
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1avo5", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $0d9f127fca17d02e$export$a4ad2735b021c132; });
$parcel$export(module.exports, "filters", function () { return $0d9f127fca17d02e$export$82462a21aead86ed; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("csytw")); });
/*!
 * pixi.js - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * pixi.js is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ parcelRequire("b3cpf");

var $csytw = parcelRequire("csytw");

var $aZdrZ = parcelRequire("aZdrZ");

var $5q3yV = parcelRequire("5q3yV");

var $7DxQ2 = parcelRequire("7DxQ2");

var $klOfb = parcelRequire("klOfb");

var $3bQv9 = parcelRequire("3bQv9");

var $kXE1p = parcelRequire("kXE1p");

var $ejo0r = parcelRequire("ejo0r");

var $9eyo7 = parcelRequire("9eyo7");

var $1WkLv = parcelRequire("1WkLv");

var $kfhEp = parcelRequire("kfhEp");

var $eQ8XE = parcelRequire("eQ8XE");

var $hnGDn = parcelRequire("hnGDn");

var $3YyWq = parcelRequire("3YyWq");

var $9RO7y = parcelRequire("9RO7y");

var $1vBjL = parcelRequire("1vBjL");

var $aPxof = parcelRequire("aPxof");

var $68QeL = parcelRequire("68QeL");

var $a3TLq = parcelRequire("a3TLq");

var $arZq0 = parcelRequire("arZq0");
parcelRequire("aqTFY");
parcelRequire("1xfIs");
parcelRequire("60K84");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $gwPoJ = parcelRequire("gwPoJ");

var $6qzqq = parcelRequire("6qzqq");

var $9Tsx3 = parcelRequire("9Tsx3");

var $eUwg9 = parcelRequire("eUwg9");

var $6fZag = parcelRequire("6fZag");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $d3fD1 = parcelRequire("d3fD1");

var $9Pi8W = parcelRequire("9Pi8W");

var $ezJmd = parcelRequire("ezJmd");
// Install renderer plugins
(0, $klOfb.Renderer).registerPlugin('accessibility', (0, $aZdrZ.AccessibilityManager));
(0, $klOfb.Renderer).registerPlugin('extract', (0, $3bQv9.Extract));
(0, $klOfb.Renderer).registerPlugin('interaction', (0, $5q3yV.InteractionManager));
(0, $klOfb.Renderer).registerPlugin('particle', (0, $9eyo7.ParticleRenderer));
(0, $klOfb.Renderer).registerPlugin('prepare', (0, $1WkLv.Prepare));
(0, $klOfb.Renderer).registerPlugin('batch', (0, $klOfb.BatchRenderer));
(0, $klOfb.Renderer).registerPlugin('tilingSprite', (0, $eQ8XE.TilingSpriteRenderer));
// Install loader plugins
(0, $kXE1p.Loader).registerPlugin((0, $hnGDn.BitmapFontLoader));
(0, $kXE1p.Loader).registerPlugin((0, $ejo0r.CompressedTextureLoader));
(0, $kXE1p.Loader).registerPlugin((0, $ejo0r.DDSLoader));
(0, $kXE1p.Loader).registerPlugin((0, $ejo0r.KTXLoader));
(0, $kXE1p.Loader).registerPlugin((0, $kfhEp.SpritesheetLoader));
// Install application plugins
(0, $7DxQ2.Application).registerPlugin((0, $3YyWq.TickerPlugin));
(0, $7DxQ2.Application).registerPlugin((0, $kXE1p.AppLoaderPlugin));
/**
 * String of the current PIXI version.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name VERSION
 * @type {string}
 */ var $0d9f127fca17d02e$export$a4ad2735b021c132 = '6.2.2';
/**
 * @namespace PIXI
 */ /**
 * This namespace contains WebGL-only display filters that can be applied
 * to DisplayObjects using the {@link PIXI.DisplayObject#filters filters} property.
 *
 * Since PixiJS only had a handful of built-in filters, additional filters
 * can be downloaded {@link https://github.com/pixijs/pixi-filters here} from the
 * PixiJS Filters repository.
 *
 * All filters must extend {@link PIXI.Filter}.
 *
 * @example
 * // Create a new application
 * const app = new PIXI.Application();
 *
 * // Draw a green rectangle
 * const rect = new PIXI.Graphics()
 *     .beginFill(0x00ff00)
 *     .drawRect(40, 40, 200, 200);
 *
 * // Add a blur filter
 * rect.filters = [new PIXI.filters.BlurFilter()];
 *
 * // Display rectangle
 * app.stage.addChild(rect);
 * document.body.appendChild(app.view);
 * @namespace PIXI.filters
 */ var $0d9f127fca17d02e$export$82462a21aead86ed = {
    AlphaFilter: (0, $9RO7y.AlphaFilter),
    BlurFilter: (0, $1vBjL.BlurFilter),
    BlurFilterPass: (0, $1vBjL.BlurFilterPass),
    ColorMatrixFilter: (0, $aPxof.ColorMatrixFilter),
    DisplacementFilter: (0, $68QeL.DisplacementFilter),
    FXAAFilter: (0, $a3TLq.FXAAFilter),
    NoiseFilter: (0, $arZq0.NoiseFilter)
};
$parcel$exportWildcard(module.exports, $aZdrZ);
$parcel$exportWildcard(module.exports, $5q3yV);
$parcel$exportWildcard(module.exports, $7DxQ2);
$parcel$exportWildcard(module.exports, $klOfb);
$parcel$exportWildcard(module.exports, $3bQv9);
$parcel$exportWildcard(module.exports, $kXE1p);
$parcel$exportWildcard(module.exports, $ejo0r);
$parcel$exportWildcard(module.exports, $9eyo7);
$parcel$exportWildcard(module.exports, $1WkLv);
$parcel$exportWildcard(module.exports, $kfhEp);
$parcel$exportWildcard(module.exports, $eQ8XE);
$parcel$exportWildcard(module.exports, $hnGDn);
$parcel$exportWildcard(module.exports, $3YyWq);
$parcel$exportWildcard(module.exports, $P8XPi);
$parcel$exportWildcard(module.exports, $8t5Gy);
$parcel$exportWildcard(module.exports, $gwPoJ);
$parcel$exportWildcard(module.exports, $6qzqq);
$parcel$exportWildcard(module.exports, $9Tsx3);
$parcel$exportWildcard(module.exports, $eUwg9);
$parcel$exportWildcard(module.exports, $6fZag);
$parcel$exportWildcard(module.exports, $7Bs2Z);
$parcel$exportWildcard(module.exports, $d3fD1);
$parcel$exportWildcard(module.exports, $9Pi8W);
$parcel$exportWildcard(module.exports, $ezJmd);

});
parcelRegister("b3cpf", function(module, exports) {
/*!
 * @pixi/polyfill - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/polyfill is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $3CbAe = parcelRequire("3CbAe");

var $4yvvI = parcelRequire("4yvvI");
// Support for IE 9 - 11 which does not include Promises
if (!self.Promise) self.Promise = (0, $3CbAe.default);
// References:
if (!Object.assign) Object.assign = (0, (/*@__PURE__*/$parcel$interopDefault($4yvvI)));
// References:
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// https://gist.github.com/1579671
// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
// https://gist.github.com/timhall/4078614
// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
// Expected to be used with Browserfiy
// Browserify automatically detects the use of `global` and passes the
// correct reference of `global`, `self`, and finally `window`
var $80b99927c6fa7733$var$ONE_FRAME_TIME = 16;
// Date.now
if (!(Date.now && Date.prototype.getTime)) Date.now = function now() {
    return new Date().getTime();
};
// performance.now
if (!(self.performance && self.performance.now)) {
    var $80b99927c6fa7733$var$startTime_1 = Date.now();
    if (!self.performance) self.performance = {};
    self.performance.now = function() {
        return Date.now() - $80b99927c6fa7733$var$startTime_1;
    };
}
// requestAnimationFrame
var $80b99927c6fa7733$var$lastTime = Date.now();
var $80b99927c6fa7733$var$vendors = [
    'ms',
    'moz',
    'webkit',
    'o'
];
for(var $80b99927c6fa7733$var$x = 0; $80b99927c6fa7733$var$x < $80b99927c6fa7733$var$vendors.length && !self.requestAnimationFrame; ++$80b99927c6fa7733$var$x){
    var $80b99927c6fa7733$var$p = $80b99927c6fa7733$var$vendors[$80b99927c6fa7733$var$x];
    self.requestAnimationFrame = self[$80b99927c6fa7733$var$p + "RequestAnimationFrame"];
    self.cancelAnimationFrame = self[$80b99927c6fa7733$var$p + "CancelAnimationFrame"] || self[$80b99927c6fa7733$var$p + "CancelRequestAnimationFrame"];
}
if (!self.requestAnimationFrame) self.requestAnimationFrame = function(callback) {
    if (typeof callback !== 'function') throw new TypeError(callback + "is not a function");
    var currentTime = Date.now();
    var delay = $80b99927c6fa7733$var$ONE_FRAME_TIME + $80b99927c6fa7733$var$lastTime - currentTime;
    if (delay < 0) delay = 0;
    $80b99927c6fa7733$var$lastTime = currentTime;
    return self.setTimeout(function() {
        $80b99927c6fa7733$var$lastTime = Date.now();
        callback(performance.now());
    }, delay);
};
if (!self.cancelAnimationFrame) self.cancelAnimationFrame = function(id) {
    return clearTimeout(id);
};
// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
if (!Math.sign) Math.sign = function mathSign(x) {
    x = Number(x);
    if (x === 0 || isNaN(x)) return x;
    return x > 0 ? 1 : -1;
};
// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
if (!Number.isInteger) Number.isInteger = function numberIsInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
if (!self.ArrayBuffer) self.ArrayBuffer = Array;
if (!self.Float32Array) self.Float32Array = Array;
if (!self.Uint32Array) self.Uint32Array = Array;
if (!self.Uint16Array) self.Uint16Array = Array;
if (!self.Uint8Array) self.Uint8Array = Array;
if (!self.Int32Array) self.Int32Array = Array;

});
parcelRegister("3CbAe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a1de7efecb34b29$export$2e2bcd8739ae039; });

var $jBtjJ = parcelRequire("jBtjJ");

var $7X2wb = parcelRequire("7X2wb");

var $91Y7A = parcelRequire("91Y7A");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $2a1de7efecb34b29$var$setTimeoutFunc = setTimeout;
function $2a1de7efecb34b29$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $2a1de7efecb34b29$var$noop() {}
// Polyfill for Function.prototype.bind
function $2a1de7efecb34b29$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $2a1de7efecb34b29$var$Promise(fn) {
    if (!(this instanceof $2a1de7efecb34b29$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $2a1de7efecb34b29$var$doResolve(fn, this);
}
function $2a1de7efecb34b29$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $2a1de7efecb34b29$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $2a1de7efecb34b29$var$resolve : $2a1de7efecb34b29$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $2a1de7efecb34b29$var$reject(deferred.promise, e);
            return;
        }
        $2a1de7efecb34b29$var$resolve(deferred.promise, ret);
    });
}
function $2a1de7efecb34b29$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $2a1de7efecb34b29$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $2a1de7efecb34b29$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $2a1de7efecb34b29$var$doResolve($2a1de7efecb34b29$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $2a1de7efecb34b29$var$finale(self);
    } catch (e) {
        $2a1de7efecb34b29$var$reject(self, e);
    }
}
function $2a1de7efecb34b29$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $2a1de7efecb34b29$var$finale(self);
}
function $2a1de7efecb34b29$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $2a1de7efecb34b29$var$Promise._immediateFn(function() {
        if (!self._handled) $2a1de7efecb34b29$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$2a1de7efecb34b29$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $2a1de7efecb34b29$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $2a1de7efecb34b29$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $2a1de7efecb34b29$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $2a1de7efecb34b29$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $2a1de7efecb34b29$var$reject(self, ex);
    }
}
$2a1de7efecb34b29$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$2a1de7efecb34b29$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($2a1de7efecb34b29$var$noop);
    $2a1de7efecb34b29$var$handle(this, new $2a1de7efecb34b29$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$2a1de7efecb34b29$var$Promise.prototype['finally'] = (0, $jBtjJ.default);
$2a1de7efecb34b29$var$Promise.all = function(arr) {
    return new $2a1de7efecb34b29$var$Promise(function(resolve, reject) {
        if (!$2a1de7efecb34b29$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$2a1de7efecb34b29$var$Promise.any = (0, $91Y7A.default);
$2a1de7efecb34b29$var$Promise.allSettled = (0, $7X2wb.default);
$2a1de7efecb34b29$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $2a1de7efecb34b29$var$Promise) return value;
    return new $2a1de7efecb34b29$var$Promise(function(resolve) {
        resolve(value);
    });
};
$2a1de7efecb34b29$var$Promise.reject = function(value) {
    return new $2a1de7efecb34b29$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$2a1de7efecb34b29$var$Promise.race = function(arr) {
    return new $2a1de7efecb34b29$var$Promise(function(resolve, reject) {
        if (!$2a1de7efecb34b29$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$2a1de7efecb34b29$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$2a1de7efecb34b29$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $2a1de7efecb34b29$var$setTimeoutFunc(fn, 0);
};
$2a1de7efecb34b29$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $2a1de7efecb34b29$export$2e2bcd8739ae039 = $2a1de7efecb34b29$var$Promise;

});
parcelRegister("jBtjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e45836d5f36de5a2$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $e45836d5f36de5a2$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $e45836d5f36de5a2$export$2e2bcd8739ae039 = $e45836d5f36de5a2$var$finallyConstructor;

});

parcelRegister("7X2wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9fff1b0ad3d7f0$export$2e2bcd8739ae039; });
function $5c9fff1b0ad3d7f0$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $5c9fff1b0ad3d7f0$export$2e2bcd8739ae039 = $5c9fff1b0ad3d7f0$var$allSettled;

});

parcelRegister("91Y7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6932d7e814bb72d7$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $6932d7e814bb72d7$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$6932d7e814bb72d7$var$AggregateError.prototype = Error.prototype;
function $6932d7e814bb72d7$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $6932d7e814bb72d7$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $6932d7e814bb72d7$export$2e2bcd8739ae039 = $6932d7e814bb72d7$var$any;

});


parcelRegister("4yvvI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("csytw", function(module, exports) {

$parcel$export(module.exports, "url", function () { return $9122d79b52dc54f0$export$128fa18b7194ef; });
$parcel$export(module.exports, "skipHello", function () { return $9122d79b52dc54f0$export$702210f86367d7ed; });
$parcel$export(module.exports, "sayHello", function () { return $9122d79b52dc54f0$export$2c6a96c059a06e7c; });
$parcel$export(module.exports, "isWebGLSupported", function () { return $9122d79b52dc54f0$export$83dc396b76015322; });
$parcel$export(module.exports, "hex2rgb", function () { return $9122d79b52dc54f0$export$858a46ce014e0e87; });
$parcel$export(module.exports, "hex2string", function () { return $9122d79b52dc54f0$export$7a57339af2222169; });
$parcel$export(module.exports, "string2hex", function () { return $9122d79b52dc54f0$export$f6a774610dbc2f6; });
$parcel$export(module.exports, "rgb2hex", function () { return $9122d79b52dc54f0$export$883528fb0afa7177; });
$parcel$export(module.exports, "premultiplyBlendMode", function () { return $9122d79b52dc54f0$export$799d0d31e2f4c737; });
$parcel$export(module.exports, "correctBlendMode", function () { return $9122d79b52dc54f0$export$3d793623cb0d1905; });
$parcel$export(module.exports, "premultiplyRgba", function () { return $9122d79b52dc54f0$export$4fa4eaa2922d1869; });
$parcel$export(module.exports, "premultiplyTint", function () { return $9122d79b52dc54f0$export$1ddadce6229d3efd; });
$parcel$export(module.exports, "premultiplyTintToRgba", function () { return $9122d79b52dc54f0$export$c75351d34304eb8c; });
$parcel$export(module.exports, "createIndicesForQuads", function () { return $9122d79b52dc54f0$export$c56148e1bec42281; });
$parcel$export(module.exports, "getBufferType", function () { return $9122d79b52dc54f0$export$adf72b506413cb57; });
$parcel$export(module.exports, "interleaveTypedArrays", function () { return $9122d79b52dc54f0$export$1ce3e224e969bb24; });
$parcel$export(module.exports, "nextPow2", function () { return $9122d79b52dc54f0$export$f0d90cf68bd426eb; });
$parcel$export(module.exports, "isPow2", function () { return $9122d79b52dc54f0$export$eb50b9c078eb6ae7; });
$parcel$export(module.exports, "log2", function () { return $9122d79b52dc54f0$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "removeItems", function () { return $9122d79b52dc54f0$export$8d47c0e1ce445404; });
$parcel$export(module.exports, "sign", function () { return $9122d79b52dc54f0$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "uid", function () { return $9122d79b52dc54f0$export$e2a22331486dcca0; });
$parcel$export(module.exports, "deprecation", function () { return $9122d79b52dc54f0$export$afd31d834b512e89; });
$parcel$export(module.exports, "ProgramCache", function () { return $9122d79b52dc54f0$export$d47c7e291d8b6e2c; });
$parcel$export(module.exports, "TextureCache", function () { return $9122d79b52dc54f0$export$4254ab7c0971430e; });
$parcel$export(module.exports, "BaseTextureCache", function () { return $9122d79b52dc54f0$export$cec649a143d060b1; });
$parcel$export(module.exports, "destroyTextureCache", function () { return $9122d79b52dc54f0$export$b5c9bc385f713d5a; });
$parcel$export(module.exports, "clearTextureCache", function () { return $9122d79b52dc54f0$export$3ee9cef7c9878d34; });
$parcel$export(module.exports, "CanvasRenderTarget", function () { return $9122d79b52dc54f0$export$525943d4c7cdfa38; });
$parcel$export(module.exports, "trimCanvas", function () { return $9122d79b52dc54f0$export$658947b9914dd428; });
$parcel$export(module.exports, "DATA_URI", function () { return $9122d79b52dc54f0$export$dbafa72958753fce; });
$parcel$export(module.exports, "decomposeDataUri", function () { return $9122d79b52dc54f0$export$672224f9983ff723; });
$parcel$export(module.exports, "determineCrossOrigin", function () { return $9122d79b52dc54f0$export$292083da55c5b406; });
$parcel$export(module.exports, "getResolutionOfUrl", function () { return $9122d79b52dc54f0$export$8695ab2f322d2637; });
$parcel$export(module.exports, "isMobile", function () { return (parcelRequire("ezJmd")).isMobile; });
$parcel$export(module.exports, "EventEmitter", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6p5EE")))); });
$parcel$export(module.exports, "earcut", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fPquT")))); });
/*!
 * @pixi/utils - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/utils is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $6p5EE = parcelRequire("6p5EE");

var $fPquT = parcelRequire("fPquT");

var $hH01d = parcelRequire("hH01d");

var $P8XPi = parcelRequire("P8XPi");
/**
 * This file contains redeclared types for Node `url` and `querystring` modules. These modules
 * don't provide their own typings but instead are a part of the full Node typings. The purpose of
 * this file is to redeclare the required types to avoid having the whole Node types as a
 * dependency.
 */ var $9122d79b52dc54f0$export$128fa18b7194ef = {
    parse: (0, $hH01d.parse),
    format: (0, $hH01d.format),
    resolve: (0, $hH01d.resolve)
};
/**
 * The prefix that denotes a URL is for a retina asset.
 *
 * @static
 * @name RETINA_PREFIX
 * @memberof PIXI.settings
 * @type {RegExp}
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ (0, $ezJmd.settings).RETINA_PREFIX = /@([0-9\.]+)x/;
/**
 * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported` function.
 * If set to true, a WebGL renderer can fail to be created if the browser thinks there could be performance issues when
 * using WebGL.
 *
 * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many scenarios as possible.
 * However, some users may have a poor experience, for example, if a user has a gpu or driver version blacklisted by the
 * browser.
 *
 * If your application requires high performance rendering, you may wish to set this to false.
 * We recommend one of two options if you decide to set this flag to false:
 *
 * 1: Use the `pixi.js-legacy` package, which includes a Canvas renderer as a fallback in case high performance WebGL is
 *    not supported.
 *
 * 2: Call `isWebGLSupported` (which if found in the PIXI.utils package) in your code before attempting to create a PixiJS
 *    renderer, and show an error message to the user if the function returns false, explaining that their device & browser
 *    combination does not support high performance WebGL.
 *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
 *
 * @static
 * @name FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
 * @memberof PIXI.settings
 * @type {boolean}
 * @default false
 */ (0, $ezJmd.settings).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;
var $9122d79b52dc54f0$var$saidHello = false;
var $9122d79b52dc54f0$var$VERSION = '6.2.2';
/**
 * Skips the hello message of renderers that are created after this is run.
 *
 * @function skipHello
 * @memberof PIXI.utils
 */ function $9122d79b52dc54f0$export$702210f86367d7ed() {
    $9122d79b52dc54f0$var$saidHello = true;
}
/**
 * Logs out the version and renderer information for this running instance of PIXI.
 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
 * creating your renderer. Keep in mind that doing that will forever make you a jerk face.
 *
 * @static
 * @function sayHello
 * @memberof PIXI.utils
 * @param {string} type - The string renderer type to log.
 */ function $9122d79b52dc54f0$export$2c6a96c059a06e7c(type) {
    var _a;
    if ($9122d79b52dc54f0$var$saidHello) return;
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var args = [
            "\n %c %c %c PixiJS " + $9122d79b52dc54f0$var$VERSION + " - \u2730 " + type + " \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n",
            'background: #ff66a5; padding:5px 0;',
            'background: #ff66a5; padding:5px 0;',
            'color: #ff66a5; background: #030307; padding:5px 0;',
            'background: #ff66a5; padding:5px 0;',
            'background: #ffc3dc; padding:5px 0;',
            'background: #ff66a5; padding:5px 0;',
            'color: #ff2424; background: #fff; padding:5px 0;',
            'color: #ff2424; background: #fff; padding:5px 0;',
            'color: #ff2424; background: #fff; padding:5px 0;'
        ];
        (_a = self.console).log.apply(_a, args);
    } else if (self.console) self.console.log("PixiJS " + $9122d79b52dc54f0$var$VERSION + " - " + type + " - http://www.pixijs.com/");
    $9122d79b52dc54f0$var$saidHello = true;
}
var $9122d79b52dc54f0$var$supported;
/**
 * Helper for checking for WebGL support.
 *
 * @memberof PIXI.utils
 * @function isWebGLSupported
 * @return {boolean} Is WebGL supported.
 */ function $9122d79b52dc54f0$export$83dc396b76015322() {
    if (typeof $9122d79b52dc54f0$var$supported === 'undefined') $9122d79b52dc54f0$var$supported = function supported() {
        var contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: (0, $ezJmd.settings).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
        };
        try {
            if (!self.WebGLRenderingContext) return false;
            var canvas = document.createElement('canvas');
            var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);
            var success = !!(gl && gl.getContextAttributes().stencil);
            if (gl) {
                var loseContext = gl.getExtension('WEBGL_lose_context');
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (e) {
            return false;
        }
    }();
    return $9122d79b52dc54f0$var$supported;
}
var $9122d79b52dc54f0$var$aliceblue = "#f0f8ff";
var $9122d79b52dc54f0$var$antiquewhite = "#faebd7";
var $9122d79b52dc54f0$var$aqua = "#00ffff";
var $9122d79b52dc54f0$var$aquamarine = "#7fffd4";
var $9122d79b52dc54f0$var$azure = "#f0ffff";
var $9122d79b52dc54f0$var$beige = "#f5f5dc";
var $9122d79b52dc54f0$var$bisque = "#ffe4c4";
var $9122d79b52dc54f0$var$black = "#000000";
var $9122d79b52dc54f0$var$blanchedalmond = "#ffebcd";
var $9122d79b52dc54f0$var$blue = "#0000ff";
var $9122d79b52dc54f0$var$blueviolet = "#8a2be2";
var $9122d79b52dc54f0$var$brown = "#a52a2a";
var $9122d79b52dc54f0$var$burlywood = "#deb887";
var $9122d79b52dc54f0$var$cadetblue = "#5f9ea0";
var $9122d79b52dc54f0$var$chartreuse = "#7fff00";
var $9122d79b52dc54f0$var$chocolate = "#d2691e";
var $9122d79b52dc54f0$var$coral = "#ff7f50";
var $9122d79b52dc54f0$var$cornflowerblue = "#6495ed";
var $9122d79b52dc54f0$var$cornsilk = "#fff8dc";
var $9122d79b52dc54f0$var$crimson = "#dc143c";
var $9122d79b52dc54f0$var$cyan = "#00ffff";
var $9122d79b52dc54f0$var$darkblue = "#00008b";
var $9122d79b52dc54f0$var$darkcyan = "#008b8b";
var $9122d79b52dc54f0$var$darkgoldenrod = "#b8860b";
var $9122d79b52dc54f0$var$darkgray = "#a9a9a9";
var $9122d79b52dc54f0$var$darkgreen = "#006400";
var $9122d79b52dc54f0$var$darkgrey = "#a9a9a9";
var $9122d79b52dc54f0$var$darkkhaki = "#bdb76b";
var $9122d79b52dc54f0$var$darkmagenta = "#8b008b";
var $9122d79b52dc54f0$var$darkolivegreen = "#556b2f";
var $9122d79b52dc54f0$var$darkorange = "#ff8c00";
var $9122d79b52dc54f0$var$darkorchid = "#9932cc";
var $9122d79b52dc54f0$var$darkred = "#8b0000";
var $9122d79b52dc54f0$var$darksalmon = "#e9967a";
var $9122d79b52dc54f0$var$darkseagreen = "#8fbc8f";
var $9122d79b52dc54f0$var$darkslateblue = "#483d8b";
var $9122d79b52dc54f0$var$darkslategray = "#2f4f4f";
var $9122d79b52dc54f0$var$darkslategrey = "#2f4f4f";
var $9122d79b52dc54f0$var$darkturquoise = "#00ced1";
var $9122d79b52dc54f0$var$darkviolet = "#9400d3";
var $9122d79b52dc54f0$var$deeppink = "#ff1493";
var $9122d79b52dc54f0$var$deepskyblue = "#00bfff";
var $9122d79b52dc54f0$var$dimgray = "#696969";
var $9122d79b52dc54f0$var$dimgrey = "#696969";
var $9122d79b52dc54f0$var$dodgerblue = "#1e90ff";
var $9122d79b52dc54f0$var$firebrick = "#b22222";
var $9122d79b52dc54f0$var$floralwhite = "#fffaf0";
var $9122d79b52dc54f0$var$forestgreen = "#228b22";
var $9122d79b52dc54f0$var$fuchsia = "#ff00ff";
var $9122d79b52dc54f0$var$gainsboro = "#dcdcdc";
var $9122d79b52dc54f0$var$ghostwhite = "#f8f8ff";
var $9122d79b52dc54f0$var$goldenrod = "#daa520";
var $9122d79b52dc54f0$var$gold = "#ffd700";
var $9122d79b52dc54f0$var$gray = "#808080";
var $9122d79b52dc54f0$var$green = "#008000";
var $9122d79b52dc54f0$var$greenyellow = "#adff2f";
var $9122d79b52dc54f0$var$grey = "#808080";
var $9122d79b52dc54f0$var$honeydew = "#f0fff0";
var $9122d79b52dc54f0$var$hotpink = "#ff69b4";
var $9122d79b52dc54f0$var$indianred = "#cd5c5c";
var $9122d79b52dc54f0$var$indigo = "#4b0082";
var $9122d79b52dc54f0$var$ivory = "#fffff0";
var $9122d79b52dc54f0$var$khaki = "#f0e68c";
var $9122d79b52dc54f0$var$lavenderblush = "#fff0f5";
var $9122d79b52dc54f0$var$lavender = "#e6e6fa";
var $9122d79b52dc54f0$var$lawngreen = "#7cfc00";
var $9122d79b52dc54f0$var$lemonchiffon = "#fffacd";
var $9122d79b52dc54f0$var$lightblue = "#add8e6";
var $9122d79b52dc54f0$var$lightcoral = "#f08080";
var $9122d79b52dc54f0$var$lightcyan = "#e0ffff";
var $9122d79b52dc54f0$var$lightgoldenrodyellow = "#fafad2";
var $9122d79b52dc54f0$var$lightgray = "#d3d3d3";
var $9122d79b52dc54f0$var$lightgreen = "#90ee90";
var $9122d79b52dc54f0$var$lightgrey = "#d3d3d3";
var $9122d79b52dc54f0$var$lightpink = "#ffb6c1";
var $9122d79b52dc54f0$var$lightsalmon = "#ffa07a";
var $9122d79b52dc54f0$var$lightseagreen = "#20b2aa";
var $9122d79b52dc54f0$var$lightskyblue = "#87cefa";
var $9122d79b52dc54f0$var$lightslategray = "#778899";
var $9122d79b52dc54f0$var$lightslategrey = "#778899";
var $9122d79b52dc54f0$var$lightsteelblue = "#b0c4de";
var $9122d79b52dc54f0$var$lightyellow = "#ffffe0";
var $9122d79b52dc54f0$var$lime = "#00ff00";
var $9122d79b52dc54f0$var$limegreen = "#32cd32";
var $9122d79b52dc54f0$var$linen = "#faf0e6";
var $9122d79b52dc54f0$var$magenta = "#ff00ff";
var $9122d79b52dc54f0$var$maroon = "#800000";
var $9122d79b52dc54f0$var$mediumaquamarine = "#66cdaa";
var $9122d79b52dc54f0$var$mediumblue = "#0000cd";
var $9122d79b52dc54f0$var$mediumorchid = "#ba55d3";
var $9122d79b52dc54f0$var$mediumpurple = "#9370db";
var $9122d79b52dc54f0$var$mediumseagreen = "#3cb371";
var $9122d79b52dc54f0$var$mediumslateblue = "#7b68ee";
var $9122d79b52dc54f0$var$mediumspringgreen = "#00fa9a";
var $9122d79b52dc54f0$var$mediumturquoise = "#48d1cc";
var $9122d79b52dc54f0$var$mediumvioletred = "#c71585";
var $9122d79b52dc54f0$var$midnightblue = "#191970";
var $9122d79b52dc54f0$var$mintcream = "#f5fffa";
var $9122d79b52dc54f0$var$mistyrose = "#ffe4e1";
var $9122d79b52dc54f0$var$moccasin = "#ffe4b5";
var $9122d79b52dc54f0$var$navajowhite = "#ffdead";
var $9122d79b52dc54f0$var$navy = "#000080";
var $9122d79b52dc54f0$var$oldlace = "#fdf5e6";
var $9122d79b52dc54f0$var$olive = "#808000";
var $9122d79b52dc54f0$var$olivedrab = "#6b8e23";
var $9122d79b52dc54f0$var$orange = "#ffa500";
var $9122d79b52dc54f0$var$orangered = "#ff4500";
var $9122d79b52dc54f0$var$orchid = "#da70d6";
var $9122d79b52dc54f0$var$palegoldenrod = "#eee8aa";
var $9122d79b52dc54f0$var$palegreen = "#98fb98";
var $9122d79b52dc54f0$var$paleturquoise = "#afeeee";
var $9122d79b52dc54f0$var$palevioletred = "#db7093";
var $9122d79b52dc54f0$var$papayawhip = "#ffefd5";
var $9122d79b52dc54f0$var$peachpuff = "#ffdab9";
var $9122d79b52dc54f0$var$peru = "#cd853f";
var $9122d79b52dc54f0$var$pink = "#ffc0cb";
var $9122d79b52dc54f0$var$plum = "#dda0dd";
var $9122d79b52dc54f0$var$powderblue = "#b0e0e6";
var $9122d79b52dc54f0$var$purple = "#800080";
var $9122d79b52dc54f0$var$rebeccapurple = "#663399";
var $9122d79b52dc54f0$var$red = "#ff0000";
var $9122d79b52dc54f0$var$rosybrown = "#bc8f8f";
var $9122d79b52dc54f0$var$royalblue = "#4169e1";
var $9122d79b52dc54f0$var$saddlebrown = "#8b4513";
var $9122d79b52dc54f0$var$salmon = "#fa8072";
var $9122d79b52dc54f0$var$sandybrown = "#f4a460";
var $9122d79b52dc54f0$var$seagreen = "#2e8b57";
var $9122d79b52dc54f0$var$seashell = "#fff5ee";
var $9122d79b52dc54f0$var$sienna = "#a0522d";
var $9122d79b52dc54f0$var$silver = "#c0c0c0";
var $9122d79b52dc54f0$var$skyblue = "#87ceeb";
var $9122d79b52dc54f0$var$slateblue = "#6a5acd";
var $9122d79b52dc54f0$var$slategray = "#708090";
var $9122d79b52dc54f0$var$slategrey = "#708090";
var $9122d79b52dc54f0$var$snow = "#fffafa";
var $9122d79b52dc54f0$var$springgreen = "#00ff7f";
var $9122d79b52dc54f0$var$steelblue = "#4682b4";
var $9122d79b52dc54f0$var$tan = "#d2b48c";
var $9122d79b52dc54f0$var$teal = "#008080";
var $9122d79b52dc54f0$var$thistle = "#d8bfd8";
var $9122d79b52dc54f0$var$tomato = "#ff6347";
var $9122d79b52dc54f0$var$turquoise = "#40e0d0";
var $9122d79b52dc54f0$var$violet = "#ee82ee";
var $9122d79b52dc54f0$var$wheat = "#f5deb3";
var $9122d79b52dc54f0$var$white = "#ffffff";
var $9122d79b52dc54f0$var$whitesmoke = "#f5f5f5";
var $9122d79b52dc54f0$var$yellow = "#ffff00";
var $9122d79b52dc54f0$var$yellowgreen = "#9acd32";
var $9122d79b52dc54f0$var$cssColorNames = {
    aliceblue: $9122d79b52dc54f0$var$aliceblue,
    antiquewhite: $9122d79b52dc54f0$var$antiquewhite,
    aqua: $9122d79b52dc54f0$var$aqua,
    aquamarine: $9122d79b52dc54f0$var$aquamarine,
    azure: $9122d79b52dc54f0$var$azure,
    beige: $9122d79b52dc54f0$var$beige,
    bisque: $9122d79b52dc54f0$var$bisque,
    black: $9122d79b52dc54f0$var$black,
    blanchedalmond: $9122d79b52dc54f0$var$blanchedalmond,
    blue: $9122d79b52dc54f0$var$blue,
    blueviolet: $9122d79b52dc54f0$var$blueviolet,
    brown: $9122d79b52dc54f0$var$brown,
    burlywood: $9122d79b52dc54f0$var$burlywood,
    cadetblue: $9122d79b52dc54f0$var$cadetblue,
    chartreuse: $9122d79b52dc54f0$var$chartreuse,
    chocolate: $9122d79b52dc54f0$var$chocolate,
    coral: $9122d79b52dc54f0$var$coral,
    cornflowerblue: $9122d79b52dc54f0$var$cornflowerblue,
    cornsilk: $9122d79b52dc54f0$var$cornsilk,
    crimson: $9122d79b52dc54f0$var$crimson,
    cyan: $9122d79b52dc54f0$var$cyan,
    darkblue: $9122d79b52dc54f0$var$darkblue,
    darkcyan: $9122d79b52dc54f0$var$darkcyan,
    darkgoldenrod: $9122d79b52dc54f0$var$darkgoldenrod,
    darkgray: $9122d79b52dc54f0$var$darkgray,
    darkgreen: $9122d79b52dc54f0$var$darkgreen,
    darkgrey: $9122d79b52dc54f0$var$darkgrey,
    darkkhaki: $9122d79b52dc54f0$var$darkkhaki,
    darkmagenta: $9122d79b52dc54f0$var$darkmagenta,
    darkolivegreen: $9122d79b52dc54f0$var$darkolivegreen,
    darkorange: $9122d79b52dc54f0$var$darkorange,
    darkorchid: $9122d79b52dc54f0$var$darkorchid,
    darkred: $9122d79b52dc54f0$var$darkred,
    darksalmon: $9122d79b52dc54f0$var$darksalmon,
    darkseagreen: $9122d79b52dc54f0$var$darkseagreen,
    darkslateblue: $9122d79b52dc54f0$var$darkslateblue,
    darkslategray: $9122d79b52dc54f0$var$darkslategray,
    darkslategrey: $9122d79b52dc54f0$var$darkslategrey,
    darkturquoise: $9122d79b52dc54f0$var$darkturquoise,
    darkviolet: $9122d79b52dc54f0$var$darkviolet,
    deeppink: $9122d79b52dc54f0$var$deeppink,
    deepskyblue: $9122d79b52dc54f0$var$deepskyblue,
    dimgray: $9122d79b52dc54f0$var$dimgray,
    dimgrey: $9122d79b52dc54f0$var$dimgrey,
    dodgerblue: $9122d79b52dc54f0$var$dodgerblue,
    firebrick: $9122d79b52dc54f0$var$firebrick,
    floralwhite: $9122d79b52dc54f0$var$floralwhite,
    forestgreen: $9122d79b52dc54f0$var$forestgreen,
    fuchsia: $9122d79b52dc54f0$var$fuchsia,
    gainsboro: $9122d79b52dc54f0$var$gainsboro,
    ghostwhite: $9122d79b52dc54f0$var$ghostwhite,
    goldenrod: $9122d79b52dc54f0$var$goldenrod,
    gold: $9122d79b52dc54f0$var$gold,
    gray: $9122d79b52dc54f0$var$gray,
    green: $9122d79b52dc54f0$var$green,
    greenyellow: $9122d79b52dc54f0$var$greenyellow,
    grey: $9122d79b52dc54f0$var$grey,
    honeydew: $9122d79b52dc54f0$var$honeydew,
    hotpink: $9122d79b52dc54f0$var$hotpink,
    indianred: $9122d79b52dc54f0$var$indianred,
    indigo: $9122d79b52dc54f0$var$indigo,
    ivory: $9122d79b52dc54f0$var$ivory,
    khaki: $9122d79b52dc54f0$var$khaki,
    lavenderblush: $9122d79b52dc54f0$var$lavenderblush,
    lavender: $9122d79b52dc54f0$var$lavender,
    lawngreen: $9122d79b52dc54f0$var$lawngreen,
    lemonchiffon: $9122d79b52dc54f0$var$lemonchiffon,
    lightblue: $9122d79b52dc54f0$var$lightblue,
    lightcoral: $9122d79b52dc54f0$var$lightcoral,
    lightcyan: $9122d79b52dc54f0$var$lightcyan,
    lightgoldenrodyellow: $9122d79b52dc54f0$var$lightgoldenrodyellow,
    lightgray: $9122d79b52dc54f0$var$lightgray,
    lightgreen: $9122d79b52dc54f0$var$lightgreen,
    lightgrey: $9122d79b52dc54f0$var$lightgrey,
    lightpink: $9122d79b52dc54f0$var$lightpink,
    lightsalmon: $9122d79b52dc54f0$var$lightsalmon,
    lightseagreen: $9122d79b52dc54f0$var$lightseagreen,
    lightskyblue: $9122d79b52dc54f0$var$lightskyblue,
    lightslategray: $9122d79b52dc54f0$var$lightslategray,
    lightslategrey: $9122d79b52dc54f0$var$lightslategrey,
    lightsteelblue: $9122d79b52dc54f0$var$lightsteelblue,
    lightyellow: $9122d79b52dc54f0$var$lightyellow,
    lime: $9122d79b52dc54f0$var$lime,
    limegreen: $9122d79b52dc54f0$var$limegreen,
    linen: $9122d79b52dc54f0$var$linen,
    magenta: $9122d79b52dc54f0$var$magenta,
    maroon: $9122d79b52dc54f0$var$maroon,
    mediumaquamarine: $9122d79b52dc54f0$var$mediumaquamarine,
    mediumblue: $9122d79b52dc54f0$var$mediumblue,
    mediumorchid: $9122d79b52dc54f0$var$mediumorchid,
    mediumpurple: $9122d79b52dc54f0$var$mediumpurple,
    mediumseagreen: $9122d79b52dc54f0$var$mediumseagreen,
    mediumslateblue: $9122d79b52dc54f0$var$mediumslateblue,
    mediumspringgreen: $9122d79b52dc54f0$var$mediumspringgreen,
    mediumturquoise: $9122d79b52dc54f0$var$mediumturquoise,
    mediumvioletred: $9122d79b52dc54f0$var$mediumvioletred,
    midnightblue: $9122d79b52dc54f0$var$midnightblue,
    mintcream: $9122d79b52dc54f0$var$mintcream,
    mistyrose: $9122d79b52dc54f0$var$mistyrose,
    moccasin: $9122d79b52dc54f0$var$moccasin,
    navajowhite: $9122d79b52dc54f0$var$navajowhite,
    navy: $9122d79b52dc54f0$var$navy,
    oldlace: $9122d79b52dc54f0$var$oldlace,
    olive: $9122d79b52dc54f0$var$olive,
    olivedrab: $9122d79b52dc54f0$var$olivedrab,
    orange: $9122d79b52dc54f0$var$orange,
    orangered: $9122d79b52dc54f0$var$orangered,
    orchid: $9122d79b52dc54f0$var$orchid,
    palegoldenrod: $9122d79b52dc54f0$var$palegoldenrod,
    palegreen: $9122d79b52dc54f0$var$palegreen,
    paleturquoise: $9122d79b52dc54f0$var$paleturquoise,
    palevioletred: $9122d79b52dc54f0$var$palevioletred,
    papayawhip: $9122d79b52dc54f0$var$papayawhip,
    peachpuff: $9122d79b52dc54f0$var$peachpuff,
    peru: $9122d79b52dc54f0$var$peru,
    pink: $9122d79b52dc54f0$var$pink,
    plum: $9122d79b52dc54f0$var$plum,
    powderblue: $9122d79b52dc54f0$var$powderblue,
    purple: $9122d79b52dc54f0$var$purple,
    rebeccapurple: $9122d79b52dc54f0$var$rebeccapurple,
    red: $9122d79b52dc54f0$var$red,
    rosybrown: $9122d79b52dc54f0$var$rosybrown,
    royalblue: $9122d79b52dc54f0$var$royalblue,
    saddlebrown: $9122d79b52dc54f0$var$saddlebrown,
    salmon: $9122d79b52dc54f0$var$salmon,
    sandybrown: $9122d79b52dc54f0$var$sandybrown,
    seagreen: $9122d79b52dc54f0$var$seagreen,
    seashell: $9122d79b52dc54f0$var$seashell,
    sienna: $9122d79b52dc54f0$var$sienna,
    silver: $9122d79b52dc54f0$var$silver,
    skyblue: $9122d79b52dc54f0$var$skyblue,
    slateblue: $9122d79b52dc54f0$var$slateblue,
    slategray: $9122d79b52dc54f0$var$slategray,
    slategrey: $9122d79b52dc54f0$var$slategrey,
    snow: $9122d79b52dc54f0$var$snow,
    springgreen: $9122d79b52dc54f0$var$springgreen,
    steelblue: $9122d79b52dc54f0$var$steelblue,
    tan: $9122d79b52dc54f0$var$tan,
    teal: $9122d79b52dc54f0$var$teal,
    thistle: $9122d79b52dc54f0$var$thistle,
    tomato: $9122d79b52dc54f0$var$tomato,
    turquoise: $9122d79b52dc54f0$var$turquoise,
    violet: $9122d79b52dc54f0$var$violet,
    wheat: $9122d79b52dc54f0$var$wheat,
    white: $9122d79b52dc54f0$var$white,
    whitesmoke: $9122d79b52dc54f0$var$whitesmoke,
    yellow: $9122d79b52dc54f0$var$yellow,
    yellowgreen: $9122d79b52dc54f0$var$yellowgreen
};
/**
 * Converts a hexadecimal color number to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
 *
 * @example
 * PIXI.utils.hex2rgb(0xffffff); // returns [1, 1, 1]
 * @memberof PIXI.utils
 * @function hex2rgb
 * @param {number} hex - The hexadecimal number to convert
 * @param  {number[]} [out=[]] - If supplied, this array will be used rather than returning a new one
 * @return {number[]} An array representing the [R, G, B] of the color where all values are floats.
 */ function $9122d79b52dc54f0$export$858a46ce014e0e87(hex, out) {
    if (out === void 0) out = [];
    out[0] = (hex >> 16 & 0xFF) / 255;
    out[1] = (hex >> 8 & 0xFF) / 255;
    out[2] = (hex & 0xFF) / 255;
    return out;
}
/**
 * Converts a hexadecimal color number to a string.
 *
 * @example
 * PIXI.utils.hex2string(0xffffff); // returns "#ffffff"
 * @memberof PIXI.utils
 * @function hex2string
 * @param {number} hex - Number in hex (e.g., `0xffffff`)
 * @return {string} The string color (e.g., `"#ffffff"`).
 */ function $9122d79b52dc54f0$export$7a57339af2222169(hex) {
    var hexString = hex.toString(16);
    hexString = '000000'.substr(0, 6 - hexString.length) + hexString;
    return "#" + hexString;
}
/**
 * Converts a string to a hexadecimal color number.
 * It can handle:
 *  hex strings starting with #: "#ffffff"
 *  hex strings starting with 0x: "0xffffff"
 *  hex strings without prefix: "ffffff"
 *  css colors: "black"
 *
 * @example
 * PIXI.utils.string2hex("#ffffff"); // returns 0xffffff
 * @memberof PIXI.utils
 * @function string2hex
 * @param {string} string - The string color (e.g., `"#ffffff"`)
 * @return {number} Number in hexadecimal.
 */ function $9122d79b52dc54f0$export$f6a774610dbc2f6(string) {
    if (typeof string === 'string') {
        string = $9122d79b52dc54f0$var$cssColorNames[string.toLowerCase()] || string;
        if (string[0] === '#') string = string.substr(1);
    }
    return parseInt(string, 16);
}
/**
 * Converts a color as an [R, G, B] array of normalized floats to a hexadecimal number.
 *
 * @example
 * PIXI.utils.rgb2hex([1, 1, 1]); // returns 0xffffff
 * @memberof PIXI.utils
 * @function rgb2hex
 * @param {number[]} rgb - Array of numbers where all values are normalized floats from 0.0 to 1.0.
 * @return {number} Number in hexadecimal.
 */ function $9122d79b52dc54f0$export$883528fb0afa7177(rgb) {
    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
}
/**
 * Corrects PixiJS blend, takes premultiplied alpha into account
 *
 * @memberof PIXI.utils
 * @function mapPremultipliedBlendModes
 * @private
 * @return {Array<number[]>} Mapped modes.
 */ function $9122d79b52dc54f0$var$mapPremultipliedBlendModes() {
    var pm = [];
    var npm = [];
    for(var i = 0; i < 32; i++){
        pm[i] = i;
        npm[i] = i;
    }
    pm[(0, $P8XPi.BLEND_MODES).NORMAL_NPM] = (0, $P8XPi.BLEND_MODES).NORMAL;
    pm[(0, $P8XPi.BLEND_MODES).ADD_NPM] = (0, $P8XPi.BLEND_MODES).ADD;
    pm[(0, $P8XPi.BLEND_MODES).SCREEN_NPM] = (0, $P8XPi.BLEND_MODES).SCREEN;
    npm[(0, $P8XPi.BLEND_MODES).NORMAL] = (0, $P8XPi.BLEND_MODES).NORMAL_NPM;
    npm[(0, $P8XPi.BLEND_MODES).ADD] = (0, $P8XPi.BLEND_MODES).ADD_NPM;
    npm[(0, $P8XPi.BLEND_MODES).SCREEN] = (0, $P8XPi.BLEND_MODES).SCREEN_NPM;
    var array = [];
    array.push(npm);
    array.push(pm);
    return array;
}
/**
 * maps premultiply flag and blendMode to adjusted blendMode
 * @memberof PIXI.utils
 * @const premultiplyBlendMode
 * @type {Array<number[]>}
 */ var $9122d79b52dc54f0$export$799d0d31e2f4c737 = $9122d79b52dc54f0$var$mapPremultipliedBlendModes();
/**
 * changes blendMode according to texture format
 *
 * @memberof PIXI.utils
 * @function correctBlendMode
 * @param {number} blendMode - supposed blend mode
 * @param {boolean} premultiplied - whether source is premultiplied
 * @returns {number} true blend mode for this texture
 */ function $9122d79b52dc54f0$export$3d793623cb0d1905(blendMode, premultiplied) {
    return $9122d79b52dc54f0$export$799d0d31e2f4c737[premultiplied ? 1 : 0][blendMode];
}
/**
 * combines rgb and alpha to out array
 *
 * @memberof PIXI.utils
 * @function premultiplyRgba
 * @param {Float32Array|number[]} rgb - input rgb
 * @param {number} alpha - alpha param
 * @param {Float32Array} [out] - output
 * @param {boolean} [premultiply=true] - do premultiply it
 * @returns {Float32Array} vec4 rgba
 */ function $9122d79b52dc54f0$export$4fa4eaa2922d1869(rgb, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    if (premultiply || premultiply === undefined) {
        out[0] = rgb[0] * alpha;
        out[1] = rgb[1] * alpha;
        out[2] = rgb[2] * alpha;
    } else {
        out[0] = rgb[0];
        out[1] = rgb[1];
        out[2] = rgb[2];
    }
    out[3] = alpha;
    return out;
}
/**
 * premultiplies tint
 *
 * @memberof PIXI.utils
 * @function premultiplyTint
 * @param {number} tint - integer RGB
 * @param {number} alpha - floating point alpha (0.0-1.0)
 * @returns {number} tint multiplied by alpha
 */ function $9122d79b52dc54f0$export$1ddadce6229d3efd(tint, alpha) {
    if (alpha === 1.0) return (alpha * 255 << 24) + tint;
    if (alpha === 0.0) return 0;
    var R = tint >> 16 & 0xFF;
    var G = tint >> 8 & 0xFF;
    var B = tint & 0xFF;
    R = R * alpha + 0.5 | 0;
    G = G * alpha + 0.5 | 0;
    B = B * alpha + 0.5 | 0;
    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
}
/**
 * converts integer tint and float alpha to vec4 form, premultiplies by default
 *
 * @memberof PIXI.utils
 * @function premultiplyTintToRgba
 * @param {number} tint - input tint
 * @param {number} alpha - alpha param
 * @param {Float32Array} [out] - output
 * @param {boolean} [premultiply=true] - do premultiply it
 * @returns {Float32Array} vec4 rgba
 */ function $9122d79b52dc54f0$export$c75351d34304eb8c(tint, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    out[0] = (tint >> 16 & 0xFF) / 255.0;
    out[1] = (tint >> 8 & 0xFF) / 255.0;
    out[2] = (tint & 0xFF) / 255.0;
    if (premultiply || premultiply === undefined) {
        out[0] *= alpha;
        out[1] *= alpha;
        out[2] *= alpha;
    }
    out[3] = alpha;
    return out;
}
/**
 * Generic Mask Stack data structure
 *
 * @memberof PIXI.utils
 * @function createIndicesForQuads
 * @param {number} size - Number of quads
 * @param {Uint16Array|Uint32Array} [outBuffer] - Buffer for output, length has to be `6 * size`
 * @return {Uint16Array|Uint32Array} - Resulting index buffer
 */ function $9122d79b52dc54f0$export$c56148e1bec42281(size, outBuffer) {
    if (outBuffer === void 0) outBuffer = null;
    // the total number of indices in our array, there are 6 points per quad.
    var totalIndices = size * 6;
    outBuffer = outBuffer || new Uint16Array(totalIndices);
    if (outBuffer.length !== totalIndices) throw new Error("Out buffer length is incorrect, got " + outBuffer.length + " and expected " + totalIndices);
    // fill the indices with the quads to draw
    for(var i = 0, j = 0; i < totalIndices; i += 6, j += 4){
        outBuffer[i + 0] = j + 0;
        outBuffer[i + 1] = j + 1;
        outBuffer[i + 2] = j + 2;
        outBuffer[i + 3] = j + 0;
        outBuffer[i + 4] = j + 2;
        outBuffer[i + 5] = j + 3;
    }
    return outBuffer;
}
function $9122d79b52dc54f0$export$adf72b506413cb57(array) {
    if (array.BYTES_PER_ELEMENT === 4) {
        if (array instanceof Float32Array) return 'Float32Array';
        else if (array instanceof Uint32Array) return 'Uint32Array';
        return 'Int32Array';
    } else if (array.BYTES_PER_ELEMENT === 2) {
        if (array instanceof Uint16Array) return 'Uint16Array';
    } else if (array.BYTES_PER_ELEMENT === 1) {
        if (array instanceof Uint8Array) return 'Uint8Array';
    }
    // TODO map out the rest of the array elements!
    return null;
}
/* eslint-disable object-shorthand */ var $9122d79b52dc54f0$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $9122d79b52dc54f0$export$1ce3e224e969bb24(arrays, sizes) {
    var outSize = 0;
    var stride = 0;
    var views = {};
    for(var i = 0; i < arrays.length; i++){
        stride += sizes[i];
        outSize += arrays[i].length;
    }
    var buffer = new ArrayBuffer(outSize * 4);
    var out = null;
    var littleOffset = 0;
    for(var i = 0; i < arrays.length; i++){
        var size = sizes[i];
        var array = arrays[i];
        /*
        @todo This is unsafe casting but consistent with how the code worked previously. Should it stay this way
              or should and `getBufferTypeUnsafe` function be exposed that throws an Error if unsupported type is passed?
         */ var type = $9122d79b52dc54f0$export$adf72b506413cb57(array);
        if (!views[type]) views[type] = new $9122d79b52dc54f0$var$map[type](buffer);
        out = views[type];
        for(var j = 0; j < array.length; j++){
            var indexStart = (j / size | 0) * stride + littleOffset;
            var index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}
// Taken from the bit-twiddle package
/**
 * Rounds to next power of two.
 *
 * @function nextPow2
 * @memberof PIXI.utils
 * @param {number} v - input value
 * @return {number}
 */ function $9122d79b52dc54f0$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
/**
 * Checks if a number is a power of two.
 *
 * @function isPow2
 * @memberof PIXI.utils
 * @param {number} v - input value
 * @return {boolean} `true` if value is power of two
 */ function $9122d79b52dc54f0$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
/**
 * Computes ceil of log base 2
 *
 * @function log2
 * @memberof PIXI.utils
 * @param {number} v - input value
 * @return {number} logarithm base 2
 */ function $9122d79b52dc54f0$export$b9fae0bba9d9094d(v) {
    var r = (v > 0xFFFF ? 1 : 0) << 4;
    v >>>= r;
    var shift = (v > 0xFF ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 0xF ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 0x3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}
/**
 * Remove items from a javascript array without generating garbage
 *
 * @function removeItems
 * @memberof PIXI.utils
 * @param {Array<any>} arr - Array to remove elements from
 * @param {number} startIdx - starting index
 * @param {number} removeCount - how many to remove
 */ function $9122d79b52dc54f0$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    var length = arr.length;
    var i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    var len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}
/**
 * Returns sign of number
 *
 * @memberof PIXI.utils
 * @function sign
 * @param {number} n - the number to check the sign of
 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
 */ function $9122d79b52dc54f0$export$c5552dfdbc7cec71(n) {
    if (n === 0) return 0;
    return n < 0 ? -1 : 1;
}
var $9122d79b52dc54f0$var$nextUid = 0;
/**
 * Gets the next unique identifier
 *
 * @memberof PIXI.utils
 * @function uid
 * @return {number} The next unique identifier to use.
 */ function $9122d79b52dc54f0$export$e2a22331486dcca0() {
    return ++$9122d79b52dc54f0$var$nextUid;
}
// A map of warning messages already fired
var $9122d79b52dc54f0$var$warnings = {};
/**
 * Helper for warning developers about deprecated features & settings.
 * A stack track for warnings is given; useful for tracking-down where
 * deprecated methods/properties/classes are being used within the code.
 *
 * @memberof PIXI.utils
 * @function deprecation
 * @param {string} version - The version where the feature became deprecated
 * @param {string} message - Message should include what is deprecated, where, and the new solution
 * @param {number} [ignoreDepth=3] - The number of steps to ignore at the top of the error stack
 *        this is mostly to ignore internal deprecation calls.
 */ function $9122d79b52dc54f0$export$afd31d834b512e89(version, message, ignoreDepth) {
    if (ignoreDepth === void 0) ignoreDepth = 3;
    // Ignore duplicat
    if ($9122d79b52dc54f0$var$warnings[message]) return;
    /* eslint-disable no-console */ var stack = new Error().stack;
    // Handle IE < 10 and Safari < 6
    if (typeof stack === 'undefined') console.warn('PixiJS Deprecation Warning: ', message + "\nDeprecated since v" + version);
    else {
        // chop off the stack trace which includes PixiJS internal calls
        stack = stack.split('\n').splice(ignoreDepth).join('\n');
        if (console.groupCollapsed) {
            console.groupCollapsed('%cPixiJS Deprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', message + "\nDeprecated since v" + version);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn('PixiJS Deprecation Warning: ', message + "\nDeprecated since v" + version);
            console.warn(stack);
        }
    }
    /* eslint-enable no-console */ $9122d79b52dc54f0$var$warnings[message] = true;
}
/**
 * @todo Describe property usage
 *
 * @static
 * @name ProgramCache
 * @memberof PIXI.utils
 * @type {Object}
 */ var $9122d79b52dc54f0$export$d47c7e291d8b6e2c = {};
/**
 * @todo Describe property usage
 *
 * @static
 * @name TextureCache
 * @memberof PIXI.utils
 * @type {Object}
 */ var $9122d79b52dc54f0$export$4254ab7c0971430e = Object.create(null);
/**
 * @todo Describe property usage
 *
 * @static
 * @name BaseTextureCache
 * @memberof PIXI.utils
 * @type {Object}
 */ var $9122d79b52dc54f0$export$cec649a143d060b1 = Object.create(null);
/**
 * Destroys all texture in the cache
 *
 * @memberof PIXI.utils
 * @function destroyTextureCache
 */ function $9122d79b52dc54f0$export$b5c9bc385f713d5a() {
    var key;
    for(key in $9122d79b52dc54f0$export$4254ab7c0971430e)$9122d79b52dc54f0$export$4254ab7c0971430e[key].destroy();
    for(key in $9122d79b52dc54f0$export$cec649a143d060b1)$9122d79b52dc54f0$export$cec649a143d060b1[key].destroy();
}
/**
 * Removes all textures from cache, but does not destroy them
 *
 * @memberof PIXI.utils
 * @function clearTextureCache
 */ function $9122d79b52dc54f0$export$3ee9cef7c9878d34() {
    var key;
    for(key in $9122d79b52dc54f0$export$4254ab7c0971430e)delete $9122d79b52dc54f0$export$4254ab7c0971430e[key];
    for(key in $9122d79b52dc54f0$export$cec649a143d060b1)delete $9122d79b52dc54f0$export$cec649a143d060b1[key];
}
/**
 * Creates a Canvas element of the given size to be used as a target for rendering to.
 *
 * @class
 * @memberof PIXI.utils
 */ var $9122d79b52dc54f0$export$525943d4c7cdfa38 = /** @class */ function() {
    /**
     * @param width - the width for the newly created canvas
     * @param height - the height for the newly created canvas
     * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
     */ function CanvasRenderTarget(width, height, resolution) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
        this.resolution = resolution || (0, $ezJmd.settings).RESOLUTION;
        this.resize(width, height);
    }
    /**
     * Clears the canvas that was created by the CanvasRenderTarget class.
     *
     * @private
     */ CanvasRenderTarget.prototype.clear = function() {
        this.context.setTransform(1, 0, 0, 1, 0, 0);
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    };
    /**
     * Resizes the canvas to the specified width and height.
     *
     * @param desiredWidth - the desired width of the canvas
     * @param desiredHeight - the desired height of the canvas
     */ CanvasRenderTarget.prototype.resize = function(desiredWidth, desiredHeight) {
        this.canvas.width = Math.round(desiredWidth * this.resolution);
        this.canvas.height = Math.round(desiredHeight * this.resolution);
    };
    /** Destroys this canvas. */ CanvasRenderTarget.prototype.destroy = function() {
        this.context = null;
        this.canvas = null;
    };
    Object.defineProperty(CanvasRenderTarget.prototype, "width", {
        /**
         * The width of the canvas buffer in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.canvas.width;
        },
        set: function(val) {
            this.canvas.width = Math.round(val);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasRenderTarget.prototype, "height", {
        /**
         * The height of the canvas buffer in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.canvas.height;
        },
        set: function(val) {
            this.canvas.height = Math.round(val);
        },
        enumerable: false,
        configurable: true
    });
    return CanvasRenderTarget;
}();
/**
 * Trim transparent borders from a canvas
 *
 * @memberof PIXI.utils
 * @function trimCanvas
 * @param {HTMLCanvasElement} canvas - the canvas to trim
 * @returns {object} Trim data
 */ function $9122d79b52dc54f0$export$658947b9914dd428(canvas) {
    // https://gist.github.com/remy/784508
    var width = canvas.width;
    var height = canvas.height;
    var context = canvas.getContext('2d');
    var imageData = context.getImageData(0, 0, width, height);
    var pixels = imageData.data;
    var len = pixels.length;
    var bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
    };
    var data = null;
    var i;
    var x;
    var y;
    for(i = 0; i < len; i += 4)if (pixels[i + 3] !== 0) {
        x = i / 4 % width;
        y = ~~(i / 4 / width);
        if (bound.top === null) bound.top = y;
        if (bound.left === null) bound.left = x;
        else if (x < bound.left) bound.left = x;
        if (bound.right === null) bound.right = x + 1;
        else if (bound.right < x) bound.right = x + 1;
        if (bound.bottom === null) bound.bottom = y;
        else if (bound.bottom < y) bound.bottom = y;
    }
    if (bound.top !== null) {
        width = bound.right - bound.left;
        height = bound.bottom - bound.top + 1;
        data = context.getImageData(bound.left, bound.top, width, height);
    }
    return {
        height: height,
        width: width,
        data: data
    };
}
/**
 * Regexp for data URI.
 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
 *
 * @static
 * @constant {RegExp|string} DATA_URI
 * @memberof PIXI
 * @example data:image/png;base64
 */ var $9122d79b52dc54f0$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
/**
 * @memberof PIXI.utils
 * @interface DecomposedDataUri
 */ /**
 * type, eg. `image`
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} mediaType
 */ /**
 * Sub type, eg. `png`
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} subType
 */ /**
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} charset
 */ /**
 * Data encoding, eg. `base64`
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} encoding
 */ /**
 * The actual data
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} data
 */ /**
 * Split a data URI into components. Returns undefined if
 * parameter `dataUri` is not a valid data URI.
 *
 * @memberof PIXI.utils
 * @function decomposeDataUri
 * @param {string} dataUri - the data URI to check
 * @return {PIXI.utils.DecomposedDataUri|undefined} The decomposed data uri or undefined
 */ function $9122d79b52dc54f0$export$672224f9983ff723(dataUri) {
    var dataUriMatch = $9122d79b52dc54f0$export$dbafa72958753fce.exec(dataUri);
    if (dataUriMatch) return {
        mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
        subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
        charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
        encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
        data: dataUriMatch[5]
    };
    return undefined;
}
var $9122d79b52dc54f0$var$tempAnchor;
/**
 * Sets the `crossOrigin` property for this resource based on if the url
 * for this resource is cross-origin. If crossOrigin was manually set, this
 * function does nothing.
 * Nipped from the resource loader!
 *
 * @ignore
 * @param {string} url - The url to test.
 * @param {object} [loc=window.location] - The location object to test against.
 * @return {string} The crossOrigin value to use (or empty string for none).
 */ function $9122d79b52dc54f0$export$292083da55c5b406(url$1, loc) {
    if (loc === void 0) loc = self.location;
    // data: and javascript: urls are considered same-origin
    if (url$1.indexOf('data:') === 0) return '';
    // default is window.location
    loc = loc || self.location;
    if (!$9122d79b52dc54f0$var$tempAnchor) $9122d79b52dc54f0$var$tempAnchor = document.createElement('a');
    // let the browser determine the full href for the url of this resource and then
    // parse with the node url lib, we can't use the properties of the anchor element
    // because they don't work in IE9 :(
    $9122d79b52dc54f0$var$tempAnchor.href = url$1;
    var parsedUrl = $9122d79b52dc54f0$export$128fa18b7194ef.parse($9122d79b52dc54f0$var$tempAnchor.href);
    var samePort = !parsedUrl.port && loc.port === '' || parsedUrl.port === loc.port;
    // if cross origin
    if (parsedUrl.hostname !== loc.hostname || !samePort || parsedUrl.protocol !== loc.protocol) return 'anonymous';
    return '';
}
/**
 * get the resolution / device pixel ratio of an asset by looking for the prefix
 * used by spritesheets and image urls
 *
 * @memberof PIXI.utils
 * @function getResolutionOfUrl
 * @param {string} url - the image path
 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
 * @return {number} resolution / device pixel ratio of an asset
 */ function $9122d79b52dc54f0$export$8695ab2f322d2637(url, defaultValue) {
    var resolution = (0, $ezJmd.settings).RETINA_PREFIX.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue !== undefined ? defaultValue : 1;
}

});
parcelRegister("ezJmd", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $a9c7849af2339627$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "settings", function () { return $a9c7849af2339627$export$a5a6e0b888b2c992; });
/*!
 * @pixi/settings - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/settings is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ parcelRequire("d99R2");
var $cHiip = parcelRequire("cHiip");
// The ESM/CJS versions of ismobilejs only
var $a9c7849af2339627$export$d0a8044dce8ff2fc = (0, $cHiip.default)(self.navigator);
/**
 * The maximum recommended texture units to use.
 * In theory the bigger the better, and for desktop we'll use as many as we can.
 * But some mobile devices slow down if there is to many branches in the shader.
 * So in practice there seems to be a sweet spot size that varies depending on the device.
 *
 * In v4, all mobile devices were limited to 4 texture units because for this.
 * In v5, we allow all texture units to be used on modern Apple or Android devices.
 *
 * @private
 * @param {number} max
 * @returns {number}
 */ function $a9c7849af2339627$var$maxRecommendedTextures(max) {
    var allowMax = true;
    if ($a9c7849af2339627$export$d0a8044dce8ff2fc.tablet || $a9c7849af2339627$export$d0a8044dce8ff2fc.phone) {
        if ($a9c7849af2339627$export$d0a8044dce8ff2fc.apple.device) {
            var match = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
            if (match) {
                var majorVersion = parseInt(match[1], 10);
                // Limit texture units on devices below iOS 11, which will be older hardware
                if (majorVersion < 11) allowMax = false;
            }
        }
        if ($a9c7849af2339627$export$d0a8044dce8ff2fc.android.device) {
            var match = navigator.userAgent.match(/Android\s([0-9.]*)/);
            if (match) {
                var majorVersion = parseInt(match[1], 10);
                // Limit texture units on devices below Android 7 (Nougat), which will be older hardware
                if (majorVersion < 7) allowMax = false;
            }
        }
    }
    return allowMax ? max : 4;
}
/**
 * Uploading the same buffer multiple times in a single frame can cause performance issues.
 * Apparent on iOS so only check for that at the moment
 * This check may become more complex if this issue pops up elsewhere.
 *
 * @private
 * @returns {boolean}
 */ function $a9c7849af2339627$var$canUploadSameBuffer() {
    return !$a9c7849af2339627$export$d0a8044dce8ff2fc.apple.device;
}
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $a9c7849af2339627$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($a9c7849af2339627$var$ENV || ($a9c7849af2339627$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $a9c7849af2339627$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($a9c7849af2339627$var$RENDERER_TYPE || ($a9c7849af2339627$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $a9c7849af2339627$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($a9c7849af2339627$var$BUFFER_BITS || ($a9c7849af2339627$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $a9c7849af2339627$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($a9c7849af2339627$var$BLEND_MODES || ($a9c7849af2339627$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $a9c7849af2339627$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($a9c7849af2339627$var$DRAW_MODES || ($a9c7849af2339627$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $a9c7849af2339627$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($a9c7849af2339627$var$FORMATS || ($a9c7849af2339627$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $a9c7849af2339627$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($a9c7849af2339627$var$TARGETS || ($a9c7849af2339627$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $a9c7849af2339627$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($a9c7849af2339627$var$TYPES || ($a9c7849af2339627$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $a9c7849af2339627$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($a9c7849af2339627$var$SAMPLER_TYPES || ($a9c7849af2339627$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $a9c7849af2339627$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($a9c7849af2339627$var$SCALE_MODES || ($a9c7849af2339627$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $a9c7849af2339627$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($a9c7849af2339627$var$WRAP_MODES || ($a9c7849af2339627$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $a9c7849af2339627$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($a9c7849af2339627$var$MIPMAP_MODES || ($a9c7849af2339627$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $a9c7849af2339627$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($a9c7849af2339627$var$ALPHA_MODES || ($a9c7849af2339627$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $a9c7849af2339627$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($a9c7849af2339627$var$CLEAR_MODES || ($a9c7849af2339627$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $a9c7849af2339627$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($a9c7849af2339627$var$GC_MODES || ($a9c7849af2339627$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $a9c7849af2339627$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($a9c7849af2339627$var$PRECISION || ($a9c7849af2339627$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $a9c7849af2339627$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($a9c7849af2339627$var$MASK_TYPES || ($a9c7849af2339627$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $a9c7849af2339627$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($a9c7849af2339627$var$MSAA_QUALITY || ($a9c7849af2339627$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $a9c7849af2339627$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($a9c7849af2339627$var$BUFFER_TYPE || ($a9c7849af2339627$var$BUFFER_TYPE = {}));
/**
 * User's customizable globals for overriding the default PIXI settings, such
 * as a renderer's default resolution, framerate, float precision, etc.
 * @example
 * // Use the native window resolution as the default resolution
 * // will support high-density displays when rendering
 * PIXI.settings.RESOLUTION = window.devicePixelRatio;
 *
 * // Disable interpolation when scaling, will make texture be pixelated
 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
 * @namespace PIXI.settings
 */ var $a9c7849af2339627$export$a5a6e0b888b2c992 = {
    /**
     * If set to true WebGL will attempt make textures mimpaped by default.
     * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
     *
     * @static
     * @name MIPMAP_TEXTURES
     * @memberof PIXI.settings
     * @type {PIXI.MIPMAP_MODES}
     * @default PIXI.MIPMAP_MODES.POW2
     */ MIPMAP_TEXTURES: $a9c7849af2339627$var$MIPMAP_MODES.POW2,
    /**
     * Default anisotropic filtering level of textures.
     * Usually from 0 to 16
     *
     * @static
     * @name ANISOTROPIC_LEVEL
     * @memberof PIXI.settings
     * @type {number}
     * @default 0
     */ ANISOTROPIC_LEVEL: 0,
    /**
     * Default resolution / device pixel ratio of the renderer.
     *
     * @static
     * @name RESOLUTION
     * @memberof PIXI.settings
     * @type {number}
     * @default 1
     */ RESOLUTION: 1,
    /**
     * Default filter resolution.
     *
     * @static
     * @name FILTER_RESOLUTION
     * @memberof PIXI.settings
     * @type {number}
     * @default 1
     */ FILTER_RESOLUTION: 1,
    /**
     * Default filter samples.
     *
     * @static
     * @name FILTER_MULTISAMPLE
     * @memberof PIXI.settings
     * @type {PIXI.MSAA_QUALITY}
     * @default PIXI.MSAA_QUALITY.NONE
     */ FILTER_MULTISAMPLE: $a9c7849af2339627$var$MSAA_QUALITY.NONE,
    /**
     * The maximum textures that this device supports.
     *
     * @static
     * @name SPRITE_MAX_TEXTURES
     * @memberof PIXI.settings
     * @type {number}
     * @default 32
     */ SPRITE_MAX_TEXTURES: $a9c7849af2339627$var$maxRecommendedTextures(32),
    // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
    // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
    /**
     * The default sprite batch size.
     *
     * The default aims to balance desktop and mobile devices.
     *
     * @static
     * @name SPRITE_BATCH_SIZE
     * @memberof PIXI.settings
     * @type {number}
     * @default 4096
     */ SPRITE_BATCH_SIZE: 4096,
    /**
     * The default render options if none are supplied to {@link PIXI.Renderer}
     * or {@link PIXI.CanvasRenderer}.
     *
     * @static
     * @name RENDER_OPTIONS
     * @memberof PIXI.settings
     * @type {object}
     * @property {HTMLCanvasElement} view=null
     * @property {boolean} antialias=false
     * @property {boolean} autoDensity=false
     * @property {boolean} useContextAlpha=true
     * @property {number} backgroundColor=0x000000
     * @property {number} backgroundAlpha=1
     * @property {boolean} clearBeforeRender=true
     * @property {boolean} preserveDrawingBuffer=false
     * @property {number} width=800
     * @property {number} height=600
     * @property {boolean} legacy=false
     */ RENDER_OPTIONS: {
        view: null,
        antialias: false,
        autoDensity: false,
        backgroundColor: 0x000000,
        backgroundAlpha: 1,
        useContextAlpha: true,
        clearBeforeRender: true,
        preserveDrawingBuffer: false,
        width: 800,
        height: 600,
        legacy: false
    },
    /**
     * Default Garbage Collection mode.
     *
     * @static
     * @name GC_MODE
     * @memberof PIXI.settings
     * @type {PIXI.GC_MODES}
     * @default PIXI.GC_MODES.AUTO
     */ GC_MODE: $a9c7849af2339627$var$GC_MODES.AUTO,
    /**
     * Default Garbage Collection max idle.
     *
     * @static
     * @name GC_MAX_IDLE
     * @memberof PIXI.settings
     * @type {number}
     * @default 3600
     */ GC_MAX_IDLE: 3600,
    /**
     * Default Garbage Collection maximum check count.
     *
     * @static
     * @name GC_MAX_CHECK_COUNT
     * @memberof PIXI.settings
     * @type {number}
     * @default 600
     */ GC_MAX_CHECK_COUNT: 600,
    /**
     * Default wrap modes that are supported by pixi.
     *
     * @static
     * @name WRAP_MODE
     * @memberof PIXI.settings
     * @type {PIXI.WRAP_MODES}
     * @default PIXI.WRAP_MODES.CLAMP
     */ WRAP_MODE: $a9c7849af2339627$var$WRAP_MODES.CLAMP,
    /**
     * Default scale mode for textures.
     *
     * @static
     * @name SCALE_MODE
     * @memberof PIXI.settings
     * @type {PIXI.SCALE_MODES}
     * @default PIXI.SCALE_MODES.LINEAR
     */ SCALE_MODE: $a9c7849af2339627$var$SCALE_MODES.LINEAR,
    /**
     * Default specify float precision in vertex shader.
     *
     * @static
     * @name PRECISION_VERTEX
     * @memberof PIXI.settings
     * @type {PIXI.PRECISION}
     * @default PIXI.PRECISION.HIGH
     */ PRECISION_VERTEX: $a9c7849af2339627$var$PRECISION.HIGH,
    /**
     * Default specify float precision in fragment shader.
     * iOS is best set at highp due to https://github.com/pixijs/pixi.js/issues/3742
     *
     * @static
     * @name PRECISION_FRAGMENT
     * @memberof PIXI.settings
     * @type {PIXI.PRECISION}
     * @default PIXI.PRECISION.MEDIUM
     */ PRECISION_FRAGMENT: $a9c7849af2339627$export$d0a8044dce8ff2fc.apple.device ? $a9c7849af2339627$var$PRECISION.HIGH : $a9c7849af2339627$var$PRECISION.MEDIUM,
    /**
     * Can we upload the same buffer in a single frame?
     *
     * @static
     * @name CAN_UPLOAD_SAME_BUFFER
     * @memberof PIXI.settings
     * @type {boolean}
     */ CAN_UPLOAD_SAME_BUFFER: $a9c7849af2339627$var$canUploadSameBuffer(),
    /**
     * Enables bitmap creation before image load. This feature is experimental.
     *
     * @static
     * @name CREATE_IMAGE_BITMAP
     * @memberof PIXI.settings
     * @type {boolean}
     * @default false
     */ CREATE_IMAGE_BITMAP: false,
    /**
     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
     * Advantages can include sharper image quality (like text) and faster rendering on canvas.
     * The main disadvantage is movement of objects may appear less smooth.
     *
     * @static
     * @constant
     * @memberof PIXI.settings
     * @type {boolean}
     * @default false
     */ ROUND_PIXELS: false
};

});
parcelRegister("d99R2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("cHiip")).default; });

var $cHiip = parcelRequire("cHiip");

});
parcelRegister("cHiip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93e7b15c28b6d528$export$2e2bcd8739ae039; });
var $93e7b15c28b6d528$var$appleIphone = /iPhone/i;
var $93e7b15c28b6d528$var$appleIpod = /iPod/i;
var $93e7b15c28b6d528$var$appleTablet = /iPad/i;
var $93e7b15c28b6d528$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $93e7b15c28b6d528$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $93e7b15c28b6d528$var$androidTablet = /Android/i;
var $93e7b15c28b6d528$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $93e7b15c28b6d528$var$amazonTablet = /Silk/i;
var $93e7b15c28b6d528$var$windowsPhone = /Windows Phone/i;
var $93e7b15c28b6d528$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $93e7b15c28b6d528$var$otherBlackBerry = /BlackBerry/i;
var $93e7b15c28b6d528$var$otherBlackBerry10 = /BB10/i;
var $93e7b15c28b6d528$var$otherOpera = /Opera Mini/i;
var $93e7b15c28b6d528$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $93e7b15c28b6d528$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $93e7b15c28b6d528$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== 'undefined' && navigator1.platform === 'MacIntel' && typeof navigator1.maxTouchPoints === 'number' && navigator1.maxTouchPoints > 1 && typeof MSStream === 'undefined';
};
function $93e7b15c28b6d528$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $93e7b15c28b6d528$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== 'undefined') nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === 'string') nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    tmp = userAgent.split('Twitter');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    var match = $93e7b15c28b6d528$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($93e7b15c28b6d528$var$appleIphone) && !match($93e7b15c28b6d528$var$windowsPhone),
            ipod: match($93e7b15c28b6d528$var$appleIpod),
            tablet: !match($93e7b15c28b6d528$var$appleIphone) && (match($93e7b15c28b6d528$var$appleTablet) || $93e7b15c28b6d528$var$isAppleTabletOnIos13(nav)) && !match($93e7b15c28b6d528$var$windowsPhone),
            universal: match($93e7b15c28b6d528$var$appleUniversal),
            device: (match($93e7b15c28b6d528$var$appleIphone) || match($93e7b15c28b6d528$var$appleIpod) || match($93e7b15c28b6d528$var$appleTablet) || match($93e7b15c28b6d528$var$appleUniversal) || $93e7b15c28b6d528$var$isAppleTabletOnIos13(nav)) && !match($93e7b15c28b6d528$var$windowsPhone)
        },
        amazon: {
            phone: match($93e7b15c28b6d528$var$amazonPhone),
            tablet: !match($93e7b15c28b6d528$var$amazonPhone) && match($93e7b15c28b6d528$var$amazonTablet),
            device: match($93e7b15c28b6d528$var$amazonPhone) || match($93e7b15c28b6d528$var$amazonTablet)
        },
        android: {
            phone: !match($93e7b15c28b6d528$var$windowsPhone) && match($93e7b15c28b6d528$var$amazonPhone) || !match($93e7b15c28b6d528$var$windowsPhone) && match($93e7b15c28b6d528$var$androidPhone),
            tablet: !match($93e7b15c28b6d528$var$windowsPhone) && !match($93e7b15c28b6d528$var$amazonPhone) && !match($93e7b15c28b6d528$var$androidPhone) && (match($93e7b15c28b6d528$var$amazonTablet) || match($93e7b15c28b6d528$var$androidTablet)),
            device: !match($93e7b15c28b6d528$var$windowsPhone) && (match($93e7b15c28b6d528$var$amazonPhone) || match($93e7b15c28b6d528$var$amazonTablet) || match($93e7b15c28b6d528$var$androidPhone) || match($93e7b15c28b6d528$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($93e7b15c28b6d528$var$windowsPhone),
            tablet: match($93e7b15c28b6d528$var$windowsTablet),
            device: match($93e7b15c28b6d528$var$windowsPhone) || match($93e7b15c28b6d528$var$windowsTablet)
        },
        other: {
            blackberry: match($93e7b15c28b6d528$var$otherBlackBerry),
            blackberry10: match($93e7b15c28b6d528$var$otherBlackBerry10),
            opera: match($93e7b15c28b6d528$var$otherOpera),
            firefox: match($93e7b15c28b6d528$var$otherFirefox),
            chrome: match($93e7b15c28b6d528$var$otherChrome),
            device: match($93e7b15c28b6d528$var$otherBlackBerry) || match($93e7b15c28b6d528$var$otherBlackBerry10) || match($93e7b15c28b6d528$var$otherOpera) || match($93e7b15c28b6d528$var$otherFirefox) || match($93e7b15c28b6d528$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}

});



parcelRegister("6p5EE", function(module, exports) {
'use strict';
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
module.exports = $4a9976ca6ebf6735$var$EventEmitter;

});

parcelRegister("fPquT", function(module, exports) {
'use strict';
module.exports = $b8602c4416cfa89b$var$earcut;
module.exports.default = $b8602c4416cfa89b$var$earcut;
function $b8602c4416cfa89b$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $b8602c4416cfa89b$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $b8602c4416cfa89b$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $b8602c4416cfa89b$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $b8602c4416cfa89b$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $b8602c4416cfa89b$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $b8602c4416cfa89b$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $b8602c4416cfa89b$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $b8602c4416cfa89b$var$equals(last, last.next)) {
        $b8602c4416cfa89b$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $b8602c4416cfa89b$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($b8602c4416cfa89b$var$equals(p, p.next) || $b8602c4416cfa89b$var$area(p.prev, p, p.next) === 0)) {
            $b8602c4416cfa89b$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $b8602c4416cfa89b$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $b8602c4416cfa89b$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $b8602c4416cfa89b$var$isEarHashed(ear, minX, minY, invSize) : $b8602c4416cfa89b$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $b8602c4416cfa89b$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $b8602c4416cfa89b$var$earcutLinked($b8602c4416cfa89b$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $b8602c4416cfa89b$var$cureLocalIntersections($b8602c4416cfa89b$var$filterPoints(ear), triangles, dim);
                $b8602c4416cfa89b$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $b8602c4416cfa89b$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $b8602c4416cfa89b$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($b8602c4416cfa89b$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $b8602c4416cfa89b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $b8602c4416cfa89b$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($b8602c4416cfa89b$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $b8602c4416cfa89b$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $b8602c4416cfa89b$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $b8602c4416cfa89b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $b8602c4416cfa89b$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $b8602c4416cfa89b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $b8602c4416cfa89b$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $b8602c4416cfa89b$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$b8602c4416cfa89b$var$equals(a, b) && $b8602c4416cfa89b$var$intersects(a, p, p.next, b) && $b8602c4416cfa89b$var$locallyInside(a, b) && $b8602c4416cfa89b$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $b8602c4416cfa89b$var$removeNode(p);
            $b8602c4416cfa89b$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $b8602c4416cfa89b$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $b8602c4416cfa89b$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $b8602c4416cfa89b$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $b8602c4416cfa89b$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $b8602c4416cfa89b$var$filterPoints(a, a.next);
                c = $b8602c4416cfa89b$var$filterPoints(c, c.next);
                // run earcut on each half
                $b8602c4416cfa89b$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $b8602c4416cfa89b$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $b8602c4416cfa89b$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $b8602c4416cfa89b$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($b8602c4416cfa89b$var$getLeftmost(list));
    }
    queue.sort($b8602c4416cfa89b$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $b8602c4416cfa89b$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $b8602c4416cfa89b$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $b8602c4416cfa89b$var$eliminateHole(hole, outerNode) {
    var bridge = $b8602c4416cfa89b$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $b8602c4416cfa89b$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $b8602c4416cfa89b$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $b8602c4416cfa89b$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $b8602c4416cfa89b$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $b8602c4416cfa89b$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($b8602c4416cfa89b$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $b8602c4416cfa89b$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $b8602c4416cfa89b$var$sectorContainsSector(m, p) {
    return $b8602c4416cfa89b$var$area(m.prev, m, p.prev) < 0 && $b8602c4416cfa89b$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $b8602c4416cfa89b$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $b8602c4416cfa89b$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $b8602c4416cfa89b$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $b8602c4416cfa89b$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $b8602c4416cfa89b$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $b8602c4416cfa89b$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $b8602c4416cfa89b$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$b8602c4416cfa89b$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($b8602c4416cfa89b$var$locallyInside(a, b) && $b8602c4416cfa89b$var$locallyInside(b, a) && $b8602c4416cfa89b$var$middleInside(a, b) && // locally visible
    ($b8602c4416cfa89b$var$area(a.prev, a, b.prev) || $b8602c4416cfa89b$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $b8602c4416cfa89b$var$equals(a, b) && $b8602c4416cfa89b$var$area(a.prev, a, a.next) > 0 && $b8602c4416cfa89b$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $b8602c4416cfa89b$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $b8602c4416cfa89b$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $b8602c4416cfa89b$var$intersects(p1, q1, p2, q2) {
    var o1 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p1, q1, p2));
    var o2 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p1, q1, q2));
    var o3 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p2, q2, p1));
    var o4 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $b8602c4416cfa89b$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $b8602c4416cfa89b$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $b8602c4416cfa89b$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $b8602c4416cfa89b$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $b8602c4416cfa89b$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $b8602c4416cfa89b$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $b8602c4416cfa89b$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $b8602c4416cfa89b$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $b8602c4416cfa89b$var$locallyInside(a, b) {
    return $b8602c4416cfa89b$var$area(a.prev, a, a.next) < 0 ? $b8602c4416cfa89b$var$area(a, b, a.next) >= 0 && $b8602c4416cfa89b$var$area(a, a.prev, b) >= 0 : $b8602c4416cfa89b$var$area(a, b, a.prev) < 0 || $b8602c4416cfa89b$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $b8602c4416cfa89b$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $b8602c4416cfa89b$var$splitPolygon(a, b) {
    var a2 = new $b8602c4416cfa89b$var$Node(a.i, a.x, a.y), b2 = new $b8602c4416cfa89b$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $b8602c4416cfa89b$var$insertNode(i, x, y, last) {
    var p = new $b8602c4416cfa89b$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $b8602c4416cfa89b$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $b8602c4416cfa89b$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$b8602c4416cfa89b$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($b8602c4416cfa89b$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($b8602c4416cfa89b$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $b8602c4416cfa89b$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$b8602c4416cfa89b$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});

parcelRegister("hH01d", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $9Wff9 = parcelRequire("9Wff9");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $kGWxD = parcelRequire("kGWxD");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $kGWxD.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $9Wff9.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $kGWxD.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $kGWxD.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("9Wff9", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("kGWxD", function(module, exports) {
'use strict';

var $jGHEN = parcelRequire("jGHEN");

var $h1p15 = parcelRequire("h1p15");

var $iSgbH = parcelRequire("iSgbH");
module.exports = {
    formats: $iSgbH,
    parse: $h1p15,
    stringify: $jGHEN
};

});
parcelRegister("jGHEN", function(module, exports) {
'use strict';

var $aLN2C = parcelRequire("aLN2C");

var $5vn5Z = parcelRequire("5vn5Z");

var $iSgbH = parcelRequire("iSgbH");
var $e553cde939346e03$var$has = Object.prototype.hasOwnProperty;
var $e553cde939346e03$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e553cde939346e03$var$isArray = Array.isArray;
var $e553cde939346e03$var$push = Array.prototype.push;
var $e553cde939346e03$var$pushToArray = function(arr, valueOrArray) {
    $e553cde939346e03$var$push.apply(arr, $e553cde939346e03$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e553cde939346e03$var$toISO = Date.prototype.toISOString;
var $e553cde939346e03$var$defaultFormat = $iSgbH.default;
var $e553cde939346e03$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $5vn5Z.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $e553cde939346e03$var$defaultFormat,
    formatter: $iSgbH.formatters[$e553cde939346e03$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e553cde939346e03$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e553cde939346e03$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $e553cde939346e03$var$sentinel = {};
var $e553cde939346e03$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e553cde939346e03$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e553cde939346e03$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $e553cde939346e03$var$isArray(obj)) obj = $5vn5Z.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e553cde939346e03$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($e553cde939346e03$var$isNonNullishPrimitive(obj) || $5vn5Z.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e553cde939346e03$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $e553cde939346e03$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $e553cde939346e03$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $5vn5Z.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($e553cde939346e03$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $e553cde939346e03$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $e553cde939346e03$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $e553cde939346e03$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $aLN2C();
        valueSideChannel.set($e553cde939346e03$var$sentinel, sideChannel);
        $e553cde939346e03$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $e553cde939346e03$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e553cde939346e03$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e553cde939346e03$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $e553cde939346e03$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $iSgbH.default;
    if (typeof opts.format !== 'undefined') {
        if (!$e553cde939346e03$var$has.call($iSgbH.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $iSgbH.formatters[format];
    var filter = $e553cde939346e03$var$defaults.filter;
    if (typeof opts.filter === 'function' || $e553cde939346e03$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $e553cde939346e03$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $e553cde939346e03$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $e553cde939346e03$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $e553cde939346e03$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $e553cde939346e03$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $e553cde939346e03$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $e553cde939346e03$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $e553cde939346e03$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $e553cde939346e03$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $e553cde939346e03$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $e553cde939346e03$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $e553cde939346e03$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $e553cde939346e03$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $e553cde939346e03$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e553cde939346e03$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($e553cde939346e03$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $e553cde939346e03$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $aLN2C();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $e553cde939346e03$var$pushToArray(keys, $e553cde939346e03$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("aLN2C", function(module, exports) {
'use strict';

var $eDiIz = parcelRequire("eDiIz");

var $5reXs = parcelRequire("5reXs");

var $2h55P = parcelRequire("2h55P");

var $Sth43 = parcelRequire("Sth43");

var $4mZ6l = parcelRequire("4mZ6l");
var $7d7455b7eca66e61$var$makeChannel = $4mZ6l || $Sth43 || $2h55P;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $7d7455b7eca66e61$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("eDiIz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("5reXs", function(module, exports) {
var $3f5b13b16a751ddf$var$hasMap = typeof Map === 'function' && Map.prototype;
var $3f5b13b16a751ddf$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $3f5b13b16a751ddf$var$mapSize = $3f5b13b16a751ddf$var$hasMap && $3f5b13b16a751ddf$var$mapSizeDescriptor && typeof $3f5b13b16a751ddf$var$mapSizeDescriptor.get === 'function' ? $3f5b13b16a751ddf$var$mapSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$mapForEach = $3f5b13b16a751ddf$var$hasMap && Map.prototype.forEach;
var $3f5b13b16a751ddf$var$hasSet = typeof Set === 'function' && Set.prototype;
var $3f5b13b16a751ddf$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $3f5b13b16a751ddf$var$setSize = $3f5b13b16a751ddf$var$hasSet && $3f5b13b16a751ddf$var$setSizeDescriptor && typeof $3f5b13b16a751ddf$var$setSizeDescriptor.get === 'function' ? $3f5b13b16a751ddf$var$setSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$setForEach = $3f5b13b16a751ddf$var$hasSet && Set.prototype.forEach;
var $3f5b13b16a751ddf$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $3f5b13b16a751ddf$var$weakMapHas = $3f5b13b16a751ddf$var$hasWeakMap ? WeakMap.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $3f5b13b16a751ddf$var$weakSetHas = $3f5b13b16a751ddf$var$hasWeakSet ? WeakSet.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $3f5b13b16a751ddf$var$weakRefDeref = $3f5b13b16a751ddf$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $3f5b13b16a751ddf$var$booleanValueOf = Boolean.prototype.valueOf;
var $3f5b13b16a751ddf$var$objectToString = Object.prototype.toString;
var $3f5b13b16a751ddf$var$functionToString = Function.prototype.toString;
var $3f5b13b16a751ddf$var$$match = String.prototype.match;
var $3f5b13b16a751ddf$var$$slice = String.prototype.slice;
var $3f5b13b16a751ddf$var$$replace = String.prototype.replace;
var $3f5b13b16a751ddf$var$$toUpperCase = String.prototype.toUpperCase;
var $3f5b13b16a751ddf$var$$toLowerCase = String.prototype.toLowerCase;
var $3f5b13b16a751ddf$var$$test = RegExp.prototype.test;
var $3f5b13b16a751ddf$var$$concat = Array.prototype.concat;
var $3f5b13b16a751ddf$var$$join = Array.prototype.join;
var $3f5b13b16a751ddf$var$$arrSlice = Array.prototype.slice;
var $3f5b13b16a751ddf$var$$floor = Math.floor;
var $3f5b13b16a751ddf$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $3f5b13b16a751ddf$var$gOPS = Object.getOwnPropertySymbols;
var $3f5b13b16a751ddf$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $3f5b13b16a751ddf$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $3f5b13b16a751ddf$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $3f5b13b16a751ddf$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $3f5b13b16a751ddf$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $3f5b13b16a751ddf$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $3f5b13b16a751ddf$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $3f5b13b16a751ddf$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$3f5b13b16a751ddf$var$$floor(-num) : $3f5b13b16a751ddf$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $3f5b13b16a751ddf$var$$slice.call(str, intStr.length + 1);
            return $3f5b13b16a751ddf$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $3f5b13b16a751ddf$var$$replace.call(str, sepRegex, '$&_');
}

var $5Io6y = parcelRequire("5Io6y");
var $3f5b13b16a751ddf$var$inspectCustom = $5Io6y.custom;
var $3f5b13b16a751ddf$var$inspectSymbol = $3f5b13b16a751ddf$var$isSymbol($3f5b13b16a751ddf$var$inspectCustom) ? $3f5b13b16a751ddf$var$inspectCustom : null;
var $3f5b13b16a751ddf$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $3f5b13b16a751ddf$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($3f5b13b16a751ddf$var$has(opts, 'quoteStyle') && !$3f5b13b16a751ddf$var$has($3f5b13b16a751ddf$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($3f5b13b16a751ddf$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $3f5b13b16a751ddf$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($3f5b13b16a751ddf$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($3f5b13b16a751ddf$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $3f5b13b16a751ddf$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $3f5b13b16a751ddf$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $3f5b13b16a751ddf$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($3f5b13b16a751ddf$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $3f5b13b16a751ddf$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($3f5b13b16a751ddf$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var name = $3f5b13b16a751ddf$var$nameOf(obj);
        var keys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $3f5b13b16a751ddf$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($3f5b13b16a751ddf$var$isSymbol(obj)) {
        var symString = $3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $3f5b13b16a751ddf$var$symToString.call(obj);
        return typeof obj === 'object' && !$3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$markBoxed(symString) : symString;
    }
    if ($3f5b13b16a751ddf$var$isElement(obj)) {
        var s = '<' + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $3f5b13b16a751ddf$var$wrapQuotes($3f5b13b16a751ddf$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($3f5b13b16a751ddf$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (indent && !$3f5b13b16a751ddf$var$singleLineValues(xs)) return '[' + $3f5b13b16a751ddf$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $3f5b13b16a751ddf$var$$join.call(xs, ', ') + ' ]';
    }
    if ($3f5b13b16a751ddf$var$isError(obj)) {
        var parts = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$3f5b13b16a751ddf$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $3f5b13b16a751ddf$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($3f5b13b16a751ddf$var$inspectSymbol && typeof obj[$3f5b13b16a751ddf$var$inspectSymbol] === 'function' && $5Io6y) return $5Io6y(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($3f5b13b16a751ddf$var$isMap(obj)) {
        var mapParts = [];
        if ($3f5b13b16a751ddf$var$mapForEach) $3f5b13b16a751ddf$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf('Map', $3f5b13b16a751ddf$var$mapSize.call(obj), mapParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isSet(obj)) {
        var setParts = [];
        if ($3f5b13b16a751ddf$var$setForEach) $3f5b13b16a751ddf$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf('Set', $3f5b13b16a751ddf$var$setSize.call(obj), setParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isWeakMap(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakMap');
    if ($3f5b13b16a751ddf$var$isWeakSet(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakSet');
    if ($3f5b13b16a751ddf$var$isWeakRef(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakRef');
    if ($3f5b13b16a751ddf$var$isNumber(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(Number(obj)));
    if ($3f5b13b16a751ddf$var$isBigInt(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect($3f5b13b16a751ddf$var$bigIntValueOf.call(obj)));
    if ($3f5b13b16a751ddf$var$isBoolean(obj)) return $3f5b13b16a751ddf$var$markBoxed($3f5b13b16a751ddf$var$booleanValueOf.call(obj));
    if ($3f5b13b16a751ddf$var$isString(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$3f5b13b16a751ddf$var$isDate(obj) && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var ys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        var isPlainObject = $3f5b13b16a751ddf$var$gPO ? $3f5b13b16a751ddf$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $3f5b13b16a751ddf$var$toStringTag && Object(obj) === obj && $3f5b13b16a751ddf$var$toStringTag in obj ? $3f5b13b16a751ddf$var$$slice.call($3f5b13b16a751ddf$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $3f5b13b16a751ddf$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $3f5b13b16a751ddf$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $3f5b13b16a751ddf$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $3f5b13b16a751ddf$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $3f5b13b16a751ddf$var$quote(s) {
    return $3f5b13b16a751ddf$var$$replace.call(String(s), /"/g, '&quot;');
}
function $3f5b13b16a751ddf$var$canTrustToString(obj) {
    return !$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === 'object' && ($3f5b13b16a751ddf$var$toStringTag in obj || typeof obj[$3f5b13b16a751ddf$var$toStringTag] !== 'undefined'));
}
function $3f5b13b16a751ddf$var$isArray(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Array]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isDate(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Date]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isRegExp(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object RegExp]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isError(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Error]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isString(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object String]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isNumber(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Number]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isBoolean(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Boolean]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $3f5b13b16a751ddf$var$isSymbol(obj) {
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$3f5b13b16a751ddf$var$symToString) return false;
    try {
        $3f5b13b16a751ddf$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$3f5b13b16a751ddf$var$bigIntValueOf) return false;
    try {
        $3f5b13b16a751ddf$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $3f5b13b16a751ddf$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $3f5b13b16a751ddf$var$has(obj, key) {
    return $3f5b13b16a751ddf$var$hasOwn.call(obj, key);
}
function $3f5b13b16a751ddf$var$toStr(obj) {
    return $3f5b13b16a751ddf$var$objectToString.call(obj);
}
function $3f5b13b16a751ddf$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $3f5b13b16a751ddf$var$$match.call($3f5b13b16a751ddf$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $3f5b13b16a751ddf$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $3f5b13b16a751ddf$var$isMap(x) {
    if (!$3f5b13b16a751ddf$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$mapSize.call(x);
        try {
            $3f5b13b16a751ddf$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakMap(x) {
    if (!$3f5b13b16a751ddf$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        try {
            $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakRef(x) {
    if (!$3f5b13b16a751ddf$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isSet(x) {
    if (!$3f5b13b16a751ddf$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$setSize.call(x);
        try {
            $3f5b13b16a751ddf$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakSet(x) {
    if (!$3f5b13b16a751ddf$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        try {
            $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $3f5b13b16a751ddf$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $3f5b13b16a751ddf$var$inspectString($3f5b13b16a751ddf$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $3f5b13b16a751ddf$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $3f5b13b16a751ddf$var$lowbyte);
    return $3f5b13b16a751ddf$var$wrapQuotes(s, 'single', opts);
}
function $3f5b13b16a751ddf$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $3f5b13b16a751ddf$var$$toUpperCase.call(n.toString(16));
}
function $3f5b13b16a751ddf$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $3f5b13b16a751ddf$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $3f5b13b16a751ddf$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $3f5b13b16a751ddf$var$indentedJoin(entries, indent) : $3f5b13b16a751ddf$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $3f5b13b16a751ddf$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($3f5b13b16a751ddf$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $3f5b13b16a751ddf$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $3f5b13b16a751ddf$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $3f5b13b16a751ddf$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $3f5b13b16a751ddf$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $3f5b13b16a751ddf$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect) {
    var isArr = $3f5b13b16a751ddf$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $3f5b13b16a751ddf$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $3f5b13b16a751ddf$var$gOPS === 'function' ? $3f5b13b16a751ddf$var$gOPS(obj) : [];
    var symMap;
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$3f5b13b16a751ddf$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($3f5b13b16a751ddf$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($3f5b13b16a751ddf$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $3f5b13b16a751ddf$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($3f5b13b16a751ddf$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});


parcelRegister("2h55P", function(module, exports) {
'use strict';

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $1a811eae018032cc$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $1a811eae018032cc$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $1a811eae018032cc$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $1a811eae018032cc$var$listSet = function(objects, key, value) {
    var node = $1a811eae018032cc$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $1a811eae018032cc$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$1a811eae018032cc$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $1a811eae018032cc$var$listDelete = function(objects, key) {
    if (objects) return $1a811eae018032cc$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $1a811eae018032cc$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $1a811eae018032cc$var$listGet($o, key);
        },
        has: function(key) {
            return $1a811eae018032cc$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $1a811eae018032cc$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("Sth43", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $bhqNG = parcelRequire("bhqNG");

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
var $0a3bc083529cac57$var$$Map = $avqmt('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $0a3bc083529cac57$var$$mapGet = $bhqNG('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $0a3bc083529cac57$var$$mapSet = $bhqNG('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0a3bc083529cac57$var$$mapHas = $bhqNG('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0a3bc083529cac57$var$$mapDelete = $bhqNG('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $0a3bc083529cac57$var$$mapSize = $bhqNG('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$0a3bc083529cac57$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $0a3bc083529cac57$var$$mapDelete($m, key);
                if ($0a3bc083529cac57$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $0a3bc083529cac57$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $0a3bc083529cac57$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $0a3bc083529cac57$var$$Map();
            $0a3bc083529cac57$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("avqmt", function(module, exports) {
'use strict';
var $7a613f7503e09dde$var$undefined1;

var $7KrI3 = parcelRequire("7KrI3");

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");

var $db7xm = parcelRequire("db7xm");

var $gKnEJ = parcelRequire("gKnEJ");

var $42MO3 = parcelRequire("42MO3");

var $daBYy = parcelRequire("daBYy");

var $7VgwK = parcelRequire("7VgwK");

var $6GICW = parcelRequire("6GICW");

var $lj3GK = parcelRequire("lj3GK");
var $7a613f7503e09dde$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $crSdH = parcelRequire("crSdH");

var $4jAFO = parcelRequire("4jAFO");
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $7a613f7503e09dde$var$ThrowTypeError = $crSdH ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $crSdH(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $agKAf = parcelRequire("agKAf");

var $e351b = parcelRequire("e351b");

var $kF6dV = parcelRequire("kF6dV");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === 'undefined' || !$agKAf ? undefined : $agKAf(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGenerator%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncIteratorPrototype%': $7a613f7503e09dde$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $7a613f7503e09dde$var$$Function,
    '%GeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf($agKAf([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7KrI3,
    '%Object.getOwnPropertyDescriptor%': $crSdH,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $7a613f7503e09dde$var$ThrowTypeError,
    '%TypedArray%': $7a613f7503e09dde$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9RlYm,
    '%Function.prototype.apply%': $hsI1I,
    '%Object.defineProperty%': $4jAFO,
    '%Object.getPrototypeOf%': $e351b,
    '%Math.abs%': $db7xm,
    '%Math.floor%': $gKnEJ,
    '%Math.max%': $42MO3,
    '%Math.min%': $daBYy,
    '%Math.pow%': $7VgwK,
    '%Math.round%': $6GICW,
    '%Math.sign%': $lj3GK,
    '%Reflect.getPrototypeOf%': $kF6dV
};
if ($agKAf) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $agKAf($agKAf(e));
    $7a613f7503e09dde$var$INTRINSICS['%Error.prototype%'] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $agKAf) value = $agKAf(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $a7ABz.call($9RlYm, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call($hsI1I, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call($9RlYm, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call($9RlYm, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call($9RlYm, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($crSdH && i + 1 >= parts.length) {
                var desc = $crSdH(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("7KrI3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ki6v4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6ZF4E", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jFaeR", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aNqH3", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("iOgL8", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("guz3A", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("db7xm", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("gKnEJ", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("42MO3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("daBYy", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("7VgwK", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("6GICW", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lj3GK", function(module, exports) {
'use strict';

var $jhjZ6 = parcelRequire("jhjZ6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jhjZ6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jhjZ6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("crSdH", function(module, exports) {
'use strict';

var $gRO4r = parcelRequire("gRO4r");
var $9102109fbf1ea315$require$$gOPD = $gRO4r;
if ($9102109fbf1ea315$require$$gOPD) try {
    $9102109fbf1ea315$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$require$$gOPD = null;
}
module.exports = $9102109fbf1ea315$require$$gOPD;

});
parcelRegister("gRO4r", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("4jAFO", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $3245625cab00454b$var$$defineProperty = Object.defineProperty || false;
if ($3245625cab00454b$var$$defineProperty) try {
    $3245625cab00454b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3245625cab00454b$var$$defineProperty = false;
}
module.exports = $3245625cab00454b$var$$defineProperty;

});

parcelRegister("5CmBX", function(module, exports) {
'use strict';
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $41720a79fda68d9e$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("agKAf", function(module, exports) {
'use strict';

var $kF6dV = parcelRequire("kF6dV");

var $e351b = parcelRequire("e351b");

var $lMT7N = parcelRequire("lMT7N");
/** @type {import('.')} */ module.exports = $kF6dV ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kF6dV(O);
} : $e351b ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e351b(O);
} : $lMT7N ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lMT7N(O);
} : null;

});
parcelRegister("kF6dV", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("e351b", function(module, exports) {
'use strict';

var $7KrI3 = parcelRequire("7KrI3");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $7KrI3.getPrototypeOf || null;

});

parcelRegister("lMT7N", function(module, exports) {
'use strict';

var $csNIY = parcelRequire("csNIY");

var $crSdH = parcelRequire("crSdH");
var $fdc8d75150bf6587$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $fdc8d75150bf6587$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $fdc8d75150bf6587$var$desc = !!$fdc8d75150bf6587$var$hasProtoAccessor && $crSdH && $crSdH(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $fdc8d75150bf6587$var$$Object = Object;
var $fdc8d75150bf6587$var$$getPrototypeOf = $fdc8d75150bf6587$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $fdc8d75150bf6587$var$desc && typeof $fdc8d75150bf6587$var$desc.get === 'function' ? $csNIY([
    $fdc8d75150bf6587$var$desc.get
]) : typeof $fdc8d75150bf6587$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $fdc8d75150bf6587$var$$getPrototypeOf(value == null ? value : $fdc8d75150bf6587$var$$Object(value));
} : false;

});
parcelRegister("csNIY", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $eDiIz = parcelRequire("eDiIz");

var $9RlYm = parcelRequire("9RlYm");

var $2Y4BE = parcelRequire("2Y4BE");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eDiIz('a function is required');
    return $2Y4BE($a7ABz, $9RlYm, args);
};

});
parcelRegister("a7ABz", function(module, exports) {
'use strict';

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = '[object Function]';
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $923fbadf1e720976$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9RlYm", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("2Y4BE", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");

var $cnaFh = parcelRequire("cnaFh");
/** @type {import('./actualApply')} */ module.exports = $cnaFh || $a7ABz.call($9RlYm, $hsI1I);

});
parcelRegister("hsI1I", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cnaFh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("7Dte4", function(module, exports) {
'use strict';
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {import('.')} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});


parcelRegister("bhqNG", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $csNIY = parcelRequire("csNIY");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $8366123d1c7410f8$var$$indexOf = $csNIY([
    $avqmt('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $avqmt(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8366123d1c7410f8$var$$indexOf(name, '.prototype.') > -1) return $csNIY(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("4mZ6l", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $bhqNG = parcelRequire("bhqNG");

var $5reXs = parcelRequire("5reXs");

var $Sth43 = parcelRequire("Sth43");

var $eDiIz = parcelRequire("eDiIz");
var $32e89cf5f0eb8664$var$$WeakMap = $avqmt('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $32e89cf5f0eb8664$var$$weakMapGet = $bhqNG('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $32e89cf5f0eb8664$var$$weakMapSet = $bhqNG('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $32e89cf5f0eb8664$var$$weakMapHas = $bhqNG('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $32e89cf5f0eb8664$var$$weakMapDelete = $bhqNG('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $32e89cf5f0eb8664$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapDelete($wm, key);
            } else if ($Sth43) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $32e89cf5f0eb8664$var$$WeakMap();
                $32e89cf5f0eb8664$var$$weakMapSet($wm, key, value);
            } else if ($Sth43) {
                if (!$m) $m = $Sth43();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $Sth43;

});


parcelRegister("5vn5Z", function(module, exports) {
'use strict';

var $iSgbH = parcelRequire("iSgbH");
var $4021c34b736659c4$var$has = Object.prototype.hasOwnProperty;
var $4021c34b736659c4$var$isArray = Array.isArray;
var $4021c34b736659c4$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $4021c34b736659c4$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($4021c34b736659c4$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $4021c34b736659c4$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $4021c34b736659c4$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($4021c34b736659c4$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$4021c34b736659c4$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($4021c34b736659c4$var$isArray(target) && !$4021c34b736659c4$var$isArray(source)) mergeTarget = $4021c34b736659c4$var$arrayToObject(target, options);
    if ($4021c34b736659c4$var$isArray(target) && $4021c34b736659c4$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($4021c34b736659c4$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($4021c34b736659c4$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $4021c34b736659c4$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $4021c34b736659c4$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $4021c34b736659c4$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $4021c34b736659c4$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $4021c34b736659c4$var$limit){
        var segment = string.length >= $4021c34b736659c4$var$limit ? string.slice(j, j + $4021c34b736659c4$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $iSgbH.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $4021c34b736659c4$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $4021c34b736659c4$var$hexTable[0xC0 | c >> 6] + $4021c34b736659c4$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $4021c34b736659c4$var$hexTable[0xE0 | c >> 12] + $4021c34b736659c4$var$hexTable[0x80 | c >> 6 & 0x3F] + $4021c34b736659c4$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $4021c34b736659c4$var$hexTable[0xF0 | c >> 18] + $4021c34b736659c4$var$hexTable[0x80 | c >> 12 & 0x3F] + $4021c34b736659c4$var$hexTable[0x80 | c >> 6 & 0x3F] + $4021c34b736659c4$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $4021c34b736659c4$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $4021c34b736659c4$var$compactQueue(queue);
    return value;
};
var $4021c34b736659c4$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $4021c34b736659c4$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $4021c34b736659c4$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $4021c34b736659c4$var$maybeMap = function maybeMap(val, fn) {
    if ($4021c34b736659c4$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $4021c34b736659c4$var$arrayToObject,
    assign: $4021c34b736659c4$var$assign,
    combine: $4021c34b736659c4$var$combine,
    compact: $4021c34b736659c4$var$compact,
    decode: $4021c34b736659c4$var$decode,
    encode: $4021c34b736659c4$var$encode,
    isBuffer: $4021c34b736659c4$var$isBuffer,
    isRegExp: $4021c34b736659c4$var$isRegExp,
    maybeMap: $4021c34b736659c4$var$maybeMap,
    merge: $4021c34b736659c4$var$merge
};

});
parcelRegister("iSgbH", function(module, exports) {
'use strict';
var $dbd9d3a7d871eabc$var$replace = String.prototype.replace;
var $dbd9d3a7d871eabc$var$percentTwenties = /%20/g;
var $dbd9d3a7d871eabc$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $dbd9d3a7d871eabc$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $dbd9d3a7d871eabc$var$replace.call(value, $dbd9d3a7d871eabc$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $dbd9d3a7d871eabc$var$Format.RFC1738,
    RFC3986: $dbd9d3a7d871eabc$var$Format.RFC3986
};

});



parcelRegister("h1p15", function(module, exports) {
'use strict';

var $5vn5Z = parcelRequire("5vn5Z");
var $c645ef6de64ebcf4$var$has = Object.prototype.hasOwnProperty;
var $c645ef6de64ebcf4$var$isArray = Array.isArray;
var $c645ef6de64ebcf4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $5vn5Z.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $c645ef6de64ebcf4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $c645ef6de64ebcf4$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $c645ef6de64ebcf4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $c645ef6de64ebcf4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $c645ef6de64ebcf4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $c645ef6de64ebcf4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $c645ef6de64ebcf4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $c645ef6de64ebcf4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $c645ef6de64ebcf4$var$defaults.decoder, charset, 'key');
            val = $5vn5Z.maybeMap($c645ef6de64ebcf4$var$parseArrayValue(part.slice(pos + 1), options, $c645ef6de64ebcf4$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $c645ef6de64ebcf4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $c645ef6de64ebcf4$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $c645ef6de64ebcf4$var$isArray(val) ? [
            val
        ] : val;
        var existing = $c645ef6de64ebcf4$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $5vn5Z.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $c645ef6de64ebcf4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $c645ef6de64ebcf4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $5vn5Z.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $c645ef6de64ebcf4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $c645ef6de64ebcf4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $c645ef6de64ebcf4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $c645ef6de64ebcf4$var$parseObject(keys, val, options, valuesParsed);
};
var $c645ef6de64ebcf4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $c645ef6de64ebcf4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $c645ef6de64ebcf4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $c645ef6de64ebcf4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $c645ef6de64ebcf4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $c645ef6de64ebcf4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $c645ef6de64ebcf4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $c645ef6de64ebcf4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $c645ef6de64ebcf4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $c645ef6de64ebcf4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $c645ef6de64ebcf4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $c645ef6de64ebcf4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $c645ef6de64ebcf4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $5vn5Z.isRegExp(opts.delimiter) ? opts.delimiter : $c645ef6de64ebcf4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $c645ef6de64ebcf4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $c645ef6de64ebcf4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $c645ef6de64ebcf4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $c645ef6de64ebcf4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $c645ef6de64ebcf4$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $c645ef6de64ebcf4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $c645ef6de64ebcf4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $c645ef6de64ebcf4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $c645ef6de64ebcf4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $5vn5Z.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $5vn5Z.compact(obj);
};

});



parcelRegister("P8XPi", function(module, exports) {

$parcel$export(module.exports, "ENV", function () { return $099bb7962f016ab8$export$83401e34d5e11bf4; });
$parcel$export(module.exports, "RENDERER_TYPE", function () { return $099bb7962f016ab8$export$747c566515e2a1d9; });
$parcel$export(module.exports, "BUFFER_BITS", function () { return $099bb7962f016ab8$export$c07ea8ac66dac49; });
$parcel$export(module.exports, "BLEND_MODES", function () { return $099bb7962f016ab8$export$f821c68fe9beaecf; });
$parcel$export(module.exports, "DRAW_MODES", function () { return $099bb7962f016ab8$export$91100badd8469338; });
$parcel$export(module.exports, "FORMATS", function () { return $099bb7962f016ab8$export$e9c4b7b466aa8274; });
$parcel$export(module.exports, "TARGETS", function () { return $099bb7962f016ab8$export$d1ff3caf57547dc5; });
$parcel$export(module.exports, "TYPES", function () { return $099bb7962f016ab8$export$426db7a6155b7a80; });
$parcel$export(module.exports, "SAMPLER_TYPES", function () { return $099bb7962f016ab8$export$8ee8af3637d728f5; });
$parcel$export(module.exports, "SCALE_MODES", function () { return $099bb7962f016ab8$export$6b734c6a0bba8473; });
$parcel$export(module.exports, "WRAP_MODES", function () { return $099bb7962f016ab8$export$2ab395cfb0dd2f0f; });
$parcel$export(module.exports, "MIPMAP_MODES", function () { return $099bb7962f016ab8$export$16f6fb5da874bbfd; });
$parcel$export(module.exports, "ALPHA_MODES", function () { return $099bb7962f016ab8$export$d56550d454401b73; });
$parcel$export(module.exports, "CLEAR_MODES", function () { return $099bb7962f016ab8$export$784901839554cbc3; });
$parcel$export(module.exports, "GC_MODES", function () { return $099bb7962f016ab8$export$5c6ba89c1f52b344; });
$parcel$export(module.exports, "PRECISION", function () { return $099bb7962f016ab8$export$d6d3992f3becc879; });
$parcel$export(module.exports, "MASK_TYPES", function () { return $099bb7962f016ab8$export$dbbea138c5d144; });
$parcel$export(module.exports, "MSAA_QUALITY", function () { return $099bb7962f016ab8$export$1eadd657d5acc2f2; });
$parcel$export(module.exports, "BUFFER_TYPE", function () { return $099bb7962f016ab8$export$b595a7e482202b96; });
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $099bb7962f016ab8$export$83401e34d5e11bf4;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($099bb7962f016ab8$export$83401e34d5e11bf4 || ($099bb7962f016ab8$export$83401e34d5e11bf4 = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $099bb7962f016ab8$export$747c566515e2a1d9;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($099bb7962f016ab8$export$747c566515e2a1d9 || ($099bb7962f016ab8$export$747c566515e2a1d9 = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $099bb7962f016ab8$export$c07ea8ac66dac49;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($099bb7962f016ab8$export$c07ea8ac66dac49 || ($099bb7962f016ab8$export$c07ea8ac66dac49 = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $099bb7962f016ab8$export$f821c68fe9beaecf;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($099bb7962f016ab8$export$f821c68fe9beaecf || ($099bb7962f016ab8$export$f821c68fe9beaecf = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $099bb7962f016ab8$export$91100badd8469338;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($099bb7962f016ab8$export$91100badd8469338 || ($099bb7962f016ab8$export$91100badd8469338 = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $099bb7962f016ab8$export$e9c4b7b466aa8274;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($099bb7962f016ab8$export$e9c4b7b466aa8274 || ($099bb7962f016ab8$export$e9c4b7b466aa8274 = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $099bb7962f016ab8$export$d1ff3caf57547dc5;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($099bb7962f016ab8$export$d1ff3caf57547dc5 || ($099bb7962f016ab8$export$d1ff3caf57547dc5 = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $099bb7962f016ab8$export$426db7a6155b7a80;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($099bb7962f016ab8$export$426db7a6155b7a80 || ($099bb7962f016ab8$export$426db7a6155b7a80 = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $099bb7962f016ab8$export$8ee8af3637d728f5;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($099bb7962f016ab8$export$8ee8af3637d728f5 || ($099bb7962f016ab8$export$8ee8af3637d728f5 = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $099bb7962f016ab8$export$6b734c6a0bba8473;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($099bb7962f016ab8$export$6b734c6a0bba8473 || ($099bb7962f016ab8$export$6b734c6a0bba8473 = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $099bb7962f016ab8$export$2ab395cfb0dd2f0f;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($099bb7962f016ab8$export$2ab395cfb0dd2f0f || ($099bb7962f016ab8$export$2ab395cfb0dd2f0f = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $099bb7962f016ab8$export$16f6fb5da874bbfd;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($099bb7962f016ab8$export$16f6fb5da874bbfd || ($099bb7962f016ab8$export$16f6fb5da874bbfd = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $099bb7962f016ab8$export$d56550d454401b73;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($099bb7962f016ab8$export$d56550d454401b73 || ($099bb7962f016ab8$export$d56550d454401b73 = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $099bb7962f016ab8$export$784901839554cbc3;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($099bb7962f016ab8$export$784901839554cbc3 || ($099bb7962f016ab8$export$784901839554cbc3 = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $099bb7962f016ab8$export$5c6ba89c1f52b344;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($099bb7962f016ab8$export$5c6ba89c1f52b344 || ($099bb7962f016ab8$export$5c6ba89c1f52b344 = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $099bb7962f016ab8$export$d6d3992f3becc879;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($099bb7962f016ab8$export$d6d3992f3becc879 || ($099bb7962f016ab8$export$d6d3992f3becc879 = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $099bb7962f016ab8$export$dbbea138c5d144;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($099bb7962f016ab8$export$dbbea138c5d144 || ($099bb7962f016ab8$export$dbbea138c5d144 = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $099bb7962f016ab8$export$1eadd657d5acc2f2;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($099bb7962f016ab8$export$1eadd657d5acc2f2 || ($099bb7962f016ab8$export$1eadd657d5acc2f2 = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $099bb7962f016ab8$export$b595a7e482202b96;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($099bb7962f016ab8$export$b595a7e482202b96 || ($099bb7962f016ab8$export$b595a7e482202b96 = {}));

});


parcelRegister("aZdrZ", function(module, exports) {

$parcel$export(module.exports, "accessibleTarget", function () { return $7ffa08e1ea5f4c07$export$2c6c5fc5694bba8e; });
$parcel$export(module.exports, "AccessibilityManager", function () { return $7ffa08e1ea5f4c07$export$a2c2de1efa8671eb; });
/*!
 * @pixi/accessibility - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/accessibility is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");
parcelRequire("csytw");
var $ezJmd = parcelRequire("ezJmd");
var $csytw = parcelRequire("csytw");
/**
 * Default property values of accessible objects
 * used by {@link PIXI.AccessibilityManager}.
 *
 * @private
 * @function accessibleTarget
 * @memberof PIXI
 * @type {Object}
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          MyObject.prototype,
 *          PIXI.accessibleTarget
 *      );
 */ var $7ffa08e1ea5f4c07$export$2c6c5fc5694bba8e = {
    /**
     *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
     *   shadow div with attributes set
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */ accessible: false,
    /**
     * Sets the title attribute of the shadow div
     * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
     *
     * @member {?string}
     * @memberof PIXI.DisplayObject#
     */ accessibleTitle: null,
    /**
     * Sets the aria-label attribute of the shadow div
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     */ accessibleHint: null,
    /**
     * @member {number}
     * @memberof PIXI.DisplayObject#
     * @private
     * @todo Needs docs.
     */ tabIndex: 0,
    /**
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     * @todo Needs docs.
     */ _accessibleActive: false,
    /**
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     * @todo Needs docs.
     */ _accessibleDiv: null,
    /**
     * Specify the type of div the accessible layer is. Screen readers treat the element differently
     * depending on this type. Defaults to button.
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     * @default 'button'
     */ accessibleType: 'button',
    /**
     * Specify the pointer-events the accessible div will use
     * Defaults to auto.
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     * @default 'auto'
     */ accessiblePointerEvents: 'auto',
    /**
     * Setting to false will prevent any children inside this container to
     * be accessible. Defaults to true.
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     * @default true
     */ accessibleChildren: true,
    renderId: -1
};
// add some extra variables to the container..
(0, $8t5Gy.DisplayObject).mixin($7ffa08e1ea5f4c07$export$2c6c5fc5694bba8e);
var $7ffa08e1ea5f4c07$var$KEY_CODE_TAB = 9;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE = 100;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_X = 0;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_Y = 0;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_ZINDEX = 2;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_SIZE = 1;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_X = -1000;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_Y = -1000;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_ZINDEX = 2;
/**
 * The Accessibility manager recreates the ability to tab and have content read by screen readers.
 * This is very important as it can possibly help people with disabilities access PixiJS content.
 *
 * A DisplayObject can be made accessible just like it can be made interactive. This manager will map the
 * events as if the mouse was being used, minimizing the effort required to implement.
 *
 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.accessibility`
 *
 * @class
 * @memberof PIXI
 */ var $7ffa08e1ea5f4c07$export$a2c2de1efa8671eb = /** @class */ function() {
    /**
     * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
     */ function AccessibilityManager(renderer) {
        /** Setting this to true will visually show the divs. */ this.debug = false;
        /** Internal variable, see isActive getter. */ this._isActive = false;
        /** Internal variable, see isMobileAccessibility getter. */ this._isMobileAccessibility = false;
        /** A simple pool for storing divs. */ this.pool = [];
        /** This is a tick used to check if an object is no longer being rendered. */ this.renderId = 0;
        /** The array of currently active accessible items. */ this.children = [];
        /** Count to throttle div updates on android devices. */ this.androidUpdateCount = 0;
        /**  The frequency to update the div elements. */ this.androidUpdateFrequency = 500; // 2fps
        this._hookDiv = null;
        if ((0, $ezJmd.isMobile).tablet || (0, $ezJmd.isMobile).phone) this.createTouchHook();
        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
        var div = document.createElement('div');
        div.style.width = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
        div.style.height = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
        div.style.position = 'absolute';
        div.style.top = $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_X + "px";
        div.style.left = $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_Y + "px";
        div.style.zIndex = $7ffa08e1ea5f4c07$var$DIV_TOUCH_ZINDEX.toString();
        this.div = div;
        this.renderer = renderer;
        /**
         * pre-bind the functions
         *
         * @type {Function}
         * @private
         */ this._onKeyDown = this._onKeyDown.bind(this);
        /**
         * pre-bind the functions
         *
         * @type {Function}
         * @private
         */ this._onMouseMove = this._onMouseMove.bind(this);
        // let listen for tab.. once pressed we can fire up and show the accessibility layer
        self.addEventListener('keydown', this._onKeyDown, false);
    }
    Object.defineProperty(AccessibilityManager.prototype, "isActive", {
        /**
         * Value of `true` if accessibility is currently active and accessibility layers are showing.
         * @member {boolean}
         * @readonly
         */ get: function() {
            return this._isActive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessibilityManager.prototype, "isMobileAccessibility", {
        /**
         * Value of `true` if accessibility is enabled for touch devices.
         * @member {boolean}
         * @readonly
         */ get: function() {
            return this._isMobileAccessibility;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates the touch hooks.
     *
     * @private
     */ AccessibilityManager.prototype.createTouchHook = function() {
        var _this = this;
        var hookDiv = document.createElement('button');
        hookDiv.style.width = $7ffa08e1ea5f4c07$var$DIV_HOOK_SIZE + "px";
        hookDiv.style.height = $7ffa08e1ea5f4c07$var$DIV_HOOK_SIZE + "px";
        hookDiv.style.position = 'absolute';
        hookDiv.style.top = $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_X + "px";
        hookDiv.style.left = $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_Y + "px";
        hookDiv.style.zIndex = $7ffa08e1ea5f4c07$var$DIV_HOOK_ZINDEX.toString();
        hookDiv.style.backgroundColor = '#FF0000';
        hookDiv.title = 'select to enable accessibility for this content';
        hookDiv.addEventListener('focus', function() {
            _this._isMobileAccessibility = true;
            _this.activate();
            _this.destroyTouchHook();
        });
        document.body.appendChild(hookDiv);
        this._hookDiv = hookDiv;
    };
    /**
     * Destroys the touch hooks.
     *
     * @private
     */ AccessibilityManager.prototype.destroyTouchHook = function() {
        if (!this._hookDiv) return;
        document.body.removeChild(this._hookDiv);
        this._hookDiv = null;
    };
    /**
     * Activating will cause the Accessibility layer to be shown.
     * This is called when a user presses the tab key.
     *
     * @private
     */ AccessibilityManager.prototype.activate = function() {
        var _a;
        if (this._isActive) return;
        this._isActive = true;
        self.document.addEventListener('mousemove', this._onMouseMove, true);
        self.removeEventListener('keydown', this._onKeyDown, false);
        this.renderer.on('postrender', this.update, this);
        (_a = this.renderer.view.parentNode) === null || _a === void 0 || _a.appendChild(this.div);
    };
    /**
     * Deactivating will cause the Accessibility layer to be hidden.
     * This is called when a user moves the mouse.
     *
     * @private
     */ AccessibilityManager.prototype.deactivate = function() {
        var _a;
        if (!this._isActive || this._isMobileAccessibility) return;
        this._isActive = false;
        self.document.removeEventListener('mousemove', this._onMouseMove, true);
        self.addEventListener('keydown', this._onKeyDown, false);
        this.renderer.off('postrender', this.update);
        (_a = this.div.parentNode) === null || _a === void 0 || _a.removeChild(this.div);
    };
    /**
     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
     *
     * @private
     * @param {PIXI.Container} displayObject - The DisplayObject to check.
     */ AccessibilityManager.prototype.updateAccessibleObjects = function(displayObject) {
        if (!displayObject.visible || !displayObject.accessibleChildren) return;
        if (displayObject.accessible && displayObject.interactive) {
            if (!displayObject._accessibleActive) this.addChild(displayObject);
            displayObject.renderId = this.renderId;
        }
        var children = displayObject.children;
        if (children) for(var i = 0; i < children.length; i++)this.updateAccessibleObjects(children[i]);
    };
    /**
     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
     *
     * @private
     */ AccessibilityManager.prototype.update = function() {
        /* On Android default web browser, tab order seems to be calculated by position rather than tabIndex,
        *  moving buttons can cause focus to flicker between two buttons making it hard/impossible to navigate,
        *  so I am just running update every half a second, seems to fix it.
        */ var now = performance.now();
        if ((0, $ezJmd.isMobile).android.device && now < this.androidUpdateCount) return;
        this.androidUpdateCount = now + this.androidUpdateFrequency;
        if (!this.renderer.renderingToScreen) return;
        // update children...
        if (this.renderer._lastObjectRendered) this.updateAccessibleObjects(this.renderer._lastObjectRendered);
        var _a = this.renderer.view.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
        var _b = this.renderer, viewWidth = _b.width, viewHeight = _b.height, resolution = _b.resolution;
        var sx = width / viewWidth * resolution;
        var sy = height / viewHeight * resolution;
        var div = this.div;
        div.style.left = left + "px";
        div.style.top = top + "px";
        div.style.width = viewWidth + "px";
        div.style.height = viewHeight + "px";
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            if (child.renderId !== this.renderId) {
                child._accessibleActive = false;
                (0, $csytw.removeItems)(this.children, i, 1);
                this.div.removeChild(child._accessibleDiv);
                this.pool.push(child._accessibleDiv);
                child._accessibleDiv = null;
                i--;
            } else {
                // map div to display..
                div = child._accessibleDiv;
                var hitArea = child.hitArea;
                var wt = child.worldTransform;
                if (child.hitArea) {
                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + "px";
                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + "px";
                    div.style.width = hitArea.width * wt.a * sx + "px";
                    div.style.height = hitArea.height * wt.d * sy + "px";
                } else {
                    hitArea = child.getBounds();
                    this.capHitArea(hitArea);
                    div.style.left = hitArea.x * sx + "px";
                    div.style.top = hitArea.y * sy + "px";
                    div.style.width = hitArea.width * sx + "px";
                    div.style.height = hitArea.height * sy + "px";
                    // update button titles and hints if they exist and they've changed
                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) div.title = child.accessibleTitle;
                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) div.setAttribute('aria-label', child.accessibleHint);
                }
                // the title or index may have changed, if so lets update it!
                if (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) {
                    div.title = child.accessibleTitle;
                    div.tabIndex = child.tabIndex;
                    if (this.debug) this.updateDebugHTML(div);
                }
            }
        }
        // increment the render id..
        this.renderId++;
    };
    /**
     * private function that will visually add the information to the
     * accessability div
     *
     * @param {HTMLElement} div
     */ AccessibilityManager.prototype.updateDebugHTML = function(div) {
        div.innerHTML = "type: " + div.type + "</br> title : " + div.title + "</br> tabIndex: " + div.tabIndex;
    };
    /**
     * Adjust the hit area based on the bounds of a display object
     *
     * @param {PIXI.Rectangle} hitArea - Bounds of the child
     */ AccessibilityManager.prototype.capHitArea = function(hitArea) {
        if (hitArea.x < 0) {
            hitArea.width += hitArea.x;
            hitArea.x = 0;
        }
        if (hitArea.y < 0) {
            hitArea.height += hitArea.y;
            hitArea.y = 0;
        }
        var _a = this.renderer, viewWidth = _a.width, viewHeight = _a.height;
        if (hitArea.x + hitArea.width > viewWidth) hitArea.width = viewWidth - hitArea.x;
        if (hitArea.y + hitArea.height > viewHeight) hitArea.height = viewHeight - hitArea.y;
    };
    /**
     * Adds a DisplayObject to the accessibility manager
     *
     * @private
     * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
     */ AccessibilityManager.prototype.addChild = function(displayObject) {
        //    this.activate();
        var div = this.pool.pop();
        if (!div) {
            div = document.createElement('button');
            div.style.width = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
            div.style.height = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
            div.style.backgroundColor = this.debug ? 'rgba(255,255,255,0.5)' : 'transparent';
            div.style.position = 'absolute';
            div.style.zIndex = $7ffa08e1ea5f4c07$var$DIV_TOUCH_ZINDEX.toString();
            div.style.borderStyle = 'none';
            // ARIA attributes ensure that button title and hint updates are announced properly
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
            div.setAttribute('aria-live', 'off');
            else div.setAttribute('aria-live', 'polite');
            if (navigator.userAgent.match(/rv:.*Gecko\//)) // FireFox needs this to announce only the new button name
            div.setAttribute('aria-relevant', 'additions');
            else // required by IE, other browsers don't much care
            div.setAttribute('aria-relevant', 'text');
            div.addEventListener('click', this._onClick.bind(this));
            div.addEventListener('focus', this._onFocus.bind(this));
            div.addEventListener('focusout', this._onFocusOut.bind(this));
        }
        // set pointer events
        div.style.pointerEvents = displayObject.accessiblePointerEvents;
        // set the type, this defaults to button!
        div.type = displayObject.accessibleType;
        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) div.title = displayObject.accessibleTitle;
        else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) div.title = "displayObject " + displayObject.tabIndex;
        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) div.setAttribute('aria-label', displayObject.accessibleHint);
        if (this.debug) this.updateDebugHTML(div);
        displayObject._accessibleActive = true;
        displayObject._accessibleDiv = div;
        div.displayObject = displayObject;
        this.children.push(displayObject);
        this.div.appendChild(displayObject._accessibleDiv);
        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    };
    /**
     * Maps the div button press to pixi's InteractionManager (click)
     *
     * @private
     * @param {MouseEvent} e - The click event.
     */ AccessibilityManager.prototype._onClick = function(e) {
        var interactionManager = this.renderer.plugins.interaction;
        var displayObject = e.target.displayObject;
        var eventData = interactionManager.eventData;
        interactionManager.dispatchEvent(displayObject, 'click', eventData);
        interactionManager.dispatchEvent(displayObject, 'pointertap', eventData);
        interactionManager.dispatchEvent(displayObject, 'tap', eventData);
    };
    /**
     * Maps the div focus events to pixi's InteractionManager (mouseover)
     *
     * @private
     * @param {FocusEvent} e - The focus event.
     */ AccessibilityManager.prototype._onFocus = function(e) {
        if (!e.target.getAttribute('aria-live')) e.target.setAttribute('aria-live', 'assertive');
        var interactionManager = this.renderer.plugins.interaction;
        var displayObject = e.target.displayObject;
        var eventData = interactionManager.eventData;
        interactionManager.dispatchEvent(displayObject, 'mouseover', eventData);
    };
    /**
     * Maps the div focus events to pixi's InteractionManager (mouseout)
     *
     * @private
     * @param {FocusEvent} e - The focusout event.
     */ AccessibilityManager.prototype._onFocusOut = function(e) {
        if (!e.target.getAttribute('aria-live')) e.target.setAttribute('aria-live', 'polite');
        var interactionManager = this.renderer.plugins.interaction;
        var displayObject = e.target.displayObject;
        var eventData = interactionManager.eventData;
        interactionManager.dispatchEvent(displayObject, 'mouseout', eventData);
    };
    /**
     * Is called when a key is pressed
     *
     * @private
     * @param {KeyboardEvent} e - The keydown event.
     */ AccessibilityManager.prototype._onKeyDown = function(e) {
        if (e.keyCode !== $7ffa08e1ea5f4c07$var$KEY_CODE_TAB) return;
        this.activate();
    };
    /**
     * Is called when the mouse moves across the renderer element
     *
     * @private
     * @param {MouseEvent} e - The mouse event.
     */ AccessibilityManager.prototype._onMouseMove = function(e) {
        if (e.movementX === 0 && e.movementY === 0) return;
        this.deactivate();
    };
    /**
     * Destroys the accessibility manager
     *
     */ AccessibilityManager.prototype.destroy = function() {
        this.destroyTouchHook();
        this.div = null;
        self.document.removeEventListener('mousemove', this._onMouseMove, true);
        self.removeEventListener('keydown', this._onKeyDown);
        this.pool = null;
        this.children = null;
        this.renderer = null;
    };
    return AccessibilityManager;
}();

});
parcelRegister("8t5Gy", function(module, exports) {

$parcel$export(module.exports, "Bounds", function () { return $62a57129ee044f79$export$c4e9d269599ab4b4; });
$parcel$export(module.exports, "DisplayObject", function () { return $62a57129ee044f79$export$1f679544f90d7d7c; });
$parcel$export(module.exports, "TemporaryDisplayObject", function () { return $62a57129ee044f79$export$a35515d77cade20d; });
$parcel$export(module.exports, "Container", function () { return $62a57129ee044f79$export$42a852a2b6b56249; });
/*!
 * @pixi/display - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/display is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $6qzqq = parcelRequire("6qzqq");
parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");
var $csytw = parcelRequire("csytw");
/**
 * Sets the default value for the container property 'sortableChildren'.
 * If set to true, the container will sort its children by zIndex value
 * when updateTransform() is called, or manually if sortChildren() is called.
 *
 * This actually changes the order of elements in the array, so should be treated
 * as a basic solution that is not performant compared to other solutions,
 * such as @link https://github.com/pixijs/pixi-display
 *
 * Also be aware of that this may not work nicely with the addChildAt() function,
 * as the zIndex sorting may cause the child to automatically sorted to another position.
 *
 * @static
 * @constant
 * @name SORTABLE_CHILDREN
 * @memberof PIXI.settings
 * @type {boolean}
 * @default false
 */ (0, $ezJmd.settings).SORTABLE_CHILDREN = false;
/**
 * 'Builder' pattern for bounds rectangles.
 *
 * This could be called an Axis-Aligned Bounding Box.
 * It is not an actual shape. It is a mutable thing; no 'EMPTY' or those kind of problems.
 *
 * @class
 * @memberof PIXI
 */ var $62a57129ee044f79$export$c4e9d269599ab4b4 = /** @class */ function() {
    function Bounds() {
        /**
         * @member {number}
         * @default 0
         */ this.minX = Infinity;
        /**
         * @member {number}
         * @default 0
         */ this.minY = Infinity;
        /**
         * @member {number}
         * @default 0
         */ this.maxX = -Infinity;
        /**
         * @member {number}
         * @default 0
         */ this.maxY = -Infinity;
        this.rect = null;
        /**
         * It is updated to _boundsID of corresponding object to keep bounds in sync with content.
         * Updated from outside, thus public modifier.
         *
         * @member {number}
         * @public
         */ this.updateID = -1;
    }
    /**
     * Checks if bounds are empty.
     *
     * @return {boolean} True if empty.
     */ Bounds.prototype.isEmpty = function() {
        return this.minX > this.maxX || this.minY > this.maxY;
    };
    /**
     * Clears the bounds and resets.
     *
     */ Bounds.prototype.clear = function() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
    };
    /**
     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
     * It is not guaranteed that it will return tempRect
     *
     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
     * @returns {PIXI.Rectangle} A rectangle of the bounds
     */ Bounds.prototype.getRectangle = function(rect) {
        if (this.minX > this.maxX || this.minY > this.maxY) return (0, $6qzqq.Rectangle).EMPTY;
        rect = rect || new (0, $6qzqq.Rectangle)(0, 0, 1, 1);
        rect.x = this.minX;
        rect.y = this.minY;
        rect.width = this.maxX - this.minX;
        rect.height = this.maxY - this.minY;
        return rect;
    };
    /**
     * This function should be inlined when its possible.
     *
     * @param {PIXI.IPointData} point - The point to add.
     */ Bounds.prototype.addPoint = function(point) {
        this.minX = Math.min(this.minX, point.x);
        this.maxX = Math.max(this.maxX, point.x);
        this.minY = Math.min(this.minY, point.y);
        this.maxY = Math.max(this.maxY, point.y);
    };
    /**
     * Adds a point, after transformed. This should be inlined when its possible.
     *
     * @param matrix
     * @param point
     */ Bounds.prototype.addPointMatrix = function(matrix, point) {
        var a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        var x = a * point.x + c * point.y + tx;
        var y = b * point.x + d * point.y + ty;
        this.minX = Math.min(this.minX, x);
        this.maxX = Math.max(this.maxX, x);
        this.minY = Math.min(this.minY, y);
        this.maxY = Math.max(this.maxY, y);
    };
    /**
     * Adds a quad, not transformed
     *
     * @param {Float32Array} vertices - The verts to add.
     */ Bounds.prototype.addQuad = function(vertices) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        var x = vertices[0];
        var y = vertices[1];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[2];
        y = vertices[3];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[4];
        y = vertices[5];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[6];
        y = vertices[7];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Adds sprite frame, transformed.
     *
     * @param {PIXI.Transform} transform - transform to apply
     * @param {number} x0 - left X of frame
     * @param {number} y0 - top Y of frame
     * @param {number} x1 - right X of frame
     * @param {number} y1 - bottom Y of frame
     */ Bounds.prototype.addFrame = function(transform, x0, y0, x1, y1) {
        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
    };
    /**
     * Adds sprite frame, multiplied by matrix
     *
     * @param {PIXI.Matrix} matrix - matrix to apply
     * @param {number} x0 - left X of frame
     * @param {number} y0 - top Y of frame
     * @param {number} x1 - right X of frame
     * @param {number} y1 - bottom Y of frame
     */ Bounds.prototype.addFrameMatrix = function(matrix, x0, y0, x1, y1) {
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        var x = a * x0 + c * y0 + tx;
        var y = b * x0 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Adds screen vertices from array
     *
     * @param {Float32Array} vertexData - calculated vertices
     * @param {number} beginOffset - begin offset
     * @param {number} endOffset - end offset, excluded
     */ Bounds.prototype.addVertexData = function(vertexData, beginOffset, endOffset) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        for(var i = beginOffset; i < endOffset; i += 2){
            var x = vertexData[i];
            var y = vertexData[i + 1];
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Add an array of mesh vertices
     *
     * @param {PIXI.Transform} transform - mesh transform
     * @param {Float32Array} vertices - mesh coordinates in array
     * @param {number} beginOffset - begin offset
     * @param {number} endOffset - end offset, excluded
     */ Bounds.prototype.addVertices = function(transform, vertices, beginOffset, endOffset) {
        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
    };
    /**
     * Add an array of mesh vertices.
     *
     * @param {PIXI.Matrix} matrix - mesh matrix
     * @param {Float32Array} vertices - mesh coordinates in array
     * @param {number} beginOffset - begin offset
     * @param {number} endOffset - end offset, excluded
     * @param {number} [padX=0] - x padding
     * @param {number} [padY=0] - y padding
     */ Bounds.prototype.addVerticesMatrix = function(matrix, vertices, beginOffset, endOffset, padX, padY) {
        if (padX === void 0) padX = 0;
        if (padY === void 0) padY = padX;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        for(var i = beginOffset; i < endOffset; i += 2){
            var rawX = vertices[i];
            var rawY = vertices[i + 1];
            var x = a * rawX + c * rawY + tx;
            var y = d * rawY + b * rawX + ty;
            minX = Math.min(minX, x - padX);
            maxX = Math.max(maxX, x + padX);
            minY = Math.min(minY, y - padY);
            maxY = Math.max(maxY, y + padY);
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Adds other Bounds.
     *
     * @param {PIXI.Bounds} bounds - The Bounds to be added
     */ Bounds.prototype.addBounds = function(bounds) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        this.minX = bounds.minX < minX ? bounds.minX : minX;
        this.minY = bounds.minY < minY ? bounds.minY : minY;
        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    };
    /**
     * Adds other Bounds, masked with Bounds.
     *
     * @param {PIXI.Bounds} bounds - The Bounds to be added.
     * @param {PIXI.Bounds} mask - TODO
     */ Bounds.prototype.addBoundsMask = function(bounds, mask) {
        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };
    /**
     * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
     *
     * @param {PIXI.Bounds} bounds - other bounds
     * @param {PIXI.Matrix} matrix - multiplicator
     */ Bounds.prototype.addBoundsMatrix = function(bounds, matrix) {
        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
    };
    /**
     * Adds other Bounds, masked with Rectangle.
     *
     * @param {PIXI.Bounds} bounds - TODO
     * @param {PIXI.Rectangle} area - TODO
     */ Bounds.prototype.addBoundsArea = function(bounds, area) {
        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };
    /**
     * Pads bounds object, making it grow in all directions.
     * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
     *
     * @param {number} [paddingX=0] - The horizontal padding amount.
     * @param {number} [paddingY=0] - The vertical padding amount.
     */ Bounds.prototype.pad = function(paddingX, paddingY) {
        if (paddingX === void 0) paddingX = 0;
        if (paddingY === void 0) paddingY = paddingX;
        if (!this.isEmpty()) {
            this.minX -= paddingX;
            this.maxX += paddingX;
            this.minY -= paddingY;
            this.maxY += paddingY;
        }
    };
    /**
     * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
     *
     * @param {number} x0 - left X of frame
     * @param {number} y0 - top Y of frame
     * @param {number} x1 - right X of frame
     * @param {number} y1 - bottom Y of frame
     * @param {number} padX - padding X
     * @param {number} padY - padding Y
     */ Bounds.prototype.addFramePad = function(x0, y0, x1, y1, padX, padY) {
        x0 -= padX;
        y0 -= padY;
        x1 += padX;
        y1 += padY;
        this.minX = this.minX < x0 ? this.minX : x0;
        this.maxX = this.maxX > x1 ? this.maxX : x1;
        this.minY = this.minY < y0 ? this.minY : y0;
        this.maxY = this.maxY > y1 ? this.maxY : y1;
    };
    return Bounds;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $62a57129ee044f79$var$extendStatics = function(d, b) {
    $62a57129ee044f79$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $62a57129ee044f79$var$extendStatics(d, b);
};
function $62a57129ee044f79$var$__extends(d, b) {
    $62a57129ee044f79$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * The base class for all objects that are rendered on the screen.
 *
 * This is an abstract class and can not be used on its own; rather it should be extended.
 *
 * ## Display objects implemented in PixiJS
 *
 * | Display Object                  | Description                                                           |
 * | ------------------------------- | --------------------------------------------------------------------- |
 * | {@link PIXI.Container}          | Adds support for `children` to DisplayObject                          |
 * | {@link PIXI.Graphics}           | Shape-drawing display object similar to the Canvas API                |
 * | {@link PIXI.Sprite}             | Draws textures (i.e. images)                                          |
 * | {@link PIXI.Text}               | Draws text using the Canvas API internally                            |
 * | {@link PIXI.BitmapText}         | More scaleable solution for text rendering, reusing glyph textures    |
 * | {@link PIXI.TilingSprite}       | Draws textures/images in a tiled fashion                              |
 * | {@link PIXI.AnimatedSprite}     | Draws an animation of multiple images                                 |
 * | {@link PIXI.Mesh}               | Provides a lower-level API for drawing meshes with custom data        |
 * | {@link PIXI.NineSlicePlane}     | Mesh-related                                                          |
 * | {@link PIXI.SimpleMesh}         | v4-compatible mesh                                                    |
 * | {@link PIXI.SimplePlane}        | Mesh-related                                                          |
 * | {@link PIXI.SimpleRope}         | Mesh-related                                                          |
 *
 * ## Transforms
 *
 * The [transform]{@link DisplayObject#transform} of a display object describes the projection from its
 * local coordinate space to its parent's local coordinate space. The following properties are derived
 * from the transform:
 *
 * <table>
 *   <thead>
 *     <tr>
 *       <th>Property</th>
 *       <th>Description</th>
 *     </tr>
 *   </thead>
 *   <tbody>
 *     <tr>
 *       <td>[pivot]{@link PIXI.DisplayObject#pivot}</td>
 *       <td>
 *         Invariant under rotation, scaling, and skewing. The projection of into the parent's space of the pivot
 *         is equal to position, regardless of the other three transformations. In other words, It is the center of
 *         rotation, scaling, and skewing.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[position]{@link PIXI.DisplayObject#position}</td>
 *       <td>
 *         Translation. This is the position of the [pivot]{@link PIXI.DisplayObject#pivot} in the parent's local
 *         space. The default value of the pivot is the origin (0,0). If the top-left corner of your display object
 *         is (0,0) in its local space, then the position will be its top-left corner in the parent's local space.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[scale]{@link PIXI.DisplayObject#scale}</td>
 *       <td>
 *         Scaling. This will stretch (or compress) the display object's projection. The scale factors are along the
 *         local coordinate axes. In other words, the display object is scaled before rotated or skewed. The center
 *         of scaling is the [pivot]{@link PIXI.DisplayObject#pivot}.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[rotation]{@link PIXI.DisplayObject#rotation}</td>
 *       <td>
 *          Rotation. This will rotate the display object's projection by this angle (in radians).
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[skew]{@link PIXI.DisplayObject#skew}</td>
 *       <td>
 *         <p>Skewing. This can be used to deform a rectangular display object into a parallelogram.</p>
 *         <p>
 *         In PixiJS, skew has a slightly different behaviour than the conventional meaning. It can be
 *         thought of the net rotation applied to the coordinate axes (separately). For example, if "skew.x" is
 *         ⍺ and "skew.y" is β, then the line x = 0 will be rotated by ⍺ (y = -x*cot⍺) and the line y = 0 will be
 *         rotated by β (y = x*tanβ). A line y = x*tanϴ (i.e. a line at angle ϴ to the x-axis in local-space) will
 *         be rotated by an angle between ⍺ and β.
 *         </p>
 *         <p>
 *         It can be observed that if skew is applied equally to both axes, then it will be equivalent to applying
 *         a rotation. Indeed, if "skew.x" = -ϴ and "skew.y" = ϴ, it will produce an equivalent of "rotation" = ϴ.
 *         </p>
 *         <p>
 *         Another quite interesting observation is that "skew.x", "skew.y", rotation are communtative operations. Indeed,
 *         because rotation is essentially a careful combination of the two.
 *         </p>
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>angle</td>
 *       <td>Rotation. This is an alias for [rotation]{@link PIXI.DisplayObject#rotation}, but in degrees.</td>
 *     </tr>
 *     <tr>
 *       <td>x</td>
 *       <td>Translation. This is an alias for position.x!</td>
 *     </tr>
 *     <tr>
 *       <td>y</td>
 *       <td>Translation. This is an alias for position.y!</td>
 *     </tr>
 *     <tr>
 *       <td>width</td>
 *       <td>
 *         Implemented in [Container]{@link PIXI.Container}. Scaling. The width property calculates scale.x by dividing
 *         the "requested" width by the local bounding box width. It is indirectly an abstraction over scale.x, and there
 *         is no concept of user-defined width.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>height</td>
 *       <td>
 *         Implemented in [Container]{@link PIXI.Container}. Scaling. The height property calculates scale.y by dividing
 *         the "requested" height by the local bounding box height. It is indirectly an abstraction over scale.y, and there
 *         is no concept of user-defined height.
 *       </td>
 *     </tr>
 *   </tbody>
 * </table>
 *
 * ## Bounds
 *
 * The bounds of a display object is defined by the minimum axis-aligned rectangle in world space that can fit
 * around it. The abstract `calculateBounds` method is responsible for providing it (and it should use the
 * `worldTransform` to calculate in world space).
 *
 * There are a few additional types of bounding boxes:
 *
 * | Bounds                | Description                                                                              |
 * | --------------------- | ---------------------------------------------------------------------------------------- |
 * | World Bounds          | This is synonymous is the regular bounds described above. See `getBounds()`.             |
 * | Local Bounds          | This the axis-aligned bounding box in the parent's local space. See `getLocalBounds()`.  |
 * | Render Bounds         | The bounds, but including extra rendering effects like filter padding.                   |
 * | Projected Bounds      | The bounds of the projected display object onto the screen. Usually equals world bounds. |
 * | Relative Bounds       | The bounds of a display object when projected onto a ancestor's (or parent's) space.     |
 * | Natural Bounds        | The bounds of an object in its own local space (not parent's space, like in local bounds)|
 * | Content Bounds        | The natural bounds when excluding all children of a `Container`.                         |
 *
 * ### calculateBounds
 *
 * [Container]{@link Container} already implements `calculateBounds` in a manner that includes children.
 *
 * But for a non-Container display object, the `calculateBounds` method must be overridden in order for `getBounds` and
 * `getLocalBounds` to work. This method must write the bounds into `this._bounds`.
 *
 * Generally, the following technique works for most simple cases: take the list of points
 * forming the "hull" of the object (i.e. outline of the object's shape), and then add them
 * using {@link PIXI.Bounds#addPointMatrix}.
 *
 * ```js
 * calculateBounds(): void
 * {
 *     const points = [...];
 *
 *     for (let i = 0, j = points.length; i < j; i++)
 *     {
 *         this._bounds.addPointMatrix(this.worldTransform, points[i]);
 *     }
 * }
 * ```
 *
 * You can optimize this for a large number of points by using {@link PIXI.Bounds#addVerticesMatrix} to pass them
 * in one array together.
 *
 * ## Alpha
 *
 * This alpha sets a display object's **relative opacity** w.r.t its parent. For example, if the alpha of a display
 * object is 0.5 and its parent's alpha is 0.5, then it will be rendered with 25% opacity (assuming alpha is not
 * applied on any ancestor further up the chain).
 *
 * The alpha with which the display object will be rendered is called the [worldAlpha]{@link PIXI.DisplayObject#worldAlpha}.
 *
 * ## Renderable vs Visible
 *
 * The `renderable` and `visible` properties can be used to prevent a display object from being rendered to the
 * screen. However, there is a subtle difference between the two. When using `renderable`, the transforms  of the display
 * object (and its children subtree) will continue to be calculated. When using `visible`, the transforms will not
 * be calculated.
 *
 * It is recommended that applications use the `renderable` property for culling. See
 * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} or
 * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull} for more details.
 *
 * Otherwise, to prevent an object from rendering in the general-purpose sense - `visible` is the property to use. This
 * one is also better in terms of performance.
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 */ var $62a57129ee044f79$export$1f679544f90d7d7c = /** @class */ function(_super) {
    $62a57129ee044f79$var$__extends(DisplayObject, _super);
    function DisplayObject() {
        var _this = _super.call(this) || this;
        _this.tempDisplayObjectParent = null;
        // TODO: need to create Transform from factory
        /**
         * World transform and local transform of this object.
         * This will become read-only later, please do not assign anything there unless you know what are you doing.
         *
         * @member {PIXI.Transform}
         */ _this.transform = new (0, $6qzqq.Transform)();
        /**
         * The opacity of the object.
         *
         * @member {number}
         */ _this.alpha = 1;
        /**
         * The visibility of the object. If false the object will not be drawn, and
         * the updateTransform function will not be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually.
         *
         * @member {boolean}
         */ _this.visible = true;
        /**
         * Can this object be rendered, if false the object will not be drawn but the updateTransform
         * methods will still be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds manually.
         *
         * @member {boolean}
         */ _this.renderable = true;
        /**
         * The display object container that contains this display object.
         *
         * @member {PIXI.Container}
         */ _this.parent = null;
        /**
         * The multiplied alpha of the displayObject.
         *
         * @member {number}
         * @readonly
         */ _this.worldAlpha = 1;
        /**
         * Which index in the children array the display component was before the previous zIndex sort.
         * Used by containers to help sort objects with the same zIndex, by using previous array index as the decider.
         *
         * @member {number}
         * @protected
         */ _this._lastSortedIndex = 0;
        /**
         * The zIndex of the displayObject.
         * A higher value will mean it will be rendered on top of other displayObjects within the same container.
         *
         * @member {number}
         * @protected
         */ _this._zIndex = 0;
        /**
         * The area the filter is applied to. This is used as more of an optimization
         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
         *
         * Also works as an interaction mask.
         *
         * @member {?PIXI.Rectangle}
         */ _this.filterArea = null;
        /**
         * Sets the filters for the displayObject.
         * * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
         * To remove filters simply set this property to `'null'`.
         *
         * @member {?PIXI.Filter[]}
         */ _this.filters = null;
        /**
         * Currently enabled filters
         * @member {PIXI.Filter[]}
         * @protected
         */ _this._enabledFilters = null;
        /**
         * The bounds object, this is used to calculate and store the bounds of the displayObject.
         *
         * @member {PIXI.Bounds}
         */ _this._bounds = new $62a57129ee044f79$export$c4e9d269599ab4b4();
        /**
         * Local bounds object, swapped with `_bounds` when using `getLocalBounds()`.
         *
         * @member {PIXI.Bounds}
         */ _this._localBounds = null;
        /**
         * Flags the cached bounds as dirty.
         *
         * @member {number}
         * @protected
         */ _this._boundsID = 0;
        /**
         * Cache of this display-object's bounds-rectangle.
         *
         * @member {PIXI.Bounds}
         * @protected
         */ _this._boundsRect = null;
        /**
         * Cache of this display-object's local-bounds rectangle.
         *
         * @member {PIXI.Bounds}
         * @protected
         */ _this._localBoundsRect = null;
        /**
         * The original, cached mask of the object.
         *
         * @member {PIXI.Container|PIXI.MaskData|null}
         * @protected
         */ _this._mask = null;
        /**
         * The number of times this object is used as a mask by another object.
         *
         * @member {number}
         * @private
         */ _this._maskRefCount = 0;
        /**
         * If the object has been destroyed via destroy(). If true, it should not be used.
         *
         * @member {boolean}
         * @protected
         */ _this._destroyed = false;
        /**
         * used to fast check if a sprite is.. a sprite!
         * @member {boolean}
         */ _this.isSprite = false;
        /**
         * Does any other displayObject use this object as a mask?
         * @member {boolean}
         */ _this.isMask = false;
        return _this;
    }
    /**
     * Mixes all enumerable properties and methods from a source object to DisplayObject.
     *
     * @param {object} source - The source of properties and methods to mix in.
     */ DisplayObject.mixin = function(source) {
        // in ES8/ES2017, this would be really easy:
        // Object.defineProperties(DisplayObject.prototype, Object.getOwnPropertyDescriptors(source));
        // get all the enumerable property keys
        var keys = Object.keys(source);
        // loop through properties
        for(var i = 0; i < keys.length; ++i){
            var propertyName = keys[i];
            // Set the property using the property descriptor - this works for accessors and normal value properties
            Object.defineProperty(DisplayObject.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    };
    Object.defineProperty(DisplayObject.prototype, "destroyed", {
        /**
         * Fired when this DisplayObject is added to a Container.
         *
         * @instance
         * @event added
         * @param {PIXI.Container} container - The container added to.
         */ /**
         * Fired when this DisplayObject is removed from a Container.
         *
         * @instance
         * @event removed
         * @param {PIXI.Container} container - The container removed from.
         */ /**
         * Fired when this DisplayObject is destroyed.
         *
         * @instance
         * @event destroyed
         */ /**
         * Readonly flag for destroyed display objects.
         */ get: function() {
            return this._destroyed;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Recursively updates transform of all objects from the root to this one
     * internal function for toLocal()
     */ DisplayObject.prototype._recursivePostUpdateTransform = function() {
        if (this.parent) {
            this.parent._recursivePostUpdateTransform();
            this.transform.updateTransform(this.parent.transform);
        } else this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    };
    /**
     * Updates the object transform for rendering.
     *
     * TODO - Optimization pass!
     */ DisplayObject.prototype.updateTransform = function() {
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        // multiply the alphas..
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
    };
    /**
     * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
     *
     * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
     * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
     * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
     * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
     * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
     * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
     * its height increases.
     *
     * * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
     * * The world bounds of all display objects in a container's **subtree** will also be recalculated.
     *
     * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
     * calculation if needed.
     *
     * ```js
     * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
     * ```
     *
     * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
     * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
     * details.
     *
     * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
     * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
     * cases.
     *
     * @param {boolean} [skipUpdate] - Setting to `true` will stop the transforms of the scene graph from
     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
     *  nice performance boost.
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
     * @return {PIXI.Rectangle} The minimum axis-aligned rectangle in world space that fits around this object.
     */ DisplayObject.prototype.getBounds = function(skipUpdate, rect) {
        if (!skipUpdate) {
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.updateTransform();
                this.parent = null;
            } else {
                this._recursivePostUpdateTransform();
                this.updateTransform();
            }
        }
        if (this._bounds.updateID !== this._boundsID) {
            this.calculateBounds();
            this._bounds.updateID = this._boundsID;
        }
        if (!rect) {
            if (!this._boundsRect) this._boundsRect = new (0, $6qzqq.Rectangle)();
            rect = this._boundsRect;
        }
        return this._bounds.getRectangle(rect);
    };
    /**
     * Retrieves the local bounds of the displayObject as a rectangle object.
     *
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
     * @return {PIXI.Rectangle} The rectangular bounding area.
     */ DisplayObject.prototype.getLocalBounds = function(rect) {
        if (!rect) {
            if (!this._localBoundsRect) this._localBoundsRect = new (0, $6qzqq.Rectangle)();
            rect = this._localBoundsRect;
        }
        if (!this._localBounds) this._localBounds = new $62a57129ee044f79$export$c4e9d269599ab4b4();
        var transformRef = this.transform;
        var parentRef = this.parent;
        this.parent = null;
        this.transform = this._tempDisplayObjectParent.transform;
        var worldBounds = this._bounds;
        var worldBoundsID = this._boundsID;
        this._bounds = this._localBounds;
        var bounds = this.getBounds(false, rect);
        this.parent = parentRef;
        this.transform = transformRef;
        this._bounds = worldBounds;
        this._bounds.updateID += this._boundsID - worldBoundsID; // reflect side-effects
        return bounds;
    };
    /**
     * Calculates the global position of the display object.
     *
     * @param {PIXI.IPointData} position - The world origin to calculate from.
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point).
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
     * @return {PIXI.Point} A point object representing the position of this object.
     */ DisplayObject.prototype.toGlobal = function(position, point, skipUpdate) {
        if (skipUpdate === void 0) skipUpdate = false;
        if (!skipUpdate) {
            this._recursivePostUpdateTransform();
            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else this.displayObjectUpdateTransform();
        }
        // don't need to update the lot
        return this.worldTransform.apply(position, point);
    };
    /**
     * Calculates the local position of the display object relative to another point.
     *
     * @param {PIXI.IPointData} position - The world origin to calculate from.
     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from.
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point).
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
     * @return {PIXI.Point} A point object representing the position of this object
     */ DisplayObject.prototype.toLocal = function(position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        if (!skipUpdate) {
            this._recursivePostUpdateTransform();
            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else this.displayObjectUpdateTransform();
        }
        // simply apply the matrix..
        return this.worldTransform.applyInverse(position, point);
    };
    /**
     * Set the parent Container of this DisplayObject.
     *
     * @param {PIXI.Container} container - The Container to add this DisplayObject to.
     * @return {PIXI.Container} The Container that this DisplayObject was added to.
     */ DisplayObject.prototype.setParent = function(container) {
        if (!container || !container.addChild) throw new Error('setParent: Argument must be a Container');
        container.addChild(this);
        return container;
    };
    /**
     * Convenience function to set the position, scale, skew and pivot at once.
     *
     * @param {number} [x=0] - The X position
     * @param {number} [y=0] - The Y position
     * @param {number} [scaleX=1] - The X scale value
     * @param {number} [scaleY=1] - The Y scale value
     * @param {number} [rotation=0] - The rotation
     * @param {number} [skewX=0] - The X skew value
     * @param {number} [skewY=0] - The Y skew value
     * @param {number} [pivotX=0] - The X pivot value
     * @param {number} [pivotY=0] - The Y pivot value
     * @return {PIXI.DisplayObject} The DisplayObject instance
     */ DisplayObject.prototype.setTransform = function(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (scaleX === void 0) scaleX = 1;
        if (scaleY === void 0) scaleY = 1;
        if (rotation === void 0) rotation = 0;
        if (skewX === void 0) skewX = 0;
        if (skewY === void 0) skewY = 0;
        if (pivotX === void 0) pivotX = 0;
        if (pivotY === void 0) pivotY = 0;
        this.position.x = x;
        this.position.y = y;
        this.scale.x = !scaleX ? 1 : scaleX;
        this.scale.y = !scaleY ? 1 : scaleY;
        this.rotation = rotation;
        this.skew.x = skewX;
        this.skew.y = skewY;
        this.pivot.x = pivotX;
        this.pivot.y = pivotY;
        return this;
    };
    /**
     * Base destroy method for generic display objects. This will automatically
     * remove the display object from its parent Container as well as remove
     * all current event listeners and internal references. Do not use a DisplayObject
     * after calling `destroy()`.
     *
     */ DisplayObject.prototype.destroy = function(_options) {
        if (this.parent) this.parent.removeChild(this);
        this.emit('destroyed');
        this.removeAllListeners();
        this.transform = null;
        this.parent = null;
        this._bounds = null;
        this.mask = null;
        this.filters = null;
        this.filterArea = null;
        this.hitArea = null;
        this.interactive = false;
        this.interactiveChildren = false;
        this._destroyed = true;
    };
    Object.defineProperty(DisplayObject.prototype, "_tempDisplayObjectParent", {
        /**
         * @protected
         * @member {PIXI.Container}
         */ get: function() {
            if (this.tempDisplayObjectParent === null) // eslint-disable-next-line @typescript-eslint/no-use-before-define
            this.tempDisplayObjectParent = new $62a57129ee044f79$export$a35515d77cade20d();
            return this.tempDisplayObjectParent;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root
     *
     * ```
     * const cacheParent = elem.enableTempParent();
     * elem.updateTransform();
     * elem.disableTempParent(cacheParent);
     * ```
     *
     * @returns {PIXI.Container} current parent
     */ DisplayObject.prototype.enableTempParent = function() {
        var myParent = this.parent;
        this.parent = this._tempDisplayObjectParent;
        return myParent;
    };
    /**
     * Pair method for `enableTempParent`
     *
     * @param {PIXI.Container} cacheParent - Actual parent of element
     */ DisplayObject.prototype.disableTempParent = function(cacheParent) {
        this.parent = cacheParent;
    };
    Object.defineProperty(DisplayObject.prototype, "x", {
        /**
         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
         * An alias to position.x
         *
         * @member {number}
         */ get: function() {
            return this.position.x;
        },
        set: function(value) {
            this.transform.position.x = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "y", {
        /**
         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
         * An alias to position.y
         *
         * @member {number}
         */ get: function() {
            return this.position.y;
        },
        set: function(value) {
            this.transform.position.y = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "worldTransform", {
        /**
         * Current transform of the object based on world (parent) factors.
         *
         * @member {PIXI.Matrix}
         * @readonly
         */ get: function() {
            return this.transform.worldTransform;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "localTransform", {
        /**
         * Current transform of the object based on local factors: position, scale, other stuff.
         *
         * @member {PIXI.Matrix}
         * @readonly
         */ get: function() {
            return this.transform.localTransform;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "position", {
        /**
         * The coordinate of the object relative to the local coordinates of the parent.
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.position;
        },
        set: function(value) {
            this.transform.position.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "scale", {
        /**
         * The scale factors of this object along the local coordinate axes.
         *
         * The default scale is (1, 1).
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.scale;
        },
        set: function(value) {
            this.transform.scale.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "pivot", {
        /**
         * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
         * is the projection of `pivot` in the parent's local space.
         *
         * By default, the pivot is the origin (0, 0).
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.pivot;
        },
        set: function(value) {
            this.transform.pivot.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "skew", {
        /**
         * The skew factor for the object in radians.
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.skew;
        },
        set: function(value) {
            this.transform.skew.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "rotation", {
        /**
         * The rotation of the object in radians.
         * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
         *
         * @member {number}
         */ get: function() {
            return this.transform.rotation;
        },
        set: function(value) {
            this.transform.rotation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "angle", {
        /**
         * The angle of the object in degrees.
         * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
         *
         * @member {number}
         */ get: function() {
            return this.transform.rotation * (0, $6qzqq.RAD_TO_DEG);
        },
        set: function(value) {
            this.transform.rotation = value * (0, $6qzqq.DEG_TO_RAD);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "zIndex", {
        /**
         * The zIndex of the displayObject.
         *
         * If a container has the sortableChildren property set to true, children will be automatically
         * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
         * and thus rendered on top of other display objects within the same container.
         *
         * @member {number}
         * @see PIXI.Container#sortableChildren
         */ get: function() {
            return this._zIndex;
        },
        set: function(value) {
            this._zIndex = value;
            if (this.parent) this.parent.sortDirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "worldVisible", {
        /**
         * Indicates if the object is globally visible.
         *
         * @member {boolean}
         * @readonly
         */ get: function() {
            var item = this;
            do {
                if (!item.visible) return false;
                item = item.parent;
            }while (item);
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "mask", {
        /**
         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
         * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
         * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
         * utilities shape clipping. To remove a mask, set this property to `null`.
         *
         * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
         *
         * @example
         * const graphics = new PIXI.Graphics();
         * graphics.beginFill(0xFF3300);
         * graphics.drawRect(50, 250, 100, 100);
         * graphics.endFill();
         *
         * const sprite = new PIXI.Sprite(texture);
         * sprite.mask = graphics;
         *
         * @todo At the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
         * @member {PIXI.Container|PIXI.MaskData|null}
         */ get: function() {
            return this._mask;
        },
        set: function(value) {
            if (this._mask === value) return;
            if (this._mask) {
                var maskObject = this._mask.maskObject || this._mask;
                maskObject._maskRefCount--;
                if (maskObject._maskRefCount === 0) {
                    maskObject.renderable = true;
                    maskObject.isMask = false;
                }
            }
            this._mask = value;
            if (this._mask) {
                var maskObject = this._mask.maskObject || this._mask;
                if (maskObject._maskRefCount === 0) {
                    maskObject.renderable = false;
                    maskObject.isMask = true;
                }
                maskObject._maskRefCount++;
            }
        },
        enumerable: false,
        configurable: true
    });
    return DisplayObject;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
/**
 * @private
 */ var $62a57129ee044f79$export$a35515d77cade20d = /** @class */ function(_super) {
    $62a57129ee044f79$var$__extends(TemporaryDisplayObject, _super);
    function TemporaryDisplayObject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortDirty = null;
        return _this;
    }
    return TemporaryDisplayObject;
}($62a57129ee044f79$export$1f679544f90d7d7c);
/**
 * DisplayObject default updateTransform, does not update children of container.
 * Will crash if there's no parent element.
 *
 * @memberof PIXI.DisplayObject#
 * @method displayObjectUpdateTransform
 */ $62a57129ee044f79$export$1f679544f90d7d7c.prototype.displayObjectUpdateTransform = $62a57129ee044f79$export$1f679544f90d7d7c.prototype.updateTransform;
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $62a57129ee044f79$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($62a57129ee044f79$var$ENV || ($62a57129ee044f79$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $62a57129ee044f79$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($62a57129ee044f79$var$RENDERER_TYPE || ($62a57129ee044f79$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $62a57129ee044f79$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($62a57129ee044f79$var$BUFFER_BITS || ($62a57129ee044f79$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $62a57129ee044f79$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($62a57129ee044f79$var$BLEND_MODES || ($62a57129ee044f79$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $62a57129ee044f79$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($62a57129ee044f79$var$DRAW_MODES || ($62a57129ee044f79$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $62a57129ee044f79$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($62a57129ee044f79$var$FORMATS || ($62a57129ee044f79$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $62a57129ee044f79$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($62a57129ee044f79$var$TARGETS || ($62a57129ee044f79$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $62a57129ee044f79$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($62a57129ee044f79$var$TYPES || ($62a57129ee044f79$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $62a57129ee044f79$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($62a57129ee044f79$var$SAMPLER_TYPES || ($62a57129ee044f79$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $62a57129ee044f79$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($62a57129ee044f79$var$SCALE_MODES || ($62a57129ee044f79$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $62a57129ee044f79$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($62a57129ee044f79$var$WRAP_MODES || ($62a57129ee044f79$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $62a57129ee044f79$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($62a57129ee044f79$var$MIPMAP_MODES || ($62a57129ee044f79$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $62a57129ee044f79$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($62a57129ee044f79$var$ALPHA_MODES || ($62a57129ee044f79$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $62a57129ee044f79$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($62a57129ee044f79$var$CLEAR_MODES || ($62a57129ee044f79$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $62a57129ee044f79$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($62a57129ee044f79$var$GC_MODES || ($62a57129ee044f79$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $62a57129ee044f79$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($62a57129ee044f79$var$PRECISION || ($62a57129ee044f79$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $62a57129ee044f79$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($62a57129ee044f79$var$MASK_TYPES || ($62a57129ee044f79$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $62a57129ee044f79$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($62a57129ee044f79$var$MSAA_QUALITY || ($62a57129ee044f79$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $62a57129ee044f79$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($62a57129ee044f79$var$BUFFER_TYPE || ($62a57129ee044f79$var$BUFFER_TYPE = {}));
function $62a57129ee044f79$var$sortChildren(a, b) {
    if (a.zIndex === b.zIndex) return a._lastSortedIndex - b._lastSortedIndex;
    return a.zIndex - b.zIndex;
}
/**
 * Container is a general-purpose display object that holds children. It also adds built-in support for advanced
 * rendering features like masking and filtering.
 *
 * It is the base class of all display objects that act as a container for other objects, including Graphics
 * and Sprite.
 *
 * ```js
 * import { BlurFilter } from '@pixi/filter-blur';
 * import { Container } from '@pixi/display';
 * import { Graphics } from '@pixi/graphics';
 * import { Sprite } from '@pixi/sprite';
 *
 * let container = new Container();
 * let sprite = Sprite.from("https://s3-us-west-2.amazonaws.com/s.cdpn.io/693612/IaUrttj.png");
 *
 * sprite.width = 512;
 * sprite.height = 512;
 *
 * // Adds a sprite as a child to this container. As a result, the sprite will be rendered whenever the container
 * // is rendered.
 * container.addChild(sprite);
 *
 * // Blurs whatever is rendered by the container
 * container.filters = [new BlurFilter()];
 *
 * // Only the contents within a circle at the center should be rendered onto the screen.
 * container.mask = new Graphics()
 *  .beginFill(0xffffff)
 *  .drawCircle(sprite.width / 2, sprite.height / 2, Math.min(sprite.width, sprite.height) / 2)
 *  .endFill();
 * ```
 *
 * @class
 * @extends PIXI.DisplayObject
 * @memberof PIXI
 */ var $62a57129ee044f79$export$42a852a2b6b56249 = /** @class */ function(_super) {
    $62a57129ee044f79$var$__extends(Container, _super);
    function Container() {
        var _this = _super.call(this) || this;
        /**
         * The array of children of this container.
         *
         * @member {PIXI.DisplayObject[]}
         * @readonly
         */ _this.children = [];
        /**
         * If set to true, the container will sort its children by zIndex value
         * when updateTransform() is called, or manually if sortChildren() is called.
         *
         * This actually changes the order of elements in the array, so should be treated
         * as a basic solution that is not performant compared to other solutions,
         * such as @link https://github.com/pixijs/pixi-display
         *
         * Also be aware of that this may not work nicely with the addChildAt() function,
         * as the zIndex sorting may cause the child to automatically sorted to another position.
         *
         * @see PIXI.settings.SORTABLE_CHILDREN
         *
         * @member {boolean}
         */ _this.sortableChildren = (0, $ezJmd.settings).SORTABLE_CHILDREN;
        /**
         * Should children be sorted by zIndex at the next updateTransform call.
         *
         * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
         *
         * @member {boolean}
         */ _this.sortDirty = false;
        return _this;
    /**
         * Fired when a DisplayObject is added to this Container.
         *
         * @event PIXI.Container#childAdded
         * @param {PIXI.DisplayObject} child - The child added to the Container.
         * @param {PIXI.Container} container - The container that added the child.
         * @param {number} index - The children's index of the added child.
         */ /**
         * Fired when a DisplayObject is removed from this Container.
         *
         * @event PIXI.DisplayObject#removedFrom
         * @param {PIXI.DisplayObject} child - The child removed from the Container.
         * @param {PIXI.Container} container - The container that removed removed the child.
         * @param {number} index - The former children's index of the removed child
         */ }
    /**
     * Overridable method that can be used by Container subclasses whenever the children array is modified
     *
     * @protected
     */ Container.prototype.onChildrenChange = function(_length) {
    /* empty */ };
    /**
     * Adds one or more children to the container.
     *
     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
     *
     * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
     * @return {PIXI.DisplayObject} The first child that was added.
     */ Container.prototype.addChild = function() {
        var arguments$1 = arguments;
        var children = [];
        for(var _i = 0; _i < arguments.length; _i++)children[_i] = arguments$1[_i];
        // if there is only one argument we can bypass looping through the them
        if (children.length > 1) // loop through the array and add all children
        for(var i = 0; i < children.length; i++)// eslint-disable-next-line prefer-rest-params
        this.addChild(children[i]);
        else {
            var child = children[0];
            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
            if (child.parent) child.parent.removeChild(child);
            child.parent = this;
            this.sortDirty = true;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            this.children.push(child);
            // ensure bounds will be recalculated
            this._boundsID++;
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(this.children.length - 1);
            this.emit('childAdded', child, this, this.children.length - 1);
            child.emit('added', this);
        }
        return children[0];
    };
    /**
     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
     *
     * @param {PIXI.DisplayObject} child - The child to add
     * @param {number} index - The index to place the child in
     * @return {PIXI.DisplayObject} The child that was added.
     */ Container.prototype.addChildAt = function(child, index) {
        if (index < 0 || index > this.children.length) throw new Error(child + "addChildAt: The index " + index + " supplied is out of bounds " + this.children.length);
        if (child.parent) child.parent.removeChild(child);
        child.parent = this;
        this.sortDirty = true;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;
        this.children.splice(index, 0, child);
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('added', this);
        this.emit('childAdded', child, this, index);
        return child;
    };
    /**
     * Swaps the position of 2 Display Objects within this container.
     *
     * @param {PIXI.DisplayObject} child - First display object to swap
     * @param {PIXI.DisplayObject} child2 - Second display object to swap
     */ Container.prototype.swapChildren = function(child, child2) {
        if (child === child2) return;
        var index1 = this.getChildIndex(child);
        var index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        this.onChildrenChange(index1 < index2 ? index1 : index2);
    };
    /**
     * Returns the index position of a child DisplayObject instance
     *
     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
     * @return {number} The index position of the child display object to identify
     */ Container.prototype.getChildIndex = function(child) {
        var index = this.children.indexOf(child);
        if (index === -1) throw new Error('The supplied DisplayObject must be a child of the caller');
        return index;
    };
    /**
     * Changes the position of an existing child in the display object container
     *
     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
     * @param {number} index - The resulting index number for the child display object
     */ Container.prototype.setChildIndex = function(child, index) {
        if (index < 0 || index >= this.children.length) throw new Error("The index " + index + " supplied is out of bounds " + this.children.length);
        var currentIndex = this.getChildIndex(child);
        (0, $csytw.removeItems)(this.children, currentIndex, 1); // remove from old position
        this.children.splice(index, 0, child); // add at new position
        this.onChildrenChange(index);
    };
    /**
     * Returns the child at the specified index
     *
     * @param {number} index - The index to get the child at
     * @return {PIXI.DisplayObject} The child at the given index, if any.
     */ Container.prototype.getChildAt = function(index) {
        if (index < 0 || index >= this.children.length) throw new Error("getChildAt: Index (" + index + ") does not exist.");
        return this.children[index];
    };
    /**
     * Removes one or more children from the container.
     *
     * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
     * @return {PIXI.DisplayObject} The first child that was removed.
     */ Container.prototype.removeChild = function() {
        var arguments$1 = arguments;
        var children = [];
        for(var _i = 0; _i < arguments.length; _i++)children[_i] = arguments$1[_i];
        // if there is only one argument we can bypass looping through the them
        if (children.length > 1) // loop through the arguments property and remove all children
        for(var i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            var child = children[0];
            var index = this.children.indexOf(child);
            if (index === -1) return null;
            child.parent = null;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            (0, $csytw.removeItems)(this.children, index, 1);
            // ensure bounds will be recalculated
            this._boundsID++;
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(index);
            child.emit('removed', this);
            this.emit('childRemoved', child, this, index);
        }
        return children[0];
    };
    /**
     * Removes a child from the specified index position.
     *
     * @param {number} index - The index to get the child from
     * @return {PIXI.DisplayObject} The child that was removed.
     */ Container.prototype.removeChildAt = function(index) {
        var child = this.getChildAt(index);
        // ensure child transform will be recalculated..
        child.parent = null;
        child.transform._parentID = -1;
        (0, $csytw.removeItems)(this.children, index, 1);
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('removed', this);
        this.emit('childRemoved', child, this, index);
        return child;
    };
    /**
     * Removes all children from this container that are within the begin and end indexes.
     *
     * @param {number} [beginIndex=0] - The beginning position.
     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
     * @returns {PIXI.DisplayObject[]} List of removed children
     */ Container.prototype.removeChildren = function(beginIndex, endIndex) {
        if (beginIndex === void 0) beginIndex = 0;
        if (endIndex === void 0) endIndex = this.children.length;
        var begin = beginIndex;
        var end = endIndex;
        var range = end - begin;
        var removed;
        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);
            for(var i = 0; i < removed.length; ++i){
                removed[i].parent = null;
                if (removed[i].transform) removed[i].transform._parentID = -1;
            }
            this._boundsID++;
            this.onChildrenChange(beginIndex);
            for(var i = 0; i < removed.length; ++i){
                removed[i].emit('removed', this);
                this.emit('childRemoved', removed[i], this, i);
            }
            return removed;
        } else if (range === 0 && this.children.length === 0) return [];
        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
    };
    /**
     * Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex.
     */ Container.prototype.sortChildren = function() {
        var sortRequired = false;
        for(var i = 0, j = this.children.length; i < j; ++i){
            var child = this.children[i];
            child._lastSortedIndex = i;
            if (!sortRequired && child.zIndex !== 0) sortRequired = true;
        }
        if (sortRequired && this.children.length > 1) this.children.sort($62a57129ee044f79$var$sortChildren);
        this.sortDirty = false;
    };
    /**
     * Updates the transform on all children of this container for rendering
     */ Container.prototype.updateTransform = function() {
        if (this.sortableChildren && this.sortDirty) this.sortChildren();
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        // TODO: check render flags, how to process stuff here
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
        for(var i = 0, j = this.children.length; i < j; ++i){
            var child = this.children[i];
            if (child.visible) child.updateTransform();
        }
    };
    /**
     * Recalculates the bounds of the container.
     *
     * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
     * is limited to its mask's bounds or filterArea, if any is applied.
     */ Container.prototype.calculateBounds = function() {
        this._bounds.clear();
        this._calculateBounds();
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            if (!child.visible || !child.renderable) continue;
            child.calculateBounds();
            // TODO: filter+mask, need to mask both somehow
            if (child._mask) {
                var maskObject = child._mask.maskObject || child._mask;
                maskObject.calculateBounds();
                this._bounds.addBoundsMask(child._bounds, maskObject._bounds);
            } else if (child.filterArea) this._bounds.addBoundsArea(child._bounds, child.filterArea);
            else this._bounds.addBounds(child._bounds);
        }
        this._bounds.updateID = this._boundsID;
    };
    /**
     * Retrieves the local bounds of the displayObject as a rectangle object.
     *
     * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
     * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
     *
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
     * @param {boolean} [skipChildrenUpdate=false] - Setting to `true` will stop re-calculation of children transforms,
     *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
     * @return {PIXI.Rectangle} The rectangular bounding area.
     */ Container.prototype.getLocalBounds = function(rect, skipChildrenUpdate) {
        if (skipChildrenUpdate === void 0) skipChildrenUpdate = false;
        var result = _super.prototype.getLocalBounds.call(this, rect);
        if (!skipChildrenUpdate) for(var i = 0, j = this.children.length; i < j; ++i){
            var child = this.children[i];
            if (child.visible) child.updateTransform();
        }
        return result;
    };
    /**
     * Recalculates the content bounds of this object. This should be overriden to
     * calculate the bounds of this specific object (not including children).
     *
     * @protected
     */ Container.prototype._calculateBounds = function() {
    // FILL IN//
    };
    /**
     * Renders the object using the WebGL renderer.
     *
     * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
     * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
     * children afterward.
     *
     * If `renderable` or `visible` is false or if `worldAlpha` is not positive, this implementation will entirely
     * skip rendering. See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
     * setting alpha to zero is not recommended for purely skipping rendering.
     *
     * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
     * advised to employ **culling** to automatically skip rendering objects outside of the current screen. The
     * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
     * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull} packages do this out of the box.
     *
     * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
     * filtering is applied on a container. This does, however, break batching and can affect performance when
     * masking and filtering is applied extensively throughout the scene graph.
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Container.prototype.render = function(renderer) {
        // if the object is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        // do a quick check to see if this element has a mask or a filter.
        if (this._mask || this.filters && this.filters.length) this.renderAdvanced(renderer);
        else {
            this._render(renderer);
            // simple render children!
            for(var i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
    };
    /**
     * Render the object using the WebGL renderer and advanced features.
     *
     * @protected
     * @param {PIXI.Renderer} renderer - The renderer
     */ Container.prototype.renderAdvanced = function(renderer) {
        var filters = this.filters;
        var mask = this._mask;
        // push filter first as we need to ensure the stencil buffer is correct for any masking
        if (filters) {
            if (!this._enabledFilters) this._enabledFilters = [];
            this._enabledFilters.length = 0;
            for(var i = 0; i < filters.length; i++)if (filters[i].enabled) this._enabledFilters.push(filters[i]);
        }
        var flush = filters && this._enabledFilters && this._enabledFilters.length || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== $62a57129ee044f79$var$MASK_TYPES.NONE));
        if (flush) renderer.batch.flush();
        if (filters && this._enabledFilters && this._enabledFilters.length) renderer.filter.push(this, this._enabledFilters);
        if (mask) renderer.mask.push(this, this._mask);
        // add this object to the batch, only rendered if it has a texture.
        this._render(renderer);
        // now loop through the children and make sure they get rendered
        for(var i = 0, j = this.children.length; i < j; i++)this.children[i].render(renderer);
        if (flush) renderer.batch.flush();
        if (mask) renderer.mask.pop(this);
        if (filters && this._enabledFilters && this._enabledFilters.length) renderer.filter.pop();
    };
    /**
     * To be overridden by the subclasses.
     *
     * @protected
     * @param {PIXI.Renderer} renderer - The renderer
     */ Container.prototype._render = function(_renderer) {
    // this is where content itself gets rendered...
    };
    /**
     * Removes all internal references and listeners as well as removes children from the display list.
     * Do not use a Container after calling `destroy`.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */ Container.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this);
        this.sortDirty = false;
        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;
        var oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(var i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    };
    Object.defineProperty(Container.prototype, "width", {
        /**
         * The width of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */ get: function() {
            return this.scale.x * this.getLocalBounds().width;
        },
        set: function(value) {
            var width = this.getLocalBounds().width;
            if (width !== 0) this.scale.x = value / width;
            else this.scale.x = 1;
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "height", {
        /**
         * The height of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */ get: function() {
            return this.scale.y * this.getLocalBounds().height;
        },
        set: function(value) {
            var height = this.getLocalBounds().height;
            if (height !== 0) this.scale.y = value / height;
            else this.scale.y = 1;
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    return Container;
}($62a57129ee044f79$export$1f679544f90d7d7c);
/**
 * Container default updateTransform, does update children of container.
 * Will crash if there's no parent element.
 *
 * @memberof PIXI.Container#
 * @method containerUpdateTransform
 */ $62a57129ee044f79$export$42a852a2b6b56249.prototype.containerUpdateTransform = $62a57129ee044f79$export$42a852a2b6b56249.prototype.updateTransform;

});
parcelRegister("6qzqq", function(module, exports) {

$parcel$export(module.exports, "PI_2", function () { return $4ae0a6833d6839bf$export$59ed0a0a5de1084b; });
$parcel$export(module.exports, "RAD_TO_DEG", function () { return $4ae0a6833d6839bf$export$3f91627dc85c5d57; });
$parcel$export(module.exports, "DEG_TO_RAD", function () { return $4ae0a6833d6839bf$export$870617f62e3187f1; });
$parcel$export(module.exports, "SHAPES", function () { return $4ae0a6833d6839bf$export$511e1d54a4a8684e; });
$parcel$export(module.exports, "Rectangle", function () { return $4ae0a6833d6839bf$export$4617fb02663045ef; });
$parcel$export(module.exports, "Circle", function () { return $4ae0a6833d6839bf$export$c89a927ffc67e6fa; });
$parcel$export(module.exports, "Ellipse", function () { return $4ae0a6833d6839bf$export$80b0269ab108fa11; });
$parcel$export(module.exports, "Polygon", function () { return $4ae0a6833d6839bf$export$7d31b617c820d435; });
$parcel$export(module.exports, "RoundedRectangle", function () { return $4ae0a6833d6839bf$export$d55ab2e3dc5a4263; });
$parcel$export(module.exports, "Point", function () { return $4ae0a6833d6839bf$export$baf26146a414f24a; });
$parcel$export(module.exports, "ObservablePoint", function () { return $4ae0a6833d6839bf$export$3755aaad3fd42e52; });
$parcel$export(module.exports, "Matrix", function () { return $4ae0a6833d6839bf$export$5b12bf1653c0dd85; });
$parcel$export(module.exports, "groupD8", function () { return $4ae0a6833d6839bf$export$b7bb6a2a8d203102; });
$parcel$export(module.exports, "Transform", function () { return $4ae0a6833d6839bf$export$563a914cafbdc389; });
/*!
 * @pixi/math - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/math is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Two Pi.
 *
 * @static
 * @member {number}
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$59ed0a0a5de1084b = Math.PI * 2;
/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @member {number} RAD_TO_DEG
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$3f91627dc85c5d57 = 180 / Math.PI;
/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @member {number}
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$870617f62e3187f1 = Math.PI / 180;
/**
 * Constants that identify shapes, mainly to prevent `instanceof` calls.
 *
 * @static
 * @memberof PIXI
 * @enum {number}
 * @property {number} POLY Polygon
 * @property {number} RECT Rectangle
 * @property {number} CIRC Circle
 * @property {number} ELIP Ellipse
 * @property {number} RREC Rounded Rectangle
 */ var $4ae0a6833d6839bf$export$511e1d54a4a8684e;
(function(SHAPES) {
    SHAPES[SHAPES["POLY"] = 0] = "POLY";
    SHAPES[SHAPES["RECT"] = 1] = "RECT";
    SHAPES[SHAPES["CIRC"] = 2] = "CIRC";
    SHAPES[SHAPES["ELIP"] = 3] = "ELIP";
    SHAPES[SHAPES["RREC"] = 4] = "RREC";
})($4ae0a6833d6839bf$export$511e1d54a4a8684e || ($4ae0a6833d6839bf$export$511e1d54a4a8684e = {}));
/**
 * Size object, contains width and height
 *
 * @memberof PIXI
 * @typedef {object} ISize
 */ /**
 * Rectangle object is an area defined by its position, as indicated by its top-left corner
 * point (x, y) and by its width and its height.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$4617fb02663045ef = /** @class */ function() {
    /**
     * @param x - The X coordinate of the upper-left corner of the rectangle
     * @param y - The Y coordinate of the upper-left corner of the rectangle
     * @param width - The overall width of the rectangle
     * @param height - The overall height of the rectangle
     */ function Rectangle(x, y, width, height) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.RECT;
    }
    Object.defineProperty(Rectangle.prototype, "left", {
        /** Returns the left edge of the rectangle. */ get: function() {
            return this.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "right", {
        /** Returns the right edge of the rectangle. */ get: function() {
            return this.x + this.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "top", {
        /** Returns the top edge of the rectangle. */ get: function() {
            return this.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "bottom", {
        /** Returns the bottom edge of the rectangle. */ get: function() {
            return this.y + this.height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle, "EMPTY", {
        /** A constant empty rectangle. */ get: function() {
            return new Rectangle(0, 0, 0, 0);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates a clone of this Rectangle
     *
     * @return a copy of the rectangle
     */ Rectangle.prototype.clone = function() {
        return new Rectangle(this.x, this.y, this.width, this.height);
    };
    /**
     * Copies another rectangle to this one.
     *
     * @param rectangle - The rectangle to copy from.
     * @return Returns itself.
     */ Rectangle.prototype.copyFrom = function(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    };
    /**
     * Copies this rectangle to another one.
     *
     * @param rectangle - The rectangle to copy to.
     * @return Returns given parameter.
     */ Rectangle.prototype.copyTo = function(rectangle) {
        rectangle.x = this.x;
        rectangle.y = this.y;
        rectangle.width = this.width;
        rectangle.height = this.height;
        return rectangle;
    };
    /**
     * Checks whether the x and y coordinates given are contained within this Rectangle
     *
     * @param x - The X coordinate of the point to test
     * @param y - The Y coordinate of the point to test
     * @return Whether the x/y coordinates are within this Rectangle
     */ Rectangle.prototype.contains = function(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    };
    /**
     * Pads the rectangle making it grow in all directions.
     * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
     *
     * @param paddingX - The horizontal padding amount.
     * @param paddingY - The vertical padding amount.
     * @return Returns itself.
     */ Rectangle.prototype.pad = function(paddingX, paddingY) {
        if (paddingX === void 0) paddingX = 0;
        if (paddingY === void 0) paddingY = paddingX;
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    };
    /**
     * Fits this rectangle around the passed one.
     *
     * @param rectangle - The rectangle to fit.
     * @return Returns itself.
     */ Rectangle.prototype.fit = function(rectangle) {
        var x1 = Math.max(this.x, rectangle.x);
        var x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        var y1 = Math.max(this.y, rectangle.y);
        var y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    };
    /**
     * Enlarges rectangle that way its corners lie on grid
     *
     * @param resolution - resolution
     * @param eps - precision
     * @return Returns itself.
     */ Rectangle.prototype.ceil = function(resolution, eps) {
        if (resolution === void 0) resolution = 1;
        if (eps === void 0) eps = 0.001;
        var x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        var y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    };
    /**
     * Enlarges this rectangle to include the passed rectangle.
     *
     * @param rectangle - The rectangle to include.
     * @return Returns itself.
     */ Rectangle.prototype.enlarge = function(rectangle) {
        var x1 = Math.min(this.x, rectangle.x);
        var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        var y1 = Math.min(this.y, rectangle.y);
        var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    };
    Rectangle.prototype.toString = function() {
        return "[@pixi/math:Rectangle x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + "]";
    };
    return Rectangle;
}();
/**
 * The Circle object is used to help draw graphics and can also be used to specify a hit area for displayObjects.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$c89a927ffc67e6fa = /** @class */ function() {
    /**
     * @param x - The X coordinate of the center of this circle
     * @param y - The Y coordinate of the center of this circle
     * @param radius - The radius of the circle
     */ function Circle(x, y, radius) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (radius === void 0) radius = 0;
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.CIRC;
    }
    /**
     * Creates a clone of this Circle instance
     *
     * @return A copy of the Circle
     */ Circle.prototype.clone = function() {
        return new Circle(this.x, this.y, this.radius);
    };
    /**
     * Checks whether the x and y coordinates given are contained within this circle
     *
     * @param x - The X coordinate of the point to test
     * @param y - The Y coordinate of the point to test
     * @return Whether the x/y coordinates are within this Circle
     */ Circle.prototype.contains = function(x, y) {
        if (this.radius <= 0) return false;
        var r2 = this.radius * this.radius;
        var dx = this.x - x;
        var dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    };
    /**
    * Returns the framing rectangle of the circle as a Rectangle object
    *
    * @return The framing rectangle
    */ Circle.prototype.getBounds = function() {
        return new $4ae0a6833d6839bf$export$4617fb02663045ef(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    };
    Circle.prototype.toString = function() {
        return "[@pixi/math:Circle x=" + this.x + " y=" + this.y + " radius=" + this.radius + "]";
    };
    return Circle;
}();
/**
 * The Ellipse object is used to help draw graphics and can also be used to specify a hit area for displayObjects.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$80b0269ab108fa11 = /** @class */ function() {
    /**
     * @param x - The X coordinate of the center of this ellipse
     * @param y - The Y coordinate of the center of this ellipse
     * @param halfWidth - The half width of this ellipse
     * @param halfHeight - The half height of this ellipse
     */ function Ellipse(x, y, halfWidth, halfHeight) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (halfWidth === void 0) halfWidth = 0;
        if (halfHeight === void 0) halfHeight = 0;
        this.x = x;
        this.y = y;
        this.width = halfWidth;
        this.height = halfHeight;
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.ELIP;
    }
    /**
     * Creates a clone of this Ellipse instance
     *
     * @return {PIXI.Ellipse} A copy of the ellipse
     */ Ellipse.prototype.clone = function() {
        return new Ellipse(this.x, this.y, this.width, this.height);
    };
    /**
     * Checks whether the x and y coordinates given are contained within this ellipse
     *
     * @param x - The X coordinate of the point to test
     * @param y - The Y coordinate of the point to test
     * @return Whether the x/y coords are within this ellipse
     */ Ellipse.prototype.contains = function(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        // normalize the coords to an ellipse with center 0,0
        var normx = (x - this.x) / this.width;
        var normy = (y - this.y) / this.height;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    };
    /**
     * Returns the framing rectangle of the ellipse as a Rectangle object
     *
     * @return The framing rectangle
     */ Ellipse.prototype.getBounds = function() {
        return new $4ae0a6833d6839bf$export$4617fb02663045ef(this.x - this.width, this.y - this.height, this.width, this.height);
    };
    Ellipse.prototype.toString = function() {
        return "[@pixi/math:Ellipse x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + "]";
    };
    return Ellipse;
}();
/**
 * A class to define a shape via user defined coordinates.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$7d31b617c820d435 = /** @class */ function() {
    /**
     * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
     *  the arguments passed can be all the points of the polygon e.g.
     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
     */ function Polygon() {
        var arguments$1 = arguments;
        var points = [];
        for(var _i = 0; _i < arguments.length; _i++)points[_i] = arguments$1[_i];
        var flat = Array.isArray(points[0]) ? points[0] : points;
        // if this is an array of points, convert it to a flat array of numbers
        if (typeof flat[0] !== 'number') {
            var p = [];
            for(var i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.POLY;
        this.closeStroke = true;
    }
    /**
     * Creates a clone of this polygon.
     *
     * @return - A copy of the polygon.
     */ Polygon.prototype.clone = function() {
        var points = this.points.slice();
        var polygon = new Polygon(points);
        polygon.closeStroke = this.closeStroke;
        return polygon;
    };
    /**
     * Checks whether the x and y coordinates passed to this function are contained within this polygon.
     *
     * @param x - The X coordinate of the point to test.
     * @param y - The Y coordinate of the point to test.
     * @return - Whether the x/y coordinates are within this polygon.
     */ Polygon.prototype.contains = function(x, y) {
        var inside = false;
        // use some raycasting to test hits
        // https://github.com/substack/point-in-polygon/blob/master/index.js
        var length = this.points.length / 2;
        for(var i = 0, j = length - 1; i < length; j = i++){
            var xi = this.points[i * 2];
            var yi = this.points[i * 2 + 1];
            var xj = this.points[j * 2];
            var yj = this.points[j * 2 + 1];
            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    };
    Polygon.prototype.toString = function() {
        return "[@pixi/math:Polygon" + ("closeStroke=" + this.closeStroke) + ("points=" + this.points.reduce(function(pointsDesc, currentPoint) {
            return pointsDesc + ", " + currentPoint;
        }, '') + "]");
    };
    return Polygon;
}();
/**
 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
 * top-left corner point (x, y) and by its width and its height and its radius.
 *
 * @class
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$d55ab2e3dc5a4263 = /** @class */ function() {
    /**
     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [width=0] - The overall width of this rounded rectangle
     * @param {number} [height=0] - The overall height of this rounded rectangle
     * @param {number} [radius=20] - Controls the radius of the rounded corners
     */ function RoundedRectangle(x, y, width, height, radius) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        if (radius === void 0) radius = 20;
        /**
         * @member {number}
         * @default 0
         */ this.x = x;
        /**
         * @member {number}
         * @default 0
         */ this.y = y;
        /**
         * @member {number}
         * @default 0
         */ this.width = width;
        /**
         * @member {number}
         * @default 0
         */ this.height = height;
        /**
         * @member {number}
         * @default 20
         */ this.radius = radius;
        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readonly
         * @default PIXI.SHAPES.RREC
         * @see PIXI.SHAPES
         */ this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.RREC;
    }
    /**
     * Creates a clone of this Rounded Rectangle
     *
     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
     */ RoundedRectangle.prototype.clone = function() {
        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
    };
    /**
     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
     *
     * @param {number} x - The X coordinate of the point to test
     * @param {number} y - The Y coordinate of the point to test
     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
     */ RoundedRectangle.prototype.contains = function(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                var radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                var dx = x - (this.x + radius);
                var dy = y - (this.y + radius);
                var radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    };
    RoundedRectangle.prototype.toString = function() {
        return "[@pixi/math:RoundedRectangle x=" + this.x + " y=" + this.y + ("width=" + this.width + " height=" + this.height + " radius=" + this.radius + "]");
    };
    return RoundedRectangle;
}();
/**
 * The Point object represents a location in a two-dimensional coordinate system, where `x` represents
 * the position on the horizontal axis and `y` represents the position on the vertical axis
 *
 * @class
 * @memberof PIXI
 * @implements IPoint
 */ var $4ae0a6833d6839bf$export$baf26146a414f24a = /** @class */ function() {
    /** Creates a new `Point`
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     */ function Point(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        /** Position of the point on the x axis */ this.x = 0;
        /** Position of the point on the y axis */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /** Creates a clone of this point
     * @returns A clone of this point
     */ Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    /**
     * Copies `x` and `y` from the given point into this point
     *
     * @param p - The point to copy from
     * @returns The point instance itself
     */ Point.prototype.copyFrom = function(p) {
        this.set(p.x, p.y);
        return this;
    };
    /**
     * Copies this point's x and y into the given point (`p`).
     *
     * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
     * @returns The point (`p`) with values updated
     */ Point.prototype.copyTo = function(p) {
        p.set(this.x, this.y);
        return p;
    };
    /**
     * Accepts another point (`p`) and returns `true` if the given point is equal to this point
     *
     * @param p - The point to check
     * @returns Returns `true` if both `x` and `y` are equal
     */ Point.prototype.equals = function(p) {
        return p.x === this.x && p.y === this.y;
    };
    /**
     * Sets the point to a new `x` and `y` position.
     * If `y` is omitted, both `x` and `y` will be set to `x`.
     *
     * @param {number} [x=0] - position of the point on the `x` axis
     * @param {number} [y=x] - position of the point on the `y` axis
     * @returns The point instance itself
     */ Point.prototype.set = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = x;
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.toString = function() {
        return "[@pixi/math:Point x=" + this.x + " y=" + this.y + "]";
    };
    return Point;
}();
/**
 * The ObservablePoint object represents a location in a two-dimensional coordinate system, where `x` represents
 * the position on the horizontal axis and `y` represents the position on the vertical axis.
 *
 * An `ObservablePoint` is a point that triggers a callback when the point's position is changed.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$3755aaad3fd42e52 = /** @class */ function() {
    /**
     * Creates a new `ObservablePoint`
     *
     * @param cb - callback function triggered when `x` and/or `y` are changed
     * @param scope - owner of callback
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
    */ function ObservablePoint(cb, scope, x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        this._x = x;
        this._y = y;
        this.cb = cb;
        this.scope = scope;
    }
    /**
     * Creates a clone of this point.
     * The callback and scope params can be overridden otherwise they will default
     * to the clone object's values.
     *
     * @override
     * @param cb - The callback function triggered when `x` and/or `y` are changed
     * @param scope - The owner of the callback
     * @return a copy of this observable point
     */ ObservablePoint.prototype.clone = function(cb, scope) {
        if (cb === void 0) cb = this.cb;
        if (scope === void 0) scope = this.scope;
        return new ObservablePoint(cb, scope, this._x, this._y);
    };
    /**
     * Sets the point to a new `x` and `y` position.
     * If `y` is omitted, both `x` and `y` will be set to `x`.
     *
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=x] - position of the point on the y axis
     * @returns The observable point instance itself
     */ ObservablePoint.prototype.set = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = x;
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this.cb.call(this.scope);
        }
        return this;
    };
    /**
     * Copies x and y from the given point (`p`)
     *
     * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
     * @returns The observable point instance itself
     */ ObservablePoint.prototype.copyFrom = function(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this.cb.call(this.scope);
        }
        return this;
    };
    /**
     * Copies this point's x and y into that of the given point (`p`)
     *
     * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
     * @returns The point (`p`) with values updated
     */ ObservablePoint.prototype.copyTo = function(p) {
        p.set(this._x, this._y);
        return p;
    };
    /**
     * Accepts another point (`p`) and returns `true` if the given point is equal to this point
     *
     * @param p - The point to check
     * @returns Returns `true` if both `x` and `y` are equal
     */ ObservablePoint.prototype.equals = function(p) {
        return p.x === this._x && p.y === this._y;
    };
    ObservablePoint.prototype.toString = function() {
        return "[@pixi/math:ObservablePoint x=0 y=0 scope=" + this.scope + "]";
    };
    Object.defineProperty(ObservablePoint.prototype, "x", {
        /** Position of the observable point on the x axis. */ get: function() {
            return this._x;
        },
        set: function(value) {
            if (this._x !== value) {
                this._x = value;
                this.cb.call(this.scope);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservablePoint.prototype, "y", {
        /** Position of the observable point on the y axis. */ get: function() {
            return this._y;
        },
        set: function(value) {
            if (this._y !== value) {
                this._y = value;
                this.cb.call(this.scope);
            }
        },
        enumerable: false,
        configurable: true
    });
    return ObservablePoint;
}();
/**
 * The PixiJS Matrix as a class makes it a lot faster.
 *
 * Here is a representation of it:
 * ```js
 * | a | c | tx|
 * | b | d | ty|
 * | 0 | 0 | 1 |
 * ```
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$5b12bf1653c0dd85 = /** @class */ function() {
    /**
     * @param a - x scale
     * @param b - y skew
     * @param c - x skew
     * @param d - y scale
     * @param tx - x translation
     * @param ty - y translation
     */ function Matrix(a, b, c, d, tx, ty) {
        if (a === void 0) a = 1;
        if (b === void 0) b = 0;
        if (c === void 0) c = 0;
        if (d === void 0) d = 1;
        if (tx === void 0) tx = 0;
        if (ty === void 0) ty = 0;
        this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
     *
     * a = array[0]
     * b = array[1]
     * c = array[3]
     * d = array[4]
     * tx = array[2]
     * ty = array[5]
     *
     * @param array - The array that the matrix will be populated from.
     */ Matrix.prototype.fromArray = function(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    };
    /**
     * Sets the matrix properties.
     *
     * @param a - Matrix component
     * @param b - Matrix component
     * @param c - Matrix component
     * @param d - Matrix component
     * @param tx - Matrix component
     * @param ty - Matrix component
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.set = function(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    };
    /**
     * Creates an array from the current Matrix object.
     *
     * @param transpose - Whether we need to transpose the matrix or not
     * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
     * @return The newly created array which contains the matrix
     */ Matrix.prototype.toArray = function(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        var array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    };
    /**
     * Get a new position with the current transformation applied.
     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
     *
     * @param pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, transformed through this matrix
     */ Matrix.prototype.apply = function(pos, newPos) {
        newPos = newPos || new $4ae0a6833d6839bf$export$baf26146a414f24a();
        var x = pos.x;
        var y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    };
    /**
     * Get a new position with the inverse of the current transformation applied.
     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
     *
     * @param pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
     */ Matrix.prototype.applyInverse = function(pos, newPos) {
        newPos = newPos || new $4ae0a6833d6839bf$export$baf26146a414f24a();
        var id = 1 / (this.a * this.d + this.c * -this.b);
        var x = pos.x;
        var y = pos.y;
        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
        return newPos;
    };
    /**
     * Translates the matrix on the x and y.
     *
     * @param x - How much to translate x by
     * @param y - How much to translate y by
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.translate = function(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    };
    /**
     * Applies a scale transformation to the matrix.
     *
     * @param x - The amount to scale horizontally
     * @param y - The amount to scale vertically
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.scale = function(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    };
    /**
     * Applies a rotation transformation to the matrix.
     *
     * @param angle - The angle in radians.
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.rotate = function(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        var a1 = this.a;
        var c1 = this.c;
        var tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    };
    /**
     * Appends the given Matrix to this Matrix.
     *
     * @param matrix - The matrix to append.
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.append = function(matrix) {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    };
    /**
     * Sets the matrix based on all the available properties
     *
     * @param x - Position on the x axis
     * @param y - Position on the y axis
     * @param pivotX - Pivot on the x axis
     * @param pivotY - Pivot on the y axis
     * @param scaleX - Scale on the x axis
     * @param scaleY - Scale on the y axis
     * @param rotation - Rotation in radians
     * @param skewX - Skew on the x axis
     * @param skewY - Skew on the y axis
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.setTransform = function(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    };
    /**
     * Prepends the given Matrix to this Matrix.
     *
     * @param matrix - The matrix to prepend
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.prepend = function(matrix) {
        var tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            var a1 = this.a;
            var c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    };
    /**
     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
     *
     * @param transform - The transform to apply the properties to.
     * @return The transform with the newly applied properties
     */ Matrix.prototype.decompose = function(transform) {
        // sort out rotation / skew..
        var a = this.a;
        var b = this.b;
        var c = this.c;
        var d = this.d;
        var pivot = transform.pivot;
        var skewX = -Math.atan2(-c, d);
        var skewY = Math.atan2(b, a);
        var delta = Math.abs(skewX + skewY);
        if (delta < 0.00001 || Math.abs($4ae0a6833d6839bf$export$59ed0a0a5de1084b - delta) < 0.00001) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        // next set scale
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        // next set position
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    };
    /**
     * Inverts this matrix
     *
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.invert = function() {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;
        var tx1 = this.tx;
        var n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    };
    /**
     * Resets this Matrix to an identity (default) matrix.
     *
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.identity = function() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    };
    /**
     * Creates a new Matrix object with the same values as this one.
     *
     * @return A copy of this matrix. Good for chaining method calls.
     */ Matrix.prototype.clone = function() {
        var matrix = new Matrix();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    };
    /**
     * Changes the values of the given matrix to be the same as the ones in this matrix
     *
     * @param matrix - The matrix to copy to.
     * @return The matrix given in parameter with its values updated.
     */ Matrix.prototype.copyTo = function(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    };
    /**
     * Changes the values of the matrix to be the same as the ones in given matrix
     *
     * @param {PIXI.Matrix} matrix - The matrix to copy from.
     * @return {PIXI.Matrix} this
     */ Matrix.prototype.copyFrom = function(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    };
    Matrix.prototype.toString = function() {
        return "[@pixi/math:Matrix a=" + this.a + " b=" + this.b + " c=" + this.c + " d=" + this.d + " tx=" + this.tx + " ty=" + this.ty + "]";
    };
    Object.defineProperty(Matrix, "IDENTITY", {
        /**
         * A default (identity) matrix
         *
         * @readonly
         */ get: function() {
            return new Matrix();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Matrix, "TEMP_MATRIX", {
        /**
         * A temp matrix
         *
         * @readonly
         */ get: function() {
            return new Matrix();
        },
        enumerable: false,
        configurable: true
    });
    return Matrix;
}();
// Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group
/*
 * Transform matrix for operation n is:
 * | ux | vx |
 * | uy | vy |
 */ var $4ae0a6833d6839bf$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
var $4ae0a6833d6839bf$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
var $4ae0a6833d6839bf$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
var $4ae0a6833d6839bf$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
/**
 * [Cayley Table]{@link https://en.wikipedia.org/wiki/Cayley_table}
 * for the composition of each rotation in the dihederal group D8.
 *
 * @type number[][]
 * @private
 */ var $4ae0a6833d6839bf$var$rotationCayley = [];
/**
 * Matrices for each `GD8Symmetry` rotation.
 *
 * @type Matrix[]
 * @private
 */ var $4ae0a6833d6839bf$var$rotationMatrices = [];
/*
 * Alias for {@code Math.sign}.
 */ var $4ae0a6833d6839bf$var$signum = Math.sign;
/*
 * Initializes `rotationCayley` and `rotationMatrices`. It is called
 * only once below.
 */ function $4ae0a6833d6839bf$var$init() {
    for(var i = 0; i < 16; i++){
        var row = [];
        $4ae0a6833d6839bf$var$rotationCayley.push(row);
        for(var j = 0; j < 16; j++){
            /* Multiplies rotation matrices i and j. */ var _ux = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$ux[i] * $4ae0a6833d6839bf$var$ux[j] + $4ae0a6833d6839bf$var$vx[i] * $4ae0a6833d6839bf$var$uy[j]);
            var _uy = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$uy[i] * $4ae0a6833d6839bf$var$ux[j] + $4ae0a6833d6839bf$var$vy[i] * $4ae0a6833d6839bf$var$uy[j]);
            var _vx = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$ux[i] * $4ae0a6833d6839bf$var$vx[j] + $4ae0a6833d6839bf$var$vx[i] * $4ae0a6833d6839bf$var$vy[j]);
            var _vy = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$uy[i] * $4ae0a6833d6839bf$var$vx[j] + $4ae0a6833d6839bf$var$vy[i] * $4ae0a6833d6839bf$var$vy[j]);
            /* Finds rotation matrix matching the product and pushes it. */ for(var k = 0; k < 16; k++)if ($4ae0a6833d6839bf$var$ux[k] === _ux && $4ae0a6833d6839bf$var$uy[k] === _uy && $4ae0a6833d6839bf$var$vx[k] === _vx && $4ae0a6833d6839bf$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(var i = 0; i < 16; i++){
        var mat = new $4ae0a6833d6839bf$export$5b12bf1653c0dd85();
        mat.set($4ae0a6833d6839bf$var$ux[i], $4ae0a6833d6839bf$var$uy[i], $4ae0a6833d6839bf$var$vx[i], $4ae0a6833d6839bf$var$vy[i], 0, 0);
        $4ae0a6833d6839bf$var$rotationMatrices.push(mat);
    }
}
$4ae0a6833d6839bf$var$init();
/**
 * @memberof PIXI
 * @typedef {number} GD8Symmetry
 * @see PIXI.groupD8
 */ /**
 * Implements the dihedral group D8, which is similar to
 * [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html};
 * D8 is the same but with diagonals, and it is used for texture
 * rotations.
 *
 * The directions the U- and V- axes after rotation
 * of an angle of `a: GD8Constant` are the vectors `(uX(a), uY(a))`
 * and `(vX(a), vY(a))`. These aren't necessarily unit vectors.
 *
 * **Origin:**<br>
 *  This is the small part of gameofbombs.com portal system. It works.
 *
 * @see PIXI.groupD8.E
 * @see PIXI.groupD8.SE
 * @see PIXI.groupD8.S
 * @see PIXI.groupD8.SW
 * @see PIXI.groupD8.W
 * @see PIXI.groupD8.NW
 * @see PIXI.groupD8.N
 * @see PIXI.groupD8.NE
 * @author Ivan @ivanpopelyshev
 * @namespace PIXI.groupD8
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$b7bb6a2a8d203102 = {
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 0°       | East      |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ E: 0,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 45°↻     | Southeast |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ SE: 1,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 90°↻     | South     |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ S: 2,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 135°↻    | Southwest |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ SW: 3,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 180°     | West      |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ W: 4,
    /**
     * | Rotation    | Direction    |
     * |-------------|--------------|
     * | -135°/225°↻ | Northwest    |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ NW: 5,
    /**
     * | Rotation    | Direction    |
     * |-------------|--------------|
     * | -90°/270°↻  | North        |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ N: 6,
    /**
     * | Rotation    | Direction    |
     * |-------------|--------------|
     * | -45°/315°↻  | Northeast    |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ NE: 7,
    /**
     * Reflection about Y-axis.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ MIRROR_VERTICAL: 8,
    /**
     * Reflection about the main diagonal.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ MAIN_DIAGONAL: 10,
    /**
     * Reflection about X-axis.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ MIRROR_HORIZONTAL: 12,
    /**
     * Reflection about reverse diagonal.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ REVERSE_DIAGONAL: 14,
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The X-component of the U-axis
     *    after rotating the axes.
     */ uX: function(ind) {
        return $4ae0a6833d6839bf$var$ux[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The Y-component of the U-axis
     *    after rotating the axes.
     */ uY: function(ind) {
        return $4ae0a6833d6839bf$var$uy[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The X-component of the V-axis
     *    after rotating the axes.
     */ vX: function(ind) {
        return $4ae0a6833d6839bf$var$vx[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The Y-component of the V-axis
     *    after rotating the axes.
     */ vY: function(ind) {
        return $4ae0a6833d6839bf$var$vy[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
     *   is needed. Only rotations have opposite symmetries while
     *   reflections don't.
     * @return {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
     */ inv: function(rotation) {
        if (rotation & 8) return rotation & 15; // or rotation % 16
        return -rotation & 7; // or (8 - rotation) % 8
    },
    /**
     * Composes the two D8 operations.
     *
     * Taking `^` as reflection:
     *
     * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
     * |-------|-----|-----|-----|-----|------|-------|-------|-------|
     * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
     * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
     * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
     * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
     * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
     * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
     * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
     * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
     *
     * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
     *   is the row in the above cayley table.
     * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
     *   is the column in the above cayley table.
     * @return {PIXI.GD8Symmetry} Composed operation
     */ add: function(rotationSecond, rotationFirst) {
        return $4ae0a6833d6839bf$var$rotationCayley[rotationSecond][rotationFirst];
    },
    /**
     * Reverse of `add`.
     *
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
     * @param {PIXI.GD8Symmetry} rotationFirst - First operation
     * @return {PIXI.GD8Symmetry} Result
     */ sub: function(rotationSecond, rotationFirst) {
        return $4ae0a6833d6839bf$var$rotationCayley[rotationSecond][$4ae0a6833d6839bf$export$b7bb6a2a8d203102.inv(rotationFirst)];
    },
    /**
     * Adds 180 degrees to rotation, which is a commutative
     * operation.
     *
     * @memberof PIXI.groupD8
     * @param {number} rotation - The number to rotate.
     * @returns {number} Rotated number
     */ rotate180: function(rotation) {
        return rotation ^ 4;
    },
    /**
     * Checks if the rotation angle is vertical, i.e. south
     * or north. It doesn't work for reflections.
     *
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotation - The number to check.
     * @returns {boolean} Whether or not the direction is vertical
     */ isVertical: function(rotation) {
        return (rotation & 3) === 2;
    },
    /**
     * Approximates the vector `V(dx,dy)` into one of the
     * eight directions provided by `groupD8`.
     *
     * @memberof PIXI.groupD8
     * @param {number} dx - X-component of the vector
     * @param {number} dy - Y-component of the vector
     * @return {PIXI.GD8Symmetry} Approximation of the vector into
     *  one of the eight symmetries.
     */ byDirection: function(dx, dy) {
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.S;
            return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.E;
            return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.SE;
            return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.NE;
        return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.NW;
    },
    /**
     * Helps sprite to compensate texture packer rotation.
     *
     * @memberof PIXI.groupD8
     * @param {PIXI.Matrix} matrix - sprite world matrix
     * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
     * @param {number} tx - sprite anchoring
     * @param {number} ty - sprite anchoring
     */ matrixAppendRotationInv: function(matrix, rotation, tx, ty) {
        if (tx === void 0) tx = 0;
        if (ty === void 0) ty = 0;
        // Packer used "rotation", we use "inv(rotation)"
        var mat = $4ae0a6833d6839bf$var$rotationMatrices[$4ae0a6833d6839bf$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};
/**
 * Transform that takes care about its versions.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$563a914cafbdc389 = /** @class */ function() {
    function Transform() {
        this.worldTransform = new $4ae0a6833d6839bf$export$5b12bf1653c0dd85();
        this.localTransform = new $4ae0a6833d6839bf$export$5b12bf1653c0dd85();
        this.position = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.onChange, this, 0, 0);
        this.scale = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.onChange, this, 1, 1);
        this.pivot = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.onChange, this, 0, 0);
        this.skew = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.updateSkew, this, 0, 0);
        this._rotation = 0;
        this._cx = 1;
        this._sx = 0;
        this._cy = 0;
        this._sy = 1;
        this._localID = 0;
        this._currentLocalID = 0;
        this._worldID = 0;
        this._parentID = 0;
    }
    /** Called when a value changes. */ Transform.prototype.onChange = function() {
        this._localID++;
    };
    /** Called when the skew or the rotation changes. */ Transform.prototype.updateSkew = function() {
        this._cx = Math.cos(this._rotation + this.skew.y);
        this._sx = Math.sin(this._rotation + this.skew.y);
        this._cy = -Math.sin(this._rotation - this.skew.x); // cos, added PI/2
        this._sy = Math.cos(this._rotation - this.skew.x); // sin, added PI/2
        this._localID++;
    };
    Transform.prototype.toString = function() {
        return "[@pixi/math:Transform " + ("position=(" + this.position.x + ", " + this.position.y + ") ") + ("rotation=" + this.rotation + " ") + ("scale=(" + this.scale.x + ", " + this.scale.y + ") ") + ("skew=(" + this.skew.x + ", " + this.skew.y + ") ") + "]";
    };
    /** Updates the local transformation matrix. */ Transform.prototype.updateLocalTransform = function() {
        var lt = this.localTransform;
        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale.x;
            lt.b = this._sx * this.scale.x;
            lt.c = this._cy * this.scale.y;
            lt.d = this._sy * this.scale.y;
            lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
            lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
            this._currentLocalID = this._localID;
            // force an update..
            this._parentID = -1;
        }
    };
    /**
     * Updates the local and the world transformation matrices.
     *
     * @param parentTransform - The parent transform
     */ Transform.prototype.updateTransform = function(parentTransform) {
        var lt = this.localTransform;
        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale.x;
            lt.b = this._sx * this.scale.x;
            lt.c = this._cy * this.scale.y;
            lt.d = this._sy * this.scale.y;
            lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
            lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
            this._currentLocalID = this._localID;
            // force an update..
            this._parentID = -1;
        }
        if (this._parentID !== parentTransform._worldID) {
            // concat the parent matrix with the objects transform.
            var pt = parentTransform.worldTransform;
            var wt = this.worldTransform;
            wt.a = lt.a * pt.a + lt.b * pt.c;
            wt.b = lt.a * pt.b + lt.b * pt.d;
            wt.c = lt.c * pt.a + lt.d * pt.c;
            wt.d = lt.c * pt.b + lt.d * pt.d;
            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
            this._parentID = parentTransform._worldID;
            // update the id of the transform..
            this._worldID++;
        }
    };
    /**
     * Decomposes a matrix and sets the transforms properties based on it.
     *
     * @param matrix - The matrix to decompose
     */ Transform.prototype.setFromMatrix = function(matrix) {
        matrix.decompose(this);
        this._localID++;
    };
    Object.defineProperty(Transform.prototype, "rotation", {
        /** The rotation of the object in radians. */ get: function() {
            return this._rotation;
        },
        set: function(value) {
            if (this._rotation !== value) {
                this._rotation = value;
                this.updateSkew();
            }
        },
        enumerable: false,
        configurable: true
    });
    /** A default (identity) transform. */ Transform.IDENTITY = new Transform();
    return Transform;
}();

});



parcelRegister("5q3yV", function(module, exports) {

$parcel$export(module.exports, "InteractionData", function () { return $3f2224d8df498ec4$export$73b9be86c227b464; });
$parcel$export(module.exports, "InteractionEvent", function () { return $3f2224d8df498ec4$export$5b6496a0e009b82d; });
$parcel$export(module.exports, "InteractionTrackingData", function () { return $3f2224d8df498ec4$export$656983b0c6f240c; });
$parcel$export(module.exports, "interactiveTarget", function () { return $3f2224d8df498ec4$export$90530c38f30e38c5; });
$parcel$export(module.exports, "InteractionManager", function () { return $3f2224d8df498ec4$export$aaa80641d584351c; });
/*!
 * @pixi/interaction - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/interaction is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6qzqq = parcelRequire("6qzqq");

var $3YyWq = parcelRequire("3YyWq");

var $8t5Gy = parcelRequire("8t5Gy");
parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");
/**
 * Holds all information related to an Interaction event
 *
 * @class
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$73b9be86c227b464 = /** @class */ function() {
    function InteractionData() {
        this.pressure = 0;
        this.rotationAngle = 0;
        this.twist = 0;
        this.tangentialPressure = 0;
        /**
         * This point stores the global coords of where the touch/mouse event happened
         *
         * @member {PIXI.Point}
         */ this.global = new (0, $6qzqq.Point)();
        /**
         * The target Sprite that was interacted with
         *
         * @member {PIXI.Sprite}
         */ this.target = null;
        /**
         * When passed to an event handler, this will be the original DOM Event that was captured
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
         * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
         * @member {MouseEvent|TouchEvent|PointerEvent}
         */ this.originalEvent = null;
        /**
         * Unique identifier for this interaction
         *
         * @member {number}
         */ this.identifier = null;
        /**
         * Indicates whether or not the pointer device that created the event is the primary pointer.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
         * @type {Boolean}
         */ this.isPrimary = false;
        /**
         * Indicates which button was pressed on the mouse or pointer device to trigger the event.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
         * @type {number}
         */ this.button = 0;
        /**
         * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
         * @type {number}
         */ this.buttons = 0;
        /**
         * The width of the pointer's contact along the x-axis, measured in CSS pixels.
         * radiusX of TouchEvents will be represented by this value.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
         * @type {number}
         */ this.width = 0;
        /**
         * The height of the pointer's contact along the y-axis, measured in CSS pixels.
         * radiusY of TouchEvents will be represented by this value.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
         * @type {number}
         */ this.height = 0;
        /**
         * The angle, in degrees, between the pointer device and the screen.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
         * @type {number}
         */ this.tiltX = 0;
        /**
         * The angle, in degrees, between the pointer device and the screen.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
         * @type {number}
         */ this.tiltY = 0;
        /**
         * The type of pointer that triggered the event.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
         * @type {string}
         */ this.pointerType = null;
        /**
         * Pressure applied by the pointing device during the event. A Touch's force property
         * will be represented by this value.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
         * @type {number}
         */ this.pressure = 0;
        /**
         * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
         * @type {number}
         */ this.rotationAngle = 0;
        /**
         * Twist of a stylus pointer.
         * @see https://w3c.github.io/pointerevents/#pointerevent-interface
         * @type {number}
         */ this.twist = 0;
        /**
         * Barrel pressure on a stylus pointer.
         * @see https://w3c.github.io/pointerevents/#pointerevent-interface
         * @type {number}
         */ this.tangentialPressure = 0;
    }
    Object.defineProperty(InteractionData.prototype, "pointerId", {
        /**
         * The unique identifier of the pointer. It will be the same as `identifier`.
         * @readonly
         * @member {number}
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
         */ get: function() {
            return this.identifier;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This will return the local coordinates of the specified displayObject for this InteractionData
     *
     * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
     *  coords off
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
     *  will create a new point)
     * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
     *  (otherwise will use the current global coords)
     * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
     *  to the DisplayObject
     */ InteractionData.prototype.getLocalPosition = function(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
    };
    /**
     * Copies properties from normalized event data.
     *
     * @param {Touch|MouseEvent|PointerEvent} event - The normalized event data
     */ InteractionData.prototype.copyEvent = function(event) {
        // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
        // it with "false" on later events when our shim for it on touch events might not be
        // accurate
        if ('isPrimary' in event && event.isPrimary) this.isPrimary = true;
        this.button = 'button' in event && event.button;
        // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
        // event.which property instead, which conveys the same information.
        var buttons = 'buttons' in event && event.buttons;
        this.buttons = Number.isInteger(buttons) ? buttons : 'which' in event && event.which;
        this.width = 'width' in event && event.width;
        this.height = 'height' in event && event.height;
        this.tiltX = 'tiltX' in event && event.tiltX;
        this.tiltY = 'tiltY' in event && event.tiltY;
        this.pointerType = 'pointerType' in event && event.pointerType;
        this.pressure = 'pressure' in event && event.pressure;
        this.rotationAngle = 'rotationAngle' in event && event.rotationAngle;
        this.twist = 'twist' in event && event.twist || 0;
        this.tangentialPressure = 'tangentialPressure' in event && event.tangentialPressure || 0;
    };
    /**
     * Resets the data for pooling.
     */ InteractionData.prototype.reset = function() {
        // isPrimary is the only property that we really need to reset - everything else is
        // guaranteed to be overwritten
        this.isPrimary = false;
    };
    return InteractionData;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $3f2224d8df498ec4$var$extendStatics = function(d, b) {
    $3f2224d8df498ec4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3f2224d8df498ec4$var$extendStatics(d, b);
};
function $3f2224d8df498ec4$var$__extends(d, b) {
    $3f2224d8df498ec4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Event class that mimics native DOM events.
 *
 * @class
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$5b6496a0e009b82d = /** @class */ function() {
    function InteractionEvent() {
        /**
         * Whether this event will continue propagating in the tree.
         *
         * Remaining events for the {@link stopsPropagatingAt} object
         * will still be dispatched.
         *
         * @member {boolean}
         */ this.stopped = false;
        /**
         * At which object this event stops propagating.
         *
         * @private
         * @member {PIXI.DisplayObject}
         */ this.stopsPropagatingAt = null;
        /**
         * Whether we already reached the element we want to
         * stop propagating at. This is important for delayed events,
         * where we start over deeper in the tree again.
         *
         * @private
         * @member {boolean}
         */ this.stopPropagationHint = false;
        /**
         * The object which caused this event to be dispatched.
         * For listener callback see {@link PIXI.InteractionEvent.currentTarget}.
         *
         * @member {PIXI.DisplayObject}
         */ this.target = null;
        /**
         * The object whose event listener’s callback is currently being invoked.
         *
         * @member {PIXI.DisplayObject}
         */ this.currentTarget = null;
        /**
         * Type of the event
         *
         * @member {string}
         */ this.type = null;
        /**
         * InteractionData related to this event
         *
         * @member {PIXI.InteractionData}
         */ this.data = null;
    }
    /**
     * Prevents event from reaching any objects other than the current object.
     *
     */ InteractionEvent.prototype.stopPropagation = function() {
        this.stopped = true;
        this.stopPropagationHint = true;
        this.stopsPropagatingAt = this.currentTarget;
    };
    /**
     * Resets the event.
     */ InteractionEvent.prototype.reset = function() {
        this.stopped = false;
        this.stopsPropagatingAt = null;
        this.stopPropagationHint = false;
        this.currentTarget = null;
        this.target = null;
    };
    return InteractionEvent;
}();
/**
 * DisplayObjects with the {@link PIXI.interactiveTarget} mixin use this class to track interactions
 *
 * @class
 * @private
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$656983b0c6f240c = /** @class */ function() {
    /**
     * @param {number} pointerId - Unique pointer id of the event
     * @private
     */ function InteractionTrackingData(pointerId) {
        this._pointerId = pointerId;
        this._flags = InteractionTrackingData.FLAGS.NONE;
    }
    /**
     *
     * @private
     * @param {number} flag - The interaction flag to set
     * @param {boolean} yn - Should the flag be set or unset
     */ InteractionTrackingData.prototype._doSet = function(flag, yn) {
        if (yn) this._flags = this._flags | flag;
        else this._flags = this._flags & ~flag;
    };
    Object.defineProperty(InteractionTrackingData.prototype, "pointerId", {
        /**
         * Unique pointer id of the event
         *
         * @readonly
         * @private
         * @member {number}
         */ get: function() {
            return this._pointerId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "flags", {
        /**
         * State of the tracking data, expressed as bit flags
         *
         * @private
         * @member {number}
         */ get: function() {
            return this._flags;
        },
        set: function(flags) {
            this._flags = flags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "none", {
        /**
         * Is the tracked event inactive (not over or down)?
         *
         * @private
         * @member {number}
         */ get: function() {
            return this._flags === InteractionTrackingData.FLAGS.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "over", {
        /**
         * Is the tracked event over the DisplayObject?
         *
         * @private
         * @member {boolean}
         */ get: function() {
            return (this._flags & InteractionTrackingData.FLAGS.OVER) !== 0;
        },
        set: function(yn) {
            this._doSet(InteractionTrackingData.FLAGS.OVER, yn);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "rightDown", {
        /**
         * Did the right mouse button come down in the DisplayObject?
         *
         * @private
         * @member {boolean}
         */ get: function() {
            return (this._flags & InteractionTrackingData.FLAGS.RIGHT_DOWN) !== 0;
        },
        set: function(yn) {
            this._doSet(InteractionTrackingData.FLAGS.RIGHT_DOWN, yn);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "leftDown", {
        /**
         * Did the left mouse button come down in the DisplayObject?
         *
         * @private
         * @member {boolean}
         */ get: function() {
            return (this._flags & InteractionTrackingData.FLAGS.LEFT_DOWN) !== 0;
        },
        set: function(yn) {
            this._doSet(InteractionTrackingData.FLAGS.LEFT_DOWN, yn);
        },
        enumerable: false,
        configurable: true
    });
    InteractionTrackingData.FLAGS = Object.freeze({
        NONE: 0,
        OVER: 1,
        LEFT_DOWN: 2,
        RIGHT_DOWN: 4
    });
    return InteractionTrackingData;
}();
/**
 * Strategy how to search through stage tree for interactive objects
 *
 * @private
 * @class
 * @memberof PIXI
 */ var $3f2224d8df498ec4$var$TreeSearch = /** @class */ function() {
    function TreeSearch() {
        this._tempPoint = new (0, $6qzqq.Point)();
    }
    /**
     * Recursive implementation for findHit
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
     * @param {boolean} [interactive] - Whether the displayObject is interactive
     * @return {boolean} returns true if the displayObject hit the point
     */ TreeSearch.prototype.recursiveFindHit = function(interactionEvent, displayObject, func, hitTest, interactive) {
        if (!displayObject || !displayObject.visible) return false;
        var point = interactionEvent.data.global;
        // Took a little while to rework this function correctly! But now it is done and nice and optimized! ^_^
        //
        // This function will now loop through all objects and then only hit test the objects it HAS
        // to, not all of them. MUCH faster..
        // An object will be hit test if the following is true:
        //
        // 1: It is interactive.
        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
        //
        // As another little optimization once an interactive object has been hit we can carry on
        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
        // A final optimization is that an object is not hit test directly if a child has already been hit.
        interactive = displayObject.interactive || interactive;
        var hit = false;
        var interactiveParent = interactive;
        // Flag here can set to false if the event is outside the parents hitArea or mask
        var hitTestChildren = true;
        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
        // There is also no longer a need to hitTest children.
        if (displayObject.hitArea) {
            if (hitTest) {
                displayObject.worldTransform.applyInverse(point, this._tempPoint);
                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
                    hitTest = false;
                    hitTestChildren = false;
                } else hit = true;
            }
            interactiveParent = false;
        } else if (displayObject._mask) {
            if (hitTest) {
                if (!(displayObject._mask.containsPoint && displayObject._mask.containsPoint(point))) hitTest = false;
            }
        }
        // ** FREE TIP **! If an object is not interactive or has no buttons in it
        // (such as a game scene!) set interactiveChildren to false for that displayObject.
        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
            var children = displayObject.children;
            for(var i = children.length - 1; i >= 0; i--){
                var child = children[i];
                // time to get recursive.. if this function will return if something is hit..
                var childHit = this.recursiveFindHit(interactionEvent, child, func, hitTest, interactiveParent);
                if (childHit) {
                    // its a good idea to check if a child has lost its parent.
                    // this means it has been removed whilst looping so its best
                    if (!child.parent) continue;
                    // we no longer need to hit test any more objects in this container as we we
                    // now know the parent has been hit
                    interactiveParent = false;
                    // If the child is interactive , that means that the object hit was actually
                    // interactive and not just the child of an interactive object.
                    // This means we no longer need to hit test anything else. We still need to run
                    // through all objects, but we don't need to perform any hit tests.
                    if (childHit) {
                        if (interactionEvent.target) hitTest = false;
                        hit = true;
                    }
                }
            }
        }
        // no point running this if the item is not interactive or does not have an interactive parent.
        if (interactive) {
            // if we are hit testing (as in we have no hit any objects yet)
            // We also don't need to worry about hit testing if once of the displayObjects children
            // has already been hit - but only if it was interactive, otherwise we need to keep
            // looking for an interactive child, just in case we hit one
            if (hitTest && !interactionEvent.target) {
                // already tested against hitArea if it is defined
                if (!displayObject.hitArea && displayObject.containsPoint) {
                    if (displayObject.containsPoint(point)) hit = true;
                }
            }
            if (displayObject.interactive) {
                if (hit && !interactionEvent.target) interactionEvent.target = displayObject;
                if (func) func(interactionEvent, displayObject, !!hit);
            }
        }
        return hit;
    };
    /**
     * This function is provides a neat way of crawling through the scene graph and running a
     * specified function on all interactive objects it finds. It will also take care of hit
     * testing the interactive objects and passes the hit across in the function.
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
     * @return {boolean} returns true if the displayObject hit the point
     */ TreeSearch.prototype.findHit = function(interactionEvent, displayObject, func, hitTest) {
        this.recursiveFindHit(interactionEvent, displayObject, func, hitTest, false);
    };
    return TreeSearch;
}();
/**
 * Interface for classes that represent a hit area.
 *
 * It is implemented by the following classes:
 * - {@link PIXI.Circle}
 * - {@link PIXI.Ellipse}
 * - {@link PIXI.Polygon}
 * - {@link PIXI.RoundedRectangle}
 *
 * @interface IHitArea
 * @memberof PIXI
 */ /**
 * Checks whether the x and y coordinates given are contained within this area
 *
 * @method
 * @name contains
 * @memberof PIXI.IHitArea#
 * @param {number} x - The X coordinate of the point to test
 * @param {number} y - The Y coordinate of the point to test
 * @return {boolean} Whether the x/y coordinates are within this area
 */ /**
 * Default property values of interactive objects
 * Used by {@link PIXI.InteractionManager} to automatically give all DisplayObjects these properties
 *
 * @private
 * @name interactiveTarget
 * @type {Object}
 * @memberof PIXI
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          DisplayObject.prototype,
 *          PIXI.interactiveTarget
 *      );
 */ var $3f2224d8df498ec4$export$90530c38f30e38c5 = {
    interactive: false,
    interactiveChildren: true,
    hitArea: null,
    /**
     * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
     * Setting this changes the 'cursor' property to `'pointer'`.
     *
     * @example
     * const sprite = new PIXI.Sprite(texture);
     * sprite.interactive = true;
     * sprite.buttonMode = true;
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */ get buttonMode () {
        return this.cursor === 'pointer';
    },
    set buttonMode (value){
        if (value) this.cursor = 'pointer';
        else if (this.cursor === 'pointer') this.cursor = null;
    },
    /**
     * This defines what cursor mode is used when the mouse cursor
     * is hovered over the displayObject.
     *
     * @example
     * const sprite = new PIXI.Sprite(texture);
     * sprite.interactive = true;
     * sprite.cursor = 'wait';
     * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     */ cursor: null,
    /**
     * Internal set of all active pointers, by identifier
     *
     * @member {Map<number, InteractionTrackingData>}
     * @memberof PIXI.DisplayObject#
     * @private
     */ get trackedPointers () {
        if (this._trackedPointers === undefined) this._trackedPointers = {};
        return this._trackedPointers;
    },
    /**
     * Map of all tracked pointers, by identifier. Use trackedPointers to access.
     *
     * @private
     * @type {Map<number, InteractionTrackingData>}
     */ _trackedPointers: undefined
};
// Mix interactiveTarget into DisplayObject.prototype
(0, $8t5Gy.DisplayObject).mixin($3f2224d8df498ec4$export$90530c38f30e38c5);
var $3f2224d8df498ec4$var$MOUSE_POINTER_ID = 1;
// helpers for hitTest() - only used inside hitTest()
var $3f2224d8df498ec4$var$hitTestEvent = {
    target: null,
    data: {
        global: null
    }
};
/**
 * The interaction manager deals with mouse, touch and pointer events.
 *
 * Any DisplayObject can be interactive if its `interactive` property is set to true.
 *
 * This manager also supports multitouch.
 *
 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.interaction`
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$aaa80641d584351c = /** @class */ function(_super) {
    $3f2224d8df498ec4$var$__extends(InteractionManager, _super);
    /**
     * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
     * @param {object} [options] - The options for the manager.
     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
     * @param {number} [options.interactionFrequency=10] - Maximum frequency (ms) at pointer over/out states will be checked.
     * @param {number} [options.useSystemTicker=true] - Whether to add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
     */ function InteractionManager(renderer, options) {
        var _this = _super.call(this) || this;
        options = options || {};
        /**
         * The renderer this interaction manager works for.
         *
         * @member {PIXI.AbstractRenderer}
         */ _this.renderer = renderer;
        /**
         * Should default browser actions automatically be prevented.
         * Does not apply to pointer events for backwards compatibility
         * preventDefault on pointer events stops mouse events from firing
         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
         *
         * @member {boolean}
         * @default true
         */ _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
        /**
         * Maximum frequency in milliseconds at which pointer over/out states will be checked by {@link tickerUpdate}.
         *
         * @member {number}
         * @default 10
         */ _this.interactionFrequency = options.interactionFrequency || 10;
        /**
         * The mouse data
         *
         * @member {PIXI.InteractionData}
         */ _this.mouse = new $3f2224d8df498ec4$export$73b9be86c227b464();
        _this.mouse.identifier = $3f2224d8df498ec4$var$MOUSE_POINTER_ID;
        // setting the mouse to start off far off screen will mean that mouse over does
        //  not get called before we even move the mouse.
        _this.mouse.global.set(-999999);
        /**
         * Actively tracked InteractionData
         *
         * @private
         * @member {Object.<number,PIXI.InteractionData>}
         */ _this.activeInteractionData = {};
        _this.activeInteractionData[$3f2224d8df498ec4$var$MOUSE_POINTER_ID] = _this.mouse;
        /**
         * Pool of unused InteractionData
         *
         * @private
         * @member {PIXI.InteractionData[]}
         */ _this.interactionDataPool = [];
        /**
         * An event data object to handle all the event tracking/dispatching
         *
         * @member {object}
         */ _this.eventData = new $3f2224d8df498ec4$export$5b6496a0e009b82d();
        /**
         * The DOM element to bind to.
         *
         * @protected
         * @member {HTMLElement}
         */ _this.interactionDOMElement = null;
        /**
         * This property determines if mousemove and touchmove events are fired only when the cursor
         * is over the object.
         * Setting to true will make things work more in line with how the DOM version works.
         * Setting to false can make things easier for things like dragging
         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
         * future versions of pixi.
         *
         * @member {boolean}
         * @default false
         */ _this.moveWhenInside = false;
        /**
         * Have events been attached to the dom element?
         *
         * @protected
         * @member {boolean}
         */ _this.eventsAdded = false;
        /**
         * Has the system ticker been added?
         *
         * @protected
         * @member {boolean}
         */ _this.tickerAdded = false;
        /**
         * Is the mouse hovering over the renderer? If working in worker mouse considered to be over renderer by default.
         *
         * @protected
         * @member {boolean}
         */ _this.mouseOverRenderer = !('PointerEvent' in self);
        /**
         * Does the device support touch events
         * https://www.w3.org/TR/touch-events/
         *
         * @readonly
         * @member {boolean}
         */ _this.supportsTouchEvents = 'ontouchstart' in self;
        /**
         * Does the device support pointer events
         * https://www.w3.org/Submission/pointer-events/
         *
         * @readonly
         * @member {boolean}
         */ _this.supportsPointerEvents = !!self.PointerEvent;
        // this will make it so that you don't have to call bind all the time
        /**
         * @private
         * @member {Function}
         */ _this.onPointerUp = _this.onPointerUp.bind(_this);
        _this.processPointerUp = _this.processPointerUp.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerCancel = _this.onPointerCancel.bind(_this);
        _this.processPointerCancel = _this.processPointerCancel.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerDown = _this.onPointerDown.bind(_this);
        _this.processPointerDown = _this.processPointerDown.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerMove = _this.onPointerMove.bind(_this);
        _this.processPointerMove = _this.processPointerMove.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerOut = _this.onPointerOut.bind(_this);
        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerOver = _this.onPointerOver.bind(_this);
        /**
         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
         * and functions are called instead of changing the CSS.
         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
         * @member {Object.<string, Object>}
         */ _this.cursorStyles = {
            default: 'inherit',
            pointer: 'pointer'
        };
        /**
         * The mode of the cursor that is being used.
         * The value of this is a key from the cursorStyles dictionary.
         *
         * @member {string}
         */ _this.currentCursorMode = null;
        /**
         * Internal cached let.
         *
         * @private
         * @member {string}
         */ _this.cursor = null;
        /**
         * The current resolution / device pixel ratio.
         *
         * @member {number}
         * @default 1
         */ _this.resolution = 1;
        /**
         * Delayed pointer events. Used to guarantee correct ordering of over/out events.
         *
         * @private
         * @member {Array}
         */ _this.delayedEvents = [];
        /**
         * TreeSearch component that is used to hitTest stage tree
         *
         * @private
         * @member {PIXI.TreeSearch}
         */ _this.search = new $3f2224d8df498ec4$var$TreeSearch();
        /**
         * Used as a last rendered object in case renderer doesnt have _lastObjectRendered
         * @member {DisplayObject}
         * @private
         */ _this._tempDisplayObject = new (0, $8t5Gy.TemporaryDisplayObject)();
        /**
         * An options object specifies characteristics about the event listener.
         * @private
         * @readonly
         * @member {Object.<string, boolean>}
         */ _this._eventListenerOptions = {
            capture: true,
            passive: false
        };
        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
         * object.
         *
         * @event PIXI.InteractionManager#mousedown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object.
         *
         * @event PIXI.InteractionManager#rightdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object.
         *
         * @event PIXI.InteractionManager#mouseup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object.
         *
         * @event PIXI.InteractionManager#rightup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object.
         *
         * @event PIXI.InteractionManager#click
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object.
         *
         * @event PIXI.InteractionManager#rightclick
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.InteractionManager#event:mousedown}.
         *
         * @event PIXI.InteractionManager#mouseupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.InteractionManager#event:rightdown}.
         *
         * @event PIXI.InteractionManager#rightupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object
         *
         * @event PIXI.InteractionManager#mousemove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object
         *
         * @event PIXI.InteractionManager#mouseover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved off the display object
         *
         * @event PIXI.InteractionManager#mouseout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed on the display object.
         *
         * @event PIXI.InteractionManager#pointerdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released over the display object.
         * Not always fired when some buttons are held down while others are released. In those cases,
         * use [mousedown]{@link PIXI.InteractionManager#event:mousedown} and
         * [mouseup]{@link PIXI.InteractionManager#event:mouseup} instead.
         *
         * @event PIXI.InteractionManager#pointerup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a pointer event
         *
         * @event PIXI.InteractionManager#pointercancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed and released on the display object.
         *
         * @event PIXI.InteractionManager#pointertap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.InteractionManager#event:pointerdown}.
         *
         * @event PIXI.InteractionManager#pointerupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved while over the display object
         *
         * @event PIXI.InteractionManager#pointermove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved onto the display object
         *
         * @event PIXI.InteractionManager#pointerover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved off the display object
         *
         * @event PIXI.InteractionManager#pointerout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed on the display object.
         *
         * @event PIXI.InteractionManager#touchstart
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed from the display object.
         *
         * @event PIXI.InteractionManager#touchend
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a touch
         *
         * @event PIXI.InteractionManager#touchcancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed and removed from the display object.
         *
         * @event PIXI.InteractionManager#tap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.InteractionManager#event:touchstart}.
         *
         * @event PIXI.InteractionManager#touchendoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is moved along the display object.
         *
         * @event PIXI.InteractionManager#touchmove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mousedown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#click
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightclick
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mousemove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a pointer event.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointercancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed and released on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointertap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointermove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchstart
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchend
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a touch.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchcancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed and removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#tap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchendoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is moved along the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchmove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ _this._useSystemTicker = options.useSystemTicker !== undefined ? options.useSystemTicker : true;
        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);
        return _this;
    }
    Object.defineProperty(InteractionManager.prototype, "useSystemTicker", {
        /**
         * Should the InteractionManager automatically add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
         *
         * @member {boolean}
         * @default true
         */ get: function() {
            return this._useSystemTicker;
        },
        set: function(useSystemTicker) {
            this._useSystemTicker = useSystemTicker;
            if (useSystemTicker) this.addTickerListener();
            else this.removeTickerListener();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionManager.prototype, "lastObjectRendered", {
        /**
         * Last rendered object or temp object
         * @readonly
         * @protected
         * @member {PIXI.DisplayObject}
         */ get: function() {
            return this.renderer._lastObjectRendered || this._tempDisplayObject;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Hit tests a point against the display tree, returning the first interactive object that is hit.
     *
     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
     * to the last rendered root of the associated renderer.
     * @return {PIXI.DisplayObject} The hit display object, if any.
     */ InteractionManager.prototype.hitTest = function(globalPoint, root) {
        // clear the target for our hit test
        $3f2224d8df498ec4$var$hitTestEvent.target = null;
        // assign the global point
        $3f2224d8df498ec4$var$hitTestEvent.data.global = globalPoint;
        // ensure safety of the root
        if (!root) root = this.lastObjectRendered;
        // run the hit test
        this.processInteractive($3f2224d8df498ec4$var$hitTestEvent, root, null, true);
        // return our found object - it'll be null if we didn't hit anything
        return $3f2224d8df498ec4$var$hitTestEvent.target;
    };
    /**
     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to delegate
     * another DOM element to receive those events.
     *
     * @param {HTMLElement} element - the DOM element which will receive mouse and touch events.
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
     */ InteractionManager.prototype.setTargetElement = function(element, resolution) {
        if (resolution === void 0) resolution = 1;
        this.removeTickerListener();
        this.removeEvents();
        this.interactionDOMElement = element;
        this.resolution = resolution;
        this.addEvents();
        this.addTickerListener();
    };
    /**
     * Add the ticker listener
     *
     * @private
     */ InteractionManager.prototype.addTickerListener = function() {
        if (this.tickerAdded || !this.interactionDOMElement || !this._useSystemTicker) return;
        (0, $3YyWq.Ticker).system.add(this.tickerUpdate, this, (0, $3YyWq.UPDATE_PRIORITY).INTERACTION);
        this.tickerAdded = true;
    };
    /**
     * Remove the ticker listener
     *
     * @private
     */ InteractionManager.prototype.removeTickerListener = function() {
        if (!this.tickerAdded) return;
        (0, $3YyWq.Ticker).system.remove(this.tickerUpdate, this);
        this.tickerAdded = false;
    };
    /**
     * Registers all the DOM events
     *
     * @private
     */ InteractionManager.prototype.addEvents = function() {
        if (this.eventsAdded || !this.interactionDOMElement) return;
        var style = this.interactionDOMElement.style;
        if (self.navigator.msPointerEnabled) {
            style.msContentZooming = 'none';
            style.msTouchAction = 'none';
        } else if (this.supportsPointerEvents) style.touchAction = 'none';
        /*
         * These events are added first, so that if pointer events are normalized, they are fired
         * in the same order as non-normalized events. ie. pointer event 1st, mouse / touch 2nd
         */ if (this.supportsPointerEvents) {
            self.document.addEventListener('pointermove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, this._eventListenerOptions);
            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
            // we already handle those, so for the purposes of what we do in onPointerOut, we only
            // care about the pointerleave event
            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, this._eventListenerOptions);
            self.addEventListener('pointercancel', this.onPointerCancel, this._eventListenerOptions);
            self.addEventListener('pointerup', this.onPointerUp, this._eventListenerOptions);
        } else {
            self.document.addEventListener('mousemove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, this._eventListenerOptions);
            self.addEventListener('mouseup', this.onPointerUp, this._eventListenerOptions);
        }
        // always look directly for touch events so that we can provide original data
        // In a future version we should change this to being just a fallback and rely solely on
        // PointerEvents whenever available
        if (this.supportsTouchEvents) {
            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, this._eventListenerOptions);
        }
        this.eventsAdded = true;
    };
    /**
     * Removes all the DOM events that were previously registered
     *
     * @private
     */ InteractionManager.prototype.removeEvents = function() {
        if (!this.eventsAdded || !this.interactionDOMElement) return;
        var style = this.interactionDOMElement.style;
        if (self.navigator.msPointerEnabled) {
            style.msContentZooming = '';
            style.msTouchAction = '';
        } else if (this.supportsPointerEvents) style.touchAction = '';
        if (this.supportsPointerEvents) {
            self.document.removeEventListener('pointermove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, this._eventListenerOptions);
            self.removeEventListener('pointercancel', this.onPointerCancel, this._eventListenerOptions);
            self.removeEventListener('pointerup', this.onPointerUp, this._eventListenerOptions);
        } else {
            self.document.removeEventListener('mousemove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, this._eventListenerOptions);
            self.removeEventListener('mouseup', this.onPointerUp, this._eventListenerOptions);
        }
        if (this.supportsTouchEvents) {
            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, this._eventListenerOptions);
        }
        this.interactionDOMElement = null;
        this.eventsAdded = false;
    };
    /**
     * Updates the state of interactive objects if at least {@link interactionFrequency}
     * milliseconds have passed since the last invocation.
     *
     * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
     *
     * @param {number} deltaTime - time delta since the last call
     */ InteractionManager.prototype.tickerUpdate = function(deltaTime) {
        this._deltaTime += deltaTime;
        if (this._deltaTime < this.interactionFrequency) return;
        this._deltaTime = 0;
        this.update();
    };
    /**
     * Updates the state of interactive objects.
     */ InteractionManager.prototype.update = function() {
        if (!this.interactionDOMElement) return;
        // if the user move the mouse this check has already been done using the mouse move!
        if (this._didMove) {
            this._didMove = false;
            return;
        }
        this.cursor = null;
        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
        // but there was a scenario of a display object moving under a static mouse cursor.
        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
        for(var k in this.activeInteractionData)// eslint-disable-next-line no-prototype-builtins
        if (this.activeInteractionData.hasOwnProperty(k)) {
            var interactionData = this.activeInteractionData[k];
            if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
                var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);
                this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerOverOut, true);
            }
        }
        this.setCursorMode(this.cursor);
    };
    /**
     * Sets the current cursor mode, handling any callbacks or CSS style changes.
     *
     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
     */ InteractionManager.prototype.setCursorMode = function(mode) {
        mode = mode || 'default';
        var applyStyles = true;
        // offscreen canvas does not support setting styles, but cursor modes can be functions,
        // in order to handle pixi rendered cursors, so we can't bail
        if (self.OffscreenCanvas && this.interactionDOMElement instanceof OffscreenCanvas) applyStyles = false;
        // if the mode didn't actually change, bail early
        if (this.currentCursorMode === mode) return;
        this.currentCursorMode = mode;
        var style = this.cursorStyles[mode];
        // only do things if there is a cursor style for it
        if (style) switch(typeof style){
            case 'string':
                // string styles are handled as cursor CSS
                if (applyStyles) this.interactionDOMElement.style.cursor = style;
                break;
            case 'function':
                // functions are just called, and passed the cursor mode
                style(mode);
                break;
            case 'object':
                // if it is an object, assume that it is a dictionary of CSS styles,
                // apply it to the interactionDOMElement
                if (applyStyles) Object.assign(this.interactionDOMElement.style, style);
                break;
        }
        else if (applyStyles && typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
        // for the mode, then assume that the dev wants it to be CSS for the cursor.
        this.interactionDOMElement.style.cursor = mode;
    };
    /**
     * Dispatches an event on the display object that was interacted with
     *
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the display object in question
     * @param {string} eventString - the name of the event (e.g, mousedown)
     * @param {PIXI.InteractionEvent} eventData - the event data object
     * @private
     */ InteractionManager.prototype.dispatchEvent = function(displayObject, eventString, eventData) {
        // Even if the event was stopped, at least dispatch any remaining events
        // for the same display object.
        if (!eventData.stopPropagationHint || displayObject === eventData.stopsPropagatingAt) {
            eventData.currentTarget = displayObject;
            eventData.type = eventString;
            displayObject.emit(eventString, eventData);
            if (displayObject[eventString]) displayObject[eventString](eventData);
        }
    };
    /**
     * Puts a event on a queue to be dispatched later. This is used to guarantee correct
     * ordering of over/out events.
     *
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the display object in question
     * @param {string} eventString - the name of the event (e.g, mousedown)
     * @param {object} eventData - the event data object
     * @private
     */ InteractionManager.prototype.delayDispatchEvent = function(displayObject, eventString, eventData) {
        this.delayedEvents.push({
            displayObject: displayObject,
            eventString: eventString,
            eventData: eventData
        });
    };
    /**
     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
     * resulting value is stored in the point. This takes into account the fact that the DOM
     * element could be scaled and positioned anywhere on the screen.
     *
     * @param  {PIXI.IPointData} point - the point that the result will be stored in
     * @param  {number} x - the x coord of the position to map
     * @param  {number} y - the y coord of the position to map
     */ InteractionManager.prototype.mapPositionToPoint = function(point, x, y) {
        var rect;
        // IE 11 fix
        if (!this.interactionDOMElement.parentElement) rect = {
            x: 0,
            y: 0,
            width: this.interactionDOMElement.width,
            height: this.interactionDOMElement.height,
            left: 0,
            top: 0
        };
        else rect = this.interactionDOMElement.getBoundingClientRect();
        var resolutionMultiplier = 1.0 / this.resolution;
        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
    };
    /**
     * This function is provides a neat way of crawling through the scene graph and running a
     * specified function on all interactive objects it finds. It will also take care of hit
     * testing the interactive objects and passes the hit across in the function.
     *
     * @protected
     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - indicates whether we want to calculate hits
     *  or just iterate through all interactive objects
     */ InteractionManager.prototype.processInteractive = function(interactionEvent, displayObject, func, hitTest) {
        var hit = this.search.findHit(interactionEvent, displayObject, func, hitTest);
        var delayedEvents = this.delayedEvents;
        if (!delayedEvents.length) return hit;
        // Reset the propagation hint, because we start deeper in the tree again.
        interactionEvent.stopPropagationHint = false;
        var delayedLen = delayedEvents.length;
        this.delayedEvents = [];
        for(var i = 0; i < delayedLen; i++){
            var _a = delayedEvents[i], displayObject_1 = _a.displayObject, eventString = _a.eventString, eventData = _a.eventData;
            // When we reach the object we wanted to stop propagating at,
            // set the propagation hint.
            if (eventData.stopsPropagatingAt === displayObject_1) eventData.stopPropagationHint = true;
            this.dispatchEvent(displayObject_1, eventString, eventData);
        }
        return hit;
    };
    /**
     * Is called when the pointer button is pressed down on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
     */ InteractionManager.prototype.onPointerDown = function(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
        var events = this.normalizeToPointerData(originalEvent);
        /*
         * No need to prevent default on natural pointer events, as there are no side effects
         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
         * so still need to be prevented.
         */ // Guaranteed that there will be at least one event in events, and all events must have the same pointer type
        if (this.autoPreventDefault && events[0].isNormalized) {
            var cancelable = originalEvent.cancelable || !('cancelable' in originalEvent);
            if (cancelable) originalEvent.preventDefault();
        }
        var eventLen = events.length;
        for(var i = 0; i < eventLen; i++){
            var event = events[i];
            var interactionData = this.getInteractionDataForPointerId(event);
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
            interactionEvent.data.originalEvent = originalEvent;
            this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerDown, true);
            this.emit('pointerdown', interactionEvent);
            if (event.pointerType === 'touch') this.emit('touchstart', interactionEvent);
            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                var isRightButton = event.button === 2;
                this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
            }
        }
    };
    /**
     * Processes the result of the pointer down check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerDown = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        if (hit) {
            if (!displayObject.trackedPointers[id]) displayObject.trackedPointers[id] = new $3f2224d8df498ec4$export$656983b0c6f240c(id);
            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);
            if (data.pointerType === 'touch') this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
            else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
                var isRightButton = data.button === 2;
                if (isRightButton) displayObject.trackedPointers[id].rightDown = true;
                else displayObject.trackedPointers[id].leftDown = true;
                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
            }
        }
    };
    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
     * @param {boolean} cancelled - true if the pointer is cancelled
     * @param {Function} func - Function passed to {@link processInteractive}
     */ InteractionManager.prototype.onPointerComplete = function(originalEvent, cancelled, func) {
        var events = this.normalizeToPointerData(originalEvent);
        var eventLen = events.length;
        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
        // in all cases (unless it was a pointercancel)
        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';
        for(var i = 0; i < eventLen; i++){
            var event = events[i];
            var interactionData = this.getInteractionDataForPointerId(event);
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
            interactionEvent.data.originalEvent = originalEvent;
            // perform hit testing for events targeting our canvas or cancel events
            this.processInteractive(interactionEvent, this.lastObjectRendered, func, cancelled || !eventAppend);
            this.emit(cancelled ? 'pointercancel' : "pointerup" + eventAppend, interactionEvent);
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                var isRightButton = event.button === 2;
                this.emit(isRightButton ? "rightup" + eventAppend : "mouseup" + eventAppend, interactionEvent);
            } else if (event.pointerType === 'touch') {
                this.emit(cancelled ? 'touchcancel' : "touchend" + eventAppend, interactionEvent);
                this.releaseInteractionDataForPointerId(event.pointerId);
            }
        }
    };
    /**
     * Is called when the pointer button is cancelled
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */ InteractionManager.prototype.onPointerCancel = function(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
        this.onPointerComplete(event, true, this.processPointerCancel);
    };
    /**
     * Processes the result of the pointer cancel check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     */ InteractionManager.prototype.processPointerCancel = function(interactionEvent, displayObject) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        if (displayObject.trackedPointers[id] !== undefined) {
            delete displayObject.trackedPointers[id];
            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);
            if (data.pointerType === 'touch') this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
        }
    };
    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */ InteractionManager.prototype.onPointerUp = function(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
        this.onPointerComplete(event, false, this.processPointerUp);
    };
    /**
     * Processes the result of the pointer up check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerUp = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        var trackingData = displayObject.trackedPointers[id];
        var isTouch = data.pointerType === 'touch';
        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        // need to track mouse down status in the mouse block so that we can emit
        // event in a later block
        var isMouseTap = false;
        // Mouse only
        if (isMouse) {
            var isRightButton = data.button === 2;
            var flags = $3f2224d8df498ec4$export$656983b0c6f240c.FLAGS;
            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;
            var isDown = trackingData !== undefined && trackingData.flags & test;
            if (hit) {
                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);
                if (isDown) {
                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
                    isMouseTap = true;
                }
            } else if (isDown) this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
            // update the down state of the tracking data
            if (trackingData) {
                if (isRightButton) trackingData.rightDown = false;
                else trackingData.leftDown = false;
            }
        }
        // Pointers and Touches, and Mouse
        if (hit) {
            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);
            if (trackingData) {
                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
                if (!isMouse || isMouseTap) this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
                if (isTouch) {
                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
                    // touches are no longer over (if they ever were) when we get the touchend
                    // so we should ensure that we don't keep pretending that they are
                    trackingData.over = false;
                }
            }
        } else if (trackingData) {
            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
        }
        // Only remove the tracking data if there is no over/down state still associated with it
        if (trackingData && trackingData.none) delete displayObject.trackedPointers[id];
    };
    /**
     * Is called when the pointer moves across the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
     */ InteractionManager.prototype.onPointerMove = function(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
        var events = this.normalizeToPointerData(originalEvent);
        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
            this._didMove = true;
            this.cursor = null;
        }
        var eventLen = events.length;
        for(var i = 0; i < eventLen; i++){
            var event = events[i];
            var interactionData = this.getInteractionDataForPointerId(event);
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
            interactionEvent.data.originalEvent = originalEvent;
            this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerMove, true);
            this.emit('pointermove', interactionEvent);
            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
        }
        if (events[0].pointerType === 'mouse') this.setCursorMode(this.cursor);
    };
    /**
     * Processes the result of the pointer move check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerMove = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var isTouch = data.pointerType === 'touch';
        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        if (isMouse) this.processPointerOverOut(interactionEvent, displayObject, hit);
        if (!this.moveWhenInside || hit) {
            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
        }
    };
    /**
     * Is called when the pointer is moved out of the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
     */ InteractionManager.prototype.onPointerOut = function(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
        var events = this.normalizeToPointerData(originalEvent);
        // Only mouse and pointer can call onPointerOut, so events will always be length 1
        var event = events[0];
        if (event.pointerType === 'mouse') {
            this.mouseOverRenderer = false;
            this.setCursorMode(null);
        }
        var interactionData = this.getInteractionDataForPointerId(event);
        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
        interactionEvent.data.originalEvent = event;
        this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerOverOut, false);
        this.emit('pointerout', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mouseout', interactionEvent);
        else // we can get touchleave events after touchend, so we want to make sure we don't
        // introduce memory leaks
        this.releaseInteractionDataForPointerId(interactionData.identifier);
    };
    /**
     * Processes the result of the pointer over/out check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerOverOut = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        var trackingData = displayObject.trackedPointers[id];
        // if we just moused over the display object, then we need to track that state
        if (hit && !trackingData) trackingData = displayObject.trackedPointers[id] = new $3f2224d8df498ec4$export$656983b0c6f240c(id);
        if (trackingData === undefined) return;
        if (hit && this.mouseOverRenderer) {
            if (!trackingData.over) {
                trackingData.over = true;
                this.delayDispatchEvent(displayObject, 'pointerover', interactionEvent);
                if (isMouse) this.delayDispatchEvent(displayObject, 'mouseover', interactionEvent);
            }
            // only change the cursor if it has not already been changed (by something deeper in the
            // display tree)
            if (isMouse && this.cursor === null) this.cursor = displayObject.cursor;
        } else if (trackingData.over) {
            trackingData.over = false;
            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
            if (isMouse) this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
            // if there is no mouse down information for the pointer, then it is safe to delete
            if (trackingData.none) delete displayObject.trackedPointers[id];
        }
    };
    /**
     * Is called when the pointer is moved into the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
     */ InteractionManager.prototype.onPointerOver = function(originalEvent) {
        var events = this.normalizeToPointerData(originalEvent);
        // Only mouse and pointer can call onPointerOver, so events will always be length 1
        var event = events[0];
        var interactionData = this.getInteractionDataForPointerId(event);
        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
        interactionEvent.data.originalEvent = event;
        if (event.pointerType === 'mouse') this.mouseOverRenderer = true;
        this.emit('pointerover', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mouseover', interactionEvent);
    };
    /**
     * Get InteractionData for a given pointerId. Store that data as well
     *
     * @private
     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
     * @return {PIXI.InteractionData} - Interaction data for the given pointer identifier
     */ InteractionManager.prototype.getInteractionDataForPointerId = function(event) {
        var pointerId = event.pointerId;
        var interactionData;
        if (pointerId === $3f2224d8df498ec4$var$MOUSE_POINTER_ID || event.pointerType === 'mouse') interactionData = this.mouse;
        else if (this.activeInteractionData[pointerId]) interactionData = this.activeInteractionData[pointerId];
        else {
            interactionData = this.interactionDataPool.pop() || new $3f2224d8df498ec4$export$73b9be86c227b464();
            interactionData.identifier = pointerId;
            this.activeInteractionData[pointerId] = interactionData;
        }
        // copy properties from the event, so that we can make sure that touch/pointer specific
        // data is available
        interactionData.copyEvent(event);
        return interactionData;
    };
    /**
     * Return unused InteractionData to the pool, for a given pointerId
     *
     * @private
     * @param {number} pointerId - Identifier from a pointer event
     */ InteractionManager.prototype.releaseInteractionDataForPointerId = function(pointerId) {
        var interactionData = this.activeInteractionData[pointerId];
        if (interactionData) {
            delete this.activeInteractionData[pointerId];
            interactionData.reset();
            this.interactionDataPool.push(interactionData);
        }
    };
    /**
     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The event to be configured
     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
     * @param {PIXI.InteractionData} interactionData - The InteractionData that will be paired
     *        with the InteractionEvent
     * @return {PIXI.InteractionEvent} the interaction event that was passed in
     */ InteractionManager.prototype.configureInteractionEventForDOMEvent = function(interactionEvent, pointerEvent, interactionData) {
        interactionEvent.data = interactionData;
        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);
        // Not really sure why this is happening, but it's how a previous version handled things
        if (pointerEvent.pointerType === 'touch') {
            pointerEvent.globalX = interactionData.global.x;
            pointerEvent.globalY = interactionData.global.y;
        }
        interactionData.originalEvent = pointerEvent;
        interactionEvent.reset();
        return interactionEvent;
    };
    /**
     * Ensures that the original event object contains all data that a regular pointer event would have
     *
     * @private
     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
     */ InteractionManager.prototype.normalizeToPointerData = function(event) {
        var normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(var i = 0, li = event.changedTouches.length; i < li; i++){
            var touch = event.changedTouches[i];
            if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
            if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
            if (typeof touch.isPrimary === 'undefined') touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
            if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
            if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
            if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
            if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
            if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
            if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
            if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
            if (typeof touch.twist === 'undefined') touch.twist = 0;
            if (typeof touch.tangentialPressure === 'undefined') touch.tangentialPressure = 0;
            // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
            // support, and the fill ins are not quite the same
            // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
            // left is not 0,0 on the page
            if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
            if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;
            // mark the touch as normalized, just so that we know we did it
            touch.isNormalized = true;
            normalizedEvents.push(touch);
        }
        else if (!self.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof self.PointerEvent))) {
            var tempEvent = event;
            if (typeof tempEvent.isPrimary === 'undefined') tempEvent.isPrimary = true;
            if (typeof tempEvent.width === 'undefined') tempEvent.width = 1;
            if (typeof tempEvent.height === 'undefined') tempEvent.height = 1;
            if (typeof tempEvent.tiltX === 'undefined') tempEvent.tiltX = 0;
            if (typeof tempEvent.tiltY === 'undefined') tempEvent.tiltY = 0;
            if (typeof tempEvent.pointerType === 'undefined') tempEvent.pointerType = 'mouse';
            if (typeof tempEvent.pointerId === 'undefined') tempEvent.pointerId = $3f2224d8df498ec4$var$MOUSE_POINTER_ID;
            if (typeof tempEvent.pressure === 'undefined') tempEvent.pressure = 0.5;
            if (typeof tempEvent.twist === 'undefined') tempEvent.twist = 0;
            if (typeof tempEvent.tangentialPressure === 'undefined') tempEvent.tangentialPressure = 0;
            // mark the mouse event as normalized, just so that we know we did it
            tempEvent.isNormalized = true;
            normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    };
    /**
     * Destroys the interaction manager
     *
     */ InteractionManager.prototype.destroy = function() {
        this.removeEvents();
        this.removeTickerListener();
        this.removeAllListeners();
        this.renderer = null;
        this.mouse = null;
        this.eventData = null;
        this.interactionDOMElement = null;
        this.onPointerDown = null;
        this.processPointerDown = null;
        this.onPointerUp = null;
        this.processPointerUp = null;
        this.onPointerCancel = null;
        this.processPointerCancel = null;
        this.onPointerMove = null;
        this.processPointerMove = null;
        this.onPointerOut = null;
        this.processPointerOverOut = null;
        this.onPointerOver = null;
        this.search = null;
    };
    return InteractionManager;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));

});
parcelRegister("3YyWq", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", function () { return $2e521452c1952d1b$export$688aaf132ba9b379; });
$parcel$export(module.exports, "Ticker", function () { return $2e521452c1952d1b$export$39c54bcc89dcee11; });
$parcel$export(module.exports, "TickerPlugin", function () { return $2e521452c1952d1b$export$50c361ceb4e2f4f0; });
/*!
 * @pixi/ticker - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/ticker is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");
/**
 * Target frames per millisecond.
 *
 * @static
 * @name TARGET_FPMS
 * @memberof PIXI.settings
 * @type {number}
 * @default 0.06
 */ (0, $ezJmd.settings).TARGET_FPMS = 0.06;
/**
 * Represents the update priorities used by internal PIXI classes when registered with
 * the {@link PIXI.Ticker} object. Higher priority items are updated first and lower
 * priority items, such as render, should go later.
 *
 * @static
 * @constant
 * @name UPDATE_PRIORITY
 * @memberof PIXI
 * @enum {number}
 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.InteractionManager}
 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.AnimatedSprite}
 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.Ticker#add}.
 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.BasePrepare} utility.
 */ var $2e521452c1952d1b$export$688aaf132ba9b379;
(function(UPDATE_PRIORITY) {
    UPDATE_PRIORITY[UPDATE_PRIORITY["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY[UPDATE_PRIORITY["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY[UPDATE_PRIORITY["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY[UPDATE_PRIORITY["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY[UPDATE_PRIORITY["UTILITY"] = -50] = "UTILITY";
})($2e521452c1952d1b$export$688aaf132ba9b379 || ($2e521452c1952d1b$export$688aaf132ba9b379 = {}));
/**
 * Internal class for handling the priority sorting of ticker handlers.
 *
 * @private
 * @class
 * @memberof PIXI
 */ var $2e521452c1952d1b$var$TickerListener = /** @class */ function() {
    /**
     * Constructor
     * @private
     * @param fn - The listener function to be added for one update
     * @param context - The listener context
     * @param priority - The priority for emitting
     * @param once - If the handler should fire once
     */ function TickerListener(fn, context, priority, once) {
        if (context === void 0) context = null;
        if (priority === void 0) priority = 0;
        if (once === void 0) once = false;
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this.fn = fn;
        this.context = context;
        this.priority = priority;
        this.once = once;
    }
    /**
     * Simple compare function to figure out if a function and context match.
     * @private
     * @param fn - The listener function to be added for one update
     * @param context - The listener context
     * @return `true` if the listener match the arguments
     */ TickerListener.prototype.match = function(fn, context) {
        if (context === void 0) context = null;
        return this.fn === fn && this.context === context;
    };
    /**
     * Emit by calling the current function.
     * @private
     * @param deltaTime - time since the last emit.
     * @return Next ticker
     */ TickerListener.prototype.emit = function(deltaTime) {
        if (this.fn) {
            if (this.context) this.fn.call(this.context, deltaTime);
            else this.fn(deltaTime);
        }
        var redirect = this.next;
        if (this.once) this.destroy(true);
        // Soft-destroying should remove
        // the next reference
        if (this._destroyed) this.next = null;
        return redirect;
    };
    /**
     * Connect to the list.
     * @private
     * @param previous - Input node, previous listener
     */ TickerListener.prototype.connect = function(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    };
    /**
     * Destroy and don't use after this.
     * @private
     * @param hard - `true` to remove the `next` reference, this
     *        is considered a hard destroy. Soft destroy maintains the next reference.
     * @return The listener to redirect while emitting or removing.
     */ TickerListener.prototype.destroy = function(hard) {
        if (hard === void 0) hard = false;
        this._destroyed = true;
        this.fn = null;
        this.context = null;
        // Disconnect, hook up next and previous
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        // Redirect to the next item
        var redirect = this.next;
        // Remove references
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    };
    return TickerListener;
}();
/**
 * A Ticker class that runs an update loop that other objects listen to.
 *
 * This class is composed around listeners meant for execution on the next requested animation frame.
 * Animation frames are requested only when necessary, e.g. When the ticker is started and the emitter has listeners.
 *
 * @class
 * @memberof PIXI
 */ var $2e521452c1952d1b$export$39c54bcc89dcee11 = /** @class */ function() {
    function Ticker() {
        var _this = this;
        /**
         * Whether or not this ticker should invoke the method
         * {@link PIXI.Ticker#start} automatically
         * when a listener is added.
         */ this.autoStart = false;
        /**
         * Scalar time value from last frame to this frame.
         * This value is capped by setting {@link PIXI.Ticker#minFPS}
         * and is scaled with {@link PIXI.Ticker#speed}.
         * **Note:** The cap may be exceeded by scaling.
         */ this.deltaTime = 1;
        /**
         * The last time {@link PIXI.Ticker#update} was invoked.
         * This value is also reset internally outside of invoking
         * update, but only when a new animation frame is requested.
         * If the platform supports DOMHighResTimeStamp,
         * this value will have a precision of 1 µs.
         */ this.lastTime = -1;
        /**
         * Factor of current {@link PIXI.Ticker#deltaTime}.
         * @example
         * // Scales ticker.deltaTime to what would be
         * // the equivalent of approximately 120 FPS
         * ticker.speed = 2;
         */ this.speed = 1;
        /**
         * Whether or not this ticker has been started.
         * `true` if {@link PIXI.Ticker#start} has been called.
         * `false` if {@link PIXI.Ticker#stop} has been called.
         * While `false`, this value may change to `true` in the
         * event of {@link PIXI.Ticker#autoStart} being `true`
         * and a listener is added.
         */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
         * Internal value managed by minFPS property setter and getter.
         * This is the maximum allowed milliseconds between updates.
         */ this._maxElapsedMS = 100;
        /**
         * Internal value managed by minFPS property setter and getter.
         * This is the minimum allowed milliseconds between updates.
         */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /**
         * The last time keyframe was executed.
         * Maintains a relatively fixed interval with the previous value.
         */ this._lastFrame = -1;
        this._head = new $2e521452c1952d1b$var$TickerListener(null, null, Infinity);
        this.deltaMS = 1 / (0, $ezJmd.settings).TARGET_FPMS;
        this.elapsedMS = 1 / (0, $ezJmd.settings).TARGET_FPMS;
        this._tick = function(time) {
            _this._requestId = null;
            if (_this.started) {
                // Invoke listeners now
                _this.update(time);
                // Listener side effects may have modified ticker state.
                if (_this.started && _this._requestId === null && _this._head.next) _this._requestId = requestAnimationFrame(_this._tick);
            }
        };
    }
    /**
     * Conditionally requests a new animation frame.
     * If a frame has not already been requested, and if the internal
     * emitter has listeners, a new frame is requested.
     *
     * @private
     */ Ticker.prototype._requestIfNeeded = function() {
        if (this._requestId === null && this._head.next) {
            // ensure callbacks get correct delta
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    };
    /**
     * Conditionally cancels a pending animation frame.
     * @private
     */ Ticker.prototype._cancelIfNeeded = function() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    };
    /**
     * Conditionally requests a new animation frame.
     * If the ticker has been started it checks if a frame has not already
     * been requested, and if the internal emitter has listeners. If these
     * conditions are met, a new frame is requested. If the ticker has not
     * been started, but autoStart is `true`, then the ticker starts now,
     * and continues with the previous conditions to request a new frame.
     *
     * @private
     */ Ticker.prototype._startIfPossible = function() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    };
    /**
     * Register a handler for tick events. Calls continuously unless
     * it is removed or the ticker is stopped.
     *
     * @param fn - The listener function to be added for updates
     * @param context - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns This instance of a ticker
     */ Ticker.prototype.add = function(fn, context, priority) {
        if (priority === void 0) priority = $2e521452c1952d1b$export$688aaf132ba9b379.NORMAL;
        return this._addListener(new $2e521452c1952d1b$var$TickerListener(fn, context, priority));
    };
    /**
     * Add a handler for the tick event which is only execute once.
     *
     * @param fn - The listener function to be added for one update
     * @param context - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns This instance of a ticker
     */ Ticker.prototype.addOnce = function(fn, context, priority) {
        if (priority === void 0) priority = $2e521452c1952d1b$export$688aaf132ba9b379.NORMAL;
        return this._addListener(new $2e521452c1952d1b$var$TickerListener(fn, context, priority, true));
    };
    /**
     * Internally adds the event handler so that it can be sorted by priority.
     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
     * before the rendering.
     *
     * @private
     * @param listener - Current listener being added.
     * @returns This instance of a ticker
     */ Ticker.prototype._addListener = function(listener) {
        // For attaching to head
        var current = this._head.next;
        var previous = this._head;
        // Add the first item
        if (!current) listener.connect(previous);
        else {
            // Go from highest to lowest priority
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            // Not yet connected
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    };
    /**
     * Removes any handlers matching the function and context parameters.
     * If no handlers are left after removing, then it cancels the animation frame.
     *
     * @param fn - The listener function to be removed
     * @param context - The listener context to be removed
     * @returns This instance of a ticker
     */ Ticker.prototype.remove = function(fn, context) {
        var listener = this._head.next;
        while(listener)// We found a match, lets remove it
        // no break to delete all possible matches
        // incase a listener was added 2+ times
        if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    };
    Object.defineProperty(Ticker.prototype, "count", {
        /**
         * The number of listeners on this ticker, calculated by walking through linked list
         *
         * @readonly
         * @member {number}
         */ get: function() {
            if (!this._head) return 0;
            var count = 0;
            var current = this._head;
            while(current = current.next)count++;
            return count;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts the ticker. If the ticker has listeners
     * a new animation frame is requested at this point.
     */ Ticker.prototype.start = function() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    };
    /**
     * Stops the ticker. If the ticker has requested
     * an animation frame it is canceled at this point.
     */ Ticker.prototype.stop = function() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    };
    /**
     * Destroy the ticker and don't use after this. Calling
     * this method removes all references to internal events.
     */ Ticker.prototype.destroy = function() {
        if (!this._protected) {
            this.stop();
            var listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    };
    /**
     * Triggers an update. An update entails setting the
     * current {@link PIXI.Ticker#elapsedMS},
     * the current {@link PIXI.Ticker#deltaTime},
     * invoking all listeners with current deltaTime,
     * and then finally setting {@link PIXI.Ticker#lastTime}
     * with the value of currentTime that was provided.
     * This method will be called automatically by animation
     * frame callbacks if the ticker instance has been started
     * and listeners are added.
     *
     * @param {number} [currentTime=performance.now()] - the current time of execution
     */ Ticker.prototype.update = function(currentTime) {
        if (currentTime === void 0) currentTime = performance.now();
        var elapsedMS;
        // If the difference in time is zero or negative, we ignore most of the work done here.
        // If there is no valid difference, then should be no reason to let anyone know about it.
        // A zero delta, is exactly that, nothing should update.
        //
        // The difference in time can be negative, and no this does not mean time traveling.
        // This can be the result of a race condition between when an animation frame is requested
        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
        // can receive a time argument that can be less than the lastTime value that was set within
        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
        //
        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.
        if (currentTime > this.lastTime) {
            // Save uncapped elapsedMS for measurement
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            // cap the milliseconds elapsed used for deltaTime
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            // If not enough time has passed, exit the function.
            // Get ready for next frame by setting _lastFrame, but based on _minElapsedMS
            // adjustment to ensure a relatively stable interval.
            if (this._minElapsedMS) {
                var delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * (0, $ezJmd.settings).TARGET_FPMS;
            // Cache a local reference, in-case ticker is destroyed
            // during the emit, we can still check for head.next
            var head = this._head;
            // Invoke listeners added to internal emitter
            var listener = head.next;
            while(listener)listener = listener.emit(this.deltaTime);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    };
    Object.defineProperty(Ticker.prototype, "FPS", {
        /**
         * The frames per second at which this ticker is running.
         * The default is approximately 60 in most modern browsers.
         * **Note:** This does not factor in the value of
         * {@link PIXI.Ticker#speed}, which is specific
         * to scaling {@link PIXI.Ticker#deltaTime}.
         *
         * @member {number}
         * @readonly
         */ get: function() {
            return 1000 / this.elapsedMS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker.prototype, "minFPS", {
        /**
         * Manages the maximum amount of milliseconds allowed to
         * elapse between invoking {@link PIXI.Ticker#update}.
         * This value is used to cap {@link PIXI.Ticker#deltaTime},
         * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
         * When setting this property it is clamped to a value between
         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
         *
         * @member {number}
         * @default 10
         */ get: function() {
            return 1000 / this._maxElapsedMS;
        },
        set: function(fps) {
            // Minimum must be below the maxFPS
            var minFPS = Math.min(this.maxFPS, fps);
            // Must be at least 0, but below 1 / settings.TARGET_FPMS
            var minFPMS = Math.min(Math.max(0, minFPS) / 1000, (0, $ezJmd.settings).TARGET_FPMS);
            this._maxElapsedMS = 1 / minFPMS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker.prototype, "maxFPS", {
        /**
         * Manages the minimum amount of milliseconds required to
         * elapse between invoking {@link PIXI.Ticker#update}.
         * This will effect the measured value of {@link PIXI.Ticker#FPS}.
         * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
         * Otherwise it will be at least `minFPS`
         *
         * @member {number}
         * @default 0
         */ get: function() {
            if (this._minElapsedMS) return Math.round(1000 / this._minElapsedMS);
            return 0;
        },
        set: function(fps) {
            if (fps === 0) this._minElapsedMS = 0;
            else {
                // Max must be at least the minFPS
                var maxFPS = Math.max(this.minFPS, fps);
                this._minElapsedMS = 1 / (maxFPS / 1000);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker, "shared", {
        /**
         * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
         * {@link PIXI.VideoResource} to update animation frames / video textures.
         *
         * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
         *
         * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
         * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
         *
         * @example
         * let ticker = PIXI.Ticker.shared;
         * // Set this to prevent starting this ticker when listeners are added.
         * // By default this is true only for the PIXI.Ticker.shared instance.
         * ticker.autoStart = false;
         * // FYI, call this to ensure the ticker is stopped. It should be stopped
         * // if you have not attempted to render anything yet.
         * ticker.stop();
         * // Call this when you are ready for a running shared ticker.
         * ticker.start();
         *
         * @example
         * // You may use the shared ticker to render...
         * let renderer = PIXI.autoDetectRenderer();
         * let stage = new PIXI.Container();
         * document.body.appendChild(renderer.view);
         * ticker.add(function (time) {
         *     renderer.render(stage);
         * });
         *
         * @example
         * // Or you can just update it manually.
         * ticker.autoStart = false;
         * ticker.stop();
         * function animate(time) {
         *     ticker.update(time);
         *     renderer.render(stage);
         *     requestAnimationFrame(animate);
         * }
         * animate(performance.now());
         *
         * @member {PIXI.Ticker}
         * @static
         */ get: function() {
            if (!Ticker._shared) {
                var shared = Ticker._shared = new Ticker();
                shared.autoStart = true;
                shared._protected = true;
            }
            return Ticker._shared;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker, "system", {
        /**
         * The system ticker instance used by {@link PIXI.InteractionManager} and by
         * {@link PIXI.BasePrepare} for core timing functionality that shouldn't usually need to be paused,
         * unlike the `shared` ticker which drives visual animations and rendering which may want to be paused.
         *
         * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
         *
         * @member {PIXI.Ticker}
         * @static
         */ get: function() {
            if (!Ticker._system) {
                var system = Ticker._system = new Ticker();
                system.autoStart = true;
                system._protected = true;
            }
            return Ticker._system;
        },
        enumerable: false,
        configurable: true
    });
    return Ticker;
}();
/**
 * Middleware for for Application Ticker.
 *
 * @example
 * import {TickerPlugin} from '@pixi/ticker';
 * import {Application} from '@pixi/app';
 * Application.registerPlugin(TickerPlugin);
 *
 * @class
 * @memberof PIXI
 */ var $2e521452c1952d1b$export$50c361ceb4e2f4f0 = /** @class */ function() {
    function TickerPlugin() {}
    /**
     * Initialize the plugin with scope of application instance
     *
     * @static
     * @private
     * @param {object} [options] - See application options
     */ TickerPlugin.init = function(options) {
        var _this = this;
        // Set default
        options = Object.assign({
            autoStart: true,
            sharedTicker: false
        }, options);
        // Create ticker setter
        Object.defineProperty(this, 'ticker', {
            set: function(ticker) {
                if (this._ticker) this._ticker.remove(this.render, this);
                this._ticker = ticker;
                if (ticker) ticker.add(this.render, this, $2e521452c1952d1b$export$688aaf132ba9b379.LOW);
            },
            get: function() {
                return this._ticker;
            }
        });
        /**
         * Convenience method for stopping the render.
         *
         * @method
         * @memberof PIXI.Application
         * @instance
         */ this.stop = function() {
            _this._ticker.stop();
        };
        /**
         * Convenience method for starting the render.
         *
         * @method
         * @memberof PIXI.Application
         * @instance
         */ this.start = function() {
            _this._ticker.start();
        };
        /**
         * Internal reference to the ticker.
         *
         * @type {PIXI.Ticker}
         * @name _ticker
         * @memberof PIXI.Application#
         * @private
         */ this._ticker = null;
        /**
         * Ticker for doing render updates.
         *
         * @type {PIXI.Ticker}
         * @name ticker
         * @memberof PIXI.Application#
         * @default PIXI.Ticker.shared
         */ this.ticker = options.sharedTicker ? $2e521452c1952d1b$export$39c54bcc89dcee11.shared : new $2e521452c1952d1b$export$39c54bcc89dcee11();
        // Start the rendering
        if (options.autoStart) this.start();
    };
    /**
     * Clean up the ticker, scoped to application.
     *
     * @static
     * @private
     */ TickerPlugin.destroy = function() {
        if (this._ticker) {
            var oldTicker = this._ticker;
            this.ticker = null;
            oldTicker.destroy();
        }
    };
    return TickerPlugin;
}();

});


parcelRegister("7DxQ2", function(module, exports) {

$parcel$export(module.exports, "Application", function () { return $58f66c8167568ee2$export$16975c34e60e1e61; });
/*!
 * @pixi/app - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/app is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");

var $klOfb = parcelRequire("klOfb");
/**
 * Convenience class to create a new PIXI application.
 *
 * This class automatically creates the renderer, ticker and root container.
 *
 * @example
 * // Create the application
 * const app = new PIXI.Application();
 *
 * // Add the view to the DOM
 * document.body.appendChild(app.view);
 *
 * // ex, add display objects
 * app.stage.addChild(PIXI.Sprite.from('something.png'));
 *
 * @class
 * @memberof PIXI
 */ var $58f66c8167568ee2$export$16975c34e60e1e61 = /** @class */ function() {
    /**
     * @param {object} [options] - The optional renderer parameters.
     * @param {boolean} [options.autoStart=true] - Automatically starts the rendering after the construction.
     *     **Note**: Setting this parameter to false does NOT stop the shared ticker even if you set
     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
     * @param {number} [options.width=800] - The width of the renderers view.
     * @param {number} [options.height=600] - The height of the renderers view.
     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
     * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
     *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
     *   canvas needs to be opaque, possibly for performance reasons on some older devices.
     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
     *   resolutions other than 1.
     * @param {boolean} [options.antialias=false] - Sets antialias
     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation, enable this if you
     *  need to call toDataUrl on the WebGL context.
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present, this
     *   option only is available when using **pixi.js-legacy** or **@pixi/canvas-renderer** modules, otherwise
     *   it is ignored.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *   not before the new render pass.
     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
     *  for devices with dual graphics card. **(WebGL only)**.
     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.Ticker.shared, `false` to create new ticker.
     *  If set to false, you cannot register a handler to occur before anything that runs on the shared ticker.
     *  The system ticker will always run before both the shared ticker and the app ticker.
     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.Loader.shared, `false` to create new Loader.
     * @param {Window|HTMLElement} [options.resizeTo] - Element to automatically resize stage to.
     */ function Application(options) {
        var _this = this;
        /**
         * The root display container that's rendered.
         * @member {PIXI.Container}
         */ this.stage = new (0, $8t5Gy.Container)();
        // The default options
        options = Object.assign({
            forceCanvas: false
        }, options);
        this.renderer = (0, $klOfb.autoDetectRenderer)(options);
        // install plugins here
        Application._plugins.forEach(function(plugin) {
            plugin.init.call(_this, options);
        });
    }
    /**
     * Register a middleware plugin for the application
     * @static
     * @param {PIXI.IApplicationPlugin} plugin - Plugin being installed
     */ Application.registerPlugin = function(plugin) {
        Application._plugins.push(plugin);
    };
    /**
     * Render the current stage.
     */ Application.prototype.render = function() {
        this.renderer.render(this.stage);
    };
    Object.defineProperty(Application.prototype, "view", {
        /**
         * Reference to the renderer's canvas element.
         * @member {HTMLCanvasElement}
         * @readonly
         */ get: function() {
            return this.renderer.view;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "screen", {
        /**
         * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
         * @member {PIXI.Rectangle}
         * @readonly
         */ get: function() {
            return this.renderer.screen;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Destroy and don't use after this.
     * @param {Boolean} [removeView=false] - Automatically remove canvas from DOM.
     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'stageOptions' will be passed on to those calls.
     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the texture of the child sprite
     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the base texture of the child sprite
     */ Application.prototype.destroy = function(removeView, stageOptions) {
        var _this = this;
        // Destroy plugins in the opposite order
        // which they were constructed
        var plugins = Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach(function(plugin) {
            plugin.destroy.call(_this);
        });
        this.stage.destroy(stageOptions);
        this.stage = null;
        this.renderer.destroy(removeView);
        this.renderer = null;
    };
    /** Collection of installed plugins. */ Application._plugins = [];
    return Application;
}();
/**
 * Middleware for for Application's resize functionality
 * @private
 * @class
 */ var $58f66c8167568ee2$var$ResizePlugin = /** @class */ function() {
    function ResizePlugin() {}
    /**
     * Initialize the plugin with scope of application instance
     * @static
     * @private
     * @param {object} [options] - See application options
     */ ResizePlugin.init = function(options) {
        var _this = this;
        Object.defineProperty(this, 'resizeTo', /**
         * The HTML element or window to automatically resize the
         * renderer's view element to match width and height.
         * @member {Window|HTMLElement}
         * @name resizeTo
         * @memberof PIXI.Application#
         */ {
            set: function(dom) {
                self.removeEventListener('resize', this.queueResize);
                this._resizeTo = dom;
                if (dom) {
                    self.addEventListener('resize', this.queueResize);
                    this.resize();
                }
            },
            get: function() {
                return this._resizeTo;
            }
        });
        /**
         * Resize is throttled, so it's safe to call this multiple times per frame and it'll
         * only be called once.
         *
         * @memberof PIXI.Application#
         * @method queueResize
         * @private
         */ this.queueResize = function() {
            if (!_this._resizeTo) return;
            _this.cancelResize();
            // // Throttle resize events per raf
            _this._resizeId = requestAnimationFrame(function() {
                return _this.resize();
            });
        };
        /**
         * Cancel the resize queue.
         *
         * @memberof PIXI.Application#
         * @method cancelResize
         * @private
         */ this.cancelResize = function() {
            if (_this._resizeId) {
                cancelAnimationFrame(_this._resizeId);
                _this._resizeId = null;
            }
        };
        /**
         * Execute an immediate resize on the renderer, this is not
         * throttled and can be expensive to call many times in a row.
         * Will resize only if `resizeTo` property is set.
         *
         * @memberof PIXI.Application#
         * @method resize
         */ this.resize = function() {
            if (!_this._resizeTo) return;
            // clear queue resize
            _this.cancelResize();
            var width;
            var height;
            // Resize to the window
            if (_this._resizeTo === self) {
                width = self.innerWidth;
                height = self.innerHeight;
            } else {
                var _a = _this._resizeTo, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
                width = clientWidth;
                height = clientHeight;
            }
            _this.renderer.resize(width, height);
        };
        // On resize
        this._resizeId = null;
        this._resizeTo = null;
        this.resizeTo = options.resizeTo || null;
    };
    /**
     * Clean up the ticker, scoped to application
     *
     * @static
     * @private
     */ ResizePlugin.destroy = function() {
        self.removeEventListener('resize', this.queueResize);
        this.cancelResize();
        this.cancelResize = null;
        this.queueResize = null;
        this.resizeTo = null;
        this.resize = null;
    };
    return ResizePlugin;
}();
$58f66c8167568ee2$export$16975c34e60e1e61.registerPlugin($58f66c8167568ee2$var$ResizePlugin);

});
parcelRegister("klOfb", function(module, exports) {

$parcel$export(module.exports, "INSTALLED", function () { return INSTALLED; });
$parcel$export(module.exports, "autoDetectResource", function () { return autoDetectResource; });
$parcel$export(module.exports, "Resource", function () { return Resource; });
$parcel$export(module.exports, "BufferResource", function () { return BufferResource; });
$parcel$export(module.exports, "BaseTexture", function () { return BaseTexture; });
$parcel$export(module.exports, "AbstractMultiResource", function () { return AbstractMultiResource; });
$parcel$export(module.exports, "ArrayResource", function () { return ArrayResource; });
$parcel$export(module.exports, "BaseImageResource", function () { return BaseImageResource; });
$parcel$export(module.exports, "CanvasResource", function () { return CanvasResource; });
$parcel$export(module.exports, "CubeResource", function () { return CubeResource; });
$parcel$export(module.exports, "ImageResource", function () { return ImageResource; });
$parcel$export(module.exports, "SVGResource", function () { return SVGResource; });
$parcel$export(module.exports, "VideoResource", function () { return VideoResource; });
$parcel$export(module.exports, "ImageBitmapResource", function () { return ImageBitmapResource; });
$parcel$export(module.exports, "Framebuffer", function () { return Framebuffer; });
$parcel$export(module.exports, "BaseRenderTexture", function () { return BaseRenderTexture; });
$parcel$export(module.exports, "TextureUvs", function () { return TextureUvs; });
$parcel$export(module.exports, "Texture", function () { return Texture; });
$parcel$export(module.exports, "RenderTexture", function () { return RenderTexture; });
$parcel$export(module.exports, "RenderTexturePool", function () { return RenderTexturePool; });
$parcel$export(module.exports, "Attribute", function () { return Attribute; });
$parcel$export(module.exports, "Buffer", function () { return Buffer; });
$parcel$export(module.exports, "Geometry", function () { return Geometry; });
$parcel$export(module.exports, "Quad", function () { return Quad; });
$parcel$export(module.exports, "QuadUv", function () { return QuadUv; });
$parcel$export(module.exports, "UniformGroup", function () { return UniformGroup; });
$parcel$export(module.exports, "FilterState", function () { return FilterState; });
$parcel$export(module.exports, "FilterSystem", function () { return FilterSystem; });
$parcel$export(module.exports, "ObjectRenderer", function () { return ObjectRenderer; });
$parcel$export(module.exports, "BatchSystem", function () { return BatchSystem; });
$parcel$export(module.exports, "ContextSystem", function () { return ContextSystem; });
$parcel$export(module.exports, "GLFramebuffer", function () { return GLFramebuffer; });
$parcel$export(module.exports, "FramebufferSystem", function () { return FramebufferSystem; });
$parcel$export(module.exports, "GeometrySystem", function () { return GeometrySystem; });
$parcel$export(module.exports, "MaskData", function () { return MaskData; });
$parcel$export(module.exports, "getTestContext", function () { return getTestContext; });
$parcel$export(module.exports, "uniformParsers", function () { return uniformParsers; });
$parcel$export(module.exports, "checkMaxIfStatementsInShader", function () { return checkMaxIfStatementsInShader; });
$parcel$export(module.exports, "Program", function () { return Program; });
$parcel$export(module.exports, "Shader", function () { return Shader; });
$parcel$export(module.exports, "State", function () { return State; });
$parcel$export(module.exports, "Filter", function () { return Filter; });
$parcel$export(module.exports, "TextureMatrix", function () { return TextureMatrix; });
$parcel$export(module.exports, "SpriteMaskFilter", function () { return SpriteMaskFilter; });
$parcel$export(module.exports, "MaskSystem", function () { return MaskSystem; });
$parcel$export(module.exports, "ScissorSystem", function () { return ScissorSystem; });
$parcel$export(module.exports, "StencilSystem", function () { return StencilSystem; });
$parcel$export(module.exports, "ProjectionSystem", function () { return ProjectionSystem; });
$parcel$export(module.exports, "RenderTextureSystem", function () { return RenderTextureSystem; });
$parcel$export(module.exports, "createUBOElements", function () { return createUBOElements; });
$parcel$export(module.exports, "getUBOData", function () { return getUBOData; });
$parcel$export(module.exports, "generateUniformBufferSync", function () { return generateUniformBufferSync; });
$parcel$export(module.exports, "IGLUniformData", function () { return IGLUniformData; });
$parcel$export(module.exports, "GLProgram", function () { return GLProgram; });
$parcel$export(module.exports, "generateProgram", function () { return generateProgram; });
$parcel$export(module.exports, "ShaderSystem", function () { return ShaderSystem; });
$parcel$export(module.exports, "StateSystem", function () { return StateSystem; });
$parcel$export(module.exports, "TextureGCSystem", function () { return TextureGCSystem; });
$parcel$export(module.exports, "GLTexture", function () { return GLTexture; });
$parcel$export(module.exports, "TextureSystem", function () { return TextureSystem; });
$parcel$export(module.exports, "AbstractRenderer", function () { return AbstractRenderer; });
$parcel$export(module.exports, "Renderer", function () { return Renderer; });
$parcel$export(module.exports, "autoDetectRenderer", function () { return autoDetectRenderer; });
$parcel$export(module.exports, "defaultVertex", function () { return defaultVertex$2; });
$parcel$export(module.exports, "defaultFilterVertex", function () { return defaultFilterVertex; });
$parcel$export(module.exports, "System", function () { return System; });
$parcel$export(module.exports, "BatchDrawCall", function () { return BatchDrawCall; });
$parcel$export(module.exports, "BatchTextureArray", function () { return BatchTextureArray; });
$parcel$export(module.exports, "ViewableBuffer", function () { return ViewableBuffer; });
$parcel$export(module.exports, "AbstractBatchRenderer", function () { return AbstractBatchRenderer; });
$parcel$export(module.exports, "BatchShaderGenerator", function () { return BatchShaderGenerator; });
$parcel$export(module.exports, "BatchGeometry", function () { return BatchGeometry; });
$parcel$export(module.exports, "BatchPluginFactory", function () { return BatchPluginFactory; });
$parcel$export(module.exports, "BatchRenderer", function () { return BatchRenderer; });
$parcel$export(module.exports, "resources", function () { return resources; });
$parcel$export(module.exports, "systems", function () { return systems; });
/*!
 * @pixi/core - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/core is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $P8XPi = parcelRequire("P8XPi");

var $csytw = parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");
var $ezJmd = parcelRequire("ezJmd");

var $6fZag = parcelRequire("6fZag");

var $3YyWq = parcelRequire("3YyWq");

var $6qzqq = parcelRequire("6qzqq");
/**
 * The maximum support for using WebGL. If a device does not
 * support WebGL version, for instance WebGL 2, it will still
 * attempt to fallback support to WebGL 1. If you want to
 * explicitly remove feature support to target a more stable
 * baseline, prefer a lower environment.
 *
 * Due to {@link https://bugs.chromium.org/p/chromium/issues/detail?id=934823|bug in chromium}
 * we disable webgl2 by default for all non-apple mobile devices.
 *
 * @static
 * @name PREFER_ENV
 * @memberof PIXI.settings
 * @type {number}
 * @default PIXI.ENV.WEBGL2
 */ (0, $ezJmd.settings).PREFER_ENV = (0, $ezJmd.isMobile).any ? (0, $P8XPi.ENV).WEBGL : (0, $P8XPi.ENV).WEBGL2;
/**
 * If set to `true`, *only* Textures and BaseTexture objects stored
 * in the caches ({@link PIXI.utils.TextureCache TextureCache} and
 * {@link PIXI.utils.BaseTextureCache BaseTextureCache}) can be
 * used when calling {@link PIXI.Texture.from Texture.from} or
 * {@link PIXI.BaseTexture.from BaseTexture.from}.
 * Otherwise, these `from` calls throw an exception. Using this property
 * can be useful if you want to enforce preloading all assets with
 * {@link PIXI.Loader Loader}.
 *
 * @static
 * @name STRICT_TEXTURE_CACHE
 * @memberof PIXI.settings
 * @type {boolean}
 * @default false
 */ (0, $ezJmd.settings).STRICT_TEXTURE_CACHE = false;
/**
 * Collection of installed resource types, class must extend {@link PIXI.Resource}.
 * @example
 * class CustomResource extends PIXI.Resource {
 *   // MUST have source, options constructor signature
 *   // for auto-detected resources to be created.
 *   constructor(source, options) {
 *     super();
 *   }
 *   upload(renderer, baseTexture, glTexture) {
 *     // upload with GL
 *     return true;
 *   }
 *   // used to auto-detect resource
 *   static test(source, extension) {
 *     return extension === 'xyz'|| source instanceof SomeClass;
 *   }
 * }
 * // Install the new resource type
 * PIXI.INSTALLED.push(CustomResource);
 *
 * @memberof PIXI
 * @type {Array<PIXI.IResourcePlugin>}
 * @static
 * @readonly
 */ var INSTALLED = [];
/**
 * Create a resource element from a single source element. This
 * auto-detects which type of resource to create. All resources that
 * are auto-detectable must have a static `test` method and a constructor
 * with the arguments `(source, options?)`. Currently, the supported
 * resources for auto-detection include:
 *  - {@link PIXI.ImageResource}
 *  - {@link PIXI.CanvasResource}
 *  - {@link PIXI.VideoResource}
 *  - {@link PIXI.SVGResource}
 *  - {@link PIXI.BufferResource}
 * @static
 * @memberof PIXI
 * @function autoDetectResource
 * @param {string|*} source - Resource source, this can be the URL to the resource,
 *        a typed-array (for BufferResource), HTMLVideoElement, SVG data-uri
 *        or any other resource that can be auto-detected. If not resource is
 *        detected, it's assumed to be an ImageResource.
 * @param {object} [options] - Pass-through options to use for Resource
 * @param {number} [options.width] - Width of BufferResource or SVG rasterization
 * @param {number} [options.height] - Height of BufferResource or SVG rasterization
 * @param {boolean} [options.autoLoad=true] - Image, SVG and Video flag to start loading
 * @param {number} [options.scale=1] - SVG source scale. Overridden by width, height
 * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - Image option to create Bitmap object
 * @param {boolean} [options.crossorigin=true] - Image and Video option to set crossOrigin
 * @param {boolean} [options.autoPlay=true] - Video option to start playing video immediately
 * @param {number} [options.updateFPS=0] - Video option to update how many times a second the
 *        texture should be updated from the video. Leave at 0 to update at every render
 * @return {PIXI.Resource} The created resource.
 */ function autoDetectResource(source, options) {
    if (!source) return null;
    var extension = '';
    if (typeof source === 'string') {
        // search for file extension: period, 3-4 chars, then ?, # or EOL
        var result = /\.(\w{3,4})(?:$|\?|#)/i.exec(source);
        if (result) extension = result[1].toLowerCase();
    }
    for(var i = INSTALLED.length - 1; i >= 0; --i){
        var ResourcePlugin = INSTALLED[i];
        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) return new ResourcePlugin(source, options);
    }
    throw new Error('Unrecognized source type to auto-detect Resource');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        var arguments$1 = arguments;
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments$1[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Base resource class for textures that manages validation and uploading, depending on its type.
 *
 * Uploading of a base texture to the GPU is required.
 *
 * @memberof PIXI
 */ var Resource = /** @class */ function() {
    /**
     * @param width - Width of the resource
     * @param height - Height of the resource
     */ function Resource(width, height) {
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this._width = width;
        this._height = height;
        this.destroyed = false;
        this.internal = false;
        this.onResize = new (0, $6fZag.Runner)('setRealSize');
        this.onUpdate = new (0, $6fZag.Runner)('update');
        this.onError = new (0, $6fZag.Runner)('onError');
    }
    /**
     * Bind to a parent BaseTexture
     *
     * @param baseTexture - Parent texture
     */ Resource.prototype.bind = function(baseTexture) {
        this.onResize.add(baseTexture);
        this.onUpdate.add(baseTexture);
        this.onError.add(baseTexture);
        // Call a resize immediate if we already
        // have the width and height of the resource
        if (this._width || this._height) this.onResize.emit(this._width, this._height);
    };
    /**
     * Unbind to a parent BaseTexture
     *
     * @param baseTexture - Parent texture
     */ Resource.prototype.unbind = function(baseTexture) {
        this.onResize.remove(baseTexture);
        this.onUpdate.remove(baseTexture);
        this.onError.remove(baseTexture);
    };
    /**
     * Trigger a resize event
     *
     * @param width - X dimension
     * @param height - Y dimension
     */ Resource.prototype.resize = function(width, height) {
        if (width !== this._width || height !== this._height) {
            this._width = width;
            this._height = height;
            this.onResize.emit(width, height);
        }
    };
    Object.defineProperty(Resource.prototype, "valid", {
        /**
         * Has been validated
         *
         * @readonly
         */ get: function() {
            return !!this._width && !!this._height;
        },
        enumerable: false,
        configurable: true
    });
    /** Has been updated trigger event. */ Resource.prototype.update = function() {
        if (!this.destroyed) this.onUpdate.emit();
    };
    /**
     * This can be overridden to start preloading a resource
     * or do any other prepare step.
     *
     * @protected
     * @return Handle the validate event
     */ Resource.prototype.load = function() {
        return Promise.resolve(this);
    };
    Object.defineProperty(Resource.prototype, "width", {
        /**
         * The width of the resource.
         *
         * @readonly
         */ get: function() {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "height", {
        /**
         * The height of the resource.
         *
         * @readonly
         */ get: function() {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Set the style, optional to override
     *
     * @param renderer - yeah, renderer!
     * @param baseTexture - the texture
     * @param glTexture - texture instance for this webgl context
     * @returns - `true` is success
     */ Resource.prototype.style = function(_renderer, _baseTexture, _glTexture) {
        return false;
    };
    /** Clean up anything, this happens when destroying is ready. */ Resource.prototype.dispose = function() {
    // override
    };
    /**
     * Call when destroying resource, unbind any BaseTexture object
     * before calling this method, as reference counts are maintained
     * internally.
     */ Resource.prototype.destroy = function() {
        if (!this.destroyed) {
            this.destroyed = true;
            this.dispose();
            this.onError.removeAll();
            this.onError = null;
            this.onResize.removeAll();
            this.onResize = null;
            this.onUpdate.removeAll();
            this.onUpdate = null;
        }
    };
    /**
     * Abstract, used to auto-detect resource type.
     *
     * @param {*} source - The source object
     * @param {string} extension - The extension of source, if set
     */ Resource.test = function(_source, _extension) {
        return false;
    };
    return Resource;
}();
/**
 * @interface SharedArrayBuffer
 */ /**
 * Buffer resource with data of typed array.
 *
 * @memberof PIXI
 */ var BufferResource = /** @class */ function(_super) {
    __extends(BufferResource, _super);
    /**
     * @param source - Source buffer
     * @param options - Options
     * @param {number} options.width - Width of the texture
     * @param {number} options.height - Height of the texture
     */ function BufferResource(source, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height;
        if (!width || !height) throw new Error('BufferResource width or height invalid');
        _this = _super.call(this, width, height) || this;
        _this.data = source;
        return _this;
    }
    /**
     * Upload the texture to the GPU.
     *
     * @param renderer - Upload to the renderer
     * @param baseTexture - Reference to parent texture
     * @param glTexture - glTexture
     * @returns - true is success
     */ BufferResource.prototype.upload = function(renderer, baseTexture, glTexture) {
        var gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        var width = baseTexture.realWidth;
        var height = baseTexture.realHeight;
        if (glTexture.width === width && glTexture.height === height) gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data);
        }
        return true;
    };
    /** Destroy and don't use after this. */ BufferResource.prototype.dispose = function() {
        this.data = null;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if <canvas>
     */ BufferResource.test = function(source) {
        return source instanceof Float32Array || source instanceof Uint8Array || source instanceof Uint32Array;
    };
    return BufferResource;
}(Resource);
var defaultBufferOptions = {
    scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST,
    format: (0, $P8XPi.FORMATS).RGBA,
    alphaMode: (0, $P8XPi.ALPHA_MODES).NPM
};
/**
 * A Texture stores the information that represents an image.
 * All textures have a base texture, which contains information about the source.
 * Therefore you can have many textures all using a single BaseTexture
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 * @typeParam R - The BaseTexture's Resource type.
 * @typeParam RO - The options for constructing resource.
 */ var BaseTexture = /** @class */ function(_super) {
    __extends(BaseTexture, _super);
    /**
     * @param {PIXI.Resource|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} [resource=null] -
     *        The current resource to use, for things that aren't Resource objects, will be converted
     *        into a Resource.
     * @param {Object} [options] - Collection of options
     * @param {PIXI.MIPMAP_MODES} [options.mipmap=PIXI.settings.MIPMAP_TEXTURES] - If mipmapping is enabled for texture
     * @param {number} [options.anisotropicLevel=PIXI.settings.ANISOTROPIC_LEVEL] - Anisotropic filtering level of texture
     * @param {PIXI.WRAP_MODES} [options.wrapMode=PIXI.settings.WRAP_MODE] - Wrap mode for textures
     * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.settings.SCALE_MODE] - Default scale mode, linear, nearest
     * @param {PIXI.FORMATS} [options.format=PIXI.FORMATS.RGBA] - GL format type
     * @param {PIXI.TYPES} [options.type=PIXI.TYPES.UNSIGNED_BYTE] - GL data type
     * @param {PIXI.TARGETS} [options.target=PIXI.TARGETS.TEXTURE_2D] - GL texture target
     * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Pre multiply the image alpha
     * @param {number} [options.width=0] - Width of the texture
     * @param {number} [options.height=0] - Height of the texture
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
     * @param {object} [options.resourceOptions] - Optional resource options,
     *        see {@link PIXI.autoDetectResource autoDetectResource}
     */ function BaseTexture(resource, options) {
        if (resource === void 0) resource = null;
        if (options === void 0) options = null;
        var _this = _super.call(this) || this;
        options = options || {};
        var alphaMode = options.alphaMode, mipmap = options.mipmap, anisotropicLevel = options.anisotropicLevel, scaleMode = options.scaleMode, width = options.width, height = options.height, wrapMode = options.wrapMode, format = options.format, type = options.type, target = options.target, resolution = options.resolution, resourceOptions = options.resourceOptions;
        // Convert the resource to a Resource object
        if (resource && !(resource instanceof Resource)) {
            resource = autoDetectResource(resource, resourceOptions);
            resource.internal = true;
        }
        _this.resolution = resolution || (0, $ezJmd.settings).RESOLUTION;
        _this.width = Math.round((width || 0) * _this.resolution) / _this.resolution;
        _this.height = Math.round((height || 0) * _this.resolution) / _this.resolution;
        _this._mipmap = mipmap !== undefined ? mipmap : (0, $ezJmd.settings).MIPMAP_TEXTURES;
        _this.anisotropicLevel = anisotropicLevel !== undefined ? anisotropicLevel : (0, $ezJmd.settings).ANISOTROPIC_LEVEL;
        _this._wrapMode = wrapMode || (0, $ezJmd.settings).WRAP_MODE;
        _this._scaleMode = scaleMode !== undefined ? scaleMode : (0, $ezJmd.settings).SCALE_MODE;
        _this.format = format || (0, $P8XPi.FORMATS).RGBA;
        _this.type = type || (0, $P8XPi.TYPES).UNSIGNED_BYTE;
        _this.target = target || (0, $P8XPi.TARGETS).TEXTURE_2D;
        _this.alphaMode = alphaMode !== undefined ? alphaMode : (0, $P8XPi.ALPHA_MODES).UNPACK;
        _this.uid = (0, $csytw.uid)();
        _this.touched = 0;
        _this.isPowerOfTwo = false;
        _this._refreshPOT();
        _this._glTextures = {};
        _this.dirtyId = 0;
        _this.dirtyStyleId = 0;
        _this.cacheId = null;
        _this.valid = width > 0 && height > 0;
        _this.textureCacheIds = [];
        _this.destroyed = false;
        _this.resource = null;
        _this._batchEnabled = 0;
        _this._batchLocation = 0;
        _this.parentTextureArray = null;
        /**
         * Fired when a not-immediately-available source finishes loading.
         *
         * @protected
         * @event PIXI.BaseTexture#loaded
         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
         */ /**
         * Fired when a not-immediately-available source fails to load.
         *
         * @protected
         * @event PIXI.BaseTexture#error
         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
         * @param {ErrorEvent} event - Load error event.
         */ /**
         * Fired when BaseTexture is updated.
         *
         * @protected
         * @event PIXI.BaseTexture#loaded
         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
         */ /**
         * Fired when BaseTexture is updated.
         *
         * @protected
         * @event PIXI.BaseTexture#update
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
         */ /**
         * Fired when BaseTexture is destroyed.
         *
         * @protected
         * @event PIXI.BaseTexture#dispose
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
         */ // Set the resource
        _this.setResource(resource);
        return _this;
    }
    Object.defineProperty(BaseTexture.prototype, "realWidth", {
        /**
         * Pixel width of the source of this texture
         *
         * @readonly
         * @member {number}
         */ get: function() {
            return Math.round(this.width * this.resolution);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "realHeight", {
        /**
         * Pixel height of the source of this texture
         *
         * @readonly
         * @member {number}
         */ get: function() {
            return Math.round(this.height * this.resolution);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "mipmap", {
        /**
         * Mipmap mode of the texture, affects downscaled images
         *
         * @member {PIXI.MIPMAP_MODES}
         * @default PIXI.settings.MIPMAP_TEXTURES
         */ get: function() {
            return this._mipmap;
        },
        set: function(value) {
            if (this._mipmap !== value) {
                this._mipmap = value;
                this.dirtyStyleId++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "scaleMode", {
        /**
         * The scale mode to apply when scaling this texture
         *
         * @member {PIXI.SCALE_MODES}
         * @default PIXI.settings.SCALE_MODE
         */ get: function() {
            return this._scaleMode;
        },
        set: function(value) {
            if (this._scaleMode !== value) {
                this._scaleMode = value;
                this.dirtyStyleId++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "wrapMode", {
        /**
         * How the texture wraps
         * @member {PIXI.WRAP_MODES}
         * @default PIXI.settings.WRAP_MODE
         */ get: function() {
            return this._wrapMode;
        },
        set: function(value) {
            if (this._wrapMode !== value) {
                this._wrapMode = value;
                this.dirtyStyleId++;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Changes style options of BaseTexture
     *
     * @param {PIXI.SCALE_MODES} [scaleMode] - Pixi scalemode
     * @param {PIXI.MIPMAP_MODES} [mipmap] - enable mipmaps
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setStyle = function(scaleMode, mipmap) {
        var dirty;
        if (scaleMode !== undefined && scaleMode !== this.scaleMode) {
            this.scaleMode = scaleMode;
            dirty = true;
        }
        if (mipmap !== undefined && mipmap !== this.mipmap) {
            this.mipmap = mipmap;
            dirty = true;
        }
        if (dirty) this.dirtyStyleId++;
        return this;
    };
    /**
     * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
     *
     * @param {number} desiredWidth - Desired visual width
     * @param {number} desiredHeight - Desired visual height
     * @param {number} [resolution] - Optionally set resolution
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setSize = function(desiredWidth, desiredHeight, resolution) {
        resolution = resolution || this.resolution;
        return this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    };
    /**
     * Sets real size of baseTexture, preserves current resolution.
     *
     * @param {number} realWidth - Full rendered width
     * @param {number} realHeight - Full rendered height
     * @param {number} [resolution] - Optionally set resolution
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setRealSize = function(realWidth, realHeight, resolution) {
        this.resolution = resolution || this.resolution;
        this.width = Math.round(realWidth) / this.resolution;
        this.height = Math.round(realHeight) / this.resolution;
        this._refreshPOT();
        this.update();
        return this;
    };
    /**
     * Refresh check for isPowerOfTwo texture based on size
     *
     * @private
     */ BaseTexture.prototype._refreshPOT = function() {
        this.isPowerOfTwo = (0, $csytw.isPow2)(this.realWidth) && (0, $csytw.isPow2)(this.realHeight);
    };
    /**
     * Changes resolution
     *
     * @param {number} resolution - res
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setResolution = function(resolution) {
        var oldResolution = this.resolution;
        if (oldResolution === resolution) return this;
        this.resolution = resolution;
        if (this.valid) {
            this.width = Math.round(this.width * oldResolution) / resolution;
            this.height = Math.round(this.height * oldResolution) / resolution;
            this.emit('update', this);
        }
        this._refreshPOT();
        return this;
    };
    /**
     * Sets the resource if it wasn't set. Throws error if resource already present
     *
     * @param {PIXI.Resource} resource - that is managing this BaseTexture
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setResource = function(resource) {
        if (this.resource === resource) return this;
        if (this.resource) throw new Error('Resource can be set only once');
        resource.bind(this);
        this.resource = resource;
        return this;
    };
    /**
     * Invalidates the object. Texture becomes valid if width and height are greater than zero.
     */ BaseTexture.prototype.update = function() {
        if (!this.valid) {
            if (this.width > 0 && this.height > 0) {
                this.valid = true;
                this.emit('loaded', this);
                this.emit('update', this);
            }
        } else {
            this.dirtyId++;
            this.dirtyStyleId++;
            this.emit('update', this);
        }
    };
    /**
     * Handle errors with resources.
     * @private
     * @param {ErrorEvent} event - Error event emitted.
     */ BaseTexture.prototype.onError = function(event) {
        this.emit('error', this, event);
    };
    /**
     * Destroys this base texture.
     * The method stops if resource doesn't want this texture to be destroyed.
     * Removes texture from all caches.
     */ BaseTexture.prototype.destroy = function() {
        // remove and destroy the resource
        if (this.resource) {
            this.resource.unbind(this);
            // only destroy resourced created internally
            if (this.resource.internal) this.resource.destroy();
            this.resource = null;
        }
        if (this.cacheId) {
            delete (0, $csytw.BaseTextureCache)[this.cacheId];
            delete (0, $csytw.TextureCache)[this.cacheId];
            this.cacheId = null;
        }
        // finally let the WebGL renderer know..
        this.dispose();
        BaseTexture.removeFromCache(this);
        this.textureCacheIds = null;
        this.destroyed = true;
    };
    /**
     * Frees the texture from WebGL memory without destroying this texture object.
     * This means you can still use the texture later which will upload it to GPU
     * memory again.
     *
     * @fires PIXI.BaseTexture#dispose
     */ BaseTexture.prototype.dispose = function() {
        this.emit('dispose', this);
    };
    /**
     * Utility function for BaseTexture|Texture cast
     */ BaseTexture.prototype.castToBaseTexture = function() {
        return this;
    };
    /**
     * Helper function that creates a base texture based on the source you provide.
     * The source can be - image url, image element, canvas element. If the
     * source is an image url or an image element and not in the base texture
     * cache, it will be created and loaded.
     *
     * @static
     * @param {string|HTMLImageElement|HTMLCanvasElement|SVGElement|HTMLVideoElement} source - The
     *        source to create base texture from.
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
     * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
     * @returns {PIXI.BaseTexture} The new base texture.
     */ BaseTexture.from = function(source, options, strict) {
        if (strict === void 0) strict = (0, $ezJmd.settings).STRICT_TEXTURE_CACHE;
        var isFrame = typeof source === 'string';
        var cacheId = null;
        if (isFrame) cacheId = source;
        else {
            if (!source._pixiId) {
                var prefix = options && options.pixiIdPrefix || 'pixiid';
                source._pixiId = prefix + "_" + (0, $csytw.uid)();
            }
            cacheId = source._pixiId;
        }
        var baseTexture = (0, $csytw.BaseTextureCache)[cacheId];
        // Strict-mode rejects invalid cacheIds
        if (isFrame && strict && !baseTexture) throw new Error("The cacheId \"" + cacheId + "\" does not exist in BaseTextureCache.");
        if (!baseTexture) {
            baseTexture = new BaseTexture(source, options);
            baseTexture.cacheId = cacheId;
            BaseTexture.addToCache(baseTexture, cacheId);
        }
        return baseTexture;
    };
    /**
     * Create a new BaseTexture with a BufferResource from a Float32Array.
     * RGBA values are floats from 0 to 1.
     * @static
     * @param {Float32Array|Uint8Array} buffer - The optional array to use, if no data
     *        is provided, a new Float32Array is created.
     * @param {number} width - Width of the resource
     * @param {number} height - Height of the resource
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @return {PIXI.BaseTexture} The resulting new BaseTexture
     */ BaseTexture.fromBuffer = function(buffer, width, height, options) {
        buffer = buffer || new Float32Array(width * height * 4);
        var resource = new BufferResource(buffer, {
            width: width,
            height: height
        });
        var type = buffer instanceof Float32Array ? (0, $P8XPi.TYPES).FLOAT : (0, $P8XPi.TYPES).UNSIGNED_BYTE;
        return new BaseTexture(resource, Object.assign(defaultBufferOptions, options || {
            width: width,
            height: height,
            type: type
        }));
    };
    /**
     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
     * @param {string} id - The id that the BaseTexture will be stored against.
     */ BaseTexture.addToCache = function(baseTexture, id) {
        if (id) {
            if (baseTexture.textureCacheIds.indexOf(id) === -1) baseTexture.textureCacheIds.push(id);
            if ((0, $csytw.BaseTextureCache)[id]) // eslint-disable-next-line no-console
            console.warn("BaseTexture added to the cache with an id [" + id + "] that already had an entry");
            (0, $csytw.BaseTextureCache)[id] = baseTexture;
        }
    };
    /**
     * Remove a BaseTexture from the global BaseTextureCache.
     *
     * @static
     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
     */ BaseTexture.removeFromCache = function(baseTexture) {
        if (typeof baseTexture === 'string') {
            var baseTextureFromCache = (0, $csytw.BaseTextureCache)[baseTexture];
            if (baseTextureFromCache) {
                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
                if (index > -1) baseTextureFromCache.textureCacheIds.splice(index, 1);
                delete (0, $csytw.BaseTextureCache)[baseTexture];
                return baseTextureFromCache;
            }
        } else if (baseTexture && baseTexture.textureCacheIds) {
            for(var i = 0; i < baseTexture.textureCacheIds.length; ++i)delete (0, $csytw.BaseTextureCache)[baseTexture.textureCacheIds[i]];
            baseTexture.textureCacheIds.length = 0;
            return baseTexture;
        }
        return null;
    };
    /**
     * Global number of the texture batch, used by multi-texture renderers
     *
     * @static
     * @member {number}
     */ BaseTexture._globalBatch = 0;
    return BaseTexture;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
/**
 * Resource that can manage several resource (items) inside.
 * All resources need to have the same pixel size.
 * Parent class for CubeResource and ArrayResource
 *
 * @memberof PIXI
 */ var AbstractMultiResource = /** @class */ function(_super) {
    __extends(AbstractMultiResource, _super);
    /**
     * @param length
     * @param options - Options to for Resource constructor
     * @param {number} [options.width] - Width of the resource
     * @param {number} [options.height] - Height of the resource
     */ function AbstractMultiResource(length, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height;
        _this = _super.call(this, width, height) || this;
        _this.items = [];
        _this.itemDirtyIds = [];
        for(var i = 0; i < length; i++){
            var partTexture = new BaseTexture();
            _this.items.push(partTexture);
            // -2 - first run of texture array upload
            // -1 - texture item was allocated
            // >=0 - texture item uploaded , in sync with items[i].dirtyId
            _this.itemDirtyIds.push(-2);
        }
        _this.length = length;
        _this._load = null;
        _this.baseTexture = null;
        return _this;
    }
    /**
     * Used from ArrayResource and CubeResource constructors.
     *
     * @param resources - Can be resources, image elements, canvas, etc. ,
     *  length should be same as constructor length
     * @param options - Detect options for resources
     */ AbstractMultiResource.prototype.initFromArray = function(resources, options) {
        for(var i = 0; i < this.length; i++){
            if (!resources[i]) continue;
            if (resources[i].castToBaseTexture) this.addBaseTextureAt(resources[i].castToBaseTexture(), i);
            else if (resources[i] instanceof Resource) this.addResourceAt(resources[i], i);
            else this.addResourceAt(autoDetectResource(resources[i], options), i);
        }
    };
    /** Destroy this BaseImageResource. */ AbstractMultiResource.prototype.dispose = function() {
        for(var i = 0, len = this.length; i < len; i++)this.items[i].destroy();
        this.items = null;
        this.itemDirtyIds = null;
        this._load = null;
    };
    /**
     * Set a resource by ID
     *
     * @param resource
     * @param index - Zero-based index of resource to set
     * @return - Instance for chaining
     */ AbstractMultiResource.prototype.addResourceAt = function(resource, index) {
        if (!this.items[index]) throw new Error("Index " + index + " is out of bounds");
        // Inherit the first resource dimensions
        if (resource.valid && !this.valid) this.resize(resource.width, resource.height);
        this.items[index].setResource(resource);
        return this;
    };
    /** Set the parent base texture. */ AbstractMultiResource.prototype.bind = function(baseTexture) {
        if (this.baseTexture !== null) throw new Error('Only one base texture per TextureArray is allowed');
        _super.prototype.bind.call(this, baseTexture);
        for(var i = 0; i < this.length; i++){
            this.items[i].parentTextureArray = baseTexture;
            this.items[i].on('update', baseTexture.update, baseTexture);
        }
    };
    /** Unset the parent base texture. */ AbstractMultiResource.prototype.unbind = function(baseTexture) {
        _super.prototype.unbind.call(this, baseTexture);
        for(var i = 0; i < this.length; i++){
            this.items[i].parentTextureArray = null;
            this.items[i].off('update', baseTexture.update, baseTexture);
        }
    };
    /**
     * Load all the resources simultaneously
     *
     * @return - When load is resolved
     */ AbstractMultiResource.prototype.load = function() {
        var _this = this;
        if (this._load) return this._load;
        var resources = this.items.map(function(item) {
            return item.resource;
        }).filter(function(item) {
            return item;
        });
        // TODO: also implement load part-by-part strategy
        var promises = resources.map(function(item) {
            return item.load();
        });
        this._load = Promise.all(promises).then(function() {
            var _a = _this.items[0], realWidth = _a.realWidth, realHeight = _a.realHeight;
            _this.resize(realWidth, realHeight);
            return Promise.resolve(_this);
        });
        return this._load;
    };
    return AbstractMultiResource;
}(Resource);
/**
 * A resource that contains a number of sources.
 *
 * @memberof PIXI
 */ var ArrayResource = /** @class */ function(_super) {
    __extends(ArrayResource, _super);
    /**
     * @param source - Number of items in array or the collection
     *        of image URLs to use. Can also be resources, image elements, canvas, etc.
     * @param options - Options to apply to {@link PIXI.autoDetectResource}
     * @param {number} [options.width] - Width of the resource
     * @param {number} [options.height] - Height of the resource
     */ function ArrayResource(source, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height;
        var urls;
        var length;
        if (Array.isArray(source)) {
            urls = source;
            length = source.length;
        } else length = source;
        _this = _super.call(this, length, {
            width: width,
            height: height
        }) || this;
        if (urls) _this.initFromArray(urls, options);
        return _this;
    }
    /**
     * Set a baseTexture by ID,
     * ArrayResource just takes resource from it, nothing more
     *
     * @param baseTexture
     * @param index - Zero-based index of resource to set
     * @return - Instance for chaining
     */ ArrayResource.prototype.addBaseTextureAt = function(baseTexture, index) {
        if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
        else throw new Error('ArrayResource does not support RenderTexture');
        return this;
    };
    /** Add binding */ ArrayResource.prototype.bind = function(baseTexture) {
        _super.prototype.bind.call(this, baseTexture);
        baseTexture.target = (0, $P8XPi.TARGETS).TEXTURE_2D_ARRAY;
    };
    /**
     * Upload the resources to the GPU.
     *
     * @param renderer
     * @param texture
     * @param glTexture
     * @returns - whether texture was uploaded
     */ ArrayResource.prototype.upload = function(renderer, texture, glTexture) {
        var _a = this, length = _a.length, itemDirtyIds = _a.itemDirtyIds, items = _a.items;
        var gl = renderer.gl;
        if (glTexture.dirtyId < 0) gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
        for(var i = 0; i < length; i++){
            var item = items[i];
            if (itemDirtyIds[i] < item.dirtyId) {
                itemDirtyIds[i] = item.dirtyId;
                if (item.valid) gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, i, item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source);
            }
        }
        return true;
    };
    return ArrayResource;
}(AbstractMultiResource);
/**
 * Base for all the image/canvas resources.
 *
 * @memberof PIXI
 */ var BaseImageResource = /** @class */ function(_super) {
    __extends(BaseImageResource, _super);
    /**
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement} source
     */ function BaseImageResource(source) {
        var _this = this;
        var sourceAny = source;
        var width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.width;
        var height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.height;
        _this = _super.call(this, width, height) || this;
        _this.source = source;
        _this.noSubImage = false;
        return _this;
    }
    /**
     * Set cross origin based detecting the url and the crossorigin
     *
     * @param element - Element to apply crossOrigin
     * @param url - URL to check
     * @param crossorigin - Cross origin value to use
     */ BaseImageResource.crossOrigin = function(element, url, crossorigin) {
        if (crossorigin === undefined && url.indexOf('data:') !== 0) element.crossOrigin = (0, $csytw.determineCrossOrigin)(url);
        else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
    };
    /**
     * Upload the texture to the GPU.
     *
     * @param renderer - Upload to the renderer
     * @param baseTexture - Reference to parent texture
     * @param glTexture
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement} [source] - (optional)
     * @returns - true is success
     */ BaseImageResource.prototype.upload = function(renderer, baseTexture, glTexture, source) {
        var gl = renderer.gl;
        var width = baseTexture.realWidth;
        var height = baseTexture.realHeight;
        source = source || this.source;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        if (!this.noSubImage && baseTexture.target === gl.TEXTURE_2D && glTexture.width === width && glTexture.height === height) gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, glTexture.type, source);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.format, glTexture.type, source);
        }
        return true;
    };
    /**
     * Checks if source width/height was changed, resize can cause extra baseTexture update.
     * Triggers one update in any case.
     */ BaseImageResource.prototype.update = function() {
        if (this.destroyed) return;
        var source = this.source;
        var width = source.naturalWidth || source.videoWidth || source.width;
        var height = source.naturalHeight || source.videoHeight || source.height;
        this.resize(width, height);
        _super.prototype.update.call(this);
    };
    /** Destroy this {@link BaseImageResource} */ BaseImageResource.prototype.dispose = function() {
        this.source = null;
    };
    return BaseImageResource;
}(Resource);
/**
 * @interface OffscreenCanvas
 */ /**
 * Resource type for HTMLCanvasElement.
 *
 * @memberof PIXI
 */ var CanvasResource = /** @class */ function(_super) {
    __extends(CanvasResource, _super);
    /**
     * @param source - Canvas element to use
     */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function CanvasResource(source) {
        return _super.call(this, source) || this;
    }
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
     */ CanvasResource.test = function(source) {
        var OffscreenCanvas = self.OffscreenCanvas;
        // Check for browsers that don't yet support OffscreenCanvas
        if (OffscreenCanvas && source instanceof OffscreenCanvas) return true;
        return self.HTMLCanvasElement && source instanceof HTMLCanvasElement;
    };
    return CanvasResource;
}(BaseImageResource);
/**
 * Resource for a CubeTexture which contains six resources.
 *
 * @memberof PIXI
 */ var CubeResource = /** @class */ function(_super) {
    __extends(CubeResource, _super);
    /**
     * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
     *        to use as the sides of the cube.
     * @param options - ImageResource options
     * @param {number} [options.width] - Width of resource
     * @param {number} [options.height] - Height of resource
     * @param {number} [options.autoLoad=true] - Whether to auto-load resources
     * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
     *   whether to copy them or use
     */ function CubeResource(source, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height, autoLoad = _a.autoLoad, linkBaseTexture = _a.linkBaseTexture;
        if (source && source.length !== CubeResource.SIDES) throw new Error("Invalid length. Got " + source.length + ", expected 6");
        _this = _super.call(this, 6, {
            width: width,
            height: height
        }) || this;
        for(var i = 0; i < CubeResource.SIDES; i++)_this.items[i].target = (0, $P8XPi.TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + i;
        _this.linkBaseTexture = linkBaseTexture !== false;
        if (source) _this.initFromArray(source, options);
        if (autoLoad !== false) _this.load();
        return _this;
    }
    /**
     * Add binding.
     *
     * @param baseTexture - parent base texture
     */ CubeResource.prototype.bind = function(baseTexture) {
        _super.prototype.bind.call(this, baseTexture);
        baseTexture.target = (0, $P8XPi.TARGETS).TEXTURE_CUBE_MAP;
    };
    CubeResource.prototype.addBaseTextureAt = function(baseTexture, index, linkBaseTexture) {
        if (linkBaseTexture === undefined) linkBaseTexture = this.linkBaseTexture;
        if (!this.items[index]) throw new Error("Index " + index + " is out of bounds");
        if (!this.linkBaseTexture || baseTexture.parentTextureArray || Object.keys(baseTexture._glTextures).length > 0) {
            // copy mode
            if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
            else throw new Error("CubeResource does not support copying of renderTexture.");
        } else {
            // link mode, the difficult one!
            baseTexture.target = (0, $P8XPi.TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + index;
            baseTexture.parentTextureArray = this.baseTexture;
            this.items[index] = baseTexture;
        }
        if (baseTexture.valid && !this.valid) this.resize(baseTexture.realWidth, baseTexture.realHeight);
        this.items[index] = baseTexture;
        return this;
    };
    /**
     * Upload the resource
     *
     * @returns {boolean} true is success
     */ CubeResource.prototype.upload = function(renderer, _baseTexture, glTexture) {
        var dirty = this.itemDirtyIds;
        for(var i = 0; i < CubeResource.SIDES; i++){
            var side = this.items[i];
            if (dirty[i] < side.dirtyId) {
                if (side.valid && side.resource) {
                    side.resource.upload(renderer, side, glTexture);
                    dirty[i] = side.dirtyId;
                } else if (dirty[i] < -1) {
                    // either item is not valid yet, either its a renderTexture
                    // allocate the memory
                    renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null);
                    dirty[i] = -1;
                }
            }
        }
        return true;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is an array of 6 elements
     */ CubeResource.test = function(source) {
        return Array.isArray(source) && source.length === CubeResource.SIDES;
    };
    /** Number of texture sides to store for CubeResources. */ CubeResource.SIDES = 6;
    return CubeResource;
}(AbstractMultiResource);
/**
 * Resource type for HTMLImageElement.
 *
 * @memberof PIXI
 */ var ImageResource = /** @class */ function(_super) {
    __extends(ImageResource, _super);
    /**
     * @param source - image source or URL
     * @param options
     * @param {boolean} [options.autoLoad=true] - start loading process
     * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
     *        a bitmap before upload
     * @param {boolean} [options.crossorigin=true] - Load image using cross origin
     * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
     */ function ImageResource(source, options) {
        var _this = this;
        options = options || {};
        if (!(source instanceof HTMLImageElement)) {
            var imageElement = new Image();
            BaseImageResource.crossOrigin(imageElement, source, options.crossorigin);
            imageElement.src = source;
            source = imageElement;
        }
        _this = _super.call(this, source) || this;
        // FireFox 68, and possibly other versions, seems like setting the HTMLImageElement#width and #height
        // to non-zero values before its loading completes if images are in a cache.
        // Because of this, need to set the `_width` and the `_height` to zero to avoid uploading incomplete images.
        // Please refer to the issue #5968 (https://github.com/pixijs/pixi.js/issues/5968).
        if (!source.complete && !!_this._width && !!_this._height) {
            _this._width = 0;
            _this._height = 0;
        }
        _this.url = source.src;
        _this._process = null;
        _this.preserveBitmap = false;
        _this.createBitmap = (options.createBitmap !== undefined ? options.createBitmap : (0, $ezJmd.settings).CREATE_IMAGE_BITMAP) && !!self.createImageBitmap;
        _this.alphaMode = typeof options.alphaMode === 'number' ? options.alphaMode : null;
        _this.bitmap = null;
        _this._load = null;
        if (options.autoLoad !== false) _this.load();
        return _this;
    }
    /**
     * Returns a promise when image will be loaded and processed.
     *
     * @param createBitmap - whether process image into bitmap
     */ ImageResource.prototype.load = function(createBitmap) {
        var _this = this;
        if (this._load) return this._load;
        if (createBitmap !== undefined) this.createBitmap = createBitmap;
        this._load = new Promise(function(resolve, reject) {
            var source = _this.source;
            _this.url = source.src;
            var completed = function() {
                if (_this.destroyed) return;
                source.onload = null;
                source.onerror = null;
                _this.resize(source.width, source.height);
                _this._load = null;
                if (_this.createBitmap) resolve(_this.process());
                else resolve(_this);
            };
            if (source.complete && source.src) completed();
            else {
                source.onload = completed;
                source.onerror = function(event) {
                    // Avoids Promise freezing when resource broken
                    reject(event);
                    _this.onError.emit(event);
                };
            }
        });
        return this._load;
    };
    /**
     * Called when we need to convert image into BitmapImage.
     * Can be called multiple times, real promise is cached inside.
     *
     * @return - Cached promise to fill that bitmap
     */ ImageResource.prototype.process = function() {
        var _this = this;
        var source = this.source;
        if (this._process !== null) return this._process;
        if (this.bitmap !== null || !self.createImageBitmap) return Promise.resolve(this);
        var createImageBitmap = self.createImageBitmap;
        var cors = !source.crossOrigin || source.crossOrigin === 'anonymous';
        this._process = fetch(source.src, {
            mode: cors ? 'cors' : 'no-cors'
        }).then(function(r) {
            return r.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, 0, 0, source.width, source.height, {
                premultiplyAlpha: _this.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK ? 'premultiply' : 'none'
            });
        }).then(function(bitmap) {
            if (_this.destroyed) return Promise.reject();
            _this.bitmap = bitmap;
            _this.update();
            _this._process = null;
            return Promise.resolve(_this);
        });
        return this._process;
    };
    /**
     * Upload the image resource to GPU.
     *
     * @param renderer - Renderer to upload to
     * @param baseTexture - BaseTexture for this resource
     * @param glTexture - GLTexture to use
     * @returns {boolean} true is success
     */ ImageResource.prototype.upload = function(renderer, baseTexture, glTexture) {
        if (typeof this.alphaMode === 'number') // bitmap stores unpack premultiply flag, we dont have to notify texImage2D about it
        baseTexture.alphaMode = this.alphaMode;
        if (!this.createBitmap) return _super.prototype.upload.call(this, renderer, baseTexture, glTexture);
        if (!this.bitmap) {
            // yeah, ignore the output
            this.process();
            if (!this.bitmap) return false;
        }
        _super.prototype.upload.call(this, renderer, baseTexture, glTexture, this.bitmap);
        if (!this.preserveBitmap) {
            // checks if there are other renderers that possibly need this bitmap
            var flag = true;
            var glTextures = baseTexture._glTextures;
            for(var key in glTextures){
                var otherTex = glTextures[key];
                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
                    flag = false;
                    break;
                }
            }
            if (flag) {
                if (this.bitmap.close) this.bitmap.close();
                this.bitmap = null;
            }
        }
        return true;
    };
    /** Destroys this resource. */ ImageResource.prototype.dispose = function() {
        this.source.onload = null;
        this.source.onerror = null;
        _super.prototype.dispose.call(this);
        if (this.bitmap) {
            this.bitmap.close();
            this.bitmap = null;
        }
        this._process = null;
        this._load = null;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is string or HTMLImageElement
     */ ImageResource.test = function(source) {
        return typeof source === 'string' || source instanceof HTMLImageElement;
    };
    return ImageResource;
}(BaseImageResource);
/**
 * Resource type for SVG elements and graphics.
 *
 * @memberof PIXI
 */ var SVGResource = /** @class */ function(_super) {
    __extends(SVGResource, _super);
    /**
     * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
     * @param {object} [options] - Options to use
     * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
     * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
     * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
     * @param {boolean} [options.autoLoad=true] - Start loading right away.
     */ function SVGResource(sourceBase64, options) {
        var _this = this;
        options = options || {};
        _this = _super.call(this, document.createElement('canvas')) || this;
        _this._width = 0;
        _this._height = 0;
        _this.svg = sourceBase64;
        _this.scale = options.scale || 1;
        _this._overrideWidth = options.width;
        _this._overrideHeight = options.height;
        _this._resolve = null;
        _this._crossorigin = options.crossorigin;
        _this._load = null;
        if (options.autoLoad !== false) _this.load();
        return _this;
    }
    SVGResource.prototype.load = function() {
        var _this = this;
        if (this._load) return this._load;
        this._load = new Promise(function(resolve) {
            // Save this until after load is finished
            _this._resolve = function() {
                _this.resize(_this.source.width, _this.source.height);
                resolve(_this);
            };
            // Convert SVG inline string to data-uri
            if (SVGResource.SVG_XML.test(_this.svg.trim())) {
                if (!btoa) throw new Error('Your browser doesn\'t support base64 conversions.');
                _this.svg = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(_this.svg)));
            }
            _this._loadSvg();
        });
        return this._load;
    };
    /** Loads an SVG image from `imageUrl` or `data URL`. */ SVGResource.prototype._loadSvg = function() {
        var _this = this;
        var tempImage = new Image();
        BaseImageResource.crossOrigin(tempImage, this.svg, this._crossorigin);
        tempImage.src = this.svg;
        tempImage.onerror = function(event) {
            if (!_this._resolve) return;
            tempImage.onerror = null;
            _this.onError.emit(event);
        };
        tempImage.onload = function() {
            if (!_this._resolve) return;
            var svgWidth = tempImage.width;
            var svgHeight = tempImage.height;
            if (!svgWidth || !svgHeight) throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
            // Set render size
            var width = svgWidth * _this.scale;
            var height = svgHeight * _this.scale;
            if (_this._overrideWidth || _this._overrideHeight) {
                width = _this._overrideWidth || _this._overrideHeight / svgHeight * svgWidth;
                height = _this._overrideHeight || _this._overrideWidth / svgWidth * svgHeight;
            }
            width = Math.round(width);
            height = Math.round(height);
            // Create a canvas element
            var canvas = _this.source;
            canvas.width = width;
            canvas.height = height;
            canvas._pixiId = "canvas_" + (0, $csytw.uid)();
            // Draw the Svg to the canvas
            canvas.getContext('2d').drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height);
            _this._resolve();
            _this._resolve = null;
        };
    };
    /**
     * Get size from an svg string using a regular expression.
     *
     * @param svgString - a serialized svg element
     * @return - image extension
     */ SVGResource.getSize = function(svgString) {
        var sizeMatch = SVGResource.SVG_SIZE.exec(svgString);
        var size = {};
        if (sizeMatch) {
            size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
            size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
        }
        return size;
    };
    /** Destroys this texture. */ SVGResource.prototype.dispose = function() {
        _super.prototype.dispose.call(this);
        this._resolve = null;
        this._crossorigin = null;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @param {string} extension - The extension of source, if set
     * @return {boolean} - If the source is a SVG source or data file
     */ SVGResource.test = function(source, extension) {
        // url file extension is SVG
        return extension === 'svg' || typeof source === 'string' && /^data:image\/svg\+xml(;(charset=utf8|utf8))?;base64/.test(source) || typeof source === 'string' && SVGResource.SVG_XML.test(source);
    };
    /**
     * Regular expression for SVG XML document.
     *
     * @example &lt;?xml version="1.0" encoding="utf-8" ?&gt;&lt;!-- image/svg --&gt;&lt;svg
     * @readonly
     */ SVGResource.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m;
    /**
     * Regular expression for SVG size.
     *
     * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
     * @readonly
     */ SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len
    return SVGResource;
}(BaseImageResource);
/**
 * Resource type for {@code HTMLVideoElement}.
 *
 * @memberof PIXI
 */ var VideoResource = /** @class */ function(_super) {
    __extends(VideoResource, _super);
    /**
     * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
     * @param {object} [options] - Options to use
     * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
     * @param {boolean} [options.autoPlay=true] - Start playing video immediately
     * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
     * Leave at 0 to update at every render.
     * @param {boolean} [options.crossorigin=true] - Load image using cross origin
     */ function VideoResource(source, options) {
        var _this = this;
        options = options || {};
        if (!(source instanceof HTMLVideoElement)) {
            var videoElement = document.createElement('video');
            // workaround for https://github.com/pixijs/pixi.js/issues/5996
            videoElement.setAttribute('preload', 'auto');
            videoElement.setAttribute('webkit-playsinline', '');
            videoElement.setAttribute('playsinline', '');
            if (typeof source === 'string') source = [
                source
            ];
            var firstSrc = source[0].src || source[0];
            BaseImageResource.crossOrigin(videoElement, firstSrc, options.crossorigin);
            // array of objects or strings
            for(var i = 0; i < source.length; ++i){
                var sourceElement = document.createElement('source');
                var _a = source[i], src = _a.src, mime = _a.mime;
                src = src || source[i];
                var baseSrc = src.split('?').shift().toLowerCase();
                var ext = baseSrc.substr(baseSrc.lastIndexOf('.') + 1);
                mime = mime || VideoResource.MIME_TYPES[ext] || "video/" + ext;
                sourceElement.src = src;
                sourceElement.type = mime;
                videoElement.appendChild(sourceElement);
            }
            // Override the source
            source = videoElement;
        }
        _this = _super.call(this, source) || this;
        _this.noSubImage = true;
        _this._autoUpdate = true;
        _this._isConnectedToTicker = false;
        _this._updateFPS = options.updateFPS || 0;
        _this._msToNextUpdate = 0;
        _this.autoPlay = options.autoPlay !== false;
        _this._load = null;
        _this._resolve = null;
        // Bind for listeners
        _this._onCanPlay = _this._onCanPlay.bind(_this);
        _this._onError = _this._onError.bind(_this);
        if (options.autoLoad !== false) _this.load();
        return _this;
    }
    /**
     * Trigger updating of the texture.
     *
     * @param deltaTime - time delta since last tick
     */ VideoResource.prototype.update = function(_deltaTime) {
        if (!this.destroyed) {
            // account for if video has had its playbackRate changed
            var elapsedMS = (0, $3YyWq.Ticker).shared.elapsedMS * this.source.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
            if (!this._updateFPS || this._msToNextUpdate <= 0) {
                _super.prototype.update.call(this);
                this._msToNextUpdate = this._updateFPS ? Math.floor(1000 / this._updateFPS) : 0;
            }
        }
    };
    /**
     * Start preloading the video resource.
     *
     * @return {Promise<void>} Handle the validate event
     */ VideoResource.prototype.load = function() {
        var _this = this;
        if (this._load) return this._load;
        var source = this.source;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener('play', this._onPlayStart.bind(this));
        source.addEventListener('pause', this._onPlayStop.bind(this));
        if (!this._isSourceReady()) {
            source.addEventListener('canplay', this._onCanPlay);
            source.addEventListener('canplaythrough', this._onCanPlay);
            source.addEventListener('error', this._onError, true);
        } else this._onCanPlay();
        this._load = new Promise(function(resolve) {
            if (_this.valid) resolve(_this);
            else {
                _this._resolve = resolve;
                source.load();
            }
        });
        return this._load;
    };
    /** Handle video error events. */ VideoResource.prototype._onError = function(event) {
        this.source.removeEventListener('error', this._onError, true);
        this.onError.emit(event);
    };
    /**
     * Returns true if the underlying source is playing.
     *
     * @return - True if playing.
     */ VideoResource.prototype._isSourcePlaying = function() {
        var source = this.source;
        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
    };
    /**
     * Returns true if the underlying source is ready for playing.
     *
     * @return - True if ready.
     */ VideoResource.prototype._isSourceReady = function() {
        var source = this.source;
        return source.readyState === 3 || source.readyState === 4;
    };
    /** Runs the update loop when the video is ready to play. */ VideoResource.prototype._onPlayStart = function() {
        // Just in case the video has not received its can play even yet..
        if (!this.valid) this._onCanPlay();
        if (this.autoUpdate && !this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.add(this.update, this);
            this._isConnectedToTicker = true;
        }
    };
    /** Fired when a pause event is triggered, stops the update loop. */ VideoResource.prototype._onPlayStop = function() {
        if (this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    };
    /** Fired when the video is loaded and ready to play. */ VideoResource.prototype._onCanPlay = function() {
        var source = this.source;
        source.removeEventListener('canplay', this._onCanPlay);
        source.removeEventListener('canplaythrough', this._onCanPlay);
        var valid = this.valid;
        this.resize(source.videoWidth, source.videoHeight);
        // prevent multiple loaded dispatches..
        if (!valid && this._resolve) {
            this._resolve(this);
            this._resolve = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) source.play();
    };
    /** Destroys this texture. */ VideoResource.prototype.dispose = function() {
        if (this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
        var source = this.source;
        if (source) {
            source.removeEventListener('error', this._onError, true);
            source.pause();
            source.src = '';
            source.load();
        }
        _super.prototype.dispose.call(this);
    };
    Object.defineProperty(VideoResource.prototype, "autoUpdate", {
        /** Should the base texture automatically update itself, set to true by default. */ get: function() {
            return this._autoUpdate;
        },
        set: function(value) {
            if (value !== this._autoUpdate) {
                this._autoUpdate = value;
                if (!this._autoUpdate && this._isConnectedToTicker) {
                    (0, $3YyWq.Ticker).shared.remove(this.update, this);
                    this._isConnectedToTicker = false;
                } else if (this._autoUpdate && !this._isConnectedToTicker && this._isSourcePlaying()) {
                    (0, $3YyWq.Ticker).shared.add(this.update, this);
                    this._isConnectedToTicker = true;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoResource.prototype, "updateFPS", {
        /**
         * How many times a second to update the texture from the video. Leave at 0 to update at every render.
         * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
         */ get: function() {
            return this._updateFPS;
        },
        set: function(value) {
            if (value !== this._updateFPS) this._updateFPS = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @param {string} extension - The extension of source, if set
     * @return {boolean} `true` if video source
     */ VideoResource.test = function(source, extension) {
        return self.HTMLVideoElement && source instanceof HTMLVideoElement || VideoResource.TYPES.indexOf(extension) > -1;
    };
    /**
     * List of common video file extensions supported by VideoResource.
     *
     * @readonly
     */ VideoResource.TYPES = [
        'mp4',
        'm4v',
        'webm',
        'ogg',
        'ogv',
        'h264',
        'avi',
        'mov'
    ];
    /**
     * Map of video MIME types that can't be directly derived from file extensions.
     *
     * @readonly
     */ VideoResource.MIME_TYPES = {
        ogv: 'video/ogg',
        mov: 'video/quicktime',
        m4v: 'video/mp4'
    };
    return VideoResource;
}(BaseImageResource);
/**
 * Resource type for ImageBitmap.
 *
 * @memberof PIXI
 */ var ImageBitmapResource = /** @class */ function(_super) {
    __extends(ImageBitmapResource, _super);
    /**
     * @param source - Image element to use
     */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function ImageBitmapResource(source) {
        return _super.call(this, source) || this;
    }
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is an ImageBitmap
     */ ImageBitmapResource.test = function(source) {
        return !!self.createImageBitmap && source instanceof ImageBitmap;
    };
    return ImageBitmapResource;
}(BaseImageResource);
INSTALLED.push(ImageResource, ImageBitmapResource, CanvasResource, VideoResource, SVGResource, BufferResource, CubeResource, ArrayResource);
var _resources = {
    __proto__: null,
    Resource: Resource,
    BaseImageResource: BaseImageResource,
    INSTALLED: INSTALLED,
    autoDetectResource: autoDetectResource,
    AbstractMultiResource: AbstractMultiResource,
    ArrayResource: ArrayResource,
    BufferResource: BufferResource,
    CanvasResource: CanvasResource,
    CubeResource: CubeResource,
    ImageResource: ImageResource,
    SVGResource: SVGResource,
    VideoResource: VideoResource,
    ImageBitmapResource: ImageBitmapResource
};
/**
 * Resource type for DepthTexture.
 *
 * @memberof PIXI
 */ var DepthResource = /** @class */ function(_super) {
    __extends(DepthResource, _super);
    function DepthResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Upload the texture to the GPU.
     *
     * @param renderer - Upload to the renderer
     * @param baseTexture - Reference to parent texture
     * @param glTexture - glTexture
     * @return - true is success
     */ DepthResource.prototype.upload = function(renderer, baseTexture, glTexture) {
        var gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        var width = baseTexture.realWidth;
        var height = baseTexture.realHeight;
        if (glTexture.width === width && glTexture.height === height) gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data);
        }
        return true;
    };
    return DepthResource;
}(BufferResource);
/**
 * A framebuffer can be used to render contents off of the screen. {@link PIXI.BaseRenderTexture} uses
 * one internally to render into itself. You can attach a depth or stencil buffer to a framebuffer.
 *
 * On WebGL 2 machines, shaders can output to multiple textures simultaneously with GLSL 300 ES.
 *
 * @class
 * @memberof PIXI
 */ var Framebuffer = /** @class */ function() {
    /**
     * @param {number} width - Width of the frame buffer
     * @param {number} height - Height of the frame buffer
     */ function Framebuffer(width, height) {
        /**
         * Width of framebuffer in pixels
         * @member {number}
         */ this.width = Math.round(width || 100);
        /**
         * Height of framebuffer in pixels
         * @member {number}
         */ this.height = Math.round(height || 100);
        this.stencil = false;
        this.depth = false;
        this.dirtyId = 0;
        this.dirtyFormat = 0;
        this.dirtySize = 0;
        this.depthTexture = null;
        this.colorTextures = [];
        this.glFramebuffers = {};
        this.disposeRunner = new (0, $6fZag.Runner)('disposeFramebuffer');
        /**
         * Desired number of samples for antialiasing. 0 means AA should not be used.
         *
         * Experimental WebGL2 feature, allows to use antialiasing in individual renderTextures.
         * Antialiasing is the same as for main buffer with renderer `antialias:true` options.
         * Seriously affects GPU memory consumption and GPU performance.
         *
         *```js
         * renderTexture.framebuffer.multisample = PIXI.MSAA_QUALITY.HIGH;
         * //...
         * renderer.render(myContainer, {renderTexture});
         * renderer.framebuffer.blit(); // copies data from MSAA framebuffer to texture
         *  ```
         *
         * @member {PIXI.MSAA_QUALITY}
         * @default PIXI.MSAA_QUALITY.NONE
         */ this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
    }
    Object.defineProperty(Framebuffer.prototype, "colorTexture", {
        /**
         * Reference to the colorTexture.
         *
         * @member {PIXI.BaseTexture[]}
         * @readonly
         */ get: function() {
            return this.colorTextures[0];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add texture to the colorTexture array
     *
     * @param {number} [index=0] - Index of the array to add the texture to
     * @param {PIXI.BaseTexture} [texture] - Texture to add to the array
     */ Framebuffer.prototype.addColorTexture = function(index, texture) {
        if (index === void 0) index = 0;
        // TODO add some validation to the texture - same width / height etc?
        this.colorTextures[index] = texture || new BaseTexture(null, {
            scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST,
            resolution: 1,
            mipmap: (0, $P8XPi.MIPMAP_MODES).OFF,
            width: this.width,
            height: this.height
        });
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Add a depth texture to the frame buffer
     *
     * @param {PIXI.BaseTexture} [texture] - Texture to add
     */ Framebuffer.prototype.addDepthTexture = function(texture) {
        /* eslint-disable max-len */ this.depthTexture = texture || new BaseTexture(new DepthResource(null, {
            width: this.width,
            height: this.height
        }), {
            scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST,
            resolution: 1,
            width: this.width,
            height: this.height,
            mipmap: (0, $P8XPi.MIPMAP_MODES).OFF,
            format: (0, $P8XPi.FORMATS).DEPTH_COMPONENT,
            type: (0, $P8XPi.TYPES).UNSIGNED_SHORT
        });
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Enable depth on the frame buffer
     */ Framebuffer.prototype.enableDepth = function() {
        this.depth = true;
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Enable stencil on the frame buffer
     */ Framebuffer.prototype.enableStencil = function() {
        this.stencil = true;
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Resize the frame buffer
     *
     * @param {number} width - Width of the frame buffer to resize to
     * @param {number} height - Height of the frame buffer to resize to
     */ Framebuffer.prototype.resize = function(width, height) {
        width = Math.round(width);
        height = Math.round(height);
        if (width === this.width && height === this.height) return;
        this.width = width;
        this.height = height;
        this.dirtyId++;
        this.dirtySize++;
        for(var i = 0; i < this.colorTextures.length; i++){
            var texture = this.colorTextures[i];
            var resolution = texture.resolution;
            // take into account the fact the texture may have a different resolution..
            texture.setSize(width / resolution, height / resolution);
        }
        if (this.depthTexture) {
            var resolution = this.depthTexture.resolution;
            this.depthTexture.setSize(width / resolution, height / resolution);
        }
    };
    /**
     * Disposes WebGL resources that are connected to this geometry
     */ Framebuffer.prototype.dispose = function() {
        this.disposeRunner.emit(this, false);
    };
    /**
     * Destroys and removes the depth texture added to this framebuffer.
     */ Framebuffer.prototype.destroyDepthTexture = function() {
        if (this.depthTexture) {
            this.depthTexture.destroy();
            this.depthTexture = null;
            ++this.dirtyId;
            ++this.dirtyFormat;
        }
    };
    return Framebuffer;
}();
/**
 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
 * and rotation of the given Display Objects is ignored. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer();
 * let baseRenderTexture = new PIXI.BaseRenderTexture({ width: 800, height: 600 });
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 * let sprite = PIXI.Sprite.from("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, {renderTexture});
 * ```
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let baseRenderTexture = new PIXI.BaseRenderTexture({ width: 100, height: 100 });
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 *
 * renderer.render(sprite, {renderTexture});  // Renders to center of RenderTexture
 * ```
 *
 * @class
 * @extends PIXI.BaseTexture
 * @memberof PIXI
 */ var BaseRenderTexture = /** @class */ function(_super) {
    __extends(BaseRenderTexture, _super);
    /**
     * @param {object} [options]
     * @param {number} [options.width=100] - The width of the base render texture.
     * @param {number} [options.height=100] - The height of the base render texture.
     * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES}
     *   for possible values.
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
     *   of the texture being generated.
     * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
     */ function BaseRenderTexture(options) {
        var _this = this;
        if (typeof options === 'number') {
            /* eslint-disable prefer-rest-params */ // Backward compatibility of signature
            var width = arguments[0];
            var height = arguments[1];
            var scaleMode = arguments[2];
            var resolution = arguments[3];
            options = {
                width: width,
                height: height,
                scaleMode: scaleMode,
                resolution: resolution
            };
        /* eslint-enable prefer-rest-params */ }
        options.width = options.width || 100;
        options.height = options.height || 100;
        options.multisample = options.multisample !== undefined ? options.multisample : (0, $P8XPi.MSAA_QUALITY).NONE;
        _this = _super.call(this, null, options) || this;
        // Set defaults
        _this.mipmap = (0, $P8XPi.MIPMAP_MODES).OFF;
        _this.valid = true;
        _this.clearColor = [
            0,
            0,
            0,
            0
        ];
        _this.framebuffer = new Framebuffer(_this.realWidth, _this.realHeight).addColorTexture(0, _this);
        _this.framebuffer.multisample = options.multisample;
        // TODO - could this be added the systems?
        /**
         * The data structure for the stencil masks.
         *
         * @member {PIXI.MaskData[]}
         */ _this.maskStack = [];
        /**
         * The data structure for the filters.
         *
         * @member {Object[]}
         */ _this.filterStack = [
            {}
        ];
        return _this;
    }
    /**
     * Resizes the BaseRenderTexture.
     *
     * @param {number} desiredWidth - The desired width to resize to.
     * @param {number} desiredHeight - The desired height to resize to.
     */ BaseRenderTexture.prototype.resize = function(desiredWidth, desiredHeight) {
        this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution);
        this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    };
    /**
     * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
     * This means you can still use the texture later which will upload it to GPU
     * memory again.
     *
     * @fires PIXI.BaseTexture#dispose
     */ BaseRenderTexture.prototype.dispose = function() {
        this.framebuffer.dispose();
        _super.prototype.dispose.call(this);
    };
    /**
     * Destroys this texture.
     */ BaseRenderTexture.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.framebuffer.destroyDepthTexture();
        this.framebuffer = null;
    };
    return BaseRenderTexture;
}(BaseTexture);
/**
 * Stores a texture's frame in UV coordinates, in
 * which everything lies in the rectangle `[(0,0), (1,0),
 * (1,1), (0,1)]`.
 *
 * | Corner       | Coordinates |
 * |--------------|-------------|
 * | Top-Left     | `(x0,y0)`   |
 * | Top-Right    | `(x1,y1)`   |
 * | Bottom-Right | `(x2,y2)`   |
 * | Bottom-Left  | `(x3,y3)`   |
 *
 * @class
 * @protected
 * @memberof PIXI
 */ var TextureUvs = /** @class */ function() {
    function TextureUvs() {
        /**
         * X-component of top-left corner `(x0,y0)`.
         *
         * @member {number}
         */ this.x0 = 0;
        /**
         * Y-component of top-left corner `(x0,y0)`.
         *
         * @member {number}
         */ this.y0 = 0;
        /**
         * X-component of top-right corner `(x1,y1)`.
         *
         * @member {number}
         */ this.x1 = 1;
        /**
         * Y-component of top-right corner `(x1,y1)`.
         *
         * @member {number}
         */ this.y1 = 0;
        /**
         * X-component of bottom-right corner `(x2,y2)`.
         *
         * @member {number}
         */ this.x2 = 1;
        /**
         * Y-component of bottom-right corner `(x2,y2)`.
         *
         * @member {number}
         */ this.y2 = 1;
        /**
         * X-component of bottom-left corner `(x3,y3)`.
         *
         * @member {number}
         */ this.x3 = 0;
        /**
         * Y-component of bottom-right corner `(x3,y3)`.
         *
         * @member {number}
         */ this.y3 = 1;
        this.uvsFloat32 = new Float32Array(8);
    }
    /**
     * Sets the texture Uvs based on the given frame information.
     *
     * @protected
     * @param {PIXI.Rectangle} frame - The frame of the texture
     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
     * @param {number} rotate - Rotation of frame, see {@link PIXI.groupD8}
     */ TextureUvs.prototype.set = function(frame, baseFrame, rotate) {
        var tw = baseFrame.width;
        var th = baseFrame.height;
        if (rotate) {
            // width and height div 2 div baseFrame size
            var w2 = frame.width / 2 / tw;
            var h2 = frame.height / 2 / th;
            // coordinates of center
            var cX = frame.x / tw + w2;
            var cY = frame.y / th + h2;
            rotate = (0, $6qzqq.groupD8).add(rotate, (0, $6qzqq.groupD8).NW); // NW is top-left corner
            this.x0 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y0 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
            rotate = (0, $6qzqq.groupD8).add(rotate, 2); // rotate 90 degrees clockwise
            this.x1 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y1 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
            rotate = (0, $6qzqq.groupD8).add(rotate, 2);
            this.x2 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y2 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
            rotate = (0, $6qzqq.groupD8).add(rotate, 2);
            this.x3 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y3 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
        } else {
            this.x0 = frame.x / tw;
            this.y0 = frame.y / th;
            this.x1 = (frame.x + frame.width) / tw;
            this.y1 = frame.y / th;
            this.x2 = (frame.x + frame.width) / tw;
            this.y2 = (frame.y + frame.height) / th;
            this.x3 = frame.x / tw;
            this.y3 = (frame.y + frame.height) / th;
        }
        this.uvsFloat32[0] = this.x0;
        this.uvsFloat32[1] = this.y0;
        this.uvsFloat32[2] = this.x1;
        this.uvsFloat32[3] = this.y1;
        this.uvsFloat32[4] = this.x2;
        this.uvsFloat32[5] = this.y2;
        this.uvsFloat32[6] = this.x3;
        this.uvsFloat32[7] = this.y3;
    };
    TextureUvs.prototype.toString = function() {
        return "[@pixi/core:TextureUvs " + ("x0=" + this.x0 + " y0=" + this.y0 + " ") + ("x1=" + this.x1 + " y1=" + this.y1 + " x2=" + this.x2 + " ") + ("y2=" + this.y2 + " x3=" + this.x3 + " y3=" + this.y3) + "]";
    };
    return TextureUvs;
}();
var DEFAULT_UVS = new TextureUvs();
/**
 * A texture stores the information that represents an image or part of an image.
 *
 * It cannot be added to the display list directly; instead use it as the texture for a Sprite.
 * If no frame is provided for a texture, then the whole image is used.
 *
 * You can directly create a texture from an image and then reuse it multiple times like this :
 *
 * ```js
 * let texture = PIXI.Texture.from('assets/image.png');
 * let sprite1 = new PIXI.Sprite(texture);
 * let sprite2 = new PIXI.Sprite(texture);
 * ```
 *
 * If you didnt pass the texture frame to constructor, it enables `noFrame` mode:
 * it subscribes on baseTexture events, it automatically resizes at the same time as baseTexture.
 *
 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
 * You can check for this by checking the sprite's _textureID property.
 * ```js
 * var texture = PIXI.Texture.from('assets/image.svg');
 * var sprite1 = new PIXI.Sprite(texture);
 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
 * ```
 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 * @typeParam R - The BaseTexture's Resource type.
 */ var Texture = /** @class */ function(_super) {
    __extends(Texture, _super);
    /**
     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
     * @param {PIXI.Rectangle} [orig] - The area of original texture
     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
     * @param {PIXI.IPointData} [anchor] - Default anchor point used for sprite placement / rotation
     */ function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
        var _this = _super.call(this) || this;
        /**
         * Does this Texture have any frame data assigned to it?
         *
         * This mode is enabled automatically if no frame was passed inside constructor.
         *
         * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
         *
         * Beware, after loading or resize of baseTexture event can fired two times!
         * If you want more control, subscribe on baseTexture itself.
         *
         * ```js
         * texture.on('update', () => {});
         * ```
         *
         * Any assignment of `frame` switches off `noFrame` mode.
         *
         * @member {boolean}
         */ _this.noFrame = false;
        if (!frame) {
            _this.noFrame = true;
            frame = new (0, $6qzqq.Rectangle)(0, 0, 1, 1);
        }
        if (baseTexture instanceof Texture) baseTexture = baseTexture.baseTexture;
        /**
         * The base texture that this texture uses.
         *
         * @member {PIXI.BaseTexture}
         */ _this.baseTexture = baseTexture;
        /**
         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
         *
         * @member {PIXI.Rectangle}
         */ _this._frame = frame;
        /**
         * This is the trimmed area of original texture, before it was put in atlas
         * Please call `updateUvs()` after you change coordinates of `trim` manually.
         *
         * @member {PIXI.Rectangle}
         */ _this.trim = trim;
        /**
         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
         *
         * @member {boolean}
         */ _this.valid = false;
        /**
         * The WebGL UV data cache. Can be used as quad UV
         *
         * @member {PIXI.TextureUvs}
         * @protected
         */ _this._uvs = DEFAULT_UVS;
        /**
         * Default TextureMatrix instance for this texture
         * By default that object is not created because its heavy
         *
         * @member {PIXI.TextureMatrix}
         */ _this.uvMatrix = null;
        /**
         * This is the area of original texture, before it was put in atlas
         *
         * @member {PIXI.Rectangle}
         */ _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);
        _this._rotate = Number(rotate || 0);
        if (rotate === true) // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
        _this._rotate = 2;
        else if (_this._rotate % 2 !== 0) throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
        /**
         * Anchor point that is used as default if sprite is created with this texture.
         * Changing the `defaultAnchor` at a later point of time will not update Sprite's anchor point.
         * @member {PIXI.Point}
         * @default {0,0}
         */ _this.defaultAnchor = anchor ? new (0, $6qzqq.Point)(anchor.x, anchor.y) : new (0, $6qzqq.Point)(0, 0);
        /**
         * Update ID is observed by sprites and TextureMatrix instances.
         * Call updateUvs() to increment it.
         *
         * @member {number}
         * @protected
         */ _this._updateID = 0;
        /**
         * The ids under which this Texture has been added to the texture cache. This is
         * automatically set as long as Texture.addToCache is used, but may not be set if a
         * Texture is added directly to the TextureCache array.
         *
         * @member {string[]}
         */ _this.textureCacheIds = [];
        if (!baseTexture.valid) baseTexture.once('loaded', _this.onBaseTextureUpdated, _this);
        else if (_this.noFrame) // if there is no frame we should monitor for any base texture changes..
        {
            if (baseTexture.valid) _this.onBaseTextureUpdated(baseTexture);
        } else _this.frame = frame;
        if (_this.noFrame) baseTexture.on('update', _this.onBaseTextureUpdated, _this);
        return _this;
    }
    /**
     * Updates this texture on the gpu.
     *
     * Calls the TextureResource update.
     *
     * If you adjusted `frame` manually, please call `updateUvs()` instead.
     *
     */ Texture.prototype.update = function() {
        if (this.baseTexture.resource) this.baseTexture.resource.update();
    };
    /**
     * Called when the base texture is updated
     *
     * @protected
     * @param {PIXI.BaseTexture} baseTexture - The base texture.
     */ Texture.prototype.onBaseTextureUpdated = function(baseTexture) {
        if (this.noFrame) {
            if (!this.baseTexture.valid) return;
            this._frame.width = baseTexture.width;
            this._frame.height = baseTexture.height;
            this.valid = true;
            this.updateUvs();
        } else // TODO this code looks confusing.. boo to abusing getters and setters!
        // if user gave us frame that has bigger size than resized texture it can be a problem
        this.frame = this._frame;
        this.emit('update', this);
    };
    /**
     * Destroys this texture
     *
     * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
     */ Texture.prototype.destroy = function(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                var resource = this.baseTexture.resource;
                // delete the texture if it exists in the texture cache..
                // this only needs to be removed if the base texture is actually destroyed too..
                if (resource && resource.url && (0, $csytw.TextureCache)[resource.url]) Texture.removeFromCache(resource.url);
                this.baseTexture.destroy();
            }
            this.baseTexture.off('loaded', this.onBaseTextureUpdated, this);
            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
            this.baseTexture = null;
        }
        this._frame = null;
        this._uvs = null;
        this.trim = null;
        this.orig = null;
        this.valid = false;
        Texture.removeFromCache(this);
        this.textureCacheIds = null;
    };
    /**
     * Creates a new texture object that acts the same as this one.
     *
     * @return {PIXI.Texture} The new texture
     */ Texture.prototype.clone = function() {
        var clonedFrame = this._frame.clone();
        var clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone();
        var clonedTexture = new Texture(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, this.trim && this.trim.clone(), this.rotate, this.defaultAnchor);
        if (this.noFrame) clonedTexture._frame = clonedFrame;
        return clonedTexture;
    };
    /**
     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
     * Call it after changing the frame
     */ Texture.prototype.updateUvs = function() {
        if (this._uvs === DEFAULT_UVS) this._uvs = new TextureUvs();
        this._uvs.set(this._frame, this.baseTexture, this.rotate);
        this._updateID++;
    };
    /**
     * Helper function that creates a new Texture based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture} source -
     *        Source to create texture from
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
     * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
     * @return {PIXI.Texture} The newly created texture
     */ Texture.from = function(source, options, strict) {
        if (options === void 0) options = {};
        if (strict === void 0) strict = (0, $ezJmd.settings).STRICT_TEXTURE_CACHE;
        var isFrame = typeof source === 'string';
        var cacheId = null;
        if (isFrame) cacheId = source;
        else if (source instanceof BaseTexture) {
            if (!source.cacheId) {
                var prefix = options && options.pixiIdPrefix || 'pixiid';
                source.cacheId = prefix + "-" + (0, $csytw.uid)();
                BaseTexture.addToCache(source, source.cacheId);
            }
            cacheId = source.cacheId;
        } else {
            if (!source._pixiId) {
                var prefix = options && options.pixiIdPrefix || 'pixiid';
                source._pixiId = prefix + "_" + (0, $csytw.uid)();
            }
            cacheId = source._pixiId;
        }
        var texture = (0, $csytw.TextureCache)[cacheId];
        // Strict-mode rejects invalid cacheIds
        if (isFrame && strict && !texture) throw new Error("The cacheId \"" + cacheId + "\" does not exist in TextureCache.");
        if (!texture && !(source instanceof BaseTexture)) {
            if (!options.resolution) options.resolution = (0, $csytw.getResolutionOfUrl)(source);
            texture = new Texture(new BaseTexture(source, options));
            texture.baseTexture.cacheId = cacheId;
            BaseTexture.addToCache(texture.baseTexture, cacheId);
            Texture.addToCache(texture, cacheId);
        } else if (!texture && source instanceof BaseTexture) {
            texture = new Texture(source);
            Texture.addToCache(texture, cacheId);
        }
        // lets assume its a base texture!
        return texture;
    };
    /**
     * Useful for loading textures via URLs. Use instead of `Texture.from` because
     * it does a better job of handling failed URLs more effectively. This also ignores
     * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
     * @param {string} url - The remote URL to load.
     * @param {object} [options] - Optional options to include
     * @return {Promise<PIXI.Texture>} A Promise that resolves to a Texture.
     */ Texture.fromURL = function(url, options) {
        var resourceOptions = Object.assign({
            autoLoad: false
        }, options === null || options === void 0 ? void 0 : options.resourceOptions);
        var texture = Texture.from(url, Object.assign({
            resourceOptions: resourceOptions
        }, options), false);
        var resource = texture.baseTexture.resource;
        // The texture was already loaded
        if (texture.baseTexture.valid) return Promise.resolve(texture);
        // Manually load the texture, this should allow users to handle load errors
        return resource.load().then(function() {
            return Promise.resolve(texture);
        });
    };
    /**
     * Create a new Texture with a BufferResource from a Float32Array.
     * RGBA values are floats from 0 to 1.
     * @static
     * @param {Float32Array|Uint8Array} buffer - The optional array to use, if no data
     *        is provided, a new Float32Array is created.
     * @param {number} width - Width of the resource
     * @param {number} height - Height of the resource
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @return {PIXI.Texture} The resulting new BaseTexture
     */ Texture.fromBuffer = function(buffer, width, height, options) {
        return new Texture(BaseTexture.fromBuffer(buffer, width, height, options));
    };
    /**
     * Create a texture from a source and add to the cache.
     *
     * @static
     * @param {HTMLImageElement|HTMLCanvasElement|string} source - The input source.
     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
     * @param {String} [name] - Human readable name for the texture cache. If no name is
     *        specified, only `imageUrl` will be used as the cache ID.
     * @return {PIXI.Texture} Output texture
     */ Texture.fromLoader = function(source, imageUrl, name, options) {
        var baseTexture = new BaseTexture(source, Object.assign({
            scaleMode: (0, $ezJmd.settings).SCALE_MODE,
            resolution: (0, $csytw.getResolutionOfUrl)(imageUrl)
        }, options));
        var resource = baseTexture.resource;
        if (resource instanceof ImageResource) resource.url = imageUrl;
        var texture = new Texture(baseTexture);
        // No name, use imageUrl instead
        if (!name) name = imageUrl;
        // lets also add the frame to pixi's global cache for 'fromLoader' function
        BaseTexture.addToCache(texture.baseTexture, name);
        Texture.addToCache(texture, name);
        // also add references by url if they are different.
        if (name !== imageUrl) {
            BaseTexture.addToCache(texture.baseTexture, imageUrl);
            Texture.addToCache(texture, imageUrl);
        }
        // Generally images are valid right away
        if (texture.baseTexture.valid) return Promise.resolve(texture);
        // SVG assets need to be parsed async, let's wait
        return new Promise(function(resolve) {
            texture.baseTexture.once('loaded', function() {
                return resolve(texture);
            });
        });
    };
    /**
     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.Texture} texture - The Texture to add to the cache.
     * @param {string} id - The id that the Texture will be stored against.
     */ Texture.addToCache = function(texture, id) {
        if (id) {
            if (texture.textureCacheIds.indexOf(id) === -1) texture.textureCacheIds.push(id);
            if ((0, $csytw.TextureCache)[id]) // eslint-disable-next-line no-console
            console.warn("Texture added to the cache with an id [" + id + "] that already had an entry");
            (0, $csytw.TextureCache)[id] = texture;
        }
    };
    /**
     * Remove a Texture from the global TextureCache.
     *
     * @static
     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
     * @return {PIXI.Texture|null} The Texture that was removed
     */ Texture.removeFromCache = function(texture) {
        if (typeof texture === 'string') {
            var textureFromCache = (0, $csytw.TextureCache)[texture];
            if (textureFromCache) {
                var index = textureFromCache.textureCacheIds.indexOf(texture);
                if (index > -1) textureFromCache.textureCacheIds.splice(index, 1);
                delete (0, $csytw.TextureCache)[texture];
                return textureFromCache;
            }
        } else if (texture && texture.textureCacheIds) {
            for(var i = 0; i < texture.textureCacheIds.length; ++i)// Check that texture matches the one being passed in before deleting it from the cache.
            if ((0, $csytw.TextureCache)[texture.textureCacheIds[i]] === texture) delete (0, $csytw.TextureCache)[texture.textureCacheIds[i]];
            texture.textureCacheIds.length = 0;
            return texture;
        }
        return null;
    };
    Object.defineProperty(Texture.prototype, "resolution", {
        /**
         * Returns resolution of baseTexture
         *
         * @member {number}
         * @readonly
         */ get: function() {
            return this.baseTexture.resolution;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "frame", {
        /**
         * The frame specifies the region of the base texture that this texture uses.
         * Please call `updateUvs()` after you change coordinates of `frame` manually.
         *
         * @member {PIXI.Rectangle}
         */ get: function() {
            return this._frame;
        },
        set: function(frame) {
            this._frame = frame;
            this.noFrame = false;
            var x = frame.x, y = frame.y, width = frame.width, height = frame.height;
            var xNotFit = x + width > this.baseTexture.width;
            var yNotFit = y + height > this.baseTexture.height;
            if (xNotFit || yNotFit) {
                var relationship = xNotFit && yNotFit ? 'and' : 'or';
                var errorX = "X: " + x + " + " + width + " = " + (x + width) + " > " + this.baseTexture.width;
                var errorY = "Y: " + y + " + " + height + " = " + (y + height) + " > " + this.baseTexture.height;
                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + " " + relationship + " " + errorY));
            }
            this.valid = width && height && this.baseTexture.valid;
            if (!this.trim && !this.rotate) this.orig = frame;
            if (this.valid) this.updateUvs();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "rotate", {
        /**
         * Indicates whether the texture is rotated inside the atlas
         * set to 2 to compensate for texture packer rotation
         * set to 6 to compensate for spine packer rotation
         * can be used to rotate or mirror sprites
         * See {@link PIXI.groupD8} for explanation
         *
         * @member {number}
         */ get: function() {
            return this._rotate;
        },
        set: function(rotate) {
            this._rotate = rotate;
            if (this.valid) this.updateUvs();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "width", {
        /**
         * The width of the Texture in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.orig.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "height", {
        /**
         * The height of the Texture in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.orig.height;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Utility function for BaseTexture|Texture cast
     */ Texture.prototype.castToBaseTexture = function() {
        return this.baseTexture;
    };
    return Texture;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
function createWhiteTexture() {
    var canvas = document.createElement('canvas');
    canvas.width = 16;
    canvas.height = 16;
    var context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 0, 16, 16);
    return new Texture(new BaseTexture(new CanvasResource(canvas)));
}
function removeAllHandlers(tex) {
    tex.destroy = function _emptyDestroy() {};
    tex.on = function _emptyOn() {};
    tex.once = function _emptyOnce() {};
    tex.emit = function _emptyEmit() {};
}
/**
 * An empty texture, used often to not have to create multiple empty textures.
 * Can not be destroyed.
 *
 * @static
 * @constant
 * @member {PIXI.Texture}
 */ Texture.EMPTY = new Texture(new BaseTexture());
removeAllHandlers(Texture.EMPTY);
removeAllHandlers(Texture.EMPTY.baseTexture);
/**
 * A white texture of 16x16 size, used for graphics and other things
 * Can not be destroyed.
 *
 * @static
 * @constant
 * @member {PIXI.Texture}
 */ Texture.WHITE = createWhiteTexture();
removeAllHandlers(Texture.WHITE);
removeAllHandlers(Texture.WHITE.baseTexture);
/**
 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * __Hint-2__: The actual memory allocation will happen on first render.
 * You shouldn't create renderTextures each frame just to delete them after, try to reuse them.
 *
 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer();
 * let renderTexture = PIXI.RenderTexture.create({ width: 800, height: 600 });
 * let sprite = PIXI.Sprite.from("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, {renderTexture});
 * ```
 * Note that you should not create a new renderer, but reuse the same one as the rest of the application.
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let renderTexture = new PIXI.RenderTexture.create({ width: 100, height: 100 });
 *
 * renderer.render(sprite, {renderTexture});  // Renders to center of RenderTexture
 * ```
 *
 * @memberof PIXI
 */ var RenderTexture = /** @class */ function(_super) {
    __extends(RenderTexture, _super);
    /**
     * @param baseRenderTexture - The base texture object that this texture uses.
     * @param frame - The rectangle frame of the texture to show.
     */ function RenderTexture(baseRenderTexture, frame) {
        var _this = _super.call(this, baseRenderTexture, frame) || this;
        _this.valid = true;
        _this.filterFrame = null;
        _this.filterPoolKey = null;
        _this.updateUvs();
        return _this;
    }
    Object.defineProperty(RenderTexture.prototype, "framebuffer", {
        /**
         * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
         *
         * @readonly
         */ get: function() {
            return this.baseTexture.framebuffer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RenderTexture.prototype, "multisample", {
        /**
         * Shortcut to `this.framebuffer.multisample`.
         *
         * @default PIXI.MSAA_QUALITY.NONE
         */ get: function() {
            return this.framebuffer.multisample;
        },
        set: function(value) {
            this.framebuffer.multisample = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Resizes the RenderTexture.
     *
     * @param desiredWidth - The desired width to resize to.
     * @param desiredHeight - The desired height to resize to.
     * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
     */ RenderTexture.prototype.resize = function(desiredWidth, desiredHeight, resizeBaseTexture) {
        if (resizeBaseTexture === void 0) resizeBaseTexture = true;
        var resolution = this.baseTexture.resolution;
        var width = Math.round(desiredWidth * resolution) / resolution;
        var height = Math.round(desiredHeight * resolution) / resolution;
        // TODO - could be not required..
        this.valid = width > 0 && height > 0;
        this._frame.width = this.orig.width = width;
        this._frame.height = this.orig.height = height;
        if (resizeBaseTexture) this.baseTexture.resize(width, height);
        this.updateUvs();
    };
    /**
     * Changes the resolution of baseTexture, but does not change framebuffer size.
     *
     * @param resolution - The new resolution to apply to RenderTexture
     */ RenderTexture.prototype.setResolution = function(resolution) {
        var baseTexture = this.baseTexture;
        if (baseTexture.resolution === resolution) return;
        baseTexture.setResolution(resolution);
        this.resize(baseTexture.width, baseTexture.height, false);
    };
    RenderTexture.create = function(options) {
        var arguments$1 = arguments;
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments$1[_i];
        // @deprecated fallback, old-style: create(width, height, scaleMode, resolution)
        if (typeof options === 'number') {
            (0, $csytw.deprecation)('6.0.0', 'Arguments (width, height, scaleMode, resolution) have been deprecated.');
            /* eslint-disable prefer-rest-params */ options = {
                width: options,
                height: rest[0],
                scaleMode: rest[1],
                resolution: rest[2]
            };
        /* eslint-enable prefer-rest-params */ }
        return new RenderTexture(new BaseRenderTexture(options));
    };
    return RenderTexture;
}(Texture);
/**
 * Texture pool, used by FilterSystem and plugins.
 *
 * Stores collection of temporary pow2 or screen-sized renderTextures
 *
 * If you use custom RenderTexturePool for your filters, you can use methods
 * `getFilterTexture` and `returnFilterTexture` same as in
 *
 * @memberof PIXI
 */ var RenderTexturePool = /** @class */ function() {
    /**
     * @param textureOptions - options that will be passed to BaseRenderTexture constructor
     * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
     */ function RenderTexturePool(textureOptions) {
        this.texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this._pixelsWidth = 0;
        this._pixelsHeight = 0;
    }
    /**
     * Creates texture with params that were specified in pool constructor.
     *
     * @param realWidth - Width of texture in pixels.
     * @param realHeight - Height of texture in pixels.
     * @param multisample - Number of samples of the framebuffer.
     */ RenderTexturePool.prototype.createTexture = function(realWidth, realHeight, multisample) {
        if (multisample === void 0) multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        var baseRenderTexture = new BaseRenderTexture(Object.assign({
            width: realWidth,
            height: realHeight,
            resolution: 1,
            multisample: multisample
        }, this.textureOptions));
        return new RenderTexture(baseRenderTexture);
    };
    /**
     * Gets a Power-of-Two render texture or fullScreen texture
     *
     * @param minWidth - The minimum width of the render texture.
     * @param minHeight - The minimum height of the render texture.
     * @param resolution - The resolution of the render texture.
     * @param multisample - Number of samples of the render texture.
     * @return The new render texture.
     */ RenderTexturePool.prototype.getOptimalTexture = function(minWidth, minHeight, resolution, multisample) {
        if (resolution === void 0) resolution = 1;
        if (multisample === void 0) multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        var key;
        minWidth = Math.ceil(minWidth * resolution);
        minHeight = Math.ceil(minHeight * resolution);
        if (!this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight) {
            minWidth = (0, $csytw.nextPow2)(minWidth);
            minHeight = (0, $csytw.nextPow2)(minHeight);
            key = ((minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF) >>> 0;
            if (multisample > 1) key += multisample * 0x100000000;
        } else key = multisample > 1 ? -multisample : -1;
        if (!this.texturePool[key]) this.texturePool[key] = [];
        var renderTexture = this.texturePool[key].pop();
        if (!renderTexture) renderTexture = this.createTexture(minWidth, minHeight, multisample);
        renderTexture.filterPoolKey = key;
        renderTexture.setResolution(resolution);
        return renderTexture;
    };
    /**
     * Gets extra texture of the same size as input renderTexture
     *
     * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
     *
     * @param input - renderTexture from which size and resolution will be copied
     * @param resolution - override resolution of the renderTexture
     *  It overrides, it does not multiply
     * @param multisample - number of samples of the renderTexture
     * @returns
     */ RenderTexturePool.prototype.getFilterTexture = function(input, resolution, multisample) {
        var filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $P8XPi.MSAA_QUALITY).NONE);
        filterTexture.filterFrame = input.filterFrame;
        return filterTexture;
    };
    /**
     * Place a render texture back into the pool.
     *
     * @param renderTexture - The renderTexture to free
     */ RenderTexturePool.prototype.returnTexture = function(renderTexture) {
        var key = renderTexture.filterPoolKey;
        renderTexture.filterFrame = null;
        this.texturePool[key].push(renderTexture);
    };
    /**
     * Alias for returnTexture, to be compliant with FilterSystem interface.
     *
     * @param renderTexture - The renderTexture to free
     */ RenderTexturePool.prototype.returnFilterTexture = function(renderTexture) {
        this.returnTexture(renderTexture);
    };
    /**
     * Clears the pool.
     *
     * @param destroyTextures - Destroy all stored textures.
     */ RenderTexturePool.prototype.clear = function(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(var i in this.texturePool){
            var textures = this.texturePool[i];
            if (textures) for(var j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this.texturePool = {};
    };
    /**
     * If screen size was changed, drops all screen-sized textures,
     * sets new screen size, sets `enableFullScreen` to true
     *
     * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
     *
     * @param size - Initial size of screen.
     */ RenderTexturePool.prototype.setScreenSize = function(size) {
        if (size.width === this._pixelsWidth && size.height === this._pixelsHeight) return;
        this.enableFullScreen = size.width > 0 && size.height > 0;
        for(var i in this.texturePool){
            if (!(Number(i) < 0)) continue;
            var textures = this.texturePool[i];
            if (textures) for(var j = 0; j < textures.length; j++)textures[j].destroy(true);
            this.texturePool[i] = [];
        }
        this._pixelsWidth = size.width;
        this._pixelsHeight = size.height;
    };
    /**
     * Key that is used to store fullscreen renderTextures in a pool
     *
     * @constant
     */ RenderTexturePool.SCREEN_KEY = -1;
    return RenderTexturePool;
}();
/* eslint-disable max-len */ /**
 * Holds the information for a single attribute structure required to render geometry.
 *
 * This does not contain the actual data, but instead has a buffer id that maps to a {@link PIXI.Buffer}
 * This can include anything from positions, uvs, normals, colors etc.
 *
 * @memberof PIXI
 */ var Attribute = /** @class */ function() {
    /**
     * @param buffer - the id of the buffer that this attribute will look for
     * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
     * @param normalized - should the data be normalized.
     * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
     * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
     * @param [start=0] - How far into the array to start reading values (used for interleaving data)
     * @param [instance=false] - Whether the geometry is instanced.
     */ function Attribute(buffer, size, normalized, type, stride, start, instance) {
        if (size === void 0) size = 0;
        if (normalized === void 0) normalized = false;
        if (type === void 0) type = (0, $P8XPi.TYPES).FLOAT;
        this.buffer = buffer;
        this.size = size;
        this.normalized = normalized;
        this.type = type;
        this.stride = stride;
        this.start = start;
        this.instance = instance;
    }
    /** Destroys the Attribute. */ Attribute.prototype.destroy = function() {
        this.buffer = null;
    };
    /**
     * Helper function that creates an Attribute based on the information provided
     *
     * @param buffer - the id of the buffer that this attribute will look for
     * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
     * @param [normalized=false] - should the data be normalized.
     * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
     * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
     * @returns - A new {@link PIXI.Attribute} based on the information provided
     */ Attribute.from = function(buffer, size, normalized, type, stride) {
        return new Attribute(buffer, size, normalized, type, stride);
    };
    return Attribute;
}();
var UID = 0;
/**
 * A wrapper for data so that it can be used and uploaded by WebGL
 *
 * @memberof PIXI
 */ var Buffer = /** @class */ function() {
    /**
     * @param {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} data - the data to store in the buffer.
     * @param _static - `true` for static buffer
     * @param index - `true` for index buffer
     */ function Buffer(data, _static, index) {
        if (_static === void 0) _static = true;
        if (index === void 0) index = false;
        this.data = data || new Float32Array(1);
        this._glBuffers = {};
        this._updateID = 0;
        this.index = index;
        this.static = _static;
        this.id = UID++;
        this.disposeRunner = new (0, $6fZag.Runner)('disposeBuffer');
    }
    // TODO could explore flagging only a partial upload?
    /**
     * Flags this buffer as requiring an upload to the GPU.
     * @param {ArrayBuffer|SharedArrayBuffer|ArrayBufferView|number[]} [data] - the data to update in the buffer.
     */ Buffer.prototype.update = function(data) {
        if (data instanceof Array) data = new Float32Array(data);
        this.data = data || this.data;
        this._updateID++;
    };
    /** Disposes WebGL resources that are connected to this geometry. */ Buffer.prototype.dispose = function() {
        this.disposeRunner.emit(this, false);
    };
    /** Destroys the buffer. */ Buffer.prototype.destroy = function() {
        this.dispose();
        this.data = null;
    };
    Object.defineProperty(Buffer.prototype, "index", {
        get: function() {
            return this.type === (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        },
        /**
         * Flags whether this is an index buffer.
         *
         * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
         * the buffer of type `ARRAY_BUFFER`.
         *
         * For backwards compatibility.
         */ set: function(value) {
            this.type = value ? (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER : (0, $P8XPi.BUFFER_TYPE).ARRAY_BUFFER;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Helper function that creates a buffer based on an array or TypedArray
     *
     * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
     * @return - A new Buffer based on the data provided.
     */ Buffer.from = function(data) {
        if (data instanceof Array) data = new Float32Array(data);
        return new Buffer(data);
    };
    return Buffer;
}();
/* eslint-disable object-shorthand */ var map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function interleaveTypedArrays(arrays, sizes) {
    var outSize = 0;
    var stride = 0;
    var views = {};
    for(var i = 0; i < arrays.length; i++){
        stride += sizes[i];
        outSize += arrays[i].length;
    }
    var buffer = new ArrayBuffer(outSize * 4);
    var out = null;
    var littleOffset = 0;
    for(var i = 0; i < arrays.length; i++){
        var size = sizes[i];
        var array = arrays[i];
        var type = (0, $csytw.getBufferType)(array);
        if (!views[type]) views[type] = new map[type](buffer);
        out = views[type];
        for(var j = 0; j < array.length; j++){
            var indexStart = (j / size | 0) * stride + littleOffset;
            var index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}
var byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
var UID$1 = 0;
/* eslint-disable object-shorthand */ var map$1 = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array,
    Uint16Array: Uint16Array
};
/* eslint-disable max-len */ /**
 * The Geometry represents a model. It consists of two components:
 * - GeometryStyle - The structure of the model such as the attributes layout
 * - GeometryData - the data of the model - this consists of buffers.
 * This can include anything from positions, uvs, normals, colors etc.
 *
 * Geometry can be defined without passing in a style or data if required (thats how I prefer!)
 *
 * ```js
 * let geometry = new PIXI.Geometry();
 *
 * geometry.addAttribute('positions', [0, 0, 100, 0, 100, 100, 0, 100], 2);
 * geometry.addAttribute('uvs', [0,0,1,0,1,1,0,1],2)
 * geometry.addIndex([0,1,2,1,3,2])
 * ```
 *
 * @memberof PIXI
 */ var Geometry = /** @class */ function() {
    /**
     * @param buffers - An array of buffers. optional.
     * @param attributes - Of the geometry, optional structure of the attributes layout
     */ function Geometry(buffers, attributes) {
        if (buffers === void 0) buffers = [];
        if (attributes === void 0) attributes = {};
        this.buffers = buffers;
        this.indexBuffer = null;
        this.attributes = attributes;
        this.glVertexArrayObjects = {};
        this.id = UID$1++;
        this.instanced = false;
        this.instanceCount = 1;
        this.disposeRunner = new (0, $6fZag.Runner)('disposeGeometry');
        this.refCount = 0;
    }
    /**
     *
     * Adds an attribute to the geometry
     * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
     *
     * @param id - the name of the attribute (matching up to a shader)
     * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
     * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
     * @param normalized - should the data be normalized.
     * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {PIXI.TYPES} to see the ones available
     * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
     * @param [start=0] - How far into the array to start reading values (used for interleaving data)
     * @param instance - Instancing flag
     * @return - Returns self, useful for chaining.
     */ Geometry.prototype.addAttribute = function(id, buffer, size, normalized, type, stride, start, instance) {
        if (size === void 0) size = 0;
        if (normalized === void 0) normalized = false;
        if (instance === void 0) instance = false;
        if (!buffer) throw new Error('You must pass a buffer when creating an attribute');
        // check if this is a buffer!
        if (!(buffer instanceof Buffer)) {
            // its an array!
            if (buffer instanceof Array) buffer = new Float32Array(buffer);
            buffer = new Buffer(buffer);
        }
        var ids = id.split('|');
        if (ids.length > 1) {
            for(var i = 0; i < ids.length; i++)this.addAttribute(ids[i], buffer, size, normalized, type);
            return this;
        }
        var bufferIndex = this.buffers.indexOf(buffer);
        if (bufferIndex === -1) {
            this.buffers.push(buffer);
            bufferIndex = this.buffers.length - 1;
        }
        this.attributes[id] = new Attribute(bufferIndex, size, normalized, type, stride, start, instance);
        // assuming that if there is instanced data then this will be drawn with instancing!
        this.instanced = this.instanced || instance;
        return this;
    };
    /**
     * Returns the requested attribute.
     *
     * @param id - The name of the attribute required
     * @return - The attribute requested.
     */ Geometry.prototype.getAttribute = function(id) {
        return this.attributes[id];
    };
    /**
     * Returns the requested buffer.
     *
     * @param id - The name of the buffer required.
     * @return - The buffer requested.
     */ Geometry.prototype.getBuffer = function(id) {
        return this.buffers[this.getAttribute(id).buffer];
    };
    /**
    *
    * Adds an index buffer to the geometry
    * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
    *
    * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
    * @return - Returns self, useful for chaining.
    */ Geometry.prototype.addIndex = function(buffer) {
        if (!(buffer instanceof Buffer)) {
            // its an array!
            if (buffer instanceof Array) buffer = new Uint16Array(buffer);
            buffer = new Buffer(buffer);
        }
        buffer.type = (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        this.indexBuffer = buffer;
        if (this.buffers.indexOf(buffer) === -1) this.buffers.push(buffer);
        return this;
    };
    /**
     * Returns the index buffer
     *
     * @return - The index buffer.
     */ Geometry.prototype.getIndex = function() {
        return this.indexBuffer;
    };
    /**
     * This function modifies the structure so that all current attributes become interleaved into a single buffer
     * This can be useful if your model remains static as it offers a little performance boost
     *
     * @return - Returns self, useful for chaining.
     */ Geometry.prototype.interleave = function() {
        // a simple check to see if buffers are already interleaved..
        if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer) return this;
        // assume already that no buffers are interleaved
        var arrays = [];
        var sizes = [];
        var interleavedBuffer = new Buffer();
        var i;
        for(i in this.attributes){
            var attribute = this.attributes[i];
            var buffer = this.buffers[attribute.buffer];
            arrays.push(buffer.data);
            sizes.push(attribute.size * byteSizeMap[attribute.type] / 4);
            attribute.buffer = 0;
        }
        interleavedBuffer.data = interleaveTypedArrays(arrays, sizes);
        for(i = 0; i < this.buffers.length; i++)if (this.buffers[i] !== this.indexBuffer) this.buffers[i].destroy();
        this.buffers = [
            interleavedBuffer
        ];
        if (this.indexBuffer) this.buffers.push(this.indexBuffer);
        return this;
    };
    /** Get the size of the geometries, in vertices. */ Geometry.prototype.getSize = function() {
        for(var i in this.attributes){
            var attribute = this.attributes[i];
            var buffer = this.buffers[attribute.buffer];
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    };
    /** Disposes WebGL resources that are connected to this geometry. */ Geometry.prototype.dispose = function() {
        this.disposeRunner.emit(this, false);
    };
    /** Destroys the geometry. */ Geometry.prototype.destroy = function() {
        this.dispose();
        this.buffers = null;
        this.indexBuffer = null;
        this.attributes = null;
    };
    /**
     * Returns a clone of the geometry.
     *
     * @returns - A new clone of this geometry.
     */ Geometry.prototype.clone = function() {
        var geometry = new Geometry();
        for(var i = 0; i < this.buffers.length; i++)geometry.buffers[i] = new Buffer(this.buffers[i].data.slice(0));
        for(var i in this.attributes){
            var attrib = this.attributes[i];
            geometry.attributes[i] = new Attribute(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
        }
        if (this.indexBuffer) {
            geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)];
            geometry.indexBuffer.type = (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        }
        return geometry;
    };
    /**
     * Merges an array of geometries into a new single one.
     *
     * Geometry attribute styles must match for this operation to work.
     *
     * @param geometries - array of geometries to merge
     * @return - Shiny new geometry!
     */ Geometry.merge = function(geometries) {
        // todo add a geometry check!
        // also a size check.. cant be too big!]
        var geometryOut = new Geometry();
        var arrays = [];
        var sizes = [];
        var offsets = [];
        var geometry;
        // pass one.. get sizes..
        for(var i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(var j = 0; j < geometry.buffers.length; j++){
                sizes[j] = sizes[j] || 0;
                sizes[j] += geometry.buffers[j].data.length;
                offsets[j] = 0;
            }
        }
        // build the correct size arrays..
        for(var i = 0; i < geometry.buffers.length; i++){
            // TODO types!
            arrays[i] = new map$1[(0, $csytw.getBufferType)(geometry.buffers[i].data)](sizes[i]);
            geometryOut.buffers[i] = new Buffer(arrays[i]);
        }
        // pass to set data..
        for(var i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(var j = 0; j < geometry.buffers.length; j++){
                arrays[j].set(geometry.buffers[j].data, offsets[j]);
                offsets[j] += geometry.buffers[j].data.length;
            }
        }
        geometryOut.attributes = geometry.attributes;
        if (geometry.indexBuffer) {
            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)];
            geometryOut.indexBuffer.type = (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
            var offset = 0;
            var stride = 0;
            var offset2 = 0;
            var bufferIndexToCount = 0;
            // get a buffer
            for(var i = 0; i < geometry.buffers.length; i++)if (geometry.buffers[i] !== geometry.indexBuffer) {
                bufferIndexToCount = i;
                break;
            }
            // figure out the stride of one buffer..
            for(var i in geometry.attributes){
                var attribute = geometry.attributes[i];
                if ((attribute.buffer | 0) === bufferIndexToCount) stride += attribute.size * byteSizeMap[attribute.type] / 4;
            }
            // time to off set all indexes..
            for(var i = 0; i < geometries.length; i++){
                var indexBufferData = geometries[i].indexBuffer.data;
                for(var j = 0; j < indexBufferData.length; j++)geometryOut.indexBuffer.data[j + offset2] += offset;
                offset += geometries[i].buffers[bufferIndexToCount].data.length / stride;
                offset2 += indexBufferData.length;
            }
        }
        return geometryOut;
    };
    return Geometry;
}();
/**
 * Helper class to create a quad
 *
 * @class
 * @memberof PIXI
 */ var Quad = /** @class */ function(_super) {
    __extends(Quad, _super);
    function Quad() {
        var _this = _super.call(this) || this;
        _this.addAttribute('aVertexPosition', new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ])).addIndex([
            0,
            1,
            3,
            2
        ]);
        return _this;
    }
    return Quad;
}(Geometry);
/**
 * Helper class to create a quad with uvs like in v4
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.Geometry
 */ var QuadUv = /** @class */ function(_super) {
    __extends(QuadUv, _super);
    function QuadUv() {
        var _this = _super.call(this) || this;
        /**
         * An array of vertices
         *
         * @member {Float32Array}
         */ _this.vertices = new Float32Array([
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1
        ]);
        /**
         * The Uvs of the quad
         *
         * @member {Float32Array}
         */ _this.uvs = new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]);
        _this.vertexBuffer = new Buffer(_this.vertices);
        _this.uvBuffer = new Buffer(_this.uvs);
        _this.addAttribute('aVertexPosition', _this.vertexBuffer).addAttribute('aTextureCoord', _this.uvBuffer).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        return _this;
    }
    /**
     * Maps two Rectangle to the quad.
     *
     * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
     * @param {PIXI.Rectangle} destinationFrame - the second rectangle
     * @return {PIXI.Quad} Returns itself.
     */ QuadUv.prototype.map = function(targetTextureFrame, destinationFrame) {
        var x = 0; // destinationFrame.x / targetTextureFrame.width;
        var y = 0; // destinationFrame.y / targetTextureFrame.height;
        this.uvs[0] = x;
        this.uvs[1] = y;
        this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[3] = y;
        this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;
        this.uvs[6] = x;
        this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;
        x = destinationFrame.x;
        y = destinationFrame.y;
        this.vertices[0] = x;
        this.vertices[1] = y;
        this.vertices[2] = x + destinationFrame.width;
        this.vertices[3] = y;
        this.vertices[4] = x + destinationFrame.width;
        this.vertices[5] = y + destinationFrame.height;
        this.vertices[6] = x;
        this.vertices[7] = y + destinationFrame.height;
        this.invalidate();
        return this;
    };
    /**
     * legacy upload method, just marks buffers dirty
     * @returns {PIXI.QuadUv} Returns itself.
     */ QuadUv.prototype.invalidate = function() {
        this.vertexBuffer._updateID++;
        this.uvBuffer._updateID++;
        return this;
    };
    return QuadUv;
}(Geometry);
var UID$2 = 0;
/**
 * Uniform group holds uniform map and some ID's for work
 *
 * `UniformGroup` has two modes:
 *
 * 1: Normal mode
 * Normal mode will upload the uniforms with individual function calls as required
 *
 * 2: Uniform buffer mode
 * This mode will treat the uniforms as a uniform buffer. You can pass in either a buffer that you manually handle, or
 * or a generic object that PixiJS will automatically map to a buffer for you.
 * For maximum benefits, make Ubo UniformGroups static, and only update them each frame.
 *
 * Rules of UBOs:
 * - UBOs only work with WebGL2, so make sure you have a fallback!
 * - Only floats are supported (including vec[2,3,4], mat[2,3,4])
 * - Samplers cannot be used in ubo's (a GPU limitation)
 * - You must ensure that the object you pass in exactly matches in the shader ubo structure.
 * Otherwise, weirdness will ensue!
 * - The name of the ubo object added to the group must match exactly the name of the ubo in the shader.
 *
 * ```
 * // ubo in shader:
 * uniform myCoolData { // declaring a ubo..
 * mat4 uCoolMatrix;
 * float uFloatyMcFloatFace
 *
 *
 * // a new uniform buffer object..
 * const myCoolData = new UniformBufferGroup({
 *   uCoolMatrix: new Matrix(),
 *   uFloatyMcFloatFace: 23,
 * }}
 *
 * // build a shader...
 * const shader = Shader.from(srcVert, srcFrag, {
 *   myCoolData // name matches the ubo name in the shader. will be processed accordingly.
 * })
 *
 *  ```
 *
 * @class
 * @memberof PIXI
 */ var UniformGroup = /** @class */ function() {
    /**
     * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer
     * @param {boolean} [isStatic] - Uniforms wont be changed after creation
     * @param {boolean} [isUbo] - if true, will treat this uniform group as a uniform buffer object
     */ function UniformGroup(uniforms, isStatic, isUbo) {
        /**
         * Its a group and not a single uniforms
         * @member {boolean}
         * @readonly
         * @default true
         */ this.group = true;
        // lets generate this when the shader ?
        this.syncUniforms = {};
        /**
         * dirty version
         * @protected
         * @member {number}
         */ this.dirtyId = 0;
        /**
         * unique id
         * @protected
         * @member {number}
         */ this.id = UID$2++;
        /**
         * Uniforms wont be changed after creation
         * @member {boolean}
         */ this.static = !!isStatic;
        /**
         * Flags whether this group is treated like a uniform buffer object.
         * @member {boolean}
         */ this.ubo = !!isUbo;
        if (uniforms instanceof Buffer) {
            this.buffer = uniforms;
            this.buffer.type = (0, $P8XPi.BUFFER_TYPE).UNIFORM_BUFFER;
            this.autoManage = false;
            this.ubo = true;
        } else {
            /**
             * uniform values
             * @member {object}
             * @readonly
             */ this.uniforms = uniforms;
            if (this.ubo) {
                this.buffer = new Buffer(new Float32Array(1));
                this.buffer.type = (0, $P8XPi.BUFFER_TYPE).UNIFORM_BUFFER;
                this.autoManage = true;
            }
        }
    }
    UniformGroup.prototype.update = function() {
        this.dirtyId++;
        if (!this.autoManage && this.buffer) this.buffer.update();
    };
    UniformGroup.prototype.add = function(name, uniforms, _static) {
        if (!this.ubo) this.uniforms[name] = new UniformGroup(uniforms, _static);
        else // eslint-disable-next-line max-len
        throw new Error('[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them');
    };
    UniformGroup.from = function(uniforms, _static, _ubo) {
        return new UniformGroup(uniforms, _static, _ubo);
    };
    /**
     * A short hand function for creating a static UBO UniformGroup.
     *
     * @param uniforms - the ubo item
     * @param _static - should this be updated each time it is used? defaults to true here!
     */ UniformGroup.uboFrom = function(uniforms, _static) {
        return new UniformGroup(uniforms, _static !== null && _static !== void 0 ? _static : true, true);
    };
    return UniformGroup;
}();
/**
 * System plugin to the renderer to manage filter states.
 *
 * @ignore
 */ var FilterState = /** @class */ function() {
    function FilterState() {
        this.renderTexture = null;
        this.target = null;
        this.legacy = false;
        this.resolution = 1;
        this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        // next three fields are created only for root
        // re-assigned for everything else
        this.sourceFrame = new (0, $6qzqq.Rectangle)();
        this.destinationFrame = new (0, $6qzqq.Rectangle)();
        this.bindingSourceFrame = new (0, $6qzqq.Rectangle)();
        this.bindingDestinationFrame = new (0, $6qzqq.Rectangle)();
        this.filters = [];
        this.transform = null;
    }
    /** Clears the state */ FilterState.prototype.clear = function() {
        this.target = null;
        this.filters = null;
        this.renderTexture = null;
    };
    return FilterState;
}();
var tempPoints = [
    new (0, $6qzqq.Point)(),
    new (0, $6qzqq.Point)(),
    new (0, $6qzqq.Point)(),
    new (0, $6qzqq.Point)()
];
var tempMatrix = new (0, $6qzqq.Matrix)();
/**
 * System plugin to the renderer to manage filters.
 *
 * ## Pipeline
 *
 * The FilterSystem executes the filtering pipeline by rendering the display-object into a texture, applying its
 * [filters]{@link PIXI.Filter} in series, and the last filter outputs into the final render-target.
 *
 * The filter-frame is the rectangle in world space being filtered, and those contents are mapped into
 * `(0, 0, filterFrame.width, filterFrame.height)` into the filter render-texture. The filter-frame is also called
 * the source-frame, as it is used to bind the filter render-textures. The last filter outputs to the `filterFrame`
 * in the final render-target.
 *
 * ## Usage
 *
 * {@link PIXI.Container#renderAdvanced} is an example of how to use the filter system. It is a 3 step process:
 *
 * * **push**: Use {@link PIXI.FilterSystem#push} to push the set of filters to be applied on a filter-target.
 * * **render**: Render the contents to be filtered using the renderer. The filter-system will only capture the contents
 *      inside the bounds of the filter-target. NOTE: Using {@link PIXI.Renderer#render} is
 *      illegal during an existing render cycle, and it may reset the filter system.
 * * **pop**: Use {@link PIXI.FilterSystem#pop} to pop & execute the filters you initially pushed. It will apply them
 *      serially and output to the bounds of the filter-target.
 *
 * @memberof PIXI
 */ var FilterSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function FilterSystem(renderer) {
        this.renderer = renderer;
        this.defaultFilterStack = [
            {}
        ];
        this.texturePool = new RenderTexturePool();
        this.texturePool.setScreenSize(renderer.view);
        this.statePool = [];
        this.quad = new Quad();
        this.quadUv = new QuadUv();
        this.tempRect = new (0, $6qzqq.Rectangle)();
        this.activeState = {};
        this.globalUniforms = new UniformGroup({
            outputFrame: new (0, $6qzqq.Rectangle)(),
            inputSize: new Float32Array(4),
            inputPixel: new Float32Array(4),
            inputClamp: new Float32Array(4),
            resolution: 1,
            // legacy variables
            filterArea: new Float32Array(4),
            filterClamp: new Float32Array(4)
        }, true);
        this.forceClear = false;
        this.useMaxPadding = false;
    }
    /**
     * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
     * input render-texture for the rest of the filtering pipeline.
     *
     * @param {PIXI.DisplayObject} target - The target of the filter to render.
     * @param filters - The filters to apply.
     */ FilterSystem.prototype.push = function(target, filters) {
        var _a, _b;
        var renderer = this.renderer;
        var filterStack = this.defaultFilterStack;
        var state = this.statePool.pop() || new FilterState();
        var renderTextureSystem = this.renderer.renderTexture;
        var resolution = filters[0].resolution;
        var multisample = filters[0].multisample;
        var padding = filters[0].padding;
        var autoFit = filters[0].autoFit;
        // We don't know whether it's a legacy filter until it was bound for the first time,
        // therefore we have to assume that it is if legacy is undefined.
        var legacy = (_a = filters[0].legacy) !== null && _a !== void 0 ? _a : true;
        for(var i = 1; i < filters.length; i++){
            var filter = filters[i];
            // let's use the lowest resolution
            resolution = Math.min(resolution, filter.resolution);
            // let's use the lowest number of samples
            multisample = Math.min(multisample, filter.multisample);
            // figure out the padding required for filters
            padding = this.useMaxPadding ? Math.max(padding, filter.padding) : padding + filter.padding;
            // only auto fit if all filters are autofit
            autoFit = autoFit && filter.autoFit;
            legacy = legacy || ((_b = filter.legacy) !== null && _b !== void 0 ? _b : true);
        }
        if (filterStack.length === 1) this.defaultFilterStack[0].renderTexture = renderTextureSystem.current;
        filterStack.push(state);
        state.resolution = resolution;
        state.multisample = multisample;
        state.legacy = legacy;
        state.target = target;
        state.sourceFrame.copyFrom(target.filterArea || target.getBounds(true));
        state.sourceFrame.pad(padding);
        if (autoFit) {
            var sourceFrameProjected = this.tempRect.copyFrom(renderTextureSystem.sourceFrame);
            // Project source frame into world space (if projection is applied)
            if (renderer.projection.transform) this.transformAABB(tempMatrix.copyFrom(renderer.projection.transform).invert(), sourceFrameProjected);
            state.sourceFrame.fit(sourceFrameProjected);
        }
        // Round sourceFrame in screen space based on render-texture.
        this.roundFrame(state.sourceFrame, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform);
        state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution, multisample);
        state.filters = filters;
        state.destinationFrame.width = state.renderTexture.width;
        state.destinationFrame.height = state.renderTexture.height;
        var destinationFrame = this.tempRect;
        destinationFrame.x = 0;
        destinationFrame.y = 0;
        destinationFrame.width = state.sourceFrame.width;
        destinationFrame.height = state.sourceFrame.height;
        state.renderTexture.filterFrame = state.sourceFrame;
        state.bindingSourceFrame.copyFrom(renderTextureSystem.sourceFrame);
        state.bindingDestinationFrame.copyFrom(renderTextureSystem.destinationFrame);
        state.transform = renderer.projection.transform;
        renderer.projection.transform = null;
        renderTextureSystem.bind(state.renderTexture, state.sourceFrame, destinationFrame);
        renderer.framebuffer.clear(0, 0, 0, 0);
    };
    /** Pops off the filter and applies it. */ FilterSystem.prototype.pop = function() {
        var filterStack = this.defaultFilterStack;
        var state = filterStack.pop();
        var filters = state.filters;
        this.activeState = state;
        var globalUniforms = this.globalUniforms.uniforms;
        globalUniforms.outputFrame = state.sourceFrame;
        globalUniforms.resolution = state.resolution;
        var inputSize = globalUniforms.inputSize;
        var inputPixel = globalUniforms.inputPixel;
        var inputClamp = globalUniforms.inputClamp;
        inputSize[0] = state.destinationFrame.width;
        inputSize[1] = state.destinationFrame.height;
        inputSize[2] = 1.0 / inputSize[0];
        inputSize[3] = 1.0 / inputSize[1];
        inputPixel[0] = Math.round(inputSize[0] * state.resolution);
        inputPixel[1] = Math.round(inputSize[1] * state.resolution);
        inputPixel[2] = 1.0 / inputPixel[0];
        inputPixel[3] = 1.0 / inputPixel[1];
        inputClamp[0] = 0.5 * inputPixel[2];
        inputClamp[1] = 0.5 * inputPixel[3];
        inputClamp[2] = state.sourceFrame.width * inputSize[2] - 0.5 * inputPixel[2];
        inputClamp[3] = state.sourceFrame.height * inputSize[3] - 0.5 * inputPixel[3];
        // only update the rect if its legacy..
        if (state.legacy) {
            var filterArea = globalUniforms.filterArea;
            filterArea[0] = state.destinationFrame.width;
            filterArea[1] = state.destinationFrame.height;
            filterArea[2] = state.sourceFrame.x;
            filterArea[3] = state.sourceFrame.y;
            globalUniforms.filterClamp = globalUniforms.inputClamp;
        }
        this.globalUniforms.update();
        var lastState = filterStack[filterStack.length - 1];
        this.renderer.framebuffer.blit();
        if (filters.length === 1) {
            filters[0].apply(this, state.renderTexture, lastState.renderTexture, (0, $P8XPi.CLEAR_MODES).BLEND, state);
            this.returnFilterTexture(state.renderTexture);
        } else {
            var flip = state.renderTexture;
            var flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
            flop.filterFrame = flip.filterFrame;
            var i = 0;
            for(i = 0; i < filters.length - 1; ++i){
                if (i === 1 && state.multisample > 1) {
                    flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
                    flop.filterFrame = flip.filterFrame;
                }
                filters[i].apply(this, flip, flop, (0, $P8XPi.CLEAR_MODES).CLEAR, state);
                var t = flip;
                flip = flop;
                flop = t;
            }
            filters[i].apply(this, flip, lastState.renderTexture, (0, $P8XPi.CLEAR_MODES).BLEND, state);
            if (i > 1 && state.multisample > 1) this.returnFilterTexture(state.renderTexture);
            this.returnFilterTexture(flip);
            this.returnFilterTexture(flop);
        }
        // lastState.renderTexture is blitted when lastState is popped
        state.clear();
        this.statePool.push(state);
    };
    /**
     * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
     *
     * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
     * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
     */ FilterSystem.prototype.bindAndClear = function(filterTexture, clearMode) {
        if (clearMode === void 0) clearMode = (0, $P8XPi.CLEAR_MODES).CLEAR;
        var _a = this.renderer, renderTextureSystem = _a.renderTexture, stateSystem = _a.state;
        if (filterTexture === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture) // Restore projection transform if rendering into the output render-target.
        this.renderer.projection.transform = this.activeState.transform;
        else // Prevent projection within filtering pipeline.
        this.renderer.projection.transform = null;
        if (filterTexture && filterTexture.filterFrame) {
            var destinationFrame = this.tempRect;
            destinationFrame.x = 0;
            destinationFrame.y = 0;
            destinationFrame.width = filterTexture.filterFrame.width;
            destinationFrame.height = filterTexture.filterFrame.height;
            renderTextureSystem.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
        } else if (filterTexture !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture) renderTextureSystem.bind(filterTexture);
        else // Restore binding for output render-target.
        this.renderer.renderTexture.bind(filterTexture, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
        // Clear the texture in BLIT mode if blending is disabled or the forceClear flag is set. The blending
        // is stored in the 0th bit of the state.
        var autoClear = stateSystem.stateId & 1 || this.forceClear;
        if (clearMode === (0, $P8XPi.CLEAR_MODES).CLEAR || clearMode === (0, $P8XPi.CLEAR_MODES).BLIT && autoClear) // Use framebuffer.clear because we want to clear the whole filter texture, not just the filtering
        // area over which the shaders are run. This is because filters may sampling outside of it (e.g. blur)
        // instead of clamping their arithmetic.
        this.renderer.framebuffer.clear(0, 0, 0, 0);
    };
    /**
     * Draws a filter using the default rendering process.
     *
     * This should be called only by {@link Filter#apply}.
     *
     * @param filter - The filter to draw.
     * @param input - The input render target.
     * @param output - The target to output to.
     * @param clearMode - Should the output be cleared before rendering to it
     */ FilterSystem.prototype.applyFilter = function(filter, input, output, clearMode) {
        var renderer = this.renderer;
        // Set state before binding, so bindAndClear gets the blend mode.
        renderer.state.set(filter.state);
        this.bindAndClear(output, clearMode);
        // set the uniforms..
        filter.uniforms.uSampler = input;
        filter.uniforms.filterGlobals = this.globalUniforms;
        // TODO make it so that the order of this does not matter..
        // because it does at the moment cos of global uniforms.
        // they need to get resynced
        renderer.shader.bind(filter);
        // check to see if the filter is a legacy one..
        filter.legacy = !!filter.program.attributeData.aTextureCoord;
        if (filter.legacy) {
            this.quadUv.map(input._frame, input.filterFrame);
            renderer.geometry.bind(this.quadUv);
            renderer.geometry.draw((0, $P8XPi.DRAW_MODES).TRIANGLES);
        } else {
            renderer.geometry.bind(this.quad);
            renderer.geometry.draw((0, $P8XPi.DRAW_MODES).TRIANGLE_STRIP);
        }
    };
    /**
     * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
     *
     * Use `outputMatrix * vTextureCoord` in the shader.
     *
     * @param outputMatrix - The matrix to output to.
     * @param {PIXI.Sprite} sprite - The sprite to map to.
     * @return The mapped matrix.
     */ FilterSystem.prototype.calculateSpriteMatrix = function(outputMatrix, sprite) {
        var _a = this.activeState, sourceFrame = _a.sourceFrame, destinationFrame = _a.destinationFrame;
        var orig = sprite._texture.orig;
        var mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y);
        var worldTransform = sprite.worldTransform.copyTo((0, $6qzqq.Matrix).TEMP_MATRIX);
        worldTransform.invert();
        mappedMatrix.prepend(worldTransform);
        mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
        mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
        return mappedMatrix;
    };
    /** Destroys this Filter System. */ FilterSystem.prototype.destroy = function() {
        this.renderer = null;
        // Those textures has to be destroyed by RenderTextureSystem or FramebufferSystem
        this.texturePool.clear(false);
    };
    /**
     * Gets a Power-of-Two render texture or fullScreen texture
     *
     * @param minWidth - The minimum width of the render texture in real pixels.
     * @param minHeight - The minimum height of the render texture in real pixels.
     * @param resolution - The resolution of the render texture.
     * @param multisample - Number of samples of the render texture.
     * @return - The new render texture.
     */ FilterSystem.prototype.getOptimalFilterTexture = function(minWidth, minHeight, resolution, multisample) {
        if (resolution === void 0) resolution = 1;
        if (multisample === void 0) multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution, multisample);
    };
    /**
     * Gets extra render texture to use inside current filter
     * To be compliant with older filters, you can use params in any order
     *
     * @param input - renderTexture from which size and resolution will be copied
     * @param resolution - override resolution of the renderTexture
     * @param multisample - number of samples of the renderTexture
     */ FilterSystem.prototype.getFilterTexture = function(input, resolution, multisample) {
        if (typeof input === 'number') {
            var swap = input;
            input = resolution;
            resolution = swap;
        }
        input = input || this.activeState.renderTexture;
        var filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $P8XPi.MSAA_QUALITY).NONE);
        filterTexture.filterFrame = input.filterFrame;
        return filterTexture;
    };
    /**
     * Frees a render texture back into the pool.
     *
     * @param renderTexture - The renderTarget to free
     */ FilterSystem.prototype.returnFilterTexture = function(renderTexture) {
        this.texturePool.returnTexture(renderTexture);
    };
    /** Empties the texture pool. */ FilterSystem.prototype.emptyPool = function() {
        this.texturePool.clear(true);
    };
    /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */ FilterSystem.prototype.resize = function() {
        this.texturePool.setScreenSize(this.renderer.view);
    };
    /**
     * @param matrix - first param
     * @param rect - second param
     */ FilterSystem.prototype.transformAABB = function(matrix, rect) {
        var lt = tempPoints[0];
        var lb = tempPoints[1];
        var rt = tempPoints[2];
        var rb = tempPoints[3];
        lt.set(rect.left, rect.top);
        lb.set(rect.left, rect.bottom);
        rt.set(rect.right, rect.top);
        rb.set(rect.right, rect.bottom);
        matrix.apply(lt, lt);
        matrix.apply(lb, lb);
        matrix.apply(rt, rt);
        matrix.apply(rb, rb);
        var x0 = Math.min(lt.x, lb.x, rt.x, rb.x);
        var y0 = Math.min(lt.y, lb.y, rt.y, rb.y);
        var x1 = Math.max(lt.x, lb.x, rt.x, rb.x);
        var y1 = Math.max(lt.y, lb.y, rt.y, rb.y);
        rect.x = x0;
        rect.y = y0;
        rect.width = x1 - x0;
        rect.height = y1 - y0;
    };
    FilterSystem.prototype.roundFrame = function(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (frame.width <= 0 || frame.height <= 0 || bindingSourceFrame.width <= 0 || bindingSourceFrame.height <= 0) return;
        if (transform) {
            var a = transform.a, b = transform.b, c = transform.c, d = transform.d;
            // Skip if skew/rotation present in matrix, except for multiple of 90° rotation. If rotation
            // is a multiple of 90°, then either pair of (b,c) or (a,d) will be (0,0).
            if ((Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4)) return;
        }
        transform = transform ? tempMatrix.copyFrom(transform) : tempMatrix.identity();
        // Get forward transform from world space to screen space
        transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y);
        // Convert frame to screen space
        this.transformAABB(transform, frame);
        // Round frame in screen space
        frame.ceil(resolution);
        // Project back into world space.
        this.transformAABB(transform.invert(), frame);
    };
    return FilterSystem;
}();
/**
 * Base for a common object renderer that can be used as a
 * system renderer plugin.
 *
 * @memberof PIXI
 */ var ObjectRenderer = /** @class */ function() {
    /**
     * @param renderer - The renderer this manager works for.
     */ function ObjectRenderer(renderer) {
        this.renderer = renderer;
    }
    /**
     * Stub method that should be used to empty the current
     * batch by rendering objects now.
     */ ObjectRenderer.prototype.flush = function() {
    // flush!
    };
    /**
     * Generic destruction method that frees all resources. This
     * should be called by subclasses.
     */ ObjectRenderer.prototype.destroy = function() {
        this.renderer = null;
    };
    /**
     * Stub method that initializes any state required before
     * rendering starts. It is different from the `prerender`
     * signal, which occurs every frame, in that it is called
     * whenever an object requests _this_ renderer specifically.
     */ ObjectRenderer.prototype.start = function() {
    // set the shader..
    };
    /**
     * Stops the renderer. It should free up any state and
     * become dormant.
     */ ObjectRenderer.prototype.stop = function() {
        this.flush();
    };
    /**
     * Keeps the object to render. It doesn't have to be
     * rendered immediately.
     *
     * @param {PIXI.DisplayObject} object - The object to render.
     */ ObjectRenderer.prototype.render = function(_object) {
    // render the object
    };
    return ObjectRenderer;
}();
/**
 * System plugin to the renderer to manage batching.
 *
 * @memberof PIXI
 */ var BatchSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function BatchSystem(renderer) {
        this.renderer = renderer;
        this.emptyRenderer = new ObjectRenderer(renderer);
        this.currentRenderer = this.emptyRenderer;
    }
    /**
     * Changes the current renderer to the one given in parameter
     *
     * @param objectRenderer - The object renderer to use.
     */ BatchSystem.prototype.setObjectRenderer = function(objectRenderer) {
        if (this.currentRenderer === objectRenderer) return;
        this.currentRenderer.stop();
        this.currentRenderer = objectRenderer;
        this.currentRenderer.start();
    };
    /**
     * This should be called if you wish to do some custom rendering
     * It will basically render anything that may be batched up such as sprites
     */ BatchSystem.prototype.flush = function() {
        this.setObjectRenderer(this.emptyRenderer);
    };
    /**
     * Reset the system to an empty renderer
     */ BatchSystem.prototype.reset = function() {
        this.setObjectRenderer(this.emptyRenderer);
    };
    /**
     * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
     * sets actual _batchLocation for them
     *
     * @param arr - arr copy destination
     * @param maxTextures - number of copied elements
     */ BatchSystem.prototype.copyBoundTextures = function(arr, maxTextures) {
        var boundTextures = this.renderer.texture.boundTextures;
        for(var i = maxTextures - 1; i >= 0; --i){
            arr[i] = boundTextures[i] || null;
            if (arr[i]) arr[i]._batchLocation = i;
        }
    };
    /**
     * Assigns batch locations to textures in array based on boundTextures state.
     * All textures in texArray should have `_batchEnabled = _batchId`,
     * and their count should be less than `maxTextures`.
     *
     * @param texArray - textures to bound
     * @param boundTextures - current state of bound textures
     * @param batchId - marker for _batchEnabled param of textures in texArray
     * @param maxTextures - number of texture locations to manipulate
     */ BatchSystem.prototype.boundArray = function(texArray, boundTextures, batchId, maxTextures) {
        var elements = texArray.elements, ids = texArray.ids, count = texArray.count;
        var j = 0;
        for(var i = 0; i < count; i++){
            var tex = elements[i];
            var loc = tex._batchLocation;
            if (loc >= 0 && loc < maxTextures && boundTextures[loc] === tex) {
                ids[i] = loc;
                continue;
            }
            while(j < maxTextures){
                var bound = boundTextures[j];
                if (bound && bound._batchEnabled === batchId && bound._batchLocation === j) {
                    j++;
                    continue;
                }
                ids[i] = j;
                tex._batchLocation = j;
                boundTextures[j] = tex;
                break;
            }
        }
    };
    /**
     * @ignore
     */ BatchSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return BatchSystem;
}();
var CONTEXT_UID_COUNTER = 0;
/**
 * System plugin to the renderer to manage the context.
 *
 * @memberof PIXI
 */ var ContextSystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function ContextSystem(renderer) {
        this.renderer = renderer;
        this.webGLVersion = 1;
        this.extensions = {};
        this.supports = {
            uint32Indices: false
        };
        // Bind functions
        this.handleContextLost = this.handleContextLost.bind(this);
        this.handleContextRestored = this.handleContextRestored.bind(this);
        renderer.view.addEventListener('webglcontextlost', this.handleContextLost, false);
        renderer.view.addEventListener('webglcontextrestored', this.handleContextRestored, false);
    }
    Object.defineProperty(ContextSystem.prototype, "isLost", {
        /**
         * `true` if the context is lost
         *
         * @readonly
         */ get: function() {
            return !this.gl || this.gl.isContextLost();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Handles the context change event.
     *
     * @param {WebGLRenderingContext} gl - New WebGL context.
     */ ContextSystem.prototype.contextChange = function(gl) {
        this.gl = gl;
        this.renderer.gl = gl;
        this.renderer.CONTEXT_UID = CONTEXT_UID_COUNTER++;
        // restore a context if it was previously lost
        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) gl.getExtension('WEBGL_lose_context').restoreContext();
    };
    /**
     * Initializes the context.
     *
     * @protected
     * @param {WebGLRenderingContext} gl - WebGL context
     */ ContextSystem.prototype.initFromContext = function(gl) {
        this.gl = gl;
        this.validateContext(gl);
        this.renderer.gl = gl;
        this.renderer.CONTEXT_UID = CONTEXT_UID_COUNTER++;
        this.renderer.runners.contextChange.emit(gl);
    };
    /**
     * Initialize from context options
     *
     * @protected
     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
     * @param {object} options - context attributes
     */ ContextSystem.prototype.initFromOptions = function(options) {
        var gl = this.createContext(this.renderer.view, options);
        this.initFromContext(gl);
    };
    /**
     * Helper class to create a WebGL Context
     *
     * @param canvas - the canvas element that we will get the context from
     * @param options - An options object that gets passed in to the canvas element containing the
     *    context attributes
     * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
     * @return {WebGLRenderingContext} the WebGL context
     */ ContextSystem.prototype.createContext = function(canvas, options) {
        var gl;
        if ((0, $ezJmd.settings).PREFER_ENV >= (0, $P8XPi.ENV).WEBGL2) gl = canvas.getContext('webgl2', options);
        if (gl) this.webGLVersion = 2;
        else {
            this.webGLVersion = 1;
            gl = canvas.getContext('webgl', options) || canvas.getContext('experimental-webgl', options);
            if (!gl) // fail, not able to get a context
            throw new Error('This browser does not support WebGL. Try using the canvas renderer');
        }
        this.gl = gl;
        this.getExtensions();
        return this.gl;
    };
    /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */ ContextSystem.prototype.getExtensions = function() {
        // time to set up default extensions that Pixi uses.
        var gl = this.gl;
        var common = {
            anisotropicFiltering: gl.getExtension('EXT_texture_filter_anisotropic'),
            floatTextureLinear: gl.getExtension('OES_texture_float_linear'),
            s3tc: gl.getExtension('WEBGL_compressed_texture_s3tc'),
            s3tc_sRGB: gl.getExtension('WEBGL_compressed_texture_s3tc_srgb'),
            etc: gl.getExtension('WEBGL_compressed_texture_etc'),
            etc1: gl.getExtension('WEBGL_compressed_texture_etc1'),
            pvrtc: gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc'),
            atc: gl.getExtension('WEBGL_compressed_texture_atc'),
            astc: gl.getExtension('WEBGL_compressed_texture_astc')
        };
        if (this.webGLVersion === 1) Object.assign(this.extensions, common, {
            drawBuffers: gl.getExtension('WEBGL_draw_buffers'),
            depthTexture: gl.getExtension('WEBGL_depth_texture'),
            loseContext: gl.getExtension('WEBGL_lose_context'),
            vertexArrayObject: gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object'),
            uint32ElementIndex: gl.getExtension('OES_element_index_uint'),
            // Floats and half-floats
            floatTexture: gl.getExtension('OES_texture_float'),
            floatTextureLinear: gl.getExtension('OES_texture_float_linear'),
            textureHalfFloat: gl.getExtension('OES_texture_half_float'),
            textureHalfFloatLinear: gl.getExtension('OES_texture_half_float_linear')
        });
        else if (this.webGLVersion === 2) Object.assign(this.extensions, common, {
            // Floats and half-floats
            colorBufferFloat: gl.getExtension('EXT_color_buffer_float')
        });
    };
    /**
     * Handles a lost webgl context
     *
     * @param {WebGLContextEvent} event - The context lost event.
     */ ContextSystem.prototype.handleContextLost = function(event) {
        event.preventDefault();
    };
    /** Handles a restored webgl context. */ ContextSystem.prototype.handleContextRestored = function() {
        this.renderer.runners.contextChange.emit(this.gl);
    };
    ContextSystem.prototype.destroy = function() {
        var view = this.renderer.view;
        this.renderer = null;
        // remove listeners
        view.removeEventListener('webglcontextlost', this.handleContextLost);
        view.removeEventListener('webglcontextrestored', this.handleContextRestored);
        this.gl.useProgram(null);
        if (this.extensions.loseContext) this.extensions.loseContext.loseContext();
    };
    /** Handle the post-render runner event. */ ContextSystem.prototype.postrender = function() {
        if (this.renderer.renderingToScreen) this.gl.flush();
    };
    /**
     * Validate context.
     *
     * @param {WebGLRenderingContext} gl - Render context.
     */ ContextSystem.prototype.validateContext = function(gl) {
        var attributes = gl.getContextAttributes();
        var isWebGl2 = 'WebGL2RenderingContext' in self && gl instanceof self.WebGL2RenderingContext;
        if (isWebGl2) this.webGLVersion = 2;
        // this is going to be fairly simple for now.. but at least we have room to grow!
        if (!attributes.stencil) /* eslint-disable max-len, no-console */ console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
        var hasuint32 = isWebGl2 || !!gl.getExtension('OES_element_index_uint');
        this.supports.uint32Indices = hasuint32;
        if (!hasuint32) /* eslint-disable max-len, no-console */ console.warn('Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly');
    };
    return ContextSystem;
}();
/**
 * Internal framebuffer for WebGL context
 * @class
 * @memberof PIXI
 */ var GLFramebuffer = /** @class */ function() {
    function GLFramebuffer(framebuffer) {
        /**
         * The WebGL framebuffer
         * @member {WebGLFramebuffer}
         */ this.framebuffer = framebuffer;
        /**
         * stencil+depth , usually costs 32bits per pixel
         * @member {WebGLRenderbuffer}
         */ this.stencil = null;
        /**
         * latest known version of framebuffer
         * @member {number}
         * @protected
         */ this.dirtyId = -1;
        /**
         * latest known version of framebuffer format
         * @member {number}
         * @protected
         */ this.dirtyFormat = -1;
        /**
         * latest known version of framebuffer size
         * @member {number}
         * @protected
         */ this.dirtySize = -1;
        /**
         * Detected AA samples number
         * @member {PIXI.MSAA_QUALITY}
         */ this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        /**
         * In case MSAA, we use this Renderbuffer instead of colorTextures[0] when we write info
         * @member {WebGLRenderbuffer}
         */ this.msaaBuffer = null;
        /**
         * In case we use MSAA, this is actual framebuffer that has colorTextures[0]
         * The contents of that framebuffer are read when we use that renderTexture in sprites
         * @member {PIXI.Framebuffer}
         */ this.blitFramebuffer = null;
        /**
         * store the current mipmap of the textures the framebuffer will write too.
         */ this.mipLevel = 0;
    }
    return GLFramebuffer;
}();
var tempRectangle = new (0, $6qzqq.Rectangle)();
/**
 * System plugin to the renderer to manage framebuffers.
 *
 * @class
 * @extends PIXI.System
 * @memberof PIXI
 */ var FramebufferSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function FramebufferSystem(renderer) {
        this.renderer = renderer;
        /**
         * A list of managed framebuffers
         * @member {PIXI.Framebuffer[]}
         * @readonly
         */ this.managedFramebuffers = [];
        /**
         * Framebuffer value that shows that we don't know what is bound
         * @member {Framebuffer}
         * @readonly
         */ this.unknownFramebuffer = new Framebuffer(10, 10);
        this.msaaSamples = null;
    }
    /**
     * Sets up the renderer context and necessary buffers.
     */ FramebufferSystem.prototype.contextChange = function() {
        var gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.current = this.unknownFramebuffer;
        this.viewport = new (0, $6qzqq.Rectangle)();
        this.hasMRT = true;
        this.writeDepthTexture = true;
        this.disposeAll(true);
        // webgl2
        if (this.renderer.context.webGLVersion === 1) {
            // webgl 1!
            var nativeDrawBuffersExtension_1 = this.renderer.context.extensions.drawBuffers;
            var nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
            if ((0, $ezJmd.settings).PREFER_ENV === (0, $P8XPi.ENV).WEBGL_LEGACY) {
                nativeDrawBuffersExtension_1 = null;
                nativeDepthTextureExtension = null;
            }
            if (nativeDrawBuffersExtension_1) gl.drawBuffers = function(activeTextures) {
                return nativeDrawBuffersExtension_1.drawBuffersWEBGL(activeTextures);
            };
            else {
                this.hasMRT = false;
                gl.drawBuffers = function() {
                // empty
                };
            }
            if (!nativeDepthTextureExtension) this.writeDepthTexture = false;
        } else // WebGL2
        // cache possible MSAA samples
        this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
    };
    /**
     * Bind a framebuffer
     *
     * @param {PIXI.Framebuffer} [framebuffer]
     * @param {PIXI.Rectangle} [frame] - frame, default is framebuffer size
     * @param {number} [mipLevel] - optional mip level to set on the framebuffer - defaults to 0
     */ FramebufferSystem.prototype.bind = function(framebuffer, frame, mipLevel) {
        if (mipLevel === void 0) mipLevel = 0;
        var gl = this.gl;
        if (framebuffer) {
            // TODO caching layer!
            var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
            if (this.current !== framebuffer) {
                this.current = framebuffer;
                gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer);
            }
            // make sure all textures are unbound..
            if (fbo.mipLevel !== mipLevel) {
                framebuffer.dirtyId++;
                framebuffer.dirtyFormat++;
                fbo.mipLevel = mipLevel;
            }
            // now check for updates...
            if (fbo.dirtyId !== framebuffer.dirtyId) {
                fbo.dirtyId = framebuffer.dirtyId;
                if (fbo.dirtyFormat !== framebuffer.dirtyFormat) {
                    fbo.dirtyFormat = framebuffer.dirtyFormat;
                    fbo.dirtySize = framebuffer.dirtySize;
                    this.updateFramebuffer(framebuffer, mipLevel);
                } else if (fbo.dirtySize !== framebuffer.dirtySize) {
                    fbo.dirtySize = framebuffer.dirtySize;
                    this.resizeFramebuffer(framebuffer);
                }
            }
            for(var i = 0; i < framebuffer.colorTextures.length; i++){
                var tex = framebuffer.colorTextures[i];
                this.renderer.texture.unbind(tex.parentTextureArray || tex);
            }
            if (framebuffer.depthTexture) this.renderer.texture.unbind(framebuffer.depthTexture);
            if (frame) {
                var mipWidth = frame.width >> mipLevel;
                var mipHeight = frame.height >> mipLevel;
                var scale = mipWidth / frame.width;
                this.setViewport(frame.x * scale, frame.y * scale, mipWidth, mipHeight);
            } else {
                var mipWidth = framebuffer.width >> mipLevel;
                var mipHeight = framebuffer.height >> mipLevel;
                this.setViewport(0, 0, mipWidth, mipHeight);
            }
        } else {
            if (this.current) {
                this.current = null;
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            }
            if (frame) this.setViewport(frame.x, frame.y, frame.width, frame.height);
            else this.setViewport(0, 0, this.renderer.width, this.renderer.height);
        }
    };
    /**
     * Set the WebGLRenderingContext's viewport.
     *
     * @param {Number} x - X position of viewport
     * @param {Number} y - Y position of viewport
     * @param {Number} width - Width of viewport
     * @param {Number} height - Height of viewport
     */ FramebufferSystem.prototype.setViewport = function(x, y, width, height) {
        var v = this.viewport;
        x = Math.round(x);
        y = Math.round(y);
        width = Math.round(width);
        height = Math.round(height);
        if (v.width !== width || v.height !== height || v.x !== x || v.y !== y) {
            v.x = x;
            v.y = y;
            v.width = width;
            v.height = height;
            this.gl.viewport(x, y, width, height);
        }
    };
    Object.defineProperty(FramebufferSystem.prototype, "size", {
        /**
         * Get the size of the current width and height. Returns object with `width` and `height` values.
         *
         * @member {object}
         * @readonly
         */ get: function() {
            if (this.current) // TODO store temp
            return {
                x: 0,
                y: 0,
                width: this.current.width,
                height: this.current.height
            };
            return {
                x: 0,
                y: 0,
                width: this.renderer.width,
                height: this.renderer.height
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clear the color of the context
     *
     * @param {Number} r - Red value from 0 to 1
     * @param {Number} g - Green value from 0 to 1
     * @param {Number} b - Blue value from 0 to 1
     * @param {Number} a - Alpha value from 0 to 1
     * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
     *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
     */ FramebufferSystem.prototype.clear = function(r, g, b, a, mask) {
        if (mask === void 0) mask = (0, $P8XPi.BUFFER_BITS).COLOR | (0, $P8XPi.BUFFER_BITS).DEPTH;
        var gl = this.gl;
        // TODO clear color can be set only one right?
        gl.clearColor(r, g, b, a);
        gl.clear(mask);
    };
    /**
     * Initialize framebuffer for this context
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     * @returns {PIXI.GLFramebuffer} created GLFramebuffer
     */ FramebufferSystem.prototype.initFramebuffer = function(framebuffer) {
        var gl = this.gl;
        var fbo = new GLFramebuffer(gl.createFramebuffer());
        fbo.multisample = this.detectSamples(framebuffer.multisample);
        framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo;
        this.managedFramebuffers.push(framebuffer);
        framebuffer.disposeRunner.add(this);
        return fbo;
    };
    /**
     * Resize the framebuffer
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     */ FramebufferSystem.prototype.resizeFramebuffer = function(framebuffer) {
        var gl = this.gl;
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (fbo.msaaBuffer) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
            gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.RGBA8, framebuffer.width, framebuffer.height);
        }
        if (fbo.stencil) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, framebuffer.width, framebuffer.height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
        }
        var colorTextures = framebuffer.colorTextures;
        var count = colorTextures.length;
        if (!gl.drawBuffers) count = Math.min(count, 1);
        for(var i = 0; i < count; i++){
            var texture = colorTextures[i];
            var parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0);
        }
        if (framebuffer.depthTexture && this.writeDepthTexture) this.renderer.texture.bind(framebuffer.depthTexture, 0);
    };
    /**
     * Update the framebuffer
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     * @param {number} mipLevel
     */ FramebufferSystem.prototype.updateFramebuffer = function(framebuffer, mipLevel) {
        var gl = this.gl;
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        // bind the color texture
        var colorTextures = framebuffer.colorTextures;
        var count = colorTextures.length;
        if (!gl.drawBuffers) count = Math.min(count, 1);
        if (fbo.multisample > 1 && this.canMultisampleFramebuffer(framebuffer)) {
            fbo.msaaBuffer = fbo.msaaBuffer || gl.createRenderbuffer();
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
            gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.RGBA8, framebuffer.width, framebuffer.height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer);
        } else if (fbo.msaaBuffer) {
            gl.deleteRenderbuffer(fbo.msaaBuffer);
            fbo.msaaBuffer = null;
            if (fbo.blitFramebuffer) {
                fbo.blitFramebuffer.dispose();
                fbo.blitFramebuffer = null;
            }
        }
        var activeTextures = [];
        for(var i = 0; i < count; i++){
            var texture = colorTextures[i];
            var parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0);
            if (i === 0 && fbo.msaaBuffer) continue;
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
            activeTextures.push(gl.COLOR_ATTACHMENT0 + i);
        }
        if (activeTextures.length > 1) gl.drawBuffers(activeTextures);
        if (framebuffer.depthTexture) {
            var writeDepthTexture = this.writeDepthTexture;
            if (writeDepthTexture) {
                var depthTexture = framebuffer.depthTexture;
                this.renderer.texture.bind(depthTexture, 0);
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
            }
        }
        if ((framebuffer.stencil || framebuffer.depth) && !(framebuffer.depthTexture && this.writeDepthTexture)) {
            fbo.stencil = fbo.stencil || gl.createRenderbuffer();
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, framebuffer.width, framebuffer.height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, fbo.stencil);
        } else if (fbo.stencil) {
            gl.deleteRenderbuffer(fbo.stencil);
            fbo.stencil = null;
        }
    };
    /**
     * Returns true if the frame buffer can be multisampled
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     */ FramebufferSystem.prototype.canMultisampleFramebuffer = function(framebuffer) {
        return this.renderer.context.webGLVersion !== 1 && framebuffer.colorTextures.length <= 1 && !framebuffer.depthTexture;
    };
    /**
     * Detects number of samples that is not more than a param but as close to it as possible
     *
     * @param {PIXI.MSAA_QUALITY} samples - number of samples
     * @returns {PIXI.MSAA_QUALITY} - recommended number of samples
     */ FramebufferSystem.prototype.detectSamples = function(samples) {
        var msaaSamples = this.msaaSamples;
        var res = (0, $P8XPi.MSAA_QUALITY).NONE;
        if (samples <= 1 || msaaSamples === null) return res;
        for(var i = 0; i < msaaSamples.length; i++)if (msaaSamples[i] <= samples) {
            res = msaaSamples[i];
            break;
        }
        if (res === 1) res = (0, $P8XPi.MSAA_QUALITY).NONE;
        return res;
    };
    /**
     * Only works with WebGL2
     *
     * blits framebuffer to another of the same or bigger size
     * after that target framebuffer is bound
     *
     * Fails with WebGL warning if blits multisample framebuffer to different size
     *
     * @param {PIXI.Framebuffer} [framebuffer] - by default it blits "into itself", from renderBuffer to texture.
     * @param {PIXI.Rectangle} [sourcePixels] - source rectangle in pixels
     * @param {PIXI.Rectangle} [destPixels] - dest rectangle in pixels, assumed to be the same as sourcePixels
     */ FramebufferSystem.prototype.blit = function(framebuffer, sourcePixels, destPixels) {
        var _a = this, current = _a.current, renderer = _a.renderer, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        if (renderer.context.webGLVersion !== 2) return;
        if (!current) return;
        var fbo = current.glFramebuffers[CONTEXT_UID];
        if (!fbo) return;
        if (!framebuffer) {
            if (!fbo.msaaBuffer) return;
            var colorTexture = current.colorTextures[0];
            if (!colorTexture) return;
            if (!fbo.blitFramebuffer) {
                fbo.blitFramebuffer = new Framebuffer(current.width, current.height);
                fbo.blitFramebuffer.addColorTexture(0, colorTexture);
            }
            framebuffer = fbo.blitFramebuffer;
            if (framebuffer.colorTextures[0] !== colorTexture) {
                framebuffer.colorTextures[0] = colorTexture;
                framebuffer.dirtyId++;
                framebuffer.dirtyFormat++;
            }
            if (framebuffer.width !== current.width || framebuffer.height !== current.height) {
                framebuffer.width = current.width;
                framebuffer.height = current.height;
                framebuffer.dirtyId++;
                framebuffer.dirtySize++;
            }
        }
        if (!sourcePixels) {
            sourcePixels = tempRectangle;
            sourcePixels.width = current.width;
            sourcePixels.height = current.height;
        }
        if (!destPixels) destPixels = sourcePixels;
        var sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
        this.bind(framebuffer);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer);
        gl.blitFramebuffer(sourcePixels.x, sourcePixels.y, sourcePixels.width, sourcePixels.height, destPixels.x, destPixels.y, destPixels.width, destPixels.height, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR);
    };
    /**
     * Disposes framebuffer
     * @param {PIXI.Framebuffer} framebuffer - framebuffer that has to be disposed of
     * @param {boolean} [contextLost=false] - If context was lost, we suppress all delete function calls
     */ FramebufferSystem.prototype.disposeFramebuffer = function(framebuffer, contextLost) {
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        var gl = this.gl;
        if (!fbo) return;
        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
        var index = this.managedFramebuffers.indexOf(framebuffer);
        if (index >= 0) this.managedFramebuffers.splice(index, 1);
        framebuffer.disposeRunner.remove(this);
        if (!contextLost) {
            gl.deleteFramebuffer(fbo.framebuffer);
            if (fbo.msaaBuffer) gl.deleteRenderbuffer(fbo.msaaBuffer);
            if (fbo.stencil) gl.deleteRenderbuffer(fbo.stencil);
        }
        if (fbo.blitFramebuffer) fbo.blitFramebuffer.dispose();
    };
    /**
     * Disposes all framebuffers, but not textures bound to them
     * @param {boolean} [contextLost=false] - If context was lost, we suppress all delete function calls
     */ FramebufferSystem.prototype.disposeAll = function(contextLost) {
        var list = this.managedFramebuffers;
        this.managedFramebuffers = [];
        for(var i = 0; i < list.length; i++)this.disposeFramebuffer(list[i], contextLost);
    };
    /**
     * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
     * Used by MaskSystem, when its time to use stencil mask for Graphics element.
     *
     * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
     *
     * @private
     */ FramebufferSystem.prototype.forceStencil = function() {
        var framebuffer = this.current;
        if (!framebuffer) return;
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (!fbo || fbo.stencil) return;
        framebuffer.stencil = true;
        var w = framebuffer.width;
        var h = framebuffer.height;
        var gl = this.gl;
        var stencil = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
        if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, w, h);
        else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, w, h);
        fbo.stencil = stencil;
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, stencil);
    };
    /**
     * resets framebuffer stored state, binds screen framebuffer
     *
     * should be called before renderTexture reset()
     */ FramebufferSystem.prototype.reset = function() {
        this.current = this.unknownFramebuffer;
        this.viewport = new (0, $6qzqq.Rectangle)();
    };
    /**
     * @ignore
     */ FramebufferSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return FramebufferSystem;
}();
var byteSizeMap$1 = {
    5126: 4,
    5123: 2,
    5121: 1
};
/**
 * System plugin to the renderer to manage geometry.
 *
 * @memberof PIXI
 */ var GeometrySystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function GeometrySystem(renderer) {
        this.renderer = renderer;
        this._activeGeometry = null;
        this._activeVao = null;
        this.hasVao = true;
        this.hasInstance = true;
        this.canUseUInt32ElementIndex = false;
        this.managedGeometries = {};
    }
    /** Sets up the renderer context and necessary buffers. */ GeometrySystem.prototype.contextChange = function() {
        this.disposeAll(true);
        var gl = this.gl = this.renderer.gl;
        var context = this.renderer.context;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        // webgl2
        if (context.webGLVersion !== 2) {
            // webgl 1!
            var nativeVaoExtension_1 = this.renderer.context.extensions.vertexArrayObject;
            if ((0, $ezJmd.settings).PREFER_ENV === (0, $P8XPi.ENV).WEBGL_LEGACY) nativeVaoExtension_1 = null;
            if (nativeVaoExtension_1) {
                gl.createVertexArray = function() {
                    return nativeVaoExtension_1.createVertexArrayOES();
                };
                gl.bindVertexArray = function(vao) {
                    return nativeVaoExtension_1.bindVertexArrayOES(vao);
                };
                gl.deleteVertexArray = function(vao) {
                    return nativeVaoExtension_1.deleteVertexArrayOES(vao);
                };
            } else {
                this.hasVao = false;
                gl.createVertexArray = function() {
                    return null;
                };
                gl.bindVertexArray = function() {
                    return null;
                };
                gl.deleteVertexArray = function() {
                    return null;
                };
            }
        }
        if (context.webGLVersion !== 2) {
            var instanceExt_1 = gl.getExtension('ANGLE_instanced_arrays');
            if (instanceExt_1) {
                gl.vertexAttribDivisor = function(a, b) {
                    return instanceExt_1.vertexAttribDivisorANGLE(a, b);
                };
                gl.drawElementsInstanced = function(a, b, c, d, e) {
                    return instanceExt_1.drawElementsInstancedANGLE(a, b, c, d, e);
                };
                gl.drawArraysInstanced = function(a, b, c, d) {
                    return instanceExt_1.drawArraysInstancedANGLE(a, b, c, d);
                };
            } else this.hasInstance = false;
        }
        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
    };
    /**
     * Binds geometry so that is can be drawn. Creating a Vao if required
     *
     * @param geometry - Instance of geometry to bind.
     * @param shader - Instance of shader to use vao for.
     */ GeometrySystem.prototype.bind = function(geometry, shader) {
        shader = shader || this.renderer.shader.shader;
        var gl = this.gl;
        // not sure the best way to address this..
        // currently different shaders require different VAOs for the same geometry
        // Still mulling over the best way to solve this one..
        // will likely need to modify the shader attribute locations at run time!
        var vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        var incRefCount = false;
        if (!vaos) {
            this.managedGeometries[geometry.id] = geometry;
            geometry.disposeRunner.add(this);
            geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {};
            incRefCount = true;
        }
        var vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader, incRefCount);
        this._activeGeometry = geometry;
        if (this._activeVao !== vao) {
            this._activeVao = vao;
            if (this.hasVao) gl.bindVertexArray(vao);
            else this.activateVao(geometry, shader.program);
        }
        // TODO - optimise later!
        // don't need to loop through if nothing changed!
        // maybe look to add an 'autoupdate' to geometry?
        this.updateBuffers();
    };
    /** Reset and unbind any active VAO and geometry. */ GeometrySystem.prototype.reset = function() {
        this.unbind();
    };
    /** Update buffers of the currently bound geometry. */ GeometrySystem.prototype.updateBuffers = function() {
        var geometry = this._activeGeometry;
        var bufferSystem = this.renderer.buffer;
        for(var i = 0; i < geometry.buffers.length; i++){
            var buffer = geometry.buffers[i];
            bufferSystem.update(buffer);
        }
    };
    /**
     * Check compatibility between a geometry and a program
     *
     * @param geometry - Geometry instance.
     * @param program - Program instance.
     */ GeometrySystem.prototype.checkCompatibility = function(geometry, program) {
        // geometry must have at least all the attributes that the shader requires.
        var geometryAttributes = geometry.attributes;
        var shaderAttributes = program.attributeData;
        for(var j in shaderAttributes){
            if (!geometryAttributes[j]) throw new Error("shader and geometry incompatible, geometry missing the \"" + j + "\" attribute");
        }
    };
    /**
     * Takes a geometry and program and generates a unique signature for them.
     *
     * @param geometry - To get signature from.
     * @param program - To test geometry against.
     * @return - Unique signature of the geometry and program
     */ GeometrySystem.prototype.getSignature = function(geometry, program) {
        var attribs = geometry.attributes;
        var shaderAttributes = program.attributeData;
        var strings = [
            'g',
            geometry.id
        ];
        for(var i in attribs)if (shaderAttributes[i]) strings.push(i, shaderAttributes[i].location);
        return strings.join('-');
    };
    /**
     * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
     * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
     * attribute locations.
     *
     * @param geometry - Instance of geometry to to generate Vao for.
     * @param shader - Instance of the shader.
     * @param incRefCount - Increment refCount of all geometry buffers.
     */ GeometrySystem.prototype.initGeometryVao = function(geometry, shader, incRefCount) {
        if (incRefCount === void 0) incRefCount = true;
        var gl = this.gl;
        var CONTEXT_UID = this.CONTEXT_UID;
        var bufferSystem = this.renderer.buffer;
        var program = shader.program;
        if (!program.glPrograms[CONTEXT_UID]) this.renderer.shader.generateProgram(shader);
        this.checkCompatibility(geometry, program);
        var signature = this.getSignature(geometry, program);
        var vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        var vao = vaoObjectHash[signature];
        if (vao) {
            // this will give us easy access to the vao
            vaoObjectHash[program.id] = vao;
            return vao;
        }
        var buffers = geometry.buffers;
        var attributes = geometry.attributes;
        var tempStride = {};
        var tempStart = {};
        for(var j in buffers){
            tempStride[j] = 0;
            tempStart[j] = 0;
        }
        for(var j in attributes){
            if (!attributes[j].size && program.attributeData[j]) attributes[j].size = program.attributeData[j].size;
            else if (!attributes[j].size) console.warn("PIXI Geometry attribute '" + j + "' size cannot be determined (likely the bound shader does not have the attribute)"); // eslint-disable-line
            tempStride[attributes[j].buffer] += attributes[j].size * byteSizeMap$1[attributes[j].type];
        }
        for(var j in attributes){
            var attribute = attributes[j];
            var attribSize = attribute.size;
            if (attribute.stride === undefined) {
                if (tempStride[attribute.buffer] === attribSize * byteSizeMap$1[attribute.type]) attribute.stride = 0;
                else attribute.stride = tempStride[attribute.buffer];
            }
            if (attribute.start === undefined) {
                attribute.start = tempStart[attribute.buffer];
                tempStart[attribute.buffer] += attribSize * byteSizeMap$1[attribute.type];
            }
        }
        vao = gl.createVertexArray();
        gl.bindVertexArray(vao);
        // first update - and create the buffers!
        // only create a gl buffer if it actually gets
        for(var i = 0; i < buffers.length; i++){
            var buffer = buffers[i];
            bufferSystem.bind(buffer);
            if (incRefCount) buffer._glBuffers[CONTEXT_UID].refCount++;
        }
        // TODO - maybe make this a data object?
        // lets wait to see if we need to first!
        this.activateVao(geometry, program);
        this._activeVao = vao;
        // add it to the cache!
        vaoObjectHash[program.id] = vao;
        vaoObjectHash[signature] = vao;
        return vao;
    };
    /**
     * Disposes geometry.
     *
     * @param geometry - Geometry with buffers. Only VAO will be disposed
     * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
     */ GeometrySystem.prototype.disposeGeometry = function(geometry, contextLost) {
        var _a;
        if (!this.managedGeometries[geometry.id]) return;
        delete this.managedGeometries[geometry.id];
        var vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        var gl = this.gl;
        var buffers = geometry.buffers;
        var bufferSystem = (_a = this.renderer) === null || _a === void 0 ? void 0 : _a.buffer;
        geometry.disposeRunner.remove(this);
        if (!vaos) return;
        // bufferSystem may have already been destroyed..
        // if this is the case, there is no need to destroy the geometry buffers...
        // they already have been!
        if (bufferSystem) for(var i = 0; i < buffers.length; i++){
            var buf = buffers[i]._glBuffers[this.CONTEXT_UID];
            // my be null as context may have changed right before the dispose is called
            if (buf) {
                buf.refCount--;
                if (buf.refCount === 0 && !contextLost) bufferSystem.dispose(buffers[i], contextLost);
            }
        }
        if (!contextLost) {
            for(var vaoId in vaos)// delete only signatures, everything else are copies
            if (vaoId[0] === 'g') {
                var vao = vaos[vaoId];
                if (this._activeVao === vao) this.unbind();
                gl.deleteVertexArray(vao);
            }
        }
        delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
    };
    /**
     * Dispose all WebGL resources of all managed geometries.
     *
     * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
     */ GeometrySystem.prototype.disposeAll = function(contextLost) {
        var all = Object.keys(this.managedGeometries);
        for(var i = 0; i < all.length; i++)this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
    };
    /**
     * Activate vertex array object.
     *
     * @param geometry - Geometry instance.
     * @param program - Shader program instance.
     */ GeometrySystem.prototype.activateVao = function(geometry, program) {
        var gl = this.gl;
        var CONTEXT_UID = this.CONTEXT_UID;
        var bufferSystem = this.renderer.buffer;
        var buffers = geometry.buffers;
        var attributes = geometry.attributes;
        if (geometry.indexBuffer) // first update the index buffer if we have one..
        bufferSystem.bind(geometry.indexBuffer);
        var lastBuffer = null;
        // add a new one!
        for(var j in attributes){
            var attribute = attributes[j];
            var buffer = buffers[attribute.buffer];
            var glBuffer = buffer._glBuffers[CONTEXT_UID];
            if (program.attributeData[j]) {
                if (lastBuffer !== glBuffer) {
                    bufferSystem.bind(buffer);
                    lastBuffer = glBuffer;
                }
                var location = program.attributeData[j].location;
                // TODO introduce state again
                // we can optimise this for older devices that have no VAOs
                gl.enableVertexAttribArray(location);
                gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start);
                if (attribute.instance) {
                    // TODO calculate instance count based of this...
                    if (this.hasInstance) gl.vertexAttribDivisor(location, 1);
                    else throw new Error('geometry error, GPU Instancing is not supported on this device');
                }
            }
        }
    };
    /**
     * Draws the currently bound geometry.
     *
     * @param type - The type primitive to render.
     * @param size - The number of elements to be rendered. If not specified, all vertices after the
     *  starting vertex will be drawn.
     * @param start - The starting vertex in the geometry to start drawing from. If not specified,
     *  drawing will start from the first vertex.
     * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
     *  all instances will be drawn.
     */ GeometrySystem.prototype.draw = function(type, size, start, instanceCount) {
        var gl = this.gl;
        var geometry = this._activeGeometry;
        // TODO.. this should not change so maybe cache the function?
        if (geometry.indexBuffer) {
            var byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT;
            var glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            if (byteSize === 2 || byteSize === 4 && this.canUseUInt32ElementIndex) {
                if (geometry.instanced) /* eslint-disable max-len */ gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1);
                else /* eslint-disable max-len */ gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize);
            } else console.warn('unsupported index buffer type: uint32');
        } else if (geometry.instanced) // TODO need a better way to calculate size..
        gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1);
        else gl.drawArrays(type, start, size || geometry.getSize());
        return this;
    };
    /** Unbind/reset everything. */ GeometrySystem.prototype.unbind = function() {
        this.gl.bindVertexArray(null);
        this._activeVao = null;
        this._activeGeometry = null;
    };
    GeometrySystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return GeometrySystem;
}();
/**
 * Component for masked elements.
 *
 * Holds mask mode and temporary data about current mask.
 *
 * @memberof PIXI
 */ var MaskData = /** @class */ function() {
    /**
     * Create MaskData
     *
     * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
     */ function MaskData(maskObject) {
        if (maskObject === void 0) maskObject = null;
        this.type = (0, $P8XPi.MASK_TYPES).NONE;
        this.autoDetect = true;
        this.maskObject = maskObject || null;
        this.pooled = false;
        this.isMaskData = true;
        this.resolution = null;
        this.multisample = (0, $ezJmd.settings).FILTER_MULTISAMPLE;
        this.enabled = true;
        this._filters = null;
        this._stencilCounter = 0;
        this._scissorCounter = 0;
        this._scissorRect = null;
        this._scissorRectLocal = null;
        this._target = null;
    }
    Object.defineProperty(MaskData.prototype, "filter", {
        /**
         * The sprite mask filter.
         * If set to `null`, the default sprite mask filter is used.
         * @default null
         */ get: function() {
            return this._filters ? this._filters[0] : null;
        },
        set: function(value) {
            if (value) {
                if (this._filters) this._filters[0] = value;
                else this._filters = [
                    value
                ];
            } else this._filters = null;
        },
        enumerable: false,
        configurable: true
    });
    /** Resets the mask data after popMask(). */ MaskData.prototype.reset = function() {
        if (this.pooled) {
            this.maskObject = null;
            this.type = (0, $P8XPi.MASK_TYPES).NONE;
            this.autoDetect = true;
        }
        this._target = null;
        this._scissorRectLocal = null;
    };
    /** Copies counters from maskData above, called from pushMask(). */ MaskData.prototype.copyCountersOrReset = function(maskAbove) {
        if (maskAbove) {
            this._stencilCounter = maskAbove._stencilCounter;
            this._scissorCounter = maskAbove._scissorCounter;
            this._scissorRect = maskAbove._scissorRect;
        } else {
            this._stencilCounter = 0;
            this._scissorCounter = 0;
            this._scissorRect = null;
        }
    };
    return MaskData;
}();
/**
 * @private
 * @param {WebGLRenderingContext} gl - The current WebGL context {WebGLProgram}
 * @param {Number} type - the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
 * @param {string} src - The vertex shader source as an array of strings.
 * @return {WebGLShader} the shader
 */ function compileShader(gl, type, src) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, src);
    gl.compileShader(shader);
    return shader;
}
/**
 * will log a shader error highlighting the lines with the error
 * also will add numbers along the side.
 *
 * @param gl - the WebGLContext
 * @param shader - the shader to log errors for
 */ function logPrettyShaderError(gl, shader) {
    var shaderSrc = gl.getShaderSource(shader).split('\n').map(function(line, index) {
        return index + ": " + line;
    });
    var shaderLog = gl.getShaderInfoLog(shader);
    var splitShader = shaderLog.split('\n');
    var dedupe = {};
    var lineNumbers = splitShader.map(function(line) {
        return parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, '$1'));
    }).filter(function(n) {
        if (n && !dedupe[n]) {
            dedupe[n] = true;
            return true;
        }
        return false;
    });
    var logArgs = [
        ''
    ];
    lineNumbers.forEach(function(number) {
        shaderSrc[number - 1] = "%c" + shaderSrc[number - 1] + "%c";
        logArgs.push('background: #FF0000; color:#FFFFFF; font-size: 10px', 'font-size: 10px');
    });
    var fragmentSourceToLog = shaderSrc.join('\n');
    logArgs[0] = fragmentSourceToLog;
    console.error(shaderLog);
    // eslint-disable-next-line no-console
    console.groupCollapsed('click to view full shader code');
    console.warn.apply(console, logArgs);
    // eslint-disable-next-line no-console
    console.groupEnd();
}
/**
 *
 * logs out any program errors
 *
 * @param gl - The current WebGL context
 * @param program - the WebGL program to display errors for
 * @param vertexShader  - the fragment WebGL shader program
 * @param fragmentShader - the vertex WebGL shader program
 */ function logProgramError(gl, program, vertexShader, fragmentShader) {
    // if linking fails, then log and cleanup
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) logPrettyShaderError(gl, vertexShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) logPrettyShaderError(gl, fragmentShader);
        console.error('PixiJS Error: Could not initialize shader.');
        // if there is a program info log, log it
        if (gl.getProgramInfoLog(program) !== '') console.warn('PixiJS Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
    }
}
function booleanArray(size) {
    var array = new Array(size);
    for(var i = 0; i < array.length; i++)array[i] = false;
    return array;
}
/**
 * @method defaultValue
 * @memberof PIXI.glCore.shader
 * @param {string} type - Type of value
 * @param {number} size
 * @private
 */ function defaultValue(type, size) {
    switch(type){
        case 'float':
            return 0;
        case 'vec2':
            return new Float32Array(2 * size);
        case 'vec3':
            return new Float32Array(3 * size);
        case 'vec4':
            return new Float32Array(4 * size);
        case 'int':
        case 'uint':
        case 'sampler2D':
        case 'sampler2DArray':
            return 0;
        case 'ivec2':
            return new Int32Array(2 * size);
        case 'ivec3':
            return new Int32Array(3 * size);
        case 'ivec4':
            return new Int32Array(4 * size);
        case 'uvec2':
            return new Uint32Array(2 * size);
        case 'uvec3':
            return new Uint32Array(3 * size);
        case 'uvec4':
            return new Uint32Array(4 * size);
        case 'bool':
            return false;
        case 'bvec2':
            return booleanArray(2 * size);
        case 'bvec3':
            return booleanArray(3 * size);
        case 'bvec4':
            return booleanArray(4 * size);
        case 'mat2':
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case 'mat3':
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case 'mat4':
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}
var unknownContext = {};
var context = unknownContext;
/**
 * returns a little WebGL context to use for program inspection.
 *
 * @static
 * @private
 * @returns {WebGLRenderingContext} a gl context to test with
 */ function getTestContext() {
    if (context === unknownContext || context && context.isContextLost()) {
        var canvas = document.createElement('canvas');
        var gl = void 0;
        if ((0, $ezJmd.settings).PREFER_ENV >= (0, $P8XPi.ENV).WEBGL2) gl = canvas.getContext('webgl2', {});
        if (!gl) {
            gl = canvas.getContext('webgl', {}) || canvas.getContext('experimental-webgl', {});
            if (!gl) // fail, not able to get a context
            gl = null;
            else // for shader testing..
            gl.getExtension('WEBGL_draw_buffers');
        }
        context = gl;
    }
    return context;
}
var maxFragmentPrecision;
function getMaxFragmentPrecision() {
    if (!maxFragmentPrecision) {
        maxFragmentPrecision = (0, $P8XPi.PRECISION).MEDIUM;
        var gl = getTestContext();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                var shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                maxFragmentPrecision = shaderFragment.precision ? (0, $P8XPi.PRECISION).HIGH : (0, $P8XPi.PRECISION).MEDIUM;
            }
        }
    }
    return maxFragmentPrecision;
}
/**
 * Sets the float precision on the shader, ensuring the device supports the request precision.
 * If the precision is already present, it just ensures that the device is able to handle it.
 *
 * @private
 * @param {string} src - The shader source
 * @param {PIXI.PRECISION} requestedPrecision - The request float precision of the shader.
 * @param {PIXI.PRECISION} maxSupportedPrecision - The maximum precision the shader supports.
 *
 * @return {string} modified shader source
 */ function setPrecision(src, requestedPrecision, maxSupportedPrecision) {
    if (src.substring(0, 9) !== 'precision') {
        // no precision supplied, so PixiJS will add the requested level.
        var precision = requestedPrecision;
        // If highp is requested but not supported, downgrade precision to a level all devices support.
        if (requestedPrecision === (0, $P8XPi.PRECISION).HIGH && maxSupportedPrecision !== (0, $P8XPi.PRECISION).HIGH) precision = (0, $P8XPi.PRECISION).MEDIUM;
        return "precision " + precision + " float;\n" + src;
    } else if (maxSupportedPrecision !== (0, $P8XPi.PRECISION).HIGH && src.substring(0, 15) === 'precision highp') // precision was supplied, but at a level this device does not support, so downgrading to mediump.
    return src.replace('precision highp', 'precision mediump');
    return src;
}
var GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
/**
 * @private
 * @method mapSize
 * @memberof PIXI.glCore.shader
 * @param {String} type
 * @return {Number}
 */ function mapSize(type) {
    return GLSL_TO_SIZE[type];
}
var GL_TABLE = null;
var GL_TO_GLSL_TYPES = {
    FLOAT: 'float',
    FLOAT_VEC2: 'vec2',
    FLOAT_VEC3: 'vec3',
    FLOAT_VEC4: 'vec4',
    INT: 'int',
    INT_VEC2: 'ivec2',
    INT_VEC3: 'ivec3',
    INT_VEC4: 'ivec4',
    UNSIGNED_INT: 'uint',
    UNSIGNED_INT_VEC2: 'uvec2',
    UNSIGNED_INT_VEC3: 'uvec3',
    UNSIGNED_INT_VEC4: 'uvec4',
    BOOL: 'bool',
    BOOL_VEC2: 'bvec2',
    BOOL_VEC3: 'bvec3',
    BOOL_VEC4: 'bvec4',
    FLOAT_MAT2: 'mat2',
    FLOAT_MAT3: 'mat3',
    FLOAT_MAT4: 'mat4',
    SAMPLER_2D: 'sampler2D',
    INT_SAMPLER_2D: 'sampler2D',
    UNSIGNED_INT_SAMPLER_2D: 'sampler2D',
    SAMPLER_CUBE: 'samplerCube',
    INT_SAMPLER_CUBE: 'samplerCube',
    UNSIGNED_INT_SAMPLER_CUBE: 'samplerCube',
    SAMPLER_2D_ARRAY: 'sampler2DArray',
    INT_SAMPLER_2D_ARRAY: 'sampler2DArray',
    UNSIGNED_INT_SAMPLER_2D_ARRAY: 'sampler2DArray'
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function mapType(gl, type) {
    if (!GL_TABLE) {
        var typeNames = Object.keys(GL_TO_GLSL_TYPES);
        GL_TABLE = {};
        for(var i = 0; i < typeNames.length; ++i){
            var tn = typeNames[i];
            GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn];
        }
    }
    return GL_TABLE[type];
}
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // Parsers, each one of these will take a look at the type of shader property and uniform.
// if they pass the test function then the code function is called that returns a the shader upload code for that uniform.
// Shader upload code is automagically generated with these parsers.
// If no parser is valid then the default upload functions are used.
// exposing Parsers means that custom upload logic can be added to pixi's shaders.
// A good example would be a pixi rectangle can be directly set on a uniform.
// If the shader sees it it knows how to upload the rectangle structure as a vec4
// format is as follows:
//
// {
//     test: (data, uniform) => {} <--- test is this code should be used for this uniform
//     code: (name, uniform) => {} <--- returns the string of the piece of code that uploads the uniform
//     codeUbo: (name, uniform) => {} <--- returns the string of the piece of code that uploads the
//                                         uniform to a uniform buffer
// }
var uniformParsers = [
    // a float cache layer
    {
        test: function(data) {
            return data.type === 'float' && data.size === 1;
        },
        code: function(name) {
            return "\n            if(uv[\"" + name + "\"] !== ud[\"" + name + "\"].value)\n            {\n                ud[\"" + name + "\"].value = uv[\"" + name + "\"]\n                gl.uniform1f(ud[\"" + name + "\"].location, uv[\"" + name + "\"])\n            }\n            ";
        }
    },
    // handling samplers
    {
        test: function(data) {
            // eslint-disable-next-line max-len
            return (data.type === 'sampler2D' || data.type === 'samplerCube' || data.type === 'sampler2DArray') && data.size === 1 && !data.isArray;
        },
        code: function(name) {
            return "t = syncData.textureCount++;\n\n            renderer.texture.bind(uv[\"" + name + "\"], t);\n\n            if(ud[\"" + name + "\"].value !== t)\n            {\n                ud[\"" + name + "\"].value = t;\n                gl.uniform1i(ud[\"" + name + "\"].location, t);\n; // eslint-disable-line max-len\n            }";
        }
    },
    // uploading pixi matrix object to mat3
    {
        test: function(data, uniform) {
            return data.type === 'mat3' && data.size === 1 && uniform.a !== undefined;
        },
        code: function(name) {
            // TODO and some smart caching dirty ids here!
            return "\n            gl.uniformMatrix3fv(ud[\"" + name + "\"].location, false, uv[\"" + name + "\"].toArray(true));\n            ";
        },
        codeUbo: function(name) {
            return "\n                var " + name + "_matrix = uv." + name + ".toArray(true);\n\n                data[offset] = " + name + "_matrix[0];\n                data[offset+1] = " + name + "_matrix[1];\n                data[offset+2] = " + name + "_matrix[2];\n        \n                data[offset + 4] = " + name + "_matrix[3];\n                data[offset + 5] = " + name + "_matrix[4];\n                data[offset + 6] = " + name + "_matrix[5];\n        \n                data[offset + 8] = " + name + "_matrix[6];\n                data[offset + 9] = " + name + "_matrix[7];\n                data[offset + 10] = " + name + "_matrix[8];\n            ";
        }
    },
    // uploading a pixi point as a vec2 with caching layer
    {
        test: function(data, uniform) {
            return data.type === 'vec2' && data.size === 1 && uniform.x !== undefined;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v.x || cv[1] !== v.y)\n                {\n                    cv[0] = v.x;\n                    cv[1] = v.y;\n                    gl.uniform2f(ud[\"" + name + "\"].location, v.x, v.y);\n                }";
        },
        codeUbo: function(name) {
            return "\n                v = uv." + name + ";\n\n                data[offset] = v.x;\n                data[offset+1] = v.y;\n            ";
        }
    },
    // caching layer for a vec2
    {
        test: function(data) {
            return data.type === 'vec2' && data.size === 1;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v[0] || cv[1] !== v[1])\n                {\n                    cv[0] = v[0];\n                    cv[1] = v[1];\n                    gl.uniform2f(ud[\"" + name + "\"].location, v[0], v[1]);\n                }\n            ";
        }
    },
    // upload a pixi rectangle as a vec4 with caching layer
    {
        test: function(data, uniform) {
            return data.type === 'vec4' && data.size === 1 && uniform.width !== undefined;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)\n                {\n                    cv[0] = v.x;\n                    cv[1] = v.y;\n                    cv[2] = v.width;\n                    cv[3] = v.height;\n                    gl.uniform4f(ud[\"" + name + "\"].location, v.x, v.y, v.width, v.height)\n                }";
        },
        codeUbo: function(name) {
            return "\n                    v = uv." + name + ";\n\n                    data[offset] = v.x;\n                    data[offset+1] = v.y;\n                    data[offset+2] = v.width;\n                    data[offset+3] = v.height;\n                ";
        }
    },
    // a caching layer for vec4 uploading
    {
        test: function(data) {
            return data.type === 'vec4' && data.size === 1;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n                {\n                    cv[0] = v[0];\n                    cv[1] = v[1];\n                    cv[2] = v[2];\n                    cv[3] = v[3];\n\n                    gl.uniform4f(ud[\"" + name + "\"].location, v[0], v[1], v[2], v[3])\n                }";
        }
    }
];
// cu = Cached value's uniform data field
// cv = Cached value
// v = value to upload
// ud = uniformData
// uv = uniformValue
// l = location
var GLSL_TO_SINGLE_SETTERS_CACHED = {
    float: "\n    if (cv !== v)\n    {\n        cu.value = v;\n        gl.uniform1f(location, v);\n    }",
    vec2: "\n    if (cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2f(location, v[0], v[1])\n    }",
    vec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3f(location, v[0], v[1], v[2])\n    }",
    vec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4f(location, v[0], v[1], v[2], v[3]);\n    }",
    int: "\n    if (cv !== v)\n    {\n        cu.value = v;\n\n        gl.uniform1i(location, v);\n    }",
    ivec2: "\n    if (cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2i(location, v[0], v[1]);\n    }",
    ivec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3i(location, v[0], v[1], v[2]);\n    }",
    ivec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4i(location, v[0], v[1], v[2], v[3]);\n    }",
    uint: "\n    if (cv !== v)\n    {\n        cu.value = v;\n\n        gl.uniform1ui(location, v);\n    }",
    uvec2: "\n    if (cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2ui(location, v[0], v[1]);\n    }",
    uvec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3ui(location, v[0], v[1], v[2]);\n    }",
    uvec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);\n    }",
    bool: "\n    if (cv !== v)\n    {\n        cu.value = v;\n        gl.uniform1i(location, v);\n    }",
    bvec2: "\n    if (cv[0] != v[0] || cv[1] != v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2i(location, v[0], v[1]);\n    }",
    bvec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3i(location, v[0], v[1], v[2]);\n    }",
    bvec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4i(location, v[0], v[1], v[2], v[3]);\n    }",
    mat2: 'gl.uniformMatrix2fv(location, false, v)',
    mat3: 'gl.uniformMatrix3fv(location, false, v)',
    mat4: 'gl.uniformMatrix4fv(location, false, v)',
    sampler2D: 'gl.uniform1i(location, v)',
    samplerCube: 'gl.uniform1i(location, v)',
    sampler2DArray: 'gl.uniform1i(location, v)'
};
var GLSL_TO_ARRAY_SETTERS = {
    float: "gl.uniform1fv(location, v)",
    vec2: "gl.uniform2fv(location, v)",
    vec3: "gl.uniform3fv(location, v)",
    vec4: 'gl.uniform4fv(location, v)',
    mat4: 'gl.uniformMatrix4fv(location, false, v)',
    mat3: 'gl.uniformMatrix3fv(location, false, v)',
    mat2: 'gl.uniformMatrix2fv(location, false, v)',
    int: 'gl.uniform1iv(location, v)',
    ivec2: 'gl.uniform2iv(location, v)',
    ivec3: 'gl.uniform3iv(location, v)',
    ivec4: 'gl.uniform4iv(location, v)',
    uint: 'gl.uniform1uiv(location, v)',
    uvec2: 'gl.uniform2uiv(location, v)',
    uvec3: 'gl.uniform3uiv(location, v)',
    uvec4: 'gl.uniform4uiv(location, v)',
    bool: 'gl.uniform1iv(location, v)',
    bvec2: 'gl.uniform2iv(location, v)',
    bvec3: 'gl.uniform3iv(location, v)',
    bvec4: 'gl.uniform4iv(location, v)',
    sampler2D: 'gl.uniform1iv(location, v)',
    samplerCube: 'gl.uniform1iv(location, v)',
    sampler2DArray: 'gl.uniform1iv(location, v)'
};
function generateUniformsSync(group, uniformData) {
    var _a;
    var funcFragments = [
        "\n        var v = null;\n        var cv = null;\n        var cu = null;\n        var t = 0;\n        var gl = renderer.gl;\n    "
    ];
    for(var i in group.uniforms){
        var data = uniformData[i];
        if (!data) {
            if ((_a = group.uniforms[i]) === null || _a === void 0 ? void 0 : _a.group) {
                if (group.uniforms[i].ubo) funcFragments.push("\n                        renderer.shader.syncUniformBufferGroup(uv." + i + ", '" + i + "');\n                    ");
                else funcFragments.push("\n                        renderer.shader.syncUniformGroup(uv." + i + ", syncData);\n                    ");
            }
            continue;
        }
        var uniform = group.uniforms[i];
        var parsed = false;
        for(var j = 0; j < uniformParsers.length; j++)if (uniformParsers[j].test(data, uniform)) {
            funcFragments.push(uniformParsers[j].code(i, uniform));
            parsed = true;
            break;
        }
        if (!parsed) {
            var templateType = data.size === 1 ? GLSL_TO_SINGLE_SETTERS_CACHED : GLSL_TO_ARRAY_SETTERS;
            var template = templateType[data.type].replace('location', "ud[\"" + i + "\"].location");
            funcFragments.push("\n            cu = ud[\"" + i + "\"];\n            cv = cu.value;\n            v = uv[\"" + i + "\"];\n            " + template + ";");
        }
    }
    /*
     * the introduction of syncData is to solve an issue where textures in uniform groups are not set correctly
     * the texture count was always starting from 0 in each group. This needs to increment each time a texture is used
     * no matter which group is being used
     *
     */ // eslint-disable-next-line no-new-func
    return new Function('ud', 'uv', 'renderer', 'syncData', funcFragments.join('\n'));
}
var fragTemplate = [
    'precision mediump float;',
    'void main(void){',
    'float test = 0.1;',
    '%forloop%',
    'gl_FragColor = vec4(0.0);',
    '}'
].join('\n');
function generateIfTestSrc(maxIfs) {
    var src = '';
    for(var i = 0; i < maxIfs; ++i){
        if (i > 0) src += '\nelse ';
        if (i < maxIfs - 1) src += "if(test == " + i + ".0){}";
    }
    return src;
}
function checkMaxIfStatementsInShader(maxIfs, gl) {
    if (maxIfs === 0) throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
    var shader = gl.createShader(gl.FRAGMENT_SHADER);
    while(true){
        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
        gl.shaderSource(shader, fragmentSrc);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
        else break;
    }
    return maxIfs;
}
// Cache the result to prevent running this over and over
var unsafeEval;
/**
 * Not all platforms allow to generate function code (e.g., `new Function`).
 * this provides the platform-level detection.
 *
 * @private
 * @returns {boolean}
 */ function unsafeEvalSupported() {
    if (typeof unsafeEval === 'boolean') return unsafeEval;
    try {
        /* eslint-disable no-new-func */ var func = new Function('param1', 'param2', 'param3', 'return param1[param2] === param3;');
        /* eslint-enable no-new-func */ unsafeEval = func({
            a: 'b'
        }, 'a', 'b') === true;
    } catch (e) {
        unsafeEval = false;
    }
    return unsafeEval;
}
var defaultFragment = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor *= texture2D(uSampler, vTextureCoord);\n}";
var defaultVertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void){\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vTextureCoord = aTextureCoord;\n}\n";
var UID$3 = 0;
var nameCache = {};
/**
 * Helper class to create a shader program.
 *
 * @memberof PIXI
 */ var Program = /** @class */ function() {
    /**
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param name - Name for shader
     */ function Program(vertexSrc, fragmentSrc, name) {
        if (name === void 0) name = 'pixi-shader';
        this.id = UID$3++;
        this.vertexSrc = vertexSrc || Program.defaultVertexSrc;
        this.fragmentSrc = fragmentSrc || Program.defaultFragmentSrc;
        this.vertexSrc = this.vertexSrc.trim();
        this.fragmentSrc = this.fragmentSrc.trim();
        if (this.vertexSrc.substring(0, 8) !== '#version') {
            name = name.replace(/\s+/g, '-');
            if (nameCache[name]) {
                nameCache[name]++;
                name += "-" + nameCache[name];
            } else nameCache[name] = 1;
            this.vertexSrc = "#define SHADER_NAME " + name + "\n" + this.vertexSrc;
            this.fragmentSrc = "#define SHADER_NAME " + name + "\n" + this.fragmentSrc;
            this.vertexSrc = setPrecision(this.vertexSrc, (0, $ezJmd.settings).PRECISION_VERTEX, (0, $P8XPi.PRECISION).HIGH);
            this.fragmentSrc = setPrecision(this.fragmentSrc, (0, $ezJmd.settings).PRECISION_FRAGMENT, getMaxFragmentPrecision());
        }
        // currently this does not extract structs only default types
        // this is where we store shader references..
        this.glPrograms = {};
        this.syncUniforms = null;
    }
    Object.defineProperty(Program, "defaultVertexSrc", {
        /**
         * The default vertex shader source.
         *
         * @constant
         */ get: function() {
            return defaultVertex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Program, "defaultFragmentSrc", {
        /**
         * The default fragment shader source.
         *
         * @constant
         */ get: function() {
            return defaultFragment;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * A short hand function to create a program based of a vertex and fragment shader.
     *
     * This method will also check to see if there is a cached program.
     *
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param name - Name for shader
     * @returns A shiny new PixiJS shader program!
     */ Program.from = function(vertexSrc, fragmentSrc, name) {
        var key = vertexSrc + fragmentSrc;
        var program = (0, $csytw.ProgramCache)[key];
        if (!program) (0, $csytw.ProgramCache)[key] = program = new Program(vertexSrc, fragmentSrc, name);
        return program;
    };
    return Program;
}();
/**
 * A helper class for shaders.
 *
 * @memberof PIXI
 */ var Shader = /** @class */ function() {
    /**
     * @param program - The program the shader will use.
     * @param uniforms - Custom uniforms to use to augment the built-in ones.
     */ function Shader(program, uniforms) {
        /**
         * Used internally to bind uniform buffer objects.
         * @ignore
         */ this.uniformBindCount = 0;
        this.program = program;
        // lets see whats been passed in
        // uniforms should be converted to a uniform group
        if (uniforms) {
            if (uniforms instanceof UniformGroup) this.uniformGroup = uniforms;
            else this.uniformGroup = new UniformGroup(uniforms);
        } else this.uniformGroup = new UniformGroup({});
    }
    // TODO move to shader system..
    Shader.prototype.checkUniformExists = function(name, group) {
        if (group.uniforms[name]) return true;
        for(var i in group.uniforms){
            var uniform = group.uniforms[i];
            if (uniform.group) {
                if (this.checkUniformExists(name, uniform)) return true;
            }
        }
        return false;
    };
    Shader.prototype.destroy = function() {
        // usage count on programs?
        // remove if not used!
        this.uniformGroup = null;
    };
    Object.defineProperty(Shader.prototype, "uniforms", {
        /**
         * Shader uniform values, shortcut for `uniformGroup.uniforms`.
         *
         * @readonly
         */ get: function() {
            return this.uniformGroup.uniforms;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * A short hand function to create a shader based of a vertex and fragment shader.
     *
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param uniforms - Custom uniforms to use to augment the built-in ones.
     * @returns A shiny new PixiJS shader!
     */ Shader.from = function(vertexSrc, fragmentSrc, uniforms) {
        var program = Program.from(vertexSrc, fragmentSrc);
        return new Shader(program, uniforms);
    };
    return Shader;
}();
/* eslint-disable max-len */ var BLEND = 0;
var OFFSET = 1;
var CULLING = 2;
var DEPTH_TEST = 3;
var WINDING = 4;
var DEPTH_MASK = 5;
/**
 * This is a WebGL state, and is is passed to {@link PIXI.StateSystem}.
 *
 * Each mesh rendered may require WebGL to be in a different state.
 * For example you may want different blend mode or to enable polygon offsets
 *
 * @memberof PIXI
 */ var State = /** @class */ function() {
    function State() {
        this.data = 0;
        this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    //  this.depthTest = true;
    }
    Object.defineProperty(State.prototype, "blend", {
        /**
         * Activates blending of the computed fragment color values.
         *
         * @default true
         */ get: function() {
            return !!(this.data & 1 << BLEND);
        },
        set: function(value) {
            if (!!(this.data & 1 << BLEND) !== value) this.data ^= 1 << BLEND;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "offsets", {
        /**
         * Activates adding an offset to depth values of polygon's fragments
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << OFFSET);
        },
        set: function(value) {
            if (!!(this.data & 1 << OFFSET) !== value) this.data ^= 1 << OFFSET;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "culling", {
        /**
         * Activates culling of polygons.
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << CULLING);
        },
        set: function(value) {
            if (!!(this.data & 1 << CULLING) !== value) this.data ^= 1 << CULLING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "depthTest", {
        /**
         * Activates depth comparisons and updates to the depth buffer.
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << DEPTH_TEST);
        },
        set: function(value) {
            if (!!(this.data & 1 << DEPTH_TEST) !== value) this.data ^= 1 << DEPTH_TEST;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "depthMask", {
        /**
         * Enables or disables writing to the depth buffer.
         *
         * @default true
         */ get: function() {
            return !!(this.data & 1 << DEPTH_MASK);
        },
        set: function(value) {
            if (!!(this.data & 1 << DEPTH_MASK) !== value) this.data ^= 1 << DEPTH_MASK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "clockwiseFrontFace", {
        /**
         * Specifies whether or not front or back-facing polygons can be culled.
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << WINDING);
        },
        set: function(value) {
            if (!!(this.data & 1 << WINDING) !== value) this.data ^= 1 << WINDING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "blendMode", {
        /**
         * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
         *
         * @default PIXI.BLEND_MODES.NORMAL
         */ get: function() {
            return this._blendMode;
        },
        set: function(value) {
            this.blend = value !== (0, $P8XPi.BLEND_MODES).NONE;
            this._blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "polygonOffset", {
        /**
         * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
         *
         * @default 0
         */ get: function() {
            return this._polygonOffset;
        },
        set: function(value) {
            this.offsets = !!value;
            this._polygonOffset = value;
        },
        enumerable: false,
        configurable: true
    });
    State.prototype.toString = function() {
        return "[@pixi/core:State " + ("blendMode=" + this.blendMode + " ") + ("clockwiseFrontFace=" + this.clockwiseFrontFace + " ") + ("culling=" + this.culling + " ") + ("depthMask=" + this.depthMask + " ") + ("polygonOffset=" + this.polygonOffset) + "]";
    };
    State.for2d = function() {
        var state = new State();
        state.depthTest = false;
        state.blend = true;
        return state;
    };
    return State;
}();
var defaultVertex$1 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";
var defaultFragment$1 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor = texture2D(uSampler, vTextureCoord);\n}\n";
/**
 * A filter is a special shader that applies post-processing effects to an input texture and writes into an output
 * render-target.
 *
 * {@link http://pixijs.io/examples/#/filters/blur-filter.js Example} of the
 * {@link PIXI.filters.BlurFilter BlurFilter}.
 *
 * ### Usage
 * Filters can be applied to any DisplayObject or Container.
 * PixiJS' `FilterSystem` renders the container into temporary Framebuffer,
 * then filter renders it to the screen.
 * Multiple filters can be added to the `filters` array property and stacked on each other.
 *
 * ```
 * const filter = new PIXI.Filter(myShaderVert, myShaderFrag, { myUniform: 0.5 });
 * const container = new PIXI.Container();
 * container.filters = [filter];
 * ```
 *
 * ### Previous Version Differences
 *
 * In PixiJS **v3**, a filter was always applied to _whole screen_.
 *
 * In PixiJS **v4**, a filter can be applied _only part of the screen_.
 * Developers had to create a set of uniforms to deal with coordinates.
 *
 * In PixiJS **v5** combines _both approaches_.
 * Developers can use normal coordinates of v3 and then allow filter to use partial Framebuffers,
 * bringing those extra uniforms into account.
 *
 * Also be aware that we have changed default vertex shader, please consult
 * {@link https://github.com/pixijs/pixi.js/wiki/v5-Creating-filters Wiki}.
 *
 * ### Frames
 *
 * The following table summarizes the coordinate spaces used in the filtering pipeline:
 *
 * <table>
 * <thead>
 *   <tr>
 *     <th>Coordinate Space</th>
 *     <th>Description</th>
 *   </tr>
 * </thead>
 * <tbody>
 *   <tr>
 *     <td>Texture Coordinates</td>
 *     <td>
 *         The texture (or UV) coordinates in the input base-texture's space. These are normalized into the (0,1) range along
 *         both axes.
 *     </td>
 *   </tr>
 *   <tr>
 *     <td>World Space</td>
 *     <td>
 *         A point in the same space as the world bounds of any display-object (i.e. in the scene graph's space).
 *     </td>
 *   </tr>
 *   <tr>
 *     <td>Physical Pixels</td>
 *     <td>
 *         This is base-texture's space with the origin on the top-left. You can calculate these by multiplying the texture
 *         coordinates by the dimensions of the texture.
 *     </td>
 *   </tr>
 * </tbody>
 * </table>
 *
 * ### Built-in Uniforms
 *
 * PixiJS viewport uses screen (CSS) coordinates, `(0, 0, renderer.screen.width, renderer.screen.height)`,
 * and `projectionMatrix` uniform maps it to the gl viewport.
 *
 * **uSampler**
 *
 * The most important uniform is the input texture that container was rendered into.
 * _Important note: as with all Framebuffers in PixiJS, both input and output are
 * premultiplied by alpha._
 *
 * By default, input normalized coordinates are passed to fragment shader with `vTextureCoord`.
 * Use it to sample the input.
 *
 * ```
 * const fragment = `
 * varying vec2 vTextureCoord;
 * uniform sampler2D uSampler;
 * void main(void)
 * {
 *    gl_FragColor = texture2D(uSampler, vTextureCoord);
 * }
 * `;
 *
 * const myFilter = new PIXI.Filter(null, fragment);
 * ```
 *
 * This filter is just one uniform less than {@link PIXI.filters.AlphaFilter AlphaFilter}.
 *
 * **outputFrame**
 *
 * The `outputFrame` holds the rectangle where filter is applied in screen (CSS) coordinates.
 * It's the same as `renderer.screen` for a fullscreen filter.
 * Only a part of  `outputFrame.zw` size of temporary Framebuffer is used,
 * `(0, 0, outputFrame.width, outputFrame.height)`,
 *
 * Filters uses this quad to normalized (0-1) space, its passed into `aVertexPosition` attribute.
 * To calculate vertex position in screen space using normalized (0-1) space:
 *
 * ```
 * vec4 filterVertexPosition( void )
 * {
 *     vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;
 *     return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
 * }
 * ```
 *
 * **inputSize**
 *
 * Temporary framebuffer is different, it can be either the size of screen, either power-of-two.
 * The `inputSize.xy` are size of temporary framebuffer that holds input.
 * The `inputSize.zw` is inverted, it's a shortcut to evade division inside the shader.
 *
 * Set `inputSize.xy = outputFrame.zw` for a fullscreen filter.
 *
 * To calculate input normalized coordinate, you have to map it to filter normalized space.
 * Multiply by `outputFrame.zw` to get input coordinate.
 * Divide by `inputSize.xy` to get input normalized coordinate.
 *
 * ```
 * vec2 filterTextureCoord( void )
 * {
 *     return aVertexPosition * (outputFrame.zw * inputSize.zw); // same as /inputSize.xy
 * }
 * ```
 * **resolution**
 *
 * The `resolution` is the ratio of screen (CSS) pixels to real pixels.
 *
 * **inputPixel**
 *
 * `inputPixel.xy` is the size of framebuffer in real pixels, same as `inputSize.xy * resolution`
 * `inputPixel.zw` is inverted `inputPixel.xy`.
 *
 * It's handy for filters that use neighbour pixels, like {@link PIXI.filters.FXAAFilter FXAAFilter}.
 *
 * **inputClamp**
 *
 * If you try to get info from outside of used part of Framebuffer - you'll get undefined behaviour.
 * For displacements, coordinates has to be clamped.
 *
 * The `inputClamp.xy` is left-top pixel center, you may ignore it, because we use left-top part of Framebuffer
 * `inputClamp.zw` is bottom-right pixel center.
 *
 * ```
 * vec4 color = texture2D(uSampler, clamp(modifiedTextureCoord, inputClamp.xy, inputClamp.zw))
 * ```
 * OR
 * ```
 * vec4 color = texture2D(uSampler, min(modifigedTextureCoord, inputClamp.zw))
 * ```
 *
 * ### Additional Information
 *
 * Complete documentation on Filter usage is located in the
 * {@link https://github.com/pixijs/pixi.js/wiki/v5-Creating-filters Wiki}.
 *
 * Since PixiJS only had a handful of built-in filters, additional filters can be downloaded
 * {@link https://github.com/pixijs/pixi-filters here} from the PixiJS Filters repository.
 *
 * @memberof PIXI
 */ var Filter = /** @class */ function(_super) {
    __extends(Filter, _super);
    /**
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param uniforms - Custom uniforms to use to augment the built-in ones.
     */ function Filter(vertexSrc, fragmentSrc, uniforms) {
        var _this = this;
        var program = Program.from(vertexSrc || Filter.defaultVertexSrc, fragmentSrc || Filter.defaultFragmentSrc);
        _this = _super.call(this, program, uniforms) || this;
        _this.padding = 0;
        _this.resolution = (0, $ezJmd.settings).FILTER_RESOLUTION;
        _this.multisample = (0, $ezJmd.settings).FILTER_MULTISAMPLE;
        _this.enabled = true;
        _this.autoFit = true;
        _this.state = new State();
        return _this;
    }
    /**
     * Applies the filter
     *
     * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
     * @param {PIXI.RenderTexture} input - The input render target.
     * @param {PIXI.RenderTexture} output - The target to output to.
     * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
     * @param {object} [currentState] - It's current state of filter.
     *        There are some useful properties in the currentState :
     *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
     */ Filter.prototype.apply = function(filterManager, input, output, clearMode, _currentState) {
        // do as you please!
        filterManager.applyFilter(this, input, output, clearMode);
    // or just do a regular render..
    };
    Object.defineProperty(Filter.prototype, "blendMode", {
        /**
         * Sets the blend mode of the filter.
         *
         * @default PIXI.BLEND_MODES.NORMAL
         */ get: function() {
            return this.state.blendMode;
        },
        set: function(value) {
            this.state.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filter.prototype, "resolution", {
        /**
         * The resolution of the filter. Setting this to be lower will lower the quality but
         * increase the performance of the filter.
         */ get: function() {
            return this._resolution;
        },
        set: function(value) {
            this._resolution = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filter, "defaultVertexSrc", {
        /**
         * The default vertex shader source
         *
         * @constant
         */ get: function() {
            return defaultVertex$1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filter, "defaultFragmentSrc", {
        /**
         * The default fragment shader source
         *
         * @constant
         */ get: function() {
            return defaultFragment$1;
        },
        enumerable: false,
        configurable: true
    });
    return Filter;
}(Shader);
var vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n";
var fragment = "varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform float npmAlpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);\n\n    original *= (alphaMul * masky.r * alpha * clip);\n\n    gl_FragColor = original;\n}\n";
var tempMat = new (0, $6qzqq.Matrix)();
/**
 * Class controls uv mapping from Texture normal space to BaseTexture normal space.
 *
 * Takes `trim` and `rotate` into account. May contain clamp settings for Meshes and TilingSprite.
 *
 * Can be used in Texture `uvMatrix` field, or separately, you can use different clamp settings on the same texture.
 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
 *
 * Takes track of Texture changes through `_lastTextureID` private field.
 * Use `update()` method call to track it from outside.
 *
 * @see PIXI.Texture
 * @see PIXI.Mesh
 * @see PIXI.TilingSprite
 * @class
 * @memberof PIXI
 */ var TextureMatrix = /** @class */ function() {
    /**
     *
     * @param {PIXI.Texture} texture - observed texture
     * @param {number} [clampMargin] - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
     * @constructor
     */ function TextureMatrix(texture, clampMargin) {
        this._texture = texture;
        /**
         * Matrix operation that converts texture region coords to texture coords
         * @member {PIXI.Matrix}
         * @readonly
         */ this.mapCoord = new (0, $6qzqq.Matrix)();
        /**
         * Clamp region for normalized coords, left-top pixel center in xy , bottom-right in zw.
         * Calculated based on clampOffset.
         * @member {Float32Array}
         * @readonly
         */ this.uClampFrame = new Float32Array(4);
        /**
         * Normalized clamp offset.
         * Calculated based on clampOffset.
         * @member {Float32Array}
         * @readonly
         */ this.uClampOffset = new Float32Array(2);
        /**
         * Tracks Texture frame changes
         * @member {number}
         * @protected
         */ this._textureID = -1;
        /**
         * Tracks Texture frame changes
         * @member {number}
         * @protected
         */ this._updateID = 0;
        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
         *
         * @default 0
         * @member {number}
         */ this.clampOffset = 0;
        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */ this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
        /**
         * If texture size is the same as baseTexture
         * @member {boolean}
         * @default false
         * @readonly
         */ this.isSimple = false;
    }
    Object.defineProperty(TextureMatrix.prototype, "texture", {
        /**
         * texture property
         * @member {PIXI.Texture}
         */ get: function() {
            return this._texture;
        },
        set: function(value) {
            this._texture = value;
            this._textureID = -1;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Multiplies uvs array to transform
     * @param {Float32Array} uvs - mesh uvs
     * @param {Float32Array} [out=uvs] - output
     * @returns {Float32Array} output
     */ TextureMatrix.prototype.multiplyUvs = function(uvs, out) {
        if (out === undefined) out = uvs;
        var mat = this.mapCoord;
        for(var i = 0; i < uvs.length; i += 2){
            var x = uvs[i];
            var y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    };
    /**
     * updates matrices if texture was changed
     * @param {boolean} [forceUpdate=false] - if true, matrices will be updated any case
     * @returns {boolean} whether or not it was updated
     */ TextureMatrix.prototype.update = function(forceUpdate) {
        var tex = this._texture;
        if (!tex || !tex.valid) return false;
        if (!forceUpdate && this._textureID === tex._updateID) return false;
        this._textureID = tex._updateID;
        this._updateID++;
        var uvs = tex._uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        var orig = tex.orig;
        var trim = tex.trim;
        if (trim) {
            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append(tempMat);
        }
        var texBase = tex.baseTexture;
        var frame = this.uClampFrame;
        var margin = this.clampMargin / texBase.resolution;
        var offset = this.clampOffset;
        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.realWidth;
        this.uClampOffset[1] = offset / texBase.realHeight;
        this.isSimple = tex._frame.width === texBase.width && tex._frame.height === texBase.height && tex.rotate === 0;
        return true;
    };
    return TextureMatrix;
}();
/**
 * This handles a Sprite acting as a mask, as opposed to a Graphic.
 *
 * WebGL only.
 *
 * @memberof PIXI
 */ var SpriteMaskFilter = /** @class */ function(_super) {
    __extends(SpriteMaskFilter, _super);
    /** @ignore */ function SpriteMaskFilter(vertexSrc, fragmentSrc, uniforms) {
        var _this = this;
        var sprite = null;
        if (typeof vertexSrc !== 'string' && fragmentSrc === undefined && uniforms === undefined) {
            sprite = vertexSrc;
            vertexSrc = undefined;
            fragmentSrc = undefined;
            uniforms = undefined;
        }
        _this = _super.call(this, vertexSrc || vertex, fragmentSrc || fragment, uniforms) || this;
        _this.maskSprite = sprite;
        _this.maskMatrix = new (0, $6qzqq.Matrix)();
        return _this;
    }
    Object.defineProperty(SpriteMaskFilter.prototype, "maskSprite", {
        /**
         * Sprite mask
         *
         * @type {PIXI.DisplayObject}
         */ get: function() {
            return this._maskSprite;
        },
        set: function(value) {
            this._maskSprite = value;
            if (this._maskSprite) this._maskSprite.renderable = false;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Applies the filter
     *
     * @param filterManager - The renderer to retrieve the filter from
     * @param input - The input render target.
     * @param output - The target to output to.
     * @param clearMode - Should the output be cleared before rendering to it.
     */ SpriteMaskFilter.prototype.apply = function(filterManager, input, output, clearMode) {
        var maskSprite = this._maskSprite;
        var tex = maskSprite._texture;
        if (!tex.valid) return;
        if (!tex.uvMatrix) // margin = 0.0, let it bleed a bit, shader code becomes easier
        // assuming that atlas textures were made with 1-pixel padding
        tex.uvMatrix = new TextureMatrix(tex, 0.0);
        tex.uvMatrix.update();
        this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0.0 : 1.0;
        this.uniforms.mask = tex;
        // get _normalized sprite texture coords_ and convert them to _normalized atlas texture coords_ with `prepend`
        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.uvMatrix.mapCoord);
        this.uniforms.alpha = maskSprite.worldAlpha;
        this.uniforms.maskClamp = tex.uvMatrix.uClampFrame;
        filterManager.applyFilter(this, input, output, clearMode);
    };
    return SpriteMaskFilter;
}(Filter);
/**
 * System plugin to the renderer to manage masks.
 *
 * There are three built-in types of masking:
 * * **Scissor Masking**: Scissor masking discards pixels that are outside of a rectangle called the scissor box. It is
 *  the most performant as the scissor test is inexpensive. However, it can only be used when the mask is rectangular.
 * * **Stencil Masking**: Stencil masking discards pixels that don't overlap with the pixels rendered into the stencil
 *  buffer. It is the next fastest option as it does not require rendering into a separate framebuffer. However, it does
 *  cause the mask to be rendered **twice** for each masking operation; hence, minimize the rendering cost of your masks.
 * * **Sprite Mask Filtering**: Sprite mask filtering discards pixels based on the red channel of the sprite-mask's
 *  texture. (Generally, the masking texture is grayscale). Using advanced techniques, you might be able to embed this
 *  type of masking in a custom shader - and hence, bypassing the masking system fully for performance wins.
 *
 * The best type of masking is auto-detected when you `push` one. To use scissor masking, you must pass in a `Graphics`
 * object with just a rectangle drawn.
 *
 * ## Mask Stacks
 *
 * In the scene graph, masks can be applied recursively, i.e. a mask can be applied during a masking operation. The mask
 * stack stores the currently applied masks in order. Each {@link PIXI.BaseRenderTexture} holds its own mask stack, i.e.
 * when you switch render-textures, the old masks only applied when you switch back to rendering to the old render-target.
 *
 * @memberof PIXI
 */ var MaskSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function MaskSystem(renderer) {
        this.renderer = renderer;
        this.enableScissor = true;
        this.alphaMaskPool = [];
        this.maskDataPool = [];
        this.maskStack = [];
        this.alphaMaskIndex = 0;
    }
    /**
     * Changes the mask stack that is used by this System.
     *
     * @param maskStack - The mask stack
     */ MaskSystem.prototype.setMaskStack = function(maskStack) {
        this.maskStack = maskStack;
        this.renderer.scissor.setMaskStack(maskStack);
        this.renderer.stencil.setMaskStack(maskStack);
    };
    /**
     * Enables the mask and appends it to the current mask stack.
     *
     * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
     *
     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
     * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskData - The masking data.
     */ MaskSystem.prototype.push = function(target, maskDataOrTarget) {
        var maskData = maskDataOrTarget;
        if (!maskData.isMaskData) {
            var d = this.maskDataPool.pop() || new MaskData();
            d.pooled = true;
            d.maskObject = maskDataOrTarget;
            maskData = d;
        }
        var maskAbove = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
        maskData.copyCountersOrReset(maskAbove);
        if (maskData.autoDetect) this.detect(maskData);
        maskData._target = target;
        if (maskData.type !== (0, $P8XPi.MASK_TYPES).SPRITE) this.maskStack.push(maskData);
        if (maskData.enabled) switch(maskData.type){
            case (0, $P8XPi.MASK_TYPES).SCISSOR:
                this.renderer.scissor.push(maskData);
                break;
            case (0, $P8XPi.MASK_TYPES).STENCIL:
                this.renderer.stencil.push(maskData);
                break;
            case (0, $P8XPi.MASK_TYPES).SPRITE:
                maskData.copyCountersOrReset(null);
                this.pushSpriteMask(maskData);
                break;
        }
        if (maskData.type === (0, $P8XPi.MASK_TYPES).SPRITE) this.maskStack.push(maskData);
    };
    /**
     * Removes the last mask from the mask stack and doesn't return it.
     *
     * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
     *
     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
     */ MaskSystem.prototype.pop = function(target) {
        var maskData = this.maskStack.pop();
        if (!maskData || maskData._target !== target) // TODO: add an assert when we have it
        return;
        if (maskData.enabled) switch(maskData.type){
            case (0, $P8XPi.MASK_TYPES).SCISSOR:
                this.renderer.scissor.pop();
                break;
            case (0, $P8XPi.MASK_TYPES).STENCIL:
                this.renderer.stencil.pop(maskData.maskObject);
                break;
            case (0, $P8XPi.MASK_TYPES).SPRITE:
                this.popSpriteMask(maskData);
                break;
        }
        maskData.reset();
        if (maskData.pooled) this.maskDataPool.push(maskData);
        if (this.maskStack.length !== 0) {
            var maskCurrent = this.maskStack[this.maskStack.length - 1];
            if (maskCurrent.type === (0, $P8XPi.MASK_TYPES).SPRITE && maskCurrent._filters) maskCurrent._filters[0].maskSprite = maskCurrent.maskObject;
        }
    };
    /** Sets type of MaskData based on its maskObject. */ MaskSystem.prototype.detect = function(maskData) {
        var maskObject = maskData.maskObject;
        if (maskObject.isSprite) maskData.type = (0, $P8XPi.MASK_TYPES).SPRITE;
        else if (this.enableScissor && this.renderer.scissor.testScissor(maskData)) maskData.type = (0, $P8XPi.MASK_TYPES).SCISSOR;
        else maskData.type = (0, $P8XPi.MASK_TYPES).STENCIL;
    };
    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param maskData - Sprite to be used as the mask.
     */ MaskSystem.prototype.pushSpriteMask = function(maskData) {
        var _a, _b;
        var maskObject = maskData.maskObject;
        var target = maskData._target;
        var alphaMaskFilter = maskData._filters;
        if (!alphaMaskFilter) {
            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
            if (!alphaMaskFilter) alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [
                new SpriteMaskFilter()
            ];
        }
        var renderer = this.renderer;
        var renderTextureSystem = renderer.renderTexture;
        var resolution;
        var multisample;
        if (renderTextureSystem.current) {
            var renderTexture = renderTextureSystem.current;
            resolution = maskData.resolution || renderTexture.resolution;
            multisample = (_a = maskData.multisample) !== null && _a !== void 0 ? _a : renderTexture.multisample;
        } else {
            resolution = maskData.resolution || renderer.resolution;
            multisample = (_b = maskData.multisample) !== null && _b !== void 0 ? _b : renderer.multisample;
        }
        alphaMaskFilter[0].resolution = resolution;
        alphaMaskFilter[0].multisample = multisample;
        alphaMaskFilter[0].maskSprite = maskObject;
        var stashFilterArea = target.filterArea;
        target.filterArea = maskObject.getBounds(true);
        renderer.filter.push(target, alphaMaskFilter);
        target.filterArea = stashFilterArea;
        if (!maskData._filters) this.alphaMaskIndex++;
    };
    /**
     * Removes the last filter from the filter stack and doesn't return it.
     *
     * @param maskData - Sprite to be used as the mask.
     */ MaskSystem.prototype.popSpriteMask = function(maskData) {
        this.renderer.filter.pop();
        if (maskData._filters) maskData._filters[0].maskSprite = null;
        else {
            this.alphaMaskIndex--;
            this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null;
        }
    };
    MaskSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return MaskSystem;
}();
/**
 * System plugin to the renderer to manage specific types of masking operations.
 *
 * @memberof PIXI
 */ var AbstractMaskSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function AbstractMaskSystem(renderer) {
        this.renderer = renderer;
        this.maskStack = [];
        this.glConst = 0;
    }
    /** Gets count of masks of certain type. */ AbstractMaskSystem.prototype.getStackLength = function() {
        return this.maskStack.length;
    };
    /**
     * Changes the mask stack that is used by this System.
     *
     * @param {PIXI.MaskData[]} maskStack - The mask stack
     */ AbstractMaskSystem.prototype.setMaskStack = function(maskStack) {
        var gl = this.renderer.gl;
        var curStackLen = this.getStackLength();
        this.maskStack = maskStack;
        var newStackLen = this.getStackLength();
        if (newStackLen !== curStackLen) {
            if (newStackLen === 0) gl.disable(this.glConst);
            else {
                gl.enable(this.glConst);
                this._useCurrent();
            }
        }
    };
    /**
     * Setup renderer to use the current mask data.
     * @private
     */ AbstractMaskSystem.prototype._useCurrent = function() {
    // OVERWRITE;
    };
    /** Destroys the mask stack. */ AbstractMaskSystem.prototype.destroy = function() {
        this.renderer = null;
        this.maskStack = null;
    };
    return AbstractMaskSystem;
}();
var tempMatrix$1 = new (0, $6qzqq.Matrix)();
/**
 * System plugin to the renderer to manage scissor masking.
 *
 * Scissor masking discards pixels outside of a rectangle called the scissor box. The scissor box is in the framebuffer
 * viewport's space; however, the mask's rectangle is projected from world-space to viewport space automatically
 * by this system.
 *
 * @memberof PIXI
 */ var ScissorSystem = /** @class */ function(_super) {
    __extends(ScissorSystem, _super);
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function ScissorSystem(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.glConst = WebGLRenderingContext.SCISSOR_TEST;
        return _this;
    }
    ScissorSystem.prototype.getStackLength = function() {
        var maskData = this.maskStack[this.maskStack.length - 1];
        if (maskData) return maskData._scissorCounter;
        return 0;
    };
    /**
     * evaluates _boundsTransformed, _scissorRect for MaskData
     * @param maskData
     */ ScissorSystem.prototype.calcScissorRect = function(maskData) {
        if (maskData._scissorRectLocal) return;
        var prevData = maskData._scissorRect;
        var maskObject = maskData.maskObject;
        var renderer = this.renderer;
        var renderTextureSystem = renderer.renderTexture;
        maskObject.renderable = true;
        var rect = maskObject.getBounds();
        this.roundFrameToPixels(rect, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform);
        maskObject.renderable = false;
        if (prevData) rect.fit(prevData);
        maskData._scissorRectLocal = rect;
    };
    ScissorSystem.isMatrixRotated = function(matrix) {
        if (!matrix) return false;
        var a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d;
        // Skip if skew/rotation present in matrix, except for multiple of 90° rotation. If rotation
        // is a multiple of 90°, then either pair of (b,c) or (a,d) will be (0,0).
        return (Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4);
    };
    /**
     * Test, whether the object can be scissor mask with current renderer projection.
     * Calls "calcScissorRect()" if its true.
     * @param maskData mask data
     * @returns whether Whether the object can be scissor mask
     */ ScissorSystem.prototype.testScissor = function(maskData) {
        var maskObject = maskData.maskObject;
        if (!maskObject.isFastRect || !maskObject.isFastRect()) return false;
        if (ScissorSystem.isMatrixRotated(maskObject.worldTransform)) return false;
        if (ScissorSystem.isMatrixRotated(this.renderer.projection.transform)) return false;
        this.calcScissorRect(maskData);
        var rect = maskData._scissorRectLocal;
        return rect.width > 0 && rect.height > 0;
    };
    ScissorSystem.prototype.roundFrameToPixels = function(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (ScissorSystem.isMatrixRotated(transform)) return;
        transform = transform ? tempMatrix$1.copyFrom(transform) : tempMatrix$1.identity();
        // Get forward transform from world space to screen space
        transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y);
        // Convert frame to screen space
        this.renderer.filter.transformAABB(transform, frame);
        frame.fit(bindingDestinationFrame);
        frame.x = Math.round(frame.x * resolution);
        frame.y = Math.round(frame.y * resolution);
        frame.width = Math.round(frame.width * resolution);
        frame.height = Math.round(frame.height * resolution);
    };
    /**
     * Applies the Mask and adds it to the current stencil stack.
     *
     * @author alvin
     * @param maskData - The mask data.
     */ ScissorSystem.prototype.push = function(maskData) {
        if (!maskData._scissorRectLocal) this.calcScissorRect(maskData);
        var gl = this.renderer.gl;
        if (!maskData._scissorRect) gl.enable(gl.SCISSOR_TEST);
        maskData._scissorCounter++;
        maskData._scissorRect = maskData._scissorRectLocal;
        this._useCurrent();
    };
    /**
     * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
     * last mask in the stack.
     *
     * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
     */ ScissorSystem.prototype.pop = function() {
        var gl = this.renderer.gl;
        if (this.getStackLength() > 0) this._useCurrent();
        else gl.disable(gl.SCISSOR_TEST);
    };
    /**
     * Setup renderer to use the current scissor data.
     * @private
     */ ScissorSystem.prototype._useCurrent = function() {
        var rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
        var y;
        if (this.renderer.renderTexture.current) y = rect.y;
        else // flipY. In future we'll have it over renderTextures as an option
        y = this.renderer.height - rect.height - rect.y;
        this.renderer.gl.scissor(rect.x, y, rect.width, rect.height);
    };
    return ScissorSystem;
}(AbstractMaskSystem);
/**
 * System plugin to the renderer to manage stencils (used for masks).
 *
 * @memberof PIXI
 */ var StencilSystem = /** @class */ function(_super) {
    __extends(StencilSystem, _super);
    /**
     * @param renderer - The renderer this System works for.
     */ function StencilSystem(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.glConst = WebGLRenderingContext.STENCIL_TEST;
        return _this;
    }
    StencilSystem.prototype.getStackLength = function() {
        var maskData = this.maskStack[this.maskStack.length - 1];
        if (maskData) return maskData._stencilCounter;
        return 0;
    };
    /**
     * Applies the Mask and adds it to the current stencil stack.
     *
     * @param maskData - The mask data
     */ StencilSystem.prototype.push = function(maskData) {
        var maskObject = maskData.maskObject;
        var gl = this.renderer.gl;
        var prevMaskCount = maskData._stencilCounter;
        if (prevMaskCount === 0) {
            // force use stencil texture in current framebuffer
            this.renderer.framebuffer.forceStencil();
            gl.clearStencil(0);
            gl.clear(gl.STENCIL_BUFFER_BIT);
            gl.enable(gl.STENCIL_TEST);
        }
        maskData._stencilCounter++;
        // Increment the reference stencil value where the new mask overlaps with the old ones.
        gl.colorMask(false, false, false, false);
        gl.stencilFunc(gl.EQUAL, prevMaskCount, 0xFFFFFFFF);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
        maskObject.renderable = true;
        maskObject.render(this.renderer);
        this.renderer.batch.flush();
        maskObject.renderable = false;
        this._useCurrent();
    };
    /**
     * Pops stencil mask. MaskData is already removed from stack
     *
     * @param {PIXI.DisplayObject} maskObject - object of popped mask data
     */ StencilSystem.prototype.pop = function(maskObject) {
        var gl = this.renderer.gl;
        if (this.getStackLength() === 0) // the stack is empty!
        gl.disable(gl.STENCIL_TEST);
        else {
            // Decrement the reference stencil value where the popped mask overlaps with the other ones
            gl.colorMask(false, false, false, false);
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
            maskObject.renderable = true;
            maskObject.render(this.renderer);
            this.renderer.batch.flush();
            maskObject.renderable = false;
            this._useCurrent();
        }
    };
    /**
     * Setup renderer to use the current stencil data.
     * @private
     */ StencilSystem.prototype._useCurrent = function() {
        var gl = this.renderer.gl;
        gl.colorMask(true, true, true, true);
        gl.stencilFunc(gl.EQUAL, this.getStackLength(), 0xFFFFFFFF);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    };
    return StencilSystem;
}(AbstractMaskSystem);
/**
 * System plugin to the renderer to manage the projection matrix.
 *
 * The `projectionMatrix` is a global uniform provided to all shaders. It is used to transform points in world space to
 * normalized device coordinates.
 *
 * @memberof PIXI
 */ var ProjectionSystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function ProjectionSystem(renderer) {
        this.renderer = renderer;
        this.destinationFrame = null;
        this.sourceFrame = null;
        this.defaultFrame = null;
        this.projectionMatrix = new (0, $6qzqq.Matrix)();
        this.transform = null;
    }
    /**
     * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
     *
     * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
     * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
     *
     * NOTE-2: {@link RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture. It is expected
     * that you dirty the current bindings when calling this manually.
     *
     * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
     *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
     * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
     * @param resolution - The resolution of the render-target, which is the ratio of
     *  world-space (or CSS) pixels to physical pixels.
     * @param root - Whether the render-target is the screen. This is required because rendering to textures
     *  is y-flipped (i.e. upside down relative to the screen).
     */ ProjectionSystem.prototype.update = function(destinationFrame, sourceFrame, resolution, root) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
        this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame;
        // Calculate object-space to clip-space projection
        this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root);
        if (this.transform) this.projectionMatrix.append(this.transform);
        var renderer = this.renderer;
        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix;
        renderer.globalUniforms.update();
        // this will work for now
        // but would be sweet to stick and even on the global uniforms..
        if (renderer.shader.shader) renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
    };
    /**
     * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
     *
     * @param destinationFrame - The destination frame in the render-target.
     * @param sourceFrame - The source frame in world space.
     * @param resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
     * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
     *  is y-flipped.
     */ ProjectionSystem.prototype.calculateProjection = function(_destinationFrame, sourceFrame, _resolution, root) {
        var pm = this.projectionMatrix;
        var sign = !root ? 1 : -1;
        pm.identity();
        pm.a = 1 / sourceFrame.width * 2;
        pm.d = sign * (1 / sourceFrame.height * 2);
        pm.tx = -1 - sourceFrame.x * pm.a;
        pm.ty = -sign - sourceFrame.y * pm.d;
    };
    /**
     * Sets the transform of the active render target to the given matrix.
     *
     * @param matrix - The transformation matrix
     */ ProjectionSystem.prototype.setTransform = function(_matrix) {
    // this._activeRenderTarget.transform = matrix;
    };
    ProjectionSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return ProjectionSystem;
}();
// Temporary rectangle for assigned sourceFrame or destinationFrame
var tempRect = new (0, $6qzqq.Rectangle)();
// Temporary rectangle for renderTexture destinationFrame
var tempRect2 = new (0, $6qzqq.Rectangle)();
/* eslint-disable max-len */ /**
 * System plugin to the renderer to manage render textures.
 *
 * Should be added after FramebufferSystem
 *
 * ### Frames
 *
 * The `RenderTextureSystem` holds a sourceFrame → destinationFrame projection. The following table explains the different
 * coordinate spaces used:
 *
 * | Frame                  | Description                                                      | Coordinate System                                       |
 * | ---------------------- | ---------------------------------------------------------------- | ------------------------------------------------------- |
 * | sourceFrame            | The rectangle inside of which display-objects are being rendered | **World Space**: The origin on the top-left             |
 * | destinationFrame       | The rectangle in the render-target (canvas or texture) into which contents should be rendered | If rendering to the canvas, this is in screen space and the origin is on the top-left. If rendering to a render-texture, this is in its base-texture's space with the origin on the bottom-left.  |
 * | viewportFrame          | The framebuffer viewport corresponding to the destination-frame  | **Window Coordinates**: The origin is always on the bottom-left. |
 *
 * @memberof PIXI
 */ var RenderTextureSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function RenderTextureSystem(renderer) {
        this.renderer = renderer;
        this.clearColor = renderer._backgroundColorRgba;
        this.defaultMaskStack = [];
        this.current = null;
        this.sourceFrame = new (0, $6qzqq.Rectangle)();
        this.destinationFrame = new (0, $6qzqq.Rectangle)();
        this.viewportFrame = new (0, $6qzqq.Rectangle)();
    }
    /**
     * Bind the current render texture.
     *
     * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
     * @param sourceFrame - Part of world that is mapped to the renderTexture.
     * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
     */ RenderTextureSystem.prototype.bind = function(renderTexture, sourceFrame, destinationFrame) {
        if (renderTexture === void 0) renderTexture = null;
        var renderer = this.renderer;
        this.current = renderTexture;
        var baseTexture;
        var framebuffer;
        var resolution;
        if (renderTexture) {
            baseTexture = renderTexture.baseTexture;
            resolution = baseTexture.resolution;
            if (!sourceFrame) {
                tempRect.width = renderTexture.frame.width;
                tempRect.height = renderTexture.frame.height;
                sourceFrame = tempRect;
            }
            if (!destinationFrame) {
                tempRect2.x = renderTexture.frame.x;
                tempRect2.y = renderTexture.frame.y;
                tempRect2.width = sourceFrame.width;
                tempRect2.height = sourceFrame.height;
                destinationFrame = tempRect2;
            }
            framebuffer = baseTexture.framebuffer;
        } else {
            resolution = renderer.resolution;
            if (!sourceFrame) {
                tempRect.width = renderer.screen.width;
                tempRect.height = renderer.screen.height;
                sourceFrame = tempRect;
            }
            if (!destinationFrame) {
                destinationFrame = tempRect;
                destinationFrame.width = sourceFrame.width;
                destinationFrame.height = sourceFrame.height;
            }
        }
        var viewportFrame = this.viewportFrame;
        viewportFrame.x = destinationFrame.x * resolution;
        viewportFrame.y = destinationFrame.y * resolution;
        viewportFrame.width = destinationFrame.width * resolution;
        viewportFrame.height = destinationFrame.height * resolution;
        if (!renderTexture) viewportFrame.y = renderer.view.height - (viewportFrame.y + viewportFrame.height);
        viewportFrame.ceil();
        this.renderer.framebuffer.bind(framebuffer, viewportFrame);
        this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer);
        if (renderTexture) this.renderer.mask.setMaskStack(baseTexture.maskStack);
        else this.renderer.mask.setMaskStack(this.defaultMaskStack);
        this.sourceFrame.copyFrom(sourceFrame);
        this.destinationFrame.copyFrom(destinationFrame);
    };
    /**
     * Erases the render texture and fills the drawing area with a colour.
     *
     * @param clearColor - The color as rgba, default to use the renderer backgroundColor
     * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
     *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
     */ RenderTextureSystem.prototype.clear = function(clearColor, mask) {
        if (this.current) clearColor = clearColor || this.current.baseTexture.clearColor;
        else clearColor = clearColor || this.clearColor;
        var destinationFrame = this.destinationFrame;
        var baseFrame = this.current ? this.current.baseTexture : this.renderer.screen;
        var clearMask = destinationFrame.width !== baseFrame.width || destinationFrame.height !== baseFrame.height;
        if (clearMask) {
            var _a = this.viewportFrame, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            x = Math.round(x);
            y = Math.round(y);
            width = Math.round(width);
            height = Math.round(height);
            // TODO: ScissorSystem should cache whether the scissor test is enabled or not.
            this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);
            this.renderer.gl.scissor(x, y, width, height);
        }
        this.renderer.framebuffer.clear(clearColor[0], clearColor[1], clearColor[2], clearColor[3], mask);
        if (clearMask) // Restore the scissor box
        this.renderer.scissor.pop();
    };
    RenderTextureSystem.prototype.resize = function() {
        // resize the root only!
        this.bind(null);
    };
    /** Resets render-texture state. */ RenderTextureSystem.prototype.reset = function() {
        this.bind(null);
    };
    RenderTextureSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return RenderTextureSystem;
}();
function uboUpdate(_ud, _uv, _renderer, _syncData, buffer) {
    _renderer.buffer.update(buffer);
}
// cv = CachedValue
// v = value
// ud = uniformData
// uv = uniformValue
// l = location
var UBO_TO_SINGLE_SETTERS = {
    float: "\n        data[offset] = v;\n    ",
    vec2: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n    ",
    vec3: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n        data[offset+2] = v[2];\n\n    ",
    vec4: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n        data[offset+2] = v[2];\n        data[offset+3] = v[3];\n    ",
    mat2: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n\n        data[offset+4] = v[2];\n        data[offset+5] = v[3];\n    ",
    mat3: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n        data[offset+2] = v[2];\n\n        data[offset + 4] = v[3];\n        data[offset + 5] = v[4];\n        data[offset + 6] = v[5];\n\n        data[offset + 8] = v[6];\n        data[offset + 9] = v[7];\n        data[offset + 10] = v[8];\n    ",
    mat4: "\n        for(var i = 0; i < 16; i++)\n        {\n            data[offset + i] = v[i];\n        }\n    "
};
var GLSL_TO_STD40_SIZE = {
    float: 4,
    vec2: 8,
    vec3: 12,
    vec4: 16,
    int: 4,
    ivec2: 8,
    ivec3: 12,
    ivec4: 16,
    uint: 4,
    uvec2: 8,
    uvec3: 12,
    uvec4: 16,
    bool: 4,
    bvec2: 8,
    bvec3: 12,
    bvec4: 16,
    mat2: 32,
    mat3: 48,
    mat4: 64
};
/**
 * @ignore
 *
 * logic originally from here: https://github.com/sketchpunk/FunWithWebGL2/blob/master/lesson_022/Shaders.js
 * rewrote it, but this was a great starting point to get a solid understanding of whats going on :)
 *
 * @param uniformData
 */ function createUBOElements(uniformData) {
    var uboElements = uniformData.map(function(data) {
        return {
            data: data,
            offset: 0,
            dataLen: 0,
            dirty: 0
        };
    });
    var size = 0;
    var chunkSize = 0;
    var offset = 0;
    for(var i = 0; i < uboElements.length; i++){
        var uboElement = uboElements[i];
        size = GLSL_TO_STD40_SIZE[uboElement.data.type];
        if (uboElement.data.size > 1) size = Math.max(size, 16) * uboElement.data.size;
        uboElement.dataLen = size;
        // add some size offset..
        // must align to the nearest 16 bytes or internally nearest round size
        if (chunkSize % size !== 0 && chunkSize < 16) {
            // diff required to line up..
            var lineUpValue = chunkSize % size % 16;
            chunkSize += lineUpValue;
            offset += lineUpValue;
        }
        if (chunkSize + size > 16) {
            offset = Math.ceil(offset / 16) * 16;
            uboElement.offset = offset;
            offset += size;
            chunkSize = size;
        } else {
            uboElement.offset = offset;
            chunkSize += size;
            offset += size;
        }
    }
    offset = Math.ceil(offset / 16) * 16;
    return {
        uboElements: uboElements,
        size: offset
    };
}
function getUBOData(uniforms, uniformData) {
    var usedUniformDatas = [];
    // build..
    for(var i in uniforms)if (uniformData[i]) usedUniformDatas.push(uniformData[i]);
    // sort them out by index!
    usedUniformDatas.sort(function(a, b) {
        return a.index - b.index;
    });
    return usedUniformDatas;
}
function generateUniformBufferSync(group, uniformData) {
    if (!group.autoManage) // if the group is nott automatically managed, we don't need to generate a special function for it...
    return {
        size: 0,
        syncFunc: uboUpdate
    };
    var usedUniformDatas = getUBOData(group.uniforms, uniformData);
    var _a = createUBOElements(usedUniformDatas), uboElements = _a.uboElements, size = _a.size;
    var funcFragments = [
        "\n    var v = null;\n    var v2 = null;\n    var cv = null;\n    var t = 0;\n    var gl = renderer.gl\n    var index = 0;\n    var data = buffer.data;\n    "
    ];
    for(var i = 0; i < uboElements.length; i++){
        var uboElement = uboElements[i];
        var uniform = group.uniforms[uboElement.data.name];
        var name = uboElement.data.name;
        var parsed = false;
        for(var j = 0; j < uniformParsers.length; j++){
            var uniformParser = uniformParsers[j];
            if (uniformParser.codeUbo && uniformParser.test(uboElement.data, uniform)) {
                funcFragments.push("offset = " + uboElement.offset / 4 + ";", uniformParsers[j].codeUbo(uboElement.data.name, uniform));
                parsed = true;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                var size_1 = mapSize(uboElement.data.type);
                var rowSize = Math.max(GLSL_TO_STD40_SIZE[uboElement.data.type] / 16, 1);
                var elementSize = size_1 / rowSize;
                var remainder = (4 - elementSize % 4) % 4;
                funcFragments.push("\n                cv = ud." + name + ".value;\n                v = uv." + name + ";\n                offset = " + uboElement.offset / 4 + ";\n\n                t = 0;\n\n                for(var i=0; i < " + uboElement.data.size * rowSize + "; i++)\n                {\n                    for(var j = 0; j < " + elementSize + "; j++)\n                    {\n                        data[offset++] = v[t++];\n                    }\n                    offset += " + remainder + ";\n                }\n\n                ");
            } else {
                var template = UBO_TO_SINGLE_SETTERS[uboElement.data.type];
                funcFragments.push("\n                cv = ud." + name + ".value;\n                v = uv." + name + ";\n                offset = " + uboElement.offset / 4 + ";\n                " + template + ";\n                ");
            }
        }
    }
    funcFragments.push("\n       renderer.buffer.update(buffer);\n    ");
    return {
        size: size,
        // eslint-disable-next-line no-new-func
        syncFunc: new Function('ud', 'uv', 'renderer', 'syncData', 'buffer', funcFragments.join('\n'))
    };
}
/**
 * @private
 */ var IGLUniformData = /** @class */ function() {
    function IGLUniformData() {}
    return IGLUniformData;
}();
/**
 * Helper class to create a WebGL Program
 *
 * @class
 * @memberof PIXI
 */ var GLProgram = /** @class */ function() {
    /**
     * Makes a new Pixi program
     *
     * @param {WebGLProgram} program - webgl program
     * @param {Object} uniformData - uniforms
     */ function GLProgram(program, uniformData) {
        /**
         * The shader program
         *
         * @member {WebGLProgram}
         */ this.program = program;
        /**
         * holds the uniform data which contains uniform locations
         * and current uniform values used for caching and preventing unneeded GPU commands
         * @member {Object}
         */ this.uniformData = uniformData;
        /**
         * uniformGroups holds the various upload functions for the shader. Each uniform group
         * and program have a unique upload function generated.
         * @member {Object}
         */ this.uniformGroups = {};
        this.uniformDirtyGroups = {};
        this.uniformBufferBindings = {};
    }
    /**
     * Destroys this program
     */ GLProgram.prototype.destroy = function() {
        this.uniformData = null;
        this.uniformGroups = null;
        this.uniformDirtyGroups = null;
        this.uniformBufferBindings = null;
        this.program = null;
    };
    return GLProgram;
}();
/**
 * returns the attribute data from the program
 * @private
 *
 * @param {WebGLProgram} [program] - the WebGL program
 * @param {WebGLRenderingContext} [gl] - the WebGL context
 *
 * @returns {object} the attribute data for this program
 */ function getAttributeData(program, gl) {
    var attributes = {};
    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(var i = 0; i < totalAttributes; i++){
        var attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.indexOf('gl_') === 0) continue;
        var type = mapType(gl, attribData.type);
        var data = {
            type: type,
            name: attribData.name,
            size: mapSize(type),
            location: gl.getAttribLocation(program, attribData.name)
        };
        attributes[attribData.name] = data;
    }
    return attributes;
}
/**
 * returns the uniform data from the program
 * @private
 *
 * @param program - the webgl program
 * @param gl - the WebGL context
 *
 * @returns {object} the uniform data for this program
 */ function getUniformData(program, gl) {
    var uniforms = {};
    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(var i = 0; i < totalUniforms; i++){
        var uniformData = gl.getActiveUniform(program, i);
        var name = uniformData.name.replace(/\[.*?\]$/, '');
        var isArray = !!uniformData.name.match(/\[.*?\]$/);
        var type = mapType(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: defaultValue(type, uniformData.size)
        };
    }
    return uniforms;
}
/**
 * generates a WebGL Program object from a high level Pixi Program.
 *
 * @param gl - a rendering context on which to generate the program
 * @param program - the high level Pixi Program.
 */ function generateProgram(gl, program) {
    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, program.vertexSrc);
    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, program.fragmentSrc);
    var webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader);
    gl.attachShader(webGLProgram, glFragShader);
    gl.linkProgram(webGLProgram);
    if (!gl.getProgramParameter(webGLProgram, gl.LINK_STATUS)) logProgramError(gl, webGLProgram, glVertShader, glFragShader);
    program.attributeData = getAttributeData(webGLProgram, gl);
    program.uniformData = getUniformData(webGLProgram, gl);
    // GLSL 1.00: bind attributes sorted by name in ascending order
    // GLSL 3.00: don't change the attribute locations that where chosen by the compiler
    //            or assigned by the layout specifier in the shader source code
    if (!/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertexSrc)) {
        var keys = Object.keys(program.attributeData);
        keys.sort(function(a, b) {
            return a > b ? 1 : -1;
        }); // eslint-disable-line no-confusing-arrow
        for(var i = 0; i < keys.length; i++){
            program.attributeData[keys[i]].location = i;
            gl.bindAttribLocation(webGLProgram, i, keys[i]);
        }
        gl.linkProgram(webGLProgram);
    }
    gl.deleteShader(glVertShader);
    gl.deleteShader(glFragShader);
    var uniformData = {};
    for(var i in program.uniformData){
        var data = program.uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: defaultValue(data.type, data.size)
        };
    }
    var glProgram = new GLProgram(webGLProgram, uniformData);
    return glProgram;
}
var UID$4 = 0;
// default sync data so we don't create a new one each time!
var defaultSyncData = {
    textureCount: 0,
    uboCount: 0
};
/**
 * System plugin to the renderer to manage shaders.
 *
 * @memberof PIXI
 */ var ShaderSystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function ShaderSystem(renderer) {
        this.destroyed = false;
        this.renderer = renderer;
        // Validation check that this environment support `new Function`
        this.systemCheck();
        this.gl = null;
        this.shader = null;
        this.program = null;
        this.cache = {};
        this._uboCache = {};
        this.id = UID$4++;
    }
    /**
     * Overrideable function by `@pixi/unsafe-eval` to silence
     * throwing an error if platform doesn't support unsafe-evals.
     *
     * @private
     */ ShaderSystem.prototype.systemCheck = function() {
        if (!unsafeEvalSupported()) throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    };
    ShaderSystem.prototype.contextChange = function(gl) {
        this.gl = gl;
        this.reset();
    };
    /**
     * Changes the current shader to the one given in parameter.
     *
     * @param shader - the new shader
     * @param dontSync - false if the shader should automatically sync its uniforms.
     * @returns the glProgram that belongs to the shader.
     */ ShaderSystem.prototype.bind = function(shader, dontSync) {
        shader.uniforms.globals = this.renderer.globalUniforms;
        var program = shader.program;
        var glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(shader);
        this.shader = shader;
        // TODO - some current Pixi plugins bypass this.. so it not safe to use yet..
        if (this.program !== program) {
            this.program = program;
            this.gl.useProgram(glProgram.program);
        }
        if (!dontSync) {
            defaultSyncData.textureCount = 0;
            defaultSyncData.uboCount = 0;
            this.syncUniformGroup(shader.uniformGroup, defaultSyncData);
        }
        return glProgram;
    };
    /**
     * Uploads the uniforms values to the currently bound shader.
     *
     * @param uniforms - the uniforms values that be applied to the current shader
     */ ShaderSystem.prototype.setUniforms = function(uniforms) {
        var shader = this.shader.program;
        var glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
    };
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
     * Syncs uniforms on the group
     *
     * @param group - the uniform group to sync
     * @param syncData - this is data that is passed to the sync function and any nested sync functions
     */ ShaderSystem.prototype.syncUniformGroup = function(group, syncData) {
        var glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== glProgram.uniformDirtyGroups[group.id]) {
            glProgram.uniformDirtyGroups[group.id] = group.dirtyId;
            this.syncUniforms(group, glProgram, syncData);
        }
    };
    /**
     * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
     */ ShaderSystem.prototype.syncUniforms = function(group, glProgram, syncData) {
        var syncFunc = group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group);
        syncFunc(glProgram.uniformData, group.uniforms, this.renderer, syncData);
    };
    ShaderSystem.prototype.createSyncGroups = function(group) {
        var id = this.getSignature(group, this.shader.program.uniformData, 'u');
        if (!this.cache[id]) this.cache[id] = generateUniformsSync(group, this.shader.program.uniformData);
        group.syncUniforms[this.shader.program.id] = this.cache[id];
        return group.syncUniforms[this.shader.program.id];
    };
    /**
     * Syncs uniform buffers
     *
     * @param group - the uniform buffer group to sync
     * @param name - the name of the uniform buffer
     */ ShaderSystem.prototype.syncUniformBufferGroup = function(group, name) {
        var glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== 0 || !glProgram.uniformGroups[group.id]) {
            group.dirtyId = 0;
            var syncFunc = glProgram.uniformGroups[group.id] || this.createSyncBufferGroup(group, glProgram, name);
            // TODO wrap update in a cache??
            group.buffer.update();
            syncFunc(glProgram.uniformData, group.uniforms, this.renderer, defaultSyncData, group.buffer);
        }
        this.renderer.buffer.bindBufferBase(group.buffer, glProgram.uniformBufferBindings[name]);
    };
    /**
     * Will create a function that uploads a uniform buffer using the STD140 standard.
     * The upload function will then be cached for future calls
     * If a group is manually managed, then a simple upload function is generated
     *
     * @param group - the uniform buffer group to sync
     * @param glProgram - the gl program to attach the uniform bindings to
     * @param name - the name of the uniform buffer (must exist on the shader)
     */ ShaderSystem.prototype.createSyncBufferGroup = function(group, glProgram, name) {
        var gl = this.renderer.gl;
        this.renderer.buffer.bind(group.buffer);
        // bind them...
        var uniformBlockIndex = this.gl.getUniformBlockIndex(glProgram.program, name);
        glProgram.uniformBufferBindings[name] = this.shader.uniformBindCount;
        gl.uniformBlockBinding(glProgram.program, uniformBlockIndex, this.shader.uniformBindCount);
        this.shader.uniformBindCount++;
        var id = this.getSignature(group, this.shader.program.uniformData, 'ubo');
        var uboData = this._uboCache[id];
        if (!uboData) uboData = this._uboCache[id] = generateUniformBufferSync(group, this.shader.program.uniformData);
        if (group.autoManage) {
            var data = new Float32Array(uboData.size / 4);
            group.buffer.update(data);
        }
        glProgram.uniformGroups[group.id] = uboData.syncFunc;
        return glProgram.uniformGroups[group.id];
    };
    /**
     * Takes a uniform group and data and generates a unique signature for them.
     *
     * @param group - The uniform group to get signature of
     * @param uniformData - Uniform information generated by the shader
     * @returns Unique signature of the uniform group
     */ ShaderSystem.prototype.getSignature = function(group, uniformData, preFix) {
        var uniforms = group.uniforms;
        var strings = [
            preFix + "-"
        ];
        for(var i in uniforms){
            strings.push(i);
            if (uniformData[i]) strings.push(uniformData[i].type);
        }
        return strings.join('-');
    };
    /**
     * Returns the underlying GLShade rof the currently bound shader.
     *
     * This can be handy for when you to have a little more control over the setting of your uniforms.
     *
     * @return The glProgram for the currently bound Shader for this context
     */ ShaderSystem.prototype.getGlProgram = function() {
        if (this.shader) return this.shader.program.glPrograms[this.renderer.CONTEXT_UID];
        return null;
    };
    /**
     * Generates a glProgram version of the Shader provided.
     *
     * @param shader - The shader that the glProgram will be based on.
     * @return A shiny new glProgram!
     */ ShaderSystem.prototype.generateProgram = function(shader) {
        var gl = this.gl;
        var program = shader.program;
        var glProgram = generateProgram(gl, program);
        program.glPrograms[this.renderer.CONTEXT_UID] = glProgram;
        return glProgram;
    };
    /** Resets ShaderSystem state, does not affect WebGL state. */ ShaderSystem.prototype.reset = function() {
        this.program = null;
        this.shader = null;
    };
    /** Destroys this System and removes all its textures. */ ShaderSystem.prototype.destroy = function() {
        this.renderer = null;
        // TODO implement destroy method for ShaderSystem
        this.destroyed = true;
    };
    return ShaderSystem;
}();
/**
 * Maps gl blend combinations to WebGL.
 *
 * @memberof PIXI
 * @function mapWebGLBlendModesToPixi
 * @private
 * @param {WebGLRenderingContext} gl - The rendering context.
 * @param {number[][]} [array=[]] - The array to output into.
 * @return {number[][]} Mapped modes.
 */ function mapWebGLBlendModesToPixi(gl, array) {
    if (array === void 0) array = [];
    // TODO - premultiply alpha would be different.
    // add a boolean for that!
    array[(0, $P8XPi.BLEND_MODES).NORMAL] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).ADD] = [
        gl.ONE,
        gl.ONE
    ];
    array[(0, $P8XPi.BLEND_MODES).MULTIPLY] = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).SCREEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).OVERLAY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DARKEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).LIGHTEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).COLOR_DODGE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).COLOR_BURN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).HARD_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).SOFT_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DIFFERENCE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).EXCLUSION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).HUE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).SATURATION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).COLOR] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).LUMINOSITY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).NONE] = [
        0,
        0
    ];
    // not-premultiplied blend modes
    array[(0, $P8XPi.BLEND_MODES).NORMAL_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).ADD_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ];
    array[(0, $P8XPi.BLEND_MODES).SCREEN_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    // composite operations
    array[(0, $P8XPi.BLEND_MODES).SRC_IN] = [
        gl.DST_ALPHA,
        gl.ZERO
    ];
    array[(0, $P8XPi.BLEND_MODES).SRC_OUT] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ZERO
    ];
    array[(0, $P8XPi.BLEND_MODES).SRC_ATOP] = [
        gl.DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_OVER] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_IN] = [
        gl.ZERO,
        gl.SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_OUT] = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_ATOP] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).XOR] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    // SUBTRACT from flash
    array[(0, $P8XPi.BLEND_MODES).SUBTRACT] = [
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.FUNC_REVERSE_SUBTRACT,
        gl.FUNC_ADD
    ];
    return array;
}
var BLEND$1 = 0;
var OFFSET$1 = 1;
var CULLING$1 = 2;
var DEPTH_TEST$1 = 3;
var WINDING$1 = 4;
var DEPTH_MASK$1 = 5;
/**
 * System plugin to the renderer to manage WebGL state machines.
 *
 * @memberof PIXI
 */ var StateSystem = /** @class */ function() {
    function StateSystem() {
        this.gl = null;
        this.stateId = 0;
        this.polygonOffset = 0;
        this.blendMode = (0, $P8XPi.BLEND_MODES).NONE;
        this._blendEq = false;
        // map functions for when we set state..
        this.map = [];
        this.map[BLEND$1] = this.setBlend;
        this.map[OFFSET$1] = this.setOffset;
        this.map[CULLING$1] = this.setCullFace;
        this.map[DEPTH_TEST$1] = this.setDepthTest;
        this.map[WINDING$1] = this.setFrontFace;
        this.map[DEPTH_MASK$1] = this.setDepthMask;
        this.checks = [];
        this.defaultState = new State();
        this.defaultState.blend = true;
    }
    StateSystem.prototype.contextChange = function(gl) {
        this.gl = gl;
        this.blendModes = mapWebGLBlendModesToPixi(gl);
        this.set(this.defaultState);
        this.reset();
    };
    /**
     * Sets the current state
     *
     * @param {*} state - The state to set.
     */ StateSystem.prototype.set = function(state) {
        state = state || this.defaultState;
        // TODO maybe to an object check? ( this.state === state )?
        if (this.stateId !== state.data) {
            var diff = this.stateId ^ state.data;
            var i = 0;
            // order from least to most common
            while(diff){
                if (diff & 1) // state change!
                this.map[i].call(this, !!(state.data & 1 << i));
                diff = diff >> 1;
                i++;
            }
            this.stateId = state.data;
        }
        // based on the above settings we check for specific modes..
        // for example if blend is active we check and set the blend modes
        // or of polygon offset is active we check the poly depth.
        for(var i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    };
    /**
     * Sets the state, when previous state is unknown.
     *
     * @param {*} state - The state to set
     */ StateSystem.prototype.forceState = function(state) {
        state = state || this.defaultState;
        for(var i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(var i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    };
    /**
     * Sets whether to enable or disable blending.
     *
     * @param value - Turn on or off WebGl blending.
     */ StateSystem.prototype.setBlend = function(value) {
        this.updateCheck(StateSystem.checkBlendMode, value);
        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
    };
    /**
     * Sets whether to enable or disable polygon offset fill.
     *
     * @param value - Turn on or off webgl polygon offset testing.
     */ StateSystem.prototype.setOffset = function(value) {
        this.updateCheck(StateSystem.checkPolygonOffset, value);
        this.gl[value ? 'enable' : 'disable'](this.gl.POLYGON_OFFSET_FILL);
    };
    /**
     * Sets whether to enable or disable depth test.
     *
     * @param value - Turn on or off webgl depth testing.
     */ StateSystem.prototype.setDepthTest = function(value) {
        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
    };
    /**
     * Sets whether to enable or disable depth mask.
     *
     * @param value - Turn on or off webgl depth mask.
     */ StateSystem.prototype.setDepthMask = function(value) {
        this.gl.depthMask(value);
    };
    /**
     * Sets whether to enable or disable cull face.
     *
     * @param {boolean} value - Turn on or off webgl cull face.
     */ StateSystem.prototype.setCullFace = function(value) {
        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
    };
    /**
     * Sets the gl front face.
     *
     * @param {boolean} value - true is clockwise and false is counter-clockwise
     */ StateSystem.prototype.setFrontFace = function(value) {
        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
    };
    /**
     * Sets the blend mode.
     *
     * @param {number} value - The blend mode to set to.
     */ StateSystem.prototype.setBlendMode = function(value) {
        if (value === this.blendMode) return;
        this.blendMode = value;
        var mode = this.blendModes[value];
        var gl = this.gl;
        if (mode.length === 2) gl.blendFunc(mode[0], mode[1]);
        else gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
        if (mode.length === 6) {
            this._blendEq = true;
            gl.blendEquationSeparate(mode[4], mode[5]);
        } else if (this._blendEq) {
            this._blendEq = false;
            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
        }
    };
    /**
     * Sets the polygon offset.
     *
     * @param {number} value - the polygon offset
     * @param {number} scale - the polygon offset scale
     */ StateSystem.prototype.setPolygonOffset = function(value, scale) {
        this.gl.polygonOffset(value, scale);
    };
    // used
    /** Resets all the logic and disables the VAOs. */ StateSystem.prototype.reset = function() {
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
        this.forceState(this.defaultState);
        this._blendEq = true;
        this.blendMode = -1;
        this.setBlendMode(0);
    };
    /**
     * Checks to see which updates should be checked based on which settings have been activated.
     *
     * For example, if blend is enabled then we should check the blend modes each time the state is changed
     * or if polygon fill is activated then we need to check if the polygon offset changes.
     * The idea is that we only check what we have too.
     *
     * @param func - the checking function to add or remove
     * @param value - should the check function be added or removed.
     */ StateSystem.prototype.updateCheck = function(func, value) {
        var index = this.checks.indexOf(func);
        if (value && index === -1) this.checks.push(func);
        else if (!value && index !== -1) this.checks.splice(index, 1);
    };
    /**
     * A private little wrapper function that we call to check the blend mode.
     *
     * @param System - the System to perform the state check on
     * @param state - the state that the blendMode will pulled from
     */ StateSystem.checkBlendMode = function(system, state) {
        system.setBlendMode(state.blendMode);
    };
    /**
     * A private little wrapper function that we call to check the polygon offset.
     *
     * @param System - the System to perform the state check on
     * @param state - the state that the blendMode will pulled from
     */ StateSystem.checkPolygonOffset = function(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    };
    /**
     * @ignore
     */ StateSystem.prototype.destroy = function() {
        this.gl = null;
    };
    return StateSystem;
}();
/**
 * System plugin to the renderer to manage texture garbage collection on the GPU,
 * ensuring that it does not get clogged up with textures that are no longer being used.
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.System
 */ var TextureGCSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function TextureGCSystem(renderer) {
        this.renderer = renderer;
        /**
         * Count
         * @member {number}
         * @readonly
         */ this.count = 0;
        /**
         * Check count
         * @member {number}
         * @readonly
         */ this.checkCount = 0;
        /**
         * Maximum idle time, in seconds
         * @member {number}
         * @see PIXI.settings.GC_MAX_IDLE
         */ this.maxIdle = (0, $ezJmd.settings).GC_MAX_IDLE;
        /**
         * Maximum number of item to check
         * @member {number}
         * @see PIXI.settings.GC_MAX_CHECK_COUNT
         */ this.checkCountMax = (0, $ezJmd.settings).GC_MAX_CHECK_COUNT;
        /**
         * Current garbage collection mode
         * @member {PIXI.GC_MODES}
         * @see PIXI.settings.GC_MODE
         */ this.mode = (0, $ezJmd.settings).GC_MODE;
    }
    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */ TextureGCSystem.prototype.postrender = function() {
        if (!this.renderer.renderingToScreen) return;
        this.count++;
        if (this.mode === (0, $P8XPi.GC_MODES).MANUAL) return;
        this.checkCount++;
        if (this.checkCount > this.checkCountMax) {
            this.checkCount = 0;
            this.run();
        }
    };
    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */ TextureGCSystem.prototype.run = function() {
        var tm = this.renderer.texture;
        var managedTextures = tm.managedTextures;
        var wasRemoved = false;
        for(var i = 0; i < managedTextures.length; i++){
            var texture = managedTextures[i];
            // only supports non generated textures at the moment!
            if (!texture.framebuffer && this.count - texture.touched > this.maxIdle) {
                tm.destroyTexture(texture, true);
                managedTextures[i] = null;
                wasRemoved = true;
            }
        }
        if (wasRemoved) {
            var j = 0;
            for(var i = 0; i < managedTextures.length; i++)if (managedTextures[i] !== null) managedTextures[j++] = managedTextures[i];
            managedTextures.length = j;
        }
    };
    /**
     * Removes all the textures within the specified displayObject and its children from the GPU
     *
     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
     */ TextureGCSystem.prototype.unload = function(displayObject) {
        var tm = this.renderer.texture;
        var texture = displayObject._texture;
        // only destroy non generated textures
        if (texture && !texture.framebuffer) tm.destroyTexture(texture);
        for(var i = displayObject.children.length - 1; i >= 0; i--)this.unload(displayObject.children[i]);
    };
    /**
     * @ignore
     */ TextureGCSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return TextureGCSystem;
}();
/**
 * Returns a lookup table that maps each type-format pair to a compatible internal format.
 *
 * @memberof PIXI
 * @function mapTypeAndFormatToInternalFormat
 * @private
 * @param {WebGLRenderingContext} gl - The rendering context.
 * @return {{ [type: number]: { [format: number]: number } }} Lookup table.
 */ function mapTypeAndFormatToInternalFormat(gl) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var table;
    if ('WebGL2RenderingContext' in self && gl instanceof self.WebGL2RenderingContext) table = (_a = {}, _a[(0, $P8XPi.TYPES).UNSIGNED_BYTE] = (_b = {}, _b[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA8, _b[(0, $P8XPi.FORMATS).RGB] = gl.RGB8, _b[(0, $P8XPi.FORMATS).RG] = gl.RG8, _b[(0, $P8XPi.FORMATS).RED] = gl.R8, _b[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA8UI, _b[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB8UI, _b[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG8UI, _b[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R8UI, _b[(0, $P8XPi.FORMATS).ALPHA] = gl.ALPHA, _b[(0, $P8XPi.FORMATS).LUMINANCE] = gl.LUMINANCE, _b[(0, $P8XPi.FORMATS).LUMINANCE_ALPHA] = gl.LUMINANCE_ALPHA, _b), _a[(0, $P8XPi.TYPES).BYTE] = (_c = {}, _c[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA8_SNORM, _c[(0, $P8XPi.FORMATS).RGB] = gl.RGB8_SNORM, _c[(0, $P8XPi.FORMATS).RG] = gl.RG8_SNORM, _c[(0, $P8XPi.FORMATS).RED] = gl.R8_SNORM, _c[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA8I, _c[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB8I, _c[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG8I, _c[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R8I, _c), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT] = (_d = {}, _d[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA16UI, _d[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB16UI, _d[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG16UI, _d[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R16UI, _d[(0, $P8XPi.FORMATS).DEPTH_COMPONENT] = gl.DEPTH_COMPONENT16, _d), _a[(0, $P8XPi.TYPES).SHORT] = (_e = {}, _e[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA16I, _e[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB16I, _e[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG16I, _e[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R16I, _e), _a[(0, $P8XPi.TYPES).UNSIGNED_INT] = (_f = {}, _f[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA32UI, _f[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB32UI, _f[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG32UI, _f[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R32UI, _f[(0, $P8XPi.FORMATS).DEPTH_COMPONENT] = gl.DEPTH_COMPONENT24, _f), _a[(0, $P8XPi.TYPES).INT] = (_g = {}, _g[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA32I, _g[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB32I, _g[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG32I, _g[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R32I, _g), _a[(0, $P8XPi.TYPES).FLOAT] = (_h = {}, _h[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA32F, _h[(0, $P8XPi.FORMATS).RGB] = gl.RGB32F, _h[(0, $P8XPi.FORMATS).RG] = gl.RG32F, _h[(0, $P8XPi.FORMATS).RED] = gl.R32F, _h[(0, $P8XPi.FORMATS).DEPTH_COMPONENT] = gl.DEPTH_COMPONENT32F, _h), _a[(0, $P8XPi.TYPES).HALF_FLOAT] = (_j = {}, _j[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA16F, _j[(0, $P8XPi.FORMATS).RGB] = gl.RGB16F, _j[(0, $P8XPi.FORMATS).RG] = gl.RG16F, _j[(0, $P8XPi.FORMATS).RED] = gl.R16F, _j), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_6_5] = (_k = {}, _k[(0, $P8XPi.FORMATS).RGB] = gl.RGB565, _k), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT_4_4_4_4] = (_l = {}, _l[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA4, _l), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_5_5_1] = (_m = {}, _m[(0, $P8XPi.FORMATS).RGBA] = gl.RGB5_A1, _m), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_2_10_10_10_REV] = (_o = {}, _o[(0, $P8XPi.FORMATS).RGBA] = gl.RGB10_A2, _o[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGB10_A2UI, _o), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_10F_11F_11F_REV] = (_p = {}, _p[(0, $P8XPi.FORMATS).RGB] = gl.R11F_G11F_B10F, _p), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_5_9_9_9_REV] = (_q = {}, _q[(0, $P8XPi.FORMATS).RGB] = gl.RGB9_E5, _q), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_24_8] = (_r = {}, _r[(0, $P8XPi.FORMATS).DEPTH_STENCIL] = gl.DEPTH24_STENCIL8, _r), _a[(0, $P8XPi.TYPES).FLOAT_32_UNSIGNED_INT_24_8_REV] = (_s = {}, _s[(0, $P8XPi.FORMATS).DEPTH_STENCIL] = gl.DEPTH32F_STENCIL8, _s), _a);
    else table = (_t = {}, _t[(0, $P8XPi.TYPES).UNSIGNED_BYTE] = (_u = {}, _u[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA, _u[(0, $P8XPi.FORMATS).RGB] = gl.RGB, _u[(0, $P8XPi.FORMATS).ALPHA] = gl.ALPHA, _u[(0, $P8XPi.FORMATS).LUMINANCE] = gl.LUMINANCE, _u[(0, $P8XPi.FORMATS).LUMINANCE_ALPHA] = gl.LUMINANCE_ALPHA, _u), _t[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_6_5] = (_v = {}, _v[(0, $P8XPi.FORMATS).RGB] = gl.RGB, _v), _t[(0, $P8XPi.TYPES).UNSIGNED_SHORT_4_4_4_4] = (_w = {}, _w[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA, _w), _t[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_5_5_1] = (_x = {}, _x[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA, _x), _t);
    return table;
}
/**
 * Internal texture for WebGL context
 * @class
 * @memberof PIXI
 */ var GLTexture = /** @class */ function() {
    function GLTexture(texture) {
        /**
         * The WebGL texture
         * @member {WebGLTexture}
         */ this.texture = texture;
        /**
         * Width of texture that was used in texImage2D
         * @member {number}
         */ this.width = -1;
        /**
         * Height of texture that was used in texImage2D
         * @member {number}
         */ this.height = -1;
        /**
         * Texture contents dirty flag
         * @member {number}
         */ this.dirtyId = -1;
        /**
         * Texture style dirty flag
         * @member {number}
         */ this.dirtyStyleId = -1;
        /**
         * Whether mip levels has to be generated
         * @member {boolean}
         */ this.mipmap = false;
        /**
         * WrapMode copied from baseTexture
         * @member {number}
         */ this.wrapMode = 33071;
        /**
         * Type copied from baseTexture
         * @member {number}
         */ this.type = (0, $P8XPi.TYPES).UNSIGNED_BYTE;
        /**
         * Type copied from baseTexture
         * @member {number}
         */ this.internalFormat = (0, $P8XPi.FORMATS).RGBA;
        this.samplerType = 0;
    }
    return GLTexture;
}();
/**
 * System plugin to the renderer to manage textures.
 *
 * @class
 * @extends PIXI.System
 * @memberof PIXI
 */ var TextureSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function TextureSystem(renderer) {
        this.renderer = renderer;
        // TODO set to max textures...
        /**
         * Bound textures
         * @member {PIXI.BaseTexture[]}
         * @readonly
         */ this.boundTextures = [];
        /**
         * Current location
         * @member {number}
         * @readonly
         */ this.currentLocation = -1;
        /**
         * List of managed textures
         * @member {PIXI.BaseTexture[]}
         * @readonly
         */ this.managedTextures = [];
        /**
         * Did someone temper with textures state? We'll overwrite them when we need to unbind something.
         * @member {boolean}
         * @private
         */ this._unknownBoundTextures = false;
        /**
         * BaseTexture value that shows that we don't know what is bound
         * @member {PIXI.BaseTexture}
         * @readonly
         */ this.unknownTexture = new BaseTexture();
        this.hasIntegerTextures = false;
    }
    /**
     * Sets up the renderer context and necessary buffers.
     */ TextureSystem.prototype.contextChange = function() {
        var gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.webGLVersion = this.renderer.context.webGLVersion;
        this.internalFormats = mapTypeAndFormatToInternalFormat(gl);
        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.boundTextures.length = maxTextures;
        for(var i = 0; i < maxTextures; i++)this.boundTextures[i] = null;
        // TODO move this.. to a nice make empty textures class..
        this.emptyTextures = {};
        var emptyTexture2D = new GLTexture(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4));
        this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D;
        this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new GLTexture(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
        for(var i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for(var i = 0; i < this.boundTextures.length; i++)this.bind(null, i);
    };
    /**
     * Bind a texture to a specific location
     *
     * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
     *
     * @param {PIXI.Texture|PIXI.BaseTexture} texture_ - Texture to bind
     * @param {number} [location=0] - Location to bind at
     */ TextureSystem.prototype.bind = function(texture, location) {
        if (location === void 0) location = 0;
        var gl = this.gl;
        texture = texture === null || texture === void 0 ? void 0 : texture.castToBaseTexture();
        // cannot bind partial texture
        // TODO: report a warning
        if (texture && texture.valid && !texture.parentTextureArray) {
            texture.touched = this.renderer.textureGC.count;
            var glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
            if (this.boundTextures[location] !== texture) {
                if (this.currentLocation !== location) {
                    this.currentLocation = location;
                    gl.activeTexture(gl.TEXTURE0 + location);
                }
                gl.bindTexture(texture.target, glTexture.texture);
            }
            if (glTexture.dirtyId !== texture.dirtyId) {
                if (this.currentLocation !== location) {
                    this.currentLocation = location;
                    gl.activeTexture(gl.TEXTURE0 + location);
                }
                this.updateTexture(texture);
            }
            this.boundTextures[location] = texture;
        } else {
            if (this.currentLocation !== location) {
                this.currentLocation = location;
                gl.activeTexture(gl.TEXTURE0 + location);
            }
            gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture);
            this.boundTextures[location] = null;
        }
    };
    /**
     * Resets texture location and bound textures
     *
     * Actual `bind(null, i)` calls will be performed at next `unbind()` call
     */ TextureSystem.prototype.reset = function() {
        this._unknownBoundTextures = true;
        this.hasIntegerTextures = false;
        this.currentLocation = -1;
        for(var i = 0; i < this.boundTextures.length; i++)this.boundTextures[i] = this.unknownTexture;
    };
    /**
     * Unbind a texture
     * @param {PIXI.BaseTexture} texture - Texture to bind
     */ TextureSystem.prototype.unbind = function(texture) {
        var _a = this, gl = _a.gl, boundTextures = _a.boundTextures;
        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = false;
            // someone changed webGL state,
            // we have to be sure that our texture does not appear in multi-texture renderer samplers
            for(var i = 0; i < boundTextures.length; i++)if (boundTextures[i] === this.unknownTexture) this.bind(null, i);
        }
        for(var i = 0; i < boundTextures.length; i++)if (boundTextures[i] === texture) {
            if (this.currentLocation !== i) {
                gl.activeTexture(gl.TEXTURE0 + i);
                this.currentLocation = i;
            }
            gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture);
            boundTextures[i] = null;
        }
    };
    /**
     * Ensures that current boundTextures all have FLOAT sampler type,
     * see {@link PIXI.SAMPLER_TYPES} for explanation.
     *
     * @param maxTextures - number of locations to check
     */ TextureSystem.prototype.ensureSamplerType = function(maxTextures) {
        var _a = this, boundTextures = _a.boundTextures, hasIntegerTextures = _a.hasIntegerTextures, CONTEXT_UID = _a.CONTEXT_UID;
        if (!hasIntegerTextures) return;
        for(var i = maxTextures - 1; i >= 0; --i){
            var tex = boundTextures[i];
            if (tex) {
                var glTexture = tex._glTextures[CONTEXT_UID];
                if (glTexture.samplerType !== (0, $P8XPi.SAMPLER_TYPES).FLOAT) this.renderer.texture.unbind(tex);
            }
        }
    };
    /**
     * Initialize a texture
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to initialize
     */ TextureSystem.prototype.initTexture = function(texture) {
        var glTexture = new GLTexture(this.gl.createTexture());
        // guarantee an update..
        glTexture.dirtyId = -1;
        texture._glTextures[this.CONTEXT_UID] = glTexture;
        this.managedTextures.push(texture);
        texture.on('dispose', this.destroyTexture, this);
        return glTexture;
    };
    TextureSystem.prototype.initTextureType = function(texture, glTexture) {
        var _a, _b;
        glTexture.internalFormat = (_b = (_a = this.internalFormats[texture.type]) === null || _a === void 0 ? void 0 : _a[texture.format]) !== null && _b !== void 0 ? _b : texture.format;
        if (this.webGLVersion === 2 && texture.type === (0, $P8XPi.TYPES).HALF_FLOAT) // TYPES.HALF_FLOAT is WebGL1 HALF_FLOAT_OES
        // we have to convert it to WebGL HALF_FLOAT
        glTexture.type = this.gl.HALF_FLOAT;
        else glTexture.type = texture.type;
    };
    /**
     * Update a texture
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to initialize
     */ TextureSystem.prototype.updateTexture = function(texture) {
        var glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        var renderer = this.renderer;
        this.initTextureType(texture, glTexture);
        if (texture.resource && texture.resource.upload(renderer, texture, glTexture)) // texture is uploaded, dont do anything!
        {
            if (glTexture.samplerType !== (0, $P8XPi.SAMPLER_TYPES).FLOAT) this.hasIntegerTextures = true;
        } else {
            // default, renderTexture-like logic
            var width = texture.realWidth;
            var height = texture.realHeight;
            var gl = renderer.gl;
            if (glTexture.width !== width || glTexture.height !== height || glTexture.dirtyId < 0) {
                glTexture.width = width;
                glTexture.height = height;
                gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null);
            }
        }
        // lets only update what changes..
        if (texture.dirtyStyleId !== glTexture.dirtyStyleId) this.updateTextureStyle(texture);
        glTexture.dirtyId = texture.dirtyId;
    };
    /**
     * Deletes the texture from WebGL
     *
     * @private
     * @param {PIXI.BaseTexture|PIXI.Texture} texture_ - the texture to destroy
     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
     */ TextureSystem.prototype.destroyTexture = function(texture, skipRemove) {
        var gl = this.gl;
        texture = texture.castToBaseTexture();
        if (texture._glTextures[this.CONTEXT_UID]) {
            this.unbind(texture);
            gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture);
            texture.off('dispose', this.destroyTexture, this);
            delete texture._glTextures[this.CONTEXT_UID];
            if (!skipRemove) {
                var i = this.managedTextures.indexOf(texture);
                if (i !== -1) (0, $csytw.removeItems)(this.managedTextures, i, 1);
            }
        }
    };
    /**
     * Update texture style such as mipmap flag
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to update
     */ TextureSystem.prototype.updateTextureStyle = function(texture) {
        var glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        if ((texture.mipmap === (0, $P8XPi.MIPMAP_MODES).POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo) glTexture.mipmap = false;
        else glTexture.mipmap = texture.mipmap >= 1;
        if (this.webGLVersion !== 2 && !texture.isPowerOfTwo) glTexture.wrapMode = (0, $P8XPi.WRAP_MODES).CLAMP;
        else glTexture.wrapMode = texture.wrapMode;
        if (texture.resource && texture.resource.style(this.renderer, texture, glTexture)) ;
        else this.setStyle(texture, glTexture);
        glTexture.dirtyStyleId = texture.dirtyStyleId;
    };
    /**
     * Set style for texture
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to update
     * @param {PIXI.GLTexture} glTexture
     */ TextureSystem.prototype.setStyle = function(texture, glTexture) {
        var gl = this.gl;
        if (glTexture.mipmap && texture.mipmap !== (0, $P8XPi.MIPMAP_MODES).ON_MANUAL) gl.generateMipmap(texture.target);
        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode);
        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode);
        if (glTexture.mipmap) {
            /* eslint-disable max-len */ gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
            /* eslint-disable max-len */ var anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR) {
                var level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
            }
        } else gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR ? gl.LINEAR : gl.NEAREST);
    };
    /**
     * @ignore
     */ TextureSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return TextureSystem;
}();
var _systems = {
    __proto__: null,
    FilterSystem: FilterSystem,
    BatchSystem: BatchSystem,
    ContextSystem: ContextSystem,
    FramebufferSystem: FramebufferSystem,
    GeometrySystem: GeometrySystem,
    MaskSystem: MaskSystem,
    ScissorSystem: ScissorSystem,
    StencilSystem: StencilSystem,
    ProjectionSystem: ProjectionSystem,
    RenderTextureSystem: RenderTextureSystem,
    ShaderSystem: ShaderSystem,
    StateSystem: StateSystem,
    TextureGCSystem: TextureGCSystem,
    TextureSystem: TextureSystem
};
var tempMatrix$2 = new (0, $6qzqq.Matrix)();
/**
 * The AbstractRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
 * and {@link PIXI.Renderer} which can be used for rendering a PixiJS scene.
 *
 * @abstract
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 */ var AbstractRenderer = /** @class */ function(_super) {
    __extends(AbstractRenderer, _super);
    /**
     * @param system - The name of the system this renderer is for.
     * @param [options] - The optional renderer parameters.
     * @param {number} [options.width=800] - The width of the screen.
     * @param {number} [options.height=600] - The height of the screen.
     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
     * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
     *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
     *   canvas needs to be opaque, possibly for performance reasons on some older devices.
     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
     *   resolutions other than 1.
     * @param {boolean} [options.antialias=false] - Sets antialias
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the WebGL context.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *      not before the new render pass.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
     */ function AbstractRenderer(type, options) {
        if (type === void 0) type = (0, $P8XPi.RENDERER_TYPE).UNKNOWN;
        var _this = _super.call(this) || this;
        // Add the default render options
        options = Object.assign({}, (0, $ezJmd.settings).RENDER_OPTIONS, options);
        /**
         * The supplied constructor options.
         *
         * @member {Object}
         * @readOnly
         */ _this.options = options;
        /**
         * The type of the renderer.
         *
         * @member {number}
         * @default PIXI.RENDERER_TYPE.UNKNOWN
         * @see PIXI.RENDERER_TYPE
         */ _this.type = type;
        /**
         * Measurements of the screen. (0, 0, screenWidth, screenHeight).
         *
         * Its safe to use as filterArea or hitArea for the whole stage.
         *
         * @member {PIXI.Rectangle}
         */ _this.screen = new (0, $6qzqq.Rectangle)(0, 0, options.width, options.height);
        /**
         * The canvas element that everything is drawn to.
         *
         * @member {HTMLCanvasElement}
         */ _this.view = options.view || document.createElement('canvas');
        /**
         * The resolution / device pixel ratio of the renderer.
         *
         * @member {number}
         * @default PIXI.settings.RESOLUTION
         */ _this.resolution = options.resolution || (0, $ezJmd.settings).RESOLUTION;
        /**
         * Pass-thru setting for the the canvas' context `alpha` property. This is typically
         * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
         *
         * @member {boolean}
         */ _this.useContextAlpha = options.useContextAlpha;
        /**
         * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
         *
         * @member {boolean}
         */ _this.autoDensity = !!options.autoDensity;
        /**
         * The value of the preserveDrawingBuffer flag affects whether or not the contents of
         * the stencil buffer is retained after rendering.
         *
         * @member {boolean}
         */ _this.preserveDrawingBuffer = options.preserveDrawingBuffer;
        /**
         * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
         * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
         * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
         * to clear the canvas every frame. Disable this by setting this to false. For example, if
         * your game has a canvas filling background image you often don't need this set.
         *
         * @member {boolean}
         * @default
         */ _this.clearBeforeRender = options.clearBeforeRender;
        /**
         * The background color as a number.
         *
         * @member {number}
         * @protected
         */ _this._backgroundColor = 0x000000;
        /**
         * The background color as an [R, G, B, A] array.
         *
         * @member {number[]}
         * @protected
         */ _this._backgroundColorRgba = [
            0,
            0,
            0,
            1
        ];
        /**
         * The background color as a string.
         *
         * @member {string}
         * @protected
         */ _this._backgroundColorString = '#000000';
        _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter
        _this.backgroundAlpha = options.backgroundAlpha;
        // @deprecated
        if (options.transparent !== undefined) {
            (0, $csytw.deprecation)('6.0.0', 'Option transparent is deprecated, please use backgroundAlpha instead.');
            _this.useContextAlpha = options.transparent;
            _this.backgroundAlpha = options.transparent ? 0 : 1;
        }
        /**
         * The last root object that the renderer tried to render.
         *
         * @member {PIXI.DisplayObject}
         * @protected
         */ _this._lastObjectRendered = null;
        /**
         * Collection of plugins.
         * @readonly
         * @member {object}
         */ _this.plugins = {};
        return _this;
    }
    /**
     * Initialize the plugins.
     *
     * @protected
     * @param {object} staticMap - The dictionary of statically saved plugins.
     */ AbstractRenderer.prototype.initPlugins = function(staticMap) {
        for(var o in staticMap)this.plugins[o] = new staticMap[o](this);
    };
    Object.defineProperty(AbstractRenderer.prototype, "width", {
        /**
         * Same as view.width, actual number of pixels in the canvas by horizontal.
         *
         * @member {number}
         * @readonly
         * @default 800
         */ get: function() {
            return this.view.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractRenderer.prototype, "height", {
        /**
         * Same as view.height, actual number of pixels in the canvas by vertical.
         *
         * @member {number}
         * @readonly
         * @default 600
         */ get: function() {
            return this.view.height;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Resizes the screen and canvas as close as possible to the specified width and height.
     * Canvas dimensions are multiplied by resolution and rounded to the nearest integers.
     * The new canvas dimensions divided by the resolution become the new screen dimensions.
     *
     * @param desiredScreenWidth - The desired width of the screen.
     * @param desiredScreenHeight - The desired height of the screen.
     */ AbstractRenderer.prototype.resize = function(desiredScreenWidth, desiredScreenHeight) {
        this.view.width = Math.round(desiredScreenWidth * this.resolution);
        this.view.height = Math.round(desiredScreenHeight * this.resolution);
        var screenWidth = this.view.width / this.resolution;
        var screenHeight = this.view.height / this.resolution;
        this.screen.width = screenWidth;
        this.screen.height = screenHeight;
        if (this.autoDensity) {
            this.view.style.width = screenWidth + "px";
            this.view.style.height = screenHeight + "px";
        }
        /**
         * Fired after view has been resized.
         *
         * @event PIXI.Renderer#resize
         * @param {number} screenWidth - The new width of the screen.
         * @param {number} screenHeight - The new height of the screen.
         */ this.emit('resize', screenWidth, screenHeight);
    };
    /**
     * @ignore
     */ AbstractRenderer.prototype.generateTexture = function(displayObject, options, resolution, region) {
        if (options === void 0) options = {};
        // @deprecated parameters spread, use options instead
        if (typeof options === 'number') {
            (0, $csytw.deprecation)('6.1.0', 'generateTexture options (scaleMode, resolution, region) are now object options.');
            options = {
                scaleMode: options,
                resolution: resolution,
                region: region
            };
        }
        var manualRegion = options.region, textureOptions = __rest(options, [
            "region"
        ]);
        region = manualRegion || displayObject.getLocalBounds(null, true);
        // minimum texture size is 1x1, 0x0 will throw an error
        if (region.width === 0) region.width = 1;
        if (region.height === 0) region.height = 1;
        var renderTexture = RenderTexture.create(__assign({
            width: region.width,
            height: region.height
        }, textureOptions));
        tempMatrix$2.tx = -region.x;
        tempMatrix$2.ty = -region.y;
        this.render(displayObject, {
            renderTexture: renderTexture,
            clear: false,
            transform: tempMatrix$2,
            skipUpdateTransform: !!displayObject.parent
        });
        return renderTexture;
    };
    /**
     * Removes everything from the renderer and optionally removes the Canvas DOM element.
     *
     * @param [removeView=false] - Removes the Canvas element from the DOM.
     */ AbstractRenderer.prototype.destroy = function(removeView) {
        for(var o in this.plugins){
            this.plugins[o].destroy();
            this.plugins[o] = null;
        }
        if (removeView && this.view.parentNode) this.view.parentNode.removeChild(this.view);
        var thisAny = this;
        // null-ing all objects, that's a tradition!
        thisAny.plugins = null;
        thisAny.type = (0, $P8XPi.RENDERER_TYPE).UNKNOWN;
        thisAny.view = null;
        thisAny.screen = null;
        thisAny._tempDisplayObjectParent = null;
        thisAny.options = null;
        this._backgroundColorRgba = null;
        this._backgroundColorString = null;
        this._lastObjectRendered = null;
    };
    Object.defineProperty(AbstractRenderer.prototype, "backgroundColor", {
        /**
         * The background color to fill if not transparent
         *
         * @member {number}
         */ get: function() {
            return this._backgroundColor;
        },
        set: function(value) {
            this._backgroundColor = value;
            this._backgroundColorString = (0, $csytw.hex2string)(value);
            (0, $csytw.hex2rgb)(value, this._backgroundColorRgba);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractRenderer.prototype, "backgroundAlpha", {
        /**
         * The background color alpha. Setting this to 0 will make the canvas transparent.
         *
         * @member {number}
         */ get: function() {
            return this._backgroundColorRgba[3];
        },
        set: function(value) {
            this._backgroundColorRgba[3] = value;
        },
        enumerable: false,
        configurable: true
    });
    return AbstractRenderer;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
var GLBuffer = /** @class */ function() {
    function GLBuffer(buffer) {
        this.buffer = buffer || null;
        this.updateID = -1;
        this.byteLength = -1;
        this.refCount = 0;
    }
    return GLBuffer;
}();
/**
 * System plugin to the renderer to manage buffers.
 *
 * WebGL uses Buffers as a way to store objects to the GPU.
 * This system makes working with them a lot easier.
 *
 * Buffers are used in three main places in WebGL
 * - geometry information
 * - Uniform information (via uniform buffer objects - a WebGL 2 only feature)
 * - Transform feedback information. (WebGL 2 only feature)
 *
 * This system will handle the binding of buffers to the GPU as well as uploading
 * them. With this system, you never need to work directly with GPU buffers, but instead work with
 * the PIXI.Buffer class.
 *
 *
 * @class
 * @memberof PIXI
 */ var BufferSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function BufferSystem(renderer) {
        this.renderer = renderer;
        this.managedBuffers = {};
        this.boundBufferBases = {};
    }
    /**
     * @ignore
     */ BufferSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    /**
     * Sets up the renderer context and necessary buffers.
     */ BufferSystem.prototype.contextChange = function() {
        this.disposeAll(true);
        this.gl = this.renderer.gl;
        // TODO fill out...
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    };
    /**
     * This binds specified buffer. On first run, it will create the webGL buffers for the context too
     *
     * @param buffer - the buffer to bind to the renderer
     */ BufferSystem.prototype.bind = function(buffer) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        var glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBuffer(buffer.type, glBuffer.buffer);
    };
    /**
     * Binds an uniform buffer to at the given index.
     *
     * A cache is used so a buffer will not be bound again if already bound.
     *
     * @param buffer - the buffer to bind
     * @param index - the base index to bind it to.
     */ BufferSystem.prototype.bindBufferBase = function(buffer, index) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        if (this.boundBufferBases[index] !== buffer) {
            var glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
            this.boundBufferBases[index] = buffer;
            gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    };
    /**
     * Binds a buffer whilst also binding its range.
     * This will make the buffer start from the offset supplied rather than 0 when it is read.
     *
     * @param buffer - the buffer to bind
     * @param index - the base index to bind at, defaults to 0
     * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
     */ BufferSystem.prototype.bindBufferRange = function(buffer, index, offset) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        offset = offset || 0;
        var glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, 256);
    };
    /**
     * Will ensure sure the the data in the buffer is uploaded to the GPU.
     *
     * @param {PIXI.Buffer} buffer - the buffer to update
     */ BufferSystem.prototype.update = function(buffer) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        var glBuffer = buffer._glBuffers[CONTEXT_UID];
        if (buffer._updateID === glBuffer.updateID) return;
        glBuffer.updateID = buffer._updateID;
        gl.bindBuffer(buffer.type, glBuffer.buffer);
        if (glBuffer.byteLength >= buffer.data.byteLength) // offset is always zero for now!
        gl.bufferSubData(buffer.type, 0, buffer.data);
        else {
            var drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
            glBuffer.byteLength = buffer.data.byteLength;
            gl.bufferData(buffer.type, buffer.data, drawType);
        }
    };
    /**
     * Disposes buffer
     * @param {PIXI.Buffer} buffer - buffer with data
     * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
     */ BufferSystem.prototype.dispose = function(buffer, contextLost) {
        if (!this.managedBuffers[buffer.id]) return;
        delete this.managedBuffers[buffer.id];
        var glBuffer = buffer._glBuffers[this.CONTEXT_UID];
        var gl = this.gl;
        buffer.disposeRunner.remove(this);
        if (!glBuffer) return;
        if (!contextLost) gl.deleteBuffer(glBuffer.buffer);
        delete buffer._glBuffers[this.CONTEXT_UID];
    };
    /**
     * dispose all WebGL resources of all managed buffers
     * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
     */ BufferSystem.prototype.disposeAll = function(contextLost) {
        var all = Object.keys(this.managedBuffers);
        for(var i = 0; i < all.length; i++)this.dispose(this.managedBuffers[all[i]], contextLost);
    };
    /**
     * creates and attaches a GLBuffer object tied to the current context.
     * @protected
     */ BufferSystem.prototype.createGLBuffer = function(buffer) {
        var _a = this, CONTEXT_UID = _a.CONTEXT_UID, gl = _a.gl;
        buffer._glBuffers[CONTEXT_UID] = new GLBuffer(gl.createBuffer());
        this.managedBuffers[buffer.id] = buffer;
        buffer.disposeRunner.add(this);
        return buffer._glBuffers[CONTEXT_UID];
    };
    return BufferSystem;
}();
/**
 * The Renderer draws the scene and all its content onto a WebGL enabled canvas.
 *
 * This renderer should be used for browsers that support WebGL.
 *
 * This renderer works by automatically managing WebGLBatchesm, so no need for Sprite Batches or Sprite Clouds.
 * Don't forget to add the view to your DOM or you will not see anything!
 *
 * Renderer is composed of systems that manage specific tasks. The following systems are added by default
 * whenever you create a renderer:
 *
 * | System                               | Description                                                                   |
 * | ------------------------------------ | ----------------------------------------------------------------------------- |
 * | {@link PIXI.BatchSystem}             | This manages object renderers that defer rendering until a flush.             |
 * | {@link PIXI.ContextSystem}           | This manages the WebGL context and extensions.                                |
 * | {@link PIXI.EventSystem}             | This manages UI events.                                                       |
 * | {@link PIXI.FilterSystem}            | This manages the filtering pipeline for post-processing effects.              |
 * | {@link PIXI.FramebufferSystem}       | This manages framebuffers, which are used for offscreen rendering.            |
 * | {@link PIXI.GeometrySystem}          | This manages geometries & buffers, which are used to draw object meshes.      |
 * | {@link PIXI.MaskSystem}              | This manages masking operations.                                              |
 * | {@link PIXI.ProjectionSystem}        | This manages the `projectionMatrix`, used by shaders to get NDC coordinates.  |
 * | {@link PIXI.RenderTextureSystem}     | This manages render-textures, which are an abstraction over framebuffers.     |
 * | {@link PIXI.ScissorSystem}           | This handles scissor masking, and is used internally by {@link MaskSystem}    |
 * | {@link PIXI.ShaderSystem}            | This manages shaders, programs that run on the GPU to calculate 'em pixels.   |
 * | {@link PIXI.StateSystem}             | This manages the WebGL state variables like blend mode, depth testing, etc.   |
 * | {@link PIXI.StencilSystem}           | This handles stencil masking, and is used internally by {@link MaskSystem}    |
 * | {@link PIXI.TextureSystem}           | This manages textures and their resources on the GPU.                         |
 * | {@link PIXI.TextureGCSystem}         | This will automatically remove textures from the GPU if they are not used.    |
 *
 * The breadth of the API surface provided by the renderer is contained within these systems.
 *
 * @memberof PIXI
 */ var Renderer = /** @class */ function(_super) {
    __extends(Renderer, _super);
    /**
     * @param [options] - The optional renderer parameters.
     * @param {number} [options.width=800] - The width of the screen.
     * @param {number} [options.height=600] - The height of the screen.
     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
     * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
     *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
     *   canvas needs to be opaque, possibly for performance reasons on some older devices.
     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
     *   resolutions other than 1.
     * @param {boolean} [options.antialias=false] - Sets antialias. If not available natively then FXAA
     *  antialiasing is used.
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
     *  preserveDrawingBuffer to `true`.
     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the WebGL context.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
     * @param {string} [options.powerPreference] - Parameter passed to WebGL context, set to "high-performance"
     *  for devices with dual graphics card.
     * @param {object} [options.context] - If WebGL context already exists, all parameters must be taken from it.
     */ function Renderer(options) {
        var _this = _super.call(this, (0, $P8XPi.RENDERER_TYPE).WEBGL, options) || this;
        // the options will have been modified here in the super constructor with pixi's default settings..
        options = _this.options;
        _this.gl = null;
        _this.CONTEXT_UID = 0;
        _this.runners = {
            destroy: new (0, $6fZag.Runner)('destroy'),
            contextChange: new (0, $6fZag.Runner)('contextChange'),
            reset: new (0, $6fZag.Runner)('reset'),
            update: new (0, $6fZag.Runner)('update'),
            postrender: new (0, $6fZag.Runner)('postrender'),
            prerender: new (0, $6fZag.Runner)('prerender'),
            resize: new (0, $6fZag.Runner)('resize')
        };
        _this.runners.contextChange.add(_this);
        _this.globalUniforms = new UniformGroup({
            projectionMatrix: new (0, $6qzqq.Matrix)()
        }, true);
        _this.addSystem(MaskSystem, 'mask').addSystem(ContextSystem, 'context').addSystem(StateSystem, 'state').addSystem(ShaderSystem, 'shader').addSystem(TextureSystem, 'texture').addSystem(BufferSystem, 'buffer').addSystem(GeometrySystem, 'geometry').addSystem(FramebufferSystem, 'framebuffer').addSystem(ScissorSystem, 'scissor').addSystem(StencilSystem, 'stencil').addSystem(ProjectionSystem, 'projection').addSystem(TextureGCSystem, 'textureGC').addSystem(FilterSystem, 'filter').addSystem(RenderTextureSystem, 'renderTexture').addSystem(BatchSystem, 'batch');
        _this.initPlugins(Renderer.__plugins);
        _this.multisample = undefined;
        /*
         * The options passed in to create a new WebGL context.
         */ if (options.context) _this.context.initFromContext(options.context);
        else _this.context.initFromOptions({
            alpha: !!_this.useContextAlpha,
            antialias: options.antialias,
            premultipliedAlpha: _this.useContextAlpha && _this.useContextAlpha !== 'notMultiplied',
            stencil: true,
            preserveDrawingBuffer: options.preserveDrawingBuffer,
            powerPreference: _this.options.powerPreference
        });
        _this.renderingToScreen = true;
        (0, $csytw.sayHello)(_this.context.webGLVersion === 2 ? 'WebGL 2' : 'WebGL 1');
        _this.resize(_this.options.width, _this.options.height);
        return _this;
    }
    /**
     * Create renderer if WebGL is available. Overrideable
     * by the **@pixi/canvas-renderer** package to allow fallback.
     * throws error if WebGL is not available.
     *
     * @private
     */ Renderer.create = function(options) {
        if ((0, $csytw.isWebGLSupported)()) return new Renderer(options);
        throw new Error('WebGL unsupported in this browser, use "pixi.js-legacy" for fallback canvas2d support.');
    };
    Renderer.prototype.contextChange = function() {
        var gl = this.gl;
        var samples;
        if (this.context.webGLVersion === 1) {
            var framebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            samples = gl.getParameter(gl.SAMPLES);
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        } else {
            var framebuffer = gl.getParameter(gl.DRAW_FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            samples = gl.getParameter(gl.SAMPLES);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, framebuffer);
        }
        if (samples >= (0, $P8XPi.MSAA_QUALITY).HIGH) this.multisample = (0, $P8XPi.MSAA_QUALITY).HIGH;
        else if (samples >= (0, $P8XPi.MSAA_QUALITY).MEDIUM) this.multisample = (0, $P8XPi.MSAA_QUALITY).MEDIUM;
        else if (samples >= (0, $P8XPi.MSAA_QUALITY).LOW) this.multisample = (0, $P8XPi.MSAA_QUALITY).LOW;
        else this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
    };
    /**
     * Add a new system to the renderer.
     * @param ClassRef - Class reference
     * @param [name] - Property name for system, if not specified
     *        will use a static `name` property on the class itself. This
     *        name will be assigned as s property on the Renderer so make
     *        sure it doesn't collide with properties on Renderer.
     * @return Return instance of renderer
     */ Renderer.prototype.addSystem = function(ClassRef, name) {
        var system = new ClassRef(this);
        if (this[name]) throw new Error("Whoops! The name \"" + name + "\" is already in use");
        this[name] = system;
        for(var i in this.runners)this.runners[i].add(system);
        /**
         * Fired after rendering finishes.
         *
         * @event PIXI.Renderer#postrender
         */ /**
         * Fired before rendering starts.
         *
         * @event PIXI.Renderer#prerender
         */ /**
         * Fired when the WebGL context is set.
         *
         * @event PIXI.Renderer#context
         * @param {WebGLRenderingContext} gl - WebGL context.
         */ return this;
    };
    /**
     * @ignore
     */ Renderer.prototype.render = function(displayObject, options) {
        var renderTexture;
        var clear;
        var transform;
        var skipUpdateTransform;
        if (options) {
            if (options instanceof RenderTexture) {
                (0, $csytw.deprecation)('6.0.0', 'Renderer#render arguments changed, use options instead.');
                /* eslint-disable prefer-rest-params */ renderTexture = options;
                clear = arguments[2];
                transform = arguments[3];
                skipUpdateTransform = arguments[4];
            /* eslint-enable prefer-rest-params */ } else {
                renderTexture = options.renderTexture;
                clear = options.clear;
                transform = options.transform;
                skipUpdateTransform = options.skipUpdateTransform;
            }
        }
        // can be handy to know!
        this.renderingToScreen = !renderTexture;
        this.runners.prerender.emit();
        this.emit('prerender');
        // apply a transform at a GPU level
        this.projection.transform = transform;
        // no point rendering if our context has been blown up!
        if (this.context.isLost) return;
        if (!renderTexture) this._lastObjectRendered = displayObject;
        if (!skipUpdateTransform) {
            // update the scene graph
            var cacheParent = displayObject.enableTempParent();
            displayObject.updateTransform();
            displayObject.disableTempParent(cacheParent);
        // displayObject.hitArea = //TODO add a temp hit area
        }
        this.renderTexture.bind(renderTexture);
        this.batch.currentRenderer.start();
        if (clear !== undefined ? clear : this.clearBeforeRender) this.renderTexture.clear();
        displayObject.render(this);
        // apply transform..
        this.batch.currentRenderer.flush();
        if (renderTexture) renderTexture.baseTexture.update();
        this.runners.postrender.emit();
        // reset transform after render
        this.projection.transform = null;
        this.emit('postrender');
    };
    /**
     * @override
     * @ignore
     */ Renderer.prototype.generateTexture = function(displayObject, options, resolution, region) {
        if (options === void 0) options = {};
        var renderTexture = _super.prototype.generateTexture.call(this, displayObject, options, resolution, region);
        this.framebuffer.blit();
        return renderTexture;
    };
    /**
     * Resizes the WebGL view to the specified width and height.
     *
     * @param desiredScreenWidth - The desired width of the screen.
     * @param desiredScreenHeight - The desired height of the screen.
     */ Renderer.prototype.resize = function(desiredScreenWidth, desiredScreenHeight) {
        _super.prototype.resize.call(this, desiredScreenWidth, desiredScreenHeight);
        this.runners.resize.emit(this.screen.height, this.screen.width);
    };
    /**
     * Resets the WebGL state so you can render things however you fancy!
     *
     * @return Returns itself.
     */ Renderer.prototype.reset = function() {
        this.runners.reset.emit();
        return this;
    };
    /** Clear the frame buffer. */ Renderer.prototype.clear = function() {
        this.renderTexture.bind();
        this.renderTexture.clear();
    };
    /**
     * Removes everything from the renderer (event listeners, spritebatch, etc...)
     *
     * @param [removeView=false] - Removes the Canvas element from the DOM.
     *  See: https://github.com/pixijs/pixi.js/issues/2233
     */ Renderer.prototype.destroy = function(removeView) {
        this.runners.destroy.emit();
        for(var r in this.runners)this.runners[r].destroy();
        // call base destroy
        _super.prototype.destroy.call(this, removeView);
        // TODO nullify all the managers..
        this.gl = null;
    };
    Object.defineProperty(Renderer.prototype, "extract", {
        /**
         * Please use `plugins.extract` instead.
         * @member {PIXI.Extract} extract
         * @deprecated since 6.0.0
         * @readonly
         */ get: function() {
            (0, $csytw.deprecation)('6.0.0', 'Renderer#extract has been deprecated, please use Renderer#plugins.extract instead.');
            return this.plugins.extract;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a plugin to the renderer.
     *
     * @param pluginName - The name of the plugin.
     * @param ctor - The constructor function or class for the plugin.
     */ Renderer.registerPlugin = function(pluginName, ctor) {
        Renderer.__plugins = Renderer.__plugins || {};
        Renderer.__plugins[pluginName] = ctor;
    };
    return Renderer;
}(AbstractRenderer);
/**
 * This helper function will automatically detect which renderer you should be using.
 * WebGL is the preferred renderer as it is a lot faster. If WebGL is not supported by
 * the browser then this function will return a canvas renderer
 *
 * @memberof PIXI
 * @function autoDetectRenderer
 * @param {object} [options] - The optional renderer parameters
 * @param {number} [options.width=800] - the width of the renderers view
 * @param {number} [options.height=600] - the height of the renderers view
 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
 * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
 *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
 *   canvas needs to be opaque, possibly for performance reasons on some older devices.
 * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
 *   resolutions other than 1
 * @param {boolean} [options.antialias=false] - sets antialias
 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
 *  need to call toDataUrl on the webgl context
 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
 *  (shown if not transparent).
 * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
 *   not before the new render pass.
 * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present, this
 *   option only is available when using **pixi.js-legacy** or **@pixi/canvas-renderer** modules, otherwise
 *   it is ignored.
 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
 *  for devices with dual graphics card **webgl only**
 * @return {PIXI.Renderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
 */ function autoDetectRenderer(options) {
    return Renderer.create(options);
}
var $defaultVertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}";
var $defaultFilterVertex = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";
/**
 * Default vertex shader
 * @memberof PIXI
 * @member {string} defaultVertex
 */ /**
 * Default filter vertex shader
 * @memberof PIXI
 * @member {string} defaultFilterVertex
 */ // NOTE: This black magic is so that @microsoft/api-extractor does not complain! This explicitly specifies the types
// of defaultVertex, defaultFilterVertex.
var defaultVertex$2 = $defaultVertex;
var defaultFilterVertex = $defaultFilterVertex;
/**
 * Use the ISystem interface instead.
 * @deprecated since 6.1.0
 * @memberof PIXI
 */ var System = /** @class */ function() {
    /**
     * @param renderer - Reference to Renderer
     */ function System(renderer) {
        (0, $csytw.deprecation)('6.1.0', 'System class is deprecated, implemement ISystem interface instead.');
        this.renderer = renderer;
    }
    /** Destroy and don't use after this. */ System.prototype.destroy = function() {
        this.renderer = null;
    };
    return System;
}();
/**
 * Used by the batcher to draw batches.
 * Each one of these contains all information required to draw a bound geometry.
 *
 * @memberof PIXI
 */ var BatchDrawCall = /** @class */ function() {
    function BatchDrawCall() {
        this.texArray = null;
        this.blend = 0;
        this.type = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        this.start = 0;
        this.size = 0;
        this.data = null;
    }
    return BatchDrawCall;
}();
/**
 * Used by the batcher to build texture batches.
 * Holds list of textures and their respective locations.
 *
 * @memberof PIXI
 */ var BatchTextureArray = /** @class */ function() {
    function BatchTextureArray() {
        this.elements = [];
        this.ids = [];
        this.count = 0;
    }
    BatchTextureArray.prototype.clear = function() {
        for(var i = 0; i < this.count; i++)this.elements[i] = null;
        this.count = 0;
    };
    return BatchTextureArray;
}();
/**
 * Flexible wrapper around `ArrayBuffer` that also provides typed array views on demand.
 *
 * @class
 * @memberof PIXI
 */ var ViewableBuffer = /** @class */ function() {
    function ViewableBuffer(sizeOrBuffer) {
        if (typeof sizeOrBuffer === 'number') /**
             * Underlying `ArrayBuffer` that holds all the data and is of capacity `this.size`.
             *
             * @member {ArrayBuffer}
             */ this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        /**
         * View on the raw binary data as a `Uint32Array`.
         *
         * @member {Uint32Array}
         */ this.uint32View = new Uint32Array(this.rawBinaryData);
        /**
         * View on the raw binary data as a `Float32Array`.
         *
         * @member {Float32Array}
         */ this.float32View = new Float32Array(this.rawBinaryData);
    }
    Object.defineProperty(ViewableBuffer.prototype, "int8View", {
        /**
         * View on the raw binary data as a `Int8Array`.
         *
         * @member {Int8Array}
         */ get: function() {
            if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
            return this._int8View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "uint8View", {
        /**
         * View on the raw binary data as a `Uint8Array`.
         *
         * @member {Uint8Array}
         */ get: function() {
            if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
            return this._uint8View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "int16View", {
        /**
         * View on the raw binary data as a `Int16Array`.
         *
         * @member {Int16Array}
         */ get: function() {
            if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
            return this._int16View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "uint16View", {
        /**
         * View on the raw binary data as a `Uint16Array`.
         *
         * @member {Uint16Array}
         */ get: function() {
            if (!this._uint16View) this._uint16View = new Uint16Array(this.rawBinaryData);
            return this._uint16View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "int32View", {
        /**
         * View on the raw binary data as a `Int32Array`.
         *
         * @member {Int32Array}
         */ get: function() {
            if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
            return this._int32View;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the view of the given type.
     *
     * @param {string} type - One of `int8`, `uint8`, `int16`,
     *    `uint16`, `int32`, `uint32`, and `float32`.
     * @return {object} typed array of given type
     */ ViewableBuffer.prototype.view = function(type) {
        return this[type + "View"];
    };
    /**
     * Destroys all buffer references. Do not use after calling
     * this.
     */ ViewableBuffer.prototype.destroy = function() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this._uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    };
    ViewableBuffer.sizeOf = function(type) {
        switch(type){
            case 'int8':
            case 'uint8':
                return 1;
            case 'int16':
            case 'uint16':
                return 2;
            case 'int32':
            case 'uint32':
            case 'float32':
                return 4;
            default:
                throw new Error(type + " isn't a valid view type");
        }
    };
    return ViewableBuffer;
}();
/**
 * Renderer dedicated to drawing and batching sprites.
 *
 * This is the default batch renderer. It buffers objects
 * with texture-based geometries and renders them in
 * batches. It uploads multiple textures to the GPU to
 * reduce to the number of draw calls.
 *
 * @memberof PIXI
 */ var AbstractBatchRenderer = /** @class */ function(_super) {
    __extends(AbstractBatchRenderer, _super);
    /**
     * This will hook onto the renderer's `contextChange`
     * and `prerender` signals.
     *
     * @param {PIXI.Renderer} renderer - The renderer this works for.
     */ function AbstractBatchRenderer(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.shaderGenerator = null;
        _this.geometryClass = null;
        _this.vertexSize = null;
        _this.state = State.for2d();
        _this.size = (0, $ezJmd.settings).SPRITE_BATCH_SIZE * 4;
        _this._vertexCount = 0;
        _this._indexCount = 0;
        _this._bufferedElements = [];
        _this._bufferedTextures = [];
        _this._bufferSize = 0;
        _this._shader = null;
        _this._packedGeometries = [];
        _this._packedGeometryPoolSize = 2;
        _this._flushId = 0;
        _this._aBuffers = {};
        _this._iBuffers = {};
        _this.MAX_TEXTURES = 1;
        _this.renderer.on('prerender', _this.onPrerender, _this);
        renderer.runners.contextChange.add(_this);
        _this._dcIndex = 0;
        _this._aIndex = 0;
        _this._iIndex = 0;
        _this._attributeBuffer = null;
        _this._indexBuffer = null;
        _this._tempBoundTextures = [];
        return _this;
    }
    /**
     * Handles the `contextChange` signal.
     *
     * It calculates `this.MAX_TEXTURES` and allocating the packed-geometry object pool.
     */ AbstractBatchRenderer.prototype.contextChange = function() {
        var gl = this.renderer.gl;
        if ((0, $ezJmd.settings).PREFER_ENV === (0, $P8XPi.ENV).WEBGL_LEGACY) this.MAX_TEXTURES = 1;
        else {
            // step 1: first check max textures the GPU can handle.
            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), (0, $ezJmd.settings).SPRITE_MAX_TEXTURES);
            // step 2: check the maximum number of if statements the shader can have too..
            this.MAX_TEXTURES = checkMaxIfStatementsInShader(this.MAX_TEXTURES, gl);
        }
        this._shader = this.shaderGenerator.generateShader(this.MAX_TEXTURES);
        // we use the second shader as the first one depending on your browser
        // may omit aTextureId as it is not used by the shader so is optimized out.
        for(var i = 0; i < this._packedGeometryPoolSize; i++)/* eslint-disable max-len */ this._packedGeometries[i] = new this.geometryClass();
        this.initFlushBuffers();
    };
    /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */ AbstractBatchRenderer.prototype.initFlushBuffers = function() {
        var _drawCallPool = AbstractBatchRenderer._drawCallPool, _textureArrayPool = AbstractBatchRenderer._textureArrayPool;
        // max draw calls
        var MAX_SPRITES = this.size / 4;
        // max texture arrays
        var MAX_TA = Math.floor(MAX_SPRITES / this.MAX_TEXTURES) + 1;
        while(_drawCallPool.length < MAX_SPRITES)_drawCallPool.push(new BatchDrawCall());
        while(_textureArrayPool.length < MAX_TA)_textureArrayPool.push(new BatchTextureArray());
        for(var i = 0; i < this.MAX_TEXTURES; i++)this._tempBoundTextures[i] = null;
    };
    /**
     * Handles the `prerender` signal.
     *
     * It ensures that flushes start from the first geometry object again.
     */ AbstractBatchRenderer.prototype.onPrerender = function() {
        this._flushId = 0;
    };
    /**
     * Buffers the "batchable" object. It need not be rendered immediately.
     *
     * @param {PIXI.DisplayObject} element - the element to render when
     *    using this renderer
     */ AbstractBatchRenderer.prototype.render = function(element) {
        if (!element._texture.valid) return;
        if (this._vertexCount + element.vertexData.length / 2 > this.size) this.flush();
        this._vertexCount += element.vertexData.length / 2;
        this._indexCount += element.indices.length;
        this._bufferedTextures[this._bufferSize] = element._texture.baseTexture;
        this._bufferedElements[this._bufferSize++] = element;
    };
    AbstractBatchRenderer.prototype.buildTexturesAndDrawCalls = function() {
        var _a = this, textures = _a._bufferedTextures, MAX_TEXTURES = _a.MAX_TEXTURES;
        var textureArrays = AbstractBatchRenderer._textureArrayPool;
        var batch = this.renderer.batch;
        var boundTextures = this._tempBoundTextures;
        var touch = this.renderer.textureGC.count;
        var TICK = ++BaseTexture._globalBatch;
        var countTexArrays = 0;
        var texArray = textureArrays[0];
        var start = 0;
        batch.copyBoundTextures(boundTextures, MAX_TEXTURES);
        for(var i = 0; i < this._bufferSize; ++i){
            var tex = textures[i];
            textures[i] = null;
            if (tex._batchEnabled === TICK) continue;
            if (texArray.count >= MAX_TEXTURES) {
                batch.boundArray(texArray, boundTextures, TICK, MAX_TEXTURES);
                this.buildDrawCalls(texArray, start, i);
                start = i;
                texArray = textureArrays[++countTexArrays];
                ++TICK;
            }
            tex._batchEnabled = TICK;
            tex.touched = touch;
            texArray.elements[texArray.count++] = tex;
        }
        if (texArray.count > 0) {
            batch.boundArray(texArray, boundTextures, TICK, MAX_TEXTURES);
            this.buildDrawCalls(texArray, start, this._bufferSize);
            ++countTexArrays;
            ++TICK;
        }
        // Clean-up
        for(var i = 0; i < boundTextures.length; i++)boundTextures[i] = null;
        BaseTexture._globalBatch = TICK;
    };
    /** Populating drawcalls for rendering */ AbstractBatchRenderer.prototype.buildDrawCalls = function(texArray, start, finish) {
        var _a = this, elements = _a._bufferedElements, _attributeBuffer = _a._attributeBuffer, _indexBuffer = _a._indexBuffer, vertexSize = _a.vertexSize;
        var drawCalls = AbstractBatchRenderer._drawCallPool;
        var dcIndex = this._dcIndex;
        var aIndex = this._aIndex;
        var iIndex = this._iIndex;
        var drawCall = drawCalls[dcIndex];
        drawCall.start = this._iIndex;
        drawCall.texArray = texArray;
        for(var i = start; i < finish; ++i){
            var sprite = elements[i];
            var tex = sprite._texture.baseTexture;
            var spriteBlendMode = (0, $csytw.premultiplyBlendMode)[tex.alphaMode ? 1 : 0][sprite.blendMode];
            elements[i] = null;
            if (start < i && drawCall.blend !== spriteBlendMode) {
                drawCall.size = iIndex - drawCall.start;
                start = i;
                drawCall = drawCalls[++dcIndex];
                drawCall.texArray = texArray;
                drawCall.start = iIndex;
            }
            this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex);
            aIndex += sprite.vertexData.length / 2 * vertexSize;
            iIndex += sprite.indices.length;
            drawCall.blend = spriteBlendMode;
        }
        if (start < finish) {
            drawCall.size = iIndex - drawCall.start;
            ++dcIndex;
        }
        this._dcIndex = dcIndex;
        this._aIndex = aIndex;
        this._iIndex = iIndex;
    };
    /** Bind textures for current rendering */ AbstractBatchRenderer.prototype.bindAndClearTexArray = function(texArray) {
        var textureSystem = this.renderer.texture;
        for(var j = 0; j < texArray.count; j++){
            textureSystem.bind(texArray.elements[j], texArray.ids[j]);
            texArray.elements[j] = null;
        }
        texArray.count = 0;
    };
    AbstractBatchRenderer.prototype.updateGeometry = function() {
        var _a = this, packedGeometries = _a._packedGeometries, attributeBuffer = _a._attributeBuffer, indexBuffer = _a._indexBuffer;
        if (!(0, $ezJmd.settings).CAN_UPLOAD_SAME_BUFFER) {
            if (this._packedGeometryPoolSize <= this._flushId) {
                this._packedGeometryPoolSize++;
                packedGeometries[this._flushId] = new this.geometryClass();
            }
            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
            this.renderer.geometry.bind(packedGeometries[this._flushId]);
            this.renderer.geometry.updateBuffers();
            this._flushId++;
        } else {
            // lets use the faster option, always use buffer number 0
            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
            this.renderer.geometry.updateBuffers();
        }
    };
    AbstractBatchRenderer.prototype.drawBatches = function() {
        var dcCount = this._dcIndex;
        var _a = this.renderer, gl = _a.gl, stateSystem = _a.state;
        var drawCalls = AbstractBatchRenderer._drawCallPool;
        var curTexArray = null;
        // Upload textures and do the draw calls
        for(var i = 0; i < dcCount; i++){
            var _b = drawCalls[i], texArray = _b.texArray, type = _b.type, size = _b.size, start = _b.start, blend = _b.blend;
            if (curTexArray !== texArray) {
                curTexArray = texArray;
                this.bindAndClearTexArray(texArray);
            }
            this.state.blendMode = blend;
            stateSystem.set(this.state);
            gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
        }
    };
    /** Renders the content _now_ and empties the current batch. */ AbstractBatchRenderer.prototype.flush = function() {
        if (this._vertexCount === 0) return;
        this._attributeBuffer = this.getAttributeBuffer(this._vertexCount);
        this._indexBuffer = this.getIndexBuffer(this._indexCount);
        this._aIndex = 0;
        this._iIndex = 0;
        this._dcIndex = 0;
        this.buildTexturesAndDrawCalls();
        this.updateGeometry();
        this.drawBatches();
        // reset elements buffer for the next flush
        this._bufferSize = 0;
        this._vertexCount = 0;
        this._indexCount = 0;
    };
    /** Starts a new sprite batch. */ AbstractBatchRenderer.prototype.start = function() {
        this.renderer.state.set(this.state);
        this.renderer.texture.ensureSamplerType(this.MAX_TEXTURES);
        this.renderer.shader.bind(this._shader);
        if ((0, $ezJmd.settings).CAN_UPLOAD_SAME_BUFFER) // bind buffer #0, we don't need others
        this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    };
    /** Stops and flushes the current batch. */ AbstractBatchRenderer.prototype.stop = function() {
        this.flush();
    };
    /** Destroys this `AbstractBatchRenderer`. It cannot be used again. */ AbstractBatchRenderer.prototype.destroy = function() {
        for(var i = 0; i < this._packedGeometryPoolSize; i++)if (this._packedGeometries[i]) this._packedGeometries[i].destroy();
        this.renderer.off('prerender', this.onPrerender, this);
        this._aBuffers = null;
        this._iBuffers = null;
        this._packedGeometries = null;
        this._attributeBuffer = null;
        this._indexBuffer = null;
        if (this._shader) {
            this._shader.destroy();
            this._shader = null;
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
     *
     * @param size - minimum capacity required
     * @return - buffer than can hold atleast `size` floats
     */ AbstractBatchRenderer.prototype.getAttributeBuffer = function(size) {
        // 8 vertices is enough for 2 quads
        var roundedP2 = (0, $csytw.nextPow2)(Math.ceil(size / 8));
        var roundedSizeIndex = (0, $csytw.log2)(roundedP2);
        var roundedSize = roundedP2 * 8;
        if (this._aBuffers.length <= roundedSizeIndex) this._iBuffers.length = roundedSizeIndex + 1;
        var buffer = this._aBuffers[roundedSize];
        if (!buffer) this._aBuffers[roundedSize] = buffer = new ViewableBuffer(roundedSize * this.vertexSize * 4);
        return buffer;
    };
    /**
     * Fetches an index buffer from `this._iBuffers` that can
     * have at least `size` capacity.
     *
     * @param size - minimum required capacity
     * @return - buffer that can fit `size` indices.
     */ AbstractBatchRenderer.prototype.getIndexBuffer = function(size) {
        // 12 indices is enough for 2 quads
        var roundedP2 = (0, $csytw.nextPow2)(Math.ceil(size / 12));
        var roundedSizeIndex = (0, $csytw.log2)(roundedP2);
        var roundedSize = roundedP2 * 12;
        if (this._iBuffers.length <= roundedSizeIndex) this._iBuffers.length = roundedSizeIndex + 1;
        var buffer = this._iBuffers[roundedSizeIndex];
        if (!buffer) this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize);
        return buffer;
    };
    /**
     * Takes the four batching parameters of `element`, interleaves
     * and pushes them into the batching attribute/index buffers given.
     *
     * It uses these properties: `vertexData` `uvs`, `textureId` and
     * `indicies`. It also uses the "tint" of the base-texture, if
     * present.
     *
     * @param {PIXI.DisplayObject} element - element being rendered
     * @param attributeBuffer - attribute buffer.
     * @param indexBuffer - index buffer
     * @param aIndex - number of floats already in the attribute buffer
     * @param iIndex - number of indices already in `indexBuffer`
     */ AbstractBatchRenderer.prototype.packInterleavedGeometry = function(element, attributeBuffer, indexBuffer, aIndex, iIndex) {
        var uint32View = attributeBuffer.uint32View, float32View = attributeBuffer.float32View;
        var packedVertices = aIndex / this.vertexSize;
        var uvs = element.uvs;
        var indicies = element.indices;
        var vertexData = element.vertexData;
        var textureId = element._texture.baseTexture._batchLocation;
        var alpha = Math.min(element.worldAlpha, 1.0);
        var argb = alpha < 1.0 && element._texture.baseTexture.alphaMode ? (0, $csytw.premultiplyTint)(element._tintRGB, alpha) : element._tintRGB + (alpha * 255 << 24);
        // lets not worry about tint! for now..
        for(var i = 0; i < vertexData.length; i += 2){
            float32View[aIndex++] = vertexData[i];
            float32View[aIndex++] = vertexData[i + 1];
            float32View[aIndex++] = uvs[i];
            float32View[aIndex++] = uvs[i + 1];
            uint32View[aIndex++] = argb;
            float32View[aIndex++] = textureId;
        }
        for(var i = 0; i < indicies.length; i++)indexBuffer[iIndex++] = packedVertices + indicies[i];
    };
    /**
     * Pool of `BatchDrawCall` objects that `flush` used
     * to create "batches" of the objects being rendered.
     *
     * These are never re-allocated again.
     * Shared between all batch renderers because it can be only one "flush" working at the moment.
     *
     * @member {PIXI.BatchDrawCall[]}
     */ AbstractBatchRenderer._drawCallPool = [];
    /**
     * Pool of `BatchDrawCall` objects that `flush` used
     * to create "batches" of the objects being rendered.
     *
     * These are never re-allocated again.
     * Shared between all batch renderers because it can be only one "flush" working at the moment.
     *
     * @member {PIXI.BatchTextureArray[]}
     */ AbstractBatchRenderer._textureArrayPool = [];
    return AbstractBatchRenderer;
}(ObjectRenderer);
/**
 * Helper that generates batching multi-texture shader. Use it with your new BatchRenderer
 *
 * @memberof PIXI
 */ var BatchShaderGenerator = /** @class */ function() {
    /**
     * @param vertexSrc - Vertex shader
     * @param fragTemplate - Fragment shader template
     */ function BatchShaderGenerator(vertexSrc, fragTemplate) {
        this.vertexSrc = vertexSrc;
        this.fragTemplate = fragTemplate;
        this.programCache = {};
        this.defaultGroupCache = {};
        if (fragTemplate.indexOf('%count%') < 0) throw new Error('Fragment template must contain "%count%".');
        if (fragTemplate.indexOf('%forloop%') < 0) throw new Error('Fragment template must contain "%forloop%".');
    }
    BatchShaderGenerator.prototype.generateShader = function(maxTextures) {
        if (!this.programCache[maxTextures]) {
            var sampleValues = new Int32Array(maxTextures);
            for(var i = 0; i < maxTextures; i++)sampleValues[i] = i;
            this.defaultGroupCache[maxTextures] = UniformGroup.from({
                uSamplers: sampleValues
            }, true);
            var fragmentSrc = this.fragTemplate;
            fragmentSrc = fragmentSrc.replace(/%count%/gi, "" + maxTextures);
            fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures));
            this.programCache[maxTextures] = new Program(this.vertexSrc, fragmentSrc);
        }
        var uniforms = {
            tint: new Float32Array([
                1,
                1,
                1,
                1
            ]),
            translationMatrix: new (0, $6qzqq.Matrix)(),
            default: this.defaultGroupCache[maxTextures]
        };
        return new Shader(this.programCache[maxTextures], uniforms);
    };
    BatchShaderGenerator.prototype.generateSampleSrc = function(maxTextures) {
        var src = '';
        src += '\n';
        src += '\n';
        for(var i = 0; i < maxTextures; i++){
            if (i > 0) src += '\nelse ';
            if (i < maxTextures - 1) src += "if(vTextureId < " + i + ".5)";
            src += '\n{';
            src += "\n\tcolor = texture2D(uSamplers[" + i + "], vTextureCoord);";
            src += '\n}';
        }
        src += '\n';
        src += '\n';
        return src;
    };
    return BatchShaderGenerator;
}();
/**
 * Geometry used to batch standard PIXI content (e.g. Mesh, Sprite, Graphics objects).
 *
 * @memberof PIXI
 */ var BatchGeometry = /** @class */ function(_super) {
    __extends(BatchGeometry, _super);
    /**
     * @param {boolean} [_static=false] - Optimization flag, where `false`
     *        is updated every frame, `true` doesn't change frame-to-frame.
     */ function BatchGeometry(_static) {
        if (_static === void 0) _static = false;
        var _this = _super.call(this) || this;
        _this._buffer = new Buffer(null, _static, false);
        _this._indexBuffer = new Buffer(null, _static, true);
        _this.addAttribute('aVertexPosition', _this._buffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addAttribute('aTextureCoord', _this._buffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addAttribute('aColor', _this._buffer, 4, true, (0, $P8XPi.TYPES).UNSIGNED_BYTE).addAttribute('aTextureId', _this._buffer, 1, true, (0, $P8XPi.TYPES).FLOAT).addIndex(_this._indexBuffer);
        return _this;
    }
    return BatchGeometry;
}(Geometry);
var defaultVertex$3 = "precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform vec4 tint;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor * tint;\n}\n";
var defaultFragment$2 = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\nuniform sampler2D uSamplers[%count%];\n\nvoid main(void){\n    vec4 color;\n    %forloop%\n    gl_FragColor = color * vColor;\n}\n";
/** @memberof PIXI */ var BatchPluginFactory = /** @class */ function() {
    function BatchPluginFactory() {}
    /**
     * Create a new BatchRenderer plugin for Renderer. this convenience can provide an easy way
     * to extend BatchRenderer with all the necessary pieces.
     * @example
     * const fragment = `
     * varying vec2 vTextureCoord;
     * varying vec4 vColor;
     * varying float vTextureId;
     * uniform sampler2D uSamplers[%count%];
     *
     * void main(void){
     *     vec4 color;
     *     %forloop%
     *     gl_FragColor = vColor * vec4(color.a - color.rgb, color.a);
     * }
     * `;
     * const InvertBatchRenderer = PIXI.BatchPluginFactory.create({ fragment });
     * PIXI.Renderer.registerPlugin('invert', InvertBatchRenderer);
     * const sprite = new PIXI.Sprite();
     * sprite.pluginName = 'invert';
     *
     * @param {object} [options]
     * @param {string} [options.vertex=PIXI.BatchPluginFactory.defaultVertexSrc] - Vertex shader source
     * @param {string} [options.fragment=PIXI.BatchPluginFactory.defaultFragmentTemplate] - Fragment shader template
     * @param {number} [options.vertexSize=6] - Vertex size
     * @param {object} [options.geometryClass=PIXI.BatchGeometry]
     * @return {*} New batch renderer plugin
     */ BatchPluginFactory.create = function(options) {
        var _a = Object.assign({
            vertex: defaultVertex$3,
            fragment: defaultFragment$2,
            geometryClass: BatchGeometry,
            vertexSize: 6
        }, options), vertex = _a.vertex, fragment = _a.fragment, vertexSize = _a.vertexSize, geometryClass = _a.geometryClass;
        return /** @class */ function(_super) {
            __extends(BatchPlugin, _super);
            function BatchPlugin(renderer) {
                var _this = _super.call(this, renderer) || this;
                _this.shaderGenerator = new BatchShaderGenerator(vertex, fragment);
                _this.geometryClass = geometryClass;
                _this.vertexSize = vertexSize;
                return _this;
            }
            return BatchPlugin;
        }(AbstractBatchRenderer);
    };
    Object.defineProperty(BatchPluginFactory, "defaultVertexSrc", {
        /**
         * The default vertex shader source
         *
         * @readonly
         */ get: function() {
            return defaultVertex$3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatchPluginFactory, "defaultFragmentTemplate", {
        /**
         * The default fragment shader source
         *
         * @readonly
         */ get: function() {
            return defaultFragment$2;
        },
        enumerable: false,
        configurable: true
    });
    return BatchPluginFactory;
}();
// Setup the default BatchRenderer plugin, this is what
// we'll actually export at the root level
var BatchRenderer = BatchPluginFactory.create();
/**
 * @memberof PIXI
 * @namespace resources
 * @see PIXI
 * @deprecated since 6.0.0
 */ var resources = {};
var _loop_1 = function(name) {
    Object.defineProperty(resources, name, {
        get: function() {
            (0, $csytw.deprecation)('6.0.0', "PIXI.systems." + name + " has moved to PIXI." + name);
            return _resources[name];
        }
    });
};
for(var name in _resources)_loop_1(name);
/**
 * @memberof PIXI
 * @namespace systems
 * @see PIXI
 * @deprecated since 6.0.0
 */ var systems = {};
var _loop_2 = function(name) {
    Object.defineProperty(systems, name, {
        get: function() {
            (0, $csytw.deprecation)('6.0.0', "PIXI.resources." + name + " has moved to PIXI." + name);
            return _systems[name];
        }
    });
};
for(var name in _systems)_loop_2(name);

});
parcelRegister("6fZag", function(module, exports) {

$parcel$export(module.exports, "Runner", function () { return $48e396c9ff697e5b$export$571ad3bcba5a0c45; });
/*!
 * @pixi/runner - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/runner is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * A Runner is a highly performant and simple alternative to signals. Best used in situations
 * where events are dispatched to many objects at high frequency (say every frame!)
 *
 *
 * like a signal..
 * ```
 * import { Runner } from '@pixi/runner';
 *
 * const myObject = {
 *     loaded: new Runner('loaded')
 * }
 *
 * const listener = {
 *     loaded: function(){
 *         // thin
 *     }
 * }
 *
 * myObject.loaded.add(listener);
 *
 * myObject.loaded.emit();
 * ```
 *
 * Or for handling calling the same function on many items
 * ```
 * import { Runner } from '@pixi/runner';
 *
 * const myGame = {
 *     update: new Runner('update')
 * }
 *
 * const gameObject = {
 *     update: function(time){
 *         // update my gamey state
 *     }
 * }
 *
 * myGame.update.add(gameObject);
 *
 * myGame.update.emit(time);
 * ```
 *
 * @memberof PIXI
 */ var $48e396c9ff697e5b$export$571ad3bcba5a0c45 = /** @class */ function() {
    /**
     * @param name - The function name that will be executed on the listeners added to this Runner.
     */ function Runner(name) {
        this.items = [];
        this._name = name;
        this._aliasCount = 0;
    }
    /**
     * Dispatch/Broadcast Runner to all listeners added to the queue.
     *
     * @param {...any} params - (optional) parameters to pass to each listener
     */ Runner.prototype.emit = function(a0, a1, a2, a3, a4, a5, a6, a7) {
        if (arguments.length > 8) throw new Error('max arguments reached');
        var _a = this, name = _a.name, items = _a.items;
        this._aliasCount++;
        for(var i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        if (items === this.items) this._aliasCount--;
        return this;
    };
    Runner.prototype.ensureNonAliasedItems = function() {
        if (this._aliasCount > 0 && this.items.length > 1) {
            this._aliasCount = 0;
            this.items = this.items.slice(0);
        }
    };
    /**
     * Add a listener to the Runner
     *
     * Runners do not need to have scope or functions passed to them.
     * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
     * as the name provided to the Runner when it was created.
     *
     * Eg A listener passed to this Runner will require a 'complete' function.
     *
     * ```
     * import { Runner } from '@pixi/runner';
     *
     * const complete = new Runner('complete');
     * ```
     *
     * The scope used will be the object itself.
     *
     * @param {any} item - The object that will be listening.
     */ Runner.prototype.add = function(item) {
        if (item[this._name]) {
            this.ensureNonAliasedItems();
            this.remove(item);
            this.items.push(item);
        }
        return this;
    };
    /**
     * Remove a single listener from the dispatch queue.
     *
     * @param {any} item - The listener that you would like to remove.
     */ Runner.prototype.remove = function(item) {
        var index = this.items.indexOf(item);
        if (index !== -1) {
            this.ensureNonAliasedItems();
            this.items.splice(index, 1);
        }
        return this;
    };
    /**
     * Check to see if the listener is already in the Runner
     *
     * @param {any} item - The listener that you would like to check.
     */ Runner.prototype.contains = function(item) {
        return this.items.indexOf(item) !== -1;
    };
    /** Remove all listeners from the Runner */ Runner.prototype.removeAll = function() {
        this.ensureNonAliasedItems();
        this.items.length = 0;
        return this;
    };
    /** Remove all references, don't use after this. */ Runner.prototype.destroy = function() {
        this.removeAll();
        this.items = null;
        this._name = null;
    };
    Object.defineProperty(Runner.prototype, "empty", {
        /**
         * `true` if there are no this Runner contains no listeners
         *
         * @readonly
         */ get: function() {
            return this.items.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Runner.prototype, "name", {
        /**
         * The name of the runner.
         *
         * @readonly
         */ get: function() {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    return Runner;
}();
Object.defineProperties($48e396c9ff697e5b$export$571ad3bcba5a0c45.prototype, {
    /**
     * Alias for `emit`
     * @memberof PIXI.Runner#
     * @method dispatch
     * @see PIXI.Runner#emit
     */ dispatch: {
        value: $48e396c9ff697e5b$export$571ad3bcba5a0c45.prototype.emit
    },
    /**
     * Alias for `emit`
     * @memberof PIXI.Runner#
     * @method run
     * @see PIXI.Runner#emit
     */ run: {
        value: $48e396c9ff697e5b$export$571ad3bcba5a0c45.prototype.emit
    }
});

});



parcelRegister("3bQv9", function(module, exports) {

$parcel$export(module.exports, "Extract", function () { return $252b1fdb6b3c4af2$export$296daa4fd2384194; });
/*!
 * @pixi/extract - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/extract is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $csytw = parcelRequire("csytw");

var $6qzqq = parcelRequire("6qzqq");

var $klOfb = parcelRequire("klOfb");
var $252b1fdb6b3c4af2$var$TEMP_RECT = new (0, $6qzqq.Rectangle)();
var $252b1fdb6b3c4af2$var$BYTES_PER_PIXEL = 4;
/**
 * This class provides renderer-specific plugins for exporting content from a renderer.
 * For instance, these plugins can be used for saving an Image, Canvas element or for exporting the raw image data (pixels).
 *
 * Do not instantiate these plugins directly. It is available from the `renderer.plugins` property.
 * See {@link PIXI.CanvasRenderer#plugins} or {@link PIXI.Renderer#plugins}.
 * @example
 * // Create a new app (will auto-add extract plugin to renderer)
 * const app = new PIXI.Application();
 *
 * // Draw a red circle
 * const graphics = new PIXI.Graphics()
 *     .beginFill(0xFF0000)
 *     .drawCircle(0, 0, 50);
 *
 * // Render the graphics as an HTMLImageElement
 * const image = app.renderer.plugins.extract.image(graphics);
 * document.body.appendChild(image);
 * @class
 * @memberof PIXI
 */ var $252b1fdb6b3c4af2$export$296daa4fd2384194 = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - A reference to the current renderer
     */ function Extract(renderer) {
        this.renderer = renderer;
    }
    /**
     * Will return a HTML Image of the target
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
     * @return {HTMLImageElement} HTML Image of the target
     */ Extract.prototype.image = function(target, format, quality) {
        var image = new Image();
        image.src = this.base64(target, format, quality);
        return image;
    };
    /**
     * Will return a a base64 encoded string of this target. It works by calling
     *  `Extract.getCanvas` and then running toDataURL on that.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
     * @return {string} A base64 encoded string of the texture.
     */ Extract.prototype.base64 = function(target, format, quality) {
        return this.canvas(target).toDataURL(format, quality);
    };
    /**
     * Creates a Canvas element, renders this target to it and then returns it.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
     */ Extract.prototype.canvas = function(target) {
        var renderer = this.renderer;
        var resolution;
        var frame;
        var flipY = false;
        var renderTexture;
        var generated = false;
        if (target) {
            if (target instanceof (0, $klOfb.RenderTexture)) renderTexture = target;
            else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = renderTexture.frame;
            flipY = false;
            renderer.renderTexture.bind(renderTexture);
        } else {
            resolution = this.renderer.resolution;
            flipY = true;
            frame = $252b1fdb6b3c4af2$var$TEMP_RECT;
            frame.width = this.renderer.width;
            frame.height = this.renderer.height;
            renderer.renderTexture.bind(null);
        }
        var width = Math.floor(frame.width * resolution + 1e-4);
        var height = Math.floor(frame.height * resolution + 1e-4);
        var canvasBuffer = new (0, $csytw.CanvasRenderTarget)(width, height, 1);
        var webglPixels = new Uint8Array($252b1fdb6b3c4af2$var$BYTES_PER_PIXEL * width * height);
        // read pixels to the array
        var gl = renderer.gl;
        gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        // add the pixels to the canvas
        var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
        Extract.arrayPostDivide(webglPixels, canvasData.data);
        canvasBuffer.context.putImageData(canvasData, 0, 0);
        // pulling pixels
        if (flipY) {
            var target_1 = new (0, $csytw.CanvasRenderTarget)(canvasBuffer.width, canvasBuffer.height, 1);
            target_1.context.scale(1, -1);
            // we can't render to itself because we should be empty before render.
            target_1.context.drawImage(canvasBuffer.canvas, 0, -height);
            canvasBuffer.destroy();
            canvasBuffer = target_1;
        }
        if (generated) renderTexture.destroy(true);
        // send the canvas back..
        return canvasBuffer.canvas;
    };
    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @return {Uint8Array} One-dimensional array containing the pixel data of the entire texture
     */ Extract.prototype.pixels = function(target) {
        var renderer = this.renderer;
        var resolution;
        var frame;
        var renderTexture;
        var generated = false;
        if (target) {
            if (target instanceof (0, $klOfb.RenderTexture)) renderTexture = target;
            else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = renderTexture.frame;
            // bind the buffer
            renderer.renderTexture.bind(renderTexture);
        } else {
            resolution = renderer.resolution;
            frame = $252b1fdb6b3c4af2$var$TEMP_RECT;
            frame.width = renderer.width;
            frame.height = renderer.height;
            renderer.renderTexture.bind(null);
        }
        var width = frame.width * resolution;
        var height = frame.height * resolution;
        var webglPixels = new Uint8Array($252b1fdb6b3c4af2$var$BYTES_PER_PIXEL * width * height);
        // read pixels to the array
        var gl = renderer.gl;
        gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        if (generated) renderTexture.destroy(true);
        Extract.arrayPostDivide(webglPixels, webglPixels);
        return webglPixels;
    };
    /**
     * Destroys the extract
     *
     */ Extract.prototype.destroy = function() {
        this.renderer = null;
    };
    /**
     * Takes premultiplied pixel data and produces regular pixel data
     *
     * @private
     * @param {number[] | Uint8Array | Uint8ClampedArray} pixels - array of pixel data
     * @param {number[] | Uint8Array | Uint8ClampedArray} out - output array
     */ Extract.arrayPostDivide = function(pixels, out) {
        for(var i = 0; i < pixels.length; i += 4){
            var alpha = out[i + 3] = pixels[i + 3];
            if (alpha !== 0) {
                out[i] = Math.round(Math.min(pixels[i] * 255.0 / alpha, 255.0));
                out[i + 1] = Math.round(Math.min(pixels[i + 1] * 255.0 / alpha, 255.0));
                out[i + 2] = Math.round(Math.min(pixels[i + 2] * 255.0 / alpha, 255.0));
            } else {
                out[i] = pixels[i];
                out[i + 1] = pixels[i + 1];
                out[i + 2] = pixels[i + 2];
            }
        }
    };
    return Extract;
}();

});

parcelRegister("kXE1p", function(module, exports) {

$parcel$export(module.exports, "LoaderResource", function () { return $f4285cd755ab388f$export$3a2d98834c8b0432; });
$parcel$export(module.exports, "Loader", function () { return $f4285cd755ab388f$export$3b0d6d7590275603; });
$parcel$export(module.exports, "AppLoaderPlugin", function () { return $f4285cd755ab388f$export$4d6e8fa105d8152b; });
$parcel$export(module.exports, "TextureLoader", function () { return $f4285cd755ab388f$export$fd1bfc71f64c538c; });
/*!
 * @pixi/loaders - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/loaders is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/* jshint -W097 */ /**
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$SignalBinding = /** @class */ function() {
    /**
     * SignalBinding constructor.
     * @constructs SignalBinding
     * @param {Function} fn - Event handler to be called.
     * @param {Boolean} [once=false] - Should this listener be removed after dispatch
     * @param {object} [thisArg] - The context of the callback function.
     * @api private
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    function SignalBinding(fn, once, thisArg) {
        if (once === void 0) once = false;
        this._fn = fn;
        this._once = once;
        this._thisArg = thisArg;
        this._next = this._prev = this._owner = null;
    }
    SignalBinding.prototype.detach = function() {
        if (this._owner === null) return false;
        this._owner.detach(this);
        return true;
    };
    return SignalBinding;
}();
/**
 * @private
 */ function $f4285cd755ab388f$var$_addSignalBinding(self1, node) {
    if (!self1._head) {
        self1._head = node;
        self1._tail = node;
    } else {
        self1._tail._next = node;
        node._prev = self1._tail;
        self1._tail = node;
    }
    node._owner = self1;
    return node;
}
/**
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$Signal = /** @class */ function() {
    /**
     * MiniSignal constructor.
     * @example
     * let mySignal = new Signal();
     * let binding = mySignal.add(onSignal);
     * mySignal.dispatch('foo', 'bar');
     * mySignal.detach(binding);
     */ function Signal() {
        this._head = this._tail = undefined;
    }
    /**
     * Return an array of attached SignalBinding.
     *
     * @param {Boolean} [exists=false] - We only need to know if there are handlers.
     * @returns {PIXI.SignalBinding[]|Boolean} Array of attached SignalBinding or Boolean if called with exists = true
     * @api public
     */ Signal.prototype.handlers = function(exists) {
        if (exists === void 0) exists = false;
        var node = this._head;
        if (exists) return !!node;
        var ee = [];
        while(node){
            ee.push(node);
            node = node._next;
        }
        return ee;
    };
    /**
     * Return true if node is a SignalBinding attached to this MiniSignal
     *
     * @param {PIXI.SignalBinding} node - Node to check.
     * @returns {Boolean} True if node is attache to mini-signal
     */ Signal.prototype.has = function(node) {
        if (!(node instanceof $f4285cd755ab388f$var$SignalBinding)) throw new Error('MiniSignal#has(): First arg must be a SignalBinding object.');
        return node._owner === this;
    };
    /**
     * Dispaches a signal to all registered listeners.
     *
     * @returns {Boolean} Indication if we've emitted an event.
     */ Signal.prototype.dispatch = function() {
        var arguments$1 = arguments;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments$1[_i];
        var node = this._head;
        if (!node) return false;
        while(node){
            if (node._once) this.detach(node);
            node._fn.apply(node._thisArg, args);
            node = node._next;
        }
        return true;
    };
    /**
     * Register a new listener.
     *
     * @param {Function} fn - Callback function.
     * @param {object} [thisArg] - The context of the callback function.
     * @returns {PIXI.SignalBinding} The SignalBinding node that was added.
     */ Signal.prototype.add = function(fn, thisArg) {
        if (thisArg === void 0) thisArg = null;
        if (typeof fn !== 'function') throw new Error('MiniSignal#add(): First arg must be a Function.');
        return $f4285cd755ab388f$var$_addSignalBinding(this, new $f4285cd755ab388f$var$SignalBinding(fn, false, thisArg));
    };
    /**
     * Register a new listener that will be executed only once.
     *
     * @param {Function} fn - Callback function.
     * @param {object} [thisArg] - The context of the callback function.
     * @returns {PIXI.SignalBinding} The SignalBinding node that was added.
     */ Signal.prototype.once = function(fn, thisArg) {
        if (thisArg === void 0) thisArg = null;
        if (typeof fn !== 'function') throw new Error('MiniSignal#once(): First arg must be a Function.');
        return $f4285cd755ab388f$var$_addSignalBinding(this, new $f4285cd755ab388f$var$SignalBinding(fn, true, thisArg));
    };
    /**
     * Remove binding object.
     *
     * @param {PIXI.SignalBinding} node - The binding node that will be removed.
     * @returns {Signal} The instance on which this method was called.
     * @api public */ Signal.prototype.detach = function(node) {
        if (!(node instanceof $f4285cd755ab388f$var$SignalBinding)) throw new Error('MiniSignal#detach(): First arg must be a SignalBinding object.');
        if (node._owner !== this) return this;
         // todo: or error?
        if (node._prev) node._prev._next = node._next;
        if (node._next) node._next._prev = node._prev;
        if (node === this._head) {
            this._head = node._next;
            if (node._next === null) this._tail = null;
        } else if (node === this._tail) {
            this._tail = node._prev;
            this._tail._next = null;
        }
        node._owner = null;
        return this;
    };
    /**
     * Detach all listeners.
     *
     * @returns {Signal} The instance on which this method was called.
     */ Signal.prototype.detachAll = function() {
        var node = this._head;
        if (!node) return this;
        this._head = this._tail = null;
        while(node){
            node._owner = null;
            node = node._next;
        }
        return this;
    };
    return Signal;
}();
/**
 * function from npm package `parseUri`, converted to TS to avoid leftpad incident
 * @param {string} str
 * @param [opts] - options
 * @param {boolean} [opts.strictMode] - type of parser
 */ function $f4285cd755ab388f$var$parseUri(str, opts) {
    opts = opts || {};
    var o = {
        // eslint-disable-next-line max-len
        key: [
            'source',
            'protocol',
            'authority',
            'userInfo',
            'user',
            'password',
            'host',
            'port',
            'relative',
            'path',
            'directory',
            'file',
            'query',
            'anchor'
        ],
        q: {
            name: 'queryKey',
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
            // eslint-disable-next-line max-len
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            // eslint-disable-next-line max-len
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
    };
    var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
    var uri = {};
    var i = 14;
    while(i--)uri[o.key[i]] = m[i] || '';
    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function(_t0, t1, t2) {
        if (t1) uri[o.q.name][t1] = t2;
    });
    return uri;
}
// tests if CORS is supported in XHR, if not we need to use XDR
var $f4285cd755ab388f$var$useXdr = !!(self.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
var $f4285cd755ab388f$var$tempAnchor = null;
// some status constants
var $f4285cd755ab388f$var$STATUS_NONE = 0;
var $f4285cd755ab388f$var$STATUS_OK = 200;
var $f4285cd755ab388f$var$STATUS_EMPTY = 204;
var $f4285cd755ab388f$var$STATUS_IE_BUG_EMPTY = 1223;
var $f4285cd755ab388f$var$STATUS_TYPE_OK = 2;
// noop
function $f4285cd755ab388f$var$_noop() {}
/**
 * Quick helper to set a value on one of the extension maps. Ensures there is no
 * dot at the start of the extension.
 *
 * @ignore
 * @param map - The map to set on.
 * @param extname - The extension (or key) to set.
 * @param val - The value to set.
 */ function $f4285cd755ab388f$var$setExtMap(map, extname, val) {
    if (extname && extname.indexOf('.') === 0) extname = extname.substring(1);
    if (!extname) return;
    map[extname] = val;
}
/**
 * Quick helper to get string xhr type.
 *
 * @ignore
 * @param xhr - The request to check.
 * @return The type.
 */ function $f4285cd755ab388f$var$reqType(xhr) {
    return xhr.toString().replace('object ', '');
}
/**
 * Manages the state and loading of a resource and all child resources.
 *
 * Can be extended in `GlobalMixins.LoaderResource`.
 *
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$3a2d98834c8b0432 = /** @class */ function() {
    /**
     * @param {string} name - The name of the resource to load.
     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
     *      an array of sources.
     * @param {object} [options] - The options for the load.
     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
     *      determine automatically.
     * @param {number} [options.timeout=0] - A timeout in milliseconds for the load. If the load takes
     *      longer than this time it is cancelled and the load is considered a failure. If this value is
     *      set to `0` then there is no explicit timeout.
     * @param {PIXI.LoaderResource.LOAD_TYPE} [options.loadType=LOAD_TYPE.XHR] - How should this resource
     *      be loaded?
     * @param {PIXI.LoaderResource.XHR_RESPONSE_TYPE} [options.xhrType=XHR_RESPONSE_TYPE.DEFAULT] - How
     *      should the data being loaded be interpreted when using XHR?
     * @param {PIXI.LoaderResource.IMetadata} [options.metadata] - Extra configuration for middleware
     *      and the Resource object.
     */ function LoaderResource(name, url, options) {
        /**
         * The `dequeue` method that will be used a storage place for the async queue dequeue method
         * used privately by the loader.
         *
         * @private
         * @member {function}
         */ this._dequeue = $f4285cd755ab388f$var$_noop;
        /**
         * Used a storage place for the on load binding used privately by the loader.
         *
         * @private
         * @member {function}
         */ this._onLoadBinding = null;
        /**
         * The timer for element loads to check if they timeout.
         *
         * @private
         */ this._elementTimer = 0;
        /**
         * The `complete` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundComplete = null;
        /**
         * The `_onError` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundOnError = null;
        /**
         * The `_onProgress` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundOnProgress = null;
        /**
         * The `_onTimeout` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundOnTimeout = null;
        this._boundXhrOnError = null;
        this._boundXhrOnTimeout = null;
        this._boundXhrOnAbort = null;
        this._boundXhrOnLoad = null;
        if (typeof name !== 'string' || typeof url !== 'string') throw new Error('Both name and url are required for constructing a resource.');
        options = options || {};
        this._flags = 0;
        // set data url flag, needs to be set early for some _determineX checks to work.
        this._setFlag(LoaderResource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);
        this.name = name;
        this.url = url;
        this.extension = this._getExtension();
        this.data = null;
        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
        this.timeout = options.timeout || 0;
        this.loadType = options.loadType || this._determineLoadType();
        // The type used to load the resource via XHR. If unset, determined automatically.
        this.xhrType = options.xhrType;
        // Extra info for middleware, and controlling specifics about how the resource loads.
        // Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
        // Meaning it will modify it as it sees fit.
        this.metadata = options.metadata || {};
        // The error that occurred while loading (if any).
        this.error = null;
        // The XHR object that was used to load this resource. This is only set
        // when `loadType` is `LoaderResource.LOAD_TYPE.XHR`.
        this.xhr = null;
        // The child resources this resource owns.
        this.children = [];
        // The resource type.
        this.type = LoaderResource.TYPE.UNKNOWN;
        // The progress chunk owned by this resource.
        this.progressChunk = 0;
        // The `dequeue` method that will be used a storage place for the async queue dequeue method
        // used privately by the loader.
        this._dequeue = $f4285cd755ab388f$var$_noop;
        // Used a storage place for the on load binding used privately by the loader.
        this._onLoadBinding = null;
        // The timer for element loads to check if they timeout.
        this._elementTimer = 0;
        this._boundComplete = this.complete.bind(this);
        this._boundOnError = this._onError.bind(this);
        this._boundOnProgress = this._onProgress.bind(this);
        this._boundOnTimeout = this._onTimeout.bind(this);
        // xhr callbacks
        this._boundXhrOnError = this._xhrOnError.bind(this);
        this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this);
        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
        // Dispatched when the resource beings to load.
        this.onStart = new $f4285cd755ab388f$var$Signal();
        // Dispatched each time progress of this resource load updates.
        // Not all resources types and loader systems can support this event
        // so sometimes it may not be available. If the resource
        // is being loaded on a modern browser, using XHR, and the remote server
        // properly sets Content-Length headers, then this will be available.
        this.onProgress = new $f4285cd755ab388f$var$Signal();
        // Dispatched once this resource has loaded, if there was an error it will
        // be in the `error` property.
        this.onComplete = new $f4285cd755ab388f$var$Signal();
        // Dispatched after this resource has had all the *after* middleware run on it.
        this.onAfterMiddleware = new $f4285cd755ab388f$var$Signal();
    }
    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {PIXI.LoaderResource.LOAD_TYPE} loadType - The load type to set it to.
     */ LoaderResource.setExtensionLoadType = function(extname, loadType) {
        $f4285cd755ab388f$var$setExtMap(LoaderResource._loadTypeMap, extname, loadType);
    };
    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {PIXI.LoaderResource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
     */ LoaderResource.setExtensionXhrType = function(extname, xhrType) {
        $f4285cd755ab388f$var$setExtMap(LoaderResource._xhrTypeMap, extname, xhrType);
    };
    Object.defineProperty(LoaderResource.prototype, "isDataUrl", {
        /**
         * When the resource starts to load.
         *
         * @memberof PIXI.LoaderResource
         * @callback OnStartSignal
         * @param {Resource} resource - The resource that the event happened on.
         */ /**
         * When the resource reports loading progress.
         *
         * @memberof PIXI.LoaderResource
         * @callback OnProgressSignal
         * @param {Resource} resource - The resource that the event happened on.
         * @param {number} percentage - The progress of the load in the range [0, 1].
         */ /**
         * When the resource finishes loading.
         *
         * @memberof PIXI.LoaderResource
         * @callback OnCompleteSignal
         * @param {Resource} resource - The resource that the event happened on.
         */ /**
         * @memberof PIXI.LoaderResource
         * @typedef {object} IMetadata
         * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
         *      element to use for loading, instead of creating one.
         * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
         *      is useful if you want to pass in a `loadElement` that you already added load sources to.
         * @property {string|string[]} [mimeType] - The mime type to use for the source element
         *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
         *      where each index is the mime type to use for the corresponding url index.
         */ /**
         * Stores whether or not this url is a data url.
         *
         * @readonly
         * @member {boolean}
         */ get: function() {
            return this._hasFlag(LoaderResource.STATUS_FLAGS.DATA_URL);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderResource.prototype, "isComplete", {
        /**
         * Describes if this resource has finished loading. Is true when the resource has completely
         * loaded.
         *
         * @readonly
         * @member {boolean}
         */ get: function() {
            return this._hasFlag(LoaderResource.STATUS_FLAGS.COMPLETE);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderResource.prototype, "isLoading", {
        /**
         * Describes if this resource is currently loading. Is true when the resource starts loading,
         * and is false again when complete.
         *
         * @readonly
         * @member {boolean}
         */ get: function() {
            return this._hasFlag(LoaderResource.STATUS_FLAGS.LOADING);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Marks the resource as complete.
     *
     */ LoaderResource.prototype.complete = function() {
        this._clearEvents();
        this._finish();
    };
    /**
     * Aborts the loading of this resource, with an optional message.
     *
     * @param {string} message - The message to use for the error
     */ LoaderResource.prototype.abort = function(message) {
        // abort can be called multiple times, ignore subsequent calls.
        if (this.error) return;
        // store error
        this.error = new Error(message);
        // clear events before calling aborts
        this._clearEvents();
        // abort the actual loading
        if (this.xhr) this.xhr.abort();
        else if (this.xdr) this.xdr.abort();
        else if (this.data) {
            // single source
            if (this.data.src) this.data.src = LoaderResource.EMPTY_GIF;
            else while(this.data.firstChild)this.data.removeChild(this.data.firstChild);
        }
        // done now.
        this._finish();
    };
    /**
     * Kicks off loading of this resource. This method is asynchronous.
     *
     * @param {PIXI.LoaderResource.OnCompleteSignal} [cb] - Optional callback to call once the resource is loaded.
     */ LoaderResource.prototype.load = function(cb) {
        var _this = this;
        if (this.isLoading) return;
        if (this.isComplete) {
            if (cb) setTimeout(function() {
                return cb(_this);
            }, 1);
            return;
        } else if (cb) this.onComplete.once(cb);
        this._setFlag(LoaderResource.STATUS_FLAGS.LOADING, true);
        this.onStart.dispatch(this);
        // if unset, determine the value
        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') this.crossOrigin = this._determineCrossOrigin(this.url);
        switch(this.loadType){
            case LoaderResource.LOAD_TYPE.IMAGE:
                this.type = LoaderResource.TYPE.IMAGE;
                this._loadElement('image');
                break;
            case LoaderResource.LOAD_TYPE.AUDIO:
                this.type = LoaderResource.TYPE.AUDIO;
                this._loadSourceElement('audio');
                break;
            case LoaderResource.LOAD_TYPE.VIDEO:
                this.type = LoaderResource.TYPE.VIDEO;
                this._loadSourceElement('video');
                break;
            case LoaderResource.LOAD_TYPE.XHR:
            /* falls through */ default:
                if ($f4285cd755ab388f$var$useXdr && this.crossOrigin) this._loadXdr();
                else this._loadXhr();
                break;
        }
    };
    /**
     * Checks if the flag is set.
     *
     * @param flag - The flag to check.
     * @return True if the flag is set.
     */ LoaderResource.prototype._hasFlag = function(flag) {
        return (this._flags & flag) !== 0;
    };
    /**
     * (Un)Sets the flag.
     *
     * @param flag - The flag to (un)set.
     * @param value - Whether to set or (un)set the flag.
     */ LoaderResource.prototype._setFlag = function(flag, value) {
        this._flags = value ? this._flags | flag : this._flags & ~flag;
    };
    /**
     * Clears all the events from the underlying loading source.
     */ LoaderResource.prototype._clearEvents = function() {
        clearTimeout(this._elementTimer);
        if (this.data && this.data.removeEventListener) {
            this.data.removeEventListener('error', this._boundOnError, false);
            this.data.removeEventListener('load', this._boundComplete, false);
            this.data.removeEventListener('progress', this._boundOnProgress, false);
            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
        }
        if (this.xhr) {
            if (this.xhr.removeEventListener) {
                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
                this.xhr.removeEventListener('timeout', this._boundXhrOnTimeout, false);
                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
            } else {
                this.xhr.onerror = null;
                this.xhr.ontimeout = null;
                this.xhr.onprogress = null;
                this.xhr.onload = null;
            }
        }
    };
    /**
     * Finalizes the load.
     */ LoaderResource.prototype._finish = function() {
        if (this.isComplete) throw new Error('Complete called again for an already completed resource.');
        this._setFlag(LoaderResource.STATUS_FLAGS.COMPLETE, true);
        this._setFlag(LoaderResource.STATUS_FLAGS.LOADING, false);
        this.onComplete.dispatch(this);
    };
    /**
     * Loads this resources using an element that has a single source,
     * like an HTMLImageElement.
     * @private
     * @param type - The type of element to use.
     */ LoaderResource.prototype._loadElement = function(type) {
        if (this.metadata.loadElement) this.data = this.metadata.loadElement;
        else if (type === 'image' && typeof self.Image !== 'undefined') this.data = new Image();
        else this.data = document.createElement(type);
        if (this.crossOrigin) this.data.crossOrigin = this.crossOrigin;
        if (!this.metadata.skipSource) this.data.src = this.url;
        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);
        if (this.timeout) this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
    };
    /**
     * Loads this resources using an element that has multiple sources,
     * like an HTMLAudioElement or HTMLVideoElement.
     * @param type - The type of element to use.
     */ LoaderResource.prototype._loadSourceElement = function(type) {
        if (this.metadata.loadElement) this.data = this.metadata.loadElement;
        else if (type === 'audio' && typeof self.Audio !== 'undefined') this.data = new Audio();
        else this.data = document.createElement(type);
        if (this.data === null) {
            this.abort("Unsupported element: " + type);
            return;
        }
        if (this.crossOrigin) this.data.crossOrigin = this.crossOrigin;
        if (!this.metadata.skipSource) {
            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
            if (navigator.isCocoonJS) this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
            else if (Array.isArray(this.url)) {
                var mimeTypes = this.metadata.mimeType;
                for(var i = 0; i < this.url.length; ++i)this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
            } else {
                var mimeTypes = this.metadata.mimeType;
                this.data.appendChild(this._createSource(type, this.url, Array.isArray(mimeTypes) ? mimeTypes[0] : mimeTypes));
            }
        }
        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);
        this.data.addEventListener('canplaythrough', this._boundComplete, false);
        this.data.load();
        if (this.timeout) this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
    };
    /**
     * Loads this resources using an XMLHttpRequest.
     */ LoaderResource.prototype._loadXhr = function() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') this.xhrType = this._determineXhrType();
        var xhr = this.xhr = new XMLHttpRequest();
        // set the request type and url
        xhr.open('GET', this.url, true);
        xhr.timeout = this.timeout;
        // load json as text and parse it ourselves. We do this because some browsers
        // *cough* safari *cough* can't deal with it.
        if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.JSON || this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT) xhr.responseType = LoaderResource.XHR_RESPONSE_TYPE.TEXT;
        else xhr.responseType = this.xhrType;
        xhr.addEventListener('error', this._boundXhrOnError, false);
        xhr.addEventListener('timeout', this._boundXhrOnTimeout, false);
        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
        xhr.addEventListener('progress', this._boundOnProgress, false);
        xhr.addEventListener('load', this._boundXhrOnLoad, false);
        xhr.send();
    };
    /**
     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
     */ LoaderResource.prototype._loadXdr = function() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') this.xhrType = this._determineXhrType();
        var xdr = this.xhr = new self.XDomainRequest(); // eslint-disable-line no-undef
        // XDomainRequest has a few quirks. Occasionally it will abort requests
        // A way to avoid this is to make sure ALL callbacks are set even if not used
        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
        xdr.timeout = this.timeout || 5000; // XDR needs a timeout value or it breaks in IE9
        xdr.onerror = this._boundXhrOnError;
        xdr.ontimeout = this._boundXhrOnTimeout;
        xdr.onprogress = this._boundOnProgress;
        xdr.onload = this._boundXhrOnLoad;
        xdr.open('GET', this.url, true);
        // Note: The xdr.send() call is wrapped in a timeout to prevent an
        // issue with the interface where some requests are lost if multiple
        // XDomainRequests are being sent at the same time.
        // Some info here: https://github.com/photonstorm/phaser/issues/1248
        setTimeout(function() {
            return xdr.send();
        }, 1);
    };
    /**
     * Creates a source used in loading via an element.
     * @param type - The element type (video or audio).
     * @param url - The source URL to load from.
     * @param [mime] - The mime type of the video
     * @return The source element.
     */ LoaderResource.prototype._createSource = function(type, url, mime) {
        if (!mime) mime = type + "/" + this._getExtension(url);
        var source = document.createElement('source');
        source.src = url;
        source.type = mime;
        return source;
    };
    /**
     * Called if a load errors out.
     *
     * @param event - The error event from the element that emits it.
     */ LoaderResource.prototype._onError = function(event) {
        this.abort("Failed to load element using: " + event.target.nodeName);
    };
    /**
     * Called if a load progress event fires for an element or xhr/xdr.
     * @param event - Progress event.
     */ LoaderResource.prototype._onProgress = function(event) {
        if (event && event.lengthComputable) this.onProgress.dispatch(this, event.loaded / event.total);
    };
    /**
     * Called if a timeout event fires for an element.
     */ LoaderResource.prototype._onTimeout = function() {
        this.abort("Load timed out.");
    };
    /**
     * Called if an error event fires for xhr/xdr.
     */ LoaderResource.prototype._xhrOnError = function() {
        var xhr = this.xhr;
        this.abort($f4285cd755ab388f$var$reqType(xhr) + " Request failed. Status: " + xhr.status + ", text: \"" + xhr.statusText + "\"");
    };
    /**
     * Called if an error event fires for xhr/xdr.
     */ LoaderResource.prototype._xhrOnTimeout = function() {
        var xhr = this.xhr;
        this.abort($f4285cd755ab388f$var$reqType(xhr) + " Request timed out.");
    };
    /**
     * Called if an abort event fires for xhr/xdr.
     */ LoaderResource.prototype._xhrOnAbort = function() {
        var xhr = this.xhr;
        this.abort($f4285cd755ab388f$var$reqType(xhr) + " Request was aborted by the user.");
    };
    /**
     * Called when data successfully loads from an xhr/xdr request.
     */ LoaderResource.prototype._xhrOnLoad = function() {
        var xhr = this.xhr;
        var text = '';
        var status = typeof xhr.status === 'undefined' ? $f4285cd755ab388f$var$STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.
        // responseText is accessible only if responseType is '' or 'text' and on older browsers
        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') text = xhr.responseText;
        // status can be 0 when using the `file://` protocol so we also check if a response is set.
        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
        if (status === $f4285cd755ab388f$var$STATUS_NONE && (text.length > 0 || xhr.responseType === LoaderResource.XHR_RESPONSE_TYPE.BUFFER)) status = $f4285cd755ab388f$var$STATUS_OK;
        else if (status === $f4285cd755ab388f$var$STATUS_IE_BUG_EMPTY) status = $f4285cd755ab388f$var$STATUS_EMPTY;
        var statusType = status / 100 | 0;
        if (statusType === $f4285cd755ab388f$var$STATUS_TYPE_OK) {
            // if text, just return it
            if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.TEXT) {
                this.data = text;
                this.type = LoaderResource.TYPE.TEXT;
            } else if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.JSON) try {
                this.data = JSON.parse(text);
                this.type = LoaderResource.TYPE.JSON;
            } catch (e) {
                this.abort("Error trying to parse loaded json: " + e);
                return;
            }
            else if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT) try {
                if (self.DOMParser) {
                    var domparser = new DOMParser();
                    this.data = domparser.parseFromString(text, 'text/xml');
                } else {
                    var div = document.createElement('div');
                    div.innerHTML = text;
                    this.data = div;
                }
                this.type = LoaderResource.TYPE.XML;
            } catch (e$1) {
                this.abort("Error trying to parse loaded xml: " + e$1);
                return;
            }
            else this.data = xhr.response || text;
        } else {
            this.abort("[" + xhr.status + "] " + xhr.statusText + ": " + xhr.responseURL);
            return;
        }
        this.complete();
    };
    /**
     * Sets the `crossOrigin` property for this resource based on if the url
     * for this resource is cross-origin. If crossOrigin was manually set, this
     * function does nothing.
     * @private
     * @param url - The url to test.
     * @param [loc=self.location] - The location object to test against.
     * @return The crossOrigin value to use (or empty string for none).
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    LoaderResource.prototype._determineCrossOrigin = function(url, loc) {
        // data: and javascript: urls are considered same-origin
        if (url.indexOf('data:') === 0) return '';
        // A sandboxed iframe without the 'allow-same-origin' attribute will have a special
        // origin designed not to match self.location.origin, and will always require
        // crossOrigin requests regardless of whether the location matches.
        if (self.origin !== self.location.origin) return 'anonymous';
        // default is self.location
        loc = loc || self.location;
        if (!$f4285cd755ab388f$var$tempAnchor) $f4285cd755ab388f$var$tempAnchor = document.createElement('a');
        // let the browser determine the full href for the url of this resource and then
        // parse with the node url lib, we can't use the properties of the anchor element
        // because they don't work in IE9 :(
        $f4285cd755ab388f$var$tempAnchor.href = url;
        var parsedUrl = $f4285cd755ab388f$var$parseUri($f4285cd755ab388f$var$tempAnchor.href, {
            strictMode: true
        });
        var samePort = !parsedUrl.port && loc.port === '' || parsedUrl.port === loc.port;
        var protocol = parsedUrl.protocol ? parsedUrl.protocol + ":" : '';
        // if cross origin
        if (parsedUrl.host !== loc.hostname || !samePort || protocol !== loc.protocol) return 'anonymous';
        return '';
    };
    /**
     * Determines the responseType of an XHR request based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {PIXI.LoaderResource.XHR_RESPONSE_TYPE} The responseType to use.
     */ LoaderResource.prototype._determineXhrType = function() {
        return LoaderResource._xhrTypeMap[this.extension] || LoaderResource.XHR_RESPONSE_TYPE.TEXT;
    };
    /**
     * Determines the loadType of a resource based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {PIXI.LoaderResource.LOAD_TYPE} The loadType to use.
     */ LoaderResource.prototype._determineLoadType = function() {
        return LoaderResource._loadTypeMap[this.extension] || LoaderResource.LOAD_TYPE.XHR;
    };
    /**
     * Extracts the extension (sans '.') of the file being loaded by the resource.
     *
     * @param [url] - url to parse, `this.url` by default.
     * @return The extension.
     */ LoaderResource.prototype._getExtension = function(url) {
        if (url === void 0) url = this.url;
        var ext = '';
        if (this.isDataUrl) {
            var slashIndex = url.indexOf('/');
            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
        } else {
            var queryStart = url.indexOf('?');
            var hashStart = url.indexOf('#');
            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);
            url = url.substring(0, index);
            ext = url.substring(url.lastIndexOf('.') + 1);
        }
        return ext.toLowerCase();
    };
    /**
     * Determines the mime type of an XHR request based on the responseType of
     * resource being loaded.
     *
     * @param type - The type to get a mime type for.
     * @private
     * @return The mime type to use.
     */ LoaderResource.prototype._getMimeFromXhrType = function(type) {
        switch(type){
            case LoaderResource.XHR_RESPONSE_TYPE.BUFFER:
                return 'application/octet-binary';
            case LoaderResource.XHR_RESPONSE_TYPE.BLOB:
                return 'application/blob';
            case LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT:
                return 'application/xml';
            case LoaderResource.XHR_RESPONSE_TYPE.JSON:
                return 'application/json';
            case LoaderResource.XHR_RESPONSE_TYPE.DEFAULT:
            case LoaderResource.XHR_RESPONSE_TYPE.TEXT:
            /* falls through */ default:
                return 'text/plain';
        }
    };
    return LoaderResource;
}();
// eslint-disable-next-line @typescript-eslint/no-namespace
(function(LoaderResource) {
    /**
     * The types of resources a resource could represent.
     *
     * @static
     * @readonly
     * @enum {number}
     * @memberof PIXI.LoaderResource
     */ var STATUS_FLAGS;
    (function(STATUS_FLAGS) {
        /** None */ STATUS_FLAGS[STATUS_FLAGS["NONE"] = 0] = "NONE";
        /** Data URL */ STATUS_FLAGS[STATUS_FLAGS["DATA_URL"] = 1] = "DATA_URL";
        /** Complete */ STATUS_FLAGS[STATUS_FLAGS["COMPLETE"] = 2] = "COMPLETE";
        /** Loading */ STATUS_FLAGS[STATUS_FLAGS["LOADING"] = 4] = "LOADING";
    })(STATUS_FLAGS = LoaderResource.STATUS_FLAGS || (LoaderResource.STATUS_FLAGS = {}));
    /**
     * The types of resources a resource could represent.
     *
     * @static
     * @readonly
     * @enum {number}
     * @memberof PIXI.LoaderResource
     */ var TYPE;
    (function(TYPE) {
        /** Unknown */ TYPE[TYPE["UNKNOWN"] = 0] = "UNKNOWN";
        /** JSON */ TYPE[TYPE["JSON"] = 1] = "JSON";
        /** XML */ TYPE[TYPE["XML"] = 2] = "XML";
        /** Image */ TYPE[TYPE["IMAGE"] = 3] = "IMAGE";
        /** Audio */ TYPE[TYPE["AUDIO"] = 4] = "AUDIO";
        /** Video */ TYPE[TYPE["VIDEO"] = 5] = "VIDEO";
        /** Plain text */ TYPE[TYPE["TEXT"] = 6] = "TEXT";
    })(TYPE = LoaderResource.TYPE || (LoaderResource.TYPE = {}));
    /**
     * The types of loading a resource can use.
     *
     * @static
     * @readonly
     * @enum {number}
     * @memberof PIXI.LoaderResource
     */ var LOAD_TYPE;
    (function(LOAD_TYPE) {
        /** Uses XMLHttpRequest to load the resource. */ LOAD_TYPE[LOAD_TYPE["XHR"] = 1] = "XHR";
        /** Uses an `Image` object to load the resource. */ LOAD_TYPE[LOAD_TYPE["IMAGE"] = 2] = "IMAGE";
        /** Uses an `Audio` object to load the resource. */ LOAD_TYPE[LOAD_TYPE["AUDIO"] = 3] = "AUDIO";
        /** Uses a `Video` object to load the resource. */ LOAD_TYPE[LOAD_TYPE["VIDEO"] = 4] = "VIDEO";
    })(LOAD_TYPE = LoaderResource.LOAD_TYPE || (LoaderResource.LOAD_TYPE = {}));
    /**
     * The XHR ready states, used internally.
     *
     * @static
     * @readonly
     * @enum {string}
     * @memberof PIXI.LoaderResource
     */ var XHR_RESPONSE_TYPE;
    (function(XHR_RESPONSE_TYPE) {
        /** string */ XHR_RESPONSE_TYPE["DEFAULT"] = "text";
        /** ArrayBuffer */ XHR_RESPONSE_TYPE["BUFFER"] = "arraybuffer";
        /** Blob */ XHR_RESPONSE_TYPE["BLOB"] = "blob";
        /** Document */ XHR_RESPONSE_TYPE["DOCUMENT"] = "document";
        /** Object */ XHR_RESPONSE_TYPE["JSON"] = "json";
        /** String */ XHR_RESPONSE_TYPE["TEXT"] = "text";
    })(XHR_RESPONSE_TYPE = LoaderResource.XHR_RESPONSE_TYPE || (LoaderResource.XHR_RESPONSE_TYPE = {}));
    LoaderResource._loadTypeMap = {
        // images
        gif: LoaderResource.LOAD_TYPE.IMAGE,
        png: LoaderResource.LOAD_TYPE.IMAGE,
        bmp: LoaderResource.LOAD_TYPE.IMAGE,
        jpg: LoaderResource.LOAD_TYPE.IMAGE,
        jpeg: LoaderResource.LOAD_TYPE.IMAGE,
        tif: LoaderResource.LOAD_TYPE.IMAGE,
        tiff: LoaderResource.LOAD_TYPE.IMAGE,
        webp: LoaderResource.LOAD_TYPE.IMAGE,
        tga: LoaderResource.LOAD_TYPE.IMAGE,
        svg: LoaderResource.LOAD_TYPE.IMAGE,
        'svg+xml': LoaderResource.LOAD_TYPE.IMAGE,
        // audio
        mp3: LoaderResource.LOAD_TYPE.AUDIO,
        ogg: LoaderResource.LOAD_TYPE.AUDIO,
        wav: LoaderResource.LOAD_TYPE.AUDIO,
        // videos
        mp4: LoaderResource.LOAD_TYPE.VIDEO,
        webm: LoaderResource.LOAD_TYPE.VIDEO
    };
    LoaderResource._xhrTypeMap = {
        // xml
        xhtml: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        html: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        htm: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        xml: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        tmx: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        svg: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
        // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
        // this should probably be fine.
        tsx: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        // images
        gif: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        png: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        bmp: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        jpg: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        jpeg: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        tif: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        tiff: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        webp: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        tga: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        // json
        json: LoaderResource.XHR_RESPONSE_TYPE.JSON,
        // text
        text: LoaderResource.XHR_RESPONSE_TYPE.TEXT,
        txt: LoaderResource.XHR_RESPONSE_TYPE.TEXT,
        // fonts
        ttf: LoaderResource.XHR_RESPONSE_TYPE.BUFFER,
        otf: LoaderResource.XHR_RESPONSE_TYPE.BUFFER
    };
    // We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
    LoaderResource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
})($f4285cd755ab388f$export$3a2d98834c8b0432 || ($f4285cd755ab388f$export$3a2d98834c8b0432 = {}));
/**
 * Smaller version of the async library constructs.
 * @ignore
 */ function $f4285cd755ab388f$var$_noop$1() {}
/**
 * Ensures a function is only called once.
 * @ignore
 * @param {function} fn - The function to wrap.
 * @return {function} The wrapping function.
 */ function $f4285cd755ab388f$var$onlyOnce(fn) {
    return function onceWrapper() {
        var arguments$1 = arguments;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments$1[_i];
        if (fn === null) throw new Error('Callback was already called.');
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
/**
 * @private
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$AsyncQueueItem = /** @class */ function() {
    /**
     * @private
     */ function AsyncQueueItem(data, callback) {
        this.data = data;
        this.callback = callback;
    }
    return AsyncQueueItem;
}();
/**
 * @private
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$AsyncQueue = /** @class */ function() {
    /**
     * @private
     */ function AsyncQueue(worker, concurrency) {
        var _this = this;
        if (concurrency === void 0) concurrency = 1;
        this.workers = 0;
        this.saturated = $f4285cd755ab388f$var$_noop$1;
        this.unsaturated = $f4285cd755ab388f$var$_noop$1;
        this.empty = $f4285cd755ab388f$var$_noop$1;
        this.drain = $f4285cd755ab388f$var$_noop$1;
        this.error = $f4285cd755ab388f$var$_noop$1;
        this.started = false;
        this.paused = false;
        this._tasks = [];
        this._insert = function(data, insertAtFront, callback) {
            if (callback && typeof callback !== 'function') throw new Error('task callback must be a function');
            _this.started = true;
            // eslint-disable-next-line no-eq-null,eqeqeq
            if (data == null && _this.idle()) {
                // call drain immediately if there are no tasks
                setTimeout(function() {
                    return _this.drain();
                }, 1);
                return;
            }
            var item = new $f4285cd755ab388f$var$AsyncQueueItem(data, typeof callback === 'function' ? callback : $f4285cd755ab388f$var$_noop$1);
            if (insertAtFront) _this._tasks.unshift(item);
            else _this._tasks.push(item);
            setTimeout(_this.process, 1);
        };
        this.process = function() {
            while(!_this.paused && _this.workers < _this.concurrency && _this._tasks.length){
                var task = _this._tasks.shift();
                if (_this._tasks.length === 0) _this.empty();
                _this.workers += 1;
                if (_this.workers === _this.concurrency) _this.saturated();
                _this._worker(task.data, $f4285cd755ab388f$var$onlyOnce(_this._next(task)));
            }
        };
        this._worker = worker;
        if (concurrency === 0) throw new Error('Concurrency must not be zero');
        this.concurrency = concurrency;
        this.buffer = concurrency / 4.0;
    }
    /**
     * @private
     */ AsyncQueue.prototype._next = function(task) {
        var _this = this;
        return function() {
            var arguments$1 = arguments;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments$1[_i];
            _this.workers -= 1;
            task.callback.apply(task, args);
            // eslint-disable-next-line no-eq-null,eqeqeq
            if (args[0] != null) _this.error(args[0], task.data);
            if (_this.workers <= _this.concurrency - _this.buffer) _this.unsaturated();
            if (_this.idle()) _this.drain();
            _this.process();
        };
    };
    // That was in object
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    AsyncQueue.prototype.push = function(data, callback) {
        this._insert(data, false, callback);
    };
    AsyncQueue.prototype.kill = function() {
        this.workers = 0;
        this.drain = $f4285cd755ab388f$var$_noop$1;
        this.started = false;
        this._tasks = [];
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    AsyncQueue.prototype.unshift = function(data, callback) {
        this._insert(data, true, callback);
    };
    AsyncQueue.prototype.length = function() {
        return this._tasks.length;
    };
    AsyncQueue.prototype.running = function() {
        return this.workers;
    };
    AsyncQueue.prototype.idle = function() {
        return this._tasks.length + this.workers === 0;
    };
    AsyncQueue.prototype.pause = function() {
        if (this.paused === true) return;
        this.paused = true;
    };
    AsyncQueue.prototype.resume = function() {
        if (this.paused === false) return;
        this.paused = false;
        // Need to call this.process once per concurrent
        // worker to preserve full concurrency after pause
        for(var w = 1; w <= this.concurrency; w++)this.process();
    };
    /**
     * Iterates an array in series.
     *
     * @param {Array.<*>} array - Array to iterate.
     * @param {function} iterator - Function to call for each element.
     * @param {function} callback - Function to call when done, or on error.
     * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
     */ AsyncQueue.eachSeries = function(array, iterator, callback, deferNext) {
        var i = 0;
        var len = array.length;
        function next(err) {
            if (err || i === len) {
                if (callback) callback(err);
                return;
            }
            if (deferNext) setTimeout(function() {
                iterator(array[i++], next);
            }, 1);
            else iterator(array[i++], next);
        }
        next();
    };
    /**
     * Async queue implementation,
     *
     * @param {function} worker - The worker function to call for each task.
     * @param {number} concurrency - How many workers to run in parrallel.
     * @return {*} The async queue object.
     */ AsyncQueue.queue = function(worker, concurrency) {
        return new AsyncQueue(worker, concurrency);
    };
    return AsyncQueue;
}();
// some constants
var $f4285cd755ab388f$var$MAX_PROGRESS = 100;
var $f4285cd755ab388f$var$rgxExtractUrlHash = /(#[\w-]+)?$/;
/**
 * The new loader, forked from Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
 *
 * ```js
 * const loader = PIXI.Loader.shared; // PixiJS exposes a premade instance for you to use.
 * // or
 * const loader = new PIXI.Loader(); // You can also create your own if you want
 *
 * const sprites = {};
 *
 * // Chainable `add` to enqueue a resource
 * loader.add('bunny', 'data/bunny.png')
 *       .add('spaceship', 'assets/spritesheet.json');
 * loader.add('scoreFont', 'assets/score.fnt');
 *
 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
 * loader.pre(cachingMiddleware);
 *
 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
 * loader.use(parsingMiddleware);
 *
 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
 * // resources have loaded.
 * loader.load((loader, resources) => {
 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
 *     // They have a couple default properties:
 *     // - `url`: The URL that the resource was loaded from
 *     // - `error`: The error that happened when trying to load (if any)
 *     // - `data`: The raw data that was loaded
 *     // also may contain other properties based on the middleware that runs.
 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
 * });
 *
 * // throughout the process multiple signals can be dispatched.
 * loader.onProgress.add(() => {}); // called once per loaded/errored file
 * loader.onError.add(() => {}); // called once per errored file
 * loader.onLoad.add(() => {}); // called once per loaded file
 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
 * ```
 *
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$3b0d6d7590275603 = /** @class */ function() {
    /**
     * @param baseUrl - The base url for all resources loaded by this loader.
     * @param concurrency - The number of resources to load concurrently.
     */ function Loader(baseUrl, concurrency) {
        var _this = this;
        if (baseUrl === void 0) baseUrl = '';
        if (concurrency === void 0) concurrency = 10;
        /**
         * The progress percent of the loader going through the queue.
         */ this.progress = 0;
        /**
         * Loading state of the loader, true if it is currently loading resources.
         */ this.loading = false;
        /**
         * A querystring to append to every URL added to the loader.
         *
         * This should be a valid query string *without* the question-mark (`?`). The loader will
         * also *not* escape values for you. Make sure to escape your parameters with
         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
         *
         * @example
         * const loader = new Loader();
         *
         * loader.defaultQueryString = 'user=me&password=secret';
         *
         * // This will request 'image.png?user=me&password=secret'
         * loader.add('image.png').load();
         *
         * loader.reset();
         *
         * // This will request 'image.png?v=1&user=me&password=secret'
         * loader.add('iamge.png?v=1').load();
         */ this.defaultQueryString = '';
        /**
         * The middleware to run before loading each resource.
         */ this._beforeMiddleware = [];
        /**
         * The middleware to run after loading each resource.
         */ this._afterMiddleware = [];
        /**
         * The tracks the resources we are currently completing parsing for.
         */ this._resourcesParsing = [];
        /**
         * The `_loadResource` function bound with this object context.
         *
         * @param r - The resource to load
         * @param d - The dequeue function
         */ this._boundLoadResource = function(r, d) {
            return _this._loadResource(r, d);
        };
        /**
         * All the resources for this loader keyed by name.
         */ this.resources = {};
        this.baseUrl = baseUrl;
        this._beforeMiddleware = [];
        this._afterMiddleware = [];
        this._resourcesParsing = [];
        this._boundLoadResource = function(r, d) {
            return _this._loadResource(r, d);
        };
        this._queue = $f4285cd755ab388f$var$AsyncQueue.queue(this._boundLoadResource, concurrency);
        this._queue.pause();
        this.resources = {};
        this.onProgress = new $f4285cd755ab388f$var$Signal();
        this.onError = new $f4285cd755ab388f$var$Signal();
        this.onLoad = new $f4285cd755ab388f$var$Signal();
        this.onStart = new $f4285cd755ab388f$var$Signal();
        this.onComplete = new $f4285cd755ab388f$var$Signal();
        for(var i = 0; i < Loader._plugins.length; ++i){
            var plugin = Loader._plugins[i];
            var pre = plugin.pre, use = plugin.use;
            if (pre) this.pre(pre);
            if (use) this.use(use);
        }
        this._protected = false;
    }
    /**
     * Same as add, params have strict order
     *
     * @private
     * @param name - The name of the resource to load.
     * @param url - The url for this resource, relative to the baseUrl of this loader.
     * @param options - The options for the load.
     * @param callback - Function to call when this specific resource completes loading.
     * @return The loader itself.
     */ Loader.prototype._add = function(name, url, options, callback) {
        // if loading already you can only add resources that have a parent.
        if (this.loading && (!options || !options.parentResource)) throw new Error('Cannot add resources while the loader is running.');
        // check if resource already exists.
        if (this.resources[name]) throw new Error("Resource named \"" + name + "\" already exists.");
        // add base url if this isn't an absolute url
        url = this._prepareUrl(url);
        // create the store the resource
        this.resources[name] = new $f4285cd755ab388f$export$3a2d98834c8b0432(name, url, options);
        if (typeof callback === 'function') this.resources[name].onAfterMiddleware.once(callback);
        // if actively loading, make sure to adjust progress chunks for that parent and its children
        if (this.loading) {
            var parent = options.parentResource;
            var incompleteChildren = [];
            for(var i = 0; i < parent.children.length; ++i)if (!parent.children[i].isComplete) incompleteChildren.push(parent.children[i]);
            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child
            parent.children.push(this.resources[name]);
            parent.progressChunk = eachChunk;
            for(var i = 0; i < incompleteChildren.length; ++i)incompleteChildren[i].progressChunk = eachChunk;
            this.resources[name].progressChunk = eachChunk;
        }
        // add the resource to the queue
        this._queue.push(this.resources[name]);
        return this;
    };
    /* eslint-enable require-jsdoc,valid-jsdoc */ /**
     * Sets up a middleware function that will run *before* the
     * resource is loaded.
     *
     * @param fn - The middleware function to register.
     * @return The loader itself.
     */ Loader.prototype.pre = function(fn) {
        this._beforeMiddleware.push(fn);
        return this;
    };
    /**
     * Sets up a middleware function that will run *after* the
     * resource is loaded.
     *
     * @param fn - The middleware function to register.
     * @return The loader itself.
     */ Loader.prototype.use = function(fn) {
        this._afterMiddleware.push(fn);
        return this;
    };
    /**
     * Resets the queue of the loader to prepare for a new load.
     *
     * @return The loader itself.
     */ Loader.prototype.reset = function() {
        this.progress = 0;
        this.loading = false;
        this._queue.kill();
        this._queue.pause();
        // abort all resource loads
        for(var k in this.resources){
            var res = this.resources[k];
            if (res._onLoadBinding) res._onLoadBinding.detach();
            if (res.isLoading) res.abort('loader reset');
        }
        this.resources = {};
        return this;
    };
    /**
     * Starts loading the queued resources.
     * @param cb - Optional callback that will be bound to the `complete` event.
     * @return The loader itself.
     */ Loader.prototype.load = function(cb) {
        // register complete callback if they pass one
        if (typeof cb === 'function') this.onComplete.once(cb);
        // if the queue has already started we are done here
        if (this.loading) return this;
        if (this._queue.idle()) {
            this._onStart();
            this._onComplete();
        } else {
            // distribute progress chunks
            var numTasks = this._queue._tasks.length;
            var chunk = $f4285cd755ab388f$var$MAX_PROGRESS / numTasks;
            for(var i = 0; i < this._queue._tasks.length; ++i)this._queue._tasks[i].data.progressChunk = chunk;
            // notify we are starting
            this._onStart();
            // start loading
            this._queue.resume();
        }
        return this;
    };
    Object.defineProperty(Loader.prototype, "concurrency", {
        /**
         * The number of resources to load concurrently.
         *
         * @default 10
         */ get: function() {
            return this._queue.concurrency;
        },
        set: function(concurrency) {
            this._queue.concurrency = concurrency;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Prepares a url for usage based on the configuration of this object
     * @param url - The url to prepare.
     * @return The prepared url.
     */ Loader.prototype._prepareUrl = function(url) {
        var parsedUrl = $f4285cd755ab388f$var$parseUri(url, {
            strictMode: true
        });
        var result;
        // absolute url, just use it as is.
        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) result = url;
        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') result = this.baseUrl + "/" + url;
        else result = this.baseUrl + url;
        // if we need to add a default querystring, there is a bit more work
        if (this.defaultQueryString) {
            var hash = $f4285cd755ab388f$var$rgxExtractUrlHash.exec(result)[0];
            result = result.substr(0, result.length - hash.length);
            if (result.indexOf('?') !== -1) result += "&" + this.defaultQueryString;
            else result += "?" + this.defaultQueryString;
            result += hash;
        }
        return result;
    };
    /**
     * Loads a single resource.
     *
     * @param resource - The resource to load.
     * @param dequeue - The function to call when we need to dequeue this item.
     */ Loader.prototype._loadResource = function(resource, dequeue) {
        var _this = this;
        resource._dequeue = dequeue;
        // run before middleware
        $f4285cd755ab388f$var$AsyncQueue.eachSeries(this._beforeMiddleware, function(fn, next) {
            fn.call(_this, resource, function() {
                // if the before middleware marks the resource as complete,
                // break and don't process any more before middleware
                next(resource.isComplete ? {} : null);
            });
        }, function() {
            if (resource.isComplete) _this._onLoad(resource);
            else {
                resource._onLoadBinding = resource.onComplete.once(_this._onLoad, _this);
                resource.load();
            }
        }, true);
    };
    /**
     * Called once loading has started.
     */ Loader.prototype._onStart = function() {
        this.progress = 0;
        this.loading = true;
        this.onStart.dispatch(this);
    };
    /**
     * Called once each resource has loaded.
     */ Loader.prototype._onComplete = function() {
        this.progress = $f4285cd755ab388f$var$MAX_PROGRESS;
        this.loading = false;
        this.onComplete.dispatch(this, this.resources);
    };
    /**
     * Called each time a resources is loaded.
     * @param resource - The resource that was loaded
     */ Loader.prototype._onLoad = function(resource) {
        var _this = this;
        resource._onLoadBinding = null;
        // remove this resource from the async queue, and add it to our list of resources that are being parsed
        this._resourcesParsing.push(resource);
        resource._dequeue();
        // run all the after middleware for this resource
        $f4285cd755ab388f$var$AsyncQueue.eachSeries(this._afterMiddleware, function(fn, next) {
            fn.call(_this, resource, next);
        }, function() {
            resource.onAfterMiddleware.dispatch(resource);
            _this.progress = Math.min($f4285cd755ab388f$var$MAX_PROGRESS, _this.progress + resource.progressChunk);
            _this.onProgress.dispatch(_this, resource);
            if (resource.error) _this.onError.dispatch(resource.error, _this, resource);
            else _this.onLoad.dispatch(_this, resource);
            _this._resourcesParsing.splice(_this._resourcesParsing.indexOf(resource), 1);
            // do completion check
            if (_this._queue.idle() && _this._resourcesParsing.length === 0) _this._onComplete();
        }, true);
    };
    /**
     * Destroy the loader, removes references.
     */ Loader.prototype.destroy = function() {
        if (!this._protected) this.reset();
    };
    Object.defineProperty(Loader, "shared", {
        /**
         * A premade instance of the loader that can be used to load resources.
         */ get: function() {
            var shared = Loader._shared;
            if (!shared) {
                shared = new Loader();
                shared._protected = true;
                Loader._shared = shared;
            }
            return shared;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a Loader plugin for the global shared loader and all
     * new Loader instances created.
     *
     * @param plugin - The plugin to add
     * @return Reference to PIXI.Loader for chaining
     */ Loader.registerPlugin = function(plugin) {
        Loader._plugins.push(plugin);
        if (plugin.add) plugin.add();
        return Loader;
    };
    Loader._plugins = [];
    return Loader;
}();
$f4285cd755ab388f$export$3b0d6d7590275603.prototype.add = function add(name, url, options, callback) {
    // special case of an array of objects or urls
    if (Array.isArray(name)) {
        for(var i = 0; i < name.length; ++i)this.add(name[i]);
        return this;
    }
    // if an object is passed instead of params
    if (typeof name === 'object') {
        options = name;
        callback = url || options.callback || options.onComplete;
        url = options.url;
        name = options.name || options.key || options.url;
    }
    // case where no name is passed shift all args over by one.
    if (typeof url !== 'string') {
        callback = options;
        options = url;
        url = name;
    }
    // now that we shifted make sure we have a proper url.
    if (typeof url !== 'string') throw new Error('No url passed to add resource to loader.');
    // options are optional so people might pass a function and no options
    if (typeof options === 'function') {
        callback = options;
        options = null;
    }
    return this._add(name, url, options, callback);
};
/**
 * Application plugin for supporting loader option. Installing the LoaderPlugin
 * is not necessary if using **pixi.js** or **pixi.js-legacy**.
 * @example
 * import {AppLoaderPlugin} from '@pixi/loaders';
 * import {Application} from '@pixi/app';
 * Application.registerPlugin(AppLoaderPlugin);
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$4d6e8fa105d8152b = /** @class */ function() {
    function AppLoaderPlugin() {}
    /**
     * Called on application constructor
     *
     * @private
     */ AppLoaderPlugin.init = function(options) {
        options = Object.assign({
            sharedLoader: false
        }, options);
        this.loader = options.sharedLoader ? $f4285cd755ab388f$export$3b0d6d7590275603.shared : new $f4285cd755ab388f$export$3b0d6d7590275603();
    };
    /**
     * Called when application destroyed
     *
     * @private
     */ AppLoaderPlugin.destroy = function() {
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
    };
    return AppLoaderPlugin;
}();
/**
 * Loader plugin for handling Texture resources.
 *
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$fd1bfc71f64c538c = /** @class */ function() {
    function TextureLoader() {}
    /**
     * Handle SVG elements a text, render with SVGResource.
     */ TextureLoader.add = function() {
        $f4285cd755ab388f$export$3a2d98834c8b0432.setExtensionLoadType('svg', $f4285cd755ab388f$export$3a2d98834c8b0432.LOAD_TYPE.XHR);
        $f4285cd755ab388f$export$3a2d98834c8b0432.setExtensionXhrType('svg', $f4285cd755ab388f$export$3a2d98834c8b0432.XHR_RESPONSE_TYPE.TEXT);
    };
    /**
     * Called after a resource is loaded.
     * @see PIXI.Loader.loaderMiddleware
     * @param resource
     * @param {function} next
     */ TextureLoader.use = function(resource, next) {
        // create a new texture if the data is an Image object
        if (resource.data && (resource.type === $f4285cd755ab388f$export$3a2d98834c8b0432.TYPE.IMAGE || resource.extension === 'svg')) {
            var data = resource.data, url = resource.url, name = resource.name, metadata = resource.metadata;
            (0, $klOfb.Texture).fromLoader(data, url, name, metadata).then(function(texture) {
                resource.texture = texture;
                next();
            })// TODO: handle errors in Texture.fromLoader
            // so we can pass them to the Loader
            .catch(next);
        } else next();
    };
    return TextureLoader;
}();
var $f4285cd755ab388f$var$_keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encodes binary into base64.
 *
 * @function encodeBinary
 * @param {string} input - The input data to encode.
 * @returns {string} The encoded base64 string
 */ function $f4285cd755ab388f$var$encodeBinary(input) {
    var output = '';
    var inx = 0;
    while(inx < input.length){
        // Fill byte buffer array
        var bytebuffer = [
            0,
            0,
            0
        ];
        var encodedCharIndexes = [
            0,
            0,
            0,
            0
        ];
        for(var jnx = 0; jnx < bytebuffer.length; ++jnx)if (inx < input.length) // throw away high-order byte, as documented at:
        // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
        bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
        else bytebuffer[jnx] = 0;
        // Get each encoded character, 6 bits at a time
        // index 1: first 6 bits
        encodedCharIndexes[0] = bytebuffer[0] >> 2;
        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;
        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;
        // index 3: forth 6 bits (6 least significant bits from input byte 3)
        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;
        // Determine whether padding happened, and adjust accordingly
        var paddingBytes = inx - (input.length - 1);
        switch(paddingBytes){
            case 2:
                // Set last 2 characters to padding char
                encodedCharIndexes[3] = 64;
                encodedCharIndexes[2] = 64;
                break;
            case 1:
                // Set last character to padding char
                encodedCharIndexes[3] = 64;
                break;
        }
        // Now we will grab each appropriate character out of our keystring
        // based on our index array and append it to the output string
        for(var jnx = 0; jnx < encodedCharIndexes.length; ++jnx)output += $f4285cd755ab388f$var$_keyStr.charAt(encodedCharIndexes[jnx]);
    }
    return output;
}
var $f4285cd755ab388f$var$Url = self.URL || self.webkitURL;
/**
 * A middleware for transforming XHR loaded Blobs into more useful objects
 *
 * @ignore
 * @function parsing
 * @example
 * import { Loader, middleware } from 'resource-loader';
 * const loader = new Loader();
 * loader.use(middleware.parsing);
 * @param resource - Current Resource
 * @param next - Callback when complete
 */ function $f4285cd755ab388f$var$parsing(resource, next) {
    if (!resource.data) {
        next();
        return;
    }
    // if this was an XHR load of a blob
    if (resource.xhr && resource.xhrType === $f4285cd755ab388f$export$3a2d98834c8b0432.XHR_RESPONSE_TYPE.BLOB) {
        // if there is no blob support we probably got a binary string back
        if (!self.Blob || typeof resource.data === 'string') {
            var type = resource.xhr.getResponseHeader('content-type');
            // this is an image, convert the binary string into a data url
            if (type && type.indexOf('image') === 0) {
                resource.data = new Image();
                resource.data.src = "data:" + type + ";base64," + $f4285cd755ab388f$var$encodeBinary(resource.xhr.responseText);
                resource.type = $f4285cd755ab388f$export$3a2d98834c8b0432.TYPE.IMAGE;
                // wait until the image loads and then callback
                resource.data.onload = function() {
                    resource.data.onload = null;
                    next();
                };
                // next will be called on load
                return;
            }
        } else if (resource.data.type.indexOf('image') === 0) {
            var src_1 = $f4285cd755ab388f$var$Url.createObjectURL(resource.data);
            resource.blob = resource.data;
            resource.data = new Image();
            resource.data.src = src_1;
            resource.type = $f4285cd755ab388f$export$3a2d98834c8b0432.TYPE.IMAGE;
            // cleanup the no longer used blob after the image loads
            // TODO: Is this correct? Will the image be invalid after revoking?
            resource.data.onload = function() {
                $f4285cd755ab388f$var$Url.revokeObjectURL(src_1);
                resource.data.onload = null;
                next();
            };
            // next will be called on load.
            return;
        }
    }
    next();
}
// parse any blob into more usable objects (e.g. Image)
$f4285cd755ab388f$export$3b0d6d7590275603.registerPlugin({
    use: $f4285cd755ab388f$var$parsing
});
// parse any Image objects into textures
$f4285cd755ab388f$export$3b0d6d7590275603.registerPlugin($f4285cd755ab388f$export$fd1bfc71f64c538c);

});

parcelRegister("ejo0r", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_FORMATS", function () { return $a6b5762b13998910$export$9a3c57b95f3e5f5d; });
$parcel$export(module.exports, "INTERNAL_FORMAT_TO_BYTES_PER_PIXEL", function () { return $a6b5762b13998910$export$fb888e587c979eee; });
$parcel$export(module.exports, "BlobResource", function () { return $a6b5762b13998910$export$f257f839012584a2; });
$parcel$export(module.exports, "CompressedTextureResource", function () { return $a6b5762b13998910$export$1982af6892f05657; });
$parcel$export(module.exports, "CompressedTextureLoader", function () { return $a6b5762b13998910$export$bd73ce947a280350; });
$parcel$export(module.exports, "DDSLoader", function () { return $a6b5762b13998910$export$7c2d2826fcfc7c67; });
$parcel$export(module.exports, "TYPES_TO_BYTES_PER_COMPONENT", function () { return $a6b5762b13998910$export$96c88eb9c7372a0b; });
$parcel$export(module.exports, "FORMATS_TO_COMPONENTS", function () { return $a6b5762b13998910$export$ace48b1390b9b0c2; });
$parcel$export(module.exports, "TYPES_TO_BYTES_PER_PIXEL", function () { return $a6b5762b13998910$export$2ca26443044e8798; });
$parcel$export(module.exports, "KTXLoader", function () { return $a6b5762b13998910$export$f154586e513f353e; });
/*!
 * @pixi/compressed-textures - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/compressed-textures is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $kXE1p = parcelRequire("kXE1p");

var $csytw = parcelRequire("csytw");

var $P8XPi = parcelRequire("P8XPi");
var $a6b5762b13998910$var$_a;
/**
 * WebGL internal formats, including compressed texture formats provided by extensions
 *
 * @memberof PIXI
 * @static
 * @name INTERNAL_FORMATS
 * @enum {number}
 * @property {number} COMPRESSED_RGB_S3TC_DXT1_EXT=0x83F0
 * @property {number} COMPRESSED_RGBA_S3TC_DXT1_EXT=0x83F1
 * @property {number} COMPRESSED_RGBA_S3TC_DXT3_EXT=0x83F2
 * @property {number} COMPRESSED_RGBA_S3TC_DXT5_EXT=0x83F3
 * @property {number} COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT=35917
 * @property {number} COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT=35918
 * @property {number} COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT=35919
 * @property {number} COMPRESSED_SRGB_S3TC_DXT1_EXT=35916
 * @property {number} COMPRESSED_R11_EAC=0x9270
 * @property {number} COMPRESSED_SIGNED_R11_EAC=0x9271
 * @property {number} COMPRESSED_RG11_EAC=0x9272
 * @property {number} COMPRESSED_SIGNED_RG11_EAC=0x9273
 * @property {number} COMPRESSED_RGB8_ETC2=0x9274
 * @property {number} COMPRESSED_RGBA8_ETC2_EAC=0x9278
 * @property {number} COMPRESSED_SRGB8_ETC2=0x9275
 * @property {number} COMPRESSED_SRGB8_ALPHA8_ETC2_EAC=0x9279
 * @property {number} COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2=0x9276
 * @property {number} COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2=0x9277
 * @property {number} COMPRESSED_RGB_PVRTC_4BPPV1_IMG=0x8C00
 * @property {number} COMPRESSED_RGBA_PVRTC_4BPPV1_IMG=0x8C02
 * @property {number} COMPRESSED_RGB_PVRTC_2BPPV1_IMG=0x8C01
 * @property {number} COMPRESSED_RGBA_PVRTC_2BPPV1_IMG=0x8C03
 * @property {number} COMPRESSED_RGB_ETC1_WEBGL=0x8D64
 * @property {number} COMPRESSED_RGB_ATC_WEBGL=0x8C92
 * @property {number} COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL=0x8C92
 * @property {number} COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL=0x87EE
 */ var $a6b5762b13998910$export$9a3c57b95f3e5f5d;
(function(INTERNAL_FORMATS) {
    // WEBGL_compressed_texture_s3tc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
    // WEBGL_compressed_texture_s3tc_srgb
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT"] = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT"] = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT"] = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_S3TC_DXT1_EXT"] = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT";
    // WEBGL_compressed_texture_etc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA8_ETC2_EAC"] = 37496] = "COMPRESSED_RGBA8_ETC2_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB8_ETC2"] = 37493] = "COMPRESSED_SRGB8_ETC2";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    // WEBGL_compressed_texture_pvrtc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_PVRTC_2BPPV1_IMG"] = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"] = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG";
    // WEBGL_compressed_texture_etc1
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
    // WEBGL_compressed_texture_atc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_ATC_WEBGL"] = 35986] = "COMPRESSED_RGB_ATC_WEBGL";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL"] = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"] = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL";
})($a6b5762b13998910$export$9a3c57b95f3e5f5d || ($a6b5762b13998910$export$9a3c57b95f3e5f5d = {}));
/**
 * Maps the compressed texture formats in {@link PIXI.INTERNAL_FORMATS} to the number of bytes taken by
 * each texel.
 *
 * @memberof PIXI
 * @static
 * @ignore
 */ var $a6b5762b13998910$export$fb888e587c979eee = ($a6b5762b13998910$var$_a = {}, // WEBGL_compressed_texture_s3tc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1, // WEBGL_compressed_texture_s3tc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT] = 1, // WEBGL_compressed_texture_etc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_R11_EAC] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SIGNED_R11_EAC] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RG11_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SIGNED_RG11_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB8_ETC2] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA8_ETC2_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB8_ETC2] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2] = 0.5, // WEBGL_compressed_texture_pvrtc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25, // WEBGL_compressed_texture_etc1
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_ETC1_WEBGL] = 0.5, // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
// WEBGL_compressed_texture_atc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_ATC_WEBGL] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1, $a6b5762b13998910$var$_a);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $a6b5762b13998910$var$extendStatics = function(d, b) {
    $a6b5762b13998910$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a6b5762b13998910$var$extendStatics(d, b);
};
function $a6b5762b13998910$var$__extends(d, b) {
    $a6b5762b13998910$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $a6b5762b13998910$var$__awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a6b5762b13998910$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Resource that fetches texture data over the network and stores it in a buffer.
 *
 * @class
 * @extends PIXI.Resource
 * @memberof PIXI
 */ var $a6b5762b13998910$export$f257f839012584a2 = /** @class */ function(_super) {
    $a6b5762b13998910$var$__extends(BlobResource, _super);
    /**
     * @param {string} url - the URL of the texture file
     * @param {boolean}[autoLoad] - whether to fetch the data immediately;
     *  you can fetch it later via {@link BlobResource#load}
     */ function BlobResource(source, options) {
        if (options === void 0) options = {
            width: 1,
            height: 1,
            autoLoad: true
        };
        var _this = this;
        var origin;
        var data;
        if (typeof source === 'string') {
            origin = source;
            data = new Uint8Array();
        } else {
            origin = null;
            data = source;
        }
        _this = _super.call(this, data, options) || this;
        /**
         * The URL of the texture file
         * @member {string}
         */ _this.origin = origin;
        /**
         * The viewable buffer on the data
         * @member {ViewableBuffer}
         */ // HINT: BlobResource allows "null" sources, assuming the child class provides an alternative
        _this.buffer = data ? new (0, $klOfb.ViewableBuffer)(data) : null;
        // Allow autoLoad = "undefined" still load the resource by default
        if (_this.origin && options.autoLoad !== false) _this.load();
        if (data && data.length) {
            _this.loaded = true;
            _this.onBlobLoaded(_this.buffer.rawBinaryData);
        }
        return _this;
    }
    BlobResource.prototype.onBlobLoaded = function(_data) {
    // TODO: Override this method
    };
    /**
     * Loads the blob
     */ BlobResource.prototype.load = function() {
        return $a6b5762b13998910$var$__awaiter(this, void 0, Promise, function() {
            var response, blob, arrayBuffer;
            return $a6b5762b13998910$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(this.origin)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.blob()
                        ];
                    case 2:
                        blob = _a.sent();
                        return [
                            4 /*yield*/ ,
                            blob.arrayBuffer()
                        ];
                    case 3:
                        arrayBuffer = _a.sent();
                        this.data = new Uint32Array(arrayBuffer);
                        this.buffer = new (0, $klOfb.ViewableBuffer)(arrayBuffer);
                        this.loaded = true;
                        this.onBlobLoaded(arrayBuffer);
                        this.update();
                        return [
                            2 /*return*/ ,
                            this
                        ];
                }
            });
        });
    };
    return BlobResource;
}((0, $klOfb.BufferResource));
/**
 * Resource for compressed texture formats, as follows: S3TC/DXTn (& their sRGB formats), ATC, ASTC, ETC 1/2, PVRTC.
 *
 * Compressed textures improve performance when rendering is texture-bound. The texture data stays compressed in
 * graphics memory, increasing memory locality and speeding up texture fetches. These formats can also be used to store
 * more detail in the same amount of memory.
 *
 * For most developers, container file formats are a better abstraction instead of directly handling raw texture
 * data. PixiJS provides native support for the following texture file formats (via {@link PIXI.Loader}):
 *
 * * **.dds** - the DirectDraw Surface file format stores DXTn (DXT-1,3,5) data. See {@link PIXI.DDSLoader}
 * * **.ktx** - the Khronos Texture Container file format supports storing all the supported WebGL compression formats.
 *  See {@link PIXI.KTXLoader}.
 * * **.basis** - the BASIS supercompressed file format stores texture data in an internal format that is transcoded
 *  to the compression format supported on the device at _runtime_. It also supports transcoding into a uncompressed
 *  format as a fallback; you must install the `@pixi/basis-loader`, `@pixi/basis-transcoder` packages separately to
 *  use these files. See {@link PIXI.BasisLoader}.
 *
 * The loaders for the aforementioned formats use `CompressedTextureResource` internally. It is strongly suggested that
 * they be used instead.
 *
 * ## Working directly with CompressedTextureResource
 *
 * Since `CompressedTextureResource` inherits `BlobResource`, you can provide it a URL pointing to a file containing
 * the raw texture data (with no file headers!):
 *
 * ```js
 * // The resource backing the texture data for your textures.
 * // NOTE: You can also provide a ArrayBufferView instead of a URL. This is used when loading data from a container file
 * //   format such as KTX, DDS, or BASIS.
 * const compressedResource = new PIXI.CompressedTextureResource("bunny.dxt5", {
 *   format: PIXI.INTERNAL_FORMATS.COMPRESSED_RGBA_S3TC_DXT5_EXT,
 *   width: 256,
 *   height: 256
 * });
 *
 * // You can create a base-texture to the cache, so that future `Texture`s can be created using the `Texture.from` API.
 * const baseTexture = new PIXI.BaseTexture(compressedResource, { pmaMode: PIXI.ALPHA_MODES.NPM });
 *
 * // Create a Texture to add to the TextureCache
 * const texture = new PIXI.Texture(baseTexture);
 *
 * // Add baseTexture & texture to the global texture cache
 * PIXI.BaseTexture.addToCache(baseTexture, "bunny.dxt5");
 * PIXI.Texture.addToCache(texture, "bunny.dxt5");
 * ```
 *
 * @memberof PIXI
 */ var $a6b5762b13998910$export$1982af6892f05657 = /** @class */ function(_super) {
    $a6b5762b13998910$var$__extends(CompressedTextureResource, _super);
    /**
     * @param source - the buffer/URL holding the compressed texture data
     * @param options
     * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
     * @param {number} options.width - the image width in pixels.
     * @param {number} options.height - the image height in pixels.
     * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
     * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
     *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
     */ function CompressedTextureResource(source, options) {
        var _this = _super.call(this, source, options) || this;
        _this.format = options.format;
        _this.levels = options.levels || 1;
        _this._width = options.width;
        _this._height = options.height;
        _this._extension = CompressedTextureResource._formatToExtension(_this.format);
        if (options.levelBuffers || _this.buffer) // ViewableBuffer doesn't support byteOffset :-( so allow source to be Uint8Array
        _this._levelBuffers = options.levelBuffers || CompressedTextureResource._createLevelBuffers(source instanceof Uint8Array ? source : _this.buffer.uint8View, _this.format, _this.levels, 4, 4, _this.width, _this.height);
        return _this;
    }
    /**
     * @override
     * @param renderer - A reference to the current renderer
     * @param _texture - the texture
     * @param _glTexture - texture instance for this webgl context
     */ CompressedTextureResource.prototype.upload = function(renderer, _texture, _glTexture) {
        var gl = renderer.gl;
        var extension = renderer.context.extensions[this._extension];
        if (!extension) throw new Error(this._extension + " textures are not supported on the current machine");
        if (!this._levelBuffers) // Do not try to upload data before BlobResource loads, unless the levelBuffers were provided directly!
        return false;
        for(var i = 0, j = this.levels; i < j; i++){
            var _a = this._levelBuffers[i], levelID = _a.levelID, levelWidth = _a.levelWidth, levelHeight = _a.levelHeight, levelBuffer = _a.levelBuffer;
            gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
        }
        return true;
    };
    /** @protected */ CompressedTextureResource.prototype.onBlobLoaded = function() {
        this._levelBuffers = CompressedTextureResource._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, this.width, this.height);
    };
    /**
     * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
     *
     * @private
     * @param format - the compression format to get the extension for.
     */ CompressedTextureResource._formatToExtension = function(format) {
        if (format >= 0x83F0 && format <= 0x83F3) return 's3tc';
        else if (format >= 0x9270 && format <= 0x9279) return 'etc';
        else if (format >= 0x8C00 && format <= 0x8C03) return 'pvrtc';
        else if (format >= 0x8D64) return 'etc1';
        else if (format >= 0x8C92 && format <= 0x87EE) return 'atc';
        throw new Error('Invalid (compressed) texture format given!');
    };
    /**
     * Pre-creates buffer views for each mipmap level
     *
     * @private
     * @param buffer -
     * @param format - compression formats
     * @param levels - mipmap levels
     * @param blockWidth -
     * @param blockHeight -
     * @param imageWidth - width of the image in pixels
     * @param imageHeight - height of the image in pixels
     */ CompressedTextureResource._createLevelBuffers = function(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
        // The byte-size of the first level buffer
        var buffers = new Array(levels);
        var offset = buffer.byteOffset;
        var levelWidth = imageWidth;
        var levelHeight = imageHeight;
        var alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
        var alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
        var levelSize = alignedLevelWidth * alignedLevelHeight * $a6b5762b13998910$export$fb888e587c979eee[format];
        for(var i = 0; i < levels; i++){
            buffers[i] = {
                levelID: i,
                levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
                levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
                levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
            };
            offset += levelSize;
            // Calculate levelBuffer dimensions for next iteration
            levelWidth = levelWidth >> 1 || 1;
            levelHeight = levelHeight >> 1 || 1;
            alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
            alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
            levelSize = alignedLevelWidth * alignedLevelHeight * $a6b5762b13998910$export$fb888e587c979eee[format];
        }
        return buffers;
    };
    return CompressedTextureResource;
}($a6b5762b13998910$export$f257f839012584a2);
/* eslint-enable camelcase */ /**
 * Loader plugin for handling compressed textures for all platforms.
 *
 * @class
 * @memberof PIXI
 * @implements PIXI.ILoaderPlugin
 */ var $a6b5762b13998910$export$bd73ce947a280350 = /** @class */ function() {
    function CompressedTextureLoader() {}
    /**
     * Called after a compressed-textures manifest is loaded.
     *
     * This will then load the correct compression format for the device. Your manifest should adhere
     * to the following schema:
     *
     * ```js
     * import { INTERNAL_FORMATS } from '@pixi/constants';
     *
     * type CompressedTextureManifest = {
     *  textures: Array<{ src: string, format?: keyof INTERNAL_FORMATS}>,
     *  cacheID: string;
     * };
     * ```
     *
     * This is an example of a .json manifest file
     *
     * ```json
     * {
     *   "cacheID":"asset",
     *   "textures":[
     *     { "src":"asset.fallback.png" },
     *     { "format":"COMPRESSED_RGBA_S3TC_DXT5_EXT", "src":"asset.s3tc.ktx" },
     *     { "format":"COMPRESSED_RGBA8_ETC2_EAC", "src":"asset.etc.ktx" },
     *     { "format":"RGBA_PVRTC_4BPPV1_IMG", "src":"asset.pvrtc.ktx" }
     *   ]
     * }
     * ```
     */ CompressedTextureLoader.use = function(resource, next) {
        var data = resource.data;
        var loader = this;
        if (resource.type === (0, $kXE1p.LoaderResource).TYPE.JSON && data && data.cacheID && data.textures) {
            var textures = data.textures;
            var textureURL = void 0;
            var fallbackURL = void 0;
            // Search for an extension that holds one the formats
            for(var i = 0, j = textures.length; i < j; i++){
                var texture = textures[i];
                var url_1 = texture.src;
                var format = texture.format;
                if (!format) fallbackURL = url_1;
                if (CompressedTextureLoader.textureFormats[format]) {
                    textureURL = url_1;
                    break;
                }
            }
            textureURL = textureURL || fallbackURL;
            // Make sure we have a URL
            if (!textureURL) {
                next(new Error("Cannot load compressed-textures in " + resource.url + ", make sure you provide a fallback"));
                return;
            }
            if (textureURL === resource.url) {
                // Prevent infinite loops
                next(new Error('URL of compressed texture cannot be the same as the manifest\'s URL'));
                return;
            }
            var loadOptions = {
                crossOrigin: resource.crossOrigin,
                metadata: resource.metadata.imageMetadata,
                parentResource: resource
            };
            var resourcePath = (0, $csytw.url).resolve(resource.url.replace(loader.baseUrl, ''), textureURL);
            var resourceName = data.cacheID;
            // The appropriate loader should register the texture
            loader.add(resourceName, resourcePath, loadOptions, function(res) {
                if (res.error) {
                    next(res.error);
                    return;
                }
                var _a = res.texture, texture = _a === void 0 ? null : _a, _b = res.textures, textures = _b === void 0 ? {} : _b;
                // Make sure texture/textures is assigned to parent resource
                Object.assign(resource, {
                    texture: texture,
                    textures: textures
                });
                // Pass along any error
                next();
            });
        } else next();
    };
    /**
     * Detects the available compressed texture extensions on the device.
     * @ignore
     */ CompressedTextureLoader.add = function() {
        // Auto-detect WebGL compressed-texture extensions
        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl');
        if (!gl) {
            console.warn('WebGL not available for compressed textures. Silently failing.');
            return;
        }
        var extensions = {
            s3tc: gl.getExtension('WEBGL_compressed_texture_s3tc'),
            s3tc_sRGB: gl.getExtension('WEBGL_compressed_texture_s3tc_srgb'),
            etc: gl.getExtension('WEBGL_compressed_texture_etc'),
            etc1: gl.getExtension('WEBGL_compressed_texture_etc1'),
            pvrtc: gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc'),
            atc: gl.getExtension('WEBGL_compressed_texture_atc'),
            astc: gl.getExtension('WEBGL_compressed_texture_astc')
        };
        CompressedTextureLoader.textureExtensions = extensions;
        CompressedTextureLoader.textureFormats = {};
        // Assign all available compressed-texture formats
        for(var extensionName in extensions){
            var extension = extensions[extensionName];
            if (!extension) continue;
            Object.assign(CompressedTextureLoader.textureFormats, Object.getPrototypeOf(extension));
        }
    };
    return CompressedTextureLoader;
}();
/**
 * Creates base-textures and textures for each compressed-texture resource and adds them into the global
 * texture cache. The first texture has two IDs - `${url}`, `${url}-1`; while the rest have an ID of the
 * form `${url}-i`.
 *
 * @param url - the original address of the resources
 * @param resources - the resources backing texture data
 * @ignore
 */ function $a6b5762b13998910$var$registerCompressedTextures(url, resources, metadata) {
    var result = {
        textures: {},
        texture: null
    };
    if (!resources) return result;
    var textures = resources.map(function(resource) {
        return new (0, $klOfb.Texture)(new (0, $klOfb.BaseTexture)(resource, Object.assign({
            mipmap: (0, $P8XPi.MIPMAP_MODES).OFF,
            alphaMode: (0, $P8XPi.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA
        }, metadata)));
    });
    textures.forEach(function(texture, i) {
        var baseTexture = texture.baseTexture;
        var cacheID = url + "-" + (i + 1);
        (0, $klOfb.BaseTexture).addToCache(baseTexture, cacheID);
        (0, $klOfb.Texture).addToCache(texture, cacheID);
        if (i === 0) {
            (0, $klOfb.BaseTexture).addToCache(baseTexture, url);
            (0, $klOfb.Texture).addToCache(texture, url);
            result.texture = texture;
        }
        result.textures[cacheID] = texture;
    });
    return result;
}
var $a6b5762b13998910$var$_a$1, $a6b5762b13998910$var$_b;
// Set DDS files to be loaded as an ArrayBuffer
(0, $kXE1p.LoaderResource).setExtensionXhrType('dds', (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.BUFFER);
var $a6b5762b13998910$var$DDS_MAGIC_SIZE = 4;
var $a6b5762b13998910$var$DDS_HEADER_SIZE = 124;
var $a6b5762b13998910$var$DDS_HEADER_PF_SIZE = 32;
var $a6b5762b13998910$var$DDS_HEADER_DX10_SIZE = 20;
// DDS file format magic word
var $a6b5762b13998910$var$DDS_MAGIC = 0x20534444;
/**
 * DWORD offsets of the DDS file header fields (relative to file start).
 *
 * @ignore
 */ var $a6b5762b13998910$var$DDS_FIELDS = {
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19
};
/**
 * DWORD offsets of the DDS PIXEL_FORMAT fields.
 *
 * @ignore
 */ var $a6b5762b13998910$var$DDS_PF_FIELDS = {
    SIZE: 0,
    FLAGS: 1,
    FOURCC: 2,
    RGB_BITCOUNT: 3,
    R_BIT_MASK: 4,
    G_BIT_MASK: 5,
    B_BIT_MASK: 6,
    A_BIT_MASK: 7
};
/**
 * DWORD offsets of the DDS_HEADER_DX10 fields.
 *
 * @ignore
 */ var $a6b5762b13998910$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
};
/**
 * @see https://docs.microsoft.com/en-us/windows/win32/api/dxgiformat/ne-dxgiformat-dxgi_format
 * @ignore
 */ // This is way over-blown for us! Lend us a hand, and remove the ones that aren't used (but set the remaining
// ones to their correct value)
var $a6b5762b13998910$var$DXGI_FORMAT;
(function(DXGI_FORMAT) {
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_UNKNOWN"] = 0] = "DXGI_FORMAT_UNKNOWN";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_TYPELESS"] = 1] = "DXGI_FORMAT_R32G32B32A32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_FLOAT"] = 2] = "DXGI_FORMAT_R32G32B32A32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_UINT"] = 3] = "DXGI_FORMAT_R32G32B32A32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_SINT"] = 4] = "DXGI_FORMAT_R32G32B32A32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_TYPELESS"] = 5] = "DXGI_FORMAT_R32G32B32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_FLOAT"] = 6] = "DXGI_FORMAT_R32G32B32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_UINT"] = 7] = "DXGI_FORMAT_R32G32B32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_SINT"] = 8] = "DXGI_FORMAT_R32G32B32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_TYPELESS"] = 9] = "DXGI_FORMAT_R16G16B16A16_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_FLOAT"] = 10] = "DXGI_FORMAT_R16G16B16A16_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_UNORM"] = 11] = "DXGI_FORMAT_R16G16B16A16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_UINT"] = 12] = "DXGI_FORMAT_R16G16B16A16_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_SNORM"] = 13] = "DXGI_FORMAT_R16G16B16A16_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_SINT"] = 14] = "DXGI_FORMAT_R16G16B16A16_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_TYPELESS"] = 15] = "DXGI_FORMAT_R32G32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_FLOAT"] = 16] = "DXGI_FORMAT_R32G32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_UINT"] = 17] = "DXGI_FORMAT_R32G32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_SINT"] = 18] = "DXGI_FORMAT_R32G32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G8X24_TYPELESS"] = 19] = "DXGI_FORMAT_R32G8X24_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D32_FLOAT_S8X24_UINT"] = 20] = "DXGI_FORMAT_D32_FLOAT_S8X24_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS"] = 21] = "DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_X32_TYPELESS_G8X24_UINT"] = 22] = "DXGI_FORMAT_X32_TYPELESS_G8X24_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10A2_TYPELESS"] = 23] = "DXGI_FORMAT_R10G10B10A2_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10A2_UNORM"] = 24] = "DXGI_FORMAT_R10G10B10A2_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10A2_UINT"] = 25] = "DXGI_FORMAT_R10G10B10A2_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R11G11B10_FLOAT"] = 26] = "DXGI_FORMAT_R11G11B10_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_TYPELESS"] = 27] = "DXGI_FORMAT_R8G8B8A8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_UNORM"] = 28] = "DXGI_FORMAT_R8G8B8A8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_UNORM_SRGB"] = 29] = "DXGI_FORMAT_R8G8B8A8_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_UINT"] = 30] = "DXGI_FORMAT_R8G8B8A8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_SNORM"] = 31] = "DXGI_FORMAT_R8G8B8A8_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_SINT"] = 32] = "DXGI_FORMAT_R8G8B8A8_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_TYPELESS"] = 33] = "DXGI_FORMAT_R16G16_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_FLOAT"] = 34] = "DXGI_FORMAT_R16G16_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_UNORM"] = 35] = "DXGI_FORMAT_R16G16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_UINT"] = 36] = "DXGI_FORMAT_R16G16_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_SNORM"] = 37] = "DXGI_FORMAT_R16G16_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_SINT"] = 38] = "DXGI_FORMAT_R16G16_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_TYPELESS"] = 39] = "DXGI_FORMAT_R32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D32_FLOAT"] = 40] = "DXGI_FORMAT_D32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_FLOAT"] = 41] = "DXGI_FORMAT_R32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_UINT"] = 42] = "DXGI_FORMAT_R32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_SINT"] = 43] = "DXGI_FORMAT_R32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R24G8_TYPELESS"] = 44] = "DXGI_FORMAT_R24G8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D24_UNORM_S8_UINT"] = 45] = "DXGI_FORMAT_D24_UNORM_S8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R24_UNORM_X8_TYPELESS"] = 46] = "DXGI_FORMAT_R24_UNORM_X8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_X24_TYPELESS_G8_UINT"] = 47] = "DXGI_FORMAT_X24_TYPELESS_G8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_TYPELESS"] = 48] = "DXGI_FORMAT_R8G8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_UNORM"] = 49] = "DXGI_FORMAT_R8G8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_UINT"] = 50] = "DXGI_FORMAT_R8G8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_SNORM"] = 51] = "DXGI_FORMAT_R8G8_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_SINT"] = 52] = "DXGI_FORMAT_R8G8_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_TYPELESS"] = 53] = "DXGI_FORMAT_R16_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_FLOAT"] = 54] = "DXGI_FORMAT_R16_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D16_UNORM"] = 55] = "DXGI_FORMAT_D16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_UNORM"] = 56] = "DXGI_FORMAT_R16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_UINT"] = 57] = "DXGI_FORMAT_R16_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_SNORM"] = 58] = "DXGI_FORMAT_R16_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_SINT"] = 59] = "DXGI_FORMAT_R16_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_TYPELESS"] = 60] = "DXGI_FORMAT_R8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_UNORM"] = 61] = "DXGI_FORMAT_R8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_UINT"] = 62] = "DXGI_FORMAT_R8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_SNORM"] = 63] = "DXGI_FORMAT_R8_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_SINT"] = 64] = "DXGI_FORMAT_R8_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_A8_UNORM"] = 65] = "DXGI_FORMAT_A8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R1_UNORM"] = 66] = "DXGI_FORMAT_R1_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R9G9B9E5_SHAREDEXP"] = 67] = "DXGI_FORMAT_R9G9B9E5_SHAREDEXP";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_B8G8_UNORM"] = 68] = "DXGI_FORMAT_R8G8_B8G8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_G8R8_G8B8_UNORM"] = 69] = "DXGI_FORMAT_G8R8_G8B8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC1_TYPELESS"] = 70] = "DXGI_FORMAT_BC1_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC1_UNORM"] = 71] = "DXGI_FORMAT_BC1_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC1_UNORM_SRGB"] = 72] = "DXGI_FORMAT_BC1_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC2_TYPELESS"] = 73] = "DXGI_FORMAT_BC2_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC2_UNORM"] = 74] = "DXGI_FORMAT_BC2_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC2_UNORM_SRGB"] = 75] = "DXGI_FORMAT_BC2_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC3_TYPELESS"] = 76] = "DXGI_FORMAT_BC3_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC3_UNORM"] = 77] = "DXGI_FORMAT_BC3_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC3_UNORM_SRGB"] = 78] = "DXGI_FORMAT_BC3_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC4_TYPELESS"] = 79] = "DXGI_FORMAT_BC4_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC4_UNORM"] = 80] = "DXGI_FORMAT_BC4_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC4_SNORM"] = 81] = "DXGI_FORMAT_BC4_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC5_TYPELESS"] = 82] = "DXGI_FORMAT_BC5_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC5_UNORM"] = 83] = "DXGI_FORMAT_BC5_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC5_SNORM"] = 84] = "DXGI_FORMAT_BC5_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B5G6R5_UNORM"] = 85] = "DXGI_FORMAT_B5G6R5_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B5G5R5A1_UNORM"] = 86] = "DXGI_FORMAT_B5G5R5A1_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8A8_UNORM"] = 87] = "DXGI_FORMAT_B8G8R8A8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8X8_UNORM"] = 88] = "DXGI_FORMAT_B8G8R8X8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM"] = 89] = "DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8A8_TYPELESS"] = 90] = "DXGI_FORMAT_B8G8R8A8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8A8_UNORM_SRGB"] = 91] = "DXGI_FORMAT_B8G8R8A8_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8X8_TYPELESS"] = 92] = "DXGI_FORMAT_B8G8R8X8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8X8_UNORM_SRGB"] = 93] = "DXGI_FORMAT_B8G8R8X8_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC6H_TYPELESS"] = 94] = "DXGI_FORMAT_BC6H_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC6H_UF16"] = 95] = "DXGI_FORMAT_BC6H_UF16";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC6H_SF16"] = 96] = "DXGI_FORMAT_BC6H_SF16";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC7_TYPELESS"] = 97] = "DXGI_FORMAT_BC7_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC7_UNORM"] = 98] = "DXGI_FORMAT_BC7_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC7_UNORM_SRGB"] = 99] = "DXGI_FORMAT_BC7_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_AYUV"] = 100] = "DXGI_FORMAT_AYUV";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y410"] = 101] = "DXGI_FORMAT_Y410";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y416"] = 102] = "DXGI_FORMAT_Y416";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_NV12"] = 103] = "DXGI_FORMAT_NV12";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P010"] = 104] = "DXGI_FORMAT_P010";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P016"] = 105] = "DXGI_FORMAT_P016";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_420_OPAQUE"] = 106] = "DXGI_FORMAT_420_OPAQUE";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_YUY2"] = 107] = "DXGI_FORMAT_YUY2";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y210"] = 108] = "DXGI_FORMAT_Y210";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y216"] = 109] = "DXGI_FORMAT_Y216";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_NV11"] = 110] = "DXGI_FORMAT_NV11";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_AI44"] = 111] = "DXGI_FORMAT_AI44";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_IA44"] = 112] = "DXGI_FORMAT_IA44";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P8"] = 113] = "DXGI_FORMAT_P8";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_A8P8"] = 114] = "DXGI_FORMAT_A8P8";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B4G4R4A4_UNORM"] = 115] = "DXGI_FORMAT_B4G4R4A4_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P208"] = 116] = "DXGI_FORMAT_P208";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_V208"] = 117] = "DXGI_FORMAT_V208";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_V408"] = 118] = "DXGI_FORMAT_V408";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE"] = 119] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE"] = 120] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_FORCE_UINT"] = 121] = "DXGI_FORMAT_FORCE_UINT";
})($a6b5762b13998910$var$DXGI_FORMAT || ($a6b5762b13998910$var$DXGI_FORMAT = {}));
/**
 * Possible values of the field {@link DDS_DX10_FIELDS.RESOURCE_DIMENSION}
 *
 * @ignore
 */ var $a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION;
(function(D3D10_RESOURCE_DIMENSION) {
    D3D10_RESOURCE_DIMENSION[D3D10_RESOURCE_DIMENSION["DDS_DIMENSION_TEXTURE1D"] = 2] = "DDS_DIMENSION_TEXTURE1D";
    D3D10_RESOURCE_DIMENSION[D3D10_RESOURCE_DIMENSION["DDS_DIMENSION_TEXTURE2D"] = 3] = "DDS_DIMENSION_TEXTURE2D";
    D3D10_RESOURCE_DIMENSION[D3D10_RESOURCE_DIMENSION["DDS_DIMENSION_TEXTURE3D"] = 6] = "DDS_DIMENSION_TEXTURE3D";
})($a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION || ($a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION = {}));
var $a6b5762b13998910$var$PF_FLAGS = 1;
// PIXEL_FORMAT flags
var $a6b5762b13998910$var$DDPF_ALPHA = 0x2;
var $a6b5762b13998910$var$DDPF_FOURCC = 0x4;
var $a6b5762b13998910$var$DDPF_RGB = 0x40;
var $a6b5762b13998910$var$DDPF_YUV = 0x200;
var $a6b5762b13998910$var$DDPF_LUMINANCE = 0x20000;
// Four character codes for DXTn formats
var $a6b5762b13998910$var$FOURCC_DXT1 = 0x31545844;
var $a6b5762b13998910$var$FOURCC_DXT3 = 0x33545844;
var $a6b5762b13998910$var$FOURCC_DXT5 = 0x35545844;
var $a6b5762b13998910$var$FOURCC_DX10 = 0x30315844;
// Cubemap texture flag (for DDS_DX10_FIELDS.MISC_FLAG)
var $a6b5762b13998910$var$DDS_RESOURCE_MISC_TEXTURECUBE = 0x4;
/**
 * Maps `FOURCC_*` formats to internal formats (see {@link PIXI.INTERNAL_FORMATS}).
 *
 * @ignore
 */ var $a6b5762b13998910$var$FOURCC_TO_FORMAT = ($a6b5762b13998910$var$_a$1 = {}, $a6b5762b13998910$var$_a$1[$a6b5762b13998910$var$FOURCC_DXT1] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_a$1[$a6b5762b13998910$var$FOURCC_DXT3] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_a$1[$a6b5762b13998910$var$FOURCC_DXT5] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT, $a6b5762b13998910$var$_a$1);
/**
 * Maps {@link DXGI_FORMAT} to types/internal-formats (see {@link PIXI.TYPES}, {@link PIXI.INTERNAL_FORMATS})
 *
 * @ignore
 */ var $a6b5762b13998910$var$DXGI_TO_FORMAT = ($a6b5762b13998910$var$_b = {}, // WEBGL_compressed_texture_s3tc
$a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC1_TYPELESS] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC1_UNORM] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC2_TYPELESS] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC2_UNORM] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC3_TYPELESS] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC3_UNORM] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT, // WEBGL_compressed_texture_s3tc_srgb
$a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC1_UNORM_SRGB] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC2_UNORM_SRGB] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC3_UNORM_SRGB] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT, $a6b5762b13998910$var$_b);
/**
 * @class
 * @memberof PIXI
 * @implements PIXI.ILoaderPlugin
 * @see https://docs.microsoft.com/en-us/windows/win32/direct3ddds/dx-graphics-dds-pguide
 */ var $a6b5762b13998910$export$7c2d2826fcfc7c67 = /** @class */ function() {
    function DDSLoader() {}
    /**
     * Registers a DDS compressed texture
     * @see PIXI.Loader.loaderMiddleware
     * @param resource - loader resource that is checked to see if it is a DDS file
     * @param next - callback Function to call when done
     */ DDSLoader.use = function(resource, next) {
        if (resource.extension === 'dds' && resource.data) try {
            Object.assign(resource, $a6b5762b13998910$var$registerCompressedTextures(resource.name || resource.url, DDSLoader.parse(resource.data), resource.metadata));
        } catch (err) {
            next(err);
            return;
        }
        next();
    };
    /** Parses the DDS file header, generates base-textures, and puts them into the texture cache. */ DDSLoader.parse = function(arrayBuffer) {
        var data = new Uint32Array(arrayBuffer);
        var magicWord = data[0];
        if (magicWord !== $a6b5762b13998910$var$DDS_MAGIC) throw new Error('Invalid DDS file magic word');
        var header = new Uint32Array(arrayBuffer, 0, $a6b5762b13998910$var$DDS_HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT);
        // DDS header fields
        var height = header[$a6b5762b13998910$var$DDS_FIELDS.HEIGHT];
        var width = header[$a6b5762b13998910$var$DDS_FIELDS.WIDTH];
        var mipmapCount = header[$a6b5762b13998910$var$DDS_FIELDS.MIPMAP_COUNT];
        // PIXEL_FORMAT fields
        var pixelFormat = new Uint32Array(arrayBuffer, $a6b5762b13998910$var$DDS_FIELDS.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, $a6b5762b13998910$var$DDS_HEADER_PF_SIZE / Uint32Array.BYTES_PER_ELEMENT);
        var formatFlags = pixelFormat[$a6b5762b13998910$var$PF_FLAGS];
        // File contains compressed texture(s)
        if (formatFlags & $a6b5762b13998910$var$DDPF_FOURCC) {
            var fourCC = pixelFormat[$a6b5762b13998910$var$DDS_PF_FIELDS.FOURCC];
            // File contains one DXTn compressed texture
            if (fourCC !== $a6b5762b13998910$var$FOURCC_DX10) {
                var internalFormat_1 = $a6b5762b13998910$var$FOURCC_TO_FORMAT[fourCC];
                var dataOffset_1 = $a6b5762b13998910$var$DDS_MAGIC_SIZE + $a6b5762b13998910$var$DDS_HEADER_SIZE;
                var texData = new Uint8Array(arrayBuffer, dataOffset_1);
                var resource = new $a6b5762b13998910$export$1982af6892f05657(texData, {
                    format: internalFormat_1,
                    width: width,
                    height: height,
                    levels: mipmapCount // CompressedTextureResource will separate the levelBuffers for us!
                });
                return [
                    resource
                ];
            }
            // FOURCC_DX10 indicates there is a 20-byte DDS_HEADER_DX10 after DDS_HEADER
            var dx10Offset = $a6b5762b13998910$var$DDS_MAGIC_SIZE + $a6b5762b13998910$var$DDS_HEADER_SIZE;
            var dx10Header = new Uint32Array(data.buffer, dx10Offset, $a6b5762b13998910$var$DDS_HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT);
            var dxgiFormat = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.DXGI_FORMAT];
            var resourceDimension = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.RESOURCE_DIMENSION];
            var miscFlag = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.MISC_FLAG];
            var arraySize = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.ARRAY_SIZE];
            // Map dxgiFormat to PIXI.INTERNAL_FORMATS
            var internalFormat_2 = $a6b5762b13998910$var$DXGI_TO_FORMAT[dxgiFormat];
            if (internalFormat_2 === undefined) throw new Error("DDSLoader cannot parse texture data with DXGI format " + dxgiFormat);
            if (miscFlag === $a6b5762b13998910$var$DDS_RESOURCE_MISC_TEXTURECUBE) // FIXME: Anybody excited about cubemap compressed textures?
            throw new Error('DDSLoader does not support cubemap textures');
            if (resourceDimension === $a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION.DDS_DIMENSION_TEXTURE3D) // FIXME: Anybody excited about 3D compressed textures?
            throw new Error('DDSLoader does not supported 3D texture data');
            // Uint8Array buffers of image data, including all mipmap levels in each image
            var imageBuffers = new Array();
            var dataOffset = $a6b5762b13998910$var$DDS_MAGIC_SIZE + $a6b5762b13998910$var$DDS_HEADER_SIZE + $a6b5762b13998910$var$DDS_HEADER_DX10_SIZE;
            if (arraySize === 1) // No need bothering with the imageSize calculation!
            imageBuffers.push(new Uint8Array(arrayBuffer, dataOffset));
            else {
                // Calculate imageSize for each texture, and then locate each image's texture data
                var pixelSize = $a6b5762b13998910$export$fb888e587c979eee[internalFormat_2];
                var imageSize = 0;
                var levelWidth = width;
                var levelHeight = height;
                for(var i = 0; i < mipmapCount; i++){
                    var alignedLevelWidth = Math.max(1, levelWidth + 3 & -4);
                    var alignedLevelHeight = Math.max(1, levelHeight + 3 & -4);
                    var levelSize = alignedLevelWidth * alignedLevelHeight * pixelSize;
                    imageSize += levelSize;
                    levelWidth = levelWidth >>> 1;
                    levelHeight = levelHeight >>> 1;
                }
                var imageOffset = dataOffset;
                // NOTE: Cubemaps have 6-images per texture (but they aren't supported so ^_^)
                for(var i = 0; i < arraySize; i++){
                    imageBuffers.push(new Uint8Array(arrayBuffer, imageOffset, imageSize));
                    imageOffset += imageSize;
                }
            }
            // Uint8Array -> CompressedTextureResource, and we're done!
            return imageBuffers.map(function(buffer) {
                return new $a6b5762b13998910$export$1982af6892f05657(buffer, {
                    format: internalFormat_2,
                    width: width,
                    height: height,
                    levels: mipmapCount
                });
            });
        }
        if (formatFlags & $a6b5762b13998910$var$DDPF_RGB) // FIXME: We might want to allow uncompressed *.dds files?
        throw new Error('DDSLoader does not support uncompressed texture data.');
        if (formatFlags & $a6b5762b13998910$var$DDPF_YUV) // FIXME: Does anybody need this feature?
        throw new Error('DDSLoader does not supported YUV uncompressed texture data.');
        if (formatFlags & $a6b5762b13998910$var$DDPF_LUMINANCE) // FIXME: Microsoft says older DDS filers use this feature! Probably not worth the effort!
        throw new Error('DDSLoader does not support single-channel (lumninance) texture data!');
        if (formatFlags & $a6b5762b13998910$var$DDPF_ALPHA) // FIXME: I'm tired! See above =)
        throw new Error('DDSLoader does not support single-channel (alpha) texture data!');
        throw new Error('DDSLoader failed to load a texture file due to an unknown reason!');
    };
    return DDSLoader;
}();
var $a6b5762b13998910$var$_a$2, $a6b5762b13998910$var$_b$1, $a6b5762b13998910$var$_c;
// Set KTX files to be loaded as an ArrayBuffer
(0, $kXE1p.LoaderResource).setExtensionXhrType('ktx', (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.BUFFER);
/**
 * The 12-byte KTX file identifier
 *
 * @see https://www.khronos.org/opengles/sdk/tools/KTX/file_format_spec/#2.1
 * @ignore
 */ var $a6b5762b13998910$var$FILE_IDENTIFIER = [
    0xAB,
    0x4B,
    0x54,
    0x58,
    0x20,
    0x31,
    0x31,
    0xBB,
    0x0D,
    0x0A,
    0x1A,
    0x0A
];
/**
 * The value stored in the "endianness" field.
 *
 * @see https://www.khronos.org/opengles/sdk/tools/KTX/file_format_spec/#2.2
 * @ignore
 */ var $a6b5762b13998910$var$ENDIANNESS = 0x04030201;
/**
 * Byte offsets of the KTX file header fields
 *
 * @ignore
 */ var $a6b5762b13998910$var$KTX_FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
};
/**
 * Byte size of the file header fields in {@code KTX_FIELDS}
 *
 * @ignore
 */ var $a6b5762b13998910$var$FILE_HEADER_SIZE = 64;
/**
 * Maps {@link PIXI.TYPES} to the bytes taken per component, excluding those ones that are bit-fields.
 *
 * @ignore
 */ var $a6b5762b13998910$export$96c88eb9c7372a0b = ($a6b5762b13998910$var$_a$2 = {}, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).UNSIGNED_BYTE] = 1, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).UNSIGNED_SHORT] = 2, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).FLOAT] = 4, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).HALF_FLOAT] = 8, $a6b5762b13998910$var$_a$2);
/**
 * Number of components in each {@link PIXI.FORMATS}
 *
 * @ignore
 */ var $a6b5762b13998910$export$ace48b1390b9b0c2 = ($a6b5762b13998910$var$_b$1 = {}, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).RGBA] = 4, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).RGB] = 3, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).LUMINANCE] = 1, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).LUMINANCE_ALPHA] = 2, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).ALPHA] = 1, $a6b5762b13998910$var$_b$1);
/**
 * Number of bytes per pixel in bit-field types in {@link PIXI.TYPES}
 *
 * @ignore
 */ var $a6b5762b13998910$export$2ca26443044e8798 = ($a6b5762b13998910$var$_c = {}, $a6b5762b13998910$var$_c[(0, $P8XPi.TYPES).UNSIGNED_SHORT_4_4_4_4] = 2, $a6b5762b13998910$var$_c[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_5_5_1] = 2, $a6b5762b13998910$var$_c[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_6_5] = 2, $a6b5762b13998910$var$_c);
/**
 * Loader plugin for handling KTX texture container files.
 *
 * This KTX loader does not currently support the following features:
 * * cube textures
 * * 3D textures
 * * vendor-specific key/value data parsing
 * * endianness conversion for big-endian machines
 * * embedded *.basis files
 *
 * It does supports the following features:
 * * multiple textures per file
 * * mipmapping
 *
 * @class
 * @memberof PIXI
 * @implements PIXI.ILoaderPlugin
 */ var $a6b5762b13998910$export$f154586e513f353e = /** @class */ function() {
    function KTXLoader() {}
    /**
     * Called after a KTX file is loaded.
     *
     * This will parse the KTX file header and add a {@code BaseTexture} to the texture
     * cache.
     *
     * @see PIXI.Loader.loaderMiddleware
     * @param resource - loader resource that is checked to see if it is a KTX file
     * @param next - callback Function to call when done
     */ KTXLoader.use = function(resource, next) {
        if (resource.extension === 'ktx' && resource.data) try {
            var url = resource.name || resource.url;
            Object.assign(resource, $a6b5762b13998910$var$registerCompressedTextures(url, KTXLoader.parse(url, resource.data), resource.metadata));
        } catch (err) {
            next(err);
            return;
        }
        next();
    };
    /** Parses the KTX file header, generates base-textures, and puts them into the texture cache. */ KTXLoader.parse = function(url, arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        if (!KTXLoader.validate(url, dataView)) return null;
        var littleEndian = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.ENDIANNESS, true) === $a6b5762b13998910$var$ENDIANNESS;
        var glType = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.GL_TYPE, littleEndian);
        // const glTypeSize = dataView.getUint32(KTX_FIELDS.GL_TYPE_SIZE, littleEndian);
        var glFormat = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.GL_FORMAT, littleEndian);
        var glInternalFormat = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.GL_INTERNAL_FORMAT, littleEndian);
        var pixelWidth = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.PIXEL_WIDTH, littleEndian);
        var pixelHeight = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.PIXEL_HEIGHT, littleEndian) || 1; // "pixelHeight = 0" -> "1"
        var pixelDepth = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.PIXEL_DEPTH, littleEndian) || 1; // ^^
        var numberOfArrayElements = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1; // ^^
        var numberOfFaces = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.NUMBER_OF_FACES, littleEndian);
        var numberOfMipmapLevels = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian);
        var bytesOfKeyValueData = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
        // Whether the platform architecture is little endian. If littleEndian !== platformLittleEndian, then the
        // file contents must be endian-converted!
        // TODO: Endianness conversion
        // const platformLittleEndian = new Uint8Array((new Uint32Array([ENDIANNESS])).buffer)[0] === 0x01;
        if (pixelHeight === 0 || pixelDepth !== 1) throw new Error('Only 2D textures are supported');
        if (numberOfFaces !== 1) throw new Error('CubeTextures are not supported by KTXLoader yet!');
        if (numberOfArrayElements !== 1) // TODO: Support splitting array-textures into multiple BaseTextures
        throw new Error('WebGL does not support array textures');
        // TODO: 8x4 blocks for 2bpp pvrtc
        var blockWidth = 4;
        var blockHeight = 4;
        var alignedWidth = pixelWidth + 3 & -4;
        var alignedHeight = pixelHeight + 3 & -4;
        var imageBuffers = new Array(numberOfArrayElements);
        var imagePixels = pixelWidth * pixelHeight;
        if (glType === 0) // Align to 16 pixels (4x4 blocks)
        imagePixels = alignedWidth * alignedHeight;
        var imagePixelByteSize;
        if (glType !== 0) {
            // Uncompressed texture format
            if ($a6b5762b13998910$export$96c88eb9c7372a0b[glType]) imagePixelByteSize = $a6b5762b13998910$export$96c88eb9c7372a0b[glType] * $a6b5762b13998910$export$ace48b1390b9b0c2[glFormat];
            else imagePixelByteSize = $a6b5762b13998910$export$2ca26443044e8798[glType];
        } else imagePixelByteSize = $a6b5762b13998910$export$fb888e587c979eee[glInternalFormat];
        if (imagePixelByteSize === undefined) throw new Error('Unable to resolve the pixel format stored in the *.ktx file!');
        var imageByteSize = imagePixels * imagePixelByteSize;
        var mipByteSize = imageByteSize;
        var mipWidth = pixelWidth;
        var mipHeight = pixelHeight;
        var alignedMipWidth = alignedWidth;
        var alignedMipHeight = alignedHeight;
        var imageOffset = $a6b5762b13998910$var$FILE_HEADER_SIZE + bytesOfKeyValueData;
        for(var mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
            var imageSize = dataView.getUint32(imageOffset, littleEndian);
            var elementOffset = imageOffset + 4;
            for(var arrayElement = 0; arrayElement < numberOfArrayElements; arrayElement++){
                // TODO: Maybe support 3D textures? :-)
                // for (let zSlice = 0; zSlice < pixelDepth; zSlice)
                var mips = imageBuffers[arrayElement];
                if (!mips) mips = imageBuffers[arrayElement] = new Array(numberOfMipmapLevels);
                mips[mipmapLevel] = {
                    levelID: mipmapLevel,
                    levelWidth: numberOfMipmapLevels > 1 ? mipWidth : alignedMipWidth,
                    levelHeight: numberOfMipmapLevels > 1 ? mipHeight : alignedMipHeight,
                    levelBuffer: new Uint8Array(arrayBuffer, elementOffset, mipByteSize)
                };
                elementOffset += mipByteSize;
            }
            // HINT: Aligns to 4-byte boundary after jumping imageSize (in lieu of mipPadding)
            imageOffset += imageSize + 4; // (+4 to jump the imageSize field itself)
            imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset;
            // Calculate mipWidth, mipHeight for _next_ iteration
            mipWidth = mipWidth >> 1 || 1;
            mipHeight = mipHeight >> 1 || 1;
            alignedMipWidth = mipWidth + blockWidth - 1 & ~(blockWidth - 1);
            alignedMipHeight = mipHeight + blockHeight - 1 & ~(blockHeight - 1);
            // Each mipmap level is 4-times smaller?
            mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
        }
        // We use the levelBuffers feature of CompressedTextureResource b/c texture data is image-major, not level-major.
        if (glType !== 0) throw new Error('TODO: Uncompressed');
        return imageBuffers.map(function(levelBuffers) {
            return new $a6b5762b13998910$export$1982af6892f05657(null, {
                format: glInternalFormat,
                width: pixelWidth,
                height: pixelHeight,
                levels: numberOfMipmapLevels,
                levelBuffers: levelBuffers
            });
        });
    };
    /** Checks whether the arrayBuffer contains a valid *.ktx file. */ KTXLoader.validate = function(url, dataView) {
        // NOTE: Do not optimize this into 3 32-bit integer comparison because the endianness
        // of the data is not specified.
        for(var i = 0; i < $a6b5762b13998910$var$FILE_IDENTIFIER.length; i++)if (dataView.getUint8(i) !== $a6b5762b13998910$var$FILE_IDENTIFIER[i]) {
            console.error(url + " is not a valid *.ktx file!");
            return false;
        }
        return true;
    };
    return KTXLoader;
}();

});

parcelRegister("9eyo7", function(module, exports) {

$parcel$export(module.exports, "ParticleContainer", function () { return $6b9018a1467258a6$export$e63bf72b2cfda112; });
$parcel$export(module.exports, "ParticleRenderer", function () { return $6b9018a1467258a6$export$42cbb08a275c7ff9; });
/*!
 * @pixi/particle-container - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/particle-container is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $csytw = parcelRequire("csytw");

var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $6b9018a1467258a6$var$extendStatics = function(d, b) {
    $6b9018a1467258a6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6b9018a1467258a6$var$extendStatics(d, b);
};
function $6b9018a1467258a6$var$__extends(d, b) {
    $6b9018a1467258a6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * The ParticleContainer class is a really fast version of the Container built solely for speed,
 * so use when you need a lot of sprites or particles.
 *
 * The tradeoff of the ParticleContainer is that most advanced functionality will not work.
 * ParticleContainer implements the basic object transform (position, scale, rotation)
 * and some advanced functionality like tint (as of v4.5.6).
 *
 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
 *
 * It's extremely easy to use:
 * ```js
 * let container = new ParticleContainer();
 *
 * for (let i = 0; i < 100; ++i)
 * {
 *     let sprite = PIXI.Sprite.from("myImage.png");
 *     container.addChild(sprite);
 * }
 * ```
 *
 * And here you have a hundred sprites that will be rendered at the speed of light.
 *
 * @memberof PIXI
 */ var $6b9018a1467258a6$export$e63bf72b2cfda112 = /** @class */ function(_super) {
    $6b9018a1467258a6$var$__extends(ParticleContainer, _super);
    /**
     * @param maxSize - The maximum number of particles that can be rendered by the container.
     *  Affects size of allocated buffers.
     * @param properties - The properties of children that should be uploaded to the gpu and applied.
     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
     * @param {boolean} [autoResize=false] - If true, container allocates more batches in case
     *  there are more than `maxSize` particles.
     */ function ParticleContainer(maxSize, properties, batchSize, autoResize) {
        if (maxSize === void 0) maxSize = 1500;
        if (batchSize === void 0) batchSize = 16384;
        if (autoResize === void 0) autoResize = false;
        var _this = _super.call(this) || this;
        // Making sure the batch size is valid
        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        var maxBatchSize = 16384;
        if (batchSize > maxBatchSize) batchSize = maxBatchSize;
        _this._properties = [
            false,
            true,
            false,
            false,
            false
        ];
        _this._maxSize = maxSize;
        _this._batchSize = batchSize;
        _this._buffers = null;
        _this._bufferUpdateIDs = [];
        _this._updateID = 0;
        _this.interactiveChildren = false;
        _this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        _this.autoResize = autoResize;
        _this.roundPixels = true;
        _this.baseTexture = null;
        _this.setProperties(properties);
        _this._tint = 0;
        _this.tintRgb = new Float32Array(4);
        _this.tint = 0xFFFFFF;
        return _this;
    }
    /**
     * Sets the private properties array to dynamic / static based on the passed properties object
     *
     * @param properties - The properties to be uploaded
     */ ParticleContainer.prototype.setProperties = function(properties) {
        if (properties) {
            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
        }
    };
    ParticleContainer.prototype.updateTransform = function() {
        // TODO don't need to!
        this.displayObjectUpdateTransform();
    };
    Object.defineProperty(ParticleContainer.prototype, "tint", {
        /**
         * The tint applied to the container. This is a hex value.
         * A value of 0xFFFFFF will remove any tint effect.
         * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
         *
         * @default 0xFFFFFF
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            this._tint = value;
            (0, $csytw.hex2rgb)(value, this.tintRgb);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Renders the container using the WebGL renderer.
     *
     * @param renderer - The WebGL renderer.
     */ ParticleContainer.prototype.render = function(renderer) {
        var _this = this;
        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) return;
        if (!this.baseTexture) {
            this.baseTexture = this.children[0]._texture.baseTexture;
            if (!this.baseTexture.valid) this.baseTexture.once('update', function() {
                return _this.onChildrenChange(0);
            });
        }
        renderer.batch.setObjectRenderer(renderer.plugins.particle);
        renderer.plugins.particle.render(this);
    };
    /**
     * Set the flag that static data should be updated to true
     *
     * @param smallestChildIndex - The smallest child index.
     */ ParticleContainer.prototype.onChildrenChange = function(smallestChildIndex) {
        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
        while(this._bufferUpdateIDs.length < bufferIndex)this._bufferUpdateIDs.push(0);
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    };
    ParticleContainer.prototype.dispose = function() {
        if (this._buffers) {
            for(var i = 0; i < this._buffers.length; ++i)this._buffers[i].destroy();
            this._buffers = null;
        }
    };
    /**
     * Destroys the container
     *
     * @param options - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */ ParticleContainer.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        this.dispose();
        this._properties = null;
        this._buffers = null;
        this._bufferUpdateIDs = null;
    };
    return ParticleContainer;
}((0, $8t5Gy.Container));
/*
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
 * they now share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleBuffer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
 */ /**
 * The particle buffer manages the static and dynamic buffers for a particle container.
 *
 * @private
 * @memberof PIXI
 */ var $6b9018a1467258a6$var$ParticleBuffer = /** @class */ function() {
    /**
     * @param {object} properties - The properties to upload.
     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
     * @param {number} size - The size of the batch.
     */ function ParticleBuffer(properties, dynamicPropertyFlags, size) {
        this.geometry = new (0, $klOfb.Geometry)();
        this.indexBuffer = null;
        this.size = size;
        this.dynamicProperties = [];
        this.staticProperties = [];
        for(var i = 0; i < properties.length; ++i){
            var property = properties[i];
            // Make copy of properties object so that when we edit the offset it doesn't
            // change all other instances of the object literal
            property = {
                attributeName: property.attributeName,
                size: property.size,
                uploadFunction: property.uploadFunction,
                type: property.type || (0, $P8XPi.TYPES).FLOAT,
                offset: property.offset
            };
            if (dynamicPropertyFlags[i]) this.dynamicProperties.push(property);
            else this.staticProperties.push(property);
        }
        this.staticStride = 0;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
        this.dynamicStride = 0;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;
        this._updateID = 0;
        this.initBuffers();
    }
    /** Sets up the renderer context and necessary buffers. */ ParticleBuffer.prototype.initBuffers = function() {
        var geometry = this.geometry;
        var dynamicOffset = 0;
        this.indexBuffer = new (0, $klOfb.Buffer)((0, $csytw.createIndicesForQuads)(this.size), true, true);
        geometry.addIndex(this.indexBuffer);
        this.dynamicStride = 0;
        for(var i = 0; i < this.dynamicProperties.length; ++i){
            var property = this.dynamicProperties[i];
            property.offset = dynamicOffset;
            dynamicOffset += property.size;
            this.dynamicStride += property.size;
        }
        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 16);
        this.dynamicData = new Float32Array(dynBuffer);
        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
        this.dynamicBuffer = new (0, $klOfb.Buffer)(this.dynamicData, false, false);
        // static //
        var staticOffset = 0;
        this.staticStride = 0;
        for(var i = 0; i < this.staticProperties.length; ++i){
            var property = this.staticProperties[i];
            property.offset = staticOffset;
            staticOffset += property.size;
            this.staticStride += property.size;
        }
        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 16);
        this.staticData = new Float32Array(statBuffer);
        this.staticDataUint32 = new Uint32Array(statBuffer);
        this.staticBuffer = new (0, $klOfb.Buffer)(this.staticData, true, false);
        for(var i = 0; i < this.dynamicProperties.length; ++i){
            var property = this.dynamicProperties[i];
            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
        }
        for(var i = 0; i < this.staticProperties.length; ++i){
            var property = this.staticProperties[i];
            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
        }
    };
    /**
     * Uploads the dynamic properties.
     *
     * @param children - The children to upload.
     * @param startIndex - The index to start at.
     * @param amount - The number to upload.
     */ ParticleBuffer.prototype.uploadDynamic = function(children, startIndex, amount) {
        for(var i = 0; i < this.dynamicProperties.length; i++){
            var property = this.dynamicProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }
        this.dynamicBuffer._updateID++;
    };
    /**
     * Uploads the static properties.
     *
     * @param children - The children to upload.
     * @param startIndex - The index to start at.
     * @param amount - The number to upload.
     */ ParticleBuffer.prototype.uploadStatic = function(children, startIndex, amount) {
        for(var i = 0; i < this.staticProperties.length; i++){
            var property = this.staticProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }
        this.staticBuffer._updateID++;
    };
    /** Destroys the ParticleBuffer. */ ParticleBuffer.prototype.destroy = function() {
        this.indexBuffer = null;
        this.dynamicProperties = null;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;
        this.staticProperties = null;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
        // all buffers are destroyed inside geometry
        this.geometry.destroy();
    };
    return ParticleBuffer;
}();
var $6b9018a1467258a6$var$fragment = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n    gl_FragColor = color;\n}";
var $6b9018a1467258a6$var$vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\n\nattribute vec2 aPositionCoord;\nattribute float aRotation;\n\nuniform mat3 translationMatrix;\nuniform vec4 uColor;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nvoid main(void){\n    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);\n    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);\n\n    vec2 v = vec2(x, y);\n    v = v + aPositionCoord;\n\n    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vColor = aColor * uColor;\n}\n";
/*
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
 * share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleRenderer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
 */ /**
 * Renderer for Particles that is designer for speed over feature set.
 *
 * @memberof PIXI
 */ var $6b9018a1467258a6$export$42cbb08a275c7ff9 = /** @class */ function(_super) {
    $6b9018a1467258a6$var$__extends(ParticleRenderer, _super);
    /**
     * @param renderer - The renderer this sprite batch works for.
     */ function ParticleRenderer(renderer) {
        var _this = _super.call(this, renderer) || this;
        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        // and max number of element in the index buffer is 16384 * 6 = 98304
        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
        // let numIndices = 98304;
        _this.shader = null;
        _this.properties = null;
        _this.tempMatrix = new (0, $6qzqq.Matrix)();
        _this.properties = [
            // verticesData
            {
                attributeName: 'aVertexPosition',
                size: 2,
                uploadFunction: _this.uploadVertices,
                offset: 0
            },
            // positionData
            {
                attributeName: 'aPositionCoord',
                size: 2,
                uploadFunction: _this.uploadPosition,
                offset: 0
            },
            // rotationData
            {
                attributeName: 'aRotation',
                size: 1,
                uploadFunction: _this.uploadRotation,
                offset: 0
            },
            // uvsData
            {
                attributeName: 'aTextureCoord',
                size: 2,
                uploadFunction: _this.uploadUvs,
                offset: 0
            },
            // tintData
            {
                attributeName: 'aColor',
                size: 1,
                type: (0, $P8XPi.TYPES).UNSIGNED_BYTE,
                uploadFunction: _this.uploadTint,
                offset: 0
            }
        ];
        _this.shader = (0, $klOfb.Shader).from($6b9018a1467258a6$var$vertex, $6b9018a1467258a6$var$fragment, {});
        _this.state = (0, $klOfb.State).for2d();
        return _this;
    }
    /**
     * Renders the particle container object.
     *
     * @param container - The container to render using this ParticleRenderer.
     */ ParticleRenderer.prototype.render = function(container) {
        var children = container.children;
        var maxSize = container._maxSize;
        var batchSize = container._batchSize;
        var renderer = this.renderer;
        var totalChildren = children.length;
        if (totalChildren === 0) return;
        else if (totalChildren > maxSize && !container.autoResize) totalChildren = maxSize;
        var buffers = container._buffers;
        if (!buffers) buffers = container._buffers = this.generateBuffers(container);
        var baseTexture = children[0]._texture.baseTexture;
        // if the uvs have not updated then no point rendering just yet!
        this.state.blendMode = (0, $csytw.correctBlendMode)(container.blendMode, baseTexture.alphaMode);
        renderer.state.set(this.state);
        var gl = renderer.gl;
        var m = container.worldTransform.copyTo(this.tempMatrix);
        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix);
        this.shader.uniforms.translationMatrix = m.toArray(true);
        this.shader.uniforms.uColor = (0, $csytw.premultiplyRgba)(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.alphaMode);
        this.shader.uniforms.uSampler = baseTexture;
        this.renderer.shader.bind(this.shader);
        var updateStatic = false;
        // now lets upload and render the buffers..
        for(var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1){
            var amount = totalChildren - i;
            if (amount > batchSize) amount = batchSize;
            if (j >= buffers.length) buffers.push(this._generateOneMoreBuffer(container));
            var buffer = buffers[j];
            // we always upload the dynamic
            buffer.uploadDynamic(children, i, amount);
            var bid = container._bufferUpdateIDs[j] || 0;
            updateStatic = updateStatic || buffer._updateID < bid;
            // we only upload the static content when we have to!
            if (updateStatic) {
                buffer._updateID = container._updateID;
                buffer.uploadStatic(children, i, amount);
            }
            // bind the buffer
            renderer.geometry.bind(buffer.geometry);
            gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
        }
    };
    /**
     * Creates one particle buffer for each child in the container we want to render and updates internal properties.
     *
     * @param container - The container to render using this ParticleRenderer
     * @return - The buffers
     */ ParticleRenderer.prototype.generateBuffers = function(container) {
        var buffers = [];
        var size = container._maxSize;
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;
        for(var i = 0; i < size; i += batchSize)buffers.push(new $6b9018a1467258a6$var$ParticleBuffer(this.properties, dynamicPropertyFlags, batchSize));
        return buffers;
    };
    /**
     * Creates one more particle buffer, because container has autoResize feature.
     *
     * @param container - The container to render using this ParticleRenderer
     * @return - The generated buffer
     */ ParticleRenderer.prototype._generateOneMoreBuffer = function(container) {
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;
        return new $6b9018a1467258a6$var$ParticleBuffer(this.properties, dynamicPropertyFlags, batchSize);
    };
    /**
     * Uploads the vertices.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their vertices uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadVertices = function(children, startIndex, amount, array, stride, offset) {
        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;
        for(var i = 0; i < amount; ++i){
            var sprite = children[startIndex + i];
            var texture = sprite._texture;
            var sx = sprite.scale.x;
            var sy = sprite.scale.y;
            var trim = texture.trim;
            var orig = texture.orig;
            if (trim) {
                // if the sprite is trimmed and is not a tilingsprite then we need to add the
                // extra space before transforming the sprite coords..
                w1 = trim.x - sprite.anchor.x * orig.width;
                w0 = w1 + trim.width;
                h1 = trim.y - sprite.anchor.y * orig.height;
                h0 = h1 + trim.height;
            } else {
                w0 = orig.width * (1 - sprite.anchor.x);
                w1 = orig.width * -sprite.anchor.x;
                h0 = orig.height * (1 - sprite.anchor.y);
                h1 = orig.height * -sprite.anchor.y;
            }
            array[offset] = w1 * sx;
            array[offset + 1] = h1 * sy;
            array[offset + stride] = w0 * sx;
            array[offset + stride + 1] = h1 * sy;
            array[offset + stride * 2] = w0 * sx;
            array[offset + stride * 2 + 1] = h0 * sy;
            array[offset + stride * 3] = w1 * sx;
            array[offset + stride * 3 + 1] = h0 * sy;
            offset += stride * 4;
        }
    };
    /**
     * Uploads the position.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their positions uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadPosition = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; i++){
            var spritePosition = children[startIndex + i].position;
            array[offset] = spritePosition.x;
            array[offset + 1] = spritePosition.y;
            array[offset + stride] = spritePosition.x;
            array[offset + stride + 1] = spritePosition.y;
            array[offset + stride * 2] = spritePosition.x;
            array[offset + stride * 2 + 1] = spritePosition.y;
            array[offset + stride * 3] = spritePosition.x;
            array[offset + stride * 3 + 1] = spritePosition.y;
            offset += stride * 4;
        }
    };
    /**
     * Uploads the rotation.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their rotation uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadRotation = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; i++){
            var spriteRotation = children[startIndex + i].rotation;
            array[offset] = spriteRotation;
            array[offset + stride] = spriteRotation;
            array[offset + stride * 2] = spriteRotation;
            array[offset + stride * 3] = spriteRotation;
            offset += stride * 4;
        }
    };
    /**
     * Uploads the UVs.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their rotation uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadUvs = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; ++i){
            var textureUvs = children[startIndex + i]._texture._uvs;
            if (textureUvs) {
                array[offset] = textureUvs.x0;
                array[offset + 1] = textureUvs.y0;
                array[offset + stride] = textureUvs.x1;
                array[offset + stride + 1] = textureUvs.y1;
                array[offset + stride * 2] = textureUvs.x2;
                array[offset + stride * 2 + 1] = textureUvs.y2;
                array[offset + stride * 3] = textureUvs.x3;
                array[offset + stride * 3 + 1] = textureUvs.y3;
                offset += stride * 4;
            } else {
                // TODO you know this can be easier!
                array[offset] = 0;
                array[offset + 1] = 0;
                array[offset + stride] = 0;
                array[offset + stride + 1] = 0;
                array[offset + stride * 2] = 0;
                array[offset + stride * 2 + 1] = 0;
                array[offset + stride * 3] = 0;
                array[offset + stride * 3 + 1] = 0;
                offset += stride * 4;
            }
        }
    };
    /**
     * Uploads the tint.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their rotation uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadTint = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; ++i){
            var sprite = children[startIndex + i];
            var premultiplied = sprite._texture.baseTexture.alphaMode > 0;
            var alpha = sprite.alpha;
            // we dont call extra function if alpha is 1.0, that's faster
            var argb = alpha < 1.0 && premultiplied ? (0, $csytw.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
            array[offset] = argb;
            array[offset + stride] = argb;
            array[offset + stride * 2] = argb;
            array[offset + stride * 3] = argb;
            offset += stride * 4;
        }
    };
    /** Destroys the ParticleRenderer. */ ParticleRenderer.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        if (this.shader) {
            this.shader.destroy();
            this.shader = null;
        }
        this.tempMatrix = null;
    };
    return ParticleRenderer;
}((0, $klOfb.ObjectRenderer));

});

parcelRegister("1WkLv", function(module, exports) {

$parcel$export(module.exports, "CountLimiter", function () { return $169b50be80908716$export$29966907153718d8; });
$parcel$export(module.exports, "BasePrepare", function () { return $169b50be80908716$export$189fb89547161769; });
$parcel$export(module.exports, "Prepare", function () { return $169b50be80908716$export$6475b8f46e7e39d6; });
$parcel$export(module.exports, "TimeLimiter", function () { return $169b50be80908716$export$82e43921ff85c600; });
/*!
 * @pixi/prepare - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/prepare is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $klOfb = parcelRequire("klOfb");

var $gwPoJ = parcelRequire("gwPoJ");

var $3YyWq = parcelRequire("3YyWq");

var $8t5Gy = parcelRequire("8t5Gy");

var $9Pi8W = parcelRequire("9Pi8W");
/**
 * Default number of uploads per frame using prepare plugin.
 *
 * @static
 * @memberof PIXI.settings
 * @name UPLOADS_PER_FRAME
 * @type {number}
 * @default 4
 */ (0, $ezJmd.settings).UPLOADS_PER_FRAME = 4;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $169b50be80908716$var$extendStatics = function(d, b) {
    $169b50be80908716$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $169b50be80908716$var$extendStatics(d, b);
};
function $169b50be80908716$var$__extends(d, b) {
    $169b50be80908716$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * CountLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
 * number of items per frame.
 *
 * @memberof PIXI
 */ var $169b50be80908716$export$29966907153718d8 = /** @class */ function() {
    /**
     * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
     */ function CountLimiter(maxItemsPerFrame) {
        this.maxItemsPerFrame = maxItemsPerFrame;
        this.itemsLeft = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ CountLimiter.prototype.beginFrame = function() {
        this.itemsLeft = this.maxItemsPerFrame;
    };
    /**
     * Checks to see if another item can be uploaded. This should only be called once per item.
     *
     * @return If the item is allowed to be uploaded.
     */ CountLimiter.prototype.allowedToUpload = function() {
        return this.itemsLeft-- > 0;
    };
    return CountLimiter;
}();
/**
 * Built-in hook to find multiple textures from objects like AnimatedSprites.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.Texture object was found.
 */ function $169b50be80908716$var$findMultipleBaseTextures(item, queue) {
    var result = false;
    // Objects with multiple textures
    if (item && item._textures && item._textures.length) {
        for(var i = 0; i < item._textures.length; i++)if (item._textures[i] instanceof (0, $klOfb.Texture)) {
            var baseTexture = item._textures[i].baseTexture;
            if (queue.indexOf(baseTexture) === -1) {
                queue.push(baseTexture);
                result = true;
            }
        }
    }
    return result;
}
/**
 * Built-in hook to find BaseTextures from Texture.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.Texture object was found.
 */ function $169b50be80908716$var$findBaseTexture(item, queue) {
    if (item.baseTexture instanceof (0, $klOfb.BaseTexture)) {
        var texture = item.baseTexture;
        if (queue.indexOf(texture) === -1) queue.push(texture);
        return true;
    }
    return false;
}
/**
 * Built-in hook to find textures from objects.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.Texture object was found.
 */ function $169b50be80908716$var$findTexture(item, queue) {
    if (item._texture && item._texture instanceof (0, $klOfb.Texture)) {
        var texture = item._texture.baseTexture;
        if (queue.indexOf(texture) === -1) queue.push(texture);
        return true;
    }
    return false;
}
/**
 * Built-in hook to draw PIXI.Text to its texture.
 *
 * @private
 * @param helper - Not used by this upload handler
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$drawText(_helper, item) {
    if (item instanceof (0, $9Pi8W.Text)) {
        // updating text will return early if it is not dirty
        item.updateText(true);
        return true;
    }
    return false;
}
/**
 * Built-in hook to calculate a text style for a PIXI.Text object.
 *
 * @private
 * @param helper - Not used by this upload handler
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$calculateTextStyle(_helper, item) {
    if (item instanceof (0, $9Pi8W.TextStyle)) {
        var font = item.toFontString();
        (0, $9Pi8W.TextMetrics).measureFont(font);
        return true;
    }
    return false;
}
/**
 * Built-in hook to find Text objects.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return if a PIXI.Text object was found.
 */ function $169b50be80908716$var$findText(item, queue) {
    if (item instanceof (0, $9Pi8W.Text)) {
        // push the text style to prepare it - this can be really expensive
        if (queue.indexOf(item.style) === -1) queue.push(item.style);
        // also push the text object so that we can render it (to canvas/texture) if needed
        if (queue.indexOf(item) === -1) queue.push(item);
        // also push the Text's texture for upload to GPU
        var texture = item._texture.baseTexture;
        if (queue.indexOf(texture) === -1) queue.push(texture);
        return true;
    }
    return false;
}
/**
 * Built-in hook to find TextStyle objects.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.TextStyle object was found.
 */ function $169b50be80908716$var$findTextStyle(item, queue) {
    if (item instanceof (0, $9Pi8W.TextStyle)) {
        if (queue.indexOf(item) === -1) queue.push(item);
        return true;
    }
    return false;
}
/**
 * The prepare manager provides functionality to upload content to the GPU.
 *
 * BasePrepare handles basic queuing functionality and is extended by
 * {@link PIXI.Prepare} and {@link PIXI.CanvasPrepare}
 * to provide preparation capabilities specific to their respective renderers.
 *
 * @example
 * // Create a sprite
 * const sprite = PIXI.Sprite.from('something.png');
 *
 * // Load object into GPU
 * app.renderer.plugins.prepare.upload(sprite, () => {
 *
 *     //Texture(s) has been uploaded to GPU
 *     app.stage.addChild(sprite);
 *
 * })
 *
 * @abstract
 * @memberof PIXI
 */ var $169b50be80908716$export$189fb89547161769 = /** @class */ function() {
    /**
     * @param {PIXI.AbstractRenderer} renderer - A reference to the current renderer
     */ function BasePrepare(renderer) {
        var _this = this;
        this.limiter = new $169b50be80908716$export$29966907153718d8((0, $ezJmd.settings).UPLOADS_PER_FRAME);
        this.renderer = renderer;
        this.uploadHookHelper = null;
        this.queue = [];
        this.addHooks = [];
        this.uploadHooks = [];
        this.completes = [];
        this.ticking = false;
        this.delayedTick = function() {
            // unlikely, but in case we were destroyed between tick() and delayedTick()
            if (!_this.queue) return;
            _this.prepareItems();
        };
        // hooks to find the correct texture
        this.registerFindHook($169b50be80908716$var$findText);
        this.registerFindHook($169b50be80908716$var$findTextStyle);
        this.registerFindHook($169b50be80908716$var$findMultipleBaseTextures);
        this.registerFindHook($169b50be80908716$var$findBaseTexture);
        this.registerFindHook($169b50be80908716$var$findTexture);
        // upload hooks
        this.registerUploadHook($169b50be80908716$var$drawText);
        this.registerUploadHook($169b50be80908716$var$calculateTextStyle);
    }
    /**
     * Upload all the textures and graphics to the GPU.
     *
     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
     *        Either the container or display object to search for items to upload, the items to upload themselves,
     *        or the callback function, if items have been added using `prepare.add`.
     * @param {Function} [done] - Optional callback when all queued uploads have completed
     */ BasePrepare.prototype.upload = function(item, done) {
        if (typeof item === 'function') {
            done = item;
            item = null;
        }
        // If a display object, search for items
        // that we could upload
        if (item) this.add(item);
        // Get the items for upload from the display
        if (this.queue.length) {
            if (done) this.completes.push(done);
            if (!this.ticking) {
                this.ticking = true;
                (0, $3YyWq.Ticker).system.addOnce(this.tick, this, (0, $3YyWq.UPDATE_PRIORITY).UTILITY);
            }
        } else if (done) done();
    };
    /**
     * Handle tick update
     *
     * @private
     */ BasePrepare.prototype.tick = function() {
        setTimeout(this.delayedTick, 0);
    };
    /**
     * Actually prepare items. This is handled outside of the tick because it will take a while
     * and we do NOT want to block the current animation frame from rendering.
     *
     * @private
     */ BasePrepare.prototype.prepareItems = function() {
        this.limiter.beginFrame();
        // Upload the graphics
        while(this.queue.length && this.limiter.allowedToUpload()){
            var item = this.queue[0];
            var uploaded = false;
            if (item && !item._destroyed) {
                for(var i = 0, len = this.uploadHooks.length; i < len; i++)if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                    this.queue.shift();
                    uploaded = true;
                    break;
                }
            }
            if (!uploaded) this.queue.shift();
        }
        // We're finished
        if (!this.queue.length) {
            this.ticking = false;
            var completes = this.completes.slice(0);
            this.completes.length = 0;
            for(var i = 0, len = completes.length; i < len; i++)completes[i]();
        } else // if we are not finished, on the next rAF do this again
        (0, $3YyWq.Ticker).system.addOnce(this.tick, this, (0, $3YyWq.UPDATE_PRIORITY).UTILITY);
    };
    /**
     * Adds hooks for finding items.
     *
     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
     *          function must return `true` if it was able to add item to the queue.
     * @return Instance of plugin for chaining.
     */ BasePrepare.prototype.registerFindHook = function(addHook) {
        if (addHook) this.addHooks.push(addHook);
        return this;
    };
    /**
     * Adds hooks for uploading items.
     *
     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
     *          function must return `true` if it was able to handle upload of item.
     * @return Instance of plugin for chaining.
     */ BasePrepare.prototype.registerUploadHook = function(uploadHook) {
        if (uploadHook) this.uploadHooks.push(uploadHook);
        return this;
    };
    /**
     * Manually add an item to the uploading queue.
     *
     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
     *        add to the queue
     * @return Instance of plugin for chaining.
     */ BasePrepare.prototype.add = function(item) {
        // Add additional hooks for finding elements on special
        // types of objects that
        for(var i = 0, len = this.addHooks.length; i < len; i++){
            if (this.addHooks[i](item, this.queue)) break;
        }
        // Get children recursively
        if (item instanceof (0, $8t5Gy.Container)) for(var i = item.children.length - 1; i >= 0; i--)this.add(item.children[i]);
        return this;
    };
    /** Destroys the plugin, don't use after this. */ BasePrepare.prototype.destroy = function() {
        if (this.ticking) (0, $3YyWq.Ticker).system.remove(this.tick, this);
        this.ticking = false;
        this.addHooks = null;
        this.uploadHooks = null;
        this.renderer = null;
        this.completes = null;
        this.queue = null;
        this.limiter = null;
        this.uploadHookHelper = null;
    };
    return BasePrepare;
}();
/**
 * Built-in hook to upload PIXI.Texture objects to the GPU.
 *
 * @private
 * @param renderer - instance of the webgl renderer
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$uploadBaseTextures(renderer, item) {
    if (item instanceof (0, $klOfb.BaseTexture)) {
        // if the texture already has a GL texture, then the texture has been prepared or rendered
        // before now. If the texture changed, then the changer should be calling texture.update() which
        // reuploads the texture without need for preparing it again
        if (!item._glTextures[renderer.CONTEXT_UID]) renderer.texture.bind(item);
        return true;
    }
    return false;
}
/**
 * Built-in hook to upload PIXI.Graphics to the GPU.
 *
 * @private
 * @param renderer - instance of the webgl renderer
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$uploadGraphics(renderer, item) {
    if (!(item instanceof (0, $gwPoJ.Graphics))) return false;
    var geometry = item.geometry;
    // update dirty graphics to get batches
    item.finishPoly();
    geometry.updateBatches();
    var batches = geometry.batches;
    // upload all textures found in styles
    for(var i = 0; i < batches.length; i++){
        var texture = batches[i].style.texture;
        if (texture) $169b50be80908716$var$uploadBaseTextures(renderer, texture.baseTexture);
    }
    // if its not batchable - update vao for particular shader
    if (!geometry.batchable) renderer.geometry.bind(geometry, item._resolveDirectShader(renderer));
    return true;
}
/**
 * Built-in hook to find graphics.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return if a PIXI.Graphics object was found.
 */ function $169b50be80908716$var$findGraphics(item, queue) {
    if (item instanceof (0, $gwPoJ.Graphics)) {
        queue.push(item);
        return true;
    }
    return false;
}
/**
 * The prepare plugin provides renderer-specific plugins for pre-rendering DisplayObjects. These plugins are useful for
 * asynchronously preparing and uploading to the GPU assets, textures, graphics waiting to be displayed.
 *
 * Do not instantiate this plugin directly. It is available from the `renderer.plugins` property.
 * See {@link PIXI.CanvasRenderer#plugins} or {@link PIXI.Renderer#plugins}.
 * @example
 * // Create a new application
 * const app = new PIXI.Application();
 * document.body.appendChild(app.view);
 *
 * // Don't start rendering right away
 * app.stop();
 *
 * // create a display object
 * const rect = new PIXI.Graphics()
 *     .beginFill(0x00ff00)
 *     .drawRect(40, 40, 200, 200);
 *
 * // Add to the stage
 * app.stage.addChild(rect);
 *
 * // Don't start rendering until the graphic is uploaded to the GPU
 * app.renderer.plugins.prepare.upload(app.stage, () => {
 *     app.start();
 * });
 *
 *
 * @memberof PIXI
 */ var $169b50be80908716$export$6475b8f46e7e39d6 = /** @class */ function(_super) {
    $169b50be80908716$var$__extends(Prepare, _super);
    /**
     * @param {PIXI.Renderer} renderer - A reference to the current renderer
     */ function Prepare(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.uploadHookHelper = _this.renderer;
        // Add textures and graphics to upload
        _this.registerFindHook($169b50be80908716$var$findGraphics);
        _this.registerUploadHook($169b50be80908716$var$uploadBaseTextures);
        _this.registerUploadHook($169b50be80908716$var$uploadGraphics);
        return _this;
    }
    return Prepare;
}($169b50be80908716$export$189fb89547161769);
/**
 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
 * number of milliseconds per frame.
 *
 * @memberof PIXI
 */ var $169b50be80908716$export$82e43921ff85c600 = /** @class */ function() {
    /** @param maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame. */ function TimeLimiter(maxMilliseconds) {
        this.maxMilliseconds = maxMilliseconds;
        this.frameStart = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ TimeLimiter.prototype.beginFrame = function() {
        this.frameStart = Date.now();
    };
    /**
     * Checks to see if another item can be uploaded. This should only be called once per item.
     *
     * @return - If the item is allowed to be uploaded.
     */ TimeLimiter.prototype.allowedToUpload = function() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
    };
    return TimeLimiter;
}();

});
parcelRegister("gwPoJ", function(module, exports) {

$parcel$export(module.exports, "LINE_JOIN", function () { return $c0878112c399eabe$export$c6a6e344be1302e7; });
$parcel$export(module.exports, "LINE_CAP", function () { return $c0878112c399eabe$export$b113e22c48c75d2e; });
$parcel$export(module.exports, "GRAPHICS_CURVES", function () { return $c0878112c399eabe$export$8331f8d2be429f2c; });
$parcel$export(module.exports, "FillStyle", function () { return $c0878112c399eabe$export$c42b166860ccdbd8; });
$parcel$export(module.exports, "GraphicsData", function () { return $c0878112c399eabe$export$94accce0eb494446; });
$parcel$export(module.exports, "GraphicsGeometry", function () { return $c0878112c399eabe$export$c707987b44ce3a12; });
$parcel$export(module.exports, "LineStyle", function () { return $c0878112c399eabe$export$5d24e00cfde59887; });
$parcel$export(module.exports, "Graphics", function () { return $c0878112c399eabe$export$29d3e417456abdad; });
$parcel$export(module.exports, "graphicsUtils", function () { return $c0878112c399eabe$export$efc72ad5bf88689; });
/*!
 * @pixi/graphics - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/graphics is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");
parcelRequire("csytw");
var $fPquT = parcelRequire("fPquT");
var $csytw = parcelRequire("csytw");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");
/**
 * Supported line joints in `PIXI.LineStyle` for graphics.
 *
 * @see PIXI.Graphics#lineStyle
 * @see https://graphicdesign.stackexchange.com/questions/59018/what-is-a-bevel-join-of-two-lines-exactly-illustrator
 *
 * @name LINE_JOIN
 * @memberof PIXI
 * @static
 * @enum {string}
 * @property {string} MITER - 'miter': make a sharp corner where outer part of lines meet
 * @property {string} BEVEL - 'bevel': add a square butt at each end of line segment and fill the triangle at turn
 * @property {string} ROUND - 'round': add an arc at the joint
 */ var $c0878112c399eabe$export$c6a6e344be1302e7;
(function(LINE_JOIN) {
    LINE_JOIN["MITER"] = "miter";
    LINE_JOIN["BEVEL"] = "bevel";
    LINE_JOIN["ROUND"] = "round";
})($c0878112c399eabe$export$c6a6e344be1302e7 || ($c0878112c399eabe$export$c6a6e344be1302e7 = {}));
/**
 * Support line caps in `PIXI.LineStyle` for graphics.
 *
 * @see PIXI.Graphics#lineStyle
 *
 * @name LINE_CAP
 * @memberof PIXI
 * @static
 * @enum {string}
 * @property {string} BUTT - 'butt': don't add any cap at line ends (leaves orthogonal edges)
 * @property {string} ROUND - 'round': add semicircle at ends
 * @property {string} SQUARE - 'square': add square at end (like `BUTT` except more length at end)
 */ var $c0878112c399eabe$export$b113e22c48c75d2e;
(function(LINE_CAP) {
    LINE_CAP["BUTT"] = "butt";
    LINE_CAP["ROUND"] = "round";
    LINE_CAP["SQUARE"] = "square";
})($c0878112c399eabe$export$b113e22c48c75d2e || ($c0878112c399eabe$export$b113e22c48c75d2e = {}));
/**
 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
 * the resolution is calculated based on the curve's length to ensure better visual quality.
 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name GRAPHICS_CURVES
 * @type {object}
 * @property {boolean} adaptive=true - flag indicating if the resolution should be adaptive
 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
 */ var $c0878112c399eabe$export$8331f8d2be429f2c = {
    adaptive: true,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048,
    epsilon: 0.0001,
    _segmentsCount: function(length, defaultSegments) {
        if (defaultSegments === void 0) defaultSegments = 20;
        if (!this.adaptive || !length || isNaN(length)) return defaultSegments;
        var result = Math.ceil(length / this.maxLength);
        if (result < this.minSegments) result = this.minSegments;
        else if (result > this.maxSegments) result = this.maxSegments;
        return result;
    }
};
/**
 * Fill style object for Graphics.
 *
 * @class
 * @memberof PIXI
 */ var $c0878112c399eabe$export$c42b166860ccdbd8 = /** @class */ function() {
    function FillStyle() {
        /**
         * The hex color value used when coloring the Graphics object.
         *
         * @default 0xFFFFFF
         */ this.color = 0xFFFFFF;
        /** The alpha value used when filling the Graphics object. */ this.alpha = 1.0;
        /**
         * The texture to be used for the fill.
         *
         * @member {PIXI.Texture}
         * @default 0
         */ this.texture = (0, $klOfb.Texture).WHITE;
        /**
         * The transform applied to the texture.
         *
         * @member {PIXI.Matrix}
         * @default null
         */ this.matrix = null;
        /** If the current fill is visible. */ this.visible = false;
        this.reset();
    }
    /**
     * Clones the object
     *
     * @return {PIXI.FillStyle}
     */ FillStyle.prototype.clone = function() {
        var obj = new FillStyle();
        obj.color = this.color;
        obj.alpha = this.alpha;
        obj.texture = this.texture;
        obj.matrix = this.matrix;
        obj.visible = this.visible;
        return obj;
    };
    /**
     * Reset
     */ FillStyle.prototype.reset = function() {
        this.color = 0xFFFFFF;
        this.alpha = 1;
        this.texture = (0, $klOfb.Texture).WHITE;
        this.matrix = null;
        this.visible = false;
    };
    /**
     * Destroy and don't use after this
     */ FillStyle.prototype.destroy = function() {
        this.texture = null;
        this.matrix = null;
    };
    return FillStyle;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $c0878112c399eabe$var$extendStatics = function(d, b) {
    $c0878112c399eabe$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c0878112c399eabe$var$extendStatics(d, b);
};
function $c0878112c399eabe$var$__extends(d, b) {
    $c0878112c399eabe$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Builds a polygon to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildPoly = {
    build: function(graphicsData) {
        graphicsData.points = graphicsData.shape.points.slice();
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var holes = graphicsData.holes;
        var verts = graphicsGeometry.points;
        var indices = graphicsGeometry.indices;
        if (points.length >= 6) {
            var holeArray = [];
            // Process holes..
            for(var i = 0; i < holes.length; i++){
                var hole = holes[i];
                holeArray.push(points.length / 2);
                points = points.concat(hole.points);
            }
            // sort color
            var triangles = (0, (/*@__PURE__*/$parcel$interopDefault($fPquT)))(points, holeArray, 2);
            if (!triangles) return;
            var vertPos = verts.length / 2;
            for(var i = 0; i < triangles.length; i += 3){
                indices.push(triangles[i] + vertPos);
                indices.push(triangles[i + 1] + vertPos);
                indices.push(triangles[i + 2] + vertPos);
            }
            for(var i = 0; i < points.length; i++)verts.push(points[i]);
        }
    }
};
// for type only
/**
 * Builds a circle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildCircle = {
    build: function(graphicsData) {
        // need to convert points to a nice regular data
        var circleData = graphicsData.shape;
        var points = graphicsData.points;
        var x = circleData.x;
        var y = circleData.y;
        var width;
        var height;
        points.length = 0;
        // TODO - bit hacky??
        if (graphicsData.type === (0, $6qzqq.SHAPES).CIRC) {
            width = circleData.radius;
            height = circleData.radius;
        } else {
            var ellipseData = graphicsData.shape;
            width = ellipseData.width;
            height = ellipseData.height;
        }
        if (width === 0 || height === 0) return;
        var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(width + height));
        totalSegs /= 2.3;
        var seg = Math.PI * 2 / totalSegs;
        for(var i = 0; i < totalSegs - 0.5; i++)points.push(x + Math.sin(-seg * i) * width, y + Math.cos(-seg * i) * height);
        points.push(points[0], points[1]);
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var verts = graphicsGeometry.points;
        var indices = graphicsGeometry.indices;
        var vertPos = verts.length / 2;
        var center = vertPos;
        var circle = graphicsData.shape;
        var matrix = graphicsData.matrix;
        var x = circle.x;
        var y = circle.y;
        // Push center (special point)
        verts.push(graphicsData.matrix ? matrix.a * x + matrix.c * y + matrix.tx : x, graphicsData.matrix ? matrix.b * x + matrix.d * y + matrix.ty : y);
        for(var i = 0; i < points.length; i += 2){
            verts.push(points[i], points[i + 1]);
            // add some uvs
            indices.push(vertPos++, center, vertPos);
        }
    }
};
/**
 * Builds a rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildRectangle = {
    build: function(graphicsData) {
        // --- //
        // need to convert points to a nice regular data
        //
        var rectData = graphicsData.shape;
        var x = rectData.x;
        var y = rectData.y;
        var width = rectData.width;
        var height = rectData.height;
        var points = graphicsData.points;
        points.length = 0;
        points.push(x, y, x + width, y, x + width, y + height, x, y + height);
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var verts = graphicsGeometry.points;
        var vertPos = verts.length / 2;
        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]);
        graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
    }
};
/**
 * Calculate a single point for a quadratic bezier curve.
 * Utility function used by quadraticBezierCurve.
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} n1 - first number
 * @param {number} n2 - second number
 * @param {number} perc - percentage
 * @return {number} the result
 *
 */ function $c0878112c399eabe$var$getPt(n1, n2, perc) {
    var diff = n2 - n1;
    return n1 + diff * perc;
}
/**
 * Calculate the points for a quadratic bezier curve. (helper function..)
 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} fromX - Origin point x
 * @param {number} fromY - Origin point x
 * @param {number} cpX - Control point x
 * @param {number} cpY - Control point y
 * @param {number} toX - Destination point x
 * @param {number} toY - Destination point y
 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
 * @return {number[]} an array of points
 */ function $c0878112c399eabe$var$quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY, out) {
    if (out === void 0) out = [];
    var n = 20;
    var points = out;
    var xa = 0;
    var ya = 0;
    var xb = 0;
    var yb = 0;
    var x = 0;
    var y = 0;
    for(var i = 0, j = 0; i <= n; ++i){
        j = i / n;
        // The Green Line
        xa = $c0878112c399eabe$var$getPt(fromX, cpX, j);
        ya = $c0878112c399eabe$var$getPt(fromY, cpY, j);
        xb = $c0878112c399eabe$var$getPt(cpX, toX, j);
        yb = $c0878112c399eabe$var$getPt(cpY, toY, j);
        // The Black Dot
        x = $c0878112c399eabe$var$getPt(xa, xb, j);
        y = $c0878112c399eabe$var$getPt(ya, yb, j);
        // Handle case when first curve points overlaps and earcut fails to triangulate
        if (i === 0 && points[points.length - 2] === x && points[points.length - 1] === y) continue;
        points.push(x, y);
    }
    return points;
}
/**
 * Builds a rounded rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildRoundedRectangle = {
    build: function(graphicsData) {
        var rrectData = graphicsData.shape;
        var points = graphicsData.points;
        var x = rrectData.x;
        var y = rrectData.y;
        var width = rrectData.width;
        var height = rrectData.height;
        // Don't allow negative radius or greater than half the smallest width
        var radius = Math.max(0, Math.min(rrectData.radius, Math.min(width, height) / 2));
        points.length = 0;
        // No radius, do a simple rectangle
        if (!radius) points.push(x, y, x + width, y, x + width, y + height, x, y + height);
        else {
            $c0878112c399eabe$var$quadraticBezierCurve(x, y + radius, x, y, x + radius, y, points);
            $c0878112c399eabe$var$quadraticBezierCurve(x + width - radius, y, x + width, y, x + width, y + radius, points);
            $c0878112c399eabe$var$quadraticBezierCurve(x + width, y + height - radius, x + width, y + height, x + width - radius, y + height, points);
            $c0878112c399eabe$var$quadraticBezierCurve(x + radius, y + height, x, y + height, x, y + height - radius, points);
        }
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var verts = graphicsGeometry.points;
        var indices = graphicsGeometry.indices;
        var vecPos = verts.length / 2;
        var triangles = (0, (/*@__PURE__*/$parcel$interopDefault($fPquT)))(points, null, 2);
        for(var i = 0, j = triangles.length; i < j; i += 3){
            indices.push(triangles[i] + vecPos);
            //     indices.push(triangles[i] + vecPos);
            indices.push(triangles[i + 1] + vecPos);
            //   indices.push(triangles[i + 2] + vecPos);
            indices.push(triangles[i + 2] + vecPos);
        }
        for(var i = 0, j = points.length; i < j; i++)verts.push(points[i], points[++i]);
    }
};
/**
 * Buffers vertices to draw a square cap.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} x - X-coord of end point
 * @param {number} y - Y-coord of end point
 * @param {number} nx - X-coord of line normal pointing inside
 * @param {number} ny - Y-coord of line normal pointing inside
 * @param {Array<number>} verts - vertex buffer
 * @returns {}
 */ function $c0878112c399eabe$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, /* rotation for square (true at left end, false at right end) */ verts) {
    var ix = x - nx * innerWeight;
    var iy = y - ny * innerWeight;
    var ox = x + nx * outerWeight;
    var oy = y + ny * outerWeight;
    /* Rotate nx,ny for extension vector */ var exx;
    var eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    /* [i|0]x,y extended at cap */ var eix = ix + exx;
    var eiy = iy + eyy;
    var eox = ox + exx;
    var eoy = oy + eyy;
    /* Square itself must be inserted clockwise*/ verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
/**
 * Buffers vertices to draw an arc at the line joint or cap.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} cx - X-coord of center
 * @param {number} cy - Y-coord of center
 * @param {number} sx - X-coord of arc start
 * @param {number} sy - Y-coord of arc start
 * @param {number} ex - X-coord of arc end
 * @param {number} ey - Y-coord of arc end
 * @param {Array<number>} verts - buffer of vertices
 * @param {boolean} clockwise - orientation of vertices
 * @returns {number} - no. of vertices pushed
 */ function $c0878112c399eabe$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    var cx2p0x = sx - cx;
    var cy2p0y = sy - cy;
    var angle0 = Math.atan2(cx2p0x, cy2p0y);
    var angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    var startAngle = angle0;
    var angleDiff = angle1 - angle0;
    var absAngleDiff = Math.abs(angleDiff);
    /* if (absAngleDiff >= PI_LBOUND && absAngleDiff <= PI_UBOUND)
    {
        const r1x = cx - nxtPx;
        const r1y = cy - nxtPy;

        if (r1x === 0)
        {
            if (r1y > 0)
            {
                angleDiff = -angleDiff;
            }
        }
        else if (r1x >= -GRAPHICS_CURVES.epsilon)
        {
            angleDiff = -angleDiff;
        }
    }*/ var radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    var segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    var angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(var i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(var i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
/**
 * Builds a line to draw using the polygon method.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
 */ function $c0878112c399eabe$var$buildNonNativeLine(graphicsData, graphicsGeometry) {
    var shape = graphicsData.shape;
    var points = graphicsData.points || shape.points.slice();
    var eps = graphicsGeometry.closePointEps;
    if (points.length === 0) return;
    // if the line width is an odd number add 0.5 to align to a whole pixel
    // commenting this out fixes #711 and #1620
    // if (graphicsData.lineWidth%2)
    // {
    //     for (i = 0; i < points.length; i++)
    //     {
    //         points[i] += 0.5;
    //     }
    // }
    var style = graphicsData.lineStyle;
    // get first and last point.. figure out the middle!
    var firstPoint = new (0, $6qzqq.Point)(points[0], points[1]);
    var lastPoint = new (0, $6qzqq.Point)(points[points.length - 2], points[points.length - 1]);
    var closedShape = shape.type !== (0, $6qzqq.SHAPES).POLY || shape.closeStroke;
    var closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    // if the first point is the last point - gonna have issues :)
    if (closedShape) {
        // need to clone as we are going to slightly modify the shape..
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        var midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        var midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    var verts = graphicsGeometry.points;
    var length = points.length / 2;
    var indexCount = points.length;
    var indexStart = verts.length / 2;
    // Max. inner and outer width
    var width = style.width / 2;
    var widthSquared = width * width;
    var miterLimitSquared = style.miterLimit * style.miterLimit;
    /* Line segments of interest where (x1,y1) forms the corner. */ var x0 = points[0];
    var y0 = points[1];
    var x1 = points[2];
    var y1 = points[3];
    var x2 = 0;
    var y2 = 0;
    /* perp[?](x|y) = the line normal with magnitude lineWidth. */ var perpx = -(y0 - y1);
    var perpy = x0 - x1;
    var perp1x = 0;
    var perp1y = 0;
    var dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;
    var ratio = style.alignment; // 0.5;
    var innerWeight = (1 - ratio) * 2;
    var outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.ROUND) indexCount += $c0878112c399eabe$var$round(x0 - perpx * (innerWeight - outerWeight) * 0.5, y0 - perpy * (innerWeight - outerWeight) * 0.5, x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight, verts, true) + 2;
        else if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.SQUARE) indexCount += $c0878112c399eabe$var$square(x0, y0, perpx, perpy, innerWeight, outerWeight, true, verts);
    }
    // Push first point (below & above vertices)
    verts.push(x0 - perpx * innerWeight, y0 - perpy * innerWeight);
    verts.push(x0 + perpx * outerWeight, y0 + perpy * outerWeight);
    for(var i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpx = -(y0 - y1);
        perpy = x0 - x1;
        dist = Math.sqrt(perpx * perpx + perpy * perpy);
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        /* d[x|y](0|1) = the component displacement between points p(0,1|1,2) */ var dx0 = x1 - x0;
        var dy0 = y0 - y1;
        var dx1 = x1 - x2;
        var dy1 = y2 - y1;
        /* +ve if internal angle counterclockwise, -ve if internal angle clockwise. */ var cross = dy0 * dx1 - dy1 * dx0;
        var clockwise = cross < 0;
        /* Going nearly straight? */ if (Math.abs(cross) < 0.1) {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight);
            verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight);
            continue;
        }
        /* p[x|y] is the miter point. pdist is the distance between miter point and p1. */ var c1 = (-perpx + x0) * (-perpy + y1) - (-perpx + x1) * (-perpy + y0);
        var c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        var px = (dx0 * c2 - dx1 * c1) / cross;
        var py = (dy1 * c1 - dy0 * c2) / cross;
        var pdist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        /* Inner miter point */ var imx = x1 + (px - x1) * innerWeight;
        var imy = y1 + (py - y1) * innerWeight;
        /* Outer miter point */ var omx = x1 - (px - x1) * outerWeight;
        var omy = y1 - (py - y1) * outerWeight;
        /* Is the inside miter point too far away, creating a spike? */ var smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        var insideWeight = clockwise ? innerWeight : outerWeight;
        var smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        var insideMiterOk = pdist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.BEVEL || pdist / widthSquared > miterLimitSquared) {
                if (clockwise) /* rotating at inner angle */ {
                    verts.push(imx, imy); // inner miter point
                    verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight); // first segment's outer vertex
                    verts.push(imx, imy); // inner miter point
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight); // second segment's outer vertex
                } else /* rotating at outer angle */ {
                    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight); // first segment's inner vertex
                    verts.push(omx, omy); // outer miter point
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight); // second segment's outer vertex
                    verts.push(omx, omy); // outer miter point
                }
                indexCount += 2;
            } else if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.ROUND) {
                if (clockwise) /* arc is outside */ {
                    verts.push(imx, imy);
                    verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight);
                    indexCount += $c0878112c399eabe$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else /* arc is inside */ {
                    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $c0878112c399eabe$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight); // first segment's inner vertex
            verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight); // first segment's outer vertex
            if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.BEVEL || pdist / widthSquared > miterLimitSquared) ;
            else if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.ROUND) {
                if (clockwise) indexCount += $c0878112c399eabe$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $c0878112c399eabe$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else {
                if (clockwise) {
                    verts.push(omx, omy); // inner miter point
                    verts.push(omx, omy); // inner miter point
                } else {
                    verts.push(imx, imy); // outer miter point
                    verts.push(imx, imy); // outer miter point
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight); // second segment's inner vertex
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight); // second segment's outer vertex
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpx = -(y0 - y1);
    perpy = x0 - x1;
    dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;
    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight);
    verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight);
    if (!closedShape) {
        if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.ROUND) indexCount += $c0878112c399eabe$var$round(x1 - perpx * (innerWeight - outerWeight) * 0.5, y1 - perpy * (innerWeight - outerWeight) * 0.5, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight, verts, false) + 2;
        else if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.SQUARE) indexCount += $c0878112c399eabe$var$square(x1, y1, perpx, perpy, innerWeight, outerWeight, false, verts);
    }
    var indices = graphicsGeometry.indices;
    var eps2 = $c0878112c399eabe$export$8331f8d2be429f2c.epsilon * $c0878112c399eabe$export$8331f8d2be429f2c.epsilon;
    // indices.push(indexStart);
    for(var i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        /* Skip zero area triangles */ if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}
/**
 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
 */ function $c0878112c399eabe$var$buildNativeLine(graphicsData, graphicsGeometry) {
    var i = 0;
    var shape = graphicsData.shape;
    var points = graphicsData.points || shape.points;
    var closedShape = shape.type !== (0, $6qzqq.SHAPES).POLY || shape.closeStroke;
    if (points.length === 0) return;
    var verts = graphicsGeometry.points;
    var indices = graphicsGeometry.indices;
    var length = points.length / 2;
    var startIndex = verts.length / 2;
    var currentIndex = startIndex;
    verts.push(points[0], points[1]);
    for(i = 1; i < length; i++){
        verts.push(points[i * 2], points[i * 2 + 1]);
        indices.push(currentIndex, currentIndex + 1);
        currentIndex++;
    }
    if (closedShape) indices.push(currentIndex, startIndex);
}
/**
 * Builds a line to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
 */ function $c0878112c399eabe$var$buildLine(graphicsData, graphicsGeometry) {
    if (graphicsData.lineStyle.native) $c0878112c399eabe$var$buildNativeLine(graphicsData, graphicsGeometry);
    else $c0878112c399eabe$var$buildNonNativeLine(graphicsData, graphicsGeometry);
}
/**
 * Utilities for arc curves
 * @class
 * @private
 */ var $c0878112c399eabe$var$ArcUtils = /** @class */ function() {
    function ArcUtils() {}
    /**
     * The arcTo() method creates an arc/curve between two tangents on the canvas.
     *
     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
     *
     * @private
     * @param {number} x1 - The x-coordinate of the beginning of the arc
     * @param {number} y1 - The y-coordinate of the beginning of the arc
     * @param {number} x2 - The x-coordinate of the end of the arc
     * @param {number} y2 - The y-coordinate of the end of the arc
     * @param {number} radius - The radius of the arc
     * @return {object} If the arc length is valid, return center of circle, radius and other info otherwise `null`.
     */ ArcUtils.curveTo = function(x1, y1, x2, y2, radius, points) {
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var a1 = fromY - y1;
        var b1 = fromX - x1;
        var a2 = y2 - y1;
        var b2 = x2 - x1;
        var mm = Math.abs(a1 * b2 - b1 * a2);
        if (mm < 1.0e-8 || radius === 0) {
            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
            return null;
        }
        var dd = a1 * a1 + b1 * b1;
        var cc = a2 * a2 + b2 * b2;
        var tt = a1 * a2 + b1 * b2;
        var k1 = radius * Math.sqrt(dd) / mm;
        var k2 = radius * Math.sqrt(cc) / mm;
        var j1 = k1 * tt / dd;
        var j2 = k2 * tt / cc;
        var cx = k1 * b2 + k2 * b1;
        var cy = k1 * a2 + k2 * a1;
        var px = b1 * (k2 + j1);
        var py = a1 * (k2 + j1);
        var qx = b2 * (k1 + j2);
        var qy = a2 * (k1 + j2);
        var startAngle = Math.atan2(py - cy, px - cx);
        var endAngle = Math.atan2(qy - cy, qx - cx);
        return {
            cx: cx + x1,
            cy: cy + y1,
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            anticlockwise: b1 * a2 > b2 * a1
        };
    };
    /* eslint-disable max-len */ /**
     * The arc method creates an arc/curve (used to create circles, or parts of circles).
     *
     * @private
     * @param {number} startX - Start x location of arc
     * @param {number} startY - Start y location of arc
     * @param {number} cx - The x-coordinate of the center of the circle
     * @param {number} cy - The y-coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
     *  of the arc's circle)
     * @param {number} endAngle - The ending angle, in radians
     * @param {boolean} anticlockwise - Specifies whether the drawing should be
     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
     *  indicates counter-clockwise.
     * @param {number[]} points - Collection of points to add to
     */ ArcUtils.arc = function(_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
        var sweep = endAngle - startAngle;
        var n = $c0878112c399eabe$export$8331f8d2be429f2c._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / (0, $6qzqq.PI_2)) * 40);
        var theta = sweep / (n * 2);
        var theta2 = theta * 2;
        var cTheta = Math.cos(theta);
        var sTheta = Math.sin(theta);
        var segMinus = n - 1;
        var remainder = segMinus % 1 / segMinus;
        for(var i = 0; i <= segMinus; ++i){
            var real = i + remainder * i;
            var angle = theta + startAngle + theta2 * real;
            var c = Math.cos(angle);
            var s = -Math.sin(angle);
            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }
    };
    return ArcUtils;
}();
/**
 * Utilities for bezier curves
 * @class
 * @private
 */ var $c0878112c399eabe$var$BezierUtils = /** @class */ function() {
    function BezierUtils() {}
    /**
     * Calculate length of bezier curve.
     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
     * Therefore numerical solution is used.
     *
     * @private
     * @param {number} fromX - Starting point x
     * @param {number} fromY - Starting point y
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {number} Length of bezier curve
     */ BezierUtils.curveLength = function(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        var n = 10;
        var result = 0.0;
        var t = 0.0;
        var t2 = 0.0;
        var t3 = 0.0;
        var nt = 0.0;
        var nt2 = 0.0;
        var nt3 = 0.0;
        var x = 0.0;
        var y = 0.0;
        var dx = 0.0;
        var dy = 0.0;
        var prevX = fromX;
        var prevY = fromY;
        for(var i = 1; i <= n; ++i){
            t = i / n;
            t2 = t * t;
            t3 = t2 * t;
            nt = 1.0 - t;
            nt2 = nt * nt;
            nt3 = nt2 * nt;
            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
            dx = prevX - x;
            dy = prevY - y;
            prevX = x;
            prevY = y;
            result += Math.sqrt(dx * dx + dy * dy);
        }
        return result;
    };
    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @param {number[]} points - Path array to push points into
     */ BezierUtils.curveTo = function(cpX, cpY, cpX2, cpY2, toX, toY, points) {
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        points.length -= 2;
        var n = $c0878112c399eabe$export$8331f8d2be429f2c._segmentsCount(BezierUtils.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
        var dt = 0;
        var dt2 = 0;
        var dt3 = 0;
        var t2 = 0;
        var t3 = 0;
        points.push(fromX, fromY);
        for(var i = 1, j = 0; i <= n; ++i){
            j = i / n;
            dt = 1 - j;
            dt2 = dt * dt;
            dt3 = dt2 * dt;
            t2 = j * j;
            t3 = t2 * j;
            points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
        }
    };
    return BezierUtils;
}();
/**
 * Utilities for quadratic curves
 * @class
 * @private
 */ var $c0878112c399eabe$var$QuadraticUtils = /** @class */ function() {
    function QuadraticUtils() {}
    /**
     * Calculate length of quadratic curve
     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
     * for the detailed explanation of math behind this.
     *
     * @private
     * @param {number} fromX - x-coordinate of curve start point
     * @param {number} fromY - y-coordinate of curve start point
     * @param {number} cpX - x-coordinate of curve control point
     * @param {number} cpY - y-coordinate of curve control point
     * @param {number} toX - x-coordinate of curve end point
     * @param {number} toY - y-coordinate of curve end point
     * @return {number} Length of quadratic curve
     */ QuadraticUtils.curveLength = function(fromX, fromY, cpX, cpY, toX, toY) {
        var ax = fromX - 2.0 * cpX + toX;
        var ay = fromY - 2.0 * cpY + toY;
        var bx = 2.0 * cpX - 2.0 * fromX;
        var by = 2.0 * cpY - 2.0 * fromY;
        var a = 4.0 * (ax * ax + ay * ay);
        var b = 4.0 * (ax * bx + ay * by);
        var c = bx * bx + by * by;
        var s = 2.0 * Math.sqrt(a + b + c);
        var a2 = Math.sqrt(a);
        var a32 = 2.0 * a * a2;
        var c2 = 2.0 * Math.sqrt(c);
        var ba = b / a2;
        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
    };
    /**
     * Calculate the points for a quadratic bezier curve and then draws it.
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * @private
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @param {number[]} points - Points to add segments to.
     */ QuadraticUtils.curveTo = function(cpX, cpY, toX, toY, points) {
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var n = $c0878112c399eabe$export$8331f8d2be429f2c._segmentsCount(QuadraticUtils.curveLength(fromX, fromY, cpX, cpY, toX, toY));
        var xa = 0;
        var ya = 0;
        for(var i = 1; i <= n; ++i){
            var j = i / n;
            xa = fromX + (cpX - fromX) * j;
            ya = fromY + (cpY - fromY) * j;
            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }
    };
    return QuadraticUtils;
}();
/**
 * A structure to hold interim batch objects for Graphics.
 * @class
 * @memberof PIXI.graphicsUtils
 */ var $c0878112c399eabe$var$BatchPart = /** @class */ function() {
    function BatchPart() {
        this.reset();
    }
    /**
     * Begin batch part
     *
     * @param {PIXI.FillStyle | PIXI.LineStyle} style
     * @param {number} startIndex
     * @param {number} attribStart
     */ BatchPart.prototype.begin = function(style, startIndex, attribStart) {
        this.reset();
        this.style = style;
        this.start = startIndex;
        this.attribStart = attribStart;
    };
    /**
     * End batch part
     *
     * @param {number} endIndex
     * @param {number} endAttrib
     */ BatchPart.prototype.end = function(endIndex, endAttrib) {
        this.attribSize = endAttrib - this.attribStart;
        this.size = endIndex - this.start;
    };
    BatchPart.prototype.reset = function() {
        this.style = null;
        this.size = 0;
        this.start = 0;
        this.attribStart = 0;
        this.attribSize = 0;
    };
    return BatchPart;
}();
/**
 * Generalized convenience utilities for Graphics.
 *
 * @namespace graphicsUtils
 * @memberof PIXI
 */ var $c0878112c399eabe$var$_a;
/**
 * Map of fill commands for each shape type.
 *
 * @memberof PIXI.graphicsUtils
 * @member {Object} FILL_COMMANDS
 */ var $c0878112c399eabe$var$FILL_COMMANDS = ($c0878112c399eabe$var$_a = {}, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).POLY] = $c0878112c399eabe$var$buildPoly, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).CIRC] = $c0878112c399eabe$var$buildCircle, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).ELIP] = $c0878112c399eabe$var$buildCircle, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).RECT] = $c0878112c399eabe$var$buildRectangle, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).RREC] = $c0878112c399eabe$var$buildRoundedRectangle, $c0878112c399eabe$var$_a);
/**
 * Batch pool, stores unused batches for preventing allocations.
 *
 * @memberof PIXI.graphicsUtils
 * @member {Array<PIXI.graphicsUtils.BatchPart>} BATCH_POOL
 */ var $c0878112c399eabe$var$BATCH_POOL = [];
/**
 * Draw call pool, stores unused draw calls for preventing allocations.
 *
 * @memberof PIXI.graphicsUtils
 * @member {Array<PIXI.BatchDrawCall>} DRAW_CALL_POOL
 */ var $c0878112c399eabe$var$DRAW_CALL_POOL = [];
/**
 * Determine if polygon is clockwise or counterclockwise.
 * @see {@link https://stackoverflow.com/questions/1165647}
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {Polygon} polygon
 * @return {boolean}
 */ function $c0878112c399eabe$var$isPolygonClockwise(polygon) {
    var points = polygon.points;
    var sum = 0;
    for(var i = 0; i < points.length - 2; i += 2)sum += (points[i + 2] - points[i]) * (points[i + 3] + points[i + 1]);
    return sum > 0;
}
/**
 * A class to contain data useful for Graphics objects
 *
 * @class
 * @memberof PIXI
 */ var $c0878112c399eabe$export$94accce0eb494446 = /** @class */ function() {
    /**
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @param {PIXI.FillStyle} [fillStyle] - the width of the line to draw
     * @param {PIXI.LineStyle} [lineStyle] - the color of the line to draw
     * @param {PIXI.Matrix} [matrix] - Transform matrix
     */ function GraphicsData(shape, fillStyle, lineStyle, matrix) {
        if (fillStyle === void 0) fillStyle = null;
        if (lineStyle === void 0) lineStyle = null;
        if (matrix === void 0) matrix = null;
        /** The collection of points. */ this.points = [];
        /**
         * The collection of holes.
         *
         * @member {PIXI.GraphicsData[]}
         */ this.holes = [];
        /**
         * The shape object to draw.
         * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
         */ this.shape = shape;
        /**
         * The style of the line.
         * @member {PIXI.LineStyle}
         */ this.lineStyle = lineStyle;
        /**
         * The style of the fill.
         * @member {PIXI.FillStyle}
         */ this.fillStyle = fillStyle;
        /**
         * The transform matrix.
         * @member {PIXI.Matrix}
         */ this.matrix = matrix;
        /**
         * The type of the shape, see the Const.Shapes file for all the existing types,
         * @member {number}
         */ this.type = shape.type;
    }
    /**
     * Creates a new GraphicsData object with the same values as this one.
     *
     * @return {PIXI.GraphicsData} Cloned GraphicsData object
     */ GraphicsData.prototype.clone = function() {
        return new GraphicsData(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    };
    /**
     * Destroys the Graphics data.
     *
     */ GraphicsData.prototype.destroy = function() {
        this.shape = null;
        this.holes.length = 0;
        this.holes = null;
        this.points.length = 0;
        this.points = null;
        this.lineStyle = null;
        this.fillStyle = null;
    };
    return GraphicsData;
}();
var $c0878112c399eabe$var$tmpPoint = new (0, $6qzqq.Point)();
var $c0878112c399eabe$var$tmpBounds = new (0, $8t5Gy.Bounds)();
/**
 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
 * rectangles to the display, and to color and fill them.
 *
 * GraphicsGeometry is designed to not be continually updating the geometry since it's expensive
 * to re-tesselate using **earcut**. Consider using {@link PIXI.Mesh} for this use-case, it's much faster.
 *
 * @class
 * @extends PIXI.BatchGeometry
 * @memberof PIXI
 */ var $c0878112c399eabe$export$c707987b44ce3a12 = /** @class */ function(_super) {
    $c0878112c399eabe$var$__extends(GraphicsGeometry, _super);
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function GraphicsGeometry() {
        var _this = _super.call(this) || this;
        /**
         * Minimal distance between points that are considered different.
         * Affects line tesselation.
         */ _this.closePointEps = 1e-4;
        /** Padding to add to the bounds. */ _this.boundsPadding = 0;
        _this.uvsFloat32 = null;
        _this.indicesUint16 = null;
        _this.batchable = false;
        /** An array of points to draw, 2 numbers per point */ _this.points = [];
        /** The collection of colors */ _this.colors = [];
        /** The UVs collection */ _this.uvs = [];
        /** The indices of the vertices */ _this.indices = [];
        /** Reference to the texture IDs. */ _this.textureIds = [];
        /**
         * The collection of drawn shapes.
         *
         * @member {PIXI.GraphicsData[]}
         */ _this.graphicsData = [];
        /**
         * List of current draw calls drived from the batches.
         *
         * @member {PIXI.BatchDrawCall[]}
         */ _this.drawCalls = [];
        /** Batches need to regenerated if the geometry is updated. */ _this.batchDirty = -1;
        /**
         * Intermediate abstract format sent to batch system.
         * Can be converted to drawCalls or to batchable objects.
         *
         * @member {PIXI.graphicsUtils.BatchPart[]}
         */ _this.batches = [];
        /** Used to detect if the graphics object has changed. */ _this.dirty = 0;
        /** Used to check if the cache is dirty. */ _this.cacheDirty = -1;
        /** Used to detect if we cleared the graphicsData. */ _this.clearDirty = 0;
        /** Index of the last batched shape in the stack of calls. */ _this.shapeIndex = 0;
        /**
         * Cached bounds.
         *
         * @member {PIXI.Bounds}
         */ _this._bounds = new (0, $8t5Gy.Bounds)();
        /** The bounds dirty flag. */ _this.boundsDirty = -1;
        return _this;
    }
    Object.defineProperty(GraphicsGeometry.prototype, "bounds", {
        /**
         * Get the current bounds of the graphic geometry.
         *
         * @member {PIXI.Bounds}
         * @readonly
         */ get: function() {
            if (this.boundsDirty !== this.dirty) {
                this.boundsDirty = this.dirty;
                this.calculateBounds();
            }
            return this._bounds;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call if you changed graphicsData manually.
     * Empties all batch buffers.
     */ GraphicsGeometry.prototype.invalidate = function() {
        this.boundsDirty = -1;
        this.dirty++;
        this.batchDirty++;
        this.shapeIndex = 0;
        this.points.length = 0;
        this.colors.length = 0;
        this.uvs.length = 0;
        this.indices.length = 0;
        this.textureIds.length = 0;
        for(var i = 0; i < this.drawCalls.length; i++){
            this.drawCalls[i].texArray.clear();
            $c0878112c399eabe$var$DRAW_CALL_POOL.push(this.drawCalls[i]);
        }
        this.drawCalls.length = 0;
        for(var i = 0; i < this.batches.length; i++){
            var batchPart = this.batches[i];
            batchPart.reset();
            $c0878112c399eabe$var$BATCH_POOL.push(batchPart);
        }
        this.batches.length = 0;
    };
    /**
     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
     *
     * @return {PIXI.GraphicsGeometry} This GraphicsGeometry object. Good for chaining method calls
     */ GraphicsGeometry.prototype.clear = function() {
        if (this.graphicsData.length > 0) {
            this.invalidate();
            this.clearDirty++;
            this.graphicsData.length = 0;
        }
        return this;
    };
    /**
     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @param {PIXI.FillStyle} fillStyle - Defines style of the fill.
     * @param {PIXI.LineStyle} lineStyle - Defines style of the lines.
     * @param {PIXI.Matrix} matrix - Transform applied to the points of the shape.
     * @return {PIXI.GraphicsGeometry} Returns geometry for chaining.
     */ GraphicsGeometry.prototype.drawShape = function(shape, fillStyle, lineStyle, matrix) {
        if (fillStyle === void 0) fillStyle = null;
        if (lineStyle === void 0) lineStyle = null;
        if (matrix === void 0) matrix = null;
        var data = new $c0878112c399eabe$export$94accce0eb494446(shape, fillStyle, lineStyle, matrix);
        this.graphicsData.push(data);
        this.dirty++;
        return this;
    };
    /**
     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @param {PIXI.Matrix} matrix - Transform applied to the points of the shape.
     * @return {PIXI.GraphicsGeometry} Returns geometry for chaining.
     */ GraphicsGeometry.prototype.drawHole = function(shape, matrix) {
        if (matrix === void 0) matrix = null;
        if (!this.graphicsData.length) return null;
        var data = new $c0878112c399eabe$export$94accce0eb494446(shape, null, null, matrix);
        var lastShape = this.graphicsData[this.graphicsData.length - 1];
        data.lineStyle = lastShape.lineStyle;
        lastShape.holes.push(data);
        this.dirty++;
        return this;
    };
    /**
     * Destroys the GraphicsGeometry object.
     *
     */ GraphicsGeometry.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        // destroy each of the GraphicsData objects
        for(var i = 0; i < this.graphicsData.length; ++i)this.graphicsData[i].destroy();
        this.points.length = 0;
        this.points = null;
        this.colors.length = 0;
        this.colors = null;
        this.uvs.length = 0;
        this.uvs = null;
        this.indices.length = 0;
        this.indices = null;
        this.indexBuffer.destroy();
        this.indexBuffer = null;
        this.graphicsData.length = 0;
        this.graphicsData = null;
        this.drawCalls.length = 0;
        this.drawCalls = null;
        this.batches.length = 0;
        this.batches = null;
        this._bounds = null;
    };
    /**
     * Check to see if a point is contained within this geometry.
     *
     * @param {PIXI.IPointData} point - Point to check if it's contained.
     * @return {Boolean} `true` if the point is contained within geometry.
     */ GraphicsGeometry.prototype.containsPoint = function(point) {
        var graphicsData = this.graphicsData;
        for(var i = 0; i < graphicsData.length; ++i){
            var data = graphicsData[i];
            if (!data.fillStyle.visible) continue;
            // only deal with fills..
            if (data.shape) {
                if (data.matrix) data.matrix.applyInverse(point, $c0878112c399eabe$var$tmpPoint);
                else $c0878112c399eabe$var$tmpPoint.copyFrom(point);
                if (data.shape.contains($c0878112c399eabe$var$tmpPoint.x, $c0878112c399eabe$var$tmpPoint.y)) {
                    var hitHole = false;
                    if (data.holes) for(var i_1 = 0; i_1 < data.holes.length; i_1++){
                        var hole = data.holes[i_1];
                        if (hole.shape.contains($c0878112c399eabe$var$tmpPoint.x, $c0878112c399eabe$var$tmpPoint.y)) {
                            hitHole = true;
                            break;
                        }
                    }
                    if (!hitHole) return true;
                }
            }
        }
        return false;
    };
    /**
     * Generates intermediate batch data. Either gets converted to drawCalls
     * or used to convert to batch objects directly by the Graphics object.
     *
     * @param {boolean} [allow32Indices] - Allow using 32-bit indices for preventing artifacts when more that 65535 vertices
     */ GraphicsGeometry.prototype.updateBatches = function(allow32Indices) {
        if (!this.graphicsData.length) {
            this.batchable = true;
            return;
        }
        if (!this.validateBatching()) return;
        this.cacheDirty = this.dirty;
        var uvs = this.uvs;
        var graphicsData = this.graphicsData;
        var batchPart = null;
        var currentStyle = null;
        if (this.batches.length > 0) {
            batchPart = this.batches[this.batches.length - 1];
            currentStyle = batchPart.style;
        }
        for(var i = this.shapeIndex; i < graphicsData.length; i++){
            this.shapeIndex++;
            var data = graphicsData[i];
            var fillStyle = data.fillStyle;
            var lineStyle = data.lineStyle;
            var command = $c0878112c399eabe$var$FILL_COMMANDS[data.type];
            // build out the shapes points..
            command.build(data);
            if (data.matrix) this.transformPoints(data.points, data.matrix);
            for(var j = 0; j < 2; j++){
                var style = j === 0 ? fillStyle : lineStyle;
                if (!style.visible) continue;
                var nextTexture = style.texture.baseTexture;
                var index_1 = this.indices.length;
                var attribIndex = this.points.length / 2;
                nextTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
                if (j === 0) this.processFill(data);
                else this.processLine(data);
                var size = this.points.length / 2 - attribIndex;
                if (size === 0) continue;
                // close batch if style is different
                if (batchPart && !this._compareStyles(currentStyle, style)) {
                    batchPart.end(index_1, attribIndex);
                    batchPart = null;
                }
                // spawn new batch if its first batch or previous was closed
                if (!batchPart) {
                    batchPart = $c0878112c399eabe$var$BATCH_POOL.pop() || new $c0878112c399eabe$var$BatchPart();
                    batchPart.begin(style, index_1, attribIndex);
                    this.batches.push(batchPart);
                    currentStyle = style;
                }
                this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix);
            }
        }
        var index = this.indices.length;
        var attrib = this.points.length / 2;
        if (batchPart) batchPart.end(index, attrib);
        if (this.batches.length === 0) {
            // there are no visible styles in GraphicsData
            // its possible that someone wants Graphics just for the bounds
            this.batchable = true;
            return;
        }
        // prevent allocation when length is same as buffer
        if (this.indicesUint16 && this.indices.length === this.indicesUint16.length) this.indicesUint16.set(this.indices);
        else {
            var need32 = attrib > 0xffff && allow32Indices;
            this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices);
        }
        // TODO make this a const..
        this.batchable = this.isBatchable();
        if (this.batchable) this.packBatches();
        else this.buildDrawCalls();
    };
    /**
     * Affinity check
     *
     * @param {PIXI.FillStyle | PIXI.LineStyle} styleA
     * @param {PIXI.FillStyle | PIXI.LineStyle} styleB
     */ GraphicsGeometry.prototype._compareStyles = function(styleA, styleB) {
        if (!styleA || !styleB) return false;
        if (styleA.texture.baseTexture !== styleB.texture.baseTexture) return false;
        if (styleA.color + styleA.alpha !== styleB.color + styleB.alpha) return false;
        if (!!styleA.native !== !!styleB.native) return false;
        return true;
    };
    /**
     * Test geometry for batching process.
     *
     * @protected
     */ GraphicsGeometry.prototype.validateBatching = function() {
        if (this.dirty === this.cacheDirty || !this.graphicsData.length) return false;
        for(var i = 0, l = this.graphicsData.length; i < l; i++){
            var data = this.graphicsData[i];
            var fill = data.fillStyle;
            var line = data.lineStyle;
            if (fill && !fill.texture.baseTexture.valid) return false;
            if (line && !line.texture.baseTexture.valid) return false;
        }
        return true;
    };
    /**
     * Offset the indices so that it works with the batcher.
     *
     * @protected
     */ GraphicsGeometry.prototype.packBatches = function() {
        this.batchDirty++;
        this.uvsFloat32 = new Float32Array(this.uvs);
        var batches = this.batches;
        for(var i = 0, l = batches.length; i < l; i++){
            var batch = batches[i];
            for(var j = 0; j < batch.size; j++){
                var index = batch.start + j;
                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
            }
        }
    };
    /**
     * Checks to see if this graphics geometry can be batched.
     * Currently it needs to be small enough and not contain any native lines.
     *
     * @protected
     */ GraphicsGeometry.prototype.isBatchable = function() {
        // prevent heavy mesh batching
        if (this.points.length > 131070) return false;
        var batches = this.batches;
        for(var i = 0; i < batches.length; i++){
            if (batches[i].style.native) return false;
        }
        return this.points.length < GraphicsGeometry.BATCHABLE_SIZE * 2;
    };
    /**
     * Converts intermediate batches data to drawCalls.
     *
     * @protected
     */ GraphicsGeometry.prototype.buildDrawCalls = function() {
        var TICK = ++(0, $klOfb.BaseTexture)._globalBatch;
        for(var i = 0; i < this.drawCalls.length; i++){
            this.drawCalls[i].texArray.clear();
            $c0878112c399eabe$var$DRAW_CALL_POOL.push(this.drawCalls[i]);
        }
        this.drawCalls.length = 0;
        var colors = this.colors;
        var textureIds = this.textureIds;
        var currentGroup = $c0878112c399eabe$var$DRAW_CALL_POOL.pop();
        if (!currentGroup) {
            currentGroup = new (0, $klOfb.BatchDrawCall)();
            currentGroup.texArray = new (0, $klOfb.BatchTextureArray)();
        }
        currentGroup.texArray.count = 0;
        currentGroup.start = 0;
        currentGroup.size = 0;
        currentGroup.type = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        var textureCount = 0;
        var currentTexture = null;
        var textureId = 0;
        var native = false;
        var drawMode = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        var index = 0;
        this.drawCalls.push(currentGroup);
        // TODO - this can be simplified
        for(var i = 0; i < this.batches.length; i++){
            var data = this.batches[i];
            // TODO add some full on MAX_TEXTURE CODE..
            var MAX_TEXTURES = 8;
            // Forced cast for checking `native` without errors
            var style = data.style;
            var nextTexture = style.texture.baseTexture;
            if (native !== !!style.native) {
                native = !!style.native;
                drawMode = native ? (0, $P8XPi.DRAW_MODES).LINES : (0, $P8XPi.DRAW_MODES).TRIANGLES;
                // force the batch to break!
                currentTexture = null;
                textureCount = MAX_TEXTURES;
                TICK++;
            }
            if (currentTexture !== nextTexture) {
                currentTexture = nextTexture;
                if (nextTexture._batchEnabled !== TICK) {
                    if (textureCount === MAX_TEXTURES) {
                        TICK++;
                        textureCount = 0;
                        if (currentGroup.size > 0) {
                            currentGroup = $c0878112c399eabe$var$DRAW_CALL_POOL.pop();
                            if (!currentGroup) {
                                currentGroup = new (0, $klOfb.BatchDrawCall)();
                                currentGroup.texArray = new (0, $klOfb.BatchTextureArray)();
                            }
                            this.drawCalls.push(currentGroup);
                        }
                        currentGroup.start = index;
                        currentGroup.size = 0;
                        currentGroup.texArray.count = 0;
                        currentGroup.type = drawMode;
                    }
                    // TODO add this to the render part..
                    // Hack! Because texture has protected `touched`
                    nextTexture.touched = 1; // touch;
                    nextTexture._batchEnabled = TICK;
                    nextTexture._batchLocation = textureCount;
                    nextTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
                    currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture;
                    textureCount++;
                }
            }
            currentGroup.size += data.size;
            index += data.size;
            textureId = nextTexture._batchLocation;
            this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart);
            this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
        }
        (0, $klOfb.BaseTexture)._globalBatch = TICK;
        // upload..
        // merge for now!
        this.packAttributes();
    };
    /**
     * Packs attributes to single buffer.
     *
     * @protected
     */ GraphicsGeometry.prototype.packAttributes = function() {
        var verts = this.points;
        var uvs = this.uvs;
        var colors = this.colors;
        var textureIds = this.textureIds;
        // verts are 2 positions.. so we * by 3 as there are 6 properties.. then 4 cos its bytes
        var glPoints = new ArrayBuffer(verts.length * 12);
        var f32 = new Float32Array(glPoints);
        var u32 = new Uint32Array(glPoints);
        var p = 0;
        for(var i = 0; i < verts.length / 2; i++){
            f32[p++] = verts[i * 2];
            f32[p++] = verts[i * 2 + 1];
            f32[p++] = uvs[i * 2];
            f32[p++] = uvs[i * 2 + 1];
            u32[p++] = colors[i];
            f32[p++] = textureIds[i];
        }
        this._buffer.update(glPoints);
        this._indexBuffer.update(this.indicesUint16);
    };
    /**
     * Process fill part of Graphics.
     *
     * @param {PIXI.GraphicsData} data
     * @protected
     */ GraphicsGeometry.prototype.processFill = function(data) {
        if (data.holes.length) {
            this.processHoles(data.holes);
            $c0878112c399eabe$var$buildPoly.triangulate(data, this);
        } else {
            var command = $c0878112c399eabe$var$FILL_COMMANDS[data.type];
            command.triangulate(data, this);
        }
    };
    /**
     * Process line part of Graphics.
     *
     * @param {PIXI.GraphicsData} data
     * @protected
     */ GraphicsGeometry.prototype.processLine = function(data) {
        $c0878112c399eabe$var$buildLine(data, this);
        for(var i = 0; i < data.holes.length; i++)$c0878112c399eabe$var$buildLine(data.holes[i], this);
    };
    /**
     * Process the holes data.
     *
     * @param {PIXI.GraphicsData[]} holes - Holes to render
     * @protected
     */ GraphicsGeometry.prototype.processHoles = function(holes) {
        for(var i = 0; i < holes.length; i++){
            var hole = holes[i];
            var command = $c0878112c399eabe$var$FILL_COMMANDS[hole.type];
            command.build(hole);
            if (hole.matrix) this.transformPoints(hole.points, hole.matrix);
        }
    };
    /**
     * Update the local bounds of the object. Expensive to use performance-wise.
     *
     * @protected
     */ GraphicsGeometry.prototype.calculateBounds = function() {
        var bounds = this._bounds;
        var sequenceBounds = $c0878112c399eabe$var$tmpBounds;
        var curMatrix = (0, $6qzqq.Matrix).IDENTITY;
        this._bounds.clear();
        sequenceBounds.clear();
        for(var i = 0; i < this.graphicsData.length; i++){
            var data = this.graphicsData[i];
            var shape = data.shape;
            var type = data.type;
            var lineStyle = data.lineStyle;
            var nextMatrix = data.matrix || (0, $6qzqq.Matrix).IDENTITY;
            var lineWidth = 0.0;
            if (lineStyle && lineStyle.visible) {
                var alignment = lineStyle.alignment;
                lineWidth = lineStyle.width;
                if (type === (0, $6qzqq.SHAPES).POLY) {
                    if ($c0878112c399eabe$var$isPolygonClockwise(shape)) lineWidth = lineWidth * (1 - alignment);
                    else lineWidth = lineWidth * alignment;
                } else lineWidth = lineWidth * Math.max(0, alignment);
            }
            if (curMatrix !== nextMatrix) {
                if (!sequenceBounds.isEmpty()) {
                    bounds.addBoundsMatrix(sequenceBounds, curMatrix);
                    sequenceBounds.clear();
                }
                curMatrix = nextMatrix;
            }
            if (type === (0, $6qzqq.SHAPES).RECT || type === (0, $6qzqq.SHAPES).RREC) {
                var rect = shape;
                sequenceBounds.addFramePad(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, lineWidth, lineWidth);
            } else if (type === (0, $6qzqq.SHAPES).CIRC) {
                var circle = shape;
                sequenceBounds.addFramePad(circle.x, circle.y, circle.x, circle.y, circle.radius + lineWidth, circle.radius + lineWidth);
            } else if (type === (0, $6qzqq.SHAPES).ELIP) {
                var ellipse = shape;
                sequenceBounds.addFramePad(ellipse.x, ellipse.y, ellipse.x, ellipse.y, ellipse.width + lineWidth, ellipse.height + lineWidth);
            } else {
                var poly = shape;
                // adding directly to the bounds
                bounds.addVerticesMatrix(curMatrix, poly.points, 0, poly.points.length, lineWidth, lineWidth);
            }
        }
        if (!sequenceBounds.isEmpty()) bounds.addBoundsMatrix(sequenceBounds, curMatrix);
        bounds.pad(this.boundsPadding, this.boundsPadding);
    };
    /**
     * Transform points using matrix.
     *
     * @protected
     * @param {number[]} points - Points to transform
     * @param {PIXI.Matrix} matrix - Transform matrix
     */ GraphicsGeometry.prototype.transformPoints = function(points, matrix) {
        for(var i = 0; i < points.length / 2; i++){
            var x = points[i * 2];
            var y = points[i * 2 + 1];
            points[i * 2] = matrix.a * x + matrix.c * y + matrix.tx;
            points[i * 2 + 1] = matrix.b * x + matrix.d * y + matrix.ty;
        }
    };
    /**
     * Add colors.
     *
     * @protected
     * @param {number[]} colors - List of colors to add to
     * @param {number} color - Color to add
     * @param {number} alpha - Alpha to use
     * @param {number} size - Number of colors to add
     * @param {number} offset
     */ GraphicsGeometry.prototype.addColors = function(colors, color, alpha, size, offset) {
        if (offset === void 0) offset = 0;
        // TODO use the premultiply bits Ivan added
        var rgb = (color >> 16) + (color & 0xff00) + ((color & 0xff) << 16);
        var rgba = (0, $csytw.premultiplyTint)(rgb, alpha);
        colors.length = Math.max(colors.length, offset + size);
        for(var i = 0; i < size; i++)colors[offset + i] = rgba;
    };
    /**
     * Add texture id that the shader/fragment wants to use.
     *
     * @protected
     * @param {number[]} textureIds
     * @param {number} id
     * @param {number} size
     * @param {number} offset
     */ GraphicsGeometry.prototype.addTextureIds = function(textureIds, id, size, offset) {
        if (offset === void 0) offset = 0;
        textureIds.length = Math.max(textureIds.length, offset + size);
        for(var i = 0; i < size; i++)textureIds[offset + i] = id;
    };
    /**
     * Generates the UVs for a shape.
     *
     * @protected
     * @param {number[]} verts - Vertices
     * @param {number[]} uvs - UVs
     * @param {PIXI.Texture} texture - Reference to Texture
     * @param {number} start - Index buffer start index.
     * @param {number} size - The size/length for index buffer.
     * @param {PIXI.Matrix} [matrix] - Optional transform for all points.
     */ GraphicsGeometry.prototype.addUvs = function(verts, uvs, texture, start, size, matrix) {
        if (matrix === void 0) matrix = null;
        var index = 0;
        var uvsStart = uvs.length;
        var frame = texture.frame;
        while(index < size){
            var x = verts[(start + index) * 2];
            var y = verts[(start + index) * 2 + 1];
            if (matrix) {
                var nx = matrix.a * x + matrix.c * y + matrix.tx;
                y = matrix.b * x + matrix.d * y + matrix.ty;
                x = nx;
            }
            index++;
            uvs.push(x / frame.width, y / frame.height);
        }
        var baseTexture = texture.baseTexture;
        if (frame.width < baseTexture.width || frame.height < baseTexture.height) this.adjustUvs(uvs, texture, uvsStart, size);
    };
    /**
     * Modify uvs array according to position of texture region
     * Does not work with rotated or trimmed textures
     *
     * @param {number[]} uvs - array
     * @param {PIXI.Texture} texture - region
     * @param {number} start - starting index for uvs
     * @param {number} size - how many points to adjust
     */ GraphicsGeometry.prototype.adjustUvs = function(uvs, texture, start, size) {
        var baseTexture = texture.baseTexture;
        var eps = 1e-6;
        var finish = start + size * 2;
        var frame = texture.frame;
        var scaleX = frame.width / baseTexture.width;
        var scaleY = frame.height / baseTexture.height;
        var offsetX = frame.x / frame.width;
        var offsetY = frame.y / frame.height;
        var minX = Math.floor(uvs[start] + eps);
        var minY = Math.floor(uvs[start + 1] + eps);
        for(var i = start + 2; i < finish; i += 2){
            minX = Math.min(minX, Math.floor(uvs[i] + eps));
            minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
        }
        offsetX -= minX;
        offsetY -= minY;
        for(var i = start; i < finish; i += 2){
            uvs[i] = (uvs[i] + offsetX) * scaleX;
            uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
        }
    };
    /**
     * The maximum number of points to consider an object "batchable",
     * able to be batched by the renderer's batch system.
\    */ GraphicsGeometry.BATCHABLE_SIZE = 100;
    return GraphicsGeometry;
}((0, $klOfb.BatchGeometry));
/**
 * Represents the line style for Graphics.
 * @memberof PIXI
 * @class
 * @extends PIXI.FillStyle
 */ var $c0878112c399eabe$export$5d24e00cfde59887 = /** @class */ function(_super) {
    $c0878112c399eabe$var$__extends(LineStyle, _super);
    function LineStyle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** The width (thickness) of any lines drawn. */ _this.width = 0;
        /** The alignment of any lines drawn (0.5 = middle, 1 = outer, 0 = inner). WebGL only. */ _this.alignment = 0.5;
        /** If true the lines will be draw using LINES instead of TRIANGLE_STRIP */ _this.native = false;
        /**
         * Line cap style.
         *
         * @member {PIXI.LINE_CAP}
         * @default PIXI.LINE_CAP.BUTT
         */ _this.cap = $c0878112c399eabe$export$b113e22c48c75d2e.BUTT;
        /**
         * Line join style.
         *
         * @member {PIXI.LINE_JOIN}
         * @default PIXI.LINE_JOIN.MITER
         */ _this.join = $c0878112c399eabe$export$c6a6e344be1302e7.MITER;
        /** Miter limit. */ _this.miterLimit = 10;
        return _this;
    }
    /**
     * Clones the object
     *
     * @return {PIXI.LineStyle}
     */ LineStyle.prototype.clone = function() {
        var obj = new LineStyle();
        obj.color = this.color;
        obj.alpha = this.alpha;
        obj.texture = this.texture;
        obj.matrix = this.matrix;
        obj.visible = this.visible;
        obj.width = this.width;
        obj.alignment = this.alignment;
        obj.native = this.native;
        obj.cap = this.cap;
        obj.join = this.join;
        obj.miterLimit = this.miterLimit;
        return obj;
    };
    /**
     * Reset the line style to default.
     */ LineStyle.prototype.reset = function() {
        _super.prototype.reset.call(this);
        // Override default line style color
        this.color = 0x0;
        this.alignment = 0.5;
        this.width = 0;
        this.native = false;
    };
    return LineStyle;
}($c0878112c399eabe$export$c42b166860ccdbd8);
var $c0878112c399eabe$var$temp = new Float32Array(3);
// a default shaders map used by graphics..
var $c0878112c399eabe$var$DEFAULT_SHADERS = {};
/**
 * The Graphics class is primarily used to render primitive shapes such as lines, circles and
 * rectangles to the display, and to color and fill them.  However, you can also use a Graphics
 * object to build a list of primitives to use as a mask, or as a complex hitArea.
 *
 * Please note that due to legacy naming conventions, the behavior of some functions in this class
 * can be confusing.  Each call to `drawRect()`, `drawPolygon()`, etc. actually stores that primitive
 * in the Geometry class's GraphicsGeometry object for later use in rendering or hit testing - the
 * functions do not directly draw anything to the screen.  Similarly, the `clear()` function doesn't
 * change the screen, it simply resets the list of primitives, which can be useful if you want to
 * rebuild the contents of an existing Graphics object.
 *
 * Once a GraphicsGeometry list is built, you can re-use it in other Geometry objects as
 * an optimization, by passing it into a new Geometry object's constructor.  Because of this
 * ability, it's important to call `destroy()` on Geometry objects once you are done with them, to
 * properly dereference each GraphicsGeometry and prevent memory leaks.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI
 */ var $c0878112c399eabe$export$29d3e417456abdad = /** @class */ function(_super) {
    $c0878112c399eabe$var$__extends(Graphics, _super);
    /**
     * @param {PIXI.GraphicsGeometry} [geometry=null] - Geometry to use, if omitted
     *        will create a new GraphicsGeometry instance.
     */ function Graphics(geometry) {
        if (geometry === void 0) geometry = null;
        var _this = _super.call(this) || this;
        /**
         * Represents the vertex and fragment shaders that processes the geometry and runs on the GPU.
         * Can be shared between multiple Graphics objects.
         */ _this.shader = null;
        /** Renderer plugin for batching */ _this.pluginName = 'batch';
        /**
         * Current path
         *
         * @member {PIXI.Polygon}
         * @readonly
         */ _this.currentPath = null;
        /**
         * A collections of batches! These can be drawn by the renderer batch system.
         *
         * @member {PIXI.IGraphicsBatchElement[]}
         */ _this.batches = [];
        /** Update dirty for limiting calculating tints for batches. */ _this.batchTint = -1;
        /** Update dirty for limiting calculating batches.*/ _this.batchDirty = -1;
        /** Copy of the object vertex data. */ _this.vertexData = null;
        /**
         * Current fill style
         *
         * @member {PIXI.FillStyle}
         */ _this._fillStyle = new $c0878112c399eabe$export$c42b166860ccdbd8();
        /**
         * Current line style
         *
         * @member {PIXI.LineStyle}
         */ _this._lineStyle = new $c0878112c399eabe$export$5d24e00cfde59887();
        /**
         * Current shape transform matrix.
         *
         * @member {PIXI.Matrix}
         */ _this._matrix = null;
        /** Current hole mode is enabled. */ _this._holeMode = false;
        /**
         * Represents the WebGL state the Graphics required to render, excludes shader and geometry. E.g.,
         * blend mode, culling, depth testing, direction of rendering triangles, backface, etc.
         *
         * @member {PIXI.State}
         */ _this.state = (0, $klOfb.State).for2d();
        _this._geometry = geometry || new $c0878112c399eabe$export$c707987b44ce3a12();
        _this._geometry.refCount++;
        /**
         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
         * This is useful if your graphics element does not change often, as it will speed up the rendering
         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
         * you are constantly redrawing the graphics element.
         *
         * @name cacheAsBitmap
         * @member {boolean}
         * @memberof PIXI.Graphics#
         * @default false
         */ _this._transformID = -1;
        // Set default
        _this.tint = 0xFFFFFF;
        _this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        return _this;
    }
    Object.defineProperty(Graphics.prototype, "geometry", {
        /**
         * Includes vertex positions, face indices, normals, colors, UVs, and
         * custom attributes within buffers, reducing the cost of passing all
         * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
         *
         * @member {PIXI.GraphicsGeometry}
         * @readonly
         */ get: function() {
            return this._geometry;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates a new Graphics object with the same values as this one.
     * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
     *
     * @return {PIXI.Graphics} A clone of the graphics object
     */ Graphics.prototype.clone = function() {
        this.finishPoly();
        return new Graphics(this._geometry);
    };
    Object.defineProperty(Graphics.prototype, "blendMode", {
        get: function() {
            return this.state.blendMode;
        },
        /**
         * The blend mode to be applied to the graphic shape. Apply a value of
         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
         * primitive in the GraphicsGeometry list is rendered sequentially, modes
         * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
         * be applied per-primitive.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL;
         * @see PIXI.BLEND_MODES
         */ set: function(value) {
            this.state.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Graphics.prototype, "tint", {
        /**
         * The tint applied to each graphic shape. This is a hex value. A value of
         * 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            this._tint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Graphics.prototype, "fill", {
        /**
         * The current fill style.
         *
         * @member {PIXI.FillStyle}
         * @readonly
         */ get: function() {
            return this._fillStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Graphics.prototype, "line", {
        /**
         * The current line style.
         *
         * @member {PIXI.LineStyle}
         * @readonly
         */ get: function() {
            return this._lineStyle;
        },
        enumerable: false,
        configurable: true
    });
    Graphics.prototype.lineStyle = function(options, color, alpha, alignment, native) {
        if (options === void 0) options = null;
        if (color === void 0) color = 0x0;
        if (alpha === void 0) alpha = 1;
        if (alignment === void 0) alignment = 0.5;
        if (native === void 0) native = false;
        // Support non-object params: (width, color, alpha, alignment, native)
        if (typeof options === 'number') options = {
            width: options,
            color: color,
            alpha: alpha,
            alignment: alignment,
            native: native
        };
        return this.lineTextureStyle(options);
    };
    /**
     * Like line style but support texture for line fill.
     *
     * @param {object} [options] - Collection of options for setting line style.
     * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
     * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
     * @param {number} [options.color=0x0] - color of the line to draw, will update the objects stored style.
     *  Default 0xFFFFFF if texture present.
     * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
     * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
     * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
     *        WebGL only.
     * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
     * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
     * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
     * @param {number}[options.miterLimit=10] - miter limit ratio
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.lineTextureStyle = function(options) {
        // Apply defaults
        options = Object.assign({
            width: 0,
            texture: (0, $klOfb.Texture).WHITE,
            color: options && options.texture ? 0xFFFFFF : 0x0,
            alpha: 1,
            matrix: null,
            alignment: 0.5,
            native: false,
            cap: $c0878112c399eabe$export$b113e22c48c75d2e.BUTT,
            join: $c0878112c399eabe$export$c6a6e344be1302e7.MITER,
            miterLimit: 10
        }, options);
        if (this.currentPath) this.startPoly();
        var visible = options.width > 0 && options.alpha > 0;
        if (!visible) this._lineStyle.reset();
        else {
            if (options.matrix) {
                options.matrix = options.matrix.clone();
                options.matrix.invert();
            }
            Object.assign(this._lineStyle, {
                visible: visible
            }, options);
        }
        return this;
    };
    /**
     * Start a polygon object internally
     * @protected
     */ Graphics.prototype.startPoly = function() {
        if (this.currentPath) {
            var points = this.currentPath.points;
            var len = this.currentPath.points.length;
            if (len > 2) {
                this.drawShape(this.currentPath);
                this.currentPath = new (0, $6qzqq.Polygon)();
                this.currentPath.closeStroke = false;
                this.currentPath.points.push(points[len - 2], points[len - 1]);
            }
        } else {
            this.currentPath = new (0, $6qzqq.Polygon)();
            this.currentPath.closeStroke = false;
        }
    };
    /**
     * Finish the polygon object.
     * @protected
     */ Graphics.prototype.finishPoly = function() {
        if (this.currentPath) {
            if (this.currentPath.points.length > 2) {
                this.drawShape(this.currentPath);
                this.currentPath = null;
            } else this.currentPath.points.length = 0;
        }
    };
    /**
     * Moves the current drawing position to x, y.
     *
     * @param {number} x - the X coordinate to move to
     * @param {number} y - the Y coordinate to move to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.moveTo = function(x, y) {
        this.startPoly();
        this.currentPath.points[0] = x;
        this.currentPath.points[1] = y;
        return this;
    };
    /**
     * Draws a line using the current line style from the current drawing position to (x, y);
     * The current drawing position is then set to (x, y).
     *
     * @param {number} x - the X coordinate to draw to
     * @param {number} y - the Y coordinate to draw to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.lineTo = function(x, y) {
        if (!this.currentPath) this.moveTo(0, 0);
        // remove duplicates..
        var points = this.currentPath.points;
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    };
    /**
     * Initialize the curve
     *
     * @param {number} [x=0]
     * @param {number} [y=0]
     */ Graphics.prototype._initCurve = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (this.currentPath) {
            if (this.currentPath.points.length === 0) this.currentPath.points = [
                x,
                y
            ];
        } else this.moveTo(x, y);
    };
    /**
     * Calculate the points for a quadratic bezier curve and then draws it.
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.quadraticCurveTo = function(cpX, cpY, toX, toY) {
        this._initCurve();
        var points = this.currentPath.points;
        if (points.length === 0) this.moveTo(0, 0);
        $c0878112c399eabe$var$QuadraticUtils.curveTo(cpX, cpY, toX, toY, points);
        return this;
    };
    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.bezierCurveTo = function(cpX, cpY, cpX2, cpY2, toX, toY) {
        this._initCurve();
        $c0878112c399eabe$var$BezierUtils.curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points);
        return this;
    };
    /**
     * The arcTo() method creates an arc/curve between two tangents on the canvas.
     *
     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
     *
     * @param {number} x1 - The x-coordinate of the first tangent point of the arc
     * @param {number} y1 - The y-coordinate of the first tangent point of the arc
     * @param {number} x2 - The x-coordinate of the end of the arc
     * @param {number} y2 - The y-coordinate of the end of the arc
     * @param {number} radius - The radius of the arc
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._initCurve(x1, y1);
        var points = this.currentPath.points;
        var result = $c0878112c399eabe$var$ArcUtils.curveTo(x1, y1, x2, y2, radius, points);
        if (result) {
            var cx = result.cx, cy = result.cy, radius_1 = result.radius, startAngle = result.startAngle, endAngle = result.endAngle, anticlockwise = result.anticlockwise;
            this.arc(cx, cy, radius_1, startAngle, endAngle, anticlockwise);
        }
        return this;
    };
    /**
     * The arc method creates an arc/curve (used to create circles, or parts of circles).
     *
     * @param {number} cx - The x-coordinate of the center of the circle
     * @param {number} cy - The y-coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
     *  of the arc's circle)
     * @param {number} endAngle - The ending angle, in radians
     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
     *  indicates counter-clockwise.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.arc = function(cx, cy, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise === void 0) anticlockwise = false;
        if (startAngle === endAngle) return this;
        if (!anticlockwise && endAngle <= startAngle) endAngle += (0, $6qzqq.PI_2);
        else if (anticlockwise && startAngle <= endAngle) startAngle += (0, $6qzqq.PI_2);
        var sweep = endAngle - startAngle;
        if (sweep === 0) return this;
        var startX = cx + Math.cos(startAngle) * radius;
        var startY = cy + Math.sin(startAngle) * radius;
        var eps = this._geometry.closePointEps;
        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
        var points = this.currentPath ? this.currentPath.points : null;
        if (points) {
            // TODO: make a better fix.
            // We check how far our start is from the last existing point
            var xDiff = Math.abs(points[points.length - 2] - startX);
            var yDiff = Math.abs(points[points.length - 1] - startY);
            if (xDiff < eps && yDiff < eps) ;
            else points.push(startX, startY);
        } else {
            this.moveTo(startX, startY);
            points = this.currentPath.points;
        }
        $c0878112c399eabe$var$ArcUtils.arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points);
        return this;
    };
    /**
     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
     * (such as lineTo() or drawCircle()) use when drawing.
     *
     * @param {number} [color=0] - the color of the fill
     * @param {number} [alpha=1] - the alpha of the fill
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.beginFill = function(color, alpha) {
        if (color === void 0) color = 0;
        if (alpha === void 0) alpha = 1;
        return this.beginTextureFill({
            texture: (0, $klOfb.Texture).WHITE,
            color: color,
            alpha: alpha
        });
    };
    /**
     * Begin the texture fill
     *
     * @param {object} [options] - Object object.
     * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
     * @param {number} [options.color=0xffffff] - Background to fill behind texture
     * @param {number} [options.alpha=1] - Alpha of fill
     * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.beginTextureFill = function(options) {
        // Apply defaults
        options = Object.assign({
            texture: (0, $klOfb.Texture).WHITE,
            color: 0xFFFFFF,
            alpha: 1,
            matrix: null
        }, options);
        if (this.currentPath) this.startPoly();
        var visible = options.alpha > 0;
        if (!visible) this._fillStyle.reset();
        else {
            if (options.matrix) {
                options.matrix = options.matrix.clone();
                options.matrix.invert();
            }
            Object.assign(this._fillStyle, {
                visible: visible
            }, options);
        }
        return this;
    };
    /**
     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.endFill = function() {
        this.finishPoly();
        this._fillStyle.reset();
        return this;
    };
    /**
     * Draws a rectangle shape.
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawRect = function(x, y, width, height) {
        return this.drawShape(new (0, $6qzqq.Rectangle)(x, y, width, height));
    };
    /**
     * Draw a rectangle shape with rounded/beveled corners.
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @param {number} radius - Radius of the rectangle corners
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawRoundedRect = function(x, y, width, height, radius) {
        return this.drawShape(new (0, $6qzqq.RoundedRectangle)(x, y, width, height, radius));
    };
    /**
     * Draws a circle.
     *
     * @param {number} x - The X coordinate of the center of the circle
     * @param {number} y - The Y coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawCircle = function(x, y, radius) {
        return this.drawShape(new (0, $6qzqq.Circle)(x, y, radius));
    };
    /**
     * Draws an ellipse.
     *
     * @param {number} x - The X coordinate of the center of the ellipse
     * @param {number} y - The Y coordinate of the center of the ellipse
     * @param {number} width - The half width of the ellipse
     * @param {number} height - The half height of the ellipse
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawEllipse = function(x, y, width, height) {
        return this.drawShape(new (0, $6qzqq.Ellipse)(x, y, width, height));
    };
    /**
     * Draws a polygon using the given path.
     *
     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawPolygon = function() {
        var arguments$1 = arguments;
        var path = [];
        for(var _i = 0; _i < arguments.length; _i++)path[_i] = arguments$1[_i];
        var points;
        var closeStroke = true; // !!this._fillStyle;
        var poly = path[0];
        // check if data has points..
        if (poly.points) {
            closeStroke = poly.closeStroke;
            points = poly.points;
        } else if (Array.isArray(path[0])) points = path[0];
        else points = path;
        var shape = new (0, $6qzqq.Polygon)(points);
        shape.closeStroke = closeStroke;
        this.drawShape(shape);
        return this;
    };
    /**
     * Draw any shape.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawShape = function(shape) {
        if (!this._holeMode) this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix);
        else this._geometry.drawHole(shape, this._matrix);
        return this;
    };
    /**
     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.clear = function() {
        this._geometry.clear();
        this._lineStyle.reset();
        this._fillStyle.reset();
        this._boundsID++;
        this._matrix = null;
        this._holeMode = false;
        this.currentPath = null;
        return this;
    };
    /**
     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
     * masked with gl.scissor.
     *
     * @returns {boolean} True if only 1 rect.
     */ Graphics.prototype.isFastRect = function() {
        var data = this._geometry.graphicsData;
        return data.length === 1 && data[0].shape.type === (0, $6qzqq.SHAPES).RECT && !data[0].matrix && !data[0].holes.length && !(data[0].lineStyle.visible && data[0].lineStyle.width);
    };
    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._render = function(renderer) {
        this.finishPoly();
        var geometry = this._geometry;
        var hasuint32 = renderer.context.supports.uint32Indices;
        // batch part..
        // batch it!
        geometry.updateBatches(hasuint32);
        if (geometry.batchable) {
            if (this.batchDirty !== geometry.batchDirty) this._populateBatches();
            this._renderBatched(renderer);
        } else {
            // no batching...
            renderer.batch.flush();
            this._renderDirect(renderer);
        }
    };
    /** Populating batches for rendering. */ Graphics.prototype._populateBatches = function() {
        var geometry = this._geometry;
        var blendMode = this.blendMode;
        var len = geometry.batches.length;
        this.batchTint = -1;
        this._transformID = -1;
        this.batchDirty = geometry.batchDirty;
        this.batches.length = len;
        this.vertexData = new Float32Array(geometry.points);
        for(var i = 0; i < len; i++){
            var gI = geometry.batches[i];
            var color = gI.style.color;
            var vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 8, gI.attribSize * 2);
            var uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 8, gI.attribSize * 2);
            var indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size);
            var batch = {
                vertexData: vertexData,
                blendMode: blendMode,
                indices: indices,
                uvs: uvs,
                _batchRGB: (0, $csytw.hex2rgb)(color),
                _tintRGB: color,
                _texture: gI.style.texture,
                alpha: gI.style.alpha,
                worldAlpha: 1
            };
            this.batches[i] = batch;
        }
    };
    /**
     * Renders the batches using the BathedRenderer plugin
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._renderBatched = function(renderer) {
        if (!this.batches.length) return;
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        this.calculateVertices();
        this.calculateTints();
        for(var i = 0, l = this.batches.length; i < l; i++){
            var batch = this.batches[i];
            batch.worldAlpha = this.worldAlpha * batch.alpha;
            renderer.plugins[this.pluginName].render(batch);
        }
    };
    /**
     * Renders the graphics direct
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._renderDirect = function(renderer) {
        var shader = this._resolveDirectShader(renderer);
        var geometry = this._geometry;
        var tint = this.tint;
        var worldAlpha = this.worldAlpha;
        var uniforms = shader.uniforms;
        var drawCalls = geometry.drawCalls;
        // lets set the transfomr
        uniforms.translationMatrix = this.transform.worldTransform;
        // and then lets set the tint..
        uniforms.tint[0] = (tint >> 16 & 0xFF) / 255 * worldAlpha;
        uniforms.tint[1] = (tint >> 8 & 0xFF) / 255 * worldAlpha;
        uniforms.tint[2] = (tint & 0xFF) / 255 * worldAlpha;
        uniforms.tint[3] = worldAlpha;
        // the first draw call, we can set the uniforms of the shader directly here.
        // this means that we can tack advantage of the sync function of pixi!
        // bind and sync uniforms..
        // there is a way to optimise this..
        renderer.shader.bind(shader);
        renderer.geometry.bind(geometry, shader);
        // set state..
        renderer.state.set(this.state);
        // then render the rest of them...
        for(var i = 0, l = drawCalls.length; i < l; i++)this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
    };
    /**
     * Renders specific DrawCall
     *
     * @param {PIXI.Renderer} renderer
     * @param {PIXI.BatchDrawCall} drawCall
     */ Graphics.prototype._renderDrawCallDirect = function(renderer, drawCall) {
        var texArray = drawCall.texArray, type = drawCall.type, size = drawCall.size, start = drawCall.start;
        var groupTextureCount = texArray.count;
        for(var j = 0; j < groupTextureCount; j++)renderer.texture.bind(texArray.elements[j], j);
        renderer.geometry.draw(type, size, start);
    };
    /**
     * Resolves shader for direct rendering
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._resolveDirectShader = function(renderer) {
        var shader = this.shader;
        var pluginName = this.pluginName;
        if (!shader) {
            // if there is no shader here, we can use the default shader.
            // and that only gets created if we actually need it..
            // but may be more than one plugins for graphics
            if (!$c0878112c399eabe$var$DEFAULT_SHADERS[pluginName]) {
                var MAX_TEXTURES = renderer.plugins.batch.MAX_TEXTURES;
                var sampleValues = new Int32Array(MAX_TEXTURES);
                for(var i = 0; i < MAX_TEXTURES; i++)sampleValues[i] = i;
                var uniforms = {
                    tint: new Float32Array([
                        1,
                        1,
                        1,
                        1
                    ]),
                    translationMatrix: new (0, $6qzqq.Matrix)(),
                    default: (0, $klOfb.UniformGroup).from({
                        uSamplers: sampleValues
                    }, true)
                };
                var program = renderer.plugins[pluginName]._shader.program;
                $c0878112c399eabe$var$DEFAULT_SHADERS[pluginName] = new (0, $klOfb.Shader)(program, uniforms);
            }
            shader = $c0878112c399eabe$var$DEFAULT_SHADERS[pluginName];
        }
        return shader;
    };
    /** Retrieves the bounds of the graphic shape as a rectangle object. */ Graphics.prototype._calculateBounds = function() {
        this.finishPoly();
        var geometry = this._geometry;
        // skipping when graphics is empty, like a container
        if (!geometry.graphicsData.length) return;
        var _a = geometry.bounds, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    };
    /**
     * Tests if a point is inside this graphics object
     *
     * @param {PIXI.IPointData} point - the point to test
     * @return {boolean} the result of the test
     */ Graphics.prototype.containsPoint = function(point) {
        this.worldTransform.applyInverse(point, Graphics._TEMP_POINT);
        return this._geometry.containsPoint(Graphics._TEMP_POINT);
    };
    /** Recalculate the tint by applying tint to batches using Graphics tint. */ Graphics.prototype.calculateTints = function() {
        if (this.batchTint !== this.tint) {
            this.batchTint = this.tint;
            var tintRGB = (0, $csytw.hex2rgb)(this.tint, $c0878112c399eabe$var$temp);
            for(var i = 0; i < this.batches.length; i++){
                var batch = this.batches[i];
                var batchTint = batch._batchRGB;
                var r = tintRGB[0] * batchTint[0] * 255;
                var g = tintRGB[1] * batchTint[1] * 255;
                var b = tintRGB[2] * batchTint[2] * 255;
                // TODO Ivan, can this be done in one go?
                var color = (r << 16) + (g << 8) + (b | 0);
                batch._tintRGB = (color >> 16) + (color & 0xff00) + ((color & 0xff) << 16);
            }
        }
    };
    /**
     * If there's a transform update or a change to the shape of the
     * geometry, recalculate the vertices.
     */ Graphics.prototype.calculateVertices = function() {
        var wtID = this.transform._worldID;
        if (this._transformID === wtID) return;
        this._transformID = wtID;
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var data = this._geometry.points; // batch.vertexDataOriginal;
        var vertexData = this.vertexData;
        var count = 0;
        for(var i = 0; i < data.length; i += 2){
            var x = data[i];
            var y = data[i + 1];
            vertexData[count++] = a * x + c * y + tx;
            vertexData[count++] = d * y + b * x + ty;
        }
    };
    /**
     * Closes the current path.
     *
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.closePath = function() {
        var currentPath = this.currentPath;
        if (currentPath) {
            // we don't need to add extra point in the end because buildLine will take care of that
            currentPath.closeStroke = true;
            // ensure that the polygon is completed, and is available for hit detection
            // (even if the graphics is not rendered yet)
            this.finishPoly();
        }
        return this;
    };
    /**
     * Apply a matrix to the positional data.
     *
     * @param {PIXI.Matrix} matrix - Matrix to use for transform current shape.
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.setMatrix = function(matrix) {
        this._matrix = matrix;
        return this;
    };
    /**
     * Begin adding holes to the last draw shape
     * IMPORTANT: holes must be fully inside a shape to work
     * Also weirdness ensues if holes overlap!
     * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
     * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.beginHole = function() {
        this.finishPoly();
        this._holeMode = true;
        return this;
    };
    /**
     * End adding holes to the last draw shape
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.endHole = function() {
        this.finishPoly();
        this._holeMode = false;
        return this;
    };
    /**
     * Destroys the Graphics object.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
     *  options have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have
     *  their destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */ Graphics.prototype.destroy = function(options) {
        this._geometry.refCount--;
        if (this._geometry.refCount === 0) this._geometry.dispose();
        this._matrix = null;
        this.currentPath = null;
        this._lineStyle.destroy();
        this._lineStyle = null;
        this._fillStyle.destroy();
        this._fillStyle = null;
        this._geometry = null;
        this.shader = null;
        this.vertexData = null;
        this.batches.length = 0;
        this.batches = null;
        _super.prototype.destroy.call(this, options);
    };
    /**
     * Temporary point to use for containsPoint
     *
     * @static
     * @private
     */ Graphics._TEMP_POINT = new (0, $6qzqq.Point)();
    return Graphics;
}((0, $8t5Gy.Container));
var $c0878112c399eabe$export$efc72ad5bf88689 = {
    buildPoly: $c0878112c399eabe$var$buildPoly,
    buildCircle: $c0878112c399eabe$var$buildCircle,
    buildRectangle: $c0878112c399eabe$var$buildRectangle,
    buildRoundedRectangle: $c0878112c399eabe$var$buildRoundedRectangle,
    buildLine: $c0878112c399eabe$var$buildLine,
    ArcUtils: $c0878112c399eabe$var$ArcUtils,
    BezierUtils: $c0878112c399eabe$var$BezierUtils,
    QuadraticUtils: $c0878112c399eabe$var$QuadraticUtils,
    BatchPart: $c0878112c399eabe$var$BatchPart,
    FILL_COMMANDS: $c0878112c399eabe$var$FILL_COMMANDS,
    BATCH_POOL: $c0878112c399eabe$var$BATCH_POOL,
    DRAW_CALL_POOL: $c0878112c399eabe$var$DRAW_CALL_POOL
};

});

parcelRegister("9Pi8W", function(module, exports) {

$parcel$export(module.exports, "TEXT_GRADIENT", function () { return $7276f35895ff141a$export$131daa784848984; });
$parcel$export(module.exports, "TextStyle", function () { return $7276f35895ff141a$export$1df879243bf2e42d; });
$parcel$export(module.exports, "TextMetrics", function () { return $7276f35895ff141a$export$4c5a129a59e1ef34; });
$parcel$export(module.exports, "Text", function () { return $7276f35895ff141a$export$5f1af8db9871e1d6; });
/*!
 * @pixi/text - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/text is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $7Bs2Z = parcelRequire("7Bs2Z");

var $klOfb = parcelRequire("klOfb");

var $ezJmd = parcelRequire("ezJmd");

var $6qzqq = parcelRequire("6qzqq");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $7276f35895ff141a$var$extendStatics = function(d, b) {
    $7276f35895ff141a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7276f35895ff141a$var$extendStatics(d, b);
};
function $7276f35895ff141a$var$__extends(d, b) {
    $7276f35895ff141a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Constants that define the type of gradient on text.
 *
 * @static
 * @constant
 * @name TEXT_GRADIENT
 * @memberof PIXI
 * @type {object}
 * @property {number} LINEAR_VERTICAL Vertical gradient
 * @property {number} LINEAR_HORIZONTAL Linear gradient
 */ var $7276f35895ff141a$export$131daa784848984;
(function(TEXT_GRADIENT) {
    TEXT_GRADIENT[TEXT_GRADIENT["LINEAR_VERTICAL"] = 0] = "LINEAR_VERTICAL";
    TEXT_GRADIENT[TEXT_GRADIENT["LINEAR_HORIZONTAL"] = 1] = "LINEAR_HORIZONTAL";
})($7276f35895ff141a$export$131daa784848984 || ($7276f35895ff141a$export$131daa784848984 = {}));
// disabling eslint for now, going to rewrite this in v5
var $7276f35895ff141a$var$defaultStyle = {
    align: 'left',
    breakWords: false,
    dropShadow: false,
    dropShadowAlpha: 1,
    dropShadowAngle: Math.PI / 6,
    dropShadowBlur: 0,
    dropShadowColor: 'black',
    dropShadowDistance: 5,
    fill: 'black',
    fillGradientType: $7276f35895ff141a$export$131daa784848984.LINEAR_VERTICAL,
    fillGradientStops: [],
    fontFamily: 'Arial',
    fontSize: 26,
    fontStyle: 'normal',
    fontVariant: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    lineHeight: 0,
    lineJoin: 'miter',
    miterLimit: 10,
    padding: 0,
    stroke: 'black',
    strokeThickness: 0,
    textBaseline: 'alphabetic',
    trim: false,
    whiteSpace: 'pre',
    wordWrap: false,
    wordWrapWidth: 100,
    leading: 0
};
var $7276f35895ff141a$var$genericFontFamilies = [
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui'
];
/**
 * A TextStyle Object contains information to decorate a Text objects.
 *
 * An instance can be shared between multiple Text objects; then changing the style will update all text objects using it.
 *
 * A tool can be used to generate a text style [here](https://pixijs.io/pixi-text-style).
 *
 * @memberof PIXI
 */ var $7276f35895ff141a$export$1df879243bf2e42d = /** @class */ function() {
    /**
     * @param {object} [style] - The style parameters
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
     *  does not affect single line text
     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
     *  needs wordWrap to be set to true
     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
     *  eg ['#000000','#FFFFFF']
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
     *  equivalents are '26px','20pt','160%' or '1.6em')
     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
     *  '200', '300', '400', '500', '600', '700', '800' or '900')
     * @param {number} [style.leading=0] - The space between lines
     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
     *      (creates a squared corner).
     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
     *      or increase the spikiness of rendered text.
     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
     *     happening by adding padding to all sides of the text.
     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
     *  e.g 'blue', '#FCFF00'
     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
     *  Default is 0 (no stroke)
     * @param {boolean} [style.trim=false] - Trim transparent borders
     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
     * @param {string} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
     */ function TextStyle(style) {
        this.styleID = 0;
        this.reset();
        $7276f35895ff141a$var$deepCopyProperties(this, style, style);
    }
    /**
     * Creates a new TextStyle object with the same values as this one.
     * Note that the only the properties of the object are cloned.
     *
     * @return New cloned TextStyle object
     */ TextStyle.prototype.clone = function() {
        var clonedProperties = {};
        $7276f35895ff141a$var$deepCopyProperties(clonedProperties, this, $7276f35895ff141a$var$defaultStyle);
        return new TextStyle(clonedProperties);
    };
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ TextStyle.prototype.reset = function() {
        $7276f35895ff141a$var$deepCopyProperties(this, $7276f35895ff141a$var$defaultStyle, $7276f35895ff141a$var$defaultStyle);
    };
    Object.defineProperty(TextStyle.prototype, "align", {
        /**
         * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
         *
         * @member {string}
         */ get: function() {
            return this._align;
        },
        set: function(align) {
            if (this._align !== align) {
                this._align = align;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "breakWords", {
        /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get: function() {
            return this._breakWords;
        },
        set: function(breakWords) {
            if (this._breakWords !== breakWords) {
                this._breakWords = breakWords;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadow", {
        /** Set a drop shadow for the text. */ get: function() {
            return this._dropShadow;
        },
        set: function(dropShadow) {
            if (this._dropShadow !== dropShadow) {
                this._dropShadow = dropShadow;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowAlpha", {
        /** Set alpha for the drop shadow. */ get: function() {
            return this._dropShadowAlpha;
        },
        set: function(dropShadowAlpha) {
            if (this._dropShadowAlpha !== dropShadowAlpha) {
                this._dropShadowAlpha = dropShadowAlpha;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowAngle", {
        /** Set a angle of the drop shadow. */ get: function() {
            return this._dropShadowAngle;
        },
        set: function(dropShadowAngle) {
            if (this._dropShadowAngle !== dropShadowAngle) {
                this._dropShadowAngle = dropShadowAngle;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowBlur", {
        /** Set a shadow blur radius. */ get: function() {
            return this._dropShadowBlur;
        },
        set: function(dropShadowBlur) {
            if (this._dropShadowBlur !== dropShadowBlur) {
                this._dropShadowBlur = dropShadowBlur;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowColor", {
        /** A fill style to be used on the dropshadow e.g 'red', '#00FF00'. */ get: function() {
            return this._dropShadowColor;
        },
        set: function(dropShadowColor) {
            var outputColor = $7276f35895ff141a$var$getColor(dropShadowColor);
            if (this._dropShadowColor !== outputColor) {
                this._dropShadowColor = outputColor;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowDistance", {
        /** Set a distance of the drop shadow. */ get: function() {
            return this._dropShadowDistance;
        },
        set: function(dropShadowDistance) {
            if (this._dropShadowDistance !== dropShadowDistance) {
                this._dropShadowDistance = dropShadowDistance;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fill", {
        /**
         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
         *
         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
         *
         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
         */ get: function() {
            return this._fill;
        },
        set: function(fill) {
            // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
            //       the setter converts to string. See this thread for more details:
            //       https://github.com/microsoft/TypeScript/issues/2521
            // TODO: Not sure if getColor works properly with CanvasGradient and/or CanvasPattern, can't pass in
            //       without casting here.
            var outputColor = $7276f35895ff141a$var$getColor(fill);
            if (this._fill !== outputColor) {
                this._fill = outputColor;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fillGradientType", {
        /**
         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
         *
         * @see PIXI.TEXT_GRADIENT
         */ get: function() {
            return this._fillGradientType;
        },
        set: function(fillGradientType) {
            if (this._fillGradientType !== fillGradientType) {
                this._fillGradientType = fillGradientType;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fillGradientStops", {
        /**
         * If fill is an array of colours to create a gradient, this array can set the stop points
         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
         */ get: function() {
            return this._fillGradientStops;
        },
        set: function(fillGradientStops) {
            if (!$7276f35895ff141a$var$areArraysEqual(this._fillGradientStops, fillGradientStops)) {
                this._fillGradientStops = fillGradientStops;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontFamily", {
        /** The font family. */ get: function() {
            return this._fontFamily;
        },
        set: function(fontFamily) {
            if (this.fontFamily !== fontFamily) {
                this._fontFamily = fontFamily;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontSize", {
        /**
         * The font size
         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
         */ get: function() {
            return this._fontSize;
        },
        set: function(fontSize) {
            if (this._fontSize !== fontSize) {
                this._fontSize = fontSize;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontStyle", {
        /**
         * The font style
         * ('normal', 'italic' or 'oblique')
         *
         * @member {string}
         */ get: function() {
            return this._fontStyle;
        },
        set: function(fontStyle) {
            if (this._fontStyle !== fontStyle) {
                this._fontStyle = fontStyle;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontVariant", {
        /**
         * The font variant
         * ('normal' or 'small-caps')
         *
         * @member {string}
         */ get: function() {
            return this._fontVariant;
        },
        set: function(fontVariant) {
            if (this._fontVariant !== fontVariant) {
                this._fontVariant = fontVariant;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontWeight", {
        /**
         * The font weight
         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
         *
         * @member {string}
         */ get: function() {
            return this._fontWeight;
        },
        set: function(fontWeight) {
            if (this._fontWeight !== fontWeight) {
                this._fontWeight = fontWeight;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "letterSpacing", {
        /** The amount of spacing between letters, default is 0. */ get: function() {
            return this._letterSpacing;
        },
        set: function(letterSpacing) {
            if (this._letterSpacing !== letterSpacing) {
                this._letterSpacing = letterSpacing;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "lineHeight", {
        /** The line height, a number that represents the vertical space that a letter uses. */ get: function() {
            return this._lineHeight;
        },
        set: function(lineHeight) {
            if (this._lineHeight !== lineHeight) {
                this._lineHeight = lineHeight;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "leading", {
        /** The space between lines. */ get: function() {
            return this._leading;
        },
        set: function(leading) {
            if (this._leading !== leading) {
                this._leading = leading;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "lineJoin", {
        /**
         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
         * Default is 'miter' (creates a sharp corner).
         *
         * @member {string}
         */ get: function() {
            return this._lineJoin;
        },
        set: function(lineJoin) {
            if (this._lineJoin !== lineJoin) {
                this._lineJoin = lineJoin;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "miterLimit", {
        /**
         * The miter limit to use when using the 'miter' lineJoin mode.
         *
         * This can reduce or increase the spikiness of rendered text.
         */ get: function() {
            return this._miterLimit;
        },
        set: function(miterLimit) {
            if (this._miterLimit !== miterLimit) {
                this._miterLimit = miterLimit;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "padding", {
        /**
         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
         * by adding padding to all sides of the text.
         */ get: function() {
            return this._padding;
        },
        set: function(padding) {
            if (this._padding !== padding) {
                this._padding = padding;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "stroke", {
        /**
         * A canvas fillstyle that will be used on the text stroke
         * e.g 'blue', '#FCFF00'
         */ get: function() {
            return this._stroke;
        },
        set: function(stroke) {
            // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
            //       the setter converts to string. See this thread for more details:
            //       https://github.com/microsoft/TypeScript/issues/2521
            var outputColor = $7276f35895ff141a$var$getColor(stroke);
            if (this._stroke !== outputColor) {
                this._stroke = outputColor;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "strokeThickness", {
        /**
         * A number that represents the thickness of the stroke.
         *
         * @default 0
         */ get: function() {
            return this._strokeThickness;
        },
        set: function(strokeThickness) {
            if (this._strokeThickness !== strokeThickness) {
                this._strokeThickness = strokeThickness;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "textBaseline", {
        /**
         * The baseline of the text that is rendered.
         *
         * @member {string}
         */ get: function() {
            return this._textBaseline;
        },
        set: function(textBaseline) {
            if (this._textBaseline !== textBaseline) {
                this._textBaseline = textBaseline;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "trim", {
        /** Trim transparent borders. */ get: function() {
            return this._trim;
        },
        set: function(trim) {
            if (this._trim !== trim) {
                this._trim = trim;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "whiteSpace", {
        /**
         * How newlines and spaces should be handled.
         * Default is 'pre' (preserve, preserve).
         *
         *  value       | New lines     |   Spaces
         *  ---         | ---           |   ---
         * 'normal'     | Collapse      |   Collapse
         * 'pre'        | Preserve      |   Preserve
         * 'pre-line'   | Preserve      |   Collapse
         *
         * @member {string}
         */ get: function() {
            return this._whiteSpace;
        },
        set: function(whiteSpace) {
            if (this._whiteSpace !== whiteSpace) {
                this._whiteSpace = whiteSpace;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "wordWrap", {
        /** Indicates if word wrap should be used. */ get: function() {
            return this._wordWrap;
        },
        set: function(wordWrap) {
            if (this._wordWrap !== wordWrap) {
                this._wordWrap = wordWrap;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "wordWrapWidth", {
        /** The width at which text will wrap, it needs wordWrap to be set to true. */ get: function() {
            return this._wordWrapWidth;
        },
        set: function(wordWrapWidth) {
            if (this._wordWrapWidth !== wordWrapWidth) {
                this._wordWrapWidth = wordWrapWidth;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Generates a font style string to use for `TextMetrics.measureFont()`.
     *
     * @return Font style string, for passing to `TextMetrics.measureFont()`
     */ TextStyle.prototype.toFontString = function() {
        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + "px" : this.fontSize;
        // Clean-up fontFamily property by quoting each font name
        // this will support font names with spaces
        var fontFamilies = this.fontFamily;
        if (!Array.isArray(this.fontFamily)) fontFamilies = this.fontFamily.split(',');
        for(var i = fontFamilies.length - 1; i >= 0; i--){
            // Trim any extra white-space
            var fontFamily = fontFamilies[i].trim();
            // Check if font already contains strings
            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && $7276f35895ff141a$var$genericFontFamilies.indexOf(fontFamily) < 0) fontFamily = "\"" + fontFamily + "\"";
            fontFamilies[i] = fontFamily;
        }
        return this.fontStyle + " " + this.fontVariant + " " + this.fontWeight + " " + fontSizeString + " " + fontFamilies.join(',');
    };
    return TextStyle;
}();
/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * @private
 * @param color
 * @return The color as a string.
 */ function $7276f35895ff141a$var$getSingleColor(color) {
    if (typeof color === 'number') return (0, $csytw.hex2string)(color);
    else if (typeof color === 'string') {
        if (color.indexOf('0x') === 0) color = color.replace('0x', '#');
    }
    return color;
}
function $7276f35895ff141a$var$getColor(color) {
    if (!Array.isArray(color)) return $7276f35895ff141a$var$getSingleColor(color);
    else {
        for(var i = 0; i < color.length; ++i)color[i] = $7276f35895ff141a$var$getSingleColor(color[i]);
        return color;
    }
}
/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * This version can also convert array of colors
 * @private
 * @param array1 - First array to compare
 * @param array2 - Second array to compare
 * @return Do the arrays contain the same values in the same order
 */ function $7276f35895ff141a$var$areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) return false;
    if (array1.length !== array2.length) return false;
    for(var i = 0; i < array1.length; ++i){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
/**
 * Utility function to ensure that object properties are copied by value, and not by reference
 * @private
 * @param target - Target object to copy properties into
 * @param source - Source object for the properties to copy
 * @param propertyObj - Object containing properties names we want to loop over
 */ function $7276f35895ff141a$var$deepCopyProperties(target, source, propertyObj) {
    for(var prop in propertyObj)if (Array.isArray(source[prop])) target[prop] = source[prop].slice();
    else target[prop] = source[prop];
}
/**
 * The TextMetrics object represents the measurement of a block of text with a specified style.
 *
 * ```js
 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
 * ```
 *
 * @memberof PIXI
 */ var $7276f35895ff141a$export$4c5a129a59e1ef34 = /** @class */ function() {
    /**
     * @param text - the text that was measured
     * @param style - the style that was measured
     * @param width - the measured width of the text
     * @param height - the measured height of the text
     * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
     * @param lineWidths - an array of the line widths for each line matched to `lines`
     * @param lineHeight - the measured line height for this style
     * @param maxLineWidth - the maximum line width for all measured lines
     * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
     */ function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }
    /**
     * Measures the supplied string of text and returns a Rectangle.
     *
     * @param text - The text to measure.
     * @param style - The text style to use for measuring
     * @param wordWrap - Override for if word-wrap should be applied to the text.
     * @param canvas - optional specification of the canvas to use for measuring.
     * @return Measured width and height of the text.
     */ TextMetrics.measureText = function(text, style, wordWrap, canvas) {
        if (canvas === void 0) canvas = TextMetrics._canvas;
        wordWrap = wordWrap === undefined || wordWrap === null ? style.wordWrap : wordWrap;
        var font = style.toFontString();
        var fontProperties = TextMetrics.measureFont(font);
        // fallback in case UA disallow canvas data extraction
        // (toDataURI, getImageData functions)
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
        }
        var context = canvas.getContext('2d');
        context.font = font;
        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
        var lines = outputText.split(/(?:\r\n|\r|\n)/);
        var lineWidths = new Array(lines.length);
        var maxLineWidth = 0;
        for(var i = 0; i < lines.length; i++){
            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        var width = maxLineWidth + style.strokeThickness;
        if (style.dropShadow) width += style.dropShadowDistance;
        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);
        if (style.dropShadow) height += style.dropShadowDistance;
        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    };
    /**
     * Applies newlines to a string to have it optimally fit into the horizontal
     * bounds set by the Text object's wordWrapWidth property.
     *
     * @param text - String to apply word wrapping to
     * @param style - the style to use when wrapping
     * @param canvas - optional specification of the canvas to use for measuring.
     * @return New string with new lines applied where required
     */ TextMetrics.wordWrap = function(text, style, canvas) {
        if (canvas === void 0) canvas = TextMetrics._canvas;
        var context = canvas.getContext('2d');
        var width = 0;
        var line = '';
        var lines = '';
        var cache = Object.create(null);
        var letterSpacing = style.letterSpacing, whiteSpace = style.whiteSpace;
        // How to handle whitespaces
        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);
        // whether or not spaces may be added to the beginning of lines
        var canPrependSpaces = !collapseSpaces;
        // There is letterSpacing after every char except the last one
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
        // so for convenience the above needs to be compared to width + 1 extra letterSpace
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
        // ________________________________________________
        // And then the final space is simply no appended to each line
        var wordWrapWidth = style.wordWrapWidth + letterSpacing;
        // break text into words, spaces and newline chars
        var tokens = TextMetrics.tokenize(text);
        for(var i = 0; i < tokens.length; i++){
            // get the word, space or newlineChar
            var token = tokens[i];
            // if word is a new line
            if (TextMetrics.isNewline(token)) {
                // keep the new line
                if (!collapseNewlines) {
                    lines += TextMetrics.addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = '';
                    width = 0;
                    continue;
                }
                // if we should collapse new lines
                // we simply convert it into a space
                token = ' ';
            }
            // if we should collapse repeated whitespaces
            if (collapseSpaces) {
                // check both this and the last tokens for spaces
                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            // get word width from cache if possible
            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);
            // word is longer than desired bounds
            if (tokenWidth > wordWrapWidth) {
                // if we are not already at the beginning of a line
                if (line !== '') {
                    // start newlines for overflow words
                    lines += TextMetrics.addLine(line);
                    line = '';
                    width = 0;
                }
                // break large word over multiple lines
                if (TextMetrics.canBreakWords(token, style.breakWords)) {
                    // break word into characters
                    var characters = TextMetrics.wordWrapSplit(token);
                    // loop the characters
                    for(var j = 0; j < characters.length; j++){
                        var char = characters[j];
                        var k = 1;
                        // we are not at the end of the token
                        while(characters[j + k]){
                            var nextChar = characters[j + k];
                            var lastChar = char[char.length - 1];
                            // should not split chars
                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) // combine chars & move forward one
                            char += nextChar;
                            else break;
                            k++;
                        }
                        j += char.length - 1;
                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);
                        if (characterWidth + width > wordWrapWidth) {
                            lines += TextMetrics.addLine(line);
                            canPrependSpaces = false;
                            line = '';
                            width = 0;
                        }
                        line += char;
                        width += characterWidth;
                    }
                } else {
                    // if there are words in this line already
                    // finish that line and start a new one
                    if (line.length > 0) {
                        lines += TextMetrics.addLine(line);
                        line = '';
                        width = 0;
                    }
                    var isLastToken = i === tokens.length - 1;
                    // give it its own line if it's not the end
                    lines += TextMetrics.addLine(token, !isLastToken);
                    canPrependSpaces = false;
                    line = '';
                    width = 0;
                }
            } else {
                // word won't fit because of existing words
                // start a new line
                if (tokenWidth + width > wordWrapWidth) {
                    // if its a space we don't want it
                    canPrependSpaces = false;
                    // add a new line
                    lines += TextMetrics.addLine(line);
                    // start a new line
                    line = '';
                    width = 0;
                }
                // don't add spaces to the beginning of lines
                if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                    // add the word to the current line
                    line += token;
                    // update width counter
                    width += tokenWidth;
                }
            }
        }
        lines += TextMetrics.addLine(line, false);
        return lines;
    };
    /**
     * Convienience function for logging each line added during the wordWrap method.
     *
     * @param line    - The line of text to add
     * @param newLine - Add new line character to end
     * @return A formatted line
     */ TextMetrics.addLine = function(line, newLine) {
        if (newLine === void 0) newLine = true;
        line = TextMetrics.trimRight(line);
        line = newLine ? line + "\n" : line;
        return line;
    };
    /**
     * Gets & sets the widths of calculated characters in a cache object
     *
     * @param key            - The key
     * @param letterSpacing  - The letter spacing
     * @param cache          - The cache
     * @param context        - The canvas context
     * @return The from cache.
     */ TextMetrics.getFromCache = function(key, letterSpacing, cache, context) {
        var width = cache[key];
        if (typeof width !== 'number') {
            var spacing = key.length * letterSpacing;
            width = context.measureText(key).width + spacing;
            cache[key] = width;
        }
        return width;
    };
    /**
     * Determines whether we should collapse breaking spaces.
     *
     * @param whiteSpace - The TextStyle property whiteSpace
     * @return Should collapse
     */ TextMetrics.collapseSpaces = function(whiteSpace) {
        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
    };
    /**
     * Determines whether we should collapse newLine chars.
     *
     * @param whiteSpace - The white space
     * @return  should collapse
     */ TextMetrics.collapseNewlines = function(whiteSpace) {
        return whiteSpace === 'normal';
    };
    /**
     * Trims breaking whitespaces from string.
     *
     * @param  text - The text
     * @return Trimmed string
     */ TextMetrics.trimRight = function(text) {
        if (typeof text !== 'string') return '';
        for(var i = text.length - 1; i >= 0; i--){
            var char = text[i];
            if (!TextMetrics.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    };
    /**
     * Determines if char is a newline.
     *
     * @param  char - The character
     * @return True if newline, False otherwise.
     */ TextMetrics.isNewline = function(char) {
        if (typeof char !== 'string') return false;
        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
    };
    /**
     * Determines if char is a breaking whitespace.
     *
     * It allows one to determine whether char should be a breaking whitespace
     * For example certain characters in CJK langs or numbers.
     * It must return a boolean.
     *
     * @param char     - The character
     * @param [nextChar] - The next character
     * @return True if whitespace, False otherwise.
     */ TextMetrics.isBreakingSpace = function(char, _nextChar) {
        if (typeof char !== 'string') return false;
        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
    };
    /**
     * Splits a string into words, breaking-spaces and newLine characters
     *
     * @param  text - The text
     * @return  A tokenized array
     */ TextMetrics.tokenize = function(text) {
        var tokens = [];
        var token = '';
        if (typeof text !== 'string') return tokens;
        for(var i = 0; i < text.length; i++){
            var char = text[i];
            var nextChar = text[i + 1];
            if (TextMetrics.isBreakingSpace(char, nextChar) || TextMetrics.isNewline(char)) {
                if (token !== '') {
                    tokens.push(token);
                    token = '';
                }
                tokens.push(char);
                continue;
            }
            token += char;
        }
        if (token !== '') tokens.push(token);
        return tokens;
    };
    /**
     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
     *
     * It allows one to customise which words should break
     * Examples are if the token is CJK or numbers.
     * It must return a boolean.
     *
     * @param  token       - The token
     * @param  breakWords - The style attr break words
     * @return Whether to break word or not
     */ TextMetrics.canBreakWords = function(_token, breakWords) {
        return breakWords;
    };
    /**
     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
     *
     * It allows one to determine whether a pair of characters
     * should be broken by newlines
     * For example certain characters in CJK langs or numbers.
     * It must return a boolean.
     *
     * @param  char        - The character
     * @param  nextChar    - The next character
     * @param  token       - The token/word the characters are from
     * @param  index       - The index in the token of the char
     * @param  breakWords - The style attr break words
     * @return whether to break word or not
     */ TextMetrics.canBreakChars = function(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    };
    /**
     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
     *
     * It is called when a token (usually a word) has to be split into separate pieces
     * in order to determine the point to break a word.
     * It must return an array of characters.
     *
     * @example
     * // Correctly splits emojis, eg "🤪🤪" will result in two element array, each with one emoji.
     * TextMetrics.wordWrapSplit = (token) => [...token];
     *
     * @param  token - The token to split
     * @return The characters of the token
     */ TextMetrics.wordWrapSplit = function(token) {
        return token.split('');
    };
    /**
     * Calculates the ascent, descent and fontSize of a given font-style
     *
     * @param font - String representing the style of the font
     * @return Font properties object
     */ TextMetrics.measureFont = function(font) {
        // as this method is used for preparing assets, don't recalculate things if we don't need to
        if (TextMetrics._fonts[font]) return TextMetrics._fonts[font];
        var properties = {
            ascent: 0,
            descent: 0,
            fontSize: 0
        };
        var canvas = TextMetrics._canvas;
        var context = TextMetrics._context;
        context.font = font;
        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
        var width = Math.ceil(context.measureText(metricsString).width);
        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
        var height = Math.ceil(TextMetrics.HEIGHT_MULTIPLIER * baseline);
        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;
        canvas.width = width;
        canvas.height = height;
        context.fillStyle = '#f00';
        context.fillRect(0, 0, width, height);
        context.font = font;
        context.textBaseline = 'alphabetic';
        context.fillStyle = '#000';
        context.fillText(metricsString, 0, baseline);
        var imagedata = context.getImageData(0, 0, width, height).data;
        var pixels = imagedata.length;
        var line = width * 4;
        var i = 0;
        var idx = 0;
        var stop = false;
        // ascent. scan from top to bottom until we find a non red pixel
        for(i = 0; i < baseline; ++i){
            for(var j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = true;
                break;
            }
            if (!stop) idx += line;
            else break;
        }
        properties.ascent = baseline - i;
        idx = pixels - line;
        stop = false;
        // descent. scan from bottom to top until we find a non red pixel
        for(i = height; i > baseline; --i){
            for(var j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = true;
                break;
            }
            if (!stop) idx -= line;
            else break;
        }
        properties.descent = i - baseline;
        properties.fontSize = properties.ascent + properties.descent;
        TextMetrics._fonts[font] = properties;
        return properties;
    };
    /**
     * Clear font metrics in metrics cache.
     *
     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
     */ TextMetrics.clearMetrics = function(font) {
        if (font === void 0) font = '';
        if (font) delete TextMetrics._fonts[font];
        else TextMetrics._fonts = {};
    };
    return TextMetrics;
}();
/**
 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
 *
 * @typedef {object} FontMetrics
 * @property {number} ascent - The ascent distance
 * @property {number} descent - The descent distance
 * @property {number} fontSize - Font size from ascent to descent
 * @memberof PIXI.TextMetrics
 * @private
 */ var $7276f35895ff141a$var$canvas = function() {
    try {
        // OffscreenCanvas2D measureText can be up to 40% faster.
        var c = new OffscreenCanvas(0, 0);
        var context = c.getContext('2d');
        if (context && context.measureText) return c;
        return document.createElement('canvas');
    } catch (ex) {
        return document.createElement('canvas');
    }
}();
$7276f35895ff141a$var$canvas.width = $7276f35895ff141a$var$canvas.height = 10;
/**
 * Cached canvas element for measuring text
 *
 * @memberof PIXI.TextMetrics
 * @type {HTMLCanvasElement}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._canvas = $7276f35895ff141a$var$canvas;
/**
 * Cache for context to use.
 *
 * @memberof PIXI.TextMetrics
 * @type {CanvasRenderingContext2D}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._context = $7276f35895ff141a$var$canvas.getContext('2d');
/**
 * Cache of {@see PIXI.TextMetrics.FontMetrics} objects.
 *
 * @memberof PIXI.TextMetrics
 * @type {Object}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._fonts = {};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name METRICS_STRING
 * @type {string}
 * @default |ÉqÅ
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.METRICS_STRING = "|\xc9q\xc5";
/**
 * Baseline symbol for calculate font metrics.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_SYMBOL
 * @type {string}
 * @default M
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.BASELINE_SYMBOL = 'M';
/**
 * Baseline multiplier for calculate font metrics.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_MULTIPLIER
 * @type {number}
 * @default 1.4
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.BASELINE_MULTIPLIER = 1.4;
/**
 * Height multiplier for setting height of canvas to calculate font metrics.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name HEIGHT_MULTIPLIER
 * @type {number}
 * @default 2.00
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.HEIGHT_MULTIPLIER = 2.0;
/**
 * Cache of new line chars.
 *
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._newlines = [
    0x000A,
    0x000D
];
/**
 * Cache of breaking spaces.
 *
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._breakingSpaces = [
    0x0009,
    0x0020,
    0x2000,
    0x2001,
    0x2002,
    0x2003,
    0x2004,
    0x2005,
    0x2006,
    0x2008,
    0x2009,
    0x200A,
    0x205F,
    0x3000
];
/**
 * A number, or a string containing a number.
 *
 * @memberof PIXI
 * @typedef {object} IFontMetrics
 * @property {number} ascent - Font ascent
 * @property {number} descent - Font descent
 * @property {number} fontSize - Font size
 */ var $7276f35895ff141a$var$defaultDestroyOptions = {
    texture: true,
    children: false,
    baseTexture: true
};
/**
 * A Text Object will create a line or multiple lines of text.
 *
 * The text is created using the [Canvas API](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API).
 *
 * The primary advantage of this class over BitmapText is that you have great control over the style of the text,
 * which you can change at runtime.
 *
 * The primary disadvantages is that each piece of text has it's own texture, which can use more memory.
 * When text changes, this texture has to be re-generated and re-uploaded to the GPU, taking up time.
 *
 * To split a line you can use '\n' in your text string, or, on the `style` object,
 * change its `wordWrap` property to true and and give the `wordWrapWidth` property a value.
 *
 * A Text can be created directly from a string and a style object,
 * which can be generated [here](https://pixijs.io/pixi-text-style).
 *
 * ```js
 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
 * ```
 *
 * @memberof PIXI
 */ var $7276f35895ff141a$export$5f1af8db9871e1d6 = /** @class */ function(_super) {
    $7276f35895ff141a$var$__extends(Text, _super);
    /**
     * @param text - The string that you would like the text to display
     * @param {object|PIXI.TextStyle} [style] - The style parameters
     * @param canvas - The canvas element for drawing text
     */ function Text(text, style, canvas) {
        var _this = this;
        var ownCanvas = false;
        if (!canvas) {
            canvas = document.createElement('canvas');
            ownCanvas = true;
        }
        canvas.width = 3;
        canvas.height = 3;
        var texture = (0, $klOfb.Texture).from(canvas);
        texture.orig = new (0, $6qzqq.Rectangle)();
        texture.trim = new (0, $6qzqq.Rectangle)();
        _this = _super.call(this, texture) || this;
        _this._ownCanvas = ownCanvas;
        _this.canvas = canvas;
        _this.context = _this.canvas.getContext('2d');
        _this._resolution = (0, $ezJmd.settings).RESOLUTION;
        _this._autoResolution = true;
        _this._text = null;
        _this._style = null;
        _this._styleListener = null;
        _this._font = '';
        _this.text = text;
        _this.style = style;
        _this.localStyleID = -1;
        return _this;
    }
    /**
     * Renders text to its canvas, and updates its texture.
     *
     * By default this is used internally to ensure the texture is correct before rendering,
     * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
     * and then shared across multiple Sprites.
     *
     * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
     */ Text.prototype.updateText = function(respectDirty) {
        var style = this._style;
        // check if style has changed..
        if (this.localStyleID !== style.styleID) {
            this.dirty = true;
            this.localStyleID = style.styleID;
        }
        if (!this.dirty && respectDirty) return;
        this._font = this._style.toFontString();
        var context = this.context;
        var measured = $7276f35895ff141a$export$4c5a129a59e1ef34.measureText(this._text || ' ', this._style, this._style.wordWrap, this.canvas);
        var width = measured.width;
        var height = measured.height;
        var lines = measured.lines;
        var lineHeight = measured.lineHeight;
        var lineWidths = measured.lineWidths;
        var maxLineWidth = measured.maxLineWidth;
        var fontProperties = measured.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, width) + style.padding * 2) * this._resolution);
        this.canvas.height = Math.ceil(Math.ceil(Math.max(1, height) + style.padding * 2) * this._resolution);
        context.scale(this._resolution, this._resolution);
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        context.font = this._font;
        context.lineWidth = style.strokeThickness;
        context.textBaseline = style.textBaseline;
        context.lineJoin = style.lineJoin;
        context.miterLimit = style.miterLimit;
        var linePositionX;
        var linePositionY;
        // require 2 passes if a shadow; the first to draw the drop shadow, the second to draw the text
        var passesCount = style.dropShadow ? 2 : 1;
        // For v4, we drew text at the colours of the drop shadow underneath the normal text. This gave the correct zIndex,
        // but features such as alpha and shadowblur did not look right at all, since we were using actual text as a shadow.
        //
        // For v5.0.0, we moved over to just use the canvas API for drop shadows, which made them look much nicer and more
        // visually please, but now because the stroke is drawn and then the fill, drop shadows would appear on both the fill
        // and the stroke; and fill drop shadows would appear over the top of the stroke.
        //
        // For v5.1.1, the new route is to revert to v4 style of drawing text first to get the drop shadows underneath normal
        // text, but instead drawing text in the correct location, we'll draw it off screen (-paddingY), and then adjust the
        // drop shadow so only that appears on screen (+paddingY). Now we'll have the correct draw order of the shadow
        // beneath the text, whilst also having the proper text shadow styling.
        for(var i = 0; i < passesCount; ++i){
            var isShadowPass = style.dropShadow && i === 0;
            // we only want the drop shadow, so put text way off-screen
            var dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + style.padding * 2) : 0;
            var dsOffsetShadow = dsOffsetText * this._resolution;
            if (isShadowPass) {
                // On Safari, text with gradient and drop shadows together do not position correctly
                // if the scale of the canvas is not 1: https://bugs.webkit.org/show_bug.cgi?id=197689
                // Therefore we'll set the styles to be a plain black whilst generating this drop shadow
                context.fillStyle = 'black';
                context.strokeStyle = 'black';
                var dropShadowColor = style.dropShadowColor;
                var rgb = (0, $csytw.hex2rgb)(typeof dropShadowColor === 'number' ? dropShadowColor : (0, $csytw.string2hex)(dropShadowColor));
                var dropShadowBlur = style.dropShadowBlur * this._resolution;
                var dropShadowDistance = style.dropShadowDistance * this._resolution;
                context.shadowColor = "rgba(" + rgb[0] * 255 + "," + rgb[1] * 255 + "," + rgb[2] * 255 + "," + style.dropShadowAlpha + ")";
                context.shadowBlur = dropShadowBlur;
                context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance;
                context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance + dsOffsetShadow;
            } else {
                // set canvas text styles
                context.fillStyle = this._generateFillStyle(style, lines, measured);
                // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
                //       the setter converts to string. See this thread for more details:
                //       https://github.com/microsoft/TypeScript/issues/2521
                context.strokeStyle = style.stroke;
                context.shadowColor = 'black';
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            var linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            if (!Text.nextLineHeightBehavior || lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
            // draw lines line by line
            for(var i_1 = 0; i_1 < lines.length; i_1++){
                linePositionX = style.strokeThickness / 2;
                linePositionY = style.strokeThickness / 2 + i_1 * lineHeight + fontProperties.ascent + linePositionYShift;
                if (style.align === 'right') linePositionX += maxLineWidth - lineWidths[i_1];
                else if (style.align === 'center') linePositionX += (maxLineWidth - lineWidths[i_1]) / 2;
                if (style.stroke && style.strokeThickness) this.drawLetterSpacing(lines[i_1], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, true);
                if (style.fill) this.drawLetterSpacing(lines[i_1], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
            }
        }
        this.updateTexture();
    };
    /**
     * Render the text with letter-spacing.
     *
     * @param text - The text to draw
     * @param x - Horizontal position to draw the text
     * @param y - Vertical position to draw the text
     * @param isStroke - Is this drawing for the outside stroke of the
     *  text? If not, it's for the inside fill
     */ Text.prototype.drawLetterSpacing = function(text, x, y, isStroke) {
        if (isStroke === void 0) isStroke = false;
        var style = this._style;
        // letterSpacing of 0 means normal
        var letterSpacing = style.letterSpacing;
        // Checking that we can use moddern canvas2D api
        // https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
        // note: this is unstable API, Chrome less 94 use a `textLetterSpacing`, newest use a letterSpacing
        // eslint-disable-next-line max-len
        var supportLetterSpacing = 'letterSpacing' in CanvasRenderingContext2D.prototype || 'textLetterSpacing' in CanvasRenderingContext2D.prototype;
        if (letterSpacing === 0 || supportLetterSpacing) {
            if (supportLetterSpacing) {
                this.context.letterSpacing = letterSpacing;
                this.context.textLetterSpacing = letterSpacing;
            }
            if (isStroke) this.context.strokeText(text, x, y);
            else this.context.fillText(text, x, y);
            return;
        }
        var currentPosition = x;
        // Using Array.from correctly splits characters whilst keeping emoji together.
        // This is not supported on IE as it requires ES6, so regular text splitting occurs.
        // This also doesn't account for emoji that are multiple emoji put together to make something else.
        // Handling all of this would require a big library itself.
        // https://medium.com/@giltayar/iterating-over-emoji-characters-the-es6-way-f06e4589516
        // https://github.com/orling/grapheme-splitter
        var stringArray = Array.from ? Array.from(text) : text.split('');
        var previousWidth = this.context.measureText(text).width;
        var currentWidth = 0;
        for(var i = 0; i < stringArray.length; ++i){
            var currentChar = stringArray[i];
            if (isStroke) this.context.strokeText(currentChar, currentPosition, y);
            else this.context.fillText(currentChar, currentPosition, y);
            var textStr = '';
            for(var j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = this.context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            previousWidth = currentWidth;
        }
    };
    /** Updates texture size based on canvas size. */ Text.prototype.updateTexture = function() {
        var canvas = this.canvas;
        if (this._style.trim) {
            var trimmed = (0, $csytw.trimCanvas)(canvas);
            if (trimmed.data) {
                canvas.width = trimmed.width;
                canvas.height = trimmed.height;
                this.context.putImageData(trimmed.data, 0, 0);
            }
        }
        var texture = this._texture;
        var style = this._style;
        var padding = style.trim ? 0 : style.padding;
        var baseTexture = texture.baseTexture;
        texture.trim.width = texture._frame.width = canvas.width / this._resolution;
        texture.trim.height = texture._frame.height = canvas.height / this._resolution;
        texture.trim.x = -padding;
        texture.trim.y = -padding;
        texture.orig.width = texture._frame.width - padding * 2;
        texture.orig.height = texture._frame.height - padding * 2;
        // call sprite onTextureUpdate to update scale if _width or _height were set
        this._onTextureUpdate();
        baseTexture.setRealSize(canvas.width, canvas.height, this._resolution);
        texture.updateUvs();
        // Recursively updates transform of all objects from the root to this one
        this._recursivePostUpdateTransform();
        this.dirty = false;
    };
    /**
     * Renders the object using the WebGL renderer
     *
     * @param renderer - The renderer
     */ Text.prototype._render = function(renderer) {
        if (this._autoResolution && this._resolution !== renderer.resolution) {
            this._resolution = renderer.resolution;
            this.dirty = true;
        }
        this.updateText(true);
        _super.prototype._render.call(this, renderer);
    };
    /**
     * Gets the local bounds of the text object.
     *
     * @param rect - The output rectangle.
     * @return The bounds.
     */ Text.prototype.getLocalBounds = function(rect) {
        this.updateText(true);
        return _super.prototype.getLocalBounds.call(this, rect);
    };
    /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */ Text.prototype._calculateBounds = function() {
        this.updateText(true);
        this.calculateVertices();
        // if we have already done this on THIS frame.
        this._bounds.addQuad(this.vertexData);
    };
    /**
     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
     *
     * @param style - The style.
     * @param lines - The lines of text.
     * @return The fill style
     */ Text.prototype._generateFillStyle = function(style, lines, metrics) {
        // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
        //       the setter converts to string. See this thread for more details:
        //       https://github.com/microsoft/TypeScript/issues/2521
        var fillStyle = style.fill;
        if (!Array.isArray(fillStyle)) return fillStyle;
        else if (fillStyle.length === 1) return fillStyle[0];
        // the gradient will be evenly spaced out according to how large the array is.
        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
        var gradient;
        // a dropshadow will enlarge the canvas and result in the gradient being
        // generated with the incorrect dimensions
        var dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0;
        // should also take padding into account, padding can offset the gradient
        var padding = style.padding || 0;
        var width = this.canvas.width / this._resolution - dropShadowCorrection - padding * 2;
        var height = this.canvas.height / this._resolution - dropShadowCorrection - padding * 2;
        // make a copy of the style settings, so we can manipulate them later
        var fill = fillStyle.slice();
        var fillGradientStops = style.fillGradientStops.slice();
        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
        if (!fillGradientStops.length) {
            var lengthPlus1 = fill.length + 1;
            for(var i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
        }
        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
        fill.unshift(fillStyle[0]);
        fillGradientStops.unshift(0);
        fill.push(fillStyle[fillStyle.length - 1]);
        fillGradientStops.push(1);
        if (style.fillGradientType === $7276f35895ff141a$export$131daa784848984.LINEAR_VERTICAL) {
            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
            // Actual height of the text itself, not counting spacing for lineHeight/leading/dropShadow etc
            var textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
            for(var i = 0; i < lines.length; i++){
                var lastLineBottom = metrics.lineHeight * (i - 1) + textHeight;
                var thisLineTop = metrics.lineHeight * i;
                var thisLineGradientStart = thisLineTop;
                // Handle case where last & this line overlap
                if (i > 0 && lastLineBottom > thisLineTop) thisLineGradientStart = (thisLineTop + lastLineBottom) / 2;
                var thisLineBottom = thisLineTop + textHeight;
                var nextLineTop = metrics.lineHeight * (i + 1);
                var thisLineGradientEnd = thisLineBottom;
                // Handle case where this & next line overlap
                if (i + 1 < lines.length && nextLineTop < thisLineBottom) thisLineGradientEnd = (thisLineBottom + nextLineTop) / 2;
                // textHeight, but as a 0-1 size in global gradient stop space
                var gradStopLineHeight = (thisLineGradientEnd - thisLineGradientStart) / height;
                for(var j = 0; j < fill.length; j++){
                    // 0-1 stop point for the current line, multiplied to global space afterwards
                    var lineStop = 0;
                    if (typeof fillGradientStops[j] === 'number') lineStop = fillGradientStops[j];
                    else lineStop = j / fill.length;
                    var globalStop = Math.min(1, Math.max(0, thisLineGradientStart / height + lineStop * gradStopLineHeight));
                    // There's potential for floating point precision issues at the seams between gradient repeats.
                    globalStop = Number(globalStop.toFixed(5));
                    gradient.addColorStop(globalStop, fill[j]);
                }
            }
        } else {
            // start the gradient at the center left of the canvas, and end at the center right of the canvas
            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
            // can just evenly space out the gradients in this case, as multiple lines makes no difference
            // to an even left to right gradient
            var totalIterations = fill.length + 1;
            var currentIteration = 1;
            for(var i = 0; i < fill.length; i++){
                var stop = void 0;
                if (typeof fillGradientStops[i] === 'number') stop = fillGradientStops[i];
                else stop = currentIteration / totalIterations;
                gradient.addColorStop(stop, fill[i]);
                currentIteration++;
            }
        }
        return gradient;
    };
    /**
     * Destroys this text object.
     *
     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
     * the majority of the time the texture will not be shared with any other Sprites.
     *
     * @param options - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
     */ Text.prototype.destroy = function(options) {
        if (typeof options === 'boolean') options = {
            children: options
        };
        options = Object.assign({}, $7276f35895ff141a$var$defaultDestroyOptions, options);
        _super.prototype.destroy.call(this, options);
        // set canvas width and height to 0 to workaround memory leak in Safari < 13
        // https://stackoverflow.com/questions/52532614/total-canvas-memory-use-exceeds-the-maximum-limit-safari-12
        if (this._ownCanvas) this.canvas.height = this.canvas.width = 0;
        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
        this.context = null;
        this.canvas = null;
        this._style = null;
    };
    Object.defineProperty(Text.prototype, "width", {
        /** The width of the Text, setting this will actually modify the scale to achieve the value set. */ get: function() {
            this.updateText(true);
            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function(value) {
            this.updateText(true);
            var s = (0, $csytw.sign)(this.scale.x) || 1;
            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "height", {
        /** The height of the Text, setting this will actually modify the scale to achieve the value set. */ get: function() {
            this.updateText(true);
            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function(value) {
            this.updateText(true);
            var s = (0, $csytw.sign)(this.scale.y) || 1;
            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "style", {
        /**
         * Set the style of the text.
         *
         * Set up an event listener to listen for changes on the style object and mark the text as dirty.
         */ get: function() {
            // TODO: Can't have different types for getter and setter. The getter shouldn't have the ITextStyle
            //       since the setter creates the TextStyle. See this thread for more details:
            //       https://github.com/microsoft/TypeScript/issues/2521
            return this._style;
        },
        set: function(style) {
            style = style || {};
            if (style instanceof $7276f35895ff141a$export$1df879243bf2e42d) this._style = style;
            else this._style = new $7276f35895ff141a$export$1df879243bf2e42d(style);
            this.localStyleID = -1;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "text", {
        /** Set the copy for the text object. To split a line you can use '\n'. */ get: function() {
            return this._text;
        },
        set: function(text) {
            text = String(text === null || text === undefined ? '' : text);
            if (this._text === text) return;
            this._text = text;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "resolution", {
        /**
         * The resolution / device pixel ratio of the canvas.
         *
         * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
         *
         * @default 1
         */ get: function() {
            return this._resolution;
        },
        set: function(value) {
            this._autoResolution = false;
            if (this._resolution === value) return;
            this._resolution = value;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * New behavior for `lineHeight` that's meant to mimic HTML text. A value of `true` will
     * make sure the first baseline is offset by the `lineHeight` value if it is greater than `fontSize`.
     * A value of `false` will use the legacy behavior and not change the baseline of the first line.
     * In the next major release, we'll enable this by default.
     */ Text.nextLineHeightBehavior = false;
    return Text;
}((0, $7Bs2Z.Sprite));

});
parcelRegister("7Bs2Z", function(module, exports) {

$parcel$export(module.exports, "Sprite", function () { return $5891beb64fa1f02f$export$3075603db8e6204c; });
/*!
 * @pixi/sprite - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/sprite is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $P8XPi = parcelRequire("P8XPi");

var $klOfb = parcelRequire("klOfb");

var $8t5Gy = parcelRequire("8t5Gy");

var $6qzqq = parcelRequire("6qzqq");

var $ezJmd = parcelRequire("ezJmd");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $5891beb64fa1f02f$var$extendStatics = function(d, b) {
    $5891beb64fa1f02f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5891beb64fa1f02f$var$extendStatics(d, b);
};
function $5891beb64fa1f02f$var$__extends(d, b) {
    $5891beb64fa1f02f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5891beb64fa1f02f$var$tempPoint = new (0, $6qzqq.Point)();
var $5891beb64fa1f02f$var$indices = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3
]);
/**
 * The Sprite object is the base for all textured objects that are rendered to the screen
*
 * A sprite can be created directly from an image like this:
 *
 * ```js
 * let sprite = PIXI.Sprite.from('assets/image.png');
 * ```
 *
 * The more efficient way to create sprites is using a {@link PIXI.Spritesheet},
 * as swapping base textures when rendering to the screen is inefficient.
 *
 * ```js
 * PIXI.Loader.shared.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.Loader.shared.resources["assets/spritesheet.json"].spritesheet;
 *   let sprite = new PIXI.Sprite(sheet.textures["image.png"]);
 *   ...
 * }
 * ```
 *
 * @memberof PIXI
 */ var $5891beb64fa1f02f$export$3075603db8e6204c = /** @class */ function(_super) {
    $5891beb64fa1f02f$var$__extends(Sprite, _super);
    /** @param texture - The texture for this sprite. */ function Sprite(texture) {
        var _this = _super.call(this) || this;
        _this._anchor = new (0, $6qzqq.ObservablePoint)(_this._onAnchorUpdate, _this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0);
        _this._texture = null;
        _this._width = 0;
        _this._height = 0;
        _this._tint = null;
        _this._tintRGB = null;
        _this.tint = 0xFFFFFF;
        _this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        _this._cachedTint = 0xFFFFFF;
        _this.uvs = null;
        // call texture setter
        _this.texture = texture || (0, $klOfb.Texture).EMPTY;
        _this.vertexData = new Float32Array(8);
        _this.vertexTrimmedData = null;
        _this._transformID = -1;
        _this._textureID = -1;
        _this._transformTrimmedID = -1;
        _this._textureTrimmedID = -1;
        // Batchable stuff..
        // TODO could make this a mixin?
        _this.indices = $5891beb64fa1f02f$var$indices;
        _this.pluginName = 'batch';
        /**
         * Used to fast check if a sprite is.. a sprite!
         * @member {boolean}
         */ _this.isSprite = true;
        _this._roundPixels = (0, $ezJmd.settings).ROUND_PIXELS;
        return _this;
    }
    /** When the texture is updated, this event will fire to update the scale and frame. */ Sprite.prototype._onTextureUpdate = function() {
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this._cachedTint = 0xFFFFFF;
        // so if _width is 0 then width was not set..
        if (this._width) this.scale.x = (0, $csytw.sign)(this.scale.x) * this._width / this._texture.orig.width;
        if (this._height) this.scale.y = (0, $csytw.sign)(this.scale.y) * this._height / this._texture.orig.height;
    };
    /** Called when the anchor position updates. */ Sprite.prototype._onAnchorUpdate = function() {
        this._transformID = -1;
        this._transformTrimmedID = -1;
    };
    /** Calculates worldTransform * vertices, store it in vertexData. */ Sprite.prototype.calculateVertices = function() {
        var texture = this._texture;
        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) return;
        // update texture UV here, because base texture can be changed without calling `_onTextureUpdate`
        if (this._textureID !== texture._updateID) this.uvs = this._texture._uvs.uvsFloat32;
        this._transformID = this.transform._worldID;
        this._textureID = texture._updateID;
        // set the vertex data
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var vertexData = this.vertexData;
        var trim = texture.trim;
        var orig = texture.orig;
        var anchor = this._anchor;
        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;
        if (trim) {
            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
            // space before transforming the sprite coords.
            w1 = trim.x - anchor._x * orig.width;
            w0 = w1 + trim.width;
            h1 = trim.y - anchor._y * orig.height;
            h0 = h1 + trim.height;
        } else {
            w1 = -anchor._x * orig.width;
            w0 = w1 + orig.width;
            h1 = -anchor._y * orig.height;
            h0 = h1 + orig.height;
        }
        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;
        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;
        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;
        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
        if (this._roundPixels) {
            var resolution = (0, $ezJmd.settings).RESOLUTION;
            for(var i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round((vertexData[i] * resolution | 0) / resolution);
        }
    };
    /**
     * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
     *
     * This is used to ensure that the true width and height of a trimmed texture is respected.
     */ Sprite.prototype.calculateTrimmedVertices = function() {
        if (!this.vertexTrimmedData) this.vertexTrimmedData = new Float32Array(8);
        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) return;
        this._transformTrimmedID = this.transform._worldID;
        this._textureTrimmedID = this._texture._updateID;
        // lets do some special trim code!
        var texture = this._texture;
        var vertexData = this.vertexTrimmedData;
        var orig = texture.orig;
        var anchor = this._anchor;
        // lets calculate the new untrimmed bounds..
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var w1 = -anchor._x * orig.width;
        var w0 = w1 + orig.width;
        var h1 = -anchor._y * orig.height;
        var h0 = h1 + orig.height;
        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;
        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;
        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;
        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    };
    /**
     *
     * Renders the object using the WebGL renderer
     *
     * @param renderer - The webgl renderer to use.
     */ Sprite.prototype._render = function(renderer) {
        this.calculateVertices();
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };
    /** Updates the bounds of the sprite. */ Sprite.prototype._calculateBounds = function() {
        var trim = this._texture.trim;
        var orig = this._texture.orig;
        // First lets check to see if the current texture has a trim..
        if (!trim || trim.width === orig.width && trim.height === orig.height) {
            // no trim! lets use the usual calculations..
            this.calculateVertices();
            this._bounds.addQuad(this.vertexData);
        } else {
            // lets calculate a special trimmed bounds...
            this.calculateTrimmedVertices();
            this._bounds.addQuad(this.vertexTrimmedData);
        }
    };
    /**
     * Gets the local bounds of the sprite object.
     *
     * @param rect - Optional output rectangle.
     * @return The bounds.
     */ Sprite.prototype.getLocalBounds = function(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            if (!this._localBounds) this._localBounds = new (0, $8t5Gy.Bounds)();
            this._localBounds.minX = this._texture.orig.width * -this._anchor._x;
            this._localBounds.minY = this._texture.orig.height * -this._anchor._y;
            this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
            this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y);
            if (!rect) {
                if (!this._localBoundsRect) this._localBoundsRect = new (0, $6qzqq.Rectangle)();
                rect = this._localBoundsRect;
            }
            return this._localBounds.getRectangle(rect);
        }
        return _super.prototype.getLocalBounds.call(this, rect);
    };
    /**
     * Tests if a point is inside this sprite
     *
     * @param point - the point to test
     * @return The result of the test
     */ Sprite.prototype.containsPoint = function(point) {
        this.worldTransform.applyInverse(point, $5891beb64fa1f02f$var$tempPoint);
        var width = this._texture.orig.width;
        var height = this._texture.orig.height;
        var x1 = -width * this.anchor.x;
        var y1 = 0;
        if ($5891beb64fa1f02f$var$tempPoint.x >= x1 && $5891beb64fa1f02f$var$tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;
            if ($5891beb64fa1f02f$var$tempPoint.y >= y1 && $5891beb64fa1f02f$var$tempPoint.y < y1 + height) return true;
        }
        return false;
    };
    /**
     * Destroys this sprite and optionally its texture and children.
     *
     * @param options - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */ Sprite.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        this._texture.off('update', this._onTextureUpdate, this);
        this._anchor = null;
        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;
        if (destroyTexture) {
            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;
            this._texture.destroy(!!destroyBaseTexture);
        }
        this._texture = null;
    };
    // some helper functions..
    /**
     * Helper function that creates a new sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @return The newly created sprite
     */ Sprite.from = function(source, options) {
        var texture = source instanceof (0, $klOfb.Texture) ? source : (0, $klOfb.Texture).from(source, options);
        return new Sprite(texture);
    };
    Object.defineProperty(Sprite.prototype, "roundPixels", {
        get: function() {
            return this._roundPixels;
        },
        /**
         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
         *
         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
         * The main disadvantage is movement of objects may appear less smooth.
         *
         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
         *
         * @default false
         */ set: function(value) {
            if (this._roundPixels !== value) this._transformID = -1;
            this._roundPixels = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "width", {
        /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function(value) {
            var s = (0, $csytw.sign)(this.scale.x) || 1;
            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "height", {
        /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function(value) {
            var s = (0, $csytw.sign)(this.scale.y) || 1;
            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "anchor", {
        /**
         * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
         * and passed to the constructor.
         *
         * The default is `(0,0)`, this means the sprite's origin is the top left.
         *
         * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
         *
         * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
         *
         * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
         *
         * @example
         * const sprite = new PIXI.Sprite(texture);
         * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
         */ get: function() {
            return this._anchor;
        },
        set: function(value) {
            this._anchor.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "tint", {
        /**
         * The tint applied to the sprite. This is a hex value.
         *
         * A value of 0xFFFFFF will remove any tint effect.
         *
         * @default 0xFFFFFF
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            this._tint = value;
            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "texture", {
        /** The texture that the sprite is using. */ get: function() {
            return this._texture;
        },
        set: function(value) {
            if (this._texture === value) return;
            if (this._texture) this._texture.off('update', this._onTextureUpdate, this);
            this._texture = value || (0, $klOfb.Texture).EMPTY;
            this._cachedTint = 0xFFFFFF;
            this._textureID = -1;
            this._textureTrimmedID = -1;
            if (value) {
                // wait for the texture to load
                if (value.baseTexture.valid) this._onTextureUpdate();
                else value.once('update', this._onTextureUpdate, this);
            }
        },
        enumerable: false,
        configurable: true
    });
    return Sprite;
}((0, $8t5Gy.Container));

});



parcelRegister("kfhEp", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", function () { return $ebd2e674a11bdcf0$export$674d2eb4debbef0c; });
$parcel$export(module.exports, "SpritesheetLoader", function () { return $ebd2e674a11bdcf0$export$cef90d24aa5a3136; });
/*!
 * @pixi/spritesheet - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/spritesheet is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6qzqq = parcelRequire("6qzqq");

var $klOfb = parcelRequire("klOfb");

var $csytw = parcelRequire("csytw");

var $kXE1p = parcelRequire("kXE1p");
/**
 * Utility class for maintaining reference to a collection
 * of Textures on a single Spritesheet.
 *
 * To access a sprite sheet from your code pass its JSON data file to Pixi's loader:
 *
 * ```js
 * PIXI.Loader.shared.add("images/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.Loader.shared.resources["images/spritesheet.json"].spritesheet;
 *   ...
 * }
 * ```
 * With the `sheet.textures` you can create Sprite objects,`sheet.animations` can be used to create an AnimatedSprite.
 *
 * Sprite sheets can be packed using tools like {@link https://codeandweb.com/texturepacker|TexturePacker},
 * {@link https://renderhjs.net/shoebox/|Shoebox} or {@link https://github.com/krzysztof-o/spritesheet.js|Spritesheet.js}.
 * Default anchor points (see {@link PIXI.Texture#defaultAnchor}) and grouping of animation sprites are currently only
 * supported by TexturePacker.
 *
 * @memberof PIXI
 */ var $ebd2e674a11bdcf0$export$674d2eb4debbef0c = /** @class */ function() {
    /**
     * @param baseTexture - Reference to the source BaseTexture object.
     * @param {Object} data - Spritesheet image data.
     * @param resolutionFilename - The filename to consider when determining
     *        the resolution of the spritesheet. If not provided, the imageUrl will
     *        be used on the BaseTexture.
     */ function Spritesheet(texture, data, resolutionFilename) {
        if (resolutionFilename === void 0) resolutionFilename = null;
        this._texture = texture instanceof (0, $klOfb.Texture) ? texture : null;
        this.baseTexture = texture instanceof (0, $klOfb.BaseTexture) ? texture : this._texture.baseTexture;
        this.textures = {};
        this.animations = {};
        this.data = data;
        var resource = this.baseTexture.resource;
        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null));
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
     * Generate the resolution from the filename or fallback
     * to the meta.scale field of the JSON data.
     *
     * @param resolutionFilename - The filename to use for resolving
     *        the default resolution.
     * @return Resolution to use for spritesheet.
     */ Spritesheet.prototype._updateResolution = function(resolutionFilename) {
        if (resolutionFilename === void 0) resolutionFilename = null;
        var scale = this.data.meta.scale;
        // Use a defaultValue of `null` to check if a url-based resolution is set
        var resolution = (0, $csytw.getResolutionOfUrl)(resolutionFilename, null);
        // No resolution found via URL
        if (resolution === null) // Use the scale value or default to 1
        resolution = scale !== undefined ? parseFloat(scale) : 1;
        // For non-1 resolutions, update baseTexture
        if (resolution !== 1) this.baseTexture.setResolution(resolution);
        return resolution;
    };
    /**
     * Parser spritesheet from loaded data. This is done asynchronously
     * to prevent creating too many Texture within a single process.
     *
     * @param {Function} callback - Callback when complete returns
     *        a map of the Textures for this spritesheet.
     */ Spritesheet.prototype.parse = function(callback) {
        this._batchIndex = 0;
        this._callback = callback;
        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
            this._processFrames(0);
            this._processAnimations();
            this._parseComplete();
        } else this._nextBatch();
    };
    /**
     * Process a batch of frames
     *
     * @param initialFrameIndex - The index of frame to start.
     */ Spritesheet.prototype._processFrames = function(initialFrameIndex) {
        var frameIndex = initialFrameIndex;
        var maxFrames = Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            var i = this._frameKeys[frameIndex];
            var data = this._frames[i];
            var rect = data.frame;
            if (rect) {
                var frame = null;
                var trim = null;
                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                var orig = new (0, $6qzqq.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $6qzqq.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $6qzqq.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                //  Check to see if the sprite is trimmed
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $6qzqq.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $klOfb.Texture)(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor);
                // lets also add the frame to pixi's global cache for 'from' and 'fromLoader' functions
                (0, $klOfb.Texture).addToCache(this.textures[i], i);
            }
            frameIndex++;
        }
    };
    /** Parse animations config. */ Spritesheet.prototype._processAnimations = function() {
        var animations = this.data.animations || {};
        for(var animName in animations){
            this.animations[animName] = [];
            for(var i = 0; i < animations[animName].length; i++){
                var frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    };
    /** The parse has completed. */ Spritesheet.prototype._parseComplete = function() {
        var callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    };
    /** Begin the next batch of textures. */ Spritesheet.prototype._nextBatch = function() {
        var _this = this;
        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(function() {
            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) _this._nextBatch();
            else {
                _this._processAnimations();
                _this._parseComplete();
            }
        }, 0);
    };
    /**
     * Destroy Spritesheet and don't use after this.
     *
     * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
     */ Spritesheet.prototype.destroy = function(destroyBase) {
        var _a;
        if (destroyBase === void 0) destroyBase = false;
        for(var i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            (_a = this._texture) === null || _a === void 0 || _a.destroy();
            this.baseTexture.destroy();
        }
        this._texture = null;
        this.baseTexture = null;
    };
    /** The maximum number of Textures to build per process. */ Spritesheet.BATCH_SIZE = 1000;
    return Spritesheet;
}();
/**
 * Reference to Spritesheet object created.
 * @member {PIXI.Spritesheet} spritesheet
 * @memberof PIXI.LoaderResource
 * @instance
 */ /**
 * Dictionary of textures from Spritesheet.
 * @member {object<string, PIXI.Texture>} textures
 * @memberof PIXI.LoaderResource
 * @instance
 */ /**
 * {@link PIXI.Loader} middleware for loading texture atlases that have been created with
 * TexturePacker or similar JSON-based spritesheet.
 *
 * This middleware automatically generates Texture resources.
 *
 * If you're using Webpack or other bundlers and plan on bundling the atlas' JSON,
 * use the {@link PIXI.Spritesheet} class to directly parse the JSON.
 *
 * The Loader's image Resource name is automatically appended with `"_image"`.
 * If a Resource with this name is already loaded, the Loader will skip parsing the
 * Spritesheet. The code below will generate an internal Loader Resource called `"myatlas_image"`.
 *
 * @example
 * loader.add('myatlas', 'path/to/myatlas.json');
 * loader.load(() => {
 *   loader.resources.myatlas; // atlas JSON resource
 *   loader.resources.myatlas_image; // atlas Image resource
 * });
 *
 * @memberof PIXI
 */ var $ebd2e674a11bdcf0$export$cef90d24aa5a3136 = /** @class */ function() {
    function SpritesheetLoader() {}
    /**
     * Called after a resource is loaded.
     *
     * @see PIXI.Loader.loaderMiddleware
     * @param resource
     * @param next
     */ SpritesheetLoader.use = function(resource, next) {
        var _a, _b;
        // because this is middleware, it execute in loader context. `this` = loader
        var loader = this;
        var imageResourceName = resource.name + "_image";
        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
        if (!resource.data || resource.type !== (0, $kXE1p.LoaderResource).TYPE.JSON || !resource.data.frames || loader.resources[imageResourceName]) {
            next();
            return;
        }
        // Check and add the multi atlas
        // Heavily influenced and based on https://github.com/rocket-ua/pixi-tps-loader/blob/master/src/ResourceLoader.js
        // eslint-disable-next-line camelcase
        var multiPacks = (_b = (_a = resource.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.related_multi_packs;
        if (Array.isArray(multiPacks)) {
            var _loop_1 = function(item) {
                if (typeof item !== 'string') return "continue";
                var itemName = item.replace('.json', '');
                var itemUrl = (0, $csytw.url).resolve(resource.url.replace(loader.baseUrl, ''), item);
                // Check if the file wasn't already added as multipacks are redundant
                if (loader.resources[itemName] || Object.values(loader.resources).some(function(r) {
                    return (0, $csytw.url).format((0, $csytw.url).parse(r.url)) === itemUrl;
                })) return "continue";
                var options = {
                    crossOrigin: resource.crossOrigin,
                    loadType: (0, $kXE1p.LoaderResource).LOAD_TYPE.XHR,
                    xhrType: (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.JSON,
                    parentResource: resource,
                    metadata: resource.metadata
                };
                loader.add(itemName, itemUrl, options);
            };
            for(var _i = 0, multiPacks_1 = multiPacks; _i < multiPacks_1.length; _i++){
                var item = multiPacks_1[_i];
                _loop_1(item);
            }
        }
        var loadOptions = {
            crossOrigin: resource.crossOrigin,
            metadata: resource.metadata.imageMetadata,
            parentResource: resource
        };
        var resourcePath = SpritesheetLoader.getResourcePath(resource, loader.baseUrl);
        // load the image for this sheet
        loader.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
            if (res.error) {
                next(res.error);
                return;
            }
            var spritesheet = new $ebd2e674a11bdcf0$export$674d2eb4debbef0c(res.texture, resource.data, resource.url);
            spritesheet.parse(function() {
                resource.spritesheet = spritesheet;
                resource.textures = spritesheet.textures;
                next();
            });
        });
    };
    /**
     * Get the spritesheets root path
     *
     * @param resource - Resource to check path
     * @param baseUrl - Base root url
     */ SpritesheetLoader.getResourcePath = function(resource, baseUrl) {
        // Prepend url path unless the resource image is a data url
        if (resource.isDataUrl) return resource.data.meta.image;
        return (0, $csytw.url).resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
    };
    return SpritesheetLoader;
}();

});

parcelRegister("eQ8XE", function(module, exports) {

$parcel$export(module.exports, "TilingSprite", function () { return $acdcdf7c54003bfb$export$db8370cd1ebcc819; });
$parcel$export(module.exports, "TilingSpriteRenderer", function () { return $acdcdf7c54003bfb$export$8b7f6ad84090f14c; });
/*!
 * @pixi/sprite-tiling - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/sprite-tiling is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $P8XPi = parcelRequire("P8XPi");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $acdcdf7c54003bfb$var$extendStatics = function(d, b) {
    $acdcdf7c54003bfb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $acdcdf7c54003bfb$var$extendStatics(d, b);
};
function $acdcdf7c54003bfb$var$__extends(d, b) {
    $acdcdf7c54003bfb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $acdcdf7c54003bfb$var$tempPoint = new (0, $6qzqq.Point)();
/**
 * A tiling sprite is a fast way of rendering a tiling image.
 *
 * @memberof PIXI
 */ var $acdcdf7c54003bfb$export$db8370cd1ebcc819 = /** @class */ function(_super) {
    $acdcdf7c54003bfb$var$__extends(TilingSprite, _super);
    /**
     * @param texture - The texture of the tiling sprite.
     * @param width - The width of the tiling sprite.
     * @param height - The height of the tiling sprite.
     */ function TilingSprite(texture, width, height) {
        if (width === void 0) width = 100;
        if (height === void 0) height = 100;
        var _this = _super.call(this, texture) || this;
        _this.tileTransform = new (0, $6qzqq.Transform)();
        // The width of the tiling sprite
        _this._width = width;
        // The height of the tiling sprite
        _this._height = height;
        _this.uvMatrix = _this.texture.uvMatrix || new (0, $klOfb.TextureMatrix)(texture);
        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_render' method.
         *
         * @default 'tilingSprite'
         */ _this.pluginName = 'tilingSprite';
        _this.uvRespectAnchor = false;
        return _this;
    }
    Object.defineProperty(TilingSprite.prototype, "clampMargin", {
        /**
         * Changes frame clamping in corresponding textureTransform, shortcut
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */ get: function() {
            return this.uvMatrix.clampMargin;
        },
        set: function(value) {
            this.uvMatrix.clampMargin = value;
            this.uvMatrix.update(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TilingSprite.prototype, "tileScale", {
        /** The scaling of the image that is being tiled. */ get: function() {
            return this.tileTransform.scale;
        },
        set: function(value) {
            this.tileTransform.scale.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TilingSprite.prototype, "tilePosition", {
        /** The offset of the image that is being tiled. */ get: function() {
            return this.tileTransform.position;
        },
        set: function(value) {
            this.tileTransform.position.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @protected
     */ TilingSprite.prototype._onTextureUpdate = function() {
        if (this.uvMatrix) this.uvMatrix.texture = this._texture;
        this._cachedTint = 0xFFFFFF;
    };
    /**
     * Renders the object using the WebGL renderer
     *
     * @param renderer - The renderer
     */ TilingSprite.prototype._render = function(renderer) {
        // tweak our texture temporarily..
        var texture = this._texture;
        if (!texture || !texture.valid) return;
        this.tileTransform.updateLocalTransform();
        this.uvMatrix.update();
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };
    /** Updates the bounds of the tiling sprite. */ TilingSprite.prototype._calculateBounds = function() {
        var minX = this._width * -this._anchor._x;
        var minY = this._height * -this._anchor._y;
        var maxX = this._width * (1 - this._anchor._x);
        var maxY = this._height * (1 - this._anchor._y);
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    };
    /**
     * Gets the local bounds of the sprite object.
     *
     * @param rect - Optional output rectangle.
     * @return The bounds.
     */ TilingSprite.prototype.getLocalBounds = function(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            this._bounds.minX = this._width * -this._anchor._x;
            this._bounds.minY = this._height * -this._anchor._y;
            this._bounds.maxX = this._width * (1 - this._anchor._x);
            this._bounds.maxY = this._height * (1 - this._anchor._y);
            if (!rect) {
                if (!this._localBoundsRect) this._localBoundsRect = new (0, $6qzqq.Rectangle)();
                rect = this._localBoundsRect;
            }
            return this._bounds.getRectangle(rect);
        }
        return _super.prototype.getLocalBounds.call(this, rect);
    };
    /**
     * Checks if a point is inside this tiling sprite.
     *
     * @param point - The point to check.
     * @return Whether or not the sprite contains the point.
     */ TilingSprite.prototype.containsPoint = function(point) {
        this.worldTransform.applyInverse(point, $acdcdf7c54003bfb$var$tempPoint);
        var width = this._width;
        var height = this._height;
        var x1 = -width * this.anchor._x;
        if ($acdcdf7c54003bfb$var$tempPoint.x >= x1 && $acdcdf7c54003bfb$var$tempPoint.x < x1 + width) {
            var y1 = -height * this.anchor._y;
            if ($acdcdf7c54003bfb$var$tempPoint.y >= y1 && $acdcdf7c54003bfb$var$tempPoint.y < y1 + height) return true;
        }
        return false;
    };
    /**
     * Destroys this sprite and optionally its texture and children
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */ TilingSprite.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        this.tileTransform = null;
        this.uvMatrix = null;
    };
    /**
     * Helper function that creates a new tiling sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
     * @param {Object} options - See {@link PIXI.BaseTexture}'s constructor for options.
     * @param {number} options.width - required width of the tiling sprite
     * @param {number} options.height - required height of the tiling sprite
     * @return {PIXI.TilingSprite} The newly created texture
     */ TilingSprite.from = function(source, options) {
        var texture = source instanceof (0, $klOfb.Texture) ? source : (0, $klOfb.Texture).from(source, options);
        return new TilingSprite(texture, options.width, options.height);
    };
    Object.defineProperty(TilingSprite.prototype, "width", {
        /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return this._width;
        },
        set: function(value) {
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TilingSprite.prototype, "height", {
        /** The height of the TilingSprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return this._height;
        },
        set: function(value) {
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    return TilingSprite;
}((0, $7Bs2Z.Sprite));
var $acdcdf7c54003bfb$var$fragmentSimpleSrc = "#version 100\n#define SHADER_NAME Tiling-Sprite-Simple-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 texSample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = texSample * uColor;\n}\n";
var $acdcdf7c54003bfb$var$gl1VertexSrc = "#version 100\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";
var $acdcdf7c54003bfb$var$gl1FragmentSrc = "#version 100\n#ifdef GL_EXT_shader_texture_lod\n    #extension GL_EXT_shader_texture_lod : enable\n#endif\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    vec2 unclamped = coord;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    #ifdef GL_EXT_shader_texture_lod\n        vec4 texSample = unclamped == coord\n            ? texture2D(uSampler, coord) \n            : texture2DLodEXT(uSampler, coord, 0);\n    #else\n        vec4 texSample = texture2D(uSampler, coord);\n    #endif\n\n    gl_FragColor = texSample * uColor;\n}\n";
var $acdcdf7c54003bfb$var$gl2VertexSrc = "#version 300 es\n#define SHADER_NAME Tiling-Sprite-300\n\nprecision lowp float;\n\nin vec2 aVertexPosition;\nin vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nout vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";
var $acdcdf7c54003bfb$var$gl2FragmentSrc = "#version 300 es\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nin vec2 vTextureCoord;\n\nout vec4 fragmentColor;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    vec2 unclamped = coord;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0\n\n    fragmentColor = texSample * uColor;\n}\n";
var $acdcdf7c54003bfb$var$tempMat = new (0, $6qzqq.Matrix)();
/**
 * WebGL renderer plugin for tiling sprites
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */ var $acdcdf7c54003bfb$export$8b7f6ad84090f14c = /** @class */ function(_super) {
    $acdcdf7c54003bfb$var$__extends(TilingSpriteRenderer, _super);
    /**
     * constructor for renderer
     *
     * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
     */ function TilingSpriteRenderer(renderer) {
        var _this = _super.call(this, renderer) || this;
        // WebGL version is not available during initialization!
        renderer.runners.contextChange.add(_this);
        _this.quad = new (0, $klOfb.QuadUv)();
        /**
         * The WebGL state in which this renderer will work.
         *
         * @member {PIXI.State}
         * @readonly
         */ _this.state = (0, $klOfb.State).for2d();
        return _this;
    }
    /**
     * Creates shaders when context is initialized.
     */ TilingSpriteRenderer.prototype.contextChange = function() {
        var renderer = this.renderer;
        var uniforms = {
            globals: renderer.globalUniforms
        };
        this.simpleShader = (0, $klOfb.Shader).from($acdcdf7c54003bfb$var$gl1VertexSrc, $acdcdf7c54003bfb$var$fragmentSimpleSrc, uniforms);
        this.shader = renderer.context.webGLVersion > 1 ? (0, $klOfb.Shader).from($acdcdf7c54003bfb$var$gl2VertexSrc, $acdcdf7c54003bfb$var$gl2FragmentSrc, uniforms) : (0, $klOfb.Shader).from($acdcdf7c54003bfb$var$gl1VertexSrc, $acdcdf7c54003bfb$var$gl1FragmentSrc, uniforms);
    };
    /**
     * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
     */ TilingSpriteRenderer.prototype.render = function(ts) {
        var renderer = this.renderer;
        var quad = this.quad;
        var vertices = quad.vertices;
        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);
        var anchorX = ts.uvRespectAnchor ? ts.anchor.x : 0;
        var anchorY = ts.uvRespectAnchor ? ts.anchor.y : 0;
        vertices = quad.uvs;
        vertices[0] = vertices[6] = -anchorX;
        vertices[1] = vertices[3] = -anchorY;
        vertices[2] = vertices[4] = 1.0 - anchorX;
        vertices[5] = vertices[7] = 1.0 - anchorY;
        quad.invalidate();
        var tex = ts._texture;
        var baseTex = tex.baseTexture;
        var lt = ts.tileTransform.localTransform;
        var uv = ts.uvMatrix;
        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
        // auto, force repeat wrapMode for big tiling textures
        if (isSimple) {
            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
                if (baseTex.wrapMode === (0, $P8XPi.WRAP_MODES).CLAMP) baseTex.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
            } else isSimple = baseTex.wrapMode !== (0, $P8XPi.WRAP_MODES).CLAMP;
        }
        var shader = isSimple ? this.simpleShader : this.shader;
        var w = tex.width;
        var h = tex.height;
        var W = ts._width;
        var H = ts._height;
        $acdcdf7c54003bfb$var$tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
        // that part is the same as above:
        // tempMat.identity();
        // tempMat.scale(tex.width, tex.height);
        // tempMat.prepend(lt);
        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);
        $acdcdf7c54003bfb$var$tempMat.invert();
        if (isSimple) $acdcdf7c54003bfb$var$tempMat.prepend(uv.mapCoord);
        else {
            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
            shader.uniforms.uClampFrame = uv.uClampFrame;
            shader.uniforms.uClampOffset = uv.uClampOffset;
        }
        shader.uniforms.uTransform = $acdcdf7c54003bfb$var$tempMat.toArray(true);
        shader.uniforms.uColor = (0, $csytw.premultiplyTintToRgba)(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.alphaMode);
        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
        shader.uniforms.uSampler = tex;
        renderer.shader.bind(shader);
        renderer.geometry.bind(quad);
        this.state.blendMode = (0, $csytw.correctBlendMode)(ts.blendMode, baseTex.alphaMode);
        renderer.state.set(this.state);
        renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    };
    return TilingSpriteRenderer;
}((0, $klOfb.ObjectRenderer));

});

parcelRegister("hnGDn", function(module, exports) {

$parcel$export(module.exports, "BitmapFontData", function () { return $ca75a7df8c7436d8$export$2fb2a0e272ba703b; });
$parcel$export(module.exports, "BitmapFont", function () { return $ca75a7df8c7436d8$export$17957a09927cadc7; });
$parcel$export(module.exports, "BitmapText", function () { return $ca75a7df8c7436d8$export$ae0da96467efdba0; });
$parcel$export(module.exports, "BitmapFontLoader", function () { return $ca75a7df8c7436d8$export$d4a75f306c6c494f; });
/*!
 * @pixi/text-bitmap - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/text-bitmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6qzqq = parcelRequire("6qzqq");

var $ezJmd = parcelRequire("ezJmd");

var $9Tsx3 = parcelRequire("9Tsx3");

var $csytw = parcelRequire("csytw");

var $klOfb = parcelRequire("klOfb");

var $9Pi8W = parcelRequire("9Pi8W");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $kXE1p = parcelRequire("kXE1p");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $ca75a7df8c7436d8$var$extendStatics = function(d, b) {
    $ca75a7df8c7436d8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ca75a7df8c7436d8$var$extendStatics(d, b);
};
function $ca75a7df8c7436d8$var$__extends(d, b) {
    $ca75a7df8c7436d8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/* eslint-disable max-len */ /**
 * Normalized parsed data from .fnt files.
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$2fb2a0e272ba703b = /** @class */ function() {
    function BitmapFontData() {
        this.info = [];
        this.common = [];
        this.page = [];
        this.char = [];
        this.kerning = [];
        this.distanceField = [];
    }
    return BitmapFontData;
}();
/**
 * BitmapFont format that's Text-based.
 *
 * @private
 */ var $ca75a7df8c7436d8$var$TextFormat = /** @class */ function() {
    function TextFormat() {}
    /**
     * Check if resource refers to txt font data.
     *
     * @param data
     * @return - True if resource could be treated as font data, false otherwise.
     */ TextFormat.test = function(data) {
        return typeof data === 'string' && data.indexOf('info face=') === 0;
    };
    /**
     * Convert text font data to a javascript object.
     *
     * @param txt - Raw string data to be converted
     * @return - Parsed font data
     */ TextFormat.parse = function(txt) {
        // Retrieve data item
        var items = txt.match(/^[a-z]+\s+.+$/gm);
        var rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(var i in items){
            // Extract item name
            var name = items[i].match(/^[a-z]+/gm)[0];
            // Extract item attribute list as string ex.: "width=10"
            var attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            // Convert attribute list into an object
            var itemData = {};
            for(var i_1 in attributeList){
                // Split key-value pairs
                var split = attributeList[i_1].split('=');
                var key = split[0];
                // Remove eventual quotes from value
                var strValue = split[1].replace(/"/gm, '');
                // Try to convert value into float
                var floatValue = parseFloat(strValue);
                // Use string value case float value is NaN
                var value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            // Push current item to the resulting data
            rawData[name].push(itemData);
        }
        var font = new $ca75a7df8c7436d8$export$2fb2a0e272ba703b();
        rawData.info.forEach(function(info) {
            return font.info.push({
                face: info.face,
                size: parseInt(info.size, 10)
            });
        });
        rawData.common.forEach(function(common) {
            return font.common.push({
                lineHeight: parseInt(common.lineHeight, 10)
            });
        });
        rawData.page.forEach(function(page) {
            return font.page.push({
                id: parseInt(page.id, 10),
                file: page.file
            });
        });
        rawData.char.forEach(function(char) {
            return font.char.push({
                id: parseInt(char.id, 10),
                page: parseInt(char.page, 10),
                x: parseInt(char.x, 10),
                y: parseInt(char.y, 10),
                width: parseInt(char.width, 10),
                height: parseInt(char.height, 10),
                xoffset: parseInt(char.xoffset, 10),
                yoffset: parseInt(char.yoffset, 10),
                xadvance: parseInt(char.xadvance, 10)
            });
        });
        rawData.kerning.forEach(function(kerning) {
            return font.kerning.push({
                first: parseInt(kerning.first, 10),
                second: parseInt(kerning.second, 10),
                amount: parseInt(kerning.amount, 10)
            });
        });
        rawData.distanceField.forEach(function(df) {
            return font.distanceField.push({
                distanceRange: parseInt(df.distanceRange, 10),
                fieldType: df.fieldType
            });
        });
        return font;
    };
    return TextFormat;
}();
/**
 * BitmapFont format that's XML-based.
 *
 * @private
 */ var $ca75a7df8c7436d8$var$XMLFormat = /** @class */ function() {
    function XMLFormat() {}
    /**
     * Check if resource refers to xml font data.
     *
     * @param data
     * @return - True if resource could be treated as font data, false otherwise.
     */ XMLFormat.test = function(data) {
        return data instanceof XMLDocument && data.getElementsByTagName('page').length && data.getElementsByTagName('info')[0].getAttribute('face') !== null;
    };
    /**
     * Convert the XML into BitmapFontData that we can use.
     *
     * @param xml
     * @return - Data to use for BitmapFont
     */ XMLFormat.parse = function(xml) {
        var data = new $ca75a7df8c7436d8$export$2fb2a0e272ba703b();
        var info = xml.getElementsByTagName('info');
        var common = xml.getElementsByTagName('common');
        var page = xml.getElementsByTagName('page');
        var char = xml.getElementsByTagName('char');
        var kerning = xml.getElementsByTagName('kerning');
        var distanceField = xml.getElementsByTagName('distanceField');
        for(var i = 0; i < info.length; i++)data.info.push({
            face: info[i].getAttribute('face'),
            size: parseInt(info[i].getAttribute('size'), 10)
        });
        for(var i = 0; i < common.length; i++)data.common.push({
            lineHeight: parseInt(common[i].getAttribute('lineHeight'), 10)
        });
        for(var i = 0; i < page.length; i++)data.page.push({
            id: parseInt(page[i].getAttribute('id'), 10) || 0,
            file: page[i].getAttribute('file')
        });
        for(var i = 0; i < char.length; i++){
            var letter = char[i];
            data.char.push({
                id: parseInt(letter.getAttribute('id'), 10),
                page: parseInt(letter.getAttribute('page'), 10) || 0,
                x: parseInt(letter.getAttribute('x'), 10),
                y: parseInt(letter.getAttribute('y'), 10),
                width: parseInt(letter.getAttribute('width'), 10),
                height: parseInt(letter.getAttribute('height'), 10),
                xoffset: parseInt(letter.getAttribute('xoffset'), 10),
                yoffset: parseInt(letter.getAttribute('yoffset'), 10),
                xadvance: parseInt(letter.getAttribute('xadvance'), 10)
            });
        }
        for(var i = 0; i < kerning.length; i++)data.kerning.push({
            first: parseInt(kerning[i].getAttribute('first'), 10),
            second: parseInt(kerning[i].getAttribute('second'), 10),
            amount: parseInt(kerning[i].getAttribute('amount'), 10)
        });
        for(var i = 0; i < distanceField.length; i++)data.distanceField.push({
            fieldType: distanceField[i].getAttribute('fieldType'),
            distanceRange: parseInt(distanceField[i].getAttribute('distanceRange'), 10)
        });
        return data;
    };
    return XMLFormat;
}();
/**
 * BitmapFont format that's XML-based.
 *
 * @private
 */ var $ca75a7df8c7436d8$var$XMLStringFormat = /** @class */ function() {
    function XMLStringFormat() {}
    /**
     * Check if resource refers to text xml font data.
     *
     * @param data
     * @return - True if resource could be treated as font data, false otherwise.
     */ XMLStringFormat.test = function(data) {
        if (typeof data === 'string' && data.indexOf('<font>') > -1) {
            var xml = new self.DOMParser().parseFromString(data, 'text/xml');
            return $ca75a7df8c7436d8$var$XMLFormat.test(xml);
        }
        return false;
    };
    /**
     * Convert the text XML into BitmapFontData that we can use.
     *
     * @param xmlTxt
     * @return - Data to use for BitmapFont
     */ XMLStringFormat.parse = function(xmlTxt) {
        var xml = new self.DOMParser().parseFromString(xmlTxt, 'text/xml');
        return $ca75a7df8c7436d8$var$XMLFormat.parse(xml);
    };
    return XMLStringFormat;
}();
// Registered formats, maybe make this extensible in the future?
var $ca75a7df8c7436d8$var$formats = [
    $ca75a7df8c7436d8$var$TextFormat,
    $ca75a7df8c7436d8$var$XMLFormat,
    $ca75a7df8c7436d8$var$XMLStringFormat
];
/**
 * Auto-detect BitmapFont parsing format based on data.
 * @private
 * @param {any} data - Data to detect format
 * @return {any} Format or null
 */ function $ca75a7df8c7436d8$var$autoDetectFormat(data) {
    for(var i = 0; i < $ca75a7df8c7436d8$var$formats.length; i++){
        if ($ca75a7df8c7436d8$var$formats[i].test(data)) return $ca75a7df8c7436d8$var$formats[i];
    }
    return null;
}
// TODO: Prevent code duplication b/w generateFillStyle & Text#generateFillStyle
/**
 * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
 *
 * @private
 * @param {object} style - The style.
 * @param {string[]} lines - The lines of text.
 * @return {string|number|CanvasGradient} The fill style
 */ function $ca75a7df8c7436d8$var$generateFillStyle(canvas, context, style, resolution, lines, metrics) {
    // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
    //       the setter converts to string. See this thread for more details:
    //       https://github.com/microsoft/TypeScript/issues/2521
    var fillStyle = style.fill;
    if (!Array.isArray(fillStyle)) return fillStyle;
    else if (fillStyle.length === 1) return fillStyle[0];
    // the gradient will be evenly spaced out according to how large the array is.
    // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
    var gradient;
    // a dropshadow will enlarge the canvas and result in the gradient being
    // generated with the incorrect dimensions
    var dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0;
    // should also take padding into account, padding can offset the gradient
    var padding = style.padding || 0;
    var width = canvas.width / resolution - dropShadowCorrection - padding * 2;
    var height = canvas.height / resolution - dropShadowCorrection - padding * 2;
    // make a copy of the style settings, so we can manipulate them later
    var fill = fillStyle.slice();
    var fillGradientStops = style.fillGradientStops.slice();
    // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
    if (!fillGradientStops.length) {
        var lengthPlus1 = fill.length + 1;
        for(var i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
    }
    // stop the bleeding of the last gradient on the line above to the top gradient of the this line
    // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
    fill.unshift(fillStyle[0]);
    fillGradientStops.unshift(0);
    fill.push(fillStyle[fillStyle.length - 1]);
    fillGradientStops.push(1);
    if (style.fillGradientType === (0, $9Pi8W.TEXT_GRADIENT).LINEAR_VERTICAL) {
        // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
        // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
        // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
        // There's potential for floating point precision issues at the seams between gradient repeats.
        // The loop below generates the stops in order, so track the last generated one to prevent
        // floating point precision from making us go the teeniest bit backwards, resulting in
        // the first and last colors getting swapped.
        var lastIterationStop = 0;
        // Actual height of the text itself, not counting spacing for lineHeight/leading/dropShadow etc
        var textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
        // textHeight, but as a 0-1 size in global gradient stop space
        var gradStopLineHeight = textHeight / height;
        for(var i = 0; i < lines.length; i++){
            var thisLineTop = metrics.lineHeight * i;
            for(var j = 0; j < fill.length; j++){
                // 0-1 stop point for the current line, multiplied to global space afterwards
                var lineStop = 0;
                if (typeof fillGradientStops[j] === 'number') lineStop = fillGradientStops[j];
                else lineStop = j / fill.length;
                var globalStop = thisLineTop / height + lineStop * gradStopLineHeight;
                // Prevent color stop generation going backwards from floating point imprecision
                var clampedStop = Math.max(lastIterationStop, globalStop);
                clampedStop = Math.min(clampedStop, 1); // Cap at 1 as well for safety's sake to avoid a possible throw.
                gradient.addColorStop(clampedStop, fill[j]);
                lastIterationStop = clampedStop;
            }
        }
    } else {
        // start the gradient at the center left of the canvas, and end at the center right of the canvas
        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
        // can just evenly space out the gradients in this case, as multiple lines makes no difference
        // to an even left to right gradient
        var totalIterations = fill.length + 1;
        var currentIteration = 1;
        for(var i = 0; i < fill.length; i++){
            var stop = void 0;
            if (typeof fillGradientStops[i] === 'number') stop = fillGradientStops[i];
            else stop = currentIteration / totalIterations;
            gradient.addColorStop(stop, fill[i]);
            currentIteration++;
        }
    }
    return gradient;
}
// TODO: Prevent code duplication b/w drawGlyph & Text#updateText
/**
 * Draws the glyph `metrics.text` on the given canvas.
 *
 * Ignored because not directly exposed.
 *
 * @ignore
 * @param {HTMLCanvasElement} canvas
 * @param {CanvasRenderingContext2D} context
 * @param {TextMetrics} metrics
 * @param {number} x
 * @param {number} y
 * @param {number} resolution
 * @param {TextStyle} style
 */ function $ca75a7df8c7436d8$var$drawGlyph(canvas, context, metrics, x, y, resolution, style) {
    var char = metrics.text;
    var fontProperties = metrics.fontProperties;
    context.translate(x, y);
    context.scale(resolution, resolution);
    var tx = style.strokeThickness / 2;
    var ty = -(style.strokeThickness / 2);
    context.font = style.toFontString();
    context.lineWidth = style.strokeThickness;
    context.textBaseline = style.textBaseline;
    context.lineJoin = style.lineJoin;
    context.miterLimit = style.miterLimit;
    // set canvas text styles
    context.fillStyle = $ca75a7df8c7436d8$var$generateFillStyle(canvas, context, style, resolution, [
        char
    ], metrics);
    context.strokeStyle = style.stroke;
    if (style.dropShadow) {
        var dropShadowColor = style.dropShadowColor;
        var rgb = (0, $csytw.hex2rgb)(typeof dropShadowColor === 'number' ? dropShadowColor : (0, $csytw.string2hex)(dropShadowColor));
        var dropShadowBlur = style.dropShadowBlur * resolution;
        var dropShadowDistance = style.dropShadowDistance * resolution;
        context.shadowColor = "rgba(" + rgb[0] * 255 + "," + rgb[1] * 255 + "," + rgb[2] * 255 + "," + style.dropShadowAlpha + ")";
        context.shadowBlur = dropShadowBlur;
        context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance;
        context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance;
    } else {
        context.shadowColor = 'black';
        context.shadowBlur = 0;
        context.shadowOffsetX = 0;
        context.shadowOffsetY = 0;
    }
    if (style.stroke && style.strokeThickness) context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
    if (style.fill) context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
    context.setTransform(1, 0, 0, 1, 0, 0); // defaults needed for older browsers (e.g. Opera 29)
    context.fillStyle = 'rgba(0, 0, 0, 0)';
}
/**
 * Ponyfill for IE because it doesn't support `Array.from`
 * @private
 */ function $ca75a7df8c7436d8$var$splitTextToCharacters(text) {
    return Array.from ? Array.from(text) : text.split('');
}
/**
 * Processes the passed character set data and returns a flattened array of all the characters.
 *
 * Ignored because not directly exposed.
 *
 * @ignore
 * @param {string | string[] | string[][] } chars
 * @returns {string[]}
 */ function $ca75a7df8c7436d8$var$resolveCharacters(chars) {
    // Split the chars string into individual characters
    if (typeof chars === 'string') chars = [
        chars
    ];
    // Handle an array of characters+ranges
    var result = [];
    for(var i = 0, j = chars.length; i < j; i++){
        var item = chars[i];
        // Handle range delimited by start/end chars
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error("[BitmapFont]: Invalid character range length, expecting 2 got " + item.length + ".");
            var startCode = item[0].charCodeAt(0);
            var endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error('[BitmapFont]: Invalid character range.');
            for(var i_1 = startCode, j_1 = endCode; i_1 <= j_1; i_1++)result.push(String.fromCharCode(i_1));
        } else result.push.apply(result, $ca75a7df8c7436d8$var$splitTextToCharacters(item));
    }
    if (result.length === 0) throw new Error('[BitmapFont]: Empty set when resolving characters.');
    return result;
}
/**
 * Ponyfill for IE because it doesn't support `codePointAt`
 * @private
 */ function $ca75a7df8c7436d8$var$extractCharCode(str) {
    return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}
/**
 * BitmapFont represents a typeface available for use with the BitmapText class. Use the `install`
 * method for adding a font to be used.
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$17957a09927cadc7 = /** @class */ function() {
    /**
     * @param data
     * @param textures
     * @param ownsTextures - Setting to `true` will destroy page textures
     *        when the font is uninstalled.
     */ function BitmapFont(data, textures, ownsTextures) {
        var _a, _b;
        var info = data.info[0];
        var common = data.common[0];
        var page = data.page[0];
        var distanceField = data.distanceField[0];
        var res = (0, $csytw.getResolutionOfUrl)(page.file);
        var pageTextures = {};
        this._ownsTextures = ownsTextures;
        this.font = info.face;
        this.size = info.size;
        this.lineHeight = common.lineHeight / res;
        this.chars = {};
        this.pageTextures = pageTextures;
        // Convert the input Texture, Textures or object
        // into a page Texture lookup by "id"
        for(var i = 0; i < data.page.length; i++){
            var _c = data.page[i], id = _c.id, file = _c.file;
            pageTextures[id] = textures instanceof Array ? textures[i] : textures[file];
            // only MSDF and SDF fonts need no-premultiplied-alpha
            if ((distanceField === null || distanceField === void 0 ? void 0 : distanceField.fieldType) && distanceField.fieldType !== 'none') pageTextures[id].baseTexture.alphaMode = (0, $P8XPi.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA;
        }
        // parse letters
        for(var i = 0; i < data.char.length; i++){
            var _d = data.char[i], id = _d.id, page_1 = _d.page;
            var _e = data.char[i], x = _e.x, y = _e.y, width = _e.width, height = _e.height, xoffset = _e.xoffset, yoffset = _e.yoffset, xadvance = _e.xadvance;
            x /= res;
            y /= res;
            width /= res;
            height /= res;
            xoffset /= res;
            yoffset /= res;
            xadvance /= res;
            var rect = new (0, $6qzqq.Rectangle)(x + pageTextures[page_1].frame.x / res, y + pageTextures[page_1].frame.y / res, width, height);
            this.chars[id] = {
                xOffset: xoffset,
                yOffset: yoffset,
                xAdvance: xadvance,
                kerning: {},
                texture: new (0, $klOfb.Texture)(pageTextures[page_1].baseTexture, rect),
                page: page_1
            };
        }
        // parse kernings
        for(var i = 0; i < data.kerning.length; i++){
            var _f = data.kerning[i], first = _f.first, second = _f.second, amount = _f.amount;
            first /= res;
            second /= res;
            amount /= res;
            if (this.chars[second]) this.chars[second].kerning[first] = amount;
        }
        // Store distance field information
        this.distanceFieldRange = distanceField === null || distanceField === void 0 ? void 0 : distanceField.distanceRange;
        this.distanceFieldType = (_b = (_a = distanceField === null || distanceField === void 0 ? void 0 : distanceField.fieldType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : 'none';
    }
    /** Remove references to created glyph textures. */ BitmapFont.prototype.destroy = function() {
        for(var id in this.chars){
            this.chars[id].texture.destroy();
            this.chars[id].texture = null;
        }
        for(var id in this.pageTextures){
            if (this._ownsTextures) this.pageTextures[id].destroy(true);
            this.pageTextures[id] = null;
        }
        // Set readonly null.
        this.chars = null;
        this.pageTextures = null;
    };
    /**
     * Register a new bitmap font.
     *
     * @param data - The
     *        characters map that could be provided as xml or raw string.
     * @param textures - List of textures for each page.
     * @param ownsTextures - Set to `true` to destroy page textures
     *        when the font is uninstalled. By default fonts created with
     *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
     * @return {PIXI.BitmapFont} Result font object with font, size, lineHeight
     *         and char fields.
     */ BitmapFont.install = function(data, textures, ownsTextures) {
        var fontData;
        if (data instanceof $ca75a7df8c7436d8$export$2fb2a0e272ba703b) fontData = data;
        else {
            var format = $ca75a7df8c7436d8$var$autoDetectFormat(data);
            if (!format) throw new Error('Unrecognized data format for font.');
            fontData = format.parse(data);
        }
        // Single texture, convert to list
        if (textures instanceof (0, $klOfb.Texture)) textures = [
            textures
        ];
        var font = new BitmapFont(fontData, textures, ownsTextures);
        BitmapFont.available[font.font] = font;
        return font;
    };
    /**
     * Remove bitmap font by name.
     *
     * @param name - Name of the font to uninstall.
     */ BitmapFont.uninstall = function(name) {
        var font = BitmapFont.available[name];
        if (!font) throw new Error("No font found named '" + name + "'");
        font.destroy();
        delete BitmapFont.available[name];
    };
    /**
     * Generates a bitmap-font for the given style and character set. This does not support
     * kernings yet. With `style` properties, only the following non-layout properties are used:
     *
     * - {@link PIXI.TextStyle#dropShadow|dropShadow}
     * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
     * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
     * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
     * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
     * - {@link PIXI.TextStyle#fill|fill}
     * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
     * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
     * - {@link PIXI.TextStyle#fontFamily|fontFamily}
     * - {@link PIXI.TextStyle#fontSize|fontSize}
     * - {@link PIXI.TextStyle#fontVariant|fontVariant}
     * - {@link PIXI.TextStyle#fontWeight|fontWeight}
     * - {@link PIXI.TextStyle#lineJoin|lineJoin}
     * - {@link PIXI.TextStyle#miterLimit|miterLimit}
     * - {@link PIXI.TextStyle#stroke|stroke}
     * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
     * - {@link PIXI.TextStyle#textBaseline|textBaseline}
     *
     * @param name - The name of the custom font to use with BitmapText.
     * @param style - Style options to render with BitmapFont.
     * @param options - Setup options for font or name of the font.
     * @param {string|string[]|string[][]} [options.chars=PIXI.BitmapFont.ALPHANUMERIC] - characters included
     *      in the font set. You can also use ranges. For example, `[['a', 'z'], ['A', 'Z'], "!@#$%^&*()~{}[] "]`.
     *      Don't forget to include spaces ' ' in your character set!
     * @param {number} [options.resolution=1] - Render resolution for glyphs.
     * @param {number} [options.textureWidth=512] - Optional width of atlas, smaller values to reduce memory.
     * @param {number} [options.textureHeight=512] - Optional height of atlas, smaller values to reduce memory.
     * @param {number} [options.padding=4] - Padding between glyphs on texture atlas.
     * @return Font generated by style options.
     * @example
     * PIXI.BitmapFont.from("TitleFont", {
     *     fontFamily: "Arial",
     *     fontSize: 12,
     *     strokeThickness: 2,
     *     fill: "purple"
     * });
     *
     * const title = new PIXI.BitmapText("This is the title", { fontName: "TitleFont" });
     */ BitmapFont.from = function(name, textStyle, options) {
        if (!name) throw new Error('[BitmapFont] Property `name` is required.');
        var _a = Object.assign({}, BitmapFont.defaultOptions, options), chars = _a.chars, padding = _a.padding, resolution = _a.resolution, textureWidth = _a.textureWidth, textureHeight = _a.textureHeight;
        var charsList = $ca75a7df8c7436d8$var$resolveCharacters(chars);
        var style = textStyle instanceof (0, $9Pi8W.TextStyle) ? textStyle : new (0, $9Pi8W.TextStyle)(textStyle);
        var lineWidth = textureWidth;
        var fontData = new $ca75a7df8c7436d8$export$2fb2a0e272ba703b();
        fontData.info[0] = {
            face: style.fontFamily,
            size: style.fontSize
        };
        fontData.common[0] = {
            lineHeight: style.fontSize
        };
        var positionX = 0;
        var positionY = 0;
        var canvas;
        var context;
        var baseTexture;
        var maxCharHeight = 0;
        var textures = [];
        for(var i = 0; i < charsList.length; i++){
            if (!canvas) {
                canvas = document.createElement('canvas');
                canvas.width = textureWidth;
                canvas.height = textureHeight;
                context = canvas.getContext('2d');
                baseTexture = new (0, $klOfb.BaseTexture)(canvas, {
                    resolution: resolution
                });
                textures.push(new (0, $klOfb.Texture)(baseTexture));
                fontData.page.push({
                    id: textures.length - 1,
                    file: ''
                });
            }
            // Measure glyph dimensions
            var metrics = (0, $9Pi8W.TextMetrics).measureText(charsList[i], style, false, canvas);
            var width = metrics.width;
            var height = Math.ceil(metrics.height);
            // This is ugly - but italics are given more space so they don't overlap
            var textureGlyphWidth = Math.ceil((style.fontStyle === 'italic' ? 2 : 1) * width);
            // Can't fit char anymore: next canvas please!
            if (positionY >= textureHeight - height * resolution) {
                if (positionY === 0) // We don't want user debugging an infinite loop (or do we? :)
                throw new Error("[BitmapFont] textureHeight " + textureHeight + "px is " + ("too small for " + style.fontSize + "px fonts"));
                --i;
                // Create new atlas once current has filled up
                canvas = null;
                context = null;
                baseTexture = null;
                positionY = 0;
                positionX = 0;
                maxCharHeight = 0;
                continue;
            }
            maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight);
            // Wrap line once full row has been rendered
            if (textureGlyphWidth * resolution + positionX >= lineWidth) {
                --i;
                positionY += maxCharHeight * resolution;
                positionY = Math.ceil(positionY);
                positionX = 0;
                maxCharHeight = 0;
                continue;
            }
            $ca75a7df8c7436d8$var$drawGlyph(canvas, context, metrics, positionX, positionY, resolution, style);
            // Unique (numeric) ID mapping to this glyph
            var id = $ca75a7df8c7436d8$var$extractCharCode(metrics.text);
            // Create a texture holding just the glyph
            fontData.char.push({
                id: id,
                page: textures.length - 1,
                x: positionX / resolution,
                y: positionY / resolution,
                width: textureGlyphWidth,
                height: height,
                xoffset: 0,
                yoffset: 0,
                xadvance: Math.ceil(width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0))
            });
            positionX += (textureGlyphWidth + 2 * padding) * resolution;
            positionX = Math.ceil(positionX);
        }
        // Brute-force kerning info, this can be expensive b/c it's an O(n²),
        // but we're using measureText which is native and fast.
        for(var i = 0, len = charsList.length; i < len; i++){
            var first = charsList[i];
            for(var j = 0; j < len; j++){
                var second = charsList[j];
                var c1 = context.measureText(first).width;
                var c2 = context.measureText(second).width;
                var total = context.measureText(first + second).width;
                var amount = total - (c1 + c2);
                if (amount) fontData.kerning.push({
                    first: $ca75a7df8c7436d8$var$extractCharCode(first),
                    second: $ca75a7df8c7436d8$var$extractCharCode(second),
                    amount: amount
                });
            }
        }
        var font = new BitmapFont(fontData, textures, true);
        // Make it easier to replace a font
        if (BitmapFont.available[name] !== undefined) BitmapFont.uninstall(name);
        BitmapFont.available[name] = font;
        return font;
    };
    /**
     * This character set includes all the letters in the alphabet (both lower- and upper- case).
     *
     * @type {string[][]}
     * @example
     * BitmapFont.from("ExampleFont", style, { chars: BitmapFont.ALPHA })
     */ BitmapFont.ALPHA = [
        [
            'a',
            'z'
        ],
        [
            'A',
            'Z'
        ],
        ' '
    ];
    /**
     * This character set includes all decimal digits (from 0 to 9).
     *
     * @type {string[][]}
     * @example
     * BitmapFont.from("ExampleFont", style, { chars: BitmapFont.NUMERIC })
     */ BitmapFont.NUMERIC = [
        [
            '0',
            '9'
        ]
    ];
    /**
     * This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
     *
     * @type {string[][]}
     */ BitmapFont.ALPHANUMERIC = [
        [
            'a',
            'z'
        ],
        [
            'A',
            'Z'
        ],
        [
            '0',
            '9'
        ],
        ' '
    ];
    /**
     * This character set consists of all the ASCII table.
     *
     * @member {string[][]}
     * @see http://www.asciitable.com/
     */ BitmapFont.ASCII = [
        [
            ' ',
            '~'
        ]
    ];
    /**
     * Collection of default options when using `BitmapFont.from`.
     *
     * @property {number} resolution=1
     * @property {number} textureWidth=512
     * @property {number} textureHeight=512
     * @property {number} padding=4
     * @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
     */ BitmapFont.defaultOptions = {
        resolution: 1,
        textureWidth: 512,
        textureHeight: 512,
        padding: 4,
        chars: BitmapFont.ALPHANUMERIC
    };
    /** Collection of available/installed fonts. */ BitmapFont.available = {};
    return BitmapFont;
}();
var $ca75a7df8c7436d8$var$msdfFrag = "// Pixi texture info\r\nvarying vec2 vTextureCoord;\r\nuniform sampler2D uSampler;\r\n\r\n// Tint\r\nuniform vec4 uColor;\r\n\r\n// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r\nuniform float uFWidth;\r\n\r\nvoid main(void) {\r\n\r\n  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r\n  vec4 texColor = texture2D(uSampler, vTextureCoord);\r\n\r\n  // MSDF\r\n  float median = texColor.r + texColor.g + texColor.b -\r\n                  min(texColor.r, min(texColor.g, texColor.b)) -\r\n                  max(texColor.r, max(texColor.g, texColor.b));\r\n  // SDF\r\n  median = min(median, texColor.a);\r\n\r\n  float screenPxDistance = uFWidth * (median - 0.5);\r\n  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r\n\r\n  // NPM Textures, NPM outputs\r\n  gl_FragColor = vec4(uColor.rgb, uColor.a * alpha);\r\n\r\n}\r\n";
var $ca75a7df8c7436d8$var$msdfVert = "// Mesh material default fragment\r\nattribute vec2 aVertexPosition;\r\nattribute vec2 aTextureCoord;\r\n\r\nuniform mat3 projectionMatrix;\r\nuniform mat3 translationMatrix;\r\nuniform mat3 uTextureMatrix;\r\n\r\nvarying vec2 vTextureCoord;\r\n\r\nvoid main(void)\r\n{\r\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r\n\r\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r\n}\r\n";
// If we ever need more than two pools, please make a Dict or something better.
var $ca75a7df8c7436d8$var$pageMeshDataDefaultPageMeshData = [];
var $ca75a7df8c7436d8$var$pageMeshDataMSDFPageMeshData = [];
var $ca75a7df8c7436d8$var$charRenderDataPool = [];
/**
 * A BitmapText object will create a line or multiple lines of text using bitmap font.
 *
 * The primary advantage of this class over Text is that all of your textures are pre-generated and loading,
 * meaning that rendering is fast, and changing text has no performance implications.
 *
 * Supporting character sets other than latin, such as CJK languages, may be impractical due to the number of characters.
 *
 * To split a line you can use '\n', '\r' or '\r\n' in your string.
 *
 * PixiJS can auto-generate fonts on-the-fly using BitmapFont or use fnt files provided by:
 * http://www.angelcode.com/products/bmfont/ for Windows or
 * http://www.bmglyph.com/ for Mac.
 *
 * You can also use SDF, MSDF and MTSDF BitmapFonts for vector-like scaling appearance provided by:
 * https://github.com/soimy/msdf-bmfont-xml for SDF and MSDF fnt files or
 * https://github.com/Chlumsky/msdf-atlas-gen for SDF, MSDF and MTSDF json files
 *
 * A BitmapText can only be created when the font is loaded.
 *
 * ```js
 * // in this case the font is in a file called 'desyrel.fnt'
 * let bitmapText = new PIXI.BitmapText("text using a fancy font!", {
 *   fontName: "Desyrel",
 *   fontSize: 35,
 *   align: "right"
 * });
 * ```
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$ae0da96467efdba0 = /** @class */ function(_super) {
    $ca75a7df8c7436d8$var$__extends(BitmapText, _super);
    /**
     * @param text - A string that you would like the text to display.
     * @param style - The style parameters.
     * @param {string} style.fontName - The installed BitmapFont name.
     * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
     *.     this will default to the BitmapFont size.
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
     *      does not affect single line text.
     * @param {number} [style.tint=0xFFFFFF] - The tint color.
     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
     * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
     */ function BitmapText(text, style) {
        if (style === void 0) style = {};
        var _this = _super.call(this) || this;
        /**
         * Private tracker for the current tint.
         *
         * @private
         */ _this._tint = 0xFFFFFF;
        // Apply the defaults
        var _a = Object.assign({}, BitmapText.styleDefaults, style), align = _a.align, tint = _a.tint, maxWidth = _a.maxWidth, letterSpacing = _a.letterSpacing, fontName = _a.fontName, fontSize = _a.fontSize;
        if (!$ca75a7df8c7436d8$export$17957a09927cadc7.available[fontName]) throw new Error("Missing BitmapFont \"" + fontName + "\"");
        _this._activePagesMeshData = [];
        _this._textWidth = 0;
        _this._textHeight = 0;
        _this._align = align;
        _this._tint = tint;
        _this._fontName = fontName;
        _this._fontSize = fontSize || $ca75a7df8c7436d8$export$17957a09927cadc7.available[fontName].size;
        _this._text = text;
        _this._maxWidth = maxWidth;
        _this._maxLineHeight = 0;
        _this._letterSpacing = letterSpacing;
        _this._anchor = new (0, $6qzqq.ObservablePoint)(function() {
            _this.dirty = true;
        }, _this, 0, 0);
        _this._roundPixels = (0, $ezJmd.settings).ROUND_PIXELS;
        _this.dirty = true;
        _this._textureCache = {};
        return _this;
    }
    /**
     * Renders text and updates it when needed. This should only be called
     * if the BitmapFont is regenerated.
     */ BitmapText.prototype.updateText = function() {
        var _a;
        var data = $ca75a7df8c7436d8$export$17957a09927cadc7.available[this._fontName];
        var scale = this._fontSize / data.size;
        var pos = new (0, $6qzqq.Point)();
        var chars = [];
        var lineWidths = [];
        var lineSpaces = [];
        var text = this._text.replace(/(?:\r\n|\r)/g, '\n') || ' ';
        var charsInput = $ca75a7df8c7436d8$var$splitTextToCharacters(text);
        var maxWidth = this._maxWidth * data.size / this._fontSize;
        var pageMeshDataPool = data.distanceFieldType === 'none' ? $ca75a7df8c7436d8$var$pageMeshDataDefaultPageMeshData : $ca75a7df8c7436d8$var$pageMeshDataMSDFPageMeshData;
        var prevCharCode = null;
        var lastLineWidth = 0;
        var maxLineWidth = 0;
        var line = 0;
        var lastBreakPos = -1;
        var lastBreakWidth = 0;
        var spacesRemoved = 0;
        var maxLineHeight = 0;
        var spaceCount = 0;
        for(var i = 0; i < charsInput.length; i++){
            var char = charsInput[i];
            var charCode = $ca75a7df8c7436d8$var$extractCharCode(char);
            if (/(?:\s)/.test(char)) {
                lastBreakPos = i;
                lastBreakWidth = lastLineWidth;
                spaceCount++;
            }
            if (char === '\r' || char === '\n') {
                lineWidths.push(lastLineWidth);
                lineSpaces.push(-1);
                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
                ++line;
                ++spacesRemoved;
                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                spaceCount = 0;
                continue;
            }
            var charData = data.chars[charCode];
            if (!charData) continue;
            if (prevCharCode && charData.kerning[prevCharCode]) pos.x += charData.kerning[prevCharCode];
            var charRenderData = $ca75a7df8c7436d8$var$charRenderDataPool.pop() || {
                texture: (0, $klOfb.Texture).EMPTY,
                line: 0,
                charCode: 0,
                prevSpaces: 0,
                position: new (0, $6qzqq.Point)()
            };
            charRenderData.texture = charData.texture;
            charRenderData.line = line;
            charRenderData.charCode = charCode;
            charRenderData.position.x = pos.x + charData.xOffset + this._letterSpacing / 2;
            charRenderData.position.y = pos.y + charData.yOffset;
            charRenderData.prevSpaces = spaceCount;
            chars.push(charRenderData);
            lastLineWidth = charRenderData.position.x + charData.texture.orig.width; // Use charRenderData position!
            pos.x += charData.xAdvance + this._letterSpacing;
            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
            prevCharCode = charCode;
            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
                ++spacesRemoved;
                (0, $csytw.removeItems)(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
                i = lastBreakPos;
                lastBreakPos = -1;
                lineWidths.push(lastBreakWidth);
                lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0);
                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
                line++;
                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                spaceCount = 0;
            }
        }
        var lastChar = charsInput[charsInput.length - 1];
        if (lastChar !== '\r' && lastChar !== '\n') {
            if (/(?:\s)/.test(lastChar)) lastLineWidth = lastBreakWidth;
            lineWidths.push(lastLineWidth);
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
            lineSpaces.push(-1);
        }
        var lineAlignOffsets = [];
        for(var i = 0; i <= line; i++){
            var alignOffset = 0;
            if (this._align === 'right') alignOffset = maxLineWidth - lineWidths[i];
            else if (this._align === 'center') alignOffset = (maxLineWidth - lineWidths[i]) / 2;
            else if (this._align === 'justify') alignOffset = lineSpaces[i] < 0 ? 0 : (maxLineWidth - lineWidths[i]) / lineSpaces[i];
            lineAlignOffsets.push(alignOffset);
        }
        var lenChars = chars.length;
        var pagesMeshData = {};
        var newPagesMeshData = [];
        var activePagesMeshData = this._activePagesMeshData;
        for(var i = 0; i < activePagesMeshData.length; i++)pageMeshDataPool.push(activePagesMeshData[i]);
        for(var i = 0; i < lenChars; i++){
            var texture = chars[i].texture;
            var baseTextureUid = texture.baseTexture.uid;
            if (!pagesMeshData[baseTextureUid]) {
                var pageMeshData = pageMeshDataPool.pop();
                if (!pageMeshData) {
                    var geometry = new (0, $9Tsx3.MeshGeometry)();
                    var material = void 0;
                    var meshBlendMode = void 0;
                    if (data.distanceFieldType === 'none') {
                        material = new (0, $9Tsx3.MeshMaterial)((0, $klOfb.Texture).EMPTY);
                        meshBlendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
                    } else {
                        material = new (0, $9Tsx3.MeshMaterial)((0, $klOfb.Texture).EMPTY, {
                            program: (0, $klOfb.Program).from($ca75a7df8c7436d8$var$msdfVert, $ca75a7df8c7436d8$var$msdfFrag),
                            uniforms: {
                                uFWidth: 0
                            }
                        });
                        meshBlendMode = (0, $P8XPi.BLEND_MODES).NORMAL_NPM;
                    }
                    var mesh = new (0, $9Tsx3.Mesh)(geometry, material);
                    mesh.blendMode = meshBlendMode;
                    pageMeshData = {
                        index: 0,
                        indexCount: 0,
                        vertexCount: 0,
                        uvsCount: 0,
                        total: 0,
                        mesh: mesh,
                        vertices: null,
                        uvs: null,
                        indices: null
                    };
                }
                // reset data..
                pageMeshData.index = 0;
                pageMeshData.indexCount = 0;
                pageMeshData.vertexCount = 0;
                pageMeshData.uvsCount = 0;
                pageMeshData.total = 0;
                // TODO need to get page texture here somehow..
                var _textureCache = this._textureCache;
                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new (0, $klOfb.Texture)(texture.baseTexture);
                pageMeshData.mesh.texture = _textureCache[baseTextureUid];
                pageMeshData.mesh.tint = this._tint;
                newPagesMeshData.push(pageMeshData);
                pagesMeshData[baseTextureUid] = pageMeshData;
            }
            pagesMeshData[baseTextureUid].total++;
        }
        // lets find any previously active pageMeshDatas that are no longer required for
        // the updated text (if any), removed and return them to the pool.
        for(var i = 0; i < activePagesMeshData.length; i++)if (newPagesMeshData.indexOf(activePagesMeshData[i]) === -1) this.removeChild(activePagesMeshData[i].mesh);
        // next lets add any new meshes, that have not yet been added to this BitmapText
        // we only add if its not already a child of this BitmapObject
        for(var i = 0; i < newPagesMeshData.length; i++)if (newPagesMeshData[i].mesh.parent !== this) this.addChild(newPagesMeshData[i].mesh);
        // active page mesh datas are set to be the new pages added.
        this._activePagesMeshData = newPagesMeshData;
        for(var i in pagesMeshData){
            var pageMeshData = pagesMeshData[i];
            var total = pageMeshData.total;
            // lets only allocate new buffers if we can fit the new text in the current ones..
            // unless that is, we will be batching. Currently batching dose not respect the size property of mesh
            if (!(((_a = pageMeshData.indices) === null || _a === void 0 ? void 0 : _a.length) > 6 * total) || pageMeshData.vertices.length < (0, $9Tsx3.Mesh).BATCHABLE_SIZE * 2) {
                pageMeshData.vertices = new Float32Array(8 * total);
                pageMeshData.uvs = new Float32Array(8 * total);
                pageMeshData.indices = new Uint16Array(6 * total);
            } else {
                var total_1 = pageMeshData.total;
                var vertices = pageMeshData.vertices;
                // Clear the garbage at the end of the vertices buffer. This will prevent the bounds miscalculation.
                for(var i_1 = total_1 * 8; i_1 < vertices.length; i_1++)vertices[i_1] = 0;
            }
            // as a buffer maybe bigger than the current word, we set the size of the meshMaterial
            // to match the number of letters needed
            pageMeshData.mesh.size = 6 * total;
        }
        for(var i = 0; i < lenChars; i++){
            var char = chars[i];
            var offset = char.position.x + lineAlignOffsets[char.line] * (this._align === 'justify' ? char.prevSpaces : 1);
            if (this._roundPixels) offset = Math.round(offset);
            var xPos = offset * scale;
            var yPos = char.position.y * scale;
            var texture = char.texture;
            var pageMesh = pagesMeshData[texture.baseTexture.uid];
            var textureFrame = texture.frame;
            var textureUvs = texture._uvs;
            var index = pageMesh.index++;
            pageMesh.indices[index * 6 + 0] = 0 + index * 4;
            pageMesh.indices[index * 6 + 1] = 1 + index * 4;
            pageMesh.indices[index * 6 + 2] = 2 + index * 4;
            pageMesh.indices[index * 6 + 3] = 0 + index * 4;
            pageMesh.indices[index * 6 + 4] = 2 + index * 4;
            pageMesh.indices[index * 6 + 5] = 3 + index * 4;
            pageMesh.vertices[index * 8 + 0] = xPos;
            pageMesh.vertices[index * 8 + 1] = yPos;
            pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale;
            pageMesh.vertices[index * 8 + 3] = yPos;
            pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale;
            pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale;
            pageMesh.vertices[index * 8 + 6] = xPos;
            pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale;
            pageMesh.uvs[index * 8 + 0] = textureUvs.x0;
            pageMesh.uvs[index * 8 + 1] = textureUvs.y0;
            pageMesh.uvs[index * 8 + 2] = textureUvs.x1;
            pageMesh.uvs[index * 8 + 3] = textureUvs.y1;
            pageMesh.uvs[index * 8 + 4] = textureUvs.x2;
            pageMesh.uvs[index * 8 + 5] = textureUvs.y2;
            pageMesh.uvs[index * 8 + 6] = textureUvs.x3;
            pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
        }
        this._textWidth = maxLineWidth * scale;
        this._textHeight = (pos.y + data.lineHeight) * scale;
        for(var i in pagesMeshData){
            var pageMeshData = pagesMeshData[i];
            // apply anchor
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                var vertexCount = 0;
                var anchorOffsetX = this._textWidth * this.anchor.x;
                var anchorOffsetY = this._textHeight * this.anchor.y;
                for(var i_2 = 0; i_2 < pageMeshData.total; i_2++){
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                }
            }
            this._maxLineHeight = maxLineHeight * scale;
            var vertexBuffer = pageMeshData.mesh.geometry.getBuffer('aVertexPosition');
            var textureBuffer = pageMeshData.mesh.geometry.getBuffer('aTextureCoord');
            var indexBuffer = pageMeshData.mesh.geometry.getIndex();
            vertexBuffer.data = pageMeshData.vertices;
            textureBuffer.data = pageMeshData.uvs;
            indexBuffer.data = pageMeshData.indices;
            vertexBuffer.update();
            textureBuffer.update();
            indexBuffer.update();
        }
        for(var i = 0; i < chars.length; i++)$ca75a7df8c7436d8$var$charRenderDataPool.push(chars[i]);
    };
    BitmapText.prototype.updateTransform = function() {
        this.validate();
        this.containerUpdateTransform();
    };
    BitmapText.prototype._render = function(renderer) {
        // Update the uniform
        var _a = $ca75a7df8c7436d8$export$17957a09927cadc7.available[this._fontName], distanceFieldRange = _a.distanceFieldRange, distanceFieldType = _a.distanceFieldType, size = _a.size;
        if (distanceFieldType !== 'none') {
            // Inject the shader code with the correct value
            var _b = this.worldTransform, a = _b.a, b = _b.b, c = _b.c, d = _b.d;
            var dx = Math.sqrt(a * a + b * b);
            var dy = Math.sqrt(c * c + d * d);
            var worldScale = (Math.abs(dx) + Math.abs(dy)) / 2;
            var fontScale = this._fontSize / size;
            for(var _i = 0, _c = this._activePagesMeshData; _i < _c.length; _i++){
                var mesh = _c[_i];
                mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * renderer.resolution;
            }
        }
        _super.prototype._render.call(this, renderer);
    };
    /**
     * Validates text before calling parent's getLocalBounds
     *
     * @return - The rectangular bounding area
     */ BitmapText.prototype.getLocalBounds = function() {
        this.validate();
        return _super.prototype.getLocalBounds.call(this);
    };
    /**
     * Updates text when needed
     *
     * @private
     */ BitmapText.prototype.validate = function() {
        if (this.dirty) {
            this.updateText();
            this.dirty = false;
        }
    };
    Object.defineProperty(BitmapText.prototype, "tint", {
        /**
         * The tint of the BitmapText object.
         *
         * @default 0xffffff
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            if (this._tint === value) return;
            this._tint = value;
            for(var i = 0; i < this._activePagesMeshData.length; i++)this._activePagesMeshData[i].mesh.tint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "align", {
        /**
         * The alignment of the BitmapText object.
         *
         * @member {string}
         * @default 'left'
         */ get: function() {
            return this._align;
        },
        set: function(value) {
            if (this._align !== value) {
                this._align = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "fontName", {
        /** The name of the BitmapFont. */ get: function() {
            return this._fontName;
        },
        set: function(value) {
            if (!$ca75a7df8c7436d8$export$17957a09927cadc7.available[value]) throw new Error("Missing BitmapFont \"" + value + "\"");
            if (this._fontName !== value) {
                this._fontName = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "fontSize", {
        /** The size of the font to display. */ get: function() {
            return this._fontSize;
        },
        set: function(value) {
            if (this._fontSize !== value) {
                this._fontSize = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "anchor", {
        /**
         * The anchor sets the origin point of the text.
         *
         * The default is `(0,0)`, this means the text's origin is the top left.
         *
         * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
         *
         * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
         */ get: function() {
            return this._anchor;
        },
        set: function(value) {
            if (typeof value === 'number') this._anchor.set(value);
            else this._anchor.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "text", {
        /** The text of the BitmapText object. */ get: function() {
            return this._text;
        },
        set: function(text) {
            text = String(text === null || text === undefined ? '' : text);
            if (this._text === text) return;
            this._text = text;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "maxWidth", {
        /**
         * The max width of this bitmap text in pixels. If the text provided is longer than the
         * value provided, line breaks will be automatically inserted in the last whitespace.
         * Disable by setting the value to 0.
         */ get: function() {
            return this._maxWidth;
        },
        set: function(value) {
            if (this._maxWidth === value) return;
            this._maxWidth = value;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "maxLineHeight", {
        /**
         * The max line height. This is useful when trying to use the total height of the Text,
         * i.e. when trying to vertically align.
         *
         * @readonly
         */ get: function() {
            this.validate();
            return this._maxLineHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "textWidth", {
        /**
         * The width of the overall text, different from fontSize,
         * which is defined in the style object.
         *
         * @readonly
         */ get: function() {
            this.validate();
            return this._textWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "letterSpacing", {
        /** Additional space between characters. */ get: function() {
            return this._letterSpacing;
        },
        set: function(value) {
            if (this._letterSpacing !== value) {
                this._letterSpacing = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "roundPixels", {
        /**
         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
         * The main disadvantage is movement of objects may appear less smooth.
         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
         *
         * @default PIXI.settings.ROUND_PIXELS
         */ get: function() {
            return this._roundPixels;
        },
        set: function(value) {
            if (value !== this._roundPixels) {
                this._roundPixels = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "textHeight", {
        /**
         * The height of the overall text, different from fontSize,
         * which is defined in the style object.
         *
         * @readonly
         */ get: function() {
            this.validate();
            return this._textHeight;
        },
        enumerable: false,
        configurable: true
    });
    BitmapText.prototype.destroy = function(options) {
        var _textureCache = this._textureCache;
        for(var id in _textureCache){
            var texture = _textureCache[id];
            texture.destroy();
            delete _textureCache[id];
        }
        this._textureCache = null;
        _super.prototype.destroy.call(this, options);
    };
    BitmapText.styleDefaults = {
        align: 'left',
        tint: 0xFFFFFF,
        maxWidth: 0,
        letterSpacing: 0
    };
    return BitmapText;
}((0, $8t5Gy.Container));
/**
 * {@link PIXI.Loader Loader} middleware for loading
 * bitmap-based fonts suitable for using with {@link PIXI.BitmapText}.
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$d4a75f306c6c494f = /** @class */ function() {
    function BitmapFontLoader() {}
    /**
     * Called when the plugin is installed.
     *
     * @see PIXI.Loader.registerPlugin
     */ BitmapFontLoader.add = function() {
        (0, $kXE1p.LoaderResource).setExtensionXhrType('fnt', (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.TEXT);
    };
    /**
     * Called after a resource is loaded.
     *
     * @see PIXI.Loader.loaderMiddleware
     * @param {PIXI.LoaderResource} resource
     * @param {function} next
     */ BitmapFontLoader.use = function(resource, next) {
        var format = $ca75a7df8c7436d8$var$autoDetectFormat(resource.data);
        // Resource was not recognised as any of the expected font data format
        if (!format) {
            next();
            return;
        }
        var baseUrl = BitmapFontLoader.getBaseUrl(this, resource);
        var data = format.parse(resource.data);
        var textures = {};
        // Handle completed, when the number of textures
        // load is the same number as references in the fnt file
        var completed = function(page) {
            textures[page.metadata.pageFile] = page.texture;
            if (Object.keys(textures).length === data.page.length) {
                resource.bitmapFont = $ca75a7df8c7436d8$export$17957a09927cadc7.install(data, textures, true);
                next();
            }
        };
        for(var i = 0; i < data.page.length; ++i){
            var pageFile = data.page[i].file;
            var url = baseUrl + pageFile;
            var exists = false;
            // incase the image is loaded outside
            // using the same loader, resource will be available
            for(var name in this.resources){
                var bitmapResource = this.resources[name];
                if (bitmapResource.url === url) {
                    bitmapResource.metadata.pageFile = pageFile;
                    if (bitmapResource.texture) completed(bitmapResource);
                    else bitmapResource.onAfterMiddleware.add(completed);
                    exists = true;
                    break;
                }
            }
            // texture is not loaded, we'll attempt to add
            // it to the load and add the texture to the list
            if (!exists) {
                // Standard loading options for images
                var options = {
                    crossOrigin: resource.crossOrigin,
                    loadType: (0, $kXE1p.LoaderResource).LOAD_TYPE.IMAGE,
                    metadata: Object.assign({
                        pageFile: pageFile
                    }, resource.metadata.imageMetadata),
                    parentResource: resource
                };
                this.add(url, options, completed);
            }
        }
    };
    /** Get folder path from a resource. */ BitmapFontLoader.getBaseUrl = function(loader, resource) {
        var resUrl = !resource.isDataUrl ? BitmapFontLoader.dirname(resource.url) : '';
        if (resource.isDataUrl) {
            if (resUrl === '.') resUrl = '';
            if (loader.baseUrl && resUrl) // if baseurl has a trailing slash then add one to resUrl so the replace works below
            {
                if (loader.baseUrl.charAt(loader.baseUrl.length - 1) === '/') resUrl += '/';
            }
        }
        // remove baseUrl from resUrl
        resUrl = resUrl.replace(loader.baseUrl, '');
        // if there is an resUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
        if (resUrl && resUrl.charAt(resUrl.length - 1) !== '/') resUrl += '/';
        return resUrl;
    };
    /**
     * Replacement for NodeJS's path.dirname
     *
     * @param {string} url - Path to get directory for
     */ BitmapFontLoader.dirname = function(url) {
        var dir = url.replace(/\\/g, '/') // convert windows notation to UNIX notation, URL-safe because it's a forbidden character
        .replace(/\/$/, '') // replace trailing slash
        .replace(/\/[^\/]*$/, ''); // remove everything after the last
        // File request is relative, use current directory
        if (dir === url) return '.';
        else if (dir === '') return '/';
        return dir;
    };
    return BitmapFontLoader;
}();

});
parcelRegister("9Tsx3", function(module, exports) {

$parcel$export(module.exports, "MeshBatchUvs", function () { return $733f620544d369b5$export$49cc356fa6ba0e7b; });
$parcel$export(module.exports, "Mesh", function () { return $733f620544d369b5$export$e176487c05830cc5; });
$parcel$export(module.exports, "MeshMaterial", function () { return $733f620544d369b5$export$d552dadfd66cc650; });
$parcel$export(module.exports, "MeshGeometry", function () { return $733f620544d369b5$export$8d075a36a73d54bc; });
/*!
 * @pixi/mesh - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mesh is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $ezJmd = parcelRequire("ezJmd");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $733f620544d369b5$var$extendStatics = function(d, b) {
    $733f620544d369b5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $733f620544d369b5$var$extendStatics(d, b);
};
function $733f620544d369b5$var$__extends(d, b) {
    $733f620544d369b5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Class controls cache for UV mapping from Texture normal space to BaseTexture normal space.
 *
 * @class
 * @memberof PIXI
 */ var $733f620544d369b5$export$49cc356fa6ba0e7b = /** @class */ function() {
    /**
     * @param {PIXI.Buffer} uvBuffer - Buffer with normalized uv's
     * @param {PIXI.TextureMatrix} uvMatrix - Material UV matrix
     */ function MeshBatchUvs(uvBuffer, uvMatrix) {
        /**
         * Buffer with normalized UV's
         * @member {PIXI.Buffer}
         */ this.uvBuffer = uvBuffer;
        /**
         * Material UV matrix
         * @member {PIXI.TextureMatrix}
         */ this.uvMatrix = uvMatrix;
        /**
         * UV Buffer data
         * @member {Float32Array}
         * @readonly
         */ this.data = null;
        this._bufferUpdateId = -1;
        this._textureUpdateId = -1;
        this._updateID = 0;
    }
    /**
     * updates
     *
     * @param {boolean} [forceUpdate] - force the update
     */ MeshBatchUvs.prototype.update = function(forceUpdate) {
        if (!forceUpdate && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID) return;
        this._bufferUpdateId = this.uvBuffer._updateID;
        this._textureUpdateId = this.uvMatrix._updateID;
        var data = this.uvBuffer.data;
        if (!this.data || this.data.length !== data.length) this.data = new Float32Array(data.length);
        this.uvMatrix.multiplyUvs(data, this.data);
        this._updateID++;
    };
    return MeshBatchUvs;
}();
var $733f620544d369b5$var$tempPoint = new (0, $6qzqq.Point)();
var $733f620544d369b5$var$tempPolygon = new (0, $6qzqq.Polygon)();
/**
 * Base mesh class.
 *
 * This class empowers you to have maximum flexibility to render any kind of WebGL visuals you can think of.
 * This class assumes a certain level of WebGL knowledge.
 * If you know a bit this should abstract enough away to make your life easier!
 *
 * Pretty much ALL WebGL can be broken down into the following:
 * - Geometry - The structure and data for the mesh. This can include anything from positions, uvs, normals, colors etc..
 * - Shader - This is the shader that PixiJS will render the geometry with (attributes in the shader must match the geometry)
 * - State - This is the state of WebGL required to render the mesh.
 *
 * Through a combination of the above elements you can render anything you want, 2D or 3D!
 *
 * @memberof PIXI
 */ var $733f620544d369b5$export$e176487c05830cc5 = /** @class */ function(_super) {
    $733f620544d369b5$var$__extends(Mesh, _super);
    /**
     * @param geometry - The geometry the mesh will use.
     * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
     * @param state - The state that the WebGL context is required to be in to render the mesh
     *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
     * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
     */ function Mesh(geometry, shader, state, drawMode) {
        if (drawMode === void 0) drawMode = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        var _this = _super.call(this) || this;
        _this.geometry = geometry;
        _this.shader = shader;
        _this.state = state || (0, $klOfb.State).for2d();
        _this.drawMode = drawMode;
        _this.start = 0;
        _this.size = 0;
        _this.uvs = null;
        _this.indices = null;
        _this.vertexData = new Float32Array(1);
        _this.vertexDirty = -1;
        _this._transformID = -1;
        _this._roundPixels = (0, $ezJmd.settings).ROUND_PIXELS;
        _this.batchUvs = null;
        return _this;
    }
    Object.defineProperty(Mesh.prototype, "geometry", {
        /**
         * Includes vertex positions, face indices, normals, colors, UVs, and
         * custom attributes within buffers, reducing the cost of passing all
         * this data to the GPU. Can be shared between multiple Mesh objects.
         */ get: function() {
            return this._geometry;
        },
        set: function(value) {
            if (this._geometry === value) return;
            if (this._geometry) {
                this._geometry.refCount--;
                if (this._geometry.refCount === 0) this._geometry.dispose();
            }
            this._geometry = value;
            if (this._geometry) this._geometry.refCount++;
            this.vertexDirty = -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "uvBuffer", {
        /**
         * To change mesh uv's, change its uvBuffer data and increment its _updateID.
         *
         * @readonly
         */ get: function() {
            return this.geometry.buffers[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "verticesBuffer", {
        /**
         * To change mesh vertices, change its uvBuffer data and increment its _updateID.
         * Incrementing _updateID is optional because most of Mesh objects do it anyway.
         *
         * @readonly
         */ get: function() {
            return this.geometry.buffers[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "material", {
        get: function() {
            return this.shader;
        },
        /** Alias for {@link PIXI.Mesh#shader}. */ set: function(value) {
            this.shader = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "blendMode", {
        get: function() {
            return this.state.blendMode;
        },
        /**
         * The blend mode to be applied to the Mesh. Apply a value of
         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         *
         * @default PIXI.BLEND_MODES.NORMAL;
         */ set: function(value) {
            this.state.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "roundPixels", {
        get: function() {
            return this._roundPixels;
        },
        /**
         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
         * The main disadvantage is movement of objects may appear less smooth.
         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
         *
         * @default false
         */ set: function(value) {
            if (this._roundPixels !== value) this._transformID = -1;
            this._roundPixels = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "tint", {
        /**
         * The multiply tint applied to the Mesh. This is a hex value. A value of
         * `0xFFFFFF` will remove any tint effect.
         *
         * Null for non-MeshMaterial shaders
         *
         * @default 0xFFFFFF
         */ get: function() {
            return 'tint' in this.shader ? this.shader.tint : null;
        },
        set: function(value) {
            this.shader.tint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "texture", {
        /**
         * The texture that the Mesh uses.
         *
         * Null for non-MeshMaterial shaders
         */ get: function() {
            return 'texture' in this.shader ? this.shader.texture : null;
        },
        set: function(value) {
            this.shader.texture = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Standard renderer draw.
     *
     * @param renderer - Instance to renderer.
     */ Mesh.prototype._render = function(renderer) {
        // set properties for batching..
        // TODO could use a different way to grab verts?
        var vertices = this.geometry.buffers[0].data;
        var shader = this.shader;
        // TODO benchmark check for attribute size..
        if (shader.batchable && this.drawMode === (0, $P8XPi.DRAW_MODES).TRIANGLES && vertices.length < Mesh.BATCHABLE_SIZE * 2) this._renderToBatch(renderer);
        else this._renderDefault(renderer);
    };
    /**
     * Standard non-batching way of rendering.
     *
     * @param renderer - Instance to renderer.
     */ Mesh.prototype._renderDefault = function(renderer) {
        var shader = this.shader;
        shader.alpha = this.worldAlpha;
        if (shader.update) shader.update();
        renderer.batch.flush();
        // bind and sync uniforms..
        shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(true);
        renderer.shader.bind(shader);
        // set state..
        renderer.state.set(this.state);
        // bind the geometry...
        renderer.geometry.bind(this.geometry, shader);
        // then render it
        renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    };
    /**
     * Rendering by using the Batch system.
     *
     * @param renderer - Instance to renderer.
     */ Mesh.prototype._renderToBatch = function(renderer) {
        var geometry = this.geometry;
        var shader = this.shader;
        if (shader.uvMatrix) {
            shader.uvMatrix.update();
            this.calculateUvs();
        }
        // set properties for batching..
        this.calculateVertices();
        this.indices = geometry.indexBuffer.data;
        this._tintRGB = shader._tintRGB;
        this._texture = shader.texture;
        var pluginName = this.material.pluginName;
        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]);
        renderer.plugins[pluginName].render(this);
    };
    /** Updates vertexData field based on transform and vertices. */ Mesh.prototype.calculateVertices = function() {
        var geometry = this.geometry;
        var verticesBuffer = geometry.buffers[0];
        var vertices = verticesBuffer.data;
        var vertexDirtyId = verticesBuffer._updateID;
        if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) return;
        this._transformID = this.transform._worldID;
        if (this.vertexData.length !== vertices.length) this.vertexData = new Float32Array(vertices.length);
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var vertexData = this.vertexData;
        for(var i = 0; i < vertexData.length / 2; i++){
            var x = vertices[i * 2];
            var y = vertices[i * 2 + 1];
            vertexData[i * 2] = a * x + c * y + tx;
            vertexData[i * 2 + 1] = b * x + d * y + ty;
        }
        if (this._roundPixels) {
            var resolution = (0, $ezJmd.settings).RESOLUTION;
            for(var i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round((vertexData[i] * resolution | 0) / resolution);
        }
        this.vertexDirty = vertexDirtyId;
    };
    /** Updates uv field based on from geometry uv's or batchUvs. */ Mesh.prototype.calculateUvs = function() {
        var geomUvs = this.geometry.buffers[1];
        var shader = this.shader;
        if (!shader.uvMatrix.isSimple) {
            if (!this.batchUvs) this.batchUvs = new $733f620544d369b5$export$49cc356fa6ba0e7b(geomUvs, shader.uvMatrix);
            this.batchUvs.update();
            this.uvs = this.batchUvs.data;
        } else this.uvs = geomUvs.data;
    };
    /**
     * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
     * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
     */ Mesh.prototype._calculateBounds = function() {
        this.calculateVertices();
        this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    };
    /**
     * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
     *
     * @param point - The point to test.
     * @return - The result of the test.
     */ Mesh.prototype.containsPoint = function(point) {
        if (!this.getBounds().contains(point.x, point.y)) return false;
        this.worldTransform.applyInverse(point, $733f620544d369b5$var$tempPoint);
        var vertices = this.geometry.getBuffer('aVertexPosition').data;
        var points = $733f620544d369b5$var$tempPolygon.points;
        var indices = this.geometry.getIndex().data;
        var len = indices.length;
        var step = this.drawMode === 4 ? 3 : 1;
        for(var i = 0; i + 2 < len; i += step){
            var ind0 = indices[i] * 2;
            var ind1 = indices[i + 1] * 2;
            var ind2 = indices[i + 2] * 2;
            points[0] = vertices[ind0];
            points[1] = vertices[ind0 + 1];
            points[2] = vertices[ind1];
            points[3] = vertices[ind1 + 1];
            points[4] = vertices[ind2];
            points[5] = vertices[ind2 + 1];
            if ($733f620544d369b5$var$tempPolygon.contains($733f620544d369b5$var$tempPoint.x, $733f620544d369b5$var$tempPoint.y)) return true;
        }
        return false;
    };
    Mesh.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        if (this._cachedTexture) {
            this._cachedTexture.destroy();
            this._cachedTexture = null;
        }
        this.geometry = null;
        this.shader = null;
        this.state = null;
        this.uvs = null;
        this.indices = null;
        this.vertexData = null;
    };
    /**
     * The maximum number of vertices to consider batchable. Generally, the complexity
     * of the geometry.
     */ Mesh.BATCHABLE_SIZE = 100;
    return Mesh;
}((0, $8t5Gy.Container));
var $733f620544d369b5$var$fragment = "varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n";
var $733f620544d369b5$var$vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTextureMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\n}\n";
/**
 * Slightly opinionated default shader for PixiJS 2D objects.
 * @class
 * @memberof PIXI
 * @extends PIXI.Shader
 */ var $733f620544d369b5$export$d552dadfd66cc650 = /** @class */ function(_super) {
    $733f620544d369b5$var$__extends(MeshMaterial, _super);
    /**
     * @param {PIXI.Texture} uSampler - Texture that material uses to render.
     * @param {object} [options] - Additional options
     * @param {number} [options.alpha=1] - Default alpha.
     * @param {number} [options.tint=0xFFFFFF] - Default tint.
     * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
     * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
     * @param {object} [options.uniforms] - Custom uniforms.
     */ function MeshMaterial(uSampler, options) {
        var _this = this;
        var uniforms = {
            uSampler: uSampler,
            alpha: 1,
            uTextureMatrix: (0, $6qzqq.Matrix).IDENTITY,
            uColor: new Float32Array([
                1,
                1,
                1,
                1
            ])
        };
        // Set defaults
        options = Object.assign({
            tint: 0xFFFFFF,
            alpha: 1,
            pluginName: 'batch'
        }, options);
        if (options.uniforms) Object.assign(uniforms, options.uniforms);
        _this = _super.call(this, options.program || (0, $klOfb.Program).from($733f620544d369b5$var$vertex, $733f620544d369b5$var$fragment), uniforms) || this;
        /**
         * Only do update if tint or alpha changes.
         * @member {boolean}
         * @private
         * @default false
         */ _this._colorDirty = false;
        /**
         * TextureMatrix instance for this Mesh, used to track Texture changes
         *
         * @member {PIXI.TextureMatrix}
         * @readonly
         */ _this.uvMatrix = new (0, $klOfb.TextureMatrix)(uSampler);
        /**
         * `true` if shader can be batch with the renderer's batch system.
         * @member {boolean}
         * @default true
         */ _this.batchable = options.program === undefined;
        /**
         * Renderer plugin for batching
         *
         * @member {string}
         * @default 'batch'
         */ _this.pluginName = options.pluginName;
        _this.tint = options.tint;
        _this.alpha = options.alpha;
        return _this;
    }
    Object.defineProperty(MeshMaterial.prototype, "texture", {
        /**
         * Reference to the texture being rendered.
         * @member {PIXI.Texture}
         */ get: function() {
            return this.uniforms.uSampler;
        },
        set: function(value) {
            if (this.uniforms.uSampler !== value) {
                this.uniforms.uSampler = value;
                this.uvMatrix.texture = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeshMaterial.prototype, "alpha", {
        get: function() {
            return this._alpha;
        },
        /**
         * This gets automatically set by the object using this.
         *
         * @default 1
         * @member {number}
         */ set: function(value) {
            if (value === this._alpha) return;
            this._alpha = value;
            this._colorDirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeshMaterial.prototype, "tint", {
        get: function() {
            return this._tint;
        },
        /**
         * Multiply tint for the material.
         * @member {number}
         * @default 0xFFFFFF
         */ set: function(value) {
            if (value === this._tint) return;
            this._tint = value;
            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
            this._colorDirty = true;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets called automatically by the Mesh. Intended to be overridden for custom
     * MeshMaterial objects.
     */ MeshMaterial.prototype.update = function() {
        if (this._colorDirty) {
            this._colorDirty = false;
            var baseTexture = this.texture.baseTexture;
            (0, $csytw.premultiplyTintToRgba)(this._tint, this._alpha, this.uniforms.uColor, baseTexture.alphaMode);
        }
        if (this.uvMatrix.update()) this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord;
    };
    return MeshMaterial;
}((0, $klOfb.Shader));
/**
 * Standard 2D geometry used in PixiJS.
 *
 * Geometry can be defined without passing in a style or data if required.
 *
 * ```js
 * const geometry = new PIXI.Geometry();
 *
 * geometry.addAttribute('positions', [0, 0, 100, 0, 100, 100, 0, 100], 2);
 * geometry.addAttribute('uvs', [0,0,1,0,1,1,0,1], 2);
 * geometry.addIndex([0,1,2,1,3,2]);
 *
 * ```
 * @class
 * @memberof PIXI
 * @extends PIXI.Geometry
 */ var $733f620544d369b5$export$8d075a36a73d54bc = /** @class */ function(_super) {
    $733f620544d369b5$var$__extends(MeshGeometry, _super);
    /**
     * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
     * @param {Float32Array|number[]} [uvs] - Texture UVs.
     * @param {Uint16Array|number[]} [index] - IndexBuffer
     */ function MeshGeometry(vertices, uvs, index) {
        var _this = _super.call(this) || this;
        var verticesBuffer = new (0, $klOfb.Buffer)(vertices);
        var uvsBuffer = new (0, $klOfb.Buffer)(uvs, true);
        var indexBuffer = new (0, $klOfb.Buffer)(index, true, true);
        _this.addAttribute('aVertexPosition', verticesBuffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addAttribute('aTextureCoord', uvsBuffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addIndex(indexBuffer);
        /**
         * Dirty flag to limit update calls on Mesh. For example,
         * limiting updates on a single Mesh instance with a shared Geometry
         * within the render loop.
         * @private
         * @member {number}
         * @default -1
         */ _this._updateId = -1;
        return _this;
    }
    Object.defineProperty(MeshGeometry.prototype, "vertexDirtyId", {
        /**
         * If the vertex position is updated.
         * @member {number}
         * @readonly
         * @private
         */ get: function() {
            return this.buffers[0]._updateID;
        },
        enumerable: false,
        configurable: true
    });
    return MeshGeometry;
}((0, $klOfb.Geometry));

});


parcelRegister("9RO7y", function(module, exports) {

$parcel$export(module.exports, "AlphaFilter", function () { return $72eff13dea783257$export$adbaa0de008b0d7a; });
/*!
 * @pixi/filter-alpha - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-alpha is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $72eff13dea783257$var$extendStatics = function(d, b) {
    $72eff13dea783257$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $72eff13dea783257$var$extendStatics(d, b);
};
function $72eff13dea783257$var$__extends(d, b) {
    $72eff13dea783257$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $72eff13dea783257$var$fragment = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n";
/**
 * Simplest filter - applies alpha.
 *
 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
 * If elements are not opaque, they will blend with each other anyway.
 *
 * Very handy if you want to use common features of all filters:
 *
 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
 *
 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
 *
 * @memberof PIXI.filters
 */ var $72eff13dea783257$export$adbaa0de008b0d7a = /** @class */ function(_super) {
    $72eff13dea783257$var$__extends(AlphaFilter, _super);
    /**
     * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
     */ function AlphaFilter(alpha) {
        if (alpha === void 0) alpha = 1.0;
        var _this = _super.call(this, (0, $klOfb.defaultVertex), $72eff13dea783257$var$fragment, {
            uAlpha: 1
        }) || this;
        _this.alpha = alpha;
        return _this;
    }
    Object.defineProperty(AlphaFilter.prototype, "alpha", {
        /**
         * Coefficient for alpha multiplication
         *
         * @default 1
         */ get: function() {
            return this.uniforms.uAlpha;
        },
        set: function(value) {
            this.uniforms.uAlpha = value;
        },
        enumerable: false,
        configurable: true
    });
    return AlphaFilter;
}((0, $klOfb.Filter));

});

parcelRegister("1vBjL", function(module, exports) {

$parcel$export(module.exports, "BlurFilterPass", function () { return $1195a23c10b8e0b1$export$b100a8e8116621cf; });
$parcel$export(module.exports, "BlurFilter", function () { return $1195a23c10b8e0b1$export$424348d09d827f49; });
/*!
 * @pixi/filter-blur - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $ezJmd = parcelRequire("ezJmd");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $1195a23c10b8e0b1$var$extendStatics = function(d, b) {
    $1195a23c10b8e0b1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1195a23c10b8e0b1$var$extendStatics(d, b);
};
function $1195a23c10b8e0b1$var$__extends(d, b) {
    $1195a23c10b8e0b1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1195a23c10b8e0b1$var$vertTemplate = "\n    attribute vec2 aVertexPosition;\n\n    uniform mat3 projectionMatrix;\n\n    uniform float strength;\n\n    varying vec2 vBlurTexCoords[%size%];\n\n    uniform vec4 inputSize;\n    uniform vec4 outputFrame;\n\n    vec4 filterVertexPosition( void )\n    {\n        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n    }\n\n    vec2 filterTextureCoord( void )\n    {\n        return aVertexPosition * (outputFrame.zw * inputSize.zw);\n    }\n\n    void main(void)\n    {\n        gl_Position = filterVertexPosition();\n\n        vec2 textureCoord = filterTextureCoord();\n        %blur%\n    }";
function $1195a23c10b8e0b1$var$generateBlurVertSource(kernelSize, x) {
    var halfLength = Math.ceil(kernelSize / 2);
    var vertSource = $1195a23c10b8e0b1$var$vertTemplate;
    var blurLoop = '';
    var template;
    if (x) template = 'vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);';
    else template = 'vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);';
    for(var i = 0; i < kernelSize; i++){
        var blur = template.replace('%index%', i.toString());
        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + ".0");
        blurLoop += blur;
        blurLoop += '\n';
    }
    vertSource = vertSource.replace('%blur%', blurLoop);
    vertSource = vertSource.replace('%size%', kernelSize.toString());
    return vertSource;
}
var $1195a23c10b8e0b1$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        0.0093,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        0.002406,
        0.009255,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        0.000489,
        0.002403,
        0.009246,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
};
var $1195a23c10b8e0b1$var$fragTemplate = [
    'varying vec2 vBlurTexCoords[%size%];',
    'uniform sampler2D uSampler;',
    'void main(void)',
    '{',
    '    gl_FragColor = vec4(0.0);',
    '    %blur%',
    '}'
].join('\n');
function $1195a23c10b8e0b1$var$generateBlurFragSource(kernelSize) {
    var kernel = $1195a23c10b8e0b1$var$GAUSSIAN_VALUES[kernelSize];
    var halfLength = kernel.length;
    var fragSource = $1195a23c10b8e0b1$var$fragTemplate;
    var blurLoop = '';
    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
    var value;
    for(var i = 0; i < kernelSize; i++){
        var blur = template.replace('%index%', i.toString());
        value = i;
        if (i >= halfLength) value = kernelSize - i - 1;
        blur = blur.replace('%value%', kernel[value].toString());
        blurLoop += blur;
        blurLoop += '\n';
    }
    fragSource = fragSource.replace('%blur%', blurLoop);
    fragSource = fragSource.replace('%size%', kernelSize.toString());
    return fragSource;
}
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $1195a23c10b8e0b1$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($1195a23c10b8e0b1$var$ENV || ($1195a23c10b8e0b1$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $1195a23c10b8e0b1$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($1195a23c10b8e0b1$var$RENDERER_TYPE || ($1195a23c10b8e0b1$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $1195a23c10b8e0b1$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($1195a23c10b8e0b1$var$BUFFER_BITS || ($1195a23c10b8e0b1$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $1195a23c10b8e0b1$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($1195a23c10b8e0b1$var$BLEND_MODES || ($1195a23c10b8e0b1$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $1195a23c10b8e0b1$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($1195a23c10b8e0b1$var$DRAW_MODES || ($1195a23c10b8e0b1$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $1195a23c10b8e0b1$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($1195a23c10b8e0b1$var$FORMATS || ($1195a23c10b8e0b1$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $1195a23c10b8e0b1$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($1195a23c10b8e0b1$var$TARGETS || ($1195a23c10b8e0b1$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $1195a23c10b8e0b1$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($1195a23c10b8e0b1$var$TYPES || ($1195a23c10b8e0b1$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $1195a23c10b8e0b1$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($1195a23c10b8e0b1$var$SAMPLER_TYPES || ($1195a23c10b8e0b1$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $1195a23c10b8e0b1$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($1195a23c10b8e0b1$var$SCALE_MODES || ($1195a23c10b8e0b1$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $1195a23c10b8e0b1$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($1195a23c10b8e0b1$var$WRAP_MODES || ($1195a23c10b8e0b1$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $1195a23c10b8e0b1$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($1195a23c10b8e0b1$var$MIPMAP_MODES || ($1195a23c10b8e0b1$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $1195a23c10b8e0b1$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($1195a23c10b8e0b1$var$ALPHA_MODES || ($1195a23c10b8e0b1$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $1195a23c10b8e0b1$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($1195a23c10b8e0b1$var$CLEAR_MODES || ($1195a23c10b8e0b1$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $1195a23c10b8e0b1$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($1195a23c10b8e0b1$var$GC_MODES || ($1195a23c10b8e0b1$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $1195a23c10b8e0b1$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($1195a23c10b8e0b1$var$PRECISION || ($1195a23c10b8e0b1$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $1195a23c10b8e0b1$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($1195a23c10b8e0b1$var$MASK_TYPES || ($1195a23c10b8e0b1$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $1195a23c10b8e0b1$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($1195a23c10b8e0b1$var$MSAA_QUALITY || ($1195a23c10b8e0b1$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $1195a23c10b8e0b1$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($1195a23c10b8e0b1$var$BUFFER_TYPE || ($1195a23c10b8e0b1$var$BUFFER_TYPE = {}));
/**
 * The BlurFilterPass applies a horizontal or vertical Gaussian blur to an object.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */ var $1195a23c10b8e0b1$export$b100a8e8116621cf = /** @class */ function(_super) {
    $1195a23c10b8e0b1$var$__extends(BlurFilterPass, _super);
    /**
     * @param {boolean} horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
     * @param {number} [strength=8] - The strength of the blur filter.
     * @param {number} [quality=4] - The quality of the blur filter.
     * @param {number} [resolution=PIXI.settings.FILTER_RESOLUTION] - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */ function BlurFilterPass(horizontal, strength, quality, resolution, kernelSize) {
        if (strength === void 0) strength = 8;
        if (quality === void 0) quality = 4;
        if (resolution === void 0) resolution = (0, $ezJmd.settings).FILTER_RESOLUTION;
        if (kernelSize === void 0) kernelSize = 5;
        var _this = this;
        var vertSrc = $1195a23c10b8e0b1$var$generateBlurVertSource(kernelSize, horizontal);
        var fragSrc = $1195a23c10b8e0b1$var$generateBlurFragSource(kernelSize);
        _this = _super.call(this, // vertex shader
        vertSrc, // fragment shader
        fragSrc) || this;
        _this.horizontal = horizontal;
        _this.resolution = resolution;
        _this._quality = 0;
        _this.quality = quality;
        _this.blur = strength;
        return _this;
    }
    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterSystem} filterManager - The manager.
     * @param {PIXI.RenderTexture} input - The input target.
     * @param {PIXI.RenderTexture} output - The output target.
     * @param {PIXI.CLEAR_MODES} clearMode - How to clear
     */ BlurFilterPass.prototype.apply = function(filterManager, input, output, clearMode) {
        if (output) {
            if (this.horizontal) this.uniforms.strength = 1 / output.width * (output.width / input.width);
            else this.uniforms.strength = 1 / output.height * (output.height / input.height);
        } else if (this.horizontal) this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width);
        else this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height); // eslint-disable-line
        // screen space!
        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes;
        if (this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            var renderTarget = filterManager.getFilterTexture();
            var renderer = filterManager.renderer;
            var flip = input;
            var flop = renderTarget;
            this.state.blend = false;
            filterManager.applyFilter(this, flip, flop, $1195a23c10b8e0b1$var$CLEAR_MODES.CLEAR);
            for(var i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, $1195a23c10b8e0b1$var$CLEAR_MODES.BLIT);
                this.uniforms.uSampler = flop;
                var temp = flop;
                flop = flip;
                flip = temp;
                renderer.shader.bind(this);
                renderer.geometry.draw(5);
            }
            this.state.blend = true;
            filterManager.applyFilter(this, flop, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        }
    };
    Object.defineProperty(BlurFilterPass.prototype, "blur", {
        /**
         * Sets the strength of both the blur.
         *
         * @member {number}
         * @default 16
         */ get: function() {
            return this.strength;
        },
        set: function(value) {
            this.padding = 1 + Math.abs(value) * 2;
            this.strength = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilterPass.prototype, "quality", {
        /**
         * Sets the quality of the blur by modifying the number of passes. More passes means higher
         * quality bluring but the lower the performance.
         *
         * @member {number}
         * @default 4
         */ get: function() {
            return this._quality;
        },
        set: function(value) {
            this._quality = value;
            this.passes = value;
        },
        enumerable: false,
        configurable: true
    });
    return BlurFilterPass;
}((0, $klOfb.Filter));
/**
 * The BlurFilter applies a Gaussian blur to an object.
 *
 * The strength of the blur can be set for the x-axis and y-axis separately.
 *
 * @memberof PIXI.filters
 */ var $1195a23c10b8e0b1$export$424348d09d827f49 = /** @class */ function(_super) {
    $1195a23c10b8e0b1$var$__extends(BlurFilter, _super);
    /**
     * @param strength - The strength of the blur filter.
     * @param quality - The quality of the blur filter.
     * @param [resolution=PIXI.settings.FILTER_RESOLUTION] - The resolution of the blur filter.
     * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */ function BlurFilter(strength, quality, resolution, kernelSize) {
        if (strength === void 0) strength = 8;
        if (quality === void 0) quality = 4;
        if (resolution === void 0) resolution = (0, $ezJmd.settings).FILTER_RESOLUTION;
        if (kernelSize === void 0) kernelSize = 5;
        var _this = _super.call(this) || this;
        _this.blurXFilter = new $1195a23c10b8e0b1$export$b100a8e8116621cf(true, strength, quality, resolution, kernelSize);
        _this.blurYFilter = new $1195a23c10b8e0b1$export$b100a8e8116621cf(false, strength, quality, resolution, kernelSize);
        _this.resolution = resolution;
        _this.quality = quality;
        _this.blur = strength;
        _this.repeatEdgePixels = false;
        return _this;
    }
    /**
     * Applies the filter.
     *
     * @param filterManager - The manager.
     * @param input - The input target.
     * @param output - The output target.
     * @param clearMode - How to clear
     */ BlurFilter.prototype.apply = function(filterManager, input, output, clearMode) {
        var xStrength = Math.abs(this.blurXFilter.strength);
        var yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            var renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, $1195a23c10b8e0b1$var$CLEAR_MODES.CLEAR);
            this.blurYFilter.apply(filterManager, renderTarget, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        } else if (yStrength) this.blurYFilter.apply(filterManager, input, output, clearMode);
        else this.blurXFilter.apply(filterManager, input, output, clearMode);
    };
    BlurFilter.prototype.updatePadding = function() {
        if (this._repeatEdgePixels) this.padding = 0;
        else this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    };
    Object.defineProperty(BlurFilter.prototype, "blur", {
        /**
         * Sets the strength of both the blurX and blurY properties simultaneously
         *
         * @default 2
         */ get: function() {
            return this.blurXFilter.blur;
        },
        set: function(value) {
            this.blurXFilter.blur = this.blurYFilter.blur = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "quality", {
        /**
         * Sets the number of passes for blur. More passes means higher quality bluring.
         *
         * @default 1
         */ get: function() {
            return this.blurXFilter.quality;
        },
        set: function(value) {
            this.blurXFilter.quality = this.blurYFilter.quality = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blurX", {
        /**
         * Sets the strength of the blurX property
         *
         * @default 2
         */ get: function() {
            return this.blurXFilter.blur;
        },
        set: function(value) {
            this.blurXFilter.blur = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blurY", {
        /**
         * Sets the strength of the blurY property
         *
         * @default 2
         */ get: function() {
            return this.blurYFilter.blur;
        },
        set: function(value) {
            this.blurYFilter.blur = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blendMode", {
        /**
         * Sets the blendmode of the filter
         *
         * @default PIXI.BLEND_MODES.NORMAL
         */ get: function() {
            return this.blurYFilter.blendMode;
        },
        set: function(value) {
            this.blurYFilter.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "repeatEdgePixels", {
        /**
         * If set to true the edge of the target will be clamped
         *
         * @default false
         */ get: function() {
            return this._repeatEdgePixels;
        },
        set: function(value) {
            this._repeatEdgePixels = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    return BlurFilter;
}((0, $klOfb.Filter));

});

parcelRegister("aPxof", function(module, exports) {

$parcel$export(module.exports, "ColorMatrixFilter", function () { return $7e28916011673245$export$6547db23997fcec5; });
/*!
 * @pixi/filter-color-matrix - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-color-matrix is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $7e28916011673245$var$extendStatics = function(d, b) {
    $7e28916011673245$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7e28916011673245$var$extendStatics(d, b);
};
function $7e28916011673245$var$__extends(d, b) {
    $7e28916011673245$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7e28916011673245$var$fragment = "varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n";
/**
 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
 * color and alpha values of every pixel on your displayObject to produce a result
 * with a new set of RGBA color and alpha values. It's pretty powerful!
 *
 * ```js
 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
 *  container.filters = [colorMatrix];
 *  colorMatrix.contrast(2);
 * ```
 * @author Clément Chenebault <clement@goodboydigital.com>
 * @memberof PIXI.filters
 */ var $7e28916011673245$export$6547db23997fcec5 = /** @class */ function(_super) {
    $7e28916011673245$var$__extends(ColorMatrixFilter, _super);
    function ColorMatrixFilter() {
        var _this = this;
        var uniforms = {
            m: new Float32Array([
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]),
            uAlpha: 1
        };
        _this = _super.call(this, (0, $klOfb.defaultFilterVertex), $7e28916011673245$var$fragment, uniforms) || this;
        _this.alpha = 1;
        return _this;
    }
    /**
     * Transforms current matrix and set the new one
     *
     * @param {number[]} matrix - 5x4 matrix
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype._loadMatrix = function(matrix, multiply) {
        if (multiply === void 0) multiply = false;
        var newMatrix = matrix;
        if (multiply) {
            this._multiply(newMatrix, this.uniforms.m, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }
        // set the new matrix
        this.uniforms.m = newMatrix;
    };
    /**
     * Multiplies two mat5's
     *
     * @private
     * @param out - 5x4 matrix the receiving matrix
     * @param a - 5x4 matrix the first operand
     * @param b - 5x4 matrix the second operand
     * @returns {number[]} 5x4 matrix
     */ ColorMatrixFilter.prototype._multiply = function(out, a, b) {
        // Red Channel
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
        // Green Channel
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
        // Blue Channel
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
        // Alpha Channel
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
        return out;
    };
    /**
     * Create a Float32 Array and normalize the offset component to 0-1
     *
     * @param {number[]} matrix - 5x4 matrix
     * @return {number[]} 5x4 matrix with all values between 0-1
     */ ColorMatrixFilter.prototype._colorMatrix = function(matrix) {
        // Create a Float32 Array and normalize the offset component to 0-1
        var m = new Float32Array(matrix);
        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;
        return m;
    };
    /**
     * Adjusts brightness
     *
     * @param b - value of the brigthness (0-1, where 0 is black)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.brightness = function(b, multiply) {
        var matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Sets each channel on the diagonal of the color matrix.
     * This can be used to achieve a tinting effect on Containers similar to the tint field of some
     * display objects like Sprite, Text, Graphics, and Mesh.
     *
     * @param color - Color of the tint. This is a hex value.
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.tint = function(color, multiply) {
        var r = color >> 16 & 0xff;
        var g = color >> 8 & 0xff;
        var b = color & 0xff;
        var matrix = [
            r / 255,
            0,
            0,
            0,
            0,
            0,
            g / 255,
            0,
            0,
            0,
            0,
            0,
            b / 255,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the matrices in grey scales
     *
     * @param scale - value of the grey (0-1, where 0 is black)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.greyscale = function(scale, multiply) {
        var matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the black and white matrice.
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.blackAndWhite = function(multiply) {
        var matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the hue property of the color
     *
     * @param rotation - in degrees
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.hue = function(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        var cosR = Math.cos(rotation);
        var sinR = Math.sin(rotation);
        var sqrt = Math.sqrt;
        /* a good approximation for hue rotation
         This matrix is far better than the versions with magic luminance constants
         formerly used here, but also used in the starling framework (flash) and known from this
         old part of the internet: quasimondo.com/archives/000565.php

         This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
         implementation as a shader not a general matrix:
         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js

         This is the source for the code:
         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
         */ var w = 1 / 3;
        var sqrW = sqrt(w); // weight is
        var a00 = cosR + (1.0 - cosR) * w;
        var a01 = w * (1.0 - cosR) - sqrW * sinR;
        var a02 = w * (1.0 - cosR) + sqrW * sinR;
        var a10 = w * (1.0 - cosR) + sqrW * sinR;
        var a11 = cosR + w * (1.0 - cosR);
        var a12 = w * (1.0 - cosR) - sqrW * sinR;
        var a20 = w * (1.0 - cosR) - sqrW * sinR;
        var a21 = w * (1.0 - cosR) + sqrW * sinR;
        var a22 = cosR + w * (1.0 - cosR);
        var matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the contrast matrix, increase the separation between dark and bright
     * Increase contrast : shadows darker and highlights brighter
     * Decrease contrast : bring the shadows up and the highlights down
     *
     * @param amount - value of the contrast (0-1)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.contrast = function(amount, multiply) {
        var v = (amount || 0) + 1;
        var o = -0.5 * (v - 1);
        var matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the saturation matrix, increase the separation between colors
     * Increase saturation : increase contrast, brightness, and sharpness
     *
     * @param amount - The saturation amount (0-1)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.saturate = function(amount, multiply) {
        if (amount === void 0) amount = 0;
        var x = amount * 2 / 3 + 1;
        var y = (x - 1) * -0.5;
        var matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Desaturate image (remove color)
     *
     * Call the saturate function
     */ ColorMatrixFilter.prototype.desaturate = function() {
        this.saturate(-1);
    };
    /**
     * Negative image (inverse of classic rgb matrix)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.negative = function(multiply) {
        var matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Sepia image
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.sepia = function(multiply) {
        var matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.technicolor = function(multiply) {
        var matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Polaroid filter
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.polaroid = function(multiply) {
        var matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Filter who transforms : Red -> Blue and Blue -> Red
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.toBGR = function(multiply) {
        var matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.kodachrome = function(multiply) {
        var matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Brown delicious browni filter (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.browni = function(multiply) {
        var matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Vintage filter (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.vintage = function(multiply) {
        var matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * We don't know exactly what it does, kind of gradient map, but funny to play with!
     *
     * @param desaturation - Tone values.
     * @param toned - Tone values.
     * @param lightColor - Tone values, example: `0xFFE580`
     * @param darkColor - Tone values, example: `0xFFE580`
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.colorTone = function(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2;
        toned = toned || 0.15;
        lightColor = lightColor || 0xFFE580;
        darkColor = darkColor || 0x338000;
        var lR = (lightColor >> 16 & 0xFF) / 255;
        var lG = (lightColor >> 8 & 0xFF) / 255;
        var lB = (lightColor & 0xFF) / 255;
        var dR = (darkColor >> 16 & 0xFF) / 255;
        var dG = (darkColor >> 8 & 0xFF) / 255;
        var dB = (darkColor & 0xFF) / 255;
        var matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Night effect
     *
     * @param intensity - The intensity of the night effect.
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.night = function(intensity, multiply) {
        intensity = intensity || 0.1;
        var matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2.0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Predator effect
     *
     * Erase the current matrix by setting a new indepent one
     *
     * @param amount - how much the predator feels his future victim
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.predator = function(amount, multiply) {
        var matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * LSD effect
     *
     * Multiply the current matrix
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.lsd = function(multiply) {
        var matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /** Erase the current matrix by setting the default one. */ ColorMatrixFilter.prototype.reset = function() {
        var matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, false);
    };
    Object.defineProperty(ColorMatrixFilter.prototype, "matrix", {
        /**
         * The matrix of the color matrix filter
         *
         * @member {number[]}
         * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
         */ get: function() {
            return this.uniforms.m;
        },
        set: function(value) {
            this.uniforms.m = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "alpha", {
        /**
         * The opacity value to use when mixing the original and resultant colors.
         *
         * When the value is 0, the original color is used without modification.
         * When the value is 1, the result color is used.
         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
         *
         * @default 1
         */ get: function() {
            return this.uniforms.uAlpha;
        },
        set: function(value) {
            this.uniforms.uAlpha = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColorMatrixFilter;
}((0, $klOfb.Filter));
// Americanized alias
$7e28916011673245$export$6547db23997fcec5.prototype.grayscale = $7e28916011673245$export$6547db23997fcec5.prototype.greyscale;

});

parcelRegister("68QeL", function(module, exports) {

$parcel$export(module.exports, "DisplacementFilter", function () { return $478c02a70e37469a$export$8ebf3229158e2895; });
/*!
 * @pixi/filter-displacement - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-displacement is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $478c02a70e37469a$var$extendStatics = function(d, b) {
    $478c02a70e37469a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $478c02a70e37469a$var$extendStatics(d, b);
};
function $478c02a70e37469a$var$__extends(d, b) {
    $478c02a70e37469a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $478c02a70e37469a$var$fragment = "varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\nuniform mat2 rotation;\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform highp vec4 inputSize;\nuniform vec4 inputClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy = scale * inputSize.zw * (rotation * map.xy);\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));\n}\n";
var $478c02a70e37469a$var$vertex = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n\tgl_Position = filterVertexPosition();\n\tvTextureCoord = filterTextureCoord();\n\tvFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;\n}\n";
/**
 * The DisplacementFilter class uses the pixel values from the specified texture
 * (called the displacement map) to perform a displacement of an object.
 *
 * You can use this filter to apply all manor of crazy warping effects.
 * Currently the `r` property of the texture is used to offset the `x`
 * and the `g` property of the texture is used to offset the `y`.
 *
 * The way it works is it uses the values of the displacement map to look up the
 * correct pixels to output. This means it's not technically moving the original.
 * Instead, it's starting at the output and asking "which pixel from the original goes here".
 * For example, if a displacement map pixel has `red = 1` and the filter scale is `20`,
 * this filter will output the pixel approximately 20 pixels to the right of the original.
 *
 * @memberof PIXI.filters
 */ var $478c02a70e37469a$export$8ebf3229158e2895 = /** @class */ function(_super) {
    $478c02a70e37469a$var$__extends(DisplacementFilter, _super);
    /**
     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
     * @param scale - The scale of the displacement
     */ function DisplacementFilter(sprite, scale) {
        var _this = this;
        var maskMatrix = new (0, $6qzqq.Matrix)();
        sprite.renderable = false;
        _this = _super.call(this, $478c02a70e37469a$var$vertex, $478c02a70e37469a$var$fragment, {
            mapSampler: sprite._texture,
            filterMatrix: maskMatrix,
            scale: {
                x: 1,
                y: 1
            },
            rotation: new Float32Array([
                1,
                0,
                0,
                1
            ])
        }) || this;
        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;
        if (scale === null || scale === undefined) scale = 20;
        /**
         * scaleX, scaleY for displacements
         * @member {PIXI.Point}
         */ _this.scale = new (0, $6qzqq.Point)(scale, scale);
        return _this;
    }
    /**
     * Applies the filter.
     *
     * @param filterManager - The manager.
     * @param input - The input target.
     * @param output - The output target.
     * @param clearMode - clearMode.
     */ DisplacementFilter.prototype.apply = function(filterManager, input, output, clearMode) {
        // fill maskMatrix with _normalized sprite texture coords_
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        this.uniforms.scale.x = this.scale.x;
        this.uniforms.scale.y = this.scale.y;
        // Extract rotation from world transform
        var wt = this.maskSprite.worldTransform;
        var lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b);
        var lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        if (lenX !== 0 && lenY !== 0) {
            this.uniforms.rotation[0] = wt.a / lenX;
            this.uniforms.rotation[1] = wt.b / lenX;
            this.uniforms.rotation[2] = wt.c / lenY;
            this.uniforms.rotation[3] = wt.d / lenY;
        }
        // draw the filter...
        filterManager.applyFilter(this, input, output, clearMode);
    };
    Object.defineProperty(DisplacementFilter.prototype, "map", {
        /** The texture used for the displacement map. Must be power of 2 sized texture. */ get: function() {
            return this.uniforms.mapSampler;
        },
        set: function(value) {
            this.uniforms.mapSampler = value;
        },
        enumerable: false,
        configurable: true
    });
    return DisplacementFilter;
}((0, $klOfb.Filter));

});

parcelRegister("a3TLq", function(module, exports) {

$parcel$export(module.exports, "FXAAFilter", function () { return $753570bf0b1e1037$export$86086ddb5389b795; });
/*!
 * @pixi/filter-fxaa - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-fxaa is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $753570bf0b1e1037$var$extendStatics = function(d, b) {
    $753570bf0b1e1037$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $753570bf0b1e1037$var$extendStatics(d, b);
};
function $753570bf0b1e1037$var$__extends(d, b) {
    $753570bf0b1e1037$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $753570bf0b1e1037$var$vertex = "\nattribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvoid texcoords(vec2 fragCoord, vec2 inverseVP,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = filterVertexPosition();\n\n   vFragCoord = aVertexPosition * outputFrame.zw;\n\n   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}\n";
var $753570bf0b1e1037$var$fragment = "varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\nuniform sampler2D uSampler;\nuniform highp vec4 inputSize;\n\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it's\n unsupported by WebGL.\n\n --\n\n From:\n https://github.com/mitsuhiko/webgl-meincraft\n\n Copyright (c) 2011 by Armin Ronacher.\n\n Some rights reserved.\n\n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n\n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n\n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n\n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n\n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n \"AS IS\" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n\n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n\n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n\n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n\n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n\n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec4 color;\n\n      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n";
/**
 * Basic FXAA (Fast Approximate Anti-Aliasing) implementation based on the code on geeks3d.com
 * with the modification that the texture2DLod stuff was removed since it is unsupported by WebGL.
 *
 * @see https://github.com/mitsuhiko/webgl-meincraft
 *
 * @memberof PIXI.filters
 */ var $753570bf0b1e1037$export$86086ddb5389b795 = /** @class */ function(_super) {
    $753570bf0b1e1037$var$__extends(FXAAFilter, _super);
    function FXAAFilter() {
        // TODO - needs work
        return _super.call(this, $753570bf0b1e1037$var$vertex, $753570bf0b1e1037$var$fragment) || this;
    }
    return FXAAFilter;
}((0, $klOfb.Filter));

});

parcelRegister("arZq0", function(module, exports) {

$parcel$export(module.exports, "NoiseFilter", function () { return $79bc116dce27c2f3$export$2d7a5b72233a5183; });
/*!
 * @pixi/filter-noise - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-noise is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $79bc116dce27c2f3$var$extendStatics = function(d, b) {
    $79bc116dce27c2f3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $79bc116dce27c2f3$var$extendStatics(d, b);
};
function $79bc116dce27c2f3$var$__extends(d, b) {
    $79bc116dce27c2f3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $79bc116dce27c2f3$var$fragment = "precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n";
/**
 * A Noise effect filter.
 *
 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
 *
 * @memberof PIXI.filters
 * @author Vico @vicocotea
 */ var $79bc116dce27c2f3$export$2d7a5b72233a5183 = /** @class */ function(_super) {
    $79bc116dce27c2f3$var$__extends(NoiseFilter, _super);
    /**
     * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
     * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
     */ function NoiseFilter(noise, seed) {
        if (noise === void 0) noise = 0.5;
        if (seed === void 0) seed = Math.random();
        var _this = _super.call(this, (0, $klOfb.defaultFilterVertex), $79bc116dce27c2f3$var$fragment, {
            uNoise: 0,
            uSeed: 0
        }) || this;
        _this.noise = noise;
        _this.seed = seed;
        return _this;
    }
    Object.defineProperty(NoiseFilter.prototype, "noise", {
        /**
         * The amount of noise to apply, this value should be in the range (0, 1].
         *
         * @default 0.5
         */ get: function() {
            return this.uniforms.uNoise;
        },
        set: function(value) {
            this.uniforms.uNoise = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoiseFilter.prototype, "seed", {
        /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */ get: function() {
            return this.uniforms.uSeed;
        },
        set: function(value) {
            this.uniforms.uSeed = value;
        },
        enumerable: false,
        configurable: true
    });
    return NoiseFilter;
}((0, $klOfb.Filter));

});

parcelRegister("aqTFY", function(module, exports) {
/*!
 * @pixi/mixin-cache-as-bitmap - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mixin-cache-as-bitmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $8t5Gy = parcelRequire("8t5Gy");

var $6qzqq = parcelRequire("6qzqq");

var $csytw = parcelRequire("csytw");

var $ezJmd = parcelRequire("ezJmd");
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $79878534657a31ab$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($79878534657a31ab$var$ENV || ($79878534657a31ab$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $79878534657a31ab$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($79878534657a31ab$var$RENDERER_TYPE || ($79878534657a31ab$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $79878534657a31ab$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($79878534657a31ab$var$BUFFER_BITS || ($79878534657a31ab$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $79878534657a31ab$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($79878534657a31ab$var$BLEND_MODES || ($79878534657a31ab$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $79878534657a31ab$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($79878534657a31ab$var$DRAW_MODES || ($79878534657a31ab$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $79878534657a31ab$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($79878534657a31ab$var$FORMATS || ($79878534657a31ab$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $79878534657a31ab$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($79878534657a31ab$var$TARGETS || ($79878534657a31ab$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $79878534657a31ab$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($79878534657a31ab$var$TYPES || ($79878534657a31ab$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $79878534657a31ab$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($79878534657a31ab$var$SAMPLER_TYPES || ($79878534657a31ab$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $79878534657a31ab$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($79878534657a31ab$var$SCALE_MODES || ($79878534657a31ab$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $79878534657a31ab$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($79878534657a31ab$var$WRAP_MODES || ($79878534657a31ab$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $79878534657a31ab$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($79878534657a31ab$var$MIPMAP_MODES || ($79878534657a31ab$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $79878534657a31ab$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($79878534657a31ab$var$ALPHA_MODES || ($79878534657a31ab$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $79878534657a31ab$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($79878534657a31ab$var$CLEAR_MODES || ($79878534657a31ab$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $79878534657a31ab$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($79878534657a31ab$var$GC_MODES || ($79878534657a31ab$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $79878534657a31ab$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($79878534657a31ab$var$PRECISION || ($79878534657a31ab$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $79878534657a31ab$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($79878534657a31ab$var$MASK_TYPES || ($79878534657a31ab$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $79878534657a31ab$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($79878534657a31ab$var$MSAA_QUALITY || ($79878534657a31ab$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $79878534657a31ab$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($79878534657a31ab$var$BUFFER_TYPE || ($79878534657a31ab$var$BUFFER_TYPE = {}));
var $79878534657a31ab$var$_tempMatrix = new (0, $6qzqq.Matrix)();
(0, $8t5Gy.DisplayObject).prototype._cacheAsBitmap = false;
(0, $8t5Gy.DisplayObject).prototype._cacheData = null;
(0, $8t5Gy.DisplayObject).prototype._cacheAsBitmapResolution = null;
(0, $8t5Gy.DisplayObject).prototype._cacheAsBitmapMultisample = $79878534657a31ab$var$MSAA_QUALITY.NONE;
// figured there's no point adding ALL the extra variables to prototype.
// this model can hold the information needed. This can also be generated on demand as
// most objects are not cached as bitmaps.
/**
 * @class
 * @ignore
 * @private
 */ var $79878534657a31ab$export$3e19bdfd927f283c = /** @class */ function() {
    function CacheData() {
        this.textureCacheId = null;
        this.originalRender = null;
        this.originalRenderCanvas = null;
        this.originalCalculateBounds = null;
        this.originalGetLocalBounds = null;
        this.originalUpdateTransform = null;
        this.originalDestroy = null;
        this.originalMask = null;
        this.originalFilterArea = null;
        this.originalContainsPoint = null;
        this.sprite = null;
    }
    return CacheData;
}();
Object.defineProperties((0, $8t5Gy.DisplayObject).prototype, {
    /**
     * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
     * but can be overriden for performance. Lower values will reduce memory usage at the expense
     * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
     * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
     *
     * @member {number} cacheAsBitmapResolution
     * @memberof PIXI.DisplayObject#
     * @default null
     */ cacheAsBitmapResolution: {
        get: function() {
            return this._cacheAsBitmapResolution;
        },
        set: function(resolution) {
            if (resolution === this._cacheAsBitmapResolution) return;
            this._cacheAsBitmapResolution = resolution;
            if (this.cacheAsBitmap) {
                // Toggle to re-render at the new resolution
                this.cacheAsBitmap = false;
                this.cacheAsBitmap = true;
            }
        }
    },
    /**
     * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
     * sample count is used.
     * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
     *
     * @member {number} cacheAsBitmapMultisample
     * @memberof PIXI.DisplayObject#
     * @default PIXI.MSAA_QUALITY.NONE
     */ cacheAsBitmapMultisample: {
        get: function() {
            return this._cacheAsBitmapMultisample;
        },
        set: function(multisample) {
            if (multisample === this._cacheAsBitmapMultisample) return;
            this._cacheAsBitmapMultisample = multisample;
            if (this.cacheAsBitmap) {
                // Toggle to re-render with new multisample
                this.cacheAsBitmap = false;
                this.cacheAsBitmap = true;
            }
        }
    },
    /**
     * Set this to true if you want this display object to be cached as a bitmap.
     * This basically takes a snap shot of the display object as it is at that moment. It can
     * provide a performance benefit for complex static displayObjects.
     * To remove simply set this property to `false`
     *
     * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */ cacheAsBitmap: {
        get: function() {
            return this._cacheAsBitmap;
        },
        set: function(value) {
            if (this._cacheAsBitmap === value) return;
            this._cacheAsBitmap = value;
            var data;
            if (value) {
                if (!this._cacheData) this._cacheData = new $79878534657a31ab$export$3e19bdfd927f283c();
                data = this._cacheData;
                data.originalRender = this.render;
                data.originalRenderCanvas = this.renderCanvas;
                data.originalUpdateTransform = this.updateTransform;
                data.originalCalculateBounds = this.calculateBounds;
                data.originalGetLocalBounds = this.getLocalBounds;
                data.originalDestroy = this.destroy;
                data.originalContainsPoint = this.containsPoint;
                data.originalMask = this._mask;
                data.originalFilterArea = this.filterArea;
                this.render = this._renderCached;
                this.renderCanvas = this._renderCachedCanvas;
                this.destroy = this._cacheAsBitmapDestroy;
            } else {
                data = this._cacheData;
                if (data.sprite) this._destroyCachedDisplayObject();
                this.render = data.originalRender;
                this.renderCanvas = data.originalRenderCanvas;
                this.calculateBounds = data.originalCalculateBounds;
                this.getLocalBounds = data.originalGetLocalBounds;
                this.destroy = data.originalDestroy;
                this.updateTransform = data.originalUpdateTransform;
                this.containsPoint = data.originalContainsPoint;
                this._mask = data.originalMask;
                this.filterArea = data.originalFilterArea;
            }
        }
    }
});
/**
 * Renders a cached version of the sprite with WebGL
 *
 * @private
 * @method _renderCached
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.Renderer} renderer - the WebGL renderer
 */ (0, $8t5Gy.DisplayObject).prototype._renderCached = function _renderCached(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
    this._initCachedDisplayObject(renderer);
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._render(renderer);
};
/**
 * Prepares the WebGL renderer to cache the sprite
 *
 * @private
 * @method _initCachedDisplayObject
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.Renderer} renderer - the WebGL renderer
 */ (0, $8t5Gy.DisplayObject).prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
    var _a;
    if (this._cacheData && this._cacheData.sprite) return;
    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
    var cacheAlpha = this.alpha;
    this.alpha = 1;
    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
    renderer.batch.flush();
    // this.filters= [];
    // next we find the dimensions of the untransformed object
    // this function also calls updatetransform on all its children as part of the measuring.
    // This means we don't need to update the transform again in this function
    // TODO pass an object to clone too? saves having to create a new one each time!
    var bounds = this.getLocalBounds(null, true).clone();
    // add some padding!
    if (this.filters && this.filters.length) {
        var padding = this.filters[0].padding;
        bounds.pad(padding);
    }
    bounds.ceil((0, $ezJmd.settings).RESOLUTION);
    // for now we cache the current renderTarget that the WebGL renderer is currently using.
    // this could be more elegant..
    var cachedRenderTexture = renderer.renderTexture.current;
    var cachedSourceFrame = renderer.renderTexture.sourceFrame.clone();
    var cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone();
    var cachedProjectionTransform = renderer.projection.transform;
    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
    // const stack = renderer.filterManager.filterStack;
    // this renderTexture will be used to store the cached DisplayObject
    var renderTexture = (0, $klOfb.RenderTexture).create({
        width: bounds.width,
        height: bounds.height,
        resolution: this.cacheAsBitmapResolution || renderer.resolution,
        multisample: (_a = this.cacheAsBitmapMultisample) !== null && _a !== void 0 ? _a : renderer.multisample
    });
    var textureCacheId = "cacheAsBitmap_" + (0, $csytw.uid)();
    this._cacheData.textureCacheId = textureCacheId;
    (0, $klOfb.BaseTexture).addToCache(renderTexture.baseTexture, textureCacheId);
    (0, $klOfb.Texture).addToCache(renderTexture, textureCacheId);
    // need to set //
    var m = this.transform.localTransform.copyTo($79878534657a31ab$var$_tempMatrix).invert().translate(-bounds.x, -bounds.y);
    // set all properties to there original so we can render to a texture
    this.render = this._cacheData.originalRender;
    renderer.render(this, {
        renderTexture: renderTexture,
        clear: true,
        transform: m,
        skipUpdateTransform: false
    });
    renderer.framebuffer.blit();
    // now restore the state be setting the new properties
    renderer.projection.transform = cachedProjectionTransform;
    renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame);
    // renderer.filterManager.filterStack = stack;
    this.render = this._renderCached;
    // the rest is the same as for Canvas
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;
    this._mask = null;
    this.filterArea = null;
    this.alpha = cacheAlpha;
    // create our cached sprite
    var cachedSprite = new (0, $7Bs2Z.Sprite)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;
    this._cacheData.sprite = cachedSprite;
    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.enableTempParent();
        this.updateTransform();
        this.disableTempParent(null);
    } else this.updateTransform();
    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
/**
 * Renders a cached version of the sprite with canvas
 *
 * @private
 * @method _renderCachedCanvas
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
 */ (0, $8t5Gy.DisplayObject).prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
    this._initCachedDisplayObjectCanvas(renderer);
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderCanvas(renderer);
};
// TODO this can be the same as the WebGL version.. will need to do a little tweaking first though..
/**
 * Prepares the Canvas renderer to cache the sprite
 *
 * @private
 * @method _initCachedDisplayObjectCanvas
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
 */ (0, $8t5Gy.DisplayObject).prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
    if (this._cacheData && this._cacheData.sprite) return;
    // get bounds actually transforms the object for us already!
    var bounds = this.getLocalBounds(null, true);
    var cacheAlpha = this.alpha;
    this.alpha = 1;
    var cachedRenderTarget = renderer.context;
    var cachedProjectionTransform = renderer._projTransform;
    bounds.ceil((0, $ezJmd.settings).RESOLUTION);
    var renderTexture = (0, $klOfb.RenderTexture).create({
        width: bounds.width,
        height: bounds.height
    });
    var textureCacheId = "cacheAsBitmap_" + (0, $csytw.uid)();
    this._cacheData.textureCacheId = textureCacheId;
    (0, $klOfb.BaseTexture).addToCache(renderTexture.baseTexture, textureCacheId);
    (0, $klOfb.Texture).addToCache(renderTexture, textureCacheId);
    // need to set //
    var m = $79878534657a31ab$var$_tempMatrix;
    this.transform.localTransform.copyTo(m);
    m.invert();
    m.tx -= bounds.x;
    m.ty -= bounds.y;
    // m.append(this.transform.worldTransform.)
    // set all properties to there original so we can render to a texture
    this.renderCanvas = this._cacheData.originalRenderCanvas;
    renderer.render(this, {
        renderTexture: renderTexture,
        clear: true,
        transform: m,
        skipUpdateTransform: false
    });
    // now restore the state be setting the new properties
    renderer.context = cachedRenderTarget;
    renderer._projTransform = cachedProjectionTransform;
    this.renderCanvas = this._renderCachedCanvas;
    // the rest is the same as for WebGL
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;
    this._mask = null;
    this.filterArea = null;
    this.alpha = cacheAlpha;
    // create our cached sprite
    var cachedSprite = new (0, $7Bs2Z.Sprite)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;
    this._cacheData.sprite = cachedSprite;
    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else this.updateTransform();
    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
/**
 * Calculates the bounds of the cached sprite
 *
 * @private
 * @method
 */ (0, $8t5Gy.DisplayObject).prototype._calculateCachedBounds = function _calculateCachedBounds() {
    this._bounds.clear();
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite._calculateBounds();
    this._bounds.updateID = this._boundsID;
};
/**
 * Gets the bounds of the cached sprite.
 *
 * @private
 * @method
 * @return {Rectangle} The local bounds.
 */ (0, $8t5Gy.DisplayObject).prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
    return this._cacheData.sprite.getLocalBounds(null);
};
/**
 * Destroys the cached sprite.
 *
 * @private
 * @method
 */ (0, $8t5Gy.DisplayObject).prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
    this._cacheData.sprite._texture.destroy(true);
    this._cacheData.sprite = null;
    (0, $klOfb.BaseTexture).removeFromCache(this._cacheData.textureCacheId);
    (0, $klOfb.Texture).removeFromCache(this._cacheData.textureCacheId);
    this._cacheData.textureCacheId = null;
};
/**
 * Destroys the cached object.
 *
 * @private
 * @method
 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
 *  have been set to that value.
 *  Used when destroying containers, see the Container.destroy method.
 */ (0, $8t5Gy.DisplayObject).prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
    this.cacheAsBitmap = false;
    this.destroy(options);
};

});

parcelRegister("1xfIs", function(module, exports) {
/*!
 * @pixi/mixin-get-child-by-name - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mixin-get-child-by-name is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");
/**
 * The instance name of the object.
 *
 * @memberof PIXI.DisplayObject#
 * @member {string} name
 */ (0, $8t5Gy.DisplayObject).prototype.name = null;
/**
 * Returns the display object in the container.
 *
 * Recursive searches are done in a preorder traversal.
 *
 * @method getChildByName
 * @memberof PIXI.Container#
 * @param {string} name - Instance name.
 * @param {boolean}[deep=false] - Whether to search recursively
 * @return {PIXI.DisplayObject} The child with the specified name.
 */ (0, $8t5Gy.Container).prototype.getChildByName = function getChildByName(name, deep) {
    for(var i = 0, j = this.children.length; i < j; i++){
        if (this.children[i].name === name) return this.children[i];
    }
    if (deep) for(var i = 0, j = this.children.length; i < j; i++){
        var child = this.children[i];
        if (!child.getChildByName) continue;
        var target = this.children[i].getChildByName(name, true);
        if (target) return target;
    }
    return null;
};

});

parcelRegister("60K84", function(module, exports) {
/*!
 * @pixi/mixin-get-global-position - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mixin-get-global-position is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");

var $6qzqq = parcelRequire("6qzqq");
/**
 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
 *
 * @method getGlobalPosition
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.Point} [point=new PIXI.Point()] - The point to write the global value to.
 * @param {boolean} [skipUpdate=false] - Setting to true will stop the transforms of the scene graph from
 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
 *  nice performance boost.
 * @return {PIXI.Point} The updated point.
 */ (0, $8t5Gy.DisplayObject).prototype.getGlobalPosition = function getGlobalPosition(point, skipUpdate) {
    if (point === void 0) point = new (0, $6qzqq.Point)();
    if (skipUpdate === void 0) skipUpdate = false;
    if (this.parent) this.parent.toGlobal(this.position, point, skipUpdate);
    else {
        point.x = this.position.x;
        point.y = this.position.y;
    }
    return point;
};

});

parcelRegister("eUwg9", function(module, exports) {

$parcel$export(module.exports, "PlaneGeometry", function () { return $adaf51b2c64e8e1b$export$967d831af31f69ce; });
$parcel$export(module.exports, "RopeGeometry", function () { return $adaf51b2c64e8e1b$export$6a9827483976bf64; });
$parcel$export(module.exports, "SimpleRope", function () { return $adaf51b2c64e8e1b$export$f009a14c3f00879e; });
$parcel$export(module.exports, "SimplePlane", function () { return $adaf51b2c64e8e1b$export$d47c1aa7111669b9; });
$parcel$export(module.exports, "SimpleMesh", function () { return $adaf51b2c64e8e1b$export$81b9e78682e7feca; });
$parcel$export(module.exports, "NineSlicePlane", function () { return $adaf51b2c64e8e1b$export$acdf4cb3f489544e; });
/*!
 * @pixi/mesh-extras - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mesh-extras is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $9Tsx3 = parcelRequire("9Tsx3");

var $P8XPi = parcelRequire("P8XPi");

var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $adaf51b2c64e8e1b$var$extendStatics = function(d, b) {
    $adaf51b2c64e8e1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $adaf51b2c64e8e1b$var$extendStatics(d, b);
};
function $adaf51b2c64e8e1b$var$__extends(d, b) {
    $adaf51b2c64e8e1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$967d831af31f69ce = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(PlaneGeometry, _super);
    /**
     * @param width - The width of the plane.
     * @param height - The height of the plane.
     * @param segWidth - Number of horizontal segments.
     * @param segHeight - Number of vertical segments.
     */ function PlaneGeometry(width, height, segWidth, segHeight) {
        if (width === void 0) width = 100;
        if (height === void 0) height = 100;
        if (segWidth === void 0) segWidth = 10;
        if (segHeight === void 0) segHeight = 10;
        var _this = _super.call(this) || this;
        _this.segWidth = segWidth;
        _this.segHeight = segHeight;
        _this.width = width;
        _this.height = height;
        _this.build();
        return _this;
    }
    /**
     * Refreshes plane coordinates
     * @private
     */ PlaneGeometry.prototype.build = function() {
        var total = this.segWidth * this.segHeight;
        var verts = [];
        var uvs = [];
        var indices = [];
        var segmentsX = this.segWidth - 1;
        var segmentsY = this.segHeight - 1;
        var sizeX = this.width / segmentsX;
        var sizeY = this.height / segmentsY;
        for(var i = 0; i < total; i++){
            var x = i % this.segWidth;
            var y = i / this.segWidth | 0;
            verts.push(x * sizeX, y * sizeY);
            uvs.push(x / segmentsX, y / segmentsY);
        }
        var totalSub = segmentsX * segmentsY;
        for(var i = 0; i < totalSub; i++){
            var xpos = i % segmentsX;
            var ypos = i / segmentsX | 0;
            var value = ypos * this.segWidth + xpos;
            var value2 = ypos * this.segWidth + xpos + 1;
            var value3 = (ypos + 1) * this.segWidth + xpos;
            var value4 = (ypos + 1) * this.segWidth + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts);
        this.buffers[1].data = new Float32Array(uvs);
        this.indexBuffer.data = new Uint16Array(indices);
        // ensure that the changes are uploaded
        this.buffers[0].update();
        this.buffers[1].update();
        this.indexBuffer.update();
    };
    return PlaneGeometry;
}((0, $9Tsx3.MeshGeometry));
/**
 * RopeGeometry allows you to draw a geometry across several points and then manipulate these points.
 *
 * ```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * const rope = new PIXI.RopeGeometry(100, points);
 * ```
 *
 * @class
 * @extends PIXI.MeshGeometry
 * @memberof PIXI
 *
 */ var $adaf51b2c64e8e1b$export$6a9827483976bf64 = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(RopeGeometry, _super);
    /**
     * @param {number} [width=200] - The width (i.e., thickness) of the rope.
     * @param {PIXI.Point[]} [points] - An array of {@link PIXI.Point} objects to construct this rope.
     * @param {number} [textureScale=0] - By default the rope texture will be stretched to match
     *     rope length. If textureScale is positive this value will be treated as a scaling
     *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
     *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
     *     then set textureScale=1 to keep the original texture pixel size.
     *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
     *     i.e. set textureScale=0.5 to scale it down twice.
     */ function RopeGeometry(width, points, textureScale) {
        if (width === void 0) width = 200;
        if (textureScale === void 0) textureScale = 0;
        var _this = _super.call(this, new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6)) || this;
        /**
         * An array of points that determine the rope
         * @member {PIXI.Point[]}
         */ _this.points = points;
        /**
         * The width (i.e., thickness) of the rope.
         * @member {number}
         * @readOnly
         */ _this._width = width;
        /**
         * Rope texture scale, if zero then the rope texture is stretched.
         * @member {number}
         * @readOnly
         */ _this.textureScale = textureScale;
        _this.build();
        return _this;
    }
    Object.defineProperty(RopeGeometry.prototype, "width", {
        /**
         * The width (i.e., thickness) of the rope.
         * @member {number}
         * @readOnly
         */ get: function() {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Refreshes Rope indices and uvs
     * @private
     */ RopeGeometry.prototype.build = function() {
        var points = this.points;
        if (!points) return;
        var vertexBuffer = this.getBuffer('aVertexPosition');
        var uvBuffer = this.getBuffer('aTextureCoord');
        var indexBuffer = this.getIndex();
        // if too little points, or texture hasn't got UVs set yet just move on.
        if (points.length < 1) return;
        // if the number of points has changed we will need to recreate the arraybuffers
        if (vertexBuffer.data.length / 4 !== points.length) {
            vertexBuffer.data = new Float32Array(points.length * 4);
            uvBuffer.data = new Float32Array(points.length * 4);
            indexBuffer.data = new Uint16Array((points.length - 1) * 6);
        }
        var uvs = uvBuffer.data;
        var indices = indexBuffer.data;
        uvs[0] = 0;
        uvs[1] = 0;
        uvs[2] = 0;
        uvs[3] = 1;
        var amount = 0;
        var prev = points[0];
        var textureWidth = this._width * this.textureScale;
        var total = points.length; // - 1;
        for(var i = 0; i < total; i++){
            // time to do some smart drawing!
            var index = i * 4;
            if (this.textureScale > 0) {
                // calculate pixel distance from previous point
                var dx = prev.x - points[i].x;
                var dy = prev.y - points[i].y;
                var distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i];
                amount += distance / textureWidth;
            } else // stretch texture
            amount = i / (total - 1);
            uvs[index] = amount;
            uvs[index + 1] = 0;
            uvs[index + 2] = amount;
            uvs[index + 3] = 1;
        }
        var indexCount = 0;
        for(var i = 0; i < total - 1; i++){
            var index = i * 2;
            indices[indexCount++] = index;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 3;
        }
        // ensure that the changes are uploaded
        uvBuffer.update();
        indexBuffer.update();
        this.updateVertices();
    };
    /**
     * refreshes vertices of Rope mesh
     */ RopeGeometry.prototype.updateVertices = function() {
        var points = this.points;
        if (points.length < 1) return;
        var lastPoint = points[0];
        var nextPoint;
        var perpX = 0;
        var perpY = 0;
        var vertices = this.buffers[0].data;
        var total = points.length;
        for(var i = 0; i < total; i++){
            var point = points[i];
            var index = i * 4;
            if (i < points.length - 1) nextPoint = points[i + 1];
            else nextPoint = point;
            perpY = -(nextPoint.x - lastPoint.x);
            perpX = nextPoint.y - lastPoint.y;
            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            var num = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
            perpX /= perpLength;
            perpY /= perpLength;
            perpX *= num;
            perpY *= num;
            vertices[index] = point.x + perpX;
            vertices[index + 1] = point.y + perpY;
            vertices[index + 2] = point.x - perpX;
            vertices[index + 3] = point.y - perpY;
            lastPoint = point;
        }
        this.buffers[0].update();
    };
    RopeGeometry.prototype.update = function() {
        if (this.textureScale > 0) this.build(); // we need to update UVs
        else this.updateVertices();
    };
    return RopeGeometry;
}((0, $9Tsx3.MeshGeometry));
/**
 * The rope allows you to draw a texture across several points and then manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let rope = new PIXI.SimpleRope(PIXI.Texture.from("snake.png"), points);
 *  ```
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$f009a14c3f00879e = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(SimpleRope, _super);
    /**
     * @param texture - The texture to use on the rope.
     * @param points - An array of {@link PIXI.Point} objects to construct this rope.
     * @param {number} textureScale - Optional. Positive values scale rope texture
     * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
     * and downsampling here. If set to zero, texture will be stretched instead.
     */ function SimpleRope(texture, points, textureScale) {
        if (textureScale === void 0) textureScale = 0;
        var _this = this;
        var ropeGeometry = new $adaf51b2c64e8e1b$export$6a9827483976bf64(texture.height, points, textureScale);
        var meshMaterial = new (0, $9Tsx3.MeshMaterial)(texture);
        if (textureScale > 0) // attempt to set UV wrapping, will fail on non-power of two textures
        texture.baseTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
        _this = _super.call(this, ropeGeometry, meshMaterial) || this;
        /**
         * re-calculate vertices by rope points each frame
         *
         * @member {boolean}
         */ _this.autoUpdate = true;
        return _this;
    }
    SimpleRope.prototype._render = function(renderer) {
        var geometry = this.geometry;
        if (this.autoUpdate || geometry._width !== this.shader.texture.height) {
            geometry._width = this.shader.texture.height;
            geometry.update();
        }
        _super.prototype._render.call(this, renderer);
    };
    return SimpleRope;
}((0, $9Tsx3.Mesh));
/**
 * The SimplePlane allows you to draw a texture across several points and then manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let SimplePlane = new PIXI.SimplePlane(PIXI.Texture.from("snake.png"), points);
 *  ```
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$d47c1aa7111669b9 = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(SimplePlane, _super);
    /**
     * @param texture - The texture to use on the SimplePlane.
     * @param verticesX - The number of vertices in the x-axis
     * @param verticesY - The number of vertices in the y-axis
     */ function SimplePlane(texture, verticesX, verticesY) {
        var _this = this;
        var planeGeometry = new $adaf51b2c64e8e1b$export$967d831af31f69ce(texture.width, texture.height, verticesX, verticesY);
        var meshMaterial = new (0, $9Tsx3.MeshMaterial)((0, $klOfb.Texture).WHITE);
        _this = _super.call(this, planeGeometry, meshMaterial) || this;
        // lets call the setter to ensure all necessary updates are performed
        _this.texture = texture;
        _this.autoResize = true;
        return _this;
    }
    /**
     * Method used for overrides, to do something in case texture frame was changed.
     * Meshes based on plane can override it and change more details based on texture.
     */ SimplePlane.prototype.textureUpdated = function() {
        this._textureID = this.shader.texture._updateID;
        var geometry = this.geometry;
        var _a = this.shader.texture, width = _a.width, height = _a.height;
        if (this.autoResize && (geometry.width !== width || geometry.height !== height)) {
            geometry.width = this.shader.texture.width;
            geometry.height = this.shader.texture.height;
            geometry.build();
        }
    };
    Object.defineProperty(SimplePlane.prototype, "texture", {
        get: function() {
            return this.shader.texture;
        },
        set: function(value) {
            // Track texture same way sprite does.
            // For generated meshes like NineSlicePlane it can change the geometry.
            // Unfortunately, this method might not work if you directly change texture in material.
            if (this.shader.texture === value) return;
            this.shader.texture = value;
            this._textureID = -1;
            if (value.baseTexture.valid) this.textureUpdated();
            else value.once('update', this.textureUpdated, this);
        },
        enumerable: false,
        configurable: true
    });
    SimplePlane.prototype._render = function(renderer) {
        if (this._textureID !== this.shader.texture._updateID) this.textureUpdated();
        _super.prototype._render.call(this, renderer);
    };
    SimplePlane.prototype.destroy = function(options) {
        this.shader.texture.off('update', this.textureUpdated, this);
        _super.prototype.destroy.call(this, options);
    };
    return SimplePlane;
}((0, $9Tsx3.Mesh));
/**
 * The Simple Mesh class mimics Mesh in PixiJS v4, providing easy-to-use constructor arguments.
 * For more robust customization, use {@link PIXI.Mesh}.
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$81b9e78682e7feca = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(SimpleMesh, _super);
    /**
     * @param texture - The texture to use
     * @param {Float32Array} [vertices] - if you want to specify the vertices
     * @param {Float32Array} [uvs] - if you want to specify the uvs
     * @param {Uint16Array} [indices] - if you want to specify the indices
     * @param drawMode - the drawMode, can be any of the Mesh.DRAW_MODES consts
     */ function SimpleMesh(texture, vertices, uvs, indices, drawMode) {
        if (texture === void 0) texture = (0, $klOfb.Texture).EMPTY;
        var _this = this;
        var geometry = new (0, $9Tsx3.MeshGeometry)(vertices, uvs, indices);
        geometry.getBuffer('aVertexPosition').static = false;
        var meshMaterial = new (0, $9Tsx3.MeshMaterial)(texture);
        _this = _super.call(this, geometry, meshMaterial, null, drawMode) || this;
        _this.autoUpdate = true;
        return _this;
    }
    Object.defineProperty(SimpleMesh.prototype, "vertices", {
        /**
         * Collection of vertices data.
         * @type {Float32Array}
         */ get: function() {
            return this.geometry.getBuffer('aVertexPosition').data;
        },
        set: function(value) {
            this.geometry.getBuffer('aVertexPosition').data = value;
        },
        enumerable: false,
        configurable: true
    });
    SimpleMesh.prototype._render = function(renderer) {
        if (this.autoUpdate) this.geometry.getBuffer('aVertexPosition').update();
        _super.prototype._render.call(this, renderer);
    };
    return SimpleMesh;
}((0, $9Tsx3.Mesh));
var $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE = 10;
/**
 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
 *
 *```js
 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.from('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
 *  ```
 * <pre>
 *      A                          B
 *    +---+----------------------+---+
 *  C | 1 |          2           | 3 |
 *    +---+----------------------+---+
 *    |   |                      |   |
 *    | 4 |          5           | 6 |
 *    |   |                      |   |
 *    +---+----------------------+---+
 *  D | 7 |          8           | 9 |
 *    +---+----------------------+---+

 *  When changing this objects width and/or height:
 *     areas 1 3 7 and 9 will remain unscaled.
 *     areas 2 and 8 will be stretched horizontally
 *     areas 4 and 6 will be stretched vertically
 *     area 5 will be stretched both horizontally and vertically
 * </pre>
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$acdf4cb3f489544e = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(NineSlicePlane, _super);
    /**
     * @param texture - The texture to use on the NineSlicePlane.
     * @param {number} [leftWidth=10] - size of the left vertical bar (A)
     * @param {number} [topHeight=10] - size of the top horizontal bar (C)
     * @param {number} [rightWidth=10] - size of the right vertical bar (B)
     * @param {number} [bottomHeight=10] - size of the bottom horizontal bar (D)
     */ function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
        if (leftWidth === void 0) leftWidth = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        if (topHeight === void 0) topHeight = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        if (rightWidth === void 0) rightWidth = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        if (bottomHeight === void 0) bottomHeight = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        var _this = _super.call(this, (0, $klOfb.Texture).WHITE, 4, 4) || this;
        _this._origWidth = texture.orig.width;
        _this._origHeight = texture.orig.height;
        /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ _this._width = _this._origWidth;
        /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ _this._height = _this._origHeight;
        _this._leftWidth = leftWidth;
        _this._rightWidth = rightWidth;
        _this._topHeight = topHeight;
        _this._bottomHeight = bottomHeight;
        // lets call the setter to ensure all necessary updates are performed
        _this.texture = texture;
        return _this;
    }
    NineSlicePlane.prototype.textureUpdated = function() {
        this._textureID = this.shader.texture._updateID;
        this._refresh();
    };
    Object.defineProperty(NineSlicePlane.prototype, "vertices", {
        get: function() {
            return this.geometry.getBuffer('aVertexPosition').data;
        },
        set: function(value) {
            this.geometry.getBuffer('aVertexPosition').data = value;
        },
        enumerable: false,
        configurable: true
    });
    /** Updates the horizontal vertices. */ NineSlicePlane.prototype.updateHorizontalVertices = function() {
        var vertices = this.vertices;
        var scale = this._getMinScale();
        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    };
    /** Updates the vertical vertices. */ NineSlicePlane.prototype.updateVerticalVertices = function() {
        var vertices = this.vertices;
        var scale = this._getMinScale();
        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    };
    /**
     * Returns the smaller of a set of vertical and horizontal scale of nine slice corners.
     *
     * @return Smaller number of vertical and horizontal scale.
     */ NineSlicePlane.prototype._getMinScale = function() {
        var w = this._leftWidth + this._rightWidth;
        var scaleW = this._width > w ? 1.0 : this._width / w;
        var h = this._topHeight + this._bottomHeight;
        var scaleH = this._height > h ? 1.0 : this._height / h;
        var scale = Math.min(scaleW, scaleH);
        return scale;
    };
    Object.defineProperty(NineSlicePlane.prototype, "width", {
        /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get: function() {
            return this._width;
        },
        set: function(value) {
            this._width = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "height", {
        /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get: function() {
            return this._height;
        },
        set: function(value) {
            this._height = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "leftWidth", {
        /** The width of the left column. */ get: function() {
            return this._leftWidth;
        },
        set: function(value) {
            this._leftWidth = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "rightWidth", {
        /** The width of the right column. */ get: function() {
            return this._rightWidth;
        },
        set: function(value) {
            this._rightWidth = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "topHeight", {
        /** The height of the top row. */ get: function() {
            return this._topHeight;
        },
        set: function(value) {
            this._topHeight = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "bottomHeight", {
        /** The height of the bottom row. */ get: function() {
            return this._bottomHeight;
        },
        set: function(value) {
            this._bottomHeight = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    /** Refreshes NineSlicePlane coords. All of them. */ NineSlicePlane.prototype._refresh = function() {
        var texture = this.texture;
        var uvs = this.geometry.buffers[1].data;
        this._origWidth = texture.orig.width;
        this._origHeight = texture.orig.height;
        var _uvw = 1.0 / this._origWidth;
        var _uvh = 1.0 / this._origHeight;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;
        this.updateHorizontalVertices();
        this.updateVerticalVertices();
        this.geometry.buffers[0].update();
        this.geometry.buffers[1].update();
    };
    return NineSlicePlane;
}($adaf51b2c64e8e1b$export$d47c1aa7111669b9);

});

parcelRegister("d3fD1", function(module, exports) {

$parcel$export(module.exports, "AnimatedSprite", function () { return $9807ad9f96ef10f2$export$dae599798687ad3c; });
/*!
 * @pixi/sprite-animated - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/sprite-animated is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $3YyWq = parcelRequire("3YyWq");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $9807ad9f96ef10f2$var$extendStatics = function(d, b) {
    $9807ad9f96ef10f2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $9807ad9f96ef10f2$var$extendStatics(d, b);
};
function $9807ad9f96ef10f2$var$__extends(d, b) {
    $9807ad9f96ef10f2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
 *
 * ```js
 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
 * let textureArray = [];
 *
 * for (let i=0; i < 4; i++)
 * {
 *      let texture = PIXI.Texture.from(alienImages[i]);
 *      textureArray.push(texture);
 * };
 *
 * let animatedSprite = new PIXI.AnimatedSprite(textureArray);
 * ```
 *
 * The more efficient and simpler way to create an animated sprite is using a {@link PIXI.Spritesheet}
 * containing the animation definitions:
 *
 * ```js
 * PIXI.Loader.shared.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.Loader.shared.resources["assets/spritesheet.json"].spritesheet;
 *   animatedSprite = new PIXI.AnimatedSprite(sheet.animations["image_sequence"]);
 *   ...
 * }
 * ```
 *
 * @memberof PIXI
 */ var $9807ad9f96ef10f2$export$dae599798687ad3c = /** @class */ function(_super) {
    $9807ad9f96ef10f2$var$__extends(AnimatedSprite, _super);
    /**
     * @param textures - An array of {@link PIXI.Texture} or frame
     *  objects that make up the animation.
     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.Ticker.shared to auto update animation time.
     */ function AnimatedSprite(textures, autoUpdate) {
        if (autoUpdate === void 0) autoUpdate = true;
        var _this = _super.call(this, textures[0] instanceof (0, $klOfb.Texture) ? textures[0] : textures[0].texture) || this;
        _this._textures = null;
        _this._durations = null;
        _this._autoUpdate = autoUpdate;
        _this._isConnectedToTicker = false;
        _this.animationSpeed = 1;
        _this.loop = true;
        _this.updateAnchor = false;
        _this.onComplete = null;
        _this.onFrameChange = null;
        _this.onLoop = null;
        _this._currentTime = 0;
        _this._playing = false;
        _this._previousFrame = null;
        _this.textures = textures;
        return _this;
    }
    /** Stops the AnimatedSprite. */ AnimatedSprite.prototype.stop = function() {
        if (!this._playing) return;
        this._playing = false;
        if (this._autoUpdate && this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    };
    /** Plays the AnimatedSprite. */ AnimatedSprite.prototype.play = function() {
        if (this._playing) return;
        this._playing = true;
        if (this._autoUpdate && !this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.add(this.update, this, (0, $3YyWq.UPDATE_PRIORITY).HIGH);
            this._isConnectedToTicker = true;
        }
    };
    /**
     * Stops the AnimatedSprite and goes to a specific frame.
     *
     * @param frameNumber - Frame index to stop at.
     */ AnimatedSprite.prototype.gotoAndStop = function(frameNumber) {
        this.stop();
        var previousFrame = this.currentFrame;
        this._currentTime = frameNumber;
        if (previousFrame !== this.currentFrame) this.updateTexture();
    };
    /**
     * Goes to a specific frame and begins playing the AnimatedSprite.
     *
     * @param frameNumber - Frame index to start at.
     */ AnimatedSprite.prototype.gotoAndPlay = function(frameNumber) {
        var previousFrame = this.currentFrame;
        this._currentTime = frameNumber;
        if (previousFrame !== this.currentFrame) this.updateTexture();
        this.play();
    };
    /**
     * Updates the object transform for rendering.
     *
     * @param deltaTime - Time since last tick.
     */ AnimatedSprite.prototype.update = function(deltaTime) {
        if (!this._playing) return;
        var elapsed = this.animationSpeed * deltaTime;
        var previousFrame = this.currentFrame;
        if (this._durations !== null) {
            var lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1000;
            while(lag < 0){
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            var sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while(lag >= this._durations[this.currentFrame]){
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) this.onComplete();
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) this.onComplete();
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) this.onLoop();
                else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) this.onLoop();
            }
            this.updateTexture();
        }
    };
    /** Updates the displayed texture to match the current frame index. */ AnimatedSprite.prototype.updateTexture = function() {
        var currentFrame = this.currentFrame;
        if (this._previousFrame === currentFrame) return;
        this._previousFrame = currentFrame;
        this._texture = this._textures[currentFrame];
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this._cachedTint = 0xFFFFFF;
        this.uvs = this._texture._uvs.uvsFloat32;
        if (this.updateAnchor) this._anchor.copyFrom(this._texture.defaultAnchor);
        if (this.onFrameChange) this.onFrameChange(this.currentFrame);
    };
    /**
     * Stops the AnimatedSprite and destroys it.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value.
     * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well.
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well.
     */ AnimatedSprite.prototype.destroy = function(options) {
        this.stop();
        _super.prototype.destroy.call(this, options);
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
    };
    /**
     * A short hand way of creating an AnimatedSprite from an array of frame ids.
     *
     * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
     * @return - The new animated sprite with the specified frames.
     */ AnimatedSprite.fromFrames = function(frames) {
        var textures = [];
        for(var i = 0; i < frames.length; ++i)textures.push((0, $klOfb.Texture).from(frames[i]));
        return new AnimatedSprite(textures);
    };
    /**
     * A short hand way of creating an AnimatedSprite from an array of image ids.
     *
     * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
     * @return The new animate sprite with the specified images as frames.
     */ AnimatedSprite.fromImages = function(images) {
        var textures = [];
        for(var i = 0; i < images.length; ++i)textures.push((0, $klOfb.Texture).from(images[i]));
        return new AnimatedSprite(textures);
    };
    Object.defineProperty(AnimatedSprite.prototype, "totalFrames", {
        /**
         * The total number of frames in the AnimatedSprite. This is the same as number of textures
         * assigned to the AnimatedSprite.
         *
         * @readonly
         * @default 0
         */ get: function() {
            return this._textures.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "textures", {
        /** The array of textures used for this AnimatedSprite. */ get: function() {
            return this._textures;
        },
        set: function(value) {
            if (value[0] instanceof (0, $klOfb.Texture)) {
                this._textures = value;
                this._durations = null;
            } else {
                this._textures = [];
                this._durations = [];
                for(var i = 0; i < value.length; i++){
                    this._textures.push(value[i].texture);
                    this._durations.push(value[i].time);
                }
            }
            this._previousFrame = null;
            this.gotoAndStop(0);
            this.updateTexture();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "currentFrame", {
        /**
         * The AnimatedSprites current frame index.
         *
         * @readonly
         */ get: function() {
            var currentFrame = Math.floor(this._currentTime) % this._textures.length;
            if (currentFrame < 0) currentFrame += this._textures.length;
            return currentFrame;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "playing", {
        /**
         * Indicates if the AnimatedSprite is currently playing.
         *
         * @readonly
         */ get: function() {
            return this._playing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "autoUpdate", {
        /** Whether to use PIXI.Ticker.shared to auto update animation time. */ get: function() {
            return this._autoUpdate;
        },
        set: function(value) {
            if (value !== this._autoUpdate) {
                this._autoUpdate = value;
                if (!this._autoUpdate && this._isConnectedToTicker) {
                    (0, $3YyWq.Ticker).shared.remove(this.update, this);
                    this._isConnectedToTicker = false;
                } else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
                    (0, $3YyWq.Ticker).shared.add(this.update, this);
                    this._isConnectedToTicker = true;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    return AnimatedSprite;
}((0, $7Bs2Z.Sprite));

});


parcelRegister("8Odl4", function(module, exports) {

$parcel$export(module.exports, "sound", function () { return I; });
/*!
 * @pixi/sound - v4.2.0
 * https://github.com/pixijs/pixi-sound
 * Compiled Wed, 05 Jan 2022 14:56:00 UTC
 *
 * @pixi/sound is licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $kXE1p = parcelRequire("kXE1p");
parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");

var $3YyWq = parcelRequire("3YyWq");

var $klOfb = parcelRequire("klOfb");
var r;
function s() {
    return r;
}
var u = function(t, e) {
    return (u = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    })(t, e);
};
function a(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    u(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var c = function() {
    return (c = Object.assign || function(t) {
        for(var e, n = 1, o = arguments.length; n < o; n++)for(var i in e = arguments[n])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }).apply(this, arguments);
}, l = [
    "mp3",
    "ogg",
    "oga",
    "opus",
    "mpeg",
    "wav",
    "m4a",
    "aiff",
    "wma",
    "mid",
    "caf"
], p = {};
function h(t) {
    var e = c({
        m4a: "audio/mp4",
        oga: "audio/ogg",
        opus: 'audio/ogg; codecs="opus"',
        caf: 'audio/x-caf; codecs="opus"'
    }, t || {}), n = document.createElement("audio"), o = {}, i = /^no$/;
    l.forEach(function(t) {
        var r = n.canPlayType("audio/".concat(t)).replace(i, ""), s = e[t] ? n.canPlayType(e[t]).replace(i, "") : "";
        o[t] = !!r || !!s;
    }), Object.assign(p, o);
}
h();
var f = /\.(\{([^\}]+)\})(\?.*)?$/;
function d(t) {
    var e = f, n = "string" == typeof t ? t : t.url;
    if (!e.test(n)) return n;
    for(var o = e.exec(n), i = o[2].split(","), r = i[i.length - 1], s = 0, u = i.length; s < u; s++){
        var a = i[s];
        if (p[a]) {
            r = a;
            break;
        }
    }
    var c = n.replace(o[1], r);
    if ("string" != typeof t) {
        var l = t;
        l.extension = r, l.url = c;
    }
    return c;
}
var _ = function() {
    function e() {}
    return e.add = function() {
        e.setLegacy(s().useLegacy);
    }, e.setLegacy = function(e) {
        var n = l;
        e ? n.forEach(function(e) {
            (0, $kXE1p.LoaderResource).setExtensionXhrType(e, (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.DEFAULT), (0, $kXE1p.LoaderResource).setExtensionLoadType(e, (0, $kXE1p.LoaderResource).LOAD_TYPE.AUDIO);
        }) : n.forEach(function(e) {
            (0, $kXE1p.LoaderResource).setExtensionXhrType(e, (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.BUFFER), (0, $kXE1p.LoaderResource).setExtensionLoadType(e, (0, $kXE1p.LoaderResource).LOAD_TYPE.XHR);
        });
    }, e.pre = function(t, e) {
        d(t), e();
    }, e.use = function(t, e) {
        t.data && l.indexOf(t.extension) > -1 ? t.sound = s().add(t.name, {
            loaded: e,
            preload: !0,
            url: t.url,
            source: t.data
        }) : e();
    }, e;
}(), y = 0, m = function(t) {
    function e(e) {
        var n = t.call(this) || this;
        return n.id = y++, n.init(e), n;
    }
    return a(e, t), e.prototype.set = function(t, e) {
        if (void 0 === this[t]) throw new Error("Property with name ".concat(t, " does not exist."));
        switch(t){
            case "speed":
                this.speed = e;
                break;
            case "volume":
                this.volume = e;
                break;
            case "paused":
                this.paused = e;
                break;
            case "loop":
                this.loop = e;
                break;
            case "muted":
                this.muted = e;
        }
        return this;
    }, Object.defineProperty(e.prototype, "progress", {
        get: function() {
            return this._source.currentTime / this._duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            this._paused = t, this.refreshPaused();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype._onPlay = function() {
        this._playing = !0;
    }, e.prototype._onPause = function() {
        this._playing = !1;
    }, e.prototype.init = function(t) {
        this._playing = !1, this._duration = t.source.duration;
        var e = this._source = t.source.cloneNode(!1);
        e.src = t.parent.url, e.onplay = this._onPlay.bind(this), e.onpause = this._onPause.bind(this), t.context.on("refresh", this.refresh, this), t.context.on("refreshPaused", this.refreshPaused, this), this._media = t;
    }, e.prototype._internalStop = function() {
        this._source && this._playing && (this._source.onended = null, this._source.pause());
    }, e.prototype.stop = function() {
        this._internalStop(), this._source && this.emit("stop");
    }, Object.defineProperty(e.prototype, "speed", {
        get: function() {
            return this._speed;
        },
        set: function(t) {
            this._speed = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            this._volume = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(t) {
            this._loop = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "muted", {
        get: function() {
            return this._muted;
        },
        set: function(t) {
            this._muted = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return null;
        },
        set: function(t) {},
        enumerable: !1,
        configurable: !0
    }), e.prototype.refresh = function() {
        var t = this._media.context, e = this._media.parent;
        this._source.loop = this._loop || e.loop;
        var n = t.volume * (t.muted ? 0 : 1), o = e.volume * (e.muted ? 0 : 1), i = this._volume * (this._muted ? 0 : 1);
        this._source.volume = i * n * o, this._source.playbackRate = this._speed * t.speed * e.speed;
    }, e.prototype.refreshPaused = function() {
        var t = this._media.context, e = this._media.parent, n = this._paused || e.paused || t.paused;
        n !== this._pausedReal && (this._pausedReal = n, n ? (this._internalStop(), this.emit("paused")) : (this.emit("resumed"), this.play({
            start: this._source.currentTime,
            end: this._end,
            volume: this._volume,
            speed: this._speed,
            loop: this._loop
        })), this.emit("pause", n));
    }, e.prototype.play = function(t) {
        var n = this, i = t.start, r = t.end, s = t.speed, u = t.loop, a = t.volume, c = t.muted;
        this._speed = s, this._volume = a, this._loop = !!u, this._muted = c, this.refresh(), this.loop && null !== r && (this.loop = !1), this._start = i, this._end = r || this._duration, this._start = Math.max(0, this._start - e.PADDING), this._end = Math.min(this._end + e.PADDING, this._duration), this._source.onloadedmetadata = function() {
            n._source && (n._source.currentTime = i, n._source.onloadedmetadata = null, n.emit("progress", i, n._duration), (0, $3YyWq.Ticker).shared.add(n._onUpdate, n));
        }, this._source.onended = this._onComplete.bind(this), this._source.play(), this.emit("start");
    }, e.prototype._onUpdate = function() {
        this.emit("progress", this.progress, this._duration), this._source.currentTime >= this._end && !this._source.loop && this._onComplete();
    }, e.prototype._onComplete = function() {
        (0, $3YyWq.Ticker).shared.remove(this._onUpdate, this), this._internalStop(), this.emit("progress", 1, this._duration), this.emit("end", this);
    }, e.prototype.destroy = function() {
        (0, $3YyWq.Ticker).shared.remove(this._onUpdate, this), this.removeAllListeners();
        var t = this._source;
        t && (t.onended = null, t.onplay = null, t.onpause = null, this._internalStop()), this._source = null, this._speed = 1, this._volume = 1, this._loop = !1, this._end = null, this._start = 0, this._duration = 0, this._playing = !1, this._pausedReal = !1, this._paused = !1, this._muted = !1, this._media && (this._media.context.off("refresh", this.refresh, this), this._media.context.off("refreshPaused", this.refreshPaused, this), this._media = null);
    }, e.prototype.toString = function() {
        return "[HTMLAudioInstance id=".concat(this.id, "]");
    }, e.PADDING = .1, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), g = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return a(e, t), e.prototype.init = function(t) {
        this.parent = t, this._source = t.options.source || new Audio, t.url && (this._source.src = t.url);
    }, e.prototype.create = function() {
        return new m(this);
    }, Object.defineProperty(e.prototype, "isPlayable", {
        get: function() {
            return !!this._source && 4 === this._source.readyState;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this._source.duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "context", {
        get: function() {
            return this.parent.context;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return null;
        },
        set: function(t) {},
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        this.removeAllListeners(), this.parent = null, this._source && (this._source.src = "", this._source.load(), this._source = null);
    }, Object.defineProperty(e.prototype, "source", {
        get: function() {
            return this._source;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.load = function(t) {
        var e = this._source, n = this.parent;
        if (4 !== e.readyState) {
            if (n.url) {
                e.src = n.url;
                var o = function() {
                    s(), n.isLoaded = !0;
                    var e = n.autoPlayStart();
                    t && t(null, n, e);
                }, i = function() {
                    s(), t && t(new Error("Sound loading has been aborted"));
                }, r = function() {
                    s();
                    var n = "Failed to load audio element (code: ".concat(e.error.code, ")");
                    t && t(new Error(n));
                }, s = function() {
                    e.removeEventListener("canplaythrough", o), e.removeEventListener("load", o), e.removeEventListener("abort", i), e.removeEventListener("error", r);
                };
                e.addEventListener("canplaythrough", o, !1), e.addEventListener("load", o, !1), e.addEventListener("abort", i, !1), e.addEventListener("error", r, !1), e.load();
            } else t(new Error("sound.url or sound.source must be set"));
        } else {
            n.isLoaded = !0;
            var u = n.autoPlayStart();
            t && setTimeout(function() {
                t(null, n, u);
            }, 0);
        }
    }, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), b = function() {
    function t(t, e) {
        this.parent = t, Object.assign(this, e), this.duration = this.end - this.start;
    }
    return t.prototype.play = function(t) {
        return this.parent.play({
            complete: t,
            speed: this.speed || this.parent.speed,
            end: this.end,
            start: this.start,
            loop: this.loop
        });
    }, t.prototype.destroy = function() {
        this.parent = null;
    }, t;
}(), v = function() {
    function t() {}
    return t.setParamValue = function(t, e) {
        if (t.setValueAtTime) {
            var n = s().context;
            t.setValueAtTime(e, n.audioContext.currentTime);
        } else t.value = e;
        return e;
    }, t;
}(), P = 0, x = function(t) {
    function e(e) {
        var n = t.call(this) || this;
        return n.id = P++, n._media = null, n._paused = !1, n._muted = !1, n._elapsed = 0, n.init(e), n;
    }
    return a(e, t), e.prototype.set = function(t, e) {
        if (void 0 === this[t]) throw new Error("Property with name ".concat(t, " does not exist."));
        switch(t){
            case "speed":
                this.speed = e;
                break;
            case "volume":
                this.volume = e;
                break;
            case "muted":
                this.muted = e;
                break;
            case "loop":
                this.loop = e;
                break;
            case "paused":
                this.paused = e;
        }
        return this;
    }, e.prototype.stop = function() {
        this._source && (this._internalStop(), this.emit("stop"));
    }, Object.defineProperty(e.prototype, "speed", {
        get: function() {
            return this._speed;
        },
        set: function(t) {
            this._speed = t, this.refresh(), this._update(!0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            this._volume = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "muted", {
        get: function() {
            return this._muted;
        },
        set: function(t) {
            this._muted = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(t) {
            this._loop = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return this._filters;
        },
        set: function(t) {
            var e;
            this._filters && (null === (e = this._filters) || void 0 === e || e.filter(function(t) {
                return t;
            }).forEach(function(t) {
                return t.disconnect();
            }), this._filters = null, this._source.connect(this._gain)), this._filters = (null == t ? void 0 : t.length) ? t.slice(0) : null, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.refresh = function() {
        if (this._source) {
            var t = this._media.context, e = this._media.parent;
            this._source.loop = this._loop || e.loop;
            var n = t.volume * (t.muted ? 0 : 1), o = e.volume * (e.muted ? 0 : 1), i = this._volume * (this._muted ? 0 : 1);
            v.setParamValue(this._gain.gain, i * o * n), v.setParamValue(this._source.playbackRate, this._speed * e.speed * t.speed), this.applyFilters();
        }
    }, e.prototype.applyFilters = function() {
        var t;
        if (null === (t = this._filters) || void 0 === t ? void 0 : t.length) {
            this._source.disconnect();
            var e = this._source;
            this._filters.forEach(function(t) {
                e.connect(t.destination), e = t;
            }), e.connect(this._gain);
        }
    }, e.prototype.refreshPaused = function() {
        var t = this._media.context, e = this._media.parent, n = this._paused || e.paused || t.paused;
        n !== this._pausedReal && (this._pausedReal = n, n ? (this._internalStop(), this.emit("paused")) : (this.emit("resumed"), this.play({
            start: this._elapsed % this._duration,
            end: this._end,
            speed: this._speed,
            loop: this._loop,
            volume: this._volume
        })), this.emit("pause", n));
    }, e.prototype.play = function(t) {
        var e = t.start, n = t.end, o = t.speed, i = t.loop, r = t.volume, s = t.muted, u = t.filters;
        this._paused = !1;
        var a = this._media.nodes.cloneBufferSource(), c = a.source, l = a.gain;
        this._source = c, this._gain = l, this._speed = o, this._volume = r, this._loop = !!i, this._muted = s, this._filters = u, this.refresh();
        var p = this._source.buffer.duration;
        this._duration = p, this._end = n, this._lastUpdate = this._now(), this._elapsed = e, this._source.onended = this._onComplete.bind(this), this._loop ? (this._source.loopEnd = n, this._source.loopStart = e, this._source.start(0, e)) : n ? this._source.start(0, e, n - e) : this._source.start(0, e), this.emit("start"), this._update(!0), this.enableTicker(!0);
    }, e.prototype.enableTicker = function(t) {
        (0, $3YyWq.Ticker).shared.remove(this._updateListener, this), t && (0, $3YyWq.Ticker).shared.add(this._updateListener, this);
    }, Object.defineProperty(e.prototype, "progress", {
        get: function() {
            return this._progress;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            this._paused = t, this.refreshPaused();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        var t;
        this.removeAllListeners(), this._internalStop(), this._gain && (this._gain.disconnect(), this._gain = null), this._media && (this._media.context.events.off("refresh", this.refresh, this), this._media.context.events.off("refreshPaused", this.refreshPaused, this), this._media = null), null === (t = this._filters) || void 0 === t || t.forEach(function(t) {
            return t.disconnect();
        }), this._filters = null, this._end = null, this._speed = 1, this._volume = 1, this._loop = !1, this._elapsed = 0, this._duration = 0, this._paused = !1, this._muted = !1, this._pausedReal = !1;
    }, e.prototype.toString = function() {
        return "[WebAudioInstance id=".concat(this.id, "]");
    }, e.prototype._now = function() {
        return this._media.context.audioContext.currentTime;
    }, e.prototype._updateListener = function() {
        this._update();
    }, e.prototype._update = function(t) {
        if (void 0 === t && (t = !1), this._source) {
            var e = this._now(), n = e - this._lastUpdate;
            if (n > 0 || t) {
                var o = this._source.playbackRate.value;
                this._elapsed += n * o, this._lastUpdate = e;
                var i = this._duration, r = void 0;
                if (this._source.loopStart) {
                    var s = this._source.loopEnd - this._source.loopStart;
                    r = (this._source.loopStart + this._elapsed % s) / i;
                } else r = this._elapsed % i / i;
                this._progress = r, this.emit("progress", this._progress, i);
            }
        }
    }, e.prototype.init = function(t) {
        this._media = t, t.context.events.on("refresh", this.refresh, this), t.context.events.on("refreshPaused", this.refreshPaused, this);
    }, e.prototype._internalStop = function() {
        if (this._source) {
            this.enableTicker(!1), this._source.onended = null, this._source.stop(0), this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (t) {}
            this._source = null;
        }
    }, e.prototype._onComplete = function() {
        if (this._source) {
            this.enableTicker(!1), this._source.onended = null, this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (t) {}
        }
        this._source = null, this._progress = 1, this.emit("progress", 1, this._duration), this.emit("end", this);
    }, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), O = function() {
    function t(t, e) {
        this._output = e, this._input = t;
    }
    return Object.defineProperty(t.prototype, "destination", {
        get: function() {
            return this._input;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filters", {
        get: function() {
            return this._filters;
        },
        set: function(t) {
            var e = this;
            if (this._filters && (this._filters.forEach(function(t) {
                t && t.disconnect();
            }), this._filters = null, this._input.connect(this._output)), t && t.length) {
                this._filters = t.slice(0), this._input.disconnect();
                var n = null;
                t.forEach(function(t) {
                    null === n ? e._input.connect(t.destination) : n.connect(t.destination), n = t;
                }), n.connect(this._output);
            }
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.destroy = function() {
        this.filters = null, this._input = null, this._output = null;
    }, t;
}(), j = function(t) {
    function e(e) {
        var n = this, o = e.audioContext, i = o.createBufferSource(), r = o.createGain(), s = o.createAnalyser();
        return i.connect(s), s.connect(r), r.connect(e.destination), (n = t.call(this, s, r) || this).context = e, n.bufferSource = i, n.gain = r, n.analyser = s, n;
    }
    return a(e, t), Object.defineProperty(e.prototype, "script", {
        get: function() {
            return this._script || (this._script = this.context.audioContext.createScriptProcessor(e.BUFFER_SIZE), this._script.connect(this.context.destination)), this._script;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        t.prototype.destroy.call(this), this.bufferSource.disconnect(), this._script && this._script.disconnect(), this.gain.disconnect(), this.analyser.disconnect(), this.bufferSource = null, this._script = null, this.gain = null, this.analyser = null, this.context = null;
    }, e.prototype.cloneBufferSource = function() {
        var t = this.bufferSource, e = this.context.audioContext.createBufferSource();
        e.buffer = t.buffer, v.setParamValue(e.playbackRate, t.playbackRate.value), e.loop = t.loop;
        var n = this.context.audioContext.createGain();
        return e.connect(n), n.connect(this.destination), {
            source: e,
            gain: n
        };
    }, Object.defineProperty(e.prototype, "bufferSize", {
        get: function() {
            return this.script.bufferSize;
        },
        enumerable: !1,
        configurable: !0
    }), e.BUFFER_SIZE = 0, e;
}(O), w = function() {
    function t() {}
    return t.prototype.init = function(t) {
        this.parent = t, this._nodes = new j(this.context), this._source = this._nodes.bufferSource, this.source = t.options.source;
    }, t.prototype.destroy = function() {
        this.parent = null, this._nodes.destroy(), this._nodes = null;
        try {
            this._source.buffer = null;
        } catch (t) {}
        this._source = null, this.source = null;
    }, t.prototype.create = function() {
        return new x(this);
    }, Object.defineProperty(t.prototype, "context", {
        get: function() {
            return this.parent.context;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlayable", {
        get: function() {
            return !!this._source && !!this._source.buffer;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filters", {
        get: function() {
            return this._nodes.filters;
        },
        set: function(t) {
            this._nodes.filters = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this._source.buffer.duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "buffer", {
        get: function() {
            return this._source.buffer;
        },
        set: function(t) {
            this._source.buffer = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "nodes", {
        get: function() {
            return this._nodes;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.load = function(t) {
        this.source ? this._decode(this.source, t) : this.parent.url ? this._loadUrl(t) : t && t(new Error("sound.url or sound.source must be set"));
    }, t.prototype._loadUrl = function(t) {
        var e = this, n = new XMLHttpRequest, o = this.parent.url;
        n.open("GET", o, !0), n.responseType = "arraybuffer", n.onload = function() {
            e.source = n.response, e._decode(n.response, t);
        }, n.send();
    }, t.prototype._decode = function(t, e) {
        var n = this, o = function(t, o) {
            if (t) e && e(t);
            else {
                n.parent.isLoaded = !0, n.buffer = o;
                var i = n.parent.autoPlayStart();
                e && e(null, n.parent, i);
            }
        };
        t instanceof AudioBuffer ? o(null, t) : this.parent.context.decode(t, o);
    }, t;
}(), A = function() {
    function t(t, e) {
        this.media = t, this.options = e, this._instances = [], this._sprites = {}, this.media.init(this);
        var n = e.complete;
        this._autoPlayOptions = n ? {
            complete: n
        } : null, this.isLoaded = !1, this.isPlaying = !1, this.autoPlay = e.autoPlay, this.singleInstance = e.singleInstance, this.preload = e.preload || this.autoPlay, this.url = e.url, this.speed = e.speed, this.volume = e.volume, this.loop = e.loop, e.sprites && this.addSprites(e.sprites), this.preload && this._preload(e.loaded);
    }
    return t.from = function(e) {
        var n = {};
        return "string" == typeof e ? n.url = e : e instanceof ArrayBuffer || e instanceof AudioBuffer || e instanceof HTMLAudioElement ? n.source = e : n = e, (n = c({
            autoPlay: !1,
            singleInstance: !1,
            url: null,
            source: null,
            preload: !1,
            volume: 1,
            speed: 1,
            complete: null,
            loaded: null,
            loop: !1
        }, n)).url && (n.url = d(n.url)), Object.freeze(n), new t(s().useLegacy ? new g : new w, n);
    }, Object.defineProperty(t.prototype, "context", {
        get: function() {
            return s().context;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.pause = function() {
        return this.isPlaying = !1, this.paused = !0, this;
    }, t.prototype.resume = function() {
        return this.isPlaying = this._instances.length > 0, this.paused = !1, this;
    }, Object.defineProperty(t.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            this._paused = t, this.refreshPaused();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "speed", {
        get: function() {
            return this._speed;
        },
        set: function(t) {
            this._speed = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filters", {
        get: function() {
            return this.media.filters;
        },
        set: function(t) {
            this.media.filters = t;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.addSprites = function(t, e) {
        if ("object" == typeof t) {
            var n = {};
            for(var o in t)n[o] = this.addSprites(o, t[o]);
            return n;
        }
        var i = new b(this, e);
        return this._sprites[t] = i, i;
    }, t.prototype.destroy = function() {
        this._removeInstances(), this.removeSprites(), this.media.destroy(), this.media = null, this._sprites = null, this._instances = null;
    }, t.prototype.removeSprites = function(t) {
        if (t) {
            var e = this._sprites[t];
            void 0 !== e && (e.destroy(), delete this._sprites[t]);
        } else for(var n in this._sprites)this.removeSprites(n);
        return this;
    }, Object.defineProperty(t.prototype, "isPlayable", {
        get: function() {
            return this.isLoaded && this.media && this.media.isPlayable;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.stop = function() {
        if (!this.isPlayable) return this.autoPlay = !1, this._autoPlayOptions = null, this;
        this.isPlaying = !1;
        for(var t = this._instances.length - 1; t >= 0; t--)this._instances[t].stop();
        return this;
    }, t.prototype.play = function(t, e) {
        var n, o = this;
        "string" == typeof t ? n = {
            sprite: r = t,
            loop: this.loop,
            complete: e
        } : "function" == typeof t ? (n = {}).complete = t : n = t;
        if ((n = c({
            complete: null,
            loaded: null,
            sprite: null,
            end: null,
            start: 0,
            volume: 1,
            speed: 1,
            muted: !1,
            loop: !1
        }, n || {})).sprite) {
            var i = n.sprite, r = this._sprites[i];
            n.start = r.start + (n.start || 0), n.end = r.end, n.speed = r.speed || 1, n.loop = r.loop || n.loop, delete n.sprite;
        }
        if (n.offset && (n.start = n.offset), !this.isLoaded) return new Promise(function(t, e) {
            o.autoPlay = !0, o._autoPlayOptions = n, o._preload(function(o, i, r) {
                o ? e(o) : (n.loaded && n.loaded(o, i, r), t(r));
            });
        });
        (this.singleInstance || n.singleInstance) && this._removeInstances();
        var s = this._createInstance();
        return this._instances.push(s), this.isPlaying = !0, s.once("end", function() {
            n.complete && n.complete(o), o._onComplete(s);
        }), s.once("stop", function() {
            o._onComplete(s);
        }), s.play(n), s;
    }, t.prototype.refresh = function() {
        for(var t = this._instances.length, e = 0; e < t; e++)this._instances[e].refresh();
    }, t.prototype.refreshPaused = function() {
        for(var t = this._instances.length, e = 0; e < t; e++)this._instances[e].refreshPaused();
    }, Object.defineProperty(t.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            this._volume = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "muted", {
        get: function() {
            return this._muted;
        },
        set: function(t) {
            this._muted = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(t) {
            this._loop = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype._preload = function(t) {
        this.media.load(t);
    }, Object.defineProperty(t.prototype, "instances", {
        get: function() {
            return this._instances;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "sprites", {
        get: function() {
            return this._sprites;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this.media.duration;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.autoPlayStart = function() {
        var t;
        return this.autoPlay && (t = this.play(this._autoPlayOptions)), t;
    }, t.prototype._removeInstances = function() {
        for(var t = this._instances.length - 1; t >= 0; t--)this._poolInstance(this._instances[t]);
        this._instances.length = 0;
    }, t.prototype._onComplete = function(t) {
        if (this._instances) {
            var e = this._instances.indexOf(t);
            e > -1 && this._instances.splice(e, 1), this.isPlaying = this._instances.length > 0;
        }
        this._poolInstance(t);
    }, t.prototype._createInstance = function() {
        if (t._pool.length > 0) {
            var e = t._pool.pop();
            return e.init(this.media), e;
        }
        return this.media.create();
    }, t.prototype._poolInstance = function(e) {
        e.destroy(), t._pool.indexOf(e) < 0 && t._pool.push(e);
    }, t._pool = [], t;
}(), F = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.speed = 1, e.muted = !1, e.volume = 1, e.paused = !1, e;
    }
    return a(e, t), e.prototype.refresh = function() {
        this.emit("refresh");
    }, e.prototype.refreshPaused = function() {
        this.emit("refreshPaused");
    }, Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return null;
        },
        set: function(t) {},
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "audioContext", {
        get: function() {
            return null;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.toggleMute = function() {
        return this.muted = !this.muted, this.refresh(), this.muted;
    }, e.prototype.togglePause = function() {
        return this.paused = !this.paused, this.refreshPaused(), this.paused;
    }, e.prototype.destroy = function() {
        this.removeAllListeners();
    }, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), C = function(t) {
    function e() {
        var o = this, i = window, r = new e.AudioContext, s = r.createDynamicsCompressor(), u = r.createAnalyser();
        return u.connect(s), s.connect(r.destination), (o = t.call(this, u, s) || this)._ctx = r, o._offlineCtx = new e.OfflineAudioContext(1, 2, i.OfflineAudioContext ? r.sampleRate : 44100), o._unlocked = !1, o.compressor = s, o.analyser = u, o.events = new (0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))), o.volume = 1, o.speed = 1, o.muted = !1, o.paused = !1, "running" !== r.state && (o._unlock(), o._unlock = o._unlock.bind(o), document.addEventListener("mousedown", o._unlock, !0), document.addEventListener("touchstart", o._unlock, !0), document.addEventListener("touchend", o._unlock, !0)), o;
    }
    return a(e, t), e.prototype._unlock = function() {
        this._unlocked || (this.playEmptySound(), "running" === this._ctx.state && (document.removeEventListener("mousedown", this._unlock, !0), document.removeEventListener("touchend", this._unlock, !0), document.removeEventListener("touchstart", this._unlock, !0), this._unlocked = !0));
    }, e.prototype.playEmptySound = function() {
        var t = this._ctx.createBufferSource();
        t.buffer = this._ctx.createBuffer(1, 1, 22050), t.connect(this._ctx.destination), t.start(0, 0, 0), "suspended" === t.context.state && t.context.resume();
    }, Object.defineProperty(e, "AudioContext", {
        get: function() {
            var t = window;
            return t.AudioContext || t.webkitAudioContext || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e, "OfflineAudioContext", {
        get: function() {
            var t = window;
            return t.OfflineAudioContext || t.webkitOfflineAudioContext || null;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        t.prototype.destroy.call(this);
        var e = this._ctx;
        void 0 !== e.close && e.close(), this.events.removeAllListeners(), this.analyser.disconnect(), this.compressor.disconnect(), this.analyser = null, this.compressor = null, this.events = null, this._offlineCtx = null, this._ctx = null;
    }, Object.defineProperty(e.prototype, "audioContext", {
        get: function() {
            return this._ctx;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "offlineContext", {
        get: function() {
            return this._offlineCtx;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            t && "running" === this._ctx.state ? this._ctx.suspend() : t || "suspended" !== this._ctx.state || this._ctx.resume(), this._paused = t;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.refresh = function() {
        this.events.emit("refresh");
    }, e.prototype.refreshPaused = function() {
        this.events.emit("refreshPaused");
    }, e.prototype.toggleMute = function() {
        return this.muted = !this.muted, this.refresh(), this.muted;
    }, e.prototype.togglePause = function() {
        return this.paused = !this.paused, this.refreshPaused(), this._paused;
    }, e.prototype.decode = function(t, e) {
        var n = function(t) {
            e(new Error(t.message || "Unable to decode file"));
        }, o = this._offlineCtx.decodeAudioData(t, function(t) {
            e(null, t);
        }, n);
        o && o.catch(n);
    }, e;
}(O), E = function() {
    function t() {
        this.init();
    }
    return t.prototype.init = function() {
        return this.supported && (this._webAudioContext = new C), this._htmlAudioContext = new F, this._sounds = {}, this.useLegacy = !this.supported, this;
    }, Object.defineProperty(t.prototype, "context", {
        get: function() {
            return this._context;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filtersAll", {
        get: function() {
            return this.useLegacy ? [] : this._context.filters;
        },
        set: function(t) {
            this.useLegacy || (this._context.filters = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "supported", {
        get: function() {
            return null !== C.AudioContext;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.add = function(t, e) {
        if ("object" == typeof t) {
            var n = {};
            for(var o in t){
                var i = this._getOptions(t[o], e);
                n[o] = this.add(o, i);
            }
            return n;
        }
        if (e instanceof A) return this._sounds[t] = e, e;
        var r = this._getOptions(e), s = A.from(r);
        return this._sounds[t] = s, s;
    }, t.prototype._getOptions = function(t, e) {
        var n;
        return n = "string" == typeof t ? {
            url: t
        } : t instanceof ArrayBuffer || t instanceof AudioBuffer || t instanceof HTMLAudioElement ? {
            source: t
        } : t, n = c(c({}, n), e || {});
    }, Object.defineProperty(t.prototype, "useLegacy", {
        get: function() {
            return this._useLegacy;
        },
        set: function(t) {
            _.setLegacy(t), this._useLegacy = t, this._context = !t && this.supported ? this._webAudioContext : this._htmlAudioContext;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.remove = function(t) {
        return this.exists(t, !0), this._sounds[t].destroy(), delete this._sounds[t], this;
    }, Object.defineProperty(t.prototype, "volumeAll", {
        get: function() {
            return this._context.volume;
        },
        set: function(t) {
            this._context.volume = t, this._context.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "speedAll", {
        get: function() {
            return this._context.speed;
        },
        set: function(t) {
            this._context.speed = t, this._context.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.togglePauseAll = function() {
        return this._context.togglePause();
    }, t.prototype.pauseAll = function() {
        return this._context.paused = !0, this._context.refreshPaused(), this;
    }, t.prototype.resumeAll = function() {
        return this._context.paused = !1, this._context.refreshPaused(), this;
    }, t.prototype.toggleMuteAll = function() {
        return this._context.toggleMute();
    }, t.prototype.muteAll = function() {
        return this._context.muted = !0, this._context.refresh(), this;
    }, t.prototype.unmuteAll = function() {
        return this._context.muted = !1, this._context.refresh(), this;
    }, t.prototype.removeAll = function() {
        for(var t in this._sounds)this._sounds[t].destroy(), delete this._sounds[t];
        return this;
    }, t.prototype.stopAll = function() {
        for(var t in this._sounds)this._sounds[t].stop();
        return this;
    }, t.prototype.exists = function(t, e) {
        return void 0 === e && (e = !1), !!this._sounds[t];
    }, t.prototype.find = function(t) {
        return this.exists(t, !0), this._sounds[t];
    }, t.prototype.play = function(t, e) {
        return this.find(t).play(e);
    }, t.prototype.stop = function(t) {
        return this.find(t).stop();
    }, t.prototype.pause = function(t) {
        return this.find(t).pause();
    }, t.prototype.resume = function(t) {
        return this.find(t).resume();
    }, t.prototype.volume = function(t, e) {
        var n = this.find(t);
        return void 0 !== e && (n.volume = e), n.volume;
    }, t.prototype.speed = function(t, e) {
        var n = this.find(t);
        return void 0 !== e && (n.speed = e), n.speed;
    }, t.prototype.duration = function(t) {
        return this.find(t).duration;
    }, t.prototype.close = function() {
        return this.removeAll(), this._sounds = null, this._webAudioContext && (this._webAudioContext.destroy(), this._webAudioContext = null), this._htmlAudioContext && (this._htmlAudioContext.destroy(), this._htmlAudioContext = null), this._context = null, this;
    }, t;
}(), L = {
    __proto__: null,
    HTMLAudioMedia: g,
    HTMLAudioInstance: m,
    HTMLAudioContext: F
}, S = function() {
    function t(t, e) {
        this.init(t, e);
    }
    return t.prototype.init = function(t, e) {
        this.destination = t, this.source = e || t;
    }, t.prototype.connect = function(t) {
        this.source.connect(t);
    }, t.prototype.disconnect = function() {
        this.source.disconnect();
    }, t.prototype.destroy = function() {
        this.disconnect(), this.destination = null, this.source = null;
    }, t;
}(), k = {
    __proto__: null,
    Filter: S,
    EqualizerFilter: function(t) {
        function e(n, o, i, r, u, a, c, l, p, h) {
            void 0 === n && (n = 0), void 0 === o && (o = 0), void 0 === i && (i = 0), void 0 === r && (r = 0), void 0 === u && (u = 0), void 0 === a && (a = 0), void 0 === c && (c = 0), void 0 === l && (l = 0), void 0 === p && (p = 0), void 0 === h && (h = 0);
            var f = this;
            if (!s().useLegacy) {
                var d = [
                    {
                        f: e.F32,
                        type: "lowshelf",
                        gain: n
                    },
                    {
                        f: e.F64,
                        type: "peaking",
                        gain: o
                    },
                    {
                        f: e.F125,
                        type: "peaking",
                        gain: i
                    },
                    {
                        f: e.F250,
                        type: "peaking",
                        gain: r
                    },
                    {
                        f: e.F500,
                        type: "peaking",
                        gain: u
                    },
                    {
                        f: e.F1K,
                        type: "peaking",
                        gain: a
                    },
                    {
                        f: e.F2K,
                        type: "peaking",
                        gain: c
                    },
                    {
                        f: e.F4K,
                        type: "peaking",
                        gain: l
                    },
                    {
                        f: e.F8K,
                        type: "peaking",
                        gain: p
                    },
                    {
                        f: e.F16K,
                        type: "highshelf",
                        gain: h
                    }
                ].map(function(t) {
                    var e = s().context.audioContext.createBiquadFilter();
                    return e.type = t.type, v.setParamValue(e.Q, 1), e.frequency.value = t.f, v.setParamValue(e.gain, t.gain), e;
                });
                (f = t.call(this, d[0], d[d.length - 1]) || this).bands = d, f.bandsMap = {};
                for(var _ = 0; _ < f.bands.length; _++){
                    var y = f.bands[_];
                    _ > 0 && f.bands[_ - 1].connect(y), f.bandsMap[y.frequency.value] = y;
                }
                return f;
            }
            f = t.call(this, null) || this;
        }
        return a(e, t), e.prototype.setGain = function(t, e) {
            if (void 0 === e && (e = 0), !this.bandsMap[t]) throw new Error("No band found for frequency ".concat(t));
            v.setParamValue(this.bandsMap[t].gain, e);
        }, e.prototype.getGain = function(t) {
            if (!this.bandsMap[t]) throw new Error("No band found for frequency ".concat(t));
            return this.bandsMap[t].gain.value;
        }, Object.defineProperty(e.prototype, "f32", {
            get: function() {
                return this.getGain(e.F32);
            },
            set: function(t) {
                this.setGain(e.F32, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f64", {
            get: function() {
                return this.getGain(e.F64);
            },
            set: function(t) {
                this.setGain(e.F64, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f125", {
            get: function() {
                return this.getGain(e.F125);
            },
            set: function(t) {
                this.setGain(e.F125, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f250", {
            get: function() {
                return this.getGain(e.F250);
            },
            set: function(t) {
                this.setGain(e.F250, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f500", {
            get: function() {
                return this.getGain(e.F500);
            },
            set: function(t) {
                this.setGain(e.F500, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f1k", {
            get: function() {
                return this.getGain(e.F1K);
            },
            set: function(t) {
                this.setGain(e.F1K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f2k", {
            get: function() {
                return this.getGain(e.F2K);
            },
            set: function(t) {
                this.setGain(e.F2K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f4k", {
            get: function() {
                return this.getGain(e.F4K);
            },
            set: function(t) {
                this.setGain(e.F4K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f8k", {
            get: function() {
                return this.getGain(e.F8K);
            },
            set: function(t) {
                this.setGain(e.F8K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f16k", {
            get: function() {
                return this.getGain(e.F16K);
            },
            set: function(t) {
                this.setGain(e.F16K, t);
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.reset = function() {
            this.bands.forEach(function(t) {
                v.setParamValue(t.gain, 0);
            });
        }, e.prototype.destroy = function() {
            this.bands.forEach(function(t) {
                t.disconnect();
            }), this.bands = null, this.bandsMap = null;
        }, e.F32 = 32, e.F64 = 64, e.F125 = 125, e.F250 = 250, e.F500 = 500, e.F1K = 1e3, e.F2K = 2e3, e.F4K = 4e3, e.F8K = 8e3, e.F16K = 16e3, e;
    }(S),
    DistortionFilter: function(t) {
        function e(e) {
            void 0 === e && (e = 0);
            var n = this;
            if (!s().useLegacy) {
                var o = s().context.audioContext.createWaveShaper();
                return (n = t.call(this, o) || this)._distortion = o, n.amount = e, n;
            }
            n = t.call(this, null) || this;
        }
        return a(e, t), Object.defineProperty(e.prototype, "amount", {
            get: function() {
                return this._amount;
            },
            set: function(t) {
                this._amount = t;
                for(var e, n = 1e3 * t, o = 44100, i = new Float32Array(o), r = Math.PI / 180, s = 0; s < o; ++s)e = 2 * s / o - 1, i[s] = (3 + n) * e * 20 * r / (Math.PI + n * Math.abs(e));
                this._distortion.curve = i, this._distortion.oversample = "4x";
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.destroy = function() {
            this._distortion = null, t.prototype.destroy.call(this);
        }, e;
    }(S),
    StereoFilter: function(t) {
        function e(e) {
            void 0 === e && (e = 0);
            var n = this;
            if (!s().useLegacy) {
                var o, i, r, u = s().context.audioContext;
                return u.createStereoPanner ? r = o = u.createStereoPanner() : ((i = u.createPanner()).panningModel = "equalpower", r = i), (n = t.call(this, r) || this)._stereo = o, n._panner = i, n.pan = e, n;
            }
            n = t.call(this, null) || this;
        }
        return a(e, t), Object.defineProperty(e.prototype, "pan", {
            get: function() {
                return this._pan;
            },
            set: function(t) {
                this._pan = t, this._stereo ? v.setParamValue(this._stereo.pan, t) : this._panner.setPosition(t, 0, 1 - Math.abs(t));
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.destroy = function() {
            t.prototype.destroy.call(this), this._stereo = null, this._panner = null;
        }, e;
    }(S),
    ReverbFilter: function(t) {
        function e(e, n, o) {
            void 0 === e && (e = 3), void 0 === n && (n = 2), void 0 === o && (o = !1);
            var i = this;
            if (!s().useLegacy) return (i = t.call(this, null) || this)._seconds = i._clamp(e, 1, 50), i._decay = i._clamp(n, 0, 100), i._reverse = o, i._rebuild(), i;
            i = t.call(this, null) || this;
        }
        return a(e, t), e.prototype._clamp = function(t, e, n) {
            return Math.min(n, Math.max(e, t));
        }, Object.defineProperty(e.prototype, "seconds", {
            get: function() {
                return this._seconds;
            },
            set: function(t) {
                this._seconds = this._clamp(t, 1, 50), this._rebuild();
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "decay", {
            get: function() {
                return this._decay;
            },
            set: function(t) {
                this._decay = this._clamp(t, 0, 100), this._rebuild();
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "reverse", {
            get: function() {
                return this._reverse;
            },
            set: function(t) {
                this._reverse = t, this._rebuild();
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype._rebuild = function() {
            for(var t, e = s().context.audioContext, n = e.sampleRate, o = n * this._seconds, i = e.createBuffer(2, o, n), r = i.getChannelData(0), u = i.getChannelData(1), a = 0; a < o; a++)t = this._reverse ? o - a : a, r[a] = (2 * Math.random() - 1) * Math.pow(1 - t / o, this._decay), u[a] = (2 * Math.random() - 1) * Math.pow(1 - t / o, this._decay);
            var c = s().context.audioContext.createConvolver();
            c.buffer = i, this.init(c);
        }, e;
    }(S),
    MonoFilter: function(t) {
        function e() {
            var e = this;
            if (!s().useLegacy) {
                var n = s().context.audioContext, o = n.createChannelSplitter(), i = n.createChannelMerger();
                return i.connect(o), (e = t.call(this, i, o) || this)._merger = i, e;
            }
            e = t.call(this, null) || this;
        }
        return a(e, t), e.prototype.destroy = function() {
            this._merger.disconnect(), this._merger = null, t.prototype.destroy.call(this);
        }, e;
    }(S),
    StreamFilter: function(t) {
        function e() {
            var e = this;
            if (!s().useLegacy) {
                var n = s().context.audioContext, o = n.createMediaStreamDestination(), i = n.createMediaStreamSource(o.stream);
                return (e = t.call(this, o, i) || this)._stream = o.stream, e;
            }
            e = t.call(this, null) || this;
        }
        return a(e, t), Object.defineProperty(e.prototype, "stream", {
            get: function() {
                return this._stream;
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.destroy = function() {
            this._stream = null, t.prototype.destroy.call(this);
        }, e;
    }(S),
    TelephoneFilter: function(t) {
        function e() {
            if (!s().useLegacy) {
                var e = s().context.audioContext, n = e.createBiquadFilter(), o = e.createBiquadFilter(), i = e.createBiquadFilter(), r = e.createBiquadFilter();
                return n.type = "lowpass", v.setParamValue(n.frequency, 2e3), o.type = "lowpass", v.setParamValue(o.frequency, 2e3), i.type = "highpass", v.setParamValue(i.frequency, 500), r.type = "highpass", v.setParamValue(r.frequency, 500), n.connect(o), o.connect(i), i.connect(r), t.call(this, n, r) || this;
            }
            t.call(this, null);
        }
        return a(e, t), e;
    }(S)
}, M = {
    __proto__: null,
    WebAudioMedia: w,
    WebAudioInstance: x,
    WebAudioNodes: j,
    WebAudioContext: C,
    WebAudioUtils: v
}, T = 0;
var G = {
    __proto__: null,
    playOnce: function(t, e) {
        var n = "alias".concat(T++);
        return s().add(n, {
            url: t,
            preload: !0,
            autoPlay: !0,
            loaded: function(t) {
                t && (s().remove(n), e && e(t));
            },
            complete: function() {
                s().remove(n), e && e(null);
            }
        }), n;
    },
    get PLAY_ID () {
        return T;
    },
    render: function(t, e) {
        var n = document.createElement("canvas");
        e = c({
            width: 512,
            height: 128,
            fill: "black"
        }, e || {}), n.width = e.width, n.height = e.height;
        var o = (0, $klOfb.BaseTexture).from(n);
        if (!(t.media instanceof w)) return o;
        var r = t.media, s = n.getContext("2d");
        s.fillStyle = e.fill;
        for(var u = r.buffer.getChannelData(0), a = Math.ceil(u.length / e.width), l = e.height / 2, p = 0; p < e.width; p++){
            for(var h = 1, f = -1, d = 0; d < a; d++){
                var _ = u[p * a + d];
                _ < h && (h = _), _ > f && (f = _);
            }
            s.fillRect(p, (1 + h) * l, 1, Math.max(1, (f - h) * l));
        }
        return o;
    },
    resolveUrl: d,
    sineTone: function(t, e) {
        void 0 === t && (t = 200), void 0 === e && (e = 1);
        var n = A.from({
            singleInstance: !0
        });
        if (!(n.media instanceof w)) return n;
        for(var o = n.media, i = n.context.audioContext.createBuffer(1, 48e3 * e, 48e3), r = i.getChannelData(0), s = 0; s < r.length; s++){
            var u = t * (s / i.sampleRate) * Math.PI;
            r[s] = 2 * Math.sin(u);
        }
        return o.buffer = i, n.isLoaded = !0, n;
    },
    validateFormats: h,
    supported: p,
    extensions: l
}, I = function(t) {
    return r = t, t;
}(new E);
(0, $kXE1p.Loader).registerPlugin(_);

});

parcelRegister("2ZTWb", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("xnasA", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("huIqu", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("jSeQD", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("cEbON", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("iBJuF", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("5UG8I", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $4f3c196954fdbf9a$export$af88d00dbe7f521; });

var $3C0Nn = parcelRequire("3C0Nn");
class $4f3c196954fdbf9a$export$3081f6083935bfeb {
    constructor(config = {}){
        this.config = {
            level: config.level || "info",
            allowedTags: config.allowedTags || [],
            minLevel: config.minLevel || 30,
            serverEndpoint: config.serverEndpoint || "http://localhost:8080/log",
            enableServerLogging: config.enableServerLogging || false
        };
        // Check if we're in a browser environment
        const isBrowser = typeof window !== "undefined";
        if (isBrowser) // Browser environment - use basic pino without transport
        this.logger = (0, (/*@__PURE__*/$parcel$interopDefault($3C0Nn)))({
            level: this.config.level,
            browser: {
                asObject: false,
                write: (o)=>{
                    // Custom pretty printing for browser
                    const level = o.level;
                    const date = new Date(o.time);
                    const time = date.toTimeString().split(" ")[0] + "." + date.getMilliseconds().toString().padStart(3, "0");
                    const msg = o.msg || "";
                    const tags = o.tags ? ` [${o.tags.join(", ")}]` : "";
                    const extra = Object.keys(o).filter((k)=>![
                            "level",
                            "time",
                            "msg",
                            "tags"
                        ].includes(k)).map((k)=>`${k}: ${JSON.stringify(o[k])}`).join(" ");
                    const levelColors = {
                        10: "\x1b[90m",
                        20: "\x1b[36m",
                        30: "\x1b[32m",
                        40: "\x1b[33m",
                        50: "\x1b[31m",
                        60: "\x1b[35m"
                    };
                    const levelNames = {
                        10: "TRACE",
                        20: "DEBUG",
                        30: "INFO",
                        40: "WARN",
                        50: "ERROR",
                        60: "FATAL"
                    };
                    const color = levelColors[level] || "";
                    const reset = "\x1b[0m";
                    const levelName = levelNames[level] || "LOG";
                    console.log(`${color}[${time}]${reset} ${msg}${extra ? " " + extra : ""}`);
                }
            }
        });
        else // Node.js environment - use pino-pretty
        this.logger = (0, (/*@__PURE__*/$parcel$interopDefault($3C0Nn)))({
            level: this.config.level,
            transport: {
                target: "pino-pretty",
                options: {
                    colorize: true,
                    translateTime: "HH:MM:ss.SSS",
                    ignore: "pid,hostname",
                    singleLine: false,
                    hideObject: false
                }
            }
        });
        // Output configuration on initialization
        this.logConfiguration();
    }
    // Log current configuration
    logConfiguration() {
        const tagFilter = this.config.allowedTags.length > 0 ? `Tags: [${this.config.allowedTags.join(", ")}] (OR logic)` : "Tags: All (no filtering)";
        const levelFilter = `Level: ${this.config.level} (min: ${this.config.minLevel})`;
        console.log(`\u{1F527} Logger initialized - ${levelFilter}, ${tagFilter}`);
    }
    // Update configuration at runtime
    updateConfig(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
        // Update logger level if changed
        if (newConfig.level) this.logger.level = newConfig.level;
        // Log updated configuration
        this.logConfiguration();
    }
    // Convenience method to update only the allowed tags
    setAllowedTags(tags) {
        this.updateConfig({
            allowedTags: tags
        });
    }
    // Convenience method to add tags to the current allowed tags
    addAllowedTags(tags) {
        const currentTags = this.config.allowedTags || [];
        const newTags = [
            ...new Set([
                ...currentTags,
                ...tags
            ])
        ] // Remove duplicates
        ;
        this.updateConfig({
            allowedTags: newTags
        });
    }
    // Convenience method to remove tags from the current allowed tags
    removeAllowedTags(tags) {
        const currentTags = this.config.allowedTags || [];
        const newTags = currentTags.filter((tag)=>!tags.includes(tag));
        this.updateConfig({
            allowedTags: newTags
        });
    }
    // Convenience method to clear all tag filtering (allow all logs)
    clearTagFilter() {
        this.updateConfig({
            allowedTags: []
        });
    }
    // Convenience method to enable/disable server logging
    setServerLogging(enabled, endpoint) {
        this.updateConfig({
            enableServerLogging: enabled,
            serverEndpoint: endpoint || this.config.serverEndpoint
        });
    }
    // Get current configuration
    getConfig() {
        return {
            ...this.config
        };
    }
    shouldLog(level, logData) {
        // Check if log level meets minimum requirement
        if (level < this.config.minLevel) return false;
        // If no tags are specified, allow all logs
        if (this.config.allowedTags.length === 0) return true;
        // Check if the log has tags and if ANY of them are in allowedTags
        if (typeof logData === "object" && logData && logData.tags && Array.isArray(logData.tags)) // Check if any log tag is in the allowed tags
        return logData.tags.some((tag)=>this.config.allowedTags.includes(tag));
        else // If no tags in the log but tags are required, don't log
        return false;
    }
    // Log methods that match pino's API
    trace(obj, msg, ...args) {
        if (this.shouldLog(10, obj)) {
            this.logger.trace(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("trace", msg || "", tags, extra);
            }
        }
    }
    debug(obj, msg, ...args) {
        if (this.shouldLog(20, obj)) {
            this.logger.debug(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("debug", msg || "", tags, extra);
            }
        }
    }
    info(obj, msg, ...args) {
        if (this.shouldLog(30, obj)) {
            this.logger.info(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("info", msg || "", tags, extra);
            }
        }
    }
    warn(obj, msg, ...args) {
        if (this.shouldLog(40, obj)) {
            this.logger.warn(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("warn", msg || "", tags, extra);
            }
        }
    }
    error(obj, msg, ...args) {
        if (this.shouldLog(50, obj)) {
            this.logger.error(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("error", msg || "", tags, extra);
            }
        }
    }
    fatal(obj, msg, ...args) {
        if (this.shouldLog(60, obj)) {
            this.logger.fatal(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("fatal", msg || "", tags, extra);
            }
        }
    }
    // Send log to server endpoint
    async sendToServer(level, msg, tags, extra) {
        if (!this.config.enableServerLogging || !this.config.serverEndpoint) return;
        try {
            const logData = {
                level: level,
                msg: msg,
                tags: tags || [],
                timestamp: new Date().toISOString(),
                extra: extra
            };
            await fetch(this.config.serverEndpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(logData)
            });
        } catch (error) {
            // Silently fail to avoid infinite logging loops
            console.warn("Failed to send log to server:", error);
        }
    }
    // Convenience method for simple string logging
    log(msg, tags) {
        if (tags) this.info({
            tags: tags
        }, msg);
        else this.info(msg);
    }
}
const $4f3c196954fdbf9a$export$af88d00dbe7f521 = new $4f3c196954fdbf9a$export$3081f6083935bfeb({
    allowedTags: [
        "viewport",
        "callback",
        "animation",
        "map",
        "damage"
    ],
    level: "debug",
    minLevel: 10,
    enableServerLogging: false,
    serverEndpoint: "http://localhost:8080/log"
});

});
parcelRegister("3C0Nn", function(module, exports) {
'use strict';

var $bb5r4 = parcelRequire("bb5r4");
module.exports = $2a1589ac5e33c3f7$var$pino;
const $2a1589ac5e33c3f7$var$_console = $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback().console || {};
const $2a1589ac5e33c3f7$var$stdSerializers = {
    mapHttpRequest: $2a1589ac5e33c3f7$var$mock,
    mapHttpResponse: $2a1589ac5e33c3f7$var$mock,
    wrapRequestSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapResponseSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapErrorSerializer: $2a1589ac5e33c3f7$var$passthrough,
    req: $2a1589ac5e33c3f7$var$mock,
    res: $2a1589ac5e33c3f7$var$mock,
    err: $2a1589ac5e33c3f7$var$asErrValue,
    errWithCause: $2a1589ac5e33c3f7$var$asErrValue
};
function $2a1589ac5e33c3f7$var$levelToValue(level, logger) {
    return level === 'silent' ? Infinity : logger.levels.values[level];
}
const $2a1589ac5e33c3f7$var$baseLogFunctionSymbol = Symbol('pino.logFuncs');
const $2a1589ac5e33c3f7$var$hierarchySymbol = Symbol('pino.hierarchy');
const $2a1589ac5e33c3f7$var$logFallbackMap = {
    error: 'log',
    fatal: 'error',
    warn: 'error',
    info: 'log',
    debug: 'log',
    trace: 'log'
};
function $2a1589ac5e33c3f7$var$appendChildLogger(parentLogger, childLogger) {
    const newEntry = {
        logger: childLogger,
        parent: parentLogger[$2a1589ac5e33c3f7$var$hierarchySymbol]
    };
    childLogger[$2a1589ac5e33c3f7$var$hierarchySymbol] = newEntry;
}
function $2a1589ac5e33c3f7$var$setupBaseLogFunctions(logger, levels, proto) {
    const logFunctions = {};
    levels.forEach((level)=>{
        logFunctions[level] = proto[level] ? proto[level] : $2a1589ac5e33c3f7$var$_console[level] || $2a1589ac5e33c3f7$var$_console[$2a1589ac5e33c3f7$var$logFallbackMap[level] || 'log'] || $2a1589ac5e33c3f7$var$noop;
    });
    logger[$2a1589ac5e33c3f7$var$baseLogFunctionSymbol] = logFunctions;
}
function $2a1589ac5e33c3f7$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== '!stdSerializers.err';
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $2a1589ac5e33c3f7$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== 'function') throw Error('pino: transmit option must have a send function');
    const proto = opts.browser.write || $2a1589ac5e33c3f7$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $2a1589ac5e33c3f7$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf('!stdSerializers.err') > -1) stdErrSerialize = false;
    const customLevels = Object.keys(opts.customLevels || {});
    const levels = [
        'error',
        'fatal',
        'warn',
        'info',
        'debug',
        'trace'
    ].concat(customLevels);
    if (typeof proto === 'function') levels.forEach(function(level) {
        proto[level] = proto;
    });
    if (opts.enabled === false || opts.browser.disabled) opts.level = 'silent';
    const level = opts.level || 'info';
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $2a1589ac5e33c3f7$var$noop;
    $2a1589ac5e33c3f7$var$setupBaseLogFunctions(logger, levels, proto);
    // setup root hierarchy entry
    $2a1589ac5e33c3f7$var$appendChildLogger({}, logger);
    Object.defineProperty(logger, 'levelVal', {
        get: getLevelVal
    });
    Object.defineProperty(logger, 'level', {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        formatters: opts.browser.formatters,
        levels: levels,
        timestamp: $2a1589ac5e33c3f7$var$getTimeFunction(opts)
    };
    logger.levels = $2a1589ac5e33c3f7$var$getLevels(opts);
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $2a1589ac5e33c3f7$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape();
    function getLevelVal() {
        return $2a1589ac5e33c3f7$var$levelToValue(this.level, this);
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== 'silent' && !this.levels.values[level]) throw Error('unknown level ' + level);
        this._level = level;
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'error') // <-- must stay first
        ;
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'fatal');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'warn');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'info');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'debug');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'trace');
        customLevels.forEach((level)=>{
            $2a1589ac5e33c3f7$var$set(this, setOpts, logger, level);
        });
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error('missing bindings for child Pino');
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $2a1589ac5e33c3f7$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            // make sure bindings are available in the `set` function
            this.bindings = bindings;
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        const newLogger = new Child(this);
        // must happen before the level is assigned
        $2a1589ac5e33c3f7$var$appendChildLogger(this, newLogger);
        // required to actually initialize the logger functions for any given child
        newLogger.level = this.level;
        return newLogger;
    }
    return logger;
}
function $2a1589ac5e33c3f7$var$getLevels(opts) {
    const customLevels = opts.customLevels || {};
    const values = Object.assign({}, $2a1589ac5e33c3f7$var$pino.levels.values, customLevels);
    const labels = Object.assign({}, $2a1589ac5e33c3f7$var$pino.levels.labels, $2a1589ac5e33c3f7$var$invertObject(customLevels));
    return {
        values: values,
        labels: labels
    };
}
function $2a1589ac5e33c3f7$var$invertObject(obj) {
    const inverted = {};
    Object.keys(obj).forEach(function(key) {
        inverted[obj[key]] = key;
    });
    return inverted;
}
$2a1589ac5e33c3f7$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: 'trace',
        20: 'debug',
        30: 'info',
        40: 'warn',
        50: 'error',
        60: 'fatal'
    }
};
$2a1589ac5e33c3f7$var$pino.stdSerializers = $2a1589ac5e33c3f7$var$stdSerializers;
$2a1589ac5e33c3f7$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $2a1589ac5e33c3f7$var$nullTime,
    epochTime: $2a1589ac5e33c3f7$var$epochTime,
    unixTime: $2a1589ac5e33c3f7$var$unixTime,
    isoTime: $2a1589ac5e33c3f7$var$isoTime
});
function $2a1589ac5e33c3f7$var$getBindingChain(logger) {
    const bindings = [];
    if (logger.bindings) bindings.push(logger.bindings);
    // traverse up the tree to get all bindings
    let hierarchy = logger[$2a1589ac5e33c3f7$var$hierarchySymbol];
    while(hierarchy.parent){
        hierarchy = hierarchy.parent;
        if (hierarchy.logger.bindings) bindings.push(hierarchy.logger.bindings);
    }
    return bindings.reverse();
}
function $2a1589ac5e33c3f7$var$set(self1, opts, rootLogger, level) {
    // override the current log functions with either `noop` or the base log function
    Object.defineProperty(self1, level, {
        value: $2a1589ac5e33c3f7$var$levelToValue(self1.level, rootLogger) > $2a1589ac5e33c3f7$var$levelToValue(level, rootLogger) ? $2a1589ac5e33c3f7$var$noop : rootLogger[$2a1589ac5e33c3f7$var$baseLogFunctionSymbol][level],
        writable: true,
        enumerable: true,
        configurable: true
    });
    if (!opts.transmit && self1[level] === $2a1589ac5e33c3f7$var$noop) return;
    // make sure the log format is correct
    self1[level] = $2a1589ac5e33c3f7$var$createWrap(self1, opts, rootLogger, level);
    // prepend bindings if it is not the root logger
    const bindings = $2a1589ac5e33c3f7$var$getBindingChain(self1);
    if (bindings.length === 0) // early exit in case for rootLogger
    return;
    self1[level] = $2a1589ac5e33c3f7$var$prependBindingsInArguments(bindings, self1[level]);
}
function $2a1589ac5e33c3f7$var$prependBindingsInArguments(bindings, logFunc) {
    return function() {
        return logFunc.apply(this, [
            ...bindings,
            ...arguments
        ]);
    };
}
function $2a1589ac5e33c3f7$var$createWrap(self1, opts, rootLogger, level) {
    return function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $2a1589ac5e33c3f7$var$_console ? $2a1589ac5e33c3f7$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $2a1589ac5e33c3f7$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject || opts.formatters) write.call(proto, $2a1589ac5e33c3f7$var$asObject(this, level, args, ts, opts.formatters));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || self1._level;
                const transmitValue = rootLogger.levels.values[transmitLevel];
                const methodValue = rootLogger.levels.values[level];
                if (methodValue < transmitValue) return;
                $2a1589ac5e33c3f7$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: rootLogger.levels.values[opts.transmit.level || self1._level],
                    send: opts.transmit.send,
                    val: $2a1589ac5e33c3f7$var$levelToValue(self1._level, rootLogger)
                }, args);
            }
        };
    }(self1[$2a1589ac5e33c3f7$var$baseLogFunctionSymbol][level]);
}
function $2a1589ac5e33c3f7$var$asObject(logger, level, args, ts, formatters = {}) {
    const { level: levelFormatter = ()=>logger.levels.values[level], log: logObjectFormatter = (obj)=>obj } = formatters;
    if (logger._serialize) $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const logObject = {};
    if (ts) logObject.time = ts;
    logObject.level = levelFormatter(level, logger.levels.values[level]);
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === 'object') {
        while(lvl-- && typeof argsCloned[0] === 'object')Object.assign(logObject, argsCloned.shift());
        msg = argsCloned.length ? $bb5r4(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === 'string') msg = $bb5r4(argsCloned.shift(), argsCloned);
    if (msg !== undefined) logObject.msg = msg;
    const formattedLogObject = logObjectFormatter(logObject);
    return formattedLogObject;
}
function $2a1589ac5e33c3f7$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $2a1589ac5e33c3f7$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $2a1589ac5e33c3f7$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape(bindings);
}
function $2a1589ac5e33c3f7$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: '',
            value: 0
        }
    };
}
function $2a1589ac5e33c3f7$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $2a1589ac5e33c3f7$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === 'function') return opts.timestamp;
    if (opts.timestamp === false) return $2a1589ac5e33c3f7$var$nullTime;
    return $2a1589ac5e33c3f7$var$epochTime;
}
function $2a1589ac5e33c3f7$var$mock() {
    return {};
}
function $2a1589ac5e33c3f7$var$passthrough(a) {
    return a;
}
function $2a1589ac5e33c3f7$var$noop() {}
function $2a1589ac5e33c3f7$var$nullTime() {
    return false;
}
function $2a1589ac5e33c3f7$var$epochTime() {
    return Date.now();
}
function $2a1589ac5e33c3f7$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $2a1589ac5e33c3f7$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== 'undefined' && o;
    }
    try {
        if (typeof globalThis !== 'undefined') return globalThis;
        Object.defineProperty(Object.prototype, 'globalThis', {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
}
/* eslint-enable */ module.exports.default = $2a1589ac5e33c3f7$var$pino;
module.exports.pino = $2a1589ac5e33c3f7$var$pino;

});
parcelRegister("bb5r4", function(module, exports) {
'use strict';
function $8234f0346c62e618$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $8234f0346c62e618$var$format;
function $8234f0346c62e618$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $8234f0346c62e618$var$tryStringify;
    var offset = 1;
    if (typeof f === 'object' && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(' ');
    }
    if (typeof f !== 'string') return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = '';
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === 'string') {
                        str += '\'' + args[a] + '\'';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === 'function') {
                        str += args[a].name || '<anonymous>';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += '%';
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});



parcelRegister("8JEKL", function(module, exports) {

(function(pkg) {
    const PIXI1 = pkg.PIXI;
    class TextInput extends PIXI1.Container {
        constructor(styles){
            super();
            this._input_style = Object.assign({
                position: 'absolute',
                background: 'none',
                border: 'none',
                outline: 'none',
                transformOrigin: '0 0',
                lineHeight: '1'
            }, styles.input);
            if (styles.box) this._box_generator = typeof styles.box === 'function' ? styles.box : new DefaultBoxGenerator(styles.box);
            else this._box_generator = null;
            if (this._input_style.hasOwnProperty('multiline')) {
                this._multiline = !!this._input_style.multiline;
                delete this._input_style.multiline;
            } else this._multiline = false;
            this._box_cache = {};
            this._previous = {};
            this._dom_added = false;
            this._dom_visible = true;
            this._placeholder = '';
            this._placeholderColor = 0xa9a9a9;
            this._selection = [
                0,
                0
            ];
            this._restrict_value = '';
            this._createDOMInput();
            this.substituteText = true;
            this._setState('DEFAULT');
            this._addListeners();
        }
        // GETTERS & SETTERS
        get substituteText() {
            return this._substituted;
        }
        set substituteText(substitute) {
            if (this._substituted == substitute) return;
            this._substituted = substitute;
            if (substitute) {
                this._createSurrogate();
                this._dom_visible = false;
            } else {
                this._destroySurrogate();
                this._dom_visible = true;
            }
            this.placeholder = this._placeholder;
            this._update();
        }
        get placeholder() {
            return this._placeholder;
        }
        set placeholder(text) {
            this._placeholder = text;
            if (this._substituted) {
                this._updateSurrogate();
                this._dom_input.placeholder = '';
            } else this._dom_input.placeholder = text;
        }
        get disabled() {
            return this._disabled;
        }
        set disabled(disabled) {
            this._disabled = disabled;
            this._dom_input.disabled = disabled;
            this._setState(disabled ? 'DISABLED' : 'DEFAULT');
        }
        get maxLength() {
            return this._max_length;
        }
        set maxLength(length) {
            this._max_length = length;
            this._dom_input.setAttribute('maxlength', length);
        }
        get restrict() {
            return this._restrict_regex;
        }
        set restrict(regex) {
            if (regex instanceof RegExp) {
                regex = regex.toString().slice(1, -1);
                if (regex.charAt(0) !== '^') regex = '^' + regex;
                if (regex.charAt(regex.length - 1) !== '$') regex = regex + '$';
                regex = new RegExp(regex);
            } else regex = new RegExp('^[' + regex + ']*$');
            this._restrict_regex = regex;
        }
        get text() {
            return this._dom_input.value;
        }
        set text(text) {
            this._dom_input.value = text;
            if (this._substituted) this._updateSurrogate();
        }
        get htmlInput() {
            return this._dom_input;
        }
        focus() {
            if (this._substituted && !this.dom_visible) this._setDOMInputVisible(true);
            this._dom_input.focus();
        }
        blur() {
            this._dom_input.blur();
        }
        select() {
            this.focus();
            this._dom_input.select();
        }
        setInputStyle(key, value) {
            this._input_style[key] = value;
            this._dom_input.style[key] = value;
            if (this._substituted && (key === 'fontFamily' || key === 'fontSize')) this._updateFontMetrics();
            if (this._last_renderer) this._update();
        }
        destroy(options) {
            this._destroyBoxCache();
            super.destroy(options);
        }
        // SETUP
        _createDOMInput() {
            if (this._multiline) {
                this._dom_input = document.createElement('textarea');
                this._dom_input.style.resize = 'none';
            } else {
                this._dom_input = document.createElement('input');
                this._dom_input.type = 'text';
            }
            for(let key in this._input_style)this._dom_input.style[key] = this._input_style[key];
        }
        _addListeners() {
            this.on('added', this._onAdded.bind(this));
            this.on('removed', this._onRemoved.bind(this));
            this._dom_input.addEventListener('keydown', this._onInputKeyDown.bind(this));
            this._dom_input.addEventListener('input', this._onInputInput.bind(this));
            this._dom_input.addEventListener('keyup', this._onInputKeyUp.bind(this));
            this._dom_input.addEventListener('focus', this._onFocused.bind(this));
            this._dom_input.addEventListener('blur', this._onBlurred.bind(this));
        }
        _onInputKeyDown(e) {
            this._selection = [
                this._dom_input.selectionStart,
                this._dom_input.selectionEnd
            ];
            this.emit('keydown', e.keyCode);
        }
        _onInputInput(e) {
            if (this._restrict_regex) this._applyRestriction();
            if (this._substituted) this._updateSubstitution();
            this.emit('input', this.text);
        }
        _onInputKeyUp(e) {
            this.emit('keyup', e.keyCode);
        }
        _onFocused() {
            this._setState('FOCUSED');
            this.emit('focus');
        }
        _onBlurred() {
            this._setState('DEFAULT');
            this.emit('blur');
        }
        _onAdded() {
            document.body.appendChild(this._dom_input);
            this._dom_input.style.display = 'none';
            this._dom_added = true;
        }
        _onRemoved() {
            document.body.removeChild(this._dom_input);
            this._dom_added = false;
        }
        _setState(state) {
            this.state = state;
            this._updateBox();
            if (this._substituted) this._updateSubstitution();
        }
        // RENDER & UPDATE
        // for pixi v4
        renderWebGL(renderer) {
            super.renderWebGL(renderer);
            this._renderInternal(renderer);
        }
        // for pixi v4
        renderCanvas(renderer) {
            super.renderCanvas(renderer);
            this._renderInternal(renderer);
        }
        // for pixi v5
        render(renderer) {
            super.render(renderer);
            this._renderInternal(renderer);
        }
        _renderInternal(renderer) {
            this._resolution = renderer.resolution;
            this._last_renderer = renderer;
            this._canvas_bounds = this._getCanvasBounds();
            if (this._needsUpdate()) this._update();
        }
        _update() {
            this._updateDOMInput();
            if (this._substituted) this._updateSurrogate();
            this._updateBox();
        }
        _updateBox() {
            if (!this._box_generator) return;
            if (this._needsNewBoxCache()) this._buildBoxCache();
            if (this.state == this._previous.state && this._box == this._box_cache[this.state]) return;
            if (this._box) this.removeChild(this._box);
            this._box = this._box_cache[this.state];
            this.addChildAt(this._box, 0);
            this._previous.state = this.state;
        }
        _updateSubstitution() {
            if (this.state === 'FOCUSED') {
                this._dom_visible = true;
                this._surrogate.visible = this.text.length === 0;
            } else {
                this._dom_visible = false;
                this._surrogate.visible = true;
            }
            this._updateDOMInput();
            this._updateSurrogate();
        }
        _updateDOMInput() {
            if (!this._canvas_bounds) return;
            this._dom_input.style.top = (this._canvas_bounds.top || 0) + 'px';
            this._dom_input.style.left = (this._canvas_bounds.left || 0) + 'px';
            this._dom_input.style.transform = this._pixiMatrixToCSS(this._getDOMRelativeWorldTransform());
            this._dom_input.style.opacity = this.worldAlpha;
            this._setDOMInputVisible(this.worldVisible && this._dom_visible);
            this._previous.canvas_bounds = this._canvas_bounds;
            this._previous.world_transform = this.worldTransform.clone();
            this._previous.world_alpha = this.worldAlpha;
            this._previous.world_visible = this.worldVisible;
        }
        _applyRestriction() {
            if (this._restrict_regex.test(this.text)) this._restrict_value = this.text;
            else {
                this.text = this._restrict_value;
                this._dom_input.setSelectionRange(this._selection[0], this._selection[1]);
            }
        }
        // STATE COMPAIRSON (FOR PERFORMANCE BENEFITS)
        _needsUpdate() {
            return !this._comparePixiMatrices(this.worldTransform, this._previous.world_transform) || !this._compareClientRects(this._canvas_bounds, this._previous.canvas_bounds) || this.worldAlpha != this._previous.world_alpha || this.worldVisible != this._previous.world_visible;
        }
        _needsNewBoxCache() {
            let input_bounds = this._getDOMInputBounds();
            return !this._previous.input_bounds || input_bounds.width != this._previous.input_bounds.width || input_bounds.height != this._previous.input_bounds.height;
        }
        // INPUT SUBSTITUTION
        _createSurrogate() {
            this._surrogate_hitbox = new PIXI1.Graphics();
            this._surrogate_hitbox.alpha = 0;
            this._surrogate_hitbox.interactive = true;
            this._surrogate_hitbox.cursor = 'text';
            this._surrogate_hitbox.on('pointerdown', this._onSurrogateFocus.bind(this));
            this.addChild(this._surrogate_hitbox);
            this._surrogate_mask = new PIXI1.Graphics();
            this.addChild(this._surrogate_mask);
            this._surrogate = new PIXI1.Text('', {});
            this.addChild(this._surrogate);
            this._surrogate.mask = this._surrogate_mask;
            this._updateFontMetrics();
            this._updateSurrogate();
        }
        _updateSurrogate() {
            let padding = this._deriveSurrogatePadding();
            let input_bounds = this._getDOMInputBounds();
            this._surrogate.style = this._deriveSurrogateStyle();
            this._surrogate.style.padding = Math.max.apply(Math, padding);
            this._surrogate.y = this._multiline ? padding[0] : (input_bounds.height - this._surrogate.height) / 2;
            this._surrogate.x = padding[3];
            this._surrogate.text = this._deriveSurrogateText();
            switch(this._surrogate.style.align){
                case 'left':
                    this._surrogate.x = padding[3];
                    break;
                case 'center':
                    this._surrogate.x = input_bounds.width * 0.5 - this._surrogate.width * 0.5;
                    break;
                case 'right':
                    this._surrogate.x = input_bounds.width - padding[1] - this._surrogate.width;
                    break;
            }
            this._updateSurrogateHitbox(input_bounds);
            this._updateSurrogateMask(input_bounds, padding);
        }
        _updateSurrogateHitbox(bounds) {
            this._surrogate_hitbox.clear();
            this._surrogate_hitbox.beginFill(0);
            this._surrogate_hitbox.drawRect(0, 0, bounds.width, bounds.height);
            this._surrogate_hitbox.endFill();
            this._surrogate_hitbox.interactive = !this._disabled;
        }
        _updateSurrogateMask(bounds, padding) {
            this._surrogate_mask.clear();
            this._surrogate_mask.beginFill(0);
            this._surrogate_mask.drawRect(padding[3], 0, bounds.width - padding[3] - padding[1], bounds.height);
            this._surrogate_mask.endFill();
        }
        _destroySurrogate() {
            if (!this._surrogate) return;
            this.removeChild(this._surrogate);
            this.removeChild(this._surrogate_hitbox);
            this._surrogate.destroy();
            this._surrogate_hitbox.destroy();
            this._surrogate = null;
            this._surrogate_hitbox = null;
        }
        _onSurrogateFocus() {
            this._setDOMInputVisible(true);
            //sometimes the input is not being focused by the mouseclick
            setTimeout(this._ensureFocus.bind(this), 10);
        }
        _ensureFocus() {
            if (!this._hasFocus()) this.focus();
        }
        _deriveSurrogateStyle() {
            let style = new PIXI1.TextStyle();
            for(var key in this._input_style)switch(key){
                case 'color':
                    style.fill = this._input_style.color;
                    break;
                case 'fontFamily':
                case 'fontSize':
                case 'fontWeight':
                case 'fontVariant':
                case 'fontStyle':
                    style[key] = this._input_style[key];
                    break;
                case 'letterSpacing':
                    style.letterSpacing = parseFloat(this._input_style.letterSpacing);
                    break;
                case 'textAlign':
                    style.align = this._input_style.textAlign;
                    break;
            }
            if (this._multiline) {
                style.lineHeight = parseFloat(style.fontSize);
                style.wordWrap = true;
                style.wordWrapWidth = this._getDOMInputBounds().width;
            }
            if (this._dom_input.value.length === 0) style.fill = this._placeholderColor;
            return style;
        }
        _deriveSurrogatePadding() {
            let indent = this._input_style.textIndent ? parseFloat(this._input_style.textIndent) : 0;
            if (this._input_style.padding && this._input_style.padding.length > 0) {
                let components = this._input_style.padding.trim().split(' ');
                if (components.length == 1) {
                    let padding = parseFloat(components[0]);
                    return [
                        padding,
                        padding,
                        padding,
                        padding + indent
                    ];
                } else if (components.length == 2) {
                    let paddingV = parseFloat(components[0]);
                    let paddingH = parseFloat(components[1]);
                    return [
                        paddingV,
                        paddingH,
                        paddingV,
                        paddingH + indent
                    ];
                } else if (components.length == 4) {
                    let padding = components.map((component)=>{
                        return parseFloat(component);
                    });
                    padding[3] += indent;
                    return padding;
                }
            }
            return [
                0,
                0,
                0,
                indent
            ];
        }
        _deriveSurrogateText() {
            if (this._dom_input.value.length === 0) return this._placeholder;
            if (this._dom_input.type == 'password') return "\u2022".repeat(this._dom_input.value.length);
            return this._dom_input.value;
        }
        _updateFontMetrics() {
            const style = this._deriveSurrogateStyle();
            const font = style.toFontString();
            this._font_metrics = PIXI1.TextMetrics.measureFont(font);
        }
        // CACHING OF INPUT BOX GRAPHICS
        _buildBoxCache() {
            this._destroyBoxCache();
            let states = [
                'DEFAULT',
                'FOCUSED',
                'DISABLED'
            ];
            let input_bounds = this._getDOMInputBounds();
            for(let i in states)this._box_cache[states[i]] = this._box_generator(input_bounds.width, input_bounds.height, states[i]);
            this._previous.input_bounds = input_bounds;
        }
        _destroyBoxCache() {
            if (this._box) {
                this.removeChild(this._box);
                this._box = null;
            }
            for(let i in this._box_cache){
                this._box_cache[i].destroy();
                this._box_cache[i] = null;
                delete this._box_cache[i];
            }
        }
        // HELPER FUNCTIONS
        _hasFocus() {
            return document.activeElement === this._dom_input;
        }
        _setDOMInputVisible(visible) {
            this._dom_input.style.display = visible ? 'block' : 'none';
        }
        _getCanvasBounds() {
            let rect = this._last_renderer.view.getBoundingClientRect();
            let bounds = {
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            };
            bounds.left += window.scrollX;
            bounds.top += window.scrollY;
            return bounds;
        }
        _getDOMInputBounds() {
            let remove_after = false;
            if (!this._dom_added) {
                document.body.appendChild(this._dom_input);
                remove_after = true;
            }
            let org_transform = this._dom_input.style.transform;
            let org_display = this._dom_input.style.display;
            this._dom_input.style.transform = '';
            this._dom_input.style.display = 'block';
            let bounds = this._dom_input.getBoundingClientRect();
            this._dom_input.style.transform = org_transform;
            this._dom_input.style.display = org_display;
            if (remove_after) document.body.removeChild(this._dom_input);
            return bounds;
        }
        _getDOMRelativeWorldTransform() {
            let canvas_bounds = this._last_renderer.view.getBoundingClientRect();
            let matrix = this.worldTransform.clone();
            matrix.scale(this._resolution, this._resolution);
            matrix.scale(canvas_bounds.width / this._last_renderer.width, canvas_bounds.height / this._last_renderer.height);
            return matrix;
        }
        _pixiMatrixToCSS(m) {
            return 'matrix(' + [
                m.a,
                m.b,
                m.c,
                m.d,
                m.tx,
                m.ty
            ].join(',') + ')';
        }
        _comparePixiMatrices(m1, m2) {
            if (!m1 || !m2) return false;
            return m1.a == m2.a && m1.b == m2.b && m1.c == m2.c && m1.d == m2.d && m1.tx == m2.tx && m1.ty == m2.ty;
        }
        _compareClientRects(r1, r2) {
            if (!r1 || !r2) return false;
            return r1.left == r2.left && r1.top == r2.top && r1.width == r2.width && r1.height == r2.height;
        }
    }
    function DefaultBoxGenerator(styles) {
        styles = styles || {
            fill: 0xcccccc
        };
        if (styles.default) {
            styles.focused = styles.focused || styles.default;
            styles.disabled = styles.disabled || styles.default;
        } else {
            let temp_styles = styles;
            styles = {};
            styles.default = styles.focused = styles.disabled = temp_styles;
        }
        return function(w, h, state) {
            let style = styles[state.toLowerCase()];
            let box = new PIXI1.Graphics();
            if (style.fill) box.beginFill(style.fill);
            if (style.stroke) box.lineStyle(style.stroke.width || 1, style.stroke.color || 0, style.stroke.alpha || 1);
            if (style.rounded) box.drawRoundedRect(0, 0, w, h, style.rounded);
            else box.drawRect(0, 0, w, h);
            box.endFill();
            box.closePath();
            return box;
        };
    }
    pkg.exportTo[0][pkg.exportTo[1]] = TextInput;
})(typeof PIXI === 'object' ? {
    PIXI: PIXI,
    exportTo: [
        PIXI,
        'TextInput'
    ]
} : {
    PIXI: (parcelRequire("1avo5")),
    exportTo: [
        module,
        'exports'
    ]
});

});

parcelRegister("bW0pk", function(module, exports) {
module.exports = $parcel$import("eInMy").then(()=>parcelRequire('h5Yew'));

});

parcelRegister("f9obu", function(module, exports) {

$parcel$export(module.exports, "ShadowDebugTest", function () { return $2ad4f177bd78ba9a$export$dc8416ded43a30dc; });

var $5UG8I = parcelRequire("5UG8I");

var $aFPGo = parcelRequire("aFPGo");
class $2ad4f177bd78ba9a$export$dc8416ded43a30dc {
    constructor(shadowRendering){
        this.testFrameCount = 0;
        this.maxTestFrames = 100;
        /**
     * Run a test to verify cache behavior
     */ this.runTest = ()=>{
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "[Shadow Debug Test] Starting cache test...");
            this.testFrameCount = 0;
            this.performanceMonitor.reset();
            // Run test for a few frames
            const testInterval = setInterval(()=>{
                this.performanceMonitor.update();
                this.testFrameCount++;
                if (this.testFrameCount >= this.maxTestFrames) {
                    clearInterval(testInterval);
                    this.logTestResults();
                }
            }, 16) // ~60 FPS
            ;
        };
        this.logTestResults = ()=>{
            const metrics = this.performanceMonitor.getMetrics();
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "[Shadow Debug Test] Test Results:");
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Total Frames: ${metrics.totalFrames}`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Cache Hit Rate: ${metrics.cacheHitRate.toFixed(1)}%`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Texture Regen Rate: ${metrics.textureRegenRate.toFixed(1)}%`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Cache Size: ${metrics.cacheSize}/${metrics.maxCacheSize}`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Needs Update: ${metrics.needsUpdate}`);
            // Check if cache is working
            if (metrics.cacheHitRate > 0) (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "\u2705 Cache is working!");
            else (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "\u274C Cache is not working - 0% hit rate");
        };
        /**
     * Force a cache clear to test cache miss behavior
     */ this.forceCacheClear = ()=>{
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "[Shadow Debug Test] Forcing cache clear...");
            this.shadowRendering.forceTextureUpdate();
        };
        /**
     * Get current cache statistics
     */ this.getCacheStats = ()=>{
            return this.shadowRendering.getCacheStats();
        };
        /**
     * Enable/disable debug logging
     */ this.setDebugLogging = (enabled)=>{
            this.shadowRendering.debugHashCalculation = enabled;
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `[Shadow Debug Test] Debug logging ${enabled ? "enabled" : "disabled"}`);
        };
        this.shadowRendering = shadowRendering;
        this.performanceMonitor = new (0, $aFPGo.ShadowPerformanceMonitor)(shadowRendering);
        // Enable debug logging
        this.shadowRendering.debugHashCalculation = true;
    }
} /**
 * Usage example:
 *
 * // In your main client code:
 * const shadowDebugTest = new ShadowDebugTest(shadowRendering)
 *
 * // Run the test
 * shadowDebugTest.runTest()
 *
 * // Or manually check cache stats
 * logger.info({ tags: ["shadow", "debug"] }, shadowDebugTest.getCacheStats())
 */ 

});
parcelRegister("aFPGo", function(module, exports) {

$parcel$export(module.exports, "ShadowPerformanceMonitor", function () { return $7df034c62ab51562$export$35757d4a95da683c; });

var $5UG8I = parcelRequire("5UG8I");
class $7df034c62ab51562$export$35757d4a95da683c {
    constructor(shadowRendering){
        this.frameCount = 0;
        this.textureRegenerationCount = 0;
        this.cacheHitCount = 0;
        this.lastStatsTime = Date.now();
        this.lastCacheSize = 0;
        this.lastHash = "";
        /**
     * Call this every frame to track performance
     */ this.update = ()=>{
            this.frameCount++;
            const stats = this.shadowRendering.getCacheStats();
            // Track cache hits vs misses based on hash changes
            // If hash changed, it means we need to regenerate texture (cache miss)
            // If hash is the same, it means we can reuse cached texture (cache hit)
            if (stats.lastVisibilityHash !== this.lastHash) {
                this.textureRegenerationCount++;
                this.lastHash = stats.lastVisibilityHash;
            } else if (stats.lastVisibilityHash) this.cacheHitCount++;
            // Log stats every 5 seconds
            const now = Date.now();
            if (now - this.lastStatsTime > 5000) {
                this.logStats();
                this.lastStatsTime = now;
            }
        };
        this.logStats = ()=>{
            const stats = this.shadowRendering.getCacheStats();
            const totalFrames = this.frameCount;
            const cacheHitRate = totalFrames > 0 ? (this.cacheHitCount / totalFrames * 100).toFixed(1) : "0";
            const textureRegenRate = totalFrames > 0 ? (this.textureRegenerationCount / totalFrames * 100).toFixed(1) : "0";
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `[Shadow Performance] Frames: ${totalFrames}, Cache Hit Rate: ${cacheHitRate}%, Texture Regen: ${textureRegenRate}%, Cache Size: ${stats.cacheSize}/${stats.maxCacheSize}`);
            // Reset counters
            this.frameCount = 0;
            this.textureRegenerationCount = 0;
            this.cacheHitCount = 0;
        };
        /**
     * Get current performance metrics
     */ this.getMetrics = ()=>{
            const stats = this.shadowRendering.getCacheStats();
            return {
                totalFrames: this.frameCount,
                cacheHitRate: this.frameCount > 0 ? this.cacheHitCount / this.frameCount * 100 : 0,
                textureRegenRate: this.frameCount > 0 ? this.textureRegenerationCount / this.frameCount * 100 : 0,
                cacheSize: stats.cacheSize,
                maxCacheSize: stats.maxCacheSize,
                needsUpdate: stats.needsUpdate
            };
        };
        /**
     * Reset all counters
     */ this.reset = ()=>{
            this.frameCount = 0;
            this.textureRegenerationCount = 0;
            this.cacheHitCount = 0;
            this.lastStatsTime = Date.now();
            this.lastHash = "";
        };
        this.shadowRendering = shadowRendering;
    }
} /**
 * Usage example:
 *
 * // In your main render loop or client update:
 * const shadowMonitor = new ShadowPerformanceMonitor(shadowRendering)
 *
 * // In your render function:
 * shadowMonitor.update()
 *
 * // To get current metrics:
 * const metrics = shadowMonitor.getMetrics()
 * logger.info({ tags: ["shadow", "debug"] }, `Cache hit rate: ${metrics.cacheHitRate.toFixed(1)}%`)
 */ 

});


var $ca5eab90a111e4cd$exports = {};
$parcel$extendImportMap({
    "eInMy": "debug_viewport_culling.f56aa5d8.js"
});

parcelRequire("1avo5");
var $ezJmd = parcelRequire("ezJmd");
var $P8XPi = parcelRequire("P8XPi");
var $kXE1p = parcelRequire("kXE1p");
var $7DxQ2 = parcelRequire("7DxQ2");
var $hnGDn = parcelRequire("hnGDn");

var $8Odl4 = parcelRequire("8Odl4");
// Global time function that can be overridden for testing
let $4171652afd996934$var$globalTimeFunction = null;
function $4171652afd996934$export$55c0f46e09192d7(timeFn) {
    $4171652afd996934$var$globalTimeFunction = timeFn;
}
function $4171652afd996934$export$a86190deb5c4a8d0() {
    return $4171652afd996934$var$globalTimeFunction ? $4171652afd996934$var$globalTimeFunction() : Date.now();
}



class $bc8613e262b54793$export$72650553bea9c295 {
    constructor(size = 1000){
        this.items = [];
        this.ptr = -1;
        this.grow = (size = 1000)=>{
            for(let i = 0; i < size; i++)this.items.push(this.create());
        };
        this.checkout = ()=>{
            if (this.releasing) alert("BAD!");
            this.ptr++;
            if (this.ptr > this.items.length - 1) // grow the array
            this.grow(1000);
            const item = this.items[this.ptr];
            item.free = false;
            return item;
        };
        this.releaseAll = (visitor)=>{
            let count = 0;
            this.releasing = true;
            const now = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            // Release the whole stack down to AND INCLUDING index 0. The old bound `this.ptr > 0`
            // (together with release()'s `ptr < 0 -> 0` clamp) left items[0] permanently checked out:
            // it was never removed from its parent nor handed back out, leaving a stale "ghost" sprite
            // on the surface plus a one-slot leak per pool.
            while(this.ptr >= 0 && (0, $4171652afd996934$export$a86190deb5c4a8d0)() - now < 2000){
                const toRelease = this.items[this.ptr];
                if (toRelease.free) {
                    // Defensive: release() no-ops on an already-free item without moving ptr, which
                    // would spin forever here. Step past it manually.
                    this.ptr--;
                    continue;
                }
                if (visitor) visitor(toRelease);
                this.release(toRelease);
                count++;
            }
            this.ptr = -1;
            this.releasing = false;
            return count;
        };
        this.release = (item)=>{
            if (item.free) // already free, noop
            return;
            item.free = true;
            this.clear(item);
            this.ptr--;
            if (this.ptr < 0) this.ptr = 0;
        };
        this.grow(size);
    }
}


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ecc82b4b4d5334a5$var$getRandomValues;
var $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}


var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $83c241de251331e8$export$2e2bcd8739ae039).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5ce84198744ccadf$var$byteToHex = [];
for(var $5ce84198744ccadf$var$i = 0; $5ce84198744ccadf$var$i < 256; ++$5ce84198744ccadf$var$i)$5ce84198744ccadf$var$byteToHex.push(($5ce84198744ccadf$var$i + 0x100).toString(16).substr(1));
function $5ce84198744ccadf$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $e70e86397c656fa2$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;


function $87befc68df50040c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $ecc82b4b4d5334a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5ce84198744ccadf$export$2e2bcd8739ae039)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;






const $df375085b7c59381$export$e4b2ac9215619f8d = {
    vileAndCrude: {
        small: [
            'ach',
            'adz',
            'ak',
            'ark',
            'az',
            'balg',
            'bilg',
            'blid',
            'blig',
            'blok',
            'blot',
            'bolg',
            'bot',
            'bug',
            'burk',
            'dokh',
            'drik',
            'driz',
            'duf',
            'flug',
            'ga',
            'gad',
            'gag',
            'gah',
            'gak',
            'gar',
            'gat',
            'gaz',
            'ghag',
            'ghak',
            'git',
            'glag',
            'glak',
            'glat',
            'glig',
            'gliz',
            'glok',
            'gnat',
            'gog',
            'grak',
            'grat',
            'guk',
            'hig',
            'irk',
            'kak',
            'khad',
            'krig',
            'lag',
            'lak',
            'lig',
            'likk',
            'loz',
            'luk',
            'mak',
            'maz',
            'miz',
            'mub',
            'nad',
            'nag',
            'naz',
            'nig',
            'nikk',
            'nogg',
            'nok',
            'nukk',
            'rag',
            'rak',
            'rat',
            'rok',
            'shrig',
            'shuk',
            'skrag',
            'skug',
            'slai',
            'slig',
            'slog',
            'sna',
            'snag',
            'snark',
            'snat',
            'snig',
            'snik',
            'snit',
            'sog',
            'spik',
            'stogg',
            'tog',
            'urf',
            'vark',
            'yad',
            'yagg',
            'yak',
            'yark',
            'yarp',
            'yig',
            'yip',
            'zat',
            'zib',
            'zit',
            'ziz'
        ],
        medium: [
            'ag',
            'aug',
            'bad',
            'bag',
            'bakh',
            'bash',
            'baz',
            'blag',
            'brag',
            'brog',
            'bruz',
            'dag',
            'dakk',
            'darg',
            'dob',
            'dog',
            'drab',
            'dug',
            'dur',
            'gash',
            'ghaz',
            'glakh',
            'glaz',
            'glob',
            'glol',
            'gluf',
            'glur',
            'gnarl',
            'gnash',
            'gnub',
            'gob',
            'gokh',
            'gol',
            'golk',
            'gor',
            'grakh',
            'grash',
            'grath',
            'graz',
            'grot',
            'grub',
            'grud',
            'gud',
            'gut',
            'hag',
            'hakk',
            'hrat',
            'hrog',
            'hrug',
            'khag',
            'khar',
            'krag',
            'krud',
            'lakh',
            'lash',
            'lob',
            'lub',
            'lud',
            'luf',
            'luk',
            'molk',
            'muk',
            'muz',
            'nar',
            'ogg',
            'olg',
            'rag',
            'rash',
            'rogg',
            'rorg',
            'rot',
            'rud',
            'ruft',
            'rug',
            'rut',
            'shad',
            'shag',
            'shak',
            'shaz',
            'shog',
            'skar',
            'skulg',
            'slur',
            'snar',
            'snorl',
            'snub',
            'snurr',
            'sod',
            'stulg',
            'thak',
            'trog',
            'ug',
            'umsh',
            'ung',
            'uth',
            'yakh',
            'yash',
            'yob',
            'zahk',
            'zog'
        ],
        large: [
            'argh',
            'barsh',
            'bog',
            'burz',
            'dof',
            'drok',
            'drub',
            'drug',
            'dub',
            'dug',
            'dul',
            'dursh',
            'dush',
            'duz',
            'faug',
            'fug',
            'ghakh',
            'ghar',
            'ghash',
            'ghol',
            'ghor',
            'ghukk',
            'ghul',
            'glub',
            'glud',
            'glug',
            'gluz',
            'gom',
            'grad',
            'grash',
            'grob',
            'grogg',
            'grok',
            'grol',
            'gru',
            'gruf',
            'gruk',
            'grul',
            'grum',
            'grumf',
            'grut',
            'gruz',
            'guhl',
            'gulv',
            'hai',
            'hrung',
            'hur',
            'hurg',
            'kai',
            'klob',
            'krod',
            'kug',
            'kulk',
            'kur',
            'lorg',
            'lug',
            'lukh',
            'lum',
            'lurz',
            'lush',
            'luz',
            'makh',
            'maug',
            'molg',
            'mud',
            'mug',
            'mul',
            'murk',
            'muzd',
            'nakh',
            'narg',
            'obb',
            'rolb',
            'rukh',
            'ruz',
            'sharg',
            'shruf',
            'shud',
            'shug',
            'shur',
            'shuz',
            'slub',
            'slud',
            'slug',
            'snad',
            'snog',
            'thrag',
            'thulk',
            'thurk',
            'trug',
            'ulg',
            'ur',
            'urd',
            'urgh',
            'urkh',
            'uz',
            'yug',
            'yur',
            'zud',
            'zug'
        ]
    },
    primitive: {
        names: [
            'ahg',
            'baod',
            'beegh',
            'bohr',
            'bul',
            'buli',
            'burh',
            'buri',
            'chah',
            'dhak',
            'digri',
            'dum',
            'eghi',
            'ehm',
            'faogh',
            'feehm',
            'ghad',
            'ghah',
            'gham',
            'ghan',
            'ghat',
            'ghaw',
            'ghee',
            'ghish',
            'ghug',
            'giree',
            'gonkh',
            'goun',
            'goush',
            'guh',
            'gunri',
            'hah',
            'hani',
            'haogh',
            'hatoo',
            'heghi',
            'heh',
            'hoo',
            'houm',
            'hree',
            'ig',
            'kham',
            'khan',
            'khaz',
            'khee',
            'khem',
            'khuri',
            'logh',
            'lugh',
            'maoh',
            'meh',
            'mogh',
            'mouh',
            'mugh',
            'naoh',
            'naroo',
            'nham',
            'nuh',
            'ob',
            'oli',
            'orf',
            'ough',
            'ouh',
            'peh',
            'pogh',
            'pugh',
            'puh',
            'quagi',
            'rahoo',
            'rhoo',
            'rifoo',
            'ronkh',
            'rouk',
            'saom',
            'saori',
            'shehi',
            'shlo',
            'shom',
            'shour',
            'shul',
            'snaoh',
            'suhi',
            'suth',
            'teb',
            'thom',
            'toudh',
            'tregh',
            'tuhli',
            'ub',
            'urush',
            'ush',
            'vuh',
            'wah',
            'wuh',
            'yaum',
            'yauth',
            'yeeh',
            'yih',
            'yuh',
            'zham'
        ],
        suffixes: [
            'doh',
            'rei',
            'mih',
            'fah',
            'soh',
            'lah',
            'tih',
            'daoh'
        ]
    },
    doughty: {
        syllables: [
            'bal',
            'durn',
            'na',
            'bord',
            'from',
            'nor',
            'born',
            'fror',
            'nord',
            'brim',
            'fuld',
            'orm',
            'brod',
            'fund',
            'skand',
            'brokk',
            'gim',
            'skond',
            'brom',
            'glo',
            'storn',
            'bru',
            'gond',
            'strom',
            'bur',
            'gord',
            'stur',
            'burl',
            'gorm',
            'sturl',
            'da',
            'grad',
            'sund',
            'dal',
            'grim',
            'thor',
            'dolg',
            'grod',
            'thorn',
            'dor',
            'grom',
            'thra',
            'dorm',
            'guld',
            'thro',
            'dral',
            'gund',
            'throl',
            'drim',
            'gur',
            'thror',
            'drom',
            'hord',
            'thru',
            'dur',
            'horn',
            'thrur',
            'durm',
            'hra',
            'thund'
        ],
        maleSuffixes: [
            'bor',
            'din',
            'in',
            'in',
            'in',
            'ir',
            'li',
            'li',
            'lin',
            'nir',
            'or',
            'ri',
            'ri',
            'rin',
            'rok',
            'ror',
            'rur',
            'vi',
            'vir',
            'vor'
        ],
        femaleSuffixes: [
            'bis',
            'da',
            'dis',
            'dis',
            'dis',
            'dis',
            'ga',
            'hild',
            'is',
            'is',
            'lif',
            'lind',
            'lis',
            'na',
            'nis',
            'ris',
            'rith',
            'run',
            'run',
            'vis'
        ]
    },
    homely: {
        syllables: [
            'ad',
            'blanc',
            'falc',
            'mil',
            'adel',
            'boff',
            'ferd',
            'mung',
            'adr',
            'bomb',
            'frob',
            'od',
            'ail',
            'bram',
            'fulb',
            'oth',
            'alb',
            'bung',
            'gam',
            'sab',
            'alm',
            'droc',
            'hald',
            'sam',
            'amb',
            'drog',
            'ham',
            'seg',
            'band',
            'durl',
            'hasc',
            'serl',
            'bard',
            'emm',
            'hod',
            'tob',
            'ben',
            'erd',
            'hug',
            'wan',
            'biff',
            'ern',
            'iv',
            'wig',
            'bild',
            'ever',
            'mark',
            'wyd'
        ],
        maleSuffixes: [
            'ald',
            'ard',
            'ert',
            'fast',
            'o',
            'o',
            'o',
            'o',
            'o',
            'old',
            'win',
            'wise'
        ],
        femaleSuffixes: [
            'a',
            'a',
            'a',
            'a',
            'a',
            'ia',
            'ia',
            'ice',
            'ily',
            'ina',
            'wina',
            'wisa'
        ]
    },
    familyName: {
        english: [
            'Adshead',
            'Akers',
            'Antell',
            'Applegarth',
            'Babb',
            'Babbs',
            'Baffin',
            'Bagg',
            'Baggett',
            'Bagnall',
            'Baldey',
            'Bamber',
            'Bark',
            'Barling',
            'Barnstable',
            'Barraclough',
            'Bastable',
            'Bastin',
            'Bather',
            'Batkin',
            'Batt',
            'Bazley',
            'Bebb',
            'Beddall',
            'Beeby',
            'Beecroft',
            'Beedell',
            'Bellis',
            'Belsey',
            'Berridge',
            'Besley',
            'Bibby',
            'Bickle',
            'Biddle',
            'Biddulph',
            'Bigg',
            'Binks',
            'Binns',
            'Bisp',
            'Biss',
            'Blenk',
            'Blenkin',
            'Boam',
            'Bobo',
            'Boddington',
            'Boffey',
            'Bonger',
            'Bonney',
            'Bonser',
            'Borrett',
            'Bossey',
            'Botterill',
            'Botting',
            'Bottom',
            'Bottomley',
            'Botwright',
            'Bowser',
            'Bracher',
            'Brasnett',
            'Brayley',
            'Breary',
            'Brickwood',
            'Brindley',
            'Broadfoot',
            'Broadribb',
            'Brocksopp',
            'Broster',
            'Buckmaster',
            'Budge',
            'Buffard',
            'Bugg',
            'Buggy',
            'Bulger',
            'Bulman',
            'Bunce',
            'Bunt',
            'Burrow',
            'Bushby',
            'Buss',
            'Cade',
            'Cadwaller',
            'Cantrill',
            'Cardno',
            'Catlow',
            'Cattermole',
            'Chaffe',
            'Chaffer',
            'Chard',
            'Chettle',
            'Chilcott',
            'Chitty',
            'Chivers',
            'Chubb',
            'Chugg',
            'Clewes',
            'Coaker',
            'Cobden',
            'Cobley',
            'Coggan',
            'Coggins',
            'Collop',
            'Coney',
            'Coote',
            'Copp',
            'Coppard',
            'Cornock',
            'Cossey',
            'Cottle',
            'Coultip',
            'Crang',
            'Crimp',
            'Croom',
            'Crowles',
            'Cubitt',
            'Cullimore',
            'Cuss',
            'Custance',
            'Cuthbert',
            'Dabbin',
            'Dabbing',
            'Dabbs',
            'Dagg',
            'Dainty',
            'Deeley',
            'Derrick',
            'Dibb',
            'Dibble',
            'Diccox',
            'Diggins',
            'Diggle',
            'Diggles',
            'Digweed',
            'Dimmock',
            'Dinsdale',
            'Dipple',
            'Dobbie',
            'Dobby',
            'Doggett',
            'Dorey',
            'Drabble',
            'Draycott',
            'Dring',
            'Drudge',
            'Duffield',
            'Dufty',
            'Duggan',
            'Duggleby',
            'Dumbrell',
            'Dunkley',
            'Eatwell',
            'Eggins',
            'Entwistle',
            'Erlam',
            'Etchells',
            'Fairclough',
            'Felgate',
            'Fensome',
            'Fenton',
            'Fidge',
            'Fidoe',
            'Figg',
            'Filer',
            'Fincham',
            'Firkins',
            'Flann',
            'Flanner',
            'Flippance',
            'Flook',
            'Flunder',
            'Followes',
            'Fooks',
            'Fremlin',
            'Frisby',
            'Frogley',
            'Frohock',
            'Froome',
            'Frow',
            'Fuggle',
            'Furse',
            'Furze',
            'Gabb',
            'Gaffey',
            'Gagg',
            'Gander',
            'Garbutt',
            'Garlick',
            'Garn',
            'Gazard',
            'Gedge',
            'Giblett',
            'Giddy',
            'Gigg',
            'Gilliat',
            'Gimble',
            'Gimson',
            'Ginger',
            'Gipps',
            'Girdler',
            'Gissing',
            'Gleave',
            'Goggin',
            'Gollogly',
            'Gomm',
            'Goodier',
            'Gook',
            'Gorringe',
            'Gorwyn',
            'Gosden',
            'Gribble',
            'Grigg',
            'Griggs',
            'Grill',
            'Grimble',
            'Grimes',
            'Grimshaw',
            'Grist',
            'Grubb',
            'Guckeen',
            'Guckian',
            'Guild',
            'Gull',
            'Gully',
            'Gumbold',
            'Gummer',
            'Gummidge',
            'Gurden',
            'Haffenden',
            'Hales',
            'Halse',
            'Harpham',
            'Hartle',
            'Hatch',
            'Hayhurst',
            'Hearle',
            'Henley',
            'Henwood',
            'Heppell',
            'Herrick',
            'Herring',
            'Hesketh',
            'Hext',
            'Hicken',
            'Hickmott',
            'Higman',
            'Hinchcliffe',
            'Hindmarsh',
            'Hobley',
            'Hoddy',
            'Hogben',
            'Holdom',
            'Hollick',
            'Holtom',
            'Honeysett',
            'Hook',
            'Hopley',
            'Hopps',
            'Horrocks',
            'Horsfall',
            'Horwood',
            'Hotten',
            'Housely',
            'Howie',
            'Huff',
            'Huffam',
            'Hutton',
            'Huxtable',
            'Icke',
            'Idden',
            'Inskip',
            'Iveson',
            'Izzard',
            'Jaggs',
            'Jellis',
            'Jepson',
            'Jesty',
            'Keel',
            'Keetley',
            'Kerkin',
            'Kerslake',
            'Kettley',
            'Killick',
            'Kinch',
            'Knaggs',
            'Kneebone',
            'Knopp',
            'Knott',
            'Lagden',
            'Laslett',
            'Laverick',
            'Leaper',
            'Leggett',
            'Liddane',
            'Liddy',
            'Liggan',
            'Lithgoe',
            'Lobb',
            'Lodder',
            'Looby',
            'Loody',
            'Lubbock',
            'Luff',
            'Lugard',
            'Lugg',
            'Lumsden',
            'Lyle',
            'Mabb',
            'Mabbitt',
            'Mabbot',
            'Mabbs',
            'Mabbutt',
            'Maffey',
            'Mallam',
            'Mangold',
            'Mapp',
            'Mappin',
            'Marfell',
            'Matthams',
            'Maunder',
            'Maxted',
            'Mayo',
            'Meech',
            'Meeson',
            'Meggison',
            'Meggitt',
            'Meggs',
            'Mellings',
            'Merrikin',
            'Metherell',
            'Mew',
            'Miggles',
            'Miggs',
            'Milsom',
            'Milson',
            'Minchin',
            'Minns',
            'Mobbs',
            'Moberly',
            'Mockler',
            'Mogford',
            'Mogg',
            'Moggs',
            'Morkam',
            'Morphett',
            'Mossman',
            'Mossop',
            'Mottershead',
            'Moulds',
            'Muddle',
            'Muddock',
            'Mudge',
            'Mullock',
            'Murch',
            'Murfin',
            'Murfitt',
            'Musson',
            'Mustill',
            'Mutter',
            'Mutton',
            'Nance',
            'Napper',
            'Neep',
            'Negus',
            'Netherway',
            'Newitt',
            'Niblett',
            'Nickless',
            'Noad',
            'Nobbs',
            'Noblet',
            'Nosworthy',
            'Nottage',
            'Nutt',
            'Offen',
            'Oram',
            'Orcutt',
            'Ord',
            'Orpe',
            'Paddock',
            'Paddon',
            'Pannell',
            'Parham',
            'Pavey',
            'Peay',
            'Peever',
            'Pegg',
            'Pegge',
            'Pegler',
            'Pegrum',
            'Pelly',
            'Pelter',
            'Pendle',
            'Petch',
            'Petcher',
            'Petchey',
            'Pettipher',
            'Philp',
            'Phippen',
            'Phippin',
            'Pickersgill',
            'Pickley',
            'Pickwell',
            'Pidduck',
            'Pigg',
            'Pilkington',
            'Pimblett',
            'Pingree',
            'Pinch',
            'Pinn',
            'Pither',
            'Pochin',
            'Poggs',
            'Polkinghorne',
            'Pomeroy',
            'Pomfret',
            'Postlethwaite',
            'Potticary',
            'Poxon',
            'Pring',
            'Pringle',
            'Prisk',
            'Proudfoot',
            'Puddicombe',
            'Pudding',
            'Puddy',
            'Pugsley',
            'Purslove',
            'Pym',
            'Quaife',
            'Quain',
            'Quenby',
            'Quibell',
            'Quigg',
            'Raddle',
            'Ranby',
            'Rapkins',
            'Ratter',
            'Reakes',
            'Reeson',
            'Riddle',
            'Rix',
            'Roddis',
            'Rosser',
            'Ruddle',
            'Ruffle',
            'Rugg',
            'Rumming',
            'Rump',
            'Sadd',
            'Samways',
            'Sankey',
            'Scantlebury',
            'Scoones',
            'Scouse',
            'Scragg',
            'Scrimgeour',
            'Scroggs',
            'Scruby',
            'Scutt',
            'Sefton',
            'Selth',
            'Semmens',
            'Seward',
            'Shalloo',
            'Sharples',
            'Siggers',
            'Sirett',
            'Skeels',
            'Skerrett',
            'Slee',
            'Sluggett',
            'Smedley',
            'Snoddy',
            'Snuggs',
            'Sparrow',
            'Sparrowhawke',
            'Spink',
            'Spinks',
            'Spriggs',
            'Springett',
            'Sproat',
            'Sprunt',
            'Spurle',
            'Spurrett',
            'Spurrier',
            'Squance',
            'Squarey',
            'Squibb',
            'Squirrel',
            'Staines',
            'Steggal',
            'Stelfox',
            'Stirk',
            'Stith',
            'Strag',
            'Straw',
            'Strutt',
            'Stubbins',
            'Stuppies',
            'Suggett',
            'Swaffer',
            'Swaffield',
            'Swarbrick',
            'Symes',
            'Tabor',
            'Tagg',
            'Tapping',
            'Tarr',
            'Tassell',
            'Teale',
            'Thew',
            'Thick',
            'Thornber',
            'Thwaites',
            'Tibbins',
            'Tibbits',
            'Tibbles',
            'Tibbotts',
            'Tink',
            'Tippell',
            'Tipping',
            'Tippins',
            'Tippling',
            'Tipton',
            'Tisser',
            'Tittmuss',
            'Tobitt',
            'Tonks',
            'Topping',
            'Towse',
            'Toye',
            'Tozer',
            'Trafford',
            'Treasure',
            'Tremlett',
            'Trett',
            'Trible',
            'Tricker',
            'Tripe',
            'Trippe',
            'Tripper',
            'Trist',
            'Troake',
            'Trotter',
            'Trouncer',
            'Trumble',
            'Tudge',
            'Tuffin',
            'Tufley',
            'Tulk',
            'Tully',
            'Tumman',
            'Tunks',
            'Tunnah',
            'Tunnicliffe',
            'Turnock',
            'Tween',
            'Tyrer',
            'Unsworth',
            'Uttley',
            'Varney',
            'Vooght',
            'Wackrill',
            'Waddilove',
            'Waddilow',
            'Walthew',
            'Waltho',
            'Walwin',
            'Wanless',
            'Wann',
            'Waple',
            'Waring',
            'Warrilow',
            'Welburn',
            'Wenden',
            'Werrett',
            'Wescott',
            'Whinnett',
            'Whiskard',
            'Whisker',
            'Whitefoot',
            'Whitlow',
            'Wibberley',
            'Widdicombe',
            'Widdows',
            'Widdup',
            'Wigg',
            'Wigley',
            'Wilberforce',
            'Wilmer',
            'Wintle',
            'Witherden',
            'Witney',
            'Witter',
            'Wolnoth',
            'Woodhead',
            'Wookey',
            'Woolland',
            'Woombill',
            'Worrel',
            'Worsley',
            'Wortley',
            'Wragg',
            'Wrixon',
            'Yeandle',
            'Yeend',
            'Yemm',
            'Yould'
        ],
        scottish: [
            'Aiken',
            'Aitken',
            'Baikie',
            'Baillie',
            'Bainbridge',
            'Baird',
            'Bairnsfeather',
            'Balios',
            'Balnaves',
            'Barbour',
            'Barclay',
            'Barrie',
            'Beattie',
            'Beilby',
            'Bell',
            'Bellenden',
            'Berwick',
            'Blackie',
            'Blackwood',
            'Blaikie',
            'Blair',
            'Bogue',
            'Boyce',
            'Braid',
            'Brechin',
            'Brisbane',
            'Brough',
            'Brougham',
            'Brown',
            'Brownlee',
            'Brymner',
            'Cairns',
            'Calderwood',
            'Candlish',
            'Cardus',
            'Cargill',
            'Caven',
            'Christison',
            'Clyde',
            'Cochran',
            'Cochrane',
            'Cockburn',
            'Colomb',
            'Crockett',
            'Cronin',
            'Cruden',
            'Cunningham',
            'Cushny',
            'Dalziel',
            'Deems',
            'Dempster',
            'Dinwiddie',
            'Doohan',
            'Doone',
            'Dunbar',
            'Dundas',
            'Dundee',
            'Dunn',
            'Dunning',
            'Eccles',
            'Eckford',
            'Edmonstone',
            'Elder',
            'Fairbairn',
            'Falconer',
            'Fenwick',
            'Ferrier',
            'Gairdner',
            'Galloway',
            'Galt',
            'Geddes',
            'Geikie',
            'Glass',
            'Glendon',
            'Graham',
            'Gregory',
            'Guthrie',
            'Haig',
            'Halkett',
            'Herdman',
            'Hogg',
            'Imey',
            'Inchbald',
            'Inglis',
            'Irvine',
            'Ivory',
            'Jebb',
            'Kerr',
            'Kircaldy',
            'Kirk',
            'Kirkbride',
            'Laird',
            'Laughlin',
            'Lawson',
            'Legge',
            'Lillie',
            'Lipton',
            'Lockhart',
            'Lorimer',
            'Lyall',
            'Lyte',
            'Masson',
            'Melrose',
            'Mill',
            'Miller',
            'Milligan',
            'Milner',
            'Moffat',
            'Mollison',
            'Moncrief',
            'Montrose',
            'Motherwell',
            'Muir',
            'Muirhead',
            'Murray',
            'Nairn',
            'Naysmith',
            'Nesbit',
            'Nisbet',
            "No\xebl",
            'Orchardson',
            'Pasley',
            'Paterson',
            'Pender',
            'Preston',
            'Primrose',
            'Pringle',
            'Quiller',
            'Raeburn',
            'Ransay',
            'Redpath',
            'Renfrew',
            'Rennie',
            'Renwick',
            'Sanderson',
            'Semphill',
            'Smiles',
            'Smollett',
            'Smybert',
            'Spenlove',
            'Sterling',
            'Stirling',
            'Strang',
            'Strange',
            'Strangeways',
            'Tait',
            'Tannahill',
            'Tassie',
            'Thom',
            'Tolmie',
            'Urquhart',
            'Wardlaw',
            'Wedderburn',
            'Whearty',
            'Wilkie',
            'Wiseheart',
            'Wishart',
            'Yarrow'
        ]
    },
    fairAndNoble: {
        elfPrefixes: [
            'an',
            'im',
            'ar',
            'in',
            'cal',
            'ir',
            'car',
            'ist',
            'cel',
            'lar',
            'cir',
            'lir',
            'clar',
            'lor',
            'el',
            'mar',
            'elb',
            'mel',
            'er',
            'mer',
            'erl',
            'mir',
            'est',
            'nim',
            'far',
            'nin',
            'fin',
            'nir',
            'gal',
            'ral',
            'gan',
            'ran',
            'gar',
            'rel',
            'gel',
            'ril',
            'gil',
            'rin',
            'ilm',
            'rim'
        ],
        alternativeElfPrefixes: [
            'aeg',
            'lith',
            'ael',
            'maeg',
            'aer',
            'mind',
            'aes',
            'mith',
            'aeth',
            'nith',
            'bel',
            'rael',
            'ber',
            'rind',
            'cael',
            'saer',
            'caer',
            'sar',
            'cris',
            'seld',
            'ear',
            'ser',
            'elth',
            'sil',
            'eol',
            'silm',
            'faer',
            'sind',
            'fean',
            'thael',
            'find',
            'thaer',
            'ith',
            'thal',
            'laeg',
            'thel',
            'lend',
            'ther',
            'lind',
            'thir'
        ],
        middle: [
            'ad',
            'al',
            'am',
            'an',
            'ar',
            'as',
            'eb',
            'ed',
            'el',
            'em',
            'en',
            'er',
            'es',
            'ev',
            'il',
            'in',
            'ir',
            'ol',
            'thal',
            'thon'
        ],
        maleSuffixes: [
            'ad',
            'dan',
            'del',
            'dil',
            'dir',
            'fal',
            'ion',
            'ion',
            'lad',
            'las',
            'lin',
            'nar',
            'or',
            'orn',
            'ras',
            'rior',
            'rod',
            'rond',
            'ros',
            'thir'
        ],
        femaleSuffixes: [
            'edel',
            'el',
            'eth',
            'ian',
            'iel',
            'iel',
            'ien',
            'loth',
            'mir',
            'rial',
            'rian',
            'riel',
            'riel',
            'rien',
            'ril',
            "ro\xebl",
            'sil',
            "w\xeb",
            'wen',
            'wen'
        ]
    },
    fairy: {
        prefixes: [
            'dex',
            'gliss',
            'tink',
            'flax',
            'goss',
            'tiss',
            'flim',
            'hex',
            'trill',
            'fliss',
            'liss',
            'trist',
            'flix',
            'min',
            'twill',
            'foss',
            'misk',
            'twiss',
            'frisk',
            'raff',
            'twisp',
            'friss',
            'ress',
            'twix',
            'gess',
            'riff',
            'weft',
            'glan',
            'rill',
            'wesk',
            'glax',
            'saff',
            'winn',
            'glim',
            'shim',
            'wisp'
        ],
        maleSuffixes: [
            'aldo',
            'allo',
            'amo',
            'ando',
            'aroll',
            'aron',
            'asto',
            'endo',
            'eroll',
            'eron',
            'esto',
            'ondo'
        ],
        femaleSuffixes: [
            'afer',
            'amer',
            'anel',
            'arel',
            'asti',
            'efer',
            'enti',
            'erel',
            'ifer',
            'imer',
            'inel',
            'irel'
        ]
    },
    alternateFairy: {
        prefixes: [
            'bris',
            'iphil',
            'opal',
            'cryl',
            'ispel',
            'oris',
            'elsi',
            'istle',
            'orif',
            'ember',
            'jat',
            'peri',
            'esk',
            'jost',
            'sarm',
            'feris',
            'jus',
            'sprin',
            'frimi',
            'lirra',
            'stith',
            'gan',
            'mali',
            'tansi',
            'glink',
            'mink',
            'tirra',
            'hal',
            'mirra',
            'trump',
            'hel',
            'mistle',
            'whis',
            'hist',
            'ninka',
            'zando'
        ],
        maleSuffixes: [
            'bik',
            'brix',
            'frell',
            'fret',
            'kin',
            'mist',
            'mit',
            'rix',
            'tross',
            'twik',
            'win',
            'zisk'
        ],
        femaleSuffixes: [
            'dee',
            'kiss',
            'la',
            'liss',
            'mee',
            'niss',
            'nyx',
            'ree',
            'riss',
            'sa',
            'tiss',
            'ynx'
        ]
    },
    elegantEvil: {
        prefixesDarkElves: [
            'bal',
            'myr',
            'ber',
            'ne',
            'char',
            'nel',
            'de',
            'nil',
            'div',
            'no',
            'dri',
            'nyl',
            'dul',
            'rel',
            'eil',
            'rha',
            'ek',
            'ru',
            'im',
            'sab',
            'ins',
            'sin',
            'ist',
            'sul',
            'jeg',
            'sus',
            'jer',
            'tel',
            'jys',
            'tul',
            'lil',
            'ver',
            'mar',
            'vil',
            'mer',
            'vir',
            'mez',
            'vril',
            'mor',
            'yas'
        ],
        prefixesAlternateDarkElves: [
            'bur',
            'olg',
            'chor',
            'on',
            'col',
            'or',
            'dol',
            'org',
            'dor',
            'oth',
            'drom',
            'pan',
            'dur',
            'pel',
            'en',
            'por',
            'er',
            'sek',
            'gon',
            'sol',
            'gul',
            'sun',
            'jend',
            'ten',
            'kil',
            'thal',
            'lul',
            'tor',
            'mab',
            'torm',
            'maz',
            'vek',
            'mol',
            'vol',
            'nor',
            'vor',
            'noth',
            'yel',
            'ol',
            'yol'
        ],
        middle: [
            'dyl',
            'el',
            'en',
            'er',
            'id',
            'il',
            'is',
            'lav',
            'len',
            'lev',
            'lin',
            'liv',
            'pel',
            'pir',
            'ra',
            'ral',
            'ril',
            'rin',
            'sin',
            'syl'
        ],
        maleSuffixes: [
            'ald',
            'eld',
            'id',
            'ild',
            'ird',
            'lim',
            'naz',
            'nid',
            'nil',
            'nim',
            'red',
            'rid',
            'rim',
            'riv',
            'ul',
            'uld',
            'vid',
            'vim',
            'vir',
            'viz'
        ],
        femaleSuffixes: [
            'bra',
            'dra',
            'dril',
            'ene',
            'hel',
            'ia',
            'il',
            'iln',
            'ira',
            'istra',
            'ith',
            'iza',
            'lin',
            'na',
            'ra',
            'rin',
            'sil',
            'tra',
            'vra',
            'vril'
        ]
    },
    malevolent: {
        prefixes: [
            'aag',
            'karg',
            'ulthu',
            'alur',
            'khark',
            'urz',
            'arak',
            'krau',
            'uti',
            'az',
            'kriv',
            'uznid',
            'azik',
            'kuaz',
            'virn',
            'bral',
            'kudu',
            'vlaaj',
            'braz',
            'luri',
            'vlag',
            'bruh',
            'mulk',
            'vlash',
            'draan',
            'nau',
            'vluk',
            'drulg',
            'nid',
            'vluzak',
            'guz',
            'ninj',
            'vraz',
            'haug',
            'nul',
            'vulk',
            'idru',
            'nym',
            'xau',
            'jhaal',
            'ranag',
            'xid',
            'jid',
            'rilthu',
            'xul',
            'jiu',
            'ruk',
            'xuraj',
            'jur',
            'rulk',
            'zauv',
            'jurg',
            'ruz',
            'zug',
            'jurz',
            'saag',
            'zuldu',
            'kaaz',
            'skaur',
            'zuv'
        ],
        maleSuffixes: [
            'arag',
            'bru',
            'drul',
            'inu',
            'lank',
            'lun',
            'lurr',
            'lurug',
            'nal',
            'rul',
            'ruzuk',
            'salk',
            'sul',
            'suruk',
            'ull',
            'undak',
            'uvik',
            'xulg',
            'zu',
            'zuk'
        ],
        femaleSuffixes: [
            'anil',
            'bau',
            'diu',
            'dusla',
            'giu',
            'ija',
            'izil',
            'jiul',
            'lihyl',
            'lin',
            'lyrr',
            'nalu',
            'rhyl',
            'rula',
            'skiu',
            'sula',
            'ulla',
            'xhiu',
            'zihyl',
            'ziu'
        ]
    },
    draconic: {
        prefixes: [
            'abra',
            'har',
            'phrixu',
            'adastra',
            'helio',
            'porphyro',
            'adra',
            'huro',
            'pyra',
            'anca',
            'iul',
            'rhada',
            'andra',
            'jalan',
            'rhe',
            'arag',
            'jarzem',
            'rhodo',
            'archo',
            'jazra',
            'rau',
            'atra',
            'jurga',
            'sar',
            'bar',
            'keruxa',
            'sarcu',
            'bara',
            'kralka',
            'sarda',
            'beru',
            'lazulo',
            'scarva',
            'bhakri',
            'majuri',
            'sidereo',
            'bia',
            'malacho',
            'skhia',
            'bra',
            'mar',
            'sulchru',
            'brado',
            'marmora',
            'tchalcedo',
            'brima',
            'melkar',
            'tchazar',
            'cadra',
            'orgra',
            'trocho',
            'chro',
            'ouro',
            'vra',
            'chryso',
            'perido',
            'zalar',
            'glau',
            'phoro',
            'zerul'
        ],
        suffixes: [
            'bazius',
            'boros',
            'bradax',
            'calchax',
            'cordax',
            'lagon',
            'malax',
            'mandros',
            'manthys',
            'mordax',
            'nadral',
            'nalux',
            'neriax',
            'phylax',
            'vorax',
            'vorung',
            'xenor',
            'zuthrax',
            'zzebrax',
            'zzemal'
        ]
    },
    infernal: {
        softs: [
            'alu',
            'alz',
            'avu',
            'azaz',
            'baph',
            'baz',
            'cha',
            'fraz',
            'garl',
            'garu',
            'gla',
            'hra',
            'mal',
            'nahu',
            'nal',
            'nasu',
            'paz',
            'raz',
            'tha',
            'thalu',
            'bre',
            'dre',
            'gel',
            'gle',
            'gre',
            'hez',
            'rez',
            'rezu',
            'tze',
            'gzi',
            'hriz',
            'hzi',
            'idrau',
            'itha',
            'ixu',
            'lilu',
            'riz',
            'yil',
            'dromu',
            'gro',
            'lol',
            'moz',
            'olth',
            'oxu',
            'sco',
            'tho',
            'bu',
            'bul',
            'buz',
            'chru',
            'dru',
            'ghu',
            'gura',
            'guz',
            'hruz',
            'huz',
            'kul',
            'lurhz',
            'muz',
            'ru',
            'shu',
            'ssu',
            'szul',
            'thu',
            'ulchru',
            'utu',
            'vul',
            'zu',
            'zul',
            'baal',
            'ghaa',
            'kraa',
            'phaal',
            'raal',
            'saa',
            'bial',
            'oazo',
            'soaz',
            'ruaz',
            'gya',
            'yaa',
            'bael',
            'nee',
            'ziel',
            'yee',
            'aiaz',
            'shai',
            'reoz',
            'duoi',
            'drau',
            'ghau',
            'glau',
            'mau',
            'sau',
            'tzau',
            'iuz',
            'juu',
            'rhuu',
            'vuul',
            'zuu'
        ],
        dulls: [
            'agh',
            'alg',
            'barg',
            'chag',
            'ghad',
            'glab',
            'grag',
            'hrag',
            'kag',
            'kwarg',
            'mag',
            'nalb',
            'sag',
            'tharg',
            'brelg',
            'dergh',
            'dregh',
            'drelb',
            'felg',
            'heg',
            'kleg',
            'igg',
            'rigg',
            'blog',
            'drog',
            'grolb',
            'kolg',
            'krolg',
            'lolg',
            'mog',
            'morg',
            'nog',
            'obb',
            'ogg',
            'olb',
            'rogg',
            'strog',
            'thog',
            'trob',
            'tzolg',
            'vogt',
            'bub',
            'bulg',
            'druj',
            'durg',
            'frub',
            'fulg',
            'gub',
            'hrud',
            'hurg',
            'jub',
            'julb',
            'nud',
            'nug',
            'nulb',
            'rung',
            'shub',
            'stug',
            'sug',
            'szug',
            'trulg',
            'ulb',
            'urb',
            'vub',
            'vulb',
            'xub',
            'zub',
            'zug',
            'zugt',
            'aab',
            'aag',
            'glaag',
            'haag',
            'naag',
            'raag',
            'boaj',
            'moab',
            'uag',
            'leegh',
            'yeb',
            'yeeg',
            'aig',
            'yibb',
            'iog',
            'droog',
            'nyog',
            'aug',
            'baug',
            'daurg',
            'draug',
            'gaub',
            'laug',
            'maug',
            'naug',
            'raug',
            'saug',
            'thaug',
            'iub',
            'iug',
            'ruug'
        ],
        sharps: [
            'ach',
            'akk',
            'ash',
            'azt',
            'bahor',
            'bar',
            'bas',
            'brax',
            'charn',
            'dak',
            'hrax',
            'lach',
            'lazt',
            'mat',
            'nam',
            'nazt',
            'ralk',
            'rhast',
            'sark',
            'slarv',
            'tash',
            'thak',
            'thalur',
            'thalk',
            'vach',
            'vap',
            'dek',
            'ech',
            'fesh',
            'gek',
            'hrek',
            'lech',
            'met',
            'ner',
            'ter',
            'blik',
            'gith',
            'igm',
            'inax',
            'irsch',
            'kir',
            'lis',
            'lisk',
            'lith',
            'nilv',
            'nirr',
            'tlizit',
            'bor',
            'chon',
            'goch',
            'gor',
            'goth',
            'hoth',
            'khor',
            'kos',
            'loch',
            'lok',
            'loth',
            'moch',
            'moth',
            'noc',
            'och',
            'oth',
            'rolk',
            'roth',
            'sot',
            'soth',
            'vrok',
            'dun',
            'gur',
            'hun',
            'luth',
            'muth',
            'nur',
            'rutt',
            'sut',
            'sutt',
            'szut',
            'tur',
            'urt',
            'utuk',
            'uzt',
            'krych',
            'nyth',
            'slyth',
            'gaan',
            'xaas',
            'boak',
            'ruaak',
            'yalm',
            'haerx',
            'iex',
            'draum',
            'gaur',
            'glaur',
            'rauk',
            'saur',
            'duum',
            'nuur',
            'ruun'
        ]
    },
    empyreal: {
        prefixes: [
            'adan',
            'asan',
            'jasan',
            'palant',
            'sarnat',
            'valmar',
            'adrast',
            'asarn',
            'jasarm',
            'palor',
            'solar',
            'valnar',
            'alant',
            'astar',
            'javral',
            'raman',
            'talan',
            'valnor',
            'amad',
            'atar',
            'kalad',
            'ranal',
            'talar',
            'valon',
            'aman',
            'atlan',
            'kalar',
            'ranar',
            'talas',
            'valor',
            'amar',
            'avar',
            'kalas',
            'rasan',
            'talon',
            'vanar',
            'amars',
            'avlant',
            'kalast',
            'ravan',
            'taran',
            'varal',
            'amart',
            'avral',
            'kasal',
            'samar',
            'taval',
            'varam',
            'ansam',
            'jalan',
            'katarn',
            'saran',
            'valant',
            'varan',
            'arad',
            'jalkar',
            'kaval',
            'sarat',
            'valar',
            'varat',
            'aram',
            'jaran',
            'klaron',
            'sardan',
            'valdor',
            'vardar',
            'aran',
            'jasal',
            'palad',
            'sardar',
            'valkar',
            'voltar'
        ],
        maleSuffixes: [
            'al',
            'an',
            'ar',
            'as',
            'at',
            'ath',
            'ath',
            'ath',
            'anth',
            'athal',
            'athar',
            'athas'
        ],
        femaleSuffixes: [
            'el',
            'en',
            'er',
            'es',
            'et',
            'eth',
            'eth',
            'eth',
            'enth',
            'eleth',
            'ereth',
            'eseth'
        ],
        titles: [
            'ar-',
            'sar-',
            'tar-',
            'var-',
            'jal-',
            'kal-',
            'pal-',
            'ral-',
            'tal-'
        ]
    },
    human: {
        one: [
            'Aind',
            'Ainn',
            'Airk',
            'Aitze',
            'Ald',
            'Ance',
            'Anxe',
            'Ard',
            'Ashf',
            'Aulg',
            'Aun',
            'Aure',
            'Authe',
            'Baelt',
            'Bakh',
            'Bal',
            'Balt',
            'Balthe',
            'Barg',
            'Barll',
            'Bauce',
            'Baysc',
            'Beek',
            'Beele',
            'Berl',
            'Bersch',
            'Beyn',
            'Bhozt',
            'Birme',
            'Birr',
            'Bjanc',
            'Blaen',
            'Blize',
            'Blouch',
            'Blurk',
            'Blynze',
            'Bokk',
            'Borl',
            'Borse',
            'Brahl',
            'Brakk',
            'Bralk',
            'Brang',
            'Brann',
            'Branth',
            'Brem',
            'Bress',
            'Breun',
            'Briint',
            'Brill',
            'Brize',
            'Brod',
            'Broik',
            'Brolt',
            'Bront',
            'Broozh',
            'Brosck',
            'Broud',
            'Brud',
            'Brule',
            'Brun',
            'Bulse',
            'Bunth',
            'Byar',
            'Byst',
            'Caer',
            'Cail',
            'Canth',
            'Carn',
            'Cayrl',
            'Ceyt',
            'Chaeng',
            'Chail',
            'Chaith',
            'Chal',
            'Chalm',
            'Charg',
            'Charn',
            'Chave',
            'Chayle',
            'Chaze',
            'Cheal',
            'Cheev',
            'Chel',
            'Chern',
            'Cherze',
            'Chezl',
            'Chilk',
            'Chlenk',
            'Choalg',
            'Choje',
            'Chor',
            'Chorl',
            'Chorsk',
            'Chounce',
            'Chraq',
            'Chrarr',
            'Chrem',
            'Chrent',
            'Chriyb',
            'Chroad',
            'Chud',
            'Chuz',
            'Claed',
            'Clart',
            'Clesh',
            'Cloup',
            'Clour',
            'Clowr',
            'Coll',
            'Corb',
            'Corje',
            'Corm',
            'Corme',
            'Crade',
            'Creeg',
            'Croold',
            'Croyn',
            'Cthon',
            'Cush',
            'Daalx',
            'Dahr',
            'Daig',
            'Dal',
            'Darm',
            'Darsh',
            'Darze',
            'Dashf',
            'Dask',
            'Datz',
            'Daug',
            'Dawl',
            'Deelth',
            'Deerch',
            'Derd',
            'Derle',
            'Dest',
            'Deuth',
            'Dex',
            'Dhaant',
            'Dherl',
            'Dhoul',
            'Dhuul',
            'Dhuur',
            'Dinz',
            'Dlak',
            'Dlask',
            'Dlir',
            'Doag',
            'Dolc',
            'Dorse',
            'Dralg',
            'Dram',
            'Dran',
            'Drance',
            'Drath',
            'Drax',
            'Draygg',
            'Dreact',
            'Dreed',
            'Dreeg',
            'Dreen',
            'Dreev',
            'Drelm',
            'Drelth',
            'Drerle',
            'Drewm',
            'Drilm',
            'Drinn',
            'Drism',
            'Drissth',
            'Drix',
            'Droale',
            'Drojj',
            'Drom',
            'Droxe',
            'Droy',
            'Drun',
            'Drust',
            'Druuth',
            'Dryle',
            'Drynn',
            'Drythe',
            'Dvarch',
            'Dwesk',
            'Dzairn',
            'Dzij',
            'Dzym',
            'Eeb',
            'Eenthe',
            'Elb',
            'Emp',
            'Ence',
            'Ench',
            'Eng',
            'Enz',
            'Ept',
            'Erd',
            'Esk',
            'Faig',
            'Falthe',
            'Fanch',
            'Faoth',
            'Fard',
            'Faum',
            'Faz',
            'Feant',
            'Feej',
            'Felg',
            'Fernsh',
            'Fesk',
            'Fess',
            'Feth',
            'Fimth',
            'Fize',
            'Flast',
            'Flatch',
            'Flayre',
            'Flerd',
            'Flersh',
            'Flisp',
            'Florn',
            'Fompt',
            'Fousk',
            'Fraine',
            'Frakk',
            'Fralg',
            'Frast',
            'Fregg',
            'Frem',
            'Fresk',
            'Fretch',
            'Frex',
            'Frike',
            'Frile',
            'Frism',
            'Frold',
            'Frone',
            'Fronx',
            'Frook',
            'Frool',
            'Froy',
            'Frush',
            'Fryx',
            'Fulm',
            'Fyahn',
            'Fyast',
            'Fyorb',
            'Fzek',
            'Fzron',
            'Gair',
            'Galthz',
            'Gand',
            'Gane',
            'Gann',
            'Gart',
            'Gath',
            'Gault',
            'Gawle',
            'Gax',
            'Genze',
            'Gerd',
            'Gez',
            'Gharl',
            'Ghea',
            'Ghenz',
            'Ghorl',
            'Ghorx',
            'Gilft',
            'Gilm',
            'Gire',
            'Glaar',
            'Glain',
            'Glarch',
            'Glaux',
            'Gleeth',
            'Gleev',
            'Gleft',
            'Glekke',
            'Glem',
            'Glice',
            'Glip',
            'Glish',
            'Glith',
            'Gloard',
            'Gloob',
            'Gloorsh',
            'Glosk',
            'Glund',
            'Glyre',
            'Glyth',
            'Gnarre',
            'Golm',
            'Gond',
            'Gorm',
            'Gosp',
            'Goste',
            'Graal',
            'Grall',
            'Greel',
            'Greeld',
            'Greelp',
            'Grend',
            'Grilf',
            'Grimp',
            'Groad',
            'Grond',
            'Groolsh',
            'Gruon',
            'Grux',
            'Gthuu',
            'Gurze',
            'Gwisp',
            'Gwith',
            'Gwosk',
            'Gyorr',
            'Gyz',
            'Haag',
            'Haar',
            'Haask',
            'Hade',
            'Hadj',
            'Halk',
            'Halm',
            'Hane',
            'Harb',
            'Harch',
            'Harg',
            'Harx',
            'Hauke',
            'Haux',
            'Hawlx',
            'Hax',
            'Heerf',
            'Hersh',
            'Hetz',
            'Hezz',
            'Hisk',
            'Hize',
            'Hjorr',
            'Hlare',
            'Hlor',
            'Hoag',
            'Hob',
            'Horl',
            'Horm',
            'Hosh',
            'Hraak',
            'Hrailk',
            'Hreen',
            'Hrine',
            'Hroon',
            'Hrume',
            'Hruse',
            'Huxx',
            'Hythe',
            'Ingg',
            'Jaarge',
            'Jad',
            'Jaerth',
            'Jaig',
            'Jairn',
            'Jal',
            'Jalth',
            'Jance',
            'Jand',
            'Jant',
            'Janx',
            'Jard',
            'Jark',
            'Jarn',
            'Jask',
            'Jath',
            'Jauce',
            'Jaus',
            'Jauth',
            'Jaze',
            'Jeel',
            'Jekk',
            'Jend',
            'Jenx',
            'Jerd',
            'Jern',
            'Jexx',
            'Jhang',
            'Jhaulk',
            'Jhor',
            'Jhure',
            'Jinch',
            'Jind',
            'Jinz',
            'Jirle',
            'Joorm',
            'Jorm',
            'Jorn',
            'Jrond',
            'Jurze',
            'Jusk',
            'Juzz',
            'Jyfe',
            'Jyin',
            'Kaerr',
            'Kaid',
            'Kal',
            'Kamn',
            'Kand',
            'Kang',
            'Kank',
            'Karn',
            'Karth',
            'Karze',
            'Kaune',
            'Kedj',
            'Keek',
            'Keig',
            'Kell',
            'Kelph',
            'Kerce',
            'Kerm',
            'Kerst',
            'Kesp',
            'Keth',
            'Kez',
            'Khaiz',
            'Khal',
            'Khand',
            'Kharb',
            'Kharsp',
            'Khern',
            'Khif',
            'Khond',
            "Kh\xf4r",
            'Khorst',
            'Khrev',
            'Kinch',
            'Kish',
            'Kiv',
            'Kjeld',
            'Klaff',
            'Klaz',
            'Kleed',
            'Kloob',
            'Kloohn',
            'Klyne',
            'Kmool',
            'Knaar',
            'Knut',
            'Kolff',
            'Kolg',
            'Konv',
            'Koss',
            'Koul',
            'Krake',
            'Krall',
            'Kranj',
            'Krax',
            'Kreel',
            'Krej',
            'Kremp',
            'Krey',
            'Krile',
            'Krinch',
            'Kroff',
            'Kroll',
            'Krompf',
            'Kuest',
            'Kull',
            'Kulm',
            'Kuon',
            'Kuum',
            'Kvon',
            'Kwask',
            'Kwaz',
            'Kyre',
            'Lach',
            'Laev',
            'Lan',
            'Lantz',
            'Larnste',
            'Lartz',
            'Laur',
            'Lawrg',
            'Layje',
            'Leet',
            'Lenx',
            'Leth',
            'Liln',
            'Liss',
            'Lod',
            'Loec',
            'Lonn',
            'Loord',
            'Loosk',
            'Lound',
            'Luhr',
            'Lumbb',
            'Lurs',
            'Lyrr',
            'Lysk',
            'Maarth',
            'Maec',
            'Maelv',
            'Magh',
            'Mald',
            'Mant',
            'Manth',
            'Mantz',
            'Marb',
            'Mard',
            'Mayxe',
            'Meand',
            'Meeth',
            'Melg',
            'Meln',
            'Merrt',
            'Merzh',
            'Mesp',
            'Mirsp',
            'Mirx',
            'Miskt',
            "Ml\xf6",
            'Mointh',
            'Mool',
            'Moork',
            'Moorthe',
            'Mord',
            'Morl',
            'Moskt',
            'Mox',
            'Mulse',
            'Murlk',
            'Murste',
            'Myrrhne',
            'Naall',
            'Naar',
            'Naaz',
            'Naer',
            'Naik',
            'Naine',
            'Nairx',
            'Nalm',
            'Nanx',
            'Naois',
            'Naphk',
            'Nar',
            'Narct',
            'Narrm',
            'Naulk',
            'Naxx',
            'Naze',
            'Nelq',
            'Nem',
            'Nemn',
            'Nerrz',
            'Ngal',
            'Nime',
            'Nirft',
            'Nisp',
            'Nithe',
            'Noerth',
            'Nolgh',
            'Nool',
            'Noom',
            'Norb',
            'Norle',
            'Noth',
            'Nraeve',
            'Nulth',
            'Nurb',
            'Nuss',
            'Nyalg',
            'Nyalk',
            'Nym',
            'Nynx',
            'Olth',
            'Omm',
            'Omn',
            'Ooon',
            'Ord',
            'Orld',
            'Ornce',
            'Oth',
            'Ounde',
            'Ourne',
            'Paaz',
            'Palch',
            'Parn',
            'Parth',
            'Parzt',
            'Path',
            'Pelk',
            'Pell',
            'Pesm',
            'Phad',
            'Phairn',
            'Phant',
            'Phlarn',
            'Phong',
            'Photz',
            'Phral',
            'Phul',
            'Pirz',
            'Pjanth',
            'Plange',
            'Plaz',
            'Plegg',
            'Plind',
            'Plomb',
            'Plorze',
            'Plumf',
            'Pluun',
            'Pnidd',
            'Poile',
            'Pome',
            'Pould',
            'Praige',
            'Presk',
            'Prike',
            'Prokk',
            'Prook',
            'Prya',
            'Pryle',
            'Prynne',
            'Psarn',
            'Ptenx',
            'Pulge',
            'Pume',
            'Quaan',
            'Quaar',
            'Quagh',
            'Quaild',
            'Quaisth',
            'Qual',
            'Qualt',
            'Quanst',
            'Quanz',
            'Quaoph',
            'Quarl',
            'Quast',
            'Quech',
            'Qued',
            'Quelg',
            'Quelm',
            'Querk',
            'Quigg',
            'Quilg',
            'Quol',
            'Quonj',
            'Quool',
            'Quorze',
            'Quune',
            'Quynd',
            'Raask',
            'Rahm',
            'Raine',
            'Raisth',
            'Ralce',
            'Rald',
            'Rast',
            'Raunt',
            'Raupt',
            'Rax',
            'Raxt',
            'Rayche',
            'Raz',
            'Reelce',
            'Reendt',
            'Relth',
            'Relz',
            'Rez',
            'Rhath',
            'Rhaze',
            'Rhiss',
            'Rhom',
            'Rhorn',
            'Rhyll',
            'Rifk',
            'Rilm',
            'Rilx',
            'Rimsk',
            'Rimth',
            'Riss',
            'Rith',
            'Rix',
            'Rodr',
            'Rodst',
            'Roen',
            'Rogg',
            'Rolm',
            'Rolx',
            'Roult',
            'Rull',
            'Rulm',
            'Rult',
            'Rumche',
            'Runce',
            'Ruor',
            'Ruusque',
            'Ruz',
            'Ryke',
            'Rynx',
            'Ryond',
            'Rythe',
            'Saar',
            'Saech',
            'Saedd',
            'Sairgh',
            'San',
            'Sange',
            'Sarg',
            'Sark',
            'Sarl',
            'Sarn',
            'Sarpt',
            'Skroine',
            'Scroot',
            'Scrylte',
            'Scryme',
            'Sculp',
            'Scuss',
            'Scyrth',
            'Sdor',
            'Seelt',
            'Seif',
            'Sen',
            'Senthe',
            'Sfite',
            'Shad',
            'Shar',
            'Sharg',
            'Sharm',
            'Sharn',
            'Sheb',
            'Sheel',
            'Shenn',
            'Shenx',
            'Sherth',
            'Shilm',
            'Shind',
            'Shont',
            'Shren',
            'Shune',
            'Shurm',
            'Shuuth',
            'Shyang',
            'Skarn',
            'Skart',
            'Skeen',
            'Skerr',
            'Skorle',
            'Skraf',
            'Skrafe',
            'Skrib',
            'Skrift',
            'Skroi',
            'Skyre',
            'Slaar',
            'Slanc',
            'Slark',
            'Slarm',
            'Slask',
            'Slaunce',
            'Slaur',
            'Sleer',
            'Slemt',
            'Slike',
            'Slith',
            'Sloif',
            'Slorg',
            'Slorn',
            'Sluff',
            'Slynd',
            'Smeke',
            'Smete',
            'Smink',
            'Smold',
            'Snabe',
            'Snard',
            'Snarr',
            'Sneath',
            'Snurch',
            'Soick',
            'Solm',
            'Sool',
            'Soorve',
            'Sorl',
            'Sorm',
            'Sorn',
            'Sosz',
            'Sounx',
            'Sparll',
            'Splynd',
            'Sprake',
            'Squalj',
            'Sran',
            'Srend',
            'Sroon',
            'Stalb',
            'Starl',
            'Stelk',
            'Strangg',
            'Strix',
            'Strom',
            'Strowl',
            'Stuhr',
            'Styche',
            'Styre',
            'Suntz',
            'Suule',
            'Suusht',
            'Svinse',
            'Swaerk',
            'Swyst',
            'Syle',
            'Syoll',
            'Taede',
            'Tael',
            'Tak',
            'Tal',
            'Tanj',
            'Targ',
            'Targh',
            'Tark',
            'Tarl',
            'Tath',
            'Taus',
            'Tavv',
            'Taze',
            'Tchel',
            'Tcherm',
            'Tchoum',
            'Tebs',
            'Teelk',
            'Teern',
            'Teirn',
            'Telg',
            'Telk',
            'Terb',
            'Terre',
            'Tez',
            'Thaad',
            'Thaarn',
            'Thad',
            'Thaed',
            'Tham',
            'Thand',
            'Thang',
            'Thapp',
            'Thard',
            'Thark',
            'Thask',
            'Thaugh',
            'Thaum',
            'Thaurn',
            'Thawn',
            'Thax',
            'Theed',
            'Thesk',
            'Thevv',
            'Theyz',
            'Thirrf',
            'Tholk',
            'Thorm',
            'Thosk',
            'Thoure',
            'Thrak',
            'Thralf',
            'Thrand',
            'Thrasp',
            'Thrawl',
            'Thrawn',
            'Thrax',
            'Thrilce',
            'Thrizz',
            'Throck',
            'Thromb',
            'Throsp',
            'Thull',
            'Thuu',
            "Tl\xf6n",
            'Toal',
            'Tog',
            'Tol',
            'Tolg',
            'Tolm',
            'Tooz',
            'Torb',
            'Torje',
            'Torm',
            'Torr',
            'Torsk',
            'Torth',
            'Trahl',
            'Treel',
            'Treesk',
            'Trell',
            'Trem',
            'Treys',
            'Trild',
            'Trilse',
            'Trinx',
            'Trojj',
            'Tronf',
            'Trost',
            'Troyne',
            'Trulm',
            'Tsai',
            'Tsang',
            'Tselm',
            'Tsleg',
            'Tspoy',
            'Tsrome',
            'Tthann',
            'Tull',
            'Tvash',
            'Twez',
            'Twillx',
            'Tyae',
            'Tyfe',
            'Tyog',
            'Tzank',
            'Tzoy',
            'Ulm',
            'Urst',
            'Vaar',
            'Vaersl',
            'Vaist',
            'Valg',
            'Valtch',
            'Vand',
            'Vansh',
            'Var',
            'Vard',
            'Varl',
            'Vask',
            'Vass',
            'Vath',
            'Vaulx',
            'Vaus',
            'Vaxx',
            'Vayze',
            'Veb',
            'Veed',
            'Veeth',
            'Vegg',
            'Vek',
            'Velb',
            'Venk',
            'Venth',
            'Verle',
            'Vesp',
            'Veth',
            'Vilt',
            'Vipt',
            'Virl',
            'Virx',
            'Visk',
            'Viss',
            'Vist',
            'Vith',
            'Vlack',
            'Vlax',
            'Vleft',
            'Vloongh',
            'Vohm',
            'Volg',
            'Vool',
            'Voon',
            'Voor',
            'Vor',
            'Vorg',
            'Vorl',
            'Vorque',
            'Vorse',
            'Vort',
            'Vrahk',
            'Vrain',
            'Vramp',
            'Vreng',
            'Vrilx',
            'Vrosk',
            'Vroyce',
            'Vuul',
            'Wertz',
            'Wheld',
            'Whimk',
            'Whirx',
            'Whoord',
            'Wix',
            'Woise',
            'Wome',
            'Woorn',
            'Worrb',
            'Wrahz',
            'Wraime',
            'Wrax',
            'Wrhye',
            'Wrold',
            'Wrost',
            'Wurlp',
            'Wyast',
            'Wye',
            'Wynv',
            'Wyrn',
            'Xaayr',
            'Xaen',
            'Xaif',
            'Xain',
            'Xalm',
            'Xan',
            'Xarle',
            'Xas',
            'Xau',
            'Xean',
            'Xelb',
            'Xenve',
            'Xerth',
            'Xill',
            'Xin',
            'Xinsce',
            'Xis',
            'Xive',
            'Xix',
            'Xord',
            'Xoth',
            'Xush',
            'Xyle',
            'Xysc',
            'Yad',
            'Yagre',
            'Yaim',
            'Yand',
            'Yarl',
            'Yauce',
            'Yeb',
            'Yeerk',
            'Yend',
            'Yenj',
            'Yest',
            'Yhalm',
            'Yhe',
            'Yhem',
            'Yifth',
            'Yilb',
            'Yivv',
            'Yoort',
            'Yoth',
            'Yrr',
            'Yund',
            'Yush',
            'Yuun',
            'Zaar',
            'Zahn',
            'Zaidh',
            'Zaift',
            'Zaile',
            'Zaive',
            'Zand',
            'Zanq',
            'Zao',
            'Zaon',
            'Zaoth',
            'Zar',
            'Zash',
            'Zeft',
            'Zeige',
            'Zek',
            'Zell',
            'Zelm',
            'Zelth',
            'Zend',
            'Zha',
            'Zhash',
            'Zhayce',
            'Zherl',
            'Zhirth',
            'Zhool',
            'Zhorm',
            'Zhuul',
            'Zil',
            'Zilge',
            'Zinn',
            'Zixt',
            'Zlante',
            'Zlaque',
            'Zlar',
            'Zold',
            'Zook',
            'Zool',
            'Zoor',
            'Zor',
            'Zorl',
            'Zorn',
            'Zoth',
            'Zoul',
            'Zreethe',
            'Zull',
            'Zusque',
            'Zwerl',
            'Zynx',
            'Zyx'
        ],
        two: [
            'Aahdret',
            'Aarlen',
            'Aasren',
            'Aastrasl',
            'Aban',
            'Abbith',
            'Ablif',
            'Aboas',
            'Abrance',
            'Abrax',
            'Abryn',
            'Abyok',
            'Acear',
            'Acfyst',
            'Achekk',
            'Achelse',
            'Achlarg',
            'Achren',
            'Achriss',
            'Ackvold',
            'Acram',
            'Acu',
            'Adaon',
            'Addanc',
            'Adeil',
            'Adire',
            'Adlay',
            'Adlen',
            'Adlon',
            'Admel',
            'Adoin',
            'Adon',
            'Adrek',
            'Adreln',
            'Adrich',
            'Adrilc',
            'Adurthe',
            'Aduush',
            'Aealim',
            'Aeddan',
            'Aedha',
            'Aedir',
            'Aedlynx',
            'Aeiran',
            'Aelis',
            'Aelma',
            'Aemon',
            'Aenet',
            'Aenthu',
            'Aeprox',
            'Aeren',
            'Aerind',
            'Aerkoon',
            'Aerkour',
            'Aerlithe',
            'Aeron',
            'Aeryle',
            'Aethlyr',
            'Aethon',
            'Afenk',
            'Affraig',
            'Afraaj',
            'Agburz',
            'Ageen',
            'Aghil',
            'Aghill',
            'Aglin',
            'Agroth',
            'Agwyn',
            'Agyorl',
            "Ahmr\xe9",
            'Aia',
            'Aiaia',
            'Aibmab',
            'Aidajn',
            'Aiden',
            'Aidon',
            'Aigol',
            'Ailcaer',
            "Aink\xe9",
            'Ainzu',
            'Airmid',
            'Aislinn',
            'Aislithe',
            'Aiza',
            'Aizan',
            'Ajaak',
            'Ajnaic',
            'Akaal',
            'Akar',
            'Akem',
            'Akhtar',
            'Akif',
            'Akii',
            'Akir',
            'Aklo',
            'Akon',
            'Akoorb',
            'Akrain',
            'Akshooth',
            'Akthrain',
            'Akvar',
            'Alao',
            'Alarre',
            'Albaize',
            'Albin',
            'Albrif',
            'Aldende',
            'Aldlor',
            'Aldlum',
            'Aldon',
            'Aldor',
            'Aldreb',
            'Aldred',
            'Aldren',
            'Aldryn',
            'Aldtas',
            'Alenthe',
            'Alfan',
            'Algus',
            'Alif',
            'Aling',
            'Aljic',
            'Aljric',
            'Allaire',
            'Allar',
            'Almaer',
            'Almeir',
            'Almen',
            'Alodd',
            'Alsob',
            'Altin',
            'Altur',
            'Alver',
            'Alya',
            'Amact',
            'Amair',
            'Ambard',
            'Ambeln',
            'Ambril',
            'Ameste',
            'Amfik',
            'Amkir',
            'Ammdar',
            'Ammek',
            'Amoyl',
            'Amphoth',
            'Amrath',
            'Amren',
            'Amyrg',
            'Amzar',
            'Anach',
            'Anar',
            'Anaz',
            'Ancharl',
            'Anclaar',
            'Anctash',
            'Andell',
            'Andjez',
            'Andon',
            'Andore',
            'Andorh',
            'Andrad',
            'Andreth',
            'Androlg',
            'Andrys',
            'Andval',
            'Anghra',
            'Anglame',
            'Angleem',
            'Anglock',
            'Anglor',
            'Angmor',
            'Angtai',
            'Anhlaw',
            'Anigg',
            'Anin',
            'Anjak',
            'Anjos',
            'Anken',
            'Ansher',
            'Ansoj',
            'Anson',
            'Antar',
            'Antarn',
            'Anthor',
            'Antrim',
            'Antriq',
            'Antrisp',
            'Anvar',
            'Anvyen',
            'Anxrin',
            'Anzire',
            'Aopharz',
            'Aophim',
            'Aquill',
            'Ara',
            'Araar',
            'Aradh',
            'Arak',
            'Aran',
            'Araste',
            'Araz',
            'Arbal',
            'Archam',
            'Archech',
            'Archite',
            'Arcus',
            'Ardann',
            'Ardesh',
            'Ardlen',
            'Ardoth',
            'Ardune',
            'Ardwar',
            'Ardwil',
            'Ardwile',
            'Areest',
            'Arell',
            'Argin',
            'Argorm',
            'Argrath',
            'Arhnaal',
            'Aribe',
            'Arick',
            'Arjhag',
            'Arkal',
            'Arkharn',
            'Arklow',
            'Arkrog',
            'Arlan',
            'Arlbeth',
            'Arldon',
            'Arlya',
            'Armast',
            'Armorn',
            'Armyze',
            'Arna',
            'Arnhor',
            'Arnid',
            'Arnlor',
            'Arnrost',
            'Aroinz',
            'Arrah',
            'Arrhod',
            'Arshel',
            'Artheen',
            'Arthex',
            'Artor',
            'Artus',
            'Arun',
            'Arvel',
            'Arvilk',
            'Arvol',
            'Arvox',
            'Arweld',
            'Aryem',
            'Aryft',
            'Aryon',
            'Aryph',
            'Aryus',
            'Arzang',
            'Arzi',
            'Asberl',
            'Ascelle',
            'Aschar',
            'Aschka',
            'Asco',
            "\xc4s\xeb",
            'Asgar',
            'Asgorn',
            'Ashan',
            'Ashane',
            'Ashbarl',
            'Ashed',
            'Ashild',
            'Ashlann',
            'Ashnyn',
            'Ashord',
            'Ashtah',
            'Ashur',
            'Askar',
            'Aspand',
            'Asrai',
            'Astei',
            'Astem',
            'Astha',
            'Astran',
            'Astrin',
            'Atang',
            'Atar',
            'Atdeel',
            'Ateng',
            'Athald',
            'Athar',
            'Athcroj',
            'Athlas',
            'Athlos',
            'Athmar',
            'Athquom',
            'Atlampt',
            'Atlank',
            'Atmaas',
            'Atmeh',
            'Atmog',
            'Atox',
            'Atraaf',
            'Atrend',
            'Atsal',
            'Attor',
            'Atyar',
            'Atyre',
            'Auchstyr',
            'Auchur',
            'Aucir',
            'Audric',
            'Aundan',
            'Aunxar',
            'Aurawn',
            'Aureth',
            'Auxid',
            'Avane',
            'Avarr',
            'Averq',
            'Avoon',
            'Avorn',
            'Awndale',
            'Axaane',
            'Axos',
            'Aya',
            'Aydras',
            'Ayen',
            'Ayin',
            'Ayir',
            'Ayla',
            'Aylmer',
            'Ayrish',
            'Ayshun',
            'Ayshung',
            'Azal',
            'Azash',
            'Azeal',
            'Azen',
            'Azgoth',
            'Azhrarn',
            'Azlon',
            'Azlyn',
            'Azmael',
            'Azorn',
            'Azoth',
            'Azra',
            'Azraq',
            'Azrean',
            'Azreck',
            'Azter',
            'Azzay',
            'Babdar',
            'Baccruz',
            'Baelil',
            'Bahar',
            'Baiar',
            'Baiern',
            'Baikaen',
            'Baiposk',
            'Bakan',
            'Bakra',
            'Balain',
            'Balaz',
            'Baldhur',
            'Baldrim',
            'Balgurr',
            'Balkar',
            'Balok',
            'Balour',
            'Banek',
            'Banffoge',
            'Bannheld',
            'Bannor',
            'Baraell',
            'Bardel',
            'Barduy',
            'Baren',
            'Barim',
            'Barind',
            'Barldsy',
            'Barlom',
            'Barlon',
            'Barltan',
            'Barnar',
            'Barood',
            'Baros',
            'Barrenc',
            'Barrin',
            'Bartain',
            'Basfric',
            'Basim',
            'Basmol',
            'Bassinth',
            'Bassto',
            'Bastarre',
            'Batrosque',
            'Bayven',
            'Bayzell',
            'Bazan',
            'Bazit',
            'Beclaan',
            'Bedane',
            'Bedese',
            'Beejlam',
            'Begnus',
            'Belan',
            'Belaz',
            'Belcoir',
            'Beleth',
            'Belgaun',
            'Belic',
            'Beljan',
            'Bellin',
            'Bellom',
            'Belmul',
            'Belnarth',
            'Belor',
            'Belorn',
            'Belot',
            'Belrain',
            'Belstos',
            'Belthan',
            'Belthis',
            'Belwilg',
            'Bengol',
            "B\xebol",
            'Beolj',
            'Beras',
            'Berclad',
            'Bercol',
            'Berik',
            'Berild',
            'Berim',
            'Berith',
            'Berlyne',
            'Berrec',
            'Bersem',
            'Bershar',
            'Bertrenk',
            'Berzik',
            'Bethmel',
            'Beyash',
            'Beyus',
            'Bezgrael',
            'Bezpar',
            'Bhoorva',
            'Biferb',
            'Biilar',
            'Bildesh',
            'Billosh',
            'Bilmar',
            'Bindle',
            'Biraad',
            'Birain',
            'Bireln',
            'Birta',
            'Bisel',
            'Bjanni',
            'Blauthike',
            'Bleran',
            'Bleskran',
            'Blonjerg',
            'Blorvind',
            'Blunyc',
            'Bodvar',
            "Bo\xebd",
            'Boggrah',
            'Bolaoz',
            'Bolthorn',
            'Borale',
            'Boren',
            'Borgald',
            'Borin',
            'Borlaith',
            'Borlas',
            'Borlid',
            'Borlo',
            'Borngah',
            'Borzer',
            'Boshan',
            'Bothar',
            'Botro',
            'Bouphar',
            'Bowjen',
            'Boyarl',
            'Braagen',
            'Bracca',
            'Braeklarn',
            'Bragen',
            'Brahan',
            'Brakkon',
            'Brala',
            'Brali',
            'Brallu',
            'Bralma',
            'Brandar',
            'Brandec',
            'Brangwej',
            'Branthu',
            'Brantys',
            'Branvaol',
            'Branzan',
            'Brascand',
            'Brasslin',
            'Braxen',
            'Braxtor',
            'Brealij',
            'Bredhal',
            'Breedast',
            'Bregem',
            'Brehen',
            'Breitsoj',
            'Brelkrov',
            'Brenen',
            'Brenlan',
            'Brestej',
            'Brethil',
            'Bretta',
            'Brevlyn',
            'Brevta',
            'Brielle',
            'Brindax',
            'Brindence',
            'Brintu',
            'Brinys',
            'Brislyn',
            'Brithael',
            'Brithric',
            'Brobal',
            'Brohnin',
            'Brona',
            'Broosin',
            'Broxus',
            'Brufod',
            'Brundelx',
            'Bryapka',
            'Brynit',
            'Buckrald',
            'Bulvet',
            'Burcan',
            'Burrgaut',
            'Bwermolc',
            'Byeloor',
            'Bylys',
            'Byrkast',
            'Byzar',
            'Cadairn',
            'Caddax',
            'Cadel',
            'Cadfrel',
            'Cadrach',
            'Cadreth',
            'Caecyn',
            'Caedfer',
            'Caelis',
            'Caerron',
            'Caillean',
            'Caiphul',
            'Cairon',
            'Caldel',
            'Calensch',
            'Calkdaev',
            'Calmic',
            'Calnor',
            'Calunn',
            'Calyz',
            'Calzan',
            'Camain',
            'Cambree',
            'Camdlon',
            'Camsar',
            'Candla',
            'Candrak',
            'Canelb',
            'Cangmor',
            'Canthar',
            'Cantrasc',
            'Caopha',
            'Caostri',
            'Caranth',
            'Carbrod',
            'Cardelv',
            'Carfheen',
            'Carlasc',
            'Carlinx',
            'Carnax',
            'Carnly',
            'Carnool',
            'Caroin',
            'Carquel',
            'Carthis',
            'Caskeil',
            'Castlon',
            'Cathlaid',
            'Caveesm',
            'Cavorn',
            'Cavosse',
            'Cavris',
            'Caynarv',
            'Cayrin',
            'Cazberr',
            'Cazyach',
            'Cedrim',
            'Cedrisk',
            'Ceilerse',
            'Celbarb',
            'Cemtruo',
            'Cenyth',
            'Ceraik',
            'Cercyon',
            'Cerdun',
            'Cerlint',
            'Cermor',
            'Cernon',
            'Cerra',
            'Cessair',
            'Cevir',
            'Ceylinn',
            'Chadan',
            'Chadlor',
            'Chadzik',
            'Chaemor',
            'Chagor',
            'Chalar',
            'Challem',
            'Challeth',
            'Chalvir',
            'Chambarr',
            'Changtsai',
            'Chanoth',
            'Chanti',
            "Cha\xf6l",
            'Charatze',
            'Charnyx',
            'Charresh',
            'Charyd',
            'Chaska',
            'Chaulet',
            'Chavir',
            'Chayim',
            'Chazane',
            'Chazgel',
            'Cheldor',
            'Chelim',
            'Chelprey',
            'Chelshrike',
            'Chendil',
            'Chenean',
            'Chenoa',
            'Cherla',
            'Chessene',
            'Chevonde',
            'Chezil',
            'Chial',
            'Chian',
            'Chigran',
            'Chimu',
            'Chimzil',
            'Chirril',
            'Chirthiz',
            'Chitrind',
            'Chlangi',
            'Chlodig',
            'Chlorild',
            'Chordash',
            'Chorrin',
            'Chrezel',
            'Chungaez',
            'Chunjan',
            'Chyvil',
            'Cidran',
            'Cilmar',
            'Cinctraic',
            'Ciraf',
            'Cirkin',
            'Cirnak',
            'Cista',
            'Civar',
            'Ciwan',
            'Clafaug',
            'Clarinn',
            'Cleedis',
            'Clendlim',
            'Clenvred',
            'Cligra',
            'Cloosag',
            'Cloralt',
            "Co\xe4x",
            'Cobord',
            'Cobrynth',
            'Coddry',
            'Cogarn',
            'Coimarn',
            'Colgrim',
            'Colyss',
            'Comnlan',
            'Conjerb',
            'Conjin',
            'Coram',
            'Corbrod',
            'Cordin',
            'Corem',
            'Coreme',
            'Corill',
            'Corince',
            'Cormast',
            'Corrysm',
            'Corsolle',
            'Couran',
            'Coyzan',
            'Cramog',
            'Craxan',
            'Craydarth',
            'Craye',
            'Creidah',
            'Crennex',
            'Crestarl',
            'Crestry',
            'Creydai',
            'Crezel',
            'Crilayth',
            'Crixbine',
            'Crochell',
            'Crolas',
            'Cromough',
            'Croquarne',
            'Cuddry',
            'Cuhaid',
            'Cullyn',
            'Curik',
            'Curin',
            'Curlask',
            'Cusheal',
            'Cusheth',
            'Cuttray',
            'Cyanril',
            'Cydace',
            'Cylenn',
            'Cynquil',
            'Cyrand',
            'Cyrib',
            'Cyrvemth',
            'Czarai',
            'Dabthan',
            'Dacil',
            'Daeglev',
            'Daelden',
            'Dafor',
            'Daghand',
            'Dagharz',
            'Dagir',
            'Dahiil',
            'Daikoon',
            'Dailenn',
            'Dakul',
            'Dakvon',
            'Dalain',
            'Dalanc',
            'Dalcraw',
            'Dalga',
            'Dalgirth',
            'Dalith',
            'Dalman',
            'Dalraev',
            'Dalsar',
            'Dalvai',
            'Dalvoc',
            'Dalwyn',
            'Damaal',
            'Damar',
            'Damesk',
            'Damrir',
            'Danchel',
            'Dandar',
            'Dandroan',
            'Danfis',
            'Dangrim',
            'Dankin',
            'Dantlee',
            'Daotar',
            'Daphrin',
            'Daplurn',
            'Dara',
            'Darach',
            'Darake',
            'Daran',
            'Darax',
            'Darbeel',
            'Darcer',
            'Darga',
            'Darglin',
            'Darinth',
            'Darjek',
            'Darjii',
            'Darlist',
            'Darlith',
            'Darmont',
            'Darmore',
            'Darnath',
            'Darnein',
            'Darnime',
            'Daron',
            'Darool',
            'Darsid',
            'Darsiiv',
            'Darsin',
            'Darvane',
            'Darven',
            'Darzed',
            'Darzha',
            'Dashgu',
            'Dasig',
            'Dastor',
            'Dastryn',
            'Daugas',
            'Daulaz',
            'Davar',
            'Daveld',
            'Davix',
            'Davlit',
            'Davras',
            'Davrou',
            'Davrune',
            'Dawfoke',
            'Daxon',
            'Dayko',
            'Daysase',
            'Daytar',
            'Deaclynd',
            'Debfin',
            'Dechru',
            'Deenos',
            'Delaur',
            'Delcold',
            'Deldrak',
            'Deleea',
            'Delente',
            'Delgath',
            'Delgaun',
            'Delmar',
            'Delna',
            'Delrean',
            'Delser',
            'Demgris',
            'Deneth',
            'Dengar',
            'Denlorn',
            'Derdain',
            'Derfel',
            'Dergast',
            'Derild',
            'Derlin',
            'Derlor',
            'Deroh',
            'Deron',
            'Derroll',
            'Dersarre',
            'Derthark',
            'Devolt',
            'Devreed',
            'Dhakos',
            'Dhornen',
            'Dhoumene',
            'Dhranak',
            'Dhyana',
            'Dialn',
            'Dibdrek',
            'Dilfar',
            'Dilgid',
            'Dilquay',
            'Dilvak',
            'Dinoor',
            'Diorne',
            'Diran',
            'Dirim',
            'Dirkalt',
            'Dirmalk',
            'Dirrach',
            'Dirrahk',
            'Dirvus',
            'Distar',
            'Disten',
            'Distran',
            'Ditrenth',
            'Divos',
            'Djarmon',
            'Djehla',
            'Djelha',
            'Djira',
            'Djola',
            'Dolljan',
            'Dolthar',
            'Dolvith',
            'Domede',
            'Domen',
            'Domin',
            'Domnux',
            'Domon',
            'Domvit',
            'Domwren',
            'Donet',
            'Donlaze',
            'Doran',
            'Dorath',
            'Dorgand',
            'Dorgath',
            'Dorhar',
            'Dorin',
            'Dornath',
            'Dornbain',
            'Dorok',
            'Dorsan',
            'Dorspaich',
            'Dortoom',
            'Dorvai',
            'Dostaan',
            'Doussa',
            'Dowflox',
            'Dozrig',
            'Dozthuk',
            'Drabsnar',
            'Dradoi',
            'Dradus',
            'Draegra',
            'Drakhor',
            'Drakhri',
            'Drakirn',
            'Drakkan',
            'Dralar',
            'Dramah',
            'Dramfer',
            'Draogat',
            'Drassonne',
            'Drauphor',
            'Draven',
            'Draxok',
            'Drayley',
            'Drayven',
            'Drazvec',
            'Drebyss',
            'Dreezhan',
            'Drefest',
            'Dreggol',
            'Dreintor',
            'Drellefe',
            'Drenfust',
            'Drengar',
            'Drethlec',
            'Drevark',
            'Dreynel',
            'Drezael',
            'Drezaem',
            'Drilant',
            'Drimmis',
            'Drinda',
            'Dringle',
            'Drion',
            'Drissa',
            'Dristirk',
            'Drocolg',
            'Drogan',
            'Drohulse',
            'Droilfin',
            'Drokoag',
            'Dronasp',
            'Druchor',
            'Drunal',
            'Drusilf',
            'Dryduos',
            'Duarn',
            'Duergan',
            'Dulith',
            'Dulkarn',
            'Dulkast',
            'Dunry',
            'Durnik',
            'Durzin',
            'Duskim',
            'Duubown',
            'Dvorast',
            'Dwendlim',
            'Dwyvach',
            'Dygard',
            'Dylenx',
            'Dymnash',
            'Dynqua',
            'Dynroth',
            'Dyoni',
            'Dyshim',
            'Dyskrahn',
            'Dytheus',
            'Dyvim',
            'Dyzant',
            'Dzoraug',
            'Easval',
            'Ebane',
            'Ebur',
            'Echael',
            'Echross',
            'Eclane',
            'Edcyl',
            'Eddar',
            'Eddax',
            'Eddor',
            'Edeth',
            'Edhil',
            'Edrun',
            'Eduu',
            'Eehatt',
            'Eelek',
            'Eelgren',
            'Eerban',
            'Eglarth',
            'Egron',
            'Ehilm',
            'Ehlmat',
            'Ehlreth',
            'Eidon',
            'Eidrinn',
            'Eilif',
            'Einar',
            'Eirecht',
            "Eithn\xe9",
            'Ejence',
            'Ekvarl',
            'Elaen',
            'Eland',
            'Elath',
            'Eldin',
            'Eldix',
            'Eldrab',
            'Eldron',
            'Eldru',
            'Elek',
            'Elem',
            'Elfreth',
            'Elgroth',
            'Elkin',
            'Elkleth',
            'Ellern',
            'Ellrass',
            'Elmral',
            'Elnume',
            'Elod',
            'Elran',
            'Elriph',
            'Elu',
            'Elvrit',
            'Elyx',
            'Elzast',
            'Emal',
            'Emberle',
            'Emdel',
            'Emerl',
            'Emgar',
            'Emton',
            'Enban',
            'Encarth',
            'Endrade',
            'Endril',
            'Enferth',
            'Englin',
            'Enkim',
            'Ennek',
            'Enris',
            'Enrost',
            'Enskel',
            'Ensorn',
            'Envess',
            'Enzhai',
            'Ephelt',
            'Ephraj',
            'Ephti',
            'Ephyre',
            'Eppent',
            'Eppin',
            'Erbmaj',
            'Erdlan',
            'Ergar',
            'Ergoth',
            'Ergron',
            'Erhil',
            'Erijn',
            'Ermon',
            'Ermor',
            'Eron',
            'Errain',
            'Errone',
            'Erson',
            'Erwat',
            'Erxab',
            'Escande',
            'Esceft',
            'Esdrix',
            'Esghar',
            'Eshrik',
            'Eshuur',
            'Eskarn',
            'Eslyn',
            'Esris',
            'Essa',
            'Estrag',
            'Estorl',
            'Estrif',
            'Esyfe',
            'Ethrene',
            'Euross',
            'Evelj',
            'Evinth',
            'Evith',
            'Evorn',
            'Evska',
            'Ewlon',
            'Eyphra',
            'Eythor',
            'Ezail',
            'Ezmi',
            'Ezri',
            'Fabolde',
            'Fadar',
            'Faendyre',
            'Faesten',
            'Faffle',
            'Fafnalg',
            'Faiorg',
            'Falbin',
            'Falcarn',
            'Falgar',
            'Falhehn',
            'Fali',
            'Falldrijn',
            'Falsfeen',
            'Falslen',
            'Falume',
            'Fanchel',
            'Faran',
            'Fardoth',
            'Fardron',
            'Farglid',
            'Farhaude',
            'Farleit',
            'Farli',
            'Farmolj',
            'Farnek',
            'Farngold',
            'Farngor',
            'Faroon',
            'Farosh',
            'Farrain',
            'Farscall',
            'Farsun',
            'Farunst',
            'Farzdoy',
            'Fasthes',
            'Fautell',
            'Favuld',
            'Favvaz',
            'Fayel',
            'Faygrenn',
            'Faylaol',
            'Faylynn',
            'Fayol',
            'Fazhal',
            'Fazzur',
            'Feeming',
            'Feikry',
            'Feirrex',
            'Felinx',
            'Felnar',
            'Felor',
            'Felstar',
            'Felthund',
            'Felvrand',
            'Femigg',
            'Fendahl',
            'Fendrabe',
            'Fenew',
            'Fenic',
            'Fenist',
            'Fenleith',
            'Fennus',
            'Fenrald',
            'Fenzil',
            'Feorth',
            'Ferman',
            'Fermern',
            'Fernath',
            'Ferndel',
            'Fernhol',
            'Fernool',
            'Fernosk',
            'Ferram',
            'Ferthel',
            'Fervigg',
            'Ferwend',
            'Fesru',
            'Fethlan',
            'Feyan',
            'Feyern',
            'Fhorat',
            'Fiantz',
            'Fictyr',
            'Figgin',
            'Fiiya',
            'Filtarg',
            'Fingril',
            'Finstar',
            'Firca',
            'Firga',
            'Firin',
            'Firon',
            'Fiskroll',
            'Fissworx',
            'Flauleck',
            'Flayna',
            'Flestrin',
            'Fletchen',
            'Flikir',
            'Flingrel',
            'Flitan',
            'Flixis',
            'Foarad',
            'Fodusk',
            'Fogrin',
            'Fohdon',
            'Folstin',
            'Fomkrin',
            'Fontand',
            'Foozan',
            'Foragh',
            'Forang',
            'Foraujh',
            'Forbulse',
            'Foren',
            'Forjisk',
            'Formki',
            'Fornoar',
            'Foros',
            'Forroosk',
            'Forstine',
            'Fortrelce',
            'Forvael',
            'Fozgiel',
            'Frama',
            'Franaard',
            'Frannon',
            'Frashtol',
            'Frayja',
            'Freasand',
            'Fremmoun',
            'Frillox',
            'Friston',
            'Frixeen',
            'Frolin',
            'Frondir',
            'Fronost',
            'Fronubb',
            'Froscele',
            'Frowal',
            'Fruwasp',
            'Ftoomi',
            'Fulshin',
            'Fulume',
            'Fumpsil',
            'Furtloft',
            'Fusraul',
            'Fylin',
            'Fylssa',
            'Fyojhkor',
            "Fy\xf6nn",
            'Fyza',
            'Gaatel',
            'Gadan',
            'Gadoc',
            'Gadra',
            'Gadri',
            'Gaenlea',
            'Gaerlind',
            'Gaerris',
            'Gafael',
            'Gaisherl',
            'Gajiste',
            'Gakaal',
            'Galaart',
            'Galach',
            'Galaij',
            'Galan',
            'Galbaaz',
            'Galchan',
            'Galdoir',
            'Galenx',
            'Galind',
            'Gallarg',
            'Gallasp',
            'Galmad',
            'Galron',
            'Galsdor',
            'Galvrix',
            'Gambrax',
            'Gamitz',
            'Gamkya',
            'Ganaek',
            'Gandril',
            'Ganerth',
            'Ganerve',
            'Ganix',
            'Gankor',
            'Ganock',
            'Gareck',
            'Gareld',
            'Garhaft',
            'Garlan',
            'Garol',
            'Garon',
            'Garos',
            'Garpast',
            'Garras',
            'Garron',
            'Garstrang',
            'Garstrith',
            'Garthag',
            'Garthaun',
            'Garven',
            'Gathen',
            'Gaunmar',
            'Gaurbal',
            'Gavrok',
            'Gawend',
            'Gaxtor',
            'Gazwylg',
            'Gearna',
            'Geaxa',
            'Gebrence',
            'Gebrow',
            'Gechart',
            'Gechrak',
            'Gedreth',
            'Geerharg',
            'Gehed',
            'Gelan',
            'Gelann',
            'Geldol',
            'Gelwik',
            'Gemal',
            'Gemelf',
            'Genglar',
            'Gerant',
            'Gerin',
            'Gerlant',
            'Geroind',
            'Gerreint',
            'Gerren',
            'Gesin',
            'Gethen',
            'Gezdrey',
            'Ghaachev',
            'Gharlane',
            'Ghatar',
            'Ghatha',
            'Ghellence',
            'Gherent',
            'Gherlan',
            'Ghirra',
            'Ghomnir',
            'Ghralence',
            'Giaj',
            'Gilboch',
            'Gildor',
            'Gildren',
            'Gildrift',
            'Gilflin',
            'Gilir',
            'Gilith',
            'Gillyn',
            'Gilmir',
            'Gilmirst',
            'Gilnar',
            'Gilorn',
            'Gilos',
            'Gilva',
            'Gilvar',
            'Gimeld',
            'Gimlej',
            'Gimnel',
            'Ginnen',
            'Ginorsh',
            'Girbeaux',
            'Girin',
            'Girzan',
            'Gisgin',
            'Githeld',
            'Githew',
            'Gitlan',
            'Gitril',
            'Gittos',
            'Gizralle',
            'Glaeloth',
            'Glaernex',
            'Glaraum',
            'Glasdray',
            'Glasquel',
            'Glaury',
            'Glayant',
            'Gleada',
            'Glebur',
            'Glethlot',
            'Gleyden',
            'Glianth',
            'Glidnimm',
            'Glimanthe',
            'Glirice',
            'Glirrish',
            'Gloisur',
            'Glowan',
            'Glufjyn',
            'Glyngal',
            'Glynzel',
            'Glystraine',
            'Gnasthor',
            'Gnasthra',
            'Gnivlah',
            'Gnohesk',
            'Gnorri',
            'Gnospret',
            'Gobar',
            'Goklod',
            'Golluer',
            'Gomar',
            'Gondrift',
            'Gonjal',
            'Gorad',
            'Gorgost',
            'Gorin',
            'Gorinssk',
            'Gorklu',
            'Gorlis',
            'Gormane',
            'Gornik',
            'Gorshay',
            'Goryon',
            'Gossparl',
            'Gothel',
            'Grachar',
            'Graequil',
            'Graghan',
            'Grahault',
            'Grainim',
            'Granik',
            'Granlon',
            'Gravec',
            'Greavdal',
            'Greelar',
            'Greethrin',
            'Greforn',
            'Grehuse',
            'Grekith',
            'Gremdahl',
            'Grendax',
            'Grennath',
            'Grenslae',
            'Grenvin',
            'Greorle',
            'Grevam',
            'Greyfell',
            'Griam',
            'Grian',
            'Griea',
            'Griffix',
            'Grifnid',
            'Grindan',
            'Grishulf',
            'Gristis',
            'Griswald',
            'Grittu',
            'Grivalx',
            "Gro\xe4xx",
            'Grombul',
            'Grondar',
            'Grortam',
            'Grulbest',
            'Grussex',
            'Grydon',
            'Gryemox',
            'Grykar',
            'Grypha',
            'Guhan',
            'Guhlnor',
            'Gulla',
            'Gulzund',
            'Gunshird',
            'Gunthal',
            'Gunthar',
            'Gunzhur',
            'Gurdam',
            'Gurjan',
            'Gustay',
            'Guthril',
            'Gwacyn',
            'Gwaihir',
            'Gweddyn',
            'Gweien',
            'Gwenca',
            'Gwendald',
            'Gwepfrath',
            'Gwesder',
            'Gwildor',
            'Gwithra',
            'Gwomyr',
            'Gwyran',
            'Gwythinst',
            "Gy\xe1n",
            'Gylrath',
            "Gy\xf3rb",
            'Gyriss',
            'Gyrlaen',
            'Gyrlath',
            'Gysankh',
            'Gyseyt',
            'Gystral',
            'Haakrim',
            'Haarstrin',
            'Habmarl',
            'Hadan',
            'Hadar',
            'Hadarg',
            'Hado',
            'Hadrim',
            'Hadron',
            'Haestan',
            'Haefgan',
            'Hafthir',
            'Hagith',
            'Hagra',
            'Haidelth',
            'Haijiss',
            'Hainen',
            'Hakhoim',
            'Haklar',
            'Haklor',
            'Hakpard',
            'Hala',
            'Halbex',
            'Halborn',
            'Haldor',
            'Haloth',
            'Halperle',
            'Halsan',
            "Hal\xfbt",
            'Halvner',
            'Hamba',
            'Hamisk',
            'Hanastre',
            'Handra',
            'Hanil',
            'Hanierth',
            'Hanith',
            'Hantar',
            'Hanthryn',
            'Hapvar',
            'Haral',
            'Harave',
            'Harchyl',
            'Harfare',
            'Hargan',
            'Harnir',
            'Harntil',
            'Harnyrse',
            'Harpann',
            'Harran',
            'Harrelm',
            'Harstar',
            'Hartaz',
            'Harthan',
            'Harthex',
            'Harthran',
            'Hartrond',
            'Harvas',
            'Harvel',
            'Harzelle',
            'Haspid',
            'Hasrick',
            'Hatchiss',
            'Hatrasd',
            'Havin',
            'Havrel',
            'Hawklin',
            'Hawkram',
            'Hawkran',
            'Hawkreld',
            'Hawleet',
            'Hawljin',
            'Hawtran',
            'Haxas',
            'Hazgarl',
            'Hazkar',
            'Hazrond',
            'Hazvelc',
            'Hazyrg',
            'Hazzal',
            'Hearroj',
            'Hedin',
            'Heenarg',
            'Heengul',
            'Hefpyre',
            'Heinvroh',
            'Helaz',
            'Heldix',
            'Helflitz',
            'Helir',
            'Helsdal',
            'Helsur',
            'Helvem',
            'Hembra',
            'Heram',
            'Herisk',
            'Herndre',
            'Herrul',
            'Herthose',
            'Herym',
            'Herzick',
            'Hespek',
            'Hesrel',
            'Hessun',
            'Hetcroft',
            'Hethar',
            'Hethra',
            'Heurhyl',
            'Hexil',
            'Hezron',
            'Heztor',
            'Hibriss',
            'Hienn',
            'Hiffelk',
            'Hifforn',
            'Hifryn',
            'Hildred',
            'Hilix',
            'Hiljin',
            'Hilxin',
            'Himlon',
            'Himon',
            'Himvli',
            'Hinthan',
            'Hinzay',
            'Hireal',
            'Hirrean',
            'Hisrilf',
            'Hisvran',
            'Hizar',
            'Hizron',
            'Hjalmar',
            'Hjeldin',
            'Hjordrik',
            'Hlyrmis',
            'Hobtalg',
            'Hoesgald',
            'Holay',
            'Holgar',
            'Hollox',
            'Holthan',
            'Homli',
            'Honturg',
            'Hophand',
            'Hoprig',
            'Horan',
            'Horglin',
            'Horjak',
            'Horlask',
            'Hormatz',
            'Horond',
            'Horros',
            'Horthoon',
            'Horzak',
            'Hotath',
            'Hothcog',
            'Hothcol',
            'Hrasha',
            'Hrasquer',
            'Hrelar',
            'Hresheuth',
            'Hrinspire',
            'Hroleur',
            "Hr\xf6nir",
            'Hrossa',
            'Hrostar',
            'Hsaptren',
            'Humbuss',
            'Humquor',
            'Hunard',
            'Hundar',
            'Hurcad',
            'Hurgal',
            'Hurnod',
            'Hurrisk',
            'Hursin',
            'Hurvin',
            'Hurym',
            'Hussuln',
            'Huusim',
            'Hyarante',
            'Hyfryn',
            'Hylar',
            'Hyssome',
            'Hyxley',
            'Hyzail',
            'Hyzen',
            'Ibchol',
            'Ibizt',
            'Ibrolg',
            'Ica',
            'Ictar',
            'Iduun',
            'Ighai',
            'Ignale',
            'Ignire',
            'Igraa',
            'Igresk',
            'Iijind',
            'Iithkin',
            'Ijeng',
            'Ikalss',
            'Ikeen',
            'Ikkrish',
            "Ikl\xe9y",
            'Ildel',
            'Ildelft',
            'Ildin',
            'Ildis',
            'Ildnarr',
            'Illa',
            'Illyis',
            'Ilnim',
            'Ilruhn',
            'Ilsuor',
            'Ilthoss',
            'Iltrilt',
            'Iltrogh',
            'Ilva',
            'Ilvar',
            'Ilxar',
            'Ilyag',
            'Imcanx',
            'Imcolg',
            'Imdiv',
            'Imhas',
            'Immak',
            'Immoyr',
            'Imnarl',
            'Impag',
            'Imrib',
            'Imrift',
            'Imtsith',
            'Indlech',
            'Indloth',
            'Indlut',
            'Indred',
            'Ingarh',
            'Ingelk',
            'Ingen',
            'Inghar',
            'Ingolm',
            'Ingrald',
            'Inilv',
            'Inis',
            'Innluu',
            'Inoke',
            'Inslar',
            'Iom',
            'Ipshoom',
            'Iraiz',
            'Iras',
            'Irauld',
            'Iraunt',
            'Irbry',
            'Irchel',
            'Irex',
            'Irglas',
            'Irlen',
            'Irough',
            'Irrash',
            'Irrax',
            'Irsai',
            'Iruste',
            'Irwick',
            'Irxeath',
            'Isbard',
            'Ishan',
            'Ishenx',
            'Ishgan',
            'Ishkar',
            'Ishlak',
            'Ishshan',
            'Ishya',
            'Islarch',
            'Ismlok',
            'Isorn',
            'Isphek',
            'Issa',
            'Isstan',
            'Itaaq',
            'Ithend',
            'Ithkaar',
            'Ithome',
            'Ivaade',
            'Ivaire',
            'Ivind',
            'Ivool',
            'Ivorn',
            'Ivral',
            'Ivran',
            'Ivrax',
            'Ivyd',
            'Ivyod',
            'Ixan',
            'Ixaq',
            'Ixor',
            'Iygin',
            'Izinth',
            'Izleng',
            'Izmisk',
            'Iztra',
            'Izvire',
            'Jaadis',
            'Jaagix',
            'Jaalmez',
            'Jaalon',
            'Jaaluth',
            'Jablant',
            'Jacor',
            'Jadir',
            'Jado',
            'Jadoorm',
            'Jaedan',
            'Jaelyss',
            'Jagan',
            'Jaggol',
            'Jagrid',
            'Jahir',
            'Jahrgrim',
            'Jaidu',
            'Jaldeer',
            'Jalmid',
            'Jalom',
            'Jama',
            'Janam',
            'Janan',
            'Jandix',
            'Janlay',
            'Jano',
            'Janrass',
            'Jantust',
            'Janu',
            'Japloon',
            'Jarad',
            'Jarilz',
            'Jariz',
            'Jarlew',
            'Jarlith',
            'Jarngor',
            'Jarra',
            'Jartak',
            'Jartusk',
            'Jarveen',
            'Jarvil',
            'Jarvix',
            'Jarzad',
            'Jasir',
            'Jasphar',
            'Jaswen',
            'Jaussig',
            'Jautan',
            'Javen',
            'Javert',
            'Javrik',
            'Javtir',
            'Jaxal',
            'Jaxel',
            'Jaylence',
            'Jazanne',
            'Jazraal',
            'Jazrel',
            'Jazrode',
            'Jebhart',
            'Jedra',
            'Jeeldor',
            'Jeelteg',
            'Jehzehr',
            'Jelthar',
            'Jekkar',
            'Jelantru',
            'Jelday',
            'Jeldor',
            'Jelym',
            'Jenbow',
            'Jendarr',
            'Jenkisk',
            'Jerdys',
            'Jerec',
            'Jerel',
            'Jerim',
            'Jessel',
            'Jetashe',
            'Jethrik',
            'Jeven',
            'Jevist',
            'Jezreel',
            'Jezzar',
            'Jezzra',
            'Jhebdaeg',
            'Jheexadh',
            'Jheluth',
            'Jherrox',
            'Jhinarr',
            'Jhinith',
            'Jhorin',
            'Jhourlann',
            'Jhumpoust',
            'Jhuvar',
            'Jiaf',
            'Jianc',
            'Jiglak',
            'Jihalg',
            'Jilsa',
            'Jiltarn',
            'Jinnow',
            'Jintlorn',
            'Jinvik',
            'Jiral',
            'Jirnon',
            'Jirnost',
            'Jisa',
            'Jithrast',
            'Jixile',
            'Joamorsk',
            'Jobel',
            'Jolrant',
            'Jolsir',
            'Jomec',
            'Jomsut',
            'Jondar',
            'Jooskan',
            'Jorad',
            'Jorael',
            'Joram',
            'Joran',
            'Jorel',
            'Jornic',
            'Joron',
            'Jorvim',
            'Joskyl',
            'Jossak',
            'Jostib',
            'Jothal',
            'Jovaine',
            'Joysair',
            'Jugeen',
            'Juldrake',
            'Julix',
            'Julphra',
            'Jultus',
            'Jungro',
            'Junnar',
            'Jurin',
            'Jurinn',
            'Jurret',
            'Jushdak',
            'Justix',
            'Juthcot',
            'Juxpire',
            'Jynyx',
            'Jyvlex',
            'Kaanpell',
            'Kadjix',
            'Kaerjeld',
            'Kaggoth',
            'Kagolm',
            'Kahlan',
            'Kahmahr',
            'Kaiya',
            'Kaklo',
            'Kaldrak',
            'Kalduk',
            'Kalen',
            'Kaliss',
            'Kallak',
            'Kalshai',
            'Kalthen',
            'Kalvek',
            'Kalvran',
            'Kalxin',
            'Kaman',
            'Kamlant',
            'Kamon',
            'Kander',
            'Kangmir',
            'Kangmor',
            'Kanliin',
            'Kanpo',
            'Kantar',
            'Kanthrix',
            'Kantran',
            'Kanven',
            'Kaplull',
            'Karchad',
            'Karchen',
            'Karchoy',
            'Karcist',
            'Karect',
            'Kareeb',
            'Kargon',
            'Karjin',
            'Karjus',
            'Karkrust',
            'Karnek',
            'Karrax',
            'Karrim',
            'Karsa',
            'Karstall',
            'Kartol',
            'Kasel',
            'Kashir',
            'Kashtuul',
            'Kaspim',
            'Kaspin',
            'Kassar',
            'Katan',
            'Kathak',
            'Kathar',
            'Kathasp',
            'Kathor',
            'Kattelg',
            'Kattra',
            'Kaukris',
            'Kavar',
            'Kavarl',
            'Kavath',
            'Kavis',
            'Kavor',
            'Kayesp',
            'Kayris',
            'Kazarn',
            'Keanca',
            'Kedern',
            'Keerlin',
            'Keermeth',
            'Kegryn',
            'Keigtril',
            'Kekkan',
            'Kelar',
            'Keldar',
            'Kelgus',
            'Kelkor',
            'Kelmar',
            'Kelner',
            'Kelrac',
            'Kelshiir',
            'Kelver',
            'Kelvon',
            'Kelvyath',
            'Kember',
            'Kembriss',
            'Kemoy',
            'Kenshlin',
            'Keraan',
            'Kerdal',
            'Kered',
            'Kerrol',
            'Kersenct',
            'Keru',
            'Kerzard',
            'Kesdric',
            'Kesnahr',
            'Kespeth',
            'Kesrack',
            'Kesrick',
            'Kethdjal',
            'Kethrak',
            'Kevlad',
            'Kexy',
            'Kezven',
            'Khadar',
            'Khadys',
            'Khalart',
            'Khaldan',
            'Khalir',
            'Kheverl',
            'Khondru',
            'Khordov',
            'Khrissa',
            'Khrithra',
            'Khrosa',
            'Khudrax',
            'Khugweb',
            'Kian',
            'Kibbath',
            'Kibha',
            'Kidash',
            'Kiirmu',
            'Kijmin',
            'Kikrasht',
            'Kilas',
            'Kilat',
            'Kilgand',
            'Kilisp',
            'Kilmin',
            'Kimda',
            'Kinduhr',
            'Kinorm',
            'Kinzroft',
            'Kipplob',
            'Kirdon',
            'Kirklen',
            'Kiroum',
            'Kirrax',
            'Kirun',
            'Kirskar',
            'Kirzav',
            'Kisarld',
            'Kishin',
            'Kismer',
            'Kismerle',
            'Kisprimn',
            'Kiston',
            'Kisvord',
            'Kithert',
            'Kithorsk',
            'Kithund',
            'Kithvor',
            'Kivan',
            'Kivooz',
            'Kivoum',
            'Kixime',
            'Kizmay',
            'Kjeldor',
            'Kjindar',
            'Koabon',
            'Kofoum',
            'Koino',
            'Kolbect',
            'Kolchash',
            'Kolduk',
            'Kolthya',
            'Kolvram',
            'Konvain',
            'Korak',
            'Korban',
            'Kordale',
            'Koren',
            'Koreth',
            'Korghil',
            'Korix',
            'Korlisk',
            'Kornor',
            'Kornud',
            'Korok',
            'Korrik',
            'Korsal',
            'Korseng',
            'Kortael',
            'Kortenj',
            'Korthoon',
            'Koruk',
            'Korusk',
            'Korvar',
            'Kosjourn',
            'Kothar',
            'Koxir',
            'Kozzir',
            'Kraatin',
            'Krallorn',
            'Krana',
            'Krangar',
            'Kranorn',
            'Krantheer',
            'Krantor',
            'Kredhal',
            'Kregnux',
            'Krelgar',
            'Krentomzh',
            'Kressen',
            'Krexnahr',
            'Krillon',
            'Krissenq',
            "Kro\xebld",
            'Krotald',
            'Krotar',
            'Krotem',
            'Kruchaen',
            'Krynerl',
            'Kugar',
            'Kuldrah',
            'Kulik',
            'Kulleest',
            'Kulxel',
            'Kunatht',
            'Kurdghar',
            'Kurgnar',
            'Kuruz',
            'Kurvos',
            'Kushish',
            'Kydra',
            'Kyladz',
            'Kylcrum',
            'Kylix',
            'Kyllam',
            'Kymen',
            'Kyrake',
            'Kyrmo',
            'Kyrsha',
            'Kyshi',
            'Kysho',
            'Laabrun',
            'Laarskim',
            'Laconde',
            "La\xebl",
            'Lagu',
            'Lailaske',
            'Laithare',
            'Lakis',
            'Lalan',
            'Lalit',
            'Lalun',
            'Lampor',
            'Lanaar',
            'Landish',
            'Landreth',
            'Langbar',
            'Lanreex',
            'Lanscitt',
            'Lanteld',
            'Lantis',
            'Lantos',
            'Lanvilt',
            'Lanycth',
            'Lanzee',
            'Lanzept',
            'Larbrun',
            'Laresm',
            'Larid',
            'Larind',
            'Larkrosp',
            'Lasquor',
            'Lathir',
            'Lathmarc',
            'Latra',
            'Laudrin',
            'Laxar',
            'Laydor',
            'Layek',
            'Lazelle',
            'Ledmai',
            'Leela',
            'Leena',
            'Leerank',
            'Leesclar',
            'Leggwyt',
            'Leghast',
            'Lehun',
            'Leistorn',
            'Lembarl',
            'Lemgaar',
            'Lemtarn',
            'Lendra',
            'Lensith',
            'Lenzeel',
            'Lephais',
            'Lephern',
            'Leqquan',
            'Lerdeln',
            'Lerlya',
            'Lermest',
            'Lerquint',
            'Lestin',
            'Letek',
            'Lexan',
            'Lextraa',
            'Leystorne',
            'Lherache',
            'Lhusark',
            'Liance',
            'Libourne',
            'Lidrill',
            'Lilir',
            'Lilnid',
            'Liltar',
            'Limdal',
            'Limhoth',
            'Limka',
            'Limson',
            'Lindarl',
            'Lindlorn',
            'Linlaith',
            'Linmer',
            'Linor',
            'Linspar',
            'Lintan',
            'Lintra',
            'Liosse',
            'Liphrodd',
            'Lirram',
            'Lishran',
            'Liskeel',
            'Lissar',
            'Lisstar',
            'Lisstra',
            'Liston',
            'Lisvorn',
            'Litheem',
            'Lithrad',
            'Littwyst',
            'Lixelle',
            'Lixeth',
            'Lixter',
            'Lizki',
            'Lobror',
            'Logas',
            'Lohmi',
            'Loiarl',
            'Loomar',
            'Loorin',
            'Loorzig',
            'Loraem',
            'Loral',
            'Lorbis',
            'Lorrhin',
            'Lorrin',
            'Lorvra',
            'Lothilv',
            'Louwend',
            'Lovoz',
            'Loxzor',
            'Luast',
            'Lubist',
            'Lucenne',
            'Lufraut',
            'Lumas',
            'Lumfa',
            'Lunzar',
            'Lurand',
            'Lurash',
            'Lurin',
            'Luscan',
            'Lutril',
            'Luzfel',
            'Lyanec',
            "Lye\xfcm",
            'Lylix',
            'Lyra',
            'Lyrin',
            'Lyron',
            'Maaga',
            'Macra',
            'Macrad',
            'Maefon',
            'Maegwin',
            'Maerraent',
            'Magalph',
            'Maghan',
            'Maglone',
            'Magmarl',
            'Magnyck',
            'Mahhri',
            'Mahrik',
            'Maidah',
            'Maidak',
            'Mairish',
            'Maisa',
            'Maisan',
            'Majan',
            'Makamb',
            'Makisp',
            'Malak',
            'Malasc',
            'Malber',
            'Malboe',
            'Malda',
            'Maldock',
            'Malfar',
            'Malgrah',
            'Malheme',
            'Malinsp',
            'Malkorf',
            'Malnurb',
            'Malthen',
            'Maltheus',
            'Malthgri',
            'Malthor',
            'Malvisp',
            'Malwer',
            "Malzh\xe9",
            'Mandrask',
            'Manggrim',
            'Mankril',
            'Manthi',
            'Manton',
            "Ma\xf6l",
            'Mapyn',
            'Marack',
            'Maraide',
            'Marasp',
            'Marath',
            'Marax',
            'Marclaw',
            'Marcoorg',
            'Mardhrene',
            'Mardix',
            'Mardur',
            'Mareft',
            'Marhalk',
            'Marhart',
            'Marjaan',
            'Markryn',
            'Marlath',
            'Marlock',
            'Marnec',
            'Maroosh',
            'Marost',
            'Marrek',
            'Marrhal',
            'Marrhan',
            'Marril',
            'Marslin',
            'Marslai',
            'Martheel',
            'Marul',
            'Marvold',
            'Marwhool',
            'Mascrox',
            'Maskrulp',
            'Masplern',
            'Masply',
            'Masquoor',
            'Masryn',
            'Massac',
            'Mastram',
            'Mastrith',
            'Mastruse',
            'Mathgi',
            'Mathlin',
            'Mattraw',
            'Matzin',
            'Maularn',
            'Maundrib',
            'Maurdax',
            'Maustere',
            'Mavasce',
            'Mavic',
            'Mavkert',
            'Mavour',
            'Maxil',
            'Mayern',
            'Maylern',
            'Maylin',
            'Mayrime',
            'Mazzyott',
            'Medarm',
            'Meder',
            'Medist',
            'Meeratz',
            'Meffroa',
            'Mefron',
            'Meglos',
            'Megwen',
            'Mejea',
            'Mekosp',
            'Melaunce',
            'Meldresc',
            'Meleas',
            'Melib',
            'Melisk',
            'Meljarn',
            'Melkur',
            'Melleg',
            'Mellore',
            'Melnayl',
            'Melnyth',
            'Melshiv',
            'Melslem',
            'Melviig',
            'Mendra',
            'Mengisp',
            'Menksoor',
            'Menna',
            'Mephyr',
            'Merdim',
            'Merewn',
            'Merkal',
            'Merkan',
            'Merley',
            'Mermold',
            'Mermoth',
            'Merngar',
            'Merophe',
            'Merresh',
            'Merrest',
            'Merrost',
            'Merryn',
            'Mershun',
            'Mersic',
            'Mersna',
            'Merssan',
            'Merthyr',
            'Merweld',
            'Mesrah',
            'Mesrawn',
            'Mestorl',
            'Mestrin',
            'Methnos',
            'Metrosq',
            'Mevid',
            'Mezard',
            'Mhoran',
            'Mhordaal',
            'Mhovair',
            'Mhurdaal',
            'Mhyrrail',
            'Mianth',
            'Mibris',
            'Micrum',
            'Mida',
            'Midor',
            'Mifrax',
            'Migglin',
            'Mijar',
            'Mijhyk',
            'Mikird',
            'Mileern',
            'Milzrik',
            'Mimur',
            'Minom',
            'Minvra',
            'Minyal',
            'Miraad',
            'Mirach',
            'Mircheld',
            'Mirdain',
            'Mirdij',
            'Mirdole',
            'Mireth',
            'Mirglish',
            'Mirhaz',
            'Mirikke',
            'Mirja',
            'Mirjanth',
            'Mirjenx',
            'Mirkaise',
            'Mirkin',
            'Mirla',
            'Mirrash',
            'Mirrin',
            'Mirrym',
            'Mirtrax',
            'Miryash',
            'Mishaar',
            'Mishim',
            'Miskin',
            'Miskul',
            'Misrach',
            'Miszlar',
            'Mithbrin',
            'Mithlerb',
            'Mitrel',
            'Mivarch',
            'Mivrid',
            'Miwarl',
            'Mixtry',
            'Mizarl',
            'Mizma',
            'Mizrab',
            'Mlenjas',
            'Mlocber',
            'Mlodach',
            'Moda',
            'Mogorn',
            'Moirulse',
            'Molez',
            'Mollith',
            'Molnyx',
            'Molrin',
            'Molvigg',
            'Molvind',
            'Mommur',
            'Monmar',
            'Moondar',
            'Mooneld',
            'Moorith',
            'Moorlow',
            'Moormish',
            'Moran',
            'Morax',
            'Morcal',
            'Morchiss',
            'Mordak',
            'Mordlaw',
            'Mordoc',
            'Mordyle',
            'Moreth',
            'Morgath',
            'Morgleeg',
            'Morglin',
            'Morgmar',
            'Morgrim',
            'Morhain',
            'Morix',
            'Morktar',
            'Morla',
            'Morlig',
            'Morlosc',
            'Mornith',
            'Morrhan',
            'Morsklon',
            'Morssen',
            'Mortan',
            'Morthyld',
            'Morvaen',
            'Moryak',
            'Moshaol',
            'Mosyerl',
            'Moyank',
            'Mozoorb',
            'Mrossard',
            'Mubfusc',
            'Mubur',
            'Mudanc',
            'Mudaz',
            'Muhlenk',
            'Muilt',
            'Mungin',
            'Munin',
            'Murgaist',
            'Murhsan',
            'Mustile',
            'Muuthas',
            'Mygon',
            'Myndax',
            'Myrii',
            'Myrnar',
            'Myronce',
            'Myrrim',
            'Myrvarth',
            'Myrya',
            'Mysind',
            'Mysmak',
            'Naadem',
            'Naadra',
            'Naafa',
            'Naalvad',
            'Naasjerth',
            'Nabdoor',
            'Nabol',
            'Nadar',
            'Nadhil',
            'Nadin',
            'Nagai',
            'Naghir',
            'Nagist',
            'Nagvar',
            'Nahar',
            'Nahoul',
            'Naia',
            'Naidel',
            'Naidis',
            'Naidule',
            'Naidusk',
            'Naion',
            'Naisnim',
            'Naithool',
            'Nakrea',
            'Nalbis',
            'Naldecc',
            'Nalkleth',
            'Nalray',
            'Namail',
            'Namat',
            'Namoin',
            'Namvert',
            'Nandrulg',
            'Namphruk',
            'Nantarth',
            "Na\xf6k",
            'Napolx',
            'Naras',
            'Nardalg',
            'Naren',
            'Narev',
            'Nargath',
            'Narjath',
            'Narkrisst',
            'Naron',
            'Narqui',
            'Narsok',
            'Narthold',
            'Nartolth',
            'Narvi',
            'Narvik',
            'Nasank',
            'Nasir',
            'Natchai',
            'Natchren',
            'Natein',
            'Nathlim',
            'Nathor',
            'Nathraq',
            'Nautcheb',
            'Navai',
            'Navairnz',
            'Navar',
            'Navesm',
            'Nazaarl',
            'Ndola',
            'Nebcherl',
            'Nebron',
            'Nectesce',
            'Neelrix',
            'Neepmire',
            'Nefhorn',
            'Negert',
            'Negort',
            'Nelat',
            'Nelbron',
            'Nelesck',
            'Nelynn',
            'Nemstere',
            'Nemweal',
            'Nenaire',
            'Nengret',
            'Nephard',
            'Nephog',
            'Neri',
            'Nerish',
            'Neruus',
            'Nerveer',
            'Nesbin',
            'Neshkem',
            'Nesser',
            'Nestra',
            'Nesvan',
            'Nethelb',
            'Netskra',
            'Nevlyn',
            'Newhar',
            'Nexoz',
            'Nextar',
            'Nexxar',
            'Neywode',
            'Nezuel',
            'Nezzdak',
            'Niand',
            'Nibine',
            'Nibor',
            'Niconde',
            'Nictroi',
            'Nida',
            'Nifeld',
            'Nigil',
            "Nigr\xe4l",
            'Nijim',
            'Nijis',
            'Nikusp',
            'Nilgorm',
            'Nilnoi',
            'Nimbol',
            'Nimir',
            'Nimon',
            'Nimrede',
            'Nindiss',
            'Nireal',
            'Nirel',
            'Nirhain',
            'Nirhath',
            'Nirloge',
            'Nirnir',
            'Nisherj',
            'Nishla',
            'Nishmir',
            'Nishran',
            'Nissac',
            'Nissal',
            'Nithilt',
            'Nithlom',
            'Nitra',
            'Nivenk',
            'Nivgrom',
            'Nixin',
            'Nizoon',
            'Nizten',
            'Nogaarn',
            'Nokelm',
            'Nolfig',
            'Noloq',
            'Nolthar',
            'Noorlim',
            'Norahl',
            'Nordell',
            'Nordran',
            'Norfroib',
            'Norin',
            'Noroj',
            'Norstoj',
            'Novvulse',
            'Noxit',
            'Nrial',
            'Nuad',
            'Nubweft',
            'Nuendo',
            'Nuhar',
            'Nulka',
            'Nulvilch',
            'Nummag',
            'Nurgan',
            'Nurrzek',
            'Nuscolg',
            'Nushla',
            'Nuuzsal',
            'Nuxile',
            'Nuzain',
            'Nyankra',
            'Nyassaed',
            'Nybron',
            'Nyconth',
            'Nydaur',
            'Nyeon',
            'Nylray',
            'Nynaeve',
            'Nyra',
            'Nyren',
            'Nysra',
            'Oaffleg',
            'Oakine',
            'Oalilse',
            'Oalyn',
            'Oarine',
            'Obron',
            'Obtin',
            'Ocarg',
            'Oedjert',
            'Oeglath',
            'Oejos',
            'Oenu',
            'Oerusk',
            'Oggran',
            'Ogmarx',
            'Ogstlang',
            'Ohmir',
            'Ohmoul',
            'Ohrool',
            'Ohwhon',
            'Ohya',
            'Olanc',
            'Olbrod',
            'Olcind',
            'Oldaar',
            'Oldac',
            'Oleird',
            'Olesk',
            'Olgeerd',
            'Olisch',
            'Olix',
            'Olney',
            'Olthang',
            'Oluode',
            'Olvoor',
            'Omag',
            'Omazd',
            'Ombaast',
            'Omdret',
            'Omfelx',
            'Omkraum',
            'Omoq',
            'Omron',
            'Onchorl',
            'Ondar',
            'Onilsh',
            'Oninsp',
            'Onolk',
            'Onvrix',
            'Oonglax',
            'Ooxaith',
            'Opaor',
            'Opchel',
            'Opild',
            'Opmar',
            'Opult',
            'Oqueln',
            'Orasch',
            'Orayl',
            'Orbern',
            'Orbohst',
            'Orbweft',
            'Ordol',
            'Orgoch',
            'Orgrool',
            'Orhomb',
            'Orinde',
            'Orisse',
            'Orix',
            'Orjasp',
            'Orkuuz',
            'Orli',
            'Orlim',
            'Ormdrad',
            'Ormerd',
            'Ormuuz',
            'Ornault',
            'Ornith',
            'Oroon',
            'Orpax',
            'Orrisk',
            'Orsind',
            'Orskog',
            'Ortain',
            'Orthmar',
            'Ortholt',
            'Orthroy',
            'Ortkuz',
            'Orvulse',
            'Orwelt',
            'Orxlorn',
            'Osgleft',
            'Oshraal',
            'Osphel',
            'Ospin',
            'Osresp',
            'Ossiz',
            'Ossvule',
            'Osthandl',
            'Othast',
            'Ottlan',
            'Ovaile',
            'Ovar',
            'Owal',
            'Owelft',
            'Owlin',
            'Ouxroul',
            'Oxdren',
            'Oxiv',
            'Oxoor',
            'Ozur',
            'Padath',
            'Palaor',
            'Palew',
            'Palifte',
            'Palvem',
            'Palzac',
            'Pamar',
            'Paminsk',
            'Panarre',
            'Pancraf',
            'Pandak',
            'Pandire',
            'Paneesh',
            'Pangaz',
            'Paono',
            'Paraerg',
            'Parbha',
            'Pargask',
            'Pargus',
            'Parmist',
            'Parnon',
            'Paroul',
            'Parrsath',
            'Paslaive',
            'Paxilp',
            'Pazot',
            'Peaflod',
            'Pelas',
            'Pelase',
            'Pelcourj',
            'Pellin',
            'Pelnos',
            'Pelvest',
            'Pemnarsc',
            'Pendoir',
            'Pendra',
            'Pengarth',
            'Pengron',
            'Peraule',
            'Percaal',
            'Perdin',
            'Perdis',
            'Perisk',
            'Perlask',
            'Perral',
            'Perreld',
            'Perrinx',
            'Perthald',
            'Perzec',
            'Pevel',
            'Pexul',
            'Pezloch',
            'Phaithor',
            'Phaleg',
            'Phanstern',
            'Phaovonce',
            'Pharan',
            'Phargon',
            'Pharvis',
            'Phatuum',
            'Phayra',
            'Phenquor',
            'Phesjan',
            'Phinerc',
            'Phinna',
            'Phinra',
            'Phislid',
            'Phlomel',
            'Pholgon',
            'Phondath',
            'Phynynx',
            'Phyzent',
            'Pidnubb',
            'Pilark',
            'Pilkarn',
            'Pirkrod',
            'Pittheus',
            'Planget',
            'Plitkin',
            'Pluroign',
            'Pnakord',
            'Poddle',
            'Pohlon',
            'Pohnoor',
            'Poroon',
            'Porsthil',
            'Portlusce',
            'Praamon',
            'Praarin',
            'Prabaar',
            'Pravdile',
            'Pressar',
            'Presta',
            'Pretil',
            'Prilsorn',
            'Pritantte',
            'Pritjan',
            'Prollel',
            'Proter',
            'Prothoon',
            'Psattor',
            'Psirrim',
            'Pteron',
            'Pulaaz',
            'Pulisk',
            'Pumish',
            'Purrdiste',
            'Puuhilsk',
            'Puvas',
            'Pyalvar',
            'Pyra',
            'Pyrafe',
            'Pyreyn',
            'Pyrjus',
            'Pyular',
            'Pyzzim',
            'Qraatin',
            'Quaestrin',
            'Quagel',
            'Quagrith',
            "Qua\xefve",
            'Quaman',
            'Quamrith',
            'Quanar',
            'Quanthon',
            'Quantra',
            'Quanvire',
            'Quardan',
            'Quargom',
            'Quarnos',
            'Quarouth',
            'Quasha',
            'Queageth',
            'Quedrech',
            'Queeden',
            'Queeyat',
            'Quekal',
            'Quelade',
            'Queldrim',
            'Quelges',
            'Quelneth',
            'Quelthar',
            'Quembras',
            'Quenna',
            'Querkez',
            'Querlo',
            'Queryl',
            'Quesan',
            'Quesparl',
            'Quesrol',
            'Quevros',
            'Queygo',
            'Quiddel',
            'Quidre',
            'Quigmoss',
            'Quilmose',
            'Quinaut',
            'Quindle',
            'Quinga',
            'Quinid',
            'Quintarl',
            'Quirrak',
            'Quirvell',
            'Quisrym',
            'Quizlo',
            'Quolbin',
            'Quondoon',
            'Quuddreus',
            'Quyssa',
            'Raaxis',
            'Raband',
            'Raberm',
            'Rablaen',
            'Rabuur',
            'Raccyx',
            'Racere',
            'Radalt',
            'Raddel',
            'Radeld',
            "Ra\xebn",
            "Ra\xebss",
            'Raethel',
            'Raevact',
            'Rafain',
            'Rafam',
            'Rafarn',
            'Rafmarth',
            'Raftwen',
            'Rafur',
            'Ragdra',
            'Ragen',
            'Rago',
            'Rahaz',
            'Raina',
            "Ra\xefre",
            'Raishauer',
            'Raistlig',
            'Raistoc',
            'Rajan',
            'Rajin',
            'Raju',
            'Rakeeg',
            'Rakhan',
            'Rakhaz',
            'Rakheer',
            'Rakkim',
            'Rakspire',
            'Rakthvi',
            'Ralik',
            'Ralir',
            'Ralise',
            'Ralith',
            'Ralkeev',
            'Ralvord',
            'Ramat',
            'Ramath',
            'Ranax',
            'Randar',
            'Randor',
            'Ranghen',
            'Rangvair',
            'Rani',
            'Ranid',
            'Ranousse',
            'Ranthur',
            "Ran\xfbk",
            'Ranyem',
            'Rascha',
            'Rascrag',
            'Raslak',
            'Rasmoth',
            'Rastagg',
            'Rastak',
            'Ratai',
            'Rater',
            'Rathdome',
            'Rathgor',
            'Rathlede',
            'Rathor',
            'Raudal',
            'Raudell',
            'Ravann',
            'Ravoe',
            'Ravthek',
            'Raxar',
            'Raxen',
            'Razdan',
            'Razdel',
            'Razul',
            'Rebesc',
            'Reddom',
            'Redlac',
            'Redleth',
            'Reeval',
            'Reevast',
            'Regwelf',
            'Relem',
            'Rellskar',
            'Rellzer',
            'Relmnar',
            'Relmund',
            'Relthar',
            'Remerst',
            'Remist',
            'Renair',
            'Rendkett',
            'Rendlorn',
            'Renjik',
            'Renlaw',
            'Renna',
            'Renquil',
            'Resfrith',
            'Reskem',
            'Resna',
            'Ressif',
            'Restid',
            'Retheer',
            'Retor',
            'Retraaj',
            'Reuzor',
            'Revas',
            'Reyga',
            'Reyna',
            'Rezbain',
            'Rezhar',
            'Rhamaine',
            'Rhandain',
            'Rhavee',
            'Rhaxdan',
            'Rhenea',
            'Rheya',
            'Rhila',
            'Rhiorn',
            'Rhobban',
            'Rhodelx',
            'Rhojann',
            'Rhylash',
            'Riaal',
            'Riak',
            'Ribos',
            'Ridun',
            'Ridya',
            'Rience',
            'Rifdos',
            'Rifgild',
            'Rigar',
            'Riklak',
            'Riksul',
            'Rila',
            'Rillif',
            'Rillu',
            'Rilmorn',
            'Rimchoze',
            'Rimnaaj',
            'Rimsall',
            'Ringool',
            'Rinquel',
            'Rinthmaw',
            'Ripurth',
            'Risnys',
            'Ristang',
            'Riswod',
            'Rivalke',
            'Rivarsh',
            'Rivcol',
            'Riveld',
            'Riverle',
            'Rivlin',
            'Rivoold',
            'Rivrook',
            'Rivvid',
            'Rixel',
            'Rixju',
            'Rizhad',
            'Rizzek',
            "Ro\xe4k",
            'Roakey',
            'Roandat',
            'Robforz',
            'Rocaltz',
            'Rodan',
            'Rodhar',
            "Ro\xeble",
            "Ro\xebll",
            'Roethord',
            'Rofloef',
            'Rokeel',
            'Rolthar',
            "R\xf6lyat",
            'Rontayn',
            'Roolenth',
            'Roqual',
            'Rorkar',
            'Rothar',
            'Roujat',
            'Roweal',
            'Roxhaast',
            'Royanse',
            'Royskyar',
            'Rubarj',
            'Rubiss',
            'Rudrisk',
            'Ruidh',
            'Rukhjan',
            'Rukuz',
            'Rulbowe',
            'Rulmool',
            'Rumael',
            'Rupaic',
            'Rupsey',
            'Rurik',
            'Rusgar',
            'Rusis',
            'Ruther',
            'Ruusul',
            'Ruvad',
            'Ruwen',
            'Ryalas',
            'Rygarn',
            'Rynell',
            'Rynrys',
            'Rysta',
            'Sabak',
            'Sabal',
            'Sabfane',
            'Sabhel',
            'Sabon',
            'Sabrok',
            'Sador',
            'Sadrouth',
            'Saerdon',
            'Saerulse',
            'Safrence',
            'Safrine',
            'Sagard',
            'Saglamne',
            'Saia',
            'Saihail',
            'Saijax',
            'Salir',
            'Sallese',
            'Samand',
            'Samar',
            'Sambrea',
            'Samler',
            'Sanald',
            'Sanan',
            'Sanar',
            'Sandice',
            'Sangol',
            'Sankor',
            'Sanpalk',
            'Sanrind',
            'Sanrow',
            'Sansal',
            'Santlor',
            'Santrul',
            'Saphyx',
            'Sarbrid',
            'Sarcyn',
            'Sardrum',
            'Sarel',
            'Sarex',
            'Sarfinn',
            'Sargash',
            'Sarik',
            'Sarla',
            'Sarlyn',
            'Sarmuld',
            'Sarnax',
            'Sarode',
            'Saroon',
            'Sarthath',
            'Sarthay',
            'Saruul',
            'Sarvan',
            'Sateer',
            'Sathla',
            'Saudraal',
            'Saugrib',
            'Savak',
            'Savar',
            'Savaunce',
            'Savay',
            'Savot',
            'Savryn',
            'Saxar',
            'Scamire',
            'Scarloth',
            'Scaroth',
            'Scarvlin',
            'Schabith',
            'Scharay',
            'Sclava',
            'Scolath',
            'Scradast',
            'Scrilisp',
            'Searan',
            'Seckba',
            'Sedrim',
            'Seethenn',
            'Segrold',
            'Seheitt',
            'Sejar',
            'Selar',
            'Seldar',
            'Selgren',
            'Selith',
            'Selkind',
            'Selnor',
            'Selris',
            'Selthen',
            'Sember',
            'Sembrith',
            'Semer',
            'Semisk',
            'Sena',
            'Sendrej',
            'Sendure',
            'Sengeld',
            'Senrin',
            'Senther',
            'Sentix',
            'Seonce',
            'Sephrone',
            'Seplacc',
            'Seprism',
            'Seraan',
            'Seranth',
            'Seray',
            'Serdu',
            'Sereste',
            'Serlarc',
            'Sermer',
            'Seroz',
            'Serrof',
            'Serryx',
            'Sersoom',
            'Sertase',
            'Seskel',
            'Sethar',
            'Sethchell',
            'Sethjen',
            'Sethran',
            "Sfa\xebl",
            'Sfennec',
            'Sferaj',
            'Sforakh',
            'Shabrum',
            'Shadar',
            'Shagold',
            'Shahile',
            'Shaifarl',
            'Shalun',
            'Shalvir',
            'Shamad',
            'Shanfa',
            'Sharaq',
            'Sharaz',
            'Sharrak',
            'Sharrel',
            'Sharva',
            'Sharzik',
            'Shastor',
            'Shathak',
            'Shaxa',
            'Shaydayl',
            'Sheerah',
            'Shembis',
            'Shenesk',
            'Shetrax',
            'Shezael',
            'Shiaf',
            'Shialk',
            'Shila',
            'Shilex',
            'Shimar',
            'Shimglor',
            'Shimren',
            'Shintar',
            'Shirak',
            'Shivan',
            'Shiza',
            'Sholmeg',
            'Shruuminth',
            'Shryffin',
            'Shudleet',
            'Shurik',
            'Shurrug',
            'Shyden',
            'Shylath',
            'Siade',
            'Sibvir',
            'Sidron',
            'Sierl',
            'Sila',
            'Silcharn',
            'Sildeed',
            'Silgast',
            'Silgool',
            'Siljenk',
            'Silmat',
            'Silon',
            'Silphane',
            'Silruum',
            'Silure',
            'Silvasp',
            'Silvryn',
            'Simbrul',
            'Sindhi',
            'Siol',
            'Siralk',
            'Sithirg',
            'Sium',
            'Skaaro',
            'Skagra',
            'Skarazk',
            'Skarloch',
            'Skayla',
            'Skedrea',
            'Skeltrin',
            'Skilon',
            'Skorafe',
            'Skurin',
            'Slanslar',
            'Slanthar',
            'Slarood',
            'Slaskren',
            'Slavgar',
            'Slazor',
            'Sleekla',
            'Sleshkeg',
            'Sleynux',
            'Slijash',
            'Slorac',
            'Slurvaum',
            'Smarag',
            'Smerdis',
            'Smialv',
            'Snargai',
            'Snayrod',
            'Sneitad',
            'Snurlix',
            'Sobeck',
            'Sodarg',
            'Solael',
            'Solbar',
            'Soldine',
            'Solis',
            'Solohe',
            'Solok',
            'Solos',
            'Soltar',
            'Sombrid',
            'Sophald',
            'Sorak',
            'Sorgas',
            'Sormtor',
            'Sorquoon',
            'Sorren',
            'Sorven',
            'Sorza',
            'Sotar',
            'Soveh',
            'Soydil',
            'Spalant',
            'Spandrell',
            'Sparveld',
            'Sperax',
            'Spereld',
            'Spirach',
            'Splinvek',
            'Sprimaine',
            'Squamgreve',
            'Srajsken',
            'Sraknis',
            'Sramine',
            'Srebold',
            'Sreeva',
            'Srendix',
            'Srennant',
            'Sriddoth',
            'Sroika',
            'Sroweb',
            'Sryxla',
            'Stajesce',
            'Stalfess',
            'Starklyn',
            'Staygus',
            'Steeglorn',
            'Stengos',
            'Stereth',
            'Steylin',
            'Sthygron',
            'Stielle',
            'Stirgan',
            'Stornrafe',
            'Strakhan',
            'Strakkar',
            'Streggen',
            'Struquil',
            'Stryast',
            'Strylax',
            'Subreen',
            'Suggner',
            'Sujaim',
            'Sulgra',
            'Sulji',
            'Sulmsy',
            'Sulnseir',
            'Sundoth',
            'Sunjeade',
            'Surast',
            'Surigg',
            'Surjan',
            'Surpy',
            'Susstark',
            'Susteelk',
            'Susur',
            'Sutekh',
            'Suukeeg',
            'Suulkas',
            'Suunall',
            'Suvael',
            'Suvrin',
            'Svringal',
            'Swarflig',
            'Swarro',
            'Swendril',
            'Swiez',
            'Syanor',
            'Sybra',
            'Sylfrix',
            'Sylvine',
            'Sylvyn',
            'Symnar',
            'Syphtar',
            'Syrag',
            'Syran',
            'Syssahz',
            'Syzaash',
            'Taarna',
            'Tabrind',
            'Tachel',
            'Tacrine',
            'Tadra',
            'Taedel',
            'Taennyn',
            'Taeral',
            'Taeya',
            'Tagor',
            'Taher',
            'Tahrjun',
            'Taiwine',
            'Talanth',
            'Talar',
            'Taldar',
            'Taleeg',
            'Taled',
            'Talesm',
            'Talgan',
            'Talgraine',
            'Talgyr',
            'Talisk',
            'Talith',
            'Talor',
            'Talthran',
            'Talune',
            'Talven',
            'Talver',
            'Tamar',
            'Tamnuz',
            'Tamone',
            'Tamoorn',
            'Tamriss',
            'Tanchilt',
            'Tandro',
            'Tanha',
            'Tanisk',
            'Tanlin',
            'Tanndo',
            'Tanoor',
            'Tanry',
            "Tan\xfbr",
            'Tanzel',
            'Tanzlor',
            'Taosar',
            'Taoyot',
            'Taran',
            'Tarath',
            'Tarax',
            'Tarcen',
            'Tareth',
            'Tarik',
            'Tarin',
            'Tarisk',
            'Tarith',
            'Tarkand',
            'Tarkrog',
            'Tarlmar',
            'Tarnor',
            'Taron',
            'Taroyn',
            'Tarqu',
            'Tarxas',
            'Tasharg',
            'Tashforn',
            'Tashlex',
            'Tashu',
            'Tashuul',
            'Tasrak',
            'Tasselt',
            'Tasvoor',
            'Taulin',
            'Taval',
            'Tavan',
            'Tavon',
            'Taxlon',
            'Tayerl',
            'Taylin',
            'Tayrsil',
            'Tazen',
            'Tazine',
            'Tchasko',
            'Tealryn',
            'Teawar',
            'Tebish',
            'Tedra',
            'Teekah',
            'Teekug',
            'Teerlin',
            'Tefaz',
            'Tefleer',
            'Tegan',
            'Tegglyn',
            'Tegoth',
            'Teiresh',
            'Teirna',
            'Telaer',
            'Telast',
            'Telcarn',
            'Telett',
            'Telglas',
            'Telgrest',
            'Telkarr',
            'Tellan',
            'Telnar',
            'Telnoom',
            'Telsar',
            'Telva',
            'Telzley',
            'Temorg',
            'Tempros',
            'Tened',
            'Tenelle',
            'Tenjal',
            'Tenlor',
            'Tenna',
            'Tensfar',
            'Tentil',
            'Teode',
            'Terare',
            'Terglaw',
            'Tergon',
            'Terlkin',
            'Terlyn',
            'Ternasse',
            'Terragg',
            'Terris',
            'Tershar',
            'Terslond',
            'Tesin',
            'Teslan',
            'Tevrin',
            'Teyvrilt',
            'Thabou',
            'Thadrum',
            'Thaiduk',
            'Thaki',
            'Thalarn',
            'Thalax',
            'Thaldok',
            'Thamin',
            'Thandart',
            'Thandrov',
            'Thandusc',
            'Thangor',
            'Tharbad',
            'Tharbolt',
            'Tharij',
            'Tharis',
            'Tharjun',
            'Tharkesh',
            'Tharquist',
            'Tharsna',
            'Tharxac',
            'Thaskam',
            'Thaval',
            'Thavarl',
            'Thawlton',
            'Thaxid',
            'Thaxis',
            'Thaxmool',
            'Thaxnar',
            'Thayvudd',
            'Theandra',
            'Thebek',
            'Thelbor',
            'Theleb',
            'Thelin',
            'Thelred',
            'Themnon',
            'Theras',
            'Therbur',
            'Therrak',
            'Therras',
            'Therrat',
            'Thervoh',
            'Thesi',
            'Thesstor',
            'Thibkern',
            'Thimmoz',
            'Thinhla',
            'Thiob',
            'Thios',
            'Thirlain',
            'Thirrild',
            'Thomilt',
            'Thondrac',
            'Thorgeir',
            'Thornix',
            'Thorskal',
            'Thorztar',
            'Thorzyl',
            'Thoskold',
            'Thoye',
            'Thranor',
            'Thraxil',
            'Thremek',
            'Thremix',
            'Thrindish',
            'Thrinyr',
            'Thrykar',
            'Thryxeer',
            'Thugar',
            'Thuldudge',
            'Thulsa',
            'Thurdis',
            'Thuvgalt',
            'Thyra',
            'Thyzlont',
            'Tiaft',
            'Tiak',
            'Tian',
            'Ticham',
            'Tiffrod',
            'Tihan',
            'Tika',
            'Tilal',
            'Tilir',
            'Timaas',
            'Timak',
            'Timdos',
            'Tira',
            'Tiralle',
            'Tirhthri',
            'Tirkan',
            'Tirnor',
            'Tirouv',
            'Tirvil',
            'Tislim',
            'Tisreth',
            'Tisseth',
            'Tithesb',
            'Tivaln',
            'Tlembic',
            'Tlichgo',
            'Tlishat',
            'Tobar',
            'Todyc',
            'Toglank',
            'Tokath',
            'Tokkreft',
            'Tokraz',
            'Tolgarm',
            'Toma',
            'Tonom',
            'Torak',
            'Torang',
            'Torbelt',
            'Torbold',
            'Torden',
            'Toreth',
            'Torghai',
            'Tormir',
            'Torsund',
            'Torthar',
            'Torvin',
            'Torxar',
            'Toscrah',
            'Tourrhok',
            'Tovak',
            'Tovis',
            'Toxathe',
            'Tozjroch',
            'Traalyr',
            'Traken',
            'Tramorn',
            'Trantain',
            'Trantle',
            'Trasven',
            'Travech',
            'Trazom',
            'Tredek',
            'Treeplin',
            'Treffaun',
            'Trefoin',
            'Treizeng',
            'Tremas',
            'Treof',
            'Treslont',
            'Tressak',
            'Trevarq',
            'Trevul',
            'Tricoj',
            'Tridusk',
            'Trilinn',
            'Trisgil',
            'Tristak',
            'Trithax',
            'Triveark',
            'Trizdoth',
            'Troiom',
            'Tromest',
            'Tronvel',
            'Troulden',
            'Trujko',
            'Tsarlit',
            'Tsavan',
            'Tsodjan',
            'Tsojwar',
            'Tsorak',
            'Tuane',
            'Tuchror',
            'Tudlech',
            'Tuezinth',
            'Tugan',
            'Tulkas',
            'Tulsoorm',
            'Tuntix',
            'Turan',
            'Turmasc',
            'Turmis',
            'Turvoost',
            'Turweld',
            'Turzeal',
            'Tuuraj',
            'Tvejasp',
            'Twenja',
            'Twinaile',
            'Twixtib',
            'Tyasaj',
            'Tydwyk',
            'Tylark',
            'Tylith',
            'Tylnen',
            'Tymarl',
            'Tymdrak',
            'Tyrbast',
            'Tyrdon',
            'Tyreen',
            'Tyrgyre',
            'Tyrinx',
            'Tyrlon',
            'Tyrum',
            'Tzichrism',
            'Tzilen',
            'Tziphrin',
            'Udraam',
            'Ufang',
            'Ufoin',
            'Ulak',
            'Ulfade',
            'Ullfrax',
            'Ulli',
            'Ulmyst',
            'Ulos',
            'Ulphar',
            'Ulsplasm',
            'Umbrask',
            'Umbresk',
            'Umchor',
            'Umleer',
            'Ummice',
            'Undreet',
            'Unfegg',
            'Ungax',
            'Unstric',
            'Unstrix',
            'Untveld',
            'Unza',
            'Uqbar',
            'Urdaa',
            'Urdain',
            'Urdal',
            'Urdryce',
            'Urlyn',
            'Urrind',
            'Urthryn',
            'Urtond',
            'Urwoon',
            'Urzvir',
            'Ushnee',
            'Usquik',
            'Ussart',
            'Ussfaal',
            'Ussit',
            'Usstrilt',
            'Ustar',
            'Ustiln',
            'Ustlin',
            'Ustor',
            'Ustorne',
            'Ustrelm',
            'Usxald',
            'Uthmal',
            'Uthnor',
            'Uvorne',
            'Uzfron',
            'Uztum',
            'Vacla',
            'Vadein',
            'Vadrelj',
            'Vadri',
            'Vadru',
            'Vaeddyn',
            'Vaelythe',
            "Va\xebrn",
            'Vagar',
            'Vaigthlu',
            'Vaitarr',
            'Valan',
            'Valaz',
            'Valbard',
            'Valek',
            'Valen',
            'Valeth',
            'Valgaard',
            'Valgar',
            'Valgarv',
            'Valka',
            'Valkarth',
            'Valken',
            'Valkesh',
            'Valkis',
            'Valkyr',
            'Valmisce',
            'Valreque',
            'Valtarb',
            'Valthoth',
            'Valyn',
            'Vamert',
            'Vamfade',
            'Vanache',
            'Vanek',
            'Vanger',
            'Vannak',
            'Vannyn',
            'Vanra',
            'Vantsled',
            'Vanyar',
            'Vaona',
            'Varat',
            'Varda',
            'Vareth',
            'Varga',
            'Varka',
            'Varlik',
            'Varmon',
            'Varmyr',
            'Varna',
            'Varnac',
            'Varnar',
            'Varnax',
            'Varnaz',
            'Varos',
            'Varrow',
            'Varsta',
            'Vartoor',
            'Vasaav',
            'Vascais',
            'Vasrind',
            'Vathan',
            'Vathar',
            'Vathek',
            'Vaudric',
            'Vayas',
            'Vaydir',
            'Vayi',
            'Vazar',
            'Vazdo',
            "Ve\xe4xe",
            'Veena',
            'Vegreth',
            'Vekil',
            'Velaunce',
            'Veldan',
            'Veldin',
            'Velex',
            'Velkind',
            'Velnard',
            'Velsant',
            'Velsard',
            'Velsin',
            'Vembrex',
            'Venast',
            'Vendik',
            'Vengkuld',
            'Venklar',
            'Vennec',
            'Vennsor',
            'Venscoth',
            'Ventorl',
            'Venzra',
            'Veor',
            'Verek',
            'Verisse',
            'Verla',
            'Verlis',
            'Vernar',
            'Vernat',
            'Vernil',
            'Veror',
            'Verren',
            'Vertence',
            'Vervitz',
            'Verwantz',
            'Verxain',
            'Verzod',
            'Veskin',
            'Veswinch',
            'Veyen',
            'Vherla',
            'Viaxx',
            'Vibsoom',
            'Vibur',
            'Vilgrax',
            'Vilraj',
            'Vilsa',
            'Vilthod',
            'Viltor',
            'Viltorc',
            'Vingverd',
            'Virainth',
            'Viran',
            'Virdla',
            'Viscanth',
            'Visharn',
            'Viskrek',
            'Vissir',
            'Vistar',
            'Vistarl',
            'Vithmard',
            'Viux',
            'Vixa',
            'Vixai',
            'Vixlim',
            'Vlastov',
            'Vlitchek',
            'Vluisc',
            'Vlustra',
            'Volcilde',
            'Voldor',
            'Volnir',
            'Vomquind',
            'Vonir',
            'Voozale',
            'Vordnaz',
            'Vorgan',
            'Vorplen',
            'Vorrmor',
            'Vorshak',
            'Vortice',
            'Vosklune',
            'Votorn',
            'Votrax',
            'Voxarl',
            'Vozkoog',
            'Vratund',
            'Vreeleth',
            'Vregom',
            'Vrithon',
            'Vrumtuun',
            'Vryxnir',
            'Vuespra',
            'Vuestri',
            'Vulpix',
            'Vuranc',
            'Vurick',
            'Vurog',
            'Vuron',
            'Vuubul',
            'Vynda',
            'Vyrnael',
            'Vywyn',
            'Vzoris',
            'Wadziq',
            'Waeytef',
            'Wairbren',
            'Walgwim',
            'Wallibt',
            'Walscrin',
            'Wanelj',
            'Wanjok',
            'Wannach',
            'Wanruum',
            'Wanthim',
            'Warbosk',
            'Warell',
            'Warisk',
            'Warthan',
            'Waryn',
            'Wastur',
            'Waylra',
            'Waznak',
            'Weardlon',
            'Wedjeeg',
            'Wedra',
            'Weftig',
            'Weftorb',
            'Weitvan',
            'Welfrede',
            'Welmek',
            'Welndar',
            'Wemsin',
            'Wendath',
            'Weppel',
            'Werclam',
            'Werin',
            'Weshap',
            'Weskin',
            'Westra',
            'Wevkinz',
            'Wextri',
            'Whilfig',
            'Whilmor',
            'Wicrore',
            'Wileert',
            'Wilnim',
            'Wilven',
            'Wilzech',
            'Wirreth',
            'Wirzanth',
            'Wistril',
            'Witrix',
            'Witrost',
            'Wizlow',
            'Wolcharn',
            'Wolkoon',
            'Wolnihr',
            'Worlit',
            'Wraxil',
            'Wrybeck',
            'Wryplax',
            'Wryxerg',
            'Wubneft',
            'Wulfrit',
            'Wurflense',
            'Wusheig',
            'Wuunal',
            'Wuxorn',
            'Wychnor',
            'Wylvin',
            'Wyndbrel',
            'Wyndra',
            'Wyrgon',
            'Wyrsis',
            'Wysholt',
            'Wyvrax',
            'Wyxef',
            'Xadair',
            'Xaedra',
            'Xaelinth',
            'Xaharl',
            'Xaidis',
            'Xaitchek',
            'Xaldreth',
            'Xalkhas',
            'Xalla',
            'Xallath',
            'Xameld',
            'Xanax',
            'Xanbarg',
            'Xandar',
            'Xandrix',
            'Xanille',
            'Xanna',
            'Xanos',
            'Xanrei',
            'Xanthon',
            'Xarafe',
            'Xarakh',
            'Xarek',
            'Xasim',
            'Xaudrin',
            'Xavest',
            'Xavin',
            'Xawnis',
            'Xaxul',
            'Xayide',
            'Xeebract',
            'Xeerha',
            'Xejem',
            'Xela',
            'Xeldon',
            'Xellosp',
            'Xenerge',
            'Xenir',
            'Xephar',
            'Xerra',
            'Xerxisp',
            'Xerys',
            'Xexal',
            'Xhagrim',
            'Xhaibar',
            'Xhomdroll',
            'Xhorald',
            'Xigil',
            'Xion',
            'Xiplin',
            'Xiri',
            'Xirrip',
            'Xloris',
            'Xoncarg',
            'Xopon',
            'Xoris',
            'Xormeer',
            'Xothun',
            'Xovro',
            'Xudeet',
            'Xulan',
            'Xundrahl',
            'Xustral',
            "Xy\xe1s",
            "Xy\xe1st",
            'Xybeuth',
            'Xycort',
            'Xydorn',
            'Xydra',
            'Xygbenth',
            'Xyhaek',
            'Xykrog',
            'Xylance',
            'Xylarz',
            'Xylvorm',
            'Xymoyl',
            'Xytrin',
            'Yaalder',
            'Yaathab',
            'Yadarl',
            'Yaddith',
            'Yadel',
            'Yadreth',
            'Yadurk',
            'Yaglaid',
            'Yagmoon',
            'Yaklar',
            'Yaklin',
            'Yako',
            'Yakthoob',
            'Yammoth',
            'Yamphut',
            'Yandorn',
            "Ya\xf6th",
            'Yarat',
            'Yarel',
            'Yari',
            'Yarin',
            'Yarnis',
            'Yarram',
            'Yastoz',
            'Yaten',
            'Yatheg',
            'Yavarre',
            'Yavood',
            'Yavroun',
            'Yazlar',
            'Ycore',
            'Yeafosk',
            'Yeifolk',
            'Yeldoj',
            'Yeldrai',
            'Yeoft',
            'Yeoun',
            'Yerdeen',
            'Yergal',
            'Yerkel',
            'Yernoold',
            'Yethler',
            'Yewrapt',
            'Yexil',
            'Yezrik',
            'Yhemnis',
            'Yhemog',
            'Yhoudeh',
            'Yiash',
            'Yildiz',
            'Yilkeyr',
            'Yimzuuem',
            'Yinaun',
            'Yiod',
            'Yirod',
            'Yivthi',
            'Ymar',
            'Ymarl',
            'Yodkin',
            'Yojra',
            'Yombris',
            'Yoorzamph',
            'Yoppulse',
            'Yorim',
            'Yorlask',
            'Yorrak',
            'Yoskan',
            'Yosneth',
            'Yothir',
            'Yottoa',
            'Yrdirr',
            'Yrgash',
            'Yrgil',
            'Yrinth',
            'Yrlmar',
            'Yrvoor',
            'Yuklat',
            'Yuleng',
            'Yurisp',
            'Yuvib',
            'Yuzan',
            'Yween',
            'Zaalit',
            'Zabal',
            'Zabil',
            'Zadko',
            'Zadom',
            'Zadool',
            'Zaelken',
            'Zaery',
            'Zaffar',
            'Zagrosk',
            'Zahur',
            'Zaihra',
            'Zalethe',
            'Zalmic',
            'Zalthen',
            'Zamar',
            'Zamewl',
            'Zamind',
            'Zamog',
            'Zamray',
            'Zanak',
            'Zaneer',
            'Zangor',
            'Zanqua',
            'Zantain',
            'Zanthu',
            'Zantir',
            'Zantyen',
            'Zanurb',
            'Zarak',
            'Zaranthe',
            'Zardal',
            'Zardence',
            'Zardirm',
            'Zardox',
            'Zargoi',
            'Zaric',
            'Zarlon',
            'Zarmarl',
            'Zarouk',
            'Zarphaut',
            'Zarquar',
            'Zarquemf',
            'Zarros',
            'Zarthule',
            'Zastor',
            'Zatarl',
            'Zatheen',
            'Zathras',
            'Zathu',
            'Zatoum',
            'Zausric',
            'Zavach',
            'Zavak',
            'Zavel',
            'Zaviv',
            'Zaxweer',
            'Zayarn',
            'Zaydrim',
            'Zebor',
            'Zebulse',
            'Zedresk',
            'Zefteel',
            'Zehain',
            'Zehirn',
            'Zekal',
            'Zeldaph',
            'Zelgad',
            'Zelgen',
            'Zelisp',
            'Zelked',
            'Zelmarth',
            'Zelminx',
            'Zelvant',
            'Zembis',
            'Zendarg',
            'Zentos',
            'Zeraa',
            'Zerai',
            'Zerakl',
            'Zermish',
            'Zerric',
            'Zervid',
            'Zesdick',
            'Zessain',
            'Zethrel',
            'Zhaizald',
            'Zhakoor',
            'Zhalore',
            'Zhantaine',
            'Zhapris',
            'Zharmele',
            'Zharvek',
            'Zhassa',
            'Zhawend',
            'Zhaya',
            'Zheral',
            'Zhirek',
            'Zhirem',
            'Zhiroq',
            'Zhirquis',
            'Zhogri',
            'Zhomrach',
            'Zhoreb',
            'Zhrana',
            'Zigmoth',
            'Zikuyth',
            'Zilar',
            'Zilmork',
            'Zincir',
            'Zindor',
            'Ziorn',
            'Zirin',
            'Zishuun',
            'Zislun',
            'Zisurgh',
            "Zlant\xe9",
            'Zlatos',
            'Zofram',
            'Zoides',
            'Zojan',
            'Zohldrom',
            'Zolfran',
            'Zoltaft',
            'Zomra',
            'Zondar',
            'Zoorkon',
            'Zopine',
            'Zorac',
            'Zorith',
            'Zorlan',
            'Zorthal',
            'Zosarde',
            'Zrufend',
            'Zugdin',
            'Zugoth',
            'Zuril',
            'Zusdhrun',
            'Zuukan',
            'Zvegnaz',
            'Zyjin',
            'Zyla',
            'Zylaax',
            'Zylyn',
            'Zyrel',
            'Zyrelx',
            'Zytan',
            'Zyxim'
        ],
        three: [
            'Aathoklaa',
            'Abalore',
            'Abeli',
            'Abreyxorn',
            'Abrisen',
            'Acaena',
            'Acamar',
            'Acarnod',
            'Ackia',
            'Acozer',
            'Acravel',
            'Actinor',
            'Adalon',
            'Adalrik',
            'Adanac',
            'Adasho',
            'Adelin',
            'Adelir',
            'Adembal',
            'Aderak',
            'Aderel',
            'Aderyn',
            'Adhara',
            'Adhirman',
            'Adia',
            'Adian',
            'Adiol',
            'Aditu',
            'Adlaron',
            'Admarlen',
            'Adnirrin',
            'Adnoren',
            'Adracea',
            'Adraeran',
            'Adraewyth',
            'Adrasta',
            'Adrena',
            'Adriphaas',
            'Aelarim',
            'Aerissa',
            'Aeruin',
            'Aetharyn',
            'Aexien',
            'Afaellan',
            'Agador',
            'Agaki',
            'Agari',
            'Agella',
            'Agerquon',
            'Agetan',
            'Agexa',
            'Aginor',
            'Agior',
            'Agnaska',
            'Agraia',
            'Agrasline',
            'Agrasol',
            'Agrias',
            'Agristair',
            'Ahina',
            'Ahorra',
            'Aidaron',
            'Aililry',
            'Ainnatic',
            'Aioula',
            'Aircristir',
            'Aistomar',
            'Ajasonde',
            'Akajur',
            'Akashic',
            'Akasta',
            'Akenchi',
            'Akhrida',
            'Akiina',
            'Akirga',
            'Akirku',
            'Akritas',
            'Akura',
            'Akvaron',
            'Alamak',
            'Alanik',
            'Alanyx',
            'Alardan',
            'Alaris',
            'Alarynd',
            'Alathen',
            'Alatvair',
            'Alaxa',
            'Alaztyr',
            'Albara',
            'Albaral',
            'Alberist',
            'Alberon',
            'Alceon',
            'Alceor',
            'Alchica',
            'Aldachur',
            'Aldaka',
            'Aldamir',
            'Aldirim',
            'Aldrella',
            'Aleasna',
            'Aleaxa',
            'Aleena',
            'Aleidar',
            'Alembis',
            'Alera',
            'Aleva',
            'Alfanar',
            'Alhana',
            'Alidar',
            'Aliet',
            'Alifyan',
            'Alinaeus',
            'Alindra',
            'Alixa',
            'Aljarik',
            'Alkaios',
            'Allindren',
            'Allomir',
            'Alloran',
            'Almarisc',
            'Almeron',
            'Almiel',
            'Alnavor',
            'Alshagrel',
            'Altavan',
            'Altorlan',
            'Altria',
            'Alucard',
            'Alzamar',
            'Alzarin',
            'Amadis',
            'Amadix',
            'Amafer',
            'Amaja',
            'Amakelb',
            'Amanster',
            'Amaremne',
            'Amarette',
            'Amatin',
            'Amazya',
            'Ambrezul',
            'Amelis',
            'Amerill',
            'Amether',
            'Amethi',
            'Amharad',
            'Amilin',
            'Aminak',
            'Amintor',
            'Amlieth',
            'Amolithe',
            'Amorin',
            'Ampenden',
            'Amramyr',
            'Anandra',
            'Anara',
            'Anartig',
            'Anashea',
            'Anatsath',
            'Ancelyn',
            'Ancifer',
            'Andaraan',
            'Andistair',
            'Andolan',
            'Andrasha',
            'Andula',
            'Aneelen',
            'Anfara',
            'Anferas',
            'Anfesef',
            'Angalli',
            'Angemon',
            'Anghyrud',
            'Anhalus',
            'Anici',
            'Anina',
            'Ankrista',
            'Annoxin',
            'Anraculd',
            'Anroana',
            'Ansivlan',
            'Ansuki',
            'Antalyaar',
            'Antarlest',
            'Anterra',
            'Antesri',
            'Anthlamar',
            'Antraneyk',
            'Anzera',
            'Apelnin',
            'Aphithea',
            'Apporrosh',
            'Aquiel',
            'Aquorren',
            'Aradek',
            'Aragaj',
            'Araglas',
            'Arajist',
            'Arakbaal',
            'Arakhreen',
            'Arakin',
            'Araldar',
            'Aralik',
            'Aramil',
            'Aranat',
            'Aranis',
            'Arathorb',
            'Araxis',
            'Arbadrul',
            'Arbalac',
            'Arbalon',
            'Arbitan',
            'Arboran',
            'Arcastor',
            'Archolach',
            'Ardalanx',
            'Ardanos',
            'Ardatha',
            'Ardaxil',
            'Ardelin',
            'Ardilex',
            'Ardiseng',
            'Ardissa',
            'Aregel',
            'Arenith',
            'Arestel',
            'Arfandas',
            'Argethlam',
            'Arghesos',
            'Argion',
            "Argo\xebl",
            'Argolin',
            'Arhanen',
            'Ariann',
            'Arianth',
            'Aribeth',
            'Arien',
            'Arion',
            'Arioth',
            'Ariseph',
            'Arismacht',
            'Aristea',
            'Arivid',
            'Arkadit',
            'Arkaris',
            'Arkavyn',
            'Arkissar',
            'Arkurel',
            'Arlana',
            'Arleano',
            'Arleost',
            'Arlomma',
            'Arokair',
            'Arolant',
            'Arozan',
            'Arpiax',
            'Arrashad',
            'Arrelask',
            'Arrenol',
            'Arriam',
            'Arridor',
            'Arrivid',
            'Arrosas',
            'Arrossai',
            'Arshashi',
            'Arshavir',
            'Artithea',
            'Artlexu',
            'Arura',
            'Arvanor',
            'Arvirask',
            'Aryion',
            'Arzeela',
            'Ascarleth',
            'Ascaveen',
            'Ascomeld',
            'Asgarath',
            'Asherild',
            'Ashikri',
            'Ashilja',
            'Ashnisci',
            'Ashrodu',
            'Asilun',
            'Asius',
            'Aslior',
            'Asmacul',
            'Asmictir',
            'Aspaleed',
            'Asparind',
            'Asphodal',
            'Aspolyme',
            'Asquilla',
            'Astaedi',
            'Astalon',
            "Aste\xe4",
            'Astinus',
            "Astra\xeba",
            'Asurzel',
            'Atalis',
            'Atazra',
            'Athana',
            'Atheran',
            'Athermoj',
            'Athina',
            'Athnolan',
            'Athrasomb',
            'Athrilas',
            'Atlavan',
            'Atorin',
            'Atralan',
            'Atraxon',
            'Atrujal',
            'Attanir',
            'Atticog',
            'Aturin',
            'Atyoto',
            'Aurever',
            'Aurian',
            'Auridra',
            'Aurina',
            'Aurion',
            'Auxebaz',
            'Avalzaunt',
            'Avandir',
            'Avarath',
            'Avasceen',
            'Avenaar',
            'Aveole',
            'Averdal',
            'Avereem',
            'Avernide',
            "Av\xe8ss\xe8d",
            'Avesur',
            'Avori',
            'Avriax',
            'Avronil',
            'Awennes',
            'Axanar',
            'Axarun',
            'Aximil',
            'Ayaren',
            'Ayesra',
            'Azaka',
            'Azakour',
            'Azanakh',
            'Azanor',
            'Azarmax',
            'Azatta',
            'Azella',
            'Azergal',
            'Azfotha',
            'Azilos',
            'Azmarbi',
            'Azmeren',
            'Azolem',
            'Azraxel',
            'Azriaz',
            'Azrienne',
            'Aztira',
            'Azuva',
            'Azuzu',
            'Baeglyndven',
            'Bahnshiath',
            'Bakailis',
            'Bakiar',
            'Balandix',
            'Balanjik',
            'Balathol',
            'Balazar',
            'Balderon',
            'Baledor',
            'Baloward',
            'Baltarreg',
            'Bandibras',
            'Banira',
            'Banjasah',
            'Banjicoy',
            'Banrodi',
            'Bantirgen',
            'Baraca',
            'Barahir',
            'Baramei',
            'Barbardon',
            'Barixid',
            'Barjazan',
            'Barolio',
            'Barsimmern',
            'Bartosca',
            'Barzolo',
            'Basfui',
            'Basidrix',
            'Baslayan',
            'Basliard',
            'Batiax',
            'Baudefloy',
            'Bayazin',
            'Bayidon',
            'Bazakel',
            'Baziran',
            "Be\xe4brae",
            'Becheton',
            'Bedivere',
            'Behamkai',
            'Belaraz',
            'Belarba',
            'Belathgert',
            'Beldara',
            'Beldaran',
            'Belegern',
            'Belensarl',
            'Belgarath',
            'Belida',
            'Belimu',
            'Belinzith',
            'Belistra',
            'Belithin',
            'Bellarix',
            'Bellinus',
            'Belloram',
            'Belmalar',
            'Belmatar',
            'Benalath',
            'Beorilf',
            'Beoshar',
            'Berazan',
            'Berefex',
            'Berethan',
            'Beriam',
            'Berlemdo',
            'Bermulan',
            'Berterin',
            'Besagren',
            'Bestagar',
            'Bethalus',
            'Beztevil',
            'Bilamarj',
            'Birictzin',
            'Birimi',
            'Birrtezir',
            'Bisuneh',
            'Bithritrilb',
            'Blascarro',
            "Bo\xe4lod",
            "Bo\xe4zye",
            'Bolangi',
            'Bolgodar',
            'Boradrend',
            'Borvazan',
            'Bordvedo',
            'Boridorn',
            'Borivig',
            'Boroqual',
            'Borosov',
            'Boruja',
            'Breldiar',
            'Breyugar',
            'Brindelvix',
            'Brinzindis',
            'Brirelin',
            'Brofothin',
            'Bruyefol',
            'Bundetlan',
            'Burangald',
            'Byjagan',
            'Caadausid',
            'Cadrillan',
            'Cadxiel',
            'Caglaree',
            'Caladon',
            'Caladra',
            'Calandol',
            'Calandra',
            'Calara',
            'Caldiza',
            'Calial',
            'Calian',
            'Calibarz',
            'Caliburr',
            'Calimen',
            'Calinor',
            'Calinthor',
            'Caliroon',
            'Calrohir',
            'Calvari',
            'Calyreg',
            'Camorba',
            'Camrenard',
            'Candelisce',
            'Candralta',
            'Canteril',
            'Capsia',
            'Caradin',
            'Caraman',
            'Carano',
            'Carastac',
            'Cardannor',
            'Cardriman',
            'Carejjar',
            'Carenac',
            'Caribros',
            'Carvirras',
            'Casliet',
            'Cassira',
            'Castivin',
            'Cathloda',
            'Cauluden',
            'Cavrello',
            'Cazago',
            'Cazrogatz',
            'Cedethea',
            'Cedruin',
            'Celasli',
            'Celedrax',
            'Celeldrir',
            'Celenorb',
            'Celephais',
            'Celimbsel',
            'Celissar',
            'Celmiac',
            'Celria',
            'Cemendur',
            'Ceomyr',
            'Cerastes',
            'Cerdotur',
            'Cereden',
            'Ceremeb',
            'Cerindar',
            'Cernaia',
            'Cerrivald',
            'Cerrlemere',
            'Cervetar',
            'Chakjalom',
            'Chalberyn',
            'Chandalla',
            'Charizar',
            'Charovis',
            'Chasergha',
            'Chatony',
            'Chavrenard',
            'Chayuleth',
            'Chedynas',
            'Chemedis',
            'Cherinra',
            'Cheshinif',
            'Chesifith',
            'Chexotah',
            'Chiranin',
            'Chirophanx',
            'Chirystrad',
            'Chissaera',
            'Choriaal',
            'Chrystara',
            'Cialrak',
            'Ciarna',
            'Ciliath',
            'Cillegra',
            'Cimpelis',
            'Cirial',
            'Cirilar',
            'Cisidor',
            'Claraven',
            'Clarian',
            'Clymerice',
            'Colperat',
            'Colverslyne',
            'Conridas',
            'Coramur',
            'Corcoran',
            'Cordago',
            'Corisur',
            'Cormannon',
            'Coromis',
            'Corraemer',
            'Corstanis',
            'Coyasal',
            'Cramorul',
            'Crayeera',
            'Credori',
            'Cresbaral',
            'Crodelan',
            'Cromora',
            'Crondowys',
            'Cruirmox',
            'Crysindlyn',
            'Cthasia',
            'Cubrucol',
            'Curtifer',
            'Cveralisk',
            'Cyarium',
            'Cynalis',
            'Cynara',
            'Cyrilla',
            'Cyrissil',
            'Daakrasef',
            'Dabnavar',
            'Dacarin',
            'Dagaldsain',
            'Dagorla',
            'Daiavend',
            'Dakkiah',
            'Dakokan',
            'Dalarthra',
            'Dalimir',
            'Dallandra',
            'Dallibren',
            'Dalmaxen',
            'Damarel',
            'Damia',
            'Damisen',
            'Dammarlet',
            'Damria',
            'Danatren',
            'Danbrelaj',
            'Daqualor',
            'Daragard',
            'Darandril',
            'Darani',
            'Darimpelg',
            'Darioj',
            'Darisimp',
            'Darnien',
            'Daruda',
            'Darusor',
            'Darvenel',
            'Darvien',
            'Dasanay',
            'Dasyani',
            'Dathanja',
            "Dauro\xe4t",
            'Daximyr',
            'Dazaroth',
            'Deglavar',
            'Dekreon',
            'Delalea',
            'Delandim',
            'Delaquoth',
            'Delcardes',
            'Delgadjas',
            'Delgari',
            'Deliard',
            'Delitra',
            'Delmonda',
            'Delonos',
            'Delsinar',
            "Demels\xe0vre",
            'Deminar',
            'Demithea',
            'Dendera',
            'Denivra',
            'Deowrix',
            'Deralten',
            'Derian',
            'Derisurm',
            'Derokain',
            'Descelet',
            'Desnema',
            'Desthia',
            'Destrino',
            'Devabril',
            'Devaia',
            'Devaren',
            'Deviscind',
            'Devyna',
            'Dezelglim',
            'Dharijor',
            'Diagur',
            'Diamel',
            'Diastul',
            'Diazrax',
            'Diniwirn',
            'Dional',
            'Diony',
            'Dismarntir',
            'Distana',
            'Distiva',
            'Diurmad',
            'Divior',
            "Do\xe4lva",
            'Dokessin',
            'Dolitan',
            'Dolskior',
            'Domagren',
            'Domovoy',
            'Doniale',
            'Donivesh',
            'Dorana',
            'Doravin',
            'Doraxa',
            'Dorether',
            'Dorgrian',
            'Dorianth',
            'Dorosard',
            'Drafarna',
            'Draglios',
            'Dralgamor',
            'Drelbaran',
            'Dreleon',
            'Dreower',
            'Drusmirak',
            'Druycalid',
            'Durathor',
            'Duruis',
            'Dusoto',
            'Duvalin',
            'Dvereya',
            'Dygardo',
            'Eberyn',
            'Ecarnis',
            'Echengar',
            'Echredrisk',
            'Edalcor',
            'Edamar',
            'Edaris',
            'Edeera',
            'Edeiric',
            'Edelan',
            'Edromon',
            'Eemonil',
            'Eermiaw',
            'Efelin',
            'Efiath',
            'Egarun',
            'Egeanin',
            'Eglashor',
            'Eglathorm',
            'Ehlmargis',
            'Eilinud',
            'Einnara',
            'Ekisha',
            'Elaara',
            'Eladain',
            'Elanja',
            'Elanlir',
            'Elantir',
            'Elardoand',
            'Elayess',
            'Elbasant',
            'Elbrian',
            'Elcaros',
            'Eldikohl',
            'Eldimyr',
            'Eldivren',
            'Eleaseth',
            'Eleniin',
            'Elerasc',
            'Eleril',
            'Elesfar',
            'Elexna',
            'Elhanter',
            'Elharta',
            'Elhiri',
            'Eliaazh',
            'Elindel',
            'Elion',
            'Elispesh',
            'Elissim',
            'Elistan',
            'Eljendril',
            'Ellamoin',
            'Ellanath',
            'Ellendar',
            'Ellidyr',
            'Elmeric',
            'Elmradra',
            'Elnavor',
            "Elno\xeb",
            'Elorix',
            'Elriseth',
            'Elrodin',
            'Elrowan',
            'Elsandar',
            'Elverus',
            'Elzirtha',
            'Emeresc',
            'Emistar',
            'Emparyn',
            "Emra\xebl",
            'Enchasol',
            'Endelaer',
            'Endeltrad',
            'Endoyarl',
            'Endremen',
            'Engkalat',
            'Enifrax',
            'Enliack',
            'Ennorath',
            "Eno\xebre",
            'Ensocand',
            'Enzoray',
            'Eolair',
            'Eolglyu',
            'Eomer',
            'Eosin',
            'Eowine',
            'Eralith',
            'Erbarax',
            'Erdegron',
            "Ere\xe4d",
            'Ereboen',
            'Eregin',
            'Ereia',
            'Ereidan',
            'Ereinid',
            'Eresbor',
            'Ergamarl',
            'Erian',
            'Erihim',
            'Erijin',
            'Erilind',
            'Erilyth',
            'Erimewn',
            'Eriptil',
            'Erizael',
            'Erjesko',
            'Erkollo',
            'Erlata',
            'Erliskan',
            'Ermentej',
            'Ermiod',
            'Ermizard',
            'Erobor',
            'Erraxam',
            'Errixi',
            'Ersazern',
            'Erudin',
            'Eruna',
            'Escaloth',
            'Eshorden',
            'Eskedar',
            'Eslenix',
            'Esmeril',
            'Essamor',
            'Esselin',
            'Estelorn',
            'Estulman',
            'Esyorna',
            'Ethayan',
            'Ethilrist',
            'Ettellarn',
            'Euralen',
            'Eurayo',
            'Evarul',
            'Evedben',
            'Eveltur',
            'Evenor',
            'Everan',
            'Everard',
            'Evidor',
            'Evrilet',
            'Ewugan',
            'Exior',
            'Exorric',
            'Ezirith',
            'Ezpirasp',
            'Ezrabar',
            'Fabliain',
            'Faerlasdar',
            'Fafmalan',
            'Fahorjom',
            'Falamund',
            'Falazarm',
            'Faldian',
            'Faledra',
            'Falias',
            'Faliorn',
            'Fallonar',
            'Falmalin',
            'Famaril',
            'Famiryah',
            'Farammil',
            'Faranar',
            'Farathar',
            'Farazwen',
            'Farendal',
            'Farezar',
            'Farias',
            'Farinda',
            'Farovlem',
            'Farreflan',
            'Farrian',
            'Fassander',
            'Fassiral',
            'Fathanor',
            'Fathimlas',
            'Favular',
            'Fayenned',
            'Felacroy',
            'Felectos',
            'Felendos',
            'Felentir',
            'Felinstrod',
            'Felladin',
            'Fellathor',
            'Fellazoor',
            'Felmarus',
            'Felvia',
            'Fenhalut',
            'Fenkkara',
            'Feollan',
            'Feraanty',
            'Ferazhin',
            'Ferdithir',
            'Ferena',
            'Ferescha',
            'Feridmir',
            'Feridoth',
            'Ferilken',
            'Ferkiel',
            'Fermandra',
            'Fermazeth',
            'Ferozak',
            'Ferrandry',
            'Ferrinox',
            'Fertimqui',
            'Fesanor',
            'Fesmaran',
            'Fethijorn',
            'Fethorval',
            'Fezmirath',
            'Fiaminch',
            'Fiantzin',
            'Fiathna',
            'Fiensar',
            'Fierex',
            'Filigal',
            'Filrena',
            'Finaefin',
            'Findegil',
            'Finmanal',
            'Finrhabar',
            'Fiollix',
            'Fionlex',
            'Fiorag',
            'Fiori',
            'Fiosthan',
            'Firandaal',
            'Firimar',
            'Firmrius',
            'Fivrenesse',
            "Flaco\xeb",
            'Fluimorl',
            "Fo\xe4shroud",
            'Fomorisk',
            'Fonesco',
            'Fontaera',
            'Forambad',
            'Forizuld',
            "Foront\xe9",
            'Forrandir',
            'Foxilkin',
            'Fozdollo',
            'Fraajior',
            'Fragadin',
            "Fre\xe4laf",
            'Frinilex',
            'Frosserthil',
            'Frugansey',
            'Fuareece',
            'Fulinas',
            'Fulmerack',
            'Fumorak',
            'Furalor',
            'Fusial',
            'Gadino',
            'Gaffindur',
            'Gaherist',
            'Gaianac',
            'Galassad',
            'Galedrej',
            'Galeeya',
            'Galeia',
            'Galendil',
            'Galhambraj',
            'Galhandvis',
            'Galiel',
            'Galjiu',
            'Gallaia',
            'Galorin',
            'Galrion',
            'Galthien',
            'Galtyran',
            'Galvaris',
            'Gambrefax',
            'Gamorrand',
            'Ganatus',
            'Ganelon',
            'Ganoraz',
            'Ganscion',
            'Ganzadahl',
            'Garagrim',
            'Garalden',
            'Garathgen',
            'Garduil',
            'Gardulkar',
            'Garemo',
            'Garflion',
            'Garlenon',
            'Garriech',
            'Garziot',
            'Gastenmil',
            'Gatlatas',
            'Gatzeiros',
            'Gavendra',
            'Gavilen',
            'Gefandrall',
            'Gelsgiath',
            'Genteras',
            'Gerergol',
            'Gerexi',
            'Geskrivus',
            'Gevanarth',
            'Ghiella',
            'Gidyrrha',
            'Gildanar',
            'Gilennan',
            'Gilfangron',
            'Giljrian',
            'Giltsanos',
            'Gimika',
            'Gipideur',
            'Girazi',
            'Giridal',
            'Giridyne',
            'Giriel',
            'Girkirath',
            'Gisorath',
            'Gisriral',
            'Gisselek',
            'Givirtrik',
            'Gizarak',
            'Gizbion',
            'Gizherae',
            'Gledrion',
            'Gleocyn',
            'Gleyander',
            'Gliranna',
            'Glirfingril',
            'Goibhniu',
            'Golexar',
            "Golo\xeb",
            'Gonscevin',
            'Gontomir',
            'Goranna',
            'Gorazky',
            'Gordalis',
            'Gorias',
            'Gorion',
            'Goronwy',
            'Goronyr',
            'Gorova',
            'Gorthokon',
            'Graginar',
            'Graliath',
            'Gredanost',
            'Griarnix',
            'Griotam',
            'Grissejan',
            'Grolliax',
            'Gualat',
            'Guilmarn',
            'Gulifrith',
            'Gurnarok',
            'Gwyrion',
            'Gydrian',
            'Gymnivus',
            'Gyrelyest',
            'Hacoulede',
            'Hadowrak',
            'Hafranel',
            'Haielva',
            'Haijannod',
            'Hajandin',
            'Hakatri',
            'Halibarn',
            'Halios',
            'Haliwyn',
            'Halveron',
            'Halvia',
            'Hamadar',
            'Hamancen',
            'Hamavand',
            'Hanamere',
            'Haneran',
            'Hanorayn',
            'Hanrassu',
            'Hantaira',
            'Haplana',
            'Haprissa',
            'Harana',
            'Harandash',
            'Harezek',
            'Hargranar',
            'Harigran',
            'Harnahad',
            'Harobel',
            'Harondar',
            'Harromarl',
            'Harsinna',
            'Hartien',
            'Hartazan',
            'Hasalgar',
            'Hasprion',
            'Hathlizu',
            'Hathvoril',
            'Hautilim',
            'Hautulin',
            'Hauxpomel',
            'Haxmaraun',
            'Haxmaspar',
            'Haxmered',
            'Hazalet',
            'Hazazel',
            'Hazharat',
            'Haziran',
            'Hedrapake',
            'Heereos',
            'Hekeren',
            'Helbathil',
            'Helobaine',
            'Helphegad',
            'Helziatz',
            'Hemgarel',
            'Henalur',
            'Herecharn',
            'Heriganj',
            'Heriol',
            'Hessevet',
            'Hethica',
            'Heuleanar',
            'Hexavren',
            'Hexelin',
            'Hiabaid',
            'Hiassveil',
            'Hifridil',
            'Higlaia',
            'Hilio',
            'Himurlem',
            'Hintyrit',
            'Hirodrix',
            'Hizirin',
            "Hokry\xe4hn",
            'Holmarun',
            'Horbajir',
            'Horlabo',
            'Hralfecca',
            'Hrioncet',
            'Hulterna',
            "Hurja\xebl",
            'Huvatal',
            'Hyaliptar',
            'Hyarantar',
            'Hydrestin',
            'Hylamet',
            'Hylarel',
            'Hylissa',
            'Hyphorond',
            'Hyraskel',
            'Hyrkhalla',
            'Hyzaspes',
            'Iahaun',
            'Iarlen',
            'Iasho',
            'Ibekon',
            'Ibgali',
            'Ibrana',
            'Ibriax',
            'Ibriole',
            'Icanaar',
            'Icavra',
            'Icera',
            'Ichandrik',
            'Ichindar',
            'Idarlan',
            'Iffalon',
            'Igjaru',
            'Ijevthla',
            'Ikarin',
            'Ikirkar',
            'Ilabrem',
            'Ilairam',
            'Ilarnin',
            'Ildezir',
            'Ilenfal',
            'Ilfangir',
            'Ilfinir',
            'Ilgaeldar',
            'Ilikir',
            'Ilimvair',
            "Ilkern\xe9",
            'Ilkyarzim',
            'Illana',
            'Illara',
            'Illiarn',
            'Illsuin',
            'Illuanc',
            'Illurdan',
            'Ilkaroque',
            'Ilnitelg',
            'Ilrehjan',
            'Ilumaar',
            'Ilvelisk',
            'Imaia',
            'Imajin',
            'Imashla',
            'Imaydra',
            'Imedet',
            'Imikeer',
            'Imilxime',
            'Imisard',
            'Immelanx',
            'Immoreth',
            'Immornam',
            'Imnatris',
            'Imrahran',
            'Imravog',
            'Imrazixt',
            'Imzia',
            'Inayiss',
            'Indreju',
            'Ingrenux',
            'Inhectin',
            'Inidar',
            'Inifael',
            'Inifox',
            'Ininay',
            'Inisdex',
            'Inisfail',
            'Inkiljist',
            'Inkotai',
            "Inno\xe4k",
            'Inora',
            'Insallasc',
            'Intaphka',
            'Inzellene',
            'Ioga',
            'Iolan',
            'Iombar',
            'Iosaz',
            'Iosdil',
            'Iperi',
            'Iphara',
            'Ipholar',
            'Ipolok',
            'Iptasor',
            'Irankar',
            'Irathar',
            'Ireneemp',
            'Irial',
            'Irian',
            'Iriboth',
            'Iriga',
            'Irmaskor',
            'Irmistib',
            'Irphilin',
            'Irriosce',
            'Irshirkur',
            'Isaelsu',
            'Isamar',
            'Isarma',
            'Isbexa',
            'Isencal',
            'Isgremnir',
            'Ishmira',
            'Ishnitra',
            'Isiki',
            'Iskarrine',
            'Iskimi',
            'Iskiret',
            'Isodrost',
            'Isotu',
            'Isromant',
            'Isrotha',
            'Issakra',
            'Issanthal',
            'Issevex',
            'Issimrak',
            'Istengrem',
            'Istensanth',
            'Isthentild',
            'Istheol',
            'Isthgiol',
            'Istidom',
            'Istijed',
            'Istroval',
            'Isuxnen',
            'Itharna',
            'Ithelus',
            'Ithimryr',
            'Ithineg',
            'Ithober',
            'Iventhax',
            'Ivrishel',
            'Iwranda',
            'Ixambel',
            'Ixanthis',
            'Ixarine',
            'Ixcavar',
            'Ixium',
            'Iyenna',
            'Iyiskek',
            'Izpiizzi',
            'Jabarla',
            'Jablomeed',
            'Jaelmura',
            'Jafila',
            'Jagadis',
            'Jagaroch',
            'Jahaurin',
            'Jakalar',
            'Jakarhul',
            'Jakendar',
            'Jakharral',
            'Jakronib',
            'Jalaran',
            'Jalatha',
            'Jaleana',
            'Jaligar',
            'Jalisharn',
            'Jalnio',
            'Jalvochin',
            "Jance\xe4",
            'Jandagar',
            'Jandenor',
            'Janien',
            'Janniel',
            'Jaralor',
            'Jarantin',
            'Jaratryne',
            'Jardilan',
            'Jarien',
            'Jarioth',
            'Jaronris',
            'Jascelat',
            'Jascenant',
            'Jaslani',
            'Jassolind',
            'Jatherfar',
            'Jathlabra',
            'Jathzoril',
            'Jaukulmar',
            'Jaurelin',
            'Javennae',
            'Javrezac',
            'Jazaeron',
            'Jejaneel',
            'Jeleeya',
            'Jelerish',
            'Jelgrion',
            'Jemadar',
            'Jemkoleng',
            'Jeoric',
            'Jeoster',
            'Jeprana',
            'Jertezan',
            'Jervida',
            'Jessabra',
            'Jevalor',
            'Jevedic',
            'Jevorin',
            'Jevrian',
            'Jhessala',
            'Jhinilak',
            'Jianthi',
            'Jidesa',
            'Jifrusni',
            'Jijinjic',
            'Jilarna',
            'Jilitha',
            'Jillaro',
            'Jingaran',
            'Jiriselk',
            'Jiruik',
            'Jivessla',
            'Jivizet',
            'Jixannil',
            'Jizuret',
            "Jo\xe4sra",
            'Joplezno',
            'Jorian',
            'Joriel',
            'Jorodrin',
            'Josafyre',
            'Jothaugan',
            'Jothera',
            'Jozranal',
            'Jranahaz',
            'Juarin',
            'Jumeon',
            'Juramanx',
            'Jussondrel',
            'Juxeccan',
            'Juzawik',
            'Kacinzen',
            'Kadishir',
            'Kahora',
            'Kairaku',
            'Kajabor',
            'Kajua',
            'Kalandrin',
            'Kaledath',
            'Kalvaro',
            'Kamisu',
            'Kamundam',
            'Kandonak',
            'Kandorin',
            'Kapasin',
            "Kara\xebl",
            'Karamis',
            'Karanchir',
            'Kardarkar',
            'Kardotha',
            'Karela',
            'Karezthame',
            'Karimeg',
            'Karogan',
            'Kasiran',
            'Kasluna',
            'Kastana',
            "Kastau\xebt",
            'Kasthukras',
            'Kathanal',
            'Katryzaj',
            'Katumar',
            'Kazellor',
            "Kazu\xf6n",
            'Kedrinal',
            'Kelemon',
            'Kelmerveld',
            'Kelraiog',
            'Kelvixa',
            'Kemmergen',
            'Kerannix',
            'Kerason',
            'Kerasun',
            'Kerendul',
            'Kerfina',
            'Kernamald',
            'Keroona',
            'Kerrekril',
            'Kerrihaude',
            'Kestramel',
            'Kexranea',
            'Khadera',
            "Khalid\xfbr",
            'Kharisden',
            'Khelaret',
            'Khorenym',
            'Khosilin',
            'Khuraram',
            'Khurkula',
            'Kiarak',
            'Kiaskek',
            'Kifadli',
            'Kinbulser',
            'Kinjeon',
            'Kintarna',
            'Kioxug',
            'Kireoj',
            'Kirias',
            'Kiriok',
            'Kirithul',
            'Kirrevi',
            'Kiuspou',
            'Kizarlon',
            'Klandisar',
            'Klirundon',
            'Kodoki',
            'Korachon',
            'Korasal',
            'Kortien',
            'Korvaron',
            'Kotajad',
            'Kothenai',
            'Kovaia',
            'Kozanga',
            'Krasgalad',
            'Krienna',
            'Krisilal',
            'Krytelgaz',
            'Kuiju',
            'Kydomor',
            'Kylara',
            'Kylinsra',
            'Kymelin',
            'Kymorel',
            'Kyrembra',
            'Kyvaran',
            'Kyveler',
            'Laaraban',
            'Lacoumox',
            'Lacrion',
            'Ladamur',
            'Ladestro',
            'Laesina',
            'Lafera',
            'Lagaram',
            'Lagova',
            'Lahanolt',
            'Laklanot',
            'Lalaia',
            'Lalthilan',
            'Lamidris',
            'Lamifer',
            'Lamizjax',
            'Lampralur',
            'Lamrella',
            'Lanisor',
            'Lanival',
            "Lanstre\xe4",
            'Lantakrel',
            'Lantamar',
            'Lanumel',
            'Lappeleme',
            'Laprimal',
            'Larana',
            'Laranel',
            'Larilect',
            'Larion',
            'Larquinip',
            'Lascynthis',
            'Lasirusk',
            'Lataffin',
            'Lattremond',
            'Lazadon',
            'Ledmial',
            'Legaaruksh',
            'Lelatha',
            'Leledish',
            'Lendela',
            'Lendoweer',
            'Leodaan',
            'Leojith',
            'Leoptrin',
            'Leptenar',
            'Leptredin',
            'Leranorb',
            'Lessefren',
            'Lethrian',
            'Levasim',
            'Lhyrrhana',
            'Liamar',
            'Liambra',
            'Liammeck',
            'Lianairn',
            'Liansra',
            'Lianvrin',
            'Liarxa',
            'Liavec',
            'Liembra',
            'Lilasta',
            'Lilkauki',
            'Lilthia',
            'Limbria',
            'Linargan',
            'Linnaker',
            'Lionus',
            'Liossoor',
            'Liquemar',
            'Liroitzin',
            'Lisimbra',
            'Lissara',
            'Lissflorel',
            'Lithuir',
            'Lithyulin',
            'Litoefer',
            'Liydala',
            'Lizenna',
            'Lizinra',
            'Llanaanu',
            "Lo\xebra",
            'Logano',
            'Lorana',
            'Lorenvra',
            'Loriant',
            'Lozeneth',
            'Luciet',
            'Lucimer',
            'Lunzia',
            'Lurepusc',
            'Luspilkir',
            'Luthirring',
            'Luuranoth',
            'Lydalay',
            'Lymandal',
            'Lynaya',
            "Lyndr\xe9",
            'Lynxias',
            'Lypilla',
            'Lyraloss',
            'Lyrian',
            'Lyrossa',
            'Lyrozi',
            'Lythian',
            'Lythratole',
            'Lyzeary',
            'Maalkeyan',
            'Maceon',
            'Madaluur',
            'Madiglim',
            'Madora',
            'Maerleetlas',
            'Maeronyx',
            'Mafranic',
            'Magezatt',
            'Magithel',
            'Maglethom',
            'Magylin',
            'Mahelas',
            'Majaelith',
            'Makana',
            "Mala\xebsse",
            'Malaioc',
            'Malambard',
            'Malandor',
            'Malasire',
            'Malasquor',
            'Malavok',
            'Malbrosac',
            'Maldagon',
            'Malechan',
            'Malestrin',
            'Malgadarn',
            'Malhantis',
            'Malhemar',
            'Malidryth',
            'Malifrin',
            'Malisken',
            'Mallaran',
            'Maloroc',
            'Malsanon',
            'Mamvier',
            'Mandrezool',
            'Manjalem',
            'Mannanon',
            'Mantragan',
            "Ma\xf6ndat",
            'Mapiran',
            'Mardieth',
            'Maridan',
            'Maridisp',
            'Marindro',
            'Marinus',
            'Marivik',
            'Marliok',
            'Marmaranx',
            'Marmeron',
            'Marniel',
            'Marreldix',
            'Marsarok',
            'Marsineh',
            'Martanzix',
            'Maruis',
            'Mashalla',
            'Masira',
            'Massoran',
            'Mathannil',
            'Matzirik',
            'Maunestin',
            'Mavira',
            'Maxander',
            'Maxtibel',
            'Mazegus',
            'Mazesra',
            'Mazian',
            'Mazivel',
            'Medarinn',
            'Medrahar',
            'Medvergaal',
            'Mehalet',
            'Mejarlan',
            'Mekeesha',
            'Melamnir',
            'Melapis',
            'Melasdar',
            'Melikkhaz',
            'Meliune',
            'Melliorn',
            'Melorond',
            'Memisaire',
            'Menalor',
            'Mendobarl',
            'Menelvaour',
            'Meodas',
            'Meraleph',
            'Merama',
            'Meramel',
            'Meranshu',
            'Meraudax',
            'Meriag',
            'Meridyn',
            'Meriel',
            'Merilec',
            'Merinar',
            'Merinard',
            'Merivran',
            'Merkalo',
            'Merlience',
            'Merresil',
            'Merscianthe',
            'Mertamet',
            'Mesegrim',
            'Metrofa',
            'Mevedet',
            'Mewreddan',
            'Mezedan',
            'Mezerel',
            'Mezlehet',
            'Mezlethil',
            'Mezrian',
            'Mezrenain',
            'Mezvorax',
            'Mialdere',
            'Mialorn',
            'Midela',
            'Mierah',
            'Mikramil',
            'Milicseth',
            'Minaxa',
            'Minrioth',
            'Miranei',
            'Mirantilb',
            'Mirelith',
            'Mirenta',
            'Miriel',
            'Mirieth',
            'Mirintha',
            'Mirion',
            'Mirreschade',
            'Mirrsomi',
            'Misella',
            'Misiplum',
            'Misirim',
            'Mithelos',
            "Mo\xe4lroc",
            'Mobrias',
            'Moieddin',
            'Moisiane',
            'Molhanni',
            'Mondestin',
            'Moramin',
            'Morannel',
            'Morilimth',
            'Morleved',
            'Mormindar',
            'Morofar',
            'Morozam',
            'Morrixan',
            'Mosbelo',
            'Movellan',
            'Moxfiel',
            'Mrankali',
            'Mredisu',
            'Mujeket',
            'Mulciner',
            'Mumivor',
            'Murbahir',
            'Murias',
            'Murinja',
            'Mustesra',
            'Mylbdenir',
            'Mylenost',
            'Myllara',
            'Myloryx',
            'Myractus',
            'Myrmelesc',
            'Myrrhismir',
            'Myrstica',
            'Myruken',
            'Myvior',
            'Naadien',
            'Nabronyb',
            "Na\xebska",
            'Nagarax',
            'Naiagard',
            'Najikim',
            'Nambolar',
            'Namezlith',
            'Namien',
            'Nappolanc',
            'Naramant',
            'Naranlob',
            'Naraven',
            'Narecan',
            'Naretha',
            'Narfalax',
            'Narimas',
            'Narisdaat',
            'Narissa',
            'Narotham',
            'Narothun',
            'Narrabhar',
            'Narseldax',
            'Nasmerul',
            'Nateera',
            'Nathogan',
            'Natrifer',
            'Nauthzegam',
            'Naveiruz',
            'Navislorn',
            'Navithesk',
            'Nefaroyn',
            'Negula',
            'Nelibar',
            'Nelphina',
            'Nelthenti',
            'Nelveren',
            'Nemarhaz',
            'Nemisen',
            'Nereitra',
            'Nerevaunt',
            'Nerian',
            'Nerida',
            'Neryonid',
            'Netharna',
            "Netho\xebl",
            'Neveena',
            'Nexian',
            'Nexlio',
            'Niascynth',
            'Nidoran',
            'Nienra',
            'Niggollo',
            'Nilchauntif',
            'Nilmio',
            'Nimandest',
            'Nimfiralth',
            'Nimiax',
            'Ninozain',
            'Niomakh',
            'Nisamon',
            'Nisaqua',
            'Nissafen',
            'Nitharna',
            'Nithikin',
            'Nitoda',
            'Nivilan',
            'Nizamar',
            'Nizared',
            'Noldiruth',
            'Nolteera',
            'Nooranda',
            'Norian',
            'Norvandrel',
            'Noumander',
            'Novrima',
            'Noxalwan',
            'Nuanvi',
            'Nuarban',
            'Nujriha',
            'Nulagdi',
            'Nuskuron',
            'Nyrana',
            'Nysorat',
            'Obatzi',
            'Obelnid',
            'Ocmias',
            'Odimos',
            'Offenalke',
            'Ogola',
            'Ohranjat',
            'Ojavi',
            'Ojilinx',
            'Okalder',
            'Okpala',
            'Oktavisp',
            'Olamar',
            'Olbenos',
            'Oldarane',
            'Oldrinben',
            'Olican',
            'Ollascet',
            'Olnefkin',
            'Olondin',
            'Olonthos',
            'Oloru',
            'Oloxem',
            'Olybris',
            'Omaldras',
            'Omaphel',
            'Omarna',
            'Omarthis',
            'Omberdal',
            'Ombriand',
            'Ommarisk',
            'Omosdur',
            'Omziec',
            'Onaldrus',
            'Oneira',
            'Onfivlen',
            'Oniack',
            'Onjedrit',
            'Onoxim',
            'Oolevran',
            'Oomia',
            'Oorandehle',
            'Oquilda',
            'Oradrad',
            'Orbasdron',
            'Orbeleez',
            'Orbitan',
            'Orchellor',
            'Orebus',
            'Oremex',
            'Orenai',
            'Orennem',
            'Oridyr',
            'Oriob',
            'Oristkel',
            'Orithreyn',
            'Orivaen',
            'Orlantsu',
            'Orliend',
            'Orlopem',
            'Orluan',
            'Ormadzel',
            'Ormarit',
            'Ormion',
            'Ornulaa',
            'Orodel',
            'Oromrath',
            'Orovar',
            'Orovune',
            'Orpirrhis',
            'Orreminsk',
            'Ortazan',
            'Osgoran',
            'Oskana',
            'Osmoril',
            'Osoyrir',
            'Ossfenness',
            'Otargol',
            'Othaldon',
            'Otralinx',
            'Oujanglor',
            'Ouraia',
            'Ovarasc',
            'Ovelleau',
            'Oveselm',
            'Ovranoj',
            'Ovrenor',
            'Oxavar',
            'Oxavart',
            "Oxru\xebl",
            'Ozatris',
            'Ozgethern',
            'Ozmirall',
            'Ozringol',
            'Palabell',
            'Palarna',
            'Palegain',
            'Palidral',
            'Palimbrust',
            'Palinor',
            'Panafig',
            'Pandaxes',
            'Pandelee',
            'Pandeleur',
            'Paomelna',
            'Pardyereyk',
            'Pargascir',
            'Parlion',
            'Paskorran',
            'Pastengral',
            'Pavadahl',
            'Pavandor',
            'Paxijanc',
            'Paxilla',
            'Pazaleeb',
            'Peladon',
            'Peledor',
            'Pelendur',
            'Peleod',
            'Pelezef',
            'Peliast',
            'Pelizon',
            'Pellingale',
            'Pelmercest',
            'Pelmergol',
            'Pelsiffra',
            'Penengvik',
            'Peradal',
            'Peraga',
            'Perendan',
            'Perendor',
            'Peridor',
            'Peripril',
            'Perisgrim',
            'Peristaad',
            'Perligon',
            'Pernian',
            'Perridex',
            'Persimmid',
            'Perushka',
            'Peslivar',
            'Petreban',
            'Phaidonaz',
            'Phaneon',
            'Pharethyn',
            'Phariol',
            'Pharnioth',
            'Phascalon',
            'Phesian',
            'Phiarusk',
            'Philizim',
            'Phiniak',
            'Phiressa',
            'Phoosrotex',
            'Phoseter',
            'Phramberzond',
            'Phranzulet',
            'Piapiar',
            'Pievalp',
            'Pillia',
            'Pioma',
            'Pirigal',
            'Pirilaud',
            'Pirinweal',
            'Piritosk',
            "Pis\xe7ion",
            'Pishior',
            'Pithibryl',
            'Piynameer',
            'Plamias',
            'Plenchiel',
            'Poinellay',
            'Poinembet',
            'Polassar',
            'Polorrum',
            'Porodo',
            'Porsenna',
            'Potadu',
            'Priligrel',
            'Progneti',
            'Ptamriad',
            'Ptelian',
            'Pteraphon',
            'Pulsavra',
            'Pyrenda',
            'Pyrtolosc',
            'Pytholtus',
            'Pytrigon',
            'Quaeleon',
            'Quagrana',
            'Qualbian',
            'Qualhassan',
            "Quana\xf6ck",
            'Quandiel',
            'Queegani',
            'Quenteri',
            'Quentezard',
            'Queoddry',
            'Queridra',
            "Quero\xeb",
            'Quersemel',
            'Quilium',
            'Quilverex',
            'Quinibus',
            'Quisifrix',
            'Quolatha',
            'Quolessip',
            "Quoran\xfbl",
            'Quyzacorm',
            'Raascia',
            'Racassar',
            'Rackafel',
            'Radasman',
            'Radelon',
            'Radula',
            'Raiveral',
            'Rajiten',
            'Rajurno',
            'Rakmyrral',
            'Rakshilan',
            'Ralanzur',
            'Ralisimp',
            'Ralmanor',
            'Ralystra',
            'Ramura',
            'Ranessin',
            'Ranicroy',
            'Ranifice',
            'Ranomar',
            'Rasaleth',
            'Rashemba',
            'Rassdolim',
            'Rasseglin',
            'Rassfydel',
            'Rastilon',
            'Ravathene',
            'Ravenor',
            'Raverail',
            'Ravimo',
            'Raxia',
            'Razamor',
            'Raziel',
            "Re\xe4nkal",
            'Reepifer',
            'Regalorj',
            'Regimir',
            'Reldorin',
            'Releza',
            'Relikin',
            'Relion',
            'Rellevirk',
            'Relliapt',
            'Relundar',
            'Rendeptir',
            'Renzelath',
            'Reonin',
            'Requiek',
            'Rescorance',
            'Resmenalse',
            'Retalkin',
            'Rethia',
            'Revenal',
            'Rezmyra',
            'Rhakotis',
            'Rhendalin',
            'Rhiacind',
            'Rhimaya',
            'Rhimeren',
            'Rhisala',
            'Rhomiscele',
            'Rhydolin',
            "Rhy\xf6lar",
            'Riasine',
            'Riatar',
            'Riatha',
            'Rickata',
            'Rigisil',
            'Rigonav',
            'Riimara',
            'Rilatha',
            'Rilidtai',
            'Rilmara',
            'Rilmorban',
            'Rinxfantir',
            'Riodan',
            'Riolarn',
            'Riolba',
            'Riscintell',
            'Risgana',
            'Risia',
            'Risrinam',
            'Rithotarl',
            'Rixian',
            'Rizifire',
            'Rocapeste',
            'Rodifel',
            'Rodion',
            "Ro\xebnen",
            'Rokefyre',
            'Romela',
            'Romenom',
            'Rondolla',
            'Rophelon',
            'Rophendir',
            'Rosmarlind',
            "Rou\xe4dth",
            'Rovlerac',
            'Rozeeldin',
            'Rugiel',
            'Ruhria',
            'Rumilan',
            'Runian',
            'Rusaadi',
            'Rusalmna',
            'Rusitholk',
            'Ruvasarn',
            'Ruvatro',
            "Ry\xf6zile",
            'Rynian',
            'Rynristas',
            'Rynyris',
            'Ryxarro',
            'Sabrazsa',
            'Sabriel',
            'Sabtimon',
            'Sadabel',
            'Sadeera',
            'Sadonel',
            'Safarrinx',
            'Saffinka',
            'Sagamir',
            'Saguil',
            "Sa\xefnda",
            'Sajaerix',
            'Salaarus',
            'Salathir',
            'Salclias',
            'Salina',
            'Salinen',
            'Salioct',
            'Salitlan',
            'Salmorin',
            'Salrissa',
            'Samalend',
            'Samerlan',
            'Sancial',
            'Sannsara',
            'Sanorye',
            'Sanpellin',
            'Sanseran',
            'Sanzhara',
            'Saqavar',
            'Sarandere',
            'Saraxa',
            'Sardanak',
            'Sarendril',
            'Sargadal',
            'Sariya',
            'Sarkinos',
            'Sarkozan',
            'Sarlian',
            'Sarmasar',
            "Saro\xeb",
            'Sarozak',
            'Sarrier',
            'Sarrofo',
            'Sarsicaul',
            'Sartenna',
            'Sarupha',
            'Saschalon',
            'Sathlatta',
            'Satrothan',
            "Sav\xeama",
            'Savretos',
            'Savria',
            'Scathanar',
            'Scesefna',
            'Sebandune',
            'Selamvra',
            'Selestor',
            'Selial',
            'Selidro',
            'Selior',
            'Selmiar',
            'Selnara',
            'Selnia',
            'Selsabar',
            'Selverel',
            'Semarsen',
            'Semdalice',
            'Semmagel',
            'Semurquan',
            'Sendara',
            'Senoster',
            'Seorra',
            'Sepiroth',
            'Seprenal',
            'Sepria',
            'Serakel',
            'Serambast',
            'Seramir',
            'Serefic',
            'Serrios',
            'Sertumen',
            'Servelen',
            'Serydran',
            'Seskandal',
            'Sevandir',
            'Sevandor',
            'Severique',
            'Severlesk',
            "Sevlasn\xe9",
            'Seytarin',
            'Sfaeriqua',
            'Sferalan',
            'Sferio',
            'Shaikala',
            'Shalimed',
            'Shameera',
            'Shanatherl',
            'Shanderzoth',
            'Sharajsha',
            'Sharbremil',
            'Shardovan',
            'Sharretal',
            "Shaxe\xe4n",
            'Shehallem',
            'Shekkazad',
            'Sherethis',
            'Sherina',
            'Sherotha',
            'Shevrian',
            'Shibema',
            'Shiennith',
            'Shildakor',
            'Shimjian',
            'Sholgonda',
            'Shragonach',
            'Shrymaroyne',
            'Shurakai',
            'Shushila',
            'Sialtaan',
            'Sianar',
            'Siandar',
            'Siandor',
            'Siannem',
            'Sidanzar',
            'Siendred',
            'Sientij',
            'Sientrib',
            'Siflana',
            'Sigilla',
            'Sildengold',
            'Silifer',
            'Silistel',
            'Silivis',
            'Silmriel',
            'Silvarak',
            'Silvronom',
            'Simara',
            'Simblio',
            'Simirling',
            'Simisthir',
            'Simrana',
            'Simusha',
            'Sindaract',
            'Sindiris',
            'Sindiroq',
            'Sinhadak',
            'Sinira',
            'Sinoprin',
            'Siortlen',
            'Sioshorl',
            'Sirelu',
            'Sirenel',
            'Sirgamesc',
            'Sirifrix',
            'Sirinar',
            'Sisimar',
            'Sisimbra',
            'Siugorn',
            'Sjalara',
            'Skalidra',
            'Skelalack',
            'Skelogha',
            'Skelother',
            'Skesira',
            'Slanarra',
            'Slanria',
            'Slenlior',
            'Slevindralsk',
            'Slyrmegnel',
            'Sofrego',
            'Sofurin',
            'Soleddin',
            'Solfellan',
            'Soliroq',
            'Solliot',
            'Solmerip',
            'Soltharan',
            'Somagar',
            'Sondaardrel',
            'Sondrelen',
            'Soomerak',
            'Soquallin',
            'Sorasta',
            'Sormian',
            'Sozmerold',
            'Srandelix',
            'Sravoorin',
            'Steraval',
            'Sthinalel',
            'Stiaver',
            'Stivernach',
            'Sudevim',
            'Sufranar',
            'Suilim',
            'Sujorgni',
            'Sukratak',
            'Sulathaag',
            'Sulethri',
            'Suliane',
            'Sulien',
            'Sulimo',
            'Sulkanar',
            'Sulkari',
            "Sulron\xe9",
            'Surmaris',
            'Suruay',
            'Suzamil',
            'Svialdan',
            'Swangoren',
            'Sweiborla',
            'Sylvetane',
            'Symaril',
            'Syriolg',
            'Syzirept',
            'Szivistri',
            'Taalivex',
            'Tabusaad',
            'Tadasli',
            'Tafashic',
            'Tainbara',
            'Taladere',
            'Talareme',
            'Talarin',
            'Talertus',
            'Talien',
            'Taliess',
            'Talieux',
            'Talion',
            'Talislance',
            'Talmora',
            'Taloxar',
            'Taloxi',
            'Talunon',
            'Tamavold',
            'Tamias',
            'Tamioj',
            'Tamlivran',
            'Tamnithir',
            'Tanafin',
            'Tanakord',
            'Tanier',
            'Tanjalas',
            'Tanjara',
            'Tanseral',
            'Tanviu',
            'Tarakus',
            'Taramag',
            'Taramos',
            'Tardelin',
            'Tariaj',
            'Tarkenthos',
            'Tarmesorn',
            'Tarmioc',
            'Taroya',
            'Tasardy',
            'Taslhiot',
            'Tassafert',
            'Tassiran',
            'Taumonar',
            'Taveli',
            'Tavista',
            'Tayaren',
            "Te\xe4nyn",
            'Tegana',
            'Tegleron',
            'Teirajan',
            'Teirishir',
            'Telarna',
            'Telcyra',
            'Teldrua',
            'Telegris',
            'Telendys',
            'Teleura',
            'Telnarzim',
            'Temeris',
            'Temeslin',
            'Temmosus',
            'Temontel',
            'Tenadas',
            'Tenidrist',
            'Teotsir',
            'Terasiln',
            'Terejoen',
            'Terena',
            'Terquaelen',
            'Terrenus',
            'Terthelej',
            'Terthyrkrim',
            "Terva\xebn",
            'Tesmarrak',
            'Tevala',
            'Tezarim',
            'Thadarin',
            'Thalafer',
            'Thalaras',
            'Thalira',
            'Thalladyle',
            'Thameera',
            'Thamiel',
            'Thanalar',
            'Tharamoon',
            'Tharnia',
            'Tharomyl',
            'Tharoval',
            'Thellikkin',
            'Thelodin',
            'Thereski',
            'Thieras',
            'Thieryn',
            'Thirindon',
            'Thithrama',
            'Thitrivar',
            'Thixagen',
            'Thlenedern',
            'Thlunarna',
            'Thoorana',
            'Thrabanquo',
            'Thumithar',
            'Thurmatoth',
            'Thuuvanar',
            'Tiabrell',
            'Tiachul',
            'Tianan',
            'Tiaosut',
            'Tiaxa',
            'Tiazan',
            'Tiefkol',
            'Tifulgar',
            'Tigrana',
            'Tirages',
            'Tiregam',
            'Tirelev',
            'Tirion',
            'Tirlimist',
            'Tirrasthu',
            'Tissawane',
            'Titia',
            'Tivadul',
            'Tiveran',
            'Tivriex',
            'Tiyagar',
            'Tizvian',
            'Tolarim',
            'Tolarmej',
            'Tolenka',
            'Tolibell',
            'Toramus',
            'Torbera',
            'Torgassin',
            'Torlion',
            'Tormitran',
            "Toro\xe4sh",
            'Toroman',
            'Torquenyx',
            'Torresind',
            'Torsamant',
            'Torzundus',
            'Tothirnal',
            'Tralien',
            'Tralquien',
            'Traviod',
            'Tredestin',
            'Trellium',
            'Trenaevis',
            'Trilajo',
            'Trinezhan',
            'Triolus',
            'Trisdestrin',
            'Troviawn',
            'Trydaron',
            'Trysadon',
            'Tsacramal',
            'Tsalkoril',
            'Tuilleth',
            'Tulio',
            'Tuniger',
            'Turmalin',
            'Turobel',
            'Turvesin',
            'Twanalor',
            'Twillessin',
            'Tylastreen',
            'Tyldora',
            'Tylenea',
            'Tyradin',
            'Tyrathis',
            'Tyrtyra',
            'Tzaroli',
            'Ualosk',
            'Ubdakon',
            'Udanax',
            'Udanib',
            'Udefoin',
            'Udrahart',
            'Udria',
            'Ufanort',
            'Ufial',
            'Ugivor',
            'Uilda',
            'Uilric',
            'Uixet',
            'Ukinorn',
            'Ulanthas',
            'Ulember',
            'Ulendal',
            'Ullifan',
            'Ulnavell',
            'Ulnaxdra',
            'Ulrepin',
            "Ulro\xebnce",
            'Umaspin',
            'Umbraheed',
            'Umbrina',
            'Umerac',
            'Umeri',
            'Umikrel',
            'Umistal',
            'Undalryn',
            'Unedrinj',
            'Unkalisk',
            'Unstoffel',
            "Ura\xf6r",
            'Urghazkoy',
            'Urhankren',
            'Urimnor',
            'Urjalum',
            'Urjaya',
            'Urmalgis',
            'Urrelor',
            'Urzunift',
            'Uscrumine',
            'Usegar',
            'Ushamtar',
            'Usigul',
            'Uskanast',
            'Ussala',
            'Ussolec',
            'Ustaleaugh',
            'Uthudain',
            'Utorel',
            'Uveena',
            'Uxavis',
            'Uxinor',
            'Uxuvi',
            'Uzileth',
            'Uziprost',
            'Uzirin',
            'Uzisloj',
            "Vacru\xebx",
            'Vakrissa',
            'Valabar',
            'Valadan',
            'Valagarth',
            'Valandrib',
            'Valarend',
            'Valarom',
            'Valaxis',
            'Valdera',
            'Valfoxel',
            'Valina',
            'Valion',
            'Valistes',
            'Vallia',
            'Valmerac',
            'Valphanar',
            'Valserna',
            'Valterla',
            "Valthom\xe9",
            'Vanamon',
            'Vanara',
            'Vanathil',
            'Vandelex',
            'Vanegrin',
            'Vangrahzmid',
            'Vantarad',
            'Varamanx',
            'Varamid',
            'Varamis',
            'Varcantis',
            'Varchimas',
            'Varkellit',
            'Varlandel',
            "Varra\xebl",
            'Varrakel',
            'Vashlion',
            'Vasmarro',
            'Vaudirek',
            'Vayemis',
            'Vedaraf',
            "Veezpro\xe4",
            'Velaila',
            'Velanac',
            'Velija',
            'Velina',
            'Velior',
            'Velissa',
            'Velozma',
            'Velvermeld',
            'Vendramyr',
            'Veneska',
            'Venithros',
            'Venmarenc',
            'Vercazlyde',
            'Vereedra',
            'Verenice',
            'Vereska',
            'Verethest',
            'Verissrad',
            'Verolant',
            'Verowa',
            'Vervadesce',
            'Ververine',
            'Veslomere',
            'Vetrengarr',
            'Vettemis',
            'Vhiallon',
            'Viastin',
            'Viastra',
            'Videla',
            'Videssos',
            'Viero',
            'Vilirast',
            'Vilrokin',
            'Vilscelyn',
            'Viomer',
            'Virandisp',
            'Virenar',
            'Virensa',
            'Virjauruk',
            'Virosanne',
            'Virthuren',
            'Vismarun',
            'Visperime',
            'Vixuad',
            "Vixu\xebl",
            'Vizina',
            'Vladilesk',
            'Vlarobaal',
            "Voiop\xeb",
            'Vojeera',
            'Voldisterre',
            'Volkazen',
            'Volmaran',
            'Voluru',
            'Vonidar',
            'Voozcoreme',
            'Voranor',
            'Vorchazel',
            'Vorelgin',
            'Vorien',
            'Vornica',
            'Vornovas',
            'Vorquemand',
            'Vorunir',
            'Vorvadoss',
            'Vosmerrel',
            'Vossari',
            'Vozmarald',
            'Vrepimus',
            'Vrilestamn',
            'Vristamor',
            "Vu\xebthar",
            'Walspinore',
            'Wandalar',
            'Wanestka',
            'Wantorak',
            'Wardlanof',
            'Warlwier',
            'Warrigel',
            'Wascramin',
            "Wasmo\xebt",
            'Watreyan',
            'Wazerac',
            'Wedonal',
            'Welmerel',
            'Wendower',
            'Werrelet',
            'Werscunok',
            'Weverin',
            'Wexavin',
            'Whallifrond',
            'Whearius',
            'Whibmistle',
            'Wianna',
            'Wicardod',
            'Widzoonaev',
            'Wignaja',
            'Wiinecot',
            'Winian',
            'Wodhrian',
            'Woringel',
            'Woxethoon',
            'Wrodlian',
            'Wurzemand',
            'Wyliath',
            'Xadamos',
            'Xadogar',
            'Xaisuruk',
            'Xalorof',
            'Xanafel',
            'Xanalver',
            'Xanbiah',
            'Xania',
            'Xantenmec',
            'Xanxia',
            'Xaraata',
            'Xargusull',
            'Xarthia',
            'Xeelafarl',
            'Xeelona',
            'Xegessem',
            'Xelica',
            'Xemeret',
            'Xemindar',
            'Xenia',
            'Xeralisk',
            'Xerdelisse',
            'Xerechron',
            'Xhalsadan',
            'Xhanazlet',
            'Xhodrovan',
            'Xibalba',
            'Xiifrani',
            'Ximahlto',
            'Ximakran',
            'Ximodi',
            'Xirian',
            'Xirijasp',
            "Xo\xe4non",
            'Xomdiral',
            'Xorandor',
            'Xoryalan',
            'Xyaria',
            'Yaimondar',
            'Yakovar',
            'Yakthodah',
            'Yalduvar',
            'Yaliath',
            'Yallarna',
            'Yallorind',
            'Yalveron',
            'Yamala',
            'Yamindra',
            'Yandelar',
            'Yandrahla',
            'Yaralet',
            'Yarial',
            'Yarillo',
            'Yarzolept',
            'Yashengzeb',
            'Yathagault',
            'Yathoric',
            'Yathorlak',
            'Ybalil',
            'Ybranar',
            'Yeltranal',
            "Yelu\xf6z",
            'Yemanthal',
            'Yemboloth',
            'Yerdien',
            'Yesgolod',
            'Yevjarel',
            'Yfremoon',
            'Ygristan',
            "Yhantu\xf6r",
            'Yldejaste',
            'Ymarisce',
            'Ymbria',
            'Yncaarim',
            'Yohonough',
            'Yonraloth',
            'Yoplossa',
            'Yoredan',
            'Yormexoon',
            'Yranthis',
            'Yratos',
            'Yrcanos',
            'Yronthol',
            'Yrwelos',
            'Yryloth',
            'Ythlyra',
            'Ythribond',
            'Yurnada',
            'Yusperal',
            'Yuzigral',
            'Zaamontel',
            'Zadamun',
            'Zadipan',
            'Zadrowane',
            'Zagrenxa',
            'Zaharbif',
            'Zajrenja',
            'Zakiwya',
            'Zalagi',
            'Zalanath',
            'Zalazar',
            'Zalberek',
            'Zalremy',
            'Zamberel',
            'Zamblezur',
            'Zamora',
            'Zamordax',
            'Zamorla',
            'Zanatir',
            'Zanestra',
            'Zangabal',
            'Zanindil',
            'Zanreynad',
            'Zantifer',
            'Zanzinel',
            'Zaraana',
            'Zaranave',
            'Zaranax',
            'Zarfhaano',
            'Zarimarth',
            'Zathmandar',
            'Zayzazi',
            'Zazamanc',
            'Zazumel',
            'Zazwinoon',
            'Zebalan',
            'Zefaeran',
            'Zefrondus',
            'Zelemorn',
            'Zelgadis',
            'Zellinet',
            'Zelmarine',
            'Zelprothon',
            'Zemanthel',
            'Zemirtol',
            'Zenaxa',
            'Zenilyeth',
            'Zenithral',
            'Zenorsha',
            'Zentrigar',
            'Zeosard',
            'Zephiron',
            'Zequiel',
            'Zeranoj',
            'Zhelavon',
            'Zhemaeta',
            'Ziacalt',
            'Zifidin',
            'Zilkorlaz',
            'Ziraldra',
            'Zirdarbis',
            'Zirzihin',
            "Zo\xe4lmar",
            "Zo\xe4ndrik",
            "Zo\xe4var",
            'Zochiad',
            'Zodolin',
            'Zoltaren',
            'Zominor',
            'Zoramus',
            'Zoranji',
            'Zorashad',
            'Zorayas',
            'Zorestrel',
            'Zorewyr',
            'Zoroma',
            'Zoromesh',
            'Zosmindo',
            'Zotaquaan',
            'Zotheera',
            'Zozminod',
            'Zubvuysa',
            'Zulaeram',
            'Zulpirek',
            'Zurenkin',
            'Zurliban',
            'Zydaraf',
            'Zylarthen',
            'Zyramythe',
            'Zytavirk'
        ],
        more: [
            'Abadapnyr',
            'Abrethendar',
            'Acrasian',
            'Adario',
            'Adieseth',
            'Adilikor',
            'Adinalar',
            'Adriaxa',
            'Afelanidd',
            'Aforvalon',
            'Agiora',
            'Agreliwin',
            'Aguidran',
            'Aguilla',
            'Aikikia',
            'Akitarka',
            'Alanahetra',
            'Alarion',
            'Alartia',
            'Alarurigu',
            'Alcidio',
            'Aldarian',
            'Alelakon',
            'Aleshmara',
            'Aletorim',
            'Aleuworust',
            'Alianala',
            'Alicindra',
            'Allessanya',
            'Alorassanz',
            'Amafeyan',
            'Amathenar',
            'Amdaramast',
            'Amiria',
            'Amriffien',
            'Anaumiantis',
            'Anelofar',
            'Angetenar',
            'Angurvidel',
            'Animeldio',
            'Anixido',
            'Ankitarla',
            'Ansamanthion',
            'Ansimantar',
            'Anspiladri',
            'Antillia',
            'Aphiana',
            'Aptolcater',
            'Aptrinuptium',
            'Aquilia',
            "Aradlum\xe9",
            'Araledek',
            'Aramanzom',
            'Aramestor',
            'Arania',
            'Arazederu',
            'Arazynxa',
            'Ardzefurith',
            'Arezia',
            'Arhilian',
            'Arianroth',
            'Ariaria',
            'Ariaxoc',
            'Arismaspia',
            'Ariyava',
            'Armalisrah',
            'Aroxian',
            'Arrolian',
            'Arsevalin',
            'Artalien',
            'Aruzustin',
            'Arzangiran',
            'Asalirin',
            'Asarlia',
            'Asicia',
            'Aslambarash',
            'Aslerion',
            'Asthania',
            'Asuricorm',
            'Atarana',
            'Athiana',
            'Athlebasia',
            'Athoriel',
            'Atiaran',
            'Aulurien',
            'Avalenar',
            'Avanimmerl',
            'Avelembai',
            'Aviathar',
            'Axajaxas',
            'Azeledim',
            'Azgelazgus',
            'Aziria',
            'Barosathlom',
            'Barylophar',
            'Bazkalia',
            'Beledira',
            'Belintraia',
            'Belrablion',
            'Borosiyan',
            'Bradullio',
            'Brodalcaflar',
            'Cajarrida',
            "Calane\xfcs",
            'Calasapia',
            'Caldiloran',
            'Caleria',
            'Calgalcandar',
            'Calidundarios',
            'Calliwelleran',
            'Calmamelis',
            'Caratrothis',
            'Carthazian',
            'Casrinian',
            'Cassrimello',
            "Cauditrice\xe4",
            'Cerelama',
            'Chaestebalon',
            'Chalirio',
            "Cha\xf6lthanesh",
            'Chisirion',
            'Cinariyan',
            'Cinnarath',
            'Cirthavion',
            "Co\xe4berul",
            "Co\xebxitaq",
            "Coranco\xe4n",
            'Coreliad',
            'Corrilisan',
            'Cossario',
            'Crotimian',
            'Cuidurjau',
            'Cymoria',
            'Dajuvius',
            'Dakrolidur',
            'Dameraxia',
            'Daraviel',
            'Daraztheon',
            'Darsimala',
            'Darsurion',
            'Dassalpian',
            'Daxxihidil',
            'Delrinian',
            'Demasaran',
            'Demeriolet',
            'Devaloka',
            'Diamerune',
            'Dicadoran',
            'Didoria',
            'Dinrudromon',
            'Dirinnia',
            'Dolohies',
            'Dophinrian',
            'Dornatentorl',
            'Drevixibrind',
            'Drexorvion',
            'Duralica',
            'Dyskilian',
            "E\xe4lisen",
            "E\xe4tinor",
            'Ebriany',
            'Eclaramon',
            'Efarion',
            'Efiranlas',
            'Egajia',
            'Eglaharant',
            'Eglantarask',
            'Elantargin',
            'Elarial',
            'Eleglorross',
            'Elianna',
            'Elisdriel',
            "Elivint\xe9",
            'Ellyria',
            "Elorta\xf6l",
            'Eltaria',
            'Elverion',
            'Elysia',
            'Emelesis',
            'Emelsyna',
            'Enstarlamyn',
            'Entalaroth',
            'Epimissia',
            'Erejitha',
            'Eremiess',
            'Erengazor',
            'Erigia',
            'Erivalda',
            'Escalinian',
            'Escamorid',
            'Eschurioz',
            'Esmerashard',
            'Esnaramik',
            'Etheriasa',
            'Etianor',
            'Etybrinel',
            'Ezaltarem',
            'Ezellohar',
            'Faedulias',
            'Falastien',
            'Falerio',
            'Falyrias',
            'Farsemnithal',
            'Favaijeness',
            'Felarica',
            'Felmarien',
            'Feresilmar',
            'Fiarazio',
            'Fiespegar',
            'Fimalemuen',
            'Finactias',
            'Fiormezath',
            'Firvintilis',
            'Flamorriwisp',
            'Flaxifyglar',
            "Fo\xe4zekov",
            'Folsalino',
            'Frixalissa',
            'Fusafandra',
            'Fuvusarooz',
            'Gaflorinos',
            'Galathanax',
            'Galdviara',
            'Galirrhyalen',
            'Gambrimanthus',
            'Ganthelios',
            'Ganvarathimyr',
            'Garlinian',
            'Gauribanon',
            'Gazaforen',
            "Geluru\xebm",
            'Gemaleon',
            'Ghondaliom',
            'Giavicel',
            'Gikishika',
            'Gorvonia',
            'Halremsolath',
            'Hanciara',
            'Harfelengol',
            'Hatuina',
            'Hazrathsimoon',
            'Hazrinivra',
            'Herazibrax',
            'Hiabezur',
            'Hidolebni',
            'Hipalonin',
            'Hizzlechaltezeme',
            "Hlantremi\xebr",
            'Hovancomi',
            'Hurania',
            "Hyfe\xe4ntio",
            'Ibaletri',
            'Idriella',
            'Ierendi',
            'Igadiax',
            'Iglithebem',
            'Ilanayom',
            'Ilerida',
            'Ilirsiya',
            'Ilizio',
            'Illemestri',
            'Ilminaris',
            'Impelia',
            'Inikia',
            "Inthe\xe4nereon",
            'Ionellza',
            'Iongua',
            'Iophroster',
            'Iptameela',
            'Irgasia',
            'Iskarnia',
            'Iuzator',
            'Ixiosyne',
            'Izmirodon',
            'Jachoriax',
            'Jakanuin',
            'Jalanochlan',
            'Jaleduin',
            'Jandrebliash',
            'Jaralectan',
            'Jarchesmadis',
            'Javethiel',
            'Jelanjaztor',
            'Jemalkhiri',
            'Jemarixtesen',
            'Jirchesmiod',
            'Juaxmanar',
            'Jurelisma',
            'Kadarion',
            'Kagilia',
            'Kalenizin',
            'Kalienlod',
            'Kalpalanin',
            'Kandathama',
            'Kanthamio',
            'Karania',
            'Kardamordax',
            'Karethezam',
            'Karisempatur',
            'Karriasal',
            'Karthassily',
            'Kastrevelda',
            'Katanmaral',
            'Kemeroxel',
            'Keolotrest',
            'Keremelar',
            'Kerisiar',
            'Khalatulajax',
            'Khrysarlion',
            'Kikianik',
            'Kiralizur',
            'Kishidega',
            'Koquilgion',
            'Kryslaria',
            'Lalarian',
            'Lamamelis',
            'Lamdiraka',
            'Lamirila',
            'Lamotridac',
            'Lantessorax',
            'Larasajan',
            'Laschiantria',
            'Lauaxeta',
            'Laziarlan',
            'Lemesprie',
            'Leoniax',
            'Lepeduin',
            'Lialasia',
            'Liquilioss',
            'Lirrissia',
            "Locrama\xebl",
            'Ludurafet',
            'Luithiole',
            'Lyzalian',
            'Lyzeoldir',
            'Maheriel',
            "Majezre\xe4l",
            'Malabderas',
            'Malantiggar',
            'Malasteon',
            'Malevila',
            'Malyremeth',
            'Manariasc',
            'Maranduax',
            'Marassumar',
            'Maresedin',
            'Marillia',
            'Marzaranax',
            'Mathranislom',
            'Maudrosnia',
            'Mayulisas',
            'Medricaeldo',
            'Meliabrak',
            'Meliadoul',
            'Melidium',
            'Meliofard',
            "Melismond\xe9",
            'Melkandoro',
            'Melozathel',
            'Melusinnia',
            'Mereniax',
            'Meresinapt',
            'Mermiculex',
            'Metebelvis',
            'Mianjira',
            'Milinderra',
            'Mirelassar',
            'Mirianis',
            'Mirtagarkarit',
            "Mo\xe4thyalond",
            'Momelsia',
            'Morasina',
            'Morciana',
            'Moriliem',
            'Morilioth',
            'Muathazaglimid',
            'Mylakhrion',
            'Myrraxion',
            'Myrristica',
            'Naburios',
            'Nanieroj',
            'Narasia',
            'Narjiona',
            'Narragazkara',
            'Narzelduin',
            'Nemmaridus',
            'Nempifermal',
            'Nerovius',
            'Nevalrimyr',
            'Nevinlemnus',
            'Nichoriam',
            'Nimrathelet',
            'Nissebaral',
            'Niziliom',
            'Nohbirrian',
            'Octramadus',
            'Ohirial',
            'Okarbia',
            'Okpralio',
            'Olemerrin',
            'Oloscendivarn',
            'Onnurian',
            'Opacalia',
            'Orathiris',
            'Orbicritis',
            'Orialex',
            'Oriastus',
            'Orissanat',
            'Ormallivir',
            'Ormeria',
            'Orrizia',
            'Orroptio',
            'Orthaxifer',
            'Orviliach',
            'Otolvian',
            'Pactinasa',
            'Palzyriax',
            'Panaxcrador',
            'Panthioleed',
            'Paolalian',
            'Pelemurto',
            'Pelluxia',
            'Pemelojurg',
            'Pemulinaan',
            'Perjauruan',
            'Phayzelobion',
            'Phomechelian',
            'Phorissital',
            'Piartamisk',
            "Pirou\xebtta",
            'Pluzemelar',
            "Pomivarno\xebn",
            'Pyrvinrian',
            'Quanamelis',
            'Quarlusian',
            'Quelidia',
            'Quelizantor',
            'Querrulian',
            'Quetradendith',
            'Rajanthesina',
            'Rakanamet',
            'Ramantasset',
            'Ranasceleb',
            'Rasanathan',
            'Rathelemen',
            'Ravannifer',
            'Reondoresin',
            'Rhazazarak',
            'Rhiadirask',
            'Roxifalcor',
            "Rozalro\xe4th",
            "Ru\xe4lia",
            'Rudliptalin',
            'Rufomella',
            'Rulinian',
            'Runevara',
            'Ruzultrejest',
            'Rylissilin',
            'Saboorakel',
            'Sadonakai',
            'Saegdondakhar',
            'Salletifian',
            'Sandurion',
            'Sanoreya',
            'Sapelintir',
            'Sarantimar',
            'Sarathia',
            "Sarpemethe\xe4n",
            'Sarrabhluil',
            'Sartenia',
            'Saterbia',
            'Scarliherin',
            "Scoramant\xe9",
            'Semnegarius',
            'Serejarand',
            'Seremnaria',
            'Seriastis',
            'Serilia',
            'Seriona',
            'Shadarabar',
            'Sharadjelamir',
            'Sharajamar',
            'Shelarinisse',
            'Shelmorian',
            'Sireelia',
            'Sirezvia',
            'Siriena',
            'Sirulia',
            'Sorolonex',
            'Soromyrium',
            'Sorosilmar',
            'Sphallurian',
            'Sreltaneema',
            'Sulparia',
            'Suularaba',
            'Sylixia',
            'Tallosia',
            'Tamarien',
            'Tapromethyna',
            'Tarachien',
            'Taralian',
            'Tarsmiria',
            'Tasambekeer',
            'Tayenias',
            'Telaswiral',
            'Telaznemor',
            'Temilion',
            'Teniliak',
            'Tercyrian',
            'Thetalia',
            'Thorosiaz',
            'Tiaskelu',
            'Tifalius',
            'Tinzlactiash',
            'Tiriala',
            'Tirunriyek',
            'Tivamtemar',
            'Toraxoran',
            'Torellian',
            'Tormosian',
            'Trystaria',
            'Tsaliveren',
            'Tsardatsira',
            'Tuivoreth',
            'Ugalius',
            'Uguesilar',
            'Uirugan',
            'Ulakrugir',
            'Ulkarien',
            'Ullibunda',
            'Ultharnarath',
            'Umasdalen',
            'Umicia',
            'Unaramand',
            'Unlasnulkai',
            'Unorrehod',
            'Unuvia',
            'Upalumo',
            "Ura\xf6sin",
            'Uttosembuluz',
            'Uxulinak',
            'Valarindio',
            'Valarion',
            'Valaronai',
            'Valeauviej',
            'Varcassian',
            'Veladamar',
            'Velorian',
            'Venzafurome',
            'Vercerenos',
            'Veridia',
            'Vialora',
            'Vilcarien',
            'Vimbrodelthion',
            'Vincarian',
            'Virunia',
            'Vistramisorn',
            'Vreniriab',
            'Vruthalidrom',
            'Vyjeremanx',
            'Vyrania',
            'Werzamerand',
            'Wiernamal',
            'Wrosceltiar',
            'Wyjezinelb',
            'Xacuahatl',
            'Xaeximinar',
            'Xalaibisad',
            'Xalisuri',
            'Xaralien',
            'Xaralyna',
            'Xarilia',
            'Xasseldasene',
            'Xavanimar',
            'Xemelenos',
            'Xilvemzarad',
            'Xiomriest',
            'Xorlanterond',
            'Xorosia',
            'Yamidala',
            'Yamovelhas',
            'Yannavalka',
            'Yarbithresin',
            'Yarmidrian',
            'Yavilana',
            'Yazarrahaj',
            'Yetlioro',
            'Yormanien',
            'Yssarion',
            'Yzaniva',
            'Zabarianx',
            'Zaharsian',
            'Zalrevliaf',
            'Zanzarathool',
            'Zatakruan',
            'Zaulizanir',
            'Zavalliar',
            'Zavalniax',
            'Zekundaloth',
            'Zekundemar',
            'Zelissinfra',
            'Zelobindio',
            'Ziandela',
            'Zicarecem',
            'Zimenaechu',
            'Zofelliara',
            'Zoramatoth',
            'Zulaaria',
            'Zuralion',
            'Zuruxeno',
            'Zuzusilmar',
            'Zwimolio',
            "Zwy\xe4clemon",
            'Zyrissalantisar'
        ]
    }
};


var $a005f386d8246fce$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $a005f386d8246fce$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $a005f386d8246fce$var$symbolTag = '[object Symbol]';
/** Used to compose unicode character classes. */ var $a005f386d8246fce$var$rsAstralRange = '\\ud800-\\udfff', $a005f386d8246fce$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $a005f386d8246fce$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $a005f386d8246fce$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a005f386d8246fce$var$rsAstral = '[' + $a005f386d8246fce$var$rsAstralRange + ']', $a005f386d8246fce$var$rsCombo = '[' + $a005f386d8246fce$var$rsComboMarksRange + $a005f386d8246fce$var$rsComboSymbolsRange + ']', $a005f386d8246fce$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a005f386d8246fce$var$rsModifier = '(?:' + $a005f386d8246fce$var$rsCombo + '|' + $a005f386d8246fce$var$rsFitz + ')', $a005f386d8246fce$var$rsNonAstral = '[^' + $a005f386d8246fce$var$rsAstralRange + ']', $a005f386d8246fce$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a005f386d8246fce$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a005f386d8246fce$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a005f386d8246fce$var$reOptMod = $a005f386d8246fce$var$rsModifier + '?', $a005f386d8246fce$var$rsOptVar = '[' + $a005f386d8246fce$var$rsVarRange + ']?', $a005f386d8246fce$var$rsOptJoin = '(?:' + $a005f386d8246fce$var$rsZWJ + '(?:' + [
    $a005f386d8246fce$var$rsNonAstral,
    $a005f386d8246fce$var$rsRegional,
    $a005f386d8246fce$var$rsSurrPair
].join('|') + ')' + $a005f386d8246fce$var$rsOptVar + $a005f386d8246fce$var$reOptMod + ')*', $a005f386d8246fce$var$rsSeq = $a005f386d8246fce$var$rsOptVar + $a005f386d8246fce$var$reOptMod + $a005f386d8246fce$var$rsOptJoin, $a005f386d8246fce$var$rsSymbol = '(?:' + [
    $a005f386d8246fce$var$rsNonAstral + $a005f386d8246fce$var$rsCombo + '?',
    $a005f386d8246fce$var$rsCombo,
    $a005f386d8246fce$var$rsRegional,
    $a005f386d8246fce$var$rsSurrPair,
    $a005f386d8246fce$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a005f386d8246fce$var$reUnicode = RegExp($a005f386d8246fce$var$rsFitz + '(?=' + $a005f386d8246fce$var$rsFitz + ')|' + $a005f386d8246fce$var$rsSymbol + $a005f386d8246fce$var$rsSeq, 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $a005f386d8246fce$var$reHasUnicode = RegExp('[' + $a005f386d8246fce$var$rsZWJ + $a005f386d8246fce$var$rsAstralRange + $a005f386d8246fce$var$rsComboMarksRange + $a005f386d8246fce$var$rsComboSymbolsRange + $a005f386d8246fce$var$rsVarRange + ']');
/** Detect free variable `global` from Node.js. */ var $a005f386d8246fce$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $a005f386d8246fce$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a005f386d8246fce$var$root = $a005f386d8246fce$var$freeGlobal || $a005f386d8246fce$var$freeSelf || Function('return this')();
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a005f386d8246fce$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $a005f386d8246fce$var$hasUnicode(string) {
    return $a005f386d8246fce$var$reHasUnicode.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a005f386d8246fce$var$stringToArray(string) {
    return $a005f386d8246fce$var$hasUnicode(string) ? $a005f386d8246fce$var$unicodeToArray(string) : $a005f386d8246fce$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a005f386d8246fce$var$unicodeToArray(string) {
    return string.match($a005f386d8246fce$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $a005f386d8246fce$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a005f386d8246fce$var$objectToString = $a005f386d8246fce$var$objectProto.toString;
/** Built-in value references. */ var $a005f386d8246fce$var$Symbol = $a005f386d8246fce$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $a005f386d8246fce$var$symbolProto = $a005f386d8246fce$var$Symbol ? $a005f386d8246fce$var$Symbol.prototype : undefined, $a005f386d8246fce$var$symbolToString = $a005f386d8246fce$var$symbolProto ? $a005f386d8246fce$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a005f386d8246fce$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $a005f386d8246fce$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($a005f386d8246fce$var$isSymbol(value)) return $a005f386d8246fce$var$symbolToString ? $a005f386d8246fce$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$a005f386d8246fce$var$INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a005f386d8246fce$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $a005f386d8246fce$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $a005f386d8246fce$var$createCaseFirst(methodName) {
    return function(string) {
        string = $a005f386d8246fce$var$toString(string);
        var strSymbols = $a005f386d8246fce$var$hasUnicode(string) ? $a005f386d8246fce$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $a005f386d8246fce$var$castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a005f386d8246fce$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a005f386d8246fce$var$isSymbol(value) {
    return typeof value == 'symbol' || $a005f386d8246fce$var$isObjectLike(value) && $a005f386d8246fce$var$objectToString.call(value) == $a005f386d8246fce$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a005f386d8246fce$var$toString(value) {
    return value == null ? '' : $a005f386d8246fce$var$baseToString(value);
}
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $a005f386d8246fce$var$capitalize(string) {
    return $a005f386d8246fce$var$upperFirst($a005f386d8246fce$var$toString(string).toLowerCase());
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $a005f386d8246fce$var$upperFirst = $a005f386d8246fce$var$createCaseFirst('toUpperCase');
$a005f386d8246fce$exports = $a005f386d8246fce$var$capitalize;


var $9a926653c32dbfd1$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $9a926653c32dbfd1$var$INFINITY = 1 / 0, $9a926653c32dbfd1$var$MAX_INTEGER = 1.7976931348623157e+308, $9a926653c32dbfd1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $9a926653c32dbfd1$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $9a926653c32dbfd1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $9a926653c32dbfd1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $9a926653c32dbfd1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $9a926653c32dbfd1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $9a926653c32dbfd1$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $9a926653c32dbfd1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $9a926653c32dbfd1$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9a926653c32dbfd1$var$root = $9a926653c32dbfd1$var$freeGlobal || $9a926653c32dbfd1$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $9a926653c32dbfd1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9a926653c32dbfd1$var$objectToString = $9a926653c32dbfd1$var$objectProto.toString;
/** Built-in value references. */ var $9a926653c32dbfd1$var$Symbol = $9a926653c32dbfd1$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $9a926653c32dbfd1$var$symbolProto = $9a926653c32dbfd1$var$Symbol ? $9a926653c32dbfd1$var$Symbol.prototype : undefined, $9a926653c32dbfd1$var$symbolToString = $9a926653c32dbfd1$var$symbolProto ? $9a926653c32dbfd1$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $9a926653c32dbfd1$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $9a926653c32dbfd1$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($9a926653c32dbfd1$var$isSymbol(value)) return $9a926653c32dbfd1$var$symbolToString ? $9a926653c32dbfd1$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$9a926653c32dbfd1$var$INFINITY ? '-0' : result;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9a926653c32dbfd1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9a926653c32dbfd1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $9a926653c32dbfd1$var$isSymbol(value) {
    return typeof value == 'symbol' || $9a926653c32dbfd1$var$isObjectLike(value) && $9a926653c32dbfd1$var$objectToString.call(value) == $9a926653c32dbfd1$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $9a926653c32dbfd1$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $9a926653c32dbfd1$var$toNumber(value);
    if (value === $9a926653c32dbfd1$var$INFINITY || value === -$9a926653c32dbfd1$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $9a926653c32dbfd1$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $9a926653c32dbfd1$var$toInteger(value) {
    var result = $9a926653c32dbfd1$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $9a926653c32dbfd1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9a926653c32dbfd1$var$isSymbol(value)) return $9a926653c32dbfd1$var$NAN;
    if ($9a926653c32dbfd1$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $9a926653c32dbfd1$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($9a926653c32dbfd1$var$reTrim, '');
    var isBinary = $9a926653c32dbfd1$var$reIsBinary.test(value);
    return isBinary || $9a926653c32dbfd1$var$reIsOctal.test(value) ? $9a926653c32dbfd1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $9a926653c32dbfd1$var$reIsBadHex.test(value) ? $9a926653c32dbfd1$var$NAN : +value;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9a926653c32dbfd1$var$toString(value) {
    return value == null ? '' : $9a926653c32dbfd1$var$baseToString(value);
}
/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $9a926653c32dbfd1$var$endsWith(string, target, position) {
    string = $9a926653c32dbfd1$var$toString(string);
    target = $9a926653c32dbfd1$var$baseToString(target);
    var length = string.length;
    position = position === undefined ? length : $9a926653c32dbfd1$var$baseClamp($9a926653c32dbfd1$var$toInteger(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$9a926653c32dbfd1$exports = $9a926653c32dbfd1$var$endsWith;


const $be7d6440f987b85e$var$dieRoll = (dieSize = 10)=>(0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, dieSize, {
        rngFn: $be7d6440f987b85e$var$rngFnContainer.rngFn
    });
const $be7d6440f987b85e$var$isVowel = (letter)=>[
        "a",
        "e",
        "i",
        "o",
        "u"
    ].includes(letter);
const $be7d6440f987b85e$var$vileAndCrude = (size)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).vileAndCrude[size];
    return $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr)) + $be7d6440f987b85e$var$sample(nameArr);
};
const $be7d6440f987b85e$var$genderSuffixesKey = (gender)=>`${gender}Suffixes`;
const $be7d6440f987b85e$export$f330661115510edf = ()=>$be7d6440f987b85e$var$vileAndCrude("small");
const $be7d6440f987b85e$export$164e3face987268c = ()=>$be7d6440f987b85e$var$vileAndCrude("medium");
const $be7d6440f987b85e$export$cbca8355c5841452 = ()=>$be7d6440f987b85e$var$vileAndCrude("large");
const $be7d6440f987b85e$export$fc734a8352e8f082 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).primitive;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (gender === "male") {
        if (roll > 3) name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names))}`;
        if (roll > 8) name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names))}`;
    } else if (gender === "female") {
        if (roll > 5) name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names))}`;
        name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.suffixes))}`;
    }
    return name;
};
const $be7d6440f987b85e$export$b7a6217d119153b2 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).doughty;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.syllables));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (gender === "male") {
        if (roll > 7) name = `${name}${$be7d6440f987b85e$var$isVowel(name.slice(-1)) ? "r" : "i"}`;
        else name = `${name}${$be7d6440f987b85e$var$sample(nameArr.maleSuffixes)}`;
    } else if (gender === "female") {
        if (roll > 7) name = `${name}${$be7d6440f987b85e$var$isVowel(name.slice(-1)) ? "ra" : "a"}`;
        else name = `${name}${$be7d6440f987b85e$var$sample(nameArr.femaleSuffixes)}`;
    }
    return name;
};
const $be7d6440f987b85e$export$b6dba0b78ba793e2 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).homely;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.syllables));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    if (roll > 6) name = `${name} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).familyName.english)}`;
    return name;
};
const $be7d6440f987b85e$export$6fb065e3009500e1 = (gender)=>{
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).doughty.syllables));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if ((0, $df375085b7c59381$export$e4b2ac9215619f8d).homely[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).homely[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    if (roll > 6) name = `${name} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).familyName.scottish)}`;
    return name;
};
const $be7d6440f987b85e$var$sample = (arr)=>{
    return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(arr, {
        rngFn: $be7d6440f987b85e$var$rngFnContainer.rngFn
    });
};
const $be7d6440f987b85e$export$1ad0edd53e6ef91 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).fairAndNoble;
    let name = `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.elfPrefixes))}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$e251ffd6d5b8e509 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).fairAndNoble;
    let name = `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.alternativeElfPrefixes))}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$var$rngFnContainer = {
    rngFn: Math.random
};
const $be7d6440f987b85e$export$d7b219776568c005 = (seed)=>{
    $be7d6440f987b85e$var$rngFnContainer.rngFn = (0, $a80d0b17b615d6f7$export$5cc7dd0a77110dbe)(seed);
};
const $be7d6440f987b85e$export$166a844384d7abeb = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).fairy;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$8e76d4779b05a9b7 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).alternateFairy;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$aa1fcb80c0fc6987 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).elegantEvil;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixesDarkElves));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (roll > 2) name = `${name}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$ee2ecd3ff60576bc = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).elegantEvil;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixesAlternateDarkElves));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (roll > 2) name = `${name}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$9e2da7d9137ba6f2 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).malevolent;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$f1fd645118ed8be8 = ()=>{
    const keys = Object.keys((0, $df375085b7c59381$export$e4b2ac9215619f8d).infernal);
    const roll = $be7d6440f987b85e$var$dieRoll(3) - 1;
    const roll2 = $be7d6440f987b85e$var$dieRoll(2) - 1;
    const chosen = keys[roll];
    const chosen2 = keys.filter((x)=>x !== chosen)[roll2];
    return `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).infernal[chosen]))}${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).infernal[chosen2])}`;
};
const $be7d6440f987b85e$export$1776144b47d3fcbf = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).draconic;
    const name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    let suffix = $be7d6440f987b85e$var$sample(nameArr.suffixes);
    if (gender === "female") {
        if (suffix === "bazius") suffix = "bazia";
        else if ($9a926653c32dbfd1$exports(suffix, "os")) suffix += "sa";
        else suffix = "is";
    }
    return name + suffix;
};
const $be7d6440f987b85e$export$759caa9319039385 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).empyreal;
    const roll = $be7d6440f987b85e$var$dieRoll(12);
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (roll === 1) {
        if (gender === "female") {
            const aIndex = name.lastIndexOf("a");
            name = name.substr(0, aIndex) + "e" + name.substr(aIndex + 1);
        }
        name = `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.titles))}${name}`;
    } else if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$2c5e0952da356af6 = (allowMultipleNames)=>{
    const roll = $be7d6440f987b85e$var$dieRoll(20);
    if (roll < 3) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.one);
    if (roll < 12) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.two);
    if (roll < 17) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.three);
    if (roll === 17) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.more);
    if (roll === 18 && allowMultipleNames) return `${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.one)} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.two)}`;
    if (roll === 19 && allowMultipleNames) return `${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.two)} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.one)}`;
    if (roll === 20 && allowMultipleNames) {
        const keys = Object.keys((0, $df375085b7c59381$export$e4b2ac9215619f8d).human);
        return `${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human[$be7d6440f987b85e$var$sample(keys)])} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human[$be7d6440f987b85e$var$sample(keys)])}`;
    }
    return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human[$be7d6440f987b85e$var$sample(Object.keys((0, $df375085b7c59381$export$e4b2ac9215619f8d).human))]);
};


const $f93bb81604774744$var$racesWithGender = [
    "cavePerson",
    "dwarf",
    "halfling",
    "gnome",
    "elf",
    "highelf",
    "fairy",
    "highfairy",
    "darkelf",
    "drow",
    "halfdemon",
    "dragon",
    "angel"
];
const $f93bb81604774744$var$otherRaces = [
    "demon",
    "human",
    "goblin",
    "ogre",
    "orc"
];
const $f93bb81604774744$export$b7f30c4d8e7172b2 = {
    otherRaces: $f93bb81604774744$var$otherRaces,
    racesWithGender: $f93bb81604774744$var$racesWithGender,
    sorted: ()=>$f93bb81604774744$var$racesWithGender.concat($f93bb81604774744$var$otherRaces).sort()
};
const $f93bb81604774744$export$5d832d6580b26c5 = (race, options = {})=>{
    const { gender: gender, allowMultipleNames: allowMultipleNames } = options;
    if ($f93bb81604774744$var$racesWithGender.includes(race) && gender !== undefined) switch(race){
        case "angel":
            return (0, $be7d6440f987b85e$export$759caa9319039385)(gender);
        case "cavePerson":
            return (0, $be7d6440f987b85e$export$fc734a8352e8f082)(gender);
        case "darkelf":
            return (0, $be7d6440f987b85e$export$aa1fcb80c0fc6987)(gender);
        case "dragon":
            return (0, $be7d6440f987b85e$export$1776144b47d3fcbf)(gender);
        case "drow":
            return (0, $be7d6440f987b85e$export$ee2ecd3ff60576bc)(gender);
        case "dwarf":
            return (0, $be7d6440f987b85e$export$b7a6217d119153b2)(gender);
        case "elf":
            return (0, $be7d6440f987b85e$export$1ad0edd53e6ef91)(gender);
        case "fairy":
            return (0, $be7d6440f987b85e$export$166a844384d7abeb)(gender);
        case "gnome":
            return (0, $be7d6440f987b85e$export$6fb065e3009500e1)(gender);
        case "halfdemon":
            return (0, $be7d6440f987b85e$export$9e2da7d9137ba6f2)(gender);
        case "halfling":
            return (0, $be7d6440f987b85e$export$b6dba0b78ba793e2)(gender);
        case "highelf":
            return (0, $be7d6440f987b85e$export$e251ffd6d5b8e509)(gender);
        case "highfairy":
            return (0, $be7d6440f987b85e$export$8e76d4779b05a9b7)(gender);
        default:
            break;
    }
    switch(race){
        case "demon":
            return (0, $be7d6440f987b85e$export$f1fd645118ed8be8)();
        case "goblin":
            return (0, $be7d6440f987b85e$export$f330661115510edf)();
        case "human":
            return (0, $be7d6440f987b85e$export$2c5e0952da356af6)(allowMultipleNames);
        case "ogre":
            return (0, $be7d6440f987b85e$export$cbca8355c5841452)();
        case "orc":
            return (0, $be7d6440f987b85e$export$164e3face987268c)();
        default:
            break;
    }
    return new Error("Must provide a gender!");
};


var $46cd47a21442bee6$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $2ZTWb = parcelRequire("2ZTWb");

var $xnasA = parcelRequire("xnasA");

var $huIqu = parcelRequire("huIqu");

var $jSeQD = parcelRequire("jSeQD");

var $cEbON = parcelRequire("cEbON");

var $iBJuF = parcelRequire("iBJuF");
var $4b474a497f635269$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if ($4b474a497f635269$exports) {
        $4b474a497f635269$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("5Io6y"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : $4b474a497f635269$exports, [], Math // math: package containing random, pow, and seedrandom
);


$4b474a497f635269$exports.alea = $2ZTWb;
$4b474a497f635269$exports.xor128 = $xnasA;
$4b474a497f635269$exports.xorwow = $huIqu;
$4b474a497f635269$exports.xorshift7 = $jSeQD;
$4b474a497f635269$exports.xor4096 = $cEbON;
$4b474a497f635269$exports.tychei = $iBJuF;
$46cd47a21442bee6$exports = $4b474a497f635269$exports;


let $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR = undefined;
const $a80d0b17b615d6f7$export$3301a959d36e944c = (seed)=>{
    $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR = $46cd47a21442bee6$exports(seed);
};
const $a80d0b17b615d6f7$export$5cc7dd0a77110dbe = (seed)=>$46cd47a21442bee6$exports(seed);
const $a80d0b17b615d6f7$export$c45e8adbbf82647d = (min, max, seed)=>{
    if (seed) {
        const randomFloat = $a80d0b17b615d6f7$export$5cc7dd0a77110dbe(seed)();
        return Math.floor(randomFloat * (max - min + 1) + min);
    }
    if ($a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR === undefined) return (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(min, max);
    const randomFloat = $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR();
    // min and max included
    return Math.floor(randomFloat * (max - min + 1) + min);
};
const $a80d0b17b615d6f7$export$2b048c255d2e69f3 = ()=>{
    if ($a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR === undefined) return Math.random();
    const randomFloat = $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR();
    // min and max included
    return randomFloat;
};
const $a80d0b17b615d6f7$export$b363da9ded343252 = (p1, p2)=>Math.atan2(p2.y - p1.y, p2.x - p1.x) + Math.PI;
const $a80d0b17b615d6f7$export$3cb92a2060a7aca2 = (degrees)=>{
    const pi = Math.PI;
    return degrees * (pi / 180);
};
const $a80d0b17b615d6f7$export$32b1497b7aadef08 = (radians)=>{
    const pi = Math.PI;
    return radians * (180 / pi);
};
const $a80d0b17b615d6f7$export$5ebc7cf9991d3d13 = (radians)=>{
    function round5(x) {
        return Math.ceil(x / 25) * 25;
    }
    const degrees = round5($a80d0b17b615d6f7$export$32b1497b7aadef08(radians));
    let result = "right";
    if ($a80d0b17b615d6f7$export$cf95c51b03f10bae(degrees, 45, 135)) result = "front";
    if ($a80d0b17b615d6f7$export$cf95c51b03f10bae(degrees, 225, 315)) result = "back";
    if ($a80d0b17b615d6f7$export$cf95c51b03f10bae(degrees, 136, 224)) result = "left";
    return result;
};
const $a80d0b17b615d6f7$export$c71726d9d0282622 = (radians)=>{
    const dir = $a80d0b17b615d6f7$export$5ebc7cf9991d3d13(radians);
    switch(dir){
        case "front":
            return "south";
        case "back":
            return "north";
        case "right":
            return "east";
        case "left":
            return "west";
    }
    return "north";
};
const $a80d0b17b615d6f7$export$94d6114d0f45bc7e = (radians)=>{
    const orientation = $a80d0b17b615d6f7$export$5ebc7cf9991d3d13(radians);
    switch(orientation){
        case "front":
            return "Down";
        case "back":
            return "Up";
        case "right":
            return "Right";
        case "left":
            return "Left";
    }
    return "Up";
};
const $a80d0b17b615d6f7$export$df50878468f09592 = (radians)=>{
    const degrees = $a80d0b17b615d6f7$export$32b1497b7aadef08(radians);
    return ![
        90,
        180,
        270,
        360
    ].includes(degrees);
};
const $a80d0b17b615d6f7$export$9dac2d59bba1062a = (direction)=>{
    switch(direction){
        case "Down":
            return "Up";
        case "Up":
            return "Down";
        case "Right":
            return "Left";
        case "Left":
            return "Right";
    }
    return "Up";
};
const $a80d0b17b615d6f7$export$cf95c51b03f10bae = (x, a, b)=>x >= a && (b === undefined || x <= b);
const $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4 = (num, min, max)=>Math.max(min, Math.min(max, num));
const $a80d0b17b615d6f7$export$504709cb2a8295d2 = (fineCoordinate)=>{
    return !fineCoordinate ? undefined : {
        x: $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.x),
        y: $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.y)
    };
};
const $a80d0b17b615d6f7$export$566fe05fdbb514ba = (x)=>x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $a80d0b17b615d6f7$export$b240a5f8651dffb4 = (x)=>Math.floor(x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
const $a80d0b17b615d6f7$export$dd08c3a9a1f05e0c = (roomWidth, roomHeight, roomId, fineCoordinate)=>{
    const globalCoordinate = $a80d0b17b615d6f7$export$b03ec757ccd6a9ce();
    $a80d0b17b615d6f7$export$bd1cca3d8706a4e0(roomWidth, roomHeight, roomId, fineCoordinate, globalCoordinate);
    return globalCoordinate;
};
const $a80d0b17b615d6f7$export$f4f894b5dc700a2d = (x, y, roomWidth, roomHeight)=>{
    const roomX = Math.floor(x / roomWidth);
    const roomY = Math.floor(y / roomHeight);
    const roomId = `room-${roomX}-${roomY}`;
    const localX = x % roomWidth;
    const localY = y % roomHeight;
    return {
        roomId: roomId,
        x: localX,
        y: localY
    };
};
const $a80d0b17b615d6f7$export$138ae9036b843d3d = (roomWidth, roomHeight, roomX, roomY, fineCoordinate)=>{
    const globalCoordinate = $a80d0b17b615d6f7$export$b03ec757ccd6a9ce();
    const roomWidthFine = roomWidth * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const roomHeightFine = roomHeight * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const x = roomWidthFine * roomX + fineCoordinate.x;
    const y = roomHeightFine * roomY + fineCoordinate.y;
    globalCoordinate.x = x;
    globalCoordinate.y = y;
    return globalCoordinate;
};
const $a80d0b17b615d6f7$export$3463efbf94c3b6e1 = (roomId)=>{
    const [_, _roomX, _roomY] = roomId.split("-");
    return {
        x: Number(_roomX),
        y: Number(_roomY)
    };
};
const $a80d0b17b615d6f7$export$bd1cca3d8706a4e0 = (roomWidth, roomHeight, roomId, fineCoordinate, globalCoordinate)=>{
    const [_, _roomX, _roomY] = roomId.split("-");
    const roomX = Number(_roomX);
    const roomY = Number(_roomY);
    const roomWidthFine = roomWidth * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const roomHeightFine = roomHeight * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const x = roomWidthFine * roomX + fineCoordinate.x;
    const y = roomHeightFine * roomY + fineCoordinate.y;
    globalCoordinate.x = x;
    globalCoordinate.y = y;
};
const $a80d0b17b615d6f7$export$ead25a0ad81e18f0 = (coordinate)=>{
    return !coordinate || coordinate.x < 0 && coordinate.y < 0;
};
const $a80d0b17b615d6f7$export$b03ec757ccd6a9ce = ()=>{
    return {
        x: -1,
        y: -1
    };
};
const $a80d0b17b615d6f7$export$246e0d97ef73b196 = (coordinate)=>{
    if (!coordinate) return;
    coordinate.x = -1;
    coordinate.y = -1;
};
const $a80d0b17b615d6f7$export$dc04a47621b9cd74 = (c1, c2)=>c1.x !== c2.x || c1.y !== c2.y;
const $a80d0b17b615d6f7$export$74d4b819b66b5c70 = (fineCoordinate, roughCoordinate)=>{
    if (!fineCoordinate || !roughCoordinate) return;
    roughCoordinate.x = $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.x);
    roughCoordinate.y = $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.y);
};
const $a80d0b17b615d6f7$export$5afd74d1b598607d = (source, target)=>{
    if (!source || !target) return;
    target.x = source.x;
    target.y = source.y;
};
const $a80d0b17b615d6f7$export$989f786e03c2b51d = (meta, fineBounds, tileSize = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))=>{
    // console.trace()
    const f = (y)=>{
        return Math.floor(y * tileSize) + tileSize / 2;
    };
    const maxX = f(meta.width());
    const maxY = f(meta.height());
    const xStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x1, 0, maxX) / tileSize);
    const yStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y1, 0, maxY) / tileSize);
    const xEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x2, 0, maxX) / tileSize);
    const yEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y2, 0, maxY) / tileSize);
    return new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(xStart, yStart, xEnd, yEnd);
};
const $a80d0b17b615d6f7$export$7b8c2026ce8c6d5e = (dimensions, fineBounds, tileSize = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))=>{
    // console.trace()
    const f = (y)=>{
        return Math.floor(y * tileSize) + tileSize / 2;
    };
    const xStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x1, 0, f(dimensions.w)) / tileSize);
    const yStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y1, 0, f(dimensions.h)) / tileSize);
    const xEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x2, 0, f(dimensions.w)) / tileSize);
    const yEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y2, 0, f(dimensions.h)) / tileSize);
    return new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(xStart, yStart, xEnd, yEnd);
};
const $a80d0b17b615d6f7$export$a7f7c08af4b939e9 = (coordinate, amount = 16)=>{
    return {
        ...coordinate,
        x: coordinate.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount),
        y: coordinate.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount)
    };
};
const $a80d0b17b615d6f7$export$3ac84d03bc812507 = (coordinate, amount = 16)=>{
    coordinate.x = coordinate.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
    coordinate.y = coordinate.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
};
const $a80d0b17b615d6f7$export$983829bfbdacf03f = (coordinate, perturbed, amount = 16)=>{
    perturbed.x = coordinate.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
    perturbed.y = coordinate.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
};
const $a80d0b17b615d6f7$export$59e9cfed91f93f03 = (coordinate)=>{
    return {
        x: Math.round(coordinate.x),
        y: Math.round(coordinate.y)
    };
};
const $a80d0b17b615d6f7$export$7d94067f6d99210b = (coordinate)=>{
    return {
        x: Math.floor(coordinate.x),
        y: Math.floor(coordinate.y)
    };
};
const $a80d0b17b615d6f7$export$afdc8e4f563fbba3 = (roughCoordinate)=>{
    return {
        x: roughCoordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5,
        y: roughCoordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5
    };
};
const $a80d0b17b615d6f7$export$c5c39d6b5122006f = (roughCoordinate, target)=>{
    target.x = $a80d0b17b615d6f7$export$87a4e8763dcd88c7(roughCoordinate.x) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5;
    target.y = $a80d0b17b615d6f7$export$87a4e8763dcd88c7(roughCoordinate.y) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5;
};
const $a80d0b17b615d6f7$export$ec6726e81e6754f2 = (roughCoordinate)=>{
    const fine = $a80d0b17b615d6f7$export$b03ec757ccd6a9ce();
    $a80d0b17b615d6f7$export$131bd9752b097096(roughCoordinate, fine);
    return fine;
};
const $a80d0b17b615d6f7$export$87a4e8763dcd88c7 = (i)=>i * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $a80d0b17b615d6f7$export$131bd9752b097096 = (roughCoordinate, target)=>{
    target.x = roughCoordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    target.y = roughCoordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
};
const $a80d0b17b615d6f7$export$2cb771f4116b60f3 = (location, radius)=>{
    return {
        x: Math.floor(location.x + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? 1 : -1) * (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, radius)),
        y: Math.floor(location.y + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? 1 : -1) * (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, radius))
    };
};
const $a80d0b17b615d6f7$export$eccbbeaacc82d907 = (bounds, dimension, budget, useRng)=>{
    const start = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    while((0, $4171652afd996934$export$a86190deb5c4a8d0)() - start < budget){
        const coordinate = $a80d0b17b615d6f7$export$b1a407392a6eb119(bounds, useRng);
        const candidate = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(coordinate.x, coordinate.y, coordinate.x + dimension.w, coordinate.y + dimension.h);
        if (bounds.encloses(candidate)) return candidate;
    }
    return null;
};
const $a80d0b17b615d6f7$export$64fb0fba146182ff = (num)=>{
    return Math.ceil(num / 100) * 100;
};
const $a80d0b17b615d6f7$export$454f7a24b1943800 = (a, b)=>{
    const x = a.x - b.x;
    const y = a.y - b.y;
    return `${x === 0 ? "0" : x < 0 ? "-" : "+"}|${y === 0 ? "0" : y < 0 ? "-" : "+"}`;
};
const $a80d0b17b615d6f7$export$a18495c0c5dcb80c = (location, radius)=>{
    const angle = Math.random() * Math.PI * 2;
    const x = Math.floor(Math.cos(angle) * radius);
    const y = Math.floor(Math.sin(angle) * radius);
    return {
        x: x + location.x,
        y: y + location.y
    };
};
const $a80d0b17b615d6f7$export$44b8c8315ca17d53 = (location, radius, numberOfPoints)=>{
    const centerX = location.x;
    const centerY = location.y;
    const theta = 2.0 * Math.PI / numberOfPoints;
    const points = [];
    for(let i = 1; i <= numberOfPoints; i++){
        const pointX = radius * Math.cos(theta * i) + centerX;
        const pointY = radius * Math.sin(theta * i) + centerY;
        points.push({
            x: pointX,
            y: pointY
        });
    }
    return points;
};
const $a80d0b17b615d6f7$export$dfd5a2436df79788 = (location, dimensions, numberOfPoints)=>{
    const totalArea = dimensions.w * dimensions.h;
    const pointArea = totalArea / numberOfPoints;
    const length = Math.sqrt(pointArea);
    const points = [];
    for(let i = length / 2; i < dimensions.w; i += length)for(let j = length / 2; j < dimensions.h; j += length){
        const x = location.x - dimensions.w / 2 + i;
        const y = location.y - dimensions.h / 2 + j;
        points.push({
            x: x,
            y: y
        });
    }
    return points;
};
const $a80d0b17b615d6f7$export$fa7d4ea13578a55a = (location, dimensions, numberOfPoints)=>{
    const centerX = location.x;
    const centerY = location.y;
    const points = [];
    const perSide = Math.ceil(numberOfPoints / 4);
    // top / bottom
    for(let x = centerX - dimensions.w / 2; x < centerX + dimensions.w / 2; x += dimensions.w / perSide){
        points.push({
            x: x,
            y: centerY - dimensions.h / 2
        });
        points.push({
            x: x,
            y: centerY + dimensions.h / 2
        });
    }
    // left / right
    for(let y = centerY - dimensions.h / 2; y < centerY + dimensions.h / 2; y += dimensions.h / perSide){
        points.push({
            x: centerX - dimensions.w / 2,
            y: y
        });
        points.push({
            x: centerX + dimensions.w / 2,
            y: y
        });
    }
    return points;
};
const $a80d0b17b615d6f7$export$7072e7f224c70dc0 = (roomId, worldMetaDimensions)=>{
    const [_, roomX, roomY] = roomId.split("-");
    const x = Number(roomX);
    const y = Number(roomY);
    return {
        x: Math.floor(x / worldMetaDimensions.quadrantWidth),
        y: Math.floor(y / worldMetaDimensions.quadrantHeight)
    };
};
const $a80d0b17b615d6f7$export$b3cc75d7f0e8e565 = (coordinate)=>`${coordinate.x}-${coordinate.y}`;
const $a80d0b17b615d6f7$export$4418bd227bd6a76a = (roomId, worldDimensions)=>{
    if (!roomId.startsWith("room")) return roomId;
    return $a80d0b17b615d6f7$export$b3cc75d7f0e8e565($a80d0b17b615d6f7$export$7072e7f224c70dc0(roomId, worldDimensions));
};
const $a80d0b17b615d6f7$export$be3fee91976fb47a = (str)=>{
    if (!str || !str.includes("-")) return {
        x: 0,
        y: 0
    };
    const parts = str.split("-").map((n)=>Number(n));
    return {
        x: parts[0],
        y: parts[1]
    };
};
const $a80d0b17b615d6f7$export$5b9a5a61c784012a = (location, d)=>{
    if ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)()) return {
        x: location.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-d.w / 2, d.w / 2),
        y: location.y + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? d.h / 2 : -d.h / 2)
    };
    else return {
        x: location.x + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? d.w / 2 : -d.w / 2),
        y: location.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-d.h / 2, d.h / 2)
    };
};
const $a80d0b17b615d6f7$export$dd04b5c066c4f0ff = (region)=>{
    const x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, region.bounds.width);
    const y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, region.bounds.height);
    return {
        x: x + region.x,
        y: y + region.y
    };
};
const $a80d0b17b615d6f7$export$b1a407392a6eb119 = (bounds, useRng)=>{
    const fnToUs = useRng ? $a80d0b17b615d6f7$export$c45e8adbbf82647d : (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18);
    const x = fnToUs(0, bounds.width);
    const y = fnToUs(0, bounds.height);
    return {
        x: x + bounds.x1,
        y: y + bounds.y1
    };
};
const $a80d0b17b615d6f7$export$333251a5a08cdd5d = (radius, callback)=>{
    for(let i = 1; i <= radius; i++){
        const r2 = i * i;
        for(let dx = -radius; dx <= radius; dx++){
            const h = Math.sqrt(r2 - dx * dx) | 0;
            for(let dy = -h; dy <= h; dy++)callback(dx, dy);
        }
    }
};
const $a80d0b17b615d6f7$export$8971db114e4d5869 = (width, height, callback)=>{
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++)callback(x, y);
};
const $a80d0b17b615d6f7$export$9387b5218de27719 = (n)=>{
    return isNaN(n) ? 0 : n;
};
const $a80d0b17b615d6f7$export$248d38f6296296c5 = (p1, p2, rounded = false)=>{
    if (p1 && !p2) return false;
    if (!p1 && p2) return false;
    if (!p1 && !p2) return true;
    if (!rounded) return p1.x === p2.x && p1.y === p2.y;
    return Math.floor(p1.x) === Math.floor(p2.x) && Math.floor(p1.y) === Math.floor(p2.y);
};
const $a80d0b17b615d6f7$export$d7b8fa4fd9c116de = $a80d0b17b615d6f7$export$248d38f6296296c5;
const $a80d0b17b615d6f7$export$86507ea8237b37e = ()=>{
    return (0, $cb689cfa16c444ba$export$86ae6e8ac17a67c6)[(0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, (0, $cb689cfa16c444ba$export$86ae6e8ac17a67c6).length - 1)];
};
const $a80d0b17b615d6f7$export$816c81660958f502 = (coordinate, direction, increment)=>{
    switch(direction){
        case "Up":
            coordinate.y -= increment;
            break;
        case "Down":
            coordinate.y += increment;
            break;
        case "Left":
            coordinate.x -= increment;
            break;
        case "Right":
            coordinate.x += increment;
            break;
        case "UpLeft":
            coordinate.x -= increment;
            coordinate.y -= increment;
            break;
        case "DownLeft":
            coordinate.x -= increment;
            coordinate.y += increment;
            break;
        case "UpRight":
            coordinate.x += increment;
            coordinate.y -= increment;
            break;
        case "DownRight":
            coordinate.x += increment;
            coordinate.y += increment;
            break;
    }
};
const $a80d0b17b615d6f7$export$81000cfff8ea05de = (a, b)=>{
    if (!a || !b) return null;
    return $a80d0b17b615d6f7$export$36659eeff558d70a(a.x, a.y, b.x, b.y);
};
const $a80d0b17b615d6f7$export$36659eeff558d70a = (aX, aY, bX, bY)=>{
    if (aX === bX && aY === bY) return null;
    if (aX === bX) {
        if (aY < bY) return "Down";
        else return "Up";
    }
    if (aY === bY) {
        if (aX > bX) return "Left";
        else return "Right";
    }
    if (aX > bX && aY < bY) return "DownLeft";
    if (aX > bX && aY > bY) return "UpLeft";
    if (aX < bX && aY < bY) return "DownRight";
    if (aX < bX && aY > bY) return "UpRight";
    return null;
};
const $a80d0b17b615d6f7$export$26a7d0ff90c06062 = (coordinate)=>{
    if (!coordinate) return;
    return {
        x: Math.floor(coordinate.x),
        y: Math.floor(coordinate.y)
    };
};
const $a80d0b17b615d6f7$export$42481bb7a9507ce8 = (coordinate, target)=>{
    if (!coordinate || !target) return;
    target.x = Math.floor(coordinate.x);
    target.y = Math.floor(coordinate.y);
};
const $a80d0b17b615d6f7$export$1fea460ac49b9e42 = (oldLocation, newLocation, dir, dist, fine = false)=>{
    const multiplier = !fine ? (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 1;
    $a80d0b17b615d6f7$export$5afd74d1b598607d(oldLocation, newLocation);
    switch(dir){
        case "Up":
            newLocation.y = Math.floor(oldLocation.y + multiplier * -dist);
            return;
        case "Down":
            newLocation.y = Math.floor(oldLocation.y + multiplier * dist);
            return;
        case "Left":
            newLocation.x = Math.floor(oldLocation.x + multiplier * -dist);
            return;
        case "Right":
            newLocation.x = Math.floor(oldLocation.x + multiplier * dist);
            return;
        case "UpLeft":
            newLocation.x = Math.floor(oldLocation.x + multiplier * -dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * -dist);
            return;
        case "UpRight":
            newLocation.x = Math.floor(oldLocation.x + multiplier * dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * -dist);
            return;
        case "DownLeft":
            newLocation.x = Math.floor(oldLocation.x + multiplier * -dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * dist);
            return;
        case "DownRight":
            newLocation.x = Math.floor(oldLocation.x + multiplier * dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * dist);
            return;
    }
};
class $a80d0b17b615d6f7$export$6cbae62f94a3133d {
    constructor({ durationWindow: durationWindow = 10000, label: label, average: average }){
        this.readings = 0;
        this.latest = 0;
        this.count = 0;
        /** `now` is an optional already-taken clock reading -- see Latch.expired. */ this.offer = (value, now)=>{
            this.readings += value;
            this.count++;
            if (this.latch.expired(true, now)) {
                const averageOverDuration = this.average ? Math.round(this.readings / this.count) : Math.round(this.readings / (this.durationWindow / 1000));
                // clear readings
                this.readings = 0;
                this.count = 0;
                this.latest = averageOverDuration;
                return averageOverDuration;
            }
            return null;
        };
        this.emitMessage = ()=>{
            console.log(this.average ? `${this.label} average: ${this.latest} / ${this.durationWindow / 1000} sec window` : `${this.label} thruput: ${this.latest} /sec`);
        };
        this.durationWindow = durationWindow;
        this.latch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(durationWindow, (0, $4171652afd996934$export$a86190deb5c4a8d0)());
        this.label = label;
        this.average = average;
    }
}
class $a80d0b17b615d6f7$export$336b4c97e7741c1a {
    constructor(v){
        this.set = (v)=>this.v = v;
        this.get = ()=>this.v;
        this.v = v;
    }
}
const $a80d0b17b615d6f7$export$81c40ebfe660d3ca = (array, terminates, index)=>{
    index = index || new $a80d0b17b615d6f7$export$336b4c97e7741c1a(-1);
    return {
        next: ()=>{
            if (array.length < 1) return {
                value: undefined,
                done: true
            };
            index.set(index.get() + 1);
            if (!terminates) {
                if (index.get() > array.length - 1) index.set(0);
                return {
                    value: array[index.get()],
                    done: false
                };
            } else {
                if (index.get() > array.length - 1) return {
                    value: undefined,
                    done: true
                };
                return {
                    value: array[index.get()],
                    done: false
                };
            }
        }
    };
};
class $a80d0b17b615d6f7$export$37a78dc06a7d1e2e {
    constructor(values, terminates = true){
        this.reset = ()=>{
            this.index.set(-1);
        };
        this.add = (item)=>{
            this.values.push(item);
            this.iterator = $a80d0b17b615d6f7$export$81c40ebfe660d3ca(this.values, this.terminates, this.index);
            this.reset();
        };
        this.remove = (item)=>{
            this.values = this.values.filter((next)=>next !== item);
            this.iterator = $a80d0b17b615d6f7$export$81c40ebfe660d3ca(this.values, this.terminates, this.index);
            this.reset();
        };
        this.next = ()=>{
            return this.iterator.next();
        };
        this.index = new $a80d0b17b615d6f7$export$336b4c97e7741c1a(-1);
        this.terminates = terminates;
        this.values = values;
        this.iterator = $a80d0b17b615d6f7$export$81c40ebfe660d3ca(values, terminates, this.index);
    }
}
const $a80d0b17b615d6f7$export$81e29c5651a28578 = (val)=>{
    if (val === "true") return true;
    if (val === "false") return false;
    if (val === "") return val;
    const nan = isNaN(Number(val));
    if (!nan) return parseInt(val);
    // its a string
    return val;
};
const $a80d0b17b615d6f7$export$e37b4dbfadf1f2de = (list, options)=>{
    if (!list || list.length < 0) return;
    const min = 0 + (options?.leftBoundIdx || 0);
    const max = list.length - 1 - (options?.rightBoundIdx || 0);
    if (options?.rngFn) {
        const pos = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(min, max, {
            rngFn: options.rngFn
        });
        return list[pos];
    }
    const rndFunctionToUse = options?.randomIntBetween ? options.randomIntBetween : (min, max)=>(0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(min, max, options);
    const pos = rndFunctionToUse(min, max);
    return list[pos];
};
function $a80d0b17b615d6f7$export$7ac3a88d34a76e7(array) {
    for(let i = array.length - 1; i > 0; i--){
        // Pick a random index from 0 to i
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
    return array;
}
function $a80d0b17b615d6f7$export$d2520d12c9d147e4(inputArray, process, timeLimitMs, limit) {
    const startTime = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    const collectorArray = [];
    // Function to check if the time limit has been reached
    const timeLimitReached = ()=>(0, $4171652afd996934$export$a86190deb5c4a8d0)() - startTime >= timeLimitMs;
    while(inputArray.length > 0 && !timeLimitReached() && collectorArray.length < limit){
        // Pick a random index from the input array
        const randomIndex = Math.floor(Math.random() * inputArray.length);
        // Extract the element at the random index
        const [element] = inputArray.splice(randomIndex, 1);
        // Execute the process function on the extracted element
        if (process(element)) // If process returns true and we haven't reached the limit, add the element to the collector array
        collectorArray.push(element);
    // The loop will continue until the input array is exhausted, the time limit is reached, or the collector array reaches the specified limit.
    }
    return collectorArray;
}
const $a80d0b17b615d6f7$export$b8b3234b4edfc4c2 = (src, str, newStr)=>{
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === "[object regexp]") return src.replace(str, newStr);
    // If a string
    return src.replace(new RegExp(str, "g"), newStr);
};
const $a80d0b17b615d6f7$export$dde5f197d352347c = (flt)=>flt * 100;
const $a80d0b17b615d6f7$export$4fece460db87ee7b = (width, height, blankValue)=>{
    const matrix = [];
    for(let x = 0; x < width; x++){
        const column = [];
        matrix.push(column);
        for(let y = 0; y < height; y++)column.push(blankValue);
    }
    return matrix;
};
const $a80d0b17b615d6f7$export$edde49207b897324 = (str = "", lineLength)=>{
    const arr = [
        ""
    ];
    str.split(" ").forEach((word)=>{
        if (arr[arr.length - 1].length + word.length > lineLength) arr.push("");
        arr[arr.length - 1] += word + " ";
    });
    return arr.map((v)=>v.trim());
};
const $a80d0b17b615d6f7$export$76d90c956114f2c2 = (fn, times)=>{
    const returned = [];
    for(let i = 0; i < times; i++){
        const val = fn();
        if (val) returned.push(val);
    }
    return returned;
};
const $a80d0b17b615d6f7$export$cefb40c9962541b5 = (str, amt)=>amt > 1 ? `${str}s` : `${str}`;
const $a80d0b17b615d6f7$export$9a00dee1beb8f576 = (str)=>str.charAt(0).toUpperCase() + str.substring(1);
const $a80d0b17b615d6f7$export$32ed0561867ec8a1 = (src, other)=>{
    other.forEach((o)=>src.push(o));
};
const $a80d0b17b615d6f7$export$f416efe173c6901c = (src = [])=>{
    const set = new Set();
    src.forEach((t)=>set.add(t));
    return set;
};
const $a80d0b17b615d6f7$export$ab4dce56041c583d = (str)=>str ? JSON.parse(str) : undefined;
const $a80d0b17b615d6f7$export$5e699d18035b41af = (0, $87befc68df50040c$export$2e2bcd8739ae039);
const $a80d0b17b615d6f7$export$c0cc6ee9538309d2 = (arr)=>arr?.length > 0 ? arr[0] : null;
const $a80d0b17b615d6f7$export$9a81a17686f0f9cf = (0, $f93bb81604774744$export$5d832d6580b26c5);
const $a80d0b17b615d6f7$export$bf81c9a7c069ded7 = (str)=>{
    return str.replace(/\s+/gi, "-").replace(/[^a-z0-9]/gi, "");
};
const $a80d0b17b615d6f7$export$9cb4719e2e525b7a = (a, b)=>{
    if (a === b) return true;
    if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) return false;
    const keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!keysB.includes(key) || !$a80d0b17b615d6f7$export$9cb4719e2e525b7a(a[key], b[key])) return false;
    }
    return true;
};
const $a80d0b17b615d6f7$export$a132fd33caa05413 = (obj, processFn)=>{
    return JSON.parse(processFn(JSON.stringify(obj)));
};
const $a80d0b17b615d6f7$export$f2101ed45d400a36 = (location)=>{
    return `${location.roomId}/${location.x}/${location.y}`;
};
const $a80d0b17b615d6f7$export$4a09470303eb5fc5 = (start, end, distance)=>{
    // Calculate the direction vector (dx, dy)
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    // Calculate the length of the vector
    const length = Math.sqrt(dx * dx + dy * dy);
    // Normalize the vector to get the unit vector
    const ux = dx / length;
    const uy = dy / length;
    // Scale the unit vector by the desired distance
    const vx = ux * distance;
    const vy = uy * distance;
    // Calculate the target coordinate
    const targetX = start.x + vx;
    const targetY = start.y + vy;
    return {
        x: Math.floor(targetX),
        y: Math.floor(targetY)
    };
};
const $a80d0b17b615d6f7$export$7758e9150891e0a1 = (start, angleRadians, distance)=>{
    // Calculate the change in x and y using the angle in radians
    const dx = Math.cos(angleRadians) * distance;
    const dy = Math.sin(angleRadians) * distance;
    // Calculate the new coordinate
    const newX = start.x + dx;
    const newY = start.y + dy;
    return {
        x: Math.floor(newX),
        y: Math.floor(newY)
    };
};
const $a80d0b17b615d6f7$export$dde4c7d71e75ad22 = (locationStr)=>{
    if (locationStr) {
        const [roomId, xStr, yStr] = locationStr.split("/");
        return {
            roomId: roomId,
            x: Number(xStr),
            y: Number(yStr)
        };
    }
};
const $a80d0b17b615d6f7$export$ef8d2ed002d536c3 = (x)=>{
    if (Array.isArray(x)) return x;
    return [
        x
    ];
};
function $a80d0b17b615d6f7$var$isNumber(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}
const $a80d0b17b615d6f7$export$b001a87b1518a69d = (str)=>{
    if (typeof str === "object") return str;
    if (!str) return;
    if ($a80d0b17b615d6f7$var$isNumber(str)) return undefined;
    try {
        return JSON.parse(str);
    } catch (e) {}
};
const $a80d0b17b615d6f7$export$ded26c9c1231eee6 = (center, points, directionMap)=>{
    const results = [];
    for (const point of points){
        // Calculate angle from center to point
        const angleRadians = Math.atan2(point.y - center.y, point.x - center.x);
        const angleDegrees = $a80d0b17b615d6f7$export$32b1497b7aadef08(angleRadians);
        // Normalize angle to 0-360 range
        const normalizedAngle = angleDegrees < 0 ? angleDegrees + 360 : angleDegrees;
        // Find the closest direction
        let closestDirection = "";
        let smallestDifference = 360;
        for (const [direction, info] of Object.entries(directionMap)){
            const difference = Math.abs(normalizedAngle - info.angle);
            const wrappedDifference = Math.min(difference, 360 - difference);
            if (wrappedDifference < smallestDifference) {
                smallestDifference = wrappedDifference;
                closestDirection = direction;
            }
        }
        results.push({
            point: point,
            direction: closestDirection,
            directionInfo: directionMap[closestDirection]
        });
    }
    return results;
};


class $22a1b96ddeb2d28f$export$90f229f3a0c9abea extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $22a1b96ddeb2d28f$export$90f229f3a0c9abea();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: {
                adjust: {
                    x: -1,
                    y: -1
                },
                collided: false,
                collision: {
                    x: -1,
                    y: -1
                },
                intersection: {
                    x: -1,
                    y: -1,
                    intersectionType: ""
                }
            }
        };
    }
    clear(item) {
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.adjust);
        item.data.collided = false, (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.collision);
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.intersection);
        item.data.intersection.intersectionType = "";
    }
}



class $044ce6b9ee544b01$export$ca8a4d4f8adbc954 extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $044ce6b9ee544b01$export$ca8a4d4f8adbc954();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: {
                x: -1,
                y: -1
            }
        };
    }
    clear(item) {
        item.data.x = -1;
        item.data.y = -1;
    }
}


/**
 * GENERATED from lpc/sprite_registry.json -- do not edit.
 *
 * Which colours each component comes in -- a fact about the art on disk, not a decision, which
 * is why it is generated and the `*Types` arrays beside it are not: their order and grouping
 * (humanoids first) mean something. `character.ts` derives its colour tables from this; run
 * `yarn compile:lpc` (from packages/tools) after changing the registry, or let the sprite lab
 * do it. `yarn compile:lpc --check` fails if this and the registry disagree.
 *
 * No imports, deliberately: character.ts imports this, so anything imported here would close a
 * cycle through the whole of common. The check that these are real colours lives there.
 */ const $e33bbc24f0896ffc$export$cb418cdf24d0dd3e = {
    "armor": {
        "armor-leather": [
            "blue",
            "brown",
            "green"
        ],
        "armor-legion": [
            "brown",
            "gray",
            "gold"
        ],
        "armor-plate": [
            "gray",
            "metal",
            "yellow",
            "gold",
            "orange",
            "tan"
        ]
    },
    "bauldron": {
        "bauldron": [
            "brown"
        ]
    },
    "body": {
        "bee": [
            "yellow"
        ],
        "chicken": [
            "white"
        ],
        "deer": [
            "brown"
        ],
        "horse": [
            "brown"
        ],
        "human": [
            "white",
            "black",
            "olive",
            "brown",
            "light",
            "dark",
            "tan"
        ],
        "orc": [
            "gray",
            "green",
            "lightgreen"
        ],
        "rabbit": [
            "white"
        ],
        "redspider": [
            "red"
        ],
        "reptile": [
            "green",
            "lightgreen",
            "blue"
        ],
        "reptile-winged": [
            "green",
            "lightgreen",
            "blue"
        ],
        "skeleton": [
            "white",
            "gray",
            "green"
        ],
        "slime": [
            "green"
        ],
        "snake": [
            "green"
        ],
        "spikes1": [
            "white"
        ],
        "wasp": [
            "yellow"
        ],
        "wolfman": [
            "brown",
            "black",
            "gray",
            "white"
        ],
        "zombie": [
            "green"
        ]
    },
    "cape": {
        "cape-solid": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "red",
            "white",
            "yellow"
        ],
        "cape-tattered": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "red",
            "white",
            "yellow"
        ],
        "cape-trimmed": [
            "white"
        ]
    },
    "eyes": {
        "cyclops": [
            "red"
        ],
        "normal": [
            "blue",
            "brown",
            "gray",
            "green",
            "orange",
            "purple",
            "red",
            "yellow"
        ]
    },
    "hair": {
        "afro": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "balding": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bangs": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bangs_bun": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bangslong": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bangslong2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bangsshort": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bedhead": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bob": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bob_side_part": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "braid": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "braid2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "bunches": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "buzzcut": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "cornrows": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "cowlick": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "cowlick_tall": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "curly_long": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "curly_short": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "curtains": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "curtains_long": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "dreadlocks_long": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "dreadlocks_short": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "flat_top_fade": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "flat_top_straight": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "half_up": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "halfmessy": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "high_and_tight": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "high_ponytail": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "idol": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "jewfro": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "lob": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "long": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "long_band": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "long_center_part": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "long_messy": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "long_messy2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "long_tied": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "longhawk": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "longknot": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "loose": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "messy1": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "messy2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "messy3": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "mop": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "natural": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "page": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "page2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "part2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "parted": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "pixie": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "plain": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "ponytail": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "ponytail2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "princess": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "sara": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "shorthawk": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "shortknot": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "shoulderl": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "shoulderr": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "single": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "spiked": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "spiked2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "spiked_beehive": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "spiked_liberty": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "spiked_liberty2": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "spiked_porcupine": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "swoop": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "twists_fade": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "twists_straight": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "unkempt": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "wavy": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ],
        "xlong": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
        ]
    },
    "nose": {
        "big": [
            "white",
            "tan",
            "gray"
        ],
        "button": [
            "white",
            "tan",
            "gray"
        ],
        "straight": [
            "white",
            "tan",
            "gray"
        ]
    },
    "pants": {
        "legion": [
            "brown"
        ],
        "pantaloons": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "orange",
            "purple",
            "red",
            "tan",
            "white",
            "yellow"
        ],
        "pants": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "orange",
            "purple",
            "red",
            "tan",
            "white",
            "yellow"
        ],
        "pants-armor": [
            "gray",
            "metal",
            "yellow",
            "gold",
            "tan",
            "orange"
        ],
        "skirts": [
            "brown",
            "black",
            "white"
        ]
    },
    "shield": {
        "shield-crusader": [
            "white"
        ],
        "shield-kite": [
            "gray",
            "orange"
        ],
        "shield-kite_blue": [
            "blue",
            "gray"
        ],
        "shield-kite_gray": [
            "blue",
            "gray",
            "green",
            "orange"
        ],
        "shield-kite_green": [
            "gray"
        ],
        "shield-kite_red": [
            "gray"
        ],
        "shield-round": [
            "black",
            "brown",
            "gold",
            "green",
            "silver",
            "yellow"
        ],
        "shield-spartan": [
            "brown"
        ]
    },
    "shirt": {
        "blouse": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
        ],
        "blouse_longsleeve": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
        ],
        "corset": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
        ],
        "longsleeve": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow"
        ],
        "longsleeve_laced": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
        ],
        "scoop_shirt": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "gray",
            "orange"
        ],
        "sleeveless": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
        ],
        "sleeveless_laced": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
        ],
        "sleeveless_striped": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
        ],
        "tanktop": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
        ],
        "tunic": [
            "brown",
            "maroon",
            "teal",
            "white"
        ]
    },
    "shoes": {
        "boots": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "orange",
            "purple",
            "red",
            "tan",
            "teal",
            "white",
            "yellow"
        ],
        "sandals": [
            "brown"
        ],
        "shoes": [
            "black",
            "brown",
            "maroon"
        ],
        "shoes-armor": [
            "gray",
            "metal",
            "yellow",
            "gold",
            "tan",
            "orange"
        ],
        "slippers": [
            "black",
            "brown",
            "gray"
        ]
    },
    "weapon": {
        "axe": [
            "metal"
        ],
        "bow": [
            "brown"
        ],
        "crossbow": [
            "brown"
        ],
        "dagger": [
            "metal",
            "brown"
        ],
        "flail": [
            "metal"
        ],
        "halberd": [
            "metal"
        ],
        "longsword": [
            "metal"
        ],
        "mace": [
            "metal"
        ],
        "none": [],
        "rapier": [
            "metal"
        ],
        "saber": [
            "metal"
        ],
        "scythe": [
            "metal"
        ],
        "spear": [
            "brown",
            "black",
            "green",
            "metal",
            "purple"
        ],
        "staff": [
            "brown"
        ],
        "waraxe": [
            "metal"
        ],
        "warhammer": [
            "metal"
        ],
        "web": [
            "white"
        ]
    }
};


const $bf6244e5cc9aa116$export$2a4812914c68f73e = [
    "human",
    "reptile",
    "reptile-winged",
    "orc",
    "skeleton",
    "wolfman",
    "zombie"
];
const $bf6244e5cc9aa116$export$46125ee88f7f0638 = [
    ...$bf6244e5cc9aa116$export$2a4812914c68f73e,
    "horse",
    "snake",
    "deer",
    "slime",
    "rabbit",
    "chicken",
    "bee",
    "wasp",
    "redspider",
    "spikes1"
];
const $bf6244e5cc9aa116$export$32cdec3d782e201f = [
    "male",
    "female"
];
const $bf6244e5cc9aa116$export$1625117e6bf800e7 = {
    human: [
        "male",
        "female"
    ],
    reptile: [
        "male",
        "female"
    ],
    "reptile-winged": [
        "male",
        "female"
    ],
    orc: [
        "male",
        "female"
    ],
    wolfman: [
        "male",
        "female"
    ],
    zombie: [
        "male"
    ],
    skeleton: [
        "male"
    ],
    horse: [
        "male"
    ],
    snake: [
        "male"
    ],
    slime: [
        "male"
    ],
    rabbit: [
        "male"
    ],
    deer: [
        "female"
    ],
    chicken: [
        "male"
    ],
    bee: [
        "male"
    ],
    wasp: [
        "male"
    ],
    redspider: [
        "male"
    ],
    spikes1: [
        "male"
    ]
};
const $bf6244e5cc9aa116$export$4eb09b1c0a6dec24 = [
    "white",
    "blonde",
    "yellow",
    "light",
    "lightgreen",
    "gold",
    "green",
    "teal",
    "blue",
    "orange",
    "maroon",
    "red",
    "purple",
    "olive",
    "tan",
    "lightbrown",
    "brown",
    "dark",
    "gray",
    "silver",
    "metal",
    "pink",
    "black",
    "na"
];
/**
 * The colour tables below are DERIVED from the sprite registry, not written here.
 *
 * Which colours a component comes in is a fact about the art on disk, and keeping it by hand is
 * what made importing a new colour a code change in three places. `sprite_colors.generated.ts`
 * is produced from `lpc/sprite_registry.json` by `yarn compile:lpc`; edit the registry (or use
 * the sprite lab) and regenerate.
 *
 * What stays hand-written, and why:
 *
 * - **`Color`** is the vocabulary. Naming a new colour is a decision, and the guard below means
 *   the data cannot invent one.
 * - **The `*Types` arrays.** Their order and grouping carry meaning -- `RaceTypes` puts the
 *   humanoids first because `HumanoidRaceTypes` is a prefix of it -- which a generator sorting
 *   keys would quietly destroy.
 * - **The `Sex*` tables.** Which sex is offered which garment is a design choice, not art.
 */ /** Widen one slot's readonly literal tuples to the `Color[]` every caller already expects. */ const $bf6244e5cc9aa116$var$derive = (table)=>Object.keys(table).reduce((out, key)=>{
        out[key] = [
            ...table[key]
        ];
        return out;
    }, {});
const $bf6244e5cc9aa116$export$af1b56af8a451d06 = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).body);
const $bf6244e5cc9aa116$export$d45f4a0015a82408 = [
    "normal",
    "cyclops"
];
const $bf6244e5cc9aa116$export$ffaabf2abfa69206 = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).eyes);
const $bf6244e5cc9aa116$export$a64d361fad6262d3 = [
    "button",
    "big",
    "straight"
];
const $bf6244e5cc9aa116$var$commonNoseColor = [
    "white",
    "tan",
    "gray"
];
const $bf6244e5cc9aa116$export$f5fdec393d34621 = {
    ...$bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).nose),
    // "none" is a Nose, not a component: it means the slot is empty, and the
    // forge returns no sheets for it. The art has nothing to say about it.
    none: []
};
const $bf6244e5cc9aa116$export$523e552deae170d8 = {
    human: [
        "big",
        "button",
        "straight"
    ],
    reptile: [],
    "reptile-winged": [],
    orc: [
        "big",
        "button",
        "straight"
    ],
    skeleton: [
        "big",
        "button",
        "straight"
    ],
    wolfman: [],
    zombie: [
        "big",
        "button",
        "straight"
    ]
};
const $bf6244e5cc9aa116$export$4f6565fe06691e22 = {
    human: [
        "normal"
    ],
    orc: [
        "normal"
    ],
    skeleton: [
        "normal"
    ],
    zombie: [
        "normal"
    ]
};
const $bf6244e5cc9aa116$export$45b2c5ee636d8393 = [
    "dagger",
    "spear",
    "bow",
    "crossbow",
    "staff",
    "axe",
    "warhammer",
    "longsword",
    "mace",
    "rapier",
    "saber",
    "scythe",
    "flail",
    "halberd",
    "waraxe",
    "web",
    "none"
];
const $bf6244e5cc9aa116$var$commonWeapons = [
    "spear",
    "bow",
    "staff",
    "axe",
    "warhammer",
    "none"
];
const $bf6244e5cc9aa116$export$448f4eb18cb556ce = {
    dagger: "slash",
    longsword: "slash",
    flail: "slash",
    halberd: "slash",
    waraxe: "slash",
    rapier: "slash",
    mace: "slash",
    saber: "slash",
    scythe: "slash",
    spear: "thrust",
    bow: "shoot",
    crossbow: "thrust",
    staff: "thrust",
    axe: "slash",
    warhammer: "slash",
    none: "slash",
    web: "shoot"
};
const $bf6244e5cc9aa116$export$3f4c28cf92a4cf37 = {
    bow: "arrow",
    crossbow: "arrow",
    web: "webAmmo"
};
const $bf6244e5cc9aa116$export$489aea052d2c5de8 = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).weapon);
const $bf6244e5cc9aa116$export$cd29cf568087531c = {
    human: [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ],
    reptile: [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ],
    "reptile-winged": [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ],
    orc: [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ],
    wolfman: [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ],
    skeleton: [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ],
    zombie: [
        ...$bf6244e5cc9aa116$var$commonWeapons
    ]
};
const $bf6244e5cc9aa116$export$2eff43e195cfa29d = {
    snake: "thrust",
    slime: "thrust",
    wasp: "thrust",
    redspider: "thrust",
    skeleton: "thrust",
    zombie: "slash",
    spikes1: "thrust"
};
const $bf6244e5cc9aa116$export$abac18ec637a6d99 = [
    "afro",
    "balding",
    "bangs",
    "bangs_bun",
    "bangslong",
    "bangslong2",
    "bangsshort",
    "bedhead",
    "bob",
    "bob_side_part",
    "braid",
    "braid2",
    "bunches",
    "buzzcut",
    "cornrows",
    "cowlick",
    "cowlick_tall",
    "curly_long",
    "curly_short",
    "curtains",
    "curtains_long",
    "dreadlocks_long",
    "dreadlocks_short",
    "flat_top_fade",
    "flat_top_straight",
    "half_up",
    "halfmessy",
    "high_and_tight",
    "high_ponytail",
    "idol",
    "jewfro",
    "lob",
    "long",
    "long_band",
    "long_center_part",
    "long_messy",
    "long_messy2",
    "long_tied",
    "longhawk",
    "longknot",
    "loose",
    "messy1",
    "messy2",
    "messy3",
    "mop",
    "natural",
    "page",
    "page2",
    "part2",
    "parted",
    // // "pigtails",
    // // "pigtails_bangs",
    "pixie",
    "plain",
    "ponytail",
    "ponytail2",
    "princess",
    "sara",
    "shorthawk",
    "shortknot",
    "shoulderl",
    "shoulderr",
    "single",
    "spiked",
    "spiked2",
    "spiked_beehive",
    "spiked_liberty",
    "spiked_liberty2",
    "spiked_porcupine",
    "swoop",
    "twists_fade",
    "twists_straight",
    "unkempt",
    "wavy",
    "xlong"
];
const $bf6244e5cc9aa116$var$commonHairColor = [
    "white",
    "blonde",
    "gold",
    "green",
    "blue",
    "red",
    "orange",
    "purple",
    "brown",
    "lightbrown",
    "gray",
    "black"
];
const $bf6244e5cc9aa116$export$c2ef2c5bddebe408 = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).hair);
const $bf6244e5cc9aa116$export$46ee3469290462e6 = {
    male: [
        ...$bf6244e5cc9aa116$export$abac18ec637a6d99.filter((hair)=>![
                "bob",
                "bob_side_part",
                "braid",
                "braid2",
                "bunches",
                "curly_long",
                "long_band",
                // "pigtails",
                // "pigtails_bang",
                "princess",
                "sara",
                "shoulderl",
                "shoulderr",
                "xlong"
            ].includes(hair))
    ],
    female: [
        ...$bf6244e5cc9aa116$export$abac18ec637a6d99.filter((hair)=>![
                "balding"
            ].includes(hair))
    ]
};
const $bf6244e5cc9aa116$export$f984f9e37c2404ad = [
    "pants-armor",
    "pants",
    "pantaloons",
    "legion",
    "skirts"
];
const $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3 = {
    male: [
        "pants-armor",
        "pants",
        "pantaloons",
        "legion",
        "skirts"
    ],
    female: [
        "pants-armor",
        "pants",
        "legion",
        "skirts"
    ]
};
const $bf6244e5cc9aa116$export$7ef85edc405cda8b = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).pants);
const $bf6244e5cc9aa116$export$16d380a34afbfbed = [
    "blouse",
    "blouse_longsleeve",
    "corset",
    "longsleeve",
    "longsleeve_laced",
    // "robe",
    "scoop_shirt",
    "sleeveless",
    "sleeveless_laced",
    "sleeveless_striped",
    "tanktop",
    "tunic"
];
const $bf6244e5cc9aa116$export$6e1561754c81021d = {
    male: [
        "longsleeve",
        "longsleeve_laced",
        "sleeveless",
        "sleeveless_laced",
        "sleeveless_striped"
    ],
    female: [
        "blouse",
        "blouse_longsleeve",
        "corset",
        "longsleeve",
        // "robe",
        "scoop_shirt",
        "tanktop",
        "tunic"
    ]
};
const $bf6244e5cc9aa116$var$commonShirtColors = [
    "black",
    "blue",
    "green",
    "maroon",
    "purple",
    "red",
    "teal",
    "white",
    "yellow"
];
const $bf6244e5cc9aa116$export$b4dd93b72d5ba14d = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).shirt);
const $bf6244e5cc9aa116$export$e373170f06c14189 = [
    "armor-plate",
    "armor-leather",
    "armor-legion"
];
const $bf6244e5cc9aa116$export$174697130974693e = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).armor);
const $bf6244e5cc9aa116$export$9b1a926f698aa2eb = [
    "boots",
    "shoes",
    "shoes-armor",
    "slippers",
    "sandals"
];
const $bf6244e5cc9aa116$export$14c4cc2ba117f70c = {
    male: [
        "shoes-armor",
        "boots",
        "sandals",
        "shoes"
    ],
    female: [
        "shoes-armor",
        "boots",
        "sandals",
        "shoes",
        "slippers"
    ]
};
const $bf6244e5cc9aa116$export$d9113a8608ba3a3c = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).shoes);
const $bf6244e5cc9aa116$export$22f463049e3f0484 = [
    "shield-crusader",
    "shield-spartan",
    "shield-round",
    "shield-kite",
    "shield-kite_blue",
    "shield-kite_gray",
    "shield-kite_green",
    "shield-kite_red"
];
const $bf6244e5cc9aa116$export$52cb84e67504327c = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).shield);
const $bf6244e5cc9aa116$export$e3843218012e8124 = [
    "cape-solid",
    "cape-tattered",
    "cape-trimmed"
];
const $bf6244e5cc9aa116$export$bacf1c742d99cac9 = {
    male: [
        "cape-solid"
    ],
    female: [
        "cape-tattered",
        "cape-trimmed"
    ]
};
const $bf6244e5cc9aa116$export$6fae0646c1b2ea33 = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).cape);
const $bf6244e5cc9aa116$export$789f63764a0c7819 = {
    castlekey: [
        "gold"
    ]
};
const $bf6244e5cc9aa116$export$2e16043d24eb3a5c = $bf6244e5cc9aa116$var$derive((0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).bauldron);
/**
 * Guards on the generated colour data. Both are compile-time only; neither runs.
 *
 * Without them "derived from data" would mean "unchecked", which is worse than the hand-written
 * tables it replaced.
 */ /**
 * 1. No value may be a colour the game does not have a name for. A registry that imported
 *    upstream's `chartreuse` fails the build here, naming it, rather than resolving to a path
 *    nothing renders.
 */ const $bf6244e5cc9aa116$var$_spriteColorsAreRealColors = (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e);
/**
 * 2. Every declared component must have an entry. This is the exhaustiveness `Record<Race, ...>`
 *    used to give for free when the table was written out by hand: drop a race from the registry
 *    and the build fails instead of that race rendering nothing.
 */ const $bf6244e5cc9aa116$var$_everyComponentHasColours = [
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).body,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).hair,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).weapon,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).pants,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).shirt,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).armor,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).shoes,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).shield,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).cape,
    (0, $e33bbc24f0896ffc$export$cb418cdf24d0dd3e).bauldron
];







const $b5d7776bdc108009$export$6a0fc7ad27079d24 = [
    "armor",
    "bauldron",
    "cape",
    "key",
    "pants",
    "resource",
    "shield",
    "shirt",
    "shoes",
    "structure",
    "weapon"
];


const $83421eaad420de4c$export$f5827cadcc93baff = {
    "coal": "ore:161",
    "copper": "ore:180",
    "feather": "ore:72",
    "flower-single-blue": "lpc-flowers-plants-fungi-wood:104",
    "flower-single-purple": "lpc-flowers-plants-fungi-wood:103",
    "flower-single-red": "lpc-flowers-plants-fungi-wood:105",
    "flower-single-yellow": "lpc-flowers-plants-fungi-wood:106",
    "gold": "ore:182",
    "iron": "ore:179",
    "metal-bar-copper": "ore:180",
    "metal-bar-gold": "ore:182",
    "metal-bar-iron": "ore:179",
    "metal-bar-silver": "ore:181",
    "mushroom-purple": "lpc-flowers-plants-fungi-wood:353",
    "mushroom-red": "lpc-flowers-plants-fungi-wood:355",
    "mushroom-yellow": "lpc-flowers-plants-fungi-wood:354",
    "planks": "ore:25",
    "rope": "ore:88",
    "seed": "seed-green.png",
    "silver": "ore:181",
    "stick": "ore:26",
    "straw": "lpc-flowers-plants-fungi-wood:212",
    "chest-wood": "container:140",
    "door-wood": "fence_medieval:478",
    "floor-wood": "floors:33",
    "roof-wood": "fence_medieval:468",
    "snare-rabbit": "ore:89",
    "stool-small": "furniture-blonde-wood:126",
    "table-large-rough": "furniture-blonde-wood:458",
    "table-mid-round": "furniture-blonde-wood:124",
    "wall-wood": "fence_medieval:410",
    "wall2-wood": "walls2:43",
    "wall-stone": "walls2:53",
    "barrel1": "container:60",
    "stackedBags": "container:449",
    "stool1": "furniture-blond-wood:128",
    "table-mid-rough": "furniture-blonde-wood:141",
    "strawBed": "build_atlas:684",
    "strawBedSmall": "build_atlas:684"
};


const $6bf155bafb42c3cf$export$e373170f06c14189 = [
    "armor-leather",
    "armor-legion",
    "armor-plate"
];
const $6bf155bafb42c3cf$export$57c30af6f9fcc7b6 = [
    "arrow",
    "webAmmo"
];
const $6bf155bafb42c3cf$export$ca2d6f27625f4d2d = [
    "coal",
    "copper",
    "gold",
    "iron",
    "silver"
];
const $6bf155bafb42c3cf$export$9cf77232fcbf2cb2 = [
    "drumstick"
];
const $6bf155bafb42c3cf$export$321076f3c47f280e = [
    "feather",
    "planks",
    "rope",
    "stick"
];
const $6bf155bafb42c3cf$export$8e1ac98f867fcfc9 = [
    "flower-single-blue",
    "flower-single-purple",
    "flower-single-red",
    "flower-single-yellow"
];
const $6bf155bafb42c3cf$export$e89e4a3be320fab7 = [
    "hide"
];
const $6bf155bafb42c3cf$export$bb3a39dc2895520e = [
    "metal-bar-copper",
    "metal-bar-gold",
    "metal-bar-iron",
    "metal-bar-silver"
];
const $6bf155bafb42c3cf$export$3b1ebfa8738bb7c9 = [
    "mushroom-purple",
    "mushroom-red",
    "mushroom-yellow"
];
const $6bf155bafb42c3cf$export$b3621abeadb119aa = [
    "seed"
];
const $6bf155bafb42c3cf$export$a9d986fd459d538f = [
    "shard-metal"
];
const $6bf155bafb42c3cf$export$13000b609864108d = [
    "straw"
];
const $6bf155bafb42c3cf$export$818357a46d9426f0 = [
    "torch"
];
const $6bf155bafb42c3cf$export$1bfe670ceaa0e353 = [
    "wood"
];
const $6bf155bafb42c3cf$export$e576fc74ec8de9d1 = [
    "shard-metal"
];
const $6bf155bafb42c3cf$export$45b2c5ee636d8393 = [
    "axe",
    "bow",
    "crossbow",
    "dagger",
    "flail",
    "halberd",
    "longsword",
    "mace",
    "none",
    "rapier",
    "saber",
    "scythe",
    "spear",
    "staff",
    "waraxe",
    "warhammer",
    "web"
];
const $6bf155bafb42c3cf$export$9d5bd4d7c47ce3e4 = [
    "bauldron"
];
const $6bf155bafb42c3cf$export$16d380a34afbfbed = [
    "blouse",
    "blouse_longsleeve",
    "corset",
    "longsleeve",
    "longsleeve_laced",
    "scoop_shirt",
    "sleeveless",
    "sleeveless_laced",
    "sleeveless_striped",
    "tanktop",
    "tunic"
];
const $6bf155bafb42c3cf$export$dabd8295a5dbc844 = [
    "boots",
    "sandals",
    "shoes",
    "shoes-armor",
    "slippers"
];
const $6bf155bafb42c3cf$export$2aceca917aabe38d = [
    "campfire",
    "snare-rabbit",
    "stool-small",
    "table-large-rough",
    "table-mid-round",
    "barrel1",
    "stackedBags",
    "stool1",
    "table-mid-rough",
    "strawBed",
    "strawBedSmall"
];
const $6bf155bafb42c3cf$export$c47ca3b04298be3 = [
    "chest-wood"
];
const $6bf155bafb42c3cf$export$f20e27ccf12c03d8 = [
    "door-wood"
];
const $6bf155bafb42c3cf$export$ba4f89177a877ab0 = [
    "floor-wood"
];
const $6bf155bafb42c3cf$export$49173db6f9847db8 = [
    "roof-wood"
];
const $6bf155bafb42c3cf$export$2862e2cd7420502d = [
    "wall-wood",
    "wall2-wood",
    "wall-stone"
];
const $6bf155bafb42c3cf$export$e3843218012e8124 = [
    "cape-solid",
    "cape-tattered",
    "cape-trimmed"
];
const $6bf155bafb42c3cf$export$4129953fbdeabac2 = [
    "castlekey"
];
const $6bf155bafb42c3cf$export$f984f9e37c2404ad = [
    "legion",
    "pantaloons",
    "pants",
    "pants-armor",
    "skirts"
];
const $6bf155bafb42c3cf$export$22f463049e3f0484 = [
    "shield-crusader",
    "shield-kite",
    "shield-kite_blue",
    "shield-kite_gray",
    "shield-kite_green",
    "shield-kite_red",
    "shield-round",
    "shield-spartan"
];
const $6bf155bafb42c3cf$export$560c482cf16d1d03 = [
    "armor-leather",
    "armor-legion",
    "armor-plate",
    "arrow",
    "axe",
    "bauldron",
    "blouse",
    "blouse_longsleeve",
    "boots",
    "bow",
    "campfire",
    "cape-solid",
    "cape-tattered",
    "cape-trimmed",
    "castlekey",
    "chest-wood",
    "coal",
    "copper",
    "corset",
    "crossbow",
    "dagger",
    "door-wood",
    "drumstick",
    "feather",
    "flail",
    "floor-wood",
    "flower-single-blue",
    "flower-single-purple",
    "flower-single-red",
    "flower-single-yellow",
    "gold",
    "halberd",
    "hide",
    "iron",
    "legion",
    "longsleeve",
    "longsleeve_laced",
    "longsword",
    "mace",
    "metal-bar-copper",
    "metal-bar-gold",
    "metal-bar-iron",
    "metal-bar-silver",
    "mushroom-purple",
    "mushroom-red",
    "mushroom-yellow",
    "none",
    "pantaloons",
    "pants",
    "pants-armor",
    "planks",
    "rapier",
    "roof-wood",
    "rope",
    "saber",
    "sandals",
    "scoop_shirt",
    "scythe",
    "seed",
    "shard-metal",
    "shield-crusader",
    "shield-kite",
    "shield-kite_blue",
    "shield-kite_gray",
    "shield-kite_green",
    "shield-kite_red",
    "shield-round",
    "shield-spartan",
    "shoes",
    "shoes-armor",
    "silver",
    "skirts",
    "sleeveless",
    "sleeveless_laced",
    "sleeveless_striped",
    "slippers",
    "snare-rabbit",
    "spear",
    "staff",
    "stick",
    "stool-small",
    "straw",
    "table-large-rough",
    "table-mid-round",
    "tanktop",
    "torch",
    "tunic",
    "wall-wood",
    "wall2-wood",
    "wall-stone",
    "waraxe",
    "warhammer",
    "web",
    "webAmmo",
    "wood",
    "barrel1",
    "stackedBags",
    "stool1",
    "table-mid-rough",
    "strawBed",
    "strawBedSmall"
];
const $6bf155bafb42c3cf$export$6144f869cd49287b = {
    armor: [
        ...$6bf155bafb42c3cf$export$e373170f06c14189
    ],
    resource: [
        ...$6bf155bafb42c3cf$export$57c30af6f9fcc7b6,
        ...$6bf155bafb42c3cf$export$ca2d6f27625f4d2d,
        ...$6bf155bafb42c3cf$export$9cf77232fcbf2cb2,
        ...$6bf155bafb42c3cf$export$321076f3c47f280e,
        ...$6bf155bafb42c3cf$export$8e1ac98f867fcfc9,
        ...$6bf155bafb42c3cf$export$e89e4a3be320fab7,
        ...$6bf155bafb42c3cf$export$bb3a39dc2895520e,
        ...$6bf155bafb42c3cf$export$3b1ebfa8738bb7c9,
        ...$6bf155bafb42c3cf$export$b3621abeadb119aa,
        ...$6bf155bafb42c3cf$export$a9d986fd459d538f,
        ...$6bf155bafb42c3cf$export$13000b609864108d,
        ...$6bf155bafb42c3cf$export$818357a46d9426f0,
        ...$6bf155bafb42c3cf$export$1bfe670ceaa0e353,
        ...$6bf155bafb42c3cf$export$e576fc74ec8de9d1
    ],
    weapon: [
        ...$6bf155bafb42c3cf$export$45b2c5ee636d8393
    ],
    bauldron: [
        ...$6bf155bafb42c3cf$export$9d5bd4d7c47ce3e4
    ],
    shirt: [
        ...$6bf155bafb42c3cf$export$16d380a34afbfbed
    ],
    shoes: [
        ...$6bf155bafb42c3cf$export$dabd8295a5dbc844
    ],
    structure: [
        ...$6bf155bafb42c3cf$export$2aceca917aabe38d,
        ...$6bf155bafb42c3cf$export$c47ca3b04298be3,
        ...$6bf155bafb42c3cf$export$f20e27ccf12c03d8,
        ...$6bf155bafb42c3cf$export$ba4f89177a877ab0,
        ...$6bf155bafb42c3cf$export$49173db6f9847db8,
        ...$6bf155bafb42c3cf$export$2862e2cd7420502d
    ],
    cape: [
        ...$6bf155bafb42c3cf$export$e3843218012e8124
    ],
    key: [
        ...$6bf155bafb42c3cf$export$4129953fbdeabac2
    ],
    pants: [
        ...$6bf155bafb42c3cf$export$f984f9e37c2404ad
    ],
    shield: [
        ...$6bf155bafb42c3cf$export$22f463049e3f0484
    ]
};


const $1a8d038f30f2e325$export$bb6a025a5450b019 = {
    "armor-leather": [
        {
            "type": "armor-leather",
            "class": "armor",
            "color": "brown",
            "spriteId": null
        }
    ],
    "armor-legion": [
        {
            "type": "armor-legion",
            "class": "armor",
            "color": "brown",
            "spriteId": null
        }
    ],
    "bauldron": [
        {
            "type": "bauldron",
            "class": "bauldron",
            "color": "brown",
            "spriteId": null
        }
    ],
    "castlekey": [
        {
            "type": "castlekey",
            "class": "key",
            "color": "gold",
            "spriteId": null
        }
    ],
    "legion": [
        {
            "type": "legion",
            "class": "pants",
            "color": "brown",
            "spriteId": null
        }
    ],
    "arrow": [
        {
            "type": "arrow",
            "class": "resource",
            "color": "brown",
            "spriteId": null
        }
    ],
    "coal": [
        {
            "type": "coal",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:161"
        }
    ],
    "copper": [
        {
            "type": "copper",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:180"
        }
    ],
    "drumstick": [
        {
            "type": "drumstick",
            "class": "resource",
            "color": "brown",
            "spriteId": null
        }
    ],
    "feather": [
        {
            "type": "feather",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:72"
        }
    ],
    "flower-single-blue": [
        {
            "type": "flower-single-blue",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:104"
        }
    ],
    "flower-single-purple": [
        {
            "type": "flower-single-purple",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:103"
        }
    ],
    "flower-single-red": [
        {
            "type": "flower-single-red",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:105"
        }
    ],
    "flower-single-yellow": [
        {
            "type": "flower-single-yellow",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:106"
        }
    ],
    "gold": [
        {
            "type": "gold",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:182"
        }
    ],
    "hide": [
        {
            "type": "hide",
            "class": "resource",
            "color": "brown",
            "spriteId": null
        }
    ],
    "iron": [
        {
            "type": "iron",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:179"
        }
    ],
    "metal-bar-copper": [
        {
            "type": "metal-bar-copper",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:180"
        }
    ],
    "metal-bar-gold": [
        {
            "type": "metal-bar-gold",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:182"
        }
    ],
    "metal-bar-iron": [
        {
            "type": "metal-bar-iron",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:179"
        }
    ],
    "metal-bar-silver": [
        {
            "type": "metal-bar-silver",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:181"
        }
    ],
    "mushroom-purple": [
        {
            "type": "mushroom-purple",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:353"
        }
    ],
    "mushroom-red": [
        {
            "type": "mushroom-red",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:355"
        }
    ],
    "mushroom-yellow": [
        {
            "type": "mushroom-yellow",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:354"
        }
    ],
    "planks": [
        {
            "type": "planks",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:25"
        }
    ],
    "rope": [
        {
            "type": "rope",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:88"
        }
    ],
    "seed": [
        {
            "type": "seed",
            "class": "resource",
            "color": "na",
            "spriteId": "seed-green.png"
        }
    ],
    "shard-metal": [
        {
            "type": "shard-metal",
            "class": "resource",
            "color": "gray"
        }
    ],
    "silver": [
        {
            "type": "silver",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:181"
        }
    ],
    "stick": [
        {
            "type": "stick",
            "class": "resource",
            "color": "na",
            "spriteId": "ore:26"
        }
    ],
    "straw": [
        {
            "type": "straw",
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:212"
        }
    ],
    "torch": [
        {
            "type": "torch",
            "class": "resource",
            "color": "na",
            "spriteId": null
        }
    ],
    "webAmmo": [
        {
            "type": "webAmmo",
            "class": "resource",
            "color": "white"
        }
    ],
    "wood": [
        {
            "type": "wood",
            "class": "resource",
            "color": "brown",
            "spriteId": null
        }
    ],
    "shield-crusader": [
        {
            "type": "shield-crusader",
            "class": "shield",
            "color": "white",
            "spriteId": null
        }
    ],
    "shield-kite": [
        {
            "type": "shield-kite",
            "class": "shield",
            "color": "white",
            "spriteId": null
        }
    ],
    "shield-round": [
        {
            "type": "shield-round",
            "class": "shield",
            "color": "brown",
            "spriteId": null
        }
    ],
    "campfire": [
        {
            "type": "campfire",
            "class": "structure",
            "color": "na",
            "spriteId": null
        }
    ],
    "chest-wood": [
        {
            "type": "chest-wood",
            "class": "structure",
            "color": "na",
            "spriteId": "container:140"
        }
    ],
    "door-wood": [
        {
            "type": "door-wood",
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:478"
        }
    ],
    "floor-wood": [
        {
            "type": "floor-wood",
            "class": "structure",
            "color": "na",
            "spriteId": "floors:33"
        }
    ],
    "roof-wood": [
        {
            "type": "roof-wood",
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:468"
        }
    ],
    "snare-rabbit": [
        {
            "type": "snare-rabbit",
            "class": "structure",
            "color": "na",
            "spriteId": "ore:89"
        }
    ],
    "stool-small": [
        {
            "type": "stool-small",
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:126"
        }
    ],
    "table-large-rough": [
        {
            "type": "table-large-rough",
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:458"
        }
    ],
    "table-mid-round": [
        {
            "type": "table-mid-round",
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:124"
        }
    ],
    "wall-wood": [
        {
            "type": "wall-wood",
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:410"
        }
    ],
    "wall2-wood": [
        {
            "type": "wall2-wood",
            "class": "structure",
            "color": "na",
            "spriteId": "walls2:43"
        }
    ],
    "wall-stone": [
        {
            "type": "wall-stone",
            "class": "structure",
            "color": "na",
            "spriteId": "walls2:53"
        }
    ],
    "barrel1": [
        {
            "type": "barrel1",
            "class": "structure",
            "color": "na",
            "spriteId": "container:60"
        }
    ],
    "stackedBags": [
        {
            "type": "stackedBags",
            "class": "structure",
            "color": "na",
            "spriteId": "container:449"
        }
    ],
    "stool1": [
        {
            "type": "stool1",
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blond-wood:128"
        }
    ],
    "table-mid-rough": [
        {
            "type": "table-mid-rough",
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:141"
        }
    ],
    "strawBed": [
        {
            "type": "strawBed",
            "class": "structure",
            "color": "na",
            "spriteId": "build_atlas:684"
        }
    ],
    "strawBedSmall": [
        {
            "type": "strawBedSmall",
            "class": "structure",
            "color": "na",
            "spriteId": "build_atlas:684"
        }
    ],
    "dagger": [
        {
            "type": "dagger",
            "class": "weapon",
            "color": "brown",
            "spriteId": null
        },
        {
            "type": "dagger",
            "class": "weapon",
            "color": "metal",
            "spriteId": null
        }
    ],
    "web": [
        {
            "type": "web",
            "class": "weapon",
            "color": "white"
        }
    ]
};


const $f684496fff50a7a1$export$618460892f1ada62 = 30;
const $f684496fff50a7a1$export$9cd6a2cdd0639728 = {
    npc: true,
    player: true
};
const $f684496fff50a7a1$export$b423c5fc832040e7 = {
    resource: true,
    structure: true
};
const $f684496fff50a7a1$var$computeAllItemTypesToMetaByColor = ()=>{
    const metaRecord = {};
    (0, $b5d7776bdc108009$export$6a0fc7ad27079d24).forEach((itemClass)=>{
        const itemTypes = (0, $6bf155bafb42c3cf$export$6144f869cd49287b)[itemClass] || [];
        itemTypes.forEach((itemType)=>{
            //
            // check the explicit list first
            //
            if ((0, $1a8d038f30f2e325$export$bb6a025a5450b019)[itemType]) {
                metaRecord[itemType] = (0, $1a8d038f30f2e325$export$bb6a025a5450b019)[itemType];
                return;
            }
            //
            // not explicitly defined, generate it
            //
            // by default, no particular color
            let colors = [
                "na"
            ];
            //
            // these are the lpc items
            //
            if ("weapon" === itemClass) colors = (0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[itemType];
            if ("pants" === itemClass) colors = (0, $bf6244e5cc9aa116$export$7ef85edc405cda8b)[itemType];
            if ("shirt" === itemClass) colors = (0, $bf6244e5cc9aa116$export$b4dd93b72d5ba14d)[itemType];
            if ("armor" === itemClass) colors = (0, $bf6244e5cc9aa116$export$174697130974693e)[itemType];
            if ("shoes" === itemClass) colors = (0, $bf6244e5cc9aa116$export$d9113a8608ba3a3c)[itemType];
            if ("shield" === itemClass) colors = (0, $bf6244e5cc9aa116$export$52cb84e67504327c)[itemType];
            if ("cape" === itemClass) colors = (0, $bf6244e5cc9aa116$export$6fae0646c1b2ea33)[itemType];
            if ("bauldron" === itemClass) colors = (0, $bf6244e5cc9aa116$export$2e16043d24eb3a5c)[itemType];
            let spriteId = (0, $83421eaad420de4c$export$f5827cadcc93baff)[itemType];
            colors.forEach((color)=>{
                const itemTypeMeta = {
                    type: itemType,
                    class: itemClass,
                    color: color,
                    spriteId: spriteId
                };
                if (!metaRecord[itemType]) metaRecord[itemType] = [];
                metaRecord[itemType].push(itemTypeMeta);
            });
        });
    });
    return metaRecord;
};
const $f684496fff50a7a1$export$7608a36d9e6299e1 = $f684496fff50a7a1$var$computeAllItemTypesToMetaByColor();
const $f684496fff50a7a1$export$9efb6bfe58196888 = (itemType, color, random)=>{
    const range = $f684496fff50a7a1$export$7608a36d9e6299e1[itemType];
    if (color) return range?.find((item)=>item.color === color);
    return random ? (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(range) : range[0];
};
const $f684496fff50a7a1$export$c71b1b663c9749e1 = (itemType)=>$f684496fff50a7a1$export$7608a36d9e6299e1[itemType];
const $f684496fff50a7a1$export$3f10b5fead7f11c3 = (meta, itemType)=>{
    if (meta?.color) return meta;
    // Range-then-[0], not resolveItemTypeToMeta(), which THROWS for an unknown type (it indexes
    // into an undefined range).
    const resolved = $f684496fff50a7a1$export$c71b1b663c9749e1(meta?.type || itemType)?.[0];
    if (!resolved) return meta;
    return {
        ...resolved,
        ...meta,
        color: resolved.color
    };
};
const $f684496fff50a7a1$export$be8fdcbd37253b73 = {
    torch: {
        effect: "light",
        clockDuration: 50
    }
};
const $f684496fff50a7a1$export$6f33aefd40985973 = (sex, clazz, pool, colorPool, defaultColor)=>{
    const shirt = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(pool[sex]);
    return {
        type: shirt,
        class: clazz,
        color: defaultColor && colorPool[shirt].find((c)=>c === defaultColor) ? defaultColor : (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(colorPool[shirt])
    };
};
const $f684496fff50a7a1$export$2029786d851276f2 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "armor", {
        male: (0, $bf6244e5cc9aa116$export$e373170f06c14189),
        female: (0, $bf6244e5cc9aa116$export$e373170f06c14189)
    }, (0, $bf6244e5cc9aa116$export$174697130974693e), color);
const $f684496fff50a7a1$export$6b5dfa9b69d47914 = (sex)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "shield", {
        male: (0, $bf6244e5cc9aa116$export$22f463049e3f0484),
        female: (0, $bf6244e5cc9aa116$export$22f463049e3f0484)
    }, (0, $bf6244e5cc9aa116$export$52cb84e67504327c));
const $f684496fff50a7a1$export$d9e877656949a349 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "pants", (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3), (0, $bf6244e5cc9aa116$export$7ef85edc405cda8b), color);
const $f684496fff50a7a1$export$66784139126343e5 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "shirt", (0, $bf6244e5cc9aa116$export$6e1561754c81021d), (0, $bf6244e5cc9aa116$export$b4dd93b72d5ba14d), color);
const $f684496fff50a7a1$export$682f83b7ac786c71 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "shoes", (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c), (0, $bf6244e5cc9aa116$export$d9113a8608ba3a3c), color);
const $f684496fff50a7a1$export$fa093afaede310d2 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "cape", (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9), (0, $bf6244e5cc9aa116$export$6fae0646c1b2ea33), color);
const $f684496fff50a7a1$export$34482bdcc23ddb1c = (sex)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "bauldron", {
        female: [
            "bauldron"
        ],
        male: [
            "bauldron"
        ]
    }, (0, $bf6244e5cc9aa116$export$2e16043d24eb3a5c));
const $f684496fff50a7a1$export$eb64c22ff8ddddd4 = (sex, spec)=>{
    const itemTypes = [];
    const averageColor = spec?.averageColor;
    const randomWeapon = ()=>{
        const weapon = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$45b2c5ee636d8393));
        return {
            type: weapon,
            class: "weapon",
            color: (0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[weapon]?.find((c)=>c === averageColor) ? averageColor : (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[weapon])
        };
    };
    const weapon = !spec || spec.weapon ? typeof spec.weapon === "boolean" ? randomWeapon() : $f684496fff50a7a1$export$9efb6bfe58196888(spec.weapon) : undefined;
    const pants = !spec || spec.pants ? typeof spec.pants === "boolean" ? $f684496fff50a7a1$export$d9e877656949a349(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.pants) : undefined;
    const shirt = !spec || spec.shirt ? typeof spec.shirt === "boolean" ? $f684496fff50a7a1$export$66784139126343e5(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.shirt) : undefined;
    const armor = !spec || spec.armor ? typeof spec.armor === "boolean" ? $f684496fff50a7a1$export$2029786d851276f2(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.armor) : undefined;
    const shoe = !spec || spec.shoe ? typeof spec.shoe === "boolean" ? $f684496fff50a7a1$export$682f83b7ac786c71(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.shoe) : undefined;
    const shield = !spec || spec.shield ? $f684496fff50a7a1$export$6b5dfa9b69d47914(sex) : undefined;
    const cape = !spec || spec.cape ? $f684496fff50a7a1$export$fa093afaede310d2(sex, averageColor) : undefined;
    const bauldron = !spec || spec.bauldron ? typeof spec.bauldron === "boolean" ? $f684496fff50a7a1$export$34482bdcc23ddb1c(sex) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.bauldron) : undefined;
    if (weapon) itemTypes.push(weapon);
    if (pants) itemTypes.push(pants);
    if (shirt) itemTypes.push(shirt);
    if (armor) itemTypes.push(armor);
    if (shoe) itemTypes.push(shoe);
    if (shield) itemTypes.push(shield);
    if (cape) itemTypes.push(cape);
    if (bauldron) itemTypes.push(bauldron);
    if (spec.chicken) itemTypes.push($f684496fff50a7a1$export$9efb6bfe58196888("drumstick"));
    if (spec.shards) itemTypes.push($f684496fff50a7a1$export$9efb6bfe58196888("shard-metal"));
    return itemTypes.map((itemTypeMeta)=>{
        return {
            itemType: "none",
            itemTypeMeta: itemTypeMeta,
            active: itemTypeMeta.class !== "resource",
            id: (0, $87befc68df50040c$export$2e2bcd8739ae039)()
        };
    });
};
const $f684496fff50a7a1$export$3c1e3d239c13de64 = (sex, noWeapon)=>{
    const itemTypes = [];
    const weapon = !noWeapon && (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$45b2c5ee636d8393)) : undefined;
    const pants = $f684496fff50a7a1$export$d9e877656949a349(sex);
    const shirt = sex === "female" ? $f684496fff50a7a1$export$66784139126343e5(sex) : (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$66784139126343e5(sex) : undefined;
    const armor = $f684496fff50a7a1$export$2029786d851276f2(sex);
    const shoe = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$682f83b7ac786c71(sex) : undefined;
    const shield = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$22f463049e3f0484)) : undefined;
    const cape = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$fa093afaede310d2(sex) : undefined;
    const bauldron = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$34482bdcc23ddb1c(sex) : undefined;
    if (weapon) itemTypes.push({
        type: weapon,
        class: "weapon",
        color: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[weapon])
    });
    if (pants) itemTypes.push(pants);
    if (shirt) itemTypes.push(shirt);
    if (armor) itemTypes.push(armor);
    if (shoe) itemTypes.push(shoe);
    if (shield) itemTypes.push({
        type: shield,
        class: "shield",
        color: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$52cb84e67504327c)[shield])
    });
    if (cape) itemTypes.push(cape);
    if (bauldron) itemTypes.push(bauldron);
    return itemTypes;
};
const $f684496fff50a7a1$export$429c16c642745fa3 = (inventory, itemClass)=>inventory?.items?.filter((item)=>item.itemTypeMeta?.class === itemClass) || [];
const $f684496fff50a7a1$export$58361cde22f3aa43 = (inventory, itemClass)=>$f684496fff50a7a1$export$ff6824850c0111da(inventory, itemClass)?.itemTypeMeta;
const $f684496fff50a7a1$export$ff6824850c0111da = (inventory, itemClass)=>inventory?.items?.find((item)=>item.itemTypeMeta?.class === itemClass && item.active);
const $f684496fff50a7a1$export$696bbd6109262d72 = (inventory, itemClass)=>inventory?.items?.filter((item)=>(!itemClass || item.itemTypeMeta?.class === itemClass) && item.readied) || [];
const $f684496fff50a7a1$export$4c2157e8933c20e3 = (inventory, itemType)=>inventory?.items?.find((item)=>item.itemTypeMeta?.type === itemType);
const $f684496fff50a7a1$export$42ef252fc2f3d24d = (inventory, meta, maxQuantity)=>inventory?.items?.find((item)=>(!maxQuantity || (item.quantity || 1) < maxQuantity) && item.itemTypeMeta?.type === meta.type && item.itemTypeMeta?.class === meta.class && item.itemTypeMeta?.color === meta.color);
const $f684496fff50a7a1$export$21ed2b172ef02352 = (entity, itemId)=>{
    return $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        readied: true
    });
};
const $f684496fff50a7a1$export$51ddac4ba8a102f9 = (entity, itemId)=>{
    return $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        readied: false
    });
};
const $f684496fff50a7a1$export$9708f70dc8060636 = (entity, itemId)=>{
    const { inventory: inventory } = entity;
    const item = inventory.items?.find((item)=>item.id === itemId);
    if (!item) return entity;
    const { itemTypeMeta: itemTypeMeta } = item;
    (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.disallowedClassesOnActive(itemTypeMeta).map((klass)=>$f684496fff50a7a1$export$ff6824850c0111da(entity.inventory, klass)).filter((n)=>!!n).forEach((conflict)=>{
        const currentlyActiveItem = $f684496fff50a7a1$export$ff6824850c0111da(entity.inventory, conflict.itemTypeMeta.class);
        if (currentlyActiveItem) entity = $f684496fff50a7a1$export$9f1dc835e66373fa(entity, currentlyActiveItem.id);
    });
    if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.exclusiveReadiness(itemTypeMeta)) {
        // can only have one active at a time per class
        const currentlyActiveItem = $f684496fff50a7a1$export$ff6824850c0111da(entity.inventory, itemTypeMeta.class);
        if (currentlyActiveItem) entity = $f684496fff50a7a1$export$9f1dc835e66373fa(entity, currentlyActiveItem.id);
    }
    return $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        active: true
    });
};
const $f684496fff50a7a1$export$9f1dc835e66373fa = (entity, itemId)=>{
    const itemToDeactiate = entity.inventory?.items?.find((item)=>item.id === itemId);
    let updatedEntity = $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        active: false
    });
    if (itemToDeactiate?.itemTypeMeta?.class === "weapon" && updatedEntity.weapon) updatedEntity.weapon.weaponType = "none";
    return updatedEntity;
};
const $f684496fff50a7a1$export$9bccf79e85d1f187 = (item, props)=>{
    const { sourceItem: sourceItem, quantity: quantity, hp: hp, id: id, flags: flags } = props;
    const inventoryItem = {
        id: id || sourceItem?.entityId || (0, $87befc68df50040c$export$2e2bcd8739ae039)(),
        itemType: item.class === "weapon" ? item.type : "none",
        itemTypeMeta: {
            ...item
        },
        flags: sourceItem?.flags ? {
            ...sourceItem.flags
        } : flags,
        quantity: quantity || sourceItem?.quantity,
        hp: sourceItem?.hp || hp || (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.durability.computeMaxDurability(item)
    };
    return inventoryItem;
};
const $f684496fff50a7a1$export$73ce97a5e6b0458a = (entity, item)=>{
    const { inventory: inventory } = entity;
    inventory.items?.push(item);
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$export$be412759309c8c0f = (entity, item, quantity)=>{
    const updatedQuantity = (item.quantity || 1) + quantity;
    item.quantity = updatedQuantity;
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$export$8d789f57f08f90fd = (entity, item, hp)=>{
    const updatedHp = (item.hp || 1) + hp;
    item.hp = Math.max(0, updatedHp);
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$export$6d9780a2b50e0c6e = (entity, itemId)=>{
    const { inventory: inventory } = entity;
    const item = inventory?.items.find((n)=>n.id === itemId);
    if (item?.active && item.itemTypeMeta.class === "weapon") entity.weapon.weaponType = "none";
    const updatedItems = inventory.items?.filter((i)=>i.id !== itemId);
    inventory.items = updatedItems;
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$var$changeInventoryItemFlags = (entity, itemId, { active: active, readied: readied })=>{
    const { inventory: inventory } = entity;
    const item = inventory.items?.find((item)=>item.id === itemId);
    if (!item) return entity;
    item.active = active !== undefined ? active : item.active;
    item.readied = readied !== undefined ? readied : item.readied;
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$var$updateInventorySideEffects = (entity)=>{
    const { inventory: inventory } = entity;
    if (entity.appearance) {
        entity.appearance.inventoryAppearanceHash = $f684496fff50a7a1$export$fe4683c17d6b2a37(inventory);
        entity.inventory.lastUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    }
    return entity;
};
const $f684496fff50a7a1$export$fe4683c17d6b2a37 = (inventory)=>{
    if (!inventory) return "";
    const weapon = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "weapon");
    const pants = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "pants");
    const shirt = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "shirt");
    const armor = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "armor");
    const shoes = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "shoes");
    const shield = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "shield");
    const cape = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "cape");
    const bauldron = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "bauldron");
    return [
        weapon,
        pants,
        shirt,
        armor,
        shoes,
        shield,
        cape,
        bauldron
    ].filter((n)=>!!n).map((n)=>`${n.class}/${n.color}/${n.type}`).join("-");
};



const $9289c16b39bc1929$export$cf55c200a2cf1225 = {
    "armor": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "bauldron": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "cape": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "key": {
        "readyable": true,
        "exclusiveReadiness": true
    },
    "pants": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "resource": {
        "readyable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "disallowedClassesOnActive": [
            "weapon",
            "structure"
        ]
    },
    "shield": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "shirt": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "shoes": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true
    },
    "structure": {
        "readyable": true,
        "exclusiveReadiness": true,
        "stableAngleOnDrop": true,
        "unbuyable": true,
        "disallowedClassesOnActive": [
            "weapon",
            "resource"
        ]
    },
    "weapon": {
        "equippable": true,
        "readyable": true,
        "exclusiveReadiness": true,
        "hasDurability": true,
        "disallowedClassesOnActive": [
            "resource",
            "structure"
        ]
    }
};



const $4ea3e677cece9ece$export$26748d48fafe06ef = [
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-iron`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`iron`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-silver`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`silver`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-copper`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`copper`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-gold`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`gold`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
        quantity: 5,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`wood`),
                quantity: 1
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`rope`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`straw`),
                quantity: 3
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
        quantity: 2,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`wood`),
                quantity: 1
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`wall-wood`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 3
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`wall-stone`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 3
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`floor-wood`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 3
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`door-wood`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 3
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`chest-wood`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`roof-wood`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 4
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`campfire`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`wood`),
                quantity: 2
            }
        ]
    },
    {
        itemTypeMeta: {
            ...(0, $f684496fff50a7a1$export$9efb6bfe58196888)(`dagger`),
            color: `metal`
        },
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
                quantity: 5
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`shard-metal`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: {
            ...(0, $f684496fff50a7a1$export$9efb6bfe58196888)(`dagger`),
            color: `brown`
        },
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
                quantity: 5
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`arrow`),
        quantity: 10,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
                quantity: 2
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`feather`),
                quantity: 3
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`shard-metal`),
                quantity: 2
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`axe`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-iron`),
                quantity: 3
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
                quantity: 2
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`spear`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`wood`),
                quantity: 10
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`shard-metal`),
                quantity: 3
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`longsword`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-iron`),
                quantity: 3
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 1
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`waraxe`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`metal-bar-iron`),
                quantity: 4
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`planks`),
                quantity: 2
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`bow`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
                quantity: 15
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`shard-metal`),
                quantity: 5
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`rope`),
                quantity: 2
            }
        ]
    },
    {
        itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`snare-rabbit`),
        quantity: 1,
        ingredients: [
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`stick`),
                quantity: 3
            },
            {
                itemTypeMeta: (0, $f684496fff50a7a1$export$9efb6bfe58196888)(`rope`),
                quantity: 1
            }
        ]
    }
];


const $7724856bf35f34f1$export$1fe1df41c32a19a1 = {
    "armor-leather": {
        "itemType": "shard-metal",
        "quantity": 60
    },
    "armor-legion": {
        "itemType": "shard-metal",
        "quantity": 240
    },
    "armor-plate": {
        "itemType": "shard-metal",
        "quantity": 360
    },
    "arrow": {
        "itemType": "shard-metal",
        "quantity": 0.1
    },
    "coal": {
        "itemType": "shard-metal",
        "quantity": 3
    },
    "copper": {
        "itemType": "shard-metal",
        "quantity": 9
    },
    "drumstick": {
        "itemType": "shard-metal",
        "quantity": 10
    },
    "feather": {
        "itemType": "shard-metal",
        "quantity": 10
    },
    "gold": {
        "itemType": "shard-metal",
        "quantity": 15
    },
    "hide": {
        "itemType": "shard-metal",
        "quantity": 2
    },
    "iron": {
        "itemType": "shard-metal",
        "quantity": 6
    },
    "metal-bar-copper": {
        "itemType": "shard-metal",
        "quantity": 45
    },
    "metal-bar-gold": {
        "itemType": "shard-metal",
        "quantity": 80
    },
    "metal-bar-iron": {
        "itemType": "shard-metal",
        "quantity": 30
    },
    "metal-bar-silver": {
        "itemType": "shard-metal",
        "quantity": 60
    },
    "silver": {
        "itemType": "shard-metal",
        "quantity": 12
    },
    "shield-crusader": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "shield-kite": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "shield-kite_blue": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "shield-kite_gray": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "shield-kite_green": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "shield-kite_red": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "shield-round": {
        "itemType": "shard-metal",
        "quantity": 120
    },
    "dagger": {
        "itemType": "shard-metal",
        "quantity": 10
    },
    "spear": {
        "itemType": "shard-metal",
        "quantity": 20
    }
};



const $7a0964f649e0c77d$export$5f8f4df3a4ea6bd = {
    "castlekey": {
        "stackable": true
    },
    "arrow": {
        "stackable": true,
        "isAmmo": true,
        "unsellable": true
    },
    "drumstick": {
        "useable": true,
        "useHasWorldEffect": true,
        "unbuyable": true
    },
    "feather": {
        "unsellable": true,
        "unbuyable": true
    },
    "flower-single-blue": {
        "unsellable": true,
        "unbuyable": true
    },
    "flower-single-purple": {
        "unsellable": true,
        "unbuyable": true
    },
    "flower-single-red": {
        "unsellable": true,
        "unbuyable": true
    },
    "flower-single-yellow": {
        "unsellable": true,
        "unbuyable": true
    },
    "hide": {
        "unbuyable": true
    },
    "mushroom-purple": {
        "useable": true,
        "useHasWorldEffect": true,
        "unbuyable": true
    },
    "mushroom-red": {
        "useable": true,
        "useHasWorldEffect": true,
        "unbuyable": true
    },
    "mushroom-yellow": {
        "useable": true,
        "useHasWorldEffect": true,
        "unbuyable": true
    },
    "rope": {
        "unbuyable": true
    },
    "seed": {
        "useable": true,
        "useHasWorldEffect": true,
        "unsellable": true,
        "unbuyable": true
    },
    "straw": {
        "unsellable": true,
        "unbuyable": true
    },
    "torch": {
        "useable": true
    },
    "wood": {
        "unbuyable": true
    },
    "campfire": {
        "useable": true,
        "useHasWorldEffect": true
    },
    "chest-wood": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true,
        "buildType": "entity"
    },
    "door-wood": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true,
        "buildType": "entity"
    },
    "floor-wood": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true,
        "buildType": "floor"
    },
    "roof-wood": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true,
        "buildType": "roof"
    },
    "snare-rabbit": {
        "useable": true,
        "useHasWorldEffect": true
    },
    "stool-small": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true
    },
    "table-large-rough": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useable": false,
        "useHasWorldEffect": true
    },
    "table-mid-round": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useable": false,
        "useHasWorldEffect": true
    },
    "wall-wood": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true,
        "buildType": "wall"
    },
    "wall2-wood": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true,
        "buildType": "wall"
    },
    "wall-stone": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true,
        "buildType": "wall"
    },
    "barrel1": {
        "unbuyable": true,
        "readyable": true,
        "buildable": true
    },
    "stackedBags": {
        "unbuyable": true,
        "readyable": true,
        "buildable": true
    },
    "stool1": {
        "unbuyable": true,
        "readyable": true,
        "buildable": true,
        "useable": false
    },
    "table-mid-rough": {
        "unbuyable": true,
        "readyable": true,
        "buildable": true,
        "useable": false
    },
    "strawBed": {
        "unbuyable": true,
        "readyable": true,
        "buildable": true,
        "useable": false
    },
    "strawBedSmall": {
        "unbuyable": true,
        "readyable": true,
        "buildable": true,
        "useable": false
    },
    "crossbow": {
        "unbuyable": true
    },
    "flail": {
        "unbuyable": true
    },
    "halberd": {
        "unbuyable": true
    },
    "longsword": {
        "unbuyable": true
    },
    "mace": {
        "unbuyable": true
    },
    "none": {
        "hasDurability": false
    },
    "rapier": {
        "unbuyable": true
    },
    "saber": {
        "unbuyable": true
    },
    "scythe": {
        "unbuyable": true
    },
    "staff": {
        "unbuyable": true
    },
    "waraxe": {
        "unbuyable": true
    },
    "warhammer": {
        "unbuyable": true
    }
};


const $94ca5c6c04d9c167$export$b7032dafe57f8d33 = {
    "armor": {
        "armor-leather": 0.1,
        "armor-legion": 0.2,
        "armor-plate": 0.3
    },
    "bauldron": {
        "bauldron": 0.05
    },
    "cape": {},
    "key": {},
    "pants": {
        "legion": 0.1,
        "pantaloons": 0.01,
        "pants-armor": 0.1,
        "skirts": 0.01
    },
    "resource": {},
    "shield": {
        "shield-crusader": 0.2,
        "shield-kite": 0.2,
        "shield-kite_blue": 0.2,
        "shield-kite_gray": 0.2,
        "shield-kite_green": 0.2,
        "shield-kite_red": 0.2,
        "shield-round": 0.1,
        "shield-spartan": 0.15
    },
    "shirt": {
        "blouse": 0.01,
        "blouse_longsleeve": 0.01,
        "corset": 0.01,
        "longsleeve": 0.01,
        "longsleeve_laced": 0.01,
        "scoop_shirt": 0.01,
        "sleeveless": 0.01,
        "sleeveless_laced": 0.01,
        "sleeveless_striped": 0.01,
        "tanktop": 0.01,
        "tunic": 0.01
    },
    "shoes": {
        "boots": 0.01,
        "sandals": 0.01,
        "shoes": 0.01,
        "shoes-armor": 0.1,
        "slippers": 0.01
    },
    "structure": {},
    "weapon": {}
};


const $56a75f3d82405d26$export$86a8c920ac50eefc = {
    "armor": {
        "armor-leather": 0.1,
        "armor-legion": 0.2,
        "armor-plate": 0.3
    },
    "bauldron": {
        "bauldron": 0.05
    },
    "cape": {},
    "key": {},
    "pants": {
        "legion": 0.1,
        "pants-armor": 0.1
    },
    "resource": {},
    "shield": {
        "shield-crusader": 0.2,
        "shield-kite": 0.2,
        "shield-kite_blue": 0.2,
        "shield-kite_gray": 0.2,
        "shield-kite_green": 0.2,
        "shield-kite_red": 0.2,
        "shield-round": 0.1,
        "shield-spartan": 0.15
    },
    "shirt": {},
    "shoes": {
        "shoes-armor": 0.1,
        "slippers": 0.01
    },
    "structure": {},
    "weapon": {
        "axe": 0.08,
        "bow": 0.05,
        "spear": 0.05,
        "staff": 0.05,
        "warhammer": 0.1
    }
};




var $5Io6y = parcelRequire("5Io6y");



var $5Io6y = parcelRequire("5Io6y");

const $c5de4107a36072bd$var$MAX_HEIGHT = 255;
class $c5de4107a36072bd$var$BiomeRange {
    constructor(min, max){
        this.fits = (value)=>{
            return this.min <= value && value <= this.max;
        };
        this.eval = (value)=>{
            const spread = this.max - this.min;
            const subRangeWidth = Math.floor(spread / 3);
            const mid = this.min + Math.floor((this.max - this.min) / 2);
            if (value < this.min) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min, this.min + subRangeWidth),
                evaluation: "low"
            };
            if (value > this.max) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth + subRangeWidth, this.max),
                evaluation: "high"
            };
            if ((0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(value, this.min, this.min + subRangeWidth)) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min, this.min + subRangeWidth),
                evaluation: "low"
            };
            if ((0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(value, this.min + subRangeWidth, this.min + subRangeWidth + subRangeWidth)) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth, this.min + subRangeWidth + subRangeWidth),
                evaluation: "mid"
            };
            if ((0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(value, this.min + subRangeWidth + subRangeWidth, this.max)) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth + subRangeWidth, this.max),
                evaluation: "high"
            };
            return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth, this.min + subRangeWidth + subRangeWidth),
                evaluation: "mid"
            };
        };
        this.min = min;
        this.max = max;
    }
}
class $c5de4107a36072bd$export$5b2d0fecb894d8ae {
    constructor(name, heightRange, tempRange, humidityRange, color){
        this.name = name;
        this.heightRange = heightRange;
        this.tempRange = tempRange;
        this.humidityRange = humidityRange;
        this.color = color;
    }
}
const $c5de4107a36072bd$export$251db8ae84045744 = [
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Abyss", new $c5de4107a36072bd$var$BiomeRange(0, 39), new $c5de4107a36072bd$var$BiomeRange(-10, 50), new $c5de4107a36072bd$var$BiomeRange(-10, Number.MAX_VALUE), 0x090140ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Ocean", new $c5de4107a36072bd$var$BiomeRange(40, 129), new $c5de4107a36072bd$var$BiomeRange(-10, 50), new $c5de4107a36072bd$var$BiomeRange(-10, Number.MAX_VALUE), 0x2107d8ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("IceLands", new $c5de4107a36072bd$var$BiomeRange(0, 170), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0x75fcf2ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Shore", new $c5de4107a36072bd$var$BiomeRange(130, 135), new $c5de4107a36072bd$var$BiomeRange(0, 50), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 50), 0xc7ce00ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("SnowyShore", new $c5de4107a36072bd$var$BiomeRange(130, 135), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0xedfca8ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Forest", new $c5de4107a36072bd$var$BiomeRange(140, 169), new $c5de4107a36072bd$var$BiomeRange(0, 25), new $c5de4107a36072bd$var$BiomeRange(5, 30), 0x128b03ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Plains", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(0, 50), new $c5de4107a36072bd$var$BiomeRange(0, 50), 0x40d115ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("FireLands", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(50, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 30), 0xe57307ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Tundra", new $c5de4107a36072bd$var$BiomeRange(140, 169), new $c5de4107a36072bd$var$BiomeRange(-10, 0), new $c5de4107a36072bd$var$BiomeRange(5, Number.MAX_VALUE), 0x745f4eff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Desert", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(30, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 5), 0xcbb848ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("GrassyHills", new $c5de4107a36072bd$var$BiomeRange(160, 189), new $c5de4107a36072bd$var$BiomeRange(5, 25), new $c5de4107a36072bd$var$BiomeRange(5, 30), 0x2e7612ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("ForestyHills", new $c5de4107a36072bd$var$BiomeRange(160, 189), new $c5de4107a36072bd$var$BiomeRange(5, 30), new $c5de4107a36072bd$var$BiomeRange(0, 30), 0x1b5504ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("MuddyHills", new $c5de4107a36072bd$var$BiomeRange(170, 189), new $c5de4107a36072bd$var$BiomeRange(0, 40), new $c5de4107a36072bd$var$BiomeRange(0, 50), 0x984319ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("DryHills", new $c5de4107a36072bd$var$BiomeRange(140, 189), new $c5de4107a36072bd$var$BiomeRange(10, 40), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), 0xc6950aff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("SnowyHills", new $c5de4107a36072bd$var$BiomeRange(170, 189), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0x1fa27cff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("DesertDunes", new $c5de4107a36072bd$var$BiomeRange(170, 189), new $c5de4107a36072bd$var$BiomeRange(30, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), 0x7e7109ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Volcano", new $c5de4107a36072bd$var$BiomeRange(170, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(30, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 35), 0xaf1109ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("RockyMountains", new $c5de4107a36072bd$var$BiomeRange(180, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 30), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 40), 0x43100dff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("IceMountains", new $c5de4107a36072bd$var$BiomeRange(180, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(5, Number.MAX_VALUE), 0x5b6a63ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Swamp", new $c5de4107a36072bd$var$BiomeRange(130, 170), new $c5de4107a36072bd$var$BiomeRange(0, 35), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), 0x052403ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("RainForest", new $c5de4107a36072bd$var$BiomeRange(140, 180), new $c5de4107a36072bd$var$BiomeRange(30, 40), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), 0x324b28ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("DryLands", new $c5de4107a36072bd$var$BiomeRange(0, 150), new $c5de4107a36072bd$var$BiomeRange(0, 40), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), 0x834c10ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Savannah", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(20, 50), new $c5de4107a36072bd$var$BiomeRange(-10, 10), 0x767618ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("GeyserLand", new $c5de4107a36072bd$var$BiomeRange(130, 170), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), 0x3a3b55ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("None", new $c5de4107a36072bd$var$BiomeRange(0, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0xe513c3ff)
];
const $c5de4107a36072bd$export$b4c1b9814b3bc6d2 = new Map();
$c5de4107a36072bd$export$251db8ae84045744.forEach((biome)=>$c5de4107a36072bd$export$b4c1b9814b3bc6d2.set(biome.name, biome));
const $c5de4107a36072bd$export$3a358f8b3ccaa20d = new Map();
$c5de4107a36072bd$export$251db8ae84045744.forEach((biome)=>$c5de4107a36072bd$export$3a358f8b3ccaa20d.set(biome.color >> 8, biome));
const $c5de4107a36072bd$export$93a7a078fd42971c = (h, temp, humidity)=>{
    const found = $c5de4107a36072bd$export$251db8ae84045744.find((biome)=>{
        if (biome.heightRange.fits(h)) {
            if (biome.tempRange.fits(temp)) {
                if (biome.humidityRange.fits(humidity)) return biome;
            }
        }
    });
    if (found) return found;
// throw Error("No biome fits the following parameters: height: " + h + ", temperature: " + temp + ", humidity: " + humidity)
};





//
// https://github.com/tlhunter/node-autotile
//
const $5cfd87a852590fa6$var$NW = Math.pow(2, 0);
const $5cfd87a852590fa6$var$N = Math.pow(2, 1);
const $5cfd87a852590fa6$var$NE = Math.pow(2, 2);
const $5cfd87a852590fa6$var$W = Math.pow(2, 3);
const $5cfd87a852590fa6$var$E = Math.pow(2, 4);
const $5cfd87a852590fa6$var$SW = Math.pow(2, 5);
const $5cfd87a852590fa6$var$S = Math.pow(2, 6);
const $5cfd87a852590fa6$var$SE = Math.pow(2, 7);
const $5cfd87a852590fa6$var$BITMASK = {
    2: 1,
    8: 2,
    10: 3,
    11: 4,
    16: 5,
    18: 6,
    22: 7,
    24: 8,
    26: 9,
    27: 10,
    30: 11,
    31: 12,
    64: 13,
    66: 14,
    72: 15,
    74: 16,
    75: 17,
    80: 18,
    82: 19,
    86: 20,
    88: 21,
    90: 22,
    91: 23,
    94: 24,
    95: 25,
    104: 26,
    106: 27,
    107: 28,
    120: 29,
    122: 30,
    123: 31,
    126: 32,
    127: 33,
    208: 34,
    210: 35,
    214: 36,
    216: 37,
    218: 38,
    219: 39,
    222: 40,
    223: 41,
    248: 42,
    250: 43,
    251: 44,
    254: 45,
    255: 46,
    0: 47
};
function $5cfd87a852590fa6$var$autotileLookup(map, x_boundary, y_boundary, x, y) {
    let sum = 0;
    let n = false;
    let e = false;
    let s = false;
    let w = false;
    if (!map[y][x]) return 0;
    if (y > 0 && map[y - 1][x]) {
        n = true;
        sum += $5cfd87a852590fa6$var$N;
    }
    if (x > 0 && map[y][x - 1]) {
        w = true;
        sum += $5cfd87a852590fa6$var$W;
    }
    if (x < x_boundary && map[y][x + 1]) {
        e = true;
        sum += $5cfd87a852590fa6$var$E;
    }
    if (y < y_boundary && map[y + 1][x]) {
        s = true;
        sum += $5cfd87a852590fa6$var$S;
    }
    if (n && w && y > 0 && x > 0 && map[y - 1][x - 1]) sum += $5cfd87a852590fa6$var$NW;
    if (n && e && y > 0 && x < x_boundary && map[y - 1][x + 1]) sum += $5cfd87a852590fa6$var$NE;
    if (s && w && y < y_boundary && x > 0 && map[y + 1][x - 1]) sum += $5cfd87a852590fa6$var$SW;
    if (s && e && x < x_boundary && y < y_boundary && map[y + 1][x + 1]) sum += $5cfd87a852590fa6$var$SE;
    return $5cfd87a852590fa6$var$BITMASK[sum];
}
const $5cfd87a852590fa6$export$6551c605d612f177 = new Set([
    1,
    2,
    3,
    5,
    6,
    8,
    9,
    13,
    14,
    15,
    16,
    18,
    19,
    21,
    22,
    47
]);
const $5cfd87a852590fa6$export$a936a6c53c1608e9 = (idx)=>{
    if (idx === 0) return true // no wall here
    ;
    if (idx === undefined) return false // wall with an unmapped neighbor configuration
    ;
    return $5cfd87a852590fa6$export$6551c605d612f177.has(idx);
};
const $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7 = (map)=>{
    const tiles = [];
    const height = map.length;
    const width = map[0].length;
    const x_boundary = width - 1;
    const y_boundary = height - 1;
    for(let y = 0; y < height; y++){
        tiles[y] = [];
        for(let x = 0; x < width; x++)tiles[y][x] = $5cfd87a852590fa6$var$autotileLookup(map, x_boundary, y_boundary, x, y);
    }
    return tiles;
};






const $2f4c91f2e2ac27f6$export$31f783804ea72f93 = (tilemapMetaProvider)=>{
    const { isOcclusionAt: isOcclusionAt } = tilemapMetaProvider;
    let polyMap = [];
    polyMap[0] = polyMap[1] = polyMap[2] = polyMap[3] = {
        a: {
            x: 0,
            y: 0
        },
        b: {
            x: 0,
            y: 0
        }
    };
    const occlusionMap = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(tilemapMetaProvider.width(), tilemapMetaProvider.height());
    for(let x = 0; x < tilemapMetaProvider.width(); x++)for(let y = 0; y < tilemapMetaProvider.height(); y++)occlusionMap[y][x] = isOcclusionAt(x, y) ? 1 : 0;
    const blockingAuto = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(occlusionMap);
    const evaluteAutotile = (x, y, autoId)=>{
        const polyMap = [];
        const o = {
            x: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
            y: y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
        };
        const offset = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
        if (autoId === 18) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        if (autoId === 8) polyMap.push({
            a: {
                x: o.x,
                y: o.y - offset + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            },
            b: {
                x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: o.y - offset + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 14) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y
            },
            b: {
                x: o.x + offset,
                y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 15) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x - offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
        }
        if (autoId === 6) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y - offset
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        if (autoId === 3) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y - offset
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x - offset,
                    y: o.y + offset
                }
            });
        }
        if (autoId === 5) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y + offset
            },
            b: {
                x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: o.y + offset
            }
        });
        if (autoId === 2) polyMap.push({
            a: {
                x: o.x - offset,
                y: o.y + offset
            },
            b: {
                x: o.x + offset,
                y: o.y + offset
            }
        });
        if (autoId === 13) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y
            },
            b: {
                x: o.x + offset,
                y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 1) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y
            },
            b: {
                x: o.x + offset,
                y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 19) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y
                },
                b: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        if (autoId === 21) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x - offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        return polyMap;
    };
    for(let x = 0; x < tilemapMetaProvider.width(); x++)for(let y = 0; y < tilemapMetaProvider.height(); y++){
        const autoId = blockingAuto[y][x];
        if (autoId) polyMap = polyMap.concat(evaluteAutotile(x, y, autoId));
    }
    return {
        vectorLines: polyMap,
        autotileMap: blockingAuto
    };
};
const $2f4c91f2e2ac27f6$export$57242d3f2812734b = (roomId, json, regionClass = [
    "REGION"
])=>{
    const { layers: layers } = json;
    const objectLayer = layers.find((layer)=>layer.name === "objects");
    if (!objectLayer) return {};
    return objectLayer.objects.filter((object)=>regionClass.includes(object.class)).reduce((acc, meta)=>{
        return {
            ...acc,
            [meta.name]: [
                ...acc[meta.name] || [],
                {
                    locationId: meta.name,
                    roomId: roomId,
                    x: Math.floor(meta.x),
                    y: Math.floor(meta.y),
                    bounds: new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(Math.floor(meta.x), Math.floor(meta.y), Math.floor(meta.x) + meta.width, Math.floor(meta.y) + meta.height),
                    context: (meta.properties || []).reduce((acc, next)=>({
                            ...acc,
                            [next.name]: next.value
                        }), {})
                }
            ]
        };
    }, {});
};
const $2f4c91f2e2ac27f6$export$8fcfa3699d7f98f4 = (roomId, json, regionClass = "REGION")=>{
    const regions = Object.values($2f4c91f2e2ac27f6$export$57242d3f2812734b(roomId, json, [
        "BIOMEREGION"
    ])).flat();
    return regions.reduce((acc, next)=>{
        return {
            ...acc,
            [next.context.biome]: [
                ...acc[next.context.biome] || [],
                next
            ]
        };
    }, {});
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = 'browser';
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ''; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391299e0893a3dfa$var$process.cwd = function() {
    return '/';
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


const $2db7e29a401f47a7$export$8eb3560959709dcf = "map3";
const $2db7e29a401f47a7$export$89f24ee63398b793 = {
    "lpc-terrain": {
        tilesetId: "lpc-terrain",
        firstgid: 1000
    },
    plants: {
        tilesetId: "plants",
        firstgid: 3000
    },
    "lpc-flowers-plants-fungi-wood": {
        tilesetId: "lpc-flowers-plants-fungi-wood",
        firstgid: 5000
    },
    "mountains-v6": {
        tilesetId: "mountains-v6",
        firstgid: 7000
    },
    ore: {
        tilesetId: "ore",
        firstgid: 10000
    },
    "jungle-ruins": {
        tilesetId: "jungle-ruins",
        firstgid: 12000
    },
    build_atlas: {
        tilesetId: "build_atlas",
        firstgid: 14000
    },
    "decorations-medieval": {
        tilesetId: "decorations-medieval",
        firstgid: 16000
    },
    roofs: {
        tilesetId: "roofs",
        firstgid: 19000
    },
    cottage: {
        tilesetId: "cottage",
        firstgid: 24000
    },
    walls: {
        tilesetId: "walls",
        firstgid: 34000
    },
    fence_medieval: {
        tilesetId: "fence_medieval",
        firstgid: 44000
    },
    container: {
        tilesetId: "container",
        firstgid: 54000
    },
    "furniture-blonde-wood": {
        tilesetId: "furniture-blonde-wood",
        firstgid: 64000
    },
    "beach-desert": {
        tilesetId: "beach-desert",
        firstgid: 74000
    },
    floors: {
        tilesetId: "floors",
        firstgid: 84000
    },
    walls2: {
        tilesetId: "walls2",
        firstgid: 94000
    }
};
const $2db7e29a401f47a7$export$bf11c92109ea6096 = {
    "lpc-terrain": {
        353: {
            34: 256,
            42: 257,
            26: 258,
            36: 288,
            28: 290,
            7: 320,
            12: 321,
            4: 322,
            33: 193,
            41: 194,
            44: 225,
            45: 226
        },
        676: {
            34: 643,
            42: 644,
            26: 645,
            36: 675,
            28: 677,
            7: 707,
            12: 708,
            4: 709,
            33: 580,
            41: 581,
            44: 612,
            45: 613
        }
    }
};
const $2db7e29a401f47a7$export$8ac3ec24b9478bb2 = {
    "lpc-terrain": {
        377: [
            // 0 - 13
            344,
            345,
            346,
            376,
            378,
            408,
            409,
            410,
            440,
            441,
            442,
            472,
            473,
            474,
            // 14 - 18
            223,
            222,
            191,
            190,
            5,
            // 19 - 22
            344,
            346,
            408,
            410
        ]
    },
    "mountains-v6": {
        837: [
            // 0 - 13
            772,
            773,
            774,
            836,
            838,
            900,
            901,
            902,
            964,
            965,
            966,
            1028,
            1029,
            1030,
            // 14 - 18
            839,
            835,
            1481,
            1483,
            -1,
            // 19 - 22
            772,
            774,
            900,
            902
        ],
        861: [
            796,
            797,
            798,
            860,
            862,
            924,
            925,
            926,
            988,
            989,
            990,
            1052,
            1053,
            1054,
            863,
            859,
            1505,
            1507,
            23,
            796,
            798,
            924,
            926
        ]
    }
};
class $2db7e29a401f47a7$var$MapLayerSpec {
    constructor(mapId, mapNumber, mapSizeX, mapSizeY){
        this.blank = true;
        this.autoTiles = new Map();
        this.toRowsWiseArray = (tile)=>{
            const rows = [];
            for(let y = 0; y < this.mapSizeY; y++){
                const row = [];
                rows.push(row);
                for(let x = 0; x < this.mapSizeX; x++){
                    const column = this.columns[x];
                    if (column) row.push(column[y] === tile ? 1 : 0);
                    else row.push(0);
                }
            }
            return rows;
        };
        this.toArray = ()=>{
            const array = [];
            for(let y = 0; y < this.mapSizeY; y++)for(let x = 0; x < this.mapSizeX; x++){
                const column = this.columns[x];
                if (column) array.push(column[y]);
            }
            return array;
        };
        this.get = (x, y)=>{
            const column = this.columns[x];
            if (column) return column[y] || 0;
            return 0;
        };
        this.set = (x, y, tile)=>{
            const column = this.columns[x];
            if (column) {
                column[y] = tile;
                return true;
            }
        };
        this.layerId = mapId;
        this.layerNumber = mapNumber;
        this.mapSizeX = mapSizeX;
        this.mapSizeY = mapSizeY;
        this.columns = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(mapSizeX, mapSizeY, 0);
    }
}
const $2db7e29a401f47a7$export$374a4bb324ec5c8 = {
    tilesetId: "lpc-terrain",
    tilePos: 121
};
class $2db7e29a401f47a7$export$2ca8f2f4218485cb {
    /**
     * Create a basic set of layers for a room (map1-6, sprite, blocking)
     */ static createBasicLayers(mapSizeX, mapSizeY) {
        const layers = {};
        // Create map layers (map1-6)
        for(let i = 1; i <= 6; i++)layers[`map${i}`] = new $2db7e29a401f47a7$var$MapLayerSpec(`map${i}`, i, mapSizeX, mapSizeY);
        // Create sprite layer
        const sprite = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite`, 7, mapSizeX, mapSizeY);
        sprite.sprite = true;
        layers.sprite = sprite;
        // Create blocking layer
        const blocking = new $2db7e29a401f47a7$var$MapLayerSpec(`blocking`, 8, mapSizeX, mapSizeY);
        blocking.blocking = true;
        layers.blocking = blocking;
        return layers;
    }
    /**
     * Create a complete set of layers including sky, occlusion, etc.
     */ static createFullLayers(mapSizeX, mapSizeY) {
        const subMapCount = 6;
        const sky3 = new $2db7e29a401f47a7$var$MapLayerSpec(`sky3`, subMapCount + 9, mapSizeX, mapSizeY);
        sky3.sky = true;
        const sky2 = new $2db7e29a401f47a7$var$MapLayerSpec(`sky2`, subMapCount + 8, mapSizeX, mapSizeY);
        sky2.sky = true;
        const sky = new $2db7e29a401f47a7$var$MapLayerSpec(`sky`, subMapCount + 7, mapSizeX, mapSizeY);
        sky.sky = true;
        const skyTrigger = new $2db7e29a401f47a7$var$MapLayerSpec(`skyTrigger`, subMapCount + 6, mapSizeX, mapSizeY);
        skyTrigger.skyTrigger = true;
        const occlusion = new $2db7e29a401f47a7$var$MapLayerSpec(`occlusion`, subMapCount + 5, mapSizeX, mapSizeY);
        occlusion.occlusion = true;
        const blocking = new $2db7e29a401f47a7$var$MapLayerSpec(`blocking`, subMapCount + 4, mapSizeX, mapSizeY);
        blocking.blocking = true;
        const sprite3 = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite3`, subMapCount + 3, mapSizeX, mapSizeY);
        sprite3.sprite = true;
        const sprite2 = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite2`, subMapCount + 2, mapSizeX, mapSizeY);
        sprite2.sprite = true;
        const sprite = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite`, subMapCount + 1, mapSizeX, mapSizeY);
        sprite.sprite = true;
        const layers = {
            sky: sky,
            sky2: sky2,
            sky3: sky3,
            skyTrigger: skyTrigger,
            occlusion: occlusion,
            blocking: blocking,
            sprite: sprite,
            sprite2: sprite2,
            sprite3: sprite3
        };
        for(let i = 1; i <= subMapCount; i++)layers[`map${i}`] = new $2db7e29a401f47a7$var$MapLayerSpec(`map${i}`, i, mapSizeX, mapSizeY);
        return layers;
    }
    /**
     * Create a blank room with specified dimensions and layer configuration
     */ static createBlankRoom(roomId, mapX, mapY, mapSizeX, mapSizeY, useFullLayers = true) {
        const layers = useFullLayers ? $2db7e29a401f47a7$export$2ca8f2f4218485cb.createFullLayers(mapSizeX, mapSizeY) : $2db7e29a401f47a7$export$2ca8f2f4218485cb.createBasicLayers(mapSizeX, mapSizeY);
        return {
            mapX: mapX,
            mapY: mapY,
            mapSizeX: mapSizeX,
            mapSizeY: mapSizeY,
            roomId: roomId,
            layers: layers,
            fineBiomes: (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(mapSizeX, mapSizeY, "")
        };
    }
    constructor(props){
        this.maps = {};
        this.objectId = 1;
        this.regionId = 1;
        this.objectSequenceId = 1;
        this.deferredMapEntries = [];
        this.finalizationEntries = [];
        this.featureEntries = [];
        this.featureCatalogs = (0, $adc2b7d4f0244689$export$cfd1f8c409da7c62).instance();
        this.pctChance = (pct)=>{
            // min and max included
            return (0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)(0, 100) >= 100 - pct;
        };
        this.randomIntBetween = (min, max)=>(0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)(min, max);
        this.random = ()=>(0, $a80d0b17b615d6f7$export$2b048c255d2e69f3)();
        this.randomOneOf = (list, options)=>{
            return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(list, {
                ...options ? {} : options,
                randomIntBetween: this.randomIntBetween
            });
        };
        this.randomFloatBetween = (min, max)=>{
            const str = (this.random() * (max - min) + min).toFixed(3);
            return parseFloat(str);
        };
        this.randomCoordinateWithinBounds = (bounds)=>{
            return (0, $a80d0b17b615d6f7$export$b1a407392a6eb119)(bounds, true);
        };
        this.getGlobal = (gX, gY, layerId, tilesetId)=>{
            const layer = this.getGlobalLayerFor(gX, gY, layerId);
            if (!layer) return 0;
            const x = gX % this.mapSize;
            const y = gY % this.mapSize;
            const absoluteTilePos = layer.get(x, y);
            if (tilesetId) {
                const tileset = $2db7e29a401f47a7$export$89f24ee63398b793[tilesetId];
                if (tileset) return absoluteTilePos - tileset.firstgid;
            }
            return absoluteTilePos;
        };
        this.setGlobal = (gX, gY, layerId, tile)=>{
            const layer = this.getGlobalLayerFor(gX, gY, layerId);
            if (!layer) return;
            const x = gX % this.mapSize;
            const y = gY % this.mapSize;
            return layer.set(x, y, tile);
        };
        this.getGlobalLayerFor = (gX, gY, layerId)=>{
            const roomId = `${this.roomPrefix}-${Math.floor(gX / this.mapSize)}-${Math.floor(gY / this.mapSize)}`;
            const map = this.maps[roomId];
            if (!map) return;
            return map.layers[layerId];
        };
        // random mountain
        this.scanPoint = (biome, gX, gY)=>{
            const bX = this.biomeMap[gX];
            const bY = bX ? bX[gY] : undefined;
            if (bY && bY.name === biome) return true;
            return false;
        };
        this.applyEntries = (mapEntries = [], roomMetas)=>{
            const meetsContainment = (x, y, containmentBiome, containmentRange)=>{
                let contained = true;
                const stride = containmentRange;
                for(let sY = -stride; sY <= stride; sY++){
                    for(let sX = -stride; sX <= stride; sX++)if (!this.scanPoint(containmentBiome, sX + x, sY + y)) {
                        contained = false;
                        break;
                    }
                    if (!contained) break;
                }
                return contained;
            };
            mapEntries.forEach((entry)=>{
                const { tileSpec: tileSpec, layerId: layerId, x: x, y: y, containmentBiome: containmentBiome, containmentRange: containmentRange, forcedContainmentOk: forcedContainmentOk, replacer: replacer, adder: adder, feature: feature } = entry;
                if (tileSpec.tilePos < 0) {
                    // remove
                    const mapLayer = this.globalMap.layers[layerId];
                    mapLayer.set(x, y, 0);
                    this.setGlobal(x, y, layerId, 0);
                } else if (feature) {
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = forcedContainmentOk || !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) feature();
                } else if (replacer) {
                    // replace
                    const firstgid = $2db7e29a401f47a7$export$89f24ee63398b793[tileSpec.tilesetId].firstgid;
                    const mapLayer = this.globalMap.layers[layerId];
                    const absoluteTilePos = mapLayer.get(x, y);
                    const currentTilePos = absoluteTilePos - firstgid;
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) {
                        const updatedTileSpec = replacer(currentTilePos);
                        if (updatedTileSpec !== undefined) {
                            const replacementFirstgid = $2db7e29a401f47a7$export$89f24ee63398b793[updatedTileSpec.tilesetId].firstgid;
                            const updatedTileId = replacementFirstgid + updatedTileSpec.tilePos;
                            mapLayer.set(x, y, updatedTileId);
                            this.setGlobal(x, y, layerId, updatedTileId);
                        }
                    }
                } else if (adder) {
                    /// add
                    const firstgid = $2db7e29a401f47a7$export$89f24ee63398b793[tileSpec.tilesetId].firstgid;
                    const mapLayer = this.globalMap.layers[layerId];
                    const absoluteTilePos = mapLayer.get(x, y);
                    const currentTilePos = absoluteTilePos - firstgid;
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = forcedContainmentOk || !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) {
                        const { tiles: addedTileSpecs, featureRegionMeta: featureRegionMeta, pointMeta: pointMeta } = adder(currentTilePos, entry.mapId, x, y) || {
                            tiles: []
                        };
                        if (pointMeta && roomMetas) {
                            const roomMeta = roomMetas.get(entry.mapId);
                            pointMeta.forEach((point)=>{
                                roomMeta.featurePoints.push(point);
                            });
                        }
                        if (featureRegionMeta && roomMetas) {
                            const roomMeta = roomMetas.get(entry.mapId);
                            featureRegionMeta.forEach((regionMeta)=>{
                                const found = roomMeta.features.find((n)=>n.region.x === regionMeta.x && n.region.y === regionMeta.y);
                                if (found) return;
                                const region = this.toFeatureRegion(regionMeta.x, regionMeta.y, regionMeta.width, regionMeta.height, regionMeta.id || (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(), regionMeta.context);
                                const feature = {
                                    roomId: entry.mapId,
                                    spawnLocation: {
                                        x: regionMeta.x,
                                        y: regionMeta.y
                                    },
                                    type: "feature",
                                    region: region,
                                    bounds: new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(regionMeta.x, regionMeta.y, regionMeta.x + regionMeta.width, regionMeta.y + regionMeta.height),
                                    featureSpriteMeta: [],
                                    subFeaturesMeta: [],
                                    subFeaturesRegions: [],
                                    featurePoints: [],
                                    postFeatureMapEntries: [],
                                    mapFeature: regionMeta.mapFeature
                                };
                                roomMeta.features.push(feature);
                            });
                        }
                        addedTileSpecs.forEach((addedTileSpec)=>{
                            const addedTileContainmentBiome = addedTileSpec.containmentBiome || containmentBiome;
                            const addedContaimentRange = addedTileSpec.containmentRange || containmentRange;
                            const addedTileX = addedTileSpec?.x || x;
                            const addedTileY = addedTileSpec?.y || y;
                            const addedNeedsContainment = !!addedTileContainmentBiome && !!addedContaimentRange;
                            const addedContained = !addedNeedsContainment || meetsContainment(addedTileX, addedTileY, addedTileContainmentBiome, addedContaimentRange);
                            if (addedContained) {
                                const replacementFirstgid = $2db7e29a401f47a7$export$89f24ee63398b793[addedTileSpec.tilesetId].firstgid;
                                const updatedTileId = replacementFirstgid + addedTileSpec.tilePos;
                                const updatedTileMapLayer = this.globalMap.layers[addedTileSpec.mapLayerId];
                                const current = updatedTileMapLayer.get(addedTileX, addedTileY);
                                if (addedTileSpec.overwrite || !current) {
                                    if (addedTileSpec.tilePos < 1) {
                                        // remove
                                        updatedTileMapLayer.set(addedTileX, addedTileY, 0);
                                        this.setGlobal(addedTileX, addedTileY, addedTileSpec.mapLayerId, 0);
                                    } else {
                                        updatedTileMapLayer.set(addedTileX, addedTileY, updatedTileId);
                                        this.setGlobal(addedTileX, addedTileY, addedTileSpec.mapLayerId, updatedTileId);
                                    }
                                }
                            }
                        });
                    }
                } else {
                    // set
                    const firstgid = $2db7e29a401f47a7$export$89f24ee63398b793[tileSpec.tilesetId].firstgid;
                    const tileId = firstgid + tileSpec.tilePos;
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) {
                        const mapLayer = this.globalMap.layers[layerId];
                        mapLayer.set(x, y, tileId);
                        if (tileSpec.autotileMap) mapLayer.autoTiles.set(tileId, tileSpec.autotileMap);
                        this.setGlobal(x, y, layerId, tileId);
                        this.getGlobalLayerFor(x, y, layerId)?.autoTiles.set(tileId, tileSpec.autotileMap);
                    }
                }
            });
        };
        this.applyAutotiling = (mapSpec, callback)=>{
            const s = new Set();
            for (let tileId of mapSpec.autoTiles.keys()){
                const autoTileSpec = mapSpec.autoTiles.get(tileId);
                const rowsWise = mapSpec.toRowsWiseArray(tileId);
                const autoTiled = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(rowsWise);
                const thisLayerNumber = mapSpec.layerNumber;
                const layerUpNumber = thisLayerNumber + (autoTileSpec.mapLayerYDelta || 1);
                const layerUpId = `map${layerUpNumber}`;
                for(let y = 0; y < mapSpec.mapSizeY; y++){
                    const row = autoTiled[y];
                    for(let x = 0; x < mapSpec.mapSizeX; x++){
                        const colValue = row[x];
                        const tileVariant = autoTileSpec.tiles[colValue];
                        const tilesetId = autoTileSpec.tilesetId;
                        const layerIdTouse = typeof tileVariant === "number" ? layerUpId : typeof tileVariant?.tile === "number" ? layerUpId : tileVariant?.tile?.namedTileLayerId || layerUpId;
                        if (tileVariant !== undefined) callback(x, y, tilesetId, tileVariant, colValue, layerUpNumber, layerIdTouse);
                        else {
                            if (autoTileSpec.tilePos === 353) s.add(colValue);
                            // record
                            if (![
                                46,
                                0
                            ].includes(colValue)) {
                                const tileset = $2db7e29a401f47a7$export$89f24ee63398b793[tilesetId];
                                console.log("miss", tilesetId, tileId - tileset.firstgid, (0, $a80d0b17b615d6f7$export$f4f894b5dc700a2d)(x, y, this.mapSize, this.mapSize), `global ${x}, ${y}`, colValue);
                            }
                            if (![
                                46,
                                0
                            ].includes(colValue)) {
                                if (mapSpec.layerId === "map1") callback(x, y, "lpc-terrain", autoTileSpec.autoTileFallback || 100, -1, layerUpNumber, layerIdTouse);
                                else callback(x, y, tilesetId, -1, colValue, layerUpNumber, layerIdTouse);
                            }
                        }
                    }
                }
            }
            if (s.size > 0) console.log("missing", s);
        };
        this.toTiledLayer = (mapSpec)=>{
            const campaigns = (this.globalMapProperties.campaigns || []).map((campaign)=>({
                    name: `campaign:${campaign}`,
                    type: "string",
                    value: ""
                }));
            const tiled = {
                data: mapSpec.toArray(),
                height: mapSpec.mapSizeY,
                id: mapSpec.layerNumber,
                name: mapSpec.layerId,
                opacity: mapSpec.blocking || mapSpec.occlusion ? 0.175 : 1,
                properties: [
                    mapSpec.blocking ? {
                        name: "blocking",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.sky ? {
                        name: "sky",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.skyTrigger ? {
                        name: "skyTrigger",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.sprite ? {
                        name: "sprite",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.layerId === $2db7e29a401f47a7$export$8eb3560959709dcf ? {
                        name: "entityTileSurface",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:encounters",
                        type: "string",
                        value: ""
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:default",
                        type: "string",
                        value: "hide_room_name:true"
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:standard",
                        type: "string",
                        value: ""
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:respawn",
                        type: "string",
                        value: ""
                    } : undefined,
                    ...campaigns
                ].filter((n)=>!!n),
                type: "tilelayer",
                visible: true,
                width: mapSpec.mapSizeX,
                x: 0,
                y: 0
            };
            return tiled;
        };
        this.toTiledTileset = (tileSetSpec)=>{
            const rootDir = `${$391299e0893a3dfa$exports.cwd()}/../..`;
            const tiled = {
                firstgid: tileSetSpec.firstgid,
                source: `${rootDir}/content/tiled/${tileSetSpec.tilesetId}.tsx`
            };
            return tiled;
        };
        this.toMapPath = (mapName)=>{
            const rootDir = `${$391299e0893a3dfa$exports.cwd()}/../..`;
            return `${rootDir}/packages/server/assets/templates/${mapName}.tmj`;
        };
        this.toWorldMetaPath = ()=>{
            const rootDir = `${$391299e0893a3dfa$exports.cwd()}/../..`;
            return `${rootDir}/packages/server/assets/world/world_meta.json`;
        };
        this.toSpawnRegion = (x, y, width, height, spawner)=>{
            return {
                class: "REGION",
                height: height,
                id: ++this.objectId,
                name: `spawn-region-${++this.objectSequenceId}`,
                properties: [
                    {
                        name: "spawner",
                        type: "string",
                        value: JSON.stringify(spawner, null, 1)
                    }
                ],
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toMapSpriteCap = (x, y, context)=>{
            return {
                class: "mapSpriteCap",
                height: 0,
                id: ++this.objectId,
                name: "",
                point: true,
                rotation: 0,
                visible: true,
                width: 0,
                x: x,
                y: y,
                properties: context ? [
                    {
                        name: "context",
                        type: "string",
                        value: JSON.stringify(context, null, 1)
                    }
                ] : undefined
            };
        };
        this.toDebugObject = (text, x, y)=>{
            return {
                class: "",
                height: 18,
                id: ++this.objectId,
                name: "",
                rotation: 0,
                text: {
                    text: text,
                    wrap: true,
                    color: "#ff2600"
                },
                visible: true,
                width: 84,
                x: x + 8,
                y: y + 8
            };
        };
        this.toFeatureRegion = (x, y, width, height, feature, context)=>{
            return {
                class: "FEATURE_REGION",
                height: height,
                id: ++this.objectId,
                name: `feature-region-${++this.objectSequenceId}`,
                properties: [
                    {
                        name: "feature",
                        type: "string",
                        value: feature
                    },
                    context ? {
                        name: "context",
                        type: "string",
                        value: JSON.stringify(context, null, 1)
                    } : undefined
                ].filter((n)=>!!n),
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toFeatureSpriteRegion = (fragmentSpriteMeta)=>{
            const properties = fragmentSpriteMeta.spriteEntries.map((next)=>{
                return {
                    name: `${next.x},${next.y}^${next.id}`,
                    type: "string",
                    value: JSON.stringify({
                        context: next.context,
                        tileId: next.tilePos
                    })
                };
            });
            if (!!fragmentSpriteMeta.context) properties.push({
                name: "context",
                type: "string",
                value: JSON.stringify(fragmentSpriteMeta.context)
            });
            return {
                class: "FEATURE_SPRITE_REGION",
                height: fragmentSpriteMeta.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                id: ++this.objectId,
                name: `feature-sprite-region-${++this.objectSequenceId}`,
                properties: properties,
                rotation: 0,
                visible: true,
                width: fragmentSpriteMeta.width * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                x: fragmentSpriteMeta.location.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: fragmentSpriteMeta.location.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            };
        };
        this.toBiomeRegion = (x, y, width, height, biome)=>{
            return {
                class: "BIOMEREGION",
                height: height,
                id: ++this.objectId,
                name: `biome-region-${++this.objectSequenceId}`,
                properties: [
                    {
                        name: "biome",
                        type: "string",
                        value: biome
                    }
                ],
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toNavRegion = (x, y, width, height, map, deltaMapX, deltaMapY)=>{
            const nextMapX = map.mapX + deltaMapX;
            const nextMapY = map.mapY + deltaMapY;
            if (nextMapX < 0 || nextMapY < 0 || nextMapX > this.mapWidth || nextMapY > this.mapHeight) return null;
            const nextRoomId = `${this.roomPrefix}-${nextMapX}-${nextMapY}`;
            return {
                class: "REGION",
                height: height,
                id: ++this.objectId,
                name: `nav-region-${++this.regionId}`,
                properties: [
                    {
                        name: "navToRoomId",
                        type: "string",
                        value: nextRoomId
                    },
                    {
                        name: "deltaMapX",
                        type: "number",
                        value: deltaMapX
                    },
                    {
                        name: "deltaMapY",
                        type: "number",
                        value: deltaMapY
                    }
                ],
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toObjectLayer = (map, biomes, biomeSpawners, features, featurePoints)=>{
            return {
                draworder: "topdown",
                id: 1,
                name: "objects",
                objects: [
                    {
                        class: "LOCATION",
                        height: 0,
                        id: ++this.objectId,
                        name: "spawn",
                        point: true,
                        rotation: 0,
                        visible: true,
                        width: 0,
                        x: this.defaultSpawnCoordinate?.x || 800,
                        y: this.defaultSpawnCoordinate?.y || 800
                    },
                    // north
                    this.toNavRegion(0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeX, 4, map, 0, -1),
                    // south
                    this.toNavRegion(0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (map.mapSizeY - 1) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeX, 4, map, 0, 1),
                    // east
                    this.toNavRegion((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (map.mapSizeX - 1) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, 0, 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeY, map, 1, 0),
                    // west
                    this.toNavRegion(0, 0, 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeY, map, -1, 0),
                    ...biomes,
                    ...biomeSpawners,
                    ...features.map((feature)=>feature.region),
                    ...features.map((feature)=>feature.featureSpriteMeta).flat(),
                    ...features.map((feature)=>{
                        return feature.subFeaturesRegions.flat();
                    }).flat(),
                    ...features.map((feature)=>feature.featurePoints).flat().map((point)=>({
                            class: "LOCATION",
                            height: 0,
                            id: ++this.objectId,
                            name: point.id,
                            point: true,
                            rotation: 0,
                            visible: true,
                            width: 0,
                            x: point.location.x,
                            y: point.location.y,
                            properties: [
                                {
                                    name: "context",
                                    value: point.context
                                }
                            ]
                        })),
                    ...features.map((feature)=>feature.debug).flat(),
                    ...featurePoints.flat().map((point)=>({
                            class: "LOCATION",
                            height: 0,
                            id: ++this.objectId,
                            name: point.id,
                            point: true,
                            rotation: 0,
                            visible: true,
                            width: 0,
                            x: point.location.x,
                            y: point.location.y,
                            properties: [
                                {
                                    name: "context",
                                    value: point.context
                                }
                            ]
                        }))
                ].filter((n)=>!!n),
                opacity: 1,
                type: "objectgroup",
                visible: true,
                x: 0,
                y: 0
            };
        };
        this.toVisibility = (id)=>{
            return {
                draworder: "topdown",
                id: id,
                name: "visibility",
                objects: [],
                opacity: 1,
                properties: [
                    this.globalMapProperties.autoVisibility !== undefined ? {
                        name: "auto",
                        type: "bool",
                        value: this.globalMapProperties.autoVisibility
                    } : undefined,
                    this.globalMapProperties.fullOcclusion !== undefined ? {
                        name: "fullOcclusion",
                        type: "bool",
                        value: this.globalMapProperties.fullOcclusion
                    } : undefined,
                    this.globalMapProperties.darkness !== undefined ? {
                        name: "darkness",
                        type: "number",
                        value: this.globalMapProperties.darkness
                    } : undefined
                ].filter((n)=>!!n),
                type: "objectgroup",
                visible: true,
                x: 0,
                y: 0
            };
        };
        this.analyzeBiomeSector = (map, bX, bY)=>{
            const biomeCounts = {};
            for(let gX = bX * 10; gX < bX * 10 + 10; gX++)for(let gY = bY * 10; gY < bY * 10 + 10; gY++){
                const biomeName = map.fineBiomes[gX][gY];
                let count = biomeCounts[biomeName] || 0;
                biomeCounts[biomeName] = count + 1;
            }
            let maxCount = 0;
            let max = "";
            Object.keys(biomeCounts).forEach((biome)=>{
                const count = biomeCounts[biome];
                if (count > maxCount) {
                    max = biome;
                    maxCount = count;
                }
            });
            return max;
        };
        this.biomeSpawnMeta = (biome)=>{
            if (biome === "Plains_high") return {
                strategy: "lineOfSight",
                diurnal: {
                    creatures: [
                        {
                            race: "rabbit",
                            probability: 0.5
                        },
                        {
                            race: "snake",
                            probability: 0.1
                        },
                        {
                            race: "chicken",
                            probability: 0.5
                        },
                        {
                            race: "bee",
                            probability: 0.5
                        },
                        {
                            race: "wasp",
                            probability: 0.1,
                            hp: 1,
                            minQuantity: 5,
                            maxQuantity: 8,
                            exemptFromMax: true
                        }
                    ],
                    max: 2
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 0.8,
                            hp: 3,
                            bufferTs: 5000,
                            maxQuantity: 2,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        }
                    ],
                    max: 2
                }
            };
            if (biome === "Plains_mid") return {
                strategy: "lineOfSight",
                diurnal: {
                    creatures: [
                        {
                            race: "rabbit",
                            probability: 0.5
                        },
                        {
                            race: "rabbit",
                            probability: 0.5
                        },
                        {
                            race: "chicken",
                            probability: 0.5
                        },
                        {
                            race: "deer",
                            probability: 0.5
                        },
                        {
                            race: "bee",
                            probability: 0.3
                        },
                        {
                            race: "wasp",
                            probability: 0.1,
                            hp: 2,
                            minQuantity: 3,
                            maxQuantity: 5,
                            exemptFromMax: true
                        }
                    ],
                    max: 1
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 0.8,
                            hp: 2,
                            bufferTs: 5000,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        }
                    ],
                    max: 1
                }
            };
            if (biome === "Forest") return {
                strategy: "random",
                diurnal: {
                    creatures: [
                        {
                            race: "slime",
                            probability: 1.0
                        },
                        {
                            race: "chicken",
                            probability: 0.5
                        },
                        {
                            race: "bee",
                            probability: 0.2
                        }
                    ],
                    max: 4
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 1.0,
                            hp: 3,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        }
                    ],
                    max: 1
                }
            };
            if (biome === "Swamp") return {
                strategy: "lineOfSight",
                diurnal: {
                    creatures: [
                        {
                            race: "redspider",
                            probability: 0.5
                        },
                        {
                            race: "slime",
                            probability: 0.5
                        }
                    ],
                    max: 4
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 1.0,
                            hp: 3,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        },
                        {
                            race: "redspider",
                            probability: 1.0
                        }
                    ],
                    max: 1
                }
            };
            return null;
        };
        this.analyzeMapBiomeSectors = (map)=>{
            const width = map.mapSizeX;
            const height = map.mapSizeY;
            const spawners = [];
            const biomes = [];
            for(let bX = 0; bX < Math.floor(width / 10); bX++)for(let bY = 0; bY < Math.floor(height / 10); bY++){
                // const mapId = map.roomId
                const biome = this.analyzeBiomeSector(map, bX, bY);
                if (biome) {
                    const region = this.toBiomeRegion(bX * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), bY * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), biome);
                    biomes.push(region);
                }
                const biomeMeta = this.biomeSpawnMeta(biome);
                if (biomeMeta) {
                    const region = this.toSpawnRegion(bX * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), bY * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), biomeMeta);
                    spawners.push(region);
                }
            }
            return {
                spawners: spawners,
                biomes: biomes,
                features: [],
                featurePoints: []
            };
        };
        this.extractWorldMeta = ()=>{
            const worldMeta = {
                id: `world-${this.random()}`,
                dimensions: {
                    width: this.globalWidth,
                    height: this.globalHeight,
                    roomWidth: this.mapSize,
                    roomHeight: this.mapSize,
                    quadrantWidth: this.quadrantDimensions.w,
                    quadrantHeight: this.quadrantDimensions.h,
                    roomsCountX: Math.floor(this.globalWidth / this.mapSize),
                    roomsCountY: Math.floor(this.globalHeight / this.mapSize),
                    sectorWidth: 10,
                    sectorHeight: 10
                },
                roomBiomesDirectory: {},
                biomesToRooms: {},
                allBiomes: [],
                biomeColorMap: [],
                locationIconsMap: {},
                geographicFeatures: {},
                mapFeatures: {}
            };
            const roomMeta = new Map();
            //
            // establish world room biomes
            //
            const biomesSet = new Set();
            Object.values(this.maps).forEach((map)=>{
                const roomId = map.roomId;
                const meta = this.analyzeMapBiomeSectors(map);
                meta.id = roomId;
                roomMeta.set(roomId, meta);
                const { biomes: biomes } = meta;
                const roomBiomes = biomes.reduce((acc, next)=>acc.indexOf(next.properties[0].value) > -1 ? acc : [
                        ...acc,
                        next.properties[0].value
                    ], []);
                roomBiomes.forEach((biome)=>{
                    biomesSet.add(biome);
                    if (!worldMeta.biomesToRooms[biome]) worldMeta.biomesToRooms[biome] = [];
                    if (worldMeta.biomesToRooms[biome].indexOf(roomId) < 0) worldMeta.biomesToRooms[biome].push(roomId);
                });
                worldMeta.roomBiomesDirectory[roomId] = roomBiomes;
            });
            worldMeta.allBiomes = Array.from(biomesSet);
            return {
                worldMeta: worldMeta,
                roomMeta: roomMeta
            };
        };
        this.fillFragmentDetails = (roomId, mapX, mapY, x, y, offset, fragmentMaps, renderStrategy, mapEntries, spriteEntries, context, locationCallback, logIt)=>{
            const bounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(-1, -1, -1, -1);
            Object.keys(fragmentMaps).forEach((layer)=>{
                const fragmentMap = fragmentMaps[layer];
                bounds.widenViaCoordinate({
                    x: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (x + offset.x),
                    y: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (y + offset.y)
                });
                bounds.widenViaCoordinate({
                    x: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (x + fragmentMap.length + offset.x),
                    y: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (y + fragmentMap[0].length + offset.y)
                });
                for(let rx = 0; rx < fragmentMap.length; rx++)for(let ry = 0; ry < fragmentMap[0].length; ry++){
                    const value = fragmentMap[rx][ry];
                    if (!!value) {
                        if (renderStrategy === "default" || layer === "blocking") {
                            const gX = mapX * this.mapSize + x + rx + offset.x;
                            const gY = mapY * this.mapSize + y + ry + offset.y;
                            if (locationCallback) locationCallback(gX, gY);
                            const tilesetPlatformAutotile = $2db7e29a401f47a7$export$8ac3ec24b9478bb2[value.tilesetId];
                            const platformAutoTileMeta = tilesetPlatformAutotile ? tilesetPlatformAutotile[value.tilePos] : undefined;
                            if (platformAutoTileMeta) mapEntries.push($2db7e29a401f47a7$export$f4de484c835405db({
                                mapId: roomId,
                                tilesetId: value.tilesetId,
                                layerId: layer,
                                tile: value.tilePos,
                                variants: platformAutoTileMeta,
                                x: gX,
                                y: gY
                            }));
                            else mapEntries.push({
                                mapId: roomId,
                                tileSpec: value,
                                layerId: layer,
                                x: gX,
                                y: gY
                            });
                        }
                        if (renderStrategy === "sprite" && layer !== "blocking") {
                            const mapEntry = {
                                id: `${offset.x},${offset.y}`,
                                x: x + rx + offset.x,
                                y: y + ry + offset.y,
                                tilePos: value.tilePos + $2db7e29a401f47a7$export$89f24ee63398b793[value.tilesetId].firstgid,
                                context: context
                            };
                            spriteEntries.push(mapEntry);
                        }
                    }
                }
            });
            return bounds;
        };
        this.buildFeatureFragment = (featureFragment, x, y, mapX, mapY, roomId, featurePoints, mapSpriteCaps)=>{
            const { fragmentMaps: fragmentMaps, renderStrategy: renderStrategy, id: id, dimensions: dimensions, points: points, fragmentPointers: fragmentPointers, mapSpriteCaps: mapSpriteCapsRaw, context: context } = featureFragment;
            points.filter((p)=>!p.context?.fragmentPointer).forEach((point)=>{
                const fineMapX = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.x;
                const fineMapY = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.y;
                const p = {
                    ...point,
                    location: {
                        x: fineMapX,
                        y: fineMapY
                    }
                };
                featurePoints.push(p);
            });
            // record map mutations
            const mapEntries = [];
            const postFeatureMapEntries = [];
            const subFeatures = [];
            const fragmentSpriteMeta = {
                id: id,
                width: dimensions.w,
                height: dimensions.h,
                mapEntries: mapEntries,
                postFeatureMapEntries: postFeatureMapEntries,
                spriteEntries: [],
                location: {
                    x: x,
                    y: y
                },
                context: context,
                subFeatures: subFeatures
            };
            fragmentPointers.forEach((pointer)=>{
                const context = pointer.context ? JSON.parse(pointer.context) : undefined;
                if (context?.fragmentPointer) {
                    const { catalog: catalog, category: category, subCategory: subCategory, tag: tagRaw, context: fragmentPointerContext } = context.fragmentPointer;
                    let tag = tagRaw;
                    if (tagRaw?.includes("|")) tag = this.randomOneOf(tagRaw.split("|"));
                    const fragment = this.featureCatalogs.randomFeature(catalog, category, subCategory, tag);
                    if (fragment) {
                        const contextToUse = {
                            ...fragment?.context || {},
                            ...fragmentPointerContext || {}
                        };
                        const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(pointer.location);
                        const fragmentMaps = fragment.fragmentMaps;
                        const bounds = this.fillFragmentDetails(roomId, mapX, mapY, x, y, rough, fragmentMaps, fragment.renderStrategy, postFeatureMapEntries, fragmentSpriteMeta.spriteEntries, contextToUse, undefined, fragment.tag === "bucket2");
                        // fragment pointers can be things like doors, so we should capture
                        // enough information about them to create regions
                        const regionMeta = {
                            id: `${roomId}-${fragment.category || "category"}-${fragment.subcategory || "subcategory"}-${fragment.tag || "tag"}`,
                            fragment: fragment,
                            bounds: bounds,
                            context: contextToUse
                        };
                        subFeatures.push(regionMeta);
                    }
                }
            });
            if (mapSpriteCapsRaw) mapSpriteCapsRaw.forEach((point)=>{
                const fineMapX = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.x;
                const fineMapY = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.y;
                const p = {
                    x: fineMapX,
                    y: fineMapY
                };
                mapSpriteCaps.push(p);
            });
            this.fillFragmentDetails(roomId, mapX, mapY, x, y, {
                x: 0,
                y: 0
            }, fragmentMaps, renderStrategy, mapEntries, fragmentSpriteMeta.spriteEntries);
            return fragmentSpriteMeta;
        };
        this.printFeature = (featureFragment, featureLocation, mapX, mapY, roomId, featureSprites, featurePoints, postFeatureMapEntries, mapSpriteCaps)=>{
            const fragmentSpriteMeta = this.buildFeatureFragment(featureFragment, featureLocation.x, featureLocation.y, mapX, mapY, roomId, featurePoints, mapSpriteCaps);
            const { mapEntries: mapEntries, spriteEntries: spriteEntries, subFeatures: subFeatures, postFeatureMapEntries: postMapEntries } = fragmentSpriteMeta;
            this.applyEntries(mapEntries);
            if (spriteEntries.length > 0 || subFeatures.length > 0) featureSprites.push(fragmentSpriteMeta);
            postMapEntries.forEach((entry)=>postFeatureMapEntries.push(entry));
        };
        this.createDefenders = ()=>{
            const context = {
                npcMeta: {
                    npc: {
                        type: "zombie",
                        weaponTypeRange: [
                            "axe",
                            "dagger",
                            "dagger",
                            "spear",
                            "bow"
                        ],
                        faction: "wild",
                        appearance: {
                            race: "wolfman",
                            sex: "male",
                            bodyColor: "brown",
                            inventoryAppearanceHash: ""
                        },
                        speed: (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.fromPctOfMax(Math.random())
                    },
                    brainProps: {
                        shooter: true,
                        scanner: true,
                        seeker: "astar",
                        scanPlayersOnly: false,
                        psychProfile: {
                            hostility: (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.psych.hostility().fromPctOfMax(this.randomFloatBetween(0.1, 0.5)),
                            aggroResponse: "pause"
                        },
                        targetLocationOffset: {
                            x: this.randomIntBetween(-(0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
                            y: this.randomIntBetween(-(0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
                        },
                        targetLocationMaxDistance: 5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    }
                }
            };
            return context;
        };
        this.buildFeatures = (worldMeta, roomMeta)=>{
        // todo
        };
        this.roomBounds = ()=>{
            const roomBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(0, 0, this.mapSize * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), this.mapSize * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            return roomBounds;
        };
        this.applyGlobalBoundaries = ()=>{
            for(let x = 0; x < this.globalWidth; x++){
                this.setGlobal(x, 0, "blocking", 121);
                this.setGlobal(x, this.globalHeight - 1, "blocking", 121);
            }
            for(let y = 0; y < this.globalHeight; y++){
                this.setGlobal(0, y, "blocking", 121);
                this.setGlobal(this.globalWidth - 1, y, "blocking", 121);
            }
        };
        this.buildResources = (worldMeta, roomMetas)=>{
            Array.from(roomMetas.keys()).forEach((roomId)=>{
                const roomMeta = roomMetas.get(roomId);
                roomMeta.biomes.forEach((biome)=>{
                    const biomeType = biome.properties.find((p)=>p.name === "biome")?.value;
                    if (biomeType === "Plains_mid") {
                        const biomeBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(biome.x, biome.y, biome.x + biome.width, biome.y + biome.height);
                        (0, $a80d0b17b615d6f7$export$76d90c956114f2c2)(()=>{
                            roomMeta.featurePoints.push({
                                id: "RESOURCE",
                                location: (0, $a80d0b17b615d6f7$export$b1a407392a6eb119)(biomeBounds, true),
                                context: JSON.stringify({
                                    itemType: this.pctChance(60) ? "flower-single-purple" : this.randomOneOf([
                                        "flower-single-blue",
                                        "flower-single-red",
                                        "flower-single-yellow"
                                    ])
                                })
                            });
                        }, this.randomIntBetween(2, 4));
                    }
                    if (biomeType === "Forest") {
                        const biomeBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(biome.x, biome.y, biome.x + biome.width, biome.y + biome.height);
                        (0, $a80d0b17b615d6f7$export$76d90c956114f2c2)(()=>{
                            roomMeta.featurePoints.push({
                                id: "RESOURCE",
                                location: (0, $a80d0b17b615d6f7$export$b1a407392a6eb119)(biomeBounds, true),
                                context: JSON.stringify({
                                    itemType: this.pctChance(60) ? "mushroom-red" : this.randomOneOf([
                                        "mushroom-purple",
                                        "mushroom-yellow"
                                    ])
                                })
                            });
                        }, this.randomIntBetween(1, 2));
                    }
                });
            });
        };
        this.mapPropertyBuilder = (map)=>{
            return [];
        };
        this.genLocationIcons = (output)=>{
            const rooms = Array.from(output.roomMaps.keys()).map((mapId)=>output.roomMaps.get(mapId));
            const locationIconsMap = {};
            const toMinimapCoordinates = (roomId, fineCoordinate)=>{
                const [_, roomX, roomY] = roomId.split("-");
                const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(fineCoordinate);
                const roughRoomX = rough.x;
                const roughRoomY = rough.y;
                const biomeX = roughRoomX / 10;
                const biomeY = roughRoomY / 10;
                const x = Math.floor(Number(roomX) * 5 + biomeX);
                const y = Math.floor(Number(roomY) * 5 + biomeY);
                return {
                    x: x,
                    y: y
                };
            };
            rooms.forEach((roomJson)=>{
                const roomIdToUse = roomJson?.properties?.find((property)=>property.name === "roomId")?.value;
                Object.values((0, $2f4c91f2e2ac27f6$export$57242d3f2812734b)(roomIdToUse, roomJson, [
                    "REGION",
                    "FEATURE_REGION"
                ])).flat().forEach((region)=>{
                    if (region.context?.context) {
                        const regionExtraContext = JSON.parse(region.context.context);
                        if (regionExtraContext.locationIcon) {
                            const location = region.bounds.center();
                            const minimapCoordinates = toMinimapCoordinates(roomIdToUse, location);
                            const { x: x, y: y } = minimapCoordinates;
                            const locationIcon = {
                                id: `${roomIdToUse}-${x}-${y}-${regionExtraContext.locationName}`,
                                roomId: roomIdToUse,
                                x: x,
                                y: y,
                                icon: regionExtraContext.locationIcon,
                                initialMapFeature: regionExtraContext.initialMapFeature,
                                noProximitySpawn: regionExtraContext.noProximitySpawn,
                                name: regionExtraContext.locationName
                            };
                            locationIconsMap[`${x}-${y}`] = locationIcon;
                        }
                    }
                });
            });
            return locationIconsMap;
        };
        const { w: width, h: height } = props.globalSize;
        this.globalWidth = width;
        this.globalHeight = height;
        this.globalMapProperties = props.mapProperties;
        this.roomPrefix = props.roomPrefix;
        this.quadrantDimensions = props.quadrantSize;
        this.mapSize = props.mapSize;
        this.mapWidth = width / props.mapSize;
        this.mapHeight = height / props.mapSize;
        for(let x = 0; x < this.mapWidth; x++)for(let y = 0; y < this.mapHeight; y++){
            const roomId = `${this.roomPrefix}-${x}-${y}`;
            this.maps[roomId] = $2db7e29a401f47a7$export$2ca8f2f4218485cb.createBlankRoom(roomId, x, y, this.mapSize, this.mapSize, true);
        }
        this.globalMap = $2db7e29a401f47a7$export$2ca8f2f4218485cb.createBlankRoom("global", 0, 0, width, height, true);
    }
    toRoomOutputPath(roomId) {
        const rootDir = `${$391299e0893a3dfa$exports.cwd()}/../..`;
        return `${rootDir}/packages/server/assets/rooms/${roomId}.tmj`;
    }
    finalize() {
        const { worldMeta: worldMeta, roomMeta: roomMeta } = this.extractWorldMeta();
        this.roomMeta = roomMeta;
        const output = {
            worldMeta: worldMeta,
            roomMaps: new Map()
        };
        // apply post-terraforming features
        // baseline tiles
        this.applyGlobalBoundaries();
        this.applyEntries(this.deferredMapEntries);
        this.buildFeatures(worldMeta, roomMeta);
        this.buildResources(worldMeta, roomMeta);
        this.applyEntries(this.featureEntries);
        // apply autotiling
        Object.values(this.globalMap.layers).forEach((layer)=>{
            this.applyAutotiling(layer, (gX, gY, tilesetId, autotileVariantTile, variantPos, layerUpNumber, layerUpId)=>{
                const tileMeta = typeof autotileVariantTile === "number" ? autotileVariantTile : autotileVariantTile.tile;
                const decorations = (typeof autotileVariantTile === "number" ? [] : autotileVariantTile.decorations || []).filter((n)=>!!n);
                const tileset = $2db7e29a401f47a7$export$89f24ee63398b793[tilesetId];
                const baseTile = typeof tileMeta === "number" ? tileMeta : tileMeta?.tile;
                if (baseTile === -1) {
                    // erase
                    const mapLayer = this.globalMap.layers[layerUpId];
                    mapLayer.set(gX, gY, 0);
                    this.setGlobal(gX, gY, layer.layerId, 0);
                    return;
                }
                const tile = baseTile + tileset.firstgid;
                // paste it into the next layer up
                const mapLayer = this.globalMap.layers[layerUpId];
                mapLayer.set(gX, gY, tile);
                this.setGlobal(gX, gY, layerUpId, tile);
                // remove original
                this.setGlobal(gX, gY, layer.layerId, 0);
                decorations.forEach((decoration)=>{
                    const decorationTilesetId = decoration.tilesetId;
                    const decorationFirstGid = decorationTilesetId ? $2db7e29a401f47a7$export$89f24ee63398b793[decorationTilesetId].firstgid : tileset.firstgid;
                    const decorationLayerId = decoration.namedTileLayerId || `map${(decoration.mapLayerYDelta || 0) + layerUpNumber}`;
                    this.setGlobal(gX + (decoration.offsetX || 0), gY + (decoration.offsetY || 0), decorationLayerId, decoration.tile + decorationFirstGid);
                });
                const noUnderTile = typeof autotileVariantTile === "number" ? false : autotileVariantTile.noUndertile;
                if (!noUnderTile) {
                    // get adjacent tile to put it under current layer
                    let gXDelta = 0;
                    let gyDelta = 0;
                    switch(variantPos){
                        case 2:
                        case 3:
                        case 15:
                        case 27:
                        case 28:
                        case 31:
                            gXDelta = 1;
                            break;
                        case 26:
                        case 44:
                            gXDelta = 1;
                            gyDelta = -1;
                            break;
                        case 12:
                        case 13:
                            gyDelta = 1;
                            break;
                        case 5:
                        case 8:
                        case 10:
                        case 42:
                            gyDelta = -1;
                            break;
                        case 36:
                            gXDelta = -1;
                            break;
                        case 25:
                        case 1:
                            gXDelta = -1;
                            break;
                        case 4:
                        case 33:
                            gXDelta = 1;
                            gyDelta = 1;
                            break;
                        case 45:
                            gXDelta = -1;
                            gyDelta = -1;
                            break;
                        case 11:
                        case 41:
                            gXDelta = -1;
                            gyDelta = 1;
                            break;
                        case 7:
                        case 17:
                        case 35:
                        case 14:
                        case 18:
                        case 20:
                        case 29:
                        case 40:
                        case 34:
                        case 32:
                            gXDelta = -1;
                            break;
                    }
                    if (gXDelta || gyDelta) {
                        const replaceTile = this.getGlobal(gX + gXDelta, gY + gyDelta, layer.layerId);
                        if (replaceTile !== 0) this.setGlobal(gX, gY, layer.layerId, replaceTile);
                    }
                }
            });
        });
        this.applyEntries(this.finalizationEntries, roomMeta);
        //
        // finalize rooms
        //
        Object.values(this.maps).forEach((map)=>{
            const { biomes: biomes, spawners: spawners, features: features, featurePoints: featurePoints } = roomMeta.get(map.roomId);
            features.forEach((feature)=>{
                const mapEntries = feature.postFeatureMapEntries;
                this.applyEntries(mapEntries);
            });
            const layers = [
                ...Object.values(map.layers).sort((a, b)=>a.layerNumber - b.layerNumber).map((layer)=>this.toTiledLayer(layer)),
                this.toObjectLayer(map, biomes, spawners, features, featurePoints)
            ];
            layers.push(this.toVisibility(layers.length + 1));
            const tiled = {
                compressionlevel: -1,
                height: map.mapSizeY,
                infinite: false,
                layers: layers,
                nextlayerid: 2,
                nextobjectid: this.objectId + 1,
                orientation: "orthogonal",
                properties: [
                    {
                        name: "name",
                        type: "string",
                        value: this.globalMapProperties?.name || map.roomId
                    },
                    {
                        name: "roomId",
                        type: "string",
                        value: map.roomId
                    },
                    {
                        name: "triggers",
                        type: "string",
                        value: "[]"
                    },
                    {
                        name: "dayPhaseSupported",
                        type: "boolean",
                        value: this.globalMapProperties?.dayPhaseSupported
                    },
                    {
                        name: "suppressMinimap",
                        type: "boolean",
                        value: this.globalMapProperties?.suppressMinimap
                    },
                    {
                        name: "mapX",
                        type: "string",
                        value: map.mapX
                    },
                    {
                        name: "mapY",
                        type: "string",
                        value: map.mapY
                    },
                    ...this.mapPropertyBuilder(map)
                ],
                renderorder: "right-down",
                tiledversion: "1.9.0",
                tileheight: 32,
                tilesets: Object.values($2db7e29a401f47a7$export$89f24ee63398b793).map((next)=>this.toTiledTileset(next)),
                tilewidth: 32,
                type: "map",
                version: "1.9",
                width: map.mapSizeX
            };
            output.roomMaps.set(map.roomId, tiled);
            const stringified = JSON.stringify(tiled);
            const roomOutputPath = this.toRoomOutputPath(map.roomId);
            if (roomOutputPath) $5Io6y.writeFileSync(roomOutputPath, stringified);
        });
        worldMeta.biomeColorMap = this.genBiomeColorMap(output);
        worldMeta.locationIconsMap = this.genLocationIcons(output);
        worldMeta.geographicFeatures = this.genGeographicFeatures(output);
        worldMeta.mapFeatures = this.genMapFeatures(output, roomMeta);
        // persist worldmeta
        const worldMetaPath = this.toWorldMetaPath();
        if (worldMetaPath) $5Io6y.writeFileSync(this.toWorldMetaPath(), JSON.stringify(worldMeta, null, 1));
        return output;
    }
    genBiomeColorMap(output) {
        const rooms = Array.from(output.roomMaps.keys()).map((mapId)=>output.roomMaps.get(mapId));
        const biomeWidth = 10;
        const biomeHeight = 10;
        const { worldMeta: worldMeta } = output;
        const dimensions = worldMeta.dimensions;
        const width = dimensions.roomsCountX * (dimensions.roomWidth / biomeWidth);
        const height = dimensions.roomsCountY * (dimensions.roomHeight / biomeHeight);
        const roomBiomeHeight = Math.floor(dimensions.roomHeight / biomeHeight);
        const roomBiomeWidth = Math.floor(dimensions.roomWidth / biomeWidth);
        const colorMap = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height, 0);
        rooms.forEach((roomJson)=>{
            const roomIdToUse = roomJson?.properties?.find((property)=>property.name === "roomId")?.value;
            const biomeRegions = Object.values((0, $2f4c91f2e2ac27f6$export$8fcfa3699d7f98f4)(roomIdToUse, roomJson)).flat();
            const worldMapX = roomJson.properties.find((property)=>property.name === "mapX")?.value;
            const worldMapY = roomJson.properties.find((property)=>property.name === "mapY")?.value;
            biomeRegions.forEach((region)=>{
                const roughBounds = (0, $a80d0b17b615d6f7$export$7b8c2026ce8c6d5e)({
                    w: dimensions.roomWidth,
                    h: dimensions.roomHeight
                }, region.bounds);
                const biomeNameFull = region.context?.biome;
                const biomeName = biomeNameFull.split("_")[0];
                const biomeColor = (0, $c5de4107a36072bd$export$b4c1b9814b3bc6d2).get(biomeName).color >> 8;
                const biomeX = Math.floor(roughBounds.x1 / biomeWidth);
                const biomeY = Math.floor(roughBounds.y1 / biomeHeight);
                const x = worldMapX * roomBiomeWidth + biomeX;
                const y = worldMapY * roomBiomeHeight + biomeY;
                colorMap[x][y] = biomeColor;
            });
        });
        return colorMap;
    }
    genMapFeatures(output, roomMetas) {
        const featureTypeMap = new Map();
        const worldFeatures = {};
        roomMetas.forEach((roomMeta, key)=>{
            roomMeta.features?.forEach((feature)=>{
                const mapFeature = feature.mapFeature;
                if (mapFeature) {
                    const ff = featureTypeMap.get(mapFeature.type) || [];
                    ff.push(mapFeature);
                    featureTypeMap.set(mapFeature.type, ff);
                }
            });
        });
        featureTypeMap.forEach((ff, type)=>{
            worldFeatures[type] = ff;
        });
        return worldFeatures;
    }
    genGeographicFeatures(output) {
        const { worldMeta: worldMeta } = output;
        function detectFeatures(image, threshold) {
            let features = [];
            for(let y = 0; y < image.length; y++){
                for(let x = 0; x < image[0].length; x++)if (!belongsToExistingFeature([
                    x,
                    y
                ], features)) {
                    let newFeature = regionGrowing(image, [
                        x,
                        y
                    ], threshold);
                    features.push(newFeature);
                }
            }
            return features;
        }
        function belongsToExistingFeature(point, features) {
            for (let feature of features){
                if (feature.some((p)=>p[0] === point[0] && p[1] === point[1])) return true;
            }
            return false;
        }
        function regionGrowing(image, seed, threshold) {
            let region = [
                seed
            ];
            let stack = [
                seed
            ];
            while(stack.length > 0){
                let point = stack.pop();
                let neighbors = getNeighbors(point);
                for (let neighbor of neighbors)if (isSimilar(image[point[0]]?.[point[1]], image[neighbor[0]]?.[neighbor[1]], threshold) && !region.some((p)=>p[0] === neighbor[0] && p[1] === neighbor[1])) {
                    region.push(neighbor);
                    stack.push(neighbor);
                }
            }
            return region;
        }
        function getNeighbors(point) {
            let [x, y] = point;
            return [
                [
                    x - 1,
                    y
                ],
                [
                    x + 1,
                    y
                ],
                [
                    x,
                    y - 1
                ],
                [
                    x,
                    y + 1
                ]
            ] // 4-connectivity
            ;
        }
        function isSimilar(color1, color2, threshold) {
            return Math.abs(color1 - color2) <= threshold;
        }
        const f = detectFeatures(worldMeta.biomeColorMap, 0).filter((n)=>n.length > 10 && n.length < 200);
        const biomeFeatures = {};
        f.forEach((feature)=>{
            const [x, y] = feature[0];
            // console.log(i, x, ",", y)
            const color = worldMeta.biomeColorMap[x][y];
            const biome = (0, $c5de4107a36072bd$export$3a358f8b3ccaa20d).get(color);
            if (biome) {
                const name = (0, $a80d0b17b615d6f7$export$9a81a17686f0f9cf)("elf", {
                    gender: "male"
                }).toString();
                const biomeCoordinates = [];
                const geographicFeature = {
                    id: `${x}-${y}-${biome.name}`,
                    biome: biome.name,
                    name: name,
                    biomeCoordinates: biomeCoordinates
                };
                feature.forEach((coordinate)=>{
                    const [cx, cy] = coordinate;
                    geographicFeature.biomeCoordinates.push({
                        x: cx,
                        y: cy
                    });
                });
                const features = biomeFeatures[biome.name] || [];
                features.push(geographicFeature);
                biomeFeatures[biome.name] = features;
            }
        });
        return biomeFeatures;
    }
}
const $2db7e29a401f47a7$export$f4de484c835405db = ({ mapId: mapId, tile: tile, tilesetId: tilesetId, layerId: layerId, variants: variants, x: x, y: y, containmentBiome: containmentBiome, containmentRange: containmentRange, autoBlocking: autoBlocking = true, autoOcclusion: autoOcclusion = false })=>{
    const blocking = autoBlocking ? {
        tilesetId: "lpc-terrain",
        namedTileLayerId: "blocking",
        tile: 121
    } : undefined;
    const occlusion = autoOcclusion ? {
        tilesetId: "lpc-terrain",
        namedTileLayerId: "occlusion",
        tile: 121
    } : undefined;
    const autotileMap = {
        tilePos: tile,
        tilesetId: tilesetId,
        mapLayerYDelta: 2,
        tiles: {
            34: {
                tile: variants[0],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            43: {
                tile: variants[1],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            42: {
                tile: variants[1],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            26: {
                tile: variants[2],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            ////////////////////////////////////
            36: {
                tile: variants[3],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            40: {
                tile: variants[3],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            28: {
                tile: variants[4],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            31: {
                tile: variants[4],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            ////////////////////////////////////
            7: {
                tile: variants[5],
                decorations: [
                    variants[8] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[8]
                    } : undefined,
                    variants[11] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[11]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            12: {
                tile: variants[6],
                decorations: [
                    variants[9] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[9]
                    } : undefined,
                    variants[12] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[12]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            25: {
                tile: variants[6],
                decorations: [
                    variants[9] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[9]
                    } : undefined,
                    variants[12] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[12]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            4: {
                tile: variants[7],
                decorations: [
                    variants[10] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[10]
                    } : undefined,
                    variants[13] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[13]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            ////////////////////////////////////
            ////////////////////////////////////
            33: {
                tile: variants[14],
                decorations: [
                    variants[9] != -1 ? {
                        mapLayerYDelta: -1,
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[9]
                    } : undefined,
                    variants[12] != -1 ? {
                        mapLayerYDelta: -1,
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[12]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            41: {
                tile: variants[15],
                decorations: [
                    variants[9] != -1 ? {
                        mapLayerYDelta: -1,
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[9]
                    } : undefined,
                    variants[12] != -1 ? {
                        mapLayerYDelta: -1,
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[12]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            ////////////////////////////////////
            44: {
                tile: variants[16],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            45: {
                tile: variants[17],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            ////////////////////////////////////
            // top left
            35: {
                tile: variants[19]
            },
            37: {
                tile: variants[19]
            },
            // top right
            27: {
                tile: variants[20],
                decorations: blocking ? [
                    blocking
                ] : undefined
            },
            29: {
                tile: variants[20],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            // bottom left
            32: {
                tile: variants[21],
                decorations: [
                    variants[8] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[8]
                    } : undefined,
                    variants[11] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[11]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            11: {
                tile: variants[21],
                decorations: [
                    variants[8] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[8]
                    } : undefined,
                    variants[11] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[11]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            20: {
                tile: variants[21],
                decorations: [
                    variants[8] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[8]
                    } : undefined,
                    variants[11] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[11]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            // bottom right
            10: {
                tile: variants[22],
                decorations: [
                    variants[10] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[10]
                    } : undefined,
                    variants[13] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[13]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            },
            17: {
                tile: variants[22],
                decorations: [
                    variants[10] != -1 ? {
                        offsetX: 0,
                        offsetY: 1,
                        tile: variants[10]
                    } : undefined,
                    variants[13] != -1 ? {
                        offsetX: 0,
                        offsetY: 2,
                        tile: variants[13]
                    } : undefined,
                    blocking,
                    occlusion
                ]
            }
        }
    };
    Object.values(autotileMap.tiles).forEach((t)=>t.noUndertile = true);
    const tileSpec = {
        tilesetId: tilesetId,
        tilePos: tile,
        autotileMap: autotileMap
    };
    const mapEntry = {
        mapId: mapId,
        tileSpec: tileSpec,
        layerId: layerId,
        x: x,
        y: y,
        containmentRange: containmentRange,
        containmentBiome: containmentBiome
    };
    return mapEntry;
};



class $adc2b7d4f0244689$export$cfd1f8c409da7c62 {
    static{
        this.globalFeatureCatalog = null;
    }
    static{
        this.instance = ()=>{
            if (!this.globalFeatureCatalog) this.globalFeatureCatalog = new $adc2b7d4f0244689$export$cfd1f8c409da7c62();
            return this.globalFeatureCatalog;
        };
    }
    constructor(){
        this.catalogs = {};
        this.fragmentByItemType = {};
        this.itemTypeMetaDescriptors = [];
        this.toMapPath = (mapName)=>{
            const rootDir = `${$391299e0893a3dfa$exports.cwd()}/../..`;
            return `${rootDir}/packages/server/assets/templates/${mapName}.tmj`;
        };
        this.featureByTag = (catalog, tag)=>this.randomFeature(catalog, null, null, tag);
        this.featureByFragmentPointer = (fragmentPointer)=>this.featureByTag(fragmentPointer.catalog, fragmentPointer.tag);
        this.randomFeature = (catalog, category, subCategory, tag)=>{
            const catalogMeta = this.catalogs[catalog];
            if (!catalogMeta) return;
            const matches = catalogMeta.fragments.filter((n)=>(!category || n.category === category) && (!subCategory || n.subcategory === subCategory) && (!tag || n.tag === tag));
            if (matches?.length < 1) return;
            return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(matches, {
                randomIntBetween: (0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)
            });
        };
        this.analyze = (catalogId, mapObj)=>{
            const mapLayers = {};
            const { width: width, height: height, layers: layers, tilesets: tilesets } = mapObj;
            //
            // parse tileset specs
            //
            const tilesetSpecs = tilesets.map((meta)=>{
                const tilesetParts = meta.source.split("/");
                const tilesetId = tilesetParts[tilesetParts.length - 1].split(".")[0];
                return {
                    tilesetId: tilesetId,
                    firstgid: meta.firstgid
                };
            }).sort((a, b)=>b.firstgid - a.firstgid);
            const resolveTileSet = (tileId)=>{
                const id = Number(tileId);
                for(let i = 0; i < tilesetSpecs.length; i++){
                    const tileset = tilesetSpecs[i];
                    if (id >= tileset.firstgid) return tileset;
                }
            };
            //
            // parse tilemaps and fragments
            //
            let fragments = [];
            let featurePoints = [];
            let mapSpriteCaps = [];
            layers.forEach((mapLayer)=>{
                const matrix = $adc2b7d4f0244689$var$blankTileMap(width, height);
                let hasData = false;
                mapLayer.data?.forEach((next, index)=>{
                    const x = index % width;
                    const y = Math.floor(index / width);
                    const tileset = resolveTileSet(`${next}`);
                    const rawId = tileset ? Math.max(0, next - tileset.firstgid) : 0;
                    if (rawId) {
                        hasData = true;
                        const autotileMapTileset = (0, $2db7e29a401f47a7$export$bf11c92109ea6096)[tileset.tilesetId];
                        const autotileMap = autotileMapTileset ? autotileMapTileset[rawId] : undefined;
                        matrix[x][y] = {
                            tilesetId: tileset.tilesetId,
                            tilePos: rawId,
                            autotileMap: autotileMap ? {
                                tilesetId: tileset.tilesetId,
                                tiles: autotileMap
                            } : undefined
                        };
                    }
                });
                if (hasData && mapLayer.type === "tilelayer") mapLayers[mapLayer.name] = matrix;
                if (mapLayer.type === "objectgroup") {
                    fragments = mapLayer.objects.filter((next)=>next.class === "FRAGMENT");
                    featurePoints = mapLayer.objects.filter((next)=>next.class === "FRAGMENT_POINT");
                    mapSpriteCaps = mapLayer.objects.filter((next)=>next.class === "mapSpriteCap");
                }
            });
            const featureFragments = fragments.filter((fragment)=>!fragment.point).map((fragment)=>{
                const fragmentBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(fragment.x, fragment.y, fragment.x + fragment.width, fragment.y + fragment.height);
                const fragX = Math.floor(fragment.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragY = Math.floor(fragment.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragWidth = Math.floor(fragment.width / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragHeight = Math.floor(fragment.height / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragmentMaps = {};
                Object.keys(mapLayers).forEach((layer)=>{
                    const fragmentMap = $adc2b7d4f0244689$var$blankTileMap(fragWidth, fragHeight);
                    fragmentMaps[layer] = fragmentMap;
                });
                // extract map slices
                let fx = 0;
                let fy = 0;
                let good = new Set();
                for(let x = fragX; x < fragX + fragWidth; x++){
                    fy = 0;
                    for(let y = fragY; y < fragY + fragHeight; y++){
                        Object.keys(mapLayers).forEach((layer)=>{
                            const value = mapLayers[layer][x][y];
                            fragmentMaps[layer][fx][fy] = value;
                            if (value) good.add(layer);
                        });
                        fy++;
                    }
                    fx++;
                }
                Object.keys(fragmentMaps).filter((k)=>!good.has(k)).forEach((layer)=>{
                    delete fragmentMaps[layer];
                });
                const mapSpriteCapsPoints = mapSpriteCaps.filter((p)=>{
                    return fragmentBounds.includes({
                        x: p.x,
                        y: p.y
                    });
                }).map((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    const context = contextRaw ? JSON.parse(contextRaw) : undefined;
                    return {
                        id: p.name,
                        location: {
                            x: p.x - fragment.x,
                            y: p.y - fragment.y
                        },
                        context: context
                    };
                });
                const points = featurePoints.filter((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    const context = contextRaw ? JSON.parse(contextRaw) : undefined;
                    return !context?.fragmentPointer && fragmentBounds.includes({
                        x: p.x,
                        y: p.y
                    });
                }).map((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    return {
                        id: p.name,
                        location: {
                            x: p.x - fragment.x,
                            y: p.y - fragment.y
                        },
                        context: contextRaw
                    };
                });
                const fragmentPointers = featurePoints.filter((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    const context = contextRaw ? JSON.parse(contextRaw) : undefined;
                    return !!context?.fragmentPointer && fragmentBounds.includes({
                        x: p.x,
                        y: p.y
                    });
                }).map((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    return {
                        id: p.name,
                        location: {
                            x: p.x - fragment.x,
                            y: p.y - fragment.y
                        },
                        context: contextRaw
                    };
                });
                const fragmentContextRaw = fragment.properties.find((p)=>p.name === "context")?.value;
                const craftableMetaRaw = fragment.properties.find((p)=>p.name === "craftableMeta")?.value;
                const itemTypeMetaDescriptorRaw = fragment.properties.find((p)=>p.name === "itemTypeMeta")?.value;
                const craftableMeta = craftableMetaRaw ? JSON.parse(craftableMetaRaw) : undefined;
                const itemTypeMetaDescriptor = itemTypeMetaDescriptorRaw ? JSON.parse(itemTypeMetaDescriptorRaw) : undefined;
                const fragmentMeta = {
                    id: fragment.name,
                    fragmentMaps: fragmentMaps,
                    category: fragment.properties.find((p)=>p.name === "category").value,
                    subcategory: fragment.properties.find((p)=>p.name === "subcategory")?.value,
                    renderStrategy: fragment.properties.find((p)=>p.name === "renderStrategy")?.value || "default",
                    tag: fragment.properties.find((p)=>p.name === "tag")?.value || undefined,
                    dimensions: {
                        w: fragWidth,
                        h: fragHeight
                    },
                    points: points,
                    fragmentPointers: fragmentPointers,
                    mapSpriteCaps: mapSpriteCapsPoints,
                    context: fragmentContextRaw ? JSON.parse(fragmentContextRaw) : undefined,
                    craftableMeta: craftableMeta,
                    itemTypeMetaDescriptor: itemTypeMetaDescriptor
                };
                if (craftableMeta) this.fragmentByItemType[craftableMeta.itemType] = {
                    catalog: catalogId,
                    tag: fragmentMeta.tag
                };
                if (itemTypeMetaDescriptor) this.itemTypeMetaDescriptors.push(itemTypeMetaDescriptor);
                return fragmentMeta;
            });
            const featureCatalog = {
                id: catalogId,
                fragments: featureFragments
            };
            this.catalogs[catalogId] = featureCatalog;
            return featureCatalog;
        };
        const catalogs = [
            "ruins",
            "settlement",
            "geo",
            "caves",
            "item"
        ];
        catalogs.forEach((catalog)=>{
            const mapPath = this.toMapPath(catalog);
            const catalogIdParts = mapPath.split("/");
            const catalogId = catalogIdParts[catalogIdParts.length - 1].split(".")[0];
            const content = $5Io6y.readFileSync(mapPath).toString();
            const mapObj = JSON.parse(content);
            this.analyze(catalogId, mapObj);
        });
    }
}
const $adc2b7d4f0244689$var$blankTileMap = (width, height)=>{
    const matrix = [];
    for(let x = 0; x < width; x++){
        const column = [];
        matrix.push(column);
        for(let y = 0; y < height; y++)column.push();
    }
    return matrix;
};




// Structures held back from the crafting list even though everything else in their class is shown.
//
// wall-stone costs 3 planks -- exactly what a wooden wall costs, with no stone in it at all. Hidden,
// that was a data quirk; shown, it is two walls at the same price where one sounds strictly better.
// It comes back when it costs something of its own.
const $6db9b00381e87aee$var$UNLISTED_STRUCTURES = [
    "wall-stone"
];
class $6db9b00381e87aee$var$Weight {
    static{
        this.maximumItemWeight = 15;
    }
    static{
        this.maximumTotalItemWeight = 0;
    }
    static{
        this.maximumTotalItemWeight = (0, $b5d7776bdc108009$export$6a0fc7ad27079d24).map((type)=>{
            const itemTypeWeights = (0, $56a75f3d82405d26$export$86a8c920ac50eefc)[type] || {};
            const sorted = Object.keys(itemTypeWeights).map((t)=>itemTypeWeights[t]).sort();
            return sorted[sorted.length - 1] || 0;
        }).reduce((a, n)=>a + n * this.maximumItemWeight, 0);
    }
    static{
        this.computeItemWeight = (item)=>{
            const { itemTypeMeta: itemTypeMeta } = item;
            if (!itemTypeMeta) return 0;
            const { type: type } = itemTypeMeta;
            const itemTypes = (0, $56a75f3d82405d26$export$86a8c920ac50eefc)[itemTypeMeta.class];
            if (!itemTypes) return 0;
            return (itemTypes[type] || 0) * this.maximumItemWeight;
        };
    }
    static{
        this.computeWeight = (inventory)=>{
            // only consider active (equipped) items
            const activeItems = inventory.items?.filter((item)=>item.active);
            return activeItems?.map((i)=>this.computeItemWeight(i)).reduce((a, n)=>a + n, 0);
        };
    }
    static{
        this.computeWeightPctOfMax = (inventory)=>{
            const f = this.computeWeight(inventory);
            return f / this.maximumTotalItemWeight;
        };
    }
}
class $6db9b00381e87aee$var$Protection {
    static{
        this.maximumItemProtection = 15;
    }
    static{
        this.maximumTotalItemProtection = 0;
    }
    static{
        this.maximumTotalItemProtection = (0, $b5d7776bdc108009$export$6a0fc7ad27079d24).map((type)=>{
            const itemTypeProtections = (0, $94ca5c6c04d9c167$export$b7032dafe57f8d33)[type] || {};
            const sorted = Object.keys(itemTypeProtections).map((t)=>itemTypeProtections[t]).sort();
            return sorted[sorted.length - 1] || 0;
        }).reduce((a, n)=>a + n * this.maximumItemProtection, 0);
    }
    static{
        this.computeItemProtection = (item)=>{
            return this.computeItemProtectionPct(item.itemTypeMeta) * this.maximumItemProtection;
        };
    }
    static{
        this.computeItemProtectionPct = (itemTypeMeta)=>{
            if (!itemTypeMeta) return 0;
            const { type: type } = itemTypeMeta;
            const itemTypes = (0, $94ca5c6c04d9c167$export$b7032dafe57f8d33)[itemTypeMeta.class];
            if (!itemTypes) return 0;
            return itemTypes[type] || 0;
        };
    }
    static{
        this.computeProtection = (inventory)=>{
            // only consider active (equipped) items
            const activeItems = inventory.items?.filter((item)=>item.active) || [];
            return activeItems.map((i)=>this.computeItemProtection(i)).reduce((a, n)=>a + n, 0);
        };
    }
    static{
        this.computeProtectionPctOfMax = (inventory)=>{
            const f = this.computeProtection(inventory);
            return f / this.maximumTotalItemProtection;
        };
    }
}
class $6db9b00381e87aee$var$Properties {
    static{
        this.hasProperty = (itemTypeMeta, prop)=>{
            if (prop === "disallowedClassesOnActive" || prop === "buildType") return !!(0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]?.[prop] || !!(0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class]?.[prop];
            if ((0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]?.[prop] !== undefined) return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type][prop];
            const klass = (0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class];
            return klass?.[prop];
        };
    }
    static{
        this.toItemTypeMeta = (itemType, color)=>{
            return (0, $f684496fff50a7a1$export$9efb6bfe58196888)(itemType, color, true);
        };
    }
    static{
        this.toSpriteId = (itemType, color)=>{
            const itemTypeMeta = this.toItemTypeMeta(itemType, color);
            if (!itemTypeMeta) return "";
            return itemTypeMeta.spriteId || `${itemTypeMeta.type}-${itemTypeMeta.color}.png`;
        };
    }
    static{
        this.buildable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "buildable");
        };
    }
    static{
        this.exclusiveReadiness = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "exclusiveReadiness");
        };
    }
    static{
        this.buildType = (itemTypeMeta)=>{
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type].buildType;
        };
    }
    static{
        this.disallowedClassesOnActive = (itemTypeMeta)=>{
            if (!this.hasProperty(itemTypeMeta, "disallowedClassesOnActive")) return [];
            return (0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class]["disallowedClassesOnActive"] || (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]["disallowedClassesOnActive"] || [];
        };
    }
    static{
        this.useable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "useable");
        };
    }
    static{
        this.readyable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "readyable");
        };
    }
    static{
        this.showWorldOnUse = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "useHasWorldEffect");
        };
    }
    static{
        this.stackable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "stackable");
        };
    }
    static{
        this.unsellable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "unsellable");
        };
    }
    static{
        this.unbuyable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "unbuyable");
        };
    }
    static{
        this.hasDurability = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "hasDurability");
        };
    }
    static{
        this.currency = (itemTypeMeta)=>{
            // todo make this less brittle
            if (itemTypeMeta.type === "shard-metal") return true;
            return false;
        };
    }
    static{
        this.equippable = (itemTypeMeta, entity)=>{
            if (!(0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class]?.equippable) return false;
            if (itemTypeMeta.class === "shirt") {
                const items = (0, $bf6244e5cc9aa116$export$6e1561754c81021d)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            if (itemTypeMeta.class === "pants") {
                const items = (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            if (itemTypeMeta.class === "shoes") {
                const items = (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            if (itemTypeMeta.class === "cape") {
                const items = (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            return true;
        };
    }
    static{
        this.itemSex = (itemTypeMeta)=>{
            const { type: type, class: itemClass } = itemTypeMeta;
            const evaluator = (male, female)=>{
                if (male && female) return "both";
                if (!male && female) return "female";
                if (male && !female) return "male";
                return "na";
            };
            if (itemClass === "cape") return evaluator((0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)["female"]?.includes(type));
            if (itemClass === "pants") return evaluator((0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)["female"]?.includes(type));
            if (itemClass === "shirt") return evaluator((0, $bf6244e5cc9aa116$export$6e1561754c81021d)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$6e1561754c81021d)["female"]?.includes(type));
            if (itemClass === "shoes") return evaluator((0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)["female"]?.includes(type));
            return "na";
        };
    }
}
class $6db9b00381e87aee$var$Trading {
    static{
        this.isCurrency = (item)=>{
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[item.itemTypeMeta.type]?.isCurrency;
        };
    }
    static{
        this.isAmmo = (item)=>{
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[item.itemTypeMeta.type]?.isAmmo;
        };
    }
    static{
        this.isItemSellable = (item)=>{
            if ($6db9b00381e87aee$var$Properties.unsellable(item.itemTypeMeta)) return false;
            const baseTradeValue = (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[item.itemTypeMeta.type];
            if (baseTradeValue && (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[item.itemTypeMeta.type]?.quantity < 1) return false;
            return true;
        };
    }
    static{
        this.computeSellValueCost = (itemTypeMeta, quantity)=>{
            const base = (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[itemTypeMeta.type];
            if (base) {
                // markdown; todo, this might depend on the seller and the buyer
                const markup = 1;
                return {
                    itemType: base.itemType,
                    quantity: Math.ceil(base.quantity * markup * quantity)
                };
            }
            if (itemTypeMeta.class === "resource") return {
                itemType: "shard-metal",
                quantity: 1
            };
            return {
                itemType: "shard-metal",
                quantity: 10
            };
        };
    }
    static{
        this.isItemBuyable = (itemTypeMeta)=>{
            return true;
        };
    }
    static{
        this.computeBuyValueCost = (itemType, quantity)=>{
            const base = (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[itemType];
            if (!base) return {
                itemType: "shard-metal",
                quantity: 10
            };
            // markup; todo, this might depend on the seller and the buyer
            const markup = 1.25;
            return {
                itemType: base.itemType,
                quantity: Math.ceil(base.quantity * markup * quantity)
            };
        };
    }
    static{
        this.getTradableItemTypes = ()=>{
            const buyable = [];
            Object.keys((0, $6bf155bafb42c3cf$export$560c482cf16d1d03)).forEach((itemType)=>{
                const itemTypeMeta = $6db9b00381e87aee$export$ad15344118fbba9b.properties.toItemTypeMeta(itemType);
                if (!$6db9b00381e87aee$export$ad15344118fbba9b.properties.unbuyable(itemTypeMeta)) buyable.push(itemTypeMeta);
            });
            return buyable;
        };
    }
}
const $6db9b00381e87aee$export$856f32592e87f3a6 = [
    "wall",
    "decor",
    "entity",
    "roof",
    "floor",
    "floor2"
];
class $6db9b00381e87aee$var$Crafting {
    static{
        this.toKey = (next)=>next.class + "-" + next.type + "-" + next.color;
    }
    static{
        this.getRecipeFor = (toFind)=>{
            return (0, $4ea3e677cece9ece$export$26748d48fafe06ef).find((next)=>this.toKey(next.itemTypeMeta) === this.toKey(toFind));
        };
    }
    static{
        // todo - dry this up with computeCraftableItemTypes
        this.isCraftable = (itemTypeMeta, inventory, skills = [])=>{
            const recipe = (0, $4ea3e677cece9ece$export$26748d48fafe06ef).find((r)=>r.itemTypeMeta.type === itemTypeMeta.type && itemTypeMeta.color == r.itemTypeMeta.color);
            if (!recipe) return {
                craftable: false,
                isValid: false
            };
            const resourceMap = inventory.items.filter((item)=>item.itemTypeMeta.class === "resource").reduce((acc, next)=>{
                const key = this.toKey(next.itemTypeMeta);
                return {
                    ...acc,
                    [key]: {
                        quantity: next.quantity || 1,
                        itemType: next.itemTypeMeta
                    }
                };
            }, {});
            const { requiredSkills: requiredSkills = [] } = recipe;
            if (requiredSkills.length > 0 && !!requiredSkills.find((s)=>!skills.includes(s))) return {
                craftable: false,
                isValid: false
            };
            const missingIngredients = [];
            const foundIngredients = recipe.ingredients.filter((required)=>{
                const toLookupKey = this.toKey(required.itemTypeMeta);
                const ownedQuantity = resourceMap[toLookupKey]?.quantity || 0;
                const found = ownedQuantity >= required.quantity;
                if (!found) // From the RECIPE, not from resourceMap. resourceMap only holds what the player is
                // carrying, so an ingredient they have NONE of -- the common case for anything worth
                // showing them -- resolved to undefined and printed as "undefined x3". It was masked
                // while the list only offered recipes you already held every ingredient for.
                missingIngredients.push({
                    itemType: required.itemTypeMeta.type,
                    quantity: Math.abs(ownedQuantity - required.quantity)
                });
                return found;
            });
            const craftable = foundIngredients.length === recipe.ingredients.length;
            return {
                craftable: craftable,
                isValid: true,
                missingIngredients: missingIngredients
            };
        };
    }
    static{
        /**
     * Is this something a player should be able to SEE they could build, whether or not they can
     * afford it today?
     *
     * The listing used to answer one question with another: it only offered a recipe you already held
     * every ingredient for, so the tree hid behind itself. Holding wood you were shown stick, planks
     * and campfire, and could never learn that a wall exists -- it needs planks, and nothing gives you
     * a reason to make planks.
     *
     * Structures are the things a camp is BUILT from, and there are eight of them: a page, not a
     * catalogue. Showing them turns the tab into the set of things this place could become. The deep
     * tree (metal bars, weapons) stays behind the old rule, so a first-wave player is not handed a
     * forge.
     */ this.alwaysListed = (itemTypeMeta)=>itemTypeMeta.class === "structure" && !$6db9b00381e87aee$var$UNLISTED_STRUCTURES.includes(itemTypeMeta.type);
    }
    static{
        /**
     * Which of the recipes a player is PERMITTED to see are actually offered.
     *
     * Three ways in, and the third is why this cannot stay a predicate over one item: it needs to
     * know the rest of the list.
     *
     *  - a structure is always offered, minus UNLISTED_STRUCTURES -- see `alwaysListed`.
     *  - anything else is offered once the player holds at least one of every ingredient. The
     *    original rule, and what keeps the deep tree out of a wave-1 player's way.
     *  - a recipe for an INGREDIENT of something already offered is offered too. The Resource tab is
     *    then exactly the support set of the rest of the list: the materials the things you can build
     *    are made of, and nothing else.
     *
     * That last rule has to be DERIVED from the recipes rather than kept as a second hand-written
     * list, which would rot: adding a structure now drags its own materials in, and staging weapons
     * in later behind `requiredSkills` will drag theirs. It matters beyond tidiness because a greyed
     * row states its cost ("wall-wood -- Needs: 3 planks, have 0") and that cost is about to become a
     * link to the planks recipe; the link only goes anywhere if planks is listed, and today planks is
     * filtered out unless the player happens to be carrying wood.
     *
     * The third rule feeds itself, so it runs to a FIXED POINT rather than one level deep. One level
     * is all the current data needs -- every structure ingredient is either raw wood or one of
     * planks/stick/rope -- but a resource made of another resource would silently drop out of a
     * single pass. Termination does not depend on the data being a tree: the set only ever grows and
     * is bounded by `itemRecipes`, so a cycle (A made of B made of A) pulls both in and then stops
     * changing.
     */ this.computeListedRecipes = (permitted, resourceMap)=>{
            const holdsSomeOfEveryIngredient = (recipe)=>recipe.ingredients.every((required)=>(resourceMap[this.toKey(required.itemTypeMeta)] || 0) > 0);
            const listedKeys = new Set(permitted.filter((recipe)=>this.alwaysListed(recipe.itemTypeMeta) || holdsSomeOfEveryIngredient(recipe)).map((recipe)=>this.toKey(recipe.itemTypeMeta)));
            let growing = true;
            while(growing){
                growing = false;
                const neededKeys = new Set();
                permitted.filter((recipe)=>listedKeys.has(this.toKey(recipe.itemTypeMeta))).forEach((recipe)=>recipe.ingredients.forEach((required)=>neededKeys.add(this.toKey(required.itemTypeMeta))));
                permitted.forEach((recipe)=>{
                    const key = this.toKey(recipe.itemTypeMeta);
                    if (listedKeys.has(key) || !neededKeys.has(key)) return;
                    listedKeys.add(key);
                    growing = true;
                });
            }
            // Filtered rather than accumulated, so the offered list keeps `itemRecipes` order: the
            // crafting panel pages items in the order it is handed them.
            return permitted.filter((recipe)=>listedKeys.has(this.toKey(recipe.itemTypeMeta)));
        };
    }
    static{
        this.computeCraftableItemTypes = (inventory, skills = [])=>{
            const resourceMap = inventory.items.filter((item)=>item.itemTypeMeta.class === "resource").reduce((acc, next)=>{
                const key = this.toKey(next.itemTypeMeta);
                return {
                    ...acc,
                    [key]: next.quantity || 1
                };
            }, {});
            // Permission is a separate question from affordability, and `requiredSkills` answers it. It
            // is applied FIRST and on its own, so a recipe the player may not see cannot drag its
            // ingredients onto the list either -- which is how the deep tree gets staged later.
            const permitted = (0, $4ea3e677cece9ece$export$26748d48fafe06ef).filter((recipe)=>{
                const { requiredSkills: requiredSkills = [] } = recipe;
                return requiredSkills.length < 1 || !requiredSkills.find((s)=>!skills.includes(s));
            });
            return this.computeListedRecipes(permitted, resourceMap).map((recipe)=>{
                const foundIngredients = recipe.ingredients.filter((required)=>{
                    const toLookupKey = this.toKey(required.itemTypeMeta);
                    const ownedQuantity = resourceMap[toLookupKey] || 0;
                    return ownedQuantity >= required.quantity;
                });
                return {
                    itemTypeMeta: recipe.itemTypeMeta,
                    craftable: foundIngredients.length === recipe.ingredients.length
                };
            });
        };
    }
    static{
        this.computeCraftableMeta = (item)=>{
            return this.computeCraftableMetaFromItemType(item?.itemTypeMeta?.type);
        };
    }
    static{
        this.computeCraftableMetaFromItemType = (itemType)=>{
            if (!itemType) return null;
            const pointer = (0, $adc2b7d4f0244689$export$cfd1f8c409da7c62).instance().fragmentByItemType[itemType];
            if (pointer) {
                const feature = (0, $adc2b7d4f0244689$export$cfd1f8c409da7c62).instance().featureByTag(pointer.catalog, pointer.tag);
                return feature?.craftableMeta;
            }
            const itemTypeMeta = (0, $f684496fff50a7a1$export$9efb6bfe58196888)(itemType);
            const buildType = (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(itemTypeMeta);
            if (buildType) return {
                itemType: itemType,
                buildType: buildType
            };
            return null;
        };
    }
}
class $6db9b00381e87aee$var$Projectile {
    static{
        this.resolveAmmoMetaFromAmmo = (ammoType)=>{
            if (!this.ammoTypeToMeta) {
                this.ammoTypeToMeta = new Map();
                this.ammoTypeToMeta.set("webAmmo", {
                    spriteId: "arrow-brown.png",
                    effects: [
                        "webslow"
                    ],
                    createNpcProps: {
                        spriteId: "spiderweb-exact.png",
                        flags: {
                            contactEffects: [
                                "webslow"
                            ]
                        },
                        msUntilExpiration: 5000,
                        dimensions: {
                            w: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2,
                            h: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2
                        }
                    }
                });
                this.ammoTypeToMeta.set("arrow", {
                    spriteId: "arrow-brown.png"
                });
            }
            return this.ammoTypeToMeta.get(ammoType);
        };
    }
    static{
        this.resolveProjectileSpriteId = (weaponType)=>{
            const characteristic = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType];
            if (!characteristic) return;
            const spriteId = characteristic.bulletSpriteId;
            if (spriteId) return spriteId;
            const bulletType = characteristic.bulletType;
            if (!bulletType) return;
            let ammoMeta;
            return ammoMeta?.spriteId;
        };
    }
    static{
        this.isStunTypeWeapon = (weaponType)=>{
            const characteristic = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType];
            if (!characteristic) return false;
            const bulletType = characteristic.bulletType;
            if (!bulletType) return false;
            return this.resolveAmmoMetaFromAmmo(bulletType)?.effects?.includes("webslow");
        };
    }
}
class $6db9b00381e87aee$var$Durability {
    static{
        this.computeMaxDurability = (itemTypeMeta)=>{
            if (!$6db9b00381e87aee$var$Properties.hasDurability(itemTypeMeta)) return;
            const material = $6db9b00381e87aee$var$Material.computeItemMaterial(itemTypeMeta);
            if (material === "metal") return 100;
            if (material === "wood") return 70;
            // todo - this should be more sophisticated, based on type and composition of the item
            return 100;
        };
    }
    static{
        this.computeItemConditionPct = (inventoryItem)=>{
            const maxDurabilty = this.computeMaxDurability(inventoryItem.itemTypeMeta);
            if (maxDurabilty === undefined) return;
            const { hp: hp = 0 } = inventoryItem;
            const pct = hp / maxDurabilty;
            return pct;
        };
    }
    static{
        this.computeItemCondition = (inventoryItem)=>{
            const pct = this.computeItemConditionPct(inventoryItem);
            if (pct === undefined) return;
            if (pct > 0.75) return "new";
            if (pct > 0.5) return "sturdy";
            if (pct > 0.25) return "worn";
            return "fragile";
        };
    }
}
class $6db9b00381e87aee$var$Material {
    static{
        // todo - make this better
        this.computeItemMaterial = (itemTypeMeta)=>{
            if (itemTypeMeta.class === "weapon") {
                if ([
                    "brown",
                    "lightbrown"
                ].includes(itemTypeMeta.color)) return "wood";
            }
            return "metal";
        };
    }
}
class $6db9b00381e87aee$var$InventoryMechanics {
    static{
        this.stackLimit = ()=>50;
    }
    static{
        this.inventoryFull = (entity)=>{
            return entity.inventory?.items?.length > (0, $f684496fff50a7a1$export$618460892f1ada62);
        };
    }
    static{
        this.canReceive = (receiver, itemType, quantity)=>{
            const isStackable = $6db9b00381e87aee$var$Properties.stackable(itemType);
            const stackLimit = this.stackLimit();
            const inventorySize = receiver.inventory?.items?.length;
            const allSlotsOccupied = inventorySize >= (0, $f684496fff50a7a1$export$618460892f1ada62);
            if (!isStackable && allSlotsOccupied) return false;
            const existingItem = (0, $f684496fff50a7a1$export$42ef252fc2f3d24d)(receiver.inventory, itemType, stackLimit);
            const maximumNumberOfNewSlots = (0, $f684496fff50a7a1$export$618460892f1ada62) - inventorySize;
            let quantityForExistingItem = 0;
            if (existingItem) // update the existing item up to its capacity
            quantityForExistingItem = stackLimit - (existingItem.quantity || 1);
            const quantityForNewItems = quantity - quantityForExistingItem;
            const numberOfNewItems = Math.ceil(quantityForNewItems / stackLimit);
            if (numberOfNewItems > maximumNumberOfNewSlots) return false;
            return true;
        };
    }
    static{
        // The largest slice of `desired` the receiver can actually hold. canReceive is monotonic in
        // quantity -- room for n implies room for anything smaller -- so this binary searches it rather
        // than restating its slot/stack arithmetic. Used to size the transfer quantity picker: the slider
        // must not offer an amount that would be silently trimmed on arrival.
        this.receivableQuantity = (receiver, itemType, desired)=>{
            const want = Math.floor(desired);
            if (want < 1) return 0;
            if (this.canReceive(receiver, itemType, want)) return want;
            let low = 0;
            let high = want - 1;
            while(low < high){
                const mid = Math.ceil((low + high) / 2);
                if (this.canReceive(receiver, itemType, mid)) low = mid;
                else high = mid - 1;
            }
            return low;
        };
    }
    static{
        this.createNewItem = ({ entity: entity, sourceItemEntity: sourceItemEntity, sourceItem: sourceItem, item: item, quantity: quantity })=>{
            // create new item because there's no existing stackable item to add to,
            // or that item is full up wrto stackable limit
            const isStackable = $6db9b00381e87aee$export$ad15344118fbba9b.properties.stackable(item);
            const hp = !isStackable ? sourceItem?.hp : sourceItemEntity?.hp;
            const newItem = (0, $f684496fff50a7a1$export$9bccf79e85d1f187)(item, {
                sourceItem: sourceItemEntity,
                quantity: quantity,
                hp: hp,
                id: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
                flags: sourceItem?.flags
            });
            let updatedEntity = (0, $f684496fff50a7a1$export$73ce97a5e6b0458a)(entity, newItem);
            if (item.class === "weapon" && !entity.weapon && (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.inventory.canEquipWeapon(entity)) {
                const weaponType = item.type;
                entity.weapon = {
                    weaponType: weaponType
                };
                updatedEntity = (0, $f684496fff50a7a1$export$9708f70dc8060636)(updatedEntity, newItem.id);
            }
            if (item.class === "armor") {
                const activeItem = (0, $f684496fff50a7a1$export$ff6824850c0111da)(entity.inventory, "armor");
                if (!activeItem) updatedEntity = (0, $f684496fff50a7a1$export$9708f70dc8060636)(updatedEntity, newItem.id);
            }
            return {
                updatedEntity: updatedEntity,
                createdItem: newItem
            };
        };
    }
    static{
        this.addItemToInventory = ({ entity: entity, sourceItemEntity: sourceItemEntity, sourceItem: sourceItem, item: item, quantity: quantity = 1 })=>{
            const currentInventorySize = entity?.inventory?.items.length;
            const isFull = currentInventorySize >= (0, $f684496fff50a7a1$export$618460892f1ada62);
            const isStackable = $6db9b00381e87aee$export$ad15344118fbba9b.properties.stackable(item);
            const stackLimit = isStackable ? $6db9b00381e87aee$var$InventoryMechanics.stackLimit() : 1;
            const existingItem = (0, $f684496fff50a7a1$export$42ef252fc2f3d24d)(entity.inventory, item, stackLimit);
            const totalQuantity = (existingItem ? existingItem.quantity || 1 : 0) + quantity;
            if (totalQuantity < 1) return {
                success: false
            };
            if (totalQuantity < stackLimit) {
                // the total amount fits within the slot
                if (existingItem) {
                    // an existing item exists, update it
                    const updatedEntity = (0, $f684496fff50a7a1$export$be412759309c8c0f)(entity, existingItem, quantity);
                    return {
                        success: true,
                        updatedEntity: updatedEntity,
                        updatedItem: existingItem
                    };
                } else {
                    if (isFull) return {
                        success: false
                    };
                    else {
                        // an existing item doesn't exist, create one
                        const { updatedEntity: updatedEntity, createdItem: createdItem } = this.createNewItem({
                            entity: entity,
                            sourceItemEntity: sourceItemEntity,
                            sourceItem: sourceItem,
                            item: item,
                            quantity: quantity
                        });
                        return {
                            success: true,
                            updatedEntity: updatedEntity,
                            addedItems: [
                                createdItem
                            ]
                        };
                    }
                }
            } else {
                // the total amount exceeds the slot, overflow other items if its possible
                const maximumNumberOfNewSlots = (0, $f684496fff50a7a1$export$618460892f1ada62) - entity.inventory.items.length;
                let updatedEntity;
                let quantityForExistingItem = 0;
                let createdItems = [];
                if (existingItem) {
                    // update the existing item up to its capacity
                    quantityForExistingItem = stackLimit - (existingItem.quantity || 1);
                    updatedEntity = (0, $f684496fff50a7a1$export$be412759309c8c0f)(entity, existingItem, quantityForExistingItem);
                }
                // spread the rest to new items
                const quantityForNewItems = quantity - quantityForExistingItem;
                const numberOfNewItems = Math.ceil(quantityForNewItems / stackLimit);
                if (isFull && numberOfNewItems > 0) return {
                    success: false,
                    updatedEntity: updatedEntity,
                    updatedItem: existingItem,
                    excessQuantity: quantityForNewItems
                };
                let totalAdded = 0;
                for(let i = 0; i < numberOfNewItems; i++){
                    if (i > maximumNumberOfNewSlots - 1) break;
                    const itemsToAdd = i == numberOfNewItems - 1 ? quantityForNewItems - i * stackLimit : stackLimit;
                    const createResults = this.createNewItem({
                        entity: updatedEntity || entity,
                        sourceItemEntity: sourceItemEntity,
                        sourceItem: sourceItem,
                        item: item,
                        quantity: itemsToAdd
                    });
                    updatedEntity = createResults.updatedEntity;
                    createdItems.push(createResults.createdItem);
                    totalAdded += itemsToAdd;
                }
                return {
                    success: true,
                    excessQuantity: quantityForNewItems - totalAdded,
                    updatedItem: existingItem,
                    updatedEntity: updatedEntity,
                    addedItems: createdItems
                };
            }
        };
    }
}
class $6db9b00381e87aee$export$ad15344118fbba9b {
    static{
        this.weight = $6db9b00381e87aee$var$Weight;
    }
    static{
        this.protection = $6db9b00381e87aee$var$Protection;
    }
    static{
        this.crafting = $6db9b00381e87aee$var$Crafting;
    }
    static{
        this.trading = $6db9b00381e87aee$var$Trading;
    }
    static{
        this.properties = $6db9b00381e87aee$var$Properties;
    }
    static{
        this.projectile = $6db9b00381e87aee$var$Projectile;
    }
    static{
        this.durability = $6db9b00381e87aee$var$Durability;
    }
    static{
        this.material = $6db9b00381e87aee$var$Material;
    }
    static{
        this.inventory = $6db9b00381e87aee$var$InventoryMechanics;
    }
}


class $bfabb40259688a2c$var$Defense {
    static{
        this.maximumDefenseProbability = 0.8;
    }
    static{
        this.calculateDefenseProbability = (entity)=>{
            const pctOfTotalProtection = Math.min(this.maximumDefenseProbability, (0, $6db9b00381e87aee$export$ad15344118fbba9b).protection.computeProtectionPctOfMax(entity.inventory));
            return pctOfTotalProtection;
        };
    }
}
const $bfabb40259688a2c$export$6d75a3bc04682d1b = [
    "square",
    "circle",
    "random"
];
const $bfabb40259688a2c$export$b8160b859f21cc45 = [
    "defense",
    "strategic",
    "aggressive"
];
class $bfabb40259688a2c$var$Squad {
}
class $bfabb40259688a2c$export$f1c3b8c7f0c3e30a {
    static{
        this.defense = $bfabb40259688a2c$var$Defense;
    }
    static{
        this.squad = $bfabb40259688a2c$var$Squad;
    }
}




const $831ce8568a4294bd$export$267e9a54988f18f1 = [
    "light",
    "webslow",
    "pushslow"
];
const $831ce8568a4294bd$export$49025350b8775b63 = [
    "light"
];
class $831ce8568a4294bd$export$b71c2cb4d3bdb35f {
    static{
        this.itemTypeToEffect = (itemTypeMeta)=>{
            return (0, $f684496fff50a7a1$export$be8fdcbd37253b73)[itemTypeMeta.type];
        };
    }
    static{
        this.getEntityEffects = (entity)=>{
            return entity?.flags?.appliedEffects || [];
        };
    }
    static{
        this.getEntityEffect = (entity, effect)=>{
            return this.getEntityEffects(entity).find((appliedEffect)=>appliedEffect.effect === effect);
        };
    }
    static{
        this.removeEntityEffect = (entity, effect)=>{
            if (!entity) return;
            const effects = this.getEntityEffects(entity).filter((appliedEffect)=>appliedEffect.effect !== effect);
            entity.lastStatsUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            entity.flags.appliedEffects = effects;
        };
    }
    static{
        this.hasEntityEffect = (entity, effect)=>{
            return !!this.getEntityEffects(entity).find((appliedEffect)=>appliedEffect.effect === effect);
        };
    }
    static{
        this.persistableEffects = (effect)=>effect ? effect.filter((n)=>$831ce8568a4294bd$export$49025350b8775b63.includes(n)) : [];
    }
    static{
        this.addEntityEffect = (entity, effectDescriptor)=>{
            if (!entity || [
                "bullet",
                "system"
            ].includes(entity.entityType)) return [];
            const effects = this.getEntityEffects(entity).filter((appliedEffect)=>appliedEffect.effect !== effectDescriptor.effect);
            entity.lastStatsUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            entity.flags.appliedEffects = [
                ...effects,
                {
                    ...effectDescriptor
                }
            ];
            return entity.flags.appliedEffects;
        };
    }
    static{
        this.contactEffectsFrom = (entity)=>{
            if (!entity) return [];
            return entity.flags?.contactEffects || [];
        };
    }
    static{
        this.isAffected = (entity, effect)=>{
            const race = entity?.appearance?.race;
            if (effect === "webslow") {
                if (race === "redspider") return false;
            }
            return true;
        };
    }
}







class $0fb3f7f2a67be6e3$var$Speed {
    static{
        this.minimum = 100;
    }
    static{
        this.maximum = 200;
    }
    static{
        this.pctIncrease = 0.045;
    }
    static{
        this.maximumSpeedEncumberancePct = 0.2;
    }
    static{
        this.perPointIncrease = ()=>{
            const range = this.range();
            const upgradeAmount = Math.round(range * this.pctIncrease);
            return upgradeAmount;
        };
    }
    static{
        this.maximumNumberOfUpgrades = ()=>{
            return Math.floor(this.maximum / this.perPointIncrease());
        };
    }
    static{
        this.increaseCostFrom = (speed)=>{
            const diffFromMinimum = speed - this.minimum;
            const numberOfInceases = Math.floor(diffFromMinimum / this.perPointIncrease());
            return Math.max(1, Math.floor(Math.log2(numberOfInceases)));
        };
    }
    static{
        this.maxNormalizedSpeed = ()=>Math.floor((this.maximum - this.minimum) / this.perPointIncrease());
    }
    static{
        this.toNormalizedSpeed = (rawSpeed)=>Math.floor((rawSpeed - this.minimum) / this.perPointIncrease());
    }
    static{
        this.range = ()=>this.maximum - this.minimum;
    }
    static{
        this.toNormalizedSpeedPctOfMax = (rawSpeed)=>(rawSpeed - this.minimum) / this.range();
    }
    static{
        this.toNormalizedSpeedPctOfMin = (rawSpeed)=>rawSpeed / this.minimum;
    }
    static{
        this.fromPctOfMax = (pct)=>this.minimum + this.range() * pct;
    }
    static{
        this.upgrade = (fromSpeed)=>{
            if (fromSpeed >= this.maximum) return;
            const upgradeAmount = this.perPointIncrease();
            let updatedMax = fromSpeed + upgradeAmount;
            const diff = this.maximum - updatedMax;
            if (diff < upgradeAmount) updatedMax = this.maximum;
            if (updatedMax > this.maximum) return;
            return updatedMax;
        };
    }
    static{
        this.needsSpeedRecomputation = (entity, lastComputationTs)=>{
            const toCmpare = Math.max(entity.inventory.lastUpdateTs || 0, entity.lastStatsUpdateTs || 0);
            return toCmpare > lastComputationTs;
        };
    }
    static{
        this.effectiveSpeed = (entity)=>{
            if (entity.isPlayer()) {
                const baselineSpeed = entity.boosted ? entity.maxSpeed + Math.floor(entity.maxSpeed * Math.min(1.0, 0.6 + entity.boostPct)) : entity.maxSpeed;
                const weightSpeedReductionBudget = this.maximumSpeedEncumberancePct * this.maximum;
                const weightPctOfMax = (0, $6db9b00381e87aee$export$ad15344118fbba9b).weight.computeWeightPctOfMax(entity.inventory);
                const speedReduction = Math.min(weightSpeedReductionBudget * weightPctOfMax, baselineSpeed * 0.65);
                const weightBased = baselineSpeed - speedReduction;
                const speed = weightBased * (entity.movingBackwards ? 0.7 : 1.0);
                const isSlowed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.hasEntityEffect(entity, "webslow");
                const isPushSlowed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.hasEntityEffect(entity, "pushslow");
                if (isSlowed) return speed * 0.2;
                else if (isPushSlowed) {
                    const pushSlowEffect = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.getEntityEffect(entity, "pushslow");
                    const speedMultiplier = pushSlowEffect?.speedMultiplier || 0.7;
                    return speed * speedMultiplier;
                }
                return speed;
            } else {
                // for now ... entities aren't affected by boosts or weight
                const speed = entity.speed * (entity.movingBackwards ? 0.7 : 1.0);
                const isSlowed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.hasEntityEffect(entity, "webslow");
                return isSlowed ? speed * 0.2 : speed;
            }
        };
    }
}
class $0fb3f7f2a67be6e3$var$HitPoints {
    static{
        this.minimum = 3;
    }
    static{
        this.maximum = 50;
    }
    static{
        this.range = ()=>this.maximum - this.minimum;
    }
    static{
        this.perPointIncrease = ()=>1;
    }
    static{
        this.increaseCostFrom = (hp)=>{
            const diffFromMinimum = hp - this.minimum;
            const numberOfInceases = Math.floor(diffFromMinimum / this.perPointIncrease());
            return Math.max(1, Math.floor(Math.log2(numberOfInceases)));
        };
    }
    static{
        this.upgrade = (fromHp)=>{
            if (fromHp >= this.maximum) return;
            const upgradeAmount = this.perPointIncrease();
            let updatedMax = fromHp + upgradeAmount;
            const diff = this.maximum - updatedMax;
            if (diff < upgradeAmount) updatedMax = this.maximum;
            if (updatedMax > this.maximum) return;
            return updatedMax;
        };
    }
    static{
        this.fromPctOfMax = (pct)=>this.minimum + this.range() * pct;
    }
}
class $0fb3f7f2a67be6e3$var$Levels {
    static{
        this.maximum = 600;
    }
    static{
        this.upgradePointsForLevel = (level)=>{
            return Math.max(1, Math.floor(Math.log1p(level)));
        };
    }
    static{
        this.totalUpgradePointsPerLevel = {};
    }
    static{
        this.ugradePointsAtLevel = {};
    }
    static{
        let totalUpgradePoints = 0;
        for(let i = 1; i <= this.maximum; i++){
            const upgradePoints = this.upgradePointsForLevel(i);
            this.ugradePointsAtLevel[i] = upgradePoints;
            totalUpgradePoints += upgradePoints;
            this.totalUpgradePointsPerLevel[i] = totalUpgradePoints;
        }
    }
}
class $0fb3f7f2a67be6e3$var$MinMax {
    constructor(min, max){
        this.maximum = 100;
        this.minimum = 0;
        this.range = ()=>this.maximum - this.minimum;
        this.fromPctOfMax = (pct)=>this.minimum + this.range() * pct;
        this.toPctOfMax = (aggression)=>aggression / this.maximum;
        this.minimum = min;
        this.maximum = max;
    }
}
class $0fb3f7f2a67be6e3$var$Inventory {
    static{
        this.inventoryBearingNpcTypes = new Set();
    }
    static{
        this.inventoryBearingNpcTypes.add("zombie");
        this.inventoryBearingNpcTypes.add("outpost");
    }
    static{
        this.canEquipWeapon = (entity)=>{
            if ([
                "zombie"
            ].includes(entity.npcType)) return true;
            return false;
        };
    }
    static{
        this.hasEquipment = (entity)=>{
            if (entity.npcType) {
                if (entity.flags.forcePersist) return true;
                if (!this.inventoryBearingNpcTypes.has(entity.npcType)) return false;
                if (entity.npcType === "outpost") return true;
            }
            // for now ... only humanoids can have equipment
            // if (!Body.isHumanoid(entity?.appearance?.race)) {
            //     return false
            // }
            return true;
        };
    }
}
class $0fb3f7f2a67be6e3$var$Body {
    static{
        this.isStationary = (entity)=>{
            if ([
                "spikes1"
            ].includes(entity?.appearance?.race)) return true;
            return false;
        };
    }
    static{
        this.isHumanoid = (race)=>{
            return (0, $bf6244e5cc9aa116$export$2a4812914c68f73e).includes(race);
        };
    }
    static{
        this.isShort = (entity)=>{
            return !this.isHumanoid(entity?.appearance?.race);
        };
    }
    static{
        this.isFlat = (entity)=>{
            const race = entity?.appearance?.race;
            if (!race) return false;
            return [
                "spikes1"
            ].includes(race);
        };
    }
    static{
        this.isSmall = (entity)=>{
            const race = entity?.appearance?.race;
            if (!race) return false;
            if (this.isHumanoid(race)) return false;
            return [
                "slime",
                "rabbit",
                "chicken",
                "snake",
                "wasp"
            ].includes(race);
        };
    }
    static{
        this.hasAppearance = (npcType)=>{
            return ![
                "outpost",
                "collectable",
                "marker"
            ].includes(npcType);
        };
    }
    static{
        this.dimensions = (entity)=>{
            if (this.isHumanoid(entity?.appearance?.race)) return {
                w: 25,
                h: 50
            };
            return (0, $cb689cfa16c444ba$export$5b5223867019c37b)[entity.entityType];
        };
    }
    static{
        this.calculateCollisionBounds = (entity, bounds)=>{
            const isHorselike = [
                "deer",
                "horse"
            ].includes(entity.appearance?.race || "");
            const x = entity.location.x;
            const y = entity.location.y;
            if (isHorselike) {
                const direction = entity.getGrossOrientation();
                if (direction === "LeftRight") {
                    bounds.x1 = x - entity.dimensions.w;
                    bounds.y1 = y - entity.dimensions.h * 1.5;
                    bounds.x2 = x + entity.dimensions.w;
                    bounds.y2 = y + entity.dimensions.h * 0.5;
                } else {
                    bounds.x1 = x - entity.dimensions.w / 2;
                    bounds.y1 = y - entity.dimensions.h * 1.5;
                    bounds.x2 = x + entity.dimensions.w / 2;
                    bounds.y2 = y + entity.dimensions.h / 2;
                }
                return true;
            }
            return false;
        };
    }
    static{
        this.calculateZIndexBoost = (entity)=>{
            if (entity.npcType === "collectable") return 0;
            else return (this.isSmall(entity) ? 85 : this.isHumanoid(entity?.appearance?.race) ? 100 : 90) + entity.location.y;
        };
    }
}
class $0fb3f7f2a67be6e3$var$Psych {
    static{
        this.hostilityMinMax = new $0fb3f7f2a67be6e3$var$MinMax(0, 100);
    }
    static{
        this.hostility = ()=>this.hostilityMinMax;
    }
    static{
        this.attackPattern = (race)=>(0, $d3527b517d667178$export$4cfe0674a42ef84e).population.psych(race)?.attackPattern || "default";
    }
    static{
        this.aggroResponse = (race)=>(0, $d3527b517d667178$export$4cfe0674a42ef84e).population.psych(race)?.aggroResponse || "default";
    }
    static{
        this.closeOnStun = (race)=>(0, $d3527b517d667178$export$4cfe0674a42ef84e).population.psych(race)?.closeOnStun;
    }
}
const $0fb3f7f2a67be6e3$export$3a513633d965417d = [
    "burn",
    "take",
    "chat",
    "inventory",
    "crown",
    "button",
    "command",
    "food"
];
const $0fb3f7f2a67be6e3$export$df3562c123d9be63 = {
    take: {
        label: "Take",
        priority: 70,
        neverPrimary: false
    },
    inventory: {
        label: "Items",
        priority: 65,
        neverPrimary: false
    },
    burn: {
        label: "Light",
        priority: 60,
        neverPrimary: false
    },
    button: {
        label: "Use",
        priority: 55,
        neverPrimary: false
    },
    crown: {
        label: "Crown",
        priority: 50,
        neverPrimary: false
    },
    command: {
        label: "Orders",
        priority: 45,
        neverPrimary: false
    },
    food: {
        label: "Give Food",
        priority: 40,
        neverPrimary: true
    },
    chat: {
        label: "Talk",
        priority: 10,
        neverPrimary: false
    }
};
const $0fb3f7f2a67be6e3$export$84e151b22524d21c = (descriptor)=>descriptor.label || $0fb3f7f2a67be6e3$export$df3562c123d9be63[descriptor.type]?.label || descriptor.type;
const $0fb3f7f2a67be6e3$export$73e01e1322ad10af = (descriptor)=>descriptor.priority ?? $0fb3f7f2a67be6e3$export$df3562c123d9be63[descriptor.type]?.priority ?? 0;
const $0fb3f7f2a67be6e3$export$70974b3c417d9dc7 = (descriptor)=>descriptor.neverPrimary ?? $0fb3f7f2a67be6e3$export$df3562c123d9be63[descriptor.type]?.neverPrimary ?? false;
const $0fb3f7f2a67be6e3$export$279c35a8a516c7b3 = (interactions)=>{
    if (!interactions) return [];
    const normalized = [];
    interactions.forEach((next)=>{
        const descriptor = typeof next === "string" ? {
            type: next
        } : next && typeof next === "object" ? next : undefined;
        if (!descriptor?.type || !$0fb3f7f2a67be6e3$export$3a513633d965417d.includes(descriptor.type)) return;
        normalized.push(descriptor);
    });
    return normalized;
};
const $0fb3f7f2a67be6e3$export$112177784473fc2f = (interactions)=>[
        ...interactions
    ].sort((a, b)=>{
        const byPriority = $0fb3f7f2a67be6e3$export$73e01e1322ad10af(b) - $0fb3f7f2a67be6e3$export$73e01e1322ad10af(a);
        if (byPriority !== 0) return byPriority;
        return $0fb3f7f2a67be6e3$export$3a513633d965417d.indexOf(a.type) - $0fb3f7f2a67be6e3$export$3a513633d965417d.indexOf(b.type);
    });
const $0fb3f7f2a67be6e3$export$24cb1bac32828cd1 = (interactions)=>{
    const ranked = $0fb3f7f2a67be6e3$export$112177784473fc2f($0fb3f7f2a67be6e3$export$279c35a8a516c7b3(interactions));
    if (ranked.length === 0) return {
        kind: "none"
    };
    if (ranked.length === 1 && !$0fb3f7f2a67be6e3$export$70974b3c417d9dc7(ranked[0])) return {
        kind: "single",
        interaction: ranked[0]
    };
    return {
        kind: "menu",
        interactions: ranked
    };
};
class $0fb3f7f2a67be6e3$var$Flags {
    static{
        this.updateFlag = (entity, flags)=>{
            const updateFlags = (entity, flag)=>{
                const value = flags[flag];
                if (value === null) // delete flag
                delete entity.flags[flag];
                else if (typeof value !== "string") entity.flags[flag] = value;
                else {
                    const result = value.matchAll(/\{(.*?)\}/g).next().value;
                    if (result) {
                        const matched = result[1];
                        const [operand, impact] = matched.split(":");
                        if (operand === "increment") {
                            const updatedValue = (entity.flags[flag] || 0) + parseInt(impact);
                            entity.flags[flag] = updatedValue;
                        }
                        if (operand === "decrement") {
                            const updatedValue = Math.max(0, (entity.flags[flag] || 0) - parseInt(impact));
                            entity.flags[flag] = updatedValue;
                        }
                        if (operand === "timestamp") entity.flags[flag] = (0, $4171652afd996934$export$a86190deb5c4a8d0)() + parseInt(impact);
                    } else entity.flags[flag] = value;
                }
            };
            if (entity) Object.keys(flags).forEach((flag)=>{
                updateFlags(entity, flag);
            });
            return entity;
        };
    }
}
class $0fb3f7f2a67be6e3$var$Interactions {
}
class $0fb3f7f2a67be6e3$export$bf48cba06b920fc0 {
    static{
        this.inventory = $0fb3f7f2a67be6e3$var$Inventory;
    }
    static{
        this.body = $0fb3f7f2a67be6e3$var$Body;
    }
    static{
        this.speed = $0fb3f7f2a67be6e3$var$Speed;
    }
    static{
        this.hitPoints = $0fb3f7f2a67be6e3$var$HitPoints;
    }
    static{
        this.levels = $0fb3f7f2a67be6e3$var$Levels;
    }
    static{
        this.psych = $0fb3f7f2a67be6e3$var$Psych;
    }
    static{
        this.interactions = $0fb3f7f2a67be6e3$var$Interactions;
    }
    static{
        this.flags = $0fb3f7f2a67be6e3$var$Flags;
    }
}



const $cdf806a94d4c01be$export$d7f6fa5288114206 = [
    "chest-wood",
    "door-wood",
    "floor-wood",
    "ore-coal",
    "palmTree1",
    "palmTree2",
    "palmTree3",
    "palmTree4",
    "palmTree5",
    "palmTree6",
    "roof-wood",
    "sapling",
    "smallTree1",
    "table-mid-round",
    "tallGrass",
    "tallReeds",
    "testore",
    "tree1",
    "tree1Small",
    "tree2",
    "tree2Small",
    "tree3",
    "tree4",
    "tree5",
    "tree6",
    "wall-stone",
    "wall-wood",
    "wall2-wood"
];
const $cdf806a94d4c01be$export$4783a51780b31483 = {
    "door-wood": {
        hp: 5,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("door-wood"),
                quantity: 1,
                probability: 0.3,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "wall-wood": {
        hp: 50,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wall-wood"),
                quantity: 1,
                probability: 0.3,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "wall2-wood": {
        hp: 50,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wall2-wood"),
                quantity: 1,
                probability: 0.3,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "wall-stone": {
        hp: 5,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wall-stone"),
                quantity: 1,
                probability: 0.3,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "floor-wood": {
        hp: 5,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("floor-wood"),
                quantity: 1,
                probability: 0.3,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "roof-wood": {
        hp: 5,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("roof-wood"),
                quantity: 1,
                probability: 0.3,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "chest-wood": {
        hp: 3,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("chest-wood"),
                quantity: 1,
                probability: 1,
                replicate: false
            }
        ],
        growthSequence: []
    },
    tree1: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: [
            {
                entityTileId: "sapling",
                requiredTime: 10
            },
            {
                entityTileId: "tree1Small",
                requiredTime: 20
            }
        ]
    },
    tree2: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: [
            {
                entityTileId: "sapling",
                requiredTime: 10
            },
            {
                entityTileId: "tree2Small",
                requiredTime: 20
            }
        ]
    },
    tree3: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: [
            {
                entityTileId: "sapling",
                requiredTime: 10
            },
            {
                entityTileId: "tree2Small",
                requiredTime: 20
            }
        ]
    },
    tree4: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: [
            {
                entityTileId: "sapling",
                requiredTime: 10
            },
            {
                entityTileId: "tree2Small",
                requiredTime: 20
            }
        ]
    },
    tree5: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: [
            {
                entityTileId: "sapling",
                requiredTime: 10
            },
            {
                entityTileId: "tree2Small",
                requiredTime: 20
            }
        ]
    },
    tree6: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: [
            {
                entityTileId: "sapling",
                requiredTime: 10
            },
            {
                entityTileId: "tree2Small",
                requiredTime: 20
            }
        ]
    },
    smallTree1: {
        hp: 15,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            }
        ],
        growthSequence: [
            {
                entityTileId: "tree2Small",
                requiredTime: 30
            }
        ]
    },
    sapling: {
        hp: 1,
        onDestructionCreateItems: [],
        growthSequence: []
    },
    tallReeds: {
        hp: 3,
        onDestructionCreateItems: [],
        growthSequence: []
    },
    tallGrass: {
        hp: 5,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("straw"),
                quantity: 3,
                probability: 0.5,
                replicate: false
            }
        ],
        growthSequence: []
    },
    tree1Small: {
        hp: 3,
        onDestructionCreateItems: [],
        growthSequence: []
    },
    tree2Small: {
        hp: 3,
        onDestructionCreateItems: [],
        growthSequence: []
    },
    "ore-coal": {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("coal"),
                quantity: 3,
                probability: 1,
                replicate: false
            }
        ],
        growthSequence: []
    },
    testore: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("coal"),
                quantity: 3,
                probability: 0.25,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("iron"),
                quantity: 3,
                probability: 0.15,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("copper"),
                quantity: 3,
                probability: 0.1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("silver"),
                quantity: 3,
                probability: 0.05,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("gold"),
                quantity: 3,
                probability: 0.025,
                replicate: false
            }
        ],
        growthSequence: []
    },
    "table-mid-round": {
        hp: 5,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("table-mid-round"),
                quantity: 1,
                probability: 1,
                replicate: false
            }
        ],
        growthSequence: []
    },
    palmTree1: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: []
    },
    palmTree2: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: []
    },
    palmTree3: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: []
    },
    palmTree4: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: []
    },
    palmTree5: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: []
    },
    palmTree6: {
        hp: 30,
        onDestructionCreateItems: [
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("wood"),
                quantity: 2,
                probability: 1,
                replicate: false
            },
            {
                itemType: (0, $f684496fff50a7a1$export$9efb6bfe58196888)("seed"),
                quantity: 2,
                probability: 1,
                replicate: true
            }
        ],
        growthSequence: []
    }
};


const $7d8209f3c8c41e8b$export$40dde5e0c1bbd734 = {
    "door-wood": 1,
    "roof-wood": 1,
    "floor-wood": 1,
    "chest-wood": 1,
    "wall-wood": 1,
    "wall2-wood": 1,
    "wall-stone": 1,
    "testore": 6,
    "ore-coal": 6,
    "tallReeds": 1,
    "tallGrass": 1,
    "sapling": 1,
    "tree1Small": 1,
    "tree2Small": 1,
    "table-mid-round": 1
};
const $7d8209f3c8c41e8b$export$166d0675377eb5ce = {
    "testore": [
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "ore-coal": [
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "tree1": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "tree2": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "tree3": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "tree4": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "tree5": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "tree6": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "smallTree1": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "tallReeds": [
        {
            "weaponType": "bow",
            "damage": 0
        },
        {
            "weaponType": "web",
            "damage": 0
        },
        {
            "weaponType": "longsword",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 0
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "tallGrass": [
        {
            "weaponType": "bow",
            "damage": 0
        },
        {
            "weaponType": "web",
            "damage": 0
        },
        {
            "weaponType": "longsword",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 0
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "sapling": [
        {
            "weaponType": "bow",
            "damage": 0
        },
        {
            "weaponType": "web",
            "damage": 0
        },
        {
            "weaponType": "longsword",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 0
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "tree1Small": [
        {
            "weaponType": "bow",
            "damage": 0
        },
        {
            "weaponType": "web",
            "damage": 0
        },
        {
            "weaponType": "longsword",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 0
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "tree2Small": [
        {
            "weaponType": "bow",
            "damage": 0
        },
        {
            "weaponType": "web",
            "damage": 0
        },
        {
            "weaponType": "longsword",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 0
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        }
    ],
    "palmTree1": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "palmTree2": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "palmTree3": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "palmTree4": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "palmTree5": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "palmTree6": [
        {
            "weaponType": "dagger",
            "damage": 6
        },
        {
            "weaponType": "spear",
            "damage": 6
        },
        {
            "weaponType": "longsword",
            "damage": 6
        },
        {
            "weaponType": "waraxe",
            "damage": 10
        },
        {
            "weaponType": "axe",
            "damage": 10
        },
        {
            "weaponType": "warhammer",
            "damage": 30
        },
        {
            "weaponType": "bow",
            "damage": 1
        },
        {
            "weaponType": "web",
            "damage": 1
        },
        {
            "weaponType": "crossbow",
            "damage": 1
        },
        {
            "weaponType": "none",
            "damage": 1
        }
    ],
    "wall-stone": [
        {
            "weaponType": "warhammer",
            "damage": 3
        }
    ],
    "wall-wood": [
        {
            "weaponType": "dagger",
            "damage": 3
        },
        {
            "weaponType": "saber",
            "damage": 3
        },
        {
            "weaponType": "spear",
            "damage": 3
        },
        {
            "weaponType": "longsword",
            "damage": 3
        },
        {
            "weaponType": "mace",
            "damage": 3
        },
        {
            "weaponType": "axe",
            "damage": 4
        },
        {
            "weaponType": "waraxe",
            "damage": 4
        },
        {
            "weaponType": "warhammer",
            "damage": 8
        }
    ],
    "wall2-wood": [
        {
            "weaponType": "dagger",
            "damage": 3
        },
        {
            "weaponType": "saber",
            "damage": 3
        },
        {
            "weaponType": "spear",
            "damage": 3
        },
        {
            "weaponType": "longsword",
            "damage": 3
        },
        {
            "weaponType": "mace",
            "damage": 3
        },
        {
            "weaponType": "axe",
            "damage": 4
        },
        {
            "weaponType": "waraxe",
            "damage": 4
        },
        {
            "weaponType": "warhammer",
            "damage": 8
        }
    ]
};


class $e268b8ad73f8592a$export$ac354329a62081f3 {
    static{
        this.canRegen = (entityTile)=>{
            // can regen if there is a growth sequence defined
            return (0, $cdf806a94d4c01be$export$4783a51780b31483)[entityTile]?.growthSequence?.length > 0;
        };
    }
    static{
        this.hpDecrementOnHit = (entityTile, weaponType)=>{
            const specificDamage = (0, $7d8209f3c8c41e8b$export$166d0675377eb5ce)[entityTile]?.find((next)=>next.weaponType === weaponType)?.damage;
            if (specificDamage !== undefined) return specificDamage;
            const defaultDamage = (0, $7d8209f3c8c41e8b$export$40dde5e0c1bbd734)[entityTile];
            if (defaultDamage !== undefined) return defaultDamage;
            return 0;
        };
    }
}



const $fb270787c5863f7d$var$forcedPhase = null;
// "night"
// "day"
const $fb270787c5863f7d$var$dayLengthMinutes = 4;
const $fb270787c5863f7d$export$ddbab1c756f33643 = $fb270787c5863f7d$var$forcedPhase === "night" ? {
    night: {
        name: "night",
        brightness: 0.4,
        dayPct: 1.0
    }
} : $fb270787c5863f7d$var$forcedPhase === "day" ? {
    day: {
        name: "day",
        brightness: 1.0,
        dayPct: 1.0
    }
} : {
    dawn: {
        name: "dawn",
        brightness: 0.4,
        dayPct: 0.05
    },
    morning: {
        name: "morning",
        brightness: 0.7,
        dayPct: 0.2
    },
    day: {
        name: "day",
        brightness: 1.0,
        dayPct: 0.55
    },
    dusk: {
        name: "dusk",
        brightness: 0.5,
        dayPct: 0.6
    },
    night: {
        name: "night",
        brightness: 0.3,
        dayPct: 0.8
    },
    darkestNight: {
        name: "darkestNight",
        brightness: 0.2,
        dayPct: 1.0
    }
};
const $fb270787c5863f7d$export$fca8416b8f6d5cbe = Object.keys($fb270787c5863f7d$export$ddbab1c756f33643).map((n)=>n);
class $fb270787c5863f7d$export$c2f3c8cbbf29966c {
    static{
        this.pushable = (target)=>{
            return (target.npcType === "zombie" || target.npcType === "collectable" || target.entityType === "npc" || target.entityType === "player") && !target.immoveable;
        };
    }
    static{
        this.dayLengthClockCycles = ()=>$fb270787c5863f7d$var$dayLengthMinutes * 60;
    }
    static{
        this.computeDayPct = (clockTime)=>{
            const dayTick = clockTime % this.dayLengthClockCycles();
            const dayPct = dayTick / this.dayLengthClockCycles();
            return dayPct;
        };
    }
    static{
        this.computeDayPhase = (clockTime)=>{
            const dayPct = this.computeDayPct(clockTime);
            for(let i = 0; i < $fb270787c5863f7d$export$fca8416b8f6d5cbe.length; i++){
                const isFirst = i === 0;
                const isLast = i === $fb270787c5863f7d$export$fca8416b8f6d5cbe.length - 1;
                const thisPhase = $fb270787c5863f7d$export$ddbab1c756f33643[$fb270787c5863f7d$export$fca8416b8f6d5cbe[i]];
                const start = isFirst ? 0 : $fb270787c5863f7d$export$ddbab1c756f33643[$fb270787c5863f7d$export$fca8416b8f6d5cbe[i - 1]].dayPct;
                const end = thisPhase.dayPct;
                if (dayPct >= start && (isLast ? dayPct <= end : dayPct < end)) return thisPhase;
            }
            return null;
        };
    }
    static{
        this.isDay = (dayPhase)=>{
            return dayPhase?.name === "day" || dayPhase?.name === "morning";
        };
    }
    static{
        this.isNight = (dayPhase)=>{
            return dayPhase?.name === "night";
        };
    }
    static{
        this.campfireDurationClockCycles = ()=>this.dayLengthClockCycles() * 0.30;
    }
}



class $0c969a2957f131f5$export$1bb73b2ee4464e6d {
    static{
        this.default = {
            maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0),
            hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
            psych: {
                hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.25),
                chronotype: "diurnal",
                attackPattern: "default",
                aggroResponse: "default",
                closeOnStun: false
            }
        };
    }
    static{
        this.creatureBaselines = {
            slime: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0) * 0.15,
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.1),
                    chronotype: "diurnal"
                }
            },
            snake: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0) * 0.4,
                hp: 1,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.6),
                    chronotype: "diurnal"
                }
            },
            deer: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(1.0),
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.fromPctOfMax(0.1),
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().minimum
                }
            },
            rabbit: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0.7),
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().minimum,
                    chronotype: "diurnal"
                }
            },
            chicken: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0.05),
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().minimum,
                    chronotype: "diurnal"
                }
            },
            wasp: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0.05),
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.2),
                    chronotype: "diurnal",
                    attackPattern: "swoop"
                }
            },
            spikes1: {
                maxSpeed: 0,
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(1.0),
                    chronotype: "diurnal"
                }
            },
            redspider: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.fromPctOfMax(0.05),
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.minimum,
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.2),
                    chronotype: "diurnal",
                    closeOnStun: true,
                    attackPattern: "v2"
                }
            },
            skeleton: {
                maxSpeed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed.minimum,
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.fromPctOfMax(0.3),
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.5),
                    chronotype: "nocturnal",
                    attackPattern: "v2"
                },
                scanDistanceTiles: 6
            },
            zombie: {
                maxSpeed: 5,
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints.fromPctOfMax(0.3),
                psych: {
                    hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility().fromPctOfMax(0.5),
                    chronotype: "nocturnal",
                    attackPattern: "v2"
                },
                scanDistanceTiles: 6
            }
        };
    }
    static{
        this.speed = (race, pctOfMax = 1.0)=>{
            const baseline = this.creatureBaselines[race] || this.default;
            return baseline.maxSpeed * pctOfMax;
        };
    }
    static{
        this.hp = (race, pctOfMax = 1.0)=>{
            const baseline = this.creatureBaselines[race] || this.default;
            return baseline.hp * pctOfMax;
        };
    }
    static{
        this.scanDistanceTiles = (race)=>{
            const baseline = this.creatureBaselines[race] || this.default;
            return baseline.scanDistanceTiles || 5;
        };
    }
    static{
        this.psych = (race)=>(this.creatureBaselines[race] || this.default).psych;
    }
}




class $f28fc484d2ef7500$export$4824be15bd3c96e6 {
    static{
        this.npcTypesAllowingDisposition = new Set();
    }
    static{
        this.npcTypesAllowingDisposition.add("zombie");
        this.npcTypesAllowingDisposition.add("marker");
    }
    static{
        this.isOutpostFaction = (f)=>f.startsWith("outpost");
    }
    static{
        this.parseStemFaction = (f)=>f.split("-")[0];
    }
    static{
        this.computeFactionDisposition = (aFaction, bFaction)=>{
            if (!aFaction || aFaction === "none") return "neutral";
            if (!bFaction || bFaction === "none") return "neutral";
            // if they don't belong to the same faction
            // or if neither belong to a faction
            if (aFaction !== bFaction) {
                // outpost isn't aggressive towards neutral faction
                if (this.isOutpostFaction(aFaction) && bFaction === "neutral") return "neutral";
                if (this.parseStemFaction(aFaction) === this.parseStemFaction(bFaction)) // recognize each other as neutral, if they have the same
                // stem faction
                return "neutral";
                // but everyone else is hostile to a different faction
                return "hostile";
            }
            return "neutral";
        };
    }
    static{
        this.addUnilateralDisposition = (entity, disposition)=>{
            if (!disposition) {
                delete entity.flags.unilateralDisposition;
                return;
            }
            entity.flags.unilateralDisposition = disposition;
        };
    }
    static{
        this.uniLateralDisposition = (entity)=>entity?.flags.unilateralDisposition;
    }
    static{
        this.hardCodedDisposition = (entity, other)=>{
            if (!other) return "neutral";
            if (entity.flags.entityDispositions) return entity.flags.entityDispositions[other.entityId] || "neutral";
            return "neutral";
        };
    }
    static{
        this.addHardCodedDisposition = (entity, other, disposition)=>{
            if (!other) return;
            if (!entity.flags.entityDispositions) entity.flags.entityDispositions = {};
            const otherEntityId = typeof other === "object" ? other.entityId : other;
            entity.flags.entityDispositions[otherEntityId] = disposition;
        };
    }
    static{
        this.removeHardCodedDisposition = (entity, other)=>{
            if (!entity.flags.entityDispositions) entity.flags.entityDispositions = {};
            delete entity.flags.entityDispositions[other.entityId];
        };
    }
    static{
        //
        // FACTION-WIDE DISPOSITION OVERRIDES
        //
        // `entity.flags.factionDispositions` maps a faction name to how THIS entity regards
        // everyone in it, overriding the default faction-vs-faction rules:
        //
        //     flags: { factionDispositions: { wild: "neutral" } }
        //
        // The common case is "ignore that faction entirely" (map it to "neutral"), which is how
        // the ember wave enemies stop getting distracted by "wild" wilderness creatures on their
        // way to the camp. It's the faction-wide sibling of `entityDispositions` (keyed by
        // entityId); the per-entity map is more specific and still wins.
        //
        // The override is ONE-WAY by design: configuring it on A changes how A regards B, not how
        // B regards A. In practice that's usually enough for both directions, because the hostile
        // scans (findHostilesNear, proximity scans) ask "does the OTHER entity regard me as
        // hostile" — so an entity that ignores a faction also drops out of that faction's scans.
        this.factionDisposition = (entity, otherFaction)=>{
            if (!entity || !otherFaction) return undefined;
            return entity.flags?.factionDispositions?.[otherFaction];
        };
    }
    static{
        // True when `entity` is configured to regard `other`'s whole faction as anything but
        // hostile — i.e. it should never pick `other` as a target. Targeting paths that bypass
        // computeDisposition (proximity scans, script hostile scans) consult this directly.
        this.ignoresFaction = (entity, other)=>{
            const disposition = this.factionDisposition(entity, other?.faction);
            return !!disposition && disposition !== "hostile";
        };
    }
    static{
        this.addFactionDisposition = (entity, faction, disposition)=>{
            if (!faction) return;
            if (!entity.flags.factionDispositions) entity.flags.factionDispositions = {};
            entity.flags.factionDispositions[faction] = disposition;
        };
    }
    static{
        this.removeFactionDisposition = (entity, faction)=>{
            if (!entity.flags.factionDispositions) return;
            delete entity.flags.factionDispositions[faction];
        };
    }
    static{
        // Faction-level disposition between two entities: the regarding entity's own faction
        // override first, then the default faction-vs-faction rules. Use this instead of
        // computeFactionDisposition wherever both entities are in hand.
        this.computeEntityFactionDisposition = (entity, other)=>{
            const override = this.factionDisposition(entity, other?.faction);
            return override !== undefined ? override : this.computeFactionDisposition(entity?.faction, other?.faction);
        };
    }
    static{
        this.makeNpcSafe = (entity, durationMs)=>{
            entity.npcSafeUntilTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)() + durationMs;
        };
    }
    static{
        this.computeDisposition = (entity, other, now)=>{
            // both need to be present to calculate
            if (!entity || !other) return "neutral";
            // its the same entity
            if (entity.entityId === other.entityId) return "neutral";
            // if the other is marked to be safe
            if (other.isNpcSafe()) return "neutral";
            // if the other is marked away from keyboard
            if (other.afk) return "neutral";
            // there's an explicit unilateral disposition
            if (!!other?.flags.unilateralDisposition) {
                if (entity.lastStruckEntityId === other.entityId && other.flags.undefined !== "hostile") return "hostile";
                return other?.flags.unilateralDisposition;
            }
            // there's a hardcoded disposition
            if (!!entity.flags.entityDispositions && entity.flags.entityDispositions[other.entityId]) return entity.flags.entityDispositions[other.entityId];
            // the entity leads the other entity
            if (other.leaderEntityId && entity.entityId === other.leaderEntityId) return "friendly";
            // if the other entity has the same leader
            if (entity.leaderEntityId && other.leaderEntityId && entity.leaderEntityId === other.leaderEntityId) return "friendly";
            // if the entity's leader is the other entity
            if (entity.leaderEntityId && entity.leaderEntityId === other.entityId) return "defender";
            // a faction-wide override on this entity (e.g. an ember wave enemy configured to
            // ignore the "wild" wilderness creatures it passes on its way to the camp). The more
            // specific relationships above — hardcoded per-entity dispositions, leader/squad ties —
            // still win.
            const factionOverride = this.factionDisposition(entity, other.faction);
            if (factionOverride) return factionOverride;
            if (other.faction === "none") return "neutral";
            if (entity.faction && other.faction && entity.faction === other.faction && entity.faction !== "neutral") return "friendly";
            // if they don't belong to the same faction
            // or if neither belong to a faction
            if (!entity.faction && !other.faction || entity.faction !== other.faction) return this.computeFactionDisposition(entity.faction, other.faction);
            // if struck by other entity recently -- hostility
            if (entity.lastStruckByEntityId && entity.lastStruckByEntityId === other.entityId) {
                const occurrenceTs = (now || (0, $4171652afd996934$export$a86190deb5c4a8d0)()) - entity.lastStruckTs;
                const distance = (0, $cb689cfa16c444ba$export$9d23471d635d220b)(entity, other);
                if (occurrenceTs < 10000) return "hostile";
            }
            // if my leader struck by other entity recently -- hostility
            if (entity.leaderEntityId && entity.leaderEntityId === other.lastStruckEntityId) {
                const occurrenceTs = (now || (0, $4171652afd996934$export$a86190deb5c4a8d0)()) - other.lastStruckEntityTs;
                if (occurrenceTs < 10000) return "hostile";
            }
            // if my leader struck the other entity recently -- hostility
            if (entity.leaderEntityId && entity.leaderEntityId === other.lastStruckByEntityId) {
                const occurrenceTs = (now || (0, $4171652afd996934$export$a86190deb5c4a8d0)()) - other.lastStruckTs;
                if (occurrenceTs < 10000) return "hostile";
            }
            // its NPC but its not something you can develop a disposition about (eg. inanimate object)
            if (!!other.npcType && !this.npcTypesAllowingDisposition.has(other.npcType)) return "neutral";
            // its NPC but its not something you can develop a disposition about (eg. inanimate object)
            if (!!entity.npcType && !this.npcTypesAllowingDisposition.has(entity.npcType)) return "neutral";
            // // aron is for debugging
            // if (other.name === "aron") {
            //     return "neutral"
            // }
            if (entity.flags?.attackNeutral) return "hostile";
            // no relationship ... by default its neutral
            return "neutral";
        };
    }
}


class $33f5907b647b6bf7$export$9840549df5e88ecc {
    static{
        this.getCurrentQuest = (entity)=>{
            const currentQuestId = entity?.context?.questsContainer?.currentQuestId;
            if (!currentQuestId) return;
            return entity?.context?.questsContainer?.activeQuests?.find((n)=>n.entityId === currentQuestId);
        };
    }
    static{
        this.setCurrentQuest = (entity, quest)=>{
            if (!entity.context) entity.context = {};
            const container = entity.context.questsContainer || {
                activeQuests: [],
                completedQuests: []
            };
            entity.context.questsContainer = container;
            container.currentQuestId = quest.entityId;
        };
    }
    static{
        this.getQuest = (entity, questId)=>{
            return entity?.context?.questsContainer?.activeQuests?.find((n)=>n.entityId === questId);
        };
    }
    static{
        this.isCurrentQuest = (entity, quest)=>{
            return this.getCurrentQuest(entity)?.entityId === quest.entityId;
        };
    }
    static{
        this.setActiveQuestMarker = (entity, questMarker)=>{
            if (!entity.context) entity.context = {};
            entity.context.questActiveMarkerId = questMarker.id;
            return entity;
        };
    }
    static{
        this.getActiveQuestMarkerId = (entity)=>{
            return entity.context?.questActiveMarkerId;
        };
    }
    static{
        this.setActiveQuestObjective = (originEntity, questId, objectiveId, markerLocation)=>{
            const quest = originEntity.context?.questsContainer?.activeQuests.find((n)=>n.entityId === questId);
            if (!quest) return originEntity;
            const active = quest.objectives?.find((n)=>n.status === "active");
            if (active) active.status = "complete";
            const objective = quest.objectives?.find((n)=>n.id === objectiveId);
            if (objective) {
                objective.status = "active";
                objective.markerLocation = markerLocation;
                // also set the current quest
                originEntity.context.questsContainer.currentQuestId = quest.entityId;
            }
            return originEntity;
        };
    }
    static{
        this.getActiveQuestObjective = (originEntity, questId)=>{
            const quest = originEntity.context?.questsContainer?.activeQuests.find((n)=>n.entityId === questId);
            return quest.objectives?.find((n)=>n.status === "active");
        };
    }
    static{
        this.addQuest = (entity, quest, setCurrent)=>{
            if (!entity.context) entity.context = {};
            const container = entity.context.questsContainer || {
                activeQuests: [],
                completedQuests: []
            };
            entity.context.questsContainer = container;
            if (!container.activeQuests.find((n)=>n.entityId === quest.entityId)) container.activeQuests.push(quest);
            if (setCurrent) container.currentQuestId = quest.entityId;
            return entity;
        };
    }
    static{
        this.completeQuest = (entity, questId)=>{
            if (!entity.context) entity.context = {};
            const container = entity.context.questsContainer || {
                activeQuests: [],
                completedQuests: []
            };
            entity.context.questsContainer = container;
            const quest = container.activeQuests.find((n)=>n.entityId === questId);
            if (quest) {
                quest.status = "complete";
                container.activeQuests = container.activeQuests.filter((n)=>n.entityId !== questId);
                if (!container.completedQuests.find((n)=>n.entityId === questId)) container.completedQuests.push(quest);
                // clear current quest id
                container.currentQuestId = undefined;
            }
            return entity;
        };
    }
    static{
        this.findActiveQuest = (entity)=>{
            return entity.context?.questsContainer?.activeQuests?.find((n)=>n.status === "active");
        };
    }
    static{
        this.destroyQuest = (entity, questId)=>{
            const quest = this.getQuest(entity, questId);
            if (!quest) return;
            entity.context.questsContainer.activeQuests = entity?.context?.questsContainer.activeQuests?.filter((n)=>n.entityId !== questId);
            return entity;
        };
    }
}


class $d3527b517d667178$export$4cfe0674a42ef84e {
    static{
        this.version = "1.0.0";
    }
    static{
        this.item = (0, $6db9b00381e87aee$export$ad15344118fbba9b);
    }
    static{
        this.entity = (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0);
    }
    static{
        this.entityTile = (0, $e268b8ad73f8592a$export$ac354329a62081f3);
    }
    static{
        this.combat = (0, $bfabb40259688a2c$export$f1c3b8c7f0c3e30a);
    }
    static{
        this.social = (0, $f28fc484d2ef7500$export$4824be15bd3c96e6);
    }
    static{
        this.physics = (0, $fb270787c5863f7d$export$c2f3c8cbbf29966c);
    }
    static{
        this.population = (0, $0c969a2957f131f5$export$1bb73b2ee4464e6d);
    }
    static{
        this.effect = (0, $831ce8568a4294bd$export$b71c2cb4d3bdb35f);
    }
    static{
        this.quest = (0, $33f5907b647b6bf7$export$9840549df5e88ecc);
    }
}



const $cb689cfa16c444ba$export$29abb25bc3a2a243 = 32;
const $cb689cfa16c444ba$export$21eac3dda76c7241 = {
    ENABLED: true,
    FRICTION: 0.815,
    ACCELERATION: 0.4,
    MIN_VELOCITY_THRESHOLD: 0.01,
    UPDATE_FPS: 60
};
const $cb689cfa16c444ba$export$3b5e9888a97104e7 = [
    "Up",
    "Down",
    "Left",
    "Right"
];
const $cb689cfa16c444ba$export$86ae6e8ac17a67c6 = [
    ...$cb689cfa16c444ba$export$3b5e9888a97104e7,
    "DownRight",
    "DownLeft",
    "UpRight",
    "UpLeft"
];
const $cb689cfa16c444ba$export$6e47733a887561b3 = {
    emp: {
        maxDistance: $cb689cfa16c444ba$export$29abb25bc3a2a243 * 8,
        manaCost: 6,
        duration: 3000,
        equipOrder: 2,
        slotVisible: true
    },
    bomb: {
        equipOrder: 3,
        slotVisible: true
    },
    none: {
        slotVisible: true,
        bulletSpeed: 200,
        firingLatchMs: 400,
        manaCost: 1,
        maxDistance: 25,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    dagger: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 450,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    mace: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 500,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    rapier: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 500,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    saber: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 500,
        manaCost: 3,
        maxDistance: 40,
        maxParticles: 2,
        equipOrder: 0,
        baseDamage: 1.5,
        bulletSpriteId: "none"
    },
    scythe: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 500,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    longsword: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 550,
        manaCost: 3,
        maxDistance: 50,
        attackRange: 64,
        maxParticles: 2,
        equipOrder: 0,
        baseDamage: 2,
        pushStrength: 1,
        // bulletSpriteId: "arrow-brown.png"
        bulletSpriteId: "none"
    },
    flail: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 250,
        manaCost: 3,
        maxDistance: 45,
        attackRange: 64,
        maxParticles: 2,
        equipOrder: 0,
        baseDamage: 0.75,
        pushStrength: 1,
        maxEntitiesHit: 3,
        // bulletSpriteId: "arrow-brown.png"
        bulletSpriteId: "none"
    },
    halberd: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 500,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    waraxe: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 550,
        manaCost: 1,
        maxDistance: 40,
        attackRange: 64,
        maxParticles: 2,
        equipOrder: 0,
        baseDamage: 1,
        pushStrength: 2,
        // bulletSpriteId: "arrow-brown.png"
        bulletSpriteId: "none"
    },
    spear: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 525,
        manaCost: 1,
        maxDistance: 50,
        maxParticles: 3,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "none"
    },
    axe: {
        // slotVisible: true,
        // bulletSpeed: 150,
        // firingLatchMs: 500,
        // manaCost: 1,
        // maxDistance: 20,
        // maxParticles: 1,
        // equipOrder: 0,
        // baseDamage: 4,
        // bulletSpriteId: "arrow-brown.png"
        // // bulletSpriteId: "none"
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 500,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 2,
        equipOrder: 0,
        baseDamage: 3,
        maxEntitiesHit: 2,
        bulletSpriteId: "none"
    },
    warhammer: {
        slotVisible: true,
        bulletSpeed: 150,
        firingLatchMs: 600,
        manaCost: 1,
        maxDistance: 20,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 5,
        bulletSpriteId: "none",
        pushStrength: 2
    },
    bow: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 400,
        manaCost: 1,
        maxDistance: 160,
        attackRange: 128,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "arrow-brown.png",
        bulletType: "arrow"
    },
    web: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 400,
        manaCost: 1,
        maxDistance: 160,
        attackRange: 128,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 0,
        bulletType: "webAmmo",
        bulletSpriteId: "web-white.png",
        pushStrength: 0
    },
    crossbow: {
        slotVisible: true,
        bulletSpeed: 500,
        firingLatchMs: 400,
        manaCost: 1,
        maxDistance: 160,
        attackRange: 128,
        maxParticles: 1,
        equipOrder: 0,
        baseDamage: 1,
        bulletSpriteId: "arrow-brown.png"
    },
    staff: {
        slotVisible: true
    }
};
const $cb689cfa16c444ba$export$1cd76c5103dfeb09 = {
    bomb: {
        equipOrder: 0,
        shortcutKey: "b",
        maxCarried: 20
    },
    heal: {
        equipOrder: 1,
        shortcutKey: "q",
        maxCarried: 3
    },
    mana: {
        equipOrder: 2,
        shortcutKey: "e",
        maxCarried: 2
    },
    speed: {
        equipOrder: 3,
        shortcutKey: "r"
    }
};
const $cb689cfa16c444ba$export$dd7412b0a9bf9701 = {
    showRoomName: false
};
const $cb689cfa16c444ba$export$ede76e7dc512924d = [
    "player",
    "bullet",
    "npc",
    "bomb"
];
const $cb689cfa16c444ba$export$e7d8be01a25416cb = [
    ...$cb689cfa16c444ba$export$ede76e7dc512924d,
    "system"
];
const $cb689cfa16c444ba$export$c894fd4e81634c0f = {
    w: 640,
    h: 360
};
const $cb689cfa16c444ba$export$5b5223867019c37b = {
    player: {
        w: 25,
        h: 25
    },
    npc: {
        w: 25,
        h: 25
    },
    bullet: {
        w: 15,
        h: 15
    },
    bomb: {
        w: 20,
        h: 20
    },
    system: {
        w: 0,
        h: 0
    }
};
class $cb689cfa16c444ba$export$cc41417b72b96611 {
    constructor(id, x, y){
        this.id = id;
        this.coordinate = {
            x: x,
            y: y
        };
    }
}
class $cb689cfa16c444ba$export$cbcb4f84fc8dd985 {
    set(id, item, unshift = false) {
        const isNew = !this._map[id];
        this._map[id] = item;
        if (isNew) {
            if (unshift) this.list.unshift(id);
            else this.list.push(id);
        }
    }
    remove(id) {
        const toRemove = this._map[id];
        if (toRemove) {
            delete this._map[id];
            // splice in place rather than this.list.filter(...), which allocated a new
            // array on every removal. EntityManager.remove calls this once per entity
            // TYPE (8x) per entity removed, and all but one of those calls is a miss --
            // indexOf returns -1 and we now allocate nothing at all for those.
            const idx = this.list.indexOf(id);
            if (idx > -1) this.list.splice(idx, 1);
        }
        return toRemove;
    }
    constructor(){
        this._map = {};
        this.list = [];
        this.clear = ()=>{
            this._map = {};
            this.list = [];
        };
        this.get = (id)=>{
            return this._map[id];
        };
        this.has = (id)=>{
            return !!this.get(id);
        };
        this.includes = (id)=>{
            return !!this.get(id);
        };
        this.getAtIdx = (idx)=>{
            if (idx > this.list.length - 1) return undefined;
            return this._map[this.list[idx]];
        };
        this.pop = ()=>{
            const obj = this.getAtIdx(0);
            if (obj) this.remove(obj.entityId);
            return obj;
        };
        this.keys = ()=>Object.keys(this._map);
        this.contains = (id)=>!!this._map[id];
        this.size = ()=>this.list.length;
        this.empty = ()=>this.size() < 1;
        this.add = (item)=>{
            return this.set(item.entityId, item);
        };
        this.iterate = (visitor, predicate)=>{
            this.list.forEach((n)=>{
                if (predicate) {
                    if (predicate(this._map[n])) visitor(this._map[n]);
                } else visitor(this._map[n]);
            });
        };
        this.forEach = this.iterate;
        this.map = (op)=>{
            return this.list.map((k)=>this._map[k]).map(op);
        };
        this.push = (item)=>{
            this.set(item.entityId, item);
        };
        this.filter = (predicate)=>{
            return this.list.map((n)=>this._map[n]).filter(predicate);
        };
        this.find = (predicate)=>{
            const key = this.list.find((n)=>{
                const item = this._map[n];
                if (predicate(item)) return true;
            });
            return key ? this._map[key] : undefined;
        };
        this.collect = (predicate)=>{
            if (!predicate) return [
                ...this.list.map((n)=>this._map[n])
            ];
            const collection = [];
            this.iterate((item)=>{
                collection.push(item);
            }, predicate);
            return collection;
        };
    }
}
class $cb689cfa16c444ba$export$7230fbaff49306c8 extends $cb689cfa16c444ba$export$cbcb4f84fc8dd985 {
    constructor(...args){
        super(...args), this.ctr = -1, this.next = ()=>{
            this.ctr++;
            if (this.ctr > this.size() - 1) this.ctr = 0;
            return this.getAtIdx(this.ctr);
        }, // -1, not 0, because next() PRE-increments: the counter starts life at -1 so the first next()
        // returns index 0, and a reset has to put it back in that same state. Setting it to 0 made the
        // next() after a reset return index 1, so element 0 was skipped every time round. Its one caller
        // is Metabrain.advance, where that meant the FIRST always-run trait of any npc whose pipeline
        // contains a "reset"-returning behaviour never ran at all -- see
        // docs/ember-wave-enemy-stall-analysis.md.
        this.reset = ()=>{
            this.ctr = -1;
        };
    }
}
class $cb689cfa16c444ba$export$aa8c1c798dd2d10a {
    constructor(){
        this.key1Map = new Map();
        this.key2Map = new Map();
        this.set = (val, key1, key2)=>{
            if (key1) this.key1Map.set(key1, val);
            if (key2) this.key2Map.set(key2, val);
        };
        this.remove = (key)=>{
            this.key1Map.delete(key);
            this.key2Map.delete(key);
        };
        this.get = (key)=>{
            const v1 = this.key1Map.get(key);
            const v2 = this.key2Map.get(key);
            return v1 || v2;
        };
        this.getExact = (key, key2)=>{
            const v1 = this.key1Map.get(key);
            const v2 = this.key2Map.get(key2);
            return v1 && v2 ? v1 : undefined;
        };
        this.has = (key)=>{
            return !!this.get(key);
        };
    }
}
class $cb689cfa16c444ba$export$ccc1bed6c7489102 extends $cb689cfa16c444ba$export$cbcb4f84fc8dd985 {
    set(id, item, unshift = false) {
        super.set(id, item, unshift);
        this.lastUpdatedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    }
    remove(id) {
        const removed = super.remove(id);
        // Only advance the "lights changed" timestamp when a light was actually
        // removed. Entity teardown calls lights.remove() for EVERY entity, including
        // non-light collectables (dropped wood/seeds). Bumping unconditionally
        // invalidated the shadow/visibility cache (the ts is part of its hash), forcing
        // a synchronous sight-polygon recompute + generateTexture on the next frame --
        // a visible hitch each time you walk over a dropped item.
        if (removed) this.lastUpdatedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        return removed;
    }
}
class $cb689cfa16c444ba$export$c4e9d269599ab4b4 {
    constructor(x1, y1, x2, y2){
        this.centerCoordinate = (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)();
        this.update = (x, y)=>{
            this.x1 = x - this.width / 2;
            this.y1 = y - this.height / 2;
            this.x2 = x + this.width / 2;
            this.y2 = x + this.height / 2;
            this.centerCoordinate.x = Math.floor(this.x1 + this.width / 2);
            this.centerCoordinate.y = Math.floor(this.y1 + this.height / 2);
            return this;
        };
        this.center = ()=>{
            return this.centerCoordinate;
        };
        this.clone = ()=>{
            return new $cb689cfa16c444ba$export$c4e9d269599ab4b4(this.x1, this.y1, this.x2, this.y2);
        };
        this.toString = ()=>{
            return `${this.x1},${this.y1},${this.x2},${this.y2}`;
        };
        this.expand = (amount)=>{
            this.x1 -= amount;
            this.y1 -= amount;
            this.x2 += amount;
            this.y2 += amount;
            this.recompute();
            return this;
        };
        this.shrink = (amount)=>{
            this.x1 += amount;
            this.y1 += amount;
            this.x2 -= amount;
            this.y2 -= amount;
            this.recompute();
            return this;
        };
        this.translate = (x, y)=>{
            this.x1 += x;
            this.x2 += x;
            this.y1 += y;
            this.y2 += y;
            this.recompute();
        };
        this.isCorner = (x, y)=>{
            if (this.x1 === x && this.y1 === y) return true;
            if (this.x2 - 1 === x && this.y1 === y) return true;
            if (this.x1 === x && this.y2 - 1 === y) return true;
            if (this.x2 - 1 === x && this.y2 - 1 === y) return true;
            return false;
        };
        this.visitEdges = (visitor, edge)=>{
            for(let x = this.topLeft().x; x < this.topLeft().x + this.width; x++){
                if (!edge || edge === "Up") visitor(x, this.topLeft().y);
                if (!edge || edge === "Down") visitor(x, this.topLeft().y + this.height - 1);
            }
            for(let y = this.topLeft().y; y < this.topLeft().y + this.height; y++){
                if (!edge || edge === "Left") visitor(this.topLeft().x + this.width - 1, y);
                if (!edge || edge === "Right") visitor(this.topLeft().x, y);
            }
        };
        this.randomEdge = (edge)=>{
            if (edge === "Up") return {
                x: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().x, this.topLeft().x + this.width),
                y: this.topLeft().y
            };
            if (edge === "Down") return {
                x: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().x, this.topLeft().x + this.width),
                y: this.topLeft().y + this.height - 1
            };
            if (edge === "Left") return {
                x: this.topLeft().x,
                y: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().y, this.topLeft().y + this.height)
            };
            if (edge === "Right") return {
                x: this.topLeft().x + this.width,
                y: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().y, this.topLeft().y + this.height)
            };
            return null;
        };
        this.getAllCoordinates = ()=>{
            const all = [];
            for(let x = this.topLeft().x; x < this.topLeft().x + this.width; x++)for(let y = this.topLeft().y; y < this.topLeft().y + this.height; y++)all.push({
                x: x,
                y: y
            });
            return all;
        };
        this.edgesAreClose = (other, threshold)=>{
            let failed = false;
            this.visitEdges((x, y)=>{
                if (failed) return;
                other.visitEdges((oX, oY)=>{
                    if (failed) return;
                    failed = $cb689cfa16c444ba$export$79376507b09a66f(x, y, oX, oY) < threshold;
                });
            });
            return failed;
        };
        this.widen = (otherBounds)=>{
            otherBounds.forEach((other, i)=>{
                if (i === 0) {
                    this.x1 = other.x1;
                    this.y1 = other.y1;
                    this.x2 = other.x2;
                    this.y2 = other.y2;
                } else {
                    if (other.x1 < this.x1) this.x1 = other.x1;
                    if (other.x2 > this.x2) this.x2 = other.x2;
                    if (other.y1 < this.y1) this.y1 = other.y1;
                    if (other.y2 > this.y2) this.y2 = other.y2;
                }
            });
            this.recompute();
        };
        this.topLeft = ()=>({
                x: this.x1,
                y: this.y1
            });
        this.topRight = ()=>({
                x: this.x2,
                y: this.y1
            });
        this.bottomLeft = ()=>({
                x: this.x1,
                y: this.y2
            });
        this.bottomRight = ()=>({
                x: this.x2,
                y: this.y2
            });
        this.widenViaCoordinate = (coordinate)=>{
            if (this.x1 === -1 || this.y1 === -1 || this.x2 === -1 || this.y2 === -1) {
                this.x1 = coordinate.x;
                this.y1 = coordinate.y;
                this.x2 = coordinate.x;
                this.y2 = coordinate.y;
            } else {
                if (this.includes(coordinate)) return;
                if (coordinate.x < this.x1) this.x1 = coordinate.x;
                if (coordinate.y < this.y1) this.y1 = coordinate.y;
                if (coordinate.x > this.x2) this.x2 = coordinate.x;
                if (coordinate.y > this.y2) this.y2 = coordinate.y;
            }
            this.recompute();
        };
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.width = this.x2 - this.x1;
        this.height = this.y2 - this.y1;
        this.centerCoordinate.x = Math.floor(this.x1 + this.width / 2);
        this.centerCoordinate.y = Math.floor(this.y1 + this.height / 2);
    }
    static from(x, y, width, height) {
        return new $cb689cfa16c444ba$export$c4e9d269599ab4b4(x, y, x + width, y + height);
    }
    collision(other) {
        if (!other) return false;
        // Optimized AABB collision detection - early exit on non-collision
        // Check if bounds are separated on any axis (using > instead of >= to maintain touching behavior)
        return !(other.x1 > this.x2 || other.x2 < this.x1 || other.y1 > this.y2 || other.y2 < this.y1);
    }
    encloses(other) {
        return this.x1 <= other.x1 && this.x2 >= other.x2 && this.y1 <= other.y1 && this.y2 >= other.y2;
    }
    hasNegative() {
        return this.x1 < 0 || this.x2 < 0 || this.y1 < 0 || this.y2 < 0;
    }
    includes(other) {
        return !(other.x > this.x2 || other.x < this.x1 || other.y > this.y2 || other.y < this.y1);
    }
    recompute() {
        this.width = this.x2 - this.x1;
        this.height = this.y2 - this.y1;
        this.centerCoordinate.x = Math.floor(this.x1 + this.width / 2);
        this.centerCoordinate.y = Math.floor(this.y1 + this.height / 2);
    }
    static{
        this.createCenteredBounds = (x, y, width, height)=>{
            return new $cb689cfa16c444ba$export$c4e9d269599ab4b4(x - width / 2, y - height / 2, x + width / 2, y + height / 2);
        };
    }
}
const $cb689cfa16c444ba$export$9c8df8edf5099d2f = 600;
const $cb689cfa16c444ba$export$5ba2a289d3a4278 = 6;
const $cb689cfa16c444ba$export$b561b6feb9d8b940 = 200;
const $cb689cfa16c444ba$export$505f8954cbaa597 = 2;
class $cb689cfa16c444ba$export$57999cdfb043a089 {
}
class $cb689cfa16c444ba$export$bc644a473284d944 {
    constructor(){
        this.maxSpeed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.minimum;
        this.speed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.minimum;
        this.speed2 = {
            x: 0,
            y: 0
        };
        this.position_buffer = [];
        this.input_sequence_number = 0;
        this.pending_inputs = [];
        this.entityState = "live";
        this.lastMoveTs = 0;
        this.hitByEntityIdTs = {};
        this.maxHp = 3;
        this.hp = 3;
        this.mana = 20;
        this.maxMana = 20;
        this.hunger = 20;
        this.maxHunger = 20;
        this.manaRecoveryDelay = 600;
        this.boostPct = 0.0;
        this.boostCost = $cb689cfa16c444ba$export$5ba2a289d3a4278;
        this.weight = 0;
        this.damage = 1;
        this.visible = true;
        this.flags = {};
        this.lastUpdateTs = null;
        this.lastRoomUpdateTs = 0;
        this.fromEntity = (entity)=>{
            this.fromJson(JSON.parse(JSON.stringify(entity)));
        };
        this.fromJson = (json)=>{
            if (!json) return;
            Object.keys(json).forEach((key)=>{
                const value = json[key];
                if (typeof this[key] !== "function") this[key] = value;
            });
            const fixedBounds = json.fixedBounds;
            this.bounds = undefined;
            if (fixedBounds) {
                this.fixedBounds = fixedBounds;
                this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(fixedBounds.x1, fixedBounds.y1, fixedBounds.x2, fixedBounds.y2);
            }
        };
        this.serializeToString = ()=>{
            return `${this.entityId}|${this.entityType}|${this.npcType || ""}|${this.faction || ""}|${this.entityState || ""}|${this.location.x}|${this.location.y}|${this.visible === true}|${this.strikeable}|${this.leaderEntityId || ""}|${this.dimensions.w}|${this.dimensions.h}|${this.expirationTs}|${this.flags ? JSON.stringify(this.flags) : ""}|${this.fixedBounds ? JSON.stringify(this.fixedBounds) : ""}|${JSON.stringify(this.movement)}|${this.paralyzeUntilTs}|${this.npcSafeUntilTs}|${this.afk === true}|${this.carried === true}|${this.speed}|${this.maxSpeed}|${this.lastStruckByEntityId || ""}|${this.lastStruckTs}|${this.lastStruckEntityId || ""}|${this.lastStruckEntityTs}`;
        };
        this.getGrossOrientation = ()=>{
            const direction = (0, $a80d0b17b615d6f7$export$94d6114d0f45bc7e)(this.movement.angle);
            if ([
                "Left",
                "Right"
            ].includes(direction)) return "LeftRight";
            else return "UpDown";
        };
        this.getCollisionBounds = (_x, _y)=>{
            if (this.fixedBounds) return this.bounds;
            const x = _x || this.location.x;
            const y = _y || this.location.y;
            if (!this.bounds) this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(0, 0, 0, 0);
            if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateCollisionBounds(this, this.bounds)) ;
            else {
                this.bounds.x1 = x - this.dimensions.w / 2;
                this.bounds.y1 = y - this.dimensions.h / 2;
                this.bounds.x2 = x + this.dimensions.w / 2;
                this.bounds.y2 = y + this.dimensions.h / 2;
            }
            this.bounds.recompute();
            return this.bounds;
        };
        this.getBounds = (_x, _y)=>{
            if (this.fixedBounds) return this.bounds;
            const x = _x || this.location.x;
            const y = _y || this.location.y;
            if (!this.bounds) this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(0, 0, 0, 0);
            this.bounds.x1 = x - (this.dimensions?.w || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.y1 = y - (this.dimensions?.h || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.x2 = x + (this.dimensions?.w || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.y2 = y + (this.dimensions?.h || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.recompute();
            return this.bounds;
        };
        this.getNavigationBounds = (_x, _y)=>{
            if (this.fixedBounds) return this.bounds;
            const x = _x || this.location.x;
            const y = _y || this.location.y;
            if (!this.bounds) this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(0, 0, 0, 0);
            // Always use standard 25x25 for navigation, same as players
            this.bounds.x1 = x - 12.5;
            this.bounds.y1 = y - 12.5;
            this.bounds.x2 = x + 12.5;
            this.bounds.y2 = y + 12.5;
            this.bounds.recompute();
            return this.bounds;
        };
        this.updateDimensions = (w, h)=>{
            this.dimensions = {
                w: w,
                h: h
            };
            return this.getBounds();
        };
        this.travelledDistance = ()=>{
            return $cb689cfa16c444ba$export$79376507b09a66f(this.origin?.x, this.origin?.y, this.location.x, this.location.y);
        };
        this.updateMana = (amt)=>{
            this.mana = Math.max(0, Math.min(this.maxMana, this.mana + amt));
        };
        this.updateHp = (amt)=>{
            this.hp = Math.max(0, Math.min(this.maxHp, this.hp + amt));
        };
        this.updateHunger = (amt)=>{
            this.hunger = Math.max(0, Math.min(this.maxHunger, this.hunger + amt));
        };
        this.hungerPct = ()=>{
            return this.hunger / this.maxHunger;
        };
        this.isDead = ()=>this.entityState === "dead";
        this.markDead = ()=>this.entityState = "dead";
        this.isPlayer = ()=>this.entityType === "player";
        this.isParalyzed = ()=>(this.paralyzeUntilTs || 0) > (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.isDowned = ()=>(this.downedUntilTs || 0) > (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.isNpcSafe = ()=>(this.npcSafeUntilTs || 0) > (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.safeName = ()=>{
            let name = this.name;
            if (!name) {
                name = this.appearance?.race || (this.flags?.isCampfire ? "campfire" : undefined) || (this.flags?.isFire ? "fire" : undefined) || this.npcType || this.entityType;
                name = this.isPlayer() ? `${name} player` : name;
            }
            const max = 15;
            if (name?.length > max) return name.substring(0, max - 3) + "...";
            return name;
        };
        this.resetHitByEntityIdTs = ()=>{
            this.hitByEntityIdTs = {};
        };
        this.canPersist = ()=>{
            return this.expirationTs === undefined && this.persistable === true;
        };
        this.lightIntensity = ()=>{
            return this.npcType === "light" ? 0.8 : this.lightMeta ? this.lightMeta.intensity : 0.6;
        };
        this.lightRadius = ()=>{
            return this.npcType === "light" ? 50 : this.lightMeta ? this.lightMeta.radius : 30;
        };
        this.location = {
            x: -1,
            y: -1
        };
        this.roomId = "tutorial1";
        this.origin = {
            x: -1,
            y: -1
        };
        this.movement = {
            moving: false,
            direction: "Up",
            angle: 0
        };
        this.position_buffer = [];
        this.inventory = {
            items: [],
            abilities: {},
            lastUpdateTs: (0, $4171652afd996934$export$a86190deb5c4a8d0)()
        };
        this.upgradePoints = 0;
        this.level = 1;
    }
    static{
        this.fromJson = (json)=>{
            if (!json) return;
            const entity = new $cb689cfa16c444ba$export$bc644a473284d944();
            entity.fromJson(json);
            return entity;
        };
    }
    static{
        this.fromString = (roomId, text)=>{
            if (!text) return;
            const [entityId, entityType, npcType, faction, entityState, x, y, visible, strikeable, leaderEntityId, dimensionsW, dimensionsH, expirationTs, flags, fixedBounds, movement, paralyzeUntilTs, npcSafeUntilTs, afk, carried, speed, maxSpeed, lastStruckByEntityId, lastStruckTs, lastStruckEntityId, lastStruckEntityTs] = text.split("|");
            const entity = new $cb689cfa16c444ba$export$bc644a473284d944();
            entity.entityId = entityId;
            entity.entityType = entityType;
            entity.npcType = npcType !== "null" && npcType !== "undefined" && npcType !== "" ? npcType : undefined;
            entity.faction = faction !== "null" && faction !== "undefined" && faction !== "" ? faction : undefined;
            entity.entityState = entityState !== "null" && entityState !== "undefined" && entityState !== "" ? entityState : undefined;
            entity.leaderEntityId = leaderEntityId !== "null" && leaderEntityId !== "undefined" && leaderEntityId !== "" ? leaderEntityId : undefined;
            entity.expirationTs = expirationTs !== "null" && expirationTs !== "undefined" ? parseInt(expirationTs) : undefined;
            entity.flags = flags !== "" ? JSON.parse(flags) : undefined;
            entity.paralyzeUntilTs = paralyzeUntilTs !== "null" && paralyzeUntilTs !== "undefined" ? Number.parseInt(paralyzeUntilTs) : undefined;
            entity.npcSafeUntilTs = npcSafeUntilTs !== "null" && npcSafeUntilTs !== "undefined" ? Number.parseInt(npcSafeUntilTs) : undefined;
            entity.carried = carried !== "null" && carried !== "undefined" ? carried === "true" : undefined;
            entity.afk = afk === "true";
            const location = {
                x: parseFloat(x),
                y: parseFloat(y)
            };
            entity.location = location;
            entity.roomId = roomId;
            entity.visible = visible === "true";
            entity.strikeable = strikeable === "true";
            entity.dimensions = {
                w: parseInt(dimensionsW),
                h: parseInt(dimensionsH)
            };
            if (fixedBounds) {
                entity.fixedBounds = JSON.parse(fixedBounds);
                const { x1: x1, y1: y1, x2: x2, y2: y2 } = entity.fixedBounds;
                entity.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(x1, y1, x2, y2);
            }
            if (movement) entity.movement = JSON.parse(movement);
            entity.speed = Number(speed);
            entity.maxSpeed = Number(maxSpeed);
            entity.lastStruckByEntityId = lastStruckByEntityId;
            entity.lastStruckTs = lastStruckTs !== "null" && lastStruckTs !== "undefined" ? parseInt(lastStruckTs) : undefined;
            entity.lastStruckEntityId = lastStruckEntityId;
            entity.lastStruckEntityTs = lastStruckEntityTs !== "null" && lastStruckEntityTs !== "undefined" ? parseInt(lastStruckEntityTs) : undefined;
            return entity;
        };
    }
    applyInput(angle, press_timeRaw, speed2, applyInputResult, collisionMover, allowAdjust, allowSlide, useNavigationBounds) {
        const a = !speed2 ? undefined : (0, $a80d0b17b615d6f7$export$b363da9ded343252)(speed2, {
            x: 0,
            y: 0
        });
        const diagonal = a === undefined ? false : this.isPlayer() ? (0, $a80d0b17b615d6f7$export$df50878468f09592)(a) : false;
        const press_time = diagonal ? press_timeRaw * 0.7 : press_timeRaw;
        let x = 0, y = 0;
        let intersection = applyInputResult.intersection;
        if (angle !== undefined) this.movement.angle = angle;
        if (speed2 !== undefined) {
            if (allowSlide) {
                const xItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                const yItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                const resultX = (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.checkout();
                const resultY = (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.checkout();
                try {
                    x += speed2.x * press_time;
                    xItem.data.x = x;
                    xItem.data.y = 0;
                    const boundsToUseX = useNavigationBounds ? this.getNavigationBounds() : this.getBounds();
                    collisionMover(boundsToUseX, xItem.data, resultX.data, allowAdjust);
                    const { adjust: adjustX, collided: collidedX, collision: c1, intersection: i1 } = resultX.data;
                    y += speed2.y * press_time;
                    yItem.data.x = 0;
                    yItem.data.y = y;
                    const boundsToUseY = useNavigationBounds ? this.getNavigationBounds() : this.getBounds();
                    collisionMover(boundsToUseY, yItem.data, resultY.data, allowAdjust);
                    const { adjust: adjustY, collided: collidedY, collision: c2, intersection: i2 } = resultY.data;
                    if (collidedX && collidedY) {
                        applyInputResult.movedX = false;
                        applyInputResult.movedY = false;
                        applyInputResult.collision.x = c1.x;
                        applyInputResult.collision.y = c2.y;
                        return;
                    }
                    this.location.x = Math.max(adjustX.x, 0);
                    this.location.y = Math.max(adjustY.y, 0);
                    this.lastMoveTs = x > 0 || y > 0 ? (0, $4171652afd996934$export$a86190deb5c4a8d0)() : this.lastMoveTs;
                    applyInputResult.movedX = !collidedX;
                    applyInputResult.movedY = !collidedY;
                    applyInputResult.collision.x = c1?.x;
                    applyInputResult.collision.y = c2?.y;
                    applyInputResult.intersection.x = (!(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i1) ? i1 : !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i2) ? i2 : undefined)?.x;
                    applyInputResult.intersection.y = (!(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i1) ? i1 : !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i2) ? i2 : undefined)?.y;
                    applyInputResult.intersection.intersectionType = (!(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i1) ? i1 : !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i2) ? i2 : undefined)?.intersectionType;
                } finally{
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(xItem);
                    (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.release(resultX);
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(yItem);
                    (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.release(resultY);
                }
            } else {
                const item = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                const result = (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.checkout();
                try {
                    x += speed2.x * press_time;
                    y += speed2.y * press_time;
                    item.data.x = x;
                    item.data.y = y;
                    const boundsToUse = useNavigationBounds ? this.getNavigationBounds() : this.getBounds();
                    collisionMover(boundsToUse, item.data, result.data, allowAdjust);
                    const { adjust: adjust, collided: collided, collision: collision, intersection: i1 } = result.data;
                    (0, $a80d0b17b615d6f7$export$5afd74d1b598607d)(i1, intersection);
                    intersection.intersectionType = i1.intersectionType;
                    if (collided) {
                        applyInputResult.movedX = false;
                        applyInputResult.movedY = false;
                        applyInputResult.collision.x = collision.x;
                        applyInputResult.collision.y = collision.y;
                        (0, $a80d0b17b615d6f7$export$5afd74d1b598607d)(intersection, applyInputResult.intersection);
                        applyInputResult.intersection.intersectionType = intersection.intersectionType;
                        return;
                    }
                    this.location.x = Math.max(adjust.x, 0);
                    this.location.y = Math.max(adjust.y, 0);
                } finally{
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(item);
                    (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.release(result);
                }
            }
            this.lastMoveTs = x > 0 || y > 0 ? (0, $4171652afd996934$export$a86190deb5c4a8d0)() : this.lastMoveTs;
            if (useNavigationBounds) {
                // Only set movedX and movedY to true if the entity actually moved
                if (x !== 0 || y !== 0) {
                    applyInputResult.movedX = true;
                    applyInputResult.movedY = true;
                } else {
                    applyInputResult.movedX = false;
                    applyInputResult.movedY = false;
                }
            } else {
                applyInputResult.movedX = true;
                applyInputResult.movedY = true;
            }
        } else {
            // No movement input, so no movement
            applyInputResult.movedX = false;
            applyInputResult.movedY = false;
        }
    }
}
const $cb689cfa16c444ba$export$79376507b09a66f = (x1, y1, x2, y2)=>{
    let y = x2 - x1;
    let x = y2 - y1;
    return Math.sqrt(x * x + y * y);
};
const $cb689cfa16c444ba$export$72a3639d5dd4d5f8 = (a, b)=>$cb689cfa16c444ba$export$79376507b09a66f(a.x, a.y, b.x, b.y);
const $cb689cfa16c444ba$export$9d23471d635d220b = (e1, e2)=>{
    return $cb689cfa16c444ba$export$79376507b09a66f(e1.location.x, e1.location.y, e2.location.x, e2.location.y);
};
const $cb689cfa16c444ba$export$7bddc4d01a7cbd18 = (min, max, options)=>{
    // min and max included
    if (options?.seed) return (0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)(min, max, options.seed);
    const fnToUse = options?.rngFn || Math.random;
    return Math.floor(fnToUse() * (max - min + 1) + min);
};
const $cb689cfa16c444ba$export$3fd68433dc33f3f9 = (min, max)=>{
    const str = (Math.random() * (max - min) + min).toFixed(3);
    return parseFloat(str);
};
const $cb689cfa16c444ba$export$30be1f861efc6479 = (pct, options)=>{
    // min and max included
    if (options?.randomIntBetween) return options.randomIntBetween(0, 100) >= 100 - pct;
    if (options?.seed) return $cb689cfa16c444ba$export$7bddc4d01a7cbd18(0, 100, {
        seed: options.seed
    }) >= 100 - pct;
    return $cb689cfa16c444ba$export$7bddc4d01a7cbd18(0, 100) >= 100 - pct;
};
const $cb689cfa16c444ba$export$b3b584c8d6ffe165 = ()=>{
    return $cb689cfa16c444ba$export$30be1f861efc6479(50);
};
const $cb689cfa16c444ba$export$403e7832f3d01519 = ()=>{
    return {
        tileTypes: []
    };
};
const $cb689cfa16c444ba$export$e08736116838d313 = (tilemapMeta)=>{
    const { isCollisionAt: isCollisionAt } = tilemapMeta;
    const func = (bounds)=>{
        const x = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.width());
        const y1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        const y2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        for(let y = y1; y <= y2; y++){
            if (x > tilemapMeta.width() - 1 || y > tilemapMeta.height() - 1) continue;
            if (isCollisionAt(x, y)) return true;
        }
        const x1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.width());
        const x2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        const y = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        for(let x = x1; x <= x2; x++){
            if (x > tilemapMeta.width() - 1 || y > tilemapMeta.height() - 1) continue;
            if (isCollisionAt(x, y)) return true;
        }
    };
    return func;
};
const $cb689cfa16c444ba$export$7e89f2bfd67dd894 = (tilemapMetaProvider, allowAdjust)=>{
    const { isCollisionAt: isCollisionAt, intersectionAt: intersectionAt } = tilemapMetaProvider;
    const func = (bounds, translate, result)=>{
        let blocked = false;
        // going right
        if (translate.x > 0) {
            const x = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.x2 + translate.x) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const y1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const y2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let y = y1; y <= y2; y++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                const collides = isCollisionAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Right");
                if (collides) {
                    blocked = true;
                    adjust = x * $cb689cfa16c444ba$export$29abb25bc3a2a243 - 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.x1 += translate.x;
                bounds.x2 += translate.x;
            } else if (allowAdjust) {
                bounds.x2 = adjust;
                bounds.x1 = adjust - bounds.width;
            }
        }
        // // going left
        if (translate.x < 0) {
            const x = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.x1 + translate.x) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const y1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const y2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let y = y1; y <= y2; y++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                if (isCollisionAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Left")) {
                    blocked = true;
                    adjust = x * $cb689cfa16c444ba$export$29abb25bc3a2a243 + $cb689cfa16c444ba$export$29abb25bc3a2a243 + 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.x1 += translate.x;
                bounds.x2 += translate.x;
            } else if (allowAdjust) {
                bounds.x1 = adjust;
                bounds.x2 = adjust + bounds.width;
            }
        }
        // going up
        if (translate.y < 0) {
            const x1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const x2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const y = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.y1 + translate.y) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let x = x1; x <= x2; x++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                if (isCollisionAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Up")) {
                    blocked = true;
                    adjust = y * $cb689cfa16c444ba$export$29abb25bc3a2a243 + $cb689cfa16c444ba$export$29abb25bc3a2a243 + 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.y1 += translate.y;
                bounds.y2 += translate.y;
            } else if (allowAdjust) {
                bounds.y1 = adjust;
                bounds.y2 = adjust + bounds.height;
            }
        }
        // going down
        if (translate.y > 0) {
            const x1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const x2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const y = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.y2 + translate.y) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let x = x1; x <= x2; x++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                if (isCollisionAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Down")) {
                    blocked = true;
                    adjust = y * $cb689cfa16c444ba$export$29abb25bc3a2a243 - 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.y1 += translate.y;
                bounds.y2 += translate.y;
            } else if (allowAdjust) {
                bounds.y1 = adjust - bounds.height;
                bounds.y2 = adjust;
            }
        }
        result.collided = blocked;
        const x = bounds.x1 + bounds.width / 2;
        const y = bounds.y1 + bounds.height / 2;
        const xx = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.x2 + translate.x) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
        const yy = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.y1 + translate.y) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
        const intersection = intersectionAt(xx, yy);
        if (intersection) {
            result.intersection.x = xx;
            result.intersection.y = yy;
            result.intersection.intersectionType = intersection;
        }
        result.adjust.x = x;
        result.adjust.y = y;
    };
    return func;
};
class $cb689cfa16c444ba$export$b56caa74c129a90c {
    constructor(threshold, now, expireCallback){
        /**
     * `now` lets a caller that has ALREADY read the clock hand its reading in rather than paying for
     * another one. Same semantics either way; it exists for hot loops that read the clock anyway
     * (see NpcManager.advanceNpcs, where the latch behind a Thruput was the fourth reading per npc).
     */ this.expired = (write = true, now = (0, $4171652afd996934$export$a86190deb5c4a8d0)())=>{
            if (now - this.ts > this.threshold) {
                if (!this.singleUse && write) this.ts = now;
                if (this.expireCallback) this.expireCallback();
                return true;
            }
            return false;
        };
        this.update = (threshold)=>{
            this.threshold = threshold;
        };
        this.reset = ()=>this.ts = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.clear = ()=>this.ts = 0;
        this.ts = now || 0;
        this.threshold = threshold;
        this.expireCallback = expireCallback;
    }
}
const $cb689cfa16c444ba$export$c8c6d6e2d9b5390d = "sigil";
const $cb689cfa16c444ba$export$1bb94dd20d93df2d = "Limbo";
const $cb689cfa16c444ba$export$d63e9b5687ab18eb = "possession";
const $cb689cfa16c444ba$export$31a13f058b1e12c3 = "possessedBy";
const $cb689cfa16c444ba$export$ce7e2d4b62e55311 = "possessedPresence";
const $cb689cfa16c444ba$export$ec1f55a13cc9f82d = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$d63e9b5687ab18eb];
const $cb689cfa16c444ba$export$1b6f57988e845c = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$31a13f058b1e12c3];
const $cb689cfa16c444ba$export$8e84fd862f8e00d4 = (entity)=>entity?.flags?.[$cb689cfa16c444ba$export$d63e9b5687ab18eb]?.vesselEntityId;
const $cb689cfa16c444ba$export$13ed58ba57f3fe76 = (entity)=>entity?.flags?.[$cb689cfa16c444ba$export$31a13f058b1e12c3];
const $cb689cfa16c444ba$export$393c772047e6bffb = "invasion";
const $cb689cfa16c444ba$export$5fab807a8414b6a0 = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$393c772047e6bffb];
const $cb689cfa16c444ba$export$6973a44df0ae6af3 = "openToTheDead";
const $cb689cfa16c444ba$export$ded21fbd09134750 = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$6973a44df0ae6af3];
const $cb689cfa16c444ba$export$e2bee4d6bf0aad4f = (entity)=>entity?.flags?.[$cb689cfa16c444ba$export$393c772047e6bffb];
const $cb689cfa16c444ba$export$8e7d91cd700396c0 = [
    "ember-ready",
    "ember-items",
    "ember-crafting",
    "ember-recipe",
    "ember-pack",
    "ember-use"
];
const $cb689cfa16c444ba$export$a35d0571df2da201 = (tutorialType)=>!!tutorialType && $cb689cfa16c444ba$export$8e7d91cd700396c0.includes(tutorialType);
const $cb689cfa16c444ba$export$ae5c2924da49a08c = 6;
const $cb689cfa16c444ba$export$d84fb6ad88214660 = (tileMap, visitor)=>{
    for(let y = 0; y < tileMap.length; y++)for(let x = 0; x < tileMap[y].length; x++)visitor(x, y, tileMap[y][x]);
};



parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");
class $479d799412e4e1cb$export$153755f98d9861de {
    static{
        this.soundOptions = {};
    }
    constructor(logic){
        this.walkSoundEffectLatch = new Map();
        this.playingSoundtrack = {};
        this.volume = 0.7;
        this.devSoundEnabled = false;
        this.devSoundHinted = false;
        // Sound is off outside production so a dev session isn't noisy by default -- which also makes
        // it impossible to hear an effect you're working on. `devSound` opens it back up; see
        // installDevSoundToggle. Production is always audible and ignores the switch.
        this.audible = ()=>{
            if (this.logic.runLevel === "prod" || this.devSoundEnabled) return true;
            // Say why exactly once, the first time something tries to make a noise, so the silence
            // isn't a mystery to anyone who doesn't already know the toggle exists.
            if (!this.devSoundHinted) {
                this.devSoundHinted = true;
                console.log("[devSound] sound is muted outside production -- set `devSound = true` to hear it");
            }
            return false;
        };
        // Browser-console switch, in the same shape as window.playerRing / window.spriteShadow:
        //
        //     devSound = true     // unmute this session
        //     devSound = 0.3      // unmute at 30% volume
        //     devSound = false    // mute again
        //     devSound            // read the current state back
        //
        // Dev only: in production sound is already on, so the setter refuses rather than pretending
        // to do something. Guarded so it is a no-op in the Node test harness.
        this.installDevSoundToggle = ()=>{
            if (typeof window === "undefined") return;
            Object.defineProperty(window, "devSound", {
                get: ()=>({
                        enabled: this.devSoundEnabled,
                        volume: this.volume
                    }),
                set: (next)=>{
                    if (this.logic.runLevel === "prod") {
                        console.log("[devSound] production already plays sound; nothing to toggle");
                        return;
                    }
                    if (typeof next === "number") {
                        this.devSoundEnabled = next > 0;
                        this.volume = Math.max(0, Math.min(1, next));
                    } else this.devSoundEnabled = !!next;
                    console.log("[devSound]", {
                        enabled: this.devSoundEnabled,
                        volume: this.volume
                    });
                },
                configurable: true
            });
        };
        this.walking = (entity)=>{
        //
        };
        this.emp = (entity)=>{
            if (!this.logic.isTooDistantFromPlayer(entity)) this.play("emp", {
                volume: 0.25
            });
        };
        this.attack = (entity)=>{
            if (!this.logic.isTooDistantFromPlayer(entity)) this.play([
                "bow",
                "crossbow"
            ].includes(entity.weapon?.weaponType) ? "bowshot" : "swordswing", {
                volume: 0.05,
                speed: 0.85 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.03)
            });
        };
        this.hit = (entity)=>{
            this.play(`hit${(0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
                1,
                2
            ])}`, {
                volume: 0.075,
                speed: 0.75 + Math.min(0.25, Math.random())
            });
        // if (entity.npcType === "zombie") {
        //     if (randomIntBetween(0, 2) === 0) {
        //         this.play(`zombie-hit-${randomIntBetween(1, 6)}`, {
        //             volume: 0.20,
        //             speed: 0.85 + Math.min(0.15, Math.random())
        //         })
        //     }
        // }
        };
        this.death = (entity)=>{
        // if (entity.npcType === "zombie") {
        //     if (randomBool()) {
        //         this.play(`zombie-death-${randomIntBetween(1, 6)}`, {
        //             volume: 0.20,
        //             speed: 0.85 + Math.min(0.15, Math.random())
        //         })
        //     }
        // }
        };
        this.destroy = (entity)=>{
            this.walkSoundEffectLatch.delete(entity.entityId);
        };
        this.walk = (entity)=>{
            const baseline = 300;
            let meta = this.walkSoundEffectLatch.get(entity.entityId);
            if (!meta) {
                meta = {
                    latch: new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(baseline),
                    soundIdx: -1,
                    soundIdxMax: 2
                };
                this.walkSoundEffectLatch.set(entity.entityId, meta);
            }
            meta.latch.update(baseline);
            if (meta.latch.expired()) {
                meta.soundIdx++;
                if (meta.soundIdx > meta.soundIdxMax - 1) meta.soundIdx = 0;
                const footstep = entity.submerged ? `swamp${meta.soundIdx}` : `footsteps${meta.soundIdx}`;
                this.play(footstep, {
                    volume: 0.08 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.01, 0.03),
                    speed: 0.85 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.15)
                });
            }
        };
        // Command-wheel / role-picker confirmation. Pitched a touch at random so repeated
        // selections don't sound machine-gunned.
        this.uiSelect = ()=>{
            this.play("wheel_select", {
                speed: 1.0 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.04)
            });
        };
        this.mapLocationFound = ()=>{
            this.play("map_location", {
                volume: 0.5
            });
        };
        this.pickup = (itemTypeMeta)=>{
            if (itemTypeMeta.type === "shard-metal") this.play("coins", {
                volume: 0.1
            });
            else this.play("cloth", {
                volume: 0.05
            });
        };
        this.soundEffect = async (effect, loop, target)=>{
            if (!this.audible()) return;
            if ($479d799412e4e1cb$export$153755f98d9861de.isSoundtrack(effect)) {
                const targetSoundtrack = this.playingSoundtrack[target];
                if (targetSoundtrack && (!effect || targetSoundtrack?.trackId !== effect)) {
                    // if no effect, or its a different track for the target
                    // then halt it
                    if (!effect) delete this.playingSoundtrack[target];
                    const player = targetSoundtrack?.player;
                    // halt the currently played soundtrack
                    if (player) {
                        const maxVolume = player.volume;
                        const incr = Math.max(0.01, maxVolume / 50);
                        let prev = -1;
                        const volInterval = setInterval(()=>{
                            if (player.volume < 0.01 || prev === player.volume) {
                                clearInterval(volInterval);
                                player.stop();
                                return;
                            }
                            prev = player.volume;
                            player.set("volume", player.volume - incr);
                        }, 50);
                    }
                }
                if (!effect) return;
                if (targetSoundtrack && targetSoundtrack.trackId === effect) // soundtrack already playing for the target
                return;
                const targetVolume = ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect]?.volume || 1.0) * this.volume;
                const incr = Math.max(0.01, targetVolume / 50);
                const track = {
                    trackId: effect,
                    player: null
                };
                this.playingSoundtrack[target] = track;
                const instance = await (0, $8Odl4.sound).play(effect, {
                    ...$479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect] || {},
                    volume: 0.01 * this.volume,
                    loop: loop
                });
                const volInterval = setInterval(()=>{
                    if (instance.volume >= targetVolume) {
                        clearInterval(volInterval);
                        return;
                    }
                    instance.set("volume", (instance.volume + incr) * this.volume);
                }, 50);
                track.player = instance;
                return;
            }
            const playOptions = {
                ...$479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect] || {}
            };
            const volume = (playOptions.volume || 1.0) * this.volume;
            await (0, $8Odl4.sound).play(effect, {
                ...playOptions,
                volume: volume
            });
        };
        // stopSoundtrack = () => {
        //     this.activeSoundtrackId = null
        //     this.playingSoundtrack.stop()
        // }
        this.play = (s, options = {})=>{
            if (!this.audible()) return;
            const volume = (options.volume === undefined ? ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[s]?.volume || 1.0) * this.volume : options.volume) * this.volume;
            (0, $8Odl4.sound)?.play(s, {
                ...options,
                volume: volume
            });
        };
        this.setVolume = (volume)=>{
            this.volume = volume;
            Object.values(this.playingSoundtrack).forEach((track)=>{
                if (track.player) {
                    const updatedVolume = ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[track.trackId]?.volume || 1.0) * volume;
                    track.player.set("volume", updatedVolume);
                }
            });
        };
        this.logic = logic;
        this.installDevSoundToggle();
    }
    static{
        this.loadAssets = ()=>{
            // sound effects
            // for (let i = 0; i <= 8; i++) {
            //     Loader.shared.add(`footsteps${i}`, `assets/boots/${i}.ogg`)
            // }
            for(let i = 0; i <= 1; i++)(0, $kXE1p.Loader).shared.add(`footsteps${i}`, `assets/grass/${i}.ogg`);
            for(let i = 0; i <= 1; i++)(0, $kXE1p.Loader).shared.add(`swamp${i}`, `assets/swamp/${i}.ogg`);
            const audioPopulator = (category, action, numAssets, extension = "mp3")=>{
                for(let i = 1; i <= numAssets; i++)(0, $kXE1p.Loader).shared.add(`${category}-${action}-${i}`, `assets/${category}/${action}/${i}.${extension}`);
            };
            // audioPopulator("zombie", "attack", 7)
            // audioPopulator("zombie", "death", 6)
            // audioPopulator("zombie", "detect", 5)
            // audioPopulator("zombie", "hit", 6)
            // audioPopulator("human", "death", 8, "ogg")
            // soundtrack
            // Loader.shared.add('dome1.ogg', 'assets/dome1.ogg')
            (0, $kXE1p.Loader).shared.add("overworld1.ogg", "assets/overworld1.ogg");
            (0, $kXE1p.Loader).shared.add("overworld-day-noises.ogg", "assets/overworld-day-noises.ogg");
            (0, $kXE1p.Loader).shared.add("overworld-night-noises.ogg", "assets/overworld-night-noises.ogg");
            (0, $kXE1p.Loader).shared.add("dungeon-ambience.ogg", "assets/dungeon-ambience.ogg");
            (0, $kXE1p.Loader).shared.add("door-open.ogg", "assets/door-open.ogg");
            (0, $kXE1p.Loader).shared.add("to_battle.ogg", "assets/to_battle.ogg");
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["overworld1.ogg"] = {
                volume: 0.15
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["overworld-day-noises.ogg"] = {
                volume: 3.8
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["overworld-night-noises.ogg"] = {
                volume: 0.25
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["dungeon-ambience.ogg"] = {
                volume: 0.5
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["powerup"] = {
                volume: 0.5
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["door_close"] = {
                volume: 0.05
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["door_open"] = {
                volume: 0.05
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["door-open.ogg"] = {
                volume: 0.25
            };
            // Procedurally synthesized one-shots (packages/tools/src/sfx/gen.py). These are peak
            // normalized in the generator, so the balance against the older, quieter assets lives
            // here rather than in the files.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["campfire_lit"] = {
                volume: 0.3
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["campfire_fed"] = {
                volume: 0.25
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["wheel_select"] = {
                volume: 0.12
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["item_crafted"] = {
                volume: 0.25
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["wave_starting"] = {
                volume: 0.4
            };
        };
    }
    static{
        this.isSoundtrack = (effect)=>{
            if (!effect) return true;
            if (effect === "overworld1.ogg") return true;
            if (effect === "overworld-day-noises.ogg") return true;
            if (effect === "overworld-night-noises.ogg") return true;
            if (effect === "dungeon-ambience.ogg") return true;
            if (effect === "to_battle.ogg") return true;
            return false;
        };
    }
}




class $5f3ac23de5b4365c$export$d565f58bc438286b extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $5f3ac23de5b4365c$export$d565f58bc438286b();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: {
                movedX: false,
                movedY: false,
                collision: (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)(),
                intersection: {
                    ...(0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)(),
                    intersectionType: ""
                }
            }
        };
    }
    clear(item) {
        item.data.movedX = false;
        item.data.movedY = false;
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.collision);
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.intersection);
        item.data.intersection.intersectionType = "";
    }
}



class $04dfe581ed7487ef$export$377bbedb5576dfa8 {
    static{
        this.type_setEntityId = "0";
    }
    static{
        this.type_destroyEntityId = "1";
    }
    static{
        this.type_ping = "2";
    }
    static{
        this.type_struckEntityId = "3";
    }
    static{
        this.type_worldState = "4";
    }
    static{
        this.type_entityDisconnected = "5";
    }
    static{
        this.type_dropAction = "6";
    }
    static{
        this.type_screenMessage = "7";
    }
    static{
        this.type_detonate = "8";
    }
    static{
        this.type_chatMessage = "9";
    }
    static{
        this.type_resetAction = "10";
    }
    static{
        this.type_boostAction = "11";
    }
    static{
        this.type_aStarResult = "12";
    }
    static{
        this.type_aStarRequest = "14";
    }
    static{
        this.type_attack = "15";
    }
    static{
        this.type_killed = "16";
    }
    static{
        this.type_respawned = "17";
    }
    static{
        this.type_orientation = "18";
    }
    static{
        this.type_fadeInOut = "19";
    }
    static{
        this.type_fireWeapon = "20";
    }
    static{
        this.type_activateInventoryItem = "21";
    }
    static{
        this.type_entityEmp = "22";
    }
    static{
        this.type_hideRoomName = "23";
    }
    static{
        this.type_sendUpdateLocation = "24";
    }
    static{
        this.type_createLocalEntity = "25";
    }
    static{
        this.type_soundEffect = "26";
    }
    static{
        this.type_destroyLocalEntity = "27";
    }
    static{
        this.type_sendAnimateLocalEntityCollection = "28";
    }
    static{
        this.type_activateAbility = "29";
    }
    static{
        this.type_animateAbility = "30";
    }
    static{
        this.type_updateName = "31";
    }
    static{
        this.type_upgradeGuest = "32";
    }
    static{
        this.type_login = "33";
    }
    static{
        this.type_logActivity = "34";
    }
    static{
        this.type_playerEvent = "35";
    }
    static{
        this.type_showStatUpgradeUI = "36";
    }
    static{
        this.type_entityClicked = "37";
    }
    static{
        this.type_inventoryAction = "38";
    }
    static{
        this.type_requestEntityDetail = "39";
    }
    static{
        this.type_requestItemPickup = "40";
    }
    static{
        this.type_saveAppearance = "41";
    }
    static{
        this.type_mapDelta = "42";
    }
    static{
        this.type_entityTileEffect = "43";
    }
    static{
        this.type_dayPhase = "44";
    }
    static{
        this.type_startSession = "45";
    }
    static{
        this.type_updatePlayerEntityId = "46";
    }
    static{
        this.type_updateSquadState = "47";
    }
    static{
        this.type_requestEntityInteractions = "48";
    }
    static{
        this.type_updateEntityInteractions = "49";
    }
    static{
        this.type_updateEntityPointerIcon = "50";
    }
    static{
        this.type_buildCharacter = "51";
    }
    static{
        this.type_finalizeCharacter = "52";
    }
    static{
        this.type_itemPickedUp = "53";
    }
    static{
        this.type_showTutorial = "54";
    }
    static{
        this.type_updatePlayerBiomeColorMap = "55";
    }
    static{
        this.type_pulseInventoryItem = "56";
    }
    static{
        this.type_fragmentAnimation = "57";
    }
    static{
        this.type_entityFeedback = "58";
    }
    static{
        this.type_onDialogClose = "59";
    }
    static{
        this.type_sendVisibility = "60";
    }
    static{
        this.type_sendTeleported = "61";
    }
    static{
        this.type_locationIconEffect = "62";
    }
    static{
        this.type_updateAudio = "63";
    }
    static{
        this.type_submitFeedback = "64";
    }
    static{
        this.type_sendPleaseWait = "65";
    }
    static{
        this.type_requestPlayerLocations = "66";
    }
    static{
        this.type_activateWorldPoint = "67";
    }
    static{
        this.type_commitWorldEdits = "68";
    }
    static{
        this.type_redrawClient = "69";
    }
    static{
        this.type_getBuildingTilePreview = "70";
    }
    static{
        this.type_sendBuildingTilePreview = "71";
    }
    static{
        this.type_requestVisibility = "72";
    }
    static{
        this.type_builderAction = "73";
    }
    static{
        this.type_requestWorldMap = "74";
    }
    static{
        this.type_sendWorldMap = "75";
    }
    static{
        this.type_requestDropActiveItem = "76";
    }
    static{
        this.type_worldMapClicked = "77";
    }
    static{
        this.type_removeLocationIcon = "78";
    }
    static{
        this.type_addLocationIcon = "79";
    }
    static{
        this.type_startAttack = "80";
    }
    static{
        this.type_entityTileStrikeAt = "81";
    }
    static{
        this.type_attackComplete = "82";
    }
    static{
        this.type_updateActivation = "83";
    }
    static{
        // Cosmetic: make an entity play its attack (swing) animation with no damage/gameplay effect
        // (e.g. a player swinging while placing a building tile).
        this.type_playAttackAnimation = "84";
    }
    static{
        // Configure client-side faction tracking (offscreen edge arrows toward faction members).
        this.type_factionTracking = "85";
    }
    static{
        // Server-initiated: open the command wheel bound to a specific NPC, locked to its role
        // (forager/defender). Payload: { entityId, role }.
        this.type_openCommandWheel = "86";
    }
    static{
        // Per-room roster of notable NPCs (ember defenders/foragers/lord) for a clickable HUD
        // strip. Only emitted for rooms that opt in (room.emberRosterEnabled). Payload: { roster }.
        this.type_updateEmberRoster = "87";
    }
    static{
        // Client-initiated: follow-cam focus. Promotes the given entity + its neighbors to the
        // detailed, every-tick sync tier so a picture-in-picture view can watch it in real time.
        // Payload: { entityId } to focus, or { entityId: null } to clear.
        this.type_setFocusEntity = "88";
    }
    static{
        // Server-initiated one-shot cosmetic: play a green "sparkle halo" over an entity (e.g.
        // when a campfire is refreshed with wood). Payload: { entityId }.
        this.type_entitySparkle = "89";
    }
    static{
        // Server-initiated: open the recruit ROLE PICKER over a specific recruit NPC, so the player can
        // assign it a role (forager/defender). Payload: { entityId }.
        this.type_openRolePicker = "90";
    }
    static{
        // Server-initiated: the player's ember run is over -- show the centered end-of-run summary
        // panel (time survived, waves, kills, camp work) with its "Try again" button.
        // Payload: { summary: EmberRunSummary }.
        this.type_showRunSummary = "91";
    }
    static{
        // Server-initiated: put up (or take down) the first-run ember tutorial invitation -- a small
        // stage-anchored bar with "show me"/"skip" and a visible countdown that resolves to "show me".
        // Payload: { prompt: EmberTutorialPrompt } to show, { prompt: null } to dismiss.
        this.type_showTutorialPrompt = "92";
    }
    static{
        // Per-room positions for the ember minimap: every camp member and every wave attacker in the
        // room, plus the room's extent. Only emitted for rooms that opt in (room.emberRosterEnabled).
        // Payload: { minimap: EmberMinimapState }.
        this.type_updateEmberMinimap = "93";
    }
    static{
        // Who ELSE is logged into the server right now, and which wave their camp is on. Sent to each
        // player in an ember room by the EMBER_PLAYERS campaign; the list a player receives never
        // contains themselves. Payload: { players: EmberPlayerEntry[] }.
        this.type_updateEmberPlayers = "94";
    }
    static{
        // Client-initiated: invite another online player into this player's ember camp. The server
        // (EMBER_PLAYERS) decides whether the invite is allowed and where the guest lands.
        // Payload: { entityId }.
        this.type_inviteEmberPlayer = "95";
    }
    static{
        // Server-initiated: put up (or take down) the invitation prompt on the INVITED player -- who is
        // asking, and how long they have to answer. Reaches that player wherever they are, camp or not.
        // Payload: { invite: EmberInvite } to show, { invite: null } to dismiss.
        this.type_updateEmberInvite = "96";
    }
    static{
        // Client-initiated: the invited player's answer. Only an accepted one moves anybody.
        // Payload: { entityId (who invited them), accepted }.
        this.type_answerEmberInvite = "97";
    }
    static{
        // Everything a room says about its own atmosphere, in one payload (RoomAmbience): the windblown
        // leaves, the night fog, the butterflies. Sent on EVERY room entry, including an empty one, so a
        // camp's weather cannot follow the player out into a room that has none of it. Payload:
        // { ambience }.
        //
        // 98, 99 and 100 were one of these each before they were collapsed into this.
        this.type_roomAmbience = "101";
    }
    static{
        // Server-initiated: open the NAME PROMPT over a specific entity so the player can name it --
        // a small field floating over the NPC, pre-filled with the name it already has. Sent when a
        // recruit is hired (the last beat of the role picker) and on the "Rename" order.
        // Payload: { entityId, name } -- `name` is what the field starts with.
        this.type_openNamePrompt = "102";
    }
    static{
        // Server-initiated: open (or dismiss) the INVASION PICKER on a player whose ember run is over --
        // the camps they could rise in as one of the wave's attackers. Up to three, each a defending
        // player's name plus where their run is up to. Payload: { candidates: EmberInvasionCandidate[] };
        // an EMPTY list is a real answer ("no camp is open to the dead"), and null dismisses the picker.
        this.type_updateInvasionOffer = "105";
    }
    static{
        // Client-initiated: stop sending me world state, nobody is drawing it. Sent once the page has
        // been in the BACKGROUND for a couple of seconds. The client's frame loop is
        // requestAnimationFrame, which a hidden tab does not get, so an unsuspended stream piles up in
        // a queue nothing drains until the tab is killed for its memory -- taking the socket with it.
        // The socket itself stays open and keeps answering pings throughout. No payload.
        this.type_suspendUpdates = "103";
    }
    static{
        // Client-initiated: start sending again, and RESEND EVERYTHING. World state is a delta stream,
        // so a client that stopped listening cannot simply pick it back up -- every change it missed is
        // one the server already considers delivered (see Server.resyncClient). No payload.
        this.type_resumeUpdates = "104";
    }
    static{
        // Server-initiated, last thing before the socket is closed: this session is OVER, and here is
        // why. Sent when the same account logs in again somewhere else ("signedInElsewhere"), which
        // takes the account off this socket. It matters that the client is TOLD: a close on its own is
        // indistinguishable from the wifi blinking, and the client now redials one of those by itself
        // (connection_lifecycle.ts) -- which would take the account straight back off the tab that just
        // claimed it, with both sockets live and both driving the same avatar.
        // Payload: { reason }.
        this.type_sessionEnded = "106";
    }
}





var $5UG8I = parcelRequire("5UG8I");
/**
 * Where this build talks to, and what it is running inside.
 *
 * The client has always derived both from `document.location.hostname`, which works fine for the
 * only two things that existed: a browser tab on projectsamsara.com, and a dev tab on localhost.
 * The native shell breaks that assumption. Capacitor serves the bundled page from
 * `capacitor://localhost` on iOS and `https://localhost` on Android, so a hostname check reads the
 * shipped app as a developer's laptop -- it would dial `ws://localhost:8080` at the phone itself
 * and show the dev name gate to every player. Hence the native check comes FIRST below and the
 * local-dev branch is explicitly gated on it.
 *
 * Everything is overridable through `window.__SAMSARA_CONFIG__`, which the mobile build writes
 * into the bundle. That is how a device build is pointed at a laptop on the LAN for profiling --
 * the thing `API_HOST` was supposed to do and never did, because `process?.env?.API_HOST` is
 * optional-chained and Parcel only substitutes the bare `process.env.X` form. The old expression
 * therefore always fell through to the production default, and a build made with API_HOST set
 * silently talked to production anyway.
 *
 * Reading the environment and deciding from it are kept apart: `resolveConfig` is pure, so the
 * decisions can be tested directly. jsdom will not let a test change `location.hostname` -- it is
 * an unforgeable property -- so a seam is the only way to cover the case this module exists for.
 */ /** Production endpoints, used by the web build and by a release shell alike. */ const $a8f3c0c196817c22$var$PRODUCTION_API_HOST = "wss://api.projectsamsara.com";
const $a8f3c0c196817c22$var$PRODUCTION_ORIGIN = "https://projectsamsara.com";
/** The port `yarn workspace server start` listens on. */ const $a8f3c0c196817c22$var$LOCAL_SERVER_PORT = 8080;
const $a8f3c0c196817c22$export$23531c8df2a01f5e = ()=>({
        hostname: typeof document !== "undefined" ? document.location.hostname : "",
        // The bridge is injected at document start, before any page script runs, so this is reliable
        // from the very first line -- including the inline bootstrap in index.html, which asks the
        // same question before the bundle has loaded.
        hasNativeBridge: typeof window !== "undefined" && !!window.Capacitor,
        injected: typeof window !== "undefined" && window.__SAMSARA_CONFIG__ || {}
    });
const $a8f3c0c196817c22$export$7eca4ea16d4c8343 = (env = $a8f3c0c196817c22$export$23531c8df2a01f5e())=>{
    const { hostname: hostname, hasNativeBridge: hasNativeBridge, injected: injected } = env;
    const native = injected.isNative ?? hasNativeBridge;
    // A dev build in a browser tab: Parcel on localhost, or the LAN address a phone on the same
    // wifi uses to reach it. Deliberately false in the shell, whose origin is also "localhost".
    const localDev = !native && (hostname === "localhost" || hostname.startsWith("10.0"));
    return {
        apiHost: injected.apiHost ?? (localDev ? `ws://${hostname}:${$a8f3c0c196817c22$var$LOCAL_SERVER_PORT}/` : $a8f3c0c196817c22$var$PRODUCTION_API_HOST),
        // A browser build is served beside its own assets; only the shell has to reach out.
        assetBase: injected.assetBase ?? (native ? $a8f3c0c196817c22$var$PRODUCTION_ORIGIN : ""),
        isNative: native,
        // There is no name gate in the shell -- nobody ships a dev prompt -- and no url to put
        // `?guest=true` in either, so the shell always enters as a guest.
        autoGuest: injected.autoGuest ?? native
    };
};
const $a8f3c0c196817c22$export$43ab85c863381e0 = ()=>$a8f3c0c196817c22$export$7eca4ea16d4c8343().isNative;


const $10da07838e6d507c$export$7d15b64cf5a3a4c4 = (num, min, max)=>Math.min(Math.max(num, min), max);
const $10da07838e6d507c$export$d0a8044dce8ff2fc = ()=>/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const $10da07838e6d507c$export$6786c0480bb11ee9 = 0.9;
const $10da07838e6d507c$export$84bfe54394ef8e9d = 1.6;
const $10da07838e6d507c$export$37f678e26ae1e8b8 = (vector, power)=>power >= $10da07838e6d507c$export$6786c0480bb11ee9 ? {
        x: vector.x * $10da07838e6d507c$export$84bfe54394ef8e9d,
        y: vector.y * $10da07838e6d507c$export$84bfe54394ef8e9d
    } : vector;
const $10da07838e6d507c$export$c6ec669adaa5980d = 1.3;
const $10da07838e6d507c$export$e4369cabd7e84cd9 = ()=>{
    const letters = "0123456789ABCDEF".split("");
    let color = "0x";
    for(var i = 0; i < 6; i++)color += letters[Math.round(Math.random() * 15)];
    return color;
};
const $10da07838e6d507c$export$aa707847c2571374 = {
    scale: $10da07838e6d507c$export$c6ec669adaa5980d,
    surfaceZoom: 2.0,
    viewportX: 7,
    viewportY: 5
};



var $5UG8I = parcelRequire("5UG8I");
/**
 * "You are not connected", with a way back.
 *
 * Deliberately DOM rather than pixi. This is the screen for when things are already broken -- the
 * server is down, the wifi dropped, the app was asleep for an hour -- and the renderer is exactly
 * the thing that may be mid-collapse or never started. A div needs nothing but a document.
 *
 * It exists because the native shell has nowhere to go. In a browser a lost socket redirects to the
 * portal, but the shell's origin IS the app bundle: "/" would reload the app, and an alert() would
 * freeze the WebView behind a modal the player cannot dismiss into anything useful. So the shell
 * sat there silently on a dead socket, which looks exactly like the game having hung.
 */ const $69f7ea6451029ed5$var$OVERLAY_ID = "samsara-disconnected";
const $69f7ea6451029ed5$var$style = (el, css)=>{
    Object.entries(css).forEach(([key, value])=>el.style.setProperty(key, value));
};
const $69f7ea6451029ed5$export$1609d5d6ccae23cd = ()=>typeof document !== "undefined" && !!document.getElementById($69f7ea6451029ed5$var$OVERLAY_ID);
const $69f7ea6451029ed5$export$b6aef85896caf7b2 = ()=>{
    if (typeof document === "undefined") return;
    document.getElementById($69f7ea6451029ed5$var$OVERLAY_ID)?.remove();
};
const $69f7ea6451029ed5$export$4237b8ea75e6554 = (reason)=>{
    if (typeof document === "undefined") return;
    // Takes over from the generic panel if a close got here first: this is the more specific story,
    // and the one with no retry.
    $69f7ea6451029ed5$export$b6aef85896caf7b2();
    const signedInElsewhere = reason === "signedInElsewhere";
    $69f7ea6451029ed5$var$renderOverlay({
        heading: signedInElsewhere ? "Signed in somewhere else" : "Session ended",
        body: signedInElsewhere ? "This account was signed in from another window or device, so this one has been signed out." : "The server ended this session.",
        buttonLabel: "Log in again",
        onPress: ()=>window.location.reload(),
        // A reload leaves, so there is nothing to re-arm.
        rearm: false
    });
};
const $69f7ea6451029ed5$export$5f7f27f369ebe35d = ({ everConnected: everConnected, onRetry: onRetry })=>{
    if (typeof document === "undefined" || $69f7ea6451029ed5$export$1609d5d6ccae23cd()) // Already up: a dead socket can report itself more than once (an error, then a close), and
    // the player should not watch the panel flicker or lose a retry they are mid-press on.
    return;
    $69f7ea6451029ed5$var$renderOverlay({
        heading: everConnected ? "Connection lost" : "Can't reach the server",
        body: everConnected ? "You have been disconnected from the world." : "The server may be down, or this device may be offline.",
        buttonLabel: "Try again",
        onPress: onRetry,
        rearm: true
    });
};
const $69f7ea6451029ed5$var$renderOverlay = ({ heading: headingText, body: bodyText, buttonLabel: buttonLabel, onPress: onPress, rearm: rearm })=>{
    if ($69f7ea6451029ed5$export$1609d5d6ccae23cd()) return;
    const overlay = document.createElement("div");
    overlay.id = $69f7ea6451029ed5$var$OVERLAY_ID;
    $69f7ea6451029ed5$var$style(overlay, {
        position: "fixed",
        inset: "0",
        // Not fully opaque: the world behind stays faintly visible, so this reads as something
        // laid over the game rather than as the app having quit.
        background: "rgba(7, 9, 13, 0.92)",
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        "font-family": "'Jost', Verdana, Geneva, sans-serif",
        "z-index": "20",
        padding: "16px",
        "box-sizing": "border-box"
    });
    const card = document.createElement("div");
    $69f7ea6451029ed5$var$style(card, {
        width: "min(380px, 100%)",
        "box-sizing": "border-box",
        padding: "26px",
        background: "rgba(17, 21, 27, 0.95)",
        border: "1px solid rgba(122, 136, 158, 0.45)",
        "border-radius": "10px",
        "text-align": "center"
    });
    const heading = document.createElement("div");
    heading.textContent = headingText;
    $69f7ea6451029ed5$var$style(heading, {
        "font-weight": "300",
        "font-size": "22px",
        "letter-spacing": "0.12em",
        color: "#f2f4ef"
    });
    const body = document.createElement("div");
    body.textContent = bodyText;
    $69f7ea6451029ed5$var$style(body, {
        "margin-top": "10px",
        "font-size": "14px",
        "line-height": "1.45",
        color: "#a9b2bf"
    });
    const button = document.createElement("button");
    button.textContent = buttonLabel;
    $69f7ea6451029ed5$var$style(button, {
        "margin-top": "22px",
        width: "100%",
        // Tall enough to be a real touch target. It is the only control on the screen, and the
        // player is already unhappy by the time they are looking at it.
        height: "48px",
        background: "#8fd66b",
        border: "0",
        "border-radius": "8px",
        "font-family": "inherit",
        "font-size": "16px",
        "font-weight": "600",
        color: "#12210a",
        cursor: "pointer"
    });
    let pressed = false;
    const press = ()=>{
        if (pressed) return;
        pressed = true;
        button.textContent = rearm ? "Reconnecting..." : "One moment...";
        button.disabled = true;
        $69f7ea6451029ed5$var$style(button, {
            background: "#5c7a49",
            color: "#0d1607",
            cursor: "default"
        });
        try {
            onPress();
        } catch (e) {
            (0, $5UG8I.logger).error({
                tags: [
                    "websocket",
                    "connection"
                ]
            }, "Retry threw", String(e));
        }
        if (!rearm) return;
        // A refused connection can fail faster than the player lets go of the button, so re-arming
        // from the close handler would race this. Re-arm on a timer instead: the control always
        // comes back, and a second press is always possible.
        setTimeout(()=>{
            if (!$69f7ea6451029ed5$export$1609d5d6ccae23cd()) return;
            pressed = false;
            button.textContent = buttonLabel;
            button.disabled = false;
            $69f7ea6451029ed5$var$style(button, {
                background: "#8fd66b",
                color: "#12210a",
                cursor: "pointer"
            });
        }, 3000);
    };
    button.addEventListener("click", press);
    card.append(heading, body, button);
    overlay.append(card);
    document.body.append(overlay);
};


// Browser-side agent that remote-controls the logged-in player. A `/agent <goal>` chat
// command starts it; `/agent stop` returns control to the human. While active it:
//   1. fully takes over input (disables the human keyboard/mouse handlers),
//   2. every ~DECISION_INTERVAL_MS: builds an observation from the client's own view,
//      POSTs it to the server's /agent/decide proxy (which calls Claude), and applies the
//      returned action via the existing Client input methods,
//   3. re-applies its held movement intent every frame (onFrame), because reconciliation
//      overwrites the local player's speed2 each frame.
// The human watches everything in their own browser — the agent's inputs produce the same
// server updates and rendering a human's would.
// Maps a semantic AgentAction to the existing Client input methods. The agent never issues
// raw keyboard/mouse — every action here is something a human player could also do.
//
// Movement actions set a *held intent* (a unit velocity vector) on the controller; the
// controller re-applies it each frame (see agent_controller.onFrame), because client-side
// reconciliation overwrites the local player's speed2 every frame. One-shot actions (attack,
// ability, pickup, etc.) call the corresponding Client sender immediately.

// Item types that restore hunger when "use"d (mirrors packages/server/.../atoms/hunger.ts).
const $6b64ef7e2f784083$var$FOOD_ITEMS = new Set([
    "drumstick",
    "mushroom-purple",
    "mushroom-yellow",
    "mushroom-red"
]);
/** Unit vectors for the compass directions the LLM may use. +y is south. */ const $6b64ef7e2f784083$var$DIR_VECTORS = {
    N: {
        x: 0,
        y: -1
    },
    S: {
        x: 0,
        y: 1
    },
    E: {
        x: 1,
        y: 0
    },
    W: {
        x: -1,
        y: 0
    },
    NE: {
        x: 0.7071,
        y: -0.7071
    },
    NW: {
        x: -0.7071,
        y: -0.7071
    },
    SE: {
        x: 0.7071,
        y: 0.7071
    },
    SW: {
        x: -0.7071,
        y: 0.7071
    }
};
function $6b64ef7e2f784083$export$79fc7e923089e4c6(client, sink, action) {
    const player = client.clientGameLogic.playerEntity;
    switch(action.type){
        case "move_toward":
            {
                if (!player?.location) return "move_toward: no player";
                const dx = action.x - player.location.x;
                const dy = action.y - player.location.y;
                const mag = Math.sqrt(dx * dx + dy * dy);
                if (mag < 1) {
                    sink.setHeldMovement(null);
                    return "move_toward: already there";
                }
                sink.setHeldMovement({
                    x: dx / mag,
                    y: dy / mag
                });
                return `move_toward (${Math.round(action.x)}, ${Math.round(action.y)})`;
            }
        case "move":
            {
                const v = $6b64ef7e2f784083$var$DIR_VECTORS[action.dir?.toUpperCase?.() || ""];
                if (!v) return `move: unknown dir ${action.dir}`;
                sink.setHeldMovement(v);
                return `move ${action.dir}`;
            }
        case "stop":
            sink.setHeldMovement(null);
            return "stop";
        case "attack":
            if (!action.entityId) return "attack: no target";
            client.startAttack(action.entityId);
            return `attack ${action.entityId}`;
        case "chop":
            // Strike a harvestable map tile (e.g. a tree) at the given world point. The server
            // only lands the strike if the player is adjacent, so aim at a nearby feature.
            client.entityTileStrike({
                x: action.x,
                y: action.y
            });
            return `chop (${Math.round(action.x)}, ${Math.round(action.y)})`;
        case "eat":
            {
                // Find a food item in the live inventory and "use" it (restores hunger server-side).
                const food = (player?.inventory?.items || []).find((i)=>i.itemType && $6b64ef7e2f784083$var$FOOD_ITEMS.has(i.itemType));
                if (!player || !food) return "eat: no food";
                client.inventoryAction(player.entityId, food.id, "use");
                return `eat ${food.itemType}`;
            }
        case "use_ability":
            client.activateAbility(action.key);
            return `use_ability ${action.key}`;
        case "pickup":
            client.itemPickupAction();
            return "pickup";
        case "drop":
            client.dropAction();
            return "drop";
        case "command_squad":
            client.sendCommandWheelSelection(action.command, action.npcType, action.targetEntityId);
            return `command_squad ${action.command} (${action.npcType})`;
        case "say":
            if (!player) return "say: no player";
            client.send({
                entityId: player.entityId,
                message: action.message
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_chatMessage);
            return `say "${action.message}"`;
        case "wait":
            return "wait";
        default:
            return `unknown action ${action.type}`;
    }
}


// Builds an AgentObservation from the client's own view of the world. This is deliberately
// sourced from ClientGameLogic (the client's partial replica) rather than server truth, so
// the agent perceives exactly what the human player's client knows — natural fog-of-war.


const $836ee63355e500c0$var$NEARBY_RADIUS_TILES = 16 // matches the server's detail range (15 tiles)
;
const $836ee63355e500c0$var$MAX_NEARBY = 20;
const $836ee63355e500c0$var$FEATURE_RADIUS_TILES = 5;
// Compass directions as (dx, dy) tile steps. +y is south (screen down).
const $836ee63355e500c0$var$DIRS = {
    N: [
        0,
        -1
    ],
    S: [
        0,
        1
    ],
    E: [
        1,
        0
    ],
    W: [
        -1,
        0
    ],
    NE: [
        1,
        -1
    ],
    NW: [
        -1,
        -1
    ],
    SE: [
        1,
        1
    ],
    SW: [
        -1,
        1
    ]
};
// Entity-tile ids the agent should be told about (harvestable trees etc.). Mirrors the
// forager's tree list; unknown entity-tiles are still reported generically by their id.
const $836ee63355e500c0$var$NOTABLE_TILE_KINDS = new Set([
    "tree1",
    "tree2",
    "tree3",
    "tree4",
    "tree5",
    "tree6",
    "smallTree1",
    "palmTree1",
    "palmTree2",
    "palmTree3",
    "palmTree4",
    "palmTree5",
    "palmTree6"
]);
const $836ee63355e500c0$var$round = (n, dp = 1)=>{
    const f = Math.pow(10, dp);
    return Math.round(n * f) / f;
};
function $836ee63355e500c0$var$buildTerrain(logic, playerTileX, playerTileY) {
    const tmp = logic.tilemapMetaProvider;
    // Sparse: list only the BLOCKED directions (open ground is the common case, so emitting
    // all-false entries every tick is pure token waste). Empty array = fully open.
    const blocked1 = [];
    const blocked2 = [];
    const isBlocked = (tx, ty)=>{
        if (!tmp) return false;
        // No approach coords => "blocked no matter what" (pure wall/water test).
        return tmp.isCollisionAt(tx, ty) || (tmp.isDeepAt ? tmp.isDeepAt(tx, ty) : false);
    };
    for (const [dir, [dx, dy]] of Object.entries($836ee63355e500c0$var$DIRS)){
        if (isBlocked(playerTileX + dx, playerTileY + dy)) blocked1.push(dir);
        if (isBlocked(playerTileX + dx * 2, playerTileY + dy * 2)) blocked2.push(dir);
    }
    const features = [];
    if (tmp?.getEntityTileAt) {
        for(let dx = -$836ee63355e500c0$var$FEATURE_RADIUS_TILES; dx <= $836ee63355e500c0$var$FEATURE_RADIUS_TILES && features.length < 12; dx++)for(let dy = -$836ee63355e500c0$var$FEATURE_RADIUS_TILES; dy <= $836ee63355e500c0$var$FEATURE_RADIUS_TILES && features.length < 12; dy++){
            if (dx === 0 && dy === 0) continue;
            let hit;
            try {
                hit = tmp.getEntityTileAt(playerTileX + dx, playerTileY + dy);
            } catch  {
                hit = undefined;
            }
            const id = hit?.tileId;
            if (id && $836ee63355e500c0$var$NOTABLE_TILE_KINDS.has(id)) features.push({
                kind: id,
                dxTiles: dx,
                dyTiles: dy
            });
        }
    }
    return {
        blocked1: blocked1,
        blocked2: blocked2,
        features: features
    };
}
function $836ee63355e500c0$export$4f720bc779752b6f(logic, goal, tick, recentChat = []) {
    const player = logic.playerEntity;
    if (!player || !player.location) return null;
    const px = player.location.x;
    const py = player.location.y;
    const playerTileX = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const playerTileY = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const nearby = [];
    logic.entityManager.iterate([
        "npc",
        "player"
    ], (e)=>{
        if (!e || e.entityId === player.entityId || !e.location) return;
        if (e.entityState === "dead") return;
        const dxPx = e.location.x - px;
        const dyPx = e.location.y - py;
        const distTiles = Math.sqrt(dxPx * dxPx + dyPx * dyPx) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        if (distTiles > $836ee63355e500c0$var$NEARBY_RADIUS_TILES) return;
        let disposition = "neutral";
        try {
            disposition = (0, $d3527b517d667178$export$4cfe0674a42ef84e).social.computeDisposition(e, player);
        } catch  {
            disposition = "neutral";
        }
        nearby.push({
            entityId: e.entityId,
            name: e.safeName ? e.safeName() : e.name || e.npcType || e.entityType,
            npcType: e.npcType,
            x: $836ee63355e500c0$var$round(e.location.x, 0),
            y: $836ee63355e500c0$var$round(e.location.y, 0),
            dxTiles: $836ee63355e500c0$var$round(dxPx / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
            dyTiles: $836ee63355e500c0$var$round(dyPx / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
            distanceTiles: $836ee63355e500c0$var$round(distTiles),
            hp: e.hp,
            maxHp: e.maxHp,
            faction: e.faction || undefined,
            disposition: disposition
        });
    });
    nearby.sort((a, b)=>a.distanceTiles - b.distanceTiles);
    if (nearby.length > $836ee63355e500c0$var$MAX_NEARBY) nearby.length = $836ee63355e500c0$var$MAX_NEARBY;
    const inventory = (player.inventory?.items || []).filter((i)=>!!i.itemType).map((i)=>({
            itemType: i.itemType,
            quantity: i.quantity,
            readied: i.readied
        }));
    return {
        goal: goal,
        tick: tick,
        roomName: logic.roomName,
        dayPhase: logic.dayPhase ? logic.dayPhase.phase || undefined : undefined,
        self: {
            entityId: player.entityId,
            x: $836ee63355e500c0$var$round(px, 0),
            y: $836ee63355e500c0$var$round(py, 0),
            hp: player.hp,
            maxHp: player.maxHp,
            mana: player.mana,
            hunger: player.hunger,
            roomId: player.roomId,
            faction: player.faction || undefined,
            moving: !!player.movement?.moving,
            inventory: inventory
        },
        nearby: nearby,
        terrain: $836ee63355e500c0$var$buildTerrain(logic, playerTileX, playerTileY),
        recentChat: recentChat.slice(-8)
    };
}


// Tick cadence floor (ms). Overridable via AGENT_INTERVAL_MS to trade cost vs. responsiveness.
const $b9d4ad6eac1471db$var$DECISION_INTERVAL_MS = Number("") || 800;
const $b9d4ad6eac1471db$var$HISTORY_LIMIT = 8;
const $b9d4ad6eac1471db$var$CHAT_LIMIT = 16;
// Named goal presets so common objectives don't have to be typed out in full.
// `/agent <preset>` (e.g. `/agent survive`) expands to the mapped goal; any other text is
// used verbatim as a free-form goal.
const $b9d4ad6eac1471db$var$PRESETS = {
    survive: "Survive and sustain the camp indefinitely: keep the campfire fed with wood (chop nearby trees yourself and/or send foragers to forage and feed the fire), defend the camp and yourself from hostiles (attack them, or command defenders to engage), eat food when your hunger gets low, pick up any wood or food nearby, and retreat if your hp gets low.",
    defend: "Protect the camp: watch for hostiles and deal with them fast \u2014 attack the nearest threat yourself and command the defenders to engage, hold the line near the Lord and campfire, and retreat to heal only if your hp gets critically low.",
    gather: "Keep the camp supplied: chop nearby trees for wood and/or command foragers to forage wood and feed the campfire so it never dies down, and pick up any wood or food lying around."
};
function $b9d4ad6eac1471db$var$decideEndpoint() {
    // Prod: derive from the WS API host (wss://host -> https://host). Local dev (Parcel on
    // :1234, server on :8080): talk to the server's HTTP port on the same hostname.
    const apiHost = "";
    if (apiHost) return apiHost.replace(/^ws/, "http").replace(/\/?$/, "") + "/agent/decide";
    const loc = typeof location !== "undefined" ? location : {
        protocol: "http:",
        hostname: "localhost"
    };
    return `${loc.protocol}//${loc.hostname}:8080/agent/decide`;
}
class $b9d4ad6eac1471db$export$433d8951d222f317 {
    constructor(client){
        this.client = client;
        this.active = false;
        this.goal = "";
        this.tick = 0;
        this.heldSpeed2 = null;
        this.history = [];
        this.recentChat = [];
        this.loopTimer = null;
        this.inFlight = false;
    }
    isActive() {
        return this.active;
    }
    /** Handle a `/agent ...` chat command. Returns true if it was consumed. */ handleCommand(raw) {
        const rest = raw.replace(/^\/agent\b/, "").trim();
        if (rest === "" || rest === "help") {
            const presets = Object.keys($b9d4ad6eac1471db$var$PRESETS).join(", ");
            this.say(`Agent: \`/agent <goal>\` to play a free-form goal, \`/agent stop\` to take back over. ` + `Presets: ${presets} (e.g. \`/agent survive\`).`);
            return true;
        }
        if (rest === "stop" || rest === "off") {
            this.stop("You have control again.");
            return true;
        }
        // Expand a known preset keyword; otherwise use the text as a free-form goal.
        const preset = $b9d4ad6eac1471db$var$PRESETS[rest.toLowerCase()];
        this.start(preset || rest);
        return true;
    }
    start(goal) {
        this.goal = goal;
        this.tick = 0;
        this.history = [];
        this.heldSpeed2 = null;
        this.active = true;
        this.setTakeover(true);
        this.say(`Agent taking over: "${goal}". Say \`/agent stop\` to reclaim control.`);
        this.scheduleNext(0);
    }
    stop(message = "Agent stopped.") {
        this.active = false;
        if (this.loopTimer) {
            clearTimeout(this.loopTimer);
            this.loopTimer = null;
        }
        this.heldSpeed2 = null;
        const p = this.client.clientGameLogic.playerEntity;
        if (p) {
            p.speed2 = {
                x: 0,
                y: 0
            };
            if (p.movement) p.movement.moving = false;
        }
        this.setTakeover(false);
        this.say(message);
    }
    /** Record chat the player heard, so the agent has recent context. */ noteChat(from, message) {
        if (!message) return;
        this.recentChat.push({
            from: from,
            message: message
        });
        if (this.recentChat.length > $b9d4ad6eac1471db$var$CHAT_LIMIT) this.recentChat.shift();
    }
    /** Called every frame from Client.update(), between reconciliation and processInputs. */ onFrame() {
        if (!this.active || !this.heldSpeed2) return;
        const p = this.client.clientGameLogic.playerEntity;
        if (!p) return;
        p.speed2 = {
            x: this.heldSpeed2.x,
            y: this.heldSpeed2.y
        };
        p.speed = p.maxSpeed;
        p.movement = {
            direction: p.movement?.direction,
            ...p.movement || {},
            moving: true,
            angle: Math.atan2(this.heldSpeed2.y, this.heldSpeed2.x)
        };
    }
    // --- MovementSink for the action dispatcher ---
    setHeldMovement(v) {
        this.heldSpeed2 = v;
        if (!v) {
            const p = this.client.clientGameLogic.playerEntity;
            if (p) {
                p.speed2 = {
                    x: 0,
                    y: 0
                };
                if (p.movement) p.movement.moving = false;
            }
        }
    }
    setTakeover(on) {
        const pc = this.client.clientGameLogic.playerController;
        if (!pc) return;
        pc.enabledKeyboardAction(!on);
        pc.enabledMouseAction(!on);
    }
    scheduleNext(delayMs) {
        if (!this.active) return;
        this.loopTimer = setTimeout(()=>this.runTick(), delayMs);
    }
    async runTick() {
        if (!this.active) return;
        const started = Date.now();
        try {
            const obs = (0, $836ee63355e500c0$export$4f720bc779752b6f)(this.client.clientGameLogic, this.goal, this.tick, this.recentChat);
            if (obs && !this.inFlight) {
                this.inFlight = true;
                const action = await this.decide(obs);
                this.inFlight = false;
                if (this.active && action) {
                    const desc = (0, $6b64ef7e2f784083$export$79fc7e923089e4c6)(this.client, this, action);
                    // eslint-disable-next-line no-console
                    console.log(`[agent tick ${this.tick}] ${desc}${action.reasoning ? " \u2014 " + action.reasoning : ""}`);
                    this.history.push({
                        tick: this.tick,
                        action: action
                    });
                    if (this.history.length > $b9d4ad6eac1471db$var$HISTORY_LIMIT) this.history.shift();
                }
            }
        } catch (e) {
            this.inFlight = false;
            // eslint-disable-next-line no-console
            console.warn("[agent] decide failed:", e?.message || e);
        }
        this.tick++;
        const elapsed = Date.now() - started;
        this.scheduleNext(Math.max(0, $b9d4ad6eac1471db$var$DECISION_INTERVAL_MS - elapsed));
    }
    async decide(observation) {
        // Strip `reasoning` from history before sending — the model doesn't need its own past
        // rationales replayed each tick, and they add up over the rolling window.
        const history = this.history.map((h)=>{
            const { reasoning: reasoning, ...action } = h.action;
            return {
                tick: h.tick,
                action: action
            };
        });
        const body = {
            observation: observation,
            history: history
        };
        const resp = await fetch($b9d4ad6eac1471db$var$decideEndpoint(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        if (!resp.ok) throw new Error(`decide HTTP ${resp.status}`);
        const data = await resp.json();
        return data?.action ?? null;
    }
    say(message) {
        // eslint-disable-next-line no-console
        console.log(`[agent] ${message}`);
        const gui = this.client.clientGameLogic.clientRenderer?.gui?.();
        if (gui?.showScreenMessage) try {
            gui.showScreenMessage(message);
        } catch  {
        /* best-effort UI feedback */ }
    }
}




/**
 * Fullscreen, and the little of it the browsers actually hand us.
 *
 * Two constraints shape everything here:
 *
 *  - It does not exist on iPhone. Every iOS browser is WebKit underneath, and WebKit only lets a
 *    <video> element go fullscreen there. It is also switched off when we are framed without
 *    allowfullscreen (the itch.io embed). `fullscreenSupported` is the check for both.
 *  - It cannot be entered on load. Every browser that supports it demands a transient user
 *    activation, so the earliest a phone can expand is the player's first tap -- which is what
 *    `enterFullscreenIfMobile` and `enterFullscreenOnFirstGesture` are for. Call them from
 *    inside a tap/click/key handler; outside one the request is refused and the activation is
 *    spent for nothing.
 */ const $0f29b5a53cc88186$var$el = ()=>document.documentElement;
const $0f29b5a53cc88186$var$dom = ()=>document;
const $0f29b5a53cc88186$var$request = ()=>{
    const e = $0f29b5a53cc88186$var$el();
    return e.requestFullscreen?.bind(e) || e.webkitRequestFullscreen?.bind(e) || e.msRequestFullscreen?.bind(e);
};
const $0f29b5a53cc88186$var$release = ()=>{
    const d = $0f29b5a53cc88186$var$dom();
    return d.exitFullscreen?.bind(d) || d.webkitExitFullscreen?.bind(d) || d.msExitFullscreen?.bind(d);
};
/** A refused request rejects rather than throws; none of this is worth an unhandled rejection. */ const $0f29b5a53cc88186$var$swallow = (result)=>{
    if (result && typeof result.catch === "function") result.catch(()=>undefined);
};
const $0f29b5a53cc88186$export$efad50a2596de3ba = ()=>{
    // The native shell has no browser chrome to escape -- it launches fullscreen, with the status
    // bar hidden by Info.plist and the Android system bars by MainActivity. WebKit still exposes
    // requestFullscreen inside the WebView, so without this the login screen would draw an expand
    // chip that can only ever be a no-op. Same principle as the iPhone case below: better an
    // absent control than one that visibly lies.
    if ((0, $a8f3c0c196817c22$export$43ab85c863381e0)()) return false;
    if (typeof document === "undefined" || !$0f29b5a53cc88186$var$request()) return false;
    // false inside an iframe embedded without allowfullscreen.
    return $0f29b5a53cc88186$var$dom().fullscreenEnabled ?? $0f29b5a53cc88186$var$dom().webkitFullscreenEnabled ?? true;
};
const $0f29b5a53cc88186$export$d7e5f5607a21fc72 = ()=>typeof document !== "undefined" && !!($0f29b5a53cc88186$var$dom().fullscreenElement || $0f29b5a53cc88186$var$dom().webkitFullscreenElement || $0f29b5a53cc88186$var$dom().msFullscreenElement);
const $0f29b5a53cc88186$export$859c5997fce6d45 = ()=>{
    if (!$0f29b5a53cc88186$export$efad50a2596de3ba() || $0f29b5a53cc88186$export$d7e5f5607a21fc72()) return;
    $0f29b5a53cc88186$var$swallow($0f29b5a53cc88186$var$request()());
};
const $0f29b5a53cc88186$export$1aba1ee5e6dc1474 = ()=>{
    if (!$0f29b5a53cc88186$export$efad50a2596de3ba()) return;
    // Ask the document which way it is rather than keeping our own flag: Esc, the system back
    // gesture and the browser's own control all leave fullscreen without telling us, and a stale
    // flag turns the next tap into an exit that does nothing -- a button that looks dead.
    $0f29b5a53cc88186$var$swallow($0f29b5a53cc88186$export$d7e5f5607a21fc72() ? $0f29b5a53cc88186$var$release()?.() : $0f29b5a53cc88186$var$request()());
};
/**
 * How many gestures the arming below is allowed to spend. More than one because a request can be
 * refused for want of a user activation and says nothing when it is -- measured in Chrome, a
 * handler on `pointerup` can run a beat before the browser marks the activation, and the request
 * rejects with a bare "Permissions check failed". Few, because past the opening taps the player
 * is likelier to have left fullscreen deliberately than to have been refused, and expanding the
 * page under them would be its own kind of broken.
 */ const $0f29b5a53cc88186$var$FIRST_GESTURE_ATTEMPTS = 3;
const $0f29b5a53cc88186$export$48ce62c637877209 = ()=>{
    if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || !$0f29b5a53cc88186$export$efad50a2596de3ba()) return;
    // A single tap arrives as both a touchend and a pointerup. Whichever a browser sends first is
    // the family we keep, so the taps after it are counted once each.
    const events = [
        "touchend",
        "pointerup"
    ];
    let attempts = 0;
    const stop = ()=>events.forEach((type)=>window.removeEventListener(type, onGesture));
    function onGesture(event) {
        events.filter((type)=>type !== event.type).forEach((type)=>window.removeEventListener(type, onGesture));
        if ($0f29b5a53cc88186$export$d7e5f5607a21fc72()) {
            stop();
            return;
        }
        attempts += 1;
        $0f29b5a53cc88186$export$859c5997fce6d45();
        if (attempts >= $0f29b5a53cc88186$var$FIRST_GESTURE_ATTEMPTS) stop();
    }
    events.forEach((type)=>window.addEventListener(type, onGesture));
};
const $0f29b5a53cc88186$export$1bfbbc26cf37a585 = ()=>{
    if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
    $0f29b5a53cc88186$export$859c5997fce6d45();
    // Arm after the current gesture has finished, or the listener catches this very tap and
    // spends a retry on a request we have already made.
    setTimeout($0f29b5a53cc88186$export$48ce62c637877209, 0);
};


// Fake a slow connection on a local dev socket, so "how does this look at 90ms?" is a question
// you can answer at your desk instead of guessing.
//
// Everything about how other players look -- interpolation, the size of the update gaps a client
// has to bridge, reconciliation on the local player -- only misbehaves once frames stop arriving
// the instant they are sent. On localhost they always do, which is exactly the case that hides
// every latency bug. The headless harness conditions its loopback the same way (see
// __tests__/integration/loopback.ts) and is the right place to MEASURE; this is for looking.
//
// Only installed against a local server, and idle until somebody asks for latency:
//
//     netsim.set({ rttMs: 90, jitterMs: 20 })   // both directions, so 90ms round trip
//     netsim.off()
//
// Delay never reorders, because a WebSocket runs over TCP and neither would a real one.
const $789f2cfb0ccfe259$var$settings = {
    rttMs: 0,
    jitterMs: 0
};
/** Last scheduled delivery time per direction, so a jittered frame never overtakes its predecessor. */ const $789f2cfb0ccfe259$var$watermark = {
    inbound: 0,
    outbound: 0
};
const $789f2cfb0ccfe259$var$oneWayDelay = ()=>{
    const base = $789f2cfb0ccfe259$var$settings.rttMs / 2;
    if (base <= 0 && $789f2cfb0ccfe259$var$settings.jitterMs <= 0) return 0;
    const jitter = $789f2cfb0ccfe259$var$settings.jitterMs > 0 ? (Math.random() * 2 - 1) * $789f2cfb0ccfe259$var$settings.jitterMs : 0;
    return Math.max(0, base + jitter);
};
const $789f2cfb0ccfe259$var$schedule = (direction, deliver)=>{
    const delay = $789f2cfb0ccfe259$var$oneWayDelay();
    if (delay <= 0) {
        deliver();
        return;
    }
    const now = Date.now();
    const at = Math.max(now + delay, $789f2cfb0ccfe259$var$watermark[direction]);
    $789f2cfb0ccfe259$var$watermark[direction] = at;
    setTimeout(deliver, at - now);
};
const $789f2cfb0ccfe259$export$1e138c080884cecd = (ws)=>{
    let handler = null;
    Object.defineProperty(ws, "onmessage", {
        configurable: true,
        get: ()=>handler,
        set: (fn)=>{
            handler = fn;
        }
    });
    ws.addEventListener("message", (event)=>{
        $789f2cfb0ccfe259$var$schedule("inbound", ()=>handler?.(event));
    });
    const send = ws.send.bind(ws);
    ws.send = (data)=>$789f2cfb0ccfe259$var$schedule("outbound", ()=>{
            // A held frame can come due after the socket has closed, which the real send()
            // answers with a throw. Nothing upstream expects that from a send it made a moment
            // ago, and the frame is moot either way.
            if (ws.readyState !== WebSocket.OPEN) return;
            send(data);
        });
    const api = {
        set: (next)=>{
            Object.assign($789f2cfb0ccfe259$var$settings, next);
            return {
                ...$789f2cfb0ccfe259$var$settings
            };
        },
        off: ()=>{
            $789f2cfb0ccfe259$var$settings.rttMs = 0;
            $789f2cfb0ccfe259$var$settings.jitterMs = 0;
            return {
                ...$789f2cfb0ccfe259$var$settings
            };
        },
        get: ()=>({
                ...$789f2cfb0ccfe259$var$settings
            })
    };
    window.netsim = api;
    return api;
};


/**
 * Staying connected across a backgrounded game.
 *
 * Two different things go wrong when the player switches away, and this module is the shared
 * machinery for both.
 *
 * The first was ours. `client.update()` runs on the pixi ticker, which is requestAnimationFrame,
 * and a hidden tab is given no frames at all -- but `ws.onmessage` keeps firing, because a
 * background tab still receives network events. So `incomingWorldStates` filled at the server's
 * tick rate (~58 frames a second) with nothing on the other end to drain it, until the renderer
 * process was killed for its memory and took the socket down with it. From the player's seat the
 * websocket "died when the game was backgrounded"; what actually died was the tab. The answer is
 * to stop the stream at its SOURCE while nobody is drawing it (type_suspendUpdates) rather than to
 * buffer it more cleverly, which also hands the server back the broadcast work for an idle player.
 *
 * The second is not ours and cannot be prevented: iOS and Android suspend a backgrounded app and
 * the socket goes with it. What can be fixed is NOTICING. A resumed WebView routinely holds a
 * socket that still reports OPEN, will never deliver another byte, and never fires `close` -- so
 * nothing tells the client anything is wrong and the game just sits there. Hence the watchdog:
 * traffic is the liveness signal, and silence while the page is in the FOREGROUND is the symptom.
 *
 * Both reconnect, so one object owns every reason to dial. Two schedulers racing here would
 * double-dial, and on this server a second socket is a second session.
 */ /** The events that mean "the player may be looking at this again". */ const $06a32a8a2cf2cac8$export$4227747d94937b6e = {
    hiddenGraceMs: 2000,
    staleAfterMs: 15000,
    resumeStaleAfterMs: 5000,
    checkEveryMs: 2500,
    retryDelaysMs: [
        1000,
        2000,
        4000,
        8000,
        15000
    ]
};
const $06a32a8a2cf2cac8$export$c7ee3fdd01415f96 = ()=>({
        // visibilityState is the modern spelling; document.hidden is kept for older Android WebViews,
        // which is the environment that most needs this to work.
        hidden: ()=>typeof document === "undefined" ? false : document.visibilityState ? document.visibilityState === "hidden" : !!document.hidden,
        now: ()=>Date.now(),
        setTimer: (fn, ms)=>setTimeout(fn, ms),
        clearTimer: (handle)=>clearTimeout(handle),
        setPoll: (fn, ms)=>setInterval(fn, ms),
        clearPoll: (handle)=>clearInterval(handle),
        listen: (type, fn)=>{
            // visibilitychange is a document event; the rest are window events. Getting this wrong
            // fails silently, which is the worst way for a reconnect path to fail.
            const target = type === "visibilitychange" ? document : window;
            target.addEventListener(type, fn);
            return ()=>target.removeEventListener(type, fn);
        }
    });
class $06a32a8a2cf2cac8$export$5be6ec909ad606e6 {
    constructor(delegate, host = $06a32a8a2cf2cac8$export$c7ee3fdd01415f96(), timings = $06a32a8a2cf2cac8$export$4227747d94937b6e){
        this.teardowns = [];
        /** True once the server has been told to stop sending. */ this.suspended = false;
        /** Last moment anything at all arrived from the server. */ this.lastTrafficTs = 0;
        /** Consecutive failed redials, for the backoff. */ this.retryCount = 0;
        /** A dial is in flight. Nothing else may start one. */ this.dialling = false;
        this.start = ()=>{
            if (this.teardowns.length > 0) return;
            this.teardowns.push(this.host.listen("visibilitychange", ()=>{
                if (this.host.hidden()) this.armHiddenTimer();
                else this.resumed();
            }));
            // Belt and braces around visibilitychange, which a WebView does not always deliver on the
            // way back in. Each of these is a resume in its own right, and `resumed` is idempotent.
            const alsoResume = [
                "focus",
                "online",
                "pageshow"
            ];
            alsoResume.forEach((type)=>this.teardowns.push(this.host.listen(type, ()=>{
                    if (!this.host.hidden()) this.resumed();
                })));
            this.pollHandle = this.host.setPoll(this.check, this.timings.checkEveryMs);
        };
        this.stop = ()=>{
            this.teardowns.forEach((teardown)=>teardown());
            this.teardowns = [];
            this.host.clearPoll(this.pollHandle);
            this.pollHandle = undefined;
            this.clearHiddenTimer();
            this.clearRetryTimer();
        };
        /** Anything arrived from the server. The one signal that the socket is really alive. */ this.noteTraffic = ()=>{
            this.lastTrafficTs = this.host.now();
            this.staleAfterMs = this.timings.staleAfterMs;
        };
        /** A socket opened. */ this.noteConnected = ()=>{
            this.dialling = false;
            this.retryCount = 0;
            this.suspended = false;
            this.noteTraffic();
            // A socket that finishes opening when the page is ALREADY hidden -- the player dialled and
            // switched away during the handshake -- still has a stream to stop.
            if (this.host.hidden()) this.armHiddenTimer();
        };
        /** The current socket closed, or a dial failed. */ this.noteConnectionLost = ()=>{
            const dialFailed = this.dialling;
            this.dialling = false;
            this.suspended = false;
            this.clearHiddenTimer();
            // A failed retry backs off; a live socket dying starts the ladder from the bottom, because
            // most lost sockets come back on the first try.
            this.retryCount = dialFailed ? this.retryCount + 1 : 0;
            this.scheduleRetry();
        };
        /** The player pressed "Try again". Skip the ladder. */ this.retryNow = ()=>{
            this.clearRetryTimer();
            this.retryCount = 0;
            this.dial("player asked");
        };
        this.armHiddenTimer = ()=>{
            if (this.hiddenHandle || this.suspended) return;
            this.hiddenHandle = this.host.setTimer(()=>{
                this.hiddenHandle = undefined;
                // Back already, or gone before the socket was up: either way there is nothing to stop.
                if (!this.host.hidden() || this.suspended || !this.delegate.isConnected()) return;
                this.suspended = true;
                this.delegate.suspendUpdates();
            }, this.timings.hiddenGraceMs);
        };
        this.clearHiddenTimer = ()=>{
            if (this.hiddenHandle) {
                this.host.clearTimer(this.hiddenHandle);
                this.hiddenHandle = undefined;
            }
        };
        this.clearRetryTimer = ()=>{
            if (this.retryHandle) {
                this.host.clearTimer(this.retryHandle);
                this.retryHandle = undefined;
            }
        };
        this.resumed = ()=>{
            this.clearHiddenTimer();
            if (!this.delegate.isConnected()) {
                // The socket did not survive. Dial straight away rather than serving out a backoff the
                // player experiences as the game having hung.
                this.clearRetryTimer();
                this.retryCount = 0;
                this.dial("resumed on a closed socket");
                return;
            }
            if (this.suspended) {
                this.suspended = false;
                this.delegate.resumeUpdates();
                // We have just asked for a resend, so it is owed immediately. If nothing comes, this
                // socket is one of the corpses that still reports OPEN.
                this.lastTrafficTs = this.host.now();
                this.staleAfterMs = this.timings.resumeStaleAfterMs;
                return;
            }
            // Never suspended (a quick flick away), so the stream never stopped and the ordinary
            // deadline applies -- but the clock restarts here, because any silence up to now was the
            // background's and says nothing about the socket.
            this.lastTrafficTs = this.host.now();
            this.staleAfterMs = this.timings.staleAfterMs;
        };
        this.scheduleRetry = ()=>{
            if (this.retryHandle || this.dialling) return;
            // No dialling while hidden: on a suspended phone it cannot succeed, and on a desktop
            // nobody is watching the result. `resumed` dials immediately instead.
            if (this.host.hidden()) return;
            const delays = this.timings.retryDelaysMs;
            const delay = delays[Math.min(this.retryCount, delays.length - 1)];
            this.retryHandle = this.host.setTimer(()=>{
                this.retryHandle = undefined;
                this.dial(`retry ${this.retryCount + 1}`);
            }, delay);
        };
        this.dial = (why)=>{
            if (this.dialling) return;
            this.dialling = true;
            // Start the liveness clock from the dial, so a socket that opens and says nothing is
            // judged on its own silence rather than on the previous socket's.
            this.lastTrafficTs = this.host.now();
            this.staleAfterMs = this.timings.staleAfterMs;
            this.delegate.log?.(`reconnecting: ${why}`);
            this.delegate.reconnect();
        };
        this.check = ()=>{
            // Nothing is being drawn and the stream was stopped on purpose, so silence here is
            // expected rather than evidence. Background timers are throttled to a crawl anyway.
            if (this.host.hidden() || this.dialling) return;
            if (!this.delegate.isConnected()) {
                // A close we were never told about, or a retry that is overdue.
                this.scheduleRetry();
                return;
            }
            if (this.host.now() - this.lastTrafficTs < this.staleAfterMs) return;
            // Open, in the foreground, and silent for longer than the server's own ping interval
            // allows. This is the resumed-but-dead socket: no close event is ever coming for it.
            this.retryCount = 0;
            this.dial("no traffic");
        };
        this.delegate = delegate;
        this.host = host;
        this.timings = timings;
        this.staleAfterMs = timings.staleAfterMs;
        this.lastTrafficTs = host.now();
    }
}


class $67f7e8116a91e4e7$export$1f2bb630327ac4b6 {
    static{
        this.POSITION_ERROR_DECAY = 0.8 // per-frame; ~200ms ease at 60fps
        ;
    }
    static{
        this.POSITION_ERROR_SNAP_EPSILON = 0.05 // px; below this, clear the error
        ;
    }
    static{
        this.SERVER_CLOCK_CREEP = 0.0005;
    }
    static{
        // How far behind the server's clock other entities are drawn. The buffer has to hold at
        // least one sample older than this for interpolation to have something to work with, so it
        // must cover the one-way latency plus the gap between updates for that entity.
        this.INTERPOLATION_DELAY_MS = 150;
    }
    static{
        this.RENDER_SMOOTHING_TAU_MS = 55;
    }
    static{
        // Past this, a "correction" is a teleport (respawn, room change, coming back into view) and
        // easing into it would draw the entity skating across the map. A tile is far more than the
        // few pixels a filter this short ever trails a moving entity by.
        this.RENDER_SMOOTHING_SNAP_PX_SQ = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // ...and below this, land on the target exactly instead of approaching it forever. An
        // exponential filter has no finish line: it trails a walking entity by about 4px, and when
        // that entity stops it keeps closing the gap by ever-smaller fractions for ~200 frames before
        // the delta underflows. Every one of those sub-micron steps counts as movement to
        // lpc_sprite.doMovement, which picks walk-vs-idle by comparing the position to last frame's,
        // so a remote player who had stopped kept walking on the spot for the better part of two
        // seconds. Half a screen pixel at surfaceZoom 2, so landing early can never show as a jump.
        this.RENDER_SMOOTHING_SETTLE_PX_SQ = 0.0625;
    }
    static{
        /**
     * Hard ceiling on the queue above. The drain is `update()`, which runs on the pixi ticker --
     * requestAnimationFrame -- and a BACKGROUNDED tab is given no frames at all, while
     * `ws.onmessage` keeps firing because a hidden tab still receives network events. So this
     * queue grew at the server's tick rate with nothing taking anything off it, until the renderer
     * was killed for its memory and the socket died with it. That is the "websocket dies when the
     * game is backgrounded" report.
     *
     * The real fix is to stop the stream at the source (see ConnectionLifecycle and
     * type_suspendUpdates). This cap is the backstop for the gap that is left: the couple of
     * seconds before the suspend is sent, a server too old to honour it, a resume message that
     * never arrives. Sized at roughly a third of a second of frames -- far more than any drawn
     * frame needs, far less than it takes to matter -- and overflow drops the OLDEST, because the
     * newest frame is the only one worth drawing. Dropping any frame leaves the picture
     * incomplete (the stream is deltas), so it also sets `desynced`, and the resume path turns
     * that into a full resend rather than letting the player wander round a stale world.
     */ this.MAX_QUEUED_WORLD_STATES = 20;
    }
    constructor(clientGameLogic){
        // Whether a socket has ever opened this session. Only used to word the disconnected panel:
        // "connection lost" and "can't reach the server" are different situations to be in, and the
        // second one usually means the server rather than the player's wifi.
        this.everConnected = false;
        this.lastState = undefined;
        this.incompleteEntityLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(2000);
        // Reconciliation error-smoothing for the local player. When an authoritative
        // update disagrees with the client's predicted position (e.g. the server has
        // slowed the player during a push that the client predicted at full speed),
        // we don't snap the rendered position to the correction -- that reads as a
        // shudder because the camera follows the player. Instead we keep the
        // authoritative/predicted position as truth in entity.location and carry the
        // visual delta here, decaying it toward zero over a few frames so the camera
        // eases into the correction. Large deltas (teleports/room changes) bypass this.
        this.playerPositionError = {
            x: 0,
            y: 0
        };
        // Interpolation can only ever be as even as the samples it is fed, and the samples are not
        // even: the server advances a player when it dequeues one of that player's input frames
        // (~16ms apart) but photographs the world on its own 10ms tick, so consecutive samples are
        // one step of movement over alternately 10ms and 20ms. Replayed literally that is a real
        // ±25% speed ripple at ~12Hz -- a visible shimmer on anything moving. So the interpolated
        // point is a TARGET, and the drawn position chases it through a first-order filter, which
        // attenuates the ripple to a few percent. The cost is TAU more latency on top of the
        // interpolation delay, which nothing about this game is tight enough to notice.
        this.renderSmoothing = new Map();
        this.incomingWorldStates = [];
        /** A world-state frame was dropped, so this client's picture has a hole in it. */ this.desynced = false;
        /**
     * Rate limit on asking the server to resend the world. A resync is a burst of work for one
     * player on a box that has a tick to make, so it is worth being certain it cannot be asked for
     * repeatedly. (It cannot in practice -- the only thing that drops frames is the drain not
     * running, and the request is made FROM the drain -- but this costs nothing to be sure of.)
     */ this.resyncRequestLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(5000);
        /**
     * How often a WALKING player's own position is reconciled against the server's. It was 100ms,
     * which meant a player holding a direction ignored nine out of every ten authoritative
     * positions -- fine while the only thing moving them is their own input, which they predict
     * exactly, but not when the server applies a force they cannot predict. A push is such a force:
     * the gap grew for a whole 100ms before anything was folded in, and a correction that big is
     * over the half-tile "that was a teleport" line in accumulatePlayerPositionError, so it was
     * snapped rather than eased -- 21px in one 16ms frame, against a 1.4px stride. Reconciling once
     * per drawn frame keeps each correction down to a pixel or two, which the smoothing absorbs
     * invisibly, and costs no more than the prediction already running every frame.
     */ this.interpolationTs = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(16);
        this.interpolatable = new Set();
        this.interpolationLogLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(3000) // Log every 3 seconds
        ;
        this.interpolationStats = {
            totalInterpolatable: 0,
            culledEntities: 0,
            actuallyInterpolated: 0,
            skippedNoBuffer: 0,
            skippedNotInterpolatable: 0,
            // Frames where the buffer could not bracket the render timestamp, so the entity was
            // drawn holding a sample instead of moving between two. A nonzero rate here means the
            // interpolation delay no longer covers this connection's latency plus update gap.
            underran: 0
        };
        this.boost = (on)=>{
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId,
                boost: on
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_boostAction);
        };
        this.fireBullet = ()=>{
            const player = this.clientGameLogic.playerEntity;
            if (!player) return;
            if (!this.clientGameLogic.canFireBulletFrom(player)) return;
            this.clientGameLogic.attack(player.entityId, ()=>{
                const bullets = this.clientGameLogic.createBulletFrom(player);
                if (!bullets?.length) // could not fire bullet
                return;
                bullets.forEach((bullet)=>{
                    bullet.entityId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
                    this.clientGameLogic.entityManager.set(bullet);
                    if (bullet.spriteId !== "none") this.clientGameLogic.clientRenderer.entity().create(bullet);
                });
                const entities = bullets.map((bullet)=>{
                    let message = {
                        entityId: bullet.entityId
                    };
                    return message;
                });
                this.send({
                    message: {
                        entities: entities,
                        origin: {
                            ...player.location
                        },
                        roomId: player.roomId,
                        movement: {
                            ...player.movement
                        },
                        weapon: player.weapon
                    }
                }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fireWeapon);
            });
        };
        this.spawnNpc = ()=>{
            // if (this.clientGameLogic.playerEntity.name?.trim() !== "aron") {
            //     return
            // }
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId
            }, "spawn");
        };
        this.dropAction = ()=>{
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_dropAction);
        };
        this.resetAction = ()=>{
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_resetAction);
        };
        this.activateInventoryItem = (item)=>{
            this.send({
                message: {
                    item: item,
                    originEntityId: this.clientGameLogic.playerEntity.entityId
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_activateInventoryItem);
        };
        this.activateAbility = (shortcutKey)=>{
            this.send({
                message: {
                    shortcutKey: shortcutKey,
                    originEntityId: this.clientGameLogic.playerEntity.entityId
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_activateAbility);
        };
        this.dropActiveItem = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestDropActiveItem);
        };
        this.startChat = ()=>{
            this.clientGameLogic.clientRenderer.gui().startChat();
        };
        this.stopChat = ()=>{
            const message = this.clientGameLogic.clientRenderer.gui().stopChat();
            if (!message) return;
            // Intercept `/agent ...` client-side: the AgentController handles it locally instead
            // of sending it to the server as a normal chat message.
            if (message.startsWith("/agent") && this.agentController) {
                this.agentController.handleCommand(message);
                return;
            }
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId,
                message: message
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_chatMessage);
        };
        this.captureKeystroke = (c, mods)=>{
            if (c.length > 1 && !$67f7e8116a91e4e7$export$1f2bb630327ac4b6.CHAT_EDIT_KEYS.includes(c)) return;
            this.clientGameLogic.clientRenderer.gui().captureKeystroke(c, mods);
        };
        this.pasteIntoChat = (text)=>{
            this.clientGameLogic.clientRenderer.gui().insertChatText(text);
        };
        this.updateName = (name)=>{
            this.send({
                message: {
                    name: name,
                    originEntityId: this.clientGameLogic.playerEntity.entityId
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateName);
        };
        this.updateEntityFromMessage = (message, entity, now)=>{
            entity.lastUpdateTs = now;
            entity.entityState = message.entityState;
            entity.roomId = message.roomId;
            entity.speed = message.speed;
            entity.maxSpeed = message.maxSpeed;
            entity.name = message.name;
            entity.faction = message.faction;
            entity.color = message.color;
            entity.hp = message.hp;
            entity.hunger = message.hunger;
            entity.maxHunger = message.maxHunger;
            entity.maxHp = message.hpMax;
            entity.joinedTeam = message.joinedTeam;
            entity.score = message.score;
            entity.level = message.level;
            entity.scoreTilNextLevel = message.scoreTillNextLevel;
            entity.weapon = message.weapon;
            entity.paralyzeUntilTs = message.paralyzeUntilTs;
            entity.appearance = message.appearance;
            entity.clickable = message.clickable;
            entity.spriteId = message.spriteId;
            entity.expirationTs = message.expirationTs;
            entity.quantity = message.quantity;
            entity.lightMeta = message.lightMeta;
            entity.spriteScale = message.spriteScale;
            entity.leaderEntityId = message.leaderEntityId;
            entity.flags = {};
            entity.flags[0, $cb689cfa16c444ba$export$c8c6d6e2d9b5390d] = message.sigilIcon;
            entity.dimensions = message.dimensions;
            entity.debug = message.debug;
            entity.afk = message.afk;
            entity.active = message.active;
            if (message.inventory) entity.inventory = message.inventory;
            this.clientGameLogic.clientRenderer.entity().update(entity);
        };
        // Fold one freshly arrived frame's send timestamp into the server clock estimate.
        this.observeServerClock = (serverTs)=>{
            if (typeof serverTs !== "number") return;
            const observed = Date.now() - serverTs;
            if (this.serverClockOffset === undefined || observed < this.serverClockOffset) {
                this.serverClockOffset = observed;
                return;
            }
            this.serverClockOffset += (observed - this.serverClockOffset) * $67f7e8116a91e4e7$export$1f2bb630327ac4b6.SERVER_CLOCK_CREEP;
        };
        // The server's clock, as best we can read it from here. Position buffers are kept on THIS
        // timeline rather than on ours: server timestamps are evenly spaced and monotonic by
        // construction, so a re-estimate of the offset moves the playback cursor instead of
        // corrupting samples already in the buffer.
        this.serverNow = ()=>Date.now() - (this.serverClockOffset ?? 0);
        /**
     * Put one freshly arrived frame on the queue, never letting it grow without bound.
     *
     * See MAX_QUEUED_WORLD_STATES for why a bound is needed at all. The oldest goes rather than the
     * newest: a stale frame has nothing to offer a renderer that is about to be handed a newer one,
     * and REPLAYING a long backlog would be worse than dropping it -- every frame runs
     * reconciliation and re-applies pending inputs, so a thousand of them arrive as a thousand
     * frames of prediction in a single tick.
     */ this.enqueueWorldState = (message)=>{
            this.incomingWorldStates.push(message);
            while(this.incomingWorldStates.length > $67f7e8116a91e4e7$export$1f2bb630327ac4b6.MAX_QUEUED_WORLD_STATES){
                this.incomingWorldStates.shift();
                this.desynced = true;
            }
        };
        /**
     * Throw away everything that went stale while the player was not looking, and ask the server
     * for a fresh picture of the world.
     *
     * Called on resume. The dropped frames cannot simply be caught up on: world state is a DELTA
     * stream, and the server marks each entity as sent per player (Server.playerEntitySentCache),
     * so a change that was broadcast while this client was ignoring it is one the server will never
     * mention again. Only a resend closes that gap, which is what type_resumeUpdates asks for.
     *
     * The local timing state goes too. The server-clock estimate creeps towards the truth over many
     * frames and is now minutes out of date; the interpolation buffers hold samples stamped on that
     * old estimate, and the render smoother holds positions from before the gap. Fed to
     * interpolateEntities as they are, they would draw every remote entity skating in from wherever
     * it stood when the player looked away.
     */ this.resyncAfterGap = ()=>{
            this.incomingWorldStates.length = 0;
            this.desynced = false;
            this.serverClockOffset = undefined;
            this.renderSmoothing.clear();
            this.clientGameLogic.entityManager.iterate(null, (entity)=>{
                entity.position_buffer = [];
            });
        };
        /**
     * Send something the game can do without, on a socket that may already be gone.
     *
     * The lifecycle's messages are all sent from timers, so the socket can close between the check
     * that it was open and the send itself -- and `send` goes straight at it. An exception thrown
     * out of a timer callback would take the rest of that callback with it, including the state
     * that decides whether to reconnect.
     */ this.sendIfOpen = (payload, payloadType)=>{
            if (this.ws?.readyState !== WebSocket.OPEN) return;
            try {
                this.send(payload, payloadType);
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "websocket",
                        "error"
                    ]
                }, `Sending ${payloadType} threw`, String(e));
            }
        };
        /** The lifecycle's view of this client: what to do, and whether the socket is up. */ this.lifecycleDelegate = ()=>({
                suspendUpdates: ()=>this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_suspendUpdates),
                resumeUpdates: ()=>{
                    this.resyncAfterGap();
                    this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_resumeUpdates);
                },
                reconnect: ()=>this.redialNow(),
                isConnected: ()=>this.ws?.readyState === WebSocket.OPEN,
                log: (message)=>(0, $5UG8I.logger).info({
                        tags: [
                            "websocket",
                            "connection"
                        ]
                    }, message)
            });
        /**
     * Drop the current socket and dial again with the same credentials.
     *
     * The old socket is closed with its handlers detached first. A socket being replaced because it
     * went silent is not necessarily dead, and its `close` landing after the replacement is up would
     * otherwise put the disconnected panel over a working connection.
     *
     * The client's own world is torn down with it. A new socket is a NEW SESSION -- the server
     * destroys the player on close, so there is nothing to resume into -- and it arrives with a
     * different entityId. Without this the previous avatar stays in the entity manager and drawn on
     * the stage, because the room-change teardown in updateFromWorldState deliberately spares
     * whatever `playerEntity` points at.
     */ this.redialNow = ()=>{
            if (!this.redial || this.injectedSocket) return;
            const old = this.ws;
            if (old) {
                old.onopen = null;
                old.onmessage = null;
                old.onerror = null;
                old.onclose = null;
                try {
                    old.close();
                } catch (e) {
                    (0, $5UG8I.logger).error({
                        tags: [
                            "websocket",
                            "connection"
                        ]
                    }, "Closing the old socket threw", String(e));
                }
            }
            this.resyncAfterGap();
            this.clientGameLogic.prepareForReconnect();
            this.redial();
        };
        /**
     * The server has ended this session and told us why. Stay down.
     *
     * Everything that would dial again is taken away: the lifecycle (its poll sees a closed socket
     * and schedules a retry) and the credentials behind `redial`. Without that, being signed out by
     * a login somewhere else turns into a tug of war -- each tab's redial evicts the other about once
     * a second, forever, with both sockets live in between and both driving the same avatar.
     *
     * The panel goes up HERE rather than waiting for the close, so the player reads why they were
     * signed out instead of a "Connection lost / Try again" that is not true and whose retry would
     * take the account back off the window they moved to.
     */ this.handleSessionEnded = (reason)=>{
            this.sessionEndReason = reason || "ended";
            (0, $5UG8I.logger).info({
                tags: [
                    "websocket",
                    "session"
                ]
            }, `session ended by the server: ${this.sessionEndReason}`);
            this.lifecycle?.stop();
            this.lifecycle = undefined;
            this.redial = undefined;
            if (!this.injectedSocket) (0, $69f7ea6451029ed5$export$4237b8ea75e6554)(this.sessionEndReason);
        };
        // Handles messages from the server and updates client state
        this.processServerMessages = ()=>{
            // A frame was dropped somewhere, so parts of this world are as the player last saw them
            // rather than as they are. Deltas cannot fill that in; only a resend can. The usual cause
            // is the queue overflowing during the couple of seconds between the page being hidden and
            // the suspend taking effect, but a long main-thread stall does it too.
            if (this.desynced && this.resyncRequestLatch.expired()) {
                this.resyncAfterGap();
                this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_resumeUpdates);
            }
            const now = Date.now();
            while(true){
                const worldState = this.incomingWorldStates.shift();
                if (!worldState) break;
                const updatedRoom = this.clientGameLogic.updateFromWorldState(worldState);
                updatedRoom;
                const { messages: messages } = worldState;
                // World state is a list of entity states.
                for(let i = 0; i < messages.length; i++){
                    const message = messages[i];
                    if (this.clientGameLogic.isDestroyed(message.entityId)) continue;
                    // If this is the first time we see this entity, create a local representation.
                    if (!this.clientGameLogic.hasEntity(message.entityId)) this.clientGameLogic.createEntity(message);
                    const entity = this.clientGameLogic.getEntity(message.entityId);
                    if (!entity) continue;
                    this.updateEntityFromMessage(message, entity, now);
                    if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isStationary(entity)) this.interpolatable.delete(entity.entityId);
                    else this.interpolatable.add(entity.entityId);
                    const player = this.clientGameLogic.playerEntity;
                    const isPlayer = message.entityId == player?.entityId;
                    // update other players locally
                    if (isPlayer) {
                        if (!updatedRoom) {
                            const updatedLocation = {
                                x: message.position[0],
                                y: message.position[1]
                            };
                            const positionUpdated = updatedLocation.x !== this.clientGameLogic.playerEntity.location.x || updatedLocation.y !== this.clientGameLogic.playerEntity.location.y;
                            this.clientGameLogic.updateFromPlayerMessage(message);
                            // At most one reconciliation per drawn frame (see interpolationTs). A
                            // standing player skips this and reconciles on every message: with no
                            // pending inputs there is nothing to replay, so it is nearly free.
                            if (player.pending_inputs.length > 0 && !this.interpolationTs.expired()) continue;
                            // Received the authoritative position of this client's entity.
                            if (player.pending_inputs.length < 1 && positionUpdated) {
                                (0, $5UG8I.logger).debug({
                                    tags: [
                                        "player",
                                        "position"
                                    ]
                                }, "Player position updating from", entity.location, "to", updatedLocation);
                                const renderedBefore = {
                                    x: entity.location.x,
                                    y: entity.location.y
                                };
                                entity.location = updatedLocation;
                                this.accumulatePlayerPositionError(renderedBefore, entity.location);
                                this.clientGameLogic.clientRenderer.updatePlayerLocation(entity);
                                // Invalidate caches when player position updates
                                this.clientGameLogic.invalidateEntitySortCache();
                                this.clientGameLogic.invalidateViewportCache();
                                (0, $5UG8I.logger).debug({
                                    tags: [
                                        "player",
                                        "initialization"
                                    ]
                                }, "Player initialized:", this.clientGameLogic.isPlayerInitialized());
                                continue;
                            }
                            if ((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(entity.location, updatedLocation) > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2) this.primingLatch = null;
                            // Capture where the player is currently rendered (last frame's predicted
                            // position) so we can measure the visual correction after reconciliation.
                            const renderedBefore = {
                                x: entity.location.x,
                                y: entity.location.y
                            };
                            entity.location = updatedLocation;
                            // Also invalidate caches in the fallback case
                            this.clientGameLogic.invalidateEntitySortCache();
                            this.clientGameLogic.invalidateViewportCache();
                            // Server Reconciliation. Re-apply all the inputs not yet processed by
                            // the server.
                            let j = 0;
                            while(j < player.pending_inputs.length){
                                const input = player.pending_inputs[j];
                                if (input.input_sequence_number <= message.last_processed_input) // Already processed. Its effect is already taken into account into the world update
                                // we just got, so we can drop it.
                                player.pending_inputs.splice(j, 1);
                                else {
                                    // Not processed by the server yet. Re-apply it.
                                    const resultItem = (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.checkout();
                                    this.clientGameLogic.advanceEntity(resultItem.data, entity, input, true);
                                    (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.release(resultItem);
                                    j++;
                                }
                            }
                            // entity.location is now the corrected predicted position (truth). Fold the
                            // delta from where we were rendering into the smoothing offset instead of
                            // letting the camera jump. accumulatePlayerPositionError() snaps outright on
                            // large corrections (teleports/room changes).
                            this.accumulatePlayerPositionError(renderedBefore, entity.location);
                        } else setTimeout(()=>{
                            entity.position_buffer = [];
                            const updatedLocation = {
                                x: message.position[0],
                                y: message.position[1]
                            };
                            this.clientGameLogic.updateFromPlayerMessage(message);
                            entity.location = updatedLocation;
                            // force=true: this room-load call fires ~100ms after the
                            // camera's translation computer was reset, still inside its
                            // 150ms ready() gate. Without force it gets dropped and the
                            // camera stays off-player until the first movement.
                            this.clientGameLogic.clientRenderer.updatePlayerLocation(entity, true);
                        }, 100);
                    } else {
                        this.clientGameLogic.updateFromNonPlayerMessage(message);
                        // Received the position of an entity other than this client's.
                        const updatedLocation = {
                            x: message.position[0],
                            y: message.position[1]
                        };
                        // Stamp the sample with when the SERVER took it, not with `now`. `now` is the
                        // moment this frame got round to draining the queue, so it quantizes every
                        // sample to the frame period and collapses two frames drained together onto
                        // one timestamp. Interpolating over that renders a constant-speed walk as one
                        // that alternates between half speed and a jump.
                        const timestamp = worldState.serverTs ?? this.serverNow();
                        entity.location = updatedLocation;
                        this.clientGameLogic.entityManager.set(entity);
                        if (!this.clientGameLogic.isTooDistantFromPlayerByLocation(entity.entityId, updatedLocation)) {
                            const buffer = entity.position_buffer;
                            const previous = buffer[buffer.length - 1];
                            if (previous && previous[0] >= timestamp) // Two samples stamped the same server millisecond. A zero-length
                            // segment has no meaningful velocity and divides by zero in the lerp,
                            // so keep the newer position and drop the older.
                            buffer.pop();
                            buffer.push([
                                timestamp,
                                message.position[0],
                                message.position[1],
                                message.direction,
                                message.angle
                            ]);
                        }
                        if (!message.complete) this.clientGameLogic.incompleteEntity(entity);
                        else this.clientGameLogic.clearIncompleteEntities([
                            entity.entityId
                        ]);
                    }
                    entity.visible = message.visible;
                    // Beside `visible`, and for the same reason: a verdict about somebody ELSE that the
                    // renderer has to act on. See Entity.invading -- it is what keeps the player ring off
                    // a possessed attacker.
                    entity.invading = message.invading;
                }
            }
        };
        this.toSendState = (player)=>{
            const { speed2: c, movement: movement } = player;
            if (!this.lastMovement) this.lastMovement = {
                ...movement
            };
            const dontSend = c.x === 0 && c.y === 0 && movement.angle === this.lastMovement.angle;
            this.lastMovement.angle = movement.angle;
            this.lastMovement.direction = movement.direction;
            this.lastMovement.moving = movement.moving;
            return !dontSend;
        };
        // Process user inputs and send updated to the server
        this.processInputs = ()=>{
            const now_ts = Date.now();
            const last_ts = this.last_ts || now_ts;
            const dt_sec = (now_ts - last_ts) / 1000.0;
            this.last_ts = now_ts;
            // dt_sec is the delta seconds since last update
            this.clientGameLogic.processEntities(dt_sec);
            const player = this.clientGameLogic.playerEntity;
            // handle player movement
            if (player) {
                const { movement: movement, speed: speed } = player;
                const thisState = this.toSendState(player);
                const changed = thisState !== this.lastState || this.lastState === undefined;
                if (changed) this.sendState = thisState;
                this.lastState = thisState;
                if (!this.primingLatch) {
                    this.primingLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(2000, Date.now());
                    this.primingLatch.singleUse = true;
                }
                if (this.sendState || this.primingLatch && !this.primingLatch.expired()) {
                    const speed2 = {
                        x: player.speed2.x * speed,
                        y: player.speed2.y * speed
                    };
                    let message = {
                        entityType: "player",
                        press_time: dt_sec,
                        direction: movement.direction,
                        angle: movement.angle,
                        speed2: speed2,
                        input_sequence_number: player.input_sequence_number++,
                        entityId: player.entityId,
                        roomId: player.roomId
                    };
                    const { x: x, y: y } = player.location;
                    const resultItem = (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.checkout();
                    this.clientGameLogic.advancePlayer(resultItem.data, message);
                    const movedX = resultItem.data?.movedX;
                    const movedY = resultItem.data?.movedY;
                    (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.release(resultItem);
                    if (!movedX && movedY || movedX && !movedY && (x !== player.location.x || y !== player.location.y)) {
                        if (movedX) {
                            const speed2 = {
                                x: player.speed2.x * speed,
                                y: 0
                            };
                            message.speed2 = speed2;
                        }
                        if (movedY) {
                            const speed2 = {
                                x: 0,
                                y: player.speed2.y * speed
                            };
                            message.speed2 = speed2;
                        }
                    }
                    this.ws.send(JSON.stringify({
                        recv_ts: Date.now(),
                        payload: message
                    }));
                    // Save this input for later reconciliation.
                    player.pending_inputs.push(message);
                }
            }
        };
        this.renderWorld = ()=>this.clientGameLogic.renderScene();
        // Ease the drawn position of one entity toward where interpolation says it is. Frame-rate
        // independent: the same time constant whatever the refresh rate.
        this.smoothRenderPosition = (entityId, targetX, targetY, now)=>{
            const state = this.renderSmoothing.get(entityId);
            if (!state) {
                const created = {
                    x: targetX,
                    y: targetY,
                    ts: now
                };
                this.renderSmoothing.set(entityId, created);
                return created;
            }
            const elapsed = now - state.ts;
            state.ts = now;
            // Squared, because this runs for every visible entity every frame and Math.hypot is a
            // surprisingly expensive way to ask a yes/no question.
            const offByX = targetX - state.x;
            const offByY = targetY - state.y;
            const offBySq = offByX * offByX + offByY * offByY;
            if (elapsed <= 0 || offBySq > $67f7e8116a91e4e7$export$1f2bb630327ac4b6.RENDER_SMOOTHING_SNAP_PX_SQ || offBySq < $67f7e8116a91e4e7$export$1f2bb630327ac4b6.RENDER_SMOOTHING_SETTLE_PX_SQ) {
                state.x = targetX;
                state.y = targetY;
                return state;
            }
            const alpha = 1 - Math.exp(-elapsed / $67f7e8116a91e4e7$export$1f2bb630327ac4b6.RENDER_SMOOTHING_TAU_MS);
            state.x += (targetX - state.x) * alpha;
            state.y += (targetY - state.y) * alpha;
            return state;
        };
        this.interpolateEntities = ()=>{
            // Compute render timestamp, on the server's timeline (that is what position buffers are
            // stamped with -- see processServerMessages).
            const now = Date.now();
            const render_timestamp = this.serverNow() - $67f7e8116a91e4e7$export$1f2bb630327ac4b6.INTERPOLATION_DELAY_MS;
            // Reset stats for this frame
            this.interpolationStats.totalInterpolatable = this.interpolatable.size;
            this.interpolationStats.culledEntities = 0;
            this.interpolationStats.actuallyInterpolated = 0;
            this.interpolationStats.skippedNoBuffer = 0;
            this.interpolationStats.skippedNotInterpolatable = 0;
            this.interpolationStats.underran = 0;
            this.interpolatable.forEach((entityId)=>{
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (!entity) return;
                // No point in interpolating local things
                if (!this.clientGameLogic.shouldInterpolate(entity)) {
                    this.interpolationStats.skippedNotInterpolatable++;
                    return;
                }
                // Skip interpolation for culled entities
                if (this.clientGameLogic.isTooDistantFromPlayer(entity)) {
                    this.interpolationStats.culledEntities++;
                    return;
                }
                this.interpolationStats.actuallyInterpolated++;
                // Find the two authoritative positions surrounding the rendering timestamp.
                const buffer = entity.position_buffer || [];
                if (buffer.length < 1) {
                    this.interpolationStats.skippedNoBuffer++;
                    return;
                }
                // Drop samples already played past, keeping the one that brackets the render
                // timestamp from below.
                while(buffer.length >= 2 && buffer[1][0] <= render_timestamp)buffer.shift();
                // Always produce a position, even when the buffer cannot bracket the render
                // timestamp -- it runs dry whenever an update is late, and it has nothing old
                // enough for the first INTERPOLATION_DELAY_MS after an entity appears. Leaving
                // the entity alone on those frames used to hand the drawing over to the raw
                // latest position that processServerMessages had written straight onto it, so
                // the entity jumped a whole interpolation delay forward and then back again on
                // the next frame. Holding the nearest sample we do have and letting the smoother
                // ease into it is both continuous and closer to the truth.
                const from = buffer[0];
                const to = buffer.length >= 2 ? buffer[1] : undefined;
                let targetX = from[1];
                let targetY = from[2];
                let facing = from;
                if (to && from[0] <= render_timestamp) {
                    const span = to[0] - from[0];
                    const progress = span > 0 ? (render_timestamp - from[0]) / span : 1;
                    targetX = from[1] + (to[1] - from[1]) * progress;
                    targetY = from[2] + (to[2] - from[2]) * progress;
                    facing = to;
                } else this.interpolationStats.underran++;
                const drawn = this.smoothRenderPosition(entityId, targetX, targetY, now);
                entity.location.x = drawn.x;
                entity.location.y = drawn.y;
                entity.movement.direction = facing[3];
                entity.movement.angle = facing[4];
            });
            // Log interpolation stats periodically
            if (this.interpolationLogLatch.expired()) {
                const stats = this.interpolationStats;
                const cullRate = stats.totalInterpolatable > 0 ? (stats.culledEntities / stats.totalInterpolatable * 100).toFixed(1) : "0";
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, "\uD83D\uDD04 Interpolation Stats:");
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Total interpolatable: ${stats.totalInterpolatable}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Culled (too far): ${stats.culledEntities} (${cullRate}%)`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Actually interpolated: ${stats.actuallyInterpolated}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Skipped (no buffer): ${stats.skippedNoBuffer}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Skipped (not interpolatable): ${stats.skippedNotInterpolatable}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Buffer underran (held a sample): ${stats.underran}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Performance: ${stats.actuallyInterpolated}/${stats.totalInterpolatable} entities processed`);
            }
        };
        this.incompleteEntities = ()=>{
            if (this.incompleteEntityLatch.expired()) {
                const nearby = this.clientGameLogic.nearbyIncompleteEntities();
                if (nearby.length > 0) this.requestEntityDetail(nearby);
            }
        };
        // Accumulate the visual delta between where the player was being rendered and the
        // freshly reconciled (authoritative/predicted) position. Instead of letting the camera
        // jump to the correction, we carry the delta as an offset that decays over a few frames.
        // A correction larger than half a tile is treated as a teleport/room-change and snapped
        // outright (clearing any pending offset) rather than rubber-banded.
        this.accumulatePlayerPositionError = (renderedBefore, corrected)=>{
            if ((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(renderedBefore, corrected) > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2) {
                this.playerPositionError.x = 0;
                this.playerPositionError.y = 0;
                return;
            }
            this.playerPositionError.x += renderedBefore.x - corrected.x;
            this.playerPositionError.y += renderedBefore.y - corrected.y;
        };
        /**
     * Where the local player is actually DRAWN this frame: the predicted/reconciled truth plus the
     * decaying correction offset. `playerEntity.location` on its own is NOT what the player sees --
     * a reconciliation moves it in a single step and this offset is precisely what hides that -- so
     * anything asking "did the screen jump" has to ask here. The render pass below computes the
     * same sum inline; this is the read-only way to sample it.
     */ this.renderedPlayerLocation = ()=>{
            const player = this.clientGameLogic.playerEntity;
            if (!player) return undefined;
            return {
                x: player.location.x + this.playerPositionError.x,
                y: player.location.y + this.playerPositionError.y
            };
        };
        // Decay the smoothing offset toward zero by one frame. Called at the TOP of the frame
        // (before reconciliation folds in any fresh error) so that on the frame a correction
        // arrives the offset renders at full strength -- exactly cancelling the positional jump --
        // and only begins easing on subsequent frames. Not private: the headless harness drives the
        // frame loop a piece at a time and has to run this one too, or its clients accumulate a
        // correction offset that never eases and stop resembling a real client.
        this.decayPlayerPositionError = ()=>{
            this.playerPositionError.x *= $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_DECAY;
            this.playerPositionError.y *= $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_DECAY;
            if (Math.abs(this.playerPositionError.x) < $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_SNAP_EPSILON) this.playerPositionError.x = 0;
            if (Math.abs(this.playerPositionError.y) < $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_SNAP_EPSILON) this.playerPositionError.y = 0;
        };
        // Game update loop
        this.update = ()=>{
            // Decay first, then let processServerMessages() fold in this frame's correction.
            this.decayPlayerPositionError();
            this.processServerMessages();
            if (!this.clientGameLogic.playerEntity) return;
            // Re-apply the agent's held movement intent after reconciliation and before
            // processInputs reads speed2 (reconciliation overwrites it every frame). No-op
            // unless the agent is actively driving.
            this.agentController?.onFrame();
            this.processInputs();
            this.interpolateEntities();
            this.incompleteEntities();
            // Render the player (and camera, which follows it) at the smoothed position:
            // truth + the decaying error offset. entity.location stays the authoritative/predicted
            // truth so the next frame's prediction and reconciliation are unaffected; we offset
            // only for the render/camera pass and restore truth immediately after.
            const player = this.clientGameLogic.playerEntity;
            const offset = this.playerPositionError;
            const hasOffset = offset.x !== 0 || offset.y !== 0;
            if (hasOffset) {
                const truthX = player.location.x;
                const truthY = player.location.y;
                player.location.x = truthX + offset.x;
                player.location.y = truthY + offset.y;
                this.clientGameLogic.clientRenderer.updatePlayerLocation(player);
                this.renderWorld();
                player.location.x = truthX;
                player.location.y = truthY;
            } else this.renderWorld();
            this.clientGameLogic.cleanup();
        };
        this.send = (payload, payloadType)=>{
            this.ws.send(JSON.stringify({
                recv_ts: Date.now(),
                payloadType: payloadType,
                payload: payload
            }));
        };
        this.register = (username, password, email)=>{
            this.send({
                username: username,
                password: password,
                email: email
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_upgradeGuest);
        };
        this.login = (username, password)=>{
            this.send({
                username: username,
                password: password
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_login);
        };
        this.logActivity = (activity)=>{
            this.send({
                activity: activity
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_logActivity);
        };
        this.submitFeedback = (feedback)=>{
            this.send({
                feedback: feedback
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_submitFeedback);
        };
        this.handleGuest = (userAgent)=>{
            this.clientGameLogic.clientRenderer.gui().getIntro().init((playerName, password)=>{
                if (!password) this.connectImpl("", undefined, true, ()=>{
                    this.send({
                        playerName: playerName,
                        userAgent: userAgent
                    }, "guest");
                });
                else this.connectImpl("", undefined, true, ()=>{
                    this.login(playerName, password);
                });
            });
        };
        this.invokeStatUpgradeUI = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showStatUpgradeUI);
        };
        this.entityClicked = (entity)=>{
            this.send({
                entityId: entity.entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityClicked);
        };
        this.emitPlayerEvent = (playerEvent)=>{
            this.send(playerEvent, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_playerEvent);
        };
        // `location` is the fine world coordinate the player chose for orders that need a place as well
        // as an order -- "Hold Position" is the one that does. Sent as two flat numbers rather than a
        // nested object: this context is spread straight into a MARKER_EVENT and read by @when
        // conditions, and flat scalars are what every other field on this channel already is.
        // A name typed into the name prompt, for the entity it was opened over. The server hands it to
        // that entity's own script (which is what decides whether this player may name it) and cleans
        // the string on the way in -- the cap here only keeps the field honest.
        this.sendEntityName = (targetEntityId, name)=>{
            this.emitPlayerEvent({
                playerEventType: "RENAME_ENTITY",
                context: {
                    targetEntityId: targetEntityId,
                    name: name
                }
            });
        };
        this.sendCommandWheelSelection = (command, npcType, targetEntityId, location)=>{
            this.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: command,
                    npcType: npcType,
                    source: "command_wheel",
                    targetEntityId: // Present only for the per-entity wheel; the server scopes the MARKER_EVENT to this
                    // NPC when set, otherwise the command broadcasts to the whole role.
                    targetEntityId,
                    ...location ? {
                        locationX: Math.round(location.x),
                        locationY: Math.round(location.y)
                    } : {}
                }
            });
        };
        // The player's answer to the first-run tutorial invitation: "accept" or "skip", and whether
        // they clicked it or let the countdown run out. Rides the generic player-event channel, which
        // the server turns into a room-wide MARKER_EVENT that ember-tutorial.js listens for.
        this.sendEmberTutorialCommand = (command, reason = "click")=>{
            this.emitPlayerEvent({
                playerEventType: "EMBER_TUTORIAL_COMMAND",
                context: {
                    command: command,
                    reason: reason
                }
            });
        };
        // The player pressed "Next" on a held speech bubble (see AvatarHud.spoke), so the speaker may go
        // on. Rides the generic player-event channel, which the server turns into a room-wide
        // MARKER_EVENT; a script that paces a conversation off these (ember-tutorial.js) then speaks at
        // the player's reading speed rather than its own clock.
        this.sendSpeechDismissed = (speakerEntityId, holdId)=>{
            this.emitPlayerEvent({
                playerEventType: "SPEECH_DISMISSED",
                context: {
                    speakerEntityId: speakerEntityId,
                    holdId: holdId
                }
            });
        };
        // A button on the ember end-of-run summary panel ("retry"). Rides the generic player-event
        // channel, which the server turns into a room-wide MARKER_EVENT the ember controller listens for.
        this.sendEmberRunCommand = (command)=>{
            this.emitPlayerEvent({
                playerEventType: "EMBER_RUN_COMMAND",
                context: {
                    command: command
                }
            });
        };
        // The invasion handshake's four presses, all on the generic player-event channel (which the
        // server turns into a room-wide MARKER_EVENT) exactly like sendEmberRunCommand -- so none of
        // them needs a protocol number of its own:
        //   seek    -- "Resurrect as Undead!" on the end-of-run panel. A nudge for a fresher offer; the
        //              picker does NOT wait on it, because the client already holds the list.
        //   join    -- a card was picked. `entityId` is the DEFENDING player, which is how a pick names
        //              the camp it means (a room is not addressable from a client).
        //   cancel  -- the picker was dismissed.
        //   release -- "Let go" while wearing one of another camp's attackers.
        this.sendEmberInvasionCommand = (command, entityId)=>{
            this.emitPlayerEvent({
                playerEventType: "EMBER_INVASION_COMMAND",
                context: {
                    command: command,
                    entityId: entityId
                }
            });
        };
        this.startAttack = (entityId)=>{
            this.send({
                entityId: entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_startAttack);
        };
        this.inventoryAction = (entityId, itemId, action)=>{
            this.send({
                entityId: entityId,
                itemId: itemId,
                action: action
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_inventoryAction);
        };
        this.activateWorldPoint = (roomFinePoint, options)=>{
            this.send({
                roomFinePoint: roomFinePoint,
                options: options
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_activateWorldPoint);
        };
        this.commitWorldEdits = (roughCoordinate)=>{
            this.send({
                roughCoordinate: roughCoordinate
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_commitWorldEdits);
        };
        this.getBuildingTilePreview = (roughCoordinate)=>{
            this.send({
                roughCoordinate: roughCoordinate
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_getBuildingTilePreview);
        };
        this.requestEntityDetail = (entityIds)=>{
            this.send({
                entityIds: entityIds
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestEntityDetail);
        };
        // Follow-cam: ask the server to sync this entity + its neighbors in full detail every tick
        // (pass null to stop). Drives the picture-in-picture view opened from the ember roster.
        // Ask the server to pull another online player into this player's ember camp. Nothing is checked
        // here: whether the invite is allowed, and where the guest lands, are the server's to decide (see
        // the EMBER_PLAYERS campaign).
        this.inviteEmberPlayer = (entityId)=>{
            this.send({
                entityId: entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_inviteEmberPlayer);
        };
        // The invited player's answer to an invitation. Only an accepted one moves them, and it is the
        // server that moves them -- see the EMBER_PLAYERS campaign.
        this.answerEmberInvite = (entityId, accepted)=>{
            this.send({
                entityId: entityId,
                accepted: accepted
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_answerEmberInvite);
        };
        this.setFocusEntity = (entityId)=>{
            this.send({
                entityId: entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_setFocusEntity);
        };
        this.requestWorldMap = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestWorldMap);
        };
        this.worldMapClicked = (coordinate)=>{
            this.send({
                coordinate: coordinate
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_worldMapClicked);
        };
        this.requestVisibility = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestVisibility);
        };
        this.itemPickupAction = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestItemPickup);
        };
        this.saveAppearance = (appearance, inventory)=>{
            this.send({
                appearance: appearance,
                inventory: inventory
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_saveAppearance);
        };
        this.finalizeCharacter = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_finalizeCharacter);
        };
        this.requestPlayerLocations = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestPlayerLocations);
        };
        this.onDialogClose = ()=>{
            this.emitPlayerEvent({
                playerEventType: "DIALOG_CLOSE",
                context: {}
            });
        };
        this.entityTileStrike = (location)=>{
            this.send({
                location: location
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityTileStrikeAt);
        };
        // Shadow performance debugging methods
        this.getShadowPerformanceMetrics = ()=>{
            return this.clientGameLogic.getShadowPerformanceMetrics();
        };
        this.forceShadowTextureUpdate = ()=>{
            this.clientGameLogic.forceShadowTextureUpdate();
        };
        this.clientGameLogic = clientGameLogic;
        this.clientGameLogic.entityManager.registerRemoveListener((entity)=>{
            this.interpolatable.delete(entity.entityId);
            this.renderSmoothing.delete(entity.entityId);
        });
        this.agentController = new (0, $b9d4ad6eac1471db$export$433d8951d222f317)(this);
    }
    static{
        // Keys that mean something to the chat input even though they type no character. Anything
        // else with a multi-character name is a modifier or a function key and never reaches the line.
        this.CHAT_EDIT_KEYS = [
            "Backspace",
            "Delete",
            "Escape",
            "Home",
            "End",
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight"
        ];
    }
    connect(playerName, accessToken, guest) {
        if (guest) {
            const userAgent = navigator?.userAgent;
            this.handleGuest(userAgent);
        } else {
            // No login screen on this path, so there is no Play button to expand from -- take the
            // next tap instead. handleGuest's intro hangs it off Play/Log in itself.
            (0, $0f29b5a53cc88186$export$48ce62c637877209)();
            this.connectImpl(playerName, accessToken, false);
        }
    }
    /**
     * Headless/testing entry point: drive the REAL client protocol over an injected,
     * WebSocket-shaped transport (e.g. an in-memory loopback) instead of a browser socket.
     * Reuses the exact onmessage handshake/netcode; only socket construction and DOM
     * redirects are bypassed. Not used in the browser.
     */ connectHeadless(ws, auth) {
        this.injectedSocket = ws;
        if (auth.mode === "login") {
            this.loginCredentials = {
                username: auth.username,
                password: auth.password
            };
            this.connectImpl("", undefined, false);
        } else if (auth.mode === "guest") {
            // Mirror handleGuest: the browser's guest flow sends the "guest" payload from
            // ws.onopen (the intro screen supplies the name). Without that onConnect the only
            // thing this mode ever sent was "initializeGuest", which the server does not act
            // on, so a headless guest never actually joined.
            const userAgent = navigator?.userAgent;
            const playerName = auth.playerName;
            this.connectImpl("", undefined, true, ()=>{
                this.send({
                    playerName: playerName,
                    userAgent: userAgent
                }, "guest");
            });
        } else this.connectImpl(auth.playerName, undefined, false);
    }
    connectImpl(playerName, accessToken, guest, onConnect) {
        // What a redial means: the same door, the same credentials. Recorded here rather than
        // threaded through every caller, so the lifecycle and the disconnected panel can both ask
        // for one without knowing how this client got connected in the first place.
        this.redial = ()=>this.connectImpl(playerName, accessToken, guest, onConnect);
        const hostname = document.location.hostname;
        const config = (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)();
        // Both the dev-vs-production split and the ws:// vs wss:// choice now live in
        // runtime_config, because the shell is served from "localhost" too and a hostname test
        // here cannot tell it apart from a laptop.
        const isLocal = !config.isNative && (hostname === "localhost" || hostname.startsWith("10.0"));
        const ws = this.injectedSocket ? this.injectedSocket : new WebSocket(config.apiHost);
        if (isLocal && !this.injectedSocket) (0, $789f2cfb0ccfe259$export$1e138c080884cecd)(ws);
        const redirectToPortal = ()=>{
            if (accessToken) {
                if (isLocal) window.location.href = "http://localhost:3000/account/login";
                else window.location.href = "https://projectsamsara.com/?guest=true";
            } else {
                if (!isLocal) alert("The server might be down, please try again in a few minutes.");
                window.location.href = "/";
            }
        };
        // Where a lost socket leaves the player. A desktop browser can send them back to the
        // portal, which is a real place with a real login. The shell cannot: its origin IS the app
        // bundle, so "/" reloads the app and an alert() freezes the WebView behind a modal that
        // dismisses into nothing. And on a phone generally, answering "the wifi blinked" by
        // discarding the session and reloading is hostile. Both get a panel with a retry instead.
        const offerRetryRatherThanRedirect = config.isNative || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)();
        const connectionLost = ()=>{
            // Not lost: ENDED, by the server, for a reason the player has already been given. Its
            // panel is up and there is nothing to retry.
            if (this.sessionEndReason) return;
            // A connection we HAD and lost is a different situation from one we never made, and
            // navigating away is only ever right for the second. The server destroys the player --
            // and with them their ember camp -- the moment a socket closes, so a reload spends a
            // run that a reconnect in place would have let the player start again from the panel.
            // A first connection that never opened is still the portal's business: an expired
            // access token looks exactly like this, and the portal is where a new one comes from.
            if (this.everConnected) {
                (0, $69f7ea6451029ed5$export$5f7f27f369ebe35d)({
                    everConnected: true,
                    onRetry: ()=>{
                        // The lifecycle owns dialling, so that a press and a pending backoff
                        // cannot both fire. It only exists in the browser.
                        if (this.lifecycle) this.lifecycle.retryNow();
                        else this.redialNow();
                    }
                });
                return;
            }
            if (offerRetryRatherThanRedirect) {
                (0, $69f7ea6451029ed5$export$5f7f27f369ebe35d)({
                    everConnected: false,
                    // Dial the same way, with the same credentials. The panel stays up until a
                    // socket actually opens, so a failed retry needs no handling of its own.
                    onRetry: ()=>this.connectImpl(playerName, accessToken, guest, onConnect)
                });
                return;
            }
            redirectToPortal();
        };
        // Only the socket this client is currently holding gets to report anything. A socket
        // replaced because it went silent (see redialNow) is not necessarily dead, and its events
        // arriving late would otherwise tear down the connection that replaced it.
        const isCurrent = ()=>this.ws === ws;
        this.ws = ws;
        ws.onopen = ()=>{
            if (!isCurrent()) return;
            (0, $5UG8I.logger).info({
                tags: [
                    "websocket",
                    "connection"
                ]
            }, "Connected");
            this.everConnected = true;
            // Covers the first connection as well as a retry: if the panel is not up, this is a
            // no-op.
            (0, $69f7ea6451029ed5$export$b6aef85896caf7b2)();
            this.lifecycle?.noteConnected();
            if (onConnect) onConnect();
        };
        ws.onerror = (e)=>(0, $5UG8I.logger).error({
                tags: [
                    "websocket",
                    "error"
                ]
            }, JSON.stringify(e));
        ws.onclose = ()=>{
            if (!isCurrent()) return;
            // Headless/test sockets have no browser portal to redirect to, and no document to put
            // a panel in.
            if (!this.injectedSocket) {
                this.lifecycle?.noteConnectionLost();
                connectionLost();
            }
        };
        // One lifecycle for the whole session, however many sockets it gets through. Not in
        // headless mode: there is no page to hide and no socket to replace.
        if (!this.injectedSocket && !this.lifecycle) {
            this.lifecycle = new (0, $06a32a8a2cf2cac8$export$5be6ec909ad606e6)(this.lifecycleDelegate());
            this.lifecycle.start();
        }
        const userAgent = navigator?.userAgent;
        ws.onmessage = (message)=>{
            if (!isCurrent()) return;
            // Anything at all arriving is the only proof this socket is alive -- a resumed WebView
            // holds one that reports OPEN forever and delivers nothing.
            this.lifecycle?.noteTraffic();
            const parsedMessage = JSON.parse(message.data);
            const { payloadType: payloadType, payload: payload } = parsedMessage;
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_startSession) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "session"
                    ]
                }, "Received start session");
                if (this.loginCredentials) // Headless/test login: authenticate an existing account by username/password.
                this.login(this.loginCredentials.username, this.loginCredentials.password);
                else if (guest) this.send({
                    userAgent: userAgent
                }, "initializeGuest");
                else if (accessToken) {
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "websocket",
                            "auth"
                        ]
                    }, "Sent access token");
                    this.send({
                        accessToken: accessToken,
                        userAgent: userAgent
                    }, "accessToken");
                } else {
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "websocket",
                            "auth"
                        ]
                    }, "Sent playername", playerName);
                    this.send({
                        playerName: playerName,
                        userAgent: userAgent
                    }, "name");
                }
                return;
            }
            // The server is ending this session on purpose, and said so before closing. The close
            // that follows must NOT be answered with a redial: it is not a dropped connection, and
            // dialling back in would take the account off whoever claimed it.
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sessionEnded) {
                this.handleSessionEnded(payload?.reason);
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_setEntityId) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "entity"
                    ]
                }, "Received entityId; guest:", guest === true);
                const { entityId: entityId } = payload;
                this.clientGameLogic.initializePlayer(entityId, this, guest === true);
                if (guest) this.clientGameLogic.clientRenderer.gui().getIntro().loginSuccess();
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updatePlayerEntityId) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "entity"
                    ]
                }, "Received update entityId");
                const { entityId: entityId } = payload;
                this.clientGameLogic.updatePlayerEntityId(entityId);
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_destroyEntityId) {
                const { entityId: entityId, roomId: roomId } = payload;
                if (this.clientGameLogic.playerEntity?.roomId === roomId) this.clientGameLogic.scheduleForDestruction(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_ping) {
                const { entityId: entityId, creationTs: creationTs } = payload;
                this.send({
                    creationTs: creationTs,
                    entityId: entityId
                }, "pong");
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendPleaseWait) this.clientGameLogic.pleaseWait();
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fragmentAnimation) {
                const { spriteId: spriteId, location: location } = payload;
                this.clientGameLogic.clientRenderer.entity().fragment(spriteId, location);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_struckEntityId) {
                const { entityId: entityId, strikerEntityId: strikerEntityId } = payload;
                this.clientGameLogic.doStruck(entityId, strikerEntityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityTileEffect) {
                const { effect: effect } = payload;
                this.clientGameLogic.tileEffect(effect);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_detonate) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.detonate(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_attack) {
                const { entityId: entityId } = payload;
                // Add callback for weapon attack effects
                this.clientGameLogic.attack(entityId, ()=>{
                    // Callback for attack completion - can be used for weapon effects
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Server-triggered attack completed for entity ${entityId}`);
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_playAttackAnimation) {
                // Cosmetic swing (e.g. another player placing a build tile). Play ONLY the sprite
                // animation -- not clientGameLogic.attack, which would also fire startAttack + audio.
                const { entityId: entityId } = payload;
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (entity) this.clientGameLogic.clientRenderer.entity().attack(entity);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateActivation) {
                const { entityId: entityId, active: active } = payload;
                this.clientGameLogic.updateActivation(entityId, active);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_orientation) {
                const { orientation: orientation } = payload;
                this.clientGameLogic.orientation(orientation);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_killed) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.killed(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_respawned) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.respawned(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendTeleported) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.teleported(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityEmp) {
                const { entityId: entityId, range: range } = payload;
                this.clientGameLogic.emp(entityId, range);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entitySparkle) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.sparkle(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fadeInOut) {
                const { direction: direction } = payload;
                // this is a hack; we do this so that the
                // map renderer is in charge of the "in" fade in after it does all its work
                if (direction === "out") this.clientGameLogic.fadeInOut(direction);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_worldState) {
                const message = payload;
                // Carry the server's own send timestamp through to interpolation, and update the
                // clock estimate from it HERE rather than in processServerMessages: the offset is
                // only meaningful against the moment the frame landed, not the moment the next
                // frame got round to draining the queue.
                message.serverTs = parsedMessage.recv_ts;
                this.observeServerClock(parsedMessage.recv_ts);
                this.enqueueWorldState(message);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityDisconnected) {
                const { entityId: entityId } = payload;
                (0, $5UG8I.logger).info({
                    tags: [
                        "websocket",
                        "disconnect"
                    ]
                }, "disconnect", entityId);
                this.clientGameLogic.scheduleForDestruction(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_screenMessage) {
                const { message: message } = payload;
                if (message) this.clientGameLogic.clientRenderer.gui().addScreenMessage(message);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_chatMessage) {
                const { message: message, originEntityName: originEntityName, originEntityId: originEntityId, hold: hold, holdId: holdId } = payload;
                this.clientGameLogic.handleChat(message, originEntityId, originEntityName, hold, holdId);
                this.agentController?.noteChat(originEntityName || originEntityId || "?", message);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_roomAmbience) {
                const { ambience: ambience } = payload;
                if (ambience) this.clientGameLogic.setRoomAmbience(ambience);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_factionTracking) {
                const { config: config } = payload;
                if (config) this.clientGameLogic.setFactionTracking(config);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_redrawClient) // Incremental repaint of just the delta-changed cells (falls back to a full rerender
            // internally if a tilemap-layer cell changed). Replaces the old full map().rerender().
            this.clientGameLogic.clientRenderer.map().onRedraw();
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_hideRoomName) {
                const { hidden: hidden, roomName: roomName } = payload;
                this.clientGameLogic.hideRoomName(hidden);
                if (!hidden && roomName) this.clientGameLogic.updateLocation(roomName);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendUpdateLocation) {
                const { location: location, roomId: roomId } = payload;
                this.clientGameLogic.updateLocation(location, roomId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_createLocalEntity) {
                const { entity: entity } = payload;
                this.clientGameLogic.createLocalEntity(entity);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_destroyLocalEntity) {
                const { flags: flags } = payload;
                this.clientGameLogic.destroyLocalEntity(flags);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_soundEffect) {
                const { effect: effect, loop: loop, target: target } = payload;
                this.clientGameLogic.playSoundEffect(effect, loop, target);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendAnimateLocalEntityCollection) {
                const { entityId: entityId, target: target, position: position } = payload;
                this.clientGameLogic.animateLocalEntityCollection(entityId, target, position);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_animateAbility) {
                const { abilityType: abilityType, duration: duration } = payload;
                this.clientGameLogic.animateAbility(abilityType, duration);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_upgradeGuest) this.clientGameLogic.upgradedAccount();
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_dayPhase) {
                const { dayPhase: dayPhase, dayPct: dayPct } = payload;
                this.clientGameLogic.updateDayPhase(dayPhase);
                this.clientGameLogic.clientRenderer.gui().updateDayPct(dayPct);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestEntityDetail) {
                const { messages: messages } = payload;
                if (messages) {
                    const now = Date.now();
                    messages.forEach((message)=>{
                        const entity = this.clientGameLogic.getEntity(message.entityId);
                        if (entity) {
                            this.updateEntityFromMessage(message, entity, now);
                            this.clientGameLogic.clearIncompleteEntities([
                                entity.entityId
                            ]);
                        }
                    });
                }
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_login) {
                const { entityId: entityId } = payload;
                if (entityId) {
                    this.clientGameLogic.clientRenderer.gui().getIntro().loginSuccess();
                    this.clientGameLogic.initializePlayer(entityId, this, false);
                    this.clientGameLogic.clientRenderer.gui().addScreenMessage({
                        target: "important",
                        text: "Welcome back!",
                        delay: 1000
                    });
                } else {
                    // The intro shows the failure under the password field and keeps what was
                    // typed; only fall back to the screen-wide banner if it could not.
                    const shownInline = this.clientGameLogic.clientRenderer.gui().getIntro().loginFailed();
                    if (!shownInline) this.clientGameLogic.clientRenderer.gui().addScreenMessage({
                        target: "important",
                        text: "Invalid player name or password."
                    });
                }
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_mapDelta) {
                const deltas = payload.delta;
                this.clientGameLogic.clientRenderer.map().queueMapDelta(deltas);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateSquadState) {
                const { squadState: squadState } = payload;
                this.clientGameLogic.clientRenderer.gui().updateSquadState(squadState);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberRoster) {
                const { roster: roster } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberRoster(roster || []);
                this.clientGameLogic.setEmberRoster(roster || []);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberMinimap) {
                const { minimap: minimap } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberMinimap(minimap || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberPlayers) {
                const { players: players } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberPlayers(players || []);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberInvite) {
                const { invite: invite } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberInvite(invite || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEntityInteractions) {
                const { entityId: entityId, interactions: interactions } = payload;
                this.clientGameLogic.clientRenderer.entity().updateEntityInteractions(entityId, interactions);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_openCommandWheel) {
                const { entityId: entityId, role: role } = payload;
                this.clientGameLogic.clientRenderer.gui().showCommandWheel({
                    targetEntityId: entityId,
                    role: role
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_openRolePicker) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.clientRenderer.gui().showRolePicker(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_openNamePrompt) {
                const { entityId: entityId, name: name } = payload;
                this.clientGameLogic.clientRenderer.gui().showNamePrompt(entityId, name);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showRunSummary) {
                const { summary: summary } = payload;
                this.clientGameLogic.clientRenderer.gui().showRunSummary(summary);
            }
            // Which camps a fallen player could rise in. An interval FEED (~2s) rather than a reply
            // to a press, so the scorecard's "Resurrect as Undead!" button lights up by itself when
            // one opens, and an open picker gains and loses cards as it is read. An empty list is a
            // real answer ("no camp is open to the dead"); null forgets the offer.
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateInvasionOffer) {
                const { candidates: candidates } = payload;
                this.clientGameLogic.clientRenderer.gui().updateInvasionOffer(candidates || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showTutorialPrompt) {
                const { prompt: prompt } = payload;
                this.clientGameLogic.clientRenderer.gui().showTutorialPrompt(prompt || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEntityPointerIcon) {
                const { entityId: entityId, show: show, angle: angle } = payload;
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (entity) this.clientGameLogic.clientRenderer.entity().updateEntityPointerIcon(entity, show, angle);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_buildCharacter) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.clientRenderer.gui().buildCharacter(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_itemPickedUp) {
                const { entityId: entityId, itemTypeMeta: itemTypeMeta, quantity: quantity } = payload;
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (entity) this.clientGameLogic.itemPickup(entity, itemTypeMeta, quantity);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showTutorial) {
                // A null tutorialType is the server taking the ember clues back down (see
                // client_proxy.showTutorial); timeoutMs is how long a raised clue holds.
                const { tutorialType: tutorialType, timeoutMs: timeoutMs } = payload;
                this.clientGameLogic.clientRenderer.gui().showTutorial(tutorialType || null, timeoutMs);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_builderAction) {
                const { active: active } = payload;
                this.clientGameLogic.playerController.builderActivation(active);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendWorldMap) {
                const { map: map } = payload;
                this.clientGameLogic.clientRenderer.gui().showWorldMap(map);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_removeLocationIcon) this.clientGameLogic.clientRenderer.map().removeLocationIcon(payload.iconId);
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_addLocationIcon) this.clientGameLogic.clientRenderer.entity().updateLocationIcons(payload.icon);
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updatePlayerBiomeColorMap) {
                const points = payload.meta?.points || [];
                const icons = payload.meta?.icons || [];
                const clear = payload?.meta?.clear === true;
                if (clear) {
                    const biomeColorMap = this.clientGameLogic.tilemapMetaProvider?.biomeColorMap;
                    if (biomeColorMap) {
                        for(let x = 0; x < biomeColorMap.length; x++)for(let y = 0; y < biomeColorMap[0].length; y++)biomeColorMap[x][y] = 0;
                        this.clientGameLogic.clientRenderer.map().updateMinimap(this.clientGameLogic.tilemapMetaProvider);
                    }
                }
                points.forEach((point)=>{
                    if (this.clientGameLogic.tilemapMetaProvider && this.clientGameLogic.tilemapMetaProvider.minimapConfig?.biomeBased && this.clientGameLogic.tilemapMetaProvider.biomeColorMap) this.clientGameLogic.tilemapMetaProvider.biomeColorMap[point.biomeCoordinate.x][point.biomeCoordinate.y] = point.color;
                    this.clientGameLogic.clientRenderer.map().updateBiomeColorMap(point.biomeCoordinate, point.color);
                });
                icons.forEach((icon)=>{
                    if (this.clientGameLogic.tilemapMetaProvider) {
                        if (!this.clientGameLogic.tilemapMetaProvider.locationIcons.find((next)=>next.x === icon.x && next.y === icon.y)) this.clientGameLogic.tilemapMetaProvider.locationIcons.push(icon);
                    }
                    this.clientGameLogic.clientRenderer.entity().updateLocationIcons(icon);
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_pulseInventoryItem) {
                const { itemId: itemId } = payload;
                this.clientGameLogic.clientRenderer.gui().pulseInventoryItem(itemId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityFeedback) {
                const { entityId: entityId, image: image, label: label, params: params } = payload;
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (entity) this.clientGameLogic.clientRenderer.entity().feedback(entity, image, label, params);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendVisibility) {
                const { visibility: visibility } = payload;
                const currentVisibility = this.clientGameLogic.clientRenderer.map().getVisibility();
                this.clientGameLogic.clientRenderer.map().update(null, {
                    ...currentVisibility || {},
                    ...visibility
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_locationIconEffect) {
                const { locationId: locationId, expires: expires } = payload;
                this.clientGameLogic.clientRenderer.entity().pulseLocation(locationId, expires);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateAudio) {
                const { volume: volume } = payload;
                this.clientGameLogic.audio.setVolume(volume);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendBuildingTilePreview) {
                if (payload.tooFar) this.clientGameLogic.playerController.clearTerrainPointer();
                else this.clientGameLogic.playerController.updateTerrainPointer(payload.deltas);
            }
        };
    }
}





class $7b78839962f6da5d$export$c7b7134fd828a5 {
    constructor(entityTypes){
        this.entities = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
        this.entityTypes = [];
        this.setEventListeners = new Set();
        this.removeEventListeners = new Set();
        this.nextCounter = 0;
        this.clear = ()=>{
            this.entities.clear();
            this.entitiesByType = this.initEntitiesByType();
        };
        this.initEntitiesByType = ()=>{
            return this.entityTypes.reduce((acc, next)=>{
                const players = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
                return {
                    ...acc,
                    [next]: players
                };
            }, {});
        };
        this.size = (entityType, predicate)=>{
            if (entityType) {
                const set = this.entitiesByType[entityType];
                if (!predicate) return set.size();
                return set.filter(predicate).length;
            }
            if (!predicate) return this.entities.size();
            else return this.entities.filter(predicate).length;
        };
        this.get = (entityId)=>{
            if (!entityId) return undefined;
            return this.entities.get(entityId);
        };
        this.contains = (entityId, entityType)=>{
            if (!entityType) return !!this.get(entityId);
            return !!this.entitiesByType[entityType]?.get(entityId);
        };
        this.getAtIdx = (idx, entityType)=>{
            if (entityType) return this.entitiesByType[entityType].getAtIdx(idx);
            return this.entities.getAtIdx(idx);
        };
        this.set = (entity, unshift, context)=>{
            const existed = this.entities.has(entity.entityId);
            this.entities.set(entity.entityId, entity, unshift);
            this.entitiesByType[entity.entityType].set(entity.entityId, entity, unshift);
            this.setEventListeners.forEach((next)=>next(entity, context, existed));
            entity.lastUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        };
        this.remove = (entityId, context)=>{
            // remove it from all types
            this.entityTypes.forEach((next)=>this.entitiesByType[next].remove(entityId));
            const entity = this.entities.remove(entityId);
            if (entity) this.removeEventListeners.forEach((next)=>next(entity, context));
        };
        this.count = (entityType)=>this.entitiesByType?.[entityType]?.size() || 0;
        this.iterate = (entityType, visitor, predicate)=>{
            if (entityType) {
                if (Array.isArray(entityType)) entityType.forEach((nextType)=>this.entitiesByType[nextType]?.iterate(visitor, predicate));
                else this.entitiesByType[entityType]?.iterate(visitor, predicate);
            } else this.entities.iterate(visitor, predicate);
        };
        this.next = ()=>{
            this.nextCounter++;
            if (this.nextCounter > this.entities.size()) this.nextCounter = 0;
            // console.log(this.nextCounter)
            return this.getAtIdx(this.nextCounter);
        };
        this.collect = (predicate)=>this.entities.collect(predicate);
        this.find = (predicate, entityType)=>{
            if (entityType) return this.entitiesByType[entityType]?.find(predicate);
            return this.entities.find(predicate);
        };
        this.registerSetListener = (listener)=>{
            this.setEventListeners.add(listener);
        };
        this.unregisterSetListener = (listener)=>{
            this.setEventListeners.delete(listener);
        };
        this.registerRemoveListener = (listener)=>{
            this.removeEventListeners.add(listener);
        };
        this.unregisterRemoveListener = (listener)=>{
            this.removeEventListeners.delete(listener);
        };
        this.entityTypes = entityTypes;
        this.entitiesByType = this.initEntitiesByType();
    }
}







const $66e35324756c76b6$export$b4792961ac683a30 = (weapon, originLocation, originMovement)=>{
    const characteristics = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weapon?.weaponType || "none"];
    if (!characteristics) return [];
    const originLocationToUse = {
        ...originLocation
    };
    if (characteristics.muzzleFireOffset) {
        const speed2X = characteristics.muzzleFireOffset * Math.cos(originMovement.angle);
        const speed2Y = characteristics.muzzleFireOffset * Math.sin(originMovement.angle);
        originLocationToUse.x += speed2X;
        originLocationToUse.y += speed2Y;
    }
    if (characteristics.maxParticles === 1) {
        const bullet = $66e35324756c76b6$export$2f6172ad7e10238b(weapon, originLocationToUse, originMovement);
        bullet.spriteId = characteristics.bulletSpriteId;
        bullet.flags.originWeaponType = weapon?.weaponType || "none";
        return bullet ? [
            bullet
        ] : [];
    }
    const bullets = [];
    const originAngle = originMovement.angle;
    const bulletBatch = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
    const particles = characteristics.maxParticles;
    for(let i = -(particles / 2); i < particles - particles / 2; i++){
        let degrees = (0, $a80d0b17b615d6f7$export$32b1497b7aadef08)(originAngle) + 15 + i * 30;
        const bullet = $66e35324756c76b6$export$2f6172ad7e10238b(weapon, originLocationToUse, {
            ...originMovement,
            angle: (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(degrees)
        });
        if (bullet) {
            bullet.flags.originWeaponType = weapon?.weaponType || "none";
            bullet.spriteId = characteristics.bulletSpriteId;
            bullet.context = {
                bullet: {
                    batchId: bulletBatch
                }
            };
            bullets.push(bullet);
        }
    }
    return bullets;
};
const $66e35324756c76b6$export$2f6172ad7e10238b = (weapon, originLocation, originMovement)=>{
    if (!originLocation || !originMovement) return;
    const characteristics = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weapon?.weaponType || "none"];
    if (!characteristics) return;
    const bullet = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
    bullet.maxDistance = characteristics.maxDistance;
    bullet.entityType = "bullet";
    bullet.origin = {
        x: originLocation.x + Math.cos(originMovement.angle),
        y: originLocation.y + Math.sin(originMovement.angle)
    };
    bullet.location = {
        x: bullet.origin?.x,
        y: bullet.origin?.y
    };
    bullet.movement = {
        ...originMovement
    };
    bullet.dimensions = characteristics.collisionDimensions || {
        ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)[bullet.entityType]
    };
    bullet.speed = characteristics.bulletSpeed;
    bullet.speed2.x = Math.cos(originMovement.angle) * characteristics.bulletSpeed;
    bullet.speed2.y = Math.sin(originMovement.angle) * characteristics.bulletSpeed;
    bullet.roomId = originLocation.roomId;
    bullet.flags = {};
    return bullet;
};





class $dec24d361621cd9a$export$8456fdc59dbd1ef9 extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $dec24d361621cd9a$export$8456fdc59dbd1ef9();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: []
        };
    }
    clear(item) {
        item.data.length = 0;
    }
    // Convenience method to get a fresh array
    checkoutArray() {
        return this.checkout();
    }
}




class $93a024e1e74df758$export$c8df09a865c1d736 {
    constructor(roomId, tilesets, tileMapDirectory, worldMetaDimensions){
        this.lastEditedTs = 0;
        // Bumped by touchTileTypes() on EVERY write to tileTypesMap. Consumers that derive
        // something from the tile grid (the A* collision matrix, see tiledCollisionBuilder)
        // cache against this.
        //
        // It exists because neither existing signal covers all the writes:
        //   - lastEditedTs is skipped by addTileAt's existing-delta branch, which returns
        //     early AFTER having mutated the set.
        //   - the add/remove delta listeners only fire when `broadcast` is true, so every
        //     broadcast:false edit is invisible to them.
        // Bump adjacent to the mutation, never at the end of a method, so no early return
        // can get between the two.
        this.collisionVersion = 0;
        this.removeEventListeners = new Set();
        this.addEventListeners = new Set();
        this.compositeTileMetaLookup = {};
        this.tilesetsById = {};
        this.resolveCompositeTileIdTileMeta = (compositeTileId, tilesetId)=>{
            return this.compositeTileMetaLookup[`${tilesetId}-${compositeTileId}`];
        };
        this.getTilesetById = (tilesetId)=>{
            return this.tilesetsById[tilesetId];
        };
        this.resolveTileSet = (tileId)=>{
            // tileId: 505
            // tileset 3: gid 1025
            //  505 >= 1025 ? no
            // tileset 2: gid 500
            //  505 >= 500 ? yes
            // ====== tileset 2
            // tileset 1: gid 1
            // tileId: 305
            // tileset 3: gid 1025
            //  305 >= 1025 ? no
            // tileset 2: gid 500
            //  305 >= 500 ? no
            // tileset 1: gid 1
            //  305 >= 1 ? no
            // ... must be first one, since we couldn't resolve any
            const id = Number(tileId);
            for(let i = 0; i < this.tilesets.length; i++){
                const tileset = this.tilesets[i];
                if (id >= tileset.firstGid) return tileset;
            }
            const first = this.tilesets[this.tilesets.length - 1];
            return first;
        };
        this.resolveTileMeta = (tileId)=>{
            if (!tileId) return (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            if (tileId.includes(":")) {
                const [tilesetId, id] = tileId.split(":");
                const tileset = this.tilesets.find((t)=>t.tilesetId == tilesetId);
                if (tileset) return tileset.tiles[Number(id)] || (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            }
            const id = Number(tileId);
            const tileset = this.resolveTileSet(tileId);
            if (!tileset) return (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            const { firstGid: firstGid } = tileset;
            const tilesetMemberId = `${id - firstGid + 1}`;
            return tileset.tiles[tilesetMemberId] || (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
        };
        this.resolveTilesetTileId = (tile)=>{
            const tileset = this.resolveTileSet(tile);
            const tileId = Number(tile);
            const adjustedTileId = tileId - tileset.firstGid + 1;
            return `${tileset.tilesetId}-${adjustedTileId}`;
        };
        this.toSerialiazeableMeta = ()=>{
            return {
                atlas: this.tilesets,
                tilemaps: this.tilemaps,
                minimapConfig: this.minimapConfig
            };
        };
        this.drawableTile = (tile)=>tile !== "0" && !!tile;
        this.removeableTile = (tile)=>{
            return this.resolveTileMeta(tile)?.malleable;
        };
        this.hasRemovedDelta = (x, y, tileId, layerId)=>{
            if (this.tilemaps.deltas) {
                const layerDeltas = this.tilemaps.deltas[layerId];
                if (!layerDeltas) return false;
                const delta = layerDeltas[`${x}-${y}`];
                if (!!delta?.removed && delta.tileId === tileId) return true;
            }
            return false;
        };
        this.shouldDrawTileAt = (x, y, layerId, tilemap)=>{
            const id = tilemap[x][y];
            if (!this.drawableTile(id)) return false;
            if (this.tilemaps.deltas) {
                const delta = this.getMapDeltaAt(x, y, layerId);
                if (!!delta?.removed && delta.tileId === id) return false;
            }
            return true;
        };
        this.getMapDeltas = ()=>{
            const deltas = [];
            Object.keys(this.tilemaps.deltas).forEach((layerId)=>{
                const deltaLayer = this.tilemaps.deltas[layerId];
                Object.values(deltaLayer).forEach((delta)=>{
                    deltas.push(delta);
                });
            });
            return deltas;
        };
        this.getSpriteMapDeltas = ()=>{
            const deltaArray = (0, $dec24d361621cd9a$export$8456fdc59dbd1ef9).instance.checkoutArray();
            // Iterate through all layers in the deltas
            Object.keys(this.tilemaps.deltas).forEach((layerId)=>{
                const layerMapping = this.resolveLayerMapping(layerId);
                // Only process sprite layers (sprited maptype)
                if (layerMapping?.maptype === "sprited") {
                    const layerDeltas = this.tilemaps.deltas[layerId];
                    Object.values(layerDeltas).forEach((delta)=>{
                        deltaArray.data.push(delta);
                    });
                }
            });
            return deltaArray;
        };
        this.getMapDeltaAt = (x, y, layerId)=>{
            return this.tilemaps.deltas[layerId]?.[`${x}-${y}`];
        };
        this.findMapDeltaAt = (x, y)=>{
            // Check all available layers for a map delta at the given coordinates
            const layerIds = Object.keys(this.tilemaps.deltas);
            for (const layerId of layerIds){
                const delta = this.getMapDeltaAt(x, y, layerId);
                if (delta) return delta;
            }
            return null;
        };
        this.setMapDeltas = (deltas, broadcast)=>{
            deltas.forEach((delta)=>{
                const { x: x, y: y, blocking: blocking, occlusion: occlusion, tileId: tileId, layerId: layerId, mapSpriteCap: mapSpriteCap, temporary: temporary, collideable: collideable, context: context } = delta;
                if (tileId) {
                    if (delta.removed) this.removeTileAt(x, y, delta.layerId, broadcast);
                    else this.addTileAt(x, y, blocking, occlusion, tileId, layerId, mapSpriteCap, temporary, collideable, context, broadcast);
                } else // update blocking
                this.updateBlockingAt(x, y, blocking, broadcast);
            });
        };
        this.visit = (callback)=>{
            this.layerIndexedMap.iterate((next)=>{
                if (next.layerClass.maptype === "tilemap") callback({
                    tilemap: next.tilemap,
                    layerId: next.entityId
                });
                if (next.layerClass.maptype === "sprited") callback({
                    tilemap: next.tilemap,
                    sprited: true,
                    mapSpriteCaps: this.tilemaps.mapSpriteCaps,
                    index: next.layerClass.idx + 1,
                    layerId: next.entityId
                });
            }, (n)=>n.layerClass.maptype === "tilemap" || n.layerClass.maptype === "sprited");
            if (this.tilemaps.spriteFragments?.length > 0) callback({
                spriteFragments: this.tilemaps.spriteFragments
            });
            this.layerIndexedMap.iterate((next)=>{
                callback({
                    tilemap: next.tilemap,
                    sky: true,
                    index: next.layerClass.idx + 1,
                    layerId: next.entityId
                });
            }, (n)=>n.layerClass.maptype === "sky");
        };
        this.isOcclusionAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            if (!_x[y]?.has("occlusion")) return false;
            return true;
        };
        // Version of the tile grid as far as collision is concerned. Changes whenever any
        // tileTypesMap cell changes; does NOT change when entities move (entity obstacles are
        // applied to the A* Grid after the matrix is built, never baked into it).
        this.getCollisionVersion = ()=>this.collisionVersion;
        // Deliberately bumped for ANY tile-type write, not just "blocking". isCollisionAt
        // reads only "blocking" today, but tying invalidation to that fact would silently
        // rot the moment it reads another type. Invalidation is rare, so the extra misses
        // cost nothing.
        this.touchTileTypes = ()=>{
            this.collisionVersion++;
        };
        this.isCollisionAt = (x, y, approacherFineX, approacherFineY, direction)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            if (!_x[y]?.has("blocking")) return false;
            // there is blocking
            // if there is no approach specified, then we're blocked no matter what
            if (approacherFineX === undefined || approacherFineY === undefined) return true;
            // special inspection
            let allowed = this.tileBlockingAllowed[x]?.[y];
            let notAllowed = this.tileBlockingNotAllowed[x]?.[y];
            if (allowed.size < 1) return true;
            const blockedLeft = (()=>{
                const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                const diff = xFine - approacherFineX;
                const dist = Math.abs(diff);
                if (allowed.has("Left")) {
                    if (direction === "Left") {
                        // console.log("dist", dist, Date.now())
                        if (dist < 20) return true;
                        else return false;
                    } else if (direction === "Right") {
                        if (diff > 0) return true;
                        else return false;
                    }
                }
                if (notAllowed.has("Left")) {
                    if (direction === "Left" && diff < -41) // console.log("[NOT ALLOWED LEFT] diff", diff)
                    return true;
                }
            })();
            const blockedDown = (()=>{
                if (allowed.has("Down")) {
                    const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                    const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                    const diff = yFine - approacherFineY;
                    const dist = Math.abs(diff);
                    // console.log("dir", dir)
                    if (direction === "Down") {
                        // console.log("dist down", dist, Date.now())
                        if (dist < 5) // console.log("(DOWN) blocked down")
                        return true;
                        else return false;
                    } else if (direction === "Up") {
                        // console.log("(DOWN) up diff", diff)
                        if (diff > -22) // console.log("(DOWN) blocked up")
                        return true;
                        else return false;
                    }
                }
            })();
            const blockedRight = (()=>{
                const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                const diff = xFine - approacherFineX;
                const dist = Math.abs(diff);
                if (allowed.has("Right")) {
                    // console.log("dir", dir)
                    if (direction === "Right") {
                        // console.log("dist", dist, Date.now(), "diff", diff)
                        if (diff < -7) return true;
                        else return false;
                    } else if (direction === "Left") {
                        // console.log("going left, diff", diff)
                        if (diff > -40) return true;
                        else return false;
                    }
                }
                if (notAllowed.has("Right")) {
                    if (direction === "Right" && diff < 3) // console.log("[NOT ALLOWED RIGHT] diff", diff)
                    return true;
                }
            })();
            const blockedUp = (()=>{
                if (allowed.has("Up")) {
                    const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                    const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                    const diff = yFine - approacherFineY;
                    const dist = Math.abs(diff);
                    // console.log("dir", dir)
                    if (direction === "Up") {
                        // console.log("dist up", dist, Date.now())
                        if (dist < 22) // console.log("(UP) blocked up")
                        return true;
                        else return false;
                    } else if (direction === "Down") {
                        // console.log("(UP) down diff", diff)
                        if (diff > -22) // console.log("(UP) blocked down")
                        return true;
                        else return false;
                    }
                }
            })();
            // console.log("default block")
            return blockedDown === true || blockedLeft === true || blockedRight === true || blockedUp === true;
        };
        this.isDeepAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            return _x[y]?.has("deep") && !_x[y]?.has("floor");
        };
        this.isSkyTileAt = (x, y)=>{
            if (!this.tilemaps.skyTrigger) return false;
            const _x = this.tilemaps.skyTrigger[x];
            if (!_x) return false;
            const hasSky = !!_x[y] && _x[y] !== "0";
            hasSky;
            return hasSky;
        };
        this.intersectionAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return "";
            if (!_x[y]) return "";
            if (_x[y]?.has("collideable")) return "collideable";
            if (_x[y]?.has("blocking")) return "blocking";
            if (_x[y]?.has("entityTile")) return "entityTile";
            return "";
        };
        this.resolveEntityTileLayerId = ()=>this.tilemaps.entityTileLayerId;
        this.removeTileAt = (x, y, layerId, broadcast)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            // console.log(
            //     "REMOVE",
            //     x,
            //     y,
            //     layerId,
            //     "occlusion?",
            //     this.tileTypesMap[x][y]?.has("occlusion"),
            //     "blocking?",
            //     this.tileTypesMap[x][y]?.has("blocking"),
            // )
            // resolve tileId to remove
            let tileId;
            if (layerId) {
                const map = this.resolveTileMapFromLayerId(layerId);
                if (map) tileId = map[x][y];
            } else {
                const map = this.resolveTileMapFromLayerId(this.tilemaps.entityTileLayerId);
                if (map) {
                    const id = map[x][y];
                    if (this.removeableTile(id)) {
                        layerId = this.tilemaps.entityTileLayerId;
                        tileId = id;
                    }
                }
            }
            const delta = layerId && tileId && tileId !== "0" ? {
                x: x,
                y: y,
                removed: true,
                layerId: layerId,
                tileId: tileId
            } : undefined;
            const deltaKey = `${x}-${y}`;
            const existingDelta = this.tilemaps.deltas[layerId]?.[deltaKey];
            const wasTemporary = existingDelta && existingDelta.temporary;
            if (wasTemporary) // delete temporary delta
            delete this.tilemaps.deltas[layerId][deltaKey];
            if (delta) {
                _x[y]?.delete("entityTile");
                this.touchTileTypes();
                this.lastEditedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
                if (!wasTemporary) {
                    let deltaLayer = this.tilemaps.deltas[layerId];
                    if (!deltaLayer) {
                        deltaLayer = {};
                        this.tilemaps.deltas[layerId] = deltaLayer;
                    }
                    deltaLayer[`${x}-${y}`] = delta;
                }
                const map = this.resolveTileMapFromLayerId(layerId);
                delete map[x][y];
                let blocking;
                let occlusion;
                let collideable;
                let deep;
                let floor;
                Object.values(this.tilemaps.deltas).map((n)=>Object.values(n).filter((n)=>n.x === x && n.y === y && !n.removed)).flat().forEach((delta)=>{
                    if (delta.blocking) blocking = true;
                    if (delta.occlusion) occlusion = true;
                    if (delta.collideable) collideable = true;
                    const tileMeta = this.resolveTileMeta(delta.tileId);
                    if (tileMeta?.tileTypes?.includes("deep")) deep = true;
                    if (tileMeta?.tileTypes?.includes("floor")) floor = true;
                });
                if (!blocking) {
                    _x[y]?.delete("blocking");
                    this.touchTileTypes();
                    delete this.tilemaps?.blocking[x]?.[y];
                }
                if (!occlusion) {
                    _x[y]?.delete("occlusion");
                    delete this.tilemaps?.occlusion[x]?.[y];
                }
                if (!collideable) _x[y]?.delete("collideable");
                const thisTileMeta = this.resolveTileMeta(tileId);
                if (thisTileMeta.tileTypes.includes("deep") && !deep) _x[y]?.delete("deep");
                if (thisTileMeta.tileTypes.includes("floor") && !floor) _x[y]?.delete("floor");
                if (broadcast) this.removeEventListeners.forEach((listener)=>listener(delta));
            }
            return delta;
        };
        this.updateBlockingAt = (x, y, blocking, broadcast)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            if (blocking) _x[y]?.add("blocking");
            else _x[y]?.delete("blocking");
            this.touchTileTypes();
            let blockingDeltaLayer = this.tilemaps.deltas["blocking"];
            if (!blockingDeltaLayer) blockingDeltaLayer = {};
            const delta = blockingDeltaLayer[`${x}-${y}`] || {
                x: x,
                y: y,
                blocking: blocking
            };
            delta.blocking = blocking;
            blockingDeltaLayer[`${x}-${y}`] = delta;
            this.tilemaps.deltas["blocking"] = blockingDeltaLayer;
            this.lastEditedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            if (broadcast) this.removeEventListeners.forEach((listener)=>listener(delta));
            return delta;
        };
        this.getTileMeta = (tileId, tilesetId)=>{
            const tileset = this.tilesets.find((t)=>t.tilesetId === tilesetId);
            if (!tileset) return null;
            const meta = tileset.tiles[tileId];
            if (meta) return {
                tileId: `${tileset.firstGid + Number(tileId) - 1}`,
                meta: meta
            };
            return null;
        };
        this.entityTileIdToTileId = (entityTileId)=>{
            let foundId;
            let foundTileSet;
            let foundMeta;
            this.tilesets.every((tileset)=>{
                Object.keys(tileset.tiles).every((tileId)=>{
                    const meta = tileset.tiles[tileId];
                    if (meta.entityTileId === entityTileId) {
                        foundId = tileId;
                        foundTileSet = tileset;
                        foundMeta = meta;
                        return false;
                    }
                    return true;
                });
                if (foundId) return false;
                return true;
            });
            if (foundId && foundTileSet) return {
                tileId: `${foundTileSet.firstGid + Number(foundId) - 1}`,
                meta: foundMeta
            };
            return null;
        };
        this.getEntityTileAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            if (this.tilemaps.tilemaps) for(let i = 0; i < this.tilemaps.tilemaps.length; i++){
                const map = this.tilemaps.tilemaps[i];
                const id = map[x][y];
                const tileMeta = this.resolveTileMeta(id);
                if (tileMeta?.entityTileId) {
                    if (this.hasRemovedDelta(x, y, id, this.tilemaps.entityTileLayerId)) return null;
                    return {
                        tileId: id,
                        entityTile: tileMeta?.entityTileId
                    };
                }
            }
        };
        this.entityTileMap = ()=>{
            return this.tilemaps.tilemaps[this.tilemaps.entityTilemapIdx];
        };
        this.addMapSpriteCapAt = (x, y, context)=>{
            this.tilemaps.mapSpriteCaps.push({
                x: x,
                y: y,
                context: context
            });
        };
        this.addTileAt = (x, y, blocking, occlusion, tileId, layerId, mapSpriteCap, temporary, collideable, context, broadcast)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            // console.log("ADD", x, y, layerId, `occlusion - ${occlusion}`, `blocking - ${blocking}`)
            if (blocking) {
                _x[y]?.add("blocking");
                this.touchTileTypes();
            }
            if (occlusion) _x[y]?.add("occlusion");
            if (collideable) _x?.[y]?.add("collideable");
            if (tileId) {
                // entityTiles
                const tileMeta = this.resolveTileMeta(tileId);
                if (tileMeta.entityTileId) {
                    this.tileTypesMap[x]?.[y]?.add("entityTile");
                    this.touchTileTypes();
                }
                // add tile id to the entity tile surface
                const entityTileMap = layerId ? this.resolveTileMapFromLayerId(layerId) : this.tilemaps.tilemaps[this.tilemaps.entityTilemapIdx];
                if (entityTileMap) entityTileMap[x][y] = tileId;
                if (tileMeta.tileTypes.includes("deep")) _x[y]?.add("deep");
                if (tileMeta.tileTypes.includes("floor")) _x[y]?.add("floor");
            }
            //
            // update deltas
            //
            const existingMapDelta = this.getMapDeltaAt(x, y, layerId);
            if (existingMapDelta) {
                if (tileId !== existingMapDelta.tileId) existingMapDelta.tileId = tileId;
                existingMapDelta.blocking = blocking;
                existingMapDelta.occlusion = occlusion;
                existingMapDelta.mapSpriteCap = mapSpriteCap;
                delete existingMapDelta.removed;
                // Preserve existing context data (like hp, damage, etc.) when updating tiles
                if (context && existingMapDelta.context) existingMapDelta.context = {
                    ...existingMapDelta.context,
                    ...context
                };
                else if (context) existingMapDelta.context = context;
                this.addEventListeners.forEach((listener)=>listener(existingMapDelta));
                return existingMapDelta;
            }
            const delta = {
                x: x,
                y: y,
                tileId: tileId,
                blocking: blocking === false ? undefined : blocking,
                occlusion: occlusion === false ? undefined : occlusion,
                layerId: layerId,
                mapSpriteCap: mapSpriteCap,
                temporary: temporary === false ? undefined : temporary,
                collideable: collideable === false ? undefined : collideable,
                context: context
            };
            let deltaLayer = this.tilemaps.deltas[layerId];
            if (!deltaLayer) {
                deltaLayer = {};
                this.tilemaps.deltas[layerId] = deltaLayer;
            }
            deltaLayer[`${x}-${y}`] = delta;
            this.lastEditedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            if (broadcast) this.addEventListeners.forEach((listener)=>listener(delta));
            return delta;
        };
        this.resolveLayerMapping = (layerId)=>{
            if (layerId === "skyTrigger" || layerId === "occlusion") return {
                idx: 0,
                maptype: layerId
            };
            return this.layerIndexedMap?.get(layerId)?.layerClass;
        };
        this.getBlockingLayer = ()=>this.tilemaps.blocking;
        this.resolveTileMapFromLayerId = (layerId)=>{
            if (!layerId) return null;
            switch(layerId){
                case "skyTrigger":
                    return this.tilemaps?.skyTrigger;
                case "occlusion":
                    return this.tilemaps?.occlusion;
            }
            return this.layerIndexedMap?.get(layerId)?.tilemap;
        };
        this.isHiddenTile = (tileId)=>this.resolveTileMeta(tileId).tileTypes.includes("hidden");
        this.getCompositeTileId = (tileId)=>this.resolveTileMeta(tileId).compositeTileId;
        this.height = ()=>this._height;
        this.width = ()=>this._width;
        this.registerRemoveListener = (listener)=>{
            this.removeEventListeners.add(listener);
        };
        this.unregisterRemoveListener = (listener)=>{
            this.removeEventListeners.delete(listener);
        };
        this.registerAddListener = (listener)=>{
            this.addEventListeners.add(listener);
        };
        this.unregisterAddListener = (listener)=>{
            this.addEventListeners.delete(listener);
        };
        this.iterateLayer = (layerId, visitor)=>{
            const map = this.resolveTileMapFromLayerId(layerId);
            if (!map) return;
            (0, $cb689cfa16c444ba$export$d84fb6ad88214660)(map, visitor);
        };
        // `layerId` names the delta to write to. Without it this takes whatever findMapDeltaAt hands back,
        // which walks the layers in whatever order the map defines them -- fine for a struck tile, whose
        // caller has already resolved the layer, but wrong for a caller that knows the tile it means: the
        // ground UNDER a wall is a delta at the same cell, and would take the damage instead.
        this.updateMapDeltaWithHP = (mapRoughCoordinates, hp, hpMax, layerId)=>{
            const { x: x, y: y } = mapRoughCoordinates;
            const existingDelta = layerId ? this.getMapDeltaAt(x, y, layerId) : this.findMapDeltaAt(x, y);
            if (existingDelta) {
                // Update existing delta with HP context
                if (!existingDelta.context) existingDelta.context = {};
                existingDelta.context.hp = hp;
                existingDelta.context.hpMax = hpMax;
                // Trigger update by calling setMapDeltas with the updated delta
                this.setMapDeltas([
                    existingDelta
                ], true);
            }
        };
        this.roomId = roomId;
        this.tilemaps = tileMapDirectory;
        this.tilesets = tilesets.sort((a, b)=>b.firstGid - a.firstGid);
        const firstTileMap = tileMapDirectory.tilemaps[0];
        if (!firstTileMap) return;
        this._width = firstTileMap.length;
        this._height = firstTileMap[0].length;
        this.tileTypesMap = [];
        this.tileBlockingAllowed = [];
        this.tileBlockingNotAllowed = [];
        this.minimapConfig = {
            biomeBased: true,
            worldMetaDimensions: worldMetaDimensions
        };
        this.layerIndexedMap = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
        if (this.tilemaps.layerIdToTileMap) Object.keys(this.tilemaps.layerIdToTileMap).forEach((layerId)=>{
            let tilemap;
            const layerClass = this.tilemaps.layerIdToTileMap[layerId];
            const { maptype: maptype, idx: idx } = layerClass;
            switch(maptype){
                case "tilemap":
                    tilemap = this.tilemaps?.tilemaps[idx];
                    break;
                case "sprited":
                    tilemap = this.tilemaps?.sprited[idx];
                    break;
                case "sky":
                    tilemap = this.tilemaps?.sky[idx];
                    break;
            }
            this.layerIndexedMap.set(layerId, {
                entityId: layerId,
                tilemap: tilemap,
                layerClass: layerClass
            });
        });
        const blockingTileSet = this.tilesets.find((n)=>n.tilesetId === "lpc-terrain");
        for(let x = 0; x < this._width; x++){
            const column = [];
            this.tileTypesMap.push(column);
            const tileBlockingAllowedColumn = [];
            const tileBlockingNotAllowedColumn = [];
            this.tileBlockingAllowed.push(tileBlockingAllowedColumn);
            this.tileBlockingNotAllowed.push(tileBlockingNotAllowedColumn);
            for(let y = 0; y < this._height; y++){
                const rowSet = new Set();
                column.push(rowSet);
                const rowTileBlockingAllowedSet = new Set();
                const rowTileBlockingNotAllowedSet = new Set();
                tileBlockingAllowedColumn.push(rowTileBlockingAllowedSet);
                tileBlockingNotAllowedColumn.push(rowTileBlockingNotAllowedSet);
                // inspect every map level and merge the tile types relevant to each cell in the map
                for(let i = 0; i < tileMapDirectory.tilemaps.length; i++){
                    // get the tile map
                    const tileMap = tileMapDirectory.tilemaps[i];
                    // look up the tile id of the current cell
                    const tileId = `${tileMap[x][y]}`;
                    // look up the tiletypes that tile id and merge it into the cell's tile types set
                    const tileMeta = this.resolveTileMeta(tileId);
                    const toAdd = tileMeta.tileTypes;
                    toAdd.forEach((tileType)=>rowSet.add(tileType));
                }
                // inspect blocking
                if (tileMapDirectory.blocking) {
                    const blockingTile = tileMapDirectory.blocking[x][y];
                    if (blockingTile && blockingTile !== `${0}`) {
                        rowSet.add("blocking");
                        if (blockingTileSet) {
                            const blockingTileId = Number(blockingTile) - blockingTileSet.firstGid;
                            switch(blockingTileId){
                                case 957:
                                    rowTileBlockingAllowedSet.add("Down");
                                    rowTileBlockingNotAllowedSet.add("Right");
                                    break;
                                case 958:
                                    rowTileBlockingAllowedSet.add("Down");
                                    break;
                                case 959:
                                    rowTileBlockingAllowedSet.add("Down");
                                    rowTileBlockingNotAllowedSet.add("Left");
                                    break;
                                case 989:
                                    rowTileBlockingAllowedSet.add("Left");
                                    break;
                                case 991:
                                    rowTileBlockingAllowedSet.add("Right");
                                    break;
                                case 1021:
                                    rowTileBlockingAllowedSet.add("Left");
                                    rowTileBlockingAllowedSet.add("Up");
                                    break;
                                case 1022:
                                    rowTileBlockingAllowedSet.add("Down");
                                    break;
                                case 1023:
                                    rowTileBlockingAllowedSet.add("Right");
                                    rowTileBlockingAllowedSet.add("Up");
                                    break;
                            }
                        }
                    }
                }
                if (tileMapDirectory.occlusion) {
                    const occlusionTile = tileMapDirectory.occlusion[x][y];
                    if (occlusionTile && occlusionTile !== `${0}`) rowSet.add("occlusion");
                }
                if (tileMapDirectory.sprited) tileMapDirectory.sprited.forEach((sprited)=>{
                    const spritedTileId = sprited[x][y];
                    const tileMeta = this.resolveTileMeta(spritedTileId);
                    const toAdd = tileMeta.tileTypes;
                    toAdd.forEach((tileType)=>rowSet.add(tileType));
                });
            }
        }
        const { deltas: deltas } = tileMapDirectory;
        const deltaLayers = Object.keys(deltas);
        if (deltaLayers.length > 0) deltaLayers.forEach((layerId)=>{
            const layerDeltas = deltas[layerId];
            Object.values(layerDeltas).forEach((delta)=>{
                if (delta.removed) this.removeTileAt(delta.x, delta.y, layerId);
                else {
                    this.addTileAt(delta.x, delta.y, delta.blocking, delta.occlusion, delta.tileId, delta.layerId, delta.mapSpriteCap, delta.temporary, delta.collideable, delta.context);
                    if (delta.mapSpriteCap) this.addMapSpriteCapAt(delta.x, delta.y, delta.mapSpriteCap.context);
                }
            });
        });
        this.tilesets.forEach((tileset)=>{
            this.tilesetsById[tileset.tilesetId] = tileset;
            Object.keys(tileset.tiles).forEach((tileId)=>{
                const tileMeta = tileset.tiles[tileId];
                if (tileMeta?.compositeTileId && tileMeta.compositeTileParent) {
                    const children = [];
                    this.compositeTileMetaLookup[`${tileset.tilesetId}-${tileMeta.compositeTileId}`] = {
                        tileMeta: tileMeta,
                        tileNumber: parseInt(tileId),
                        children: children
                    };
                    Object.keys(tileset.tiles).reduce((acc, childTileId)=>{
                        const childTileMeta = tileset.tiles[childTileId];
                        if (childTileMeta.compositeTileId === tileMeta.compositeTileId) children.push({
                            tileMeta: childTileMeta,
                            tileNumber: parseInt(childTileId)
                        });
                        return acc;
                    }, []);
                }
            });
        });
    }
}






var $5UG8I = parcelRequire("5UG8I");



class $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c {
    constructor(subject, props){
        this.faderStep = 0.01;
        this.direction = "out";
        this.isActive = ()=>this.active;
        this.update = ()=>{
            this.active = true;
            if (this.interval) return;
            this.interval = setInterval(()=>{
                if (this.direction === "out") {
                    this.subject.alpha -= this.faderStep;
                    if (this.subject.alpha <= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else if (this.direction === "in") {
                    this.subject.alpha += this.faderStep;
                    if (this.subject.alpha >= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else {
                    // not supported, clear it right away
                    clearInterval(this.interval);
                    this.interval = undefined;
                }
            }, this.fadeInterval);
        };
        this.stop = (suppressCallback)=>{
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
            if (!suppressCallback && this.releaseCallback) this.releaseCallback();
            this.active = false;
        };
        this.subject = subject;
        this.releaseCallback = props?.releaseCallback;
        this.minAlpha = props?.minAlpha !== undefined ? props.minAlpha : this.direction === "out" ? 0.0 : 1.0;
        this.fadeInterval = props?.fadeInterval || 2;
        this.faderStep = props?.fadeAlphaDecrement || 0.01;
        this.direction = props?.direction || "out";
    }
}


// How long a press has to sit on an interactable entity before it stops meaning "interact" and starts
// meaning "attack". Short enough that holding to swing feels immediate; comfortably longer than any
// deliberate tap, including a touch tap, which is what keeps the two gestures from being confused.
const $319b1dfd90d3ebea$var$ENTITY_PRESS_HOLD_MS = 220;
class $319b1dfd90d3ebea$var$DegreesRotator {
    constructor(targetAngle, increment, currentAngle){
        this.update = ()=>{
            const delta = this.targetAngle - this.currentAngle;
            if (delta < 0) this.currentAngle -= this.increment;
            else this.currentAngle += this.increment;
            if (Math.abs(delta) < this.increment) return true;
            return false;
        };
        this.normalizedCurrent = ()=>{
            return this.currentAngle > 360 ? this.currentAngle - 360 : this.currentAngle;
        };
        this.normalizedTarget = ()=>{
            return this.targetAngle > 360 ? this.targetAngle - 360 : this.targetAngle;
        };
        this.targetAngle = targetAngle;
        this.currentAngle = currentAngle;
        this.increment = increment;
        const delta = this.targetAngle - this.currentAngle;
        if (Math.abs(delta) >= 180) {
            if (this.targetAngle > this.currentAngle) this.currentAngle += 360;
            else this.targetAngle += 360;
        }
    }
}
class $319b1dfd90d3ebea$export$2616165974278734 {
    constructor(client, entity, mouseHandler, keyboardHandler, guest){
        this.isChat = false;
        this.lastMouseMoveTs = 0;
        this.keyboardActionEnabled = true;
        this.mouseActionEnabled = true;
        this.suppressAttackUntilTs = 0;
        // DOWNED: the server's verdict that this player has fallen and has not been put back on their
        // feet yet (Message.downed, mirrored by ClientGameLogic.updateFromPlayerMessage). Distinct
        // from `paralyzed`, which is a short client-side beat that times itself out -- this one lasts
        // as long as the server says it does, which for an ember camp is however long the player takes
        // to answer their end-of-run panel. The server refuses their input for the same reason, so
        // stopping here is what keeps them from predicting a walk they never get to take.
        this.downed = false;
        this.randomness = undefined;
        this.roughCompositeTilePointer = (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)();
        this.longRangedEquipped = undefined;
        this.terrainPointerOn = false;
        this.terrainPointerSprites = new Set();
        this.pressBecameAttack = false;
        this.targetSpeed2 = {
            x: 0,
            y: 0
        };
        // Held movement intent from the mobile joysticks. Their onChange only fires on pointermove,
        // so a thumb parked at full deflection produces no events at all -- the intent has to be
        // latched here and re-applied by updatePlayerVelocity every tick, exactly as a held key is.
        this.joystickSpeed2 = null;
        this.movementStartTime = 0;
        this.isSustainedMovement = false;
        this.isKeyOn = (key)=>{
            // If in chat mode, don't detect movement keys
            if (this.isChat && [
                "w",
                "a",
                "s",
                "d",
                "ArrowUp",
                "ArrowDown",
                "ArrowLeft",
                "ArrowRight"
            ].includes(key)) return false;
            return this.keyboardHandler.state().get(key) || this.keyboardHandler.state().get(key.toUpperCase());
        };
        this.isButtonOn = (key)=>this.mouseHandler.state().buttons.get(key) == true;
        this.adjustEntityAngle = (entity, delta)=>(0, $a80d0b17b615d6f7$export$b363da9ded343252)({
                x: entity.location.x,
                y: entity.location.y
            }, {
                x: entity.location.x + delta.x,
                y: entity.location.y + delta.y
            });
        this.keyboardBasedAngle = (entity)=>{
            const leftRightOn = this.isKeyOn("a") || this.isKeyOn("ArrowLeft") || this.isKeyOn("d") || this.isKeyOn("ArrowRight");
            const upDownOn = this.isKeyOn("w") || this.isKeyOn("ArrowUp") || this.isKeyOn("s") || this.isKeyOn("ArrowDown");
            let newTargetAngle;
            if (!leftRightOn) {
                if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: 0,
                    y: 1
                });
                if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: 0,
                    y: -1
                });
            } else {
                if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) {
                    if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: 1
                    });
                    if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: 1
                    });
                }
                if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) {
                    if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: -1
                    });
                    if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: -1
                    });
                }
            }
            if (!upDownOn) {
                if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: 1,
                    y: 0
                });
                if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: -1,
                    y: 0
                });
            } else {
                if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) {
                    if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: 1
                    });
                    if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: -1
                    });
                }
                if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) {
                    if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: 1
                    });
                    if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: -1
                    });
                }
            }
            if (newTargetAngle !== undefined && newTargetAngle !== this.targetKeyboardAngle) {
                if (this.keyboardAndleAdjustInterval) clearInterval(this.keyboardAndleAdjustInterval);
                this.targetKeyboardAngle = newTargetAngle;
                const increment = 5;
                const rotator = new $319b1dfd90d3ebea$var$DegreesRotator(Math.floor((0, $a80d0b17b615d6f7$export$32b1497b7aadef08)(newTargetAngle)), increment, Math.floor((0, $a80d0b17b615d6f7$export$32b1497b7aadef08)(this.entity.movement.angle)));
                this.keyboardAndleAdjustInterval = setInterval(()=>{
                    const done = rotator.update();
                    this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(rotator.normalizedCurrent());
                    if (done) {
                        this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(rotator.normalizedTarget());
                        clearInterval(this.keyboardAndleAdjustInterval);
                    }
                }, 5);
            }
        };
        this.updateRoom = ()=>{
            // A pick armed in the room just left has nothing to point at any more.
            this.cancelLocationPick();
            if (this.pointer) this.pointer = undefined;
            if (this.roughPointer) this.roughPointer = undefined;
            this.hoveredEntity = undefined;
        };
        this.updateOrientation = (orientation)=>{
            const { entity: entity } = this;
            switch(orientation){
                case "south":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: 0,
                        y: -1
                    });
                    break;
                case "north":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: 0,
                        y: 1
                    });
                    break;
                case "east":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: 0
                    });
                    break;
                case "west":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: 0
                    });
                    break;
            }
        };
        // Pasted text only means anything while the chat input is open; anywhere else in the game
        // there is nothing it could be pasted INTO.
        this.respondToPaste = (text)=>{
            if (!this.isChat || !this.client.clientGameLogic.isBootstrapped()) return;
            this.client.pasteIntoChat(text);
        };
        this.respondToKeyBoard = (key, down, repeat, mods)=>{
            if (!this.client.clientGameLogic.isBootstrapped()) // can't do anything unless you're bootstrapped
            return;
            if (!this.keyboardActionEnabled) return;
            const { entity: entity } = this;
            if (this.isKeyOn("/") && !this.isChat) {
                this.client.startChat();
                this.isChat = true;
            }
            if (this.isKeyOn("Enter")) {
                if (this.isChat) this.client.stopChat();
                else this.client.startChat();
                this.isChat = !this.isChat;
            }
            if (this.isChat && down) this.client.captureKeystroke(key, mods);
            if (this.isKeyOn("Escape") && this.isChat) {
                this.client.stopChat();
                this.isChat = false;
            }
            if (this.isChat) return;
            // Handle Control key for command wheel
            if (key === "Control" || key === "ControlLeft" || key === "ControlRight") {
                if (down) // Control key pressed - show command wheel
                this.client.clientGameLogic.clientRenderer.gui().showCommandWheel();
                else // Control key released - hide command wheel
                this.client.clientGameLogic.clientRenderer.gui().hideCommandWheel();
            }
            // Escape dismisses the per-entity command wheel (opened from an NPC's command button,
            // so it isn't tied to holding Control).
            if ((key === "Escape" || key === "Esc") && down) {
                const gui = this.client.clientGameLogic.clientRenderer.gui();
                if (gui.isCommandWheelVisible()) gui.hideCommandWheel();
                // Also dismiss the recruit role picker if it's open.
                if (gui.isRolePickerVisible()) gui.hideRolePicker();
                // ...and either possession splash, which is only ever telling the player something, so
                // Escape is simply the keyboard's dismiss button.
                if (gui.isPossessionSplashVisible()) gui.hidePossessionSplash();
                // ...and the invasion picker, which is open over the end-of-run scorecard while the
                // player is still DOWNED -- so this has to sit above the paralyzed/downed guard below,
                // where it already does. Routed through cancelInvasionPicker so the keyboard way out
                // tells the server exactly what the footer button and the scrim do.
                if (gui.isInvasionPickerVisible()) gui.cancelInvasionPicker();
                // ...and the name prompt. Escape is the one key that still reaches here while a text
                // field holds the keyboard (Keyboard.suppressTyping), precisely so that a field whose
                // focus has been clicked away can still be dismissed.
                if (gui.isNamePromptVisible()) gui.hideNamePrompt();
                // Escape backs out of an armed placement ("Place" on a buildable item): drop the preview
                // right away so the pointer stops meaning "build here", and put the item away server-side,
                // which is what actually ends build mode (INACTIVATE_ITEM -> sendBuilderAction(false)).
                if (this.terrainPointerOn) {
                    this.updateTerrainPointerOn(false);
                    this.client.clientGameLogic.cancelBuildPlacement();
                }
                // Escape backs out of an armed location pick (the defender's "Hold Position") the same
                // way it backs out of build mode: the order is simply never sent.
                this.cancelLocationPick();
                // Also deactivate the ember follow-cam PiP / roster slot.
                gui.dismissFollowCam();
            }
            if (this.paralyzed || this.downed) {
                entity.movement.moving = false;
                entity.speed2.x = 0;
                entity.speed2.y = 0;
                return;
            }
            if (Date.now() - this.lastMouseMoveTs > 150) this.keyboardBasedAngle(entity);
            const isMoving = this.isKeyOn("w") || this.isKeyOn("ArrowUp") || this.isKeyOn("s") || this.isKeyOn("ArrowDown") || this.isKeyOn("a") || this.isKeyOn("ArrowLeft") || this.isKeyOn("d") || this.isKeyOn("ArrowRight");
            let manualControl = isMoving;
            if (isMoving) {
                clearInterval(this.autoMovingInterval);
                this.setAutoMoving(false);
            }
            // Remove immediate velocity zeroing to allow inertial slowdown
            // The updatePlayerVelocity method will handle velocity updates with inertia
            if (manualControl) {
                const wasMoving = entity.movement.moving;
                entity.movement.moving = isMoving;
                if (!wasMoving && entity.movement.moving) {
                    // started moving!
                    this.movementStartTime = Date.now();
                    this.isSustainedMovement = false;
                    if (this.movementDaemon !== undefined) clearInterval(this.movementDaemon);
                    this.movementDaemon = setInterval(()=>{
                        if (Date.now() - this.lastMouseMoveTs > 150) this.keyboardBasedAngle(entity);
                    }, 150);
                }
                if (wasMoving && !entity.movement.moving) {
                    // stopped moving
                    this.movementStartTime = 0;
                    this.isSustainedMovement = false;
                    if (this.movementDaemon !== undefined) clearInterval(this.movementDaemon);
                }
                if (!entity.afk) {
                    // Set target speed2 values
                    this.targetSpeed2 = {
                        x: 0,
                        y: 0
                    };
                    if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) this.targetSpeed2.y = -1;
                    if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) this.targetSpeed2.y = 1;
                    if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) this.targetSpeed2.x = -1;
                    if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) this.targetSpeed2.x = 1;
                } else // If AFK, set target to zero
                this.targetSpeed2 = {
                    x: 0,
                    y: 0
                };
            }
            if (this.isKeyOn("e")) {
                if (this.terrainPointerOn) this.client.clientGameLogic.activateWorldPoint(this.pointer, {
                    delete: true
                });
            }
            if (this.isKeyOn("p")) this.updateTerrainPointerOn(!this.terrainPointerOn);
            if (this.isKeyOn("u")) this.client.spawnNpc();
            if (this.isKeyOn("x")) this.client.dropAction();
            if (this.isKeyOn("y")) this.client.itemPickupAction();
            if (this.isKeyOn("b")) this.activeAbility("b");
            if (this.isKeyOn(" ")) this.manualAttack(isMoving);
            if (this.isKeyOn("q")) this.client.dropActiveItem();
            if (this.isKeyOn("]")) this.client.activateAbility("e");
            if (this.isKeyOn("1")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(1);
            if (this.isKeyOn("2")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(2);
            if (this.isKeyOn("3")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(3);
            if (this.isKeyOn("4")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(4);
            if (this.isKeyOn("5")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(5);
            if (this.isKeyOn("6")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(6);
            if (this.isKeyOn("j")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "come"
                }
            });
            if (this.isKeyOn("h")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "stopStart"
                }
            });
            if (this.isKeyOn("k")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "formation"
                }
            });
            if (this.isKeyOn("l")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "updateStance"
                }
            });
            if (key === "Shift") {
                if (down) this.client.boost(true);
                else this.client.boost(false);
            }
            if (this.isKeyOn("~")) {
                if (this.randomness) {
                    clearInterval(this.randomness);
                    this.randomness = null;
                } else {
                    const latch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(500);
                    this.randomness = setInterval(()=>{
                        if (latch.expired()) {
                            const w = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 20);
                            this.client.fireBullet();
                        }
                        const r = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 1);
                        entity.movement.moving = true;
                        entity.speed2.x = r * ((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 1) === 1 ? -1 : 1);
                        entity.speed2.y = r * ((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 1) === 1 ? -1 : 1);
                    }, 100);
                }
            }
            if (this.isKeyOn("i")) this.client.clientGameLogic.clientRenderer.gui().toggleInventory();
            // Toggle faction tracking (offscreen edge arrows). Gate on `down` so holding the
            // key doesn't rapidly flip it. No-op unless the room designated a faction to track.
            if ((key === "f" || key === "F") && down && !this.isChat) this.client.clientGameLogic.toggleFactionTracking();
            // Toggle the crafting screen. Gated on the key's own key-down, and on it not being an
            // auto-repeat, so holding `c` doesn't flip the screen open and shut.
            if ((key === "c" || key === "C") && down && !repeat) this.client.clientGameLogic.clientRenderer.gui().toggleCrafting();
            if (this.isKeyOn("t")) {
                if (entity.debug || entity.name === "aron") this.client.clientGameLogic.clientRenderer.gui().toggleCharacterCustomizer();
            }
        };
        this.perturb = ()=>{
            const { entity: entity } = this;
            entity.speed2.x = 0.001;
            setTimeout(()=>{
                entity.speed2.x = 0;
            }, 10);
        };
        this.respondToMouse = (mouseState)=>{
            if (!this.mouseActionEnabled) return;
            this.lastMouseMoveTs = Date.now();
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                if (!this.pointer && this.client.clientGameLogic.tilemapMetaProvider) {
                    const pointer = {
                        x: 64,
                        y: 64
                    };
                    this.pointer = pointer;
                }
                if (!this.roughPointer && this.client.clientGameLogic.tilemapMetaProvider) {
                    const pointer = {
                        x: 0,
                        y: 0
                    };
                    this.roughPointer = pointer;
                }
                this.client.clientGameLogic.clientRenderer.entity();
                const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
                const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
                const entity = this.client.clientGameLogic.playerEntity;
                const tilemapMetaProvider = this.client.clientGameLogic.tilemapMetaProvider;
                if (tilemapMetaProvider) {
                    const location = entity.location;
                    const rightThreshold = (tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    const bottomThreshold = (tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    const isOverX = location.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && location.x > rightThreshold;
                    const isOverY = location.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && location.y > bottomThreshold;
                    if (this.pointer) {
                        const renderer = this.client.clientGameLogic.clientRenderer.map();
                        const { modifierX: modifierX, modifierY: modifierY } = renderer.translationComputer;
                        const factor = 0.5;
                        const yfactor = 0.38;
                        this.pointer = {
                            x: Math.round(mouseState.position.x * factor) + Math.round((modifierX !== undefined ? -modifierX : 0) * 1) - (modifierX !== undefined ? Math.round((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR * factor) : isOverX ? -rightThreshold + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR : 0) - (modifierX !== undefined ? 40 : -24),
                            y: Math.round(mouseState.position.y * yfactor) + Math.round((modifierY !== undefined ? -modifierY : 0) * 1) - (modifierY !== undefined ? Math.round((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR * yfactor) : isOverY ? -bottomThreshold + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR : 0) - (modifierY !== undefined ? 0 : -30)
                        };
                        this.pointer.y += -10;
                        const newRoughPointerX = Math.floor(this.pointer.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                        const newRoughPointerY = Math.floor(this.pointer.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                        if (this.roughPointer.x !== newRoughPointerX || this.roughPointer.y !== newRoughPointerY) {
                            this.roughPointer.x = newRoughPointerX;
                            this.roughPointer.y = newRoughPointerY;
                            this.updatedRoughPointer(this.roughPointer);
                        }
                        this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)(this.pointer, entity.location);
                        this.targetKeyboardAngle = this.entity.movement.angle;
                        // Keep an armed location pick's verdict current as the pointer travels: the
                        // reticle is amber over ground the NPC could stand on, red over ground it
                        // could not.
                        if (this.locationPick) this.client.clientGameLogic.clientRenderer.gui().setLocationPickerBlocked(!this.locationPickable());
                        // ... and not the bow's crosshair on top of it: while a pick is armed the
                        // location reticle IS the pointer, and two of them read as a bug.
                        if ((this.longRangedEquipped || this.terrainPointerOn) && !this.locationPick) {
                            const mouseSprite = this.client.clientGameLogic.clientRenderer.gui().createCursorSprite();
                            mouseSprite.visible = true;
                            mouseSprite.alpha = 1.0;
                            if (this.mousePointerFadeInterval) clearInterval(this.mousePointerFadeInterval);
                            if (this.mousePointerFader) {
                                this.mousePointerFader.stop(true);
                                this.mousePointerFader = null;
                            }
                            this.mousePointerFadeInterval = setTimeout(()=>{
                                this.mousePointerFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(mouseSprite, {
                                    releaseCallback: ()=>{
                                        mouseSprite.visible = false;
                                    }
                                });
                                this.mousePointerFader.update();
                            }, 500);
                        }
                    }
                }
                clearInterval(this.keyboardAndleAdjustInterval);
            }
            if (this.isButtonOn("0")) {
                // A click on an interaction icon (chest open/close, chat, etc.) must never also
                // trigger a world attack. The attack click arrives via a document-level mousedown
                // that can't tell it landed on a pixi interaction widget, so we suppress attacks
                // for a short window around every interaction activation (see suppressAttack).
                if (Date.now() < this.suppressAttackUntilTs) return;
                // Check if command wheel is visible - if so, don't process mouse clicks for attacks
                if (this.client.clientGameLogic.clientRenderer.gui().isCommandWheelVisible()) return;
                // Same for the name prompt: it stands open for as long as it takes to type a name, with
                // the player's attention on a field rather than the world, so a click meant for it (or
                // for the field it just lost focus to) must not fire a shot.
                if (this.client.clientGameLogic.clientRenderer.gui().isNamePromptVisible?.()) return;
                // Likewise, a click on an inventory/crafting/trading screen (e.g. an item action
                // button) must not also fire a world attack. Those modals draw over the world but the
                // attack arrives via a document-level mousedown that can't see the pixi widget it hit,
                // so gate on the open screen the same way the command wheel does above.
                if (this.client.clientGameLogic.clientRenderer.gui().isItemScreenOpen()) return;
                // button pressed
                if (!this.isFiring) {
                    this.isFiring = true;
                    // An armed location pick claims this press: it is the player answering "click a
                    // spot", not an attack on whatever happens to be under the reticle.
                    if (this.locationPick) {
                        this.completeLocationPick();
                        return;
                    }
                    // A press that landed on an entity offering interactions belongs to the press
                    // arbitration instead: a short press activates the interaction, holding past the
                    // threshold hands the press back here as an attack. The pixi pointer handlers on the
                    // entity own it from this point (see beginEntityPress), so this click does nothing.
                    if (this.pointedAtInteractableEntity()) return;
                    this.startWorldAction();
                }
            } else if (this.isFiring) {
                // button unpressed
                mouseState.buttons.set("0", false);
                this.stopFiring();
            }
        };
        // Everything a plain press on the world does: commit a build tile, close on a distant target,
        // strike an adjacent entity tile, or fire. Extracted from respondToMouse so a press held on an
        // interactable entity can be handed back to it once the hold threshold passes.
        //
        // `ignoreHover` is what makes hold-to-attack actually swing at the thing under the pointer: with
        // a hovered entity this code would otherwise close on it and fire a bullet, because hovering has
        // always suppressed the melee strike. A deliberate hold on an adjacent entity means "hit that",
        // so the hover is dropped and the adjacent-tile strike path runs.
        this.startWorldAction = (opts)=>{
            if (this.terrainPointerOn) {
                this.client.commitWorldEdits(this.roughPointer);
                this.playBuildSwing();
                this.clearTerrainPointer();
                this.fireInterval = setInterval(()=>{
                    this.client.commitWorldEdits(this.roughPointer);
                    this.playBuildSwing();
                }, 400);
                this.lastMouseMoveTs = Date.now();
                return;
            }
            const hoveredEntity = opts?.ignoreHover ? undefined : this.client.clientGameLogic.getEntity(this.hoveredEntity);
            let isAutoTravelling = false;
            const entityTilePointer = !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(this.roughCompositeTilePointer) ? this.roughCompositeTilePointer : this.roughPointer;
            const entityTile = this.client.clientGameLogic.tilemapMetaProvider.getEntityTileAt(entityTilePointer.x, entityTilePointer.y);
            const entityTileAccessible = entityTile && (0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(this.entity.location, (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)(entityTilePointer)) < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            if (!entityTileAccessible && !this.longRangedEquipped) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Mouse click: Entity tile not accessible, not long-ranged. hoveredEntity=${!!hoveredEntity}`);
                if (hoveredEntity) {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Mouse click: Scheduling auto-travel to hovered entity ${hoveredEntity.entityId}`);
                    isAutoTravelling = this.scheduleAutoTravelToEntity(hoveredEntity, ()=>{
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Firing bullet after reaching hovered entity`);
                        this.client.fireBullet();
                    });
                } else {
                    const collisionCheck = (0, $a80d0b17b615d6f7$export$7758e9150891e0a1)(this.entity.location, this.entity.movement.angle, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                    if (this.client.clientGameLogic.tilemapMetaProvider.isCollisionAt((0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.x), (0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.y))) {
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Collision detected, no auto-travel`);
                        isAutoTravelling = false;
                    } else {
                        const thePoint = (0, $a80d0b17b615d6f7$export$4a09470303eb5fc5)(this.entity.location, this.pointer, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5);
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Scheduling auto-travel to calculated point (${thePoint.x}, ${thePoint.y})`);
                        isAutoTravelling = this.scheduleAutoTravelToPoint(thePoint, ()=>{
                            (0, $5UG8I.logger).info({
                                tags: [
                                    "callback",
                                    "animation"
                                ]
                            }, `Mouse click: Firing bullet after reaching calculated point`);
                            this.client.fireBullet();
                        }, false);
                    }
                }
            }
            if (!isAutoTravelling) {
                if (entityTileAccessible && !hoveredEntity) {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Mouse click: Entity tile accessible, doing strike attack`);
                    const doStrike = ()=>{
                        const s = {
                            ...this.roughCompositeTilePointer
                        };
                        this.client.clientGameLogic.attack(this.entity.entityId, ()=>{
                            this.client.entityTileStrike(s);
                        });
                    };
                    doStrike();
                    this.fireInterval = setInterval(()=>{
                        doStrike();
                    }, 400);
                } else {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Mouse click: No auto-travel, no accessible entity tile - firing bullet (no automatic boost - use Shift key for boost)`);
                    this.client.fireBullet();
                    this.fireInterval = setInterval(()=>{
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Repeating bullet fire in interval (no automatic boost)`);
                        this.client.fireBullet();
                    }, 400);
                }
            }
            this.lastMouseMoveTs = Date.now();
        };
        // Stop an in-flight press: clears the repeat so a held attack can't outlive the press. Shared by
        // the mouse-up path and the entity press handlers, because a touch that is held never produces
        // the emulated mouseup a desktop release does.
        this.stopFiring = ()=>{
            this.isFiring = false;
            clearInterval(this.fireInterval);
            this.fireInterval = undefined;
        };
        // Whether the pointer is currently on an entity that offers this player interactions. Read from
        // the client's own per-entity interaction cache, so it costs nothing and needs no round trip.
        this.pointedAtInteractableEntity = ()=>this.interactionsFor(this.hoveredEntity).length > 0;
        this.interactionsFor = (entityId)=>{
            if (!entityId) return [];
            return this.client.clientGameLogic.clientRenderer.entity().getEntityInteractions(entityId) || [];
        };
        // ---- press arbitration ---------------------------------------------------------------------
        // One press on an entity, two meanings: tap to interact, hold to attack. Driven by the entity's
        // own pixi pointer events (see EntityRenderingManager.attachClickHandler) because those are the
        // only ones a finger and a mouse both produce. An entity with no interactions never gets here --
        // its press falls straight through to the world action, exactly as before.
        this.beginEntityPress = (entityId)=>{
            if (this.interactionsFor(entityId).length === 0) return;
            // Build mode owns the press: placing a tile on the ground an interactable stands on must not
            // open the interactable instead.
            if (this.terrainPointerOn) return;
            // Same for an armed location pick: "hold THIS spot" has to stay available even when an NPC
            // happens to be standing on the spot being chosen.
            if (this.locationPick) return;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            // A wheel or picker already open sits directly over its entity, so a press on one of its
            // slices lands on the entity underneath too. The open widget owns that press.
            if (gui.isCommandWheelVisible() || gui.isRolePickerVisible?.() || gui.isNamePromptVisible?.() || gui.isItemScreenOpen()) return;
            this.clearPressHoldTimer();
            this.pressedEntityId = entityId;
            this.pressBecameAttack = false;
            this.pressHoldTimer = setTimeout(()=>{
                this.pressHoldTimer = undefined;
                // Held long enough to mean it: this press is an attack on whatever is under the pointer.
                this.pressBecameAttack = true;
                if (!this.isFiring) this.isFiring = true;
                this.startWorldAction({
                    ignoreHover: true
                });
            }, $319b1dfd90d3ebea$var$ENTITY_PRESS_HOLD_MS);
        };
        this.endEntityPress = (entityId)=>{
            if (this.pressedEntityId !== entityId) return;
            const becameAttack = this.pressBecameAttack;
            this.releaseEntityPress();
            if (becameAttack) {
                // The hold already started swinging; releasing just stops it.
                this.stopFiring();
                return;
            }
            this.activateEntityInteraction(entityId);
        };
        this.cancelEntityPress = (entityId)=>{
            if (this.pressedEntityId !== entityId) return;
            const becameAttack = this.pressBecameAttack;
            this.releaseEntityPress();
            if (becameAttack) this.stopFiring();
        };
        this.releaseEntityPress = ()=>{
            this.clearPressHoldTimer();
            this.pressedEntityId = undefined;
            this.pressBecameAttack = false;
        };
        this.clearPressHoldTimer = ()=>{
            if (this.pressHoldTimer) {
                clearTimeout(this.pressHoldTimer);
                this.pressHoldTimer = undefined;
            }
        };
        // One interaction fires straight away; two or more (or a single wheel-only one, like handing over
        // food) open the wheel over the entity so the choice is deliberate. resolveInteractions holds
        // that contract, shared with the server-side defaults and the tests.
        this.activateEntityInteraction = (entityId)=>{
            const resolution = (0, $0fb3f7f2a67be6e3$export$24cb1bac32828cd1)(this.interactionsFor(entityId));
            if (resolution.kind === "single") {
                this.client.clientGameLogic.interactionCallback(entityId, resolution.interaction.type);
                return;
            }
            if (resolution.kind === "menu") {
                // The wheel itself gates clicks while it is open, but the press that opened it is still
                // travelling through the document-level mouse listeners.
                this.suppressAttack();
                this.client.clientGameLogic.clientRenderer.gui().showInteractionWheel(entityId, resolution.interactions);
            }
        };
        this.updatedRoughPointer = (coordinate)=>{
            if (this.terrainPointerOn) this.client.getBuildingTilePreview(coordinate);
        };
        this.clearTerrainPointer = ()=>{
            this.terrainPointerSprites.forEach((sprite)=>sprite.parent?.removeChild(sprite));
            this.terrainPointerSprites.clear();
        };
        // Cosmetic feedback for placing a build tile: play the local player's attack (swing) animation.
        // Goes straight to the renderer's animation path (NOT clientGameLogic.attack, which would also
        // start a real server attack + audio), so there's no damage or gameplay effect. Other players
        // are shown the swing via the server's type_playAttackAnimation broadcast on the build commit.
        this.playBuildSwing = ()=>{
            if (this.entity) this.client.clientGameLogic.clientRenderer.entity().attack(this.entity);
        };
        this.updateTerrainPointer = (deltas)=>{
            this.clearTerrainPointer();
            if (deltas?.length < 1) return;
            deltas.forEach((delta)=>{
                if (delta.layerId === "blocking" || delta.layerId === "skyTrigger") return;
                const result = this.client.clientGameLogic.clientRenderer.map().addTileAt(delta.x, delta.y, String(delta.tileSpec.tilePos), delta.layerId);
                if (result.sprite) {
                    this.terrainPointerSprites.add(result.sprite);
                    result.sprite.alpha = 0.5;
                    if (delta?.context?.highZ) result.sprite.zIndex = 100000;
                }
            });
        };
        this.enabledMouseAction = (enabled)=>{
            this.mouseActionEnabled = enabled;
            if (!enabled) // Whatever took the world's mouse away (a modal, a dialog) also took the pointer the
            // pick was waiting on, and respondToMouse stops running -- a reticle left up would just
            // hang wherever it was.
            this.cancelLocationPick();
        };
        // Briefly suppress click-to-attack (strike / ranged / build). Called right after an interaction
        // is activated so the same press — or a rapid follow-up tap on the same entity (open then close a
        // chest) — can't fall through to a world attack. Needed because the attack click comes from a
        // document-level mousedown, which can't see that the press was claimed by an entity.
        this.suppressAttack = (durationMs = 300)=>{
            this.suppressAttackUntilTs = Date.now() + durationMs;
        };
        this.setHoveredEntity = (entityId)=>{
            this.hoveredEntity = entityId;
        };
        this.unHoveredEntity = (entityId)=>{
            // Only clear if this is still the hovered entity. When the pointer moves
            // straight from one entity to another, the new entity's mouseover can run
            // before the old entity's mouseout; an unconditional clear would then wipe the
            // freshly-set hover and break click auto-travel.
            if (this.hoveredEntity === entityId) this.hoveredEntity = undefined;
        };
        // Called when a hovered entity is removed or culled out of range. Releases the hover reference
        // and re-enables world mouse actions so they can't stay stuck disabled if the entity vanished
        // mid-press, and drops any press being arbitrated against it -- an entity that no longer exists
        // will never send the pointer-up that would otherwise resolve or cancel its press.
        this.clearHoverForEntity = (entityId)=>{
            this.cancelEntityPress(entityId);
            if (this.hoveredEntity === entityId) {
                this.hoveredEntity = undefined;
                this.mouseActionEnabled = true;
            }
        };
        this.isMouseActionEnabled = ()=>this.mouseActionEnabled;
        this.enabledKeyboardAction = (enabled)=>{
            this.keyboardActionEnabled = enabled;
        };
        this.paralyze = (value, timeout = 1000)=>{
            this.paralyzed = value;
            if (value) setTimeout(()=>{
                this.paralyzed = false;
            }, timeout);
        };
        // Mirrors the server's DOWNED verdict. Every world-state message for this player carries it,
        // so it clears itself the moment the server stops saying it -- there is no client-side timer
        // to get out of step with, and nothing here that can hold a player down on its own.
        this.setDowned = (value)=>{
            if (value === this.downed) return;
            this.downed = value;
            if (value) {
                this.cancelLocationPick();
                const { entity: entity } = this;
                entity.movement.moving = false;
                entity.speed2.x = 0;
                entity.speed2.y = 0;
                this.targetSpeed2 = {
                    x: 0,
                    y: 0
                };
                this.joystickSpeed2 = null;
                clearInterval(this.autoMovingInterval);
                this.setAutoMoving(false);
            }
        };
        this.fireBullet = ()=>{
            this.client.fireBullet();
        };
        this.selectSlot = (itemId)=>{
            this.client.clientGameLogic.selectSlot(itemId);
        };
        this.activeAbility = (shortcutKey)=>{
            this.client.activateAbility(shortcutKey);
        };
        this.isGuest = ()=>this.guest;
        this.setIsGuest = (guest)=>{
            this.guest = guest;
        };
        this.updateLongRangedEquippedState = (equipped)=>{
            if (this.longRangedEquipped !== equipped) {
                this.longRangedEquipped = equipped;
                const mouseSprite = this.client.clientGameLogic.clientRenderer.gui().createCursorSprite();
                if (!equipped && mouseSprite) mouseSprite.visible = false;
            }
        };
        this.updateTerrainPointerOn = (on)=>{
            this.terrainPointerOn = on;
            if (!this.terrainPointerOn) this.clearTerrainPointer();
        };
        // ---- location pick ---------------------------------------------------------------------------
        // "Click a spot on the ground, then do something with it." The defender's "Hold Position" order
        // is the first user: the wheel selects the order, this chooses the post, and only then does the
        // command go to the server (see GuiManager's onCommandSelect).
        //
        // The gesture deliberately sits at the same level as build mode rather than inside the command
        // wheel: both take the pointer away from attacking for one press, both are backed out of with
        // Escape, and both have to hold back the entity-press arbitration while they are armed.
        this.beginLocationPick = (request)=>{
            // Build mode and a location pick both own the pointer. The newer intent wins, and build mode
            // has to be ENDED server-side too, not just visually dropped (see the Escape path).
            if (this.terrainPointerOn) {
                this.updateTerrainPointerOn(false);
                this.client.clientGameLogic.cancelBuildPlacement();
            }
            // A press already being arbitrated against an entity would turn into an attack under the
            // reticle when its hold timer fired. Arming the pick ends it.
            this.releaseEntityPress();
            this.locationPick = request;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            const cursorSprite = gui.createCursorSprite();
            if (cursorSprite) cursorSprite.visible = false;
            gui.showLocationPicker(request.caption, request.blockedCaption);
            gui.setLocationPickerBlocked(!this.locationPickable());
            // The press that picked the order off the command wheel is still travelling through the
            // document-level mouse listeners (pixi's pointerdown on the wheel runs first). Without this
            // it would arrive here as the pick itself and post the NPC under the wheel slice.
            this.suppressAttack();
        };
        this.cancelLocationPick = ()=>{
            if (!this.locationPick) return;
            this.locationPick = undefined;
            this.client.clientGameLogic.clientRenderer.gui().hideLocationPicker();
        };
        this.isPickingLocation = ()=>!!this.locationPick;
        // The fine world coordinate under the pointer. Asked of the GUI rather than read off
        // `this.pointer`: that one is hand-derived from the camera modifiers and lifted ~10px so a bow
        // aims at a body rather than at the ground beneath it, which is the wrong bias for "stand here".
        this.locationPickTarget = ()=>this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer();
        // Could an NPC actually stand where the pointer is? A post inside a wall would leave the NPC
        // walking into it forever, so blocked ground is refused at the click instead of being sent and
        // quietly ignored -- and the reticle says so in red before the player commits to it.
        this.locationPickable = ()=>{
            const point = this.locationPickTarget();
            if (!point) return false;
            const tilemap = this.client.clientGameLogic.tilemapMetaProvider;
            if (!tilemap) return false;
            const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(point);
            if (rough.x < 0 || rough.y < 0 || rough.x >= tilemap.width() || rough.y >= tilemap.height()) return false;
            return !tilemap.isCollisionAt(rough.x, rough.y);
        };
        this.completeLocationPick = ()=>{
            const request = this.locationPick;
            if (!request) return;
            const point = this.locationPickTarget();
            if (!point || !this.locationPickable()) // A click on ground nothing can stand on is not an answer. Stay armed so the player can
            // just click somewhere else -- the reticle is already red, so it isn't a silent refusal.
            return;
            this.cancelLocationPick();
            request.onPick((0, $a80d0b17b615d6f7$export$59e9cfed91f93f03)(point));
        };
        this.builderActivation = (on)=>{
            this.updateTerrainPointerOn(on);
            if (on) {
                const pointer = !this.roughPointer || this.roughPointer.x < 1 || this.roughPointer.y < 1 ? (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(this.entity.location) : this.roughPointer;
                this.client.getBuildingTilePreview(pointer);
            }
        };
        this.manualAttack = (isMoving)=>{
            (0, $5UG8I.logger).info({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `manualAttack: Spacebar pressed, isMoving=${isMoving}`);
            const useMousePointer = Date.now() - this.lastMouseMoveTs < 150;
            const collisionCheck = (0, $a80d0b17b615d6f7$export$7758e9150891e0a1)(this.entity.location, this.entity.movement.angle, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            if (this.client.clientGameLogic.tilemapMetaProvider.isCollisionAt((0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.x), (0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.y))) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `manualAttack: Collision detected, firing bullet directly`);
                this.client.fireBullet();
                return;
            }
            if (isMoving) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `manualAttack: Player is moving, firing bullet (no automatic boost - use Shift key for boost)`);
                this.client.fireBullet();
                return;
            }
            (0, $5UG8I.logger).info({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `manualAttack: Player not moving, scheduling auto-travel`);
            const distance = this.longRangedEquipped ? 0 : (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5;
            const thePoint = useMousePointer ? (0, $a80d0b17b615d6f7$export$4a09470303eb5fc5)(this.entity.location, this.pointer, distance) : (0, $a80d0b17b615d6f7$export$7758e9150891e0a1)(this.entity.location, this.entity.movement.angle, distance);
            this.scheduleAutoTravelToPoint(thePoint, ()=>{
                this.client.fireBullet();
            }, false);
        };
        this.setAutoMoving = (moving)=>{
            this.isAutoMoving = moving;
        };
        // The mobile joystick's held movement intent, as the same per-axis -1/0/1 vector a WASD
        // combination produces, or null when the thumb is off the stick. updatePlayerVelocity treats
        // it exactly like a held key. See GuiManager.setupJoystick for why it must be latched rather
        // than written straight onto entity.speed2.
        this.setJoystickIntent = (intent)=>{
            const wasHeld = this.joystickSpeed2 !== null;
            this.joystickSpeed2 = intent;
            if (intent && !wasHeld) {
                // Started moving: take over from any auto-travel and start the same 700ms-then-inertia
                // ramp the keyboard path starts, so both input sources feel the same.
                clearInterval(this.autoMovingInterval);
                this.setAutoMoving(false);
                this.movementStartTime = Date.now();
                this.isSustainedMovement = false;
            }
        };
        this.scheduleAutoTravelToEntity = (entity, travelCallback)=>{
            if (!entity) return false;
            if (this.autoMovingInterval) clearInterval(this.autoMovingInterval);
            const { entity: playerEntity } = this;
            const distance = (0, $cb689cfa16c444ba$export$9d23471d635d220b)(playerEntity, entity);
            const tooClose = distance < 24;
            const tooFar = distance > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2;
            if (!tooClose && !tooFar) {
                // console.log("distance", distance)
                this.autoTravelToEntity(entity, travelCallback);
                return true;
            }
            return false;
        };
        this.scheduleAutoTravelToPoint = (point, travelCallback, restricted = true)=>{
            if (!point) return;
            if (this.autoMovingInterval) clearInterval(this.autoMovingInterval);
            const { entity: playerEntity } = this;
            const distance = (0, $cb689cfa16c444ba$export$79376507b09a66f)(point.x, point.y, playerEntity.location.x, playerEntity.location.y);
            const tooClose = distance < 24;
            const tooFar = distance > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2;
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `scheduleAutoTravelToPoint: distance=${distance}, tooClose=${tooClose}, tooFar=${tooFar}, restricted=${restricted}`);
            if (!restricted || !tooClose && !tooFar) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Starting auto-travel to point (${point.x}, ${point.y}) from (${playerEntity.location.x}, ${playerEntity.location.y})`);
                this.autoTravelTo(point, travelCallback);
                return true;
            }
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Auto-travel blocked: tooClose=${tooClose}, tooFar=${tooFar}`);
            return false;
        };
        this.autoTravelToEntity = (entity, arriveCallback)=>{
            const targetCoordinate = (0, $a80d0b17b615d6f7$export$7d94067f6d99210b)(entity.location);
            return this.autoTravelTo(targetCoordinate, arriveCallback);
        };
        this.autoTravelTo = (targetCoordinate, arriveCallback)=>{
            const { entity: playerEntity } = this;
            this.setAutoMoving(true);
            this.client.boost(true);
            (0, $5UG8I.logger).info({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `autoTravelTo: Starting travel to (${targetCoordinate.x}, ${targetCoordinate.y}) from (${playerEntity.location.x}, ${playerEntity.location.y}) - CALLBACK EXECUTED IMMEDIATELY`);
            // BUG: This callback is executed immediately, not when arriving!
            arriveCallback();
            let startTs = Date.now();
            this.autoMovingInterval = setInterval(()=>{
                const distance = Math.floor((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(playerEntity.location, targetCoordinate));
                const tooClose = distance < 24;
                const tooFar = distance > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2;
                const isThere = (0, $a80d0b17b615d6f7$export$248d38f6296296c5)(targetCoordinate, playerEntity.location);
                if (tooClose || isThere || tooFar) {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `autoTravelTo: Arrived at destination! distance=${distance}, tooClose=${tooClose}, tooFar=${tooFar}, isThere=${isThere}`);
                    clearInterval(this.autoMovingInterval);
                    this.setAutoMoving(false);
                    this.targetSpeed2 = {
                        x: 0,
                        y: 0
                    };
                    this.client.boost(false);
                    return;
                }
                if (Date.now() - startTs < 200) return;
                // Set target speed2 for auto-travel
                this.targetSpeed2 = {
                    x: 0,
                    y: 0
                };
                if (Math.floor(playerEntity.location.x) > targetCoordinate.x) this.targetSpeed2.x = -1;
                else if (Math.floor(playerEntity.location.x) < targetCoordinate.x) this.targetSpeed2.x = 1;
                if (Math.floor(playerEntity.location.y) > targetCoordinate.y) this.targetSpeed2.y = -1;
                else if (Math.floor(playerEntity.location.y) < targetCoordinate.y) this.targetSpeed2.y = 1;
            }, 5);
        };
        this.updateCompositeTile = (x, y)=>{
            const entityTile = this.client.clientGameLogic.tilemapMetaProvider.getEntityTileAt(this.roughPointer.x, this.roughPointer.y);
            if (entityTile && x > -1 && y > -1) {
                this.roughCompositeTilePointer.x = x;
                this.roughCompositeTilePointer.y = y;
            } else (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(this.roughCompositeTilePointer);
        };
        this.startVelocityUpdates = ()=>{
            const updateInterval = 1000 / (0, $cb689cfa16c444ba$export$21eac3dda76c7241).UPDATE_FPS;
            this.velocityUpdateInterval = setInterval(()=>{
                this.updatePlayerVelocity();
            }, updateInterval);
        };
        this.stopVelocityUpdates = ()=>{
            if (this.velocityUpdateInterval) {
                clearInterval(this.velocityUpdateInterval);
                this.velocityUpdateInterval = null;
            }
        };
        this.updatePlayerVelocity = ()=>{
            if (!this.entity || !(0, $cb689cfa16c444ba$export$21eac3dda76c7241).ENABLED) return;
            // Stop movement if player is dead, downed or paralyzed. This loop OWNS entity.speed2, so
            // it is the one gate every kind of movement intent passes through -- held keys, a parked
            // joystick thumb, an auto-travel in progress.
            if (this.entity.isDead() || this.paralyzed || this.downed) {
                this.entity.speed2.x = 0;
                this.entity.speed2.y = 0;
                this.entity.movement.moving = false;
                return;
            }
            const friction = (0, $cb689cfa16c444ba$export$21eac3dda76c7241).FRICTION;
            const minThreshold = (0, $cb689cfa16c444ba$export$21eac3dda76c7241).MIN_VELOCITY_THRESHOLD;
            const acceleration = (0, $cb689cfa16c444ba$export$21eac3dda76c7241).ACCELERATION;
            // Check if any keys are pressed
            const keyboardMoving = this.isKeyOn("w") || this.isKeyOn("ArrowUp") || this.isKeyOn("s") || this.isKeyOn("ArrowDown") || this.isKeyOn("a") || this.isKeyOn("ArrowLeft") || this.isKeyOn("d") || this.isKeyOn("ArrowRight");
            // A held joystick is a held input too, and it owns the target vector while it is down:
            // its onChange fires only while the thumb actually moves, so nothing else would keep
            // targetSpeed2 current. The keyboard wins if somehow both are active.
            const joystick = this.joystickSpeed2;
            const isMoving = keyboardMoving || joystick !== null;
            if (joystick && !keyboardMoving) this.targetSpeed2 = this.entity.afk ? {
                x: 0,
                y: 0
            } : {
                x: joystick.x,
                y: joystick.y
            };
            // Check if we've been moving for more than 1 second
            const movementDuration = this.movementStartTime > 0 ? Date.now() - this.movementStartTime : 0;
            const shouldUseInertia = movementDuration > 700;
            if (isMoving) {
                // Update sustained movement state
                if (shouldUseInertia && !this.isSustainedMovement) this.isSustainedMovement = true;
                if (shouldUseInertia) {
                    // Keys are pressed and we've been moving for >1s - smoothly interpolate toward target
                    const diffX = this.targetSpeed2.x - this.entity.speed2.x;
                    const diffY = this.targetSpeed2.y - this.entity.speed2.y;
                    this.entity.speed2.x += diffX * acceleration;
                    this.entity.speed2.y += diffY * acceleration;
                } else {
                    // Keys are pressed but <1s - immediate response
                    this.entity.speed2.x = this.targetSpeed2.x;
                    this.entity.speed2.y = this.targetSpeed2.y;
                }
            } else // No keys pressed
            if (shouldUseInertia && this.isSustainedMovement) {
                // Apply friction to slow down only if we were in sustained movement
                this.entity.speed2.x *= friction;
                this.entity.speed2.y *= friction;
                // Stop movement if below threshold
                const speed = Math.sqrt(this.entity.speed2.x * this.entity.speed2.x + this.entity.speed2.y * this.entity.speed2.y);
                if (speed < minThreshold) {
                    this.entity.speed2.x = 0;
                    this.entity.speed2.y = 0;
                }
            } else {
                // Immediate stop for short movements
                this.entity.speed2.x = 0;
                this.entity.speed2.y = 0;
            }
            // Update movement state
            const speed = Math.sqrt(this.entity.speed2.x * this.entity.speed2.x + this.entity.speed2.y * this.entity.speed2.y);
            this.entity.movement.moving = speed > minThreshold;
        };
        this.destroy = ()=>{
            // Hand the input back. A reconnect builds a NEW Player (ClientGameLogic.initializePlayer)
            // and the keyboard's listener list is static, so a controller that leaves its listeners
            // behind has every keystroke answered twice from then on -- which reads, in chat, as every
            // character you type appearing twice.
            this.keyboardHandler.removeListener(this.respondToKeyBoard);
            this.keyboardHandler.removePasteListener(this.respondToPaste);
            this.mouseHandler.removeListener(this.respondToMouse);
            this.stopVelocityUpdates();
            if (this.movementDaemon) clearInterval(this.movementDaemon);
            if (this.autoMovingInterval) clearInterval(this.autoMovingInterval);
            if (this.keyboardAndleAdjustInterval) clearInterval(this.keyboardAndleAdjustInterval);
            if (this.fireInterval) clearInterval(this.fireInterval);
            if (this.mousePointerFadeInterval) clearTimeout(this.mousePointerFadeInterval);
        };
        this.client = client;
        this.entity = entity;
        this.mouseHandler = mouseHandler;
        this.keyboardHandler = keyboardHandler;
        this.guest = guest;
        keyboardHandler.addListener(this.respondToKeyBoard);
        keyboardHandler.addPasteListener(this.respondToPaste);
        mouseHandler.addListener(this.respondToMouse);
        // Start velocity update loop
        this.startVelocityUpdates();
    }
}




class $752781dc0ac4b8dc$export$2e2bcd8739ae039 {
    constructor(bounds, max_objects, max_levels, level){
        /**
     * Split the node into 4 subnodes
     */ this.split = ()=>{
            const nextLevel = this.level + 1, subWidth = this.bounds.width / 2, subHeight = this.bounds.height / 2, x = this.bounds.x, y = this.bounds.y;
            //top right node
            this.nodes[0] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x + subWidth,
                y: y,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
            //top left node
            this.nodes[1] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x,
                y: y,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
            //bottom left node
            this.nodes[2] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x,
                y: y + subHeight,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
            //bottom right node
            this.nodes[3] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x + subWidth,
                y: y + subHeight,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
        };
        /**
     * Determine which node the object belongs to
     */ this.getIndex = (pRect)=>{
            const indexes = [];
            const verticalMidpoint = this.bounds.x + this.bounds.width / 2;
            const horizontalMidpoint = this.bounds.y + this.bounds.height / 2;
            const startIsNorth = pRect.y < horizontalMidpoint;
            const startIsWest = pRect.x < verticalMidpoint;
            const endIsEast = pRect.x + pRect.width > verticalMidpoint;
            const endIsSouth = pRect.y + pRect.height > horizontalMidpoint;
            // Use bitwise operations for better performance
            //top-right quad
            if (startIsNorth && endIsEast) indexes.push(0);
            //top-left quad
            if (startIsWest && startIsNorth) indexes.push(1);
            //bottom-left quad
            if (startIsWest && endIsSouth) indexes.push(2);
            //bottom-right quad
            if (endIsEast && endIsSouth) indexes.push(3);
            return indexes;
        };
        /**
     * Insert the object into the node. If the node
     * exceeds the capacity, it will split and add all
     * objects to their corresponding subnodes.
     */ this.insert = (pRect)=>{
            //if we have subnodes, call insert on matching subnodes
            if (this.nodes.length) {
                const indexes = this.getIndex(pRect);
                for(let i = 0; i < indexes.length; i++)this.nodes[indexes[i]].insert(pRect);
                return;
            }
            //otherwise, store object here
            this.objects.push(pRect);
            //max_objects reached
            if (this.objects.length > this.max_objects && this.level < this.max_levels) {
                //   if we don't already have subnodes
                if (!this.nodes.length) this.split();
                //add all objects to their corresponding subnode
                const objectsToProcess = this.objects;
                this.objects = [] // Clear immediately to free memory
                ;
                for(let i = 0; i < objectsToProcess.length; i++){
                    const indexes = this.getIndex(objectsToProcess[i]);
                    for(let k = 0; k < indexes.length; k++)this.nodes[indexes[k]].insert(objectsToProcess[i]);
                }
            }
        };
        /**
     * Return all objects that could collide with the given object
     */ this.retrieve = (pRect)=>{
            // Early return if no objects in this node
            if (this.objects.length === 0 && this.nodes.length === 0) return [];
            let returnObjects = this.objects;
            //if we have subnodes, retrieve their objects
            if (this.nodes.length) {
                const indexes = this.getIndex(pRect);
                for(let i = 0; i < indexes.length; i++){
                    const subObjects = this.nodes[indexes[i]].retrieve(pRect);
                    if (subObjects.length > 0) returnObjects = returnObjects.concat(subObjects);
                }
            }
            // Use Set for O(1) duplicate removal instead of O(n²) indexOf
            if (returnObjects.length > 1) {
                const seen = new Set();
                const uniqueObjects = [];
                for (const obj of returnObjects)if (!seen.has(obj)) {
                    seen.add(obj);
                    uniqueObjects.push(obj);
                }
                return uniqueObjects;
            }
            return returnObjects;
        };
        /**
     * Clear the quadtree
     */ this.clear = ()=>{
            this.objects = [];
            for(let i = 0; i < this.nodes.length; i++)if (this.nodes.length) this.nodes[i].clear();
            this.nodes = [];
        };
        this.max_objects = max_objects || 10;
        this.max_levels = max_levels || 4;
        this.level = level || 0;
        this.bounds = bounds;
        this.objects = [];
        this.nodes = [];
    }
}



class $aa05461586bc3fba$export$8b098ebd5e242ae7 {
    constructor(entityManager, worldWidth, worldHeight){
        this.lastViewportBounds = null;
        this.cachedVisibleEntities = null;
        this.lastPlayerPos = null;
        this.cacheValid = false;
        // Cache invalidation settings
        this.CACHE_VALIDITY_MS = 100 // 100ms cache validity
        ;
        this.MOVEMENT_THRESHOLD = 16 // 16 pixels movement threshold
        ;
        // Entity movement tracking for efficient updates
        this.lastEntityPositions = new Map();
        this.entityUpdateListeners = new Set();
        // Performance tracking
        this.cacheHits = 0;
        this.cacheMisses = 0;
        this.totalQueries = 0;
        // Debug logging control
        this.debugLogLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(1000) // Log every 1000ms
        ;
        this.entityManager = entityManager;
        this.worldWidth = worldWidth;
        this.worldHeight = worldHeight;
        // Store bound listeners for proper cleanup
        this.boundUpdateListener = this.onEntityUpdate.bind(this);
        this.boundRemoveListener = this.onEntityRemove.bind(this);
        // Initialize quadtree for the entire world
        this.viewportQuadTree = new (0, $752781dc0ac4b8dc$export$2e2bcd8739ae039)({
            x: 0,
            y: 0,
            width: worldWidth,
            height: worldHeight
        }, 10, 6) // 10 objects per node, 6 levels deep
        ;
        // Register entity listeners for efficient updates
        this.setupEntityListeners();
        // Initial population of quadtree
        this.populateQuadTree();
    }
    setupEntityListeners() {
        // Listen for entity updates to keep quadtree in sync
        this.entityManager.registerSetListener(this.boundUpdateListener);
        this.entityManager.registerRemoveListener(this.boundRemoveListener);
    }
    onEntityUpdate(entity) {
        // Skip entities without valid location or entityId
        if (!entity || !entity.location || !entity.entityId) return;
        // Check if entity position actually changed
        const lastPos = this.lastEntityPositions.get(entity.entityId);
        const currentPos = {
            x: entity.location.x,
            y: entity.location.y
        };
        if (!lastPos || lastPos.x !== currentPos.x || lastPos.y !== currentPos.y) {
            this.updateEntityInQuadTree(entity);
            this.lastEntityPositions.set(entity.entityId, currentPos);
            this.invalidateCache();
        }
    }
    onEntityRemove(entity) {
        if (!entity || !entity.entityId) return;
        this.removeEntityFromQuadTree(entity.entityId);
        this.lastEntityPositions.delete(entity.entityId);
        this.invalidateCache();
    }
    populateQuadTree() {
        this.viewportQuadTree.clear();
        this.lastEntityPositions.clear();
        this.entityManager.iterate(null, (entity)=>{
            this.addEntityToQuadTree(entity);
            this.lastEntityPositions.set(entity.entityId, {
                x: entity.location.x,
                y: entity.location.y
            });
        });
    }
    addEntityToQuadTree(entity) {
        // Skip entities without valid location or entityId
        if (!entity || !entity.location || !entity.entityId) return;
        // Use fallback dimensions if entity doesn't have dimensions defined
        const width = entity.dimensions?.w || 32 // Default to tile size
        ;
        const height = entity.dimensions?.h || 32 // Default to tile size
        ;
        const rect = {
            x: entity.location.x - width / 2,
            y: entity.location.y - height / 2,
            width: width,
            height: height,
            entityId: entity.entityId
        };
        this.viewportQuadTree.insert(rect);
    }
    updateEntityInQuadTree(entity) {
        // Remove old position and add new position
        this.removeEntityFromQuadTree(entity.entityId);
        this.addEntityToQuadTree(entity);
    }
    removeEntityFromQuadTree(entityId) {
        // Note: Quadtree doesn't have a direct remove method, so we'll clear and repopulate
        // This is not optimal but works for now. A proper implementation would track rects by entityId
        this.populateQuadTree();
    }
    invalidateCache() {
        this.cacheValid = false;
        this.cachedVisibleEntities = null;
    }
    /**
     * Get entities visible in the viewport - O(log n) instead of O(n)
     */ getVisibleEntities(playerPos, viewportSize) {
        this.totalQueries++;
        // Check if cache is still valid
        if (this.cacheValid && this.isCacheStillValid(playerPos)) {
            this.cacheHits++;
            return this.cachedVisibleEntities.entities;
        }
        this.cacheMisses++;
        // Calculate viewport bounds
        const viewportBounds = this.calculateViewportBounds(playerPos, viewportSize);
        // Use quadtree to find entities in viewport area - MUCH faster than iterating all entities
        const foundRects = this.viewportQuadTree.retrieve({
            x: viewportBounds.x1,
            y: viewportBounds.y1,
            width: viewportBounds.width,
            height: viewportBounds.height
        });
        // Convert rects to entities and filter to actual visible entities
        const entitiesWithDistance = [];
        let processedCount = 0;
        let passedCullingCount = 0;
        for (const rect of foundRects){
            if (!rect.entityId) continue;
            const entity = this.entityManager.get(rect.entityId);
            if (!entity) continue;
            processedCount++;
            // Additional viewport bounds check for precision
            if (this.isEntityInViewport(entity, viewportBounds)) {
                passedCullingCount++;
                // Calculate distance for sorting
                const dx = entity.location.x - playerPos.x;
                const dy = entity.location.y - playerPos.y;
                const distSquared = dx * dx + dy * dy;
                entitiesWithDistance.push({
                    entity: entity,
                    distSquared: distSquared
                });
            }
        }
        // Sort by distance (closest first)
        entitiesWithDistance.sort((a, b)=>a.distSquared - b.distSquared);
        // Cache the result
        this.cachedVisibleEntities = {
            entities: entitiesWithDistance,
            playerPos: {
                x: playerPos.x,
                y: playerPos.y
            },
            timestamp: Date.now(),
            viewportBounds: viewportBounds
        };
        this.cacheValid = true;
        this.lastPlayerPos = {
            x: playerPos.x,
            y: playerPos.y
        };
        return entitiesWithDistance;
    }
    isCacheStillValid(playerPos) {
        if (!this.cachedVisibleEntities || !this.lastPlayerPos) return false;
        // Check if cache is too old
        if (Date.now() - this.cachedVisibleEntities.timestamp > this.CACHE_VALIDITY_MS) return false;
        // Check if player moved significantly
        const dx = Math.abs(playerPos.x - this.lastPlayerPos.x);
        const dy = Math.abs(playerPos.y - this.lastPlayerPos.y);
        return dx <= this.MOVEMENT_THRESHOLD && dy <= this.MOVEMENT_THRESHOLD;
    }
    calculateViewportBounds(playerPos, viewportSize) {
        const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
        const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
        // Use provided viewport size or default
        const viewportWidth = viewportSize?.width || X_FACTOR * 2 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const viewportHeight = viewportSize?.height || Y_FACTOR * 2 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        // Calculate viewport center
        let viewportCenterX = playerPos.x;
        let viewportCenterY = playerPos.y;
        // Handle edge cases (player at map boundaries)
        const inBoundsX = playerPos.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && playerPos.x < (this.worldWidth - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const inBoundsY = playerPos.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && playerPos.y < (this.worldHeight - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        if (!inBoundsX) {
            if (playerPos.x <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR) viewportCenterX = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR;
            else viewportCenterX = (this.worldWidth - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        }
        if (!inBoundsY) {
            if (playerPos.y <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR) viewportCenterY = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR;
            else viewportCenterY = (this.worldHeight - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        }
        const x1 = viewportCenterX - viewportWidth / 2;
        const y1 = viewportCenterY - viewportHeight / 2;
        const x2 = viewportCenterX + viewportWidth / 2;
        const y2 = viewportCenterY + viewportHeight / 2;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: viewportWidth,
            height: viewportHeight
        };
    }
    isEntityInViewport(entity, viewportBounds) {
        const entityX = entity.location.x;
        const entityY = entity.location.y;
        // Add small padding for entities that might be partially visible
        const padding = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
        return entityX >= viewportBounds.x1 - padding && entityX <= viewportBounds.x2 + padding && entityY >= viewportBounds.y1 - padding && entityY <= viewportBounds.y2 + padding;
    }
    /**
     * Force cache invalidation (useful when world changes)
     */ forceInvalidateCache() {
        this.invalidateCache();
    }
    /**
     * Reset the viewport manager for a new room - clears all data but keeps the instance
     * More efficient than destroying and recreating
     */ reset(newWorldWidth, newWorldHeight) {
        // Update world dimensions if provided
        if (newWorldWidth !== undefined) this.worldWidth = newWorldWidth;
        if (newWorldHeight !== undefined) this.worldHeight = newWorldHeight;
        // Clear all data
        this.viewportQuadTree.clear();
        this.lastEntityPositions.clear();
        this.cachedVisibleEntities = null;
        this.cacheValid = false;
        this.lastPlayerPos = null;
        this.lastViewportBounds = null;
        // Reset performance counters
        this.cacheHits = 0;
        this.cacheMisses = 0;
        this.totalQueries = 0;
        // Repopulate with current entities
        this.populateQuadTree();
    }
    /**
     * Get performance statistics
     */ getPerformanceStats() {
        const hitRate = this.totalQueries > 0 ? this.cacheHits / this.totalQueries * 100 : 0;
        return {
            cacheHits: this.cacheHits,
            cacheMisses: this.cacheMisses,
            totalQueries: this.totalQueries,
            hitRate: Math.round(hitRate * 100) / 100,
            quadtreeSize: this.lastEntityPositions.size
        };
    }
    /**
     * Cleanup resources
     */ destroy() {
        // Properly unregister listeners using stored references
        this.entityManager.unregisterSetListener(this.boundUpdateListener);
        this.entityManager.unregisterRemoveListener(this.boundRemoveListener);
        this.viewportQuadTree.clear();
        this.lastEntityPositions.clear();
        this.cachedVisibleEntities = null;
        this.cacheValid = false;
    }
}


const $1e46c45e333c583b$export$e1d138f8777c998e = {
    value: ""
};
class $1e46c45e333c583b$export$99cd19a42c3acc3f {
    static{
        // Radius (px) around the focused entity kept live for the PiP. Slightly larger than the PiP
        // viewport so entities entering frame are already interpolating. Tune with the PiP size.
        this.FOCUS_RENDER_RADIUS = 14 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    constructor(factory){
        this.destroyedEntities = new Set();
        this.destroyedEntitiesLagBuffer = new Set();
        // Viewport bounds caching
        this.cachedViewportBounds = {
            minX: 0,
            maxX: 0,
            minY: 0,
            maxY: 0
        };
        this.viewportBoundsValid = false;
        this.VIEWPORT_CACHE_THRESHOLD = 16 // Only recalculate if player moves more than 16 pixels
        ;
        this.expiredTs = 0;
        this.lagbufferTs = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(1500);
        this.quadrantId = "";
        this.entityManager = new (0, $7b78839962f6da5d$export$c7b7134fd828a5)((0, $cb689cfa16c444ba$export$ede76e7dc512924d));
        this.currentBrightness = 0.0;
        // Faction tracking: offscreen edge arrows pointing to members of a faction.
        // trackedFaction is set by the server (per-room) on room entry; trackingEnabled
        // is toggled by the player in the client.
        this.trackedFaction = null;
        this.trackingEnabled = false;
        // This room's atmosphere -- leaves, fog, butterflies (see RoomAmbience). Configured per room by
        // the server and sent on every room entry, empty included, so a camp's weather cannot follow the
        // player out. Read by the renderer's effects each frame; null before the first room entry, which
        // they treat as nothing at all.
        this.ambience = null;
        // Recent speech per entity, so the faction tracker can show a chat bubble on the
        // arrow when a tracked member speaks while offscreen (its own world-space bubble
        // would be off-screen). Expires like the avatar HUD bubble.
        this.recentSpeech = new Map();
        // Last line each entity said, kept a fixed ~10s (longer than recentSpeech's ~3s window), for the
        // follow-cam PiP caption so a distant roster member's last words linger there a while.
        this.lastSpeech = new Map();
        // Ember roster role per entity, mirrored from the roster broadcast so the offscreen
        // faction tracker can show each member's role glyph (👑/🛡️/🪓). The roster itself is
        // routed to the HUD widget; here we keep only the entityId -> role lookup.
        this.emberRoles = new Map();
        // Follow-cam: the entity the picture-in-picture view is watching (set by the ember roster
        // click). While set, its neighborhood is kept "near" for rendering/interpolation so the PiP
        // shows it live, wherever it is in the room.
        this.focusEntityId = null;
        this.incompleteEntities = new Set();
        // Unified culling system - single source of truth for entity distance culling
        this.CULLING_DISTANCE_TILES = 3;
        this.cullingDistanceSquared = this.CULLING_DISTANCE_TILES * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (this.CULLING_DISTANCE_TILES * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        // Entity sorting cache invalidation tracking
        this.entitySortCacheInvalidated = false;
        // Spatial indexing for efficient culling
        this.viewportManager = null;
        this.hasEntity = (entityId)=>!!this.entityManager.get(entityId);
        this.getEntity = (entityId)=>this.entityManager.get(entityId);
        this.updateScores = (scores)=>{
            const scoreEntityIds = Object.keys(scores);
            scoreEntityIds.forEach((entityId)=>{
                const entity = this.getEntity(entityId);
                if (entity) this.clientRenderer.entity().update(entity, scores[entityId]);
            });
        };
        /**
     * Empty the world out before a reconnect hands us a new one.
     *
     * A new socket is a NEW session: the server destroys the player on close, so a reconnect comes
     * back with a different entityId and (for an ember player) a different room. Everything drawn
     * right now belongs to the session that just ended.
     *
     * initializePlayer cannot do this itself -- it only overwrites the `playerEntity` POINTER,
     * leaving the previous avatar in the entity manager and on the stage -- and neither can the
     * room-change teardown in updateFromWorldState, which deliberately spares whatever
     * `playerEntity` points at so a player survives walking between rooms. So the old player has to
     * go from here, explicitly, before anybody takes their place.
     *
     * `roomId` is cleared too, so the first world state of the new session reads as a room change
     * and rebuilds the tilemap rather than being taken for more of the room we just left.
     */ this.prepareForReconnect = ()=>{
            const toRemove = [];
            this.entityManager.iterate(null, (next)=>{
                this.clientRenderer.entity().destroy(next);
                toRemove.push(next.entityId);
            });
            toRemove.forEach((entityId)=>this.entityManager.remove(entityId));
            this.playerEntity = undefined;
            this.roomId = undefined;
            this.incompleteEntities.clear();
            this.destroyedEntities.clear();
            this.destroyedEntitiesLagBuffer.clear();
            this.viewportManager?.reset();
            this.invalidateViewportCache();
            this.invalidateEntitySortCache();
        };
        this.initializePlayer = (entityId, client, guest)=>{
            $1e46c45e333c583b$export$e1d138f8777c998e.value = entityId;
            const playerEntity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            playerEntity.entityType = "player";
            playerEntity.entityId = entityId;
            playerEntity.dimensions = {
                ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)["player"]
            };
            playerEntity.hp = -1;
            playerEntity.mana = -1;
            playerEntity.hunger = -1;
            playerEntity.visible = false;
            this.playerEntity = playerEntity;
            this.entityManager.set(this.playerEntity);
            // A reconnect comes back through here with the old controller still listening to the
            // keyboard and mouse. Letting it go first is what stops its listeners doubling up with the
            // new one's.
            this.playerController?.destroy();
            this.playerController = new (0, $319b1dfd90d3ebea$export$2616165974278734)(client, playerEntity, this.clientRenderer.mouse(), this.clientRenderer.keyboard(), guest);
            this.clientRenderer.entity().create(playerEntity);
            this.clientRenderer.gui().helpMessaging();
        };
        this.updatePlayerEntityId = (entityId)=>{
            if (!this.playerEntity) return;
            const originalEntityId = this.playerEntity.entityId;
            this.playerEntity.entityId = entityId;
            this.clientRenderer.entity().updateEntityId(originalEntityId, entityId);
        };
        this.shouldInterpolate = (entity)=>{
            // No point in interpolating this client"s entity.
            if (entity.entityId == this.playerEntity?.entityId) return false;
            // its a local bullet; don"t interpolate
            if (this.entityManager.contains(entity.entityId, "bullet")) return false;
            return true;
        };
        this.createEntity = (message)=>{
            const { entityId: entityId, entityType: entityType } = message;
            if (this.destroyedEntitiesLagBuffer.has(entityId) || message.entityState === "dead") return;
            if (entityId === this.playerEntity?.entityId) return this.playerEntity;
            // create a local client entity based on the remote message from the server
            const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            entity.entityType = entityType;
            entity.npcType = message.npcType;
            entity.spriteId = message.spriteId;
            entity.entityId = entityId;
            entity.position_buffer = [];
            if (message.origin) entity.origin = {
                ...message.origin
            };
            entity.maxDistance = message.maxDistance;
            entity.location = {
                x: message?.position[0],
                y: message?.position[1]
            };
            entity.movement.direction = message.direction;
            entity.movement.angle = message.angle;
            entity.speed = message.speed;
            entity.speed2 = message.speed2;
            entity.color = message.color;
            entity.dimensions = message.dimensions || {
                ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)[entityType]
            };
            entity.hp = -1;
            entity.roomId = message.entityId;
            entity.clickable = message.clickable;
            entity.inventory = message.inventory;
            entity.expirationTs = message.expirationTs;
            entity.debug = message.debug;
            entity.active = message.active;
            // abort entity creation if its already travelled the maximum distance; should only
            // in theory apply to bullets
            if (entity.maxDistance !== undefined && entity.travelledDistance() > entity.maxDistance) return;
            this.entityManager.set(entity);
            // Check if the new entity is within viewport - if so, invalidate cache
            if (!this.isTooDistantFromPlayer(entity)) this.entitySortCacheInvalidated = true;
            //// for any created entity -- create a renderable representation
            //// and add it onto the displayable surface
            this.clientRenderer.entity().create(entity);
            return entity;
        };
        this.canFireBulletFrom = (source)=>{
            if (!this.playerEntity.visible) // can"t fire bullets when you are visible
            // todo - serverside enforcement
            return false;
            if (!source.canShootBullets) return false;
            const { weapon: weapon } = source;
            const weaponType = weapon?.weaponType || "none";
            const characteristics = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType];
            if (!characteristics) return false;
            if (source.mana < characteristics.manaCost) return false;
            if (this.lastWeapon?.weaponType !== weaponType) {
                this.lastFireTs = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(characteristics.firingLatchMs);
                this.lastWeapon = weapon;
            }
            if (!this.lastFireTs.expired()) return false;
            const ammoNeeded = (0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[weaponType];
            if (ammoNeeded) {
                const foundAmmo = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(source.inventory, ammoNeeded);
                if (!foundAmmo || foundAmmo.quantity < 1) {
                    this.handleChat("I need craft or buy more " + ammoNeeded + "s.", source.entityId, "");
                    let foundSlot;
                    (0, $f684496fff50a7a1$export$696bbd6109262d72)(source.inventory).find((item, slot)=>{
                        if (!(0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[item.itemType]) {
                            foundSlot = slot;
                            return item;
                        }
                    });
                    if (foundSlot !== undefined) this.clientRenderer.gui().activateInventorySlot(foundSlot + 1);
                    return false;
                }
            }
            return true;
        };
        this.createBulletFrom = (source)=>{
            const bullets = (0, $66e35324756c76b6$export$b4792961ac683a30)(this.lastWeapon, {
                ...source.location,
                roomId: source.roomId
            }, source.movement);
            return bullets;
        };
        this.createBombFrom = (source)=>{
            if (!this.playerEntity.visible) // can"t fire bullets when you are visible
            // todo - serverside enforcement
            return;
            if (!source.canLayBomb) return;
            if (source.mana < 3) return;
            if (!source.inventory?.items.find((item)=>item.itemType === "bomb")) return;
            const bomb = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            bomb.entityType = "bomb";
            bomb.location = {
                ...source.location
            };
            bomb.entityId = (0, $87befc68df50040c$export$2e2bcd8739ae039)();
            bomb.dimensions = {
                ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)[bomb.entityType]
            };
            bomb.speed = 600;
            bomb.roomId = source.roomId;
            this.entityManager.set(bomb);
            ////
            this.clientRenderer.entity().create(bomb);
            return bomb;
        };
        this.isBootstrapped = ()=>{
            return this.roomId && this.tilemapMetaProvider;
        };
        this.updateFromWorldState = (worldState)=>{
            const { scores: scores, tilemaps: tilemaps, worldMetaDimensions: worldMetaDimensions, tilemapMeta: tilemapMeta, visibility: visibility, roomId: roomId, roomName: roomName, leaderboards: leaderboards, dayPhase: dayPhase, dayPct: dayPct, biomeColorMap: biomeColorMap, locationIcons: locationIcons, playerLocations: playerLocations, minimapConfig: minimapConfig, runLevel: runLevel } = worldState;
            const updatedRoom = this.roomId !== roomId;
            let updatedQuadrant = false;
            if (updatedRoom) {
                //
                // we"re in a new room
                //
                this.runLevel = runLevel;
                this.dayPhase = null;
                this.roomId = roomId;
                // Reset viewport manager for new room (more efficient than destroying/recreating)
                if (this.viewportManager) this.viewportManager.reset();
                // Clear viewport cache when room changes since map dimensions may change
                this.invalidateViewportCache();
                const currentQuardrantId = (0, $a80d0b17b615d6f7$export$4418bd227bd6a76a)(roomId, worldMetaDimensions);
                if (this.quadrantId !== currentQuardrantId) {
                    this.quadrantId = currentQuardrantId;
                    updatedQuadrant = true;
                }
                const toRemove = [];
                this.entityManager.iterate(null, (next)=>{
                    if (next.entityId !== this.playerEntity.entityId) {
                        this.clientRenderer.entity().destroy(next);
                        toRemove.push(next.entityId);
                    }
                });
                for(let i = 0; i < toRemove.length; i++)this.entityManager.remove(toRemove[i]);
                this.incompleteEntities.clear();
                this.clientRenderer.gui().roomUpdated(roomId, roomName, visibility?.suppressMinimap, visibility?.suppressDayCycle, visibility?.suppressControlBar, visibility?.suppressLevelUp, visibility?.suppressMana, visibility?.suppressFood, visibility?.suppressShards, visibility?.suppressPlayerName, visibility?.suppressTutorial, visibility?.suppressGuestPrompt);
                this.clientRenderer.gui().updateLeaderboard(null);
                clearInterval(this.brightnessInterval);
                this.currentBrightness = dayPhase ? dayPhase.brightness : 0.0;
                if (dayPct !== undefined) this.clientRenderer.gui().updateDayPct(dayPct);
                this.updateDayPhase(dayPhase);
                this.playerController.updateRoom();
            }
            if (scores) this.updateScores(scores);
            if (updatedRoom && tilemaps && tilemapMeta) {
                this.tilemapMetaProvider = new (0, $93a024e1e74df758$export$c8df09a865c1d736)(roomId, tilemapMeta, tilemaps, worldMetaDimensions);
                this.tilemapMetaProvider.biomeColorMap = biomeColorMap;
                this.tilemapMetaProvider.locationIcons = locationIcons;
                this.tilemapMetaProvider.minimapConfig = minimapConfig;
                this.entitySortCacheInvalidated = true;
                // Initialize spatial indexing for efficient culling
                this.initializeViewportManager();
                this.clientRenderer.map().update(this.tilemapMetaProvider, visibility ? visibility : dayPhase ? {
                    darkness: dayPhase.brightness
                } : undefined);
                this.playerController.enabledMouseAction(true);
                this.playerController.enabledKeyboardAction(true);
                // Landing in a room is landing on your feet -- an ember "restart" arrives this way
                // rather than as a respawn, and nothing else in a whole-room load would lift the
                // death freeze the run before left behind.
                this.playerController.setDowned(false);
                this.fadeInOut("in");
                setTimeout(()=>{
                    this.playerController.perturb();
                }, 100);
            }
            if (leaderboards) this.clientRenderer.gui().updateLeaderboard(leaderboards);
            if (playerLocations) this.clientRenderer.entity().updatePlayerLocations(playerLocations);
            if (updatedRoom) {
                this.playerController.client.requestPlayerLocations();
                this.playerController.client.requestVisibility();
            }
            updatedQuadrant;
            return updatedRoom;
        };
        this.updateFromPlayerMessage = (message)=>{
            if (this.playerEntity.entityId !== message.entityId) return;
            if (message.roomId !== this.playerEntity.roomId) this.playerEntity.roomId = message.roomId;
            this.playerEntity.mana = message.mana;
            this.playerEntity.visible = message.visible;
            this.playerEntity.canShootBullets = message.canShootBullets;
            this.playerEntity.canLayBomb = message.canLayBomb;
            // A fallen player who hasn't been stood back up yet doesn't get to walk around. Taken
            // from the server's verdict on every message rather than from a local timer, so it lifts
            // the instant the server lifts it -- and can't outlive it, which is what would strand a
            // player who was already alive again behind a controller that still thought otherwise.
            this.playerController.setDowned(!!message.downed);
            // ...and whether they are wearing one of another camp's attackers, which is what puts the
            // "Let go" button on the screen. Same shape as `downed` for the same reason: it is the
            // server's verdict on every message, so the only way out of a body cannot outlive it (or
            // go missing while it lives) because of a local timer disagreeing.
            this.clientRenderer.gui().setInvading(!!message.invading);
            // this.playerController.paralyze(message.paralyzeUntilTs > Date.now())
            this.playerEntity.upgradePoints = message.upgradePoints;
            this.clientRenderer.entity().update(this.playerEntity);
            if (message.inventory) this.updateInventoryFrom(this.playerEntity, message);
            this.started = true;
        };
        this.updateFromNonPlayerMessage = (message)=>{
            if (this.playerEntity.entityId === message.entityId) return;
            if (message.roomId !== this.playerEntity.roomId) return;
            const entity = this.entityManager.get(message.entityId);
            if (!entity) return;
            if (message.inventory) this.updateInventoryFrom(entity, message);
        };
        this.updateInventoryFrom = (entity, message)=>{
            if (this.clientRenderer.gui().updateInventory(entity, message.inventory)) {
                entity.inventory = {
                    ...message.inventory
                };
                return true;
            }
            return false;
        };
        this.scheduleForDestruction = (entityId)=>{
            this.destroyedEntities.add(entityId);
            this.destroyedEntitiesLagBuffer.add(entityId);
        };
        this.isDestroyed = (entityId)=>this.destroyedEntities.has(entityId);
        this.destroyEntity = (entity)=>{
            if (entity) {
                this.entitySortCacheInvalidated = true;
                this.clientRenderer.entity().destroy(entity);
            }
        };
        this.processEntities = (dt_sec)=>{
            // process bullets
            this.entityManager.iterate("bullet", (bullet)=>{
                if (bullet.isDead()) {
                    this.scheduleForDestruction(bullet.entityId);
                    return;
                }
                const result = (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.checkout();
                bullet.applyInput(undefined, dt_sec, bullet.speed2, result.data, (0, $cb689cfa16c444ba$export$7e89f2bfd67dd894)(this.tilemapMetaProvider), true);
                if (!result.data?.movedX && !result.data?.movedY) this.scheduleForDestruction(bullet.entityId);
                else {
                    const distance = bullet.travelledDistance();
                    if (distance > bullet.maxDistance) this.scheduleForDestruction(bullet.entityId);
                }
                (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.release(result);
            });
        };
        this.cleanup = ()=>{
            const now = Date.now();
            if (now - this.expiredTs > 3000) this.entityManager.iterate(null, (next)=>{
                this.scheduleForDestruction(next.entityId);
            }, (next)=>next.entityId !== this.playerEntity.entityId && next.roomId !== this.roomId);
            this.destroyedEntities.forEach((entityId)=>{
                const entity = this.entityManager.get(entityId);
                if (entity) {
                    this.destroyEntity(entity);
                    this.entityManager.remove(entity.entityId);
                }
            });
            this.destroyedEntities.clear();
            if (this.lagbufferTs.expired()) this.destroyedEntitiesLagBuffer.clear();
        };
        // Unified culling system methods
        this.setFocusEntityId = (entityId)=>{
            this.focusEntityId = entityId;
        };
        // True if a follow-cam focus is active and the given location is within the focus render
        // radius of it — used to keep the focused entity's neighborhood rendering/interpolating even
        // when it is far from the player (so the PiP view is live).
        this.isNearFocus = (location)=>{
            if (!this.focusEntityId) return false;
            const focus = this.entityManager.get(this.focusEntityId);
            if (!focus) return false;
            return (0, $cb689cfa16c444ba$export$79376507b09a66f)(location.x, location.y, focus.location.x, focus.location.y) < $1e46c45e333c583b$export$99cd19a42c3acc3f.FOCUS_RENDER_RADIUS;
        };
        this.isTooDistantFromPlayer = (entity)=>{
            return this.isTooDistantFromPlayerByLocation(entity.entityId, entity.location);
        };
        // Unified culling system methods
        this.isTooDistantFromPlayerByLocation = (entityId, entityLocation)=>{
            if (entityId === this.playerEntity.entityId) return false // Never cull the player
            ;
            return !this.isEntityWithinCullingDistance(entityId, entityLocation, this.playerEntity.location);
        };
        this.isPlayerInitialized = ()=>{
            return !(this.playerEntity.location?.x === -1 && this.playerEntity.location?.y === -1);
        };
        // Efficient culling check that combines distance and viewport-based culling
        this.isEntityWithinCullingDistance = (entityId, entityLocation, playerPos)=>{
            if (entityId === this.playerEntity.entityId) return true // Always include player
            ;
            // Keep the follow-cam focus neighborhood live even when it is off the main viewport, so
            // the picture-in-picture view renders and interpolates it.
            if (this.isNearFocus(entityLocation)) return true;
            // // First check: distance-based culling (existing)
            // const dx = entity.location.x - playerPos.x
            // const dy = entity.location.y - playerPos.y
            // const distSquared = dx * dx + dy * dy
            // if (distSquared > this.cullingDistanceSquared) {
            //     return false
            // }
            // Second check: viewport-based culling (new)
            const viewportBounds = this.getViewportBounds(playerPos);
            const entityX = entityLocation.x;
            const entityY = entityLocation.y;
            const isWithinViewport = entityX >= viewportBounds.minX && entityX <= viewportBounds.maxX && entityY >= viewportBounds.minY && entityY <= viewportBounds.maxY;
            return isWithinViewport;
        };
        // Pure viewport test against the player's current position (no follow-cam focus exemption).
        // Used by the follow-cam PiP to hide itself once the watched entity is visible on the main screen.
        this.isWithinPlayerViewport = (location)=>{
            const bounds = this.getViewportBounds(this.playerEntity.location);
            return location.x >= bounds.minX && location.x <= bounds.maxX && location.y >= bounds.minY && location.y <= bounds.maxY;
        };
        // Get culling distance for other systems
        this.getCullingDistanceTiles = ()=>{
            return this.CULLING_DISTANCE_TILES;
        };
        this.getCullingDistanceSquared = ()=>{
            return this.cullingDistanceSquared;
        };
        // Check if entities need to be resorted for rendering optimization
        this.shouldResortEntities = (playerPos)=>{
            // Check if player moved significantly
            const playerMoved = !this.lastPlayerPosForViewport || Math.abs(playerPos.x - this.lastPlayerPosForViewport.x) > 25 || Math.abs(playerPos.y - this.lastPlayerPosForViewport.y) > 25;
            // Check if cache was invalidated due to new entities in viewport
            const playerInitialized = this.isPlayerInitialized();
            const shouldResort = !playerInitialized || playerMoved || this.entitySortCacheInvalidated;
            if (shouldResort) {
                this.lastPlayerPosForViewport = {
                    x: playerPos.x,
                    y: playerPos.y
                };
                this.entitySortCacheInvalidated = false;
            }
            return shouldResort;
        };
        // Invalidate viewport cache when needed (e.g., when map changes)
        this.invalidateViewportCache = ()=>{
            this.viewportBoundsValid = false;
            // Reset viewport manager to prevent stale data (more efficient than destroy)
            if (this.viewportManager) this.viewportManager.reset();
        };
        // Invalidate entity sort cache when needed (e.g., when player position updates)
        this.invalidateEntitySortCache = ()=>{
            this.entitySortCacheInvalidated = true;
        };
        // Optimized viewport bounds calculation with caching
        this.getViewportBounds = (playerPos)=>{
            // Check if we need to recalculate based on player movement
            const playerMoved = this.lastPlayerPosForViewport && (Math.abs(playerPos.x - this.lastPlayerPosForViewport.x) > this.VIEWPORT_CACHE_THRESHOLD || Math.abs(playerPos.y - this.lastPlayerPosForViewport.y) > this.VIEWPORT_CACHE_THRESHOLD);
            if (!this.viewportBoundsValid || playerMoved) {
                this.calculateViewportBounds(playerPos);
                this.lastPlayerPosForViewport = {
                    x: playerPos.x,
                    y: playerPos.y
                };
                this.viewportBoundsValid = true;
            }
            return this.cachedViewportBounds;
        };
        this.calculateViewportBounds = (playerPos)=>{
            const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
            const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
            // Calculate viewport center based on TranslationComputer logic
            let viewportCenterX = playerPos.x;
            let viewportCenterY = playerPos.y;
            // Check if player is in bounds (not at edges)
            const inBoundsX = playerPos.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && playerPos.x < (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const inBoundsY = playerPos.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && playerPos.y < (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            // If not in bounds, use edge positions (like TranslationComputer)
            if (!inBoundsX) {
                if (playerPos.x <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR) viewportCenterX = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR;
                else viewportCenterX = (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            }
            if (!inBoundsY) {
                if (playerPos.y <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR) viewportCenterY = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR;
                else viewportCenterY = (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            }
            // Calculate viewport bounds
            const offsetWidth = X_FACTOR * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const offsetHeight = Y_FACTOR * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            // Update the cached bounds object instead of creating a new one
            this.cachedViewportBounds.minX = viewportCenterX - offsetWidth;
            this.cachedViewportBounds.maxX = viewportCenterX + offsetWidth;
            this.cachedViewportBounds.minY = viewportCenterY - offsetHeight;
            this.cachedViewportBounds.maxY = viewportCenterY + offsetHeight;
        };
        this.doStruck = (entityId, strikerEntityId)=>{
            const entity = this.entityManager.get(entityId);
            if (!entity) return;
            if (!this.isTooDistantFromPlayer(entity)) {
                this.clientRenderer.entity().animateStrikeOn(entity);
                this.audio.hit(entity);
            }
            const strikerEntity = this.entityManager.get(strikerEntityId);
            if (strikerEntity) this.scheduleForDestruction(strikerEntityId);
            if (entity.entityId === this.playerEntity.entityId) {
                this.clientRenderer.map().screenShake(entity);
                if (entity.hp < Math.max(3, Math.ceil(entity.maxHp * 0.6))) this.clientRenderer.gui().pulseDamage();
            }
        };
        this.tileEffect = (effect)=>{
            if (effect.hp !== undefined && effect.hpMax !== undefined && effect.effectType === "damage") this.tilemapMetaProvider.updateMapDeltaWithHP(effect.mapRoughCoordinates, effect.hp, effect.hpMax);
            this.clientRenderer.map().tileEffect(effect);
            if (![
                "tallGrass",
                "tallReeds"
            ].includes(effect.entityTile)) this.audio.play("woodhit", {
                volume: 0.125,
                speed: 0.85 + Math.min(0.15, Math.random())
            });
        };
        this.detonate = (entityId)=>{
            const entity = this.entityManager.get(entityId);
            if (entity) {
                if (!this.isTooDistantFromPlayer(entity)) this.clientRenderer.entity().detonate(entity);
            }
        };
        this.attack = (entityId, trigger)=>{
            const entity = this.entityManager.get(entityId);
            if (entity) {
                if (!this.isTooDistantFromPlayer(entity)) {
                    this.playerController.client.startAttack(entityId);
                    this.clientRenderer.entity().attack(entity, trigger);
                    this.audio.attack(entity);
                }
            }
        };
        this.updateActivation = (entityId, active)=>{
            const entity = this.entityManager.get(entityId);
            if (entity) this.clientRenderer.entity().updateActivation(entity, active);
        };
        this.itemPickup = (entity, itemTypeMeta, quantity)=>{
            this.clientRenderer.entity().itemPickedUp(entity, itemTypeMeta, quantity);
            this.audio.pickup(itemTypeMeta);
        };
        this.orientation = (orientation)=>{
            this.playerController.updateOrientation(orientation);
        };
        this.emp = (entityId, range)=>{
            const entity = this.entityManager.get(entityId);
            if (entity) {
                this.clientRenderer.entity().emp(entity, range);
                this.audio.emp(entity);
            }
        };
        this.sparkle = (entityId)=>{
            const entity = this.entityManager.get(entityId);
            if (entity) {
                if (!this.isTooDistantFromPlayer(entity)) this.clientRenderer.entity().sparkle(entity);
            }
        };
        this.killed = (entityId)=>{
            const entity = this.entityManager.get(entityId);
            if (entityId === this.playerEntity.entityId) {
                this.clientRenderer.entity().death(this.playerEntity);
                this.playerController.paralyze(true, 5000);
            // this.clientRenderer.gui().fadeOut()
            } else if (entity) {
                this.clientRenderer.entity().death(entity);
                this.audio.death(entity);
            }
        };
        this.respawned = (entityId)=>{
            if (entityId === this.playerEntity.entityId) {
                // Alive again: lift the death freeze here rather than waiting for the next world-state
                // message to say so. The server cleared it before sending this, so the two agree --
                // this just spares the player a beat of being stood up but unable to move.
                this.playerController.setDowned(false);
                this.fadeInOut("in");
                setTimeout(()=>{
                    this.playerController.perturb();
                }, 100);
            }
        };
        this.teleported = (entityId)=>{
            if (entityId === this.playerEntity.entityId) this.clientRenderer.map().reset();
        };
        this.pleaseWait = ()=>{
            this.clientRenderer.gui().addScreenMessage({
                text: "Loading, please wait...",
                target: "important"
            });
            this.fadeInOut("inOut", 10000);
        };
        this.fadeInOut = (direction, timeOut = 1000)=>{
            if (direction === "in") {
                if (this.blackedOutTimeout) {
                    clearTimeout(this.blackedOutTimeout);
                    this.blackedOutTimeout = undefined;
                }
                this.clientRenderer.gui().fadeIn();
                this.playerController.paralyze(false);
            }
            if (direction === "out") {
                this.clientRenderer.gui().fadeOut(true);
                this.playerController.paralyze(true, timeOut);
            }
            if (direction === "inOut") {
                this.fadeInOut("out", timeOut);
                this.blackedOutTimeout = setTimeout(()=>{
                    this.fadeInOut("in");
                }, timeOut);
            }
        };
        this.advanceEntity = (result, entity, message, allowSlide)=>{
            if (!this.tilemapMetaProvider) return;
            return entity.applyInput(message.angle, message.press_time, message.speed2, result, (0, $cb689cfa16c444ba$export$7e89f2bfd67dd894)(this.tilemapMetaProvider), allowSlide, allowSlide);
        };
        this.advancePlayer = (result, message)=>{
            const { x: originalX, y: originalY } = this.playerEntity.location;
            this.advanceEntity(result, this.playerEntity, message, true);
            this.clientRenderer.updatePlayerLocation(this.playerEntity);
            if (originalX !== this.playerEntity.location.x || originalY !== this.playerEntity.location.y) this.audio.walk(this.playerEntity);
        };
        // `hold` marks a line the player dismisses themselves: its bubble grows a "Next" button and
        // stays up until pressed, and anything the same entity says meanwhile queues behind it (see
        // AvatarHud.spoke). `holdId` is the token the speaker gave that line; pressing Next sends it
        // back so a script pacing a conversation off the player (ember-tutorial.js) knows WHICH line was
        // read and may speak the next one. The HUD-side copies below still expire on the usual clock --
        // they are captions for a speaker the player can't see, not the bubble itself.
        this.handleChat = (message, entityId, entityName, hold, holdId)=>{
            const entity = this.entityManager.get(entityId);
            // Player chat is server-wide by design, so the LOG takes every line it is given, wherever
            // the speaker is standing. Nothing SPATIAL does: a bubble, an offscreen arrow's caption, the
            // PiP caption -- those all claim the speaker is somewhere near, and for a speaker in another
            // room that is simply false.
            //
            // The server already keeps out-of-room lines off the wire (ServerGameLogic
            // .broadcastChatMessage), but a client can still be HOLDING a speaker it has just left
            // behind: entities are discarded lazily on a room change, so for a moment the camp the
            // player walked out of is still in the entity manager. A HELD line landing there never
            // fades -- it sits and everything after it queues up, which is the "the other camp's Lord is
            // collecting in mine" bug.
            const elsewhere = !!entity?.roomId && entity.roomId !== this.playerEntity?.roomId;
            if (entityName) this.clientRenderer.gui().appendChatHistory(message, entityName);
            if (entity && !elsewhere) this.clientRenderer.entity().spoke(entity, message, {
                hold: hold,
                onDismissed: hold ? ()=>this.playerController?.client?.sendSpeechDismissed(entityId, holdId) : undefined
            });
            if (elsewhere) return;
            // Record speech so an offscreen tracked member's bubble can ride its arrow.
            // Duration mirrors the avatar HUD bubble (avatar_hud.spokeImpl).
            const wordCount = message.split(" ").length;
            const durationMs = Math.max(3000, wordCount * 60 / 200 * 1250);
            this.recentSpeech.set(entityId, {
                text: message,
                expiresAt: Date.now() + durationMs
            });
            // Longer-lived copy for the follow-cam PiP caption.
            this.lastSpeech.set(entityId, {
                text: message,
                expiresAt: Date.now() + 10000
            });
        };
        // Returns the entity's current speech-bubble text, or null if none/expired.
        this.getRecentSpeech = (entityId)=>{
            const s = this.recentSpeech.get(entityId);
            if (!s) return null;
            if (Date.now() >= s.expiresAt) {
                this.recentSpeech.delete(entityId);
                return null;
            }
            return s.text;
        };
        // Returns the entity's last spoken line for the follow-cam PiP caption, or null once it's older
        // than ~10s. Outlives getRecentSpeech so the PiP keeps showing the last words a while.
        this.getLastSpeech = (entityId)=>{
            const s = this.lastSpeech.get(entityId);
            if (!s) return null;
            if (Date.now() >= s.expiresAt) {
                this.lastSpeech.delete(entityId);
                return null;
            }
            return s.text;
        };
        // Mirror the latest ember roster into the entityId -> role lookup used by the offscreen
        // faction tracker. Called alongside the HUD widget update from the roster broadcast.
        this.setEmberRoster = (roster)=>{
            this.emberRoles.clear();
            for (const entry of roster)this.emberRoles.set(entry.entityId, entry.role);
        };
        this.getEmberRole = (entityId)=>this.emberRoles.get(entityId) ?? null;
        this.hideRoomName = (hidden)=>{
            this.clientRenderer.gui().hideRoomName(hidden);
        };
        this.updateLocation = (location, roomId)=>{
            if (!roomId || roomId === this.roomId) this.clientRenderer.gui().updateLocation(location);
        };
        this.renderScene = ()=>{
            // one ring to rule them all
            this.clientRenderer.render();
        };
        // Get shadow performance metrics for debugging
        this.getShadowPerformanceMetrics = ()=>{
            return this.clientRenderer.getShadowPerformanceMetrics();
        };
        // Force shadow texture update (useful for debugging)
        this.forceShadowTextureUpdate = ()=>{
            this.clientRenderer.forceShadowTextureUpdate();
        };
        this.createLocalEntity = (entitySrc)=>{
            const entity = (0, $cb689cfa16c444ba$export$bc644a473284d944).fromJson(entitySrc);
            setTimeout(()=>{
                this.entityManager.set(entity);
                this.clientRenderer.entity().create(entity);
            }, 250);
        };
        this.destroyLocalEntity = (targetFlags)=>{
            this.entityManager.collect((entity)=>{
                return !Object.keys(targetFlags).find((flag)=>targetFlags[flag] !== entity.flags[flag]);
            }).forEach((entity)=>{
                entity.visible = false;
                this.scheduleForDestruction(entity.entityId);
            });
        };
        this.playSoundEffect = (effect, loop, target)=>{
            this.audio.soundEffect(effect, loop, target);
        };
        this.enablePlayerMouseAction = (enabled)=>this.playerController?.enabledMouseAction(enabled);
        this.animateLocalEntityCollection = (entityId, target, position)=>{
            const entity = this.entityManager.get(entityId);
            if (!entity) return;
            entity.visible = false;
            this.clientRenderer.gui().animateLocalEntityCollection(entity, target, position);
        };
        this.animateAbility = (abilityType, duration)=>{
            this.clientRenderer.gui().animateAbility(abilityType, duration);
        };
        this.upgradedAccount = ()=>{
            this.playerController.setIsGuest(false);
            this.clientRenderer.gui().helpMessaging();
        };
        this.updateDayPhase = (phase)=>{
            if (phase?.name !== this.dayPhase?.name) {
                this.dayPhase = {
                    ...phase
                };
                const targetBrightness = this.dayPhase.brightness;
                if (this.brightnessInterval) clearInterval(this.brightnessInterval);
                this.brightnessInterval = setInterval(()=>{
                    if (this.currentBrightness > targetBrightness) this.currentBrightness -= 0.01;
                    else if (this.currentBrightness < targetBrightness) this.currentBrightness += 0.01;
                    if (Math.abs(this.currentBrightness - targetBrightness) <= 0.01) {
                        clearInterval(this.brightnessInterval);
                        this.currentBrightness = targetBrightness;
                    }
                    const currentVisibility = this.clientRenderer.map().getVisibility();
                    const visibility = {
                        ...currentVisibility || {},
                        darkness: this.currentBrightness
                    };
                    this.clientRenderer.map().update(null, visibility);
                }, 60);
            }
        };
        this.log = (text)=>{
            this.playerController.client.logActivity(text);
        };
        this.incompleteEntity = (entity)=>{
            this.incompleteEntities.add(entity.entityId);
        };
        this.nearbyIncompleteEntities = ()=>{
            const entities = [];
            this.incompleteEntities.forEach((e)=>{
                if (e === this.playerEntity.entityId) return false;
                const inc = this.entityManager.get(e);
                if (!inc) return false;
                const distance = (0, $cb689cfa16c444ba$export$79376507b09a66f)(inc.location.x, inc.location.y, this.playerEntity.location.x, this.playerEntity.location.y);
                if (distance < 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) entities.push(e);
            });
            return entities;
        };
        this.clearIncompleteEntities = (entityIds)=>{
            entityIds.forEach((id)=>{
                this.incompleteEntities.delete(id);
            });
        };
        this.saveAppearance = (appearance)=>{
            this.playerController.client.saveAppearance(appearance);
        };
        this.invokeCrafting = ()=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_CRAFTING",
                context: {}
            });
        };
        this.invokeInventory = (inventoryActionToken)=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_INVENTORY",
                context: {
                    actionToken: inventoryActionToken
                }
            });
        };
        this.invokeQuests = ()=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_QUESTS",
                context: {}
            });
        };
        this.emitConversationResponse = (response)=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "CONVERSATION_RESPONSE",
                context: response
            });
        };
        this.requestEntityInteractions = (entityId)=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_ENTITY_INTERACTIONS",
                context: {
                    entityId: entityId
                }
            });
        };
        this.interactionCallback = (entityId, interaction)=>{
            // Clicking an interaction icon must never also trigger a world attack. The click that
            // fires attacks originates from a document-level mousedown that doesn't know a pixi
            // interaction widget was hit, so briefly suppress attacks around the activation.
            this.playerController.suppressAttack();
            this.playerController.client.emitPlayerEvent({
                playerEventType: "ACTIVATE_ENTITY_INTERACTION",
                context: {
                    interaction: interaction,
                    entityId: entityId
                }
            });
        };
        this.selectSlot = (itemId)=>{
            const item = this.playerEntity.inventory?.items.find((i)=>i.id === itemId);
            if (!item) return;
            this.playerController.client.inventoryAction(this.playerEntity.entityId, itemId, item.active ? "deactivate" : "activate");
        };
        // Back out of an armed placement (the "Place" option on a buildable item, or a build the player
        // no longer wants to commit). Deactivating the item is what actually ends build mode: the server's
        // building atom turns the terrain pointer back off when it sees INACTIVATE_ITEM.
        this.cancelBuildPlacement = ()=>{
            const item = this.playerEntity?.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            if (!item) return;
            this.playerController.client.inventoryAction(this.playerEntity.entityId, item.id, "deactivate");
        };
        this.activateWorldPoint = (roomFinePoint, options)=>{
            if ((0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(roomFinePoint)) return;
            this.playerController.client.activateWorldPoint(roomFinePoint, options);
        };
        this.entityClicked = (entity)=>{
            if (entity.clickable) // todo - rename this, entity.clickable means that the server has some
            // plan for whenever the player explicitly clicks on the entity
            this.playerController.client.entityClicked(entity);
        };
        // Spatial indexing methods for efficient culling
        this.initializeViewportManager = ()=>{
            if (!this.tilemapMetaProvider) return;
            // Get world dimensions
            const worldWidth = this.tilemapMetaProvider.width() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const worldHeight = this.tilemapMetaProvider.height() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            // Reuse existing viewport manager if it exists, otherwise create new one
            if (this.viewportManager) // Reset with new dimensions
            this.viewportManager.reset(worldWidth, worldHeight);
            else // Create new viewport manager
            this.viewportManager = new (0, $aa05461586bc3fba$export$8b098ebd5e242ae7)(this.entityManager, worldWidth, worldHeight);
        };
        // Apply a server-sent faction-tracking config (e.g. on entering an ember room).
        this.setFactionTracking = (config)=>{
            this.trackedFaction = config.faction;
            this.trackingEnabled = config.enabled && !!config.faction;
        };
        // Apply a server-sent room ambience (sent on every room entry, empty included).
        this.setRoomAmbience = (ambience)=>{
            this.ambience = ambience;
        };
        // Player-facing toggle. No-op unless a faction has been designated for this room.
        // Returns the resulting enabled state.
        this.toggleFactionTracking = ()=>{
            if (!this.trackedFaction) return false;
            this.trackingEnabled = !this.trackingEnabled;
            return this.trackingEnabled;
        };
        // Get visible entities using spatial indexing - O(log n) instead of O(n)
        this.getVisibleEntities = (playerPos)=>{
            if (!this.viewportManager) // Fallback to old method if viewport manager not initialized
            return this.getVisibleEntitiesFallback(playerPos);
            return this.viewportManager.getVisibleEntities(playerPos);
        };
        // Fallback method using the old O(n) approach
        this.getVisibleEntitiesFallback = (playerPos)=>{
            const allEntities = this.entityManager.collect(()=>true);
            const entitiesWithDistance = [];
            for (const entity of allEntities)if (this.isEntityWithinCullingDistance(entity.entityId, entity.location, playerPos)) {
                const dx = entity.location.x - playerPos.x;
                const dy = entity.location.y - playerPos.y;
                const distSquared = dx * dx + dy * dy;
                entitiesWithDistance.push({
                    entity: entity,
                    distSquared: distSquared
                });
            }
            entitiesWithDistance.sort((a, b)=>a.distSquared - b.distSquared);
            return entitiesWithDistance;
        };
        // Get performance statistics for the viewport manager
        this.getViewportManagerStats = ()=>{
            return this.viewportManager?.getPerformanceStats() || null;
        };
        // Force cache invalidation (useful for debugging)
        this.forceInvalidateViewportCache = ()=>{
            this.viewportManager?.forceInvalidateCache();
        };
        this.clientRenderer = factory.create(this);
        this.audio = new (0, $479d799412e4e1cb$export$153755f98d9861de)(this);
    }
}



const $1016737a9aedcca9$export$542cb9bd603edb0f = [
    "lpc/spritesheets/body/male/human/white.png.json",
    "lpc/spritesheets/weapon/slash/male/dagger.png.json",
    "lpc/spritesheets/weapon/slash/male/dagger_brown.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json",
    "lpc/spritesheets/weapon/slash/male/axe_2.png.json",
    "lpc/spritesheets/weapon/slash/male/warhammer.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_2.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_black.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_green.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_metal.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_purple.png.json",
    "lpc/spritesheets/weapon/bow/normal.png.json",
    "lpc/spritesheets/weapon/thrust/male/crossbow.png.json",
    "lpc/spritesheets/weapon/thrust/male/simple_staff.png.json",
    "lpc/spritesheets/body/female/human/white.png.json",
    "lpc/spritesheets/weapon/slash/female/dagger.png.json",
    "lpc/spritesheets/weapon/slash/female/dagger_brown.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json",
    "lpc/spritesheets/weapon/slash/female/axe_2.png.json",
    "lpc/spritesheets/weapon/slash/female/warhammer.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_2.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_black.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_green.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_metal.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_purple.png.json",
    "lpc/spritesheets/weapon/thrust/female/crossbow.png.json",
    "lpc/spritesheets/weapon/thrust/female/simple_staff.png.json",
    "lpc/spritesheets/body/male/human/black.png.json",
    "lpc/spritesheets/body/female/human/black.png.json",
    "lpc/spritesheets/body/male/human/olive.png.json",
    "lpc/spritesheets/body/female/human/olive.png.json",
    "lpc/spritesheets/body/male/human/brown.png.json",
    "lpc/spritesheets/body/female/human/brown.png.json",
    "lpc/spritesheets/body/male/human/light.png.json",
    "lpc/spritesheets/body/female/human/light.png.json",
    "lpc/spritesheets/body/male/human/dark.png.json",
    "lpc/spritesheets/body/female/human/dark.png.json",
    "lpc/spritesheets/body/male/human/tanned.png.json",
    "lpc/spritesheets/body/female/human/tanned.png.json",
    "lpc/spritesheets/body/male/reptiles/green_unwinged.png.json",
    "lpc/spritesheets/body/female/reptiles/green_unwinged.png.json",
    "lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json",
    "lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json",
    "lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json",
    "lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json",
    "lpc/spritesheets/body/male/reptiles/green_winged.png.json",
    "lpc/spritesheets/body/female/reptiles/green_winged.png.json",
    "lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json",
    "lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json",
    "lpc/spritesheets/body/male/reptiles/blue_winged.png.json",
    "lpc/spritesheets/body/female/reptiles/blue_winged.png.json",
    "lpc/spritesheets/body/male/orcs/gray.png.json",
    "lpc/spritesheets/body/female/orcs/gray.png.json",
    "lpc/spritesheets/body/male/orcs/green_1.png.json",
    "lpc/spritesheets/body/female/orcs/green_1.png.json",
    "lpc/spritesheets/body/male/orcs/green_3.png.json",
    "lpc/spritesheets/body/female/orcs/green_3.png.json",
    "lpc/spritesheets/body/male/wolf/brown.png.json",
    "lpc/spritesheets/body/male/wolf/head/brown.png.json",
    "lpc/spritesheets/body/female/wolf/brown.png.json",
    "lpc/spritesheets/body/female/wolf/head/brown.png.json",
    "lpc/spritesheets/body/male/wolf/black.png.json",
    "lpc/spritesheets/body/male/wolf/head/black.png.json",
    "lpc/spritesheets/body/female/wolf/black.png.json",
    "lpc/spritesheets/body/female/wolf/head/black.png.json",
    "lpc/spritesheets/body/male/wolf/gray.png.json",
    "lpc/spritesheets/body/male/wolf/head/gray.png.json",
    "lpc/spritesheets/body/female/wolf/gray.png.json",
    "lpc/spritesheets/body/female/wolf/head/gray.png.json",
    "lpc/spritesheets/body/male/wolf/white.png.json",
    "lpc/spritesheets/body/male/wolf/head/white.png.json",
    "lpc/spritesheets/body/female/wolf/white.png.json",
    "lpc/spritesheets/body/female/wolf/head/white.png.json",
    "lpc/spritesheets/body/skeleton/beige.png.json",
    "lpc/spritesheets/body/skeleton/gray.png.json",
    "lpc/spritesheets/body/skeleton/green.png.json",
    "lpc/spritesheets/body/male/special/zombie.png.json",
    "lpc/spritesheets/hair/afro/male/white.png.json",
    "lpc/spritesheets/hair/afro/male/blonde.png.json",
    "lpc/spritesheets/hair/afro/male/gold.png.json",
    "lpc/spritesheets/hair/afro/male/green.png.json",
    "lpc/spritesheets/hair/afro/male/blue.png.json",
    "lpc/spritesheets/hair/afro/male/red.png.json",
    "lpc/spritesheets/hair/afro/male/orange.png.json",
    "lpc/spritesheets/hair/afro/male/purple.png.json",
    "lpc/spritesheets/hair/afro/male/dark_brown.png.json",
    "lpc/spritesheets/hair/afro/male/light_brown.png.json",
    "lpc/spritesheets/hair/afro/male/gray.png.json",
    "lpc/spritesheets/hair/afro/male/black.png.json",
    "lpc/spritesheets/hair/balding/male/white.png.json",
    "lpc/spritesheets/hair/balding/male/blonde.png.json",
    "lpc/spritesheets/hair/balding/male/gold.png.json",
    "lpc/spritesheets/hair/balding/male/green.png.json",
    "lpc/spritesheets/hair/balding/male/blue.png.json",
    "lpc/spritesheets/hair/balding/male/red.png.json",
    "lpc/spritesheets/hair/balding/male/orange.png.json",
    "lpc/spritesheets/hair/balding/male/purple.png.json",
    "lpc/spritesheets/hair/balding/male/dark_brown.png.json",
    "lpc/spritesheets/hair/balding/male/light_brown.png.json",
    "lpc/spritesheets/hair/balding/male/gray.png.json",
    "lpc/spritesheets/hair/balding/male/black.png.json",
    "lpc/spritesheets/hair/bangs/male/white.png.json",
    "lpc/spritesheets/hair/bangs/male/blonde.png.json",
    "lpc/spritesheets/hair/bangs/male/gold.png.json",
    "lpc/spritesheets/hair/bangs/male/green.png.json",
    "lpc/spritesheets/hair/bangs/male/blue.png.json",
    "lpc/spritesheets/hair/bangs/male/red.png.json",
    "lpc/spritesheets/hair/bangs/male/orange.png.json",
    "lpc/spritesheets/hair/bangs/male/purple.png.json",
    "lpc/spritesheets/hair/bangs/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangs/male/gray.png.json",
    "lpc/spritesheets/hair/bangs/male/black.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/white.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/blonde.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/gold.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/green.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/blue.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/red.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/orange.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/purple.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/gray.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/black.png.json",
    "lpc/spritesheets/hair/bangslong/male/white.png.json",
    "lpc/spritesheets/hair/bangslong/male/blonde.png.json",
    "lpc/spritesheets/hair/bangslong/male/gold.png.json",
    "lpc/spritesheets/hair/bangslong/male/green.png.json",
    "lpc/spritesheets/hair/bangslong/male/blue.png.json",
    "lpc/spritesheets/hair/bangslong/male/red.png.json",
    "lpc/spritesheets/hair/bangslong/male/orange.png.json",
    "lpc/spritesheets/hair/bangslong/male/purple.png.json",
    "lpc/spritesheets/hair/bangslong/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong/male/gray.png.json",
    "lpc/spritesheets/hair/bangslong/male/black.png.json",
    "lpc/spritesheets/hair/bangslong2/male/white.png.json",
    "lpc/spritesheets/hair/bangslong2/male/blonde.png.json",
    "lpc/spritesheets/hair/bangslong2/male/gold.png.json",
    "lpc/spritesheets/hair/bangslong2/male/green.png.json",
    "lpc/spritesheets/hair/bangslong2/male/blue.png.json",
    "lpc/spritesheets/hair/bangslong2/male/red.png.json",
    "lpc/spritesheets/hair/bangslong2/male/orange.png.json",
    "lpc/spritesheets/hair/bangslong2/male/purple.png.json",
    "lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/male/gray.png.json",
    "lpc/spritesheets/hair/bangslong2/male/black.png.json",
    "lpc/spritesheets/hair/bangsshort/male/white.png.json",
    "lpc/spritesheets/hair/bangsshort/male/blonde.png.json",
    "lpc/spritesheets/hair/bangsshort/male/gold.png.json",
    "lpc/spritesheets/hair/bangsshort/male/green.png.json",
    "lpc/spritesheets/hair/bangsshort/male/blue.png.json",
    "lpc/spritesheets/hair/bangsshort/male/red.png.json",
    "lpc/spritesheets/hair/bangsshort/male/orange.png.json",
    "lpc/spritesheets/hair/bangsshort/male/purple.png.json",
    "lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/male/gray.png.json",
    "lpc/spritesheets/hair/bangsshort/male/black.png.json",
    "lpc/spritesheets/hair/bedhead/male/white.png.json",
    "lpc/spritesheets/hair/bedhead/male/blonde.png.json",
    "lpc/spritesheets/hair/bedhead/male/gold.png.json",
    "lpc/spritesheets/hair/bedhead/male/green.png.json",
    "lpc/spritesheets/hair/bedhead/male/blue.png.json",
    "lpc/spritesheets/hair/bedhead/male/red.png.json",
    "lpc/spritesheets/hair/bedhead/male/orange.png.json",
    "lpc/spritesheets/hair/bedhead/male/purple.png.json",
    "lpc/spritesheets/hair/bedhead/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bedhead/male/light_brown.png.json",
    "lpc/spritesheets/hair/bedhead/male/gray.png.json",
    "lpc/spritesheets/hair/bedhead/male/black.png.json",
    "lpc/spritesheets/hair/bob/male/white.png.json",
    "lpc/spritesheets/hair/bob/male/blonde.png.json",
    "lpc/spritesheets/hair/bob/male/gold.png.json",
    "lpc/spritesheets/hair/bob/male/green.png.json",
    "lpc/spritesheets/hair/bob/male/blue.png.json",
    "lpc/spritesheets/hair/bob/male/red.png.json",
    "lpc/spritesheets/hair/bob/male/orange.png.json",
    "lpc/spritesheets/hair/bob/male/purple.png.json",
    "lpc/spritesheets/hair/bob/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bob/male/light_brown.png.json",
    "lpc/spritesheets/hair/bob/male/gray.png.json",
    "lpc/spritesheets/hair/bob/male/black.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/white.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/blonde.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/gold.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/green.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/blue.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/red.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/orange.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/purple.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/light_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/gray.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/black.png.json",
    "lpc/spritesheets/hair/braid/male/white.png.json",
    "lpc/spritesheets/hair/braid/male/blonde.png.json",
    "lpc/spritesheets/hair/braid/male/gold.png.json",
    "lpc/spritesheets/hair/braid/male/green.png.json",
    "lpc/spritesheets/hair/braid/male/blue.png.json",
    "lpc/spritesheets/hair/braid/male/red.png.json",
    "lpc/spritesheets/hair/braid/male/orange.png.json",
    "lpc/spritesheets/hair/braid/male/purple.png.json",
    "lpc/spritesheets/hair/braid/male/dark_brown.png.json",
    "lpc/spritesheets/hair/braid/male/light_brown.png.json",
    "lpc/spritesheets/hair/braid/male/gray.png.json",
    "lpc/spritesheets/hair/braid/male/black.png.json",
    "lpc/spritesheets/hair/braid2/male/white.png.json",
    "lpc/spritesheets/hair/braid2/male/blonde.png.json",
    "lpc/spritesheets/hair/braid2/male/gold.png.json",
    "lpc/spritesheets/hair/braid2/male/green.png.json",
    "lpc/spritesheets/hair/braid2/male/blue.png.json",
    "lpc/spritesheets/hair/braid2/male/red.png.json",
    "lpc/spritesheets/hair/braid2/male/orange.png.json",
    "lpc/spritesheets/hair/braid2/male/purple.png.json",
    "lpc/spritesheets/hair/braid2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/braid2/male/light_brown.png.json",
    "lpc/spritesheets/hair/braid2/male/gray.png.json",
    "lpc/spritesheets/hair/braid2/male/black.png.json",
    "lpc/spritesheets/hair/bunches/male/white.png.json",
    "lpc/spritesheets/hair/bunches/male/blonde.png.json",
    "lpc/spritesheets/hair/bunches/male/gold.png.json",
    "lpc/spritesheets/hair/bunches/male/green.png.json",
    "lpc/spritesheets/hair/bunches/male/blue.png.json",
    "lpc/spritesheets/hair/bunches/male/red.png.json",
    "lpc/spritesheets/hair/bunches/male/orange.png.json",
    "lpc/spritesheets/hair/bunches/male/purple.png.json",
    "lpc/spritesheets/hair/bunches/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bunches/male/light_brown.png.json",
    "lpc/spritesheets/hair/bunches/male/gray.png.json",
    "lpc/spritesheets/hair/bunches/male/black.png.json",
    "lpc/spritesheets/hair/buzzcut/male/white.png.json",
    "lpc/spritesheets/hair/buzzcut/male/blonde.png.json",
    "lpc/spritesheets/hair/buzzcut/male/gold.png.json",
    "lpc/spritesheets/hair/buzzcut/male/green.png.json",
    "lpc/spritesheets/hair/buzzcut/male/blue.png.json",
    "lpc/spritesheets/hair/buzzcut/male/red.png.json",
    "lpc/spritesheets/hair/buzzcut/male/orange.png.json",
    "lpc/spritesheets/hair/buzzcut/male/purple.png.json",
    "lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/male/light_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/male/gray.png.json",
    "lpc/spritesheets/hair/buzzcut/male/black.png.json",
    "lpc/spritesheets/hair/cornrows/male/white.png.json",
    "lpc/spritesheets/hair/cornrows/male/blonde.png.json",
    "lpc/spritesheets/hair/cornrows/male/gold.png.json",
    "lpc/spritesheets/hair/cornrows/male/green.png.json",
    "lpc/spritesheets/hair/cornrows/male/blue.png.json",
    "lpc/spritesheets/hair/cornrows/male/red.png.json",
    "lpc/spritesheets/hair/cornrows/male/orange.png.json",
    "lpc/spritesheets/hair/cornrows/male/purple.png.json",
    "lpc/spritesheets/hair/cornrows/male/dark_brown.png.json",
    "lpc/spritesheets/hair/cornrows/male/light_brown.png.json",
    "lpc/spritesheets/hair/cornrows/male/gray.png.json",
    "lpc/spritesheets/hair/cornrows/male/black.png.json",
    "lpc/spritesheets/hair/cowlick/male/white.png.json",
    "lpc/spritesheets/hair/cowlick/male/blonde.png.json",
    "lpc/spritesheets/hair/cowlick/male/gold.png.json",
    "lpc/spritesheets/hair/cowlick/male/green.png.json",
    "lpc/spritesheets/hair/cowlick/male/blue.png.json",
    "lpc/spritesheets/hair/cowlick/male/red.png.json",
    "lpc/spritesheets/hair/cowlick/male/orange.png.json",
    "lpc/spritesheets/hair/cowlick/male/purple.png.json",
    "lpc/spritesheets/hair/cowlick/male/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick/male/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick/male/gray.png.json",
    "lpc/spritesheets/hair/cowlick/male/black.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/white.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/gold.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/green.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/blue.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/red.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/orange.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/purple.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/gray.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/black.png.json",
    "lpc/spritesheets/hair/curly_long/male/white.png.json",
    "lpc/spritesheets/hair/curly_long/male/blonde.png.json",
    "lpc/spritesheets/hair/curly_long/male/gold.png.json",
    "lpc/spritesheets/hair/curly_long/male/green.png.json",
    "lpc/spritesheets/hair/curly_long/male/blue.png.json",
    "lpc/spritesheets/hair/curly_long/male/red.png.json",
    "lpc/spritesheets/hair/curly_long/male/orange.png.json",
    "lpc/spritesheets/hair/curly_long/male/purple.png.json",
    "lpc/spritesheets/hair/curly_long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_long/male/light_brown.png.json",
    "lpc/spritesheets/hair/curly_long/male/gray.png.json",
    "lpc/spritesheets/hair/curly_long/male/black.png.json",
    "lpc/spritesheets/hair/curly_short/male/white.png.json",
    "lpc/spritesheets/hair/curly_short/male/blonde.png.json",
    "lpc/spritesheets/hair/curly_short/male/gold.png.json",
    "lpc/spritesheets/hair/curly_short/male/green.png.json",
    "lpc/spritesheets/hair/curly_short/male/blue.png.json",
    "lpc/spritesheets/hair/curly_short/male/red.png.json",
    "lpc/spritesheets/hair/curly_short/male/orange.png.json",
    "lpc/spritesheets/hair/curly_short/male/purple.png.json",
    "lpc/spritesheets/hair/curly_short/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_short/male/light_brown.png.json",
    "lpc/spritesheets/hair/curly_short/male/gray.png.json",
    "lpc/spritesheets/hair/curly_short/male/black.png.json",
    "lpc/spritesheets/hair/curtains/male/white.png.json",
    "lpc/spritesheets/hair/curtains/male/blonde.png.json",
    "lpc/spritesheets/hair/curtains/male/gold.png.json",
    "lpc/spritesheets/hair/curtains/male/green.png.json",
    "lpc/spritesheets/hair/curtains/male/blue.png.json",
    "lpc/spritesheets/hair/curtains/male/red.png.json",
    "lpc/spritesheets/hair/curtains/male/orange.png.json",
    "lpc/spritesheets/hair/curtains/male/purple.png.json",
    "lpc/spritesheets/hair/curtains/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains/male/light_brown.png.json",
    "lpc/spritesheets/hair/curtains/male/gray.png.json",
    "lpc/spritesheets/hair/curtains/male/black.png.json",
    "lpc/spritesheets/hair/curtains_long/male/white.png.json",
    "lpc/spritesheets/hair/curtains_long/male/blonde.png.json",
    "lpc/spritesheets/hair/curtains_long/male/gold.png.json",
    "lpc/spritesheets/hair/curtains_long/male/green.png.json",
    "lpc/spritesheets/hair/curtains_long/male/blue.png.json",
    "lpc/spritesheets/hair/curtains_long/male/red.png.json",
    "lpc/spritesheets/hair/curtains_long/male/orange.png.json",
    "lpc/spritesheets/hair/curtains_long/male/purple.png.json",
    "lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/male/light_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/male/gray.png.json",
    "lpc/spritesheets/hair/curtains_long/male/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/black.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/white.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/gold.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/green.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/blue.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/red.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/orange.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/purple.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/gray.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/black.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/white.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/gold.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/green.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/blue.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/red.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/orange.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/purple.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/gray.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/black.png.json",
    "lpc/spritesheets/hair/half_up/male/white.png.json",
    "lpc/spritesheets/hair/half_up/male/blonde.png.json",
    "lpc/spritesheets/hair/half_up/male/gold.png.json",
    "lpc/spritesheets/hair/half_up/male/green.png.json",
    "lpc/spritesheets/hair/half_up/male/blue.png.json",
    "lpc/spritesheets/hair/half_up/male/red.png.json",
    "lpc/spritesheets/hair/half_up/male/orange.png.json",
    "lpc/spritesheets/hair/half_up/male/purple.png.json",
    "lpc/spritesheets/hair/half_up/male/dark_brown.png.json",
    "lpc/spritesheets/hair/half_up/male/light_brown.png.json",
    "lpc/spritesheets/hair/half_up/male/gray.png.json",
    "lpc/spritesheets/hair/half_up/male/black.png.json",
    "lpc/spritesheets/hair/halfmessy/male/white.png.json",
    "lpc/spritesheets/hair/halfmessy/male/blonde.png.json",
    "lpc/spritesheets/hair/halfmessy/male/gold.png.json",
    "lpc/spritesheets/hair/halfmessy/male/green.png.json",
    "lpc/spritesheets/hair/halfmessy/male/blue.png.json",
    "lpc/spritesheets/hair/halfmessy/male/red.png.json",
    "lpc/spritesheets/hair/halfmessy/male/orange.png.json",
    "lpc/spritesheets/hair/halfmessy/male/purple.png.json",
    "lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/male/light_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/male/gray.png.json",
    "lpc/spritesheets/hair/halfmessy/male/black.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/white.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/blonde.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/gold.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/green.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/blue.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/red.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/orange.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/purple.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/gray.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/black.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/white.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/blonde.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/gold.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/green.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/blue.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/red.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/orange.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/purple.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/gray.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/black.png.json",
    "lpc/spritesheets/hair/idol/male/white.png.json",
    "lpc/spritesheets/hair/idol/male/blonde.png.json",
    "lpc/spritesheets/hair/idol/male/gold.png.json",
    "lpc/spritesheets/hair/idol/male/green.png.json",
    "lpc/spritesheets/hair/idol/male/blue.png.json",
    "lpc/spritesheets/hair/idol/male/red.png.json",
    "lpc/spritesheets/hair/idol/male/orange.png.json",
    "lpc/spritesheets/hair/idol/male/purple.png.json",
    "lpc/spritesheets/hair/idol/male/dark_brown.png.json",
    "lpc/spritesheets/hair/idol/male/light_brown.png.json",
    "lpc/spritesheets/hair/idol/male/gray.png.json",
    "lpc/spritesheets/hair/idol/male/black.png.json",
    "lpc/spritesheets/hair/jewfro/male/white.png.json",
    "lpc/spritesheets/hair/jewfro/male/blonde.png.json",
    "lpc/spritesheets/hair/jewfro/male/gold.png.json",
    "lpc/spritesheets/hair/jewfro/male/green.png.json",
    "lpc/spritesheets/hair/jewfro/male/blue.png.json",
    "lpc/spritesheets/hair/jewfro/male/red.png.json",
    "lpc/spritesheets/hair/jewfro/male/orange.png.json",
    "lpc/spritesheets/hair/jewfro/male/purple.png.json",
    "lpc/spritesheets/hair/jewfro/male/dark_brown.png.json",
    "lpc/spritesheets/hair/jewfro/male/light_brown.png.json",
    "lpc/spritesheets/hair/jewfro/male/gray.png.json",
    "lpc/spritesheets/hair/jewfro/male/black.png.json",
    "lpc/spritesheets/hair/lob/male/white.png.json",
    "lpc/spritesheets/hair/lob/male/blonde.png.json",
    "lpc/spritesheets/hair/lob/male/gold.png.json",
    "lpc/spritesheets/hair/lob/male/green.png.json",
    "lpc/spritesheets/hair/lob/male/blue.png.json",
    "lpc/spritesheets/hair/lob/male/red.png.json",
    "lpc/spritesheets/hair/lob/male/orange.png.json",
    "lpc/spritesheets/hair/lob/male/purple.png.json",
    "lpc/spritesheets/hair/lob/male/dark_brown.png.json",
    "lpc/spritesheets/hair/lob/male/light_brown.png.json",
    "lpc/spritesheets/hair/lob/male/gray.png.json",
    "lpc/spritesheets/hair/lob/male/black.png.json",
    "lpc/spritesheets/hair/long/male/white.png.json",
    "lpc/spritesheets/hair/long/male/blonde.png.json",
    "lpc/spritesheets/hair/long/male/gold.png.json",
    "lpc/spritesheets/hair/long/male/green.png.json",
    "lpc/spritesheets/hair/long/male/blue.png.json",
    "lpc/spritesheets/hair/long/male/red.png.json",
    "lpc/spritesheets/hair/long/male/orange.png.json",
    "lpc/spritesheets/hair/long/male/purple.png.json",
    "lpc/spritesheets/hair/long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long/male/light_brown.png.json",
    "lpc/spritesheets/hair/long/male/gray.png.json",
    "lpc/spritesheets/hair/long/male/black.png.json",
    "lpc/spritesheets/hair/long_band/male/white.png.json",
    "lpc/spritesheets/hair/long_band/male/blonde.png.json",
    "lpc/spritesheets/hair/long_band/male/gold.png.json",
    "lpc/spritesheets/hair/long_band/male/green.png.json",
    "lpc/spritesheets/hair/long_band/male/blue.png.json",
    "lpc/spritesheets/hair/long_band/male/red.png.json",
    "lpc/spritesheets/hair/long_band/male/orange.png.json",
    "lpc/spritesheets/hair/long_band/male/purple.png.json",
    "lpc/spritesheets/hair/long_band/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_band/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_band/male/gray.png.json",
    "lpc/spritesheets/hair/long_band/male/black.png.json",
    "lpc/spritesheets/hair/long_center_part/male/white.png.json",
    "lpc/spritesheets/hair/long_center_part/male/blonde.png.json",
    "lpc/spritesheets/hair/long_center_part/male/gold.png.json",
    "lpc/spritesheets/hair/long_center_part/male/green.png.json",
    "lpc/spritesheets/hair/long_center_part/male/blue.png.json",
    "lpc/spritesheets/hair/long_center_part/male/red.png.json",
    "lpc/spritesheets/hair/long_center_part/male/orange.png.json",
    "lpc/spritesheets/hair/long_center_part/male/purple.png.json",
    "lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/male/gray.png.json",
    "lpc/spritesheets/hair/long_center_part/male/black.png.json",
    "lpc/spritesheets/hair/long_messy/male/white.png.json",
    "lpc/spritesheets/hair/long_messy/male/blonde.png.json",
    "lpc/spritesheets/hair/long_messy/male/gold.png.json",
    "lpc/spritesheets/hair/long_messy/male/green.png.json",
    "lpc/spritesheets/hair/long_messy/male/blue.png.json",
    "lpc/spritesheets/hair/long_messy/male/red.png.json",
    "lpc/spritesheets/hair/long_messy/male/orange.png.json",
    "lpc/spritesheets/hair/long_messy/male/purple.png.json",
    "lpc/spritesheets/hair/long_messy/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy/male/gray.png.json",
    "lpc/spritesheets/hair/long_messy/male/black.png.json",
    "lpc/spritesheets/hair/long_messy2/male/white.png.json",
    "lpc/spritesheets/hair/long_messy2/male/blonde.png.json",
    "lpc/spritesheets/hair/long_messy2/male/gold.png.json",
    "lpc/spritesheets/hair/long_messy2/male/green.png.json",
    "lpc/spritesheets/hair/long_messy2/male/blue.png.json",
    "lpc/spritesheets/hair/long_messy2/male/red.png.json",
    "lpc/spritesheets/hair/long_messy2/male/orange.png.json",
    "lpc/spritesheets/hair/long_messy2/male/purple.png.json",
    "lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/male/gray.png.json",
    "lpc/spritesheets/hair/long_messy2/male/black.png.json",
    "lpc/spritesheets/hair/long_tied/male/white.png.json",
    "lpc/spritesheets/hair/long_tied/male/blonde.png.json",
    "lpc/spritesheets/hair/long_tied/male/gold.png.json",
    "lpc/spritesheets/hair/long_tied/male/green.png.json",
    "lpc/spritesheets/hair/long_tied/male/blue.png.json",
    "lpc/spritesheets/hair/long_tied/male/red.png.json",
    "lpc/spritesheets/hair/long_tied/male/orange.png.json",
    "lpc/spritesheets/hair/long_tied/male/purple.png.json",
    "lpc/spritesheets/hair/long_tied/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_tied/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_tied/male/gray.png.json",
    "lpc/spritesheets/hair/long_tied/male/black.png.json",
    "lpc/spritesheets/hair/longhawk/male/white.png.json",
    "lpc/spritesheets/hair/longhawk/male/blonde.png.json",
    "lpc/spritesheets/hair/longhawk/male/gold.png.json",
    "lpc/spritesheets/hair/longhawk/male/green.png.json",
    "lpc/spritesheets/hair/longhawk/male/blue.png.json",
    "lpc/spritesheets/hair/longhawk/male/red.png.json",
    "lpc/spritesheets/hair/longhawk/male/orange.png.json",
    "lpc/spritesheets/hair/longhawk/male/purple.png.json",
    "lpc/spritesheets/hair/longhawk/male/dark_brown.png.json",
    "lpc/spritesheets/hair/longhawk/male/light_brown.png.json",
    "lpc/spritesheets/hair/longhawk/male/gray.png.json",
    "lpc/spritesheets/hair/longhawk/male/black.png.json",
    "lpc/spritesheets/hair/longknot/male/white.png.json",
    "lpc/spritesheets/hair/longknot/male/blonde.png.json",
    "lpc/spritesheets/hair/longknot/male/gold.png.json",
    "lpc/spritesheets/hair/longknot/male/green.png.json",
    "lpc/spritesheets/hair/longknot/male/blue.png.json",
    "lpc/spritesheets/hair/longknot/male/red.png.json",
    "lpc/spritesheets/hair/longknot/male/orange.png.json",
    "lpc/spritesheets/hair/longknot/male/purple.png.json",
    "lpc/spritesheets/hair/longknot/male/dark_brown.png.json",
    "lpc/spritesheets/hair/longknot/male/light_brown.png.json",
    "lpc/spritesheets/hair/longknot/male/gray.png.json",
    "lpc/spritesheets/hair/longknot/male/black.png.json",
    "lpc/spritesheets/hair/loose/male/white.png.json",
    "lpc/spritesheets/hair/loose/male/blonde.png.json",
    "lpc/spritesheets/hair/loose/male/gold.png.json",
    "lpc/spritesheets/hair/loose/male/green.png.json",
    "lpc/spritesheets/hair/loose/male/blue.png.json",
    "lpc/spritesheets/hair/loose/male/red.png.json",
    "lpc/spritesheets/hair/loose/male/orange.png.json",
    "lpc/spritesheets/hair/loose/male/purple.png.json",
    "lpc/spritesheets/hair/loose/male/dark_brown.png.json",
    "lpc/spritesheets/hair/loose/male/light_brown.png.json",
    "lpc/spritesheets/hair/loose/male/gray.png.json",
    "lpc/spritesheets/hair/loose/male/black.png.json",
    "lpc/spritesheets/hair/messy1/male/white.png.json",
    "lpc/spritesheets/hair/messy1/male/blonde.png.json",
    "lpc/spritesheets/hair/messy1/male/gold.png.json",
    "lpc/spritesheets/hair/messy1/male/green.png.json",
    "lpc/spritesheets/hair/messy1/male/blue.png.json",
    "lpc/spritesheets/hair/messy1/male/red.png.json",
    "lpc/spritesheets/hair/messy1/male/orange.png.json",
    "lpc/spritesheets/hair/messy1/male/purple.png.json",
    "lpc/spritesheets/hair/messy1/male/dark_brown.png.json",
    "lpc/spritesheets/hair/messy1/male/light_brown.png.json",
    "lpc/spritesheets/hair/messy1/male/gray.png.json",
    "lpc/spritesheets/hair/messy1/male/black.png.json",
    "lpc/spritesheets/hair/messy2/male/white.png.json",
    "lpc/spritesheets/hair/messy2/male/blonde.png.json",
    "lpc/spritesheets/hair/messy2/male/gold.png.json",
    "lpc/spritesheets/hair/messy2/male/green.png.json",
    "lpc/spritesheets/hair/messy2/male/blue.png.json",
    "lpc/spritesheets/hair/messy2/male/red.png.json",
    "lpc/spritesheets/hair/messy2/male/orange.png.json",
    "lpc/spritesheets/hair/messy2/male/purple.png.json",
    "lpc/spritesheets/hair/messy2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/messy2/male/light_brown.png.json",
    "lpc/spritesheets/hair/messy2/male/gray.png.json",
    "lpc/spritesheets/hair/messy2/male/black.png.json",
    "lpc/spritesheets/hair/messy3/male/white.png.json",
    "lpc/spritesheets/hair/messy3/male/blonde.png.json",
    "lpc/spritesheets/hair/messy3/male/gold.png.json",
    "lpc/spritesheets/hair/messy3/male/green.png.json",
    "lpc/spritesheets/hair/messy3/male/blue.png.json",
    "lpc/spritesheets/hair/messy3/male/red.png.json",
    "lpc/spritesheets/hair/messy3/male/orange.png.json",
    "lpc/spritesheets/hair/messy3/male/purple.png.json",
    "lpc/spritesheets/hair/messy3/male/dark_brown.png.json",
    "lpc/spritesheets/hair/messy3/male/light_brown.png.json",
    "lpc/spritesheets/hair/messy3/male/gray.png.json",
    "lpc/spritesheets/hair/messy3/male/black.png.json",
    "lpc/spritesheets/hair/mop/male/white.png.json",
    "lpc/spritesheets/hair/mop/male/blonde.png.json",
    "lpc/spritesheets/hair/mop/male/gold.png.json",
    "lpc/spritesheets/hair/mop/male/green.png.json",
    "lpc/spritesheets/hair/mop/male/blue.png.json",
    "lpc/spritesheets/hair/mop/male/red.png.json",
    "lpc/spritesheets/hair/mop/male/orange.png.json",
    "lpc/spritesheets/hair/mop/male/purple.png.json",
    "lpc/spritesheets/hair/mop/male/dark_brown.png.json",
    "lpc/spritesheets/hair/mop/male/light_brown.png.json",
    "lpc/spritesheets/hair/mop/male/gray.png.json",
    "lpc/spritesheets/hair/mop/male/black.png.json",
    "lpc/spritesheets/hair/natural/male/white.png.json",
    "lpc/spritesheets/hair/natural/male/blonde.png.json",
    "lpc/spritesheets/hair/natural/male/gold.png.json",
    "lpc/spritesheets/hair/natural/male/green.png.json",
    "lpc/spritesheets/hair/natural/male/blue.png.json",
    "lpc/spritesheets/hair/natural/male/red.png.json",
    "lpc/spritesheets/hair/natural/male/orange.png.json",
    "lpc/spritesheets/hair/natural/male/purple.png.json",
    "lpc/spritesheets/hair/natural/male/dark_brown.png.json",
    "lpc/spritesheets/hair/natural/male/light_brown.png.json",
    "lpc/spritesheets/hair/natural/male/gray.png.json",
    "lpc/spritesheets/hair/natural/male/black.png.json",
    "lpc/spritesheets/hair/page/male/white.png.json",
    "lpc/spritesheets/hair/page/male/blonde.png.json",
    "lpc/spritesheets/hair/page/male/gold.png.json",
    "lpc/spritesheets/hair/page/male/green.png.json",
    "lpc/spritesheets/hair/page/male/blue.png.json",
    "lpc/spritesheets/hair/page/male/red.png.json",
    "lpc/spritesheets/hair/page/male/orange.png.json",
    "lpc/spritesheets/hair/page/male/purple.png.json",
    "lpc/spritesheets/hair/page/male/dark_brown.png.json",
    "lpc/spritesheets/hair/page/male/light_brown.png.json",
    "lpc/spritesheets/hair/page/male/gray.png.json",
    "lpc/spritesheets/hair/page/male/black.png.json",
    "lpc/spritesheets/hair/page2/male/white.png.json",
    "lpc/spritesheets/hair/page2/male/blonde.png.json",
    "lpc/spritesheets/hair/page2/male/gold.png.json",
    "lpc/spritesheets/hair/page2/male/green.png.json",
    "lpc/spritesheets/hair/page2/male/blue.png.json",
    "lpc/spritesheets/hair/page2/male/red.png.json",
    "lpc/spritesheets/hair/page2/male/orange.png.json",
    "lpc/spritesheets/hair/page2/male/purple.png.json",
    "lpc/spritesheets/hair/page2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/page2/male/light_brown.png.json",
    "lpc/spritesheets/hair/page2/male/gray.png.json",
    "lpc/spritesheets/hair/page2/male/black.png.json",
    "lpc/spritesheets/hair/part2/male/white.png.json",
    "lpc/spritesheets/hair/part2/male/blonde.png.json",
    "lpc/spritesheets/hair/part2/male/gold.png.json",
    "lpc/spritesheets/hair/part2/male/green.png.json",
    "lpc/spritesheets/hair/part2/male/blue.png.json",
    "lpc/spritesheets/hair/part2/male/red.png.json",
    "lpc/spritesheets/hair/part2/male/orange.png.json",
    "lpc/spritesheets/hair/part2/male/purple.png.json",
    "lpc/spritesheets/hair/part2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/part2/male/light_brown.png.json",
    "lpc/spritesheets/hair/part2/male/gray.png.json",
    "lpc/spritesheets/hair/part2/male/black.png.json",
    "lpc/spritesheets/hair/parted/male/white.png.json",
    "lpc/spritesheets/hair/parted/male/blonde.png.json",
    "lpc/spritesheets/hair/parted/male/gold.png.json",
    "lpc/spritesheets/hair/parted/male/green.png.json",
    "lpc/spritesheets/hair/parted/male/blue.png.json",
    "lpc/spritesheets/hair/parted/male/red.png.json",
    "lpc/spritesheets/hair/parted/male/orange.png.json",
    "lpc/spritesheets/hair/parted/male/purple.png.json",
    "lpc/spritesheets/hair/parted/male/dark_brown.png.json",
    "lpc/spritesheets/hair/parted/male/light_brown.png.json",
    "lpc/spritesheets/hair/parted/male/gray.png.json",
    "lpc/spritesheets/hair/parted/male/black.png.json",
    "lpc/spritesheets/hair/pixie/male/white.png.json",
    "lpc/spritesheets/hair/pixie/male/blonde.png.json",
    "lpc/spritesheets/hair/pixie/male/gold.png.json",
    "lpc/spritesheets/hair/pixie/male/green.png.json",
    "lpc/spritesheets/hair/pixie/male/blue.png.json",
    "lpc/spritesheets/hair/pixie/male/red.png.json",
    "lpc/spritesheets/hair/pixie/male/orange.png.json",
    "lpc/spritesheets/hair/pixie/male/purple.png.json",
    "lpc/spritesheets/hair/pixie/male/dark_brown.png.json",
    "lpc/spritesheets/hair/pixie/male/light_brown.png.json",
    "lpc/spritesheets/hair/pixie/male/gray.png.json",
    "lpc/spritesheets/hair/pixie/male/black.png.json",
    "lpc/spritesheets/hair/plain/male/white.png.json",
    "lpc/spritesheets/hair/plain/male/blonde.png.json",
    "lpc/spritesheets/hair/plain/male/gold.png.json",
    "lpc/spritesheets/hair/plain/male/green.png.json",
    "lpc/spritesheets/hair/plain/male/blue.png.json",
    "lpc/spritesheets/hair/plain/male/red.png.json",
    "lpc/spritesheets/hair/plain/male/orange.png.json",
    "lpc/spritesheets/hair/plain/male/purple.png.json",
    "lpc/spritesheets/hair/plain/male/dark_brown.png.json",
    "lpc/spritesheets/hair/plain/male/light_brown.png.json",
    "lpc/spritesheets/hair/plain/male/gray.png.json",
    "lpc/spritesheets/hair/plain/male/black.png.json",
    "lpc/spritesheets/hair/ponytail/male/white.png.json",
    "lpc/spritesheets/hair/ponytail/male/blonde.png.json",
    "lpc/spritesheets/hair/ponytail/male/gold.png.json",
    "lpc/spritesheets/hair/ponytail/male/green.png.json",
    "lpc/spritesheets/hair/ponytail/male/blue.png.json",
    "lpc/spritesheets/hair/ponytail/male/red.png.json",
    "lpc/spritesheets/hair/ponytail/male/orange.png.json",
    "lpc/spritesheets/hair/ponytail/male/purple.png.json",
    "lpc/spritesheets/hair/ponytail/male/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail/male/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail/male/gray.png.json",
    "lpc/spritesheets/hair/ponytail/male/black.png.json",
    "lpc/spritesheets/hair/ponytail2/male/white.png.json",
    "lpc/spritesheets/hair/ponytail2/male/blonde.png.json",
    "lpc/spritesheets/hair/ponytail2/male/gold.png.json",
    "lpc/spritesheets/hair/ponytail2/male/green.png.json",
    "lpc/spritesheets/hair/ponytail2/male/blue.png.json",
    "lpc/spritesheets/hair/ponytail2/male/red.png.json",
    "lpc/spritesheets/hair/ponytail2/male/orange.png.json",
    "lpc/spritesheets/hair/ponytail2/male/purple.png.json",
    "lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/male/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/male/gray.png.json",
    "lpc/spritesheets/hair/ponytail2/male/black.png.json",
    "lpc/spritesheets/hair/princess/male/white.png.json",
    "lpc/spritesheets/hair/princess/male/blonde.png.json",
    "lpc/spritesheets/hair/princess/male/gold.png.json",
    "lpc/spritesheets/hair/princess/male/green.png.json",
    "lpc/spritesheets/hair/princess/male/blue.png.json",
    "lpc/spritesheets/hair/princess/male/red.png.json",
    "lpc/spritesheets/hair/princess/male/orange.png.json",
    "lpc/spritesheets/hair/princess/male/purple.png.json",
    "lpc/spritesheets/hair/princess/male/dark_brown.png.json",
    "lpc/spritesheets/hair/princess/male/light_brown.png.json",
    "lpc/spritesheets/hair/princess/male/gray.png.json",
    "lpc/spritesheets/hair/princess/male/black.png.json",
    "lpc/spritesheets/hair/sara/male/white.png.json",
    "lpc/spritesheets/hair/sara/male/blonde.png.json",
    "lpc/spritesheets/hair/sara/male/gold.png.json",
    "lpc/spritesheets/hair/sara/male/green.png.json",
    "lpc/spritesheets/hair/sara/male/blue.png.json",
    "lpc/spritesheets/hair/sara/male/red.png.json",
    "lpc/spritesheets/hair/sara/male/orange.png.json",
    "lpc/spritesheets/hair/sara/male/purple.png.json",
    "lpc/spritesheets/hair/sara/male/dark_brown.png.json",
    "lpc/spritesheets/hair/sara/male/light_brown.png.json",
    "lpc/spritesheets/hair/sara/male/gray.png.json",
    "lpc/spritesheets/hair/sara/male/black.png.json",
    "lpc/spritesheets/hair/shorthawk/male/white.png.json",
    "lpc/spritesheets/hair/shorthawk/male/blonde.png.json",
    "lpc/spritesheets/hair/shorthawk/male/gold.png.json",
    "lpc/spritesheets/hair/shorthawk/male/green.png.json",
    "lpc/spritesheets/hair/shorthawk/male/blue.png.json",
    "lpc/spritesheets/hair/shorthawk/male/red.png.json",
    "lpc/spritesheets/hair/shorthawk/male/orange.png.json",
    "lpc/spritesheets/hair/shorthawk/male/purple.png.json",
    "lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/male/light_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/male/gray.png.json",
    "lpc/spritesheets/hair/shorthawk/male/black.png.json",
    "lpc/spritesheets/hair/shortknot/male/white.png.json",
    "lpc/spritesheets/hair/shortknot/male/blonde.png.json",
    "lpc/spritesheets/hair/shortknot/male/gold.png.json",
    "lpc/spritesheets/hair/shortknot/male/green.png.json",
    "lpc/spritesheets/hair/shortknot/male/blue.png.json",
    "lpc/spritesheets/hair/shortknot/male/red.png.json",
    "lpc/spritesheets/hair/shortknot/male/orange.png.json",
    "lpc/spritesheets/hair/shortknot/male/purple.png.json",
    "lpc/spritesheets/hair/shortknot/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shortknot/male/light_brown.png.json",
    "lpc/spritesheets/hair/shortknot/male/gray.png.json",
    "lpc/spritesheets/hair/shortknot/male/black.png.json",
    "lpc/spritesheets/hair/shoulderl/male/white.png.json",
    "lpc/spritesheets/hair/shoulderl/male/blonde.png.json",
    "lpc/spritesheets/hair/shoulderl/male/gold.png.json",
    "lpc/spritesheets/hair/shoulderl/male/green.png.json",
    "lpc/spritesheets/hair/shoulderl/male/blue.png.json",
    "lpc/spritesheets/hair/shoulderl/male/red.png.json",
    "lpc/spritesheets/hair/shoulderl/male/orange.png.json",
    "lpc/spritesheets/hair/shoulderl/male/purple.png.json",
    "lpc/spritesheets/hair/shoulderl/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/male/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/male/gray.png.json",
    "lpc/spritesheets/hair/shoulderl/male/black.png.json",
    "lpc/spritesheets/hair/shoulderr/male/white.png.json",
    "lpc/spritesheets/hair/shoulderr/male/blonde.png.json",
    "lpc/spritesheets/hair/shoulderr/male/gold.png.json",
    "lpc/spritesheets/hair/shoulderr/male/green.png.json",
    "lpc/spritesheets/hair/shoulderr/male/blue.png.json",
    "lpc/spritesheets/hair/shoulderr/male/red.png.json",
    "lpc/spritesheets/hair/shoulderr/male/orange.png.json",
    "lpc/spritesheets/hair/shoulderr/male/purple.png.json",
    "lpc/spritesheets/hair/shoulderr/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/male/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/male/gray.png.json",
    "lpc/spritesheets/hair/shoulderr/male/black.png.json",
    "lpc/spritesheets/hair/single/male/white.png.json",
    "lpc/spritesheets/hair/single/male/blonde.png.json",
    "lpc/spritesheets/hair/single/male/gold.png.json",
    "lpc/spritesheets/hair/single/male/green.png.json",
    "lpc/spritesheets/hair/single/male/blue.png.json",
    "lpc/spritesheets/hair/single/male/red.png.json",
    "lpc/spritesheets/hair/single/male/orange.png.json",
    "lpc/spritesheets/hair/single/male/purple.png.json",
    "lpc/spritesheets/hair/single/male/dark_brown.png.json",
    "lpc/spritesheets/hair/single/male/light_brown.png.json",
    "lpc/spritesheets/hair/single/male/gray.png.json",
    "lpc/spritesheets/hair/single/male/black.png.json",
    "lpc/spritesheets/hair/spiked/male/white.png.json",
    "lpc/spritesheets/hair/spiked/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked/male/gold.png.json",
    "lpc/spritesheets/hair/spiked/male/green.png.json",
    "lpc/spritesheets/hair/spiked/male/blue.png.json",
    "lpc/spritesheets/hair/spiked/male/red.png.json",
    "lpc/spritesheets/hair/spiked/male/orange.png.json",
    "lpc/spritesheets/hair/spiked/male/purple.png.json",
    "lpc/spritesheets/hair/spiked/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked/male/gray.png.json",
    "lpc/spritesheets/hair/spiked/male/black.png.json",
    "lpc/spritesheets/hair/spiked2/male/white.png.json",
    "lpc/spritesheets/hair/spiked2/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked2/male/gold.png.json",
    "lpc/spritesheets/hair/spiked2/male/green.png.json",
    "lpc/spritesheets/hair/spiked2/male/blue.png.json",
    "lpc/spritesheets/hair/spiked2/male/red.png.json",
    "lpc/spritesheets/hair/spiked2/male/orange.png.json",
    "lpc/spritesheets/hair/spiked2/male/purple.png.json",
    "lpc/spritesheets/hair/spiked2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked2/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked2/male/gray.png.json",
    "lpc/spritesheets/hair/spiked2/male/black.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/white.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/green.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/red.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/black.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/white.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/green.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/red.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/black.png.json",
    "lpc/spritesheets/hair/swoop/male/white.png.json",
    "lpc/spritesheets/hair/swoop/male/blonde.png.json",
    "lpc/spritesheets/hair/swoop/male/gold.png.json",
    "lpc/spritesheets/hair/swoop/male/green.png.json",
    "lpc/spritesheets/hair/swoop/male/blue.png.json",
    "lpc/spritesheets/hair/swoop/male/red.png.json",
    "lpc/spritesheets/hair/swoop/male/orange.png.json",
    "lpc/spritesheets/hair/swoop/male/purple.png.json",
    "lpc/spritesheets/hair/swoop/male/dark_brown.png.json",
    "lpc/spritesheets/hair/swoop/male/light_brown.png.json",
    "lpc/spritesheets/hair/swoop/male/gray.png.json",
    "lpc/spritesheets/hair/swoop/male/black.png.json",
    "lpc/spritesheets/hair/twists_fade/male/white.png.json",
    "lpc/spritesheets/hair/twists_fade/male/blonde.png.json",
    "lpc/spritesheets/hair/twists_fade/male/gold.png.json",
    "lpc/spritesheets/hair/twists_fade/male/green.png.json",
    "lpc/spritesheets/hair/twists_fade/male/blue.png.json",
    "lpc/spritesheets/hair/twists_fade/male/red.png.json",
    "lpc/spritesheets/hair/twists_fade/male/orange.png.json",
    "lpc/spritesheets/hair/twists_fade/male/purple.png.json",
    "lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/male/light_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/male/gray.png.json",
    "lpc/spritesheets/hair/twists_fade/male/black.png.json",
    "lpc/spritesheets/hair/twists_straight/male/white.png.json",
    "lpc/spritesheets/hair/twists_straight/male/blonde.png.json",
    "lpc/spritesheets/hair/twists_straight/male/gold.png.json",
    "lpc/spritesheets/hair/twists_straight/male/green.png.json",
    "lpc/spritesheets/hair/twists_straight/male/blue.png.json",
    "lpc/spritesheets/hair/twists_straight/male/red.png.json",
    "lpc/spritesheets/hair/twists_straight/male/orange.png.json",
    "lpc/spritesheets/hair/twists_straight/male/purple.png.json",
    "lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/male/light_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/male/gray.png.json",
    "lpc/spritesheets/hair/twists_straight/male/black.png.json",
    "lpc/spritesheets/hair/unkempt/male/white.png.json",
    "lpc/spritesheets/hair/unkempt/male/blonde.png.json",
    "lpc/spritesheets/hair/unkempt/male/gold.png.json",
    "lpc/spritesheets/hair/unkempt/male/green.png.json",
    "lpc/spritesheets/hair/unkempt/male/blue.png.json",
    "lpc/spritesheets/hair/unkempt/male/red.png.json",
    "lpc/spritesheets/hair/unkempt/male/orange.png.json",
    "lpc/spritesheets/hair/unkempt/male/purple.png.json",
    "lpc/spritesheets/hair/unkempt/male/dark_brown.png.json",
    "lpc/spritesheets/hair/unkempt/male/light_brown.png.json",
    "lpc/spritesheets/hair/unkempt/male/gray.png.json",
    "lpc/spritesheets/hair/unkempt/male/black.png.json",
    "lpc/spritesheets/hair/wavy/male/white.png.json",
    "lpc/spritesheets/hair/wavy/male/blonde.png.json",
    "lpc/spritesheets/hair/wavy/male/gold.png.json",
    "lpc/spritesheets/hair/wavy/male/green.png.json",
    "lpc/spritesheets/hair/wavy/male/blue.png.json",
    "lpc/spritesheets/hair/wavy/male/red.png.json",
    "lpc/spritesheets/hair/wavy/male/orange.png.json",
    "lpc/spritesheets/hair/wavy/male/purple.png.json",
    "lpc/spritesheets/hair/wavy/male/dark_brown.png.json",
    "lpc/spritesheets/hair/wavy/male/light_brown.png.json",
    "lpc/spritesheets/hair/wavy/male/gray.png.json",
    "lpc/spritesheets/hair/wavy/male/black.png.json",
    "lpc/spritesheets/hair/xlong/male/white.png.json",
    "lpc/spritesheets/hair/xlong/male/blonde.png.json",
    "lpc/spritesheets/hair/xlong/male/gold.png.json",
    "lpc/spritesheets/hair/xlong/male/green.png.json",
    "lpc/spritesheets/hair/xlong/male/blue.png.json",
    "lpc/spritesheets/hair/xlong/male/red.png.json",
    "lpc/spritesheets/hair/xlong/male/orange.png.json",
    "lpc/spritesheets/hair/xlong/male/purple.png.json",
    "lpc/spritesheets/hair/xlong/male/dark_brown.png.json",
    "lpc/spritesheets/hair/xlong/male/light_brown.png.json",
    "lpc/spritesheets/hair/xlong/male/gray.png.json",
    "lpc/spritesheets/hair/xlong/male/black.png.json",
    "lpc/spritesheets/head/nose/big/male/light.png.json",
    "lpc/spritesheets/head/nose/big/male/tanned.png.json",
    "lpc/spritesheets/head/nose/big/male/darkelf.png.json",
    "lpc/spritesheets/head/nose/button/male/light.png.json",
    "lpc/spritesheets/head/nose/button/male/tanned.png.json",
    "lpc/spritesheets/head/nose/button/male/darkelf.png.json",
    "lpc/spritesheets/head/nose/straight/male/light.png.json",
    "lpc/spritesheets/head/nose/straight/male/tanned.png.json",
    "lpc/spritesheets/head/nose/straight/male/darkelf.png.json",
    "lpc/spritesheets/eyes/male/blue.png.json",
    "lpc/spritesheets/eyes/male/brown.png.json",
    "lpc/spritesheets/eyes/male/gray.png.json",
    "lpc/spritesheets/eyes/male/green.png.json",
    "lpc/spritesheets/eyes/male/orange.png.json",
    "lpc/spritesheets/eyes/male/purple.png.json",
    "lpc/spritesheets/eyes/male/red.png.json",
    "lpc/spritesheets/eyes/male/yellow.png.json",
    "lpc/spritesheets/eyes/male/cyclope.png.json",
    "lpc/spritesheets/legs/armour/male/7.png.json",
    "lpc/spritesheets/legs/armour/male/8.png.json",
    "lpc/spritesheets/legs/armour/male/9.png.json",
    "lpc/spritesheets/legs/armour/male/10.png.json",
    "lpc/spritesheets/legs/armour/male/11.png.json",
    "lpc/spritesheets/legs/pants/male/black.png.json",
    "lpc/spritesheets/legs/pants/male/blue.png.json",
    "lpc/spritesheets/legs/pants/male/brown.png.json",
    "lpc/spritesheets/legs/pants/male/gray.png.json",
    "lpc/spritesheets/legs/pants/male/green.png.json",
    "lpc/spritesheets/legs/pants/male/maroon.png.json",
    "lpc/spritesheets/legs/pants/male/orange.png.json",
    "lpc/spritesheets/legs/pants/male/purple.png.json",
    "lpc/spritesheets/legs/pants/male/red.png.json",
    "lpc/spritesheets/legs/pants/male/tan.png.json",
    "lpc/spritesheets/legs/pants/male/white.png.json",
    "lpc/spritesheets/legs/pants/male/yellow.png.json",
    "lpc/spritesheets/legs/pantaloons/male/black.png.json",
    "lpc/spritesheets/legs/pantaloons/male/blue.png.json",
    "lpc/spritesheets/legs/pantaloons/male/brown.png.json",
    "lpc/spritesheets/legs/pantaloons/male/gray.png.json",
    "lpc/spritesheets/legs/pantaloons/male/green.png.json",
    "lpc/spritesheets/legs/pantaloons/male/maroon.png.json",
    "lpc/spritesheets/legs/pantaloons/male/orange.png.json",
    "lpc/spritesheets/legs/pantaloons/male/purple.png.json",
    "lpc/spritesheets/legs/pantaloons/male/red.png.json",
    "lpc/spritesheets/legs/pantaloons/male/tan.png.json",
    "lpc/spritesheets/legs/pantaloons/male/white.png.json",
    "lpc/spritesheets/legs/pantaloons/male/yellow.png.json",
    "lpc/spritesheets/legs/skirts/male/legion.png.json",
    "lpc/spritesheets/legs/skirts/male/brown.png.json",
    "lpc/spritesheets/legs/skirts/male/black.png.json",
    "lpc/spritesheets/legs/skirts/male/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json",
    "lpc/spritesheets/torso/armour/plate/male/11.png.json",
    "lpc/spritesheets/torso/armour/plate/male/12.png.json",
    "lpc/spritesheets/torso/armour/plate/male/14.png.json",
    "lpc/spritesheets/torso/armour/plate/male/16.png.json",
    "lpc/spritesheets/torso/armour/plate/male/special.png.json",
    "lpc/spritesheets/torso/armour/leather/male/blue.png.json",
    "lpc/spritesheets/torso/armour/leather/male/brown.png.json",
    "lpc/spritesheets/torso/armour/leather/male/green.png.json",
    "lpc/spritesheets/torso/armour/legion/male/bronze.png.json",
    "lpc/spritesheets/torso/armour/legion/male/steel.png.json",
    "lpc/spritesheets/torso/armour/legion/male/gold.png.json",
    "lpc/spritesheets/feet/armor/male/4.png.json",
    "lpc/spritesheets/feet/armor/male/5.png.json",
    "lpc/spritesheets/feet/armor/male/6.png.json",
    "lpc/spritesheets/feet/armor/male/7.png.json",
    "lpc/spritesheets/feet/armor/male/8.png.json",
    "lpc/spritesheets/feet/armor/male/9.png.json",
    "lpc/spritesheets/feet/boots/male/black.png.json",
    "lpc/spritesheets/feet/boots/male/blue.png.json",
    "lpc/spritesheets/feet/boots/male/brown.png.json",
    "lpc/spritesheets/feet/boots/male/gray.png.json",
    "lpc/spritesheets/feet/boots/male/green.png.json",
    "lpc/spritesheets/feet/boots/male/maroon.png.json",
    "lpc/spritesheets/feet/boots/male/orange.png.json",
    "lpc/spritesheets/feet/boots/male/purple.png.json",
    "lpc/spritesheets/feet/boots/male/red.png.json",
    "lpc/spritesheets/feet/boots/male/tan.png.json",
    "lpc/spritesheets/feet/boots/male/teal.png.json",
    "lpc/spritesheets/feet/boots/male/white.png.json",
    "lpc/spritesheets/feet/boots/male/yellow.png.json",
    "lpc/spritesheets/feet/sandals/male/brown.png.json",
    "lpc/spritesheets/feet/shoes/male/black.png.json",
    "lpc/spritesheets/feet/shoes/male/brown.png.json",
    "lpc/spritesheets/feet/shoes/male/maroon.png.json",
    "lpc/spritesheets/shield/male/crusader.png.json",
    "lpc/spritesheets/shield/male/spartan.png.json",
    "lpc/spritesheets/shield/male/round_black.png.json",
    "lpc/spritesheets/shield/male/round_brown.png.json",
    "lpc/spritesheets/shield/male/round_gold.png.json",
    "lpc/spritesheets/shield/male/round_green.png.json",
    "lpc/spritesheets/shield/male/round_silver.png.json",
    "lpc/spritesheets/shield/male/round_yellow.png.json",
    "lpc/spritesheets/shield/male/kite_gray.png.json",
    "lpc/spritesheets/shield/male/kite_orange.png.json",
    "lpc/spritesheets/shield/male/kite_blue_blue.png.json",
    "lpc/spritesheets/shield/male/kite_blue_gray.png.json",
    "lpc/spritesheets/shield/male/kite_gray_blue.png.json",
    "lpc/spritesheets/shield/male/kite_gray_gray.png.json",
    "lpc/spritesheets/shield/male/kite_gray_green.png.json",
    "lpc/spritesheets/shield/male/kite_gray_orange.png.json",
    "lpc/spritesheets/shield/male/kite_green_gray.png.json",
    "lpc/spritesheets/shield/male/kite_red_gray.png.json",
    "lpc/spritesheets/cape/solid/male/black.png.json",
    "lpc/spritesheets/cape/solid_behind/black.png.json",
    "lpc/spritesheets/cape/solid/male/blue.png.json",
    "lpc/spritesheets/cape/solid_behind/blue.png.json",
    "lpc/spritesheets/cape/solid/male/brown.png.json",
    "lpc/spritesheets/cape/solid_behind/brown.png.json",
    "lpc/spritesheets/cape/solid/male/gray.png.json",
    "lpc/spritesheets/cape/solid_behind/gray.png.json",
    "lpc/spritesheets/cape/solid/male/green.png.json",
    "lpc/spritesheets/cape/solid_behind/green.png.json",
    "lpc/spritesheets/cape/solid/male/maroon.png.json",
    "lpc/spritesheets/cape/solid_behind/maroon.png.json",
    "lpc/spritesheets/cape/solid/male/red.png.json",
    "lpc/spritesheets/cape/solid_behind/red.png.json",
    "lpc/spritesheets/cape/solid/male/white.png.json",
    "lpc/spritesheets/cape/solid_behind/white.png.json",
    "lpc/spritesheets/cape/solid/male/yellow.png.json",
    "lpc/spritesheets/cape/solid_behind/yellow.png.json",
    "lpc/spritesheets/bauldron/male/brown.png.json",
    "lpc/spritesheets/hair/afro/female/white.png.json",
    "lpc/spritesheets/hair/afro/female/blonde.png.json",
    "lpc/spritesheets/hair/afro/female/gold.png.json",
    "lpc/spritesheets/hair/afro/female/green.png.json",
    "lpc/spritesheets/hair/afro/female/blue.png.json",
    "lpc/spritesheets/hair/afro/female/red.png.json",
    "lpc/spritesheets/hair/afro/female/orange.png.json",
    "lpc/spritesheets/hair/afro/female/purple.png.json",
    "lpc/spritesheets/hair/afro/female/dark_brown.png.json",
    "lpc/spritesheets/hair/afro/female/light_brown.png.json",
    "lpc/spritesheets/hair/afro/female/gray.png.json",
    "lpc/spritesheets/hair/afro/female/black.png.json",
    "lpc/spritesheets/hair/balding/female/white.png.json",
    "lpc/spritesheets/hair/balding/female/blonde.png.json",
    "lpc/spritesheets/hair/balding/female/gold.png.json",
    "lpc/spritesheets/hair/balding/female/green.png.json",
    "lpc/spritesheets/hair/balding/female/blue.png.json",
    "lpc/spritesheets/hair/balding/female/red.png.json",
    "lpc/spritesheets/hair/balding/female/orange.png.json",
    "lpc/spritesheets/hair/balding/female/purple.png.json",
    "lpc/spritesheets/hair/balding/female/dark_brown.png.json",
    "lpc/spritesheets/hair/balding/female/light_brown.png.json",
    "lpc/spritesheets/hair/balding/female/gray.png.json",
    "lpc/spritesheets/hair/balding/female/black.png.json",
    "lpc/spritesheets/hair/bangs/female/white.png.json",
    "lpc/spritesheets/hair/bangs/female/blonde.png.json",
    "lpc/spritesheets/hair/bangs/female/gold.png.json",
    "lpc/spritesheets/hair/bangs/female/green.png.json",
    "lpc/spritesheets/hair/bangs/female/blue.png.json",
    "lpc/spritesheets/hair/bangs/female/red.png.json",
    "lpc/spritesheets/hair/bangs/female/orange.png.json",
    "lpc/spritesheets/hair/bangs/female/purple.png.json",
    "lpc/spritesheets/hair/bangs/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangs/female/gray.png.json",
    "lpc/spritesheets/hair/bangs/female/black.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/white.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/blonde.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/gold.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/green.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/blue.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/red.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/orange.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/purple.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/gray.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/black.png.json",
    "lpc/spritesheets/hair/bangslong/female/white.png.json",
    "lpc/spritesheets/hair/bangslong/female/blonde.png.json",
    "lpc/spritesheets/hair/bangslong/female/gold.png.json",
    "lpc/spritesheets/hair/bangslong/female/green.png.json",
    "lpc/spritesheets/hair/bangslong/female/blue.png.json",
    "lpc/spritesheets/hair/bangslong/female/red.png.json",
    "lpc/spritesheets/hair/bangslong/female/orange.png.json",
    "lpc/spritesheets/hair/bangslong/female/purple.png.json",
    "lpc/spritesheets/hair/bangslong/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong/female/gray.png.json",
    "lpc/spritesheets/hair/bangslong/female/black.png.json",
    "lpc/spritesheets/hair/bangslong2/female/white.png.json",
    "lpc/spritesheets/hair/bangslong2/female/blonde.png.json",
    "lpc/spritesheets/hair/bangslong2/female/gold.png.json",
    "lpc/spritesheets/hair/bangslong2/female/green.png.json",
    "lpc/spritesheets/hair/bangslong2/female/blue.png.json",
    "lpc/spritesheets/hair/bangslong2/female/red.png.json",
    "lpc/spritesheets/hair/bangslong2/female/orange.png.json",
    "lpc/spritesheets/hair/bangslong2/female/purple.png.json",
    "lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/female/gray.png.json",
    "lpc/spritesheets/hair/bangslong2/female/black.png.json",
    "lpc/spritesheets/hair/bangsshort/female/white.png.json",
    "lpc/spritesheets/hair/bangsshort/female/blonde.png.json",
    "lpc/spritesheets/hair/bangsshort/female/gold.png.json",
    "lpc/spritesheets/hair/bangsshort/female/green.png.json",
    "lpc/spritesheets/hair/bangsshort/female/blue.png.json",
    "lpc/spritesheets/hair/bangsshort/female/red.png.json",
    "lpc/spritesheets/hair/bangsshort/female/orange.png.json",
    "lpc/spritesheets/hair/bangsshort/female/purple.png.json",
    "lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/female/gray.png.json",
    "lpc/spritesheets/hair/bangsshort/female/black.png.json",
    "lpc/spritesheets/hair/bedhead/female/white.png.json",
    "lpc/spritesheets/hair/bedhead/female/blonde.png.json",
    "lpc/spritesheets/hair/bedhead/female/gold.png.json",
    "lpc/spritesheets/hair/bedhead/female/green.png.json",
    "lpc/spritesheets/hair/bedhead/female/blue.png.json",
    "lpc/spritesheets/hair/bedhead/female/red.png.json",
    "lpc/spritesheets/hair/bedhead/female/orange.png.json",
    "lpc/spritesheets/hair/bedhead/female/purple.png.json",
    "lpc/spritesheets/hair/bedhead/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bedhead/female/light_brown.png.json",
    "lpc/spritesheets/hair/bedhead/female/gray.png.json",
    "lpc/spritesheets/hair/bedhead/female/black.png.json",
    "lpc/spritesheets/hair/bob/female/white.png.json",
    "lpc/spritesheets/hair/bob/female/blonde.png.json",
    "lpc/spritesheets/hair/bob/female/gold.png.json",
    "lpc/spritesheets/hair/bob/female/green.png.json",
    "lpc/spritesheets/hair/bob/female/blue.png.json",
    "lpc/spritesheets/hair/bob/female/red.png.json",
    "lpc/spritesheets/hair/bob/female/orange.png.json",
    "lpc/spritesheets/hair/bob/female/purple.png.json",
    "lpc/spritesheets/hair/bob/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bob/female/light_brown.png.json",
    "lpc/spritesheets/hair/bob/female/gray.png.json",
    "lpc/spritesheets/hair/bob/female/black.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/white.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/blonde.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/gold.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/green.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/blue.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/red.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/orange.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/purple.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/gray.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/black.png.json",
    "lpc/spritesheets/hair/braid/female/white.png.json",
    "lpc/spritesheets/hair/braid/female/blonde.png.json",
    "lpc/spritesheets/hair/braid/female/gold.png.json",
    "lpc/spritesheets/hair/braid/female/green.png.json",
    "lpc/spritesheets/hair/braid/female/blue.png.json",
    "lpc/spritesheets/hair/braid/female/red.png.json",
    "lpc/spritesheets/hair/braid/female/orange.png.json",
    "lpc/spritesheets/hair/braid/female/purple.png.json",
    "lpc/spritesheets/hair/braid/female/dark_brown.png.json",
    "lpc/spritesheets/hair/braid/female/light_brown.png.json",
    "lpc/spritesheets/hair/braid/female/gray.png.json",
    "lpc/spritesheets/hair/braid/female/black.png.json",
    "lpc/spritesheets/hair/braid2/female/white.png.json",
    "lpc/spritesheets/hair/braid2/female/blonde.png.json",
    "lpc/spritesheets/hair/braid2/female/gold.png.json",
    "lpc/spritesheets/hair/braid2/female/green.png.json",
    "lpc/spritesheets/hair/braid2/female/blue.png.json",
    "lpc/spritesheets/hair/braid2/female/red.png.json",
    "lpc/spritesheets/hair/braid2/female/orange.png.json",
    "lpc/spritesheets/hair/braid2/female/purple.png.json",
    "lpc/spritesheets/hair/braid2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/braid2/female/light_brown.png.json",
    "lpc/spritesheets/hair/braid2/female/gray.png.json",
    "lpc/spritesheets/hair/braid2/female/black.png.json",
    "lpc/spritesheets/hair/bunches/female/white.png.json",
    "lpc/spritesheets/hair/bunches/female/blonde.png.json",
    "lpc/spritesheets/hair/bunches/female/gold.png.json",
    "lpc/spritesheets/hair/bunches/female/green.png.json",
    "lpc/spritesheets/hair/bunches/female/blue.png.json",
    "lpc/spritesheets/hair/bunches/female/red.png.json",
    "lpc/spritesheets/hair/bunches/female/orange.png.json",
    "lpc/spritesheets/hair/bunches/female/purple.png.json",
    "lpc/spritesheets/hair/bunches/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bunches/female/light_brown.png.json",
    "lpc/spritesheets/hair/bunches/female/gray.png.json",
    "lpc/spritesheets/hair/bunches/female/black.png.json",
    "lpc/spritesheets/hair/buzzcut/female/white.png.json",
    "lpc/spritesheets/hair/buzzcut/female/blonde.png.json",
    "lpc/spritesheets/hair/buzzcut/female/gold.png.json",
    "lpc/spritesheets/hair/buzzcut/female/green.png.json",
    "lpc/spritesheets/hair/buzzcut/female/blue.png.json",
    "lpc/spritesheets/hair/buzzcut/female/red.png.json",
    "lpc/spritesheets/hair/buzzcut/female/orange.png.json",
    "lpc/spritesheets/hair/buzzcut/female/purple.png.json",
    "lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/female/light_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/female/gray.png.json",
    "lpc/spritesheets/hair/buzzcut/female/black.png.json",
    "lpc/spritesheets/hair/cornrows/female/white.png.json",
    "lpc/spritesheets/hair/cornrows/female/blonde.png.json",
    "lpc/spritesheets/hair/cornrows/female/gold.png.json",
    "lpc/spritesheets/hair/cornrows/female/green.png.json",
    "lpc/spritesheets/hair/cornrows/female/blue.png.json",
    "lpc/spritesheets/hair/cornrows/female/red.png.json",
    "lpc/spritesheets/hair/cornrows/female/orange.png.json",
    "lpc/spritesheets/hair/cornrows/female/purple.png.json",
    "lpc/spritesheets/hair/cornrows/female/dark_brown.png.json",
    "lpc/spritesheets/hair/cornrows/female/light_brown.png.json",
    "lpc/spritesheets/hair/cornrows/female/gray.png.json",
    "lpc/spritesheets/hair/cornrows/female/black.png.json",
    "lpc/spritesheets/hair/cowlick/female/white.png.json",
    "lpc/spritesheets/hair/cowlick/female/blonde.png.json",
    "lpc/spritesheets/hair/cowlick/female/gold.png.json",
    "lpc/spritesheets/hair/cowlick/female/green.png.json",
    "lpc/spritesheets/hair/cowlick/female/blue.png.json",
    "lpc/spritesheets/hair/cowlick/female/red.png.json",
    "lpc/spritesheets/hair/cowlick/female/orange.png.json",
    "lpc/spritesheets/hair/cowlick/female/purple.png.json",
    "lpc/spritesheets/hair/cowlick/female/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick/female/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick/female/gray.png.json",
    "lpc/spritesheets/hair/cowlick/female/black.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/white.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/gold.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/green.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/blue.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/red.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/orange.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/purple.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/gray.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/black.png.json",
    "lpc/spritesheets/hair/curly_long/female/white.png.json",
    "lpc/spritesheets/hair/curly_long/female/blonde.png.json",
    "lpc/spritesheets/hair/curly_long/female/gold.png.json",
    "lpc/spritesheets/hair/curly_long/female/green.png.json",
    "lpc/spritesheets/hair/curly_long/female/blue.png.json",
    "lpc/spritesheets/hair/curly_long/female/red.png.json",
    "lpc/spritesheets/hair/curly_long/female/orange.png.json",
    "lpc/spritesheets/hair/curly_long/female/purple.png.json",
    "lpc/spritesheets/hair/curly_long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_long/female/light_brown.png.json",
    "lpc/spritesheets/hair/curly_long/female/gray.png.json",
    "lpc/spritesheets/hair/curly_long/female/black.png.json",
    "lpc/spritesheets/hair/curly_short/female/white.png.json",
    "lpc/spritesheets/hair/curly_short/female/blonde.png.json",
    "lpc/spritesheets/hair/curly_short/female/gold.png.json",
    "lpc/spritesheets/hair/curly_short/female/green.png.json",
    "lpc/spritesheets/hair/curly_short/female/blue.png.json",
    "lpc/spritesheets/hair/curly_short/female/red.png.json",
    "lpc/spritesheets/hair/curly_short/female/orange.png.json",
    "lpc/spritesheets/hair/curly_short/female/purple.png.json",
    "lpc/spritesheets/hair/curly_short/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_short/female/light_brown.png.json",
    "lpc/spritesheets/hair/curly_short/female/gray.png.json",
    "lpc/spritesheets/hair/curly_short/female/black.png.json",
    "lpc/spritesheets/hair/curtains/female/white.png.json",
    "lpc/spritesheets/hair/curtains/female/blonde.png.json",
    "lpc/spritesheets/hair/curtains/female/gold.png.json",
    "lpc/spritesheets/hair/curtains/female/green.png.json",
    "lpc/spritesheets/hair/curtains/female/blue.png.json",
    "lpc/spritesheets/hair/curtains/female/red.png.json",
    "lpc/spritesheets/hair/curtains/female/orange.png.json",
    "lpc/spritesheets/hair/curtains/female/purple.png.json",
    "lpc/spritesheets/hair/curtains/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains/female/light_brown.png.json",
    "lpc/spritesheets/hair/curtains/female/gray.png.json",
    "lpc/spritesheets/hair/curtains/female/black.png.json",
    "lpc/spritesheets/hair/curtains_long/female/white.png.json",
    "lpc/spritesheets/hair/curtains_long/female/blonde.png.json",
    "lpc/spritesheets/hair/curtains_long/female/gold.png.json",
    "lpc/spritesheets/hair/curtains_long/female/green.png.json",
    "lpc/spritesheets/hair/curtains_long/female/blue.png.json",
    "lpc/spritesheets/hair/curtains_long/female/red.png.json",
    "lpc/spritesheets/hair/curtains_long/female/orange.png.json",
    "lpc/spritesheets/hair/curtains_long/female/purple.png.json",
    "lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/female/light_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/female/gray.png.json",
    "lpc/spritesheets/hair/curtains_long/female/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/black.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/white.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/gold.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/green.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/blue.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/red.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/orange.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/purple.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/gray.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/black.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/white.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/gold.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/green.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/blue.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/red.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/orange.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/purple.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/gray.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/black.png.json",
    "lpc/spritesheets/hair/half_up/female/white.png.json",
    "lpc/spritesheets/hair/half_up/female/blonde.png.json",
    "lpc/spritesheets/hair/half_up/female/gold.png.json",
    "lpc/spritesheets/hair/half_up/female/green.png.json",
    "lpc/spritesheets/hair/half_up/female/blue.png.json",
    "lpc/spritesheets/hair/half_up/female/red.png.json",
    "lpc/spritesheets/hair/half_up/female/orange.png.json",
    "lpc/spritesheets/hair/half_up/female/purple.png.json",
    "lpc/spritesheets/hair/half_up/female/dark_brown.png.json",
    "lpc/spritesheets/hair/half_up/female/light_brown.png.json",
    "lpc/spritesheets/hair/half_up/female/gray.png.json",
    "lpc/spritesheets/hair/half_up/female/black.png.json",
    "lpc/spritesheets/hair/halfmessy/female/white.png.json",
    "lpc/spritesheets/hair/halfmessy/female/blonde.png.json",
    "lpc/spritesheets/hair/halfmessy/female/gold.png.json",
    "lpc/spritesheets/hair/halfmessy/female/green.png.json",
    "lpc/spritesheets/hair/halfmessy/female/blue.png.json",
    "lpc/spritesheets/hair/halfmessy/female/red.png.json",
    "lpc/spritesheets/hair/halfmessy/female/orange.png.json",
    "lpc/spritesheets/hair/halfmessy/female/purple.png.json",
    "lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/female/light_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/female/gray.png.json",
    "lpc/spritesheets/hair/halfmessy/female/black.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/white.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/blonde.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/gold.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/green.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/blue.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/red.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/orange.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/purple.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/gray.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/black.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/white.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/blonde.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/gold.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/green.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/blue.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/red.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/orange.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/purple.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/gray.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/black.png.json",
    "lpc/spritesheets/hair/idol/female/white.png.json",
    "lpc/spritesheets/hair/idol/female/blonde.png.json",
    "lpc/spritesheets/hair/idol/female/gold.png.json",
    "lpc/spritesheets/hair/idol/female/green.png.json",
    "lpc/spritesheets/hair/idol/female/blue.png.json",
    "lpc/spritesheets/hair/idol/female/red.png.json",
    "lpc/spritesheets/hair/idol/female/orange.png.json",
    "lpc/spritesheets/hair/idol/female/purple.png.json",
    "lpc/spritesheets/hair/idol/female/dark_brown.png.json",
    "lpc/spritesheets/hair/idol/female/light_brown.png.json",
    "lpc/spritesheets/hair/idol/female/gray.png.json",
    "lpc/spritesheets/hair/idol/female/black.png.json",
    "lpc/spritesheets/hair/jewfro/female/white.png.json",
    "lpc/spritesheets/hair/jewfro/female/blonde.png.json",
    "lpc/spritesheets/hair/jewfro/female/gold.png.json",
    "lpc/spritesheets/hair/jewfro/female/green.png.json",
    "lpc/spritesheets/hair/jewfro/female/blue.png.json",
    "lpc/spritesheets/hair/jewfro/female/red.png.json",
    "lpc/spritesheets/hair/jewfro/female/orange.png.json",
    "lpc/spritesheets/hair/jewfro/female/purple.png.json",
    "lpc/spritesheets/hair/jewfro/female/dark_brown.png.json",
    "lpc/spritesheets/hair/jewfro/female/light_brown.png.json",
    "lpc/spritesheets/hair/jewfro/female/gray.png.json",
    "lpc/spritesheets/hair/jewfro/female/black.png.json",
    "lpc/spritesheets/hair/lob/female/white.png.json",
    "lpc/spritesheets/hair/lob/female/blonde.png.json",
    "lpc/spritesheets/hair/lob/female/gold.png.json",
    "lpc/spritesheets/hair/lob/female/green.png.json",
    "lpc/spritesheets/hair/lob/female/blue.png.json",
    "lpc/spritesheets/hair/lob/female/red.png.json",
    "lpc/spritesheets/hair/lob/female/orange.png.json",
    "lpc/spritesheets/hair/lob/female/purple.png.json",
    "lpc/spritesheets/hair/lob/female/dark_brown.png.json",
    "lpc/spritesheets/hair/lob/female/light_brown.png.json",
    "lpc/spritesheets/hair/lob/female/gray.png.json",
    "lpc/spritesheets/hair/lob/female/black.png.json",
    "lpc/spritesheets/hair/long/female/white.png.json",
    "lpc/spritesheets/hair/long/female/blonde.png.json",
    "lpc/spritesheets/hair/long/female/gold.png.json",
    "lpc/spritesheets/hair/long/female/green.png.json",
    "lpc/spritesheets/hair/long/female/blue.png.json",
    "lpc/spritesheets/hair/long/female/red.png.json",
    "lpc/spritesheets/hair/long/female/orange.png.json",
    "lpc/spritesheets/hair/long/female/purple.png.json",
    "lpc/spritesheets/hair/long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long/female/light_brown.png.json",
    "lpc/spritesheets/hair/long/female/gray.png.json",
    "lpc/spritesheets/hair/long/female/black.png.json",
    "lpc/spritesheets/hair/long_band/female/white.png.json",
    "lpc/spritesheets/hair/long_band/female/blonde.png.json",
    "lpc/spritesheets/hair/long_band/female/gold.png.json",
    "lpc/spritesheets/hair/long_band/female/green.png.json",
    "lpc/spritesheets/hair/long_band/female/blue.png.json",
    "lpc/spritesheets/hair/long_band/female/red.png.json",
    "lpc/spritesheets/hair/long_band/female/orange.png.json",
    "lpc/spritesheets/hair/long_band/female/purple.png.json",
    "lpc/spritesheets/hair/long_band/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_band/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_band/female/gray.png.json",
    "lpc/spritesheets/hair/long_band/female/black.png.json",
    "lpc/spritesheets/hair/long_center_part/female/white.png.json",
    "lpc/spritesheets/hair/long_center_part/female/blonde.png.json",
    "lpc/spritesheets/hair/long_center_part/female/gold.png.json",
    "lpc/spritesheets/hair/long_center_part/female/green.png.json",
    "lpc/spritesheets/hair/long_center_part/female/blue.png.json",
    "lpc/spritesheets/hair/long_center_part/female/red.png.json",
    "lpc/spritesheets/hair/long_center_part/female/orange.png.json",
    "lpc/spritesheets/hair/long_center_part/female/purple.png.json",
    "lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/female/gray.png.json",
    "lpc/spritesheets/hair/long_center_part/female/black.png.json",
    "lpc/spritesheets/hair/long_messy/female/white.png.json",
    "lpc/spritesheets/hair/long_messy/female/blonde.png.json",
    "lpc/spritesheets/hair/long_messy/female/gold.png.json",
    "lpc/spritesheets/hair/long_messy/female/green.png.json",
    "lpc/spritesheets/hair/long_messy/female/blue.png.json",
    "lpc/spritesheets/hair/long_messy/female/red.png.json",
    "lpc/spritesheets/hair/long_messy/female/orange.png.json",
    "lpc/spritesheets/hair/long_messy/female/purple.png.json",
    "lpc/spritesheets/hair/long_messy/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy/female/gray.png.json",
    "lpc/spritesheets/hair/long_messy/female/black.png.json",
    "lpc/spritesheets/hair/long_messy2/female/white.png.json",
    "lpc/spritesheets/hair/long_messy2/female/blonde.png.json",
    "lpc/spritesheets/hair/long_messy2/female/gold.png.json",
    "lpc/spritesheets/hair/long_messy2/female/green.png.json",
    "lpc/spritesheets/hair/long_messy2/female/blue.png.json",
    "lpc/spritesheets/hair/long_messy2/female/red.png.json",
    "lpc/spritesheets/hair/long_messy2/female/orange.png.json",
    "lpc/spritesheets/hair/long_messy2/female/purple.png.json",
    "lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/female/gray.png.json",
    "lpc/spritesheets/hair/long_messy2/female/black.png.json",
    "lpc/spritesheets/hair/long_tied/female/white.png.json",
    "lpc/spritesheets/hair/long_tied/female/blonde.png.json",
    "lpc/spritesheets/hair/long_tied/female/gold.png.json",
    "lpc/spritesheets/hair/long_tied/female/green.png.json",
    "lpc/spritesheets/hair/long_tied/female/blue.png.json",
    "lpc/spritesheets/hair/long_tied/female/red.png.json",
    "lpc/spritesheets/hair/long_tied/female/orange.png.json",
    "lpc/spritesheets/hair/long_tied/female/purple.png.json",
    "lpc/spritesheets/hair/long_tied/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_tied/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_tied/female/gray.png.json",
    "lpc/spritesheets/hair/long_tied/female/black.png.json",
    "lpc/spritesheets/hair/longhawk/female/white.png.json",
    "lpc/spritesheets/hair/longhawk/female/blonde.png.json",
    "lpc/spritesheets/hair/longhawk/female/gold.png.json",
    "lpc/spritesheets/hair/longhawk/female/green.png.json",
    "lpc/spritesheets/hair/longhawk/female/blue.png.json",
    "lpc/spritesheets/hair/longhawk/female/red.png.json",
    "lpc/spritesheets/hair/longhawk/female/orange.png.json",
    "lpc/spritesheets/hair/longhawk/female/purple.png.json",
    "lpc/spritesheets/hair/longhawk/female/dark_brown.png.json",
    "lpc/spritesheets/hair/longhawk/female/light_brown.png.json",
    "lpc/spritesheets/hair/longhawk/female/gray.png.json",
    "lpc/spritesheets/hair/longhawk/female/black.png.json",
    "lpc/spritesheets/hair/longknot/female/white.png.json",
    "lpc/spritesheets/hair/longknot/female/blonde.png.json",
    "lpc/spritesheets/hair/longknot/female/gold.png.json",
    "lpc/spritesheets/hair/longknot/female/green.png.json",
    "lpc/spritesheets/hair/longknot/female/blue.png.json",
    "lpc/spritesheets/hair/longknot/female/red.png.json",
    "lpc/spritesheets/hair/longknot/female/orange.png.json",
    "lpc/spritesheets/hair/longknot/female/purple.png.json",
    "lpc/spritesheets/hair/longknot/female/dark_brown.png.json",
    "lpc/spritesheets/hair/longknot/female/light_brown.png.json",
    "lpc/spritesheets/hair/longknot/female/gray.png.json",
    "lpc/spritesheets/hair/longknot/female/black.png.json",
    "lpc/spritesheets/hair/loose/female/white.png.json",
    "lpc/spritesheets/hair/loose/female/blonde.png.json",
    "lpc/spritesheets/hair/loose/female/gold.png.json",
    "lpc/spritesheets/hair/loose/female/green.png.json",
    "lpc/spritesheets/hair/loose/female/blue.png.json",
    "lpc/spritesheets/hair/loose/female/red.png.json",
    "lpc/spritesheets/hair/loose/female/orange.png.json",
    "lpc/spritesheets/hair/loose/female/purple.png.json",
    "lpc/spritesheets/hair/loose/female/dark_brown.png.json",
    "lpc/spritesheets/hair/loose/female/light_brown.png.json",
    "lpc/spritesheets/hair/loose/female/gray.png.json",
    "lpc/spritesheets/hair/loose/female/black.png.json",
    "lpc/spritesheets/hair/messy1/female/white.png.json",
    "lpc/spritesheets/hair/messy1/female/blonde.png.json",
    "lpc/spritesheets/hair/messy1/female/gold.png.json",
    "lpc/spritesheets/hair/messy1/female/green.png.json",
    "lpc/spritesheets/hair/messy1/female/blue.png.json",
    "lpc/spritesheets/hair/messy1/female/red.png.json",
    "lpc/spritesheets/hair/messy1/female/orange.png.json",
    "lpc/spritesheets/hair/messy1/female/purple.png.json",
    "lpc/spritesheets/hair/messy1/female/dark_brown.png.json",
    "lpc/spritesheets/hair/messy1/female/light_brown.png.json",
    "lpc/spritesheets/hair/messy1/female/gray.png.json",
    "lpc/spritesheets/hair/messy1/female/black.png.json",
    "lpc/spritesheets/hair/messy2/female/white.png.json",
    "lpc/spritesheets/hair/messy2/female/blonde.png.json",
    "lpc/spritesheets/hair/messy2/female/gold.png.json",
    "lpc/spritesheets/hair/messy2/female/green.png.json",
    "lpc/spritesheets/hair/messy2/female/blue.png.json",
    "lpc/spritesheets/hair/messy2/female/red.png.json",
    "lpc/spritesheets/hair/messy2/female/orange.png.json",
    "lpc/spritesheets/hair/messy2/female/purple.png.json",
    "lpc/spritesheets/hair/messy2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/messy2/female/light_brown.png.json",
    "lpc/spritesheets/hair/messy2/female/gray.png.json",
    "lpc/spritesheets/hair/messy2/female/black.png.json",
    "lpc/spritesheets/hair/messy3/female/white.png.json",
    "lpc/spritesheets/hair/messy3/female/blonde.png.json",
    "lpc/spritesheets/hair/messy3/female/gold.png.json",
    "lpc/spritesheets/hair/messy3/female/green.png.json",
    "lpc/spritesheets/hair/messy3/female/blue.png.json",
    "lpc/spritesheets/hair/messy3/female/red.png.json",
    "lpc/spritesheets/hair/messy3/female/orange.png.json",
    "lpc/spritesheets/hair/messy3/female/purple.png.json",
    "lpc/spritesheets/hair/messy3/female/dark_brown.png.json",
    "lpc/spritesheets/hair/messy3/female/light_brown.png.json",
    "lpc/spritesheets/hair/messy3/female/gray.png.json",
    "lpc/spritesheets/hair/messy3/female/black.png.json",
    "lpc/spritesheets/hair/mop/female/white.png.json",
    "lpc/spritesheets/hair/mop/female/blonde.png.json",
    "lpc/spritesheets/hair/mop/female/gold.png.json",
    "lpc/spritesheets/hair/mop/female/green.png.json",
    "lpc/spritesheets/hair/mop/female/blue.png.json",
    "lpc/spritesheets/hair/mop/female/red.png.json",
    "lpc/spritesheets/hair/mop/female/orange.png.json",
    "lpc/spritesheets/hair/mop/female/purple.png.json",
    "lpc/spritesheets/hair/mop/female/dark_brown.png.json",
    "lpc/spritesheets/hair/mop/female/light_brown.png.json",
    "lpc/spritesheets/hair/mop/female/gray.png.json",
    "lpc/spritesheets/hair/mop/female/black.png.json",
    "lpc/spritesheets/hair/natural/female/white.png.json",
    "lpc/spritesheets/hair/natural/female/blonde.png.json",
    "lpc/spritesheets/hair/natural/female/gold.png.json",
    "lpc/spritesheets/hair/natural/female/green.png.json",
    "lpc/spritesheets/hair/natural/female/blue.png.json",
    "lpc/spritesheets/hair/natural/female/red.png.json",
    "lpc/spritesheets/hair/natural/female/orange.png.json",
    "lpc/spritesheets/hair/natural/female/purple.png.json",
    "lpc/spritesheets/hair/natural/female/dark_brown.png.json",
    "lpc/spritesheets/hair/natural/female/light_brown.png.json",
    "lpc/spritesheets/hair/natural/female/gray.png.json",
    "lpc/spritesheets/hair/natural/female/black.png.json",
    "lpc/spritesheets/hair/page/female/white.png.json",
    "lpc/spritesheets/hair/page/female/blonde.png.json",
    "lpc/spritesheets/hair/page/female/gold.png.json",
    "lpc/spritesheets/hair/page/female/green.png.json",
    "lpc/spritesheets/hair/page/female/blue.png.json",
    "lpc/spritesheets/hair/page/female/red.png.json",
    "lpc/spritesheets/hair/page/female/orange.png.json",
    "lpc/spritesheets/hair/page/female/purple.png.json",
    "lpc/spritesheets/hair/page/female/dark_brown.png.json",
    "lpc/spritesheets/hair/page/female/light_brown.png.json",
    "lpc/spritesheets/hair/page/female/gray.png.json",
    "lpc/spritesheets/hair/page/female/black.png.json",
    "lpc/spritesheets/hair/page2/female/white.png.json",
    "lpc/spritesheets/hair/page2/female/blonde.png.json",
    "lpc/spritesheets/hair/page2/female/gold.png.json",
    "lpc/spritesheets/hair/page2/female/green.png.json",
    "lpc/spritesheets/hair/page2/female/blue.png.json",
    "lpc/spritesheets/hair/page2/female/red.png.json",
    "lpc/spritesheets/hair/page2/female/orange.png.json",
    "lpc/spritesheets/hair/page2/female/purple.png.json",
    "lpc/spritesheets/hair/page2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/page2/female/light_brown.png.json",
    "lpc/spritesheets/hair/page2/female/gray.png.json",
    "lpc/spritesheets/hair/page2/female/black.png.json",
    "lpc/spritesheets/hair/part2/female/white.png.json",
    "lpc/spritesheets/hair/part2/female/blonde.png.json",
    "lpc/spritesheets/hair/part2/female/gold.png.json",
    "lpc/spritesheets/hair/part2/female/green.png.json",
    "lpc/spritesheets/hair/part2/female/blue.png.json",
    "lpc/spritesheets/hair/part2/female/red.png.json",
    "lpc/spritesheets/hair/part2/female/orange.png.json",
    "lpc/spritesheets/hair/part2/female/purple.png.json",
    "lpc/spritesheets/hair/part2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/part2/female/light_brown.png.json",
    "lpc/spritesheets/hair/part2/female/gray.png.json",
    "lpc/spritesheets/hair/part2/female/black.png.json",
    "lpc/spritesheets/hair/parted/female/white.png.json",
    "lpc/spritesheets/hair/parted/female/blonde.png.json",
    "lpc/spritesheets/hair/parted/female/gold.png.json",
    "lpc/spritesheets/hair/parted/female/green.png.json",
    "lpc/spritesheets/hair/parted/female/blue.png.json",
    "lpc/spritesheets/hair/parted/female/red.png.json",
    "lpc/spritesheets/hair/parted/female/orange.png.json",
    "lpc/spritesheets/hair/parted/female/purple.png.json",
    "lpc/spritesheets/hair/parted/female/dark_brown.png.json",
    "lpc/spritesheets/hair/parted/female/light_brown.png.json",
    "lpc/spritesheets/hair/parted/female/gray.png.json",
    "lpc/spritesheets/hair/parted/female/black.png.json",
    "lpc/spritesheets/hair/pixie/female/white.png.json",
    "lpc/spritesheets/hair/pixie/female/blonde.png.json",
    "lpc/spritesheets/hair/pixie/female/gold.png.json",
    "lpc/spritesheets/hair/pixie/female/green.png.json",
    "lpc/spritesheets/hair/pixie/female/blue.png.json",
    "lpc/spritesheets/hair/pixie/female/red.png.json",
    "lpc/spritesheets/hair/pixie/female/orange.png.json",
    "lpc/spritesheets/hair/pixie/female/purple.png.json",
    "lpc/spritesheets/hair/pixie/female/dark_brown.png.json",
    "lpc/spritesheets/hair/pixie/female/light_brown.png.json",
    "lpc/spritesheets/hair/pixie/female/gray.png.json",
    "lpc/spritesheets/hair/pixie/female/black.png.json",
    "lpc/spritesheets/hair/plain/female/white.png.json",
    "lpc/spritesheets/hair/plain/female/blonde.png.json",
    "lpc/spritesheets/hair/plain/female/gold.png.json",
    "lpc/spritesheets/hair/plain/female/green.png.json",
    "lpc/spritesheets/hair/plain/female/blue.png.json",
    "lpc/spritesheets/hair/plain/female/red.png.json",
    "lpc/spritesheets/hair/plain/female/orange.png.json",
    "lpc/spritesheets/hair/plain/female/purple.png.json",
    "lpc/spritesheets/hair/plain/female/dark_brown.png.json",
    "lpc/spritesheets/hair/plain/female/light_brown.png.json",
    "lpc/spritesheets/hair/plain/female/gray.png.json",
    "lpc/spritesheets/hair/plain/female/black.png.json",
    "lpc/spritesheets/hair/ponytail/female/white.png.json",
    "lpc/spritesheets/hair/ponytail/female/blonde.png.json",
    "lpc/spritesheets/hair/ponytail/female/gold.png.json",
    "lpc/spritesheets/hair/ponytail/female/green.png.json",
    "lpc/spritesheets/hair/ponytail/female/blue.png.json",
    "lpc/spritesheets/hair/ponytail/female/red.png.json",
    "lpc/spritesheets/hair/ponytail/female/orange.png.json",
    "lpc/spritesheets/hair/ponytail/female/purple.png.json",
    "lpc/spritesheets/hair/ponytail/female/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail/female/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail/female/gray.png.json",
    "lpc/spritesheets/hair/ponytail/female/black.png.json",
    "lpc/spritesheets/hair/ponytail2/female/white.png.json",
    "lpc/spritesheets/hair/ponytail2/female/blonde.png.json",
    "lpc/spritesheets/hair/ponytail2/female/gold.png.json",
    "lpc/spritesheets/hair/ponytail2/female/green.png.json",
    "lpc/spritesheets/hair/ponytail2/female/blue.png.json",
    "lpc/spritesheets/hair/ponytail2/female/red.png.json",
    "lpc/spritesheets/hair/ponytail2/female/orange.png.json",
    "lpc/spritesheets/hair/ponytail2/female/purple.png.json",
    "lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/female/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/female/gray.png.json",
    "lpc/spritesheets/hair/ponytail2/female/black.png.json",
    "lpc/spritesheets/hair/princess/female/white.png.json",
    "lpc/spritesheets/hair/princess/female/blonde.png.json",
    "lpc/spritesheets/hair/princess/female/gold.png.json",
    "lpc/spritesheets/hair/princess/female/green.png.json",
    "lpc/spritesheets/hair/princess/female/blue.png.json",
    "lpc/spritesheets/hair/princess/female/red.png.json",
    "lpc/spritesheets/hair/princess/female/orange.png.json",
    "lpc/spritesheets/hair/princess/female/purple.png.json",
    "lpc/spritesheets/hair/princess/female/dark_brown.png.json",
    "lpc/spritesheets/hair/princess/female/light_brown.png.json",
    "lpc/spritesheets/hair/princess/female/gray.png.json",
    "lpc/spritesheets/hair/princess/female/black.png.json",
    "lpc/spritesheets/hair/sara/female/white.png.json",
    "lpc/spritesheets/hair/sara/female/blonde.png.json",
    "lpc/spritesheets/hair/sara/female/gold.png.json",
    "lpc/spritesheets/hair/sara/female/green.png.json",
    "lpc/spritesheets/hair/sara/female/blue.png.json",
    "lpc/spritesheets/hair/sara/female/red.png.json",
    "lpc/spritesheets/hair/sara/female/orange.png.json",
    "lpc/spritesheets/hair/sara/female/purple.png.json",
    "lpc/spritesheets/hair/sara/female/dark_brown.png.json",
    "lpc/spritesheets/hair/sara/female/light_brown.png.json",
    "lpc/spritesheets/hair/sara/female/gray.png.json",
    "lpc/spritesheets/hair/sara/female/black.png.json",
    "lpc/spritesheets/hair/shorthawk/female/white.png.json",
    "lpc/spritesheets/hair/shorthawk/female/blonde.png.json",
    "lpc/spritesheets/hair/shorthawk/female/gold.png.json",
    "lpc/spritesheets/hair/shorthawk/female/green.png.json",
    "lpc/spritesheets/hair/shorthawk/female/blue.png.json",
    "lpc/spritesheets/hair/shorthawk/female/red.png.json",
    "lpc/spritesheets/hair/shorthawk/female/orange.png.json",
    "lpc/spritesheets/hair/shorthawk/female/purple.png.json",
    "lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/female/light_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/female/gray.png.json",
    "lpc/spritesheets/hair/shorthawk/female/black.png.json",
    "lpc/spritesheets/hair/shortknot/female/white.png.json",
    "lpc/spritesheets/hair/shortknot/female/blonde.png.json",
    "lpc/spritesheets/hair/shortknot/female/gold.png.json",
    "lpc/spritesheets/hair/shortknot/female/green.png.json",
    "lpc/spritesheets/hair/shortknot/female/blue.png.json",
    "lpc/spritesheets/hair/shortknot/female/red.png.json",
    "lpc/spritesheets/hair/shortknot/female/orange.png.json",
    "lpc/spritesheets/hair/shortknot/female/purple.png.json",
    "lpc/spritesheets/hair/shortknot/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shortknot/female/light_brown.png.json",
    "lpc/spritesheets/hair/shortknot/female/gray.png.json",
    "lpc/spritesheets/hair/shortknot/female/black.png.json",
    "lpc/spritesheets/hair/shoulderl/female/white.png.json",
    "lpc/spritesheets/hair/shoulderl/female/blonde.png.json",
    "lpc/spritesheets/hair/shoulderl/female/gold.png.json",
    "lpc/spritesheets/hair/shoulderl/female/green.png.json",
    "lpc/spritesheets/hair/shoulderl/female/blue.png.json",
    "lpc/spritesheets/hair/shoulderl/female/red.png.json",
    "lpc/spritesheets/hair/shoulderl/female/orange.png.json",
    "lpc/spritesheets/hair/shoulderl/female/purple.png.json",
    "lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/female/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/female/gray.png.json",
    "lpc/spritesheets/hair/shoulderl/female/black.png.json",
    "lpc/spritesheets/hair/shoulderr/female/white.png.json",
    "lpc/spritesheets/hair/shoulderr/female/blonde.png.json",
    "lpc/spritesheets/hair/shoulderr/female/gold.png.json",
    "lpc/spritesheets/hair/shoulderr/female/green.png.json",
    "lpc/spritesheets/hair/shoulderr/female/blue.png.json",
    "lpc/spritesheets/hair/shoulderr/female/red.png.json",
    "lpc/spritesheets/hair/shoulderr/female/orange.png.json",
    "lpc/spritesheets/hair/shoulderr/female/purple.png.json",
    "lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/female/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/female/gray.png.json",
    "lpc/spritesheets/hair/shoulderr/female/black.png.json",
    "lpc/spritesheets/hair/single/female/white.png.json",
    "lpc/spritesheets/hair/single/female/blonde.png.json",
    "lpc/spritesheets/hair/single/female/gold.png.json",
    "lpc/spritesheets/hair/single/female/green.png.json",
    "lpc/spritesheets/hair/single/female/blue.png.json",
    "lpc/spritesheets/hair/single/female/red.png.json",
    "lpc/spritesheets/hair/single/female/orange.png.json",
    "lpc/spritesheets/hair/single/female/purple.png.json",
    "lpc/spritesheets/hair/single/female/dark_brown.png.json",
    "lpc/spritesheets/hair/single/female/light_brown.png.json",
    "lpc/spritesheets/hair/single/female/gray.png.json",
    "lpc/spritesheets/hair/single/female/black.png.json",
    "lpc/spritesheets/hair/spiked/female/white.png.json",
    "lpc/spritesheets/hair/spiked/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked/female/gold.png.json",
    "lpc/spritesheets/hair/spiked/female/green.png.json",
    "lpc/spritesheets/hair/spiked/female/blue.png.json",
    "lpc/spritesheets/hair/spiked/female/red.png.json",
    "lpc/spritesheets/hair/spiked/female/orange.png.json",
    "lpc/spritesheets/hair/spiked/female/purple.png.json",
    "lpc/spritesheets/hair/spiked/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked/female/gray.png.json",
    "lpc/spritesheets/hair/spiked/female/black.png.json",
    "lpc/spritesheets/hair/spiked2/female/white.png.json",
    "lpc/spritesheets/hair/spiked2/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked2/female/gold.png.json",
    "lpc/spritesheets/hair/spiked2/female/green.png.json",
    "lpc/spritesheets/hair/spiked2/female/blue.png.json",
    "lpc/spritesheets/hair/spiked2/female/red.png.json",
    "lpc/spritesheets/hair/spiked2/female/orange.png.json",
    "lpc/spritesheets/hair/spiked2/female/purple.png.json",
    "lpc/spritesheets/hair/spiked2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked2/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked2/female/gray.png.json",
    "lpc/spritesheets/hair/spiked2/female/black.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/white.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/green.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/red.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/black.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/white.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/green.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/red.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/black.png.json",
    "lpc/spritesheets/hair/swoop/female/white.png.json",
    "lpc/spritesheets/hair/swoop/female/blonde.png.json",
    "lpc/spritesheets/hair/swoop/female/gold.png.json",
    "lpc/spritesheets/hair/swoop/female/green.png.json",
    "lpc/spritesheets/hair/swoop/female/blue.png.json",
    "lpc/spritesheets/hair/swoop/female/red.png.json",
    "lpc/spritesheets/hair/swoop/female/orange.png.json",
    "lpc/spritesheets/hair/swoop/female/purple.png.json",
    "lpc/spritesheets/hair/swoop/female/dark_brown.png.json",
    "lpc/spritesheets/hair/swoop/female/light_brown.png.json",
    "lpc/spritesheets/hair/swoop/female/gray.png.json",
    "lpc/spritesheets/hair/swoop/female/black.png.json",
    "lpc/spritesheets/hair/twists_fade/female/white.png.json",
    "lpc/spritesheets/hair/twists_fade/female/blonde.png.json",
    "lpc/spritesheets/hair/twists_fade/female/gold.png.json",
    "lpc/spritesheets/hair/twists_fade/female/green.png.json",
    "lpc/spritesheets/hair/twists_fade/female/blue.png.json",
    "lpc/spritesheets/hair/twists_fade/female/red.png.json",
    "lpc/spritesheets/hair/twists_fade/female/orange.png.json",
    "lpc/spritesheets/hair/twists_fade/female/purple.png.json",
    "lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/female/light_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/female/gray.png.json",
    "lpc/spritesheets/hair/twists_fade/female/black.png.json",
    "lpc/spritesheets/hair/twists_straight/female/white.png.json",
    "lpc/spritesheets/hair/twists_straight/female/blonde.png.json",
    "lpc/spritesheets/hair/twists_straight/female/gold.png.json",
    "lpc/spritesheets/hair/twists_straight/female/green.png.json",
    "lpc/spritesheets/hair/twists_straight/female/blue.png.json",
    "lpc/spritesheets/hair/twists_straight/female/red.png.json",
    "lpc/spritesheets/hair/twists_straight/female/orange.png.json",
    "lpc/spritesheets/hair/twists_straight/female/purple.png.json",
    "lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/female/light_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/female/gray.png.json",
    "lpc/spritesheets/hair/twists_straight/female/black.png.json",
    "lpc/spritesheets/hair/unkempt/female/white.png.json",
    "lpc/spritesheets/hair/unkempt/female/blonde.png.json",
    "lpc/spritesheets/hair/unkempt/female/gold.png.json",
    "lpc/spritesheets/hair/unkempt/female/green.png.json",
    "lpc/spritesheets/hair/unkempt/female/blue.png.json",
    "lpc/spritesheets/hair/unkempt/female/red.png.json",
    "lpc/spritesheets/hair/unkempt/female/orange.png.json",
    "lpc/spritesheets/hair/unkempt/female/purple.png.json",
    "lpc/spritesheets/hair/unkempt/female/dark_brown.png.json",
    "lpc/spritesheets/hair/unkempt/female/light_brown.png.json",
    "lpc/spritesheets/hair/unkempt/female/gray.png.json",
    "lpc/spritesheets/hair/unkempt/female/black.png.json",
    "lpc/spritesheets/hair/wavy/female/white.png.json",
    "lpc/spritesheets/hair/wavy/female/blonde.png.json",
    "lpc/spritesheets/hair/wavy/female/gold.png.json",
    "lpc/spritesheets/hair/wavy/female/green.png.json",
    "lpc/spritesheets/hair/wavy/female/blue.png.json",
    "lpc/spritesheets/hair/wavy/female/red.png.json",
    "lpc/spritesheets/hair/wavy/female/orange.png.json",
    "lpc/spritesheets/hair/wavy/female/purple.png.json",
    "lpc/spritesheets/hair/wavy/female/dark_brown.png.json",
    "lpc/spritesheets/hair/wavy/female/light_brown.png.json",
    "lpc/spritesheets/hair/wavy/female/gray.png.json",
    "lpc/spritesheets/hair/wavy/female/black.png.json",
    "lpc/spritesheets/hair/xlong/female/white.png.json",
    "lpc/spritesheets/hair/xlong/female/blonde.png.json",
    "lpc/spritesheets/hair/xlong/female/gold.png.json",
    "lpc/spritesheets/hair/xlong/female/green.png.json",
    "lpc/spritesheets/hair/xlong/female/blue.png.json",
    "lpc/spritesheets/hair/xlong/female/red.png.json",
    "lpc/spritesheets/hair/xlong/female/orange.png.json",
    "lpc/spritesheets/hair/xlong/female/purple.png.json",
    "lpc/spritesheets/hair/xlong/female/dark_brown.png.json",
    "lpc/spritesheets/hair/xlong/female/light_brown.png.json",
    "lpc/spritesheets/hair/xlong/female/gray.png.json",
    "lpc/spritesheets/hair/xlong/female/black.png.json",
    "lpc/spritesheets/head/nose/big/female/light.png.json",
    "lpc/spritesheets/head/nose/big/female/tanned.png.json",
    "lpc/spritesheets/head/nose/big/female/darkelf.png.json",
    "lpc/spritesheets/head/nose/button/female/light.png.json",
    "lpc/spritesheets/head/nose/button/female/tanned.png.json",
    "lpc/spritesheets/head/nose/button/female/darkelf.png.json",
    "lpc/spritesheets/head/nose/straight/female/light.png.json",
    "lpc/spritesheets/head/nose/straight/female/tanned.png.json",
    "lpc/spritesheets/head/nose/straight/female/darkelf.png.json",
    "lpc/spritesheets/eyes/female/blue.png.json",
    "lpc/spritesheets/eyes/female/brown.png.json",
    "lpc/spritesheets/eyes/female/gray.png.json",
    "lpc/spritesheets/eyes/female/green.png.json",
    "lpc/spritesheets/eyes/female/orange.png.json",
    "lpc/spritesheets/eyes/female/purple.png.json",
    "lpc/spritesheets/eyes/female/red.png.json",
    "lpc/spritesheets/eyes/female/yellow.png.json",
    "lpc/spritesheets/eyes/female/cyclope.png.json",
    "lpc/spritesheets/legs/armour/female/7.png.json",
    "lpc/spritesheets/legs/armour/female/8.png.json",
    "lpc/spritesheets/legs/armour/female/9.png.json",
    "lpc/spritesheets/legs/armour/female/10.png.json",
    "lpc/spritesheets/legs/armour/female/11.png.json",
    "lpc/spritesheets/legs/pants/female/black.png.json",
    "lpc/spritesheets/legs/pants/female/blue.png.json",
    "lpc/spritesheets/legs/pants/female/brown.png.json",
    "lpc/spritesheets/legs/pants/female/gray.png.json",
    "lpc/spritesheets/legs/pants/female/green.png.json",
    "lpc/spritesheets/legs/pants/female/maroon.png.json",
    "lpc/spritesheets/legs/pants/female/orange.png.json",
    "lpc/spritesheets/legs/pants/female/purple.png.json",
    "lpc/spritesheets/legs/pants/female/red.png.json",
    "lpc/spritesheets/legs/pants/female/tan.png.json",
    "lpc/spritesheets/legs/pants/female/white.png.json",
    "lpc/spritesheets/legs/pants/female/yellow.png.json",
    "lpc/spritesheets/legs/skirts/female/legion.png.json",
    "lpc/spritesheets/legs/skirts/female/brown.png.json",
    "lpc/spritesheets/legs/skirts/female/black.png.json",
    "lpc/spritesheets/legs/skirts/female/white.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/black.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/green.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/red.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/white.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/black.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/green.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/red.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/white.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/leather.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/black.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/green.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/red.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/white.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/brown.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/white.png.json",
    "lpc/spritesheets/torso/armour/plate/female/11.png.json",
    "lpc/spritesheets/torso/armour/plate/female/12.png.json",
    "lpc/spritesheets/torso/armour/plate/female/14.png.json",
    "lpc/spritesheets/torso/armour/plate/female/16.png.json",
    "lpc/spritesheets/torso/armour/plate/female/special.png.json",
    "lpc/spritesheets/torso/armour/leather/female/blue.png.json",
    "lpc/spritesheets/torso/armour/leather/female/brown.png.json",
    "lpc/spritesheets/torso/armour/leather/female/green.png.json",
    "lpc/spritesheets/torso/armour/legion/female/bronze.png.json",
    "lpc/spritesheets/torso/armour/legion/female/steel.png.json",
    "lpc/spritesheets/torso/armour/legion/female/gold.png.json",
    "lpc/spritesheets/feet/armor/female/4.png.json",
    "lpc/spritesheets/feet/armor/female/5.png.json",
    "lpc/spritesheets/feet/armor/female/6.png.json",
    "lpc/spritesheets/feet/armor/female/7.png.json",
    "lpc/spritesheets/feet/armor/female/8.png.json",
    "lpc/spritesheets/feet/armor/female/9.png.json",
    "lpc/spritesheets/feet/boots/female/black.png.json",
    "lpc/spritesheets/feet/boots/female/blue.png.json",
    "lpc/spritesheets/feet/boots/female/brown.png.json",
    "lpc/spritesheets/feet/boots/female/gray.png.json",
    "lpc/spritesheets/feet/boots/female/green.png.json",
    "lpc/spritesheets/feet/boots/female/maroon.png.json",
    "lpc/spritesheets/feet/boots/female/orange.png.json",
    "lpc/spritesheets/feet/boots/female/purple.png.json",
    "lpc/spritesheets/feet/boots/female/red.png.json",
    "lpc/spritesheets/feet/boots/female/tan.png.json",
    "lpc/spritesheets/feet/boots/female/teal.png.json",
    "lpc/spritesheets/feet/boots/female/white.png.json",
    "lpc/spritesheets/feet/boots/female/yellow.png.json",
    "lpc/spritesheets/feet/sandals/female/brown.png.json",
    "lpc/spritesheets/feet/shoes/female/black.png.json",
    "lpc/spritesheets/feet/shoes/female/brown.png.json",
    "lpc/spritesheets/feet/shoes/female/maroon.png.json",
    "lpc/spritesheets/feet/slippers/female/black.png.json",
    "lpc/spritesheets/feet/slippers/female/brown.png.json",
    "lpc/spritesheets/feet/slippers/female/gray.png.json",
    "lpc/spritesheets/shield/female/crusader.png.json",
    "lpc/spritesheets/shield/female/spartan.png.json",
    "lpc/spritesheets/shield/female/round_black.png.json",
    "lpc/spritesheets/shield/female/round_brown.png.json",
    "lpc/spritesheets/shield/female/round_gold.png.json",
    "lpc/spritesheets/shield/female/round_green.png.json",
    "lpc/spritesheets/shield/female/round_silver.png.json",
    "lpc/spritesheets/shield/female/round_yellow.png.json",
    "lpc/spritesheets/shield/female/kite_gray.png.json",
    "lpc/spritesheets/shield/female/kite_orange.png.json",
    "lpc/spritesheets/shield/female/kite_blue_blue.png.json",
    "lpc/spritesheets/shield/female/kite_blue_gray.png.json",
    "lpc/spritesheets/shield/female/kite_gray_blue.png.json",
    "lpc/spritesheets/shield/female/kite_gray_gray.png.json",
    "lpc/spritesheets/shield/female/kite_gray_green.png.json",
    "lpc/spritesheets/shield/female/kite_gray_orange.png.json",
    "lpc/spritesheets/shield/female/kite_green_gray.png.json",
    "lpc/spritesheets/shield/female/kite_red_gray.png.json",
    "lpc/spritesheets/cape/tattered/female/black.png.json",
    "lpc/spritesheets/cape/tattered_behind/black.png.json",
    "lpc/spritesheets/cape/tattered/female/blue.png.json",
    "lpc/spritesheets/cape/tattered_behind/blue.png.json",
    "lpc/spritesheets/cape/tattered/female/brown.png.json",
    "lpc/spritesheets/cape/tattered_behind/brown.png.json",
    "lpc/spritesheets/cape/tattered/female/gray.png.json",
    "lpc/spritesheets/cape/tattered_behind/gray.png.json",
    "lpc/spritesheets/cape/tattered/female/green.png.json",
    "lpc/spritesheets/cape/tattered_behind/green.png.json",
    "lpc/spritesheets/cape/tattered/female/maroon.png.json",
    "lpc/spritesheets/cape/tattered_behind/maroon.png.json",
    "lpc/spritesheets/cape/tattered/female/red.png.json",
    "lpc/spritesheets/cape/tattered_behind/red.png.json",
    "lpc/spritesheets/cape/tattered/female/white.png.json",
    "lpc/spritesheets/cape/tattered_behind/white.png.json",
    "lpc/spritesheets/cape/tattered/female/yellow.png.json",
    "lpc/spritesheets/cape/tattered_behind/yellow.png.json",
    "lpc/spritesheets/cape/trimmed/female/white_blue.png.json",
    "lpc/spritesheets/cape/trimmed_behind/white_blue.png.json",
    "lpc/spritesheets/bauldron/female/brown.png.json"
];



var $5UG8I = parcelRequire("5UG8I");
// Keys the page must not act on while the game has them. Tab is the one that actually bites: the
// browser's answer to it is to move focus off the canvas, after which these document-level
// handlers stop seeing anything at all and the game looks like it has frozen. A field that owns
// the keyboard is let through above, so tabbing inside the name prompt still works.
const $ea3f90e500565ae9$var$SWALLOWED = new Set([
    "Tab"
]);
class $ea3f90e500565ae9$export$16e4d70cc375e707 {
    static{
        this.state = new Map();
    }
    static{
        this.listeners = [];
    }
    static{
        this.pasteListeners = [];
    }
    static{
        // Set while a text field owns the keyboard (the name prompt). Keystrokes then reach only that
        // field: without this, naming a defender "Bryn" walks the player north-east and opens their
        // inventory, because every key the game reads is read from a document-level listener that
        // cannot see which DOM element has focus.
        this.typingSuppressed = false;
    }
    /**
     * Hand the keyboard to (or take it back from) a focused text field.
     *
     * Escape is deliberately NOT suppressed: it is how a player gets out of whatever is holding
     * the keyboard, so it has to keep reaching the handlers that close things.
     */ static suppressTyping(suppressed) {
        $ea3f90e500565ae9$export$16e4d70cc375e707.typingSuppressed = suppressed;
        if (suppressed) // Whatever was held when the field opened is released -- otherwise a key still down at
        // that moment would read as held for as long as the field is up (the movement loop
        // reads this map every frame, so clearing it is what stops the player walking).
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.clear();
    }
    static isSuppressed(key) {
        return $ea3f90e500565ae9$export$16e4d70cc375e707.typingSuppressed && key !== "Escape" && key !== "Esc";
    }
    static initialize() {
        // The `.bind(this)` here isn't necesary as these functions won't use `this`!
        document.addEventListener("keydown", $ea3f90e500565ae9$export$16e4d70cc375e707.keyDown);
        document.addEventListener("keyup", $ea3f90e500565ae9$export$16e4d70cc375e707.keyUp);
        // Paste. The game is a canvas, not a text field, so cmd/ctrl+V produces no keystroke that
        // anything upstream could use -- the pasted text only ever arrives on this event. It goes
        // to the listeners (the chat input is the only one today) and is dropped otherwise.
        document.addEventListener("paste", (event)=>{
            if ($ea3f90e500565ae9$export$16e4d70cc375e707.typingSuppressed) // A focused DOM text field (the name prompt) is handling its own paste.
            return;
            const text = event.clipboardData?.getData("text") || "";
            if (!text) return;
            $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.forEach((listener)=>listener(text));
        });
        document.addEventListener("mouseleave", (event)=>{
            if (event.clientY <= 0 || event.clientX <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight) $ea3f90e500565ae9$export$16e4d70cc375e707.state.clear();
        });
        window.addEventListener("blur", ()=>{
            $ea3f90e500565ae9$export$16e4d70cc375e707.state.clear();
        });
    }
    static modifiersOf(e) {
        return {
            shift: e.shiftKey,
            alt: e.altKey,
            ctrl: e.ctrlKey,
            meta: e.metaKey
        };
    }
    static keyDown(e) {
        if ($ea3f90e500565ae9$export$16e4d70cc375e707.isSuppressed(e.key)) return;
        if ($ea3f90e500565ae9$var$SWALLOWED.has(e.key)) e.preventDefault();
        const isUppercase = e.key == e.key.toUpperCase();
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toLowerCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toUpperCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.set(e.key, true);
        $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.forEach((listener)=>listener(e.key, true, e.repeat, $ea3f90e500565ae9$export$16e4d70cc375e707.modifiersOf(e)));
    }
    static keyUp(e) {
        if ($ea3f90e500565ae9$export$16e4d70cc375e707.isSuppressed(e.key)) return;
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toLowerCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toUpperCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key);
        $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.forEach((listener)=>listener(e.key, false, false, $ea3f90e500565ae9$export$16e4d70cc375e707.modifiersOf(e)));
    }
    constructor(){
        this.addListener = (listener)=>{
            if ($ea3f90e500565ae9$export$16e4d70cc375e707.listeners.indexOf(listener) < 0) $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.push(listener);
        };
        this.removeListener = (listener)=>{
            $ea3f90e500565ae9$export$16e4d70cc375e707.listeners = $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.filter((l)=>l != listener);
        };
        this.addPasteListener = (listener)=>{
            if ($ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.indexOf(listener) < 0) $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.push(listener);
        };
        this.removePasteListener = (listener)=>{
            $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners = $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.filter((l)=>l != listener);
        };
        this.state = ()=>$ea3f90e500565ae9$export$16e4d70cc375e707.state;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
class $f246f635ee3b2e66$export$7caecd373b84cec3 {
    static{
        this.listeners = [];
    }
    static{
        this.state = {
            position: new (0, $6qzqq.Point)(),
            buttons: new Map()
        };
    }
    static{
        this.worldRoots = [];
    }
    static{
        // True while a press that STARTED on the HUD is still held. The release has to be swallowed too,
        // or letting go over open ground would arrive as a world click the player never made.
        this.guiPress = false;
    }
    static setWorldRoots(roots) {
        $f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots = roots.filter(Boolean);
    }
    /**
     * Did this press land on the HUD rather than on the world?
     *
     * Button presses are bound to the DOCUMENT, not to the stage, so pixi never hit-tests them and
     * every click reached the player controller wherever it landed: pressing Items, or the skip button
     * on the intro prompt, swung the player's weapon at whatever was behind it. Hovering used to be
     * the only defence (GuiManager.mouseOverControl), which meant every control had to remember to opt
     * in, and most never did.
     *
     * Asking pixi what is under the pointer settles it in one place instead. Nothing under the pointer,
     * or something belonging to a world layer, is a world press as before.
     */ static pressIsOnGui() {
        const interaction = $f246f635ee3b2e66$export$7caecd373b84cec3.app?.renderer?.plugins?.interaction;
        if (!interaction?.hitTest || $f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots.length === 0) return false;
        const hit = interaction.hitTest($f246f635ee3b2e66$export$7caecd373b84cec3.state.position);
        if (!hit || hit === $f246f635ee3b2e66$export$7caecd373b84cec3.app?.stage) return false;
        for(let node = hit; node; node = node.parent){
            if ($f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots.indexOf(node) >= 0) return false;
        }
        return true;
    }
    /**
     * What a DOM-level press landed on, in the display tree, or null for empty canvas.
     *
     * Presses are bound to the DOCUMENT rather than the stage (see pressIsOnGui), so pixi never
     * hit-tests them and a widget has no way of its own to tell whether a click belongs to it. This
     * answers that for any listener that needs it -- e.g. the HUD dismissing an open command wheel
     * on a press that landed anywhere else.
     *
     * `undefined` means the question can't be answered here (no interaction plugin, i.e. headless
     * tests). Callers should read that as "don't act", never as "landed on nothing".
     */ static pressTarget(at) {
        const interaction = $f246f635ee3b2e66$export$7caecd373b84cec3.app?.renderer?.plugins?.interaction;
        if (!interaction?.hitTest || !interaction?.mapPositionToPoint) return undefined;
        const point = new (0, $6qzqq.Point)();
        interaction.mapPositionToPoint(point, at.clientX, at.clientY);
        return interaction.hitTest(point) || null;
    }
    static initialize(app) {
        $f246f635ee3b2e66$export$7caecd373b84cec3.app = app;
        app.stage.on("pointermove", $f246f635ee3b2e66$export$7caecd373b84cec3.movePointer);
        document.addEventListener("mousedown", $f246f635ee3b2e66$export$7caecd373b84cec3.pointerDown);
        document.addEventListener("mouseup", $f246f635ee3b2e66$export$7caecd373b84cec3.pointerUp);
    }
    static movePointer(e) {
        $f246f635ee3b2e66$export$7caecd373b84cec3.state.position = e.data.global;
        $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
    }
    static pointerUp(e) {
        // The release of a press that began on the HUD is swallowed with it, and the button is left
        // false so nothing downstream thinks it is still being held.
        if ($f246f635ee3b2e66$export$7caecd373b84cec3.guiPress) {
            $f246f635ee3b2e66$export$7caecd373b84cec3.guiPress = false;
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), false);
            return;
        }
        $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), false);
        $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
    }
    static pointerDown(e) {
        if ($f246f635ee3b2e66$export$7caecd373b84cec3.pressIsOnGui()) {
            // Never set the button: the world should not see this press at all, and a pointermove
            // arriving while it is held would otherwise read as a swing.
            $f246f635ee3b2e66$export$7caecd373b84cec3.guiPress = true;
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), false);
            return;
        }
        $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), true);
        $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
    }
    constructor(){
        this.addListener = (listener)=>{
            if ($f246f635ee3b2e66$export$7caecd373b84cec3.listeners.indexOf(listener) < 0) $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.push(listener);
        };
        this.removeListener = (listener)=>{
            $f246f635ee3b2e66$export$7caecd373b84cec3.listeners = $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.filter((l)=>l != listener);
        };
        this.updateButton = (buttonId, val)=>{
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(buttonId, val);
        };
        this.state = ()=>{
            return $f246f635ee3b2e66$export$7caecd373b84cec3.state;
        };
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

var $5UG8I = parcelRequire("5UG8I");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


var $1avo5 = parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $3YyWq = parcelRequire("3YyWq");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
// Warm amber, the same family as the command wheel's rim (WHEEL_RIM_COLOR), so the hover cue and the
// wheel it can open read as one system.
const $95f2390044c89843$var$GLOW_COLOR = 0xf7c070;
// The outline is built by drawing the frame's shape a second time, offset in every direction: the
// union of those offsets sticks out past the art by `distance` on every side, and the art drawn on
// top hides the middle, leaving a rim. Two passes give the rim a falloff -- a tight bright edge and a
// wider faint bloom -- rather than one hard band. Kept deliberately thin and low-contrast: this is a
// "you can act on this" hint the eye should catch without the entity looking like it is on fire.
const $95f2390044c89843$var$OUTLINE_PASSES = [
    {
        distance: 1.5,
        alpha: 0.66
    },
    {
        distance: 3.5,
        alpha: 0.21
    }
];
// Eight directions: the four sides plus the diagonals at 1/sqrt(2), so the rim stays an even
// thickness around a curve instead of bulging at the corners.
const $95f2390044c89843$var$DIAGONAL = Math.SQRT1_2;
const $95f2390044c89843$var$OUTLINE_DIRECTIONS = [
    [
        1,
        0
    ],
    [
        -1,
        0
    ],
    [
        0,
        1
    ],
    [
        0,
        -1
    ],
    [
        $95f2390044c89843$var$DIAGONAL,
        $95f2390044c89843$var$DIAGONAL
    ],
    [
        -$95f2390044c89843$var$DIAGONAL,
        $95f2390044c89843$var$DIAGONAL
    ],
    [
        $95f2390044c89843$var$DIAGONAL,
        -$95f2390044c89843$var$DIAGONAL
    ],
    [
        -$95f2390044c89843$var$DIAGONAL,
        -$95f2390044c89843$var$DIAGONAL
    ]
];
// Breathing, not blinking: the glow rides between PULSE_FLOOR and full strength over PULSE_PERIOD_MS.
const $95f2390044c89843$var$PULSE_PERIOD_MS = 1600;
const $95f2390044c89843$var$PULSE_FLOOR = 0.62;
// The glow eases in and out rather than snapping, so sweeping the pointer across a crowd doesn't
// strobe. Out is slower than in: the arrival should feel responsive, the departure unhurried.
const $95f2390044c89843$var$FADE_IN_MS = 140;
const $95f2390044c89843$var$FADE_OUT_MS = 220;
// The outline passes are drawn from the entity's OWN frame texture, whose edge pixels are the art's
// dark LPC outline -- tinting those would give a dark halo, not a glow. This flattens every pass to
// the glow color while keeping its alpha, so what shows is the shape, lit. One filter instance,
// shared by every highlight: it carries no per-object state, and at most a handful are ever lit at
// once (the pointed-at entity and the selected ember roster member).
let $95f2390044c89843$var$glowFlattenFilter;
const $95f2390044c89843$var$flattenToGlowColor = ()=>{
    if (!$95f2390044c89843$var$glowFlattenFilter) {
        const r = ($95f2390044c89843$var$GLOW_COLOR >> 16 & 0xff) / 0xff;
        const g = ($95f2390044c89843$var$GLOW_COLOR >> 8 & 0xff) / 0xff;
        const b = ($95f2390044c89843$var$GLOW_COLOR & 0xff) / 0xff;
        const filter = new (0, $1avo5.filters).ColorMatrixFilter();
        // Zero every color coefficient and carry the glow color in the offset column; the alpha row
        // passes alpha straight through, so the silhouette's shape survives untouched.
        filter.matrix = [
            0,
            0,
            0,
            0,
            r,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            1,
            0
        ];
        $95f2390044c89843$var$glowFlattenFilter = filter;
    }
    return $95f2390044c89843$var$glowFlattenFilter;
};
// The highlight is pure decoration and must never move the thing it decorates. Renderables derive
// their on-screen position from their own measured height (BaseRenderable.getYOffset reads
// `this.height`, which is a bounds query over every child), so a decoration that widened the parent's
// bounds would nudge the entity the instant you pointed at it -- and nudge it back when you looked
// away. This container renders its children normally but reports no bounds of its own, which keeps
// the whole highlight out of every measurement taken of the entity.
//
// A filter still sizes itself correctly inside this: the filter system asks the FILTERED object for
// its bounds directly (FilterSystem.push -> target.getBounds), never through its parent.
class $95f2390044c89843$var$BoundlessContainer extends (0, $8t5Gy.Container) {
    calculateBounds() {
        this._bounds.clear();
    }
}
class $95f2390044c89843$export$b6cf31fac6564392 {
    constructor(opts){
        this.outlineSprites = [];
        this.on = false;
        // 0..1, eased toward `on` every frame; the glow's alpha is this times the pulse. A fade-out keeps
        // ticking until it reaches 0, which is also when the highlight finally hides itself.
        this.strength = 0;
        this.ticking = false;
        this.disposed = false;
        this.isOn = ()=>this.on;
        this.set = (on)=>{
            if (this.disposed || this.on === on) return;
            this.on = on;
            // Both directions are animated, so switching off keeps the ticker running until the fade
            // finishes -- update() hides everything and deregisters once the glow reaches zero.
            if (!this.ticking) {
                (0, $3YyWq.Ticker).shared.add(this.update);
                this.ticking = true;
            }
            this.update();
        };
        // Release the ticker registration and the borrowed frame texture. Called from the renderable's
        // cleanup so a culled or destroyed entity can't leave a callback running against a detached
        // display object, or hold a reference the sprite generator wants to reclaim.
        this.dispose = ()=>{
            this.disposed = true;
            this.on = false;
            this.strength = 0;
            this.stopTicking();
            this.hide();
        };
        this.hide = ()=>{
            this.hideOutline();
        };
        this.stopTicking = ()=>{
            if (this.ticking) {
                (0, $3YyWq.Ticker).shared.remove(this.update);
                this.ticking = false;
            }
        };
        this.hideOutline = ()=>{
            if (!this.outline) return;
            this.outline.visible = false;
            this.outlineSprites.forEach((sprite)=>{
                sprite.texture = (0, $klOfb.Texture).EMPTY;
            });
        };
        // Step `strength` toward the on/off target using real elapsed time, so the fade takes the same
        // wall-clock duration whatever the frame rate.
        this.advanceFade = ()=>{
            const elapsed = (0, $3YyWq.Ticker).shared.deltaMS || 0;
            const target = this.on ? 1 : 0;
            const duration = this.on ? $95f2390044c89843$var$FADE_IN_MS : $95f2390044c89843$var$FADE_OUT_MS;
            const step = duration > 0 ? elapsed / duration : 1;
            if (this.strength < target) this.strength = Math.min(target, this.strength + step);
            else if (this.strength > target) this.strength = Math.max(target, this.strength - step);
        };
        // 0..1, a sine that never reaches zero: the glow breathes rather than blinking out. Driven from
        // the wall clock so every highlight pulses in step and the rate doesn't follow the frame rate.
        this.pulse = ()=>{
            const phase = Date.now() % $95f2390044c89843$var$PULSE_PERIOD_MS / $95f2390044c89843$var$PULSE_PERIOD_MS;
            const wave = 0.5 - 0.5 * Math.cos(phase * Math.PI * 2);
            return $95f2390044c89843$var$PULSE_FLOOR + (1 - $95f2390044c89843$var$PULSE_FLOOR) * wave;
        };
        this.update = ()=>{
            this.advanceFade();
            if (this.strength <= 0) {
                // Fully faded out (or never faded in): nothing to draw, and nothing left to animate.
                this.hide();
                this.stopTicking();
                return;
            }
            if (!this.drawOutline(this.pulse() * this.strength)) this.hideOutline();
        };
        this.drawOutline = (pulse)=>{
            const { artContainer: artContainer, frame: frame } = this.opts;
            if (!artContainer || !frame) return false;
            const current = frame();
            const frames = (Array.isArray(current) ? current : [
                current
            ]).filter((next)=>next?.texture?.valid);
            if (frames.length === 0) return false;
            if (!this.outline) {
                const shell = new $95f2390044c89843$var$BoundlessContainer();
                const outline = new (0, $8t5Gy.Container)();
                outline.filters = [
                    $95f2390044c89843$var$flattenToGlowColor()
                ];
                this.outline = outline;
                this.shell = shell;
                shell.addChild(outline);
                // Behind the art. LPC animations are appended to their container as they finish baking, so
                // index 0 keeps the outline below whichever frames arrive later.
                artContainer.addChildAt(shell, 0);
            }
            // One copy per (frame x pass x direction). The pool grows to fit and is reused; anything left
            // over from a frame count that has since shrunk is parked empty rather than destroyed.
            let i = 0;
            frames.forEach(({ texture: texture, x: x, y: y, scaleX: scaleX, scaleY: scaleY })=>{
                $95f2390044c89843$var$OUTLINE_PASSES.forEach((pass)=>{
                    $95f2390044c89843$var$OUTLINE_DIRECTIONS.forEach(([dx, dy])=>{
                        const sprite = this.outlineSpriteAt(i++, pass.alpha);
                        sprite.texture = texture;
                        sprite.scale.set(scaleX, scaleY);
                        sprite.x = x + dx * pass.distance;
                        sprite.y = y + dy * pass.distance;
                        sprite.visible = true;
                    });
                });
            });
            for(let spare = i; spare < this.outlineSprites.length; spare++)this.outlineSprites[spare].visible = false;
            this.outline.alpha = pulse;
            this.outline.visible = true;
            if (this.opts.zIndex && this.shell) this.shell.zIndex = this.opts.zIndex();
            return true;
        };
        this.outlineSpriteAt = (index, alpha)=>{
            let sprite = this.outlineSprites[index];
            if (!sprite) {
                sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
                sprite.anchor.set(0, 0);
                this.outlineSprites[index] = sprite;
                this.outline.addChild(sprite);
            }
            sprite.alpha = alpha;
            return sprite;
        };
        this.opts = opts;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $kXE1p = parcelRequire("kXE1p");
var $d3fD1 = parcelRequire("d3fD1");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
class $a64b70167386625f$export$98e91636974d835d extends (0, $gwPoJ.Graphics) {
    doMovement(entity) {
    //
    }
    update(hp, hpMax) {
    //
    }
    updateName(name) {
    //
    }
    updateSubmerged(submerged) {
    //
    }
    // Only the LPC composite draws a ground ring, so everything else ignores this. See
    // LpcComposite.updatePlayerRing and Entity.invading.
    updatePlayerRing(entity) {
    //
    }
    setId(id) {
    //
    }
    recolor(color) {
    //
    }
    updateBlinking(blinking) {
    //
    }
    updateScale(scale) {
    //
    }
    addTag() {
    //
    }
    removeTag() {
    //
    }
    updateSigil(sigil) {
    //
    }
    updateRole(role) {
    //
    }
    remove() {
        this.parent?.removeChild(this);
    }
    detonate() {
    //
    }
    updateLevel(level) {
    //
    }
    doAttack(entity, callback) {
    //
    }
    cleanup() {
    // Override in subclasses for cleanup logic
    }
    updateActivation(entity, active, callback) {
    //
    }
    doDamaged(entity) {
    //
    }
    spoke(message, options) {
    //
    }
    // Drop a held bubble and anything queued behind it, without acking the speaker (see
    // AvatarHud.releaseHeldSpeech).
    releaseHeldSpeech() {
    //
    }
    getDrawableSurface() {
        return null;
    //
    }
    updatePaperdoll(entity) {
    //
    }
    updateHalo(entity, enabled) {
    //
    }
    updateSpeed(factor) {
    //
    }
    fragment(entity, callback) {
    //
    }
    updateRotating(rotating) {
    //
    }
    onMouseOver(show) {
    //
    }
    // Warm outline glow shown while this entity is the one the player is pointing at (or, on touch,
    // the nearest interactable). Returns false when this renderable has no art of its own to trace --
    // an invisible marker standing on tile-drawn art -- so the caller can outline the map tiles
    // instead. See EntityHighlight.
    setHighlighted(on) {
        return false;
    }
    fadeIn() {
        this.alpha = 0;
        const t = setInterval(()=>{
            this.alpha += 0.1;
            if (this.alpha >= 1.0) {
                this.alpha = 1.0;
                clearInterval(t);
            }
        }, 25);
    }
    fadeOut(callback) {
        const t = setInterval(()=>{
            this.alpha -= 0.1;
            if (this.alpha <= 0.0) {
                this.alpha = 0;
                clearInterval(t);
                if (callback) callback();
            }
        }, 25);
    }
    getClickSurface() {
        return this;
    }
    setWorldOverlayItem(item) {
    //
    }
    updatePointerIcon(show, angle) {
    //
    }
    itemPickedUp(entity, itemTypeMeta, quantity) {
    //
    }
    feedback(entity, image, label, params) {
    //
    }
    updateSpriteId(spriteId) {
    //
    }
    updateAfk(afk) {
    //
    }
    addSidecar(entity) {
        if (entity.debug) {
            let g = this.sideCar;
            if (!g) {
                g = new $a64b70167386625f$export$98e91636974d835d();
                this.parent.addChild(g);
                this.sideCar = g;
            }
            g.clear();
            g.beginFill(0xff0000);
            g.alpha = 0.6;
            const bounds = entity.getCollisionBounds();
            // console.log(bounds.x1, bounds.y1, bounds.width, bounds.height)
            g.drawRect(bounds.x1, bounds.y1, bounds.width, bounds.height);
            g.endFill();
        }
    }
    getYOffset() {
        return -this.height * 0.25;
    }
    updateRenderedLocationFrom(entity) {
        this.x = entity.location.x;
        this.y = entity.location.y + this.getYOffset();
        this.addSidecar(entity);
    }
    constructor(...args){
        super(...args), this.defaultZIndex = 0, this.getCurrentColor = ()=>this.tint;
    }
}




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
const $85a39b5d41a16ed9$export$15d4c1eea10d6840 = (artBounds)=>{
    let x1 = -(0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
    let y1 = -(0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
    let x2 = x1 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    let y2 = y1 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    // Union in the art so objects drawn larger/taller/offset from one tile (the campfire, whose
    // sprite is centered via the "-texture.width/2" shift) get a region that matches what you see.
    if (artBounds && artBounds.width > 0 && artBounds.height > 0) {
        x1 = Math.min(x1, artBounds.x);
        y1 = Math.min(y1, artBounds.y);
        x2 = Math.max(x2, artBounds.x + artBounds.width);
        y2 = Math.max(y2, artBounds.y + artBounds.height);
    }
    return new (0, $6qzqq.Rectangle)(x1, y1, x2 - x1, y2 - y1);
};


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $6qzqq = parcelRequire("6qzqq");

var $5UG8I = parcelRequire("5UG8I");

// Alpha at or below this counts as empty. Matches the threshold the death-crumble effect uses for
// the same question ("where does the art actually stop").
const $35a6592763403c18$var$CONTENT_ALPHA_THRESHOLD = 8;
// Keyed by the caller's texture id. A composite tile texture is built once and shared by every
// sprite drawn from it, so its content bounds are worth computing once for the whole session --
// the readback is a GPU stall, and a null result (no renderer, e.g. in tests) is cached too so a
// failing lookup isn't retried on every sprite.
const $35a6592763403c18$var$cache = new Map();
const $35a6592763403c18$export$46429b068ef0a2d5 = (texture, cacheKey)=>{
    if ($35a6592763403c18$var$cache.has(cacheKey)) return $35a6592763403c18$var$cache.get(cacheKey);
    const bounds = $35a6592763403c18$var$computeContentBounds(texture);
    $35a6592763403c18$var$cache.set(cacheKey, bounds);
    return bounds;
};
const $35a6592763403c18$var$computeContentBounds = (texture)=>{
    const extract = (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app?.renderer?.plugins?.extract;
    if (!extract || !texture?.valid) return null;
    const probe = new (0, $7Bs2Z.Sprite)(texture);
    try {
        const canvas = extract.canvas(probe);
        const ctx = canvas.getContext("2d");
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        if (!ctx || canvasWidth === 0 || canvasHeight === 0) return null;
        const data = ctx.getImageData(0, 0, canvasWidth, canvasHeight).data;
        let minX = canvasWidth;
        let minY = canvasHeight;
        let maxX = -1;
        let maxY = -1;
        for(let y = 0; y < canvasHeight; y++){
            const rowOffset = y * canvasWidth * 4;
            for(let x = 0; x < canvasWidth; x++)if (data[rowOffset + x * 4 + 3] > $35a6592763403c18$var$CONTENT_ALPHA_THRESHOLD) {
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
            }
        }
        if (maxX < 0) // Entirely transparent (a blank stand-in marker). No content to point at.
        return null;
        // The extracted canvas can be at a different resolution than the texture, so map back through
        // its own dimensions rather than assuming 1:1.
        const scaleX = (texture.orig?.width ?? texture.width) / canvasWidth;
        const scaleY = (texture.orig?.height ?? texture.height) / canvasHeight;
        return new (0, $6qzqq.Rectangle)(minX * scaleX, minY * scaleY, (maxX - minX + 1) * scaleX, (maxY - minY + 1) * scaleY);
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
        return null;
    } finally{
        probe.destroy();
    }
};



parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");

class $86e9e05f3ebc1d8f$export$171acc6ba80afe2 {
    static{
        this.instance = new $86e9e05f3ebc1d8f$export$171acc6ba80afe2();
    }
    static{
        this.textureCache = new Map();
    }
    static{
        this.compositeTileSpriteBounds = new Map();
    }
    constructor(){
        this.extract = (tilemapMetaProvider, tilesetId, compositeTileId)=>{
            const parentTileSet = tilemapMetaProvider.getTilesetById(tilesetId);
            const compositeTileMeta = tilemapMetaProvider.resolveCompositeTileIdTileMeta(compositeTileId, tilesetId);
            if (!compositeTileMeta) return null;
            const fullTileId = `${parentTileSet.tilesetId}-${compositeTileId}`;
            let texture = $86e9e05f3ebc1d8f$export$171acc6ba80afe2.textureCache.get(fullTileId);
            // Only reuse a cached texture that is still valid. A DESTROYED texture (orig === null, or a
            // destroyed baseTexture) can linger in this module-level static cache -- e.g. left behind
            // across an HMR reload by code that used to evict+destroy these -- and handing it to a Sprite
            // crashes Pixi in calculateVertices/containsPoint ("Cannot read properties of null (reading
            // 'width')"). If the cached entry is stale, fall through and regenerate it below.
            if (texture && texture.orig && !texture.baseTexture?.destroyed) return texture;
            const { width: width } = parentTileSet;
            const children = compositeTileMeta.children || [];
            const bounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(0, 0, 0, 0);
            const childBounds = children.map((childTileMeta)=>{
                const tileNumber = childTileMeta.tileNumber - 1;
                const tileSetX = tileNumber % width;
                const tileSetY = Math.floor(tileNumber / width);
                const childBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(tileSetX, tileSetY, tileSetX + 1, tileSetY + 1);
                return childBounds;
            });
            bounds.widen(childBounds);
            const xx = bounds.x1;
            const yy = bounds.y1;
            bounds.translate(-bounds.x1, -bounds.y1);
            $86e9e05f3ebc1d8f$export$171acc6ba80afe2.compositeTileSpriteBounds.set(fullTileId, bounds);
            const rect = new (0, $6qzqq.Rectangle)(0, 0, bounds.width * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), bounds.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const textureSurface = new (0, $gwPoJ.Graphics)();
            const textureToCache = (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app.renderer.generateTexture(textureSurface, {
                region: rect
            });
            const containingSprite = new (0, $7Bs2Z.Sprite)(textureToCache);
            // debug
            // const g = new Graphics()
            // g.beginFill(0xFF0000, 0.2)
            // g.drawRect(0, 0, rect.width, rect.height)
            // g.endFill()
            // containingSprite.addChild(g)
            children.forEach((childTileMeta)=>{
                const tileId = `${childTileMeta.tileNumber}`;
                const tileNumber = childTileMeta.tileNumber - 1;
                const tileSetX = tileNumber % width - xx;
                const tileSetY = Math.floor(tileNumber / width) - yy;
                const subtileSprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).from(`${parentTileSet.tilesetId}-${tileId}`));
                subtileSprite.x = tileSetX * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 0;
                subtileSprite.y = tileSetY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 0;
                containingSprite.addChild(subtileSprite);
            });
            texture = (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app.renderer.generateTexture(containingSprite);
            $86e9e05f3ebc1d8f$export$171acc6ba80afe2.textureCache.set(fullTileId, texture);
            return texture;
        };
    }
}


parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
class $30b51e7e6bcae30f$export$75ebcd2c8ed5b901 {
    constructor(){
        this.namedSizeToNumberSize = (size)=>{
            if (size === "tiny") return 8;
            if (size === "small") return 12;
            if (size === "medium") return 14;
            if (size === "normal") return 16;
            return this.namedSizeToNumberSize("medium");
        };
        this.size = (size)=>{
            this._namedSize = size;
            return this;
        };
        this.color = (color)=>{
            if (color !== undefined) this._color = color;
            return this;
        };
        this.bold = ()=>{
            this._bold = true;
            return this;
        };
        this.align = (align)=>{
            this._align = align;
            return this;
        };
        this.fontFamily = (fontFamily)=>{
            this._fontFamily = fontFamily;
            return this;
        };
        this.fontSize = (size)=>{
            this._size = size;
            return this;
        };
        // Wrap onto multiple lines at `width`, breaking inside a word if one is longer than that. Set
        // at BUILD time rather than by poking text.style afterwards, so the measured width of the
        // resulting Text is guaranteed to respect it — a caller that sizes a panel around the text
        // (see gui/roster_speech.ts) depends on that being true from the first frame.
        this.wordWrap = (width)=>{
            this._wordWrapWidth = width;
            return this;
        };
        // Outline width, in pixels, of the black stroke every Text gets by default (see render()). The
        // default earns its keep over the world, where a label has to stay readable against whatever
        // tile it happens to sit on -- but it is a liability on flat UI: a DARK glyph on a LIGHT fill
        // grows a black halo the same colour as its own ink, which fattens the stems and closes up the
        // counters of small bold type. Pass 0 for text that sits on a solid panel.
        this.strokeThickness = (thickness)=>{
            this._strokeThickness = thickness;
            return this;
        };
        this.variant = (variant)=>{
            if (variant) {
                if (variant === "BannerFont") {
                    this._color = 0xffffff;
                    this._size = 20;
                }
                if (variant === "LogoFont") {
                    this._color = 0xffffff;
                    this._size = 40;
                }
                if (variant === "RedChatFont") {
                    this._color = 0xffa500;
                    this._size = 10;
                }
                if (variant === "SmallFont") this._size = 10;
                if (variant === "AlertFont") {
                    this._color = 0xff0000;
                    this._size = 30;
                }
                if (variant === "DamageFont") {
                    this._color = 0xff0000;
                    this._size = 15;
                    this._bold = true;
                }
                if (variant === "EntityImportantFont") {
                    this._size = 15;
                    this._bold = true;
                }
                if (variant === "ChatFont") {
                    this._color = 0x00ee00;
                    this._size = 10;
                }
                if (variant === "BubbleChatFont") {
                    this._color = 0xffffff;
                    this._size = this.namedSizeToNumberSize("small");
                    // Pin the resolution so the Text doesn't AUTO-re-rasterize when it's first drawn into
                    // the follow-cam PiP's higher-resolution RenderTexture — that re-raster is what made a
                    // PiP bubble "jump" on its first frame. Match the PiP texture's 2×devicePixelRatio so
                    // it stays crisp there too.
                    this._resolution = 2 * (typeof window !== "undefined" && window.devicePixelRatio ? window.devicePixelRatio : 1);
                }
                if (variant === "Normal-Green-Bold") {
                    this._color = 0x00ff00;
                    this._size = 15;
                }
                if (variant === "ImportantFont") {
                    this._color = 0xffffff;
                    this._size = 30;
                }
                if (variant === "GiganticFont") {
                    this._color = 0xffffff;
                    this._size = 100;
                }
            }
            return this;
        };
        this.render = (text)=>{
            const style = {
                fontFamily: this._fontFamily || "Verdana, Geneva, sans-serif",
                // font: 'bold italic Sans-Serif',
                fill: "#ffffff",
                // stroke: '#000000',
                fontWeight: this._bold ? "bolder" : "normal",
                align: this._align || "left",
                strokeThickness: this._strokeThickness === undefined ? 1 : this._strokeThickness,
                fontSize: this._size === undefined ? this.namedSizeToNumberSize(this._namedSize) : this._size,
                ...this._wordWrapWidth !== undefined ? {
                    wordWrap: true,
                    wordWrapWidth: this._wordWrapWidth,
                    breakWords: true
                } : {}
            };
            var someText = new (0, $9Pi8W.Text)(text || "", style);
            someText.roundPixels = true;
            if (this._resolution !== undefined) // Fixed resolution => Text.autoResolution off => it won't re-rasterize (nor glitch for a
            // frame) when rendered into a RenderTexture of a different resolution, i.e. the PiP.
            someText.resolution = this._resolution;
            someText.tint = this._color !== undefined ? this._color : 0xffffff;
            someText.scale.set(1.0);
            return someText;
        };
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $484648df9dc7cb6f$export$353f5b6fc5456de1 extends (0, $gwPoJ.Graphics) {
    constructor({ text: text, font: font, color: color, textColor: textColor, buttonWidth: buttonWidth, padding: paddingProp, mouseControlCallback: mouseControlCallback, onClick: onClick }){
        super(), // True while the pointer is on the button and mouseControlCallback has taken the world's mouse
        // away. Tracked so the latch can be handed back when the button goes (see releaseMouseControl),
        // and so a button never clears a latch it did not set -- it is one global boolean, and something
        // else (an open modal, another control under the pointer) may be holding it for a good reason.
        this.holdingMouseControl = false, this.setMouseControl = (hold)=>{
            if (this.holdingMouseControl === hold) return;
            this.holdingMouseControl = hold;
            this.mouseControlCallback && this.mouseControlCallback(hold);
        }, // Give the world its mouse back, if this button is the one holding it. Idempotent, and a no-op
        // for a button that was never hovered.
        this.releaseMouseControl = ()=>this.setMouseControl(false);
        this.text = text;
        this.font = font;
        this.color = color;
        this.textColor = textColor || 0x000000;
        this.buttonWidth = buttonWidth;
        this.mouseControlCallback = mouseControlCallback;
        this.onClick = onClick;
        const button = new (0, $gwPoJ.Graphics)();
        const textObj = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(this.textColor).align("center").render(this.text);
        const padding = paddingProp ?? 3;
        textObj.x = buttonWidth ? buttonWidth / 2 - textObj.width / 2 : padding;
        textObj.y = padding;
        button.lineStyle(2, color, 1.0);
        button.beginFill(color, 1.0);
        button.drawRoundedRect(0, 0, buttonWidth || textObj.width + padding * 3, textObj.height + padding * 2, 5);
        button.addChild(textObj);
        this.drawRect(0, 0, this.buttonWidth || 1, button.height + padding);
        this.addChild(button);
        this.interactive = true;
        if (this.mouseControlCallback) {
            this.on("mouseover", ()=>{
                this.alpha = 0.7;
                this.setMouseControl(true);
            });
            this.on("mouseout", ()=>{
                this.alpha = 1.0;
                this.setMouseControl(false);
            });
            // pixi delivers no mouseout to a display object that has been removed from the display
            // tree, so a button taken down under a resting pointer would hold the world's mouse for
            // good -- and these buttons do exactly that: they throb and expire on a timer, and the
            // message button rebuilds the stack it lives in from its own click handler.
            //
            // This covers a button removed on its own. A button whose PARENT is removed gets no
            // event at all, so whoever rebuilds the stack has to release it (see
            // GuiManager.helpMessaging).
            this.on("removed", ()=>this.releaseMouseControl());
            if (this.onClick) {
                this.on("click", this.onClick);
                this.on("tap", this.onClick);
            }
        }
        this.cursor = "pointer";
        this.y -= padding;
    }
}



parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
const $7fc026ed2e091ee4$export$7e4c1296b4859de0 = (node)=>{
    if (!node) return;
    if (node instanceof (0, $9Pi8W.Text)) {
        if (!node.destroyed) node.destroy({
            texture: true,
            baseTexture: true
        });
        return;
    }
    const children = node.children;
    if (children && children.length) // Copy first: destroying a child mutates the live children array.
    for (const child of [
        ...children
    ])$7fc026ed2e091ee4$export$7e4c1296b4859de0(child);
};


class $9fd6885af96d4f37$export$98d0db62fdbc7614 extends (0, $gwPoJ.Graphics) {
    constructor(text, props){
        super(), this.stop = ()=>{
            this.active = false;
        }, this.playback = (charDelay, parent, doneCallback)=>{
            const items = this.text.split("");
            const canvas = new (0, $gwPoJ.Graphics)();
            canvas.x = this.x;
            canvas.y = this.y;
            canvas.width = this.width;
            canvas.height = this.height;
            parent.addChild(canvas);
            // Reuse ONE Text and mutate its .text each tick. PIXI re-rasterizes into the Text's own
            // canvas/texture in place, so no new canvas-backed BaseTexture is allocated per character.
            // The old code created a fresh Text (and texture) per char and only removeChildren()'d the
            // previous one -- never destroying it -- so every typed character leaked a GPU texture.
            const textObj = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(this.color).variant(this.font).render("");
            canvas.addChild(textObj);
            let idx = 0;
            let str = "";
            let interval;
            let cleaned = false;
            const cleanup = ()=>{
                if (cleaned) return;
                cleaned = true;
                clearTimeout(interval);
                if (!textObj.destroyed) textObj.destroy({
                    texture: true,
                    baseTexture: true
                });
                if (canvas.parent) parent.removeChild(canvas);
                canvas.destroy();
            };
            const next = ()=>{
                if (!this.active) {
                    cleanup();
                    return;
                }
                const nextChar = items[idx];
                str += nextChar;
                textObj.text = str;
                idx++;
                if (idx > items.length - 1) {
                    doneCallback();
                    cleanup();
                    parent.addChild(this);
                    return;
                }
                const delay = nextChar.trim() === "," ? charDelay * 12 : nextChar.trim() === "." ? charDelay * 24 : charDelay;
                interval = setTimeout(next, delay);
            };
            next();
            return cleanup;
        };
        this.active = true;
        this.text = text;
        this.font = props?.font || "ScoreFont";
        this.color = props?.color || 0xffffff;
        this.pause = props?.pause;
        this.type = props?.type || "text";
        const { textDecorations: textDecorations = [] } = props || {};
        const disabled = textDecorations.includes("disabled");
        if (props?.onClick) {
            this.interactive = true;
            const onClick = ()=>{
                props.onClick();
                if (props?.extraOnClickListener) props.extraOnClickListener(this.text);
            };
            this.on("click", onClick);
            if (!disabled) {
                this.cursor = "pointer";
                const originalAlpha = this.alpha;
                this.on("mouseover", ()=>{
                    this.alpha = 0.7;
                });
                this.on("mouseout", ()=>{
                    this.alpha = originalAlpha;
                });
            }
            this.on("tap", onClick);
        } else if (props?.link) {
            this.interactive = true;
            const onClick = ()=>{
                if (props?.extraOnClickListener) props.extraOnClickListener(this.text);
                window.open(props.link);
            };
            this.on("click", onClick);
            this.on("tap", onClick);
        }
        const textObj = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(disabled ? 0x808080 : this.color).variant(this.font).render(this.text);
        if (this.type === "text") {
            this.addChild(textObj);
            if (this.text && textDecorations.includes("underline")) {
                const underline = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
                underline.position.y = textObj.height;
                underline.width = textObj.width;
                underline.height = 2;
                textObj.addChild(underline);
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.drawRect(0, 0, 0, 40);
                this.addChild(spacer);
            }
        }
        if (this.type === "button" || this.type === "button|dynamic") {
            const button = new (0, $484648df9dc7cb6f$export$353f5b6fc5456de1)({
                text: this.text,
                font: this.font,
                color: disabled ? 0x808080 : this.color,
                buttonWidth: this.type === "button|dynamic" ? undefined : 100,
                mouseControlCallback: disabled ? undefined : props.mouseControlCallback
            });
            this.addChild(button);
        }
        if (this.type === "sprite") {
            const itemSprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: props.spriteId,
                scale: props.scale || 1.0,
                color: disabled ? 0x808080 : 0xffffff,
                rotating: false
            });
            itemSprite.y += itemSprite.height * 0.4;
            this.addChild(itemSprite);
            if (itemSprite.height < 30) {
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.drawRect(0, 0, 0, 30);
                this.addChild(spacer);
            }
        }
    }
    destroy(options) {
        // Free this node's own canvas-backed Text texture(s) before teardown. Shared Sprite textures
        // (e.g. item icons for type "sprite") are deliberately left intact by disposeTextTextures.
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this);
        super.destroy({
            children: true,
            texture: false,
            baseTexture: false
        });
    }
}




class $aeae8505a2eb5f5c$export$f169141001428c70 extends (0, $gwPoJ.Graphics) {
    constructor(props){
        super(), this.progressivePlayList = [], this.opaque = false, this.wipe = ()=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            this.progressivePlayList = [];
            this.previous = null;
            this.lineHasButton = false;
        }, this.append2 = (item, props = {
            sameLine: false
        })=>{
            const toAdd = typeof item === "string" ? new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item, {
                font: props.font || this.defaultTextFont,
                extraOnClickListener: this.linkCallback,
                pause: props.pause,
                type: props.type,
                onClick: props.onClick,
                mouseControlCallback: props.mouseControlCallback,
                spriteId: props.spriteId,
                scale: props.scale,
                textDecorations: props.textDecorations,
                context: props.context,
                color: props.color
            }) : item;
            this.progressivePlayList.push(toAdd);
            const typeToUse = props.type || item.type;
            if (typeToUse === "horizontalLine") {
                toAdd.beginFill(0xffffff, 0.8);
                toAdd.drawRect(0, 0, this.width, 1);
                toAdd.endFill();
            }
            if (!this.progressive) this.addChild(toAdd);
            if (this.previous && !props?.ignorePrevious) {
                if (props.sameLine) toAdd.y = this.previous.y;
                else {
                    toAdd.y = this.previous.y + (props.preservePreviousHeight === undefined || props.preservePreviousHeight ? this.previous.height : 0);
                    // + toAdd.height
                    this.lineHasButton = false;
                }
            }
            if (typeToUse === "button" || typeToUse === "button|dynamic") this.lineHasButton = true;
            if (props.leftSpacer) toAdd.x = props.leftSpacer;
            else if (this.previous && !props?.ignorePrevious) {
                if (props.sameLine) toAdd.x = this.previous.x + (props.fixedWidth !== undefined ? props.fixedWidth : this.previous.width);
                else if (props.sameX) toAdd.x = this.previous.x;
            }
            if (props.leftMargin) toAdd.x += props.leftMargin;
            if (props.topSpacer) toAdd.y = props.topSpacer;
            if (props.topMargin) toAdd.y += props.topMargin;
            if (props.bottomMargin) {
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.drawRect(0, 0, this.width, props.bottomMargin);
                toAdd.addChild(spacer);
            }
            if (props.exactLocation) {
                toAdd.x = props.exactLocation.x;
                toAdd.y = props.exactLocation.y;
            }
            if (props.hoverText && this.hoverText) {
                toAdd.interactive = true;
                toAdd.on("mouseover", ()=>{
                    this.hoverText.visible = true;
                    this.hoverText.x = toAdd.x + this.x;
                    this.hoverText.y = toAdd.y + this.y;
                    this.hoverText.update(props.hoverText);
                });
            }
            if (this.progressive) {
                const g = new (0, $gwPoJ.Graphics)();
                g.drawRect(0, 0, toAdd.height, 1);
                g.x = toAdd.x;
                g.y = toAdd.y;
                this.addChild(g);
            }
            this.previous = toAdd;
            if (this.backdrop) {
                this.backdrop.clear();
                if (this.opaque) this.backdrop.lineStyle({
                    width: this.borderColor === undefined ? 1 : 2,
                    color: this.borderColor === undefined ? 0x707b91 : this.borderColor,
                    alpha: this.borderColor === undefined ? 0.75 : 1
                });
                this.backdrop.beginFill(this.opaque ? 0x141821 : 0x000000, this.opaque ? 1 : 0.5);
                this.backdrop.drawRoundedRect(-5 - this.margin, -5 - this.margin, this.width + 10 + this.margin, this.height + 10 + this.margin, 5);
                this.backdrop.endFill();
                if (this.opaque) this.backdrop.lineStyle(0);
            }
            return this;
        }, this.append = (item, sameLine = false, leftSpacer = 0, leftMargin = 0, pause, type, onClick, mouseControlCallback)=>{
            const toAdd = typeof item === "string" ? new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item, {
                font: this.defaultTextFont,
                extraOnClickListener: this.linkCallback,
                pause: pause,
                type: type,
                onClick: onClick,
                mouseControlCallback: mouseControlCallback
            }) : item;
            this.progressivePlayList.push(toAdd);
            if (!this.progressive) this.addChild(toAdd);
            if (this.previous) {
                if (sameLine) toAdd.y = this.previous.y;
                else {
                    toAdd.y = this.previous.y + toAdd.height;
                    this.lineHasButton = false;
                }
            }
            if (type === "button") this.lineHasButton = true;
            if (leftSpacer) toAdd.x = leftSpacer;
            else if (this.previous && sameLine) toAdd.x = this.previous.x + this.previous.width;
            if (leftMargin) toAdd.x += leftMargin;
            if (this.progressive) {
                const g = new (0, $gwPoJ.Graphics)();
                g.drawRect(0, 0, toAdd.height, 1);
                g.x = toAdd.x;
                g.y = toAdd.y;
                this.addChild(g);
            }
            this.previous = toAdd;
            return this;
        }, this.appendLink = (item, target, sameLine = false, leftSpacer = 0)=>{
            return this.append(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item, {
                color: 0x00ff00,
                link: target,
                extraOnClickListener: this.linkCallback
            }), sameLine, leftSpacer);
        }, this.cleanup = ()=>{
            this.activePlaybackId = undefined;
            if (this.currentlyPlayingLineCleaner) this.currentlyPlayingLineCleaner();
        }, this.playback = (callback)=>{
            const playlistLength = this.progressivePlayList.length;
            let idx = 0;
            const activePlaybackId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
            this.activePlaybackId = activePlaybackId;
            const doNext = ()=>{
                const nextElement = this.progressivePlayList[idx];
                idx++;
                const dynamicText = nextElement;
                const cleanup = dynamicText?.playback(20, this, ()=>{
                    if (idx < playlistLength && this.activePlaybackId === activePlaybackId) setTimeout(()=>{
                        if (this.activePlaybackId === activePlaybackId) doNext();
                        else {
                            dynamicText.stop();
                            if (callback) callback();
                        }
                    }, dynamicText.pause ? dynamicText.pause : 1);
                    else {
                        dynamicText.stop();
                        if (callback) callback();
                    }
                });
                this.currentlyPlayingLineCleaner = ()=>{
                    dynamicText.active = false;
                    if (cleanup) cleanup();
                };
            };
            doNext();
        }, this.appendChunkedText = (source)=>{
            const texts = (0, $a80d0b17b615d6f7$export$edde49207b897324)(source, 95);
            texts.forEach((text)=>{
                this.append2(text, {
                    sameLine: false
                });
            });
        };
        this.defaultTextFont = props?.defaultTextFont;
        this.linkCallback = props?.linkCallback;
        this.progressive = props?.progressive;
        this.activePlaybackId = undefined;
        this.lineHasButton = false;
        this.hoverText = props?.hoverText;
        this.opaque = props?.opaque === true;
        this.borderColor = props?.borderColor;
        if (props?.backdrop) {
            this.backdrop = new (0, $gwPoJ.Graphics)();
            this.addChild(this.backdrop);
        }
        this.margin = props?.margin || 0;
    }
}




class $b3798b784c33df3d$export$3b2ce821e7872e8e {
    constructor(subject, props){
        this.release = ()=>{
            this.subject.alpha = 1.0;
            if (this.releaseCallback) this.releaseCallback();
            let cycles = 0;
            const releaseInterval = setInterval(()=>{
                if (this.subject.alpha >= 1.0 && cycles > 0) {
                    clearInterval(releaseInterval);
                    return;
                }
                this.subject.alpha += this.dir ? 0.1 : -0.1;
                if (this.subject.alpha <= 0.4 || this.subject.alpha >= 1.5) {
                    this.dir = !this.dir;
                    cycles++;
                }
            }, this.blinkInterval);
        };
        this.update = ()=>{
            if (this.flasherInterval) return;
            this.flasherInterval = setInterval(()=>{
                this.subject.alpha += this.dir ? 0.1 : -0.1;
                if (this.subject.alpha <= this.minAlpha || this.subject.alpha >= this.maxAlpha) {
                    this.dir = !this.dir;
                    if (this.cycleCallback) this.cycleCallback();
                }
                if (!!this.expires && Date.now() > this.expires) {
                    this.stop();
                    return;
                }
            }, this.blinkInterval);
        };
        this.stop = ()=>{
            this.release();
            clearInterval(this.flasherInterval);
            this.flasherInterval = undefined;
        };
        this.subject = subject;
        this.expires = !props?.permanent ? Date.now() + props?.expires : undefined;
        this.releaseCallback = props?.releaseCallback;
        this.cycleCallback = props?.cycleCallback;
        this.blinkInterval = props?.blinkInterval || 100;
        this.minAlpha = props?.minAlpha || 0.4;
        this.maxAlpha = props?.maxAlpha || 1.5;
    }
}


class $5f817afe83d87a88$export$9ec831f4c1f089b1 {
    setup(x, y, image, label, parent, params = {}, spriteParent) {
        const job = ()=>{
            this.isExecuting = true;
            if (params.type === "vibrate" && spriteParent) {
                // this affects the parent
                let startTs = Date.now();
                let shakeDirLeft = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
                // let shakeDistance = randomIntBetween(1, 1)
                let shakeDistance = 1;
                let currentShakeDistance = shakeDistance;
                let duration = 750;
                let up = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
                let shakeOffsetX = 0;
                let shakeOffsetY = 0;
                let originalX = spriteParent.x;
                let originalY = spriteParent.y;
                const interval = setInterval(()=>{
                    let elapsed = Date.now() - startTs;
                    if (elapsed > duration) {
                        clearInterval(interval);
                        shakeOffsetX = 0;
                        shakeOffsetY = 0;
                        spriteParent.x = originalX;
                        spriteParent.y = originalY;
                        return;
                    }
                    if (elapsed / duration % 0.25 === 0 || currentShakeDistance <= 0) {
                        shakeDirLeft = !shakeDirLeft;
                        shakeDistance = shakeDistance - 1;
                        currentShakeDistance = shakeDistance;
                    }
                    currentShakeDistance -= 1;
                    shakeOffsetX += shakeDirLeft ? 1 : -1;
                    // this.updatePlayerLocation(entity)
                    // shakeOffsetY += up ? -1 : 1
                    spriteParent.x = originalX + shakeOffsetX;
                    spriteParent.y = originalY + shakeOffsetY;
                    up = !up;
                }, 10);
            }
            if (image || label) {
                const sprite = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
                if (label) sprite.append2(label, {
                    leftMargin: 0,
                    color: params?.color,
                    font: params?.font || "ChatFont"
                });
                if (image) {
                    const baseScale = 2.4;
                    const spriteImg = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        scale: baseScale,
                        name: image
                    });
                    // Small resource icons look right at baseScale, but crafted item art
                    // (weapons/tools) has a full-size frame that becomes gigantic at 2.4x.
                    // Shrink only when the rendered art exceeds ~1.5 tiles; never enlarge.
                    const maxDisplaySize = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5;
                    const largestDim = Math.max(spriteImg.width, spriteImg.height);
                    if (largestDim > maxDisplaySize) spriteImg.updateScale(baseScale * maxDisplaySize / largestDim);
                    sprite.append2(spriteImg, {
                        sameLine: true,
                        leftMargin: 8
                    });
                }
                let throbber;
                if (params?.alignment === "center") {
                    sprite.x = parent.width / 2 + (label.length > 1 ? -(label.length * 11) : 0);
                    sprite.y = y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(sprite, {
                        blinkInterval: 10
                    });
                    throbber.update();
                } else {
                    // default
                    sprite.x = -sprite.width / 4 + x;
                    sprite.y = y;
                }
                parent.addChild(sprite);
                const now = Date.now();
                const budget = params?.duration || 750;
                const { variant: variant = "default" } = params;
                const scrollIncrement = (params?.scrollSpeed || 1.0) * 2;
                const interval = setInterval(()=>{
                    if (variant === "default") sprite.y -= scrollIncrement;
                    const elapsed = Date.now() - now;
                    const alpha = elapsed / budget;
                    if (variant === "default") {
                        if (alpha > 0.7) sprite.alpha = 1.0 - alpha + 0.2;
                    }
                    if (elapsed > budget) {
                        clearInterval(interval);
                        sprite.parent?.removeChild(sprite);
                        // sprite.remove()
                        this.isExecuting = false;
                        if (this.itemPickupQueue.length < 1) {
                            clearInterval(this.itemPickupQueueInterval);
                            this.itemPickupQueueInterval = undefined;
                        }
                        if (throbber) throbber.stop();
                    }
                }, 20);
            }
        };
        if (params.immediate) {
            job();
            return job;
        }
        if (this.itemPickupQueueInterval) clearInterval(this.itemPickupQueueInterval);
        this.itemPickupQueueInterval = setInterval(()=>{
            if (this.itemPickupQueue.length < 1) {
                clearInterval(this.itemPickupQueueInterval);
                return;
            }
            const next = this.itemPickupQueue.shift();
            if (next) next();
        }, 50);
        if (!this.isExecuting) job();
        else this.itemPickupQueue.push(job);
        return job;
    }
    constructor(){
        this.itemPickupQueue = [];
        this.isExecuting = false;
        this.remove = (job)=>{
            this.itemPickupQueue = this.itemPickupQueue.filter((n)=>n !== job);
        };
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");


// Runtime toggle for the visual that plays when an entity dies.
//
// "explode" is the original effect: the sprite shatters into a radial burst of
// spinning, reddening fragments that fly outward and fade in ~500ms.
//
// "crumble" is the new alternative: the same fragments instead fall under
// gravity, tumble, bounce and settle into a dusty pile at the entity's feet,
// with a small puff of dust rising off the base.
//
// Both live side by side so they can be compared in-game. The default stays on
// the original "explode". Flip the active style at runtime from the browser
// console:
//
//     deathEffect = "crumble"    // then kill an NPC to watch it crumble
//     deathEffect = "explode"    // back to the original
//
// or preload a style with a ?death=crumble query param on the game URL.
const $e117ef21d9885baa$var$STYLES = [
    "explode",
    "crumble"
];
const $e117ef21d9885baa$var$isDeathEffectStyle = (value)=>typeof value === "string" && $e117ef21d9885baa$var$STYLES.includes(value);
let $e117ef21d9885baa$var$activeStyle = "crumble";
const $e117ef21d9885baa$export$a6f8340679349869 = ()=>$e117ef21d9885baa$var$activeStyle;
const $e117ef21d9885baa$export$14f53a783ad0d379 = (style)=>{
    if (!$e117ef21d9885baa$var$isDeathEffectStyle(style)) {
        console.warn(`[deathEffect] unknown style ${JSON.stringify(style)}; expected one of ${$e117ef21d9885baa$var$STYLES.join(", ")}`);
        return;
    }
    $e117ef21d9885baa$var$activeStyle = style;
    console.log(`[deathEffect] active style: ${$e117ef21d9885baa$var$activeStyle}`);
};
// Wire up the browser-console toggle + optional ?death= query param. Guarded so
// it is a no-op in the Node test harness (no window).
if (typeof window !== "undefined") {
    try {
        const param = new URLSearchParams(window.location.search).get("death");
        if ($e117ef21d9885baa$var$isDeathEffectStyle(param)) $e117ef21d9885baa$var$activeStyle = param;
    } catch  {
    // window.location may be unavailable in some embeddings; ignore.
    }
    Object.defineProperty(window, "deathEffect", {
        get: ()=>$e117ef21d9885baa$var$activeStyle,
        set: (style)=>$e117ef21d9885baa$export$14f53a783ad0d379(style),
        configurable: true
    });
}



// Shared slice-and-animate core behind every sprite's entity-death `fragment()`.
//
// Each sprite class builds + positions a `surface` Graphics and resolves the
// current animation frame `frame`, then hands both here. This slices the frame
// into a grid of little sub-sprites and animates them with whichever death
// style is currently active (see death_effect_config): the original radial
// "explode", or the new gravity-driven "crumble".
//
// The `onSpawned` hook fires once after all fragments are created (BasicSprite
// uses it to resolve its fragment callback).
const $4264eae3240561ee$var$randomFloatBetween = (min, max)=>Math.random() * (max - min) + min;
// Alpha byte above which a pixel counts as "solid" when locating the visible
// bottom (the feet) of a death frame. See computeContentBottomPx.
const $4264eae3240561ee$var$CONTENT_ALPHA_THRESHOLD = 8;
// Memoized foot line (local-pixel bottom of the visible art), keyed by a stable
// art identifier -- race for creatures, spriteId for basic sprites. The foot
// line within a cell is a static property of a species' art (outfit/action barely
// move it), so a whole species costs ONE readback for the session, then zero.
// Stores a plain number, so it's immune to the destroyed-texture staleness that
// bites texture caches here (no HMR clearing needed).
const $4264eae3240561ee$var$footLineCache = new Map();
const $4264eae3240561ee$export$cc249234599c5a64 = (surface, frame, opts = {})=>{
    const style = (0, $e117ef21d9885baa$export$a6f8340679349869)();
    const { x: origX, y: origY, width: width, height: height } = frame._frame;
    const divisor = height < 50 || width < 50 ? 3 : (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(10, 20);
    const cols = Math.floor(width / divisor);
    const rows = Math.floor(height / divisor);
    // Fragments (and, for crumble, dust motes) each drive their own timer. We
    // remove the shared `surface` only once the last one has finished.
    let awaitedCount = 0;
    const cleaner = ()=>{
        if (awaitedCount < 1) surface.parent?.removeChild(surface);
    };
    const onFinished = ()=>{
        awaitedCount--;
        cleaner();
    };
    // For crumble, locate the visible bottom (feet) of the art so every piece
    // settles at the creature's real foot line rather than the (often
    // padding-filled) bottom of the sprite-sheet cell. Cached per art identifier
    // (opts.cacheKey), so it's one GPU readback per species, then free.
    const crumbleGround = style === "crumble" ? $4264eae3240561ee$var$resolveCrumbleGround(frame, rows, divisor, opts.cacheKey) : 0;
    for(let y = 0; y < rows; y++)for(let x = 0; x < cols; x++){
        const fragX = origX + x * divisor;
        const fragY = origY + y * divisor;
        const frag = new (0, $klOfb.Texture)(frame.baseTexture, new (0, $6qzqq.Rectangle)(fragX, fragY, divisor, divisor), undefined, undefined, frame.rotate, frame.defaultAnchor);
        const fragSprite = new (0, $7Bs2Z.Sprite)(frag);
        fragSprite.x = x * divisor;
        fragSprite.y = y * divisor;
        surface.addChild(fragSprite);
        awaitedCount++;
        if (style === "crumble") $4264eae3240561ee$var$animateCrumbleFragment(fragSprite, {
            row: y,
            rows: rows,
            divisor: divisor
        }, crumbleGround, onFinished);
        else $4264eae3240561ee$var$animateExplodeFragment(fragSprite, onFinished);
    }
    const fragmentCount = awaitedCount;
    // A puff of dust rising off the base sells the crumble.
    if (style === "crumble" && fragmentCount > 0) {
        const dustCount = 6;
        for(let d = 0; d < dustCount; d++){
            awaitedCount++;
            $4264eae3240561ee$var$spawnDustMote(surface, width, crumbleGround, onFinished);
        }
    }
    // Matches the original loop's semantics: fire only once fragments exist.
    if (fragmentCount > 0) opts.onSpawned?.();
    else // Nothing to animate (frame smaller than the divisor): tear down now.
    surface.parent?.removeChild(surface);
};
// --- Original "explode": radial constant-velocity scatter, spin, red tint, fade over ~500ms. ---
const $4264eae3240561ee$var$animateExplodeFragment = (fragSprite, onFinished)=>{
    const angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 360));
    const speed2 = {
        x: Math.cos(angle),
        y: Math.sin(angle)
    };
    let rotation = 0;
    const startTs = Date.now();
    let changedColor1 = false;
    let changedColor2 = false;
    const interval = setInterval(()=>{
        fragSprite.x += speed2.x * 10;
        fragSprite.y += speed2.y * 10;
        fragSprite.alpha -= 0.1;
        rotation += 1;
        if (rotation > 360) rotation = 0;
        fragSprite.angle = rotation;
        if (fragSprite.alpha < 0.7 && !changedColor1) {
            fragSprite.tint = 0xffc0c0;
            changedColor1 = true;
        }
        if (fragSprite.alpha < 0.5 && !changedColor2) {
            fragSprite.tint = 0xff0000;
            changedColor2 = true;
        }
        if (Date.now() - startTs > 500) {
            $4264eae3240561ee$var$removeFrag(fragSprite);
            clearInterval(interval);
            onFinished();
        }
    }, 50);
};
// --- New "crumble": pieces fall under gravity, tumble, bounce on the ground, settle then fade. ---
const $4264eae3240561ee$var$animateCrumbleFragment = (fragSprite, grid, groundLine, onFinished)=>{
    const gravity = 1.4;
    const bounce = 0.32;
    // Settle at the resolved foot line (bottom of the visible art), with a
    // little jitter for an uneven pile. Never above the piece's own start, so a
    // fragment already at/below the foot just settles in place instead of rising.
    const startY = grid.row * grid.divisor;
    const ground = Math.max(startY, groundLine + $4264eae3240561ee$var$randomFloatBetween(-grid.divisor * 0.4, grid.divisor * 0.25));
    // Lower rows give way first, so the figure collapses from the base upward.
    const delay = (grid.rows - 1 - grid.row) * 18;
    let vx = $4264eae3240561ee$var$randomFloatBetween(-2.2, 2.2);
    let vy = $4264eae3240561ee$var$randomFloatBetween(-1.5, 0.5);
    let spin = $4264eae3240561ee$var$randomFloatBetween(-4, 4);
    let settled = false;
    let tinted = false;
    const startTs = Date.now();
    const startAt = startTs + delay;
    const interval = setInterval(()=>{
        const now = Date.now();
        if (now < startAt) return;
        if (!settled) {
            vy += gravity;
            fragSprite.y += vy;
            fragSprite.x += vx;
            fragSprite.angle += spin;
            if (fragSprite.y >= ground && vy > 0) {
                fragSprite.y = ground;
                vy *= -bounce;
                vx *= 0.55;
                spin *= 0.5;
                if (Math.abs(vy) < 1) {
                    vy = 0;
                    settled = true;
                }
            }
        }
        // Once it has come to rest (or lingered long enough) it fades to dust.
        if (settled || now - startAt > 700) {
            fragSprite.alpha -= 0.06;
            if (fragSprite.alpha < 0.6 && !tinted) {
                fragSprite.tint = 0x9a8f80 // dusty grey-brown, not fiery red
                ;
                tinted = true;
            }
        }
        if (fragSprite.alpha <= 0 || now - startTs > 1600) {
            $4264eae3240561ee$var$removeFrag(fragSprite);
            clearInterval(interval);
            onFinished();
        }
    }, 50);
};
// Resolve the local-pixel y where crumble pieces should pile: the bottom of the
// frame's visible art (the feet), falling back to the bottom of the sprite-sheet
// cell when a pixel read isn't possible. When a cacheKey is given, the resolved
// foot line is memoized per art identifier (see footLineCache) so we do at most
// one readback per species. A failed/unavailable read is NOT cached, so we retry
// on the next death (e.g. if the renderer wasn't ready the first time).
const $4264eae3240561ee$var$resolveCrumbleGround = (frame, rows, divisor, cacheKey)=>{
    if (cacheKey) {
        const cached = $4264eae3240561ee$var$footLineCache.get(cacheKey);
        if (cached !== undefined) return cached;
    }
    // Cache miss (or no key given): pay for one pixel readback.
    const contentBottom = $4264eae3240561ee$var$computeContentBottomPx(frame);
    if (contentBottom != null && contentBottom > 0) {
        if (cacheKey) $4264eae3240561ee$var$footLineCache.set(cacheKey, contentBottom);
        return contentBottom;
    }
    return rows * divisor;
};
// Read back the frame's pixels and return the local-pixel y of the lowest row
// that still has a solid (non-transparent) pixel -- the visible bottom of the
// art. Returns null if the renderer/extract plugin is unavailable (e.g. tests)
// or the frame is empty. Resolution-independent: works off canvas-height fractions.
const $4264eae3240561ee$var$computeContentBottomPx = (frame)=>{
    const extract = (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app?.renderer?.plugins?.extract;
    if (!extract) return null;
    const probe = new (0, $7Bs2Z.Sprite)(frame);
    try {
        const canvas = extract.canvas(probe);
        const ctx = canvas.getContext("2d");
        const cw = canvas.width;
        const ch = canvas.height;
        if (!ctx || cw === 0 || ch === 0) return null;
        const data = ctx.getImageData(0, 0, cw, ch).data;
        const frameHeight = frame._frame.height;
        for(let y = ch - 1; y >= 0; y--){
            const rowOffset = y * cw * 4;
            for(let x = 0; x < cw; x++){
                if (data[rowOffset + x * 4 + 3] > $4264eae3240561ee$var$CONTENT_ALPHA_THRESHOLD) // Map the canvas row back into the frame's local pixel space.
                return (y + 1) / ch * frameHeight;
            }
        }
        return null;
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
        return null;
    } finally{
        probe.destroy();
    }
};
// A single dust mote off the shared WHITE texture (batches cheaply): rises, drifts, shrinks, fades.
const $4264eae3240561ee$var$spawnDustMote = (surface, width, baseY, onFinished)=>{
    const dust = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
    dust.tint = 0x8b7355;
    const size = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(2, 4);
    dust.width = size;
    dust.height = size;
    dust.x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, Math.max(1, width));
    dust.y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.floor(baseY * 0.7), Math.max(1, Math.floor(baseY)));
    dust.alpha = 0.6;
    surface.addChild(dust);
    const vx = $4264eae3240561ee$var$randomFloatBetween(-0.8, 0.8);
    const vy = $4264eae3240561ee$var$randomFloatBetween(-3.5, -2);
    const interval = setInterval(()=>{
        dust.x += vx;
        dust.y += vy;
        dust.alpha -= 0.03;
        dust.scale.set(dust.scale.x * 0.97);
        if (dust.alpha <= 0) {
            $4264eae3240561ee$var$removeFrag(dust);
            clearInterval(interval);
            onFinished();
        }
    }, 50);
};
const $4264eae3240561ee$var$removeFrag = (sprite)=>{
    try {
        if (sprite?.parent) sprite.parent.removeChild(sprite);
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
    }
};


class $15caf4b106aaadb3$export$5a33d6de29791ec5 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    // `withClickArea` gives this sprite its own hover/hit surface sized to the rendered art (see
    // updateClickAreaBounds) instead of hit-testing the whole renderable. Entities the player can
    // point at -- the interactable markers -- opt in; pure decoration doesn't.
    constructor(spriteMeta, withClickArea){
        super(), this.updateScale = (scale)=>{
            if (this.animation) this.animation.scale.set(scale);
            if (this.sprite) this.sprite.scale.set(scale);
            this.updateClickAreaBounds();
        }, this.startRotation = ()=>{
            let angle = 0;
            this.rotationInterval = setInterval(()=>{
                if (angle > 360) angle = 0;
                this.container.angle = angle;
                angle++;
            }, 50);
        }, this.updateRotating = (rotating)=>{
            if (!rotating) {
                if (this.rotationInterval) {
                    clearInterval(this.rotationInterval);
                    this.container.angle = 0;
                }
            } else this.startRotation();
        }, this.getCurrentColor = ()=>this.currentColor, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            if (this.animation) this.animation.tint = color;
            if (this.sprite) this.sprite.tint = color;
        }, this.getClickSurface = ()=>{
            if (this.clickArea) return this.clickArea;
            return super.getClickSurface();
        }, // Size the hover/hit region to the actual rendered art instead of a fixed one-tile box.
        // Uses pixi's `hitArea` Rectangle: nothing is drawn (no batched geometry, no per-frame GPU
        // cost) and hit-testing short-circuits to a rectangle contains-check. This runs ONCE here at
        // construction, and again only on sprite/scale change (both change-gated) — never per frame —
        // so it stays cheap on low-end hardware.
        this.updateClickAreaBounds = ()=>{
            if (!this.clickArea) return;
            this.clickArea.x = 0;
            this.clickArea.y = 0;
            this.clickArea.hitArea = (0, $85a39b5d41a16ed9$export$15d4c1eea10d6840)(this.visibleArtBounds());
        }, // What this sprite actually draws, in the renderable's own local space -- the region a pointer
        // should have to be inside.
        //
        // NOT simply the container's bounds: a composite tile texture is the bounding box of every tile
        // making up the object (see TileTextureExtractor), and for the ember campfire that box carries
        // ~32px of empty tile out to each side. Taking it at face value made the campfire react to a
        // pointer a whole tile away from the flame. Trim to the texture's opaque pixels where we can;
        // fall back to the container bounds when we can't (an animation, or no renderer to read back
        // from, as in tests).
        this.visibleArtBounds = ()=>{
            const containerBounds = this.container.getLocalBounds();
            const fallback = containerBounds.width > 0 && containerBounds.height > 0 && isFinite(containerBounds.x) && isFinite(containerBounds.y) ? containerBounds : null;
            if (!this.sprite || this.animation) return fallback;
            const content = (0, $35a6592763403c18$export$46429b068ef0a2d5)(this.sprite.texture, this.spriteId);
            if (!content) return fallback;
            // content is in texture pixel space; the sprite's own position already carries the centering
            // shift applied to composite tiles, and its scale the render scale.
            return new (0, $6qzqq.Rectangle)(this.sprite.position.x + content.x * this.sprite.scale.x, this.sprite.position.y + content.y * this.sprite.scale.y, content.width * this.sprite.scale.x, content.height * this.sprite.scale.y);
        }, // Reports false for a blank stand-in sprite: the V2 chest draws its real art in the TILEMAP and
        // keeps only an invisible 32x32 marker here, so there is no shape here to trace and the caller
        // outlines the map tiles instead. Anything with actual art (a door, an outpost, a dropped item)
        // traces itself.
        this.setHighlighted = (on)=>{
            if (!this.highlightFrame()) return false;
            if (!this.entityHighlight) this.entityHighlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
                artContainer: this.container,
                frame: this.highlightFrame
            });
            this.entityHighlight.set(on);
            return true;
        }, this.highlightFrame = ()=>{
            // A blank stand-in sprite has nothing to outline; say so and take the ring instead.
            if (!this.spriteId || this.spriteId.startsWith("blank")) return null;
            const art = this.animation ?? this.sprite;
            const texture = this.animation ? this.animation.textures[this.animation.currentFrame] : this.sprite?.texture;
            if (!art || !texture?.valid) return null;
            return {
                texture: texture,
                x: art.position.x,
                y: art.position.y,
                scaleX: art.scale.x,
                scaleY: art.scale.y
            };
        }, this.setWorldOverlayItem = (item)=>{
            this.worldOverlayItem = item;
        };
        this.spriteMeta = spriteMeta;
        const { color: color = 0xffffff, name: name, scale: scale = 1.0, alpha: alpha = 1.0, animated: animated, animationSpeed: animationSpeed = 0.167, rotating: rotating, looping: looping = true, rotation: rotation, onLoopDone: onLoopDone, supportLabel: supportLabel } = spriteMeta;
        this.spriteId = name;
        this.supportLabel = supportLabel;
        this.scaleValue = scale;
        if (withClickArea) {
            this.clickArea = new (0, $a64b70167386625f$export$98e91636974d835d)();
            if (this.clickArea.parent) this.clickArea.parent.removeChild(this.parentArea);
            // Hover/hit region is sized to the actual rendered art in updateClickAreaBounds()
            // (called below, after the sprite is built). We deliberately draw NOTHING here and
            // rely on pixi's `hitArea` Rectangle instead of a filled Graphics — see that method.
            this.addChild(this.clickArea);
        }
        this.container = new (0, $gwPoJ.Graphics)();
        this.addChild(this.container);
        this.originalColor = color;
        this.currentColor = color;
        const loader = (0, $kXE1p.Loader).shared;
        let resource = loader.resources["humanoid"];
        // A sheet that failed to load leaves the resource present but unparsed, so `.spritesheet`
        // is undefined and reading `.animations` off it throws -- inside a constructor, on the
        // entity-creation path, which takes out every renderable in the room and leaves a world
        // with terrain and no characters in it. One unreachable file should cost one sprite, not
        // all of them, so degrade the way lpc_sprite.setup() already does.
        const sheet = resource?.spritesheet;
        const isAnimated = animated !== undefined ? animated : !!sheet?.animations[name];
        this._scale = scale;
        // `animated: true` can be passed explicitly, so the frames still have to be there before
        // this branch dereferences them.
        if (isAnimated && sheet?.animations[name]) {
            this.animation = new (0, $d3fD1.AnimatedSprite)(sheet.animations[name]);
            this.animation.scale.set(0.35);
            // set speed, start playback and add it to the stage
            this.animation.animationSpeed = animationSpeed;
            this.animation.tint = color;
            this.animation.alpha = alpha;
            this.animation.play();
            this.animation.scale.set(scale);
            this.container.addChild(this.animation);
            if (!looping) {
                this.animation.loop = false;
                if (onLoopDone) this.animation.onComplete = onLoopDone;
            }
        } else {
            let tileIdToUse = name;
            let texture;
            if (name.includes(":")) {
                const [resourceName, tileId] = name.split(":");
                tileIdToUse = `${resourceName}-${tileId}`;
                resource = (0, $kXE1p.Loader).shared.resources[resourceName];
                const tileset = spriteMeta?.tileMapMetaProvider?.getTilesetById(resourceName);
                if (tileset) {
                    const tilesetTileMeta = tileset.tiles[Number(tileId) - 1];
                    if (tilesetTileMeta) {
                        const compositeTileId = tilesetTileMeta.compositeTileId;
                        if (compositeTileId) texture = (0, $86e9e05f3ebc1d8f$export$171acc6ba80afe2).instance.extract(spriteMeta.tileMapMetaProvider, tileset.tilesetId, compositeTileId);
                    }
                }
            }
            if (!texture) texture = resource?.textures[tileIdToUse];
            if (texture) {
                this.sprite = new (0, $7Bs2Z.Sprite)(texture);
                if (name.includes(":")) {
                    this.sprite.transform.position.x -= texture.width / 2;
                    this.sprite.transform.position.y -= 14;
                }
                this.sprite.tint = color;
                this.sprite.scale.set(scale);
                this.container.addChild(this.sprite);
            }
        }
        this.updateClickAreaBounds();
        this.labelText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").color(0x00ff00).render();
        this.labelText.visible = false;
        this.labelText.x = -this.container.width * 0.23;
        this.labelText.y = -this.container.height * 0.7;
        this.addChild(this.labelText);
        if (rotation !== undefined) this.container.angle = rotation;
        if (rotating) this.startRotation();
        this.animatedFeedback = new (0, $5f817afe83d87a88$export$9ec831f4c1f089b1)();
    }
    updateName(name) {
        if (!this.supportLabel) return;
        if (name) {
            this.labelText.text = name.replace(/ /g, "\n");
            this.labelText.visible = true;
        } else this.labelText.visible = false;
    }
    fragment(_, callback) {
        const surface = new (0, $gwPoJ.Graphics)();
        surface.scale.set(this._scale);
        surface.rotation = this.container.rotation;
        this.parent.addChild(surface);
        const f = this.animation ? this.animation.textures[this.animation.currentFrame] : this.sprite?.texture;
        const { width: width, height: height } = f._frame;
        surface.x -= width / 2;
        surface.y -= height / 2;
        (0, $4264eae3240561ee$export$cc249234599c5a64)(surface, f, {
            onSpawned: ()=>callback?.(),
            cacheKey: this.spriteId
        });
    }
    updateSpriteId(spriteId) {
        if (!spriteId) return;
        if (this.spriteId === spriteId) // noop, it has changed already
        return;
        // todo ... this only really supports non-animated sprites
        if (this.sprite) this.container.removeChild(this.sprite);
        if (this.animation) this.container.removeChild(this.animation);
        this.spriteId = spriteId;
        let resource = (0, $kXE1p.Loader).shared.resources["humanoid"];
        let tileIdToUse = spriteId;
        if (spriteId.includes(":")) {
            const [resourceName, tileId] = spriteId.split(":");
            tileIdToUse = `${resourceName}-${tileId}`;
            resource = (0, $kXE1p.Loader).shared.resources[resourceName];
        }
        if (resource) {
            // `resource` being present says only that the loader knows the url, not that the sheet
            // behind it parsed -- a failed or still-parsing sheet leaves `.spritesheet` (or its
            // `.animations`) undefined, and reading through it throws inside this constructor, on
            // the entity-creation path, taking out every renderable in the room. Same reason the
            // constructor above guards; this is the second door into the same trap.
            const isAnimated = !!resource.spritesheet?.animations?.[spriteId];
            if (isAnimated) {
                const { color: color = 0xffffff, scale: scale = 1.0, alpha: alpha = 1.0, animationSpeed: animationSpeed = 0.167, looping: looping = true, onLoopDone: onLoopDone } = this.spriteMeta;
                this.animation = new (0, $d3fD1.AnimatedSprite)(resource.spritesheet.animations[spriteId]);
                this.animation.scale.set(0.35);
                // set speed, start playback and add it to the stage
                this.animation.animationSpeed = animationSpeed;
                this.animation.tint = color;
                this.animation.alpha = alpha;
                this.animation.play();
                this.animation.scale.set(scale);
                this.container.addChild(this.animation);
                if (!looping) {
                    this.animation.loop = false;
                    if (onLoopDone) this.animation.onComplete = onLoopDone;
                }
            } else {
                const texture = resource.textures?.[tileIdToUse];
                if (texture) {
                    this.sprite = new (0, $7Bs2Z.Sprite)(texture);
                    this.sprite.tint = this.currentColor;
                    this.sprite.scale.set(this.scaleValue);
                    this.container.addChild(this.sprite);
                }
            }
        }
        this.updateClickAreaBounds();
    }
    getYOffset() {
        if (this.spriteId.includes("-exact")) return 0;
        return super.getYOffset();
    }
    // Floating feedback over this sprite. A running body's dust trail does NOT come through here --
    // see LpcComposite.feedback and FootDust: it is ground art, z-sorted in the world surface, and
    // EntityRenderingManager.feedback routes it away before it reaches a renderable.
    feedback(entity, image, label, params) {
        (0, $5UG8I.logger).debug({
            tags: [
                "sprite",
                "feedback"
            ]
        }, "Feedback");
        this.animatedFeedback.setup(0, this.worldOverlayItem.height / 2, image, label, this.worldOverlayItem, params, this.sprite);
    }
}



class $6d7a9fd00230699d$export$eb38fb18cfba1d64 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(){
        super();
        this.drawCircle(0, 0, 1);
    }
}



var $8Odl4 = parcelRequire("8Odl4");

class $a372f7647b536fce$export$3a0f78411bc2215d extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entity){
        super(), this.startTs = 0, this.i = 0, this.size = 0, this.pulse = ()=>{
            if (this.entity?.isDead() || this.detonted) {
                this.visible = false;
                return;
            }
            this.i++;
            let color = this.i % 2 === 0 ? 0x80deea : 0xb3ebf2;
            this.drawArea(color, this.i, 2);
            if (this.pulseDelay > 50) {
                this.pulseDelay *= 0.8;
                this.pulseTimeout = setTimeout(this.pulse, this.pulseDelay);
            } else this.pulseTimeout = setTimeout(this.pulse, this.pulseDelay);
        }, this.detonate = ()=>{
            if (this.detonted) return;
            clearInterval(this.tickPlayInterval);
            clearTimeout(this.pulseTimeout);
            this.detonted = true;
            let maxRadius = 100;
            let i = 0;
            (0, $8Odl4.sound).play("explosion");
            const interval = setInterval(()=>{
                if (this.entity?.isDead() || this.size > maxRadius) {
                    this.clear();
                    clearInterval(interval);
                    return;
                }
                const increment = maxRadius / 17;
                this.size += increment;
                i++;
                this.drawArea(i % 2 === 0 ? 0xff0000 : 0xefefef, 0, this.size);
            }, 17);
        }, this.drawArea = (color, i, radius)=>{
            super.clear();
            super.beginFill(color);
            super.lineStyle(10, color);
            super.drawCircle(0, 0, radius + (i % 2 === 0 ? 0 : 1));
            super.endFill();
        };
        this.entity = entity;
        this.drawArea(0xb3ebf2, 0, 2);
        this.pulseDelay = 500;
        this.startTs = Date.now();
        this.pulse();
        this.tickPlayInterval = setInterval(()=>{
            (0, $8Odl4.sound).play("clocktick", {
                volume: 0.1,
                speed: 0.85 + Math.min(0.15, Math.random())
            });
        }, 500);
    }
    remove() {
        super.remove();
        clearInterval(this.tickPlayInterval);
    }
}



class $8b020fb41ab0fc7e$export$f90411c24f6aebf8 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff0000, alpha = 1.0){
        super();
        super.beginFill(0xff0000, alpha);
        super.lineStyle(2, 0xff0000, alpha);
        super.drawRoundedRect(5, 0, 9, 1, 1);
        super.endFill();
        super.beginFill(0xffffff, 0.35);
        super.lineStyle(2, 0xffffff, 0.35);
        super.drawRoundedRect(2, 0, 4, 1, 1);
        super.endFill();
        super.beginFill(0xffffff, 0.1);
        super.lineStyle(2, 0xffffff, 0.1);
        super.drawRoundedRect(0, 0, 3, 1, 1);
        super.endFill();
    }
}


parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");
var $klOfb = parcelRequire("klOfb");
var $d3fD1 = parcelRequire("d3fD1");

// In-world campfire flame rendered from a PROCEDURALLY BAKED animation instead of hand-drawn atlas
// frames. A pool of rising particles (the ember roster's flame look, minus the halo) is baked once
// into a small set of RenderTextures; every fire plays those back through a plain AnimatedSprite.
// Playback is a GPU texture swap per frame (the same cost as the old atlas "fire" sprite) — far
// cheaper than redrawing a Graphics every frame per fire.
//
// SEAMLESS LOOP: unlike the roster's real-time stochastic sim, the bake is PHASE-based. Every
// particle is a pure function of a loop phase u in [0,1): its age is frac(u - birthPhase), so the
// frame at u=1 is identical to u=0 and the AnimatedSprite loops with no jump. Particles fade to zero
// alpha just before their age wraps (top -> bottom), so the invisible reset is never seen; staggered
// birth phases mean no two reset together.
// Bake resolution / length. The flame fills the frame; height gives the particles room to rise. More
// frames = smoother motion + more VRAM; the loop is seamless at any count.
const $2ea1527dda10caae$var$FRAME_W = 48;
const $2ea1527dda10caae$var$FRAME_H = 64;
const $2ea1527dda10caae$var$FRAME_COUNT = 30;
const $2ea1527dda10caae$var$PARTICLE_COUNT = 52;
// Playback tuning (world-space). Tweak scale to size the flame against a 32px tile.
const $2ea1527dda10caae$var$FIRE_SCALE = 0.8;
const $2ea1527dda10caae$var$ANIMATION_SPEED = 0.4;
// Nudge the flame's base down a few px so it reads as emanating from inside the campfire logs
// rather than sitting right on top of them.
const $2ea1527dda10caae$var$FIRE_Y_OFFSET = 5;
// Horizontal nudge of the flame within its container (the fire entity is placed a few px right of
// the campfire centre server-side); negative pulls it left to sit centred over the logs.
const $2ea1527dda10caae$var$FIRE_X_OFFSET = -3;
// ADD makes the warm glow bloom onto the world (great at night, like the roster card; can look
// washed-out over bright daytime terrain). Switch to BLEND_MODES.NORMAL if daytime fires read weak.
const $2ea1527dda10caae$var$FIRE_BLEND = (0, $P8XPi.BLEND_MODES).ADD;
// Campfire flame palette (young -> old): hot orange core -> orange -> red-orange -> deep red.
// Warmer/redder than the roster's golden flame (no white/yellow), and with ADD blend the dense base
// still brightens toward a hot core. Tweak these hexes to push the fire more red or more orange.
const $2ea1527dda10caae$var$campfireColor = (lifeFrac)=>lifeFrac > 0.85 ? 0xff9d2b : lifeFrac > 0.58 ? 0xff6a12 : lifeFrac > 0.3 ? 0xdc3a0c : 0xa81805;
// Baked once and shared across every fire instance.
let $2ea1527dda10caae$var$cachedFrames;
const $2ea1527dda10caae$var$frac = (n)=>n - Math.floor(n);
const $2ea1527dda10caae$var$makeLoopParticles = ()=>{
    const cx = $2ea1527dda10caae$var$FRAME_W / 2;
    const particles = [];
    for(let i = 0; i < $2ea1527dda10caae$var$PARTICLE_COUNT; i++)particles.push({
        // Evenly staggered around the loop (+ small jitter) so density is steady, not pulsing.
        birthPhase: $2ea1527dda10caae$var$frac(i / $2ea1527dda10caae$var$PARTICLE_COUNT + (Math.random() - 0.5) * (0.4 / $2ea1527dda10caae$var$PARTICLE_COUNT)),
        baseX: cx + (Math.random() - 0.5) * $2ea1527dda10caae$var$FRAME_W * 0.5,
        baseY: $2ea1527dda10caae$var$FRAME_H - Math.random() * 5,
        rise: $2ea1527dda10caae$var$FRAME_H * (0.55 + Math.random() * 0.5),
        size: 3.5 + Math.random() * 3.5,
        drift: (Math.random() - 0.5) * $2ea1527dda10caae$var$FRAME_W * 0.1,
        converge: 0.3 + Math.random() * 0.4,
        wobbleAmp: 1.5 + Math.random() * 3,
        wobbleFreq: 0.5 + Math.random() * 1.5,
        wobblePhase: Math.random() * Math.PI * 2
    });
    return particles;
};
// Draw one loop frame (phase in [0,1)) of the particle pool into `g`. Additive-style bright core is
// left to the playback blend; here each particle is a soft warm circle whose alpha envelope is 0 at
// both ends of its life (so the top->bottom wrap is invisible) and brightest near the base.
const $2ea1527dda10caae$var$drawLoopFrame = (g, particles, phase)=>{
    g.clear();
    const cx = $2ea1527dda10caae$var$FRAME_W / 2;
    for (const p of particles){
        const age = $2ea1527dda10caae$var$frac(phase - p.birthPhase) // 0 (youngest, at base) -> 1 (oldest, at top)
        ;
        const lifeFrac = 1 - age;
        const fadeIn = Math.min(1, age / 0.12) // kill the pop as age wraps back to 0 at the base
        ;
        const env = fadeIn * (1 - age // 0 at both ends, brightest near the base
        );
        if (env <= 0.02) continue;
        const y = p.baseY - p.rise * age;
        const xBase = p.baseX + (cx - p.baseX) * (age * p.converge) + p.drift * age;
        const x = xBase + p.wobbleAmp * Math.sin(p.wobbleFreq * age * Math.PI * 2 + p.wobblePhase);
        const r = p.size * (0.5 + 0.5 * lifeFrac);
        g.beginFill($2ea1527dda10caae$var$campfireColor(lifeFrac), env * 0.9);
        g.drawCircle(x, y, r);
        g.endFill();
    }
};
// Bake FRAME_COUNT seamless loop frames into RenderTextures. Cached: only the first fire in a
// session pays for the bake; every later fire reuses the same textures.
const $2ea1527dda10caae$var$bakeFireFrames = (renderer)=>{
    if ($2ea1527dda10caae$var$cachedFrames) return $2ea1527dda10caae$var$cachedFrames;
    const particles = $2ea1527dda10caae$var$makeLoopParticles();
    const g = new (0, $gwPoJ.Graphics)();
    const frames = [];
    for(let i = 0; i < $2ea1527dda10caae$var$FRAME_COUNT; i++){
        $2ea1527dda10caae$var$drawLoopFrame(g, particles, i / $2ea1527dda10caae$var$FRAME_COUNT);
        const rt = (0, $klOfb.RenderTexture).create({
            width: $2ea1527dda10caae$var$FRAME_W,
            height: $2ea1527dda10caae$var$FRAME_H
        });
        renderer.render(g, {
            renderTexture: rt,
            clear: true
        });
        frames.push(rt);
    }
    g.destroy();
    $2ea1527dda10caae$var$cachedFrames = frames;
    return frames;
};
class $2ea1527dda10caae$export$5d3e6a2d155f61d0 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(renderer){
        super(), // Fire strength (0..1) -> flame height + brightness, so a dying fire reads as a smaller, dimmer
        // flame. Defaults to full strength; wire this to a per-fire strength signal when one exists.
        this.setIntensity = (strength)=>{
            const s = Math.max(0, Math.min(1, strength));
            this.animation.alpha = 0.35 + 0.65 * s;
            this.animation.scale.set($2ea1527dda10caae$var$FIRE_SCALE, $2ea1527dda10caae$var$FIRE_SCALE * (0.5 + 0.5 * s));
        }, // Detach from the shared ticker when the fire entity is destroyed (AnimatedSprite.play registers
        // it there); the cached textures are shared and intentionally left alive.
        this.cleanup = ()=>{
            this.animation.stop();
        };
        const frames = $2ea1527dda10caae$var$bakeFireFrames(renderer);
        this.animation = new (0, $d3fD1.AnimatedSprite)(frames);
        // Bottom-centre anchored so the flame's base sits on the fire entity's location.
        this.animation.anchor.set(0.5, 1);
        this.animation.x = $2ea1527dda10caae$var$FIRE_X_OFFSET;
        // Additive, like the roster card: the warm glow adds onto the (night-time) world.
        this.animation.blendMode = $2ea1527dda10caae$var$FIRE_BLEND;
        this.animation.animationSpeed = $2ea1527dda10caae$var$ANIMATION_SPEED;
        // Start on a random frame so multiple fires don't flicker in lockstep.
        this.animation.gotoAndPlay(Math.floor(Math.random() * frames.length));
        this.addChild(this.animation);
        this.setIntensity(1);
    }
    // Anchored at its base (not the default -height*0.25); drop it slightly so the flame emanates
    // from within the campfire rather than perching on top.
    getYOffset() {
        return $2ea1527dda10caae$var$FIRE_Y_OFFSET;
    }
    // The campfire drives a burn-down factor through the entity's spriteScale (1 -> 0 as the fire
    // ages). The marker-create path applies it via scale.set once; honour later updates here too so
    // a dying fire visibly shrinks toward its base. Composes with the internal FIRE_SCALE/intensity.
    updateScale(scale) {
        this.scale.set(scale, scale);
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");

class $0a6164d33da4c314$export$462e530a9b3886e4 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff){
        super();
        super.beginFill(color);
        super.lineStyle(4, color);
        super.drawPolygon([
            new (0, $6qzqq.Point)(0, 0),
            new (0, $6qzqq.Point)(50, 50)
        ]);
        super.drawPolygon([
            new (0, $6qzqq.Point)(50, 0),
            new (0, $6qzqq.Point)(0, 50)
        ]);
        super.endFill();
    }
}







const $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1 = (itemTypeMeta)=>{
    if (!itemTypeMeta) return;
    return {
        component: itemTypeMeta.type,
        color: itemTypeMeta.color
    };
};
const $1a2d6d21d6b0fac8$export$b7be1ee14f302b62 = (entity, raceToUse, sexToUse)=>{
    const race = raceToUse || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$2a4812914c68f73e));
    const hair = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$abac18ec637a6d99));
    const nose = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$523e552deae170d8)[race]);
    const eyes = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[race]);
    const sex = sexToUse || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[race]);
    return {
        race: race,
        bodyColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[race]),
        hair: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex]),
        hairColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[hair]),
        sex: sex,
        nose: nose,
        noseColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$f5fdec393d34621)[nose]),
        eyes: eyes,
        eyesColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[eyes]),
        inventoryAppearanceHash: (0, $f684496fff50a7a1$export$fe4683c17d6b2a37)(entity?.inventory)
    };
};
const $1a2d6d21d6b0fac8$export$f46d9a45b447180e = (appearanceSpec)=>{
    const pick = (t)=>{
        if (Array.isArray(t)) return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(t);
        return t;
    };
    const { race: race = "human", sex: sex = "male", age: age = "young" } = appearanceSpec;
    const eyes = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[race]);
    let hairColor;
    let hair = appearanceSpec.hair === "none" ? undefined : pick(appearanceSpec.hair) || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$abac18ec637a6d99));
    let nose = appearanceSpec.nose === "none" ? undefined : pick(appearanceSpec.nose) || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$523e552deae170d8)[race]);
    if (age === "old" && !appearanceSpec.hairColor) hairColor = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
        "gray",
        "white"
    ]);
    else hairColor = pick(appearanceSpec.hairColor);
    if (age === "old" && sex === "male") {
        hair = "balding";
        nose = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
            undefined,
            "big"
        ]);
    }
    if (age === "old" && sex === "female") // hair = "loose"
    hair = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
        "long_center_part",
        "loose",
        "shortknot"
    ]);
    const bodyColor = pick(appearanceSpec.bodyColor);
    return {
        race: race,
        bodyColor: bodyColor || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[race]),
        hair: hair,
        hairColor: hairColor || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[hair]),
        sex: sex,
        nose: nose || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$523e552deae170d8)[race]),
        noseColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$f5fdec393d34621)[nose]),
        eyes: eyes,
        eyesColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[eyes]),
        inventoryAppearanceHash: ""
    };
};


/**
 * The sprite registry: which sheets a component is made of, as data.
 *
 * The pipeline around this file -- what generates what, and how to change it -- is written up in
 * `docs/sprite-lab.md`.
 *
 * This is the shape `lpc-forge.ts`'s branching turns into. An entry is either
 *
 *   - **templated** -- a list of layers, each a z-index and a path over `{sex}` and `{variant}`,
 *     plus the map from the game's `Color` names to the variant names the art actually uses; or
 *   - **explicit** -- a flat `sex/colour -> sheets` table, for the handful of components whose
 *     shape no template describes.
 *
 * The two exist because the registry is DERIVED from the forge and verified against it (see
 * tools/src/derive-lpc-registry.ts): anything the template form cannot reproduce exactly falls
 * back to the table rather than shipping a near-miss.
 *
 * ## What is deliberately not here
 *
 * The colour list. `HairColors`, `RaceColors` and the rest stay the source of which colours a
 * component offers and, because the first entry is the fallback, of what an unrecognised colour
 * renders as. The registry only says where a colour's art lives. Keeping the list in one place
 * means adding a colour is still one edit, and `slot_colors.ts` is where both sides read it.
 */ const $77edb5cf00d051a9$export$ffcd8ef8c2ace575 = (entry, { color: color, requestedColor: requestedColor, sex: sex })=>{
    if (!entry) return [];
    if (entry.explicit) {
        // An explicit table is keyed by what was ASKED for, not by the resolved colour: it was
        // captured per requested colour and already has the fallback baked into each row.
        const found = entry.explicit[`${sex}/${requestedColor}`];
        return (found || []).map((s)=>({
                entityId: s.path,
                zIndex: s.z,
                ...s.type ? {
                    type: s.type
                } : {}
            }));
    }
    if (!entry.layers) return [];
    // A component with a variant map that has nothing for this colour has no art to point at.
    // (Only reachable when the component declares no colours at all, since the fallback otherwise
    // guarantees a supported one.)
    const variant = entry.variants ? entry.variants[color] : undefined;
    if (entry.variants && variant === undefined) return [];
    return entry.layers.map((layer)=>({
            entityId: layer.path.replace("{sex}", sex).replace("{variant}", variant ?? ""),
            zIndex: layer.z,
            ...layer.type ? {
                type: layer.type
            } : {}
        }));
};


/**
 * GENERATED from sprite_registry.json -- do not edit.
 *
 * Edit the JSON and run `yarn compile:lpc` (from packages/tools), or let the sprite lab do it.
 * `yarn compile:lpc --check` fails if this file and the JSON disagree.
 */ const $c5288b67ae1c4c33$export$5bfd8bfbf03dc8d7 = {
    "armor": {
        "armor-leather": {
            "colors": [
                "blue",
                "brown",
                "green"
            ],
            "layers": [
                {
                    "z": 60,
                    "path": "torso/armour/leather/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "blue": "blue",
                "brown": "brown",
                "green": "green"
            }
        },
        "armor-legion": {
            "colors": [
                "brown",
                "gray",
                "gold"
            ],
            "layers": [
                {
                    "z": 60,
                    "path": "torso/armour/legion/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "brown": "bronze",
                "gray": "steel",
                "gold": "gold"
            }
        },
        "armor-plate": {
            "colors": [
                "gray",
                "metal",
                "yellow",
                "gold",
                "orange",
                "tan"
            ],
            "layers": [
                {
                    "z": 60,
                    "path": "torso/armour/plate/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "gray": "11",
                "metal": "12",
                "yellow": "12",
                "gold": "14",
                "orange": "16",
                "tan": "special"
            }
        }
    },
    "bauldron": {
        "bauldron": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 65,
                    "path": "bauldron/{sex}/brown.png"
                }
            ]
        }
    },
    "body": {
        "bee": {
            "colors": [
                "yellow"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/bee/yellow.png"
                }
            ]
        },
        "chicken": {
            "colors": [
                "white"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/chicken/white.png"
                }
            ]
        },
        "deer": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/deer/brown.png"
                }
            ]
        },
        "horse": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/horse/burdened/brown.png"
                }
            ]
        },
        "human": {
            "colors": [
                "white",
                "black",
                "olive",
                "brown",
                "light",
                "dark",
                "tan"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/human/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "black": "black",
                "olive": "olive",
                "brown": "brown",
                "light": "light",
                "dark": "dark",
                "tan": "tanned"
            }
        },
        "orc": {
            "colors": [
                "gray",
                "green",
                "lightgreen"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/orcs/{variant}.png"
                }
            ],
            "variants": {
                "gray": "gray",
                "green": "green_1",
                "lightgreen": "green_3"
            }
        },
        "rabbit": {
            "colors": [
                "white"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/rabbit/white.png"
                }
            ]
        },
        "redspider": {
            "colors": [
                "red"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/redspider/red.png"
                }
            ]
        },
        "reptile": {
            "colors": [
                "green",
                "lightgreen",
                "blue"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/reptiles/{variant}_unwinged.png"
                }
            ],
            "variants": {
                "green": "green",
                "lightgreen": "lightgreen",
                "blue": "blue"
            }
        },
        "reptile-winged": {
            "colors": [
                "green",
                "lightgreen",
                "blue"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/reptiles/{variant}_winged.png"
                }
            ],
            "variants": {
                "green": "green",
                "lightgreen": "lightgreen",
                "blue": "blue"
            }
        },
        "skeleton": {
            "colors": [
                "white",
                "gray",
                "green"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/skeleton/{variant}.png"
                }
            ],
            "variants": {
                "white": "beige",
                "gray": "gray",
                "green": "green"
            }
        },
        "slime": {
            "colors": [
                "green"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/slime/green.png"
                }
            ]
        },
        "snake": {
            "colors": [
                "green"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/snake/green.png"
                }
            ]
        },
        "spikes1": {
            "colors": [
                "white"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "spike/spikes1.png"
                }
            ]
        },
        "wasp": {
            "colors": [
                "yellow"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/wasp/yellow.png"
                }
            ]
        },
        "wolfman": {
            "colors": [
                "brown",
                "black",
                "gray",
                "white"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/wolf/{variant}.png"
                },
                {
                    "z": 100,
                    "path": "body/{sex}/wolf/head/{variant}.png"
                }
            ],
            "variants": {
                "brown": "brown",
                "black": "black",
                "gray": "gray",
                "white": "white"
            }
        },
        "zombie": {
            "colors": [
                "green"
            ],
            "layers": [
                {
                    "z": 10,
                    "path": "body/{sex}/special/zombie.png"
                }
            ]
        }
    },
    "cape": {
        "cape-solid": {
            "colors": [
                "black",
                "blue",
                "brown",
                "gray",
                "green",
                "maroon",
                "red",
                "white",
                "yellow"
            ],
            "layers": [
                {
                    "z": 85,
                    "path": "cape/solid/{sex}/{variant}.png"
                },
                {
                    "z": 5,
                    "path": "cape/solid_behind/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "brown": "brown",
                "gray": "gray",
                "green": "green",
                "maroon": "maroon",
                "red": "red",
                "white": "white",
                "yellow": "yellow"
            }
        },
        "cape-tattered": {
            "colors": [
                "black",
                "blue",
                "brown",
                "gray",
                "green",
                "maroon",
                "red",
                "white",
                "yellow"
            ],
            "layers": [
                {
                    "z": 85,
                    "path": "cape/tattered/{sex}/{variant}.png"
                },
                {
                    "z": 5,
                    "path": "cape/tattered_behind/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "brown": "brown",
                "gray": "gray",
                "green": "green",
                "maroon": "maroon",
                "red": "red",
                "white": "white",
                "yellow": "yellow"
            }
        },
        "cape-trimmed": {
            "colors": [
                "white"
            ],
            "layers": [
                {
                    "z": 85,
                    "path": "cape/trimmed/{sex}/white_blue.png"
                },
                {
                    "z": 5,
                    "path": "cape/trimmed_behind/white_blue.png"
                }
            ]
        }
    },
    "eyes": {
        "cyclops": {
            "colors": [
                "red"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "eyes/{sex}/cyclope.png"
                }
            ]
        },
        "normal": {
            "colors": [
                "blue",
                "brown",
                "gray",
                "green",
                "orange",
                "purple",
                "red",
                "yellow"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "eyes/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "blue": "blue",
                "brown": "brown",
                "gray": "gray",
                "green": "green",
                "orange": "orange",
                "purple": "purple",
                "red": "red",
                "yellow": "yellow"
            }
        }
    },
    "hair": {
        "afro": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/afro/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "balding": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/balding/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bangs": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bangs/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bangs_bun": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bangs_bun/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bangslong": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bangslong/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bangslong2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bangslong2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bangsshort": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bangsshort/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bedhead": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bedhead/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bob": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bob/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bob_side_part": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bob_side_part/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "braid": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/braid/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "braid2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/braid2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "bunches": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/bunches/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "buzzcut": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/buzzcut/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "cornrows": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/cornrows/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "cowlick": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/cowlick/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "cowlick_tall": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/cowlick_tall/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "curly_long": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/curly_long/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "curly_short": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/curly_short/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "curtains": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/curtains/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "curtains_long": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/curtains_long/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "dreadlocks_long": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/dreadlocks_long/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "dreadlocks_short": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/dreadlocks_short/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "flat_top_fade": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/flat_top_fade/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "flat_top_straight": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/flat_top_straight/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "half_up": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/half_up/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "halfmessy": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/halfmessy/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "high_and_tight": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/high_and_tight/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "high_ponytail": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/high_ponytail/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "idol": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/idol/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "jewfro": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/jewfro/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "lob": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/lob/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "long": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/long/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "long_band": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/long_band/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "long_center_part": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/long_center_part/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "long_messy": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/long_messy/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "long_messy2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/long_messy2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "long_tied": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/long_tied/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "longhawk": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/longhawk/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "longknot": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/longknot/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "loose": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/loose/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "messy1": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/messy1/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "messy2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/messy2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "messy3": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/messy3/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "mop": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/mop/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "natural": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/natural/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "page": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/page/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "page2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/page2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "part2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/part2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "parted": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/parted/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "pixie": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/pixie/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "plain": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/plain/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "ponytail": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/ponytail/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "ponytail2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/ponytail2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "princess": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/princess/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "sara": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/sara/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "shorthawk": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/shorthawk/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "shortknot": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/shortknot/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "shoulderl": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/shoulderl/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "shoulderr": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/shoulderr/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "single": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/single/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "spiked": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/spiked/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "spiked2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/spiked2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "spiked_beehive": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/spiked_beehive/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "spiked_liberty": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/spiked_liberty/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "spiked_liberty2": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/spiked_liberty2/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "spiked_porcupine": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/spiked_porcupine/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "swoop": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/swoop/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "twists_fade": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/twists_fade/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "twists_straight": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/twists_straight/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "unkempt": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/unkempt/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "wavy": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/wavy/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        },
        "xlong": {
            "colors": [
                "white",
                "blonde",
                "gold",
                "green",
                "blue",
                "red",
                "orange",
                "purple",
                "brown",
                "lightbrown",
                "gray",
                "black"
            ],
            "layers": [
                {
                    "z": 120,
                    "path": "hair/xlong/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "white",
                "blonde": "blonde",
                "gold": "gold",
                "green": "green",
                "blue": "blue",
                "red": "red",
                "orange": "orange",
                "purple": "purple",
                "brown": "dark_brown",
                "lightbrown": "light_brown",
                "gray": "gray",
                "black": "black"
            }
        }
    },
    "nose": {
        "big": {
            "colors": [
                "white",
                "tan",
                "gray"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "head/nose/big/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "light",
                "tan": "tanned",
                "gray": "darkelf"
            }
        },
        "button": {
            "colors": [
                "white",
                "tan",
                "gray"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "head/nose/button/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "light",
                "tan": "tanned",
                "gray": "darkelf"
            }
        },
        "straight": {
            "colors": [
                "white",
                "tan",
                "gray"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "head/nose/straight/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "white": "light",
                "tan": "tanned",
                "gray": "darkelf"
            }
        }
    },
    "pants": {
        "legion": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "legs/skirts/{sex}/legion.png"
                }
            ]
        },
        "pantaloons": {
            "colors": [
                "black",
                "blue",
                "brown",
                "gray",
                "green",
                "maroon",
                "orange",
                "purple",
                "red",
                "tan",
                "white",
                "yellow"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "legs/pantaloons/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "brown": "brown",
                "gray": "gray",
                "green": "green",
                "maroon": "maroon",
                "orange": "orange",
                "purple": "purple",
                "red": "red",
                "tan": "tan",
                "white": "white",
                "yellow": "yellow"
            }
        },
        "pants": {
            "colors": [
                "black",
                "blue",
                "brown",
                "gray",
                "green",
                "maroon",
                "orange",
                "purple",
                "red",
                "tan",
                "white",
                "yellow"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "legs/pants/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "brown": "brown",
                "gray": "gray",
                "green": "green",
                "maroon": "maroon",
                "orange": "orange",
                "purple": "purple",
                "red": "red",
                "tan": "tan",
                "white": "white",
                "yellow": "yellow"
            }
        },
        "pants-armor": {
            "colors": [
                "gray",
                "metal",
                "yellow",
                "gold",
                "tan",
                "orange"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "legs/armour/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "gray": "7",
                "metal": "8",
                "yellow": "9",
                "gold": "8",
                "tan": "10",
                "orange": "11"
            }
        },
        "skirts": {
            "colors": [
                "brown",
                "black",
                "white"
            ],
            "layers": [
                {
                    "z": 20,
                    "path": "legs/skirts/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "brown": "brown",
                "black": "black",
                "white": "white"
            }
        }
    },
    "shield": {
        "shield-crusader": {
            "colors": [
                "white"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/crusader.png"
                }
            ]
        },
        "shield-kite": {
            "colors": [
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/kite_{variant}.png"
                }
            ],
            "variants": {
                "gray": "gray",
                "orange": "orange"
            }
        },
        "shield-kite_blue": {
            "colors": [
                "blue",
                "gray"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/kite_blue_{variant}.png"
                }
            ],
            "variants": {
                "blue": "blue",
                "gray": "gray"
            }
        },
        "shield-kite_gray": {
            "colors": [
                "blue",
                "gray",
                "green",
                "orange"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/kite_gray_{variant}.png"
                }
            ],
            "variants": {
                "blue": "blue",
                "gray": "gray",
                "green": "green",
                "orange": "orange"
            }
        },
        "shield-kite_green": {
            "colors": [
                "gray"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/kite_green_gray.png"
                }
            ]
        },
        "shield-kite_red": {
            "colors": [
                "gray"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/kite_red_gray.png"
                }
            ]
        },
        "shield-round": {
            "colors": [
                "black",
                "brown",
                "gold",
                "green",
                "silver",
                "yellow"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/round_{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "brown": "brown",
                "gold": "gold",
                "green": "green",
                "silver": "silver",
                "yellow": "yellow"
            }
        },
        "shield-spartan": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 141,
                    "path": "shield/{sex}/spartan.png"
                }
            ]
        }
    },
    "shirt": {
        "blouse": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/blouse/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "blouse_longsleeve": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/blouse_longsleeve/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "corset": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "brown",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/corset/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "brown": "leather",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "longsleeve": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/longsleeve/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow"
            }
        },
        "longsleeve_laced": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/longsleeve_laced/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "scoop_shirt": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/scoop_shirt/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "sleeveless": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "brown",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/sleeveless/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "brown": "brown",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "sleeveless_laced": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "brown",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/sleeveless_laced/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "brown": "brown",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "sleeveless_striped": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "brown",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/sleeveless_striped/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "brown": "brown",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "tanktop": {
            "colors": [
                "black",
                "blue",
                "green",
                "maroon",
                "purple",
                "red",
                "teal",
                "white",
                "yellow",
                "tan",
                "gray",
                "orange"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/tanktop/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "green": "green",
                "maroon": "maroon",
                "purple": "purple",
                "red": "red",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow",
                "tan": "tan",
                "gray": "gray",
                "orange": "orange"
            }
        },
        "tunic": {
            "colors": [
                "brown",
                "maroon",
                "teal",
                "white"
            ],
            "layers": [
                {
                    "z": 35,
                    "path": "torso/clothes/tunic/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "brown": "brown",
                "maroon": "maroon",
                "teal": "teal",
                "white": "white"
            }
        }
    },
    "shoes": {
        "boots": {
            "colors": [
                "black",
                "blue",
                "brown",
                "gray",
                "green",
                "maroon",
                "orange",
                "purple",
                "red",
                "tan",
                "teal",
                "white",
                "yellow"
            ],
            "layers": [
                {
                    "z": 25,
                    "path": "feet/boots/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "blue": "blue",
                "brown": "brown",
                "gray": "gray",
                "green": "green",
                "maroon": "maroon",
                "orange": "orange",
                "purple": "purple",
                "red": "red",
                "tan": "tan",
                "teal": "teal",
                "white": "white",
                "yellow": "yellow"
            }
        },
        "sandals": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 15,
                    "path": "feet/sandals/{sex}/brown.png"
                }
            ]
        },
        "shoes": {
            "colors": [
                "black",
                "brown",
                "maroon"
            ],
            "layers": [
                {
                    "z": 15,
                    "path": "feet/shoes/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "brown": "brown",
                "maroon": "maroon"
            }
        },
        "shoes-armor": {
            "colors": [
                "gray",
                "metal",
                "yellow",
                "gold",
                "tan",
                "orange"
            ],
            "layers": [
                {
                    "z": 15,
                    "path": "feet/armor/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "gray": "4",
                "metal": "5",
                "yellow": "6",
                "gold": "7",
                "tan": "8",
                "orange": "9"
            }
        },
        "slippers": {
            "colors": [
                "black",
                "brown",
                "gray"
            ],
            "layers": [
                {
                    "z": 15,
                    "path": "feet/slippers/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "black": "black",
                "brown": "brown",
                "gray": "gray"
            }
        }
    },
    "weapon": {
        "axe": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/slash/{sex}/axe_2.png"
                }
            ]
        },
        "bow": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/bow/normal.png"
                }
            ]
        },
        "crossbow": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/thrust/{sex}/crossbow.png"
                }
            ]
        },
        "dagger": {
            "colors": [
                "metal",
                "brown"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/slash/{sex}/{variant}.png"
                }
            ],
            "variants": {
                "metal": "dagger",
                "brown": "dagger_brown"
            }
        },
        "flail": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/slash_oversize/{sex}/universal/flail.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize/{sex}/flail.png",
                    "type": "oversize"
                }
            ]
        },
        "halberd": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/slash_oversize/{sex}/universal/halberd.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize/{sex}/halberd.png",
                    "type": "oversize"
                }
            ]
        },
        "longsword": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 9,
                    "path": "weapon/slash_oversize_layered/all/universal/behind/longsword.png"
                },
                {
                    "z": 140,
                    "path": "weapon/slash_oversize_layered/all/universal/longsword.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize_layered/all/longsword.png",
                    "type": "oversize"
                }
            ]
        },
        "mace": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 9,
                    "path": "weapon/slash_oversize_layered/all/universal/behind/mace.png"
                },
                {
                    "z": 140,
                    "path": "weapon/slash_oversize_layered/all/universal/mace.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize_layered/all/mace.png",
                    "type": "oversize"
                }
            ]
        },
        "none": {
            "colors": [],
            "layers": []
        },
        "rapier": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 9,
                    "path": "weapon/slash_oversize_layered/all/universal/behind/rapier.png"
                },
                {
                    "z": 140,
                    "path": "weapon/slash_oversize_layered/all/universal/rapier.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize_layered/all/rapier.png",
                    "type": "oversize"
                }
            ]
        },
        "saber": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 9,
                    "path": "weapon/slash_oversize_layered/all/universal/behind/saber.png"
                },
                {
                    "z": 140,
                    "path": "weapon/slash_oversize_layered/all/universal/saber.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize_layered/all/saber.png",
                    "type": "oversize"
                }
            ]
        },
        "scythe": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 9,
                    "path": "weapon/slash_oversize_layered/all/universal/behind/scythe.png"
                },
                {
                    "z": 140,
                    "path": "weapon/slash_oversize_layered/all/universal/scythe.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize_layered/all/scythe.png",
                    "type": "oversize"
                }
            ]
        },
        "spear": {
            "colors": [
                "brown",
                "black",
                "green",
                "metal",
                "purple"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/thrust/{sex}/spear_{variant}.png"
                }
            ],
            "variants": {
                "brown": "2",
                "black": "black",
                "green": "green",
                "metal": "metal",
                "purple": "purple"
            }
        },
        "staff": {
            "colors": [
                "brown"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/thrust/{sex}/simple_staff.png"
                }
            ]
        },
        "waraxe": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/slash_oversize/{sex}/universal/waraxe.png"
                },
                {
                    "z": 150,
                    "path": "weapon/slash_oversize/{sex}/waraxe.png",
                    "type": "oversize"
                }
            ]
        },
        "warhammer": {
            "colors": [
                "metal"
            ],
            "layers": [
                {
                    "z": 140,
                    "path": "weapon/slash/{sex}/warhammer.png"
                }
            ]
        },
        "web": {
            "colors": [
                "white"
            ],
            "layers": []
        }
    }
};


/**
 * Which colours and sexes each sprite slot offers, in one place.
 *
 * The enums already answer this, but each answer lives under a different name -- `HairColors`
 * keyed by hair type, `RaceColors` keyed by race, `SexShirts` keyed the other way round -- so
 * every caller that wants "the colours of this component" has been rewriting the same switch.
 * There are now three: the descriptor matrix, the registry that replaces the forge's branching,
 * and the derivation tool that builds one from the other. They must agree exactly or the
 * registry's colour fallback stops matching the forge's, so they share this.
 *
 * Deliberately a lookup over the existing enums rather than a copy of them: the enums stay the
 * source of what exists, and adding a colour there still reaches everything.
 */ 
const $6448276859e40569$export$1355fc6f1df3193a = [
    "body",
    "hair",
    "nose",
    "eyes",
    "weapon",
    "pants",
    "shirt",
    "armor",
    "shoes",
    "shield",
    "cape",
    "bauldron"
];
const $6448276859e40569$var$COLOR_TABLES = {
    body: (0, $bf6244e5cc9aa116$export$af1b56af8a451d06),
    hair: (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408),
    nose: (0, $bf6244e5cc9aa116$export$f5fdec393d34621),
    eyes: (0, $bf6244e5cc9aa116$export$ffaabf2abfa69206),
    weapon: (0, $bf6244e5cc9aa116$export$489aea052d2c5de8),
    pants: (0, $bf6244e5cc9aa116$export$7ef85edc405cda8b),
    shirt: (0, $bf6244e5cc9aa116$export$b4dd93b72d5ba14d),
    armor: (0, $bf6244e5cc9aa116$export$174697130974693e),
    shoes: (0, $bf6244e5cc9aa116$export$d9113a8608ba3a3c),
    shield: (0, $bf6244e5cc9aa116$export$52cb84e67504327c),
    cape: (0, $bf6244e5cc9aa116$export$6fae0646c1b2ea33),
    bauldron: (0, $bf6244e5cc9aa116$export$2e16043d24eb3a5c)
};
const $6448276859e40569$export$aee49538df5fa24d = (slot, component)=>$6448276859e40569$var$COLOR_TABLES[slot]?.[component] || [];
const $6448276859e40569$export$ab23858d9d410aae = (slot, component, color)=>{
    const colors = $6448276859e40569$export$aee49538df5fa24d(slot, component);
    if (colors.length < 1) return undefined;
    return colors.includes(color) ? color : colors[0];
};
const $6448276859e40569$var$SEX_TABLES = {
    hair: (0, $bf6244e5cc9aa116$export$46ee3469290462e6),
    pants: (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3),
    shirt: (0, $bf6244e5cc9aa116$export$6e1561754c81021d),
    shoes: (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c),
    cape: (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)
};
const $6448276859e40569$export$53e35886565bd318 = (slot, component)=>{
    if (slot === "body") return (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[component] || [];
    const table = $6448276859e40569$var$SEX_TABLES[slot];
    if (!table) return [
        ...(0, $bf6244e5cc9aa116$export$32cdec3d782e201f)
    ];
    return (0, $bf6244e5cc9aa116$export$32cdec3d782e201f).filter((sex)=>table[sex].includes(component));
};


const $71594ae8b880a354$export$b2ae80db0884a5f7 = {
    horse: {
        w: 128,
        h: 128
    },
    snake: {
        w: 64,
        h: 64
    },
    slime: {
        w: 64,
        h: 64
    },
    wasp: {
        w: 32,
        h: 32
    },
    spikes1: {
        w: 32,
        h: 32
    },
    redspider: {
        w: 64,
        h: 64
    },
    deer: {
        w: 128,
        h: 128
    },
    rabbit: {
        w: 72,
        h: 72
    },
    chicken: {
        w: 32,
        h: 32
    }
};
/**
 * Every descriptor now comes from the registry. See `docs/sprite-lab.md` for the whole pipeline.
 *
 * What used to be here was 600 lines of `if (component === ...)` whose real content was a set of
 * path templates and, per component, a translation from the game's `Color` names to the ones the
 * art files actually use (`brown` -> `dark_brown`, `white` -> `beige`, `gold` -> `8`). That table
 * is data, and it now lives in `sprite_registry.json` with a generated module beside it.
 *
 * The registry was DERIVED from this file's own answers over every descriptor the enums can
 * produce and verified by re-expanding all of them, so the swap is a capture rather than a
 * rewrite. `lpc_forge.test.ts` holds the snapshot of all 2,303 cases that proves it, and
 * `yarn derive:lpc --check` proves the registry still matches its source.
 *
 * The one rule that stayed in code is the colour fallback -- a component asked for a colour it
 * has no art for renders its first one -- because it is identical across every slot and depends
 * on the enum's declaration order. See `slot_colors.ts`.
 *
 * Behaviour note: an unknown component used to throw here for some slots (reading `colors[0]` off
 * an undefined colour list) and return `[]` for others. It is `[]` everywhere now. Saved
 * characters outlive the enums, and a removed hair type should cost that layer, not the character.
 */ const $71594ae8b880a354$var$fromRegistry = (slot, component, color, sex)=>{
    const entry = (0, $c5288b67ae1c4c33$export$5bfd8bfbf03dc8d7)[slot]?.[component];
    if (!entry) return [];
    return (0, $77edb5cf00d051a9$export$ffcd8ef8c2ace575)(entry, {
        color: (0, $6448276859e40569$export$ab23858d9d410aae)(slot, component, color),
        requestedColor: color,
        sex: sex
    });
};
/** Slots whose descriptor is `{component, color}` plus a sex -- everything except the body. */ const $71594ae8b880a354$var$forgeComponent = (slot)=>(descriptor, sex)=>descriptor ? $71594ae8b880a354$var$fromRegistry(slot, descriptor.component, descriptor.color, sex) : [];
const $71594ae8b880a354$export$f97c59eb28641f1e = (body)=>body ? $71594ae8b880a354$var$fromRegistry("body", body.race, body.color, body.sex) : [];
const $71594ae8b880a354$export$43128cd69e2d5491 = (weapon)=>{
    return [
        "longsword",
        "rapier",
        "mace",
        "scythe",
        "saber",
        "flail",
        "halberd",
        "waraxe"
    ].includes(weapon);
};
const $71594ae8b880a354$export$eb439c7a658b0b8 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("weapon")(descriptor, sex);
const $71594ae8b880a354$export$55464a27c08f23fe = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("hair")(descriptor, sex);
const $71594ae8b880a354$export$2d6e2f919ad84c9c = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("nose")(descriptor, sex);
const $71594ae8b880a354$export$d96ba5ecdac9f401 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("eyes")(descriptor, sex);
const $71594ae8b880a354$export$402b088ac9ea61f6 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("pants")(descriptor, sex);
const $71594ae8b880a354$export$3a0bfd4ad2f621c2 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("shirt")(descriptor, sex);
const $71594ae8b880a354$export$12bd863799b8972b = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("armor")(descriptor, sex);
const $71594ae8b880a354$export$cb3c55b5933062cc = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("shoes")(descriptor, sex);
const $71594ae8b880a354$export$f27f48c85cec4c5c = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("shield")(descriptor, sex);
const $71594ae8b880a354$export$86d144b8cdae5638 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("cape")(descriptor, sex);
const $71594ae8b880a354$export$8b17c24843c3a9ac = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("bauldron")(descriptor, sex);
const $71594ae8b880a354$export$68fee8ec0f096607 = (appearance)=>{
    if (appearance.race === "spikes1") return "inactive";
};
const $71594ae8b880a354$export$efde97289773c11d = ({ body: body, weapon: weapon, hair: hair, nose: nose, eyes: eyes, sex: sex, pants: pants, shirt: shirt, armor: armor, shoes: shoes, shield: shield, cape: cape, bauldron: bauldron })=>{
    const bodyDescriptors = $71594ae8b880a354$export$f97c59eb28641f1e(body);
    const weaponDescriptors = $71594ae8b880a354$export$eb439c7a658b0b8(weapon, sex || body.sex);
    const hairDescriptors = $71594ae8b880a354$export$55464a27c08f23fe(hair, sex || body.sex);
    const noseDescriptors = $71594ae8b880a354$export$2d6e2f919ad84c9c(nose, sex || body.sex);
    const eyesDescriptors = $71594ae8b880a354$export$d96ba5ecdac9f401(eyes, sex || body.sex);
    const pantsDescriptors = $71594ae8b880a354$export$402b088ac9ea61f6(pants, sex || body.sex);
    const shirtDescriptors = $71594ae8b880a354$export$3a0bfd4ad2f621c2(shirt, sex || body.sex);
    const armorDescriptors = $71594ae8b880a354$export$12bd863799b8972b(armor, sex || body.sex);
    const shoeDescriptors = $71594ae8b880a354$export$cb3c55b5933062cc(shoes, sex || body.sex);
    const shieldDescriptors = $71594ae8b880a354$export$f27f48c85cec4c5c(shield, sex || body.sex);
    const capeDescriptors = $71594ae8b880a354$export$86d144b8cdae5638(cape, sex || body.sex);
    const bauldronDescriptors = $71594ae8b880a354$export$8b17c24843c3a9ac(bauldron, sex || body.sex);
    let descriptors = {
        body: bodyDescriptors,
        weapon: weaponDescriptors,
        hair: hairDescriptors,
        pants: pantsDescriptors,
        shirt: shirtDescriptors,
        armor: armorDescriptors,
        shoes: shoeDescriptors,
        shield: shieldDescriptors,
        cape: capeDescriptors,
        bauldron: bauldronDescriptors,
        nose: noseDescriptors,
        eyes: eyesDescriptors
    };
    return descriptors;
};





var $1avo5 = parcelRequire("1avo5");




parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");





class $5dbaf3682d88a932$export$46264c47e2aa11a2 {
    static{
        // Only buttons that are currently ON SCREEN are in here: register() on show, unregister() on
        // dismiss and on HUD cleanup. So "hidden for capture" can flip them wholesale without having to
        // remember which ones were visible to begin with.
        this.buttons = new Set();
    }
    static{
        // Called once by the renderer. Lazily reads the player controller: the controller does not exist
        // yet when the renderer is built.
        this.bindSuppressAttack = (suppress)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.suppressAttack = suppress;
        };
    }
    static{
        this.register = (button)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.add(button);
        };
    }
    static{
        this.unregister = (button)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.delete(button);
        };
    }
    static{
        // Hide/show every live Next button. Wrapped around the follow-cam's overlay render pass.
        this.setHiddenForCapture = (hidden)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.forEach((button)=>{
                button.visible = !hidden;
            });
        };
    }
    static{
        this.notePressed = ()=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.suppressAttack?.();
        };
    }
    static{
        // Tests only.
        this.liveCount = ()=>$5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.size;
    }
}


// Chat speech-bubble geometry (see spokeImpl)
const $1d5c2742ca857d0e$var$BUBBLE_PAD_X = 12;
const $1d5c2742ca857d0e$var$BUBBLE_PAD_Y = 10;
const $1d5c2742ca857d0e$var$BUBBLE_RADIUS = 8;
const $1d5c2742ca857d0e$var$BUBBLE_BORDER = 2;
const $1d5c2742ca857d0e$var$BUBBLE_SHADOW_X = 3;
const $1d5c2742ca857d0e$var$BUBBLE_SHADOW_Y = 4;
const $1d5c2742ca857d0e$var$BUBBLE_FILL = 0x141821;
const $1d5c2742ca857d0e$var$BUBBLE_FILL_ALPHA = 0.9;
const $1d5c2742ca857d0e$var$BUBBLE_BORDER_COLOR = 0x707b91;
const $1d5c2742ca857d0e$var$BUBBLE_BORDER_ALPHA = 0.75;
// The "Next" button on a HELD bubble (see spoke): a line the player dismisses themselves rather
// than one that fades on a timer. It hangs off the bottom-right inside edge of the panel, on its own
// row, so it can never sit over the words however they wrap.
const $1d5c2742ca857d0e$var$NEXT_BUTTON_W = 52;
const $1d5c2742ca857d0e$var$NEXT_BUTTON_H = 19 // tall enough for the label plus the countdown bar's own row
;
const $1d5c2742ca857d0e$var$NEXT_BUTTON_CORNER = 5;
const $1d5c2742ca857d0e$var$NEXT_BUTTON_GAP = 7 // clear air between the last line of text and the button row
;
const $1d5c2742ca857d0e$var$NEXT_BUTTON_FONT = 10;
// Warm amber, matching the ember UI set (role picker / tutorial bar / command wheel).
const $1d5c2742ca857d0e$var$NEXT_RIM = 0xf2a94e;
const $1d5c2742ca857d0e$var$NEXT_TEXT = 0xfff3e0;
const $1d5c2742ca857d0e$var$NEXT_FILL_IDLE = 0x2a201a;
const $1d5c2742ca857d0e$var$NEXT_FILL_HOVER = 0x33271e;
const $1d5c2742ca857d0e$var$NEXT_RIM_IDLE = 0x6b4f38;
// A held line stops the scene behind it until it is dismissed, so the button presses ITSELF after
// this long: a player who wanders off, misses the button, or can't reach it (a bubble drawn half off
// the screen) must not be able to strand the ember tutorial for good. The countdown bar along the
// bottom of the button is the only cue, and it is deliberately quiet -- the button is still the way
// you're meant to get through a conversation, not a thing to race.
const $1d5c2742ca857d0e$var$NEXT_BUTTON_AUTO_MS = 15000;
// Redraw cadence of that bar. Coarse on purpose: the bar is ~42px wide, so a finer tick cannot move
// it a whole pixel, and a live bubble has no business churning the GPU on a budget machine.
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_TICK_MS = 250;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_H = 2;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_ROW = 4 // the bar plus its clearance from the button's bottom border
;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_INSET = $1d5c2742ca857d0e$var$NEXT_BUTTON_CORNER // keeps the bar clear of the rounded corners
;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_ALPHA = 0.45;
// Ceiling on the per-entity backlog of lines waiting behind a held bubble. A player who walks away
// mid-conversation never presses Next, and the speaker (the ember Lord, mid-intro) keeps talking;
// without a cap that queue grows for as long as the run lasts. Dropping the OLDEST line keeps the
// most recent, most relevant ones.
const $1d5c2742ca857d0e$var$MAX_QUEUED_LINES = 8;
// Compact segmented HP meter drawn beneath the name (variant B) -- replaces the old "|" pipe text.
// Colours mirror the roster HP bar (ember_roster drawHpBar) so the world and roster read the same.
const $1d5c2742ca857d0e$var$HP_BAR_W = 54;
const $1d5c2742ca857d0e$var$HP_BAR_H = 7;
const $1d5c2742ca857d0e$var$HP_SEGMENTS = 6;
const $1d5c2742ca857d0e$var$HP_SEG_GAP = 2;
const $1d5c2742ca857d0e$var$HP_CASE_PAD = 2;
const $1d5c2742ca857d0e$var$HP_COLOR_FULL = 0x6fe06f;
const $1d5c2742ca857d0e$var$HP_COLOR_WARN = 0xffd23f;
const $1d5c2742ca857d0e$var$HP_COLOR_CRIT = 0xff5c5c;
// Floating role glyph (👑 lord / 🛡️ defender / 🪓 forager) shown above an ember-camp NPC's head. It
// rests just above the head and lifts on hover to make room for the name + HP, then drops back down.
// The Y values are the tunable bits (like the HP-bar alignment was).
const $1d5c2742ca857d0e$var$GLYPH_SIZE = 15;
const $1d5c2742ca857d0e$var$GLYPH_X = 18 // centred over the NPC (tunable)
;
const $1d5c2742ca857d0e$var$GLYPH_Y = 20 // rests just above the head; the glyph fades out on hover (it does not move)
;
const $1d5c2742ca857d0e$var$GLYPH_FADE_MS = 130;
// Emoji hardcoded (not imported from gui/ember_roster) to avoid a sprites<->gui import cycle -- the
// same reason command_wheel keeps its own copy. Keep in sync with ROLE_EMOJI in ember_roster_card.ts.
//
// A "player" role draws NOTHING here, deliberately: this glyph set means JOB, and the other people
// in the camp are already marked out in the world by the ground ring every player wears (see
// window.playerRing). A badge as well would say the same thing twice, in the one place where
// vertical room above a head is scarce. Their roster card still carries the 🧑.
const $1d5c2742ca857d0e$var$ROLE_GLYPH = {
    lord: "\uD83D\uDC51",
    player: "",
    defender: "\uD83D\uDEE1\uFE0F",
    forager: "\uD83E\uDE93"
};
// Draw order of the per-entity widgets inside the HUD. These only take effect because the HUD turns
// on sortableChildren in the constructor -- without it pixi paints in addChild order, which put the
// role glyph and the sigil (added later, on demand) on top of the chat bubble.
const $1d5c2742ca857d0e$var$Z_TAG = 0;
const $1d5c2742ca857d0e$var$Z_LABEL = 10 // name + HP meter
;
const $1d5c2742ca857d0e$var$Z_SIGIL = 20;
const $1d5c2742ca857d0e$var$Z_ROLE_GLYPH = 30;
const $1d5c2742ca857d0e$var$Z_POINTER = 40;
const $1d5c2742ca857d0e$var$Z_CHAT_BUBBLE = 100000 // a bubble always reads over every other widget of its entity
;
// Every entity's HUD is a separate child of the world-overlay surface, so ordering the bubble within
// its own HUD isn't enough -- a neighbour's nameplate/glyph would still paint over it. The speaking
// entity's whole overlay item is lifted above the resting ones for as long as its bubble is up.
const $1d5c2742ca857d0e$var$Z_OVERLAY_RESTING = 0;
const $1d5c2742ca857d0e$var$Z_OVERLAY_SPEAKING = 1000;
class $1d5c2742ca857d0e$export$5ef96c383b67a5e2 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff, renderMeta, parentArea, suppressDetailHover){
        super(), this.currentName = "", this.currentHp = 0, this.currentHpMax = 0, this.currentRole = null, this.nextButtonHovered = false, this.nextArmedAt = 0, // Width the bar was last drawn at, so a tick that wouldn't move it draws nothing.
        this.nextProgressWidth = -1, // True from the moment a held line lands until its Next is pressed. While it is set, everything
        // this entity says queues rather than replacing what's on screen.
        this.holding = false, // Lines waiting their turn behind the held bubble, oldest first. They inherit the hold, so the
        // player cycles through the whole backlog with the same button, and each carries its OWN ack --
        // the speaker is told about the line the player actually just read, not the one at the front.
        this.speechQueue = [], // Whether the line currently on screen was drawn instantly (PiP focus) -- carried so a queued
        // line is shown the same way.
        this.lastInstant = false, this.makeBubbleText = ()=>{
            const bubbleText = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                // progressive is set per-utterance in spokeImpl (typewriter on the main view, instant in
                // the PiP focus), so this is just the default.
                progressive: true,
                // The styled panel drawn in spokeImpl is the bubble background now; the old inner
                // text-hugging backdrop just muddied it with a second dark rect, so it's disabled.
                backdrop: false
            });
            bubbleText.x = $1d5c2742ca857d0e$var$BUBBLE_PAD_X;
            bubbleText.y = $1d5c2742ca857d0e$var$BUBBLE_PAD_Y;
            this.bubbleText = bubbleText;
            return bubbleText;
        }, // Show/replace the floating role glyph above the head (or remove it when the entity has no role).
        this.updateRole = (role)=>{
            if (this.currentRole === role) return;
            this.currentRole = role;
            if (this.glyphAnimInterval) {
                clearInterval(this.glyphAnimInterval);
                this.glyphAnimInterval = undefined;
            }
            if (this.roleGlyph) {
                this.removeChild(this.roleGlyph);
                this.roleGlyph.destroy({
                    texture: true,
                    baseTexture: true
                });
                this.roleGlyph = undefined;
            }
            // An empty glyph counts as no glyph: that is how a role opts out of being badged in the
            // world while still having a card on the strip (see ROLE_GLYPH).
            if (role && $1d5c2742ca857d0e$var$ROLE_GLYPH[role]) {
                // No .color() -> tint stays the no-op white so the emoji keeps its own colours.
                const glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($1d5c2742ca857d0e$var$GLYPH_SIZE).render($1d5c2742ca857d0e$var$ROLE_GLYPH[role]);
                glyph.anchor.set(0.5);
                glyph.roundPixels = true;
                glyph.x = $1d5c2742ca857d0e$var$GLYPH_X;
                glyph.y = $1d5c2742ca857d0e$var$GLYPH_Y;
                // Hidden while the label is showing (hovered / always-on), else visible above the head.
                const hidden = this.idText.visible || this.alwaysShowLabel;
                glyph.alpha = hidden ? 0 : 1;
                glyph.visible = !hidden;
                glyph.zIndex = $1d5c2742ca857d0e$var$Z_ROLE_GLYPH;
                this.addChild(glyph);
                this.roleGlyph = glyph;
            }
        }, // Fade the glyph in/out -- it hides on hover so the name/HP take its place, and fades back when
        // the pointer leaves. Runs a short self-clearing interval only while fading, so there's no
        // per-frame timer sitting idle.
        this.fadeGlyphTo = (targetAlpha)=>{
            const glyph = this.roleGlyph;
            if (!glyph) return;
            if (this.glyphAnimInterval) {
                clearInterval(this.glyphAnimInterval);
                this.glyphAnimInterval = undefined;
            }
            if (targetAlpha > 0) glyph.visible = true // fade-in from a hidden glyph must start visible
            ;
            const startAlpha = glyph.alpha;
            const delta = targetAlpha - startAlpha;
            if (Math.abs(delta) < 0.02) {
                glyph.alpha = targetAlpha;
                glyph.visible = targetAlpha > 0;
                return;
            }
            const stepMs = 16;
            let elapsed = 0;
            this.glyphAnimInterval = setInterval(()=>{
                elapsed += stepMs;
                const t = Math.min(1, elapsed / $1d5c2742ca857d0e$var$GLYPH_FADE_MS);
                glyph.alpha = startAlpha + delta * t;
                if (t >= 1) {
                    glyph.alpha = targetAlpha;
                    glyph.visible = targetAlpha > 0;
                    clearInterval(this.glyphAnimInterval);
                    this.glyphAnimInterval = undefined;
                }
            }, stepMs);
        }, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            if (this.tag) this.tag.tint = color;
        }, this.updateLevel = (level)=>{
            if (this.currentLevel === level) return;
            this.currentLevel = level;
            this.calcLabel();
        }, this.updateName = (name)=>{
            if (name !== this.currentName) {
                this.currentName = name;
                this.calcLabel();
            }
        }, this.update = (hp, hpMax)=>{
            if (this.currentHp !== hp) {
                this.currentHp = hp;
                this.calcLabel();
            }
            if (this.currentHpMax !== hpMax) {
                this.currentHpMax = hpMax;
                this.calcLabel();
            }
        }, this.calcLabel = ()=>{
            let name = this.currentName || "";
            const max = 15;
            if (name.length > max) name = name.substring(0, max - 3) + "...";
            const level = !!name && this.currentLevel > 0 ? `Lv ${this.currentLevel}` : "";
            this.idText.y = 0;
            this.idText.text = (name + "  " + level).trim();
            // Left-align the HP meter to the name's left edge, just below it.
            this.hpBar.x = this.idText.x;
            this.hpBar.y = this.idText.y + this.idText.height + 2;
            this.drawHpBar();
        }, this.drawHpBar = ()=>{
            const g = this.hpBar;
            g.clear();
            if (this.currentHpMax < 1) return;
            const ratio = Math.max(0, Math.min(1, this.currentHp / this.currentHpMax));
            const color = ratio < 0.4 ? $1d5c2742ca857d0e$var$HP_COLOR_CRIT : ratio < 0.7 ? $1d5c2742ca857d0e$var$HP_COLOR_WARN : $1d5c2742ca857d0e$var$HP_COLOR_FULL;
            const innerW = $1d5c2742ca857d0e$var$HP_BAR_W - $1d5c2742ca857d0e$var$HP_CASE_PAD * 2;
            const segW = (innerW - $1d5c2742ca857d0e$var$HP_SEG_GAP * ($1d5c2742ca857d0e$var$HP_SEGMENTS - 1)) / $1d5c2742ca857d0e$var$HP_SEGMENTS;
            const segH = $1d5c2742ca857d0e$var$HP_BAR_H - $1d5c2742ca857d0e$var$HP_CASE_PAD * 2;
            // Keep at least one segment lit while alive so a near-dead entity never reads as empty.
            const lit = this.currentHp > 0 ? Math.max(1, Math.round(ratio * $1d5c2742ca857d0e$var$HP_SEGMENTS)) : 0;
            // Dark casing
            g.beginFill(0x000000, 0.72);
            g.drawRoundedRect(0, 0, $1d5c2742ca857d0e$var$HP_BAR_W, $1d5c2742ca857d0e$var$HP_BAR_H, 2);
            g.endFill();
            // Notched segments
            for(let i = 0; i < $1d5c2742ca857d0e$var$HP_SEGMENTS; i++){
                const on = i < lit;
                g.beginFill(on ? color : 0xffffff, on ? 1 : 0.1);
                g.drawRoundedRect($1d5c2742ca857d0e$var$HP_CASE_PAD + i * (segW + $1d5c2742ca857d0e$var$HP_SEG_GAP), $1d5c2742ca857d0e$var$HP_CASE_PAD, segW, segH, 1);
                g.endFill();
            }
        }, // Raise/lower this entity's world-overlay item so a live bubble clears the HUDs of neighbouring
        // entities (their nameplates and role glyphs are siblings of this HUD, not children of it).
        this.liftOverlay = (speaking)=>{
            const overlayItem = this.parent;
            if (!overlayItem) return;
            overlayItem.zIndex = speaking ? $1d5c2742ca857d0e$var$Z_OVERLAY_SPEAKING : $1d5c2742ca857d0e$var$Z_OVERLAY_RESTING;
        }, // A line this entity just said. See SpeechOptions for what the flags mean.
        //
        // A HELD line's bubble waits for a "Next" press instead of fading on a timer sized to the word
        // count -- players were losing the ember Lord's intro to that timer. The press also calls the
        // line's `onDismissed`, which is how the SPEAKER gets to pace itself off the player's reading
        // speed rather than its own clock. If nobody presses, the button presses itself after
        // NEXT_BUTTON_AUTO_MS, so handing the pacing to the player can never stall a scene outright.
        //
        // Anything this entity says while a held line is up QUEUES behind it and is shown, in order, as
        // the player works through the backlog with the same button, so no line can be shouldered off
        // the screen before it has been read. A speaker that waits for the ack keeps that queue empty by
        // construction; it is the safety net for one that doesn't (and for a line from somewhere else
        // entirely, mid-conversation). Only this entity's lines queue -- every speaker has its own HUD.
        this.spoke = (message, options)=>{
            const instant = !!options?.instant;
            const hold = !!options?.hold;
            const onDismissed = options?.onDismissed;
            if (this.holding) {
                // Don't stack a line that's already on screen or already waiting -- a nudge the script
                // re-asks on a timer ("The wood. Onto the fire.") would otherwise become a stack of
                // identical bubbles for the player to click through.
                const lastQueued = this.speechQueue[this.speechQueue.length - 1];
                if (message === lastQueued?.message || !this.speechQueue.length && message === this.currentHeldMessage) return;
                this.speechQueue.push({
                    message: message,
                    onDismissed: onDismissed
                });
                while(this.speechQueue.length > $1d5c2742ca857d0e$var$MAX_QUEUED_LINES)this.speechQueue.shift();
                // The button carries the backlog count, so the player can see there's more behind it.
                this.drawNextButton();
                return;
            }
            this.showLine(message, instant, hold, onDismissed);
        }, // Put one line on screen, replacing whatever is there. The queue is handled by spoke(); by the
        // time we get here this line is the one to show.
        this.showLine = (message, instant, hold, onDismissed)=>{
            if (this.speaking) {
                this.bubbleText.wipe();
                this.bubbleText.parent.removeChild(this.bubbleText);
                this.bubbleText = this.makeBubbleText();
                this.chatBubble.addChild(this.bubbleText);
            }
            this.speaking = true;
            this.holding = hold;
            this.lastInstant = instant;
            this.currentHeldMessage = hold ? message : undefined;
            this.heldDismissedCallback = hold ? onDismissed : undefined;
            this.hideNextButton();
            this.spokeImpl(message, instant, hold, ()=>{
                this.speaking = false;
            });
        }, // How many of this entity's lines are waiting behind the held one. Exposed for tests and for the
        // button's own label.
        this.queuedSpeechCount = ()=>this.speechQueue.length, // Take a held bubble down WITHOUT the player pressing "Next", because the conversation it
        // belonged to has been called off -- the ember tutorial's Skip. The backlog goes with it (those
        // lines are the rest of a scene nobody is playing now), and without this the sign-off that
        // follows a skip would queue behind the very button the player just declined, inherit its hold,
        // and sit there unread.
        //
        // The speaker is deliberately NOT acked: nothing here was read, and a script pacing itself off
        // the ack falls back to its own timeout, exactly as it does for a bubble that was never drawn.
        this.releaseHeldSpeech = ()=>{
            if (!this.holding && !this.speechQueue.length) return;
            this.speechQueue = [];
            this.holding = false;
            this.currentHeldMessage = undefined;
            this.heldDismissedCallback = undefined;
            this.hideNextButton();
            this.closeBubble();
        }, // "Next" pressed -- by the player, or by the button's own countdown running out. Tells the
        // speaker it may go on, then shows the next line in the backlog, or closes the bubble when there
        // is none.
        this.advanceHeldSpeech = ()=>{
            if (!this.holding) return;
            this.holding = false;
            this.currentHeldMessage = undefined;
            this.hideNextButton();
            // Ack the line the player just read BEFORE showing the next one: a speaker waiting on this
            // is holding its own tongue until it arrives.
            const dismissed = this.heldDismissedCallback;
            this.heldDismissedCallback = undefined;
            dismissed?.();
            const next = this.speechQueue.shift();
            if (next) {
                // Queued lines inherit the hold: the player has taken over the pacing of this
                // conversation, so every line of it waits for them.
                this.showLine(next.message, this.lastInstant, true, next.onDismissed);
                return;
            }
            this.closeBubble();
        }, this.spokeImpl = (message, instant, hold, done)=>{
            if (this.chatBubbleTimeout) {
                clearTimeout(this.chatBubbleTimeout);
                this.chatBubbleTimeout = undefined;
            }
            if (this.chatBubbleFadeInterval) {
                clearInterval(this.chatBubbleFadeInterval);
                this.chatBubbleFadeInterval = undefined;
            }
            this.hpBar.visible = false;
            this.idText.visible = false;
            // A chat bubble takes over the label area; the glyph returns to its resting visible state.
            this.fadeGlyphTo(1);
            const wordCount = message.split(" ").length;
            const delayMs = Math.max(3000, wordCount * 60 / 200 * 1250);
            const sentences = (0, $a80d0b17b615d6f7$export$edde49207b897324)(message, 22);
            // Size the bubble to the ACTUAL rendered text rather than a per-char estimate -- the old
            // estimate under-sized the panel, so text crowded the right/top edges. Measure the wrapped
            // lines with the real bubble font and wrap the panel around them with uniform padding.
            const probe = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("BubbleChatFont").render();
            const metrics = (0, $9Pi8W.TextMetrics).measureText(sentences.join("\n"), probe.style);
            probe.destroy({
                texture: true,
                baseTexture: true
            });
            // A held line needs a row at the bottom for its Next button -- grow the panel around it the
            // same way the text grows it, so the button is always BELOW the words and never over them,
            // however they wrapped. (Same lesson as the tutorial bar: buttons beside server-authored
            // copy only fits until the copy gets a few words longer.)
            const textH = Math.ceil(metrics.height);
            const buttonRowH = hold ? $1d5c2742ca857d0e$var$NEXT_BUTTON_GAP + $1d5c2742ca857d0e$var$NEXT_BUTTON_H : 0;
            const minW = hold ? $1d5c2742ca857d0e$var$NEXT_BUTTON_W + $1d5c2742ca857d0e$var$BUBBLE_PAD_X * 2 : 46;
            const bubbleW = Math.max(minW, Math.ceil(metrics.width) + $1d5c2742ca857d0e$var$BUBBLE_PAD_X * 2);
            const bubbleH = textH + buttonRowH + $1d5c2742ca857d0e$var$BUBBLE_PAD_Y * 2;
            this.bubbleText.x = $1d5c2742ca857d0e$var$BUBBLE_PAD_X;
            this.bubbleText.y = $1d5c2742ca857d0e$var$BUBBLE_PAD_Y;
            // Trace the whole bubble outline -- rounded rect plus a tail on the bottom edge -- as one
            // continuous path. Filling and stroking a single path keeps the border seamless around the
            // tail and the fill uniform (drawing the tail as a separate shape left a seam + colour gap).
            const r = $1d5c2742ca857d0e$var$BUBBLE_RADIUS;
            const tailBaseLeftX = 14;
            const tailBaseRightX = 30;
            const tailTipX = 6;
            const tailTipY = bubbleH + 14;
            const tracePath = (ox, oy)=>{
                const g = this.chatBubble;
                g.moveTo(ox + r, oy);
                g.lineTo(ox + bubbleW - r, oy);
                g.quadraticCurveTo(ox + bubbleW, oy, ox + bubbleW, oy + r);
                g.lineTo(ox + bubbleW, oy + bubbleH - r);
                g.quadraticCurveTo(ox + bubbleW, oy + bubbleH, ox + bubbleW - r, oy + bubbleH);
                g.lineTo(ox + tailBaseRightX, oy + bubbleH);
                g.lineTo(ox + tailTipX, oy + tailTipY) // out to the tail tip, pointing down toward the entity
                ;
                g.lineTo(ox + tailBaseLeftX, oy + bubbleH);
                g.lineTo(ox + r, oy + bubbleH);
                g.quadraticCurveTo(ox, oy + bubbleH, ox, oy + bubbleH - r);
                g.lineTo(ox, oy + r);
                g.quadraticCurveTo(ox, oy, ox + r, oy);
                g.closePath();
            };
            this.chatBubble.clear();
            this.chatBubble.alpha = 1.0;
            this.chatBubble.x = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.4;
            this.chatBubble.zIndex = $1d5c2742ca857d0e$var$Z_CHAT_BUBBLE;
            this.liftOverlay(true);
            // Soft drop shadow (same silhouette, offset, no stroke) for depth against the busy world
            this.chatBubble.lineStyle(0);
            this.chatBubble.beginFill(0x000000, 0.3);
            tracePath($1d5c2742ca857d0e$var$BUBBLE_SHADOW_X, $1d5c2742ca857d0e$var$BUBBLE_SHADOW_Y);
            this.chatBubble.endFill();
            // Panel body + tail: one path, filled and bordered together for a seamless outline
            this.chatBubble.lineStyle({
                width: $1d5c2742ca857d0e$var$BUBBLE_BORDER,
                color: $1d5c2742ca857d0e$var$BUBBLE_BORDER_COLOR,
                alpha: $1d5c2742ca857d0e$var$BUBBLE_BORDER_ALPHA,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            this.chatBubble.beginFill($1d5c2742ca857d0e$var$BUBBLE_FILL, $1d5c2742ca857d0e$var$BUBBLE_FILL_ALPHA);
            tracePath(0, 0);
            this.chatBubble.endFill();
            this.chatBubble.visible = true;
            this.bubbleText.progressive = !instant;
            this.bubbleText.wipe();
            sentences.forEach((sentence)=>{
                this.bubbleText.append2(sentence, {
                    font: "BubbleChatFont"
                });
            });
            const scheduleFade = ()=>{
                this.chatBubbleTimeout = setTimeout(()=>{
                    const fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.chatBubble, {
                        releaseCallback: ()=>{
                            clearInterval(this.chatBubbleFadeInterval);
                            this.bubbleText.wipe();
                            this.chatBubble.visible = false;
                            this.chatBubble.alpha = 1.0;
                            this.liftOverlay(false);
                            done();
                        }
                    });
                    fader.update();
                }, delayMs * 0.5);
            };
            // A held line hands the dismissal to the player: arm the button once the words have all
            // arrived (no point offering "Next" over a half-typed sentence, nor starting its countdown
            // while they're still appearing) and schedule no fade at all.
            const finish = hold ? ()=>{
                this.holdDone = done;
                this.showNextButton(bubbleW, bubbleH);
            } : scheduleFade;
            if (instant) // PiP focus: the line is already fully drawn (non-progressive above), so just fade — no
            // typewriter, whose progressive-reveal objects flicker when rendered into the PiP texture.
            finish();
            else this.bubbleText.playback(finish);
        }, // Take the bubble down for good: no fade, because the player has just told us they're done with
        // it and a dismissal that lingers reads as an unresponsive button.
        this.closeBubble = ()=>{
            if (this.chatBubbleTimeout) {
                clearTimeout(this.chatBubbleTimeout);
                this.chatBubbleTimeout = undefined;
            }
            if (this.chatBubbleFadeInterval) {
                clearInterval(this.chatBubbleFadeInterval);
                this.chatBubbleFadeInterval = undefined;
            }
            this.bubbleText.cleanup();
            this.bubbleText.wipe();
            this.chatBubble.visible = false;
            this.chatBubble.alpha = 1.0;
            this.liftOverlay(false);
            const done = this.holdDone;
            this.holdDone = undefined;
            done?.();
        }, // ---------------------------------------------------------------------------------------
        // The "Next" button on a held bubble.
        // ---------------------------------------------------------------------------------------
        this.makeNextButton = ()=>{
            const button = new (0, $8t5Gy.Container)();
            button.interactive = true;
            button.cursor = "pointer";
            button.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $1d5c2742ca857d0e$var$NEXT_BUTTON_W, $1d5c2742ca857d0e$var$NEXT_BUTTON_H);
            const bg = new (0, $gwPoJ.Graphics)();
            button.addChild(bg);
            this.nextButtonBg = bg;
            // Added between the background and the label so the bar reads as part of the button's rim
            // rather than as something sitting on top of the words.
            const progress = new (0, $gwPoJ.Graphics)();
            button.addChild(progress);
            this.nextButtonProgress = progress;
            const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($1d5c2742ca857d0e$var$NEXT_TEXT).fontSize($1d5c2742ca857d0e$var$NEXT_BUTTON_FONT).bold().align("center").render("");
            button.addChild(label);
            this.nextButtonLabel = label;
            button.on("pointerover", ()=>{
                this.nextButtonHovered = true;
                this.drawNextButton();
            });
            button.on("pointerout", ()=>{
                this.nextButtonHovered = false;
                this.drawNextButton();
            });
            button.on("pointerdown", (event)=>{
                event?.stopPropagation?.();
                // The world-attack click comes from a document-level mousedown that can't see this
                // widget, so ask the player controller to hold off -- same deal as an interaction icon.
                (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).notePressed();
                this.advanceHeldSpeech();
            });
            return button;
        }, this.drawNextButton = ()=>{
            const bg = this.nextButtonBg;
            const label = this.nextButtonLabel;
            if (!bg || !label) return;
            // The backlog count is the only cue that there is more waiting, so it lives on the button.
            const pending = this.speechQueue.length;
            label.text = pending > 0 ? `Next ${pending + 1}\u{203A}` : "Next \u203A";
            label.x = Math.round($1d5c2742ca857d0e$var$NEXT_BUTTON_W / 2 - label.width / 2);
            // Centred in the space ABOVE the countdown bar, not in the whole button.
            label.y = Math.round(($1d5c2742ca857d0e$var$NEXT_BUTTON_H - $1d5c2742ca857d0e$var$NEXT_PROGRESS_ROW) / 2 - label.height / 2);
            bg.clear();
            if (this.nextButtonHovered) {
                bg.beginFill($1d5c2742ca857d0e$var$NEXT_RIM, 0.16);
                bg.drawRoundedRect(-3, -3, $1d5c2742ca857d0e$var$NEXT_BUTTON_W + 6, $1d5c2742ca857d0e$var$NEXT_BUTTON_H + 6, $1d5c2742ca857d0e$var$NEXT_BUTTON_CORNER + 3);
                bg.endFill();
                bg.lineStyle(1.5, $1d5c2742ca857d0e$var$NEXT_RIM, 1);
                bg.beginFill($1d5c2742ca857d0e$var$NEXT_FILL_HOVER, 0.97);
            } else {
                bg.lineStyle(1.5, $1d5c2742ca857d0e$var$NEXT_RIM_IDLE, 0.85);
                bg.beginFill($1d5c2742ca857d0e$var$NEXT_FILL_IDLE, 0.92);
            }
            bg.drawRoundedRect(0, 0, $1d5c2742ca857d0e$var$NEXT_BUTTON_W, $1d5c2742ca857d0e$var$NEXT_BUTTON_H, $1d5c2742ca857d0e$var$NEXT_BUTTON_CORNER);
            bg.endFill();
        }, this.showNextButton = (bubbleW, bubbleH)=>{
            if (!this.nextButton) this.nextButton = this.makeNextButton();
            const button = this.nextButton;
            // Bottom-right inside the panel; the tail hangs off the bottom-LEFT, so the two never meet.
            button.x = bubbleW - $1d5c2742ca857d0e$var$BUBBLE_PAD_X - $1d5c2742ca857d0e$var$NEXT_BUTTON_W;
            button.y = bubbleH - $1d5c2742ca857d0e$var$BUBBLE_PAD_Y - $1d5c2742ca857d0e$var$NEXT_BUTTON_H;
            button.visible = true;
            this.nextButtonHovered = false;
            this.drawNextButton();
            if (button.parent !== this.chatBubble) this.chatBubble.addChild(button);
            // Only a button the player can actually reach is registered -- the registry is what the
            // follow-cam hides while it composites the overlay into its texture.
            (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).register(button);
            this.armNextAutoAdvance();
        }, // Start this line's countdown. When it runs out the button takes exactly the path a press takes
        // -- same ack, same backlog cycling -- so the speaker cannot tell the two apart, and a scene
        // paced off the ack keeps moving whether or not anyone is watching it.
        this.armNextAutoAdvance = ()=>{
            this.clearNextAutoAdvance();
            this.nextArmedAt = Date.now();
            this.drawNextProgress();
            this.nextProgressInterval = setInterval(this.drawNextProgress, $1d5c2742ca857d0e$var$NEXT_PROGRESS_TICK_MS);
            this.nextAutoTimeout = setTimeout(()=>{
                this.nextAutoTimeout = undefined;
                this.advanceHeldSpeech();
            }, $1d5c2742ca857d0e$var$NEXT_BUTTON_AUTO_MS);
        }, this.clearNextAutoAdvance = ()=>{
            if (this.nextAutoTimeout) {
                clearTimeout(this.nextAutoTimeout);
                this.nextAutoTimeout = undefined;
            }
            if (this.nextProgressInterval) {
                clearInterval(this.nextProgressInterval);
                this.nextProgressInterval = undefined;
            }
            this.nextButtonProgress?.clear();
            this.nextProgressWidth = -1;
        }, // The countdown, as a thin amber bar along the bottom inside edge of the button that drains from
        // full to nothing. Time is read off the clock rather than counted in ticks so a throttled
        // background tab (or a dropped frame) leaves the bar honest about the timeout it is tracking.
        this.drawNextProgress = ()=>{
            const bar = this.nextButtonProgress;
            if (!bar) return;
            const remaining = 1 - (Date.now() - this.nextArmedAt) / $1d5c2742ca857d0e$var$NEXT_BUTTON_AUTO_MS;
            const full = $1d5c2742ca857d0e$var$NEXT_BUTTON_W - $1d5c2742ca857d0e$var$NEXT_PROGRESS_INSET * 2;
            const width = Math.max(0, Math.round(full * Math.min(1, remaining)));
            if (width === this.nextProgressWidth) return;
            this.nextProgressWidth = width;
            bar.clear();
            if (width <= 0) return;
            bar.beginFill($1d5c2742ca857d0e$var$NEXT_RIM, $1d5c2742ca857d0e$var$NEXT_PROGRESS_ALPHA);
            bar.drawRect($1d5c2742ca857d0e$var$NEXT_PROGRESS_INSET, $1d5c2742ca857d0e$var$NEXT_BUTTON_H - $1d5c2742ca857d0e$var$NEXT_PROGRESS_ROW, width, $1d5c2742ca857d0e$var$NEXT_PROGRESS_H);
            bar.endFill();
        }, this.hideNextButton = ()=>{
            this.clearNextAutoAdvance();
            const button = this.nextButton;
            if (!button) return;
            (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).unregister(button);
            button.visible = false;
            this.nextButtonHovered = false;
            button.parent?.removeChild(button);
        }, this.onMouseOver = (show)=>{
            if (!this.suppressDetailHover && !this.speaking) {
                if (!this.alwaysShowLabel) {
                    this.idText.visible = show;
                    this.hpBar.visible = show;
                    this.fadeGlyphTo(show ? 0 : 1);
                }
                if (show) this.calcLabel();
            }
        };
        this.parentArea = parentArea;
        this.currentColor = color;
        // Paint the HUD's widgets by zIndex (see the Z_* constants) rather than by addChild order.
        this.sortableChildren = true;
        this.alwaysShowLabel = renderMeta.alwaysShowLabel;
        this.idText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("small").color(0xffffff).render();
        // No backing plate (variant B): give the name a crisp black outline + soft shadow so it stays
        // legible over busy terrain.
        const nameStyle = this.idText.style;
        nameStyle.stroke = "#000000";
        nameStyle.strokeThickness = 3;
        nameStyle.lineJoin = "round";
        nameStyle.dropShadow = true;
        nameStyle.dropShadowColor = "#000000";
        nameStyle.dropShadowAlpha = 0.55;
        nameStyle.dropShadowBlur = 2;
        nameStyle.dropShadowAngle = Math.PI / 2;
        nameStyle.dropShadowDistance = 1;
        // HP as a compact segmented meter drawn below the name (replaces the old "|" pipe text).
        this.hpBar = new (0, $gwPoJ.Graphics)();
        this.suppressDetailHover = suppressDetailHover;
        const startVisible = !suppressDetailHover ? this.alwaysShowLabel : false;
        this.idText.visible = startVisible;
        this.hpBar.visible = startVisible;
        this.idText.alpha = 1;
        const tag = new (0, $gwPoJ.Graphics)();
        tag.beginFill(0xffffff);
        tag.lineStyle(1, 0xffffff);
        tag.drawCircle(-8, 8, 6);
        tag.endFill();
        tag.zIndex = $1d5c2742ca857d0e$var$Z_TAG;
        this.addChild(tag);
        tag.visible = false;
        tag.alpha = 0.7;
        this.tag = tag;
        this.idText.zIndex = $1d5c2742ca857d0e$var$Z_LABEL;
        this.hpBar.zIndex = $1d5c2742ca857d0e$var$Z_LABEL;
        this.addChild(this.idText);
        this.addChild(this.hpBar);
        this.update(3, 3);
        this.calcLabel();
        this.chatBubble = new (0, $gwPoJ.Graphics)();
        this.chatBubble.visible = true;
        this.chatBubble.x = 0;
        this.chatBubble.zIndex = $1d5c2742ca857d0e$var$Z_CHAT_BUBBLE;
        this.addChild(this.chatBubble);
        const chatBubbleHorizontalSpacer = new (0, $gwPoJ.Graphics)();
        this.chatBubble.addChild(chatBubbleHorizontalSpacer);
        const bubbleText = this.makeBubbleText();
        this.chatBubble.addChild(bubbleText);
        this.chatBubble.visible = false;
        const pointer = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            name: "icon-arrow.png",
            color: 0xffffff,
            scale: 1.0
        });
        pointer.visible = false;
        pointer.zIndex = $1d5c2742ca857d0e$var$Z_POINTER;
        this.addChild(pointer);
        this.pointerIcon = pointer;
    }
    updateSigil(sigil) {
        // remove existing sigil
        if (this.sigil) this.sigil.parent?.removeChild(this.sigil);
        if (sigil) {
            this.sigil = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: sigil,
                scale: 1.8,
                color: 0xffffff
            });
            this.sigil.x += this.sigil.width * 0.3;
            this.sigil.y = -3;
            this.sigil.zIndex = $1d5c2742ca857d0e$var$Z_SIGIL;
            this.addChild(this.sigil);
        }
    }
    addTag() {
        this.tag.visible = true;
        this.tag.tint = this.currentColor;
    }
    removeTag() {
        this.tag.visible = false;
    }
    // The entity is going away (removed, or culled and discarded). Drop the HUD's own timers and,
    // above all, take any live Next button out of the shared registry -- a button left in there
    // belongs to a HUD nobody can click any more, and the follow-cam would keep toggling it forever.
    cleanup() {
        if (this.chatBubbleTimeout) {
            clearTimeout(this.chatBubbleTimeout);
            this.chatBubbleTimeout = undefined;
        }
        if (this.chatBubbleFadeInterval) {
            clearInterval(this.chatBubbleFadeInterval);
            this.chatBubbleFadeInterval = undefined;
        }
        if (this.glyphAnimInterval) {
            clearInterval(this.glyphAnimInterval);
            this.glyphAnimInterval = undefined;
        }
        if (this.pointerIconPulseInterval) {
            clearInterval(this.pointerIconPulseInterval);
            this.pointerIconPulseInterval = undefined;
        }
        if (this.pointerIconAngleInterval) {
            clearInterval(this.pointerIconAngleInterval);
            this.pointerIconAngleInterval = undefined;
        }
        this.hideNextButton();
        this.speechQueue = [];
        this.holding = false;
        this.currentHeldMessage = undefined;
        this.holdDone = undefined;
        // Deliberately NOT fired: the HUD is being discarded, which is not the player reading
        // anything. A speaker waiting on the ack falls back to its own timeout instead.
        this.heldDismissedCallback = undefined;
    }
    updatePointerIcon(show, angle) {
        if (!show) {
            clearInterval(this.pointerIconPulseInterval);
            clearInterval(this.pointerIconAngleInterval);
            this.pointerIconPulseInterval = undefined;
            this.pointerIconAngleInterval = undefined;
            this.pointerIcon.visible = false;
            this.pointerIcon.angle = 0;
        } else if (angle !== undefined) {
            this.pointerIcon.visible = true;
            this.pointerIcon.angle = angle;
            const radius = 32;
            const x = radius * Math.sin(Math.PI * 180 / 360);
            const y = radius * Math.cos(Math.PI * 180 / 360);
            this.pointerIcon.x = x + radius - 10;
            this.pointerIcon.y = y + radius + 10;
            if (!this.pointerIconPulseInterval) {
                let scale = 1.0;
                let scaleDir = 1;
                this.pointerIconPulseInterval = setInterval(()=>{
                    scale += 0.01 * scaleDir;
                    if (scale > 1.2 || scale < 1.0) scaleDir = scaleDir * -1;
                    this.pointerIcon.scale.set(scale);
                }, 50);
            }
        }
    }
}





parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $3YyWq = parcelRequire("3YyWq");



parcelRequire("1avo5");
var $d3fD1 = parcelRequire("d3fD1");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
/**
 * The one pixi Application, held apart from the renderer that builds it.
 *
 * `PixiJsClientRenderer` owns the Application, but several low-level modules need nothing from
 * that class except `app.renderer` -- somewhere to bake a texture. Reaching for the class to get
 * it drags its entire import graph along (client_game_logic, audio, the GUI, every effect), which
 * is why `lpc_composite_generator`'s own test has to `jest.mock` the module before it can load.
 *
 * Keeping the handle here instead means the composite generator depends on a two-function module,
 * so it can be driven from anywhere that has a pixi Application -- a test, or the sprite lab --
 * without standing up the game.
 */ let $065c5647ab3ff4dc$var$rendererApp;
const $065c5647ab3ff4dc$export$6a54bfeffaafa5f7 = (app)=>{
    $065c5647ab3ff4dc$var$rendererApp = app;
};
const $065c5647ab3ff4dc$export$56359d4511c7424 = ()=>{
    if (!$065c5647ab3ff4dc$var$rendererApp) throw new Error("No pixi Application registered -- call setRendererApp() before rendering");
    return $065c5647ab3ff4dc$var$rendererApp;
};



parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");


var $5UG8I = parcelRequire("5UG8I");

// A sheet that errors (404, transient network failure) is retried on another loader up to this
// many times before we give up and unblock waiting entities so they render available layers.
const $c1d8cd49591538f1$var$MAX_LOAD_ATTEMPTS = 3;
// Base backoff between retries (multiplied by attempt count).
const $c1d8cd49591538f1$var$RETRY_DELAY_MS = 500;
class $c1d8cd49591538f1$export$8f67d857ad88efa0 {
    static{
        this.loaderNumber = 0;
    }
    static{
        // Upper bound on how long a single loader.load() batch may run before we assume it is wedged
        // (a stalled request PIXI never resolves) and hand the batch back for retry elsewhere, so one
        // hung fetch can't leave isLoading stuck true and poison this container for the session.
        this.loadTimeoutMs = 30000;
    }
    constructor(){
        this.buffer = [];
        this.inFlight = [];
        this.add = (toLoad)=>{
            this.buffer.push(toLoad);
            this.scheduleFlush();
        };
        // (Re)arm the debounce that drains the buffer into a single loader.load() call. A burst of
        // adds within the window batches into one load. No-op while a load is in flight -- the load's
        // completion handler re-drains anything that arrived meanwhile (see flush), so requests can
        // never be stranded in the buffer waiting for an incidental future add().
        this.scheduleFlush = ()=>{
            if (this.isLoading || this.loader.loading) return;
            if (this.buffer.length < 1) return;
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(this.flush, 100);
        };
        this.flush = ()=>{
            this.timer = undefined;
            // Never add to a PIXI loader that is mid-run; the completion handler will re-drain.
            if (this.isLoading || this.loader.loading || this.buffer.length < 1) return;
            const batch = this.buffer;
            this.buffer = [];
            this.inFlight = batch;
            batch.forEach((item)=>{
                const { url: url, callback: callback } = item;
                // A url that has been here before -- a retry that round-robined back onto this
                // container -- still occupies a slot in PIXI's resource table, and Loader.add THROWS
                // on a duplicate name rather than replacing it. Unguarded that throw escapes the
                // forEach, so every later item in the batch is silently never added while inFlight
                // still claims them: the batch can then only end at the watchdog, 30s later. Dropping
                // the stale entry first is what makes a retry actually retry.
                //
                // Only ever reached for a resource that already settled (PIXI refuses to add while
                // loading, and flush bails above if the loader is mid-run), so nothing in flight is
                // discarded here.
                if (this.loader.resources[url]) delete this.loader.resources[url];
                try {
                    this.loader.add(url, url, callback);
                } catch (e) {
                    // Defence in depth: a failed add must not strand the rest of the batch. Report it
                    // as a load failure so the url goes back through the normal retry path.
                    (0, $5UG8I.logger).warn({
                        tags: [
                            "assets",
                            "loading"
                        ]
                    }, "Sheet could not be queued", url, String(e));
                    callback({
                        name: url,
                        url: url,
                        error: e
                    });
                }
            });
            this.isLoading = true;
            // Guards the batch against being settled twice (watchdog firing vs. the real completion).
            let settled = false;
            const finish = ()=>{
                settled = true;
                if (this.watchdog) {
                    clearTimeout(this.watchdog);
                    this.watchdog = undefined;
                }
                this.isLoading = false;
                this.inFlight = [];
                // Items added while this batch was loading were held in the buffer; kick them off now
                // instead of waiting for the next incidental add() to happen to hit this loader idle.
                if (this.buffer.length > 0) this.scheduleFlush();
            };
            this.watchdog = setTimeout(()=>{
                if (settled) return;
                const stalled = this.inFlight;
                finish();
                this.onStall?.(stalled);
            }, $c1d8cd49591538f1$export$8f67d857ad88efa0.loadTimeoutMs);
            this.loader.load(()=>{
                if (settled) return;
                finish();
            });
        };
        this.entityId = "loader-" + ++$c1d8cd49591538f1$export$8f67d857ad88efa0.loaderNumber;
        // The LPC sheets are the bulk of what the shell has to fetch from the web, and these
        // loaders are separate instances -- setting Loader.shared.baseUrl does not reach them.
        this.loader = new (0, $kXE1p.Loader)((0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().assetBase);
    }
}
class $c1d8cd49591538f1$export$18359c08ecfb12c1 {
    constructor(){
        this.sheetLoadingState = {};
        this.loaders = new (0, $cb689cfa16c444ba$export$7230fbaff49306c8)();
        this.urlLoaderMap = new Map();
        this.loadedTextures = new Set();
        // Route a stalled in-flight request through the same failure path as a real load error, so it
        // is retried on a fresh loader instead of hanging forever behind a wedged one.
        this.handleStalled = (item)=>{
            (0, $5UG8I.logger).warn({
                tags: [
                    "assets",
                    "loading"
                ]
            }, "Sheet load stalled; retrying", item.url);
            // `name` as well as `url`: loadCallback keys off name (see the comment there), and a
            // synthetic failure has to look like a real resource or the retry is dropped on the floor.
            this.loadCallback({
                name: item.url,
                url: item.url,
                error: new Error("sheet load timeout")
            });
        };
        this.suppressTextureCacheWarnings = ()=>{
            const originalWarn = console.warn;
            console.warn = (...args)=>{
                // Suppress PIXI texture cache warnings
                if (args[0] && typeof args[0] === "string" && args[0].includes("Texture added to the cache with an id")) return;
                // Allow other warnings through
                originalWarn.apply(console, args);
            };
        };
        this.bulkLoad = (urls, completeCallback)=>{
            let descriptorCountdown = (0, $1016737a9aedcca9$export$542cb9bd603edb0f).length;
            const s = Date.now();
            urls.forEach((url)=>{
                this.load(url, (_)=>{
                    descriptorCountdown -= 1;
                    if (descriptorCountdown <= 0) {
                        (0, $5UG8I.logger).info({
                            tags: [
                                "assets",
                                "loading"
                            ]
                        }, "Bulk asset load completed", urls.length);
                        completeCallback();
                    }
                });
            });
        };
        this.getLoaderFor = (url)=>{
            return this.urlLoaderMap.get(url);
        };
        this.load = (url, callback)=>{
            const key = `${url}`;
            const loadingState = this.sheetLoadingState[key];
            // its not yet been queued for loading; setup the sheet for loading
            // add the callback
            // register loader callback
            if (!loadingState) {
                this.sheetLoadingState[key] = {
                    url: url,
                    lifeCycle: "loading",
                    callbacks: [
                        callback
                    ],
                    attempts: 1
                };
                this.dispatch(url);
                return;
            }
            // its already been loaded; callback immediately
            if (loadingState.lifeCycle === "loaded") {
                callback(url);
                return;
            }
            // a previous attempt failed and is currently idle; piggyback and re-issue the load
            if (loadingState.lifeCycle === "failed") {
                loadingState.callbacks.push(callback);
                this.retry(url);
                return;
            }
            // queue the callback
            loadingState.callbacks.push(callback);
        };
        // (Re)assign the url to the next round-robin loader and enqueue it. Round-robin advances each
        // call, so a retry almost always lands on a loader that doesn't already hold the failed
        // resource (avoiding PIXI's "resource already exists" no-op reload).
        this.dispatch = (url)=>{
            const loaderContainer = this.loaders.next();
            this.urlLoaderMap.set(url, loaderContainer.loader);
            loaderContainer.add({
                url: url,
                callback: this.loadCallback
            });
        };
        this.loadCallback = (resource)=>{
            // Key off the resource NAME, never its url. These loaders carry a baseUrl (the native
            // shell fetches art from the web rather than from the app bundle), and resource-loader
            // prefixes that onto `url` while leaving `name` exactly as registered -- the relative
            // "assets/..." path this class keys sheetLoadingState by. Looking up by `url` misses every
            // entry once a baseUrl is set, and the miss is silent: the waiting callbacks never fire,
            // so composite sprites never initialize, never bake, and every character renders as an
            // invisible 1x1 placeholder while the terrain around them looks perfectly fine.
            const url = resource.name || resource.url;
            const loadingState = this.sheetLoadingState[url];
            if (!loadingState) return;
            // Already settled (e.g. a wedged batch was retried elsewhere and succeeded, then the
            // original finally errored in): ignore the late duplicate.
            if (loadingState.lifeCycle === "loaded") return;
            // A failed fetch still fires this callback (PIXI sets resource.error); our watchdog also
            // routes stalls here with a synthetic error. Don't mark such a sheet "loaded" with no
            // textures -- retry it, or (once exhausted) unblock waiters so they render what did load.
            if (resource.error) {
                this.onLoadFailed(url, loadingState);
                return;
            }
            // Check for duplicate textures and prevent cache warnings
            this.validateTextureCache(resource);
            // fullfill the waiting callbacks
            loadingState.callbacks.forEach((callback)=>{
                callback(loadingState.url);
            });
            // clear them out, mark resource as loaded
            loadingState.callbacks = [];
            loadingState.lifeCycle = "loaded";
        };
        this.onLoadFailed = (url, loadingState)=>{
            if (loadingState.attempts < $c1d8cd49591538f1$var$MAX_LOAD_ATTEMPTS) {
                loadingState.lifeCycle = "failed";
                (0, $5UG8I.logger).warn({
                    tags: [
                        "assets",
                        "loading"
                    ]
                }, "Sheet load failed; scheduling retry", url, loadingState.attempts);
                setTimeout(()=>this.retry(url), $c1d8cd49591538f1$var$RETRY_DELAY_MS * loadingState.attempts);
                return;
            }
            // Exhausted retries. Unblock any waiting entities (fire their callbacks) so they render
            // with the layers that did load rather than staying fully blank forever, and mark the
            // sheet terminal so it never retries again.
            (0, $5UG8I.logger).error({
                tags: [
                    "assets",
                    "loading"
                ]
            }, "Sheet load failed permanently; unblocking waiters", url);
            loadingState.callbacks.forEach((callback)=>{
                callback(loadingState.url);
            });
            loadingState.callbacks = [];
            loadingState.lifeCycle = "loaded";
        };
        this.retry = (url)=>{
            const loadingState = this.sheetLoadingState[url];
            // Only retry from an idle failed state; a retry already in flight (or a success) wins.
            if (!loadingState || loadingState.lifeCycle !== "failed") return;
            loadingState.attempts += 1;
            loadingState.lifeCycle = "loading";
            this.dispatch(url);
        };
        this.validateTextureCache = (resource)=>{
            if (!resource.spritesheet || !resource.spritesheet.textures) return;
            const textures = resource.spritesheet.textures;
            Object.keys(textures).forEach((textureId)=>{
                // Mark as loaded
                this.loadedTextures.add(textureId);
            });
        };
        // Method to check if a texture is already loaded
        this.isTextureLoaded = (textureId)=>{
            return this.loadedTextures.has(textureId);
        };
        // Method to clear texture tracking (useful for cleanup)
        this.clearTextureTracking = ()=>{
            this.loadedTextures.clear();
        };
        // Method to restore original console.warn (useful for debugging)
        this.restoreConsoleWarn = ()=>{
        // This would need to store the original warn function
        // For now, we'll keep the suppression active
        };
        for(let i = 0; i < 8; i++){
            const container = new $c1d8cd49591538f1$export$8f67d857ad88efa0();
            // A batch that hangs past the watchdog is failed + retried on another loader.
            container.onStall = (items)=>items.forEach((item)=>this.handleStalled(item));
            this.loaders.push(container);
        }
    // Suppress PIXI texture cache warnings
    // this.suppressTextureCacheWarnings()
    }
}
const $c1d8cd49591538f1$export$cd02f82db8cdb05 = new $c1d8cd49591538f1$export$18359c08ecfb12c1();


const $39fb998eb7d66fde$var$INTERVAL = 20;
const $39fb998eb7d66fde$export$8130c6196a172b8a = 32;
// An oversize weapon sheet (longsword, mace, saber, rapier, scythe, flail, halberd, waraxe --
// every `slash_oversize*` sheet) carries 192x192 slash frames, so when it contributes to the
// action the composite's bounds grow to 192x192 starting at (-96, -96) instead of 64x64 at
// (-32, -32). generateTexture bakes those bounds, and the result is still drawn at anchor (0, 0),
// which would push the body to (96, 96) -- 64px right and 64px down of where walk/idle put it.
// Shifting the clone by -(96 - 32) on both axes cancels exactly that. See the geometry test in
// __tests__/lpc_composite_generator.test.ts, which measures the two bounds with real pixi and
// pins this number to them.
const $39fb998eb7d66fde$var$OVERSIZE_OFFSET = -(96 - $39fb998eb7d66fde$export$8130c6196a172b8a);
class $39fb998eb7d66fde$export$7229ffc582571c48 {
    constructor({ animation: animation, sprite: sprite }){
        // Position correction the baked frames need, measured ONCE when this loadout+action was baked
        // and carried on the cached (canonical) entry so every clone -- the first caller's and every
        // later cache hit's -- is placed identically. It lives here rather than being recomputed per
        // clone because the inputs it depends on (which sheets contribute frames to this action) are
        // only available on the bake path: a job served from cache never looks at the sheets at all,
        // so any per-clone recomputation silently yields "no offset" and the same animation lands in
        // two different places depending on who baked it first. See OVERSIZE_OFFSET.
        this.offsetX = 0;
        this.offsetY = 0;
        this.play = ()=>{
            if (this.animation) {
                this.animation.visible = true;
                this.animation.gotoAndPlay(0);
            }
            if (this.sprite) this.sprite.visible = true;
        };
        this.stop = ()=>{
            if (this.animation) {
                this.animation.visible = false;
                this.animation.stop();
            }
            if (this.sprite) this.sprite.visible = false;
        };
        this.fragmentBase = ()=>{
            if (this.animation) {
                const f = this.animation.textures[this.animation.currentFrame];
                return f;
            }
            if (this.sprite) return this.sprite.texture;
        };
        this.recolor = (color)=>{
            if (this.animation) this.animation.tint = color;
            if (this.sprite) this.sprite.tint = color;
        };
        this.sprite = sprite;
        this.animation = animation;
    }
}
class $39fb998eb7d66fde$var$SynchronousJob {
    static{
        this.textureCache = new Map();
    }
    static{
        this.animationCache = new Map();
    }
    static{
        // Number of live (on-screen) clones per cache key. Only keys at zero may be evicted; this is
        // what makes destroying baked textures safe -- they are shared by every live clone.
        this.refCounts = new Map();
    }
    static{
        // Upper bound on cached loadout+action entries. Beyond this, unreferenced entries are evicted
        // oldest-first and their baked RenderTextures destroyed (generateTexture textures are only
        // reclaimed by explicit destroy(), never by GC).
        this.maxCachedAnimations = 512;
    }
    static{
        // Build a fresh, independent display object from a cached result, reusing its baked textures.
        // Used for BOTH cache hits and the first (miss) caller, so the cached entry is never itself
        // handed to a live sprite -- only clones are, keeping the canonical safe to evict.
        this.cloneResult = (cached, source, key)=>{
            const { scale: scale, speed: speed = 0.267, color: color = 0xffffff } = source;
            let animation;
            let sprite;
            if (cached.animation) {
                animation = new (0, $d3fD1.AnimatedSprite)(cached.animation.textures);
                animation.scale.set(scale);
                animation.animationSpeed = speed;
                animation.visible = false;
                animation.tint = color;
                // Read off the cached entry, never recomputed here -- see LpcJobResult.offsetX.
                animation.x += cached.offsetX;
                animation.y += cached.offsetY;
            }
            if (cached.sprite) {
                sprite = new (0, $7Bs2Z.Sprite)(cached.sprite.texture);
                sprite.tint = color;
                sprite.scale.set(scale);
                sprite.visible = false;
            }
            const result = new $39fb998eb7d66fde$export$7229ffc582571c48({
                animation: animation,
                sprite: sprite
            });
            result.key = key;
            result.offsetX = cached.offsetX;
            result.offsetY = cached.offsetY;
            return result;
        };
    }
    static{
        // The cache key for a loadout+action -- shared by every sprite with the same descriptors, action
        // and submerged flag. Single source of truth for both generate() and request-time retains.
        this.computeKey = (descriptors, action, lpcRenderProps)=>descriptors.map((d)=>d.entityId).join("") + "_" + action + lpcRenderProps.isSubmerged;
    }
    static{
        // Increment the live reference count for a key. Callers retain a key from the moment they REQUEST
        // its generation (see LpcCompositeSprite.doPreparation), NOT when they adopt the clone: generation
        // is async/time-budgeted and the baked textures are shared across sprites, so retaining only on
        // adopt leaves a request->adopt window in which eviction could destroy textures a soon-to-be-live
        // clone needs -- the clone then renders a destroyed texture and Pixi throws in calculateVertices.
        this.retainKey = (key)=>{
            if (!key) return;
            $39fb998eb7d66fde$var$SynchronousJob.refCounts.set(key, ($39fb998eb7d66fde$var$SynchronousJob.refCounts.get(key) || 0) + 1);
        };
    }
    static{
        // Decrement a key's reference count WITHOUT destroying any display object, then maybe evict.
        this.releaseKey = (key)=>{
            if (key) {
                const next = ($39fb998eb7d66fde$var$SynchronousJob.refCounts.get(key) || 0) - 1;
                if (next <= 0) $39fb998eb7d66fde$var$SynchronousJob.refCounts.delete(key);
                else $39fb998eb7d66fde$var$SynchronousJob.refCounts.set(key, next);
            }
            $39fb998eb7d66fde$var$SynchronousJob.maybeEvict();
        };
    }
    static{
        // Result-based convenience wrappers (used by tests and internal callers).
        this.retain = (result)=>{
            $39fb998eb7d66fde$var$SynchronousJob.retainKey(result?.key);
        };
    }
    static{
        // Decrement the count and destroy the clone's display object (textures untouched -- they belong
        // to the cache). May trigger eviction of now-unreferenced entries.
        this.release = (result)=>{
            $39fb998eb7d66fde$var$SynchronousJob.destroyClone(result);
            $39fb998eb7d66fde$var$SynchronousJob.releaseKey(result?.key);
        };
    }
    static{
        // Dispose a clone's display object without touching the refcount: either a clone that was never
        // adopted (sprite discarded before the async callback), or an adopted clone torn down at cleanup
        // where its request-time key hold is released separately via releaseKey.
        this.abandon = (result)=>{
            $39fb998eb7d66fde$var$SynchronousJob.destroyClone(result);
        };
    }
    static{
        this.destroyClone = (result)=>{
            if (!result) return;
            try {
                result.animation?.destroy({
                    children: true,
                    texture: false,
                    baseTexture: false
                });
            } catch (e) {
            // ignore -- best-effort teardown
            }
            try {
                result.sprite?.destroy({
                    children: true,
                    texture: false,
                    baseTexture: false
                });
            } catch (e) {
            // ignore -- best-effort teardown
            }
        };
    }
    static{
        // Evict unreferenced entries oldest-first until under the cap (or nothing evictable remains).
        this.maybeEvict = ()=>{
            while($39fb998eb7d66fde$var$SynchronousJob.animationCache.size > $39fb998eb7d66fde$var$SynchronousJob.maxCachedAnimations){
                let evicted = false;
                for (const key of $39fb998eb7d66fde$var$SynchronousJob.animationCache.keys())if (($39fb998eb7d66fde$var$SynchronousJob.refCounts.get(key) || 0) <= 0) {
                    $39fb998eb7d66fde$var$SynchronousJob.evictKey(key);
                    evicted = true;
                    break;
                }
                if (!evicted) break;
            }
        };
    }
    static{
        this.evictKey = (key)=>{
            const canonical = $39fb998eb7d66fde$var$SynchronousJob.animationCache.get(key);
            $39fb998eb7d66fde$var$SynchronousJob.animationCache.delete(key);
            $39fb998eb7d66fde$var$SynchronousJob.refCounts.delete(key);
            // Destroy this key's baked frame RenderTextures (safe: no live clone references them).
            const prefix = `${key}-f-`;
            for (const tKey of Array.from($39fb998eb7d66fde$var$SynchronousJob.textureCache.keys()))if (tKey.startsWith(prefix)) {
                const tex = $39fb998eb7d66fde$var$SynchronousJob.textureCache.get(tKey);
                $39fb998eb7d66fde$var$SynchronousJob.textureCache.delete(tKey);
                try {
                    tex?.destroy(true);
                } catch (e) {
                // ignore -- best-effort teardown
                }
            }
            // Drop the cache-only canonical holder (its textures were destroyed just above).
            $39fb998eb7d66fde$var$SynchronousJob.destroyClone(canonical);
        };
    }
    static{
        this.clearCaches = ()=>{
            $39fb998eb7d66fde$var$SynchronousJob.textureCache.clear();
            $39fb998eb7d66fde$var$SynchronousJob.animationCache.clear();
            $39fb998eb7d66fde$var$SynchronousJob.refCounts.clear();
        };
    }
    constructor(key, action, lpcRenderMeta, lpcRenderProps, descriptors, callback, cancelled){
        this.isCancelled = ()=>!!this.cancelled?.();
        this.process = ()=>{
            // The requesting sprite was discarded before this job ran (e.g. entity torn down on a room
            // change); skip the bake entirely -- nothing is waiting for the result.
            if (this.isCancelled()) {
                this.callback(null);
                return;
            }
            const cachedResult = $39fb998eb7d66fde$var$SynchronousJob.animationCache.get(this.key);
            if (cachedResult) {
                const source = this.lpcRenderMeta;
                if (!source) {
                    this.callback(null);
                    return;
                }
                // Refresh LRU recency so an in-use entry isn't evicted ahead of colder ones.
                $39fb998eb7d66fde$var$SynchronousJob.animationCache.delete(this.key);
                $39fb998eb7d66fde$var$SynchronousJob.animationCache.set(this.key, cachedResult);
                const result = $39fb998eb7d66fde$var$SynchronousJob.cloneResult(cachedResult, source, this.key);
                this.result = result;
                this.callback(result);
                return;
            }
            let textureLayers = [];
            const processTextureLayers = ()=>{
                const layers = textureLayers.sort((a, b)=>a.order - b.order).map((n)=>n.textures);
                const animationFrameTextures = [];
                // No layer had textures for this action (e.g. every sheet was skipped or failed to
                // load). Nothing to bake -- report failure instead of dereferencing layers[0].
                if (layers.length < 1 || !layers[0]) {
                    this.callback(null);
                    return;
                }
                const frameCount = layers[0].length;
                for(let frame = 0; frame < frameCount; frame++){
                    const textureKey = `${this.key}-f-${frame}`;
                    let combinedTexture = $39fb998eb7d66fde$var$SynchronousJob.textureCache.get(textureKey);
                    if (!combinedTexture) {
                        const surface = new (0, $gwPoJ.Graphics)();
                        for(let l = 0; l < layers.length; l++){
                            const layerFrame = layers[l][frame];
                            // A layer with fewer frames than layer 0 has no texture here; skip it rather
                            // than baking an empty Sprite for it.
                            if (!layerFrame) continue;
                            const sprite = new (0, $7Bs2Z.Sprite)(layerFrame);
                            surface.addChild(sprite);
                            if (this.lpcRenderProps.isSubmerged) {
                                const mask = new (0, $gwPoJ.Graphics)();
                                mask.beginFill(0x000000, 1.0);
                                mask.drawRect(-40, -40, 80, 64);
                                mask.endFill();
                                sprite.addChild(mask);
                                sprite.mask = mask;
                            }
                        }
                        combinedTexture = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.generateTexture(surface);
                        $39fb998eb7d66fde$var$SynchronousJob.textureCache.set(textureKey, combinedTexture);
                    }
                    animationFrameTextures.push(combinedTexture);
                }
                if (animationFrameTextures.length < 1) {
                    this.callback(null);
                    return;
                }
                const source = this.lpcRenderMeta;
                if (!source) {
                    this.callback(null);
                    return;
                }
                const { animated: animated = true } = source;
                // Build a cache-only "canonical" holder from the baked frame textures. It is never
                // displayed; every caller (including this first one) receives an independent clone via
                // cloneResult, so the cached entry stays safe to evict without affecting live sprites.
                let canonicalAnimation;
                let canonicalSprite;
                if (animated) {
                    canonicalAnimation = new (0, $d3fD1.AnimatedSprite)(animationFrameTextures);
                    canonicalAnimation.visible = false;
                } else {
                    canonicalSprite = new (0, $7Bs2Z.Sprite)(animationFrameTextures[0]);
                    canonicalSprite.visible = false;
                }
                const canonical = new $39fb998eb7d66fde$export$7229ffc582571c48({
                    animation: canonicalAnimation,
                    sprite: canonicalSprite
                });
                canonical.key = this.key;
                // Stamped here, on the cache entry, while we still know which sheets fed this action --
                // every clone (this caller's and every later cache hit's) then reads the same numbers.
                if (this.oversized) {
                    canonical.offsetX = $39fb998eb7d66fde$var$OVERSIZE_OFFSET;
                    canonical.offsetY = $39fb998eb7d66fde$var$OVERSIZE_OFFSET;
                }
                $39fb998eb7d66fde$var$SynchronousJob.animationCache.set(this.key, canonical);
                // Safe to evict here: the caller retained this key at REQUEST time (see doPreparation),
                // so maybeEvict() cannot destroy the loadout we are about to clone and hand back.
                $39fb998eb7d66fde$var$SynchronousJob.maybeEvict();
                const result = $39fb998eb7d66fde$var$SynchronousJob.cloneResult(canonical, source, this.key);
                this.result = result;
                this.callback(result);
                return canonical;
            };
            this.descriptors.forEach((descriptor, i)=>{
                const sheetId = `lpc/spritesheets/${descriptor.entityId}.json`;
                const url = `assets/${sheetId}`;
                const key = `${url}`;
                const loader = (0, $c1d8cd49591538f1$export$cd02f82db8cdb05).getLoaderFor(url);
                const texturesSource = loader.resources[key]?.textures;
                if (!texturesSource) return;
                Object.keys(texturesSource).forEach((k)=>{
                    if (k.startsWith(this.action)) {
                        if (descriptor.type === "oversize") this.oversized = true;
                    }
                });
                const textures = Object.keys(texturesSource).filter((k)=>k.startsWith(this.action)).map((k)=>loader.resources[key].textures[k]);
                const x = {
                    order: i,
                    textures: textures
                };
                textureLayers.push(x);
            });
            // processTextureLayers caches the canonical entry itself (and evicts if over cap).
            processTextureLayers();
        };
        this.getResult = ()=>this.result;
        this.getKey = ()=>this.key;
        this.key = key;
        this.action = action;
        this.lpcRenderMeta = lpcRenderMeta;
        this.lpcRenderProps = lpcRenderProps;
        this.descriptors = descriptors;
        this.callback = callback;
        this.cancelled = cancelled;
        this.startTs = Date.now();
    }
}
class $39fb998eb7d66fde$var$LpcCompositeGenerator {
    // Max cached loadout+action entries before unreferenced ones are evicted.
    get maxCachedAnimations() {
        return $39fb998eb7d66fde$var$SynchronousJob.maxCachedAnimations;
    }
    set maxCachedAnimations(n) {
        $39fb998eb7d66fde$var$SynchronousJob.maxCachedAnimations = n;
        $39fb998eb7d66fde$var$SynchronousJob.maybeEvict();
    }
    constructor(){
        this.jobs = [];
        // cache: Map<string, AnimatedSprite> = new Map()
        this.processing = new Set();
        this.latch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(1000);
        // Per-tick wall-clock budget (ms) for building composites. Instead of a fixed one-job-per-tick
        // cap, process() drains jobs until this much time is spent, always doing at least one so the
        // queue makes progress. This is self-scaling across hardware: cache-hit clones are nearly free
        // so many drain per tick, while an expensive generateTexture bake eats the budget -- so a weak
        // GPU naturally does ~1 bake/tick (no frame hitch) and a fast one does many (rooms populate
        // near-instantly). Kept small so a single tick can't blow a 60fps frame on low-end hardware.
        this.bakeBudgetMs = 4;
        // Monotonic clock used for the budget. Prefers performance.now() (sub-ms, and NOT the mocked
        // Date.now this codebase uses for game time). Overridable in tests.
        this.now = ()=>typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
        this.generate = (priority, action, lpcRenderMeta, lpcRenderProps, descriptors, callback, cancelled)=>{
            const key = $39fb998eb7d66fde$var$SynchronousJob.computeKey(descriptors, action, lpcRenderProps);
            const job = new $39fb998eb7d66fde$var$SynchronousJob(key, action, lpcRenderMeta, lpcRenderProps, descriptors, callback, cancelled);
            if (priority) this.jobs.unshift(job);
            else this.jobs.push(job);
            if (!this.timer) this.timer = setInterval(this.process, $39fb998eb7d66fde$var$INTERVAL);
        };
        // Mark a clone as live on screen (call when a sprite adopts a generate result).
        this.retain = (result)=>$39fb998eb7d66fde$var$SynchronousJob.retain(result);
        // Mark a clone as gone (call when a sprite discards it); destroys the clone and may evict.
        this.release = (result)=>$39fb998eb7d66fde$var$SynchronousJob.release(result);
        // Dispose a clone that was never adopted (sprite discarded before the async callback arrived).
        this.abandon = (result)=>$39fb998eb7d66fde$var$SynchronousJob.abandon(result);
        // Retain a loadout key from the moment generation is REQUESTED (before the async job runs), so
        // eviction can't destroy its shared textures during the request->adopt window.
        this.retainKey = (key)=>$39fb998eb7d66fde$var$SynchronousJob.retainKey(key);
        // Release a request-time key hold (refcount-only; does not destroy any display object).
        this.releaseKey = (key)=>$39fb998eb7d66fde$var$SynchronousJob.releaseKey(key);
        // Compute the cache key for a loadout+action (same formula generate() uses).
        this.computeKey = (descriptors, action, lpcRenderProps)=>$39fb998eb7d66fde$var$SynchronousJob.computeKey(descriptors, action, lpcRenderProps);
        // Clears the static composite caches (test isolation / teardown).
        this.clearCaches = ()=>$39fb998eb7d66fde$var$SynchronousJob.clearCaches();
        this.process = ()=>{
            const start = this.now();
            // Drain jobs until the time budget is spent, always processing at least one so the queue
            // advances even if a single bake exceeds the budget on slow hardware.
            while(true){
                // Drop cancelled jobs (sprite discarded, e.g. on a room change) cheaply -- they don't
                // count against the budget. Their callbacks get null inside process(), which released
                // sprites ignore.
                let current = this.jobs.shift();
                while(current && current.isCancelled()){
                    current.process();
                    current = this.jobs.shift();
                }
                if (!current) {
                    clearInterval(this.timer);
                    this.timer = undefined;
                    return;
                }
                current.process();
                if (this.now() - start >= this.bakeBudgetMs) return;
            }
        };
    }
}
const $39fb998eb7d66fde$export$7100d33e089ec0 = new $39fb998eb7d66fde$var$LpcCompositeGenerator();




var $5UG8I = parcelRequire("5UG8I");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
// The ground marker that says "a real person is driving this body".
//
// Other players are LPC characters exactly like every NPC in the world, so nothing about the art
// tells one apart -- and the cues that would (a permanent name plate, a chat bubble) either cost
// vertical space above the head or only appear when the player happens to speak. This is the quietest
// cue that still reads at a glance: a thin cool-toned ellipse painted on the ground under the feet,
// behind the body, so the character stands inside it. It occupies no space above the head, never
// occludes a neighbour, and a dozen of them on screen still parse -- which a dozen name plates do not.
//
// Deliberately NOT an outline glow: that vocabulary belongs to the hover/interaction highlight (see
// entity_highlight), and a permanent rim would read as "you can act on this" all the time. It is not
// animated either -- no ticker, no pulse. This is a standing fact about the entity, not an alert, and
// a static Graphics costs nothing on the low-end machines this game targets.
// Geometry lives in the sprite's own 64x64 art space; the sprite anchors the ring on the same foot
// line it draws its shadow on, so the ring sits where the character's weight is (and rides up with it
// when the body is submerged).
const $4422ba9e5bf47053$var$RING_RX = 13.5;
const $4422ba9e5bf47053$var$RING_RY = 6.25;
const $4422ba9e5bf47053$var$RING_WIDTH = 1.5;
// A darker contour under the bright ring, a pixel wider on each side, so the cue survives pale ground
// (sand, snow, the camp's trodden dirt) as well as dark grass -- the same trick the name plate plays
// with its black text stroke.
const $4422ba9e5bf47053$var$CONTOUR_COLOR = 0x0b1a26;
const $4422ba9e5bf47053$var$CONTOUR_WIDTH = $4422ba9e5bf47053$var$RING_WIDTH + 2;
// Alphas of the contour and the outer bloom, both expressed as a fraction of the ring's own alpha, so
// tuning `alpha` fades the whole marker together instead of pulling it apart.
const $4422ba9e5bf47053$var$CONTOUR_ALPHA_SHARE = 0.4;
// A very faint filled ellipse just outside the ring: it beds the marker into the ground instead of
// leaving it looking like a decal laid on top.
const $4422ba9e5bf47053$var$GLOW_RX = $4422ba9e5bf47053$var$RING_RX + 2;
const $4422ba9e5bf47053$var$GLOW_RY = $4422ba9e5bf47053$var$RING_RY + 1.5;
const $4422ba9e5bf47053$var$GLOW_ALPHA_SHARE = 0.14;
const $4422ba9e5bf47053$export$d54c1ceb0ac36b4e = {
    enabled: true,
    color: 0x8fd6ff,
    alpha: 0.8,
    scale: 1
};
let $4422ba9e5bf47053$var$tuning = {
    ...$4422ba9e5bf47053$export$d54c1ceb0ac36b4e
};
const $4422ba9e5bf47053$export$65a499c0f5c261b4 = ()=>$4422ba9e5bf47053$var$tuning;
// Every ring currently on screen. Tuning from the console repaints what is already there rather than
// only reaching players who walk into view afterwards; rings drop out of the set in dispose().
const $4422ba9e5bf47053$var$liveRings = new Set();
const $4422ba9e5bf47053$export$d7fdea8fdac98454 = (next)=>{
    const patch = typeof next === "boolean" ? {
        enabled: next
    } : next || {};
    $4422ba9e5bf47053$var$tuning = {
        ...$4422ba9e5bf47053$var$tuning,
        ...patch
    };
    $4422ba9e5bf47053$var$liveRings.forEach((ring)=>ring.redraw());
    return $4422ba9e5bf47053$var$tuning;
};
const $4422ba9e5bf47053$export$a1adf936bbb1d6bd = ()=>$4422ba9e5bf47053$export$d7fdea8fdac98454({
        ...$4422ba9e5bf47053$export$d54c1ceb0ac36b4e
    });
class $4422ba9e5bf47053$export$54b95433f33ae529 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super();
        $4422ba9e5bf47053$var$liveRings.add(this);
        this.redraw();
    }
    redraw() {
        this.clear();
        const { enabled: enabled, color: color, alpha: alpha, scale: scale } = $4422ba9e5bf47053$var$tuning;
        this.visible = enabled;
        if (!enabled) return;
        const rx = $4422ba9e5bf47053$var$RING_RX * scale;
        const ry = $4422ba9e5bf47053$var$RING_RY * scale;
        // Bloom first, then the dark contour, then the bright ring on top of it.
        this.beginFill(color, alpha * $4422ba9e5bf47053$var$GLOW_ALPHA_SHARE);
        this.drawEllipse(0, 0, $4422ba9e5bf47053$var$GLOW_RX * scale, $4422ba9e5bf47053$var$GLOW_RY * scale);
        this.endFill();
        this.lineStyle($4422ba9e5bf47053$var$CONTOUR_WIDTH, $4422ba9e5bf47053$var$CONTOUR_COLOR, alpha * $4422ba9e5bf47053$var$CONTOUR_ALPHA_SHARE);
        this.drawEllipse(0, 0, rx, ry);
        this.lineStyle($4422ba9e5bf47053$var$RING_WIDTH, color, alpha);
        this.drawEllipse(0, 0, rx, ry);
        this.lineStyle(0);
    }
    // Decoration must never resize the thing it decorates. A renderable derives its on-screen y from
    // its own measured height (BaseRenderable.getYOffset reads `this.height`, a bounds query over every
    // child), so a ring that widened those bounds would nudge the very character it marks. Reporting no
    // bounds keeps the marker out of every measurement taken of the entity -- the same reasoning as the
    // hover outline's BoundlessContainer.
    calculateBounds() {
        this._bounds.clear();
    }
    // Stop tracking this ring for live tuning. The owning sprite calls this from its cleanup, which
    // runs on a paperdoll rebuild as well as on teardown -- remove() only detaches, it never destroys,
    // so without this the set would grow by one entry per rebuild.
    dispose() {
        $4422ba9e5bf47053$var$liveRings.delete(this);
    }
    destroy(options) {
        this.dispose();
        super.destroy(options);
    }
}
// Browser-console tuning, in the same shape as window.spriteShadow / window.deathEffect:
//
//     playerRing = false                 // off
//     playerRing = { scale: 1.4 }        // wider footprint
//     playerRing = { color: 0xff6688 }   // try another hue
//     playerRing                         // read the active values back
//
// Guarded so it is a no-op in the Node test harness.
if (typeof window !== "undefined") Object.defineProperty(window, "playerRing", {
    get: ()=>$4422ba9e5bf47053$var$tuning,
    set: (next)=>{
        console.log("[playerRing]", $4422ba9e5bf47053$export$d7fdea8fdac98454(next));
    },
    configurable: true
});


const $d782e74b2eaa8700$export$c93e91c91768c5a2 = [
    "walk-left",
    "walk-right",
    "walk-back",
    "walk-front",
    "idle-left",
    "idle-right",
    "idle-back",
    "idle-front",
    "thrust-left",
    "thrust-right",
    "thrust-back",
    "thrust-front",
    "slash-left",
    "slash-right",
    "slash-back",
    "slash-front",
    "shoot-left",
    "shoot-right",
    "shoot-back",
    "shoot-front",
    "hurt-front",
    "activate",
    "deactivate",
    "inactive",
    "active"
];
const $d782e74b2eaa8700$var$AnimationTypeToActionType = {
    activate: "activate",
    deactivate: "deactivate",
    inactive: "inactive",
    active: "activate",
    "walk-left": "walk",
    "walk-right": "walk",
    "walk-back": "walk",
    "walk-front": "walk",
    "idle-left": "idle",
    "idle-right": "idle",
    "idle-back": "idle",
    "idle-front": "idle",
    "thrust-left": "thrust",
    "thrust-right": "thrust",
    "thrust-back": "thrust",
    "thrust-front": "thrust",
    "slash-left": "slash",
    "slash-right": "slash",
    "slash-back": "slash",
    "slash-front": "slash",
    "shoot-left": "shoot",
    "shoot-right": "shoot",
    "shoot-back": "shoot",
    "shoot-front": "shoot",
    "hurt-front": "hurt"
};
const $d782e74b2eaa8700$export$e9e3e7e76042b5bf = (frameHeight, feetY)=>frameHeight / 2 + (feetY - (0, $39fb998eb7d66fde$export$8130c6196a172b8a));
const $d782e74b2eaa8700$var$defaultRenderMeta = {
    activate: {
        scale: 1,
        speed: 0.25
    },
    deactivate: {
        scale: 1,
        speed: 0.25
    },
    inactive: {
        scale: 1,
        animated: false
    },
    active: {
        scale: 1
    },
    "walk-left": {
        scale: 1,
        speed: 0.25
    },
    "walk-right": {
        scale: 1,
        speed: 0.25
    },
    "walk-back": {
        scale: 1,
        speed: 0.25
    },
    "walk-front": {
        scale: 1,
        speed: 0.25
    },
    "idle-left": {
        scale: 1
    },
    "idle-right": {
        scale: 1
    },
    "idle-back": {
        scale: 1
    },
    "idle-front": {
        scale: 1
    },
    "thrust-left": {
        scale: 1,
        speed: 0.55
    },
    "thrust-right": {
        scale: 1,
        speed: 0.55
    },
    "thrust-back": {
        scale: 1,
        speed: 0.55
    },
    "thrust-front": {
        scale: 1,
        speed: 0.55
    },
    "slash-left": {
        scale: 1,
        speed: 0.25
    },
    "slash-right": {
        scale: 1,
        speed: 0.25
    },
    "slash-back": {
        scale: 1,
        speed: 0.25
    },
    "slash-front": {
        scale: 1,
        speed: 0.25
    },
    "shoot-left": {
        scale: 1,
        speed: 0.85
    },
    "shoot-right": {
        scale: 1,
        speed: 0.85
    },
    "shoot-back": {
        scale: 1,
        speed: 0.85
    },
    "shoot-front": {
        scale: 1,
        speed: 0.85
    },
    "hurt-front": {
        scale: 1
    }
};
const $d782e74b2eaa8700$var$animationToAction = (animation)=>animation.split("-")[0];
const $d782e74b2eaa8700$var$isDirectional = (type)=>type.includes("-");
const $d782e74b2eaa8700$var$isAttackAnimation = (animationName)=>[
        "shoot",
        "thrust",
        "slash"
    ].includes($d782e74b2eaa8700$var$animationToAction(animationName));
const $d782e74b2eaa8700$var$isActivationAnimation = (animationName)=>[
        "activate",
        "deactivate"
    ].includes($d782e74b2eaa8700$var$animationToAction(animationName));
const $d782e74b2eaa8700$var$isWalkAnimation = (animationName)=>[
        "walk"
    ].includes($d782e74b2eaa8700$var$animationToAction(animationName));
const $d782e74b2eaa8700$var$extractDirection = (animation)=>animation.split("-")[1];
const $d782e74b2eaa8700$var$actionTypeToAnimationAction = (actionType)=>{
    if (actionType === "activate") return "activate";
    if (actionType === "deactivate") return "deactivate";
    if (actionType === "inactive") return "inactive";
    if (actionType === "active") return "active";
};
const $d782e74b2eaa8700$var$isLooped = (animation)=>{
    if ($d782e74b2eaa8700$var$isAttackAnimation(animation) || $d782e74b2eaa8700$var$isActivationAnimation(animation)) return false;
    return true;
};
class $d782e74b2eaa8700$export$7e6fc99bfa4004f1 {
    constructor(doneCallback){
        this.jobs = new Set();
        this.offer = (job)=>{
            this.jobs.add(job);
        };
        this.complete = (job)=>{
            this.jobs.delete(job);
            if (this.completed) return;
            if (this.jobs.size < 1) {
                this.completed = true;
                this.doneCallback();
            }
        };
        this.clear = ()=>{
            this.jobs.clear();
            this.completed = false;
        };
        this.doneCallback = doneCallback;
    }
}
// Single shared driver for every LpcCompositeSprite's periodic callback maintenance. Each sprite
// used to create its OWN setInterval(100ms) + setInterval(10s); with many sprites on screen that
// was dozens of independent timer wake-ups per second on the main thread -- a real cost on low-end
// CPUs. One shared pair of timers iterating the registered set is far cheaper, and each sprite's
// check early-returns when it has no active callbacks. The timers exist only while >=1 sprite is
// registered, so an empty scene schedules nothing.
class $d782e74b2eaa8700$var$LpcSpriteMaintenanceTicker {
    constructor(){
        this.sprites = new Set();
        this.register = (sprite)=>{
            this.sprites.add(sprite);
            if (this.missingTimer === undefined) this.missingTimer = setInterval(this.runMissingChecks, 100);
            if (this.orphanedTimer === undefined) this.orphanedTimer = setInterval(this.runOrphanedCleanup, 10000);
        };
        this.unregister = (sprite)=>{
            if (!this.sprites.delete(sprite)) return;
            if (this.sprites.size === 0) {
                clearInterval(this.missingTimer);
                clearInterval(this.orphanedTimer);
                this.missingTimer = undefined;
                this.orphanedTimer = undefined;
            }
        };
        // Iterate a snapshot and isolate each sprite so one throwing check can't stop maintenance for
        // the rest (and can't kill the shared interval).
        this.runMissingChecks = ()=>{
            Array.from(this.sprites).forEach((s)=>{
                try {
                    s.checkForMissingCallbacks();
                } catch (e) {
                // best-effort maintenance
                }
            });
        };
        this.runOrphanedCleanup = ()=>{
            Array.from(this.sprites).forEach((s)=>{
                try {
                    s.cleanupOrphanedCallbacks();
                } catch (e) {
                // best-effort maintenance
                }
            });
        };
    }
}
const $d782e74b2eaa8700$var$lpcSpriteMaintenanceTicker = new $d782e74b2eaa8700$var$LpcSpriteMaintenanceTicker();
class $d782e74b2eaa8700$export$db88fc637337eefb extends (0, $a64b70167386625f$export$98e91636974d835d) {
    // Show or hide the ground ring without rebuilding anything. Hiding rather than disposing: an
    // invader's ring comes back the moment they are their own person again, and a sprite that threw
    // the ring away would have to rebuild its layers to get one.
    setPlayerRingVisible(visible) {
        if (this.playerRing) this.playerRing.visible = visible;
    }
    constructor({ descriptors: descriptors, renderMeta: renderMeta = $d782e74b2eaa8700$var$defaultRenderMeta, attackAction: attackAction, angle: angle, hasHalo: hasHalo, hasShadow: hasShadow, hasPlayerRing: hasPlayerRing, id: id, priority: priority, loadObserver: loadObserver, isSubmerged: isSubmerged, defaultAction: defaultAction }){
        super(), this.spriteAngle = 0, this.action = "idle-front", this.prevAction = "idle-front", this.animations = {}, // Set once this sprite has been discarded, so a late async generate callback disposes its
        // clone instead of adopting it (and leaking a cache reference).
        this.spriteReleased = false, // Cache key retained at request time for each action we've prepared (see doPreparation). Released
        // once per entry in cleanup() -- covers adopted, still-loading, and failed actions alike.
        this.preparedActionKeys = new Map(), this.facingDir = "front", this.attackAction = "idle", this.animationDictionaryTypeLoadingState = new Map(), this.feetY = 60, this.spriteShadowTicking = false, this.actionCompleteListeners = new Map(), // Enhanced callback management
        this.callbackStates = new Map(), this.activeCallbacks = new Set(), this.currentAnimationCallbacks = new Set(), // Whether this sprite is registered with the shared maintenance ticker (see startCleanupTimer).
        this.registeredWithTicker = false, // Per-frame: draw the active animation's current frame a second time, projected onto the ground
        // along the sun vector, as a real pose-accurate shadow. Reuses the entity's own baked frame textures
        // (shared, refcounted by the generator) -- no new bake, no filter. The projection is a planar shadow
        // matrix: every pixel of the sprite's height above the feet is displaced by (dirX, dirY) on the
        // ground, so (dirX, dirY) IS the sun angle. Defaults cast a shallow shadow toward the lower-left to
        // match the map's baked bush/tree shadows. window.spriteShadow = false falls back to the ellipse;
        // window.spriteShadow{DirX,DirY,Alpha} tune it live without a reload.
        this.updateSpriteShadow = ()=>{
            const shadow = this.spriteShadow;
            if (!shadow) return;
            // On by default; set window.spriteShadow = false to fall back to the foot ellipse.
            const w = window;
            const on = w.spriteShadow !== false;
            // Swap which shadow style is visible.
            if (this.shadow) this.shadow.visible = !on;
            if (!on) {
                if (shadow.visible) {
                    shadow.visible = false;
                    shadow.texture = (0, $klOfb.Texture).EMPTY;
                }
                return;
            }
            const active = this.animations[this.action]?.animation;
            if (!active || !active.visible || active.textures.length === 0) {
                shadow.visible = false;
                return;
            }
            const tex = active.textures[active.currentFrame];
            if (!tex || !tex.valid) {
                shadow.visible = false;
                return;
            }
            // Sun vector: ground displacement per pixel of sprite height. dirX < 0 leans left, dirY > 0
            // stretches "south". A shallow lower-left cast (|dirX| > dirY) matches the baked bush/tree art.
            const dirX = typeof w.spriteShadowDirX === "number" ? w.spriteShadowDirX : -0.23;
            const dirY = typeof w.spriteShadowDirY === "number" ? w.spriteShadowDirY : 0.13;
            const alpha = typeof w.spriteShadowAlpha === "number" ? w.spriteShadowAlpha : 0.3;
            const fh = tex.orig?.height ?? 64;
            const feet = $d782e74b2eaa8700$export$e9e3e7e76042b5bf(fh, this.feetY);
            const sx = active.scale.x;
            const sy = active.scale.y;
            shadow.texture = tex;
            shadow.anchor.set(0, 0);
            shadow.alpha = alpha;
            // Affine planar-projection matrix mapping texture (lx, ly) -> container space. A texel `hUp`
            // pixels above the feet lands at feet + hUp * (dirX, dirY); the feet themselves stay pinned.
            // The negative d-term flips the silhouette down onto the ground. active.x/scale already carry
            // any oversize offset, so the shadow tracks the sprite. fw/2 centering cancels out of tx.
            const a = sx;
            const c = -sx * dirX;
            const d = -sy * dirY;
            const tx = active.x + feet * sx * dirX;
            const ty = active.y + feet * sy * (1 + dirY);
            shadow.transform.setFromMatrix(new (0, $6qzqq.Matrix)(a, 0, c, d, tx, ty));
            shadow.visible = true;
        }, // The frame EntityHighlight traces for the hover outline: the active animation's current baked
        // texture plus the transform it is drawn with, so the outline lands exactly on the pose (including
        // any oversize offset already baked into active.x/scale) and follows the animation frame by frame.
        // Null while the sheets are still loading or when this sprite has no art of its own -- the caller
        // then falls back to a footprint ring.
        this.highlightFrame = ()=>{
            const result = this.animations[this.action];
            const active = result?.animation ?? result?.sprite;
            if (!active || !active.visible) return null;
            const texture = result.fragmentBase();
            if (!texture?.valid) return null;
            return {
                texture: texture,
                x: active.x,
                y: active.y,
                scaleX: active.scale.x,
                scaleY: active.scale.y
            };
        }, this.setHighlighted = (on)=>{
            if (!this.highlight) {
                if (!on) return true;
                this.highlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
                    artContainer: this.container,
                    frame: this.highlightFrame
                });
            }
            this.highlight.set(on);
            return true;
        }, this.logme = (msg, m2 = "", m3 = "")=>{
        // console.log(this.creationTs, "@@@", this.identifier, msg, m2, m3)
        }, this.initalize = (id, angle)=>{
            this.identifier = id;
            const f = this.calcDir(angle);
            const action = $d782e74b2eaa8700$var$actionTypeToAnimationAction(this.defaultAction) || "idle-" + f;
            let descriptorCountdown = this.descriptors.length;
            this.logme("initializing sheets", id);
            const s = Date.now();
            this.loadObserver?.offer(action);
            // No sheets to wait on: the per-descriptor countdown below would never reach zero, leaving
            // the sprite permanently uninitialized (and blank). Initialize straight away instead.
            if (descriptorCountdown <= 0) {
                this.initialized = true;
                this.loadObserver?.complete(action);
                this.startCleanupTimer();
                this.activateAnimation(action, true);
                return;
            }
            this.descriptors.forEach((descriptor, i)=>{
                const sheetId = `lpc/spritesheets/${descriptor.entityId}.json`;
                const url = `assets/${sheetId}`;
                this.logme("loading", url);
                (0, $c1d8cd49591538f1$export$cd02f82db8cdb05).load(url, (_)=>{
                    descriptorCountdown -= 1;
                    if (descriptorCountdown <= 0) {
                        this.initialized = true;
                        this.logme("@@@ all sheets loaded", action);
                        this.loadObserver?.complete(action);
                        // Start cleanup timer for orphaned callbacks
                        this.startCleanupTimer();
                        const elapsed = Date.now() - s;
                        this.activateAnimation(action, true);
                    }
                });
            });
        }, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            const source = this.animations[`${this.action}`];
            if (source) source.recolor(color);
        }, this.postAnimation = (animation)=>{
            if ($d782e74b2eaa8700$var$isAttackAnimation(animation)) return `idle-${$d782e74b2eaa8700$var$extractDirection(this.action)}`;
            if (animation === "activate") return "active";
            if (animation === "deactivate") return "inactive";
        }, this.doPreparation = (action)=>{
            this.logme("@@@ kicked off", action);
            this.animationDictionaryTypeLoadingState.set(action, "loading");
            // Retain this loadout's cache key NOW, at request time -- generation is async/time-budgeted
            // and the baked textures are shared across sprites, so retaining only on adopt (below) leaves
            // a window where eviction could destroy textures this sprite is about to display. Released
            // once per prepared action in cleanup().
            if (!this.preparedActionKeys.has(action)) {
                const key = (0, $39fb998eb7d66fde$export$7100d33e089ec0).computeKey(this.descriptors, action, this.renderProps);
                this.preparedActionKeys.set(action, key);
                (0, $39fb998eb7d66fde$export$7100d33e089ec0).retainKey(key);
            }
            (0, $39fb998eb7d66fde$export$7100d33e089ec0).generate(this.priority, action, this.renderMeta[action], this.renderProps, this.descriptors, (result)=>{
                if (result) {
                    // Sprite was discarded before this async result arrived: dispose the orphan
                    // clone rather than adopting it into a detached container.
                    if (this.spriteReleased) {
                        (0, $39fb998eb7d66fde$export$7100d33e089ec0).abandon(result);
                        return;
                    }
                    const animation = result.animation;
                    const sprite = result.sprite;
                    if (animation) this.container.addChild(animation);
                    if (sprite) this.container.addChild(sprite);
                    const postAnimation = this.postAnimation(action);
                    this.logme("caching", action);
                    if (animation) {
                        animation.loop = $d782e74b2eaa8700$var$isLooped(action);
                        const listeners = this.actionCompleteListeners.get($d782e74b2eaa8700$var$animationToAction(action));
                        if (listeners?.size() > 0) {
                            const totalFrames = animation.totalFrames;
                            animation.onFrameChange = (frame)=>{
                                const pct = frame / (totalFrames - 1);
                                if (pct > 0.5) // Enhanced callback execution with state tracking
                                this.executeCallbacks(listeners, $d782e74b2eaa8700$var$animationToAction(action));
                            };
                        }
                        if (postAnimation) animation.onComplete = ()=>{
                            this.activateAnimation(postAnimation);
                        };
                        else // Add completion handler for cleanup
                        animation.onComplete = ()=>{
                            this.cleanupAnimationCallbacks(action);
                        };
                    }
                    if (sprite) {
                        const listeners = this.actionCompleteListeners.get($d782e74b2eaa8700$var$animationToAction(action));
                        if (listeners?.size() > 0) listeners.forEach((listener)=>{
                            listener.callback();
                            listeners.remove(listener.entityId);
                        });
                    }
                    this.animations[action] = result;
                    // No retain here: the key was already retained at request time (doPreparation).
                    // Retain-at-request closes the async request->adopt window that retain-on-adopt left
                    // open (eviction could destroy the shared textures before this clone went live).
                    this.logme("is all prepared for", action);
                    this.animationDictionaryTypeLoadingState.set(action, "loaded");
                    this.activateAnimation(action, true);
                    if (sprite && postAnimation) this.activateAnimation(postAnimation);
                } else {
                    this.logme("! could not prepare", action);
                    this.animationDictionaryTypeLoadingState.set(action, "failed");
                }
            }, // Lets the generator drop this job cheaply if the sprite is discarded (entity torn down
            // on a room change) before the job runs, so it never bakes a texture nobody wants.
            ()=>this.spriteReleased);
        }, this.prepare = (updatedAction)=>{
            this.logme("@@@ prepare", updatedAction);
            if (this.animations[updatedAction]) {
                this.logme("@@@ already exists", updatedAction);
                // already exists
                return;
            }
            const loadState = this.animationDictionaryTypeLoadingState.get(updatedAction);
            if (loadState && loadState !== "loaded" && loadState !== "failed") {
                this.logme("@@@", updatedAction, "still in progress");
                // still in progress
                return;
            }
            if (loadState === "failed") {
                this.logme("@@@", updatedAction, "failed");
                return;
            }
            // kick it off
            this.doPreparation(updatedAction);
        }, this.activateAnimation = (updatedAction, force)=>{
            if (!this.initialized) return;
            this.logme("->", updatedAction);
            if (updatedAction === this.action && !force) // noop
            return;
            // Clean up callbacks for current animation before changing
            this.cleanupCurrentAnimationCallbacks();
            const source = this.animations[`${this.action}`];
            const toUpdate = this.animations[`${updatedAction}`];
            if (!toUpdate) {
                // const currentState = this.animationDictionaryTypeLoadingState[updatedAction]
                // if (currentState === "loading" || currentState === "failed") {
                //     return
                // }
                this.logme(updatedAction, "not present, prepping");
                this.prepare(`${updatedAction}`);
                return;
            }
            if (source) {
                // Cancel callbacks before stopping animation
                this.cancelCurrentAnimationCallbacks();
                source.stop();
            }
            // Update action and start new animation
            this.action = updatedAction;
            toUpdate?.play();
            // Reapply the current tint: each action's clone was built with whatever color was current
            // when it was baked, so an animation prepared before the last recolor() would otherwise
            // show its stale build-time color when activated.
            if (this.currentColor !== undefined) toUpdate?.recolor(this.currentColor);
            // CRITICAL FIX: Preserve listeners when changing animation directions for the same action
            this.preserveListenersForSameAction(updatedAction);
            // Set up callbacks for new animation
            this.setupNewAnimationCallbacks(updatedAction);
            // CRITICAL FIX: Ensure callbacks are set up even if animation is already loaded
            this.ensureCallbacksAreSetUp(updatedAction);
        }, this.addActionListener = (action, actionListener)=>{
            const callbackId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
            const callbackState = {
                entityId: actionListener.entityId,
                callback: actionListener.callback,
                animationName: this.action,
                actionType: action,
                createdAt: Date.now(),
                status: "pending"
            };
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Adding action listener: ${callbackId} for action: ${action}, current animation: ${this.action}`);
            this.callbackStates.set(callbackId, callbackState);
            this.activeCallbacks.add(callbackId);
            // Store in existing system for compatibility
            let listeners = this.actionCompleteListeners.get(action);
            if (!listeners) {
                listeners = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
                this.actionCompleteListeners.set(action, listeners);
                (0, $5UG8I.logger).debug({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Created new listeners map for action: ${action}`);
            }
            listeners.add({
                ...actionListener,
                callbackId: callbackId
            });
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Added listener to map. Total listeners for ${action}: ${listeners.size()}`);
        }, this.fragment = (entity)=>{
            let actionToUse = this.action;
            if (!this.renderMeta[this.action]) actionToUse = `idle-${this.facingDir}`;
            if (!this.renderMeta[actionToUse]) return;
            const { scale: scale } = this.renderMeta[actionToUse];
            const surface = new (0, $gwPoJ.Graphics)();
            surface.x = this.parent?.x - this.parent.width * 0.5;
            surface.y = this.parent?.y - this.parent.height * 0.5;
            surface.scale.set(scale);
            surface.rotation = this.container.rotation;
            this.parent.parent.addChild(surface);
            const f = this.animations[`${actionToUse}`]?.fragmentBase();
            if (!f) return;
            (0, $4264eae3240561ee$export$cc249234599c5a64)(surface, f, {
                cacheKey: entity.appearance?.race
            });
        };
        // TEST: Log immediately to verify logging is working
        (0, $5UG8I.logger).info({
            tags: [
                "callback",
                "animation"
            ]
        }, `LPC Composite Sprite created for entity ${id}, action: ${this.action}`);
        this.id = id;
        this.priority = priority;
        this.renderMeta = {
            ...$d782e74b2eaa8700$var$defaultRenderMeta,
            ...renderMeta
        };
        this.renderProps = {
            isSubmerged: isSubmerged
        };
        this.attackAction = attackAction;
        this.spriteAngle = angle;
        this.facingDir = this.calcDir(angle);
        this.container = new (0, $gwPoJ.Graphics)();
        this.addChild(this.container);
        this.loadObserver = loadObserver;
        if (hasHalo) {
            const halo = new (0, $gwPoJ.Graphics)();
            halo.alpha = 0.5;
            halo.beginFill(0xffffff);
            halo.drawCircle(32, 25, 13);
            halo.endFill();
            this.halo = halo;
            this.container.addChild(halo);
        }
        // The ground line this body stands on, shared by the foot shadow and the player ring. A
        // submerged body sits higher in its frame, so its feet are higher too.
        this.feetY = isSubmerged ? 55 : 60;
        if (hasShadow) {
            const shadow = new (0, $gwPoJ.Graphics)();
            shadow.alpha = 0.2;
            shadow.beginFill(0x000000);
            shadow.drawEllipse(32, this.feetY, 16, 8);
            shadow.endFill();
            this.shadow = shadow;
            this.container.addChild(shadow);
            // Projected silhouette shadow -- on by default (window.spriteShadow = false falls back to
            // the ellipse). Sits behind the character; the per-frame update swaps which one is visible.
            const spriteShadow = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
            spriteShadow.tint = 0x000000;
            spriteShadow.visible = false;
            this.spriteShadow = spriteShadow;
            this.container.addChild(spriteShadow);
            (0, $3YyWq.Ticker).shared.add(this.updateSpriteShadow);
            this.spriteShadowTicking = true;
        }
        if (hasPlayerRing) {
            // Added after both shadows so neither darkens the marker, and before the animation layers
            // (which arrive later, see doPreparation) so the body occludes its middle and the character
            // reads as standing inside the ring rather than in front of a decal.
            const ring = new (0, $4422ba9e5bf47053$export$54b95433f33ae529)();
            ring.x = 32;
            ring.y = this.feetY;
            this.playerRing = ring;
            this.container.addChild(ring);
        }
        this.descriptors = descriptors;
        this.creationTs = Date.now();
        this.defaultAction = defaultAction;
    }
    calcDir(angle) {
        return (0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(angle);
    }
    doMovement(entity) {
        const { movement: movement } = entity;
        if (!movement) return;
        if (this.spriteAngle !== movement.angle) {
            const facingDir = this.calcDir(movement.angle);
            if (facingDir !== this.facingDir) // Enhanced direction change handling
            this.changeDirection(facingDir);
            this.facingDir = facingDir;
        }
        this.spriteAngle = movement.angle;
        const { x: x, y: y } = entity.location;
        if (x !== this.lastX || y !== this.lastY) {
            if (this.idleTimeout !== undefined) {
                clearTimeout(this.idleTimeout);
                this.idleTimeout = undefined;
            }
            if (this.lastX !== undefined && this.lastY !== undefined && !$d782e74b2eaa8700$var$isAttackAnimation(this.action)) this.activateAnimation(`walk-${this.facingDir}`);
            this.lastX = x;
            this.lastY = y;
        } else if (this.idleTimeout === undefined) this.idleTimeout = setTimeout(()=>{
            if ($d782e74b2eaa8700$var$isAttackAnimation(this.action)) return;
            if (!(0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isStationary(entity)) this.activateAnimation(`idle-${this.facingDir}`);
        }, 50);
    }
    doAttack(entity, callback) {
        // TEST: Log immediately to verify attack logging is working
        (0, $5UG8I.logger).info({
            tags: [
                "callback",
                "animation"
            ]
        }, `ATTACK TEST: doAttack called for entity ${entity.entityId}, callback: ${!!callback}, action: ${this.action}`);
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `doAttack called with callback: ${!!callback}, current action: ${this.action}`);
        // Cancel any existing attack callbacks
        this.cancelAttackCallbacks();
        if ($d782e74b2eaa8700$var$isAttackAnimation(this.action)) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Already attacking, replacing callback`);
            // If already attacking, replace the callback
            this.replaceAttackCallback(callback);
            return;
        }
        if (this.disallowMoveAttackAnimation && $d782e74b2eaa8700$var$isWalkAnimation(this.action)) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Attack blocked - disallowMoveAttackAnimation and walking`);
            return;
        }
        this.prevAction = this.action;
        const newAction = `${this.attackAction}-${this.facingDir}`;
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `Starting attack animation: ${newAction}`);
        if (callback) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Adding callback for action: ${$d782e74b2eaa8700$var$animationToAction(newAction)}`);
            this.addActionListener($d782e74b2eaa8700$var$animationToAction(newAction), {
                entityId: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
                callback: callback
            });
        }
        this.activateAnimation(newAction);
    }
    // Enhanced callback management methods
    cleanupCurrentAnimationCallbacks() {
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const listeners = this.actionCompleteListeners.get(currentAction);
        if (listeners) {
            listeners.forEach((listener)=>{
                const callbackId = listener.callbackId;
                if (callbackId) this.cancelCallback(callbackId);
            });
            listeners.clear();
        }
    }
    cancelCurrentAnimationCallbacks() {
        this.currentAnimationCallbacks.forEach((callbackId)=>{
            this.cancelCallback(callbackId);
        });
        this.currentAnimationCallbacks.clear();
    }
    setupNewAnimationCallbacks(animationName) {
        const action = $d782e74b2eaa8700$var$animationToAction(animationName);
        const listeners = this.actionCompleteListeners.get(action);
        if (listeners?.size() > 0) listeners.forEach((listener)=>{
            const callbackId = listener.callbackId;
            if (callbackId) this.currentAnimationCallbacks.add(callbackId);
        });
    }
    cancelAttackCallbacks() {
        const attackActions = [
            "thrust",
            "slash",
            "shoot"
        ];
        attackActions.forEach((action)=>{
            const listeners = this.actionCompleteListeners.get(action);
            if (listeners) {
                listeners.forEach((listener)=>{
                    const callbackId = listener.callbackId;
                    if (callbackId) this.cancelCallback(callbackId);
                });
                listeners.clear();
            }
        });
    }
    replaceAttackCallback(callback) {
        if (!callback) return;
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const listeners = this.actionCompleteListeners.get(currentAction);
        if (listeners) {
            // Clear existing callbacks
            listeners.forEach((listener)=>{
                const callbackId = listener.callbackId;
                if (callbackId) this.cancelCallback(callbackId);
            });
            listeners.clear();
            // Add new callback
            this.addActionListener(currentAction, {
                entityId: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
                callback: callback
            });
        }
    }
    cancelCallback(callbackId) {
        const callbackState = this.callbackStates.get(callbackId);
        if (callbackState && callbackState.status === "pending") {
            callbackState.status = "cancelled";
            this.activeCallbacks.delete(callbackId);
            this.currentAnimationCallbacks.delete(callbackId);
        }
    }
    executeCallbacks(listeners, action) {
        listeners.forEach((listener)=>{
            const callbackId = listener.callbackId;
            if (callbackId && this.callbackStates.has(callbackId)) {
                const callbackState = this.callbackStates.get(callbackId);
                if (callbackState.status === "pending") try {
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Executing callback for ${callbackId}`);
                    callbackState.callback();
                    callbackState.status = "executed";
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Callback executed successfully: ${callbackId}`);
                } catch (error) {
                    (0, $5UG8I.logger).error({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Callback execution failed for ${callbackId}:`, error);
                    callbackState.status = "cancelled";
                }
                else (0, $5UG8I.logger).debug({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Callback ${callbackId} already ${callbackState.status}`);
                // Remove from active callbacks
                this.activeCallbacks.delete(callbackId);
                this.currentAnimationCallbacks.delete(callbackId);
            } else (0, $5UG8I.logger).warn({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Callback state not found for ${callbackId}`);
            listeners.remove(listener.entityId);
        });
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `Callback execution complete for action: ${action}`);
    }
    cleanupAnimationCallbacks(action) {
        const actionType = $d782e74b2eaa8700$var$animationToAction(action);
        const listeners = this.actionCompleteListeners.get(actionType);
        if (listeners) {
            listeners.forEach((listener)=>{
                const callbackId = listener.callbackId;
                if (callbackId) this.cancelCallback(callbackId);
            });
            listeners.clear();
        }
    }
    changeDirection(newFacingDir) {
        const parts = this.action.split("-");
        const updated = `${parts[0]}-${newFacingDir}`;
        // Don't change direction during attack animations - let them complete
        if ($d782e74b2eaa8700$var$isAttackAnimation(this.action)) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Preventing direction change during attack: ${this.action} -> ${updated}`);
            return;
        }
        // Transfer callbacks to new direction animation
        this.transferCallbacksToNewAnimation(updated);
        this.activateAnimation(updated);
    }
    transferCallbacksToNewAnimation(newAnimation) {
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const newAction = $d782e74b2eaa8700$var$animationToAction(newAnimation);
        // Move callbacks from current action to new action
        const currentListeners = this.actionCompleteListeners.get(currentAction);
        if (currentListeners) {
            let newListeners = this.actionCompleteListeners.get(newAction);
            if (!newListeners) {
                newListeners = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
                this.actionCompleteListeners.set(newAction, newListeners);
            }
            // Transfer all listeners
            currentListeners.forEach((listener)=>{
                newListeners.add(listener);
            });
            currentListeners.clear();
        }
    }
    // Enhanced cleanup method
    cleanup() {
        // Same reasoning as the shadow below: drop the outline's ticker registration and its borrowed
        // texture reference before the generator reclaims the frames.
        this.highlight?.dispose();
        this.highlight = undefined;
        // Leave the shared maintenance ticker. Previously each sprite created its own 100ms + 10s
        // intervals that (if never cleared) fired for the rest of the session on every sprite ever
        // built; now the sprite just deregisters and the shared timers stop once the set is empty.
        if (this.registeredWithTicker) {
            $d782e74b2eaa8700$var$lpcSpriteMaintenanceTicker.unregister(this);
            this.registeredWithTicker = false;
        }
        // Stop tracking the (about-to-be-abandoned) animation textures and drop the borrowed
        // reference before the generator reclaims them, so the shadow never points at a dead texture.
        if (this.spriteShadowTicking) {
            (0, $3YyWq.Ticker).shared.remove(this.updateSpriteShadow);
            this.spriteShadowTicking = false;
        }
        if (this.spriteShadow) this.spriteShadow.texture = (0, $klOfb.Texture).EMPTY;
        // remove() only detaches the sprite, so the ring has to drop its live-tuning registration
        // here or a paperdoll rebuild would leave the old one registered forever.
        this.playerRing?.dispose();
        this.playerRing = undefined;
        // Release every clone this sprite adopted: destroys the clone display objects and drops
        // their cache references so the generator can reclaim baked textures once no live sprite
        // uses that loadout. Guards a late generate callback from re-adopting into a dead sprite.
        this.spriteReleased = true;
        // Dispose the display objects of adopted clones (refcount untouched -- keys are released just
        // below). abandon(), not release(), so we don't double-drop the key retained at request time.
        Object.keys(this.animations).forEach((action)=>{
            (0, $39fb998eb7d66fde$export$7100d33e089ec0).abandon(this.animations[action]);
        });
        this.animations = {};
        // Release the request-time key hold for EVERY action we prepared (adopted, still-loading, or
        // failed) -- balances the retainKey in doPreparation exactly once per prepared action.
        this.preparedActionKeys.forEach((key)=>(0, $39fb998eb7d66fde$export$7100d33e089ec0).releaseKey(key));
        this.preparedActionKeys.clear();
        // Cancel all pending callbacks
        this.activeCallbacks.forEach((callbackId)=>{
            this.cancelCallback(callbackId);
        });
        // Clear all data structures
        this.callbackStates.clear();
        this.activeCallbacks.clear();
        this.currentAnimationCallbacks.clear();
        this.actionCompleteListeners.clear();
    }
    // Override remove so discarding a sprite (paperdoll rebuild / fade-out both call remove(),
    // not destroy()) also tears down its timers and callbacks instead of leaking them.
    remove() {
        this.cleanup();
        super.remove();
    }
    // Override destroy method
    destroy() {
        this.cleanup();
        super.destroy();
    }
    // Periodic cleanup for orphaned callbacks. Public so the shared maintenance ticker can drive it.
    cleanupOrphanedCallbacks() {
        const now = Date.now();
        const maxAge = 30000 // 30 seconds
        ;
        this.callbackStates.forEach((state, callbackId)=>{
            if (state.status === "pending" && now - state.createdAt > maxAge) {
                console.warn("Cleaning up orphaned callback:", callbackId);
                this.cancelCallback(callbackId);
            }
        });
    }
    // Register for periodic callback maintenance on the shared ticker (idempotent).
    startCleanupTimer() {
        if (this.registeredWithTicker) return;
        this.registeredWithTicker = true;
        $d782e74b2eaa8700$var$lpcSpriteMaintenanceTicker.register(this);
    }
    // CRITICAL FIX: Ensure callbacks are set up for animations that are already loaded
    ensureCallbacksAreSetUp(animationName) {
        const action = $d782e74b2eaa8700$var$animationToAction(animationName);
        const listeners = this.actionCompleteListeners.get(action);
        if (listeners?.size() > 0) {
            const animationResult = this.animations[animationName];
            if (animationResult && animationResult.animation && !animationResult.animation.onFrameChange) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `CRITICAL FIX: Setting up missing onFrameChange for ${animationName}`);
                const animation = animationResult.animation;
                const totalFrames = animation.totalFrames;
                animation.onFrameChange = (frame)=>{
                    const pct = frame / (totalFrames - 1);
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Frame change (CRITICAL FIX): ${frame}/${totalFrames - 1} (${(pct * 100).toFixed(1)}%)`);
                    if (pct > 0.5) {
                        (0, $5UG8I.logger).debug({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Triggering callbacks (CRITICAL FIX) at ${(pct * 100).toFixed(1)}% completion`);
                        this.executeCallbacks(listeners, action);
                    }
                };
            }
        }
    }
    // FALLBACK: Check for missing callbacks and set them up. Public so the shared maintenance ticker
    // can drive it; early-returns cheaply when this sprite has no active callbacks.
    checkForMissingCallbacks() {
        if (this.activeCallbacks.size === 0) return; // No active callbacks to check
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const listeners = this.actionCompleteListeners.get(currentAction);
        if (listeners?.size() > 0) {
            const animationResult = this.animations[this.action];
            if (animationResult && animationResult.animation && !animationResult.animation.onFrameChange) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `FALLBACK: Detected missing onFrameChange for ${this.action}, setting up now`);
                const animation = animationResult.animation;
                const totalFrames = animation.totalFrames;
                animation.onFrameChange = (frame)=>{
                    const pct = frame / (totalFrames - 1);
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Frame change (FALLBACK): ${frame}/${totalFrames - 1} (${(pct * 100).toFixed(1)}%)`);
                    if (pct > 0.5) {
                        (0, $5UG8I.logger).debug({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Triggering callbacks (FALLBACK) at ${(pct * 100).toFixed(1)}% completion`);
                        this.executeCallbacks(listeners, currentAction);
                    }
                };
            }
        }
    }
    // CRITICAL FIX: Preserve listeners when changing animation directions for the same action
    preserveListenersForSameAction(newAnimation) {
        const newAction = $d782e74b2eaa8700$var$animationToAction(newAnimation);
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        // If we're changing to the same action, preserve listeners
        if (newAction === currentAction) // Don't clear listeners for the same action
        return;
        // For different actions, clean up current animation callbacks
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `Cleaning up callbacks for different action: ${currentAction} -> ${newAction}`);
        this.cleanupCurrentAnimationCallbacks();
    }
}



class $64e038f1765e0ab3$export$f3390963b1a1dc25 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entityId, loadObserver, isClientPlayer, isRemotePlayer){
        super(), // The body's frame height for this race (64 for a human), captured on build. getYOffset lifts
        // the entity by a fraction of its BODY, and must not read the container's measured bounds --
        // see getYOffset.
        this.bodyFrameHeight = 64, this.getClickSurface = ()=>{
            return this.clickArea;
        }, this.rebuildLayers = (entity)=>{
            const dimensions = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.dimensions(entity);
            const race = entity.appearance?.race;
            const sex = entity.appearance?.sex;
            const hair = entity.appearance?.hair;
            const nose = entity.appearance?.nose;
            const eyes = entity.appearance?.eyes;
            const weaponAction = (0, $bf6244e5cc9aa116$export$448f4eb18cb556ce)[entity?.weapon?.weaponType || "none"] || (0, $bf6244e5cc9aa116$export$2eff43e195cfa29d)[race];
            const descriptors = (0, $71594ae8b880a354$export$efde97289773c11d)({
                body: {
                    race: race,
                    sex: sex,
                    color: entity.appearance?.bodyColor
                },
                hair: hair ? {
                    component: hair,
                    color: entity.appearance?.hairColor
                } : undefined,
                nose: nose ? {
                    component: nose,
                    color: entity.appearance?.noseColor
                } : undefined,
                eyes: eyes ? {
                    component: eyes,
                    color: entity.appearance?.eyesColor
                } : undefined,
                ///////
                weapon: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$4c2157e8933c20e3)(entity.inventory, entity?.weapon?.weaponType)?.itemTypeMeta),
                pants: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "pants")),
                shirt: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shirt")),
                armor: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "armor")),
                shoes: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shoes")),
                shield: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shield")),
                cape: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "cape")),
                bauldron: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "bauldron"))
            });
            const all = [];
            descriptors.body?.forEach((next)=>all.push(next));
            const isHumanoid = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isHumanoid(race);
            if (isHumanoid) {
                descriptors.hair?.forEach((next)=>all.push(next));
                descriptors.nose?.forEach((next)=>all.push(next));
                descriptors.eyes?.forEach((next)=>all.push(next));
                descriptors.weapon?.forEach((next)=>all.push(next));
                descriptors.pants?.forEach((next)=>all.push(next));
                descriptors.shirt?.forEach((next)=>all.push(next));
                descriptors.armor?.forEach((next)=>all.push(next));
                descriptors.shoes?.forEach((next)=>all.push(next));
                descriptors.shield?.forEach((next)=>all.push(next));
                descriptors.cape?.forEach((next)=>all.push(next));
                descriptors.bauldron?.forEach((next)=>all.push(next));
            }
            const sortedDescriptors = all.sort((a, b)=>a.zIndex - b.zIndex);
            const id = race + " " + entity?.safeName();
            const priority = (0, $1e46c45e333c583b$export$e1d138f8777c998e).value === entity.entityId;
            const oldSprite = this.sprite;
            let loadObserver;
            if (this.loadObserver) {
                loadObserver = this.loadObserver;
                oldSprite?.remove();
            } else if (oldSprite) loadObserver = new (0, $d782e74b2eaa8700$export$7e6fc99bfa4004f1)(()=>{
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(oldSprite, {
                    releaseCallback: ()=>{
                        oldSprite?.remove();
                    },
                    fadeAlphaDecrement: 0.05
                }).update();
            });
            loadObserver?.clear();
            this.sprite = new (0, $d782e74b2eaa8700$export$db88fc637337eefb)({
                attackAction: weaponAction,
                angle: entity.movement.angle,
                descriptors: sortedDescriptors,
                hasHalo: this.halo,
                hasShadow: isHumanoid,
                // The ring says "a person is driving this". An INVADER is a person driving one of the
                // camp's own attackers, and the whole point of the body is that the defender cannot tell
                // -- so it is withheld. If the marked variant of the design wins instead, this is where a
                // hostile-coloured ring goes, and "the ring ignites on breaking out" is the concealment
                // variant's reveal (see docs/ember-the-fallen-design.md).
                hasPlayerRing: this.remotePlayer && !entity.invading,
                id: id,
                priority: priority,
                loadObserver: loadObserver,
                isSubmerged: this.submerged,
                defaultAction: (0, $71594ae8b880a354$export$68fee8ec0f096607)(entity.appearance)
            });
            this.sprite.initalize(id, entity.movement.angle);
            this.haloObject = this.sprite.halo;
            const raceDimensions = (0, $71594ae8b880a354$export$b2ae80db0884a5f7)[entity?.appearance?.race] || {
                w: 64,
                h: 64
            };
            const renderable = this.sprite;
            renderable.x = -raceDimensions.w / 2;
            renderable.y = -raceDimensions.h / 2;
            this.bodyFrameHeight = raceDimensions.h;
            this.addChild(this.sprite);
            if (this.clickArea.parent) this.clickArea.parent.removeChild(this.parentArea);
            this.clickArea.clear();
            this.clickArea.beginFill(0xff0000, 0.0001);
            this.clickArea.drawRect(0, 0, dimensions.w, dimensions.h);
            this.clickArea.x = -dimensions.w / 2;
            this.clickArea.y = -dimensions.h / 2 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
            this.clickArea.endFill();
            this.addChild(this.clickArea);
            if (this.haloObject) this.updateHaloColor(entity.hp, entity.maxHp);
        }, this.fragment = (entity)=>{
            this.sprite?.fragment(entity);
            this.drawableSurface.fragment(entity);
        }, this.onMouseOver = (show)=>{
            this.hud.onMouseOver(show);
        }, // Pose-accurate hover outline. The glow belongs to the sprite, which is the only thing that knows
        // which baked frame is on screen this instant and which carries the oversize offsets the outline
        // has to inherit -- and it is replaced wholesale on a paperdoll rebuild, so the highlight has to
        // live and die with it. A composite with no sprite yet (or none at all) reports false, and the
        // caller outlines whatever map tiles stand in for it.
        this.setHighlighted = (on)=>{
            if (!this.sprite) return false;
            this.sprite.setHighlighted(on);
            return true;
        }, this.setWorldOverlayItem = (item)=>{
            this.worldOverlayItem = item;
            this.worldOverlayItem.addChild(this.hud);
        };
        this.entityId = entityId;
        this.remotePlayer = isRemotePlayer === true;
        this.clickArea = new (0, $a64b70167386625f$export$98e91636974d835d)();
        this.loadObserver = loadObserver;
        this.hud = new (0, $1d5c2742ca857d0e$export$5ef96c383b67a5e2)(0xffffff, {
            renderActions: {},
            alwaysShowLabel: false
        }, this.clickArea, isClientPlayer);
        this.drawableSurface = new (0, $a64b70167386625f$export$98e91636974d835d)();
        this.animatedFeedback = new (0, $5f817afe83d87a88$export$9ec831f4c1f089b1)();
        // The ColorMatrixFilter is only needed for the brief damage flash. A filtered display
        // object is rendered into its own framebuffer and cannot batch with its neighbours, so
        // leaving it attached costs an offscreen render pass per character every frame. Attach it
        // only while flashing (see doDamaged) and detach it afterwards.
        this.colorMatrix = new (0, $1avo5.filters).ColorMatrixFilter();
    }
    doMovement(entity) {
        this.sprite?.doMovement(entity);
        this.drawableSurface.doMovement(entity);
    }
    update(hp, hpMax) {
        this.hud.update(hp, hpMax);
        this.updateHaloColor(hp, hpMax);
    }
    updateName(name) {
        this.hud.updateName(name);
    }
    recolor(color) {
        this.hud.recolor(color);
    }
    updateHaloColor(hp, hpMax) {
        if (!this.haloObject) return;
        const hpPct = hp / hpMax;
        if (hpPct < 0.7) {
            if (hpPct < 0.4) this.haloObject.tint = 0xff0000;
            else this.haloObject.tint = 0xffa500;
        } else this.haloObject.tint = 0x00ff00;
    }
    updateBlinking(blinking) {
        if (!blinking) {
            this.visible = true;
            if (this.blinkingInterval) {
                clearInterval(this.blinkingInterval);
                this.blinkingInterval = null;
            }
        } else {
            if (this.blinkingInterval) return;
            this.blinkingInterval = setInterval(()=>{
                this.visible = !this.visible;
            }, 100);
        }
    }
    addTag() {
        this.hud.addTag();
    }
    removeTag() {
        this.hud.removeTag();
    }
    updateLevel(level) {
        this.hud.updateLevel(level);
    }
    doAttack(entity, callback) {
        this.sprite?.doAttack(entity, callback);
    }
    doDamaged(entity) {
        this.sprite?.doDamaged(entity);
        // Attach the filter only for the duration of the flash, then detach it so the character
        // batches normally again (see constructor).
        this.filters = [
            this.colorMatrix
        ];
        this.colorMatrix.blackAndWhite(true);
        this.colorMatrix.contrast(1, true);
        this.colorMatrix.saturate(1, true);
        // Guard against overlapping hits resetting the flash early.
        if (this.damageFlashTimeout !== undefined) clearTimeout(this.damageFlashTimeout);
        this.damageFlashTimeout = setTimeout(()=>{
            this.colorMatrix.reset();
            this.filters = null;
            this.damageFlashTimeout = undefined;
        }, 100);
    }
    // Called on entity removal (EntityRenderingManager.destroy). Cascades teardown into the inner
    // sprite -- which clears its cleanup timers and releases its generator clones -- and clears
    // this wrapper's own timers. Without this, entity removal (the common discard path, distinct
    // from a paperdoll rebuild) leaked both.
    cleanup() {
        if (this.rebuildTimeout !== undefined) {
            clearTimeout(this.rebuildTimeout);
            this.rebuildTimeout = undefined;
        }
        if (this.damageFlashTimeout !== undefined) {
            clearTimeout(this.damageFlashTimeout);
            this.damageFlashTimeout = undefined;
        }
        if (this.blinkingInterval) {
            clearInterval(this.blinkingInterval);
            this.blinkingInterval = null;
        }
        this.sprite?.cleanup();
        this.hud?.cleanup();
    }
    spoke(message, options) {
        this.hud.spoke(message, options);
    }
    releaseHeldSpeech() {
        this.hud.releaseHeldSpeech();
    }
    getDrawableSurface() {
        return this.drawableSurface.getDrawableSurface();
    }
    updatePaperdoll(entity) {
        if (!entity) return;
        const { appearance: appearance } = entity;
        if (!appearance) return;
        if (this.rebuildTimeout !== undefined) clearTimeout(this.rebuildTimeout);
        // console.trace()
        this.rebuildTimeout = setTimeout(()=>{
            this.rebuildLayers(entity);
            this.rebuildTimeout = undefined;
        }, 250);
    }
    // Possession happens to a sprite that already exists -- the player is standing there and then
    // they are wearing a skeleton -- so the ring has to be answerable after construction too, not
    // only when the layers are rebuilt from scratch.
    updatePlayerRing(entity) {
        this.sprite?.setPlayerRingVisible(!!this.remotePlayer && !entity?.invading);
    }
    updateHalo(entity, enabled) {
        this.halo = enabled;
        this.updatePaperdoll(entity);
        if (this.haloObject) this.updateHaloColor(entity.hp, entity.maxHp);
    }
    updateSpeed(factor) {
    //
    }
    updatePointerIcon(show, angle) {
        this.hud.updatePointerIcon(show, angle);
    }
    itemPickedUp(entity, itemTypeMeta, quantity) {
        this.feedback(entity, itemTypeMeta.spriteId || `${itemTypeMeta.type}-${itemTypeMeta.color}.png`, quantity > 0 ? `+${quantity}` : "", {
            font: "EntityImportantFont",
            color: 0x00ff00
        });
    }
    // Floating feedback over this body: a pickup icon, a damage number, the "!!!" alert. A running
    // body's dust trail does NOT come through here -- it is ground art that has to z-sort against
    // other entities, which nothing parented into the overlay can do. EntityRenderingManager.feedback
    // routes `type: "foot"` to FootDust before it ever reaches a renderable.
    feedback(entity, image, label, params) {
        this.animatedFeedback.setup(0, this.worldOverlayItem.height / 2, image, label, this.worldOverlayItem, params, this.sprite);
    }
    updateSigil(sigil) {
        this.hud.updateSigil(sigil);
    }
    updateRole(role) {
        this.hud.updateRole(role);
    }
    // A small lift so the body sits on its tile rather than in the middle of it. Deliberately
    // derived from the RACE's body frame and not from `this.height`, which is a bounds query over
    // the whole container: an oversize weapon swaps a 192x192 slash frame in for the 64x64 one, so
    // a height-derived lift hoisted the entity ~13px into the air for the length of every swing and
    // dropped it back afterwards -- shadow and all, since they share this container. (The generator's
    // old -51.25 oversize offset was 12.75 short of the geometrically correct -64 precisely to cancel
    // this; both are fixed now, each in the right place.) The measured height also drifts frame to
    // frame with the projected shadow's silhouette, which this avoids too.
    getYOffset() {
        return -this.bodyFrameHeight * 0.1;
    }
    updateSubmerged(submerged) {
        this.submerged = submerged;
    }
    updateAfk(afk) {
        if (this.sprite) this.sprite.alpha = afk ? 0.3 : 1.0;
    }
    updateActivation(entity, active) {
        if (!this.sprite) return;
        this.sprite.activateAnimation(active ? "activate" : "deactivate");
    }
}



class $e97a9ef66e2e5f53$export$8653a30c44b6e879 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff0000, size = 10, alpha = 1.0){
        super();
        super.beginFill(color, alpha);
        super.lineStyle(size, color, alpha);
        super.drawCircle(1, 1, 2);
        super.endFill();
    }
}



class $0ecb2be6c709254f$export$2d9ac7aa84f97a08 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff, rotating){
        super();
        super.lineStyle(1, color);
        super.beginFill(color);
        super.drawRect(-10, 0, 25, 5);
        super.lineStyle(1, color);
        super.beginFill(color);
        super.drawRect(0, -10, 5, 25);
        super.endFill();
        let angle = 0;
        if (rotating) setInterval(()=>{
            if (angle > 360) angle = 0;
            this.angle = angle;
            angle++;
        }, 50);
    }
}


parcelRequire("1avo5");
var $hnGDn = parcelRequire("hnGDn");

class $a326659fb0a13e91$export$b0c249583f27a2b9 extends (0, $15caf4b106aaadb3$export$5a33d6de29791ec5) {
    constructor(spriteMeta){
        super(spriteMeta);
        this.labelText = new (0, $hnGDn.BitmapText)("", {
            fontName: "SignFont",
            align: "center"
        });
        this.labelText.visible = false;
        this.labelText.x = -this.container.width * 0.23;
        this.labelText.y = -this.container.height * 0.3;
        this.addChild(this.labelText);
    }
    updateName(name) {
        if (name) {
            this.labelText.text = name.replace(/ /g, "\n");
            this.labelText.visible = true;
        } else this.labelText.visible = false;
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");

/**
 * The dust a running body kicks up (ENTITY_FEEDBACK `type: "foot"` -- a player holding the boost
 * key, or an NPC rushing a target).
 *
 * WHY THIS IS ITS OWN EFFECT. The trail used to be built by the generic AnimatedFeedback, which
 * parents everything it makes into the WORLD OVERLAY surface -- the layer that carries nameplates
 * and chat bubbles, added to the stage after the world and therefore drawn on top of every entity
 * in the room. That is right for a nameplate and wrong for dust: a runner heading SOUTH leaves its
 * trail to the north of itself, where the puffs have to be drawn BEHIND the body, and they were
 * drawn in front of it instead (and over every other character they passed). Nothing about the old
 * placement could be tuned into the right answer, because the overlay has no relationship to the
 * entity z-order at all. So the trail lives here, in the world surface, where each puff is an
 * ordinary z-sorted sibling of the bodies it has to interleave with.
 *
 * WHAT MAKES IT READ AS KICKED-UP DUST rather than as a sprite playing over the runner. Three
 * things, none of which the old version did:
 *
 *   FOOTFALLS, NOT A COLUMN. Puffs come off alternating feet, offset PERPENDICULAR to the direction
 *   of travel. One emission point dead-centre on the body draws a single column of stamps; two
 *   interleaved tracks read as something a pair of shoes did.
 *
 *   KICKED BACKWARDS, NOT RISING. Each puff is thrown along the ground opposite the run and
 *   decelerates into stillness (exponential drag), so it falls behind the runner and settles where
 *   it landed. Separately -- and this is the part that needs the 3/4 view taken seriously -- it has
 *   a HEIGHT that is tracked apart from its ground position: `lift` moves the drawn sprite up the
 *   screen while `groundY` stays put, so a rising puff does not slide backwards out of its own
 *   footprint, and it still sorts against bodies by the patch of ground it came off.
 *
 *   DIFFUSING, NOT STAMPED. It fades in over the first tenth of its life, grows to about 1.7x, and
 *   fades out on a curve. Size, lifetime, tint, spin and kick are all jittered per puff, so a run
 *   never shows the same puff twice.
 *
 * The art is baked here rather than shipped (the pattern wind_leaves and butterflies established):
 * white lumps generated once, tinted per puff off an earth palette, which is what lets one texture
 * serve the whole trail and batch into a single draw call. The shipped `dust` spritesheet it
 * replaces was an 8-frame burst of 1px GREY specks that popped symmetrically outward -- a pop, not
 * a kick, and grey flecks on grass at that.
 *
 * NOTHING HERE USES A TIMER. One update() off the render loop advances every puff of every trail
 * and decides when the next footfall lands. That matters twice over: a dozen rushing NPCs would
 * otherwise each hold a setTimeout chain plus one setInterval per live puff, and in a backgrounded
 * tab (rAF throttled to zero) the timers would keep emitting into a world nobody is drawing.
 */ // How far BELOW `entity.location.y` an LPC humanoid's soles are drawn: location.y lands around the
// hips, not on the floor. A puff is kicked up by a shoe, so it is laid down at the feet -- but
// sorted on the hip line, which is the line every entity in the surface sorts by. Positioning at the
// feet and sorting at the hip is the whole trick; sorting at the feet instead would draw the dust in
// front of its own runner from the waist down.
const $f63df80eccdeeea6$var$FOOT_DROP = 20;
// Dust comes off the back of the heel, so a puff sorts just behind whatever is standing on the same
// patch of ground. It only decides anything in the instant a puff is born, when it and the runner
// share a sort line; after that each one sorts on its own ground position.
const $f63df80eccdeeea6$var$BEHIND_THE_HEELS = 1;
// One footfall per this many ms, alternating feet. Roughly a stride at run speed.
const $f63df80eccdeeea6$var$FOOTFALL_MS = 105;
// A trail normally ends on the matching `action: "remove"` (BOOST_ACTION_OFF, or a rushing NPC
// arriving). Nothing guarantees that event lands -- it is a distance-filtered broadcast, and the
// runner can be culled or leave the room mid-stride -- so a trail also expires by itself.
const $f63df80eccdeeea6$var$TRAIL_MAX_MS = 1500;
// Emission is driven off the render loop, so a backgrounded tab (or a long frame) can hand us a gap
// of seconds. Past this many footfalls' worth we skip the backlog rather than burst-emitting it.
const $f63df80eccdeeea6$var$MAX_FOOTFALL_CATCHUP = 4;
// A frame longer than this is a stall, not motion; clamp it so nothing teleports on the way back.
const $f63df80eccdeeea6$var$MAX_FRAME_SECONDS = 0.05;
// Where a footfall lands relative to the body: half the gap between the two feet, across the
// direction of travel, and a little behind the body's centre where the pushing foot actually is.
const $f63df80eccdeeea6$var$FOOT_SPREAD = 4.5;
const $f63df80eccdeeea6$var$HEEL_SETBACK = 3;
// The kick, in world px/sec along the ground, opposite the run. GROUND_DRAG is an e-fold per second:
// at 5.5 a puff has spent most of its travel inside 200ms, so the trail's spacing comes from the
// runner moving on rather than from the dust flying.
const $f63df80eccdeeea6$var$KICK = 34;
const $f63df80eccdeeea6$var$KICK_MIN = 0.65;
const $f63df80eccdeeea6$var$KICK_MAX = 1.35;
const $f63df80eccdeeea6$var$GROUND_DRAG = 5.5;
// How far off straight-backwards a puff may be thrown, in radians either way.
const $f63df80eccdeeea6$var$KICK_SPREAD = 0.5;
// Height off the ground, which is tracked and drawn separately from the ground position (see above).
const $f63df80eccdeeea6$var$LIFT = 15;
const $f63df80eccdeeea6$var$LIFT_DRAG = 3.4;
// Per-puff jitter ranges.
const $f63df80eccdeeea6$var$SCALE_MIN = 0.42;
const $f63df80eccdeeea6$var$SCALE_MAX = 0.62;
const $f63df80eccdeeea6$var$GROWTH_MIN = 1.5;
const $f63df80eccdeeea6$var$GROWTH_MAX = 2.0;
const $f63df80eccdeeea6$var$ALPHA_MIN = 0.5;
const $f63df80eccdeeea6$var$ALPHA_MAX = 0.78;
const $f63df80eccdeeea6$var$SPIN = 0.6;
const $f63df80eccdeeea6$var$LIFE_MS = 520;
const $f63df80eccdeeea6$var$LIFE_JITTER = 0.3;
// Fraction of its life a puff holds full opacity for before it starts fading.
const $f63df80eccdeeea6$var$FADE_AFTER = 0.42;
// Fraction of its life it fades IN over, so it diffuses into being instead of popping.
const $f63df80eccdeeea6$var$FADE_IN = 0.1;
// Extra, smaller motes thrown with each footfall. One is enough to break the silhouette up; the
// difference between a single lump and a lump with a mote beside it is most of the irregularity.
const $f63df80eccdeeea6$var$SATELLITES = 1;
const $f63df80eccdeeea6$var$SATELLITE_SCALE = 0.55;
// Dry earth catching the light. Varied per puff rather than per trail, for grain.
const $f63df80eccdeeea6$var$TINTS = [
    0xd8caa8,
    0xc4b494,
    0xb3a384,
    0xe3d8bd
];
// Total live puffs across every trail. A wave of rushing NPCs is the case this exists for: they all
// kick dust at once, and the trail is ambience -- dropping the newest puff is invisible, a frame
// spent on four hundred sprites is not.
const $f63df80eccdeeea6$var$MAX_PUFFS = 220;
const $f63df80eccdeeea6$var$between = (min, max)=>min + Math.random() * (max - min);
class $f63df80eccdeeea6$export$ab8cf330af9aa032 {
    constructor(surface, makeTextures){
        this.textures = [];
        this.trails = new Map();
        this.puffs = [];
        // Begin (or restart) the trail under `entity`. `params.duration` sets the base puff lifetime;
        // the art is baked here, so the event's `image` is not looked up.
        this.start = (entity, params = {}, nowMs = performance.now())=>{
            // A second start while one is already running -- an NPC that re-rushes without arriving --
            // replaces the emitter rather than stacking a second one onto the same entity.
            this.stop(entity.entityId);
            this.trails.set(entity.entityId, {
                entity: entity,
                roomId: entity.roomId,
                startedMs: nowMs,
                nextFootfallMs: nowMs,
                side: Math.random() < 0.5 ? 1 : -1,
                lifeMs: params?.duration || $f63df80eccdeeea6$var$LIFE_MS
            });
        };
        // Stop emitting under `entity`. Puffs already on the ground are left to settle and fade -- dust
        // does not vanish the moment a runner stops running.
        this.stop = (entityId)=>{
            this.trails.delete(entityId);
        };
        // Stop emitting AND take the trail off the surface now. For an entity being destroyed, or one
        // that changed rooms: its dust belongs to a patch of ground that is no longer on screen.
        this.remove = (entityId)=>{
            const trail = this.trails.get(entityId);
            this.stop(entityId);
            if (!trail) return;
            const emitter = trail.entity.entityId;
            this.puffs = this.puffs.filter((puff)=>{
                if (puff.emitterId !== emitter) return true;
                this.retire(puff);
                return false;
            });
        };
        // Exposed for tests: puffs currently on the surface.
        this.activeCount = ()=>this.puffs.length;
        /**
     * Lay down any footfalls that have come due and advance every live puff. Called once per drawn
     * frame (EntityRenderingManager.endFrame), which is also what pauses the whole effect in a
     * backgrounded tab rather than letting it emit into a world nobody is drawing.
     */ this.update = (nowMs = performance.now())=>{
            if (this.lastMs === undefined) {
                this.lastMs = nowMs;
                return;
            }
            const dt = Math.min((nowMs - this.lastMs) / 1000, $f63df80eccdeeea6$var$MAX_FRAME_SECONDS);
            this.lastMs = nowMs;
            this.emit(nowMs);
            this.advance(nowMs, dt);
        };
        this.emit = (nowMs)=>{
            this.trails.forEach((trail, entityId)=>{
                const entity = trail.entity;
                if (entity.roomId !== trail.roomId) {
                    this.remove(entityId);
                    return;
                }
                if (nowMs - trail.startedMs > $f63df80eccdeeea6$var$TRAIL_MAX_MS) {
                    this.stop(entityId);
                    return;
                }
                // A stalled frame (or a tab coming back) can leave several footfalls due at once. Lay
                // down one and skip the backlog -- emitting it would dump a clump of dust on one spot.
                if (nowMs - trail.nextFootfallMs > $f63df80eccdeeea6$var$FOOTFALL_MS * $f63df80eccdeeea6$var$MAX_FOOTFALL_CATCHUP) trail.nextFootfallMs = nowMs;
                while(nowMs >= trail.nextFootfallMs){
                    this.footfall(trail, nowMs);
                    trail.nextFootfallMs += $f63df80eccdeeea6$var$FOOTFALL_MS;
                }
            });
        };
        // One foot hitting the ground: a lump of dust under the shoe, plus a smaller mote beside it.
        this.footfall = (trail, nowMs)=>{
            const entity = trail.entity;
            // The direction of travel. `movement.angle` points the way the body is going (+y is south),
            // and is maintained for remote entities too -- the interpolator stamps it off the position
            // buffer -- so a trail behind another player is thrown the right way as well.
            const angle = entity.movement?.angle ?? 0;
            const travelX = Math.cos(angle);
            const travelY = Math.sin(angle);
            // Across the run, for the gap between the two feet.
            const acrossX = -travelY;
            const acrossY = travelX;
            const side = trail.side;
            trail.side = -side;
            const footX = entity.location.x + acrossX * $f63df80eccdeeea6$var$FOOT_SPREAD * side - travelX * $f63df80eccdeeea6$var$HEEL_SETBACK;
            const footGroundY = entity.location.y + $f63df80eccdeeea6$var$FOOT_DROP + acrossY * $f63df80eccdeeea6$var$FOOT_SPREAD * side - travelY * $f63df80eccdeeea6$var$HEEL_SETBACK;
            // The emitter's own sort line, minus its ground position: carrying the race class rather
            // than the position is what lets each puff sort on the ground it actually settles on.
            const zBase = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateZIndexBoost(entity) - entity.location.y - $f63df80eccdeeea6$var$FOOT_DROP;
            this.spawn(trail, nowMs, footX, footGroundY, travelX, travelY, zBase, 1);
            for(let i = 0; i < $f63df80eccdeeea6$var$SATELLITES; i++)this.spawn(trail, nowMs, footX, footGroundY, travelX, travelY, zBase, $f63df80eccdeeea6$var$SATELLITE_SCALE);
        };
        this.spawn = (trail, nowMs, x, groundY, travelX, travelY, zBase, sizeFactor)=>{
            if (this.puffs.length >= $f63df80eccdeeea6$var$MAX_PUFFS) return;
            const texture = this.texture();
            if (!texture) return;
            // Thrown backwards along the ground, fanned off straight-back so a trail is not a ruler line.
            const spread = $f63df80eccdeeea6$var$between(-$f63df80eccdeeea6$var$KICK_SPREAD, $f63df80eccdeeea6$var$KICK_SPREAD);
            const speed = $f63df80eccdeeea6$var$KICK * $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$KICK_MIN, $f63df80eccdeeea6$var$KICK_MAX);
            const kickX = -(travelX * Math.cos(spread) - travelY * Math.sin(spread)) * speed;
            const kickY = -(travelX * Math.sin(spread) + travelY * Math.cos(spread)) * speed;
            const sprite = new (0, $7Bs2Z.Sprite)(texture);
            // Most of the lump sits above the point it is pinned to, so it reads as sitting ON the
            // ground rather than straddling it, and it grows from there.
            sprite.anchor.set(0.5, 0.7);
            sprite.tint = $f63df80eccdeeea6$var$TINTS[Math.floor(Math.random() * $f63df80eccdeeea6$var$TINTS.length)];
            sprite.alpha = 0;
            sprite.rotation = Math.random() * Math.PI * 2;
            this.surface.addChild(sprite);
            const puff = {
                sprite: sprite,
                emitterId: trail.entity.entityId,
                x: x,
                groundY: groundY,
                lift: 0,
                vx: kickX,
                vy: kickY,
                liftV: $f63df80eccdeeea6$var$LIFT * $f63df80eccdeeea6$var$between(0.7, 1.3),
                bornMs: nowMs,
                lifeMs: trail.lifeMs * $f63df80eccdeeea6$var$between(1 - $f63df80eccdeeea6$var$LIFE_JITTER, 1 + $f63df80eccdeeea6$var$LIFE_JITTER),
                zBase: zBase,
                scale: $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$SCALE_MIN, $f63df80eccdeeea6$var$SCALE_MAX) * sizeFactor,
                growth: $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$GROWTH_MIN, $f63df80eccdeeea6$var$GROWTH_MAX),
                alpha: $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$ALPHA_MIN, $f63df80eccdeeea6$var$ALPHA_MAX),
                spin: $f63df80eccdeeea6$var$between(-$f63df80eccdeeea6$var$SPIN, $f63df80eccdeeea6$var$SPIN)
            };
            this.puffs.push(puff);
            this.draw(puff, 0);
        };
        this.advance = (nowMs, dt)=>{
            // Exponential decay: the kick is spent in the first fraction of a second and the puff settles
            // where it landed, instead of coasting at a constant speed for its whole life.
            const groundDrag = Math.exp(-$f63df80eccdeeea6$var$GROUND_DRAG * dt);
            const liftDrag = Math.exp(-$f63df80eccdeeea6$var$LIFT_DRAG * dt);
            let write = 0;
            for(let i = 0; i < this.puffs.length; i++){
                const puff = this.puffs[i];
                const elapsed = (nowMs - puff.bornMs) / puff.lifeMs;
                if (elapsed >= 1) {
                    this.retire(puff);
                    continue;
                }
                puff.x += puff.vx * dt;
                puff.groundY += puff.vy * dt;
                puff.lift += puff.liftV * dt;
                puff.vx *= groundDrag;
                puff.vy *= groundDrag;
                puff.liftV *= liftDrag;
                puff.sprite.rotation += puff.spin * dt;
                this.draw(puff, elapsed);
                this.puffs[write++] = puff;
            }
            this.puffs.length = write;
        };
        this.draw = (puff, elapsed)=>{
            const sprite = puff.sprite;
            sprite.x = puff.x;
            sprite.y = puff.groundY - puff.lift;
            sprite.zIndex = puff.zBase + puff.groundY - $f63df80eccdeeea6$var$BEHIND_THE_HEELS;
            // Grows fastest early, the way a puff of anything diffuses.
            const eased = 1 - (1 - elapsed) * (1 - elapsed);
            sprite.scale.set(puff.scale * (1 + (puff.growth - 1) * eased));
            if (elapsed < $f63df80eccdeeea6$var$FADE_IN) sprite.alpha = puff.alpha * (elapsed / $f63df80eccdeeea6$var$FADE_IN);
            else if (elapsed < $f63df80eccdeeea6$var$FADE_AFTER) sprite.alpha = puff.alpha;
            else {
                const out = (elapsed - $f63df80eccdeeea6$var$FADE_AFTER) / (1 - $f63df80eccdeeea6$var$FADE_AFTER);
                sprite.alpha = puff.alpha * (1 - out * out);
            }
        };
        this.retire = (puff)=>{
            this.surface.removeChild(puff.sprite);
            puff.sprite.destroy();
        };
        // Baked on the first puff rather than at construction: the renderer may not be able to generate
        // a texture yet (and in a test there is no GPU at all), and a trail that silently never appears
        // is worse than one drawn with a plain white blob.
        this.texture = ()=>{
            if (!this.textures.length) {
                try {
                    this.textures = this.makeTextures();
                } catch (e) {
                    this.textures = [];
                }
                if (!this.textures.length) this.textures = [
                    (0, $klOfb.Texture).WHITE
                ];
            }
            return this.textures[Math.floor(Math.random() * this.textures.length)];
        };
        this.surface = surface;
        this.makeTextures = makeTextures;
    }
    static{
        /**
     * The puff art: three white lumps, each built from overlapping soft ellipses, which every puff
     * then tints off the earth palette. White art is what makes one texture serve the whole palette
     * (tint multiplies), and three silhouettes is enough that the eye stops reading a repeated stamp
     * while all three still batch together.
     *
     * The softness is BAKED, three nested ellipses per blob rather than a blur filter: a filtered
     * display object renders into its own framebuffer and cannot batch with its neighbours, which
     * would be an offscreen pass per puff with a dozen of them on screen.
     *
     * Drawn oversized and scaled down per puff, at resolution 2 to match the world surface's 2x zoom,
     * so the edges stay smooth instead of showing the blocky diagonal of a 10px sprite. Each lump is
     * wider than it is tall: dust spreads along the ground, and the ground is seen at an angle.
     */ this.buildPuffTextures = (generate)=>{
            // [cx, cy, rx, ry] blobs per lump: a round one, a long low one, and a small wisp.
            const lumps = [
                [
                    [
                        0,
                        0,
                        7,
                        4.8
                    ],
                    [
                        -4.5,
                        1.4,
                        4.6,
                        3.4
                    ],
                    [
                        4,
                        -1,
                        5,
                        3.6
                    ]
                ],
                [
                    [
                        0,
                        0,
                        8,
                        4.4
                    ],
                    [
                        -5,
                        0.6,
                        4,
                        2.8
                    ],
                    [
                        4.6,
                        1,
                        3.4,
                        2.4
                    ]
                ],
                [
                    [
                        0,
                        0,
                        5.4,
                        4
                    ],
                    [
                        3,
                        -2,
                        3.6,
                        2.8
                    ]
                ]
            ];
            return lumps.map((blobs)=>{
                const g = new (0, $gwPoJ.Graphics)();
                blobs.forEach(([cx, cy, rx, ry])=>{
                    // Faint halo, body, dense core. Overlapping blobs compound where they meet, which is
                    // what gives a lump an uneven inside rather than a flat disc.
                    g.beginFill(0xffffff, 0.22);
                    g.drawEllipse(cx, cy, rx, ry);
                    g.endFill();
                    g.beginFill(0xffffff, 0.45);
                    g.drawEllipse(cx, cy, rx * 0.68, ry * 0.68);
                    g.endFill();
                    g.beginFill(0xffffff, 0.9);
                    g.drawEllipse(cx, cy, rx * 0.36, ry * 0.36);
                    g.endFill();
                });
                const texture = generate(g);
                g.destroy();
                return texture;
            });
        };
    }
    static{
        // The default texture factory, bound to a live pixi renderer. Split from buildPuffTextures so the
        // trail can be driven in a test without a GPU.
        this.textureFactory = (renderer)=>()=>$f63df80eccdeeea6$export$ab8cf330af9aa032.buildPuffTextures((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}


// How long an entity stays "pointed at" after the pointer leaves it. There are no interaction icons
// to travel onto any more, but the grace period still absorbs the pointer flicking across a gap in
// an entity's hit area, and it keeps the hide self-healing if a pointer-out event is ever dropped.
const $3de7f2d858d8583e$var$INTERACTION_HOVER_GRACE_MS = 150;
// Touch has no hover, so the interactable nearest the player is focused instead: it takes the same
// outline the pointer would give it, which is the only cue a tap has anything to activate. Recomputed
// on this interval rather than per frame -- it walks the room's interactable entities.
const $3de7f2d858d8583e$var$FOCUS_SCAN_INTERVAL_MS = 200;
// How close the player has to be for an entity to become the focused one. Generous compared with the
// server's own reach checks (1.5-2 tiles), so the outline appears slightly before the interaction
// would actually succeed rather than after.
const $3de7f2d858d8583e$var$FOCUS_RANGE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2.5;
const $3de7f2d858d8583e$export$7250836c183fa0a2 = [
    "move",
    "idle",
    "attack"
];
class $3de7f2d858d8583e$export$b797a3cc601f36f1 {
    constructor(surface, minimapSurface, worldOverlaySurface, logic, clientRenderer, app){
        this.entityIdToRenderable = {};
        this.localEntityMetaCache = {};
        // Last interaction list the server told us about, keyed by entityId and cached
        // independently of the renderable. The list can arrive (proactive broadcast or the
        // response to a hover re-request) before the client has built the entity's renderable,
        // so it is stashed here and applied whenever the renderable turns up. This cache is also
        // what decides, locally and with no round trip, what a tap on the entity does: see
        // resolveInteractions in game-common and PlayerController's press arbitration.
        this.entityIdToInteractions = {};
        this.lastFocusScanTs = 0;
        this.lights = new (0, $cb689cfa16c444ba$export$ccc1bed6c7489102)();
        // A renderable is only ever hidden by render(), and the render loop only calls render() for
        // the entities in that frame's culled set. An entity that leaves the set between two frames --
        // it wandered out of the viewport, or the follow-cam PiP stopped feeding its neighborhood --
        // was therefore never told to hide, and its sprite stayed drawn at the position it was last
        // rendered at while the real entity moved on: the "ghost" NPC. These two sets let
        // beginFrame/endFrame hide anything that was on screen last frame and went unrendered this one.
        this.shownEntityIds = new Set();
        this.renderedThisFrame = new Set();
        this.init = ()=>{
        // noop, todo?
        };
        this.cacheEntity = (entity)=>{
            const item = {
                name: entity.name,
                color: entity.color,
                hp: entity.hp,
                hunger: entity.hunger,
                maxHunger: entity.maxHunger,
                maxHp: entity.maxHp,
                mana: entity.mana,
                visible: entity.visible,
                level: 0,
                speed: entity.speed,
                joinedTeam: undefined,
                paralyzeUntilTs: entity.paralyzeUntilTs,
                upgradePoints: entity.upgradePoints,
                apperanceKey: this.computeAppearanceKey(entity),
                weaponType: entity.weapon?.weaponType,
                x: entity.location.x,
                y: entity.location.y,
                expirationTs: entity.expirationTs,
                clickable: entity.clickable,
                quantity: entity.quantity,
                leaderEntityId: entity.leaderEntityId
            };
            this.localEntityMetaCache[entity.entityId] = item;
            return item;
        };
        this.computeAppearanceKey = (entity)=>{
            return `${entity.submerged}-` + `${entity?.weapon?.weaponType}-` + `${entity?.appearance?.race}-` + `${entity?.appearance?.sex}-` + `${entity?.appearance?.hair}-` + `${entity?.appearance?.inventoryAppearanceHash}`;
        };
        this.isPaperdollDifferent = (cachedEntity, entity)=>{
            return cachedEntity.apperanceKey !== this.computeAppearanceKey(entity);
        };
        this.renderEntity = (entity, meta)=>{
            let renderable;
            switch(entity.npcType){
                case "flag":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: entity.color,
                        name: "flag",
                        scale: 0.6,
                        animated: true
                    });
                    break;
                case "spawner":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        name: "spawner",
                        scale: 2.0,
                        animated: true
                    });
                    break;
                case "bomb":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        name: "bomb.png",
                        scale: 1.0,
                        animated: false,
                        rotating: true,
                        ...meta || {}
                    });
                    break;
                case "emp":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        name: "emp.png",
                        scale: 1.0,
                        animated: false,
                        rotating: true
                    });
                    break;
                case "sign":
                    renderable = new (0, $a326659fb0a13e91$export$b0c249583f27a2b9)({
                        color: entity.color,
                        name: "sign.png",
                        scale: 0.55,
                        animated: false
                    });
                    break;
                case "goal":
                    renderable = new (0, $0a6164d33da4c314$export$462e530a9b3886e4)(entity.color);
                    break;
                case "light":
                    renderable = new (0, $6d7a9fd00230699d$export$eb38fb18cfba1d64)();
                    break;
                case "door":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "arch.png",
                        scale: 2.0,
                        animated: false
                    });
                    // renderable = new BasicSprite(entity.color, "arch", 2)
                    renderable.zIndex = 1000000;
                    break;
                case "lock":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "lock.png",
                        scale: 0.5,
                        animated: false
                    });
                    break;
                case "fire":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xff0000,
                        name: "fire",
                        scale: 1.0,
                        animated: true
                    });
                    break;
                case "health":
                    renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x00ff00, true);
                    break;
                case "mana":
                    renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x399cbd, true);
                    break;
                case "outpost":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: entity.spriteId,
                        scale: 1.0,
                        color: 0xffffff,
                        rotating: entity.expirationTs !== undefined
                    });
                    break;
                default:
                    renderable = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)(entity.entityId);
            }
            return renderable;
        };
        this.attachClickHandler = (entity, entityRenderable)=>{
            const renderable = entityRenderable.getClickSurface();
            renderable.interactive = this.shouldTakePointer(entity);
            // Re-apply whatever the server has already told us about this entity. The list can arrive
            // before the renderable exists (a proactive broadcast, or the reply to a hover request that
            // won the race), so applying it here -- at create and on every clickable change -- arms the
            // entity regardless of message ordering. Without this the entity silently stays inert until
            // some later hover happens to win the round trip, which was the intermittent "interactions
            // don't work on that one NPC".
            this.applyInteractionAffordance(entity.entityId);
            // update() re-invokes this whenever entity.clickable changes. Bind the pointer listeners
            // (and the hover-state closure below) only once per renderable -- otherwise stacked
            // listeners fight each other over the same hover state.
            if (renderable.interactionsBound) return;
            renderable.interactionsBound = true;
            // Hover state for one entity. The icons this used to arm are gone: hovering now shows the
            // entity's own name/HP and, when it has something to activate, the warm outline. The grace
            // timer on the way out is kept because it makes the hide self-healing -- a dropped
            // pointer-out still resolves to "not hovered" instead of latching the outline on forever.
            let overSelf = false;
            let hideTimer;
            const clearHideTimer = ()=>{
                if (hideTimer) {
                    clearTimeout(hideTimer);
                    hideTimer = undefined;
                }
            };
            const reconcile = ()=>{
                clearHideTimer();
                if (overSelf) {
                    entityRenderable.onMouseOver(true);
                    this.setHighlightedEntity(entity.entityId);
                } else hideTimer = setTimeout(()=>{
                    hideTimer = undefined;
                    entityRenderable.onMouseOver(false);
                    this.clearHighlightIf(entity.entityId);
                }, $3de7f2d858d8583e$var$INTERACTION_HOVER_GRACE_MS);
            };
            const pointAt = ()=>{
                overSelf = true;
                this.logic.requestEntityInteractions(entity.entityId);
                this.logic.playerController.setHoveredEntity(entity.entityId);
                reconcile();
            };
            renderable.on((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? "tap" : "mouseover", ()=>{
                pointAt();
                if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                    // Touch has no mouseout; release the entity after a delay instead.
                    clearHideTimer();
                    hideTimer = setTimeout(()=>{
                        hideTimer = undefined;
                        overSelf = false;
                        this.logic.playerController.unHoveredEntity(entity.entityId);
                        reconcile();
                    }, 1500);
                }
            });
            renderable.on("mouseout", ()=>{
                overSelf = false;
                this.logic.playerController.unHoveredEntity(entity.entityId);
                reconcile();
            });
            // Press arbitration lives on pixi's pointer events rather than the document-level mouse
            // listeners the world attack uses, because these are the only ones that behave the same for
            // a mouse and for a finger: a touch that is held never produces the emulated mousedown a
            // desktop press does. A short press activates the entity's interaction; holding past the
            // threshold hands the press back to the world action, i.e. an attack. See PlayerController.
            renderable.on("pointerdown", ()=>{
                // Establishes the target on touch, where there is no hover to have set it.
                this.logic.playerController.setHoveredEntity(entity.entityId);
                this.logic.playerController.beginEntityPress(entity.entityId);
            });
            renderable.on("pointerup", ()=>{
                this.logic.playerController.endEntityPress(entity.entityId);
            });
            renderable.on("pointerupoutside", ()=>{
                this.logic.playerController.cancelEntityPress(entity.entityId);
            });
            // Entities the server has its own plans for on a plain click (collectables it picks up, the
            // outpost avatars) keep working, but only when they offer no interactions of their own --
            // otherwise a single tap would both activate an interaction and fire ENTITY_CLICKED, and the
            // two handlers would race. An entity with interactions reaches the server through
            // ACTIVATE_ENTITY_INTERACTION instead.
            const callback = ()=>{
                if (this.getEntityInteractions(entity.entityId).length > 0) return;
                this.logic.entityClicked(entity);
            };
            renderable.on("click", callback);
            renderable.on("tap", callback);
        };
        // The interactions this viewer has been offered for an entity, most-primary first. Empty for an
        // entity that offers none, which is what makes a tap on it fall through to the world action.
        //
        // You are never a target of your own interactions: hovering yourself must not light you up, and a
        // press on yourself belongs to the world action (attack/build), not to an interaction. Filtered
        // here rather than upstream because the server really does offer the player entity interactions
        // of its own -- atoms/inventory.ts puts "inventory" on it -- and this is the single funnel the
        // cursor, the outline and the press arbitration all read.
        this.getEntityInteractions = (entityId)=>{
            if (entityId === this.logic.playerEntity?.entityId) return [];
            return this.entityIdToInteractions[entityId] || [];
        };
        this.updateEntityInteractions = (entityId, interactions)=>{
            // Cached even when the renderable isn't ready yet, so attachClickHandler can re-apply it on
            // (re)creation -- see entityIdToInteractions. Normalized on the way in so a bare
            // InteractionType[] (older payload shape, or a test fixture) still works.
            this.entityIdToInteractions[entityId] = (0, $0fb3f7f2a67be6e3$export$279c35a8a516c7b3)(interactions);
            this.applyInteractionAffordance(entityId);
        };
        // A pointer cursor is the whole desktop "you can do something here" cue now that the icons are
        // gone; the outline is the other half and comes on hover. Both are driven from the cache, so an
        // entity that gains or loses an interaction mid-session picks it up immediately -- including
        // losing the outline it is currently wearing.
        this.applyInteractionAffordance = (entityId)=>{
            const renderable = this.entityIdToRenderable[entityId];
            if (!renderable) return;
            const hasInteractions = this.getEntityInteractions(entityId).length > 0;
            const clickSurface = renderable.getClickSurface();
            if (clickSurface) {
                clickSurface.cursor = hasInteractions ? "pointer" : null;
                const entity = this.logic.getEntity(entityId);
                if (entity) clickSurface.interactive = this.shouldTakePointer(entity);
            }
            if (!hasInteractions && this.highlightedEntityId === entityId) this.clearHighlightIf(entityId);
        };
        // Whether this entity should take pointer events at all.
        //
        // Pixi hands a pointer to the TOPMOST interactive object, so an entity with nothing to offer
        // doesn't merely waste a hit test -- it HIDES whatever is under it. The ember campfire sat under
        // two such things at once: its flame is a separate decorative marker drawn over the logs, and an
        // invisible ember manager entity (the wave/spawner/tutorial controllers are all `blank-32x32.png`
        // markers parked on the camp) sits on the same tile. Between them they swallowed every hover
        // aimed at the fire, leaving only the sliver of the logs' hit box poking out past them -- which
        // is why the campfire read as having a hover target a few pixels tall.
        //
        // So a MARKER has to earn the pointer: by offering an interaction, or by having visible art that
        // a click means something on. Everything else keeps it unconditionally -- players and NPCs show a
        // name plate and HP bar on hover even when they offer nothing to activate.
        this.shouldTakePointer = (entity)=>{
            if (this.getEntityInteractions(entity.entityId).length > 0) return true;
            if (entity.npcType !== "marker") return true;
            // A blank stand-in sprite is either tile-drawn art (a chest -- which has interactions, so it
            // never reaches here) or an invisible controller. Neither is something to point at.
            const isBlank = !entity.spriteId || entity.spriteId.startsWith("blank");
            return !!entity.clickable && !isBlank;
        };
        // Only the pointed-at (or, on touch, focused) entity is outlined, and only when it has something
        // to activate -- an outline on an entity a tap would just swing at would be a lie.
        this.setHighlightedEntity = (entityId)=>{
            if (this.getEntityInteractions(entityId).length === 0) {
                this.clearHighlightIf(this.highlightedEntityId);
                return;
            }
            if (this.highlightedEntityId === entityId) return;
            this.clearHighlightIf(this.highlightedEntityId);
            this.highlightedEntityId = entityId;
            // A renderable that reports false has no art of its own to trace -- it is an invisible marker
            // standing on tile-drawn art (the V2 chest). Outline those map tiles instead, so a chest gets
            // the same glow as a person rather than a box drawn round its footprint.
            if (this.applyHighlight(entityId) === false) this.tileHighlight().set(true);
        };
        this.clearHighlightIf = (entityId)=>{
            if (!entityId || this.highlightedEntityId !== entityId) return;
            this.highlightedEntityId = undefined;
            // Not simply "off": the roster may still want this one outlined.
            this.applyHighlight(entityId);
            this.entityTileHighlight?.set(false);
        };
        // The ember roster's selected member wears the same outline as a pointed-at entity, so the card
        // and the character on screen are visibly the same person. Undefined takes it off. The glow only
        // shows while the member is actually drawn: culling strips it (see hideRenderable) and coming
        // back into view puts it back (see renderEntity), which is what makes it viewport-bound.
        this.setRosterHighlight = (entityId)=>{
            if (this.rosterHighlightId === entityId) return;
            const previous = this.rosterHighlightId;
            this.rosterHighlightId = entityId;
            this.applyHighlight(previous);
            this.applyHighlight(entityId);
        };
        // Does this entity have ANY reason left to be outlined? Two channels feed the one glow, and the
        // renderable only holds a single on/off, so the union has to be worked out here.
        this.highlightWanted = (entityId)=>this.highlightedEntityId === entityId || this.rosterHighlightId === entityId;
        // Push that union onto one entity's renderable. Returns what the renderable reported (false =
        // no art of its own to trace), or undefined when there is nothing to push it onto. Cheap to call
        // repeatedly: EntityHighlight.set is a no-op when nothing has changed.
        this.applyHighlight = (entityId)=>{
            if (!entityId) return undefined;
            return this.entityIdToRenderable[entityId]?.setHighlighted(this.highlightWanted(entityId));
        };
        // The outline used for entities drawn as map tiles. One instance, reused: it reads the highlighted
        // entity's tiles each frame, so switching from one chest to another needs no teardown. It is
        // parented into the map's own tile surface, which is why the tile sprites' coordinates can be
        // copied straight across with no conversion.
        this.tileHighlight = ()=>{
            if (!this.entityTileHighlight) this.entityTileHighlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
                artContainer: this.logic.clientRenderer.map().getTileSurface(),
                frame: this.highlightedEntityTileFrames,
                // Under its own tiles in the z-sorted tile surface.
                zIndex: ()=>this.highlightedEntityTileZIndex
            });
            return this.entityTileHighlight;
        };
        this.highlightedEntityTileZIndex = 0;
        // The map tiles standing in for the highlighted entity, as outline frames. Looked up per frame
        // rather than cached: a map rerender destroys and rebuilds these sprites, and a stale reference
        // would be a destroyed texture.
        this.highlightedEntityTileFrames = ()=>{
            const entityId = this.highlightedEntityId;
            if (!entityId) return [];
            const entity = this.logic.getEntity(entityId);
            if (!entity) return [];
            // Floor, not round: this is "which cell contains the entity". NB the fineToRoughCoordinates
            // exported further down this very file ROUNDS, which lands a marker sitting at its tile's
            // centre (a chest is at x*32 + 16) on the NEXT cell over -- where there are no tiles to trace.
            const tiles = this.logic.clientRenderer.map().getSpritedTilesAt(Math.floor(entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            if (tiles.length === 0) return [];
            this.highlightedEntityTileZIndex = Math.min(...tiles.map((tile)=>tile.zIndex)) - 1;
            return tiles.map((tile)=>({
                    texture: tile.texture,
                    x: tile.x,
                    y: tile.y,
                    scaleX: tile.scale.x,
                    scaleY: tile.scale.y
                }));
        };
        // Touch substitute for hover: outline the interactable nearest the player, so a tap always has a
        // visible target. Driven from the render loop, throttled, and a no-op with a mouse -- there the
        // pointer says what is being aimed at far more precisely than proximity can.
        this.updateInteractionFocus = ()=>{
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            const now = Date.now();
            if (now - this.lastFocusScanTs < $3de7f2d858d8583e$var$FOCUS_SCAN_INTERVAL_MS) return;
            this.lastFocusScanTs = now;
            const player = this.logic.playerEntity;
            if (!player) return;
            let nearestId;
            let nearestDistance = $3de7f2d858d8583e$var$FOCUS_RANGE;
            Object.keys(this.entityIdToInteractions).forEach((entityId)=>{
                if (this.entityIdToInteractions[entityId].length === 0) return;
                const entity = this.logic.getEntity(entityId);
                if (!entity || entity.entityId === player.entityId) return;
                const dx = entity.location.x - player.location.x;
                const dy = entity.location.y - player.location.y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                if (distance <= nearestDistance) {
                    nearestDistance = distance;
                    nearestId = entity.entityId;
                }
            });
            if (!nearestId) {
                this.clearHighlightIf(this.highlightedEntityId);
                return;
            }
            this.setHighlightedEntity(nearestId);
        };
        // Newly created renderables start visible, so a creation that lands outside the culled set
        // has to be hidden here -- and one that lands inside has to join the shown set, or the
        // end-of-frame sweep would not know to hide it later.
        this.trackCreated = (entity, renderable, worldOverlayItem)=>{
            if (this.logic.isTooDistantFromPlayer(entity)) {
                renderable.visible = false;
                if (worldOverlayItem) worldOverlayItem.visible = false;
                return;
            }
            this.shownEntityIds.add(entity.entityId);
        };
        this.create = (entity)=>{
            this.cacheEntity(entity);
            const isClientPlayer = this.logic.playerEntity.entityId === entity.entityId;
            if (entity.entityType === "player") {
                // Only this branch sees real player bodies (NPCs build their LpcComposite in
                // renderEntity), so it is where the "a person is driving this" ground ring is decided:
                // every player except the one at this keyboard.
                const renderable = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)(entity.entityId, undefined, isClientPlayer, !isClientPlayer);
                this.entityIdToRenderable[entity.entityId] = renderable;
                this.surface.addChild(renderable);
                if (entity.isPlayer()) this.minimapSurface.offer(entity.entityId, isClientPlayer);
                this.attachClickHandler(entity, renderable);
                const worldOverlayItem = this.worldOverlaySurface.offer(entity);
                renderable.setWorldOverlayItem(worldOverlayItem);
                renderable.fadeIn();
                this.trackCreated(entity, renderable, worldOverlayItem);
                return renderable;
            }
            if (entity.entityType === "bullet") {
                if (entity.spriteId !== "none") {
                    const renderable = new (0, $8b020fb41ab0fc7e$export$f90411c24f6aebf8)(0xffffff);
                    // const renderable = new BasicSprite({
                    //     name: entity.spriteId,
                    //     scale: 1.0,
                    //     color: 0xFF0000,
                    // })
                    renderable.x = entity.location.x;
                    renderable.y = entity.location.y;
                    renderable.rotation = entity.movement.angle;
                    this.entityIdToRenderable[entity.entityId] = renderable;
                    this.surface.addChild(renderable);
                    this.attachClickHandler(entity, renderable);
                    return renderable;
                }
            }
            if (entity.npcType === "collectable") {
                const renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: entity.spriteId,
                    scale: 1.0,
                    color: 0xffffff,
                    animated: false,
                    supportLabel: true,
                    rotating: entity.expirationTs !== undefined
                });
                renderable.container.rotation = entity.movement.angle;
                this.entityIdToRenderable[entity.entityId] = renderable;
                if (entity.quantity) renderable.updateName(`${entity.quantity}`);
                renderable.recolor(0xffffff);
                this.surface.addChild(renderable);
                this.attachClickHandler(entity, renderable);
                this.trackCreated(entity, renderable);
                return renderable;
            }
            if (entity.npcType === "marker") {
                if (entity.spriteId) {
                    // The campfire flame is a `marker` with spriteId "fire" (see server campfire.ts).
                    // Render it as the procedurally-baked FireSprite (the ember roster's glowy particle
                    // look, at cheap AnimatedSprite cost) instead of the hand-drawn atlas animation.
                    const renderable = entity.spriteId === "fire" ? new (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)((0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app.renderer) : new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: entity.spriteId,
                        scale: 1.0,
                        color: 0xffffff,
                        tileMapMetaProvider: this.logic.tilemapMetaProvider
                    }, // Interactable markers (chests, campfires) need their own hit surface
                    // sized to the art they stand on.
                    true);
                    renderable.rotation = entity.movement.angle;
                    this.entityIdToRenderable[entity.entityId] = renderable;
                    this.surface.addChild(renderable);
                    this.attachClickHandler(entity, renderable);
                    const worldOverlayItem = this.worldOverlaySurface.offer(entity);
                    renderable.setWorldOverlayItem(worldOverlayItem);
                    if (entity.spriteScale !== undefined) renderable.scale.set(entity.spriteScale);
                    const tileMeta = this.logic.tilemapMetaProvider.resolveTileMeta(entity.spriteId);
                    if (tileMeta) {
                        if (tileMeta.renderZIdxOffset) {
                            // renderable.defaultZIndex = tileMeta.renderZIdxOffset
                            renderable.defaultZIndex = tileMeta.renderZIdxOffset;
                            renderable.zIndex = renderable.defaultZIndex;
                        }
                    }
                    this.trackCreated(entity, renderable, worldOverlayItem);
                    return renderable;
                } else {
                    const renderable = new (0, $6d7a9fd00230699d$export$eb38fb18cfba1d64)();
                    this.entityIdToRenderable[entity.entityId] = renderable;
                    this.surface.addChild(renderable);
                    this.attachClickHandler(entity, renderable);
                    if (entity.spriteScale !== undefined) renderable.scale.set(entity.spriteScale);
                    return renderable;
                }
            }
            if (entity.entityType === "bomb") {
                const renderable = new (0, $a372f7647b536fce$export$3a0f78411bc2215d)(entity);
                renderable.x = entity.location.x;
                renderable.y = entity.location.y;
                this.entityIdToRenderable[entity.entityId] = renderable;
                this.surface.addChild(renderable);
                this.attachClickHandler(entity, renderable);
                return renderable;
            }
            let renderable = this.renderEntity(entity);
            if (!renderable) return;
            renderable.fadeIn();
            this.attachClickHandler(entity, renderable);
            let minimappable = false;
            switch(entity.npcType){
                case "flag":
                case "goal":
                    minimappable = true;
                    break;
                case "door":
                    minimappable = true;
                    break;
                default:
                    if (entity.isPlayer()) // if (entity.npcType === "zombie") {
                    minimappable = true;
                    else minimappable = false;
            }
            if (minimappable) this.minimapSurface.offer(entity.entityId);
            this.entityIdToRenderable[entity.entityId] = renderable;
            this.surface.addChild(renderable);
            const worldOverlayItem = this.worldOverlaySurface.offer(entity);
            renderable.setWorldOverlayItem(worldOverlayItem);
            this.trackCreated(entity, renderable, worldOverlayItem);
            return renderable;
        };
        this.get = (entity)=>{
            return this.entityIdToRenderable[entity.entityId];
        };
        this.isClientPlayer = (entity)=>entity?.entityId === this.clientRenderer.logic().playerEntity.entityId;
        this.updateEntityId = (originalEntityId, updatedEntityId)=>{
            this.entityIdToRenderable[updatedEntityId] = this.entityIdToRenderable[originalEntityId];
            delete this.entityIdToRenderable[originalEntityId];
            this.localEntityMetaCache[updatedEntityId] = this.localEntityMetaCache[originalEntityId];
            delete this.localEntityMetaCache[originalEntityId];
            this.entityIdToInteractions[updatedEntityId] = this.entityIdToInteractions[originalEntityId];
            delete this.entityIdToInteractions[originalEntityId];
            this.worldOverlaySurface.updateEntityId(originalEntityId, updatedEntityId);
        };
        this.isSubmerged = (entity)=>{
            return this.logic.tilemapMetaProvider?.isDeepAt(Math.floor(entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
        };
        this.update = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            const minimapRenderable = this.minimapSurface.get(entity.entityId);
            let cachedEntity = this.localEntityMetaCache[entity.entityId];
            const wasCached = !!cachedEntity;
            if (!cachedEntity) this.cacheEntity(entity);
            if (cachedEntity?.expirationTs !== entity.expirationTs) renderable.updateRotating(entity.expirationTs !== undefined);
            if (cachedEntity?.name !== entity.name) {
                renderable.updateName(entity.name || "");
                cachedEntity.name = entity.name;
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
            }
            if (cachedEntity?.color !== entity.color) {
                renderable.recolor(entity.color);
                cachedEntity.color = entity.color;
            }
            if (cachedEntity?.spriteScale !== entity.spriteScale) {
                renderable.updateScale(entity.spriteScale);
                cachedEntity.spriteScale = entity.spriteScale;
            }
            if (cachedEntity?.quantity !== entity.quantity) {
                renderable.updateName(entity.quantity > 1 ? `${entity.quantity}` : "");
                cachedEntity.quantity = entity.quantity;
            }
            if (cachedEntity?.clickable !== entity.clickable) {
                this.attachClickHandler(entity, renderable);
                cachedEntity.clickable = entity.clickable;
            }
            if (cachedEntity.submerged !== entity.submerged) {
                renderable.updateSubmerged(entity.submerged);
                cachedEntity.submerged = entity.submerged;
            }
            // A player who starts or stops wearing one of a camp's attackers. Diffed like `submerged`
            // above rather than set every frame, and it has to be here at all because possession happens
            // to a sprite that already exists: the ring is built at construction from `remotePlayer`, and
            // a possessor is still a player entity, so without this the defender gets a player ring under
            // one of the sixteen things attacking their camp. See Entity.invading.
            if (cachedEntity.invading !== entity.invading) {
                renderable.updatePlayerRing(entity);
                cachedEntity.invading = entity.invading;
            }
            if (this.isPaperdollDifferent(cachedEntity, entity)) {
                cachedEntity.apperanceKey = this.computeAppearanceKey(entity);
                renderable.updatePaperdoll(entity);
            }
            if (cachedEntity?.hp !== entity.hp) {
                renderable.update(entity.hp, entity.maxHp);
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
                cachedEntity.hp = entity.hp;
            }
            if (cachedEntity?.hunger !== entity.hunger) {
                renderable.update(entity.hp, entity.maxHunger);
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
                cachedEntity.hunger = entity.hunger;
            }
            if (cachedEntity?.maxHp !== entity.maxHp) {
                renderable.update(entity.hp, entity.maxHp);
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
                cachedEntity.maxHp = entity.maxHp;
            }
            if (cachedEntity?.mana !== entity.mana) {
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
                cachedEntity.mana = entity.mana;
            }
            if (cachedEntity?.upgradePoints !== entity.upgradePoints) {
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
                cachedEntity.upgradePoints = entity.upgradePoints;
            }
            if (cachedEntity?.speed !== entity.speed) {
                const factor = entity.speed / entity.maxSpeed;
                renderable.updateSpeed(factor);
                cachedEntity.speed = entity.speed;
            }
            if (cachedEntity?.upgradePoints !== entity.upgradePoints) {
                if (this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
                cachedEntity.upgradePoints = entity.upgradePoints;
            }
            if (cachedEntity?.joinedTeam !== entity.joinedTeam) {
                cachedEntity.joinedTeam = entity.joinedTeam;
                if (entity.joinedTeam) renderable.addTag();
                else renderable.removeTag();
            }
            if (cachedEntity?.sigil !== entity?.flags[0, $cb689cfa16c444ba$export$c8c6d6e2d9b5390d]) {
                cachedEntity.sigil = entity?.flags[0, $cb689cfa16c444ba$export$c8c6d6e2d9b5390d];
                renderable.updateSigil(cachedEntity.sigil);
            }
            if (cachedEntity?.spriteId !== entity?.spriteId) {
                cachedEntity.spriteId = entity?.spriteId;
                renderable.updateSpriteId(cachedEntity.spriteId);
            }
            if (cachedEntity.visible !== entity.visible) {
                if (!entity.visible) {
                    renderable.recolor(0xffffff80);
                    if (minimapRenderable) minimapRenderable.visible = false;
                } else {
                    renderable.recolor(entity.color);
                    if (minimapRenderable) minimapRenderable.visible = true;
                }
                cachedEntity.visible = entity.visible;
                if (this.isClientPlayer(entity)) {
                    // renderable.updateBlinking(!entity.visible)
                    if (entity.visible) renderable.alpha = 1.0;
                    else renderable.alpha = 0.0;
                }
            }
            if (cachedEntity.afk !== entity.afk) {
                cachedEntity.afk = entity.afk;
                renderable.updateAfk(cachedEntity.afk);
            }
            if (cachedEntity.level !== entity.level) {
                renderable.updateLevel(entity.level || 1);
                cachedEntity.level = entity.level;
            }
            // Ember-camp role glyph (lord/defender/forager). Role isn't on the synced entity, but the
            // client already keeps an entityId->role map from the roster broadcast (getEmberRole).
            const role = this.logic.getEmberRole(entity.entityId);
            if (cachedEntity.role !== role) {
                cachedEntity.role = role;
                renderable.updateRole(role);
            }
            if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isFlat(entity)) renderable.zIndex = 0;
            else {
                const zIndexBoost = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateZIndexBoost(entity);
                renderable.zIndex = zIndexBoost + renderable.defaultZIndex || 0;
            }
            const locationChanged = !(cachedEntity.x === entity.location.x && cachedEntity.y === entity.location.y);
            const entityLight = this.lights.get(entity.entityId);
            const lightChanged = !this.lights.contains(entity.entityId) || entityLight?.intensity !== entity.lightMeta?.intensity || entityLight?.radius !== entity.lightMeta?.radius;
            if (locationChanged) entity.submerged = this.isSubmerged(entity);
            if ((this.isClientPlayer(entity) || entity.lightMeta) && (locationChanged || lightChanged) || entity.npcType === "light" && lightChanged) {
                this.lights.set(entity.entityId, {
                    entityId: entity.entityId,
                    location: entity.location,
                    intensity: entity.lightIntensity(),
                    radius: entity.lightRadius()
                });
                cachedEntity.x = entity.location.x;
                cachedEntity.y = entity.location.y;
            }
            if (!wasCached || cachedEntity?.leaderEntityId !== entity.leaderEntityId) {
                if (this.logic.playerEntity.entityId !== entity.leaderEntityId) // renderable.updateBlinking(true)
                renderable.updateHalo(entity, false);
                else // renderable.updateBlinking(false)
                renderable.updateHalo(entity, true);
                cachedEntity.leaderEntityId = entity.leaderEntityId;
            }
        };
        this.destroy = (entity)=>{
            delete this.localEntityMetaCache[entity.entityId];
            delete this.entityIdToInteractions[entity.entityId];
            this.shownEntityIds.delete(entity.entityId);
            this.renderedThisFrame.delete(entity.entityId);
            this.minimapSurface.remove(entity.entityId);
            // Release hover state so a removed entity can't leave the hover reference (used for click
            // auto-travel and press arbitration) pointing at a stale id, or world mouse actions stuck
            // disabled because it vanished mid-press.
            this.logic.playerController.clearHoverForEntity(entity.entityId);
            this.clearHighlightIf(entity.entityId);
            // A member who is gone is nobody's selection any more; leaving the id here would put the
            // glow on whatever entity is recycled into it.
            if (this.rosterHighlightId === entity.entityId) this.rosterHighlightId = undefined;
            const renderable = this.entityIdToRenderable[entity.entityId];
            if (renderable) {
                // Clean up callbacks before destroying
                if (renderable.cleanup) renderable.cleanup();
                renderable.remove();
                delete this.entityIdToRenderable[entity.entityId];
                if (renderable.sideCar) renderable.sideCar.remove();
            }
            this.worldOverlaySurface.remove(entity);
            this.lights.remove(entity.entityId);
            this.footDust.remove(entity.entityId);
        };
        // Called by the render loop around its entity pass; see shownEntityIds above.
        this.beginFrame = ()=>{
            this.renderedThisFrame.clear();
        };
        // Entities the render loop dropped for its per-frame budget rather than for distance. They
        // keep whatever they were showing (freezing in place is the existing behaviour under load)
        // instead of popping out of the world.
        this.markDeferred = (entityId)=>{
            this.renderedThisFrame.add(entityId);
        };
        this.endFrame = ()=>{
            // Lay down any footfalls that have come due and settle the dust already on the ground. It
            // runs before the early return below: a frame that rendered no entities still has to
            // advance a trail somebody left behind.
            this.footDust.update();
            if (this.shownEntityIds.size < 1) return;
            // hideRenderable only ever deletes the entry being visited, which is safe to do while
            // iterating a Set.
            for (const entityId of this.shownEntityIds){
                if (this.renderedThisFrame.has(entityId)) continue;
                this.hideRenderable(entityId);
            }
        };
        // Hide an entity's sprite and overlay, and release any hover it was holding. Culling to
        // invisible never fires a pointer-out, so a stranded hover (name plate, outline) has to be
        // dropped by hand or it reappears without a hover when the entity comes back.
        this.hideRenderable = (entityId)=>{
            this.shownEntityIds.delete(entityId);
            const renderable = this.entityIdToRenderable[entityId];
            if (renderable) {
                if (renderable.visible) {
                    renderable.onMouseOver?.(false);
                    renderable.setHighlighted?.(false);
                    this.clearHighlightIf(entityId);
                    this.logic.playerController?.clearHoverForEntity(entityId);
                }
                renderable.visible = false;
            }
            const worldOverlayItem = this.worldOverlaySurface.getEntityRenderable(entityId);
            if (worldOverlayItem) worldOverlayItem.visible = false;
        };
        this.render = (entity, playerEntityId)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            this.renderedThisFrame.add(entity.entityId);
            if (!this.logic.clientRenderer.map().getVisibility()?.suppressMinimap) this.minimapSurface.updateEntity(entity.entityId, entity.roomId, entity.location);
            // Check if entity is too far from player
            const isTooFar = this.logic.isTooDistantFromPlayer(entity);
            if (!isTooFar) {
                // Entity is close enough - make it visible and update
                if (entity.entityId !== playerEntityId) {
                    renderable.visible = entity.visible;
                    if (entity.visible) {
                        this.shownEntityIds.add(entity.entityId);
                        // Re-assert the selected member's outline every frame they are drawn. A hover
                        // glow re-arms itself on the next pointer move; a roster selection has nothing
                        // to re-arm it, and two things throw it away behind its back -- culling takes it
                        // off by hand (see hideRenderable), and a paperdoll rebuild replaces the sprite
                        // that owns it (see LpcComposite.setHighlighted). Costs a map lookup: the
                        // highlight itself ignores a set() that changes nothing.
                        if (entity.entityId === this.rosterHighlightId) this.applyHighlight(entity.entityId);
                    } else this.shownEntityIds.delete(entity.entityId);
                }
                renderable.updateRenderedLocationFrom(entity);
                renderable.doMovement(entity);
                this.worldOverlaySurface.updateEntity(entity);
            } else // Entity is too far - hide it
            if (entity.entityId !== playerEntityId) this.hideRenderable(entity.entityId);
            else {
                // Also hide the world overlay
                const worldOverlayItem = this.worldOverlaySurface.getEntityRenderable(entity.entityId);
                if (worldOverlayItem) worldOverlayItem.visible = false;
            }
            return true;
        };
        this.detonate = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.detonate();
        };
        this.emp = (entity, range)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            const halo = new (0, $gwPoJ.Graphics)();
            this.surface.addChild(halo);
            halo.beginFill(0xff000080, 0.25);
            halo.drawCircle(1, 5, 5);
            halo.endFill();
            halo.x = renderable.x;
            halo.y = renderable.y;
            let scale = 1.0;
            let roomId = entity.roomId;
            const expandInterval = setInterval(()=>{
                scale += 0.5;
                halo.scale.set(scale);
                halo.x = renderable.x - halo.width * 0.1;
                halo.y = renderable.y - halo.height / 2;
                if (halo.height > range) {
                    clearInterval(expandInterval);
                    let alpha = 1.0;
                    let startTs = Date.now();
                    const contractInterval = setInterval(()=>{
                        const changedRooms = roomId !== entity.roomId;
                        if (Date.now() - startTs > 3000 || changedRooms) {
                            clearInterval(contractInterval);
                            if (changedRooms) this.surface.removeChild(halo);
                            else setInterval(()=>{
                                alpha -= 0.01;
                                halo.alpha = alpha;
                                if (alpha <= 0.0) this.surface.removeChild(halo);
                            }, 5);
                        }
                    }, 250);
                }
            }, 4);
        };
        // Green "sparkle halo": an expanding green glow ring plus a handful of twinkling star
        // sparkles ringing the entity, all fading over ~700ms. Server-triggered (see
        // Protocol.type_entitySparkle) as feedback when a campfire is refreshed with wood.
        this.sparkle = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            const roomId = entity.roomId;
            const color = 0x33ff66;
            const cx = renderable.x;
            // Nudge up toward the middle of the sprite so the halo sits over the campfire.
            const cy = renderable.y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            // --- Expanding green glow ring ---
            const ring = new (0, $gwPoJ.Graphics)();
            this.surface.addChild(ring);
            ring.lineStyle(3, color, 0.9);
            ring.beginFill(color, 0.15);
            ring.drawCircle(0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.6);
            ring.endFill();
            ring.x = cx;
            ring.y = cy;
            const ringStart = Date.now();
            const ringDuration = 700;
            const ringInterval = setInterval(()=>{
                const t = (Date.now() - ringStart) / ringDuration;
                if (t >= 1 || roomId !== entity.roomId) {
                    clearInterval(ringInterval);
                    this.surface.removeChild(ring);
                    return;
                }
                ring.scale.set(0.6 + t * 1.6);
                ring.alpha = 1 - t;
            }, 16);
            // --- Twinkling star sparkles ringing the campfire ---
            const sparkleCount = 7;
            for(let i = 0; i < sparkleCount; i++){
                const angle = Math.PI * 2 * i / sparkleCount + Math.random() * 0.4;
                const radius = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (0.5 + Math.random() * 0.35);
                const star = this.drawSparkleStar(color, 3 + Math.random() * 2);
                this.surface.addChild(star);
                star.x = cx + Math.cos(angle) * radius;
                star.y = cy + Math.sin(angle) * radius;
                const driftX = Math.cos(angle) * 0.3;
                const driftY = Math.sin(angle) * 0.3 - 0.4 // slight upward bias
                ;
                const start = Date.now();
                const life = 500 + Math.random() * 300;
                const twinklePhase = Math.random() * Math.PI * 2;
                const interval = setInterval(()=>{
                    const elapsed = Date.now() - start;
                    if (elapsed > life || roomId !== entity.roomId) {
                        clearInterval(interval);
                        this.surface.removeChild(star);
                        return;
                    }
                    star.x += driftX;
                    star.y += driftY;
                    const fade = 1 - elapsed / life;
                    star.alpha = fade * (0.5 + 0.5 * Math.abs(Math.sin(elapsed / 60 + twinklePhase)));
                    star.rotation += 0.08;
                }, 16);
            }
        };
        // A small 4-point sparkle drawn from two overlapping diamonds (drawPolygon is core in
        // pixi v6; drawStar is not).
        this.drawSparkleStar = (color, size)=>{
            const g = new (0, $gwPoJ.Graphics)();
            g.beginFill(color, 1);
            // Vertical spike
            g.drawPolygon([
                0,
                -size * 2,
                size * 0.5,
                0,
                0,
                size * 2,
                -size * 0.5,
                0
            ]);
            // Horizontal spike
            g.drawPolygon([
                -size * 2,
                0,
                0,
                size * 0.5,
                size * 2,
                0,
                0,
                -size * 0.5
            ]);
            g.endFill();
            return g;
        };
        this.attack = (entity, callback)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.doAttack(entity, callback);
        };
        this.updateActivation = (entity, active)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.updateActivation(entity, active);
        };
        this.animateStrikeOn = (target)=>{
            const struckEffect = new (0, $e97a9ef66e2e5f53$export$8653a30c44b6e879)(0xff0000, 10);
            const renderable = this.get(target);
            if (!renderable) return;
            // struckEffect.x = renderable.x
            // struckEffect.y = renderable.y
            // struckEffect.zIndex = renderable.zIndex + 1
            // this.surface.addChild(struckEffect)
            // struckEffect.alpha = 0.5
            // let startTS = Date.now()
            // let totalDuration = 150
            // let scale = 0
            // let incr = 0
            // const itr = setInterval(() => {
            //     const duration = Date.now() - startTS
            //     incr = duration > totalDuration / 2 ? -1 : 1
            //     scale += incr
            //     struckEffect.scale.set(scale, scale)
            //     if (duration > totalDuration) {
            //         clearInterval(itr)
            //         this.surface?.removeChild(struckEffect)
            //     }
            // }, 17)
            renderable.doDamaged(target);
        };
        this.spoke = (entity, message, options)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            // Render instantly (no typewriter) when this entity is the follow-cam PiP focus — the
            // typewriter's progressive reveal flickers when rendered into the PiP texture. On the main
            // view (not the PiP focus) keep the typewriter.
            const instant = entity.entityId === this.logic.focusEntityId;
            renderable.spoke(message, {
                instant: instant,
                hold: options?.hold,
                onDismissed: options?.onDismissed
            });
        };
        // Called off a conversation the player has opted out of (the ember tutorial's Skip): every
        // held bubble on screen comes down, with whatever was queued behind it. Room-wide rather than
        // per-speaker, because what is being ended is the SCENE, not one entity's line.
        this.releaseHeldSpeech = ()=>{
            Object.values(this.entityIdToRenderable).forEach((renderable)=>renderable?.releaseHeldSpeech());
        };
        this.death = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.fragment(entity);
        };
        this.getLights = ()=>{
            return this.lights;
        };
        this.clearBiomeColorMap = ()=>{
            this.minimapSurface.clearBiomeColorMap();
        };
        this.updateLocationIcons = (icon)=>{
            this.minimapSurface.updateLocationIcon(icon);
        };
        this.updatePlayerLocations = (playerLocations)=>{
            const clientPlayerEntityId = this.clientRenderer.logic().playerEntity.entityId;
            if (!clientPlayerEntityId) return;
            if (!playerLocations) return;
            this.minimapSurface.entities().forEach((entityId)=>{
                // remove any players not present in the latest
                // player location manifest sent from the server
                const entity = this.logic.entityManager.get(entityId);
                if (!playerLocations[entityId] || entity?.roomId !== this.clientRenderer.logic().playerEntity.roomId) this.minimapSurface.remove(entityId);
            });
            Object.keys(playerLocations).forEach((entityId)=>{
                const location = playerLocations[entityId];
                if (location?.quadrantId && location.quadrantId !== this.clientRenderer.logic().quadrantId) return;
                this.minimapSurface.offer(entityId);
                this.minimapSurface.updateEntity(entityId, location.roomId, {
                    x: location.x,
                    y: location.y
                }, true);
            });
        };
        this.pulseLocation = (locationId, expires)=>{
            this.minimapSurface.pulseLocation(locationId, expires);
        };
        this.updateEntityPointerIcon = (entity, show, angle)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.updatePointerIcon(show, angle);
        };
        this.itemPickedUp = (entity, itemTypeMeta, quantity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.itemPickedUp(entity, itemTypeMeta, quantity);
        };
        this.feedback = (entity, image, label, params)=>{
            // A running body's dust trail is not overlay feedback like a nameplate or a floating "+1":
            // it is art laid on the ground that has to sort against the bodies around it, so it is drawn
            // in the world surface this manager owns instead of inside the entity's renderable. See
            // FootDust for why the renderable cannot get the z-order right.
            if (params?.type === "foot") {
                if (params.action === "remove") this.footDust.stop(entity.entityId);
                else this.footDust.start(entity, params);
                return;
            }
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.feedback(entity, image, label, params);
        };
        this.fragment = (spriteId, location)=>{
            const renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: spriteId,
                scale: 1.0,
                color: 0xffffff
            });
            const fragmentContainer = new (0, $gwPoJ.Graphics)();
            fragmentContainer.x = location.x;
            fragmentContainer.y = location.y - renderable.height * 0.25;
            fragmentContainer.addChild(renderable);
            this.surface.addChild(fragmentContainer);
            renderable.fragment(null, ()=>{
                renderable.visible = false;
            });
            setTimeout(()=>{
                this.surface.removeChild(fragmentContainer);
            }, 1500);
        };
        this.surface = surface;
        this.minimapSurface = minimapSurface;
        this.worldOverlaySurface = worldOverlaySurface;
        this.logic = logic;
        this.clientRenderer = clientRenderer;
        this.footDust = new (0, $f63df80eccdeeea6$export$ab8cf330af9aa032)(surface, (0, $f63df80eccdeeea6$export$ab8cf330af9aa032).textureFactory(app.renderer));
    }
}
const $3de7f2d858d8583e$export$504709cb2a8295d2 = (fineCoordinate)=>{
    return {
        x: Math.round(fineCoordinate.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
        y: Math.round(fineCoordinate.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
    };
};








var $8JEKL = parcelRequire("8JEKL");
var $f569351cceda89c3$exports = {};
"use strict";
var $f569351cceda89c3$var$__extends = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f569351cceda89c3$var$__createBinding = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f569351cceda89c3$var$__setModuleDefault = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f569351cceda89c3$var$__importStar = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f569351cceda89c3$var$__createBinding(result, mod, k);
    }
    $f569351cceda89c3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f569351cceda89c3$exports, "__esModule", {
    value: true
});
$f569351cceda89c3$exports.Joystick = $f569351cceda89c3$exports.Direction = void 0;

var $f569351cceda89c3$var$PIXI = $f569351cceda89c3$var$__importStar((parcelRequire("1avo5")));
var $f569351cceda89c3$var$Direction;
(function(Direction) {
    Direction["LEFT"] = "left";
    Direction["TOP"] = "top";
    Direction["BOTTOM"] = "bottom";
    Direction["RIGHT"] = "right";
    Direction["TOP_LEFT"] = "top_left";
    Direction["TOP_RIGHT"] = "top_right";
    Direction["BOTTOM_LEFT"] = "bottom_left";
    Direction["BOTTOM_RIGHT"] = "bottom_right";
})($f569351cceda89c3$var$Direction = $f569351cceda89c3$exports.Direction || ($f569351cceda89c3$exports.Direction = {}));
var $f569351cceda89c3$var$Joystick = /** @class */ function(_super) {
    $f569351cceda89c3$var$__extends(Joystick, _super);
    function Joystick(opts) {
        var _this = _super.call(this) || this;
        _this.outerRadius = 0;
        _this.innerRadius = 0;
        _this.innerAlphaStandby = 0.5;
        _this.settings = Object.assign({
            outerScale: {
                x: 1,
                y: 1
            },
            innerScale: {
                x: 1,
                y: 1
            }
        }, opts);
        if (!_this.settings.outer) {
            var outer = new $f569351cceda89c3$var$PIXI.Graphics();
            outer.beginFill(0x000000);
            outer.drawCircle(0, 0, 60);
            outer.alpha = 0.5;
            _this.settings.outer = outer;
        }
        if (!_this.settings.inner) {
            var inner = new $f569351cceda89c3$var$PIXI.Graphics();
            inner.beginFill(0x000000);
            inner.drawCircle(0, 0, 35);
            inner.alpha = _this.innerAlphaStandby;
            _this.settings.inner = inner;
        }
        _this.initialize();
        return _this;
    }
    Joystick.prototype.initialize = function() {
        this.outer = this.settings.outer;
        this.inner = this.settings.inner;
        this.outer.scale.set(this.settings.outerScale.x, this.settings.outerScale.y);
        this.inner.scale.set(this.settings.innerScale.x, this.settings.innerScale.y);
        if ('anchor' in this.outer) this.outer.anchor.set(0.5);
        if ('anchor' in this.inner) this.inner.anchor.set(0.5);
        this.addChild(this.outer);
        this.addChild(this.inner);
        // this.outerRadius = this.containerJoystick.width / 2;
        this.outerRadius = this.width / 2.5;
        this.innerRadius = this.inner.width / 2;
        this.bindEvents();
    };
    Joystick.prototype.bindEvents = function() {
        var that = this;
        this.interactive = true;
        var dragging = false;
        var eventData;
        var power;
        var startPosition;
        function onDragStart(event) {
            var _a, _b;
            eventData = event.data;
            startPosition = eventData.getLocalPosition(that);
            dragging = true;
            that.inner.alpha = 1;
            (_b = (_a = that.settings).onStart) === null || _b === void 0 || _b.call(_a);
        }
        function onDragEnd(event) {
            var _a, _b;
            if (dragging == false) return;
            that.inner.position.set(0, 0);
            dragging = false;
            that.inner.alpha = that.innerAlphaStandby;
            (_b = (_a = that.settings).onEnd) === null || _b === void 0 || _b.call(_a);
        }
        function onDragMove(event) {
            var _a, _b, _c, _d, _e, _f;
            if (dragging == false) return;
            var newPosition = eventData.getLocalPosition(that);
            var sideX = newPosition.x - startPosition.x;
            var sideY = newPosition.y - startPosition.y;
            var centerPoint = new $f569351cceda89c3$var$PIXI.Point(0, 0);
            var angle = 0;
            if (sideX == 0 && sideY == 0) return;
            var calRadius = 0;
            if (sideX * sideX + sideY * sideY >= that.outerRadius * that.outerRadius) calRadius = that.outerRadius;
            else calRadius = that.outerRadius - that.innerRadius;
            /**
             * x:   -1 <-> 1
             * y:   -1 <-> 1
             *          Y
             *          ^
             *          |
             *     180  |  90
             *    ------------> X
             *     270  |  360
             *          |
             *          |
             */ var direction = $f569351cceda89c3$var$Direction.LEFT;
            if (sideX == 0) {
                if (sideY > 0) {
                    centerPoint.set(0, sideY > that.outerRadius ? that.outerRadius : sideY);
                    angle = 270;
                    direction = $f569351cceda89c3$var$Direction.BOTTOM;
                } else {
                    centerPoint.set(0, -(Math.abs(sideY) > that.outerRadius ? that.outerRadius : Math.abs(sideY)));
                    angle = 90;
                    direction = $f569351cceda89c3$var$Direction.TOP;
                }
                that.inner.position.set(centerPoint.x, centerPoint.y);
                power = that.getPower(centerPoint);
                (_b = (_a = that.settings).onChange) === null || _b === void 0 || _b.call(_a, {
                    angle: angle,
                    direction: direction,
                    power: power
                });
                return;
            }
            if (sideY == 0) {
                if (sideX > 0) {
                    centerPoint.set(Math.abs(sideX) > that.outerRadius ? that.outerRadius : Math.abs(sideX), 0);
                    angle = 0;
                    direction = $f569351cceda89c3$var$Direction.LEFT;
                } else {
                    centerPoint.set(-(Math.abs(sideX) > that.outerRadius ? that.outerRadius : Math.abs(sideX)), 0);
                    angle = 180;
                    direction = $f569351cceda89c3$var$Direction.RIGHT;
                }
                that.inner.position.set(centerPoint.x, centerPoint.y);
                power = that.getPower(centerPoint);
                (_d = (_c = that.settings).onChange) === null || _d === void 0 || _d.call(_c, {
                    angle: angle,
                    direction: direction,
                    power: power
                });
                return;
            }
            var tanVal = Math.abs(sideY / sideX);
            var radian = Math.atan(tanVal);
            angle = radian * 180 / Math.PI;
            var centerX = 0;
            var centerY = 0;
            if (sideX * sideX + sideY * sideY >= that.outerRadius * that.outerRadius) {
                centerX = that.outerRadius * Math.cos(radian);
                centerY = that.outerRadius * Math.sin(radian);
            } else {
                centerX = Math.abs(sideX) > that.outerRadius ? that.outerRadius : Math.abs(sideX);
                centerY = Math.abs(sideY) > that.outerRadius ? that.outerRadius : Math.abs(sideY);
            }
            if (sideY < 0) centerY = -Math.abs(centerY);
            if (sideX < 0) centerX = -Math.abs(centerX);
            if (sideX > 0 && sideY < 0) ;
            else if (sideX < 0 && sideY < 0) // 90 ~ 180
            angle = 180 - angle;
            else if (sideX < 0 && sideY > 0) // 180 ~ 270
            angle = angle + 180;
            else if (sideX > 0 && sideY > 0) // 270 ~ 369
            angle = 360 - angle;
            centerPoint.set(centerX, centerY);
            power = that.getPower(centerPoint);
            direction = that.getDirection(centerPoint);
            that.inner.position.set(centerPoint.x, centerPoint.y);
            (_f = (_e = that.settings).onChange) === null || _f === void 0 || _f.call(_e, {
                angle: angle,
                direction: direction,
                power: power
            });
        }
        this.on('pointerdown', onDragStart).on('pointerup', onDragEnd).on('pointerupoutside', onDragEnd).on('pointermove', onDragMove);
    };
    Joystick.prototype.getPower = function(centerPoint) {
        var a = centerPoint.x - 0;
        var b = centerPoint.y - 0;
        return Math.min(1, Math.sqrt(a * a + b * b) / this.outerRadius);
    };
    Joystick.prototype.getDirection = function(center) {
        var rad = Math.atan2(center.y, center.x); // [-PI, PI]
        if (rad >= -Math.PI / 8 && rad < 0 || rad >= 0 && rad < Math.PI / 8) return $f569351cceda89c3$var$Direction.RIGHT;
        else if (rad >= Math.PI / 8 && rad < 3 * Math.PI / 8) return $f569351cceda89c3$var$Direction.BOTTOM_RIGHT;
        else if (rad >= 3 * Math.PI / 8 && rad < 5 * Math.PI / 8) return $f569351cceda89c3$var$Direction.BOTTOM;
        else if (rad >= 5 * Math.PI / 8 && rad < 7 * Math.PI / 8) return $f569351cceda89c3$var$Direction.BOTTOM_LEFT;
        else if (rad >= 7 * Math.PI / 8 && rad < Math.PI || rad >= -Math.PI && rad < -7 * Math.PI / 8) return $f569351cceda89c3$var$Direction.LEFT;
        else if (rad >= -7 * Math.PI / 8 && rad < -5 * Math.PI / 8) return $f569351cceda89c3$var$Direction.TOP_LEFT;
        else if (rad >= -5 * Math.PI / 8 && rad < -3 * Math.PI / 8) return $f569351cceda89c3$var$Direction.TOP;
        else return $f569351cceda89c3$var$Direction.TOP_RIGHT;
    };
    return Joystick;
}($f569351cceda89c3$var$PIXI.Container);
$f569351cceda89c3$exports.Joystick = $f569351cceda89c3$var$Joystick;


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $hnGDn = parcelRequire("hnGDn");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $kXE1p = parcelRequire("kXE1p");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");





class $ae9502ee83364da4$var$Pulsar {
    constructor(id, circle, mask){
        this.pulse = (duration)=>{
            if (this.pulsing) {
                clearInterval(this.circleGlow);
                clearInterval(this.volume);
            }
            this.pulsing = true;
            let { circle: circle, mask: mask } = this;
            circle.alpha = 1.0;
            circle.lineStyle(1, 0xffffff);
            circle.beginFill(0xffffff);
            circle.drawCircle(0, 0, 14);
            circle.endFill();
            mask.clear();
            mask.beginFill(0xff3300);
            mask.drawRect(-15, -15, 30, 30);
            mask.endFill();
            let dir = 1;
            this.circleGlow = setInterval(()=>{
                if (dir === -1) circle.alpha -= 0.01;
                else circle.alpha += 0.01;
                if (circle.alpha < 0.2) dir = 1;
                if (circle.alpha > 0.8) dir = -1;
            }, 10);
            let h = 0;
            this.volume = setInterval(()=>{
                if (h >= 30) {
                    clearInterval(this.volume);
                    clearInterval(this.circleGlow);
                    this.pulsing = false;
                    return;
                }
                h += 1;
                mask.clear();
                mask.beginFill(0xff3300);
                mask.drawRect(-15, h - 15, 30, 30);
                mask.endFill();
            }, duration / 30);
        };
        this.remove = ()=>{
            this.circle.parent.removeChild(this.circle);
            this.mask.parent.removeChild(this.mask);
        };
        this.entityId = id;
        this.circle = circle;
        this.mask = mask;
    }
}
class $ae9502ee83364da4$export$f69bebae58da6a32 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.slotCoordinates = new Map(), this.slotPulsar = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)(), this.renderSlot = (abilityType, label, item, quantity, cap, callback, showRing)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            const mask = new (0, $gwPoJ.Graphics)();
            mask.name = "mask";
            mask.beginFill(0xff3300);
            mask.drawRect(-15, -15, 30, 30);
            mask.endFill();
            const circle = new (0, $gwPoJ.Graphics)();
            circle.name = "circle";
            circle.alpha = 0.0;
            circle.lineStyle(1, 0xffffff);
            circle.beginFill(0xffffff);
            circle.drawCircle(0, 0, 14);
            circle.endFill();
            circle.mask = mask;
            slot.addChild(mask, circle);
            if (showRing) {
                const circle2 = new (0, $gwPoJ.Graphics)();
                circle2.lineStyle(1, 0xffffff);
                circle2.drawCircle(0, 0, 14);
                slot.addChild(circle2);
            }
            item.y = -2;
            item.x = -2;
            slot.addChild(item);
            const labelObject = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(`${label}: ${quantity}${cap ? `/${cap}` : ""}`);
            labelObject.x = -20;
            labelObject.y = -30;
            slot.addChild(labelObject);
            const pulsar = new $ae9502ee83364da4$var$Pulsar(abilityType, circle, mask);
            this.slotPulsar.set(abilityType, pulsar);
            slot.interactive = true;
            slot.on("pointerdown", callback);
            return slot;
        }, this.update = (inventory, slotCallback)=>{
            // clear all
            this.slotCoordinates.clear();
            this.slotPulsar.iterate((next)=>next.remove());
            this.slotPulsar.clear();
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            let slotPos = 0;
            Object.values(inventory?.abilities || {}).sort((a, b)=>(0, $cb689cfa16c444ba$export$1cd76c5103dfeb09)[a.abilityType].equipOrder - (0, $cb689cfa16c444ba$export$1cd76c5103dfeb09)[b.abilityType].equipOrder).map((item)=>{
                const { abilityType: abilityType, quantity: quantity } = item;
                if (quantity < 1) return;
                const meta = (0, $cb689cfa16c444ba$export$1cd76c5103dfeb09)[abilityType];
                const shortcutKey = meta.shortcutKey;
                let renderable;
                let showRing = true;
                switch(abilityType){
                    case "heal":
                        renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x00ff00);
                        renderable.scale.set(0.7);
                        break;
                    case "mana":
                        renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x399cbd);
                        renderable.scale.set(0.7);
                        break;
                    case "bomb":
                        renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                            color: 0xffffff,
                            name: "bomb.png",
                            scale: 1.45,
                            animated: false
                        });
                        showRing = false;
                        break;
                    case "speed":
                        break;
                }
                const slot = this.renderSlot(abilityType, shortcutKey, renderable, quantity, meta.maxCarried || 0, ()=>slotCallback(shortcutKey), showRing);
                slot.x = slotPos * 50;
                this.addChild(slot);
                this.slotCoordinates.set(abilityType, {
                    x: slot.x,
                    y: slot.y
                });
                slotPos++;
            });
        };
        this.guiManager = guiManager;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $ac2a97d45725bff5$export$f79759b47a91f0e7 {
    constructor(guiManager, props){
        this.isOpen = ()=>this.show;
        this.update = ()=>{
            this.rebuildSurface();
        };
        // Repaint the content. Split out from update() so a subclass can decide for itself WHEN to
        // repaint (the character builder is driven by player-stat updates it mostly wants to ignore)
        // and still get the same teardown.
        //
        // Frees the previous content's per-instance Text textures before rebuilding -- otherwise every
        // open of this modal (inventory, character sheet, etc.) strands all its grid item labels /
        // quantity / stat Text textures. Shared item-sprite textures are left intact.
        this.rebuildSurface = ()=>{
            [
                ...this.surface.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.surface.removeChildren();
            this.surface.addChild(this.createContent());
        };
        this.width = ()=>this.modal?.width;
        this.height = ()=>this.modal?.height;
        this.close = ()=>{
            this.show = !this.show;
            if (!this.show && this.modal) this.modal.close();
        };
        this.toggle = (onClose)=>{
            this.show = !this.show;
            if (!this.show && this.modal) this.modal.close();
            if (this.show) {
                this.modal = this.guiManager.createModal({
                    padding: this.padding,
                    content: this.surface,
                    fullScreen: true,
                    backgroundAlpha: this.backgroundAlpha !== undefined ? this.backgroundAlpha : !this.opaque ? 0.91 : 1.0,
                    plain: true,
                    unescapeable: this.unescapable,
                    closeAnchor: this.closeAnchor,
                    closeCallback: (clicked)=>{
                        this.show = false;
                        if (this.onClose) this.onClose(clicked);
                        else if (onClose) onClose(clicked);
                    }
                });
                this.update();
            }
        };
        this.guiManager = guiManager;
        this.show = false;
        this.surface = new (0, $gwPoJ.Graphics)();
        this.padding = props?.padding || 10;
        this.opaque = props?.opaque || false;
        this.unescapable = props?.unescapable || false;
        this.backgroundAlpha = props?.backgroundAlpha;
        this.closeAnchor = props?.closeAnchor;
    }
}


class $a67de6ec9600469c$export$c8424c4d8ba2150 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager){
        super(guiManager), this.createContent = ()=>{
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            main.append("~~~~~~~~~~~~~~~~~~~").append("About Project Samsara").append("v2.0.0").append("~~~~~~~~~~~~~~~~~~~").append("Project Samsara is an experimental multiplayer combat game, in the vein").append("of its forebearers of the 90's, similar to Diablo I. This is about").append("that old feeling of blasting away the hordes, with or without your friends.").append("").append("...and also of blasting away your friends.").append("").append("The initial focus of this project is getting the gameplay mechanics right,").append("which is advancing your character's stats and equipment by completing the").append("game's challenges.").append("").append("Players will make decisions on what weapons, abilities, and equipment to").append("lean on in real-time during combat.").append("").append("There is a storyline in the works, which can be enjoyed as part of the").append("optional exploration aspect of this world that is yet to be developed.").append("").append("Stick with me as I evolve this game. Drop me a line at").appendLink("project-samsara@olioapps.com", "mailto:project-samsara@olioapps.com").append(", join the ", true).appendLink("project subreddit", "https://www.reddit.com/r/projectsamsara/", true).append(" or ", true).appendLink("discord channel", "https://discord.gg/Mbt6UfqW6e").append(" for latest developments!", true);
            return main;
        };
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");
const $d4e9bfba8663fd0e$var$MAX_PARTICLES = 30;
const $d4e9bfba8663fd0e$var$SPAWN_RATE = 48 // particles/sec at full intensity
;
const $d4e9bfba8663fd0e$export$c8b3142d2b0d3df4 = (lifeFrac)=>lifeFrac > 0.8 ? 0xfff6d0 : lifeFrac > 0.55 ? 0xffd23c : lifeFrac > 0.3 ? 0xff8a1e : 0xe33a12;
class $d4e9bfba8663fd0e$export$180e4127bb338fb5 extends (0, $gwPoJ.Graphics) {
    // `glow` draws the layered warm halo behind the particles (the roster card wants it; the in-world
    // campfire flame bakes with glow off so only the particles render — see FireSprite).
    constructor(width, height, { glow: glow = true } = {}){
        super(), this.particles = [], this.spawnAccumulator = 0, this._t = 0, this.spawn = ()=>{
            const cx = this.w / 2;
            this.particles.push({
                x: cx + (Math.random() - 0.5) * this.w * 0.85,
                y: this.h - Math.random() * 6,
                vx: (Math.random() - 0.5) * 0.01,
                vy: -(0.02 + Math.random() * 0.035),
                life: 0,
                maxLife: 650 + Math.random() * 800,
                size: 3.5 + Math.random() * 3.5
            });
        }, this.update = (dtMs, intensity)=>{
            const dt = Math.min(dtMs, 50) // clamp big frame gaps so particles don't jump
            ;
            const i = Math.max(0, Math.min(1, intensity));
            const target = Math.round($d4e9bfba8663fd0e$var$MAX_PARTICLES * i);
            // advance + cull
            this.particles = this.particles.filter((p)=>{
                p.life += dt;
                p.x += p.vx * dt;
                p.y += p.vy * dt;
                return p.life < p.maxLife && p.y > -3;
            });
            // spawn toward the target at a rate proportional to intensity
            this.spawnAccumulator += dt / 1000 * $d4e9bfba8663fd0e$var$SPAWN_RATE * i;
            while(this.spawnAccumulator >= 1){
                this.spawnAccumulator -= 1;
                if (this.particles.length < target) this.spawn();
            }
            // redraw
            this.clear();
            if (i <= 0) return;
            // Warm glow rising from the bottom-centre — this is the "backdrop" that dims with weak fire.
            // A gentle flicker keeps it alive even when few particles are around.
            if (this.showGlow) {
                const flicker = 0.85 + 0.15 * Math.sin(this._t + Math.random());
                this._t += 0.15;
                const gx = this.w / 2;
                const gy = this.h * 0.72;
                const glowR = this.w * 0.85;
                // Layered warm glow, brightest at the core (additive, so these stack toward white).
                this.beginFill(0xff4a12, 0.3 * i * flicker);
                this.drawEllipse(gx, gy, glowR, glowR * 0.95);
                this.endFill();
                this.beginFill(0xff8a24, 0.32 * i * flicker);
                this.drawEllipse(gx, gy + 3, glowR * 0.62, glowR * 0.74);
                this.endFill();
                this.beginFill(0xffcf5a, 0.34 * i * flicker);
                this.drawEllipse(gx, gy + 6, glowR * 0.34, glowR * 0.5);
                this.endFill();
            }
            // particles
            for (const p of this.particles){
                const lifeFrac = 1 - p.life / p.maxLife // 1 young -> 0 old
                ;
                const alpha = lifeFrac * 0.9 * i;
                const r = p.size * (0.5 + 0.5 * lifeFrac);
                this.beginFill($d4e9bfba8663fd0e$export$c8b3142d2b0d3df4(lifeFrac), alpha);
                this.drawCircle(p.x, p.y, r);
                this.endFill();
            }
        };
        this.w = width;
        this.h = height;
        this.showGlow = glow;
        // Additive blending: warm colours glow against the dark card and overlapping particles /
        // glow accumulate toward white — the classic bright-fire look.
        this.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $2b3f66371c8d7b60$export$fe2b06ef7574cc0e extends (0, $gwPoJ.Graphics) {
    // Frame hook, only called while this page is the one on screen.
    animate(_dtMs) {
    //
    }
    tearDown() {
    //
    }
    // Free the per-instance Text textures of the last draw before rebuilding (they are not GC'd).
    wipe() {
        [
            ...this.children
        ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
        this.removeChildren();
    }
}


// Grid maths for the palette picker. Pure (no pixi), so the awkward cases -- a palette of two, a
// palette of seventy-six, a box too short for a single row -- are unit-tested rather than eyeballed.
const $e9b2f8e011d0ad84$export$2ad821b5ee3abcf6 = (spec)=>{
    const gapX = spec.gapX ?? 6;
    const gapY = spec.gapY ?? 6;
    const count = Math.max(0, spec.count);
    // Widest grid whose cells still clear minCellWidth.
    let cols = Math.max(1, Math.floor((spec.width + gapX) / (spec.minCellWidth + gapX)));
    // A short palette shouldn't be spread over more columns than it has entries.
    cols = Math.max(1, Math.min(cols, count || 1));
    let cellWidth = (spec.width - (cols - 1) * gapX) / cols;
    if (spec.maxCellWidth !== undefined) cellWidth = Math.min(cellWidth, spec.maxCellWidth);
    const rows = Math.max(1, Math.floor((spec.height + gapY) / (spec.cellHeight + gapY)));
    const perPage = cols * rows;
    const pages = Math.max(1, Math.ceil(count / perPage));
    const usedRows = Math.max(1, Math.min(rows, Math.ceil(count / cols)));
    return {
        cols: cols,
        rows: rows,
        usedRows: usedRows,
        cellWidth: cellWidth,
        perPage: perPage,
        pages: pages,
        height: usedRows * spec.cellHeight + (usedRows - 1) * gapY
    };
};
const $e9b2f8e011d0ad84$export$2660a47c412cb681 = (items, layout, page)=>{
    const safePage = Math.max(0, Math.min(page, layout.pages - 1));
    const start = safePage * layout.perPage;
    return items.slice(start, start + layout.perPage);
};
const $e9b2f8e011d0ad84$export$da4afb51d4f9da58 = (index, layout, cellHeight, gapX = 6, gapY = 6)=>({
        x: index % layout.cols * (layout.cellWidth + gapX),
        y: Math.floor(index / layout.cols) * (cellHeight + gapY)
    });


const $ee6ea042cf422424$export$dd27ce85ad53c944 = 0xf2a94e;
const $ee6ea042cf422424$export$640631a81002c59c = 0x6b4f38;
const $ee6ea042cf422424$export$4389bfa33b3049ea = 0x120d0a;
const $ee6ea042cf422424$export$35cf6b4f538836cd = 0x1b1512;
const $ee6ea042cf422424$export$50b2007dd9e18f6b = 0.92;
const $ee6ea042cf422424$export$47e6a71c2ae4bc1f = 0x2a201a;
const $ee6ea042cf422424$export$fc0b8fefbf3a9f6a = 0x3a2c21;
const $ee6ea042cf422424$export$4623f99f39ff0c85 = 0x54402e;
const $ee6ea042cf422424$export$d597759d33be802e = 0xfff3e0;
const $ee6ea042cf422424$export$2032e0ed6548abf9 = 0xb49b83;
const $ee6ea042cf422424$export$6b1a2b07ad04beea = 0xffd27a;
const $ee6ea042cf422424$export$64abe9059de17029 = 0x4a3113;
const $ee6ea042cf422424$export$35aa3e8070dd3c30 = 780;
const $ee6ea042cf422424$export$8a4e6245b38ca3f5 = 420;
const $ee6ea042cf422424$export$341c383d1f147954 = 34;
const $ee6ea042cf422424$export$7900c34204647a1b = 42;
const $ee6ea042cf422424$export$2c2fdba2e52ddfba = $ee6ea042cf422424$export$341c383d1f147954 + 10;
const $ee6ea042cf422424$export$343fef082e4bb475 = $ee6ea042cf422424$export$8a4e6245b38ca3f5 - $ee6ea042cf422424$export$7900c34204647a1b - $ee6ea042cf422424$export$2c2fdba2e52ddfba;
const $ee6ea042cf422424$export$7e244b51fe9b8780 = 8;
const $ee6ea042cf422424$export$d35e9f16aaee0022 = 176;
const $ee6ea042cf422424$export$de7d1b6c57f828f4 = 232;
const $ee6ea042cf422424$export$c212ee05c579f421 = $ee6ea042cf422424$export$35aa3e8070dd3c30 - $ee6ea042cf422424$export$d35e9f16aaee0022 - $ee6ea042cf422424$export$de7d1b6c57f828f4 - 2 * $ee6ea042cf422424$export$7e244b51fe9b8780;
const $ee6ea042cf422424$export$dcc2b41e4d83d427 = 0;
const $ee6ea042cf422424$export$f3a8244e0a259e49 = $ee6ea042cf422424$export$d35e9f16aaee0022 + $ee6ea042cf422424$export$7e244b51fe9b8780;
const $ee6ea042cf422424$export$1a7bb33882f2a323 = $ee6ea042cf422424$export$f3a8244e0a259e49 + $ee6ea042cf422424$export$de7d1b6c57f828f4 + $ee6ea042cf422424$export$7e244b51fe9b8780;
const $ee6ea042cf422424$export$348bab8f5b4627be = {
    white: 0xf9d5ba,
    light: 0xfdd5b7,
    tan: 0xfdd082,
    olive: 0xd98e60,
    dark: 0xba8454,
    brown: 0xa86431,
    black: 0x61382d
};
const $ee6ea042cf422424$export$c597f79f1052724f = {
    white: 0xd8dcdc,
    blonde: 0xfccf56,
    gold: 0xe8c31a,
    green: 0x2f8f2f,
    blue: 0x2f7fcb,
    red: 0xe21414,
    orange: 0xe55600,
    purple: 0xa966dd,
    brown: 0x6d2f0d,
    lightbrown: 0xae682a,
    gray: 0xaaaaaa,
    black: 0x31313e
};
const $ee6ea042cf422424$export$7a6359c34632213c = {
    black: 0x4a5057,
    blue: 0x61a0ef,
    brown: 0x996b4a,
    gray: 0xa2a0a4,
    green: 0x64a42c,
    maroon: 0xae424a,
    orange: 0xef7e19,
    purple: 0x813089,
    red: 0xcd2429,
    tan: 0xb78c41,
    teal: 0x00cfdf,
    white: 0xe5e6c7,
    yellow: 0xf3c03f,
    gold: 0xe0b23c,
    metal: 0xc9ccd6,
    silver: 0xd9dde3,
    olive: 0x6b6b32,
    lightbrown: 0x9b6b3a,
    lightgreen: 0x8ed07a,
    light: 0xe8e0d0,
    dark: 0x3b3b44,
    pink: 0xe89bbd,
    blonde: 0xe7c98a,
    na: 0x808080
};
const $ee6ea042cf422424$var$FAMILY_MAP = {
    skin: $ee6ea042cf422424$export$348bab8f5b4627be,
    hair: $ee6ea042cf422424$export$c597f79f1052724f,
    cloth: $ee6ea042cf422424$export$7a6359c34632213c
};
const $ee6ea042cf422424$export$ff0eb67b170646b7 = (family, color)=>$ee6ea042cf422424$var$FAMILY_MAP[family][color] ?? $ee6ea042cf422424$export$7a6359c34632213c[color] ?? 0x808080;
// Hand-written names for the values whose raw ids are either unreadable or far too long for a chip.
const $ee6ea042cf422424$var$NICE_NAMES = {
    none: "None",
    "pants-armor": "Armored",
    "shoes-armor": "Armored",
    skirts: "Skirt",
    scoop_shirt: "Scoop Neck",
    blouse_longsleeve: "Long Blouse",
    longsleeve_laced: "Laced",
    sleeveless_laced: "Laced Vest",
    sleeveless_striped: "Striped",
    bob_side_part: "Side Bob",
    curly_long: "Long Curls",
    curly_short: "Short Curls",
    curtains_long: "Long Curtains",
    dreadlocks_long: "Long Dreads",
    dreadlocks_short: "Dreads",
    flat_top_fade: "Flat Fade",
    flat_top_straight: "Flat Top",
    high_and_tight: "High & Tight",
    high_ponytail: "High Tail",
    long_center_part: "Center Part",
    long_messy: "Messy Long",
    long_messy2: "Messy Long 2",
    spiked_beehive: "Beehive",
    spiked_liberty: "Liberty",
    spiked_liberty2: "Liberty 2",
    spiked_porcupine: "Porcupine",
    twists_straight: "Twists",
    twists_fade: "Twist Fade",
    lightbrown: "Light Brown",
    lightgreen: "Light Green",
    half_up: "Half Up",
    bangs_bun: "Bangs Bun"
};
const $ee6ea042cf422424$export$9e764535c6c076b3 = (value)=>{
    if (!value) return "None";
    const nice = $ee6ea042cf422424$var$NICE_NAMES[value];
    if (nice) return nice;
    return value.split(/[-_]/).map((word)=>word.replace(/(\d+)$/, " $1")).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};






const $e8dc6d9c289fb887$export$c53d0f541b41b88e = "none";
const $e8dc6d9c289fb887$export$5b887099a2508732 = [
    "sex",
    "skin",
    "hair",
    "eyes",
    "nose",
    "shirt",
    "pants",
    "shoes"
];
const $e8dc6d9c289fb887$var$TRAIT_META = {
    sex: {
        label: "Build",
        icon: "\uD83E\uDDCD"
    },
    skin: {
        label: "Skin",
        icon: "\uD83C\uDFA8"
    },
    hair: {
        label: "Hair",
        icon: "\uD83D\uDC87"
    },
    eyes: {
        label: "Eyes",
        icon: "\uD83D\uDC41"
    },
    nose: {
        label: "Nose",
        icon: "\uD83D\uDC43"
    },
    shirt: {
        label: "Shirt",
        icon: "\uD83D\uDC55"
    },
    pants: {
        label: "Legs",
        icon: "\uD83D\uDC56"
    },
    shoes: {
        label: "Feet",
        icon: "\uD83D\uDC62"
    }
};
const $e8dc6d9c289fb887$var$GARMENT_CLASS = {
    shirt: "shirt",
    pants: "pants",
    shoes: "shoes"
};
// Colours a given garment type can be painted. The sheets only exist in these, so offering more
// would silently fall back to the first one.
const $e8dc6d9c289fb887$var$garmentColors = (itemClass, type)=>{
    if (!type || type === $e8dc6d9c289fb887$export$c53d0f541b41b88e) return [];
    if (itemClass === "shirt") return (0, $bf6244e5cc9aa116$export$b4dd93b72d5ba14d)[type] || [];
    if (itemClass === "pants") return (0, $bf6244e5cc9aa116$export$7ef85edc405cda8b)[type] || [];
    if (itemClass === "shoes") return (0, $bf6244e5cc9aa116$export$d9113a8608ba3a3c)[type] || [];
    return [];
};
// Types a garment can be, for this character's sex. Shirts and shoes may be left off; trousers of
// some kind are not optional.
const $e8dc6d9c289fb887$var$garmentTypes = (itemClass, sex)=>{
    if (itemClass === "shirt") return [
        ...(0, $bf6244e5cc9aa116$export$6e1561754c81021d)[sex],
        $e8dc6d9c289fb887$export$c53d0f541b41b88e
    ];
    if (itemClass === "pants") return [
        ...(0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)[sex]
    ];
    if (itemClass === "shoes") return [
        ...(0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)[sex],
        $e8dc6d9c289fb887$export$c53d0f541b41b88e
    ];
    return [];
};
const $e8dc6d9c289fb887$var$styleSection = (title, values, selected)=>({
        kind: "style",
        title: title,
        options: values.map((value)=>({
                value: value,
                label: (0, $ee6ea042cf422424$export$9e764535c6c076b3)(value)
            })),
        selected: selected || $e8dc6d9c289fb887$export$c53d0f541b41b88e
    });
const $e8dc6d9c289fb887$var$colorSection = (title, family, values, selected)=>({
        kind: "color",
        title: title,
        options: values.map((value)=>({
                value: value,
                label: (0, $ee6ea042cf422424$export$9e764535c6c076b3)(value),
                swatch: (0, $ee6ea042cf422424$export$ff0eb67b170646b7)(family, value)
            })),
        selected: selected || ""
    });
const $e8dc6d9c289fb887$export$4cb82e77282accdd = (entity, id)=>{
    const { label: label, icon: icon } = $e8dc6d9c289fb887$var$TRAIT_META[id];
    const appearance = entity.appearance;
    const sex = appearance.sex;
    const race = appearance.race;
    const view = (summary, sections, swatch)=>({
            id: id,
            label: label,
            icon: icon,
            summary: summary,
            swatch: swatch,
            sections: sections
        });
    if (id === "sex") return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(sex), [
        $e8dc6d9c289fb887$var$styleSection("Build", [
            ...(0, $bf6244e5cc9aa116$export$32cdec3d782e201f)
        ], sex)
    ]);
    if (id === "skin") {
        const colors = (0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[race] || [];
        return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(appearance.bodyColor), [
            $e8dc6d9c289fb887$var$colorSection("Skin tone", "skin", colors, appearance.bodyColor)
        ], (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("skin", appearance.bodyColor));
    }
    if (id === "hair") {
        const styles = [
            $e8dc6d9c289fb887$export$c53d0f541b41b88e,
            ...(0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex]
        ];
        const sections = [
            $e8dc6d9c289fb887$var$styleSection("Style", styles, appearance.hair || $e8dc6d9c289fb887$export$c53d0f541b41b88e)
        ];
        if (appearance.hair) sections.push($e8dc6d9c289fb887$var$colorSection("Colour", "hair", (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[appearance.hair], appearance.hairColor));
        return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(appearance.hair || $e8dc6d9c289fb887$export$c53d0f541b41b88e), sections, appearance.hair ? (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("hair", appearance.hairColor) : undefined);
    }
    if (id === "eyes") {
        const colors = (0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[appearance.eyes || "normal"] || [];
        return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(appearance.eyesColor), [
            $e8dc6d9c289fb887$var$colorSection("Eye colour", "cloth", colors, appearance.eyesColor)
        ], (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("cloth", appearance.eyesColor));
    }
    if (id === "nose") {
        const noses = [
            $e8dc6d9c289fb887$export$c53d0f541b41b88e,
            ...(0, $bf6244e5cc9aa116$export$523e552deae170d8)[race] || []
        ];
        return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(appearance.nose || $e8dc6d9c289fb887$export$c53d0f541b41b88e), [
            $e8dc6d9c289fb887$var$styleSection("Shape", noses, appearance.nose || $e8dc6d9c289fb887$export$c53d0f541b41b88e)
        ]);
    }
    // shirt / pants / shoes
    const itemClass = $e8dc6d9c289fb887$var$GARMENT_CLASS[id];
    const worn = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, itemClass);
    const type = worn?.type;
    const sections = [
        $e8dc6d9c289fb887$var$styleSection("Cut", $e8dc6d9c289fb887$var$garmentTypes(itemClass, sex), type || $e8dc6d9c289fb887$export$c53d0f541b41b88e)
    ];
    const colors = $e8dc6d9c289fb887$var$garmentColors(itemClass, type);
    if (colors.length > 0) sections.push($e8dc6d9c289fb887$var$colorSection("Colour", "cloth", colors, worn?.color));
    return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(type || $e8dc6d9c289fb887$export$c53d0f541b41b88e), sections, worn?.color ? (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("cloth", worn.color) : undefined);
};
const $e8dc6d9c289fb887$export$d0a4aaa8f938be7a = (entity)=>$e8dc6d9c289fb887$export$5b887099a2508732.map((id)=>$e8dc6d9c289fb887$export$4cb82e77282accdd(entity, id));
// Swap what the character wears in one slot. Removing first keeps a single active item per class,
// and both helpers refresh the inventory-appearance hash the server reads.
const $e8dc6d9c289fb887$var$equip = (entity, itemClass, type, preferredColor)=>{
    const existing = (0, $f684496fff50a7a1$export$ff6824850c0111da)(entity.inventory, itemClass);
    if (existing) (0, $f684496fff50a7a1$export$6d9780a2b50e0c6e)(entity, existing.id);
    if (!type || type === $e8dc6d9c289fb887$export$c53d0f541b41b88e) return;
    const colors = $e8dc6d9c289fb887$var$garmentColors(itemClass, type);
    const color = preferredColor && colors.includes(preferredColor) ? preferredColor : colors[0];
    const itemTypeMeta = {
        type: type,
        class: itemClass,
        color: color
    };
    (0, $f684496fff50a7a1$export$73ce97a5e6b0458a)(entity, {
        id: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
        itemType: "none",
        itemTypeMeta: itemTypeMeta,
        quantity: 1,
        active: true
    });
};
const $e8dc6d9c289fb887$export$f90ea17b26c746f3 = (entity)=>{
    const appearance = entity.appearance;
    const sex = appearance.sex;
    if (appearance.hair && !(0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex].includes(appearance.hair)) appearance.hair = (0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex][0];
    [
        "shirt",
        "pants",
        "shoes"
    ].forEach((itemClass)=>{
        const worn = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, itemClass);
        const allowed = $e8dc6d9c289fb887$var$garmentTypes(itemClass, sex);
        if (!worn) {
            // Trousers are the one slot nobody goes without.
            if (itemClass === "pants") $e8dc6d9c289fb887$var$equip(entity, itemClass, allowed[0]);
            return;
        }
        if (!allowed.includes(worn.type)) $e8dc6d9c289fb887$var$equip(entity, itemClass, allowed[0], worn.color);
    });
};
const $e8dc6d9c289fb887$export$5ca4f74dfb7adac4 = (entity, id, kind, value)=>{
    const appearance = entity.appearance;
    if (id === "sex") {
        appearance.sex = value;
        $e8dc6d9c289fb887$export$f90ea17b26c746f3(entity);
        return;
    }
    if (id === "skin") {
        appearance.bodyColor = value;
        // The nose is a separate sheet tinted to match the body; left alone it floats as a different
        // colour patch on the face.
        appearance.noseColor = value;
        return;
    }
    if (id === "hair") {
        if (kind === "color") {
            appearance.hairColor = value;
            return;
        }
        if (value === $e8dc6d9c289fb887$export$c53d0f541b41b88e) {
            appearance.hair = undefined;
            return;
        }
        appearance.hair = value;
        const colors = (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[appearance.hair];
        if (!colors?.includes(appearance.hairColor)) appearance.hairColor = colors?.[0];
        return;
    }
    if (id === "eyes") {
        appearance.eyesColor = value;
        return;
    }
    if (id === "nose") {
        appearance.nose = value === $e8dc6d9c289fb887$export$c53d0f541b41b88e ? undefined : value;
        appearance.noseColor = appearance.bodyColor;
        return;
    }
    const itemClass = $e8dc6d9c289fb887$var$GARMENT_CLASS[id];
    const worn = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, itemClass);
    if (kind === "color") {
        $e8dc6d9c289fb887$var$equip(entity, itemClass, worn?.type, value);
        return;
    }
    $e8dc6d9c289fb887$var$equip(entity, itemClass, value, worn?.color);
};


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");



const $e0fb6921b9eca6b1$export$6f093cfa640b7166 = (value, { size: size = 11, color: color = (0, $ee6ea042cf422424$export$d597759d33be802e), bold: bold = false, wrap: wrap } = {})=>{
    // No black outline. Every label on this screen sits on a flat panel or chip, so the stroke buys
    // nothing -- and on the light fills (a primary pill, a selected chip, a numbered badge) it wraps
    // the dark ink in a halo of its own colour, which smears small bold type into a blur.
    const renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(color).fontSize(size).strokeThickness(0);
    if (bold) renderer.bold();
    if (wrap !== undefined) // Set at build time: poking style.wordWrap afterwards re-rasterizes the Text.
    renderer.wordWrap(wrap);
    return renderer.render(value);
};
const $e0fb6921b9eca6b1$export$b94583dc679500d = (label, maxWidth, minScale = 0.78)=>{
    if (label.width <= maxWidth || label.width === 0) return;
    const scale = Math.max(minScale, maxWidth / label.width);
    label.scale.set(scale);
    if (label.width <= maxWidth) return;
    const source = label.text;
    for(let cut = source.length - 1; cut > 1; cut--){
        label.text = `${source.slice(0, cut).trimEnd()}\u{2026}`;
        if (label.width <= maxWidth) return;
    }
};
const $e0fb6921b9eca6b1$export$7fbfc7da7d3c2e5e = (label, boxX, boxWidth, y)=>{
    label.x = Math.round(boxX + (boxWidth - label.width) / 2);
    label.y = Math.round(y);
};
const $e0fb6921b9eca6b1$export$3cd4174479c25cc8 = (g, x, y, w, h, { radius: radius = 10, rim: rim = (0, $ee6ea042cf422424$export$640631a81002c59c), rimAlpha: rimAlpha = 0.75, glow: glow = true, fill: fill = (0, $ee6ea042cf422424$export$35cf6b4f538836cd), fillAlpha: fillAlpha = (0, $ee6ea042cf422424$export$50b2007dd9e18f6b) } = {})=>{
    if (glow) {
        g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.05);
        g.drawRoundedRect(x - 4, y - 4, w + 8, h + 8, radius + 4);
        g.endFill();
    }
    g.lineStyle(1.5, rim, rimAlpha);
    g.beginFill(fill, fillAlpha);
    g.drawRoundedRect(x, y, w, h, radius);
    g.endFill();
    g.lineStyle(0);
};
const $e0fb6921b9eca6b1$export$300ac6f106ef584d = (title, width)=>{
    const container = new (0, $8t5Gy.Container)();
    const label = $e0fb6921b9eca6b1$export$6f093cfa640b7166(title.toUpperCase(), {
        size: 9,
        color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
        bold: true
    });
    label.alpha = 0.9;
    container.addChild(label);
    const rule = new (0, $gwPoJ.Graphics)();
    rule.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.5);
    rule.drawRect(label.width + 8, Math.round(label.height / 2), Math.max(0, width - label.width - 8), 1);
    rule.endFill();
    container.addChild(rule);
    return container;
};
class $e0fb6921b9eca6b1$export$f1b71a6df9b30e88 extends (0, $8t5Gy.Container) {
    constructor(label, props){
        super(), this.hovered = false;
        this.props = props;
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        const caption = $e0fb6921b9eca6b1$export$6f093cfa640b7166(label, {
            size: 10,
            color: props.selected ? 0x2a1c0c : (0, $ee6ea042cf422424$export$d597759d33be802e)
        });
        $e0fb6921b9eca6b1$export$b94583dc679500d(caption, props.width - 12);
        $e0fb6921b9eca6b1$export$7fbfc7da7d3c2e5e(caption, 0, props.width, (props.height - caption.height) / 2);
        this.addChild(caption);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, props.width, props.height);
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw();
    }
    draw() {
        const { width: width, height: height, selected: selected } = this.props;
        const g = this.bg;
        g.clear();
        if (selected) {
            g.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.18);
            g.drawRoundedRect(-3, -3, width + 6, height + 6, 9);
            g.endFill();
            g.lineStyle(1.5, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 1);
            g.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.92);
        } else {
            g.lineStyle(1, this.hovered ? (0, $ee6ea042cf422424$export$dd27ce85ad53c944) : (0, $ee6ea042cf422424$export$4623f99f39ff0c85), this.hovered ? 0.9 : 0.6);
            g.beginFill(this.hovered ? (0, $ee6ea042cf422424$export$fc0b8fefbf3a9f6a) : (0, $ee6ea042cf422424$export$47e6a71c2ae4bc1f), 0.95);
        }
        g.drawRoundedRect(0, 0, width, height, 6);
        g.endFill();
        g.lineStyle(0);
    }
}
class $e0fb6921b9eca6b1$export$43e54f70144d08dc extends (0, $8t5Gy.Container) {
    constructor(color, props){
        super(), this.hovered = false;
        this.props = {
            ...props,
            color: color
        };
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, props.width, props.height);
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw();
    }
    draw() {
        const { width: width, height: height, selected: selected, color: color } = this.props;
        const g = this.bg;
        g.clear();
        if (selected || this.hovered) {
            g.beginFill(selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : (0, $ee6ea042cf422424$export$dd27ce85ad53c944), selected ? 0.3 : 0.16);
            g.drawRoundedRect(-4, -4, width + 8, height + 8, 9);
            g.endFill();
        }
        g.lineStyle(selected ? 2 : 1, selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : this.hovered ? (0, $ee6ea042cf422424$export$dd27ce85ad53c944) : 0x000000, selected ? 1 : 0.55);
        g.beginFill(color, 1);
        g.drawRoundedRect(0, 0, width, height, 5);
        g.endFill();
        // Inner highlight: a hairline of light along the top edge so flat colours read as objects.
        g.lineStyle(1, 0xffffff, 0.18);
        g.moveTo(3, 2);
        g.lineTo(width - 3, 2);
        g.lineStyle(0);
    }
}
class $e0fb6921b9eca6b1$export$35081c78d70f9c8b extends (0, $8t5Gy.Container) {
    constructor(props){
        super(), this.hovered = false;
        const { width: width, height: height, selected: selected } = props;
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        const icon = $e0fb6921b9eca6b1$export$6f093cfa640b7166(props.icon, {
            size: 13
        });
        icon.x = 9;
        icon.y = Math.round((height - icon.height) / 2);
        this.addChild(icon);
        const name = $e0fb6921b9eca6b1$export$6f093cfa640b7166(props.label, {
            size: 11,
            color: selected ? 0xfff6e5 : (0, $ee6ea042cf422424$export$d597759d33be802e),
            bold: selected
        });
        name.x = 32;
        name.y = Math.round((height - name.height) / 2) - 5;
        this.addChild(name);
        const summary = $e0fb6921b9eca6b1$export$6f093cfa640b7166(props.summary, {
            size: 9,
            color: selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        const summaryRight = props.swatch !== undefined ? width - 24 : width - 10;
        $e0fb6921b9eca6b1$export$b94583dc679500d(summary, summaryRight - 32);
        summary.x = 32;
        summary.y = name.y + 13;
        this.addChild(summary);
        if (props.swatch !== undefined) {
            const dot = new (0, $gwPoJ.Graphics)();
            dot.lineStyle(1, 0x000000, 0.4);
            dot.beginFill(props.swatch, 1);
            dot.drawCircle(width - 15, height / 2, 6);
            dot.endFill();
            this.addChild(dot);
        }
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, width, height);
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw(props);
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw(props);
        });
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw(props);
    }
    draw(props) {
        const { width: width, height: height, selected: selected } = props;
        const g = this.bg;
        g.clear();
        if (selected) {
            g.beginFill((0, $ee6ea042cf422424$export$64abe9059de17029), 0.95);
            g.drawRoundedRect(0, 0, width, height, 7);
            g.endFill();
            // Amber spine on the selected row, pointing at the palette it opened.
            g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 1);
            g.drawRoundedRect(0, 4, 3, height - 8, 1.5);
            g.endFill();
        } else if (this.hovered) {
            g.beginFill((0, $ee6ea042cf422424$export$fc0b8fefbf3a9f6a), 0.8);
            g.drawRoundedRect(0, 0, width, height, 7);
            g.endFill();
        }
    }
}
// How far a footer button's tap target is grown past its pill on touch. See the note in the
// constructor: padX is half the footer's 8px inter-button gap, padY is free space.
const $e0fb6921b9eca6b1$var$TOUCH_PAD_X = 4;
const $e0fb6921b9eca6b1$var$TOUCH_PAD_Y = 10;
class $e0fb6921b9eca6b1$export$c5e39530e713771e extends (0, $8t5Gy.Container) {
    constructor(props){
        super(), this.hovered = false;
        const height = props.height ?? 26;
        const caption = $e0fb6921b9eca6b1$export$6f093cfa640b7166(props.label, {
            size: 11,
            color: props.primary ? 0x2a1c0c : (0, $ee6ea042cf422424$export$d597759d33be802e),
            bold: !!props.primary
        });
        const width = Math.round(caption.width + 26);
        this.boxWidth = width;
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        $e0fb6921b9eca6b1$export$7fbfc7da7d3c2e5e(caption, 0, width, (height - caption.height) / 2);
        this.addChild(caption);
        this.interactive = true;
        this.cursor = "pointer";
        // Under a thumb the tap target is grown well past the pill, without moving the pill: these
        // are the buttons the whole character-creation flow is driven by ("Forge your character",
        // "Take the road", "Let's go"), and at 26 stage pixels tall they land at roughly 27 CSS px
        // on a phone -- a little over half what a touch target wants, and missed as often as hit.
        //
        // Horizontal padding is exactly half the 8px the footer leaves between buttons, so adjacent
        // targets meet without overlapping. An overlap would quietly hand taps in the gap to
        // whichever button happened to be added last.
        const padX = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? $e0fb6921b9eca6b1$var$TOUCH_PAD_X : 0;
        const padY = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? $e0fb6921b9eca6b1$var$TOUCH_PAD_Y : 0;
        this.hitArea = new (0, $6qzqq.Rectangle)(-padX, -padY, width + padX * 2, height + padY * 2);
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw(width, height, !!props.primary);
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw(width, height, !!props.primary);
        });
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw(width, height, !!props.primary);
    }
    draw(width, height, primary) {
        const g = this.bg;
        g.clear();
        if (primary) {
            g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), this.hovered ? 0.3 : 0.18);
            g.drawRoundedRect(-4, -4, width + 8, height + 8, height / 2 + 4);
            g.endFill();
            g.lineStyle(1.5, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 1);
            g.beginFill(this.hovered ? 0xffdf9b : (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 1);
        } else {
            g.lineStyle(1.5, this.hovered ? (0, $ee6ea042cf422424$export$dd27ce85ad53c944) : (0, $ee6ea042cf422424$export$4623f99f39ff0c85), this.hovered ? 1 : 0.8);
            g.beginFill(this.hovered ? (0, $ee6ea042cf422424$export$fc0b8fefbf3a9f6a) : (0, $ee6ea042cf422424$export$47e6a71c2ae4bc1f), 0.9);
        }
        g.drawRoundedRect(0, 0, width, height, height / 2);
        g.endFill();
        g.lineStyle(0);
    }
}
class $e0fb6921b9eca6b1$export$57625d62e5386b09 extends (0, $8t5Gy.Container) {
    constructor(props){
        super();
        const { page: page, pages: pages, onPage: onPage } = props;
        const arrow = (glyph, enabled, target)=>{
            const button = new (0, $8t5Gy.Container)();
            const g = new (0, $gwPoJ.Graphics)();
            g.lineStyle(1, enabled ? (0, $ee6ea042cf422424$export$4623f99f39ff0c85) : 0x2a2018, 0.8);
            g.beginFill((0, $ee6ea042cf422424$export$47e6a71c2ae4bc1f), enabled ? 0.9 : 0.4);
            g.drawRoundedRect(0, 0, 18, 18, 5);
            g.endFill();
            button.addChild(g);
            const caption = $e0fb6921b9eca6b1$export$6f093cfa640b7166(glyph, {
                size: 11,
                color: enabled ? (0, $ee6ea042cf422424$export$d597759d33be802e) : 0x584a3c
            });
            $e0fb6921b9eca6b1$export$7fbfc7da7d3c2e5e(caption, 0, 18, (18 - caption.height) / 2);
            button.addChild(caption);
            if (enabled) {
                button.interactive = true;
                button.cursor = "pointer";
                button.hitArea = new (0, $6qzqq.Rectangle)(0, 0, 18, 18);
                button.on("pointerdown", (event)=>{
                    event?.stopPropagation?.();
                    onPage(target);
                });
            }
            return button;
        };
        const left = arrow("\u2039", page > 0, page - 1);
        this.addChild(left);
        const counter = $e0fb6921b9eca6b1$export$6f093cfa640b7166(`${page + 1} / ${pages}`, {
            size: 9,
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        counter.x = 24;
        counter.y = Math.round((18 - counter.height) / 2);
        this.addChild(counter);
        const right = arrow("\u203A", page < pages - 1, page + 1);
        right.x = 28 + counter.width;
        this.addChild(right);
        this.boxWidth = right.x + 18;
    }
}


// The character forge: the trait list on the left, the character on a lit stage in the middle, and
// the palette for whichever trait is open on the right.
//
// Two things drive the design. The character always faces the viewer -- you are looking at the face
// you are building, not at whichever way the mouse last pointed. And every trait opens as a PALETTE:
// all of its choices laid out at once as chips and colour swatches, one click each, instead of a
// pair of arrows to cycle through.
const $c025c38ccd2d28a7$var$PANEL_PAD = 8;
const $c025c38ccd2d28a7$var$ROW_H = 36;
const $c025c38ccd2d28a7$var$ROW_GAP = 3;
const $c025c38ccd2d28a7$var$PALETTE_PAD = 14;
const $c025c38ccd2d28a7$var$PALETTE_INNER_W = (0, $ee6ea042cf422424$export$c212ee05c579f421) - $c025c38ccd2d28a7$var$PALETTE_PAD * 2;
const $c025c38ccd2d28a7$var$PALETTE_TITLE_H = 38;
const $c025c38ccd2d28a7$var$STYLE_CELL_H = 24;
const $c025c38ccd2d28a7$var$STYLE_MIN_W = 76;
const $c025c38ccd2d28a7$var$COLOR_CELL = 24;
const $c025c38ccd2d28a7$var$GRID_GAP = 6;
const $c025c38ccd2d28a7$var$SECTION_HEAD_H = 14;
const $c025c38ccd2d28a7$var$SECTION_GAP = 10;
const $c025c38ccd2d28a7$var$PAGER_H = 22;
// The stage. The composite is drawn from the centre of its 64x64 frame, and a standing LPC figure's
// feet sit about 28px below that centre.
const $c025c38ccd2d28a7$var$COMPOSITE_SCALE = 3.4;
const $c025c38ccd2d28a7$var$FEET_OFFSET = 28 * $c025c38ccd2d28a7$var$COMPOSITE_SCALE;
const $c025c38ccd2d28a7$var$FEET_Y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 252;
const $c025c38ccd2d28a7$var$STAGE_CENTER_X = (0, $ee6ea042cf422424$export$f3a8244e0a259e49) + (0, $ee6ea042cf422424$export$de7d1b6c57f828f4) / 2;
const $c025c38ccd2d28a7$var$FLAME_H = 132;
class $c025c38ccd2d28a7$export$fd5a80e92d0a5c1d extends (0, $2b3f66371c8d7b60$export$fe2b06ef7574cc0e) {
    constructor(player){
        super(), this.pageId = "build", this.title = "Forge your character", this.hint = "Pick a trait, then pick from its palette", this.openTrait = "sex", // Palettes bigger than one page remember where each trait was left.
        this.pageIndex = {}, // Deep enough that editing the draft can't reach back into the live player's inventory (a
        // shallow copy shares the items array, so a new shirt would land on the player mid-creation).
        this.cloneForBuilder = (player)=>{
            const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            entity.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(90);
            entity.weapon = {
                weaponType: "none"
            };
            entity.appearance = {
                ...player.appearance || (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)(undefined, "human", "male")
            };
            entity.inventory = {
                items: (player.inventory?.items || []).map((item)=>({
                        ...item,
                        itemTypeMeta: item.itemTypeMeta ? {
                            ...item.itemTypeMeta
                        } : undefined
                    })),
                abilities: {
                    ...player.inventory?.abilities || {}
                },
                lastUpdateTs: 0
            };
            const appearance = entity.appearance;
            appearance.race = "human";
            // The eye layer is what the "Eyes" palette tints; an appearance that arrived without one has
            // nothing to colour.
            appearance.eyes = appearance.eyes || "normal";
            appearance.eyesColor = appearance.eyesColor || "brown";
            appearance.noseColor = appearance.bodyColor;
            if (entity.inventory.items.length < 1) entity.inventory.items = this.rollOutfit(entity);
            (0, $e8dc6d9c289fb887$export$f90ea17b26c746f3)(entity);
            return entity;
        }, this.rollOutfit = (entity)=>(0, $f684496fff50a7a1$export$eb64c22ff8ddddd4)(entity.appearance.sex, {
                pants: true,
                shirt: entity.appearance.sex === "male" ? (0, $cb689cfa16c444ba$export$30be1f861efc6479)(60) : true,
                shoe: true,
                weapon: true
            }), this.getAppearance = ()=>this.entity.appearance, this.getInventory = ()=>this.entity.inventory, this.lookSignature = ()=>JSON.stringify([
                this.entity.appearance,
                this.entity.inventory.items
            ]);
        this.entity = this.cloneForBuilder(player);
        this.flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)((0, $ee6ea042cf422424$export$de7d1b6c57f828f4) - 24, $c025c38ccd2d28a7$var$FLAME_H);
    }
    animate(dtMs) {
        // A low, steady hearth glow at the character's feet -- alive, but never competing with the
        // character for attention.
        this.flame.update(dtMs, 0.45);
    }
    tearDown() {
        this.openTrait = "sex";
    }
    // Detach the pieces that outlive a repaint before the rest of the page is disposed.
    wipe() {
        if (this.composite?.parent) this.composite.parent.removeChild(this.composite);
        if (this.flame?.parent) this.flame.parent.removeChild(this.flame);
        super.wipe();
    }
    build() {
        this.wipe();
        this.drawTraitList();
        this.drawStage();
        this.drawPalette();
        this.drawNav();
    }
    drawTraitList() {
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, (0, $ee6ea042cf422424$export$dcc2b41e4d83d427), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$d35e9f16aaee0022), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        this.addChild(panel);
        const views = (0, $e8dc6d9c289fb887$export$d0a4aaa8f938be7a)(this.entity);
        const listH = views.length * $c025c38ccd2d28a7$var$ROW_H + (views.length - 1) * $c025c38ccd2d28a7$var$ROW_GAP;
        let y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + Math.max($c025c38ccd2d28a7$var$PANEL_PAD, ((0, $ee6ea042cf422424$export$343fef082e4bb475) - listH) / 2);
        views.forEach((view)=>{
            const row = new (0, $e0fb6921b9eca6b1$export$35081c78d70f9c8b)({
                icon: view.icon,
                label: view.label,
                summary: view.summary,
                swatch: view.swatch,
                width: (0, $ee6ea042cf422424$export$d35e9f16aaee0022) - $c025c38ccd2d28a7$var$PANEL_PAD * 2,
                height: $c025c38ccd2d28a7$var$ROW_H,
                selected: view.id === this.openTrait,
                onClick: ()=>{
                    this.openTrait = view.id;
                    this.host.refresh();
                }
            });
            row.x = (0, $ee6ea042cf422424$export$dcc2b41e4d83d427) + $c025c38ccd2d28a7$var$PANEL_PAD;
            row.y = y;
            this.addChild(row);
            y += $c025c38ccd2d28a7$var$ROW_H + $c025c38ccd2d28a7$var$ROW_GAP;
        });
    }
    drawStage() {
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, (0, $ee6ea042cf422424$export$f3a8244e0a259e49), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$de7d1b6c57f828f4), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        this.addChild(panel);
        // Warm pool of light the character stands in, drawn as a few stacked ellipses (cheaper than
        // a blur, and it reads as firelight from below).
        const glow = new (0, $gwPoJ.Graphics)();
        glow.beginFill(0xff8a24, 0.07);
        glow.drawEllipse($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y - 20, 96, 104);
        glow.endFill();
        glow.beginFill(0xffcf5a, 0.06);
        glow.drawEllipse($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y - 6, 62, 62);
        glow.endFill();
        this.addChild(glow);
        this.flame.x = (0, $ee6ea042cf422424$export$f3a8244e0a259e49) + 12;
        this.flame.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - $c025c38ccd2d28a7$var$FLAME_H - 6;
        this.addChild(this.flame);
        // Ground shadow, so the figure stands on something.
        const floor = new (0, $gwPoJ.Graphics)();
        floor.beginFill(0x000000, 0.45);
        floor.drawEllipse($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y + 2, 46, 11);
        floor.endFill();
        floor.beginFill(0x000000, 0.3);
        floor.drawEllipse($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y + 2, 62, 15);
        floor.endFill();
        this.addChild(floor);
        if (!this.composite) {
            this.composite = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)("");
            this.composite.scale.set($c025c38ccd2d28a7$var$COMPOSITE_SCALE);
        }
        const look = this.lookSignature();
        if (look !== this.bakedLook) {
            this.bakedLook = look;
            this.composite.updatePaperdoll(this.entity);
        }
        // Always facing the viewer: the angle is pinned to "front" and nothing turns it.
        this.composite.doMovement(this.entity);
        this.composite.x = $c025c38ccd2d28a7$var$STAGE_CENTER_X;
        this.composite.y = $c025c38ccd2d28a7$var$FEET_Y - $c025c38ccd2d28a7$var$FEET_OFFSET;
        this.addChild(this.composite);
        const caption = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("Bound for the West", {
            size: 9,
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        caption.x = Math.round($c025c38ccd2d28a7$var$STAGE_CENTER_X - caption.width / 2);
        caption.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - 20;
        caption.alpha = 0.8;
        this.addChild(caption);
    }
    drawPalette() {
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, (0, $ee6ea042cf422424$export$1a7bb33882f2a323), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$c212ee05c579f421), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        this.addChild(panel);
        const view = (0, $e8dc6d9c289fb887$export$4cb82e77282accdd)(this.entity, this.openTrait);
        const x = (0, $ee6ea042cf422424$export$1a7bb33882f2a323) + $c025c38ccd2d28a7$var$PALETTE_PAD;
        const heading = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(view.label, {
            size: 15,
            color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
            bold: true
        });
        heading.x = x;
        heading.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 11;
        this.addChild(heading);
        const hint = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(`Now: ${view.summary}`, {
            size: 10,
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        (0, $e0fb6921b9eca6b1$export$b94583dc679500d)(hint, $c025c38ccd2d28a7$var$PALETTE_INNER_W - heading.width - 14);
        hint.x = (0, $ee6ea042cf422424$export$1a7bb33882f2a323) + (0, $ee6ea042cf422424$export$c212ee05c579f421) - $c025c38ccd2d28a7$var$PALETTE_PAD - hint.width;
        hint.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 15;
        this.addChild(hint);
        const top = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + $c025c38ccd2d28a7$var$PALETTE_TITLE_H;
        const bottom = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - $c025c38ccd2d28a7$var$PALETTE_PAD;
        const colorSection = view.sections.find((section)=>section.kind === "color");
        const styleSection = view.sections.find((section)=>section.kind === "style");
        // The colour row is short and fixed; the style grid takes whatever is left.
        let colorBlockH = 0;
        let colorLayout;
        if (colorSection) {
            colorLayout = (0, $e9b2f8e011d0ad84$export$2ad821b5ee3abcf6)({
                count: colorSection.options.length,
                width: $c025c38ccd2d28a7$var$PALETTE_INNER_W,
                height: $c025c38ccd2d28a7$var$COLOR_CELL * 2 + $c025c38ccd2d28a7$var$GRID_GAP,
                cellHeight: $c025c38ccd2d28a7$var$COLOR_CELL,
                minCellWidth: $c025c38ccd2d28a7$var$COLOR_CELL,
                maxCellWidth: $c025c38ccd2d28a7$var$COLOR_CELL + 6,
                gapX: $c025c38ccd2d28a7$var$GRID_GAP,
                gapY: $c025c38ccd2d28a7$var$GRID_GAP
            });
            colorBlockH = $c025c38ccd2d28a7$var$SECTION_HEAD_H + colorLayout.height + $c025c38ccd2d28a7$var$SECTION_GAP;
        }
        let y = top;
        if (styleSection) {
            const available = bottom - top - colorBlockH - $c025c38ccd2d28a7$var$SECTION_HEAD_H - $c025c38ccd2d28a7$var$PAGER_H;
            const layout = (0, $e9b2f8e011d0ad84$export$2ad821b5ee3abcf6)({
                count: styleSection.options.length,
                width: $c025c38ccd2d28a7$var$PALETTE_INNER_W,
                height: available,
                cellHeight: $c025c38ccd2d28a7$var$STYLE_CELL_H,
                minCellWidth: $c025c38ccd2d28a7$var$STYLE_MIN_W,
                gapX: $c025c38ccd2d28a7$var$GRID_GAP,
                gapY: $c025c38ccd2d28a7$var$GRID_GAP
            });
            y = this.drawSection(styleSection, x, y, layout);
        }
        if (colorSection && colorLayout) {
            // With a style grid above it the colour row sits on the floor of the panel; on its own
            // (skin, eyes) it belongs at the top, not stranded at the bottom of an empty panel.
            const colorY = styleSection ? Math.max(y, bottom - colorBlockH + $c025c38ccd2d28a7$var$SECTION_GAP) : top;
            this.drawSection(colorSection, x, colorY, colorLayout);
        }
    }
    // Draws one section (heading, grid of choices, pager when it doesn't fit on a page) and returns
    // the y just below it.
    drawSection(section, x, y, layout) {
        const heading = (0, $e0fb6921b9eca6b1$export$300ac6f106ef584d)(section.title, $c025c38ccd2d28a7$var$PALETTE_INNER_W);
        heading.x = x;
        heading.y = y;
        this.addChild(heading);
        const gridY = y + $c025c38ccd2d28a7$var$SECTION_HEAD_H;
        const page = Math.min(this.pageIndex[this.openTrait] || 0, layout.pages - 1);
        const shown = (0, $e9b2f8e011d0ad84$export$2660a47c412cb681)(section.options, layout, page);
        const cellH = section.kind === "color" ? $c025c38ccd2d28a7$var$COLOR_CELL : $c025c38ccd2d28a7$var$STYLE_CELL_H;
        shown.forEach((option, index)=>{
            const at = (0, $e9b2f8e011d0ad84$export$da4afb51d4f9da58)(index, layout, cellH, $c025c38ccd2d28a7$var$GRID_GAP, $c025c38ccd2d28a7$var$GRID_GAP);
            const onClick = ()=>this.choose(section, option.value);
            const chip = section.kind === "color" ? new (0, $e0fb6921b9eca6b1$export$43e54f70144d08dc)(option.swatch, {
                width: layout.cellWidth,
                height: cellH,
                selected: option.value === section.selected,
                onClick: onClick
            }) : new (0, $e0fb6921b9eca6b1$export$f1b71a6df9b30e88)(option.label, {
                width: layout.cellWidth,
                height: cellH,
                selected: option.value === section.selected,
                onClick: onClick
            });
            chip.x = x + at.x;
            chip.y = gridY + at.y;
            this.addChild(chip);
        });
        let bottom = gridY + layout.height + $c025c38ccd2d28a7$var$SECTION_GAP;
        if (layout.pages > 1) {
            const pager = new (0, $e0fb6921b9eca6b1$export$57625d62e5386b09)({
                page: page,
                pages: layout.pages,
                onPage: (next)=>{
                    this.pageIndex[this.openTrait] = next;
                    this.host.refresh();
                }
            });
            pager.x = x + $c025c38ccd2d28a7$var$PALETTE_INNER_W - pager.boxWidth;
            pager.y = gridY + layout.height + 4;
            this.addChild(pager);
            bottom += $c025c38ccd2d28a7$var$PAGER_H;
        }
        return bottom;
    }
    choose(section, value) {
        (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(this.entity, this.openTrait, section.kind, value);
        // A different hairstyle (or cut of shirt) can offer a different set of colours, so the open
        // palette is rebuilt rather than patched.
        this.host.refresh();
    }
    drawNav() {
        this.host.setNavButtons([
            {
                title: "\uD83C\uDFB2 Random look",
                callback: ()=>{
                    const appearance = (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)(this.entity, "human", this.entity.appearance.sex);
                    appearance.inventoryAppearanceHash = this.entity.appearance.inventoryAppearanceHash;
                    this.entity.appearance = appearance;
                    this.entity.appearance.eyes = this.entity.appearance.eyes || "normal";
                    this.entity.appearance.noseColor = this.entity.appearance.bodyColor;
                    (0, $e8dc6d9c289fb887$export$f90ea17b26c746f3)(this.entity);
                    this.host.refresh();
                }
            },
            {
                title: "\uD83D\uDC55 Random outfit",
                callback: ()=>{
                    this.entity.inventory.items = this.rollOutfit(this.entity);
                    (0, $e8dc6d9c289fb887$export$f90ea17b26c746f3)(this.entity);
                    this.host.refresh();
                }
            },
            {
                title: "Continue \u25B8",
                primary: true,
                callback: ()=>{
                    this.host.submitCharacter(this.entity.appearance, this.entity.inventory);
                    this.host.resetNavButtons();
                    this.host.switchPage("journey");
                }
            }
        ]);
    }
}


parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");

// The game's control reference, as data. Shared by the /help modal and the controls page of the
// character-creation screen so the two can never drift apart.
//
// Written for the camp a new player is dropped into (an ember room): alongside the world controls
// every room has, the entries cover the camp-only ones -- firewood, orders, the HUD chips --
// because that is where someone reading this is actually standing.
//
// KEEP EACH BODY TO ONE LINE. The /help modal renders these unwrapped at size 14 into an 800-wide
// screen (about 70 characters) and stacks them down a 460px column, so a body that wraps pushes the
// last entries off the bottom. The controls page wraps the same text into its own columns.
const $9232cedf236eccda$export$37a7ec870b628d38 = [
    {
        title: "Movement",
        body: "WASD or the arrow keys. Hold SHIFT to run."
    },
    {
        title: "Interact",
        body: "Click or tap a thing to act on it. Several choices open a wheel."
    },
    {
        title: "Attack",
        body: "Press SPACE, or click. Hold a click on someone to swing instead."
    },
    {
        title: "Firewood",
        body: "An axe fells trees. Carry the wood to the fire and feed it in."
    },
    {
        title: "Inventory",
        body: "Press 'i' or the ITEMS chip. Keys 1-6 ready a slot, 'q' drops one."
    },
    {
        title: "Crafting",
        body: "Press 'c' to open the crafting screen."
    },
    {
        title: "Camp orders",
        body: "Click one of your camp for their orders. Hold CTRL to order them all."
    },
    {
        title: "Camp HUD",
        body: "The map, your roster, the wave countdown. Click a chip to reopen one."
    },
    {
        title: "Chat & help",
        body: "ENTER to chat. '/help' for this list, '/register' to save progress."
    }
];





// The pages either side of the forge: the exile that puts you on the road, the briefing that sends
// you off, and the controls reference.
const $3388c3749452b953$var$LINE_H = 20;
const $3388c3749452b953$var$TYPE_MS_PER_CHAR = 16;
// A block of prose that types itself out. Pre-wrapped with TextMetrics so revealing a character at a
// time can't reflow the paragraph underneath itself (the usual word-wrap typewriter jitter).
class $3388c3749452b953$var$Typewriter extends (0, $8t5Gy.Container) {
    constructor(body, width, { size: size = 13, color: color = (0, $ee6ea042cf422424$export$d597759d33be802e) } = {}){
        super(), this.lines = [], this.total = 0, this.revealed = 0, this.elapsed = 0, this.finished = false;
        const style = new (0, $9Pi8W.TextStyle)({
            fontFamily: "Verdana, Geneva, sans-serif",
            fontSize: size,
            wordWrap: true,
            wordWrapWidth: width,
            // Match what text() below actually renders, so the lines it measures are the lines drawn.
            strokeThickness: 0
        });
        const measured = (0, $9Pi8W.TextMetrics).measureText(body, style);
        measured.lines.forEach((line, i)=>{
            const label = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("", {
                size: size,
                color: color
            });
            label.y = i * $3388c3749452b953$var$LINE_H;
            this.addChild(label);
            this.lines.push(label);
            this.total += line.length;
            label._full = line;
        });
    }
    animate(dtMs) {
        if (this.finished) return;
        this.elapsed += dtMs;
        const target = Math.floor(this.elapsed / $3388c3749452b953$var$TYPE_MS_PER_CHAR);
        if (target <= this.revealed) return;
        this.revealed = Math.min(target, this.total);
        let remaining = this.revealed;
        for(let i = 0; i < this.lines.length; i++){
            const full = this.lines[i]._full;
            const take = Math.max(0, Math.min(full.length, remaining));
            if (this.lines[i].text.length !== take) this.lines[i].text = full.slice(0, take);
            remaining -= full.length;
        }
        if (this.revealed >= this.total) this.finished = true;
    }
}
class $3388c3749452b953$export$1f1210b18f6f2bd1 extends (0, $2b3f66371c8d7b60$export$fe2b06ef7574cc0e) {
    animate(dtMs) {
        this.typewriter?.animate(dtMs);
    }
    build() {
        this.wipe();
        this.typewriter = undefined;
        const panelW = 560;
        const panelX = ((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - panelW) / 2;
        const panelH = 190;
        const panelY = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + ((0, $ee6ea042cf422424$export$343fef082e4bb475) - panelH) / 2;
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, panelX, panelY, panelW, panelH, {
            radius: 12
        });
        this.addChild(panel);
        const rule = new (0, $gwPoJ.Graphics)();
        rule.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.8);
        rule.drawRect(panelX + 28, panelY + 34, 44, 2);
        rule.endFill();
        this.addChild(rule);
        const kicker = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("BY ORDER OF THE EMPEROR", {
            size: 10,
            color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
            bold: true
        });
        kicker.x = panelX + 28;
        kicker.y = panelY + 18;
        kicker.alpha = 0.9;
        this.addChild(kicker);
        const body = new $3388c3749452b953$var$Typewriter("You have been exiled to the barbarous lands of the West, for the Emperor will suffer no rivals in the East.", panelW - 56, {
            size: 14
        });
        body.x = panelX + 28;
        body.y = panelY + 54;
        this.addChild(body);
        this.typewriter = body;
        this.host.setNavButtons([
            {
                title: "Forge your character \u25B8",
                primary: true,
                callback: ()=>this.host.switchPage("build")
            }
        ]);
    }
    constructor(...args){
        super(...args), this.pageId = "intro", this.title = "The long exile";
    }
}
// The loop of an ember camp, in the order a player meets it: the fire that keeps the Lord alive,
// the food that buys a household, and the assault that comes for both. These are the same three
// things the end-of-run scorecard counts, so the briefing and the reckoning agree.
const $3388c3749452b953$var$STEPS = [
    "Fell trees and feed the wood to the fire. Keep it burning.",
    "Hunt meat in the forest. Hungry strangers will be drawn in. Task them to aid in your survival.",
    "The dead come in waves. Keep the fire lit, and hold out for as long as you can."
];
class $3388c3749452b953$export$789f026efedb4082 extends (0, $2b3f66371c8d7b60$export$fe2b06ef7574cc0e) {
    build() {
        this.wipe();
        const panelW = 470;
        const panelX = 24;
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, panelX, (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), panelW, (0, $ee6ea042cf422424$export$343fef082e4bb475), {
            radius: 12
        });
        this.addChild(panel);
        // Wrapped, and everything below it hung off its measured height: the lead is two lines of
        // prose rather than a caption, and an unwrapped one would run out over the campfire.
        const lead = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("You are the steward of a great house. Your lord is dying. The fire is the only thing anchoring him to the word.", {
            size: 12,
            color: (0, $ee6ea042cf422424$export$d597759d33be802e),
            wrap: panelW - 44
        });
        lead.x = panelX + 22;
        lead.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 18;
        this.addChild(lead);
        const heading = (0, $e0fb6921b9eca6b1$export$300ac6f106ef584d)("Holding the camp", panelW - 44);
        heading.x = panelX + 22;
        heading.y = lead.y + lead.height + 14;
        this.addChild(heading);
        let y = heading.y + 22;
        $3388c3749452b953$var$STEPS.forEach((step, i)=>{
            const card = new (0, $gwPoJ.Graphics)();
            card.lineStyle(1, (0, $ee6ea042cf422424$export$4623f99f39ff0c85), 0.6);
            card.beginFill((0, $ee6ea042cf422424$export$47e6a71c2ae4bc1f), 0.85);
            card.drawRoundedRect(panelX + 22, y, panelW - 44, 48, 8);
            card.endFill();
            card.lineStyle(0);
            // Numbered badge.
            card.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.9);
            card.drawCircle(panelX + 46, y + 24, 12);
            card.endFill();
            this.addChild(card);
            const number = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(`${i + 1}`, {
                size: 12,
                color: 0x2a1c0c,
                bold: true
            });
            number.x = panelX + 46 - number.width / 2;
            number.y = y + 24 - number.height / 2;
            this.addChild(number);
            // Wrapped inside the card, to the right of its numbered badge; the vertical centring
            // below already works off the measured height, so a second line costs nothing.
            const body = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(step, {
                size: 11,
                color: (0, $ee6ea042cf422424$export$d597759d33be802e),
                wrap: panelW - 112
            });
            body.x = panelX + 68;
            body.y = y + 24 - body.height / 2;
            this.addChild(body);
            y += 56;
        });
        const closer = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("Survive.", {
            size: 11,
            color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
            wrap: panelW - 44
        });
        closer.x = panelX + 22;
        closer.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - 18 - closer.height;
        this.addChild(closer);
        this.drawCampfire(panelX + panelW + 90, (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) / 2);
    }
    // The campfire the briefing is about, burning beside it.
    drawCampfire(x, y) {
        const halo = new (0, $gwPoJ.Graphics)();
        halo.beginFill(0xff8a24, 0.08);
        halo.drawCircle(x, y, 96);
        halo.endFill();
        halo.beginFill(0xffcf5a, 0.07);
        halo.drawCircle(x, y, 58);
        halo.endFill();
        this.addChild(halo);
        const campfire = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            name: "lpc-terrain:760",
            scale: 1.0,
            color: 0xffffff
        });
        const fire = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            name: "fire",
            scale: 1.0,
            color: 0xffffff
        });
        fire.x = 3;
        fire.y = -23;
        const animation = new (0, $gwPoJ.Graphics)();
        animation.addChild(campfire);
        animation.addChild(fire);
        animation.scale.set(3.0);
        animation.x = x;
        animation.y = y;
        this.addChild(animation);
    }
    constructor(...args){
        super(...args), this.pageId = "journey", this.title = "Journey onward";
    }
}
class $3388c3749452b953$export$1b11309adedc0b38 extends (0, $2b3f66371c8d7b60$export$fe2b06ef7574cc0e) {
    build() {
        this.wipe();
        const panelW = 640;
        const panelX = ((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - panelW) / 2;
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, panelX, (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), panelW, (0, $ee6ea042cf422424$export$343fef082e4bb475), {
            radius: 12
        });
        this.addChild(panel);
        // Two columns of entries, so nothing runs off the bottom of the panel.
        const colW = (panelW - 66) / 2;
        const rows = Math.ceil((0, $9232cedf236eccda$export$37a7ec870b628d38).length / 2);
        (0, $9232cedf236eccda$export$37a7ec870b628d38).forEach((entry, i)=>{
            const col = Math.floor(i / rows);
            const row = i % rows;
            const x = panelX + 24 + col * (colW + 18);
            const y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 20 + row * 62;
            const title = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(entry.title, {
                size: 11,
                color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
                bold: true
            });
            title.x = x;
            title.y = y;
            this.addChild(title);
            const body = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(entry.body, {
                size: 10,
                color: (0, $ee6ea042cf422424$export$d597759d33be802e),
                wrap: colW
            });
            body.x = x;
            body.y = y + 16;
            this.addChild(body);
        });
        this.host.setNavButtons([
            {
                title: "\u25C2 Back",
                callback: ()=>{
                    this.host.resetNavButtons();
                    this.host.switchPage("journey");
                }
            }
        ]);
    }
    constructor(...args){
        super(...args), this.pageId = "controls", this.title = "Controls";
    }
}






class $5be630d7f2f3b131$export$49421d8fc42e7f44 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, logic){
        super(guiManager, {
            opaque: true,
            unescapable: true
        }), this.pages = new Map(), this.currentPageId = "intro", this.navButtons = [], this.initialized = false, this.dirty = true, this.wasOpen = false, // A repaint only fades the body up when the body is genuinely new -- opening the screen, or
        // moving to another page. An in-place repaint (a palette click, a pager step) redraws the same
        // page, and fading that from nothing is read as the whole screen blinking.
        this.fadeNextPaint = true, // The HUD calls this whenever the player entity changes. Rebuild only when the screen has
        // something new to show -- but keep retrying initialization, because the first call usually
        // arrives before the player's appearance and starting kit have.
        this.update = ()=>{
            // Opening (toggle -> update) always paints, even if nothing changed since it last closed.
            const open = this.isOpen();
            if (open && !this.wasOpen) {
                this.dirty = true;
                this.fadeNextPaint = true;
            }
            this.wasOpen = open;
            if (!this.initialized && !this.initialize()) return;
            if (!this.dirty) return;
            this.dirty = false;
            this.rebuildSurface();
        }, // Frame hook (driven by GuiManager.updateTimer) for the page's own animation: the ember glow on
        // the forge's stage, the intro's typewriter.
        this.animate = (dtMs)=>{
            if (!this.isOpen()) return;
            this.pages.get(this.currentPageId)?.animate(dtMs);
        }, this.initialize = ()=>{
            const player = this.guiManager.getPlayer();
            if (!player?.appearance || player.inventory?.items?.length < 1) return false;
            const register = (page)=>{
                page.host = this;
                this.pages.set(page.pageId, page);
            };
            register(new (0, $3388c3749452b953$export$1f1210b18f6f2bd1)());
            register(new (0, $c025c38ccd2d28a7$export$fd5a80e92d0a5c1d)(player));
            register(new (0, $3388c3749452b953$export$789f026efedb4082)());
            register(new (0, $3388c3749452b953$export$1b11309adedc0b38)());
            this.resetNavButtons();
            this.initialized = true;
            return true;
        }, // --- BuilderHost -------------------------------------------------------------------------
        // Repaint, but not from inside the click that asked for it: a palette click would otherwise tear
        // down the very chip pixi is still dispatching the event on. Coalesces a burst into one repaint.
        this.refresh = ()=>{
            this.dirty = true;
            if (this.refreshTimer !== undefined) return;
            this.refreshTimer = setTimeout(()=>{
                this.refreshTimer = undefined;
                if (this.isOpen()) this.update();
            }, 0);
        }, this.setNavButtons = (buttons)=>{
            this.navButtons = buttons;
        }, this.resetNavButtons = ()=>{
            this.navButtons = [
                {
                    title: "Edit character",
                    callback: ()=>this.switchPage("build")
                },
                {
                    title: "Review controls",
                    callback: ()=>this.switchPage("controls")
                },
                {
                    title: "Let's go! \u25B8",
                    primary: true,
                    callback: ()=>this.close()
                }
            ];
        }, this.submitCharacter = (appearance, inventory)=>{
            this.logic.playerController.client.saveAppearance(appearance, inventory);
        }, this.switchPage = (pageId)=>{
            if (pageId === this.currentPageId) return;
            this.pages.get(this.currentPageId)?.tearDown();
            this.currentPageId = pageId;
            this.fadeNextPaint = true;
            this.refresh();
        }, // --- rendering ---------------------------------------------------------------------------
        this.createContent = ()=>{
            const main = new (0, $gwPoJ.Graphics)();
            this.drawBackdrop(main);
            if (!this.initialized && !this.initialize()) // Player data hasn't landed yet; the next update() tries again.
            return main;
            const page = this.pages.get(this.currentPageId);
            page.build();
            main.addChild(page);
            this.drawHeader(main, page.title, page.hint);
            this.drawFooter(main);
            // On a page switch everything but the backdrop fades up together, so the move reads as one.
            // A repaint of the page you are already on has to land instantly -- the whole rebuild
            // happens inside one task, so swapping the children is invisible unless we fade them.
            if (this.fadeNextPaint) {
                this.fadeNextPaint = false;
                page.alpha = 0;
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(page, {
                    direction: "in",
                    minAlpha: 1.0,
                    fadeAlphaDecrement: 0.06
                }).update();
            } else // Pages are long-lived objects, so a fade left in flight by an earlier paint would
            // otherwise hand this one a half-transparent page.
            page.alpha = 1;
            return main;
        }, // A warm, dark hall for the character to stand in -- the modal's own backdrop is flat black.
        // Drawn out past the content box so it covers the dialog's padding too.
        this.drawBackdrop = (g)=>{
            g.beginFill((0, $ee6ea042cf422424$export$4389bfa33b3049ea), 1);
            g.drawRect(-12, -12, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) + 24, (0, $ee6ea042cf422424$export$8a4e6245b38ca3f5) + 44);
            g.endFill();
            // Firelight welling up from the floor of the screen: three stacked ellipses, brightest at the
            // core. A handful of draw calls instead of a blur filter (see the budget-hardware note).
            const cx = (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) / 2;
            const cy = (0, $ee6ea042cf422424$export$8a4e6245b38ca3f5) - 40;
            g.beginFill(0xff4a12, 0.05);
            g.drawEllipse(cx, cy, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) * 0.52, 250);
            g.endFill();
            g.beginFill(0xff8a24, 0.045);
            g.drawEllipse(cx, cy, 300, 180);
            g.endFill();
            g.beginFill(0xffcf5a, 0.03);
            g.drawEllipse(cx, cy, 160, 110);
            g.endFill();
            // Vignette: darker at the rim, so the panels sit forward of the background.
            for(let i = 0; i < 4; i++){
                g.lineStyle(14, 0x000000, 0.1);
                g.drawRect(-12 + i * 12, -12 + i * 12, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) + 24 - i * 24, (0, $ee6ea042cf422424$export$8a4e6245b38ca3f5) + 44 - i * 24);
            }
            g.lineStyle(0);
        }, this.drawHeader = (g, title, hintText)=>{
            const heading = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(title.toUpperCase(), {
                size: 17,
                color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
                bold: true
            });
            heading.x = 2;
            heading.y = 4;
            g.addChild(heading);
            if (hintText) {
                const hint = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(hintText, {
                    size: 10,
                    color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
                });
                hint.x = (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - hint.width - 2;
                hint.y = 10;
                hint.alpha = 0.75;
                g.addChild(hint);
            }
            const rule = new (0, $gwPoJ.Graphics)();
            rule.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.55);
            rule.drawRect(0, (0, $ee6ea042cf422424$export$341c383d1f147954) - 6, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30), 2);
            rule.endFill();
            rule.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.35);
            rule.drawRect(0, (0, $ee6ea042cf422424$export$341c383d1f147954) - 4, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30), 1);
            rule.endFill();
            g.addChild(rule);
        }, this.drawFooter = (g)=>{
            const y = (0, $ee6ea042cf422424$export$8a4e6245b38ca3f5) - (0, $ee6ea042cf422424$export$7900c34204647a1b);
            const rule = new (0, $gwPoJ.Graphics)();
            rule.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.45);
            rule.drawRect(0, y, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30), 1);
            rule.endFill();
            g.addChild(rule);
            const buttonY = y + 10;
            let x = 2;
            const primary = this.navButtons.filter((meta)=>meta.primary);
            const secondary = this.navButtons.filter((meta)=>!meta.primary);
            secondary.forEach((meta)=>{
                const button = new (0, $e0fb6921b9eca6b1$export$c5e39530e713771e)({
                    label: meta.title,
                    onClick: meta.callback
                });
                button.x = x;
                button.y = buttonY;
                g.addChild(button);
                x += button.boxWidth + 8;
            });
            let right = (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - 2;
            primary.slice().reverse().forEach((meta)=>{
                const button = new (0, $e0fb6921b9eca6b1$export$c5e39530e713771e)({
                    label: meta.title,
                    primary: true,
                    onClick: meta.callback
                });
                button.x = right - button.boxWidth;
                button.y = buttonY;
                g.addChild(button);
                right -= button.boxWidth + 8;
            });
        };
        this.logic = logic;
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");









parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");
var $d3fD1 = parcelRequire("d3fD1");
var $gwPoJ = parcelRequire("gwPoJ");


const $4d7afde9fb919e81$var$dirs = [
    "left",
    "right",
    "front",
    "back"
];
const $4d7afde9fb919e81$var$SheetLoadingState = {};
const $4d7afde9fb919e81$export$c93e91c91768c5a2 = [
    "walk-left",
    "walk-right",
    "walk-back",
    "walk-front",
    "idle-left",
    "idle-right",
    "idle-back",
    "idle-front",
    "thrust-left",
    "thrust-right",
    "thrust-back",
    "thrust-front",
    "slash-left",
    "slash-right",
    "slash-back",
    "slash-front",
    "shoot-left",
    "shoot-right",
    "shoot-back",
    "shoot-front",
    "hurt-front",
    "activate",
    "deactivate",
    "inactive",
    "active"
];
const $4d7afde9fb919e81$var$defaultRenderMeta = {
    "walk-left": {
        scale: 1,
        speed: 0.25
    },
    activate: {
        scale: 1,
        speed: 0.25
    },
    deactivate: {
        scale: 1,
        speed: 0.25
    },
    "walk-right": {
        scale: 1,
        speed: 0.25
    },
    "walk-back": {
        scale: 1,
        speed: 0.25
    },
    "walk-front": {
        scale: 1,
        speed: 0.25
    },
    inactive: {
        scale: 1
    },
    active: {
        scale: 1
    },
    "idle-left": {
        scale: 1
    },
    "idle-right": {
        scale: 1
    },
    "idle-back": {
        scale: 1
    },
    "idle-front": {
        scale: 1
    },
    "thrust-left": {
        scale: 1,
        speed: 0.55
    },
    "thrust-right": {
        scale: 1,
        speed: 0.55
    },
    "thrust-back": {
        scale: 1,
        speed: 0.55
    },
    "thrust-front": {
        scale: 1,
        speed: 0.55
    },
    "slash-left": {
        scale: 1,
        speed: 0.25
    },
    "slash-right": {
        scale: 1,
        speed: 0.25
    },
    "slash-back": {
        scale: 1,
        speed: 0.25
    },
    "slash-front": {
        scale: 1,
        speed: 0.25
    },
    "shoot-left": {
        scale: 1,
        speed: 0.85
    },
    "shoot-right": {
        scale: 1,
        speed: 0.85
    },
    "shoot-back": {
        scale: 1,
        speed: 0.85
    },
    "shoot-front": {
        scale: 1,
        speed: 0.85
    },
    "hurt-front": {
        scale: 1
    }
};
const $4d7afde9fb919e81$var$animationToAction = {
    "walk-left": "walk",
    "walk-right": "walk",
    "walk-back": "walk",
    "walk-front": "walk",
    "idle-left": "idle",
    "idle-right": "idle",
    "idle-back": "idle",
    "idle-front": "idle",
    "thrust-left": "thrust",
    "thrust-right": "thrust",
    "thrust-back": "thrust",
    "thrust-front": "thrust",
    "slash-left": "slash",
    "slash-right": "slash",
    "slash-back": "slash",
    "slash-front": "slash",
    "shoot-left": "thrust",
    "shoot-right": "thrust",
    "shoot-back": "thrust",
    "shoot-front": "thrust",
    "hurt-front": "hurt",
    activate: "activate",
    deactivate: "deactivate",
    inactive: "inactive",
    active: "active"
};
const $4d7afde9fb919e81$var$isAttackAnimation = (animationName)=>[
        "shoot",
        "thrust",
        "slash"
    ].includes($4d7afde9fb919e81$var$animationToAction[animationName]);
const $4d7afde9fb919e81$var$isWalkAnimation = (animationName)=>[
        "walk"
    ].includes($4d7afde9fb919e81$var$animationToAction[animationName]);
const $4d7afde9fb919e81$var$extractDirection = (animation)=>animation.split("-")[1];
class $4d7afde9fb919e81$export$1a1b4f8679485f1c extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor({ sheetId: sheetId, renderMeta: renderMeta = $4d7afde9fb919e81$var$defaultRenderMeta, attackAction: attackAction, angle: angle, hasHalo: hasHalo, defaultAction: defaultAction = "idle-front" }){
        super(), this.spriteAngle = 0, this.action = "idle-front", this.prevAction = "idle-front", this.animations = {}, this.facingDir = "front", this.attackAction = "idle", this.initalize = ()=>{
            const loadingState = $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId];
            if (loadingState === "loaded") {
                this.setup();
                return;
            }
            if (loadingState === "loading") {
                this.loadingInterval = setInterval(()=>{
                    const loadingState = $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId];
                    if (loadingState === "loaded") {
                        this.setup();
                        clearInterval(this.loadingInterval);
                        return;
                    }
                }, 1000);
                return;
            }
            // its not loaded at all -- start loading it!
            $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId] = "loading";
            (0, $kXE1p.Loader).shared.add(this.sheetId, `assets/${this.sheetId}`, ()=>{
                $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId] = "loaded";
                this.setup();
            });
        }, this.setup = ()=>{
            const loader = (0, $kXE1p.Loader).shared;
            this.spritesheetResource = loader.resources[this.sheetId];
            const sheet = this.spritesheetResource?.spritesheet;
            if (!sheet) return;
            this.disallowMoveAttackAnimation = false;
            $4d7afde9fb919e81$export$c93e91c91768c5a2.forEach((animationName)=>{
                const source = this.renderMeta[animationName];
                if (!source) return;
                const { scale: scale, speed: speed = 0.267, color: color = 0xffffff } = source;
                const resource = sheet.animations[animationName];
                if (!resource) return;
                const animation = new (0, $d3fD1.AnimatedSprite)(resource);
                animation.scale.set(scale);
                animation.animationSpeed = speed;
                animation.visible = false;
                animation.tint = color;
                this.container.addChild(animation);
                this.animations[animationName] = animation;
                if ($4d7afde9fb919e81$var$isAttackAnimation(animationName)) {
                    animation.loop = false;
                    animation.onComplete = ()=>{
                        this.activateAnimation(`idle-${$4d7afde9fb919e81$var$extractDirection(this.action)}`);
                    };
                }
            });
            this.action = "idle-front";
            this.activateAnimation(this.action, true);
        }, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            if (this.animation) this.animation.tint = color;
            if (this.sprite) this.sprite.tint = color;
        }, this.activateAnimation = (updatedAction, force)=>{
            if (!this.spritesheetResource) return;
            if (updatedAction === this.action && !force) // noop
            return;
            const source = this.animations[`${this.action}`];
            const toUpdate = this.animations[`${updatedAction}`];
            if (!toUpdate) return;
            if (source) {
                // stop and hide the current animation
                source.visible = false;
                source.stop();
            }
            // start and show the next animation
            this.action = updatedAction;
            toUpdate.visible = true;
            toUpdate.gotoAndPlay(0);
        }, this.fragment = (entity)=>{
            let actionToUse = this.action;
            if (!this.renderMeta[this.action]) actionToUse = `idle-${this.facingDir}`;
            if (!this.renderMeta[actionToUse]) return;
            const { scale: scale } = this.renderMeta[actionToUse];
            const surface = new (0, $gwPoJ.Graphics)();
            surface.x = this.parent.x;
            surface.y = this.parent.y;
            surface.scale.set(scale);
            surface.rotation = this.container.rotation;
            this.parent.parent.addChild(surface);
            const sprite = this.animations[`${actionToUse}`];
            if (!sprite) return;
            const f = sprite.textures[sprite.currentFrame];
            const { width: width, height: height } = f._frame;
            surface.x -= width / 2;
            surface.y -= height / 2;
            (0, $4264eae3240561ee$export$cc249234599c5a64)(surface, f, {
                cacheKey: entity.appearance?.race
            });
        };
        this.renderMeta = {
            ...$4d7afde9fb919e81$var$defaultRenderMeta,
            ...renderMeta
        };
        this.attackAction = attackAction;
        this.spriteAngle = angle;
        this.facingDir = this.calcDir(angle);
        this.container = new (0, $gwPoJ.Graphics)();
        this.addChild(this.container);
        if (hasHalo) {
            const halo = new (0, $gwPoJ.Graphics)();
            halo.alpha = 0.5;
            halo.beginFill(0xffffff);
            halo.drawCircle(0, -10, 12);
            halo.endFill();
            this.halo = halo;
            this.container.addChild(halo);
        }
        this.sheetId = sheetId;
        this.defaultAnimationType = defaultAction;
        this.initalize();
    }
    calcDir(angle) {
        return (0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(angle);
    }
    calcSpriteAngle() {
        if (this.facingDir === "front") return 90;
        if (this.facingDir === "back") return 270;
        if (this.facingDir === "left") return 181;
        return 0;
    }
    doMovement(entity) {
        const { movement: movement } = entity;
        if (!movement) return;
        if (this.spriteAngle !== movement.angle) {
            const facingDir = this.calcDir(movement.angle);
            if (facingDir !== this.facingDir) {
                const parts = this.action.split("-");
                const updated = `${parts[0]}-${facingDir}`;
                this.activateAnimation(updated);
            }
            this.facingDir = facingDir;
        }
        this.spriteAngle = movement.angle;
        const { x: x, y: y } = entity.location;
        if (x !== this.lastX || y !== this.lastY) {
            this.lastX = x;
            this.lastY = y;
            if (this.idleTimeout !== undefined) {
                clearTimeout(this.idleTimeout);
                this.idleTimeout = undefined;
            }
            if (!$4d7afde9fb919e81$var$isAttackAnimation(this.action)) this.activateAnimation(`walk-${this.facingDir}`);
        } else if (this.idleTimeout === undefined) this.idleTimeout = setTimeout(()=>{
            if ($4d7afde9fb919e81$var$isAttackAnimation(this.action)) return;
            this.activateAnimation(`idle-${this.facingDir}`);
        }, 50);
    }
    doAttack(entity) {
        if ($4d7afde9fb919e81$var$isAttackAnimation(this.action)) // noop - already attacking
        return;
        if (this.disallowMoveAttackAnimation && $4d7afde9fb919e81$var$isWalkAnimation(this.action)) return;
        this.prevAction = this.action;
        this.activateAnimation(`${this.attackAction}-${this.facingDir}`);
    }
}


class $8d5e1ee7d468f782$export$6927fb12d9ccc2a extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entityId){
        super(), this.parts = [], this.getClickSurface = ()=>{
            return this.clickArea;
        }, this.rebuildLayers = (entity)=>{
            const dimensions = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.dimensions(entity);
            this.parts.forEach((part)=>{
                part.remove();
            });
            this.parts = [];
            const race = entity.appearance?.race;
            const sex = entity.appearance?.sex;
            const hair = entity.appearance?.hair;
            const nose = entity.appearance?.nose;
            const eyes = entity.appearance?.eyes;
            const weapon = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(entity.inventory, entity?.weapon?.weaponType)?.itemTypeMeta;
            const weaponAction = (0, $bf6244e5cc9aa116$export$448f4eb18cb556ce)[entity?.weapon?.weaponType || "none"] || (0, $bf6244e5cc9aa116$export$2eff43e195cfa29d)[race];
            const armor = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "armor");
            const descriptors = (0, $71594ae8b880a354$export$efde97289773c11d)({
                body: {
                    race: race,
                    sex: sex,
                    color: entity.appearance.bodyColor
                },
                hair: hair ? {
                    component: hair,
                    color: entity.appearance.hairColor
                } : undefined,
                nose: nose ? {
                    component: nose,
                    color: entity.appearance.noseColor
                } : undefined,
                eyes: eyes ? {
                    component: eyes,
                    color: entity.appearance.eyesColor
                } : undefined,
                ///////
                weapon: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)(weapon),
                pants: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "pants")),
                shirt: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shirt")),
                armor: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)(armor),
                shoes: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shoes")),
                shield: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shield")),
                cape: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "cape")),
                bauldron: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "bauldron"))
            });
            const all = [];
            descriptors.body?.forEach((next)=>all.push(next));
            if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isHumanoid(race)) {
                descriptors.hair?.forEach((next)=>all.push(next));
                descriptors.nose?.forEach((next)=>all.push(next));
                descriptors.eyes?.forEach((next)=>all.push(next));
                descriptors.weapon?.forEach((next)=>all.push(next));
                descriptors.pants?.forEach((next)=>all.push(next));
                descriptors.shirt?.forEach((next)=>all.push(next));
                descriptors.armor?.forEach((next)=>all.push(next));
                descriptors.shoes?.forEach((next)=>all.push(next));
                descriptors.shield?.forEach((next)=>all.push(next));
                descriptors.cape?.forEach((next)=>all.push(next));
                descriptors.bauldron?.forEach((next)=>all.push(next));
            }
            all.sort((a, b)=>a.zIndex - b.zIndex).map((sheet)=>this.buildPart(weaponAction, entity.movement.angle, sheet)).forEach((sprite)=>{
                if (sprite.halo) this.haloObject = sprite.halo;
                this.addChild(sprite);
                this.parts.push(sprite);
            });
            if (this.clickArea.parent) this.clickArea.parent.removeChild(this.parentArea);
            this.clickArea.clear();
            this.clickArea.beginFill(0xff0000, 0.001);
            this.clickArea.drawRect(0, 0, dimensions.w, dimensions.h);
            this.clickArea.x = -dimensions.w / 2;
            this.clickArea.y = -dimensions.h / 2 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
            this.clickArea.endFill();
            this.addChild(this.clickArea);
        }, this.buildPart = (attackAction, angle, dollComponent)=>{
            if (!dollComponent) return;
            return new (0, $4d7afde9fb919e81$export$1a1b4f8679485f1c)({
                sheetId: `lpc/spritesheets/${dollComponent.entityId}.json`,
                attackAction: attackAction,
                angle: angle,
                hasHalo: this.halo && dollComponent.entityId.startsWith("body")
            });
        }, this.fragment = (entity)=>{
            this.parts.forEach((part)=>part.fragment(entity));
            this.drawableSurface.fragment(entity);
        }, this.onMouseOver = (show)=>{
            this.hud.onMouseOver(show);
        }, this.setWorldOverlayItem = (item)=>{
            this.worldOverlayItem = item;
            this.worldOverlayItem.addChild(this.hud);
        };
        this.entityId = entityId;
        this.clickArea = new (0, $a64b70167386625f$export$98e91636974d835d)();
        this.hud = new (0, $1d5c2742ca857d0e$export$5ef96c383b67a5e2)(0xffffff, {
            renderActions: {},
            alwaysShowLabel: false
        }, this.clickArea);
        this.drawableSurface = new (0, $a64b70167386625f$export$98e91636974d835d)();
    }
    doMovement(entity) {
        this.parts.forEach((part)=>part.doMovement(entity));
        this.drawableSurface.doMovement(entity);
    }
    updateHaloColor(hp, hpMax) {
        const hpPct = hp / hpMax;
        if (hpPct < 0.7) {
            if (hpPct < 0.4) this.haloObject.tint = 0xff0000;
            else this.haloObject.tint = 0xffa500;
        } else this.haloObject.tint = 0x00ff00;
    }
    update(hp, hpMax) {
        this.hud.update(hp, hpMax);
        if (this.haloObject) this.updateHaloColor(hp, hpMax);
    }
    updateName(name) {
        this.hud.updateName(name);
    }
    recolor(color) {
        this.hud.recolor(color);
    }
    updateBlinking(blinking) {
        if (!blinking) {
            this.visible = true;
            if (this.blinkingInterval) {
                clearInterval(this.blinkingInterval);
                this.blinkingInterval = null;
                this.alpha = 1.0;
            }
        } else {
            if (this.blinkingInterval) return;
            let dir = -1;
            this.blinkingInterval = setInterval(()=>{
                this.alpha -= 0.1 * dir;
                if (this.alpha < 0.4 || this.alpha > 1.0) dir = -1 * dir;
            }, 25);
        }
    }
    addTag() {
        this.hud.addTag();
    }
    removeTag() {
        this.hud.removeTag();
    }
    updateLevel(level) {
        this.hud.updateLevel(level);
    }
    doAttack(entity) {
        this.parts.forEach((part)=>part.doAttack(entity));
    }
    doDamaged(entity) {
        this.parts.forEach((part)=>part.doDamaged(entity));
    }
    spoke(message, options) {
        this.hud.spoke(message, options);
    }
    releaseHeldSpeech() {
        this.hud.releaseHeldSpeech();
    }
    cleanup() {
        this.hud?.cleanup();
    }
    getDrawableSurface() {
        return this.drawableSurface.getDrawableSurface();
    }
    updatePaperdoll(entity) {
        if (!entity) return;
        const { appearance: appearance } = entity;
        if (!appearance) return;
        this.rebuildLayers(entity);
    }
    updateHalo(entity, enabled) {
        this.halo = enabled;
        this.updatePaperdoll(entity);
        if (this.haloObject) this.updateHaloColor(entity.hp, entity.maxHp);
    }
    updateSpeed(factor) {
    //
    }
    updatePointerIcon(show, angle) {
        this.hud.updatePointerIcon(show, angle);
    }
    updateSigil(sigil) {
        this.hud.updateSigil(sigil);
    }
    updateRole(role) {
        this.hud.updateRole(role);
    }
}




class $16b4bf3d247fe459$export$6bed762da66f1ed6 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, logic){
        super(guiManager), this.race = "human", this.bodyColor = "white", this.sex = "male", this.save = ()=>{
            const appearance = {
                race: this.race,
                bodyColor: this.bodyColor,
                sex: this.sex,
                hair: this.hair,
                hairColor: this.hairColor,
                nose: this.nose,
                noseColor: this.noseColor,
                eyes: this.eyes,
                eyesColor: this.eyesColor,
                inventoryAppearanceHash: this.entity.appearance.inventoryAppearanceHash
            };
            this.logic.saveAppearance(appearance);
            this.modal.close();
        }, this.createContent = ()=>{
            if (!this.entity) this.entity = this.guiManager.getPlayer();
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                defaultTextFont: "ChatFont"
            });
            const spacer = ()=>{
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.x = 0;
                spacer.y = 0;
                spacer.drawRect(0, 0, 0, 10);
                return spacer;
            };
            const refresh = ()=>{
                if (this.nose && !(0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race] || (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race]?.indexOf(this.nose) < 0) this.nose = (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race] ? (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race][0] : undefined;
                if (this.eyes && !(0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race] || (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race]?.indexOf(this.eyes) < 0) this.eyes = (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race] ? (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race][0] : undefined;
                if (this.sex && !(0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race] || (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race]?.indexOf(this.sex) < 0) this.sex = (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race][0];
                this.entity.appearance.race = this.race;
                this.entity.appearance.bodyColor = this.bodyColor;
                this.entity.appearance.sex = this.sex;
                this.entity.appearance.hair = this.hair;
                this.entity.appearance.hairColor = this.hairColor;
                this.entity.appearance.nose = this.nose;
                this.entity.appearance.noseColor = this.noseColor;
                this.entity.appearance.eyes = this.eyes;
                this.entity.appearance.eyesColor = this.eyesColor;
                this.update();
            };
            const printControl = (title, range, t, setter, suppressNone)=>{
                const previous = (range, t, setter)=>{
                    let idx = range.indexOf(t) - 1;
                    if (idx < 0) idx = range.length - 1;
                    setter(range[idx]);
                    refresh();
                };
                const next = (range, t, setter)=>{
                    let idx = range.indexOf(t) + 1;
                    if (idx > range.length - 1) idx = 0;
                    setter(range[idx]);
                    refresh();
                };
                main.append(`${title}: ` + (t || " - none - "));
                main.append("Previous", false, undefined, undefined, undefined, "button", ()=>{
                    previous(range, t, setter);
                });
                main.append(" ", true);
                main.append("Next", true, undefined, undefined, undefined, "button", ()=>{
                    next(range, t, setter);
                });
                if (!suppressNone) {
                    main.append(" ", true);
                    main.append("None", true, undefined, undefined, undefined, "button", ()=>{
                        setter(undefined);
                        refresh();
                    });
                }
                main.append(spacer());
            };
            main.append("Randomize", true, undefined, undefined, undefined, "button", ()=>{
                const { race: race, bodyColor: bodyColor, sex: sex, hair: hair, hairColor: hairColor, nose: nose, noseColor: noseColor, eyes: eyes, eyesColor: eyesColor } = (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)();
                this.race = race;
                this.bodyColor = bodyColor;
                this.sex = sex;
                this.hair = hair;
                this.hairColor = hairColor;
                this.nose = nose;
                this.noseColor = noseColor;
                this.eyes = eyes;
                this.eyesColor = eyesColor;
                refresh();
            });
            main.append(" ", true);
            main.append("Save", true, undefined, undefined, undefined, "button", ()=>{
                this.save();
            });
            main.append(spacer());
            main.append(spacer());
            // race
            printControl("Race", (0, $bf6244e5cc9aa116$export$46125ee88f7f0638), this.race, (t)=>this.race = t, true);
            // bodyColor
            printControl("Body Color", (0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[this.race], this.bodyColor, (t)=>this.bodyColor = t, true);
            // sex
            printControl("Sex", (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race], this.sex, (t)=>this.sex = t, true);
            // hair
            printControl("Hair", (0, $bf6244e5cc9aa116$export$abac18ec637a6d99), this.hair, (t)=>this.hair = t);
            if (this.hair) // hair color
            printControl("Hair Color", (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[this.hair], this.hairColor, (t)=>this.hairColor = t);
            if ((0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race]?.length > 0) {
                // Eyes
                printControl("Eyes", (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race], this.eyes, (t)=>this.eyes = t);
                if (this.eyes) printControl("Eyes Color", (0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[this.eyes], this.eyesColor, (t)=>this.eyesColor = t);
            }
            if ((0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race]?.length > 0) {
                // Nose
                printControl("Nose", (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race], this.nose, (t)=>this.nose = t);
                if (this.nose) printControl("Nose Color", (0, $bf6244e5cc9aa116$export$f5fdec393d34621)[this.nose], this.noseColor, (t)=>this.noseColor = t);
            }
            const lpcComposite = new (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)("");
            lpcComposite.updatePaperdoll(this.entity);
            lpcComposite.scale.set(4);
            lpcComposite.x = this.width() - 150;
            lpcComposite.y = 250;
            lpcComposite.doMovement(this.entity);
            main.addChild(lpcComposite);
            return main;
        };
        this.logic = logic;
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");

// Palette and metrics shared by the chat LOG (gui/chat_history.ts) and the chat INPUT
// (gui/typing.ts). The two sit in the same corner and have to read as one component, so every
// colour and every measurement either widget uses lives here.
//
// Deliberately the ember HUD's warm dark glass (cf. gui/tutorial_prompt.ts, gui/role_picker.ts,
// gui/command_wheel.ts) rather than a palette of chat's own: the chat log shares the bottom-left
// corner with the readied-item slots and sits under the camp HUD, and a cool slate panel there
// looked like a different game's overlay.
const $bde0eb94ead9038f$export$72ee0c7a4855a274 = 320;
const $bde0eb94ead9038f$export$440d7b56d7e79537 = 8;
const $bde0eb94ead9038f$export$4f4624f448d7f7d8 = 9;
const $bde0eb94ead9038f$export$4dcefa986f9ebefe = 6;
const $bde0eb94ead9038f$export$35cf6b4f538836cd = 0x1b1512;
const $bde0eb94ead9038f$export$a3946689840d08dd = 0.84;
const $bde0eb94ead9038f$export$5eb57294d7a01ff = 0.93;
const $bde0eb94ead9038f$export$a9fed83f1c193f7e = 0x000000;
const $bde0eb94ead9038f$export$7fb3621e17d8a3da = 0.3;
const $bde0eb94ead9038f$export$ba288e268a12646c = 2;
const $bde0eb94ead9038f$export$13a6d78198248670 = 0x6b4f38;
const $bde0eb94ead9038f$export$542c8a566b36979 = 0xf2a94e;
const $bde0eb94ead9038f$export$516f68680b50dca1 = 0xfff3e0;
const $bde0eb94ead9038f$export$4a863a35dfd357dc = 0xf2a94e;
const $bde0eb94ead9038f$export$1f7cbc51fe7009c3 = 0xf2c879;
const $bde0eb94ead9038f$export$dc58655d5df465a7 = 0xf2c879;
const $bde0eb94ead9038f$export$ddc55e6671963e97 = 0xe8745a;
const $bde0eb94ead9038f$export$4e71f896fa269c0a = 10;
const $bde0eb94ead9038f$export$d02b3fe546d6073a = 3;
const $bde0eb94ead9038f$export$ec0e4eff17ebd09e = 13;
const $bde0eb94ead9038f$export$c1e8972bf2d4e8dc = 9;
const $bde0eb94ead9038f$export$251eac38a164bee4 = 22;
const $bde0eb94ead9038f$export$ae76bdcbbb40538 = 6;
const $bde0eb94ead9038f$export$b305389aaeaa7609 = 0.5;
const $bde0eb94ead9038f$export$baa08eb4811faa03 = 0xffd27f;
// Everyone else. Warm-leaning so they sit with the panel, but far enough apart in hue that two
// speakers in the same conversation never read as the same person.
const $bde0eb94ead9038f$var$SPEAKER_COLORS = [
    0x8fc9f0,
    0x9fe08f,
    0xf0a6c8,
    0xc4b3f0,
    0x7fe0d4,
    0xf0b27a,
    0xd6d66b,
    0xe39393
];
const $bde0eb94ead9038f$export$180c07c2129a34ac = (name, isSelf)=>{
    if (isSelf) return $bde0eb94ead9038f$export$baa08eb4811faa03;
    let hash = 5381;
    for(let i = 0; i < name.length; i++)hash = (hash << 5) + hash + name.charCodeAt(i) >>> 0;
    return $bde0eb94ead9038f$var$SPEAKER_COLORS[hash % $bde0eb94ead9038f$var$SPEAKER_COLORS.length];
};


// How much of a row's width the speaker's name may take before it is given its own line. Past
// this, the hanging indent leaves the message in a gutter too narrow to read.
const $030df650e8220c82$var$MAX_NAME_SHARE = 0.45;
// Air between the name and the message that follows it on the same line.
const $030df650e8220c82$var$NAME_GAP = 5;
// Used only where a Text measures as zero (a headless/mocked canvas), so the panel can never
// collapse into a sliver with every line drawn on top of the last.
const $030df650e8220c82$var$FALLBACK_LINE_H = (0, $bde0eb94ead9038f$export$4e71f896fa269c0a) + 3;
class $030df650e8220c82$export$23974c6ecceedade extends (0, $8t5Gy.Container) {
    constructor(pos){
        super(), // The row built for each entry currently on screen, so an arriving line costs one row rather
        // than a whole log's worth of text rasterization.
        this.rowCache = new Map(), this.hide = ()=>{
            this.visible = false;
        }, this.show = ()=>{
            this.visible = true;
        }, // Entries oldest-first; the newest is drawn at the bottom, nearest the input.
        this.updateEntries = (entries)=>{
            const shown = entries.filter((entry)=>!!entry.text);
            if (shown.length === 0) {
                this.clearRows();
                this.shadow.clear();
                this.panel.clear();
                return;
            }
            // The log is append-only: every call but the first adds ONE line and drops at most one off
            // the top. Rebuilding all of it would re-rasterize a dozen Texts in the frame a message
            // lands in, which on an integrated GPU is a visible hitch for nothing (see the budget
            // hardware target), so rows are kept and looked up by the entry they were built from.
            const kept = new Map();
            let y = 0;
            shown.forEach((entry, index)=>{
                const row = this.rowCache.get(entry) || this.buildRow(entry);
                kept.set(entry, row);
                row.y = y;
                // Recency as opacity: full strength for the newest line, fading back through the ones
                // the player has probably already read.
                row.alpha = shown.length === 1 ? 1 : (0, $bde0eb94ead9038f$export$b305389aaeaa7609) + (1 - (0, $bde0eb94ead9038f$export$b305389aaeaa7609)) * index / (shown.length - 1);
                if (row.parent !== this.rows) this.rows.addChild(row);
                y += Math.max(row.height || $030df650e8220c82$var$FALLBACK_LINE_H, $030df650e8220c82$var$FALLBACK_LINE_H) + (0, $bde0eb94ead9038f$export$d02b3fe546d6073a);
            });
            this.rowCache.forEach((row, entry)=>{
                if (!kept.has(entry)) {
                    this.rows.removeChild(row);
                    row.destroy({
                        children: true
                    });
                }
            });
            this.rowCache = kept;
            const height = Math.round(y - (0, $bde0eb94ead9038f$export$d02b3fe546d6073a) + (0, $bde0eb94ead9038f$export$4dcefa986f9ebefe) * 2);
            this.draw(height);
            this.y = this.pos - height;
        }, // One line: the speaker's name, then the message in a column beside it, wrapped to whatever
        // width that leaves.
        this.buildRow = (entry)=>{
            const inner = (0, $bde0eb94ead9038f$export$72ee0c7a4855a274) - (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) * 2;
            const row = new (0, $8t5Gy.Container)();
            let bodyX = 0;
            let bodyY = 0;
            if (entry.speaker) {
                const name = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$4e71f896fa269c0a)).color((0, $bde0eb94ead9038f$export$180c07c2129a34ac)(entry.speaker, entry.self)).bold().strokeThickness(0).render(entry.speaker);
                row.addChild(name);
                const nameWidth = name.width || entry.speaker.length * ((0, $bde0eb94ead9038f$export$4e71f896fa269c0a) * 0.6);
                if (nameWidth + $030df650e8220c82$var$NAME_GAP <= inner * $030df650e8220c82$var$MAX_NAME_SHARE) bodyX = nameWidth + $030df650e8220c82$var$NAME_GAP;
                else // A long name takes the line to itself and the message wraps full width under it,
                // rather than being squeezed into what is left.
                bodyY = (name.height || $030df650e8220c82$var$FALLBACK_LINE_H) + 1;
            }
            const body = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$4e71f896fa269c0a)).color((0, $bde0eb94ead9038f$export$516f68680b50dca1)).strokeThickness(0).wordWrap(Math.max(40, inner - bodyX)).render(entry.text);
            body.x = bodyX;
            body.y = bodyY;
            row.addChild(body);
            return row;
        }, this.draw = (height)=>{
            this.shadow.clear();
            this.shadow.beginFill((0, $bde0eb94ead9038f$export$a9fed83f1c193f7e), (0, $bde0eb94ead9038f$export$7fb3621e17d8a3da));
            this.shadow.drawRoundedRect((0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), height, (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.shadow.endFill();
            this.panel.clear();
            this.panel.lineStyle({
                width: 1,
                color: (0, $bde0eb94ead9038f$export$13a6d78198248670),
                alpha: 0.45,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            this.panel.beginFill((0, $bde0eb94ead9038f$export$35cf6b4f538836cd), (0, $bde0eb94ead9038f$export$a3946689840d08dd));
            this.panel.drawRoundedRect(0, 0, (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), height, (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.panel.endFill();
        }, this.clearRows = ()=>{
            this.rows.removeChildren().forEach((child)=>child.destroy({
                    children: true
                }));
            this.rowCache = new Map();
        };
        this.pos = pos;
        this.shadow = new (0, $gwPoJ.Graphics)();
        this.panel = new (0, $gwPoJ.Graphics)();
        this.rows = new (0, $8t5Gy.Container)();
        this.rows.x = (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8);
        this.rows.y = (0, $bde0eb94ead9038f$export$4dcefa986f9ebefe);
        this.addChild(this.shadow);
        this.addChild(this.panel);
        this.addChild(this.rows);
    }
}
// "Bryn: the fire is low" -> { speaker: "Bryn", text: "the fire is low" }, so a caller that still
// hands over one formatted line gets a coloured name like everyone else. A colon far into the line
// is punctuation in somebody's sentence, not a speaker, so only a short leading one counts.
const $030df650e8220c82$var$MAX_PARSED_NAME = 24;
const $030df650e8220c82$export$1efc33041612526 = (line)=>{
    const at = line.indexOf(": ");
    if (at <= 0 || at > $030df650e8220c82$var$MAX_PARSED_NAME) return {
        text: line
    };
    return {
        speaker: line.slice(0, at),
        text: line.slice(at + 2)
    };
};


// The chat line as DATA: the text, where the caret is in it, and what each edit does to both.
//
// It lives apart from the widget that draws it (gui/typing.ts) and from the manager that feeds it
// keystrokes (gui_manager) because this is the part with all the edge cases -- a caret in the
// middle of the line, word-wise deletion, pasted text that has to fit under the length cap, a
// history walk that must not eat the half-written line it was started from -- and all of them can
// then be tested without a renderer (gui/__tests__/chat_input_model.test.ts).
//
// Every function here is PURE: it returns a new state and never touches the one it was given.
const $2bc3e70fbff7f064$export$4779cfd32b998f47 = 150;
const $2bc3e70fbff7f064$export$d42b23612a605795 = {
    value: "",
    caret: 0
};
const $2bc3e70fbff7f064$var$clampCaret = (value, caret)=>Math.max(0, Math.min(value.length, caret));
const $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e = (value, caret)=>({
        value: value,
        caret: $2bc3e70fbff7f064$var$clampCaret(value, caret === undefined ? value.length : caret)
    });
// Pasted text arrives from the OS and can be anything: several lines, tabs, a stray control
// character from a terminal copy. Chat is one line, so newlines and tabs become single spaces
// rather than being dropped (dropping them glues the last word of one line to the first of the
// next) and other control characters go.
const $2bc3e70fbff7f064$var$CONTROL_CHARS = new RegExp("[\\u0000-\\u001f\\u007f]", "g");
const $2bc3e70fbff7f064$var$LINE_BREAKS = new RegExp("[\\r\\n\\t\\v\\f]+", "g");
const $2bc3e70fbff7f064$export$bdade7163ff3b5d5 = (text)=>text.replace($2bc3e70fbff7f064$var$LINE_BREAKS, " ").replace($2bc3e70fbff7f064$var$CONTROL_CHARS, "");
const $2bc3e70fbff7f064$export$78ba03e296d6b5ac = (state, text, maxLength = $2bc3e70fbff7f064$export$4779cfd32b998f47)=>{
    const clean = $2bc3e70fbff7f064$export$bdade7163ff3b5d5(text);
    if (!clean) return state;
    // Truncate the INSERTION rather than the result, so pasting a wall of text into the middle of
    // a line keeps what is already there instead of cutting the tail off it.
    const room = Math.max(0, maxLength - state.value.length);
    const fitted = clean.slice(0, room);
    if (!fitted) return state;
    return {
        value: state.value.slice(0, state.caret) + fitted + state.value.slice(state.caret),
        caret: state.caret + fitted.length
    };
};
// Start of the word before `index`: skip any run of spaces, then the run of non-spaces. Matches
// what Alt/Ctrl+Backspace does in a terminal and in a browser text field.
const $2bc3e70fbff7f064$var$wordStart = (value, index)=>{
    let i = index;
    while(i > 0 && value[i - 1] === " ")i--;
    while(i > 0 && value[i - 1] !== " ")i--;
    return i;
};
const $2bc3e70fbff7f064$var$wordEnd = (value, index)=>{
    let i = index;
    while(i < value.length && value[i] === " ")i++;
    while(i < value.length && value[i] !== " ")i++;
    return i;
};
const $2bc3e70fbff7f064$export$f2323afd0aa0bdea = (state, scope = "char")=>{
    if (state.caret === 0) return state;
    const from = scope === "line" ? 0 : scope === "word" ? $2bc3e70fbff7f064$var$wordStart(state.value, state.caret) : state.caret - 1;
    return {
        value: state.value.slice(0, from) + state.value.slice(state.caret),
        caret: from
    };
};
// Forward word-delete also swallows the gap it leaves behind -- deleting "the" out of "feed the
// fire" has to give back "feed fire", not "feed  fire".
const $2bc3e70fbff7f064$var$wordEndWithGap = (value, index)=>{
    let i = $2bc3e70fbff7f064$var$wordEnd(value, index);
    while(i < value.length && value[i] === " ")i++;
    return i;
};
const $2bc3e70fbff7f064$export$948b9f836237b4b4 = (state, scope = "char")=>{
    if (state.caret >= state.value.length) return state;
    const to = scope === "line" ? state.value.length : scope === "word" ? $2bc3e70fbff7f064$var$wordEndWithGap(state.value, state.caret) : state.caret + 1;
    return {
        value: state.value.slice(0, state.caret) + state.value.slice(to),
        caret: state.caret
    };
};
const $2bc3e70fbff7f064$export$f98ff0c9f6637db1 = (state, target, byWord = false)=>{
    switch(target){
        case "home":
            return {
                ...state,
                caret: 0
            };
        case "end":
            return {
                ...state,
                caret: state.value.length
            };
        case "left":
            return {
                ...state,
                caret: byWord ? $2bc3e70fbff7f064$var$wordStart(state.value, state.caret) : Math.max(0, state.caret - 1)
            };
        case "right":
            return {
                ...state,
                caret: byWord ? $2bc3e70fbff7f064$var$wordEnd(state.value, state.caret) : Math.min(state.value.length, state.caret + 1)
            };
    }
};
const $2bc3e70fbff7f064$export$2cd8bbcbf799240 = {
    entries: [],
    index: -1,
    draft: ""
};
const $2bc3e70fbff7f064$export$7f903ac43047fe20 = (walk, current)=>{
    if (walk.entries.length === 0) return {
        walk: walk,
        input: current
    };
    if (walk.index === -1) {
        const index = walk.entries.length - 1;
        return {
            walk: {
                ...walk,
                index: index,
                draft: current.value
            },
            input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.entries[index])
        };
    }
    const index = Math.max(0, walk.index - 1);
    return {
        walk: {
            ...walk,
            index: index
        },
        input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.entries[index])
    };
};
const $2bc3e70fbff7f064$export$2957600c134d4b7e = (walk, current)=>{
    if (walk.index === -1) return {
        walk: walk,
        input: current
    };
    if (walk.index >= walk.entries.length - 1) // Off the recent end: back to whatever was being written when the walk started.
    return {
        walk: {
            ...walk,
            index: -1,
            draft: ""
        },
        input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.draft)
    };
    const index = walk.index + 1;
    return {
        walk: {
            ...walk,
            index: index
        },
        input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.entries[index])
    };
};
const $2bc3e70fbff7f064$export$2051cccf06572bb3 = 50;
const $2bc3e70fbff7f064$export$8981372ce0f88573 = (walk, message)=>{
    if (!message) return {
        ...walk,
        index: -1,
        draft: ""
    };
    const last = walk.entries[walk.entries.length - 1];
    const entries = last === message ? walk.entries : [
        ...walk.entries,
        message
    ].slice(-$2bc3e70fbff7f064$export$2051cccf06572bb3);
    return {
        entries: entries,
        index: -1,
        draft: ""
    };
};




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $c95294a9bc078027$export$ee1739c2abaa1d8d extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.setup = (inventoryCallback, questsCallback, feedbackCallback, mapCallback)=>{
            this.interactive = true;
            this.on("mouseover", ()=>{
                this.guiManager.mouseOverControl(true);
            });
            this.on("mouseout", ()=>{
                this.guiManager.mouseOverControl(false);
            });
            const items = [
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "inventory.png",
                        scale: 0.8
                    }),
                    callback: inventoryCallback
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "globe.png",
                        scale: 0.8
                    }),
                    callback: mapCallback
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "book.png",
                        scale: 1.4
                    }),
                    callback: questsCallback
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "question.png",
                        scale: 0.6
                    }),
                    callback: ()=>this.guiManager.help(null)
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "discord.png",
                        scale: 0.7
                    }),
                    callback: ()=>window.open("https://discord.gg/Mbt6UfqW6e")
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "feedback.png",
                        scale: 0.8
                    }),
                    callback: feedbackCallback,
                    padding: 5
                }
            ];
            let prevObj;
            items.forEach((item)=>{
                const obj = item.sprite;
                obj.x = (prevObj ? prevObj.x : 0) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.75 + (item.padding || 0);
                obj.y = item.sprite.height / 2;
                obj.interactive = true;
                obj.on("click", item.callback);
                obj.on("tap", item.callback);
                prevObj = obj;
                this.addChild(obj);
            });
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");


// Fade timing for showing/dismissing the wheel. ms-per-step × steps-to-cross ≈ ~100ms each way.
const $7676384fbaf9cdf2$var$WHEEL_FADE_INTERVAL_MS = 5;
const $7676384fbaf9cdf2$var$WHEEL_FADE_STEP = 0.05;
// Ember-themed look + geometry. Kept as module constants (not props) so the visual treatment stays
// consistent regardless of the per-state colors a caller passes in.
const $7676384fbaf9cdf2$var$WHEEL_RIM_COLOR = 0xf2a94e // warm amber rim + soft glow
;
const $7676384fbaf9cdf2$var$WHEEL_DISC_ALPHA = 0.85 // opacity of the dark "glass" disc (legible over the world)
;
const $7676384fbaf9cdf2$var$WHEEL_SLICE_IDLE_COLOR = 0x3a2c22 // resting slice fill (warm charcoal)
;
const $7676384fbaf9cdf2$var$WHEEL_SLICE_IDLE_ALPHA = 0.55;
const $7676384fbaf9cdf2$var$WHEEL_GAP_ANGLE = 0.06 // radians of empty space on each side of a slice (purely visual)
;
const $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO = 0.3 // donut-hole radius as a fraction of the wheel radius
;
const $7676384fbaf9cdf2$var$WHEEL_HUB_RATIO = 0.22 // center hub radius as a fraction of the wheel radius
;
const $7676384fbaf9cdf2$var$WHEEL_LABEL_PADDING = 8 // how far inside the rim a label's furthest corner has to stay
;
const $7676384fbaf9cdf2$var$WHEEL_LABEL_MIN_SCALE = 0.7 // floor for shrinking a label that fits nowhere in its slice
;
const $7676384fbaf9cdf2$export$f672e119ffb748dd = "interactions";
const $7676384fbaf9cdf2$export$1789b2f994d19a7a = "defender:hold";
// Per-role accent for the per-NPC (role-locked) wheel — matches ROLE_COLORS in ember_roster.ts,
// hand-synced to avoid an import cycle (command_wheel ← gui_manager → ember_roster). The global
// (broadcast) wheel keeps the neutral amber WHEEL_RIM_COLOR instead.
const $7676384fbaf9cdf2$var$ROLE_ACCENT = {
    forager: 0x7be08a,
    defender: 0xff8a5c
};
class $7676384fbaf9cdf2$export$a36bd337d7c5ab90 extends (0, $gwPoJ.Graphics) {
    constructor(props = {}){
        super(), this.commandSlices = [], this.commandTexts = [], this.currentNPCIndex = 0, this.activeCommandIndex = -1, this.hoveredCommandIndex = -1, // While targeting a single NPC the role page is locked (center switcher disabled).
        this.roleLocked = false, // Fade state. `opened` is the logical open/closed flag (flips the instant a fade starts) so
        // callers see the wheel as "closed" the moment it begins dismissing, while the graphic keeps
        // rendering until its fade-out completes. Only one fader runs at a time.
        this.opened = false, this.fadeInFader = null, this.fadeOutFader = null, // Role glyphs match ROLE_EMOJI in ember_roster_card.ts (kept in sync by hand to avoid an import
        // cycle: command_wheel ← gui_manager → ember_roster).
        this.npcTypes = [
            {
                name: "forager",
                displayName: "Forager",
                emoji: "\uD83E\uDE93",
                commands: [
                    {
                        name: "forager:forage",
                        displayName: "Forage Wood"
                    },
                    {
                        name: "forager:feed_fire",
                        displayName: "Feed Fire"
                    },
                    {
                        name: "forager:head_back",
                        displayName: "Head Back"
                    },
                    {
                        name: "forager:follow",
                        displayName: "Follow Me"
                    },
                    {
                        name: "forager:rename",
                        displayName: "Rename"
                    }
                ]
            },
            {
                name: "defender",
                displayName: "Defender",
                emoji: "\uD83D\uDEE1\uFE0F",
                commands: [
                    {
                        name: "defender:defend",
                        displayName: "Defend Camp"
                    },
                    {
                        name: $7676384fbaf9cdf2$export$1789b2f994d19a7a,
                        displayName: "Hold Position"
                    },
                    {
                        name: "defender:follow",
                        displayName: "Follow Me"
                    },
                    {
                        name: "defender:rename",
                        displayName: "Rename"
                    }
                ]
            }
        ];
        this.radius = props.radius || 80;
        this.strokeWidth = props.strokeWidth || 3;
        this.backgroundColor = props.backgroundColor || 0x333333;
        this.textColor = props.textColor || 0xffffff;
        this.highlightColor = props.highlightColor || 0x4caf50;
        this.activeColor = props.activeColor || 0x2196f3;
        this.onCommandSelect = props.onCommandSelect;
        this.setupWheel();
        this.updateDisplay();
    }
    wrapText(text, maxWidth) {
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words){
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            // More accurate estimation: 8 pixels per character for 11px bold font
            const estimatedWidth = testLine.length * 8;
            if (estimatedWidth <= maxWidth) currentLine = testLine;
            else {
                if (currentLine) {
                    lines.push(currentLine);
                    currentLine = word;
                } else // If even a single word is too long, split it intelligently
                if (word.length * 8 > maxWidth) {
                    // Try to split at natural break points (hyphens, etc.)
                    const hyphenIndex = word.indexOf("-");
                    if (hyphenIndex > 0 && hyphenIndex < word.length - 1) {
                        lines.push(word.substring(0, hyphenIndex + 1));
                        currentLine = word.substring(hyphenIndex + 1);
                    } else {
                        const midPoint = Math.floor(word.length / 2);
                        lines.push(word.substring(0, midPoint));
                        currentLine = word.substring(midPoint);
                    }
                } else lines.push(word);
            }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
    }
    // The wheel's outer radius, so callers can anchor chrome of their own (e.g. the tether line
    // gui_manager draws to the commanded NPC) on the rim rather than the center.
    getRadius() {
        return this.radius;
    }
    // Identity color for the wheel's chrome: a per-NPC (role-locked) wheel takes its role's accent
    // so it reads as "this one unit"; the global broadcast wheel stays neutral amber. Public so the
    // tether line to the commanded NPC can wear the same accent as the wheel it leaves.
    getAccent() {
        if (this.roleLocked) {
            const role = this.npcTypes[this.currentNPCIndex].name;
            return $7676384fbaf9cdf2$var$ROLE_ACCENT[role] ?? $7676384fbaf9cdf2$var$WHEEL_RIM_COLOR;
        }
        return $7676384fbaf9cdf2$var$WHEEL_RIM_COLOR;
    }
    // (Re)draw the glowing "glass" backdrop in the current accent color. Two faint accent rings fake
    // an outer glow (cheaper than a blur filter, which matters on low-end GPUs), then a dark
    // translucent disc with an accent rim, and an inner ring framing the donut hole. Called on every
    // display update so the accent tracks global (amber) vs per-NPC (role color).
    drawBackground() {
        const accent = this.getAccent();
        const bg = this.backgroundCircle;
        bg.clear();
        bg.beginFill(accent, 0.05);
        bg.drawCircle(0, 0, this.radius + 11);
        bg.endFill();
        bg.beginFill(accent, 0.09);
        bg.drawCircle(0, 0, this.radius + 5);
        bg.endFill();
        bg.lineStyle(2, accent, 0.9);
        bg.beginFill(this.backgroundColor, $7676384fbaf9cdf2$var$WHEEL_DISC_ALPHA);
        bg.drawCircle(0, 0, this.radius);
        bg.endFill();
        bg.lineStyle(1.5, accent, 0.35);
        bg.drawCircle(0, 0, this.radius * $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO);
    }
    setupWheel() {
        // The backdrop (glow + disc + rim + inner ring) is (re)drawn by drawBackground so it can pick
        // up the current accent color; slices + labels are built by updateDisplay. Both run on every
        // hover/selection change.
        this.backgroundCircle = new (0, $gwPoJ.Graphics)();
        this.addChild(this.backgroundCircle);
        this.drawBackground();
        // Make the wheel interactive
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Circle)(0, 0, this.radius);
        // Add mouse events
        this.on("pointermove", this.onPointerMove.bind(this));
        this.on("pointerdown", this.onPointerDown.bind(this));
        this.on("pointerout", this.onPointerOut.bind(this));
        // Prevent context menu from appearing
        this.on("rightclick", (event)=>{
            event.stopPropagation();
        });
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
    }
    setupCenterDisplay() {
        // Remove existing center display elements
        if (this.centerBackground) this.removeChild(this.centerBackground);
        if (this.centerEmoji) this.removeChild(this.centerEmoji);
        if (this.switchGlyph) {
            this.removeChild(this.switchGlyph);
            this.switchGlyph = undefined;
        }
        if (this.pageDots) {
            this.removeChild(this.pageDots);
            this.pageDots = undefined;
        }
        const accent = this.getAccent();
        const hubRadius = this.radius * $7676384fbaf9cdf2$var$WHEEL_HUB_RATIO;
        // Circular hub for the center emoji, sitting in the donut hole
        this.centerBackground = new (0, $gwPoJ.Graphics)();
        this.centerBackground.lineStyle(2, accent, 0.9);
        this.centerBackground.beginFill(this.backgroundColor, 0.95);
        this.centerBackground.drawCircle(0, 0, hubRadius);
        this.centerBackground.endFill();
        this.addChild(this.centerBackground);
        if (this.roleLocked) // Per-NPC wheel: the hub is locked to one role — make it visibly inert (no switch
        // affordance, no hover glow, default cursor).
        this.centerBackground.interactive = false;
        else {
            // Global wheel: the hub cycles roles, so give it the full switch affordance — hover glow,
            // pointer cursor, a ↻ hint above the emoji, and a page dot per role below it.
            this.centerBackground.interactive = true;
            this.centerBackground.cursor = "pointer";
            this.centerBackground.hitArea = new (0, $6qzqq.Circle)(0, 0, hubRadius);
            this.centerBackground.on("pointerdown", (event)=>{
                event.stopPropagation();
                this.switchNPC();
            });
            this.centerBackground.on("pointerover", ()=>{
                this.centerBackground.tint = accent;
            });
            this.centerBackground.on("pointerout", ()=>{
                this.centerBackground.tint = 0xffffff;
            });
            this.drawSwitchAffordance(accent, hubRadius);
        }
        // Create center emoji
        this.updateCenterEmoji();
    }
    // Draw the "this hub switches roles" cues for the global wheel: a ↻ glyph in the top gap ring and
    // one page dot per role in the bottom gap ring (the current role filled, the others outlined).
    // Both sit on the wheel's vertical seam (the inter-slice gap), so they don't overlap any slice.
    drawSwitchAffordance(accent, hubRadius) {
        const innerRadius = this.radius * $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO;
        const gapMid = (hubRadius + innerRadius) / 2;
        const glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(accent).fontSize(Math.max(8, Math.round(hubRadius * 0.55))).bold().align("center").render("\u21BB");
        glyph.x = -glyph.width / 2;
        glyph.y = -gapMid - glyph.height / 2;
        glyph.alpha = 0.9;
        this.switchGlyph = glyph;
        this.addChild(glyph);
        const dots = new (0, $gwPoJ.Graphics)();
        const count = this.npcTypes.length;
        const spacing = 6;
        const startX = -((count - 1) * spacing) / 2;
        for(let i = 0; i < count; i++){
            const dx = startX + i * spacing;
            if (i === this.currentNPCIndex) {
                dots.beginFill(accent, 1.0);
                dots.drawCircle(dx, gapMid, 1.8);
                dots.endFill();
            } else {
                dots.lineStyle(1, accent, 0.7);
                dots.drawCircle(dx, gapMid, 1.8);
            }
        }
        this.pageDots = dots;
        this.addChild(dots);
    }
    updateCenterEmoji() {
        // Remove existing center emoji if it exists
        if (this.centerEmoji) this.removeChild(this.centerEmoji);
        const currentNPC = this.npcTypes[this.currentNPCIndex];
        // Sized to sit inside the circular hub (radius = this.radius * WHEEL_HUB_RATIO).
        this.centerEmoji = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(this.textColor).fontSize(Math.round(this.radius * $7676384fbaf9cdf2$var$WHEEL_HUB_RATIO * 1.5)).bold().align("center").render(currentNPC.emoji);
        this.centerEmoji.x = -this.centerEmoji.width / 2;
        this.centerEmoji.y = -this.centerEmoji.height / 2;
        this.centerEmoji.alpha = 0.9;
        this.addChild(this.centerEmoji);
    }
    onPointerMove(event) {
        // Stop event propagation to prevent interfering with game mouse handling
        event.stopPropagation();
        const position = event.data.global;
        const localPos = this.toLocal(position);
        const distance = Math.sqrt(localPos.x * localPos.x + localPos.y * localPos.y);
        // Over the center hub / donut hole → not hovering a slice
        const centerDistance = Math.sqrt(localPos.x * localPos.x + localPos.y * localPos.y);
        if (centerDistance <= this.radius * $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO) {
            // Mouse is over center emoji, clear any hover state
            if (this.hoveredCommandIndex !== -1) {
                this.hoveredCommandIndex = -1;
                this.updateDisplay();
            }
            return;
        }
        if (distance <= this.radius) {
            const angle = Math.atan2(localPos.y, localPos.x) + Math.PI / 2;
            const normalizedAngle = angle < 0 ? angle + Math.PI * 2 : angle;
            const currentNPC = this.npcTypes[this.currentNPCIndex];
            const sliceAngle = Math.PI * 2 / currentNPC.commands.length;
            const commandIndex = Math.floor(normalizedAngle / sliceAngle);
            if (commandIndex !== this.hoveredCommandIndex && commandIndex < currentNPC.commands.length) {
                this.hoveredCommandIndex = commandIndex;
                this.updateDisplay();
            }
        } else if (this.hoveredCommandIndex !== -1) {
            this.hoveredCommandIndex = -1;
            this.updateDisplay();
        }
    }
    onPointerDown(event) {
        // Stop event propagation to prevent triggering game attacks
        event.stopPropagation();
        const position = event.data.global;
        const localPos = this.toLocal(position);
        const distance = Math.sqrt(localPos.x * localPos.x + localPos.y * localPos.y);
        // Ignore clicks in the donut hole / on the hub (the hub handles its own click).
        if (distance <= this.radius && distance >= this.radius * $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO) {
            const angle = Math.atan2(localPos.y, localPos.x) + Math.PI / 2;
            const normalizedAngle = angle < 0 ? angle + Math.PI * 2 : angle;
            const currentNPC = this.npcTypes[this.currentNPCIndex];
            const sliceAngle = Math.PI * 2 / currentNPC.commands.length;
            const commandIndex = Math.floor(normalizedAngle / sliceAngle);
            if (commandIndex < currentNPC.commands.length) {
                this.activeCommandIndex = commandIndex;
                this.updateDisplay();
                // Call the callback
                const command = currentNPC.commands[commandIndex];
                this.onCommandSelect?.(command.name, currentNPC.name);
            }
        }
    }
    onPointerOut() {
        this.hoveredCommandIndex = -1;
        this.updateDisplay();
    }
    switchNPC() {
        // When bound to a single NPC the page is locked to that NPC's role.
        if (this.roleLocked) return;
        this.currentNPCIndex = (this.currentNPCIndex + 1) % this.npcTypes.length;
        this.activeCommandIndex = -1;
        this.hoveredCommandIndex = -1;
        this.updateCenterEmoji();
        this.updateDisplay();
    }
    updateDisplay() {
        // Tear the previous slices/labels down completely (not just .clear()) so repeated hover
        // updates don't leave orphaned Graphics accumulating as children.
        this.commandSlices.forEach((slice)=>this.removeChild(slice));
        this.commandSlices = [];
        this.commandTexts.forEach((text)=>this.removeChild(text));
        this.commandTexts = [];
        // Refresh the backdrop so its accent tracks global (amber) vs per-NPC (role color).
        this.drawBackground();
        const currentNPC = this.npcTypes[this.currentNPCIndex];
        const commandCount = currentNPC.commands.length;
        const sliceAngle = Math.PI * 2 / commandCount;
        const innerRadius = this.radius * $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO;
        const accent = this.getAccent();
        // Create new command slices and texts
        for(let i = 0; i < currentNPC.commands.length; i++){
            const slice = new (0, $gwPoJ.Graphics)();
            this.commandSlices.push(slice);
            this.addChild(slice);
            // Create text container
            const textContainer = new (0, $gwPoJ.Graphics)();
            this.commandTexts.push(textContainer);
            this.addChild(textContainer);
            // Get the command text
            const commandText = currentNPC.commands[i].displayName;
            // Wrap on an estimate first (wrapText counts characters), then measure what actually got
            // rendered -- the estimate is what the placement below has to correct for.
            const wrappedLines = this.wrapText(commandText, this.radius * 0.72);
            const textLineHeight = 12;
            // Calculate total content height for vertical centering
            const totalContentHeight = wrappedLines.length * textLineHeight;
            // Calculate starting Y position to center the entire content block
            let currentY = -totalContentHeight / 2;
            // Create text lines
            let blockWidth = 0;
            for(let lineIndex = 0; lineIndex < wrappedLines.length; lineIndex++){
                const lineText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(this.textColor).fontSize(11).bold().align("center").render(wrappedLines[lineIndex]);
                textContainer.addChild(lineText);
                blockWidth = Math.max(blockWidth, lineText.width);
                // Center each line horizontally
                lineText.x = -lineText.width / 2;
                lineText.y = currentY + lineIndex * textLineHeight;
            }
            const angle = i * sliceAngle - Math.PI / 2 + sliceAngle / 2;
            // Nudge labels away from the center hub: those above it lift, those below it drop. Derived
            // from the slice's own angle rather than its index, so a wheel with two or three slices
            // (an entity's interactions) lays out as sensibly as the four-command role wheels.
            const verticalOffset = Math.sin(angle) < 0 ? -6 : 6;
            const fit = this.fitLabel(angle, blockWidth, totalContentHeight, verticalOffset);
            textContainer.x = Math.cos(angle) * fit.radius;
            textContainer.y = Math.sin(angle) * fit.radius + verticalOffset;
            if (fit.scale < 1) textContainer.scale.set(fit.scale);
            // State-driven fill + edge color (idle edge takes the wheel's accent)
            let fillColor = $7676384fbaf9cdf2$var$WHEEL_SLICE_IDLE_COLOR;
            let fillAlpha = $7676384fbaf9cdf2$var$WHEEL_SLICE_IDLE_ALPHA;
            let edgeColor = accent;
            let edgeAlpha = 0.4;
            if (i === this.activeCommandIndex) {
                fillColor = this.activeColor;
                fillAlpha = 0.95;
                edgeColor = this.activeColor;
                edgeAlpha = 1.0;
            } else if (i === this.hoveredCommandIndex) {
                fillColor = this.highlightColor;
                fillAlpha = 0.9;
                edgeColor = this.highlightColor;
                edgeAlpha = 1.0;
            }
            slice.lineStyle(2, edgeColor, edgeAlpha);
            slice.beginFill(fillColor, fillAlpha);
            if (commandCount === 1) {
                // A lone command is an unbroken ring. Cutting the usual gaps into it would leave a
                // wedge-shaped notch at the top -- a divider dividing one thing from itself.
                slice.drawCircle(0, 0, this.radius);
                slice.beginHole();
                slice.drawCircle(0, 0, innerRadius);
                slice.endHole();
            } else {
                // Each slice is an annulus segment with a small gap on each side, so the commands read
                // as separated petals around the hub instead of a solid pie.
                const startAngle = i * sliceAngle - Math.PI / 2 + $7676384fbaf9cdf2$var$WHEEL_GAP_ANGLE;
                const endAngle = (i + 1) * sliceAngle - Math.PI / 2 - $7676384fbaf9cdf2$var$WHEEL_GAP_ANGLE;
                slice.moveTo(Math.cos(startAngle) * innerRadius, Math.sin(startAngle) * innerRadius);
                slice.lineTo(Math.cos(startAngle) * this.radius, Math.sin(startAngle) * this.radius);
                slice.arc(0, 0, this.radius, startAngle, endAngle);
                slice.lineTo(Math.cos(endAngle) * innerRadius, Math.sin(endAngle) * innerRadius);
                slice.arc(0, 0, innerRadius, endAngle, startAngle, true);
                slice.closePath();
            }
            slice.endFill();
        }
        // Ensure center display is always on top
        this.setupCenterDisplay();
    }
    // Where a label of this size can sit in a slice pointing along `angle`, and how much it has to
    // shrink if it cannot fit there at all.
    //
    // Placing every label at the middle of the annulus band is what used to push text into the rim:
    // the band's midpoint is measured along the slice's own axis, but a label is a BOX, and its outer
    // corner reaches further from the centre than the label's own midpoint does. On a diagonal slice
    // a wide label put that corner within a pixel or two of the rim, which reads as text spilling out
    // of the wheel. So: solve for the largest radius whose far corner still clears the rim by
    // WHEEL_LABEL_PADDING, cap it at the band midpoint so short labels keep the roomier placement,
    // and floor it at the donut hole so nothing is dragged onto the hub.
    fitLabel(angle, blockWidth, blockHeight, verticalOffset) {
        const u = Math.abs(Math.cos(angle));
        const v = Math.abs(Math.sin(angle));
        const halfWidth = blockWidth / 2;
        // The vertical nudge pushes the block AWAY from the hub, i.e. the same way the slice points,
        // so it adds to the corner's reach rather than cancelling any of it.
        const halfHeight = blockHeight / 2 + Math.abs(verticalOffset);
        const limit = this.radius - $7676384fbaf9cdf2$var$WHEEL_LABEL_PADDING;
        const innerRadius = this.radius * $7676384fbaf9cdf2$var$WHEEL_INNER_RATIO;
        // (u*r + halfWidth)^2 + (v*r + halfHeight)^2 = limit^2, solved for r. u^2 + v^2 === 1, so the
        // quadratic reduces to r^2 + 2*b*r + c = 0.
        const b = u * halfWidth + v * halfHeight;
        const c = halfWidth * halfWidth + halfHeight * halfHeight - limit * limit;
        const discriminant = b * b - c;
        const fitRadius = discriminant > 0 ? Math.sqrt(discriminant) - b : 0;
        const radius = Math.min((innerRadius + this.radius) / 2, Math.max(fitRadius, innerRadius));
        // Last resort for a label too long to fit anywhere in its slice: shrink it rather than let it
        // cross the rim. Scaling a centre-anchored block keeps it centred, so nothing else moves.
        const reach = Math.sqrt(Math.max(0, limit * limit - Math.pow(v * radius + halfHeight, 2))) - u * radius;
        const availableWidth = 2 * reach;
        const scale = blockWidth > availableWidth && availableWidth > 0 ? Math.max($7676384fbaf9cdf2$var$WHEEL_LABEL_MIN_SCALE, availableWidth / blockWidth) : 1;
        return {
            radius: radius,
            scale: scale
        };
    }
    getCurrentNPC() {
        return this.npcTypes[this.currentNPCIndex].name;
    }
    getActiveCommand() {
        if (this.activeCommandIndex >= 0) return this.npcTypes[this.currentNPCIndex].commands[this.activeCommandIndex].name;
        return null;
    }
    clearSelection() {
        this.activeCommandIndex = -1;
        this.hoveredCommandIndex = -1;
        this.updateDisplay();
    }
    // Bind the wheel to a single NPC and lock it to that NPC's role page. Used when the wheel is
    // opened from an entity's command button (server tells us which role).
    bindToEntity(targetEntityId, role) {
        this.targetEntityId = targetEntityId;
        this.roleLocked = true;
        const roleIndex = this.npcTypes.findIndex((npc)=>npc.name === role);
        this.currentNPCIndex = roleIndex >= 0 ? roleIndex : this.currentNPCIndex;
        this.activeCommandIndex = -1;
        this.hoveredCommandIndex = -1;
        this.updateCenterEmoji();
        this.updateDisplay();
    }
    // Bind the wheel to one entity's interactions: a synthetic single page whose "commands" are the
    // interaction types, locked (there is nothing to switch to). Reusing the role wheel's page shape
    // means the geometry, slice drawing, hover/selection states and fading all come for free; the
    // only thing gui_manager has to know is that a selection on the INTERACTION_PAGE page is an
    // interaction rather than a squad command.
    bindToInteractions(targetEntityId, commands, emoji = "\u270B") {
        this.targetEntityId = targetEntityId;
        this.roleLocked = true;
        this.npcTypes = [
            ...this.npcTypes.filter((npc)=>npc.name !== $7676384fbaf9cdf2$export$f672e119ffb748dd),
            {
                name: $7676384fbaf9cdf2$export$f672e119ffb748dd,
                displayName: "Interactions",
                emoji: emoji,
                commands: commands
            }
        ];
        this.currentNPCIndex = this.npcTypes.length - 1;
        this.activeCommandIndex = -1;
        this.hoveredCommandIndex = -1;
        this.updateCenterEmoji();
        this.updateDisplay();
    }
    // Return to the global (broadcast) wheel: no bound entity, role switching re-enabled.
    clearTarget() {
        this.targetEntityId = undefined;
        this.roleLocked = false;
        // Drop any synthetic interaction page so the global (Control-key) wheel can't cycle onto one
        // entity's verbs, and so the page dots count roles again.
        if (this.npcTypes.some((npc)=>npc.name === $7676384fbaf9cdf2$export$f672e119ffb748dd)) {
            this.npcTypes = this.npcTypes.filter((npc)=>npc.name !== $7676384fbaf9cdf2$export$f672e119ffb748dd);
            this.currentNPCIndex = Math.min(this.currentNPCIndex, this.npcTypes.length - 1);
            this.updateCenterEmoji();
            this.updateDisplay();
        }
    }
    getTargetEntityId() {
        return this.targetEntityId;
    }
    setVisible(visible) {
        if (visible) this.fadeIn();
        else this.fadeOut();
    }
    // Whether the wheel is logically open — true from the moment a fade-in starts until a fade-out
    // starts. Use this (not `.visible`) for input gating so releasing the wheel frees clicks
    // immediately rather than after the dismiss animation finishes.
    isOpen() {
        return this.opened;
    }
    // Reveal the wheel by fading it in. Interrupts an in-progress dismiss so a quick re-open picks
    // up from the current alpha instead of snapping.
    fadeIn() {
        this.opened = true;
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        // Start from fully transparent only when coming from a hidden state; if we're interrupting a
        // fade-out, continue from wherever the alpha currently sits.
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $7676384fbaf9cdf2$var$WHEEL_FADE_INTERVAL_MS,
            fadeAlphaDecrement: $7676384fbaf9cdf2$var$WHEEL_FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    // Dismiss the wheel by fading it out, hiding it once transparent. Interrupts an in-progress
    // reveal so a quick close starts from the current alpha.
    fadeOut() {
        this.opened = false;
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $7676384fbaf9cdf2$var$WHEEL_FADE_INTERVAL_MS,
            fadeAlphaDecrement: $7676384fbaf9cdf2$var$WHEEL_FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
            }
        });
        this.fadeOutFader.update();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


// The location chooser: while it is up the pointer stops meaning "attack" and starts meaning
// "here". Put up by the defender's "Hold Position" order, which wants a spot on the ground at FINE
// (pixel) precision -- the build preview's tile grid is too coarse to post a guard with.
//
// Drawn rather than sprited (unlike the bow's crosshair, which is an atlas frame) so the whole
// reticle can carry a state color -- amber for ground the NPC can stand on, red for ground it
// can't -- without a second texture, and so it costs one Graphics on a weak GPU.
//
// GEOMETRY. This is a direct child of the stage, which carries `scale.y = SCALER` (1.3): the same
// vertical stretch every GUI widget here lives with. A circle drawn in that frame reads as an egg,
// so the container undoes the stretch (scale.y = 1/SCALER) and positions itself in stage-local
// space (global.y / SCALER). The ground ellipse underneath is squashed DELIBERATELY on top of that,
// so it lies on the ground plane the way an entity's foot shadow does.
const $76a97c569b52295c$var$RETICLE_COLOR = 0xf2a94e // warm amber -- the command wheel's rim, so the ember UI reads as one set
;
const $76a97c569b52295c$var$BLOCKED_COLOR = 0xe8705c // muted red: this ground can't be stood on
;
const $76a97c569b52295c$var$CAPTION_COLOR = 0xfff3e0;
const $76a97c569b52295c$var$RING_RADIUS = 11;
const $76a97c569b52295c$var$TICK_GAP = 4 // clear space between the ring and the cross ticks
;
const $76a97c569b52295c$var$TICK_LENGTH = 6;
const $76a97c569b52295c$var$GROUND_RADIUS_X = 17;
const $76a97c569b52295c$var$GROUND_RADIUS_Y = 6;
const $76a97c569b52295c$var$CAPTION_OFFSET_Y = 20;
class $76a97c569b52295c$export$2e19b9798c747684 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), // Two captions, one line: what the pick is FOR, and — over ground nothing can stand on — why
        // clicking here will not take. The refusal replaces the prompt rather than sitting beside it,
        // so the line never has to compete with itself for the player's eye.
        this.prompt = "", this.refusal = "", this.blocked = false, // Idempotent: the first show() binds, every later one is a no-op.
        this.bindMouse = (mouse)=>{
            if (this.boundMouse || !mouse) return;
            this.boundMouse = mouse;
            mouse.addListener(this.followPointer);
        }, this.followPointer = (state)=>{
            if (!this.visible) return;
            this.x = state.position.x;
            this.y = state.position.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
        }, this.show = (caption, blockedCaption)=>{
            this.prompt = caption;
            this.refusal = blockedCaption;
            this.blocked = false;
            this.layoutCaption();
            this.visible = true;
            // Jump straight to wherever the pointer already is instead of waiting for the next move --
            // otherwise the reticle appears at the last spot it was used, which is somewhere else.
            if (this.boundMouse) {
                const position = this.boundMouse.state().position;
                this.x = position.x;
                this.y = position.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
            }
        }, this.hide = ()=>{
            this.visible = false;
        }, this.isVisible = ()=>this.visible, this.isBlocked = ()=>this.blocked, // The line currently under the reticle -- the prompt, or the refusal that has replaced it.
        this.captionText = ()=>this.caption.text, this.setBlocked = (blocked)=>{
            if (this.blocked === blocked) return;
            this.blocked = blocked;
            this.redraw();
        }, // The line under the reticle: the prompt, or the refusal in its place while the ground is
        // blocked. Re-centred every time because the two read at different widths.
        this.layoutCaption = ()=>{
            this.caption.text = this.blocked ? this.refusal : this.prompt;
            this.caption.x = -this.caption.width / 2;
            this.caption.y = $76a97c569b52295c$var$CAPTION_OFFSET_Y;
            this.caption.tint = this.blocked ? $76a97c569b52295c$var$BLOCKED_COLOR : $76a97c569b52295c$var$CAPTION_COLOR;
        }, this.redraw = ()=>{
            const color = this.blocked ? $76a97c569b52295c$var$BLOCKED_COLOR : $76a97c569b52295c$var$RETICLE_COLOR;
            const graphics = this.reticle;
            graphics.clear();
            // The patch of ground being chosen, lying flat.
            graphics.lineStyle(1, color, this.blocked ? 0.9 : 0.5);
            graphics.drawEllipse(0, 0, $76a97c569b52295c$var$GROUND_RADIUS_X, $76a97c569b52295c$var$GROUND_RADIUS_Y);
            // The reticle proper: a ring with four ticks aimed at its center.
            graphics.lineStyle(1.5, color, 1);
            graphics.drawCircle(0, 0, $76a97c569b52295c$var$RING_RADIUS);
            const directions = [
                [
                    1,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    -1
                ]
            ];
            directions.forEach(([dx, dy])=>{
                graphics.moveTo(dx * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP), dy * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP));
                graphics.lineTo(dx * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP + $76a97c569b52295c$var$TICK_LENGTH), dy * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP + $76a97c569b52295c$var$TICK_LENGTH));
            });
            graphics.beginFill(color, 1);
            graphics.drawCircle(0, 0, 1.5);
            graphics.endFill();
            this.layoutCaption();
        };
        // Undo the stage's vertical stretch so the reticle is round (see GEOMETRY above).
        this.scale.set(1, 1 / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        this.zIndex = 59000 // over the world and the HUD, under the command wheel (60000)
        ;
        this.visible = false;
        this.reticle = new (0, $gwPoJ.Graphics)();
        this.addChild(this.reticle);
        this.caption = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(11).bold().align("center").color($76a97c569b52295c$var$CAPTION_COLOR).render();
        this.addChild(this.caption);
        this.redraw();
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


// Fade timing — mirrors CommandWheel (~100ms each way).
const $1a2af550e0229b29$var$FADE_INTERVAL_MS = 5;
const $1a2af550e0229b29$var$FADE_STEP = 0.05;
// Ember-lit palette + geometry.
const $1a2af550e0229b29$var$RIM = 0xf2a94e // warm amber rim / glow
;
const $1a2af550e0229b29$var$PANEL_FILL = 0x1b1512;
const $1a2af550e0229b29$var$PANEL_ALPHA = 0.92;
const $1a2af550e0229b29$var$CARD_IDLE_FILL = 0x2a201a;
const $1a2af550e0229b29$var$CARD_HOVER_FILL = 0x33271e;
const $1a2af550e0229b29$var$CARD_IDLE_RIM = 0x6b4f38;
const $1a2af550e0229b29$var$TEXT_COLOR = 0xfff3e0;
const $1a2af550e0229b29$var$PAD = 12;
const $1a2af550e0229b29$var$TITLE_H = 20;
const $1a2af550e0229b29$var$CARD_W = 96;
const $1a2af550e0229b29$var$CARD_H = 104;
const $1a2af550e0229b29$var$CARD_GAP = 12;
const $1a2af550e0229b29$var$TAIL_H = 12;
const $1a2af550e0229b29$var$TAIL_HALF_W = 9;
const $1a2af550e0229b29$var$PANEL_CORNER = 10;
const $1a2af550e0229b29$var$CARD_CORNER = 8;
// Overall footprint scale. The stage applies a 1.3× vertical scale, so keep the widget compact
// enough that it still floats clear of the recruit near the top of the screen.
const $1a2af550e0229b29$var$WIDGET_SCALE = 0.82;
const $1a2af550e0229b29$var$PANEL_W = 2 * $1a2af550e0229b29$var$CARD_W + $1a2af550e0229b29$var$CARD_GAP + 2 * $1a2af550e0229b29$var$PAD;
const $1a2af550e0229b29$var$PANEL_H = $1a2af550e0229b29$var$TITLE_H + $1a2af550e0229b29$var$CARD_H + 2 * $1a2af550e0229b29$var$PAD;
// Origin (0,0) is the tail tip (points down at the recruit); the panel body floats above it.
const $1a2af550e0229b29$var$PANEL_LEFT = -$1a2af550e0229b29$var$PANEL_W / 2;
const $1a2af550e0229b29$var$PANEL_TOP = -($1a2af550e0229b29$var$TAIL_H + $1a2af550e0229b29$var$PANEL_H);
const $1a2af550e0229b29$var$CARD_Y = $1a2af550e0229b29$var$PANEL_TOP + $1a2af550e0229b29$var$PAD + $1a2af550e0229b29$var$TITLE_H;
const $1a2af550e0229b29$var$CARD_X0 = $1a2af550e0229b29$var$PANEL_LEFT + $1a2af550e0229b29$var$PAD;
const $1a2af550e0229b29$var$CARD_X1 = $1a2af550e0229b29$var$CARD_X0 + $1a2af550e0229b29$var$CARD_W + $1a2af550e0229b29$var$CARD_GAP;
const $1a2af550e0229b29$var$ROLE_CARDS = [
    {
        role: "forager",
        emoji: "\uD83E\uDE93",
        title: "Forager",
        desc: [
            "Gathers wood",
            "to feed the fire"
        ],
        color: 0x7be08a
    },
    {
        role: "defender",
        emoji: "\uD83D\uDEE1\uFE0F",
        title: "Defender",
        desc: [
            "Guards the camp",
            "and the Lord"
        ],
        color: 0xff8a5c
    }
];
class $1a2af550e0229b29$export$fcd75734e151a80 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.cards = [], // Whether the downward pointer is drawn. The tail is a claim -- "this panel is about whoever is
        // standing under its tip" -- so it comes off when there is no longer anybody there (see
        // setTailVisible).
        this.tailVisible = true, // Logical open flag — flips the instant a fade starts so input gating frees immediately (mirrors
        // CommandWheel.isOpen semantics). Only one fader runs at a time.
        this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onSelect = props.onSelect;
        this.scale.set($1a2af550e0229b29$var$WIDGET_SCALE);
        // Swallow pointer events over the panel so clicks on the widget never fall through to a world
        // attack (the cards handle their own clicks; this covers the gaps/title too).
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)($1a2af550e0229b29$var$PANEL_LEFT, $1a2af550e0229b29$var$PANEL_TOP, $1a2af550e0229b29$var$PANEL_W, $1a2af550e0229b29$var$PANEL_H + $1a2af550e0229b29$var$TAIL_H);
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.drawBackground();
        this.addTitle();
        this.cards = [
            this.makeCard($1a2af550e0229b29$var$ROLE_CARDS[0], $1a2af550e0229b29$var$CARD_X0),
            this.makeCard($1a2af550e0229b29$var$ROLE_CARDS[1], $1a2af550e0229b29$var$CARD_X1)
        ];
        this.visible = false;
    }
    // Dark "glass" panel with a warm rim, a faint outer glow (a fatter low-alpha copy — cheaper than a
    // blur filter, which matters on low-end GPUs), and a downward pointer whose tip sits at the origin.
    // The tail is drawn as a filled triangle overlapping the body's bottom edge with only its two
    // diagonals stroked, so there's no seam where it meets the body. Nothing below the body is drawn
    // at all once the tail is off, so the panel ends at its own bottom edge.
    drawBackground() {
        const g = this.bg;
        g.clear();
        // Soft outer glow.
        g.beginFill($1a2af550e0229b29$var$RIM, 0.06);
        g.drawRoundedRect($1a2af550e0229b29$var$PANEL_LEFT - 5, $1a2af550e0229b29$var$PANEL_TOP - 5, $1a2af550e0229b29$var$PANEL_W + 10, $1a2af550e0229b29$var$PANEL_H + 10, $1a2af550e0229b29$var$PANEL_CORNER + 5);
        g.endFill();
        // Body.
        g.lineStyle(2, $1a2af550e0229b29$var$RIM, 0.9);
        g.beginFill($1a2af550e0229b29$var$PANEL_FILL, $1a2af550e0229b29$var$PANEL_ALPHA);
        g.drawRoundedRect($1a2af550e0229b29$var$PANEL_LEFT, $1a2af550e0229b29$var$PANEL_TOP, $1a2af550e0229b29$var$PANEL_W, $1a2af550e0229b29$var$PANEL_H, $1a2af550e0229b29$var$PANEL_CORNER);
        g.endFill();
        if (!this.tailVisible) return;
        // Tail fill (base tucked 1px up into the body so the join is hidden).
        const baseY = -$1a2af550e0229b29$var$TAIL_H - 1;
        g.lineStyle(0);
        g.beginFill($1a2af550e0229b29$var$PANEL_FILL, $1a2af550e0229b29$var$PANEL_ALPHA);
        g.moveTo(-$1a2af550e0229b29$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($1a2af550e0229b29$var$TAIL_HALF_W, baseY);
        g.closePath();
        g.endFill();
        // Tail rim: stroke only the two visible diagonals (not the hidden base).
        g.lineStyle(2, $1a2af550e0229b29$var$RIM, 0.9);
        g.moveTo(-$1a2af550e0229b29$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($1a2af550e0229b29$var$TAIL_HALF_W, baseY);
    }
    addTitle() {
        const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($1a2af550e0229b29$var$TEXT_COLOR).fontSize(13).bold().align("center").render("Assign this recruit");
        title.x = -title.width / 2;
        title.y = $1a2af550e0229b29$var$PANEL_TOP + $1a2af550e0229b29$var$PAD - 2;
        title.alpha = 0.95;
        this.addChild(title);
    }
    makeCard(meta, x) {
        const container = new (0, $8t5Gy.Container)();
        container.x = x;
        container.y = $1a2af550e0229b29$var$CARD_Y;
        container.interactive = true;
        container.cursor = "pointer";
        container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $1a2af550e0229b29$var$CARD_W, $1a2af550e0229b29$var$CARD_H);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        // Emoji (no color/tint so it keeps its own colors).
        const emoji = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(34).align("center").render(meta.emoji);
        emoji.x = $1a2af550e0229b29$var$CARD_W / 2 - emoji.width / 2;
        emoji.y = 12;
        container.addChild(emoji);
        // Title in the role accent color.
        const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(meta.color).fontSize(15).bold().align("center").render(meta.title);
        title.x = $1a2af550e0229b29$var$CARD_W / 2 - title.width / 2;
        title.y = 56;
        container.addChild(title);
        // Two-line description.
        meta.desc.forEach((line, i)=>{
            const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($1a2af550e0229b29$var$TEXT_COLOR).fontSize(10).align("center").render(line);
            t.x = $1a2af550e0229b29$var$CARD_W / 2 - t.width / 2;
            t.y = 78 + i * 12;
            t.alpha = 0.82;
            container.addChild(t);
        });
        const handle = {
            container: container,
            bg: bg,
            meta: meta,
            hovered: false
        };
        this.drawCard(handle);
        container.on("pointerover", ()=>{
            handle.hovered = true;
            this.drawCard(handle);
        });
        container.on("pointerout", ()=>{
            handle.hovered = false;
            this.drawCard(handle);
        });
        container.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onSelect?.(meta.role);
        });
        this.addChild(container);
        return handle;
    }
    // Draw (or redraw on hover) a card: idle = warm charcoal fill + muted rim; hovered = a soft glow
    // in the role color, a brighter fill, and a full role-color rim.
    drawCard(handle) {
        const g = handle.bg;
        const color = handle.meta.color;
        g.clear();
        if (handle.hovered) {
            g.beginFill(color, 0.16);
            g.drawRoundedRect(-3, -3, $1a2af550e0229b29$var$CARD_W + 6, $1a2af550e0229b29$var$CARD_H + 6, $1a2af550e0229b29$var$CARD_CORNER + 3);
            g.endFill();
            g.lineStyle(2, color, 1);
            g.beginFill($1a2af550e0229b29$var$CARD_HOVER_FILL, 0.97);
        } else {
            g.lineStyle(1.5, $1a2af550e0229b29$var$CARD_IDLE_RIM, 0.7);
            g.beginFill($1a2af550e0229b29$var$CARD_IDLE_FILL, 0.9);
        }
        g.drawRoundedRect(0, 0, $1a2af550e0229b29$var$CARD_W, $1a2af550e0229b29$var$CARD_H, $1a2af550e0229b29$var$CARD_CORNER);
        g.endFill();
    }
    clearHover() {
        this.cards.forEach((card)=>{
            if (card.hovered) {
                card.hovered = false;
                this.drawCard(card);
            }
        });
    }
    // Bind the picker to a single recruit so GuiManager can keep it positioned over that NPC and scope
    // the chosen role back to it.
    bindToEntity(targetEntityId) {
        this.targetEntityId = targetEntityId;
        this.clearHover();
    }
    clearTarget() {
        this.targetEntityId = undefined;
    }
    // Show or hide the downward pointer. A recruit can walk off while the picker is up, and a tail
    // left behind would aim at bare ground -- or worse, at whoever wandered into that spot. Without
    // it the panel is just a panel, which is the honest thing to show. The hit area follows so the
    // widget stops swallowing clicks on a strip of world it no longer covers.
    setTailVisible(visible) {
        if (this.tailVisible === visible) return;
        this.tailVisible = visible;
        this.hitArea = new (0, $6qzqq.Rectangle)($1a2af550e0229b29$var$PANEL_LEFT, $1a2af550e0229b29$var$PANEL_TOP, $1a2af550e0229b29$var$PANEL_W, $1a2af550e0229b29$var$PANEL_H + (visible ? $1a2af550e0229b29$var$TAIL_H : 0));
        this.drawBackground();
    }
    getTargetEntityId() {
        return this.targetEntityId;
    }
    isOpen() {
        return this.opened;
    }
    // Reveal by fading in, interrupting an in-progress dismiss (mirrors CommandWheel.fadeIn).
    fadeIn() {
        this.opened = true;
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $1a2af550e0229b29$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $1a2af550e0229b29$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    // Dismiss by fading out, hiding once transparent (mirrors CommandWheel.fadeOut).
    fadeOut() {
        this.opened = false;
        this.clearHover();
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $1a2af550e0229b29$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $1a2af550e0229b29$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
            }
        });
        this.fadeOutFader.update();
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

var $8JEKL = parcelRequire("8JEKL");
// What an entity's displayed NAME is allowed to be.
//
// Entity names used to be fixed strings baked into a spawn template ("The Defender"), so nothing
// ever had to validate one. They are now also PLAYER INPUT: a camp member can be named by whoever
// recruited it (see the ember role picker / the "Rename" order), and in a shared camp that name is
// shown to every other player in the roster, so it goes through here on the way in.
//
// Lives in common so the one cap and the one cleaner are shared: the client limits what can be
// typed, the server refuses to store anything else, and neither can drift from the other.
// Longest name we keep. Matched to the ember roster card's own display cap (NAME_MAX_CHARS in
// ember_roster_card.ts), which is where names are read most: a longer one would arrive and then be
// shown ellipsized, which looks like the field lost the end of what was typed.
const $f515f7e7306690f2$export$3f7a98c621297efa = 11;
/**
 * Whether a code point may appear in a name: everything except the C0/C1 control codes and the
 * zero-width / directional-formatting marks. That second group is the one worth being explicit
 * about -- those spell nothing, they let a name hide characters inside itself or reorder the row it
 * is drawn in, which is a cheap way to misrepresent one player's crew to another.
 *
 * Written as comparisons rather than a regex character class on purpose: a class of escapes for
 * these is unreadable, and one mistyped digit silently widens it over real letters.
 */ const $f515f7e7306690f2$var$isNameCharacter = (codePoint)=>{
    if (codePoint <= 0x1f) return false // C0 controls (tab and newline included -- whitespace is collapsed below)
    ;
    if (codePoint >= 0x7f && codePoint <= 0x9f) return false // delete + C1 controls
    ;
    if (codePoint >= 0x200b && codePoint <= 0x200f) return false // zero-width space/joiners, LTR/RTL marks
    ;
    if (codePoint === 0x2028 || codePoint === 0x2029) return false // line + paragraph separators
    ;
    if (codePoint >= 0x202a && codePoint <= 0x202e) return false // bidi embeddings and overrides
    ;
    if (codePoint >= 0x2066 && codePoint <= 0x2069) return false // bidi isolates
    ;
    if (codePoint === 0xfeff) return false // byte-order mark / zero-width no-break space
    ;
    return true;
};
const $f515f7e7306690f2$export$994e283d47c52c2e = (raw)=>{
    if (typeof raw !== "string") return "";
    // Array.from splits by code POINT, so an astral character (an emoji) is weighed, kept or cut as
    // one thing rather than as two halves of a surrogate pair.
    const printable = Array.from(raw).filter((character)=>$f515f7e7306690f2$var$isNameCharacter(character.codePointAt(0) || 0)).join("");
    return printable.replace(/\s+/g, " ").trim().slice(0, $f515f7e7306690f2$export$3f7a98c621297efa).trim();
};




// The name prompt: a small field that floats over a camp member so the player can name it.
//
// Put up by the server (Protocol.type_openNamePrompt) at the two moments naming belongs to -- the
// end of a hire, as the last beat of the role picker, and the "Rename" order from a member's
// command wheel. It always opens on a name the member ALREADY has (one rolled from the camp's
// register, server-side), so the player is editing rather than filling in a blank, and dismissing
// it keeps that name. Nothing waits on the answer.
//
// Styled and driven exactly like role_picker.ts beside it -- same ember-lit palette, same
// bind/fade API so GuiManager can treat them the same way. Unlike the picker it does NOT follow its
// entity: it is pinned where it opened, because a field that slides around under a cursor (and a
// soft keyboard) is hard to type into. Same reasoning as the command wheel staying put.
//
// The text field is pixi-text-input, i.e. a real DOM <input> positioned over the canvas, which is
// what makes it work with a phone's keyboard. The two departures from the library's defaults are
// the same ones intro/login_field.ts documents at length (substituteText off, our own box), and
// are repeated rather than shared because that class is wired into the intro's own theme.
// Fade timing -- mirrors RolePicker / CommandWheel (~100ms each way).
const $c40c25df820e3512$var$FADE_INTERVAL_MS = 5;
const $c40c25df820e3512$var$FADE_STEP = 0.05;
// Ember-lit palette. Kept in sync by hand with role_picker.ts (the two open over the same NPC, one
// after the other, so they have to read as one panel).
const $c40c25df820e3512$var$RIM = 0xf2a94e;
const $c40c25df820e3512$var$PANEL_FILL = 0x1b1512;
const $c40c25df820e3512$var$PANEL_ALPHA = 0.92;
const $c40c25df820e3512$var$TEXT_COLOR = 0xfff3e0;
const $c40c25df820e3512$var$BUTTON_IDLE_FILL = 0x2a201a;
const $c40c25df820e3512$var$BUTTON_HOVER_FILL = 0x33271e;
const $c40c25df820e3512$var$BUTTON_IDLE_RIM = 0x6b4f38;
const $c40c25df820e3512$var$PAD = 12;
const $c40c25df820e3512$var$TITLE_H = 18;
const $c40c25df820e3512$var$FIELD_H = 26;
const $c40c25df820e3512$var$GAP = 8;
const $c40c25df820e3512$var$BUTTON_W = 88;
const $c40c25df820e3512$var$BUTTON_H = 24;
const $c40c25df820e3512$var$TAIL_H = 12;
const $c40c25df820e3512$var$TAIL_HALF_W = 9;
const $c40c25df820e3512$var$PANEL_CORNER = 10;
const $c40c25df820e3512$var$BUTTON_CORNER = 6;
const $c40c25df820e3512$var$PANEL_W = 184;
const $c40c25df820e3512$var$PANEL_H = $c40c25df820e3512$var$PAD + $c40c25df820e3512$var$TITLE_H + $c40c25df820e3512$var$GAP + $c40c25df820e3512$var$FIELD_H + $c40c25df820e3512$var$GAP + $c40c25df820e3512$var$BUTTON_H + $c40c25df820e3512$var$PAD;
// Origin (0,0) is the tail tip (points down at the entity); the panel body floats above it.
const $c40c25df820e3512$var$PANEL_LEFT = -$c40c25df820e3512$var$PANEL_W / 2;
const $c40c25df820e3512$var$PANEL_TOP = -($c40c25df820e3512$var$TAIL_H + $c40c25df820e3512$var$PANEL_H);
const $c40c25df820e3512$var$FIELD_W = $c40c25df820e3512$var$PANEL_W - 2 * $c40c25df820e3512$var$PAD;
const $c40c25df820e3512$var$FIELD_X = $c40c25df820e3512$var$PANEL_LEFT + $c40c25df820e3512$var$PAD;
const $c40c25df820e3512$var$FIELD_Y = $c40c25df820e3512$var$PANEL_TOP + $c40c25df820e3512$var$PAD + $c40c25df820e3512$var$TITLE_H + $c40c25df820e3512$var$GAP;
const $c40c25df820e3512$var$BUTTON_X = -$c40c25df820e3512$var$BUTTON_W / 2;
const $c40c25df820e3512$var$BUTTON_Y = $c40c25df820e3512$var$FIELD_Y + $c40c25df820e3512$var$FIELD_H + $c40c25df820e3512$var$GAP;
class $c40c25df820e3512$export$8a1c693d5de025d7 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.buttonHovered = false, // Whether the downward pointer is drawn. The prompt stays where it opened while its subject is
        // free to walk off, so the tail is the first thing to stop being true (see setTailVisible).
        this.tailVisible = true, // Logical open flag -- flips the instant a fade starts so input gating frees immediately
        // (mirrors RolePicker.isOpen semantics). Only one fader runs at a time.
        this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onSubmit = props.onSubmit;
        this.onCancel = props.onCancel;
        // Swallow pointer events over the panel so a click on it never falls through to a world
        // attack (the field and button handle their own; this covers the gaps and the title).
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)($c40c25df820e3512$var$PANEL_LEFT, $c40c25df820e3512$var$PANEL_TOP, $c40c25df820e3512$var$PANEL_W, $c40c25df820e3512$var$PANEL_H + $c40c25df820e3512$var$TAIL_H);
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.drawBackground();
        this.titleText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($c40c25df820e3512$var$TEXT_COLOR).fontSize(13).bold().align("center").render("Name them");
        this.titleText.x = -this.titleText.width / 2;
        this.titleText.y = $c40c25df820e3512$var$PANEL_TOP + $c40c25df820e3512$var$PAD - 2;
        this.titleText.alpha = 0.95;
        this.addChild(this.titleText);
        this.input = this.makeField();
        this.addChild(this.input);
        const { container: container, bg: bg } = this.makeButton();
        this.button = container;
        this.buttonBg = bg;
        this.drawButton();
        this.addChild(this.button);
        this.visible = false;
    }
    // Dark "glass" panel with a warm rim, a faint outer glow (a fatter low-alpha copy rather than a
    // blur filter, which matters on low-end GPUs) and a downward pointer whose tip sits at the
    // origin. Drawn exactly as role_picker.ts draws its own, tail and all.
    drawBackground() {
        const g = this.bg;
        g.clear();
        g.beginFill($c40c25df820e3512$var$RIM, 0.06);
        g.drawRoundedRect($c40c25df820e3512$var$PANEL_LEFT - 5, $c40c25df820e3512$var$PANEL_TOP - 5, $c40c25df820e3512$var$PANEL_W + 10, $c40c25df820e3512$var$PANEL_H + 10, $c40c25df820e3512$var$PANEL_CORNER + 5);
        g.endFill();
        g.lineStyle(2, $c40c25df820e3512$var$RIM, 0.9);
        g.beginFill($c40c25df820e3512$var$PANEL_FILL, $c40c25df820e3512$var$PANEL_ALPHA);
        g.drawRoundedRect($c40c25df820e3512$var$PANEL_LEFT, $c40c25df820e3512$var$PANEL_TOP, $c40c25df820e3512$var$PANEL_W, $c40c25df820e3512$var$PANEL_H, $c40c25df820e3512$var$PANEL_CORNER);
        g.endFill();
        if (!this.tailVisible) return;
        // Tail fill (base tucked 1px up into the body so the join is hidden), then only its two
        // visible diagonals stroked.
        const baseY = -$c40c25df820e3512$var$TAIL_H - 1;
        g.lineStyle(0);
        g.beginFill($c40c25df820e3512$var$PANEL_FILL, $c40c25df820e3512$var$PANEL_ALPHA);
        g.moveTo(-$c40c25df820e3512$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($c40c25df820e3512$var$TAIL_HALF_W, baseY);
        g.closePath();
        g.endFill();
        g.lineStyle(2, $c40c25df820e3512$var$RIM, 0.9);
        g.moveTo(-$c40c25df820e3512$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($c40c25df820e3512$var$TAIL_HALF_W, baseY);
    }
    makeField() {
        const input = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
            input: {
                fontFamily: "Arial, sans-serif",
                fontSize: "15px",
                lineHeight: `${$c40c25df820e3512$var$FIELD_H}px`,
                height: `${$c40c25df820e3512$var$FIELD_H}px`,
                width: `${$c40c25df820e3512$var$FIELD_W}px`,
                boxSizing: "border-box",
                padding: "0 8px",
                textAlign: "center",
                color: "#fff3e0",
                caretColor: "#f2a94e",
                multiline: false
            },
            box: (w, h, state)=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.lineStyle(1.5, state === "FOCUSED" ? $c40c25df820e3512$var$RIM : $c40c25df820e3512$var$BUTTON_IDLE_RIM, state === "FOCUSED" ? 1 : 0.7);
                g.beginFill(0x120e0b, 0.95);
                g.drawRoundedRect(0, 0, w, h, $c40c25df820e3512$var$BUTTON_CORNER);
                g.endFill();
                return g;
            }
        });
        // Keep the real <input> on screen instead of the library's pixi Text stand-in: that copy is
        // a canvas raster scaled by the stage transform, and it hides the field from the browser
        // while unfocused. The constructor always builds the stand-in before we can opt out, and
        // _destroySurrogate() leaves _surrogate_mask behind -- an opaque black Graphics that would
        // paint a slab over our frame. Take it out. (Same two fixes as intro/login_field.ts.)
        input.substituteText = false;
        const orphanedMask = input._surrogate_mask;
        if (orphanedMask) {
            input.removeChild(orphanedMask);
            orphanedMask.destroy();
            input._surrogate_mask = null;
        }
        input.x = $c40c25df820e3512$var$FIELD_X;
        input.y = $c40c25df820e3512$var$FIELD_Y;
        // The server refuses anything longer anyway (sanitizeEntityName); capping the field means a
        // player never types a name and then watches its tail disappear.
        input.maxLength = (0, $f515f7e7306690f2$export$3f7a98c621297efa);
        const dom = input._dom_input;
        dom.setAttribute("aria-label", "Name");
        dom.setAttribute("autocapitalize", "words");
        dom.setAttribute("autocorrect", "off");
        dom.setAttribute("spellcheck", "false");
        // Enter accepts, Escape backs out. Both on key-UP because that is the event the library
        // forwards -- and Escape in particular only arrives here while the field has focus, which is
        // why GuiManager also lets Escape through its typing suppression.
        input.on("keyup", (keycode)=>{
            if (keycode === 13) this.submit();
            if (keycode === 27) this.onCancel?.();
        });
        return input;
    }
    makeButton() {
        const container = new (0, $8t5Gy.Container)();
        container.x = $c40c25df820e3512$var$BUTTON_X;
        container.y = $c40c25df820e3512$var$BUTTON_Y;
        container.interactive = true;
        container.cursor = "pointer";
        container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $c40c25df820e3512$var$BUTTON_W, $c40c25df820e3512$var$BUTTON_H);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($c40c25df820e3512$var$TEXT_COLOR).fontSize(12).bold().align("center").render("Done");
        label.x = $c40c25df820e3512$var$BUTTON_W / 2 - label.width / 2;
        label.y = $c40c25df820e3512$var$BUTTON_H / 2 - label.height / 2;
        container.addChild(label);
        container.on("pointerover", ()=>{
            this.buttonHovered = true;
            this.drawButton();
        });
        container.on("pointerout", ()=>{
            this.buttonHovered = false;
            this.drawButton();
        });
        container.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.submit();
        });
        return {
            container: container,
            bg: bg
        };
    }
    drawButton() {
        const g = this.buttonBg;
        if (!g) return;
        g.clear();
        if (this.buttonHovered) {
            g.beginFill($c40c25df820e3512$var$RIM, 0.14);
            g.drawRoundedRect(-3, -3, $c40c25df820e3512$var$BUTTON_W + 6, $c40c25df820e3512$var$BUTTON_H + 6, $c40c25df820e3512$var$BUTTON_CORNER + 3);
            g.endFill();
            g.lineStyle(2, $c40c25df820e3512$var$RIM, 1);
            g.beginFill($c40c25df820e3512$var$BUTTON_HOVER_FILL, 0.97);
        } else {
            g.lineStyle(1.5, $c40c25df820e3512$var$BUTTON_IDLE_RIM, 0.7);
            g.beginFill($c40c25df820e3512$var$BUTTON_IDLE_FILL, 0.9);
        }
        g.drawRoundedRect(0, 0, $c40c25df820e3512$var$BUTTON_W, $c40c25df820e3512$var$BUTTON_H, $c40c25df820e3512$var$BUTTON_CORNER);
        g.endFill();
    }
    /**
     * Show or hide the DOM <input> itself.
     *
     * pixi-text-input syncs the real <input>'s position AND its css display from render(), i.e.
     * only while the panel is actually being drawn. So the moment this container's `visible` goes
     * false, pixi stops drawing it and the library never gets another chance to hide the field --
     * leaving the typed name on the page for good: crisp, fixed in screen space, floating over
     * whatever the player does next. (This bites a widget that comes and goes; the intro's fields
     * never had to, which is why intro/login_field.ts only has to tear the node down once.)
     *
     * So the prompt drives it itself, around every open and close.
     */ setFieldVisible(visible) {
        this.input._setDOMInputVisible(visible);
    }
    // An empty field means "leave the name alone" rather than "clear the name", so it cancels.
    submit() {
        const value = (this.input.text || "").trim();
        if (!value) {
            this.onCancel?.();
            return;
        }
        this.onSubmit?.(value);
    }
    // Bind the prompt to one entity and start the field on the name it already has. The focus is
    // deferred a tick on purpose: a focus() issued while the browser is still dispatching the
    // pointerdown that led here is handed straight back to the canvas, leaving the player typing at
    // the game instead of the field (the trap intro/login_field.ts hit).
    bindToEntity(targetEntityId, name) {
        this.targetEntityId = targetEntityId;
        this.input.text = name || "";
        this.buttonHovered = false;
        this.drawButton();
        setTimeout(()=>{
            if (this.opened) // select(), not focus(): the field opens on a name already, and the player's first
            // keystroke should replace it rather than land in the middle of it.
            this.input.select();
        }, 0);
    }
    clearTarget() {
        this.targetEntityId = undefined;
        this.input.blur();
    }
    // Show or hide the downward pointer. This prompt is pinned where it opened on purpose, so the
    // member being named routinely walks out from under it -- and a tail hanging over the spot they
    // left points at bare ground, or at whoever stepped into it. Dropping it leaves a plain panel,
    // which is the honest thing to show. The hit area follows so the widget stops swallowing clicks
    // on a strip of world it no longer covers.
    setTailVisible(visible) {
        if (this.tailVisible === visible) return;
        this.tailVisible = visible;
        this.hitArea = new (0, $6qzqq.Rectangle)($c40c25df820e3512$var$PANEL_LEFT, $c40c25df820e3512$var$PANEL_TOP, $c40c25df820e3512$var$PANEL_W, $c40c25df820e3512$var$PANEL_H + (visible ? $c40c25df820e3512$var$TAIL_H : 0));
        this.drawBackground();
    }
    getTargetEntityId() {
        return this.targetEntityId;
    }
    isOpen() {
        return this.opened;
    }
    // Reveal by fading in, interrupting an in-progress dismiss (mirrors RolePicker.fadeIn).
    fadeIn() {
        this.opened = true;
        // Shown on the NEXT frame, not this one: the library places the DOM input from its own
        // render(), so a field made visible before that first render is briefly drawn wherever the
        // page would have put it -- a flash of the name in the top-left corner. Still done by hand
        // rather than left to the library, because a reopen that interrupts a dismissal can leave
        // the panel's transform unchanged, and the library only re-syncs when something about it
        // has changed -- which would leave the field hidden for good.
        requestAnimationFrame(()=>{
            if (this.opened) this.setFieldVisible(true);
        });
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $c40c25df820e3512$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $c40c25df820e3512$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    // Dismiss by fading out, hiding once transparent (mirrors RolePicker.fadeOut). The DOM input
    // follows worldVisible/worldAlpha, so it goes with it.
    fadeOut() {
        this.opened = false;
        this.buttonHovered = false;
        this.drawButton();
        this.input.blur();
        // Before the early returns below, and before the fade rather than at the end of it: every
        // path out of here has to take the field with it (see setFieldVisible).
        this.setFieldVisible(false);
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $c40c25df820e3512$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $c40c25df820e3512$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
                this.setFieldVisible(false);
            }
        });
        this.fadeOutFader.update();
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");







// Presentation helpers for the ember end-of-run scorecard (see run_summary.ts). Split out so they
// can be unit-tested without pulling in the panel's pixi/paperdoll dependencies.
//
// Non-negotiable: run_summary.ts itself CANNOT be instantiated under jest -- importing it pulls in
// the pixi sprite graph, which dies on a circular import (`SignSprite extends undefined`). So every
// RULE the panel enforces lives here and the widget only sizes and places what these functions say.
// How a creature kind from the server is presented. Keys are what ember-controller.js reports: a
// wave enemy's orchestrator role, a wilderness enemy's race, or "rabbit". Anything unknown still
// renders (title-cased, with the generic skull) so a new creature type needs no client change.
const $0f597a38e51c14fa$var$CREATURE_META = {
    skirmisher: {
        label: "Skirmishers",
        emoji: "\uD83D\uDC80"
    },
    raider: {
        label: "Raiders",
        emoji: "\uD83D\uDDE1\uFE0F"
    },
    archer: {
        label: "Archers",
        emoji: "\uD83C\uDFF9"
    },
    bruiser: {
        label: "Bruisers",
        emoji: "\uD83E\uDDDF"
    },
    eliteRaider: {
        label: "Elite raiders",
        emoji: "\uD83D\uDC79"
    },
    slime: {
        label: "Slimes",
        emoji: "\uD83D\uDFE2"
    },
    snake: {
        label: "Snakes",
        emoji: "\uD83D\uDC0D"
    },
    redspider: {
        label: "Spiders",
        emoji: "\uD83D\uDD77\uFE0F"
    },
    rabbit: {
        label: "Rabbits",
        emoji: "\uD83D\uDC07"
    }
};
const $0f597a38e51c14fa$export$fe9c44471babb83 = (key)=>$0f597a38e51c14fa$var$CREATURE_META[key] || {
        label: key.charAt(0).toUpperCase() + key.slice(1),
        emoji: "\uD83D\uDC80"
    };
const $0f597a38e51c14fa$export$bc733b0c5cbb3e8a = (ms)=>{
    const total = Math.max(0, Math.round(ms / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor(total % 3600 / 60);
    const seconds = total % 60;
    const pad = (n)=>n < 10 ? `0${n}` : `${n}`;
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
};
const $0f597a38e51c14fa$export$ff38440d3f9f6c69 = (summary)=>{
    // A summary from a camp that doesn't report lives at all (an older server) reads as "no lives
    // to show" rather than as "out of lives": the panel then hides the embers and leaves both ways
    // on available, which is how it behaved before lives existed.
    const total = Math.max(0, Math.floor(summary?.livesTotal || 0));
    const spent = Math.max(0, Math.min(total, Math.floor(summary?.livesSpent || 0)));
    const remaining = total - spent;
    return {
        total: total,
        spent: spent,
        remaining: remaining,
        canTryAgain: total === 0 || remaining > 0,
        caption: total === 0 ? "" : remaining > 0 ? `${spent} OF ${total} SPENT` : "ALL SPENT"
    };
};
const $0f597a38e51c14fa$var$RESTART_BUTTON = {
    action: "restart",
    label: "RESTART",
    sublabel: "A FRESH CAMP"
};
// What the picker is for, in the two words the player has to recognise later.
const $0f597a38e51c14fa$var$INVADE_LABEL = "RESURRECT AS UNDEAD!";
const $0f597a38e51c14fa$export$539f268c17834231 = "RISE IN A STRANGER'S CAMP";
const $0f597a38e51c14fa$export$abb63c118f1212b9 = (remaining)=>remaining === 1 ? "ENDS YOUR RUN \u2014 1 LIFE LEFT" : `ENDS YOUR RUN \u{2014} ${remaining} LIVES LEFT`;
const $0f597a38e51c14fa$export$457f4e9d8b9cc341 = (summary, candidates)=>{
    const lives = $0f597a38e51c14fa$export$ff38440d3f9f6c69(summary);
    const buttons = lives.canTryAgain ? [
        {
            action: "tryAgain",
            label: "TRY AGAIN",
            sublabel: "HOLD THIS CAMP",
            primary: true,
            enabled: true,
            minor: false
        },
        {
            ...$0f597a38e51c14fa$var$RESTART_BUTTON,
            primary: false,
            enabled: true,
            minor: false
        }
    ] : [
        {
            ...$0f597a38e51c14fa$var$RESTART_BUTTON,
            primary: true,
            enabled: true,
            minor: false
        }
    ];
    // Only ever drawn when there is somewhere to GO. See the note above the three states.
    if (candidates && candidates.length > 0) buttons.push({
        action: "invade",
        label: $0f597a38e51c14fa$var$INVADE_LABEL,
        // Rise and lose nothing (the run was over anyway), or rise and spend what is left of
        // this camp -- which the button says out loud, because every exit builds a fresh one.
        sublabel: lives.canTryAgain ? $0f597a38e51c14fa$export$abb63c118f1212b9(Math.max(1, lives.remaining)) : $0f597a38e51c14fa$export$539f268c17834231,
        primary: false,
        enabled: true,
        minor: true
    });
    return buttons;
};
const $0f597a38e51c14fa$export$379f48b98209a8ad = 520;
const $0f597a38e51c14fa$export$fa4a844e549b373e = 1900;
const $0f597a38e51c14fa$export$6b83639ebebd9af = (elapsedMs)=>{
    const t = Math.min(1, Math.max(0, elapsedMs / $0f597a38e51c14fa$export$379f48b98209a8ad));
    // Eased out, so it slams in and drains away rather than fading evenly.
    return (1 - t) * (1 - t);
};
const $0f597a38e51c14fa$export$78e7f021a5df08b1 = 260 // the number slams in, throwing a shockwave
;
const $0f597a38e51c14fa$export$b16ae063a0ac6cd3 = 3000 // ...and is held, breathing, while embers rise past it
;
const $0f597a38e51c14fa$export$276df5295c341d02 = 480 // ...then lifts away as the panel rises into its place
;
const $0f597a38e51c14fa$export$f35fd8a59a3bec81 = $0f597a38e51c14fa$export$b16ae063a0ac6cd3 + $0f597a38e51c14fa$export$276df5295c341d02;
// How far into the handoff the panel starts coming up. Well before the headline is gone: the
// overlap is what makes it read as one movement instead of two.
const $0f597a38e51c14fa$var$PANEL_ENTRY_AT = 0.25;
// The slam: the headline arrives oversized and snaps down past its resting size before settling.
const $0f597a38e51c14fa$var$SLAM_FROM = 2.05;
// The hold's breath, and how fast it breathes.
const $0f597a38e51c14fa$var$BREATH = 0.014;
// One unhurried cycle across the hold, so a three-second pause reads as something alive rather
// than as a frozen frame.
const $0f597a38e51c14fa$var$BREATH_HZ = 2 * Math.PI / 3000;
// What the headline does on its way out.
const $0f597a38e51c14fa$var$EXIT_SHRINK = 0.22;
const $0f597a38e51c14fa$var$EXIT_LIFT = 34;
// The panel's rise, in stage units.
const $0f597a38e51c14fa$var$PANEL_RISE = 22;
const $0f597a38e51c14fa$var$clamp01 = (t)=>t < 0 ? 0 : t > 1 ? 1 : t;
const $0f597a38e51c14fa$var$easeOutCubic = (t)=>1 - Math.pow(1 - $0f597a38e51c14fa$var$clamp01(t), 3);
const $0f597a38e51c14fa$var$easeInOutCubic = (t)=>{
    const x = $0f597a38e51c14fa$var$clamp01(t);
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
};
// Overshoots its target and comes back, which is what makes the slam land rather than glide.
const $0f597a38e51c14fa$var$easeOutBack = (t)=>{
    const x = $0f597a38e51c14fa$var$clamp01(t);
    const c1 = 1.9;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};
// A band of a timeline, as 0..1. Used for the staggered fades (kicker, then epithet).
const $0f597a38e51c14fa$var$band = (elapsedMs, fromMs, toMs)=>$0f597a38e51c14fa$var$clamp01((elapsedMs - fromMs) / (toMs - fromMs));
const $0f597a38e51c14fa$export$1d9e6deb9235c1ae = (elapsedMs)=>{
    const elapsed = Math.max(0, elapsedMs);
    if (elapsed >= $0f597a38e51c14fa$export$f35fd8a59a3bec81) return {
        done: true,
        alpha: 0,
        scale: 1 - $0f597a38e51c14fa$var$EXIT_SHRINK,
        lift: $0f597a38e51c14fa$var$EXIT_LIFT,
        kickerAlpha: 0,
        epithetAlpha: 0,
        ringT: -1,
        emitting: false,
        panelAlpha: 1,
        panelRise: 0
    };
    const strike = $0f597a38e51c14fa$var$clamp01(elapsed / $0f597a38e51c14fa$export$78e7f021a5df08b1);
    const handoff = $0f597a38e51c14fa$var$band(elapsed, $0f597a38e51c14fa$export$b16ae063a0ac6cd3, $0f597a38e51c14fa$export$f35fd8a59a3bec81);
    // The number is gone before the handoff ends, so the panel's last stretch of arriving is
    // uncluttered.
    const leaving = $0f597a38e51c14fa$var$easeOutCubic(handoff / 0.8);
    const entering = $0f597a38e51c14fa$var$easeOutCubic($0f597a38e51c14fa$var$band(elapsed, $0f597a38e51c14fa$export$b16ae063a0ac6cd3 + $0f597a38e51c14fa$export$276df5295c341d02 * $0f597a38e51c14fa$var$PANEL_ENTRY_AT, $0f597a38e51c14fa$export$f35fd8a59a3bec81));
    const settled = $0f597a38e51c14fa$var$SLAM_FROM + (1 - $0f597a38e51c14fa$var$SLAM_FROM) * $0f597a38e51c14fa$var$easeOutBack(strike);
    const breath = handoff > 0 ? 0 : $0f597a38e51c14fa$var$BREATH * Math.sin(elapsed * $0f597a38e51c14fa$var$BREATH_HZ);
    return {
        done: false,
        alpha: $0f597a38e51c14fa$var$easeOutCubic(elapsed / ($0f597a38e51c14fa$export$78e7f021a5df08b1 * 0.5)) * (1 - leaving),
        scale: settled + breath - $0f597a38e51c14fa$var$EXIT_SHRINK * $0f597a38e51c14fa$var$easeInOutCubic(handoff),
        lift: $0f597a38e51c14fa$var$EXIT_LIFT * $0f597a38e51c14fa$var$easeInOutCubic(handoff),
        kickerAlpha: $0f597a38e51c14fa$var$band(elapsed, 120, 320) * (1 - leaving),
        epithetAlpha: $0f597a38e51c14fa$var$band(elapsed, 360, 600) * (1 - leaving),
        ringT: strike < 1 ? strike : -1,
        emitting: elapsed > $0f597a38e51c14fa$export$78e7f021a5df08b1 * 0.4 && handoff < 0.35,
        panelAlpha: entering,
        panelRise: $0f597a38e51c14fa$var$PANEL_RISE * (1 - entering)
    };
};
// Rungs of the ladder, richest-first: the first one the wave clears is the one it gets. The camp's
// wave table runs to 20 (see ember-wave-tempo docs), so the top rung is the whole night survived.
const $0f597a38e51c14fa$var$WAVE_EPITHETS = [
    {
        from: 20,
        epithet: "THE NIGHT BROKE FIRST"
    },
    {
        from: 15,
        epithet: "DEEP IN THE DARK"
    },
    {
        from: 10,
        epithet: "A LONG VIGIL"
    },
    {
        from: 6,
        epithet: "HARD-WON GROUND"
    },
    {
        from: 3,
        epithet: "THE CAMP HELD"
    },
    {
        from: 1,
        epithet: "THE FIRST OF THEM"
    }
];
const $0f597a38e51c14fa$export$c3cad9a9dc8138b = (wave)=>($0f597a38e51c14fa$var$WAVE_EPITHETS.find((rung)=>wave >= rung.from) || $0f597a38e51c14fa$var$WAVE_EPITHETS[$0f597a38e51c14fa$var$WAVE_EPITHETS.length - 1]).epithet;
const $0f597a38e51c14fa$export$ab07704fa45aa778 = (summary)=>{
    const wave = Math.max(0, Math.floor(summary?.wavesReached || 0));
    // Dying before the first wave lands has no number to report -- "WAVE 0" is not a thing that
    // happened. So this one case turns the big line from a verdict into a shove: the player who
    // sees it got the least out of the camp and is the likeliest to walk away from the game, and
    // three seconds of the screen telling them they achieved nothing is not what should be in
    // front of them while they decide. It names the fact small and puts the way forward big.
    if (wave <= 0) return {
        kicker: "NO WAVE CAME",
        headline: "BEGIN AGAIN",
        epithet: "YOU GOT THIS"
    };
    return {
        kicker: "YOU SURVIVED TO",
        headline: `WAVE ${wave}`,
        epithet: $0f597a38e51c14fa$export$c3cad9a9dc8138b(wave)
    };
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");




// The opening beat of the end-of-run scorecard: how far the camp got, in the biggest type the
// screen has, before the panel itself is allowed to say anything. See run_summary_format for the
// timing (it is one pure function of the clock) and run_summary.ts for who drives it.
//
// The number is the whole point, so everything here is arranged to make it land: it arrives
// oversized and snaps down past its resting size, a shockwave goes out from it, a bloom of warm
// light sits behind it, embers climb past it while it is held, and the two smaller lines fade in
// after it rather than with it. Then it lifts away and the panel comes up through the space it
// leaves.
//
// Drawn in the same language as the panel below it (warm amber, dark glass, no blur filters --
// fake glows out of layered fills, which is what the rest of the ember UI does for the sake of
// weak GPUs).
// Geometry, as the centre line of each element relative to the block's own centre. The stage
// stretches everything vertically by SCALER, so anything that should LOOK round (the shockwave,
// the bloom, the diamond) is drawn squashed.
const $ea1172331fcf5328$var$HEADLINE_SIZE = 58;
const $ea1172331fcf5328$var$KICKER_CY = -58;
const $ea1172331fcf5328$var$HEADLINE_CY = 0;
const $ea1172331fcf5328$var$RULE_Y = 48;
const $ea1172331fcf5328$var$EPITHET_CY = 62;
const $ea1172331fcf5328$var$GOLD = 0xffd23f // the run's number, in the same gold the panel gives "WAVES HELD"
;
const $ea1172331fcf5328$var$GOLD_HOT = 0xffb04a;
const $ea1172331fcf5328$var$RIM = 0xf2a94e;
const $ea1172331fcf5328$var$EMBER_CORE = 0xffd98a;
const $ea1172331fcf5328$var$SHADOW = 0x140a04;
// The bloom behind the number: concentric filled ellipses, low alpha, biggest first. Banded fills
// rather than a blur filter, for the same reason the panel's ash shadow is banded.
const $ea1172331fcf5328$var$BLOOM_BANDS = 7;
const $ea1172331fcf5328$var$BLOOM_RX = 260;
const $ea1172331fcf5328$var$BLOOM_RY = 104 / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
// The shockwave: two strokes going out from the strike, fading as they widen.
const $ea1172331fcf5328$var$RING_RX_FROM = 70;
const $ea1172331fcf5328$var$RING_RX_TO = 330;
const $ea1172331fcf5328$var$RING_ASPECT = 0.38;
// Embers climbing past the held number. Emitted on a clock while the frame says to, capped so a
// long hold can't grow the list without bound.
const $ea1172331fcf5328$var$MOTE_EVERY_MS = 46;
const $ea1172331fcf5328$var$MOTE_MAX = 44;
const $ea1172331fcf5328$var$MOTE_SPREAD_X = 210;
class $ea1172331fcf5328$export$8fae586d267b054 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.moteList = [], this.moteClock = 0;
        this.ring = new (0, $gwPoJ.Graphics)();
        this.addChild(this.ring);
        this.block = new (0, $8t5Gy.Container)();
        this.addChild(this.block);
        // Above the type, so an ember can pass in front of the number as well as behind the bloom.
        this.motes = new (0, $gwPoJ.Graphics)();
        this.addChild(this.motes);
        this.visible = false;
    }
    // Rebuild around a run. Safe to call again -- the previous build is torn down first.
    setSummary(summary) {
        this.teardown();
        const { kicker: kicker, headline: headline, epithet: epithet } = (0, $0f597a38e51c14fa$export$ab07704fa45aa778)(summary);
        const block = this.block;
        const bloom = new (0, $gwPoJ.Graphics)();
        for(let i = $ea1172331fcf5328$var$BLOOM_BANDS; i >= 1; i--){
            const t = i / $ea1172331fcf5328$var$BLOOM_BANDS;
            // The outer bands are nearly nothing; the light gathers towards the letters.
            bloom.beginFill($ea1172331fcf5328$var$GOLD_HOT, 0.055 * (1 - t) + 0.012);
            bloom.drawEllipse(0, $ea1172331fcf5328$var$HEADLINE_CY, $ea1172331fcf5328$var$BLOOM_RX * t, $ea1172331fcf5328$var$BLOOM_RY * t);
            bloom.endFill();
        }
        block.addChild(bloom);
        this.kicker = this.addLine(block, kicker, {
            size: 13,
            color: $ea1172331fcf5328$var$RIM,
            cy: $ea1172331fcf5328$var$KICKER_CY
        });
        // The number, in three passes: a dark copy for weight, a hotter oversized copy for the
        // glow around the letters, and the letters themselves on top.
        this.addHeadline(block, headline, $ea1172331fcf5328$var$SHADOW, 1, 3, 0.55);
        this.addHeadline(block, headline, $ea1172331fcf5328$var$GOLD_HOT, 1.06, 0, 0.38);
        this.addHeadline(block, headline, $ea1172331fcf5328$var$GOLD, 1, 0, 1);
        // A hairline rule with a diamond in it, separating the number from its verdict.
        const rule = new (0, $gwPoJ.Graphics)();
        const gap = 12;
        const reach = 92;
        rule.lineStyle(1, $ea1172331fcf5328$var$RIM, 0.45);
        rule.moveTo(-gap - reach, $ea1172331fcf5328$var$RULE_Y);
        rule.lineTo(-gap, $ea1172331fcf5328$var$RULE_Y);
        rule.moveTo(gap, $ea1172331fcf5328$var$RULE_Y);
        rule.lineTo(gap + reach, $ea1172331fcf5328$var$RULE_Y);
        rule.lineStyle(0);
        rule.beginFill($ea1172331fcf5328$var$RIM, 0.7);
        rule.drawPolygon([
            0,
            $ea1172331fcf5328$var$RULE_Y - 4 / (0, $10da07838e6d507c$export$c6ec669adaa5980d),
            4,
            $ea1172331fcf5328$var$RULE_Y,
            0,
            $ea1172331fcf5328$var$RULE_Y + 4 / (0, $10da07838e6d507c$export$c6ec669adaa5980d),
            -4,
            $ea1172331fcf5328$var$RULE_Y
        ]);
        rule.endFill();
        block.addChild(rule);
        this.epithet = this.addLine(block, epithet, {
            size: 11,
            color: $ea1172331fcf5328$var$RIM,
            cy: $ea1172331fcf5328$var$EPITHET_CY
        });
        this.moteList = [];
        this.moteClock = 0;
        this.ring.clear();
        this.motes.clear();
        this.block.alpha = 0;
        this.visible = true;
    }
    // TextRenderer has no letter-spacing, so these lines get theirs the only way a plain Text can:
    // spaces between the characters. Worth it -- they read as an inscription rather than a
    // caption, which is the difference between this beat and a tooltip.
    spaceOut(text) {
        return text.split("").join(" ");
    }
    // Anchored rather than offset by half its width: the whole block is scaled through the slam,
    // and an anchored Text stays put under a scale while an offset one drifts.
    addLine(parent, text, opts) {
        const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(opts.size).color(opts.color).bold().align("center").render(this.spaceOut(text));
        t.anchor.set(0.5, 0.5);
        t.y = opts.cy;
        t.alpha = 0;
        parent.addChild(t);
        return t;
    }
    // One pass of the number. `scale` is baked into this Text rather than taken from the block, so
    // the glow copy stays a fixed amount bigger than the letters through the whole slam.
    addHeadline(parent, text, color, scale, dy, alpha) {
        const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($ea1172331fcf5328$var$HEADLINE_SIZE).color(color).bold().align("center").render(text);
        t.anchor.set(0.5, 0.5);
        t.scale.set(scale);
        t.y = $ea1172331fcf5328$var$HEADLINE_CY + dy;
        t.alpha = alpha;
        parent.addChild(t);
    }
    // ===== per-frame ===================================================================
    // Draw one already-computed moment of the beat (see waveRevealFrame). `dtMs` is only needed by
    // the part that carries its own state: the embers.
    applyFrame(frame, dtMs = 0) {
        if (frame.done) {
            this.visible = false;
            return;
        }
        this.visible = true;
        this.block.alpha = frame.alpha;
        this.block.scale.set(frame.scale);
        this.block.y = -frame.lift;
        // The small lines fade in UNDER the block's own alpha, so neither can outrun the number.
        if (this.kicker) this.kicker.alpha = frame.kickerAlpha;
        if (this.epithet) this.epithet.alpha = frame.epithetAlpha;
        this.drawRing(frame.ringT);
        this.advanceMotes(dtMs, frame.emitting, frame.alpha);
    }
    drawRing(t) {
        const g = this.ring;
        g.clear();
        if (t < 0) return;
        const eased = 1 - Math.pow(1 - t, 3);
        const left = Math.pow(1 - t, 2);
        for(let i = 0; i < 2; i++){
            const rx = $ea1172331fcf5328$var$RING_RX_FROM + ($ea1172331fcf5328$var$RING_RX_TO - $ea1172331fcf5328$var$RING_RX_FROM) * eased - i * 26;
            if (rx <= 0) continue;
            g.lineStyle(3 * left + 0.6, i === 0 ? $ea1172331fcf5328$var$GOLD : $ea1172331fcf5328$var$GOLD_HOT, (0.55 - i * 0.2) * left);
            g.drawEllipse(0, $ea1172331fcf5328$var$HEADLINE_CY, rx, rx * $ea1172331fcf5328$var$RING_ASPECT / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        }
    }
    // Embers thrown up past the held number. One Graphics, cleared and refilled each frame -- a
    // few dozen filled circles, which costs nothing next to the paperdoll the panel is building.
    advanceMotes(dtMs, emitting, alpha) {
        if (emitting) {
            this.moteClock += dtMs;
            while(this.moteClock >= $ea1172331fcf5328$var$MOTE_EVERY_MS && this.moteList.length < $ea1172331fcf5328$var$MOTE_MAX){
                this.moteClock -= $ea1172331fcf5328$var$MOTE_EVERY_MS;
                this.moteList.push({
                    x: (Math.random() - 0.5) * $ea1172331fcf5328$var$MOTE_SPREAD_X * 2,
                    y: 46 + Math.random() * 26,
                    vx: (Math.random() - 0.5) * 0.02,
                    vy: -(0.045 + Math.random() * 0.055),
                    age: 0,
                    life: 700 + Math.random() * 700,
                    r: 0.9 + Math.random() * 1.5
                });
            }
        } else this.moteClock = 0;
        this.moteList = this.moteList.filter((mote)=>{
            mote.age += dtMs;
            mote.x += mote.vx * dtMs;
            mote.y += mote.vy * dtMs;
            return mote.age < mote.life;
        });
        const g = this.motes;
        g.clear();
        g.lineStyle(0);
        this.moteList.forEach((mote)=>{
            const left = 1 - mote.age / mote.life;
            // In fast, out slow: an ember is brightest just after it leaves the fire.
            const heat = Math.min(1, left * 3) * left * alpha;
            if (heat <= 0.02) return;
            g.beginFill($ea1172331fcf5328$var$GOLD_HOT, 0.16 * heat);
            g.drawCircle(mote.x, mote.y, mote.r * 2.4);
            g.endFill();
            g.beginFill($ea1172331fcf5328$var$EMBER_CORE, 0.9 * heat);
            g.drawCircle(mote.x, mote.y, mote.r);
            g.endFill();
        });
    }
    // ===== teardown ====================================================================
    // Free the number's textures (a 58pt Text is not a small canvas to hold onto until the next
    // death) and reset every piece of running state.
    teardown() {
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this.block);
        this.block.removeChildren().forEach((child)=>{
            if (!child.destroyed) child.destroy();
        });
        this.kicker = undefined;
        this.epithet = undefined;
        this.ring.clear();
        this.motes.clear();
        this.moteList = [];
        this.moteClock = 0;
        this.block.alpha = 0;
        this.block.scale.set(1);
        this.block.y = 0;
        this.visible = false;
    }
}


// The ember end-of-run scorecard: a centered panel that comes up when the player falls defending
// the camp, showing how the run went and offering the way back in. Driven entirely by one payload
// from the ember controller script (Protocol.type_showRunSummary -> EmberRunSummary).
//
// It offers up to two ways on, and the difference between them is the panel's whole job to make
// plain:
//   TRY AGAIN  -- get up in this same camp, everything still standing. This is what a life BUYS,
//                 so it is offered only while the camp still has one for the player.
//   RESTART    -- abandon it for a fresh camp, which is always available.
// The lives themselves are drawn as embers under the portrait: one per life the camp granted, lit
// while unspent and burnt out once spent. When the last one goes dark "try again" goes with it --
// not greyed out but GONE, leaving one button, centered: that camp is finished with the player and
// starting again elsewhere is the only thing left to decide.
//
// Drawn here in full, in the same ember-lit language as the command wheel / role picker (warm amber
// rim, dark glass, role-coloured accents) so the whole ember UI reads as one set. Fake glows rather
// than blur filters, for the same reason they use them: filters are expensive on weak GPUs.
// The stage stretches everything vertically by SCALER (1.3), so a box that should LOOK square is
// drawn wider than tall. All the geometry below is in stage units with that already accounted for.
const $8bf61ed7fd954e0e$var$SCREEN_W = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
const $8bf61ed7fd954e0e$var$CENTER_X = $8bf61ed7fd954e0e$var$SCREEN_W / 2;
// The same "visually centered" line the hero banner uses (the HUD's usable band is shorter than
// the nominal screen height).
const $8bf61ed7fd954e0e$var$CENTER_Y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2 + 52;
const $8bf61ed7fd954e0e$var$PANEL_W = 440;
const $8bf61ed7fd954e0e$var$PANEL_H = 310;
const $8bf61ed7fd954e0e$var$PANEL_LEFT = $8bf61ed7fd954e0e$var$CENTER_X - $8bf61ed7fd954e0e$var$PANEL_W / 2;
const $8bf61ed7fd954e0e$var$PANEL_TOP = $8bf61ed7fd954e0e$var$CENTER_Y - $8bf61ed7fd954e0e$var$PANEL_H / 2;
// Palette, shared with role_picker.ts / the ember roster.
const $8bf61ed7fd954e0e$var$RIM = 0xf2a94e;
const $8bf61ed7fd954e0e$var$PANEL_FILL = 0x1b1512;
const $8bf61ed7fd954e0e$var$PANEL_ALPHA = 0.96;
const $8bf61ed7fd954e0e$var$CARD_FILL = 0x241b16;
const $8bf61ed7fd954e0e$var$CARD_RIM = 0x6b4f38;
const $8bf61ed7fd954e0e$var$TEXT_COLOR = 0xfff3e0;
const $8bf61ed7fd954e0e$var$SCRIM_COLOR = 0x06060a;
// The gone-out portrait card: a cold frame, a near-black ground, and a blue-grey shadow over the
// player. Deliberately cool, where every other colour on this panel is warm.
const $8bf61ed7fd954e0e$var$ASH_RIM = 0x3c4048;
const $8bf61ed7fd954e0e$var$ASH_FILL = 0x05070c;
const $8bf61ed7fd954e0e$var$ASH_SHADOW = 0x04060f;
const $8bf61ed7fd954e0e$var$ASH_TEXT = 0x9aa2ae;
// The shadow is not flat: it thickens down the card, so the face is still legible and the body
// below it is swallowed. Top and bottom opacity of that fall, and how many bands it is drawn in
// (no gradient fills and no filters in this panel -- banded rects are what the rest of the ember
// UI uses, and they cost nothing on a weak GPU).
const $8bf61ed7fd954e0e$var$ASH_SHADOW_TOP = 0.14;
const $8bf61ed7fd954e0e$var$ASH_SHADOW_BOTTOM = 0.95;
const $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS = 28;
const $8bf61ed7fd954e0e$var$GOLD = 0xffd23f // waves — the run's real score
;
const $8bf61ed7fd954e0e$var$AMBER = 0xf2a94e // time survived
;
const $8bf61ed7fd954e0e$var$EMBER = 0xff8a5c // creatures vanquished
;
const $8bf61ed7fd954e0e$var$GREEN = 0x7be08a // forager/camp work
;
// Fade timing — mirrors the command wheel / role picker (~100ms each way).
const $8bf61ed7fd954e0e$var$FADE_INTERVAL_MS = 5;
const $8bf61ed7fd954e0e$var$FADE_STEP = 0.05;
// Panel-local geometry (origin = panel top-left).
const $8bf61ed7fd954e0e$var$PAD = 16;
const $8bf61ed7fd954e0e$var$PORTRAIT_W = 104;
const $8bf61ed7fd954e0e$var$PORTRAIT_H = 128;
const $8bf61ed7fd954e0e$var$PORTRAIT_TOP = 56;
// Zoom of the paperdoll inside the card, matched to the roster's framing (1.5 in a 70px card).
const $8bf61ed7fd954e0e$var$PORTRAIT_SCALE = 2.2;
const $8bf61ed7fd954e0e$var$STATS_LEFT = $8bf61ed7fd954e0e$var$PAD + $8bf61ed7fd954e0e$var$PORTRAIT_W + 14;
const $8bf61ed7fd954e0e$var$STATS_W = $8bf61ed7fd954e0e$var$PANEL_W - $8bf61ed7fd954e0e$var$PAD - $8bf61ed7fd954e0e$var$STATS_LEFT;
const $8bf61ed7fd954e0e$var$HERO_TOP = $8bf61ed7fd954e0e$var$PORTRAIT_TOP;
const $8bf61ed7fd954e0e$var$HERO_H = 60;
const $8bf61ed7fd954e0e$var$TILE_TOP = 134;
const $8bf61ed7fd954e0e$var$TILE_H = 44;
const $8bf61ed7fd954e0e$var$CHIP_LABEL_Y = 186;
const $8bf61ed7fd954e0e$var$CHIP_TOP = 197;
const $8bf61ed7fd954e0e$var$CHIP_H = 16;
const $8bf61ed7fd954e0e$var$CHIP_GAP = 5;
// The lives block sits in the left column, in the space under the portrait card.
const $8bf61ed7fd954e0e$var$LIVES_LABEL_Y = 188;
// The embers hang well clear of the label: a flame's tip reaches PIP_R * 1.35 above its centre,
// so a tight row here reads as the word sitting on top of the fire.
const $8bf61ed7fd954e0e$var$LIVES_ROW_Y = 210;
const $8bf61ed7fd954e0e$var$LIVES_CAPTION_Y = 234;
const $8bf61ed7fd954e0e$var$PIP_R = 9;
const $8bf61ed7fd954e0e$var$PIP_GAP = 8;
// The ember palette, warmer and redder than the panel's gold so a life reads as a coal rather
// than a coin: a red-orange body, a lighter rim, and a hot centre.
const $8bf61ed7fd954e0e$var$EMBER_BODY = 0xef5524;
const $8bf61ed7fd954e0e$var$EMBER_RIM = 0xffab66;
const $8bf61ed7fd954e0e$var$EMBER_CORE = 0xffd98a;
// How long the just-spent life takes to go out when the panel opens. It burns, gutters, and
// collapses into ash rather than simply appearing spent -- the player has to SEE it cost them.
const $8bf61ed7fd954e0e$var$LIVES_BURN_MS = 1150;
// The stretch of that, as a fraction, the ember spends still burning (and flickering) before it
// starts to go out.
const $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD = 0.35;
// The most of the opening flourish any single frame is allowed to consume. See advanceReveal.
const $8bf61ed7fd954e0e$var$REVEAL_MAX_STEP_MS = 90;
// Two buttons, side by side, filling the panel's inner width. Deliberately large: this panel is a
// dead stop in the run and these are the only two things on it the player can do.
const $8bf61ed7fd954e0e$var$BUTTON_H = 42;
const $8bf61ed7fd954e0e$var$BUTTON_GAP = 12;
const $8bf61ed7fd954e0e$var$BUTTON_W = ($8bf61ed7fd954e0e$var$PANEL_W - $8bf61ed7fd954e0e$var$PAD * 2 - $8bf61ed7fd954e0e$var$BUTTON_GAP) / 2;
// A lone button doesn't inherit half the panel's width -- it would read as one of a pair with the
// other one missing. Wider, and centered.
const $8bf61ed7fd954e0e$var$SOLO_BUTTON_W = 240;
const $8bf61ed7fd954e0e$var$BUTTON_TOP = 252;
// The MINOR row: the third way on ("Resurrect as Undead!"), which sits BELOW the panel's own bottom
// edge rather than inside it.
//
// Outside, because the panel has no vertical budget left -- the kill chips already stop 6px short
// of BUTTON_TOP -- and because being off the card is the clearest possible statement of rank. The
// design names the scorecard's hierarchy as the dial that stops the camp game becoming
// instrumental: this is third, smaller, cooler, and detached, and none of that is decoration.
//
// The stage is 800x600 with scale.y = SCALER, so the usable vertical band is 600/1.3 ~= 461 units
// and the panel ends at PANEL_TOP + PANEL_H = 387. This row runs to ~431, which keeps ~30 units of
// clearance -- the docked-panel height budget, which is a real limit and not a style note.
const $8bf61ed7fd954e0e$var$MINOR_BUTTON_W = 262;
const $8bf61ed7fd954e0e$var$MINOR_BUTTON_H = 30;
const $8bf61ed7fd954e0e$var$MINOR_BUTTON_TOP = $8bf61ed7fd954e0e$var$PANEL_H + 14;
class $8bf61ed7fd954e0e$export$786eace44478b97d extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), // Anything currently wearing a mask. Masks have to be detached before the subtree is destroyed
        // (a display object left pointing at a destroyed mask crashes the next render), which is the
        // same dance the roster cards do.
        this.masked = [], this.buttons = [], this.livesBurnMs = 0, // Sparks thrown off as the ember collapses: { x, y, vy, age, life }.
        this.sparks = [], this.revealMs = 0, this.revealing = false, this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onTryAgain = props.onTryAgain;
        this.onRestart = props.onRestart;
        this.onInvade = props.onInvade;
        // The scrim both dims the world and swallows every click, so a stray press while the panel
        // is up can't fire the player's bow into the camp behind it.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill($8bf61ed7fd954e0e$var$SCRIM_COLOR, 0.8);
        this.scrim.drawRect(-400, -400, $8bf61ed7fd954e0e$var$SCREEN_W + 800, 1400);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(-400, -400, $8bf61ed7fd954e0e$var$SCREEN_W + 800, 1400);
        this.scrim.on("pointerdown", (event)=>event.stopPropagation());
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.scrim.on("rightclick", (event)=>event.stopPropagation());
        this.scrim.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.addChild(this.scrim);
        this.panel = new (0, $8t5Gy.Container)();
        this.panel.x = $8bf61ed7fd954e0e$var$PANEL_LEFT;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP;
        this.addChild(this.panel);
        this.content = new (0, $8t5Gy.Container)();
        this.panel.addChild(this.content);
        // Over the panel, and centered on the screen rather than on the panel: the number is
        // bigger than the thing it introduces.
        this.reveal = new (0, $ea1172331fcf5328$export$8fae586d267b054)();
        this.reveal.x = $8bf61ed7fd954e0e$var$CENTER_X;
        this.reveal.y = $8bf61ed7fd954e0e$var$CENTER_Y;
        this.addChild(this.reveal);
        this.visible = false;
    }
    // ===== drawing =====================================================================
    // Dark "glass" body with a warm rim and a faint outer glow (a fatter low-alpha copy — cheaper
    // than a blur filter, which matters on low-end GPUs), plus a warm bar across the very top so
    // the header reads as its own band.
    drawPanelChrome() {
        const g = new (0, $gwPoJ.Graphics)();
        g.beginFill($8bf61ed7fd954e0e$var$RIM, 0.05);
        g.drawRoundedRect(-6, -6, $8bf61ed7fd954e0e$var$PANEL_W + 12, $8bf61ed7fd954e0e$var$PANEL_H + 12, 16);
        g.endFill();
        g.lineStyle(2, $8bf61ed7fd954e0e$var$RIM, 0.9);
        g.beginFill($8bf61ed7fd954e0e$var$PANEL_FILL, $8bf61ed7fd954e0e$var$PANEL_ALPHA);
        g.drawRoundedRect(0, 0, $8bf61ed7fd954e0e$var$PANEL_W, $8bf61ed7fd954e0e$var$PANEL_H, 11);
        g.endFill();
        // Header underline, fading out at both ends.
        g.lineStyle(0);
        g.beginFill($8bf61ed7fd954e0e$var$RIM, 0.35);
        g.drawRect($8bf61ed7fd954e0e$var$PAD * 2, 47, $8bf61ed7fd954e0e$var$PANEL_W - $8bf61ed7fd954e0e$var$PAD * 4, 1);
        g.endFill();
        return g;
    }
    addText(parent, text, opts) {
        const builder = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(opts.size).color(opts.color === undefined ? $8bf61ed7fd954e0e$var$TEXT_COLOR : opts.color);
        if (opts.bold) builder.bold();
        const t = builder.align("center").render(text);
        t.x = opts.center ? Math.round(opts.x - t.width / 2) : opts.x;
        t.y = opts.y;
        if (opts.alpha !== undefined) t.alpha = opts.alpha;
        parent.addChild(t);
        return t;
    }
    // Shrink a value until it fits its cell — a 12-minute run ("12:45") is a lot wider than "3".
    addFittedValue(parent, text, color, cx, y, maxW) {
        let size = 27;
        let t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).color(color).bold().align("center").render(text);
        while(t.width > maxW && size > 13){
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(t);
            size -= 2;
            t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).color(color).bold().align("center").render(text);
        }
        t.x = Math.round(cx - t.width / 2);
        t.y = y;
        parent.addChild(t);
        return t;
    }
    // The player's own paperdoll, framed and lit from below by the same campfire particles the
    // roster gives the Lord — the camp's fire is what the run was about.
    //
    // `extinguished` is the last-life version of the same card: with the lives spent, the fire
    // behind the portrait is OUT. No particles, a colder frame, and the player sunk into shadow —
    // the card stops being a portrait lit by a camp and becomes what is left of one. It is the
    // same reading as the burnt embers and the missing "try again" button, said a third way.
    buildPortrait(parent, player, extinguished) {
        const card = new (0, $8t5Gy.Container)();
        card.x = $8bf61ed7fd954e0e$var$PAD;
        card.y = $8bf61ed7fd954e0e$var$PORTRAIT_TOP;
        parent.addChild(card);
        const chrome = new (0, $gwPoJ.Graphics)();
        chrome.lineStyle(1.5, extinguished ? $8bf61ed7fd954e0e$var$ASH_RIM : $8bf61ed7fd954e0e$var$CARD_RIM, extinguished ? 0.5 : 0.8);
        chrome.beginFill(extinguished ? $8bf61ed7fd954e0e$var$ASH_FILL : 0x0a0d08, 0.95);
        chrome.drawRoundedRect(0, 0, $8bf61ed7fd954e0e$var$PORTRAIT_W, $8bf61ed7fd954e0e$var$PORTRAIT_H, 8);
        chrome.endFill();
        card.addChild(chrome);
        // A pixi mask belongs to exactly one display object, so the flame and the paperdoll each
        // get their own copy of the same inset rounded rect (as the roster cards do).
        const makeClip = ()=>{
            const clip = new (0, $gwPoJ.Graphics)();
            clip.beginFill(0xffffff);
            clip.drawRoundedRect(3, 3, $8bf61ed7fd954e0e$var$PORTRAIT_W - 6, $8bf61ed7fd954e0e$var$PORTRAIT_H - 6, 6);
            clip.endFill();
            return clip;
        };
        // The fire behind the portrait, unless it has gone out with the last life — in which case
        // there is no backdrop at all, and animate() has nothing left to advance.
        if (!extinguished) {
            const flameClip = makeClip();
            card.addChild(flameClip);
            const flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)($8bf61ed7fd954e0e$var$PORTRAIT_W, $8bf61ed7fd954e0e$var$PORTRAIT_H);
            flame.mask = flameClip;
            card.addChild(flame);
            this.flame = flame;
            this.masked.push(flame);
        }
        if (player && player.appearance) {
            // Paperdoll off a synthetic entity carrying just appearance/inventory/weapon, the same
            // way the inventory screen and the roster build theirs — nothing here should touch the
            // live player entity.
            const doll = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            doll.weapon = {
                weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(player.inventory, "weapon")?.type
            };
            doll.appearance = player.appearance;
            doll.inventory = player.inventory;
            const portrait = new (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)(player.entityId);
            try {
                portrait.updatePaperdoll(doll);
                // Framing matched to the roster cards (same zoom + head-and-shoulders crop, scaled
                // up for this bigger card), so the player reads as one of the camp.
                portrait.scale.set($8bf61ed7fd954e0e$var$PORTRAIT_SCALE);
                portrait.x = $8bf61ed7fd954e0e$var$PORTRAIT_W / 2;
                portrait.y = Math.round($8bf61ed7fd954e0e$var$PORTRAIT_H * 0.57);
                // Sunk into the dark rather than deleted: the shape of the player is still there
                // to be made out, which is what makes it read as a body and not an empty frame.
                // The falling shadow below does most of that work, so this only takes the edge off.
                portrait.alpha = extinguished ? 0.72 : 1;
                const portraitClip = makeClip();
                card.addChild(portraitClip);
                portrait.mask = portraitClip;
                card.addChild(portrait);
                this.masked.push(portrait);
            } catch (e) {
                // A malformed paperdoll must not cost the player their only way back into a run.
                console.warn("[RunSummary] portrait build failed", e);
            }
        }
        // A cold shadow over the card once the fire behind it is out — drawn above the paperdoll so
        // it falls ON the player, and under the name plate so the name stays readable.
        //
        // It DEEPENS down the card rather than lying flat: the head keeps just enough light to be
        // recognisable and everything below it goes into the dark, which is what makes the card
        // read as a body sinking rather than a picture someone turned the brightness down on.
        if (extinguished) {
            const shadow = new (0, $gwPoJ.Graphics)();
            const top = 3;
            const height = $8bf61ed7fd954e0e$var$PORTRAIT_H - 6;
            for(let band = 0; band < $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS; band++){
                // Eased, so the fall is gentle across the face and steep past the shoulders.
                const t = band / ($8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS - 1);
                const alpha = $8bf61ed7fd954e0e$var$ASH_SHADOW_TOP + ($8bf61ed7fd954e0e$var$ASH_SHADOW_BOTTOM - $8bf61ed7fd954e0e$var$ASH_SHADOW_TOP) * Math.pow(t, 1.6);
                shadow.beginFill($8bf61ed7fd954e0e$var$ASH_SHADOW, alpha);
                // Half a pixel of overlap: abutting bands leave hairline seams once the panel is
                // scaled onto the stage.
                shadow.drawRect(top, top + height * band / $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS, $8bf61ed7fd954e0e$var$PORTRAIT_W - 6, height / $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS + 0.6);
                shadow.endFill();
            }
            // Banded rects have square corners; the card does not. Clip them to the same inset
            // rounded rect the flame and the paperdoll use.
            const shadowClip = makeClip();
            card.addChild(shadowClip);
            shadow.mask = shadowClip;
            card.addChild(shadow);
            this.masked.push(shadow);
        }
        // Scrim + name plate across the bottom of the card.
        const plate = new (0, $gwPoJ.Graphics)();
        plate.beginFill(0x000000, 0.55);
        plate.drawRoundedRect(3, $8bf61ed7fd954e0e$var$PORTRAIT_H - 25, $8bf61ed7fd954e0e$var$PORTRAIT_W - 6, 22, 6);
        plate.endFill();
        card.addChild(plate);
        const name = player?.name ? player.name : "Camper";
        this.addText(card, name.length > 14 ? `${name.slice(0, 13)}\u{2026}` : name, {
            size: 11,
            bold: true,
            color: extinguished ? $8bf61ed7fd954e0e$var$ASH_TEXT : $8bf61ed7fd954e0e$var$TEXT_COLOR,
            x: $8bf61ed7fd954e0e$var$PORTRAIT_W / 2,
            y: $8bf61ed7fd954e0e$var$PORTRAIT_H - 21,
            center: true
        });
    }
    // The three headline numbers. These are the run's score, so they get the panel's biggest type.
    buildHeroStats(parent, summary) {
        const cells = [
            {
                value: (0, $0f597a38e51c14fa$export$bc733b0c5cbb3e8a)(summary.survivedMs),
                label: "SURVIVED",
                color: $8bf61ed7fd954e0e$var$AMBER
            },
            {
                value: `${summary.wavesCleared}`,
                label: "WAVES HELD",
                color: $8bf61ed7fd954e0e$var$GOLD
            },
            {
                value: `${summary.killsTotal}`,
                label: "VANQUISHED",
                color: $8bf61ed7fd954e0e$var$EMBER
            }
        ];
        const gap = 8;
        const cellW = ($8bf61ed7fd954e0e$var$STATS_W - gap * (cells.length - 1)) / cells.length;
        cells.forEach((cell, i)=>{
            const x = $8bf61ed7fd954e0e$var$STATS_LEFT + i * (cellW + gap);
            const bg = new (0, $gwPoJ.Graphics)();
            bg.lineStyle(1, cell.color, 0.28);
            bg.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, 0.85);
            bg.drawRoundedRect(x, $8bf61ed7fd954e0e$var$HERO_TOP, cellW, $8bf61ed7fd954e0e$var$HERO_H, 8);
            bg.endFill();
            parent.addChild(bg);
            this.addFittedValue(parent, cell.value, cell.color, x + cellW / 2, $8bf61ed7fd954e0e$var$HERO_TOP + 9, cellW - 10);
            this.addText(parent, cell.label, {
                size: 8,
                alpha: 0.7,
                x: x + cellW / 2,
                y: $8bf61ed7fd954e0e$var$HERO_TOP + $8bf61ed7fd954e0e$var$HERO_H - 15,
                center: true
            });
        });
        // The one number that is purely the player's own doing, rather than the camp's.
        if (summary.killsByPlayer > 0) this.addText(parent, `${summary.killsByPlayer} struck down by your own hand`, {
            size: 9,
            alpha: 0.6,
            x: $8bf61ed7fd954e0e$var$STATS_LEFT + $8bf61ed7fd954e0e$var$STATS_W / 2,
            y: $8bf61ed7fd954e0e$var$HERO_TOP + $8bf61ed7fd954e0e$var$HERO_H + 6,
            center: true
        });
    }
    // What the player built and kept alive, as opposed to what they killed.
    buildCampTiles(parent, summary) {
        const tiles = [
            {
                emoji: "\uD83E\uDE93",
                value: summary.treesFelled,
                label: "TREES FELLED",
                color: $8bf61ed7fd954e0e$var$GREEN
            },
            {
                emoji: "\uD83E\uDD1D",
                value: summary.recruitsHired,
                label: "RECRUITED",
                color: $8bf61ed7fd954e0e$var$GOLD
            },
            {
                emoji: "\uD83D\uDD25",
                value: summary.fireRekindled,
                label: "FIRE FED",
                color: $8bf61ed7fd954e0e$var$AMBER
            }
        ];
        const gap = 8;
        const tileW = ($8bf61ed7fd954e0e$var$STATS_W - gap * (tiles.length - 1)) / tiles.length;
        tiles.forEach((tile, i)=>{
            const x = $8bf61ed7fd954e0e$var$STATS_LEFT + i * (tileW + gap);
            const bg = new (0, $gwPoJ.Graphics)();
            bg.lineStyle(1, $8bf61ed7fd954e0e$var$CARD_RIM, 0.5);
            bg.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, 0.6);
            bg.drawRoundedRect(x, $8bf61ed7fd954e0e$var$TILE_TOP, tileW, $8bf61ed7fd954e0e$var$TILE_H, 7);
            bg.endFill();
            parent.addChild(bg);
            // Emoji keeps its own colours (never tinted), so it sits on its own line to the left of
            // the count rather than inside the coloured value text.
            const emoji = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(13).align("center").render(tile.emoji);
            const count = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(15).color(tile.color).bold().align("center").render(`${tile.value}`);
            const groupW = emoji.width + 4 + count.width;
            emoji.x = Math.round(x + tileW / 2 - groupW / 2);
            emoji.y = $8bf61ed7fd954e0e$var$TILE_TOP + 7;
            count.x = Math.round(emoji.x + emoji.width + 4);
            count.y = $8bf61ed7fd954e0e$var$TILE_TOP + 6;
            parent.addChild(emoji, count);
            this.addText(parent, tile.label, {
                size: 7,
                alpha: 0.65,
                x: x + tileW / 2,
                y: $8bf61ed7fd954e0e$var$TILE_TOP + $8bf61ed7fd954e0e$var$TILE_H - 13,
                center: true
            });
        });
    }
    // The kill breakdown, as compact emoji chips that flow onto as many rows as they need. Ordered
    // biggest-first by the server, so the run's defining enemy leads.
    buildKillChips(parent, summary) {
        this.addText(parent, summary.kills.length > 0 ? "THE FALLEN" : "NOTHING FELL TO THE CAMP", {
            size: 8,
            alpha: 0.5,
            x: $8bf61ed7fd954e0e$var$STATS_LEFT,
            y: $8bf61ed7fd954e0e$var$CHIP_LABEL_Y
        });
        let x = $8bf61ed7fd954e0e$var$STATS_LEFT;
        let y = $8bf61ed7fd954e0e$var$CHIP_TOP;
        summary.kills.forEach((kill)=>{
            const meta = (0, $0f597a38e51c14fa$export$fe9c44471babb83)(kill.key);
            const emoji = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(10).align("center").render(meta.emoji);
            const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(9).color($8bf61ed7fd954e0e$var$TEXT_COLOR).align("center").render(`${meta.label} ${kill.count}`);
            const chipW = 8 + emoji.width + 4 + label.width + 8;
            // Wrap to the next row; drop anything that would spill past the two rows the panel has
            // room for (a long tail of one-off kinds isn't worth pushing the button off the panel).
            if (x + chipW > $8bf61ed7fd954e0e$var$STATS_LEFT + $8bf61ed7fd954e0e$var$STATS_W) {
                x = $8bf61ed7fd954e0e$var$STATS_LEFT;
                y += $8bf61ed7fd954e0e$var$CHIP_H + $8bf61ed7fd954e0e$var$CHIP_GAP;
            }
            if (y + $8bf61ed7fd954e0e$var$CHIP_H > $8bf61ed7fd954e0e$var$BUTTON_TOP - 6) {
                (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(emoji);
                (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(label);
                return;
            }
            const bg = new (0, $gwPoJ.Graphics)();
            bg.lineStyle(1, $8bf61ed7fd954e0e$var$CARD_RIM, 0.55);
            bg.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, 0.75);
            bg.drawRoundedRect(x, y, chipW, $8bf61ed7fd954e0e$var$CHIP_H, $8bf61ed7fd954e0e$var$CHIP_H / 2);
            bg.endFill();
            parent.addChild(bg);
            emoji.x = Math.round(x + 8);
            emoji.y = Math.round(y + 2);
            label.x = Math.round(emoji.x + emoji.width + 4);
            label.y = Math.round(y + 3);
            label.alpha = 0.9;
            parent.addChild(emoji, label);
            x += chipW + $8bf61ed7fd954e0e$var$CHIP_GAP;
        });
    }
    // The lives this camp granted, as embers under the portrait: lit for a life still in hand,
    // burnt out for one already spent. The count is also spelled out underneath, because the
    // difference between two lit embers and three is not something to make anyone squint at.
    buildLives(parent, summary) {
        const { total: total, spent: spent, remaining: remaining, caption: caption } = (0, $0f597a38e51c14fa$export$ff38440d3f9f6c69)(summary);
        if (total <= 0) return;
        const columnCx = $8bf61ed7fd954e0e$var$PAD + $8bf61ed7fd954e0e$var$PORTRAIT_W / 2;
        this.addText(parent, "LIVES", {
            size: 8,
            alpha: 0.5,
            x: columnCx,
            y: $8bf61ed7fd954e0e$var$LIVES_LABEL_Y,
            center: true
        });
        const step = $8bf61ed7fd954e0e$var$PIP_R * 2 + $8bf61ed7fd954e0e$var$PIP_GAP;
        const rowW = total * $8bf61ed7fd954e0e$var$PIP_R * 2 + (total - 1) * $8bf61ed7fd954e0e$var$PIP_GAP;
        this.embers = new (0, $gwPoJ.Graphics)();
        parent.addChild(this.embers);
        this.livesLayout = {
            firstCx: columnCx - rowW / 2 + $8bf61ed7fd954e0e$var$PIP_R,
            step: step,
            cy: $8bf61ed7fd954e0e$var$LIVES_ROW_Y + $8bf61ed7fd954e0e$var$PIP_R,
            total: total,
            spent: spent
        };
        // The row empties from the RIGHT: the lives still in hand stay banked on the left, and the
        // one this death just took is the leftmost of the dark ones -- which is the one that burns
        // out in front of the player (see drawLivesRow / animate).
        this.livesBurnMs = 0;
        this.sparks = [];
        this.drawLivesRow();
        this.addText(parent, caption, {
            size: 8,
            color: remaining > 0 ? $8bf61ed7fd954e0e$var$TEXT_COLOR : $8bf61ed7fd954e0e$var$EMBER,
            alpha: remaining > 0 ? 0.6 : 0.9,
            x: columnCx,
            y: $8bf61ed7fd954e0e$var$LIVES_CAPTION_Y,
            center: true
        });
    }
    // Redraw the whole row for the current moment of the burn-out. Cheap enough to do every frame
    // (a handful of filled paths), and it keeps all the state in one place: which lives are lit,
    // which are ash, and how far through going out the one in between is.
    drawLivesRow() {
        const g = this.embers;
        const layout = this.livesLayout;
        if (!g || !layout) return;
        const { firstCx: firstCx, step: step, cy: cy, total: total, spent: spent } = layout;
        const remaining = total - spent;
        // How much fire is left in the life this death took. It holds — guttering, which is what
        // the flicker is — and only then goes out, so the loss reads as an event rather than as a
        // value that was always that way. The one that burns is the leftmost of the spent ones:
        // the boundary between what is still in hand and what is gone.
        const t = Math.max(0, Math.min(1, this.livesBurnMs / $8bf61ed7fd954e0e$var$LIVES_BURN_MS));
        const heat = t < $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD ? 1 - 0.14 * Math.abs(Math.sin(t * 26)) : 1 - (t - $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD) / (1 - $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD);
        g.clear();
        for(let i = 0; i < total; i++){
            const cx = firstCx + i * step;
            if (i < remaining) this.drawEmber(g, cx, cy, 1);
            else if (i === remaining && spent > 0) this.drawEmber(g, cx, cy, heat);
            else this.drawEmber(g, cx, cy, 0);
        }
        this.sparks.forEach((spark)=>{
            const left = 1 - spark.age / spark.life;
            if (left <= 0) return;
            g.lineStyle(0);
            g.beginFill($8bf61ed7fd954e0e$var$EMBER_CORE, 0.85 * left);
            g.drawCircle(spark.x, spark.y, 1.4 * left + 0.5);
            g.endFill();
        });
    }
    // One ember: a teardrop flame, drawn at `heat` — 1 burning, 0 cold ash. The socket (the dark
    // outline) is always there, so the row keeps its shape as it empties; what changes is the fire
    // inside it, which shrinks into the socket and drains from red-orange to nothing.
    drawEmber(g, cx, cy, heat) {
        const flame = (r, oy = 0)=>{
            const y = cy + oy;
            g.moveTo(cx, y - r * 1.35);
            g.bezierCurveTo(cx + r * 1.0, y - r * 0.3, cx + r * 0.9, y + r * 0.85, cx, y + r);
            g.bezierCurveTo(cx - r * 0.9, y + r * 0.85, cx - r * 1.0, y - r * 0.3, cx, y - r * 1.35);
        };
        // The cold socket, under everything.
        g.lineStyle(1.5, $8bf61ed7fd954e0e$var$CARD_RIM, 0.75);
        g.beginFill(0x120d0a, 0.9);
        flame($8bf61ed7fd954e0e$var$PIP_R);
        g.endFill();
        if (heat <= 0.01) return;
        // A flame low on heat sits down into its socket rather than hovering, and its glow goes
        // first -- the light leaves the ember before the ember does.
        const scale = 0.35 + 0.65 * heat;
        const drop = $8bf61ed7fd954e0e$var$PIP_R * 0.5 * (1 - heat);
        g.lineStyle(0);
        g.beginFill($8bf61ed7fd954e0e$var$EMBER_BODY, 0.18 * heat);
        flame($8bf61ed7fd954e0e$var$PIP_R * 1.45 * scale, drop);
        g.endFill();
        g.lineStyle(1.5, $8bf61ed7fd954e0e$var$EMBER_RIM, 0.95 * Math.min(1, heat * 1.4));
        g.beginFill($8bf61ed7fd954e0e$var$EMBER_BODY, 0.95);
        flame($8bf61ed7fd954e0e$var$PIP_R * scale, drop);
        g.endFill();
        g.lineStyle(0);
        g.beginFill($8bf61ed7fd954e0e$var$EMBER_CORE, 0.9 * heat);
        flame($8bf61ed7fd954e0e$var$PIP_R * 0.42 * scale, drop);
        g.endFill();
    }
    // Draw the ways on that runSummaryButtons decided there are (see run_summary_format: WHICH
    // buttons exist is the rule, and lives in the testable half). All this end does is size and
    // place them: the ordinary pair splits the panel's inner width, a lone one is wider and
    // centered rather than sitting in half a row with a gap beside it, and the minor one gets a row
    // of its own under the panel.
    buildButtons(parent) {
        const summary = this.summary;
        if (!summary) return;
        const buttons = (0, $0f597a38e51c14fa$export$457f4e9d8b9cc341)(summary, this.invasionCandidates);
        const major = buttons.filter((button)=>!button.minor);
        const solo = major.length === 1;
        buttons.forEach((button)=>{
            const i = major.indexOf(button);
            this.addButton(parent, {
                x: button.minor ? $8bf61ed7fd954e0e$var$PANEL_W / 2 - $8bf61ed7fd954e0e$var$MINOR_BUTTON_W / 2 : solo ? $8bf61ed7fd954e0e$var$PANEL_W / 2 - $8bf61ed7fd954e0e$var$SOLO_BUTTON_W / 2 : $8bf61ed7fd954e0e$var$PAD + i * ($8bf61ed7fd954e0e$var$BUTTON_W + $8bf61ed7fd954e0e$var$BUTTON_GAP),
                y: button.minor ? $8bf61ed7fd954e0e$var$MINOR_BUTTON_TOP : $8bf61ed7fd954e0e$var$BUTTON_TOP,
                width: button.minor ? $8bf61ed7fd954e0e$var$MINOR_BUTTON_W : solo ? $8bf61ed7fd954e0e$var$SOLO_BUTTON_W : $8bf61ed7fd954e0e$var$BUTTON_W,
                height: button.minor ? $8bf61ed7fd954e0e$var$MINOR_BUTTON_H : $8bf61ed7fd954e0e$var$BUTTON_H,
                label: button.label,
                sublabel: button.sublabel,
                primary: button.primary,
                minor: button.minor,
                enabled: button.enabled,
                onPress: ()=>button.action === "tryAgain" ? this.onTryAgain?.() : button.action === "restart" ? this.onRestart?.() : this.onInvade?.()
            });
        });
    }
    // Re-run the button rule and redraw the row if its answer has changed. Cheap and idempotent, so
    // it can be called from the feed, and it is: the invasion offer arrives every couple of seconds
    // while the panel is up, which is what makes the third button light up by itself when a camp
    // opens. Guarded on a signature so a tick that changes nothing does not rebuild the row (and
    // lose the hover) under a pointer already resting on it.
    syncButtons() {
        const summary = this.summary;
        const layer = this.buttonLayer;
        if (!summary || !layer) return;
        const key = (0, $0f597a38e51c14fa$export$457f4e9d8b9cc341)(summary, this.invasionCandidates).map((button)=>`${button.action}/${button.enabled}/${button.sublabel}`).join("|");
        if (key === this.buttonsKey) return;
        this.buttonsKey = key;
        // The handles point into the subtree being thrown away, so they go with it.
        this.buttons = [];
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(layer);
        layer.removeChildren().forEach((child)=>child.destroy({
                children: true
            }));
        this.buildButtons(layer);
    }
    addButton(parent, opts) {
        const width = opts.width === undefined ? $8bf61ed7fd954e0e$var$BUTTON_W : opts.width;
        const height = opts.height === undefined ? $8bf61ed7fd954e0e$var$BUTTON_H : opts.height;
        const minor = !!opts.minor;
        const enabled = opts.enabled !== false;
        const container = new (0, $8t5Gy.Container)();
        container.x = opts.x;
        container.y = opts.y;
        parent.addChild(container);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        const handle = {
            bg: bg,
            width: width,
            height: height,
            primary: opts.primary,
            minor: minor,
            // Starts the arrival flare. Without this the first draw sees a finished one.
            flareMs: 0,
            pulseMs: 0,
            enabled: enabled,
            hovered: false
        };
        this.buttons.push(handle);
        this.drawButton(handle);
        // A filled button needs dark text on it; an outlined one needs light. The minor row is
        // smaller on both lines, which is most of what makes it read as third.
        // Dark on anything FILLED -- the primary way on, and now the invade button, which is lit
        // rather than outlined. Pale text on an ember fill is the one combination that reads as
        // broken. (UNDEAD_RIM, the old cool outline colour, is what it used to be.)
        const labelColor = opts.primary || minor ? 0x2a1a0c : $8bf61ed7fd954e0e$var$TEXT_COLOR;
        const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(minor ? 11 : 14).color(labelColor).bold().align("center").render(opts.label);
        label.x = Math.round(width / 2 - label.width / 2);
        label.y = minor ? 4 : 8;
        label.alpha = enabled ? 1 : 0.45;
        container.addChild(label);
        const sub = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(minor ? 7 : 8).color(minor ? $8bf61ed7fd954e0e$var$TEXT_COLOR : labelColor).align("center").render(opts.sublabel);
        sub.x = Math.round(width / 2 - sub.width / 2);
        sub.y = minor ? 19 : 27;
        sub.alpha = enabled ? opts.primary ? 0.7 : 0.6 : 0.4;
        container.addChild(sub);
        // An inert button is drawn and readable but is NOT a control: no pointer, no hover, no
        // press. It is there to say why it cannot be used, and to light up when that changes.
        if (!enabled) return;
        container.interactive = true;
        container.cursor = "pointer";
        container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, width, height);
        container.on("pointerover", ()=>{
            handle.hovered = true;
            this.drawButton(handle);
        });
        container.on("pointerout", ()=>{
            handle.hovered = false;
            this.drawButton(handle);
        });
        container.on("pointerdown", (event)=>{
            event.stopPropagation();
            opts.onPress();
        });
    }
    drawButton(handle) {
        const g = handle.bg;
        if (!g) return;
        g.clear();
        // The minor row -- the way back into somebody else's night, and now the loudest thing on
        // this panel rather than the quietest.
        //
        // It started as a cool outline on dark glass, deliberately understated, on the reasoning
        // that the offer should be offered and not recommended. That was the wrong read once it was
        // played: by the time this button exists the player is sitting on a dead run looking at
        // numbers, and the one live thing on the screen has to say so.
        //
        // Three things carry it, and none of them is a pixi filter (see the GUI playbook -- a glow
        // is faked with concentric strokes, which also costs nothing):
        //
        //   1. An ARRIVAL FLARE. It is the only button that turns up mid-panel, so for the first
        //      moment it is oversized and white-hot, settling into its resting look. Movement on a
        //      still screen beats any colour.
        //   2. A BREATHING GLOW, so it keeps the eye after the flare is gone -- an ember, not a
        //      highlight, which is the one visual language this whole panel already speaks.
        //   3. A HOT FILL with dark text, like the primary button above it, rather than dark glass
        //      with pale text like everything else down here.
        if (handle.minor) {
            const flare = (0, $0f597a38e51c14fa$export$6b83639ebebd9af)(handle.flareMs ?? (0, $0f597a38e51c14fa$export$379f48b98209a8ad));
            const breath = 0.5 + 0.5 * Math.sin((handle.pulseMs ?? 0) / (0, $0f597a38e51c14fa$export$fa4a844e549b373e) * Math.PI * 2);
            // Hover tops the breath out rather than adding a separate state: the button is already
            // pulsing, so a hovered one simply stops dimming.
            const heat = handle.hovered ? 1 : 0.55 + 0.45 * breath;
            // The fake glow: three rings, widest first, the outermost one riding the flare out.
            const spread = 4 + 7 * heat + 16 * flare;
            for(let ring = 3; ring >= 1; ring--){
                const t = ring / 3;
                const pad = spread * t;
                g.beginFill(ring === 3 ? $8bf61ed7fd954e0e$var$EMBER_BODY : $8bf61ed7fd954e0e$var$EMBER_RIM, (0.1 + 0.22 * heat) * (1 - t * 0.55));
                g.drawRoundedRect(-pad, -pad, handle.width + pad * 2, handle.height + pad * 2, 9 + pad * 0.5);
                g.endFill();
            }
            g.lineStyle(2, flare > 0 ? $8bf61ed7fd954e0e$var$EMBER_CORE : $8bf61ed7fd954e0e$var$EMBER_RIM, 1);
            g.beginFill($8bf61ed7fd954e0e$var$EMBER_BODY, 0.82 + 0.18 * heat);
            g.drawRoundedRect(0, 0, handle.width, handle.height, 7);
            g.endFill();
            // The flare's own white core, laid over the fill and gone within the beat.
            if (flare > 0) {
                g.beginFill($8bf61ed7fd954e0e$var$EMBER_CORE, 0.75 * flare);
                g.drawRoundedRect(0, 0, handle.width, handle.height, 7);
                g.endFill();
            }
            return;
        }
        g.beginFill($8bf61ed7fd954e0e$var$RIM, handle.hovered ? 0.3 : 0.16);
        g.drawRoundedRect(-4, -4, handle.width + 8, handle.height + 8, 12);
        g.endFill();
        if (handle.primary) {
            g.lineStyle(2, handle.hovered ? 0xffe3ab : $8bf61ed7fd954e0e$var$RIM, 1);
            g.beginFill(handle.hovered ? 0xffc978 : $8bf61ed7fd954e0e$var$RIM, 1);
        } else {
            g.lineStyle(2, handle.hovered ? 0xffe3ab : $8bf61ed7fd954e0e$var$RIM, handle.hovered ? 1 : 0.8);
            g.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, handle.hovered ? 0.95 : 0.8);
        }
        g.drawRoundedRect(0, 0, handle.width, handle.height, 8);
        g.endFill();
    }
    // ===== public API ==================================================================
    isOpen() {
        return this.opened;
    }
    // The newest invasion offer off the feed (Protocol.type_updateInvasionOffer). Held whether or
    // not the panel is up, because the panel may go up a frame later and the third button has to be
    // on it immediately; `null` forgets the offer entirely, which takes the button away again.
    //
    // Note that an EMPTY array is not the same as null here. It is a real answer -- "no camp is
    // open to the dead" -- and it keeps an inert button on the panel saying so. See
    // runSummaryButtons.
    setInvasionOffer(candidates) {
        this.invasionCandidates = candidates || undefined;
        this.syncButtons();
    }
    // What the panel's buttons currently say, for a caller outside the display tree. The RULE is in
    // run_summary_format (and tested there); this is only the drawn answer.
    buttonSignature() {
        return this.buttonsKey;
    }
    // Rebuild the whole panel around a new scorecard. `player` is the local player entity, used for
    // the portrait and name; the panel still renders (without a portrait) if it's unavailable.
    // NOT named `render` -- that's pixi's own DisplayObject.render(renderer).
    setSummary(summary, player) {
        this.teardownContent();
        this.summary = summary;
        const content = new (0, $8t5Gy.Container)();
        this.content = content;
        this.panel.addChild(content);
        content.addChild(this.drawPanelChrome());
        this.addText(content, "YOU HAVE FALLEN", {
            size: 18,
            color: $8bf61ed7fd954e0e$var$RIM,
            bold: true,
            x: $8bf61ed7fd954e0e$var$PANEL_W / 2,
            y: 12,
            center: true
        });
        this.addText(content, summary.wavesReached > 0 ? `You held the ember through wave ${summary.wavesReached}.` : "The ember went dark before the first wave.", {
            size: 9,
            alpha: 0.6,
            x: $8bf61ed7fd954e0e$var$PANEL_W / 2,
            y: 33,
            center: true
        });
        // With the lives spent the camp is finished with this player, and the portrait card says
        // so: its fire is out (see buildPortrait).
        this.buildPortrait(content, player, !(0, $0f597a38e51c14fa$export$ff38440d3f9f6c69)(summary).canTryAgain);
        this.buildHeroStats(content, summary);
        this.buildCampTiles(content, summary);
        this.buildKillChips(content, summary);
        this.buildLives(content, summary);
        // The ways on go in a layer of their own, because they are the one part of this panel that
        // is rebuilt while it is up (see syncButtons).
        this.buttonLayer = new (0, $8t5Gy.Container)();
        content.addChild(this.buttonLayer);
        this.buttonsKey = undefined;
        this.syncButtons();
        // ...and put the flourish in front of all of it. The panel is not merely transparent
        // while the number is up, it is HIDDEN: an invisible button is still a pressable one, and
        // a player mashing attack as they die must not be able to restart a run they haven't been
        // shown yet.
        this.startReveal(summary);
    }
    // ===== the opening flourish ========================================================
    // Arm the wave reveal and put the panel in its pre-entrance state. Everything after this is
    // driven from animate(), off waveRevealFrame's clock.
    startReveal(summary) {
        this.revealMs = 0;
        this.revealing = true;
        this.reveal.setSummary(summary);
        this.panel.visible = false;
        this.panel.alpha = 0;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP;
    }
    // Advance it a frame, hand the panel its share of the movement, and take the whole thing down
    // once the beat is over. From here on the panel is simply the panel.
    advanceReveal(dtMs) {
        // Clamped, because this beat is measured in tenths of a second and one stalled frame (a
        // tab coming back, a texture upload) can be longer than the whole of it -- which would
        // land the player on the panel having never seen the number.
        const step = Math.max(0, Math.min(dtMs, $8bf61ed7fd954e0e$var$REVEAL_MAX_STEP_MS));
        this.revealMs += step;
        const frame = (0, $0f597a38e51c14fa$export$1d9e6deb9235c1ae)(this.revealMs);
        this.reveal.applyFrame(frame, step);
        this.panel.visible = frame.panelAlpha > 0;
        this.panel.alpha = frame.panelAlpha;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP + frame.panelRise;
        if (frame.done) this.endReveal();
    }
    // Leave the panel exactly as it would have been had there been no flourish at all. Called both
    // when the beat finishes and when the panel is torn down mid-beat.
    endReveal() {
        this.revealing = false;
        this.revealMs = 0;
        this.reveal.teardown();
        this.panel.visible = true;
        this.panel.alpha = 1;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP;
    }
    teardownContent() {
        if (this.revealing) this.endReveal();
        this.masked.forEach((node)=>{
            node.mask = null;
        });
        this.masked = [];
        this.flame = undefined;
        if (this.content) {
            this.panel.removeChild(this.content);
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this.content);
            this.content.destroy({
                children: true
            });
        }
        this.buttons = [];
        this.buttonLayer = undefined;
        this.buttonsKey = undefined;
        this.summary = undefined;
        // NOT the invasion candidates: the feed is about the SERVER's state, not this panel's, and
        // a panel that forgot the newest list on teardown would come back up with no third button
        // until the next tick -- up to two seconds of the offer being missing at the exact moment
        // it is meant to be read.
        this.embers = undefined;
        this.livesLayout = undefined;
        this.sparks = [];
    }
    // Called each frame by GuiManager: the opening flourish, the portrait's campfire particles, and
    // the life this death took guttering out. Note the flame is optional (no portrait without a
    // player entity) while the lives are not, so neither may gate the other.
    animate(dtMs) {
        if (!this.visible) return;
        if (this.revealing) this.advanceReveal(dtMs);
        this.flame?.update(dtMs, 0.85);
        this.advanceLivesBurn(dtMs);
        this.advanceInvadeHeat(dtMs);
    }
    // The invade button breathes, and flares once when it appears. Redrawn every frame it is on
    // screen, which is one Graphics with a handful of rounded rects -- the panel is already
    // redrawing the lives embers at this rate.
    advanceInvadeHeat(dtMs) {
        this.buttons.forEach((handle)=>{
            if (!handle.minor) return;
            handle.pulseMs = ((handle.pulseMs ?? 0) + dtMs) % (0, $0f597a38e51c14fa$export$fa4a844e549b373e);
            if ((handle.flareMs ?? (0, $0f597a38e51c14fa$export$379f48b98209a8ad)) < (0, $0f597a38e51c14fa$export$379f48b98209a8ad)) handle.flareMs = Math.min((0, $0f597a38e51c14fa$export$379f48b98209a8ad), (handle.flareMs ?? 0) + dtMs);
            this.drawButton(handle);
        });
    }
    // The just-spent ember: it holds, flickering, long enough to be noticed, then collapses into
    // its socket and throws off a few sparks on the way out. Runs once per opening of the panel.
    advanceLivesBurn(dtMs) {
        const layout = this.livesLayout;
        if (!layout || layout.spent <= 0 || !this.embers) return;
        // Not while the wave reveal is still up. The whole point of this animation is that the
        // player SEES the life go out, and the panel it is drawn on is hidden until the flourish
        // hands over -- left running, the ember would be ash by the time anyone looked at it.
        if (this.revealing && this.panel.alpha <= 0) return;
        const finished = this.livesBurnMs >= $8bf61ed7fd954e0e$var$LIVES_BURN_MS;
        if (finished && this.sparks.length === 0) return;
        const before = this.livesBurnMs;
        this.livesBurnMs = Math.min($8bf61ed7fd954e0e$var$LIVES_BURN_MS, this.livesBurnMs + dtMs);
        // Sparks are thrown at the moment it starts to go out, not while it is still burning.
        const startMs = $8bf61ed7fd954e0e$var$LIVES_BURN_MS * $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD;
        if (before < startMs && this.livesBurnMs >= startMs) {
            const cx = layout.firstCx + (layout.total - layout.spent) * layout.step;
            for(let i = 0; i < 6; i++)this.sparks.push({
                x: cx + (Math.random() - 0.5) * $8bf61ed7fd954e0e$var$PIP_R * 1.2,
                y: layout.cy - $8bf61ed7fd954e0e$var$PIP_R * 0.4,
                vx: (Math.random() - 0.5) * 0.012,
                vy: -(0.02 + Math.random() * 0.02),
                age: 0,
                life: 420 + Math.random() * 320
            });
        }
        this.sparks = this.sparks.filter((spark)=>{
            spark.age += dtMs;
            spark.x += spark.vx * dtMs;
            spark.y += spark.vy * dtMs;
            return spark.age < spark.life;
        });
        this.drawLivesRow();
    }
    fadeIn() {
        this.opened = true;
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $8bf61ed7fd954e0e$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $8bf61ed7fd954e0e$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    fadeOut() {
        this.opened = false;
        // Drop every hover highlight: the pointer is nowhere near these buttons the next time the
        // panel opens, and a button that came up already lit would read as pre-selected.
        this.buttons.forEach((button)=>{
            button.hovered = false;
        });
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $8bf61ed7fd954e0e$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $8bf61ed7fd954e0e$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
                // The run is over and the panel is gone — free the paperdoll/text textures rather
                // than hold a whole scorecard's worth until the next death.
                this.teardownContent();
            }
        });
        this.fadeOutFader.update();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");


const $daf4f1c650b6c0f9$export$e483a3dc05447c30 = "A stranger";
const $daf4f1c650b6c0f9$export$6881c612b1e8acd5 = 14;
const $daf4f1c650b6c0f9$export$b2a71ccdb46cebdd = (candidate)=>{
    const name = candidate?.name?.trim();
    if (!name) return $daf4f1c650b6c0f9$export$e483a3dc05447c30;
    return name.length > $daf4f1c650b6c0f9$export$6881c612b1e8acd5 ? name.slice(0, $daf4f1c650b6c0f9$export$6881c612b1e8acd5 - 1) + "\u2026" : name;
};
const $daf4f1c650b6c0f9$export$72b7e65d3fa926ba = (candidate)=>{
    const wave = Math.max(0, Math.floor(candidate?.wave || 0));
    return wave > 0 ? `WAVE ${wave}` : "NO WAVE YET";
};
const $daf4f1c650b6c0f9$export$5064431e273f99c6 = (candidate, ageMs = 0)=>{
    const seconds = candidate?.secondsToWave;
    if (typeof seconds !== "number" || !Number.isFinite(seconds)) return undefined;
    return Math.max(0, Math.ceil(Math.max(0, seconds) - Math.max(0, ageMs) / 1000));
};
const $daf4f1c650b6c0f9$export$55099e7ccfabe53e = (candidate, ageMs = 0)=>{
    if (candidate?.waveActive) return "fighting now";
    const left = $daf4f1c650b6c0f9$export$5064431e273f99c6(candidate, ageMs);
    if (left === undefined) return "quiet for now";
    return left > 0 ? `in ${left}s` : "landing now";
};
// ===== geometry =======================================================================
// The stage stretches everything vertically by 1.3, so these are stage units with that already
// accounted for -- the same frame run_summary.ts works in, because this opens on top of it.
const $daf4f1c650b6c0f9$var$SCREEN_W = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
const $daf4f1c650b6c0f9$var$CENTER_X = $daf4f1c650b6c0f9$var$SCREEN_W / 2;
const $daf4f1c650b6c0f9$var$CENTER_Y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2 + 52;
const $daf4f1c650b6c0f9$export$4f5c9faaebb411d3 = 3;
const $daf4f1c650b6c0f9$var$PAD = 16;
const $daf4f1c650b6c0f9$var$TITLE_H = 42;
const $daf4f1c650b6c0f9$export$bed693db0561df20 = 118;
const $daf4f1c650b6c0f9$var$CARD_H = 104;
const $daf4f1c650b6c0f9$export$c73e9b0a14b3993b = 10;
const $daf4f1c650b6c0f9$var$FOOTER_H = 28;
const $daf4f1c650b6c0f9$var$FOOTER_GAP = 12;
const $daf4f1c650b6c0f9$var$PANEL_W = $daf4f1c650b6c0f9$var$PAD * 2 + $daf4f1c650b6c0f9$export$4f5c9faaebb411d3 * $daf4f1c650b6c0f9$export$bed693db0561df20 + ($daf4f1c650b6c0f9$export$4f5c9faaebb411d3 - 1) * $daf4f1c650b6c0f9$export$c73e9b0a14b3993b;
const $daf4f1c650b6c0f9$var$PANEL_H = $daf4f1c650b6c0f9$var$TITLE_H + $daf4f1c650b6c0f9$var$CARD_H + $daf4f1c650b6c0f9$var$FOOTER_GAP + $daf4f1c650b6c0f9$var$FOOTER_H + $daf4f1c650b6c0f9$var$PAD;
const $daf4f1c650b6c0f9$var$PANEL_LEFT = $daf4f1c650b6c0f9$var$CENTER_X - $daf4f1c650b6c0f9$var$PANEL_W / 2;
const $daf4f1c650b6c0f9$var$PANEL_TOP = $daf4f1c650b6c0f9$var$CENTER_Y - $daf4f1c650b6c0f9$var$PANEL_H / 2;
const $daf4f1c650b6c0f9$var$CARD_TOP = $daf4f1c650b6c0f9$var$PANEL_TOP + $daf4f1c650b6c0f9$var$TITLE_H;
const $daf4f1c650b6c0f9$var$FOOTER_TOP = $daf4f1c650b6c0f9$var$CARD_TOP + $daf4f1c650b6c0f9$var$CARD_H + $daf4f1c650b6c0f9$var$FOOTER_GAP;
const $daf4f1c650b6c0f9$var$FOOTER_W = 150;
// Palette, shared with run_summary.ts / role_picker.ts.
const $daf4f1c650b6c0f9$var$RIM = 0xf2a94e;
const $daf4f1c650b6c0f9$var$PANEL_FILL = 0x1b1512;
const $daf4f1c650b6c0f9$var$PANEL_ALPHA = 0.97;
const $daf4f1c650b6c0f9$var$CARD_FILL = 0x241b16;
const $daf4f1c650b6c0f9$var$CARD_HOVER_FILL = 0x33271e;
const $daf4f1c650b6c0f9$var$CARD_RIM = 0x6b4f38;
const $daf4f1c650b6c0f9$var$TEXT_COLOR = 0xfff3e0;
const $daf4f1c650b6c0f9$var$SCRIM_COLOR = 0x06060a;
const $daf4f1c650b6c0f9$var$MUTED = 0x8d97ad;
// The undead's own colour, used only for the thing the player is about to become: a cold rim on a
// live card and on "Let go". Everything else on the panel is warm, so one cool accent is enough to
// say this way out is not the camp's.
const $daf4f1c650b6c0f9$var$UNDEAD = 0x9fd2ff;
// A camp already fighting is the louder choice, not the disqualified one.
const $daf4f1c650b6c0f9$var$FIGHTING = 0xff8a5c;
// Fade timing -- mirrors the role picker / scorecard (~100ms each way), done by hand here because
// this widget is shown and hidden by the GUI manager rather than by a Fader of its own.
const $daf4f1c650b6c0f9$var$FADE_STEP = 0.14;
class $daf4f1c650b6c0f9$export$9306c99f3e124fbc extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.slots = [], this.cardRow = new (0, $8t5Gy.Container)(), this.footer = new (0, $gwPoJ.Graphics)(), // The newest list the feed gave us, and how long ago it arrived. The age is what drains the
        // countdowns; see candidateTimingLabel.
        this.candidates = [], this.ageMs = 0, // The timing strings last drawn, so the per-frame drain only touches a Text when its second
        // actually ticks over.
        this.drawnTiming = [], this.layoutPending = false, this.opened = false, // ===== public API =================================================================
        this.isOpen = ()=>this.opened, // Open on what the client already holds. Deliberately takes the list rather than fetching one:
        // the press must not wait for a server round trip (see the note at the top of this file).
        //
        // The slots are wiped FIRST. Clearing them on close instead would be wrong in the other
        // direction: a slot left holding a camp that has since dropped out would come back up as a gap
        // in a row, sized for a camp the player never saw.
        this.open = (candidates)=>{
            this.slots.forEach((slot)=>{
                slot.entityId = undefined;
                slot.vacated = false;
                slot.hovered = false;
            });
            // Nothing is hovered on a picker that is not up yet, so there is nothing to defer to -- and
            // the last visit's positions must not be inherited.
            this.laidOut = undefined;
            this.layoutPending = false;
            this.setCandidates(candidates);
            this.layoutCards(true);
            if (!this.visible) this.alpha = 0;
            this.opened = true;
            this.visible = true;
        }, // Dismiss. The content is deliberately left standing so the fade-out shows what the player was
        // looking at rather than collapsing to the empty state on its way off the screen.
        this.close = ()=>{
            this.opened = false;
            this.slots.forEach((slot)=>{
                if (slot.hovered) {
                    slot.hovered = false;
                    this.drawSlot(slot);
                }
            });
        }, // A fresh list off the feed. No-op on the display tree while closed, but the candidates are
        // still remembered: the scorecard's button reads them, and the picker may be opened from them
        // on the very next press.
        this.setCandidates = (candidates)=>{
            this.candidates = candidates || [];
            this.ageMs = 0;
            this.seatCandidates();
            this.fill();
        }, // Which camps the picker currently has to offer -- what a card press can mean, for a caller
        // outside the display tree (and for a test).
        this.liveEntityIds = ()=>this.slots.filter((slot)=>!!slot.entityId && !slot.vacated).map((slot)=>slot.entityId), // Whether the panel is showing the "no camp is open" state rather than any cards.
        this.isEmptyState = ()=>this.liveEntityIds().length < 1, // What one slot currently says, top line to bottom. The readable summary of a slot for a caller
        // outside the display tree.
        this.slotText = (index)=>{
            const slot = this.slots[index];
            return slot ? [
                slot.name.text,
                slot.wave.text,
                slot.timing.text
            ] : [];
        }, // Pick a camp. This IS the card's handler, and it is public because the cards are buried in the
        // display tree -- anything holding a defending player's id holds the control.
        this.pick = (entityId)=>{
            // The `opened` guard is for the fade-out: the panel is still drawn (and still catching
            // presses) for ~100ms after it has been dismissed, and a camp invaded on the way out would
            // be a camp nobody chose.
            if (!this.opened) return;
            const slot = this.slots.find((s)=>s.entityId === entityId && !s.vacated);
            if (!slot) return;
            this.onJoin?.(entityId);
        }, // Drain the countdowns, and the fade. Called every frame by the GUI manager; cheap while shut.
        this.animate = (dtMs)=>{
            if (!this.visible) return;
            const target = this.opened ? 1 : 0;
            if (this.alpha !== target) {
                this.alpha = target > this.alpha ? Math.min(1, this.alpha + $daf4f1c650b6c0f9$var$FADE_STEP) : Math.max(0, this.alpha - $daf4f1c650b6c0f9$var$FADE_STEP);
                if (this.alpha <= 0) {
                    this.visible = false;
                    return;
                }
            }
            if (!this.opened) return;
            this.ageMs += dtMs;
            this.refreshTiming();
        }, // ===== internals ==================================================================
        // Seat the newest list in the fixed slots: a camp keeps the slot it already had, a camp that has
        // dropped out leaves its slot standing (dead), and only a slot that never held anything takes a
        // newcomer. That is the whole anti-slide rule -- see the file header.
        this.seatCandidates = ()=>{
            const byId = new Map();
            this.candidates.slice(0, $daf4f1c650b6c0f9$export$4f5c9faaebb411d3).forEach((candidate)=>{
                if (candidate?.entityId) byId.set(candidate.entityId, candidate);
            });
            this.slots.forEach((slot)=>{
                if (!slot.entityId) return;
                if (byId.has(slot.entityId)) {
                    byId.delete(slot.entityId);
                    slot.vacated = false;
                    return;
                }
                // Gone. Keep the slot, mark it, and never hand it to anybody else.
                slot.vacated = true;
            });
            Array.from(byId.keys()).forEach((entityId)=>{
                const free = this.slots.find((slot)=>!slot.entityId);
                if (!free) return;
                free.entityId = entityId;
                free.vacated = false;
            });
        }, this.candidateFor = (entityId)=>entityId ? this.candidates.find((candidate)=>candidate?.entityId === entityId) : undefined, // Write every slot's labels and redraw it. Called on each feed tick (and on open), not per
        // frame -- the per-frame path is refreshTiming, which touches one line.
        this.fill = ()=>{
            const empty = this.isEmptyState();
            this.cardRow.visible = !empty;
            this.emptyLine.visible = empty;
            this.emptySub.visible = empty;
            this.title.text = empty ? "THE DEAD WAIT" : "THE DEAD WALK";
            this.subtitle.text = empty ? "Nothing is open to you yet." : "Choose a fire to rise at. You will wake as one of its attackers.";
            this.footerLabel.text = empty ? "BACK" : "NOT YET";
            this.center(this.title);
            this.center(this.subtitle);
            this.center(this.emptyLine);
            this.center(this.emptySub);
            this.footerLabel.x = Math.round($daf4f1c650b6c0f9$var$CENTER_X - this.footerLabel.width / 2);
            this.slots.forEach((slot, index)=>{
                const candidate = this.candidateFor(slot.entityId);
                const live = !!candidate && !slot.vacated;
                slot.container.interactive = live;
                slot.container.cursor = live ? "pointer" : "default";
                if (live) {
                    slot.name.text = $daf4f1c650b6c0f9$export$b2a71ccdb46cebdd(candidate);
                    slot.wave.text = $daf4f1c650b6c0f9$export$72b7e65d3fa926ba(candidate);
                    slot.timing.text = $daf4f1c650b6c0f9$export$55099e7ccfabe53e(candidate, this.ageMs);
                    slot.timing.tint = candidate.waveActive ? $daf4f1c650b6c0f9$var$FIGHTING : $daf4f1c650b6c0f9$var$UNDEAD;
                } else {
                    slot.name.text = "";
                    slot.wave.text = "";
                    slot.timing.text = "";
                }
                this.drawnTiming[index] = slot.timing.text;
                this.centerIn(slot.name, $daf4f1c650b6c0f9$export$bed693db0561df20);
                this.centerIn(slot.wave, $daf4f1c650b6c0f9$export$bed693db0561df20);
                this.centerIn(slot.timing, $daf4f1c650b6c0f9$export$bed693db0561df20);
                this.drawSlot(slot);
            });
            this.layoutCards();
        }, /** The slots currently showing a camp, in slot order. */ this.liveSlots = ()=>this.slots.filter((slot)=>!!this.candidateFor(slot.entityId) && !slot.vacated), /**
     * Place the live cards CENTRED, and draw nothing where a camp has dropped out.
     *
     * The slots themselves stay fixed and ordered -- a camp keeps the slot it was first given, and a
     * slot it has vacated is never handed to anybody else -- so what moves here is only where a card
     * is DRAWN, never which camp a given card means. That is what keeps "the press means the camp
     * the player was looking at" true while still closing the gaps up.
     *
     * Deferred while the pointer is over the row, because the press resolves on pointerDOWN: the
     * hazard is not a card moving mid-click, it is a card moving while the player is reaching for
     * it, which would land their press on a stranger they never chose. The pending layout is taken
     * the moment they move off.
     */ this.layoutCards = (force = false)=>{
            const live = this.liveSlots();
            const signature = live.map((slot)=>slot.entityId).join("|");
            if (signature === this.laidOut) {
                this.layoutPending = false;
                return;
            }
            if (!force && this.slots.some((slot)=>slot.hovered)) {
                this.layoutPending = true;
                return;
            }
            const width = live.length * $daf4f1c650b6c0f9$export$bed693db0561df20 + Math.max(0, live.length - 1) * $daf4f1c650b6c0f9$export$c73e9b0a14b3993b;
            let x = Math.round($daf4f1c650b6c0f9$var$CENTER_X - width / 2);
            this.slots.forEach((slot)=>{
                slot.container.visible = false;
            });
            live.forEach((slot)=>{
                slot.container.visible = true;
                slot.container.x = x;
                x += $daf4f1c650b6c0f9$export$bed693db0561df20 + $daf4f1c650b6c0f9$export$c73e9b0a14b3993b;
            });
            this.laidOut = signature;
            this.layoutPending = false;
        }, /** Where the live cards sit, for a caller outside the display tree. */ this.cardPositions = ()=>this.liveSlots().map((slot)=>slot.container.x), /** Hovering a card, and the one thing it owes the layout on the way out. */ this.hover = (handle, hovered)=>{
            handle.hovered = hovered;
            this.drawSlot(handle);
            // Whatever the feed said while they were reading it.
            if (!hovered && this.layoutPending && !this.slots.some((slot)=>slot.hovered)) this.layoutCards();
        }, /** Drive the hover from a test: pixi's own pointer events are not available under jsdom. */ this.setHovered = (index, hovered)=>{
            const slot = this.slots[index];
            if (slot) this.hover(slot, hovered);
        }, // The per-frame half of the drain: only the timing line can change between feed ticks, and only
        // when its whole second ticks over, so this is a string compare per card and nothing else.
        this.refreshTiming = ()=>{
            this.slots.forEach((slot, index)=>{
                const candidate = this.candidateFor(slot.entityId);
                if (!candidate || slot.vacated) return;
                const next = $daf4f1c650b6c0f9$export$55099e7ccfabe53e(candidate, this.ageMs);
                if (next === this.drawnTiming[index]) return;
                this.drawnTiming[index] = next;
                slot.timing.text = next;
                this.centerIn(slot.timing, $daf4f1c650b6c0f9$export$bed693db0561df20);
            });
        }, this.buildSlot = (index)=>{
            const container = new (0, $8t5Gy.Container)();
            container.x = $daf4f1c650b6c0f9$var$PANEL_LEFT + $daf4f1c650b6c0f9$var$PAD + index * ($daf4f1c650b6c0f9$export$bed693db0561df20 + $daf4f1c650b6c0f9$export$c73e9b0a14b3993b);
            container.y = $daf4f1c650b6c0f9$var$CARD_TOP;
            container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $daf4f1c650b6c0f9$export$bed693db0561df20, $daf4f1c650b6c0f9$var$CARD_H);
            const bg = new (0, $gwPoJ.Graphics)();
            container.addChild(bg);
            // A skull rather than a portrait: the client has no appearance for a player in another
            // room, and a card promising a face it cannot draw is worse than one that doesn't.
            const sigil = this.text("\uD83D\uDC80", {
                size: 24
            });
            sigil.y = 12;
            this.centerIn(sigil, $daf4f1c650b6c0f9$export$bed693db0561df20);
            container.addChild(sigil);
            const name = this.text("", {
                size: 12,
                color: $daf4f1c650b6c0f9$var$TEXT_COLOR,
                bold: true
            });
            name.y = 46;
            const wave = this.text("", {
                size: 9,
                color: $daf4f1c650b6c0f9$var$RIM
            });
            wave.y = 66;
            const timing = this.text("", {
                size: 10,
                color: $daf4f1c650b6c0f9$var$UNDEAD
            });
            timing.y = 80;
            container.addChild(name, wave, timing);
            const handle = {
                container: container,
                bg: bg,
                name: name,
                wave: wave,
                timing: timing,
                vacated: false,
                hovered: false
            };
            container.on("pointerover", ()=>this.hover(handle, true));
            container.on("pointerout", ()=>this.hover(handle, false));
            container.on("pointerdown", (event)=>{
                event.stopPropagation();
                // Read the id off the slot at press time: the feed may have changed what this card is
                // showing since it was drawn, and the press has to mean whatever it says NOW.
                if (handle.entityId && !handle.vacated) this.pick(handle.entityId);
            });
            this.cardRow.addChild(container);
            return handle;
        }, this.drawSlot = (slot)=>{
            const candidate = this.candidateFor(slot.entityId);
            const live = !!candidate && !slot.vacated;
            const accent = candidate?.waveActive ? $daf4f1c650b6c0f9$var$FIGHTING : $daf4f1c650b6c0f9$var$UNDEAD;
            const g = slot.bg;
            g.clear();
            if (!live) {
                // An empty or spent slot is a frame, not a button: no glow, no fill to speak of.
                g.lineStyle(1, $daf4f1c650b6c0f9$var$CARD_RIM, slot.vacated ? 0.5 : 0.25);
                g.beginFill($daf4f1c650b6c0f9$var$CARD_FILL, slot.vacated ? 0.5 : 0.25);
                g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$export$bed693db0561df20, $daf4f1c650b6c0f9$var$CARD_H, 8);
                g.endFill();
                slot.name.alpha = 0.5;
                slot.wave.alpha = 0.45;
                slot.timing.alpha = 0.45;
                return;
            }
            slot.name.alpha = 1;
            slot.wave.alpha = 0.85;
            slot.timing.alpha = 0.95;
            if (slot.hovered) {
                // Fake glow: a fatter low-alpha copy behind the card. Cheaper than a blur filter, which
                // is the rule across this UI because filters cost real money on a weak GPU.
                g.beginFill(accent, 0.18);
                g.drawRoundedRect(-3, -3, $daf4f1c650b6c0f9$export$bed693db0561df20 + 6, $daf4f1c650b6c0f9$var$CARD_H + 6, 11);
                g.endFill();
                g.lineStyle(2, accent, 1);
                g.beginFill($daf4f1c650b6c0f9$var$CARD_HOVER_FILL, 0.97);
            } else {
                g.lineStyle(1.5, $daf4f1c650b6c0f9$var$CARD_RIM, 0.75);
                g.beginFill($daf4f1c650b6c0f9$var$CARD_FILL, 0.9);
            }
            g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$export$bed693db0561df20, $daf4f1c650b6c0f9$var$CARD_H, 8);
            g.endFill();
        }, this.drawPlate = ()=>{
            const g = this.plate;
            g.clear();
            g.beginFill($daf4f1c650b6c0f9$var$RIM, 0.06);
            g.drawRoundedRect($daf4f1c650b6c0f9$var$PANEL_LEFT - 6, $daf4f1c650b6c0f9$var$PANEL_TOP - 6, $daf4f1c650b6c0f9$var$PANEL_W + 12, $daf4f1c650b6c0f9$var$PANEL_H + 12, 16);
            g.endFill();
            g.lineStyle(2, $daf4f1c650b6c0f9$var$RIM, 0.9);
            g.beginFill($daf4f1c650b6c0f9$var$PANEL_FILL, $daf4f1c650b6c0f9$var$PANEL_ALPHA);
            g.drawRoundedRect($daf4f1c650b6c0f9$var$PANEL_LEFT, $daf4f1c650b6c0f9$var$PANEL_TOP, $daf4f1c650b6c0f9$var$PANEL_W, $daf4f1c650b6c0f9$var$PANEL_H, 12);
            g.endFill();
        }, this.drawFooter = (hovered)=>{
            const g = this.footer;
            g.clear();
            g.lineStyle(1.5, hovered ? $daf4f1c650b6c0f9$var$RIM : $daf4f1c650b6c0f9$var$CARD_RIM, hovered ? 1 : 0.7);
            g.beginFill($daf4f1c650b6c0f9$var$CARD_FILL, hovered ? 0.95 : 0.8);
            g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$var$FOOTER_W, $daf4f1c650b6c0f9$var$FOOTER_H, 7);
            g.endFill();
        }, this.text = (value, opts)=>{
            let renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(opts.size).align("center");
            if (opts.color !== undefined) renderer = renderer.color(opts.color);
            if (opts.bold) renderer = renderer.bold();
            const text = renderer.render(value);
            if (opts.alpha !== undefined) text.alpha = opts.alpha;
            if (opts.center) this.center(text);
            return text;
        }, // Centre on the panel's own axis. Both of these are no-ops under a mocked canvas (every Text
        // measures as zero wide there), which is why no test asserts on a position.
        this.center = (text)=>{
            text.x = Math.round($daf4f1c650b6c0f9$var$CENTER_X - text.width / 2);
        }, this.centerIn = (text, width)=>{
            text.x = Math.round(width / 2 - text.width / 2);
        };
        this.onJoin = props.onJoin;
        this.onCancel = props.onCancel;
        // The scrim swallows every press that isn't on a card, and a press on it is an answer:
        // clicking off this panel means "not now". It has to swallow them even when it isn't
        // answering, or a stray click fires the player's bow into the camp behind the scorecard.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill($daf4f1c650b6c0f9$var$SCRIM_COLOR, 0.55);
        this.scrim.drawRect(-400, -400, $daf4f1c650b6c0f9$var$SCREEN_W + 800, 1400);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(-400, -400, $daf4f1c650b6c0f9$var$SCREEN_W + 800, 1400);
        this.scrim.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onCancel?.();
        });
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.scrim.on("rightclick", (event)=>event.stopPropagation());
        this.addChild(this.scrim);
        this.panel = new (0, $8t5Gy.Container)();
        // Presses inside the panel never reach the scrim, so the panel's own gaps are not a way to
        // dismiss it by accident.
        this.panel.interactive = true;
        this.panel.hitArea = new (0, $6qzqq.Rectangle)($daf4f1c650b6c0f9$var$PANEL_LEFT, $daf4f1c650b6c0f9$var$PANEL_TOP, $daf4f1c650b6c0f9$var$PANEL_W, $daf4f1c650b6c0f9$var$PANEL_H);
        this.panel.on("pointerdown", (event)=>event.stopPropagation());
        this.panel.on("pointermove", (event)=>event.stopPropagation());
        this.addChild(this.panel);
        this.panel.addChild(this.plate);
        this.drawPlate();
        this.title = this.text("THE DEAD WALK", {
            size: 17,
            color: $daf4f1c650b6c0f9$var$RIM,
            bold: true,
            center: true
        });
        this.title.y = $daf4f1c650b6c0f9$var$PANEL_TOP + 10;
        this.subtitle = this.text("Choose a fire to rise at. You will wake as one of its attackers.", {
            size: 9,
            alpha: 0.6,
            center: true
        });
        this.subtitle.y = $daf4f1c650b6c0f9$var$PANEL_TOP + 29;
        this.panel.addChild(this.title, this.subtitle);
        this.cardRow.y = 0;
        this.panel.addChild(this.cardRow);
        for(let i = 0; i < $daf4f1c650b6c0f9$export$4f5c9faaebb411d3; i++)this.slots.push(this.buildSlot(i));
        // Centred on the card row's own band, so the two states occupy the same space and the panel
        // does not appear to resize when the last camp drops out.
        this.emptyLine = this.text("No camp is open to the dead right now.", {
            size: 11,
            color: $daf4f1c650b6c0f9$var$MUTED,
            center: true
        });
        this.emptyLine.y = $daf4f1c650b6c0f9$var$CARD_TOP + $daf4f1c650b6c0f9$var$CARD_H / 2 - 16;
        this.emptySub = this.text("The living are keeping their fires closed. Try again in a moment.", {
            size: 9,
            alpha: 0.5,
            center: true
        });
        this.emptySub.y = $daf4f1c650b6c0f9$var$CARD_TOP + $daf4f1c650b6c0f9$var$CARD_H / 2 + 2;
        this.panel.addChild(this.emptyLine, this.emptySub);
        this.footerLabel = this.text("NOT YET", {
            size: 11,
            color: $daf4f1c650b6c0f9$var$TEXT_COLOR,
            bold: true,
            center: true
        });
        this.footer.x = $daf4f1c650b6c0f9$var$CENTER_X - $daf4f1c650b6c0f9$var$FOOTER_W / 2;
        this.footer.y = $daf4f1c650b6c0f9$var$FOOTER_TOP;
        this.footerLabel.y = $daf4f1c650b6c0f9$var$FOOTER_TOP + 8;
        this.footer.interactive = true;
        this.footer.cursor = "pointer";
        this.footer.hitArea = new (0, $6qzqq.Rectangle)(-4, -4, $daf4f1c650b6c0f9$var$FOOTER_W + 8, $daf4f1c650b6c0f9$var$FOOTER_H + 8);
        this.footer.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onCancel?.();
        });
        this.footer.on("pointerover", ()=>this.drawFooter(true));
        this.footer.on("pointerout", ()=>this.drawFooter(false));
        this.panel.addChild(this.footer, this.footerLabel);
        this.drawFooter(false);
        this.fill();
        this.visible = false;
    }
}
// ===== "Let go" =======================================================================
// LEAVING: the one exit the invader presses themself. The other four fire on their own (you die,
// you kill the Lord, the wave is cleared, the defender leaves), and all five land in the same
// place: a fresh camp of the player's own.
//
// It exists ONLY while Message.invading is true, which is why this is a button and not a menu item:
// a player wearing somebody else's attacker, in a room that is not theirs, needs exactly one
// visible way home and needs to find it without opening anything.
//
// Cool-rimmed where the camp HUD is warm, because it belongs to the invasion rather than to the
// camp being invaded.
const $daf4f1c650b6c0f9$var$LETGO_W = 104;
const $daf4f1c650b6c0f9$var$LETGO_H = 26;
class $daf4f1c650b6c0f9$export$59009c2c2d99348c extends (0, $8t5Gy.Container) {
    constructor({ onPress: onPress }){
        super(), this.bg = new (0, $gwPoJ.Graphics)(), this.hovered = false, this.getWidth = ()=>$daf4f1c650b6c0f9$var$LETGO_W, this.getHeight = ()=>$daf4f1c650b6c0f9$var$LETGO_H, // Follows the server's verdict on every message (Message.invading), exactly as the downed flag
        // does -- never a local guess, so the button cannot outlive the body it lets go of.
        this.setInvading = (invading)=>{
            if (this.visible === invading) return;
            this.visible = invading;
            this.hovered = false;
            this.draw();
        }, this.draw = ()=>{
            const g = this.bg;
            g.clear();
            g.beginFill($daf4f1c650b6c0f9$var$UNDEAD, this.hovered ? 0.2 : 0.1);
            g.drawRoundedRect(-3, -3, $daf4f1c650b6c0f9$var$LETGO_W + 6, $daf4f1c650b6c0f9$var$LETGO_H + 6, 9);
            g.endFill();
            g.lineStyle(1.5, $daf4f1c650b6c0f9$var$UNDEAD, this.hovered ? 1 : 0.75);
            g.beginFill(0x0a1118, this.hovered ? 0.96 : 0.86);
            g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$var$LETGO_W, $daf4f1c650b6c0f9$var$LETGO_H, 6);
            g.endFill();
            this.label.alpha = this.hovered ? 1 : 0.9;
        };
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(11).color($daf4f1c650b6c0f9$var$TEXT_COLOR).bold().align("center").render("LET GO");
        this.label.x = Math.round($daf4f1c650b6c0f9$var$LETGO_W / 2 - this.label.width / 2);
        this.label.y = 6;
        this.addChild(this.bg, this.label);
        this.interactive = true;
        this.cursor = "pointer";
        // Proud of the fill on every side: it is 26px tall and it is the way out.
        this.hitArea = new (0, $6qzqq.Rectangle)(-4, -4, $daf4f1c650b6c0f9$var$LETGO_W + 8, $daf4f1c650b6c0f9$var$LETGO_H + 8);
        this.on("pointerdown", (event)=>{
            event.stopPropagation();
            onPress();
        });
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.draw();
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");

const $fd1228436d3e60cd$export$abbfafa8f348c16c = (kind)=>kind === "possessed" ? {
        title: "YOU HAVE POSSESSED AN INVADER",
        line: "You wear one of the wave's attackers. The camp does not know you.",
        button: "DISMISS"
    } : {
        title: "RETURNED TO THE LAND OF THE LIVING",
        line: "The borrowed body is finished with. You are yourself again.",
        button: "DISMISS"
    };
const $fd1228436d3e60cd$export$42463ac0de0f0a2 = (was, now)=>was === now ? undefined : now ? "possessed" : "returned";
// ===== geometry =======================================================================
// Stage units, with the 1.3 vertical stretch already accounted for -- the frame run_summary.ts and
// invasion_picker.ts work in, because this opens over the same screen.
const $fd1228436d3e60cd$var$SCREEN_W = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
const $fd1228436d3e60cd$var$CENTER_X = $fd1228436d3e60cd$var$SCREEN_W / 2;
const $fd1228436d3e60cd$var$CENTER_Y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2 + 52;
const $fd1228436d3e60cd$var$PANEL_W = 420;
const $fd1228436d3e60cd$var$PANEL_H = 150;
const $fd1228436d3e60cd$var$PANEL_LEFT = $fd1228436d3e60cd$var$CENTER_X - $fd1228436d3e60cd$var$PANEL_W / 2;
const $fd1228436d3e60cd$var$PANEL_TOP = $fd1228436d3e60cd$var$CENTER_Y - $fd1228436d3e60cd$var$PANEL_H / 2;
const $fd1228436d3e60cd$var$BUTTON_W = 150;
const $fd1228436d3e60cd$var$BUTTON_H = 34;
const $fd1228436d3e60cd$var$BUTTON_TOP = $fd1228436d3e60cd$var$PANEL_TOP + $fd1228436d3e60cd$var$PANEL_H - $fd1228436d3e60cd$var$BUTTON_H - 18;
// Palette, shared with run_summary.ts / invasion_picker.ts.
const $fd1228436d3e60cd$var$PANEL_FILL = 0x1b1512;
const $fd1228436d3e60cd$var$PANEL_ALPHA = 0.97;
const $fd1228436d3e60cd$var$RIM = 0xf2a94e;
const $fd1228436d3e60cd$var$TEXT_COLOR = 0xfff3e0;
const $fd1228436d3e60cd$var$MUTED = 0xbfae99;
const $fd1228436d3e60cd$var$SCRIM_COLOR = 0x06060a;
// The undead's own cold colour, for the half of this that is about wearing somebody else.
const $fd1228436d3e60cd$var$UNDEAD = 0x9fd2ff;
const $fd1228436d3e60cd$var$FADE_STEP = 0.14;
class $fd1228436d3e60cd$export$3cab3b6954a18297 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.opened = false, this.kind = "possessed", this.hovered = false, this.isOpen = ()=>this.opened, /** Which message is up, for a caller outside the display tree (and for a test). */ this.shownKind = ()=>this.opened ? this.kind : undefined, this.open = (kind)=>{
            this.kind = kind;
            this.hovered = false;
            this.build();
            if (!this.visible) this.alpha = 0;
            this.opened = true;
            this.visible = true;
        }, this.close = ()=>{
            this.opened = false;
            this.hovered = false;
        }, this.animate = (_dtMs)=>{
            if (!this.visible) return;
            const target = this.opened ? 1 : 0;
            if (this.alpha === target) return;
            this.alpha = target > this.alpha ? Math.min(1, this.alpha + $fd1228436d3e60cd$var$FADE_STEP) : Math.max(0, this.alpha - $fd1228436d3e60cd$var$FADE_STEP);
            if (this.alpha <= 0) this.visible = false;
        }, // ===== internals ==================================================================
        this.build = ()=>{
            if (this.content) {
                this.panel.removeChild(this.content);
                this.content.destroy({
                    children: true
                });
                this.content = undefined;
            }
            const copy = $fd1228436d3e60cd$export$abbfafa8f348c16c(this.kind);
            // Warm for coming home, cold for putting somebody else's face on -- the one accent the
            // scorecard and the picker already use to mean "this is the undead's half".
            const accent = this.kind === "possessed" ? $fd1228436d3e60cd$var$UNDEAD : $fd1228436d3e60cd$var$RIM;
            const content = new (0, $8t5Gy.Container)();
            this.content = content;
            this.panel.addChild(content);
            const chrome = new (0, $gwPoJ.Graphics)();
            chrome.beginFill(accent, 0.1);
            chrome.drawRoundedRect($fd1228436d3e60cd$var$PANEL_LEFT - 6, $fd1228436d3e60cd$var$PANEL_TOP - 6, $fd1228436d3e60cd$var$PANEL_W + 12, $fd1228436d3e60cd$var$PANEL_H + 12, 16);
            chrome.endFill();
            chrome.lineStyle(1.5, accent, 0.85);
            chrome.beginFill($fd1228436d3e60cd$var$PANEL_FILL, $fd1228436d3e60cd$var$PANEL_ALPHA);
            chrome.drawRoundedRect($fd1228436d3e60cd$var$PANEL_LEFT, $fd1228436d3e60cd$var$PANEL_TOP, $fd1228436d3e60cd$var$PANEL_W, $fd1228436d3e60cd$var$PANEL_H, 12);
            chrome.endFill();
            content.addChild(chrome);
            const title = this.text(copy.title, {
                size: 16,
                color: accent,
                bold: true
            });
            title.x = Math.round($fd1228436d3e60cd$var$CENTER_X - title.width / 2);
            title.y = $fd1228436d3e60cd$var$PANEL_TOP + 22;
            content.addChild(title);
            const line = this.text(copy.line, {
                size: 11,
                color: $fd1228436d3e60cd$var$MUTED
            });
            line.x = Math.round($fd1228436d3e60cd$var$CENTER_X - line.width / 2);
            line.y = $fd1228436d3e60cd$var$PANEL_TOP + 58;
            content.addChild(line);
            const button = new (0, $8t5Gy.Container)();
            button.x = $fd1228436d3e60cd$var$CENTER_X - $fd1228436d3e60cd$var$BUTTON_W / 2;
            button.y = $fd1228436d3e60cd$var$BUTTON_TOP;
            button.interactive = true;
            button.cursor = "pointer";
            button.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $fd1228436d3e60cd$var$BUTTON_W, $fd1228436d3e60cd$var$BUTTON_H);
            const bg = new (0, $gwPoJ.Graphics)();
            this.buttonBg = bg;
            button.addChild(bg);
            const label = this.text(copy.button, {
                size: 12,
                color: $fd1228436d3e60cd$var$TEXT_COLOR,
                bold: true
            });
            label.x = Math.round($fd1228436d3e60cd$var$BUTTON_W / 2 - label.width / 2);
            label.y = 9;
            button.addChild(label);
            button.on("pointerover", ()=>{
                this.hovered = true;
                this.drawButton();
            });
            button.on("pointerout", ()=>{
                this.hovered = false;
                this.drawButton();
            });
            button.on("pointerdown", (event)=>{
                event.stopPropagation();
                this.dismiss();
            });
            content.addChild(button);
            this.drawButton();
        }, /** Guarded on `opened`, so the fade-out cannot answer a second time on the way off the screen. */ this.dismiss = ()=>{
            if (!this.opened) return;
            this.close();
            this.onDismiss?.();
        }, this.drawButton = ()=>{
            const g = this.buttonBg;
            if (!g) return;
            const accent = this.kind === "possessed" ? $fd1228436d3e60cd$var$UNDEAD : $fd1228436d3e60cd$var$RIM;
            g.clear();
            g.beginFill(accent, this.hovered ? 0.2 : 0.08);
            g.drawRoundedRect(-3, -3, $fd1228436d3e60cd$var$BUTTON_W + 6, $fd1228436d3e60cd$var$BUTTON_H + 6, 10);
            g.endFill();
            g.lineStyle(1.5, accent, this.hovered ? 1 : 0.7);
            g.beginFill(0x120d0a, this.hovered ? 0.95 : 0.85);
            g.drawRoundedRect(0, 0, $fd1228436d3e60cd$var$BUTTON_W, $fd1228436d3e60cd$var$BUTTON_H, 7);
            g.endFill();
        }, this.text = (value, opts)=>{
            let renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(opts.size).align("center");
            if (opts.color !== undefined) renderer = renderer.color(opts.color);
            if (opts.bold) renderer = renderer.bold();
            return renderer.render(value);
        };
        this.onDismiss = props.onDismiss;
        // The scrim swallows every press that is not the button, and unlike the picker's it is NOT
        // an answer: this panel is telling the player something, and a stray click while they are
        // reading it should not fire their bow into the camp behind -- nor dismiss a message they
        // have not read.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill($fd1228436d3e60cd$var$SCRIM_COLOR, 0.55);
        this.scrim.drawRect(-400, -400, $fd1228436d3e60cd$var$SCREEN_W + 800, 1400);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(-400, -400, $fd1228436d3e60cd$var$SCREEN_W + 800, 1400);
        this.scrim.on("pointerdown", (event)=>event.stopPropagation());
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.scrim.on("rightclick", (event)=>event.stopPropagation());
        this.addChild(this.scrim);
        this.panel = new (0, $8t5Gy.Container)();
        this.panel.interactive = true;
        this.panel.hitArea = new (0, $6qzqq.Rectangle)($fd1228436d3e60cd$var$PANEL_LEFT, $fd1228436d3e60cd$var$PANEL_TOP, $fd1228436d3e60cd$var$PANEL_W, $fd1228436d3e60cd$var$PANEL_H);
        this.panel.on("pointerdown", (event)=>event.stopPropagation());
        this.panel.on("pointermove", (event)=>event.stopPropagation());
        this.addChild(this.panel);
        this.visible = false;
        this.alpha = 0;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


// Fade timing — mirrors RolePicker/CommandWheel (~100ms each way).
const $6d8fdbf74f9b9254$var$FADE_INTERVAL_MS = 5;
const $6d8fdbf74f9b9254$var$FADE_STEP = 0.05;
// Ember-lit palette, shared with the role picker.
const $6d8fdbf74f9b9254$var$RIM = 0xf2a94e;
const $6d8fdbf74f9b9254$var$PANEL_FILL = 0x1b1512;
const $6d8fdbf74f9b9254$var$PANEL_ALPHA = 0.92;
const $6d8fdbf74f9b9254$var$TEXT_COLOR = 0xfff3e0;
const $6d8fdbf74f9b9254$var$ACCEPT_COLOR = 0x7be08a;
const $6d8fdbf74f9b9254$var$SKIP_COLOR = 0x9a8e82;
const $6d8fdbf74f9b9254$var$BUTTON_IDLE_FILL = 0x2a201a;
const $6d8fdbf74f9b9254$var$BUTTON_HOVER_FILL = 0x33271e;
const $6d8fdbf74f9b9254$var$BUTTON_IDLE_RIM = 0x6b4f38;
const $6d8fdbf74f9b9254$var$METER_TRACK = 0x3a2c22;
// Overall footprint scale. The stage applies a 1.3x vertical scale (client_util SCALER), so the
// bar is authored a little large and scaled down, exactly like RolePicker does.
const $6d8fdbf74f9b9254$var$WIDGET_SCALE = 0.82;
const $6d8fdbf74f9b9254$var$PAD = 13;
const $6d8fdbf74f9b9254$var$PANEL_W = 420;
const $6d8fdbf74f9b9254$var$PANEL_CORNER = 10;
const $6d8fdbf74f9b9254$var$BUTTON_W = 96;
const $6d8fdbf74f9b9254$var$BUTTON_H = 26;
const $6d8fdbf74f9b9254$var$BUTTON_GAP = 8;
const $6d8fdbf74f9b9254$var$BUTTON_CORNER = 7;
const $6d8fdbf74f9b9254$var$METER_H = 3;
// The bar is laid out in ROWS -- title, body, then the buttons on their own line -- and never in
// columns. Buttons beside the text only fits copy short enough to clear them, and the copy is
// written on the SERVER: the moment a line got a few words longer it ran underneath the buttons.
// So the text gets the full inner width to wrap into, and the panel grows to whatever that needs.
const $6d8fdbf74f9b9254$var$TEXT_W = $6d8fdbf74f9b9254$var$PANEL_W - $6d8fdbf74f9b9254$var$PAD * 2;
const $6d8fdbf74f9b9254$var$TITLE_BODY_GAP = 2;
// Clear air between the last line of copy and the button row.
const $6d8fdbf74f9b9254$var$BODY_BUTTONS_GAP = 12;
// A floor, so a one-line prompt still reads as a bar rather than a sliver.
const $6d8fdbf74f9b9254$var$PANEL_H_MIN = 84;
// Fallback line heights, used only where a Text measures as zero (a headless/mocked canvas): the
// panel must never collapse onto its own buttons just because nothing could be measured.
const $6d8fdbf74f9b9254$var$TITLE_LINE_H = 19;
const $6d8fdbf74f9b9254$var$BODY_LINE_H = 15;
// Origin (0,0) is the panel's top-left; GuiManager positions it against the stage. The buttons are
// right-aligned; their row sits at the bottom, at a y computed from the measured text.
const $6d8fdbf74f9b9254$var$ACCEPT_X = $6d8fdbf74f9b9254$var$PANEL_W - $6d8fdbf74f9b9254$var$PAD - $6d8fdbf74f9b9254$var$BUTTON_W * 2 - $6d8fdbf74f9b9254$var$BUTTON_GAP;
const $6d8fdbf74f9b9254$var$SKIP_X = $6d8fdbf74f9b9254$var$PANEL_W - $6d8fdbf74f9b9254$var$PAD - $6d8fdbf74f9b9254$var$BUTTON_W;
class $6d8fdbf74f9b9254$export$7d04c213ce109943 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), // Height the current copy needs (see setPrompt). Everything that touches the bottom edge --
        // the background, the meter, the button row -- reads it rather than a constant.
        this.panelH = $6d8fdbf74f9b9254$var$PANEL_H_MIN, // Countdown state. `remainingMs` only ticks while the bar is open; at 0 it resolves to accept.
        this.totalMs = 0, this.remainingMs = 0, this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onChoose = props.onChoose;
        this.scale.set($6d8fdbf74f9b9254$var$WIDGET_SCALE);
        // Swallow pointer events over the bar so a click on it never falls through to a world
        // attack (the buttons handle their own clicks; this covers the text/gaps).
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $6d8fdbf74f9b9254$var$PANEL_W, this.panelH);
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.meter = new (0, $gwPoJ.Graphics)();
        this.addChild(this.meter);
        this.textLayer = new (0, $8t5Gy.Container)();
        this.addChild(this.textLayer);
        this.buttonLayer = new (0, $8t5Gy.Container)();
        this.addChild(this.buttonLayer);
        this.drawBackground();
        this.visible = false;
    }
    // On-stage footprint (authored size x WIDGET_SCALE), so GuiManager can place the bar without
    // reaching into pixi's measured bounds (which include the glow).
    static stageWidth() {
        return $6d8fdbf74f9b9254$var$PANEL_W * $6d8fdbf74f9b9254$var$WIDGET_SCALE;
    }
    // Instance-side, not static: the bar's height depends on the copy the server sent, so whoever
    // anchors it to the bottom of the screen has to re-read this after setPrompt.
    stageHeight() {
        return this.panelH * $6d8fdbf74f9b9254$var$WIDGET_SCALE;
    }
    // Dark "glass" bar with a warm rim and a faint outer glow (a fatter low-alpha copy rather than
    // a blur filter, which matters on low-end GPUs).
    drawBackground() {
        const g = this.bg;
        g.clear();
        g.beginFill($6d8fdbf74f9b9254$var$RIM, 0.06);
        g.drawRoundedRect(-5, -5, $6d8fdbf74f9b9254$var$PANEL_W + 10, this.panelH + 10, $6d8fdbf74f9b9254$var$PANEL_CORNER + 5);
        g.endFill();
        g.lineStyle(2, $6d8fdbf74f9b9254$var$RIM, 0.9);
        g.beginFill($6d8fdbf74f9b9254$var$PANEL_FILL, $6d8fdbf74f9b9254$var$PANEL_ALPHA);
        g.drawRoundedRect(0, 0, $6d8fdbf74f9b9254$var$PANEL_W, this.panelH, $6d8fdbf74f9b9254$var$PANEL_CORNER);
        g.endFill();
    }
    // The countdown: a thin track pinned to the bottom inside edge, with an amber fill that drains
    // left to right. Redrawn only when the filled width actually changes by a visible amount.
    drawMeter() {
        const g = this.meter;
        const x = $6d8fdbf74f9b9254$var$PAD;
        const y = this.panelH - $6d8fdbf74f9b9254$var$PAD / 2 - $6d8fdbf74f9b9254$var$METER_H;
        const w = $6d8fdbf74f9b9254$var$TEXT_W;
        const pct = this.totalMs > 0 ? Math.max(0, Math.min(1, this.remainingMs / this.totalMs)) : 0;
        g.clear();
        g.beginFill($6d8fdbf74f9b9254$var$METER_TRACK, 0.9);
        g.drawRoundedRect(x, y, w, $6d8fdbf74f9b9254$var$METER_H, $6d8fdbf74f9b9254$var$METER_H / 2);
        g.endFill();
        if (pct > 0) {
            g.beginFill($6d8fdbf74f9b9254$var$RIM, 0.95);
            g.drawRoundedRect(x, y, Math.max($6d8fdbf74f9b9254$var$METER_H, w * pct), $6d8fdbf74f9b9254$var$METER_H, $6d8fdbf74f9b9254$var$METER_H / 2);
            g.endFill();
        }
    }
    makeButton(label, x, y, color, choice) {
        const container = new (0, $8t5Gy.Container)();
        container.x = x;
        container.y = y;
        container.interactive = true;
        container.cursor = "pointer";
        container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $6d8fdbf74f9b9254$var$BUTTON_W, $6d8fdbf74f9b9254$var$BUTTON_H);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(color).fontSize(13).bold().align("center").render(label);
        text.x = $6d8fdbf74f9b9254$var$BUTTON_W / 2 - text.width / 2;
        text.y = $6d8fdbf74f9b9254$var$BUTTON_H / 2 - text.height / 2;
        container.addChild(text);
        const handle = {
            container: container,
            bg: bg,
            color: color,
            hovered: false
        };
        this.drawButton(handle);
        container.on("pointerover", ()=>{
            handle.hovered = true;
            this.drawButton(handle);
        });
        container.on("pointerout", ()=>{
            handle.hovered = false;
            this.drawButton(handle);
        });
        container.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.choose(choice, "click");
        });
        this.buttonLayer.addChild(container);
        return handle;
    }
    drawButton(handle) {
        const g = handle.bg;
        g.clear();
        if (handle.hovered) {
            g.beginFill(handle.color, 0.16);
            g.drawRoundedRect(-3, -3, $6d8fdbf74f9b9254$var$BUTTON_W + 6, $6d8fdbf74f9b9254$var$BUTTON_H + 6, $6d8fdbf74f9b9254$var$BUTTON_CORNER + 3);
            g.endFill();
            g.lineStyle(2, handle.color, 1);
            g.beginFill($6d8fdbf74f9b9254$var$BUTTON_HOVER_FILL, 0.97);
        } else {
            g.lineStyle(1.5, $6d8fdbf74f9b9254$var$BUTTON_IDLE_RIM, 0.7);
            g.beginFill($6d8fdbf74f9b9254$var$BUTTON_IDLE_FILL, 0.9);
        }
        g.drawRoundedRect(0, 0, $6d8fdbf74f9b9254$var$BUTTON_W, $6d8fdbf74f9b9254$var$BUTTON_H, $6d8fdbf74f9b9254$var$BUTTON_CORNER);
        g.endFill();
    }
    clearHover() {
        [
            this.accept,
            this.skip
        ].forEach((button)=>{
            if (button?.hovered) {
                button.hovered = false;
                this.drawButton(button);
            }
        });
    }
    // Answer once and only once: the first choice closes the bar, so a click landing in the same
    // frame the countdown expires can't send two answers.
    choose(choice, reason) {
        if (!this.opened) return;
        this.opened = false;
        this.onChoose?.(choice, reason);
    }
    // Rebuild the bar around a server-authored prompt (copy and countdown both come from the
    // server, so the wording can be retuned without a client release).
    setPrompt(prompt) {
        this.textLayer.removeChildren();
        this.buttonLayer.removeChildren();
        this.accept = undefined;
        this.skip = undefined;
        // Both lines wrap inside the bar rather than running off it (or under the buttons): the
        // wrap width is set at BUILD time so the measured height below is true on the first frame.
        const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($6d8fdbf74f9b9254$var$TEXT_COLOR).fontSize(15).bold().wordWrap($6d8fdbf74f9b9254$var$TEXT_W).render(prompt.title || "");
        title.x = $6d8fdbf74f9b9254$var$PAD;
        title.y = $6d8fdbf74f9b9254$var$PAD - 2;
        this.textLayer.addChild(title);
        const body = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($6d8fdbf74f9b9254$var$TEXT_COLOR).fontSize(11).wordWrap($6d8fdbf74f9b9254$var$TEXT_W).render(prompt.body || "");
        body.x = $6d8fdbf74f9b9254$var$PAD;
        body.y = title.y + Math.max(title.height, $6d8fdbf74f9b9254$var$TITLE_LINE_H) + $6d8fdbf74f9b9254$var$TITLE_BODY_GAP;
        body.alpha = 0.82;
        this.textLayer.addChild(body);
        // Grow the panel around the copy, then hang the button row off the BOTTOM of it. However
        // long the server's wording turns out to be, the buttons end up below it, never over it.
        const textBottom = body.y + Math.max(body.height, $6d8fdbf74f9b9254$var$BODY_LINE_H);
        this.panelH = Math.max($6d8fdbf74f9b9254$var$PANEL_H_MIN, textBottom + $6d8fdbf74f9b9254$var$BODY_BUTTONS_GAP + $6d8fdbf74f9b9254$var$BUTTON_H + $6d8fdbf74f9b9254$var$PAD);
        const buttonsY = this.panelH - $6d8fdbf74f9b9254$var$PAD - $6d8fdbf74f9b9254$var$BUTTON_H;
        this.accept = this.makeButton(prompt.acceptLabel || "Show me", $6d8fdbf74f9b9254$var$ACCEPT_X, buttonsY, $6d8fdbf74f9b9254$var$ACCEPT_COLOR, "accept");
        this.skip = this.makeButton(prompt.skipLabel || "Skip", $6d8fdbf74f9b9254$var$SKIP_X, buttonsY, $6d8fdbf74f9b9254$var$SKIP_COLOR, "skip");
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $6d8fdbf74f9b9254$var$PANEL_W, this.panelH);
        this.drawBackground();
        this.totalMs = Math.max(0, prompt.timeoutMs || 0);
        this.remainingMs = this.totalMs;
        this.drawMeter();
    }
    // Where the button row currently sits, in authored (unscaled) coordinates. Exposed so a test
    // can assert the thing that broke here: that the copy never reaches it.
    buttonsTop() {
        return this.panelH - $6d8fdbf74f9b9254$var$PAD - $6d8fdbf74f9b9254$var$BUTTON_H;
    }
    // The bottom of the last line of copy, in the same coordinates.
    textBottom() {
        let bottom = 0;
        this.textLayer.children.forEach((child)=>{
            bottom = Math.max(bottom, child.y + Math.max(child.height, $6d8fdbf74f9b9254$var$BODY_LINE_H));
        });
        return bottom;
    }
    // Drain the countdown. Called every frame by GuiManager while the bar is up; deltaTime is in
    // milliseconds (same contract as CountdownTimer.update). A prompt with timeoutMs 0 never
    // expires on its own.
    update(deltaTime) {
        if (!this.opened || this.totalMs <= 0) return;
        this.remainingMs = Math.max(0, this.remainingMs - deltaTime);
        this.drawMeter();
        if (this.remainingMs <= 0) this.choose("accept", "timeout");
    }
    remaining() {
        return this.remainingMs;
    }
    isOpen() {
        return this.opened;
    }
    // Reveal by fading in, interrupting an in-progress dismiss (mirrors RolePicker.fadeIn).
    fadeIn() {
        this.opened = true;
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $6d8fdbf74f9b9254$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $6d8fdbf74f9b9254$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    // Dismiss by fading out, hiding once transparent (mirrors RolePicker.fadeOut).
    fadeOut() {
        this.opened = false;
        this.clearHover();
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $6d8fdbf74f9b9254$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $6d8fdbf74f9b9254$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
            }
        });
        this.fadeOutFader.update();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $d85ea5e2371a760e$export$5a0af15366b01c51 extends (0, $gwPoJ.Graphics) {
    constructor(props = {}){
        super(), this.currentTime = 0, this.totalTime = 0, this.isRunning = false, // Animation properties
        this.lastDisplayTime = 0, this.textAnimationStartTime = 0, this.isAnimating = false, this.fader = null;
        this.radius = props.radius || 50;
        this.strokeWidth = props.strokeWidth || 8;
        this.backgroundColor = props.backgroundColor || 0x111a16;
        this.textColor = props.textColor || 0xffffff;
        this.onComplete = props.onComplete;
        this.setupTimer();
    }
    // Radius the countdown arc is stroked along (keeps the stroke inside the dial edge)
    get arcRadius() {
        return this.radius - this.strokeWidth / 2;
    }
    // Radius of the dark dial face behind the ring + number
    get faceRadius() {
        return this.radius + this.strokeWidth / 2;
    }
    setupTimer() {
        const { arcRadius: arcRadius, faceRadius: faceRadius } = this;
        // Dark translucent dial face: adds depth and keeps the number legible
        // over the bright, busy game world behind it.
        this.backgroundCircle = new (0, $gwPoJ.Graphics)();
        this.backgroundCircle.beginFill(this.backgroundColor, 0.62);
        this.backgroundCircle.drawCircle(0, 0, faceRadius);
        this.backgroundCircle.endFill();
        // Empty "groove" the countdown arc drains along
        this.backgroundCircle.lineStyle({
            width: this.strokeWidth,
            color: 0x000000,
            alpha: 0.3,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        this.backgroundCircle.drawCircle(0, 0, arcRadius);
        // Thin bright rim for a crisp, finished edge
        this.backgroundCircle.lineStyle({
            width: 1.5,
            color: 0xffffff,
            alpha: 0.1
        });
        this.backgroundCircle.drawCircle(0, 0, faceRadius - 1);
        this.addChild(this.backgroundCircle);
        // Create the depleting countdown arc
        this.pieSlice = new (0, $gwPoJ.Graphics)();
        this.addChild(this.pieSlice);
        // Create text display
        this.textDisplay = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(this.textColor).fontSize(30).bold().align("center").render("0");
        // Center the text
        this.textDisplay.x = -this.textDisplay.width / 2;
        this.textDisplay.y = -this.textDisplay.height / 2;
        this.addChild(this.textDisplay);
        // Center the entire timer
        this.x = this.radius + this.strokeWidth;
        this.y = this.radius + this.strokeWidth;
    }
    start(totalSeconds) {
        this.totalTime = totalSeconds;
        this.currentTime = totalSeconds;
        this.isRunning = true;
        this.lastDisplayTime = -1 // Force animation on first display
        ;
        this.isAnimating = false;
        // Reset alpha and visibility for new timer
        this.alpha = 1.0;
        this.visible = true;
        this.updateDisplay();
    }
    reset() {
        this.currentTime = this.totalTime;
        this.isRunning = false;
        this.lastDisplayTime = -1 // Force animation on next display
        ;
        this.isAnimating = false;
        // Stop any active fader
        if (this.fader) {
            this.fader.stop(true);
            this.fader = null;
        }
        // Reset alpha and visibility
        this.alpha = 1.0;
        this.visible = true;
        this.updateDisplay();
    }
    update(deltaTime) {
        if (!this.isRunning || this.currentTime <= 0) return;
        this.currentTime -= deltaTime / 1000 // Convert milliseconds to seconds
        ;
        if (this.currentTime <= 0) {
            this.currentTime = 0;
            this.isRunning = false;
            this.onComplete?.();
            this.startFadeOut();
        }
        this.updateDisplay();
    }
    updateDisplay() {
        // Update text with animation
        const displayTime = Math.ceil(this.currentTime);
        // Check if the display time changed (new second)
        if (displayTime !== this.lastDisplayTime) {
            this.lastDisplayTime = displayTime;
            this.textDisplay.text = displayTime.toString();
            this.textDisplay.x = -this.textDisplay.width / 2;
            this.textDisplay.y = -this.textDisplay.height / 2;
            // Start animation for new number
            this.isAnimating = true;
            this.textAnimationStartTime = this.currentTime;
        }
        // Handle text animation
        if (this.isAnimating) {
            const timeInSecond = this.currentTime - Math.floor(this.currentTime);
            const animationProgress = Math.min(timeInSecond / 0.2, 1) // Animation over 0.2 seconds
            ;
            if (timeInSecond < 0.2) {
                // Scale from 80% to 100% over 0.2 seconds
                const scale = 0.8 + 0.2 * animationProgress;
                this.textDisplay.scale.set(scale);
                this.textDisplay.alpha = 1.0;
            } else if (timeInSecond > 0.9) {
                // Fade out in the last 0.1 seconds
                const fadeProgress = (timeInSecond - 0.9) / 0.1;
                this.textDisplay.alpha = 1.0 - fadeProgress;
            } else {
                // Normal state
                this.textDisplay.scale.set(1.0);
                this.textDisplay.alpha = 1.0;
            }
            // Re-center text after scaling to keep it centered
            this.textDisplay.x = -this.textDisplay.width / 2;
            this.textDisplay.y = -this.textDisplay.height / 2;
        }
        // Update the countdown arc (a depleting ring gauge)
        this.pieSlice.clear();
        if (this.totalTime <= 0) return;
        // Don't show the arc when the countdown reaches 0
        if (displayTime <= 0) return;
        const progress = Math.max(0, Math.min(1, this.currentTime / this.totalTime));
        const arcRadius = this.arcRadius;
        // Arc sweeps clockwise from 12 o'clock and shrinks back toward it as time drains
        const startAngle = -Math.PI / 2;
        const endAngle = startAngle + progress * Math.PI * 2;
        const startX = Math.cos(startAngle) * arcRadius;
        const startY = Math.sin(startAngle) * arcRadius;
        // Smooth green -> amber -> red ramp as time runs out
        const color = this.rampColor(progress);
        // Warm the number toward the ring color as time drains: it stays crisp
        // white while there's plenty of time, then reddens for urgency near zero.
        // Tint is a cheap multiply over the white text, so it never re-rasterizes.
        const warmFactor = Math.pow(1 - progress, 1.6);
        this.textDisplay.tint = this.interpolateColor(0xffffff, color, warmFactor);
        // Final-seconds urgency: brighter, pulsing glow
        const urgent = displayTime <= 5;
        const pulse = 0.5 + 0.5 * Math.sin(this.currentTime * 9);
        const haloAlpha = urgent ? 0.22 + 0.3 * pulse : 0.2;
        // Soft outer glow (drawn as a fat, faint arc — cheap, no filters)
        this.pieSlice.lineStyle({
            width: this.strokeWidth + (urgent ? 8 : 5),
            color: color,
            alpha: haloAlpha,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        this.pieSlice.moveTo(startX, startY);
        this.pieSlice.arc(0, 0, arcRadius, startAngle, endAngle);
        // Main arc with rounded caps
        this.pieSlice.lineStyle({
            width: this.strokeWidth,
            color: color,
            alpha: 1.0,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        this.pieSlice.moveTo(startX, startY);
        this.pieSlice.arc(0, 0, arcRadius, startAngle, endAngle);
        // Bright leading tip at the draining end — reads like a clock hand
        const tipX = Math.cos(endAngle) * arcRadius;
        const tipY = Math.sin(endAngle) * arcRadius;
        this.pieSlice.lineStyle(0);
        this.pieSlice.beginFill(0xffffff, 0.85);
        this.pieSlice.drawCircle(tipX, tipY, this.strokeWidth * 0.3);
        this.pieSlice.endFill();
    }
    // Green (full) -> amber (half) -> red (empty)
    rampColor(progress) {
        const green = 0x4ade80;
        const amber = 0xfbbf24;
        const red = 0xef4444;
        if (progress > 0.5) return this.interpolateColor(amber, green, (progress - 0.5) / 0.5);
        return this.interpolateColor(red, amber, progress / 0.5);
    }
    interpolateColor(color1, color2, factor) {
        const r1 = color1 >> 16 & 0xff;
        const g1 = color1 >> 8 & 0xff;
        const b1 = color1 & 0xff;
        const r2 = color2 >> 16 & 0xff;
        const g2 = color2 >> 8 & 0xff;
        const b2 = color2 & 0xff;
        const r = Math.round(r1 + (r2 - r1) * factor);
        const g = Math.round(g1 + (g2 - g1) * factor);
        const b = Math.round(b1 + (b2 - b1) * factor);
        return r << 16 | g << 8 | b;
    }
    getCurrentTime() {
        return this.currentTime;
    }
    getTotalTime() {
        return this.totalTime;
    }
    isActive() {
        return this.isRunning;
    }
    startFadeOut() {
        // Stop any existing fader
        if (this.fader) this.fader.stop(true);
        // Create new fader for quick fade out (250ms)
        // 250ms / 5ms intervals = 50 steps, 1.0 / 50 = 0.02 per step
        this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            fadeInterval: 5,
            fadeAlphaDecrement: 0.02,
            minAlpha: 0.0,
            releaseCallback: ()=>{
                this.visible = false;
                this.fader = null;
            }
        });
        this.fader.update();
    }
    stop() {
        this.isRunning = false;
        // Stop any active fader
        if (this.fader) {
            this.fader.stop(true);
            this.fader = null;
        }
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

// The HUD badge shown while an ember camp is under assault: which wave is being fought and how many
// of its enemies are still to be put down.
//
// It deliberately takes the pre-wave COUNTDOWN DIAL's slot and its shape — same radius, same stroke,
// same dark face and groove. The countdown drains to zero, disappears, and this dial takes its place
// already full, so the HUD reads as one object handing over: "time until the wave" becomes "what's
// left of the wave". The palettes are what separate them: the countdown ramps green->amber->red as
// safety runs out, this one burns down from hostile red to ember gold as the threat does.
//
// The gauge is `remaining / total`, where remaining counts enemies not yet released by the spawners
// as well as the ones on the field — so it only ever falls (see ember-wave-manager.js, which owns
// those numbers). A head count would climb while the player fought, which reads backwards.
const $3220884133cc6599$var$FACE_COLOR = 0x1b1512 // the ember UI's panel brown (command wheel, role picker, speech bubble)
;
const $3220884133cc6599$var$FACE_ALPHA = 0.72;
const $3220884133cc6599$var$GROOVE_COLOR = 0x000000;
const $3220884133cc6599$var$GROOVE_ALPHA = 0.32;
const $3220884133cc6599$var$RIM_COLOR = 0xffffff;
const $3220884133cc6599$var$RIM_ALPHA = 0.1;
// Gauge ramp: a full ring is hostile red, a nearly-cleared one is ember gold.
const $3220884133cc6599$var$THREAT_COLOR = 0xef4444;
const $3220884133cc6599$var$CLEARING_COLOR = 0xffb648;
const $3220884133cc6599$var$COUNT_COLOR = 0xffffff;
const $3220884133cc6599$var$CAPTION_COLOR = 0xffc89a;
const $3220884133cc6599$var$CHIP_FILL = 0x2a1d16;
const $3220884133cc6599$var$CHIP_BORDER = 0xff8a3d;
const $3220884133cc6599$var$CHIP_TEXT_COLOR = 0xffd9a8;
const $3220884133cc6599$var$COUNT_SIZE = 30;
const $3220884133cc6599$var$CAPTION_SIZE = 9;
const $3220884133cc6599$var$CHIP_TEXT_SIZE = 12;
const $3220884133cc6599$var$CHIP_PAD_X = 9;
const $3220884133cc6599$var$CHIP_PAD_Y = 4;
const $3220884133cc6599$var$CHIP_GAP = 11 // between the dial's outer edge and the top of the chip
;
const $3220884133cc6599$var$APPEAR_MS = 220;
const $3220884133cc6599$var$FLASH_MS = 320;
// Below this many enemies the ring breathes — the last of a wave is the part worth watching.
const $3220884133cc6599$var$FINAL_STRETCH = 3;
const $3220884133cc6599$export$c556ea7803c4be93 = (remaining, total)=>{
    if (!(total > 0)) return remaining > 0 ? 1 : 0;
    return Math.max(0, Math.min(1, remaining / total));
};
const $3220884133cc6599$export$5ba3d6ef6c5cead = (progress)=>$3220884133cc6599$var$interpolateColor($3220884133cc6599$var$CLEARING_COLOR, $3220884133cc6599$var$THREAT_COLOR, progress);
const $3220884133cc6599$var$interpolateColor = (from, to, factor)=>{
    const f = Math.max(0, Math.min(1, factor));
    const r = Math.round((from >> 16 & 0xff) + ((to >> 16 & 0xff) - (from >> 16 & 0xff)) * f);
    const g = Math.round((from >> 8 & 0xff) + ((to >> 8 & 0xff) - (from >> 8 & 0xff)) * f);
    const b = Math.round((from & 0xff) + ((to & 0xff) - (from & 0xff)) * f);
    return r << 16 | g << 8 | b;
};
const $3220884133cc6599$var$easeOut = (t)=>1 - Math.pow(1 - t, 3);
class $3220884133cc6599$export$20faccd1109d9248 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), // What's being displayed. Null until the first wave status arrives.
        this.status = null, // Whether the badge wants to be on screen; `appear` is how far the entrance/exit has got (0..1).
        this.wanted = false, this.appear = 0, // Kill feedback: driven to 1 when `remaining` drops, decays back to 0.
        this.flash = 0, // Free-running clock for the final-stretch breathing.
        this.pulseTs = 0, this.needsDraw = true;
        this.radius = props.radius || 50;
        this.strokeWidth = props.strokeWidth || 7.5;
        this.face = new (0, $gwPoJ.Graphics)();
        this.gauge = new (0, $gwPoJ.Graphics)();
        this.chip = new (0, $gwPoJ.Graphics)();
        this.countText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($3220884133cc6599$var$COUNT_COLOR).fontSize($3220884133cc6599$var$COUNT_SIZE).bold().align("center").render("0");
        this.countText.anchor.set(0.5);
        this.captionText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($3220884133cc6599$var$CAPTION_COLOR).fontSize($3220884133cc6599$var$CAPTION_SIZE).bold().align("center").render("LEFT");
        this.captionText.anchor.set(0.5);
        this.captionText.alpha = 0.75;
        this.chipText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($3220884133cc6599$var$CHIP_TEXT_COLOR).fontSize($3220884133cc6599$var$CHIP_TEXT_SIZE).bold().align("center").render("WAVE 1");
        this.chipText.anchor.set(0.5);
        this.addChild(this.face);
        this.addChild(this.gauge);
        this.addChild(this.countText);
        this.addChild(this.captionText);
        this.addChild(this.chip);
        this.addChild(this.chipText);
        this.drawFace();
        this.layoutText();
        this.visible = false;
        this.alpha = 0;
    }
    // Outer painted size of the dial — what a caller positions against (the chip hangs below it and
    // is narrower, so it never widens the badge's footprint).
    get dialSize() {
        return this.radius * 2 + this.strokeWidth;
    }
    // How far below the dial's CENTRE the badge actually paints, chip included. Lets a caller keep
    // the whole thing on screen without reaching into the layout.
    get bottomExtent() {
        return this.radius + this.strokeWidth / 2 + $3220884133cc6599$var$CHIP_GAP + $3220884133cc6599$var$CHIP_TEXT_SIZE + $3220884133cc6599$var$CHIP_PAD_Y * 2;
    }
    // New wave state from the server, or null / wave 0 to take the badge down.
    update(status) {
        const live = status && status.wave > 0 ? status : null;
        if (!live) {
            if (this.wanted) this.wanted = false;
            return;
        }
        const previous = this.status;
        // A drop in the count is a kill (or several): flash the number so the player sees it land.
        // A new wave is not a drop, however much the number falls between waves.
        if (previous && previous.wave === live.wave && live.remaining < previous.remaining) this.flash = 1;
        this.status = live;
        this.wanted = true;
        this.needsDraw = true;
    }
    // Per-frame tick. Only redraws when something is actually moving, so a long wave doesn't repaint
    // a static dial 60 times a second.
    animate(deltaMs) {
        const target = this.wanted ? 1 : 0;
        if (this.appear !== target) {
            const step = deltaMs / $3220884133cc6599$var$APPEAR_MS;
            this.appear = target > this.appear ? Math.min(1, this.appear + step) : Math.max(0, this.appear - step);
            this.needsDraw = true;
        }
        if (this.flash > 0) {
            this.flash = Math.max(0, this.flash - deltaMs / $3220884133cc6599$var$FLASH_MS);
            this.needsDraw = true;
        }
        if (this.isBreathing()) {
            this.pulseTs += deltaMs;
            this.needsDraw = true;
        }
        if (!this.needsDraw) return;
        this.needsDraw = false;
        this.redraw();
    }
    // Whether the badge is on screen at all (mid-fade counts).
    isShowing() {
        return this.visible;
    }
    // Test/inspection seam: how strong the kill flash is right now (1 the frame a kill lands, 0 once
    // it has decayed).
    flashStrength() {
        return this.flash;
    }
    isBreathing() {
        return this.wanted && !!this.status && this.status.remaining > 0 && this.status.remaining <= $3220884133cc6599$var$FINAL_STRETCH;
    }
    redraw() {
        this.visible = this.appear > 0;
        if (!this.visible || !this.status) {
            this.alpha = 0;
            return;
        }
        const eased = $3220884133cc6599$var$easeOut(this.appear);
        this.alpha = eased;
        // Grows into place rather than popping — the countdown dial it replaces has just vanished
        // from the same spot.
        this.scale.set(0.82 + 0.18 * eased);
        const { remaining: remaining, total: total, wave: wave } = this.status;
        if (this.countText.text !== String(remaining)) this.countText.text = String(remaining);
        const chipLabel = `WAVE ${wave}`;
        if (this.chipText.text !== chipLabel) {
            this.chipText.text = chipLabel;
            this.layoutChip();
        }
        // The number swells on a kill and settles back.
        this.countText.scale.set(1 + 0.28 * this.flash);
        this.drawGauge($3220884133cc6599$export$c556ea7803c4be93(remaining, total));
    }
    drawFace() {
        const arcRadius = this.radius - this.strokeWidth / 2;
        const faceRadius = this.radius + this.strokeWidth / 2;
        this.face.clear();
        // Dark dial face: depth, and it keeps the number legible over a bright, busy camp.
        this.face.beginFill($3220884133cc6599$var$FACE_COLOR, $3220884133cc6599$var$FACE_ALPHA);
        this.face.drawCircle(0, 0, faceRadius);
        this.face.endFill();
        // The empty groove the gauge drains along.
        this.face.lineStyle({
            width: this.strokeWidth,
            color: $3220884133cc6599$var$GROOVE_COLOR,
            alpha: $3220884133cc6599$var$GROOVE_ALPHA,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        this.face.drawCircle(0, 0, arcRadius);
        // Thin bright rim for a crisp edge.
        this.face.lineStyle({
            width: 1.5,
            color: $3220884133cc6599$var$RIM_COLOR,
            alpha: $3220884133cc6599$var$RIM_ALPHA
        });
        this.face.drawCircle(0, 0, faceRadius - 1);
    }
    layoutText() {
        // The number sits a little above centre to leave room for its caption underneath.
        this.countText.y = -7;
        this.captionText.y = 15;
        this.layoutChip();
    }
    layoutChip() {
        const w = this.chipText.width + $3220884133cc6599$var$CHIP_PAD_X * 2;
        const h = this.chipText.height + $3220884133cc6599$var$CHIP_PAD_Y * 2;
        const top = this.radius + this.strokeWidth / 2 + $3220884133cc6599$var$CHIP_GAP;
        this.chipText.y = top + h / 2;
        this.chip.clear();
        this.chip.beginFill($3220884133cc6599$var$CHIP_FILL, 0.92);
        this.chip.lineStyle({
            width: 1,
            color: $3220884133cc6599$var$CHIP_BORDER,
            alpha: 0.55
        });
        this.chip.drawRoundedRect(-w / 2, top, w, h, h / 2);
        this.chip.endFill();
    }
    drawGauge(progress) {
        this.gauge.clear();
        if (progress <= 0) return;
        const arcRadius = this.radius - this.strokeWidth / 2;
        const color = $3220884133cc6599$export$5ba3d6ef6c5cead(progress);
        // Sweeps clockwise from 12 o'clock and shrinks back toward it as the wave is cleared —
        // the same motion as the countdown dial this badge replaces.
        const startAngle = -Math.PI / 2;
        const endAngle = startAngle + progress * Math.PI * 2;
        const startX = Math.cos(startAngle) * arcRadius;
        const startY = Math.sin(startAngle) * arcRadius;
        // Soft outer glow: a fatter, fainter copy of the arc. Cheap — no filters, which the low-end
        // hardware this targets can't spare.
        const breath = this.isBreathing() ? 0.5 + 0.5 * Math.sin(this.pulseTs / 190) : 0;
        const haloAlpha = 0.18 + 0.22 * breath + 0.3 * this.flash;
        this.gauge.lineStyle({
            width: this.strokeWidth + 5 + 4 * breath,
            color: color,
            alpha: haloAlpha,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        this.gauge.moveTo(startX, startY);
        this.gauge.arc(0, 0, arcRadius, startAngle, endAngle);
        // Main arc. A kill washes it toward white for a moment.
        this.gauge.lineStyle({
            width: this.strokeWidth,
            color: this.flash > 0 ? $3220884133cc6599$var$interpolateColor(color, 0xffffff, this.flash * 0.55) : color,
            alpha: 1,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        this.gauge.moveTo(startX, startY);
        this.gauge.arc(0, 0, arcRadius, startAngle, endAngle);
        // Bright bead at the draining end, so the eye can find how far round the gauge has got.
        const tipX = Math.cos(endAngle) * arcRadius;
        const tipY = Math.sin(endAngle) * arcRadius;
        this.gauge.lineStyle(0);
        this.gauge.beginFill(0xffffff, 0.85);
        this.gauge.drawCircle(tipX, tipY, this.strokeWidth * 0.3);
        this.gauge.endFill();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $617042715e0a010b$export$5696eab43b4d4c5a extends (0, $gwPoJ.Graphics) {
    constructor(gui){
        super(), this.setup = (angle)=>{
            //
            // this.surface.removeChildren()
            // let angle = 0
            // setInterval(() => {
            //     angle++
            //     if (angle > 360) {
            //         angle = 0
            //     }
            this.surface.angle = angle;
            // sun.angle -= angle
            const x = Math.sin(Math.PI * 180 / 360);
            const y = Math.cos(Math.PI * 180 / 360);
            this.surface.x = x;
            this.surface.y = y;
            this.sun.angle = -this.surface.angle;
            this.moon.angle = -this.surface.angle;
        // }, 25)
        };
        this.gui = gui;
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.scale.set(0.44);
        const mask = new (0, $gwPoJ.Graphics)();
        mask.beginFill(0x000000, 1.0);
        mask.drawRect(-40, -40, 80, 39);
        mask.endFill();
        this.addChild(mask);
        this.surface.mask = mask;
        const sun = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            color: 0xffffff,
            scale: 1.0,
            name: "sun-icon.png"
        });
        const moon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            color: 0xffffff,
            scale: 1.0,
            name: "moon-icon.png"
        });
        this.surface.addChild(sun);
        sun.x = -25;
        moon.x = 25;
        this.surface.addChild(moon);
        this.beginFill(0x00ff00, 1);
        this.drawRect(-40, -1, 80, 2);
        this.endFill();
        this.sun = sun;
        this.moon = moon;
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");



parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
const $7dcf9acc2579c643$export$4a423b5b028a4cfb = (width, height, centerAlpha)=>{
    try {
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(width));
        canvas.height = Math.max(1, Math.round(height));
        const ctx = canvas.getContext("2d");
        if (!ctx) return (0, $klOfb.Texture).WHITE;
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        gradient.addColorStop(0.0, "rgba(0,0,0,0)");
        gradient.addColorStop(0.18, `rgba(0,0,0,${centerAlpha})`);
        gradient.addColorStop(0.82, `rgba(0,0,0,${centerAlpha})`);
        gradient.addColorStop(1.0, "rgba(0,0,0,0)");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        return (0, $klOfb.Texture).from(canvas);
    } catch (e) {
        return (0, $klOfb.Texture).WHITE;
    }
};


// The "hero" banner: a big center-screen announcement. Same calm ambient look as the
// "important" strip — a full-width translucent band whose left/right edges fade to nothing,
// gently faded in and out — but with the giant text and centered placement that make it a
// "hero" moment rather than a routine notice.
const $4a3ce4bbe28116a7$var$VERTICAL_PADDING = 30 // space above/below the text inside the strip
;
const $4a3ce4bbe28116a7$var$STRIP_ALPHA = 0.4 // center opacity of the strip; kept airy so the giant text carries it
;
const $4a3ce4bbe28116a7$var$VERTICAL_OFFSET = 55 // nudge down to sit visually centered given the surrounding UI
;
class $4a3ce4bbe28116a7$export$75ee3f18f40024cd extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.background = null, this.fadeInFader = null, this.fadeOutFader = null, this.displayCallback = null, // The strip spans the full (fixed) viewport width, so the gradient texture is built once.
        this.gradientTexture = null, this.show = (message)=>{
            const { text: text, displayCallback: displayCallback, duration: duration = 1500 } = message;
            this.displayCallback = displayCallback || null;
            // Clear any existing animation
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
            }
            if (this.fadeOutFader) {
                this.fadeOutFader.stop(true);
                this.fadeOutFader = null;
            }
            // Clear previous content
            this.removeChildren();
            // Use the actual game screen dimensions (the visible viewport is wider than the 640 play area).
            const gameScreenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            const gameScreenHeight = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h;
            // The giant hero text (retained size)
            this.heroText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("GiganticFont").color(0xffffff).align("center").render(text);
            this.heroText.anchor.set(0, 0);
            this.heroText.x = gameScreenWidth / 2 - this.heroText.width / 2;
            this.heroText.y = gameScreenHeight / 2 - this.heroText.height / 2 + $4a3ce4bbe28116a7$var$VERTICAL_OFFSET;
            // Full-width gradient strip, vertically centered on the hero text.
            const stripHeight = this.heroText.height + $4a3ce4bbe28116a7$var$VERTICAL_PADDING * 2;
            const stripTop = this.heroText.y - $4a3ce4bbe28116a7$var$VERTICAL_PADDING;
            if (!this.gradientTexture) this.gradientTexture = (0, $7dcf9acc2579c643$export$4a423b5b028a4cfb)(gameScreenWidth, stripHeight, $4a3ce4bbe28116a7$var$STRIP_ALPHA);
            const background = new (0, $7Bs2Z.Sprite)(this.gradientTexture);
            background.x = 0;
            background.y = stripTop;
            background.width = gameScreenWidth;
            background.height = stripHeight;
            if (this.gradientTexture === (0, $klOfb.Texture).WHITE) {
                // Fallback (no 2D canvas): tint + alpha the flat texture so it still reads as a dark strip.
                background.tint = 0x000000;
                background.alpha = $4a3ce4bbe28116a7$var$STRIP_ALPHA;
            }
            this.background = background;
            // Background first so the text sits on top of it.
            this.addChild(background);
            this.addChild(this.heroText);
            this.visible = true;
            this.alpha = 0.0 // start transparent, fade in
            ;
            // Fade in -> hold -> fade out. No pop, no shrink.
            const displayDuration = duration || 2000;
            const fadeInDuration = 250 // 250ms fade in time
            ;
            const fadeOutDuration = 500 // 500ms fade out time
            ;
            const displayTime = displayDuration - fadeInDuration - fadeOutDuration;
            this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "in",
                minAlpha: 1.0,
                fadeInterval: 5,
                fadeAlphaDecrement: 0.02,
                releaseCallback: ()=>{
                    this.fadeInFader = null;
                    // Start the display timer after fade in completes
                    setTimeout(()=>{
                        this.startFadeOut();
                    }, Math.max(0, displayTime));
                }
            });
            this.fadeInFader.update();
        }, this.startFadeOut = ()=>{
            this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "out",
                minAlpha: 0.0,
                fadeInterval: 20,
                fadeAlphaDecrement: 0.05,
                releaseCallback: ()=>{
                    this.fadeOutFader = null;
                    this.visible = false;
                    this.alpha = 1.0 // Reset opacity for next display
                    ;
                    this.removeChildren();
                    if (this.displayCallback) {
                        this.displayCallback();
                        this.displayCallback = null;
                    }
                }
            });
            this.fadeOutFader.update();
        }, this.destroy = ()=>{
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
            }
            if (this.fadeOutFader) {
                this.fadeOutFader.stop(true);
                this.fadeOutFader = null;
            }
            this.removeChildren();
            this.visible = false;
            this.alpha = 1.0 // Reset opacity for next display
            ;
        };
        this.visible = false;
    }
}




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


const $d634a66159f23623$export$db3e35bb56748094 = (sprite, x, y, size)=>{
    const b = sprite.getLocalBounds();
    if (b.width > 0 && b.height > 0) {
        sprite.x = x + size / 2 - (b.x + b.width / 2);
        sprite.y = y + size / 2 - (b.y + b.height / 2);
    } else {
        sprite.x = x + size / 2;
        sprite.y = y + size / 2;
    }
};


// Geometry for the crafting panel. Like the chest/trade screen, the crafting screen now shows the
// player's backpack underneath its own UI -- the materials every recipe draws from. Both halves live
// in ONE docked panel that has to stay inside the 442px-tall screen, so neither half can claim a
// fixed size: the recipe rows compress (down to a floor) to make room for the backpack, and the
// backpack picks the largest slot size whose rows still fit in whatever is left.
//
// Pure math, no pixi -- see __tests__/crafting_layout.test.ts.
// Slot sizes the backpack grid will try, largest first. Each one implies its own column count,
// fitted to the panel's inner width (32 -> 8 cols, 28 -> 9, 24 -> 10 at a 4px gap in 284px).
const $a5a3df2f3994c840$export$a880d2a4436d893d = [
    32,
    28,
    24
];
const $a5a3df2f3994c840$export$b00cc381b2941ede = 4;
// Chests/players always show at least two rows on the trade screen; match that so a light backpack
// still reads as a grid rather than a lone strip of icons.
const $a5a3df2f3994c840$var$MIN_ROWS = 2;
// Rows the recipe list is asked to give up room for. A fuller backpack than this shrinks its own
// slots rather than squeezing the recipes further.
const $a5a3df2f3994c840$var$MAX_RESERVED_ROWS = 3;
const $a5a3df2f3994c840$export$b6095232b96cb2d5 = 4;
const $a5a3df2f3994c840$export$936291e846da1cf6 = 52;
const $a5a3df2f3994c840$export$f2d3f3e7b3a52713 = 36;
// Height of the "No recipes available yet." placeholder that stands in for the rows.
const $a5a3df2f3994c840$var$RECIPE_EMPTY_H = 24;
// Gap between the recipe list and the backpack's section label, and from that label to its slots.
// Both are kept tight on purpose: a handful of pixels here is the difference between the pack fitting
// a third row of slots and having to report the tail of itself as "+N more".
const $a5a3df2f3994c840$var$SECTION_GAP = 6;
const $a5a3df2f3994c840$var$LABEL_H = 18;
const $a5a3df2f3994c840$var$rowsHeight = (slot, rows)=>rows * (slot + $a5a3df2f3994c840$export$b00cc381b2941ede) - $a5a3df2f3994c840$export$b00cc381b2941ede;
// What one slot size can make of `maxH`: every row it needs when they fit (padded out to MIN_ROWS if
// there is room to spare), otherwise every row it can draw.
const $a5a3df2f3994c840$var$gridFor = (slot, itemCount, innerW, maxH)=>{
    const cols = Math.max(1, Math.floor((innerW + $a5a3df2f3994c840$export$b00cc381b2941ede) / (slot + $a5a3df2f3994c840$export$b00cc381b2941ede)));
    const needed = Math.max(1, Math.ceil(itemCount / cols));
    const affordable = Math.floor((maxH + $a5a3df2f3994c840$export$b00cc381b2941ede) / (slot + $a5a3df2f3994c840$export$b00cc381b2941ede));
    const rows = needed <= affordable ? Math.min(affordable, Math.max(needed, $a5a3df2f3994c840$var$MIN_ROWS)) : Math.max(1, affordable);
    return {
        slot: slot,
        cols: cols,
        rows: rows,
        gap: $a5a3df2f3994c840$export$b00cc381b2941ede,
        height: $a5a3df2f3994c840$var$rowsHeight(slot, rows),
        hidden: Math.max(0, itemCount - rows * cols)
    };
};
const $a5a3df2f3994c840$export$1db2d49d36d40ac5 = (itemCount, innerW, maxH)=>{
    const candidates = $a5a3df2f3994c840$export$a880d2a4436d893d.map((slot)=>$a5a3df2f3994c840$var$gridFor(slot, itemCount, innerW, maxH));
    const complete = candidates.find((c)=>c.height <= maxH && c.hidden === 0);
    if (complete) return complete;
    const fitting = candidates.filter((c)=>c.height <= maxH);
    // Ties keep the earlier (roomier) candidate.
    return (fitting.length > 0 ? fitting : candidates).reduce((best, c)=>c.hidden < best.hidden ? c : best);
};
const $a5a3df2f3994c840$export$cad70a0e6e8fa48e = ({ topY: topY, bottomY: bottomY, innerW: innerW, recipeCount: recipeCount, itemCount: itemCount })=>{
    // Reserve what the backpack wants at the roomiest slot size given unlimited height, capped so a
    // full pack can't starve the recipe list -- past the cap the grid compensates with smaller slots.
    const preferred = $a5a3df2f3994c840$var$gridFor($a5a3df2f3994c840$export$a880d2a4436d893d[0], itemCount, innerW, Number.MAX_SAFE_INTEGER);
    const cappedRows = Math.min(preferred.rows, $a5a3df2f3994c840$var$MAX_RESERVED_ROWS);
    const reserved = $a5a3df2f3994c840$var$SECTION_GAP + $a5a3df2f3994c840$var$LABEL_H + $a5a3df2f3994c840$var$rowsHeight(preferred.slot, cappedRows);
    const forRecipes = bottomY - topY - reserved;
    const cardH = recipeCount > 0 ? Math.max($a5a3df2f3994c840$export$f2d3f3e7b3a52713, Math.min($a5a3df2f3994c840$export$936291e846da1cf6, Math.floor((forRecipes + $a5a3df2f3994c840$export$b6095232b96cb2d5) / recipeCount) - $a5a3df2f3994c840$export$b6095232b96cb2d5)) : 0;
    const recipesBottom = recipeCount > 0 ? topY + recipeCount * (cardH + $a5a3df2f3994c840$export$b6095232b96cb2d5) - $a5a3df2f3994c840$export$b6095232b96cb2d5 : topY + $a5a3df2f3994c840$var$RECIPE_EMPTY_H;
    const labelY = recipesBottom + $a5a3df2f3994c840$var$SECTION_GAP;
    const gridY = labelY + $a5a3df2f3994c840$var$LABEL_H;
    const grid = $a5a3df2f3994c840$export$1db2d49d36d40ac5(itemCount, innerW, bottomY - gridY);
    return {
        cardH: cardH,
        recipesBottom: recipesBottom,
        labelY: labelY,
        gridY: gridY,
        grid: grid,
        bottom: gridY + grid.height
    };
};







parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");




class $c14ea609224dd88d$export$982d39230018c180 extends (0, $aeae8505a2eb5f5c$export$f169141001428c70) {
    constructor(entityProps, entity, props){
        super(props), this.createContent = ()=>{
            const content = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const lpcComposite = new (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)(this.entity.entityId);
            lpcComposite.updatePaperdoll(this.entity);
            lpcComposite.scale.set(this.entityProps.scale || 3);
            content.append2(lpcComposite, {
                topMargin: 32,
                leftMargin: 32
            });
            return content;
        };
        this.entityProps = entityProps;
        this.entity = entity;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");








class $3abf84d544684951$export$63ffc65ecf9f990b extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.update = (item, onSelectCallback)=>{
            if (!item) return;
            [
                ...this.surface.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.surface.removeChildren();
            this.clear();
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            this.surface.addChild(main);
            this.surface.addChild(this.hoverText);
            const title = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item.title, {
                color: 0x00ff00
            });
            main.append2(title);
            if (item.hoverText?.length > 0) {
                this.hoverText.visible = true;
                this.hoverText.visible = true;
                this.hoverText.update(item.hoverText);
                this.hoverText.y = -this.hoverText.height;
            } else this.hoverText.visible = false;
            let width = 0;
            item.options.forEach((itemOption, i)=>{
                const option = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(itemOption.title, {
                    type: "button|dynamic",
                    onClick: ()=>{
                        onSelectCallback({
                            ...itemOption
                        });
                    }
                });
                main.append2(option, {
                    topMargin: i === 0 ? 5 : undefined
                });
                if (option.width > width) width = option.width;
            });
            this.beginFill(0xff0000, 0.1);
            this.drawRect(0, 0, width, main.height);
            this.endFill();
            this.zIndex = 100000;
        };
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.hoverText = new (0, $95fcf006ca17068b$export$9035ac6ca3ebe147)();
        this.interactive = true;
        this.on("mouseover", ()=>{
            if (this.fader) {
                this.fader.stop();
                this.visible = true;
                this.alpha = 1.0;
            }
        });
        this.on("mouseout", ()=>{
            this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                fadeInterval: 1,
                fadeAlphaDecrement: 0.03,
                releaseCallback: ()=>{
                    this.alpha = 1.0;
                    this.visible = false;
                }
            });
            this.fader.update();
        });
    }
}
class $3abf84d544684951$export$ef2184bd89960b14 extends (0, $aeae8505a2eb5f5c$export$f169141001428c70) {
    constructor(gridMeta, props){
        super(props), this.itemMap = new Map(), this.createContent = (itemDetail)=>{
            const pane = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const itemList = this.buildItems(this.meta.itemMeta, itemDetail, this.meta.rows, this.meta.columns, this.meta.optionSelectionHandler);
            pane.append(itemList);
            this.surface = pane;
            return pane;
        }, this.buildItems = (items, detail, rows, columns, optionSelectionHandler)=>{
            const itemList = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const surfaceWidth = 48;
            const print = (item, row, column)=>{
                const itemSurface = new (0, $gwPoJ.Graphics)();
                itemSurface.width = surfaceWidth;
                itemSurface.height = surfaceWidth;
                itemSurface.zIndex = 1;
                if (item) this.itemMap.set(item.id, itemSurface);
                if (item && item.active) {
                    itemSurface.beginFill(item.activeColor !== undefined ? item.activeColor : 0x00ff00, 0.5);
                    itemSurface.drawCircle(surfaceWidth / 2, surfaceWidth / 2, surfaceWidth / 2 - 1);
                    itemSurface.endFill();
                } else {
                    itemSurface.beginFill(0xffffff, 0.3);
                    itemSurface.drawCircle(surfaceWidth / 2, surfaceWidth / 2, surfaceWidth / 2 - 1);
                    itemSurface.endFill();
                    itemSurface.beginFill(0x000000, 1);
                    itemSurface.drawCircle(surfaceWidth / 2, surfaceWidth / 2, surfaceWidth / 2 - 2);
                    itemSurface.endFill();
                }
                if (item) {
                    itemSurface.interactive = true;
                    itemSurface.on((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? "tap" : "mouseover", ()=>{
                        detail.visible = true;
                        detail.x = itemSurface.x + this.surface.x + (this.foofoo?.x || 0);
                        detail.y = itemSurface.y + this.surface.y + (this.foofoo?.y || 0);
                        detail.update(item, optionSelectionHandler);
                    });
                    const itemSprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: item.spriteId,
                        scale: 0.8,
                        color: 0xffffff,
                        animated: false,
                        rotating: false
                    });
                    itemSprite.x = surfaceWidth / 2;
                    itemSprite.y = surfaceWidth / 2;
                    itemSurface.addChild(itemSprite);
                    if (item.quantity > 1) {
                        const quantityLabel = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(`${item.quantity}`);
                        quantityLabel.x = itemSprite.x - quantityLabel.width / 2;
                        quantityLabel.y = itemSprite.y + 10;
                        itemSurface.addChild(quantityLabel);
                    }
                }
                itemSurface.x = column * surfaceWidth;
                itemSurface.y = row * surfaceWidth;
                itemList.addChild(itemSurface);
            };
            let itemPos = 0;
            for(let row = 0; row < rows; row++)for(let column = 0; column < columns; column++){
                print(items[row * columns + column], row, column);
                itemPos++;
            }
            return itemList;
        };
        this.meta = gridMeta;
    }
}




class $95fcf006ca17068b$export$9035ac6ca3ebe147 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.update = (texts)=>{
            if (texts.length < 1) return;
            this.surface.removeChildren();
            this.clear();
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            this.surface.addChild(main);
            texts.forEach((text, i)=>{
                main.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(text), {
                    topMargin: i === 0 ? 5 : 0,
                    leftMargin: 5,
                    bottomMargin: 2
                });
            });
            this.beginFill(0x808080);
            this.drawRoundedRect(0, 0, main.width + 10, main.height + 10, 5);
            this.endFill();
        };
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.interactive = true;
        this.on("mouseover", ()=>{
            if (this.fader) {
                this.fader.stop();
                this.visible = true;
                this.alpha = 1.0;
            }
        });
        this.on("mouseout", ()=>{
            this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                fadeInterval: 1,
                fadeAlphaDecrement: 0.03,
                releaseCallback: ()=>{
                    this.alpha = 1.0;
                    this.visible = false;
                }
            });
            this.fader.update();
        });
    }
}
class $95fcf006ca17068b$export$97a92ac594e41d5f extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, logic, message, onClose, modalProps){
        super(guiManager, modalProps), this.grids = [], this.throbbers = [], this.updateContent = (message)=>{
            this.grids = [];
            this.message = message;
            // this.logic.enablePlayerMouseAction(false)
            this.update();
        }, this.createContent = ()=>{
            const { message: message } = this;
            return $95fcf006ca17068b$export$97a92ac594e41d5f.createContent(this.logic, message, this.width(), this.grids);
        }, this.pulseGridItem = (itemId)=>{
            const slots = this.grids.map((grid)=>grid.itemMap.get(itemId)).filter((items)=>!!items).flat();
            slots.forEach((slot)=>{
                const newIndicator = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("New!", {
                    font: "RedChatFont"
                });
                newIndicator.x = slot.width / 2 - newIndicator.width / 2;
                newIndicator.y = 2;
                slot.addChild(newIndicator);
                const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(slot, {
                    expires: 10000,
                    blinkInterval: 50,
                    releaseCallback: ()=>{
                        slot.removeChild(newIndicator);
                    }
                });
                throbber.update();
            });
        };
        this.logic = logic;
        this.message = message;
        if (onClose) this.onClose = ()=>{
            if (onClose) onClose();
        };
    }
    static{
        this.createContent = (logic, message, width, grids, props)=>{
            const progressive = message.progressive;
            const content = new (0, $gwPoJ.Graphics)();
            const { dynamicText: dynamicText = [], columnCount: columnCount = 1 } = message;
            const columns = new Map();
            const columnWidth = width / columnCount;
            const detailContainer = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const itemDetail = new (0, $3abf84d544684951$export$63ffc65ecf9f990b)();
            const hoverText = new $95fcf006ca17068b$export$9035ac6ca3ebe147();
            detailContainer.addChild(itemDetail);
            detailContainer.addChild(hoverText);
            for(let i = 1; i <= columnCount; i++){
                const columnSurface = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                    linkCallback: logic.log,
                    progressive: progressive,
                    hoverText: hoverText,
                    ...props || {}
                });
                columnSurface.x = (i - 1) * columnWidth;
                content.addChild(columnSurface);
                columns.set(i, columnSurface);
            }
            const processText = (text, targetContainer)=>{
                if (text.type === "entity") {
                    const { entityId: entityId, scale: scale, appearance: appearance, inventory: inventory } = text.context;
                    const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                    entity.weapon = {
                        weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(inventory, "weapon")?.type
                    };
                    entity.appearance = appearance;
                    entity.inventory = inventory;
                    const entityDisplayer = new (0, $c14ea609224dd88d$export$982d39230018c180)({
                        entityId: entityId,
                        scale: scale
                    }, entity);
                    const c = entityDisplayer.createContent();
                    targetContainer.append2(c, {
                        sameLine: text.sameLine,
                        leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                        leftMargin: text.leftMargin !== undefined ? text.leftMargin : 15,
                        topMargin: text.topMargin,
                        exactLocation: text.exactLocation,
                        hoverText: text.hoverText
                    });
                }
                if (text.type === "grid") {
                    const { gridMeta: meta, rows: rows, columns: columns } = text.context;
                    const grid = new (0, $3abf84d544684951$export$ef2184bd89960b14)({
                        itemMeta: meta,
                        optionSelectionHandler: (option)=>{
                            logic.playerController.client.emitPlayerEvent({
                                ...option.onClickContext
                            });
                        },
                        rows: rows,
                        columns: columns
                    });
                    grid.foofoo = targetContainer;
                    grids.push(grid);
                    targetContainer.append2(grid.createContent(itemDetail), {
                        sameLine: text.sameLine,
                        leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                        leftMargin: text.leftMargin !== undefined ? text.leftMargin : 0,
                        topMargin: text.topMargin,
                        exactLocation: text.exactLocation,
                        hoverText: text.hoverText
                    });
                } else if (text.type === "horizontalLine") targetContainer.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("", {
                    type: "horizontalLine"
                }), {
                    topMargin: text.topMargin,
                    bottomMargin: text.bottomMargin,
                    leftMargin: text.leftMargin,
                    hoverText: text.hoverText
                });
                else if (text.type === "container") {
                    const containerSurface = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                        linkCallback: logic.log,
                        progressive: progressive,
                        hoverText: hoverText
                    });
                    text.children.forEach((child)=>{
                        processText(child, containerSurface);
                    });
                    targetContainer.append2(containerSurface, {
                        sameLine: text.sameLine,
                        sameX: text.sameX,
                        leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                        leftMargin: text.leftMargin !== undefined ? text.leftMargin : 15,
                        topMargin: text.topMargin,
                        exactLocation: text.exactLocation,
                        hoverText: text.hoverText
                    });
                } else {
                    const texts = (0, $a80d0b17b615d6f7$export$edde49207b897324)(text.text, 95);
                    texts.forEach((nextText)=>{
                        targetContainer.append2(nextText, {
                            sameLine: text.sameLine,
                            sameX: text.sameX,
                            leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                            leftMargin: text.leftMargin !== undefined ? text.leftMargin : 15,
                            pause: text.pause,
                            type: text.type,
                            textDecorations: text.textDecorations,
                            onClick: text.clickEventEmitter ? ()=>{
                                logic.playerController.client.emitPlayerEvent(text.clickEventEmitter);
                            } : undefined,
                            mouseControlCallback: (on)=>{
                                const wasEnabled = logic.playerController.isMouseActionEnabled();
                                const enableRequested = !on;
                                if (enableRequested) // turn on player mouse control
                                {
                                    if (wasEnabled) // mouse control was allowed, so turn it on
                                    logic.playerController.enabledMouseAction(true);
                                // it wasn't allowed prior, so don't turn it on
                                } else // turn off player mouse control
                                logic.playerController.enabledMouseAction(enableRequested);
                            },
                            spriteId: text.spriteId,
                            scale: text.scale,
                            context: text.context,
                            exactLocation: text.exactLocation,
                            hoverText: text.hoverText,
                            font: text.font,
                            color: text.color
                        });
                    });
                }
            };
            dynamicText.map((next)=>typeof next === "string" ? {
                    text: next
                } : next).forEach((text)=>{
                const { column: column = 1 } = text;
                const textBlock = columns.get(column);
                processText(text, textBlock);
            });
            content.addChild(detailContainer);
            if (progressive) for(let i = 1; i <= columnCount; i++)columns.get(i).playback();
            return content;
        };
    }
}




// Geometry and arithmetic for the transfer quantity picker -- the small panel that Take and Give
// open inside the chest/trade screen so a stack can be split without leaving the mouse. Pure
// numbers, no pixi: the widget that draws them is modern_inventory_dialog.ts, and every row below is
// checked in __tests__/quantity_picker.test.ts.
//
// The picker has three ways to land on an amount, and they all write the same value: drag the slider,
// tap a chip (1 / Half / All), or just type the number. Typing keeps its own digit BUFFER rather than
// a number, because a half-typed "1" on the way to "12" has to show as "1" without the slider
// snapping to 1 and back.
const $70944e0e10e6c43a$export$2910b725986ae787 = 264;
const $70944e0e10e6c43a$export$ac1e2850638b95a7 = 14;
const $70944e0e10e6c43a$export$a9ede386157d607a = $70944e0e10e6c43a$export$2910b725986ae787 - $70944e0e10e6c43a$export$ac1e2850638b95a7 * 2;
const $70944e0e10e6c43a$export$9af9114e89ff83a2 = 11;
const $70944e0e10e6c43a$export$553d45c3442434df = 13;
const $70944e0e10e6c43a$export$da8ec1e8cb867d79 = 32;
const $70944e0e10e6c43a$export$3e922b6dc32741b1 = 86;
const $70944e0e10e6c43a$export$7d52ac13ac82d711 = 30;
const $70944e0e10e6c43a$export$6a9dffc2d456b0a3 = 8;
const $70944e0e10e6c43a$export$b3279a5753537da9 = 20;
const $70944e0e10e6c43a$export$cf30ece78a3cde75 = 76;
const $70944e0e10e6c43a$export$dcfd15f865104c82 = 24;
const $70944e0e10e6c43a$export$22d76395a6fcd5f6 = 10;
const $70944e0e10e6c43a$export$df9c782f47875f3d = $70944e0e10e6c43a$export$ac1e2850638b95a7 + $70944e0e10e6c43a$export$dcfd15f865104c82 + $70944e0e10e6c43a$export$22d76395a6fcd5f6;
const $70944e0e10e6c43a$export$35b0ea25dd9324cb = $70944e0e10e6c43a$export$2910b725986ae787 - $70944e0e10e6c43a$export$df9c782f47875f3d * 2;
const $70944e0e10e6c43a$export$4f0a5731cdda4a44 = 6;
const $70944e0e10e6c43a$export$7b47d622867725d1 = $70944e0e10e6c43a$export$cf30ece78a3cde75 + $70944e0e10e6c43a$export$dcfd15f865104c82 / 2;
const $70944e0e10e6c43a$export$fa15a17427b0bc4d = 8;
const $70944e0e10e6c43a$export$a9b2c383cf2ab052 = 108;
const $70944e0e10e6c43a$export$be057f60597d5793 = 64;
const $70944e0e10e6c43a$export$5102f6b83c315c0c = 22;
const $70944e0e10e6c43a$export$4a74fa73d9fcb37a = 8;
const $70944e0e10e6c43a$export$53b190a46f0ad1d8 = ($70944e0e10e6c43a$export$2910b725986ae787 - ($70944e0e10e6c43a$export$be057f60597d5793 * 3 + $70944e0e10e6c43a$export$4a74fa73d9fcb37a * 2)) / 2;
const $70944e0e10e6c43a$export$fe23d09197d672af = 140;
const $70944e0e10e6c43a$export$69d919be6a7605d6 = 30;
const $70944e0e10e6c43a$export$edd5e498781c14ea = 100;
const $70944e0e10e6c43a$export$1104136229124ac4 = 12;
const $70944e0e10e6c43a$export$fb049acdf78c8ac0 = $70944e0e10e6c43a$export$ac1e2850638b95a7 + $70944e0e10e6c43a$export$edd5e498781c14ea + $70944e0e10e6c43a$export$1104136229124ac4;
const $70944e0e10e6c43a$export$7f34fdcc42257ed6 = $70944e0e10e6c43a$export$a9ede386157d607a - $70944e0e10e6c43a$export$edd5e498781c14ea - $70944e0e10e6c43a$export$1104136229124ac4;
const $70944e0e10e6c43a$export$8dc567715ae55238 = $70944e0e10e6c43a$export$fe23d09197d672af + $70944e0e10e6c43a$export$69d919be6a7605d6 + $70944e0e10e6c43a$export$ac1e2850638b95a7;
const $70944e0e10e6c43a$export$82285e32b1314e7f = (panelW, panelH)=>({
        x: Math.max(0, Math.round((panelW - $70944e0e10e6c43a$export$2910b725986ae787) / 2)),
        y: Math.max(8, Math.round((panelH - $70944e0e10e6c43a$export$8dc567715ae55238) / 2))
    });
const $70944e0e10e6c43a$export$bbeb423b0346ff89 = (value, max)=>{
    if (!Number.isFinite(value)) return 1;
    return Math.max(1, Math.min(Math.floor(value), Math.max(1, Math.floor(max))));
};
const $70944e0e10e6c43a$export$83caf5bd22dcb16c = (quantity, max, trackW = $70944e0e10e6c43a$export$35b0ea25dd9324cb)=>{
    if (max <= 1) return 0;
    return ($70944e0e10e6c43a$export$bbeb423b0346ff89(quantity, max) - 1) / (max - 1) * trackW;
};
const $70944e0e10e6c43a$export$1e01af2fcd867956 = (offset, max, trackW = $70944e0e10e6c43a$export$35b0ea25dd9324cb)=>{
    if (max <= 1 || trackW <= 0) return 1;
    const ratio = Math.max(0, Math.min(1, offset / trackW));
    return $70944e0e10e6c43a$export$bbeb423b0346ff89(1 + Math.round(ratio * (max - 1)), max);
};
const $70944e0e10e6c43a$export$5bd044db5e0bc461 = (buffer, digit, max)=>{
    if (!/^[0-9]$/.test(digit)) return buffer;
    const next = `${buffer}${digit}`.replace(/^0+(?=\d)/, "");
    return Number(next) > max ? String($70944e0e10e6c43a$export$bbeb423b0346ff89(max, max)) : next;
};
const $70944e0e10e6c43a$export$6fbb95dd774f97a5 = (buffer)=>buffer.slice(0, -1);
const $70944e0e10e6c43a$export$f94dcf61679e1cfc = (buffer, max)=>{
    if (!/^[0-9]+$/.test(buffer)) return undefined;
    const value = Number(buffer);
    return value < 1 ? undefined : $70944e0e10e6c43a$export$bbeb423b0346ff89(value, max);
};
const $70944e0e10e6c43a$export$2c2c55fe8865ab2 = (max)=>Math.max(1, Math.floor(max / 2));




const $9600e6b065d22e57$export$e47778fec1008d44 = 45000;
const $9600e6b065d22e57$export$e19271ea5abac88c = 18;
const $9600e6b065d22e57$export$cf3a52d3dbeb0881 = 4;
const $9600e6b065d22e57$export$14401afa5819d457 = 8;
const $9600e6b065d22e57$export$cbebaa48d952aec0 = {
    "ember-ready": [
        "Your axe is ready here.",
        "Anything on this bar can be held."
    ],
    "ember-items": [
        "Open your pack.",
        "The wood you cut is in there."
    ],
    "ember-crafting": [
        "Switch to crafting."
    ],
    "ember-recipe": [
        "Craft a campfire out of the wood."
    ],
    "ember-pack": [
        "Here it is, in your pack.",
        "Choose it for its actions."
    ],
    "ember-use": [
        "Use it to set the fire down."
    ]
};
const $9600e6b065d22e57$export$e9a54e30240a1d3d = [
    // "ember-ready" is deliberately NOT in this chain. It names the ready bar when the axe is handed
    // over, which is a beat of its own with nothing before or after it -- putting it in the order
    // would have the pack's clue retire it, which is not what taking the axe means. It ends on its own
    // timeout, or with the rest when the lesson is marked seen.
    "ember-items",
    "ember-crafting",
    "ember-recipe",
    "ember-pack",
    "ember-use"
];
const $9600e6b065d22e57$export$478dbbcac4bfb39 = (tutorialType)=>$9600e6b065d22e57$export$e9a54e30240a1d3d[$9600e6b065d22e57$export$e9a54e30240a1d3d.indexOf(tutorialType) - 1];
const $9600e6b065d22e57$export$9069b388aec1210a = (tutorialType, suppressed)=>{
    if (!tutorialType) return "clear";
    if ((0, $cb689cfa16c444ba$export$a35d0571df2da201)(tutorialType)) return "clue";
    return suppressed ? "suppressed" : "popup";
};
const $9600e6b065d22e57$export$e8a38504aad4fd94 = ({ anchorX: anchorX, anchorY: anchorY, anchorW: anchorW = 0, anchorH: anchorH, boxW: boxW, boxH: boxH, boxMinX: boxMinX = $9600e6b065d22e57$export$14401afa5819d457, placement: placement = "left" })=>{
    if (placement === "above") {
        // Centred over the control and sitting on top of it. `leader` is the vertical drop back down
        // to it, and is 0 when the clamp left no clear gap to draw one in.
        const boxX = Math.max(boxMinX, anchorX + anchorW / 2 - boxW / 2);
        const boxY = Math.max($9600e6b065d22e57$export$cf3a52d3dbeb0881, anchorY - $9600e6b065d22e57$export$e19271ea5abac88c - boxH);
        return {
            boxX: boxX,
            boxY: boxY,
            leader: Math.max(0, anchorY - (boxY + boxH))
        };
    }
    const boxX = Math.max(boxMinX, anchorX - $9600e6b065d22e57$export$e19271ea5abac88c - boxW);
    const boxY = Math.max($9600e6b065d22e57$export$cf3a52d3dbeb0881, anchorY + anchorH / 2 - boxH / 2);
    return {
        boxX: boxX,
        boxY: boxY,
        leader: Math.max(0, anchorX - (boxX + boxW))
    };
};
class $9600e6b065d22e57$export$5e29510581c9aca2 {
    constructor(props){
        // Armed, with each clue's expiry timer.
        this.armed = new Map();
        // Where each clue's control was last drawn.
        this.anchors = new Map();
        // What is currently on screen, and how to retract it.
        this.drawn = new Map();
        // The server says this clue's beat is live. Draws it now if its control is already on screen;
        // otherwise remembers it, so it appears the moment the control does.
        this.arm = (tutorialType, timeoutMs)=>{
            if (this.armed.has(tutorialType)) return;
            const hold = timeoutMs && timeoutMs > 0 ? timeoutMs : this.props.defaultTimeoutMs || $9600e6b065d22e57$export$e47778fec1008d44;
            this.armed.set(tutorialType, setTimeout(()=>this.disarm(tutorialType), hold));
            this.refresh(tutorialType);
        };
        // Whatever drew one of the clued controls says where it landed. Called again on every rebuild of
        // the panel it lives in, which is why this redraws rather than skipping: an inventory update
        // throws the whole content tree away, clue and all.
        this.registerAnchor = (tutorialType, anchor)=>{
            this.anchors.set(tutorialType, anchor);
            this.refresh(tutorialType);
        };
        // The control has gone (its panel closed, or this rebuild no longer draws it). The clue stays
        // ARMED -- reopening the panel puts it back -- but nothing is left pointing at nothing.
        this.clearAnchor = (tutorialType)=>{
            this.anchors.delete(tutorialType);
            this.retract(tutorialType);
        };
        // Every clue down and disarmed. Sent by the server the moment the tutorial counts as seen, and
        // done locally on a room change.
        this.clearAll = ()=>{
            Array.from(this.armed.keys()).forEach(this.disarm);
            Array.from(this.drawn.keys()).forEach(this.retract);
            this.anchors.clear();
        };
        // Taken down for good rather than merely undrawn: an expired clue, or one the player dismissed,
        // must not reappear on the next rebuild of the panel it pointed at.
        this.disarm = (tutorialType)=>{
            const timer = this.armed.get(tutorialType);
            if (timer !== undefined) clearTimeout(timer);
            this.armed.delete(tutorialType);
            this.retract(tutorialType);
        };
        this.isArmed = (tutorialType)=>this.armed.has(tutorialType);
        this.isShowing = (tutorialType)=>this.drawn.has(tutorialType);
        this.retract = (tutorialType)=>{
            const stop = this.drawn.get(tutorialType);
            this.drawn.delete(tutorialType);
            if (stop) stop();
        };
        this.refresh = (tutorialType)=>{
            if (!this.armed.has(tutorialType)) return;
            const anchor = this.anchors.get(tutorialType) || (this.props.builtInAnchor ? this.props.builtInAnchor(tutorialType) : undefined);
            if (anchor === undefined || anchor === null) return;
            // Replace whatever was drawn for this clue before (a rebuilt panel) rather than stacking.
            this.retract(tutorialType);
            const stop = this.props.draw(tutorialType, anchor);
            if (stop) this.drawn.set(tutorialType, stop);
        };
        this.props = props;
    }
}


// Where the inventory's hover pill goes.
//
// Hovering a slot names the item; clicking it opens the menu. The pill exists so that looking through
// a pack answers "what is that?" without a context menu springing open under the pointer on its way
// across the grid.
//
// Pixi-free, like crafting_layout.ts beside it: the drawing is three lines of Graphics and the part
// worth guarding is the arithmetic, which has to keep a pill on an edge slot inside the panel.
// Clear air between the pill and the slot it names.
const $ad04bdb603662f3e$export$760b8ddd45219997 = 5;
const $ad04bdb603662f3e$export$ada46e7358e1cb98 = 4;
const $ad04bdb603662f3e$export$824d04aee2bc3075 = ({ slotX: slotX, slotY: slotY, slotSize: slotSize, pillW: pillW, pillH: pillH, panelW: panelW })=>{
    // Centred over the slot...
    const centred = slotX + slotSize / 2 - pillW / 2;
    // ...then pulled back inside the panel. A pill on the first or last column would otherwise hang
    // off the side of it, and a long item name makes that the common case rather than the rare one.
    const maxX = Math.max($ad04bdb603662f3e$export$ada46e7358e1cb98, panelW - pillW - $ad04bdb603662f3e$export$ada46e7358e1cb98);
    const x = Math.round(Math.max($ad04bdb603662f3e$export$ada46e7358e1cb98, Math.min(maxX, centred)));
    // Above the slot, unless that is off the top of the panel -- the top row is where this bites.
    const y = Math.round(Math.max($ad04bdb603662f3e$export$ada46e7358e1cb98, slotY - pillH - $ad04bdb603662f3e$export$760b8ddd45219997));
    return {
        x: x,
        y: y
    };
};


// -----------------------------------------------------------------------------
// Palette — a cohesive dark-fantasy scheme. Kept local so this renderer's look is
// self-contained and easy to tweak without touching the classic dialog.
// -----------------------------------------------------------------------------
const $98fc6d407c9f2a1f$var$COLOR = {
    panelFill: 0x171b26,
    panelFillTop: 0x212636,
    panelBorder: 0x3a4256,
    titleBar: 0x232a3d,
    gold: 0xd9a441,
    blue: 0x4a90d9,
    green: 0x5fbf5f,
    slotFill: 0x2a3142,
    slotInset: 0x11141c,
    slotBorder: 0x3a4256,
    slotHover: 0xd9a441,
    text: 0xe6e9f0,
    textMuted: 0x8b93a7,
    cardFill: 0x11141c,
    cardBorder: 0x3a4256,
    btnFill: 0x2f3648,
    btnFillHover: 0x3f4a63
};
// Full-screen coordinate space (matches FullScreenModal / Modal fullScreen sizing). Used for the
// chest/trade screen, which needs the full width for two side-by-side inventories.
const $98fc6d407c9f2a1f$var$PANEL_W = 780;
const $98fc6d407c9f2a1f$var$PANEL_H = 442;
// Right-docked panel used for the inventory/crafting/trade screens: a tall, narrow panel pinned to
// the right so the player and the world stay visible on the left. DOCK_X is the on-screen left
// offset applied to the whole content container. The width is fitted to the 8-column grid
// (8*32 + 7*4 = 284) plus even 16px margins, and DOCK_X leaves room for the close button, which hangs
// off the panel's top-right corner.
const $98fc6d407c9f2a1f$var$DOCK_SLOT = 32 // compact slot size for the narrow docked grids
;
const $98fc6d407c9f2a1f$var$DOCK_MARGIN = 16;
const $98fc6d407c9f2a1f$var$DOCK_W = $98fc6d407c9f2a1f$var$DOCK_MARGIN * 2 + 8 * $98fc6d407c9f2a1f$var$DOCK_SLOT + 28 // 316
;
const $98fc6d407c9f2a1f$var$DOCK_H = 430;
const $98fc6d407c9f2a1f$var$DOCK_X = 452;
// The panel background is drawn inset by this much inside the content box, so this is where its
// visible corners are (see drawPanelBg).
const $98fc6d407c9f2a1f$var$PANEL_INSET = 4;
// Slack assemble() leaves under the content when it sizes the panel to fit. A screen that lays itself
// out against a height budget (crafting) has to subtract it to land inside DOCK_H.
const $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD = 14;
const $98fc6d407c9f2a1f$var$SLOT = 44;
const $98fc6d407c9f2a1f$var$GAP = 6;
// ---- the ember tutorial's clues -------------------------------------------------------------
//
// Three of the five controls the first-run camp's tutorial points at live in THIS panel: the Craft
// toggle in the inventory's title bar, the campfire's own Craft button in the crafting list, and the
// crafted campfire's slot in the pack (whose hover menu carries the fourth, its Use button). The
// panel does not know or care whether a clue is armed -- it simply reports where it drew each one,
// and the tutorial layer decides (see gui/tutorial.ts registerClueAnchor).
//
// Every clue this panel owns, so a rebuild or a close can retract the lot in one go.
const $98fc6d407c9f2a1f$var$PANEL_CLUES = [
    "ember-crafting",
    "ember-recipe",
    "ember-pack",
    "ember-use"
];
// The recipe and the item the clues name. `title` is capitalize(itemTypeMeta.type) server-side and
// a recipe's `name` is the raw item type, so both compare case-insensitively against this.
const $98fc6d407c9f2a1f$var$CLUED_ITEM = "campfire";
// The inventory title bar's action that opens the crafting screen.
const $98fc6d407c9f2a1f$var$CRAFT_ACTION = /craft/i;
// The hover-menu option that puts a carried campfire on the ground (inventory.ts pushes "Use" for
// anything `useable`, which is how a campfire is placed -- it is not buildable).
const $98fc6d407c9f2a1f$var$USE_OPTION = /^use$/i;
// A clue's box is drawn to the left of its control, in the panel's own container -- which starts
// DOCK_X into the screen, so the box legitimately sits at a negative x. This is how far left it may
// go before it would run off the screen.
const $98fc6d407c9f2a1f$var$CLUE_BOX_MIN_X = -$98fc6d407c9f2a1f$var$DOCK_X + 8;
// The hover name pill. Small, quiet, and gone the moment the pointer leaves: its whole job is to
// answer "what is that?" without opening anything.
const $98fc6d407c9f2a1f$var$PILL_FONT = 10;
const $98fc6d407c9f2a1f$var$PILL_PAD_X = 7;
const $98fc6d407c9f2a1f$var$PILL_PAD_Y = 3;
const $98fc6d407c9f2a1f$var$PILL_FILL = 0x141821;
const $98fc6d407c9f2a1f$var$PILL_BORDER = 0x707b91;
const $98fc6d407c9f2a1f$var$PILL_TEXT = 0xe6e9f0;
const $98fc6d407c9f2a1f$var$text = (value, size, color, bold = false)=>{
    const renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).color(color);
    if (bold) renderer.bold();
    return renderer.render(value);
};
const $98fc6d407c9f2a1f$var$prettify = (value)=>(value || "").replace(/[-_]/g, " ").replace(/\b\w/g, (c)=>c.toUpperCase());
const $98fc6d407c9f2a1f$var$asMeta = (node)=>typeof node === "string" ? {
        text: node
    } : node;
const $98fc6d407c9f2a1f$export$bc3be2b9790d3f4d = (message)=>(message.dynamicText || []).some((n)=>$98fc6d407c9f2a1f$var$asMeta(n)?.text === "Craftable items");
// The paginator's own label, e.g. "Page 2 of 3" — how the paginator container is told apart from the
// category/subcategory chip containers beside it. Matching on a bare "Page" misses it (the label is
// never that exactly), which left the < > buttons to be read as two more category chips.
const $98fc6d407c9f2a1f$var$PAGE_LABEL = /^Page \d+ of \d+$/;
const $98fc6d407c9f2a1f$var$hasPageLabel = (node)=>{
    if (!node) return false;
    if ($98fc6d407c9f2a1f$var$PAGE_LABEL.test(node.text || "")) return true;
    return (node.children || []).some($98fc6d407c9f2a1f$var$hasPageLabel);
};
const $98fc6d407c9f2a1f$var$hasDescendantText = (node, value)=>{
    if (!node) return false;
    if (node.text === value) return true;
    return (node.children || []).some((c)=>$98fc6d407c9f2a1f$var$hasDescendantText(c, value));
};
const $98fc6d407c9f2a1f$export$1a9ed648cfadc85e = (message)=>(message.dynamicText || []).some((n)=>{
        const m = $98fc6d407c9f2a1f$var$asMeta(n);
        return m?.type === "sprite" && m?.spriteId === "action-trade.png";
    });
// -----------------------------------------------------------------------------
// The floating item detail / action card. Shown on hover (or tap on mobile); stays
// open while the pointer is over the originating slot OR the card itself, so its
// action buttons are reachable. Mirrors the classic ItemDetail's Fader behavior.
// -----------------------------------------------------------------------------
class $98fc6d407c9f2a1f$var$ModernDetailCard extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.scheduleHide = ()=>{
            // Stop any in-flight fade first so overlapping faders can't stack and yank the card
            // invisible mid-interaction (that race made action buttons occasionally un-clickable).
            if (this.fader) this.fader.stop(true);
            // Gentle ~250ms grace so the pointer has time to travel from the slot onto the card.
            this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                fadeInterval: 16,
                fadeAlphaDecrement: 0.06,
                releaseCallback: ()=>{
                    this.alpha = 1.0;
                    this.visible = false;
                    if (this.onHidden) this.onHidden();
                }
            });
            this.fader.update();
        }, this.show = (item, onSelect, anchorX, anchorY, anchorSize = $98fc6d407c9f2a1f$var$SLOT, panelW = $98fc6d407c9f2a1f$var$PANEL_W, panelH = $98fc6d407c9f2a1f$var$PANEL_H)=>{
            if (this.fader) this.fader.stop();
            [
                ...this.surface.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.surface.removeChildren();
            this.surface.clear();
            const padX = 12;
            const padY = 10;
            const lineGap = 4;
            let y = padY;
            let contentW = 150;
            const accent = item.active ? item.activeColor ?? $98fc6d407c9f2a1f$var$COLOR.green : $98fc6d407c9f2a1f$var$COLOR.gold;
            const title = $98fc6d407c9f2a1f$var$text(item.title || "Item", 15, accent, true);
            title.x = padX;
            title.y = y;
            this.surface.addChild(title);
            contentW = Math.max(contentW, title.width);
            y += title.height + lineGap + 2;
            (item.hoverText || []).forEach((line)=>{
                const t = $98fc6d407c9f2a1f$var$text(line, 11, $98fc6d407c9f2a1f$var$COLOR.textMuted);
                t.x = padX;
                t.y = y;
                this.surface.addChild(t);
                contentW = Math.max(contentW, t.width);
                y += t.height + lineGap;
            });
            const options = item.options || [];
            if (options.length > 0) y += 4;
            const btnH = 26;
            const btnGap = 5;
            const optionButtons = [];
            options.forEach((option)=>{
                const btnW = ()=>contentW // resolved after final width known; recomputed below
                ;
                const button = $98fc6d407c9f2a1f$var$makeButton(option.title, btnW(), btnH, ()=>{
                    onSelect({
                        ...option
                    });
                    this.hideNow();
                });
                button.x = padX;
                button.y = y;
                this.surface.addChild(button);
                optionButtons.push({
                    option: option,
                    button: button
                });
                y += btnH + btnGap;
            });
            const cardW = contentW + padX * 2;
            const cardH = y + padY - (options.length > 0 ? btnGap : 0);
            // Re-stretch buttons to the full card inner width now that it's known.
            this.surface.children.forEach((child)=>{
                const b = child;
                if (b.isModernButton) b.resize(cardW - padX * 2, btnH);
            });
            // Backdrop.
            this.surface.beginFill($98fc6d407c9f2a1f$var$COLOR.cardFill, 0.97);
            this.surface.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.cardBorder, 1);
            this.surface.drawRoundedRect(0, 0, cardW, cardH, 8);
            this.surface.endFill();
            // Accent top edge.
            this.surface.beginFill(accent, 0.9);
            this.surface.drawRoundedRect(0, 0, cardW, 3, 2);
            this.surface.endFill();
            // Keep the drawn backdrop behind the text/buttons.
            this.surface.setChildIndex(this.surface.children[0], 0);
            // A full-card hit area means hovering anywhere on the card (not just a button) keeps it
            // alive — moving the pointer from the slot onto the card immediately cancels the fade.
            this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, cardW, cardH);
            // Anchor as a dropdown directly beneath the slot, overlapping it by 2px so there is NO dead
            // gap for the pointer to cross on its way to the menu (crossing empty space is what let the
            // menu fade out before you could click it). Flip above / clamp to stay on-panel.
            let x = anchorX;
            if (x + cardW > panelW - 8) x = panelW - 8 - cardW;
            if (x < 8) x = 8;
            let cy = anchorY + anchorSize - 2;
            if (cy + cardH > panelH - 6) cy = anchorY - cardH + 2 // not enough room below — flip above the slot
            ;
            // Final guarantee: keep the WHOLE menu inside the panel so nothing is ever clipped — even a
            // tall menu near an edge. This pins the bottom edge in-bounds (it may overlap the icon), so
            // every option stays visible and clickable rather than running off the panel.
            cy = Math.max(8, Math.min(cy, panelH - 6 - cardH));
            this.x = x;
            this.y = cy;
            this.visible = true;
            this.alpha = 1.0;
            // Report the buttons last, once the card's own position is settled: a clue has to be told
            // where a button is in the PARENT's space, and until now neither the card's x/y nor the
            // buttons' final width were known.
            if (this.optionAnchors && optionButtons.length > 0) this.optionAnchors(item, optionButtons.map(({ option: option, button: button })=>({
                    option: option,
                    rect: new (0, $6qzqq.Rectangle)(this.x + button.x, this.y + button.y, cardW - padX * 2, btnH)
                })));
        }, this.hideNow = ()=>{
            this.visible = false;
            this.alpha = 1.0;
            if (this.onHidden) this.onHidden();
        };
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.visible = false;
        this.interactive = true;
        this.on("mouseover", ()=>{
            if (this.fader) this.fader.stop();
            this.visible = true;
            this.alpha = 1.0;
        });
        this.on("mouseout", ()=>this.scheduleHide());
    }
}
const $98fc6d407c9f2a1f$var$makeButton = (label, w, h, onClick, style)=>{
    const button = new (0, $gwPoJ.Graphics)();
    button.isModernButton = true;
    button.interactive = true;
    button.cursor = "pointer";
    const labelText = $98fc6d407c9f2a1f$var$text(label, style?.fontSize ?? 12, $98fc6d407c9f2a1f$var$COLOR.text);
    button.addChild(labelText);
    let hovered = false;
    let enabled = true;
    const draw = (bw, bh)=>{
        button.clear();
        const fill = style?.accent !== undefined && enabled ? style.accent : $98fc6d407c9f2a1f$var$COLOR.btnFill;
        button.beginFill(hovered && enabled ? $98fc6d407c9f2a1f$var$COLOR.btnFillHover : fill, 1);
        button.lineStyle(1, hovered && enabled ? $98fc6d407c9f2a1f$var$COLOR.gold : $98fc6d407c9f2a1f$var$COLOR.slotBorder, 1);
        button.drawRoundedRect(0, 0, bw, bh, 5);
        button.endFill();
        labelText.x = (bw - labelText.width) / 2;
        labelText.y = (bh - labelText.height) / 2;
    };
    let curW = w;
    let curH = h;
    draw(curW, curH);
    button.resize = (nw, nh)=>{
        curW = nw;
        curH = nh;
        draw(curW, curH);
    };
    button.setLabel = (next)=>{
        labelText.text = next;
        draw(curW, curH);
    };
    button.setEnabled = (next)=>{
        enabled = next;
        button.interactive = next;
        button.cursor = next ? "pointer" : "default";
        button.alpha = next ? 1 : 0.45;
        draw(curW, curH);
    };
    button.on("mouseover", ()=>{
        hovered = true;
        draw(curW, curH);
    });
    button.on("mouseout", ()=>{
        hovered = false;
        draw(curW, curH);
    });
    button.on("click", onClick);
    button.on("tap", onClick);
    return button;
};
class $98fc6d407c9f2a1f$var$QuantityPicker extends (0, $8t5Gy.Container) {
    constructor(props){
        super(), // Digits typed since the picker opened. Empty means "not typing", and the readout shows `value`.
        // Kept as a string, not a number, because a half-typed "1" on the way to "12" must read as "1"
        // without the slider snapping to 1 and back.
        this.buffer = "", this.dragging = false, this.released = false, this.panel = new (0, $8t5Gy.Container)(), this.slider = new (0, $gwPoJ.Graphics)(), this.readout = new (0, $gwPoJ.Graphics)(), this.trackHit = new (0, $gwPoJ.Graphics)(), // Sits over the whole panel for the duration of a drag so every move lands on ONE object, rather
        // than being swallowed by whatever the pointer happens to be over. Draws nothing.
        this.capture = new (0, $gwPoJ.Graphics)(), // A dim wash over the panel: says "answer this first", and blocks the item slots underneath so a
        // stray hover can't reopen the menu the picker was launched from.
        this.buildScrim = ()=>{
            const { panelW: panelW, panelH: panelH } = this.props;
            const scrim = new (0, $gwPoJ.Graphics)();
            scrim.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 0.62);
            scrim.drawRect(0, 0, panelW, panelH);
            scrim.endFill();
            scrim.interactive = true;
            this.addChild(scrim);
        }, this.buildPanel = ()=>{
            const { itemTitle: itemTitle, prompt: prompt, panelW: panelW, panelH: panelH } = this.props;
            const origin = (0, $70944e0e10e6c43a$export$82285e32b1314e7f)(panelW, panelH);
            this.panel.x = origin.x;
            this.panel.y = origin.y;
            const chrome = new (0, $gwPoJ.Graphics)();
            chrome.beginFill($98fc6d407c9f2a1f$var$COLOR.panelFill, 0.99);
            chrome.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.gold, 0.85);
            chrome.drawRoundedRect(0, 0, (0, $70944e0e10e6c43a$export$2910b725986ae787), (0, $70944e0e10e6c43a$export$8dc567715ae55238), 10);
            chrome.endFill();
            chrome.lineStyle(0);
            chrome.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
            chrome.drawRoundedRect(0, 0, (0, $70944e0e10e6c43a$export$2910b725986ae787), 3, 2);
            chrome.endFill();
            this.panel.addChild(chrome);
            const title = $98fc6d407c9f2a1f$var$text(`${prompt.verb} ${itemTitle}`, (0, $70944e0e10e6c43a$export$553d45c3442434df), $98fc6d407c9f2a1f$var$COLOR.gold, true);
            title.x = (0, $70944e0e10e6c43a$export$ac1e2850638b95a7);
            title.y = (0, $70944e0e10e6c43a$export$9af9114e89ff83a2);
            this.panel.addChild(title);
            // Readout row: the boxed amount, with "/ max" alongside. Centered as one group, so the box
            // stays put no matter how many digits the number grows to.
            const ofMax = $98fc6d407c9f2a1f$var$text(`/ ${this.max}`, 12, $98fc6d407c9f2a1f$var$COLOR.textMuted);
            const groupW = (0, $70944e0e10e6c43a$export$3e922b6dc32741b1) + (0, $70944e0e10e6c43a$export$6a9dffc2d456b0a3) + ofMax.width;
            const boxX = Math.round(((0, $70944e0e10e6c43a$export$2910b725986ae787) - groupW) / 2);
            this.readout.x = boxX;
            this.readout.y = (0, $70944e0e10e6c43a$export$da8ec1e8cb867d79);
            this.readout.interactive = true;
            this.readout.cursor = "text";
            this.readout.hitArea = new (0, $6qzqq.Rectangle)(0, 0, (0, $70944e0e10e6c43a$export$3e922b6dc32741b1), (0, $70944e0e10e6c43a$export$7d52ac13ac82d711));
            // Clicking the box means "let me retype this": empty the buffer and wait for digits.
            this.readout.on("pointerdown", ()=>{
                this.buffer = "";
                this.sync();
            });
            this.panel.addChild(this.readout);
            this.amountText = $98fc6d407c9f2a1f$var$text("", (0, $70944e0e10e6c43a$export$b3279a5753537da9), $98fc6d407c9f2a1f$var$COLOR.text, true);
            this.panel.addChild(this.amountText);
            ofMax.x = boxX + (0, $70944e0e10e6c43a$export$3e922b6dc32741b1) + (0, $70944e0e10e6c43a$export$6a9dffc2d456b0a3);
            ofMax.y = (0, $70944e0e10e6c43a$export$da8ec1e8cb867d79) + ((0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - ofMax.height) / 2 + 1;
            this.panel.addChild(ofMax);
            // Steppers pinned to the margins, slider between them.
            const minus = $98fc6d407c9f2a1f$var$makeButton("-", (0, $70944e0e10e6c43a$export$dcfd15f865104c82), (0, $70944e0e10e6c43a$export$dcfd15f865104c82), ()=>this.step(-1), {
                fontSize: 15
            });
            minus.x = (0, $70944e0e10e6c43a$export$ac1e2850638b95a7);
            minus.y = (0, $70944e0e10e6c43a$export$cf30ece78a3cde75);
            this.panel.addChild(minus);
            const plus = $98fc6d407c9f2a1f$var$makeButton("+", (0, $70944e0e10e6c43a$export$dcfd15f865104c82), (0, $70944e0e10e6c43a$export$dcfd15f865104c82), ()=>this.step(1), {
                fontSize: 15
            });
            plus.x = (0, $70944e0e10e6c43a$export$2910b725986ae787) - (0, $70944e0e10e6c43a$export$ac1e2850638b95a7) - (0, $70944e0e10e6c43a$export$dcfd15f865104c82);
            plus.y = (0, $70944e0e10e6c43a$export$cf30ece78a3cde75);
            this.panel.addChild(plus);
            this.panel.addChild(this.slider);
            this.trackHit.interactive = true;
            this.trackHit.cursor = "pointer";
            // Taller than the track and wider by a handle radius at each end, so the ends are reachable
            // and the grab doesn't demand pixel accuracy.
            this.trackHit.hitArea = new (0, $6qzqq.Rectangle)((0, $70944e0e10e6c43a$export$df9c782f47875f3d) - (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d), (0, $70944e0e10e6c43a$export$7b47d622867725d1) - 12, (0, $70944e0e10e6c43a$export$35b0ea25dd9324cb) + (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d) * 2, 24);
            this.trackHit.on("pointerdown", this.beginDrag);
            this.trackHit.on("pointerup", this.endDrag);
            this.trackHit.on("pointerupoutside", this.endDrag);
            this.panel.addChild(this.trackHit);
            const chips = [
                {
                    label: "1",
                    amount: ()=>1
                },
                {
                    label: "Half",
                    amount: ()=>(0, $70944e0e10e6c43a$export$2c2c55fe8865ab2)(this.max)
                },
                {
                    label: "All",
                    amount: ()=>this.max
                }
            ];
            chips.forEach((chip, i)=>{
                const button = $98fc6d407c9f2a1f$var$makeButton(chip.label, (0, $70944e0e10e6c43a$export$be057f60597d5793), (0, $70944e0e10e6c43a$export$5102f6b83c315c0c), ()=>this.set(chip.amount()), {
                    fontSize: 11
                });
                button.x = (0, $70944e0e10e6c43a$export$53b190a46f0ad1d8) + i * ((0, $70944e0e10e6c43a$export$be057f60597d5793) + (0, $70944e0e10e6c43a$export$4a74fa73d9fcb37a));
                button.y = (0, $70944e0e10e6c43a$export$a9b2c383cf2ab052);
                this.panel.addChild(button);
            });
            const cancel = $98fc6d407c9f2a1f$var$makeButton("Cancel", (0, $70944e0e10e6c43a$export$edd5e498781c14ea), (0, $70944e0e10e6c43a$export$69d919be6a7605d6), ()=>this.dismissWith(this.props.onCancel));
            cancel.x = (0, $70944e0e10e6c43a$export$ac1e2850638b95a7);
            cancel.y = (0, $70944e0e10e6c43a$export$fe23d09197d672af);
            this.panel.addChild(cancel);
            this.confirmButton = $98fc6d407c9f2a1f$var$makeButton("", (0, $70944e0e10e6c43a$export$7f34fdcc42257ed6), (0, $70944e0e10e6c43a$export$69d919be6a7605d6), this.confirm, {
                accent: $98fc6d407c9f2a1f$var$COLOR.titleBar
            });
            this.confirmButton.x = (0, $70944e0e10e6c43a$export$fb049acdf78c8ac0);
            this.confirmButton.y = (0, $70944e0e10e6c43a$export$fe23d09197d672af);
            this.panel.addChild(this.confirmButton);
        }, // ---- state ----------------------------------------------------------
        // The amount as it stands: the typed digits while typing, otherwise the slider's value. Undefined
        // only when the buffer has been emptied out -- a half-typed number with nothing to transfer yet.
        this.committed = ()=>this.buffer === "" ? this.value : (0, $70944e0e10e6c43a$export$f94dcf61679e1cfc)(this.buffer, this.max), this.set = (amount)=>{
            this.value = (0, $70944e0e10e6c43a$export$bbeb423b0346ff89)(amount, this.max);
            this.buffer = "";
            this.sync();
        }, this.step = (delta)=>this.set((this.committed() ?? this.value) + delta), // Redraws only what changes with the amount (readout, handle, confirm label). The chrome, labels
        // and buttons are built once -- a full rebuild on every drag frame would churn a Text texture per
        // pixel of travel.
        this.sync = ()=>{
            const amount = this.committed();
            const typing = this.buffer !== "";
            this.amountText.text = typing ? this.buffer : `${this.value}`;
            this.amountText.x = this.readout.x + ((0, $70944e0e10e6c43a$export$3e922b6dc32741b1) - this.amountText.width) / 2;
            this.amountText.y = (0, $70944e0e10e6c43a$export$da8ec1e8cb867d79) + ((0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - this.amountText.height) / 2;
            this.readout.clear();
            this.readout.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
            this.readout.lineStyle(typing ? 2 : 1, typing ? $98fc6d407c9f2a1f$var$COLOR.gold : $98fc6d407c9f2a1f$var$COLOR.slotBorder, 1);
            this.readout.drawRoundedRect(0, 0, (0, $70944e0e10e6c43a$export$3e922b6dc32741b1), (0, $70944e0e10e6c43a$export$7d52ac13ac82d711), 6);
            this.readout.endFill();
            this.readout.lineStyle(0);
            if (typing || amount === undefined) {
                // A plain caret rather than a blinking one: a blink needs a timer per open picker, and the
                // gold box edge already says the field has the keyboard.
                this.readout.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
                this.readout.drawRect(this.amountText.x - this.readout.x + this.amountText.width + 2, 6, 2, (0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - 12);
                this.readout.endFill();
            }
            this.drawSlider();
            const { verb: verb } = this.props.prompt;
            this.confirmButton.setLabel(amount === undefined ? verb : `${verb} ${amount}`);
            this.confirmButton.setEnabled(amount !== undefined);
        }, this.drawSlider = ()=>{
            const g = this.slider;
            const shown = this.committed() ?? this.value;
            const filled = (0, $70944e0e10e6c43a$export$83caf5bd22dcb16c)(shown, this.max);
            const top = (0, $70944e0e10e6c43a$export$7b47d622867725d1) - (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2;
            g.clear();
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
            g.drawRoundedRect((0, $70944e0e10e6c43a$export$df9c782f47875f3d), top, (0, $70944e0e10e6c43a$export$35b0ea25dd9324cb), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2);
            g.endFill();
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
            g.drawRoundedRect((0, $70944e0e10e6c43a$export$df9c782f47875f3d), top, Math.max((0, $70944e0e10e6c43a$export$4f0a5731cdda4a44), filled), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2);
            g.endFill();
            g.lineStyle(2, $98fc6d407c9f2a1f$var$COLOR.panelFill, 1);
            g.beginFill(this.dragging ? $98fc6d407c9f2a1f$var$COLOR.gold : $98fc6d407c9f2a1f$var$COLOR.text, 1);
            g.drawCircle((0, $70944e0e10e6c43a$export$df9c782f47875f3d) + filled, (0, $70944e0e10e6c43a$export$7b47d622867725d1), (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d));
            g.endFill();
            g.lineStyle(0);
        }, // ---- slider drag ----------------------------------------------------
        this.beginDrag = (event)=>{
            this.dragging = true;
            this.capture.visible = true;
            this.onDragMove(event);
        }, this.onDragMove = (event)=>{
            if (!this.dragging) return;
            const local = event.data.getLocalPosition(this.panel);
            this.set((0, $70944e0e10e6c43a$export$1e01af2fcd867956)(local.x - (0, $70944e0e10e6c43a$export$df9c782f47875f3d), this.max));
        }, this.endDrag = ()=>{
            if (!this.dragging) return;
            this.dragging = false;
            this.capture.visible = false;
            this.drawSlider();
        }, // ---- keyboard -------------------------------------------------------
        // The picker owns the keyboard while it is up: digits would otherwise hit the hotbar, the arrows
        // would walk the player out from under the screen, and Escape would tear the whole screen down
        // rather than backing out of the picker.
        this.attachKeys = ()=>{
            this.props.logic.playerController.enabledKeyboardAction(false);
            this.props.modal?.suspendEscape(true);
            this.props.logic.clientRenderer.keyboard().addListener(this.onKey);
        }, this.detachKeys = ()=>{
            this.props.logic.clientRenderer.keyboard().removeListener(this.onKey);
            this.props.modal?.suspendEscape(false);
            this.props.logic.playerController.enabledKeyboardAction(true);
        }, this.onKey = (key, down)=>{
            if (!down || this.released) return;
            if (/^[0-9]$/.test(key)) {
                this.buffer = (0, $70944e0e10e6c43a$export$5bd044db5e0bc461)(this.buffer, key, this.max);
                const typed = (0, $70944e0e10e6c43a$export$f94dcf61679e1cfc)(this.buffer, this.max);
                if (typed !== undefined) this.value = typed;
                this.sync();
                return;
            }
            if (key === "Backspace" || key === "Delete") {
                this.buffer = (0, $70944e0e10e6c43a$export$6fbb95dd774f97a5)(this.buffer === "" ? `${this.value}` : this.buffer);
                const typed = (0, $70944e0e10e6c43a$export$f94dcf61679e1cfc)(this.buffer, this.max);
                if (typed !== undefined) this.value = typed;
                this.sync();
                return;
            }
            if (key === "Enter") {
                this.confirm();
                return;
            }
            if (key === "Escape" || key === "Esc") {
                this.dismissWith(this.props.onCancel);
                return;
            }
            if (key === "ArrowLeft" || key === "ArrowDown") {
                this.step(key === "ArrowDown" ? -10 : -1);
                return;
            }
            if (key === "ArrowRight" || key === "ArrowUp") this.step(key === "ArrowUp" ? 10 : 1);
        }, // ---- teardown -------------------------------------------------------
        this.confirm = ()=>{
            const amount = this.committed();
            if (amount === undefined) return;
            this.dismissWith(()=>this.props.onConfirm(amount));
        }, this.dismissWith = (then)=>{
            this.dismiss();
            then();
        }, // Idempotent, and safe to call from anywhere the screen can be torn down under us (a re-render
        // after a transfer, the close button, the room changing) -- whatever happens, the keyboard has to
        // go back to the player.
        this.dismiss = ()=>{
            if (this.released) return;
            this.released = true;
            this.endDrag();
            this.detachKeys();
            this.parent?.removeChild(this);
        };
        this.props = props;
        this.max = Math.max(2, Math.floor(props.prompt.max));
        // Half the stack: the middle is the one starting point that is a short drag from every
        // answer, and the whole stack is one click away on the All chip.
        this.value = (0, $70944e0e10e6c43a$export$2c2c55fe8865ab2)(this.max);
        this.buildScrim();
        this.buildPanel();
        this.addChild(this.panel);
        this.addChild(this.capture);
        this.capture.interactive = true;
        this.capture.visible = false;
        this.capture.hitArea = new (0, $6qzqq.Rectangle)(0, 0, props.panelW, props.panelH);
        this.capture.on("pointermove", this.onDragMove);
        this.capture.on("pointerup", this.endDrag);
        this.capture.on("pointerupoutside", this.endDrag);
        this.attachKeys();
        this.sync();
    }
}
class $98fc6d407c9f2a1f$export$a2cb772ea0bad012 extends (0, $95fcf006ca17068b$export$97a92ac594e41d5f) {
    constructor(guiManager, logic, message, onClose){
        // Every modern screen (inventory, crafting, chest/trade) docks to the right with a
        // transparent backdrop so the world stays visible on the left. The dialog's close button is
        // hung off the DOCKED PANEL's top-right corner (the dialog rect itself is the whole screen,
        // whose corner is both off in the void and clipped by the screen edge).
        super(guiManager, logic, message, onClose, {
            backgroundAlpha: 0,
            closeAnchor: {
                x: $98fc6d407c9f2a1f$var$DOCK_X + $98fc6d407c9f2a1f$var$DOCK_W - $98fc6d407c9f2a1f$var$PANEL_INSET,
                y: $98fc6d407c9f2a1f$var$PANEL_INSET
            }
        }), this.modernItemMap = new Map(), this.createContent = ()=>{
            this.modernItemMap = new Map();
            // Every rebuild (including the one that follows a transfer) throws the old tree away, the
            // picker with it. Retire it properly first so it gives the keyboard back.
            this.dismissQuantityPicker();
            this.pickerLayer = undefined;
            // Same for the tutorial clues: the tree they were drawn into is about to be discarded, so drop
            // every anchor and let this pass re-report whichever controls it actually draws.
            this.retractClues();
            this.clueLayer = undefined;
            // The two-sided transfer screen (chest / trade) — two inventories stacked vertically.
            if ($98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message)) return this.createTradeContent();
            // The crafting screen reuses this same modal (it opens from the inventory's Craft button),
            // so route it to the modern crafting layout rather than the generic fallback.
            if ($98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message)) return this.createCraftingContent();
            const parsed = this.parse(this.message);
            // Only the player's own inventory renders in the modern layout. Anything else that reuses
            // this modal (or a mis-fired open-intent flag) falls back to the classic generic renderer so
            // it looks and behaves exactly as before. DynamicDialog.createContent is an instance arrow
            // field on the base, so `super.createContent` doesn't resolve — call the static form directly.
            if (!this.isSelfInventory(parsed)) return (0, $95fcf006ca17068b$export$97a92ac594e41d5f).createContent(this.logic, this.message, this.width() || $98fc6d407c9f2a1f$var$PANEL_W, this.grids);
            return this.assemble((body)=>{
                const detailCard = this.clueOnDetailCard(new $98fc6d407c9f2a1f$var$ModernDetailCard());
                this.drawTitleBar(body, parsed);
                this.drawPortraitAndStats(body, parsed);
                this.drawEquipped(body, parsed, detailCard);
                this.drawReadied(body, parsed, detailCard);
                this.drawBackpack(body, parsed, detailCard);
                // Detail card is added last so it always renders above the slots.
                body.addChild(detailCard);
            });
        }, // Builds a docked panel that sizes its height to the content. The body is drawn first, then the
        // rounded panel background is sized to fit behind it — so no screen has awkward empty space
        // below its content. The whole thing is offset to the right dock position.
        this.assemble = (drawBody)=>{
            const wrapper = new (0, $gwPoJ.Graphics)();
            const bg = new (0, $gwPoJ.Graphics)();
            const body = new (0, $gwPoJ.Graphics)();
            wrapper.addChild(bg);
            wrapper.addChild(body);
            // Created before the body is drawn (drawBody reports its clued controls as it goes) but
            // parented after it, so it draws over the panel and is never part of the body's measurement.
            // It shares the body's coordinate space: both sit at the wrapper's origin.
            const clueLayer = new (0, $8t5Gy.Container)();
            this.clueLayer = clueLayer;
            drawBody(body);
            // Measure the visible content (the hidden detail card is excluded) and size the panel to it.
            const b = body.getLocalBounds();
            const h = b.height > 0 ? b.y + b.height + $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD : this.panelH;
            this.panelH = h;
            this.drawPanelBg(bg, h);
            // Mounted last, and after the measurement, so an open picker floats over everything without
            // stretching the panel it is floating over.
            this.pickerLayer = new (0, $8t5Gy.Container)();
            body.addChild(this.pickerLayer);
            // The hover pill, over the panel like the clues but under them: a clue is a standing
            // instruction, a pill is a passing label, and the instruction wins if they ever overlap.
            this.pillLayer = new (0, $8t5Gy.Container)();
            wrapper.addChild(this.pillLayer);
            wrapper.addChild(clueLayer);
            wrapper.x = this.dockX;
            return wrapper;
        }, // ---- the hover name pill -----------------------------------------------
        /**
     * A small rounded label with the item's name, centred over the slot the pointer is on.
     *
     * Deliberately not a DyanmicTextContainer: this is redrawn on every slot the pointer crosses, and
     * a pill wants to be cheap to make and throw away.
     */ this.showNamePill = (title, slotX, slotY, size)=>{
            const layer = this.pillLayer;
            if (!layer || !title) return;
            layer.removeChildren();
            const label = $98fc6d407c9f2a1f$var$text(title, $98fc6d407c9f2a1f$var$PILL_FONT, $98fc6d407c9f2a1f$var$PILL_TEXT);
            const w = Math.ceil(label.width) + $98fc6d407c9f2a1f$var$PILL_PAD_X * 2;
            const h = Math.ceil(label.height) + $98fc6d407c9f2a1f$var$PILL_PAD_Y * 2;
            const pill = new (0, $gwPoJ.Graphics)();
            pill.lineStyle({
                width: 1,
                color: $98fc6d407c9f2a1f$var$PILL_BORDER,
                alpha: 0.9
            });
            pill.beginFill($98fc6d407c9f2a1f$var$PILL_FILL, 0.96);
            pill.drawRoundedRect(0, 0, w, h, h / 2);
            pill.endFill();
            pill.lineStyle(0);
            label.x = $98fc6d407c9f2a1f$var$PILL_PAD_X;
            label.y = $98fc6d407c9f2a1f$var$PILL_PAD_Y;
            pill.addChild(label);
            const { x: x, y: y } = (0, $ad04bdb603662f3e$export$824d04aee2bc3075)({
                slotX: slotX,
                slotY: slotY,
                slotSize: size,
                pillW: w,
                pillH: h,
                panelW: this.panelW
            });
            pill.x = x;
            pill.y = y;
            layer.addChild(pill);
        }, this.hideNamePill = ()=>{
            this.pillLayer?.removeChildren();
        }, // ---- ember tutorial clues ----------------------------------------------
        // "I drew this clued control, here." The tutorial layer decides whether anything comes of it.
        this.clueAt = (tutorialType, x, y, w, h)=>{
            if (!this.clueLayer) return;
            const clues = this.guiManager.tutorialClues();
            clues.registerClueAnchor(tutorialType, {
                host: this.clueLayer,
                x: x,
                y: y,
                w: w,
                h: h,
                boxMinX: $98fc6d407c9f2a1f$var$CLUE_BOX_MIN_X
            });
            // Drawing this control retires the one before it (see clueSatisfiedByDrawing). Order within a
            // rebuild does not matter: disarming wins, because registerAnchor on a disarmed clue is a no-op.
            const previous = (0, $9600e6b065d22e57$export$478dbbcac4bfb39)(tutorialType);
            if (previous) clues.satisfyClue(previous);
        }, this.retractClues = ()=>{
            const clues = this.guiManager.tutorialClues();
            $98fc6d407c9f2a1f$var$PANEL_CLUES.forEach((tutorialType)=>clues.clearClueAnchor(tutorialType));
        }, // The fifth clue lives on the hover menu, which only exists once the player has picked the item --
        // so the card reports its buttons as it lays them out, and this picks the campfire's "Use" out of
        // them. Picking any other item (or the menu closing) takes the pointer off.
        this.clueOnDetailCard = (card)=>{
            const clues = this.guiManager.tutorialClues();
            card.optionAnchors = (item, anchors)=>{
                const use = (item.title || "").toLowerCase() === $98fc6d407c9f2a1f$var$CLUED_ITEM ? anchors.find((a)=>$98fc6d407c9f2a1f$var$USE_OPTION.test(a.option.title || "")) : undefined;
                if (!use) {
                    clues.clearClueAnchor("ember-use");
                    return;
                }
                this.clueAt("ember-use", use.rect.x, use.rect.y, use.rect.width, use.rect.height);
            };
            card.onHidden = ()=>clues.clearClueAnchor("ember-use");
            return card;
        }, // ---- quantity picker ----------------------------------------------------
        // A Take/Give on a stack asks how many first. Everything else fires on the click, as before.
        this.openQuantityPicker = (item, option)=>{
            const prompt = option.quantityPrompt;
            if (!prompt || !this.pickerLayer) return false;
            this.dismissQuantityPicker();
            const picker = new $98fc6d407c9f2a1f$var$QuantityPicker({
                logic: this.logic,
                modal: this.modal,
                itemTitle: item.title,
                prompt: prompt,
                panelW: this.panelW,
                panelH: this.panelH,
                onConfirm: (amount)=>{
                    this.quantityPicker = undefined;
                    // The amount rides beside the option's sealed transaction -- it was chosen after the
                    // option was minted, so it cannot be inside it. The server clamps it.
                    this.logic.playerController.client.emitPlayerEvent({
                        ...option.onClickContext,
                        context: {
                            ...option.onClickContext?.context,
                            transferQuantity: amount
                        }
                    });
                },
                onCancel: ()=>{
                    this.quantityPicker = undefined;
                }
            });
            this.quantityPicker = picker;
            this.pickerLayer.addChild(picker);
            return true;
        }, this.dismissQuantityPicker = ()=>{
            const picker = this.quantityPicker;
            this.quantityPicker = undefined;
            picker?.dismiss();
        }, this.pulseGridItem = (itemId)=>{
            // In modern mode there's one slot per item; in classic-fallback mode (crafting etc.) the
            // generic grids own the slots. Pulse whichever we find. `super.pulseGridItem` can't be used
            // because the base defines it as an instance arrow field, not a prototype method.
            const slots = [];
            const modern = this.modernItemMap.get(itemId);
            if (modern) slots.push(modern);
            else this.grids.forEach((grid)=>{
                const s = grid.itemMap.get(itemId);
                if (s) slots.push(s);
            });
            slots.forEach((slot)=>{
                const indicator = $98fc6d407c9f2a1f$var$text("New!", 11, $98fc6d407c9f2a1f$var$COLOR.gold, true);
                indicator.x = (slot.width - indicator.width) / 2;
                indicator.y = 2;
                slot.addChild(indicator);
                const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(slot, {
                    expires: 10000,
                    blinkInterval: 50,
                    releaseCallback: ()=>slot.removeChild(indicator)
                });
                throbber.update();
            });
        }, // ---- payload parsing ----------------------------------------------------
        this.parse = (message)=>{
            const result = {
                backpack: [],
                readied: [],
                equipped: [],
                statLines: [],
                actions: [],
                gridCount: 0,
                hasBackpackGrid: false
            };
            const grids = [];
            const walk = (node)=>{
                const meta = typeof node === "string" ? {
                    text: node
                } : node;
                if (!meta) return;
                if (meta.type === "grid") {
                    const items = meta.context?.gridMeta || [];
                    grids.push({
                        items: items,
                        rows: meta.context?.rows ?? 0,
                        columns: meta.context?.columns ?? 0
                    });
                } else if (meta.type === "entity") {
                    if (!result.entity) result.entity = {
                        entityId: meta.context?.entityId,
                        appearance: meta.context?.appearance,
                        inventory: meta.context?.inventory
                    };
                } else if (meta.type === "button|dynamic" && meta.clickEventEmitter) result.actions.push({
                    text: meta.text,
                    event: meta.clickEventEmitter
                });
                else if (meta.font === "ImportantFont" && meta.text) {
                    if (!result.name) result.name = meta.text;
                } else if (meta.text && /^(Level|HP:|Speed:|Defense:|Mana)/.test(meta.text)) result.statLines.push(meta.text);
                if (meta.children) meta.children.forEach(walk);
            };
            (message.dynamicText || []).forEach(walk);
            result.gridCount = grids.length;
            // Classify grids by the server's dimensions (6x5 backpack, 6x1 readied, 2x6 equipped);
            // any unclassified grid folds into the backpack. We deliberately IGNORE these dims for
            // layout — they only tell us which bucket each pre-filtered item list belongs to.
            grids.forEach((grid)=>{
                if (grid.columns === 6 && grid.rows === 1) result.readied.push(...grid.items);
                else if (grid.columns === 2 && grid.rows === 6) result.equipped.push(...grid.items);
                else {
                    if (grid.columns === 6 && grid.rows === 5) result.hasBackpackGrid = true;
                    result.backpack.push(...grid.items);
                }
            });
            return result;
        }, // The modern layout is only meaningful for the player's own inventory panel. That panel is the
        // only reuse of this modal that carries BOTH the 6x5 backpack grid AND the character portrait
        // (showEntity). Crafting/trade sub-dialogs reuse the modal via updateContent but omit the
        // portrait, so they fall through to the generic renderer and look exactly as they always did.
        this.isSelfInventory = (parsed)=>!!parsed.entity && parsed.hasBackpackGrid, // ---- panel chrome -------------------------------------------------------
        this.drawPanelBg = (g, h)=>{
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.panelFill, 0.98);
            g.lineStyle(2, $98fc6d407c9f2a1f$var$COLOR.panelBorder, 1);
            g.drawRoundedRect(4, 4, this.panelW - 8, h - 8, 12);
            g.endFill();
            // Top depth band.
            g.lineStyle(0);
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.panelFillTop, 0.5);
            g.drawRoundedRect(6, 6, this.panelW - 12, 44, 10);
            g.endFill();
        }, this.drawTitleBar = (content, parsed)=>{
            const title = $98fc6d407c9f2a1f$var$text("INVENTORY", 17, $98fc6d407c9f2a1f$var$COLOR.gold, true);
            title.x = 16;
            title.y = 13;
            content.addChild(title);
            // Gold underline accent under the title bar.
            content.lineStyle(2, $98fc6d407c9f2a1f$var$COLOR.gold, 0.7);
            content.moveTo(16, 40);
            content.lineTo(this.panelW - 16, 40);
            content.lineStyle(0);
            // Header actions (e.g. Craft) — out to the right margin; the close button hangs off the
            // panel's corner rather than sitting inside it.
            let bx = this.panelW - 16;
            parsed.actions.forEach((action)=>{
                const btnW = 64;
                const button = $98fc6d407c9f2a1f$var$makeButton(action.text, btnW, 24, ()=>{
                    this.logic.playerController.client.emitPlayerEvent(action.event);
                });
                bx -= btnW;
                button.x = bx;
                button.y = 11;
                content.addChild(button);
                // The way through to the recipe list, and the second clue in the ember tutorial's chain.
                if ($98fc6d407c9f2a1f$var$CRAFT_ACTION.test(action.text || "")) this.clueAt("ember-crafting", button.x, button.y, btnW, 24);
                bx -= 6;
            });
        }, // ---- portrait + stats (compact header row) -----------------------------
        this.drawPortraitAndStats = (content, parsed)=>{
            const frameX = 16;
            const frameY = 46;
            const frameW = 74;
            const frameH = 80;
            // Portrait frame.
            content.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 0.85);
            content.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.panelBorder, 1);
            content.drawRoundedRect(frameX, frameY, frameW, frameH, 8);
            content.endFill();
            content.lineStyle(0);
            if (parsed.entity?.appearance || parsed.entity?.inventory) {
                const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                entity.weapon = {
                    weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(parsed.entity.inventory, "weapon")?.type
                };
                entity.appearance = parsed.entity.appearance;
                entity.inventory = parsed.entity.inventory;
                const displayer = new (0, $c14ea609224dd88d$export$982d39230018c180)({
                    entityId: parsed.entity.entityId,
                    scale: 1.6
                }, entity);
                const portrait = displayer.createContent();
                content.addChild(portrait);
                const bounds = portrait.getLocalBounds();
                if (bounds.width > 0 && bounds.height > 0) {
                    const fit = Math.min((frameW - 12) / bounds.width, (frameH - 12) / bounds.height, 1);
                    portrait.scale.set(fit);
                    portrait.x = frameX + (frameW - bounds.width * fit) / 2 - bounds.x * fit;
                    portrait.y = frameY + (frameH - bounds.height * fit) / 2 - bounds.y * fit;
                }
            }
            // Stats to the right of the portrait, tight line spacing to fit the header height.
            const statsX = frameX + frameW + 12;
            let sy = frameY + 2;
            if (parsed.name) {
                const name = $98fc6d407c9f2a1f$var$text(parsed.name, 14, $98fc6d407c9f2a1f$var$COLOR.gold, true);
                name.x = statsX;
                name.y = sy;
                content.addChild(name);
                sy += 17;
            }
            parsed.statLines.forEach((line)=>{
                const hp = line.match(/^HP:\s*([\d.]+)\s*\/\s*([\d.]+)/);
                if (hp) {
                    this.drawStatBar(content, statsX, sy, this.panelW - statsX - 16, "HP", parseFloat(hp[1]), parseFloat(hp[2]), $98fc6d407c9f2a1f$var$COLOR.green);
                    sy += 18;
                } else {
                    const t = $98fc6d407c9f2a1f$var$text(line, 11, $98fc6d407c9f2a1f$var$COLOR.textMuted);
                    t.x = statsX;
                    t.y = sy;
                    content.addChild(t);
                    sy += 14;
                }
            });
        }, this.drawStatBar = (content, x, y, w, label, value, max, color)=>{
            const barH = 14;
            content.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
            content.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.panelBorder, 1);
            content.drawRoundedRect(x, y, w, barH, 4);
            content.endFill();
            content.lineStyle(0);
            const ratio = max > 0 ? Math.max(0, Math.min(1, value / max)) : 0;
            if (ratio > 0) {
                content.beginFill(color, 0.9);
                content.drawRoundedRect(x + 1, y + 1, Math.max(2, (w - 2) * ratio), barH - 2, 3);
                content.endFill();
            }
            const t = $98fc6d407c9f2a1f$var$text(`${label}  ${Math.ceil(value)} / ${Math.ceil(max)}`, 11, $98fc6d407c9f2a1f$var$COLOR.text, true);
            t.x = x + 6;
            t.y = y + (barH - t.height) / 2;
            content.addChild(t);
        }, // ---- right region sections ---------------------------------------------
        // `note` is a muted right-aligned aside on the label row (e.g. the crafting pack's "+3 more"); the
        // rule stops short of it.
        this.sectionLabel = (content, label, x, y, note)=>{
            const t = $98fc6d407c9f2a1f$var$text(label.toUpperCase(), 12, $98fc6d407c9f2a1f$var$COLOR.gold, true);
            t.x = x;
            t.y = y;
            content.addChild(t);
            let ruleRight = this.panelW - 16;
            if (note) {
                const n = $98fc6d407c9f2a1f$var$text(note, 11, $98fc6d407c9f2a1f$var$COLOR.textMuted);
                n.x = this.panelW - 16 - n.width;
                n.y = y + 1;
                content.addChild(n);
                ruleRight = n.x - 8;
            }
            // subtle rule to the right of the label
            content.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.panelBorder, 0.8);
            content.moveTo(x + t.width + 10, y + t.height / 2 + 1);
            content.lineTo(ruleRight, y + t.height / 2 + 1);
            content.lineStyle(0);
        }, // Docked inventory: compact slots stacked vertically below the portrait row.
        this.drawEquipped = (content, parsed, card)=>{
            const originX = 16;
            const labelY = 132;
            this.sectionLabel(content, "Equipped", originX, labelY);
            const slotsY = labelY + 18;
            const count = Math.max(2, parsed.equipped.length);
            for(let i = 0; i < count; i++){
                const item = parsed.equipped[i];
                const slot = this.makeSlot(item, originX + i * ($98fc6d407c9f2a1f$var$DOCK_SLOT + 5), slotsY, card, $98fc6d407c9f2a1f$var$COLOR.green, $98fc6d407c9f2a1f$var$DOCK_SLOT);
                content.addChild(slot);
            }
        }, this.drawReadied = (content, parsed, card)=>{
            const originX = 16;
            const labelY = 188;
            this.sectionLabel(content, "Readied", originX, labelY);
            const slotsY = labelY + 18;
            for(let i = 0; i < (0, $cb689cfa16c444ba$export$ae5c2924da49a08c); i++){
                const item = parsed.readied[i];
                const slot = this.makeSlot(item, originX + i * ($98fc6d407c9f2a1f$var$DOCK_SLOT + 5), slotsY, card, $98fc6d407c9f2a1f$var$COLOR.blue, $98fc6d407c9f2a1f$var$DOCK_SLOT);
                content.addChild(slot);
            }
        }, this.drawBackpack = (content, parsed, card)=>{
            const originX = 16;
            const labelY = 244;
            this.sectionLabel(content, "Backpack", originX, labelY);
            const slotsY = labelY + 18;
            const cols = 8;
            const gap = 4;
            const rows = Math.max(4, Math.ceil(parsed.backpack.length / cols));
            for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
                const idx = r * cols + c;
                const item = parsed.backpack[idx];
                const slot = this.makeSlot(item, originX + c * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), slotsY + r * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), card, $98fc6d407c9f2a1f$var$COLOR.gold, $98fc6d407c9f2a1f$var$DOCK_SLOT, true);
                content.addChild(slot);
            }
        }, // ---- individual slot ----------------------------------------------------
        this.makeSlot = (item, x, y, card, accent, size = $98fc6d407c9f2a1f$var$SLOT, // Only the PLAYER'S OWN pack grid is clued. The same slot builder draws the equipped/readied
        // rows and both halves of a trade, and a campfire sitting in a chest is not the one the
        // tutorial is talking about.
        clued = false)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            slot.x = x;
            slot.y = y;
            const drawFrame = (hovered)=>{
                slot.clear();
                // inset well
                slot.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
                slot.drawRoundedRect(0, 0, size, size, 6);
                slot.endFill();
                // face
                slot.beginFill($98fc6d407c9f2a1f$var$COLOR.slotFill, item ? 0.95 : 0.4);
                slot.drawRoundedRect(2, 2, size - 4, size - 4, 5);
                slot.endFill();
                // border — accent ring for filled/active, hover highlight otherwise
                const active = !!item?.active;
                const borderColor = hovered ? $98fc6d407c9f2a1f$var$COLOR.slotHover : active ? accent : $98fc6d407c9f2a1f$var$COLOR.slotBorder;
                slot.lineStyle(active || hovered ? 2 : 1, borderColor, active || hovered ? 1 : 0.8);
                slot.drawRoundedRect(1, 1, size - 2, size - 2, 5);
                slot.lineStyle(0);
            };
            drawFrame(false);
            if (!item) return slot;
            this.modernItemMap.set(item.id, slot);
            // The fourth clue: the campfire they just made, in the pack it landed in.
            if (clued && (item.title || "").toLowerCase() === $98fc6d407c9f2a1f$var$CLUED_ITEM) this.clueAt("ember-pack", x, y, size, size);
            const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: item.spriteId,
                scale: 0.78 * size / $98fc6d407c9f2a1f$var$SLOT,
                color: 0xffffff,
                animated: false,
                rotating: false
            });
            slot.addChild(sprite);
            (0, $d634a66159f23623$export$db3e35bb56748094)(sprite, 0, 0, size);
            if (item.quantity > 1) {
                const qty = $98fc6d407c9f2a1f$var$text(`${item.quantity}`, 10, $98fc6d407c9f2a1f$var$COLOR.text, true);
                qty.x = size - qty.width - 3;
                qty.y = size - qty.height - 2;
                slot.addChild(qty);
            }
            slot.interactive = true;
            slot.cursor = "pointer";
            const onSelect = (option)=>{
                // A stack asks "how many?" in a picker over the panel instead of moving one straight away.
                if (this.openQuantityPicker(item, option)) return;
                this.logic.playerController.client.emitPlayerEvent({
                    ...option.onClickContext
                });
                if (option.closeDialog) // "Place" and friends: the panel has to get out of the way so the player can point at
                // the world. Closing here (rather than waiting for the server) also clears the dialog
                // token, so the inventory update that follows the action can't re-render the panel
                // straight back over what we just armed.
                this.guiManager.closeModal();
            };
            const reveal = ()=>{
                drawFrame(true);
                this.hideNamePill();
                card.show(item, onSelect, slot.x, slot.y, size, this.panelW, this.panelH);
            };
            // HOVER NAMES IT, CLICK OPENS IT. The card used to spring open under the pointer on its way
            // across the grid, which made simply looking at your pack feel like being interrupted. A pill
            // with the item's name answers "what is that?" without answering a question nobody asked, and
            // the menu is now something you go and get.
            slot.on((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? "tap" : "click", reveal);
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) slot.on("mouseover", ()=>{
                drawFrame(true);
                this.showNamePill(item.title, slot.x, slot.y, size);
            });
            slot.on("mouseout", ()=>{
                drawFrame(false);
                this.hideNamePill();
                // The card still closes on its own terms: it has its own hover grace period, so travelling
                // from the slot to the menu that just opened does not shut it (see ModernDetailCard).
                card.scheduleHide();
            });
            return slot;
        }, // =========================================================================
        // CRAFTING — a paginated recipe browser + the player's materials. Reuses this
        // same modal (opened from the inventory's Craft button).
        // =========================================================================
        this.emit = (event)=>{
            if (event) this.logic.playerController.client.emitPlayerEvent(event);
        }, this.parseCrafting = (message)=>{
            const inv = this.parse(message);
            const result = {
                materials: [
                    ...inv.readied,
                    ...inv.backpack
                ],
                tabs: [],
                recipes: [],
                headerActions: [],
                empty: false
            };
            const top = (message.dynamicText || []).map($98fc6d407c9f2a1f$var$asMeta).filter(Boolean);
            // The craftable browser is the top-level container holding recipe rows (a "Craft" button
            // descendant) or the "None" placeholder when nothing is craftable.
            const craftable = top.find((n)=>n.type === "container" && ($98fc6d407c9f2a1f$var$hasDescendantText(n, "Craft") || $98fc6d407c9f2a1f$var$hasDescendantText(n, "None")));
            // Header actions (e.g. "Inventory") — button|dynamic buttons OUTSIDE the browser, so we don't
            // scoop up each recipe's Craft button.
            top.forEach((n)=>{
                if (n === craftable) return;
                const collect = (node)=>{
                    if (node.type === "button|dynamic" && node.clickEventEmitter && node.text !== "Craft") result.headerActions.push({
                        text: node.text,
                        event: node.clickEventEmitter
                    });
                    (node.children || []).forEach(collect);
                };
                collect(n);
            });
            if (!craftable) {
                result.empty = true;
                return result;
            }
            const children = craftable.children || [];
            // First pass: category/subcategory chips and the paginator (both are containers).
            children.forEach((child)=>{
                if (child.type !== "container") return;
                if ($98fc6d407c9f2a1f$var$hasPageLabel(child)) {
                    const pagination = {
                        label: ""
                    };
                    (child.children || []).forEach((p)=>{
                        if (p.text === "<") pagination.leftEvent = p.clickEventEmitter;
                        else if (p.text === ">") pagination.rightEvent = p.clickEventEmitter;
                        else if ($98fc6d407c9f2a1f$var$PAGE_LABEL.test(p.text || "")) pagination.label = p.text;
                    });
                    result.pagination = pagination;
                } else (child.children || []).forEach((tab)=>{
                    if (tab.clickEventEmitter) {
                        const selected = tab.color === 0x00ff00 || (tab.textDecorations || []).includes("underline");
                        result.tabs.push({
                            label: tab.text,
                            selected: selected,
                            event: tab.clickEventEmitter
                        });
                    }
                });
            });
            // Second pass: recipe rows are a flat sequence of [Craft button, icon sprite, name text, spacer].
            let cur = null;
            children.forEach((child)=>{
                if (child.type === "button|dynamic" && child.text === "Craft") {
                    cur = {
                        name: "",
                        ingredients: [],
                        enabled: !!child.clickEventEmitter && !(child.textDecorations || []).includes("disabled"),
                        event: child.clickEventEmitter,
                        disabledReason: child.hoverText
                    };
                    result.recipes.push(cur);
                } else if (cur && child.type === "sprite") cur.spriteId = child.spriteId;
                else if (cur && child.text && child.text.trim() !== "" && child.text !== "Craft") {
                    if (!cur.name) {
                        cur.name = child.text;
                        // hoverText[0] repeats the item name; the rest are the recipe's ingredients.
                        cur.ingredients = (child.hoverText || []).slice(1);
                    }
                }
            });
            result.empty = result.recipes.length === 0;
            return result;
        }, this.createCraftingContent = ()=>this.assemble((body)=>{
                const parsed = this.parseCrafting(this.message);
                const detailCard = this.clueOnDetailCard(new $98fc6d407c9f2a1f$var$ModernDetailCard());
                this.drawCraftingTitleBar(body, parsed);
                // Single narrow column: tabs → pagination → recipe rows, with the player's backpack
                // underneath — the materials every recipe draws from, laid out like the chest/trade
                // screen's grids so an ingredient line can be checked against what's actually in the pack.
                let y = 48;
                y = this.drawTabs(body, parsed, 16, y, this.panelW - 16);
                y = this.drawPagination(body, parsed, 16, y);
                // Both halves are sized together: the recipe rows compress to make room for the backpack,
                // which in turn picks the largest slots that fit in what the rows leave behind.
                const layout = (0, $a5a3df2f3994c840$export$cad70a0e6e8fa48e)({
                    topY: y,
                    bottomY: $98fc6d407c9f2a1f$var$DOCK_H - $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD,
                    innerW: this.panelW - 32,
                    recipeCount: parsed.empty ? 0 : parsed.recipes.length,
                    itemCount: parsed.materials.length
                });
                this.drawRecipes(body, parsed, 16, y, this.panelW - 16, layout.cardH);
                this.drawCraftingBackpack(body, parsed, detailCard, layout);
                // Detail card last so a hovered material's menu draws above the slots.
                body.addChild(detailCard);
            }), // The player's own pack, pinned below the recipe list. Hovering a slot surfaces the same item
        // menu the inventory screen gives it, so materials can be readied or dropped without leaving.
        this.drawCraftingBackpack = (content, parsed, card, layout)=>{
            const originX = 16;
            const { slot: slot, cols: cols, rows: rows, gap: gap, hidden: hidden } = layout.grid;
            this.sectionLabel(content, "Backpack", originX, layout.labelY, hidden > 0 ? `+${hidden} more` : undefined);
            for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
                const item = parsed.materials[r * cols + c];
                content.addChild(this.makeSlot(item, originX + c * (slot + gap), layout.gridY + r * (slot + gap), card, $98fc6d407c9f2a1f$var$COLOR.gold, slot, true));
            }
        }, this.drawCraftingTitleBar = (content, parsed)=>{
            const title = $98fc6d407c9f2a1f$var$text("CRAFTING", 17, $98fc6d407c9f2a1f$var$COLOR.gold, true);
            title.x = 16;
            title.y = 13;
            content.addChild(title);
            content.lineStyle(2, $98fc6d407c9f2a1f$var$COLOR.gold, 0.7);
            content.moveTo(16, 40);
            content.lineTo(this.panelW - 16, 40);
            content.lineStyle(0);
            // Header action (e.g. "Inventory") — top-right at the margin, the close button having moved
            // out onto the panel's corner.
            let bx = this.panelW - 16;
            parsed.headerActions.forEach((action)=>{
                const btnW = 82;
                const button = $98fc6d407c9f2a1f$var$makeButton(action.text, btnW, 24, ()=>this.emit(action.event));
                bx -= btnW;
                button.x = bx;
                button.y = 11;
                content.addChild(button);
                bx -= 6;
            });
        }, this.drawTabs = (content, parsed, x, y, right)=>{
            if (parsed.tabs.length === 0) return y;
            const h = 24;
            const padX = 10;
            let cx = x;
            let cy = y;
            parsed.tabs.forEach((tab)=>{
                const label = $98fc6d407c9f2a1f$var$text($98fc6d407c9f2a1f$var$prettify(tab.label), 12, tab.selected ? $98fc6d407c9f2a1f$var$COLOR.panelFill : $98fc6d407c9f2a1f$var$COLOR.text, tab.selected);
                const w = label.width + padX * 2;
                if (cx + w > right) {
                    cx = x;
                    cy += h + 6;
                }
                const chip = new (0, $gwPoJ.Graphics)();
                chip.x = cx;
                chip.y = cy;
                chip.beginFill(tab.selected ? $98fc6d407c9f2a1f$var$COLOR.gold : $98fc6d407c9f2a1f$var$COLOR.slotFill, 1);
                chip.lineStyle(1, tab.selected ? $98fc6d407c9f2a1f$var$COLOR.gold : $98fc6d407c9f2a1f$var$COLOR.slotBorder, 1);
                chip.drawRoundedRect(0, 0, w, h, 6);
                chip.endFill();
                chip.lineStyle(0);
                label.x = padX;
                label.y = (h - label.height) / 2;
                chip.addChild(label);
                if (tab.event) {
                    chip.interactive = true;
                    chip.cursor = "pointer";
                    chip.on("click", ()=>this.emit(tab.event));
                    chip.on("tap", ()=>this.emit(tab.event));
                }
                content.addChild(chip);
                cx += w + 6;
            });
            return cy + h + 10;
        }, this.drawPagination = (content, parsed, x, y)=>{
            if (!parsed.pagination) return y;
            const { label: label, leftEvent: leftEvent, rightEvent: rightEvent } = parsed.pagination;
            const left = $98fc6d407c9f2a1f$var$makeButton("<", 30, 24, ()=>this.emit(leftEvent));
            left.x = x;
            left.y = y;
            content.addChild(left);
            const lbl = $98fc6d407c9f2a1f$var$text(label, 12, $98fc6d407c9f2a1f$var$COLOR.textMuted);
            lbl.x = x + 40;
            lbl.y = y + 5;
            content.addChild(lbl);
            const right = $98fc6d407c9f2a1f$var$makeButton(">", 30, 24, ()=>this.emit(rightEvent));
            right.x = x + 40 + lbl.width + 10;
            right.y = y;
            content.addChild(right);
            return y + 32;
        }, this.drawRecipes = (content, parsed, x, y, right, cardH)=>{
            if (parsed.empty) {
                const msg = $98fc6d407c9f2a1f$var$text("No recipes available yet.", 12, $98fc6d407c9f2a1f$var$COLOR.textMuted);
                msg.x = x;
                msg.y = y + 6;
                content.addChild(msg);
                return;
            }
            // One compact row per recipe, stacked between the paginator and the backpack grid. The height
            // comes from craftingLayout, which shares the panel out between the two.
            const cardW = right - x;
            parsed.recipes.forEach((recipe, i)=>{
                this.drawRecipeCard(content, recipe, x, y + i * (cardH + (0, $a5a3df2f3994c840$export$b6095232b96cb2d5)), cardW, cardH);
            });
        }, this.drawRecipeCard = (content, recipe, x, y, w, h)=>{
            const enabled = recipe.enabled;
            const card = new (0, $gwPoJ.Graphics)();
            card.x = x;
            card.y = y;
            card.beginFill($98fc6d407c9f2a1f$var$COLOR.slotFill, enabled ? 0.95 : 0.5);
            card.lineStyle(1, enabled ? $98fc6d407c9f2a1f$var$COLOR.panelBorder : $98fc6d407c9f2a1f$var$COLOR.slotBorder, 1);
            card.drawRoundedRect(0, 0, w, h, 8);
            card.endFill();
            card.lineStyle(0);
            content.addChild(card);
            // Square icon well filling the card height. The padding tracks the card height so a card
            // compressed to make room for the backpack still holds both text lines (name + ingredients).
            const pad = Math.max(4, Math.round((h - 34) / 2));
            const iconSize = h - pad * 2;
            card.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
            card.drawRoundedRect(pad, pad, iconSize, iconSize, 6);
            card.endFill();
            if (recipe.spriteId) {
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: recipe.spriteId,
                    scale: iconSize / 52 * 0.95,
                    color: enabled ? 0xffffff : 0x9aa0ad,
                    animated: false,
                    rotating: false
                });
                card.addChild(sprite);
                (0, $d634a66159f23623$export$db3e35bb56748094)(sprite, pad, pad, iconSize);
            }
            const btnW = 64;
            const btnH = 24;
            const btnX = w - btnW - pad;
            const btnY = (h - btnH) / 2;
            const textX = pad + iconSize + 10;
            const name = $98fc6d407c9f2a1f$var$text($98fc6d407c9f2a1f$var$prettify(recipe.name), 13, enabled ? $98fc6d407c9f2a1f$var$COLOR.text : $98fc6d407c9f2a1f$var$COLOR.textMuted, true);
            name.x = textX;
            name.y = pad;
            card.addChild(name);
            // Second line: ingredients when craftable, or the reason it isn't (in red).
            const reason = !enabled ? recipe.disabledReason?.find((r)=>r.startsWith("-"))?.replace(/^-\s*/, "need ") || recipe.disabledReason?.[0] : undefined;
            const line = reason || recipe.ingredients.join(",  ");
            if (line) {
                const t = $98fc6d407c9f2a1f$var$text(line, 10, reason ? 0xd98a8a : $98fc6d407c9f2a1f$var$COLOR.textMuted);
                t.x = textX;
                // Hung off the name's own height rather than a fixed offset — a compressed card has no
                // spare pixels to lose to a guessed line height.
                t.y = name.y + name.height + 1;
                card.addChild(t);
            }
            // The campfire row is the third clue in the ember tutorial's chain. Reported whether or not the
            // button is live: a greyed row with "need 2 wood" on it is still the row they are looking for.
            if ((recipe.name || "").toLowerCase() === $98fc6d407c9f2a1f$var$CLUED_ITEM) this.clueAt("ember-recipe", x + btnX, y + btnY, btnW, btnH);
            // Craft button (enabled) or a grayed placeholder (disabled).
            if (enabled) {
                const craftBtn = $98fc6d407c9f2a1f$var$makeButton("Craft", btnW, btnH, ()=>this.emit(recipe.event));
                craftBtn.x = btnX;
                craftBtn.y = btnY;
                card.addChild(craftBtn);
            } else {
                const disabled = new (0, $gwPoJ.Graphics)();
                disabled.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 0.8);
                disabled.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.slotBorder, 1);
                disabled.drawRoundedRect(0, 0, btnW, btnH, 5);
                disabled.endFill();
                disabled.lineStyle(0);
                const dl = $98fc6d407c9f2a1f$var$text("Craft", 11, $98fc6d407c9f2a1f$var$COLOR.textMuted);
                dl.x = (btnW - dl.width) / 2;
                dl.y = (btnH - dl.height) / 2;
                disabled.addChild(dl);
                disabled.x = btnX;
                disabled.y = btnY;
                card.addChild(disabled);
            }
        }, // =========================================================================
        // TRANSFER — two side-by-side inventories (chest / trade). Each item carries
        // its own Take / Give options; hovering a slot surfaces them.
        // =========================================================================
        this.parseTrade = (message)=>{
            const left = {
                items: [],
                statLines: []
            };
            const right = {
                items: [],
                statLines: []
            };
            const headerActions = [];
            const collect = (node, side)=>{
                if (node.type === "grid") side.items.push(...node.context?.gridMeta || []);
                else if (node.type === "entity") {
                    if (!side.entity) side.entity = {
                        entityId: node.context?.entityId,
                        appearance: node.context?.appearance,
                        inventory: node.context?.inventory
                    };
                } else if (node.type === "sprite" && node.spriteId && node.spriteId !== "action-trade.png") {
                    if (!side.spriteId) side.spriteId = node.spriteId;
                } else if (node.type === "button|dynamic" && node.clickEventEmitter) headerActions.push({
                    text: node.text,
                    event: node.clickEventEmitter
                });
                else if (node.font === "ImportantFont" && node.text) {
                    if (!side.name) side.name = node.text;
                } else if (node.text && /^(Level|HP:|Speed:|Defense:|Mana)/.test(node.text)) side.statLines.push(node.text);
                (node.children || []).forEach((c)=>collect(c, side));
            };
            (message.dynamicText || []).map($98fc6d407c9f2a1f$var$asMeta).filter(Boolean).forEach((node)=>{
                if (node.type === "sprite" && node.spriteId === "action-trade.png") return;
                // The server positions the target (chest) on the left and the origin (player) on the
                // right; bucket every node by its x anchor.
                const x = node.exactLocation?.x ?? 0;
                collect(node, x < 350 ? left : right);
            });
            return {
                left: left,
                right: right,
                headerActions: headerActions
            };
        }, this.createTradeContent = ()=>this.assemble((body)=>{
                const parsed = this.parseTrade(this.message);
                const card = new $98fc6d407c9f2a1f$var$ModernDetailCard();
                // Header action (e.g. "Inventory" when trading with a humanoid) top-right at the margin.
                let bx = this.panelW - 16;
                parsed.headerActions.forEach((action)=>{
                    const btnW = 82;
                    const button = $98fc6d407c9f2a1f$var$makeButton(action.text, btnW, 24, ()=>this.emit(action.event));
                    bx -= btnW;
                    button.x = bx;
                    button.y = 11;
                    body.addChild(button);
                    bx -= 6;
                });
                // Two inventories stacked vertically: target (chest) on top, player below, with a
                // transfer arrow between them (generous padding above and below). Each hovered item still
                // surfaces its Take/Give options.
                let y = 14;
                y = this.drawTradeSection(body, parsed.left, y, card, $98fc6d407c9f2a1f$var$COLOR.gold);
                this.drawTradeArrow(body, this.panelW / 2, y + 24);
                y += 48;
                this.drawTradeSection(body, parsed.right, y, card, $98fc6d407c9f2a1f$var$COLOR.blue);
                body.addChild(card);
            }), // One stacked inventory: [thumbnail][name (+ compact stats)] header, then a grid of its items.
        this.drawTradeSection = (content, side, y, card, accent)=>{
            const margin = 16;
            const thumb = 40;
            this.drawTradeThumb(content, side, margin, y, thumb);
            const nameX = margin + thumb + 10;
            const name = $98fc6d407c9f2a1f$var$text(side.name || "", 15, $98fc6d407c9f2a1f$var$COLOR.gold, true);
            name.x = nameX;
            name.y = y + 2;
            content.addChild(name);
            // Compact Level · HP line for humanoid sides (chests have no stats).
            const lvl = side.statLines.find((l)=>l.startsWith("Level"))?.replace("Level ", "Lvl ");
            const hp = side.statLines.find((l)=>l.startsWith("HP:"))?.replace("HP: ", "HP ").replace(/\s*\/\s*/, "/");
            const statLine = [
                lvl,
                hp
            ].filter(Boolean).join("   \xb7   ");
            if (statLine) {
                const s = $98fc6d407c9f2a1f$var$text(statLine, 11, $98fc6d407c9f2a1f$var$COLOR.textMuted);
                s.x = nameX;
                s.y = y + 22;
                content.addChild(s);
            }
            // Item grid.
            const gridY = y + thumb + 8;
            const cols = 8;
            const gap = 4;
            const rows = Math.max(2, Math.ceil(side.items.length / cols));
            for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
                const item = side.items[r * cols + c];
                const slot = this.makeSlot(item, margin + c * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), gridY + r * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), card, accent, $98fc6d407c9f2a1f$var$DOCK_SLOT);
                content.addChild(slot);
            }
            return gridY + rows * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap);
        }, // Small framed thumbnail: the player's portrait, or a chest's item sprite.
        this.drawTradeThumb = (content, side, x, y, size)=>{
            content.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 0.85);
            content.lineStyle(1, $98fc6d407c9f2a1f$var$COLOR.panelBorder, 1);
            content.drawRoundedRect(x, y, size, size, 6);
            content.endFill();
            content.lineStyle(0);
            if (side.entity?.appearance || side.entity?.inventory) {
                const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                entity.weapon = {
                    weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(side.entity.inventory, "weapon")?.type
                };
                entity.appearance = side.entity.appearance;
                entity.inventory = side.entity.inventory;
                const displayer = new (0, $c14ea609224dd88d$export$982d39230018c180)({
                    entityId: side.entity.entityId,
                    scale: 1.4
                }, entity);
                const portrait = displayer.createContent();
                content.addChild(portrait);
                const b = portrait.getLocalBounds();
                if (b.width > 0 && b.height > 0) {
                    const fit = Math.min((size - 6) / b.width, (size - 6) / b.height, 1);
                    portrait.scale.set(fit);
                    portrait.x = x + (size - b.width * fit) / 2 - b.x * fit;
                    portrait.y = y + (size - b.height * fit) / 2 - b.y * fit;
                }
            } else if (side.spriteId) {
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: side.spriteId,
                    scale: 0.9,
                    color: 0xffffff,
                    animated: false,
                    rotating: false
                });
                content.addChild(sprite);
                (0, $d634a66159f23623$export$db3e35bb56748094)(sprite, x, y, size);
            }
        }, // Vertical double-headed arrow between the two stacked inventories.
        this.drawTradeArrow = (content, cx, cy)=>{
            content.lineStyle(3, $98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
            content.moveTo(cx, cy - 7);
            content.lineTo(cx, cy + 7);
            content.lineStyle(0);
            content.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
            content.drawPolygon([
                cx,
                cy - 10,
                cx - 6,
                cy - 2,
                cx + 6,
                cy - 2
            ]);
            content.drawPolygon([
                cx,
                cy + 10,
                cx - 6,
                cy + 2,
                cx + 6,
                cy + 2
            ]);
            content.endFill();
        };
        this.panelW = $98fc6d407c9f2a1f$var$DOCK_W;
        this.panelH = $98fc6d407c9f2a1f$var$DOCK_H;
        this.dockX = $98fc6d407c9f2a1f$var$DOCK_X;
        // Closing the screen out from under an open picker (close button, Escape, a room change) has
        // to hand the keyboard back. DynamicDialog has already installed onClose by the time this
        // runs, so wrap whatever it set.
        const inherited = this.onClose;
        this.onClose = (clicked)=>{
            this.dismissQuantityPicker();
            // The clued controls go off screen with the panel. The clues stay ARMED (reopening the pack
            // puts them back) but nothing is left pointing at a control that isn't there.
            this.retractClues();
            if (inherited) inherited(clicked);
        };
    }
}





parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");




const $9fb9be6d4b9a07da$export$1d2a07e77e913156 = 58;
const $9fb9be6d4b9a07da$var$SLOT_HIT_RADIUS = 27;
class $9fb9be6d4b9a07da$export$ae188dfa452708ef extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.renderSlot = (label, spriteMeta, selected, callback, amt)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            const item = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)(spriteMeta);
            slot.addChild(item);
            // One uniform, circular press target per slot, rather than each item's own sprite bounds.
            //
            // Hanging the handler off the sprite made a slot exactly as easy to hit as its art is big:
            // a shield filled the slot and a dagger was a few pixels of blade on the diagonal, so the
            // same gesture picked one reliably and missed the other. Which item is in a slot should not
            // change how hard it is to select. A circle rather than a box because the slot READS as a
            // circle -- that is the shape the selected highlight draws -- so the target matches what is
            // on screen, and a corner tap that looks outside the slot does not select it.
            //
            // Sits outside the highlight's own radius but inside half the slot pitch, so neighbouring
            // targets cannot overlap and steal each other's taps.
            slot.interactive = true;
            slot.cursor = "pointer";
            slot.hitArea = new (0, $6qzqq.Circle)(0, 0, $9fb9be6d4b9a07da$var$SLOT_HIT_RADIUS);
            slot.on("pointerdown", callback);
            if (amt !== undefined) {
                const amtLabel = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(`${amt}`, {
                    font: "ChatFont"
                });
                amtLabel.y = 5;
                slot.addChild(amtLabel);
            }
            const labelObject = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(label);
            labelObject.x = -20;
            labelObject.y = -30;
            if (selected) {
                labelObject.tint = 0x00ff00;
                slot.beginFill(0x00ff00, 0.25);
                slot.drawCircle(0, 0, 15);
                slot.endFill();
            }
            slot.addChild(labelObject);
            return slot;
        }, this.update = (inventory, slotCallback)=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            const baseMeta = {
                animated: false,
                color: 0xffffff,
                name: "",
                scale: 1.0
            };
            const slotCallbacks = {};
            inventory.items?.filter((item)=>(0, $cb689cfa16c444ba$export$6e47733a887561b3)[item.itemType]?.slotVisible && item.readied).map((item, i)=>{
                const { itemType: itemType } = item;
                const scale = 1;
                const name = item.itemTypeMeta.spriteId || `${item.itemTypeMeta.type}-${item.itemTypeMeta.color}.png`;
                const shortcutKey = `${i + 1}`;
                const callback = ()=>slotCallback(item.id);
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: item.active ? 0x00ff00 : baseMeta.color,
                    name: name,
                    scale: scale
                }, item.active, callback, item.quantity > 0 ? item.quantity : undefined);
                slotCallbacks[i + 1] = callback;
                slot.x = i * $9fb9be6d4b9a07da$export$1d2a07e77e913156;
                this.addChild(slot);
            });
            return slotCallbacks;
        };
        this.guiManager = guiManager;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $91106b3dea6906a4$export$6386e5268de7fe1f extends (0, $gwPoJ.Graphics) {
    constructor(gui){
        super(), this.remove = ()=>{
            if (this.surface) {
                this.fader?.stop();
                this.removeChild(this.surface);
            }
        }, this.setup = (screenMessage)=>{
            if (screenMessage.action === "close") {
                if (this.surface) {
                    this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.surface, {
                        fadeInterval: 5,
                        releaseCallback: ()=>{
                            this.removeChild(this.surface);
                        }
                    });
                    this.fader.update();
                }
                return;
            }
            if (this.surface) {
                this.fader?.stop();
                this.removeChild(this.surface);
            }
            this.surface = (0, $95fcf006ca17068b$export$97a92ac594e41d5f).createContent(this.gui.logic, screenMessage, this.width, [], {
                backdrop: true
            });
            this.surface.x = -150;
            this.addChild(this.surface);
            const interval = setInterval(()=>{
                this.surface.x += 5;
                if (this.surface.x >= 0) {
                    this.surface.x = 0;
                    clearInterval(interval);
                }
            }, 10);
        };
        this.gui = gui;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

var $8JEKL = parcelRequire("8JEKL");

const $95442441126989b8$var$MODAL_WIDTH = 400;
const $95442441126989b8$var$MODAL_HEIGHT = 340;
class $95442441126989b8$export$175e500a48a60fd2 {
    constructor(guiManager, props){
        this.fields = [];
        this.feedbackText = "";
        this.emailText = "";
        this.setup = ()=>{
            this.surface.clear();
            this.modal = this.guiManager.createModal({
                padding: 0,
                width: $95442441126989b8$var$MODAL_WIDTH,
                height: $95442441126989b8$var$MODAL_HEIGHT,
                content: this.surface,
                center: true,
                closeCallback: ()=>{
                    this.fields.forEach((field)=>field.destroy());
                    this.fields = [];
                }
            });
            this.renderForm();
        };
        this.renderForm = ()=>{
            const fieldWidth = $95442441126989b8$var$MODAL_WIDTH - 40;
            const title = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("Feedback - what do you think of this game?");
            title.x = 20, title.y = 10, this.surface.addChild(title);
            const feedback = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                input: {
                    fontFamily: "Arial",
                    fontSize: "10pt",
                    lineHeight: "13px",
                    padding: "10px 12px",
                    color: "#26272E",
                    multiline: true,
                    width: `${fieldWidth}px`,
                    height: `${fieldWidth / 2}px`
                },
                box: {
                    default: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xcbcee0,
                            width: 2
                        }
                    },
                    focused: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xabafc6,
                            width: 2
                        }
                    },
                    disabled: {
                        fill: 0xdbdbdb,
                        rounded: 10
                    }
                }
            });
            feedback.on("focus", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(false);
            });
            feedback.on("blur", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(true);
            });
            feedback.x = 20;
            feedback.y = 40;
            feedback.placeHolder = "What do you think of this game?";
            feedback.placeholderColor = 0x000000;
            feedback.on("input", (text)=>{
                this.feedbackText = text;
            });
            this.fields.push(feedback);
            this.surface.addChild(feedback);
            feedback.focus();
            const emailField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                input: {
                    fontFamily: "Arial",
                    fontSize: "10pt",
                    lineHeight: "13px",
                    padding: "10px 12px",
                    color: "#26272E",
                    multiline: false,
                    width: `${fieldWidth}px`
                },
                box: {
                    default: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xcbcee0,
                            width: 2
                        }
                    },
                    focused: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xabafc6,
                            width: 2
                        }
                    },
                    disabled: {
                        fill: 0xdbdbdb,
                        rounded: 10
                    }
                }
            });
            emailField.x = 20;
            emailField.y = feedback.y + feedback.height + 20;
            emailField.placeholderColor = 0x000000;
            emailField.placeholder = "Your email address (optional)";
            emailField.on("input", (text)=>{
                this.emailText = text;
            });
            emailField.on("focus", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(false);
            });
            emailField.on("blur", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(true);
            });
            this.surface.addChild(emailField);
            const submitButton = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("Submit", {
                type: "button|dynamic",
                onClick: ()=>{
                    this.props?.onSubmit({
                        feedback: this.feedbackText,
                        email: this.emailText
                    });
                    this.modal.close();
                }
            });
            submitButton.x = 20, submitButton.y = $95442441126989b8$var$MODAL_HEIGHT - submitButton.height - 10;
            this.fields.push(emailField);
            this.surface.addChild(submitButton);
        };
        this.guiManager = guiManager;
        this.props = props;
        this.surface = new (0, $gwPoJ.Graphics)();
    }
}







class $7ce197e6bf5d40c1$export$1be7516c0280bee8 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager){
        super(guiManager), this.createContent = ()=>{
            const textBlock = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            textBlock.append2("").append2("");
            $7ce197e6bf5d40c1$export$1be7516c0280bee8.attachHelp(textBlock);
            const media = this.guiManager.socialMedia();
            textBlock.append2(media, {
                exactLocation: {
                    x: 0,
                    y: (0, $7dd73ecdd94bfe01$export$84e1549b474f1b93) - media.height - 10
                }
            });
            return textBlock;
        };
    }
    static{
        this.attachHelp = (textBlock)=>{
            (0, $9232cedf236eccda$export$37a7ec870b628d38).forEach((entry, i)=>{
                const block = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
                block.append2(new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(0xffa500).bold().render(entry.title)).append2(new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(entry.body));
                textBlock.append2(block, i > 0 ? {
                    topMargin: 8
                } : undefined);
            });
        };
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $9b7bf4301258d7f9$export$7332475dd933238a extends (0, $gwPoJ.Graphics) {
    constructor(iconBase, max){
        super(), this.update = (amt)=>{
            if (this.max < 1) return;
            if (amt === this.current) return;
            this.current = amt;
            this.removeChildren();
            // this.clear()
            const amtToUse = amt / 2;
            if (amtToUse < 2) {
                if (!this.pulser) this.pulser = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(this, {
                    permanent: true,
                    blinkInterval: 25,
                    releaseCallback: ()=>{
                        this.alpha = 1.0;
                    }
                });
                this.pulser.update();
            } else this.pulser?.stop();
            for(let i = 0; i < Math.floor(this.max / 2); i++){
                const level = i > amtToUse ? "empty" : i === Math.floor(amtToUse) ? amtToUse % 1 === 0 ? "empty" : "half" : "full";
                const iconFull = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: `${this.iconBase}-${level}.png`,
                    scale: 1.0
                });
                iconFull.x = i * iconFull.width + 3;
                iconFull.y = iconFull.height / 2 + 2;
                this.addChild(iconFull);
            }
        };
        this.iconBase = iconBase;
        this.max = max;
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");




// An "important" notice, rendered as a calm ambient strip: a thin translucent band near
// the top of the screen whose left/right edges fade to nothing. It fades in, holds long
// enough to read, then fades out. Deliberately NOT a hard black slab that pops in and
// shrinks away — that read as an alarm (and the shrink looked buggy). The point is to be
// noticed without blocking the game behind it.
const $a7b6262714ec8487$var$STRIP_TOP_Y = 40 // distance from the top of the screen to the top of the strip
;
const $a7b6262714ec8487$var$VERTICAL_PADDING = 12 // space above/below the text inside the strip
;
const $a7b6262714ec8487$var$STRIP_ALPHA = 0.5 // center opacity of the strip; low so the game stays visible behind it
;
class $a7b6262714ec8487$export$b3ee1e8559ec7f0c extends (0, $gwPoJ.Graphics) {
    constructor(color = 0xffffff, screenMessage){
        super(), this.bannerText = null, this.background = null, this.fadeInFader = null, this.fadeOutFader = null, this.holdTimer = null, this.displayCallback = null, // The strip spans the full visible width, which never changes (ScreenDimensions is
        // fixed and the stage is scaled to fit), so the gradient texture is built once and reused.
        this.gradientTexture = null, // Same full width hero_message uses (the visible viewport is wider than the 640 play area).
        this.stripWidth = ()=>(0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7, this.update = (message)=>{
            const { text: text, duration: duration, displayCallback: displayCallback } = message;
            this.displayCallback = displayCallback || null;
            // Interrupt any in-flight fade/hold so a newer message shows cleanly.
            this.stopAnimations();
            this.removeChildren();
            const width = this.stripWidth();
            const bannerText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("ImportantFont").color(this.color).align("center").render(text);
            this.bannerText = bannerText;
            const stripHeight = bannerText.height + $a7b6262714ec8487$var$VERTICAL_PADDING * 2;
            // Background gradient strip (built once, reused thereafter).
            if (!this.gradientTexture) this.gradientTexture = (0, $7dcf9acc2579c643$export$4a423b5b028a4cfb)(width, stripHeight, $a7b6262714ec8487$var$STRIP_ALPHA);
            const background = new (0, $7Bs2Z.Sprite)(this.gradientTexture);
            background.x = 0;
            background.y = $a7b6262714ec8487$var$STRIP_TOP_Y;
            background.width = width;
            background.height = stripHeight;
            if (this.gradientTexture === (0, $klOfb.Texture).WHITE) {
                // Fallback path (no 2D canvas): tint + alpha the flat texture so it still reads as a dark strip.
                background.tint = 0x000000;
                background.alpha = $a7b6262714ec8487$var$STRIP_ALPHA;
            }
            this.background = background;
            this.addChild(background);
            // Text centered horizontally across the full width, vertically within the strip.
            bannerText.x = width / 2 - bannerText.width / 2;
            bannerText.y = $a7b6262714ec8487$var$STRIP_TOP_Y + (stripHeight - bannerText.height) / 2;
            this.addChild(bannerText);
            // Hold time scales gently with message length (min 1.5s) so there's time to read it.
            const wordCount = text.split(" ").length;
            const holdMs = duration || Math.max(1500, wordCount * 300);
            // Fade in -> hold -> fade out. No pop-in, no shrink-to-zero.
            this.visible = true;
            this.alpha = 0.0;
            this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "in",
                minAlpha: 1.0,
                fadeInterval: 5,
                fadeAlphaDecrement: 0.025,
                releaseCallback: ()=>{
                    this.fadeInFader = null;
                    this.holdTimer = setTimeout(()=>{
                        this.holdTimer = null;
                        this.startFadeOut();
                    }, holdMs);
                }
            });
            this.fadeInFader.update();
        }, this.startFadeOut = ()=>{
            this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "out",
                minAlpha: 0.0,
                fadeInterval: 10,
                fadeAlphaDecrement: 0.025,
                releaseCallback: ()=>{
                    this.fadeOutFader = null;
                    this.visible = false;
                    this.alpha = 1.0;
                    this.removeChildren();
                    if (this.displayCallback) {
                        this.displayCallback();
                        this.displayCallback = null;
                    }
                }
            });
            this.fadeOutFader.update();
        }, this.stopAnimations = ()=>{
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
            }
            if (this.fadeOutFader) {
                this.fadeOutFader.stop(true);
                this.fadeOutFader = null;
            }
            if (this.holdTimer) {
                clearTimeout(this.holdTimer);
                this.holdTimer = null;
            }
        }, // Mirrors HeroMessage.destroy: tear down timers/faders so nothing fires against a dead Graphics.
        this.destroy = ()=>{
            this.stopAnimations();
            this.removeChildren();
            this.visible = false;
            this.alpha = 1.0;
        };
        this.color = color;
        this.screenMessage = screenMessage;
        this.visible = false;
        this.zIndex = 55000 // above the rest of the HUD; below the hero banner / countdown (60000)
        ;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $hnGDn = parcelRequire("hnGDn");
class $f98cea862b8a2ca9$export$c75dedfb09f9174d extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.show = [], this.createToggles = (height, i)=>{
            if (this.toggle[i]) return;
            const toggle = new (0, $gwPoJ.Graphics)();
            this.toggle[i] = toggle;
            toggle.lineStyle(1, 0xff0000);
            // Because the array is initialized as [], we need to specifically check for undefined, not just a falsey value.
            if (this.show[i] === undefined) this.show[i] = false;
            if (!this.show[i]) {
                toggle.beginFill(0x101010);
                toggle.drawRect(0, 0, 8, 8);
                toggle.endFill();
            } else {
                toggle.beginFill(0xcc0000);
                toggle.drawRect(0, 0, 8, 8);
                toggle.endFill();
            }
            toggle.x = -15;
            toggle.y = 7 + height;
            toggle.interactive = true;
            toggle.on("mouseover", ()=>{
                this.guiManager.mouseOverControl(true);
            });
            toggle.on("mouseout", ()=>{
                this.guiManager.mouseOverControl(false);
            });
            toggle.on("mouseup", ()=>{
                this.show[i] = !this.show[i];
                this.update(this.leaderboards);
            });
            this.addChild(toggle);
        }, this.renderBoard = (boardIndex, leaderboard, pos, show)=>{
            const graphics = new (0, $gwPoJ.Graphics)();
            const name = leaderboard.name.replace("_", " ").toLowerCase().split(" ").map((n)=>{
                return n.split("").map((l, i)=>i === 0 ? l.toUpperCase() : l).join("");
            }).join(" ");
            const leaderName = leaderboard.items[0].name;
            const headerContainer = new (0, $gwPoJ.Graphics)();
            const headerText = new (0, $hnGDn.BitmapText)(`Top ${name}`, {
                fontName: "LeaderboardFont"
            });
            headerContainer.addChild(headerText);
            headerContainer.interactive = true;
            headerContainer.on("mouseover", ()=>{
                this.guiManager.mouseOverControl(true);
            });
            headerContainer.on("mouseout", ()=>{
                this.guiManager.mouseOverControl(false);
            });
            headerContainer.on("mouseup", ()=>{
                this.show[boardIndex] = !this.show[boardIndex];
                this.update(this.leaderboards);
            });
            if (!show) {
                const name = new (0, $hnGDn.BitmapText)(leaderName, {
                    fontName: "LeaderboardLeaderFont"
                });
                name.x = 175 - name.width;
                headerContainer.addChild(name);
            }
            graphics.addChild(headerContainer);
            graphics.lineStyle(1, 0x00a000);
            graphics.drawRect(0, headerText.height, 175, 1);
            let height = headerContainer.height;
            if (show) leaderboard.items.forEach((item, i)=>{
                const font = {
                    fontName: i == 0 ? "LeaderboardLeaderFont" : "LeaderboardFont"
                };
                const name = new (0, $hnGDn.BitmapText)(item.name, font);
                name.y = headerContainer.height + i * name.height + 3;
                graphics.addChild(name);
                const count = new (0, $hnGDn.BitmapText)("" + item.count, font);
                count.y = headerContainer.height + i * count.height + 3;
                count.x = graphics.width - count.width;
                graphics.addChild(count);
                height += name.height;
            });
            graphics.y = pos;
            this.addChild(graphics);
            return height + (show ? 15 : 5);
        }, this.update = (leaderboards)=>{
            this.leaderboards = leaderboards;
            this.toggle = this.leaderboards ? new Array(leaderboards.length).fill(null) : [];
            // clear all
            this.removeChildren();
            if (!leaderboards) return;
            let prevHeight = 0;
            leaderboards.sort().forEach((next, i)=>{
                this.createToggles(prevHeight, i);
                prevHeight += this.renderBoard(i, next, prevHeight, this.show[i]);
            });
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
class $fad6195fae17b303$export$62e3ae2a4090b879 extends (0, $gwPoJ.Graphics) {
    constructor(color = 0x00ff00, max, lowColor){
        super(), this.update = (amt)=>{
            const color = this.lowColor ? amt < this.max / 2 ? 0xff0000 : this.color : this.color;
            this.clear();
            for(let i = 0; i < amt; i++){
                super.lineStyle(0, color);
                super.beginFill(color);
                super.drawRoundedRect(i * 3, 2, 3, 2 + this.barHeight, 0);
                super.endFill();
            }
            super.lineStyle(1, color, 0.4);
            super.beginFill(color, 0.35);
            super.drawRoundedRect(-2, 0, this.max * 3 + 4, this.barHeight + 6, 2);
        };
        this.color = color;
        this.lowColor = lowColor;
        this.max = max;
        this.barHeight = 6;
    }
} // 0 - 3
 // 6 - 9
 // 12 - 15
 // 24 - 27
 // 30 - 33



class $6cfcddb9955aa6fe$export$10811ae595fe85fd extends (0, $gwPoJ.Graphics) {
    constructor(color = 0x00ff00, max, spriteId, lowColor){
        super(), this.update = (amt)=>{
            this.meter.update(amt);
        };
        this.max = max;
        this.meter = new (0, $fad6195fae17b303$export$62e3ae2a4090b879)(color, max, lowColor);
        const icon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            name: spriteId || "stamina.png",
            scale: 0.9
        });
        icon.y = icon.height / 2 + 1;
        this.addChild(icon);
        this.meter.x = 13;
        this.addChild(this.meter);
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");

// Shared circular close button for dialogs/modals. It replaces the bare "x" glyph the Dialog used to
// drop in the top-right corner: a dark disc with a light rim and a stroked X, drawn CENTERED ON ITS
// OWN ORIGIN so a caller can pin it straight onto a panel corner and let it hang over the edge.
//
// Bigger under a thumb. The stage is a fixed 640x360 letterboxed into whatever the device gives us,
// so on a phone one stage pixel is well under one CSS pixel: an 11px disc lands at roughly 14 CSS
// px across, against the ~44px a touch target wants. It is drawn from its radius and hangs off a
// corner, so growing it costs no layout anywhere.
const $e59d4eca9b366180$var$DESKTOP_RADIUS = 11;
const $e59d4eca9b366180$var$TOUCH_RADIUS = 17;
const $e59d4eca9b366180$export$dc3c988e71114e28 = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? $e59d4eca9b366180$var$TOUCH_RADIUS : $e59d4eca9b366180$var$DESKTOP_RADIUS;
const $e59d4eca9b366180$var$RIM = 0x8d97ad;
const $e59d4eca9b366180$var$RIM_HOVER = 0xd9a441 // gold, matching the inventory/crafting panel accent
;
const $e59d4eca9b366180$var$FILL = 0x1b2030;
const $e59d4eca9b366180$var$FILL_HOVER = 0x2f3648;
const $e59d4eca9b366180$var$GLYPH = 0xe6e9f0;
const $e59d4eca9b366180$var$GLYPH_HOVER = 0xffe6b0;
class $e59d4eca9b366180$export$de65de8213222d10 extends (0, $gwPoJ.Graphics) {
    constructor({ radius: radius = $e59d4eca9b366180$export$dc3c988e71114e28, onClick: onClick } = {}){
        super(), this.draw = (hover)=>{
            const r = this.radius;
            this.clear();
            // Fake drop shadow -- an offset dark disc behind, rather than a filter (see the budget
            // hardware target: filters cost a render pass per instance).
            this.lineStyle(0);
            this.beginFill(0x000000, 0.35);
            this.drawCircle(0, 1.5, r);
            this.endFill();
            this.lineStyle({
                width: 2,
                color: hover ? $e59d4eca9b366180$var$RIM_HOVER : $e59d4eca9b366180$var$RIM,
                alpha: 1
            });
            this.beginFill(hover ? $e59d4eca9b366180$var$FILL_HOVER : $e59d4eca9b366180$var$FILL, 0.98);
            this.drawCircle(0, 0, r);
            this.endFill();
            const arm = r * 0.4;
            this.lineStyle({
                width: Math.max(2, r * 0.19),
                color: hover ? $e59d4eca9b366180$var$GLYPH_HOVER : $e59d4eca9b366180$var$GLYPH,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            this.moveTo(-arm, -arm);
            this.lineTo(arm, arm);
            this.moveTo(arm, -arm);
            this.lineTo(-arm, arm);
            this.lineStyle(0);
        };
        this.radius = radius;
        this.draw(false);
        this.interactive = true;
        this.cursor = "pointer";
        // An explicit circular hit area, a couple of px proud of the rim: the disc is small and this
        // is the one control every dialog is closed by, so it should be forgiving to hit (and to tap).
        this.hitArea = new (0, $6qzqq.Circle)(0, 0, radius + 3);
        this.on("mouseover", ()=>this.draw(true));
        this.on("mouseout", ()=>this.draw(false));
        if (onClick) {
            this.on("click", onClick);
            this.on("tap", onClick);
        }
    }
}



class $09653c960702fb63$export$3ddf2d174ce01153 {
    constructor(parent, { padding: padding = 0, x: x = 0, y: y = 0, content: content = new (0, $gwPoJ.Graphics)(), borderColor: borderColor = 0xffffff, backgroundColor: backgroundColor = 0x000000, backgroundAlpha: backgroundAlpha = 0.91, width: width, height: height, closeCallback: closeCallback, onCloseClick: onCloseClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut, plain: plain, unescapeable: unescapeable, closeAnchor: closeAnchor }){
        this.update = ()=>{
            const dialog = new (0, $gwPoJ.Graphics)();
            this.dialog = dialog;
            this.dialog.zIndex = 3;
            this.parent.addChild(dialog);
            this.content.x = this.padding;
            this.content.y = this.padding;
            dialog.addChild(this.content);
            if (this.width) {
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.x = 0;
                spacer.y = 0;
                spacer.drawRect(0, 0, this.width, 1);
                spacer.width = this.width;
                dialog.addChild(spacer);
            }
            if (this.height) {
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.x = 0;
                spacer.y = 0;
                spacer.drawRect(0, 0, 1, this.height);
                spacer.height = this.height;
                dialog.addChild(spacer);
            }
            dialog.x = this.x;
            dialog.y = this.y;
            if (!this.plain) dialog.lineStyle(1, this.borderColor, 0.5);
            dialog.beginFill(this.backgroundColor, this.backgroundAlpha);
            if (!this.plain) dialog.drawRoundedRect(0, 0, dialog.width + this.padding * 2, dialog.height + this.padding * 2, 8);
            else dialog.drawRect(0, 0, dialog.width + this.padding * 2, dialog.height + this.padding * 2);
            dialog.endFill();
            if (!this.unescapeable) {
                // Hung on the top-right corner: the button draws from its own center, so pinning it at a
                // corner leaves it half over the edge. dialog.width is read after the backdrop is drawn,
                // so it is the width of the visible rect (content + padding on both sides).
                const close = new (0, $e59d4eca9b366180$export$de65de8213222d10)({
                    onClick: this.onCloseClick
                });
                if (this.closeAnchor) {
                    close.x = this.closeAnchor.x + this.padding;
                    close.y = this.closeAnchor.y + this.padding;
                } else {
                    // Nothing inset to hang off (the backdrop runs to the screen edge), so tuck the
                    // button just inside the corner where it can't be clipped off-screen.
                    close.x = dialog.width - (0, $e59d4eca9b366180$export$dc3c988e71114e28) - 6;
                    close.y = (0, $e59d4eca9b366180$export$dc3c988e71114e28) + 6;
                }
                dialog.addChild(close);
            }
            dialog.interactive = !!this.onMouseOut || !!this.onMouseOver;
            if (this.onMouseOver) dialog.on("mouseover", ()=>this.onMouseOver());
            if (this.onMouseOut) dialog.on("mouseout", ()=>this.onMouseOut());
        };
        this.close = ()=>{
            if (this.closed) return;
            // Free the dialog content's per-instance Text textures on close -- every modal/dialog
            // (inventory, character sheet, etc.) builds Text via TextRenderer, and detaching without
            // this strands each one's canvas-backed texture (not reclaimed by GC). Shared item-sprite
            // textures are left intact by disposeTextTextures.
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this.dialog);
            this.parent.removeChild(this.dialog);
            this.closeCallback();
            this.closed = true;
        };
        this.parent = parent;
        this.padding = padding;
        this.content = content;
        this.x = x;
        this.y = y;
        this.backgroundAlpha = backgroundAlpha;
        this.backgroundColor = backgroundColor;
        this.width = width;
        this.height = height;
        this.closeCallback = closeCallback;
        this.onCloseClick = onCloseClick;
        this.borderColor = borderColor;
        this.onMouseOver = onMouseOver;
        this.onMouseOut = onMouseOut;
        this.plain = plain;
        this.unescapeable = unescapeable;
        this.closeAnchor = closeAnchor;
    }
}


class $33e5ff783af47130$export$2b77a92f1a5ad772 {
    constructor(logic, parent, props){
        this.escapeSuspended = false;
        // Key DOWN only. The key-up matters because a sub-panel that borrows Escape (see suspendEscape)
        // hands it back the moment it closes on the key-down -- and the key-up that follows would
        // otherwise land here and take the whole screen down behind it.
        this.closeListener = (key, down)=>{
            if (key === "Escape" && down && !this.escapeSuspended) {
                this.closedClicked = true;
                this.dialog.close();
            }
        };
        // A sub-panel opened INSIDE this modal (the trade screen's quantity picker) borrows Escape while
        // it is up, so backing out of the picker doesn't also tear down the screen behind it.
        this.suspendEscape = (suspended)=>{
            this.escapeSuspended = suspended;
        };
        this.release = ()=>{
            // this.logic.playerController.enabledKeyboardAction(true)
            this.logic.playerController.enabledMouseAction(true);
            this.logic.clientRenderer.keyboard().removeListener(this.closeListener);
            if (this.props.closeCallback && !this.suppressOnCloseCallback) this.props.closeCallback(this.closedClicked);
        };
        this.update = ()=>{
            const createDialog = ()=>{
                const mouseOver = ()=>{
                    if (this.props.onMouseOver) this.props.onMouseOver();
                    this.logic.enablePlayerMouseAction(false);
                };
                const mouseOut = ()=>{
                    if (this.props.onMouseOut) this.props.onMouseOut();
                    this.logic.enablePlayerMouseAction(true);
                };
                const dialog = new (0, $09653c960702fb63$export$3ddf2d174ce01153)(this.parent, {
                    ...this.props,
                    onMouseOver: mouseOver,
                    onMouseOut: mouseOut,
                    closeCallback: this.release,
                    onCloseClick: ()=>{
                        this.closedClicked = true;
                        dialog.close();
                    }
                });
                dialog.update();
                return dialog;
            };
            const dialog = createDialog();
            this.dialog = dialog;
            // setup
            // this.logic.playerController.enabledKeyboardAction(false)
            this.logic.playerController.enabledMouseAction(false);
            if (!this.props.unescapeable) this.logic.clientRenderer.keyboard().addListener(this.closeListener);
        };
        this.close = ()=>{
            this.dialog.close();
        };
        this.logic = logic;
        this.parent = parent;
        this.width = props.fullScreen ? 800 - (props.padding || 0) * 2 : props.width;
        this.height = props.fullScreen ? 442 : props.width;
        if (props.fullScreen) props = {
            ...props,
            x: 0,
            y: 0,
            width: this.width,
            height: this.height
        };
        else if (props.center) props = {
            ...props,
            x: (799 - props.width) / 2,
            y: (441 - props.height) / 2
        };
        this.props = props;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");



class $11fe0387f9c174f1$export$85cd1614e509c3d9 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.setup = (resourcesMeta = [])=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            let prev;
            resourcesMeta.forEach((meta, idx)=>{
                const icon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: meta.icon,
                    scale: 1.0,
                    color: 0xffffff
                });
                icon.x = prev ? prev + 40 : 0;
                icon.y = icon.height < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 ? icon.height + 5 : icon.height / 2 + 2;
                this.addChild(icon);
                const quantityText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render();
                quantityText.x = Math.max((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, icon.x + icon.width - 8);
                quantityText.y = 1;
                quantityText.text = `${meta.quantity}`;
                this.addChild(quantityText);
                prev = icon.x + quantityText.width;
            });
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");



class $bbfac5179e5fdb9e$export$d5f40203d1afc530 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.renderSlot = (label, spriteMeta, selected, callback)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            const item = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)(spriteMeta);
            item.interactive = true;
            item.on("pointerdown", callback);
            slot.addChild(item);
            const labelObject = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(label);
            labelObject.x = -20;
            labelObject.y = -30;
            if (selected) labelObject.tint = 0x00ff00;
            slot.addChild(labelObject);
            return slot;
        }, this.update = (squadState)=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            if (squadState.count < 1) return;
            const baseMeta = {
                animated: false,
                color: 0xffffff,
                name: "",
                scale: 1.0
            };
            let i = -1;
            const width = 40;
            {
                i++;
                const scale = 1;
                const name = `squad-tome.png`;
                const shortcutKey = `J`;
                const callback = ()=>{
                // alert(squadState.stance)
                };
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: baseMeta.color,
                    name: name,
                    scale: scale
                }, false, callback);
                slot.x = i * width;
                this.addChild(slot);
            }
            {
                i++;
                const scale = 1;
                const name = `formation-${squadState?.formation || "random"}.png`;
                const shortcutKey = `K`;
                const callback = ()=>{
                // alert(squadState.stance)
                };
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: baseMeta.color,
                    name: name,
                    scale: scale
                }, false, callback);
                slot.x = i * width;
                this.addChild(slot);
            }
            {
                i++;
                const scale = 1;
                const name = `stance-${squadState?.stance || "defense"}.png`;
                const shortcutKey = `L`;
                const callback = ()=>{
                // alert(squadState.stance)
                };
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: baseMeta.color,
                    name: name,
                    scale: scale
                }, false, callback);
                slot.x = i * width;
                this.addChild(slot);
            }
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");







parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

// The speech bubble that floats above the ember roster strip when a camp member says something the
// player can't see them say (they're outside the viewport). Its tail points down at the speaker's
// roster card, so the line is tied to a face and a name rather than floating free.
//
// ONE bubble exists and is re-aimed as the lane's occupant changes — see EmberRosterWidget, which
// owns the queue. Keeping it single is the whole clutter strategy: a bubble is far wider than the
// ~56px card it belongs to, so two of them side by side would overlap and neither would be readable.
//
// It fades in and out rather than popping, and a HANDOVER between two speakers fades the old line
// out before the new one fades in — the tail moves to a different card, so cross-dissolving in place
// would read as the bubble teleporting. The fade is driven by the roster's existing per-frame tick
// rather than the Fader utility, which spawns a setInterval per fade; this runs on every frame the
// roster already animates, and timer churn is worth avoiding on the low-end hardware this targets.
// Ember-lit palette, matching the command wheel / role picker so the whole ember UI reads as one set.
const $23d13a6e2a72aec5$var$PANEL_FILL = 0x1b1512;
const $23d13a6e2a72aec5$var$PANEL_ALPHA = 0.94;
const $23d13a6e2a72aec5$var$TEXT_COLOR = 0xfff3e0;
const $23d13a6e2a72aec5$var$PAD_X = 9;
const $23d13a6e2a72aec5$var$PAD_Y = 7;
const $23d13a6e2a72aec5$var$CORNER = 7;
const $23d13a6e2a72aec5$var$TAIL_H = 8;
const $23d13a6e2a72aec5$var$TAIL_HALF_W = 6;
const $23d13a6e2a72aec5$var$LINE_GAP = 2;
// EVERY size here is in the roster widget's local units, which the strip then draws at
// WIDGET_SCALE (0.8) — so a font set to 15 lands at ~12px on screen. 12px is deliberate: it is what
// the in-world chat bubble uses (TextRenderer's "BubbleChatFont"), so a line reads the same whether
// you happen to be standing next to the speaker or reading it off the HUD.
const $23d13a6e2a72aec5$var$ROSTER_SCALE = 0.8;
const $23d13a6e2a72aec5$var$SCREEN_MSG_PX = 12;
const $23d13a6e2a72aec5$var$SCREEN_NAME_PX = 9;
const $23d13a6e2a72aec5$var$MSG_SIZE = Math.round($23d13a6e2a72aec5$var$SCREEN_MSG_PX / $23d13a6e2a72aec5$var$ROSTER_SCALE);
const $23d13a6e2a72aec5$var$NAME_SIZE = Math.round($23d13a6e2a72aec5$var$SCREEN_NAME_PX / $23d13a6e2a72aec5$var$ROSTER_SCALE);
// Wide enough for a sentence over two lines at that size, narrow enough to sit over the strip.
const $23d13a6e2a72aec5$var$MAX_W = 250;
// Hard cap so a long line can't grow the bubble without bound. The longest thing anyone currently
// says (the Lord's camp-news lines) is ~60 characters.
const $23d13a6e2a72aec5$var$MAX_CHARS = 72;
// The name line doesn't wrap, so an over-long name would render wider than the body it sits in and
// spill out both sides of the bubble. Cap it.
const $23d13a6e2a72aec5$var$MAX_NAME_CHARS = 18;
// Rough line box for a font size — Verdana's ascent+descent plus the 1px stroke TextRenderer adds.
const $23d13a6e2a72aec5$var$lineHeight = (fontSize)=>Math.ceil(fontSize * 1.35);
const $23d13a6e2a72aec5$export$256f864ac4a53998 = $23d13a6e2a72aec5$var$PAD_Y * 2 + $23d13a6e2a72aec5$var$lineHeight($23d13a6e2a72aec5$var$NAME_SIZE) + $23d13a6e2a72aec5$var$LINE_GAP + 3 * $23d13a6e2a72aec5$var$lineHeight($23d13a6e2a72aec5$var$MSG_SIZE) + $23d13a6e2a72aec5$var$TAIL_H;
// The glow is drawn as a fatter copy of the body, so the bubble's real painted extent is this much
// past its rect on every side. The clamp has to allow for it or the glow is what runs off-screen.
const $23d13a6e2a72aec5$var$GLOW_PAD = 4;
const $23d13a6e2a72aec5$export$6ba66118f048f541 = (contentW, contentH, tailX, tailY, clampRight)=>{
    const width = Math.min($23d13a6e2a72aec5$var$MAX_W, contentW + $23d13a6e2a72aec5$var$PAD_X * 2);
    const height = contentH + $23d13a6e2a72aec5$var$PAD_Y * 2;
    const rightLimit = clampRight - $23d13a6e2a72aec5$var$GLOW_PAD;
    let left = tailX - width / 2;
    if (left + width > rightLimit) left = rightLimit - width;
    return {
        left: left,
        top: tailY - $23d13a6e2a72aec5$var$TAIL_H - height,
        width: width,
        height: height
    };
};
const $23d13a6e2a72aec5$var$FADE_IN_MS = 160;
const $23d13a6e2a72aec5$var$FADE_OUT_MS = 220;
class $23d13a6e2a72aec5$export$1173af088df4f527 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), // The utterance currently drawn (null while nothing is), and where the fade is up to.
        this.shownKey = null, this.fade = 0, // Drive one frame of the bubble toward `target` (null = nothing to say). Handles the fade and
        // the swap, so the caller can simply hand over whatever the lane picked each frame.
        this.update = (dtMs, target)=>{
            const wantsSwap = target !== null && this.shownKey !== null && target.key !== this.shownKey;
            // Fade OUT when there's nothing to show, or when a different speaker is taking the lane —
            // the new line only appears once the old one has cleared.
            if (target === null || wantsSwap) {
                this.fade = Math.max(0, this.fade - dtMs / $23d13a6e2a72aec5$var$FADE_OUT_MS);
                if (this.fade <= 0) {
                    this.shownKey = null;
                    this.visible = false;
                }
                this.alpha = this.fade;
                return;
            }
            if (this.shownKey !== target.key) {
                this.draw(target);
                this.shownKey = target.key;
                this.visible = true;
            }
            this.fade = Math.min(1, this.fade + dtMs / $23d13a6e2a72aec5$var$FADE_IN_MS);
            this.alpha = this.fade;
        }, // Lay the bubble out around its tail. `tailX`/`tailY` are the tail TIP in the parent's
        // coordinate space (the top-centre of the speaking card); the body is drawn above it, and
        // `clampRight` keeps it from spilling past the right edge of the roster strip.
        this.draw = (target)=>{
            const { name: name, text: text, tailX: tailX, tailY: tailY, clampRight: clampRight, color: color } = target;
            const trimmed = text.length > $23d13a6e2a72aec5$var$MAX_CHARS ? text.slice(0, $23d13a6e2a72aec5$var$MAX_CHARS - 1) + "\u2026" : text;
            if (this.messageText.text !== trimmed) this.messageText.text = trimmed;
            const shortName = name.length > $23d13a6e2a72aec5$var$MAX_NAME_CHARS ? name.slice(0, $23d13a6e2a72aec5$var$MAX_NAME_CHARS - 1) + "\u2026" : name;
            if (this.nameText.text !== shortName) this.nameText.text = shortName;
            this.nameText.tint = color;
            const contentW = Math.max(this.nameText.width, this.messageText.width);
            const contentH = this.nameText.height + $23d13a6e2a72aec5$var$LINE_GAP + this.messageText.height;
            const box = $23d13a6e2a72aec5$export$6ba66118f048f541(contentW, contentH, tailX, tailY, clampRight);
            const { left: bodyLeft, top: bodyTop, width: bodyW, height: bodyH } = box;
            this.drawBubble(bodyLeft, bodyTop, bodyW, bodyH, tailX, tailY, color);
            const centerX = bodyLeft + bodyW / 2;
            this.nameText.position.set(centerX, bodyTop + $23d13a6e2a72aec5$var$PAD_Y);
            this.messageText.position.set(centerX, bodyTop + $23d13a6e2a72aec5$var$PAD_Y + this.nameText.height + $23d13a6e2a72aec5$var$LINE_GAP);
        }, // Body + tail drawn as ONE filled path so there's no seam where they meet: the tail's fill is
        // tucked a pixel up into the body, and only its two diagonals are stroked.
        this.drawBubble = (left, top, w, h, tailX, tailY, color)=>{
            const g = this.bg;
            g.clear();
            // Soft outer glow — a fatter, low-alpha copy. Cheaper than a blur filter, which matters on
            // the low-end GPUs this game targets.
            g.beginFill(color, 0.06);
            g.drawRoundedRect(left - 4, top - 4, w + 8, h + 8, $23d13a6e2a72aec5$var$CORNER + 4);
            g.endFill();
            g.lineStyle(1.5, color, 0.9);
            g.beginFill($23d13a6e2a72aec5$var$PANEL_FILL, $23d13a6e2a72aec5$var$PANEL_ALPHA);
            g.drawRoundedRect(left, top, w, h, $23d13a6e2a72aec5$var$CORNER);
            g.endFill();
            // Tail fill (base tucked 1px up into the body so the join is hidden).
            const baseY = top + h - 1;
            const tipX = Math.max(left + $23d13a6e2a72aec5$var$CORNER + $23d13a6e2a72aec5$var$TAIL_HALF_W, Math.min(left + w - $23d13a6e2a72aec5$var$CORNER - $23d13a6e2a72aec5$var$TAIL_HALF_W, tailX));
            g.lineStyle(0);
            g.beginFill($23d13a6e2a72aec5$var$PANEL_FILL, $23d13a6e2a72aec5$var$PANEL_ALPHA);
            g.moveTo(tipX - $23d13a6e2a72aec5$var$TAIL_HALF_W, baseY);
            g.lineTo(tipX + $23d13a6e2a72aec5$var$TAIL_HALF_W, baseY);
            g.lineTo(tailX, tailY);
            g.closePath();
            g.endFill();
            // Only the two diagonals are stroked — stroking the base would draw a line across the body.
            g.lineStyle(1.5, color, 0.9);
            g.moveTo(tipX - $23d13a6e2a72aec5$var$TAIL_HALF_W, baseY);
            g.lineTo(tailX, tailY);
            g.lineTo(tipX + $23d13a6e2a72aec5$var$TAIL_HALF_W, baseY);
        };
        this.bg = new (0, $gwPoJ.Graphics)();
        this.nameText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($23d13a6e2a72aec5$var$NAME_SIZE).render("");
        this.messageText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($23d13a6e2a72aec5$var$MSG_SIZE).wordWrap($23d13a6e2a72aec5$var$MAX_W - $23d13a6e2a72aec5$var$PAD_X * 2).align("center").render("");
        // Top-centred so the two lines stack cleanly under one centre line.
        this.nameText.anchor.set(0.5, 0);
        this.messageText.anchor.set(0.5, 0);
        this.messageText.tint = $23d13a6e2a72aec5$var$TEXT_COLOR;
        this.addChild(this.bg, this.nameText, this.messageText);
        this.visible = false;
    }
}


// The state machine behind the ember roster's offscreen speech lane. Kept free of PIXI (like
// faction_tracker_geometry.ts) so the rules can be unit-tested without a renderer; ember_roster.ts
// owns the drawing and just asks this what to show.
//
// THE CLUTTER RULE. A camp member who speaks while the player can't see them gets their line shown
// over their roster card. A readable bubble is several times wider than the ~56px card it belongs
// to, so two of them side by side would overlap into mush — the lane therefore holds exactly ONE at
// a time and everyone else queues:
//
//   - a line holds the lane for MIN_MS before it can be pushed out, so it can actually be read,
//   - and gives it up at MAX_MS even if nobody is waiting, so the HUD returns to quiet,
//   - a burst keeps only the newest QUEUE_MAX lines: when several people shout at once, current
//     lines are worth more than stale ones,
//   - and every speaker's card flashes the moment they speak, so a queued line is acknowledged
//     immediately even though its bubble has to wait its turn.
const $9e747834c562d64b$export$5c1878fd8e0add16 = 2200;
const $9e747834c562d64b$export$c0be6884d7e4f609 = 5200;
const $9e747834c562d64b$export$19be0e4958a5a0ee = 3;
const $9e747834c562d64b$export$42fd3fb39fa9e691 = 700;
class $9e747834c562d64b$export$902003cea2799f4d {
    constructor(){
        this.queue = [];
        this.current = null;
        this.elapsedMs = 0;
        // The last line already reacted to per member, so one utterance raises one bubble rather than
        // one per frame it remains inside its ~3s window.
        this.handled = new Map();
        // entityId -> remaining flash time.
        this.pulses = new Map();
        // Advance one frame. `getSpeech` must answer null for anyone the player can currently SEE —
        // their bubble is already drawn over their head in the world, and repeating it here is noise.
        this.update = (dtMs, members, getSpeech)=>{
            this.collect(members, getSpeech);
            this.advance(dtMs, getSpeech);
            this.advancePulses(dtMs);
        };
        // The line to show, or null for an empty lane.
        this.currentLine = ()=>this.current;
        // 0..1 flash strength for a member's card this frame.
        this.pulseAlpha = (entityId)=>(this.pulses.get(entityId) || 0) / $9e747834c562d64b$export$42fd3fb39fa9e691;
        this.queueLength = ()=>this.queue.length;
        // A member who left the roster keeps neither the lane nor a place in the queue.
        this.forget = (entityId)=>{
            this.queue = this.queue.filter((q)=>q.entityId !== entityId);
            this.handled.delete(entityId);
            this.pulses.delete(entityId);
            if (this.current?.entityId === entityId) this.clear();
        };
        this.collect = (members, getSpeech)=>{
            members.forEach((member)=>{
                const line = getSpeech(member.entityId);
                if (!line) {
                    // Window lapsed, or they walked into view: re-arm so saying the same thing again
                    // later counts as a fresh utterance.
                    this.handled.delete(member.entityId);
                    return;
                }
                if (this.handled.get(member.entityId) === line) return;
                this.handled.set(member.entityId, line);
                this.pulses.set(member.entityId, $9e747834c562d64b$export$42fd3fb39fa9e691);
                this.queue.push({
                    entityId: member.entityId,
                    name: member.name,
                    text: line
                });
                if (this.queue.length > $9e747834c562d64b$export$19be0e4958a5a0ee) this.queue.splice(0, this.queue.length - $9e747834c562d64b$export$19be0e4958a5a0ee);
            });
        };
        this.advance = (dtMs, getSpeech)=>{
            if (this.current) {
                this.elapsedMs += dtMs;
                const readable = this.elapsedMs >= $9e747834c562d64b$export$5c1878fd8e0add16;
                // Let it go early once the player has caught up with the speaker — they can see the real
                // bubble now — but never before it has been up long enough to read.
                const caughtUp = getSpeech(this.current.entityId) === null;
                if (readable && (caughtUp || this.queue.length > 0) || this.elapsedMs >= $9e747834c562d64b$export$c0be6884d7e4f609) this.clear();
            }
            if (!this.current && this.queue.length > 0) {
                this.current = this.queue.shift();
                this.elapsedMs = 0;
            }
        };
        this.advancePulses = (dtMs)=>{
            for (const [entityId, remaining] of Array.from(this.pulses.entries())){
                const next = remaining - dtMs;
                if (next <= 0) this.pulses.delete(entityId);
                else this.pulses.set(entityId, next);
            }
        };
        this.clear = ()=>{
            this.current = null;
            this.elapsedMs = 0;
        };
    }
}


const $8d6533e00bd59062$export$cdc10a00a6ecc04e = 70;
const $8d6533e00bd59062$export$4cacdb4184ffb7a8 = 96;
const $8d6533e00bd59062$export$2295e056c5b8b159 = 6;
const $8d6533e00bd59062$export$f8b8d0e2524d7c47 = 5;
const $8d6533e00bd59062$export$4e669d5539617474 = 6;
const $8d6533e00bd59062$export$937b0d3608fcf11e = 1.5;
const $8d6533e00bd59062$export$77f435e13f71eb7f = $8d6533e00bd59062$export$cdc10a00a6ecc04e / 2;
const $8d6533e00bd59062$export$572eba96a021644d = 50;
const $8d6533e00bd59062$export$e1a1d856f86d5382 = 15;
const $8d6533e00bd59062$export$c51218e3426de1b7 = 4;
const $8d6533e00bd59062$export$b643d415cf93452e = 3;
const $8d6533e00bd59062$export$9abd345d8933c5ce = 38;
const $8d6533e00bd59062$export$50e8cfc43db69af3 = $8d6533e00bd59062$export$4cacdb4184ffb7a8 - 32;
const $8d6533e00bd59062$export$dc9a8445d2f3c372 = 9;
const $8d6533e00bd59062$export$1c21151185bd8e77 = $8d6533e00bd59062$export$4cacdb4184ffb7a8 - 18;
const $8d6533e00bd59062$export$d80daa1884709eb5 = 5;
const $8d6533e00bd59062$export$8c0eb8c159a41292 = $8d6533e00bd59062$export$1c21151185bd8e77 + $8d6533e00bd59062$export$d80daa1884709eb5 + 2;
const $8d6533e00bd59062$export$30e8349973c4d242 = 4;
const $8d6533e00bd59062$export$6881c612b1e8acd5 = 11;
const $8d6533e00bd59062$export$68dee29db058ecad = 11;
const $8d6533e00bd59062$export$e74fbfde0a93daa9 = 0.3;
const $8d6533e00bd59062$export$d87ce5ad91d00207 = 900;
const $8d6533e00bd59062$export$a3fc1e002308197a = (ratio)=>ratio > 0.6 ? 0xf0b429 : ratio > $8d6533e00bd59062$export$e74fbfde0a93daa9 ? 0xe07b39 : 0xd94f3d;
const $8d6533e00bd59062$export$ff66bb5d2113fcb7 = (ratio)=>ratio > 0.5 ? 0x6fe06f : ratio > 0.25 ? 0xffd23f : 0xff5c5c;
const $8d6533e00bd59062$export$688b358246787b37 = {
    lord: "\uD83D\uDC51",
    player: "\uD83E\uDDD1",
    defender: "\uD83D\uDEE1\uFE0F",
    forager: "\uD83E\uDE93"
};
const $8d6533e00bd59062$export$c082e8bc79733f73 = 0xc21a1a;
const $8d6533e00bd59062$export$7b5bc50f06bd4503 = 0xff4d4d;
const $8d6533e00bd59062$export$2231d9ccf0d5169e = 0xffd9d9;
const $8d6533e00bd59062$export$77f3d2d2b010c804 = 0xff7a7a;
const $8d6533e00bd59062$export$e82906a3183f43fc = 14;
const $8d6533e00bd59062$export$db313b0d55ae90f4 = 44;


// The impact an ember roster card takes when its member is hurt. Kept free of PIXI (like
// roster_speech_lane.ts) so the timings and curves can be unit-tested without a renderer;
// ember_roster.ts owns the drawing and just asks this what a card should look like this frame.
//
// WHY A CARD HAS TO SHOUT. The roster is the only sight the player has of a camp member who is
// fighting somewhere off-screen, and an HP bar 52px wide losing a few pixels is not something
// anyone notices mid-fight. So a hit is drawn as an EVENT rather than a new value: the card jolts,
// washes red, and the health it just lost is left hanging as a pale "ghost" segment that drains
// away a beat later -- the fighting-game trick, which is what makes the size of the hit legible at
// a glance. A rising damage number over the portrait says exactly how much.
//
// Everything is scaled by SEVERITY (the share of the member's maximum health the blow took), so a
// scratch reads as a scratch and a mauling reads as a mauling. The roster only speaks every 500ms
// (ROSTER_INTERVAL_MS), so what arrives is really "the damage taken since the last tick" -- one
// jolt per tick is the most any card can show, and that is the right density for the HUD anyway.
const $510d6be55289832c$export$be5fdb9a8fa8ab45 = 360;
const $510d6be55289832c$export$6c1279663b1160c7 = 300;
const $510d6be55289832c$export$2b1e059ccff43a50 = 420;
const $510d6be55289832c$export$25d491887f28ed2b = 190;
const $510d6be55289832c$export$37009f542e15b99d = 200;
const $510d6be55289832c$export$985f4ffd0a61844d = 420;
const $510d6be55289832c$export$7c035f1efc26822 = 820;
const $510d6be55289832c$export$16bddead18efce30 = $510d6be55289832c$export$7c035f1efc26822;
const $510d6be55289832c$export$c4792b23dd798686 = 0.25;
const $510d6be55289832c$export$cd5aa8e599364038 = 2;
const $510d6be55289832c$export$435698e2819999e8 = 6.5;
const $510d6be55289832c$export$386e78b4dec646f6 = 21;
const $510d6be55289832c$export$e02c62cd85f02998 = 0.04;
const $510d6be55289832c$export$ad35d3e46d06a1bb = 0.11;
const $510d6be55289832c$export$bbbcf641baad31af = 0.55;
const $510d6be55289832c$export$3459ca9a00502428 = 0.9;
const $510d6be55289832c$export$270b70581362efed = 18;
const $510d6be55289832c$export$9a468fc1f4d8a2e3 = 0.45;
const $510d6be55289832c$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $510d6be55289832c$export$57800b7ee2fc44c1 = (elapsedMs, severity)=>{
    if (elapsedMs >= $510d6be55289832c$export$be5fdb9a8fa8ab45) return {
        x: 0,
        y: 0
    };
    const decay = 1 - elapsedMs / $510d6be55289832c$export$be5fdb9a8fa8ab45;
    const amp = ($510d6be55289832c$export$cd5aa8e599364038 + ($510d6be55289832c$export$435698e2819999e8 - $510d6be55289832c$export$cd5aa8e599364038) * $510d6be55289832c$var$clamp01(severity)) * decay * decay;
    const w = 2 * Math.PI * $510d6be55289832c$export$386e78b4dec646f6 / 1000;
    return {
        x: amp * Math.sin(elapsedMs * w),
        y: amp * 0.4 * Math.sin(elapsedMs * w * 1.7 + 1.1)
    };
};
const $510d6be55289832c$export$5ecbb996e3d16f6f = (elapsedMs, severity)=>{
    if (elapsedMs >= $510d6be55289832c$export$25d491887f28ed2b) return 1;
    const amount = $510d6be55289832c$export$e02c62cd85f02998 + ($510d6be55289832c$export$ad35d3e46d06a1bb - $510d6be55289832c$export$e02c62cd85f02998) * $510d6be55289832c$var$clamp01(severity);
    return 1 + amount * Math.sin(Math.PI * (elapsedMs / $510d6be55289832c$export$25d491887f28ed2b));
};
const $510d6be55289832c$export$d4dc426e7bd6642e = (elapsedMs)=>{
    if (elapsedMs >= $510d6be55289832c$export$6c1279663b1160c7) return 0;
    const p = 1 - elapsedMs / $510d6be55289832c$export$6c1279663b1160c7;
    return $510d6be55289832c$export$bbbcf641baad31af * p * p;
};
const $510d6be55289832c$export$4f7bbc3eca0964c0 = (elapsedMs)=>elapsedMs >= $510d6be55289832c$export$2b1e059ccff43a50 ? 0 : $510d6be55289832c$export$3459ca9a00502428 * (1 - elapsedMs / $510d6be55289832c$export$2b1e059ccff43a50);
const $510d6be55289832c$export$c6b2f0bee2bd53d2 = (elapsedMs, fromRatio, toRatio)=>{
    if (elapsedMs <= $510d6be55289832c$export$37009f542e15b99d) return fromRatio;
    const p = $510d6be55289832c$var$clamp01((elapsedMs - $510d6be55289832c$export$37009f542e15b99d) / $510d6be55289832c$export$985f4ffd0a61844d);
    return fromRatio + (toRatio - fromRatio) * p * p;
};
const $510d6be55289832c$export$6b868817a54a4b96 = (elapsedMs)=>{
    if (elapsedMs >= $510d6be55289832c$export$7c035f1efc26822) return {
        alpha: 0,
        rise: $510d6be55289832c$export$270b70581362efed
    };
    const p = elapsedMs / $510d6be55289832c$export$7c035f1efc26822;
    const alpha = p < $510d6be55289832c$export$9a468fc1f4d8a2e3 ? 1 : 1 - (p - $510d6be55289832c$export$9a468fc1f4d8a2e3) / (1 - $510d6be55289832c$export$9a468fc1f4d8a2e3);
    return {
        alpha: alpha,
        rise: $510d6be55289832c$export$270b70581362efed * (1 - (1 - p) * (1 - p))
    };
};
class $510d6be55289832c$export$c2606b7ba4b337e3 {
    constructor(){
        this.pulses = new Map();
        this.nextSeq = 1;
        // A member's health went DOWN. Healing and first sightings never reach here -- the caller only
        // knows there was a hit because it remembers what the last roster tick said.
        this.hit = (entityId, previousHp, hp, hpMax)=>{
            const lost = previousHp - hp;
            if (!(hpMax > 0) || !(lost > 0)) return;
            const existing = this.pulses.get(entityId);
            const beforeRatio = $510d6be55289832c$var$clamp01(previousHp / hpMax);
            this.pulses.set(entityId, {
                elapsedMs: 0,
                amount: Math.max(1, Math.round(lost)),
                severity: $510d6be55289832c$var$clamp01(lost / hpMax / $510d6be55289832c$export$c4792b23dd798686),
                // Struck again mid-effect: start the ghost from wherever it currently stands rather than
                // from the health before THIS hit, or the pale segment would jump back down and the two
                // blows would read as one small one.
                fromRatio: existing ? Math.max(beforeRatio, $510d6be55289832c$export$c6b2f0bee2bd53d2(existing.elapsedMs, existing.fromRatio, existing.toRatio)) : beforeRatio,
                toRatio: $510d6be55289832c$var$clamp01(hp / hpMax),
                seq: this.nextSeq++
            });
        };
        this.update = (dtMs)=>{
            for (const [entityId, pulse] of Array.from(this.pulses.entries())){
                pulse.elapsedMs += dtMs;
                if (pulse.elapsedMs >= $510d6be55289832c$export$16bddead18efce30) this.pulses.delete(entityId);
            }
        };
        // What this member's card should look like, or null when it is at rest (the common case -- the
        // widget then puts the card back to its resting position and stops redrawing it).
        this.frame = (entityId)=>{
            const pulse = this.pulses.get(entityId);
            if (!pulse) return null;
            const { elapsedMs: elapsedMs, severity: severity } = pulse;
            const shake = $510d6be55289832c$export$57800b7ee2fc44c1(elapsedMs, severity);
            const number = $510d6be55289832c$export$6b868817a54a4b96(elapsedMs);
            return {
                shakeX: shake.x,
                shakeY: shake.y,
                scale: $510d6be55289832c$export$5ecbb996e3d16f6f(elapsedMs, severity),
                flashAlpha: $510d6be55289832c$export$d4dc426e7bd6642e(elapsedMs),
                ringAlpha: $510d6be55289832c$export$4f7bbc3eca0964c0(elapsedMs),
                ghostRatio: $510d6be55289832c$export$c6b2f0bee2bd53d2(elapsedMs, pulse.fromRatio, pulse.toRatio),
                numberAlpha: number.alpha,
                numberRise: number.rise,
                amount: pulse.amount,
                seq: pulse.seq
            };
        };
        // A member who left the roster takes their effect with them.
        this.forget = (entityId)=>{
            this.pulses.delete(entityId);
        };
        this.activeCount = ()=>this.pulses.size;
    }
}


// How an ember roster card leaves the strip when its member dies. PIXI-free (like
// roster_damage.ts and roster_speech_lane.ts beside it), so the timings and the shard motion can be
// unit-tested without a renderer; ember_roster.ts owns the objects and draws what this decides.
//
// WHY A DEATH GETS A SECOND AND A HALF. Until now a member who died simply stopped being in the
// roster broadcast, and their card vanished between two ticks -- the strip just had one card fewer,
// with nothing to say that somebody had been lost. The camp is small enough that losing a defender
// matters, so the card is given an exit:
//
//   - the colour drains out of it until it is completely grey (the member is gone),
//   - then the card itself breaks apart and the pieces fall away,
//   - and only once the last piece has gone does the strip close the gap.
//
// The card holds its COLUMN for the whole of it. Letting the survivors slide over immediately would
// put a live card on top of the one that is breaking up, and would also mean the strip shrank before
// the player had seen which card it was.
const $bb9e23e7af52cc31$export$db237cf1ba467f33 = 500;
const $bb9e23e7af52cc31$export$8c5c1ebc079711ff = 1000;
const $bb9e23e7af52cc31$export$f3b14c224c07c95b = $bb9e23e7af52cc31$export$db237cf1ba467f33 + $bb9e23e7af52cc31$export$8c5c1ebc079711ff;
const $bb9e23e7af52cc31$export$6029fd88d9db5b6 = 14;
const $bb9e23e7af52cc31$export$9c83558f29ac851e = 900;
const $bb9e23e7af52cc31$export$c059030fbdddd4b3 = 70;
const $bb9e23e7af52cc31$export$172c7549624448fe = 150;
const $bb9e23e7af52cc31$export$d19c6a2eaa617cfa = 420;
const $bb9e23e7af52cc31$export$4b1fde3a9508334 = 90;
const $bb9e23e7af52cc31$export$70ee08772c334b5 = 0.35;
const $bb9e23e7af52cc31$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $bb9e23e7af52cc31$export$54311821b45b94a4 = (elapsedMs)=>{
    const p = $bb9e23e7af52cc31$var$clamp01(elapsedMs / $bb9e23e7af52cc31$export$db237cf1ba467f33);
    return 1 - (1 - p) * (1 - p);
};
const $bb9e23e7af52cc31$export$1d5894916c503cf9 = (elapsedMs)=>elapsedMs >= $bb9e23e7af52cc31$export$db237cf1ba467f33;
const $bb9e23e7af52cc31$export$b019cd4aafde2132 = (elapsedMs)=>elapsedMs >= $bb9e23e7af52cc31$export$f3b14c224c07c95b;
const $bb9e23e7af52cc31$export$3157021a2e406e10 = (size, resolution)=>{
    const scale = resolution > 0 ? resolution : 1;
    return Math.ceil(size * scale) / scale;
};
const $bb9e23e7af52cc31$export$62785211b15662cd = (width, height, rand = Math.random, size = $bb9e23e7af52cc31$export$6029fd88d9db5b6)=>{
    const cols = Math.max(1, Math.ceil(width / size));
    const rows = Math.max(1, Math.ceil(height / size));
    const seeds = [];
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const x = col * size;
        const y = row * size;
        // Where this piece sits relative to the card's centre, -1..1 on each axis. It decides
        // which way the piece is thrown, so the card comes apart from the middle.
        const nx = cols > 1 ? (col - (cols - 1) / 2) / ((cols - 1) / 2) : 0;
        const ny = rows > 1 ? (row - (rows - 1) / 2) / ((rows - 1) / 2) : 0;
        const spread = Math.min(1, Math.sqrt(nx * nx + ny * ny));
        seeds.push({
            col: col,
            row: row,
            x: x,
            y: y,
            // Clipped at the right/bottom edge so the shards tile the card exactly.
            w: Math.min(size, width - x),
            h: Math.min(size, height - y),
            vx: nx * $bb9e23e7af52cc31$export$c059030fbdddd4b3 * (0.6 + rand() * 0.8),
            // Up first (negative y), hardest at the top of the card, then gravity takes over.
            vy: -$bb9e23e7af52cc31$export$172c7549624448fe * (0.45 + rand() * 0.7) + ny * 30,
            spin: (rand() - 0.5) * 2 * $bb9e23e7af52cc31$export$d19c6a2eaa617cfa,
            delayMs: spread * $bb9e23e7af52cc31$export$4b1fde3a9508334
        });
    }
    return seeds;
};
const $bb9e23e7af52cc31$export$e174c14a9cb043b8 = (shatterMs, seed)=>{
    if (shatterMs < seed.delayMs) return null;
    const flightMs = $bb9e23e7af52cc31$export$8c5c1ebc079711ff - seed.delayMs;
    const p = $bb9e23e7af52cc31$var$clamp01((shatterMs - seed.delayMs) / flightMs);
    const t = (shatterMs - seed.delayMs) / 1000;
    return {
        dx: seed.vx * t,
        dy: seed.vy * t + 0.5 * $bb9e23e7af52cc31$export$9c83558f29ac851e * t * t,
        angle: seed.spin * t,
        alpha: p < $bb9e23e7af52cc31$export$70ee08772c334b5 ? 1 : 1 - (p - $bb9e23e7af52cc31$export$70ee08772c334b5) / (1 - $bb9e23e7af52cc31$export$70ee08772c334b5)
    };
};


const $44af089a9f2b65fe$var$ROLE_COLORS = {
    lord: 0xffd23f,
    // The same cool green a partner's dot gets on the minimap, so the card and the dot are
    // recognisably the same person without having to read either.
    player: 0x2bc4a8,
    defender: 0xff8a5c,
    forager: 0x7be08a
};
// Must agree with ROLE_ORDER in the server's ember_roster campaign, which is what actually sorts
// the strip; this one re-sorts locally after a card is added or removed.
const $44af089a9f2b65fe$var$ROLE_ORDER = {
    lord: 0,
    player: 1,
    defender: 2,
    forager: 3
};
// Uniform scale for the whole widget (portraits, text, emoji, spacing) — cheaper and more reliable
// than re-tuning every geometry constant below.
const $44af089a9f2b65fe$var$WIDGET_SCALE = 0.8;
// Kept back from the edge of a texture a shard is cut out of. A frame that measures EXACTLY to the
// edge is a floating-point coin toss against pixi's "does this fit" test, and losing it throws; a
// hundredth of a pixel is not a thing anybody can see. See shatterCard.
const $44af089a9f2b65fe$var$FRAME_EPSILON = 0.01;
// Child z-order within a card (container.sortableChildren) so the fire backdrop sits behind the
// portrait but above the frame, regardless of add/rebuild order.
const $44af089a9f2b65fe$var$Z_CHROME = 0;
const $44af089a9f2b65fe$var$Z_FLAME = 1;
const $44af089a9f2b65fe$var$Z_PORTRAIT = 2;
const $44af089a9f2b65fe$var$Z_SCRIM = 3;
// The damage wash goes over the portrait but UNDER the name and stat bars, so a card can shout that
// it was hit without hiding the numbers the player is being told to look at.
const $44af089a9f2b65fe$var$Z_WASH = 4;
const $44af089a9f2b65fe$var$Z_BADGE = 5;
const $44af089a9f2b65fe$var$Z_NAME = 6;
const $44af089a9f2b65fe$var$Z_HP = 7;
const $44af089a9f2b65fe$var$Z_HUNGER = 8;
const $44af089a9f2b65fe$var$Z_SELECTION = 9;
const $44af089a9f2b65fe$var$Z_SPEAKING = 10;
const $44af089a9f2b65fe$var$Z_DAMAGE_RING = 11;
const $44af089a9f2b65fe$var$Z_DAMAGE_NUMBER = 12;
// The grey a dead member's card goes under sits over everything else on it.
const $44af089a9f2b65fe$var$Z_DEATH_PALL = 13;
// Ash: mid-grey, and just short of opaque (see drawPall).
const $44af089a9f2b65fe$var$PALL_COLOR = 0x5a5f5a;
const $44af089a9f2b65fe$var$PALL_MAX_ALPHA = 0.88;
// Offscreen speech lane: a camp member speaking while OUT of the player's view gets their line
// shown over their roster card. The rules (one bubble at a time, dwell, queue cap, card flash) are
// in roster_speech_lane.ts; this file only draws what that decides. The lane's height comes from
// the bubble itself so the two can't drift apart — it is reserved whether or not anyone is talking,
// so the follow-cam PiP sitting above the strip never jumps.
const $44af089a9f2b65fe$var$SPEECH_LANE_H = (0, $23d13a6e2a72aec5$export$256f864ac4a53998);
class $44af089a9f2b65fe$export$7b64a8ee2d511abd extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.slots = new Map(), this.speechLane = new (0, $9e747834c562d64b$export$902003cea2799f4d)(), // Hits taken by camp members, read off the health each roster tick reports. The curves and
        // timings live in roster_damage.ts; this widget only draws the frame it is handed.
        this.damageFx = new (0, $510d6be55289832c$export$c2606b7ba4b337e3)(), // Cards whose member has died: greying, then breaking apart, and holding their column in the
        // strip until the last shard has gone (see roster_death.ts). Keyed by the entity that left, so a
        // member who somehow comes back gets a fresh card rather than the one that is falling apart.
        this.dying = new Map(), // The living cards in display order, remembered so the strip can be laid out again the moment a
        // death finishes rather than waiting for the next roster tick to close the gap.
        this.order = [], // Free-running clock for the starving-member pulse, shared by every card so they breathe together
        // rather than each on its own phase.
        this.pulseMs = 0, // Browser-console triggers, in the same shape as window.playerRing / window.spriteShadow:
        //
        //     rosterHit()        // every card takes a middling hit
        //     rosterHit(0.4)     // ...takes 40% of its health off
        //     rosterKill()       // the last card on the strip dies and breaks apart
        //     rosterWidget       // the strip itself: cardCount(), isDying(id), deathPhase(id)
        //
        // Neither reaction can be looked at on demand -- one needs something off-screen to land a blow,
        // the other needs somebody to die -- so there would otherwise be no way to tune the shake, the
        // colours or the shatter. The health rosterHit pretends was lost is corrected by the next roster
        // tick half a second later; the card rosterKill takes is rebuilt by it.
        this.exposeDevTriggers = ()=>{
            if (typeof window === "undefined") return;
            window.rosterWidget = this;
            window.rosterKill = (name)=>{
                const entry = Array.from(this.slots.entries()).reverse().find(([, slot])=>!name || (slot.name || "").toLowerCase().includes(name.toLowerCase()));
                if (!entry) return `[rosterKill] no card matching ${name ?? "(any)"}`;
                this.beginDeath(entry[0], entry[1]);
                this.layout();
                this.guiManager.positionEmberRoster();
                return entry[0];
            };
            window.rosterHit = (fraction = 0.18)=>{
                this.slots.forEach((slot, entityId)=>{
                    const hpMax = slot.hpMax ?? 20;
                    const hp = slot.hp ?? hpMax;
                    const hit = Math.max(0, hp - hpMax * fraction);
                    this.damageFx.hit(entityId, hp, hit, hpMax);
                    slot.hp = hit;
                    this.drawHpBar(slot.hpBar, hit, hpMax, slot.ghostRatio);
                });
                return `[rosterHit] ${this.slots.size} card(s)`;
            };
        }, this.appearanceKeyFor = (entry)=>entry.appearance ? JSON.stringify(entry.appearance) : "", this.truncate = (name)=>{
            if (!name) return "";
            return name.length > (0, $8d6533e00bd59062$export$6881c612b1e8acd5) ? name.slice(0, (0, $8d6533e00bd59062$export$6881c612b1e8acd5) - 1) + "\u2026" : name;
        }, // Build the zoomed front-facing portrait from a synthetic entity, mirroring the inventory-view
        // portrait (dynamic_dialog.ts / EntityDisplayer). Clipped to the card via `mask` by the caller.
        this.buildPortrait = (entry)=>{
            const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            entity.weapon = {
                weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entry.inventory, "weapon")?.type
            };
            entity.appearance = entry.appearance;
            entity.inventory = entry.inventory;
            const portrait = new (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)(entry.entityId);
            try {
                portrait.updatePaperdoll(entity);
            } catch (e) {
                // Malformed appearance data must not take down the whole roster — leave it blank.
                console.warn(`[EmberRoster] portrait build failed for ${entry.entityId}`, e);
            }
            portrait.scale.set((0, $8d6533e00bd59062$export$937b0d3608fcf11e));
            portrait.x = (0, $8d6533e00bd59062$export$77f435e13f71eb7f);
            portrait.y = (0, $8d6533e00bd59062$export$572eba96a021644d);
            return portrait;
        }, this.makeMask = ()=>{
            const g = new (0, $gwPoJ.Graphics)();
            g.beginFill(0xffffff);
            g.drawRoundedRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4e669d5539617474));
            g.endFill();
            return g;
        }, this.makeBadge = (role)=>{
            // No tint: keep the emoji's own colors.
            const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $8d6533e00bd59062$export$e1a1d856f86d5382)).render((0, $8d6533e00bd59062$export$688b358246787b37)[role]);
            t.x = (0, $8d6533e00bd59062$export$c51218e3426de1b7);
            t.y = (0, $8d6533e00bd59062$export$b643d415cf93452e);
            return t;
        }, this.makeNameText = (name)=>{
            const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(this.truncate(name));
            t.tint = 0xffffff;
            t.x = Math.round((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2 - t.width / 2);
            t.y = (0, $8d6533e00bd59062$export$50e8cfc43db69af3);
            return t;
        }, // `ghostRatio` is the fighting-game "health you just lost": a pale segment left standing where
        // the bar was before the hit, drawn UNDER the live fill so only the difference shows, and drained
        // away by the damage effect a beat later. Undefined (the resting case) draws the bar as before.
        this.drawHpBar = (bar, hp, hpMax, ghostRatio)=>{
            bar.clear();
            const w = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$dc9a8445d2f3c372) * 2;
            bar.beginFill(0x000000, 0.6);
            bar.drawRoundedRect(0, 0, w, (0, $8d6533e00bd59062$export$d80daa1884709eb5), 2);
            bar.endFill();
            if (ghostRatio !== undefined && ghostRatio > 0) {
                bar.beginFill((0, $8d6533e00bd59062$export$2231d9ccf0d5169e), 0.9);
                bar.drawRoundedRect(0, 0, Math.max(1, w * Math.min(1, ghostRatio)), (0, $8d6533e00bd59062$export$d80daa1884709eb5), 2);
                bar.endFill();
            }
            if (hp !== undefined && hpMax && hpMax > 0) {
                const ratio = Math.max(0, Math.min(1, hp / hpMax));
                const color = (0, $8d6533e00bd59062$export$ff66bb5d2113fcb7)(ratio);
                if (ratio > 0) {
                    bar.beginFill(color, 0.95);
                    bar.drawRoundedRect(0, 0, Math.max(1, w * ratio), (0, $8d6533e00bd59062$export$d80daa1884709eb5), 2);
                    bar.endFill();
                }
            }
            bar.x = (0, $8d6533e00bd59062$export$dc9a8445d2f3c372);
            bar.y = (0, $8d6533e00bd59062$export$1c21151185bd8e77);
        }, // The hunger bar: the recruit's whole food arc as one falling bar, drawn a shade thinner than the
        // HP bar above it and in warm food colours (amber -> orange -> ember red) so the two rows can't be
        // read as the same stat. The server sends no hunger for the lord, whose row stays empty.
        this.drawHungerBar = (bar, hunger)=>{
            bar.clear();
            bar.visible = hunger !== undefined;
            if (hunger === undefined) return;
            const w = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$dc9a8445d2f3c372) * 2;
            bar.beginFill(0x000000, 0.6);
            bar.drawRoundedRect(0, 0, w, (0, $8d6533e00bd59062$export$30e8349973c4d242), 2);
            bar.endFill();
            const ratio = Math.max(0, Math.min(1, hunger));
            const color = (0, $8d6533e00bd59062$export$a3fc1e002308197a)(ratio);
            if (ratio > 0) {
                bar.beginFill(color, 0.95);
                bar.drawRoundedRect(0, 0, Math.max(1, w * ratio), (0, $8d6533e00bd59062$export$30e8349973c4d242), 2);
                bar.endFill();
            }
            bar.x = (0, $8d6533e00bd59062$export$dc9a8445d2f3c372);
            bar.y = (0, $8d6533e00bd59062$export$8c0eb8c159a41292);
        }, // The card frame (dark, so the inset portrait reads as a bordered background) plus a bottom
        // scrim and a small chip behind the badge, all in one Graphics behind the portrait/overlays.
        this.drawChrome = (chrome)=>{
            chrome.clear();
            // Frame / margin.
            chrome.beginFill(0x0a0d08, 0.9);
            chrome.lineStyle(1, 0xffffff, 0.1);
            chrome.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            chrome.endFill();
        }, this.drawScrim = (scrim)=>{
            scrim.clear();
            scrim.beginFill(0x000000, 0.5);
            scrim.drawRoundedRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) - (0, $8d6533e00bd59062$export$9abd345d8933c5ce), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$9abd345d8933c5ce), (0, $8d6533e00bd59062$export$4e669d5539617474));
            scrim.endFill();
            // Chip behind the emoji badge (top-left) for contrast over any portrait.
            scrim.beginFill(0x000000, 0.45);
            scrim.drawRoundedRect((0, $8d6533e00bd59062$export$c51218e3426de1b7) - 2, (0, $8d6533e00bd59062$export$b643d415cf93452e) - 1, (0, $8d6533e00bd59062$export$e1a1d856f86d5382) + 5, (0, $8d6533e00bd59062$export$e1a1d856f86d5382) + 3, 3);
            scrim.endFill();
        }, // The flash a card gives when its member speaks from offscreen — the immediate acknowledgement
        // that lets extra speakers wait in the queue without their line feeling dropped.
        this.drawSpeakingRing = (ring, role)=>{
            ring.clear();
            ring.lineStyle(2, $44af089a9f2b65fe$var$ROLE_COLORS[role], 1);
            ring.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
        }, // The two halves of a hit's flash, drawn once per card and then only faded: a wash filling the
        // portrait area and a ring around the frame (which outlives the wash, so the card stays marked
        // as the one that was hit).
        this.drawWash = (wash)=>{
            wash.clear();
            wash.beginFill((0, $8d6533e00bd59062$export$c082e8bc79733f73), 1);
            wash.drawRoundedRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4e669d5539617474));
            wash.endFill();
        }, this.drawDamageRing = (ring)=>{
            ring.clear();
            ring.lineStyle(2, (0, $8d6533e00bd59062$export$7b5bc50f06bd4503), 1);
            ring.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
        }, // The grey a dead member's card goes under. Left just short of opaque, so the shape of the card
        // -- the portrait, the name -- is still faintly there under the ash rather than replaced by a
        // plain grey oblong.
        this.drawPall = (pall)=>{
            pall.clear();
            pall.beginFill($44af089a9f2b65fe$var$PALL_COLOR, 1);
            pall.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            pall.endFill();
        }, this.drawSelection = (selection, role)=>{
            selection.clear();
            selection.lineStyle(2, $44af089a9f2b65fe$var$ROLE_COLORS[role], 0.95);
            selection.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
        }, // Add (lord) or remove (non-lord) the animated fire-particle backdrop for a slot, matching its
        // role. The flame sits behind the portrait, clipped to the same inset rounded rect.
        this.ensureFlame = (slot)=>{
            const isLord = slot.role === "lord";
            if (isLord && !slot.flame) {
                const mask = this.makeMask();
                const flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8));
                flame.mask = mask;
                flame.zIndex = $44af089a9f2b65fe$var$Z_FLAME;
                slot.container.addChild(mask, flame);
                slot.flame = flame;
                slot.flameMask = mask;
            } else if (!isLord && slot.flame) {
                slot.flame.mask = null;
                slot.container.removeChild(slot.flame, slot.flameMask);
                slot.flame.destroy();
                slot.flameMask?.destroy();
                slot.flame = undefined;
                slot.flameMask = undefined;
            }
        }, // Advance the fire-particle backdrops, the starving pulse, the damage effects and the offscreen
        // speech lane (called each frame by GuiManager).
        this.animate = (dtMs)=>{
            this.pulseMs = (this.pulseMs + dtMs) % (0, $8d6533e00bd59062$export$d87ce5ad91d00207);
            // 1 -> 0.55 -> 1 over the period. Done with alpha rather than a redraw so a pulsing card
            // costs nothing beyond the value itself.
            const pulse = 0.55 + 0.45 * (0.5 + 0.5 * Math.cos(this.pulseMs / (0, $8d6533e00bd59062$export$d87ce5ad91d00207) * Math.PI * 2));
            this.damageFx.update(dtMs);
            this.slots.forEach((slot, entityId)=>{
                slot.flame?.update(dtMs, slot.fireStrength);
                slot.hungerBar.alpha = slot.hunger !== undefined && slot.hunger <= (0, $8d6533e00bd59062$export$e74fbfde0a93daa9) ? pulse : 1;
                this.applyDamage(slot, this.damageFx.frame(entityId));
            });
            this.updateSpeech(dtMs);
            this.updateDeaths(dtMs);
        }, // Put one card into the state a hit's frame asks for -- or back to rest when there is no hit.
        // The resting path touches nothing it doesn't have to, so an undamaged strip (the normal case)
        // costs a handful of assignments per card per frame and no redraw at all.
        this.applyDamage = (slot, frame)=>{
            if (!frame) {
                if (slot.damageSeq === 0) return;
                slot.damageSeq = 0;
                slot.container.x = slot.baseX;
                slot.container.y = 0;
                slot.container.scale.set(1);
                slot.wash.visible = false;
                slot.damageRing.visible = false;
                if (slot.damageNumber) slot.damageNumber.visible = false;
                if (slot.ghostRatio !== undefined) {
                    slot.ghostRatio = undefined;
                    this.drawHpBar(slot.hpBar, slot.hp, slot.hpMax);
                }
                return;
            }
            // Scale about the card's centre without a pivot (which `selectedCardAnchor` and the layout
            // below both read `container.x` raw for), by taking back half of what the growth adds.
            const grow = frame.scale - 1;
            slot.container.scale.set(frame.scale);
            slot.container.x = slot.baseX + frame.shakeX - grow * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2;
            slot.container.y = frame.shakeY - grow * (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) / 2;
            slot.wash.alpha = frame.flashAlpha;
            slot.wash.visible = frame.flashAlpha > 0.01;
            slot.damageRing.alpha = frame.ringAlpha;
            slot.damageRing.visible = frame.ringAlpha > 0.01;
            // The ghost holds still for the first fifth of the effect; only repaint the bar once it has
            // actually moved.
            if (slot.ghostRatio === undefined || Math.abs(slot.ghostRatio - frame.ghostRatio) > 0.004) {
                slot.ghostRatio = frame.ghostRatio;
                this.drawHpBar(slot.hpBar, slot.hp, slot.hpMax, frame.ghostRatio);
            }
            const damageNumber = this.ensureDamageNumber(slot);
            if (slot.damageSeq !== frame.seq) {
                slot.damageSeq = frame.seq;
                damageNumber.text = `-${frame.amount}`;
                damageNumber.x = Math.round((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2 - damageNumber.width / 2);
            }
            damageNumber.y = (0, $8d6533e00bd59062$export$db313b0d55ae90f4) - frame.numberRise;
            damageNumber.alpha = frame.numberAlpha;
            damageNumber.visible = frame.numberAlpha > 0.01;
        }, // The floating "-N" is built on the card's FIRST hit and then reused (its text is re-rasterized
        // per hit, which is once every 500ms at worst) -- a fresh Text per hit would churn a canvas-backed
        // texture through the GPU for every blow landed in the camp.
        this.ensureDamageNumber = (slot)=>{
            if (!slot.damageNumber) {
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $8d6533e00bd59062$export$e82906a3183f43fc)).bold().color((0, $8d6533e00bd59062$export$77f3d2d2b010c804)).render("");
                text.zIndex = $44af089a9f2b65fe$var$Z_DAMAGE_NUMBER;
                slot.container.addChild(text);
                slot.damageNumber = text;
            }
            return slot.damageNumber;
        }, // Hand the lane this frame's members and whatever they've said out of the player's sight, then
        // draw whichever single line it picked, plus the card flashes it wants.
        this.updateSpeech = (dtMs)=>{
            const members = Array.from(this.slots.entries()).map(([entityId, slot])=>({
                    entityId: entityId,
                    name: slot.name || ""
                }));
            this.speechLane.update(dtMs, members, this.guiManager.getOffscreenSpeech);
            // Hand the bubble this frame's target; it owns the fade and the swap between speakers.
            const line = this.speechLane.currentLine();
            const slot = line ? this.slots.get(line.entityId) : undefined;
            const target = line && slot ? {
                key: `${line.entityId}:${line.text}`,
                name: line.name,
                text: line.text,
                tailX: slot.baseX + (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2,
                tailY: -(0, $8d6533e00bd59062$export$2295e056c5b8b159),
                clampRight: this.slots.size * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) + (0, $8d6533e00bd59062$export$2295e056c5b8b159),
                color: $44af089a9f2b65fe$var$ROLE_COLORS[slot.role]
            } : null;
            this.speechBubble.update(dtMs, target);
            this.slots.forEach((s, entityId)=>{
                const alpha = this.speechLane.pulseAlpha(entityId);
                if (alpha > 0 && s.speakingRole !== s.role) {
                    this.drawSpeakingRing(s.speaking, s.role);
                    s.speakingRole = s.role;
                }
                s.speaking.alpha = alpha;
                s.speaking.visible = alpha > 0;
            });
        }, // A member has left the roster, which in an ember camp means they died. Hand their card over to
        // the death sequence instead of tearing it down: it holds its column, greys over, and breaks
        // apart (roster_death.ts owns the timings).
        this.beginDeath = (entityId, slot)=>{
            this.slots.delete(entityId);
            this.speechLane.forget(entityId);
            this.damageFx.forget(entityId);
            this.order = this.order.filter((id)=>id !== entityId);
            // A dead member is not somebody you can still click through to, and the card's live
            // decoration (the selection ring, a speech flash, a half-finished damage flash) has no
            // business outliving them.
            slot.container.interactive = false;
            slot.container.cursor = "default";
            slot.selection.visible = false;
            slot.speaking.visible = false;
            slot.wash.visible = false;
            slot.damageRing.visible = false;
            if (slot.damageNumber) slot.damageNumber.visible = false;
            slot.container.scale.set(1);
            if (this.selectedEntityId === entityId) this.selectedEntityId = undefined;
            const pall = new (0, $gwPoJ.Graphics)();
            this.drawPall(pall);
            pall.alpha = 0;
            pall.zIndex = $44af089a9f2b65fe$var$Z_DEATH_PALL;
            slot.container.addChild(pall);
            this.dying.set(entityId, {
                slot: slot,
                column: slot.column,
                elapsedMs: 0,
                pall: pall,
                shattered: false
            });
        }, // Advance every dying card: drain its colour, break it apart at the halfway mark, fly the shards,
        // and take the whole thing off the strip when it is done.
        this.updateDeaths = (dtMs)=>{
            let finished = false;
            this.dying.forEach((card, entityId)=>{
                card.elapsedMs += dtMs;
                if (!card.shattered) // Over the WHOLE card, bars and name included -- the member is gone, so nothing on
                // the card is still telling the player anything.
                card.pall.alpha = $44af089a9f2b65fe$var$PALL_MAX_ALPHA * (0, $bb9e23e7af52cc31$export$54311821b45b94a4)(card.elapsedMs);
                if (!card.shattered && (0, $bb9e23e7af52cc31$export$1d5894916c503cf9)(card.elapsedMs)) this.shatterCard(card);
                if (card.shattered && card.seeds && card.pieces) {
                    const shatterMs = card.elapsedMs - (0, $bb9e23e7af52cc31$export$db237cf1ba467f33);
                    card.seeds.forEach((seed, i)=>{
                        const piece = card.pieces[i];
                        const motion = (0, $bb9e23e7af52cc31$export$e174c14a9cb043b8)(shatterMs, seed);
                        if (!motion) return;
                        piece.x = seed.x + seed.w / 2 + motion.dx;
                        piece.y = seed.y + seed.h / 2 + motion.dy;
                        piece.angle = motion.angle;
                        piece.alpha = motion.alpha;
                    });
                }
                if ((0, $bb9e23e7af52cc31$export$b019cd4aafde2132)(card.elapsedMs)) {
                    this.endDeath(entityId, card);
                    finished = true;
                }
            });
            if (finished) {
                // The gap closes the moment the last shard has gone, rather than on whichever roster tick
                // happens to come next.
                this.layout();
                this.guiManager.positionEmberRoster();
            }
        }, // Break the (by now grey) card into shards: snapshot it to a texture, slice that into a grid of
        // little sprites, and hide the card itself. Without a renderer -- a test, or a context that is
        // gone -- there is nothing to photograph and nothing being watched either, so the card just goes
        // and the death runs out its clock with the column still held.
        this.shatterCard = (card)=>{
            card.shattered = true;
            const texture = this.captureCard(card.slot);
            if (!texture) {
                card.slot.container.visible = false;
                return;
            }
            // Clamped to what the photograph ACTUALLY measures, which can be a fraction less than the
            // card it photographed -- see captureCard. `new Texture` throws on a frame that does not fit
            // inside its base, and this runs from the render loop, where a throw used to stop the ticker
            // and freeze the whole client (see the frame guard in index.ts). captureCard now rounds the
            // capture up so this never binds; it stays because the cost of being wrong here is the game.
            const maxW = texture.baseTexture.width;
            const maxH = texture.baseTexture.height;
            const seeds = (0, $bb9e23e7af52cc31$export$62785211b15662cd)((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8)).map((seed)=>({
                    ...seed,
                    w: Math.min(seed.w, maxW - seed.x - $44af089a9f2b65fe$var$FRAME_EPSILON),
                    h: Math.min(seed.h, maxH - seed.y - $44af089a9f2b65fe$var$FRAME_EPSILON)
                }))// A shard that fell entirely outside the photograph has nothing to show.
            .filter((seed)=>seed.w > 0 && seed.h > 0);
            const shards = new (0, $8t5Gy.Container)();
            shards.position.set(card.column * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), 0);
            const pieces = seeds.map((seed)=>{
                const piece = new (0, $7Bs2Z.Sprite)(new (0, $klOfb.Texture)(texture.baseTexture, new (0, $6qzqq.Rectangle)(seed.x, seed.y, seed.w, seed.h)));
                // Spun about their own middles, so a shard tumbles rather than swinging around a corner.
                piece.anchor.set(0.5);
                piece.x = seed.x + seed.w / 2;
                piece.y = seed.y + seed.h / 2;
                shards.addChild(piece);
                return piece;
            });
            this.addChild(shards);
            card.texture = texture;
            card.shards = shards;
            card.pieces = pieces;
            card.seeds = seeds;
            card.slot.container.visible = false;
        }, // Snapshot one card into a texture of its own. The card is drawn at its own origin (its position
        // in the strip is put back straight afterwards) so the shards can be placed by the grid alone.
        this.captureCard = (slot)=>{
            const renderer = (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app?.renderer;
            if (!renderer) return null;
            try {
                const resolution = renderer.resolution || 1;
                // Asked for in whole DEVICE pixels, so the photograph can never come back smaller than
                // the card the shards are cut from -- see captureExtent for why that happens and what it
                // used to cost.
                const texture = (0, $klOfb.RenderTexture).create({
                    width: (0, $bb9e23e7af52cc31$export$3157021a2e406e10)((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), resolution),
                    height: (0, $bb9e23e7af52cc31$export$3157021a2e406e10)((0, $8d6533e00bd59062$export$4cacdb4184ffb7a8), resolution),
                    resolution: resolution
                });
                const savedX = slot.container.x;
                const savedY = slot.container.y;
                slot.container.position.set(0, 0);
                renderer.render(slot.container, {
                    renderTexture: texture,
                    clear: true
                });
                slot.container.position.set(savedX, savedY);
                return texture;
            } catch (e) {
                // A card that can't be photographed must not take the roster down with it.
                console.warn("[EmberRoster] card snapshot failed", e);
                return null;
            }
        }, this.endDeath = (entityId, card)=>{
            this.dying.delete(entityId);
            card.pall.destroy();
            if (card.shards) {
                this.removeChild(card.shards);
                card.shards.destroy({
                    children: true
                });
            }
            // The shards' sub-textures share this base texture, so it goes last, once they are gone.
            card.texture?.destroy(true);
            this.disposeSlot(card.slot);
        }, this.disposeSlot = (slot)=>{
            slot.speaking.destroy();
            slot.wash.destroy();
            slot.damageRing.destroy();
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(slot.container);
            slot.portrait.mask = null;
            slot.portrait.remove();
            if (slot.flame) {
                slot.flame.mask = null;
                slot.flame.destroy();
                slot.flameMask?.destroy();
            }
            this.removeChild(slot.container);
        }, this.drawPanel = (count)=>{
            this.clear();
            if (count < 1) return;
            const w = count * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) + (0, $8d6533e00bd59062$export$2295e056c5b8b159) * 2;
            const h = (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) + (0, $8d6533e00bd59062$export$2295e056c5b8b159) * 2;
            this.beginFill(0x10140f, 0.72);
            this.lineStyle(1, 0xffffff, 0.12);
            this.drawRoundedRect(-(0, $8d6533e00bd59062$export$2295e056c5b8b159), -(0, $8d6533e00bd59062$export$2295e056c5b8b159), w, h, 8);
            this.endFill();
        }, this.update = (roster)=>{
            // At most ONE hit sound per tick, however many members were hurt in it. The roster speaks
            // twice a second, so a wave mauling the whole camp would otherwise stack three or four
            // sounds into the same frame and arrive as a blur rather than as blows.
            let heardAHit = false;
            // Stable order (lord, defenders, foragers) so cards don't shuffle between ticks.
            const ordered = [
                ...roster
            ].sort((a, b)=>{
                const o = $44af089a9f2b65fe$var$ROLE_ORDER[a.role] - $44af089a9f2b65fe$var$ROLE_ORDER[b.role];
                return o !== 0 ? o : a.entityId.localeCompare(b.entityId);
            });
            const incoming = new Set(ordered.map((e)=>e.entityId));
            for (const [entityId, slot] of Array.from(this.slots.entries()))if (!incoming.has(entityId)) // Off the roster means dead (or gone): the card doesn't just disappear, it dies.
            this.beginDeath(entityId, slot);
            ordered.forEach((entry)=>{
                const appearanceKey = this.appearanceKeyFor(entry);
                let slot = this.slots.get(entry.entityId);
                if (!slot) {
                    const container = new (0, $8t5Gy.Container)();
                    container.interactive = true;
                    container.cursor = "pointer";
                    container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8));
                    container.sortableChildren = true;
                    const chrome = new (0, $gwPoJ.Graphics)();
                    this.drawChrome(chrome);
                    chrome.zIndex = $44af089a9f2b65fe$var$Z_CHROME;
                    const mask = this.makeMask();
                    const portrait = this.buildPortrait(entry);
                    portrait.mask = mask;
                    portrait.zIndex = $44af089a9f2b65fe$var$Z_PORTRAIT;
                    const scrim = new (0, $gwPoJ.Graphics)();
                    this.drawScrim(scrim);
                    scrim.zIndex = $44af089a9f2b65fe$var$Z_SCRIM;
                    const badge = this.makeBadge(entry.role);
                    badge.zIndex = $44af089a9f2b65fe$var$Z_BADGE;
                    const nameText = this.makeNameText(entry.name);
                    nameText.zIndex = $44af089a9f2b65fe$var$Z_NAME;
                    const hpBar = new (0, $gwPoJ.Graphics)();
                    this.drawHpBar(hpBar, entry.hp, entry.hpMax);
                    hpBar.zIndex = $44af089a9f2b65fe$var$Z_HP;
                    const hungerBar = new (0, $gwPoJ.Graphics)();
                    this.drawHungerBar(hungerBar, entry.hunger);
                    hungerBar.zIndex = $44af089a9f2b65fe$var$Z_HUNGER;
                    const selection = new (0, $gwPoJ.Graphics)();
                    selection.visible = false;
                    selection.zIndex = $44af089a9f2b65fe$var$Z_SELECTION;
                    const speaking = new (0, $gwPoJ.Graphics)();
                    speaking.visible = false;
                    speaking.zIndex = $44af089a9f2b65fe$var$Z_SPEAKING;
                    const wash = new (0, $gwPoJ.Graphics)();
                    this.drawWash(wash);
                    wash.visible = false;
                    wash.zIndex = $44af089a9f2b65fe$var$Z_WASH;
                    const damageRing = new (0, $gwPoJ.Graphics)();
                    this.drawDamageRing(damageRing);
                    damageRing.visible = false;
                    damageRing.zIndex = $44af089a9f2b65fe$var$Z_DAMAGE_RING;
                    container.addChild(chrome, portrait, mask, scrim, badge, nameText, hpBar, hungerBar, selection, speaking, wash, damageRing);
                    container.on("pointerdown", ()=>this.onSlotClick(entry.entityId));
                    slot = {
                        container: container,
                        portrait: portrait,
                        mask: mask,
                        badge: badge,
                        nameText: nameText,
                        hpBar: hpBar,
                        hungerBar: hungerBar,
                        hunger: entry.hunger,
                        selection: selection,
                        appearanceKey: appearanceKey,
                        role: entry.role,
                        name: entry.name,
                        hp: entry.hp,
                        hpMax: entry.hpMax,
                        baseX: 0,
                        column: 0,
                        fireStrength: entry.fireStrength ?? 0,
                        speaking: speaking,
                        wash: wash,
                        damageRing: damageRing,
                        damageSeq: 0
                    };
                    this.ensureFlame(slot);
                    this.slots.set(entry.entityId, slot);
                    this.addChild(container);
                } else {
                    // Rebuild only what actually changed (portrait rebuild + Text textures are costly).
                    if (slot.appearanceKey !== appearanceKey) {
                        slot.portrait.mask = null;
                        slot.portrait.remove();
                        const portrait = this.buildPortrait(entry);
                        portrait.mask = slot.mask;
                        portrait.zIndex = $44af089a9f2b65fe$var$Z_PORTRAIT;
                        slot.container.addChild(portrait);
                        slot.portrait = portrait;
                        slot.appearanceKey = appearanceKey;
                    }
                    if (slot.role !== entry.role) {
                        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(slot.badge);
                        slot.container.removeChild(slot.badge);
                        slot.badge = this.makeBadge(entry.role);
                        slot.badge.zIndex = $44af089a9f2b65fe$var$Z_BADGE;
                        slot.container.addChild(slot.badge);
                        slot.role = entry.role;
                    }
                    if (slot.name !== entry.name) {
                        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(slot.nameText);
                        slot.container.removeChild(slot.nameText);
                        slot.nameText = this.makeNameText(entry.name);
                        slot.nameText.zIndex = $44af089a9f2b65fe$var$Z_NAME;
                        slot.container.addChild(slot.nameText);
                        slot.name = entry.name;
                    }
                    if (slot.hp !== entry.hp || slot.hpMax !== entry.hpMax) {
                        // A member whose health went DOWN since the last tick was hurt -- the roster
                        // carries no hit event of its own, and this is the one place both numbers are
                        // known. Healing and a first sighting fall through to a plain redraw.
                        if (slot.hp !== undefined && entry.hp !== undefined && entry.hpMax) {
                            this.damageFx.hit(entry.entityId, slot.hp, entry.hp, entry.hpMax);
                            if (entry.hp < slot.hp && !heardAHit) {
                                // Somebody in the camp is being hurt out of sight. The card says so; the
                                // sound is what gets the player to look at it. GuiManager keeps quiet for
                                // a member close enough that the world already played their hit.
                                this.guiManager.playOffscreenHit(entry.entityId);
                                heardAHit = true;
                            }
                        }
                        slot.hp = entry.hp;
                        slot.hpMax = entry.hpMax;
                        this.drawHpBar(slot.hpBar, entry.hp, entry.hpMax, slot.ghostRatio);
                    }
                    if (slot.hunger !== entry.hunger) {
                        this.drawHungerBar(slot.hungerBar, entry.hunger);
                        slot.hunger = entry.hunger;
                    }
                    slot.fireStrength = entry.fireStrength ?? 0;
                    this.ensureFlame(slot);
                }
            });
            this.order = ordered.map((entry)=>entry.entityId);
            this.layout();
            this.applySelection();
        }, // Place every card in the strip and redraw the panel behind them. Cards whose member has died
        // keep the column they had, and the living lay out around those gaps -- so a card breaking apart
        // is never slid under by a survivor, and the strip only closes up once it has gone.
        //
        // Called on each roster tick AND the moment a death finishes, because the gap has to close then
        // rather than whenever the next tick happens to arrive.
        this.layout = ()=>{
            const total = this.order.length + this.dying.size;
            // Dying cards claim their column first, lowest first. An index that no longer exists (the
            // last card of the strip died) falls to the nearest one that does.
            const taken = new Set();
            Array.from(this.dying.values()).sort((a, b)=>a.column - b.column).forEach((card)=>{
                let column = Math.min(Math.max(0, card.column), Math.max(0, total - 1));
                while(taken.has(column))column = column + 1 >= total ? 0 : column + 1;
                taken.add(column);
                card.column = column;
                card.slot.column = column;
                this.place(card.slot, column);
                card.shards?.position.set(column * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), 0);
            });
            let column = 0;
            this.order.forEach((entityId)=>{
                const slot = this.slots.get(entityId);
                if (!slot) return;
                while(taken.has(column))column++;
                slot.column = column;
                this.place(slot, column);
                this.applyDamage(slot, this.damageFx.frame(entityId));
                column++;
            });
            this.drawPanel(total);
        }, // The card's resting place. Its ACTUAL position is set by applyDamage, which is what holds the
        // shake -- a roster tick landing mid-jolt would otherwise snap the card back.
        this.place = (slot, column)=>{
            slot.baseX = column * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e);
            slot.container.x = slot.baseX;
            slot.container.y = 0;
        }, // Take the whole strip down at once, with no death animation: this is a ROOM CHANGE, not a camp
        // losing its people, and a card cannot break apart over a room the player has already left.
        // (Not `clear`, which is Graphics' own.)
        this.clearRoster = ()=>{
            this.dying.forEach((card, entityId)=>this.endDeath(entityId, card));
            this.slots.forEach((slot, entityId)=>{
                this.disposeSlot(slot);
                this.speechLane.forget(entityId);
                this.damageFx.forget(entityId);
            });
            this.slots.clear();
            this.order = [];
            this.selectMember(undefined);
            this.drawPanel(0);
        }, // A card carries two different offers depending on who is on it. The LORD is the one member the
        // player never gives orders to, so his card opens the follow-cam PiP and lets you watch him.
        // Everyone else is under command, so their card opens THEIR command wheel above the strip --
        // which is the whole point of a roster you can reach an off-screen member through.
        this.onSlotClick = (entityId)=>{
            const slot = this.slots.get(entityId);
            if (!slot) return;
            // Whatever the last tap put up comes down first -- both live in the slot above the strip, and
            // only one card is ever the active one. It also makes tapping the ACTIVE card a toggle.
            const wasSelected = this.selectedEntityId === entityId;
            this.guiManager.closeRosterSelection();
            if (wasSelected) return;
            // Set AFTER the close above: closeRosterSelection clears the selection on its way out.
            this.selectMember(entityId);
            // The lord takes no orders, and neither does another PERSON: both cards open the follow cam
            // instead. For a partner that is the more useful half of the deal anyway -- a live window on
            // where they are and what is closing in on them, at the same zoom as the main camera, which
            // is the whole reason to glance at their card while they are off in the forest.
            if (slot.role === "lord" || slot.role === "player") this.guiManager.openFollowCam(entityId, slot.name);
            else this.guiManager.openRosterCommandWheel(entityId, slot.role);
        }, // The one place the active card changes. Besides lighting the card itself, the selected member is
        // outlined OUT IN THE WORLD with the same glow a pointed-at entity gets, so it is obvious which
        // character on screen the card belongs to. Everything that selects or deselects goes through here
        // so the world glow can never outlive the card highlight.
        this.selectMember = (entityId)=>{
            if (this.selectedEntityId === entityId) return;
            this.selectedEntityId = entityId;
            this.applySelection();
            this.guiManager.highlightEmberMember(entityId);
        }, // Called by GuiManager when whatever the card opened closes again (the follow-cam, or that
        // member's command wheel), so the highlighted card returns to normal.
        this.clearSelection = ()=>{
            this.selectMember(undefined);
        }, // --- What the strip currently holds. Live cards plus the ones still breaking apart, because to
        // everything outside this widget (its width, the gap it is holding) those count as cards too.
        this.cardCount = ()=>this.slots.size + this.dying.size, this.isDying = (entityId)=>this.dying.has(entityId), // Which column a card occupies, living or dying; -1 if it isn't on the strip at all.
        this.columnOf = (entityId)=>this.slots.get(entityId)?.column ?? this.dying.get(entityId)?.column ?? -1, // "greying" | "shattering" for a card on its way out, null for anything else.
        this.deathPhase = (entityId)=>{
            const card = this.dying.get(entityId);
            return card ? card.shattered ? "shattering" : "greying" : null;
        }, // Rendered panel extents (in the parent's coordinate space, i.e. including WIDGET_SCALE), so
        // GuiManager can right-/bottom-align the strip as the card count changes. Measured from this
        // widget's origin (x/y) to the panel's right / bottom edge.
        this.rightExtent = ()=>{
            // Cards still breaking apart hold their column, so they are still part of the strip's width.
            const count = this.slots.size + this.dying.size;
            return count < 1 ? 0 : (count * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) + (0, $8d6533e00bd59062$export$2295e056c5b8b159)) * $44af089a9f2b65fe$var$WIDGET_SCALE;
        }, this.bottomExtent = ()=>((0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) + (0, $8d6533e00bd59062$export$2295e056c5b8b159)) * $44af089a9f2b65fe$var$WIDGET_SCALE, // Distance from this widget's origin (y) up to the panel's top edge, INCLUDING the reserved
        // speech lane above it. Reserved whether or not a bubble is showing, so whatever sits above the
        // roster (the follow-cam PiP) doesn't jump every time someone speaks.
        this.topExtent = ()=>((0, $8d6533e00bd59062$export$2295e056c5b8b159) + $44af089a9f2b65fe$var$SPEECH_LANE_H) * $44af089a9f2b65fe$var$WIDGET_SCALE, // Top-centre of one member's card, in this widget's PARENT coordinate space (i.e. including this
        // widget's position and scale), plus the card's role colour. Null when that member has no card.
        // Used to draw a connector line from whatever the card opened back down to the card.
        //
        // `edge` picks which top the point sits on. The follow-cam's line is drawn OVER the strip and
        // stops at the card itself; a roster command wheel's line is drawn UNDER it (so a speech bubble
        // reads over the line) and has to stop at the panel's outer edge, or its end is buried.
        this.cardAnchor = (entityId, edge = "card")=>{
            if (!entityId) return null;
            const slot = this.slots.get(entityId);
            if (!slot) return null;
            // The card's RESTING centre: reading container.x would make the connector line wobble along
            // with a damage shake.
            const localCenterX = slot.baseX + (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2;
            return {
                x: this.x + localCenterX * this.scale.x,
                y: this.y - (edge === "panel" ? (0, $8d6533e00bd59062$export$2295e056c5b8b159) * this.scale.y : 0),
                color: $44af089a9f2b65fe$var$ROLE_COLORS[slot.role]
            };
        }, // The selected card's anchor, for the follow-cam PiP's connector line.
        this.selectedCardAnchor = ()=>this.cardAnchor(this.selectedEntityId), this.applySelection = ()=>{
            this.slots.forEach((slot, entityId)=>{
                const selected = this.selectedEntityId === entityId;
                if (selected) this.drawSelection(slot.selection, slot.role);
                slot.selection.visible = selected;
            });
        };
        this.guiManager = guiManager;
        this.scale.set($44af089a9f2b65fe$var$WIDGET_SCALE);
        this.speechBubble = new (0, $23d13a6e2a72aec5$export$1173af088df4f527)();
        this.addChild(this.speechBubble);
        this.exposeDevTriggers();
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
// Picture-in-picture "follow cam" opened from the ember roster. Shows the world rendered live,
// centred on a chosen entity, so the player can watch a defender/forager/lord wherever it is in
// the room. The actual world render into `texture` is driven each frame by PixiJsClientRenderer
// (renderWorldToTexture); this widget just owns the texture, frame, title and close button.
//
// TUNABLES (verify live): VIEW_W/H is the window size; ZOOM is the world scale shown inside it
// (1.0 shows ~VIEW_W px of world; raise to zoom in). Keep ZOOM's visible span within the client's
// FOCUS_RENDER_RADIUS or entities will pop at the edges.
const $a800cd15c7729c86$var$VIEW_W = 260;
const $a800cd15c7729c86$var$VIEW_H = 200;
const $a800cd15c7729c86$var$ZOOM = 1.0;
// The overlay renders into the PiP at scale zoom/surfaceZoom (0.5), which pixel-drops bitmap text.
// Render the texture at a higher resolution (2 x devicePixelRatio) so the downscaled text stays legible.
const $a800cd15c7729c86$var$PIP_RESOLUTION = 2 * (typeof window !== "undefined" && window.devicePixelRatio ? window.devicePixelRatio : 1);
const $a800cd15c7729c86$var$FRAME = 4;
// No title/name header — the PiP is just the framed world view.
const $a800cd15c7729c86$var$TITLE_H = 0;
class $a800cd15c7729c86$export$6b342f104f181be3 extends (0, $8t5Gy.Container) {
    constructor(guiManager){
        super(), this.isOpen_ = false, this.focusEntityId = null, this.drawFrame = ()=>{
            this.frame.clear();
            this.frame.beginFill(0x000000, 0.75);
            this.frame.lineStyle(2, 0xffffff, 0.5);
            this.frame.drawRoundedRect(0, 0, $a800cd15c7729c86$var$VIEW_W + $a800cd15c7729c86$var$FRAME * 2, $a800cd15c7729c86$var$VIEW_H + $a800cd15c7729c86$var$FRAME * 2 + $a800cd15c7729c86$var$TITLE_H, 6);
            this.frame.endFill();
        }, this.open = (entityId, _name)=>{
            this.focusEntityId = entityId;
            this.isOpen_ = true;
            this.visible = true;
        }, this.close = ()=>{
            this.isOpen_ = false;
            this.visible = false;
            this.focusEntityId = null;
        }, this.isOpen = ()=>this.isOpen_, this.getTexture = ()=>this.texture, this.getZoom = ()=>$a800cd15c7729c86$var$ZOOM, // Outer frame dimensions (for positioning the modal relative to other HUD elements).
        this.getWidth = ()=>$a800cd15c7729c86$var$VIEW_W + $a800cd15c7729c86$var$FRAME * 2, this.getHeight = ()=>$a800cd15c7729c86$var$VIEW_H + $a800cd15c7729c86$var$FRAME * 2 + $a800cd15c7729c86$var$TITLE_H;
        this.guiManager = guiManager;
        this.texture = (0, $klOfb.RenderTexture).create({
            width: $a800cd15c7729c86$var$VIEW_W,
            height: $a800cd15c7729c86$var$VIEW_H,
            resolution: $a800cd15c7729c86$var$PIP_RESOLUTION
        });
        this.frame = new (0, $gwPoJ.Graphics)();
        this.addChild(this.frame);
        this.drawFrame();
        this.view = new (0, $7Bs2Z.Sprite)(this.texture);
        this.view.x = $a800cd15c7729c86$var$FRAME;
        this.view.y = $a800cd15c7729c86$var$FRAME + $a800cd15c7729c86$var$TITLE_H;
        this.addChild(this.view);
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



// Frame thickness (matches the follow-cam PiP, which shares this HUD slot) and the largest the map
// SURFACE may get. The longer room axis maps to MAP_MAX and the shorter one shrinks in proportion,
// so the map always carries the room's own aspect ratio -- an ember camp is square, but nothing here
// assumes that.
const $27706b8361e494c8$var$FRAME = 4;
const $27706b8361e494c8$export$c974090714d23ec7 = 176;
const $27706b8361e494c8$var$CORNER = 6;
// The collapse control, hung off the map's top-right corner the way a dialog hangs its close button.
// Smaller than a dialog's on a pointer, because it is dismissing a HUD panel rather than a modal --
// but NOT under a thumb, where 8 stage pixels is about 10 CSS pixels of target and essentially
// unhittable. Everything that places it measures from this constant, so it costs no layout.
const $27706b8361e494c8$var$COLLAPSE_RADIUS = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? 15 : 8;
// Dot sizes and colours. White = camp member, red = wave attacker, bright green = you (the same
// green the world minimap has always used for the player). Trees are a DIM green wash painted under
// all of them: terrain, not a dot, and far enough from the player's bright green to never be mistaken
// for it.
const $27706b8361e494c8$var$DOT_R = 2.2;
const $27706b8361e494c8$var$PLAYER_DOT_R = 2.8;
const $27706b8361e494c8$var$MEMBER_COLOR = 0xffffff;
const $27706b8361e494c8$var$ATTACKER_COLOR = 0xff3b30;
const $27706b8361e494c8$var$PLAYER_COLOR = 0x39ff6a;
const $27706b8361e494c8$var$TREE_COLOR = 0x2f6b3d;
// Another person in the camp: a player, so player-sized and player-green, but a cooler, dimmer
// green than your own bright one. Near enough to read as "one of us" at a glance, far enough apart
// that you never mistake theirs for the dot you are steering.
const $27706b8361e494c8$var$PARTNER_COLOR = 0x2bc4a8;
// How much of the world the map lets through. The BACKDROP, its border and the tree wash are all
// semi-transparent so the map sits lightly over the game rather than punching a panel out of it; the
// dots stay fully opaque, because they are the thing the map is for.
const $27706b8361e494c8$var$PANEL_COLOR = 0x05070a;
const $27706b8361e494c8$var$PANEL_ALPHA = 0.59;
const $27706b8361e494c8$var$BORDER_ALPHA = 0.36;
const $27706b8361e494c8$var$TREE_ALPHA = 0.61;
const $27706b8361e494c8$export$a6ce970ca4241c6a = 1000;
const $27706b8361e494c8$export$f2723e5f32c829e9 = (track)=>{
    const p = $27706b8361e494c8$export$a6ce970ca4241c6a > 0 ? Math.max(0, Math.min(1, track.t / $27706b8361e494c8$export$a6ce970ca4241c6a)) : 1;
    return {
        x: track.fromX + (track.toX - track.fromX) * p,
        y: track.fromY + (track.toY - track.fromY) * p
    };
};
const $27706b8361e494c8$export$1db3e4d273a27613 = (entityTile)=>!!entityTile && /tree/i.test(entityTile);
const $27706b8361e494c8$export$d8cdfd7fe35d629c = (map, tilesWide, tilesHigh)=>{
    const cells = [];
    if (!map || !(tilesWide > 0) || !(tilesHigh > 0)) return cells;
    for(let x = 0; x < tilesWide; x++){
        for(let y = 0; y < tilesHigh; y++)if ($27706b8361e494c8$export$1db3e4d273a27613(map.getEntityTileAt(x, y)?.entityTile)) cells.push({
            x: x,
            y: y
        });
    }
    return cells;
};
const $27706b8361e494c8$export$7d8c499170a003eb = (dot, room, mapW, mapH)=>{
    const fx = room.width > 0 ? dot.x / room.width : 0;
    const fy = room.height > 0 ? dot.y / room.height : 0;
    return {
        x: Math.max(0, Math.min(1, fx)) * mapW,
        y: Math.max(0, Math.min(1, fy)) * mapH
    };
};
const $27706b8361e494c8$export$750bcf04cfea520e = (room)=>{
    if (!(room.width > 0) || !(room.height > 0)) return {
        w: $27706b8361e494c8$export$c974090714d23ec7,
        h: $27706b8361e494c8$export$c974090714d23ec7
    };
    const longest = Math.max(room.width, room.height);
    return {
        w: Math.round(room.width / longest * $27706b8361e494c8$export$c974090714d23ec7),
        h: Math.round(room.height / longest * $27706b8361e494c8$export$c974090714d23ec7)
    };
};
const $27706b8361e494c8$export$39715f4eaf395d01 = (at, panel, bounds)=>({
        x: (0, $10da07838e6d507c$export$7d15b64cf5a3a4c4)(at.x, bounds.left, Math.max(bounds.left, bounds.right - panel.width)),
        y: (0, $10da07838e6d507c$export$7d15b64cf5a3a4c4)(at.y, bounds.top, Math.max(bounds.top, bounds.bottom - panel.height))
    });
class $27706b8361e494c8$export$72d7fbba603469ff extends (0, $8t5Gy.Container) {
    // `onCollapse` is what the corner control calls and `drag` is who moves the panel; both optional
    // only so the widget can be stood up bare in a test.
    constructor(onCollapse, drag){
        super(), this.frame = new (0, $gwPoJ.Graphics)(), this.trees = new (0, $gwPoJ.Graphics)(), this.dots = new (0, $gwPoJ.Graphics)(), this.playerDot = new (0, $gwPoJ.Graphics)(), this.state = null, this.mapW = $27706b8361e494c8$export$c974090714d23ec7, this.mapH = $27706b8361e494c8$export$c974090714d23ec7, // The last tree scan, kept so the layer can be repainted if the map's extent changes under it.
        this.treeCells = [], this.treeTilesWide = 0, this.treeTilesHigh = 0, // Where each dot is travelling, keyed by its entity id -- the whole reason the dots carry one.
        // Kept per kind because a camper never becomes an attacker, and it saves storing the colour.
        this.memberTracks = new Map(), this.attackerTracks = new Map(), // The other PEOPLE in the camp. Glided like the rest -- they come off the same once-a-second
        // feed -- and kept apart from `members` so they can be drawn last, bigger and in their own
        // green. The viewer is never in here; the server leaves them out, and their own dot is
        // `playerDot`, repositioned every frame off the entity the client already tracks.
        this.partnerTracks = new Map(), // The extent the frame was last drawn for, so a steady stream of broadcasts doesn't redraw it.
        this.drawnExtent = "", // Whether the pointer currently has hold of the panel, and where it took hold: the panel's origin
        // MINUS the pointer, in PARENT coordinates. Fixed at pointerdown rather than recomputed per frame,
        // or a drag that ran into a screen edge and came back would leave the panel creeping out from
        // under the cursor.
        this.grabbed = false, this.grabDx = 0, this.grabDy = 0, // Make the whole panel a grab handle. Deliberately NO hitArea of its own: the frame graphic
        // already IS the panel's shape, and pixi skips a container's children entirely once the pointer
        // falls outside an explicit hitArea -- which would strand the collapse control in its hover state
        // whenever the pointer left the map in one jump.
        //
        // pointermove/pointerup are bound here rather than on some capture layer because pixi dispatches
        // both to every interactive object regardless of what was hit (moveWhenInside is off), so a drag
        // keeps its stream of moves even while the pointer is way off the panel -- which it will be the
        // moment the panel is dragged up against a screen edge.
        this.attachDrag = (drag)=>{
            this.drag = drag;
            this.interactive = true;
            this.cursor = "grab";
            this.on("pointerdown", this.onGrab);
            this.on("pointermove", this.onDragMove);
            this.on("pointerup", this.onRelease);
            this.on("pointerupoutside", this.onRelease);
        }, // A press on the panel takes hold of it -- unless it landed on the collapse control, the one thing
        // up here that is not a grab handle. (pixi bubbles a child's pointerdown to its parent, and
        // `target` is the deepest INTERACTIVE object that was actually hit, so that is what tells them
        // apart.)
        this.onGrab = (event)=>{
            if (event.target !== this || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            this.grabDx = this.x - pointer.x;
            this.grabDy = this.y - pointer.y;
            this.grabbed = true;
            this.cursor = "grabbing";
            this.drag?.onGrab();
        }, this.onDragMove = (event)=>{
            if (!this.grabbed || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            this.drag?.onDragTo(pointer.x + this.grabDx, pointer.y + this.grabDy);
        }, this.onRelease = ()=>{
            if (!this.grabbed) return;
            this.grabbed = false;
            this.cursor = "grab";
            this.drag?.onRelease();
        }, // Pin the collapse control INSIDE the map's top-right corner. A dialog hangs its close button
        // over the corner, but this panel is right-justified a few px from the edge of the screen, so a
        // button hanging off it would sit half in the margin. Tucked in instead.
        this.positionCollapseButton = ()=>{
            this.collapseButton.x = this.getWidth() - $27706b8361e494c8$var$COLLAPSE_RADIUS - 3;
            this.collapseButton.y = $27706b8361e494c8$var$COLLAPSE_RADIUS + 3;
        }, this.drawFrame = ()=>{
            this.frame.clear();
            this.frame.beginFill($27706b8361e494c8$var$PANEL_COLOR, $27706b8361e494c8$var$PANEL_ALPHA);
            this.frame.lineStyle(2, 0xffffff, $27706b8361e494c8$var$BORDER_ALPHA);
            this.frame.drawRoundedRect(0, 0, this.mapW + $27706b8361e494c8$var$FRAME * 2, this.mapH + $27706b8361e494c8$var$FRAME * 2, $27706b8361e494c8$var$CORNER);
            this.frame.endFill();
            this.positionCollapseButton();
        }, this.drawPlayerDot = ()=>{
            this.playerDot.clear();
            this.playerDot.beginFill($27706b8361e494c8$var$PLAYER_COLOR, 1);
            this.playerDot.drawCircle(0, 0, $27706b8361e494c8$var$PLAYER_DOT_R);
            this.playerDot.endFill();
            this.playerDot.visible = false;
        }, // One cell-sized square per tree tile. Rects rather than circles because a forest is hundreds of
        // cells and a square is 2 triangles to a circle's dozens — and at ~3.5px a tile, a square IS the
        // honest shape for "this cell has canopy in it".
        this.drawTrees = ()=>{
            this.trees.clear();
            if (this.treeCells.length < 1 || !(this.treeTilesWide > 0) || !(this.treeTilesHigh > 0)) return;
            const cellW = this.mapW / this.treeTilesWide;
            const cellH = this.mapH / this.treeTilesHigh;
            // Overdrawn by a hair so neighbouring cells of one canopy read as a clump, not a grid.
            const w = cellW + 0.5;
            const h = cellH + 0.5;
            this.trees.beginFill($27706b8361e494c8$var$TREE_COLOR, $27706b8361e494c8$var$TREE_ALPHA);
            for (const cell of this.treeCells)this.trees.drawRect($27706b8361e494c8$var$FRAME + cell.x * cellW, $27706b8361e494c8$var$FRAME + cell.y * cellH, w, h);
            this.trees.endFill();
        }, this.plot = (tracks, color, radius = $27706b8361e494c8$var$DOT_R)=>{
            if (tracks.size < 1) return;
            this.dots.beginFill(color, 1);
            tracks.forEach((track)=>{
                const p = $27706b8361e494c8$export$7d8c499170a003eb($27706b8361e494c8$export$f2723e5f32c829e9(track), this.state, this.mapW, this.mapH);
                this.dots.drawCircle($27706b8361e494c8$var$FRAME + p.x, $27706b8361e494c8$var$FRAME + p.y, radius);
            });
            this.dots.endFill();
        }, this.drawDots = ()=>{
            this.dots.clear();
            if (!this.state) return;
            // Attackers last so an attacker standing on a defender still reads as the threat -- but
            // partners after even them: a person is never the thing you want hidden under a dot, and an
            // attacker ON a partner is read off the red crowding them rather than off the green going
            // missing.
            this.plot(this.memberTracks, $27706b8361e494c8$var$MEMBER_COLOR);
            this.plot(this.attackerTracks, $27706b8361e494c8$var$ATTACKER_COLOR);
            this.plot(this.partnerTracks, $27706b8361e494c8$var$PARTNER_COLOR, $27706b8361e494c8$var$PLAYER_DOT_R);
        }, // Fold one snapshot's dots into their tracks: a dot seen before is re-aimed FROM wherever it has
        // glided to so far (never from its last reported position, which would snap it back), a dot seen
        // for the first time simply appears where it is, and a dot that has gone is dropped.
        this.syncTracks = (tracks, dots)=>{
            const present = new Set();
            for (const dot of dots || []){
                if (!dot || dot.id === undefined) continue;
                present.add(dot.id);
                const track = tracks.get(dot.id);
                if (!track) {
                    tracks.set(dot.id, {
                        fromX: dot.x,
                        fromY: dot.y,
                        toX: dot.x,
                        toY: dot.y,
                        t: $27706b8361e494c8$export$a6ce970ca4241c6a
                    });
                    continue;
                }
                if (track.toX === dot.x && track.toY === dot.y) continue;
                const at = $27706b8361e494c8$export$f2723e5f32c829e9(track);
                track.fromX = at.x;
                track.fromY = at.y;
                track.toX = dot.x;
                track.toY = dot.y;
                track.t = 0;
            }
            for (const id of Array.from(tracks.keys()))if (!present.has(id)) tracks.delete(id);
        }, // Advance every glide by a frame, and repaint the dots only if any of them actually moved. A camp
        // standing still costs nothing.
        this.animate = (dtMs)=>{
            if (!this.state) return;
            let moved = false;
            const advance = (tracks)=>tracks.forEach((track)=>{
                    if (track.t < $27706b8361e494c8$export$a6ce970ca4241c6a) {
                        track.t = Math.min($27706b8361e494c8$export$a6ce970ca4241c6a, track.t + dtMs);
                        moved = true;
                    }
                });
            advance(this.memberTracks);
            advance(this.attackerTracks);
            advance(this.partnerTracks);
            if (moved) this.drawDots();
        }, // Take the latest snapshot (null clears the map, e.g. on leaving the room).
        this.update = (state)=>{
            this.state = state;
            if (!state) {
                this.dots.clear();
                this.trees.clear();
                this.treeCells = [];
                this.treeTilesWide = 0;
                this.treeTilesHigh = 0;
                this.memberTracks.clear();
                this.attackerTracks.clear();
                this.partnerTracks.clear();
                this.playerDot.visible = false;
                return;
            }
            const extent = `${state.width}x${state.height}`;
            if (extent !== this.drawnExtent) {
                const size = $27706b8361e494c8$export$750bcf04cfea520e(state);
                this.mapW = size.w;
                this.mapH = size.h;
                this.drawnExtent = extent;
                this.drawFrame();
                // The tree layer is laid out in the surface's px, so it has to follow the surface.
                this.drawTrees();
            }
            this.syncTracks(this.memberTracks, state.members);
            this.syncTracks(this.attackerTracks, state.attackers);
            // Absent on an older server's snapshot; syncTracks reads a missing list as an empty one,
            // which correctly empties the partner tracks rather than freezing the last dots in place.
            this.syncTracks(this.partnerTracks, state.players);
            this.drawDots();
        }, // Replace the forest. `cells` are TILE coordinates in a room `tilesWide` x `tilesHigh` tiles; the
        // caller (GuiManager) scans them off the client's own tile map and only when it has changed.
        this.updateTrees = (cells, tilesWide, tilesHigh)=>{
            this.treeCells = cells || [];
            this.treeTilesWide = tilesWide;
            this.treeTilesHigh = tilesHigh;
            this.drawTrees();
        }, // Move the player's own dot. Called every frame with the client's live player location, which is
        // predicted locally and so smoother than anything the broadcast could carry.
        this.trackPlayer = (location)=>{
            if (!this.state || !location) {
                this.playerDot.visible = false;
                return;
            }
            const p = $27706b8361e494c8$export$7d8c499170a003eb(location, this.state, this.mapW, this.mapH);
            this.playerDot.position.set($27706b8361e494c8$var$FRAME + p.x, $27706b8361e494c8$var$FRAME + p.y);
            this.playerDot.visible = true;
        }, // Whether there is a room to draw at all -- GuiManager keeps the widget off screen until the
        // first broadcast arrives, and takes it down again on leaving the room.
        this.hasData = ()=>!!this.state, // The room's extent in TILES, for the caller's tree scan. Zero until the first broadcast.
        this.tilesWide = ()=>this.state ? Math.round(this.state.width / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) : 0, this.tilesHigh = ()=>this.state ? Math.round(this.state.height / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) : 0, // Outer frame dimensions, for positioning against the rest of the HUD.
        this.getWidth = ()=>this.mapW + $27706b8361e494c8$var$FRAME * 2, this.getHeight = ()=>this.mapH + $27706b8361e494c8$var$FRAME * 2, // Test seam: the corner control that folds the map away.
        this.collapseControl = ()=>this.collapseButton, // Test seam: whether the pointer currently has hold of the panel.
        this.isGrabbed = ()=>this.grabbed, // Test seams: what the map is currently showing.
        this.memberCount = ()=>this.memberTracks.size, this.attackerCount = ()=>this.attackerTracks.size, // Where a dot is being drawn right now, in ROOM (fine) coordinates -- i.e. part-way through its
        // glide, not where the last snapshot put it.
        this.dotPosition = (id)=>{
            const track = this.memberTracks.get(id) || this.attackerTracks.get(id) || this.partnerTracks.get(id);
            return track ? $27706b8361e494c8$export$f2723e5f32c829e9(track) : null;
        }, this.treeCount = ()=>this.treeCells.length, this.isTrackingPlayer = ()=>this.playerDot.visible, this.playerDotPosition = ()=>({
                x: this.playerDot.x,
                y: this.playerDot.y
            });
        this.addChild(this.frame, this.trees, this.dots, this.playerDot);
        this.collapseButton = new (0, $e59d4eca9b366180$export$de65de8213222d10)({
            radius: $27706b8361e494c8$var$COLLAPSE_RADIUS,
            onClick: onCollapse
        });
        this.addChild(this.collapseButton);
        this.drawPlayerDot();
        this.drawFrame();
        this.attachDrag(drag);
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");


const $b63697c140e90637$export$3334ef930a1012a = 6;
const $b63697c140e90637$export$96ce6b4b664e61a3 = 4;
const $b63697c140e90637$var$CORNER = 5;
const $b63697c140e90637$var$GLYPH_SIZE = 11;
const $b63697c140e90637$var$GAP = 4;
const $b63697c140e90637$export$1193eaef86e14179 = 0x05070a;
const $b63697c140e90637$export$4d5d11e976d0c432 = 0.59;
const $b63697c140e90637$export$a51459aea0dfefc8 = 0.82;
const $b63697c140e90637$export$3abdbd57ee78af1d = 0.36;
const $b63697c140e90637$export$93ef67ef32ca60d0 = 0.75;
const $b63697c140e90637$export$fbad5307eca418e5 = 0xcfd8dc;
const $b63697c140e90637$export$555570afd9db0e6 = 0xffffff;
// How far proud of the plate the tap/click target reaches. These chips are small on any screen and
// genuinely small under a thumb, and each is the only way to whatever it opens, so the target is
// grown rather than the pill -- a bigger pill would eat the corner the map itself wants.
const $b63697c140e90637$var$HIT_PAD = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? 10 : 3;
class $b63697c140e90637$export$81c7dcc65e224ff6 extends (0, $8t5Gy.Container) {
    constructor({ glyph: glyph, label: label, onClick: onClick }){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.draw = (hover)=>{
            this.plate.clear();
            this.plate.beginFill($b63697c140e90637$export$1193eaef86e14179, hover ? $b63697c140e90637$export$a51459aea0dfefc8 : $b63697c140e90637$export$4d5d11e976d0c432);
            this.plate.lineStyle(1, 0xffffff, hover ? $b63697c140e90637$export$93ef67ef32ca60d0 : $b63697c140e90637$export$3abdbd57ee78af1d);
            this.plate.drawRoundedRect(0, 0, this.getWidth(), this.getHeight(), $b63697c140e90637$var$CORNER);
            this.plate.endFill();
            this.label.tint = hover ? $b63697c140e90637$export$555570afd9db0e6 : $b63697c140e90637$export$fbad5307eca418e5;
        }, // Measured off the content rather than getBounds(), so the plate can be drawn to the size the
        // caller is about to position against without a chicken-and-egg on bounds.
        this.getWidth = ()=>$b63697c140e90637$export$3334ef930a1012a * 2 + this.glyph.width + $b63697c140e90637$var$GAP + this.label.width, this.getHeight = ()=>$b63697c140e90637$export$96ce6b4b664e61a3 * 2 + Math.max(this.glyph.height, this.label.height);
        // No tint on the emoji -- it carries its own colours.
        this.glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($b63697c140e90637$var$GLYPH_SIZE).render(glyph);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(label);
        this.glyph.x = $b63697c140e90637$export$3334ef930a1012a;
        this.label.x = $b63697c140e90637$export$3334ef930a1012a + this.glyph.width + $b63697c140e90637$var$GAP;
        // Both sit on a shared centre line, so the glyph and the text don't stagger.
        const h = Math.max(this.glyph.height, this.label.height);
        this.glyph.y = $b63697c140e90637$export$96ce6b4b664e61a3 + (h - this.glyph.height) / 2;
        this.label.y = $b63697c140e90637$export$96ce6b4b664e61a3 + (h - this.label.height) / 2;
        this.addChild(this.plate, this.glyph, this.label);
        this.draw(false);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(-$b63697c140e90637$var$HIT_PAD, -$b63697c140e90637$var$HIT_PAD, this.getWidth() + $b63697c140e90637$var$HIT_PAD * 2, this.getHeight() + $b63697c140e90637$var$HIT_PAD * 2);
        this.on("mouseover", ()=>this.draw(true));
        this.on("mouseout", ()=>this.draw(false));
        this.on("click", onClick);
        this.on("tap", onClick);
        // Every chip in this row is put on screen by whatever owns it, once it has something to
        // say. None of them should appear merely by being constructed.
        this.visible = false;
    }
}


class $4a2d6e0f8539e4d1$export$3adb491320ceffcc extends (0, $b63697c140e90637$export$81c7dcc65e224ff6) {
    constructor(onClick){
        super({
            glyph: "\uD83C\uDF92",
            label: "ITEMS",
            onClick: onClick
        });
    }
}



class $d36eec2a890b47fd$export$155d6b3ee6ea424d extends (0, $b63697c140e90637$export$81c7dcc65e224ff6) {
    constructor(onClick){
        super({
            glyph: "\uD83D\uDDFA",
            label: "MAP",
            onClick: onClick
        });
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");

// The "you are not alone" chip: a small pill in the top-right corner, beside the map toggle, carrying
// the number of OTHER players logged into the server. It is present only while there is somebody else
// to count -- a solo camp has no use for it, and the corner is better empty than occupied by a zero.
//
// Deliberately built off the map chip's own plate (dark translucent, thin light rim, glyph + label) so
// the pair reads as one row of controls rather than two unrelated badges.
//
// Because it appears on its own -- nothing the player did puts it there -- it announces itself with an
// orange FLASH on arrival. See flash()/animate(): a couple of hot pulses that decay back to the
// resting plate, which is enough to catch the eye without turning into a permanent blinking light.
const $847e936c2402c20f$var$PAD_X = 6;
const $847e936c2402c20f$var$PAD_Y = 4;
const $847e936c2402c20f$var$CORNER = 5;
const $847e936c2402c20f$var$GLYPH = "\uD83D\uDC65";
const $847e936c2402c20f$var$GLYPH_SIZE = 11;
const $847e936c2402c20f$var$GAP = 4;
const $847e936c2402c20f$var$PANEL_COLOR = 0x05070a;
const $847e936c2402c20f$var$PANEL_ALPHA = 0.59;
const $847e936c2402c20f$var$PANEL_ALPHA_HOVER = 0.82;
const $847e936c2402c20f$var$BORDER_ALPHA = 0.36;
const $847e936c2402c20f$var$BORDER_ALPHA_HOVER = 0.75;
const $847e936c2402c20f$var$LABEL_COLOR = 0xcfd8dc;
const $847e936c2402c20f$var$LABEL_COLOR_HOVER = 0xffffff;
const $847e936c2402c20f$export$11e650aef6b1dd3a = 0xff8a1f;
const $847e936c2402c20f$export$6c1279663b1160c7 = 1400;
const $847e936c2402c20f$var$FLASH_PULSES = 2.5;
const $847e936c2402c20f$export$6b162bbd73b17f58 = (remainingMs)=>{
    if (!(remainingMs > 0)) return 0;
    const remaining = Math.min(1, remainingMs / $847e936c2402c20f$export$6c1279663b1160c7);
    // Pulses run on the ELAPSED fraction so the train starts hot at its first peak rather than at
    // zero, and `remaining` (squared, so the tail goes quietly) is the envelope.
    const elapsed = 1 - remaining;
    const pulse = Math.abs(Math.cos(elapsed * Math.PI * $847e936c2402c20f$var$FLASH_PULSES));
    return pulse * remaining * remaining;
};
const $847e936c2402c20f$export$33ee99e9ec522cbf = (from, to, amount)=>{
    const a = Math.max(0, Math.min(1, amount));
    const mix = (shift)=>{
        const f = from >> shift & 0xff;
        const t = to >> shift & 0xff;
        return Math.round(f + (t - f) * a) & 0xff;
    };
    return mix(16) << 16 | mix(8) << 8 | mix(0);
};
class $847e936c2402c20f$export$79ada16547910660 extends (0, $8t5Gy.Container) {
    constructor(onClick){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.count = 0, this.hovered = false, this.flashMs = 0, // How many others there are. Going from none to some is what makes the chip appear, and an
        // appearance always flashes -- including one caused by walking into a camp while somebody else is
        // already online, which is exactly the case worth announcing.
        this.update = (count)=>{
            const next = Math.max(0, Math.floor(count || 0));
            const appearing = next > 0 && this.count < 1;
            this.count = next;
            this.label.text = String(next);
            this.layout();
            this.visible = next > 0;
            if (appearing) this.flash();
            this.draw();
        }, this.flash = ()=>{
            this.flashMs = $847e936c2402c20f$export$6c1279663b1160c7;
        }, this.isFlashing = ()=>this.flashMs > 0, // Drain the flash. Only repaints while one is running, so a chip that has settled costs nothing
        // per frame.
        this.animate = (dtMs)=>{
            if (this.flashMs <= 0) return;
            this.flashMs = Math.max(0, this.flashMs - dtMs);
            this.draw();
        }, // Both sit on a shared centre line, so the glyph and the count don't stagger. Re-run whenever the
        // count's width changes (1 digit to 2), which also moves the hit area.
        this.layout = ()=>{
            this.glyph.x = $847e936c2402c20f$var$PAD_X;
            this.label.x = $847e936c2402c20f$var$PAD_X + this.glyph.width + $847e936c2402c20f$var$GAP;
            const h = Math.max(this.glyph.height, this.label.height);
            this.glyph.y = $847e936c2402c20f$var$PAD_Y + (h - this.glyph.height) / 2;
            this.label.y = $847e936c2402c20f$var$PAD_Y + (h - this.label.height) / 2;
            // An explicit hit area a couple of px proud of the plate: the chip is small, and it is the one
            // way into the player list.
            this.hitArea = new (0, $6qzqq.Rectangle)(-3, -3, this.getWidth() + 6, this.getHeight() + 6);
        }, this.draw = ()=>{
            const hot = $847e936c2402c20f$export$6b162bbd73b17f58(this.flashMs);
            this.plate.clear();
            this.plate.beginFill($847e936c2402c20f$export$33ee99e9ec522cbf($847e936c2402c20f$var$PANEL_COLOR, $847e936c2402c20f$export$11e650aef6b1dd3a, hot * 0.75), (this.hovered ? $847e936c2402c20f$var$PANEL_ALPHA_HOVER : $847e936c2402c20f$var$PANEL_ALPHA) + hot * (1 - $847e936c2402c20f$var$PANEL_ALPHA));
            this.plate.lineStyle(1 + hot, $847e936c2402c20f$export$33ee99e9ec522cbf(0xffffff, $847e936c2402c20f$export$11e650aef6b1dd3a, hot), Math.min(1, (this.hovered ? $847e936c2402c20f$var$BORDER_ALPHA_HOVER : $847e936c2402c20f$var$BORDER_ALPHA) + hot));
            this.plate.drawRoundedRect(0, 0, this.getWidth(), this.getHeight(), $847e936c2402c20f$var$CORNER);
            this.plate.endFill();
            this.label.tint = $847e936c2402c20f$export$33ee99e9ec522cbf(this.hovered ? $847e936c2402c20f$var$LABEL_COLOR_HOVER : $847e936c2402c20f$var$LABEL_COLOR, 0xffffff, hot);
        }, // Measured off the content rather than getBounds(), so the plate can be drawn to the size the
        // caller is about to position against without a chicken-and-egg on bounds.
        this.getWidth = ()=>$847e936c2402c20f$var$PAD_X * 2 + this.glyph.width + $847e936c2402c20f$var$GAP + this.label.width, this.getHeight = ()=>$847e936c2402c20f$var$PAD_Y * 2 + Math.max(this.glyph.height, this.label.height);
        // No tint on the emoji -- it carries its own colours.
        this.glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($847e936c2402c20f$var$GLYPH_SIZE).render($847e936c2402c20f$var$GLYPH);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("0");
        this.layout();
        this.addChild(this.plate, this.glyph, this.label);
        this.draw();
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mouseover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("mouseout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.on("click", onClick);
        this.on("tap", onClick);
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");


// Panel geometry. Sized to the right-hand HUD gutter: wide enough for a name, a wave badge and a
// button side by side, and no wider, because everything else on that edge (the map, the roster strip)
// has to keep its own room.
const $031092a28fb787ca$var$WIDTH = 186;
const $031092a28fb787ca$var$PAD = 8;
const $031092a28fb787ca$var$CORNER = 6;
const $031092a28fb787ca$var$HEADER_H = 18;
const $031092a28fb787ca$var$ROW_H = 21;
const $031092a28fb787ca$var$ROW_GAP = 2;
const $031092a28fb787ca$export$29aaa579571d742c = 5;
const $031092a28fb787ca$var$FOOTER_H = 12;
const $031092a28fb787ca$export$6881c612b1e8acd5 = 13;
const $031092a28fb787ca$var$PANEL_COLOR = 0x05070a;
const $031092a28fb787ca$var$PANEL_ALPHA = 0.82;
const $031092a28fb787ca$var$BORDER_ALPHA = 0.36;
const $031092a28fb787ca$var$HEADER_COLOR = 0x8d97ad;
const $031092a28fb787ca$var$NAME_COLOR = 0xe6e9f0;
const $031092a28fb787ca$var$NAME_COLOR_HERE = 0x9fe6a8 // already in your camp -- the same green the map draws a friend in
;
const $031092a28fb787ca$var$WAVE_COLOR = 0xffab66;
const $031092a28fb787ca$var$WAVE_IDLE_COLOR = 0x6b7382;
// The invite button.
const $031092a28fb787ca$var$BUTTON_W = 46;
const $031092a28fb787ca$var$BUTTON_H = 15;
const $031092a28fb787ca$var$BUTTON_FILL = 0x1b2030;
const $031092a28fb787ca$var$BUTTON_FILL_HOVER = 0x33405e;
const $031092a28fb787ca$var$BUTTON_RIM = 0xff8a1f;
const $031092a28fb787ca$var$BUTTON_RIM_IDLE = 0x8d97ad;
const $031092a28fb787ca$var$BUTTON_TEXT = 0xffe6b0;
const $031092a28fb787ca$export$e22393ef4e0495dc = 2500;
const $031092a28fb787ca$export$988945b3d699075c = (name)=>{
    if (!name) return "???";
    return name.length > $031092a28fb787ca$export$6881c612b1e8acd5 ? name.slice(0, $031092a28fb787ca$export$6881c612b1e8acd5 - 1) + "\u2026" : name;
};
const $031092a28fb787ca$export$447f0dcdd48b7fcc = (wave)=>{
    if (wave === undefined || wave === null) return "\u2014";
    return wave > 0 ? `W${wave}` : "\u2022";
};
class $031092a28fb787ca$export$349ef492ca0f8a2a extends (0, $8t5Gy.Container) {
    constructor({ onInvite: onInvite, onClose: onClose }){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.rowsLayer = new (0, $8t5Gy.Container)(), this.rows = new Map(), this.players = [], this.overflow = 0, // "Asked" is remembered per player rather than per row, so a list that rebuilds underneath the
        // player (somebody's wave ticked over) doesn't swallow the acknowledgement they just earned.
        this.sentAt = new Map(), // The players to list, newest state wins. Rows are reconciled by entity id rather than rebuilt,
        // so a list that refreshes while the pointer is over a button doesn't pull it out from under them.
        this.update = (players)=>{
            const listed = (players || []).slice(0, $031092a28fb787ca$export$29aaa579571d742c);
            this.players = listed;
            this.overflow = Math.max(0, (players || []).length - listed.length);
            const seen = new Set();
            listed.forEach((player, index)=>{
                seen.add(player.entityId);
                const row = this.rows.get(player.entityId) || this.buildRow(player);
                this.rows.set(player.entityId, row);
                this.fillRow(row, player);
                row.container.y = index * ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP);
            });
            Array.from(this.rows.keys()).forEach((entityId)=>{
                if (!seen.has(entityId)) {
                    const row = this.rows.get(entityId);
                    this.rowsLayer.removeChild(row.container);
                    row.container.destroy({
                        children: true
                    });
                    this.rows.delete(entityId);
                    // Somebody who has logged out has no press left to acknowledge.
                    this.sentAt.delete(entityId);
                }
            });
            this.header.text = `ONLINE  ${(players || []).length}`;
            this.footer.text = this.overflow > 0 ? `+${this.overflow} more` : "";
            this.footer.visible = this.overflow > 0;
            this.footer.y = $031092a28fb787ca$var$PAD + $031092a28fb787ca$var$HEADER_H + listed.length * ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP) + 1;
            this.draw();
        }, // Let the "Sent" acknowledgements lapse. Cheap when there are none, which is almost always.
        this.animate = (dtMs)=>{
            if (this.sentAt.size < 1) return;
            let changed = false;
            this.sentAt.forEach((remaining, entityId)=>{
                const left = remaining - dtMs;
                if (left > 0) {
                    this.sentAt.set(entityId, left);
                    return;
                }
                this.sentAt.delete(entityId);
                changed = true;
            });
            if (changed) this.players.forEach((player)=>{
                const row = this.rows.get(player.entityId);
                if (row) this.fillRow(row, player);
            });
        }, this.getWidth = ()=>$031092a28fb787ca$var$WIDTH, this.getHeight = ()=>$031092a28fb787ca$var$PAD * 2 + $031092a28fb787ca$var$HEADER_H + Math.max(1, this.players.length) * ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP) + (this.overflow > 0 ? $031092a28fb787ca$var$FOOTER_H : 0), // Press one row's invite. This IS the button's handler, and it is public because the button itself
        // is buried in the display tree -- a caller (or a test) that has the player's id has the control.
        this.inviteFor = (entityId)=>{
            const row = this.rows.get(entityId);
            if (!row) return;
            // A player already in the camp has nothing to be invited to, and a press already acknowledged
            // is not sent twice -- both would just be a wasted round trip.
            if (row.here || this.sentAt.has(entityId)) return;
            this.sentAt.set(entityId, $031092a28fb787ca$export$e22393ef4e0495dc);
            this.onInvite(entityId);
            const current = this.players.find((player)=>player.entityId === entityId);
            if (current) this.fillRow(row, current);
        }, // What a listed player's button currently says ("Invite" / "Sent" / "Here"), or undefined when they
        // have no row. The one readable summary of a row's state, for a caller outside the display tree.
        this.buttonLabelFor = (entityId)=>this.rows.get(entityId)?.buttonLabel.text, // How many players did NOT get a row (the footer's number).
        this.overflowCount = ()=>this.overflow, this.buildRow = (player)=>{
            const container = new (0, $8t5Gy.Container)();
            const backdrop = new (0, $gwPoJ.Graphics)();
            const name = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
            const wave = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
            const button = new (0, $gwPoJ.Graphics)();
            const buttonLabel = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("Invite");
            buttonLabel.tint = $031092a28fb787ca$var$BUTTON_TEXT;
            name.x = $031092a28fb787ca$var$PAD;
            name.y = Math.round(($031092a28fb787ca$var$ROW_H - 8) / 2);
            wave.y = name.y;
            button.x = $031092a28fb787ca$var$WIDTH - $031092a28fb787ca$var$PAD - $031092a28fb787ca$var$BUTTON_W;
            button.y = Math.round(($031092a28fb787ca$var$ROW_H - $031092a28fb787ca$var$BUTTON_H) / 2);
            // The whole button is the control, and a 46x15 target is small, so its hit area is proud of
            // the fill on every side.
            button.interactive = true;
            button.cursor = "pointer";
            button.hitArea = new (0, $6qzqq.Rectangle)(-3, -3, $031092a28fb787ca$var$BUTTON_W + 6, $031092a28fb787ca$var$BUTTON_H + 6);
            container.addChild(backdrop, name, wave, button);
            button.addChild(buttonLabel);
            this.rowsLayer.addChild(container);
            const row = {
                entityId: player.entityId,
                container: container,
                name: name,
                wave: wave,
                button: button,
                buttonLabel: buttonLabel,
                here: false
            };
            const press = ()=>this.inviteFor(row.entityId);
            button.on("click", press);
            button.on("tap", press);
            button.on("mouseover", ()=>this.drawButton(row, true));
            button.on("mouseout", ()=>this.drawButton(row, false));
            // Row backdrop: a faint plate, so a long list still reads as rows rather than as a wall of
            // text. Drawn once -- it never changes size.
            backdrop.beginFill(0xffffff, 0.04);
            backdrop.drawRoundedRect($031092a28fb787ca$var$PAD - 4, 0, $031092a28fb787ca$var$WIDTH - ($031092a28fb787ca$var$PAD - 4) * 2, $031092a28fb787ca$var$ROW_H, 3);
            backdrop.endFill();
            return row;
        }, this.fillRow = (row, player)=>{
            row.here = !!player.here;
            row.name.text = $031092a28fb787ca$export$988945b3d699075c(player.name);
            row.name.tint = player.here ? $031092a28fb787ca$var$NAME_COLOR_HERE : $031092a28fb787ca$var$NAME_COLOR;
            row.wave.text = $031092a28fb787ca$export$447f0dcdd48b7fcc(player.wave);
            row.wave.tint = player.wave ? $031092a28fb787ca$var$WAVE_COLOR : $031092a28fb787ca$var$WAVE_IDLE_COLOR;
            // Right-aligned against the button, so the badge column lines up however wide a name is.
            row.wave.x = $031092a28fb787ca$var$WIDTH - $031092a28fb787ca$var$PAD - $031092a28fb787ca$var$BUTTON_W - 6 - row.wave.width;
            row.buttonLabel.text = row.here ? "Here" : this.sentAt.has(player.entityId) ? "Asked" : "Invite";
            row.buttonLabel.x = Math.round(($031092a28fb787ca$var$BUTTON_W - row.buttonLabel.width) / 2);
            row.buttonLabel.y = Math.round(($031092a28fb787ca$var$BUTTON_H - row.buttonLabel.height) / 2);
            this.drawButton(row, false);
        }, this.drawButton = (row, hover)=>{
            const inert = row.here || this.sentAt.has(row.entityId);
            row.button.clear();
            row.button.lineStyle(1, inert ? $031092a28fb787ca$var$BUTTON_RIM_IDLE : $031092a28fb787ca$var$BUTTON_RIM, inert ? 0.4 : hover ? 1 : 0.8);
            row.button.beginFill(hover && !inert ? $031092a28fb787ca$var$BUTTON_FILL_HOVER : $031092a28fb787ca$var$BUTTON_FILL, inert ? 0.5 : 0.95);
            row.button.drawRoundedRect(0, 0, $031092a28fb787ca$var$BUTTON_W, $031092a28fb787ca$var$BUTTON_H, 4);
            row.button.endFill();
            row.buttonLabel.alpha = inert ? 0.6 : 1;
            row.button.cursor = inert ? "default" : "pointer";
        }, this.draw = ()=>{
            this.plate.clear();
            this.plate.beginFill($031092a28fb787ca$var$PANEL_COLOR, $031092a28fb787ca$var$PANEL_ALPHA);
            this.plate.lineStyle(1, 0xffffff, $031092a28fb787ca$var$BORDER_ALPHA);
            this.plate.drawRoundedRect(0, 0, $031092a28fb787ca$var$WIDTH, this.getHeight(), $031092a28fb787ca$var$CORNER);
            this.plate.endFill();
        };
        this.onInvite = onInvite;
        this.header = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("ONLINE");
        this.header.tint = $031092a28fb787ca$var$HEADER_COLOR;
        this.header.x = $031092a28fb787ca$var$PAD;
        this.header.y = $031092a28fb787ca$var$PAD - 2;
        this.footer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
        this.footer.tint = $031092a28fb787ca$var$HEADER_COLOR;
        this.footer.x = $031092a28fb787ca$var$PAD;
        this.footer.visible = false;
        this.rowsLayer.x = 0;
        this.rowsLayer.y = $031092a28fb787ca$var$PAD + $031092a28fb787ca$var$HEADER_H;
        const close = new (0, $e59d4eca9b366180$export$de65de8213222d10)({
            radius: 8,
            onClick: onClose
        });
        close.x = $031092a28fb787ca$var$WIDTH - 6;
        close.y = 6;
        this.addChild(this.plate, this.header, this.rowsLayer, this.footer, close);
        this.draw();
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");


// The prompt an invited player answers: who is asking, and Join / Decline. It docks in the right-hand
// gutter directly under the players chip, above the player list, so the whole "who else is playing"
// business reads as one column.
//
// It is NOT a modal. An invitation is somebody else's idea, arriving while the player is in the middle
// of something -- very likely a wave -- so it must be ignorable. Ignoring it IS an answer: the bar at
// the foot of the panel drains, and at zero the prompt takes itself down without moving anybody. The
// server expires the invitation on the same clock, so the two agree without a second message.
//
// Amber rim, from the same ember-lit family as the role picker and the tutorial bar, because unlike
// everything else in this column it wants an answer.
const $102f4cd7b044a43e$var$WIDTH = 186;
const $102f4cd7b044a43e$var$PAD = 8;
const $102f4cd7b044a43e$var$CORNER = 6;
const $102f4cd7b044a43e$var$LINE_GAP = 4;
const $102f4cd7b044a43e$var$BUTTON_H = 16;
const $102f4cd7b044a43e$var$BUTTON_GAP = 6;
const $102f4cd7b044a43e$var$METER_H = 3;
const $102f4cd7b044a43e$var$METER_GAP = 7;
const $102f4cd7b044a43e$var$PANEL_COLOR = 0x05070a;
const $102f4cd7b044a43e$var$PANEL_ALPHA = 0.9;
const $102f4cd7b044a43e$var$RIM = 0xf2a94e;
const $102f4cd7b044a43e$var$RIM_ALPHA = 0.7;
const $102f4cd7b044a43e$var$TITLE_COLOR = 0xfff3e0;
const $102f4cd7b044a43e$var$BODY_COLOR = 0x8d97ad;
const $102f4cd7b044a43e$var$ACCEPT_RIM = 0x7be08a;
const $102f4cd7b044a43e$var$ACCEPT_TEXT = 0xdcffe2;
const $102f4cd7b044a43e$var$DECLINE_RIM = 0x8d97ad;
const $102f4cd7b044a43e$var$DECLINE_TEXT = 0xd4d8e0;
const $102f4cd7b044a43e$var$BUTTON_FILL = 0x1b2030;
const $102f4cd7b044a43e$var$BUTTON_FILL_HOVER = 0x33405e;
const $102f4cd7b044a43e$var$METER_TRACK = 0x2a2119;
// Fallback line height for a Text that measures as zero, which is every Text under a mocked canvas.
// Without it the panel collapses onto its own buttons in any headless render.
const $102f4cd7b044a43e$var$LINE_H = 10;
const $102f4cd7b044a43e$export$c0f8283346f0f07a = (remainingMs, totalMs)=>{
    if (!(totalMs > 0)) return 0;
    return Math.max(0, Math.min(1, remainingMs / totalMs));
};
class $102f4cd7b044a43e$export$2910d5f40b7274eb extends (0, $8t5Gy.Container) {
    constructor({ onAnswer: onAnswer }){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.meter = new (0, $gwPoJ.Graphics)(), this.accept = new (0, $gwPoJ.Graphics)(), this.decline = new (0, $gwPoJ.Graphics)(), this.invite = null, this.remainingMs = 0, this.totalMs = 0, this.buildButton = (button, text, x, y, w, tint)=>{
            const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(text);
            label.tint = tint;
            label.x = Math.round((w - label.width) / 2);
            label.y = Math.round(($102f4cd7b044a43e$var$BUTTON_H - (label.height || $102f4cd7b044a43e$var$LINE_H)) / 2);
            button.x = x;
            button.y = y;
            button.addChild(label);
            return label;
        }, this.bindButton = (button, rim, w, accepted)=>{
            button.interactive = true;
            button.cursor = "pointer";
            // Proud of the fill on every side: these are 16px tall, and one of them moves the player to
            // another room.
            button.hitArea = new (0, $6qzqq.Rectangle)(-3, -3, w + 6, $102f4cd7b044a43e$var$BUTTON_H + 6);
            const answer = ()=>this.answer(accepted);
            button.on("click", answer);
            button.on("tap", answer);
            button.on("mouseover", ()=>this.drawButton(button, rim, w, true));
            button.on("mouseout", ()=>this.drawButton(button, rim, w, false));
        }, // Put the prompt up, or take it down with null. A fresh invitation always restarts the clock --
        // a second host asking replaces the first, exactly as the server's own one-per-guest rule does.
        this.update = (invite)=>{
            this.invite = invite || null;
            if (!this.invite) {
                this.visible = false;
                this.remainingMs = 0;
                this.totalMs = 0;
                return;
            }
            this.totalMs = this.invite.expiresInMs > 0 ? this.invite.expiresInMs : 0;
            this.remainingMs = this.totalMs;
            this.title.text = `${(0, $031092a28fb787ca$export$988945b3d699075c)(this.invite.fromName)}`;
            this.visible = true;
            this.draw();
        }, // Answer it. Public because the buttons are buried in the display tree, and because a caller with
        // a keyboard shortcut or a test has as much right to answer as the pointer does.
        this.answer = (accepted)=>{
            if (!this.invite) return;
            this.invite = null;
            this.visible = false;
            this.onAnswer(accepted);
        }, // Drain the clock. Doing nothing is an answer -- at zero the prompt takes itself down, and tells
        // the server nothing: the server is expiring the same invitation on the same clock.
        this.animate = (dtMs)=>{
            if (!this.invite || this.totalMs <= 0) return;
            this.remainingMs = Math.max(0, this.remainingMs - dtMs);
            if (this.remainingMs <= 0) {
                this.invite = null;
                this.visible = false;
                return;
            }
            this.drawMeter();
        }, this.isOpen = ()=>!!this.invite, this.remaining = ()=>this.remainingMs, // The name the prompt is showing, for a caller outside the display tree.
        this.inviterLabel = ()=>this.title.text, this.getWidth = ()=>$102f4cd7b044a43e$var$WIDTH, this.getHeight = ()=>this.accept.y + $102f4cd7b044a43e$var$BUTTON_H + $102f4cd7b044a43e$var$METER_GAP + $102f4cd7b044a43e$var$METER_H + $102f4cd7b044a43e$var$PAD - 2, this.draw = ()=>{
            const buttonW = Math.round(($102f4cd7b044a43e$var$WIDTH - $102f4cd7b044a43e$var$PAD * 2 - $102f4cd7b044a43e$var$BUTTON_GAP) / 2);
            this.plate.clear();
            this.plate.beginFill($102f4cd7b044a43e$var$PANEL_COLOR, $102f4cd7b044a43e$var$PANEL_ALPHA);
            this.plate.lineStyle(1, $102f4cd7b044a43e$var$RIM, $102f4cd7b044a43e$var$RIM_ALPHA);
            this.plate.drawRoundedRect(0, 0, $102f4cd7b044a43e$var$WIDTH, this.getHeight(), $102f4cd7b044a43e$var$CORNER);
            this.plate.endFill();
            this.drawButton(this.accept, $102f4cd7b044a43e$var$ACCEPT_RIM, buttonW, false);
            this.drawButton(this.decline, $102f4cd7b044a43e$var$DECLINE_RIM, buttonW, false);
            this.acceptLabel.x = Math.round((buttonW - this.acceptLabel.width) / 2);
            this.declineLabel.x = Math.round((buttonW - this.declineLabel.width) / 2);
            this.drawMeter();
        }, this.drawButton = (button, rim, w, hover)=>{
            button.clear();
            button.lineStyle(1, rim, hover ? 1 : 0.75);
            button.beginFill(hover ? $102f4cd7b044a43e$var$BUTTON_FILL_HOVER : $102f4cd7b044a43e$var$BUTTON_FILL, 0.95);
            button.drawRoundedRect(0, 0, w, $102f4cd7b044a43e$var$BUTTON_H, 4);
            button.endFill();
        }, this.drawMeter = ()=>{
            const w = $102f4cd7b044a43e$var$WIDTH - $102f4cd7b044a43e$var$PAD * 2;
            const y = this.accept.y + $102f4cd7b044a43e$var$BUTTON_H + $102f4cd7b044a43e$var$METER_GAP;
            this.meter.clear();
            this.meter.beginFill($102f4cd7b044a43e$var$METER_TRACK, 0.9);
            this.meter.drawRoundedRect($102f4cd7b044a43e$var$PAD, y, w, $102f4cd7b044a43e$var$METER_H, 1.5);
            this.meter.endFill();
            const left = $102f4cd7b044a43e$export$c0f8283346f0f07a(this.remainingMs, this.totalMs);
            if (left > 0) {
                this.meter.beginFill($102f4cd7b044a43e$var$RIM, 0.95);
                this.meter.drawRoundedRect($102f4cd7b044a43e$var$PAD, y, Math.max(1, w * left), $102f4cd7b044a43e$var$METER_H, 1.5);
                this.meter.endFill();
            }
        };
        this.onAnswer = onAnswer;
        this.title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
        this.title.tint = $102f4cd7b044a43e$var$TITLE_COLOR;
        this.title.x = $102f4cd7b044a43e$var$PAD;
        this.title.y = $102f4cd7b044a43e$var$PAD - 2;
        this.body = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("wants you at their camp");
        this.body.tint = $102f4cd7b044a43e$var$BODY_COLOR;
        this.body.x = $102f4cd7b044a43e$var$PAD;
        this.body.y = this.title.y + $102f4cd7b044a43e$var$LINE_H + $102f4cd7b044a43e$var$LINE_GAP;
        const buttonW = Math.round(($102f4cd7b044a43e$var$WIDTH - $102f4cd7b044a43e$var$PAD * 2 - $102f4cd7b044a43e$var$BUTTON_GAP) / 2);
        const buttonY = this.body.y + $102f4cd7b044a43e$var$LINE_H + $102f4cd7b044a43e$var$LINE_GAP + 2;
        this.acceptLabel = this.buildButton(this.accept, "Join", $102f4cd7b044a43e$var$PAD, buttonY, buttonW, $102f4cd7b044a43e$var$ACCEPT_TEXT);
        this.declineLabel = this.buildButton(this.decline, "Decline", $102f4cd7b044a43e$var$PAD + buttonW + $102f4cd7b044a43e$var$BUTTON_GAP, buttonY, buttonW, $102f4cd7b044a43e$var$DECLINE_TEXT);
        this.bindButton(this.accept, $102f4cd7b044a43e$var$ACCEPT_RIM, buttonW, true);
        this.bindButton(this.decline, $102f4cd7b044a43e$var$DECLINE_RIM, buttonW, false);
        this.addChild(this.plate, this.title, this.body, this.accept, this.decline, this.meter);
        this.draw();
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");




class $0159750bbc757373$export$cd136f60375f2af0 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.setup = (text, sprite, hoverText)=>{
            this.removeChildren();
            const container = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            let s;
            if (sprite) {
                const s = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: sprite,
                    color: 0xffffff,
                    scale: 1.0
                });
                container.append2(s, {
                    topMargin: s.height / 2
                });
            }
            if (text) container.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(text), {
                sameLine: true,
                topMargin: -10,
                leftMargin: s ? -10 : undefined
            });
            this.addChild(container);
            if (hoverText) {
                this.addChild(this.hoverText);
                container.interactive = true;
                container.on("mouseover", ()=>{
                    this.hoverText.x = container.x - 15;
                    this.hoverText.y = container.y + 20;
                    this.hoverText.visible = true;
                    this.hoverText.update(hoverText);
                });
            }
        };
        this.guiManager = guiManager;
        this.hoverText = new (0, $95fcf006ca17068b$export$9035ac6ca3ebe147)();
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");





// The dismiss button is the SAME control every dialog is closed by (gui/close_button.ts), just
// smaller: same disc, rim, stroked X and hover states, so there is one close affordance in the game
// rather than a second hand-drawn one that has to be kept looking like the first. Scaling the shared
// radius rather than hardcoding one keeps its bigger touch size on a phone.
const $dbd41000427e8969$var$DISMISS_RADIUS = Math.round((0, $e59d4eca9b366180$export$dc3c988e71114e28) * 0.75);
const $dbd41000427e8969$var$DISMISS_GAP = 6 // clear air between the last line of text and the button row
;
// The one red the clues are drawn in: the ring round the control, the leader, and the box's outline.
const $dbd41000427e8969$var$CLUE_RED = 0xff0000;
// How far the leader starts inside the panel, so the join is never a hairline short.
const $dbd41000427e8969$var$LEADER_OVERLAP = 3;
// How long an overworld popup stays up. Tuned for a notice nobody is waiting on: it says its piece
// and gets out of the way. (A clue's much longer lifetime lives in ember_clues.ts, with the rest of
// the clue bookkeeping.)
const $dbd41000427e8969$var$POPUP_TIMEOUT_MS = 7000;
// The control bar's inventory button, as the existing controlbar popup boxes it: the first entry in
// ControlBar.setup() (inventory.png), measured from the bar's own x in the gui surface.
const $dbd41000427e8969$var$CONTROLBAR_ITEMS_OFFSET_X = 15;
const $dbd41000427e8969$var$CONTROLBAR_ITEMS_W = 32;
const $dbd41000427e8969$var$CONTROLBAR_ITEMS_H = 30;
class $dbd41000427e8969$export$825b76de5f2b0345 {
    constructor(gui, surface, equippedWidget, controlBar, minimapSurface, emberInventoryChip){
        this.activeTutorials = new Set();
        // Per-room suppression latch (set from GuiManager.roomUpdated via WorldState.visibility). When
        // true, setup() is a no-op so no tutorial popups appear — ember rooms suppress them. It does NOT
        // hold back the ember clues: see setup().
        this.suppressed = false;
        // The ember clues' bookkeeping (armed vs anchored, expiry, teardown) lives next door in
        // ember_clues.ts, free of pixi; all this file provides is the drawing.
        this.clues = new (0, $9600e6b065d22e57$export$5e29510581c9aca2)({
            draw: (tutorialType, anchor)=>this.drawClue(tutorialType, anchor),
            builtInAnchor: (tutorialType)=>this.builtInClueAnchor(tutorialType) || undefined
        });
        // The dismiss button sits INSIDE the panel, on its own row under the text, the way the chat
        // bubble's "Next" button does: the container flows it like any other row, so the backdrop grows to
        // enclose it instead of having a circle hung off the top-left corner where it overlapped both the
        // panel edge and the text.
        //
        // CloseButton draws itself CENTRED ON ITS OWN ORIGIN (it is built to hang off a panel corner), but
        // append2 flows children by their top-left, so both offsets below carry a radius to put the disc
        // where a top-left-origin child of the same size would have gone.
        this.addDismiss = (container, callback)=>{
            const radius = $dbd41000427e8969$var$DISMISS_RADIUS;
            // Measure the text block BEFORE the button joins it, or it right-aligns against itself.
            const textWidth = container.width;
            const dismissButton = new (0, $e59d4eca9b366180$export$de65de8213222d10)({
                radius: radius,
                onClick: callback
            });
            container.append2(dismissButton, {
                // Math.max keeps it on the panel when the text is narrower than the button. A leftSpacer of
                // 0 is falsy and would be ignored, which is the same place the flow would have put it.
                leftSpacer: Math.max(0, Math.round(textWidth - radius)),
                topMargin: $dbd41000427e8969$var$DISMISS_GAP + radius
            });
        };
        this.createStop = (tutorialType, lines, container, throbber, releaseHover)=>{
            // Idempotent: a clue can be taken down by its own dismiss button, by its expiry timer, by the
            // panel it points at being rebuilt, and by the tutorial being marked seen -- and more than one
            // of those can land on the same clue.
            let stopped = false;
            const stop = ()=>{
                if (stopped) return;
                stopped = true;
                // Give the world its mouse back FIRST. The panel takes it away while the pointer is on it
                // (see setupTutorial), and the commonest way for one to go is the player clicking the
                // panel's own dismiss button -- with the pointer right there on it. Removing a display
                // object does not make pixi deliver the mouseout it owed, so the latch would stay set and
                // the player would be left unable to walk or swing until the next room load. The expiry
                // timer and a panel rebuild can land under a resting pointer the same way.
                releaseHover();
                throbber.stop();
                // Was hardcoded to "controlbar", so a dismissed hotbar/map popup stayed in the set and
                // could never be raised again in the same session.
                this.activeTutorials.delete(tutorialType);
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(container, {
                    releaseCallback: ()=>{
                        container.parent?.removeChild(container);
                    }
                }).update();
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(lines, {
                    releaseCallback: ()=>{
                        lines?.parent?.removeChild(lines);
                    }
                }).update();
            };
            return stop;
        };
        // Builds the box + blinking pointer every tutorial and clue is made of. `timeoutMs` of 0 means it
        // does not take itself down: the ember clues have their own lifetime (see ember_clues.ts).
        this.setupTutorial = (tutorialType, text, attachToSurface = true, timeoutMs = $dbd41000427e8969$var$POPUP_TIMEOUT_MS)=>{
            if (this.activeTutorials.has(tutorialType)) return;
            this.activeTutorials.add(tutorialType);
            // A clue's panel is SOLID. It is read over the camp at night, over the inventory panel and over
            // whatever is moving in the world behind it, none of which the overworld popups have to cope
            // with, and half-transparent text over all that is not reliably legible.
            const isClue = (0, $cb689cfa16c444ba$export$a35d0571df2da201)(tutorialType);
            const container = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                backdrop: true,
                opaque: isClue,
                // Same red as the ring round the control and the leader between them, so the box and the
                // thing it names read as one object rather than two bits of chrome that happen to be near.
                borderColor: isClue ? $dbd41000427e8969$var$CLUE_RED : undefined,
                margin: 2
            });
            const lines = new (0, $gwPoJ.Graphics)();
            if (attachToSurface) this.surface.addChild(lines);
            const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(lines, {
                blinkInterval: 250,
                minAlpha: 0.5
            });
            // While the pointer is on the panel the world does not get the mouse, so a click meant for
            // the box (or for its dismiss button) is not also a swing at whatever is behind it. Tracked
            // here rather than left to pixi so the teardown can hand the mouse back (see createStop),
            // and so a panel never clears a latch it did not set.
            let hovered = false;
            const setHovered = (over)=>{
                if (hovered === over) return;
                hovered = over;
                this.gui.mouseOverControl(over);
            };
            container.interactive = true;
            container.on("mouseover", ()=>setHovered(true));
            container.on("mouseout", ()=>setHovered(false));
            const stop = this.createStop(tutorialType, lines, container, throbber, ()=>setHovered(false));
            text.forEach((l)=>container.append2(l));
            // Dismissing a CLUE has to disarm it as well as take it down, or the next rebuild of the panel
            // it points at would put it straight back up over a player who has said they are done with it.
            this.addDismiss(container, ()=>{
                stop();
                if ((0, $cb689cfa16c444ba$export$a35d0571df2da201)(tutorialType)) this.clues.disarm(tutorialType);
            });
            throbber.update();
            if (attachToSurface) this.surface.addChild(container);
            if (timeoutMs > 0) setTimeout(stop, timeoutMs);
            return {
                lines: lines,
                container: container,
                stop: stop
            };
        };
        this.setupHotbarTutorial = ()=>{
            const tutorial = this.setupTutorial("hotbar", [
                "This is your hotbar. Activate readied equipment, supplies, and follower",
                "commands by pressing their associated numbers and letters (1, 2, J, K ...)."
            ]);
            if (!tutorial) return;
            const { lines: lines, container: container } = tutorial;
            container.x = this.equippedWidget.x - 15;
            container.y = this.equippedWidget.y - container.height - 45;
            lines.x = container.x - 5;
            lines.y = container.y + container.height + 10;
            lines.lineStyle({
                width: 2,
                color: 0xff0000,
                alpha: 1.0
            });
            lines.drawRect(250, -25, 0.5, 25);
            lines.drawRect(0, 0, 500, 55);
        };
        this.setupMapTutorial = ()=>{
            const tutorial = this.setupTutorial("map", [
                "This your map. Points of interest appear as icons, and new ones",
                "will pulse to get your attention!"
            ]);
            if (!tutorial) return;
            const { lines: lines, container: container } = tutorial;
            container.x = this.minimapSurface.x - container.width;
            container.y = this.minimapSurface.y - container.height - 55;
            lines.x = container.x + container.width + 50;
            lines.y = container.y + container.height / 2 - 25;
            lines.lineStyle({
                width: 2,
                color: 0xff0000,
                alpha: 1.0
            });
            lines.drawRect(-60, 0, 60, 0.5);
            lines.drawRect(0, 0, 0.5, 108);
            lines.drawRect(-60, 110, this.minimapSurface.width + 15, this.minimapSurface.height + 15);
        };
        this.setupControlbarTutorial = ()=>{
            const tutorial = this.setupTutorial("controlbar", [
                "Access your inventory and craft items using these controls."
            ]);
            if (!tutorial) return;
            const { lines: lines, container: container } = tutorial;
            container.x = this.controlBar.x - container.width + 10;
            container.y = this.controlBar.y + 30;
            lines.x = this.controlBar.x + 15;
            lines.y = 0;
            lines.lineStyle({
                width: 2,
                color: 0xff0000,
                alpha: 1.0
            });
            lines.drawRect(0, 0, 32, 30);
            lines.drawRect(31, 30, 1, 40);
            lines.drawRect(31, 70, -50, 1);
        };
        this.setupCompanionTutorial = ()=>{
            const playerEntity = this.gui.logic.playerEntity;
            if (!playerEntity) {
                this.activeTutorials.delete("companion");
                return;
            }
            const companion = this.gui.logic.entityManager.find((e)=>e.leaderEntityId === playerEntity.entityId);
            if (!companion) {
                this.activeTutorials.delete("companion");
                return;
            }
            const entityRenderable = this.gui.logic.clientRenderer.map().overlay().getEntityRenderable(companion.entityId);
            if (!entityRenderable) {
                this.activeTutorials.delete("companion");
                return;
            }
            const tutorial = this.setupTutorial("companion", [
                "This is your companion and protected. Mouse over",
                "him, and click the icons that appear to interact."
            ], false);
            if (!tutorial) return;
            const { lines: lines, container: container } = tutorial;
            // container.x = this.minimapSurface.x - container.width
            container.x = -container.width;
            container.y = -25;
            entityRenderable.addChild(lines);
            entityRenderable.addChild(container);
            lines.x = container.x + container.width;
            lines.y = container.y + container.height / 2;
            lines.lineStyle({
                width: 2,
                color: 0xff0000,
                alpha: 1.0
            });
            lines.drawRect(-10, 0, 30, 0.5);
            lines.drawRect(20, 0, 0.5, 25);
        };
        // =========================================================================================
        // THE EMBER CLUES
        //
        // Five pointer-and-text boxes that name the controls the camp's first fire is built with. They are
        // armed by the SERVER (assets/scripts/v2/ember-tutorial.js), one beat at a time, because only the
        // director knows which beat is live -- the client cannot tell "waiting for a campfire to be
        // crafted" from "the player is browsing recipes for fun".
        //
        // The rules (armed vs anchored, lifetime, teardown) are in ember_clues.ts. This half draws them.
        // =========================================================================================
        // Whatever draws one of the clued controls says where it landed. Called again on every rebuild of
        // the panel it lives in.
        this.registerClueAnchor = (tutorialType, anchor)=>this.clues.registerAnchor(tutorialType, anchor);
        // The control has gone (its panel closed, or this rebuild no longer draws it).
        this.clearClueAnchor = (tutorialType)=>this.clues.clearAnchor(tutorialType);
        // The player DID the thing this clue was pointing at, so it has served its purpose and goes for
        // good. Disarm rather than merely retract: a satisfied clue must not come back when the panel it
        // pointed at is next rebuilt, or reopening the pack would re-light a label for a step already done.
        this.satisfyClue = (tutorialType)=>this.clues.disarm(tutorialType);
        // Every clue down and disarmed: the tutorial is over, or the camp is.
        this.clearEmberClues = ()=>this.clues.clearAll();
        this.isClueArmed = (tutorialType)=>this.clues.isArmed(tutorialType);
        this.isClueShowing = (tutorialType)=>this.clues.isShowing(tutorialType);
        // Draw one clue at its anchor, and hand back how to take it down.
        this.drawClue = (tutorialType, anchor)=>{
            const tutorial = this.setupTutorial(tutorialType, (0, $9600e6b065d22e57$export$cbebaa48d952aec0)[tutorialType], false, 0);
            if (!tutorial) return undefined;
            const { lines: lines, container: container, stop: stop } = tutorial;
            anchor.host.addChild(lines);
            anchor.host.addChild(container);
            const placement = anchor.placement || "left";
            const { boxX: boxX, boxY: boxY, leader: leader } = (0, $9600e6b065d22e57$export$e8a38504aad4fd94)({
                anchorX: anchor.x,
                anchorY: anchor.y,
                anchorW: anchor.w,
                anchorH: anchor.h,
                boxW: container.width,
                boxH: container.height,
                boxMinX: anchor.boxMinX,
                placement: placement
            });
            container.x = boxX;
            container.y = boxY;
            // clueBoxLayout works in content sizes, but a container's ORIGIN is not its top-left corner:
            // the backdrop is drawn from -5-margin, so what is on screen starts above and to the left of
            // where the box was placed. Re-place against the bounds that actually exist, so the box really
            // clears its control and the leader comes out straight instead of stepping.
            const bounds = container.getLocalBounds();
            if (placement === "above") {
                // Sit its VISIBLE bottom edge clear of the control's top, and centre it on the control --
                // but never past the host's left edge. clueBoxLayout already clamps, and re-placing against
                // the real bounds threw that away: the ready bar is in the bottom-left corner, so a box
                // centred on it ran off the side of the screen with half its words unreadable.
                //
                // Clamped on the VISIBLE edge (container.x + bounds.x), not the origin, because the
                // backdrop is drawn outside the content box.
                const minX = anchor.boxMinX ?? (0, $9600e6b065d22e57$export$14401afa5819d457);
                const centred = anchor.x + anchor.w / 2 - (bounds.x + bounds.width / 2);
                container.x = Math.round(Math.max(minX - bounds.x, centred));
                container.y = Math.round(anchor.y - (0, $9600e6b065d22e57$export$e19271ea5abac88c) - (bounds.y + bounds.height));
            } else container.y = Math.max((0, $9600e6b065d22e57$export$cf3a52d3dbeb0881) - bounds.y, anchor.y + anchor.h / 2 - (bounds.y + bounds.height / 2));
            lines.x = anchor.x;
            lines.y = anchor.y;
            lines.lineStyle({
                width: 2,
                color: $dbd41000427e8969$var$CLUE_RED,
                alpha: 1.0
            });
            // A ring round the control itself...
            lines.drawRect(0, 0, anchor.w, anchor.h);
            // ...and a leader back to the box, when the clamp left room for one.
            //
            // Drawn from the panel's VISIBLE edge, taken off its real bounds rather than off container.width:
            // the backdrop is a rounded rect deliberately larger than its contents (see
            // DyanmicTextContainer), so the box on screen is wider than the text it wraps, and measuring
            // the text left the line ending short of the panel it was supposed to be joined to.
            //
            // The elbow is only for the one case the re-centring above cannot fix: a box tall enough that
            // levelling it with its control would push it off the top of the screen, where it is clamped
            // instead and a straight line would leave the panel at a height the panel no longer occupies.
            // Every other time the two ends already line up and this draws one straight line.
            if (leader > 0 && placement === "above") {
                // Straight down from the box's visible bottom to the top of the control, on the control's
                // own centre line.
                const x = anchor.w / 2;
                const startY = container.y + bounds.y + bounds.height - anchor.y;
                lines.moveTo(x, startY - $dbd41000427e8969$var$LEADER_OVERLAP);
                lines.lineTo(x, 0);
            } else if (leader > 0) {
                const startX = container.x + bounds.x + bounds.width - anchor.x;
                const startY = container.y + bounds.y + bounds.height / 2 - anchor.y;
                const endY = anchor.h / 2;
                // Start a little INSIDE the panel so there can be no seam where the two meet.
                lines.moveTo(startX - $dbd41000427e8969$var$LEADER_OVERLAP, startY);
                if (Math.round(startY) !== Math.round(endY)) {
                    const elbowX = startX / 2;
                    lines.lineTo(elbowX, startY);
                    lines.lineTo(elbowX, endY);
                }
                lines.lineTo(0, endY);
            }
            return stop;
        };
        // The one clue whose control is part of the permanent HUD rather than a panel, so it needs no
        // registration: in a CAMP the pack is opened from the ITEMS chip in the top-right row, because
        // ember rooms suppress the control bar (GuiManager.roomUpdated). The bar's own inventory.png --
        // the first entry in ControlBar.setup() -- is the fallback for a room that leaves the bar up.
        this.builtInClueAnchor = (tutorialType)=>{
            // The ready bar, which is the equipped widget: permanent HUD, so nothing has to report it.
            if (tutorialType === "ember-ready") {
                if (!this.equippedWidget || !this.equippedWidget.visible) return null;
                const bounds = this.equippedWidget.getLocalBounds();
                return {
                    host: this.surface,
                    x: this.equippedWidget.x + bounds.x,
                    y: this.equippedWidget.y + bounds.y,
                    w: bounds.width,
                    h: bounds.height,
                    placement: "above"
                };
            }
            if (tutorialType !== "ember-items") return null;
            const chip = this.emberInventoryChip;
            if (chip && chip.visible) return {
                host: this.surface,
                x: chip.x,
                y: chip.y,
                w: chip.getWidth(),
                h: chip.getHeight()
            };
            if (!this.controlBar || !this.controlBar.visible) return null;
            return {
                host: this.surface,
                x: this.controlBar.x + $dbd41000427e8969$var$CONTROLBAR_ITEMS_OFFSET_X,
                y: this.controlBar.y,
                w: $dbd41000427e8969$var$CONTROLBAR_ITEMS_W,
                h: $dbd41000427e8969$var$CONTROLBAR_ITEMS_H
            };
        };
        // The one way in from the wire (GuiManager.showTutorial). What each kind of message means -- and
        // which of them `suppressed` is allowed to swallow -- is decided in one place, routeTutorial.
        this.setup = (tutorialType, timeoutMs)=>{
            const route = (0, $9600e6b065d22e57$export$9069b388aec1210a)(tutorialType, this.suppressed);
            if (route === "clear") {
                this.clearEmberClues();
                return;
            }
            if (route === "suppressed") return;
            if (route === "clue") {
                this.clues.arm(tutorialType, timeoutMs);
                return;
            }
            const all = false;
            if (all || tutorialType === "controlbar") this.setupControlbarTutorial();
            if (all || tutorialType === "hotbar") this.setupHotbarTutorial();
            if (all || tutorialType === "map") this.setupMapTutorial();
            if (all || tutorialType === "companion") setTimeout(()=>{
                this.setupCompanionTutorial();
            }, 4000);
        };
        this.gui = gui;
        this.surface = surface;
        this.equippedWidget = equippedWidget;
        this.controlBar = controlBar;
        this.minimapSurface = minimapSurface;
        this.emberInventoryChip = emberInventoryChip;
    }
}


parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



const $1d7285dcca0039d8$var$BLINK_MS = 530;
// Start warning about the length cap once the line is this close to it. Earlier than that it is
// noise; later and the player hits the cap mid-word with no warning at all.
const $1d7285dcca0039d8$var$COUNTER_FROM = (0, $2bc3e70fbff7f064$export$4779cfd32b998f47) - 30;
const $1d7285dcca0039d8$var$CARET_W = 1.5;
const $1d7285dcca0039d8$var$CHEVRON_GAP = 5;
// Air kept to the right of the text so a caret at the end of a full line is never flush against
// the rim.
const $1d7285dcca0039d8$var$TAIL_PAD = 3;
class $1d7285dcca0039d8$export$3997e86453ee41f3 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.textX = 0, this.viewportWidth = 0, this.update = (state)=>{
            this.visible = true;
            this.startBlink();
            const isCommand = state.value.startsWith("/");
            this.textNode.text = state.value;
            this.textNode.tint = isCommand ? (0, $bde0eb94ead9038f$export$1f7cbc51fe7009c3) : (0, $bde0eb94ead9038f$export$516f68680b50dca1);
            const remaining = (0, $2bc3e70fbff7f064$export$4779cfd32b998f47) - state.value.length;
            const showCounter = state.value.length >= $1d7285dcca0039d8$var$COUNTER_FROM;
            this.counter.visible = showCounter;
            if (showCounter) {
                this.counter.text = `${remaining}`;
                this.counter.tint = remaining <= 10 ? (0, $bde0eb94ead9038f$export$ddc55e6671963e97) : (0, $bde0eb94ead9038f$export$dc58655d5df465a7);
            }
            this.layoutRows();
            const caretX = this.measure(state.value.slice(0, state.caret));
            this.caret.x = caretX;
            // Keep the caret inside the field: scroll only as far as it has to, and never past the
            // start, so a short line always sits against the chevron.
            const maxScroll = Math.max(0, this.measure(state.value) - this.viewportWidth + $1d7285dcca0039d8$var$TAIL_PAD);
            let scroll = -this.textNode.x;
            if (caretX - scroll > this.viewportWidth - $1d7285dcca0039d8$var$TAIL_PAD) scroll = caretX - this.viewportWidth + $1d7285dcca0039d8$var$TAIL_PAD;
            if (caretX - scroll < 0) scroll = caretX;
            scroll = Math.max(0, Math.min(scroll, maxScroll));
            this.textNode.x = -scroll;
            this.caret.x -= scroll;
        }, this.removeText = ()=>{
            this.visible = false;
            this.textNode.text = "";
            this.textNode.x = 0;
            this.stopBlink();
        }, // Width of a prefix of the line, in the field's own font. TextMetrics caches per string+style,
        // so re-measuring on every keystroke is cheap.
        this.measure = (text)=>text ? (0, $9Pi8W.TextMetrics).measureText(text, this.textNode.style).width : 0, this.layoutRows = ()=>{
            const lineH = this.textNode.height || (0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e) + 4;
            const baseline = Math.round(((0, $bde0eb94ead9038f$export$251eac38a164bee4) - lineH) / 2);
            this.chevron.y = Math.round(((0, $bde0eb94ead9038f$export$251eac38a164bee4) - (this.chevron.height || lineH)) / 2);
            this.viewport.y = baseline;
            // The countdown to the length cap is pinned to the right edge, and takes its width out of
            // the field the text may scroll in.
            const tail = this.counter.visible ? this.counter : undefined;
            const tailWidth = tail ? (tail.width || 0) + $1d7285dcca0039d8$var$CHEVRON_GAP : 0;
            if (tail) {
                tail.x = (0, $bde0eb94ead9038f$export$72ee0c7a4855a274) - (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) - (tail.width || 0);
                tail.y = Math.round(((0, $bde0eb94ead9038f$export$251eac38a164bee4) - (tail.height || (0, $bde0eb94ead9038f$export$c1e8972bf2d4e8dc))) / 2) + 1;
            }
            this.viewportWidth = Math.max(40, (0, $bde0eb94ead9038f$export$72ee0c7a4855a274) - this.textX - (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) - tailWidth);
            this.textMask.clear();
            this.textMask.beginFill(0xffffff);
            this.textMask.drawRect(this.textX, 0, this.viewportWidth, (0, $bde0eb94ead9038f$export$251eac38a164bee4));
            this.textMask.endFill();
            this.caret.clear();
            this.caret.beginFill((0, $bde0eb94ead9038f$export$4a863a35dfd357dc), 0.95);
            this.caret.drawRect(0, 1, $1d7285dcca0039d8$var$CARET_W, Math.max(10, lineH - 2));
            this.caret.endFill();
        }, this.drawPanel = ()=>{
            this.shadow.clear();
            this.shadow.beginFill((0, $bde0eb94ead9038f$export$a9fed83f1c193f7e), (0, $bde0eb94ead9038f$export$7fb3621e17d8a3da));
            this.shadow.drawRoundedRect((0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), (0, $bde0eb94ead9038f$export$251eac38a164bee4), (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.shadow.endFill();
            this.panel.clear();
            this.panel.lineStyle({
                width: 1,
                color: (0, $bde0eb94ead9038f$export$542c8a566b36979),
                alpha: 0.55,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            this.panel.beginFill((0, $bde0eb94ead9038f$export$35cf6b4f538836cd), (0, $bde0eb94ead9038f$export$5eb57294d7a01ff));
            this.panel.drawRoundedRect(0, 0, (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), (0, $bde0eb94ead9038f$export$251eac38a164bee4), (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.panel.endFill();
        }, // The caret is solid while the player is typing and only resumes blinking once they stop --
        // a caret that blinks THROUGH the keystroke reads as dropped input.
        this.startBlink = ()=>{
            this.caret.visible = true;
            if (this.blinkInterval) clearInterval(this.blinkInterval);
            this.blinkInterval = setInterval(()=>{
                this.caret.visible = !this.caret.visible;
            }, $1d7285dcca0039d8$var$BLINK_MS);
        }, this.stopBlink = ()=>{
            clearInterval(this.blinkInterval);
            this.blinkInterval = undefined;
            this.caret.visible = false;
        };
        this.shadow = new (0, $gwPoJ.Graphics)();
        this.panel = new (0, $gwPoJ.Graphics)();
        this.addChild(this.shadow);
        this.addChild(this.panel);
        this.chevron = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e)).color((0, $bde0eb94ead9038f$export$542c8a566b36979)).bold().strokeThickness(0).render(">");
        this.chevron.x = (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8);
        this.addChild(this.chevron);
        this.textX = (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) + (this.chevron.width || (0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e) * 0.6) + $1d7285dcca0039d8$var$CHEVRON_GAP;
        // Everything that scrolls lives in the viewport; the mask is what makes a long line stop
        // at the rim instead of running on across the world behind the panel.
        this.viewport = new (0, $8t5Gy.Container)();
        this.viewport.x = this.textX;
        this.textMask = new (0, $gwPoJ.Graphics)();
        this.viewport.mask = this.textMask;
        this.addChild(this.textMask);
        this.addChild(this.viewport);
        this.textNode = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e)).color((0, $bde0eb94ead9038f$export$516f68680b50dca1)).strokeThickness(0).render("");
        this.caret = new (0, $gwPoJ.Graphics)();
        this.viewport.addChild(this.textNode);
        this.viewport.addChild(this.caret);
        this.counter = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$c1e8972bf2d4e8dc)).color((0, $bde0eb94ead9038f$export$dc58655d5df465a7)).strokeThickness(0).render("");
        this.counter.visible = false;
        this.addChild(this.counter);
        this.drawPanel();
        this.layoutRows();
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $kXE1p = parcelRequire("kXE1p");



class $af8850319a5e9cba$export$d7a6623f3d958f18 extends (0, $gwPoJ.Graphics) {
    constructor(...args){
        super(...args), this.bufferFlies = ()=>{
            const container = new (0, $gwPoJ.Graphics)();
            container.beginFill(0xffffff, 0);
            container.drawRect(0, 0, 800, 1);
            container.drawRect(0, 0, 1, 400);
            container.endFill();
            for(let i = 0; i < 3; i++)setTimeout(()=>{
                const renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: "bee",
                    scale: 1.0,
                    color: 0xffffff,
                    animationSpeed: (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.14, 0.167)
                });
                renderable.x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(50, 800);
                renderable.y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(50, 400);
                renderable.alpha = 0.0;
                container.addChild(renderable);
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(renderable, {
                    direction: "in",
                    minAlpha: 1.0,
                    fadeAlphaDecrement: 0.1
                }).update();
            }, (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 250));
            return container;
        }, this.update = ()=>{
            const container = new (0, $gwPoJ.Graphics)();
            const sprite = new (0, $7Bs2Z.Sprite)((0, $kXE1p.Loader).shared.resources["intro_scene"].texture);
            sprite.scale.set(0.3);
            container.addChild(sprite);
            container.alpha = 0.0;
            return container;
        };
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
const $f84ce7d40829905e$export$d366e2aaf798d630 = "Jost, Verdana, Geneva, sans-serif";
const $f84ce7d40829905e$export$bdcdd190e0e471c4 = 800;
const $f84ce7d40829905e$export$843193d9c9a3c91b = 460;
const $f84ce7d40829905e$export$56d196d2844d1ca1 = {
    panelFill: 0x11151b,
    panelRim: 0x7a889e,
    fieldFill: 0x070a0e,
    fieldRim: 0x7a889e,
    text: 0xf2f4ef,
    muted: 0xa9b2bf,
    accent: 0x8fd66b,
    accentHi: 0xa9e388,
    accentDim: 0x6fae4f,
    onAccent: 0x0d1710,
    danger: 0xe8a08c,
    shadow: 0x000000,
    scrim: 0x080b10
};
const $f84ce7d40829905e$export$3f0e99ae6e0ec541 = {
    cardWidth: 460,
    cardPadding: 26,
    cardRadius: 10,
    fieldHeight: 44,
    fieldRadius: 8,
    buttonHeight: 44,
    buttonRadius: 8,
    gutter: 16
};
const $f84ce7d40829905e$export$35aa3e8070dd3c30 = $f84ce7d40829905e$export$3f0e99ae6e0ec541.cardWidth - $f84ce7d40829905e$export$3f0e99ae6e0ec541.cardPadding * 2;
const $f84ce7d40829905e$export$3d8dfa7926012c64 = (g, w, h, radius = $f84ce7d40829905e$export$3f0e99ae6e0ec541.cardRadius)=>{
    g.clear();
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.shadow, 0.34);
    g.drawRoundedRect(3, 7, w, h, radius);
    g.endFill();
    g.lineStyle({
        width: 1,
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.panelRim,
        alpha: 0.55
    });
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.panelFill, 0.9);
    g.drawRoundedRect(0, 0, w, h, radius);
    g.endFill();
    g.lineStyle(0);
};
const $f84ce7d40829905e$export$7ac3698ce9457404 = (g, w, h, radius = 8)=>{
    g.clear();
    g.lineStyle({
        width: 1,
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.panelRim,
        alpha: 0.35
    });
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.panelFill, 0.8);
    g.drawRoundedRect(0, 0, w, h, radius);
    g.endFill();
    g.lineStyle(0);
};
const $f84ce7d40829905e$export$a00f6eb43ef2da81 = (g, w, h, tone)=>{
    g.clear();
    const rim = tone === "error" ? {
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.danger,
        alpha: 0.9,
        width: 2
    } : tone === "focused" ? {
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.accent,
        alpha: 0.85,
        width: 2
    } : {
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.fieldRim,
        alpha: 0.4,
        width: 1
    };
    g.lineStyle({
        width: rim.width,
        color: rim.color,
        alpha: rim.alpha
    });
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.fieldFill, 0.72);
    g.drawRoundedRect(0, 0, w, h, $f84ce7d40829905e$export$3f0e99ae6e0ec541.fieldRadius);
    g.endFill();
    g.lineStyle(0);
};
const $f84ce7d40829905e$export$970ba5b8c200b2f1 = (tone)=>(w, h, state)=>{
        const g = new (0, $gwPoJ.Graphics)();
        const override = tone();
        $f84ce7d40829905e$export$a00f6eb43ef2da81(g, w, h, override === "error" ? "error" : state === "FOCUSED" ? "focused" : "default");
        return g;
    };
const $f84ce7d40829905e$export$e2b5c7690a313f00 = ()=>{
    const fonts = typeof document !== "undefined" ? document.fonts : undefined;
    if (!fonts || typeof fonts.load !== "function") return Promise.resolve();
    return Promise.all([
        fonts.load('300 88px "Jost"'),
        fonts.load('400 16px "Jost"'),
        fonts.load('500 16px "Jost"')
    ]).then(()=>undefined).catch(()=>undefined);
};


/**
 * The wordmark's timeline, as pure maths.
 *
 * Everything here is a function of elapsed milliseconds, so the renderer can be a single
 * requestAnimationFrame loop that asks "what should letter i look like at t?" and writes the
 * answer. Two things fall out of that:
 *
 *  - A frame that never arrives costs nothing. A hidden tab gets no animation frames at all, and
 *    the old wordmark -- a Fader per letter on `setInterval(..., 2)`, which Chrome clamps to ~1s in
 *    the background -- would sit half-drawn for minutes before finishing. Time-driven state just
 *    jumps to where it should be on the first frame after the tab comes back.
 *  - The choreography is testable without a renderer, which is the only way to assert the shape of
 *    an animation (does it overshoot? is the stagger right? does it land?) at all.
 */ /** Gap between one letter starting its entrance and the next. */ const $b67ebd3775cb0f71$export$5a345ca57ca838cd = 115;
const $b67ebd3775cb0f71$export$8b9e5c5d42c3f8db = 460;
const $b67ebd3775cb0f71$export$4f9066f935d3d8b2 = 28;
const $b67ebd3775cb0f71$export$2d357ab4bb4914c8 = 0.88;
const $b67ebd3775cb0f71$export$1f25fc24307f93ac = 2.2;
const $b67ebd3775cb0f71$export$61d039e8338b360e = 260;
const $b67ebd3775cb0f71$export$51699b5802e21c52 = 520;
const $b67ebd3775cb0f71$export$40da588c31712df0 = 300;
const $b67ebd3775cb0f71$export$5dedcc161001eebd = 0.14;
const $b67ebd3775cb0f71$export$d71fc30b0fb49107 = 0.62;
const $b67ebd3775cb0f71$export$e39d66636c1cc1b8 = 0.07;
const $b67ebd3775cb0f71$export$78832952c59ee86 = 3200;
const $b67ebd3775cb0f71$export$921356573f9c65e9 = 170;
const $b67ebd3775cb0f71$export$42fd3fb39fa9e691 = 700;
const $b67ebd3775cb0f71$export$1755e49798589433 = 0.22;
const $b67ebd3775cb0f71$export$5c5ee632c52bc4a2 = (t)=>t < 0 ? 0 : t > 1 ? 1 : t;
const $b67ebd3775cb0f71$export$1157fb72e7fbceb5 = (t)=>1 - Math.pow(1 - $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t), 3);
const $b67ebd3775cb0f71$export$b410709e4ad080bf = (t)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t) >= 1 ? 1 : 1 - Math.pow(2, -10 * $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t));
const $b67ebd3775cb0f71$export$3daa4a78f444687d = (t, overshoot = $b67ebd3775cb0f71$export$1f25fc24307f93ac)=>{
    const u = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t) - 1;
    return 1 + (overshoot + 1) * u * u * u + overshoot * u * u;
};
const $b67ebd3775cb0f71$export$4053e36566dd3d9a = (t)=>{
    const c = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t);
    return c * c * (3 - 2 * c);
};
const $b67ebd3775cb0f71$export$671c724dbdd0c3a9 = (from, to, t)=>{
    const k = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t);
    const fr = from >> 16 & 0xff;
    const fg = from >> 8 & 0xff;
    const fb = from & 0xff;
    const tr = to >> 16 & 0xff;
    const tg = to >> 8 & 0xff;
    const tb = to & 0xff;
    const r = Math.round(fr + (tr - fr) * k);
    const g = Math.round(fg + (tg - fg) * k);
    const b = Math.round(fb + (tb - fb) * k);
    return r << 16 | g << 8 | b;
};
const $b67ebd3775cb0f71$export$38205451e09fd057 = (cold, hot, settled, t)=>{
    const k = $b67ebd3775cb0f71$export$4053e36566dd3d9a(t);
    return k < 0.5 ? $b67ebd3775cb0f71$export$671c724dbdd0c3a9(cold, hot, k * 2) : $b67ebd3775cb0f71$export$671c724dbdd0c3a9(hot, settled, (k - 0.5) * 2);
};
const $b67ebd3775cb0f71$export$50c9d04991b8f25 = (index, elapsedMs)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2((elapsedMs - index * $b67ebd3775cb0f71$export$5a345ca57ca838cd) / $b67ebd3775cb0f71$export$8b9e5c5d42c3f8db);
const $b67ebd3775cb0f71$export$41b48cf6ccdd6df9 = (index, elapsedMs, pulseElapsed)=>{
    const t = $b67ebd3775cb0f71$export$50c9d04991b8f25(index, elapsedMs);
    const eased = $b67ebd3775cb0f71$export$3daa4a78f444687d(t);
    // Peaks mid-entrance and is gone by the time the letter lands, leaving only the resting halo:
    // this is the "ignition" that travels across the word on the stagger.
    const flare = Math.pow(Math.sin(Math.PI * t), 1.5);
    const breath = 0.5 + 0.5 * Math.sin(2 * Math.PI * (elapsedMs - index * $b67ebd3775cb0f71$export$921356573f9c65e9) / $b67ebd3775cb0f71$export$78832952c59ee86);
    const pulse = pulseElapsed === undefined ? 0 : $b67ebd3775cb0f71$export$1755e49798589433 * Math.sin(Math.PI * $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(pulseElapsed / $b67ebd3775cb0f71$export$42fd3fb39fa9e691));
    return {
        y: $b67ebd3775cb0f71$export$4f9066f935d3d8b2 * (1 - eased),
        alpha: $b67ebd3775cb0f71$export$1157fb72e7fbceb5(t * 1.8),
        scale: $b67ebd3775cb0f71$export$2d357ab4bb4914c8 + (1 - $b67ebd3775cb0f71$export$2d357ab4bb4914c8) * eased,
        tintProgress: t,
        glowAlpha: t * ($b67ebd3775cb0f71$export$5dedcc161001eebd + $b67ebd3775cb0f71$export$e39d66636c1cc1b8 * breath + pulse) + ($b67ebd3775cb0f71$export$d71fc30b0fb49107 - $b67ebd3775cb0f71$export$5dedcc161001eebd) * flare
    };
};
const $b67ebd3775cb0f71$export$bcda309bcb37ce01 = (letterCount)=>(letterCount - 1) * $b67ebd3775cb0f71$export$5a345ca57ca838cd + $b67ebd3775cb0f71$export$40da588c31712df0;
const $b67ebd3775cb0f71$export$d50f73c555340634 = (elapsedMs, letterCount)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2((elapsedMs - ((letterCount - 1) * $b67ebd3775cb0f71$export$5a345ca57ca838cd + $b67ebd3775cb0f71$export$61d039e8338b360e)) / $b67ebd3775cb0f71$export$51699b5802e21c52);
const $b67ebd3775cb0f71$export$dc0efc1f2335b611 = (letterCount)=>(letterCount - 1) * $b67ebd3775cb0f71$export$5a345ca57ca838cd + Math.max($b67ebd3775cb0f71$export$8b9e5c5d42c3f8db, $b67ebd3775cb0f71$export$61d039e8338b360e + $b67ebd3775cb0f71$export$51699b5802e21c52);


const $768df19440da6131$var$LOGO_SIZE = 88;
/** Wide tracking -- roughly 0.16em, applied between letters (never after the last one). */ const $768df19440da6131$var$TRACKING = 14;
/** Offset dark copy behind each glyph. The canopy underneath is busy and nearly the same value as
 *  the accent, so without this the wordmark has no edge to sit on. Matches drawPanel's shadow. */ const $768df19440da6131$var$SHADOW_OFFSET_X = 2;
const $768df19440da6131$var$SHADOW_OFFSET_Y = 5;
const $768df19440da6131$var$SHADOW_ALPHA = 0.4;
/** The halo is a scaled copy of the glyph behind it -- never a filter, see intro_theme. */ const $768df19440da6131$var$GLOW_SPREAD = 1.07;
/** The hairline under the wordmark: half-heights at its thickest point, in logical pixels. */ const $768df19440da6131$var$RULE_WIDTH_RATIO = 0.56;
const $768df19440da6131$var$RULE_CORE_HALF = 1.0;
const $768df19440da6131$var$RULE_GLOW_HALF = 3.0;
const $768df19440da6131$var$RULE_GAP = 16;
class $768df19440da6131$export$a1a937f96881772 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.logoText = "samsara", this.letters = [], this.letterWidths = [], this.totalWidth = 0, this.lineHeight = 0, this.startedAt = 0, this.disposed = false, /**
     * Build every letter up front and cache the run's width.
     *
     * The width has to be exact from frame 1: `intro.ts` centres the wordmark with it once, and
     * the old version both hardcoded `calcWidth() => 630` against a run that rendered ~427 wide
     * AND appended letters one per timer tick, so the container grew while it was spelling itself
     * out and anything positioned from it drifted.
     */ this.build = ()=>{
            this.letters = this.logoText.split("").map(this.buildLetter);
            this.letterWidths = this.letters.map((letter)=>letter.width);
            this.lineHeight = this.letters.length > 0 ? this.letters[0].glyph.height : 0;
            this.totalWidth = this.letterWidths.reduce((sum, w)=>sum + w, 0) + $768df19440da6131$var$TRACKING * Math.max(0, this.letterWidths.length - 1);
        }, this.renderLetter = (letter)=>{
            const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).fontSize($768df19440da6131$var$LOGO_SIZE).color(0xffffff)// The default 1px black outline is for labels out in the world. Here it only muddies
            // the thin Jost 300 stems; the shadow copy below does the separation properly.
            .strokeThickness(0).render(letter);
            // Set before anything reads .width: a style change re-rasterizes, and Jost 300 and 400 have
            // different advances, so measuring at the default weight would mis-size the run.
            text.style.fontWeight = "300";
            return text;
        }, /**
     * One letter = three draws of the SAME raster. Reading `.width` forces the Text to rasterize
     * (the getter calls updateText), after which its texture can back plain Sprites for the shadow
     * and the halo -- 7 canvas textures for the wordmark instead of 21, and the two copies can
     * never drift out of register with the glyph.
     */ this.buildLetter = (letter)=>{
            const glyph = this.renderLetter(letter);
            glyph.anchor.set(0.5);
            // Reading .width is also what forces the raster -- the getter calls updateText -- and
            // everything below depends on the texture being final.
            const width = glyph.width;
            const shadow = new (0, $7Bs2Z.Sprite)(glyph.texture);
            shadow.anchor.set(0.5);
            shadow.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).shadow;
            shadow.alpha = $768df19440da6131$var$SHADOW_ALPHA;
            shadow.x = $768df19440da6131$var$SHADOW_OFFSET_X;
            shadow.y = $768df19440da6131$var$SHADOW_OFFSET_Y;
            const glow = new (0, $7Bs2Z.Sprite)(glyph.texture);
            glow.anchor.set(0.5);
            glow.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent;
            glow.scale.set($768df19440da6131$var$GLOW_SPREAD);
            glow.alpha = 0;
            const container = new (0, $8t5Gy.Container)();
            // Anchored glyphs mean the container's origin is the letter's centre, so the pop scales
            // about the letter rather than dragging it right and down.
            container.addChild(shadow, glow, glyph);
            return {
                container: container,
                glyph: glyph,
                glow: glow,
                shadow: shadow,
                width: width
            };
        }, this.calcWidth = ()=>this.totalWidth, /**
     * A one-off flare over the resting halo. `intro.ts` fires it as the block starts sliding up, so
     * the glow and the motion read as one event rather than two things that happen to overlap.
     */ this.pulse = ()=>{
            this.pulsedAt = Date.now();
        }, /**
     * Lay the wordmark out and start it. `callback` fires once the letters have landed -- that is
     * the screen's cue to slide the block up and bring in the login card.
     */ this.update = (callback)=>{
            const root = new (0, $8t5Gy.Container)();
            let x = 0;
            this.letters.forEach((letter, i)=>{
                letter.container.x = x + this.letterWidths[i] / 2;
                letter.container.y = this.lineHeight / 2;
                root.addChild(letter.container);
                x += this.letterWidths[i] + $768df19440da6131$var$TRACKING;
            });
            this.rule = new (0, $gwPoJ.Graphics)();
            root.addChild(this.rule);
            this.startedAt = Date.now();
            this.applyFrame(0);
            // The letters are driven by animation frames, but the CUE is a timer. A hidden tab gets no
            // frames, and a player who opens the game in a background tab still has to find a login
            // card waiting when they come back -- so the cue never depends on anything having rendered.
            this.settleHandle = setTimeout(callback, (0, $b67ebd3775cb0f71$export$bcda309bcb37ce01)(this.letters.length));
            this.frameHandle = requestAnimationFrame(this.tick);
            return root;
        }, this.tick = ()=>{
            if (this.disposed) return;
            this.applyFrame(Date.now() - this.startedAt);
            this.frameHandle = requestAnimationFrame(this.tick);
        }, this.applyFrame = (elapsed)=>{
            const pulseElapsed = this.pulsedAt === undefined ? undefined : Date.now() - this.pulsedAt;
            this.letters.forEach((letter, i)=>{
                const state = (0, $b67ebd3775cb0f71$export$41b48cf6ccdd6df9)(i, elapsed, pulseElapsed);
                letter.container.y = this.lineHeight / 2 + state.y;
                letter.container.alpha = state.alpha;
                letter.container.scale.set(state.scale);
                letter.glyph.tint = (0, $b67ebd3775cb0f71$export$38205451e09fd057)((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text, state.tintProgress);
                letter.glow.alpha = state.glowAlpha;
            });
            this.drawRule((0, $b67ebd3775cb0f71$export$d50f73c555340634)(elapsed, this.letters.length));
        }, /**
     * The hairline wipes out from the centre.
     *
     * It is one lens-shaped path, not a bar and not a row of segments. A bar has two hard stops
     * and reads as a divider; segments with falling alpha leave a bright seam everywhere two of
     * them overlap. A lens tapers to nothing at both ends in a single fill, which is also the
     * cheaper draw -- and the same "shape as one continuous path" rule the chat bubbles follow.
     */ this.drawRule = (progress)=>{
            if (!this.rule) return;
            this.rule.clear();
            if (progress <= 0) return;
            const halfWidth = (0, $b67ebd3775cb0f71$export$b410709e4ad080bf)(progress) * this.totalWidth * $768df19440da6131$var$RULE_WIDTH_RATIO / 2;
            const alpha = (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5)(progress);
            const cx = this.totalWidth / 2;
            const y = this.lineHeight + $768df19440da6131$var$RULE_GAP;
            // A quadratic's peak sits halfway to its control point, so the control goes at twice the
            // half-height we actually want.
            const lens = (half)=>{
                this.rule.moveTo(cx - halfWidth, y);
                this.rule.quadraticCurveTo(cx, y - half * 2, cx + halfWidth, y);
                this.rule.quadraticCurveTo(cx, y + half * 2, cx - halfWidth, y);
                this.rule.closePath();
            };
            // Fatter, dimmer copy for the glow, then the hairline itself. Never a filter -- intro_theme.
            this.rule.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, 0.14 * alpha);
            lens($768df19440da6131$var$RULE_GLOW_HALF);
            this.rule.endFill();
            this.rule.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, 0.9 * alpha);
            lens($768df19440da6131$var$RULE_CORE_HALF);
            this.rule.endFill();
        }, /**
     * Stop the loop and free the rasters. A pixi Text's canvas texture is not reclaimed by GC, and
     * the login screen is torn down on every sign-in, so this has to be called -- see
     * `Intro.guestLandingRemover`.
     */ this.dispose = ()=>{
            this.disposed = true;
            if (this.frameHandle !== undefined) {
                cancelAnimationFrame(this.frameHandle);
                this.frameHandle = undefined;
            }
            if (this.settleHandle !== undefined) {
                clearTimeout(this.settleHandle);
                this.settleHandle = undefined;
            }
            this.letters.forEach((letter)=>{
                // The sprites borrow the glyph's texture, so only the glyph may destroy it.
                letter.shadow.destroy({
                    texture: false,
                    baseTexture: false
                });
                letter.glow.destroy({
                    texture: false,
                    baseTexture: false
                });
                letter.glyph.destroy({
                    texture: true,
                    baseTexture: true
                });
                letter.container.destroy({
                    children: true
                });
            });
            this.letters = [];
            this.rule?.destroy();
            this.rule = undefined;
        };
        this.build();
    }
}





parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $314a16dbbd0a4e9b$export$b78a3abd8101bea6 extends (0, $gwPoJ.Graphics) {
    constructor({ label: label, width: width, variant: variant, onClick: onClick, height: height }){
        super(), this.hovered = false, this.pressed = false, this.enabled = true, this.setEnabled = (enabled)=>{
            this.enabled = enabled;
            this.interactive = enabled;
            this.cursor = enabled ? "pointer" : "default";
            this.paint();
        }, this.setLabel = (text)=>{
            this.label.text = text;
            this.paint();
        }, this.paint = ()=>{
            this.clear();
            const dim = !this.enabled;
            const fillAlpha = dim ? 0.4 : 1;
            if (this.variant === "primary") {
                const fill = this.pressed ? (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentDim : this.hovered ? (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi : (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent;
                this.beginFill(fill, fillAlpha);
                this.drawRoundedRect(0, 0, this.w, this.h, (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonRadius);
                this.endFill();
            } else {
                this.lineStyle({
                    width: 1,
                    color: (0, $f84ce7d40829905e$export$56d196d2844d1ca1).panelRim,
                    alpha: dim ? 0.3 : this.hovered ? 0.8 : 0.55
                });
                this.beginFill(0xffffff, this.pressed ? 0.1 : this.hovered ? 0.08 : 0.04);
                this.drawRoundedRect(0, 0, this.w, this.h, (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonRadius);
                this.endFill();
                this.lineStyle(0);
            }
            this.label.alpha = dim ? 0.55 : 1;
            this.label.x = Math.round((this.w - this.label.width) / 2);
            this.label.y = Math.round((this.h - this.label.height) / 2);
        };
        this.variant = variant;
        this.w = width;
        this.h = height ?? (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight;
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).fontSize(16).color(variant === "primary" ? (0, $f84ce7d40829905e$export$56d196d2844d1ca1).onAccent : (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text).align("center").render(label);
        if (variant === "primary") this.label.style.fontWeight = "600";
        else this.label.style.fontWeight = "500";
        this.addChild(this.label);
        this.interactive = true;
        this.cursor = "pointer";
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.paint();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.pressed = false;
            this.paint();
        });
        this.on("pointerdown", ()=>{
            this.pressed = true;
            this.paint();
        });
        this.on("pointerup", ()=>{
            this.pressed = false;
            this.paint();
        });
        const fire = ()=>{
            if (this.enabled) onClick();
        };
        this.on("click", fire);
        this.on("tap", fire);
        this.paint();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

var $8JEKL = parcelRequire("8JEKL");


const $774b7b76c6b71a95$export$2566754fe8f3b125 = 24 + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight;
class $774b7b76c6b71a95$export$58231d3fc204542d extends (0, $8t5Gy.Container) {
    constructor({ label: label, placeholder: placeholder, autocomplete: autocomplete, password: password, onInput: onInput, onEnter: onEnter, onEscape: onEscape }){
        super(), this.tone = "default", /**
     * Deferred by a tick on purpose: a focus() issued while the browser is still dispatching the
     * pointerdown/click that triggered it gets handed straight back to the canvas, so switching to
     * the sign-in fields by clicking "Log in" would leave you typing at the game instead.
     */ this.focus = ()=>{
            setTimeout(()=>this.input.focus(), 0);
        }, this.setTone = (tone)=>{
            if (this.tone === tone) return;
            this.tone = tone;
            // Force the library to re-run our box generator: it caches one box per state and only
            // rebuilds when the input's measured size changes, which a tone change does not.
            this.input._buildBoxCache();
            this.input._setState(this.input.state);
        }, /**
     * Detach the DOM input. pixi-text-input appends it to document.body on 'added' and removes it on
     * 'removed', so the node outlives the canvas unless the field is taken off the stage.
     */ this.dispose = ()=>{
            const dom = this.input._dom_input;
            try {
                // The library's 'removed' handler unconditionally does document.body.removeChild, which
                // throws for a field that was disposed before it ever rendered a frame.
                this.input.parent?.removeChild(this.input);
            } catch (e) {
            /* ignore -- the node is detached below either way */ }
            if (dom && dom.parentNode) dom.parentNode.removeChild(dom);
            this.input._dom_added = false;
        };
        this.labelText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).fontSize(12).color((0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted).render(label.toUpperCase());
        this.labelText.style.fontWeight = "500";
        this.labelText.style.letterSpacing = 1.1;
        this.addChild(this.labelText);
        this.input = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
            input: {
                fontFamily: (0, $f84ce7d40829905e$export$d366e2aaf798d630),
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: `${(0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight}px`,
                height: `${(0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight}px`,
                width: `${(0, $f84ce7d40829905e$export$35aa3e8070dd3c30)}px`,
                boxSizing: "border-box",
                padding: "0 14px",
                color: "#f2f4ef",
                caretColor: "#8fd66b",
                multiline: false
            },
            box: (w, h, state)=>{
                const g = new (0, $gwPoJ.Graphics)();
                (0, $f84ce7d40829905e$export$a00f6eb43ef2da81)(g, w, h, this.tone === "error" ? "error" : state === "FOCUSED" ? "focused" : "default");
                return g;
            }
        });
        // Keep the real <input> on screen instead of the library's pixi Text stand-in -- see the
        // class comment.
        //
        // The constructor always builds the stand-in before we can opt out, and the library's
        // _destroySurrogate() drops the Text and its hitbox but NOT _surrogate_mask -- a Graphics
        // filled with beginFill(0), i.e. opaque black, covering the field inset by its padding.
        // Left behind it paints a black slab over our frame. Take it out here.
        this.input.substituteText = false;
        const orphanedMask = this.input._surrogate_mask;
        if (orphanedMask) {
            this.input.removeChild(orphanedMask);
            orphanedMask.destroy();
            this.input._surrogate_mask = null;
        }
        this.input.y = 24;
        this.addChild(this.input);
        const dom = this.input._dom_input;
        dom.className = "samsara-input";
        dom.setAttribute("autocomplete", autocomplete);
        dom.setAttribute("name", autocomplete === "current-password" ? "password" : "username");
        dom.setAttribute("aria-label", label);
        if (password) dom.type = "password";
        else {
            dom.setAttribute("autocapitalize", "off");
            dom.setAttribute("autocorrect", "off");
            dom.setAttribute("spellcheck", "false");
            this.input.maxLength = 24;
        }
        if (placeholder) this.input.placeholder = placeholder;
        if (onInput) this.input.on("input", onInput);
        this.input.on("keyup", (keycode)=>{
            if (keycode === 13 && onEnter) onEnter();
            if (keycode === 27 && onEscape) onEscape();
        });
        // Typing in a field that is showing an error clears the error rim -- the message itself is
        // cleared by the card, which owns it.
        this.input.on("input", ()=>{
            if (this.tone === "error") this.setTone("default");
        });
    }
    get value() {
        return (this.input.text || "").trim();
    }
    set value(next) {
        this.input.text = next;
    }
}


class $19eb09ada16d9b5b$export$25233b7fe55e5696 extends (0, $8t5Gy.Container) {
    constructor(props){
        super(), this.panel = new (0, $gwPoJ.Graphics)(), this.content = new (0, $8t5Gy.Container)(), this.mode = "guest", this.submitted = false, this.focus = ()=>{
            this.nameField?.focus();
        }, this.setMode = (mode)=>{
            if (this.mode === mode) return;
            this.mode = mode;
            this.layout();
            if (mode === "account" && this.nameField?.value) this.passwordField?.focus();
            else this.focus();
        }, /**
     * Show a failure against the credentials that are still in the fields. The username is kept --
     * losing it on every wrong password is most of what made the old failure path miserable.
     */ this.showError = (message)=>{
            this.submitted = false;
            this.mode = "account";
            this.layout({
                error: message
            });
            this.passwordField?.setTone("error");
            this.passwordField?.focus();
        }, this.dispose = ()=>{
            this.nameField?.dispose();
            this.passwordField?.dispose();
            this.nameField = undefined;
            this.passwordField = undefined;
            this.content.removeChildren();
            this.removeChildren();
            this.parent?.removeChild(this);
        }, this.layout = (opts = {})=>{
            const keepName = this.nameField?.value;
            const keepPassword = this.passwordField?.value;
            this.nameField?.dispose();
            this.passwordField?.dispose();
            this.nameField = undefined;
            this.passwordField = undefined;
            this.content.removeChildren();
            this.errorText = undefined;
            const pad = (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardPadding;
            let y = pad;
            const place = (child, top)=>{
                child.x = pad;
                child.y = top;
                this.content.addChild(child);
            };
            if (this.mode === "account") {
                const heading = this.text("Welcome back", 18, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text, "500");
                place(heading, y);
                y += 34;
            }
            this.nameField = new (0, $774b7b76c6b71a95$export$58231d3fc204542d)({
                label: "Player name",
                placeholder: this.mode === "guest" ? "Pick a name, or play as a guest" : undefined,
                autocomplete: "username",
                onEnter: ()=>this.mode === "guest" ? this.play() : this.passwordField?.focus(),
                onEscape: ()=>this.mode === "account" && this.setMode("guest")
            });
            if (keepName) this.nameField.value = keepName;
            place(this.nameField, y);
            y += 24 + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight;
            if (this.mode === "account") {
                y += 16;
                this.passwordField = new (0, $774b7b76c6b71a95$export$58231d3fc204542d)({
                    label: "Password",
                    autocomplete: "current-password",
                    password: true,
                    onInput: this.dimError,
                    onEnter: this.submit,
                    onEscape: ()=>this.setMode("guest")
                });
                if (keepPassword) this.passwordField.value = keepPassword;
                place(this.passwordField, y);
                y += 24 + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight;
            }
            if (opts.error) {
                y += 10;
                this.errorText = this.text(opts.error, 14, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).danger, "normal", (0, $f84ce7d40829905e$export$35aa3e8070dd3c30));
                place(this.errorText, y);
                y += this.errorText.height;
            }
            y += (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).gutter;
            if (this.mode === "guest") {
                const half = ((0, $f84ce7d40829905e$export$35aa3e8070dd3c30) - (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).gutter) / 2;
                const play = new (0, $314a16dbbd0a4e9b$export$b78a3abd8101bea6)({
                    label: "Play",
                    width: half,
                    variant: "primary",
                    onClick: this.play
                });
                place(play, y);
                const guest = new (0, $314a16dbbd0a4e9b$export$b78a3abd8101bea6)({
                    label: "Play as guest",
                    width: half,
                    variant: "ghost",
                    onClick: ()=>this.props.onPlay(this.props.guestName)
                });
                guest.x = pad + half + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).gutter;
                guest.y = y;
                this.content.addChild(guest);
                y += (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight + 24;
                const rule = new (0, $gwPoJ.Graphics)();
                rule.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).panelRim, 0.28);
                rule.drawRect(0, 0, (0, $f84ce7d40829905e$export$35aa3e8070dd3c30), 1);
                rule.endFill();
                place(rule, y);
                y += 15;
                const footer = new (0, $8t5Gy.Container)();
                const prompt = this.text("Already have an account?", 14, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted);
                const link = this.text("Log in", 14, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, "500");
                link.x = prompt.width + 6;
                link.interactive = true;
                link.cursor = "pointer";
                const toAccount = ()=>this.setMode("account");
                link.on("click", toAccount);
                link.on("tap", toAccount);
                link.on("pointerover", ()=>link.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi);
                link.on("pointerout", ()=>link.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent);
                footer.addChild(prompt);
                footer.addChild(link);
                footer.x = pad + Math.round(((0, $f84ce7d40829905e$export$35aa3e8070dd3c30) - (prompt.width + 6 + link.width)) / 2);
                footer.y = y;
                this.content.addChild(footer);
                y += footer.height;
            } else {
                const login = new (0, $314a16dbbd0a4e9b$export$b78a3abd8101bea6)({
                    label: "Log in",
                    width: (0, $f84ce7d40829905e$export$35aa3e8070dd3c30) - 86,
                    variant: "primary",
                    onClick: this.submit
                });
                place(login, y);
                const back = this.text("Back", 14, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted);
                back.interactive = true;
                back.cursor = "pointer";
                const toGuest = ()=>this.setMode("guest");
                back.on("click", toGuest);
                back.on("tap", toGuest);
                back.on("pointerover", ()=>back.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text);
                back.on("pointerout", ()=>back.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted);
                back.x = pad + (0, $f84ce7d40829905e$export$35aa3e8070dd3c30) - 86 + Math.round((86 - back.width) / 2);
                back.y = y + Math.round(((0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight - back.height) / 2);
                this.content.addChild(back);
                y += (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight;
            }
            const height = y + pad;
            (0, $f84ce7d40829905e$export$3d8dfa7926012c64)(this.panel, (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardWidth, height);
            this.y = Math.round(this.props.centerY - height / 2);
        }, /**
     * Fade the message once the player starts fixing the input, without re-laying out the card --
     * dropping the row would resize the panel and steal focus mid-keystroke.
     */ this.dimError = ()=>{
            if (this.errorText) this.errorText.visible = false;
        }, this.text = (value, size, color, weight = "normal", wrap)=>{
            const builder = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).fontSize(size).color(color);
            const text = (wrap ? builder.wordWrap(wrap) : builder).render(value);
            text.style.fontWeight = weight;
            return text;
        }, this.play = ()=>{
            if (this.submitted) return;
            const name = this.nameField?.value || this.props.guestName;
            this.submitted = true;
            this.props.onPlay(name);
        }, this.submit = ()=>{
            if (this.submitted) return;
            const username = this.nameField?.value;
            const password = this.passwordField?.value;
            if (!username) {
                this.layout({
                    error: "Enter your player name."
                });
                this.nameField?.setTone("error");
                this.nameField?.focus();
                return;
            }
            if (!password) {
                this.layout({
                    error: "Enter your password."
                });
                this.passwordField?.setTone("error");
                this.passwordField?.focus();
                return;
            }
            this.submitted = true;
            this.props.onLogin(username, password);
        };
        this.props = props;
        this.addChild(this.panel);
        this.addChild(this.content);
        this.layout();
    }
    get currentMode() {
        return this.mode;
    }
}




/** Where the wordmark starts before it settles, and how long the slide takes. */ const $93842021a2e36862$var$LOGO_DROP = 120;
const $93842021a2e36862$var$LOGO_SLIDE_MS = 630;
/**
 * The card's middle. The wordmark settles above ~130 and the socials/fullscreen chips sit at
 * CHROME_Y, so this centres the card in what is left and lets it grow either way.
 */ const $93842021a2e36862$var$CARD_CENTER_Y = 273;
const $93842021a2e36862$var$CHROME_Y = (0, $f84ce7d40829905e$export$843193d9c9a3c91b) - 40;
class $93842021a2e36862$export$b3c44ac484b3c461 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.formRemover = ()=>{
            this.card?.dispose();
            this.card = undefined;
            this.container?.removeChildren();
            this.container?.parent?.removeChild(this.container);
            this.container = undefined;
        }, this.guestLandingRemover = ()=>{
            this.formRemover();
            // Frees the wordmark's canvas rasters and stops its animation frame loop; neither is
            // reclaimed by removeChildren().
            this.logo?.dispose();
            this.logo = undefined;
            this.landingContainer?.removeChildren();
            this.landingContainer?.parent?.removeChild(this.landingContainer);
            this.socials?.removeChildren();
            this.socials?.parent?.removeChild(this.socials);
        }, this.loginSuccess = ()=>{
            this.loggingIn = false;
            this.guestLandingRemover();
        }, /**
     * A rejected sign-in. Returns true when the card took the message inline -- the caller then
     * skips the global screen banner, which used to land across the wordmark.
     */ this.loginFailed = ()=>{
            this.loggingIn = false;
            if (this.card) {
                this.container.visible = true;
                this.card.showError("That name and password don't match.");
                return true;
            }
            if (this.container) this.container.visible = true;
            return false;
        }, this.init = (doneCallback)=>{
            if (this.loggingIn) return;
            // Jost has to be resolvable before the first Text is built; a pixi Text keeps whatever face
            // it rasterized with. ensureIntroFont never rejects, so a slow CDN-less start still gets a
            // login screen, just in Verdana.
            (0, $f84ce7d40829905e$export$e2b5c7690a313f00)().then(()=>this.build(doneCallback));
        }, this.build = (doneCallback)=>{
            const landingContainer = new (0, $gwPoJ.Graphics)();
            this.landingContainer = landingContainer;
            const introBackgroundGenerator = new (0, $af8850319a5e9cba$export$d7a6623f3d958f18)();
            const background = introBackgroundGenerator.update();
            background.x = 0;
            landingContainer.addChild(background);
            // A touch of scrim so white text and the card's rim hold up over the busiest parts of the
            // forest without hiding the art.
            const scrim = new (0, $gwPoJ.Graphics)();
            scrim.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).scrim, 0.28);
            scrim.drawRect(0, 0, (0, $f84ce7d40829905e$export$bdcdd190e0e471c4), (0, $f84ce7d40829905e$export$843193d9c9a3c91b) + 40);
            scrim.endFill();
            landingContainer.addChild(scrim);
            const butterflies = introBackgroundGenerator.bufferFlies();
            butterflies.x = 0;
            landingContainer.addChild(butterflies);
            const introGenerator = new (0, $768df19440da6131$export$a1a937f96881772)();
            this.logo = introGenerator;
            const intro = introGenerator.update(()=>{
                introGenerator.pulse();
                this.slideLogo(intro);
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(background, {
                    direction: "in",
                    minAlpha: 1.0,
                    fadeAlphaDecrement: 0.005,
                    releaseCallback: ()=>{
                        if (this.container) {
                            this.container.visible = true;
                            this.card?.focus();
                        }
                    }
                }).update();
                this.container = this.buildLoginContainer(doneCallback);
                this.container.visible = false;
                this.guiManager.stage.addChild(this.container);
                this.socials = this.buildSocials(this.guiManager.stage);
            });
            intro.x = Math.round(((0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - introGenerator.calcWidth()) / 2);
            intro.y = $93842021a2e36862$var$LOGO_DROP;
            landingContainer.addChild(intro);
            this.guiManager.stage.addChild(landingContainer);
        }, /**
     * Ease the wordmark up to its resting place (the old version stepped 1px on a 1ms timer).
     *
     * Expo rather than cubic: it covers most of the distance early and then creeps the last few
     * pixels, which reads as the block settling into place instead of coasting to a stop. No
     * overshoot here -- the wordmark rests at y=0, the top of the screen, so there is nothing above
     * it to spring into. The spring lives in the individual letters, where there is room for it.
     *
     * LOGO_SLIDE_MS is the one dial for how gradual this feels; it is the whole travel time.
     */ this.slideLogo = (intro)=>{
            const started = Date.now();
            const tick = ()=>{
                const t = Math.min(1, (Date.now() - started) / $93842021a2e36862$var$LOGO_SLIDE_MS);
                const eased = t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
                intro.y = Math.round($93842021a2e36862$var$LOGO_DROP * (1 - eased));
                if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
        }, this.buildLoginContainer = (doneCallback)=>{
            const container = new (0, $8t5Gy.Container)();
            const guestName = "Guest " + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(1, 10000);
            const card = new (0, $19eb09ada16d9b5b$export$25233b7fe55e5696)({
                guestName: guestName,
                centerY: $93842021a2e36862$var$CARD_CENTER_Y,
                onPlay: (playerName)=>{
                    // A phone can only expand from inside a gesture, and this is the first one that
                    // means "I am playing" -- the taps before it may be aimed at the name field, and
                    // resizing the page out from under an opening soft keyboard is its own mess.
                    (0, $0f29b5a53cc88186$export$1bfbbc26cf37a585)();
                    container.visible = false;
                    setTimeout(()=>doneCallback(playerName), 250);
                },
                onLogin: (username, password)=>{
                    (0, $0f29b5a53cc88186$export$1bfbbc26cf37a585)();
                    this.loggingIn = true;
                    container.visible = false;
                    doneCallback(username, password);
                }
            });
            // y is the card's own business -- it re-centres itself on CARD_CENTER_Y after each layout.
            card.x = Math.round(((0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardWidth) / 2);
            container.addChild(card);
            this.card = card;
            return container;
        }, this.buildSocials = (parent)=>{
            const allContainer = new (0, $gwPoJ.Graphics)();
            if (parent) parent.addChild(allContainer);
            const socialContainer = new (0, $gwPoJ.Graphics)();
            socialContainer.x = 12;
            socialContainer.y = $93842021a2e36862$var$CHROME_Y;
            const socialMedia = this.guiManager.socialMedia();
            // socialMedia() positions its own row for the in-game HUD; the intro parks it in a chip.
            socialMedia.y = 0;
            socialMedia.x = 0;
            (0, $f84ce7d40829905e$export$7ac3698ce9457404)(socialContainer, socialMedia.width + 20, 34);
            socialMedia.x = 10;
            socialMedia.y = Math.round((34 - socialMedia.height) / 2);
            socialContainer.addChild(socialMedia);
            allContainer.addChild(socialContainer);
            // No chip where the platform has no fullscreen to give: iPhone, and an embed framed
            // without allowfullscreen. Better an absent control than one that visibly does nothing.
            if (!(0, $0f29b5a53cc88186$export$efad50a2596de3ba)()) return allContainer;
            const fullscreenChip = new (0, $gwPoJ.Graphics)();
            (0, $f84ce7d40829905e$export$7ac3698ce9457404)(fullscreenChip, 34, 34);
            fullscreenChip.x = (0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - 34 - 12;
            fullscreenChip.y = $93842021a2e36862$var$CHROME_Y;
            const expandFullScreen = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: "fullscreen.png",
                scale: 0.55
            });
            expandFullScreen.x = 17;
            expandFullScreen.y = 17;
            fullscreenChip.addChild(expandFullScreen);
            fullscreenChip.interactive = true;
            fullscreenChip.cursor = "pointer";
            fullscreenChip.on("click", (0, $0f29b5a53cc88186$export$1aba1ee5e6dc1474));
            fullscreenChip.on("tap", (0, $0f29b5a53cc88186$export$1aba1ee5e6dc1474));
            allContainer.addChild(fullscreenChip);
            return allContainer;
        };
        this.guiManager = guiManager;
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");




class $7679dbbb27672f9f$export$3ee0d0a1366434ff {
    constructor(subject, props){
        this.faderStep = 0.01;
        this.direction = "out";
        this.isActive = ()=>this.active;
        this.update = ()=>{
            this.active = true;
            if (this.interval) return;
            this.interval = setInterval(()=>{
                if (this.direction === "out") {
                    this.alpha -= this.faderStep;
                    this.effectCallback(this.alpha);
                    if (this.alpha <= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else if (this.direction === "in") {
                    this.alpha += this.faderStep;
                    this.effectCallback(this.alpha);
                    if (this.alpha >= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else {
                    // not supported, clear it right away
                    clearInterval(this.interval);
                    this.interval = undefined;
                }
            }, this.fadeInterval);
        };
        this.stop = (suppressCallback)=>{
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
            if (!suppressCallback && this.releaseCallback) this.releaseCallback();
            this.active = false;
        };
        this.releaseCallback = props?.releaseCallback;
        this.effectCallback = props?.effectCallback;
        this.minAlpha = props?.minAlpha !== undefined ? props.minAlpha : this.direction === "out" ? 0.0 : 1.0;
        this.fadeInterval = props?.fadeInterval || 2;
        this.faderStep = props?.fadeAlphaDecrement || 0.01;
        this.direction = props?.direction || "out";
        if (this.direction === "out") this.alpha = props.maxAlpha || 1.0;
        else this.alpha = 0.0;
    }
}


class $a231d713277e9a39$export$9a82c68eff2bb78f extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, map, onClickCallback){
        super(guiManager), this.throbbers = [], this.createContent = ()=>{
            const main = new (0, $gwPoJ.Graphics)();
            const width = this.width();
            const height = this.height();
            const sizeX = width / this.map.dimensions.w;
            const sizeY = height / this.map.dimensions.h;
            main.beginFill(0x808080);
            main.drawRect(0, 0, width, height);
            main.endFill();
            this.map.map.points.forEach((point)=>{
                const pointObj = new (0, $gwPoJ.Graphics)();
                pointObj.interactive = true;
                main.addChild(pointObj);
                const { x: x, y: y } = point.biomeCoordinate;
                pointObj.x = x * sizeX;
                pointObj.y = y * sizeY;
                pointObj.beginFill(point.color);
                pointObj.drawRect(0, 0, sizeX, sizeY);
                pointObj.endFill();
                pointObj.on("click", ()=>this.onClickCallback({
                        x: x,
                        y: y
                    }));
                pointObj.on("tap", ()=>this.onClickCallback({
                        x: x,
                        y: y
                    }));
            });
            if (this.map.playerLocations) this.map.playerLocations.forEach((location)=>{
                const playerLocation = new (0, $gwPoJ.Graphics)();
                playerLocation.beginFill(location.isViewer ? 0xff0000 : 0xffffff);
                playerLocation.drawCircle(0, 0, sizeX / 2);
                playerLocation.endFill();
                playerLocation.x = location.location.x * sizeX;
                playerLocation.y = location.location.y * sizeY;
                main.addChild(playerLocation);
                playerLocation.interactive = true;
                if (location.isViewer) {
                    let dir = false;
                    playerLocation.scale.set(1.2);
                    const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(playerLocation, {
                        blinkInterval: 25,
                        cycleCallback: ()=>{
                            if (dir) playerLocation.tint = 0xff0000;
                            else playerLocation.tint = 0x000000;
                            dir = !dir;
                        }
                    });
                    this.throbbers.push(throbber);
                    throbber.update();
                    const playerLocationHuge = new (0, $gwPoJ.Graphics)();
                    playerLocationHuge.beginFill(location.isViewer ? 0xff0000 : 0xffffff);
                    playerLocationHuge.drawCircle(0, 0, sizeX / 2);
                    playerLocationHuge.endFill();
                    playerLocationHuge.x = location.location.x * sizeX;
                    playerLocationHuge.y = location.location.y * sizeY;
                    playerLocationHuge.scale.set(2);
                    main.addChild(playerLocationHuge);
                    const fader = new (0, $7679dbbb27672f9f$export$3ee0d0a1366434ff)(playerLocationHuge, {
                        direction: "out",
                        maxAlpha: 4.0,
                        fadeAlphaDecrement: 0.03,
                        fadeInterval: 0.5,
                        effectCallback: (alpha)=>{
                            playerLocationHuge.scale.set(alpha);
                        }
                    });
                    fader.update();
                }
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(location.label);
                playerLocation.on("mouseover", ()=>{
                    text.x = playerLocation.x - text.width / 2;
                    text.y = playerLocation.y - text.height * 1.2;
                    text.zIndex = 1000;
                    main.addChild(text);
                });
                playerLocation.on("mouseout", ()=>{
                    text.parent.removeChild(text);
                });
            });
            if (this.map.locationIcons) this.map.locationIcons.forEach((icon)=>{
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: icon.icon,
                    color: 0xffffff,
                    scale: 0.25
                });
                sprite.x = icon.x * sizeX;
                sprite.y = icon.y * sizeY;
                sprite.interactive = true;
                main.addChild(sprite);
            });
            if (this.map.questMarkers) this.map.questMarkers.forEach((icon)=>{
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: icon.icon,
                    color: 0xffffff,
                    scale: 0.25
                });
                sprite.x = icon.x * sizeX;
                sprite.y = icon.y * sizeY;
                sprite.interactive = true;
                if (icon.context?.active) {
                    sprite.recolor(0xff0000);
                    sprite.scale.set(1.5);
                    let dir = false;
                    const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(sprite, {
                        blinkInterval: 25,
                        cycleCallback: ()=>{
                            if (dir) sprite.recolor(0xff0000);
                            else sprite.recolor(0x000000);
                            dir = !dir;
                        }
                    });
                    this.throbbers.push(throbber);
                    throbber.update();
                    const spriteHuge = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: icon.icon,
                        color: 0xffffff,
                        scale: 2.0
                    });
                    spriteHuge.x = icon.x * sizeX;
                    spriteHuge.y = icon.y * sizeY;
                    main.addChild(spriteHuge);
                    const fader = new (0, $7679dbbb27672f9f$export$3ee0d0a1366434ff)(spriteHuge, {
                        direction: "out",
                        maxAlpha: 1.0,
                        fadeInterval: 0.2,
                        effectCallback: (alpha)=>{
                            spriteHuge.scale.set(alpha);
                        }
                    });
                    fader.update();
                }
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(icon.context?.label || "");
                sprite.on("mouseover", ()=>{
                    text.x = sprite.x - text.width / 2;
                    text.y = sprite.y - text.height * 1.2;
                    text.zIndex = 1000;
                    main.addChild(text);
                });
                sprite.on("mouseout", ()=>{
                    text.parent.removeChild(text);
                });
                sprite.on("click", ()=>this.onClickCallback({
                        x: icon.x,
                        y: icon.y
                    }));
                sprite.on("tap", ()=>this.onClickCallback({
                        x: icon.x,
                        y: icon.y
                    }));
                main.addChild(sprite);
            });
            if (this.map.geographicFeatureLocations) this.map.geographicFeatureLocations.forEach((location)=>{
                const chatHistoryText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(location.name);
                chatHistoryText.x = location.x * sizeX;
                chatHistoryText.y = location.y * sizeY;
                main.addChild(chatHistoryText);
            });
            return main;
        };
        this.map = map;
        this.onClose = ()=>{
            this.throbbers?.forEach((throbber)=>throbber.stop);
            this.throbbers = [];
        };
        this.onClickCallback = onClickCallback;
    }
}


const $7dd73ecdd94bfe01$export$84e1549b474f1b93 = 460;
// The top-right chip row: the map toggle, the inventory toggle and the players count, and the gap
// between them. Ember rooms suppress the control bar that normally lives up there, so the corner is
// theirs.
const $7dd73ecdd94bfe01$var$CHIP_ROW_Y = 6;
const $7dd73ecdd94bfe01$var$CHIP_GAP = 5;
// How much bigger the readied-item slots are under a thumb, and how far the row is lifted off the
// bottom edge to make room for the growth. See where the widget is built.
const $7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_SCALE = 1.5;
const $7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_LIFT = 14;
// The tether from a per-entity command wheel to the NPC it commands. Semi-transparent so it reads as
// a link rather than another piece of HUD, and started off the rim so it doesn't cut across the disc.
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA = 0.45;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH = 2;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP = 4 // how far outside the wheel's rim the line begins
;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH = 6 // shorter than this and the line is just a nub: don't draw it
;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS = 3 // marker pinning the far end to the NPC's center
;
// How far past its radius the wheel actually paints -- drawBackground fakes its glow with a ring at
// radius + 11 -- so a wheel parked against a screen edge is clamped on what it LOOKS like, not on
// its geometry. Hand-synced with command_wheel.ts's drawBackground.
const $7dd73ecdd94bfe01$var$WHEEL_GLOW_REACH = 11;
// How far the subject of a pinned panel may drift from that panel's tail tip before the tail stops
// telling the truth -- half a tile, i.e. they are still standing on the spot the panel opened over.
// In stage pixels, which the world overlay puts at surfaceZoom to the world unit (computeLocation).
const $7dd73ecdd94bfe01$var$PANEL_TAIL_SLACK = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
// The joysticks report one of eight compass sectors, and the game moves in those same eight
// directions (see Directions in game-common/models), so each sector maps to the per-axis -1/0/1
// vector the equivalent WASD combination would produce.
const $7dd73ecdd94bfe01$var$JoystickVectors = {
    left: {
        x: -1,
        y: 0
    },
    right: {
        x: 1,
        y: 0
    },
    top: {
        x: 0,
        y: -1
    },
    bottom: {
        x: 0,
        y: 1
    },
    top_left: {
        x: -1,
        y: -1
    },
    top_right: {
        x: 1,
        y: -1
    },
    bottom_left: {
        x: -1,
        y: 1
    },
    bottom_right: {
        x: 1,
        y: 1
    }
};
// Fraction of the stick's travel that reads as "no input". The move stick used to demand 0.9,
// which left only the outermost tenth of the travel usable and let ordinary thumb jitter fall
// out of it mid-drag.
const $7dd73ecdd94bfe01$var$JoystickDeadZone = 0.3;
class $7dd73ecdd94bfe01$export$530fe131767a4087 {
    constructor(stage, minimapSurface, logic){
        this.chatHistoryFader = null;
        this.chatLog = [];
        this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
        this.chatWalk = (0, $2bc3e70fbff7f064$export$2cd8bbcbf799240);
        // Whether the input currently owns the keyboard. The log does not fade itself out while it
        // is open: a line arriving mid-sentence must not take the conversation away from the player
        // who is in the middle of answering it.
        this.chatOpen = false;
        this.CHAT_HISTORY_KEY = "_chatHistory_";
        this.screenMessages = [];
        this.currentScreenMessage = null;
        this.currentMessageTimeout = null;
        // Fade state for the follow-cam: `followCamShown` is the current target (null forces the first
        // evaluation after open to run a fade); `followCamFader` is the active alpha tween.
        this.followCamShown = false;
        this.followCamFader = null;
        // The last list the server sent, kept so opening the panel draws the current one rather than
        // waiting for the next broadcast.
        this.emberPlayers = [];
        // Whether the player has folded the map away. Remembered across rooms and sessions: an ember run
        // drops you into a FRESH room on every death and retry, so a preference that reset each time
        // would be no preference at all.
        this.emberMinimapCollapsed = false;
        this.EMBER_MINIMAP_COLLAPSED_KEY = "_emberMinimapCollapsed_";
        // Where the player has DRAGGED the map to, in this HUD container's own coordinates, or null while
        // it is still parked in its default slot above the roster. Remembered for the same reason the
        // collapsed flag is: a run hands out a fresh room on every death and retry.
        this.emberMinimapPlacement = null;
        this.EMBER_MINIMAP_PLACEMENT_KEY = "_emberMinimapPlacement_";
        // Cache key for the minimap's TREE layer, which the client scans off its own tile map rather than
        // being sent: room + the map's collision version (bumped on every tile write, so a felled tree or
        // a placed wall invalidates it) + the room's extent. Null means "not scanned yet".
        this.emberTreeScanKey = null;
        // ...plus a floor on how often that O(tiles) scan may re-run, so a burst of tile edits (placing a
        // wall writes several cells) can't rescan on every broadcast. Low-end CPUs are the target here.
        this.emberTreeScanAt = 0;
        this.commandWheelHome = {
            x: 0,
            y: 0
        };
        // Last invading verdict seen, so the scorecard is dismissed -- and each end of a visit
        // announced -- on the TRANSITION rather than on every message that arrives during one.
        this.invading = false;
        this.currentPlayerUpgradePoints = 0;
        this.currentPlayerName = "";
        this.currentPlayerHp = 0;
        this.currentPlayerHpMax = 0;
        this.currentPlayerHunger = 0;
        this.currentPlayerHungerMax = 0;
        this.currentPlayerMana = 0;
        this.leftJoystickAngleAllowed = true;
        this.inventoryUpdateTs = new Map();
        this.userSuppressMinimap = false;
        // Per-room flag: when true, the day/night indicator stays hidden even as day-pct updates arrive.
        this.suppressDayCycle = false;
        // Per-room flag: when true, the "Level up stats!" button is not built in helpMessaging().
        this.suppressLevelUp = false;
        // The buttons the LAST helpMessaging() build put on screen. Held only so the next build can give
        // the world's mouse back on their behalf before they are removed -- see helpMessaging().
        this.helpMessagingButtons = [];
        // Per-room flags: when true, the mana meter / food (hunger) meter stay hidden even as
        // update() receives new player mana/hunger values.
        this.suppressMana = false;
        this.suppressFood = false;
        // Per-room flags: when true, the shard/resource counter (resourceBar) / the player name+level
        // label stay hidden even as updateInventory()/update() would otherwise show them.
        this.suppressShards = false;
        this.suppressPlayerName = false;
        // Per-room flag: when true, a guest's standing "/register to save progress" nudge is left out of
        // the help-messaging stack. Ember rooms set it -- see Visibility.suppressGuestPrompt.
        this.suppressGuestPrompt = false;
        this.controlKeyPressed = false;
        this.init = ()=>{
            // meters
            const container = new (0, $gwPoJ.Graphics)();
            this.container = container;
            container.x = 10;
            container.zIndex = 2;
            this.stage.addChild(container);
            const bannerText = new (0, $hnGDn.BitmapText)("", {
                fontName: "BannerFont"
            });
            bannerText.y = 50;
            this.bannerText = bannerText;
            container.addChild(bannerText);
            container.addChild(this.minimapSurface);
            const screenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            // message — the ambient "important" strip self-positions across the full viewport,
            // so it lives on the stage (not the +10 offset HUD container) at its own zIndex.
            const importantMessage = new (0, $a7b6262714ec8487$export$b3ee1e8559ec7f0c)(0xffffff, {
                text: ""
            });
            this.importantMessage = importantMessage;
            this.stage.addChild(importantMessage);
            const hp = new (0, $9b7bf4301258d7f9$export$7332475dd933238a)("heart", 0);
            hp.x = this.stage.width / 2 - hp.width;
            hp.y = 2;
            this.hp = hp;
            container.addChild(hp);
            const mana = new (0, $6cfcddb9955aa6fe$export$10811ae595fe85fd)(0xf0e54c, 19);
            mana.x = hp.x;
            mana.y = hp.height + 8;
            mana.visible = false;
            this.mana = mana;
            container.addChild(mana);
            const hunger = new (0, $6cfcddb9955aa6fe$export$10811ae595fe85fd)(0xc4a484, 19, "drumstick-brown.png");
            hunger.x = mana.x;
            hunger.y = mana.height + 20;
            hunger.visible = false;
            this.hunger = hunger;
            container.addChild(hunger);
            // Chat, bottom-left: the input field, with the log hanging off its top edge. Both are the
            // same width and share a left edge, so they read as one component (gui/chat_theme.ts).
            // The field's bottom has to clear the readied-item row's number labels, which start just
            // below BOTTOM - 46.
            const chatLeft = 15;
            const chatInputTop = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 74;
            this.typing = new (0, $1d7285dcca0039d8$export$3997e86453ee41f3)();
            this.typing.x = chatLeft;
            this.typing.y = chatInputTop;
            this.typing.visible = false;
            this.typing.zIndex = 3;
            this.stage.addChild(this.typing);
            // The log sizes itself and hangs UP from this line, so a long conversation grows into the
            // empty grass above instead of pushing the field down over the hotbar.
            const chatHistory = new (0, $030df650e8220c82$export$23974c6ecceedade)(chatInputTop - 6);
            chatHistory.zIndex = 3;
            chatHistory.x = chatLeft;
            chatHistory.y = chatInputTop - 6;
            this.chatHistory = chatHistory;
            this.stage.addChild(chatHistory);
            // leaderboard
            this.leaderboard = new (0, $f98cea862b8a2ca9$export$c75dedfb09f9174d)(this);
            this.leaderboard.x = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w - 25;
            this.leaderboard.y = 0;
            this.stage.addChild(this.leaderboard);
            // equipped
            this.equipped = new (0, $9fb9be6d4b9a07da$export$ae188dfa452708ef)(this);
            // The readied slots are the only way to swap weapon under a thumb, and at 1x they are a
            // ~32px icon on a 640x360 stage letterboxed down to a phone -- roughly 20 CSS px, and a
            // miss as often as a hit. Scaling the widget takes the slot art, the spacing and the tap
            // targets with it, the same way the control bar is scaled up on touch just below.
            // Anchored bottom-left off BOTTOM, so growing it reaches UP, into empty grass.
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) this.equipped.scale.set($7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_SCALE);
            this.equipped.x = container.x + 10;
            // The anchor cannot be measured: the widget is empty until an inventory arrives, so its
            // height here is 0 and this is really "BOTTOM minus a slot's worth". Scaling the slots
            // makes that guess too small at the bottom -- a slot's quantity badge hangs BELOW its
            // origin, and at 1.5x it hung off the bottom of the screen -- so the anchor is lifted by
            // the same amount the extra scale added.
            this.equipped.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - this.equipped.height - 20 - ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? $7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_LIFT : 0);
            container.addChild(this.equipped);
            // squad
            this.squad = new (0, $bbfac5179e5fdb9e$export$d5f40203d1afc530)(this);
            this.squad.x = 390;
            this.squad.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - this.squad.height - 20;
            container.addChild(this.squad);
            // The connector from a roster-opened command wheel down to the card that opened it. Added
            // BEFORE the roster so the strip -- and the speech bubbles it floats above itself -- draw
            // over the line rather than the line over them.
            this.rosterWheelConnector = new (0, $gwPoJ.Graphics)();
            this.rosterWheelConnector.visible = false;
            container.addChild(this.rosterWheelConnector);
            // ember roster (clickable NPC portraits; only populated in ember rooms). Anchored
            // bottom-right; repositioned as the card count changes (see positionEmberRoster).
            this.emberRoster = new (0, $44af089a9f2b65fe$export$7b64a8ee2d511abd)(this);
            container.addChild(this.emberRoster);
            this.positionEmberRoster();
            // follow-cam PiP modal (opened by clicking a roster portrait). Positioned above the roster
            // on open (see positionFollowCam); the connector line ties it to the watched card.
            this.followCamConnector = new (0, $gwPoJ.Graphics)();
            container.addChild(this.followCamConnector);
            this.followCam = new (0, $a800cd15c7729c86$export$6b342f104f181be3)(this);
            container.addChild(this.followCam);
            // ember minimap — the same slot above the roster, shown while nobody is being tracked
            // (see positionEmberMinimap). Stays hidden until the first per-room broadcast arrives, and
            // folds away into the top-right "show map" chip when the player collapses it. Draggable off
            // that slot to anywhere on screen (see dragEmberMinimapTo).
            this.emberMinimapCollapsed = this.loadEmberMinimapCollapsed();
            this.emberMinimapPlacement = this.loadEmberMinimapPlacement();
            this.emberMinimap = new (0, $27706b8361e494c8$export$72d7fbba603469ff)(()=>this.setEmberMinimapCollapsed(true), {
                onGrab: this.holdOffMinimapDragAttack,
                onDragTo: this.dragEmberMinimapTo,
                onRelease: this.dropEmberMinimap
            });
            container.addChild(this.emberMinimap);
            this.emberMinimapChip = new (0, $d36eec2a890b47fd$export$155d6b3ee6ea424d)(()=>this.setEmberMinimapCollapsed(false));
            container.addChild(this.emberMinimapChip);
            // Same inventory the control bar's button opens; this chip is simply where it lives when
            // the room has hidden that bar.
            this.emberInventoryChip = new (0, $4a2d6e0f8539e4d1$export$3adb491320ceffcc)(()=>this.logic.invokeInventory(null));
            container.addChild(this.emberInventoryChip);
            // "Who else is playing" -- the count chip sits immediately to the LEFT of the map toggle in
            // the top-right corner, and opens the list of online players down the right-hand edge below
            // it. Both stay hidden until the server says there is somebody else to show.
            this.emberPlayersPanel = new (0, $031092a28fb787ca$export$349ef492ca0f8a2a)({
                onInvite: this.inviteEmberPlayer,
                onClose: ()=>this.setEmberPlayersOpen(false)
            });
            container.addChild(this.emberPlayersPanel);
            this.emberPlayersChip = new (0, $847e936c2402c20f$export$79ada16547910660)(()=>this.setEmberPlayersOpen(!this.emberPlayersPanel.visible));
            container.addChild(this.emberPlayersChip);
            // The invitation prompt. Unlike the chip and the list this is NOT ember-only: an invitation
            // finds the player wherever they are, which is the point of being invited somewhere.
            this.emberInvitePrompt = new (0, $102f4cd7b044a43e$export$2910d5f40b7274eb)({
                onAnswer: this.answerEmberInvite
            });
            container.addChild(this.emberInvitePrompt);
            // abilities
            this.abilities = new (0, $ae9502ee83364da4$export$f69bebae58da6a32)(this);
            this.abilities.x = 390;
            this.abilities.y = this.equipped.y;
            container.addChild(this.abilities);
            // player
            this.nameText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(0x00ff00).render();
            this.nameText.y = 1;
            this.nameText.x = 90;
            container.addChild(this.nameText);
            // resource bar
            this.resourceBar = new (0, $11fe0387f9c174f1$export$85cd1614e509c3d9)(this);
            this.resourceBar.visible = true;
            this.resourceBar.setup();
            this.resourceBar.x = this.nameText.x + 5;
            this.resourceBar.y = this.nameText.y;
            container.addChild(this.resourceBar);
            const blackout = new (0, $gwPoJ.Graphics)();
            blackout.x = 0;
            blackout.y = 0;
            blackout.lineStyle(2, 0x000000);
            blackout.beginFill(0x000000);
            blackout.drawRect(0, 0, 1000, 1000);
            blackout.visible = true;
            blackout.alpha = 1.0;
            blackout.endFill();
            this.blackout = blackout;
            this.stage.addChild(blackout);
            const redout = new (0, $gwPoJ.Graphics)();
            redout.x = 0;
            redout.y = 0;
            redout.lineStyle(2, 0xff0000);
            redout.beginFill(0xff0000);
            redout.drawRect(0, 0, 1000, 1000);
            redout.visible = false;
            redout.alpha = 0.3;
            redout.endFill();
            this.redout = redout;
            this.stage.addChild(redout);
            this.minimapSurface.x = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + 40;
            this.minimapSurface.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 105;
            this.characterCustomizer = new (0, $16b4bf3d247fe459$export$6bed762da66f1ed6)(this, this.logic);
            this.characterBuilder = new (0, $5be630d7f2f3b131$export$49421d8fc42e7f44)(this, this.logic);
            const controlBar = new (0, $c95294a9bc078027$export$ee1739c2abaa1d8d)(this);
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) controlBar.scale.set(1.5);
            else controlBar.scale.set(0.7);
            controlBar.setup(()=>{
                this.logic.invokeInventory(null);
            }, ()=>{
                this.logic.invokeQuests();
            }, ()=>{
                this.invokeFeedback();
            }, ()=>{
                this.logic.playerController.client.requestWorldMap();
            });
            controlBar.x = screenWidth - controlBar.width - ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? 32 : 18);
            controlBar.y = 4;
            controlBar.visible = false;
            this.controlBar = controlBar;
            this.container.addChild(controlBar);
            const stickyBanner = new (0, $0159750bbc757373$export$cd136f60375f2af0)(this);
            stickyBanner.setup();
            stickyBanner.y = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.07;
            stickyBanner.x = controlBar.x - stickyBanner.width - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
            this.stickyBanner = stickyBanner;
            this.container.addChild(stickyBanner);
            // The chip goes in because it is what the ember tutorial's first clue points at: a camp
            // suppresses the control bar, so the chip IS the Items button in there (see roomUpdated).
            this.tutorial = new (0, $dbd41000427e8969$export$825b76de5f2b0345)(this, this.container, this.equipped, this.controlBar, this.minimapSurface, this.emberInventoryChip);
            this.dayCycle = new (0, $617042715e0a010b$export$5696eab43b4d4c5a)(this);
            this.dayCycle.visible = false;
            this.dayCycle.x = stickyBanner.x - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 5.25;
            this.dayCycle.y = stickyBanner.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.46;
            this.container.addChild(this.dayCycle);
            this.dayCycle.setup(90);
            this.featureWidget = new (0, $91106b3dea6906a4$export$6386e5268de7fe1f)(this);
            this.featureWidget.x = 0;
            this.featureWidget.y = 55;
            this.container.addChild(this.featureWidget);
            // countdown timer - positioned in center of screen
            this.countdownTimer = new (0, $d85ea5e2371a760e$export$5a0af15366b01c51)({
                radius: 50,
                strokeWidth: 7.5,
                backgroundColor: 0x222222,
                textColor: 0xffffff,
                onComplete: ()=>{
                    // Hide timer after fade out completes (250ms + small buffer)
                    setTimeout(()=>{
                        this.countdownTimer.visible = false;
                    }, 300);
                }
            });
            // Position timer on the top-left, directly under the HP bar and left-aligned to it.
            // The HP bar lives on `container` (offset by container.x), while the timer lives on the
            // stage, so add container.x to convert into stage space. The dial is center-anchored,
            // so add half its width/height to left- and top-align it against the HP bar.
            this.countdownTimer.x = this.container.x + this.hp.x + this.countdownTimer.width / 2;
            this.countdownTimer.y = this.hp.y + this.hp.height + this.countdownTimer.height / 2 + 24;
            this.countdownTimer.visible = false;
            this.countdownTimer.zIndex = 50000 // Lower than chat bubbles (100000)
            ;
            this.stage.addChild(this.countdownTimer);
            // Ember wave badge. Sits exactly where the countdown dial does and is the same size: the
            // dial counts DOWN to the wave, then vanishes and this takes the slot for as long as the
            // wave lasts. The two are never up together (see addScreenMessage).
            this.waveIndicator = new (0, $3220884133cc6599$export$20faccd1109d9248)({
                radius: 50,
                strokeWidth: 7.5
            });
            this.waveIndicator.x = this.countdownTimer.x;
            this.waveIndicator.y = this.countdownTimer.y;
            this.waveIndicator.zIndex = 50000;
            this.stage.addChild(this.waveIndicator);
            // "Let go" -- the invader's way out, and the only exit of the five they press themself. It
            // continues the top-left column (HP bar, then the countdown dial / wave badge) rather than
            // taking a corner of its own: an invader is reading that dial, so the way out sits where
            // they are already looking. Placed once, like the dial above it.
            this.letGoButton = new (0, $daf4f1c650b6c0f9$export$59009c2c2d99348c)({
                onPress: ()=>{
                    this.logic.playerController?.client?.sendEmberInvasionCommand("release");
                    this.logic.playerController?.client?.logActivity("invasion: let go");
                }
            });
            this.letGoButton.x = Math.round(this.countdownTimer.x - this.letGoButton.getWidth() / 2);
            this.letGoButton.y = Math.round(this.countdownTimer.y + 50 + 12);
            this.letGoButton.zIndex = 50001;
            this.stage.addChild(this.letGoButton);
            // command wheel - positioned in center of screen
            this.commandWheel = new (0, $7676384fbaf9cdf2$export$a36bd337d7c5ab90)({
                radius: 80,
                strokeWidth: 3,
                backgroundColor: 0x1b1512,
                textColor: 0xfff3e0,
                highlightColor: 0xffcf87,
                activeColor: 0xff8a3d,
                onCommandSelect: (command, npcType)=>{
                    // Confirmation click, before the branch below: both the interaction page and the
                    // squad command channel are the same gesture from the player's side.
                    this.logic.audio.uiSelect();
                    // targetEntityId is set only when the wheel was opened from a specific NPC's
                    // command button; otherwise the command broadcasts to the whole role.
                    const targetEntityId = this.commandWheel.getTargetEntityId();
                    // The interaction page's "commands" are interaction types on one entity, so they go
                    // out on the interaction channel rather than the squad command channel.
                    if (npcType === (0, $7676384fbaf9cdf2$export$f672e119ffb748dd)) {
                        this.hideCommandWheel();
                        if (targetEntityId) {
                            this.logic.interactionCallback(targetEntityId, command);
                            this.logic.playerController.client.logActivity(`interaction wheel: ${command} on ${targetEntityId}`);
                        }
                        return;
                    }
                    // "Hold Position" asks for a PLACE as well as an order. Hand the pointer to the
                    // location picker and let the click that follows carry the spot; until then nothing
                    // goes to the server. On touch there is no hovering pointer to aim with, so the
                    // order keeps its older meaning there: hold the ground you are already on.
                    if (command === (0, $7676384fbaf9cdf2$export$1789b2f994d19a7a) && !(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                        this.hideCommandWheel();
                        this.logic.playerController.beginLocationPick({
                            caption: "Click the spot to hold",
                            blockedCaption: "Nothing can stand here",
                            onPick: (point)=>{
                                this.logic.playerController.client.sendCommandWheelSelection(command, npcType, targetEntityId, point);
                                this.logic.playerController.client.logActivity(`command wheel: ${command} for ${npcType} at ` + `${Math.round(point.x)},${Math.round(point.y)}`);
                            }
                        });
                        return;
                    }
                    this.logic.playerController.client.sendCommandWheelSelection(command, npcType, targetEntityId);
                    this.logic.playerController.client.logActivity(`command wheel: ${command} for ${npcType}`);
                    // The per-entity wheel is not tied to the Control key, so dismiss it on selection.
                    if (targetEntityId) this.hideCommandWheel();
                }
            });
            this.commandWheel.x = screenWidth / 2;
            this.commandWheel.y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2;
            // Screen-center "home" the global (Control-key) wheel returns to after a per-entity wheel
            // has moved it over an NPC.
            this.commandWheelHome = {
                x: this.commandWheel.x,
                y: this.commandWheel.y
            };
            this.commandWheel.visible = false;
            this.commandWheel.zIndex = 60000 // Higher than countdown timer
            ;
            // The tether lives in the same (stage) frame as the wheel so both ends can be expressed in
            // stage-local coordinates, and sits just under it so the line tucks behind the disc.
            this.commandWheelTether = new (0, $gwPoJ.Graphics)();
            this.commandWheelTether.visible = false;
            this.commandWheelTether.zIndex = this.commandWheel.zIndex - 1;
            this.stage.addChild(this.commandWheelTether);
            this.stage.addChild(this.commandWheel);
            // recruit role picker — opened by the server over a specific recruit (like the per-entity
            // command wheel). Selecting a card sends the chosen role back on the SQUAD_COMMAND channel,
            // scoped to that recruit, which its script turns into a swap to the role.
            this.rolePicker = new (0, $1a2af550e0229b29$export$fcd75734e151a80)({
                onSelect: (role)=>{
                    const targetEntityId = this.rolePicker.getTargetEntityId();
                    this.logic.playerController.client.sendCommandWheelSelection(`recruit:${role}`, "recruit", targetEntityId);
                    this.logic.playerController.client.logActivity(`role picker: ${role} for ${targetEntityId}`);
                    this.hideRolePicker();
                }
            });
            this.rolePicker.visible = false;
            this.rolePicker.zIndex = 60000 // Same tier as the command wheel
            ;
            this.stage.addChild(this.rolePicker);
            // name prompt -- opened by the server over a camp member (at the end of a hire, or on the
            // "Rename" order) so the player can name it. The field starts on the name the member
            // already has, so backing out is a complete answer and simply keeps it.
            this.namePrompt = new (0, $c40c25df820e3512$export$8a1c693d5de025d7)({
                onSubmit: (name)=>{
                    const targetEntityId = this.namePrompt.getTargetEntityId();
                    if (targetEntityId) {
                        this.logic.playerController.client.sendEntityName(targetEntityId, name);
                        this.logic.playerController.client.logActivity(`named ${targetEntityId} "${name}"`);
                    }
                    this.hideNamePrompt();
                },
                onCancel: ()=>this.hideNamePrompt()
            });
            this.namePrompt.visible = false;
            this.namePrompt.zIndex = 60001 // Just over the role picker, which it opens on top of
            ;
            this.stage.addChild(this.namePrompt);
            // The location chooser — the reticle a "Hold Position" order puts under the pointer while
            // the player picks the spot. It only draws; the pick itself (and the click that ends it)
            // belongs to PlayerController, which owns world presses.
            this.locationPicker = new (0, $76a97c569b52295c$export$2e19b9798c747684)();
            this.stage.addChild(this.locationPicker);
            // ember end-of-run scorecard — put up by the server when the player dies in an ember camp
            // (Protocol.type_showRunSummary). Its two buttons go back to the ember controller, which
            // either stands the player up in the camp they fell in or builds them a fresh one; the
            // panel dismisses itself as it sends. Whether a restart is on the table at all is the
            // camp's call (it rides in on the summary's lives) — the controller enforces it either way.
            this.runSummary = new (0, $8bf61ed7fd954e0e$export$786eace44478b97d)({
                onTryAgain: ()=>{
                    this.logic.playerController.client.sendEmberRunCommand("tryAgain");
                    this.logic.playerController.client.logActivity("run summary: try again");
                    this.hideRunSummary();
                },
                onRestart: ()=>{
                    this.logic.playerController.client.sendEmberRunCommand("restart");
                    this.logic.playerController.client.logActivity("run summary: restart");
                    this.hideRunSummary();
                },
                // The third way on. The press opens the picker from the list the client ALREADY holds
                // -- the offer is an interval feed, not a reply -- and the `seek` that goes with it is
                // only a nudge for a fresher list. Nothing waits on the server.
                onInvade: ()=>{
                    this.logic.playerController.client.sendEmberInvasionCommand("seek");
                    this.logic.playerController.client.logActivity("run summary: resurrect as undead");
                    this.showInvasionPicker();
                }
            });
            this.runSummary.visible = false;
            // Above the command wheel / role picker: this one is a full-screen modal over a finished run.
            this.runSummary.zIndex = 70000;
            this.stage.addChild(this.runSummary);
            // The camp chooser, opened from the scorecard and drawn over it. Picking a card is the last
            // press of the whole handshake: the server moves the player, and every exit from there is a
            // fresh camp of their own (see docs/ember-the-fallen-design.md, "Leave").
            this.invasionPicker = new (0, $daf4f1c650b6c0f9$export$9306c99f3e124fbc)({
                onJoin: (entityId)=>{
                    this.logic.playerController.client.sendEmberInvasionCommand("join", entityId);
                    this.logic.playerController.client.logActivity(`invasion: join ${entityId}`);
                    this.hideInvasionPicker();
                },
                onCancel: ()=>{
                    this.cancelInvasionPicker();
                }
            });
            this.invasionPicker.visible = false;
            // Over the scorecard, which stays up behind it.
            this.invasionPicker.zIndex = 70001;
            this.stage.addChild(this.invasionPicker);
            // The two doorways of a possession. Above BOTH of those, because it is the one thing on the
            // screen the player has not seen yet -- and because the far end of a visit arrives together
            // with a whole new room, whose load must not draw over it.
            this.possessionSplash = new (0, $fd1228436d3e60cd$export$3cab3b6954a18297)({
                onDismiss: ()=>{
                    this.logic.playerController?.client?.logActivity("possession splash dismissed");
                }
            });
            this.possessionSplash.visible = false;
            this.possessionSplash.zIndex = 70002;
            this.stage.addChild(this.possessionSplash);
            // first-run ember tutorial invitation — put up by ember-tutorial.js on a player's very
            // first camp (Protocol.type_showTutorialPrompt). Either button answers on the generic
            // player-event channel, and so does letting the countdown run out (which means "go ahead").
            // Low on the screen and clear of the roster strip (bottom-right) and the wave dial
            // (top-left), so the Lord stays visible while he talks.
            this.tutorialPrompt = new (0, $6d8fdbf74f9b9254$export$7d04c213ce109943)({
                onChoose: (choice, reason)=>{
                    this.logic.playerController.client.sendEmberTutorialCommand(choice, reason);
                    this.logic.playerController.client.logActivity(`tutorial prompt: ${choice} (${reason})`);
                    this.hideTutorialPrompt();
                    if (choice === "skip") // Anything still waiting on a "Next" belongs to a scene that is over, and a
                    // held bubble SWALLOWS what comes after it: lines spoken while one is up queue
                    // behind it and inherit its hold (AvatarHud.spoke), which is exactly what the
                    // Lord's sign-off must not do to the player who just declined the lesson.
                    this.logic.clientRenderer.entity().releaseHeldSpeech();
                }
            });
            this.tutorialPrompt.x = screenWidth / 2 - (0, $6d8fdbf74f9b9254$export$7d04c213ce109943).stageWidth() / 2;
            this.anchorTutorialPrompt();
            this.tutorialPrompt.visible = false;
            // Same tier as the command wheel / role picker: above the HUD, below the run scorecard.
            this.tutorialPrompt.zIndex = 60000;
            this.stage.addChild(this.tutorialPrompt);
            // hero message - positioned in center of screen
            this.heroMessage = new (0, $4a3ce4bbe28116a7$export$75ee3f18f40024cd)();
            this.heroMessage.zIndex = 60000 // Higher than countdown timer
            ;
            this.stage.addChild(this.heroMessage);
            this.intro = new (0, $93842021a2e36862$export$b3c44ac484b3c461)(this);
            // A press anywhere that isn't the wheel puts the wheel away (see onOutsidePress). Bound once,
            // for the life of the HUD, and inert while no wheel is up.
            if (typeof document !== "undefined") document.addEventListener("pointerdown", this.onOutsidePress, true);
        };
        // Dismiss-on-outside-press. A wheel is modal in intent but not in fact -- it floats over the
        // world and the world goes on taking clicks underneath it -- so a press that lands anywhere else
        // has to read as "put it away". Presses arrive on the DOCUMENT (see Mouse.pressIsOnGui), which is
        // why this asks pixi what was under the pointer rather than hanging a handler off the stage: a
        // press on empty canvas hits nothing and would never reach one.
        //
        // Capture phase, so it runs before the widget the press landed on: a press on another roster card
        // closes this wheel and then that card opens its own.
        //
        // Three things own their own presses and are left alone: the wheel itself (a slice is a choice,
        // not a dismissal), the role picker (a sibling of the wheel, not a rival), and the roster strip,
        // whose cards re-target the wheel or toggle it off themselves.
        this.onOutsidePress = (event)=>{
            if (!this.commandWheel?.isOpen()) return;
            const target = (0, $f246f635ee3b2e66$export$7caecd373b84cec3).pressTarget(event);
            // Can't tell (no interaction plugin) is not the same as "landed on nothing": leave it up.
            if (target === undefined) return;
            for(let node = target; node; node = node.parent){
                if (node === this.commandWheel || node === this.rolePicker || node === this.namePrompt || node === this.emberRoster) return;
            }
            this.hideCommandWheel();
        };
        this.updateDayPct = (pct)=>{
            if (pct !== undefined && !this.suppressDayCycle) {
                this.dayCycle.visible = true;
                this.dayCycle.setup(pct * 360);
            }
        };
        this.getIntro = ()=>this.intro;
        this.log = (msg)=>this.logic.playerController.client.logActivity(msg);
        // The wire's one way into the tutorial layer: an overworld popup, an ember clue to arm, or -- on a
        // null type -- the server taking the ember clues back down (see Tutorial.setup).
        this.showTutorial = (tutorialType, timeoutMs)=>{
            this.tutorial.setup(tutorialType, timeoutMs);
        };
        // What the inventory/crafting panel calls to say where one of the clued controls landed, and to
        // take the pointer off one it is no longer drawing.
        this.tutorialClues = ()=>this.tutorial;
        this.invokeFeedback = ()=>{
            this.logic.playerController.client.logActivity("Opened feedback widget");
            const feedback = new (0, $95442441126989b8$export$175e500a48a60fd2)(this, {
                onSubmit: (feedback)=>{
                    if ((feedback.feedback || "").trim().length > 0) {
                        this.addScreenMessage({
                            target: "important",
                            text: "Thanks. Your feedback will improve the game!"
                        });
                        this.logic.playerController.client.submitFeedback(feedback);
                    }
                }
            });
            feedback.setup();
        };
        this.helpMessaging = ()=>{
            // Hand the world's mouse back before anything is torn down. Both buttons below take it away
            // while the pointer is on them, and this rebuild is how they go: the message button calls
            // haltMessageIndicator from its own click handler, its throbber does the same 30s later with
            // nobody touching anything, and the level-up button goes when the points are spent. pixi
            // delivers no mouseout to a removed display object -- and none at all to one whose PARENT is
            // removed, which is how the message button goes -- so the latch would stay set and every
            // world click (walk, swing, fire) would be dead until the next room load.
            this.helpMessagingButtons.forEach((button)=>button.releaseMouseControl());
            this.helpMessagingButtons = [];
            // cleanout old message
            const existingMessage = this.container.getChildByName("_help_messaging_");
            if (existingMessage) existingMessage.parent.removeChild(existingMessage);
            // The "Level up stats!" prompt is positioned independently (beside the hp/mana bars), not
            // in the help-messaging stack — clean up its previous instance here too.
            const existingLevelUp = this.container.getChildByName("_level_up_stats_");
            if (existingLevelUp) existingLevelUp.parent.removeChild(existingLevelUp);
            const helpMessaging = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            helpMessaging.name = "_help_messaging_";
            this.container.addChild(helpMessaging);
            const messages = [];
            const items = [];
            if (this.logic.playerController.isGuest() && !this.suppressGuestPrompt) messages.push("/register to save progress");
            let previous = null;
            messages.forEach((message)=>{
                const messageText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().align("right").render(message);
                helpMessaging.addChild(messageText);
                if (previous) messageText.y = previous.y - messageText.height;
                items.push(messageText);
                previous = messageText;
            });
            if (this.incomingMessageMeta.unread) {
                const haltIndicator = (showDialog = true)=>{
                    if (showDialog) this.doDynamicDialog(this.incomingMessageMeta.text);
                    this.haltMessageIndicator();
                };
                const button = new (0, $484648df9dc7cb6f$export$353f5b6fc5456de1)({
                    text: "Incoming message",
                    font: "NameFont",
                    color: 0xff0000,
                    textColor: 0xffffff,
                    buttonWidth: 100,
                    onClick: ()=>{
                        this.log("open incoming message");
                        haltIndicator(true);
                    },
                    mouseControlCallback: (on)=>{
                        this.logic.playerController.enabledMouseAction(!on);
                    }
                });
                button.y = previous.y - button.height;
                new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(button, {
                    expires: 30000,
                    blinkInterval: 20,
                    releaseCallback: ()=>haltIndicator(false)
                }).update();
                previous = button;
                helpMessaging.addChild(button);
                items.push(button);
                this.helpMessagingButtons.push(button);
            }
            if (this.upgradeIndicator && !this.suppressLevelUp) {
                const levelUpPadding = 2;
                const button = new (0, $484648df9dc7cb6f$export$353f5b6fc5456de1)({
                    text: "Level up stats!",
                    font: "NameFont",
                    color: 0xfffff,
                    buttonWidth: 120,
                    padding: levelUpPadding,
                    onClick: ()=>{
                        this.log("open stats upgrade ui");
                        this.logic.playerController.client.invokeStatUpgradeUI();
                    },
                    mouseControlCallback: (on)=>{
                        this.logic.playerController.enabledMouseAction(!on);
                    }
                });
                new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(button, {
                    expires: 5000,
                    blinkInterval: 20
                }).update();
                // Position beside (to the right of) the player's hp/mana bars. The name/level label
                // shares the top hearts row, so anchor the button's top just BELOW the hearts (at the
                // mana-bar row) and let it grow downward — otherwise it lands on the name. hp.height is
                // fresh (hp updates earlier this frame); fall back to 22 if bounds aren't ready.
                button.name = "_level_up_stats_";
                button.x = this.hp.x + this.hp.width + 12;
                button.y = this.hp.y + (this.hp.height || 22) + 7;
                this.container.addChild(button);
                this.helpMessagingButtons.push(button);
            }
            helpMessaging.x = this.minimapSurface.x - helpMessaging.width - 10;
            helpMessaging.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 30;
            items.forEach((item)=>{
                item.x = helpMessaging.width - item.width;
            });
        };
        this.update = (player)=>{
            if (this.currentPlayerHp !== player.hp || this.currentPlayerHpMax !== player.maxHp) {
                this.hp.max = 10;
                this.hp.update(player.hp / player.maxHp * this.hp.max);
                this.hunger.x = this.hp.x;
                this.currentPlayerHp = player.hp;
                this.currentPlayerHpMax = player.maxHp;
            }
            if (this.currentPlayerHunger !== player.hunger || this.currentPlayerHungerMax !== player.maxHunger) {
                this.hunger.visible = !this.suppressFood;
                this.hunger.update(player.hunger / player.maxHunger * this.hunger.max);
                this.mana.x = this.hunger.x;
                this.currentPlayerHunger = player.hunger;
                this.currentPlayerHungerMax = player.maxHunger;
            }
            if (this.currentPlayerMana !== player.mana) {
                this.mana.visible = !this.suppressMana;
                this.mana.y = this.hp.height + 8;
                this.mana.update(player.mana / player.maxMana * this.mana.max);
            }
            if (this.currentPlayerName !== player.name || this.currentScore !== player.score) {
                let name = player.safeName();
                this.nameText.text = `${name}, Lvl ${Math.floor(player.level)}`;
                // this.nameText.text = `${name} - Lvl ${player.level} | `
                // this.nameText.text += `${Math.floor(player.score)}/${Math.floor(player.score + player.scoreTilNextLevel)} next level`
                this.currentPlayerName = player.name;
                this.currentScore = player.score;
            }
            if (this.currentPlayerUpgradePoints !== player.upgradePoints) {
                this.currentPlayerUpgradePoints = player.upgradePoints;
                this.upgradeIndicator = this.currentPlayerUpgradePoints > 0;
                this.helpMessaging();
            }
            if (player && player.entityId === this.logic.playerEntity.entityId && !this.joystickSetup) {
                this.setupJoystick(this.container);
                this.joystickSetup = true;
            }
            if (player && player.entityId === this.logic.playerEntity.entityId) {
                if (this.characterBuilder.isOpen()) this.characterBuilder.update();
            }
        };
        this.updateTimer = (deltaTime)=>{
            if (this.countdownTimer && this.countdownTimer.visible) this.countdownTimer.update(deltaTime);
            // Cheap when nothing is moving: the badge only repaints on a change or a live animation.
            this.waveIndicator?.animate(deltaTime);
            // Track the follow-cam subject each frame: hide the PiP while it's on-screen, show it when off.
            this.updateFollowCamVisibility();
            // Advance the lord's campfire-strength fire-particle backdrop.
            this.emberRoster.animate(deltaTime);
            // The character-creation screen animates its own stage (hearth glow, intro typewriter).
            this.characterBuilder.animate(deltaTime);
            // Glide the minimap's dots between snapshots (the feed only speaks once a second), and slide
            // the player's own dot, whose location is predicted locally and so needs no interpolation.
            if (this.emberMinimap?.visible) {
                this.emberMinimap.animate(deltaTime);
                this.emberMinimap.trackPlayer(this.logic.playerEntity?.location);
            }
            // Drain the players chip's arrival flash, and the transient "Sent" on an invite button. Both
            // are no-ops when nothing is running.
            this.emberPlayersChip?.animate(deltaTime);
            if (this.emberPlayersPanel?.visible) this.emberPlayersPanel.animate(deltaTime);
            // Drain the invitation's clock. At zero the prompt takes itself down -- doing nothing is an
            // answer -- which frees the slot the list sits below.
            if (this.emberInvitePrompt?.isOpen()) {
                this.emberInvitePrompt.animate(deltaTime);
                if (!this.emberInvitePrompt.isOpen()) {
                    this.emberInviteFrom = undefined;
                    this.positionEmberPlayers();
                }
            }
            // ...and the one behind the run scorecard's portrait, while that's up.
            this.runSummary?.animate(deltaTime);
            // Drain the invasion picker's countdowns (the feed is two seconds coarse, so the seconds
            // are counted down locally between ticks) and its fade. No-op while shut.
            this.invasionPicker?.animate(deltaTime);
            this.possessionSplash?.animate(deltaTime);
            // Drain the tutorial invitation's countdown; at zero it answers "accept" for the player.
            if (this.tutorialPrompt?.isOpen()) this.tutorialPrompt.update(deltaTime);
        };
        // A line a roster member has just spoken, but ONLY while the player can't see them say it —
        // once they're in the viewport their bubble is already drawn over their head in the world, and
        // repeating it on the HUD would be noise. Null otherwise. Drives the roster's speech lane.
        // A hit the player had no way of hearing: the roster saw a camp member lose health while they
        // were too far off for the world to have played anything for them.
        //
        // The predicate is deliberately the SAME one doStruck uses to decide whether to play the hit
        // sound at all (isTooDistantFromPlayer -- which also keeps the follow-cam's focus neighbourhood
        // audible), rather than a plain viewport test. Anything looser would double up the sound on a
        // member the player can already hear being hit, which is the whole reason this is conditional.
        this.playOffscreenHit = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (entity && !this.logic.isTooDistantFromPlayer(entity)) return;
            this.logic.audio.hit(entity);
        };
        this.getOffscreenSpeech = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (!entity || !entity.location || this.logic.isDestroyed(entityId)) return null;
            if (this.logic.isWithinPlayerViewport(entity.location)) return null;
            return this.logic.getRecentSpeech(entityId);
        };
        this.updateSquadState = (squadState)=>{
            this.squad.update(squadState);
        };
        // The ember camp's wave badge, driven by the wave manager script's "waveStatus" screen messages
        // (see ember-wave-manager.js). The structured counts ride in the message's context; the text
        // carries the wave number as well, so a message that somehow arrives without a context can still
        // say whether a wave is on. Wave 0 — or an unreadable payload — takes the badge down.
        this.updateWaveIndicator = (message)=>{
            const context = message.context || {};
            const wave = Number(context.wave !== undefined ? context.wave : parseInt(message.text || "0"));
            if (isNaN(wave) || wave <= 0) {
                this.waveIndicator.update(null);
                return;
            }
            // A wave has landed, so the pre-wave dial has had its turn.
            if (this.countdownTimer.visible) {
                this.countdownTimer.stop();
                this.countdownTimer.visible = false;
            }
            this.waveIndicator.update({
                wave: wave,
                remaining: Number(context.remaining) || 0,
                total: Number(context.total) || 0,
                alive: Number(context.alive) || 0
            });
        };
        this.updateEmberRoster = (roster)=>{
            this.emberRoster.update(roster);
            this.positionEmberRoster();
        };
        // Bottom-right of the HUD (the ember room suppresses the minimap that normally sits there).
        // Recomputed each update because the strip's width depends on how many cards are showing --
        // including by the widget itself, when a card finishes breaking apart between roster ticks.
        this.positionEmberRoster = ()=>{
            const screenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            const rightEdge = screenWidth - this.container.x - 6;
            // Roughly aligned with the inventory-slots (equipped) widget's bottom (constant BOTTOM - 20),
            // then nudged down 15 so the whole roster/follow-cam system sits a little lower.
            const bottomEdge = $7dd73ecdd94bfe01$export$84e1549b474f1b93;
            this.emberRoster.x = rightEdge - this.emberRoster.rightExtent();
            this.emberRoster.y = bottomEdge - this.emberRoster.bottomExtent();
            // Keep whatever holds the slot above the roster aligned with it as cards come and go.
            this.positionFollowCam();
            this.positionRosterCommandWheel();
            this.positionEmberMinimap();
        };
        // The single HUD slot directly above the ember roster strip: right-aligned with the strip, its
        // bottom edge a little clear of it. The follow-cam PiP, the minimap and a roster-opened command
        // wheel all live here (only one at a time), so they can't drift apart.
        this.rosterSlotAnchor = (width, height)=>{
            const screenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            const rightEdge = screenWidth - this.container.x - 6;
            const rosterTop = this.emberRoster.y - this.emberRoster.topExtent();
            return {
                x: rightEdge - width,
                y: rosterTop - 16 - height
            };
        };
        // Place the follow-cam PiP in the slot above the roster strip, then redraw the connector line to
        // the watched card.
        this.positionFollowCam = ()=>{
            // positionEmberRoster runs during init before followCam exists — guard against that.
            if (!this.followCam?.isOpen()) return;
            const anchor = this.rosterSlotAnchor(this.followCam.getWidth(), this.followCam.getHeight());
            this.followCam.x = anchor.x;
            this.followCam.y = anchor.y;
            this.updateFollowCamVisibility();
        };
        // The minimap holds the slot above the roster strip while NO roster member is being tracked. Once
        // one is, the follow-cam owns that space and the map steps aside — keyed on whether a member is
        // selected (followCam.isOpen()) rather than on whether the PiP happens to be drawn, so the two
        // don't trade places every time the watched character wanders on and off screen.
        //
        // Collapsed, the map gives the slot up entirely and leaves its "show map" chip in the top-right
        // corner instead. The chip is deliberately NOT tied to the follow-cam: while the player watches a
        // member in the PiP the map is unavailable anyway, so offering to show it would be a dead control.
        //
        // A map the player has DRAGGED somewhere keeps that spot instead of the slot, and keeps it through
        // everything that calls this (a roster card coming and going, a collapse, a new room).
        this.positionEmberMinimap = ()=>{
            if (!this.emberMinimap) return;
            const hasMap = this.emberMinimap.hasData();
            const slotFree = !this.followCam?.isOpen() && !this.commandWheelRosterId;
            const show = hasMap && slotFree && !this.emberMinimapCollapsed;
            this.emberMinimap.visible = show;
            if (show) {
                const width = this.emberMinimap.getWidth();
                const height = this.emberMinimap.getHeight();
                // Re-clamped rather than taken as read: the map is a plan of the room and carries its
                // aspect ratio, so the panel a placement was chosen for may not be the size of this one.
                const at = this.emberMinimapPlacement ? this.clampToScreen(this.emberMinimapPlacement, width, height) : this.rosterSlotAnchor(width, height);
                this.emberMinimap.x = at.x;
                this.emberMinimap.y = at.y;
            }
            const showChip = hasMap && slotFree && this.emberMinimapCollapsed;
            this.emberMinimapChip.visible = showChip;
            // Top-right corner of the screen. Ember rooms suppress the control bar that normally lives
            // there, so the corner is the camp HUD's. Laid out unconditionally: the map toggle holds its
            // slot even while it is hidden, so the chips beside it do not move when the map is unfolded.
            this.layoutChipRow();
        };
        // The x every right-justified HUD panel measures back from, in this container's coordinates.
        this.hudRightEdge = ()=>(0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7 - this.container.x - 6;
        // The top-right chip row, laid out right to left: map, items, players.
        //
        // Every chip keeps its slot whether or not it is currently on screen. They appear and vanish
        // independently -- the map toggle only exists while the map is folded away, the players count
        // only while somebody else is logged in -- and a row that closed up around a missing one would
        // shuffle the others sideways under the player's thumb each time that happened. Reserving the
        // slots costs a few empty pixels and buys a row that never moves.
        //
        // Called again whenever a chip's width can change; the players chip carries a count, so it
        // does.
        this.layoutChipRow = ()=>{
            let right = this.hudRightEdge();
            const place = (chip)=>{
                if (!chip) return;
                chip.x = right - chip.getWidth();
                chip.y = $7dd73ecdd94bfe01$var$CHIP_ROW_Y;
                right -= chip.getWidth() + $7dd73ecdd94bfe01$var$CHIP_GAP;
            };
            place(this.emberMinimapChip);
            place(this.emberInventoryChip);
            place(this.emberPlayersChip);
        };
        // Who else is logged in, as the server last told us. An empty list takes the chip down and, with
        // it, the panel -- there is nothing left to invite.
        this.updateEmberPlayers = (players)=>{
            if (!this.emberPlayersChip) // A room update can land before the HUD has finished standing itself up.
            return;
            this.emberPlayers = players || [];
            // The chip owns its own visibility (and the orange flash it makes on arrival) -- it is the
            // count that decides, and only the chip knows whether this count is the first one.
            this.emberPlayersChip.update(this.emberPlayers.length);
            if (this.emberPlayers.length < 1) this.emberPlayersPanel.visible = false;
            if (this.emberPlayersPanel.visible) this.emberPlayersPanel.update(this.emberPlayers);
            this.positionEmberPlayers();
        };
        // Open or close the player list. Filled on open rather than kept up to date while hidden: the feed
        // only speaks when the list CHANGES, so a panel that waited for the next broadcast could sit empty
        // indefinitely.
        this.setEmberPlayersOpen = (open)=>{
            const show = open && this.emberPlayers.length > 0;
            if (show) this.emberPlayersPanel.update(this.emberPlayers);
            this.emberPlayersPanel.visible = show;
            this.positionEmberPlayers();
        };
        // Ask the server to pull another player into this camp. It is a request in both directions: the
        // server decides whether it is allowed and where they land, and the INVITED player decides
        // whether to come at all (see the EMBER_PLAYERS campaign and updateEmberInvite).
        this.inviteEmberPlayer = (entityId)=>{
            this.logic.playerController?.client?.inviteEmberPlayer(entityId);
        };
        // An invitation into somebody's camp, or null to take the prompt down. Deliberately NOT gated on
        // being in an ember room: the player being invited is, by definition, somewhere else.
        this.updateEmberInvite = (invite)=>{
            if (!this.emberInvitePrompt) return;
            this.emberInviteFrom = invite?.fromEntityId;
            this.emberInvitePrompt.update(invite);
            this.positionEmberPlayers();
        };
        // The player's answer. Only an accepted one moves them, and the server does the moving -- this
        // says nothing about where they will land.
        this.answerEmberInvite = (accepted)=>{
            const from = this.emberInviteFrom;
            this.emberInviteFrom = undefined;
            if (from) this.logic.playerController?.client?.answerEmberInvite(from, accepted);
            this.positionEmberPlayers();
        };
        // The players chip takes the leftmost place in the top-right row (see layoutChipRow), and the
        // list of players hangs under it against the same right edge.
        this.positionEmberPlayers = ()=>{
            if (!this.emberPlayersChip) return;
            const rightEdge = this.hudRightEdge();
            // The chip's own place in the top-right row. Re-run here because this chip's width moves
            // with the count it carries, which nothing else is watching.
            this.layoutChipRow();
            // One column down the right edge: the chip's row, then the invitation prompt, then the list.
            // The chip's row is reserved whether or not the chip is IN it, for the same reason the map
            // toggle's slot is -- so nothing below it slides about as players come and go.
            let below = $7dd73ecdd94bfe01$var$CHIP_ROW_Y + this.emberPlayersChip.getHeight() + $7dd73ecdd94bfe01$var$CHIP_GAP;
            if (this.emberInvitePrompt?.isOpen()) {
                this.emberInvitePrompt.x = rightEdge - this.emberInvitePrompt.getWidth();
                this.emberInvitePrompt.y = below;
                below += this.emberInvitePrompt.getHeight() + $7dd73ecdd94bfe01$var$CHIP_GAP;
            }
            this.emberPlayersPanel.x = rightEdge - this.emberPlayersPanel.getWidth();
            this.emberPlayersPanel.y = below;
        };
        // Fold the map away (or bring it back), remembering the choice.
        this.setEmberMinimapCollapsed = (collapsed)=>{
            if (this.emberMinimapCollapsed === collapsed) return;
            this.emberMinimapCollapsed = collapsed;
            this.saveEmberMinimapCollapsed(collapsed);
            this.positionEmberMinimap();
        };
        // The collapsed preference is a per-viewer convenience, so it lives in localStorage — which can
        // throw or come back empty (private windows, blocked site data), hence the guards.
        this.loadEmberMinimapCollapsed = ()=>{
            try {
                if (typeof localStorage !== "undefined") return localStorage.getItem(this.EMBER_MINIMAP_COLLAPSED_KEY) === "true";
            } catch (error) {
                console.warn("Failed to load minimap collapsed state from localStorage:", error);
            }
            return false;
        };
        this.saveEmberMinimapCollapsed = (collapsed)=>{
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.EMBER_MINIMAP_COLLAPSED_KEY, String(collapsed));
            } catch (error) {
                console.warn("Failed to save minimap collapsed state to localStorage:", error);
            }
        };
        this.holdOffMinimapDragAttack = ()=>this.logic.playerController?.suppressAttack($7dd73ecdd94bfe01$export$530fe131767a4087.MINIMAP_DRAG_ATTACK_HOLDOFF_MS);
        this.dragEmberMinimapTo = (x, y)=>{
            this.holdOffMinimapDragAttack();
            const at = this.clampToScreen({
                x: x,
                y: y
            }, this.emberMinimap.getWidth(), this.emberMinimap.getHeight());
            this.emberMinimapPlacement = at;
            this.emberMinimap.x = at.x;
            this.emberMinimap.y = at.y;
        };
        // Saved on release rather than per frame: a drag is hundreds of positions and only the last one is
        // the answer.
        this.dropEmberMinimap = ()=>{
            this.holdOffMinimapDragAttack();
            this.saveEmberMinimapPlacement();
        };
        // The screen, in the HUD container's own coordinates: the container is nudged in from the left
        // edge, so screen left sits at -container.x; the right edge is the same expression the rest of the
        // HUD right-justifies against, and BOTTOM is the HUD's own floor.
        this.hudBounds = ()=>{
            const screenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            return {
                left: -this.container.x,
                top: 0,
                right: screenWidth - this.container.x,
                bottom: $7dd73ecdd94bfe01$export$84e1549b474f1b93
            };
        };
        this.clampToScreen = (at, width, height)=>(0, $27706b8361e494c8$export$39715f4eaf395d01)(at, {
                width: width,
                height: height
            }, this.hudBounds());
        // The dragged position is a per-viewer convenience, so it lives in localStorage — which can throw
        // or come back empty (private windows, blocked site data), and whose contents are whatever was
        // last written there, hence the guards and the shape check.
        this.loadEmberMinimapPlacement = ()=>{
            try {
                if (typeof localStorage !== "undefined") {
                    const stored = localStorage.getItem(this.EMBER_MINIMAP_PLACEMENT_KEY);
                    const at = stored ? JSON.parse(stored) : null;
                    if (isFinite(at?.x) && isFinite(at?.y)) return {
                        x: at.x,
                        y: at.y
                    };
                }
            } catch (error) {
                console.warn("Failed to load minimap placement from localStorage:", error);
            }
            return null;
        };
        this.saveEmberMinimapPlacement = ()=>{
            if (!this.emberMinimapPlacement) return;
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.EMBER_MINIMAP_PLACEMENT_KEY, JSON.stringify(this.emberMinimapPlacement));
            } catch (error) {
                console.warn("Failed to save minimap placement to localStorage:", error);
            }
        };
        // The ember room's per-room minimap snapshot (camp members + wave attackers). null takes the map
        // down.
        this.updateEmberMinimap = (minimap)=>{
            this.emberMinimap.update(minimap);
            this.refreshEmberMinimapTrees(minimap);
            this.positionEmberMinimap();
        };
        this.refreshEmberMinimapTrees = (minimap)=>{
            if (!minimap) {
                this.emberTreeScanKey = null;
                return;
            }
            const provider = this.logic.tilemapMetaProvider;
            if (!provider) return;
            const key = `${this.currentRoomId}:${provider.getCollisionVersion()}:${minimap.width}x${minimap.height}`;
            if (key === this.emberTreeScanKey) return;
            const now = Date.now();
            // A brand-new room (nothing scanned yet) is drawn immediately; only RE-scans wait their turn.
            if (this.emberTreeScanKey !== null && now - this.emberTreeScanAt < $7dd73ecdd94bfe01$export$530fe131767a4087.EMBER_TREE_RESCAN_MS) return;
            this.emberTreeScanKey = key;
            this.emberTreeScanAt = now;
            const tilesWide = this.emberMinimap.tilesWide();
            const tilesHigh = this.emberMinimap.tilesHigh();
            this.emberMinimap.updateTrees((0, $27706b8361e494c8$export$d8cdfd7fe35d629c)(provider, tilesWide, tilesHigh), tilesWide, tilesHigh);
        };
        // The PiP only earns its screen space while the watched character is OFF-screen. Hide the PiP
        // (and its connector) once the subject enters the player's viewport; show them again when it
        // leaves. Called every frame (updateTimer) so it tracks the subject's movement.
        this.updateFollowCamVisibility = ()=>{
            if (!this.followCam?.isOpen()) {
                this.followCamShown = false;
                return;
            }
            const focusId = this.followCam.focusEntityId;
            const entity = focusId ? this.logic.getEntity(focusId) : null;
            // Tracked entity gone (removed) or destroyed -> close the PiP.
            if (!entity || this.logic.isDestroyed(entity.entityId)) {
                this.closeFollowCam();
                return;
            }
            const onScreen = this.logic.isWithinPlayerViewport(entity.location);
            const shouldShow = !onScreen;
            // Only start a fade on an actual transition (this runs every frame).
            if (shouldShow !== this.followCamShown) {
                this.followCamShown = shouldShow;
                this.followCamFader?.stop(true);
                if (shouldShow) {
                    this.followCam.visible = true;
                    // minAlpha (the fade target) passed explicitly: Fader computes its default before
                    // applying `direction`, so an "in" fade would otherwise target 0 and never appear.
                    this.followCamFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.followCam, {
                        direction: "in",
                        minAlpha: 1.0
                    });
                } else this.followCamFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.followCam, {
                    direction: "out",
                    minAlpha: 0,
                    releaseCallback: ()=>{
                        this.followCam.visible = false;
                    }
                });
                this.followCamFader.update();
            }
            // Keep the connector drawn and its alpha in lockstep with the PiP's fade.
            this.updateFollowCamConnector();
            this.followCamConnector.alpha = this.followCam.alpha;
        };
        // Draw a line from the follow-cam's bottom to the top-centre of the selected roster card, so
        // it's obvious which character the PiP is showing. Hidden whenever the PiP itself is hidden.
        this.updateFollowCamConnector = ()=>{
            const g = this.followCamConnector;
            g.clear();
            const anchor = this.emberRoster.selectedCardAnchor();
            if (!this.followCam.isOpen() || !this.followCam.visible || !anchor) {
                g.visible = false;
                return;
            }
            g.visible = true;
            const fromX = this.followCam.x + this.followCam.getWidth() / 2;
            const fromY = this.followCam.y + this.followCam.getHeight();
            g.lineStyle(2, anchor.color, 0.9);
            g.moveTo(fromX, fromY);
            g.lineTo(anchor.x, anchor.y);
            g.beginFill(anchor.color, 0.95);
            g.drawCircle(fromX, fromY, 2.5);
            g.drawCircle(anchor.x, anchor.y, 3);
            g.endFill();
        };
        // Open the follow-cam PiP on an entity: show the modal, keep the entity's neighborhood live on
        // the client, and ask the server to sync it in full detail every tick.
        this.openFollowCam = (entityId, name)=>{
            // The PiP and a roster-opened wheel share one slot above the strip; the PiP is taking it.
            if (this.commandWheelRosterId) this.hideCommandWheel();
            this.followCam.open(entityId, name);
            // Start transparent and let updateFollowCamVisibility fade it in (null forces a fade).
            this.followCam.alpha = 0;
            this.followCamShown = null;
            this.positionFollowCam();
            // The PiP takes the slot the minimap was holding.
            this.positionEmberMinimap();
            this.logic.setFocusEntityId(entityId);
            this.logic.playerController.client.setFocusEntity(entityId);
        };
        // Close the follow-cam if it's open (Escape / deactivation); no-op otherwise.
        this.dismissFollowCam = ()=>{
            if (this.followCam?.isOpen()) this.closeFollowCam();
        };
        this.closeFollowCam = ()=>{
            this.followCamFader?.stop(true);
            this.followCamShown = false;
            this.followCam.close();
            this.emberRoster.clearSelection();
            this.updateFollowCamConnector();
            // Nobody is being tracked any more, so the minimap takes the slot back.
            this.positionEmberMinimap();
            this.logic.setFocusEntityId(null);
            this.logic.playerController.client.setFocusEntity(null);
        };
        this.updateBannerText = (text)=>{
            this.bannerText.text = text;
        };
        this.updateLocation = (label)=>{
        //
        };
        this.startChat = ()=>{
            this.chatOpen = true;
            this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
            this.chatWalk = {
                ...this.chatWalk,
                index: -1,
                draft: ""
            };
            this.renderChatInput();
            clearTimeout(this.chatHistoryTextTimer);
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            this.chatHistory.alpha = 1.0;
            this.chatHistory.show();
        };
        // Redraws the input from the current state. Everything that edits the line ends here.
        this.renderChatInput = ()=>{
            this.typing.update(this.chatInput);
        };
        // Takes the input off the screen, and the log with it, dropping the half-written line. Every
        // client-side slash command below starts this way before doing its own thing.
        this.dismissChatInput = ()=>{
            this.chatOpen = false;
            this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
            this.typing.removeText();
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            this.chatHistory.alpha = 1.0;
            this.chatHistory.hide();
        };
        this.appendChatHistory = (message, speaker)=>{
            if (!message) return;
            this.chatHistory.show();
            // Callers hand over the speaker and the line apart; a single formatted "Name: line" is
            // still understood, because that is what this took for its whole life before.
            const named = speaker === undefined ? (0, $030df650e8220c82$export$1efc33041612526)(message) : {
                speaker: speaker,
                text: message
            };
            this.chatLog.push({
                ...named,
                self: !!named.speaker && named.speaker === this.logic?.playerEntity?.name
            });
            this.chatLog = this.chatLog.slice(-(0, $bde0eb94ead9038f$export$ae76bdcbbb40538));
            this.chatHistory.updateEntries(this.chatLog);
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            clearTimeout(this.chatHistoryTextTimer);
            this.chatHistory.alpha = 1.0;
            // A line that lands while the player is typing does NOT start the clock: fading the log
            // out from under someone who is in the middle of answering it is how a reply gets sent to
            // a conversation the sender can no longer see. stopChat starts it again on the way out.
            if (this.chatOpen) return;
            this.scheduleChatHistoryFade(5000);
        };
        this.scheduleChatHistoryFade = (delay)=>{
            clearTimeout(this.chatHistoryTextTimer);
            this.chatHistoryTextTimer = setTimeout(()=>{
                this.chatHistoryFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.chatHistory, {
                    direction: "out",
                    minAlpha: 0.0,
                    fadeInterval: 16,
                    fadeAlphaDecrement: 0.02,
                    releaseCallback: ()=>{
                        this.chatHistory.hide();
                        this.chatHistory.alpha = 1.0 // Reset alpha for next time
                        ;
                    }
                });
                this.chatHistoryFader.update();
            }, delay);
        };
        // One keystroke of chat input. `mods` is the modifier state at the moment the key went down,
        // which is what tells a plain Backspace from a word-wise one -- and what keeps the letter of
        // an OS shortcut (cmd+R) out of the line.
        this.captureKeystroke = (c, mods)=>{
            const scope = mods?.meta ? "line" : mods?.alt || mods?.ctrl ? "word" : "char";
            if (c === "Escape") {
                // player.ts closes the input right after this; dropping the line here is what makes
                // Escape a cancel rather than a send.
                this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
                this.chatWalk = {
                    ...this.chatWalk,
                    index: -1,
                    draft: ""
                };
                return;
            }
            if (c === "Backspace") this.chatInput = (0, $2bc3e70fbff7f064$export$f2323afd0aa0bdea)(this.chatInput, scope);
            else if (c === "Delete") this.chatInput = (0, $2bc3e70fbff7f064$export$948b9f836237b4b4)(this.chatInput, scope);
            else if (c === "ArrowLeft" || c === "ArrowRight") {
                const back = c === "ArrowLeft";
                // cmd+arrow is "to the end of the line" on a Mac, not "a word at a time".
                this.chatInput = mods?.meta ? (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, back ? "home" : "end") : (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, back ? "left" : "right", scope === "word");
            } else if (c === "Home" || c === "End") this.chatInput = (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, c === "Home" ? "home" : "end");
            else if (c === "ArrowUp" || c === "ArrowDown") {
                const walked = c === "ArrowUp" ? (0, $2bc3e70fbff7f064$export$7f903ac43047fe20)(this.chatWalk, this.chatInput) : (0, $2bc3e70fbff7f064$export$2957600c134d4b7e)(this.chatWalk, this.chatInput);
                this.chatWalk = walked.walk;
                this.chatInput = walked.input;
            } else if (mods?.ctrl) // The line-editing keys a terminal (and a browser text field) answers to.
            switch(c.toLowerCase()){
                case "u":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f2323afd0aa0bdea)(this.chatInput, "line");
                    break;
                case "k":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$948b9f836237b4b4)(this.chatInput, "line");
                    break;
                case "w":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f2323afd0aa0bdea)(this.chatInput, "word");
                    break;
                case "a":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, "home");
                    break;
                case "e":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, "end");
                    break;
                default:
                    return;
            }
            else if (mods?.meta) // cmd+R, cmd+L, cmd+1 ... the player is talking to the browser, not to the camp.
            return;
            else if (c.length === 1) this.chatInput = (0, $2bc3e70fbff7f064$export$78ba03e296d6b5ac)(this.chatInput, c);
            else return;
            this.renderChatInput();
        };
        // Pasted text (see Keyboard.addPasteListener): dropped in at the caret, flattened to one line
        // and trimmed to whatever is left under the length cap.
        this.insertChatText = (text)=>{
            this.chatInput = (0, $2bc3e70fbff7f064$export$78ba03e296d6b5ac)(this.chatInput, text);
            this.renderChatInput();
        };
        this.stopChat = ()=>{
            this.chatOpen = false;
            // Stop any active fader and timeout
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            clearTimeout(this.chatHistoryTextTimer);
            const messageToSend = this.chatInput.value.trim();
            if (messageToSend === "/register") {
                this.dismissChatInput();
                if (this.logic.playerController.isGuest()) this.collectPlayerAccount(this.logic.playerEntity.name, (username, password, email)=>{
                    if (username && password) this.logic.playerController.client.register(username, password, email);
                });
                else this.addScreenMessage({
                    target: "important",
                    text: "You're already registered"
                });
                return "";
            }
            if (messageToSend === "/message") {
                this.dismissChatInput();
                if (this.incomingMessageMeta.text) {
                    this.doDynamicDialog(this.incomingMessageMeta.text);
                    this.haltMessageIndicator();
                }
                return "";
            }
            if (messageToSend === "/help") {
                this.logic.playerController.client.logActivity("invoke help");
                this.dismissChatInput();
                this.help(()=>{});
                return "";
            }
            if (messageToSend === "/upgrade") {
                this.logic.playerController.client.invokeStatUpgradeUI();
                this.dismissChatInput();
                return "";
            }
            if (messageToSend === "/about") {
                this.logic.playerController.client.logActivity("invoke about");
                this.dismissChatInput();
                this.about();
                return "";
            }
            if (messageToSend.startsWith("/timer")) {
                this.logic.playerController.client.logActivity("invoke timer");
                this.dismissChatInput();
                // Parse timer duration from command (e.g., "/timer 30" for 30 seconds)
                const parts = messageToSend.split(" ");
                const duration = parts.length > 1 ? parseInt(parts[1]) : 10 // default 10 seconds
                ;
                if (isNaN(duration) || duration <= 0) this.addScreenMessage({
                    target: "important",
                    text: "Invalid timer duration. Use: /timer [seconds]"
                });
                else {
                    this.countdownTimer.visible = true;
                    this.countdownTimer.start(duration);
                }
                return "";
            }
            if (messageToSend === "/timerstop") {
                this.logic.playerController.client.logActivity("stop timer");
                this.dismissChatInput();
                if (this.countdownTimer.visible) {
                    this.countdownTimer.stop();
                    this.countdownTimer.visible = false;
                    this.addScreenMessage({
                        target: "important",
                        text: "Timer stopped"
                    });
                } else this.addScreenMessage({
                    target: "important",
                    text: "No timer is currently running"
                });
                return "";
            }
            if (messageToSend === "/timerreset") {
                this.logic.playerController.client.logActivity("reset timer");
                this.dismissChatInput();
                this.countdownTimer.reset();
                this.countdownTimer.visible = false;
                this.addScreenMessage({
                    target: "important",
                    text: "Timer reset"
                });
                return "";
            }
            if (messageToSend === "/wheel") {
                this.logic.playerController.client.logActivity("invoke command wheel");
                this.dismissChatInput();
                this.commandWheel.fadeIn();
                this.addScreenMessage({
                    text: "Command wheel opened. Click commands to select, use button to switch NPCs."
                });
                return "";
            }
            if (messageToSend === "/wheelclose") {
                this.logic.playerController.client.logActivity("close command wheel");
                this.dismissChatInput();
                this.commandWheel.fadeOut();
                this.addScreenMessage({
                    text: "Command wheel closed"
                });
                return "";
            }
            if (messageToSend.startsWith("/hero")) {
                this.logic.playerController.client.logActivity("test hero message");
                this.dismissChatInput();
                // Parse text and duration from command
                // Format: /hero [duration] [text] or /hero [text]
                const parts = messageToSend.split(" ");
                let text = "HERO MESSAGE!" // default text
                ;
                let duration = 2000 // default 2 seconds
                ;
                if (parts.length > 1) {
                    // Check if second part is a number (duration)
                    const secondPart = parseInt(parts[1]);
                    if (!isNaN(secondPart)) {
                        // Format: /hero [duration] [text]
                        duration = secondPart;
                        text = parts.slice(2).join(" ") || "HERO MESSAGE!";
                    } else // Format: /hero [text]
                    text = parts.slice(1).join(" ");
                }
                this.addScreenMessage({
                    target: "hero",
                    text: text,
                    duration: duration
                });
                return "";
            }
            // The log outlives the input it was opened with, so the player can read the answer to
            // what they just sent.
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            this.scheduleChatHistoryFade(10000);
            // Remember what was sent for the up-arrow walk (consecutive duplicates collapse), and
            // reset the walk so the next Up starts from this line rather than mid-history.
            this.chatWalk = (0, $2bc3e70fbff7f064$export$8981372ce0f88573)(this.chatWalk, messageToSend);
            if (messageToSend) this.saveChatHistory();
            this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
            this.typing.removeText();
            return messageToSend;
        };
        this.saveChatHistory = ()=>{
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.CHAT_HISTORY_KEY, JSON.stringify(this.chatWalk.entries));
            } catch (error) {
                console.warn("Failed to save chat history to localStorage:", error);
            }
        };
        this.loadChatHistory = ()=>{
            try {
                if (typeof localStorage !== "undefined") {
                    const saved = localStorage.getItem(this.CHAT_HISTORY_KEY);
                    if (saved) {
                        const parsed = JSON.parse(saved);
                        if (Array.isArray(parsed)) this.chatWalk = {
                            entries: parsed.filter((entry)=>typeof entry === "string"),
                            index: -1,
                            draft: ""
                        };
                    }
                }
            } catch (error) {
                console.warn("Failed to load chat history from localStorage:", error);
                this.chatWalk = (0, $2bc3e70fbff7f064$export$2cd8bbcbf799240);
            }
        };
        this.clearChatHistory = ()=>{
            this.chatWalk = (0, $2bc3e70fbff7f064$export$2cd8bbcbf799240);
            try {
                if (typeof localStorage !== "undefined") localStorage.removeItem(this.CHAT_HISTORY_KEY);
            } catch (error) {
                console.warn("Failed to clear chat history from localStorage:", error);
            }
        };
        this.addScreenMessage = (message)=>{
            const { target: target, text: text, roomId: roomId, action: action, actionToken: actionToken, context: context, suppressOnCloseEmitEvent: suppressOnCloseEmitEvent } = message;
            if (suppressOnCloseEmitEvent && this.currentModal) this.currentModal.modal.suppressOnCloseCallback = suppressOnCloseEmitEvent;
            if (!!roomId && roomId !== this.currentRoomId) return;
            if (action === "close" && target !== "featureWidget") {
                this.closeModal();
                return;
            }
            if (action === "openDynamicDialog") this.dynamicDialogToken = actionToken;
            if (!target) {
                this.screenMessages.push(message);
                // Always consume messages immediately to allow interruption
                this.consumeMessages();
            } else {
                if (target === "leaderboard") this.updateBannerText(text);
                if (target === "important") this.importantMessage.update(message);
                if (target === "waveStatus") this.updateWaveIndicator(message);
                if (target === "countdown") {
                    const duration = parseInt(text);
                    if (!isNaN(duration) && duration > 0) {
                        // The dial and the wave badge share one slot: starting a countdown means the
                        // previous wave is over, so the badge comes down.
                        this.waveIndicator.update(null);
                        this.countdownTimer.visible = true;
                        this.countdownTimer.start(duration);
                    } else if (!isNaN(duration)) {
                        // A non-positive value is an explicit "hide the countdown" signal (e.g. the ember
                        // waves were stopped on a delegated respawn). Clear the ring immediately instead of
                        // letting its client-side timer run down.
                        this.countdownTimer.stop();
                        this.countdownTimer.visible = false;
                    } else this.addScreenMessage({
                        target: "important",
                        text: "Invalid countdown duration. Must be a positive number."
                    });
                }
                if (target === "hero") this.heroMessage.show(message);
                if (target === "dialog") {
                    if (message.forceTarget) this.doDynamicDialog(message);
                    else this.availableMessage(message);
                }
                if (target === "stickyBanner") {
                    this.stickyBanner.setup(message.text, message.context?.icon, message.context?.hoverText);
                    this.stickyBanner.x = this.controlBar.x - this.stickyBanner.width - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    this.dayCycle.x = this.stickyBanner.x - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.25;
                }
                if (target === "featureWidget") this.featureWidget.setup(message);
            }
        };
        this.updateLeaderboard = (leaderboards)=>{
            this.leaderboard.update(leaderboards);
        };
        this.updateInventory = (owner, inventory)=>{
            if (this.inventoryUpdateTs.get(owner.entityId) === inventory.lastUpdateTs) return false;
            this.inventoryUpdateTs.set(owner.entityId, inventory.lastUpdateTs);
            const player = this.getPlayer();
            if (player.entityId === owner.entityId) {
                if (this.dynamicDialogToken) this.logic.emitConversationResponse(this.dynamicDialogToken);
                this.slotCallbacks = this.equipped.update(inventory, (itemId)=>{
                    this.logic.playerController.selectSlot(itemId);
                });
                this.abilities.update(inventory, (shortcut)=>{
                    this.logic.playerController.activeAbility(shortcut);
                });
                this.abilities.x = this.equipped.x + this.equipped.width;
                const ammoBearingWeapon = (0, $f684496fff50a7a1$export$429c16c642745fa3)(inventory, "weapon").sort((b, a)=>a.active ? 2 : 1 - (b.active ? 2 : 1)).find((o)=>{
                    return !!(0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[o.itemType];
                });
                const shards = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(inventory, "shard-metal");
                const sources = [
                    {
                        icon: `shard-metal-gray.png`,
                        quantity: shards?.quantity || 0
                    }
                ];
                if (ammoBearingWeapon) {
                    const ammoType = (0, $f684496fff50a7a1$export$9efb6bfe58196888)((0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[ammoBearingWeapon.itemTypeMeta.type]);
                    if (ammoType) {
                        this.resourceBar.visible = true;
                        const ammoItem = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(inventory, ammoType.type);
                        sources.push({
                            icon: `${ammoType.type}-${ammoType.color}.png`,
                            quantity: ammoItem?.quantity || 0
                        });
                        this.logic.playerController.updateLongRangedEquippedState(ammoBearingWeapon.active);
                    } else this.logic.playerController.updateLongRangedEquippedState(false);
                } else this.logic.playerController.updateLongRangedEquippedState(false);
                this.resourceBar.setup(sources);
                this.resourceBar.x = this.nameText.x + this.nameText.width + 20;
                // Honor per-room suppression (e.g. ember rooms) — the ammo branch above may have
                // forced it visible; keep it hidden while suppressed.
                this.resourceBar.visible = !this.suppressShards;
            }
            // this.inventoryGui.update()
            return true;
        };
        this.activateInventorySlot = (slot)=>{
            const callback = this.slotCallbacks[slot];
            if (callback) callback();
        };
        this.mouseOverControl = (disable)=>{
            this.logic.enablePlayerMouseAction(!disable);
        };
        this.consumeMessages = ()=>{
            // Clear any existing timeout to allow interruption
            if (this.currentMessageTimeout) {
                clearTimeout(this.currentMessageTimeout);
                this.currentMessageTimeout = null;
            }
            // If there's a current message, interrupt it and process the next one
            if (this.currentScreenMessage) {
                if (this.currentScreenMessage.displayCallback) this.currentScreenMessage.displayCallback();
                this.currentScreenMessage = null;
            }
            this.currentScreenMessage = this.screenMessages.shift();
            if (!this.currentScreenMessage) return;
            const { text: text, roomId: roomId, displayCallback: displayCallback } = this.currentScreenMessage;
            let delayMs = 0;
            if (!roomId || roomId === this.currentRoomId) {
                this.bannerText.text = text;
                const wordCount = text.split(" ").length;
                delayMs = Math.max(1000, wordCount * 60 / 200 * 1000);
            }
            this.currentMessageTimeout = setTimeout(()=>{
                if (displayCallback) displayCallback();
                this.bannerText.text = "";
                this.currentScreenMessage = null;
                this.currentMessageTimeout = null;
                this.consumeMessages();
            }, delayMs);
        };
        this.fadeOut = (immediate)=>{
            this.blackout.alpha = 0.0;
            this.blackout.visible = true;
            this.bannerText.text = "";
            // Clear any pending message timeout
            if (this.currentMessageTimeout) {
                clearTimeout(this.currentMessageTimeout);
                this.currentMessageTimeout = null;
            }
            this.currentScreenMessage = null;
            if (immediate) this.blackout.alpha = 1.0;
            else {
                const loop = setInterval(()=>{
                    const newAlpha = Math.min(1.0, this.blackout.alpha + 0.1);
                    this.blackout.alpha = newAlpha;
                    if (newAlpha === 1.0) clearInterval(loop);
                }, 100);
            }
        };
        this.fadeIn = ()=>{
            this.blackout.alpha = 1.0;
            this.blackout.visible = true;
            const loop = setInterval(()=>{
                const newAlpha = Math.max(0.0, this.blackout.alpha - 0.1);
                this.blackout.alpha = newAlpha;
                if (newAlpha === 0.0) {
                    clearInterval(loop);
                    this.blackout.alpha = 0.0;
                    this.blackout.visible = false;
                }
            }, 100);
        };
        this.roomUpdated = (roomId, roomName, suppressMinimap, suppressDayCycle, suppressControlBar, suppressLevelUp, suppressMana, suppressFood, suppressShards, suppressPlayerName, suppressTutorial, suppressGuestPrompt)=>{
            // On an ACTUAL room change, clear any stale wave countdown from the previous room. The
            // countdown ring is per-room wave UI driven purely by a client-side timer, so nothing else
            // hides it when the room goes away (e.g. after dying and respawning into a fresh ember camp).
            // Guarded on a real change so it never cancels a countdown that's legitimately running in the
            // room we're already in (roomUpdated can fire repeatedly for the same room).
            if (roomId !== this.currentRoomId && this.countdownTimer) {
                this.countdownTimer.reset();
                this.countdownTimer.visible = false;
                // Same for the wave badge: it's per-room wave UI, and the room it belonged to is gone.
                this.waveIndicator?.update(null);
            }
            // The ember clues belong to the camp that armed them. A real room change ends that camp, so
            // they come down with it -- guarded on the change, because roomUpdated fires repeatedly for
            // the room we are already in and an armed clue must survive those.
            if (roomId !== this.currentRoomId) this.tutorial.clearEmberClues();
            this.currentRoomId = roomId;
            this.currenRoomName = roomName;
            this.screenMessages = this.screenMessages.filter((n)=>!n.roomId || n.roomId === roomId);
            this.controlBar.visible = !suppressControlBar;
            // The pack has to stay reachable. Suppressing the control bar takes the inventory button
            // with it, and in a camp there is no keyboard to fall back on, so the chip in the top-right
            // row stands in for exactly as long as the bar is gone.
            this.emberInventoryChip.visible = !!suppressControlBar;
            this.layoutChipRow();
            // Latch per-room mana / food (hunger) meter suppression so it survives later update() calls,
            // which otherwise force the meters visible on any mana/hunger change. Hide immediately on
            // entry (and the meters are restored on exit when the flags come back false).
            this.suppressMana = !!suppressMana;
            this.suppressFood = !!suppressFood;
            if (this.suppressMana) this.mana.visible = false;
            if (this.suppressFood) this.hunger.visible = false;
            // Latch per-room shard/resource counter + player-name suppression. updateInventory() only
            // fires when the inventory changes, so apply the resourceBar state here on entry too; the
            // name label is applied directly here (update() never toggles its visibility).
            this.suppressShards = !!suppressShards;
            this.suppressPlayerName = !!suppressPlayerName;
            this.resourceBar.visible = !this.suppressShards;
            this.nameText.visible = !this.suppressPlayerName;
            // Latch per-room day/night suppression so it survives later updateDayPct() calls, which
            // otherwise force the widget visible on every day-pct tick. Hide immediately on entry too.
            this.suppressDayCycle = !!suppressDayCycle;
            if (this.suppressDayCycle) this.dayCycle.visible = false;
            // Latch per-room "Level up stats!" suppression and rebuild the help-messaging stack so a
            // button from the previous room is removed on entry (and restored on exit).
            this.suppressLevelUp = !!suppressLevelUp;
            // Latch per-room tutorial suppression so showTutorial() is a no-op while in the room (and
            // popups return once the flag comes back false on exit). Ember rooms set this.
            this.tutorial.suppressed = !!suppressTutorial;
            // Same for a guest's "/register to save progress" line, which helpMessaging() rebuilds from
            // scratch just below -- so setting it here is what takes the line off on entry and puts it
            // back on exit.
            this.suppressGuestPrompt = !!suppressGuestPrompt;
            this.helpMessaging();
            this.minimapSurface.roomUpdated(this.userSuppressMinimap || suppressMinimap);
            this.featureWidget.remove();
            // Roster is per-room and ember-only; clear it on any room change so it never lingers
            // after leaving (the server simply stops sending it in non-ember rooms). Same for the
            // minimap, which is a plan of the room we're leaving.
            // clear(), not update([]): the cards are not dying, the player is leaving the room, and a
            // card cannot break apart over a room that is already gone.
            this.emberRoster.clearRoster();
            this.positionEmberRoster();
            this.updateEmberMinimap(null);
            // The player list is ember-only too, and it is about the server rather than the room -- but a
            // room change is the one moment we know the feed may stop, so it goes down with the rest and
            // comes back on the next broadcast.
            this.updateEmberPlayers([]);
            // Close any open follow-cam on room change (clears the server focus subscription too).
            if (this.followCam?.isOpen()) this.closeFollowCam();
        };
        this.hideRoomName = (hidden)=>{
            this.roomNameHidden = hidden;
        };
        this.animateAbility = (abilityType, duration)=>{
            const pulsar = this.abilities.slotPulsar.get(abilityType);
            if (!pulsar) return;
            pulsar.pulse(duration || 750);
        };
        this.animateLocalEntityCollection = (entity, target, position)=>{
            // for now -- all local entity animations relate to ability slot
            const abilityType = target.split(":")[1];
            const location = this.abilities.slotCoordinates.get(abilityType);
            if (!location) return;
            const destX = this.abilities.x + location.x + 3;
            const destY = this.abilities.y + location.y - 10;
            const entityRenderingManager = this.logic.clientRenderer.entity();
            const clientRenderable = entityRenderingManager.renderEntity(entity);
            this.stage.addChild(clientRenderable);
            clientRenderable.x = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w * 0.58;
            clientRenderable.y = 285;
            const increment = 6;
            const animationInterval = setInterval(()=>{
                const currentDistance = (0, $cb689cfa16c444ba$export$79376507b09a66f)(clientRenderable.x, clientRenderable.y, destX, destY);
                if (currentDistance < increment) {
                    clearInterval(animationInterval);
                    // clientRenderable.remove()
                    const fadeInterval = setInterval(()=>{
                        if (clientRenderable.alpha <= 0.0) {
                            clearInterval(fadeInterval);
                            clientRenderable.remove();
                            return;
                        }
                        clientRenderable.alpha -= 0.01;
                    }, 1);
                    return;
                }
                if (clientRenderable.alpha > 0.6) clientRenderable.alpha -= 0.01;
                clientRenderable.x += clientRenderable.x > destX ? -increment : increment;
                clientRenderable.y += clientRenderable.y > destY ? -increment : increment;
            }, 1);
        };
        this.setupJoystick = (container)=>{
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                {
                    const joystick = new (0, $f569351cceda89c3$exports.Joystick)({
                        outer: (0, $7Bs2Z.Sprite).from("outer"),
                        inner: (0, $7Bs2Z.Sprite).from("inner"),
                        outerScale: {
                            x: 0.5,
                            y: 0.5
                        },
                        innerScale: {
                            x: 0.8,
                            y: 0.8
                        },
                        // Held intent, not a direct write. Player's 60Hz velocity loop rebuilds
                        // speed2 from held input every tick, so anything written onto entity.speed2
                        // here is erased before the next frame -- and since onChange only fires on
                        // pointermove, a thumb held at full deflection never writes again. That pair
                        // is what made the stick stutter and refuse to move continuously.
                        onChange: (data)=>{
                            const entity = this.logic.playerEntity;
                            const { power: power } = data;
                            if (power < $7dd73ecdd94bfe01$var$JoystickDeadZone) {
                                this.logic.playerController.setJoystickIntent(null);
                                return;
                            }
                            const vector = $7dd73ecdd94bfe01$var$JoystickVectors[data.direction];
                            if (!vector) return;
                            // Stick pushed right out to the rim means sprint. See sprintScaledIntent
                            // for why scaling the vector is the whole mechanic, and why it must not
                            // scale the shared JoystickVectors entry in place.
                            const intent = (0, $10da07838e6d507c$export$37f678e26ae1e8b8)(vector, power);
                            this.logic.playerController.setJoystickIntent(intent);
                            // Facing follows the move stick unless the aim stick has taken it over.
                            // Sprinting scales the vector but not its direction, so the same intent
                            // serves for both.
                            if (this.leftJoystickAngleAllowed) entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)({
                                x: entity.location.x + intent.x,
                                y: entity.location.y + intent.y
                            }, {
                                x: entity.location.x,
                                y: entity.location.y
                            });
                        },
                        onStart: ()=>{
                            this.logic.playerController.enabledMouseAction(false);
                        },
                        onEnd: ()=>{
                            this.logic.playerController.setJoystickIntent(null);
                            this.logic.playerController.enabledMouseAction(true);
                        }
                    });
                    joystick.x = 80;
                    joystick.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 120;
                    container.addChild(joystick);
                    // pixi-virtual-joystick only ends a drag on pointerup/pointerupoutside. A
                    // cancelled touch (system gesture, incoming call) emits neither, which would
                    // leave the stick's intent latched and the player walking with no finger down.
                    // Routing cancel back through the library's own end handler resets the knob too.
                    joystick.on("pointercancel", ()=>joystick.emit("pointerup", undefined));
                }
                {
                    const sprite = (0, $7Bs2Z.Sprite).from("inner");
                    sprite.tint = 0xff0000;
                    let foo;
                    const joystick = new (0, $f569351cceda89c3$exports.Joystick)({
                        outer: (0, $7Bs2Z.Sprite).from("outer"),
                        inner: sprite,
                        outerScale: {
                            x: 0.5,
                            y: 0.5
                        },
                        innerScale: {
                            x: 0.8,
                            y: 0.8
                        },
                        onChange: (data)=>{
                            const entity = this.logic.playerEntity;
                            const { power: power, angle: angle } = data;
                            if (power < 1.0) return;
                            this.logic.playerController.client.fireBullet();
                            const aim = $7dd73ecdd94bfe01$var$JoystickVectors[data.direction];
                            if (!aim) return;
                            entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)({
                                x: entity.location.x + aim.x,
                                y: entity.location.y + aim.y
                            }, {
                                x: entity.location.x,
                                y: entity.location.y
                            });
                        },
                        onStart: ()=>{
                            this.logic.playerController.enabledMouseAction(false);
                            this.leftJoystickAngleAllowed = false;
                            foo = this.getPlayer().movement.angle;
                        },
                        onEnd: ()=>{
                            this.logic.playerController.enabledMouseAction(true);
                            this.leftJoystickAngleAllowed = true;
                            this.getPlayer().movement.angle = foo;
                        }
                    });
                    joystick.x = 650;
                    joystick.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 120;
                    container.addChild(joystick);
                    joystick.interactive = true;
                    joystick.on("tap", ()=>{
                        this.logic.playerController.client.fireBullet();
                    });
                    // As on the move stick: a cancelled touch emits no pointerup, and this one's
                    // onEnd is what re-enables mouse actions and hands facing back to the move
                    // stick, so skipping it would wedge both.
                    joystick.on("pointercancel", ()=>joystick.emit("pointerup", undefined));
                }
            }
        };
        this.socialMedia = (parent)=>{
            const container = new (0, $gwPoJ.Graphics)();
            container.y = 480;
            if (parent) parent.addChild(container);
            const socialMedia = new (0, $gwPoJ.Graphics)();
            const reddit = new (0, $7Bs2Z.Sprite)((0, $kXE1p.Loader).shared.resources["reddit"].texture);
            reddit.scale.set(0.05);
            reddit.interactive = true;
            reddit.on("click", ()=>{
                window.open("https://www.reddit.com/r/projectsamsara/");
                this.logic.playerController.client.logActivity(`>> ${this.logic.playerEntity?.name || "guest"} visited discord <<`);
            });
            reddit.on("tap", ()=>{
                window.open("https://www.reddit.com/r/projectsamsara/");
                this.logic.playerController.client.logActivity(`>> ${this.logic.playerEntity?.name || "guest"} visited subreddit <<`);
            });
            const discord = new (0, $7Bs2Z.Sprite)((0, $kXE1p.Loader).shared.resources["discord"].texture);
            discord.scale.set(0.13);
            discord.x = reddit.x + reddit.width + 12;
            discord.y = -1;
            discord.interactive = true;
            discord.on("click", ()=>window.open("https://discord.gg/Mbt6UfqW6e"));
            discord.on("tap", ()=>window.open("https://discord.gg/Mbt6UfqW6e"));
            socialMedia.addChild(reddit);
            socialMedia.addChild(discord);
            container.addChild(socialMedia);
            return container;
        };
        this.collectPlayerAccount = (name, doneCallback)=>{
            const release = ()=>{
                this.logic.playerController.enabledKeyboardAction(true);
                this.logic.playerController.enabledMouseAction(true);
            };
            const askForName = ()=>{
                const dialog = new (0, $gwPoJ.Graphics)();
                this.stage.addChild(dialog);
                const padding = 20;
                const container = new (0, $gwPoJ.Graphics)();
                container.x = padding;
                container.y = padding;
                dialog.addChild(container);
                const bannerText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("BannerFont").render();
                bannerText.y = 10;
                bannerText.text = "Register new player:";
                container.addChild(bannerText);
                const placeHolder = name;
                const nameField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                    input: {
                        fontSize: "20pt",
                        padding: "10px",
                        width: "530px",
                        color: "#26272E"
                    },
                    box: {
                        default: {
                            fill: 0xe8e9f3,
                            rounded: 16,
                            stroke: {
                                color: 0xcbcee0,
                                width: 4
                            }
                        },
                        focused: {
                            fill: 0xe1e3ee,
                            rounded: 16,
                            stroke: {
                                color: 0xabafc6,
                                width: 4
                            }
                        },
                        disabled: {
                            fill: 0xdbdbdb,
                            rounded: 16
                        }
                    }
                });
                nameField.text = placeHolder;
                nameField.y = 50;
                nameField.placeholder = placeHolder;
                nameField.placeholderColor = 0x000000;
                container.addChild(nameField);
                nameField.focus();
                let currentName = placeHolder;
                let currentPassword = "";
                let currentEmail = "";
                const submit = ()=>{
                    if (!currentName) {
                        this.addScreenMessage({
                            target: "important",
                            text: "Player name is required"
                        });
                        return false;
                    }
                    if (!currentPassword) {
                        this.addScreenMessage({
                            target: "important",
                            text: "Password is required"
                        });
                        return false;
                    }
                    release();
                    doneCallback(currentName, currentPassword, currentEmail);
                    return true;
                };
                nameField.on("input", (text)=>{
                    currentName = text;
                });
                nameField.on("keyup", (keycode)=>{
                    if (keycode === 27) {
                        release();
                        container.removeChildren();
                        dialog.parent.removeChild(dialog);
                        return;
                    }
                    if (keycode === 13) passwordField.focus();
                });
                const passwordField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                    input: {
                        fontSize: "20pt",
                        padding: "10px",
                        width: "530px",
                        color: "#26272E"
                    },
                    box: {
                        default: {
                            fill: 0xe8e9f3,
                            rounded: 16,
                            stroke: {
                                color: 0xcbcee0,
                                width: 4
                            }
                        },
                        focused: {
                            fill: 0xe1e3ee,
                            rounded: 16,
                            stroke: {
                                color: 0xabafc6,
                                width: 4
                            }
                        },
                        disabled: {
                            fill: 0xdbdbdb,
                            rounded: 16
                        }
                    }
                });
                passwordField._dom_input.type = "password";
                passwordField.y = 115;
                passwordField.placeholder = "Password";
                passwordField.placeholderColor = 0x000000;
                passwordField.on("input", (text)=>{
                    currentPassword = text;
                });
                passwordField.on("keyup", (keycode)=>{
                    if (keycode === 27) {
                        release();
                        container.removeChildren();
                        dialog.parent.removeChild(dialog);
                        return;
                    }
                    if (keycode === 13) {
                        if (submit()) {
                            container.removeChildren();
                            dialog.parent.removeChild(dialog);
                        }
                    }
                });
                container.addChild(passwordField);
                const emailField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                    input: {
                        fontSize: "20pt",
                        padding: "10px",
                        width: "530px",
                        color: "#26272E"
                    },
                    box: {
                        default: {
                            fill: 0xe8e9f3,
                            rounded: 16,
                            stroke: {
                                color: 0xcbcee0,
                                width: 4
                            }
                        },
                        focused: {
                            fill: 0xe1e3ee,
                            rounded: 16,
                            stroke: {
                                color: 0xabafc6,
                                width: 4
                            }
                        },
                        disabled: {
                            fill: 0xdbdbdb,
                            rounded: 16
                        }
                    }
                });
                emailField.y = 180;
                emailField.placeholder = "Email (optional)";
                emailField.placeholderColor = 0x000000;
                emailField.on("input", (text)=>{
                    currentEmail = text;
                });
                container.addChild(emailField);
                const buttonContainer = new (0, $gwPoJ.Graphics)();
                buttonContainer.y = 245;
                container.addChild(buttonContainer);
                {
                    const button = new (0, $gwPoJ.Graphics)();
                    button.addChild(new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("ImportantFont").render("Cancel"));
                    button.x = 125;
                    button.interactive = true;
                    button.on("click", ()=>{
                        release();
                        doneCallback();
                        container.removeChildren();
                        dialog.parent.removeChild(dialog);
                    });
                    buttonContainer.addChild(button);
                }
                {
                    const button = new (0, $gwPoJ.Graphics)();
                    const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("ImportantFont").render("Register");
                    text.tint = 0x00ff00;
                    button.addChild(text);
                    button.interactive = true;
                    button.on("click", ()=>{
                        if (submit()) {
                            container.removeChildren();
                            dialog.parent.removeChild(dialog);
                            doneCallback();
                        }
                    });
                    buttonContainer.addChild(button);
                }
                dialog.x = 15;
                dialog.y = 50;
                dialog.lineStyle(1, 0xffffff, 0.5);
                dialog.beginFill(0x000000, 0.9);
                dialog.drawRoundedRect(0, 0, dialog.width + padding * 2, dialog.height + padding * 2.5, 8);
                dialog.endFill();
            };
            this.logic.playerController.enabledKeyboardAction(false);
            this.logic.playerController.enabledMouseAction(false);
            askForName();
        };
        this.help = (doneCallback)=>{
            const help = new (0, $7ce197e6bf5d40c1$export$1be7516c0280bee8)(this);
            help.toggle();
        };
        this.screenDimensions = ()=>{
            return {
                w: this.stage.width,
                h: this.stage.height
            };
        };
        this.createModal = (props)=>{
            const modal = new (0, $33e5ff783af47130$export$2b77a92f1a5ad772)(this.logic, this.stage, props);
            modal.update();
            return modal;
        };
        this.about = ()=>{
            const about = new (0, $a67de6ec9600469c$export$c8424c4d8ba2150)(this);
            about.toggle();
        };
        this.doDynamicDialog = (message)=>{
            if (this.currentModal) {
                this.currentModal.updateContent(message);
                return;
            }
            if (!message) return;
            // Always render via ModernInventoryDialog. It extends DynamicDialog and self-selects its
            // layout from the payload: the player's own inventory, crafting, and trade/chest screens get
            // the modern client-native panels, while any other server-driven dialog (quests, traders,
            // NPC management) falls through to the generic DynamicDialog renderer and looks exactly as
            // before. It's a drop-in for currentModal and every downstream call (updateContent/close/
            // pulseGridItem).
            const onClose = ()=>{
                if (message.onCloseEmitEvent) this.logic.playerController.client.emitPlayerEvent(message.onCloseEmitEvent);
                this.logic.playerController.client.onDialogClose();
                this.currentModal = undefined;
                this.dynamicDialogToken = undefined;
            };
            const dialog = new (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012)(this, this.logic, message, onClose);
            dialog.toggle((clicked)=>{
                if (clicked) // this.dynamicDialogToken = null
                this.closeModal();
            });
            this.currentModal = dialog;
        };
        this.availableMessage = (message)=>{
            this.incomingMessageMeta.unread = true;
            this.incomingMessageMeta.expires = Date.now() + 60000;
            this.incomingMessageMeta.text = {
                ...message
            };
            this.helpMessaging();
        };
        this.haltMessageIndicator = ()=>{
            clearInterval(this.incomingMessageMeta.flasherInterval);
            this.incomingMessageMeta.unread = false;
            this.incomingMessageMeta.expires = null;
            this.incomingMessageMeta.text = null;
            this.helpMessaging();
        };
        this.showUpgradeIndicator = ()=>{};
        this.closeModal = ()=>{
            if (this.currentModal) this.currentModal.close();
            this.dynamicDialogToken = null;
            this.currentModal = null;
        };
        this.toggleInventory = ()=>{
            if (!this.dynamicDialogToken) this.logic.invokeInventory(null);
            else this.closeModal();
        };
        // `c` toggles the crafting screen the way `i` toggles the inventory. Asking the server to open
        // crafting while a screen is already up would only re-dress the modal that's there, so a second
        // press has to close it locally instead.
        this.toggleCrafting = ()=>{
            if (!this.dynamicDialogToken) this.logic.invokeCrafting();
            else this.closeModal();
        };
        this.toggleCharacterCustomizer = ()=>{
            this.characterCustomizer.toggle();
        };
        this.buildCharacter = (entityId)=>{
            const player = this.getPlayer();
            if (player?.entityId !== entityId) // for now -- you can only build your own character
            return;
            if (!this.characterBuilder.isOpen()) this.characterBuilder.toggle(()=>{
                this.logic.playerController.client.finalizeCharacter();
                // Close the curtain on the CLICK, not on the teleport that answers it.
                //
                // A character drawn in LIMBO is whisked out of it into a fresh camp, and that
                // teleport brings the usual room-transition blackout with it
                // (ServerGameLogic.teleportEntity -> sendFadeInOut("out")). But it cannot arrive for
                // half a second: the finalize has to cross the socket, the server has to dispatch
                // BUILD_CHARACTER{finalized}, and EmberRoomService has to build a whole camp room.
                // This modal is opaque and comes down in the frame of this very callback, so without
                // this that half second is spent looking at limbo -- a tile-less room the visibility
                // parser gives darkness 1.0, i.e. the new character alone in the void.
                //
                // Only from limbo, because only from limbo is a room change coming. Finalizing in
                // the overworld (EMBER_ENABLED off, where the INTRO campaign opens this screen) goes
                // nowhere, and a curtain nothing lifts would be a worse bug than the one above.
                //
                // "out" is an immediate black (fadeOut(true)), so the modal's disappearance reveals
                // the curtain rather than the void, and the camp's own map build fades back in
                // (ClientGameLogic.updateFromWorldState). The "inOut" form is the watchdog: if no
                // camp ever arrives -- a failed build falls through to rescueFromLimbo, which can
                // itself come up empty -- the screen lifts anyway instead of stranding the player
                // behind a black rectangle.
                if (this.currenRoomName === (0, $cb689cfa16c444ba$export$1bb94dd20d93df2d)) this.logic.fadeInOut("inOut", 10000);
            });
        };
        this.getPlayer = ()=>this.logic.playerEntity;
        this.pulseInventoryItem = (itemId)=>{
            if (!this.currentModal) return;
            this.currentModal.pulseGridItem(itemId);
        };
        this.mapPointHoverListener = (onMouseOver, label)=>{
            // this.container.beginFill(0xFF0000)
            // this.container.drawCircle(705, 454, 20)
            // this.container.endFill()
            const position = this.logic.clientRenderer.mouse().state().position;
            if (onMouseOver) {
                const container = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                    backdrop: true
                });
                container.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(label, {
                    font: "ChatFont"
                }));
                this.mouseHoverElement = container;
                this.container.addChild(this.mouseHoverElement);
                this.mouseHoverElement.x = 5 + this.minimapSurface.x + this.minimapSurface.width / 2 - this.mouseHoverElement.width / 2;
                this.mouseHoverElement.y = this.minimapSurface.y - this.mouseHoverElement.height + 2;
            } else if (this.mouseHoverElement) this.container.removeChild(this.mouseHoverElement);
        };
        this.createCursorSprite = ()=>{
            if (this.mousePointer) return this.mousePointer;
            const mousePointer = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                scale: 0.3,
                name: "crosshairs.png"
            });
            mousePointer.x = 0;
            mousePointer.y = 0;
            mousePointer.visible = false;
            this.mousePointer = mousePointer;
            this.stage.addChild(mousePointer);
            this.logic.clientRenderer?.mouse().addListener((state)=>{
                mousePointer.x = state.position.x;
                mousePointer.y = state.position.y * 0.77;
            });
            return mousePointer;
        };
        // ---- location picker -------------------------------------------------------------------------
        // The reticle under the pointer while the player chooses a spot on the ground (the defender's
        // "Hold Position" order). GuiManager owns only the drawing and the screen->world conversion;
        // arming the pick, ending it, and what the chosen spot MEANS belong to PlayerController, which
        // owns world presses.
        this.showLocationPicker = (caption, blockedCaption)=>{
            this.locationPicker.bindMouse(this.logic.clientRenderer?.mouse());
            this.locationPicker.show(caption, blockedCaption);
        };
        this.hideLocationPicker = ()=>{
            this.locationPicker.hide();
        };
        this.isLocationPickerVisible = ()=>this.locationPicker.isVisible();
        this.setLocationPickerBlocked = (blocked)=>{
            this.locationPicker.setBlocked(blocked);
        };
        // The fine world coordinate under the pointer, read straight off pixi's own transforms: the
        // world-overlay surface carries the same camera transform as the world itself, so `toLocal`
        // plus its scale is an exact inverse of the camera with nothing to keep in sync.
        //
        // Deliberately NOT PlayerController's `pointer`. That one is hand-derived from the camera
        // modifiers and lifted ~10px so a bow aims at a body rather than at the ground under it —
        // exactly the wrong bias for "stand here".
        this.worldPointAtPointer = ()=>{
            const overlay = this.logic.clientRenderer?.map()?.overlay();
            const mouse = this.logic.clientRenderer?.mouse();
            if (!overlay || !mouse) return null;
            const local = overlay.toLocal(mouse.state().position);
            return overlay.worldLocation(local.x, local.y);
        };
        this.pulseDamage = ()=>{
            this.redout.alpha = 0.3;
            this.redout.visible = true;
            new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.redout, {
                fadeInterval: 25,
                releaseCallback: ()=>{
                    this.redout.visible = false;
                }
            }).update();
        };
        this.showWorldMap = (map)=>{
            const worldMap = new (0, $a231d713277e9a39$export$9a82c68eff2bb78f)(this, map, (coordinate)=>{
                if (this.logic.runLevel === "dev") {
                    this.logic.playerController.client.worldMapClicked(coordinate);
                    worldMap.close();
                }
            });
            worldMap.toggle();
        };
        this.isControlKeyPressed = ()=>{
            return this.logic.clientRenderer.keyboard().state().get("Control") || this.logic.clientRenderer.keyboard().state().get("ControlLeft") || this.logic.clientRenderer.keyboard().state().get("ControlRight");
        };
        // True when one of the player's item screens (inventory, crafting, or trading) is the open
        // modal. Under the modern renderer all three are a single ModernInventoryDialog; under the
        // classic renderer crafting/trading are still recognizable from the opening message.
        // Public so the world-click handler can suppress attacks while a screen is up.
        this.isItemScreenOpen = ()=>{
            const modal = this.currentModal;
            if (!modal) return false;
            if (modal instanceof (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012)) return true;
            return (0, $98fc6d407c9f2a1f$export$bc3be2b9790d3f4d)(modal.message) || (0, $98fc6d407c9f2a1f$export$1a9ed648cfadc85e)(modal.message);
        };
        // Called both by the global Control-key path (no args → broadcast wheel) and by the server's
        // OPEN_COMMAND_WHEEL reply (opts → wheel bound to one NPC, locked to its role).
        this.showCommandWheel = (opts)=>{
            // The command wheel is only available in rooms that opt in (ember rooms), signalled by the
            // per-room enableCommandWheel flag that rides to the client in WorldState.visibility.
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            // Don't let the player summon the wheel on top of an inventory/crafting/trading screen.
            // The server-driven per-NPC wheel (opts present) is intentional and stays allowed.
            if (!opts && this.isItemScreenOpen()) return;
            // A wheel going up replaces whatever the pointer was being used for: an armed location pick
            // has no press left to answer it, and its reticle would sit under the wheel unexplained.
            this.logic.playerController?.cancelLocationPick();
            this.clearCommandWheelTether();
            // Whatever this wheel is about, it is no longer the roster card's.
            this.releaseRosterWheel();
            if (opts) {
                this.commandWheel.bindToEntity(opts.targetEntityId, opts.role);
                // A per-entity wheel opens directly over its NPC instead of screen-center, and stays
                // there: updateCommandWheelTether draws the line to the NPC as it walks off.
                this.positionCommandWheelOverEntity(opts.targetEntityId);
            } else {
                this.commandWheel.clearTarget();
                this.commandWheel.clearSelection() // Clear any previous selection
                ;
                // The global (Control-key) wheel returns to its screen-center home in case a prior
                // per-entity wheel moved it.
                this.commandWheel.position.copyFrom(this.commandWheelHome);
            }
            this.commandWheel.fadeIn();
            // Prevent context menu when command wheel is visible
            this.preventContextMenu();
        };
        // Open one camp member's command wheel from their ROSTER CARD.
        //
        // Unlike the per-NPC wheel above, this one is not put over its entity: a member you reach through
        // the roster is usually the one you can't see, so it takes the HUD slot directly above the strip
        // (the same slot the follow-cam PiP and the minimap share) and a connector line carries which
        // card it belongs to. For the same reason it does NOT close when its NPC leaves the viewport.
        this.openRosterCommandWheel = (entityId, role)=>{
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            if (this.isItemScreenOpen()) return;
            this.logic.playerController?.cancelLocationPick();
            this.clearCommandWheelTether();
            this.commandWheelRosterId = entityId;
            this.commandWheel.bindToEntity(entityId, role);
            this.positionRosterCommandWheel();
            this.commandWheel.fadeIn();
            // The wheel has taken the slot the minimap was holding.
            this.positionEmberMinimap();
            this.preventContextMenu();
        };
        // Park a roster-opened wheel in the slot above the strip, clamped so no part of the disc -- glow
        // included -- can leave the screen, however few cards the strip is down to.
        this.positionRosterCommandWheel = ()=>{
            // positionEmberRoster runs during init before the wheel exists -- guard against that.
            if (!this.commandWheelRosterId || !this.commandWheel) return;
            const span = 2 * (this.commandWheel.getRadius() + $7dd73ecdd94bfe01$var$WHEEL_GLOW_REACH);
            const slot = this.rosterSlotAnchor(span, span);
            const at = this.clampToScreen(slot, span, span);
            // rosterSlotAnchor and clampToScreen work in the HUD container's frame; the wheel is a direct
            // child of the stage, and is centre-anchored rather than top-left.
            this.commandWheel.position.set(this.container.x + at.x + span / 2, this.container.y + at.y + span / 2);
            this.updateRosterWheelConnector();
        };
        // The line from a roster-opened wheel down to the card that opened it, in the wheel's accent (the
        // member's role colour). Drawn UNDER the strip -- see where rosterWheelConnector is built -- so an
        // offscreen-speech bubble, and every other piece of HUD, reads over the top of it.
        this.updateRosterWheelConnector = ()=>{
            const g = this.rosterWheelConnector;
            g.clear();
            const anchor = this.commandWheelRosterId ? this.emberRoster.cardAnchor(this.commandWheelRosterId, "panel") : null;
            if (!anchor || !this.commandWheel.isOpen()) {
                g.visible = false;
                return;
            }
            // Both ends in the HUD container's frame (the wheel lives on the stage, one level up). The
            // card end stops a dot's width clear of the panel: the line runs UNDER the strip, so a dot
            // sitting on the panel's edge would be half buried by it.
            const toX = anchor.x;
            const toY = anchor.y - $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS;
            const fromCenterX = this.commandWheel.x - this.container.x;
            const fromCenterY = this.commandWheel.y - this.container.y;
            const dx = toX - fromCenterX;
            const dy = toY - fromCenterY;
            const distance = Math.hypot(dx, dy);
            const rim = this.commandWheel.getRadius() + $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP;
            if (distance < rim + $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH) {
                g.visible = false;
                return;
            }
            g.visible = true;
            g.alpha = this.commandWheel.alpha * $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA;
            g.lineStyle({
                width: $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH,
                color: anchor.color,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(fromCenterX + dx / distance * rim, fromCenterY + dy / distance * rim);
            g.lineTo(toX, toY);
            g.beginFill(anchor.color, 1);
            g.drawCircle(toX, toY, $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS);
            g.endFill();
        };
        this.clearRosterWheelConnector = ()=>{
            this.rosterWheelConnector.clear();
            this.rosterWheelConnector.visible = false;
        };
        // Outline the roster's selected member out in the world (undefined takes it off). Routed through
        // the HUD rather than called from the roster widget directly, which knows only about this class.
        this.highlightEmberMember = (entityId)=>{
            this.logic.clientRenderer.entity().setRosterHighlight(entityId);
        };
        // Put away whatever the roster's active card opened -- the follow-cam PiP or that member's
        // command wheel -- and clear the card's highlight. Called by the roster before it acts on a tap,
        // so only one card is ever live and tapping the active card is a toggle.
        this.closeRosterSelection = ()=>{
            this.dismissFollowCam();
            if (this.commandWheelRosterId) this.hideCommandWheel();
        };
        // Open the wheel over an entity to choose between the interactions it offers. Unlike
        // showCommandWheel this is NOT gated on the ember-room enableCommandWheel flag: chests, campfires
        // and denizens exist everywhere, and their interactions are how a player opens them now that the
        // hover icons are gone. Positioning, dismissal (Escape, Control, selection) and the fade are
        // shared with the command wheel.
        this.showInteractionWheel = (entityId, interactions)=>{
            if (!interactions?.length) return;
            // Don't put a wheel up underneath an inventory/crafting/trading screen.
            if (this.isItemScreenOpen()) return;
            this.logic.playerController?.cancelLocationPick();
            this.releaseRosterWheel();
            this.commandWheel.bindToInteractions(entityId, interactions.map((next)=>({
                    name: next.type,
                    displayName: (0, $0fb3f7f2a67be6e3$export$84e151b22524d21c)(next)
                })));
            this.clearCommandWheelTether();
            if (!this.positionCommandWheelOverEntity(entityId)) this.commandWheel.position.copyFrom(this.commandWheelHome);
            this.commandWheel.fadeIn();
            this.preventContextMenu();
        };
        // The given entity's center in stage-local coordinates (the frame the command wheel / role
        // picker live in, as direct children of the stage). Null when the entity isn't available yet.
        this.entityStageLocal = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (!entity) return null;
            const overlay = this.logic.clientRenderer.map().overlay();
            // computeLocation gives the entity's center in the overlay surface's local frame; convert
            // that into stage-local coordinates.
            const center = overlay.computeLocation(entity.location.x, entity.location.y);
            return this.stage.toLocal(center, overlay);
        };
        // Move the wheel so its center sits over the given entity. Returns false when the entity (or its
        // overlay frame) isn't available yet. Called once, at open: the wheel then stays put (a wheel
        // that chased a walking NPC was impossible to aim at), and the tether line carries the link.
        this.positionCommandWheelOverEntity = (entityId)=>{
            const local = this.entityStageLocal(entityId);
            if (!local) return false;
            this.commandWheel.position.set(local.x, local.y);
            return true;
        };
        // Per-frame upkeep for a per-entity wheel: drop it once its target is gone or has left the
        // viewport (there is nothing left on screen to command), and otherwise redraw the tether from
        // the pinned wheel to the NPC. No-op for the global broadcast wheel (no bound target) and while
        // the wheel is closed. Called every frame by the renderer.
        this.updateCommandWheelTether = ()=>{
            const entityId = this.commandWheel.isOpen() ? this.commandWheel.getTargetEntityId() : undefined;
            if (!entityId) {
                this.clearCommandWheelTether();
                this.clearRosterWheelConnector();
                return;
            }
            const entity = this.logic.getEntity(entityId);
            const gone = !entity || this.logic.isDestroyed(entityId);
            // A ROSTER-opened wheel is pinned to the HUD, not to the world: it is tied to a card rather
            // than to the NPC, and it must survive its member being off screen -- reaching somebody you
            // cannot see is what the roster is for. Only the member actually going closes it.
            if (this.commandWheelRosterId) {
                if (gone) {
                    this.hideCommandWheel();
                    return;
                }
                this.clearCommandWheelTether();
                this.updateRosterWheelConnector();
                return;
            }
            if (gone || !this.logic.isWithinPlayerViewport(entity.location)) {
                this.hideCommandWheel();
                return;
            }
            this.drawCommandWheelTether(entityId);
        };
        // A translucent line from the pinned wheel's rim to the commanded NPC's center, with a dot on
        // the NPC end. Drawn in the wheel's accent and multiplied by the wheel's own alpha so it fades
        // in and out with it. Suppressed while the NPC is still under the disc, where a stub of line
        // would only show as a nub poking out of the hub.
        this.drawCommandWheelTether = (entityId)=>{
            const g = this.commandWheelTether;
            g.clear();
            const local = this.entityStageLocal(entityId);
            if (!local) {
                g.visible = false;
                return;
            }
            const dx = local.x - this.commandWheel.x;
            const dy = local.y - this.commandWheel.y;
            const distance = Math.hypot(dx, dy);
            const rim = this.commandWheel.getRadius() + $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP;
            if (distance < rim + $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH) {
                g.visible = false;
                return;
            }
            const accent = this.commandWheel.getAccent();
            g.visible = true;
            g.alpha = this.commandWheel.alpha * $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA;
            g.lineStyle({
                width: $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH,
                color: accent,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(this.commandWheel.x + dx / distance * rim, this.commandWheel.y + dy / distance * rim);
            g.lineTo(local.x, local.y);
            g.beginFill(accent, 1);
            g.drawCircle(local.x, local.y, $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS);
            g.endFill();
        };
        this.clearCommandWheelTether = ()=>{
            this.commandWheelTether.clear();
            this.commandWheelTether.visible = false;
        };
        // Let go of a roster-opened wheel: drop its connector, un-highlight the card that opened it, and
        // hand the slot above the strip back to the minimap. Called wherever the wheel stops being that
        // card's -- it closing, or another kind of wheel taking it over.
        this.releaseRosterWheel = ()=>{
            if (!this.commandWheelRosterId) return;
            this.commandWheelRosterId = undefined;
            this.clearRosterWheelConnector();
            this.emberRoster.clearSelection();
            this.positionEmberMinimap();
        };
        this.hideCommandWheel = ()=>{
            this.releaseRosterWheel();
            this.commandWheel.fadeOut();
            this.commandWheel.clearTarget();
            this.commandWheel.clearSelection() // Clear any previous selection
            ;
            this.clearCommandWheelTether();
            // Restore normal context menu behavior
            this.restoreContextMenu();
        };
        this.isCommandWheelVisible = ()=>{
            return this.commandWheel.isOpen();
        };
        // Server-driven: open the recruit role picker over a specific recruit so the player can assign it
        // a role. Gated to ember rooms via the same per-room visibility flag as the command wheel.
        this.showRolePicker = (entityId)=>{
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            this.rolePicker.bindToEntity(entityId);
            this.positionRolePickerOverEntity(entityId);
            this.rolePicker.fadeIn();
            this.preventContextMenu();
        };
        // Position the picker so its tail tip sits at the recruit's center (the panel floats above).
        // The picker is glued to its recruit, so the tail is true for exactly as long as there is
        // somebody to glue it to: once the recruit is gone from this client the panel is left standing
        // where it was, and the pointer comes off rather than aim at empty ground.
        this.positionRolePickerOverEntity = (entityId)=>{
            const local = this.logic.isDestroyed(entityId) ? null : this.entityStageLocal(entityId);
            if (!local) {
                this.rolePicker.setTailVisible(false);
                return false;
            }
            this.rolePicker.position.set(local.x, local.y);
            this.rolePicker.setTailVisible(true);
            return true;
        };
        // Keep the picker glued over its recruit as the entity (or camera) moves. No-op while closed.
        // Called every frame by the renderer.
        this.updateRolePickerPosition = ()=>{
            if (!this.rolePicker.isOpen()) return;
            const entityId = this.rolePicker.getTargetEntityId();
            if (!entityId) return;
            this.positionRolePickerOverEntity(entityId);
        };
        this.hideRolePicker = ()=>{
            this.rolePicker.fadeOut();
            this.rolePicker.clearTarget();
            this.restoreContextMenu();
        };
        // Server-driven: put the name field up over one camp member, started on `name`. Gated to ember
        // rooms by the same per-room visibility flag as the command wheel and the role picker.
        this.showNamePrompt = (entityId, name)=>{
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            this.namePrompt.bindToEntity(entityId, name);
            if (!this.positionNamePromptOverEntity(entityId)) {
                // The entity isn't on this client yet (a hire names the recruit in the same breath as
                // swapping its script). Nothing to pin to, so there is nothing sensible to show.
                this.namePrompt.clearTarget();
                return;
            }
            this.namePrompt.fadeIn();
            // The field now owns the keyboard: see Keyboard.suppressTyping. Released in hideNamePrompt,
            // and Escape still gets through, which is what guarantees there is always a way out.
            (0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(true);
            this.preventContextMenu();
        };
        // Position the prompt so its tail tip sits at the member's center (the panel floats above).
        // Called once, at open: unlike the role picker the prompt does NOT follow its entity, because a
        // field that slides out from under the cursor while being typed into is far worse than one
        // left standing where the player opened it. The tail is what pays for that -- see
        // updateNamePrompt.
        this.positionNamePromptOverEntity = (entityId)=>{
            const local = this.entityStageLocal(entityId);
            if (!local) return false;
            this.namePrompt.position.set(local.x, local.y);
            this.namePrompt.setTailVisible(true);
            return true;
        };
        // Per-frame upkeep: drop the prompt once the entity being named is gone -- there is nobody left
        // to name. Deliberately NOT closed when that entity merely walks off screen: a member can wander
        // out of view while their name is half typed, and losing the field then would lose the name.
        //
        // What does go is the tail. The panel is pinned where it opened, so the member (or the camera)
        // only has to move for the pointer to be aiming at bare ground, which reads as the prompt being
        // about whatever is standing there now. Checked every frame, and it comes back if they walk
        // back under it.
        this.updateNamePrompt = ()=>{
            if (!this.namePrompt.isOpen()) return;
            const entityId = this.namePrompt.getTargetEntityId();
            if (!entityId) return;
            if (!this.logic.getEntity(entityId) || this.logic.isDestroyed(entityId)) {
                this.hideNamePrompt();
                return;
            }
            const local = this.entityStageLocal(entityId);
            const onTip = !!local && Math.hypot(local.x - this.namePrompt.x, local.y - this.namePrompt.y) <= $7dd73ecdd94bfe01$var$PANEL_TAIL_SLACK;
            this.namePrompt.setTailVisible(onTip);
        };
        this.hideNamePrompt = ()=>{
            this.namePrompt.fadeOut();
            this.namePrompt.clearTarget();
            (0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(false);
            this.restoreContextMenu();
        };
        this.isNamePromptVisible = ()=>{
            return this.namePrompt.isOpen();
        };
        // The run is over: rebuild the scorecard around this payload and fade it in over the camp.
        this.showRunSummary = (summary)=>{
            if (!summary) return;
            // Nothing else should be competing for the screen once the run has ended.
            this.hideCommandWheel();
            this.hideRolePicker();
            this.hideNamePrompt();
            this.hideInvasionPicker();
            this.dismissFollowCam();
            // Prefer the synced entity (it carries the current appearance/inventory the paperdoll needs)
            // and fall back to the local player stub.
            const player = this.logic.getEntity(this.logic.playerEntity?.entityId) || this.logic.playerEntity;
            this.runSummary.setSummary(summary, player);
            this.runSummary.fadeIn();
        };
        this.hideRunSummary = ()=>{
            this.runSummary.fadeOut();
            // The picker is opened FROM the scorecard and is meaningless without it: the panel going
            // away means the player took one of its other ways on, and a chooser left floating over a
            // room they have already left would still send a `join`.
            this.hideInvasionPicker();
        };
        this.isRunSummaryVisible = ()=>{
            return this.runSummary?.isOpen() === true;
        };
        // Server-driven: the newest invasion offer (Protocol.type_updateInvasionOffer). An interval
        // feed, ~2s, NOT a reply to a press -- which is the point: the scorecard's third button lights
        // up by itself when a camp becomes available, and an open picker gains and loses cards while
        // it is being read.
        //
        // `null` forgets the offer and takes the picker down. An EMPTY list does neither: it is a real
        // answer ("no camp is open to the dead") and the normal steady state on a quiet server, so the
        // button stays, inert and saying so, and an open picker shows its empty state rather than
        // vanishing under the player.
        this.updateInvasionOffer = (candidates)=>{
            if (!candidates) {
                this.invasionCandidates = undefined;
                this.runSummary?.setInvasionOffer(undefined);
                this.hideInvasionPicker();
                return;
            }
            this.invasionCandidates = candidates;
            this.runSummary?.setInvasionOffer(candidates);
            if (this.invasionPicker?.isOpen()) this.invasionPicker.setCandidates(candidates);
        };
        // Open the chooser on what the client already holds. No round trip: see the scorecard's
        // onInvade. Refuses to open on nothing, because the inert button should not have been pressable
        // in the first place (runSummaryButtons) and a picker opening onto its own empty state would
        // read as a broken press rather than as an honest answer.
        this.showInvasionPicker = ()=>{
            if (!this.invasionCandidates || this.invasionCandidates.length < 1) return;
            this.invasionPicker.open(this.invasionCandidates);
        };
        this.hideInvasionPicker = ()=>{
            if (this.invasionPicker?.isOpen()) this.invasionPicker.close();
        };
        this.isInvasionPickerVisible = ()=>{
            return this.invasionPicker?.isOpen() === true;
        };
        // Backing out of the picker, from any of its three ways out: the footer button, a press on its
        // own scrim, and Escape (the house convention for every other modal -- see Player's Escape
        // chain). All three go through here rather than each pairing the message with the close
        // themselves, which is how the keyboard path and the pointer path drift apart.
        this.cancelInvasionPicker = ()=>{
            if (!this.isInvasionPickerVisible()) return;
            this.logic.playerController?.client?.sendEmberInvasionCommand("cancel");
            this.hideInvasionPicker();
        };
        // Whether this player is currently wearing one of another camp's attackers (Message.invading).
        // Taken from the server's verdict on every message, like the downed flag, so the way out cannot
        // outlive the body -- or go missing while it lives.
        //
        // It is also what takes the SCORECARD down, and the timing is the point. The other two ways off
        // that panel dismiss it as they send, because they cannot fail; a `join` can -- the camp may
        // have closed, or filled, between the feed and the press -- and a panel dismissed optimistically
        // on a refused join would leave a still-fallen player with no way out at all until the camp's
        // own 3-minute net fired. So the panel waits for the server to say the visit really started.
        this.setInvading = (invading)=>{
            this.letGoButton?.setInvading(invading);
            if (invading && !this.invading && this.isRunSummaryVisible()) this.hideRunSummary();
            // Each end of a visit, announced once. Both ends are this ONE verdict's transitions, which
            // is why neither needs a message of its own: the server already tells the client whether it
            // is wearing somebody else's body, every message, for its own entity.
            //
            // A visit that ends by dying also builds the player a fresh camp, so the "returned" splash
            // goes up alongside a room load -- hence its zIndex above everything, and hence nothing in
            // the room-change path takes it down. It waits to be read.
            const splash = (0, $fd1228436d3e60cd$export$42463ac0de0f0a2)(this.invading, invading);
            if (splash) this.showPossessionSplash(splash);
            this.invading = invading;
        };
        this.showPossessionSplash = (kind)=>{
            this.possessionSplash?.open(kind);
        };
        this.hidePossessionSplash = ()=>{
            if (this.possessionSplash?.isOpen()) this.possessionSplash.close();
        };
        this.isPossessionSplashVisible = ()=>this.possessionSplash?.isOpen() === true;
        this.isRolePickerVisible = ()=>{
            return this.rolePicker.isOpen();
        };
        // Server-driven: put up the first-run tutorial invitation (or take it down again when the
        // server passes null -- e.g. the player answered on another client, or the camp moved on).
        // Gated to ember rooms by the same per-room visibility flag as the command wheel and the role
        // picker, so a stray payload can never park a bar over a normal room.
        this.showTutorialPrompt = (prompt)=>{
            if (!prompt) {
                this.hideTutorialPrompt();
                return;
            }
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            this.tutorialPrompt.setPrompt(prompt);
            // The bar sizes itself to the server's wording, so re-anchor it to the bottom of the
            // screen AFTER it has been rebuilt -- otherwise a taller prompt hangs off the edge.
            this.anchorTutorialPrompt();
            this.tutorialPrompt.fadeIn();
        };
        // Keep the invitation a fixed distance off the bottom edge, whatever height its copy needs.
        this.anchorTutorialPrompt = ()=>{
            this.tutorialPrompt.y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h - this.tutorialPrompt.stageHeight() - 18;
        };
        this.hideTutorialPrompt = ()=>{
            this.tutorialPrompt.fadeOut();
        };
        this.isTutorialPromptVisible = ()=>{
            return this.tutorialPrompt.isOpen();
        };
        this.preventContextMenu = ()=>{
            // Add document-level context menu prevention
            document.addEventListener("contextmenu", this.onContextMenu, true);
        };
        this.restoreContextMenu = ()=>{
            // Remove document-level context menu prevention
            document.removeEventListener("contextmenu", this.onContextMenu, true);
        };
        this.onContextMenu = (event)=>{
            // Only prevent context menu if command wheel is open
            if (this.commandWheel.isOpen()) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        this.stage = stage;
        this.minimapSurface = minimapSurface;
        this.logic = logic;
        this.incomingMessageMeta = {
            unread: false,
            flasherInterval: null,
            expires: null,
            text: null
        };
        this.currentModal = null;
        this.upgradeIndicator = false;
        this.minimapSurface.register(this.mapPointHoverListener);
        // Load chat history from localStorage
        this.loadChatHistory();
    }
    static{
        // ---- dragging the minimap ------------------------------------------------
        //
        // The whole panel is a grab handle (see EmberMinimapWidget.attachDrag), because the part of the
        // camp the map covers is sometimes the part the player needs to watch. GuiManager does the moving
        // rather than the widget: it is what re-anchors the panel above the roster strip, and so the only
        // place that can both honour a dragged position and keep it on screen.
        // A press on the panel must never also swing the player's axe. The attack click arrives via a
        // document-level mousedown that cannot see which pixi widget it landed on, so it is held off the
        // same way an interaction-icon click is (see Player.suppressAttack) — renewed on grab, on every
        // drag frame and once more on release, so a drag of any length is covered end to end. A drag that
        // pauses needs no cover: a still pointer raises no mouse events, so nothing can fire.
        this.MINIMAP_DRAG_ATTACK_HOLDOFF_MS = 500;
    }
    static{
        // The forest under the dots. Trees are TILES, and the client already holds the whole room's tile
        // map, so they are scanned here instead of riding the wire — the broadcast carries only what moves.
        // Keyed on the map's collision version so a felled tree drops off the map, and floored on
        // EMBER_TREE_RESCAN_MS so a run of tile edits can't turn a 5Hz broadcast into a 5Hz full-room scan.
        this.EMBER_TREE_RESCAN_MS = 1000;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");


// Pure geometry for the faction-tracking edge arrows. Kept free of PIXI so it can be
// unit-tested. All inputs are in ONE consistent coordinate space (the overlay container's
// local space); the caller obtains points/rect via PIXI transforms (toLocal) so no screen
// dimensions are assumed here.
function $346557f46cacf0ca$export$ed6daf3dad1b8753(a, b) {
    return {
        left: Math.min(a.x, b.x),
        right: Math.max(a.x, b.x),
        top: Math.min(a.y, b.y),
        bottom: Math.max(a.y, b.y)
    };
}
function $346557f46cacf0ca$export$cdb01b513ccf6a5c(p, rect, pad = 0) {
    return p.x < rect.left + pad || p.x > rect.right - pad || p.y < rect.top + pad || p.y > rect.bottom - pad;
}
function $346557f46cacf0ca$export$d96d408106aa045f(x, y, w, h, rect, pad = 2) {
    const halfW = w / 2 + pad;
    const halfH = h / 2 + pad;
    const minX = rect.left + halfW;
    const maxX = rect.right - halfW;
    const minY = rect.top + halfH;
    const maxY = rect.bottom - halfH;
    return {
        x: minX > maxX ? (rect.left + rect.right) / 2 : Math.max(minX, Math.min(maxX, x)),
        y: minY > maxY ? (rect.top + rect.bottom) / 2 : Math.max(minY, Math.min(maxY, y))
    };
}
function $346557f46cacf0ca$export$c0fb7ff48a5b5eeb(placement, w, h, rect, arrowClear, gap) {
    return $346557f46cacf0ca$var$offsetInwardBox(placement, placement.x, placement.y, arrowClear + gap, w, h, rect);
}
function $346557f46cacf0ca$export$91ef56399d0e33f3(placement, anchor, anchorW, anchorH, w, h, rect, gap) {
    const anchorHalf = placement.onVerticalEdge ? anchorW / 2 : anchorH / 2;
    return $346557f46cacf0ca$var$offsetInwardBox(placement, anchor.x, anchor.y, anchorHalf + gap, w, h, rect);
}
// Shared core: offset a box inward (perpendicular to the placement's screen edge), aligned
// with the anchor point on the along-edge axis, so the box's near edge sits `clearance` past
// the anchor. Then clamp it on screen (which only pushes further inward -> no re-overlap).
function $346557f46cacf0ca$var$offsetInwardBox(placement, ax, ay, clearance, w, h, rect) {
    let x = ax;
    let y = ay;
    if (placement.onVerticalEdge) // sign(cos) matches sign(anchor.x - center.x): +1 on the right edge, -1 on the left.
    // Subtracting pushes the box inward by half its width plus the clearance.
    x = ax - Math.sign(Math.cos(placement.angle)) * (clearance + w / 2);
    else y = ay - Math.sign(Math.sin(placement.angle)) * (clearance + h / 2);
    return $346557f46cacf0ca$export$d96d408106aa045f(x, y, w, h, rect);
}
function $346557f46cacf0ca$export$d6462cc94e2727e7(target, rect, margin) {
    const cx = (rect.left + rect.right) / 2;
    const cy = (rect.top + rect.bottom) / 2;
    const dx = target.x - cx;
    const dy = target.y - cy;
    if (dx === 0 && dy === 0) return {
        x: cx,
        y: cy,
        angle: 0,
        onVerticalEdge: true
    };
    const halfW = Math.max(1, (rect.right - rect.left) / 2 - margin);
    const halfH = Math.max(1, (rect.bottom - rect.top) / 2 - margin);
    // Whichever normalized reach is smaller binds first: the x-scale binding means the ray
    // exits through a left/right (vertical) edge; the y-scale, a top/bottom (horizontal) one.
    const sx = halfW / Math.abs(dx || 1e-9);
    const sy = halfH / Math.abs(dy || 1e-9);
    const scale = Math.min(sx, sy);
    return {
        x: cx + dx * scale,
        y: cy + dy * scale,
        angle: Math.atan2(dy, dx),
        onVerticalEdge: sx <= sy
    };
}


class $265fbb56155cf111$export$92880c192d1b7482 {
    constructor(logic, surface, app){
        this.markers = new Map();
        this.EDGE_MARGIN = 18;
        // How far the arrow triangle can reach toward the glyph (its farthest vertex is the 9px
        // tip; near a corner the rotated arrow reaches obliquely toward the glyph, so use the tip
        // radius rather than the 6px back edge). GLYPH_GAP is the extra clear space kept between
        // the arrow and the glyph; together they set the constant near-edge clearance used by
        // placeInwardBox so the glyph never overlaps the arrow at any edge angle.
        this.ARROW_REACH = 9;
        this.GLYPH_GAP = 1;
        this.OFFSCREEN_PAD = 8;
        this.ARROW_COLOR = 0x66ff66;
        // The highlighted roster member's arrow: hot orange, breathing, with an expanding ping behind
        // it, so "where is the one I just clicked?" is answerable at a glance across a busy screen.
        this.HIGHLIGHT_COLOR = 0xff8a1f;
        this.PULSE_MS = 900 // one breathe/ping cycle
        ;
        this.PULSE_GROW = 0.5 // the arrow swells to 1.5x at the top of the breath
        ;
        this.NAME_COLOR = 0x66ff66 // name line — matches the arrow/glyph
        ;
        this.GLYPH_SIZE = 16 // role emoji font size
        ;
        this.HOVER_PAD = 5 // extra hit-area padding so the small glyph is easy to hover
        ;
        this.PANEL_GAP = 5 // gap between the glyph and the name/message panel
        ;
        this.FALLBACK_GLYPH = "\u2022" // tracked member with no roster role (e.g. a follower)
        ;
        // Rescanning every entity in the room each frame (entityManager.collect is O(n) and
        // allocates) is wasteful; the tracked-member SET changes slowly. Rebuild it a few times
        // a second and reuse the cached Entity references — their `location` is mutated in place
        // by the netcode, so arrow positions still update every frame.
        this.members = [];
        this.lastScanMs = 0;
        this.lastScannedFaction = null;
        this.SCAN_INTERVAL_MS = 250;
        // Reused scratch points to avoid per-frame allocation.
        this.tmpA = new (0, $6qzqq.Point)();
        this.tmpB = new (0, $6qzqq.Point)();
        this.logic = logic;
        this.surface = surface;
        this.app = app;
        this.container = new (0, $8t5Gy.Container)();
        this.container.zIndex = 50000 // above other HUD; stage.sortableChildren is on
        ;
        // Markers sort among themselves so the highlighted arrow draws over its neighbours when
        // two members are bunched at the same screen edge.
        this.container.sortableChildren = true;
    }
    // Triangle pointing toward +x; the marker's rotation orients it outward. Redrawn (rather than
    // tinted) when the highlight turns on/off, so the fill is the literal colour either way.
    drawArrow(g, color) {
        g.clear();
        g.beginFill(color);
        g.moveTo(9, 0);
        g.lineTo(-6, -6);
        g.lineTo(-6, 6);
        g.closePath();
        g.endFill();
    }
    // Fake glow behind the highlighted arrow: the same triangle stacked at growing scales with
    // falling alpha, largest first. A real blur filter would cost a GPU bake per frame per arrow,
    // which this has to run without.
    buildGlow() {
        const g = new (0, $gwPoJ.Graphics)();
        for (const [scale, alpha] of [
            [
                2.6,
                0.14
            ],
            [
                1.9,
                0.28
            ],
            [
                1.35,
                0.5
            ]
        ]){
            g.beginFill(this.HIGHLIGHT_COLOR, alpha);
            g.moveTo(9 * scale, 0);
            g.lineTo(-6 * scale, -6 * scale);
            g.lineTo(-6 * scale, 6 * scale);
            g.closePath();
            g.endFill();
        }
        g.visible = false;
        return g;
    }
    buildArrow() {
        const g = new (0, $gwPoJ.Graphics)();
        this.drawArrow(g, this.ARROW_COLOR);
        // Padded hit area around the small triangle (local bounds ~x[-6,9] y[-6,6]) so the
        // arrow itself is an easy hover target, not just the glyph. Rotates with the arrow.
        g.hitArea = new (0, $6qzqq.Rectangle)(-6 - this.HOVER_PAD, -6 - this.HOVER_PAD, 15 + this.HOVER_PAD * 2, 12 + this.HOVER_PAD * 2);
        return g;
    }
    // Make an object a hover target that drives the marker's tooltip (arrow + glyph both use this).
    wireHover(obj, marker) {
        obj.interactive = true;
        obj.cursor = "help";
        obj.on("pointerover", ()=>marker.hoverCount += 1);
        obj.on("pointerout", ()=>marker.hoverCount = Math.max(0, marker.hoverCount - 1));
    }
    // The glyph text + tint for a role: the role emoji rendered in its own colors (no tint), or
    // a neutral dot tinted the arrow colour — orange while highlighted — for a tracked member with
    // no roster role.
    glyphFor(role, highlighted) {
        const accent = highlighted ? this.HIGHLIGHT_COLOR : this.ARROW_COLOR;
        return role ? {
            text: (0, $8d6533e00bd59062$export$688b358246787b37)[role],
            tint: 0xffffff
        } : {
            text: this.FALLBACK_GLYPH,
            tint: accent
        };
    }
    applyGlyph(m) {
        const g = this.glyphFor(m.role, m.highlighted);
        m.glyph.text = g.text;
        m.glyph.tint = g.tint;
        // Padded hit area (measured after the text is set) so the small glyph is easy to hover.
        const hw = m.glyph.width / 2 + this.HOVER_PAD;
        const hh = m.glyph.height / 2 + this.HOVER_PAD;
        m.glyph.hitArea = new (0, $6qzqq.Rectangle)(-hw, -hh, hw * 2, hh * 2);
    }
    ensureMarker(entityId, role) {
        let m = this.markers.get(entityId);
        if (!m) {
            const container = new (0, $8t5Gy.Container)();
            const glow = this.buildGlow();
            const arrow = this.buildArrow();
            const glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(this.GLYPH_SIZE).render();
            glyph.anchor.set(0.5);
            container.addChild(glow) // behind the arrow
            ;
            container.addChild(arrow);
            container.addChild(glyph);
            this.container.addChild(container);
            m = {
                container: container,
                glow: glow,
                arrow: arrow,
                glyph: glyph,
                role: role,
                hoverCount: 0,
                highlighted: false
            };
            this.wireHover(arrow, m) // hovering the arrow OR the glyph shows the name tooltip
            ;
            this.wireHover(glyph, m);
            this.applyGlyph(m);
            this.markers.set(entityId, m);
        } else if (m.role !== role) {
            m.role = role;
            this.applyGlyph(m);
        }
        return m;
    }
    // Turn the "this is the roster card you have open" treatment on/off for a marker. Only the
    // state CHANGE redraws; the per-frame motion is in animateHighlight.
    setHighlight(m, on) {
        if (m.highlighted === on) return;
        m.highlighted = on;
        this.drawArrow(m.arrow, on ? this.HIGHLIGHT_COLOR : this.ARROW_COLOR);
        this.applyGlyph(m);
        m.glow.visible = on;
        m.container.zIndex = on ? 1 : 0;
        if (!on) m.arrow.scale.set(1);
    }
    // The pulse itself: the arrow breathes (smooth cosine) while a ping expands and fades out of
    // it (sawtooth), both off one shared clock so every highlighted arrow beats in time.
    animateHighlight(m, nowMs, placement) {
        const t = nowMs % this.PULSE_MS / this.PULSE_MS;
        const breathe = 0.5 - 0.5 * Math.cos(t * Math.PI * 2);
        m.arrow.scale.set(1 + this.PULSE_GROW * breathe);
        m.glow.position.set(placement.x, placement.y);
        m.glow.rotation = placement.angle;
        m.glow.scale.set(0.85 + 0.9 * t);
        m.glow.alpha = 0.85 * Math.pow(1 - t, 1.5);
    }
    hideMarker(m) {
        m.container.visible = false;
        m.hoverCount = 0 // pointerout won't fire while hidden; clear so no stale tooltip on return
        ;
    }
    hideAll() {
        this.markers.forEach((m)=>this.hideMarker(m));
    }
    // Show the black high-contrast panel inward of the glyph: the name (name color), and — when
    // the member is speaking — the message (message color) stacked below it. `message` is null
    // for a plain hover (name only). Positioned just past the glyph (via placeInwardOfBox) so it
    // never covers the glyph or the arrowhead.
    // The hover label: just the member's name. What they SAY is no longer shown here — an offscreen
    // member's words go to the ember roster's speech lane instead (gui/roster_speech_lane.ts), where
    // they sit above that member's own portrait card. Showing the line in both places at once was
    // the same sentence twice on screen.
    showPanel(marker, name, glyphCenter, glyphW, glyphH, placement, rect) {
        if (!marker.panel) {
            const container = new (0, $8t5Gy.Container)();
            const bg = new (0, $gwPoJ.Graphics)();
            const nameText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").color(this.NAME_COLOR).render();
            nameText.anchor.set(0.5, 0) // top-centered
            ;
            container.addChild(bg);
            container.addChild(nameText);
            marker.container.addChild(container);
            marker.panel = {
                container: container,
                bg: bg,
                nameText: nameText
            };
        }
        const panel = marker.panel;
        if (panel.nameText.text !== name) panel.nameText.text = name;
        const padX = 6;
        const padY = 3;
        const w = panel.nameText.width + padX * 2;
        const h = panel.nameText.height + padY * 2;
        panel.nameText.position.set(0, -h / 2 + padY);
        panel.bg.clear();
        panel.bg.beginFill(0x000000, 0.85) // near-opaque black for high contrast over the world
        ;
        panel.bg.lineStyle(1, this.ARROW_COLOR, 0.9);
        panel.bg.drawRoundedRect(-w / 2, -h / 2, w, h, 4);
        panel.bg.endFill();
        // Sit the panel just past the glyph (inward), aligned with it, and keep it on screen.
        const pos = (0, $346557f46cacf0ca$export$91ef56399d0e33f3)(placement, glyphCenter, glyphW, glyphH, w, h, rect, this.PANEL_GAP);
        panel.container.position.set(pos.x, pos.y);
        panel.container.visible = true;
    }
    hidePanel(marker) {
        if (marker.panel) marker.panel.container.visible = false;
    }
    nameFor(entity) {
        const anyEntity = entity;
        if (typeof anyEntity.safeName === "function") return anyEntity.safeName() || "";
        return entity.name || "";
    }
    // The visible screen rectangle expressed in this overlay's local coordinate space,
    // derived from the renderer's actual screen corners via PIXI transforms.
    screenRectInLocal() {
        this.tmpA.set(this.app.screen.x, this.app.screen.y);
        this.tmpB.set(this.app.screen.x + this.app.screen.width, this.app.screen.y + this.app.screen.height);
        const tl = this.container.toLocal(this.tmpA);
        const br = this.container.toLocal(this.tmpB);
        return (0, $346557f46cacf0ca$export$ed6daf3dad1b8753)(tl, br);
    }
    update() {
        const logic = this.logic;
        if (!logic.trackingEnabled || !logic.trackedFaction) {
            this.hideAll();
            return;
        }
        const player = logic.playerEntity;
        if (!player || !player.location) {
            this.hideAll();
            return;
        }
        const rect = this.screenRectInLocal();
        // Throttled rescan of the tracked-faction member set (also rescans immediately if
        // the tracked faction changed). Positions come from the cached refs each frame.
        const nowMs = performance.now();
        if (nowMs - this.lastScanMs >= this.SCAN_INTERVAL_MS || this.lastScannedFaction !== logic.trackedFaction) {
            this.lastScanMs = nowMs;
            this.lastScannedFaction = logic.trackedFaction;
            this.members = logic.entityManager.collect((e)=>e.faction === logic.trackedFaction && e.entityId !== player.entityId);
        }
        // The highlighted roster card IS the follow-cam focus (EmberRosterWidget.onSlotClick ->
        // GuiManager.openFollowCam -> setFocusEntityId), so that one id is the whole signal.
        const highlightedId = logic.focusEntityId;
        const present = new Set();
        for (const entity of this.members){
            // Skip stale cached refs: entity hidden, removed from the manager, or already
            // scheduled for destruction (removed next cleanup). Not adding it to `present`
            // makes the cleanup pass below destroy its arrow this frame.
            if (!entity.location || entity.visible === false || !logic.hasEntity(entity.entityId) || logic.isDestroyed(entity.entityId)) continue;
            present.add(entity.entityId);
            // Entity world position -> this overlay's local space (exact, via the world
            // container's transform).
            this.tmpA.set(entity.location.x, entity.location.y);
            const p = this.container.toLocal(this.tmpA, this.surface);
            if (!(0, $346557f46cacf0ca$export$cdb01b513ccf6a5c)(p, rect, this.OFFSCREEN_PAD)) {
                const existing = this.markers.get(entity.entityId);
                if (existing) this.hideMarker(existing);
                continue;
            }
            const placement = (0, $346557f46cacf0ca$export$d6462cc94e2727e7)(p, rect, this.EDGE_MARGIN);
            const marker = this.ensureMarker(entity.entityId, this.logic.getEmberRole(entity.entityId));
            this.setHighlight(marker, !!highlightedId && entity.entityId === highlightedId);
            marker.container.visible = true;
            marker.arrow.position.set(placement.x, placement.y);
            marker.arrow.rotation = placement.angle;
            if (marker.highlighted) this.animateHighlight(marker, nowMs, placement);
            // The role glyph, offset perpendicular to the arrow's screen edge and aligned along
            // it, so it sits centered next to the arrow without overlapping the arrowhead.
            // Reserve clearance for the arrow at its LARGEST (peak of the breath) rather than
            // re-placing the glyph every frame, which would make it jitter in and out.
            const reach = marker.highlighted ? this.ARROW_REACH * (1 + this.PULSE_GROW) : this.ARROW_REACH;
            const gp = (0, $346557f46cacf0ca$export$c0fb7ff48a5b5eeb)(placement, marker.glyph.width, marker.glyph.height, rect, reach, this.GLYPH_GAP);
            marker.glyph.position.set(gp.x, gp.y);
            // The black panel (just past the glyph) names the member while the arrow or glyph is
            // hovered. The arrow's job is DIRECTION — where they are; what they're saying belongs to
            // the roster's speech lane, which has their portrait and name already.
            if (marker.hoverCount > 0) this.showPanel(marker, this.nameFor(entity), gp, marker.glyph.width, marker.glyph.height, placement, rect);
            else this.hidePanel(marker);
        }
        // Drop markers whose entity is gone (left room, died, out of sync range).
        for (const [id, m] of this.markers)if (!present.has(id)) {
            m.container.destroy({
                children: true
            });
            this.markers.delete(id);
        }
    }
}




/* eslint-disable */ /*!
 * @pixi/tilemap - v3.2.2
 * Compiled Fri, 22 Oct 2021 12:27:49 UTC
 *
 * @pixi/tilemap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 * 
 * Copyright 2019-2020, Ivan Popelyshev, All Rights Reserved
 */ 
var $8t5Gy = parcelRequire("8t5Gy");

var $klOfb = parcelRequire("klOfb");

var $P8XPi = parcelRequire("P8XPi");

var $6qzqq = parcelRequire("6qzqq");

var $csytw = parcelRequire("csytw");
/**
 * The renderer plugin for canvas. It isn't registered by default.
 *
 * ```
 * import { CanvasTileRenderer } from '@pixi/tilemap';
 * import { CanvasRenderer } from '@pixi/canvas-core';
 *
 * // You must register this yourself (optional). @pixi/tilemap doesn't do it to
 * // prevent a hard dependency on @pixi/canvas-core.
 * CanvasRenderer.registerPlugin('tilemap', CanvasTileRenderer);
 * ```
 */ // TODO: Move to @pixi/tilemap-canvas
class $21ba273fabeffbe8$export$adc19050884d1e30 {
    /** The renderer */ /** The global tile animation state */ __init() {
        this.tileAnim = [
            0,
            0
        ];
    }
    /** @deprecated */ __init2() {
        this.dontUseTransform = false;
    }
    /** @param renderer */ constructor(renderer){
        $21ba273fabeffbe8$export$adc19050884d1e30.prototype.__init.call(this);
        $21ba273fabeffbe8$export$adc19050884d1e30.prototype.__init2.call(this);
        this.renderer = renderer;
        this.tileAnim = [
            0,
            0
        ];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static getInstance(renderer) {
        if (!renderer.plugins.tilemap) renderer.plugins.tilemap = new $21ba273fabeffbe8$export$adc19050884d1e30(renderer);
        return renderer.plugins.tilemap;
    }
}
/**
 * These are additional @pixi/tilemap options.
 *
 * This settings should not be changed after the renderer has initialized; otherwise, the behavior
 * is undefined.
 */ const $21ba273fabeffbe8$export$a5a6e0b888b2c992 = {
    /** The default number of textures per tilemap in a tilemap composite. */ TEXTURES_PER_TILEMAP: 16,
    /**
     * The width/height of each texture tile in a {@link TEXTILE_DIMEN}. This is 1024px by default.
     *
     * This should fit all tile base-textures; otherwise, {@link TextileResource} may fail to correctly
     * upload the textures togther in a tiled fashion.
     */ TEXTILE_DIMEN: 1024,
    /**
     * The number of texture tiles per {@link TextileResource}.
     *
     * Texture tiling is disabled by default, and so this is set to `1` by default. If it is set to a
     * higher value, textures will be uploaded together in a tiled fashion.
     *
     * Since {@link TextileResource} is a dual-column format, this should be even for packing
     * efficiency. The optimal value is usually 4.
     */ TEXTILE_UNITS: 1,
    /** The scaling mode of the combined texture tiling. */ TEXTILE_SCALE_MODE: (0, $P8XPi.SCALE_MODES).LINEAR,
    /** This will enable 32-bit index buffers. It's useful when you have more than 16K tiles. */ use32bitIndex: false,
    /** Flags whether textiles should be cleared when each tile is uploaded. */ DO_CLEAR: true,
    // Backward compatibility
    get maxTextures () {
        return this.MAX_TEXTURES;
    },
    set maxTextures (value){
        this.MAX_TEXTURES = value;
    },
    get boundSize () {
        return this.TEXTURE_TILE_DIMEN;
    },
    set boundSize (value){
        this.TILE_TEXTURE_DIMEN = value;
    },
    get boundCountPerBuffer () {
        return this.TEXTILE_UNITS;
    },
    set boundCountPerBuffer (value){
        this.TEXTILE_UNITS = value;
    }
};
// @deprecated
const $21ba273fabeffbe8$export$3c508fb3f8ac1ad4 = $21ba273fabeffbe8$export$a5a6e0b888b2c992;
function $21ba273fabeffbe8$var$_nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
var $21ba273fabeffbe8$var$POINT_STRUCT;
(function(POINT_STRUCT) {
    const U = 0;
    POINT_STRUCT[POINT_STRUCT["U"] = U] = "U";
    const V = U + 1;
    POINT_STRUCT[POINT_STRUCT["V"] = V] = "V";
    const X = V + 1;
    POINT_STRUCT[POINT_STRUCT["X"] = X] = "X";
    const Y = X + 1;
    POINT_STRUCT[POINT_STRUCT["Y"] = Y] = "Y";
    const TILE_WIDTH = Y + 1;
    POINT_STRUCT[POINT_STRUCT["TILE_WIDTH"] = TILE_WIDTH] = "TILE_WIDTH";
    const TILE_HEIGHT = TILE_WIDTH + 1;
    POINT_STRUCT[POINT_STRUCT["TILE_HEIGHT"] = TILE_HEIGHT] = "TILE_HEIGHT";
    const ROTATE = TILE_HEIGHT + 1;
    POINT_STRUCT[POINT_STRUCT["ROTATE"] = ROTATE] = "ROTATE";
    const ANIM_X = ROTATE + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_X"] = ANIM_X] = "ANIM_X";
    const ANIM_Y = ANIM_X + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_Y"] = ANIM_Y] = "ANIM_Y";
    const TEXTURE_INDEX = ANIM_Y + 1;
    POINT_STRUCT[POINT_STRUCT["TEXTURE_INDEX"] = TEXTURE_INDEX] = "TEXTURE_INDEX";
    const ANIM_COUNT_X = TEXTURE_INDEX + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_COUNT_X"] = ANIM_COUNT_X] = "ANIM_COUNT_X";
    const ANIM_COUNT_Y = ANIM_COUNT_X + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_COUNT_Y"] = ANIM_COUNT_Y] = "ANIM_COUNT_Y";
    const ANIM_DIVISOR = ANIM_COUNT_Y + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_DIVISOR"] = ANIM_DIVISOR] = "ANIM_DIVISOR";
    const ALPHA = ANIM_DIVISOR + 1;
    POINT_STRUCT[POINT_STRUCT["ALPHA"] = ALPHA] = "ALPHA";
})($21ba273fabeffbe8$var$POINT_STRUCT || ($21ba273fabeffbe8$var$POINT_STRUCT = {}));
const $21ba273fabeffbe8$export$1352a974e0a4bb22 = Object.keys($21ba273fabeffbe8$var$POINT_STRUCT).length / 2;
/**
 * A rectangular tilemap implementation that renders a predefined set of tile textures.
 *
 * The {@link Tilemap.tileset tileset} of a tilemap defines the list of base-textures that can be painted in the
 * tilemap. A texture is identified using its base-texture's index into the this list, i.e. changing the base-texture
 * at a given index in the tileset modifies the paint of all tiles pointing to that index.
 *
 * The size of the tileset is limited by the texture units supported by the client device. The minimum supported
 * value is 8, as defined by the WebGL 1 specification. `gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS`) can be used
 * to extract this limit. {@link CompositeTilemap} can be used to get around this limit by layering multiple tilemap
 * instances.
 *
 * @example
 * import { Tilemap } from '@pixi/tilemap';
 * import { Loader } from '@pixi/loaders';
 *
 * // Add the spritesheet into your loader!
 * Loader.shared.add('atlas', 'assets/atlas.json');
 *
 * // Make the tilemap once the tileset assets are available.
 * Loader.shared.load(function onTilesetLoaded()
 * {
 *      // The base-texture is shared between all the tile textures.
 *      const tilemap = new Tilemap([Texture.from('grass.png').baseTexture])
 *          .tile('grass.png', 0, 0)
 *          .tile('grass.png', 100, 100)
 *          .tile('brick_wall.png', 0, 100);
 * });
 */ class $21ba273fabeffbe8$export$f9d4276726476e59 extends (0, $8t5Gy.Container) {
    __init() {
        this.shadowColor = new Float32Array([
            0.0,
            0.0,
            0.0,
            0.5
        ]);
    }
    __init2() {
        this._globalMat = null;
    }
    /**
     * The tile animation frame.
     *
     * @see CompositeTilemap.tileAnim
     */ __init3() {
        this.tileAnim = null;
    }
    /**
     * This is the last uploaded size of the tilemap geometry.
     * @ignore
     */ __init4() {
        this.modificationMarker = 0;
    }
    /** @ignore */ __init5() {
        this.offsetX = 0;
    }
    /** @ignore */ __init6() {
        this.offsetY = 0;
    }
    /** @ignore */ __init7() {
        this.compositeParent = false;
    }
    /**
     * The list of base-textures being used in the tilemap.
     *
     * This should not be shuffled after tiles have been added into this tilemap. Usually, only tile textures
     * should be added after tiles have been added into the map.
     */ /**
     * The local bounds of the tilemap itself. This does not include DisplayObject children.
     */ __init8() {
        this.tilemapBounds = new (0, $8t5Gy.Bounds)();
    }
    /** Flags whether any animated tile was added. */ __init9() {
        this.hasAnimatedTile = false;
    }
    /** The interleaved geometry of the tilemap. */ __init10() {
        this.pointsBuf = [];
    }
    /**
     * @param tileset - The tileset to use for the tilemap. This can be reset later with {@link Tilemap.setTileset}. The
     *      base-textures in this array must not be duplicated.
     */ constructor(tileset){
        super();
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init4.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init5.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init6.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init7.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init8.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init9.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init10.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init11.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init12.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init13.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init14.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init15.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init16.call(this);
        this.setTileset(tileset);
    }
    /**
     * @returns The tileset of this tilemap.
     */ getTileset() {
        return this.tileset;
    }
    /**
     * Define the tileset used by the tilemap.
     *
     * @param tileset - The list of textures to use in the tilemap. If a base-texture (not array) is passed, it will
     *  be wrapped into an array. This should not contain any duplicates.
     */ setTileset(tileset = []) {
        if (!Array.isArray(tileset)) tileset = [
            tileset
        ];
        for(let i = 0; i < tileset.length; i++)if (tileset[i].baseTexture) tileset[i] = tileset[i].baseTexture;
        this.tileset = tileset;
        return this;
    }
    /**  Clears all the tiles added into this tilemap. */ clear() {
        this.pointsBuf.length = 0;
        this.modificationMarker = 0;
        this.tilemapBounds.clear();
        this.hasAnimatedTile = false;
        return this;
    }
    /**
     * Adds a tile that paints the given texture at (x, y).
     *
     * @param tileTexture - The tiling texture to render.
     * @param x - The local x-coordinate of the tile's position.
     * @param y - The local y-coordinate of the tile's position.
     * @param options - Additional tile options.
     * @param [options.u=texture.frame.x] - The x-coordinate of the texture in its base-texture's space.
     * @param [options.v=texture.frame.y] - The y-coordinate of the texture in its base-texture's space.
     * @param [options.tileWidth=texture.orig.width] - The local width of the tile.
     * @param [options.tileHeight=texture.orig.height] - The local height of the tile.
     * @param [options.animX=0] - For animated tiles, this is the "offset" along the x-axis for adjacent
     *      animation frame textures in the base-texture.
     * @param [options.animY=0] - For animated tiles, this is the "offset" along the y-axis for adjacent
     *      animation frames textures in the base-texture.
     * @param [options.rotate=0]
     * @param [options.animCountX=1024] - For animated tiles, this is the number of animation frame textures
     *      per row.
     * @param [options.animCountY=1024] - For animated tiles, this is the number of animation frame textures
     *      per column.
     * @param [options.animDivisor=1] - For animated tiles, this is the animation duration of each frame
     * @param [options.alpha=1] - Tile alpha
     * @return This tilemap, good for chaining.
     */ tile(tileTexture, x, y, options = {}) {
        let baseTexture;
        let textureIndex = -1;
        if (typeof tileTexture === 'number') {
            textureIndex = tileTexture;
            baseTexture = this.tileset[textureIndex];
        } else {
            let texture;
            if (typeof tileTexture === 'string') texture = (0, $klOfb.Texture).from(tileTexture);
            else texture = tileTexture;
            const textureList = this.tileset;
            for(let i = 0; i < textureList.length; i++)if (textureList[i] === texture.castToBaseTexture()) {
                textureIndex = i;
                break;
            }
            if ('baseTexture' in texture) {
                options.u = $21ba273fabeffbe8$var$_nullishCoalesce(options.u, ()=>texture.frame.x);
                options.v = $21ba273fabeffbe8$var$_nullishCoalesce(options.v, ()=>texture.frame.y);
                options.tileWidth = $21ba273fabeffbe8$var$_nullishCoalesce(options.tileWidth, ()=>texture.orig.width);
                options.tileHeight = $21ba273fabeffbe8$var$_nullishCoalesce(options.tileHeight, ()=>texture.orig.height);
            }
            baseTexture = texture.castToBaseTexture();
        }
        if (!baseTexture || textureIndex < 0) {
            console.error('The tile texture was not found in the tilemap tileset.');
            return this;
        }
        const { u: u = 0, v: v = 0, tileWidth: tileWidth = baseTexture.realWidth, tileHeight: tileHeight = baseTexture.realHeight, animX: animX = 0, animY: animY = 0, rotate: rotate = 0, animCountX: animCountX = 1024, animCountY: animCountY = 1024, animDivisor: animDivisor = 1, alpha: alpha = 1 } = options;
        const pb = this.pointsBuf;
        this.hasAnimatedTile = this.hasAnimatedTile || animX > 0 || animY > 0;
        pb.push(u);
        pb.push(v);
        pb.push(x);
        pb.push(y);
        pb.push(tileWidth);
        pb.push(tileHeight);
        pb.push(rotate);
        pb.push(animX | 0);
        pb.push(animY | 0);
        pb.push(textureIndex);
        pb.push(animCountX);
        pb.push(animCountY);
        pb.push(animDivisor);
        pb.push(alpha);
        this.tilemapBounds.addFramePad(x, y, x + tileWidth, y + tileHeight, 0, 0);
        return this;
    }
    /** Changes the rotation of the last tile. */ tileRotate(rotate) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.TEXTURE_INDEX)] = rotate;
    }
    /** Changes the `animX`, `animCountX` of the last tile. */ tileAnimX(offset, count) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_X)] = offset;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_X)] = count;
    // pb[pb.length - (POINT_STRUCT_SIZE - POINT_STRUCT.ANIM_DIVISOR)] = duration;
    }
    /** Changes the `animY`, `animCountY` of the last tile. */ tileAnimY(offset, count) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_Y)] = offset;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_Y)] = count;
    }
    /** Changes the `animDivisor` value of the last tile. */ tileAnimDivisor(divisor) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_DIVISOR)] = divisor;
    }
    tileAlpha(alpha) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ALPHA)] = alpha;
    }
    __init11() {
        this.renderCanvas = (renderer)=>{
            const plugin = $21ba273fabeffbe8$export$adc19050884d1e30.getInstance(renderer);
            if (plugin && !plugin.dontUseTransform) {
                const wt = this.worldTransform;
                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
            }
            this.renderCanvasCore(renderer);
        };
    }
    renderCanvasCore(renderer) {
        if (this.tileset.length === 0) return;
        const points = this.pointsBuf;
        const tileAnim = this.tileAnim || renderer.plugins.tilemap && renderer.plugins.tilemap.tileAnim;
        renderer.context.fillStyle = '#000000';
        for(let i = 0, n = points.length; i < n; i += $21ba273fabeffbe8$export$1352a974e0a4bb22){
            let x1 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.U];
            let y1 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.V];
            const x2 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.X];
            const y2 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.Y];
            const w = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_WIDTH];
            const h = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_HEIGHT];
            x1 += points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_X] * tileAnim[0];
            y1 += points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_Y] * tileAnim[1];
            const textureIndex = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TEXTURE_INDEX];
            const alpha = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ALPHA];
            // canvas does not work with rotate yet
            if (textureIndex >= 0 && this.tileset[textureIndex]) {
                renderer.context.globalAlpha = alpha;
                renderer.context.drawImage(this.tileset[textureIndex].getDrawableSource(), x1, y1, w, h, x2, y2, w, h);
            } else {
                renderer.context.globalAlpha = 0.5;
                renderer.context.fillRect(x2, y2, w, h);
            }
            renderer.context.globalAlpha = 1;
        }
    }
    __init12() {
        this.vbId = 0;
    }
    __init13() {
        this.vb = null;
    }
    __init14() {
        this.vbBuffer = null;
    }
    __init15() {
        this.vbArray = null;
    }
    __init16() {
        this.vbInts = null;
    }
    destroyVb() {
        if (this.vb) {
            this.vb.destroy();
            this.vb = null;
        }
    }
    render(renderer) {
        const plugin = renderer.plugins.tilemap;
        const shader = plugin.getShader();
        renderer.batch.setObjectRenderer(plugin);
        this._globalMat = shader.uniforms.projTransMatrix;
        renderer.globalUniforms.uniforms.projectionMatrix.copyTo(this._globalMat).append(this.worldTransform);
        shader.uniforms.shadowColor = this.shadowColor;
        shader.uniforms.animationFrame = this.tileAnim || plugin.tileAnim;
        this.renderWebGLCore(renderer, plugin);
    }
    renderWebGLCore(renderer, plugin) {
        const points = this.pointsBuf;
        if (points.length === 0) return;
        const rectsCount = points.length / $21ba273fabeffbe8$export$1352a974e0a4bb22;
        const shader = plugin.getShader();
        const textures = this.tileset;
        if (textures.length === 0) return;
        plugin.bindTileTextures(renderer, textures);
        renderer.shader.bind(shader, false);
        // lost context! recover!
        let vb = this.vb;
        if (!vb) {
            vb = plugin.createVb();
            this.vb = vb;
            this.vbId = vb.id;
            this.vbBuffer = null;
            this.modificationMarker = 0;
        }
        plugin.checkIndexBuffer(rectsCount, vb);
        const boundCountPerBuffer = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS;
        const vertexBuf = vb.getBuffer('aVertexPosition');
        // if layer was changed, re-upload vertices
        const vertices = rectsCount * vb.vertPerQuad;
        if (vertices === 0) return;
        if (this.modificationMarker !== vertices) {
            this.modificationMarker = vertices;
            const vs = vb.stride * vertices;
            if (!this.vbBuffer || this.vbBuffer.byteLength < vs) {
                // !@#$ happens, need resize
                let bk = vb.stride;
                while(bk < vs)bk *= 2;
                this.vbBuffer = new ArrayBuffer(bk);
                this.vbArray = new Float32Array(this.vbBuffer);
                this.vbInts = new Uint32Array(this.vbBuffer);
                vertexBuf.update(this.vbBuffer);
            }
            const arr = this.vbArray;
            // const ints = this.vbInts;
            // upload vertices!
            let sz = 0;
            // let tint = 0xffffffff;
            let textureId = 0;
            let shiftU = this.offsetX;
            let shiftV = this.offsetY;
            // let tint = 0xffffffff;
            // const tint = -1;
            for(let i = 0; i < points.length; i += $21ba273fabeffbe8$export$1352a974e0a4bb22){
                const eps = 0.5;
                if (this.compositeParent) {
                    const textureIndex = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TEXTURE_INDEX];
                    if (boundCountPerBuffer > 1) {
                        // TODO: what if its more than 4?
                        textureId = textureIndex >> 2;
                        shiftU = this.offsetX * (textureIndex & 1);
                        shiftV = this.offsetY * (textureIndex >> 1 & 1);
                    } else {
                        textureId = textureIndex;
                        shiftU = 0;
                        shiftV = 0;
                    }
                }
                const x = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.X];
                const y = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.Y];
                const w = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_WIDTH];
                const h = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_HEIGHT];
                const u = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.U] + shiftU;
                const v = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.V] + shiftV;
                let rotate = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ROTATE];
                const animX = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_X];
                const animY = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_Y];
                const animWidth = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_X] || 1024;
                const animHeight = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_Y] || 1024;
                const animXEncoded = animX + animWidth * 2048;
                const animYEncoded = animY + animHeight * 2048;
                const animDivisor = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_DIVISOR];
                const alpha = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ALPHA];
                let u0;
                let v0;
                let u1;
                let v1;
                let u2;
                let v2;
                let u3;
                let v3;
                if (rotate === 0) {
                    u0 = u;
                    v0 = v;
                    u1 = u + w;
                    v1 = v;
                    u2 = u + w;
                    v2 = v + h;
                    u3 = u;
                    v3 = v + h;
                } else {
                    let w2 = w / 2;
                    let h2 = h / 2;
                    if (rotate % 4 !== 0) {
                        w2 = h / 2;
                        h2 = w / 2;
                    }
                    const cX = u + w2;
                    const cY = v + h2;
                    rotate = (0, $6qzqq.groupD8).add(rotate, (0, $6qzqq.groupD8).NW);
                    u0 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v0 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                    rotate = (0, $6qzqq.groupD8).add(rotate, 2); // rotate 90 degrees clockwise
                    u1 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v1 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                    rotate = (0, $6qzqq.groupD8).add(rotate, 2);
                    u2 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v2 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                    rotate = (0, $6qzqq.groupD8).add(rotate, 2);
                    u3 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v3 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                }
                arr[sz++] = x;
                arr[sz++] = y;
                arr[sz++] = u0;
                arr[sz++] = v0;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
                arr[sz++] = x + w;
                arr[sz++] = y;
                arr[sz++] = u1;
                arr[sz++] = v1;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
                arr[sz++] = x + w;
                arr[sz++] = y + h;
                arr[sz++] = u2;
                arr[sz++] = v2;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
                arr[sz++] = x;
                arr[sz++] = y + h;
                arr[sz++] = u3;
                arr[sz++] = v3;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
            }
            vertexBuf.update(arr);
        }
        renderer.geometry.bind(vb, shader);
        renderer.geometry.draw((0, $P8XPi.DRAW_MODES).TRIANGLES, rectsCount * 6, 0);
    }
    /**
     * @internal
     * @ignore
     */ isModified(anim) {
        if (this.modificationMarker !== this.pointsBuf.length || anim && this.hasAnimatedTile) return true;
        return false;
    }
    /**
     * This will pull forward the modification marker.
     *
     * @internal
     * @ignore
     */ clearModify() {
        this.modificationMarker = this.pointsBuf.length;
    }
    /** @override */ _calculateBounds() {
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = this.tilemapBounds;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /** @override */ getLocalBounds(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) return this.tilemapBounds.getRectangle(rect);
        return super.getLocalBounds.call(this, rect);
    }
    /** @override */ destroy(options) {
        super.destroy(options);
        this.destroyVb();
    }
    /**
     * Deprecated signature for {@link Tilemap.tile tile}.
     *
     * @deprecated Since @pixi/tilemap 3.
     */ addFrame(texture, x, y, animX, animY) {
        this.tile(texture, x, y, {
            animX: animX,
            animY: animY
        });
        return true;
    }
    /**
     * Deprecated signature for {@link Tilemap.tile tile}.
     *
     * @deprecated Since @pixi/tilemap 3.
     */ // eslint-disable-next-line max-params
    addRect(textureIndex, u, v, x, y, tileWidth, tileHeight, animX = 0, animY = 0, rotate = 0, animCountX = 1024, animCountY = 1024, animDivisor = 1, alpha = 1) {
        return this.tile(textureIndex, x, y, {
            u: u,
            v: v,
            tileWidth: tileWidth,
            tileHeight: tileHeight,
            animX: animX,
            animY: animY,
            rotate: rotate,
            animCountX: animCountX,
            animCountY: animCountY,
            animDivisor: animDivisor,
            alpha: alpha
        });
    }
}
/**
 * A tilemap composite that lazily builds tilesets layered into multiple tilemaps.
 *
 * The composite tileset is the concatenatation of the individual tilesets used in the tilemaps. You can
 * preinitialized it by passing a list of tile textures to the constructor. Otherwise, the composite tilemap
 * is lazily built as you add more tiles with newer tile textures. A new tilemap is created once the last
 * tilemap has reached its limit (as set by {@link CompositeTilemap.texturesPerTilemap texturesPerTilemap}).
 *
 * @example
 * import { Application } from '@pixi/app';
 * import { CompositeTilemap } from '@pixi/tilemap';
 * import { Loader } from '@pixi/loaders';
 *
 * // Setup view & stage.
 * const app = new Application();
 *
 * document.body.appendChild(app.renderer.view);
 * app.stage.interactive = true;
 *
 * // Global reference to the tilemap.
 * let globalTilemap: CompositeTilemap;
 *
 * // Load the tileset spritesheet!
 * Loader.shared.load('atlas.json');
 *
 * // Initialize the tilemap scene when the assets load.
 * Loader.shared.load(function onTilesetLoaded()
 * {
 *      const tilemap = new CompositeTilemap();
 *
 *      // Setup the game level with grass and dungeons!
 *      for (let x = 0; x < 10; x++)
 *      {
 *          for (let y = 0; y < 10; y++)
 *          {
 *              tilemap.tile(
 *                  x % 2 === 0 && (x === y || x + y === 10) ? 'dungeon.png' : 'grass.png',
 *                  x * 100,
 *                  y * 100,
 *              );
 *          }
 *      }
 *
 *      globalTilemap = app.stage.addChild(tilemap);
 * });
 *
 * // Show a bomb at a random location whenever the user clicks!
 * app.stage.on('click', function onClick()
 * {
 *      if (!globalTilemap) return;
 *
 *      const x = Math.floor(Math.random() * 10);
 *      const y = Math.floor(Math.random() * 10);
 *
 *      globalTilemap.tile('bomb.png', x * 100, y * 100);
 * });
 */ class $21ba273fabeffbe8$export$8f858bd4088571f0 extends (0, $8t5Gy.Container) {
    /** The hard limit on the number of tile textures used in each tilemap. */ /**
     * The animation frame vector.
     *
     * Animated tiles have four parameters - `animX`, `animY`, `animCountX`, `animCountY`. The textures
     * of adjacent animation frames are at offset `animX` or `animY` of each other, with `animCountX` per
     * row and `animCountY` per column.
     *
     * The animation frame vector specifies which animation frame texture to use. If the x/y coordinate is
     * larger than the `animCountX` or `animCountY` for a specific tile, the modulus is taken.
     */ __init() {
        this.tileAnim = null;
    }
    /** The last modified tilemap. */ __init2() {
        this.lastModifiedTilemap = null;
    }
    __init3() {
        this.modificationMarker = 0;
    }
    __init4() {
        this.shadowColor = new Float32Array([
            0.0,
            0.0,
            0.0,
            0.5
        ]);
    }
    __init5() {
        this._globalMat = null;
    }
    /**
     * @param tileset - A list of tile base-textures that will be used to eagerly initialized the layered
     *  tilemaps. This is only an performance optimization, and using {@link CompositeTilemap.tile tile}
     *  will work equivalently.
     */ constructor(tileset){
        super();
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init4.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init5.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init6.call(this);
        this.tileset(tileset);
        this.texturesPerTilemap = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTURES_PER_TILEMAP;
    }
    /**
     * This will preinitialize the tilesets of the layered tilemaps.
     *
     * If used after a tilemap has been created (or a tile added), this will overwrite the tile textures of the
     * existing tilemaps. Passing the tileset to the constructor instead is the best practice.
     *
     * @param tileTextures - The list of tile textures that make up the tileset.
     */ tileset(tileTextures) {
        if (!tileTextures) tileTextures = [];
        const texPerChild = this.texturesPerTilemap;
        const len1 = this.children.length;
        const len2 = Math.ceil(tileTextures.length / texPerChild);
        for(let i = 0; i < Math.min(len1, len2); i++)this.children[i].setTileset(tileTextures.slice(i * texPerChild, (i + 1) * texPerChild));
        for(let i = len1; i < len2; i++){
            const tilemap = new $21ba273fabeffbe8$export$f9d4276726476e59(tileTextures.slice(i * texPerChild, (i + 1) * texPerChild));
            tilemap.compositeParent = true;
            tilemap.offsetX = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
            tilemap.offsetY = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
            // TODO: Don't use children
            this.addChild(tilemap);
        }
        return this;
    }
    /** Clears the tilemap composite. */ clear() {
        for(let i = 0; i < this.children.length; i++)this.children[i].clear();
        this.modificationMarker = 0;
        return this;
    }
    /** Changes the rotation of the last added tile. */ tileRotate(rotate) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileRotate(rotate);
        return this;
    }
    /** Changes `animX`, `animCountX` of the last added tile. */ tileAnimX(offset, count) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileAnimX(offset, count);
        return this;
    }
    /** Changes `animY`, `animCountY` of the last added tile. */ tileAnimY(offset, count) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileAnimY(offset, count);
        return this;
    }
    /** Changes `tileAnimDivisor` value of the last added tile. */ tileAnimDivisor(divisor) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileAnimDivisor(divisor);
        return this;
    }
    /**
     * Adds a tile that paints the given tile texture at (x, y).
     *
     * @param tileTexture - The tile texture. You can pass an index into the composite tilemap as well.
     * @param x - The local x-coordinate of the tile's location.
     * @param y - The local y-coordinate of the tile's location.
     * @param options - Additional options to pass to {@link Tilemap.tile}.
     * @param [options.u=texture.frame.x] - The x-coordinate of the texture in its base-texture's space.
     * @param [options.v=texture.frame.y] - The y-coordinate of the texture in its base-texture's space.
     * @param [options.tileWidth=texture.orig.width] - The local width of the tile.
     * @param [options.tileHeight=texture.orig.height] - The local height of the tile.
     * @param [options.animX=0] - For animated tiles, this is the "offset" along the x-axis for adjacent
     *      animation frame textures in the base-texture.
     * @param [options.animY=0] - For animated tiles, this is the "offset" along the y-axis for adjacent
     *      animation frames textures in the base-texture.
     * @param [options.rotate=0]
     * @param [options.animCountX=1024] - For animated tiles, this is the number of animation frame textures
     *      per row.
     * @param [options.animCountY=1024] - For animated tiles, this is the number of animation frame textures
     *      per column.
     * @param [options.animDivisor=1] - For animated tiles, this is the animation duration each frame
     * @param [options.alpha=1] - Tile alpha
     * @return This tilemap, good for chaining.
     */ tile(tileTexture, x, y, options = {}) {
        let tilemap = null;
        const children = this.children;
        this.lastModifiedTilemap = null;
        if (typeof tileTexture === 'number') {
            const childIndex = tileTexture / this.texturesPerTilemap >> 0;
            let tileIndex = 0;
            tilemap = children[childIndex];
            if (!tilemap) {
                tilemap = children[0];
                // Silently fail if the tilemap doesn't exist
                if (!tilemap) return this;
                tileIndex = 0;
            } else tileIndex = tileTexture % this.texturesPerTilemap;
            tilemap.tile(tileIndex, x, y, options);
        } else {
            if (typeof tileTexture === 'string') tileTexture = (0, $klOfb.Texture).from(tileTexture);
            // Probe all tilemaps to find which tileset contains the base-texture.
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                const tex = child.getTileset();
                for(let j = 0; j < tex.length; j++)if (tex[j] === tileTexture.baseTexture) {
                    tilemap = child;
                    break;
                }
                if (tilemap) break;
            }
            // If no tileset contains the base-texture, attempt to add it.
            if (!tilemap) {
                // Probe the tilemaps to find one below capacity. If so, add the texture into that tilemap.
                for(let i = children.length - 1; i >= 0; i--){
                    const child = children[i];
                    if (child.getTileset().length < this.texturesPerTilemap) {
                        tilemap = child;
                        child.getTileset().push(tileTexture.baseTexture);
                        break;
                    }
                }
                // Otherwise, create a new tilemap initialized with that tile texture.
                if (!tilemap) {
                    tilemap = new $21ba273fabeffbe8$export$f9d4276726476e59(tileTexture.baseTexture);
                    tilemap.compositeParent = true;
                    tilemap.offsetX = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
                    tilemap.offsetY = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
                    this.addChild(tilemap);
                }
            }
            tilemap.tile(tileTexture, x, y, options);
        }
        this.lastModifiedTilemap = tilemap;
        return this;
    }
    renderCanvas(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        const tilemapPlugin = $21ba273fabeffbe8$export$adc19050884d1e30.getInstance(renderer);
        if (tilemapPlugin && !tilemapPlugin.dontUseTransform) {
            const wt = this.worldTransform;
            renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
        }
        const layers = this.children;
        for(let i = 0; i < layers.length; i++){
            const layer = layers[i];
            layer.tileAnim = this.tileAnim;
            layer.renderCanvasCore(renderer);
        }
    }
    render(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        const plugin = renderer.plugins.tilemap;
        const shader = plugin.getShader();
        renderer.batch.setObjectRenderer(plugin);
        // TODO: dont create new array, please
        this._globalMat = shader.uniforms.projTransMatrix;
        renderer.globalUniforms.uniforms.projectionMatrix.copyTo(this._globalMat).append(this.worldTransform);
        shader.uniforms.shadowColor = this.shadowColor;
        shader.uniforms.animationFrame = this.tileAnim || plugin.tileAnim;
        renderer.shader.bind(shader, false);
        const layers = this.children;
        for(let i = 0; i < layers.length; i++)layers[i].renderWebGLCore(renderer, plugin);
    }
    /**
     * @internal
     * @ignore
     */ isModified(anim) {
        const layers = this.children;
        if (this.modificationMarker !== layers.length) return true;
        for(let i = 0; i < layers.length; i++){
            if (layers[i].isModified(anim)) return true;
        }
        return false;
    }
    /**
     * @internal
     * @ignore
     */ clearModify() {
        const layers = this.children;
        this.modificationMarker = layers.length;
        for(let i = 0; i < layers.length; i++)layers[i].clearModify();
    }
    /**
     * @deprecated Since @pixi/tilemap 3.
     * @see CompositeTilemap.tile
     */ addFrame(texture, x, y, animX, animY, animWidth, animHeight, animDivisor, alpha) {
        return this.tile(texture, x, y, {
            animX: animX,
            animY: animY,
            animCountX: animWidth,
            animCountY: animHeight,
            animDivisor: animDivisor,
            alpha: alpha
        });
    }
    /**
     * @deprecated @pixi/tilemap 3
     * @see CompositeTilemap.tile
     */ // eslint-disable-next-line max-params
    addRect(textureIndex, u, v, x, y, tileWidth, tileHeight, animX, animY, rotate, animWidth, animHeight) {
        const childIndex = textureIndex / this.texturesPerTilemap >> 0;
        const textureId = textureIndex % this.texturesPerTilemap;
        if (this.children[childIndex] && this.children[childIndex].getTileset()) {
            this.lastModifiedTilemap = this.children[childIndex];
            this.lastModifiedTilemap.addRect(textureId, u, v, x, y, tileWidth, tileHeight, animX, animY, rotate, animWidth, animHeight);
        } else this.lastModifiedTilemap = null;
        return this;
    }
    /**
     * Alias for {@link CompositeTilemap.tileset tileset}.
     *
     * @deprecated Since @pixi/tilemap 3.
     */ __init6() {
        this.setBitmaps = this.tileset;
    }
    /**
     * @deprecated Since @pixi/tilemap 3.
     * @readonly
     * @see CompositeTilemap.texturesPerTilemap
     */ get texPerChild() {
        return this.texturesPerTilemap;
    }
}
// For some reason ESLint goes mad with indendation in this file ^&^
/* eslint-disable indent */ /**
 * This texture tiling resource can be used to upload multiple base-textures together.
 *
 * This resource combines multiple base-textures into a "textile". They're laid out in
 * a dual column format, placed in row-order order. The size of each tile is predefined,
 * and defaults to {@link settings.TEXTILE_DIMEN}. This means that each input base-texture
 * must is smaller than that along both its width and height.
 *
 * @see settings.TEXTILE_UNITS
 */ class $21ba273fabeffbe8$export$b40e6bac0476cdd9 extends (0, $klOfb.Resource) {
    /** The base-texture that contains all the texture tiles. */ __init() {
        this.baseTexture = null;
    }
    __init2() {
        this._clearBuffer = null;
    }
    /**
	 * @param options - This will default to the "settings" exported by @pixi/tilemap.
	 * @param options.TEXTILE_DIMEN - The dimensions of each tile.
	 * @param options.TEXTILE_UNITS - The number of texture tiles.
	 */ constructor(options = $21ba273fabeffbe8$export$a5a6e0b888b2c992){
        super(options.TEXTILE_DIMEN * 2, options.TEXTILE_DIMEN * Math.ceil(options.TEXTILE_UNITS / 2));
        $21ba273fabeffbe8$export$b40e6bac0476cdd9.prototype.__init.call(this);
        $21ba273fabeffbe8$export$b40e6bac0476cdd9.prototype.__init2.call(this);
        const tiles = this.tiles = new Array(options.TEXTILE_UNITS);
        this.doClear = !!options.DO_CLEAR;
        this.tileDimen = options.TEXTILE_DIMEN;
        for(let j = 0; j < options.TEXTILE_UNITS; j++)tiles[j] = {
            dirtyId: 0,
            x: options.TEXTILE_DIMEN * (j & 1),
            y: options.TEXTILE_DIMEN * (j >> 1),
            baseTexture: (0, $klOfb.Texture).WHITE.baseTexture
        };
    }
    /**
	 * Sets the texture to be uploaded for the given tile.
	 *
	 * @param index - The index of the tile being set.
	 * @param texture - The texture with the base-texture to upload.
	 */ tile(index, texture) {
        const tile = this.tiles[index];
        if (tile.baseTexture === texture) return;
        tile.baseTexture = texture;
        this.baseTexture.update();
        this.tiles[index].dirtyId = this.baseTexture.dirtyId;
    }
    /** @override */ bind(baseTexture) {
        if (this.baseTexture) throw new Error('Only one baseTexture is allowed for this resource!');
        this.baseTexture = baseTexture;
        super.bind(baseTexture);
    }
    /** @override */ upload(renderer, texture, glTexture) {
        const { gl: gl } = renderer;
        const { width: width, height: height } = this;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.alphaMode === undefined || texture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        if (glTexture.dirtyId < 0) {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(texture.target, 0, texture.format, width, height, 0, texture.format, texture.type, null);
        }
        const doClear = this.doClear;
        const tiles = this.tiles;
        if (doClear && !this._clearBuffer) this._clearBuffer = new Uint8Array($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN * $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN * 4);
        for(let i = 0; i < tiles.length; i++){
            const spr = tiles[i];
            const tex = spr.baseTexture;
            if (glTexture.dirtyId >= this.tiles[i].dirtyId) continue;
            const res = tex.resource;
            if (!tex.valid || !res || !res.source) continue;
            if (doClear && (tex.width < this.tileDimen || tex.height < this.tileDimen)) gl.texSubImage2D(texture.target, 0, spr.x, spr.y, this.tileDimen, this.tileDimen, texture.format, texture.type, this._clearBuffer);
            gl.texSubImage2D(texture.target, 0, spr.x, spr.y, texture.format, texture.type, res.source);
        }
        return true;
    }
}
/**
 * This will generate fragment shader code that samples the correct texture into the "color" variable.
 *
 * @internal
 * @ignore
 * @param maxTextures - The texture array length in the shader's uniforms.
 */ function $21ba273fabeffbe8$var$generateSampleSrc(maxTextures) {
    let src = '';
    src += '\n';
    src += '\n';
    src += 'if(vTextureId <= -1.0) {';
    src += '\n\tcolor = shadowColor;';
    src += '\n}';
    for(let i = 0; i < maxTextures; i++){
        src += '\nelse ';
        if (i < maxTextures - 1) src += `if(textureId == ${i}.0)`;
        src += '\n{';
        src += `\n\tcolor = texture2D(uSamplers[${i}], textureCoord * uSamplerSize[${i}]);`;
        src += '\n}';
    }
    src += '\n';
    src += '\n';
    return src;
}
/**
 * @internal
 * @ignore
 * @param shader
 * @param maxTextures
 */ function $21ba273fabeffbe8$export$436f73875e9a62fb(shader, maxTextures) {
    const sampleValues = [];
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    shader.uniforms.uSamplers = sampleValues;
    const samplerSize = [];
    for(let i = 0; i < maxTextures; i++){
        // These are overwritten by TileRenderer when textures actually bound.
        samplerSize.push(1.0 / 2048);
        samplerSize.push(1.0 / 2048);
    }
    shader.uniforms.uSamplerSize = samplerSize;
}
/**
 * @internal
 * @ignore
 * @param maxTextures
 * @param fragmentSrc
 * @returns
 */ function $21ba273fabeffbe8$export$2c417c463460549d(maxTextures, fragmentSrc) {
    return fragmentSrc.replace(/%count%/gi, `${maxTextures}`).replace(/%forloop%/gi, $21ba273fabeffbe8$var$generateSampleSrc(maxTextures));
}
// eslint-disable-next-line @typescript-eslint/triple-slash-reference, spaced-comment
const $21ba273fabeffbe8$var$tilemapVertexTemplateSrc = `#version 100
precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aFrame;
attribute vec2 aAnim;
attribute float aAnimDivisor;
attribute float aTextureId;
attribute float aAlpha;

uniform mat3 projTransMatrix;
uniform vec2 animationFrame;

varying vec2 vTextureCoord;
varying float vTextureId;
varying vec4 vFrame;
varying float vAlpha;

void main(void)
{
   gl_Position = vec4((projTransMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vec2 animCount = floor((aAnim + 0.5) / 2048.0);
   vec2 animFrameOffset = aAnim - animCount * 2048.0;
   vec2 currentFrame = floor(animationFrame / aAnimDivisor);
   vec2 animOffset = animFrameOffset * floor(mod(currentFrame + 0.5, animCount));

   vTextureCoord = aTextureCoord + animOffset;
   vFrame = aFrame + vec4(animOffset, animOffset);
   vTextureId = aTextureId;
   vAlpha = aAlpha;
}
`;
const $21ba273fabeffbe8$var$tilemapFragmentTemplateSrc = `#version 100
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec2 vTextureCoord;
varying vec4 vFrame;
varying float vTextureId;
varying float vAlpha;
uniform vec4 shadowColor;
uniform sampler2D uSamplers[%count%];
uniform vec2 uSamplerSize[%count%];

void main(void)
{
   vec2 textureCoord = clamp(vTextureCoord, vFrame.xy, vFrame.zw);
   float textureId = floor(vTextureId + 0.5);

   vec4 color;
   %forloop%
   gl_FragColor = color * vAlpha;
}
`;
// For some reason ESLint goes mad with indendation in this file ^&^
/* eslint-disable no-mixed-spaces-and-tabs, indent */ class $21ba273fabeffbe8$export$6cd4ea578148e7f0 extends (0, $klOfb.Shader) {
    __init() {
        this.maxTextures = 0;
    }
    constructor(maxTextures){
        super(new (0, $klOfb.Program)($21ba273fabeffbe8$var$tilemapVertexTemplateSrc, $21ba273fabeffbe8$export$2c417c463460549d(maxTextures, $21ba273fabeffbe8$var$tilemapFragmentTemplateSrc)), {
            animationFrame: new Float32Array(2),
            uSamplers: [],
            uSamplerSize: [],
            projTransMatrix: new (0, $6qzqq.Matrix)()
        });
        $21ba273fabeffbe8$export$6cd4ea578148e7f0.prototype.__init.call(this);
        this.maxTextures = maxTextures;
        $21ba273fabeffbe8$export$436f73875e9a62fb(this, this.maxTextures);
    }
}
class $21ba273fabeffbe8$export$102165b99c936142 extends (0, $klOfb.Geometry) {
    __init2() {
        this.vertSize = 13;
    }
    __init3() {
        this.vertPerQuad = 4;
    }
    __init4() {
        this.stride = this.vertSize * 4;
    }
    __init5() {
        this.lastTimeAccess = 0;
    }
    constructor(){
        super();
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init4.call(this);
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init5.call(this);
        const buf = this.buf = new (0, $klOfb.Buffer)(new Float32Array(2), true, false);
        this.addAttribute('aVertexPosition', buf, 0, false, 0, this.stride, 0).addAttribute('aTextureCoord', buf, 0, false, 0, this.stride, 8).addAttribute('aFrame', buf, 0, false, 0, this.stride, 16).addAttribute('aAnim', buf, 0, false, 0, this.stride, 32).addAttribute('aTextureId', buf, 0, false, 0, this.stride, 40).addAttribute('aAnimDivisor', buf, 0, false, 0, this.stride, 44).addAttribute('aAlpha', buf, 0, false, 0, this.stride, 48);
    }
}
// For some reason ESLint goes mad with indendation in this file ^&^
/* eslint-disable no-mixed-spaces-and-tabs, indent */ /**
 * Rendering helper pipeline for tilemaps. This plugin is registered automatically.
 */ class $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2 extends (0, $klOfb.ObjectRenderer) {
    /** The managing renderer */ /** The tile animation frame */ __init() {
        this.tileAnim = [
            0,
            0
        ];
    }
    __init2() {
        this.ibLen = 0;
    }
    /** The index buffer for the tilemaps to share. */ __init3() {
        this.indexBuffer = null;
    }
    /** The shader used to render tilemaps. */ /**
	 * {@link TextileResource} instances used to upload textures batched in tiled groups. This is
	 * used only if {@link settings.TEXTURES_PER_TILEMAP} is greater than 1.
	 */ __init4() {
        this.textiles = [];
    }
    /** @param renderer - The managing renderer */ constructor(renderer){
        super(renderer);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init.call(this);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init4.call(this);
        this.shader = new $21ba273fabeffbe8$export$6cd4ea578148e7f0($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTURES_PER_TILEMAP);
        this.indexBuffer = new (0, $klOfb.Buffer)(undefined, true, true);
        this.checkIndexBuffer(2000);
        this.makeTextiles();
    }
    /**
	 * Binds the tile textures to the renderer, and updates the tilemap shader's `uSamplerSize` uniform.
	 *
	 * If {@link settings.TEXTILE_UNITS}
	 *
	 * @param renderer - The renderer to which the textures are to be bound.
	 * @param textures - The tile textures being bound.
	 */ bindTileTextures(renderer, textures) {
        const len = textures.length;
        const shader = this.shader;
        const maxTextures = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTURES_PER_TILEMAP;
        const samplerSize = shader.uniforms.uSamplerSize;
        if (len > $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS * maxTextures) // TODO: Show error message instead of silently failing!
        return;
        if ($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS <= 1) // Bind each texture directly & update samplerSize.
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (!texture || !texture.valid) return;
            renderer.texture.bind(textures[i], i);
            samplerSize[i * 2] = 1.0 / textures[i].realWidth;
            samplerSize[i * 2 + 1] = 1.0 / textures[i].realHeight;
        }
        else {
            // Ensure we have enough textiles, in case settings.TEXTILE_UNITS was modified.
            this.makeTextiles();
            const usedTextiles = Math.ceil(len / $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS);
            // First ensure each textile has all tiles point to the right textures.
            for(let i = 0; i < len; i++){
                const texture = textures[i];
                if (texture && texture.valid) {
                    const resourceIndex = Math.floor(i / $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS);
                    const tileIndex = i % $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS;
                    this.textiles[resourceIndex].tile(tileIndex, texture);
                }
            }
            // Then bind the textiles + update samplerSize.
            for(let i = 0; i < usedTextiles; i++){
                renderer.texture.bind(this.textiles[i].baseTexture, i);
                samplerSize[i * 2] = 1.0 / this.textiles[i].width;
                samplerSize[i * 2 + 1] = 1.0 / this.textiles[i].baseTexture.height;
            }
        }
        shader.uniforms.uSamplerSize = samplerSize;
    }
    start() {
    // sorry, nothing
    }
    /**
	 * @internal
	 * @ignore
	 */ createVb() {
        const geom = new $21ba273fabeffbe8$export$102165b99c936142();
        geom.addIndex(this.indexBuffer);
        geom.lastTimeAccess = Date.now();
        return geom;
    }
    /** @return The {@link TilemapShader} shader that this rendering pipeline is using. */ getShader() {
        return this.shader;
    }
    destroy() {
        super.destroy();
        // this.rectShader.destroy();
        this.shader = null;
    }
    checkIndexBuffer(size, _vb = null) {
        const totalIndices = size * 6;
        if (totalIndices <= this.ibLen) return;
        this.ibLen = totalIndices;
        this.indexBuffer.update((0, $csytw.createIndicesForQuads)(size, $21ba273fabeffbe8$export$a5a6e0b888b2c992.use32bitIndex ? new Uint32Array(size * 6) : undefined));
    // 	TODO: create new index buffer instead?
    // if (vb) {
    // 	const curIndex = vb.getIndex();
    // 	if (curIndex !== this.indexBuffer && (curIndex.data as any).length < totalIndices) {
    // 		this.swapIndex(vb, this.indexBuffer);
    // 	}
    // }
    }
    /** Makes textile resources and initializes {@link TileRenderer.textiles}. */ makeTextiles() {
        if ($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS <= 1) return;
        for(let i = 0; i < $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS; i++){
            if (this.textiles[i]) continue;
            const resource = new $21ba273fabeffbe8$export$b40e6bac0476cdd9();
            const baseTex = new (0, $klOfb.BaseTexture)(resource);
            baseTex.scaleMode = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_SCALE_MODE;
            baseTex.wrapMode = (0, $P8XPi.WRAP_MODES).CLAMP;
            this.textiles[i] = resource;
        }
    }
}
// eslint-disable-next-line camelcase
const $21ba273fabeffbe8$export$6fd503dcb5b4d46c = {
    CanvasTileRenderer: $21ba273fabeffbe8$export$adc19050884d1e30,
    CompositeRectTileLayer: $21ba273fabeffbe8$export$8f858bd4088571f0,
    CompositeTilemap: $21ba273fabeffbe8$export$8f858bd4088571f0,
    Constant: $21ba273fabeffbe8$export$3c508fb3f8ac1ad4,
    TextileResource: $21ba273fabeffbe8$export$b40e6bac0476cdd9,
    MultiTextureResource: $21ba273fabeffbe8$export$b40e6bac0476cdd9,
    RectTileLayer: $21ba273fabeffbe8$export$f9d4276726476e59,
    Tilemap: $21ba273fabeffbe8$export$f9d4276726476e59,
    TilemapShader: $21ba273fabeffbe8$export$6cd4ea578148e7f0,
    TilemapGeometry: $21ba273fabeffbe8$export$102165b99c936142,
    RectTileShader: $21ba273fabeffbe8$export$6cd4ea578148e7f0,
    RectTileGeom: $21ba273fabeffbe8$export$102165b99c936142,
    TileRenderer: $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2
};
(0, $klOfb.Renderer).registerPlugin('tilemap', $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2);




parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");

var $5UG8I = parcelRequire("5UG8I");
parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
class $30804d8d8c7ac29a$export$d2b760035f8f14b9 {
    static{
        this.DEFAULT_OUTLINE_CONFIG = {
            thickness: 0.8,
            color: 0x1a1a1a,
            alpha: 0.7,
            enabled: true
        };
    }
    static{
        this.DEFAULT_SCUFF_CONFIG = {
            enabled: true,
            count: 3,
            color: 0xff00ff,
            alpha: 0.8,
            minSize: 0.05,
            maxSize: 0.15,
            roughness: 0.7
        };
    }
    static{
        this.DEFAULT_DENT_CONFIG = {
            enabled: true,
            count: 2,
            color: 0x1a1a1a,
            alpha: 0.4,
            minSize: 0.08,
            maxSize: 0.2,
            depth: 0.6
        };
    }
    static{
        // Make cache persistent across rooms
        this.GLOBAL_DAMAGED_SPRITES_CACHE = new Map();
    }
    static{
        this.maxGlobalCacheSize = 5000 // Global cache size limit
        ;
    }
    static{
        this.cacheHits = 0;
    }
    static{
        this.cacheMisses = 0;
    }
    constructor(roomId, randomNumberGenerator){
        this.outlineConfig = {
            ...$30804d8d8c7ac29a$export$d2b760035f8f14b9.DEFAULT_OUTLINE_CONFIG
        };
        this.scuffConfig = {
            ...$30804d8d8c7ac29a$export$d2b760035f8f14b9.DEFAULT_SCUFF_CONFIG
        };
        this.dentConfig = {
            ...$30804d8d8c7ac29a$export$d2b760035f8f14b9.DEFAULT_DENT_CONFIG
        };
        this.rngCache = new Map();
        // Cache original textures by x,y coordinates to enable incremental damage (room-specific)
        this.originalTexturesByLocation = new Map();
        /**
     * Update the random number generator and room context
     * Only clear room-specific caches, keep global damage cache
     */ this.updateRandomContext = (roomId, randomNumberGenerator)=>{
            this.roomId = roomId;
            this.randomNumberGenerator = randomNumberGenerator;
            this.rngCache.clear();
            this.originalTexturesByLocation.clear() // Clear room-specific texture cache
            ;
        // DON'T clear the global damaged sprites cache - keep it persistent!
        };
        /**
     * Cache original textures by x,y location for incremental damage
     */ this.cacheOriginalTexturesByLocation = (sprites, x, y)=>{
            const locationKey = `${this.roomId}-${x},${y}`;
            // Only cache if not already cached to avoid overwriting
            if (!this.originalTexturesByLocation.has(locationKey)) {
                const originalTextures = sprites.map((sprite)=>sprite.texture);
                this.originalTexturesByLocation.set(locationKey, originalTextures);
            }
        };
        /**
     * Configure hole outline appearance
     */ this.configureHoleOutlines = (config)=>{
            this.outlineConfig = {
                ...this.outlineConfig,
                ...config
            };
        };
        /**
     * Enable or disable hole outlines
     */ this.setHoleOutlinesEnabled = (enabled)=>{
            this.outlineConfig.enabled = enabled;
        };
        /**
     * Get current hole outline configuration
     */ this.getHoleOutlineConfig = ()=>{
            return {
                ...this.outlineConfig
            };
        };
        /**
     * Configure scuff mark appearance
     */ this.configureScuffMarks = (config)=>{
            this.scuffConfig = {
                ...this.scuffConfig,
                ...config
            };
        };
        /**
     * Enable or disable scuff marks
     */ this.setScuffMarksEnabled = (enabled)=>{
            this.scuffConfig.enabled = enabled;
        };
        /**
     * Get current scuff mark configuration
     */ this.getScuffMarkConfig = ()=>{
            return {
                ...this.scuffConfig
            };
        };
        /**
     * Configure dent appearance
     */ this.configureDents = (config)=>{
            this.dentConfig = {
                ...this.dentConfig,
                ...config
            };
        };
        /**
     * Enable or disable dents
     */ this.setDentsEnabled = (enabled)=>{
            this.dentConfig.enabled = enabled;
        };
        /**
     * Get current dent configuration
     */ this.getDentConfig = ()=>{
            return {
                ...this.dentConfig
            };
        };
        /**
     * Normalize damage percentage to nearest 5%
     */ this.normalizeDamagePct = (damagePct)=>{
            return Math.round(damagePct * 20) / 20 // Round to nearest 5%
            ;
        };
        /**
     * Create cache key that's room-agnostic for global cache
     */ this.createGlobalCacheKey = (surfaceObject, normalizedDamagePct)=>{
            // The cached value is the ENTIRE spriteSet, re-applied to sprites by positional index
            // on a hit. So the key must uniquely identify the full per-sprite composition, not just
            // one surface-level tile id. A vertical wall is two sprites (cap + base) that share a
            // single parent -- surfaceObject.tilesetTileId only records the BASE tile, so keying on
            // it alone made every wall with the same base tile collide regardless of its cap or
            // sprite ordering. On a hit, cap and base textures were then stamped by index onto a
            // differently-composed wall, making the base cell render as a cap. Build the key from
            // each sprite's own texture identity, in order, so a collision guarantees an identical
            // composition and the by-index texture copy is always correct.
            const spriteKey = (surfaceObject.spriteSet || []).map((sprite)=>{
                const texture = sprite?.texture;
                if (!texture) return "x";
                const id = texture.textureCacheIds && texture.textureCacheIds.length ? texture.textureCacheIds[0] : `${texture.baseTexture?.uid}`;
                const frame = texture.frame ? `${texture.frame.x},${texture.frame.y},${texture.frame.width},${texture.frame.height}` : "";
                return `${id}:${frame}`;
            }).join("|");
            // Room-agnostic key for global cache
            return `${spriteKey}-${normalizedDamagePct}`;
        };
        /**
     * Generate dynamic holes, scuff marks, and dents on sprites based on damage percentage
     * Now accepts SurfaceObject for better caching and tile identification
     *
     * @param surfaceObject - SurfaceObject containing sprites and tile information
     * @param options - Configuration options including damage percentage and effect configs
     *
     * Example usage:
     * ```typescript
     * const holeEffect = new HoleEffect(roomId, randomNumberGenerator);
     *
     * // Configure scuff marks
     * holeEffect.configureScuffMarks({
     *   enabled: true,
     *   count: 5,
     *   color: 0x333333,
     *   alpha: 0.7,
     *   minSize: 0.08,
     *   maxSize: 0.20,
     *   roughness: 0.8
     * });
     *
     * // Configure dents
     * holeEffect.configureDents({
     *   enabled: true,
     *   count: 3,
     *   color: 0x1a1a1a,
     *   alpha: 0.5,
     *   minSize: 0.10,
     *   maxSize: 0.25,
     *   depth: 0.7
     * });
     *
     * // Apply effects
     * holeEffect.generateDynamicHoles(surfaceObject, {
     *   damagePct: 0.5, // 50% damage
     *   x: 100,
     *   y: 100,
     *   scuffConfig: { count: 4, roughness: 0.9 },
     *   dentConfig: { count: 2, depth: 0.8 }
     * });
     * ```
     */ this.generateDynamicHoles = (surfaceObject, options)=>{
            const { damagePct: damagePct, x: x, y: y, outlineConfig: outlineConfig, scuffConfig: scuffConfig, dentConfig: dentConfig } = options;
            // This can run deferred (a shake's onComplete, or applyDamageVisualizationToExistingTiles after a
            // full rerender). In between, a concurrent full rerender / incremental repaint can have destroyed
            // this surface's sprites -- reading `.x` (generateAndCacheDamagedSprites) or `.texture`
            // (createSpriteCanvas) on a destroyed sprite (transform null) throws. Prune to live sprites in
            // place so the cache key and the per-index texture copy stay consistent, then bail if none remain.
            if (surfaceObject.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && s.transform);
            // Sprites are already in correct Y-order from processSurfaceId insertion
            const sprites = surfaceObject.spriteSet;
            if (!sprites || sprites.length === 0) return;
            // Apply configs if provided
            if (outlineConfig) this.configureHoleOutlines(outlineConfig);
            if (scuffConfig) this.configureScuffMarks(scuffConfig);
            if (dentConfig) this.configureDents(dentConfig);
            // Normalize damage to nearest 5%
            const normalizedDamagePct = this.normalizeDamagePct(damagePct);
            // Check global cache first (room-agnostic)
            const globalCacheKey = this.createGlobalCacheKey(surfaceObject, normalizedDamagePct);
            const cachedDamagedSprites = $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.get(globalCacheKey);
            if (cachedDamagedSprites) {
                $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits++;
                // Use cached sprites - just copy the textures
                sprites.forEach((sprite, index)=>{
                    if (cachedDamagedSprites[index]) sprite.texture = cachedDamagedSprites[index].texture;
                });
                return;
            }
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses++;
            // Generate new damaged sprites and cache them globally
            const damagedSprites = this.generateAndCacheDamagedSprites(surfaceObject, normalizedDamagePct, globalCacheKey);
            // Apply the damaged textures to the input sprites
            sprites.forEach((sprite, index)=>{
                if (damagedSprites[index]) sprite.texture = damagedSprites[index].texture;
            });
        };
        /**
     * Generate and cache damaged sprites for global reuse
     */ this.generateAndCacheDamagedSprites = (surfaceObject, normalizedDamagePct, globalCacheKey)=>{
            const sprites = surfaceObject.spriteSet;
            // Create copies of the original sprites for caching
            const damagedSprites = sprites.map((sprite)=>{
                const copy = new (0, $7Bs2Z.Sprite)(sprite.texture);
                copy.x = sprite.x;
                copy.y = sprite.y;
                copy.zIndex = sprite.zIndex;
                return copy;
            });
            // Apply damage effects to the copies using the original incremental method
            this.applyDamageToSprites(damagedSprites, normalizedDamagePct, 0, 0);
            // Cache the damaged sprites globally
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.set(globalCacheKey, damagedSprites);
            // Manage cache size
            this.evictOldestGlobalCache();
            return damagedSprites;
        };
        /**
     * Apply damage effects to sprites (extracted from original generateDynamicHoles logic)
     */ this.applyDamageToSprites = (sprites, damagePct, x, y)=>{
            // Apply damage incrementally from 10% to current damage level
            const currentDamageStep = Math.floor(damagePct * 20) / 20 // Round to nearest 5%
            ;
            const maxDamageStep = Math.max(0.1, currentDamageStep) // Start from 10% minimum
            ;
            // Build ONE canvas per sprite up front. Every hole/scuff/dent for that sprite is drawn
            // onto this single canvas and uploaded as a single texture at the end. This replaces the
            // previous approach that allocated a fresh canvas, ran a full-canvas getImageData()
            // readback (a synchronous GPU->CPU stall) and a Texture.from() upload for EVERY individual
            // mark -- the dominant cost of this path on low-end/integrated GPUs.
            const canvases = sprites.map((sprite)=>this.createSpriteCanvas(sprite));
            // Walk up by 10% damage increments up to current damage
            for(let stepDamage = 0.1; stepDamage <= maxDamageStep; stepDamage += 0.1){
                const stepDamagePct = Math.min(stepDamage, maxDamageStep);
                // Generate holes for this damage step
                const numHoles = Math.floor(stepDamagePct * 8) + 1 // 1-17 holes based on damage
                ;
                // Distribute holes evenly across all sprites in the set
                const holesPerSprite = Math.max(1, Math.floor(numHoles / sprites.length));
                const remainingHoles = numHoles - holesPerSprite * sprites.length;
                for(let spriteIndex = 0; spriteIndex < sprites.length; spriteIndex++){
                    const dc = canvases[spriteIndex];
                    if (!dc) continue;
                    const holesForThisSprite = holesPerSprite + (spriteIndex < remainingHoles ? 1 : 0);
                    // Create holes for this damage step
                    for(let i = 0; i < holesForThisSprite; i++)this.createHoleInSprite(dc, stepDamagePct, x, y, spriteIndex, i);
                    // Add scuff marks and dents for this damage step
                    this.addScuffMarksToSprite(dc, stepDamagePct, x, y, spriteIndex);
                    this.addDentsToSprite(dc, stepDamagePct, x, y, spriteIndex);
                }
            }
            // Upload each modified canvas as a single texture (one GPU upload per sprite).
            sprites.forEach((sprite, index)=>{
                const dc = canvases[index];
                if (dc) sprite.texture = (0, $klOfb.Texture).from(dc.canvas);
            });
        };
        /**
     * Build a scratch canvas seeded with the sprite's original texture. All damage marks for
     * the sprite are drawn onto this one canvas; marks that must stay within the sprite's opaque
     * silhouette use the "source-atop" composite op rather than a per-pixel getImageData mask.
     */ this.createSpriteCanvas = (sprite)=>{
            try {
                const texture = sprite.texture;
                const baseTexture = texture.baseTexture;
                const imageSource = baseTexture.resource?.source;
                if (!imageSource) {
                    console.warn("Cannot access image source for texture manipulation");
                    return null;
                }
                const canvas = document.createElement("canvas");
                canvas.width = texture.width;
                canvas.height = texture.height;
                const ctx = canvas.getContext("2d");
                // Draw the original texture to canvas using the frame coordinates
                const frame = texture.frame;
                ctx.drawImage(imageSource, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height);
                return {
                    canvas: canvas,
                    ctx: ctx,
                    width: frame.width,
                    height: frame.height
                };
            } catch (error) {
                console.warn("Failed to create sprite canvas:", error);
                return null;
            }
        };
        /**
     * Convenience method that matches MapRenderingManager's interface
     * @param surfaceObject - SurfaceObject containing sprites and tile information
     * @param hpPct - Health percentage (0-1, where 1 is full health)
     * @param x - X coordinate for seeded randomness
     * @param y - Y coordinate for seeded randomness
     */ this.generateDynamicHolesFromHp = (surfaceObject, hpPct, x, y)=>{
            const damagePct = 1.0 - hpPct;
            this.generateDynamicHoles(surfaceObject, {
                damagePct: damagePct,
                x: x,
                y: y
            });
        };
        /**
     * Create a single hole in a sprite
     */ this.createHoleInSprite = (dc, damagePct, x, y, spriteIndex, holeIndex)=>{
            // Use texture frame dimensions (not full texture) for hole positioning
            const textureWidth = dc.width;
            const textureHeight = dc.height;
            const holeSize = Math.min(textureWidth, textureHeight) * (0.09 + damagePct * 0.12 // 9-21% of texture size (50% larger holes)
            );
            // Position hole randomly across the frame area, but keep it within bounds
            const maxRadius = Math.min(holeSize, textureWidth, textureHeight) / 2;
            // Use seeded randomness for consistent positioning
            const centerX = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureWidth - maxRadius), `hole-center-x-${spriteIndex}-${holeIndex}-${x}-${y}`);
            const centerY = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureHeight - maxRadius), `hole-center-y-${spriteIndex}-${holeIndex}-${x}-${y}`);
            const sides = 3 + this.randomIntBetweenRng(0, 5, `hole-sides-${spriteIndex}-${holeIndex}-${x}-${y}`) // 3-5 sides
            ;
            const radius = holeSize * (0.4 + this.randomIntBetweenRng(0, 60, `hole-radius-${spriteIndex}-${holeIndex}-${x}-${y}`) / 100 // 40-100% of hole size
            );
            // Generate polygon points for the hole using seeded randomness
            const points = [];
            for(let j = 0; j < sides; j++){
                // Use seeded randomness for angles and radii
                const baseAngle = j / sides * Math.PI * 2;
                const angleVariation = this.randomIntBetweenRng(-50, 50, `hole-angle-${spriteIndex}-${holeIndex}-${j}-${x}-${y}`) / 100 * Math.PI;
                const angle = baseAngle + angleVariation;
                const pointRadius = radius * (0.5 + this.randomIntBetweenRng(0, 50, `hole-point-radius-${spriteIndex}-${holeIndex}-${j}-${x}-${y}`) / 100 // 50-100% of radius
                );
                const pointX = Math.max(0, Math.min(textureWidth - 1, centerX + Math.cos(angle) * pointRadius));
                const pointY = Math.max(0, Math.min(textureHeight - 1, centerY + Math.sin(angle) * pointRadius));
                points.push(pointX, pointY);
            }
            // Cut the hole into the shared canvas (also draws the outline)
            this.cutHoleOnCtx(dc.ctx, points);
        };
        /**
     * Add scuff marks to a sprite
     */ this.addScuffMarksToSprite = (dc, damagePct, x, y, spriteIndex)=>{
            if (!this.scuffConfig.enabled) return;
            // Calculate number of scuffs based on damage
            const scuffCount = Math.floor(this.scuffConfig.count * (0.5 + damagePct * 0.5)) // 50-100% of base count
            ;
            for(let i = 0; i < scuffCount; i++)this.createScuffMarkInSprite(dc, damagePct, x, y, spriteIndex, i);
        };
        /**
     * Create a single scuff mark in a sprite
     */ this.createScuffMarkInSprite = (dc, damagePct, x, y, spriteIndex, scuffIndex)=>{
            const textureWidth = dc.width;
            const textureHeight = dc.height;
            // Calculate scuff size based on damage and config
            const baseSize = textureWidth * (this.scuffConfig.minSize + damagePct * (this.scuffConfig.maxSize - this.scuffConfig.minSize));
            const scuffSize = baseSize * (0.8 + this.randomIntBetweenRng(0, 40, `scuff-size-${spriteIndex}-${scuffIndex}-${x}-${y}`) / 100 // 80-120% of base size
            );
            // Position scuff randomly across the frame area
            const maxRadius = scuffSize / 2;
            const centerX = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureWidth - maxRadius), `scuff-center-x-${spriteIndex}-${scuffIndex}-${x}-${y}`);
            const centerY = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureHeight - maxRadius), `scuff-center-y-${spriteIndex}-${scuffIndex}-${x}-${y}`);
            // Generate scuff as radial crack pattern with more randomness
            const crackRadius = scuffSize * (0.3 + this.randomIntBetweenRng(0, 40, `crack-radius-${spriteIndex}-${scuffIndex}-${x}-${y}`) / 100 // 30-70% of scuff size
            );
            const crackCount = 3 + this.randomIntBetweenRng(0, 4, `crack-count-${spriteIndex}-${scuffIndex}-${x}-${y}`) // 3-7 cracks
            ;
            // Draw scuff mark onto the shared canvas
            this.drawScuffMarkOnCtx(dc.ctx, centerX, centerY, crackRadius, crackCount, spriteIndex, scuffIndex, x, y);
        };
        /**
     * Add dents to a sprite
     */ this.addDentsToSprite = (dc, damagePct, x, y, spriteIndex)=>{
            if (!this.dentConfig.enabled) return;
            // Calculate number of dents based on damage
            const dentCount = Math.floor(this.dentConfig.count * (0.3 + damagePct * 0.7)) // 30-100% of base count
            ;
            for(let i = 0; i < dentCount; i++)this.createDentInSprite(dc, damagePct, x, y, spriteIndex, i);
        };
        /**
     * Create a single dent in a sprite
     */ this.createDentInSprite = (dc, damagePct, x, y, spriteIndex, dentIndex)=>{
            const textureWidth = dc.width;
            const textureHeight = dc.height;
            // Calculate dent size based on damage and config
            const baseSize = textureWidth * (this.dentConfig.minSize + damagePct * (this.dentConfig.maxSize - this.dentConfig.minSize));
            const dentSize = baseSize * (0.7 + this.randomIntBetweenRng(0, 60, `dent-size-${spriteIndex}-${dentIndex}-${x}-${y}`) / 100 // 70-130% of base size
            );
            // Position dent randomly across the frame area
            const maxRadius = dentSize / 2;
            const centerX = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureWidth - maxRadius), `dent-center-x-${spriteIndex}-${dentIndex}-${x}-${y}`);
            const centerY = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureHeight - maxRadius), `dent-center-y-${spriteIndex}-${dentIndex}-${x}-${y}`);
            // Generate dent shape (oval with shadow effect)
            const points = this.generateDentShape(centerX, centerY, dentSize, spriteIndex, dentIndex, x, y, textureWidth, textureHeight);
            // Draw dent onto the shared canvas
            this.drawDentOnCtx(dc.ctx, points, centerX, centerY, dentSize);
        };
        /**
     * Generate dent shape points (oval)
     */ this.generateDentShape = (centerX, centerY, size, spriteIndex, dentIndex, x, y, textureWidth, textureHeight)=>{
            const points = [];
            const segments = 16;
            const radiusX = size * 0.4 // 40% of size for width
            ;
            const radiusY = size * 0.3 // 30% of size for height
            ;
            // Generate oval points
            for(let i = 0; i <= segments; i++){
                const angle = i / segments * Math.PI * 2;
                const pointX = centerX + Math.cos(angle) * radiusX;
                const pointY = centerY + Math.sin(angle) * radiusY;
                points.push(Math.max(0, Math.min(textureWidth - 1, pointX)), Math.max(0, Math.min(textureHeight - 1, pointY)));
            }
            return points;
        };
        /**
     * Cut a hole into the shared canvas and stroke its outline.
     *
     * The outline is drawn with the "source-atop" composite op so it only lands on pixels that
     * are still opaque -- this reproduces the old "mask the outline by the sprite's alpha" result
     * without the getImageData/putImageData readback + per-pixel JS loop it used to require.
     */ this.cutHoleOnCtx = (ctx, holePoints)=>{
            try {
                const buildPath = ()=>{
                    ctx.beginPath();
                    ctx.moveTo(holePoints[0], holePoints[1]);
                    for(let i = 2; i < holePoints.length; i += 2)ctx.lineTo(holePoints[i], holePoints[i + 1]);
                    ctx.closePath();
                };
                // Cut out the hole.
                ctx.save();
                ctx.globalCompositeOperation = "destination-out";
                buildPath();
                ctx.fill();
                ctx.restore();
                // Draw the outline, clipped to the remaining opaque silhouette.
                if (this.outlineConfig.enabled) {
                    ctx.save();
                    ctx.globalCompositeOperation = "source-atop";
                    ctx.strokeStyle = `rgba(${this.getColorComponents(this.outlineConfig.color)}, ${this.outlineConfig.alpha})`;
                    ctx.lineWidth = this.outlineConfig.thickness;
                    ctx.lineCap = "round";
                    ctx.lineJoin = "round";
                    buildPath();
                    ctx.stroke();
                    ctx.restore();
                }
            } catch (error) {
                console.warn("Failed to cut hole on canvas:", error);
            }
        };
        /**
     * Draw a scuff mark (radial cracks) directly onto the shared canvas.
     *
     * Uses "source-atop" so the cracks are clipped to the sprite's opaque silhouette -- the same
     * result the old per-pixel alpha mask produced, minus the getImageData readback + temp canvas.
     */ this.drawScuffMarkOnCtx = (ctx, centerX, centerY, crackRadius, crackCount, spriteIndex, scuffIndex, x, y)=>{
            try {
                ctx.save();
                ctx.globalCompositeOperation = "source-atop";
                ctx.strokeStyle = `rgba(${this.getColorComponents(this.scuffConfig.color)}, ${this.scuffConfig.alpha})`;
                ctx.lineWidth = 1.5;
                ctx.lineCap = "round";
                ctx.lineJoin = "round";
                // Draw radial cracks from center point
                for(let i = 0; i < crackCount; i++){
                    // Calculate angle for this crack with more randomness
                    const baseAngle = i / crackCount * Math.PI * 2;
                    // Add more randomness to the angle using seeded RNG instead of Date.now()
                    const angleVariation = this.randomIntBetweenRng(-60, 60, `crack-angle-${spriteIndex}-${scuffIndex}-${i}-${x}-${y}`) / 100 * Math.PI;
                    const angle = baseAngle + angleVariation;
                    // Calculate crack length (with more variation) using seeded RNG instead of Date.now()
                    const crackLength = crackRadius * (0.4 + this.randomIntBetweenRng(0, 120, `crack-length-${spriteIndex}-${scuffIndex}-${i}-${x}-${y}`) / 100 // 40-160% of radius
                    );
                    // Calculate end point
                    const endX = centerX + Math.cos(angle) * crackLength;
                    const endY = centerY + Math.sin(angle) * crackLength;
                    // Draw the crack line
                    ctx.beginPath();
                    ctx.moveTo(centerX, centerY);
                    ctx.lineTo(endX, endY);
                    ctx.stroke();
                }
                ctx.restore();
            } catch (error) {
                console.warn("Failed to draw scuff mark on canvas:", error);
            }
        };
        /**
     * Draw a dent (radial shadow gradient + subtle outline) directly onto the shared canvas.
     *
     * Uses "source-atop" so the dent is clipped to the sprite's opaque silhouette -- the same
     * result the old per-pixel alpha mask produced, minus the getImageData readback + temp canvas.
     */ this.drawDentOnCtx = (ctx, dentPoints, centerX, centerY, dentSize)=>{
            try {
                ctx.save();
                ctx.globalCompositeOperation = "source-atop";
                // Create shadow gradient for dent effect
                const gradient = ctx.createRadialGradient(centerX - dentSize * 0.1, centerY - dentSize * 0.1, 0, centerX, centerY, dentSize * 0.5);
                gradient.addColorStop(0, `rgba(${this.getColorComponents(this.dentConfig.color)}, ${this.dentConfig.alpha * this.dentConfig.depth})`);
                gradient.addColorStop(1, `rgba(${this.getColorComponents(this.dentConfig.color)}, 0)`);
                // Build the dent path once, reused for fill + stroke
                ctx.beginPath();
                ctx.moveTo(dentPoints[0], dentPoints[1]);
                for(let i = 2; i < dentPoints.length; i += 2)ctx.lineTo(dentPoints[i], dentPoints[i + 1]);
                ctx.closePath();
                // Draw the dent shadow
                ctx.fillStyle = gradient;
                ctx.fill();
                // Add a subtle outline
                ctx.strokeStyle = `rgba(${this.getColorComponents(this.dentConfig.color)}, ${this.dentConfig.alpha * 0.8})`;
                ctx.lineWidth = 1;
                ctx.lineCap = "round";
                ctx.lineJoin = "round";
                ctx.stroke();
                ctx.restore();
            } catch (error) {
                console.warn("Failed to draw dent on canvas:", error);
            }
        };
        /**
     * Convert color number to RGB components string
     */ this.getColorComponents = (color)=>{
            const r = color >> 16 & 0xff;
            const g = color >> 8 & 0xff;
            const b = color & 0xff;
            return `${r}, ${g}, ${b}`;
        };
        /**
     * Generate random integer between min and max using seeded randomness
     * This matches the exact same format as MapRenderingManager.randomIntBetweenRng
     */ this.randomIntBetweenRng = (min, max, seed)=>{
            let randomFloat;
            if (!seed) randomFloat = this.randomNumberGenerator ? this.randomNumberGenerator() : Math.random();
            else {
                const toUse = `${seed}-${min}-${max}-${this.roomId}`;
                randomFloat = this.rngCache.get(toUse);
                if (randomFloat === undefined) {
                    randomFloat = this.randomNumberGenerator ? this.randomNumberGenerator() : Math.random();
                    this.rngCache.set(toUse, randomFloat);
                }
            }
            return Math.floor(randomFloat * (max - min + 1) + min);
        };
        /**
     * Evict oldest entries from global cache when it gets too large
     */ this.evictOldestGlobalCache = ()=>{
            if ($30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.size > $30804d8d8c7ac29a$export$d2b760035f8f14b9.maxGlobalCacheSize) {
                // Remove oldest entries (Map maintains insertion order)
                const entriesToRemove = $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.size - $30804d8d8c7ac29a$export$d2b760035f8f14b9.maxGlobalCacheSize;
                const keysToRemove = Array.from($30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.keys()).slice(0, entriesToRemove);
                keysToRemove.forEach((key)=>{
                    const sprites = $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.get(key);
                    if (sprites) sprites.forEach((sprite)=>sprite.destroy());
                    $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.delete(key);
                });
            }
        };
        this.roomId = roomId;
        this.randomNumberGenerator = randomNumberGenerator;
    }
    /**
     * Flush the texture cache (useful when full map rerender starts)
     */ flushCache() {
        this.originalTexturesByLocation.clear();
    }
    static{
        /**
     * Get cache statistics
     */ this.getCacheStats = ()=>{
            const total = $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits + $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses;
            return {
                hits: $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits,
                misses: $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses,
                size: $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.size,
                hitRate: total > 0 ? $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits / total : 0
            };
        };
    }
    static{
        /**
     * Clear global cache (useful for memory management or testing)
     */ this.clearGlobalCache = ()=>{
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.forEach((sprites)=>{
                sprites.forEach((sprite)=>sprite.destroy());
            });
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.clear();
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits = 0;
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses = 0;
        };
    }
    /**
     * Clean up resources (only clear room-specific caches)
     */ destroy() {
        this.rngCache.clear();
        this.originalTexturesByLocation.clear();
    // DON'T clear global cache - it's shared across instances
    }
}


parcelRequire("1avo5");
var $hnGDn = parcelRequire("hnGDn");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $3YyWq = parcelRequire("3YyWq");
var $gwPoJ = parcelRequire("gwPoJ");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");


// Helper function for random float values
const $680de7ed15411c91$var$randomFloatBetween = (min, max)=>{
    return Math.random() * (max - min) + min;
};
// All FragmentEffects share ONE Ticker.shared callback rather than each registering their own.
// Cutting several trees at once previously added one ticker callback per effect, each looping its
// own animator array; now a single callback fans out to every active effect once per frame.
const $680de7ed15411c91$var$activeEffects = new Set();
let $680de7ed15411c91$var$sharedTickerAdded = false;
// Hard cap on simultaneous effects. Destroying a whole cluster of trees/walls in one frame used to
// spawn an unbounded burst of sprites+textures and stutter budget machines; past this many active
// effects we simply skip the visual rather than let the allocation storm tank the frame rate.
const $680de7ed15411c91$var$MAX_ACTIVE_EFFECTS = 12;
const $680de7ed15411c91$var$sharedTick = ()=>{
    const now = Date.now();
    $680de7ed15411c91$var$activeEffects.forEach((effect)=>effect.step(now));
};
const $680de7ed15411c91$var$ensureSharedTicker = ()=>{
    if (!$680de7ed15411c91$var$sharedTickerAdded) {
        (0, $3YyWq.Ticker).shared.add($680de7ed15411c91$var$sharedTick);
        $680de7ed15411c91$var$sharedTickerAdded = true;
    }
};
class $680de7ed15411c91$export$e2a711ce70ac9a4 {
    constructor(parent){
        this.pooledItems = [];
        this.dustItems = [];
        // All particles for this effect are driven by ONE shared-ticker callback rather
        // than a setInterval per particle. Each tree cut previously started ~16-24
        // independent setInterval(16ms) timers (one per fragment + one per dust particle,
        // plus a nested fade timer per fragment). Those timers fire off the render frame
        // and pile up when several trees are cut in quick succession -- the stutter you see
        // when the splinter animation plays. Ticker.shared is rAF-driven, so every particle
        // now updates exactly once per rendered frame with a single timer for the whole effect.
        this.animators = [];
        this.started = false;
        this.released = false;
        this.parent = parent;
        this.surface = new (0, $gwPoJ.Graphics)();
        this.surface.scale.set(1.0);
        this.parent.addChild(this.surface);
    }
    createEffect(texture, x, y, options = {}) {
        // Drop the effect entirely if we're already saturated -- see MAX_ACTIVE_EFFECTS.
        if ($680de7ed15411c91$var$activeEffects.size >= $680de7ed15411c91$var$MAX_ACTIVE_EFFECTS) {
            this.cleanup();
            return;
        }
        const { fragmentCount: fragmentCount = 32, duration: duration = 1000, effectType: effectType = "crumble", gravity: gravity = 0.3, bounceFactor: bounceFactor = 0.6, dustParticles: dustParticles = 5, groundLevel: groundLevel = 0 } = options;
        this.surface.x = x;
        this.surface.y = y;
        const { x: origX, y: origY, width: width, height: height } = texture._frame;
        // Create fragments based on effect type
        for(let i = 0; i < fragmentCount; i++){
            const fragment = this.createFragment(texture, origX, origY, width, height, i, effectType);
            if (fragment) this.animators.push(this.makeFragmentAnimator(fragment, effectType, duration, gravity, bounceFactor, groundLevel));
        }
        // Add dust particles for crumble effect
        if (effectType === "crumble" && dustParticles > 0) this.createDustParticles(origX, origY, width, height, dustParticles);
        this.start();
    }
    createMultiTextureEffect(textures, options = {}) {
        // Drop the effect entirely if we're already saturated -- see MAX_ACTIVE_EFFECTS.
        if ($680de7ed15411c91$var$activeEffects.size >= $680de7ed15411c91$var$MAX_ACTIVE_EFFECTS) {
            this.cleanup();
            return;
        }
        const { fragmentCount: fragmentCount = 32, duration: duration = 1000, effectType: effectType = "crumble", gravity: gravity = 0.3, bounceFactor: bounceFactor = 0.6, dustParticles: dustParticles = 8, groundLevel: groundLevel = 0 } = options;
        // Calculate bounds for dust particles
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        textures.forEach(({ x: x, y: y, texture: texture })=>{
            const { width: width, height: height } = texture._frame;
            if (x < minX) minX = x;
            if (x + width > maxX) maxX = x + width;
            if (y < minY) minY = y;
            if (y + height > maxY) maxY = y + height;
        });
        this.surface.x = minX;
        this.surface.y = minY;
        // Create fragments for each texture
        textures.forEach(({ texture: texture, x: x, y: y })=>{
            const { x: origX, y: origY, width: width, height: height } = texture._frame;
            const localX = x - minX;
            const localY = y - minY;
            // Create fragments for this texture
            for(let i = 0; i < Math.ceil(fragmentCount / textures.length); i++){
                const fragment = this.createFragment(texture, origX, origY, width, height, i, effectType);
                if (fragment) {
                    // Adjust fragment position relative to the combined surface
                    fragment.x += localX;
                    fragment.y += localY;
                    this.animators.push(this.makeFragmentAnimator(fragment, effectType, duration, gravity, bounceFactor, groundLevel - minY));
                }
            }
        });
        // Add dust particles for the entire area
        if (effectType === "crumble" && dustParticles > 0) this.createDustParticles(0, 0, maxX - minX, maxY - minY, dustParticles);
        this.start();
    }
    createFragment(texture, origX, origY, width, height, index, effectType) {
        // Fragment size based on effect type - larger chunks for crumble
        let fragWidth;
        let fragHeight;
        if (effectType === "crumble") {
            // Larger, more realistic chunks
            fragWidth = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(2, Math.floor(width / 4)), Math.max(2, Math.floor(width / 2)));
            fragHeight = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(2, Math.floor(height / 4)), Math.max(2, Math.floor(height / 2)));
        } else {
            // Original smaller fragments for explosion
            fragWidth = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(1, Math.floor(width / 8)), Math.max(1, Math.floor(width / 3)));
            fragHeight = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(1, Math.floor(height / 8)), Math.max(1, Math.floor(height / 3)));
        }
        const fragX = origX + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, Math.max(1, width - fragWidth));
        const fragY = origY + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, Math.max(1, height - fragHeight));
        const frag = new (0, $klOfb.Texture)(texture.baseTexture, new (0, $6qzqq.Rectangle)(fragX, fragY, fragWidth, fragHeight), undefined, undefined, texture.rotate, texture.defaultAnchor);
        const fragSprite = new (0, $7Bs2Z.Sprite)(frag);
        fragSprite.x = fragX - origX;
        fragSprite.y = fragY - origY;
        this.surface.addChild(fragSprite);
        this.pooledItems.push(fragSprite);
        return fragSprite;
    }
    // Build a per-fragment animator. It replaces the old setInterval-based
    // animateFragment: the physics (crumble/explosion), settle detection and the
    // 500ms fade-out are the same, just driven by the shared ticker one frame at a time.
    makeFragmentAnimator(fragSprite, effectType, duration, gravity, bounceFactor, groundLevel) {
        const angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 360));
        let velocity;
        let velocityY = 0;
        let rotation = 0;
        const startTs = Date.now();
        let changedColor1 = false;
        let changedColor2 = false;
        // fade-out phase state
        let fading = false;
        let fadeOutStart = 0;
        const fadeOutDuration = 500;
        let fadeStartAlpha = 0;
        if (effectType === "crumble") {
            // Crumble physics - more realistic chunk behavior
            const chunkType = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 3);
            let horizontalForce = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(2, 8);
            let verticalForce = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-2, 2) // Some chunks start falling immediately
            ;
            switch(chunkType){
                case 0:
                    horizontalForce *= 0.7;
                    verticalForce -= 1;
                    break;
                case 1:
                    horizontalForce *= 1.2;
                    verticalForce += 2;
                    break;
                case 2:
                    horizontalForce *= 1.5;
                    verticalForce -= 0.5;
                    break;
            }
            velocity = {
                x: Math.cos(angle) * horizontalForce,
                y: Math.sin(angle) * horizontalForce * 0.3
            };
            velocityY = verticalForce;
        } else // Explosion physics (original)
        velocity = {
            x: Math.cos(angle) * 10,
            y: Math.sin(angle) * 10
        };
        return (now)=>{
            if (fading) {
                const fadeProgress = (now - fadeOutStart) / fadeOutDuration;
                fragSprite.alpha = Math.max(0, fadeStartAlpha - fadeProgress * fadeStartAlpha);
                return fadeProgress >= 1 || fragSprite.alpha <= 0;
            }
            if (effectType === "crumble") {
                // Apply gravity
                velocityY += gravity;
                fragSprite.y += velocityY;
                fragSprite.x += velocity.x * 0.3 // Slower horizontal movement
                ;
                // Bounce effect when hitting ground
                if (fragSprite.y >= groundLevel && velocityY > 0) {
                    velocityY *= -bounceFactor;
                    fragSprite.y = groundLevel;
                    // Add some horizontal friction
                    velocity.x *= 0.8;
                }
                // Rotation based on movement and gravity
                fragSprite.angle += (velocityY + Math.abs(velocity.x)) * 0.05;
                // Fade out more gradually
                fragSprite.alpha -= 0.008;
            } else {
                // Original explosion effect
                fragSprite.x += velocity.x;
                fragSprite.y += velocity.y;
                rotation += 1;
                if (rotation > 360) rotation = 0;
                fragSprite.angle = rotation;
                fragSprite.alpha -= 0.1;
                // Color changes for explosion effect
                if (fragSprite.alpha < 0.7 && !changedColor1) {
                    fragSprite.tint = 0xffc0c0;
                    changedColor1 = true;
                }
                if (fragSprite.alpha < 0.5 && !changedColor2) {
                    fragSprite.tint = 0xff0000;
                    changedColor2 = true;
                }
            }
            // Check if fragment should start fading out
            const isSettled = effectType === "crumble" && Math.abs(velocityY) < 0.1 && Math.abs(velocity.x) < 0.1 && fragSprite.alpha < 0.8;
            // If settled or duration exceeded, start fade out instead of immediate cleanup
            if (isSettled || now - startTs > duration) {
                fading = true;
                fadeOutStart = now;
                fadeStartAlpha = fragSprite.alpha // Start from current alpha
                ;
            }
            return false;
        };
    }
    createDustParticles(origX, origY, width, height, count) {
        for(let d = 0; d < count; d++){
            // Dust is a tinted sprite off the shared Texture.WHITE rather than its own Graphics
            // object. Graphics don't batch (each is its own draw call); WHITE-textured sprites all
            // batch together, so a burst of dust is a handful of draw calls instead of one per mote.
            const dust = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
            dust.tint = 0x8b7355 // Brown dust color
            ;
            const size = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(2, 4);
            dust.width = size;
            dust.height = size;
            dust.x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, width);
            dust.y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, height);
            dust.alpha = 0.6;
            const jitter = $680de7ed15411c91$var$randomFloatBetween(0.5, 1.5);
            dust.scale.set(dust.scale.x * jitter, dust.scale.y * jitter);
            this.surface.addChild(dust);
            this.dustItems.push(dust);
            const dustVelocity = {
                x: $680de7ed15411c91$var$randomFloatBetween(-1, 1),
                y: $680de7ed15411c91$var$randomFloatBetween(-2, -4)
            };
            this.animators.push(()=>{
                dust.x += dustVelocity.x;
                dust.y += dustVelocity.y;
                dust.alpha -= 0.02;
                dust.scale.set(dust.scale.x * 0.98) // Shrink slightly
                ;
                if (dust.alpha <= 0) {
                    if (dust.parent) dust.parent.removeChild(dust);
                    return true;
                }
                return false;
            });
        }
    }
    // Advance every particle in this effect by one frame. Called once per frame by the shared
    // ticker (sharedTick), not registered as its own Ticker callback.
    step(now) {
        if (this.released) return;
        for(let i = this.animators.length - 1; i >= 0; i--){
            let done = false;
            try {
                done = this.animators[i](now);
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "fragment",
                        "error"
                    ]
                }, e);
                done = true;
            }
            if (done) this.animators.splice(i, 1);
        }
        if (this.animators.length === 0) this.cleanup();
    }
    start() {
        if (this.started) return;
        this.started = true;
        if (this.animators.length === 0) {
            // Nothing to animate; tear down immediately.
            this.cleanup();
            return;
        }
        $680de7ed15411c91$var$activeEffects.add(this);
        $680de7ed15411c91$var$ensureSharedTicker();
    }
    cleanup() {
        if (this.released) return;
        this.released = true;
        $680de7ed15411c91$var$activeEffects.delete(this);
        this.animators = [];
        this.pooledItems.forEach((p)=>{
            try {
                if (p?.parent) {
                    p.parent.removeChild(p);
                    p.texture.destroy();
                }
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "fragment",
                        "error"
                    ]
                }, e);
            }
        });
        this.dustItems.forEach((dust)=>{
            try {
                if (dust?.parent) dust.parent.removeChild(dust);
                dust.destroy();
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "fragment",
                        "error"
                    ]
                }, e);
            }
        });
        this.pooledItems = [];
        this.dustItems = [];
        if (this.surface.parent) this.surface.parent.removeChild(this.surface);
    }
    destroy() {
        this.cleanup();
    }
}





class $cf8aec4e49454e2b$export$59b4c816941e3699 {
    constructor(config, surfaceObjectsByKey){
        // Shatter textures captured when a wall's cell was removed, keyed by surfaceId. Lets a "destroy"
        // tile-effect that arrives AFTER the removal-triggered rerender (which cleared the live surface)
        // still play the shatter. Bounded; entries are consumed on use.
        this.removedSurfaceSnapshots = new Map();
        /**
     * Configure the hole effect with proper colors
     */ this.configureHoleEffect = ()=>{
            this.config.holeEffect.configureScuffMarks({
                enabled: true,
                count: 3,
                color: 0x000000,
                alpha: 0.15,
                minSize: 0.05,
                maxSize: 0.15,
                roughness: 0.7
            });
            this.config.holeEffect.configureDents({
                enabled: true,
                count: 2,
                color: 0x1a1a1a,
                alpha: 0.4,
                minSize: 0.08,
                maxSize: 0.2,
                depth: 0.6
            });
        };
        // ============================================================================
        // Sprite Fragment Rendering Methods
        // ============================================================================
        /**
     * Render a sprite fragment with all its map entries
     */ this.renderSpriteFragment = (fragment)=>{
            const { location: location, height: height, mapEntries: mapEntries, fineLocationNudge: fineLocationNudge, debugTxt: debugTxt } = fragment;
            if (debugTxt) {
                const debugTxtLocation = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                    x: location.x,
                    y: location.y + 0
                });
                const debugTextObj = new (0, $hnGDn.BitmapText)(debugTxt, {
                    fontName: "SignFont",
                    align: "center"
                });
                debugTextObj.x = debugTxtLocation.x;
                debugTextObj.y = debugTxtLocation.y;
                this.config.surface.addChild(debugTextObj);
                return;
            }
            const key = `frag-${fragment.id}-${location.x}-${location.y}`;
            const set = [];
            this.surfaceObjectsByKey.set(key, {
                spriteSet: set
            });
            const bottom = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: location.x,
                y: location.y + 0
            });
            bottom.x += fineLocationNudge?.x || 0;
            bottom.y += fineLocationNudge?.y || 0;
            let maxX = undefined;
            let maxY = undefined;
            const debug = false;
            const renderZIdxOffset = mapEntries[0].renderZIdxOffset || 0;
            mapEntries.forEach((mapEntry)=>{
                const tile = `${mapEntry.tilePos}`;
                const compositeTileId = this.config.tilemapMetaProvider.getCompositeTileId(`${mapEntry.tilePos}`);
                if (compositeTileId) this.config.renderCompositeTile(this.config.tilemapMetaProvider, tile, compositeTileId, mapEntry.x, mapEntry.y, renderZIdxOffset + 200);
                else {
                    const tilesetTileId = this.config.tilemapMetaProvider.resolveTilesetTileId(tile);
                    const g = this.config.attachTexture((0, $klOfb.Texture).from(`${tilesetTileId}`), mapEntry.roofLayer === "below" ? this.config.skySpriteSurfaceBelow : mapEntry.roofLayer === "above" ? this.config.skySpriteSurfaceAbove : undefined);
                    const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                        x: mapEntry.x,
                        y: mapEntry.y
                    });
                    fine.x += fineLocationNudge?.x || 0;
                    fine.y += fineLocationNudge?.y || 0;
                    g.x = fine.x;
                    g.y = fine.y;
                    g.zIndex = 100 + bottom.y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5;
                    set.push(g);
                    if (debug) {
                        const f = new (0, $gwPoJ.Graphics)();
                        f.beginFill(0x00ff00);
                        f.drawCircle(0, 0, 5);
                        f.endFill();
                        f.x = fine.x;
                        f.y = fine.y;
                        f.zIndex = 100000;
                        this.config.surface.addChild(f);
                    }
                    if (maxY === undefined || fine.y > maxY) maxY = fine.y;
                    if (maxX == undefined) maxX = fine.x;
                }
            });
            if (maxX !== undefined && maxY !== undefined) {
                const z = maxY + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.35;
                set.forEach((sprite)=>{
                    sprite.zIndex = 100 + renderZIdxOffset + z;
                });
                if (debug) {
                    const f = new (0, $gwPoJ.Graphics)();
                    f.beginFill(0xff0000);
                    f.drawCircle(0, 0, 5);
                    f.endFill();
                    f.x = maxX;
                    f.y = z;
                    f.zIndex = 100000;
                    this.config.surface.addChild(f);
                }
            }
        };
        /**
     * Process surface ID for sprite grouping
     * Maintains consistent Y-coordinate ordering for proper visual layering
     */ this.processSurfaceId = (tilesetTileId, surfaceId, spriteToReturn, delta)=>{
            if (!surfaceId) return;
            let surfaceObject = this.surfaceObjectsByKey.get(surfaceId);
            if (!surfaceObject) {
                surfaceObject = {
                    spriteSet: [
                        spriteToReturn
                    ]
                };
                this.surfaceObjectsByKey.set(surfaceId, surfaceObject);
            } else {
                // Insert sprite in correct Y-order to maintain consistent ordering
                // This ensures the same ordering used in damage visualization
                const insertIndex = surfaceObject.spriteSet.findIndex((sprite)=>sprite.y > spriteToReturn.y);
                if (insertIndex === -1) surfaceObject.spriteSet.push(spriteToReturn);
                else surfaceObject.spriteSet.splice(insertIndex, 0, spriteToReturn);
            }
            if (delta) surfaceObject.delta = delta;
            if (tilesetTileId) surfaceObject.tilesetTileId = tilesetTileId;
        };
        /**
     * Inverse of processSurfaceId's insertion: drop the given sprites from a surface's spriteSet by
     * identity. Called when an incremental repaint destroys a cell's owned sprites -- without this the
     * shared spriteSet keeps references to destroyed sprites, and the next damage/shake/hole pass reads
     * `.x` / `.texture` on a destroyed sprite (transform is null) and throws. If the set empties out the
     * surface object is removed entirely so a stale, spriteless entry can't linger.
     */ this.detachSpritesFromSurface = (surfaceId, sprites)=>{
            if (!surfaceId || !sprites || sprites.length === 0) return;
            const surfaceObject = this.surfaceObjectsByKey.get(surfaceId);
            if (!surfaceObject || !surfaceObject.spriteSet) return;
            surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>!sprites.includes(s));
            if (surfaceObject.spriteSet.length === 0) this.surfaceObjectsByKey.delete(surfaceId);
        };
        /**
     * Capture a surface's current shatter textures + positions before its sprites are torn down by the
     * removal-triggered rerender. A wall's "destroy" tile-effect can arrive AFTER that rerender (the
     * removal delta beats the effect), by which point the live surface is gone; the snapshot lets the
     * shatter still play. Called per removed cell -- a multi-cell wall snapshots the same surfaceId
     * (idempotent, captures the full sprite set each time). Bounded so a missing destroy effect can't
     * grow it without limit.
     */ this.snapshotSurfaceForDestroy = (surfaceId)=>{
            if (!surfaceId) return;
            const surfaceObject = this.surfaceObjectsByKey.get(surfaceId);
            const set = (surfaceObject?.spriteSet || []).filter((s)=>s && !s.destroyed && !!s.transform);
            if (set.length === 0) return;
            let minY = Infinity;
            let maxY = -Infinity;
            set.forEach((g)=>{
                if (g.y < minY) minY = g.y;
                if (g.y + g.height > maxY) maxY = g.y + g.height;
            });
            const groundLevel = maxY - (maxY - minY) / 2;
            const textures = set.map((g)=>({
                    texture: g.texture,
                    x: g.x,
                    y: g.y
                }));
            this.removedSurfaceSnapshots.set(surfaceId, {
                textures: textures,
                groundLevel: groundLevel
            });
            if (this.removedSurfaceSnapshots.size > 32) {
                const oldest = this.removedSurfaceSnapshots.keys().next().value;
                this.removedSurfaceSnapshots.delete(oldest);
            }
        };
        // Play the shatter from a snapshot captured at removal time; consume it so it can't be reused.
        this.shatterFromSnapshot = (surfaceId)=>{
            const snap = this.removedSurfaceSnapshots.get(surfaceId);
            if (!snap) return;
            this.removedSurfaceSnapshots.delete(surfaceId);
            // A destroyed PIXI texture nulls its baseTexture/orig; skip those so the fragment effect never
            // reads a torn-down texture.
            const textures = snap.textures.filter((t)=>t.texture && t.texture.baseTexture && t.texture.orig);
            if (textures.length === 0) return;
            this.createFragmentEffect(textures, snap.groundLevel);
        };
        // ============================================================================
        // Tile Effect Methods
        // ============================================================================
        /**
     * Apply a tile effect (damage, destroy, remove)
     */ this.applyTileEffect = (effect)=>{
            if (!effect.tileId && !effect.surfaceId) // we need either the tileId or surfaceId to do an effect
            return;
            if (effect.effectType === "remove") this.applyRemoveEffect(effect);
            else if (effect.effectType === "destroy") {
                const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
                const { x: x, y: y } = mapRoughCoordinates;
                const key = surfaceId || `${tileId}-${x}-${y}`;
                const surfaceObject = this.surfaceObjectsByKey.get(key);
                if (surfaceObject) this.applyDestroyEffect(effect, surfaceObject);
                else // The live surface was already cleared by a removal-triggered rerender that beat this
                // destroy effect -- play the shatter from the snapshot captured at removal time.
                this.shatterFromSnapshot(key);
            } else if (effect.effectType === "damage") {
                const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
                const { x: x, y: y } = mapRoughCoordinates;
                const key = surfaceId || `${tileId}-${x}-${y}`;
                const surfaceObject = this.surfaceObjectsByKey.get(key);
                if (surfaceObject) this.applyDamageEffect(effect, surfaceObject);
            }
        };
        /**
     * Apply damage effect to a tile
     */ this.applyDamageEffect = (effect, surfaceObject)=>{
            if (effect.effectType !== "damage") return;
            const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
            const { x: x, y: y } = mapRoughCoordinates;
            // Defensive: an incremental repaint can leave destroyed sprites in the shared spriteSet
            // (removeSpritedCell detaches them via detachSpritesFromSurface, but guard here too). A
            // destroyed sprite's transform is null, so reading `.x` in the shake or `.texture` in the hole
            // pass throws "Cannot read properties of null (reading 'position')". Drop them in place so both
            // the shake (set) and the hole pass (surfaceObject.spriteSet) only ever touch live sprites.
            if (surfaceObject?.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && s.transform);
            const set = surfaceObject?.spriteSet;
            if (!set || set.length === 0) return;
            // Prevent multiple shake animations on the same tiles
            if (surfaceObject.isShaking) return;
            surfaceObject.isShaking = true;
            this.performShakeAnimation(set, surfaceObject, ()=>{
                this.applyDamageVisualization(effect, surfaceObject, set, x, y);
            });
        };
        /**
     * Apply destroy effect to a tile
     */ this.applyDestroyEffect = (effect, surfaceObject)=>{
            const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
            const { x: x, y: y } = mapRoughCoordinates;
            // Defensive: drop any destroyed sprites left in the shared spriteSet by an incremental repaint
            // before we read their geometry (g.y + g.height below throws on a destroyed sprite). See the
            // matching note in applyDamageEffect.
            if (surfaceObject?.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && s.transform);
            const set = surfaceObject?.spriteSet;
            if (set && set.length > 0) {
                // Calculate the ground level (bottom of the lowest sprite)
                let groundLevel = 0;
                let minX = Infinity;
                let maxX = -Infinity;
                let minY = Infinity;
                let maxY = -Infinity;
                set.forEach((g)=>{
                    const spriteBottomY = g.y + g.height;
                    if (spriteBottomY > groundLevel) groundLevel = spriteBottomY;
                    if (g.x < minX) minX = g.x;
                    if (g.x + g.width > maxX) maxX = g.x + g.width;
                    if (g.y < minY) minY = g.y;
                    if (g.y + g.height > maxY) maxY = g.y + g.height;
                });
                // Ground level should be one tile height above the bottom of the lowest sprite
                const totalHeight = maxY - minY;
                groundLevel = maxY - totalHeight / 2;
                // Prepare texture data for multi-texture effect
                const textures = Array.from(set).map((g)=>({
                        texture: g.texture,
                        x: g.x,
                        y: g.y
                    }));
                this.createFragmentEffect(textures, groundLevel);
                // Remove all sprites
                set.forEach((g)=>{
                    g.parent?.removeChild(g);
                });
                const compositeTileMeta = this.config.tilemapMetaProvider.resolveCompositeTileIdTileMeta(surfaceObject.compositeTileId, surfaceObject.tilesetId);
                const breakageMeta = compositeTileMeta?.tileMeta?.breakageMeta;
                if (breakageMeta) breakageMeta.descriptors.forEach((descriptor)=>{
                    const key = `${descriptor.compositeTileId}-${x}-${y}`;
                    this.surfaceObjectsByKey.delete(key);
                });
            }
        };
        /**
     * Apply remove effect to a tile
     */ this.applyRemoveEffect = (effect)=>{
            const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
            const { x: x, y: y } = mapRoughCoordinates;
            const key = surfaceId || `${tileId}-${x}-${y}`;
            const set = this.surfaceObjectsByKey.get(key)?.spriteSet;
            if (set) set.forEach((g)=>{
                g.parent?.removeChild(g);
            });
        };
        // ============================================================================
        // Fragment Effect Methods
        // ============================================================================
        /**
     * Create fragment effect for destroyed tiles
     */ this.createFragmentEffect = (textures, groundLevel)=>{
            const options = {
                effectType: "crumble",
                fragmentCount: 8,
                duration: 1000,
                animationSpeed: 16,
                gravity: 0.3,
                bounceFactor: 0.6,
                dustParticles: 8,
                groundLevel: groundLevel
            };
            const effect = new (0, $680de7ed15411c91$export$e2a711ce70ac9a4)(this.config.surface);
            effect.createMultiTextureEffect(textures, options);
        };
        /**
     * Create single texture fragment effect
     */ this.createSingleFragmentEffect = (texture, parentX, parentY)=>{
            const options = {
                effectType: "crumble",
                duration: 1000,
                animationSpeed: 16,
                gravity: 0.3,
                bounceFactor: 0.6,
                dustParticles: 5,
                groundLevel: 20
            };
            const effect = new (0, $680de7ed15411c91$export$e2a711ce70ac9a4)(this.config.surface);
            effect.createEffect(texture, parentX, parentY, options);
        };
        // ============================================================================
        // Damage Visualization Methods
        // ============================================================================
        /**
     * Apply damage visualization to existing tiles
     */ this.applyDamageVisualizationToExistingTiles = (surfaceObjectsByKey)=>{
            surfaceObjectsByKey.forEach((obj, key)=>{
                if (obj.delta?.context?.hp && obj.delta?.context?.hpMax) {
                    const hpPct = obj.delta.context.hp / obj.delta.context.hpMax;
                    this.config.holeEffect.generateDynamicHolesFromHp(obj, hpPct, obj.delta.x, obj.delta.y);
                }
            });
        };
        // ============================================================================
        // Configuration Methods
        // ============================================================================
        /**
     * Update the tilemap meta provider
     */ this.updateTilemapMetaProvider = (tilemapMetaProvider)=>{
            this.config.tilemapMetaProvider = tilemapMetaProvider;
        };
        /**
     * Get the hole effect instance for advanced configuration
     */ this.getHoleEffect = ()=>{
            return this.config.holeEffect;
        };
        /**
     * Update sky surfaces (called after SkyManager is initialized)
     */ this.updateSkySurfaces = (skySpriteSurfaceAbove, skySpriteSurfaceBelow)=>{
            this.config.skySpriteSurfaceAbove = skySpriteSurfaceAbove;
            this.config.skySpriteSurfaceBelow = skySpriteSurfaceBelow;
        };
        /**
     * Create damage overlay sprite for damaged tiles
     */ this.createDamageOverlaySprite = (tilesetTileId, x, y, surface)=>{
            return this.config.attachTexture((0, $klOfb.Texture).from(tilesetTileId), surface);
        };
        /**
     * Check if a tile should have a damage overlay based on its delta
     */ this.shouldCreateDamageOverlay = (delta)=>{
            return !!(delta && delta.context?.hp && delta.context.hp < delta.context.hpMax);
        };
        /**
     * Update hole effect context when room changes
     */ this.updateHoleEffectContext = (roomId, rng)=>{
            // Update hole effect with new room context
            this.config.holeEffect.updateRandomContext(roomId, rng);
        };
        /**
     * Clear all surface objects
     */ this.clearSurfaceObjects = ()=>{
            this.surfaceObjectsByKey.clear();
        };
        // ============================================================================
        // Private Helper Methods (consolidated from TileDamageManager)
        // ============================================================================
        /**
     * Perform shake animation for damaged tiles
     */ this.performShakeAnimation = (set, surfaceObject, onComplete)=>{
            const startTs = Date.now();
            const duration = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(100, 200) // ms
            ;
            const frequency = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(20, 30) // Hz
            ;
            const initialAmplitude = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(3, 6) // pixels
            ;
            const original = set.map((g)=>({
                    x: g.x,
                    y: g.y
                }));
            // A sprite in `set` can be destroyed mid-shake by a concurrent incremental repaint (placing or
            // hitting an adjacent wall re-tiles this one -> removeSpritedCell destroys its owned sprites).
            // A destroyed sprite is still truthy but its transform is null, so `g.x = ...` throws
            // "Cannot read properties of null (reading 'position')". Skip any sprite that's gone.
            const alive = (g)=>!!g && !g.destroyed && !!g.transform;
            const interval = setInterval(()=>{
                const elapsed = Date.now() - startTs;
                const progress = elapsed / duration;
                if (progress >= 1.0) {
                    clearInterval(interval);
                    // Guaranteed restoration - ensure tiles return to exact original positions
                    set.forEach((g, i)=>{
                        if (!alive(g)) return;
                        g.x = original[i].x;
                    });
                    // Clear the shaking flag to allow future shake effects
                    surfaceObject.isShaking = false;
                    onComplete();
                    return;
                }
                // Damped sine wave: amplitude * decay * sin(2π * frequency * time)
                const decay = Math.pow(1 - progress, 2) // Exponential decay
                ;
                const amplitude = initialAmplitude * decay;
                const offset = amplitude * Math.sin(2 * Math.PI * frequency * (elapsed / 1000));
                set.forEach((g, i)=>{
                    if (!alive(g)) return;
                    g.x = original[i].x + offset;
                });
            }, 16) // ~60fps
            ;
        };
        /**
     * Apply damage visualization after shake completes
     * Sprites are already in correct Y-order from processSurfaceId
     */ this.applyDamageVisualization = (effect, surfaceObject, set, x, y)=>{
            // This runs from the shake's onComplete, so `set` (captured before the shake) can now hold
            // sprites destroyed mid-shake by a concurrent full rerender / repaint. Reading their geometry
            // (breakage addChild, the HP-indicator's set[0].width) throws. Prune the shared spriteSet and
            // work from the live sprites; bail if nothing survives (the tile is gone -- nothing to visualize).
            if (surfaceObject.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && !!s.transform);
            // Sprites are already in correct Y-order from processSurfaceId insertion
            const sorted = (surfaceObject.spriteSet || []).filter((s)=>s && !s.destroyed && !!s.transform);
            if (sorted.length === 0) return;
            // The server only populates hpPct for tiles whose max hp > 10 (see entity_tile.ts);
            // low-hp tiles like wall-wood (hp 5) arrive with hpPct undefined, which would make
            // damagePct = 1 - undefined = NaN and draw no damage. Derive the fraction from the
            // hp/hpMax the effect always carries -- the same values the deferred (re-render) path
            // uses -- so immediate damage matches what a reload would show.
            const hpPct = effect.hpPct ?? (effect.hpMax ? effect.hp / effect.hpMax : undefined);
            const compositeTileMeta = this.config.tilemapMetaProvider.resolveCompositeTileIdTileMeta(surfaceObject.compositeTileId, surfaceObject.tilesetId);
            const breakageMeta = compositeTileMeta?.tileMeta?.breakageMeta;
            if (breakageMeta) {
                const damagePct = 1.0 - hpPct;
                if (!surfaceObject.flags) surfaceObject.flags = new Set();
                const breakSets = [];
                breakageMeta?.descriptors.forEach((descriptor, i)=>{
                    const key = `${descriptor.compositeTileId}-${x}-${y}`;
                    const applies = (0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(damagePct, descriptor.thresholdLow, descriptor.thresholdHigh);
                    if (applies) {
                        if (!surfaceObject.flags.has(key)) {
                            if (this.config.handleRenderCompositeTile) {
                                let breakset = this.config.handleRenderCompositeTile(key, this.config.tilemapMetaProvider, descriptor.compositeTileId, descriptor.tilesetId);
                                surfaceObject.flags.add(key);
                                breakSets.push(breakset);
                            }
                        }
                    }
                });
                if (breakSets.length > 0) breakSets.forEach((breakSet)=>{
                    sorted.forEach((next, i)=>{
                        const renderable = breakSet[i];
                        // `next` can have been destroyed mid-shake by a concurrent repaint (same race as
                        // performShakeAnimation); addChild on a destroyed sprite throws. Skip if gone.
                        if (!renderable || !next || next.destroyed || !next.transform) return;
                        // Position child sprites relative to parent, not absolute
                        renderable.x = 0;
                        renderable.y = 0;
                        next.addChild(renderable);
                    });
                });
            } else // Generate holes for more realistic damage
            this.config.holeEffect.generateDynamicHolesFromHp(surfaceObject, hpPct, x, y);
            // Show HP percentage indicator
            if (effect.hpPct) {
                const indicator = new (0, $5f817afe83d87a88$export$9ec831f4c1f089b1)();
                const location = this.config.worldOverlaySurface.computeLocation(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                indicator.setup(location.x + sorted[0].width / 2, location.y, undefined, `${Math.ceil(effect.hpPct * 100)}%`, this.config.worldOverlaySurface);
            }
        };
        /**
     * Get cache statistics from the hole effect
     */ this.getCacheStats = ()=>{
            return (0, $30804d8d8c7ac29a$export$d2b760035f8f14b9).getCacheStats();
        };
        /**
     * Clear the global damage cache
     */ this.clearGlobalCache = ()=>{
            (0, $30804d8d8c7ac29a$export$d2b760035f8f14b9).clearGlobalCache();
        };
        this.config = config;
        this.surfaceObjectsByKey = surfaceObjectsByKey;
        // Configure hole effect with proper colors
        this.configureHoleEffect();
    }
}






class $4c699c02db426c96$export$7d222435fcebb768 {
    constructor(){
        this.hasRunOnce = false;
        this.noDelay = false;
        this.update = (tilemapMetaProvider)=>{
            this.tilemapMetaProvider = tilemapMetaProvider;
            this.ts = Date.now();
            this.reset();
        };
        this.reset = ()=>{
            this.hasRunOnce = false;
            this.xStatus = undefined;
            this.yStatus = undefined;
        };
        this.ready = ()=>{
            if (Date.now() - this.ts < 150) return false;
            return true;
        };
        this.compute = (location, force)=>{
            const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
            const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
            this.modifierX = undefined;
            this.modifierY = undefined;
            if (!this.hasRunOnce) {
                if (!force && !this.noDelay && !this.ready()) return;
                // First placement after a room load: center on the player, clamped to the
                // map edges. This is the same target the steady-state branch converges to,
                // but it always produces a value so the very first frame is already correct.
                // (The old code snapped to a map edge here, leaving the camera off-player
                // until some later compute() happened to re-center — the room-load bug.)
                const minX = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR;
                const maxX = (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                const minY = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR;
                const maxY = (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                this.modifierX = -Math.min(Math.max(location.x, minX), maxX) + 50;
                this.modifierY = -Math.min(Math.max(location.y, minY), maxY) + 50;
                this.hasRunOnce = true;
            } else {
                const inBoundsX = location.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && location.x < (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                const inBoundsY = location.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && location.y < (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                if (inBoundsX) this.modifierX = -location.x + 50;
                else this.modifierX = undefined;
                if (inBoundsY) this.modifierY = -location.y + 50;
                else this.modifierY = undefined;
            }
            if (location.x <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR) this.xStatus = "left";
            else if (location.x >= (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) this.xStatus = "right";
            else this.xStatus = "center";
            if (location.y <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR) this.yStatus = "top";
            else if (location.y >= (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) this.yStatus = "bottom";
            else this.yStatus = "center";
        };
    }
}


class $ecbfd660c7b27906$export$b63e72441cbf98ad {
    constructor(config){
        /**
     * Update the camera position based on player location
     */ this.updatePlayerLocation = (entity, force)=>{
            if (!entity) return;
            if (entity.location.x < 0 || entity.location.y < 0) return;
            // Compute camera translation modifiers
            this.translationComputer.compute(entity.location, force);
            const { modifierX: modifierX, modifierY: modifierY } = this.translationComputer;
            // Apply screen shake and camera positioning
            const shakeState = this.screenShakeManager.getState();
            if (modifierX !== undefined) {
                const transformedX = (shakeState.shakeOffsetX + modifierX + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w / 2) * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom - 48 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
                this.surface.transform.position.x = transformedX;
                this.worldOverlaySurface.transform.position.x = transformedX;
            }
            if (modifierY !== undefined) {
                const transformedY = (shakeState.shakeOffsetY + modifierY + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2) * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom - 48 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportY;
                this.surface.transform.position.y = transformedY;
                this.worldOverlaySurface.transform.position.y = transformedY;
            }
        };
        /**
     * Trigger screen shake effect
     */ this.screenShake = (entity)=>{
            this.screenShakeManager.screenShake(entity, this.updatePlayerLocation);
        };
        /**
     * Update the translation computer with new tilemap data
     */ this.updateTranslationComputer = (tilemapMetaProvider)=>{
            this.translationComputer.update(tilemapMetaProvider);
        };
        /**
     * Reset camera state
     */ this.reset = ()=>{
            this.translationComputer.reset();
        };
        /**
     * Get the current translation computer for advanced operations
     */ this.getTranslationComputer = ()=>{
            return this.translationComputer;
        };
        /**
     * Get the current screen shake manager
     */ this.getScreenShakeManager = ()=>{
            return this.screenShakeManager;
        };
        this.surface = config.surface;
        this.worldOverlaySurface = config.worldOverlaySurface;
        this.screenShakeManager = config.screenShakeManager;
        this.translationComputer = new (0, $4c699c02db426c96$export$7d222435fcebb768)();
    }
}


parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");
var $klOfb = parcelRequire("klOfb");

const $ff74dc2a666565c1$export$1db3e4d273a27613 = (tile)=>[
        "tree1",
        "tree2",
        "tree3",
        "tree4",
        "tree5",
        "tree6",
        "smallTree1"
    ].includes(tile);





class $9973b82363bdbab3$export$ca0a091ecfb17b44 {
    constructor(options){
        this.renderCompositeTile = (tilemapMetaProvider, parentTileId, compositeTileId, x, y, zIndex = 0)=>{
            const key = `${parentTileId}-${x}-${y}`;
            const parentTileMeta = tilemapMetaProvider.resolveTileMeta(parentTileId);
            //
            // dense microtiles
            //
            if (parentTileMeta.tileTypes.includes("dense")) {
                this.renderDenseMicrotiles(key, parentTileId, parentTileMeta, x, y, zIndex);
                return;
            }
            //
            // compositeTile
            //
            const tileset = tilemapMetaProvider.resolveTileSet(parentTileId);
            const compositeSprites = this.handleRenderCompositeTile(key, tilemapMetaProvider, compositeTileId, tileset.tilesetId, x, y, this.surface, zIndex);
        };
        this.handleRenderCompositeTile = (key, tilemapMetaProvider, compositeTileId, tilesetId, x = 0, y = 0, surface, extraZIndex)=>{
            let set = this.surfaceObjectsByKey.get(key)?.spriteSet;
            if (set) return set;
            set = [];
            const compositeTileMeta = tilemapMetaProvider.resolveCompositeTileIdTileMeta(compositeTileId, tilesetId);
            if (!compositeTileMeta) return set;
            const parentTileSet = tilemapMetaProvider.getTilesetById(tilesetId);
            const parentTileMeta = compositeTileMeta.tileMeta;
            //
            // compositeTile
            //
            const { width: width } = parentTileSet;
            // find the parent tile location
            let parentTileSetX;
            let parentTileSetY;
            const tileNumber = compositeTileMeta.tileNumber - 1;
            parentTileSetX = tileNumber % width;
            parentTileSetY = Math.floor(tileNumber / width);
            const isDenseVertical = parentTileMeta.tileTypes.includes("denseVertical");
            if (isDenseVertical) {
                this.renderDenseVerticalTiles(key, compositeTileMeta, parentTileSet, parentTileSetX, parentTileSetY, x, y, surface, extraZIndex, set);
                this.surfaceObjectsByKey.set(key, {
                    spriteSet: set,
                    compositeTileId: compositeTileId,
                    tilesetId: tilesetId
                });
            } else {
                const fullTileId = `${parentTileSet.tilesetId}-${compositeTileId}`;
                const texture = this.tileTextureExtractor.extract(tilemapMetaProvider, parentTileSet.tilesetId, compositeTileId);
                const bounds = (0, $86e9e05f3ebc1d8f$export$171acc6ba80afe2).compositeTileSpriteBounds.get(fullTileId);
                const children = compositeTileMeta.children || [];
                let intersects = false;
                for(let i = 0; i < children.length; i++){
                    const childTileMeta = children[i];
                    const tileNumber = childTileMeta.tileNumber - 1;
                    const tileSetX = tileNumber % width;
                    const tileSetY = Math.floor(tileNumber / width);
                    const childTileSetXOffset = tileSetX - parentTileSetX;
                    const childTileSetYOffset = tileSetY - parentTileSetY;
                    const xx = x + childTileSetXOffset;
                    const yy = y + childTileSetYOffset;
                    if (tilemapMetaProvider.isSkyTileAt(xx, yy)) {
                        intersects = true;
                        break;
                    }
                }
                if (!intersects) this.renderNonIntersectingCompositeTile(compositeTileMeta, texture, bounds, x, y, surface, extraZIndex, set);
                else this.renderSkyIntersectingCompositeTile(compositeTileMeta, parentTileSet, x, y, surface, extraZIndex, set, bounds, children, tilemapMetaProvider);
                this.surfaceObjectsByKey.set(key, {
                    spriteSet: set,
                    compositeTileId: compositeTileId,
                    tilesetId: tilesetId
                });
            }
            // Tag the tree tiles so the occluder-fade pass can fade ONLY trees (a structured check on the
            // tile's entityTileId -- no sprite/texture name parsing). Pool sprites default to false at
            // checkout (SpriteManagementService.attachTexture), so this only needs to flip trees on.
            const entityTileId = parentTileMeta?.entityTileId;
            if (entityTileId && (0, $ff74dc2a666565c1$export$1db3e4d273a27613)(entityTileId)) for (const g of set)g.occluderTreeTile = true;
            return set;
        };
        this.renderDenseMicrotiles = (key, parentTileId, parentTileMeta, x, y, zIndex)=>{
            const set = [];
            this.surfaceObjectsByKey.set(key, {
                spriteSet: set
            });
            const fullTileId = this.tilemapMetaProvider.resolveTilesetTileId(parentTileId);
            let textTure = this.compositeTileSpriteTextures.get(fullTileId);
            if (!textTure) {
                if (parentTileMeta.spriteId) {
                    const loader = (0, $kXE1p.Loader).shared;
                    let resource = loader.resources["humanoid"];
                    if (resource) textTure = resource.texture;
                } else {
                    textTure = (0, $klOfb.Texture).from(`${fullTileId}`);
                    this.compositeTileSpriteTextures.set(fullTileId, textTure);
                }
            }
            const parentFine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            });
            const noiseChance = 0.1;
            const print = (offsetX = 0, offsetY = 0)=>{
                const g = this.attachTexture(textTure);
                g.x = parentFine.x + offsetX;
                g.y = parentFine.y + offsetY;
                g.zIndex = zIndex;
                set.push(g);
            };
            print();
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(-0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), -0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), -0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(-0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        };
        this.renderDenseVerticalTiles = (key, compositeTileMeta, parentTileSet, parentTileSetX, parentTileSetY, x, y, surface, extraZIndex, set)=>{
            const count = this.pctChance(10, `dense-vertical-${key}-1`) ? this.pctChance(50, `dense-vertical-${key}-2`) ? 1 : 3 : 2;
            const gradient = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / count;
            for(let i = 0; i < count; i++){
                let verticalOffset = i * gradient;
                const yPertubation = this.pertubation("_", x, y, i, `horizontalDensity`);
                const children = compositeTileMeta.children || [];
                const parentTileIdNumber = compositeTileMeta.tileNumber;
                // The id the composite's parent tile renders under. NOTE the convention change: a tile's
                // position as an AUTHOR writes it is one below the id the client resolves it to (see
                // flora.ts), but compositeTileMeta.tileNumber is already in the resolved convention. Both
                // numbers are small, plausible and name a real neighbouring tile, so getting this wrong
                // matches nothing and reports nothing -- which is exactly what it did first.
                const parentCompositeTextureId = `${parentTileSet.tilesetId}-${parentTileIdNumber}`;
                let height = 0;
                children.forEach((childTileMeta)=>{
                    const tileId = `${childTileMeta.tileNumber}`;
                    const tileNumber = childTileMeta.tileNumber - 1;
                    const tileSetX = tileNumber % parentTileSet.width;
                    const tileSetY = Math.floor(tileNumber / parentTileSet.width);
                    const fullTileId = `${parentTileSet.tilesetId}-${tileId}`;
                    const isParent = parentTileIdNumber === tileNumber;
                    const childTileSetXOffset = tileSetX - parentTileSetX;
                    const childTileSetYOffset = tileSetY - parentTileSetY;
                    if (!isParent) height = Math.max(height, Math.abs(childTileSetYOffset));
                    let textTure = this.compositeTileSpriteTextures.get(fullTileId);
                    if (!textTure) {
                        textTure = (0, $klOfb.Texture).from(`${fullTileId}`);
                        this.compositeTileSpriteTextures.set(fullTileId, textTure);
                    }
                    const g = this.attachTexture(textTure, surface);
                    const fineItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                    const roughItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                    const rough = roughItem.data;
                    rough.x = x + childTileSetXOffset;
                    rough.y = y + childTileSetYOffset;
                    const fine = fineItem.data;
                    (0, $a80d0b17b615d6f7$export$131bd9752b097096)(rough, fine);
                    g.x = fine.x - this.pertubation(tileId, fine.x, fine.y, i, `verticalDensity`, 1);
                    g.y = fine.y - yPertubation;
                    g.zIndex = 100 + (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                        x: x,
                        y: y
                    }).y - verticalOffset - yPertubation + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3 + extraZIndex || 0;
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(roughItem);
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(fineItem);
                    g.interactive = true;
                    g.on("mouseover", ()=>{
                        this.logic.playerController.updateCompositeTile(x, y);
                    });
                    g.on("mouseout", ()=>{
                        this.logic.playerController.updateCompositeTile(-1, -1);
                    });
                    // Offer this sub-tile to the wind. Long grass is a two-tile vertical composite -- a
                    // base and a top -- so the sub-tile's own height above the anchor row is exactly how
                    // much of the bend it should carry: the base barely moves and the top does the
                    // leaning, which is how a plant bends rather than how a decal slides.
                    //
                    // Keyed on the COMPOSITE's parent tile, not on the sub-tile, so one entry in the sway
                    // table covers every piece of the plant.
                    this.getGrassSway()?.register(g, x, y, parentCompositeTextureId, -childTileSetYOffset);
                    set.push(g);
                });
                if (height > 0 || compositeTileMeta.tileMeta.renderZIdxOffset !== undefined) set.forEach((g)=>{
                    if (height > 1) {
                        g.y += (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                        g.zIndex += (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    }
                    if (compositeTileMeta.tileMeta.renderZIdxOffset) g.zIndex += compositeTileMeta.tileMeta.renderZIdxOffset;
                });
            }
        };
        this.renderNonIntersectingCompositeTile = (compositeTileMeta, texture, bounds, x, y, surface, extraZIndex, set)=>{
            const surfaceToUse = surface || this.surface;
            const containingSprite = this.attachTexture(texture, surfaceToUse);
            const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y - bounds.height + 1
            });
            containingSprite.x = fine.x - (bounds.width > 1 ? bounds.width * 0.25 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 0) + (compositeTileMeta?.tileMeta?.renderXOffset || 0);
            containingSprite.y = fine.y + (compositeTileMeta?.tileMeta?.renderYOffset || 0);
            containingSprite.zIndex = 100 + (extraZIndex || 0) + (fine.y + bounds.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.75;
            set.push(containingSprite);
        };
        this.renderSkyIntersectingCompositeTile = (compositeTileMeta, parentTileSet, x, y, surface, extraZIndex, set, bounds, children, tilemapMetaProvider)=>{
            // find the parent tile location
            const tileNumber = compositeTileMeta.tileNumber - 1;
            const parentTileSetXLocal = tileNumber % parentTileSet.width;
            const parentTileSetYLocal = Math.floor(tileNumber / parentTileSet.width);
            const fineXX = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            }).x;
            const fineYY = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            }).y;
            children.forEach((childTileMeta)=>{
                const tileId = `${childTileMeta.tileNumber}`;
                const tileNumber = childTileMeta.tileNumber - 1;
                const tileSetX = tileNumber % parentTileSet.width;
                const tileSetY = Math.floor(tileNumber / parentTileSet.width);
                const fullTileId = `${parentTileSet.tilesetId}-${tileId}`;
                const childTileSetXOffset = tileSetX - parentTileSetXLocal;
                const childTileSetYOffset = tileSetY - parentTileSetYLocal;
                const xx = x + childTileSetXOffset;
                const yy = y + childTileSetYOffset;
                const skyAt = tilemapMetaProvider.isSkyTileAt(xx, yy);
                const surfaceToUse = skyAt ? this.skySpriteSurfaceAbove : surface;
                const subtileSprite = this.attachTexture((0, $klOfb.Texture).from(fullTileId), surfaceToUse);
                const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                    x: xx,
                    y: yy
                });
                const fineX = fine.x;
                const fineY = fine.y + (compositeTileMeta?.tileMeta?.renderYOffset || 0);
                subtileSprite.x = fineX;
                subtileSprite.y = fineY;
                subtileSprite.zIndex = +(extraZIndex || 0) + (fineYY + bounds.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                set.push(subtileSprite);
            });
        };
        this.updateSkySurfaces = (skySpriteSurfaceAbove)=>{
            this.skySpriteSurfaceAbove = skySpriteSurfaceAbove;
        };
        this.surface = options.surface;
        this.skySpriteSurfaceAbove = options.skySpriteSurfaceAbove;
        this.tilemapMetaProvider = options.tilemapMetaProvider;
        this.compositeTileSpriteTextures = options.compositeTileSpriteTextures;
        this.surfaceObjectsByKey = options.surfaceObjectsByKey;
        this.attachTexture = options.attachTexture;
        this.pertubation = options.pertubation;
        this.pctChance = options.pctChance;
        this.logic = options.logic;
        this.tileTextureExtractor = options.tileTextureExtractor;
        this.getGrassSway = options.getGrassSway || (()=>undefined);
    }
    updateTilemapMetaProvider(tilemapMetaProvider) {
        this.tilemapMetaProvider = tilemapMetaProvider;
    }
}



class $21e34920946cefc2$export$5dbc5b3773f0a3b2 {
    /**
     * Get current shake state
     */ getState() {
        return {
            ...this.state
        };
    }
    /**
     * Update shake offsets
     */ setShakeOffsets(x, y) {
        this.state.shakeOffsetX = x;
        this.state.shakeOffsetY = y;
    }
    /**
     * Reset shake state
     */ reset() {
        this.state.shakeOffsetX = 0;
        this.state.shakeOffsetY = 0;
        this.state.isShaking = false;
    }
    /**
     * Trigger screen shake effect
     */ screenShake(entity, onUpdate) {
        if (!this.screenshakeEnabled) return;
        if (this.state.isShaking) return;
        this.state.isShaking = true;
        let startTs = Date.now();
        let shakeDirLeft = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
        let shakeDistance = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(5, 8);
        let currentShakeDistance = shakeDistance;
        let duration = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(40, 60);
        let up = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
        const interval = setInterval(()=>{
            let elapsed = Date.now() - startTs;
            if (elapsed > duration) {
                clearInterval(interval);
                this.state.shakeOffsetX = 0;
                this.state.shakeOffsetY = 0;
                this.state.isShaking = false;
                onUpdate(entity);
                return;
            }
            if (elapsed / duration % 0.25 === 0 || currentShakeDistance <= 0) {
                shakeDirLeft = !shakeDirLeft;
                shakeDistance = shakeDistance - 1;
                currentShakeDistance = shakeDistance;
            }
            currentShakeDistance -= 1;
            this.state.shakeOffsetX += shakeDirLeft ? 1 : -1;
            onUpdate(entity);
            this.state.shakeOffsetY += up ? -1 : 1;
            up = !up;
        }, 10);
    }
    constructor(){
        this.state = {
            isShaking: false,
            shakeOffsetX: 0,
            shakeOffsetY: 0
        };
        this.screenshakeEnabled = true;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $1avo5 = parcelRequire("1avo5");




class $c83cd7e406c913d7$export$530258b752862cdf {
    constructor(config){
        this.skyHidingAllowed = true;
        this.currentUnderSky = undefined;
        this.currentSkyFader = undefined;
        this.currentRoughCoordinates = (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)();
        // ============================================================================
        // Sky Visibility Control
        // ============================================================================
        /**
     * Set whether sky hiding is allowed
     */ this.setStaticHidingAllowed = (allowed)=>{
            this.skyHidingAllowed = allowed;
        };
        /**
     * Update sky visibility based on player location
     */ this.updatePlayerLocation = (entity, force)=>{
            if (!this.tilemapMetaProvider || !entity) return;
            // turn sky map layer on or off based on player position
            const item = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
            (0, $a80d0b17b615d6f7$export$74d4b819b66b5c70)(entity.location, item.data);
            if (force || !(0, $a80d0b17b615d6f7$export$248d38f6296296c5)(item.data, this.currentRoughCoordinates)) {
                (0, $a80d0b17b615d6f7$export$5afd74d1b598607d)(item.data, this.currentRoughCoordinates);
                const isSkyTile = this.tilemapMetaProvider.isSkyTileAt(item.data.x, item.data.y);
                if (isSkyTile !== this.currentUnderSky) {
                    if (isSkyTile && this.skyHidingAllowed) {
                        if (this.currentSkyFader) this.currentSkyFader.stop();
                        // Attach the filter for the duration of the fade-out only.
                        this.skySurface.filters = [
                            this.skyAlphFilter
                        ];
                        this.currentSkyFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.skyAlphFilter, {
                            // fadeInterval: 15,
                            direction: "out",
                            releaseCallback: ()=>{
                                this.skySurface.visible = false;
                                this.skyAlphFilter.alpha = 0.0;
                                // Hidden surface needs no filter.
                                this.skySurface.filters = null;
                            }
                        });
                        this.currentSkyFader.update();
                    } else if (!this.skySurface.visible) {
                        if (this.currentSkyFader) this.currentSkyFader.stop();
                        this.skySurface.visible = true;
                        // Attach the filter only for the fade-in; drop it once fully opaque so the
                        // steady-state visible sky renders without a per-frame filter pass.
                        this.skySurface.filters = [
                            this.skyAlphFilter
                        ];
                        this.skyAlphFilter.alpha = 0.0;
                        this.currentSkyFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.skyAlphFilter, {
                            fadeInterval: 1,
                            direction: "in",
                            minAlpha: 1.0,
                            releaseCallback: ()=>{
                                this.skyAlphFilter.alpha = 1.0;
                                this.skySurface.filters = null;
                            }
                        });
                        this.currentSkyFader.update();
                    }
                    this.currentUnderSky = isSkyTile;
                }
            }
            (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(item);
        };
        // ============================================================================
        // Sky Rendering
        // ============================================================================
        /**
     * Clear all sky surfaces
     */ this.clearSkySurfaces = ()=>{
            this.skyTilemapRenderer.clear();
            this.skySpriteSurfaceAbove.removeChildren();
            this.skySpriteSurfaceBelow.removeChildren();
        };
        /**
     * Get the sky tilemap renderer
     */ this.getSkyTilemapRenderer = ()=>{
            return this.skyTilemapRenderer;
        };
        /**
     * Get the sky sprite surface above
     */ this.getSkySpriteSurfaceAbove = ()=>{
            return this.skySpriteSurfaceAbove;
        };
        /**
     * Get the sky sprite surface below
     */ this.getSkySpriteSurfaceBelow = ()=>{
            return this.skySpriteSurfaceBelow;
        };
        // ============================================================================
        // Sky State
        // ============================================================================
        /**
     * Check if currently under sky
     */ this.isUnderSky = ()=>{
            return this.currentUnderSky;
        };
        /**
     * Check if sky hiding is allowed
     */ this.isSkyHidingAllowed = ()=>{
            return this.skyHidingAllowed;
        };
        // ============================================================================
        // Configuration
        // ============================================================================
        /**
     * Update the tilemap meta provider
     */ this.updateTilemapMetaProvider = (tilemapMetaProvider)=>{
            this.tilemapMetaProvider = tilemapMetaProvider;
        };
        /**
     * Reset sky state (called when changing rooms)
     */ this.resetSkyState = ()=>{
            this.skyHidingAllowed = true;
            this.currentUnderSky = undefined;
            if (this.currentSkyFader) {
                this.currentSkyFader.stop();
                this.currentSkyFader = undefined;
            }
        };
        this.skySurface = config.skySurface;
        this.tilemapMetaProvider = config.tilemapMetaProvider;
        // Initialize sky components
        this.skyTilemapRenderer = new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)();
        this.skySpriteSurfaceAbove = new (0, $gwPoJ.Graphics)();
        this.skySpriteSurfaceBelow = new (0, $gwPoJ.Graphics)();
        this.skyAlphFilter = new (0, $1avo5.filters).AlphaFilter(1.0);
        // Setup sky surface. The AlphaFilter is attached ONLY while a fade is in progress (see
        // updatePlayerLocation) -- a permanently attached filter forces the whole sky surface to
        // render-to-texture every frame even at full alpha, a constant cost on integrated GPUs.
        this.skySurface.addChild(this.skySpriteSurfaceBelow);
        this.skySurface.addChild(this.skyTilemapRenderer);
        this.skySurface.addChild(this.skySpriteSurfaceAbove);
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");



parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
class $16c48257f96a9477$export$1bcf5cc4ba3a2b8f extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    constructor(size = 1000){
        super(size), this.poolStats = {
            totalCreated: 0,
            totalReused: 0,
            totalCleared: 0,
            peakUsage: 0,
            currentUsage: 0
        }, // Properties from parent class
        this.items = [], this.ptr = -1, this.releasing = false, this.checkout = ()=>{
            // Call parent checkout method directly
            if (this.releasing) throw new Error("BAD!");
            this.ptr++;
            if (this.ptr > this.items.length - 1) // grow the array by creating new items
            for(let i = 0; i < 1000; i++)this.items.push(this.create());
            const item = this.items[this.ptr];
            item.free = false;
            // Update stats (ensure poolStats is initialized)
            if (this.poolStats) {
                this.poolStats.totalReused++;
                this.poolStats.currentUsage++;
                this.poolStats.peakUsage = Math.max(this.poolStats.peakUsage, this.poolStats.currentUsage);
            }
            return item;
        }, this.release = (item)=>{
            // Call parent release method directly
            if (item.free) // already free, noop
            return;
            item.free = true;
            this.clear(item);
            this.ptr--;
            if (this.ptr < 0) this.ptr = 0;
            // Update stats (ensure poolStats is initialized)
            if (this.poolStats) this.poolStats.currentUsage--;
        };
        this.defaultSprite = new (0, $7Bs2Z.Sprite)();
    }
    static getInstance() {
        if (!$16c48257f96a9477$export$1bcf5cc4ba3a2b8f.instance) $16c48257f96a9477$export$1bcf5cc4ba3a2b8f.instance = new $16c48257f96a9477$export$1bcf5cc4ba3a2b8f();
        return $16c48257f96a9477$export$1bcf5cc4ba3a2b8f.instance;
    }
    create() {
        // Initialize poolStats if not already initialized (happens during construction)
        if (!this.poolStats) this.poolStats = {
            totalCreated: 0,
            totalReused: 0,
            totalCleared: 0,
            peakUsage: 0,
            currentUsage: 0
        };
        this.poolStats.totalCreated++;
        this.poolStats.currentUsage++;
        this.poolStats.peakUsage = Math.max(this.poolStats.peakUsage, this.poolStats.currentUsage);
        return {
            free: true,
            data: new (0, $7Bs2Z.Sprite)()
        };
    }
    clear(item) {
        // Update stats (ensure poolStats is initialized)
        if (this.poolStats) this.poolStats.totalCleared++;
        // Reset all properties to default state
        item.data.texture = (0, $klOfb.Texture).EMPTY;
        item.data.x = this.defaultSprite.x;
        item.data.y = this.defaultSprite.y;
        item.data.tint = this.defaultSprite.tint;
        item.data.visible = this.defaultSprite.visible;
        item.data.alpha = this.defaultSprite.alpha;
        item.data.scale.set(this.defaultSprite.scale.x, this.defaultSprite.scale.y);
        item.data.rotation = this.defaultSprite.rotation;
        item.data.zIndex = this.defaultSprite.zIndex;
        item.data.removeAllListeners();
        item.data.interactive = false;
        item.data.buttonMode = false;
        // Clear any filters
        item.data.filters = null;
        // Reset anchor
        item.data.anchor.set(0, 0);
        // Remove from parent if attached
        if (item.data.parent) item.data.parent.removeChild(item.data);
    }
    getStats() {
        return {
            ...this.poolStats,
            reuseRate: this.poolStats.totalCreated > 0 ? (this.poolStats.totalReused / this.poolStats.totalCreated * 100).toFixed(2) + "%" : "0%",
            currentPoolSize: this.items.length,
            freeItems: this.items.filter((item)=>item.free).length,
            usedItems: this.items.filter((item)=>!item.free).length
        };
    }
    resetStats() {
        this.poolStats = {
            totalCreated: 0,
            totalReused: 0,
            totalCleared: 0,
            peakUsage: 0,
            currentUsage: 0
        };
    }
}


class $2937f12c3e372b97$export$c10d0c7e188aaa18 {
    constructor(config){
        /**
     * Attach a texture to a sprite and add it to the specified surface
     */ this.attachTexture = (texture, surface)=>{
            const spritePoolItem = this.spritePool.checkout();
            const sprite = spritePoolItem.data;
            sprite.texture = texture;
            sprite.occluderTreeTile = false;
            // Same reasoning for the wind's shear: GrassSway leans a blade by writing skew.x, and these
            // sprites are POOLED. A blade that is released mid-gust and handed out again as a wall or a
            // tree would arrive already bent, with nothing to straighten it.
            sprite.skew.x = 0;
            const surfaceToUse = surface || this.defaultSurface;
            surfaceToUse.addChild(sprite);
            spritePoolItem.data = sprite;
            return sprite;
        };
        /**
     * Creates a sprite at the specified coordinates with consistent positioning and z-index calculation
     */ this.createSpriteAt = (tilesetTileId, x, y, zIndexOffset = 0, surface)=>{
            const texture = (0, $klOfb.Texture).from(`${tilesetTileId}`);
            const sprite = this.attachTexture(texture, surface);
            const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            });
            sprite.x = fine.x;
            sprite.y = fine.y;
            sprite.zIndex = 100 + zIndexOffset + fine.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3;
            return sprite;
        };
        /**
     * Release all sprites back to the pool
     */ this.releaseAllSprites = (onRelease)=>{
            return this.spritePool.releaseAll((spriteItemObject)=>{
                const sprite = spriteItemObject.data;
                if (!sprite.parent) {
                    spriteItemObject.data = new (0, $7Bs2Z.Sprite)();
                    return true // Indicates error
                    ;
                } else {
                    sprite.parent?.removeChild(sprite);
                    return false // No error
                    ;
                }
            });
        };
        /**
     * Get the current sprite pool for advanced operations
     */ this.getSpritePool = ()=>{
            return this.spritePool;
        };
        /**
     * Clean up resources
     */ this.destroy = ()=>{
            this.spritePool.releaseAll();
        };
        this.spritePool = new (0, $16c48257f96a9477$export$1bcf5cc4ba3a2b8f)(config.spritePoolSize);
        this.defaultSurface = config.defaultSurface;
    }
}




const $f78f32798274f66a$export$6a603ef1f674b5ef = (item)=>item.context?.parent?.y ?? item.y;
const $f78f32798274f66a$export$360f852efd938c01 = (index, anchorY)=>100 + index + anchorY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3;


// Makes a map tile-sprite (a tree/bush/reed canopy, or a wall) translucent while the LOCAL player is
// standing behind it, so the player is never fully hidden. Purely a client-side visual: it only
// tweaks each sprite's `.alpha` (the same handle the build-preview ghost uses) and never touches game
// state, z-order, or the tile-effect system (which does not read/write alpha).
//
// Occlusion is decided the same way the engine already decides draw order -- a y-sort. A tile sprite
// sorts in front of the player when its zIndex is greater (see sprite_management_service.createSpriteAt
// and entity_mechanics.calculateZIndexBoost). We fade exactly the sprites that (a) sort in front and
// (b) whose box overlaps the player's body box. That is self-limiting: the trunk below the player and
// trees lower on screen never overlap the body box, so only the canopy actually covering the player
// fades.
//
// The candidate sprites are the pooled tile sprites (trees/bushes) plus the owned sprited-cell sprites
// (walls). Both persist between map re-renders, so we track what we faded and ease it back to opaque
// once the player steps out. The sprite pool resets alpha to 1.0 when it recycles a sprite, so a stale
// tracked reference can never leave a tile stuck translucent.
// Master on/off switch for the whole tree occluder-fade feature. Flip to false to ship it disabled:
// it becomes the default for `enabled`, and the per-frame pass short-circuits to a no-op (no pool scan,
// no fading). For toggling at runtime without a rebuild, set window.occluderFade.enabled instead.
const $75a0a4fb75fb6456$export$b972511549e2f31a = true;
const $75a0a4fb75fb6456$export$f34b24a5dc375e3 = ()=>({
        enabled: $75a0a4fb75fb6456$export$b972511549e2f31a,
        alpha: 0.5,
        speed: 0.1,
        neighborRadius: 160,
        minNeighbors: 8,
        hysteresis: 3
    });
// Player body box in fine (pixel) coords, anchored at the feet sort-point (== entity.location). The
// box spans up from the feet to roughly the head so a canopy overlapping the torso/head counts as
// occluding, while a trunk sprite sitting at/below the feet line does not.
const $75a0a4fb75fb6456$var$PLAYER_HALF_WIDTH = 11;
const $75a0a4fb75fb6456$var$PLAYER_BODY_HEIGHT = 46;
const $75a0a4fb75fb6456$var$PLAYER_FEET_MARGIN = 2;
// Alpha within this of the target snaps exactly (and, when restoring, drops the sprite from tracking).
const $75a0a4fb75fb6456$var$SNAP = 0.02;
class $75a0a4fb75fb6456$export$ffb41811f55797a3 {
    // Whether the player is currently in a "dense" stand (the fade is active).
    get isDense() {
        return this.denseLatched;
    }
    // Fade the tile sprites the player (feet at fine coords feetX/feetY, draw-order key playerZIndex)
    // is behind, and ease everything else back to opaque. `candidates` is the tree sprites currently on
    // screen (a reused array, so no allocation). One indexed pass computes both the local tree density
    // (neighbor count) and the set of tiles overlapping the player; the density gate then decides
    // whether those overlappers fade. Allocation-free and idempotent per frame.
    update(feetX, feetY, playerZIndex, candidates) {
        if (!this.config.enabled) {
            this.relaxAll();
            return;
        }
        const bx1 = feetX - $75a0a4fb75fb6456$var$PLAYER_HALF_WIDTH;
        const bx2 = feetX + $75a0a4fb75fb6456$var$PLAYER_HALF_WIDTH;
        const by1 = feetY - $75a0a4fb75fb6456$var$PLAYER_BODY_HEIGHT;
        const by2 = feetY - $75a0a4fb75fb6456$var$PLAYER_FEET_MARGIN;
        const radius = this.config.neighborRadius;
        const r2 = radius * radius;
        let neighbors = 0;
        const occluding = this.occluding;
        occluding.clear();
        for(let i = 0; i < candidates.length; i++){
            const g = candidates[i];
            if (!g || g.destroyed) continue;
            const w = g.width;
            const h = g.height;
            if (w <= 0 || h <= 0) continue;
            // Local density: does this tile's center sit within neighborRadius of the player? Skip the
            // squared-distance for tiles already too far in x to qualify (the common case off-cluster).
            const dx = g.x + w * 0.5 - feetX;
            if (dx <= radius && dx >= -radius) {
                const dy = g.y + h * 0.5 - feetY;
                if (dx * dx + dy * dy <= r2) neighbors++;
            }
            // Occlusion: draws in front AND its box (top-left anchored) overlaps the body box. Cheap
            // comparisons that short-circuit for far tiles, so this stays correct at any neighborRadius.
            if (g.zIndex > playerZIndex && g.x < bx2 && g.x + w > bx1 && g.y < by2 && g.y + h > by1) occluding.add(g);
        }
        this.lastNeighborCount = neighbors;
        // Neighbor-density gate with hysteresis: turn ON at minNeighbors, OFF only once density falls
        // to minNeighbors - hysteresis, so the player lingering on the boundary can't cause a blink.
        const onThreshold = this.config.minNeighbors;
        const offThreshold = Math.max(0, this.config.minNeighbors - this.config.hysteresis);
        this.denseLatched = this.denseLatched ? neighbors >= offThreshold : neighbors >= onThreshold;
        const dense = this.denseLatched;
        if (dense) occluding.forEach((g)=>this.tracked.add(g));
        for (const g of this.tracked){
            if (g.destroyed) {
                this.tracked.delete(g);
                continue;
            }
            const target = dense && occluding.has(g) ? this.config.alpha : 1.0;
            const next = g.alpha + (target - g.alpha) * this.config.speed;
            if (Math.abs(next - target) <= $75a0a4fb75fb6456$var$SNAP) {
                g.alpha = target;
                if (target >= 1.0) this.tracked.delete(g);
            } else g.alpha = next;
        }
    }
    // Ease every tracked sprite back to full opacity (used when the feature is disabled or there is no
    // player). Idempotent; drops sprites once restored so no sprite references are retained while idle.
    relaxAll() {
        // Drop last frame's occluder refs -- the active path clears this each frame, but the disabled
        // path skips it, so clear here too and hold nothing while idle.
        this.occluding.clear();
        this.denseLatched = false;
        for (const g of this.tracked){
            if (g.destroyed) {
                this.tracked.delete(g);
                continue;
            }
            const next = g.alpha + (1.0 - g.alpha) * this.config.speed;
            if (1.0 - next <= $75a0a4fb75fb6456$var$SNAP) {
                g.alpha = 1.0;
                this.tracked.delete(g);
            } else g.alpha = next;
        }
    }
    constructor(){
        this.config = $75a0a4fb75fb6456$export$f34b24a5dc375e3();
        // Sprites currently pushed off full opacity; tracked until they lerp back to 1.0 so we know which
        // to restore once the player steps out from behind them.
        this.tracked = new Set();
        // The occluders found this frame. Reused (cleared) every frame rather than reallocated, so the
        // per-frame path allocates nothing -- avoids the steady GC pressure that causes hitches on
        // low-end machines (see the budget-hardware note).
        this.occluding = new Set();
        // Latched gate state (hysteresis) + last density, exposed for the debug/tuning readout.
        this.denseLatched = false;
        this.lastNeighborCount = 0;
    }
}



class $409e08612bd4cd6f$export$ac241b7c41940a17 {
    constructor(surface, skySurface, miniMapSurface, worldOverlaySurface, logic){
        this.needsRender = false;
        this.compositeTileSpriteTextures = new Map();
        // Sprited-layer sprites owned per-cell (key `${x}-${y}-${layerId}`), NOT drawn from the frame
        // sprite pool -- so a single cell can be repainted incrementally on a map delta / redrawClient
        // without the LIFO pool's all-or-nothing release. Destroyed on full render + incremental removal.
        this.spritedCellSprites = new Map();
        // Which layer ids have actually rendered sprited cells, so a per-cell lookup can check just those
        // keys instead of scanning the whole map's worth of them. Populated as cells render.
        this.spritedLayerIds = new Set();
        // Fades map tile sprites (tree/bush canopies + walls) the local player stands behind toward
        // translucent, so the player is never fully hidden by them. Alpha-only; see applyOccluderFade.
        this.occluderFade = new (0, $75a0a4fb75fb6456$export$ffb41811f55797a3)();
        // The surfaceId (if any) each sprited cell registered its owned sprites under, so an incremental
        // remove can detach those exact sprites from the shared surfaceObjectsByKey spriteSet (which the
        // tile-effect system reads). Without this, removeSpritedCell destroys the sprites but leaves dead
        // references in the spriteSet, and a later hit reads `.x`/`.texture` on a destroyed sprite -> throw.
        this.spritedCellSurfaceId = new Map();
        // Cells (key `${x}-${y}-${layerId}`) changed by applied map deltas since the last repaint. On a
        // redrawClient signal we repaint just these incrementally (sprited layers) instead of the whole
        // map; if any dirty cell is a tilemap/other layer we fall back to a full rerender. Cleared on
        // both paths.
        this.dirtyCells = new Set();
        this.pendingRedraw = false;
        // Set when a dirty batch includes a removal or a damaged (hp < hpMax) tile. Those cells must go
        // through the FULL rerender path: the tile-effect system (crumble, wall shake, damage holes) owns
        // and reads these sprites, and an incremental remove+recreate races/breaks it. Pristine placements
        // (new tile, hp == hpMax / no hp) stay incremental.
        this.dirtyNeedsFull = false;
        this.surfaceObjectsByKey = new Map();
        this.rngCache = new Map();
        // Rendering state lock and queue system for race condition prevention
        this.isRendering = false;
        this.pendingMapDeltas = [];
        this.pendingRerender = false;
        // ============================================================================
        // INITIALIZATION
        // ============================================================================
        this.init = ()=>{
            this.tilemapRendererList = [
                new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)(),
                new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)(),
                new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)(),
                new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)(),
                new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)(),
                new (0, $21ba273fabeffbe8$export$8f858bd4088571f0)()
            ];
            this.tilemapRenderers = new (0, $a80d0b17b615d6f7$export$37a78dc06a7d1e2e)(this.tilemapRendererList);
            this.tilemapRendererList.forEach((renderer, i)=>{
                this.surface.addChild(renderer);
            });
            // Update composite tile renderer with sky surfaces from SkyManager
            this.compositeTileRenderer.updateSkySurfaces(this.skyManager.getSkySpriteSurfaceAbove());
            // Update tile effect system with sky surfaces from SkyManager
            this.tileEffectSystem.updateSkySurfaces(this.skyManager.getSkySpriteSurfaceAbove(), this.skyManager.getSkySpriteSurfaceBelow());
            // Live tuning hook: window.occluderFade.enabled / .alpha / .speed / .minNeighbors etc.
            // (matches window.deathEffect).
            if (typeof window !== "undefined") window.occluderFade = this.occluderFade.config;
        };
        // ============================================================================
        // CORE RENDERING METHODS
        // ============================================================================
        this.renderTileMap = ()=>{
            // Apply queued map deltas every frame, independent of the visual re-render gate
            // below. Deltas carry collision/blocking changes -- e.g. a chopped-down tree
            // becoming walkable. Previously deltas were only applied inside a full re-render,
            // but a tree cut does not trigger one (it sends a map delta, not a redrawClient),
            // so the client's collision map (tileTypesMap "blocking") stayed stale until the
            // next unrelated re-render or a reload. The player then predicts a collision the
            // server no longer enforces; reconciliation repeatedly yanks the player through the
            // now-empty space -- the shudder when walking where a tree used to be. Applying
            // deltas here mutates the persistent data model, so a later full re-render still
            // reflects them.
            this.processPendingDeltas();
            // A redrawClient signal: repaint just the delta-changed cells (incremental) rather than the
            // whole map. Runs here, after processPendingDeltas has applied the accompanying deltas. May
            // escalate to a full rerender (needsRender) if a tilemap-layer cell changed.
            if (this.pendingRedraw && !this.isRendering) {
                this.pendingRedraw = false;
                this.repaintDirtyCells();
            }
            if (!this.shouldRender()) return;
            this.isRendering = true;
            try {
                this.prepareRendering();
                this.renderAllLayers();
                this.finalizeRendering();
            } finally{
                this.isRendering = false;
            }
            // Process queued re-render request
            if (this.pendingRerender) {
                this.pendingRerender = false;
                this.needsRender = true;
            }
        };
        this.renderAt = (x, y, tilemap, layerId, options)=>{
            let { tilemapRender: tilemapRender, wasReplaced: wasReplaced, surfaceId: surfaceId } = options || {};
            tilemapRender = tilemapRender || this.tilemapRenderers.next().value;
            const size = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const _x = tilemap[x];
            if (!_x) return;
            let spriteToReturn;
            const tile = _x[y];
            if (tile && this.tilemapMetaProvider.shouldDrawTileAt(x, y, layerId, tilemap)) {
                if (!this.tilemapMetaProvider.isHiddenTile(tile)) {
                    const compositeTileId = this.tilemapMetaProvider.getCompositeTileId(tile);
                    if (compositeTileId) this.renderCompositeTile(this.tilemapMetaProvider, tile, compositeTileId, x, y);
                    else {
                        const tilesetTileId = this.tilemapMetaProvider.resolveTilesetTileId(tile);
                        if (layerId) {
                            const layerMapping = this.tilemapMetaProvider.resolveLayerMapping(layerId);
                            if (layerMapping.maptype === "sprited") spriteToReturn = this.spriteManagementService.createSpriteAt(tilesetTileId, x, y);
                            if (layerMapping.maptype === "tilemap") {
                                this.tilemapRenderers.values[layerMapping.idx]?.tile(`${tilesetTileId}`, x * size, y * size);
                                if (wasReplaced) {
                                    // todo -- this is too blunt... maybe there is a way to avoid full
                                    // rerenders on pixijs tilemap renders
                                    this.rerender();
                                    return;
                                }
                            }
                            if (layerMapping.maptype === "sky") {
                                const delta = this.tilemapMetaProvider.getMapDeltaAt(x, y, "sky");
                                if (delta?.collideable) spriteToReturn = this.spriteManagementService.createSpriteAt(tilesetTileId, x, y, 0, this.skyManager.getSkySpriteSurfaceAbove());
                                else this.skyManager.getSkyTilemapRenderer().tile(`${tilesetTileId}`, x * size, y * size);
                            }
                        } else {
                            tilemapRender?.tile(`${tilesetTileId}`, x * size, y * size);
                            // Create overlay sprite for damage effects on regular layers
                            const delta = this.tilemapMetaProvider.findMapDeltaAt(x, y);
                            if (this.tileEffectSystem.shouldCreateDamageOverlay(delta)) spriteToReturn = this.tileEffectSystem.createDamageOverlaySprite(tilesetTileId, x, y);
                        }
                    }
                }
            }
            return spriteToReturn;
        };
        this.addTileAt = (x, y, tile, layerId)=>{
            const mapping = this.tilemapMetaProvider.resolveLayerMapping(layerId);
            const tilesetTileId = this.tilemapMetaProvider.resolveTilesetTileId(tile);
            const sprite = this.spriteManagementService.createSpriteAt(tilesetTileId, x, y, mapping?.idx || 0);
            return {
                sprite: sprite
            };
        };
        this.renderCompositeTile = (tilemapMetaProvider, parentTileId, compositeTileId, x, y, zIndex = 0)=>{
            this.compositeTileRenderer.renderCompositeTile(tilemapMetaProvider, parentTileId, compositeTileId, x, y, zIndex);
        };
        // ============================================================================
        // PLAYER/CAMERA MANAGEMENT METHODS
        // ============================================================================
        this.updatePlayerLocation = (entity, force)=>{
            if (!entity) return;
            // Update sky visibility based on player position
            this.skyManager.updatePlayerLocation(entity, force);
            if (!force && this.needsRender || !this.tilemapMetaProvider || entity.location.x < 0 || entity.location.y < 0) return;
            // Delegate camera positioning to camera management service
            this.cameraManagementService.updatePlayerLocation(entity, force);
        };
        this.screenShake = (entity)=>{
            this.cameraManagementService.screenShake(entity);
        };
        // ============================================================================
        // EFFECTS AND OVERLAYS METHODS
        // ============================================================================
        this.tileEffect = (effect)=>{
            this.tileEffectSystem.applyTileEffect(effect);
        };
        this.overlay = ()=>this.worldOverlaySurface;
        this.setStaticHidingAllowed = (allowed)=>this.skyManager.setStaticHidingAllowed(allowed);
        // ============================================================================
        // MINIMAP METHODS
        // ============================================================================
        this.updateMinimap = (tilemapMetaProvider)=>{
            this.miniMapSurface.update(tilemapMetaProvider);
        };
        this.updateBiomeColorMap = (biomeCoordinate, color)=>{
            this.miniMapSurface.updateBiomeColorMap(biomeCoordinate, color);
        };
        this.removeLocationIcon = (iconId)=>{
            this.miniMapSurface.removeLocationIcon(iconId);
        };
        // ============================================================================
        // STATE MANAGEMENT METHODS
        // ============================================================================
        this.update = (tilemapMetaProvider, visibility)=>{
            if (tilemapMetaProvider) {
                this.tilemapMetaProvider = tilemapMetaProvider;
                // Update composite tile renderer with new tilemap meta provider
                this.compositeTileRenderer.updateTilemapMetaProvider(tilemapMetaProvider);
                // Update tile effect system with new tilemap meta provider
                this.tileEffectSystem.updateTilemapMetaProvider(tilemapMetaProvider);
                // Update sky manager with new tilemap meta provider
                this.skyManager.updateTilemapMetaProvider(tilemapMetaProvider);
                if (this.roomId !== tilemapMetaProvider.roomId) {
                    this.roomId = tilemapMetaProvider.roomId;
                    // new room boundary has been crossed
                    this.tileEffectSystem.clearSurfaceObjects();
                    this.RANDOM_NUMBER_GENERATOR = $46cd47a21442bee6$exports(this.roomId);
                    this.rngCache.clear();
                    // Reset sky state
                    this.skyManager.resetSkyState();
                    // Update tile effect system with new room context
                    this.tileEffectSystem.updateHoleEffectContext(this.roomId, this.RANDOM_NUMBER_GENERATOR);
                }
                this.rerender();
                this.cameraManagementService.updateTranslationComputer(tilemapMetaProvider);
            }
            this.visibility = visibility;
            if (this.visibility) this.visibility.lastUpdateTs = Date.now();
        };
        this.rerender = ()=>{
            if (this.isRendering) // Queue the re-render request for after current rendering completes
            this.pendingRerender = true;
            else this.needsRender = true;
        };
        this.reset = ()=>{
            this.cameraManagementService.reset();
        };
        /**
     * Clean up resources and cancel pending operations
     */ this.destroy = ()=>{
            // Clean up sprite management service
            this.spriteManagementService.destroy();
        };
        // ============================================================================
        // UTILITY/HELPER METHODS
        // ============================================================================
        this.randomIntBetweenRng = (min, max, seed)=>{
            let randomFloat;
            if (!seed) randomFloat = this.RANDOM_NUMBER_GENERATOR ? this.RANDOM_NUMBER_GENERATOR() : Math.random();
            else {
                const toUse = `${seed}-${min}-${max}-${this.roomId}`;
                randomFloat = this.rngCache.get(toUse);
                if (randomFloat === undefined) {
                    randomFloat = this.RANDOM_NUMBER_GENERATOR ? this.RANDOM_NUMBER_GENERATOR() : Math.random();
                    this.rngCache.set(toUse, randomFloat);
                }
            }
            return Math.floor(randomFloat * (max - min + 1) + min);
        };
        this.pctChance = (pct, seed)=>{
            // min and max included
            return this.randomIntBetweenRng(0, 100, seed) >= 100 - pct;
        };
        this.pertubation = (tileId, x, y, offset, type, range = 5)=>{
            const key = `${type}-${tileId}-${x}-${y}-${range}-${offset}`;
            return this.randomIntBetweenRng(-range, range, key);
        };
        // ============================================================================
        // PRIVATE HELPER METHODS
        // ============================================================================
        this.shouldRender = ()=>{
            return this.needsRender && !!this.tilemapMetaProvider;
        };
        this.prepareRendering = ()=>{
            let errorCount = 0;
            const releasedCount = this.spriteManagementService.releaseAllSprites((spriteItemObject)=>{
                const sprite = spriteItemObject.data;
                if (!sprite.parent) {
                    spriteItemObject.data = new (0, $7Bs2Z.Sprite)();
                    errorCount++;
                    return true;
                } else {
                    sprite.parent?.removeChild(sprite);
                    return false;
                }
            });
            // Sprited-layer cells use OWNED sprites (not the frame pool), so releaseAllSprites above does
            // not touch them -- destroy them here before the full rebuild. children:true tears down any
            // damage-overlay children; texture defaults false so the shared spritesheet textures survive.
            this.spritedCellSprites.forEach((sprites)=>sprites.forEach((s)=>{
                    s.parent?.removeChild(s);
                    s.destroy({
                        children: true
                    });
                }));
            this.spritedCellSprites.clear();
            this.spritedLayerIds.clear();
            this.spritedCellSurfaceId.clear();
            // A full rebuild releases every pooled sprite, which is every blade the wind was bending -- and
            // a released sprite is not merely dead, it is about to be handed to some other tile. Per-CELL
            // removals need no such hook (GrassSway prunes destroyed sprites itself), but discovering a
            // whole room's worth one frame at a time would mean bending sprites that now belong elsewhere.
            this.grassSway?.clear();
            // A full render repaints every cell, so any pending incremental dirty cells are subsumed.
            this.dirtyCells.clear();
            this.dirtyNeedsFull = false;
            // Clear tilemap renderers
            this.tilemapRendererList.forEach((renderer)=>renderer.clear());
            this.skyManager.clearSkySurfaces();
            this.tilemapRenderers.reset();
            // Clear tile effect system surface objects
            this.tileEffectSystem.clearSurfaceObjects();
        // Composite-tile textures (TileTextureExtractor.textureCache / compositeTileSpriteBounds and
        // this.compositeTileSpriteTextures) are content-addressed by `${tilesetId}-${compositeTileId}`,
        // immutable, and safely shared across rooms, so they are an intentional PERSISTENT memo --
        // NOT cleared per rerender (regenerating each rerender was a hitch) and bounded by the number
        // of distinct composite-tile types in the loaded tilesets. These were previously ".clear()"ed
        // here, but those calls were silent no-ops -- the Maps were accessed with bracket syntax, so
        // .clear() never touched the entries; the access is now .get/.set. Do NOT clear+destroy them
        // on room change: live sprites can still reference a cached texture, and destroy() nulls
        // Texture.orig, crashing any later getBounds() ("Cannot read properties of null (reading
        // 'width')").
        };
        this.renderAllLayers = ()=>{
            const { visit: visit } = this.tilemapMetaProvider;
            visit(({ tilemap: tilemap, sky: sky, sprited: sprited, mapSpriteCaps: mapSpriteCaps = [], spriteFragments: spriteFragments, index: index, layerId: layerId })=>{
                if (spriteFragments) spriteFragments.forEach((fragment)=>{
                    this.tileEffectSystem.renderSpriteFragment(fragment);
                });
                else if (sprited) this.renderSpritedLayer(tilemap, mapSpriteCaps, index, layerId);
                else if (tilemap) {
                    const tilemapRender = sky ? this.skyManager.getSkyTilemapRenderer() : this.tilemapRenderers.next().value;
                    for(let y = 0; y < this.tilemapMetaProvider.height(); y++)for(let x = 0; x < this.tilemapMetaProvider.width(); x++)this.renderAt(x, y, tilemap, sky ? "sky" : undefined, {
                        tilemapRender: tilemapRender
                    });
                }
            });
        };
        this.finalizeRendering = ()=>{
            this.miniMapSurface.update(this.tilemapMetaProvider);
            this.needsRender = false;
            this.tileEffectSystem.applyDamageVisualizationToExistingTiles(this.surfaceObjectsByKey);
        };
        // Hand the map the wind that bends its grass. Set once by the renderer at construction; the map
        // passes it down to the composite tile renderer, which is what actually builds the grass, and
        // tells it when a full rebuild has taken every blade away.
        this.setGrassSway = (grassSway)=>{
            this.grassSway = grassSway;
        };
        // Render one sprited-layer cell as an OWNED sprite (not from the frame pool) and track it per-cell
        // in spritedCellSprites so it can be removed/repainted individually (incremental redraw). Shared
        // spritesheet textures (Texture.from) are reused; only the Sprite wrapper is owned here.
        this.renderSpritedCell = (x, y, tile, layerId, index)=>{
            const tilesetTileId = this.tilemapMetaProvider.resolveTilesetTileId(tile);
            if (tile === "0" || !tile || tilesetTileId === "lpc-terrain-723") return;
            const delta = this.tilemapMetaProvider.getMapDeltaAt(x, y, layerId);
            const context = delta?.context;
            const item = {
                x: x,
                y: y,
                tile: tile,
                context: context,
                delta: !!context?.hp ? delta : undefined
            };
            try {
                const g = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).from(`${tilesetTileId}`));
                this.surface.addChild(g);
                const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                    x: x,
                    y: y
                });
                g.x = fine.x;
                g.y = fine.y;
                g.zIndex = (0, $f78f32798274f66a$export$360f852efd938c01)(index, (0, $f78f32798274f66a$export$6a603ef1f674b5ef)(item));
                const surfaceId = context?.surfaceId;
                const isParent = context?.parent && context.parent?.x === x && context.parent?.y === y;
                this.tileEffectSystem.processSurfaceId(isParent ? tilesetTileId : undefined, surfaceId, g, item.delta);
                const key = `${x}-${y}-${layerId}`;
                this.spritedLayerIds.add(layerId);
                const arr = this.spritedCellSprites.get(key);
                if (arr) arr.push(g);
                else this.spritedCellSprites.set(key, [
                    g
                ]);
                // Remember which surface this cell registered under so removeSpritedCell can detach these
                // exact sprites from the shared spriteSet on an incremental repaint.
                if (surfaceId) this.spritedCellSurfaceId.set(key, surfaceId);
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "map",
                        "error"
                    ]
                }, e);
            }
        };
        this.renderSpritedLayer = (tilemap, mapSpriteCaps, index, layerId)=>{
            // The previous per-run buffer/mapSpriteCap "splitter" machinery was vestigial: it only
            // re-assigned each sprite's z-index to the SAME per-cell value it already had (a sprited tile
            // z-sorts by its own structure base row, context.parent.y -- see sprited_tile_zindex.ts). So
            // this is now a straight per-cell render via renderSpritedCell.
            const width = this.tilemapMetaProvider.width();
            const height = this.tilemapMetaProvider.height();
            for(let x = 0; x < width; x++)for(let y = 0; y < height; y++)this.renderSpritedCell(x, y, tilemap[x][y], layerId, index);
        };
        // The sprited-layer sprites currently drawn at one map cell, across every sprited layer. This is
        // how a tile-drawn entity gets a hover outline: the V2 chest is an invisible marker standing on
        // these sprites, so they -- not the marker -- are the shape to trace. Returns live sprites in the
        // map surface's own coordinate space; callers must not retain them across a rerender.
        this.getSpritedTilesAt = (x, y)=>{
            const found = [];
            this.spritedLayerIds.forEach((layerId)=>{
                const sprites = this.spritedCellSprites.get(`${x}-${y}-${layerId}`);
                sprites?.forEach((sprite)=>{
                    if (!sprite.destroyed) found.push(sprite);
                });
            });
            return found;
        };
        // The container those sprites live in, so an outline traced from them can be parented alongside
        // and share their coordinate space without any conversion.
        this.getTileSurface = ()=>this.surface;
        // Remove (destroy) the owned sprites currently rendered for one sprited cell.
        this.removeSpritedCell = (x, y, layerId)=>{
            const key = `${x}-${y}-${layerId}`;
            const sprites = this.spritedCellSprites.get(key);
            if (!sprites) return;
            // Detach these sprites from the shared surfaceObjectsByKey spriteSet BEFORE destroying them, so
            // the tile-effect system never keeps a destroyed sprite in a surface's set. A vertical wall's
            // cap+base cells share one surfaceId, so this removes only this cell's sprites and empties the
            // surface only once its last cell is removed.
            const surfaceId = this.spritedCellSurfaceId.get(key);
            if (surfaceId) {
                this.tileEffectSystem.detachSpritesFromSurface(surfaceId, sprites);
                this.spritedCellSurfaceId.delete(key);
            }
            sprites.forEach((s)=>{
                s.parent?.removeChild(s);
                if (!s.destroyed) s.destroy({
                    children: true
                });
            });
            this.spritedCellSprites.delete(key);
        };
        // The z-index "index" a sprited layer renders with (matches renderAllLayers' visit()).
        this.spritedLayerIndex = (layerId)=>(this.tilemapMetaProvider.resolveLayerMapping(layerId)?.idx ?? 0) + 1;
        // Fade the tree canopies the LOCAL player is standing behind toward translucent, and ease the rest
        // back to opaque. Called once per frame after entities are laid out. playerZIndex mirrors
        // Mechanics.entity.body.calculateZIndexBoost for the humanoid player (100 + feet-y, defaultZIndex 0)
        // -- the same key tile sprites are z-sorted against.
        //
        // Candidates are ONLY the pooled tile sprites tagged as trees (occluderTreeTile, stamped by
        // CompositeTileRenderer from the tile's structured entityTileId via isTreeEntityTile). Ground tiles
        // are baked into CompositeTilemaps and never occlude; walls (owned sprited-cell sprites) are
        // deliberately excluded so only trees fade.
        this.applyOccluderFade = (player)=>{
            // Disabled (via the OCCLUDER_FADE_ENABLED constant or a runtime window.occluderFade.enabled
            // toggle) or no player yet: ease any residual fade back and do NO per-frame work (no pool scan).
            // The ticker calls render() every frame, including before a room's map/entities exist.
            if (!this.occluderFade.config.enabled || !player?.location) {
                this.occluderFade.relaxAll();
                this.treeSpriteBuf.length = 0 // hold no sprite refs while idle
                ;
                return;
            }
            const feetX = player.location.x;
            const feetY = player.location.y;
            this.occluderFade.update(feetX, feetY, 100 + feetY, this.collectTreeSprites());
        };
        // Reused buffer of the on-screen tree sprites, refilled each frame (never reallocated) so the fade
        // pass stays allocation-free. Scans only the pool's checked-out slots (0..ptr), not the whole
        // padded pool array; the tree tag is stamped by CompositeTileRenderer and reset on pool checkout.
        this.treeSpriteBuf = [];
        this.collectTreeSprites = ()=>{
            const buf = this.treeSpriteBuf;
            buf.length = 0;
            const pool = this.spriteManagementService.getSpritePool();
            const items = pool.items;
            const ptr = pool.ptr;
            for(let i = 0; i <= ptr; i++){
                const item = items[i];
                if (item && !item.free && item.data && item.data.occluderTreeTile === true) buf.push(item.data);
            }
            return buf;
        };
        // Called on a redrawClient signal (building/chest/door placement). Deferred to renderTileMap so it
        // runs after processPendingDeltas has applied the accompanying deltas.
        this.onRedraw = ()=>{
            this.pendingRedraw = true;
        };
        // Repaint only the delta-changed cells. Sprited-layer cells are updated in place (remove old owned
        // sprites + re-render the current tile); if any dirty cell belongs to a tilemap/sky/other layer we
        // can't update in isolation (CompositeTilemap is append+clear only), so fall back to a full rerender.
        this.repaintDirtyCells = ()=>{
            if (!this.tilemapMetaProvider || this.dirtyCells.size === 0) {
                this.dirtyCells.clear();
                this.dirtyNeedsFull = false;
                return;
            }
            // Fall back to a FULL rerender when: any dirty batch touched a removal/damaged tile (tile
            // effects -- see dirtyNeedsFull), OR any dirty cell is a non-sprited (tilemap/sky/occlusion)
            // layer that can't be updated in isolation (CompositeTilemap is append+clear only). Otherwise
            // every change is a pristine sprited placement and we repaint just those cells.
            let needFullRerender = this.dirtyNeedsFull;
            this.dirtyNeedsFull = false;
            this.dirtyCells.forEach((key)=>{
                const layerId = key.slice(key.lastIndexOf("-") + 1);
                if (this.tilemapMetaProvider.resolveLayerMapping(layerId)?.maptype !== "sprited") needFullRerender = true;
            });
            if (needFullRerender) {
                this.dirtyCells.clear();
                this.rerender();
                return;
            }
            this.dirtyCells.forEach((key)=>{
                const dash = key.lastIndexOf("-");
                const layerId = key.slice(dash + 1);
                const [x, y] = key.slice(0, dash).split("-").map(Number);
                this.removeSpritedCell(x, y, layerId);
                const tileMap = this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId);
                const tile = tileMap?.[x]?.[y];
                if (tile) this.renderSpritedCell(x, y, tile, layerId, this.spritedLayerIndex(layerId));
            });
            this.dirtyCells.clear();
        };
        this.queueMapDelta = (delta)=>{
            this.pendingMapDeltas = this.pendingMapDeltas.concat(delta);
        };
        this.processPendingDeltas = ()=>{
            if (this.pendingMapDeltas.length > 0) {
                const deltas = [
                    ...this.pendingMapDeltas
                ];
                this.pendingMapDeltas = [];
                deltas.forEach((delta)=>{
                    this.applyMapDelta(delta);
                });
            }
        };
        this.applyMapDelta = (delta)=>{
            if (!delta || !this.tilemapMetaProvider) return;
            const { x: x, y: y, blocking: blocking, occlusion: occlusion, tileId: tileId, layerId: layerId, surfaceId: surfaceId, mapSpriteCap: mapSpriteCap, collideable: collideable, temporary: temporary, context: context } = delta;
            if (tileId) {
                // Remember this cell so a following redrawClient can repaint just it (see repaintDirtyCells).
                this.dirtyCells.add(`${x}-${y}-${layerId}`);
                // A removal (destroy) or a damaged tile drives the tile-effect system -- keep it on the
                // full-rerender path so crumble/shake/holes are not raced by an incremental remove+recreate.
                if (delta.removed || context?.hp !== undefined && context?.hpMax !== undefined && context.hp < context.hpMax) this.dirtyNeedsFull = true;
                if (delta.removed) {
                    // The removal delta and the wall's "destroy" tile-effect race; the removal (which drives
                    // the surface-clearing rerender below) can win, so the destroy effect then finds no
                    // surface to shatter. Snapshot this cell's shatter textures NOW -- the surface + its
                    // live sprites still exist at this point -- so a destroy effect arriving after the
                    // rerender can still play the shatter from the snapshot.
                    const removedSurfaceId = this.spritedCellSurfaceId.get(`${x}-${y}-${layerId}`);
                    if (removedSurfaceId) this.tileEffectSystem.snapshotSurfaceForDestroy(removedSurfaceId);
                    this.tilemapMetaProvider.removeTileAt(x, y, layerId);
                } else {
                    const layerMapping = this.tilemapMetaProvider.resolveLayerMapping(layerId);
                    const tileMap = this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId) || this.tilemapMetaProvider.entityTileMap();
                    const isReplace = layerMapping?.maptype === "tilemap" && tileMap[x][y] !== "0";
                    // Preserve existing damage data when adding new tiles
                    const existingDelta = this.tilemapMetaProvider.getMapDeltaAt(x, y, layerId);
                    const existingContext = existingDelta?.context;
                    const mergedContext = {
                        ...context,
                        // Preserve existing damage data if it exists
                        ...existingContext?.hp ? {
                            hp: existingContext.hp,
                            hpMax: existingContext.hpMax
                        } : {},
                        // Preserve other existing context data
                        ...existingContext ? Object.fromEntries(Object.entries(existingContext).filter(([key, value])=>key !== "hp" && key !== "hpMax" && value !== undefined)) : {}
                    };
                    this.tilemapMetaProvider.addTileAt(x, y, blocking, occlusion, tileId, layerId, mapSpriteCap, temporary, collideable, mergedContext);
                // if (tileMap) {
                //     this.renderAt(x, y, tileMap, layerId, {
                //         wasReplaced: isReplace,
                //         surfaceId,
                //     })
                // }
                // if (mapSpriteCap) {
                //     this.tilemapMetaProvider.addMapSpriteCapAt(x, y, mapSpriteCap?.context)
                // }
                }
            } else this.tilemapMetaProvider.updateBlockingAt(x, y, blocking, false);
        };
        // ============================================================================
        // GETTERS
        // ============================================================================
        this.getVisibilityMap = ()=>!this.visibility?.mask ? undefined : this.visibility.mask;
        this.getVisibility = ()=>this.visibility;
        this.surface = surface;
        this.skySurface = skySurface;
        this.miniMapSurface = miniMapSurface;
        this.worldOverlaySurface = worldOverlaySurface;
        this.screenShakeManager = new (0, $21e34920946cefc2$export$5dbc5b3773f0a3b2)();
        this.logic = logic;
        // Initialize camera management service
        this.cameraManagementService = new (0, $ecbfd660c7b27906$export$b63e72441cbf98ad)({
            surface: this.surface,
            worldOverlaySurface: this.worldOverlaySurface,
            screenShakeManager: this.screenShakeManager
        });
        // Initialize sprite management service
        this.spriteManagementService = new (0, $2937f12c3e372b97$export$c10d0c7e188aaa18)({
            spritePoolSize: 2000,
            defaultSurface: this.surface
        });
        // Initialize sky manager
        const skyConfig = {
            skySurface: this.skySurface,
            tilemapMetaProvider: null
        };
        this.skyManager = new (0, $c83cd7e406c913d7$export$530258b752862cdf)(skyConfig);
        // Initialize composite tile renderer first
        this.compositeTileRenderer = new (0, $9973b82363bdbab3$export$ca0a091ecfb17b44)({
            surface: this.surface,
            skySpriteSurfaceAbove: null,
            tilemapMetaProvider: null,
            compositeTileSpriteTextures: this.compositeTileSpriteTextures,
            surfaceObjectsByKey: this.surfaceObjectsByKey,
            attachTexture: this.spriteManagementService.attachTexture,
            getGrassSway: ()=>this.grassSway,
            pertubation: this.pertubation,
            pctChance: this.pctChance,
            logic: this.logic,
            tileTextureExtractor: (0, $86e9e05f3ebc1d8f$export$171acc6ba80afe2).instance
        });
        // Initialize tile effect system
        const tileEffectConfig = {
            surface: this.surface,
            worldOverlaySurface: this.worldOverlaySurface,
            tilemapMetaProvider: null,
            holeEffect: new (0, $30804d8d8c7ac29a$export$d2b760035f8f14b9)("", ()=>Math.random()),
            skySpriteSurfaceAbove: null,
            skySpriteSurfaceBelow: null,
            attachTexture: this.spriteManagementService.attachTexture,
            renderCompositeTile: this.renderCompositeTile
        };
        this.tileEffectSystem = new (0, $cf8aec4e49454e2b$export$59b4c816941e3699)(tileEffectConfig, this.surfaceObjectsByKey);
    }
    get translationComputer() {
        return this.cameraManagementService.getTranslationComputer();
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

var $5UG8I = parcelRequire("5UG8I");



class $1cf3778ec61af1ce$export$46cd43cb5d943bd1 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff){
        super();
        super.beginFill(color);
        super.drawRect(0, 0, 1, 1);
        super.endFill();
    }
    recolor(color) {
        super.beginFill(color);
        super.drawRect(0, 0, 1, 1);
        super.endFill();
    }
}


class $0de04cf39fd0c1a1$export$549555cdc2ac3f0f extends (0, $gwPoJ.Graphics) {
    constructor(logic){
        super(), this.entityIdToMinimapRenderable = new Map(), this.entityUpdatePauseTs = Date.now(), this.isVisible = false, this.localBiomeColorMapUpdate = new Map(), this.localLocationIconUpdate = new Map(), this.iconChildren = new Map(), this.setup = ()=>{}, this.get = (entityId)=>{
            return this.entityIdToMinimapRenderable.get(entityId);
        }, this.entities = ()=>Array.from(this.entityIdToMinimapRenderable.keys()), this.offer = (entity, isClientPlayer = false)=>{
            const existing = this.entityIdToMinimapRenderable.get(entity);
            if (existing) {
                // already exists
                const currentRoomId = this.logic.roomId;
                const entityObj = this.logic.entityManager.get(entity);
                if (entityObj?.roomId === currentRoomId) existing.visible = true;
                return existing;
            }
            const minimapRenderable = new (0, $1cf3778ec61af1ce$export$46cd43cb5d943bd1)();
            const recolor = (color)=>{
                if (isClientPlayer) // you appear green
                minimapRenderable.recolor(color || 0x00ff00);
                else // all others appear white
                minimapRenderable.recolor(color || 0xffb6c1);
            };
            recolor();
            this.addChild(minimapRenderable);
            this.entityIdToMinimapRenderable.set(entity, minimapRenderable);
            minimapRenderable.interactive = true;
            const player = this.logic.entityManager.get(entity);
            if (player && player.entityId === this.logic.playerEntity?.entityId) {
                minimapRenderable.on("mouseover", ()=>{
                    if (this.pointHoverListener) {
                        this.pointHoverListener(true, "You");
                        minimapRenderable.recolor(0xff0000);
                    }
                });
                minimapRenderable.on("mouseout", ()=>{
                    if (this.pointHoverListener) {
                        this.pointHoverListener(false);
                        recolor();
                    }
                });
            }
            return minimapRenderable;
        }, this.remove = (entity)=>{
            const renderable = this.entityIdToMinimapRenderable.get(entity);
            if (!renderable) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "minimap",
                        "renderable"
                    ]
                }, "No renderable", entity);
                return;
            }
            this.removeChild(renderable);
            this.entityIdToMinimapRenderable.delete(entity);
            (0, $5UG8I.logger).debug({
                tags: [
                    "minimap",
                    "renderable"
                ]
            }, "Removed renderable", entity);
        }, this.roomUpdated = (suppressMinimap)=>{
            // hide everything
            this.entityIdToMinimapRenderable.forEach((renderable)=>{
                renderable.visible = false;
            });
            this.visible = !suppressMinimap;
            this.isVisible = this.visible;
            this.entityUpdatePauseTs = Date.now() + 500;
        }, this.updateBiomeColorMap = (coordinate, color)=>{
            if (color === 0) return;
            const key = `${coordinate.x}-${coordinate.y}`;
            if (this.localBiomeColorMapUpdate.get(key) === color) return;
            this.localBiomeColorMapUpdate.set(key, color);
            this.beginFill(color, 0.4);
            this.drawRect(coordinate.x, coordinate.y, 1, 1);
            this.endFill();
        }, this.clearBiomeColorMap = ()=>{
            this.clear();
            this.localBiomeColorMapUpdate.clear();
        }, this.removeLocationIcon = (iconId)=>{
            const sprite = this.iconChildren.get(iconId);
            this.localLocationIconUpdate.delete(iconId);
            if (sprite) sprite.parent.removeChild(sprite);
            this.iconChildren.delete(iconId);
        }, this.updateLocationIcon = (icon)=>{
            const key = icon.id;
            if (this.localLocationIconUpdate.has(key)) return;
            const quadrantCoordinate = this.computeQuadrantOffsetCoordinate();
            if (!quadrantCoordinate) // minimapConfig isn't set yet -- a location-icon update arrived over the socket before
            // the map's update() ran (or this map has no minimap config). Skip: update() redraws all
            // icons once a config is present, and this icon isn't marked seen so it retries.
            return;
            const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: icon.icon,
                color: 0xffffff,
                scale: 0.05
            });
            sprite.x = icon.x - quadrantCoordinate.x + sprite.width / 2;
            sprite.y = icon.y - quadrantCoordinate.y + sprite.height / 2;
            this.addChild(sprite);
            this.iconChildren.set(key, sprite);
            sprite.interactive = true;
            const original = sprite.tint;
            sprite.on("mouseover", (event)=>{
                if (this.pointHoverListener) {
                    this.pointHoverListener(true, icon.name);
                    sprite.recolor(0xff0000);
                }
            });
            sprite.on("mouseout", ()=>{
                if (this.pointHoverListener) {
                    this.pointHoverListener(false);
                    sprite.recolor(original || 0xffffff);
                }
            });
            this.localLocationIconUpdate.set(key, sprite);
            this.pulseLocation(icon.id);
        }, this.flashMap = ()=>{
            if (this.mapIsFlashing) return;
            const overlay = new (0, $gwPoJ.Graphics)();
            overlay.zIndex = 0;
            overlay.x = this.x;
            overlay.y = this.y;
            this.parent.addChild(overlay);
            overlay.beginFill(0xffffff, 0.5);
            overlay.drawRect(0, 0, this.width, this.height);
            overlay.endFill();
            this.mapIsFlashing = true;
            const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(overlay, {
                blinkInterval: 50,
                minAlpha: 0.1,
                expires: 750,
                releaseCallback: ()=>{
                    this.parent.removeChild(overlay);
                    this.mapIsFlashing = false;
                }
            });
            throbber.update();
        }, this.pulseLocation = (locationId, expires = 10000)=>{
            this.logic.audio.mapLocationFound();
            this.flashMap();
            const location = this.localLocationIconUpdate.get(locationId);
            if (location) {
                const originalColor = location.currentColor;
                location.recolor(0xff0000);
                const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(location, {
                    blinkInterval: 50,
                    minAlpha: 0.5,
                    expires: expires,
                    releaseCallback: ()=>{
                        location.recolor(originalColor);
                    }
                });
                throbber.update();
            }
        }, this.computeQuadrantOffsetCoordinate = ()=>{
            if (!this.minimapConfig) return null;
            const { worldMetaDimensions: worldMetaDimensions } = this.minimapConfig;
            const biomeQuadrantStrideX = worldMetaDimensions.roomWidth / worldMetaDimensions.sectorWidth;
            const biomeQuadrantStrideY = worldMetaDimensions.roomHeight / worldMetaDimensions.sectorHeight;
            const quadrantBiomesWidth = biomeQuadrantStrideX * worldMetaDimensions.quadrantWidth;
            const quadrantBiomesHeight = biomeQuadrantStrideY * worldMetaDimensions.quadrantHeight;
            const quadrantCoordinate = (0, $a80d0b17b615d6f7$export$be3fee91976fb47a)(this.logic.quadrantId);
            quadrantCoordinate.x = quadrantCoordinate.x * quadrantBiomesWidth;
            quadrantCoordinate.y = quadrantCoordinate.y * quadrantBiomesHeight;
            return quadrantCoordinate;
        }, this.update = (tilemapMetaProvider)=>{
            if (!tilemapMetaProvider) return;
            const wasEmpty = this.localLocationIconUpdate.size < 1;
            const previousLocationIds = [
                ...this.localLocationIconUpdate.keys()
            ];
            this.minimapConfig = tilemapMetaProvider.minimapConfig;
            this.localBiomeColorMapUpdate.clear();
            this.localLocationIconUpdate.clear();
            this.clear();
            this.iconChildren.forEach((child)=>{
                this.removeChild(child);
            });
            this.iconChildren.clear();
            const { biomeColorMap: biomeColorMap, locationIcons: locationIcons } = tilemapMetaProvider;
            if (biomeColorMap) {
                for(let x = 0; x < biomeColorMap.length; x++)for(let y = 0; y < biomeColorMap[0].length; y++){
                    const color = biomeColorMap[x][y];
                    // Skip empty cells: color 0 would otherwise fill a black 40%-alpha rect over
                    // every empty biome cell (a visible overlay) and emit an O(w*h) run of fill
                    // commands. Matches the incremental updateBiomeColorMap path, which also skips 0.
                    if (color !== 0) {
                        const key = `${x}-${y}`;
                        this.localBiomeColorMapUpdate.set(key, color);
                        this.beginFill(color, 0.4);
                        this.drawRect(x, y, 1, 1);
                        this.endFill();
                    }
                }
            }
            if (locationIcons) {
                const quadrantCoordinate = this.computeQuadrantOffsetCoordinate();
                locationIcons.forEach((icon)=>{
                    if (!quadrantCoordinate) // No minimap config -> no quadrant offset -> nothing to place (matches updateLocationIcon).
                    return;
                    if (icon.quadrantId && icon.quadrantId !== this.logic.quadrantId) return;
                    const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: icon.icon,
                        color: 0xffffff,
                        scale: 0.05
                    });
                    sprite.x = icon.x - quadrantCoordinate.x + sprite.width / 2;
                    sprite.y = icon.y - quadrantCoordinate.y + sprite.height / 2;
                    this.addChild(sprite);
                    this.iconChildren.set(icon.id, sprite);
                    const key = icon.id;
                    const shouldPulse = !wasEmpty && !previousLocationIds.includes(key);
                    this.localLocationIconUpdate.set(key, sprite);
                    sprite.interactive = true;
                    let original;
                    sprite.on("mouseover", (event)=>{
                        if (this.pointHoverListener) {
                            original = sprite.getCurrentColor();
                            this.pointHoverListener(true, icon.name);
                            sprite.recolor(0xff0000);
                        }
                    });
                    sprite.on("mouseout", ()=>{
                        if (this.pointHoverListener) {
                            this.pointHoverListener(false);
                            sprite.recolor(original);
                        }
                    });
                    shouldPulse;
                });
            }
            this.width = 100;
            this.height = 100;
            this.visible = this.isVisible;
        }, this.updateEntity = (entity, roomId, location, force = false)=>{
            if (!force && Date.now() < this.entityUpdatePauseTs) return;
            const minimapRenderable = this.entityIdToMinimapRenderable.get(entity);
            if (!minimapRenderable) return;
            const [_, roomX, roomY] = roomId.split("-");
            const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(location);
            const roughRoomX = rough.x;
            const roughRoomY = rough.y;
            if (!minimapRenderable.visible) minimapRenderable.visible = true;
            if (this.minimapConfig?.biomeBased) {
                const { worldMetaDimensions: worldMetaDimensions } = this.minimapConfig;
                const biomeX = roughRoomX / worldMetaDimensions.sectorWidth;
                const biomeY = roughRoomY / worldMetaDimensions.sectorHeight;
                const biomeQuadrantStrideX = worldMetaDimensions.roomWidth / worldMetaDimensions.sectorWidth;
                const biomeQuadrantStrideY = worldMetaDimensions.roomHeight / worldMetaDimensions.sectorHeight;
                const globalX = Number(roomX) * biomeQuadrantStrideX + biomeX;
                const globalY = Number(roomY) * biomeQuadrantStrideY + biomeY;
                const quadrantBiomesWidth = biomeQuadrantStrideX * worldMetaDimensions.quadrantWidth;
                const quadrantBiomesHeight = biomeQuadrantStrideY * worldMetaDimensions.quadrantHeight;
                minimapRenderable.x = Math.min(globalX % quadrantBiomesWidth, quadrantBiomesWidth - 1);
                minimapRenderable.y = Math.min(globalY % quadrantBiomesHeight, quadrantBiomesHeight - 1);
            } else {
                minimapRenderable.x = roughRoomX;
                minimapRenderable.y = roughRoomY;
            }
            this.width = 100;
            this.height = 100;
        }, this.register = (listener)=>this.pointHoverListener = listener;
        this.logic = logic;
        this.visible = false;
    }
}



const $23e67fb1a742a4ea$var$getIntersection = (ray, segment)=>{
    // RAY in parametric: Point + Delta*T1
    var r_px = ray.a.x;
    var r_py = ray.a.y;
    var r_dx = ray.b.x - ray.a.x;
    var r_dy = ray.b.y - ray.a.y;
    // SEGMENT in parametric: Point + Delta*T2
    var s_px = segment.a.x;
    var s_py = segment.a.y;
    var s_dx = segment.b.x - segment.a.x;
    var s_dy = segment.b.y - segment.a.y;
    // Are they parallel? If so, no intersect
    var r_mag = Math.sqrt(r_dx * r_dx + r_dy * r_dy);
    var s_mag = Math.sqrt(s_dx * s_dx + s_dy * s_dy);
    if (r_dx / r_mag == s_dx / s_mag && r_dy / r_mag == s_dy / s_mag) // Unit vectors are the same.
    return null;
    // SOLVE FOR T1 & T2
    // r_px+r_dx*T1 = s_px+s_dx*T2 && r_py+r_dy*T1 = s_py+s_dy*T2
    // ==> T1 = (s_px+s_dx*T2-r_px)/r_dx = (s_py+s_dy*T2-r_py)/r_dy
    // ==> s_px*r_dy + s_dx*T2*r_dy - r_px*r_dy = s_py*r_dx + s_dy*T2*r_dx - r_py*r_dx
    // ==> T2 = (r_dx*(s_py-r_py) + r_dy*(r_px-s_px))/(s_dx*r_dy - s_dy*r_dx)
    var T2 = (r_dx * (s_py - r_py) + r_dy * (r_px - s_px)) / (s_dx * r_dy - s_dy * r_dx);
    var T1 = (s_px + s_dx * T2 - r_px) / r_dx;
    // Must be within parametic whatevers for RAY/SEGMENT
    if (T1 < 0) return null;
    if (T2 < 0 || T2 > 1) return null;
    // Return the POINT OF INTERSECTION
    return {
        x: r_px + r_dx * T1,
        y: r_py + r_dy * T1,
        param: T1
    };
};
const $23e67fb1a742a4ea$export$a30470b4ef717782 = (segments, sightX, sightY)=>{
    // Track all unique points
    const unqiuePointsMap = {};
    // RAYS IN ALL DIRECTIONS
    let intersects = [];
    const handleAngle = (angle)=>{
        // Calculate dx & dy from angle
        const dx = Math.cos(angle);
        const dy = Math.sin(angle);
        // Ray from center of screen to mouse
        const ray = {
            a: {
                x: sightX,
                y: sightY
            },
            b: {
                x: sightX + dx,
                y: sightY + dy
            }
        };
        // Find CLOSEST intersection
        let closestIntersect = null;
        for(let i = 0; i < segments.length; i++){
            const intersect = $23e67fb1a742a4ea$var$getIntersection(ray, segments[i]);
            if (!intersect) continue;
            if (!closestIntersect || intersect.param < closestIntersect.param) closestIntersect = intersect;
        }
        // Intersect angle
        if (!closestIntersect) return;
        closestIntersect.angle = angle;
        // Add to list of intersects
        intersects.push(closestIntersect);
    };
    const handleUniqueAngle = (vector)=>{
        const key = `${vector.x}-${vector.y}`;
        if (unqiuePointsMap[key]) return;
        unqiuePointsMap[key] = true;
        const angle = Math.atan2(vector.y - sightY, vector.x - sightX);
        handleAngle(angle - 0.00001);
        handleAngle(angle);
        handleAngle(angle + 0.00001);
    };
    segments.forEach((seg)=>{
        handleUniqueAngle(seg.a);
        handleUniqueAngle(seg.b);
    });
    // Sort intersects by angle
    intersects = intersects.sort((a, b)=>{
        return b.angle - a.angle;
    });
    // Polygon is intersects, in order of angle
    return intersects;
};
const $23e67fb1a742a4ea$export$691dec627034f05a = (segments, sightX, sightY, size = 100, skip = 0)=>segments.filter((s, i)=>i <= skip || Math.abs(sightX - s.a.x) < size && Math.abs(sightY - s.a.y) < size || Math.abs(sightX - s.b.x) < size && Math.abs(sightY - s.b.y) < size);


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $1avo5 = parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");

var $5UG8I = parcelRequire("5UG8I");


class $cb0ab22baf2add07$export$fe76cdfccd658eb {
    constructor(app, surface, debug, logic){
        this.lastLocation = {
            x: -1,
            y: -1
        };
        this.cleared = true;
        this.translationComputer = new (0, $4c699c02db426c96$export$7d222435fcebb768)();
        // NEW: Texture caching and dirty flagging properties
        this.needsTextureUpdate = false;
        this.lastVisibilityHash = "";
        this.cachedVisibilityHash = "";
        this.textureCache = new Map();
        this.maxCacheSize = 10 // Limit cache size to prevent memory leaks
        ;
        this.debugHashCalculation = false // Debug flag for hash calculation logging
        ;
        this.renderVisibility = (visionOptions)=>{
            const shouldRender = this.prepare(visionOptions);
            if (!shouldRender) return false;
            // NEW: Only render if we need to update the texture
            if (this.needsTextureUpdate) {
                this.render();
                this.needsTextureUpdate = false;
            }
            return true;
        };
        this.prepare = ({ polyMap: polyMap, location: location, visibility: visibility, debug: debug, lights: lights })=>{
            if (!this.logic.tilemapMetaProvider) return false;
            const darkness = visibility?.darkness;
            const hasDarkness = darkness < 1.0;
            const hasPolymap = polyMap?.length > 0;
            if (this.roomId !== this.logic.tilemapMetaProvider?.roomId) {
                this.lastLocation = {
                    x: -1,
                    y: -1
                };
                this.translationComputer.update(this.logic.tilemapMetaProvider);
                this.roomId = this.logic.tilemapMetaProvider.roomId;
                // NEW: Clear cache on room change
                this.clearTextureCache();
            }
            if (!hasPolymap && !hasDarkness && this.cleared === false) {
                this.translationComputer.reset();
                this.visibilitySurface.clear();
                this.cleared = true;
                this.surface.mask = undefined;
                if (this.visibilitySprite) this.app.stage.removeChild(this.visibilitySprite);
                this.lastLocation = {
                    x: -1,
                    y: -1
                };
                // NEW: Clear cache when visibility is disabled
                this.clearTextureCache();
                return false;
            }
            const lightsChanged = this.lightLastChangedTs !== lights?.lastUpdatedTs;
            const playerLocationChanged = !(location.x === this.lastLocation.x && location.y === this.lastLocation.y);
            const darknessChanged = this.latestDarkness !== darkness;
            // NEW: Calculate visibility hash to determine if update is needed
            const hashState = {
                polyMap: polyMap,
                location: location,
                visibility: visibility,
                lights: lights,
                playerLocationChanged: playerLocationChanged,
                lightsChanged: lightsChanged,
                darknessChanged: darknessChanged
            };
            if (this.debugHashCalculation) this.debugHashCalculationLog(hashState);
            const currentVisibilityHash = this.computeVisibilityHash(hashState);
            if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "cache",
                    "debug"
                ]
            }, `[Shadow Cache] Current hash: ${currentVisibilityHash}, Cached hash: ${this.cachedVisibilityHash}`);
            // NEW: Check if we can reuse a cached texture first
            const cachedTexture = this.textureCache.get(currentVisibilityHash);
            if (cachedTexture) {
                // Cache hit - reuse existing texture
                if (this.visibilitySprite) this.visibilitySprite.texture = cachedTexture;
                this.cachedVisibilityHash = currentVisibilityHash;
                this.needsTextureUpdate = false // Mark as cache hit
                ;
                if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                    tags: [
                        "shadow",
                        "cache",
                        "hit"
                    ]
                }, `[Shadow Cache] Cache HIT for hash: ${currentVisibilityHash}`);
                return true;
            }
            // NEW: Check if we already have the same hash (no changes needed)
            if (currentVisibilityHash === this.cachedVisibilityHash) {
                this.needsTextureUpdate = false // Mark as cache hit
                ;
                if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                    tags: [
                        "shadow",
                        "cache",
                        "hit"
                    ]
                }, `[Shadow Cache] Same hash, no update needed: ${currentVisibilityHash}`);
                return true;
            }
            // Check if we should skip expensive operations based on old logic
            if (!hasPolymap) {
                // there isn't a poly map. In this case, then we don't care about player location changes,
                // only pure darkness changes
                if (!hasDarkness || this.translationComputer.ready() && !darknessChanged && !playerLocationChanged && !lightsChanged) return false;
            } else // there's a poly map. in this case we care about player changes
            if (!playerLocationChanged && !lightsChanged) {
                if (this.visibilityLastUpdateTs === visibility?.lastUpdateTs) return false;
            }
            if (this.visibilityLastUpdateTs !== visibility?.lastUpdateTs) this.visibilityLastUpdateTs = visibility?.lastUpdateTs;
            this.lightLastChangedTs = lights.lastUpdatedTs;
            this.latestDarkness = darkness;
            this.cleared = false;
            const g = this.visibilitySurface;
            g.clear();
            const playerLocation = {
                x: location.x,
                y: location.y
            };
            this.translationComputer.compute(playerLocation);
            let { modifierX: modifierX, modifierY: modifierY, xStatus: xStatus, yStatus: yStatus } = this.translationComputer;
            if (modifierX === undefined) {
                if (xStatus === "left") modifierX = -180;
                if (xStatus === "right") modifierX = -1330;
            }
            if (modifierY === undefined) {
                if (yStatus === "top") modifierY = -80;
                if (yStatus === "bottom") modifierY = -1420;
            }
            if (modifierX !== undefined) // g.transform.position.x = ((-playerLocation.x + modifierX + ScreenDimensions.w / 2) * 2) - 32 * 11
            g.transform.position.x = (modifierX + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w / 2) * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom - 48 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
            if (modifierY !== undefined) // g.transform.position.y = ((-playerLocation.y + modifierY + ScreenDimensions.h / 2) * 2) - 32 * 7
            g.transform.position.y = (modifierY + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2) * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom - 48 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportY;
            if (hasPolymap) {
                const vs = visibility?.range || 600;
                // Top
                polyMap[0] = {
                    a: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y - vs
                    },
                    b: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y - vs
                    }
                };
                // Bottom
                polyMap[1] = {
                    a: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y + vs
                    },
                    b: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y + vs
                    }
                };
                // Left
                polyMap[2] = {
                    a: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y - vs
                    },
                    b: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y + vs
                    }
                };
                // Right
                polyMap[3] = {
                    a: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y - vs
                    },
                    b: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y + vs
                    }
                };
                const prunedSegments = (0, $23e67fb1a742a4ea$export$691dec627034f05a)(polyMap, playerLocation.x, playerLocation.y, vs, 3);
                let polygons = [
                    (0, $23e67fb1a742a4ea$export$a30470b4ef717782)(prunedSegments, playerLocation.x, playerLocation.y)
                ];
                if (debug) {
                    // debug.transform.position.x = -playerLocation.x + 50 + ScreenDimensions.w / 2
                    // debug.transform.position.y = -playerLocation.y + 50 + ScreenDimensions.h / 2
                    debug.transform.position.x = (-playerLocation.x + 50 + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w / 2) * 2 - 32 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
                    debug.transform.position.y = (-playerLocation.y + 50 + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2) * 2 - 32 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportY;
                    debug.clear();
                    const lineMap = prunedSegments.reduce((acc, x)=>{
                        acc.push(x.a);
                        acc.push(x.b);
                        return acc;
                    }, []);
                    debug.beginFill(0xff0000, 0.95);
                    for (let point of lineMap)debug.drawCircle(point.x, point.y, 3);
                    debug.endFill();
                    debug.beginFill(0x00ff00, debug ? 0.2 : 1);
                    for (let polygon of polygons)for (let point of polygon)debug.drawCircle(point.x, point.y, 3);
                    debug.endFill();
                    debug.beginFill(0xff0000, 0.2);
                    for (let polygon of polygons)debug.drawPolygon(polygon);
                    debug.endFill();
                }
                g.beginFill(0xff0000, darkness);
                for (let polygon of polygons)g.drawPolygon(polygon);
                g.endFill();
            }
            if (darkness !== undefined) {
                g.beginFill(0xfffffff, hasPolymap ? 0.01 : darkness);
                // for now -- hardcode to large map size
                g.drawRect(0, 0, this.logic.tilemapMetaProvider.width() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), this.logic.tilemapMetaProvider.height() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                g.endFill();
            }
            if (darkness !== undefined && lights) lights.iterate((light)=>{
                const { location: { x: x, y: y }, intensity: intensity, radius: radius } = light;
                g.beginFill(0xffffff, intensity);
                g.drawCircle(x, y, radius);
                g.endFill();
            });
            this.lastLocation.x = location.x;
            this.lastLocation.y = location.y;
            // NEW: Mark that texture needs update and update cached hash
            this.needsTextureUpdate = true;
            this.cachedVisibilityHash = currentVisibilityHash;
            if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "cache",
                    "miss"
                ]
            }, `[Shadow Cache] Cache MISS for hash: ${currentVisibilityHash}`);
            return true;
        };
        this.render = ()=>{
            // NEW: Check if we can reuse a cached texture
            const currentHash = this.cachedVisibilityHash;
            let textureToUse = this.textureCache.get(currentHash);
            if (!textureToUse) {
                // Create new texture. Do NOT destroy this.visibilityTexture here: it is always a member
                // of textureCache (see line where textureToUse is assigned below), so destroying it would
                // leave a freed texture (baseTexture === null) sitting in the cache. A later cache hit on
                // that hash would then assign the dead texture to the sprite and crash in Sprite.set
                // ("Cannot read properties of null (reading 'valid')"). Texture lifetime is owned solely
                // by the cache (manageCacheSize / clearTextureCache).
                if (!this.visibilityBounds) this.visibilityBounds = new (0, $6qzqq.Rectangle)(0, 0, 27 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 16 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                textureToUse = this.app.renderer.generateTexture(this.visibilitySurface, {
                    region: this.visibilityBounds
                });
                // NEW: Cache the new texture
                this.textureCache.set(currentHash, textureToUse);
                this.manageCacheSize();
                if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                    tags: [
                        "shadow",
                        "cache",
                        "create"
                    ]
                }, `[Shadow Cache] Created and cached texture for hash: ${currentHash}`);
            } else if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "cache",
                    "reuse"
                ]
            }, `[Shadow Cache] Reusing cached texture for hash: ${currentHash}`);
            this.visibilityTexture = textureToUse;
            if (!this.visibilitySprite) this.visibilitySprite = new (0, $7Bs2Z.Sprite)(this.visibilityTexture);
            else this.visibilitySprite.texture = this.visibilityTexture;
            this.surface.mask = this.visibilitySprite;
            this.visibilitySprite.x = 0;
            this.visibilitySprite.y = 0;
            this.app.stage.addChild(this.visibilitySprite);
        };
        this.renderPipLightMask = (opts)=>{
            const { cx: cx, cy: cy, zoom: zoom, texW: texW, texH: texH, resolution: resolution, visibility: visibility, lights: lights } = opts;
            const darkness = visibility?.darkness;
            // No darkness in this room → no mask (the PiP renders at full brightness, same as the world).
            if (darkness === undefined || darkness >= 1.0) return undefined;
            if (!this.pipDarkness) {
                this.pipDarkness = new (0, $gwPoJ.Graphics)();
                // Soften the light edges, mirroring the main mask's blur (scaled down for the PiP zoom).
                this.pipDarkness.filters = [
                    new (0, $1avo5.filters).BlurFilter(10)
                ];
            }
            if (!this.pipMaskTexture || this.pipMaskTexture.width !== texW || this.pipMaskTexture.height !== texH || this.pipMaskTexture.baseTexture.resolution !== resolution) {
                this.pipMaskTexture?.destroy(true);
                this.pipMaskTexture = (0, $klOfb.RenderTexture).create({
                    width: texW,
                    height: texH,
                    resolution: resolution
                });
                this.pipMaskSprite = new (0, $7Bs2Z.Sprite)(this.pipMaskTexture);
            }
            const g = this.pipDarkness;
            g.clear();
            // Base dim fill over just the visible PiP region (a small margin covers the blur bleed at the
            // edges). Bounding it to the view keeps the blur-filter texture small instead of map-sized.
            const halfW = texW / zoom / 2;
            const halfH = texH / zoom / 2;
            const margin = 48;
            g.beginFill(0xffffff, darkness);
            g.drawRect(cx - halfW - margin, cy - halfH - margin, (halfW + margin) * 2, (halfH + margin) * 2);
            g.endFill();
            // Brighter "holes" at each in-view light's world position (matches prepare()'s light pass).
            lights?.iterate((light)=>{
                const { location: { x: x, y: y }, intensity: intensity, radius: radius } = light;
                if (Math.abs(x - cx) > halfW + radius || Math.abs(y - cy) > halfH + radius) return;
                g.beginFill(0xffffff, intensity);
                g.drawCircle(x, y, radius);
                g.endFill();
            });
            // Bake the world→PiP-texture framing into the graphics transform (identical to the surface
            // transform in renderWorldToTexture), so the mask lines up pixel-for-pixel with the world.
            g.position.set(texW / 2 - cx * zoom, texH / 2 - cy * zoom);
            g.scale.set(zoom);
            this.app.renderer.render(g, {
                renderTexture: this.pipMaskTexture,
                clear: true
            });
            return this.pipMaskSprite;
        };
        // NEW: Clear texture cache to prevent memory leaks
        this.clearTextureCache = ()=>{
            this.textureCache.forEach((texture)=>texture.destroy(true));
            this.textureCache.clear();
            this.cachedVisibilityHash = "";
            this.needsTextureUpdate = true;
        };
        // NEW: Manage cache size to prevent memory leaks
        this.manageCacheSize = ()=>{
            if (this.textureCache.size > this.maxCacheSize) {
                // Remove oldest entries (simple FIFO)
                const entries = Array.from(this.textureCache.entries());
                const toRemove = entries.slice(0, entries.length - this.maxCacheSize);
                toRemove.forEach(([key, texture])=>{
                    // Never evict/destroy the texture currently bound to the mask sprite; freeing it
                    // would leave the sprite pointing at a dead texture and crash on the next frame.
                    if (texture === this.visibilityTexture) return;
                    texture.destroy(true);
                    this.textureCache.delete(key);
                });
            }
        };
        // NEW: Public method to force texture update (useful for debugging)
        this.forceTextureUpdate = ()=>{
            this.needsTextureUpdate = true;
            this.clearTextureCache();
        };
        // NEW: Get cache statistics for monitoring
        this.getCacheStats = ()=>{
            return {
                cacheSize: this.textureCache.size,
                maxCacheSize: this.maxCacheSize,
                lastVisibilityHash: this.cachedVisibilityHash,
                needsUpdate: this.needsTextureUpdate
            };
        };
        // NEW: Debug method to log current state
        this.debugLog = ()=>{
            const stats = this.getCacheStats();
            (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "debug",
                    "cache"
                ]
            }, `[Shadow Debug] Cache: ${stats.cacheSize}/${stats.maxCacheSize}, Needs Update: ${stats.needsUpdate}, Hash: ${stats.lastVisibilityHash}`);
        };
        // NEW: Debug method to log hash calculation details
        this.debugHashCalculationLog = (state)=>{
            const { polyMap: polyMap, location: location, visibility: visibility, lights: lights, playerLocationChanged: playerLocationChanged, lightsChanged: lightsChanged, darknessChanged: darknessChanged } = state;
            const locationKey = `${location.x}-${location.y}`;
            const darknessKey = visibility?.darkness?.toString() || "1.0";
            const lightsKey = lights?.lastUpdatedTs?.toString() || "0";
            const polyMapKey = polyMap?.length?.toString() || "0";
            const changeFlags = `${playerLocationChanged ? "1" : "0"}${lightsChanged ? "1" : "0"}${darknessChanged ? "1" : "0"}`;
            (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "debug",
                    "hash"
                ]
            }, `[Shadow Hash Debug] Location: ${locationKey}, Darkness: ${darknessKey}, Lights: ${lightsKey}, PolyMap: ${polyMapKey}, Changes: ${changeFlags}`);
        };
        this.app = app;
        this.surface = surface;
        this.logic = logic;
        const visibilitySurface = new (0, $gwPoJ.Graphics)();
        if (!debug) visibilitySurface.filters = [
            new (0, $1avo5.filters).BlurFilter(50)
        ];
        visibilitySurface.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this.visibilitySurface = visibilitySurface;
        this.translationComputer.noDelay = true;
    }
    // NEW: Compute a hash of the current visibility state
    computeVisibilityHash(state) {
        const { polyMap: polyMap, location: location, visibility: visibility, lights: lights } = state;
        // Create a hash based on key factors that affect visibility.
        //
        // The location goes in at FULL precision. It used to be quantized to a 32px tile, which is
        // wrong for a mask baked in SCREEN space: prepare() positions the graphics with the camera
        // modifier taken from this exact location, so two positions inside one tile bake to
        // different places. Quantizing them to the same hash froze the mask while the world went on
        // scrolling, and every light -- the player's own and every campfire's -- slid against the
        // ground by however far the camera had moved, then snapped back on the next real bake.
        //
        // It survived locally because the OTHER half of the hash is lights.lastUpdatedTs, and the
        // lights are re-registered by entity_rendering_manager.update(), whose only callers are the
        // server-message handlers. On localhost an update lands on essentially every frame, so the
        // hash changed anyway; at 50ms it lands on ~3 frames in 4, and the rest drew a stale mask.
        // Measured on production: up to 9px of slide per snap in ordinary walking (~20 CSS px at a
        // typical canvas scale), and 50px across a burst of late frames.
        const locationKey = `${location.x}-${location.y}`;
        const darknessKey = visibility?.darkness?.toString() || "1.0";
        const lightsKey = lights?.lastUpdatedTs?.toString() || "0";
        const polyMapKey = polyMap?.length?.toString() || "0";
        const visibilityKey = visibility?.lastUpdateTs?.toString() || "0";
        return `${locationKey}-${darknessKey}-${lightsKey}-${polyMapKey}-${visibilityKey}`;
    }
}



var $aFPGo = parcelRequire("aFPGo");

parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");


// How much of the day it is, for the ambience effects that only belong at one end of it: windblown
// leaves by day (wind_leaves.ts), fog by night (night_fog.ts). One place, so the two cross-fade
// against the same numbers instead of drifting apart.
//
// WHY BRIGHTNESS AND NOT THE PHASE NAME. The engine has six phases, each with a brightness
// (game-common/mechanics/physics_mechanics.ts):
//
//     darkestNight 0.2   night 0.3   dawn 0.4   dusk 0.5   morning 0.7   day 1.0
//
// and the client walks `currentBrightness` between them a hundredth at a time rather than snapping
// (ClientGameLogic.updateDayPhase). Reading the interpolated value means an effect dies across the
// whole of dusk and gets up across the whole of the morning; reading the phase NAME would step it,
// and a wind that stops mid-gust on a phase boundary looks like a bug.
// At or below STILL there is no daylight left as far as these effects are concerned; at or above FULL
// it is broad day; between them it ramps. This puts dawn (0.4) and every darker phase at zero and
// morning (0.7) upward at one, leaving dusk (0.5) as the half-lit third.
//
// 0.42 sits deliberately BETWEEN two phase brightnesses. On a threshold a settled phase could land
// exactly on, an effect that starts and stops at the boundary would flicker on and off forever.
const $eca6088c9a6d9651$export$9916be3f5943c55c = 0.42;
const $eca6088c9a6d9651$export$82825f99e114a585 = 0.7;
const $eca6088c9a6d9651$export$45f6af437d59d9ba = (brightness)=>{
    if (brightness === undefined) return 1;
    const span = $eca6088c9a6d9651$export$82825f99e114a585 - $eca6088c9a6d9651$export$9916be3f5943c55c;
    return Math.min(1, Math.max(0, (brightness - $eca6088c9a6d9651$export$9916be3f5943c55c) / span));
};
const $eca6088c9a6d9651$export$92091d9bb73d8475 = (brightness)=>1 - $eca6088c9a6d9651$export$45f6af437d59d9ba(brightness);


const $3462bfbeaff010be$export$4bccb4f7607c3eec = 22;
const $3462bfbeaff010be$export$7bac97f9fd8f9135 = 0.6;
const $3462bfbeaff010be$export$4e07af95bd4178be = (tSeconds, gustiness)=>Math.max(0.15, 1 + gustiness * (0.62 * Math.sin(tSeconds * 0.41) + 0.38 * Math.sin(tSeconds * 1.13 + 1.7)));
const $3462bfbeaff010be$export$317929bda4a1dd52 = (config, tSeconds)=>{
    const w = window;
    const forced = typeof w.windLeaves === "boolean" ? w.windLeaves : undefined;
    const enabled = forced !== undefined ? forced : !!config?.enabled;
    if (!enabled) return null;
    const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
    const rad = num(w.windLeavesDirection, config?.directionDeg, $3462bfbeaff010be$export$4bccb4f7607c3eec) * Math.PI / 180;
    const gustiness = Math.min(1, Math.max(0, num(w.windLeavesGust, config?.gustiness, $3462bfbeaff010be$export$7bac97f9fd8f9135)));
    return {
        x: Math.cos(rad),
        y: Math.sin(rad),
        gust: $3462bfbeaff010be$export$4e07af95bd4178be(tSeconds, gustiness)
    };
};


class $be65b55052fa66e7$export$b384c8d4ebe6bf23 {
    static{
        // Above the fog and the grass, below the windblown leaves, well under the sky.
        this.Z_INDEX = 898000;
    }
    static{
        // However many a room asks for. They are cheap, but they are also meant to be rare.
        this.MAX_BUTTERFLIES = 24;
    }
    static{
        this.DEFAULT_COUNT = 3;
    }
    static{
        // Cruising speed. A butterfly beating ten times a second and barely crossing a tile reads as
        // swimming in treacle -- the eye checks the two against each other and knows. See FLAP_REFERENCE.
        this.DEFAULT_SPEED = 58;
    }
    static{
        this.DEFAULT_ALPHA = 0.95;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.34;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.52;
    }
    static{
        // Cabbage whites and brimstones, mostly: pale colours are what stay legible against grass. The one
        // orange is the occasional fritillary, and it is the one anybody will actually notice.
        this.DEFAULT_COLORS = [
            0xfdf6e3,
            0xfff4b8,
            0xf7e7a8,
            0xffffff,
            0xe8a33d
        ];
    }
    static{
        // The travel speed a butterfly's own wingbeat is quoted against. The beat is derived from how fast
        // it is actually going, not set independently, so the two can never drift apart: a butterfly
        // sheltering from a gust slows AND beats more slowly, and a fast one beats harder. Getting this
        // wrong in either direction is immediately obvious and hard to name -- it just looks wrong.
        this.FLAP_REFERENCE = 58;
    }
    static{
        // The box they are kept in, as a half-extent in world px around the player -- the visible world
        // plus a margin, same as the leaves.
        this.HALF_W = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.HALF_H = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Inside this fraction of the box they fly freely; past it they are steered back. Kept well inside
        // the edge so the turn happens off-screen and reads as a butterfly changing its mind.
        this.HOME_FRACTION = 0.72;
    }
    static{
        // A jump bigger than this is a teleport or a room change, not walking.
        // How far it will go looking for somewhere to land. Kept inside its own box, or one would set off
        // across the map towards a tuft you cannot see.
        this.PERCH_SEARCH = 5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Close enough to have landed. Small, because the approach steps straight in and clamps to the
        // remaining distance -- there is no "close enough" jump to hide.
        this.PERCH_ARRIVE = 0.05;
    }
    static{
        // How long it sits, before the gust makes it sit longer.
        this.PERCH_DWELL_MS = [
            2200,
            7000
        ];
    }
    static{
        // ...and how long it flies before it thinks about landing again.
        this.FLIGHT_MS = [
            2500,
            9000
        ];
    }
    static{
        // The lazy open-and-close of a settled butterfly's wings, in radians/sec. A deliberate exception to
        // the beat being derived from travel: a perched one is not travelling at all, so the derived beat
        // would be zero and the wings would simply freeze wherever they stopped.
        this.PERCHED_FLAP_RATE = 2.2;
    }
    static{
        this.TELEPORT_JUMP = $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W;
    }
    constructor(makeTextures, findPerch){
        this.makeTextures = makeTextures;
        this.findPerch = findPerch;
        this.butterflies = [];
        this.activeCount = 0;
        this.textures = [];
        this.running = false;
        this.lastMs = 0;
        this.lastCenterX = 0;
        this.lastCenterY = 0;
        this.hasCenter = false;
        this.// Exposed for tests: how many are currently flying.
        getActiveCount = ()=>this.running ? this.activeCount : 0;
        this.// Exposed for tests: how many are currently sitting on something.
        getPerchedCount = ()=>this.running ? this.butterflies.slice(0, this.activeCount).filter((b)=>b.state === "perched").length : 0;
        this./**
     * Fly them for one frame. `brightness` is the client's interpolated daylight, or undefined in a
     * room with no day cycle (which counts as day). Cheap to call every frame in any room.
     */ update = (config, center, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved || !center) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                this.running = true;
                this.container.visible = true;
                this.lastMs = nowMs;
                this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                this.hasCenter = true;
                return;
            }
            this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
            if (this.hasCenter && (Math.abs(center.x - this.lastCenterX) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.TELEPORT_JUMP || Math.abs(center.y - this.lastCenterY) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.TELEPORT_JUMP)) {
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastMs = nowMs;
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                return;
            }
            this.lastCenterX = center.x;
            this.lastCenterY = center.y;
            this.hasCenter = true;
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            // Clamped for the same reason as the leaves: a tab returning from the background would
            // otherwise advance every butterfly by minutes in one step.
            dt = Math.min(dt, 0.05);
            this.step(dt, nowMs, center.x, center.y, resolved);
        };
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
            this.lastMs = 0;
            this.hasCenter = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.butterflies === "boolean" ? w.butterflies : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            // Forcing them on from the console lifts the day gate too -- otherwise there is no way to look
            // at them except by waiting for the right hour.
            const dayOnly = forced === true ? false : config?.dayOnly !== false;
            const day = dayOnly ? (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness) : 1;
            if (day <= 0) return null;
            // The shared wind, if this room has any. A gust is the one thing that stops a butterfly flying,
            // so its strength is read here and spent on speed below. A room with no wind is simply calm.
            const wind = (0, $3462bfbeaff010be$export$317929bda4a1dd52)(null, performance.now() / 1000);
            const gust = wind ? wind.gust : 1;
            // Sheltering: brisk in a lull, much slower at the top of a gust. Floored well above zero --
            // because the wingbeat follows the speed, a butterfly slowed to a crawl would also stop
            // flapping, which reads as one dying rather than one waiting out a gust.
            const shelter = Math.min(1, Math.max(0.45, 1.3 - gust * 0.5));
            const scaleMin = config?.scaleMin ?? $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_SCALE_MAX;
            return {
                // Fewer about as the light goes, and none once it is properly dark.
                count: Math.max(day > 0 ? 1 : 0, Math.min($be65b55052fa66e7$export$b384c8d4ebe6bf23.MAX_BUTTERFLIES, Math.round(num(w.butterflyCount, config?.count, $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_COUNT) * day))),
                speed: Math.max(1, num(w.butterflySpeed, config?.speed, $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_SPEED)) * shelter,
                // Sinking a little in the gust as well as slowing, which is what sheltering looks like.
                bobScale: shelter,
                alpha: Math.min(1, Math.max(0, num(w.butterflyAlpha, config?.alpha, $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_ALPHA))) * day,
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                colors: config?.colors?.length ? config.colors : $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_COLORS
            };
        };
        this.step = (dt, nowMs, centerX, centerY, cfg)=>{
            const perching = window.butterflyPerch !== false;
            const homeW = $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            const homeH = $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_H * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            for(let i = 0; i < this.activeCount; i++){
                const b = this.butterflies[i];
                // PERCHED: sitting still, wings opening and closing lazily, until its time is up.
                if (b.state === "perched") {
                    b.flapPhase += $be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCHED_FLAP_RATE * dt;
                    const sprite = b.sprite;
                    sprite.x = b.x;
                    sprite.y = b.y;
                    // Wings held mostly open and moved gently, rather than folding right down: a settled
                    // butterfly fans them, it does not beat them.
                    const fan = 0.45 + 0.55 * Math.abs(Math.cos(b.flapPhase));
                    sprite.rotation = b.heading + Math.PI / 2;
                    sprite.scale.set(b.scale * fan, b.scale);
                    sprite.alpha = b.baseAlpha * cfg.alpha;
                    if (nowMs >= b.stateUntilMs) {
                        b.state = "flying";
                        b.heading = Math.random() * Math.PI * 2;
                        b.headingTarget = b.heading;
                        b.nextTurnMs = nowMs + 300;
                        b.stateUntilMs = nowMs + $be65b55052fa66e7$export$b384c8d4ebe6bf23.pick($be65b55052fa66e7$export$b384c8d4ebe6bf23.FLIGHT_MS);
                    }
                    continue;
                }
                // FLYING, and long enough since the last rest to think about landing. A gust makes it
                // readier to settle -- being blown about is what sends one looking for a leaf.
                if (b.state === "flying" && nowMs >= b.stateUntilMs && this.findPerch && perching) {
                    const spot = this.findPerch(b.x, b.y, $be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCH_SEARCH);
                    if (spot) {
                        b.state = "approaching";
                        b.perchX = spot.x;
                        b.perchY = spot.y;
                    } else // Nowhere to land here; try again shortly rather than every frame.
                    b.stateUntilMs = nowMs + 1500;
                }
                // Pick somewhere new to be heading, every second or so. This is the wander.
                if (b.state === "flying" && nowMs >= b.nextTurnMs) {
                    b.headingTarget = b.heading + (Math.random() * 2 - 1) * 1.6;
                    b.nextTurnMs = nowMs + 500 + Math.random() * 1600;
                }
                // Past the inner boundary, the next decision is made for it: turn back towards the middle.
                // Steering rather than teleporting is the whole difference between milling about a meadow
                // and being blown across one.
                const outX = b.x - centerX;
                const outY = b.y - centerY;
                // Stranded well outside the box -- however it got there -- is not something to steer back
                // from, because at twenty pixels a second it would take the best part of a minute. Put it
                // back. Nothing should reach this now that the pool places what it creates; it is here so
                // that if anything ever does, it self-corrects rather than going missing.
                if (Math.abs(outX) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W * 2 || Math.abs(outY) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_H * 2) {
                    this.place(b, centerX, centerY, cfg, nowMs);
                    continue;
                }
                if (Math.abs(outX) > homeW || Math.abs(outY) > homeH) b.headingTarget = Math.atan2(-outY, -outX) + (Math.random() * 2 - 1) * 0.5;
                // APPROACHING: go straight at the spot rather than steering onto it.
                //
                // Two reasons it is handled here instead of by the heading, which was the first attempt.
                // A butterfly whose turn rate cannot keep up ORBITS the spot forever, circling something a
                // few pixels away; and arriving "close enough" and then snapping the last couple of pixels
                // is a jump of a whole body length at this size. Stepping straight in, clamped so it
                // cannot overshoot, lands exactly on the spot and cannot circle it.
                if (b.state === "approaching") {
                    const dx = b.perchX - b.x;
                    const dy = b.perchY - b.y;
                    const distance = Math.hypot(dx, dy) || 1;
                    // Ease off, but LATE and not by much. A butterfly does not glide in on a long approach;
                    // it flies at the flower at pace and drops onto it over the last few body-lengths. This
                    // holds full speed until about thirteen pixels out -- three or four of its own
                    // wingspans -- and then eases to half. An earlier, deeper ramp (from six tiles out,
                    // down to a fifth of speed) read as swimming towards the leaf.
                    //
                    // The wingbeat follows travel speed, so this is also what makes it settle rather than
                    // stop dead: the beat drops with the approach on its own.
                    const closing = Math.min(1, 0.5 + distance / (0.8 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
                    const travel = b.speed * cfg.speed * closing;
                    const stepLength = Math.min(distance, travel * dt);
                    b.x += dx / distance * stepLength;
                    b.y += dy / distance * stepLength;
                    b.heading = Math.atan2(dy, dx);
                    b.headingTarget = b.heading;
                    b.flapPhase += b.flapRate * (travel / $be65b55052fa66e7$export$b384c8d4ebe6bf23.FLAP_REFERENCE) * dt;
                    if (distance - stepLength <= $be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCH_ARRIVE) {
                        b.x = b.perchX;
                        b.y = b.perchY;
                        b.state = "perched";
                        b.stateUntilMs = nowMs + $be65b55052fa66e7$export$b384c8d4ebe6bf23.pick($be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCH_DWELL_MS) * (2 - cfg.bobScale);
                    }
                    this.draw(b, cfg, 0);
                    continue;
                }
                // Ease the heading towards the target so a turn is a curve, and take the SHORT way round --
                // without this a butterfly turning past due west unwinds the long way, a full circle.
                let delta = b.headingTarget - b.heading;
                while(delta > Math.PI)delta -= Math.PI * 2;
                while(delta < -Math.PI)delta += Math.PI * 2;
                b.heading += delta * Math.min(1, dt * 3.5);
                // How fast this one is actually travelling right now, after its own variation and after
                // sheltering from the wind.
                const travel = b.speed * cfg.speed;
                b.x += Math.cos(b.heading) * travel * dt;
                b.y += Math.sin(b.heading) * travel * dt;
                // The wingbeat is DERIVED from that, so distance covered per beat stays roughly constant
                // whatever the speed. Set the two independently and they disagree the moment either one
                // changes -- which is exactly how this looked first: beating hard and going nowhere.
                b.flapPhase += b.flapRate * (travel / $be65b55052fa66e7$export$b384c8d4ebe6bf23.FLAP_REFERENCE) * dt;
                this.draw(b, cfg, cfg.bobScale);
            }
        };
        this.draw = (b, cfg, bobStrength)=>{
            const sprite = b.sprite;
            // The wings fold almost shut and spring open twice per bob -- abs() of a cosine gives the
            // sharp turn at the moment they are closed, which a plain sine would round off into a pulse.
            // This is the single cue that says "butterfly" at this size.
            const wing = 0.18 + 0.82 * Math.abs(Math.cos(b.flapPhase));
            // ...and the body rises once per cycle, off the same phase.
            const lift = Math.sin(b.flapPhase) * b.bob * bobStrength;
            sprite.x = b.x;
            sprite.y = b.y + lift;
            // The art is drawn with the body along -y, so this turns the body to face the heading.
            sprite.rotation = b.heading + Math.PI / 2;
            sprite.scale.set(b.scale * wing, b.scale);
            sprite.alpha = b.baseAlpha * cfg.alpha;
        };
        this.ensurePool = (count, centerX, centerY, cfg, nowMs)=>{
            const target = Math.min(count, $be65b55052fa66e7$export$b384c8d4ebe6bf23.MAX_BUTTERFLIES);
            if (!this.textures.length && target > 0) {
                try {
                    this.textures = this.makeTextures();
                } catch (e) {
                    this.textures = [];
                }
                if (!this.textures.length) this.textures = [
                    (0, $klOfb.Texture).WHITE
                ];
            }
            while(this.butterflies.length < target){
                const sprite = new (0, $7Bs2Z.Sprite)(this.textures[this.butterflies.length % this.textures.length] ?? (0, $klOfb.Texture).WHITE);
                sprite.anchor.set(0.5);
                this.container.addChild(sprite);
                const butterfly = {
                    sprite: sprite,
                    x: 0,
                    y: 0,
                    heading: 0,
                    headingTarget: 0,
                    nextTurnMs: 0,
                    speed: 1,
                    flapPhase: 0,
                    flapRate: 1,
                    bob: 1,
                    scale: 0.4,
                    baseAlpha: 1,
                    state: "flying",
                    perchX: 0,
                    perchY: 0,
                    stateUntilMs: 0
                };
                this.butterflies.push(butterfly);
                this.place(butterfly, centerX, centerY, cfg, nowMs);
            }
            if (target === this.activeCount) return;
            for(let i = 0; i < this.butterflies.length; i++)this.butterflies[i].sprite.visible = i < target;
            this.activeCount = target;
        };
        this.scatter = (centerX, centerY, cfg, nowMs)=>{
            for(let i = 0; i < this.activeCount; i++)this.place(this.butterflies[i], centerX, centerY, cfg, nowMs);
        };
        this.place = (b, centerX, centerY, cfg, nowMs)=>{
            this.randomize(b, cfg, nowMs);
            b.x = centerX + (Math.random() * 2 - 1) * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            b.y = centerY + (Math.random() * 2 - 1) * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_H * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            b.sprite.x = b.x;
            b.sprite.y = b.y;
        };
        this.randomize = (b, cfg, nowMs)=>{
            const rand = (min, max)=>min + Math.random() * (max - min);
            b.heading = Math.random() * Math.PI * 2;
            b.headingTarget = b.heading;
            b.nextTurnMs = nowMs + Math.random() * 1200;
            // Always airborne to begin with, and never still believing it is mid-landing: this also runs
            // when one is re-placed after a teleport or when the pool grows, and a stale perch target
            // would send it back across the room to a tuft of grass that is no longer there.
            b.state = "flying";
            b.perchX = 0;
            b.perchY = 0;
            b.stateUntilMs = nowMs + $be65b55052fa66e7$export$b384c8d4ebe6bf23.pick($be65b55052fa66e7$export$b384c8d4ebe6bf23.FLIGHT_MS);
            b.speed = rand(0.7, 1.35);
            // Six to eight VISIBLE flaps a second at the reference speed, scaled from there by how fast
            // this one is actually going.
            //
            // Note the factor of pi rather than 2pi: the wings fold on abs(cos), which closes them TWICE
            // per phase cycle, so a phase rate of 2pi*f gives 2f flaps. Quoting this in cycles instead of
            // flaps is how it first ended up at 12-16 a second -- a bee's buzz, where a butterfly's flap is
            // slow and floppy and is half the reason you can tell one from the other across a field.
            b.flapRate = rand(Math.PI * 6, Math.PI * 8);
            b.bob = rand(1.1, 2.4);
            b.scale = rand(cfg.scaleMin, cfg.scaleMax);
            b.baseAlpha = rand(0.85, 1);
            b.sprite.texture = this.textures[Math.floor(Math.random() * this.textures.length)] ?? (0, $klOfb.Texture).WHITE;
            b.sprite.tint = cfg.colors[Math.floor(Math.random() * cfg.colors.length)];
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $be65b55052fa66e7$export$b384c8d4ebe6bf23.Z_INDEX;
        container.interactiveChildren = false;
        container.visible = false;
        this.container = container;
    }
    static{
        // A value from a [min, max] range.
        this.pick = ([min, max])=>min + Math.random() * (max - min);
    }
    static{
        /**
     * The butterfly art, generated once rather than shipped: a body along -y with a fore and hind wing
     * either side, drawn white so a single texture serves the whole palette by tint.
     *
     * The body runs along the sprite's Y axis so that squashing X folds the wings towards it -- get
     * that the other way round and the flap squashes the butterfly along its length instead, which
     * reads as a bug being stepped on rather than one in flight.
     */ this.buildButterflyTextures = (generate)=>{
            // [forewing radius, hindwing radius, body length]. Two shapes is enough variety at this size.
            const shapes = [
                [
                    5,
                    3.6,
                    9
                ],
                [
                    4.2,
                    3,
                    7.5
                ]
            ];
            return shapes.map(([fore, hind, body])=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.beginFill(0xffffff);
                // Forewings, set slightly forward of centre, and the smaller hindwings behind them.
                g.drawEllipse(-fore * 0.75, -body * 0.18, fore, fore * 0.78);
                g.drawEllipse(fore * 0.75, -body * 0.18, fore, fore * 0.78);
                g.drawEllipse(-hind * 0.8, body * 0.25, hind, hind * 0.85);
                g.drawEllipse(hind * 0.8, body * 0.25, hind, hind * 0.85);
                g.endFill();
                // The body, darker so it survives tinting as a visible seam between the wings -- without it
                // the two halves merge into one blob the moment the wings fold.
                g.beginFill(0x6b6b6b);
                g.drawEllipse(0, 0, body * 0.11, body * 0.5);
                g.endFill();
                const texture = generate(g);
                g.destroy();
                return texture;
            });
        };
    }
    static{
        // The default texture factory, bound to a live renderer. Split out so the flight can be tested
        // without a GPU.
        this.textureFactory = (renderer)=>()=>$be65b55052fa66e7$export$b384c8d4ebe6bf23.buildButterflyTextures((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");



class $aa1fa3752bebfcbe$export$14e015fa5aada1ce {
    static{
        // Under the overlay surface's own items (chat bubbles, HUD), which sit at zero.
        this.Z_INDEX = -100;
    }
    static{
        this.MAX_FIREFLIES = 40;
    }
    static{
        this.DEFAULT_COUNT = 5;
    }
    static{
        // How long one flash lasts, in seconds -- the difference between a firefly and a SPARK. The eye
        // needs long enough to find the thing, look at it, and watch it go out.
        //
        // A DURATION, not a share of the cycle. As a share it was the product of two separate random draws
        // (the share and the period), which spread it from one second to nearly three and moved it
        // whenever the cycle was retuned. How long a glow lasts and how often it comes round are two
        // different questions and are asked separately here.
        this.DEFAULT_FLASH_SECONDS = 2.5;
    }
    static{
        // A flash cannot outlast its own cycle, however it is configured.
        this.MAX_LIT_FRACTION = 0.75;
    }
    static{
        this.DEFAULT_ALPHA = 0.95;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.55;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.95;
    }
    static{
        // Yellow-green, which is what the real ones are and what reads as a living light rather than a
        // lamp. The cooler one is the odd variation.
        this.DEFAULT_COLORS = [
            0xd8ff8a,
            0xc6ff70,
            0xeaff9e,
            0xa8ff86
        ];
    }
    static{
        // How far one strays from its home point.
        this.HOVER_RADIUS = 0.85 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // ...and how quickly it gets there. Enough to look busy over a small patch.
        this.DART_SPEED = 26;
    }
    static{
        this.HALF_W = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.HALF_H = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Beyond THIS it is re-homed. Deliberately outside the range it is placed in: a firefly homed near
        // the edge of the box and then hovering outward would otherwise trip the recycle and be flung to
        // the far side, every time it drifted.
        this.RECYCLE_W = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_W + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.RECYCLE_H = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_H + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.TELEPORT_JUMP = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_W;
    }
    constructor(makeTexture){
        this.makeTexture = makeTexture;
        this.flies = [];
        this.activeCount = 0;
        this.running = false;
        this.lastMs = 0;
        this.lastCenterX = 0;
        this.lastCenterY = 0;
        this.hasCenter = false;
        this.// Exposed for tests: how many are about, and how many are lit this instant.
        getActiveCount = ()=>this.running ? this.activeCount : 0;
        this.getLitCount = ()=>this.running ? this.flies.slice(0, this.activeCount).filter((f)=>f.sprite.visible).length : 0;
        this.update = (config, center, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved || !center) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                this.running = true;
                this.container.visible = true;
                this.lastMs = nowMs;
                this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                this.hasCenter = true;
                return;
            }
            this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
            if (this.hasCenter && (Math.abs(center.x - this.lastCenterX) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.TELEPORT_JUMP || Math.abs(center.y - this.lastCenterY) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.TELEPORT_JUMP)) {
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastMs = nowMs;
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                return;
            }
            this.lastCenterX = center.x;
            this.lastCenterY = center.y;
            this.hasCenter = true;
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            dt = Math.min(dt, 0.05);
            this.step(dt, nowMs, center.x, center.y, resolved);
        };
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
            this.lastMs = 0;
            this.hasCenter = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.fireflies === "boolean" ? w.fireflies : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            // Forcing them on from the console lifts the night gate as well; there is no other way to look
            // at them in daylight.
            const nightOnly = forced === true ? false : config?.nightOnly !== false;
            const night = nightOnly ? (0, $eca6088c9a6d9651$export$92091d9bb73d8475)(brightness) : 1;
            if (night <= 0) return null;
            const scaleMin = config?.scaleMin ?? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_SCALE_MAX;
            return {
                // More of them the darker it gets, and none at all before dusk.
                count: Math.max(night > 0 ? 1 : 0, Math.min($aa1fa3752bebfcbe$export$14e015fa5aada1ce.MAX_FIREFLIES, Math.round(num(w.fireflyCount, config?.count, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_COUNT) * night))),
                flashSeconds: Math.max(0.1, num(w.fireflyFlashSeconds, config?.flashSeconds, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_FLASH_SECONDS)),
                alpha: Math.min(1, Math.max(0, num(w.fireflyAlpha, config?.alpha, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_ALPHA))) * night,
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                colors: config?.colors?.length ? config.colors : $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_COLORS
            };
        };
        this.step = (dt, nowMs, centerX, centerY, cfg)=>{
            for(let i = 0; i < this.activeCount; i++){
                const f = this.flies[i];
                // Wandered off the edge of what could be on screen -- re-home it on the other side. Doing
                // this only WHILE DARK is what makes it free: a firefly between flashes is not on screen,
                // so there is nothing to see move.
                if (!f.sprite.visible && (Math.abs(f.homeX - centerX) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.RECYCLE_W || Math.abs(f.homeY - centerY) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.RECYCLE_H)) this.place(f, centerX, centerY, cfg, nowMs);
                // Somewhere new in its patch to dart to, every so often. Short hops with pauses between
                // read as busy; one long drift reads as floating away.
                if (nowMs >= f.nextDartMs) {
                    const angle = Math.random() * Math.PI * 2;
                    const reach = Math.random() * $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HOVER_RADIUS;
                    f.targetX = f.homeX + Math.cos(angle) * reach;
                    f.targetY = f.homeY + Math.sin(angle) * reach * 0.7;
                    f.nextDartMs = nowMs + 260 + Math.random() * 900;
                }
                // Ease towards it, clamped so it cannot overshoot and jitter around the target.
                const dx = f.targetX - f.x;
                const dy = f.targetY - f.y;
                const distance = Math.hypot(dx, dy);
                if (distance > 0.01) {
                    const stepLength = Math.min(distance, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DART_SPEED * dt);
                    f.x += dx / distance * stepLength;
                    f.y += dy / distance * stepLength;
                }
                f.phase = (f.phase + f.cycleRate * dt) % 1;
                // THE FLASH. Lit for the opening slice of the cycle and dark for all the rest -- and dark
                // means hidden, not faint: a firefly between flashes is gone, and a dim dot hanging there
                // would give away that it never left.
                const sprite = f.sprite;
                if (f.phase < f.litFraction) {
                    const u = f.phase / f.litFraction;
                    // Rise, HOLD, fade. The hold is the point: a bare rise-and-fall curve peaks for an
                    // instant and is gone, which is what made these read as sparks however long the window
                    // was. Coming up quickly, sitting there, and fading out slowly is what a firefly does.
                    const glow = u < 0.22 ? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.smooth(u / 0.22) : u > 0.55 ? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.smooth((1 - u) / 0.45) : 1;
                    sprite.visible = true;
                    sprite.x = f.x;
                    sprite.y = f.y;
                    sprite.alpha = f.peakAlpha * cfg.alpha * glow;
                    // Swells very slightly as it brightens, which reads as light spilling rather than a
                    // sprite fading up.
                    sprite.scale.set(f.scale * (0.85 + 0.15 * glow));
                } else if (sprite.visible) sprite.visible = false;
            }
        };
        this.ensurePool = (count, centerX, centerY, cfg, nowMs)=>{
            const target = Math.min(count, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.MAX_FIREFLIES);
            if (!this.texture && target > 0) try {
                this.texture = this.makeTexture();
            } catch (e) {
                this.texture = (0, $klOfb.Texture).WHITE;
            }
            while(this.flies.length < target){
                const sprite = new (0, $7Bs2Z.Sprite)(this.texture ?? (0, $klOfb.Texture).WHITE);
                sprite.anchor.set(0.5);
                // A glow is light, not a pale sprite.
                sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
                sprite.visible = false;
                this.container.addChild(sprite);
                const fly = {
                    sprite: sprite,
                    homeX: 0,
                    homeY: 0,
                    x: 0,
                    y: 0,
                    targetX: 0,
                    targetY: 0,
                    nextDartMs: 0,
                    phase: 0,
                    cycleRate: 0.3,
                    litFraction: 0.2,
                    scale: 0.7,
                    peakAlpha: 1
                };
                this.flies.push(fly);
                // Placed as it is created, not merely constructed -- the count rises as the light goes, so
                // this runs at dusk and not only on the first frame.
                this.place(fly, centerX, centerY, cfg, nowMs);
            }
            if (target === this.activeCount) return;
            for(let i = 0; i < this.flies.length; i++)if (i >= target) this.flies[i].sprite.visible = false;
            this.activeCount = target;
        };
        this.scatter = (centerX, centerY, cfg, nowMs)=>{
            for(let i = 0; i < this.activeCount; i++)this.place(this.flies[i], centerX, centerY, cfg, nowMs);
        };
        this.place = (f, centerX, centerY, cfg, nowMs)=>{
            const rand = (min, max)=>min + Math.random() * (max - min);
            f.homeX = centerX + (Math.random() * 2 - 1) * $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_W;
            f.homeY = centerY + (Math.random() * 2 - 1) * $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_H;
            f.x = f.homeX;
            f.y = f.homeY;
            f.targetX = f.homeX;
            f.targetY = f.homeY;
            f.nextDartMs = nowMs + Math.random() * 600;
            // A random starting point in the cycle, so they do not all flash together the moment they are
            // placed. Real ones do synchronise; a whole camp doing it in step on the first frame after
            // dusk would read as a bug rather than as a phenomenon.
            f.phase = Math.random();
            // Seven to twelve seconds a cycle -- and this, not the lit fraction, is what decides how OFTEN
            // the camp flashes. Five of them on a ten-second cycle is a glow about every two seconds
            // somewhere in the trees, which is the "odd firefly" this is meant to be. On the two-to-five
            // seconds it had first, the same five read as a scattering of sparks going off constantly.
            f.cycleRate = rand(0.08, 0.14);
            // The lit share is DERIVED from the wanted duration and this one's own cycle, so the flash is
            // the length it was asked to be whatever period it happens to have drawn. The small variation
            // is on the duration, so no two are identical without any of them being the wrong length.
            const flashSeconds = cfg.flashSeconds * rand(0.85, 1.15);
            f.litFraction = Math.min($aa1fa3752bebfcbe$export$14e015fa5aada1ce.MAX_LIT_FRACTION, flashSeconds * f.cycleRate);
            f.scale = rand(cfg.scaleMin, cfg.scaleMax);
            f.peakAlpha = rand(0.8, 1);
            f.sprite.visible = false;
            f.sprite.tint = cfg.colors[Math.floor(Math.random() * cfg.colors.length)];
            // Put the sprite where the firefly is, even though it is dark and nothing will look at it
            // until it flashes. A hidden sprite left at its old position is a stale reading waiting for
            // whatever asks next -- and `step` only writes a position on the frames it is lit.
            f.sprite.x = f.x;
            f.sprite.y = f.y;
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.Z_INDEX;
        container.interactiveChildren = false;
        container.visible = false;
        // The overlay surface is camera-translated but NOT zoomed, so this container carries the zoom
        // and everything inside it is in plain world coordinates.
        container.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this.container = container;
    }
    static{
        // Smoothstep: eases in and out instead of ramping linearly, so neither end of a flash has a corner
        // on it.
        this.smooth = (t)=>{
            const u = Math.min(1, Math.max(0, t));
            return u * u * (3 - 2 * u);
        };
    }
    static{
        /**
     * The glow, generated once: a small bright core inside a soft halo, drawn white so one texture
     * serves every tint. Stacked translucent circles rather than a blur filter -- a filter would want
     * a render target for something that is four rings of a Graphics.
     */ this.buildGlowTexture = (generate)=>{
            const g = new (0, $gwPoJ.Graphics)();
            const RINGS = 7;
            const OUTER = 9;
            for(let i = RINGS; i >= 1; i--){
                const radius = OUTER * i / RINGS;
                // Falls off faster than linear so the core stays tight and the halo stays faint; a linear
                // ramp gives a soft ball with no centre to it.
                const alpha = 0.1 * Math.pow(1 - (i - 1) / RINGS, 1.6);
                g.beginFill(0xffffff, alpha);
                g.drawCircle(0, 0, radius);
                g.endFill();
            }
            // The core itself, near solid.
            g.beginFill(0xffffff, 0.95);
            g.drawCircle(0, 0, 1.4);
            g.endFill();
            const texture = generate(g);
            g.destroy();
            return texture;
        };
    }
    static{
        this.textureFactory = (renderer)=>()=>$aa1fa3752bebfcbe$export$14e015fa5aada1ce.buildGlowTexture((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}



// The flora tiles the world is decorated with, and the one arithmetic fact needed to recognise them
// again on the client.
//
// These indices MATCH the game's own procedural biome generators (packages/tools/src/mapgen/biomes),
// which is what makes ember decoration read like the rest of the world. Most live in the
// "lpc-flowers-plants-fungi-wood" tileset; the small terrain flowers live in "lpc-terrain".
//
// Layer conventions follow the game too: flat vegetation the player walks in front of (bushes, flower
// patches, small flowers) goes on map2, tall grass that y-sorts like a plant -- you can stand behind
// it -- goes on the entity-tile surface (map3, same layer as trees), and fine forest litter goes on
// map4. All are purely cosmetic and non-blocking.
const $757b61c60f0c23c3$export$fae1c8fa1221db37 = "lpc-flowers-plants-fungi-wood";
const $757b61c60f0c23c3$export$417c9cba6e63b540 = "lpc-terrain";
const $757b61c60f0c23c3$export$10eda66a00e50d39 = 227 // dense tall-grass fill -- addLongGrass' 95% pick
;
const $757b61c60f0c23c3$export$3e2090e8a40a2fc7 = [
    160,
    161,
    162,
    177,
    178
] // sparser tufts -- addLongGrass' 5% variety
;
const $757b61c60f0c23c3$export$1ce2c088de1b2a1c = [
    376,
    412,
    412,
    408
] // leafy/round shrubs, per Plains biome (412 weighted)
;
const $757b61c60f0c23c3$export$c13ebf3c1e690fc9 = [
    29,
    45
] // yellow / white flower patches, per Plains biome
;
const $757b61c60f0c23c3$export$e8b67ad437d4386e = [
    355,
    356,
    357
] // small red wildflowers (lpc-terrain), per Plains
;
const $757b61c60f0c23c3$export$c5676199efd017fe = [
    452,
    436,
    421
] // forest-floor twigs, per Forest biome
;
const $757b61c60f0c23c3$export$e9f428948ba22692 = [
    353,
    354,
    355
] // forest-floor mushrooms (the mushroom items' tiles)
;
const $757b61c60f0c23c3$export$b5fe4f8e2269498c = (tilesetId, tilePos)=>`${tilesetId}-${tilePos + 1}`;
const $757b61c60f0c23c3$export$480d4dd19409d344 = (tilesetId, tilePositions)=>tilePositions.map((tilePos)=>$757b61c60f0c23c3$export$b5fe4f8e2269498c(tilesetId, tilePos));
const $757b61c60f0c23c3$export$33e4a0514d95213f = [
    {
        tilesetId: $757b61c60f0c23c3$export$fae1c8fa1221db37,
        tilePositions: [
            $757b61c60f0c23c3$export$10eda66a00e50d39
        ],
        lean: 4.5
    },
    {
        tilesetId: $757b61c60f0c23c3$export$fae1c8fa1221db37,
        tilePositions: $757b61c60f0c23c3$export$3e2090e8a40a2fc7,
        lean: 2.8
    }
];
const $757b61c60f0c23c3$export$166f49b89327c25e = $757b61c60f0c23c3$export$33e4a0514d95213f.reduce((acc, { tilesetId: tilesetId, tilePositions: tilePositions, lean: lean })=>{
    $757b61c60f0c23c3$export$480d4dd19409d344(tilesetId, tilePositions).forEach((id)=>{
        acc[id] = lean;
    });
    return acc;
}, {});




class $59052a7f89e51e65$export$7d832ea11681c35b {
    static{
        // How fast a blade oscillates, in radians/sec, before the console multiplier.
        this.FREQUENCY = 1.9;
    }
    static{
        // How far apart the crests of the travelling wave are, in world px. About six tiles: short enough
        // that a gust is visibly moving across the view, long enough that neighbours lean together.
        this.WAVELENGTH = 6 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // How much a blade's own phase is scattered off the wave front, in radians.
        this.JITTER = 0.9;
    }
    static{
        // The bend is a horizontal shear, so only the wind's horizontal component can show as a lean -- a
        // wind blowing straight up or down the screen bends grass towards the viewer, which a flat sprite
        // cannot draw. Rooms with a cross-screen wind (ember's is 22 degrees) get the full effect.
        //
        // The hinge height: the blade pivots about the bottom of its cell.
        this.HINGE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Beyond the viewport by this much is still updated, so a blade is already mid-lean when it scrolls
        // in rather than snapping upright to bent on its first visible frame.
        this.MARGIN = 2 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // The wind calms after dark but never stops: the leaves settle for the night (day_gate.ts) and the
        // grass keeps a little stir, so the world does not freeze solid the moment the fog comes up.
        this.NIGHT_CALM = 0.3;
    }
    static{
        // Where the bend profile starts, as a share of the full lean, at the top of the piece sitting ON
        // the anchor row. Not zero: grass rooted in the ground still stirs low down, and a base held
        // perfectly rigid under a leaning top reads as a hinge rather than as a plant.
        this.ROOT_SHARE = 0.18;
    }
    static{
        // How far the player may move before the near set is gathered again. Half the margin, so a blade
        // cannot cross the whole margin and reach the screen before it is picked up.
        this.REGATHER = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    constructor(){
        this.blades = [];
        this.running = false;
        // The blades near enough to matter, rebuilt only when the player has actually moved somewhere new.
        // A room holds well over a thousand blades and fewer than a twentieth are ever on screen; testing
        // every one of them every frame measured at about 0.8ms a frame on a fast machine, which is real
        // money on the low-end target for an effect nobody is looking directly at.
        this.visible = [];
        this.visibleAtX = 0;
        this.visibleAtY = 0;
        this.visibleValid = false;
        /**
     * Take an interest in a sprited cell, if it is something that bends. Called for every sprited cell
     * the map renders, so it has to be cheap and it has to say no quickly.
     */ this.register = (sprite, cellX, cellY, textureId, heightAbove = 0)=>{
            const lean = (0, $757b61c60f0c23c3$export$166f49b89327c25e)[textureId];
            if (lean === undefined) return;
            // Where this piece's two edges sit on the plant's bend profile. `heightAbove` is the sub-tile's
            // own row above the anchor, so the profile is evaluated at the top of this piece and at the top
            // of the piece below it -- which is this one's bottom. Cumulative by construction: the joins
            // cannot come apart, however hard the wind blows.
            //
            // The ground itself never moves, so the base piece's bottom is pinned at zero.
            const profile = (h)=>lean * (h + $59052a7f89e51e65$export$7d832ea11681c35b.ROOT_SHARE) / (1 + $59052a7f89e51e65$export$7d832ea11681c35b.ROOT_SHARE);
            const leanTop = profile(heightAbove);
            const leanBottom = heightAbove === 0 ? 0 : profile(heightAbove - 1);
            const worldX = cellX * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const worldY = cellY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            this.blades.push({
                sprite: sprite,
                baseX: sprite.x,
                worldX: worldX,
                worldY: worldY,
                leanTop: leanTop,
                leanBottom: leanBottom,
                // A cheap positional hash: no per-blade storage, stable across a rebuild of the same room,
                // and uncorrelated enough between neighbours to break up the wave front.
                jitter: Math.sin(cellX * 12.9898 + cellY * 78.233) * 43758.5453 % 1 * $59052a7f89e51e65$export$7d832ea11681c35b.JITTER
            });
            this.visibleValid = false;
        };
        // The map tore down every cell for a full rebuild; the blades went with them. This matters more
        // here than it looks: these sprites come from a POOL, so a stale reference is not merely dead, it
        // is a live sprite that now belongs to some other tile.
        this.clear = ()=>{
            this.blades = [];
            this.visible = [];
            this.visibleValid = false;
            this.running = false;
        };
        // Exposed for tests: how many blades are registered, and how many moved on the last frame.
        this.getBladeCount = ()=>this.blades.length;
        this.swayingCount = 0;
        /**
     * A blade of grass near (x, y) that something could land on, or null if there is none within
     * `radius`. The butterflies perch on these (see Butterflies) -- which is why this reads the FULL
     * registry rather than the near set: the near set only exists while the wind is blowing, and a
     * still room still has grass to sit on.
     *
     * The point returned is the top of the plant, not the cell it is rooted in. Long grass is two tiles
     * tall, and a butterfly sitting at its base would be down in the roots with the blades drawn over
     * the top of it.
     *
     * Reservoir sampling so it is an even pick among the candidates without building a list -- this
     * walks the room's blades, and at a few calls a second that is cheap, but allocating an array of
     * them each time would not be.
     */ this.perchNear = (x, y, radius)=>{
            let chosen;
            let seen = 0;
            for (const blade of this.blades){
                if (blade.sprite.destroyed) continue;
                if (Math.abs(blade.worldX - x) > radius || Math.abs(blade.worldY - y) > radius) continue;
                seen++;
                if (Math.random() * seen < 1) chosen = blade;
            }
            if (!chosen) return null;
            // Middle of the cell, and up near the tips rather than the roots.
            return {
                x: chosen.worldX + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
                y: chosen.worldY - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.35
            };
        };
        /**
     * Bend the grass for this frame.
     *
     * @param config the room's wind (see wind.ts -- the leaves' config IS the room's wind)
     * @param center the player's world position; the box follows them
     * @param brightness the client's interpolated daylight, or undefined in a room with no day cycle
     */ this.update = (config, center, brightness)=>{
            const w = window;
            const enabled = w.grassSway !== false;
            const wind = enabled && center ? (0, $3462bfbeaff010be$export$317929bda4a1dd52)(config, performance.now() / 1000) : null;
            if (!wind) {
                // Stand everything upright once, then stop paying anything until the wind returns. Without
                // this a room whose wind is switched off keeps its grass frozen mid-lean.
                if (this.running) this.release();
                return;
            }
            this.running = true;
            const leanScale = typeof w.grassSwayLean === "number" ? w.grassSwayLean : 1;
            const speedScale = typeof w.grassSwaySpeed === "number" ? w.grassSwaySpeed : 1;
            // Calmer after dark, in step with the leaves settling, but never quite still.
            const hour = $59052a7f89e51e65$export$7d832ea11681c35b.NIGHT_CALM + (1 - $59052a7f89e51e65$export$7d832ea11681c35b.NIGHT_CALM) * (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness);
            const amplitude = wind.gust * wind.x * leanScale * hour;
            const tSeconds = performance.now() / 1000 * $59052a7f89e51e65$export$7d832ea11681c35b.FREQUENCY * speedScale;
            const waveNumber = Math.PI * 2 / $59052a7f89e51e65$export$7d832ea11681c35b.WAVELENGTH;
            const halfW = 9 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + $59052a7f89e51e65$export$7d832ea11681c35b.MARGIN;
            const halfH = 7 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + $59052a7f89e51e65$export$7d832ea11681c35b.MARGIN;
            // Re-gather the near set only when the player has left the box it was gathered for. Walking a
            // whole room's blades every frame is the one thing about this effect that could actually cost
            // something; walking them once every few tiles costs nothing.
            if (!this.visibleValid || Math.abs(center.x - this.visibleAtX) > $59052a7f89e51e65$export$7d832ea11681c35b.REGATHER || Math.abs(center.y - this.visibleAtY) > $59052a7f89e51e65$export$7d832ea11681c35b.REGATHER) this.gather(center.x, center.y, halfW, halfH);
            let swaying = 0;
            for(let i = 0; i < this.visible.length; i++){
                const blade = this.visible[i];
                const sprite = blade.sprite;
                if (sprite.destroyed) {
                    // A pooled sprite that has been handed to something else. Drop the whole near set and
                    // rebuild it next frame rather than reasoning about which half is still good.
                    this.visibleValid = false;
                    continue;
                }
                const phase = (blade.worldX * wind.x + blade.worldY * wind.y) * waveNumber + blade.jitter;
                // Signed tip displacement in world px. The minus on the shear is what makes a positive lean
                // carry the TIP downwind: skew about the top moves the base, and sliding the sprite back by
                // the same amount lands the base where it started and hands the whole displacement to the
                // tip.
                const wave = amplitude * Math.sin(tSeconds - phase);
                const top = blade.leanTop * wave;
                const bottom = blade.leanBottom * wave;
                // The shear only has to supply the DIFFERENCE across this piece; the translation puts its
                // bottom where the piece below it left off. Together they hand the top edge `top` and the
                // bottom edge `bottom`, so neighbouring pieces meet EXACTLY.
                //
                // asin, not the small-angle shortcut. The error in `skew ~= offset / HINGE` is under a
                // hundredth of a world pixel, which sounds ignorable and is not: the world surface draws at
                // 2x, and a fraction of a pixel of disagreement between two halves of the same plant shows
                // up as a visible seam along a hard pixel-art edge. One asin per visible blade per frame is
                // cheaper than a seam.
                sprite.skew.x = Math.asin(Math.max(-1, Math.min(1, (bottom - top) / $59052a7f89e51e65$export$7d832ea11681c35b.HINGE)));
                sprite.x = blade.baseX + top;
                swaying++;
            }
            this.swayingCount = swaying;
        };
        /**
     * Collect the blades near enough to be worth moving, and straighten the ones leaving the set --
     * otherwise a blade scrolls off frozen mid-lean and is still bent when it comes back.
     *
     * This is also where destroyed sprites are pruned. Per-cell removals in the map have no hook into
     * the wind, by design: a cell that disappears should not have to know this exists.
     */ this.gather = (centerX, centerY, halfW, halfH)=>{
            for (const blade of this.visible)if (!blade.sprite.destroyed) {
                blade.sprite.skew.x = 0;
                blade.sprite.x = blade.baseX;
            }
            const near = [];
            const alive = [];
            let anyDead = false;
            for (const blade of this.blades){
                if (blade.sprite.destroyed) {
                    anyDead = true;
                    continue;
                }
                alive.push(blade);
                if (Math.abs(blade.worldX - centerX) <= halfW && Math.abs(blade.worldY - centerY) <= halfH) near.push(blade);
            }
            if (anyDead) this.blades = alive;
            this.visible = near;
            this.visibleAtX = centerX;
            this.visibleAtY = centerY;
            this.visibleValid = true;
        };
        // Put every blade back upright and forget the destroyed ones.
        this.release = ()=>{
            this.running = false;
            this.swayingCount = 0;
            this.visible = [];
            this.visibleValid = false;
            const alive = [];
            for (const blade of this.blades){
                if (blade.sprite.destroyed) continue;
                blade.sprite.skew.x = 0;
                blade.sprite.x = blade.baseX;
                alive.push(blade);
            }
            this.blades = alive;
        };
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $klOfb = parcelRequire("klOfb");
var $9Tsx3 = parcelRequire("9Tsx3");
var $8t5Gy = parcelRequire("8t5Gy");
var $P8XPi = parcelRequire("P8XPi");


// Three drifting layers of the same noise field, at different sizes and at different fractions of the
// camera. `parallax` is what sells depth: 1 is locked to the ground (the bank sits still in the world
// as you walk through it), 0 is locked to the screen (infinitely far off), and between the two a layer
// slides against the ground at its own rate. In a top-down orthographic view there is no true
// parallax for a plane above the floor -- translating the camera moves every height equally -- so a
// layer that lags the world is the whole of the illusion of height, and these three read as ground
// mist, a bank at waist height, and far haze.
//
// The sizes are set against what is actually on screen -- about 12 x 9 tiles at the world surface's 2x
// zoom -- and the noise field's own 3x3 lattice means one texture tile already holds about three
// lobes. So a 9-tile layer draws lobes of roughly three tiles, four of them across the view. Sizes
// much above the screen were the first version's mistake: a feature wider than the viewport cannot
// read as a wisp, only as an overall gradient, which is precisely what a hazy filter looks like.
const $5771f9fef21bdf34$var$LAYERS = [
    {
        size: 14 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        parallax: 0.34
    },
    {
        size: 9 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        parallax: 0.66
    },
    {
        size: 5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        parallax: 1.0
    }
];
// The noise bake. 128 is plenty: fog is low-frequency by nature and every layer stretches this across
// at least seven tiles, so the texture is magnified, never minified. Power of two because WebGL 1 only
// wraps (GL_REPEAT) power-of-two textures, and the whole design rests on wrapping.
const $5771f9fef21bdf34$var$NOISE_SIZE = 128;
// Lattice frequencies summed into each field, coarsest first, with the weights beside them. Kept few
// and coarse ON PURPOSE: pile on octaves at half weight each and the sum converges on its mean
// (it is an average of independent fields), which is exactly the flat grey a fog must not be. Three
// octaves dominated by a 3x3 lattice gives big, separable lobes with room between them.
const $5771f9fef21bdf34$var$NOISE_OCTAVES = [
    {
        freq: 3,
        weight: 1
    },
    {
        freq: 6,
        weight: 0.45
    },
    {
        freq: 12,
        weight: 0.2
    }
];
class $5771f9fef21bdf34$export$321e670ba3865065 {
    static{
        // Above tiles and entities, below the leaves (900000) and the sky surface (1000000).
        this.Z_INDEX = 890000;
    }
    static{
        // Defaults for anything a room leaves out. Deliberately faint: this is "light fog", and at night
        // it is competing with the darkness mask for the same contrast budget.
        this.DEFAULT_INTENSITY = 0.35;
    }
    static{
        this.DEFAULT_SPEED = 11;
    }
    static{
        this.DEFAULT_DIRECTION_DEG = 22;
    }
    static{
        // The silhouette threshold, and the whole difference between wisps and a veil. LOW sits ABOVE the
        // field's mean, so most of the field falls under it and is simply not there; HIGH is close enough
        // above it to keep the edges soft rather than cut out. Drop LOW towards 0 and the fog goes back to
        // being a hazy filter over everything.
        this.DEFAULT_LOW = 0.5;
    }
    static{
        this.DEFAULT_HIGH = 0.74;
    }
    static{
        // How far the warp field drags the sample, in noise-tile units. This is what curls a round blob
        // into a wisp; too much and the bank shears into streaks.
        this.DEFAULT_WARP = 0.16;
    }
    static{
        this.DEFAULT_COLOR = 0xc8d4e0;
    }
    static{
        // The quad is grown this far past the visible rectangle, so nothing shows at the edge if the
        // camera moves between the corners being read and the frame being drawn.
        this.MARGIN = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    /**
     * @param surface the world surface -- the fog goes inside it, and is also asked (via toLocal) what
     *        world rectangle is currently on screen, which is the one way to get that right through the
     *        camera's edge clamping, the 2x zoom and screen shake.
     * @param screen the renderer's screen rectangle.
     * @param bake builds the tiling noise texture; injected so the simulation can be tested headless.
     */ constructor(surface, screen, bake){
        this.surface = surface;
        this.screen = screen;
        this.bake = bake;
        this.vertices = new Float32Array(8);
        this.running = false;
        this.startMs = 0;
        this.probe = new (0, $6qzqq.Point)();
        this.topLeft = new (0, $6qzqq.Point)();
        this.bottomRight = new (0, $6qzqq.Point)();
        this.color = new Float32Array(3);
        this./**
     * Draw one frame of fog, or take it down. `brightness` is the client's interpolated daylight, or
     * undefined for a room with no day cycle (which counts as day, so no fog).
     *
     * Cheap to call every frame: a room with no fog, or any hour that is not night, costs one boolean.
     */ update = (config, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved) {
                this.stop();
                return;
            }
            const mesh = this.ensureMesh();
            if (!mesh) return;
            if (!this.running) {
                this.running = true;
                this.container.visible = true;
                // Time is measured from the moment the bank rolls in, not from page load, so the fog does
                // not arrive already scrolled a long way along.
                this.startMs = performance.now();
            }
            // What is on screen right now, in world coordinates, straight from the live transform. Reading
            // the camera's own modifiers instead would be wrong at the map edges, where the camera stops
            // following the player and the modifier is left undefined.
            this.probe.set(0, 0);
            this.surface.toLocal(this.probe, undefined, this.topLeft);
            this.probe.set(this.screen.width, this.screen.height);
            this.surface.toLocal(this.probe, undefined, this.bottomRight);
            const left = Math.min(this.topLeft.x, this.bottomRight.x) - $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const right = Math.max(this.topLeft.x, this.bottomRight.x) + $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const top = Math.min(this.topLeft.y, this.bottomRight.y) - $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const bottom = Math.max(this.topLeft.y, this.bottomRight.y) + $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const cameraX = (left + right) / 2;
            const cameraY = (top + bottom) / 2;
            // Camera-relative corners; the mesh transform puts them back in the world. This is the
            // precision guard -- these are hundreds of pixels, never thousands.
            this.vertices[0] = left - cameraX;
            this.vertices[1] = top - cameraY;
            this.vertices[2] = right - cameraX;
            this.vertices[3] = top - cameraY;
            this.vertices[4] = right - cameraX;
            this.vertices[5] = bottom - cameraY;
            this.vertices[6] = left - cameraX;
            this.vertices[7] = bottom - cameraY;
            this.vertexBuffer?.update(this.vertices);
            mesh.position.set(cameraX, cameraY);
            const seconds = (performance.now() - this.startMs) / 1000;
            const driftX = Math.cos(resolved.directionRad) * resolved.speed * seconds;
            const driftY = Math.sin(resolved.directionRad) * resolved.speed * seconds;
            const uniforms = mesh.shader.uniforms;
            for(let i = 0; i < $5771f9fef21bdf34$var$LAYERS.length; i++){
                const { size: size, parallax: parallax } = $5771f9fef21bdf34$var$LAYERS[i];
                const inv = 1 / size;
                // uv = (world - camera * (1 - parallax) - drift) / size, rearranged around the
                // camera-relative vertex the shader actually has: rel * inv + (camera * parallax - drift) *
                // inv. The constant half is computed HERE, in double precision, and reduced to its
                // fractional part -- dropping whole noise tiles is invisible because the texture wraps, and
                // it is what keeps a big world from quantising the fog into steps.
                const offX = (cameraX * parallax - driftX) * inv;
                const offY = (cameraY * parallax - driftY) * inv;
                uniforms[`uInv${i}`][0] = inv;
                uniforms[`uInv${i}`][1] = inv;
                uniforms[`uOff${i}`][0] = offX - Math.floor(offX);
                uniforms[`uOff${i}`][1] = offY - Math.floor(offY);
            }
            uniforms.uIntensity = resolved.intensity;
            uniforms.uLow = resolved.low;
            uniforms.uHigh = resolved.high;
            uniforms.uWarp = resolved.warp;
            this.color[0] = (resolved.color >> 16 & 0xff) / 255;
            this.color[1] = (resolved.color >> 8 & 0xff) / 255;
            this.color[2] = (resolved.color & 0xff) / 255;
        };
        this.// Exposed for tests: the opacity the fog is currently drawing at, 0 when it is not drawing.
        getIntensity = ()=>this.running && this.mesh ? this.mesh.shader.uniforms.uIntensity : 0;
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.nightFog === "boolean" ? w.nightFog : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            // Forcing the fog on from the console also lifts the night gate; there is no way to look at it
            // at noon otherwise, and waiting for the hour is a four-minute round trip.
            const nightOnly = forced === true ? false : config?.nightOnly !== false;
            const night = nightOnly ? (0, $eca6088c9a6d9651$export$92091d9bb73d8475)(brightness) : 1;
            if (night <= 0) return null;
            return {
                // The hour scales the opacity and nothing else: unlike the leaves there is no count to
                // thin, so the bank simply thickens as the light goes.
                intensity: Math.min(1, Math.max(0, num(w.nightFogIntensity, config?.intensity, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_INTENSITY))) * night,
                speed: num(w.nightFogSpeed, config?.speed, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_SPEED),
                directionRad: num(w.nightFogDirection, config?.directionDeg, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_DIRECTION_DEG) * Math.PI / 180,
                low: num(w.nightFogLow, config?.low, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_LOW),
                high: num(w.nightFogHigh, config?.high, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_HIGH),
                warp: num(w.nightFogWarp, config?.warp, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_WARP),
                color: typeof config?.color === "number" ? config.color : $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_COLOR
            };
        };
        this.ensureMesh = ()=>{
            if (this.mesh) return this.mesh;
            let noise;
            try {
                noise = this.bake();
            } catch (e) {
                // Fog is ambience. If the bake fails there simply is no fog.
                return undefined;
            }
            this.noise = noise;
            this.vertexBuffer = new (0, $klOfb.Buffer)(this.vertices, false, false);
            const geometry = new (0, $klOfb.Geometry)().addAttribute("aVertexPosition", this.vertexBuffer, 2).addIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            const shader = (0, $klOfb.Shader).from($5771f9fef21bdf34$export$321e670ba3865065.VERTEX, $5771f9fef21bdf34$export$321e670ba3865065.FRAGMENT, {
                uNoise: noise,
                uInv0: new Float32Array(2),
                uInv1: new Float32Array(2),
                uInv2: new Float32Array(2),
                uOff0: new Float32Array(2),
                uOff1: new Float32Array(2),
                uOff2: new Float32Array(2),
                uIntensity: 0,
                uLow: $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_LOW,
                uHigh: $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_HIGH,
                uWarp: $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_WARP,
                uColor: this.color
            });
            const mesh = new (0, $9Tsx3.Mesh)(geometry, shader);
            this.mesh = mesh;
            this.container.addChild(mesh);
            return mesh;
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $5771f9fef21bdf34$export$321e670ba3865065.Z_INDEX;
        container.interactiveChildren = false;
        container.visible = false;
        this.container = container;
    }
    static{
        // Vertex positions arrive camera-relative and go straight out as the varying; a vertex shader is
        // always highp, so the transform itself is safe whatever the world coordinates are.
        this.VERTEX = `
        precision highp float;

        attribute vec2 aVertexPosition;

        uniform mat3 projectionMatrix;
        uniform mat3 translationMatrix;

        varying vec2 vRel;

        void main() {
            vRel = aVertexPosition;
            gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
        }
    `;
    }
    static{
        this.FRAGMENT = `
        precision mediump float;

        varying vec2 vRel;

        uniform sampler2D uNoise;
        uniform vec2 uInv0;
        uniform vec2 uInv1;
        uniform vec2 uInv2;
        uniform vec2 uOff0;
        uniform vec2 uOff1;
        uniform vec2 uOff2;
        uniform float uIntensity;
        uniform float uLow;
        uniform float uHigh;
        uniform float uWarp;
        uniform vec3 uColor;

        void main() {
            // The coarse layer does double duty: it is both the slowest-parallaxing body of the bank
            // and the source of the warp. Its green and blue channels are two INDEPENDENT fields, so
            // the displacement is a real 2D vector -- a greyscale texture would give g == b and shear
            // everything along one diagonal.
            vec3 coarse = texture2D(uNoise, vRel * uInv0 + uOff0).rgb;
            vec2 warp = (coarse.gb - 0.5) * uWarp;

            // DOMAIN WARPING is what turns blobs into wisps: the mass is sampled at a position that has
            // itself been dragged around by a slower field, so its lobes stretch and curl the way
            // something carried on moving air does, instead of sitting there as soft circles.
            float body = texture2D(uNoise, vRel * uInv1 + uOff1 + warp).r;
            float detail = texture2D(uNoise, vRel * uInv2 + uOff2 + warp * 0.5).g;

            // Build ONE field out of the three, then cut it. Mixing the fine layer in BEFORE the
            // threshold is what makes an edge billow: the silhouette wanders at the fine layer's
            // frequency and breaks into lobes. Multiplying it in afterwards -- the obvious thing, and
            // what this did first -- only shades the inside and leaves a smooth, soapy outline.
            float field = body * 0.55 + coarse.r * 0.25 + detail * 0.2;

            // THE SILHOUETTE, and the whole difference between fog and a hazy filter. uLow sits at the
            // field's median, so half the screen falls below it and has no fog on it AT ALL -- the
            // empty gaps are what the eye reads as separate wisps. A threshold low enough to touch
            // every pixel is a grey filter, however faint it is made.
            float mass = smoothstep(uLow, uHigh, field);

            // Structure inside a wisp, so it is not a flat cut-out: lighter cores, thinner fringes.
            float density = mass * (0.6 + 0.4 * detail);

            float a = density * uIntensity;
            // Premultiplied: pixi's NORMAL blend expects the colour already multiplied by the alpha.
            gl_FragColor = vec4(uColor * a, a);
        }
    `;
    }
    static{
        /**
     * Three independent tileable value-noise fields, each in 0..1, row-major.
     *
     * Baked rather than computed per pixel in the shader: procedural fbm would cost forty-odd ALU ops a
     * pixel every frame forever, where this is a few thousand CPU operations once. It has to TILE,
     * because the whole scroll scheme rests on GL_REPEAT, so every lattice lookup wraps -- get that
     * wrong and there is a hard seam across the world every few tiles, and it only shows up there.
     *
     * Separate from bakeNoise so the fields can be checked without a GPU.
     */ this.buildNoiseField = ()=>{
            const channels = [];
            for(let c = 0; c < 3; c++){
                const field = new Float32Array($5771f9fef21bdf34$var$NOISE_SIZE * $5771f9fef21bdf34$var$NOISE_SIZE);
                for (const { freq: freq, weight: weight } of $5771f9fef21bdf34$var$NOISE_OCTAVES){
                    // The lattice this octave interpolates. Indices wrap, which is what makes it tile.
                    const lattice = new Float32Array(freq * freq);
                    for(let i = 0; i < lattice.length; i++)lattice[i] = Math.random();
                    const cell = $5771f9fef21bdf34$var$NOISE_SIZE / freq;
                    for(let y = 0; y < $5771f9fef21bdf34$var$NOISE_SIZE; y++)for(let x = 0; x < $5771f9fef21bdf34$var$NOISE_SIZE; x++){
                        const fx = x / cell;
                        const fy = y / cell;
                        const x0 = Math.floor(fx);
                        const y0 = Math.floor(fy);
                        const x1 = (x0 + 1) % freq;
                        const y1 = (y0 + 1) % freq;
                        // Smoothstep rather than linear interpolation: linear leaves the lattice
                        // visible as a grid of creases, which on a stretched fog layer is unmissable.
                        const tx = fx - x0;
                        const ty = fy - y0;
                        const sx = tx * tx * (3 - 2 * tx);
                        const sy = ty * ty * (3 - 2 * ty);
                        const wx0 = x0 % freq;
                        const wy0 = y0 % freq;
                        const a = lattice[wy0 * freq + wx0];
                        const b = lattice[wy0 * freq + x1];
                        const d = lattice[y1 * freq + wx0];
                        const e = lattice[y1 * freq + x1];
                        const top = a + (b - a) * sx;
                        const bot = d + (e - d) * sx;
                        field[y * $5771f9fef21bdf34$var$NOISE_SIZE + x] += (top + (bot - top) * sy) * weight;
                    }
                }
                // Normalise on the field's ACTUAL range rather than the weight sum. A sum of octaves never
                // reaches its theoretical extremes, so dividing by the weights leaves everything bunched in
                // the middle -- which is the flat grey this effect exists to avoid. Stretching to the real
                // min/max is free contrast, and the silhouette threshold depends on having it.
                let min = Infinity;
                let max = -Infinity;
                for(let i = 0; i < field.length; i++){
                    min = Math.min(min, field[i]);
                    max = Math.max(max, field[i]);
                }
                const span = max - min || 1;
                for(let i = 0; i < field.length; i++)field[i] = (field[i] - min) / span;
                channels.push(field);
            }
            return {
                size: $5771f9fef21bdf34$var$NOISE_SIZE,
                channels: channels
            };
        };
    }
    static{
        // Upload the three fields as the R, G and B channels of one wrapping texture -- one fetch hands the
        // shader three independent values, which is what keeps this to three texture reads a pixel.
        this.bakeNoise = ()=>{
            const { size: size, channels: channels } = $5771f9fef21bdf34$export$321e670ba3865065.buildNoiseField();
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const context = canvas.getContext("2d");
            if (!context) throw new Error("no 2d context for the fog noise bake");
            const image = context.createImageData(size, size);
            const byte = (value)=>Math.max(0, Math.min(255, Math.round(value * 255)));
            for(let i = 0; i < channels[0].length; i++){
                image.data[i * 4] = byte(channels[0][i]);
                image.data[i * 4 + 1] = byte(channels[1][i]);
                image.data[i * 4 + 2] = byte(channels[2][i]);
                image.data[i * 4 + 3] = 255;
            }
            context.putImageData(image, 0, 0);
            const texture = (0, $klOfb.Texture).from(canvas);
            // The one non-negotiable: every layer scrolls indefinitely, so the field has to wrap. This is
            // also why NOISE_SIZE is a power of two -- WebGL 1 refuses to repeat anything else.
            texture.baseTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
            return texture;
        };
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");




class $02d47f540b0d58f8$export$ebaa494e10da0ea2 {
    static{
        // Above every tile and entity (world sprites sort at roughly 100 + row * TileSize), below the
        // sky surface at 1_000_000 so a roof still hides the leaves indoors.
        this.Z_INDEX = 900000;
    }
    static{
        // Hard ceiling on the sprite count whatever a room or the console asks for. The effect is
        // ambience; it does not get to cost a frame.
        this.MAX_LEAVES = 64;
    }
    static{
        // The box the simulation lives in, as a half-extent in world px around the player. The visible
        // world is ScalingParams.viewportX/Y tiles either side of the player, so this is that plus a
        // three-tile margin: leaves are born and die outside the screen, never in view.
        this.HALF_W = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 3) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.HALF_H = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 3) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // How deep the fade-in/out band at the edge of the box is, in world px. A leaf's opacity ramps
        // with its distance to the nearest edge, so nothing ever pops into or out of existence.
        this.FADE_BAND = 44;
    }
    static{
        // Defaults for everything a config may leave out.
        this.DEFAULT_DIRECTION_DEG = 22;
    }
    static{
        this.DEFAULT_COUNT = 10;
    }
    static{
        this.DEFAULT_SPEED = 46;
    }
    static{
        this.DEFAULT_GUSTINESS = 0.6;
    }
    static{
        this.DEFAULT_ALPHA = 0.85;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.3;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.62;
    }
    static{
        // Tint multiplies, so these are the colours the (white) leaf art becomes. A leaf samples this list
        // uniformly, so the MIX is simply how many entries each shade gets: five living greens to two
        // turned ones, i.e. mostly green with the odd dry leaf among them.
        this.DEFAULT_COLORS = [
            0x6f9b3a,
            0x568a2e,
            0x86ab48,
            0x4e7c2a,
            0x9cbb55,
            0xb9762b,
            0xd9a13a
        ];
    }
    static{
        // A jump bigger than this between frames is a teleport or a room change, not walking, so the
        // whole field is re-scattered rather than dragged across the map behind the player.
        this.TELEPORT_JUMP = $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
    }
    constructor(makeTextures){
        this.makeTextures = makeTextures;
        this.leaves = [];
        this.activeCount = 0;
        this.textures = [];
        this.config = null;
        this.running = false;
        this.lastMs = 0;
        this.lastCenterX = 0;
        this.lastCenterY = 0;
        this.hasCenter = false;
        this./**
     * Advance the field one frame and draw it. `center` is the player's world position: the box
     * follows the player, so the simulation only ever runs over what could be on screen.
     *
     * `brightness` is the client's interpolated daylight (ClientGameLogic.currentBrightness), or
     * undefined for a room with no day cycle -- which counts as full daylight, not as darkness.
     *
     * Safe and cheap to call every frame whether or not the room has wind.
     */ update = (config, center, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved || !center) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                // Starting (or restarting after a still room): fill the box immediately so the wind is
                // already blowing on the first visible frame, rather than blowing in from one edge.
                this.running = true;
                this.container.visible = true;
                this.lastMs = nowMs;
                this.ensurePool(resolved.count);
                this.scatter(center.x, center.y, resolved);
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                this.hasCenter = true;
                return;
            }
            this.ensurePool(resolved.count);
            // A teleport (or a new room) moves the box further in one frame than the box is wide. Dragging
            // the existing leaves along would show the previous room's field sliding into place, so
            // re-seed instead.
            if (this.hasCenter && (Math.abs(center.x - this.lastCenterX) > $02d47f540b0d58f8$export$ebaa494e10da0ea2.TELEPORT_JUMP || Math.abs(center.y - this.lastCenterY) > $02d47f540b0d58f8$export$ebaa494e10da0ea2.TELEPORT_JUMP)) {
                this.scatter(center.x, center.y, resolved);
                this.lastMs = nowMs;
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                return;
            }
            this.lastCenterX = center.x;
            this.lastCenterY = center.y;
            this.hasCenter = true;
            // Time-based, so the wind blows at the same speed on a 30fps laptop and a 144Hz monitor. The
            // clamp is for the tab coming back from the background, where the gap can be minutes: without
            // it every leaf would teleport clean across the map in a single step.
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            dt = Math.min(dt, 0.05);
            this.step(dt, nowMs / 1000, center.x, center.y, resolved);
        };
        this.// Exposed for tests: how many leaves are currently simulated and drawn.
        getActiveCount = ()=>this.running ? this.activeCount : 0;
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
            // Next enable must not integrate the whole time the effect was off.
            this.lastMs = 0;
            this.hasCenter = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.windLeaves === "boolean" ? w.windLeaves : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const daylight = this.daylightFactor(config, brightness);
            if (daylight <= 0) // Night. Returning null takes the same path as a room with no wind: the container is
            // hidden and not one leaf is simulated until the light comes back.
            return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            const directionDeg = num(w.windLeavesDirection, config?.directionDeg, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_DIRECTION_DEG);
            const rad = directionDeg * Math.PI / 180;
            const scaleMin = config?.scaleMin ?? $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_SCALE_MAX;
            return {
                // Unit heading, and the unit perpendicular the cross-wind wander rides on.
                windX: Math.cos(rad),
                windY: Math.sin(rad),
                crossX: -Math.sin(rad),
                crossY: Math.cos(rad),
                speed: Math.max(1, num(w.windLeavesSpeed, config?.speed, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_SPEED)),
                gustiness: Math.min(1, Math.max(0, num(w.windLeavesGust, config?.gustiness, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_GUSTINESS))),
                // Thinned by the time of day, but never rounded away to nothing while there is still
                // light: a last leaf or two in the failing light is the point of the fade.
                count: Math.max(daylight > 0 ? 1 : 0, Math.min($02d47f540b0d58f8$export$ebaa494e10da0ea2.MAX_LEAVES, Math.round(num(w.windLeavesCount, config?.count, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_COUNT) * daylight))),
                alpha: Math.min(1, Math.max(0, num(w.windLeavesAlpha, config?.alpha, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_ALPHA))),
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                colors: config?.colors?.length ? config.colors : $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_COLORS,
                daylight: daylight
            };
        };
        this.daylightFactor = (config, brightness)=>{
            const w = window;
            const dayOnly = typeof w.windLeavesDayOnly === "boolean" ? w.windLeavesDayOnly : config?.dayOnly !== false;
            if (!dayOnly) return 1;
            return (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness);
        };
        this.step = (dt, tSeconds, centerX, centerY, cfg)=>{
            // The shared gust envelope (wind.ts), the same one the bending grass reads -- the leaves and the
            // grass have to surge at the same moments or the two read as different weather.
            const gust = (0, $3462bfbeaff010be$export$4e07af95bd4178be)(tSeconds, cfg.gustiness);
            for(let i = 0; i < this.activeCount; i++){
                const leaf = this.leaves[i];
                const along = cfg.speed * gust * leaf.speedScale;
                const cross = Math.sin(tSeconds * leaf.swayFreq + leaf.swayPhase) * leaf.swayAmp;
                leaf.x += (cfg.windX * along + cfg.crossX * cross) * dt;
                leaf.y += (cfg.windY * along + cfg.crossY * cross) * dt;
                // Distance to the nearest edge of the box, which is both the recycle test and the fade.
                const edgeX = $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W - Math.abs(leaf.x - centerX);
                const edgeY = $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H - Math.abs(leaf.y - centerY);
                if (edgeX <= 0 || edgeY <= 0) {
                    this.reseed(leaf, centerX, centerY, cfg);
                    continue;
                }
                const sprite = leaf.sprite;
                sprite.x = leaf.x;
                sprite.y = leaf.y;
                // Tumble. Faster in a gust, because a leaf that spins at a constant rate while its drift
                // surges looks like it is on rails.
                sprite.rotation += leaf.spin * gust * dt;
                // Edge-on flip: squash the short axis only. abs() of a cosine gives the sharp turn at the
                // moment the leaf passes through edge-on, which a plain sine would smooth away.
                const flutter = Math.abs(Math.cos(tSeconds * leaf.flutterFreq + leaf.flutterPhase));
                sprite.scale.set(leaf.scale, leaf.scale * (0.3 + 0.7 * flutter));
                // cfg.daylight is applied HERE and not folded into baseAlpha at reseed: a leaf keeps its
                // baseAlpha for its whole crossing, so baking the light in would leave the field fading
                // one leaf at a time as each got recycled instead of dimming together.
                sprite.alpha = leaf.baseAlpha * cfg.daylight * Math.min(1, Math.min(edgeX, edgeY) / $02d47f540b0d58f8$export$ebaa494e10da0ea2.FADE_BAND);
            }
        };
        this.ensurePool = (count)=>{
            const target = Math.min(count, $02d47f540b0d58f8$export$ebaa494e10da0ea2.MAX_LEAVES);
            if (!this.textures.length && target > 0) {
                // A leaf is ambience. If the bake fails (no GPU -- a test, a lost context), draw plain
                // tinted quads rather than taking the frame down.
                try {
                    this.textures = this.makeTextures();
                } catch (e) {
                    this.textures = [];
                }
                if (!this.textures.length) this.textures = [
                    (0, $klOfb.Texture).WHITE
                ];
            }
            while(this.leaves.length < target){
                const sprite = new (0, $7Bs2Z.Sprite)(this.textures[this.leaves.length % this.textures.length] ?? (0, $klOfb.Texture).WHITE);
                sprite.anchor.set(0.5);
                this.container.addChild(sprite);
                this.leaves.push({
                    sprite: sprite,
                    x: 0,
                    y: 0,
                    speedScale: 1,
                    swayAmp: 0,
                    swayFreq: 1,
                    swayPhase: 0,
                    spin: 0,
                    flutterFreq: 1,
                    flutterPhase: 0,
                    scale: 0.5,
                    baseAlpha: 1
                });
            }
            if (target === this.activeCount) return;
            for(let i = 0; i < this.leaves.length; i++)this.leaves[i].sprite.visible = i < target;
            this.activeCount = target;
        };
        this.scatter = (centerX, centerY, cfg)=>{
            for(let i = 0; i < this.activeCount; i++){
                const leaf = this.leaves[i];
                this.randomizeLeaf(leaf, cfg);
                leaf.x = centerX + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
                leaf.y = centerY + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H;
                leaf.sprite.x = leaf.x;
                leaf.sprite.y = leaf.y;
                leaf.sprite.alpha = 0;
            }
        };
        this.reseed = (leaf, centerX, centerY, cfg)=>{
            this.randomizeLeaf(leaf, cfg);
            const absX = Math.abs(cfg.windX);
            const absY = Math.abs(cfg.windY);
            // Weighted pick with no zero-division: with a purely vertical wind absX is 0 and this never
            // takes the horizontal arm, which is what we want (its sign would be 0 and the leaf would be
            // born in the middle of the screen).
            if (Math.random() * (absX + absY) < absX) {
                leaf.x = centerX - Math.sign(cfg.windX) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
                leaf.y = centerY + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H;
            } else {
                leaf.x = centerX + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
                leaf.y = centerY - Math.sign(cfg.windY) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H;
            }
            leaf.sprite.x = leaf.x;
            leaf.sprite.y = leaf.y;
            leaf.sprite.alpha = 0;
        };
        this.randomizeLeaf = (leaf, cfg)=>{
            const rand = (min, max)=>min + Math.random() * (max - min);
            leaf.speedScale = rand(0.62, 1.45);
            // Sway amplitude is a fraction of the drift speed: a slow leaf that wanders as hard as a fast
            // one looks like it is being steered rather than carried.
            leaf.swayAmp = cfg.speed * rand(0.18, 0.5);
            leaf.swayFreq = rand(0.5, 1.9);
            leaf.swayPhase = Math.random() * Math.PI * 2;
            leaf.spin = rand(0.6, 3.1) * (Math.random() < 0.5 ? -1 : 1);
            leaf.flutterFreq = rand(1.4, 4.2);
            leaf.flutterPhase = Math.random() * Math.PI * 2;
            leaf.scale = rand(cfg.scaleMin, cfg.scaleMax);
            // Smaller leaves read as further away, so they are also fainter. Cheap depth for free.
            const depth = (leaf.scale - cfg.scaleMin) / Math.max(0.0001, cfg.scaleMax - cfg.scaleMin);
            leaf.baseAlpha = cfg.alpha * (0.6 + 0.4 * depth);
            leaf.sprite.texture = this.textures[Math.floor(Math.random() * this.textures.length)] ?? (0, $klOfb.Texture).WHITE;
            leaf.sprite.tint = cfg.colors[Math.floor(Math.random() * cfg.colors.length)];
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $02d47f540b0d58f8$export$ebaa494e10da0ea2.Z_INDEX;
        // Nothing in here is ever clicked, and it sits over the whole world -- keep it out of hit
        // testing entirely so it can't swallow a press meant for an entity underneath.
        container.interactiveChildren = false;
        container.visible = false;
        this.container = container;
    }
    static{
        /**
     * The leaf art, generated once at startup rather than shipped as an asset: three white blades with
     * a grey midrib, which every leaf then tints. White art is what makes a single texture serve a
     * whole seasonal palette (tint multiplies), and the grey rib survives tinting as a darker vein.
     *
     * Drawn oversized and scaled down per leaf, at resolution 2 to match the world surface's 2x zoom,
     * so the edges stay smooth instead of showing the blocky diagonal of a 6px sprite.
     */ this.buildLeafTextures = (generate)=>{
            // Long/narrow, short/round, and a thin sliver: enough variety that the eye stops reading a
            // repeated stamp, few enough that all three stay in one batch.
            const shapes = [
                [
                    17,
                    7
                ],
                [
                    13,
                    10
                ],
                [
                    15,
                    4
                ]
            ];
            return shapes.map(([length, width])=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.beginFill(0xffffff);
                // A lens: two quadratic curves from tip to tip. The control points at ±width sit outside
                // the curve, so the widest point of the blade lands near width/2 -- deliberate, it gives
                // the leaf a pointed tip rather than an ellipse's blunt one.
                g.moveTo(-length / 2, 0);
                g.quadraticCurveTo(0, -width, length / 2, 0);
                g.quadraticCurveTo(0, width, -length / 2, 0);
                g.endFill();
                // Midrib, stopping short of both tips so it doesn't spill outside the blade.
                g.lineStyle(1, 0x9a9a9a, 0.85);
                g.moveTo(-length / 2 + 1.5, 0);
                g.lineTo(length / 2 - 1.5, 0);
                const texture = generate(g);
                g.destroy();
                return texture;
            });
        };
    }
    static{
        // The default texture factory, bound to a live pixi renderer. Split from buildLeafTextures so the
        // simulation can be tested without a GPU.
        this.textureFactory = (renderer)=>()=>$02d47f540b0d58f8$export$ebaa494e10da0ea2.buildLeafTextures((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $b11c64d757fefaba$export$ca9afcfe841d52c9 extends (0, $a64b70167386625f$export$98e91636974d835d) {
}
const $b11c64d757fefaba$var$SCALING_CONSTANT = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
class $b11c64d757fefaba$export$198fa1625abb29ee extends (0, $gwPoJ.Graphics) {
    constructor(logic){
        super(), this.entityIdToOverlayItem = new Map(), this.offer = (entity)=>{
            const renderable = new $b11c64d757fefaba$export$ca9afcfe841d52c9();
            renderable.zIndex = 0;
            this.entityIdToOverlayItem.set(entity.entityId, renderable);
            const f = 32 * $b11c64d757fefaba$var$SCALING_CONSTANT;
            renderable.beginFill(0xff0000, 0.01);
            renderable.drawRect(0, 0, f, f);
            renderable.endFill();
            renderable.width = f;
            renderable.height = f;
            this.addChild(renderable);
            return renderable;
        }, this.remove = (entity)=>{
            if (!entity) return;
            const renderable = this.entityIdToOverlayItem.get(entity.entityId);
            if (!renderable) return;
            renderable.remove();
            this.entityIdToOverlayItem.delete(entity.entityId);
        }, this.updateEntityId = (originalEntityId, updatedEntityId)=>{
            this.entityIdToOverlayItem.set(updatedEntityId, this.entityIdToOverlayItem.get(originalEntityId));
            this.entityIdToOverlayItem.delete(originalEntityId);
        }, this.updateEntity = (entity)=>{
            if (!entity) return;
            const renderable = this.entityIdToOverlayItem.get(entity.entityId);
            if (!renderable) return;
            const yScaler = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isShort(entity) ? 0.75 : 1.25;
            renderable.visible = entity.visible;
            renderable.x = entity.location.x * $b11c64d757fefaba$var$SCALING_CONSTANT - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.25 * $b11c64d757fefaba$var$SCALING_CONSTANT;
            renderable.y = entity.location.y * $b11c64d757fefaba$var$SCALING_CONSTANT - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * yScaler * $b11c64d757fefaba$var$SCALING_CONSTANT;
        }, this.getEntityRenderable = (entityId)=>{
            return this.entityIdToOverlayItem.get(entityId);
        }, this.computeLocation = (x, y)=>{
            return {
                x: x * $b11c64d757fefaba$var$SCALING_CONSTANT,
                y: y * $b11c64d757fefaba$var$SCALING_CONSTANT
            };
        }, // The inverse of computeLocation: a point in this surface's local frame back to a fine world
        // coordinate. With `toLocal` in front of it this turns a screen position into the spot on the
        // ground under it -- which is how the location picker resolves where the player clicked,
        // straight off pixi's own transforms rather than off the camera arithmetic.
        this.worldLocation = (x, y)=>{
            return {
                x: x / $b11c64d757fefaba$var$SCALING_CONSTANT,
                y: y / $b11c64d757fefaba$var$SCALING_CONSTANT
            };
        };
        this.logic = logic;
        // Overlay items paint by zIndex so a speaking entity can lift its HUD (chat bubble) above the
        // nameplates/role glyphs of the entities around it -- see AvatarHud.liftOverlay. Items all rest
        // at zIndex 0, where pixi's stable sort keeps the old insertion order.
        this.sortableChildren = true;
    }
}




var $5UG8I = parcelRequire("5UG8I");
class $3a1b2b5c28aeeeee$export$9b229b42dc5ba616 {
    constructor(config){
        this.frameCount = 0;
        this.lastFrameTime = 0;
        this.frameTimes = [];
        this.renderTimes = [];
        this.updateTimes = [];
        this.lastLogTime = 0;
        this.entityCount = 0;
        this.renderedEntityCount = 0;
        this.culledEntityCount = 0;
        this.startTime = 0;
        this.renderStartTime = 0;
        this.updateStartTime = 0;
        this.config = {
            enableMetrics: true,
            logInterval: 5000,
            enableMemoryTracking: false,
            enableDetailedStats: false,
            ...config
        };
    }
    /**
     * Set callbacks to get stats from other systems
     */ setStatCallbacks(callbacks) {
        this.getViewportCullingStats = callbacks.getViewportCullingStats;
        this.getSpritePoolStats = callbacks.getSpritePoolStats;
    }
    /**
     * Start timing a frame
     */ startFrame() {
        this.startTime = performance.now();
        this.frameCount++;
    }
    /**
     * Start timing render phase
     */ startRender() {
        this.renderStartTime = performance.now();
    }
    /**
     * End timing render phase
     */ endRender() {
        if (this.renderStartTime > 0) {
            const renderTime = performance.now() - this.renderStartTime;
            this.renderTimes.push(renderTime);
            // Keep only last 60 frames
            if (this.renderTimes.length > 60) this.renderTimes.shift();
        }
    }
    /**
     * Start timing update phase
     */ startUpdate() {
        this.updateStartTime = performance.now();
    }
    /**
     * End timing update phase
     */ endUpdate() {
        if (this.updateStartTime > 0) {
            const updateTime = performance.now() - this.updateStartTime;
            this.updateTimes.push(updateTime);
            // Keep only last 60 frames
            if (this.updateTimes.length > 60) this.updateTimes.shift();
        }
    }
    /**
     * End timing a frame
     */ endFrame() {
        const currentTime = performance.now();
        const frameTime = currentTime - this.startTime;
        // Clamp frame time to reasonable values (avoid division by very small numbers)
        const clampedFrameTime = Math.max(frameTime, 0.1) // Minimum 0.1ms
        ;
        this.frameTimes.push(clampedFrameTime);
        // Keep only last 60 frames for rolling average
        if (this.frameTimes.length > 60) this.frameTimes.shift();
        this.lastFrameTime = frameTime;
        // Log metrics periodically
        if (this.config.enableMetrics && currentTime - this.lastLogTime > this.config.logInterval) {
            this.logMetrics();
            this.lastLogTime = currentTime;
        }
    }
    /**
     * Update entity counts
     */ updateEntityCounts(total, rendered, culled) {
        this.entityCount = total;
        this.renderedEntityCount = rendered;
        this.culledEntityCount = culled;
    }
    /**
     * Get current performance metrics
     */ getMetrics() {
        const avgFrameTime = this.frameTimes.length > 0 ? this.frameTimes.reduce((a, b)=>a + b, 0) / this.frameTimes.length : 0;
        const avgRenderTime = this.renderTimes.length > 0 ? this.renderTimes.reduce((a, b)=>a + b, 0) / this.renderTimes.length : 0;
        const avgUpdateTime = this.updateTimes.length > 0 ? this.updateTimes.reduce((a, b)=>a + b, 0) / this.updateTimes.length : 0;
        const frameRate = avgFrameTime > 0 ? 1000 / avgFrameTime : 0;
        return {
            frameRate: Math.round(frameRate * 10) / 10,
            entityCount: this.entityCount,
            renderedEntities: this.renderedEntityCount,
            culledEntities: this.culledEntityCount,
            viewportCullingStats: this.getViewportCullingStats?.() || {},
            spritePoolStats: this.getSpritePoolStats?.() || {},
            renderTime: Math.round(avgRenderTime * 100) / 100,
            updateTime: Math.round(avgUpdateTime * 100) / 100,
            totalTime: Math.round(avgFrameTime * 100) / 100,
            memoryUsage: this.config.enableMemoryTracking ? this.getMemoryUsage() : undefined
        };
    }
    /**
     * Log performance metrics to console
     */ logMetrics() {
        const metrics = this.getMetrics();
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, "=== Performance Metrics ===");
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Frame Rate: ${metrics.frameRate} FPS`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Entities: ${metrics.renderedEntities}/${metrics.entityCount} rendered (${metrics.culledEntities} culled)`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Render Time: ${metrics.renderTime}ms`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Update Time: ${metrics.updateTime}ms`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Total Time: ${metrics.totalTime}ms`);
        if (this.config.enableDetailedStats) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "performance",
                    "viewport"
                ]
            }, "Viewport Culling:", metrics.viewportCullingStats);
            (0, $5UG8I.logger).debug({
                tags: [
                    "performance",
                    "sprites"
                ]
            }, "Sprite Pool:", metrics.spritePoolStats);
            // Debug: Log if too many entities are being culled
            const cullRate = metrics.entityCount > 0 ? (metrics.culledEntities / metrics.entityCount * 100).toFixed(1) : "0";
            if (parseFloat(cullRate) > 80) (0, $5UG8I.logger).warn({
                tags: [
                    "performance",
                    "culling"
                ]
            }, `High cull rate: ${cullRate}% (${metrics.culledEntities}/${metrics.entityCount} entities culled)`);
        }
        if (metrics.memoryUsage !== undefined) (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "memory"
            ]
        }, `Memory Usage: ${metrics.memoryUsage}MB`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, "========================");
    }
    /**
     * Get memory usage (if available)
     */ getMemoryUsage() {
        if (typeof performance !== "undefined" && "memory" in performance) {
            const memory = performance.memory;
            return Math.round(memory.usedJSHeapSize / 1024 / 1024 * 100) / 100;
        }
        return undefined;
    }
    /**
     * Reset all metrics
     */ reset() {
        this.frameCount = 0;
        this.frameTimes = [];
        this.renderTimes = [];
        this.updateTimes = [];
        this.entityCount = 0;
        this.renderedEntityCount = 0;
        this.culledEntityCount = 0;
        this.lastLogTime = 0;
    }
    /**
     * Update configuration
     */ updateConfig(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
    }
    /**
     * Get current configuration
     */ getConfig() {
        return {
            ...this.config
        };
    }
    /**
     * Get performance warnings
     */ getPerformanceWarnings() {
        const warnings = [];
        const metrics = this.getMetrics();
        if (metrics.frameRate < 30) warnings.push(`Low frame rate: ${metrics.frameRate} FPS`);
        if (metrics.totalTime > 33) warnings.push(`High frame time: ${metrics.totalTime}ms`);
        if (metrics.renderedEntities > 100) warnings.push(`High entity count: ${metrics.renderedEntities} entities`);
        if (metrics.renderTime > 16) warnings.push(`High render time: ${metrics.renderTime}ms`);
        return warnings;
    }
}



class $baf9ca3dd57f31c4$export$e33484ee45c8bb13 {
    constructor(app, logic){
        this.debugVision = false;
        this.cachedSortedEntities = null;
        this.frameTimeHistory = [];
        this.lastFrameTime = 0;
        this.targetFrameTime = 1000 / 60 // 60 FPS target
        ;
        this.maxEntitiesPerFrame = 200 // Simple limit for basic culling
        ;
        this.performanceHistory = [] // Track performance over time
        ;
        this.gui = ()=>this._gui;
        this.entity = ()=>this._entity;
        this.map = ()=>this._map;
        this.mouse = ()=>this._mouse;
        this.keyboard = ()=>this._keyboard;
        this.logic = ()=>this._logic;
        this.getApp = ()=>this.app;
        // Follow-cam driver: while the ember-roster PiP modal is open, refresh the focused entity's
        // neighborhood (the main loop culls to ~7 tiles around the player, so far focus entities would
        // otherwise be frozen) and render the world centred on it into the modal's texture.
        this.updateFollowCam = ()=>{
            const focusId = this._logic.focusEntityId;
            const followCam = this._gui.followCam;
            // Skip the render-to-texture while the PiP is open-but-hidden (subject is on-screen).
            if (!focusId || !followCam || !followCam.isOpen() || !followCam.visible) return;
            const focus = this._logic.getEntity(focusId);
            if (!focus) return;
            this.renderFocusNeighborhood(focus.entityId);
            this.renderWorldToTexture(followCam.getTexture(), focus.location.x, focus.location.y, followCam.getZoom());
        };
        // Update renderables for entities near the focused entity so the PiP shows live movement even
        // when that neighborhood is off the player's screen. Bounded work: only runs while the modal
        // is open, and only touches entities the client already knows about.
        this.renderFocusNeighborhood = (focusEntityId)=>{
            const playerEntityId = this._logic.playerEntity.entityId;
            this._logic.entityManager.iterate(null, (entity)=>{
                if (entity.entityId === playerEntityId) return;
                if (this._logic.isDestroyed(entity.entityId)) return;
                if (!this._logic.isNearFocus(entity.location)) return;
                this._entity.render(entity, playerEntityId);
            });
        };
        // Render the world (`surface`) into `renderTexture`, centred on world coords (cx, cy), for the
        // follow-cam PiP. Temporarily re-aims the surface transform, then restores it before the normal
        // on-screen render in the same frame. Render square (equal x/y zoom): the PiP sprite lives in
        // the HUD, which is a child of the stage and so already inherits the stage's vertical SCALER —
        // baking SCALER in here too would double it (the vertical stretch bug).
        this.renderWorldToTexture = (renderTexture, cx, cy, zoom)=>{
            const surface = this._surface;
            if (!surface) return;
            const px = renderTexture.width / 2 - cx * zoom;
            const py = renderTexture.height / 2 - cy * zoom;
            const savedX = surface.position.x;
            const savedY = surface.position.y;
            const savedScaleX = surface.scale.x;
            const savedScaleY = surface.scale.y;
            surface.scale.set(zoom, zoom);
            surface.position.set(px, py);
            // Swap in a focus-centred darkness/light mask for this render only. The main mask
            // (this.surface.mask, set by ShadowRendering) is baked in the PLAYER's screen space, so
            // reusing it here makes lights drift across the PiP as the player walks. renderPipLightMask
            // rebakes the same lights in the PiP's framing so a light stays fixed over the world it lit.
            const savedMask = surface.mask;
            const pipMask = this.shadowRendering.renderPipLightMask({
                cx: cx,
                cy: cy,
                zoom: zoom,
                texW: renderTexture.width,
                texH: renderTexture.height,
                resolution: renderTexture.baseTexture.resolution,
                visibility: this._map.getVisibility(),
                lights: this._entity.getLights()
            });
            surface.mask = pipMask ?? null;
            $baf9ca3dd57f31c4$export$e33484ee45c8bb13._app.renderer.render(surface, {
                renderTexture: renderTexture,
                clear: true
            });
            surface.mask = savedMask;
            surface.position.set(savedX, savedY);
            surface.scale.set(savedScaleX, savedScaleY);
            // Composite the world-overlay layer (name tags, hp, and speech bubbles) on top, so the PiP
            // shows the same in-world bubbles as the main view. Overlay items are positioned at
            // world*surfaceZoom (vs the surface's raw-world children), so it takes the SAME position but
            // a scale of zoom/surfaceZoom to line up with the world underneath.
            const overlay = this._worldOverlay;
            if (overlay) {
                const oSavedX = overlay.position.x;
                const oSavedY = overlay.position.y;
                const oSavedScaleX = overlay.scale.x;
                const oSavedScaleY = overlay.scale.y;
                overlay.scale.set(zoom / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom, zoom / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
                overlay.position.set(px, py);
                // A held bubble's "Next" button is a CONTROL, and inside the PiP it would be a picture
                // of one -- unclickable, and sitting over the words the player is trying to read. Hide
                // every live one for this pass only; the main view gets them back immediately after.
                (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).setHiddenForCapture(true);
                $baf9ca3dd57f31c4$export$e33484ee45c8bb13._app.renderer.render(overlay, {
                    renderTexture: renderTexture,
                    clear: false
                });
                (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).setHiddenForCapture(false);
                overlay.position.set(oSavedX, oSavedY);
                overlay.scale.set(oSavedScaleX, oSavedScaleY);
            }
        };
        this.updatePlayerLocation = (entity, force)=>{
            this._map.updatePlayerLocation(entity, force);
        };
        // Get shadow performance metrics for debugging
        this.getShadowPerformanceMetrics = ()=>{
            return this.shadowPerformanceMonitor.getMetrics();
        };
        // Force shadow texture update (useful for debugging)
        this.forceShadowTextureUpdate = ()=>{
            this.shadowRendering.forceTextureUpdate();
        };
        // Debug methods for viewport culling
        this.enableTileBasedCulling = ()=>{
        // this._entity.enableTileBasedCulling()
        };
        this.getViewportDebugInfo = (playerLocation)=>{
            // return this._entity.getViewportDebugInfo(playerLocation)
            return {};
        };
        this.render = ()=>{
            const currentTime = performance.now();
            const frameTime = currentTime - this.lastFrameTime;
            this.lastFrameTime = currentTime;
            // Track frame time history for smoothness analysis
            this.frameTimeHistory.push(frameTime);
            if (this.frameTimeHistory.length > 60) this.frameTimeHistory.shift();
            // Start performance monitoring
            this.performanceMonitor.startFrame();
            // world
            this._map.renderTileMap();
            // Start render timing
            this.performanceMonitor.startRender();
            // Optimized entity rendering with early exits and batching
            this._entity.beginFrame();
            this.renderEntitiesOptimized();
            // Fade entity tiles (trees/bushes) the local player is standing behind, so the player stays
            // visible. Runs after entities are laid out this frame (player location is current).
            if (this._logic.playerEntity) this._map.applyOccluderFade(this._logic.playerEntity);
            // End render timing
            this.performanceMonitor.endRender();
            // Follow-cam picture-in-picture (ember roster): keep the focused entity's neighborhood
            // updated and render the world centred on it into the PiP texture.
            this.updateFollowCam();
            // Anything that was on screen last frame but nothing rendered this frame (it left the
            // culled set, or the follow-cam stopped feeding its neighborhood) has to be hidden, or it
            // stays drawn where it last was while the real entity moves on -- the "ghost" NPC.
            this._entity.endFrame();
            this.shadowRendering.renderVisibility({
                location: this._logic.playerEntity.location,
                polyMap: this._map.getVisibilityMap(),
                visibility: this._map.getVisibility(),
                debug: this.debugVision ? this.debugSurface : undefined,
                lights: this._entity.getLights()
            });
            // Update shadow performance monitoring
            this.shadowPerformanceMonitor.update();
            // Update GUI timer
            this._gui.updateTimer(frameTime);
            // Redraw the tether from a per-entity command wheel to its target (and close the wheel once
            // that target leaves the viewport). The wheel itself stays where it opened.
            this._gui.updateCommandWheelTether();
            // Same for the recruit role picker, which floats over its recruit.
            this._gui.updateRolePickerPosition();
            this._gui.updateNamePrompt();
            // Touch has no hover, so keep the outline on the interactable nearest the player. Throttled
            // internally and a no-op with a mouse.
            this._entity.updateInteractionFocus();
            // Update faction-tracking edge arrows (offscreen faction members)
            this._factionTracker.update();
            // Blow the room's leaves about (no-op, one boolean, in a room with no wind or after dark).
            // After the world is laid out, so the box is centred on where the player actually is this
            // frame. The brightness is what makes the wind die at dusk -- and it is passed as undefined
            // for a room with no day cycle (dayPhase null), which the effect reads as permanent day
            // rather than as pitch dark.
            const brightness = this._logic.dayPhase ? this._logic.currentBrightness : undefined;
            const ambience = this._logic.ambience;
            this._windLeaves.update(ambience?.windLeaves ?? null, this._logic.playerEntity?.location, brightness);
            // ...and roll the fog in, which is the same gate read backwards: it thickens as the wind drops.
            this._nightFog.update(ambience?.nightFog ?? null, brightness);
            // ...and bend the grass on the SAME gust that carries the leaves, so the two are one wind.
            this._grassSway.update(ambience?.windLeaves ?? null, this._logic.playerEntity?.location, brightness);
            // ...and let the butterflies out, which read that same gust to know when to shelter.
            this._butterflies.update(ambience?.butterflies ?? null, this._logic.playerEntity?.location, brightness);
            // ...and light the fireflies, which are the butterflies' opposite number after dark.
            this._fireflies.update(ambience?.fireflies ?? null, this._logic.playerEntity?.location, brightness);
            // End performance monitoring
            this.performanceMonitor.endFrame();
            // Adaptive frame rate limiting for smoother gameplay
            this.adaptiveFrameRateLimit();
        };
        this.renderEntitiesOptimized = ()=>{
            const playerEntityId = this._logic.playerEntity.entityId;
            let renderedCount = 0;
            const playerPos = this._logic.playerEntity.location;
            // First pass: render player entity (always highest priority)
            if (this._logic.playerEntity) {
                this._entity.render(this._logic.playerEntity, playerEntityId);
                renderedCount++;
            }
            // Check if we need to re-sort entities
            const shouldResort = this._logic.shouldResortEntities(playerPos);
            let entitiesToProcess;
            if (shouldResort) {
                entitiesToProcess = this.calculateSortedEntitiesByDistance(playerPos);
                this.cachedSortedEntities = entitiesToProcess;
            } else entitiesToProcess = this.cachedSortedEntities;
            if (!entitiesToProcess?.length) return;
            // Get adaptive entity limit based on performance (cached)
            const maxEntitiesToRender = this.getCachedEntityLimit();
            // Render entities in distance order (closest first)
            // Note: entities are already culled to 7 tiles during sorting
            for(let i = 0; i < entitiesToProcess.length; i++){
                const { entity: entity } = entitiesToProcess[i];
                // Early exit if we've rendered too many entities this frame
                if (renderedCount >= maxEntitiesToRender) {
                    // Budget, not culling: the rest keep showing whatever they last showed rather
                    // than popping out of the world, so exempt them from the end-of-frame sweep.
                    for(let j = i; j < entitiesToProcess.length; j++)this._entity.markDeferred(entitiesToProcess[j].entity.entityId);
                    break;
                }
                // Skip if entity is the player (already rendered)
                if (entity.entityId === playerEntityId) continue;
                // Skip if entity is destroyed
                if (this._logic.isDestroyed(entity.entityId)) continue;
                // Render the entity
                if (this._entity.render(entity, playerEntityId)) renderedCount++;
            }
            // Update performance monitor with entity counts
            this.updateEntityRenderingMetrics(renderedCount);
        };
        this.cachedEntityLimit = 200;
        this.lastEntityLimitUpdate = 0;
        this.entityLimitUpdateInterval = 1000 // Update every 1 second
        ;
        this.adaptiveFrameRateLimit = ()=>{
            if (this.frameTimeHistory.length < 10) return;
            // Calculate average frame time
            const avgFrameTime = this.frameTimeHistory.reduce((a, b)=>a + b, 0) / this.frameTimeHistory.length;
            const currentFPS = 1000 / avgFrameTime;
            // Track performance history
            this.performanceHistory.push(currentFPS);
            if (this.performanceHistory.length > 30) this.performanceHistory.shift();
            // Get total entity count for scaling decisions
            const totalEntities = this._logic.entityManager.size();
            // If we're running too fast, add a small delay for smoother gameplay
            if (currentFPS > 120) {
                const delay = Math.min(2, 1000 / 120 - avgFrameTime);
                if (delay > 0) // Use setTimeout to add a small delay without blocking
                setTimeout(()=>{}, delay);
            }
            // Temporarily disable adaptive scaling to debug performance
            // Keep entity limit at 500 for now
            this.maxEntitiesPerFrame = 500;
        };
        $baf9ca3dd57f31c4$export$e33484ee45c8bb13._app = app;
        // Also publish it on the standalone holder, which is what the low-level bakers read. See
        // renderer_app.ts for why they no longer reach through this class.
        (0, $065c5647ab3ff4dc$export$6a54bfeffaafa5f7)(app);
        this.app = app;
        this._logic = logic;
        const stage = this.app.stage;
        stage.interactive = true;
        stage.sortableChildren = true;
        const surface = new (0, $gwPoJ.Graphics)();
        surface.sortableChildren = true;
        stage.addChild(surface);
        surface.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this._surface = surface;
        const worldOverlaySurface = new (0, $b11c64d757fefaba$export$198fa1625abb29ee)(logic);
        stage.addChild(worldOverlaySurface);
        this._worldOverlay = worldOverlaySurface;
        // WHICH LAYERS ARE THE WORLD. Button presses arrive on a document-level mousedown, which pixi
        // never hit-tests, so before this every click reached the player controller wherever it landed
        // and pressing a HUD control swung the weapon at whatever was behind it. Naming the world's
        // layers lets Mouse ask what is under the pointer and drop presses that belong to the HUD.
        //
        // Everything else on the stage is chrome: the gui container, the faction tracker, debug.
        (0, $f246f635ee3b2e66$export$7caecd373b84cec3).setWorldRoots([
            surface,
            worldOverlaySurface
        ]);
        // This one is still needed and is NOT the same problem. A held bubble's "Next" is drawn on the
        // entity's own sprite, INSIDE the world surface, so it is a world press by every test above --
        // it has to say so itself. Read the controller lazily: it does not exist yet here.
        (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).bindSuppressAttack(()=>logic.playerController?.suppressAttack());
        const minimapSurface = new (0, $0de04cf39fd0c1a1$export$549555cdc2ac3f0f)(logic);
        this._gui = new (0, $7dd73ecdd94bfe01$export$530fe131767a4087)(stage, minimapSurface, logic);
        this._gui.init();
        // Screen-space overlay for faction-tracking edge arrows (reads state from logic).
        this._factionTracker = new (0, $265fbb56155cf111$export$92880c192d1b7482)(logic, surface, app);
        stage.addChild(this._factionTracker.container);
        ////////////////////////////////////////
        const skySurface = new (0, $gwPoJ.Graphics)();
        skySurface.sortableChildren = true;
        skySurface.zIndex = 1000000;
        // The wind bending the grass (see GrassSway). Built before the map, because the map hands it
        // every sprited cell as it renders one.
        this._grassSway = new (0, $59052a7f89e51e65$export$7d832ea11681c35b)();
        this._map = new (0, $409e08612bd4cd6f$export$ac241b7c41940a17)(surface, skySurface, minimapSurface, worldOverlaySurface, logic);
        this._map.setGrassSway(this._grassSway);
        this._map.init();
        this._entity = new (0, $3de7f2d858d8583e$export$b797a3cc601f36f1)(surface, minimapSurface, worldOverlaySurface, logic, this, app);
        this._entity.init();
        // Windblown leaves (see WindLeaves): a per-room ambience, off unless the room asks for it.
        // It goes INSIDE the world surface so the leaves parallax with the camera and inherit the
        // night-time visibility mask; its zIndex keeps them above entities but under the sky/roof.
        this._windLeaves = new (0, $02d47f540b0d58f8$export$ebaa494e10da0ea2)((0, $02d47f540b0d58f8$export$ebaa494e10da0ea2).textureFactory(app.renderer));
        surface.addChild(this._windLeaves.container);
        // Night fog (see NightFog): one shader on one quad, also inside the world surface so it
        // parallaxes and is clipped by the night visibility mask. It asks the surface itself what world
        // rectangle is on screen, which is the only way to be right at the map edges where the camera
        // stops following the player. Drawn under the leaves, so leaves stay crisp against it.
        this._nightFog = new (0, $5771f9fef21bdf34$export$321e670ba3865065)(surface, app.screen, (0, $5771f9fef21bdf34$export$321e670ba3865065).bakeNoise);
        surface.addChild(this._nightFog.container);
        // Butterflies by day (see Butterflies), the day-side counterpart to the fog. In the world
        // surface with the rest, so they parallax and are clipped by the visibility mask.
        // The perch source is the grass registry: butterflies settle on the same tufts the wind bends.
        this._butterflies = new (0, $be65b55052fa66e7$export$b384c8d4ebe6bf23)((0, $be65b55052fa66e7$export$b384c8d4ebe6bf23).textureFactory(app.renderer), (x, y, r)=>this._grassSway.perchNear(x, y, r));
        surface.addChild(this._butterflies.container);
        // Fireflies, after dark. NOT in the world surface with the others: that surface is masked by
        // the night visibility, and a firefly is a light -- the whole picture is one glowing out in the
        // dark where you cannot otherwise see. The overlay surface is camera-moved but unmasked.
        this._fireflies = new (0, $aa1fa3752bebfcbe$export$14e015fa5aada1ce)((0, $aa1fa3752bebfcbe$export$14e015fa5aada1ce).textureFactory(app.renderer));
        worldOverlaySurface.addChild(this._fireflies.container);
        this._mouse = new (0, $f246f635ee3b2e66$export$7caecd373b84cec3)();
        this._keyboard = new (0, $ea3f90e500565ae9$export$16e4d70cc375e707)();
        const debugSurface = new (0, $gwPoJ.Graphics)();
        this.debugSurface = debugSurface;
        debugSurface.sortableChildren = true;
        surface.addChild(skySurface);
        stage.addChild(debugSurface);
        this.shadowRendering = new (0, $cb0ab22baf2add07$export$fe76cdfccd658eb)(app, surface, this.debugVision, logic);
        this.shadowPerformanceMonitor = new (0, $aFPGo.ShadowPerformanceMonitor)(this.shadowRendering);
        // Initialize performance monitor
        this.performanceMonitor = new (0, $3a1b2b5c28aeeeee$export$9b229b42dc5ba616)({
            enableMetrics: true,
            logInterval: 5000,
            enableMemoryTracking: true,
            enableDetailedStats: true
        });
        // Set up performance monitor callbacks
        this.performanceMonitor.setStatCallbacks({
            getViewportCullingStats: ()=>{}
        });
    }
    calculateSortedEntitiesByDistance(playerPos) {
        // Use spatial indexing for O(log n) performance instead of O(n)
        return this._logic.getVisibleEntities(playerPos);
    }
    getCullingDistanceSquared() {
        // Use unified culling system from ClientGameLogic
        return this._logic.getCullingDistanceSquared();
    }
    getCachedEntityLimit() {
        const now = performance.now();
        // Only update entity limit periodically to avoid expensive metrics calls
        if (now - this.lastEntityLimitUpdate > this.entityLimitUpdateInterval) {
            this.updateCachedEntityLimit();
            this.lastEntityLimitUpdate = now;
        }
        return this.cachedEntityLimit;
    }
    updateCachedEntityLimit() {
        const metrics = this.performanceMonitor.getMetrics();
        const baseLimit = 200;
        // Adjust based on performance
        if (metrics.frameRate < 30) this.cachedEntityLimit = Math.floor(baseLimit * 0.6) // Reduce when performance is poor
        ;
        else if (metrics.frameRate > 60) this.cachedEntityLimit = Math.floor(baseLimit * 1.5) // Increase when performance is good
        ;
        else this.cachedEntityLimit = baseLimit;
    }
    updateEntityRenderingMetrics(renderedCount) {
        const totalEntities = this._logic.entityManager.size();
        const culledCount = totalEntities - renderedCount;
        this.performanceMonitor.updateEntityCounts(totalEntities, renderedCount, culledCount);
        // Debug: Log entity counts every few seconds (reduced frequency)
        if (Math.random() < 0.01) // 1% chance to log
        (0, $5UG8I.logger).debug({
            tags: [
                "rendering",
                "entities"
            ]
        }, `Entity rendering: ${renderedCount}/${totalEntities} rendered, ${culledCount} culled`);
    }
}


class $b413b66e0babaf69$export$7152e8d75caca3a3 {
    constructor(app){
        this.create = (logic)=>{
            return new (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)(this.app, logic);
        };
        this.app = app;
    }
}



(0, $ezJmd.settings).SCALE_MODE = (0, $P8XPi.SCALE_MODES).NEAREST;
(0, $ezJmd.settings).RENDER_OPTIONS.antialias = false;
// Every asset url in the client is written relative ("assets/foo.png"), which resolves against
// whatever origin served the page. That is right for a browser tab and wrong for the native
// shell, whose origin is the app bundle -- the art is not shipped inside it. Setting the loader's
// baseUrl once redirects all 50-odd call sites without touching any of them; it is "" everywhere
// else, and resource-loader leaves urls alone when it is empty. Must happen before the first
// Loader.shared.add(), which is why it sits at module top rather than inside the boot callback.
(0, $kXE1p.Loader).shared.baseUrl = (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().assetBase;
// The fixed virtual screen the whole client is laid out in: pixi's own default, which the game was
// built on back when the renderer was never resized. Every GUI coordinate, and BOTTOM in
// gui_manager, is written against it.
const $d787de46f259e3a8$var$VIRTUAL_W = 800;
const $d787de46f259e3a8$var$VIRTUAL_H = 600;
// The shape the canvas is letterboxed to. `stage.scale.y = SCALER` stretches the virtual screen
// vertically, and this ratio is exactly what squashes it back, so a circle drawn in stage
// coordinates comes out round. Letterboxing to 16:9 (ScreenDimensions) instead left the whole game
// 2.6% wider than tall -- SCALER is 1.3 where undoing a 4:3 buffer at 16:9 needs 4/3.
const $d787de46f259e3a8$var$DISPLAY_RATIO = $d787de46f259e3a8$var$VIRTUAL_W / ($d787de46f259e3a8$var$VIRTUAL_H / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
// Ceiling on the drawing buffer, as a resolution multiplier: VIRTUAL_W x VIRTUAL_H x this^2 pixels,
// i.e. ~5M. A fullscreen 4K panel would otherwise ask for ~10M, four times what the client used to
// draw, on hardware that may be an integrated GPU. Past the cap the browser stretches the last
// little bit, which is still far less resampling than before.
const $d787de46f259e3a8$var$MAX_RESOLUTION = Math.sqrt(5000000 / ($d787de46f259e3a8$var$VIRTUAL_W * $d787de46f259e3a8$var$VIRTUAL_H));




const $d787de46f259e3a8$var$foo = setInterval(()=>{
    if (window["__GO__"]) {
        clearInterval($d787de46f259e3a8$var$foo);
        const stopLoading = window["stopLoading"];
        const app = new (0, $7DxQ2.Application)({
            view: document.getElementById("pixi-canvas"),
            resolution: window.devicePixelRatio || 2,
            autoDensity: true,
            backgroundColor: 0x000000
        });
        (0, $ea3f90e500565ae9$export$16e4d70cc375e707).initialize();
        (0, $f246f635ee3b2e66$export$7caecd373b84cec3).initialize(app);
        const onLoadComplete = ()=>{
            if (stopLoading) stopLoading();
            function resize() {
                const width = window.innerWidth;
                const height = window.innerHeight;
                const letterboxed = width / height >= $d787de46f259e3a8$var$DISPLAY_RATIO;
                const w = letterboxed ? height * $d787de46f259e3a8$var$DISPLAY_RATIO : width;
                const h = letterboxed ? height : width / $d787de46f259e3a8$var$DISPLAY_RATIO;
                // Draw at the density the canvas is actually SHOWN at. The virtual screen is fixed,
                // so this changes nothing about coordinates -- only how many real pixels each
                // virtual unit gets. Without it pixi filled its default 1600x1200 buffer and left
                // the browser to stretch that ~1.8x across the window, which is what made text and
                // HUD art soft. Capped, because the buffer would otherwise grow with the player's
                // monitor and the client has to stay playable on an integrated GPU.
                const dpr = window.devicePixelRatio || 1;
                const resolution = Math.max(1, Math.min(w * dpr / $d787de46f259e3a8$var$VIRTUAL_W, $d787de46f259e3a8$var$MAX_RESOLUTION));
                app.renderer.resolution = resolution;
                // InteractionManager copies the resolution once, when it is constructed, and never
                // looks at it again. Leave it stale and every interactive widget -- and the mouse
                // position the world is aimed with -- hit-tests in the wrong place.
                const interaction = app.renderer.plugins?.interaction;
                if (interaction) interaction.resolution = resolution;
                app.renderer.resize($d787de46f259e3a8$var$VIRTUAL_W, $d787de46f259e3a8$var$VIRTUAL_H);
                // resize() with autoDensity has just written the VIRTUAL size into the canvas
                // style; the letterboxed size is what belongs on screen.
                app.renderer.view.style.width = w + "px";
                app.renderer.view.style.height = h + "px";
                app.stage.scale.y = (0, $10da07838e6d507c$export$c6ec669adaa5980d);
            }
            resize();
            window.onresize = resize;
            const factory = new (0, $b413b66e0babaf69$export$7152e8d75caca3a3)(app);
            const clientGameLogic = new (0, $1e46c45e333c583b$export$99cd19a42c3acc3f)(factory);
            const client = new (0, $67f7e8116a91e4e7$export$1f2bb630327ac4b6)(clientGameLogic);
            // Setup viewport culling debug tools
            (parcelRequire("bW0pk")).then(({ setupViewportCullingDebug: setupViewportCullingDebug })=>{
                setupViewportCullingDebug(clientGameLogic.clientRenderer);
            });
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            if (window["IS_ITCH"] || (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().autoGuest) client.connect("", "", true);
            else {
                const { accessToken: accessToken, guest: guest } = params;
                if (accessToken) client.connect("", accessToken);
                else {
                    const isGuest = guest === "true";
                    const cachedPlayerName = isGuest ? "" : localStorage.getItem("_playerName_") || "";
                    client.connect(cachedPlayerName, "", isGuest);
                }
            }
            // ONE thrown exception out of a frame must not end the game.
            //
            // pixi's ticker re-arms its requestAnimationFrame AFTER emitting, so a listener that
            // throws stops the loop for good: the canvas holds its last frame, the socket stays up,
            // and the player is left looking at a picture. That is the "my screen froze" report, and
            // it is indistinguishable from a crash however small the thing that threw -- a widget
            // animating a panel, a sprite whose paperdoll was swapped under it, a mask on a destroyed
            // display object. Nothing drawn in a single frame is worth the whole renderer, so: keep
            // drawing, and make sure the first few failures carry a stack somebody can act on.
            //
            // The count AND the stacks go on `window` deliberately. On a device there is no console
            // to scroll back through, and even in a browser the console is no use here: this client
            // logs a couple of thousand texture warnings on load, so by the time a frame fails its
            // stack is somewhere in the middle of that and cannot be found. `__frameErrors` answers
            // "has this client been dropping frames", and `__frameErrorLog` says what it was --
            // readable over CDP, from devtools, or by a test.
            let frameErrors = 0;
            const frameErrorLog = [];
            window.__frameErrors = 0;
            window.__frameErrorLog = frameErrorLog;
            app.ticker.add(()=>{
                try {
                    client.update();
                } catch (error) {
                    frameErrors++;
                    window.__frameErrors = frameErrors;
                    // The first few only: a frame that fails tends to fail every frame, and the
                    // hundredth copy of one stack is worth less than the first copy of the next.
                    if (frameErrors <= 5) {
                        const detail = error?.stack || String(error);
                        frameErrorLog.push(detail);
                        console.error("[frame] update failed", error);
                        (0, $5UG8I.logger).error({
                            tags: [
                                "frame",
                                "error"
                            ]
                        }, `frame update failed: ${detail}`);
                    }
                }
            });
            // Expose shadow debug features to global scope for debugging
            if (typeof window !== "undefined") {
                window.__PIXI_APP__ = app;
                window.logger = (0, $5UG8I.logger);
                window.shadowDebug = {
                    getMetrics: ()=>client.getShadowPerformanceMetrics(),
                    forceUpdate: ()=>client.forceShadowTextureUpdate(),
                    logMetrics: ()=>{
                        const metrics = client.getShadowPerformanceMetrics();
                        (0, $5UG8I.logger).info({
                            tags: [
                                "shadow",
                                "performance"
                            ]
                        }, "Shadow Performance:", metrics);
                    },
                    debugLog: ()=>{
                        // Access the shadow rendering directly for debug logging
                        const renderer = client.clientGameLogic.clientRenderer;
                        if (renderer.shadowRendering) renderer.shadowRendering.debugLog();
                    },
                    enableDebugLogging: ()=>{
                        // Enable debug logging for hash calculation
                        const renderer = client.clientGameLogic.clientRenderer;
                        if (renderer.shadowRendering) {
                            renderer.shadowRendering.debugHashCalculation = true;
                            (0, $5UG8I.logger).info({
                                tags: [
                                    "shadow",
                                    "debug"
                                ]
                            }, "Shadow hash debug logging enabled");
                        }
                    },
                    disableDebugLogging: ()=>{
                        // Disable debug logging
                        const renderer = client.clientGameLogic.clientRenderer;
                        if (renderer.shadowRendering) {
                            renderer.shadowRendering.debugHashCalculation = false;
                            (0, $5UG8I.logger).info({
                                tags: [
                                    "shadow",
                                    "debug"
                                ]
                            }, "Shadow hash debug logging disabled");
                        }
                    }
                };
                (0, $5UG8I.logger).info({
                    tags: [
                        "shadow",
                        "debug"
                    ]
                }, "Shadow debug tools available at window.shadowDebug");
                (0, $5UG8I.logger).info({
                    tags: [
                        "shadow",
                        "debug"
                    ]
                }, "Shadow debug test available at window.shadowDebugTest");
                (0, $5UG8I.logger).info({
                    tags: [
                        "logger",
                        "debug"
                    ]
                }, "Logger available at window.logger for debugging");
                window.shadowDebugTest = {
                    startMonitoring: ()=>{
                        const { ShadowDebugTest: ShadowDebugTest } = (parcelRequire("f9obu"));
                        const debugTest = new ShadowDebugTest(clientGameLogic);
                        debugTest.startMonitoring();
                    },
                    testStationary: ()=>{
                        const { ShadowDebugTest: ShadowDebugTest } = (parcelRequire("f9obu"));
                        const debugTest = new ShadowDebugTest(clientGameLogic);
                        debugTest.testStationary();
                    },
                    testMovement: ()=>{
                        const { ShadowDebugTest: ShadowDebugTest } = (parcelRequire("f9obu"));
                        const debugTest = new ShadowDebugTest(clientGameLogic);
                        debugTest.testMovement();
                    }
                };
            }
        };
        $d787de46f259e3a8$var$loadAssets();
        const aggressiveLoad = false;
        (0, $kXE1p.Loader).shared.load(aggressiveLoad ? ()=>(0, $c1d8cd49591538f1$export$cd02f82db8cdb05).bulkLoad((0, $1016737a9aedcca9$export$542cb9bd603edb0f).map((sheetId)=>`assets/${sheetId}`), onLoadComplete) : onLoadComplete);
    }
}, 1000);
const $d787de46f259e3a8$var$loadAssets = ()=>{
    //
    // fonts
    //
    const chars = {
        chars: [
            [
                "a",
                "z"
            ],
            [
                "0",
                "9"
            ],
            [
                "A",
                "Z"
            ],
            " .!?|,\":<>~!@#$%^&*()_+-=/\\'\xeb"
        ]
    };
    (0, $hnGDn.BitmapFont).from("LocationFont", {
        fill: "#00FF00",
        fontSize: 25
    }, chars);
    (0, $hnGDn.BitmapFont).from("BannerFont", {
        fill: "#FFFFFF",
        fontSize: 20
    }, chars);
    (0, $hnGDn.BitmapFont).from("ImportantFont", {
        fill: "#FFFFFF",
        fontSize: 30
    }, chars);
    (0, $hnGDn.BitmapFont).from("LogoFont", {
        fill: "#FFFFFF",
        fontSize: 40
    }, chars);
    (0, $hnGDn.BitmapFont).from("ScoreFont", {
        fill: "#FFFFFF",
        fontSize: 15,
        fontFamily: "Serif"
    }, chars);
    (0, $hnGDn.BitmapFont).from("NameFont", {
        fill: "#FFFFFF",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("ChatFont", {
        fill: "#00EE00",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("RedChatFont", {
        fill: "#FFA500",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("SmallFont", {
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("SignFont", {
        fill: "#000000",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("ChatBubbleFont", {
        fill: "#FFFFFF",
        fontSize: 15
    }, chars);
    (0, $hnGDn.BitmapFont).from("BlinkFont", {
        fill: "#00FF00",
        fontSize: 10,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("ChatHistoryFont", {
        fill: "#00FF00",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("LeaderboardFont", {
        fill: "#00FF00",
        fontSize: 15
    }, chars);
    (0, $hnGDn.BitmapFont).from("LeaderboardLeaderFont", {
        fill: "#FFFFFF",
        fontSize: 15
    }, chars);
    (0, $hnGDn.BitmapFont).from("HpFont", {
        fill: "#FFFFFF",
        fontSize: 12,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("IdFont", {
        fill: "#00FF00",
        fontSize: 12,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("Normal-Green-Bold", {
        fill: "#00FF00",
        fontSize: 15,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("TinyFont", {
        fill: "#FFFFFF",
        fontSize: 9
    }, chars);
    //
    // audio
    //
    (0, $479d799412e4e1cb$export$153755f98d9861de).loadAssets();
    (0, $kXE1p.Loader).shared.add("hit1", "assets/strike1.ogg").add("hit2", "assets/strike2.ogg").add("woodhit", "assets/woodhit.ogg").add("bowshot", "assets/shoot.ogg").add("swordswing", "assets/swordswing.ogg").add("explosion", "assets/explosion.mp3").add("emp", "assets/emp.mp3").add("health", "assets/health.mp3").add("mana", "assets/mana.mp3").add("door_open", "assets/door_open.ogg").add("door_close", "assets/door_close.ogg").add("clocktick", "assets/clocktick.mp3").add("powerup", "assets/powerup.mp3").add("map_location", "assets/map_location.ogg").add("click", "assets/click.mp3").add("coins", "assets/coin3.ogg").add("cloth", "assets/cloth.ogg")// procedurally synthesized (packages/tools/src/sfx/gen.py)
    .add("campfire_lit", "assets/campfire_lit.ogg").add("campfire_fed", "assets/campfire_fed.ogg").add("wheel_select", "assets/wheel_select.ogg").add("item_crafted", "assets/item_crafted.ogg").add("wave_starting", "assets/wave_starting.ogg");
    //
    // image
    //
    (0, $kXE1p.Loader).shared.add("furniture-blonde-wood", "assets/furniture-blonde-wood.json").add("fence_medieval", "assets/fence_medieval.json").add("container", "assets/container.json").add("walls", "assets/walls.json").add("walls2", "assets/walls2.json").add("floors", "assets/floors.json").add("cottage", "assets/cottage.json").add("roofs", "assets/roofs.json").add("ore", "assets/ore.json").add("decorations-medieval", "assets/decorations-medieval.json").add("jungle-ruins", "assets/jungle-ruins.json").add("mountains-v6", "assets/mountains-v6.json").add("lpc-flowers-plants-fungi-wood", "assets/lpc-flowers-plants-fungi-wood.json").add("lpc-terrain", "assets/lpc-terrain.json").add("beach-desert", "assets/beach-desert.json").add("map-atlas", "assets/map-atlas.json").add("plants", "assets/plants.json").add("build_atlas", "assets/build_atlas.json").add("humanoid", "assets/humanoid.json").add("outer", "assets/joystick.png").add("inner", "assets/joystick-handle.png").add("reddit", "assets/reddit.png").add("discord", "assets/discord.png").add("intro_scene", "assets/intro/scene.png");
};


//# sourceMappingURL=client.265411b8.js.map
